// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gupJu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _esRegexpFlagsJs = require("core-js/modules/es.regexp.flags.js");
var _esTypedArraySetJs = require("core-js/modules/es.typed-array.set.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _reactRouterDom = require("react-router-dom");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react1 = require("@sentry/react");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _replaceAllJs = require("core-js/es/string/replace-all.js");
var _app = require("./components/App/App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _errorBoundary = require("./components/ErrorBoundary/ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _authProvider = require("./providers/AuthProvider/AuthProvider");
var _authProviderAuthSessionService = require("./providers/AuthProvider/AuthProvider.authSessionService");
var _languageProvider = require("./providers/LanguageProvider");
var _pageNavigation = require("./providers/PageNavigation");
var _snackbarProvider = require("./providers/SnackbarProvider");
var _history = require("./utils/history");
var _historyDefault = parcelHelpers.interopDefault(_history);
var _api = require("./api");
var _apiDefault = parcelHelpers.interopDefault(_api);
// Set API defaults
(0, _apiDefault.default).defaults.fetch = (0, _authProviderAuthSessionService.authSessionService).apiFetchInterceptor;
(0, _apiDefault.default).defaults.baseUrl = `${"https://services.dev.beaufort.io/v2"?.replace("/v2", "")}`;
// Init Sentry
// Only track and send events/reports to Sentry when running in (pre)prod, ie:
// * NODE_ENV is "production", and
// * REACT_APP_SENTRY_ENVIRONMENT is either "production" or "preprod"
const isSentryEnabled = [
    "production",
    "preprod"
].includes("staging");
_react1.init({
    dsn: "https://faa16036871443b2b8d7abc154c8d983@o331045.ingest.sentry.io/5370819",
    tunnel: `${(0, _apiDefault.default).defaults.baseUrl}/sentry`,
    environment: "staging",
    release: "d3727a360650d42e4c05da6bf253346cfdaa40a2",
    integrations: [
        new _react1.BrowserTracing({
            routingInstrumentation: _react1.reactRouterV5Instrumentation((0, _historyDefault.default))
        })
    ],
    // Transaction sample rate (ie. recording rate of page loads, API requests etc.)
    // Docs recommend starting with a low sampling rate, then gradually increase it,
    // or configure it with `tracesSampler`.
    // For more, see https://docs.sentry.io/platforms/javascript/guides/react/configuration/sampling/
    tracesSampleRate: 0.2,
    beforeSend (event) {
        if (isSentryEnabled) // Send event to Sentry if running in (pre)prod
        return event;
        else {
            // Do not send events to Sentry for other envs. Log instead
            console.error("Captured Sentry event: ", event);
            return null;
        }
    },
    // see https://stackoverflow.com/questions/26483541/referenceerror-cant-find-variable-gcrweb
    ignoreErrors: [
        "__gCrWeb" // "Chrome in iOS __gCrWeb error",
    ],
    sendClientReports: isSentryEnabled,
    autoSessionTracking: isSentryEnabled
});
const isDevelopment = false;
if (isDevelopment) require("890c3703d771fc90");
// Setup Sentry as logger for react-query
// if sentry is not enabled, messages will be printed in the console
const queryClient = new (0, _reactQuery.QueryClient)({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: !isDevelopment
        }
    }
});
const OuterErrorBoundaryFallback = ()=>// At this point none of the providers has been loaded
    // -> Cannot use Polaris components, translation hooks etc.
    // -> Render basic error message
    // --> Hopefully we won't get here :)
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            padding: "2em"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                style: {
                    fontSize: "1.5em"
                },
                children: "En feil oppstod."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                style: {
                    fontSize: "1em"
                },
                children: "Vi er p\xe5 saken!"
            })
        ]
    });
const container = document.getElementById("root");
const root = (0, _client.createRoot)(container);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
    fallback: OuterErrorBoundaryFallback,
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Router), {
        history: (0, _historyDefault.default),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authProvider.AuthProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageProvider.LanguageContextProvider), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
                    client: queryClient,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledComponents.StyleSheetManager), {
                        shouldForwardProp: (propName, target)=>// For HTML elements, forward the prop if it is a valid HTML attribute
                            // For other elements, forward all props
                            typeof target !== "string" || (0, _isPropValidDefault.default)(propName),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageNavigation.PageNavigationContextProvider), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snackbarProvider.SnackbarProvider), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
                            })
                        })
                    })
                })
            })
        })
    })
}));

},{"core-js/modules/es.regexp.flags.js":"fkRgI","core-js/modules/es.typed-array.set.js":"4axQW","react/jsx-runtime":"enbMA","react":"cOWTg","react-dom/client":"d0tab","react-router-dom":"1ee65","@emotion/is-prop-valid":"kjOQx","@sentry/react":"akCRS","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","core-js/es/string/replace-all.js":"cbJvB","./components/App/App":"dC0Jd","./components/ErrorBoundary/ErrorBoundary":"7RMaM","./providers/AuthProvider/AuthProvider":"jnIYf","./providers/AuthProvider/AuthProvider.authSessionService":"lpZZM","./providers/LanguageProvider":"iHLZe","./providers/PageNavigation":"eJqkE","./providers/SnackbarProvider":"cSMb7","./utils/history":"c4gdf","./api":"f6lXD","890c3703d771fc90":"AVQWA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fkRgI":[function(require,module,exports) {
"use strict";
var global = require("c6bf5eee641c0bcc");
var DESCRIPTORS = require("32574bd865b8e6e5");
var defineBuiltInAccessor = require("ba3ead2b02aa5c9b");
var regExpFlags = require("67e6b6bed174b69b");
var fails = require("f4050f72fe5dda92");
// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp = global.RegExp;
var RegExpPrototype = RegExp.prototype;
var FORCED = DESCRIPTORS && fails(function() {
    var INDICES_SUPPORT = true;
    try {
        RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor(RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) defineBuiltInAccessor(RegExpPrototype, "flags", {
    configurable: true,
    get: regExpFlags
});

},{"c6bf5eee641c0bcc":"j6YVW","32574bd865b8e6e5":"55NyN","ba3ead2b02aa5c9b":"jcgeN","67e6b6bed174b69b":"dNPA1","f4050f72fe5dda92":"2EuIj"}],"j6YVW":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == "object" && self) || check(typeof global == "object" && global) || check(typeof this == "object" && this) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();

},{}],"55NyN":[function(require,module,exports) {
"use strict";
var fails = require("735b783268fd06c0");
// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

},{"735b783268fd06c0":"2EuIj"}],"2EuIj":[function(require,module,exports) {
"use strict";
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

},{}],"jcgeN":[function(require,module,exports) {
"use strict";
var makeBuiltIn = require("5bd1cd8472955124");
var defineProperty = require("1413185c6323bbbc");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) makeBuiltIn(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) makeBuiltIn(descriptor.set, name, {
        setter: true
    });
    return defineProperty.f(target, name, descriptor);
};

},{"5bd1cd8472955124":"6wVaa","1413185c6323bbbc":"iTMdX"}],"6wVaa":[function(require,module,exports) {
"use strict";
var uncurryThis = require("ca84677f1ebd1804");
var fails = require("13360f2842eba261");
var isCallable = require("103e488c0928755a");
var hasOwn = require("cbf9b0e0779cc368");
var DESCRIPTORS = require("3f2eb7efeae2f72b");
var CONFIGURABLE_FUNCTION_NAME = require("548b10f284264c72").CONFIGURABLE;
var inspectSource = require("358f00f3103bd55b");
var InternalStateModule = require("9b2ce14119fd2412");
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis("".slice);
var replace = uncurryThis("".replace);
var join = uncurryThis([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
    return defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var TEMPLATE = String(String).split("String");
var makeBuiltIn = module.exports = function(value, name, options) {
    if (stringSlice($String(name), 0, 7) === "Symbol(") name = "[" + replace($String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!hasOwn(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS) defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwn(options, "arity") && value.length !== options.arity) defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && hasOwn(options, "constructor") && options.constructor) {
            if (DESCRIPTORS) defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = enforceInternalState(value);
    if (!hasOwn(state, "source")) state.source = join(TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, "toString");

},{"ca84677f1ebd1804":"37Z8T","13360f2842eba261":"2EuIj","103e488c0928755a":"aHyPE","cbf9b0e0779cc368":"36o5K","3f2eb7efeae2f72b":"55NyN","548b10f284264c72":"5ZADh","358f00f3103bd55b":"01U5j","9b2ce14119fd2412":"lNt2C"}],"37Z8T":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("829dd7a4e960cf9e");
var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
    return function() {
        return call.apply(fn, arguments);
    };
};

},{"829dd7a4e960cf9e":"3ippH"}],"3ippH":[function(require,module,exports) {
"use strict";
var fails = require("2642aa7619056f20");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});

},{"2642aa7619056f20":"2EuIj"}],"aHyPE":[function(require,module,exports) {
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == "undefined" && documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === documentAll;
} : function(argument) {
    return typeof argument == "function";
};

},{}],"36o5K":[function(require,module,exports) {
"use strict";
var uncurryThis = require("f5dcaa60a713971f");
var toObject = require("ab17c4f45fcf0841");
var hasOwnProperty = uncurryThis({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
};

},{"f5dcaa60a713971f":"37Z8T","ab17c4f45fcf0841":"jzUbe"}],"jzUbe":[function(require,module,exports) {
"use strict";
var requireObjectCoercible = require("f45a7b5dcdc4a410");
var $Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $Object(requireObjectCoercible(argument));
};

},{"f45a7b5dcdc4a410":"1YCCJ"}],"1YCCJ":[function(require,module,exports) {
"use strict";
var isNullOrUndefined = require("74607922ed30019f");
var $TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
    return it;
};

},{"74607922ed30019f":"aUt9w"}],"aUt9w":[function(require,module,exports) {
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

},{}],"5ZADh":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("8ad2bacb0e20b95c");
var hasOwn = require("4eabfd8f83afc9d5");
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn(FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
module.exports = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};

},{"8ad2bacb0e20b95c":"55NyN","4eabfd8f83afc9d5":"36o5K"}],"01U5j":[function(require,module,exports) {
"use strict";
var uncurryThis = require("26e26db98367212e");
var isCallable = require("40ed9a4f6ae66648");
var store = require("485d48d6f4c6739e");
var functionToString = uncurryThis(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
    return functionToString(it);
};
module.exports = store.inspectSource;

},{"26e26db98367212e":"37Z8T","40ed9a4f6ae66648":"aHyPE","485d48d6f4c6739e":"17Rn5"}],"17Rn5":[function(require,module,exports) {
"use strict";
var global = require("8756de416b94afec");
var defineGlobalProperty = require("dfb72a1d809f7b02");
var SHARED = "__core-js_shared__";
var store = global[SHARED] || defineGlobalProperty(SHARED, {});
module.exports = store;

},{"8756de416b94afec":"j6YVW","dfb72a1d809f7b02":"4GyjI"}],"4GyjI":[function(require,module,exports) {
"use strict";
var global = require("70259c1dd4aa0e14");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        defineProperty(global, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        global[key] = value;
    }
    return value;
};

},{"70259c1dd4aa0e14":"j6YVW"}],"lNt2C":[function(require,module,exports) {
"use strict";
var NATIVE_WEAK_MAP = require("d3f0c9f3327b2fd6");
var global = require("ca46b44b6201ccd7");
var isObject = require("f82e6cc0ac249fa5");
var createNonEnumerableProperty = require("c0ae163eea4ef97");
var hasOwn = require("6dea7358344877bb");
var shared = require("3e035a1241da2f0");
var sharedKey = require("88d6ccc27e779e5a");
var hiddenKeys = require("d40b9b3abdbb956e");
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
    store.has = store.has;
    store.set = store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
        if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store.get(it) || {};
    };
    has = function(it) {
        return store.has(it);
    };
} else {
    var STATE = sharedKey("state");
    hiddenKeys[STATE] = true;
    set = function(it, metadata) {
        if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn(it, STATE);
    };
}
module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};

},{"d3f0c9f3327b2fd6":"agw8W","ca46b44b6201ccd7":"j6YVW","f82e6cc0ac249fa5":"ffNuE","c0ae163eea4ef97":"br79i","6dea7358344877bb":"36o5K","3e035a1241da2f0":"17Rn5","88d6ccc27e779e5a":"6I2Cd","d40b9b3abdbb956e":"butZz"}],"agw8W":[function(require,module,exports) {
"use strict";
var global = require("6bd2547a42528a9c");
var isCallable = require("aa77fff8d5ef0565");
var WeakMap = global.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"6bd2547a42528a9c":"j6YVW","aa77fff8d5ef0565":"aHyPE"}],"ffNuE":[function(require,module,exports) {
"use strict";
var isCallable = require("f87cee1cb79cbcca");
module.exports = function(it) {
    return typeof it == "object" ? it !== null : isCallable(it);
};

},{"f87cee1cb79cbcca":"aHyPE"}],"br79i":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("a8753383ef98ee18");
var definePropertyModule = require("189ab650b8f71085");
var createPropertyDescriptor = require("1168c8162aa30435");
module.exports = DESCRIPTORS ? function(object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"a8753383ef98ee18":"55NyN","189ab650b8f71085":"iTMdX","1168c8162aa30435":"ehEJ3"}],"iTMdX":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("ca50eb9163928400");
var IE8_DOM_DEFINE = require("d482f9e5478795e8");
var V8_PROTOTYPE_DEFINE_BUG = require("b6ad7537efb06f4b");
var anObject = require("16365a73399e7fe7");
var toPropertyKey = require("fab1d366c47796d9");
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE = "configurable";
var WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

},{"ca50eb9163928400":"55NyN","d482f9e5478795e8":"iHNmT","b6ad7537efb06f4b":"26J45","16365a73399e7fe7":"90Dm0","fab1d366c47796d9":"cfNtP"}],"iHNmT":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("9b4278b13c076bf");
var fails = require("8aee5d88a5f9b6b5");
var createElement = require("1db4d60148afcf21");
// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

},{"9b4278b13c076bf":"55NyN","8aee5d88a5f9b6b5":"2EuIj","1db4d60148afcf21":"kZUwH"}],"kZUwH":[function(require,module,exports) {
"use strict";
var global = require("f5891d48afd7ec83");
var isObject = require("824df78b2e007250");
var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return EXISTS ? document.createElement(it) : {};
};

},{"f5891d48afd7ec83":"j6YVW","824df78b2e007250":"ffNuE"}],"26J45":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("b22a5a2de93e3ad2");
var fails = require("249a5b857c2dfccd");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});

},{"b22a5a2de93e3ad2":"55NyN","249a5b857c2dfccd":"2EuIj"}],"90Dm0":[function(require,module,exports) {
"use strict";
var isObject = require("2b6c6258a0a6082f");
var $String = String;
var $TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if (isObject(argument)) return argument;
    throw new $TypeError($String(argument) + " is not an object");
};

},{"2b6c6258a0a6082f":"ffNuE"}],"cfNtP":[function(require,module,exports) {
"use strict";
var toPrimitive = require("53a3a67ac381c4e8");
var isSymbol = require("b992ca9cdcf7937b");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = toPrimitive(argument, "string");
    return isSymbol(key) ? key : key + "";
};

},{"53a3a67ac381c4e8":"lUkaD","b992ca9cdcf7937b":"3DJoV"}],"lUkaD":[function(require,module,exports) {
"use strict";
var call = require("70235907dc93b4b0");
var isObject = require("46fb53dace408c8e");
var isSymbol = require("677bdc4d74d2f983");
var getMethod = require("80395bcde336a28b");
var ordinaryToPrimitive = require("49552a7324952190");
var wellKnownSymbol = require("aea01c71276624bf");
var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = call(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw new $TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return ordinaryToPrimitive(input, pref);
};

},{"70235907dc93b4b0":"hBrD1","46fb53dace408c8e":"ffNuE","677bdc4d74d2f983":"3DJoV","80395bcde336a28b":"fhwn3","49552a7324952190":"liPDK","aea01c71276624bf":"lTRfe"}],"hBrD1":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("44e025d030d66023");
var call = Function.prototype.call;
module.exports = NATIVE_BIND ? call.bind(call) : function() {
    return call.apply(call, arguments);
};

},{"44e025d030d66023":"3ippH"}],"3DJoV":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("6b6c481cdfb7df35");
var isCallable = require("2af44fcbdbf14c83");
var isPrototypeOf = require("76e903e830c40e7c");
var USE_SYMBOL_AS_UID = require("7e2fe930b3598e22");
var $Object = Object;
module.exports = USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = getBuiltIn("Symbol");
    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"6b6c481cdfb7df35":"lFcMR","2af44fcbdbf14c83":"aHyPE","76e903e830c40e7c":"hQKZd","7e2fe930b3598e22":"8rQG0"}],"lFcMR":[function(require,module,exports) {
"use strict";
var global = require("dd9e9ae04e8684f7");
var isCallable = require("f1d62079325906cb");
var aFunction = function(argument) {
    return isCallable(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};

},{"dd9e9ae04e8684f7":"j6YVW","f1d62079325906cb":"aHyPE"}],"hQKZd":[function(require,module,exports) {
"use strict";
var uncurryThis = require("83f14842ef67e16a");
module.exports = uncurryThis({}.isPrototypeOf);

},{"83f14842ef67e16a":"37Z8T"}],"8rQG0":[function(require,module,exports) {
"use strict";
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = require("da4a972af0214ea0");
module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";

},{"da4a972af0214ea0":"dvDjp"}],"dvDjp":[function(require,module,exports) {
"use strict";
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = require("ecc4d354cb42bea8");
var fails = require("b37df495bcdc1d99");
var global = require("d8adff9188ad5fee");
var $String = global.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"ecc4d354cb42bea8":"5l43v","b37df495bcdc1d99":"2EuIj","d8adff9188ad5fee":"j6YVW"}],"5l43v":[function(require,module,exports) {
"use strict";
var global = require("705d79ce07ed8cf");
var userAgent = require("5afb83a49cd74e4c");
var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
module.exports = version;

},{"705d79ce07ed8cf":"j6YVW","5afb83a49cd74e4c":"cubJp"}],"cubJp":[function(require,module,exports) {
"use strict";
module.exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";

},{}],"fhwn3":[function(require,module,exports) {
"use strict";
var aCallable = require("bbfed17b24e215f4");
var isNullOrUndefined = require("492a86e2970f6a26");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"bbfed17b24e215f4":"eYWIK","492a86e2970f6a26":"aUt9w"}],"eYWIK":[function(require,module,exports) {
"use strict";
var isCallable = require("4094667126ecac05");
var tryToString = require("fce2a7573db493fa");
var $TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if (isCallable(argument)) return argument;
    throw new $TypeError(tryToString(argument) + " is not a function");
};

},{"4094667126ecac05":"aHyPE","fce2a7573db493fa":"b59Rt"}],"b59Rt":[function(require,module,exports) {
"use strict";
var $String = String;
module.exports = function(argument) {
    try {
        return $String(argument);
    } catch (error) {
        return "Object";
    }
};

},{}],"liPDK":[function(require,module,exports) {
"use strict";
var call = require("abe9ca006f56626e");
var isCallable = require("c96b3a89fec6248a");
var isObject = require("551615fda0214f1b");
var $TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
    if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    throw new $TypeError("Can't convert object to primitive value");
};

},{"abe9ca006f56626e":"hBrD1","c96b3a89fec6248a":"aHyPE","551615fda0214f1b":"ffNuE"}],"lTRfe":[function(require,module,exports) {
"use strict";
var global = require("dbe74e87464035e3");
var shared = require("6a2cda01df6b4c79");
var hasOwn = require("dccc28ffa5beeb54");
var uid = require("48d6af1225853d44");
var NATIVE_SYMBOL = require("9f762329148684");
var USE_SYMBOL_AS_UID = require("1ce268781e409df2");
var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared("wks");
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol["for"] || Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function(name) {
    if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name) ? Symbol[name] : createWellKnownSymbol("Symbol." + name);
    return WellKnownSymbolsStore[name];
};

},{"dbe74e87464035e3":"j6YVW","6a2cda01df6b4c79":"8H71l","dccc28ffa5beeb54":"36o5K","48d6af1225853d44":"1tDqA","9f762329148684":"dvDjp","1ce268781e409df2":"8rQG0"}],"8H71l":[function(require,module,exports) {
"use strict";
var IS_PURE = require("fe5f96cb4b2826a2");
var store = require("84eeed9891aafe14");
(module.exports = function(key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.35.1",
    mode: IS_PURE ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});

},{"fe5f96cb4b2826a2":"8k1hD","84eeed9891aafe14":"17Rn5"}],"8k1hD":[function(require,module,exports) {
"use strict";
module.exports = false;

},{}],"1tDqA":[function(require,module,exports) {
"use strict";
var uncurryThis = require("5da0fe4507da20a3");
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);
module.exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString(++id + postfix, 36);
};

},{"5da0fe4507da20a3":"37Z8T"}],"ehEJ3":[function(require,module,exports) {
"use strict";
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"6I2Cd":[function(require,module,exports) {
"use strict";
var shared = require("dbc8182adeb8c92f");
var uid = require("90b4ffb58508a6e5");
var keys = shared("keys");
module.exports = function(key) {
    return keys[key] || (keys[key] = uid(key));
};

},{"dbc8182adeb8c92f":"8H71l","90b4ffb58508a6e5":"1tDqA"}],"butZz":[function(require,module,exports) {
"use strict";
module.exports = {};

},{}],"dNPA1":[function(require,module,exports) {
"use strict";
var anObject = require("136abace0aec2b5c");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function() {
    var that = anObject(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};

},{"136abace0aec2b5c":"90Dm0"}],"4axQW":[function(require,module,exports) {
"use strict";
var global = require("b9fe5b9aa917cacb");
var call = require("8bf28e9cdb4b51e7");
var ArrayBufferViewCore = require("3cf762b146f90585");
var lengthOfArrayLike = require("16f38bcdf8d74421");
var toOffset = require("4a9c5a15d77842f8");
var toIndexedObject = require("e57503c492a0d3da");
var fails = require("52b307bfea7391a");
var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    call($set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function() {
    var array = new Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    aTypedArray(this);
    var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = toIndexedObject(arrayLike);
    if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
    var length = this.length;
    var len = lengthOfArrayLike(src);
    var index = 0;
    if (len + offset > length) throw new RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

},{"b9fe5b9aa917cacb":"j6YVW","8bf28e9cdb4b51e7":"hBrD1","3cf762b146f90585":"8f52u","16f38bcdf8d74421":"kSAsj","4a9c5a15d77842f8":"cBxfv","e57503c492a0d3da":"jzUbe","52b307bfea7391a":"2EuIj"}],"8f52u":[function(require,module,exports) {
"use strict";
var NATIVE_ARRAY_BUFFER = require("4142cc1b1f950662");
var DESCRIPTORS = require("fa237bbf2050dd6d");
var global = require("c88b3cc3863fe00");
var isCallable = require("1b44b7e19e6f660d");
var isObject = require("af39713fe0cf7587");
var hasOwn = require("dd5eec94b1519471");
var classof = require("b9eebb2d4c13b0d6");
var tryToString = require("36a2290066710aa0");
var createNonEnumerableProperty = require("fdfbb82e20f81a19");
var defineBuiltIn = require("81ef6d90bc6acdce");
var defineBuiltInAccessor = require("96421c541af03be5");
var isPrototypeOf = require("ab8263bb2af6274");
var getPrototypeOf = require("ba5da2480b30b79");
var setPrototypeOf = require("b6e4d282cbe3e34a");
var wellKnownSymbol = require("3d5af0d43aa6e42b");
var uid = require("8007fa7370557b8e");
var InternalStateModule = require("82848943f937d383");
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var TYPED_ARRAY_TAG = uid("TYPED_ARRAY_TAG");
var TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== "Opera";
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;
var TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var isView = function isView(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return klass === "DataView" || hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
};
var getTypedArrayConstructor = function(it) {
    var proto = getPrototypeOf(it);
    if (!isObject(proto)) return;
    var state = getInternalState(proto);
    return state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};
var isTypedArray = function(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
};
var aTypedArray = function(it) {
    if (isTypedArray(it)) return it;
    throw new TypeError("Target is not a typed array");
};
var aTypedArrayConstructor = function(C) {
    if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
    throw new TypeError(tryToString(C) + " is not a typed array constructor");
};
var exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!DESCRIPTORS) return;
    if (forced) for(var ARRAY in TypedArrayConstructorsList){
        var TypedArrayConstructor = global[ARRAY];
        if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!TypedArrayPrototype[KEY] || forced) defineBuiltIn(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
};
var exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!DESCRIPTORS) return;
    if (setPrototypeOf) {
        if (forced) for(ARRAY in TypedArrayConstructorsList){
            TypedArrayConstructor = global[ARRAY];
            if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in TypedArrayConstructorsList){
        TypedArrayConstructor = global[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
};
for(NAME in TypedArrayConstructorsList){
    Constructor = global[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
    else NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for(NAME in BigIntArrayConstructorsList){
    Constructor = global[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    TypedArray = function TypedArray() {
        throw new TypeError("Incorrect invocation");
    };
    if (NATIVE_ARRAY_BUFFER_VIEWS) {
        for(NAME in TypedArrayConstructorsList)if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
    }
}
if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
    TypedArrayPrototype = TypedArray.prototype;
    if (NATIVE_ARRAY_BUFFER_VIEWS) {
        for(NAME in TypedArrayConstructorsList)if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
    TYPED_ARRAY_TAG_REQUIRED = true;
    defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
        }
    });
    for(NAME in TypedArrayConstructorsList)if (global[NAME]) createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
}
module.exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
    aTypedArray: aTypedArray,
    aTypedArrayConstructor: aTypedArrayConstructor,
    exportTypedArrayMethod: exportTypedArrayMethod,
    exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
    getTypedArrayConstructor: getTypedArrayConstructor,
    isView: isView,
    isTypedArray: isTypedArray,
    TypedArray: TypedArray,
    TypedArrayPrototype: TypedArrayPrototype
};

},{"4142cc1b1f950662":"6rrOL","fa237bbf2050dd6d":"55NyN","c88b3cc3863fe00":"j6YVW","1b44b7e19e6f660d":"aHyPE","af39713fe0cf7587":"ffNuE","dd5eec94b1519471":"36o5K","b9eebb2d4c13b0d6":"qAq9Y","36a2290066710aa0":"b59Rt","fdfbb82e20f81a19":"br79i","81ef6d90bc6acdce":"cyjCn","96421c541af03be5":"jcgeN","ab8263bb2af6274":"hQKZd","ba5da2480b30b79":"kKlxC","b6e4d282cbe3e34a":"4fV6q","3d5af0d43aa6e42b":"lTRfe","8007fa7370557b8e":"1tDqA","82848943f937d383":"lNt2C"}],"6rrOL":[function(require,module,exports) {
"use strict";
// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";

},{}],"qAq9Y":[function(require,module,exports) {
"use strict";
var TO_STRING_TAG_SUPPORT = require("397e535b3976d304");
var isCallable = require("eebd8012c2d2c3ae");
var classofRaw = require("8da113eeaf06c4ba");
var wellKnownSymbol = require("df252844008f634");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var $Object = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === "Object" && isCallable(O.callee) ? "Arguments" : result;
};

},{"397e535b3976d304":"aVkF5","eebd8012c2d2c3ae":"aHyPE","8da113eeaf06c4ba":"gYVXX","df252844008f634":"lTRfe"}],"aVkF5":[function(require,module,exports) {
"use strict";
var wellKnownSymbol = require("6306cd4835715127");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var test = {};
test[TO_STRING_TAG] = "z";
module.exports = String(test) === "[object z]";

},{"6306cd4835715127":"lTRfe"}],"gYVXX":[function(require,module,exports) {
"use strict";
var uncurryThis = require("1c71c3f6daac476c");
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis("".slice);
module.exports = function(it) {
    return stringSlice(toString(it), 8, -1);
};

},{"1c71c3f6daac476c":"37Z8T"}],"cyjCn":[function(require,module,exports) {
"use strict";
var isCallable = require("99ee13632b3fa68");
var definePropertyModule = require("9ebb3e3004fccc0a");
var makeBuiltIn = require("f10cc812a3094053");
var defineGlobalProperty = require("d354802d852d9c2b");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if (isCallable(value)) makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else definePropertyModule.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

},{"99ee13632b3fa68":"aHyPE","9ebb3e3004fccc0a":"iTMdX","f10cc812a3094053":"6wVaa","d354802d852d9c2b":"4GyjI"}],"kKlxC":[function(require,module,exports) {
"use strict";
var hasOwn = require("da54a59ea207dd");
var isCallable = require("71ab2a7bcc8c8fc8");
var toObject = require("7a3afd2bb40b0292");
var sharedKey = require("296d7a2db8e23969");
var CORRECT_PROTOTYPE_GETTER = require("58de29d5e883862f");
var IE_PROTO = sharedKey("IE_PROTO");
var $Object = Object;
var ObjectPrototype = $Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
    var object = toObject(O);
    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;
    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $Object ? ObjectPrototype : null;
};

},{"da54a59ea207dd":"36o5K","71ab2a7bcc8c8fc8":"aHyPE","7a3afd2bb40b0292":"jzUbe","296d7a2db8e23969":"6I2Cd","58de29d5e883862f":"5nW3Q"}],"5nW3Q":[function(require,module,exports) {
"use strict";
var fails = require("85ffc28af2e8afc1");
module.exports = !fails(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"85ffc28af2e8afc1":"2EuIj"}],"4fV6q":[function(require,module,exports) {
"use strict";
/* eslint-disable no-proto -- safe */ var uncurryThisAccessor = require("995a94425a563d6");
var anObject = require("4b49e5767d221547");
var aPossiblePrototype = require("6e2c833ee2a62cf6");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = uncurryThisAccessor(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        anObject(O);
        aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

},{"995a94425a563d6":"k4Y08","4b49e5767d221547":"90Dm0","6e2c833ee2a62cf6":"6HzSR"}],"k4Y08":[function(require,module,exports) {
"use strict";
var uncurryThis = require("27a2d181325e1926");
var aCallable = require("36b26076b1e2fac1");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

},{"27a2d181325e1926":"37Z8T","36b26076b1e2fac1":"eYWIK"}],"6HzSR":[function(require,module,exports) {
"use strict";
var isPossiblePrototype = require("fcc5bbb526d602c6");
var $String = String;
var $TypeError = TypeError;
module.exports = function(argument) {
    if (isPossiblePrototype(argument)) return argument;
    throw new $TypeError("Can't set " + $String(argument) + " as a prototype");
};

},{"fcc5bbb526d602c6":"4bkNu"}],"4bkNu":[function(require,module,exports) {
"use strict";
var isObject = require("a504c97d35bacd6c");
module.exports = function(argument) {
    return isObject(argument) || argument === null;
};

},{"a504c97d35bacd6c":"ffNuE"}],"kSAsj":[function(require,module,exports) {
"use strict";
var toLength = require("23d9716c54a2ab90");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return toLength(obj.length);
};

},{"23d9716c54a2ab90":"kZQ1D"}],"kZQ1D":[function(require,module,exports) {
"use strict";
var toIntegerOrInfinity = require("c48d3a8b8ac52b0b");
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = toIntegerOrInfinity(argument);
    return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"c48d3a8b8ac52b0b":"lQoKl"}],"lQoKl":[function(require,module,exports) {
"use strict";
var trunc = require("3403cba02b5f61d8");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};

},{"3403cba02b5f61d8":"5YReJ"}],"5YReJ":[function(require,module,exports) {
"use strict";
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};

},{}],"cBxfv":[function(require,module,exports) {
"use strict";
var toPositiveInteger = require("3d42e5f9448f0334");
var $RangeError = RangeError;
module.exports = function(it, BYTES) {
    var offset = toPositiveInteger(it);
    if (offset % BYTES) throw new $RangeError("Wrong offset");
    return offset;
};

},{"3d42e5f9448f0334":"dKElF"}],"dKElF":[function(require,module,exports) {
"use strict";
var toIntegerOrInfinity = require("e509d82728a7abb4");
var $RangeError = RangeError;
module.exports = function(it) {
    var result = toIntegerOrInfinity(it);
    if (result < 0) throw new $RangeError("The argument can't be less than 0");
    return result;
};

},{"e509d82728a7abb4":"lQoKl"}],"enbMA":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"9HEnv"}],"9HEnv":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"cOWTg"}],"cOWTg":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7pbWU"}],"7pbWU":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.2.0";

},{}],"d0tab":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"aPjLf"}],"aPjLf":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"l9Ddo"}],"l9Ddo":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var Mg = Uf(null), Ng = null, Og = null, Pg = null;
function Qg() {
    Pg = Og = Ng = null;
}
function Rg(a) {
    var b = Mg.current;
    E(Mg);
    a._currentValue = b;
}
function Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function Tg(a, b) {
    Ng = a;
    Pg = Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (Ug = !0), a.firstContext = null);
}
function Vg(a) {
    var b = a._currentValue;
    if (Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Og) {
            if (null === Ng) throw Error(p(308));
            Og = a;
            Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Og = Og.next = a;
    }
    return b;
}
var Wg = null;
function Xg(a) {
    null === Wg ? Wg = [
        a
    ] : Wg.push(a);
}
function Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return Zg(a, d);
}
function Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $g = !1;
function ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return Zg(a, c);
}
function eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function gh(a, b, c, d) {
    var e = a.updateQueue;
    $g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            $g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var jh = (new aa.Component).refs;
function kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = L(), d = lh(a), e = ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = dh(a, e, d);
        null !== b && (mh(b, a, d, c), eh(b, a, d));
    }
};
function oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function ph(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = Vg(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && nh.enqueueReplaceState(b, b.state, null);
}
function rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = jh;
    ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = Vg(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && nh.enqueueReplaceState(e, e.state, null), gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function uh(a) {
    var b = a._init;
    return b(a._payload);
}
function vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && uh(f) === b.type)) return d = e(b, c.props), d.ref = sh(a, b, c), d.return = a, d;
        d = yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = yh(b.type, b.key, b.props, null, a.mode, c), c.ref = sh(a, null, b), c.return = a, c;
                case wa:
                    return b = zh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Ah(b, a.mode, c, null), b.return = a, b;
            th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = yh(f.type, f.key, f.props, null, a.mode, h), h.ref = sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Bh = vh(!0), Ch = vh(!1), Dh = {}, Eh = Uf(Dh), Fh = Uf(Dh), Gh = Uf(Dh);
function Hh(a) {
    if (a === Dh) throw Error(p(174));
    return a;
}
function Ih(a, b) {
    G(Gh, b);
    G(Fh, a);
    G(Eh, Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(Eh);
    G(Eh, b);
}
function Jh() {
    E(Eh);
    E(Fh);
    E(Gh);
}
function Kh(a) {
    Hh(Gh.current);
    var b = Hh(Eh.current);
    var c = lb(b, a.type);
    b !== c && (G(Fh, a), G(Eh, c));
}
function Lh(a) {
    Fh.current === a && (E(Eh), E(Fh));
}
var M = Uf(0);
function Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Nh = [];
function Oh() {
    for(var a = 0; a < Nh.length; a++)Nh[a]._workInProgressVersionPrimary = null;
    Nh.length = 0;
}
var Ph = ua.ReactCurrentDispatcher, Qh = ua.ReactCurrentBatchConfig, Rh = 0, N = null, O = null, P = null, Sh = !1, Th = !1, Uh = 0, Vh = 0;
function Q() {
    throw Error(p(321));
}
function Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Xh(a, b, c, d, e, f) {
    Rh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Ph.current = null === a || null === a.memoizedState ? Yh : Zh;
    a = c(d, e);
    if (Th) {
        f = 0;
        do {
            Th = !1;
            Uh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            Ph.current = $h;
            a = c(d, e);
        }while (Th);
    }
    Ph.current = ai;
    b = null !== O && null !== O.next;
    Rh = 0;
    P = O = N = null;
    Sh = !1;
    if (b) throw Error(p(300));
    return a;
}
function bi() {
    var a = 0 !== Uh;
    Uh = 0;
    return a;
}
function ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function di() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(p(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function fi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                N.lanes |= m;
                hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, N.lanes |= f, hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function gi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function hi() {}
function ii(a, b) {
    var c = N, d = di(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, Ug = !0);
    d = d.queue;
    ji(ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== P && P.memoizedState.tag & 1) {
        c.flags |= 2048;
        li(9, mi.bind(null, c, d, e, b), void 0, null);
        if (null === R) throw Error(p(349));
        0 !== (Rh & 30) || ni(c, b, e);
    }
    return e;
}
function ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    oi(b) && pi(a);
}
function ki(a, b, c) {
    return c(function() {
        oi(b) && pi(a);
    });
}
function oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function pi(a) {
    var b = Zg(a, 1);
    null !== b && mh(b, a, 1, -1);
}
function qi(a) {
    var b = ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ri.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function si() {
    return di().memoizedState;
}
function ti(a, b, c, d) {
    var e = ci();
    N.flags |= a;
    e.memoizedState = li(1 | b, c, void 0, void 0 === d ? null : d);
}
function ui(a, b, c, d) {
    var e = di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && Wh(d, g.deps)) {
            e.memoizedState = li(b, c, f, d);
            return;
        }
    }
    N.flags |= a;
    e.memoizedState = li(1 | b, c, f, d);
}
function vi(a, b) {
    return ti(8390656, 8, a, b);
}
function ji(a, b) {
    return ui(2048, 8, a, b);
}
function wi(a, b) {
    return ui(4, 2, a, b);
}
function xi(a, b) {
    return ui(4, 4, a, b);
}
function yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return ui(4, 4, yi.bind(null, b, a), c);
}
function Ai() {}
function Bi(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ci(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Di(a, b, c) {
    if (0 === (Rh & 21)) return a.baseState && (a.baseState = !1, Ug = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), N.lanes |= c, hh |= c, a.baseState = !0);
    return b;
}
function Ei(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Qh.transition;
    Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Qh.transition = d;
    }
}
function Fi() {
    return di().memoizedState;
}
function Gi(a, b, c) {
    var d = lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, c);
    else if (c = Yg(a, b, c, d), null !== c) {
        var e = L();
        mh(c, a, d, e);
        Ji(c, b, d);
    }
}
function ri(a, b, c) {
    var d = lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = Yg(a, b, e, d);
        null !== c && (e = L(), mh(c, a, d, e), Ji(c, b, d));
    }
}
function Hi(a) {
    var b = a.alternate;
    return a === N || null !== b && b === N;
}
function Ii(a, b) {
    Th = Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var ai = {
    readContext: Vg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useInsertionEffect: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useDeferredValue: Q,
    useTransition: Q,
    useMutableSource: Q,
    useSyncExternalStore: Q,
    useId: Q,
    unstable_isNewReconciler: !1
}, Yh = {
    readContext: Vg,
    useCallback: function(a, b) {
        ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: Vg,
    useEffect: vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ti(4194308, 4, yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Gi.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: qi,
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        return ci().memoizedState = a;
    },
    useTransition: function() {
        var a = qi(!1), b = a[0];
        a = Ei.bind(null, a[1]);
        ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = N, e = ci();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === R) throw Error(p(349));
            0 !== (Rh & 30) || ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        vi(ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        li(9, mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = ci(), b = R.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Zh = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: fi,
    useRef: si,
    useState: function() {
        return fi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = fi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
}, $h = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: gi,
    useRef: si,
    useState: function() {
        return gi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return null === O ? b.memoizedState = a : Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = gi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
};
function Ki(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ni = "function" === typeof WeakMap ? WeakMap : Map;
function Oi(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Pi || (Pi = !0, Qi = d);
        Mi(a, b);
    };
    return c;
}
function Ri(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Mi(a, b);
        "function" !== typeof d && (null === Si ? Si = new Set([
            this
        ]) : Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ui.bind(null, a, b, c), b.then(a, a));
}
function Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ch(-1, 1), b.tag = 2, dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Xi = ua.ReactCurrentOwner, Ug = !1;
function Yi(a, b, c, d) {
    b.child = null === a ? Ch(b, null, c, d) : Bh(b, a.child, c, d);
}
function Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Tg(b, e);
    d = Xh(a, b, c, d, f, e);
    c = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Yi(a, b, d, e);
    return b.child;
}
function aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, cj(a, b, f, d, e);
        a = yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return $i(a, b, e);
    }
    b.flags |= 1;
    a = wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (Ug = !0);
            else return b.lanes = a.lanes, $i(a, b, e);
        }
    }
    return dj(a, b, c, d, e);
}
function ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(fj, gj), gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(fj, gj), gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(fj, gj);
            gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(fj, gj), gj |= d;
    Yi(a, b, e, c);
    return b.child;
}
function hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function dj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    Tg(b, e);
    c = Xh(a, b, c, d, f, e);
    d = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Yi(a, b, c, e);
    return b.child;
}
function ij(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    Tg(b, e);
    if (null === b.stateNode) jj(a, b), ph(b, c, d), rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = Vg(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && qh(b, g, d, l);
        $g = !1;
        var r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || $g ? ("function" === typeof m && (kh(b, c, m, d), k = b.memoizedState), (h = $g || oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = Vg(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && qh(b, g, d, k);
        $g = !1;
        r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || $g ? ("function" === typeof y && (kh(b, c, y, d), n = b.memoizedState), (l = $g || oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return kj(a, b, c, d, f, e);
}
function kj(a, b, c, d, e, f) {
    hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), $i(a, b, f);
    d = b.stateNode;
    Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Bh(b, a.child, null, f), b.child = Bh(b, null, h, f)) : Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function lj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    Ih(a, b.containerInfo);
}
function mj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Yi(a, b, c, d);
    return b.child;
}
var nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function pj(a, b, c) {
    var d = b.pendingProps, e = M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(M, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = qj(g, d, 0, null), a = Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = oj(c), b.memoizedState = nj, a) : rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = wh(h, f) : (f = Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function rj(a, b) {
    b = qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function tj(a, b, c, d) {
    null !== d && Jg(d);
    Bh(b, a.child, null, c);
    a = rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Li(Error(p(422))), tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Bh(b, a.child, null, g);
        b.child.memoizedState = oj(g);
        b.memoizedState = nj;
        return f;
    }
    if (0 === (b.mode & 1)) return tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Li(f, d, void 0);
        return tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (Ug || h) {
        d = R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, Zg(a, e), mh(d, a, e, -1));
        }
        uj();
        d = Li(Error(p(421)));
        return tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    Sg(a.return, b, c);
}
function xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Yi(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && wj(a, c, b);
            else if (19 === a.tag) wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            xj(b, !0, c, null, f);
            break;
        case "together":
            xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function zj(a, b, c) {
    switch(b.tag){
        case 3:
            lj(b);
            Ig();
            break;
        case 5:
            Kh(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(M, M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return pj(a, b, c);
                G(M, M.current & 1);
                a = $i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(M, M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(M, M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, ej(a, b, c);
    }
    return $i(a, b, c);
}
var Aj, Bj, Cj, Dj;
Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Bj = function() {};
Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Hh(Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Ej(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Fj(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            Jh();
            E(Wf);
            E(H);
            Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Gj(zg), zg = null));
            Bj(a, b);
            S(b);
            return null;
        case 5:
            Lh(b);
            var e = Hh(Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Hh(Gh.current);
                Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Gj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (M.current & 1) ? 0 === T && (T = 3) : uj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return Jh(), Bj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return Rg(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(M);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Ej(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(M, M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Hj && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Hj && 1073741824 !== c && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = M.current, G(M, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (gj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Jj(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Jh(), E(Wf), E(H), Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Lh(b), null;
        case 13:
            E(M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(M), null;
        case 4:
            return Jh(), null;
        case 10:
            return Rg(b.type._context), null;
        case 22:
        case 23:
            return Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Kj = !1, U = !1, Lj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Oj = !1;
function Pj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Oj;
    Oj = !1;
    return n;
}
function Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
function Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Xj(a, b, c), a = a.sibling; null !== a;)Xj(a, b, c), a = a.sibling;
}
var X = null, Yj = !1;
function Zj(a, b, c) {
    for(c = c.child; null !== c;)ak(a, b, c), c = c.sibling;
}
function ak(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Mj(c, b);
        case 6:
            var d = X, e = Yj;
            X = null;
            Zj(a, b, c);
            X = d;
            Yj = e;
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Yj;
            X = c.stateNode.containerInfo;
            Yj = !0;
            Zj(a, b, c);
            X = d;
            Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Nj(c, b, g) : 0 !== (f & 4) && Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Zj(a, b, c);
            break;
        case 1:
            if (!U && (Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Zj(a, b, c);
            break;
        case 21:
            Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Zj(a, b, c), U = d) : Zj(a, b, c);
            break;
        default:
            Zj(a, b, c);
    }
}
function bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Lj);
        b.forEach(function(b) {
            var d = ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Yj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            ak(f, g, e);
            X = null;
            Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ek(b, a), b = b.sibling;
}
function ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            dk(b, a);
            fk(a);
            if (d & 4) {
                try {
                    Qj(3, a, a.return), Rj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Qj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            break;
        case 5:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            dk(b, a);
            fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            dk(b, a);
            fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            dk(b, a);
            fk(a);
            break;
        case 13:
            dk(b, a);
            fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (gk = B()));
            d & 4 && bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, dk(b, a), U = l) : dk(b, a);
            fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Qj(4, r, r.return);
                                break;
                            case 1:
                                Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            dk(b, a);
            fk(a);
            d & 4 && bk(a);
            break;
        case 21:
            break;
        default:
            dk(b, a), fk(a);
    }
}
function fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Vj(a);
                    Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Vj(a);
                    Wj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function ik(a, b, c) {
    V = a;
    jk(a, b, c);
}
function jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Kj;
                var l = U;
                Kj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? kk(e) : null !== k ? (k.return = g, V = k) : kk(e);
                for(; null !== f;)V = f, jk(f, b, c), f = f.sibling;
                V = e;
                Kj = h;
                U = l;
            }
            lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : lk(a, b, c);
    }
}
function lk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Sj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function hk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Rj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var mk = Math.ceil, nk = ua.ReactCurrentDispatcher, ok = ua.ReactCurrentOwner, pk = ua.ReactCurrentBatchConfig, K = 0, R = null, Y = null, Z = 0, gj = 0, fj = Uf(0), T = 0, qk = null, hh = 0, rk = 0, sk = 0, tk = null, uk = null, gk = 0, Hj = Infinity, vk = null, Pi = !1, Qi = null, Si = null, wk = !1, xk = null, yk = 0, zk = 0, Ak = null, Bk = -1, Ck = 0;
function L() {
    return 0 !== (K & 6) ? B() : -1 !== Bk ? Bk : Bk = B();
}
function lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Ck && (Ck = yc()), Ck;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function mh(a, b, c, d) {
    if (50 < zk) throw zk = 0, Ak = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== R) a === R && (0 === (K & 2) && (rk |= c), 4 === T && Dk(a, Z)), Ek(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Hj = B() + 500, fg && jg());
}
function Ek(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Fk.bind(null, a)) : hg(Fk.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Gk(c, Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Hk(a, b) {
    Bk = -1;
    Ck = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Ik() && a.callbackNode !== c) return null;
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Jk(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Kk();
        if (R !== a || Z !== b) vk = null, Hj = B() + 500, Lk(a, b);
        for(;;)try {
            Mk();
            break;
        } catch (h) {
            Nk(a, h);
        }
        Qg();
        nk.current = f;
        K = e;
        null !== Y ? b = 0 : (R = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Ok(a, e)));
        if (1 === b) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
        if (6 === b) Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Pk(e) && (b = Jk(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Ok(a, f))), 1 === b)) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Qk(a, uk, vk);
                    break;
                case 3:
                    Dk(a, d);
                    if ((d & 130023424) === d && (b = gk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), b);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 4:
                    Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), d);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 5:
                    Qk(a, uk, vk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ek(a, B());
    return a.callbackNode === c ? Hk.bind(null, a) : null;
}
function Ok(a, b) {
    var c = tk;
    a.current.memoizedState.isDehydrated && (Lk(a, b).flags |= 256);
    a = Jk(a, b);
    2 !== a && (b = uk, uk = c, null !== b && Gj(b));
    return a;
}
function Gj(a) {
    null === uk ? uk = a : uk.push.apply(uk, a);
}
function Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Dk(a, b) {
    b &= ~sk;
    b &= ~rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Fk(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Ik();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Ek(a, B()), null;
    var c = Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Ok(a, d));
    }
    if (1 === c) throw c = qk, Lk(a, 0), Dk(a, b), Ek(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Qk(a, uk, vk);
    Ek(a, B());
    return null;
}
function Rk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Hj = B() + 500, fg && jg());
    }
}
function Sk(a) {
    null !== xk && 0 === xk.tag && 0 === (K & 6) && Ik();
    var b = K;
    K |= 1;
    var c = pk.transition, d = C;
    try {
        if (pk.transition = null, C = 1, a) return a();
    } finally{
        C = d, pk.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Ij() {
    gj = fj.current;
    E(fj);
}
function Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                Jh();
                E(Wf);
                E(H);
                Oh();
                break;
            case 5:
                Lh(d);
                break;
            case 4:
                Jh();
                break;
            case 13:
                E(M);
                break;
            case 19:
                E(M);
                break;
            case 10:
                Rg(d.type._context);
                break;
            case 22:
            case 23:
                Ij();
        }
        c = c.return;
    }
    R = a;
    Y = a = wh(a.current, null);
    Z = gj = b;
    T = 0;
    qk = null;
    sk = rk = hh = 0;
    uk = tk = null;
    if (null !== Wg) {
        for(b = 0; b < Wg.length; b++)if (c = Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        Wg = null;
    }
    return a;
}
function Nk(a, b) {
    do {
        var c = Y;
        try {
            Qg();
            Ph.current = ai;
            if (Sh) {
                for(var d = N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Sh = !1;
            }
            Rh = 0;
            P = O = N = null;
            Th = !1;
            Uh = 0;
            ok.current = null;
            if (null === c || null === c.return) {
                T = 1;
                qk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Wi(y, g, h, f, b);
                        y.mode & 1 && Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Ti(f, l, b);
                            uj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Wi(J, g, h, f, b);
                        Jg(Ki(k, h));
                        break a;
                    }
                }
                f = k = Ki(k, h);
                4 !== T && (T = 2);
                null === tk ? tk = [
                    f
                ] : tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Oi(f, k, b);
                            fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Si || !Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Ri(f, h, b);
                                fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Tk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Kk() {
    var a = nk.current;
    nk.current = ai;
    return null === a ? ai : a;
}
function uj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === R || 0 === (hh & 268435455) && 0 === (rk & 268435455) || Dk(R, Z);
}
function Jk(a, b) {
    var c = K;
    K |= 2;
    var d = Kk();
    if (R !== a || Z !== b) vk = null, Lk(a, b);
    for(;;)try {
        Uk();
        break;
    } catch (e) {
        Nk(a, e);
    }
    Qg();
    K = c;
    nk.current = d;
    if (null !== Y) throw Error(p(261));
    R = null;
    Z = 0;
    return T;
}
function Uk() {
    for(; null !== Y;)Vk(Y);
}
function Mk() {
    for(; null !== Y && !cc();)Vk(Y);
}
function Vk(a) {
    var b = Wk(a.alternate, a, gj);
    a.memoizedProps = a.pendingProps;
    null === b ? Tk(a) : Y = b;
    ok.current = null;
}
function Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Fj(c, b, gj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Qk(a, b, c) {
    var d = C, e = pk.transition;
    try {
        pk.transition = null, C = 1, Xk(a, b, c, d);
    } finally{
        pk.transition = e, C = d;
    }
    return null;
}
function Xk(a, b, c, d) {
    do Ik();
    while (null !== xk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === R && (Y = R = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || wk || (wk = !0, Gk(hc, function() {
        Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = pk.transition;
        pk.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        ok.current = null;
        Pj(a, c);
        ek(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        ik(c, a, e);
        dc();
        K = h;
        C = g;
        pk.transition = f;
    } else a.current = c;
    wk && (wk = !1, xk = a, yk = e);
    f = a.pendingLanes;
    0 === f && (Si = null);
    mc(c.stateNode, d);
    Ek(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Pi) throw Pi = !1, a = Qi, Qi = null, a;
    0 !== (yk & 1) && 0 !== a.tag && Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === Ak ? zk++ : (zk = 0, Ak = a) : zk = 0;
    jg();
    return null;
}
function Ik() {
    if (null !== xk) {
        var a = Dc(yk), b = pk.transition, c = C;
        try {
            pk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === xk) var d = !1;
            else {
                a = xk;
                xk = null;
                yk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Tj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Rj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, pk.transition = b;
        }
    }
    return !1;
}
function Yk(a, b, c) {
    b = Ki(c, b);
    b = Oi(a, b, 1);
    a = dh(a, b, 1);
    b = L();
    null !== a && (Ac(a, 1, b), Ek(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Si || !Si.has(d))) {
                a = Ki(c, a);
                a = Ri(b, a, 1);
                b = dh(b, a, 1);
                a = L();
                null !== b && (Ac(b, 1, a), Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = L();
    a.pingedLanes |= a.suspendedLanes & c;
    R === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - gk ? Lk(a, 0) : sk |= c);
    Ek(a, b);
}
function Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = L();
    a = Zg(a, b);
    null !== a && (Ac(a, b, c), Ek(a, c));
}
function vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Zk(a, c);
}
function ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Zk(a, c);
}
var Wk;
Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return Ug = !1, zj(a, b, c);
            Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else Ug = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            jj(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            Tg(b, c);
            e = Xh(null, b, d, a, e, c);
            var f = bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ah(b), e.updater = nh, b.stateNode = e, e._reactInternals = b, rh(b, d, a, c), b = kj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $k(d);
                a = Lg(d, a);
                switch(e){
                    case 0:
                        b = dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = aj(null, b, d, Lg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), ij(a, b, d, e, c);
        case 3:
            a: {
                lj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                bh(a, b);
                gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ki(Error(p(423)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ki(Error(p(424)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = $i(a, b, c);
                        break a;
                    }
                    Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Kh(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), hj(a, b), Yi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return pj(a, b, c);
        case 4:
            return Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Bh(b, null, d, c) : Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), Zi(a, b, d, e, c);
        case 7:
            return Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = $i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, Tg(b, c), e = Vg(e), d = d(e), b.flags |= 1, Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Lg(d, b.pendingProps), e = Lg(d.type, e), aj(a, b, d, e, c);
        case 15:
            return cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), jj(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, Tg(b, c), ph(b, d, e), rh(b, d, e, c), kj(null, b, d, !0, a, c);
        case 19:
            return yj(a, b, c);
        case 22:
            return ej(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Gk(a, b) {
    return ac(a, b);
}
function al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new al(a, b, c, d);
}
function bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $k(a) {
    if ("function" === typeof a) return bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function wh(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Ah(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Ah(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function qj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function xh(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function zh(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function cl(a, b, c, d, e, f, g, h, k) {
    a = new bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    ah(f);
    return a;
}
function dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function el(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function fl(a, b, c, d, e, f, g, h, k) {
    a = cl(c, d, !0, a, e, f, g, h, k);
    a.context = el(null);
    c = a.current;
    d = L();
    e = lh(c);
    f = ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    dh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Ek(a, d);
    return a;
}
function gl(a, b, c, d) {
    var e = b.current, f = L(), g = lh(e);
    c = el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = dh(e, b, g);
    null !== a && (mh(a, e, g, f), eh(a, e, g));
    return g;
}
function hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function jl(a, b) {
    il(a, b);
    (a = a.alternate) && il(a, b);
}
function kl() {
    return null;
}
var ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ml(a) {
    this._internalRoot = a;
}
nl.prototype.render = ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    gl(a, b, null, null);
};
nl.prototype.unmount = ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Sk(function() {
            gl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function nl(a) {
    this._internalRoot = a;
}
nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ql() {}
function rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = hl(g);
                f.call(a);
            };
        }
        var g = fl(b, d, a, 0, null, !1, !1, "", ql);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = hl(k);
            h.call(a);
        };
    }
    var k = cl(a, 0, !1, null, null, !1, !1, "", ql);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Sk(function() {
        gl(b, k, c, d);
    });
    return k;
}
function sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = hl(g);
                h.call(a);
            };
        }
        gl(b, g, a, e);
    } else g = rl(c, b, a, e, d);
    return hl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Ek(b, B()), 0 === (K & 6) && (Hj = B() + 500, jg()));
            }
            break;
        case 13:
            Sk(function() {
                var b = Zg(a, 1);
                if (null !== b) {
                    var c = L();
                    mh(b, a, 1, c);
                }
            }), jl(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Zg(a, 134217728);
        if (null !== b) {
            var c = L();
            mh(b, a, 134217728, c);
        }
        jl(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = lh(a), c = Zg(a, b);
        if (null !== c) {
            var d = L();
            mh(c, a, b, d);
        }
        jl(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Rk;
Hb = Sk;
var tl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Rk
    ]
}, ul = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var vl = {
    bundleType: ul.bundleType,
    version: ul.version,
    rendererPackageName: ul.rendererPackageName,
    rendererConfig: ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: ul.findFiberByHostInstance || kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!wl.isDisabled && wl.supportsFiber) try {
        kc = wl.inject(vl), lc = wl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ol(b)) throw Error(p(200));
    return dl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ol(a)) throw Error(p(299));
    var c = !1, d = "", e = ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = cl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ml(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Sk(a);
};
exports.hydrate = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ol(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new nl(b);
};
exports.render = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!pl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Sk(function() {
        sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Rk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!pl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return sl(a, b, c, !1, d);
};
exports.version = "18.2.0-next-9e3b772b8-20220608";

},{"5393afc8c463ef07":"cOWTg","ece50e903283a22f":"fX4RI"}],"fX4RI":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"befWH"}],"befWH":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"1ee65":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"5RYYS","@babel/runtime/helpers/esm/inheritsLoose":"9ThIf","react":"cOWTg","history":"9nqhJ","prop-types":"jc0Wl","tiny-warning":"1uO6B","@babel/runtime/helpers/esm/extends":"73iO2","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"hwWkd","tiny-invariant":"3lKy7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5RYYS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global$1, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"9ThIf","react":"cOWTg","prop-types":"jc0Wl","history":"9nqhJ","tiny-warning":"1uO6B","tiny-invariant":"3lKy7","@babel/runtime/helpers/esm/extends":"73iO2","path-to-regexp":"6SzoO","react-is":"cQX9w","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"hwWkd","hoist-non-react-statics":"bIZ8D","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9ThIf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"ck991","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ck991":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bNgzC":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"jc0Wl":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"8HtaG"}],"8HtaG":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"64cnc"}],"64cnc":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"9nqhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var PopStateEvent = "popstate";
var HashChangeEvent = "hashchange";
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = "hashchange";
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + "#" + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = stripHash(window.location.href);
        return href + "#" + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"73iO2","resolve-pathname":"9SdFG","value-equal":"00AXZ","tiny-warning":"1uO6B","tiny-invariant":"3lKy7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"73iO2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9SdFG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") spliceOne(fromParts, i);
        else if (part === "..") {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"00AXZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1uO6B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3lKy7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6SzoO":[function(require,module,exports) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === "string" ? tokens[tokens.length - 1] : "");
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return "[^" + escapeString(delimiter) + "]+?";
    return escapeString(prevText) + "|(?:(?!" + escapeString(prevText) + ")[^" + escapeString(delimiter) + "])+?";
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return attachKeys(new RegExp("^" + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"hcGUt"}],"hcGUt":[function(require,module,exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

},{}],"cQX9w":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1caXr"}],"1caXr":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"hwWkd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bIZ8D":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"cQX9w"}],"kjOQx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"7o2Zo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7o2Zo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"akCRS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>(0, _sdkJs.init));
parcelHelpers.export(exports, "Profiler", ()=>(0, _profilerJs.Profiler));
parcelHelpers.export(exports, "useProfiler", ()=>(0, _profilerJs.useProfiler));
parcelHelpers.export(exports, "withProfiler", ()=>(0, _profilerJs.withProfiler));
parcelHelpers.export(exports, "ErrorBoundary", ()=>(0, _errorboundaryJs.ErrorBoundary));
parcelHelpers.export(exports, "withErrorBoundary", ()=>(0, _errorboundaryJs.withErrorBoundary));
parcelHelpers.export(exports, "createReduxEnhancer", ()=>(0, _reduxJs.createReduxEnhancer));
parcelHelpers.export(exports, "reactRouterV3BrowserTracingIntegration", ()=>(0, _reactrouterv3Js.reactRouterV3BrowserTracingIntegration));
parcelHelpers.export(exports, "reactRouterV3Instrumentation", ()=>(0, _reactrouterv3Js.reactRouterV3Instrumentation));
parcelHelpers.export(exports, "reactRouterV4BrowserTracingIntegration", ()=>(0, _reactrouterJs.reactRouterV4BrowserTracingIntegration));
parcelHelpers.export(exports, "reactRouterV4Instrumentation", ()=>(0, _reactrouterJs.reactRouterV4Instrumentation));
parcelHelpers.export(exports, "reactRouterV5BrowserTracingIntegration", ()=>(0, _reactrouterJs.reactRouterV5BrowserTracingIntegration));
parcelHelpers.export(exports, "reactRouterV5Instrumentation", ()=>(0, _reactrouterJs.reactRouterV5Instrumentation));
parcelHelpers.export(exports, "withSentryRouting", ()=>(0, _reactrouterJs.withSentryRouting));
parcelHelpers.export(exports, "reactRouterV6BrowserTracingIntegration", ()=>(0, _reactrouterv6Js.reactRouterV6BrowserTracingIntegration));
parcelHelpers.export(exports, "reactRouterV6Instrumentation", ()=>(0, _reactrouterv6Js.reactRouterV6Instrumentation));
parcelHelpers.export(exports, "withSentryReactRouterV6Routing", ()=>(0, _reactrouterv6Js.withSentryReactRouterV6Routing));
parcelHelpers.export(exports, "wrapCreateBrowserRouter", ()=>(0, _reactrouterv6Js.wrapCreateBrowserRouter));
parcelHelpers.export(exports, "wrapUseRoutes", ()=>(0, _reactrouterv6Js.wrapUseRoutes));
var _browser = require("@sentry/browser");
parcelHelpers.exportAll(_browser, exports);
var _sdkJs = require("./sdk.js");
var _profilerJs = require("./profiler.js");
var _errorboundaryJs = require("./errorboundary.js");
var _reduxJs = require("./redux.js");
var _reactrouterv3Js = require("./reactrouterv3.js");
var _reactrouterJs = require("./reactrouter.js");
var _reactrouterv6Js = require("./reactrouterv6.js");

},{"@sentry/browser":"7DFlu","./sdk.js":"5Ccf8","./profiler.js":"gRpnr","./errorboundary.js":"4ZAzP","./redux.js":"iKT04","./reactrouterv3.js":"if1Yw","./reactrouter.js":"j7aOD","./reactrouterv6.js":"4bZtQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7DFlu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", ()=>(0, _core.FunctionToString));
parcelHelpers.export(exports, "Hub", ()=>(0, _core.Hub));
parcelHelpers.export(exports, "InboundFilters", ()=>(0, _core.InboundFilters));
parcelHelpers.export(exports, "ModuleMetadata", ()=>(0, _core.ModuleMetadata));
parcelHelpers.export(exports, "SDK_VERSION", ()=>(0, _core.SDK_VERSION));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", ()=>(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", ()=>(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", ()=>(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", ()=>(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE));
parcelHelpers.export(exports, "Scope", ()=>(0, _core.Scope));
parcelHelpers.export(exports, "addBreadcrumb", ()=>(0, _core.addBreadcrumb));
parcelHelpers.export(exports, "addEventProcessor", ()=>(0, _core.addEventProcessor));
parcelHelpers.export(exports, "addGlobalEventProcessor", ()=>(0, _core.addGlobalEventProcessor));
parcelHelpers.export(exports, "addIntegration", ()=>(0, _core.addIntegration));
parcelHelpers.export(exports, "addTracingExtensions", ()=>(0, _core.addTracingExtensions));
parcelHelpers.export(exports, "captureEvent", ()=>(0, _core.captureEvent));
parcelHelpers.export(exports, "captureException", ()=>(0, _core.captureException));
parcelHelpers.export(exports, "captureMessage", ()=>(0, _core.captureMessage));
parcelHelpers.export(exports, "captureSession", ()=>(0, _core.captureSession));
parcelHelpers.export(exports, "close", ()=>(0, _core.close));
parcelHelpers.export(exports, "configureScope", ()=>(0, _core.configureScope));
parcelHelpers.export(exports, "continueTrace", ()=>(0, _core.continueTrace));
parcelHelpers.export(exports, "createTransport", ()=>(0, _core.createTransport));
parcelHelpers.export(exports, "endSession", ()=>(0, _core.endSession));
parcelHelpers.export(exports, "extractTraceparentData", ()=>(0, _core.extractTraceparentData));
parcelHelpers.export(exports, "flush", ()=>(0, _core.flush));
parcelHelpers.export(exports, "functionToStringIntegration", ()=>(0, _core.functionToStringIntegration));
parcelHelpers.export(exports, "getActiveSpan", ()=>(0, _core.getActiveSpan));
parcelHelpers.export(exports, "getActiveTransaction", ()=>(0, _core.getActiveTransaction));
parcelHelpers.export(exports, "getClient", ()=>(0, _core.getClient));
parcelHelpers.export(exports, "getCurrentHub", ()=>(0, _core.getCurrentHub));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _core.getCurrentScope));
parcelHelpers.export(exports, "getHubFromCarrier", ()=>(0, _core.getHubFromCarrier));
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", ()=>(0, _core.getSpanStatusFromHttpCode));
parcelHelpers.export(exports, "inboundFiltersIntegration", ()=>(0, _core.inboundFiltersIntegration));
parcelHelpers.export(exports, "isInitialized", ()=>(0, _core.isInitialized));
parcelHelpers.export(exports, "lastEventId", ()=>(0, _core.lastEventId));
parcelHelpers.export(exports, "makeMain", ()=>(0, _core.makeMain));
parcelHelpers.export(exports, "makeMultiplexedTransport", ()=>(0, _core.makeMultiplexedTransport));
parcelHelpers.export(exports, "metrics", ()=>(0, _core.metrics));
parcelHelpers.export(exports, "moduleMetadataIntegration", ()=>(0, _core.moduleMetadataIntegration));
parcelHelpers.export(exports, "parameterize", ()=>(0, _core.parameterize));
parcelHelpers.export(exports, "setContext", ()=>(0, _core.setContext));
parcelHelpers.export(exports, "setCurrentClient", ()=>(0, _core.setCurrentClient));
parcelHelpers.export(exports, "setExtra", ()=>(0, _core.setExtra));
parcelHelpers.export(exports, "setExtras", ()=>(0, _core.setExtras));
parcelHelpers.export(exports, "setHttpStatus", ()=>(0, _core.setHttpStatus));
parcelHelpers.export(exports, "setMeasurement", ()=>(0, _core.setMeasurement));
parcelHelpers.export(exports, "setTag", ()=>(0, _core.setTag));
parcelHelpers.export(exports, "setTags", ()=>(0, _core.setTags));
parcelHelpers.export(exports, "setUser", ()=>(0, _core.setUser));
parcelHelpers.export(exports, "spanStatusfromHttpCode", ()=>(0, _core.spanStatusfromHttpCode));
parcelHelpers.export(exports, "startInactiveSpan", ()=>(0, _core.startInactiveSpan));
parcelHelpers.export(exports, "startSession", ()=>(0, _core.startSession));
parcelHelpers.export(exports, "startSpan", ()=>(0, _core.startSpan));
parcelHelpers.export(exports, "startSpanManual", ()=>(0, _core.startSpanManual));
parcelHelpers.export(exports, "startTransaction", ()=>(0, _core.startTransaction));
parcelHelpers.export(exports, "trace", ()=>(0, _core.trace));
parcelHelpers.export(exports, "withActiveSpan", ()=>(0, _core.withActiveSpan));
parcelHelpers.export(exports, "withIsolationScope", ()=>(0, _core.withIsolationScope));
parcelHelpers.export(exports, "withScope", ()=>(0, _core.withScope));
parcelHelpers.export(exports, "WINDOW", ()=>(0, _helpersJs.WINDOW));
parcelHelpers.export(exports, "BrowserClient", ()=>(0, _clientJs.BrowserClient));
parcelHelpers.export(exports, "makeFetchTransport", ()=>(0, _fetchJs.makeFetchTransport));
parcelHelpers.export(exports, "makeXHRTransport", ()=>(0, _xhrJs.makeXHRTransport));
parcelHelpers.export(exports, "chromeStackLineParser", ()=>(0, _stackParsersJs.chromeStackLineParser));
parcelHelpers.export(exports, "defaultStackLineParsers", ()=>(0, _stackParsersJs.defaultStackLineParsers));
parcelHelpers.export(exports, "defaultStackParser", ()=>(0, _stackParsersJs.defaultStackParser));
parcelHelpers.export(exports, "geckoStackLineParser", ()=>(0, _stackParsersJs.geckoStackLineParser));
parcelHelpers.export(exports, "opera10StackLineParser", ()=>(0, _stackParsersJs.opera10StackLineParser));
parcelHelpers.export(exports, "opera11StackLineParser", ()=>(0, _stackParsersJs.opera11StackLineParser));
parcelHelpers.export(exports, "winjsStackLineParser", ()=>(0, _stackParsersJs.winjsStackLineParser));
parcelHelpers.export(exports, "eventFromException", ()=>(0, _eventbuilderJs.eventFromException));
parcelHelpers.export(exports, "eventFromMessage", ()=>(0, _eventbuilderJs.eventFromMessage));
parcelHelpers.export(exports, "exceptionFromError", ()=>(0, _eventbuilderJs.exceptionFromError));
parcelHelpers.export(exports, "createUserFeedbackEnvelope", ()=>(0, _userfeedbackJs.createUserFeedbackEnvelope));
parcelHelpers.export(exports, "captureUserFeedback", ()=>(0, _sdkJs.captureUserFeedback));
parcelHelpers.export(exports, "defaultIntegrations", ()=>(0, _sdkJs.defaultIntegrations));
parcelHelpers.export(exports, "forceLoad", ()=>(0, _sdkJs.forceLoad));
parcelHelpers.export(exports, "getDefaultIntegrations", ()=>(0, _sdkJs.getDefaultIntegrations));
parcelHelpers.export(exports, "init", ()=>(0, _sdkJs.init));
parcelHelpers.export(exports, "onLoad", ()=>(0, _sdkJs.onLoad));
parcelHelpers.export(exports, "showReportDialog", ()=>(0, _sdkJs.showReportDialog));
parcelHelpers.export(exports, "wrap", ()=>(0, _sdkJs.wrap));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbsJs.Breadcrumbs));
parcelHelpers.export(exports, "breadcrumbsIntegration", ()=>(0, _breadcrumbsJs.breadcrumbsIntegration));
parcelHelpers.export(exports, "Dedupe", ()=>(0, _dedupeJs.Dedupe));
parcelHelpers.export(exports, "GlobalHandlers", ()=>(0, _globalhandlersJs.GlobalHandlers));
parcelHelpers.export(exports, "globalHandlersIntegration", ()=>(0, _globalhandlersJs.globalHandlersIntegration));
parcelHelpers.export(exports, "HttpContext", ()=>(0, _httpcontextJs.HttpContext));
parcelHelpers.export(exports, "httpContextIntegration", ()=>(0, _httpcontextJs.httpContextIntegration));
parcelHelpers.export(exports, "LinkedErrors", ()=>(0, _linkederrorsJs.LinkedErrors));
parcelHelpers.export(exports, "linkedErrorsIntegration", ()=>(0, _linkederrorsJs.linkedErrorsIntegration));
parcelHelpers.export(exports, "TryCatch", ()=>(0, _trycatchJs.TryCatch));
parcelHelpers.export(exports, "browserApiErrorsIntegration", ()=>(0, _trycatchJs.browserApiErrorsIntegration));
parcelHelpers.export(exports, "Replay", ()=>(0, _replay.InternalReplay));
parcelHelpers.export(exports, "getReplay", ()=>(0, _replay.internalGetReplay));
parcelHelpers.export(exports, "replayIntegration", ()=>(0, _replay.internalReplayIntegration));
parcelHelpers.export(exports, "ReplayCanvas", ()=>(0, _replayCanvas.ReplayCanvas));
parcelHelpers.export(exports, "replayCanvasIntegration", ()=>(0, _replayCanvas.replayCanvasIntegration));
parcelHelpers.export(exports, "Feedback", ()=>(0, _feedback.Feedback));
parcelHelpers.export(exports, "feedbackIntegration", ()=>(0, _feedback.feedbackIntegration));
parcelHelpers.export(exports, "sendFeedback", ()=>(0, _feedback.sendFeedback));
parcelHelpers.export(exports, "captureConsoleIntegration", ()=>(0, _integrations.captureConsoleIntegration));
parcelHelpers.export(exports, "contextLinesIntegration", ()=>(0, _integrations.contextLinesIntegration));
parcelHelpers.export(exports, "debugIntegration", ()=>(0, _integrations.debugIntegration));
parcelHelpers.export(exports, "dedupeIntegration", ()=>(0, _integrations.dedupeIntegration));
parcelHelpers.export(exports, "extraErrorDataIntegration", ()=>(0, _integrations.extraErrorDataIntegration));
parcelHelpers.export(exports, "httpClientIntegration", ()=>(0, _integrations.httpClientIntegration));
parcelHelpers.export(exports, "reportingObserverIntegration", ()=>(0, _integrations.reportingObserverIntegration));
parcelHelpers.export(exports, "rewriteFramesIntegration", ()=>(0, _integrations.rewriteFramesIntegration));
parcelHelpers.export(exports, "sessionTimingIntegration", ()=>(0, _integrations.sessionTimingIntegration));
parcelHelpers.export(exports, "BrowserTracing", ()=>(0, _tracing.BrowserTracing));
parcelHelpers.export(exports, "browserTracingIntegration", ()=>(0, _tracing.browserTracingIntegration));
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", ()=>(0, _tracing.defaultRequestInstrumentationOptions));
parcelHelpers.export(exports, "instrumentOutgoingRequests", ()=>(0, _tracing.instrumentOutgoingRequests));
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", ()=>(0, _tracing.startBrowserTracingNavigationSpan));
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", ()=>(0, _tracing.startBrowserTracingPageLoadSpan));
parcelHelpers.export(exports, "makeBrowserOfflineTransport", ()=>(0, _offlineJs.makeBrowserOfflineTransport));
parcelHelpers.export(exports, "onProfilingStartRouteTransaction", ()=>(0, _hubextensionsJs.onProfilingStartRouteTransaction));
parcelHelpers.export(exports, "BrowserProfilingIntegration", ()=>(0, _integrationJs.BrowserProfilingIntegration));
parcelHelpers.export(exports, "browserProfilingIntegration", ()=>(0, _integrationJs.browserProfilingIntegration));
parcelHelpers.export(exports, "Integrations", ()=>INTEGRATIONS);
var _core = require("@sentry/core");
var _helpersJs = require("./helpers.js");
var _clientJs = require("./client.js");
var _fetchJs = require("./transports/fetch.js");
var _xhrJs = require("./transports/xhr.js");
var _stackParsersJs = require("./stack-parsers.js");
var _eventbuilderJs = require("./eventbuilder.js");
var _userfeedbackJs = require("./userfeedback.js");
var _sdkJs = require("./sdk.js");
var _breadcrumbsJs = require("./integrations/breadcrumbs.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _globalhandlersJs = require("./integrations/globalhandlers.js");
var _httpcontextJs = require("./integrations/httpcontext.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _trycatchJs = require("./integrations/trycatch.js");
var _indexJs = require("./integrations/index.js");
var _replay = require("@sentry/replay");
var _replayCanvas = require("@sentry-internal/replay-canvas");
var _feedback = require("@sentry-internal/feedback");
var _integrations = require("@sentry/integrations");
var _tracing = require("@sentry-internal/tracing");
var _offlineJs = require("./transports/offline.js");
var _hubextensionsJs = require("./profiling/hubextensions.js");
var _integrationJs = require("./profiling/integration.js");
let windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, _helpersJs.WINDOW).Sentry && (0, _helpersJs.WINDOW).Sentry.Integrations) windowIntegrations = (0, _helpersJs.WINDOW).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const INTEGRATIONS = {
    ...windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, _core.Integrations),
    ..._indexJs
};

},{"@sentry/core":"3UnXU","./helpers.js":"2KfuB","./client.js":"frCMF","./transports/fetch.js":"arrPs","./transports/xhr.js":"dX3I8","./stack-parsers.js":"gAGHp","./eventbuilder.js":"jEksv","./userfeedback.js":"iiLle","./sdk.js":"BPFBM","./integrations/breadcrumbs.js":"6G3dh","./integrations/dedupe.js":"jgxJx","./integrations/globalhandlers.js":"eP5eB","./integrations/httpcontext.js":"lPmmT","./integrations/linkederrors.js":"2EBDN","./integrations/trycatch.js":"6Ym6g","./integrations/index.js":"5TVwd","@sentry/replay":"alMdd","@sentry-internal/replay-canvas":"jwrAU","@sentry-internal/feedback":"iFDZX","@sentry/integrations":"YWzCw","@sentry-internal/tracing":"5gs22","./transports/offline.js":"1WFrj","./profiling/hubextensions.js":"2zbwO","./profiling/integration.js":"bQAVq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3UnXU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTracingExtensions", ()=>(0, _hubextensionsJs.addTracingExtensions));
parcelHelpers.export(exports, "startIdleTransaction", ()=>(0, _hubextensionsJs.startIdleTransaction));
parcelHelpers.export(exports, "IdleTransaction", ()=>(0, _idletransactionJs.IdleTransaction));
parcelHelpers.export(exports, "TRACING_DEFAULTS", ()=>(0, _idletransactionJs.TRACING_DEFAULTS));
parcelHelpers.export(exports, "Span", ()=>(0, _spanJs.Span));
parcelHelpers.export(exports, "Transaction", ()=>(0, _transactionJs.Transaction));
parcelHelpers.export(exports, "extractTraceparentData", ()=>(0, _utilsJs.extractTraceparentData));
parcelHelpers.export(exports, "getActiveTransaction", ()=>(0, _utilsJs.getActiveTransaction));
parcelHelpers.export(exports, "SpanStatus", ()=>(0, _spanstatusJs.SpanStatus));
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", ()=>(0, _spanstatusJs.getSpanStatusFromHttpCode));
parcelHelpers.export(exports, "setHttpStatus", ()=>(0, _spanstatusJs.setHttpStatus));
parcelHelpers.export(exports, "spanStatusfromHttpCode", ()=>(0, _spanstatusJs.spanStatusfromHttpCode));
parcelHelpers.export(exports, "continueTrace", ()=>(0, _traceJs.continueTrace));
parcelHelpers.export(exports, "getActiveSpan", ()=>(0, _traceJs.getActiveSpan));
parcelHelpers.export(exports, "startActiveSpan", ()=>(0, _traceJs.startActiveSpan));
parcelHelpers.export(exports, "startInactiveSpan", ()=>(0, _traceJs.startInactiveSpan));
parcelHelpers.export(exports, "startSpan", ()=>(0, _traceJs.startSpan));
parcelHelpers.export(exports, "startSpanManual", ()=>(0, _traceJs.startSpanManual));
parcelHelpers.export(exports, "trace", ()=>(0, _traceJs.trace));
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", ()=>(0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient));
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", ()=>(0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan));
parcelHelpers.export(exports, "setMeasurement", ()=>(0, _measurementJs.setMeasurement));
parcelHelpers.export(exports, "isValidSampleRate", ()=>(0, _samplingJs.isValidSampleRate));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE));
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", ()=>(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE));
parcelHelpers.export(exports, "createEventEnvelope", ()=>(0, _envelopeJs.createEventEnvelope));
parcelHelpers.export(exports, "createSessionEnvelope", ()=>(0, _envelopeJs.createSessionEnvelope));
parcelHelpers.export(exports, "addBreadcrumb", ()=>(0, _exportsJs.addBreadcrumb));
parcelHelpers.export(exports, "captureCheckIn", ()=>(0, _exportsJs.captureCheckIn));
parcelHelpers.export(exports, "captureEvent", ()=>(0, _exportsJs.captureEvent));
parcelHelpers.export(exports, "captureException", ()=>(0, _exportsJs.captureException));
parcelHelpers.export(exports, "captureMessage", ()=>(0, _exportsJs.captureMessage));
parcelHelpers.export(exports, "captureSession", ()=>(0, _exportsJs.captureSession));
parcelHelpers.export(exports, "close", ()=>(0, _exportsJs.close));
parcelHelpers.export(exports, "configureScope", ()=>(0, _exportsJs.configureScope));
parcelHelpers.export(exports, "endSession", ()=>(0, _exportsJs.endSession));
parcelHelpers.export(exports, "flush", ()=>(0, _exportsJs.flush));
parcelHelpers.export(exports, "getClient", ()=>(0, _exportsJs.getClient));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _exportsJs.getCurrentScope));
parcelHelpers.export(exports, "isInitialized", ()=>(0, _exportsJs.isInitialized));
parcelHelpers.export(exports, "lastEventId", ()=>(0, _exportsJs.lastEventId));
parcelHelpers.export(exports, "setContext", ()=>(0, _exportsJs.setContext));
parcelHelpers.export(exports, "setExtra", ()=>(0, _exportsJs.setExtra));
parcelHelpers.export(exports, "setExtras", ()=>(0, _exportsJs.setExtras));
parcelHelpers.export(exports, "setTag", ()=>(0, _exportsJs.setTag));
parcelHelpers.export(exports, "setTags", ()=>(0, _exportsJs.setTags));
parcelHelpers.export(exports, "setUser", ()=>(0, _exportsJs.setUser));
parcelHelpers.export(exports, "startSession", ()=>(0, _exportsJs.startSession));
parcelHelpers.export(exports, "startTransaction", ()=>(0, _exportsJs.startTransaction));
parcelHelpers.export(exports, "withActiveSpan", ()=>(0, _exportsJs.withActiveSpan));
parcelHelpers.export(exports, "withIsolationScope", ()=>(0, _exportsJs.withIsolationScope));
parcelHelpers.export(exports, "withMonitor", ()=>(0, _exportsJs.withMonitor));
parcelHelpers.export(exports, "withScope", ()=>(0, _exportsJs.withScope));
parcelHelpers.export(exports, "Hub", ()=>(0, _hubJs.Hub));
parcelHelpers.export(exports, "ensureHubOnCarrier", ()=>(0, _hubJs.ensureHubOnCarrier));
parcelHelpers.export(exports, "getCurrentHub", ()=>(0, _hubJs.getCurrentHub));
parcelHelpers.export(exports, "getHubFromCarrier", ()=>(0, _hubJs.getHubFromCarrier));
parcelHelpers.export(exports, "getIsolationScope", ()=>(0, _hubJs.getIsolationScope));
parcelHelpers.export(exports, "getMainCarrier", ()=>(0, _hubJs.getMainCarrier));
parcelHelpers.export(exports, "makeMain", ()=>(0, _hubJs.makeMain));
parcelHelpers.export(exports, "runWithAsyncContext", ()=>(0, _hubJs.runWithAsyncContext));
parcelHelpers.export(exports, "setAsyncContextStrategy", ()=>(0, _hubJs.setAsyncContextStrategy));
parcelHelpers.export(exports, "setHubOnCarrier", ()=>(0, _hubJs.setHubOnCarrier));
parcelHelpers.export(exports, "closeSession", ()=>(0, _sessionJs.closeSession));
parcelHelpers.export(exports, "makeSession", ()=>(0, _sessionJs.makeSession));
parcelHelpers.export(exports, "updateSession", ()=>(0, _sessionJs.updateSession));
parcelHelpers.export(exports, "SessionFlusher", ()=>(0, _sessionflusherJs.SessionFlusher));
parcelHelpers.export(exports, "Scope", ()=>(0, _scopeJs.Scope));
parcelHelpers.export(exports, "getGlobalScope", ()=>(0, _scopeJs.getGlobalScope));
parcelHelpers.export(exports, "setGlobalScope", ()=>(0, _scopeJs.setGlobalScope));
parcelHelpers.export(exports, "addGlobalEventProcessor", ()=>(0, _eventProcessorsJs.addGlobalEventProcessor));
parcelHelpers.export(exports, "notifyEventProcessors", ()=>(0, _eventProcessorsJs.notifyEventProcessors));
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>(0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth));
parcelHelpers.export(exports, "getReportDialogEndpoint", ()=>(0, _apiJs.getReportDialogEndpoint));
parcelHelpers.export(exports, "BaseClient", ()=>(0, _baseclientJs.BaseClient));
parcelHelpers.export(exports, "addEventProcessor", ()=>(0, _baseclientJs.addEventProcessor));
parcelHelpers.export(exports, "ServerRuntimeClient", ()=>(0, _serverRuntimeClientJs.ServerRuntimeClient));
parcelHelpers.export(exports, "initAndBind", ()=>(0, _sdkJs.initAndBind));
parcelHelpers.export(exports, "setCurrentClient", ()=>(0, _sdkJs.setCurrentClient));
parcelHelpers.export(exports, "createTransport", ()=>(0, _baseJs.createTransport));
parcelHelpers.export(exports, "makeOfflineTransport", ()=>(0, _offlineJs.makeOfflineTransport));
parcelHelpers.export(exports, "makeMultiplexedTransport", ()=>(0, _multiplexedJs.makeMultiplexedTransport));
parcelHelpers.export(exports, "SDK_VERSION", ()=>(0, _versionJs.SDK_VERSION));
parcelHelpers.export(exports, "addIntegration", ()=>(0, _integrationJs.addIntegration));
parcelHelpers.export(exports, "convertIntegrationFnToClass", ()=>(0, _integrationJs.convertIntegrationFnToClass));
parcelHelpers.export(exports, "defineIntegration", ()=>(0, _integrationJs.defineIntegration));
parcelHelpers.export(exports, "getIntegrationsToSetup", ()=>(0, _integrationJs.getIntegrationsToSetup));
parcelHelpers.export(exports, "applyScopeDataToEvent", ()=>(0, _applyScopeDataToEventJs.applyScopeDataToEvent));
parcelHelpers.export(exports, "mergeScopeData", ()=>(0, _applyScopeDataToEventJs.mergeScopeData));
parcelHelpers.export(exports, "prepareEvent", ()=>(0, _prepareEventJs.prepareEvent));
parcelHelpers.export(exports, "createCheckInEnvelope", ()=>(0, _checkinJs.createCheckInEnvelope));
parcelHelpers.export(exports, "createSpanEnvelope", ()=>(0, _spanJs1.createSpanEnvelope));
parcelHelpers.export(exports, "hasTracingEnabled", ()=>(0, _hasTracingEnabledJs.hasTracingEnabled));
parcelHelpers.export(exports, "isSentryRequestUrl", ()=>(0, _isSentryRequestUrlJs.isSentryRequestUrl));
parcelHelpers.export(exports, "handleCallbackErrors", ()=>(0, _handleCallbackErrorsJs.handleCallbackErrors));
parcelHelpers.export(exports, "parameterize", ()=>(0, _parameterizeJs.parameterize));
parcelHelpers.export(exports, "spanIsSampled", ()=>(0, _spanUtilsJs.spanIsSampled));
parcelHelpers.export(exports, "spanToJSON", ()=>(0, _spanUtilsJs.spanToJSON));
parcelHelpers.export(exports, "spanToTraceContext", ()=>(0, _spanUtilsJs.spanToTraceContext));
parcelHelpers.export(exports, "spanToTraceHeader", ()=>(0, _spanUtilsJs.spanToTraceHeader));
parcelHelpers.export(exports, "getRootSpan", ()=>(0, _getRootSpanJs.getRootSpan));
parcelHelpers.export(exports, "applySdkMetadata", ()=>(0, _sdkMetadataJs.applySdkMetadata));
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", ()=>(0, _constantsJs.DEFAULT_ENVIRONMENT));
parcelHelpers.export(exports, "ModuleMetadata", ()=>(0, _metadataJs.ModuleMetadata));
parcelHelpers.export(exports, "moduleMetadataIntegration", ()=>(0, _metadataJs.moduleMetadataIntegration));
parcelHelpers.export(exports, "RequestData", ()=>(0, _requestdataJs.RequestData));
parcelHelpers.export(exports, "requestDataIntegration", ()=>(0, _requestdataJs.requestDataIntegration));
parcelHelpers.export(exports, "InboundFilters", ()=>(0, _inboundfiltersJs.InboundFilters));
parcelHelpers.export(exports, "inboundFiltersIntegration", ()=>(0, _inboundfiltersJs.inboundFiltersIntegration));
parcelHelpers.export(exports, "FunctionToString", ()=>(0, _functiontostringJs.FunctionToString));
parcelHelpers.export(exports, "functionToStringIntegration", ()=>(0, _functiontostringJs.functionToStringIntegration));
parcelHelpers.export(exports, "LinkedErrors", ()=>(0, _linkederrorsJs.LinkedErrors));
parcelHelpers.export(exports, "linkedErrorsIntegration", ()=>(0, _linkederrorsJs.linkedErrorsIntegration));
parcelHelpers.export(exports, "metrics", ()=>(0, _exportsJs1.metrics));
parcelHelpers.export(exports, "Integrations", ()=>Integrations);
var _hubextensionsJs = require("./tracing/hubextensions.js");
var _idletransactionJs = require("./tracing/idletransaction.js");
var _spanJs = require("./tracing/span.js");
var _transactionJs = require("./tracing/transaction.js");
var _utilsJs = require("./tracing/utils.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _traceJs = require("./tracing/trace.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _measurementJs = require("./tracing/measurement.js");
var _samplingJs = require("./tracing/sampling.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
var _sessionJs = require("./session.js");
var _sessionflusherJs = require("./sessionflusher.js");
var _scopeJs = require("./scope.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _apiJs = require("./api.js");
var _baseclientJs = require("./baseclient.js");
var _serverRuntimeClientJs = require("./server-runtime-client.js");
var _sdkJs = require("./sdk.js");
var _baseJs = require("./transports/base.js");
var _offlineJs = require("./transports/offline.js");
var _multiplexedJs = require("./transports/multiplexed.js");
var _versionJs = require("./version.js");
var _integrationJs = require("./integration.js");
var _applyScopeDataToEventJs = require("./utils/applyScopeDataToEvent.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _checkinJs = require("./checkin.js");
var _spanJs1 = require("./span.js");
var _hasTracingEnabledJs = require("./utils/hasTracingEnabled.js");
var _isSentryRequestUrlJs = require("./utils/isSentryRequestUrl.js");
var _handleCallbackErrorsJs = require("./utils/handleCallbackErrors.js");
var _parameterizeJs = require("./utils/parameterize.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _getRootSpanJs = require("./utils/getRootSpan.js");
var _sdkMetadataJs = require("./utils/sdkMetadata.js");
var _constantsJs = require("./constants.js");
var _metadataJs = require("./integrations/metadata.js");
var _requestdataJs = require("./integrations/requestdata.js");
var _inboundfiltersJs = require("./integrations/inboundfilters.js");
var _functiontostringJs = require("./integrations/functiontostring.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _indexJs = require("./integrations/index.js");
var _exportsJs1 = require("./metrics/exports.js");
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const Integrations = _indexJs;

},{"./tracing/hubextensions.js":"erreh","./tracing/idletransaction.js":"fiVf5","./tracing/span.js":"iZ89M","./tracing/transaction.js":"dRdd1","./tracing/utils.js":"eQe4H","./tracing/spanstatus.js":"cpbRr","./tracing/trace.js":"kHZwE","./tracing/dynamicSamplingContext.js":"czMfo","./tracing/measurement.js":"ljNB0","./tracing/sampling.js":"U72ua","./semanticAttributes.js":"fh7tL","./envelope.js":"kpLGj","./exports.js":"bQ1GW","./hub.js":"d9xVP","./session.js":"019j9","./sessionflusher.js":"4tJhc","./scope.js":"38Vhk","./eventProcessors.js":"aLe4Y","./api.js":"wYtlM","./baseclient.js":"8Zre8","./server-runtime-client.js":"lR4Al","./sdk.js":"A9twl","./transports/base.js":"eBo3y","./transports/offline.js":"kNJDm","./transports/multiplexed.js":"gnY7b","./version.js":"aWeoJ","./integration.js":"d8HWn","./utils/applyScopeDataToEvent.js":"91PZM","./utils/prepareEvent.js":"5y48Y","./checkin.js":"1xKwa","./span.js":"9kPSz","./utils/hasTracingEnabled.js":"kbYmo","./utils/isSentryRequestUrl.js":"avSaB","./utils/handleCallbackErrors.js":"2v1xV","./utils/parameterize.js":"dVtlQ","./utils/spanUtils.js":"jLzrc","./utils/getRootSpan.js":"6BdAG","./utils/sdkMetadata.js":"dbSgw","./constants.js":"2PUCq","./integrations/metadata.js":"d2Dlh","./integrations/requestdata.js":"bgvc0","./integrations/inboundfilters.js":"7fRSe","./integrations/functiontostring.js":"7yDbJ","./integrations/linkederrors.js":"ikMss","./integrations/index.js":"1FQb2","./metrics/exports.js":"b3Kwg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"erreh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTracingExtensions", ()=>addTracingExtensions);
parcelHelpers.export(exports, "startIdleTransaction", ()=>startIdleTransaction);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubJs = require("../hub.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _errorsJs = require("./errors.js");
var _idletransactionJs = require("./idletransaction.js");
var _samplingJs = require("./sampling.js");
var _transactionJs = require("./transaction.js");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, _spanUtilsJs.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, _transactionJs.Transaction)(transactionContext, this);
    transaction = (0, _samplingJs.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function startIdleTransaction(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, _idletransactionJs.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, _samplingJs.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function addTracingExtensions() {
    const carrier = (0, _hubJs.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    (0, _errorsJs.registerErrorInstrumentation)();
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../hub.js":"d9xVP","../utils/spanUtils.js":"jLzrc","./errors.js":"lei5h","./idletransaction.js":"fiVf5","./sampling.js":"U72ua","./transaction.js":"dRdd1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5XfgR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", ()=>(0, _aggregateErrorsJs.applyAggregateErrorsToEvent));
parcelHelpers.export(exports, "getComponentName", ()=>(0, _browserJs.getComponentName));
parcelHelpers.export(exports, "getDomElement", ()=>(0, _browserJs.getDomElement));
parcelHelpers.export(exports, "getLocationHref", ()=>(0, _browserJs.getLocationHref));
parcelHelpers.export(exports, "htmlTreeAsString", ()=>(0, _browserJs.htmlTreeAsString));
parcelHelpers.export(exports, "dsnFromString", ()=>(0, _dsnJs.dsnFromString));
parcelHelpers.export(exports, "dsnToString", ()=>(0, _dsnJs.dsnToString));
parcelHelpers.export(exports, "makeDsn", ()=>(0, _dsnJs.makeDsn));
parcelHelpers.export(exports, "SentryError", ()=>(0, _errorJs.SentryError));
parcelHelpers.export(exports, "GLOBAL_OBJ", ()=>(0, _worldwideJs.GLOBAL_OBJ));
parcelHelpers.export(exports, "getGlobalObject", ()=>(0, _worldwideJs.getGlobalObject));
parcelHelpers.export(exports, "getGlobalSingleton", ()=>(0, _worldwideJs.getGlobalSingleton));
parcelHelpers.export(exports, "addInstrumentationHandler", ()=>(0, _indexJs.addInstrumentationHandler));
parcelHelpers.export(exports, "isDOMError", ()=>(0, _isJs.isDOMError));
parcelHelpers.export(exports, "isDOMException", ()=>(0, _isJs.isDOMException));
parcelHelpers.export(exports, "isElement", ()=>(0, _isJs.isElement));
parcelHelpers.export(exports, "isError", ()=>(0, _isJs.isError));
parcelHelpers.export(exports, "isErrorEvent", ()=>(0, _isJs.isErrorEvent));
parcelHelpers.export(exports, "isEvent", ()=>(0, _isJs.isEvent));
parcelHelpers.export(exports, "isInstanceOf", ()=>(0, _isJs.isInstanceOf));
parcelHelpers.export(exports, "isNaN", ()=>(0, _isJs.isNaN));
parcelHelpers.export(exports, "isParameterizedString", ()=>(0, _isJs.isParameterizedString));
parcelHelpers.export(exports, "isPlainObject", ()=>(0, _isJs.isPlainObject));
parcelHelpers.export(exports, "isPrimitive", ()=>(0, _isJs.isPrimitive));
parcelHelpers.export(exports, "isRegExp", ()=>(0, _isJs.isRegExp));
parcelHelpers.export(exports, "isString", ()=>(0, _isJs.isString));
parcelHelpers.export(exports, "isSyntheticEvent", ()=>(0, _isJs.isSyntheticEvent));
parcelHelpers.export(exports, "isThenable", ()=>(0, _isJs.isThenable));
parcelHelpers.export(exports, "isVueViewModel", ()=>(0, _isJs.isVueViewModel));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _isBrowserJs.isBrowser));
parcelHelpers.export(exports, "CONSOLE_LEVELS", ()=>(0, _loggerJs.CONSOLE_LEVELS));
parcelHelpers.export(exports, "consoleSandbox", ()=>(0, _loggerJs.consoleSandbox));
parcelHelpers.export(exports, "logger", ()=>(0, _loggerJs.logger));
parcelHelpers.export(exports, "originalConsoleMethods", ()=>(0, _loggerJs.originalConsoleMethods));
parcelHelpers.export(exports, "memoBuilder", ()=>(0, _memoJs.memoBuilder));
parcelHelpers.export(exports, "addContextToFrame", ()=>(0, _miscJs.addContextToFrame));
parcelHelpers.export(exports, "addExceptionMechanism", ()=>(0, _miscJs.addExceptionMechanism));
parcelHelpers.export(exports, "addExceptionTypeValue", ()=>(0, _miscJs.addExceptionTypeValue));
parcelHelpers.export(exports, "arrayify", ()=>(0, _miscJs.arrayify));
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", ()=>(0, _miscJs.checkOrSetAlreadyCaught));
parcelHelpers.export(exports, "getEventDescription", ()=>(0, _miscJs.getEventDescription));
parcelHelpers.export(exports, "parseSemver", ()=>(0, _miscJs.parseSemver));
parcelHelpers.export(exports, "uuid4", ()=>(0, _miscJs.uuid4));
parcelHelpers.export(exports, "dynamicRequire", ()=>(0, _nodeJs.dynamicRequire));
parcelHelpers.export(exports, "isNodeEnv", ()=>(0, _nodeJs.isNodeEnv));
parcelHelpers.export(exports, "loadModule", ()=>(0, _nodeJs.loadModule));
parcelHelpers.export(exports, "normalize", ()=>(0, _normalizeJs.normalize));
parcelHelpers.export(exports, "normalizeToSize", ()=>(0, _normalizeJs.normalizeToSize));
parcelHelpers.export(exports, "normalizeUrlToBase", ()=>(0, _normalizeJs.normalizeUrlToBase));
parcelHelpers.export(exports, "walk", ()=>(0, _normalizeJs.walk));
parcelHelpers.export(exports, "addNonEnumerableProperty", ()=>(0, _objectJs.addNonEnumerableProperty));
parcelHelpers.export(exports, "convertToPlainObject", ()=>(0, _objectJs.convertToPlainObject));
parcelHelpers.export(exports, "dropUndefinedKeys", ()=>(0, _objectJs.dropUndefinedKeys));
parcelHelpers.export(exports, "extractExceptionKeysForMessage", ()=>(0, _objectJs.extractExceptionKeysForMessage));
parcelHelpers.export(exports, "fill", ()=>(0, _objectJs.fill));
parcelHelpers.export(exports, "getOriginalFunction", ()=>(0, _objectJs.getOriginalFunction));
parcelHelpers.export(exports, "markFunctionWrapped", ()=>(0, _objectJs.markFunctionWrapped));
parcelHelpers.export(exports, "objectify", ()=>(0, _objectJs.objectify));
parcelHelpers.export(exports, "urlEncode", ()=>(0, _objectJs.urlEncode));
parcelHelpers.export(exports, "basename", ()=>(0, _pathJs.basename));
parcelHelpers.export(exports, "dirname", ()=>(0, _pathJs.dirname));
parcelHelpers.export(exports, "isAbsolute", ()=>(0, _pathJs.isAbsolute));
parcelHelpers.export(exports, "join", ()=>(0, _pathJs.join));
parcelHelpers.export(exports, "normalizePath", ()=>(0, _pathJs.normalizePath));
parcelHelpers.export(exports, "relative", ()=>(0, _pathJs.relative));
parcelHelpers.export(exports, "resolve", ()=>(0, _pathJs.resolve));
parcelHelpers.export(exports, "makePromiseBuffer", ()=>(0, _promisebufferJs.makePromiseBuffer));
parcelHelpers.export(exports, "DEFAULT_USER_INCLUDES", ()=>(0, _requestdataJs.DEFAULT_USER_INCLUDES));
parcelHelpers.export(exports, "addRequestDataToEvent", ()=>(0, _requestdataJs.addRequestDataToEvent));
parcelHelpers.export(exports, "addRequestDataToTransaction", ()=>(0, _requestdataJs.addRequestDataToTransaction));
parcelHelpers.export(exports, "extractPathForTransaction", ()=>(0, _requestdataJs.extractPathForTransaction));
parcelHelpers.export(exports, "extractRequestData", ()=>(0, _requestdataJs.extractRequestData));
parcelHelpers.export(exports, "winterCGHeadersToDict", ()=>(0, _requestdataJs.winterCGHeadersToDict));
parcelHelpers.export(exports, "winterCGRequestToRequestData", ()=>(0, _requestdataJs.winterCGRequestToRequestData));
parcelHelpers.export(exports, "severityFromString", ()=>(0, _severityJs.severityFromString));
parcelHelpers.export(exports, "severityLevelFromString", ()=>(0, _severityJs.severityLevelFromString));
parcelHelpers.export(exports, "validSeverityLevels", ()=>(0, _severityJs.validSeverityLevels));
parcelHelpers.export(exports, "createStackParser", ()=>(0, _stacktraceJs.createStackParser));
parcelHelpers.export(exports, "getFunctionName", ()=>(0, _stacktraceJs.getFunctionName));
parcelHelpers.export(exports, "nodeStackLineParser", ()=>(0, _stacktraceJs.nodeStackLineParser));
parcelHelpers.export(exports, "stackParserFromStackParserOptions", ()=>(0, _stacktraceJs.stackParserFromStackParserOptions));
parcelHelpers.export(exports, "stripSentryFramesAndReverse", ()=>(0, _stacktraceJs.stripSentryFramesAndReverse));
parcelHelpers.export(exports, "isMatchingPattern", ()=>(0, _stringJs.isMatchingPattern));
parcelHelpers.export(exports, "safeJoin", ()=>(0, _stringJs.safeJoin));
parcelHelpers.export(exports, "snipLine", ()=>(0, _stringJs.snipLine));
parcelHelpers.export(exports, "stringMatchesSomePattern", ()=>(0, _stringJs.stringMatchesSomePattern));
parcelHelpers.export(exports, "truncate", ()=>(0, _stringJs.truncate));
parcelHelpers.export(exports, "isNativeFetch", ()=>(0, _supportsJs.isNativeFetch));
parcelHelpers.export(exports, "supportsDOMError", ()=>(0, _supportsJs.supportsDOMError));
parcelHelpers.export(exports, "supportsDOMException", ()=>(0, _supportsJs.supportsDOMException));
parcelHelpers.export(exports, "supportsErrorEvent", ()=>(0, _supportsJs.supportsErrorEvent));
parcelHelpers.export(exports, "supportsFetch", ()=>(0, _supportsJs.supportsFetch));
parcelHelpers.export(exports, "supportsNativeFetch", ()=>(0, _supportsJs.supportsNativeFetch));
parcelHelpers.export(exports, "supportsReferrerPolicy", ()=>(0, _supportsJs.supportsReferrerPolicy));
parcelHelpers.export(exports, "supportsReportingObserver", ()=>(0, _supportsJs.supportsReportingObserver));
parcelHelpers.export(exports, "SyncPromise", ()=>(0, _syncpromiseJs.SyncPromise));
parcelHelpers.export(exports, "rejectedSyncPromise", ()=>(0, _syncpromiseJs.rejectedSyncPromise));
parcelHelpers.export(exports, "resolvedSyncPromise", ()=>(0, _syncpromiseJs.resolvedSyncPromise));
parcelHelpers.export(exports, "_browserPerformanceTimeOriginMode", ()=>(0, _timeJs._browserPerformanceTimeOriginMode));
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", ()=>(0, _timeJs.browserPerformanceTimeOrigin));
parcelHelpers.export(exports, "dateTimestampInSeconds", ()=>(0, _timeJs.dateTimestampInSeconds));
parcelHelpers.export(exports, "timestampInSeconds", ()=>(0, _timeJs.timestampInSeconds));
parcelHelpers.export(exports, "timestampWithMs", ()=>(0, _timeJs.timestampWithMs));
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", ()=>(0, _tracingJs.TRACEPARENT_REGEXP));
parcelHelpers.export(exports, "extractTraceparentData", ()=>(0, _tracingJs.extractTraceparentData));
parcelHelpers.export(exports, "generateSentryTraceHeader", ()=>(0, _tracingJs.generateSentryTraceHeader));
parcelHelpers.export(exports, "propagationContextFromHeaders", ()=>(0, _tracingJs.propagationContextFromHeaders));
parcelHelpers.export(exports, "tracingContextFromHeaders", ()=>(0, _tracingJs.tracingContextFromHeaders));
parcelHelpers.export(exports, "getSDKSource", ()=>(0, _envJs.getSDKSource));
parcelHelpers.export(exports, "isBrowserBundle", ()=>(0, _envJs.isBrowserBundle));
parcelHelpers.export(exports, "addItemToEnvelope", ()=>(0, _envelopeJs.addItemToEnvelope));
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", ()=>(0, _envelopeJs.createAttachmentEnvelopeItem));
parcelHelpers.export(exports, "createEnvelope", ()=>(0, _envelopeJs.createEnvelope));
parcelHelpers.export(exports, "createEventEnvelopeHeaders", ()=>(0, _envelopeJs.createEventEnvelopeHeaders));
parcelHelpers.export(exports, "envelopeContainsItemType", ()=>(0, _envelopeJs.envelopeContainsItemType));
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", ()=>(0, _envelopeJs.envelopeItemTypeToDataCategory));
parcelHelpers.export(exports, "forEachEnvelopeItem", ()=>(0, _envelopeJs.forEachEnvelopeItem));
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", ()=>(0, _envelopeJs.getSdkMetadataForEnvelopeHeader));
parcelHelpers.export(exports, "parseEnvelope", ()=>(0, _envelopeJs.parseEnvelope));
parcelHelpers.export(exports, "serializeEnvelope", ()=>(0, _envelopeJs.serializeEnvelope));
parcelHelpers.export(exports, "createClientReportEnvelope", ()=>(0, _clientreportJs.createClientReportEnvelope));
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", ()=>(0, _ratelimitJs.DEFAULT_RETRY_AFTER));
parcelHelpers.export(exports, "disabledUntil", ()=>(0, _ratelimitJs.disabledUntil));
parcelHelpers.export(exports, "isRateLimited", ()=>(0, _ratelimitJs.isRateLimited));
parcelHelpers.export(exports, "parseRetryAfterHeader", ()=>(0, _ratelimitJs.parseRetryAfterHeader));
parcelHelpers.export(exports, "updateRateLimits", ()=>(0, _ratelimitJs.updateRateLimits));
parcelHelpers.export(exports, "BAGGAGE_HEADER_NAME", ()=>(0, _baggageJs.BAGGAGE_HEADER_NAME));
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", ()=>(0, _baggageJs.MAX_BAGGAGE_STRING_LENGTH));
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", ()=>(0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX));
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", ()=>(0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX_REGEX));
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", ()=>(0, _baggageJs.baggageHeaderToDynamicSamplingContext));
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", ()=>(0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader));
parcelHelpers.export(exports, "getNumberOfUrlSegments", ()=>(0, _urlJs.getNumberOfUrlSegments));
parcelHelpers.export(exports, "getSanitizedUrlString", ()=>(0, _urlJs.getSanitizedUrlString));
parcelHelpers.export(exports, "parseUrl", ()=>(0, _urlJs.parseUrl));
parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>(0, _urlJs.stripUrlQueryAndFragment));
parcelHelpers.export(exports, "addOrUpdateIntegration", ()=>(0, _userIntegrationsJs.addOrUpdateIntegration));
parcelHelpers.export(exports, "makeFifoCache", ()=>(0, _cacheJs.makeFifoCache));
parcelHelpers.export(exports, "eventFromMessage", ()=>(0, _eventbuilderJs.eventFromMessage));
parcelHelpers.export(exports, "eventFromUnknownInput", ()=>(0, _eventbuilderJs.eventFromUnknownInput));
parcelHelpers.export(exports, "exceptionFromError", ()=>(0, _eventbuilderJs.exceptionFromError));
parcelHelpers.export(exports, "parseStackFrames", ()=>(0, _eventbuilderJs.parseStackFrames));
parcelHelpers.export(exports, "callFrameToStackFrame", ()=>(0, _anrJs.callFrameToStackFrame));
parcelHelpers.export(exports, "watchdogTimer", ()=>(0, _anrJs.watchdogTimer));
parcelHelpers.export(exports, "LRUMap", ()=>(0, _lruJs.LRUMap));
parcelHelpers.export(exports, "_asyncNullishCoalesce", ()=>(0, _asyncNullishCoalesceJs._asyncNullishCoalesce));
parcelHelpers.export(exports, "_asyncOptionalChain", ()=>(0, _asyncOptionalChainJs._asyncOptionalChain));
parcelHelpers.export(exports, "_asyncOptionalChainDelete", ()=>(0, _asyncOptionalChainDeleteJs._asyncOptionalChainDelete));
parcelHelpers.export(exports, "_nullishCoalesce", ()=>(0, _nullishCoalesceJs._nullishCoalesce));
parcelHelpers.export(exports, "_optionalChain", ()=>(0, _optionalChainJs._optionalChain));
parcelHelpers.export(exports, "_optionalChainDelete", ()=>(0, _optionalChainDeleteJs._optionalChainDelete));
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", ()=>(0, _consoleJs.addConsoleInstrumentationHandler));
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", ()=>(0, _domJs.addClickKeypressInstrumentationHandler));
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", ()=>(0, _xhrJs.SENTRY_XHR_DATA_KEY));
parcelHelpers.export(exports, "addXhrInstrumentationHandler", ()=>(0, _xhrJs.addXhrInstrumentationHandler));
parcelHelpers.export(exports, "addFetchInstrumentationHandler", ()=>(0, _fetchJs.addFetchInstrumentationHandler));
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", ()=>(0, _historyJs.addHistoryInstrumentationHandler));
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", ()=>(0, _globalErrorJs.addGlobalErrorInstrumentationHandler));
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", ()=>(0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler));
parcelHelpers.export(exports, "resetInstrumentationHandlers", ()=>(0, _handlersJs.resetInstrumentationHandlers));
parcelHelpers.export(exports, "filenameIsInApp", ()=>(0, _nodeStackTraceJs.filenameIsInApp));
parcelHelpers.export(exports, "escapeStringForRegex", ()=>(0, _escapeStringForRegexJs.escapeStringForRegex));
parcelHelpers.export(exports, "supportsHistory", ()=>(0, _supportsHistoryJs.supportsHistory));
var _aggregateErrorsJs = require("./aggregate-errors.js");
var _browserJs = require("./browser.js");
var _dsnJs = require("./dsn.js");
var _errorJs = require("./error.js");
var _worldwideJs = require("./worldwide.js");
var _indexJs = require("./instrument/index.js");
var _isJs = require("./is.js");
var _isBrowserJs = require("./isBrowser.js");
var _loggerJs = require("./logger.js");
var _memoJs = require("./memo.js");
var _miscJs = require("./misc.js");
var _nodeJs = require("./node.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
var _pathJs = require("./path.js");
var _promisebufferJs = require("./promisebuffer.js");
var _requestdataJs = require("./requestdata.js");
var _severityJs = require("./severity.js");
var _stacktraceJs = require("./stacktrace.js");
var _stringJs = require("./string.js");
var _supportsJs = require("./supports.js");
var _syncpromiseJs = require("./syncpromise.js");
var _timeJs = require("./time.js");
var _tracingJs = require("./tracing.js");
var _envJs = require("./env.js");
var _envelopeJs = require("./envelope.js");
var _clientreportJs = require("./clientreport.js");
var _ratelimitJs = require("./ratelimit.js");
var _baggageJs = require("./baggage.js");
var _urlJs = require("./url.js");
var _userIntegrationsJs = require("./userIntegrations.js");
var _cacheJs = require("./cache.js");
var _eventbuilderJs = require("./eventbuilder.js");
var _anrJs = require("./anr.js");
var _lruJs = require("./lru.js");
var _asyncNullishCoalesceJs = require("./buildPolyfills/_asyncNullishCoalesce.js");
var _asyncOptionalChainJs = require("./buildPolyfills/_asyncOptionalChain.js");
var _asyncOptionalChainDeleteJs = require("./buildPolyfills/_asyncOptionalChainDelete.js");
var _nullishCoalesceJs = require("./buildPolyfills/_nullishCoalesce.js");
var _optionalChainJs = require("./buildPolyfills/_optionalChain.js");
var _optionalChainDeleteJs = require("./buildPolyfills/_optionalChainDelete.js");
var _consoleJs = require("./instrument/console.js");
var _domJs = require("./instrument/dom.js");
var _xhrJs = require("./instrument/xhr.js");
var _fetchJs = require("./instrument/fetch.js");
var _historyJs = require("./instrument/history.js");
var _globalErrorJs = require("./instrument/globalError.js");
var _globalUnhandledRejectionJs = require("./instrument/globalUnhandledRejection.js");
var _handlersJs = require("./instrument/_handlers.js");
var _nodeStackTraceJs = require("./node-stack-trace.js");
var _escapeStringForRegexJs = require("./vendor/escapeStringForRegex.js");
var _supportsHistoryJs = require("./vendor/supportsHistory.js");

},{"./aggregate-errors.js":"9ZVvJ","./browser.js":"aBIno","./dsn.js":"21OzZ","./error.js":"30a4n","./worldwide.js":"7yTu1","./instrument/index.js":"g3yY9","./is.js":"fZ7Sf","./isBrowser.js":"3nmbq","./logger.js":"g9pQ4","./memo.js":"cN7BT","./misc.js":"5olK5","./node.js":"4eyap","./normalize.js":"2KRpQ","./object.js":"EL0BH","./path.js":"5aTVy","./promisebuffer.js":"1EfGU","./requestdata.js":"kruQQ","./severity.js":"6102M","./stacktrace.js":"79j0c","./string.js":"33XF7","./supports.js":"fBMBP","./syncpromise.js":"9Qewv","./time.js":"iZSsN","./tracing.js":"ehCv4","./env.js":"gprfP","./envelope.js":"37jyh","./clientreport.js":"hTdT8","./ratelimit.js":"gqwTq","./baggage.js":"kSPac","./url.js":"hvGqf","./userIntegrations.js":"1pO2e","./cache.js":"auszg","./eventbuilder.js":"fcKuL","./anr.js":"fBu9q","./lru.js":"bGxum","./buildPolyfills/_asyncNullishCoalesce.js":"3lruO","./buildPolyfills/_asyncOptionalChain.js":"fUSxi","./buildPolyfills/_asyncOptionalChainDelete.js":"jwFWO","./buildPolyfills/_nullishCoalesce.js":"fSLkb","./buildPolyfills/_optionalChain.js":"iear9","./buildPolyfills/_optionalChainDelete.js":"kIuGY","./instrument/console.js":"3nLtV","./instrument/dom.js":"lUREs","./instrument/xhr.js":"dhQL0","./instrument/fetch.js":"48Jc3","./instrument/history.js":"jZJoM","./instrument/globalError.js":"1yjLx","./instrument/globalUnhandledRejection.js":"dut0H","./instrument/_handlers.js":"fRiSW","./node-stack-trace.js":"81oIx","./vendor/escapeStringForRegex.js":"gpQZS","./vendor/supportsHistory.js":"lTqlG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9ZVvJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", ()=>applyAggregateErrorsToEvent);
var _isJs = require("./is.js");
var _stringJs = require("./string.js");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, _isJs.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, _isJs.isInstanceOf)(error[key], Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, _isJs.isInstanceOf)(childError, Error)) {
            applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, _stringJs.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

},{"./is.js":"fZ7Sf","./string.js":"33XF7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fZ7Sf":[function(require,module,exports) {
// eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMError", ()=>isDOMError);
parcelHelpers.export(exports, "isDOMException", ()=>isDOMException);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isErrorEvent", ()=>isErrorEvent);
parcelHelpers.export(exports, "isEvent", ()=>isEvent);
parcelHelpers.export(exports, "isInstanceOf", ()=>isInstanceOf);
parcelHelpers.export(exports, "isNaN", ()=>isNaN);
parcelHelpers.export(exports, "isParameterizedString", ()=>isParameterizedString);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSyntheticEvent", ()=>isSyntheticEvent);
parcelHelpers.export(exports, "isThenable", ()=>isThenable);
parcelHelpers.export(exports, "isVueViewModel", ()=>isVueViewModel);
const objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isNaN(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"33XF7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMatchingPattern", ()=>isMatchingPattern);
parcelHelpers.export(exports, "safeJoin", ()=>safeJoin);
parcelHelpers.export(exports, "snipLine", ()=>snipLine);
parcelHelpers.export(exports, "stringMatchesSomePattern", ()=>stringMatchesSomePattern);
parcelHelpers.export(exports, "truncate", ()=>truncate);
var _isJs = require("./is.js");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, _isJs.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!(0, _isJs.isString)(value)) return false;
    if ((0, _isJs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, _isJs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>isMatchingPattern(testString, pattern, requireExactStringMatch));
}

},{"./is.js":"fZ7Sf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aBIno":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComponentName", ()=>getComponentName);
parcelHelpers.export(exports, "getDomElement", ()=>getDomElement);
parcelHelpers.export(exports, "getLocationHref", ()=>getLocationHref);
parcelHelpers.export(exports, "htmlTreeAsString", ()=>htmlTreeAsString);
var _isJs = require("./is.js");
var _worldwideJs = require("./worldwide.js");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, _worldwideJs.getGlobalObject)();
const DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, _isJs.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
    if (WINDOW.document && WINDOW.document.querySelector) return WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

},{"./is.js":"fZ7Sf","./worldwide.js":"7yTu1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7yTu1":[function(require,module,exports) {
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_OBJ", ()=>GLOBAL_OBJ);
parcelHelpers.export(exports, "getGlobalObject", ()=>getGlobalObject);
parcelHelpers.export(exports, "getGlobalSingleton", ()=>getGlobalSingleton);
var global = arguments[3];
function isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const GLOBAL_OBJ = typeof globalThis == "object" && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && isGlobalObj(window) || typeof self == "object" && isGlobalObj(self) || typeof global == "object" && isGlobalObj(global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function getGlobalObject() {
    return GLOBAL_OBJ;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator, obj) {
    const gbl = obj || GLOBAL_OBJ;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"21OzZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsnFromString", ()=>dsnFromString);
parcelHelpers.export(exports, "dsnToString", ()=>dsnToString);
parcelHelpers.export(exports, "makeDsn", ()=>makeDsn);
var _debugBuildJs = require("./debug-build.js");
var _loggerJs = require("./logger.js");
/** Regular expression used to parse a Dsn. */ const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsnToString(dsn, withPassword = false) {
    const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    const match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, _loggerJs.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return dsnFromComponents({
        host,
        pass,
        path,
        projectId,
        port,
        protocol: protocol,
        publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return true;
    const { port, projectId, protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, _loggerJs.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, _loggerJs.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!isValidProtocol(protocol)) {
        (0, _loggerJs.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, _loggerJs.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function makeDsn(from) {
    const components = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) return undefined;
    return components;
}

},{"./debug-build.js":"cZjsV","./logger.js":"g9pQ4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cZjsV":[function(require,module,exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", ()=>DEBUG_BUILD);
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g9pQ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", ()=>CONSOLE_LEVELS);
parcelHelpers.export(exports, "consoleSandbox", ()=>consoleSandbox);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "originalConsoleMethods", ()=>originalConsoleMethods);
var _debugBuildJs = require("./debug-build.js");
var _worldwideJs = require("./worldwide.js");
/** Prefix for logging strings */ const PREFIX = "Sentry Logger ";
const CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const originalConsoleMethods = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!("console" in (0, _worldwideJs.GLOBAL_OBJ))) return callback();
    const console = (0, _worldwideJs.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, _debugBuildJs.DEBUG_BUILD) CONSOLE_LEVELS.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) consoleSandbox(()=>{
                (0, _worldwideJs.GLOBAL_OBJ).console[name](`${PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else CONSOLE_LEVELS.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const logger = makeLogger();

},{"./debug-build.js":"cZjsV","./worldwide.js":"7yTu1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"30a4n":[function(require,module,exports) {
/** An error emitted by Sentry SDKs and related utilities. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryError", ()=>SentryError);
class SentryError extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g3yY9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", ()=>(0, _consoleJs.addConsoleInstrumentationHandler));
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", ()=>(0, _domJs.addClickKeypressInstrumentationHandler));
parcelHelpers.export(exports, "addFetchInstrumentationHandler", ()=>(0, _fetchJs.addFetchInstrumentationHandler));
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", ()=>(0, _globalErrorJs.addGlobalErrorInstrumentationHandler));
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", ()=>(0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler));
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", ()=>(0, _historyJs.addHistoryInstrumentationHandler));
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", ()=>(0, _xhrJs.SENTRY_XHR_DATA_KEY));
parcelHelpers.export(exports, "addXhrInstrumentationHandler", ()=>(0, _xhrJs.addXhrInstrumentationHandler));
parcelHelpers.export(exports, "addInstrumentationHandler", ()=>addInstrumentationHandler);
var _debugBuildJs = require("../debug-build.js");
var _loggerJs = require("../logger.js");
var _consoleJs = require("./console.js");
var _domJs = require("./dom.js");
var _fetchJs = require("./fetch.js");
var _globalErrorJs = require("./globalError.js");
var _globalUnhandledRejectionJs = require("./globalUnhandledRejection.js");
var _historyJs = require("./history.js");
var _xhrJs = require("./xhr.js");
// TODO(v8): Consider moving this file (or at least parts of it) into the browser package. The registered handlers are mostly non-generic and we risk leaking runtime specific code into generic packages.
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 * @deprecated Use the proper function per instrumentation type instead!
 */ function addInstrumentationHandler(type, callback) {
    switch(type){
        case "console":
            return (0, _consoleJs.addConsoleInstrumentationHandler)(callback);
        case "dom":
            return (0, _domJs.addClickKeypressInstrumentationHandler)(callback);
        case "xhr":
            return (0, _xhrJs.addXhrInstrumentationHandler)(callback);
        case "fetch":
            return (0, _fetchJs.addFetchInstrumentationHandler)(callback);
        case "history":
            return (0, _historyJs.addHistoryInstrumentationHandler)(callback);
        case "error":
            return (0, _globalErrorJs.addGlobalErrorInstrumentationHandler)(callback);
        case "unhandledrejection":
            return (0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler)(callback);
        default:
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn("unknown instrumentation type:", type);
    }
}

},{"../debug-build.js":"cZjsV","../logger.js":"g9pQ4","./console.js":"3nLtV","./dom.js":"lUREs","./fetch.js":"48Jc3","./globalError.js":"1yjLx","./globalUnhandledRejection.js":"dut0H","./history.js":"jZJoM","./xhr.js":"dhQL0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3nLtV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", ()=>addConsoleInstrumentationHandler);
var _loggerJs = require("../logger.js");
var _objectJs = require("../object.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addConsoleInstrumentationHandler(handler) {
    const type = "console";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentConsole);
}
function instrumentConsole() {
    if (!("console" in (0, _worldwideJs.GLOBAL_OBJ))) return;
    (0, _loggerJs.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, _worldwideJs.GLOBAL_OBJ).console)) return;
        (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, _loggerJs.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args,
                    level
                };
                (0, _handlersJs.triggerHandlers)("console", handlerData);
                const log = (0, _loggerJs.originalConsoleMethods)[level];
                log && log.apply((0, _worldwideJs.GLOBAL_OBJ).console, args);
            };
        });
    });
}

},{"../logger.js":"g9pQ4","../object.js":"EL0BH","../worldwide.js":"7yTu1","./_handlers.js":"fRiSW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"EL0BH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addNonEnumerableProperty", ()=>addNonEnumerableProperty);
parcelHelpers.export(exports, "convertToPlainObject", ()=>convertToPlainObject);
parcelHelpers.export(exports, "dropUndefinedKeys", ()=>dropUndefinedKeys);
parcelHelpers.export(exports, "extractExceptionKeysForMessage", ()=>extractExceptionKeysForMessage);
parcelHelpers.export(exports, "fill", ()=>fill);
parcelHelpers.export(exports, "getOriginalFunction", ()=>getOriginalFunction);
parcelHelpers.export(exports, "markFunctionWrapped", ()=>markFunctionWrapped);
parcelHelpers.export(exports, "objectify", ()=>objectify);
parcelHelpers.export(exports, "urlEncode", ()=>urlEncode);
var _browserJs = require("./browser.js");
var _debugBuildJs = require("./debug-build.js");
var _isJs = require("./is.js");
var _loggerJs = require("./logger.js");
var _stringJs = require("./string.js");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") markFunctionWrapped(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function urlEncode(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0, _isJs.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...getOwnProperties(value)
    };
    else if ((0, _isJs.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget),
            ...getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, _isJs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _isJs.isElement)(target) ? (0, _browserJs.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception, maxLength = 40) {
    const keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, _stringJs.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, _stringJs.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    if (isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push(_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function isPojo(input) {
    if (!(0, _isJs.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _isJs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"./browser.js":"aBIno","./debug-build.js":"cZjsV","./is.js":"fZ7Sf","./logger.js":"g9pQ4","./string.js":"33XF7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fRiSW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHandler", ()=>addHandler);
parcelHelpers.export(exports, "maybeInstrument", ()=>maybeInstrument);
parcelHelpers.export(exports, "resetInstrumentationHandlers", ()=>resetInstrumentationHandlers);
parcelHelpers.export(exports, "triggerHandlers", ()=>triggerHandlers);
var _debugBuildJs = require("../debug-build.js");
var _loggerJs = require("../logger.js");
var _stacktraceJs = require("../stacktrace.js");
// We keep the handlers globally
const handlers = {};
const instrumented = {};
/** Add a handler function. */ function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function resetInstrumentationHandlers() {
    Object.keys(handlers).forEach((key)=>{
        handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumentFn();
        instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function triggerHandlers(type, data) {
    const typeHandlers = type && handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, _stacktraceJs.getFunctionName)(handler)}\nError:`, e);
    }
}

},{"../debug-build.js":"cZjsV","../logger.js":"g9pQ4","../stacktrace.js":"79j0c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"79j0c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filenameIsInApp", ()=>(0, _nodeStackTraceJs.filenameIsInApp));
parcelHelpers.export(exports, "createStackParser", ()=>createStackParser);
parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
parcelHelpers.export(exports, "nodeStackLineParser", ()=>nodeStackLineParser);
parcelHelpers.export(exports, "stackParserFromStackParserOptions", ()=>stackParserFromStackParserOptions);
parcelHelpers.export(exports, "stripSentryFramesAndReverse", ()=>stripSentryFramesAndReverse);
var _nodeStackTraceJs = require("./node-stack-trace.js");
const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT) break;
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return createStackParser(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function nodeStackLineParser(getModule) {
    return [
        90,
        (0, _nodeStackTraceJs.node)(getModule)
    ];
}

},{"./node-stack-trace.js":"81oIx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"81oIx":[function(require,module,exports) {
/**
 * Does this filename look like it's part of the app code?
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filenameIsInApp", ()=>filenameIsInApp);
parcelHelpers.export(exports, "node", ()=>node);
function filenameIsInApp(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function node(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: filenameIsInApp(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lUREs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", ()=>addClickKeypressInstrumentationHandler);
parcelHelpers.export(exports, "instrumentDOM", ()=>instrumentDOM);
var _miscJs = require("../misc.js");
var _objectJs = require("../object.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
const WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
const DEBOUNCE_DURATION = 1000;
let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addClickKeypressInstrumentationHandler(handler) {
    const type = "dom";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentDOM);
}
/** Exported for tests only. */ function instrumentDOM() {
    if (!WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, _handlersJs.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = WINDOW[target] && WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, _objectJs.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, _objectJs.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = getEventTarget(event);
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, _objectJs.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, _objectJs.addNonEnumerableProperty)(target, "_sentryId", (0, _miscJs.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event,
                name,
                global: globalListener
            };
            handler(handlerData);
            lastCapturedEventType = event.type;
            lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = WINDOW.setTimeout(()=>{
            lastCapturedEventTargetId = undefined;
            lastCapturedEventType = undefined;
        }, DEBOUNCE_DURATION);
    };
}
function getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

},{"../misc.js":"5olK5","../object.js":"EL0BH","../worldwide.js":"7yTu1","./_handlers.js":"fRiSW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5olK5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addContextToFrame", ()=>addContextToFrame);
parcelHelpers.export(exports, "addExceptionMechanism", ()=>addExceptionMechanism);
parcelHelpers.export(exports, "addExceptionTypeValue", ()=>addExceptionTypeValue);
parcelHelpers.export(exports, "arrayify", ()=>arrayify);
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", ()=>checkOrSetAlreadyCaught);
parcelHelpers.export(exports, "getEventDescription", ()=>getEventDescription);
parcelHelpers.export(exports, "parseSemver", ()=>parseSemver);
parcelHelpers.export(exports, "uuid4", ()=>uuid4);
var _objectJs = require("./object.js");
var _stringJs = require("./string.js");
var _worldwideJs = require("./worldwide.js");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function uuid4() {
    const gbl = (0, _worldwideJs.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    const { message, event_id: eventId } = event;
    if (message) return message;
    const firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    const firstException = getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    const match = input.match(SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, _stringJs.snipLine)(line, 0));
    frame.context_line = (0, _stringJs.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, _stringJs.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _objectJs.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function arrayify(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

},{"./object.js":"EL0BH","./string.js":"33XF7","./worldwide.js":"7yTu1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"48Jc3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFetchInstrumentationHandler", ()=>addFetchInstrumentationHandler);
parcelHelpers.export(exports, "parseFetchArgs", ()=>parseFetchArgs);
var _objectJs = require("../object.js");
var _supportsJs = require("../supports.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addFetchInstrumentationHandler(handler) {
    const type = "fetch";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentFetch);
}
function instrumentFetch() {
    if (!(0, _supportsJs.supportsNativeFetch)()) return;
    (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method, url } = parseFetchArgs(args);
            const handlerData = {
                args,
                fetchData: {
                    method,
                    url
                },
                startTimestamp: Date.now()
            };
            (0, _handlersJs.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, _worldwideJs.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response
                };
                (0, _handlersJs.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error
                };
                (0, _handlersJs.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if (hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: getUrlFromResource(url),
            method: hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

},{"../object.js":"EL0BH","../supports.js":"fBMBP","../worldwide.js":"7yTu1","./_handlers.js":"fRiSW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fBMBP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNativeFetch", ()=>isNativeFetch);
parcelHelpers.export(exports, "supportsDOMError", ()=>supportsDOMError);
parcelHelpers.export(exports, "supportsDOMException", ()=>supportsDOMException);
parcelHelpers.export(exports, "supportsErrorEvent", ()=>supportsErrorEvent);
parcelHelpers.export(exports, "supportsFetch", ()=>supportsFetch);
parcelHelpers.export(exports, "supportsNativeFetch", ()=>supportsNativeFetch);
parcelHelpers.export(exports, "supportsReferrerPolicy", ()=>supportsReferrerPolicy);
parcelHelpers.export(exports, "supportsReportingObserver", ()=>supportsReportingObserver);
var _debugBuildJs = require("./debug-build.js");
var _loggerJs = require("./logger.js");
var _worldwideJs = require("./worldwide.js");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, _worldwideJs.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function supportsFetch() {
    if (!("fetch" in WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") return true;
    if (!supportsFetch()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function supportsReportingObserver() {
    return "ReportingObserver" in WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

},{"./debug-build.js":"cZjsV","./logger.js":"g9pQ4","./worldwide.js":"7yTu1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1yjLx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", ()=>addGlobalErrorInstrumentationHandler);
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
let _oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalErrorInstrumentationHandler(handler) {
    const type = "error";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentError);
}
function instrumentError() {
    _oldOnErrorHandler = (0, _worldwideJs.GLOBAL_OBJ).onerror;
    (0, _worldwideJs.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column,
            error,
            line,
            msg,
            url
        };
        (0, _handlersJs.triggerHandlers)("error", handlerData);
        if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return _oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

},{"../worldwide.js":"7yTu1","./_handlers.js":"fRiSW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dut0H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", ()=>addGlobalUnhandledRejectionInstrumentationHandler);
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
let _oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = "unhandledrejection";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection;
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, _handlersJs.triggerHandlers)("unhandledrejection", handlerData);
        if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

},{"../worldwide.js":"7yTu1","./_handlers.js":"fRiSW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jZJoM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", ()=>addHistoryInstrumentationHandler);
var _objectJs = require("../object.js");
var _debugBuildJs = require("../debug-build.js");
var _loggerJs = require("../logger.js");
var _worldwideJs = require("../worldwide.js");
var _supportsHistoryJs = require("../vendor/supportsHistory.js");
var _handlersJs = require("./_handlers.js");
const WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
let lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addHistoryInstrumentationHandler(handler) {
    const type = "history";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentHistory);
}
function instrumentHistory() {
    if (!(0, _supportsHistoryJs.supportsHistory)()) return;
    const oldOnPopState = WINDOW.onpopstate;
    WINDOW.onpopstate = function(...args) {
        const to = WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = lastHref;
        lastHref = to;
        const handlerData = {
            from,
            to
        };
        (0, _handlersJs.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                const handlerData = {
                    from,
                    to
                };
                (0, _handlersJs.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, _objectJs.fill)(WINDOW.history, "pushState", historyReplacementFunction);
    (0, _objectJs.fill)(WINDOW.history, "replaceState", historyReplacementFunction);
}

},{"../object.js":"EL0BH","../debug-build.js":"cZjsV","../logger.js":"g9pQ4","../worldwide.js":"7yTu1","../vendor/supportsHistory.js":"lTqlG","./_handlers.js":"fRiSW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lTqlG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsHistory", ()=>supportsHistory);
var _worldwideJs = require("../worldwide.js");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, _worldwideJs.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

},{"../worldwide.js":"7yTu1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dhQL0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", ()=>SENTRY_XHR_DATA_KEY);
parcelHelpers.export(exports, "addXhrInstrumentationHandler", ()=>addXhrInstrumentationHandler);
parcelHelpers.export(exports, "instrumentXHR", ()=>instrumentXHR);
var _isJs = require("../is.js");
var _objectJs = require("../object.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
const WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
const SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addXhrInstrumentationHandler(handler) {
    const type = "xhr";
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentXHR);
}
/** Exported only for tests. */ function instrumentXHR() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, _objectJs.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, _isJs.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[SENTRY_XHR_DATA_KEY] = {
                method,
                url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[SENTRY_XHR_DATA_KEY];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp,
                        xhr: this
                    };
                    (0, _handlersJs.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, _objectJs.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, _objectJs.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[SENTRY_XHR_DATA_KEY];
                    if (xhrInfo && (0, _isJs.isString)(header) && (0, _isJs.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, _objectJs.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, _handlersJs.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function parseUrl(url) {
    if ((0, _isJs.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

},{"../is.js":"fZ7Sf","../object.js":"EL0BH","../worldwide.js":"7yTu1","./_handlers.js":"fRiSW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3nmbq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
var _nodeJs = require("./node.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Returns true if we are in the browser.
 */ function isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, _nodeJs.isNodeEnv)() || isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, _worldwideJs.GLOBAL_OBJ).process !== undefined && (0, _worldwideJs.GLOBAL_OBJ).process.type === "renderer");
}

},{"./node.js":"4eyap","./worldwide.js":"7yTu1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4eyap":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dynamicRequire", ()=>dynamicRequire);
parcelHelpers.export(exports, "isNodeEnv", ()=>isNodeEnv);
parcelHelpers.export(exports, "loadModule", ()=>loadModule);
var _envJs = require("./env.js");
var process = require("7e97d5f12975dbbe");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _envJs.isBrowserBundle)() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"7e97d5f12975dbbe":"b4AGK","./env.js":"gprfP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b4AGK":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"gprfP":[function(require,module,exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDKSource", ()=>getSDKSource);
parcelHelpers.export(exports, "isBrowserBundle", ()=>isBrowserBundle);
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cN7BT":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoBuilder", ()=>memoBuilder);
function memoBuilder() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2KRpQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize", ()=>normalize);
parcelHelpers.export(exports, "normalizeToSize", ()=>normalizeToSize);
parcelHelpers.export(exports, "normalizeUrlToBase", ()=>normalizeUrlToBase);
parcelHelpers.export(exports, "walk", ()=>visit);
var _isJs = require("./is.js");
var _memoJs = require("./memo.js");
var _objectJs = require("./object.js");
var _stacktraceJs = require("./stacktrace.js");
var global = arguments[3];
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, _memoJs.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, _isJs.isNaN)(value)) return value;
    const stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, _objectJs.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== "undefined" && value === global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, _isJs.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, _isJs.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, _stacktraceJs.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

},{"./is.js":"fZ7Sf","./memo.js":"cN7BT","./object.js":"EL0BH","./stacktrace.js":"79j0c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5aTVy":[function(require,module,exports) {
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basename", ()=>basename);
parcelHelpers.export(exports, "dirname", ()=>dirname);
parcelHelpers.export(exports, "isAbsolute", ()=>isAbsolute);
parcelHelpers.export(exports, "join", ()=>join);
parcelHelpers.export(exports, "normalizePath", ()=>normalizePath);
parcelHelpers.export(exports, "relative", ()=>relative);
parcelHelpers.export(exports, "resolve", ()=>resolve);
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function resolve(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
/** JSDoc */ function trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function relative(from, to) {
    /* eslint-disable no-param-reassign */ from = resolve(from).slice(1);
    to = resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = trim(from.split("/"));
    const toParts = trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
// path.normalize(path)
// posix version
/** JSDoc */ function normalizePath(path) {
    const isPathAbsolute = isAbsolute(path);
    const trailingSlash = path.slice(-1) === "/";
    // Normalize the path
    let normalizedPath = normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
// posix version
/** JSDoc */ function isAbsolute(path) {
    return path.charAt(0) === "/";
}
// posix version
/** JSDoc */ function join(...args) {
    return normalizePath(args.join("/"));
}
/** JSDoc */ function dirname(path) {
    const result = splitPath(path);
    const root = result[0];
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return ".";
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function basename(path, ext) {
    let f = splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1EfGU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makePromiseBuffer", ()=>makePromiseBuffer);
var _errorJs = require("./error.js");
var _syncpromiseJs = require("./syncpromise.js");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function makePromiseBuffer(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, _syncpromiseJs.rejectedSyncPromise)(new (0, _errorJs.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, _syncpromiseJs.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, _syncpromiseJs.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add,
        drain
    };
}

},{"./error.js":"30a4n","./syncpromise.js":"9Qewv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9Qewv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncPromise", ()=>SyncPromise);
parcelHelpers.export(exports, "rejectedSyncPromise", ()=>rejectedSyncPromise);
parcelHelpers.export(exports, "resolvedSyncPromise", ()=>resolvedSyncPromise);
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class SyncPromise {
    constructor(executor){
        SyncPromise.prototype.__init.call(this);
        SyncPromise.prototype.__init2.call(this);
        SyncPromise.prototype.__init3.call(this);
        SyncPromise.prototype.__init4.call(this);
        this._state = States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult(States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult(States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== States.PENDING) return;
            if ((0, _isJs.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

},{"./is.js":"fZ7Sf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kruQQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_USER_INCLUDES", ()=>DEFAULT_USER_INCLUDES);
parcelHelpers.export(exports, "addRequestDataToEvent", ()=>addRequestDataToEvent);
parcelHelpers.export(exports, "addRequestDataToTransaction", ()=>addRequestDataToTransaction);
parcelHelpers.export(exports, "extractPathForTransaction", ()=>extractPathForTransaction);
parcelHelpers.export(exports, "extractRequestData", ()=>extractRequestData);
parcelHelpers.export(exports, "winterCGHeadersToDict", ()=>winterCGHeadersToDict);
parcelHelpers.export(exports, "winterCGRequestToRequestData", ()=>winterCGRequestToRequestData);
var _cookieJs = require("./cookie.js");
var _debugBuildJs = require("./debug-build.js");
var _isJs = require("./is.js");
var _loggerJs = require("./logger.js");
var _normalizeJs = require("./normalize.js");
var _urlJs = require("./url.js");
const DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const DEFAULT_REQUEST_INCLUDES = [
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
];
const DEFAULT_USER_INCLUDES = [
    "id",
    "username",
    "email"
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function addRequestDataToTransaction(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === "url") {
        // Attempt to grab a parameterized route off of the request
        const [name, source] = extractPathForTransaction(req, {
            path: true,
            method: true
        });
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source
        });
    }
    transaction.setAttribute("url", req.originalUrl || req.url);
    if (req.baseUrl) transaction.setAttribute("baseUrl", req.baseUrl);
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData("query", extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function extractPathForTransaction(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = "";
    let source = "url";
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ""}${req.route && req.route.path}`;
        source = "route";
    } else if (req.originalUrl || req.url) path = (0, _urlJs.stripUrlQueryAndFragment)(req.originalUrl || req.url || "");
    let name = "";
    if (options.method && method) name += method;
    if (options.method && options.path) name += " ";
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function extractTransaction(req, type) {
    switch(type){
        case "path":
            return extractPathForTransaction(req, {
                path: true
            })[0];
        case "handler":
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || "<anonymous>";
        case "methodPath":
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                const customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return extractPathForTransaction(req, {
                    path: true,
                    method: true,
                    customRoute
                })[0];
            }
    }
}
/** JSDoc */ function extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : DEFAULT_USER_INCLUDES;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function extractRequestData(req, options) {
    const { include = DEFAULT_REQUEST_INCLUDES, deps } = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    const host = headers.host || req.hostname || req.host || "<no host>";
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === "https" || req.socket && req.socket.encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || "";
    // absolute url
    const absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case "headers":
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes("cookies")) delete requestData.headers.cookie;
                break;
            case "method":
                requestData.method = method;
                break;
            case "url":
                requestData.url = absoluteUrl;
                break;
            case "cookies":
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, _cookieJs.parseCookie)(headers.cookie) || {};
                break;
            case "query_string":
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = extractQueryParams(req, deps);
                break;
            case "data":
                if (method === "GET" || method === "HEAD") break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, _isJs.isString)(req.body) ? req.body : JSON.stringify((0, _normalizeJs.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function addRequestDataToEvent(event, req, options) {
    const include = {
        ...DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? extractRequestData(req, {
            include: include.request,
            deps: options && options.deps
        }) : extractRequestData(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, _isJs.isPlainObject)(req.user) ? extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = extractTransaction(req, include.transaction);
    return event;
}
function extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || "";
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith("/")) originalUrl = `http://dogs.are.great${originalUrl}`;
    try {
        return req.query || typeof URL !== "undefined" && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === "string") // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn("Sentry failed extracting headers from a request object. If you see this, please file an issue.");
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function winterCGRequestToRequestData(req) {
    const headers = winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers
    };
}

},{"./cookie.js":"cJTpV","./debug-build.js":"cZjsV","./is.js":"fZ7Sf","./logger.js":"g9pQ4","./normalize.js":"2KRpQ","./url.js":"hvGqf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cJTpV":[function(require,module,exports) {
/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCookie", ()=>parseCookie);
function parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf("=", index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(";", index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf("%") !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hvGqf":[function(require,module,exports) {
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNumberOfUrlSegments", ()=>getNumberOfUrlSegments);
parcelHelpers.export(exports, "getSanitizedUrlString", ()=>getSanitizedUrlString);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>stripUrlQueryAndFragment);
function parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function getNumberOfUrlSegments(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    const { protocol, host, path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6102M":[function(require,module,exports) {
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "severityFromString", ()=>severityFromString);
parcelHelpers.export(exports, "severityLevelFromString", ()=>severityLevelFromString);
parcelHelpers.export(exports, "validSeverityLevels", ()=>validSeverityLevels);
const validSeverityLevels = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function severityFromString(level) {
    return severityLevelFromString(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function severityLevelFromString(level) {
    return level === "warn" ? "warning" : validSeverityLevels.includes(level) ? level : "log";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iZSsN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_browserPerformanceTimeOriginMode", ()=>_browserPerformanceTimeOriginMode);
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", ()=>browserPerformanceTimeOrigin);
parcelHelpers.export(exports, "dateTimestampInSeconds", ()=>dateTimestampInSeconds);
parcelHelpers.export(exports, "timestampInSeconds", ()=>timestampInSeconds);
parcelHelpers.export(exports, "timestampWithMs", ()=>timestampWithMs);
var _worldwideJs = require("./worldwide.js");
const ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    const { performance } = (0, _worldwideJs.GLOBAL_OBJ);
    if (!performance || !performance.now) return dateTimestampInSeconds;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const timestampWithMs = timestampInSeconds;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = (0, _worldwideJs.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
})();

},{"./worldwide.js":"7yTu1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ehCv4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", ()=>TRACEPARENT_REGEXP);
parcelHelpers.export(exports, "extractTraceparentData", ()=>extractTraceparentData);
parcelHelpers.export(exports, "generateSentryTraceHeader", ()=>generateSentryTraceHeader);
parcelHelpers.export(exports, "propagationContextFromHeaders", ()=>propagationContextFromHeaders);
parcelHelpers.export(exports, "tracingContextFromHeaders", ()=>tracingContextFromHeaders);
var _baggageJs = require("./baggage.js");
var _miscJs = require("./misc.js");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function tracingContextFromHeaders(sentryTrace, baggage) {
    const traceparentData = extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId, parentSpanId, parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, _miscJs.uuid4)(),
            spanId: (0, _miscJs.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, _miscJs.uuid4)(),
            parentSpanId: parentSpanId || (0, _miscJs.uuid4)().substring(16),
            spanId: (0, _miscJs.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    const traceparentData = extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId, parentSpanId, parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, _miscJs.uuid4)(),
        spanId: (0, _miscJs.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, _miscJs.uuid4)(),
        parentSpanId: parentSpanId || (0, _miscJs.uuid4)().substring(16),
        spanId: (0, _miscJs.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader(traceId = (0, _miscJs.uuid4)(), spanId = (0, _miscJs.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

},{"./baggage.js":"kSPac","./misc.js":"5olK5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kSPac":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BAGGAGE_HEADER_NAME", ()=>BAGGAGE_HEADER_NAME);
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", ()=>MAX_BAGGAGE_STRING_LENGTH);
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", ()=>SENTRY_BAGGAGE_KEY_PREFIX);
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", ()=>SENTRY_BAGGAGE_KEY_PREFIX_REGEX);
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", ()=>baggageHeaderToDynamicSamplingContext);
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", ()=>dynamicSamplingContextToSentryBaggageHeader);
var _debugBuildJs = require("./debug-build.js");
var _isJs = require("./is.js");
var _loggerJs = require("./logger.js");
const BAGGAGE_HEADER_NAME = "baggage";
const SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, _isJs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
            const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

},{"./debug-build.js":"cZjsV","./is.js":"fZ7Sf","./logger.js":"g9pQ4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"37jyh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addItemToEnvelope", ()=>addItemToEnvelope);
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", ()=>createAttachmentEnvelopeItem);
parcelHelpers.export(exports, "createEnvelope", ()=>createEnvelope);
parcelHelpers.export(exports, "createEventEnvelopeHeaders", ()=>createEventEnvelopeHeaders);
parcelHelpers.export(exports, "envelopeContainsItemType", ()=>envelopeContainsItemType);
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", ()=>envelopeItemTypeToDataCategory);
parcelHelpers.export(exports, "forEachEnvelopeItem", ()=>forEachEnvelopeItem);
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", ()=>getSdkMetadataForEnvelopeHeader);
parcelHelpers.export(exports, "parseEnvelope", ()=>parseEnvelope);
parcelHelpers.export(exports, "serializeEnvelope", ()=>serializeEnvelope);
var _dsnJs = require("./dsn.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, _normalizeJs.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, _objectJs.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name, version } = metadataOrEvent.sdk;
    return {
        name,
        version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, _dsnJs.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, _objectJs.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

},{"./dsn.js":"21OzZ","./normalize.js":"2KRpQ","./object.js":"EL0BH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hTdT8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createClientReportEnvelope", ()=>createClientReportEnvelope);
var _envelopeJs = require("./envelope.js");
var _timeJs = require("./time.js");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, _timeJs.dateTimestampInSeconds)(),
            discarded_events
        }
    ];
    return (0, _envelopeJs.createEnvelope)(dsn ? {
        dsn
    } : {}, [
        clientReportItem
    ]);
}

},{"./envelope.js":"37jyh","./time.js":"iZSsN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gqwTq":[function(require,module,exports) {
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", ()=>DEFAULT_RETRY_AFTER);
parcelHelpers.export(exports, "disabledUntil", ()=>disabledUntil);
parcelHelpers.export(exports, "isRateLimited", ()=>isRateLimited);
parcelHelpers.export(exports, "parseRetryAfterHeader", ()=>parseRetryAfterHeader);
parcelHelpers.export(exports, "updateRateLimits", ()=>updateRateLimits);
const DEFAULT_RETRY_AFTER = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function parseRetryAfterHeader(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function isRateLimited(limits, dataCategory, now = Date.now()) {
    return disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function updateRateLimits(limits, { statusCode, headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1pO2e":[function(require,module,exports) {
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addOrUpdateIntegration", ()=>addOrUpdateIntegration);
function setNestedKey(obj, keyPath, value) {
    // Ex. foo.bar.zoop will extract foo and bar.zoop
    const match = keyPath.match(/([a-z_]+)\.(.*)/i);
    // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
    if (match === null) obj[keyPath] = value;
    else {
        // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
        const innerObj = obj[match[1]];
        setNestedKey(innerObj, match[2], value);
    }
}
/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 *
 * @deprecated This will be removed in v8.
 */ function addOrUpdateIntegration(defaultIntegrationInstance, userIntegrations, forcedOptions = {}) {
    return Array.isArray(userIntegrations) ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions) : addOrUpdateIntegrationInFunction(defaultIntegrationInstance, // Somehow TS can't figure out that not being an array makes this necessarily a function
    userIntegrations, forcedOptions);
}
function addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions) {
    const userInstance = userIntegrations.find((integration)=>integration.name === defaultIntegrationInstance.name);
    if (userInstance) {
        for (const [keyPath, value] of Object.entries(forcedOptions))setNestedKey(userInstance, keyPath, value);
        return userIntegrations;
    }
    return [
        ...userIntegrations,
        defaultIntegrationInstance
    ];
}
function addOrUpdateIntegrationInFunction(defaultIntegrationInstance, userIntegrationsFunc, forcedOptions) {
    const wrapper = (defaultIntegrations)=>{
        const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
        // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
        // would do by providing a function which filters out the integration in question. If that's happened in one of
        // those cases, don't add our default back in.
        if (defaultIntegrationInstance.allowExclusionByUser) {
            const userFinalInstance = userFinalIntegrations.find((integration)=>integration.name === defaultIntegrationInstance.name);
            if (!userFinalInstance) return userFinalIntegrations;
        }
        return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
    };
    return wrapper;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"auszg":[function(require,module,exports) {
/**
 * Creates a cache that evicts keys in fifo order
 * @param size {Number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFifoCache", ()=>makeFifoCache);
function makeFifoCache(size) {
    // Maintain a fifo queue of keys, we cannot rely on Object.keys as the browser may not support it.
    let evictionOrder = [];
    let cache = {};
    return {
        add (key, value) {
            while(evictionOrder.length >= size){
                // shift is O(n) but this is small size and only happens if we are
                // exceeding the cache size so it should be fine.
                const evictCandidate = evictionOrder.shift();
                if (evictCandidate !== undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete cache[evictCandidate];
            }
            // in case we have a collision, delete the old key.
            if (cache[key]) this.delete(key);
            evictionOrder.push(key);
            cache[key] = value;
        },
        clear () {
            cache = {};
            evictionOrder = [];
        },
        get (key) {
            return cache[key];
        },
        size () {
            return evictionOrder.length;
        },
        // Delete cache key and return true if it existed, false otherwise.
        delete (key) {
            if (!cache[key]) return false;
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete cache[key];
            for(let i = 0; i < evictionOrder.length; i++)if (evictionOrder[i] === key) {
                evictionOrder.splice(i, 1);
                break;
            }
            return true;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fcKuL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromMessage", ()=>eventFromMessage);
parcelHelpers.export(exports, "eventFromUnknownInput", ()=>eventFromUnknownInput);
parcelHelpers.export(exports, "exceptionFromError", ()=>exceptionFromError);
parcelHelpers.export(exports, "parseStackFrames", ()=>parseStackFrames);
var _isJs = require("./is.js");
var _miscJs = require("./misc.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
/**
 * Extracts stack frames from the error.stack string
 */ function parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames
    };
    return exception;
}
function getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, _objectJs.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function eventFromUnknownInput(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, _isJs.isError)(exception)) {
        if ((0, _isJs.isPlainObject)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, _normalizeJs.normalizeToSize)(exception, normalizeDepth)
            };
            const message = getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, _miscJs.addExceptionTypeValue)(event, undefined, undefined);
    (0, _miscJs.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames
                    }
                }
            ]
        };
    }
    if ((0, _isJs.isParameterizedString)(message)) {
        const { __sentry_template_string__, __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

},{"./is.js":"fZ7Sf","./misc.js":"5olK5","./normalize.js":"2KRpQ","./object.js":"EL0BH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fBu9q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "callFrameToStackFrame", ()=>callFrameToStackFrame);
parcelHelpers.export(exports, "watchdogTimer", ()=>watchdogTimer);
var _objectJs = require("./object.js");
var _nodeStackTraceJs = require("./node-stack-trace.js");
/**
 * A node.js watchdog timer
 * @param pollInterval The interval that we expect to get polled at
 * @param anrThreshold The threshold for when we consider ANR
 * @param callback The callback to call for ANR
 * @returns An object with `poll` and `enabled` functions {@link WatchdogReturn}
 */ function watchdogTimer(createTimer, pollInterval, anrThreshold, callback) {
    const timer = createTimer();
    let triggered = false;
    let enabled = true;
    setInterval(()=>{
        const diffMs = timer.getTimeMs();
        if (triggered === false && diffMs > pollInterval + anrThreshold) {
            triggered = true;
            if (enabled) callback();
        }
        if (diffMs < pollInterval + anrThreshold) triggered = false;
    }, 20);
    return {
        poll: ()=>{
            timer.reset();
        },
        enabled: (state)=>{
            enabled = state;
        }
    };
}
// types copied from inspector.d.ts
/**
 * Converts Debugger.CallFrame to Sentry StackFrame
 */ function callFrameToStackFrame(frame, url, getModuleFromFilename) {
    const filename = url ? url.replace(/^file:\/\//, "") : undefined;
    // CallFrame row/col are 0 based, whereas StackFrame are 1 based
    const colno = frame.location.columnNumber ? frame.location.columnNumber + 1 : undefined;
    const lineno = frame.location.lineNumber ? frame.location.lineNumber + 1 : undefined;
    return (0, _objectJs.dropUndefinedKeys)({
        filename,
        module: getModuleFromFilename(filename),
        function: frame.functionName || "?",
        colno,
        lineno,
        in_app: filename ? (0, _nodeStackTraceJs.filenameIsInApp)(filename) : undefined
    });
}

},{"./object.js":"EL0BH","./node-stack-trace.js":"81oIx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bGxum":[function(require,module,exports) {
/** A simple Least Recently Used map */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LRUMap", ()=>LRUMap);
class LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === undefined) return undefined;
        // Remove and re-insert to update the order
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) // keys() returns an iterator in insertion order so keys().next() gives us the oldest key
        this._cache.delete(this._cache.keys().next().value);
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3lruO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// async function _asyncNullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return await rhsFn();
//   }
// }
parcelHelpers.export(exports, "_asyncNullishCoalesce", ()=>_asyncNullishCoalesce);
var _nullishCoalesceJs = require("./_nullishCoalesce.js");
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
/**
 * Polyfill for the nullish coalescing operator (`??`), when used in situations where at least one of the values is the
 * result of an async operation.
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ async function _asyncNullishCoalesce(lhs, rhsFn) {
    return (0, _nullishCoalesceJs._nullishCoalesce)(lhs, rhsFn);
}

},{"./_nullishCoalesce.js":"fSLkb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fSLkb":[function(require,module,exports) {
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }
parcelHelpers.export(exports, "_nullishCoalesce", ()=>_nullishCoalesce);
function _nullishCoalesce(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fUSxi":[function(require,module,exports) {
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, for situations in which at least one part of the expression is async.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// async function _asyncOptionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = await fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = await fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }
parcelHelpers.export(exports, "_asyncOptionalChain", ()=>_asyncOptionalChain);
async function _asyncOptionalChain(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = await fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = await fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jwFWO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// async function asyncOptionalChainDelete(ops) {
//   const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);
//   return result == null ? true : result;
// }
parcelHelpers.export(exports, "_asyncOptionalChainDelete", ()=>_asyncOptionalChainDelete);
var _asyncOptionalChainJs = require("./_asyncOptionalChain.js");
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, in cases where the value of the expression is to be deleted.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The return value of the `delete` operator: `true`, unless the deletion target is an own, non-configurable
 * property (one which can't be deleted or turned into an accessor, and whose enumerability can't be changed), in which
 * case `false`.
 */ async function _asyncOptionalChainDelete(ops) {
    const result = await (0, _asyncOptionalChainJs._asyncOptionalChain)(ops);
    // If `result` is `null`, it means we didn't get to the end of the chain and so nothing was deleted (in which case,
    // return `true` since that's what `delete` does when it no-ops). If it's non-null, we know the delete happened, in
    // which case we return whatever the `delete` returned, which will be a boolean.
    return result == null ? true : result;
}

},{"./_asyncOptionalChain.js":"fUSxi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iear9":[function(require,module,exports) {
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }
parcelHelpers.export(exports, "_optionalChain", ()=>_optionalChain);
function _optionalChain(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kIuGY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// function _optionalChainDelete(ops) {
//   const result = _optionalChain(ops);
//   // by checking for loose equality to `null`, we catch both `null` and `undefined`
//   return result == null ? true : result;
// }
parcelHelpers.export(exports, "_optionalChainDelete", ()=>_optionalChainDelete);
var _optionalChainJs = require("./_optionalChain.js");
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, in cases where the value of the expression is to be deleted.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The return value of the `delete` operator: `true`, unless the deletion target is an own, non-configurable
 * property (one which can't be deleted or turned into an accessor, and whose enumerability can't be changed), in which
 * case `false`.
 */ function _optionalChainDelete(ops) {
    const result = (0, _optionalChainJs._optionalChain)(ops);
    // If `result` is `null`, it means we didn't get to the end of the chain and so nothing was deleted (in which case,
    // return `true` since that's what `delete` does when it no-ops). If it's non-null, we know the delete happened, in
    // which case we return whatever the `delete` returned, which will be a boolean.
    return result == null ? true : result;
}

},{"./_optionalChain.js":"iear9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gpQZS":[function(require,module,exports) {
// Based on https://github.com/sindresorhus/escape-string-regexp but with modifications to:
//   a) reduce the size by skipping the runtime type - checking
//   b) ensure it gets down - compiled for old versions of Node(the published package only supports Node 12+).
//
// MIT License
//
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
// documentation files(the "Software"), to deal in the Software without restriction, including without limitation
// the rights to use, copy, modify, merge, publish, distribute, sublicense, and / or sell copies of the Software, and
// to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of
// the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
// THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeStringForRegex", ()=>escapeStringForRegex);
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h4qdv":[function(require,module,exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", ()=>DEBUG_BUILD);
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d9xVP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_VERSION", ()=>API_VERSION);
parcelHelpers.export(exports, "Hub", ()=>Hub);
parcelHelpers.export(exports, "ensureHubOnCarrier", ()=>ensureHubOnCarrier);
parcelHelpers.export(exports, "getCurrentHub", ()=>getCurrentHub);
parcelHelpers.export(exports, "getHubFromCarrier", ()=>getHubFromCarrier);
parcelHelpers.export(exports, "getIsolationScope", ()=>getIsolationScope);
parcelHelpers.export(exports, "getMainCarrier", ()=>getMainCarrier);
parcelHelpers.export(exports, "makeMain", ()=>makeMain);
parcelHelpers.export(exports, "runWithAsyncContext", ()=>runWithAsyncContext);
parcelHelpers.export(exports, "setAsyncContextStrategy", ()=>setAsyncContextStrategy);
parcelHelpers.export(exports, "setHubOnCarrier", ()=>setHubOnCarrier);
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _debugBuildJs = require("./debug-build.js");
var _scopeJs = require("./scope.js");
var _sessionJs = require("./session.js");
var _versionJs = require("./version.js");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const API_VERSION = parseFloat((0, _versionJs.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class Hub {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = API_VERSION){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, _scopeJs.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, _scopeJs.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, _utils.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope, client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, _utils.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, _utils.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope, client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = makeMain(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            makeMain(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, _debugBuildJs.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, _utils.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, _utils.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, _sessionJs.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope, client } = this.getStackTop();
        const { release, environment = (0, _constantsJs.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent } = (0, _utils.GLOBAL_OBJ).navigator || {};
        const session = (0, _sessionJs.makeSession)({
            release,
            environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, _sessionJs.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope, client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = getMainCarrier();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    (0, _utils.GLOBAL_OBJ).__SENTRY__ = (0, _utils.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, _utils.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
    const registry = getMainCarrier();
    const oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
    // Get main carrier (global for every environment)
    const registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function getIsolationScope() {
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function getGlobalHub(registry = getMainCarrier()) {
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)) // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(registry, new Hub());
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    const registry = getMainCarrier();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function runWithAsyncContext(callback, options = {}) {
    const registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _utils.getGlobalSingleton)("hub", ()=>new Hub(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

},{"@sentry/utils":"5XfgR","./constants.js":"2PUCq","./debug-build.js":"h4qdv","./scope.js":"38Vhk","./session.js":"019j9","./version.js":"aWeoJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2PUCq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", ()=>DEFAULT_ENVIRONMENT);
const DEFAULT_ENVIRONMENT = "production";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"38Vhk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", ()=>Scope);
parcelHelpers.export(exports, "getGlobalScope", ()=>getGlobalScope);
parcelHelpers.export(exports, "setGlobalScope", ()=>setGlobalScope);
var _utils = require("@sentry/utils");
var _eventProcessorsJs = require("./eventProcessors.js");
var _sessionJs = require("./session.js");
var _applyScopeDataToEventJs = require("./utils/applyScopeDataToEvent.js");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class Scope {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new Scope();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, _sessionJs.updateSession)(this._session, {
            user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof Scope) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, _utils.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, _utils.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs, _attachments, _contexts, _tags, _extra, _user, _level, _fingerprint, _eventProcessors, _propagationContext, _sdkProcessingMetadata, _transactionName, _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, _applyScopeDataToEventJs.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, _eventProcessorsJs.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, _eventProcessorsJs.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        if (!this._client) {
            (0, _utils.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        if (!this._client) {
            (0, _utils.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
        if (!this._client) {
            (0, _utils.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    if (!globalScope) globalScope = new Scope();
    return globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function setGlobalScope(scope) {
    globalScope = scope;
}
function generatePropagationContext() {
    return {
        traceId: (0, _utils.uuid4)(),
        spanId: (0, _utils.uuid4)().substring(16)
    };
}

},{"@sentry/utils":"5XfgR","./eventProcessors.js":"aLe4Y","./session.js":"019j9","./utils/applyScopeDataToEvent.js":"91PZM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aLe4Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalEventProcessor", ()=>addGlobalEventProcessor);
parcelHelpers.export(exports, "getGlobalEventProcessors", ()=>getGlobalEventProcessors);
parcelHelpers.export(exports, "notifyEventProcessors", ()=>notifyEventProcessors);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function getGlobalEventProcessors() {
    return (0, _utils.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function addGlobalEventProcessor(callback) {
    // eslint-disable-next-line deprecation/deprecation
    getGlobalEventProcessors().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function notifyEventProcessors(processors, event, hint, index = 0) {
    return new (0, _utils.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, _debugBuildJs.DEBUG_BUILD) && processor.id && result === null && (0, _utils.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, _utils.isThenable)(result)) result.then((final)=>notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

},{"@sentry/utils":"5XfgR","./debug-build.js":"h4qdv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"019j9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeSession", ()=>closeSession);
parcelHelpers.export(exports, "makeSession", ()=>makeSession);
parcelHelpers.export(exports, "updateSession", ()=>updateSession);
var _utils = require("@sentry/utils");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, _utils.timestampInSeconds)();
    const session = {
        sid: (0, _utils.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>sessionToJSON(session)
    };
    if (context) updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, _utils.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, _utils.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    let context = {};
    if (status) context = {
        status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return (0, _utils.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"91PZM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyScopeDataToEvent", ()=>applyScopeDataToEvent);
parcelHelpers.export(exports, "mergeAndOverwriteScopeData", ()=>mergeAndOverwriteScopeData);
parcelHelpers.export(exports, "mergeScopeData", ()=>mergeScopeData);
var _utils = require("@sentry/utils");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _getRootSpanJs = require("./getRootSpan.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function applyScopeDataToEvent(event, data) {
    const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;
    // Apply general data
    applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) applySpanToEvent(event, span);
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function mergeScopeData(data, mergeData) {
    const { extra, tags, user, contexts, level, sdkProcessingMetadata, breadcrumbs, fingerprint, eventProcessors, attachments, propagationContext, // eslint-disable-next-line deprecation/deprecation
    transactionName, span } = mergeData;
    mergeAndOverwriteScopeData(data, "extra", extra);
    mergeAndOverwriteScopeData(data, "tags", tags);
    mergeAndOverwriteScopeData(data, "user", user);
    mergeAndOverwriteScopeData(data, "contexts", contexts);
    mergeAndOverwriteScopeData(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function mergeAndOverwriteScopeData(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function applyDataToEvent(event, data) {
    const { extra, tags, user, contexts, level, // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, _utils.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, _utils.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, _utils.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, _utils.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, _spanUtilsJs.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, _getRootSpanJs.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, _spanUtilsJs.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, _utils.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

},{"@sentry/utils":"5XfgR","../tracing/dynamicSamplingContext.js":"czMfo","./getRootSpan.js":"6BdAG","./spanUtils.js":"jLzrc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"czMfo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", ()=>getDynamicSamplingContextFromClient);
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", ()=>getDynamicSamplingContextFromSpan);
var _utils = require("@sentry/utils");
var _constantsJs = require("../constants.js");
var _exportsJs = require("../exports.js");
var _getRootSpanJs = require("../utils/getRootSpan.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, _utils.dropUndefinedKeys)({
        environment: options.environment || (0, _constantsJs.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment,
        public_key,
        trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    const client = (0, _exportsJs.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = getDynamicSamplingContextFromClient((0, _spanUtilsJs.spanToJSON)(span).trace_id || "", client, (0, _exportsJs.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, _getRootSpanJs.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, _spanUtilsJs.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, _spanUtilsJs.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

},{"@sentry/utils":"5XfgR","../constants.js":"2PUCq","../exports.js":"bQ1GW","../utils/getRootSpan.js":"6BdAG","../utils/spanUtils.js":"jLzrc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bQ1GW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBreadcrumb", ()=>addBreadcrumb);
parcelHelpers.export(exports, "captureCheckIn", ()=>captureCheckIn);
parcelHelpers.export(exports, "captureEvent", ()=>captureEvent);
parcelHelpers.export(exports, "captureException", ()=>captureException);
parcelHelpers.export(exports, "captureMessage", ()=>captureMessage);
parcelHelpers.export(exports, "captureSession", ()=>captureSession);
parcelHelpers.export(exports, "close", ()=>close);
parcelHelpers.export(exports, "configureScope", ()=>configureScope);
parcelHelpers.export(exports, "endSession", ()=>endSession);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getClient", ()=>getClient);
parcelHelpers.export(exports, "getCurrentScope", ()=>getCurrentScope);
parcelHelpers.export(exports, "isInitialized", ()=>isInitialized);
parcelHelpers.export(exports, "lastEventId", ()=>lastEventId);
parcelHelpers.export(exports, "setContext", ()=>setContext);
parcelHelpers.export(exports, "setExtra", ()=>setExtra);
parcelHelpers.export(exports, "setExtras", ()=>setExtras);
parcelHelpers.export(exports, "setTag", ()=>setTag);
parcelHelpers.export(exports, "setTags", ()=>setTags);
parcelHelpers.export(exports, "setUser", ()=>setUser);
parcelHelpers.export(exports, "startSession", ()=>startSession);
parcelHelpers.export(exports, "startTransaction", ()=>startTransaction);
parcelHelpers.export(exports, "withActiveSpan", ()=>withActiveSpan);
parcelHelpers.export(exports, "withIsolationScope", ()=>withIsolationScope);
parcelHelpers.export(exports, "withMonitor", ()=>withMonitor);
parcelHelpers.export(exports, "withScope", ()=>withScope);
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _debugBuildJs = require("./debug-build.js");
var _hubJs = require("./hub.js");
var _sessionJs = require("./session.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureException(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().captureException(exception, (0, _prepareEventJs.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function captureEvent(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function configureScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtras(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtra(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setTags(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function setTag(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function setUser(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, _hubJs.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function withIsolationScope(callback) {
    return (0, _hubJs.runWithAsyncContext)(()=>{
        return callback((0, _hubJs.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function withActiveSpan(span, callback) {
    return withScope((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function startTransaction(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = getCurrentScope();
    const client = getClient();
    if (!client) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, _utils.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = captureCheckIn({
        monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, _utils.timestampInSeconds)();
    function finishCheckIn(status) {
        captureCheckIn({
            monitorSlug,
            status,
            checkInId,
            duration: (0, _utils.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, _utils.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function flush(timeout) {
    const client = getClient();
    if (client) return client.flush(timeout);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function close(timeout) {
    const client = getClient();
    if (client) return client.close(timeout);
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function lastEventId() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function getClient() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function isInitialized() {
    return !!getClient();
}
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function startSession(context) {
    const client = getClient();
    const isolationScope = (0, _hubJs.getIsolationScope)();
    const currentScope = getCurrentScope();
    const { release, environment = (0, _constantsJs.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent } = (0, _utils.GLOBAL_OBJ).navigator || {};
    const session = (0, _sessionJs.makeSession)({
        release,
        environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, _sessionJs.updateSession)(currentSession, {
        status: "exited"
    });
    endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function endSession() {
    const isolationScope = (0, _hubJs.getIsolationScope)();
    const currentScope = getCurrentScope();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, _sessionJs.closeSession)(session);
    _sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function _sendSessionUpdate() {
    const isolationScope = (0, _hubJs.getIsolationScope)();
    const currentScope = getCurrentScope();
    const client = getClient();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function captureSession(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        endSession();
        return;
    }
    // only send the update
    _sendSessionUpdate();
}

},{"@sentry/utils":"5XfgR","./constants.js":"2PUCq","./debug-build.js":"h4qdv","./hub.js":"d9xVP","./session.js":"019j9","./utils/prepareEvent.js":"5y48Y","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5y48Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyDebugIds", ()=>applyDebugIds);
parcelHelpers.export(exports, "applyDebugMeta", ()=>applyDebugMeta);
parcelHelpers.export(exports, "parseEventHintOrCaptureContext", ()=>parseEventHintOrCaptureContext);
parcelHelpers.export(exports, "prepareEvent", ()=>prepareEvent);
var _utils = require("@sentry/utils");
var _constantsJs = require("../constants.js");
var _eventProcessorsJs = require("../eventProcessors.js");
var _scopeJs = require("../scope.js");
var _applyScopeDataToEventJs = require("./applyScopeDataToEvent.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, _utils.uuid4)(),
        timestamp: event.timestamp || (0, _utils.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    applyClientOptions(prepared, options);
    applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) applyDebugIds(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, _utils.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, _scopeJs.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, _applyScopeDataToEventJs.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, _eventProcessorsJs.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, _eventProcessorsJs.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        applyDebugMeta(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function applyClientOptions(event, options) {
    const { environment, release, dist, maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, _constantsJs.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, _utils.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, _utils.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, _utils.truncate)(request.url, maxValueLength);
}
const debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function applyDebugIds(event, stackParser) {
    const debugIdMap = (0, _utils.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function applyDebugMeta(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, _utils.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, _utils.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, _utils.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, _utils.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, _utils.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, _spanUtilsJs.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, _utils.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, _scopeJs.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function parseEventHintOrCaptureContext(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if (hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if (hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return hint instanceof (0, _scopeJs.Scope) || typeof hint === "function";
}
const captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>captureContextKeys.includes(key));
}

},{"@sentry/utils":"5XfgR","../constants.js":"2PUCq","../eventProcessors.js":"aLe4Y","../scope.js":"38Vhk","./applyScopeDataToEvent.js":"91PZM","./spanUtils.js":"jLzrc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jLzrc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACE_FLAG_NONE", ()=>TRACE_FLAG_NONE);
parcelHelpers.export(exports, "TRACE_FLAG_SAMPLED", ()=>TRACE_FLAG_SAMPLED);
parcelHelpers.export(exports, "spanIsSampled", ()=>spanIsSampled);
parcelHelpers.export(exports, "spanTimeInputToSeconds", ()=>spanTimeInputToSeconds);
parcelHelpers.export(exports, "spanToJSON", ()=>spanToJSON);
parcelHelpers.export(exports, "spanToTraceContext", ()=>spanToTraceContext);
parcelHelpers.export(exports, "spanToTraceHeader", ()=>spanToTraceHeader);
var _utils = require("@sentry/utils");
// These are aligned with OpenTelemetry trace flags
const TRACE_FLAG_NONE = 0x0;
const TRACE_FLAG_SAMPLED = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function spanToTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data, op, parent_span_id, status, tags, origin } = spanToJSON(span);
    return (0, _utils.dropUndefinedKeys)({
        data,
        op,
        parent_span_id,
        span_id,
        status,
        tags,
        trace_id,
        origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    const { traceId, spanId } = span.spanContext();
    const sampled = spanIsSampled(span);
    return (0, _utils.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === "number") return ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return ensureTimestampInSeconds(input.getTime());
    return (0, _utils.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function spanToJSON(span) {
    if (spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6BdAG":[function(require,module,exports) {
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRootSpan", ()=>getRootSpan);
function getRootSpan(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aWeoJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_VERSION", ()=>SDK_VERSION);
const SDK_VERSION = "7.120.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lei5h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerErrorInstrumentation", ()=>registerErrorInstrumentation);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _utilsJs = require("./utils.js");
let errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function registerErrorInstrumentation() {
    if (errorsInstrumented) return;
    errorsInstrumented = true;
    (0, _utils.addGlobalErrorInstrumentationHandler)(errorCallback);
    (0, _utils.addGlobalUnhandledRejectionInstrumentationHandler)(errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, _utilsJs.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = "sentry_tracingErrorCallback";

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","./utils.js":"eQe4H","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eQe4H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>(0, _utils.stripUrlQueryAndFragment));
parcelHelpers.export(exports, "extractTraceparentData", ()=>extractTraceparentData);
parcelHelpers.export(exports, "getActiveTransaction", ()=>getActiveTransaction);
var _utils = require("@sentry/utils");
var _hubJs = require("../hub.js");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, _hubJs.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const extractTraceparentData = (0, _utils.extractTraceparentData);

},{"@sentry/utils":"5XfgR","../hub.js":"d9xVP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fiVf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdleTransaction", ()=>IdleTransaction);
parcelHelpers.export(exports, "IdleTransactionSpanRecorder", ()=>IdleTransactionSpanRecorder);
parcelHelpers.export(exports, "TRACING_DEFAULTS", ()=>TRACING_DEFAULTS);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _spanJs = require("./span.js");
var _transactionJs = require("./transaction.js");
const TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const FINISH_REASON_TAG = "finishReason";
const IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class IdleTransactionSpanRecorder extends (0, _spanJs.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, _spanUtilsJs.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class IdleTransaction extends (0, _transactionJs.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = TRACING_DEFAULTS.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = TRACING_DEFAULTS.finalTimeout, _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute(FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, _debugBuildJs.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, _utils.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, _spanUtilsJs.spanToJSON)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, _spanUtilsJs.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, _debugBuildJs.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, _utils.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, _utils.logger).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] flushing IdleTransaction");
        } else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, _utils.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../utils/spanUtils.js":"jLzrc","./span.js":"iZ89M","./transaction.js":"dRdd1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iZ89M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Span", ()=>Span);
parcelHelpers.export(exports, "SpanRecorder", ()=>SpanRecorder);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _metricSummaryJs = require("../metrics/metric-summary.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _getRootSpanJs = require("../utils/getRootSpan.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _spanstatusJs = require("./spanstatus.js");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class SpanRecorder {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class Span {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, _utils.uuid4)();
        this._spanId = spanContext.spanId || (0, _utils.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, _utils.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || "manual",
            [(0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId,
            traceId,
            traceFlags: sampled ? (0, _spanUtilsJs.TRACE_FLAG_SAMPLED) : (0, _spanUtilsJs.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new Span({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, _getRootSpanJs.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, _debugBuildJs.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, _spanUtilsJs.spanToJSON)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, _utils.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, _spanstatusJs.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, _getRootSpanJs.getRootSpan)(this);
        if ((0, _debugBuildJs.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, _utils.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, _spanUtilsJs.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, _utils.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, _spanUtilsJs.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, _utils.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, _metricSummaryJs.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../metrics/metric-summary.js":"lyMY0","../semanticAttributes.js":"fh7tL","../utils/getRootSpan.js":"6BdAG","../utils/spanUtils.js":"jLzrc","./spanstatus.js":"cpbRr","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lyMY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMetricSummaryJsonForSpan", ()=>getMetricSummaryJsonForSpan);
parcelHelpers.export(exports, "updateMetricSummaryOnActiveSpan", ()=>updateMetricSummaryOnActiveSpan);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _errorsJs = require("../tracing/errors.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _traceJs = require("../tracing/trace.js");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let SPAN_METRIC_SUMMARY;
function getMetricStorageForSpan(span) {
    return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function getMetricSummaryJsonForSpan(span) {
    const storage = getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, _utils.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function updateMetricSummaryOnActiveSpan(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, _traceJs.getActiveSpan)();
    if (span) {
        const storage = getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags
            }
        ]);
        if (!SPAN_METRIC_SUMMARY) SPAN_METRIC_SUMMARY = new WeakMap();
        SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../tracing/errors.js":"lei5h","../tracing/spanstatus.js":"cpbRr","../tracing/trace.js":"kHZwE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cpbRr":[function(require,module,exports) {
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpanStatus", ()=>SpanStatus);
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", ()=>getSpanStatusFromHttpCode);
parcelHelpers.export(exports, "setHttpStatus", ()=>setHttpStatus);
parcelHelpers.export(exports, "spanStatusfromHttpCode", ()=>spanStatusfromHttpCode);
var SpanStatus;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})(SpanStatus || (SpanStatus = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const spanStatusfromHttpCode = getSpanStatusFromHttpCode;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kHZwE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "continueTrace", ()=>continueTrace);
parcelHelpers.export(exports, "getActiveSpan", ()=>getActiveSpan);
parcelHelpers.export(exports, "getCapturedScopesOnSpan", ()=>getCapturedScopesOnSpan);
parcelHelpers.export(exports, "startActiveSpan", ()=>startActiveSpan);
parcelHelpers.export(exports, "startInactiveSpan", ()=>startInactiveSpan);
parcelHelpers.export(exports, "startSpan", ()=>startSpan);
parcelHelpers.export(exports, "startSpanManual", ()=>startSpanManual);
parcelHelpers.export(exports, "trace", ()=>trace);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubJs = require("../hub.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _errorsJs = require("./errors.js");
var _spanstatusJs = require("./spanstatus.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _exportsJs = require("../exports.js");
var _handleCallbackErrorsJs = require("../utils/handleCallbackErrors.js");
var _hasTracingEnabledJs = require("../utils/hasTracingEnabled.js");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function trace(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, _hubJs.getCurrentHub)();
    const scope = (0, _exportsJs.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = normalizeContext(context);
    const activeSpan = createChildSpanOrTransaction(hub, {
        parentSpan,
        spanContext,
        forceTransaction: false,
        scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, _handleCallbackErrorsJs.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpan(context, callback) {
    const spanContext = normalizeContext(context);
    return (0, _hubJs.runWithAsyncContext)(()=>{
        return (0, _exportsJs.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, _hubJs.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan,
                spanContext,
                forceTransaction: context.forceTransaction,
                scope
            });
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status } = (0, _spanUtilsJs.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const startActiveSpan = startSpan;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpanManual(context, callback) {
    const spanContext = normalizeContext(context);
    return (0, _hubJs.runWithAsyncContext)(()=>{
        return (0, _exportsJs.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, _hubJs.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan,
                spanContext,
                forceTransaction: context.forceTransaction,
                scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status } = (0, _spanUtilsJs.spanToJSON)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startInactiveSpan(context) {
    if (!(0, _hasTracingEnabledJs.hasTracingEnabled)()) return undefined;
    const spanContext = normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, _hubJs.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : getActiveSpan();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, _exportsJs.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return createChildSpanOrTransaction(hub, {
        parentSpan,
        spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function getActiveSpan() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _exportsJs.getCurrentScope)().getSpan();
}
const continueTrace = ({ sentryTrace, baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, _exportsJs.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData, dynamicSamplingContext, propagationContext } = (0, _utils.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, _debugBuildJs.DEBUG_BUILD) && traceparentData) (0, _utils.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, _utils.dropUndefinedKeys)({
            dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, _hubJs.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan, spanContext, forceTransaction, scope }) {
    if (!(0, _hasTracingEnabledJs.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, _hubJs.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, _spanUtilsJs.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId,
            parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId, dsc, parentSpanId, sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId,
            parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, _spanUtilsJs.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, _utils.addNonEnumerableProperty)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, _utils.addNonEnumerableProperty)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function getCapturedScopesOnSpan(span) {
    return {
        scope: span[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../hub.js":"d9xVP","../utils/spanUtils.js":"jLzrc","./errors.js":"lei5h","./spanstatus.js":"cpbRr","./dynamicSamplingContext.js":"czMfo","../exports.js":"bQ1GW","../utils/handleCallbackErrors.js":"2v1xV","../utils/hasTracingEnabled.js":"kbYmo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2v1xV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleCallbackErrors", ()=>handleCallbackErrors);
var _utils = require("@sentry/utils");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function handleCallbackErrors(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, _utils.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kbYmo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasTracingEnabled", ()=>hasTracingEnabled);
var _exportsJs = require("../exports.js");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function hasTracingEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, _exportsJs.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

},{"../exports.js":"bQ1GW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fh7tL":[function(require,module,exports) {
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", ()=>SEMANTIC_ATTRIBUTE_PROFILE_ID);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", ()=>SEMANTIC_ATTRIBUTE_SENTRY_OP);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", ()=>SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", ()=>SEMANTIC_ATTRIBUTE_SENTRY_SOURCE);
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const SEMANTIC_ATTRIBUTE_PROFILE_ID = "profile_id";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dRdd1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transaction", ()=>Transaction);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubJs = require("../hub.js");
var _metricSummaryJs = require("../metrics/metric-summary.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _spanJs = require("./span.js");
var _traceJs = require("./trace.js");
/** JSDoc */ class Transaction extends (0, _spanJs.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, _hubJs.getCurrentHub)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, _spanJs.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value,
            unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, _utils.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, _spanUtilsJs.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, _spanUtilsJs.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, _traceJs.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, _spanUtilsJs.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope,
                capturedSpanIsolationScope,
                ...(0, _utils.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, _metricSummaryJs.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../hub.js":"d9xVP","../metrics/metric-summary.js":"lyMY0","../semanticAttributes.js":"fh7tL","../utils/spanUtils.js":"jLzrc","./dynamicSamplingContext.js":"czMfo","./span.js":"iZ89M","./trace.js":"kHZwE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"U72ua":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidSampleRate", ()=>isValidSampleRate);
parcelHelpers.export(exports, "sampleTransaction", ()=>sampleTransaction);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _hasTracingEnabledJs = require("../utils/hasTracingEnabled.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function sampleTransaction(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, _hasTracingEnabledJs.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, _debugBuildJs.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, _utils.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, _spanUtilsJs.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, _utils.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../semanticAttributes.js":"fh7tL","../utils/hasTracingEnabled.js":"kbYmo","../utils/spanUtils.js":"jLzrc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ljNB0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setMeasurement", ()=>setMeasurement);
var _utilsJs = require("./utils.js");
/**
 * Adds a measurement to the current active transaction.
 */ function setMeasurement(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, _utilsJs.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

},{"./utils.js":"eQe4H","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kpLGj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEventEnvelope", ()=>createEventEnvelope);
parcelHelpers.export(exports, "createSessionEnvelope", ()=>createSessionEnvelope);
var _utils = require("@sentry/utils");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function createSessionEnvelope(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, _utils.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, _utils.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, _utils.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, _utils.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, _utils.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, _utils.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4tJhc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionFlusher", ()=>SessionFlusher);
var _utils = require("@sentry/utils");
var _exportsJs = require("./exports.js");
/**
 * @inheritdoc
 */ class SessionFlusher {
    // Cast to any so that it can use Node.js timeout
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(client, attrs){
        this._client = client;
        this.flushTimeout = 60;
        this._pendingAggregates = {};
        this._isEnabled = true;
        // Call to setInterval, so that flush is called every 60 seconds.
        this._intervalId = setInterval(()=>this.flush(), this.flushTimeout * 1000);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (this._intervalId.unref) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._intervalId.unref();
        this._sessionAttrs = attrs;
    }
    /** Checks if `pendingAggregates` has entries, and if it does flushes them by calling `sendSession` */ flush() {
        const sessionAggregates = this.getSessionAggregates();
        if (sessionAggregates.aggregates.length === 0) return;
        this._pendingAggregates = {};
        this._client.sendSession(sessionAggregates);
    }
    /** Massages the entries in `pendingAggregates` and returns aggregated sessions */ getSessionAggregates() {
        const aggregates = Object.keys(this._pendingAggregates).map((key)=>{
            return this._pendingAggregates[parseInt(key)];
        });
        const sessionAggregates = {
            attrs: this._sessionAttrs,
            aggregates
        };
        return (0, _utils.dropUndefinedKeys)(sessionAggregates);
    }
    /** JSDoc */ close() {
        clearInterval(this._intervalId);
        this._isEnabled = false;
        this.flush();
    }
    /**
   * Wrapper function for _incrementSessionStatusCount that checks if the instance of SessionFlusher is enabled then
   * fetches the session status of the request from `Scope.getRequestSession().status` on the scope and passes them to
   * `_incrementSessionStatusCount` along with the start date
   */ incrementSessionStatusCount() {
        if (!this._isEnabled) return;
        const scope = (0, _exportsJs.getCurrentScope)();
        const requestSession = scope.getRequestSession();
        if (requestSession && requestSession.status) {
            this._incrementSessionStatusCount(requestSession.status, new Date());
            // This is not entirely necessarily but is added as a safe guard to indicate the bounds of a request and so in
            // case captureRequestSession is called more than once to prevent double count
            scope.setRequestSession(undefined);
        /* eslint-enable @typescript-eslint/no-unsafe-member-access */ }
    }
    /**
   * Increments status bucket in pendingAggregates buffer (internal state) corresponding to status of
   * the session received
   */ _incrementSessionStatusCount(status, date) {
        // Truncate minutes and seconds on Session Started attribute to have one minute bucket keys
        const sessionStartedTrunc = new Date(date).setSeconds(0, 0);
        this._pendingAggregates[sessionStartedTrunc] = this._pendingAggregates[sessionStartedTrunc] || {};
        // corresponds to aggregated sessions in one specific minute bucket
        // for example, {"started":"2021-03-16T08:00:00.000Z","exited":4, "errored": 1}
        const aggregationCounts = this._pendingAggregates[sessionStartedTrunc];
        if (!aggregationCounts.started) aggregationCounts.started = new Date(sessionStartedTrunc).toISOString();
        switch(status){
            case "errored":
                aggregationCounts.errored = (aggregationCounts.errored || 0) + 1;
                return aggregationCounts.errored;
            case "ok":
                aggregationCounts.exited = (aggregationCounts.exited || 0) + 1;
                return aggregationCounts.exited;
            default:
                aggregationCounts.crashed = (aggregationCounts.crashed || 0) + 1;
                return aggregationCounts.crashed;
        }
    }
}

},{"@sentry/utils":"5XfgR","./exports.js":"bQ1GW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"wYtlM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>getEnvelopeEndpointWithUrlEncodedAuth);
parcelHelpers.export(exports, "getReportDialogEndpoint", ()=>getReportDialogEndpoint);
var _utils = require("@sentry/utils");
const SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function _getIngestEndpoint(dsn) {
    return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function _encodedAuth(dsn, sdkInfo) {
    return (0, _utils.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function getEnvelopeEndpointWithUrlEncodedAuth(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn = (0, _utils.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, _utils.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Zre8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseClient", ()=>BaseClient);
parcelHelpers.export(exports, "addEventProcessor", ()=>addEventProcessor);
var _utils = require("@sentry/utils");
var _apiJs = require("./api.js");
var _debugBuildJs = require("./debug-build.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
var _integrationJs = require("./integration.js");
var _envelopeJs1 = require("./metrics/envelope.js");
var _sessionJs = require("./session.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class BaseClient {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, _utils.makeDsn)(options.dsn);
        else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, _utils.checkOrSetAlreadyCaught)(exception)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, _utils.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, _utils.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, _utils.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, _sessionJs.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, _utils.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, _integrationJs.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, _integrationJs.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, _envelopeJs.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, _utils.addItemToEnvelope)(env, (0, _utils.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, _envelopeJs.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, _envelopeJs1.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations } = this._options;
        this._integrations = (0, _integrationJs.setupIntegrations)(this, integrations);
        (0, _integrationJs.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, _sessionJs.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, _utils.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, _hubJs.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, _prepareEventJs.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, _debugBuildJs.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, _utils.logger).log(sentryError.message);
                else (0, _utils.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate } = options;
        const isTransaction = isTransactionEvent(event);
        const isError = isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, _utils.rejectedSyncPromise)(new (0, _utils.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, _utils.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = processBeforeSend(options, prepared, hint);
            return _validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, _utils.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, _utils.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, _utils.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Error while sending event:", reason);
        });
        else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason,
                category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, _utils.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, _utils.isPlainObject)(event) && event !== null) throw new (0, _utils.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, _utils.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, _utils.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, _utils.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function processBeforeSend(options, event, hint) {
    const { beforeSend, beforeSendTransaction } = options;
    if (isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if (isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function isErrorEvent(event) {
    return event.type === undefined;
}
function isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function addEventProcessor(callback) {
    const client = (0, _exportsJs.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

},{"@sentry/utils":"5XfgR","./api.js":"wYtlM","./debug-build.js":"h4qdv","./envelope.js":"kpLGj","./exports.js":"bQ1GW","./hub.js":"d9xVP","./integration.js":"d8HWn","./metrics/envelope.js":"7R4Ld","./session.js":"019j9","./tracing/dynamicSamplingContext.js":"czMfo","./utils/prepareEvent.js":"5y48Y","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d8HWn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addIntegration", ()=>addIntegration);
parcelHelpers.export(exports, "afterSetupIntegrations", ()=>afterSetupIntegrations);
parcelHelpers.export(exports, "convertIntegrationFnToClass", ()=>convertIntegrationFnToClass);
parcelHelpers.export(exports, "defineIntegration", ()=>defineIntegration);
parcelHelpers.export(exports, "getIntegrationsToSetup", ()=>getIntegrationsToSetup);
parcelHelpers.export(exports, "installedIntegrations", ()=>installedIntegrations);
parcelHelpers.export(exports, "setupIntegration", ()=>setupIntegration);
parcelHelpers.export(exports, "setupIntegrations", ()=>setupIntegrations);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
const installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, _utils.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (installedIntegrations.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, _eventProcessorsJs.addGlobalEventProcessor), (0, _hubJs.getCurrentHub));
        installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function addIntegration(integration) {
    const client = (0, _exportsJs.getClient)();
    if (!client || !client.addIntegration) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function convertIntegrationFnToClass(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function defineIntegration(fn) {
    return fn;
}

},{"@sentry/utils":"5XfgR","./debug-build.js":"h4qdv","./eventProcessors.js":"aLe4Y","./exports.js":"bQ1GW","./hub.js":"d9xVP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7R4Ld":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMetricEnvelope", ()=>createMetricEnvelope);
var _utils = require("@sentry/utils");
var _utilsJs = require("./utils.js");
/**
 * Create envelope from a metric aggregate.
 */ function createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, _utils.dsnToString)(dsn);
    const item = createMetricEnvelopeItem(metricBucketItems);
    return (0, _utils.createEnvelope)(headers, [
        item
    ]);
}
function createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, _utilsJs.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

},{"@sentry/utils":"5XfgR","./utils.js":"Qh9vi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"Qh9vi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBucketKey", ()=>getBucketKey);
parcelHelpers.export(exports, "sanitizeMetricKey", ()=>sanitizeMetricKey);
parcelHelpers.export(exports, "sanitizeTags", ()=>sanitizeTags);
parcelHelpers.export(exports, "sanitizeUnit", ()=>sanitizeUnit);
parcelHelpers.export(exports, "serializeMetricBuckets", ()=>serializeMetricBuckets);
parcelHelpers.export(exports, "simpleHash", ()=>simpleHash);
var _utils = require("@sentry/utils");
/**
 * Generate bucket key from metric properties.
 */ function getBucketKey(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, _utils.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function simpleHash(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function serializeMetricBuckets(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function sanitizeUnit(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function sanitizeMetricKey(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function getCharOrReplacement(input) {
    for (const [search, replacement] of tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function sanitizeTags(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = sanitizeTagKey(key);
        tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lR4Al":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerRuntimeClient", ()=>ServerRuntimeClient);
var _utils = require("@sentry/utils");
var _baseclientJs = require("./baseclient.js");
var _checkinJs = require("./checkin.js");
var _debugBuildJs = require("./debug-build.js");
var _exportsJs = require("./exports.js");
var _aggregatorJs = require("./metrics/aggregator.js");
var _sessionflusherJs = require("./sessionflusher.js");
var _hubextensionsJs = require("./tracing/hubextensions.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _getRootSpanJs = require("./utils/getRootSpan.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
/**
 * The Sentry Server Runtime Client SDK.
 */ class ServerRuntimeClient extends (0, _baseclientJs.BaseClient) {
    /**
   * Creates a new Edge SDK instance.
   * @param options Configuration options for this SDK.
   */ constructor(options){
        // Server clients always support tracing
        (0, _hubextensionsJs.addTracingExtensions)();
        super(options);
        if (options._experiments && options._experiments["metricsAggregator"]) this.metricsAggregator = new (0, _aggregatorJs.MetricsAggregator)(this);
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, _utils.resolvedSyncPromise)((0, _utils.eventFromUnknownInput)((0, _exportsJs.getClient)(), this._options.stackParser, exception, hint));
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, _utils.resolvedSyncPromise)((0, _utils.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace));
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // Check if the flag `autoSessionTracking` is enabled, and if `_sessionFlusher` exists because it is initialised only
        // when the `requestHandler` middleware is used, and hence the expectation is to have SessionAggregates payload
        // sent to the Server only when the `requestHandler` middleware is used
        if (this._options.autoSessionTracking && this._sessionFlusher && scope) {
            const requestSession = scope.getRequestSession();
            // Necessary checks to ensure this is code block is executed only within a request
            // Should override the status only if `requestSession.status` is `Ok`, which is its initial stage
            if (requestSession && requestSession.status === "ok") requestSession.status = "errored";
        }
        return super.captureException(exception, hint, scope);
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // Check if the flag `autoSessionTracking` is enabled, and if `_sessionFlusher` exists because it is initialised only
        // when the `requestHandler` middleware is used, and hence the expectation is to have SessionAggregates payload
        // sent to the Server only when the `requestHandler` middleware is used
        if (this._options.autoSessionTracking && this._sessionFlusher && scope) {
            const eventType = event.type || "exception";
            const isException = eventType === "exception" && event.exception && event.exception.values && event.exception.values.length > 0;
            // If the event is of type Exception, then a request session should be captured
            if (isException) {
                const requestSession = scope.getRequestSession();
                // Ensure that this is happening within the bounds of a request, and make sure not to override
                // Session Status if Errored / Crashed
                if (requestSession && requestSession.status === "ok") requestSession.status = "errored";
            }
        }
        return super.captureEvent(event, hint, scope);
    }
    /**
   *
   * @inheritdoc
   */ close(timeout) {
        if (this._sessionFlusher) this._sessionFlusher.close();
        return super.close(timeout);
    }
    /** Method that initialises an instance of SessionFlusher on Client */ initSessionFlusher() {
        const { release, environment } = this._options;
        if (!release) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Cannot initialise an instance of SessionFlusher if no release is provided!");
        else this._sessionFlusher = new (0, _sessionflusherJs.SessionFlusher)(this, {
            release,
            environment
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   */ captureCheckIn(checkIn, monitorConfig, scope) {
        const id = "checkInId" in checkIn && checkIn.checkInId ? checkIn.checkInId : (0, _utils.uuid4)();
        if (!this._isEnabled()) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("SDK not enabled, will not capture checkin.");
            return id;
        }
        const options = this.getOptions();
        const { release, environment, tunnel } = options;
        const serializedCheckIn = {
            check_in_id: id,
            monitor_slug: checkIn.monitorSlug,
            status: checkIn.status,
            release,
            environment
        };
        if ("duration" in checkIn) serializedCheckIn.duration = checkIn.duration;
        if (monitorConfig) serializedCheckIn.monitor_config = {
            schedule: monitorConfig.schedule,
            checkin_margin: monitorConfig.checkinMargin,
            max_runtime: monitorConfig.maxRuntime,
            timezone: monitorConfig.timezone
        };
        const [dynamicSamplingContext, traceContext] = this._getTraceInfoFromScope(scope);
        if (traceContext) serializedCheckIn.contexts = {
            trace: traceContext
        };
        const envelope = (0, _checkinJs.createCheckInEnvelope)(serializedCheckIn, dynamicSamplingContext, this.getSdkMetadata(), tunnel, this.getDsn());
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).info("Sending checkin:", checkIn.monitorSlug, checkIn.status);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
        return id;
    }
    /**
   * Method responsible for capturing/ending a request session by calling `incrementSessionStatusCount` to increment
   * appropriate session aggregates bucket
   */ _captureRequestSession() {
        if (!this._sessionFlusher) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Discarded request mode session because autoSessionTracking option was disabled");
        else this._sessionFlusher.incrementSessionStatusCount();
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope, isolationScope) {
        if (this._options.platform) event.platform = event.platform || this._options.platform;
        if (this._options.runtime) event.contexts = {
            ...event.contexts,
            runtime: (event.contexts || {}).runtime || this._options.runtime
        };
        if (this._options.serverName) event.server_name = event.server_name || this._options.serverName;
        return super._prepareEvent(event, hint, scope, isolationScope);
    }
    /** Extract trace information from scope */ _getTraceInfoFromScope(scope) {
        if (!scope) return [
            undefined,
            undefined
        ];
        // eslint-disable-next-line deprecation/deprecation
        const span = scope.getSpan();
        if (span) {
            const samplingContext = (0, _getRootSpanJs.getRootSpan)(span) ? (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span) : undefined;
            return [
                samplingContext,
                (0, _spanUtilsJs.spanToTraceContext)(span)
            ];
        }
        const { traceId, spanId, parentSpanId, dsc } = scope.getPropagationContext();
        const traceContext = {
            trace_id: traceId,
            span_id: spanId,
            parent_span_id: parentSpanId
        };
        if (dsc) return [
            dsc,
            traceContext
        ];
        return [
            (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient)(traceId, this, scope),
            traceContext
        ];
    }
}

},{"@sentry/utils":"5XfgR","./baseclient.js":"8Zre8","./checkin.js":"1xKwa","./debug-build.js":"h4qdv","./exports.js":"bQ1GW","./metrics/aggregator.js":"eR1ZI","./sessionflusher.js":"4tJhc","./tracing/hubextensions.js":"erreh","./utils/spanUtils.js":"jLzrc","./utils/getRootSpan.js":"6BdAG","./tracing/spanstatus.js":"cpbRr","./tracing/dynamicSamplingContext.js":"czMfo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1xKwa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCheckInEnvelope", ()=>createCheckInEnvelope);
var _utils = require("@sentry/utils");
/**
 * Create envelope from check in item.
 */ function createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, _utils.dsnToString)(dsn);
    if (dynamicSamplingContext) headers.trace = (0, _utils.dropUndefinedKeys)(dynamicSamplingContext);
    const item = createCheckInEnvelopeItem(checkIn);
    return (0, _utils.createEnvelope)(headers, [
        item
    ]);
}
function createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: "check_in"
    };
    return [
        checkInHeaders,
        checkIn
    ];
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eR1ZI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsAggregator", ()=>MetricsAggregator);
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _instanceJs = require("./instance.js");
var _metricSummaryJs = require("./metric-summary.js");
var _utilsJs = require("./utils.js");
/**
 * A metrics aggregator that aggregates metrics in memory and flushes them periodically.
 */ class MetricsAggregator {
    // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
    // when the aggregator is garbage collected.
    // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
    // Different metrics have different weights. We use this to limit the number of metrics
    // that we store in memory.
    // Cast to any so that it can use Node.js timeout
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // SDKs are required to shift the flush interval by random() * rollup_in_seconds.
    // That shift is determined once per startup to create jittering.
    // An SDK is required to perform force flushing ahead of scheduled time if the memory
    // pressure is too high. There is no rule for this other than that SDKs should be tracking
    // abstract aggregation complexity (eg: a counter only carries a single float, whereas a
    // distribution is a float per emission).
    //
    // Force flush is used on either shutdown, flush() or when we exceed the max weight.
    constructor(_client){
        this._client = _client;
        this._buckets = new Map();
        this._bucketsTotalWeight = 0;
        this._interval = setInterval(()=>this._flush(), (0, _constantsJs.DEFAULT_FLUSH_INTERVAL));
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (this._interval.unref) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._interval.unref();
        this._flushShift = Math.floor(Math.random() * (0, _constantsJs.DEFAULT_FLUSH_INTERVAL) / 1000);
        this._forceFlush = false;
    }
    /**
   * @inheritDoc
   */ add(metricType, unsanitizedName, value, unsanitizedUnit = "none", unsanitizedTags = {}, maybeFloatTimestamp = (0, _utils.timestampInSeconds)()) {
        const timestamp = Math.floor(maybeFloatTimestamp);
        const name = (0, _utilsJs.sanitizeMetricKey)(unsanitizedName);
        const tags = (0, _utilsJs.sanitizeTags)(unsanitizedTags);
        const unit = (0, _utilsJs.sanitizeUnit)(unsanitizedUnit);
        const bucketKey = (0, _utilsJs.getBucketKey)(metricType, name, unit, tags);
        let bucketItem = this._buckets.get(bucketKey);
        // If this is a set metric, we need to calculate the delta from the previous weight.
        const previousWeight = bucketItem && metricType === (0, _constantsJs.SET_METRIC_TYPE) ? bucketItem.metric.weight : 0;
        if (bucketItem) {
            bucketItem.metric.add(value);
            // TODO(abhi): Do we need this check?
            if (bucketItem.timestamp < timestamp) bucketItem.timestamp = timestamp;
        } else {
            bucketItem = {
                // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                metric: new (0, _instanceJs.METRIC_MAP)[metricType](value),
                timestamp,
                metricType,
                name,
                unit,
                tags
            };
            this._buckets.set(bucketKey, bucketItem);
        }
        // If value is a string, it's a set metric so calculate the delta from the previous weight.
        const val = typeof value === "string" ? bucketItem.metric.weight - previousWeight : value;
        (0, _metricSummaryJs.updateMetricSummaryOnActiveSpan)(metricType, name, val, unit, unsanitizedTags, bucketKey);
        // We need to keep track of the total weight of the buckets so that we can
        // flush them when we exceed the max weight.
        this._bucketsTotalWeight += bucketItem.metric.weight;
        if (this._bucketsTotalWeight >= (0, _constantsJs.MAX_WEIGHT)) this.flush();
    }
    /**
   * Flushes the current metrics to the transport via the transport.
   */ flush() {
        this._forceFlush = true;
        this._flush();
    }
    /**
   * Shuts down metrics aggregator and clears all metrics.
   */ close() {
        this._forceFlush = true;
        clearInterval(this._interval);
        this._flush();
    }
    /**
   * Flushes the buckets according to the internal state of the aggregator.
   * If it is a force flush, which happens on shutdown, it will flush all buckets.
   * Otherwise, it will only flush buckets that are older than the flush interval,
   * and according to the flush shift.
   *
   * This function mutates `_forceFlush` and `_bucketsTotalWeight` properties.
   */ _flush() {
        // TODO(@anonrig): Add Atomics for locking to avoid having force flush and regular flush
        // running at the same time.
        // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Atomics
        // This path eliminates the need for checking for timestamps since we're forcing a flush.
        // Remember to reset the flag, or it will always flush all metrics.
        if (this._forceFlush) {
            this._forceFlush = false;
            this._bucketsTotalWeight = 0;
            this._captureMetrics(this._buckets);
            this._buckets.clear();
            return;
        }
        const cutoffSeconds = Math.floor((0, _utils.timestampInSeconds)()) - (0, _constantsJs.DEFAULT_FLUSH_INTERVAL) / 1000 - this._flushShift;
        // TODO(@anonrig): Optimization opportunity.
        // Convert this map to an array and store key in the bucketItem.
        const flushedBuckets = new Map();
        for (const [key, bucket] of this._buckets)if (bucket.timestamp <= cutoffSeconds) {
            flushedBuckets.set(key, bucket);
            this._bucketsTotalWeight -= bucket.metric.weight;
        }
        for (const [key] of flushedBuckets)this._buckets.delete(key);
        this._captureMetrics(flushedBuckets);
    }
    /**
   * Only captures a subset of the buckets passed to this function.
   * @param flushedBuckets
   */ _captureMetrics(flushedBuckets) {
        if (flushedBuckets.size > 0 && this._client.captureAggregateMetrics) {
            // TODO(@anonrig): Optimization opportunity.
            // This copy operation can be avoided if we store the key in the bucketItem.
            const buckets = Array.from(flushedBuckets).map(([, bucketItem])=>bucketItem);
            this._client.captureAggregateMetrics(buckets);
        }
    }
}

},{"@sentry/utils":"5XfgR","./constants.js":"eaU1U","./instance.js":"jfFac","./metric-summary.js":"lyMY0","./utils.js":"Qh9vi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eaU1U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COUNTER_METRIC_TYPE", ()=>COUNTER_METRIC_TYPE);
parcelHelpers.export(exports, "DEFAULT_BROWSER_FLUSH_INTERVAL", ()=>DEFAULT_BROWSER_FLUSH_INTERVAL);
parcelHelpers.export(exports, "DEFAULT_FLUSH_INTERVAL", ()=>DEFAULT_FLUSH_INTERVAL);
parcelHelpers.export(exports, "DISTRIBUTION_METRIC_TYPE", ()=>DISTRIBUTION_METRIC_TYPE);
parcelHelpers.export(exports, "GAUGE_METRIC_TYPE", ()=>GAUGE_METRIC_TYPE);
parcelHelpers.export(exports, "MAX_WEIGHT", ()=>MAX_WEIGHT);
parcelHelpers.export(exports, "SET_METRIC_TYPE", ()=>SET_METRIC_TYPE);
const COUNTER_METRIC_TYPE = "c";
const GAUGE_METRIC_TYPE = "g";
const SET_METRIC_TYPE = "s";
const DISTRIBUTION_METRIC_TYPE = "d";
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const DEFAULT_BROWSER_FLUSH_INTERVAL = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const DEFAULT_FLUSH_INTERVAL = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const MAX_WEIGHT = 10000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jfFac":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CounterMetric", ()=>CounterMetric);
parcelHelpers.export(exports, "DistributionMetric", ()=>DistributionMetric);
parcelHelpers.export(exports, "GaugeMetric", ()=>GaugeMetric);
parcelHelpers.export(exports, "METRIC_MAP", ()=>METRIC_MAP);
parcelHelpers.export(exports, "SetMetric", ()=>SetMetric);
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
/**
 * A metric instance representing a counter.
 */ class CounterMetric {
    constructor(_value){
        this._value = _value;
    }
    /** @inheritDoc */ get weight() {
        return 1;
    }
    /** @inheritdoc */ add(value) {
        this._value += value;
    }
    /** @inheritdoc */ toString() {
        return `${this._value}`;
    }
}
/**
 * A metric instance representing a gauge.
 */ class GaugeMetric {
    constructor(value){
        this._last = value;
        this._min = value;
        this._max = value;
        this._sum = value;
        this._count = 1;
    }
    /** @inheritDoc */ get weight() {
        return 5;
    }
    /** @inheritdoc */ add(value) {
        this._last = value;
        if (value < this._min) this._min = value;
        if (value > this._max) this._max = value;
        this._sum += value;
        this._count++;
    }
    /** @inheritdoc */ toString() {
        return `${this._last}:${this._min}:${this._max}:${this._sum}:${this._count}`;
    }
}
/**
 * A metric instance representing a distribution.
 */ class DistributionMetric {
    constructor(first){
        this._value = [
            first
        ];
    }
    /** @inheritDoc */ get weight() {
        return this._value.length;
    }
    /** @inheritdoc */ add(value) {
        this._value.push(value);
    }
    /** @inheritdoc */ toString() {
        return this._value.join(":");
    }
}
/**
 * A metric instance representing a set.
 */ class SetMetric {
    constructor(first){
        this.first = first;
        this._value = new Set([
            first
        ]);
    }
    /** @inheritDoc */ get weight() {
        return this._value.size;
    }
    /** @inheritdoc */ add(value) {
        this._value.add(value);
    }
    /** @inheritdoc */ toString() {
        return Array.from(this._value).map((val)=>typeof val === "string" ? (0, _utilsJs.simpleHash)(val) : val).join(":");
    }
}
const METRIC_MAP = {
    [(0, _constantsJs.COUNTER_METRIC_TYPE)]: CounterMetric,
    [(0, _constantsJs.GAUGE_METRIC_TYPE)]: GaugeMetric,
    [(0, _constantsJs.DISTRIBUTION_METRIC_TYPE)]: DistributionMetric,
    [(0, _constantsJs.SET_METRIC_TYPE)]: SetMetric
};

},{"./constants.js":"eaU1U","./utils.js":"Qh9vi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"A9twl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAndBind", ()=>initAndBind);
parcelHelpers.export(exports, "setCurrentClient", ()=>setCurrentClient);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, _utils.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, _exportsJs.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    setCurrentClient(client);
    initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function setCurrentClient(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, _hubJs.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

},{"@sentry/utils":"5XfgR","./debug-build.js":"h4qdv","./exports.js":"bQ1GW","./hub.js":"d9xVP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eBo3y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_TRANSPORT_BUFFER_SIZE", ()=>DEFAULT_TRANSPORT_BUFFER_SIZE);
parcelHelpers.export(exports, "createTransport", ()=>createTransport);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function createTransport(options, makeRequest, buffer = (0, _utils.makePromiseBuffer)(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, _utils.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, _utils.envelopeItemTypeToDataCategory)(type);
            if ((0, _utils.isRateLimited)(rateLimits, dataCategory)) {
                const event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, _utils.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, _utils.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, _utils.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, _utils.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, _utils.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, _utils.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, _utils.SentryError)) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, _utils.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send,
        flush
    };
}
function getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kNJDm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MIN_DELAY", ()=>MIN_DELAY);
parcelHelpers.export(exports, "START_DELAY", ()=>START_DELAY);
parcelHelpers.export(exports, "makeOfflineTransport", ()=>makeOfflineTransport);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
const MIN_DELAY = 100; // 100 ms
const START_DELAY = 5000; // 5 seconds
const MAX_DELAY = 3.6e6; // 1 hour
function log(msg, error) {
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).info(`[Offline]: ${msg}`, error);
}
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function makeOfflineTransport(createTransport) {
    return (options)=>{
        const transport = createTransport(options);
        const store = options.createStore ? options.createStore(options) : undefined;
        let retryDelay = START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We don't queue Session Replay envelopes because they are:
            // - Ordered and Replay relies on the response status to know when they're successfully sent.
            // - Likely to fill the queue quickly and block other events from being sent.
            // We also want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, _utils.envelopeContainsItemType)(env, [
                "replay_event",
                "replay_recording",
                "client_report"
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (!store) return;
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.pop();
                if (found) {
                    log("Attempting to send previously queued event");
                    send(found).catch((e)=>{
                        log("Failed to retry sending", e);
                    });
                }
            }, delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== "number" && flushTimer.unref) flushTimer.unref();
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
        }
        async function send(envelope) {
            try {
                const result = await transport.send(envelope);
                let delay = MIN_DELAY;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers && result.headers["retry-after"]) delay = (0, _utils.parseRetryAfterHeader)(result.headers["retry-after"]);
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = START_DELAY;
                return result;
            } catch (e) {
                if (store && await shouldQueue(envelope, e, retryDelay)) {
                    await store.insert(envelope);
                    flushWithBackOff();
                    log("Error sending. Event queued", e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send,
            flush: (t)=>transport.flush(t)
        };
    };
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gnY7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromEnvelope", ()=>eventFromEnvelope);
parcelHelpers.export(exports, "makeMultiplexedTransport", ()=>makeMultiplexedTransport);
var _utils = require("@sentry/utils");
var _apiJs = require("../api.js");
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function eventFromEnvelope(env, types) {
    let event;
    (0, _utils.forEachEnvelopeItem)(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = eventFromEnvelope(envelope, [
                    "event",
                    "transaction",
                    "profile",
                    "replay_event"
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function overrideDsn(envelope, dsn) {
    return (0, _utils.createEnvelope)(dsn ? {
        ...envelope[0],
        dsn
    } : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn}:${release}` : dsn;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = (0, _utils.dsnFromString)(dsn);
                if (!validatedDsn) return undefined;
                const url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(validatedDsn, options.tunnel);
                transport = release ? makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url
                }) : createTransport({
                    ...options,
                    url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types && types.length ? types : [
                    "event"
                ];
                return eventFromEnvelope(envelope, eventTypes);
            }
            const transports = matcher({
                envelope,
                getEvent
            }).map((result)=>{
                if (typeof result === "string") return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            if (transports.length === 0) // Don't override the DSN in the header for the fallback transport. '' is falsy
            transports.push([
                "",
                fallbackTransport
            ]);
            const results = await Promise.all(transports.map(([dsn, transport])=>transport.send(overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const promises = [
                await fallbackTransport.flush(timeout)
            ];
            for (const [, transport] of otherTransports)promises.push(await transport.flush(timeout));
            return promises.every((r)=>r);
        }
        return {
            send,
            flush
        };
    };
}

},{"@sentry/utils":"5XfgR","../api.js":"wYtlM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9kPSz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSpanEnvelope", ()=>createSpanEnvelope);
var _utils = require("@sentry/utils");
/**
 * Create envelope from Span item.
 */ function createSpanEnvelope(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, _utils.dsnToString)(dsn);
    const items = spans.map(createSpanItem);
    return (0, _utils.createEnvelope)(headers, items);
}
function createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"avSaB":[function(require,module,exports) {
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSentryRequestUrl", ()=>isSentryRequestUrl);
function isSentryRequestUrl(url, hubOrClient) {
    const client = hubOrClient && isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dVtlQ":[function(require,module,exports) {
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parameterize", ()=>parameterize);
function parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join("\0").replace(/%/g, "%%").replace(/\0/g, "%s");
    formatted.__sentry_template_values__ = values;
    return formatted;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dbSgw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applySdkMetadata", ()=>applySdkMetadata);
var _versionJs = require("../version.js");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function applySdkMetadata(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, _versionJs.SDK_VERSION)
            })),
        version: (0, _versionJs.SDK_VERSION)
    };
    options._metadata = metadata;
}

},{"../version.js":"aWeoJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d2Dlh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModuleMetadata", ()=>ModuleMetadata);
parcelHelpers.export(exports, "moduleMetadataIntegration", ()=>moduleMetadataIntegration);
var _utils = require("@sentry/utils");
var _integrationJs = require("../integration.js");
var _metadataJs = require("../metadata.js");
const INTEGRATION_NAME = "ModuleMetadata";
const _moduleMetadataIntegration = ()=>{
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (typeof client.on !== "function") return;
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on("beforeEnvelope", (envelope)=>{
                (0, _utils.forEachEnvelopeItem)(envelope, (item, type)=>{
                    if (type === "event") {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, _metadataJs.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
        },
        processEvent (event, _hint, client) {
            const stackParser = client.getOptions().stackParser;
            (0, _metadataJs.addMetadataToStackFrames)(stackParser, event);
            return event;
        }
    };
};
const moduleMetadataIntegration = (0, _integrationJs.defineIntegration)(_moduleMetadataIntegration);
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const ModuleMetadata = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, moduleMetadataIntegration);

},{"@sentry/utils":"5XfgR","../integration.js":"d8HWn","../metadata.js":"jqIsi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jqIsi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addMetadataToStackFrames", ()=>addMetadataToStackFrames);
parcelHelpers.export(exports, "getMetadataForUrl", ()=>getMetadataForUrl);
parcelHelpers.export(exports, "stripMetadataFromStackFrames", ()=>stripMetadataFromStackFrames);
var _utils = require("@sentry/utils");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const parsedStacks = new Set();
function ensureMetadataStacksAreParsed(parser) {
    if (!(0, _utils.GLOBAL_OBJ)._sentryModuleMetadata) return;
    for (const stack of Object.keys((0, _utils.GLOBAL_OBJ)._sentryModuleMetadata)){
        const metadata = (0, _utils.GLOBAL_OBJ)._sentryModuleMetadata[stack];
        if (parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser, filename) {
    ensureMetadataStacksAreParsed(parser);
    return filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function addMetadataToStackFrames(parser, event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || []){
                if (!frame.filename) continue;
                const metadata = getMetadataForUrl(parser, frame.filename);
                if (metadata) frame.module_metadata = metadata;
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Strips metadata from stack frames.
 */ function stripMetadataFromStackFrames(event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            if (!exception.stacktrace) return;
            for (const frame of exception.stacktrace.frames || [])delete frame.module_metadata;
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bgvc0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestData", ()=>RequestData);
parcelHelpers.export(exports, "requestDataIntegration", ()=>requestDataIntegration);
var _utils = require("@sentry/utils");
var _integrationJs = require("../integration.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
const DEFAULT_OPTIONS = {
    include: {
        cookies: true,
        data: true,
        headers: true,
        ip: false,
        query_string: true,
        url: true,
        user: {
            id: true,
            username: true,
            email: true
        }
    },
    transactionNamingScheme: "methodPath"
};
const INTEGRATION_NAME = "RequestData";
const _requestDataIntegration = (options = {})=>{
    const _addRequestData = (0, _utils.addRequestDataToEvent);
    const _options = {
        ...DEFAULT_OPTIONS,
        ...options,
        include: {
            // @ts-expect-error It's mad because `method` isn't a known `include` key. (It's only here and not set by default in
            // `addRequestDataToEvent` for legacy reasons. TODO (v8): Change that.)
            method: true,
            ...DEFAULT_OPTIONS.include,
            ...options.include,
            user: options.include && typeof options.include.user === "boolean" ? options.include.user : {
                ...DEFAULT_OPTIONS.include.user,
                // Unclear why TS still thinks `options.include.user` could be a boolean at this point
                ...(options.include || {}).user
            }
        }
    };
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            // Note: In the long run, most of the logic here should probably move into the request data utility functions. For
            // the moment it lives here, though, until https://github.com/getsentry/sentry-javascript/issues/5718 is addressed.
            // (TL;DR: Those functions touch many parts of the repo in many different ways, and need to be clened up. Once
            // that's happened, it will be easier to add this logic in without worrying about unexpected side effects.)
            const { transactionNamingScheme } = _options;
            const { sdkProcessingMetadata = {} } = event;
            const req = sdkProcessingMetadata.request;
            if (!req) return event;
            // The Express request handler takes a similar `include` option to that which can be passed to this integration.
            // If passed there, we store it in `sdkProcessingMetadata`. TODO(v8): Force express and GCP people to use this
            // integration, so that all of this passing and conversion isn't necessary
            const addRequestDataOptions = sdkProcessingMetadata.requestDataOptionsFromExpressHandler || sdkProcessingMetadata.requestDataOptionsFromGCPWrapper || convertReqDataIntegrationOptsToAddReqDataOpts(_options);
            const processedEvent = _addRequestData(event, req, addRequestDataOptions);
            // Transaction events already have the right `transaction` value
            if (event.type === "transaction" || transactionNamingScheme === "handler") return processedEvent;
            // In all other cases, use the request's associated transaction (if any) to overwrite the event's `transaction`
            // value with a high-quality one
            const reqWithTransaction = req;
            const transaction = reqWithTransaction._sentryTransaction;
            if (transaction) {
                const name = (0, _spanUtilsJs.spanToJSON)(transaction).description || "";
                // TODO (v8): Remove the nextjs check and just base it on `transactionNamingScheme` for all SDKs. (We have to
                // keep it the way it is for the moment, because changing the names of transactions in Sentry has the potential
                // to break things like alert rules.)
                const shouldIncludeMethodInTransactionName = getSDKName(client) === "sentry.javascript.nextjs" ? name.startsWith("/api") : transactionNamingScheme !== "path";
                const [transactionValue] = (0, _utils.extractPathForTransaction)(req, {
                    path: true,
                    method: shouldIncludeMethodInTransactionName,
                    customRoute: name
                });
                processedEvent.transaction = transactionValue;
            }
            return processedEvent;
        }
    };
};
const requestDataIntegration = (0, _integrationJs.defineIntegration)(_requestDataIntegration);
/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/integrations`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 * @deprecated Use `requestDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const RequestData = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, requestDataIntegration);
/** Convert this integration's options to match what `addRequestDataToEvent` expects */ /** TODO: Can possibly be deleted once https://github.com/getsentry/sentry-javascript/issues/5718 is fixed */ function convertReqDataIntegrationOptsToAddReqDataOpts(integrationOptions) {
    const { transactionNamingScheme, include: { ip, user, ...requestOptions } } = integrationOptions;
    const requestIncludeKeys = [];
    for (const [key, value] of Object.entries(requestOptions))if (value) requestIncludeKeys.push(key);
    let addReqDataUserOpt;
    if (user === undefined) addReqDataUserOpt = true;
    else if (typeof user === "boolean") addReqDataUserOpt = user;
    else {
        const userIncludeKeys = [];
        for (const [key, value] of Object.entries(user))if (value) userIncludeKeys.push(key);
        addReqDataUserOpt = userIncludeKeys;
    }
    return {
        include: {
            ip,
            user: addReqDataUserOpt,
            request: requestIncludeKeys.length !== 0 ? requestIncludeKeys : undefined,
            transaction: transactionNamingScheme
        }
    };
}
function getSDKName(client) {
    try {
        // For a long chain like this, it's fewer bytes to combine a try-catch with assuming everything is there than to
        // write out a long chain of `a && a.b && a.b.c && ...`
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return client.getOptions()._metadata.sdk.name;
    } catch (err) {
        // In theory we should never get here
        return undefined;
    }
}

},{"@sentry/utils":"5XfgR","../integration.js":"d8HWn","../utils/spanUtils.js":"jLzrc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7fRSe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboundFilters", ()=>InboundFilters);
parcelHelpers.export(exports, "inboundFiltersIntegration", ()=>inboundFiltersIntegration);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const INTEGRATION_NAME = "InboundFilters";
const _inboundFiltersIntegration = (options = {})=>{
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = _mergeOptions(options, clientOptions);
            return _shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const inboundFiltersIntegration = (0, _integrationJs.defineIntegration)(_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const InboundFilters = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, inboundFiltersIntegration);
function _mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, _utils.getEventDescription)(event)}`);
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}`);
        return true;
    }
    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}`);
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return _getPossibleEventMessages(event).some((message)=>(0, _utils.stringMatchesSomePattern)(message, ignoreErrors));
}
function _isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, _utils.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = _getEventFilterUrl(event);
    return !url ? false : (0, _utils.stringMatchesSomePattern)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = _getEventFilterUrl(event);
    return !url ? true : (0, _utils.stringMatchesSomePattern)(url, allowUrls);
}
function _getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, _debugBuildJs.DEBUG_BUILD) && possibleMessages.length === 0) (0, _utils.logger).error(`Could not extract message for event ${(0, _utils.getEventDescription)(event)}`);
    return possibleMessages;
}
function _isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function _getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? _getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`Cannot extract url for event ${(0, _utils.getEventDescription)(event)}`);
        return null;
    }
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../integration.js":"d8HWn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7yDbJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "FunctionToString", ()=>FunctionToString);
parcelHelpers.export(exports, "functionToStringIntegration", ()=>functionToStringIntegration);
var _utils = require("@sentry/utils");
var _exportsJs = require("../exports.js");
var _integrationJs = require("../integration.js");
let originalFunctionToString;
const INTEGRATION_NAME = "FunctionToString";
const SETUP_CLIENTS = new WeakMap();
const _functionToStringIntegration = ()=>{
    return {
        name: INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, _utils.getOriginalFunction)(this);
                    const context = SETUP_CLIENTS.has((0, _exportsJs.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const functionToStringIntegration = (0, _integrationJs.defineIntegration)(_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const FunctionToString = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, functionToStringIntegration);

},{"@sentry/utils":"5XfgR","../exports.js":"bQ1GW","../integration.js":"d8HWn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ikMss":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedErrors", ()=>LinkedErrors);
parcelHelpers.export(exports, "linkedErrorsIntegration", ()=>linkedErrorsIntegration);
var _utils = require("@sentry/utils");
var _integrationJs = require("../integration.js");
const DEFAULT_KEY = "cause";
const DEFAULT_LIMIT = 5;
const INTEGRATION_NAME = "LinkedErrors";
const _linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || DEFAULT_LIMIT;
    const key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, _utils.applyAggregateErrorsToEvent)((0, _utils.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const linkedErrorsIntegration = (0, _integrationJs.defineIntegration)(_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const LinkedErrors = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, linkedErrorsIntegration);

},{"@sentry/utils":"5XfgR","../integration.js":"d8HWn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1FQb2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", ()=>(0, _functiontostringJs.FunctionToString));
parcelHelpers.export(exports, "InboundFilters", ()=>(0, _inboundfiltersJs.InboundFilters));
parcelHelpers.export(exports, "LinkedErrors", ()=>(0, _linkederrorsJs.LinkedErrors)) /* eslint-disable deprecation/deprecation */ ;
var _functiontostringJs = require("./functiontostring.js");
var _inboundfiltersJs = require("./inboundfilters.js");
var _linkederrorsJs = require("./linkederrors.js");

},{"./functiontostring.js":"7yDbJ","./inboundfilters.js":"7fRSe","./linkederrors.js":"ikMss","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b3Kwg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distribution", ()=>distribution);
parcelHelpers.export(exports, "gauge", ()=>gauge);
parcelHelpers.export(exports, "increment", ()=>increment);
parcelHelpers.export(exports, "metrics", ()=>metrics);
parcelHelpers.export(exports, "set", ()=>set);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _exportsJs = require("../exports.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _constantsJs = require("./constants.js");
var _integrationJs = require("./integration.js");
function addToMetricsAggregator(metricType, name, value, data = {}) {
    const client = (0, _exportsJs.getClient)();
    const scope = (0, _exportsJs.getCurrentScope)();
    if (client) {
        if (!client.metricsAggregator) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs");
            return;
        }
        const { unit, tags, timestamp } = data;
        const { release, environment } = client.getOptions();
        // eslint-disable-next-line deprecation/deprecation
        const transaction = scope.getTransaction();
        const metricTags = {};
        if (release) metricTags.release = release;
        if (environment) metricTags.environment = environment;
        if (transaction) metricTags.transaction = (0, _spanUtilsJs.spanToJSON)(transaction).description || "";
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Adding value of ${value} to ${metricType} metric ${name}`);
        client.metricsAggregator.add(metricType, name, value, unit, {
            ...metricTags,
            ...tags
        }, timestamp);
    }
}
/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function increment(name, value = 1, data) {
    addToMetricsAggregator((0, _constantsJs.COUNTER_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function distribution(name, value, data) {
    addToMetricsAggregator((0, _constantsJs.DISTRIBUTION_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function set(name, value, data) {
    addToMetricsAggregator((0, _constantsJs.SET_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function gauge(name, value, data) {
    addToMetricsAggregator((0, _constantsJs.GAUGE_METRIC_TYPE), name, value, data);
}
const metrics = {
    increment,
    distribution,
    set,
    gauge,
    MetricsAggregator: /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */ // eslint-disable-next-line deprecation/deprecation
    (0, _integrationJs.MetricsAggregator),
    metricsAggregatorIntegration: (0, _integrationJs.metricsAggregatorIntegration)
};

},{"@sentry/utils":"5XfgR","../debug-build.js":"h4qdv","../exports.js":"bQ1GW","../utils/spanUtils.js":"jLzrc","./constants.js":"eaU1U","./integration.js":"ffMiK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ffMiK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsAggregator", ()=>MetricsAggregator);
parcelHelpers.export(exports, "metricsAggregatorIntegration", ()=>metricsAggregatorIntegration);
var _integrationJs = require("../integration.js");
var _browserAggregatorJs = require("./browser-aggregator.js");
const INTEGRATION_NAME = "MetricsAggregator";
const _metricsAggregatorIntegration = ()=>{
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            client.metricsAggregator = new (0, _browserAggregatorJs.BrowserMetricsAggregator)(client);
        }
    };
};
const metricsAggregatorIntegration = (0, _integrationJs.defineIntegration)(_metricsAggregatorIntegration);
/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const MetricsAggregator = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, metricsAggregatorIntegration);

},{"../integration.js":"d8HWn","./browser-aggregator.js":"e0FZk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e0FZk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserMetricsAggregator", ()=>BrowserMetricsAggregator);
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _instanceJs = require("./instance.js");
var _metricSummaryJs = require("./metric-summary.js");
var _utilsJs = require("./utils.js");
/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */ class BrowserMetricsAggregator {
    // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
    // when the aggregator is garbage collected.
    // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
    constructor(_client){
        this._client = _client;
        this._buckets = new Map();
        this._interval = setInterval(()=>this.flush(), (0, _constantsJs.DEFAULT_BROWSER_FLUSH_INTERVAL));
    }
    /**
   * @inheritDoc
   */ add(metricType, unsanitizedName, value, unsanitizedUnit = "none", unsanitizedTags = {}, maybeFloatTimestamp = (0, _utils.timestampInSeconds)()) {
        const timestamp = Math.floor(maybeFloatTimestamp);
        const name = (0, _utilsJs.sanitizeMetricKey)(unsanitizedName);
        const tags = (0, _utilsJs.sanitizeTags)(unsanitizedTags);
        const unit = (0, _utilsJs.sanitizeUnit)(unsanitizedUnit);
        const bucketKey = (0, _utilsJs.getBucketKey)(metricType, name, unit, tags);
        let bucketItem = this._buckets.get(bucketKey);
        // If this is a set metric, we need to calculate the delta from the previous weight.
        const previousWeight = bucketItem && metricType === (0, _constantsJs.SET_METRIC_TYPE) ? bucketItem.metric.weight : 0;
        if (bucketItem) {
            bucketItem.metric.add(value);
            // TODO(abhi): Do we need this check?
            if (bucketItem.timestamp < timestamp) bucketItem.timestamp = timestamp;
        } else {
            bucketItem = {
                // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                metric: new (0, _instanceJs.METRIC_MAP)[metricType](value),
                timestamp,
                metricType,
                name,
                unit,
                tags
            };
            this._buckets.set(bucketKey, bucketItem);
        }
        // If value is a string, it's a set metric so calculate the delta from the previous weight.
        const val = typeof value === "string" ? bucketItem.metric.weight - previousWeight : value;
        (0, _metricSummaryJs.updateMetricSummaryOnActiveSpan)(metricType, name, val, unit, unsanitizedTags, bucketKey);
    }
    /**
   * @inheritDoc
   */ flush() {
        // short circuit if buckets are empty.
        if (this._buckets.size === 0) return;
        if (this._client.captureAggregateMetrics) {
            // TODO(@anonrig): Use Object.values() when we support ES6+
            const metricBuckets = Array.from(this._buckets).map(([, bucketItem])=>bucketItem);
            this._client.captureAggregateMetrics(metricBuckets);
        }
        this._buckets.clear();
    }
    /**
   * @inheritDoc
   */ close() {
        clearInterval(this._interval);
        this.flush();
    }
}

},{"@sentry/utils":"5XfgR","./constants.js":"eaU1U","./instance.js":"jfFac","./metric-summary.js":"lyMY0","./utils.js":"Qh9vi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2KfuB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WINDOW", ()=>WINDOW);
parcelHelpers.export(exports, "ignoreNextOnError", ()=>ignoreNextOnError);
parcelHelpers.export(exports, "shouldIgnoreOnError", ()=>shouldIgnoreOnError);
parcelHelpers.export(exports, "wrap", ()=>wrap);
var _tracing = require("@sentry-internal/tracing");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
const WINDOW = (0, _utils.GLOBAL_OBJ);
let ignoreOnError = 0;
/**
 * @hidden
 */ function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */ function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError++;
    setTimeout(()=>{
        ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function wrap(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, _utils.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>wrap(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            (0, _core.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, _utils.addExceptionTypeValue)(event, undefined, undefined);
                        (0, _utils.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, _core.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, _utils.markFunctionWrapped)(sentryWrapped, fn);
    (0, _utils.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

},{"@sentry-internal/tracing":"5gs22","@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5gs22":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdleTransaction", ()=>(0, _core.IdleTransaction));
parcelHelpers.export(exports, "Span", ()=>(0, _core.Span));
parcelHelpers.export(exports, "SpanStatus", ()=>(0, _core.SpanStatus));
parcelHelpers.export(exports, "Transaction", ()=>(0, _core.Transaction));
parcelHelpers.export(exports, "extractTraceparentData", ()=>(0, _core.extractTraceparentData));
parcelHelpers.export(exports, "getActiveTransaction", ()=>(0, _core.getActiveTransaction));
parcelHelpers.export(exports, "hasTracingEnabled", ()=>(0, _core.hasTracingEnabled));
parcelHelpers.export(exports, "spanStatusfromHttpCode", ()=>(0, _core.spanStatusfromHttpCode));
parcelHelpers.export(exports, "startIdleTransaction", ()=>(0, _core.startIdleTransaction));
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", ()=>(0, _utils.TRACEPARENT_REGEXP));
parcelHelpers.export(exports, "stripUrlQueryAndFragment", ()=>(0, _utils.stripUrlQueryAndFragment));
parcelHelpers.export(exports, "Express", ()=>(0, _expressJs.Express));
parcelHelpers.export(exports, "Postgres", ()=>(0, _postgresJs.Postgres));
parcelHelpers.export(exports, "Mysql", ()=>(0, _mysqlJs.Mysql));
parcelHelpers.export(exports, "Mongo", ()=>(0, _mongoJs.Mongo));
parcelHelpers.export(exports, "Prisma", ()=>(0, _prismaJs.Prisma));
parcelHelpers.export(exports, "GraphQL", ()=>(0, _graphqlJs.GraphQL));
parcelHelpers.export(exports, "Apollo", ()=>(0, _apolloJs.Apollo));
parcelHelpers.export(exports, "lazyLoadedNodePerformanceMonitoringIntegrations", ()=>(0, _lazyJs.lazyLoadedNodePerformanceMonitoringIntegrations));
parcelHelpers.export(exports, "BROWSER_TRACING_INTEGRATION_ID", ()=>(0, _browsertracingJs.BROWSER_TRACING_INTEGRATION_ID));
parcelHelpers.export(exports, "BrowserTracing", ()=>(0, _browsertracingJs.BrowserTracing));
parcelHelpers.export(exports, "browserTracingIntegration", ()=>(0, _browserTracingIntegrationJs.browserTracingIntegration));
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", ()=>(0, _browserTracingIntegrationJs.startBrowserTracingNavigationSpan));
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", ()=>(0, _browserTracingIntegrationJs.startBrowserTracingPageLoadSpan));
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", ()=>(0, _requestJs.defaultRequestInstrumentationOptions));
parcelHelpers.export(exports, "instrumentOutgoingRequests", ()=>(0, _requestJs.instrumentOutgoingRequests));
parcelHelpers.export(exports, "addClsInstrumentationHandler", ()=>(0, _instrumentJs.addClsInstrumentationHandler));
parcelHelpers.export(exports, "addFidInstrumentationHandler", ()=>(0, _instrumentJs.addFidInstrumentationHandler));
parcelHelpers.export(exports, "addLcpInstrumentationHandler", ()=>(0, _instrumentJs.addLcpInstrumentationHandler));
parcelHelpers.export(exports, "addPerformanceInstrumentationHandler", ()=>(0, _instrumentJs.addPerformanceInstrumentationHandler));
parcelHelpers.export(exports, "addTracingHeadersToFetchRequest", ()=>(0, _fetchJs.addTracingHeadersToFetchRequest));
parcelHelpers.export(exports, "instrumentFetchRequest", ()=>(0, _fetchJs.instrumentFetchRequest));
parcelHelpers.export(exports, "addExtensionMethods", ()=>(0, _extensionsJs.addExtensionMethods));
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _expressJs = require("./node/integrations/express.js");
var _postgresJs = require("./node/integrations/postgres.js");
var _mysqlJs = require("./node/integrations/mysql.js");
var _mongoJs = require("./node/integrations/mongo.js");
var _prismaJs = require("./node/integrations/prisma.js");
var _graphqlJs = require("./node/integrations/graphql.js");
var _apolloJs = require("./node/integrations/apollo.js");
var _lazyJs = require("./node/integrations/lazy.js");
var _browsertracingJs = require("./browser/browsertracing.js");
var _browserTracingIntegrationJs = require("./browser/browserTracingIntegration.js");
var _requestJs = require("./browser/request.js");
var _instrumentJs = require("./browser/instrument.js");
var _fetchJs = require("./common/fetch.js");
var _extensionsJs = require("./extensions.js");

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","./node/integrations/express.js":"czb79","./node/integrations/postgres.js":"jjHkN","./node/integrations/mysql.js":"ez7oC","./node/integrations/mongo.js":"1hDOO","./node/integrations/prisma.js":"f53g3","./node/integrations/graphql.js":"9npSn","./node/integrations/apollo.js":"iecDp","./node/integrations/lazy.js":"bQQOG","./browser/browsertracing.js":"3M2YS","./browser/browserTracingIntegration.js":"bPl5o","./browser/request.js":"h4Tnq","./browser/instrument.js":"5D0uU","./common/fetch.js":"8jlmw","./extensions.js":"akbBW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"czb79":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Express", ()=>Express);
parcelHelpers.export(exports, "extractOriginalRoute", ()=>extractOriginalRoute);
parcelHelpers.export(exports, "preventDuplicateSegments", ()=>preventDuplicateSegments);
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/* eslint-disable max-lines */ /**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class Express {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Express";
    }
    /**
   * @inheritDoc
   */ /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = Express.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat("use");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("ExpressIntegration is missing an Express instance");
            return;
        }
        if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Express Integration is skipped because of instrumenter configuration.");
            return;
        }
        instrumentMiddlewares(this._router, this._methods);
        instrumentRouter(this._router);
    }
}
Express.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: "auto.middleware.express"
                    });
                    res.once("finish", ()=>{
                        span.end();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, _utils._optionalChain)([
                    transaction,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, _utils._optionalChain)([
                        span,
                        "optionalAccess",
                        (_4)=>_4.end,
                        "call",
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, _utils._optionalChain)([
                    transaction,
                    "optionalAccess",
                    (_6)=>_6.startChild,
                    "call",
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: "auto.middleware.express"
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, _utils._optionalChain)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.end,
                        "call",
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === "function") return wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === "function") return wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = "settings" in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).debug("Cannot instrument router for URL Parameterization (did not find a valid router).");
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).debug("Routing instrumentation is currently only supported in Express 4.");
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = "";
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath, isRegex, isArray, numExtraSegments } = getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        let partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = preventDuplicateSegments(req.originalUrl, req._reconstructedRoute, layer.path) || "";
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split("/").filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes("*"))).join("/");
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? "/" : ""}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, _utils.getNumberOfUrlSegments)((0, _utils.stripUrlQueryAndFragment)(req.originalUrl || "")) + numExtraSegments;
        const routeLength = (0, _utils.getNumberOfUrlSegments)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, _utils.stripUrlQueryAndFragment)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            const attributes = transaction && (0, _core.spanToJSON)(transaction).data || {};
            if (transaction && attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] !== "custom") {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || "/";
                const [name, source] = (0, _utils.extractPathForTransaction)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                });
                transaction.updateName(name);
                transaction.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ const extractOriginalRoute = (path, regexp, keys)=>{
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || !(0, _utils._optionalChain)([
        keys,
        "access",
        (_10)=>_10[0],
        "optionalAccess",
        (_11)=>_11.offset
    ])) return undefined;
    const orderedKeys = keys.sort((a, b)=>a.offset - b.offset);
    // add d flag for getting indices from regexp result
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
    const pathRegex = new RegExp(regexp, `${regexp.flags}d`);
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ const execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ const [, ...paramIndices] = execResult.indices;
    if (paramIndices.length !== orderedKeys.length) return undefined;
    let resultPath = path;
    let indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach((item, index)=>{
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            const [startOffset, endOffset] = item;
            /**
       * isolate part before param
       */ const substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ const replacement = `:${orderedKeys[index].name}`;
            /**
       * isolate part after param
       */ const substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function getLayerRoutePathInfo(layer) {
    let lrp = (0, _utils._optionalChain)([
        layer,
        "access",
        (_12)=>_12.route,
        "optionalAccess",
        (_13)=>_13.path
    ]);
    const isRegex = (0, _utils.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        const [major] = (0, _utils.GLOBAL_OBJ).process.versions.node.split(".").map(Number);
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = extractOriginalRoute(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex,
        isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max(getNumberOfArrayUrlSegments(lrp) - (0, _utils.getNumberOfUrlSegments)(layer.path || ""), 0) : 0;
    const layerRoutePath = getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath,
        isRegex,
        isArray,
        numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, _utils.getNumberOfUrlSegments)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(",");
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function preventDuplicateSegments(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    const normalizeURL = (0, _utils.stripUrlQueryAndFragment)(originalUrl || "");
    const originalUrlSplit = (0, _utils._optionalChain)([
        normalizeURL,
        "optionalAccess",
        (_14)=>_14.split,
        "call",
        (_15)=>_15("/"),
        "access",
        (_16)=>_16.filter,
        "call",
        (_17)=>_17((v)=>!!v)
    ]);
    let tempCounter = 0;
    const currentOffset = (0, _utils._optionalChain)([
        reconstructedRoute,
        "optionalAccess",
        (_18)=>_18.split,
        "call",
        (_19)=>_19("/"),
        "access",
        (_20)=>_20.filter,
        "call",
        (_21)=>_21((v)=>!!v),
        "access",
        (_22)=>_22.length
    ]) || 0;
    const result = (0, _utils._optionalChain)([
        layerPath,
        "optionalAccess",
        (_23)=>_23.split,
        "call",
        (_24)=>_24("/"),
        "access",
        (_25)=>_25.filter,
        "call",
        (_26)=>_26((segment)=>{
                if ((0, _utils._optionalChain)([
                    originalUrlSplit,
                    "optionalAccess",
                    (_27)=>_27[currentOffset + tempCounter]
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            }),
        "access",
        (_28)=>_28.join,
        "call",
        (_29)=>_29("/")
    ]);
    return result;
}

},{"@sentry/utils":"5XfgR","@sentry/core":"3UnXU","../../common/debug-build.js":"4kXV7","./utils/node-utils.js":"lm31X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4kXV7":[function(require,module,exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", ()=>DEBUG_BUILD);
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lm31X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldDisableAutoInstrumentation", ()=>shouldDisableAutoInstrumentation);
var _utils = require("@sentry/utils");
/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ // eslint-disable-next-line deprecation/deprecation
function shouldDisableAutoInstrumentation(getCurrentHub) {
    // eslint-disable-next-line deprecation/deprecation
    const clientOptions = (0, _utils._optionalChain)([
        getCurrentHub,
        "call",
        (_)=>_(),
        "access",
        (_2)=>_2.getClient,
        "call",
        (_3)=>_3(),
        "optionalAccess",
        (_4)=>_4.getOptions,
        "call",
        (_5)=>_5()
    ]);
    const instrumenter = (0, _utils._optionalChain)([
        clientOptions,
        "optionalAccess",
        (_6)=>_6.instrumenter
    ]) || "sentry";
    return instrumenter !== "sentry";
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jjHkN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Postgres", ()=>Postgres);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for node-postgres package */ class Postgres {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Postgres";
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = Postgres.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, _utils.loadModule)("pg");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Postgres Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Postgres Integration was unable to require `pg` package.");
            return;
        }
        const Client = this._usePgNative ? (0, _utils._optionalChain)([
            pkg,
            "access",
            (_2)=>_2.native,
            "optionalAccess",
            (_3)=>_3.Client
        ]) : pkg.Client;
        if (!Client) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, _utils.fill)(Client.prototype, "query", function(orig) {
            return function(config, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const data = {
                    "db.system": "postgresql"
                };
                try {
                    if (this.database) data["db.name"] = this.database;
                    if (this.host) data["server.address"] = this.host;
                    if (this.port) data["server.port"] = this.port;
                    if (this.user) data["db.user"] = this.user;
                } catch (e) {
                // ignore
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, _utils._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_4)=>_4.startChild,
                    "call",
                    (_5)=>_5({
                            description: typeof config === "string" ? config : config.text,
                            op: "db",
                            origin: "auto.db.postgres",
                            data
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, config, values, function(err, result) {
                    (0, _utils._optionalChain)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.end,
                        "call",
                        (_7)=>_7()
                    ]);
                    callback(err, result);
                });
                if (typeof values === "function") return orig.call(this, config, function(err, result) {
                    (0, _utils._optionalChain)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.end,
                        "call",
                        (_9)=>_9()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== "undefined" ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, _utils.isThenable)(rv)) return rv.then((res)=>{
                    (0, _utils._optionalChain)([
                        span,
                        "optionalAccess",
                        (_10)=>_10.end,
                        "call",
                        (_11)=>_11()
                    ]);
                    return res;
                });
                (0, _utils._optionalChain)([
                    span,
                    "optionalAccess",
                    (_12)=>_12.end,
                    "call",
                    (_13)=>_13()
                ]);
                return rv;
            };
        });
    }
}
Postgres.__initStatic();

},{"@sentry/utils":"5XfgR","../../common/debug-build.js":"4kXV7","./utils/node-utils.js":"lm31X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ez7oC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mysql", ()=>Mysql);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for node-mysql package */ class Mysql {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mysql";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = Mysql.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, _utils.loadModule)("mysql/lib/Connection.js");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Mysql Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Mysql Integration was unable to require `mysql` package.");
            return;
        }
        let mySqlConfig = undefined;
        try {
            pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                apply (wrappingTarget, thisArg, args) {
                    if (!mySqlConfig) mySqlConfig = thisArg.config;
                    return wrappingTarget.apply(thisArg, args);
                }
            });
        } catch (e) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Mysql Integration was unable to instrument `mysql` config.");
        }
        function spanDataFromConfig() {
            if (!mySqlConfig) return {};
            return {
                "server.address": mySqlConfig.host,
                "server.port": mySqlConfig.port,
                "db.user": mySqlConfig.user
            };
        }
        function finishSpan(span) {
            if (!span) return;
            const data = spanDataFromConfig();
            Object.keys(data).forEach((key)=>{
                span.setAttribute(key, data[key]);
            });
            span.end();
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, _utils.fill)(pkg, "createQuery", function(orig) {
            return function(options, values, callback) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, _utils._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: typeof options === "string" ? options : options.sql,
                            op: "db",
                            origin: "auto.db.mysql",
                            data: {
                                "db.system": "mysql"
                            }
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, options, values, function(err, result, fields) {
                    finishSpan(span);
                    callback(err, result, fields);
                });
                if (typeof values === "function") return orig.call(this, options, function(err, result, fields) {
                    finishSpan(span);
                    values(err, result, fields);
                });
                // streaming, no callback!
                const query = orig.call(this, options, values);
                query.on("end", ()=>{
                    finishSpan(span);
                });
                return query;
            };
        });
    }
}
Mysql.__initStatic();

},{"@sentry/utils":"5XfgR","../../common/debug-build.js":"4kXV7","./utils/node-utils.js":"lm31X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1hDOO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mongo", ()=>Mongo);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const OPERATIONS = [
    "aggregate",
    "bulkWrite",
    "countDocuments",
    "createIndex",
    "createIndexes",
    "deleteMany",
    "deleteOne",
    "distinct",
    "drop",
    "dropIndex",
    "dropIndexes",
    "estimatedDocumentCount",
    "find",
    "findOne",
    "findOneAndDelete",
    "findOneAndReplace",
    "findOneAndUpdate",
    "indexes",
    "indexExists",
    "indexInformation",
    "initializeOrderedBulkOp",
    "insertMany",
    "insertOne",
    "isCapped",
    "mapReduce",
    "options",
    "parallelCollectionScan",
    "rename",
    "replaceOne",
    "stats",
    "updateMany",
    "updateOne"
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        "operations"
    ],
    countDocuments: [
        "query"
    ],
    createIndex: [
        "fieldOrSpec"
    ],
    createIndexes: [
        "indexSpecs"
    ],
    deleteMany: [
        "filter"
    ],
    deleteOne: [
        "filter"
    ],
    distinct: [
        "key",
        "query"
    ],
    dropIndex: [
        "indexName"
    ],
    find: [
        "query"
    ],
    findOne: [
        "query"
    ],
    findOneAndDelete: [
        "filter"
    ],
    findOneAndReplace: [
        "filter",
        "replacement"
    ],
    findOneAndUpdate: [
        "filter",
        "update"
    ],
    indexExists: [
        "indexes"
    ],
    insertMany: [
        "docs"
    ],
    insertOne: [
        "doc"
    ],
    mapReduce: [
        "map",
        "reduce"
    ],
    rename: [
        "newName"
    ],
    replaceOne: [
        "filter",
        "doc"
    ],
    updateMany: [
        "filter",
        "update"
    ],
    updateOne: [
        "filter",
        "update"
    ]
};
function isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === "object" && maybeCursor.once && typeof maybeCursor.once === "function";
}
/** Tracing integration for mongo package */ class Mongo {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mongo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = Mongo.id;
        this._operations = Array.isArray(options.operations) ? options.operations : OPERATIONS;
        this._describeOperations = "describeOperations" in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? "mongoose" : "mongodb";
        return this._module = this._module || (0, _utils.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Mongo Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? "mongoose" : "mongodb";
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ // eslint-disable-next-line deprecation/deprecation
    _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ // eslint-disable-next-line deprecation/deprecation
    _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, _utils.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                // eslint-disable-next-line deprecation/deprecation
                const hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                const scope = hub.getScope();
                // eslint-disable-next-line deprecation/deprecation
                const client = hub.getClient();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                const sendDefaultPii = (0, _utils._optionalChain)([
                    client,
                    "optionalAccess",
                    (_2)=>_2.getOptions,
                    "call",
                    (_3)=>_3(),
                    "access",
                    (_4)=>_4.sendDefaultPii
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== "function" || operation === "mapReduce" && args.length === 2) {
                    // eslint-disable-next-line deprecation/deprecation
                    const span = (0, _utils._optionalChain)([
                        parentSpan,
                        "optionalAccess",
                        (_5)=>_5.startChild,
                        "call",
                        (_6)=>_6(getSpanContext(this, operation, args, sendDefaultPii))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, _utils.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, _utils._optionalChain)([
                            span,
                            "optionalAccess",
                            (_7)=>_7.end,
                            "call",
                            (_8)=>_8()
                        ]);
                        return res;
                    });
                    else if (isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once("close", ()=>{
                                (0, _utils._optionalChain)([
                                    span,
                                    "optionalAccess",
                                    (_9)=>_9.end,
                                    "call",
                                    (_10)=>_10()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, _utils._optionalChain)([
                                span,
                                "optionalAccess",
                                (_11)=>_11.end,
                                "call",
                                (_12)=>_12()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, _utils._optionalChain)([
                            span,
                            "optionalAccess",
                            (_13)=>_13.end,
                            "call",
                            (_14)=>_14()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, _utils._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_15)=>_15.startChild,
                    "call",
                    (_16)=>_16(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, _utils._optionalChain)([
                        span,
                        "optionalAccess",
                        (_17)=>_17.end,
                        "call",
                        (_18)=>_18()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args, sendDefaultPii = false) {
        const data = {
            "db.system": "mongodb",
            "db.name": collection.dbName,
            "db.operation": operation,
            "db.mongodb.collection": collection.collectionName
        };
        const spanContext = {
            op: "db",
            // TODO v8: Use `${collection.collectionName}.${operation}`
            origin: "auto.db.mongo",
            description: operation,
            data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe || !sendDefaultPii) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === "mapReduce") {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === "string" ? map : map.name || "<anonymous>";
                data[signature[1]] = typeof reduce === "string" ? reduce : reduce.name || "<anonymous>";
            } else for(let i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
Mongo.__initStatic();

},{"@sentry/utils":"5XfgR","../../common/debug-build.js":"4kXV7","./utils/node-utils.js":"lm31X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f53g3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Prisma", ()=>Prisma);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
function isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient["$use"];
}
/** Tracing integration for @prisma/client package */ class Prisma {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Prisma";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = Prisma.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if (isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, _utils.addNonEnumerableProperty)(options.client, "_sentryInstrumented", true);
            const clientData = {};
            try {
                const engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    const { activeProvider, clientVersion } = engineConfig;
                    if (activeProvider) clientData["db.system"] = activeProvider;
                    if (clientVersion) clientData["db.prisma.version"] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use((params, next)=>{
                // eslint-disable-next-line deprecation/deprecation
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)((0, _core.getCurrentHub))) return next(params);
                const action = params.action;
                const model = params.model;
                return (0, _core.startSpan)({
                    name: model ? `${model} ${action}` : action,
                    onlyIfParent: true,
                    op: "db.prisma",
                    attributes: {
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.db.prisma"
                    },
                    data: {
                        ...clientData,
                        "db.operation": action
                    }
                }, ()=>next(params));
            });
        } else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Unsupported Prisma client provided to PrismaIntegration. Provided client:", options.client);
    }
    /**
   * @inheritDoc
   */ setupOnce() {
    // Noop - here for backwards compatibility
    }
}
Prisma.__initStatic();

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../../common/debug-build.js":"4kXV7","./utils/node-utils.js":"lm31X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9npSn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQL", ()=>GraphQL);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for graphql package */ class GraphQL {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GraphQL";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = GraphQL.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, _utils.loadModule)("graphql/execution/execute.js");
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("GraphQL Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("GraphQL Integration was unable to require graphql/execution package.");
            return;
        }
        (0, _utils.fill)(pkg, "execute", function(orig) {
            return function(...args) {
                // eslint-disable-next-line deprecation/deprecation
                const scope = getCurrentHub().getScope();
                // eslint-disable-next-line deprecation/deprecation
                const parentSpan = scope.getSpan();
                // eslint-disable-next-line deprecation/deprecation
                const span = (0, _utils._optionalChain)([
                    parentSpan,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: "execute",
                            op: "graphql.execute",
                            origin: "auto.graphql.graphql"
                        })
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, _utils._optionalChain)([
                    scope,
                    "optionalAccess",
                    (_4)=>_4.setSpan,
                    "call",
                    (_5)=>_5(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, _utils.isThenable)(rv)) return rv.then((res)=>{
                    (0, _utils._optionalChain)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.end,
                        "call",
                        (_7)=>_7()
                    ]);
                    // eslint-disable-next-line deprecation/deprecation
                    (0, _utils._optionalChain)([
                        scope,
                        "optionalAccess",
                        (_8)=>_8.setSpan,
                        "call",
                        (_9)=>_9(parentSpan)
                    ]);
                    return res;
                });
                (0, _utils._optionalChain)([
                    span,
                    "optionalAccess",
                    (_10)=>_10.end,
                    "call",
                    (_11)=>_11()
                ]);
                // eslint-disable-next-line deprecation/deprecation
                (0, _utils._optionalChain)([
                    scope,
                    "optionalAccess",
                    (_12)=>_12.setSpan,
                    "call",
                    (_13)=>_13(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
GraphQL.__initStatic();

},{"@sentry/utils":"5XfgR","../../common/debug-build.js":"4kXV7","./utils/node-utils.js":"lm31X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iecDp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Apollo", ()=>Apollo);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for Apollo */ class Apollo {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Apollo";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        this.name = Apollo.id;
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, _utils.loadModule)("@nestjs/graphql");
        else this._module = this._module || (0, _utils.loadModule)("apollo-server-core");
        return this._module;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Apollo Integration is skipped because of instrumenter configuration.");
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Apollo-NestJS Integration was unable to require @nestjs/graphql package.");
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, _utils.fill)(pkg.GraphQLFactory.prototype, "mergeWithSchema", function(orig) {
                return function(...args) {
                    (0, _utils.fill)(this.resolversExplorerService, "explore", function(orig) {
                        return function() {
                            const resolvers = (0, _utils.arrayify)(orig.call(this));
                            const instrumentedResolvers = instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Apollo Integration was unable to require apollo-server-core package.");
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, _utils.fill)(pkg.ApolloServerBase.prototype, "constructSchema", function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (0, _debugBuildJs.DEBUG_BUILD) {
                            if (this.config.schema) {
                                (0, _utils.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, _utils.logger).warn();
                            } else if (this.config.modules) (0, _utils.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.");
                            (0, _utils.logger).error("Skipping tracing as no resolvers found on the `ApolloServer` instance.");
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, _utils.arrayify)(this.config.resolvers);
                    this.config.resolvers = instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
Apollo.__initStatic();
// eslint-disable-next-line deprecation/deprecation
function instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== "function") return;
                wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function wrapResolver(model, resolverGroupName, resolverName, // eslint-disable-next-line deprecation/deprecation
getCurrentHub) {
    (0, _utils.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = getCurrentHub().getScope();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            // eslint-disable-next-line deprecation/deprecation
            const span = (0, _utils._optionalChain)([
                parentSpan,
                "optionalAccess",
                (_2)=>_2.startChild,
                "call",
                (_3)=>_3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: "graphql.resolve",
                        origin: "auto.graphql.apollo"
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, _utils.isThenable)(rv)) return rv.then((res)=>{
                (0, _utils._optionalChain)([
                    span,
                    "optionalAccess",
                    (_4)=>_4.end,
                    "call",
                    (_5)=>_5()
                ]);
                return res;
            });
            (0, _utils._optionalChain)([
                span,
                "optionalAccess",
                (_6)=>_6.end,
                "call",
                (_7)=>_7()
            ]);
            return rv;
        };
    });
}

},{"@sentry/utils":"5XfgR","../../common/debug-build.js":"4kXV7","./utils/node-utils.js":"lm31X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bQQOG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lazyLoadedNodePerformanceMonitoringIntegrations", ()=>lazyLoadedNodePerformanceMonitoringIntegrations);
var _utils = require("@sentry/utils");
const lazyLoadedNodePerformanceMonitoringIntegrations = [
    ()=>{
        const integration = (0, _utils.dynamicRequire)(module, "./apollo");
        return new integration.Apollo();
    },
    ()=>{
        const integration = (0, _utils.dynamicRequire)(module, "./apollo");
        return new integration.Apollo({
            useNestjs: true
        });
    },
    ()=>{
        const integration = (0, _utils.dynamicRequire)(module, "./graphql");
        return new integration.GraphQL();
    },
    ()=>{
        const integration = (0, _utils.dynamicRequire)(module, "./mongo");
        return new integration.Mongo();
    },
    ()=>{
        const integration = (0, _utils.dynamicRequire)(module, "./mongo");
        return new integration.Mongo({
            mongoose: true
        });
    },
    ()=>{
        const integration = (0, _utils.dynamicRequire)(module, "./mysql");
        return new integration.Mysql();
    },
    ()=>{
        const integration = (0, _utils.dynamicRequire)(module, "./postgres");
        return new integration.Postgres();
    }
];

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3M2YS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BROWSER_TRACING_INTEGRATION_ID", ()=>BROWSER_TRACING_INTEGRATION_ID);
parcelHelpers.export(exports, "BrowserTracing", ()=>BrowserTracing);
parcelHelpers.export(exports, "getMetaContent", ()=>getMetaContent);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _backgroundtabJs = require("./backgroundtab.js");
var _instrumentJs = require("./instrument.js");
var _indexJs = require("./metrics/index.js");
var _requestJs = require("./request.js");
var _routerJs = require("./router.js");
var _typesJs = require("./types.js");
const BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
/** Options for Browser Tracing integration */ const DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, _core.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, _routerJs.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, _requestJs.defaultRequestInstrumentationOptions)
};
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ class BrowserTracing {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(_options){
        this.name = BROWSER_TRACING_INTEGRATION_ID;
        this._hasSetTracePropagationTargets = false;
        (0, _core.addTracingExtensions)();
        if (0, _debugBuildJs.DEBUG_BUILD) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, _indexJs.startTrackingWebVitals)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, _indexJs.startTrackingINP)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, _indexJs.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, _indexJs.startTrackingInteractions)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange, startTransactionOnPageLoad, markBackgroundTransactions, traceFetch, traceXHR, shouldCreateSpanForRequest, enableHTTPTimings, _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, _debugBuildJs.DEBUG_BUILD) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, _utils.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, _backgroundtabJs.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        if (this.options.enableInp) this._registerInpInteractionListener();
        (0, _requestJs.instrumentOutgoingRequests)({
            traceFetch,
            traceXHR,
            tracePropagationTargets,
            shouldCreateSpanForRequest,
            enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? getMetaContent("sentry-trace") : "";
            const baggage = isPageloadTransaction ? getMetaContent("baggage") : undefined;
            const { traceId, dsc, parentSpanId, sampled } = (0, _utils.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId,
                parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRoute.name = finalContext.name;
        this._latestRoute.context = finalContext;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location } = (0, _typesJs.WINDOW);
        const idleTransaction = (0, _core.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            if ((0, _typesJs.WINDOW).document) {
                (0, _typesJs.WINDOW).document.addEventListener("readystatechange", ()=>{
                    if ([
                        "interactive",
                        "complete"
                    ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
                });
                if ([
                    "interactive",
                    "complete"
                ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            }
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, _indexJs.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, _core.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRoute.name) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location } = (0, _typesJs.WINDOW);
            const context = {
                name: this._latestRoute.name,
                op,
                trimEnd: true,
                data: {
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: this._latestRoute.context ? getSource(this._latestRoute.context) : "url"
                }
            };
            inflightInteractionTransaction = (0, _core.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            if ((0, _typesJs.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
    /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ _registerInpInteractionListener() {
        const handleEntries = ({ entries })=>{
            const client = (0, _core.getClient)();
            // We need to get the replay, user, and activeTransaction from the current scope
            // so that we can associate replay id, profile id, and a user display to the span
            const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
            const replayId = replay !== undefined ? replay.getReplayId() : undefined;
            // eslint-disable-next-line deprecation/deprecation
            const activeTransaction = (0, _core.getActiveTransaction)();
            const currentScope = (0, _core.getCurrentScope)();
            const user = currentScope !== undefined ? currentScope.getUser() : undefined;
            entries.forEach((entry)=>{
                if (isPerformanceEventTiming(entry)) {
                    const interactionId = entry.interactionId;
                    if (interactionId === undefined) return;
                    const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
                    const duration = entry.duration;
                    const startTime = entry.startTime;
                    const keys = Object.keys(this._interactionIdToRouteNameMapping);
                    const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                        return this._interactionIdToRouteNameMapping[a].duration < this._interactionIdToRouteNameMapping[b].duration ? a : b;
                    }) : undefined;
                    // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                    // This is also checked in the web-vitals library.
                    if (entry.entryType === "first-input") {
                        const matchingEntry = keys.map((key)=>this._interactionIdToRouteNameMapping[key]).some((interaction)=>{
                            return interaction.duration === duration && interaction.startTime === startTime;
                        });
                        if (matchingEntry) return;
                    }
                    // Interactions with an id of 0 and are not first-input are not valid.
                    if (!interactionId) return;
                    // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                    if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                    else if (keys.length < MAX_INTERACTIONS || minInteractionId === undefined || duration > this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                        // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                        const routeName = this._latestRoute.name;
                        const parentContext = this._latestRoute.context;
                        if (routeName && parentContext) {
                            if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                            delete this._interactionIdToRouteNameMapping[minInteractionId];
                            this._interactionIdToRouteNameMapping[interactionId] = {
                                routeName,
                                duration,
                                parentContext,
                                user,
                                activeTransaction,
                                replayId,
                                startTime
                            };
                        }
                    }
                }
            });
        };
        (0, _instrumentJs.addPerformanceInstrumentationHandler)("event", handleEntries);
        (0, _instrumentJs.addPerformanceInstrumentationHandler)("first-input", handleEntries);
    }
}
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, _utils.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
function getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function isPerformanceEventTiming(entry) {
    return "duration" in entry;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../common/debug-build.js":"4kXV7","./backgroundtab.js":"bTCyK","./instrument.js":"5D0uU","./metrics/index.js":"1srB4","./request.js":"h4Tnq","./router.js":"18gR1","./types.js":"fTBvn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bTCyK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerBackgroundTabDetection", ()=>registerBackgroundTabDetection);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _typesJs = require("./types.js");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function registerBackgroundTabDetection() {
    if ((0, _typesJs.WINDOW).document) (0, _typesJs.WINDOW).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, _core.getActiveTransaction)();
        if ((0, _typesJs.WINDOW).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op, status } = (0, _core.spanToJSON)(activeTransaction);
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../common/debug-build.js":"4kXV7","./types.js":"fTBvn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fTBvn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WINDOW", ()=>WINDOW);
var _utils = require("@sentry/utils");
const WINDOW = (0, _utils.GLOBAL_OBJ);

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5D0uU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addClsInstrumentationHandler", ()=>addClsInstrumentationHandler);
parcelHelpers.export(exports, "addFidInstrumentationHandler", ()=>addFidInstrumentationHandler);
parcelHelpers.export(exports, "addInpInstrumentationHandler", ()=>addInpInstrumentationHandler);
parcelHelpers.export(exports, "addLcpInstrumentationHandler", ()=>addLcpInstrumentationHandler);
parcelHelpers.export(exports, "addPerformanceInstrumentationHandler", ()=>addPerformanceInstrumentationHandler);
parcelHelpers.export(exports, "addTtfbInstrumentationHandler", ()=>addTtfbInstrumentationHandler);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _getCLSJs = require("./web-vitals/getCLS.js");
var _getFIDJs = require("./web-vitals/getFID.js");
var _getINPJs = require("./web-vitals/getINP.js");
var _getLCPJs = require("./web-vitals/getLCP.js");
var _observeJs = require("./web-vitals/lib/observe.js");
var _onTTFBJs = require("./web-vitals/onTTFB.js");
const handlers = {};
const instrumented = {};
let _previousCls;
let _previousFid;
let _previousLcp;
let _previousTtfb;
let _previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function addClsInstrumentationHandler(callback, stopOnCallback = false) {
    return addMetricObserver("cls", callback, instrumentCls, _previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function addLcpInstrumentationHandler(callback, stopOnCallback = false) {
    return addMetricObserver("lcp", callback, instrumentLcp, _previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function addTtfbInstrumentationHandler(callback) {
    return addMetricObserver("ttfb", callback, instrumentTtfb, _previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addFidInstrumentationHandler(callback) {
    return addMetricObserver("fid", callback, instrumentFid, _previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addInpInstrumentationHandler(callback) {
    return addMetricObserver("inp", callback, instrumentInp, _previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addPerformanceInstrumentationHandler(type, callback) {
    addHandler(type, callback);
    if (!instrumented[type]) {
        instrumentPerformanceObserver(type);
        instrumented[type] = true;
    }
    return getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function triggerHandlers(type, data) {
    const typeHandlers = handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, _utils.getFunctionName)(handler)}\nError:`, e);
    }
}
function instrumentCls() {
    return (0, _getCLSJs.onCLS)((metric)=>{
        triggerHandlers("cls", {
            metric
        });
        _previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function instrumentFid() {
    return (0, _getFIDJs.onFID)((metric)=>{
        triggerHandlers("fid", {
            metric
        });
        _previousFid = metric;
    });
}
function instrumentLcp() {
    return (0, _getLCPJs.onLCP)((metric)=>{
        triggerHandlers("lcp", {
            metric
        });
        _previousLcp = metric;
    });
}
function instrumentTtfb() {
    return (0, _onTTFBJs.onTTFB)((metric)=>{
        triggerHandlers("ttfb", {
            metric
        });
        _previousTtfb = metric;
    });
}
function instrumentInp() {
    return (0, _getINPJs.onINP)((metric)=>{
        triggerHandlers("inp", {
            metric
        });
        _previousInp = metric;
    });
}
function addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    addHandler(type, callback);
    let stopListening;
    if (!instrumented[type]) {
        stopListening = instrumentFn();
        instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, _observeJs.observe)(type, (entries)=>{
        triggerHandlers(type, {
            entries
        });
    }, options);
}
function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

},{"@sentry/utils":"5XfgR","../common/debug-build.js":"4kXV7","./web-vitals/getCLS.js":"i5LPj","./web-vitals/getFID.js":"8UdYn","./web-vitals/getINP.js":"5kDLv","./web-vitals/getLCP.js":"lEuEd","./web-vitals/lib/observe.js":"7fABj","./web-vitals/onTTFB.js":"b7KCj","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i5LPj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onCLS", ()=>onCLS);
var _bindReporterJs = require("./lib/bindReporter.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const onCLS = (onReport, options = {})=>{
    const metric = (0, _initMetricJs.initMetric)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, _observeJs.observe)("layout-shift", handleEntries);
    if (po) {
        report = (0, _bindReporterJs.bindReporter)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, _onHiddenJs.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

},{"./lib/bindReporter.js":"8luFD","./lib/initMetric.js":"7ykMR","./lib/observe.js":"7fABj","./lib/onHidden.js":"6dn2k","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8luFD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindReporter", ()=>bindReporter);
const bindReporter = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7ykMR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initMetric", ()=>initMetric);
var _typesJs = require("../../types.js");
var _generateUniqueIDJs = require("./generateUniqueID.js");
var _getActivationStartJs = require("./getActivationStart.js");
var _getNavigationEntryJs = require("./getNavigationEntry.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const initMetric = (name, value)=>{
    const navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, _typesJs.WINDOW).document && (0, _typesJs.WINDOW).document.prerendering || (0, _getActivationStartJs.getActivationStart)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, _generateUniqueIDJs.generateUniqueID)(),
        navigationType
    };
};

},{"../../types.js":"fTBvn","./generateUniqueID.js":"chJrz","./getActivationStart.js":"8CTeJ","./getNavigationEntry.js":"fJLRQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"chJrz":[function(require,module,exports) {
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUniqueID", ()=>generateUniqueID);
const generateUniqueID = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8CTeJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActivationStart", ()=>getActivationStart);
var _getNavigationEntryJs = require("./getNavigationEntry.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const getActivationStart = ()=>{
    const navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

},{"./getNavigationEntry.js":"fJLRQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fJLRQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNavigationEntry", ()=>getNavigationEntry);
var _typesJs = require("../../types.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, _typesJs.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, _typesJs.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const getNavigationEntry = ()=>{
    if ((0, _typesJs.WINDOW).__WEB_VITALS_POLYFILL__) return (0, _typesJs.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || getNavigationEntryFromPerformanceTiming());
    else return (0, _typesJs.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};

},{"../../types.js":"fTBvn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7fABj":[function(require,module,exports) {
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observe", ()=>observe);
const observe = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6dn2k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onHidden", ()=>onHidden);
var _typesJs = require("../../types.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const onHidden = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, _typesJs.WINDOW).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, _typesJs.WINDOW).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};

},{"../../types.js":"fTBvn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8UdYn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onFID", ()=>onFID);
var _bindReporterJs = require("./lib/bindReporter.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const onFID = (onReport)=>{
    const visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
    const metric = (0, _initMetricJs.initMetric)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, _observeJs.observe)("first-input", handleEntries);
    report = (0, _bindReporterJs.bindReporter)(onReport, metric);
    if (po) (0, _onHiddenJs.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

},{"./lib/bindReporter.js":"8luFD","./lib/getVisibilityWatcher.js":"apJF8","./lib/initMetric.js":"7ykMR","./lib/observe.js":"7fABj","./lib/onHidden.js":"6dn2k","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"apJF8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVisibilityWatcher", ()=>getVisibilityWatcher);
var _typesJs = require("../../types.js");
var _onHiddenJs = require("./onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let firstHiddenTime = -1;
const initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, _typesJs.WINDOW).document && (0, _typesJs.WINDOW).document.visibilityState) firstHiddenTime = (0, _typesJs.WINDOW).document.visibilityState === "hidden" && !(0, _typesJs.WINDOW).document.prerendering ? 0 : Infinity;
};
const trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, _onHiddenJs.onHidden)(({ timeStamp })=>{
        firstHiddenTime = timeStamp;
    }, true);
};
const getVisibilityWatcher = ()=>{
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime () {
            return firstHiddenTime;
        }
    };
};

},{"../../types.js":"fTBvn","./onHidden.js":"6dn2k","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5kDLv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onINP", ()=>onINP);
var _bindReporterJs = require("./lib/bindReporter.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
var _interactionCountPolyfillJs = require("./lib/polyfills/interactionCountPolyfill.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const getInteractionCountForNavigation = ()=>{
    return (0, _interactionCountPolyfillJs.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            longestInteractionMap[interaction.id] = interaction;
            longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        longestInteractionList.sort((a, b)=>b.latency - a.latency);
        longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min(longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
    return longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const onINP = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, _interactionCountPolyfillJs.initInteractionCountPolyfill)();
    const metric = (0, _initMetricJs.initMetric)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) processEntry(entry);
            }
        });
        const inp = estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, _observeJs.observe)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, _bindReporterJs.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, _onHiddenJs.onHidden)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

},{"./lib/bindReporter.js":"8luFD","./lib/initMetric.js":"7ykMR","./lib/observe.js":"7fABj","./lib/onHidden.js":"6dn2k","./lib/polyfills/interactionCountPolyfill.js":"3pZpB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3pZpB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInteractionCount", ()=>getInteractionCount);
parcelHelpers.export(exports, "initInteractionCountPolyfill", ()=>initInteractionCountPolyfill);
var _observeJs = require("../observe.js");
let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;
const updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
            maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
            interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const getInteractionCount = ()=>{
    return po ? interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const initInteractionCountPolyfill = ()=>{
    if ("interactionCount" in performance || po) return;
    po = (0, _observeJs.observe)("event", updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};

},{"../observe.js":"7fABj","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lEuEd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onLCP", ()=>onLCP);
var _typesJs = require("../types.js");
var _bindReporterJs = require("./lib/bindReporter.js");
var _getActivationStartJs = require("./lib/getActivationStart.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const onLCP = (onReport)=>{
    const visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
    const metric = (0, _initMetricJs.initMetric)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, _getActivationStartJs.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, _observeJs.observe)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, _bindReporterJs.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, _typesJs.WINDOW).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, _onHiddenJs.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

},{"../types.js":"fTBvn","./lib/bindReporter.js":"8luFD","./lib/getActivationStart.js":"8CTeJ","./lib/getVisibilityWatcher.js":"apJF8","./lib/initMetric.js":"7ykMR","./lib/observe.js":"7fABj","./lib/onHidden.js":"6dn2k","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b7KCj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onTTFB", ()=>onTTFB);
var _typesJs = require("../types.js");
var _bindReporterJs = require("./lib/bindReporter.js");
var _getActivationStartJs = require("./lib/getActivationStart.js");
var _getNavigationEntryJs = require("./lib/getNavigationEntry.js");
var _initMetricJs = require("./lib/initMetric.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const whenReady = (callback)=>{
    if (!(0, _typesJs.WINDOW).document) return;
    if ((0, _typesJs.WINDOW).document.prerendering) addEventListener("prerenderingchange", ()=>whenReady(callback), true);
    else if ((0, _typesJs.WINDOW).document.readyState !== "complete") addEventListener("load", ()=>whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const onTTFB = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, _initMetricJs.initMetric)("TTFB");
    const report = (0, _bindReporterJs.bindReporter)(onReport, metric, opts.reportAllChanges);
    whenReady(()=>{
        const navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, _getActivationStartJs.getActivationStart)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};

},{"../types.js":"fTBvn","./lib/bindReporter.js":"8luFD","./lib/getActivationStart.js":"8CTeJ","./lib/getNavigationEntry.js":"fJLRQ","./lib/initMetric.js":"7ykMR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1srB4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_addMeasureSpans", ()=>_addMeasureSpans);
parcelHelpers.export(exports, "_addResourceSpans", ()=>_addResourceSpans);
parcelHelpers.export(exports, "addPerformanceEntries", ()=>addPerformanceEntries);
parcelHelpers.export(exports, "startTrackingINP", ()=>startTrackingINP);
parcelHelpers.export(exports, "startTrackingInteractions", ()=>startTrackingInteractions);
parcelHelpers.export(exports, "startTrackingLongTasks", ()=>startTrackingLongTasks);
parcelHelpers.export(exports, "startTrackingWebVitals", ()=>startTrackingWebVitals);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _instrumentJs = require("../instrument.js");
var _typesJs = require("../types.js");
var _getVisibilityWatcherJs = require("../web-vitals/lib/getVisibilityWatcher.js");
var _utilsJs = require("./utils.js");
var _getNavigationEntryJs = require("../web-vitals/lib/getNavigationEntry.js");
const MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function msToSec(time) {
    return time / 1000;
}
function getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, _typesJs.WINDOW) && (0, _typesJs.WINDOW).addEventListener && (0, _typesJs.WINDOW).performance;
}
let _performanceCursor = 0;
let _measurements = {};
let _lcpEntry;
let _clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function startTrackingWebVitals() {
    const performance = getBrowserPerformanceAPI();
    if (performance && (0, _utils.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, _typesJs.WINDOW).performance.mark("sentry-tracing-init");
        const fidCallback = _trackFID();
        const clsCallback = _trackCLS();
        const lcpCallback = _trackLCP();
        const ttfbCallback = _trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function startTrackingLongTasks() {
    (0, _instrumentJs.addPerformanceInstrumentationHandler)("longtask", ({ entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, _core.getActiveTransaction)();
            if (!transaction) return;
            const startTime = msToSec((0, _utils.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function startTrackingInteractions() {
    (0, _instrumentJs.addPerformanceInstrumentationHandler)("event", ({ entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, _core.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = msToSec((0, _utils.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = msToSec(entry.duration);
                const span = {
                    description: (0, _utils.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, _utils.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function startTrackingINP(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = getBrowserPerformanceAPI();
    if (performance && (0, _utils.browserPerformanceTimeOrigin)) {
        const inpCallback = _trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function _trackCLS() {
    return (0, _instrumentJs.addClsInstrumentationHandler)(({ metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding CLS");
        _measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        _clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function _trackLCP() {
    return (0, _instrumentJs.addLcpInstrumentationHandler)(({ metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding LCP");
        _measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        _lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function _trackFID() {
    return (0, _instrumentJs.addFidInstrumentationHandler)(({ metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = msToSec((0, _utils.browserPerformanceTimeOrigin));
        const startTime = msToSec(entry.startTime);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding FID");
        _measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        _measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function _trackTtfb() {
    return (0, _instrumentJs.addTtfbInstrumentationHandler)(({ metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding TTFB");
        _measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function _trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, _instrumentJs.addInpInstrumentationHandler)(({ metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, _core.getClient)();
        if (!entry || !client) return;
        const interactionType = INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = msToSec((0, _utils.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName, parentContext, activeTransaction, user, replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, _core.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, _utils.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, _core.createSpanEnvelope)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function addPerformanceEntries(transaction) {
    const performance = getBrowserPerformanceAPI();
    if (!performance || !(0, _typesJs.WINDOW).performance.getEntries || !(0, _utils.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = msToSec((0, _utils.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op, start_timestamp: transactionStartTime } = (0, _core.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice(_performanceCursor).forEach((entry)=>{
        const startTime = msToSec(entry.startTime);
        const duration = msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                _addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding FP");
                        _measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding FCP");
                        _measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                _addResourceSpans(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    _performanceCursor = Math.max(performanceEntries.length - 1, 0);
    _trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        _addTtfbRequestTimeToMeasurements(_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = _measurements[name].value;
            const measurementTimestamp = timeOrigin + msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            _measurements[name].value = normalizedValue;
        });
        const fidMark = _measurements["mark.fid"];
        if (fidMark && _measurements["fid"]) {
            // create span for FID
            (0, _utilsJs._startChild)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + msToSec(_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete _measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in _measurements)) delete _measurements.cls;
        Object.keys(_measurements).forEach((measurementName)=>{
            (0, _core.setMeasurement)(measurementName, _measurements[measurementName].value, _measurements[measurementName].unit);
        });
        _tagMetricInfo(transaction);
    }
    _lcpEntry = undefined;
    _clsEntry = undefined;
    _measurements = {};
}
/** Create measure related spans */ function _addMeasureSpans(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, _utilsJs._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    _addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    _addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    _addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    _addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function _addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, _utilsJs._startChild)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + msToSec(start),
        endTimestamp: timeOrigin + msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, _utilsJs._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + msToSec(entry.requestStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
        (0, _utilsJs._startChild)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + msToSec(entry.responseStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function _addResourceSpans(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, _utils.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, _typesJs.WINDOW).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, _utilsJs._startChild)(transaction, {
        description: resourceUrl.replace((0, _typesJs.WINDOW).location.origin, ""),
        endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp,
        data
    });
}
/**
 * Capture the information of the user agent.
 */ function _trackNavigator(transaction) {
    const navigator = (0, _typesJs.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, _utilsJs.isMeasurementValue)(connection.rtt)) _measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, _utilsJs.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, _utilsJs.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function _tagMetricInfo(transaction) {
    if (_lcpEntry) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if (_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, _utils.htmlTreeAsString)(_lcpEntry.element));
        if (_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", _lcpEntry.id);
        if (_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", _lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", _lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (_clsEntry && _clsEntry.sources) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding CLS Data");
        _clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, _utils.htmlTreeAsString)(source.node)));
    }
}
function setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function _addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    if (!navEntry) return;
    const { responseStart, requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, _core.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, _typesJs.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, _core.isValidSampleRate)(sampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../../common/debug-build.js":"4kXV7","../instrument.js":"5D0uU","../types.js":"fTBvn","../web-vitals/lib/getVisibilityWatcher.js":"apJF8","./utils.js":"clCLp","../web-vitals/lib/getNavigationEntry.js":"fJLRQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"clCLp":[function(require,module,exports) {
/**
 * Checks if a given value is a valid measurement value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_startChild", ()=>_startChild);
parcelHelpers.export(exports, "isMeasurementValue", ()=>isMeasurementValue);
function isMeasurementValue(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function _startChild(transaction, { startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp,
        ...ctx
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h4Tnq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_TRACE_PROPAGATION_TARGETS", ()=>DEFAULT_TRACE_PROPAGATION_TARGETS);
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", ()=>defaultRequestInstrumentationOptions);
parcelHelpers.export(exports, "extractNetworkProtocol", ()=>extractNetworkProtocol);
parcelHelpers.export(exports, "instrumentOutgoingRequests", ()=>instrumentOutgoingRequests);
parcelHelpers.export(exports, "shouldAttachHeaders", ()=>shouldAttachHeaders);
parcelHelpers.export(exports, "xhrCallback", ()=>xhrCallback);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _fetchJs = require("../common/fetch.js");
var _instrumentJs = require("./instrument.js");
var _typesJs = require("./types.js");
/* eslint-disable max-lines */ const DEFAULT_TRACE_PROPAGATION_TARGETS = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
    tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS
};
/** Registers span creators for xhr and fetch requests  */ function instrumentOutgoingRequests(_options) {
    const { traceFetch, traceXHR, // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest, enableHTTPTimings } = {
        traceFetch: defaultRequestInstrumentationOptions.traceFetch,
        traceXHR: defaultRequestInstrumentationOptions.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, _utils.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, _fetchJs.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, _utils.parseUrl)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, _utils.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) addHTTPTimings(createdSpan);
    });
}
function isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function addHTTPTimings(span) {
    const { url } = (0, _core.spanToJSON)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, _instrumentJs.addPerformanceInstrumentationHandler)("resource", ({ entries })=>{
        entries.forEach((entry)=>{
            if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function extractNetworkProtocol(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name,
        version
    };
}
function getAbsoluteTime(time = 0) {
    return (((0, _utils.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function resourceTimingEntryToSpanData(resourceTiming) {
    const { name, version } = extractNetworkProtocol(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, _utils.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function shouldAttachHeaders(url, tracePropagationTargets) {
    return (0, _utils.stringMatchesSomePattern)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, _utils.SENTRY_XHR_DATA_KEY];
    if (!(0, _core.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, _core.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, _core.getCurrentScope)();
    const isolationScope = (0, _core.getIsolationScope)();
    const fullUrl = getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, _utils.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, _core.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, _core.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId, spanId, sampled, dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, _core.spanToTraceHeader)(span) : (0, _utils.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, _utils.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, _core.getDynamicSamplingContextFromSpan)(span) : (0, _core.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, _utils.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, _typesJs.WINDOW).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../common/fetch.js":"8jlmw","./instrument.js":"5D0uU","./types.js":"fTBvn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8jlmw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTracingHeadersToFetchRequest", ()=>addTracingHeadersToFetchRequest);
parcelHelpers.export(exports, "instrumentFetchRequest", ()=>instrumentFetchRequest);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, _core.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, _core.getCurrentScope)();
    const client = (0, _core.getClient)();
    const { method, url } = handlerData.fetchData;
    const fullUrl = getFullURL(url);
    const host = fullUrl ? (0, _utils.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, _core.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function addTracingHeadersToFetchRequest(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, _core.getIsolationScope)();
    const { traceId, spanId, sampled, dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, _core.spanToTraceHeader)(span) : (0, _utils.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, _utils.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, _core.getDynamicSamplingContextFromSpan)(span) : (0, _core.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, _utils.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, _utils.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, _utils.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, _utils.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, _core.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"18gR1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentRoutingWithDefaults", ()=>instrumentRoutingWithDefaults);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _typesJs = require("./types.js");
/**
 * Default function implementing pageload and navigation transactions
 */ function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, _typesJs.WINDOW) || !(0, _typesJs.WINDOW).location) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, _typesJs.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, _typesJs.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, _utils.browserPerformanceTimeOrigin) ? (0, _utils.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, _utils.addHistoryInstrumentationHandler)(({ to, from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, _typesJs.WINDOW).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}

},{"@sentry/utils":"5XfgR","../common/debug-build.js":"4kXV7","./types.js":"fTBvn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bPl5o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BROWSER_TRACING_INTEGRATION_ID", ()=>BROWSER_TRACING_INTEGRATION_ID);
parcelHelpers.export(exports, "browserTracingIntegration", ()=>browserTracingIntegration);
parcelHelpers.export(exports, "getMetaContent", ()=>getMetaContent);
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", ()=>startBrowserTracingNavigationSpan);
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", ()=>startBrowserTracingPageLoadSpan);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _backgroundtabJs = require("./backgroundtab.js");
var _instrumentJs = require("./instrument.js");
var _indexJs = require("./metrics/index.js");
var _requestJs = require("./request.js");
var _typesJs = require("./types.js");
const BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
/** Options for Browser Tracing integration */ const DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, _core.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, _requestJs.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const browserTracingIntegration = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, _debugBuildJs.DEBUG_BUILD) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, _core.addTracingExtensions)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, _indexJs.startTrackingWebVitals)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, _indexJs.startTrackingINP)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, _indexJs.startTrackingLongTasks)();
    if (options._experiments.enableInteractions) (0, _indexJs.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, _core.getCurrentHub)();
        const { beforeStartSpan, idleTimeout, finalTimeout, heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? getMetaContent("sentry-trace") : "";
            const baggage = isPageloadTransaction ? getMetaContent("baggage") : undefined;
            const { traceId, dsc, parentSpanId, sampled } = (0, _utils.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId,
                parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location } = (0, _typesJs.WINDOW);
        const idleTransaction = (0, _core.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, _typesJs.WINDOW).document) {
            (0, _typesJs.WINDOW).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, _indexJs.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: BROWSER_TRACING_INTEGRATION_ID,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan, traceFetch, traceXHR, shouldCreateSpanForRequest, enableHTTPTimings, _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, _debugBuildJs.DEBUG_BUILD) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, _utils.logger).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, _typesJs.WINDOW).location && (0, _typesJs.WINDOW).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing current transaction with op: ${(0, _core.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing current transaction with op: ${(0, _core.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, _typesJs.WINDOW).location) {
                const context = {
                    name: (0, _typesJs.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, _utils.browserPerformanceTimeOrigin) ? (0, _utils.browserPerformanceTimeOrigin) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
                    }
                };
                startBrowserTracingPageLoadSpan(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, _typesJs.WINDOW).location) (0, _utils.addHistoryInstrumentationHandler)(({ to, from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, _typesJs.WINDOW).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url"
                        }
                    };
                    startBrowserTracingNavigationSpan(client, context);
                }
            });
            if (markBackgroundSpan) (0, _backgroundtabJs.registerBackgroundTabDetection)();
            if (_experiments.enableInteractions) registerInteractionListener(options, latestRoute);
            if (options.enableInp) registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, _requestJs.instrumentOutgoingRequests)({
                traceFetch,
                traceXHR,
                tracePropagationTargets,
                shouldCreateSpanForRequest,
                enableHTTPTimings
            });
        },
        // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingPageLoadSpan(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, _core.getActiveSpan)();
    const op = span && (0, _core.spanToJSON)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingNavigationSpan(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, _core.getActiveSpan)();
    const op = span && (0, _core.spanToJSON)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, _utils.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout, finalTimeout, heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, _core.getActiveTransaction)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location } = (0, _typesJs.WINDOW);
        const context = {
            name: latestRoute.name,
            op,
            trimEnd: true,
            data: {
                [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.context ? getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, _core.startIdleTransaction)(// eslint-disable-next-line deprecation/deprecation
        (0, _core.getCurrentHub)(), context, idleTimeout, finalTimeout, true, {
            location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        if ((0, _typesJs.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries })=>{
        const client = (0, _core.getClient)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, _core.getActiveTransaction)();
        const currentScope = (0, _core.getCurrentScope)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if (isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName,
                            duration,
                            parentContext,
                            user,
                            activeTransaction,
                            replayId,
                            startTime
                        };
                    }
                }
            }
        });
    };
    (0, _instrumentJs.addPerformanceInstrumentationHandler)("event", handleEntries);
    (0, _instrumentJs.addPerformanceInstrumentationHandler)("first-input", handleEntries);
}
function getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../common/debug-build.js":"4kXV7","./backgroundtab.js":"bTCyK","./instrument.js":"5D0uU","./metrics/index.js":"1srB4","./request.js":"h4Tnq","./types.js":"fTBvn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"akbBW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addExtensionMethods", ()=>addExtensionMethods);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, _core.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, _utils.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, _utils.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, _utils.dynamicRequire)(module, "./node/integrations/mysql");
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, _utils.dynamicRequire)(module, "./node/integrations/postgres");
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, _utils.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, _core.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, _utils.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"frCMF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserClient", ()=>BrowserClient);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var _eventbuilderJs = require("./eventbuilder.js");
var _helpersJs = require("./helpers.js");
var _userfeedbackJs = require("./userfeedback.js");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class BrowserClient extends (0, _core.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, _helpersJs.WINDOW).SENTRY_SDK_SOURCE || (0, _utils.getSDKSource)();
        (0, _core.applySdkMetadata)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, _helpersJs.WINDOW).document) (0, _helpersJs.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, _helpersJs.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, _eventbuilderJs.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, _eventbuilderJs.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, _userfeedbackJs.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, _utils.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, _utils.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","./debug-build.js":"auUOe","./eventbuilder.js":"jEksv","./helpers.js":"2KfuB","./userfeedback.js":"iiLle","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"auUOe":[function(require,module,exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", ()=>DEBUG_BUILD);
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jEksv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromError", ()=>eventFromError);
parcelHelpers.export(exports, "eventFromException", ()=>eventFromException);
parcelHelpers.export(exports, "eventFromMessage", ()=>eventFromMessage);
parcelHelpers.export(exports, "eventFromPlainObject", ()=>eventFromPlainObject);
parcelHelpers.export(exports, "eventFromString", ()=>eventFromString);
parcelHelpers.export(exports, "eventFromUnknownInput", ()=>eventFromUnknownInput);
parcelHelpers.export(exports, "exceptionFromError", ()=>exceptionFromError);
parcelHelpers.export(exports, "parseStackFrames", ()=>parseStackFrames);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * This function creates an exception from a JavaScript Error
 */ function exceptionFromError(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = parseStackFrames(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, _core.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, _utils.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, _utils.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if (reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function eventFromException(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
    (0, _utils.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, _utils.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, _utils.isDOMError)(exception) || (0, _utils.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, _utils.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, _utils.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, _utils.isError)(exception)) // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
    if ((0, _utils.isPlainObject)(exception) || (0, _utils.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, _utils.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, _utils.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, _utils.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames
                    }
                }
            ]
        };
    }
    if ((0, _utils.isParameterizedString)(message)) {
        const { __sentry_template_string__, __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }) {
    const keys = (0, _utils.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, _utils.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, _utils.isEvent)(exception)) {
        const className = getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iiLle":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUserFeedbackEnvelope", ()=>createUserFeedbackEnvelope);
var _utils = require("@sentry/utils");
/**
 * Creates an envelope from a user feedback.
 */ function createUserFeedbackEnvelope(feedback, { metadata, tunnel, dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, _utils.dsnToString)(dsn)
        }
    };
    const item = createUserFeedbackEnvelopeItem(feedback);
    return (0, _utils.createEnvelope)(headers, [
        item
    ]);
}
function createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"arrPs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFetchTransport", ()=>makeFetchTransport);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _utilsJs = require("./utils.js");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function makeFetchTransport(options, nativeFetch = (0, _utilsJs.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, _utilsJs.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, _utils.rejectedSyncPromise)(e);
        }
    }
    return (0, _core.createTransport)(options, makeRequest);
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","./utils.js":"ayyYB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ayyYB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearCachedFetchImplementation", ()=>clearCachedFetchImplementation);
parcelHelpers.export(exports, "getNativeFetchImplementation", ()=>getNativeFetchImplementation);
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
let cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function getNativeFetchImplementation() {
    if (cachedFetchImpl) return cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, _utils.isNativeFetch)((0, _helpersJs.WINDOW).fetch)) return cachedFetchImpl = (0, _helpersJs.WINDOW).fetch.bind((0, _helpersJs.WINDOW));
    const document = (0, _helpersJs.WINDOW).document;
    let fetchImpl = (0, _helpersJs.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return cachedFetchImpl = fetchImpl.bind((0, _helpersJs.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function clearCachedFetchImplementation() {
    cachedFetchImpl = undefined;
}

},{"@sentry/utils":"5XfgR","../debug-build.js":"auUOe","../helpers.js":"2KfuB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dX3I8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeXHRTransport", ()=>makeXHRTransport);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function makeXHRTransport(options) {
    function makeRequest(request) {
        return new (0, _utils.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, _core.createTransport)(options, makeRequest);
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gAGHp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chromeStackLineParser", ()=>chromeStackLineParser);
parcelHelpers.export(exports, "defaultStackLineParsers", ()=>defaultStackLineParsers);
parcelHelpers.export(exports, "defaultStackParser", ()=>defaultStackParser);
parcelHelpers.export(exports, "geckoStackLineParser", ()=>geckoStackLineParser);
parcelHelpers.export(exports, "opera10StackLineParser", ()=>opera10StackLineParser);
parcelHelpers.export(exports, "opera11StackLineParser", ()=>opera11StackLineParser);
parcelHelpers.export(exports, "winjsStackLineParser", ()=>winjsStackLineParser);
var _utils = require("@sentry/utils");
// global reference to slice
const UNKNOWN_FUNCTION = "?";
const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    const frame = {
        filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const chromeStackParserFn = (line)=>{
    const parts = chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const chromeStackLineParser = [
    CHROME_PRIORITY,
    chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const gecko = (line)=>{
    const parts = geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || UNKNOWN_FUNCTION;
        [func, filename] = extractSafariExtensionDetails(func, filename);
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const geckoStackLineParser = [
    GECKO_PRIORITY,
    gecko
];
const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const winjs = (line)=>{
    const parts = winjsRegex.exec(line);
    return parts ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const winjsStackLineParser = [
    WINJS_PRIORITY,
    winjs
];
const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const opera10 = (line)=>{
    const parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const opera10StackLineParser = [
    OPERA10_PRIORITY,
    opera10
];
const opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const opera11 = (line)=>{
    const parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const opera11StackLineParser = [
    OPERA11_PRIORITY,
    opera11
];
const defaultStackLineParsers = [
    chromeStackLineParser,
    geckoStackLineParser,
    winjsStackLineParser
];
const defaultStackParser = (0, _utils.createStackParser)(...defaultStackLineParsers);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

},{"@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"BPFBM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureUserFeedback", ()=>captureUserFeedback);
parcelHelpers.export(exports, "defaultIntegrations", ()=>defaultIntegrations);
parcelHelpers.export(exports, "forceLoad", ()=>forceLoad);
parcelHelpers.export(exports, "getDefaultIntegrations", ()=>getDefaultIntegrations);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "onLoad", ()=>onLoad);
parcelHelpers.export(exports, "showReportDialog", ()=>showReportDialog);
parcelHelpers.export(exports, "wrap", ()=>wrap);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _clientJs = require("./client.js");
var _debugBuildJs = require("./debug-build.js");
var _helpersJs = require("./helpers.js");
var _breadcrumbsJs = require("./integrations/breadcrumbs.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _globalhandlersJs = require("./integrations/globalhandlers.js");
var _httpcontextJs = require("./integrations/httpcontext.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _trycatchJs = require("./integrations/trycatch.js");
var _stackParsersJs = require("./stack-parsers.js");
var _fetchJs = require("./transports/fetch.js");
var _xhrJs = require("./transports/xhr.js");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const defaultIntegrations = [
    (0, _core.inboundFiltersIntegration)(),
    (0, _core.functionToStringIntegration)(),
    (0, _trycatchJs.browserApiErrorsIntegration)(),
    (0, _breadcrumbsJs.breadcrumbsIntegration)(),
    (0, _globalhandlersJs.globalHandlersIntegration)(),
    (0, _linkederrorsJs.linkedErrorsIntegration)(),
    (0, _dedupeJs.dedupeIntegration)(),
    (0, _httpcontextJs.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function getDefaultIntegrations(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...defaultIntegrations
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function init(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = getDefaultIntegrations();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, _helpersJs.WINDOW).SENTRY_RELEASE && (0, _helpersJs.WINDOW).SENTRY_RELEASE.id) options.release = (0, _helpersJs.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, _utils.stackParserFromStackParserOptions)(options.stackParser || (0, _stackParsersJs.defaultStackParser)),
        integrations: (0, _core.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, _utils.supportsFetch)() ? (0, _fetchJs.makeFetchTransport) : (0, _xhrJs.makeXHRTransport))
    };
    (0, _core.initAndBind)((0, _clientJs.BrowserClient), clientOptions);
    if (options.autoSessionTracking) startSessionTracking();
}
const showReportDialog = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, _core.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, _helpersJs.WINDOW).document) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client, scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, _helpersJs.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, _core.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, _helpersJs.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, _helpersJs.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, _helpersJs.WINDOW).document.head || (0, _helpersJs.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function forceLoad() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function onLoad(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return (0, _helpersJs.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function startSessionTracking() {
    if (typeof (0, _helpersJs.WINDOW).document === "undefined") {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, _core.startSession)({
        ignoreDuration: true
    });
    (0, _core.captureSession)();
    // We want to create a session for every navigation as well
    (0, _utils.addHistoryInstrumentationHandler)(({ from, to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, _core.startSession)({
                ignoreDuration: true
            });
            (0, _core.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function captureUserFeedback(feedback) {
    const client = (0, _core.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","./client.js":"frCMF","./debug-build.js":"auUOe","./helpers.js":"2KfuB","./integrations/breadcrumbs.js":"6G3dh","./integrations/dedupe.js":"jgxJx","./integrations/globalhandlers.js":"eP5eB","./integrations/httpcontext.js":"lPmmT","./integrations/linkederrors.js":"2EBDN","./integrations/trycatch.js":"6Ym6g","./stack-parsers.js":"gAGHp","./transports/fetch.js":"arrPs","./transports/xhr.js":"dX3I8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6G3dh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", ()=>Breadcrumbs);
parcelHelpers.export(exports, "breadcrumbsIntegration", ()=>breadcrumbsIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const MAX_ALLOWED_STRING_LENGTH = 1024;
const INTEGRATION_NAME = "Breadcrumbs";
const _breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, _utils.addConsoleInstrumentationHandler)(_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, _utils.addClickKeypressInstrumentationHandler)(_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, _utils.addXhrInstrumentationHandler)(_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, _utils.addFetchInstrumentationHandler)(_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, _utils.addHistoryInstrumentationHandler)(_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", _getSentryBreadcrumbHandler(client));
        }
    };
};
const breadcrumbsIntegration = (0, _core.defineIntegration)(_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const Breadcrumbs = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function _getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, _core.getClient)() !== client) return;
        (0, _core.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, _utils.getEventDescription)(event)
        }, {
            event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function _getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = _isEvent(event) ? event.target : event;
            target = (0, _utils.htmlTreeAsString)(element, {
                keyAttrs,
                maxStringLength
            });
            componentName = (0, _utils.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, _core.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function _getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, _utils.severityLevelFromString)(handlerData.level),
            message: (0, _utils.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, _utils.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, _core.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function _getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        const { startTimestamp, endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, _utils.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method, url, status_code, body } = sentryXhrData;
        const data = {
            method,
            url,
            status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp,
            endTimestamp
        };
        (0, _core.addBreadcrumb)({
            category: "xhr",
            data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function _getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        const { startTimestamp, endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp,
                endTimestamp
            };
            (0, _core.addBreadcrumb)({
                category: "fetch",
                data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response,
                startTimestamp,
                endTimestamp
            };
            (0, _core.addBreadcrumb)({
                category: "fetch",
                data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function _getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, _utils.parseUrl)((0, _helpersJs.WINDOW).location.href);
        let parsedFrom = from ? (0, _utils.parseUrl)(from) : undefined;
        const parsedTo = (0, _utils.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, _core.addBreadcrumb)({
            category: "navigation",
            data: {
                from,
                to
            }
        });
    };
}
function _isEvent(event) {
    return !!event && !!event.target;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../debug-build.js":"auUOe","../helpers.js":"2KfuB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jgxJx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dedupe", ()=>Dedupe);
parcelHelpers.export(exports, "dedupeIntegration", ()=>dedupeIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
const INTEGRATION_NAME = "Dedupe";
const _dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const dedupeIntegration = (0, _core.defineIntegration)(_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const Dedupe = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, dedupeIntegration);
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = _getExceptionFromEvent(previousEvent);
    const currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = _getFramesFromEvent(currentEvent);
    let previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../debug-build.js":"auUOe","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eP5eB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", ()=>GlobalHandlers);
parcelHelpers.export(exports, "globalHandlersIntegration", ()=>globalHandlersIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _eventbuilderJs = require("../eventbuilder.js");
var _helpersJs = require("../helpers.js");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const INTEGRATION_NAME = "GlobalHandlers";
const _globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                _installGlobalOnErrorHandler(client);
                globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                _installGlobalOnUnhandledRejectionHandler(client);
                globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const globalHandlersIntegration = (0, _core.defineIntegration)(_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const GlobalHandlers = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
    (0, _utils.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser, attachStacktrace } = getOptions();
        if ((0, _core.getClient)() !== client || (0, _helpersJs.shouldIgnoreOnError)()) return;
        const { msg, url, line, column, error } = data;
        const event = error === undefined && (0, _utils.isString)(msg) ? _eventFromIncompleteOnError(msg, url, line, column) : _enhanceEventWithInitialFrame((0, _eventbuilderJs.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, _core.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
    (0, _utils.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser, attachStacktrace } = getOptions();
        if ((0, _core.getClient)() !== client || (0, _helpersJs.shouldIgnoreOnError)()) return;
        const error = _getUnhandledRejectionError(e);
        const event = (0, _utils.isPrimitive)(error) ? _eventFromRejectionWithPrimitive(error) : (0, _eventbuilderJs.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, _core.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function _getUnhandledRejectionError(error) {
    if ((0, _utils.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, _utils.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, _utils.isString)(url) && url.length > 0 ? url : (0, _utils.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno,
        filename,
        function: "?",
        in_app: true,
        lineno
    });
    return event;
}
function globalHandlerLog(type) {
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Global Handler attached: ${type}`);
}
function getOptions() {
    const client = (0, _core.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../debug-build.js":"auUOe","../eventbuilder.js":"jEksv","../helpers.js":"2KfuB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lPmmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpContext", ()=>HttpContext);
parcelHelpers.export(exports, "httpContextIntegration", ()=>httpContextIntegration);
var _core = require("@sentry/core");
var _helpersJs = require("../helpers.js");
const INTEGRATION_NAME = "HttpContext";
const _httpContextIntegration = ()=>{
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, _helpersJs.WINDOW).navigator && !(0, _helpersJs.WINDOW).location && !(0, _helpersJs.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, _helpersJs.WINDOW).location && (0, _helpersJs.WINDOW).location.href;
            const { referrer } = (0, _helpersJs.WINDOW).document || {};
            const { userAgent } = (0, _helpersJs.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url
                },
                headers
            };
            event.request = request;
        }
    };
};
const httpContextIntegration = (0, _core.defineIntegration)(_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const HttpContext = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, httpContextIntegration);

},{"@sentry/core":"3UnXU","../helpers.js":"2KfuB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2EBDN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedErrors", ()=>LinkedErrors);
parcelHelpers.export(exports, "linkedErrorsIntegration", ()=>linkedErrorsIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _eventbuilderJs = require("../eventbuilder.js");
const DEFAULT_KEY = "cause";
const DEFAULT_LIMIT = 5;
const INTEGRATION_NAME = "LinkedErrors";
const _linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || DEFAULT_LIMIT;
    const key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, _utils.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, _eventbuilderJs.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const linkedErrorsIntegration = (0, _core.defineIntegration)(_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const LinkedErrors = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, linkedErrorsIntegration);

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../eventbuilder.js":"jEksv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Ym6g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TryCatch", ()=>TryCatch);
parcelHelpers.export(exports, "browserApiErrorsIntegration", ()=>browserApiErrorsIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _helpersJs = require("../helpers.js");
const DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const INTEGRATION_NAME = "TryCatch";
const _browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, _utils.fill)((0, _helpersJs.WINDOW), "setTimeout", _wrapTimeFunction);
            if (_options.setInterval) (0, _utils.fill)((0, _helpersJs.WINDOW), "setInterval", _wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, _utils.fill)((0, _helpersJs.WINDOW), "requestAnimationFrame", _wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, _helpersJs.WINDOW)) (0, _utils.fill)(XMLHttpRequest.prototype, "send", _wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
                eventTarget.forEach(_wrapEventTarget);
            }
        }
    };
};
const browserApiErrorsIntegration = (0, _core.defineIntegration)(_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const TryCatch = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, _helpersJs.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, _utils.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, _helpersJs.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, _utils.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, _utils.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, _utils.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, _utils.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, _utils.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, _helpersJs.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, _helpersJs.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, _utils.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, _helpersJs.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, _utils.getFunctionName)(fn),
                            target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, _helpersJs.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, _utils.getFunctionName)(fn),
                            target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, _utils.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../helpers.js":"2KfuB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5TVwd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", ()=>(0, _globalhandlersJs.GlobalHandlers));
parcelHelpers.export(exports, "TryCatch", ()=>(0, _trycatchJs.TryCatch));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbsJs.Breadcrumbs));
parcelHelpers.export(exports, "LinkedErrors", ()=>(0, _linkederrorsJs.LinkedErrors));
parcelHelpers.export(exports, "HttpContext", ()=>(0, _httpcontextJs.HttpContext));
parcelHelpers.export(exports, "Dedupe", ()=>(0, _dedupeJs.Dedupe)) /* eslint-disable deprecation/deprecation */ ;
var _globalhandlersJs = require("./globalhandlers.js");
var _trycatchJs = require("./trycatch.js");
var _breadcrumbsJs = require("./breadcrumbs.js");
var _linkederrorsJs = require("./linkederrors.js");
var _httpcontextJs = require("./httpcontext.js");
var _dedupeJs = require("./dedupe.js");

},{"./globalhandlers.js":"eP5eB","./trycatch.js":"6Ym6g","./breadcrumbs.js":"6G3dh","./linkederrors.js":"2EBDN","./httpcontext.js":"lPmmT","./dedupe.js":"jgxJx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"alMdd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalReplay", ()=>Replay$1);
parcelHelpers.export(exports, "Replay", ()=>Replay);
parcelHelpers.export(exports, "getReplay", ()=>getReplay);
parcelHelpers.export(exports, "internalGetReplay", ()=>getReplay$1);
parcelHelpers.export(exports, "internalReplayIntegration", ()=>replayIntegration$1);
parcelHelpers.export(exports, "replayIntegration", ()=>replayIntegration);
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
var _tracing = require("@sentry-internal/tracing");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const WINDOW = (0, _utils.GLOBAL_OBJ);
const REPLAY_SESSION_KEY = "sentryReplaySession";
const REPLAY_EVENT_NAME = "replay_event";
const UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const BUFFER_CHECKOUT_TIME = 60000;
const RETRY_BASE_INTERVAL = 5000;
const RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function _nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function _optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));
function isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
    const host = _optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean(_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function escapeImportStatement(rule) {
    const { cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? fixBrowserCompatibilityIssuesInCSS(Array.from(rules, stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function stringifyRule(rule) {
    let importStringified;
    if (isCSSImportRule(rule)) try {
        importStringified = stringifyStylesheet(rule.styleSheet) || escapeImportStatement(rule);
    } catch (error) {}
    else if (isCSSStyleRule(rule) && rule.selectorText.includes(":")) return fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = _optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return _nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function createMirror() {
    return new Mirror();
}
function shouldMaskInput({ maskInputOptions, tagName, type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function maskInputValue({ isMasked, element, value, maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function toLowerCase(str) {
    return str.toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
const ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? toLowerCase(type) : null;
}
function getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let _id = 1;
const tagNameRegex = new RegExp("[^a-z0-9-_:]");
const IGNORED_NODE = -2;
function genId() {
    return _id++;
}
function getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = toLowerCase(element.tagName);
    if (tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let canvasService;
let canvasCtx;
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const URL_WWW_MATCH = /^www\..*/i;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace(URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return absoluteToDoc(doc, value);
    else if (name === "srcset") return getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return absoluteToStylesheet(value, getHref());
    else if (tagName === "object" && name === "data") return absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if (elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function serializeNode(n, options) {
    const { doc, mirror, blockClass, blockSelector, unblockSelector, maskAllText, maskAttributeFn, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, inlineStylesheet, maskInputOptions = {}, maskTextFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false } = options;
    const rootId = getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId
            };
        case n.ELEMENT_NODE:
            return serializeElementNode(n, {
                doc,
                blockClass,
                blockSelector,
                unblockSelector,
                inlineStylesheet,
                maskAttributeFn,
                maskInputOptions,
                maskInputFn,
                dataURLOptions,
                inlineImages,
                recordCanvas,
                keepIframeSrcFn,
                newlyAddedElement,
                rootId,
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector
            });
        case n.TEXT_NODE:
            return serializeTextNode(n, {
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                maskTextFn,
                maskInputOptions,
                maskInputFn,
                rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: NodeType$1.CDATA,
                textContent: "",
                rootId
            };
        case n.COMMENT_NODE:
            return {
                type: NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId
            };
        default:
            return false;
    }
}
function getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function serializeTextNode(n, options) {
    const { maskAllText, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, maskTextFn, maskInputOptions, maskInputFn, rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if (_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = absoluteToStylesheet(textContent, getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions
        });
        textContent = maskInputValue({
            isMasked: needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn
        });
    }
    return {
        type: NodeType$1.Text,
        textContent: textContent || "",
        isStyle,
        rootId
    };
}
function serializeElementNode(n, options) {
    const { doc, blockClass, blockSelector, unblockSelector, inlineStylesheet, maskInputOptions = {}, maskAttributeFn, maskInputFn, dataURLOptions = {}, inlineImages, recordCanvas, keepIframeSrcFn, newlyAddedElement = false, rootId, maskAllText, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector } = options;
    const needBlock = _isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = absoluteToStylesheet(cssText, getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = getInputType(el);
        const value = getInputValue(el, toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, shouldMaskInput({
                type,
                tagName: toUpperCase(tagName),
                maskInputOptions
            }));
            attributes.value = maskInputValue({
                isMasked: forceMask,
                element: el,
                value,
                maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!canvasService) {
            canvasService = doc.createElement("canvas");
            canvasCtx = canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                canvasService.width = image.naturalWidth;
                canvasService.height = image.naturalHeight;
                canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width, height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: NodeType$1.Element,
        tagName,
        attributes,
        childNodes: [],
        isSVG: isSVGElement(n) || undefined,
        needBlock,
        rootId,
        isCustom: isCustomElement
    };
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) return true;
    else if (sn.type === NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === "application-name" || lowerIfExists(sn.attributes.rel) === "icon" || lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === "robots" || lowerIfExists(sn.attributes.name) === "googlebot" || lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === "author" || lowerIfExists(sn.attributes.name) === "generator" || lowerIfExists(sn.attributes.name) === "framework" || lowerIfExists(sn.attributes.name) === "publisher" || lowerIfExists(sn.attributes.name) === "progid" || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === "google-site-verification" || lowerIfExists(sn.attributes.name) === "yandex-verification" || lowerIfExists(sn.attributes.name) === "csrf-token" || lowerIfExists(sn.attributes.name) === "p:domain_verify" || lowerIfExists(sn.attributes.name) === "verify-v1" || lowerIfExists(sn.attributes.name) === "verification" || lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function serializeNodeWithId(n, options) {
    const { doc, mirror, blockClass, blockSelector, unblockSelector, maskAllText, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector, skipChild = false, inlineStylesheet = true, maskInputOptions = {}, maskAttributeFn, maskTextFn, maskInputFn, slimDOMOptions, dataURLOptions = {}, inlineImages = false, recordCanvas = false, onSerialize, onIframeLoad, iframeLoadTimeout = 5000, onStylesheetLoad, stylesheetLoadTimeout = 5000, keepIframeSrcFn = ()=>false, newlyAddedElement = false } = options;
    let { preserveWhiteSpace = true } = options;
    const _serializedNode = serializeNode(n, {
        doc,
        mirror,
        blockClass,
        blockSelector,
        maskAllText,
        unblockSelector,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        inlineStylesheet,
        maskInputOptions,
        maskAttributeFn,
        maskTextFn,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = IGNORED_NODE;
    else id = genId();
    const serializedNode = Object.assign(_serializedNode, {
        id
    });
    mirror.add(n, serializedNode);
    if (id === IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === NodeType$1.Document || serializedNode.type === NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc,
            mirror,
            blockClass,
            blockSelector,
            maskAllText,
            unblockSelector,
            maskTextClass,
            unmaskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild,
            inlineStylesheet,
            maskInputOptions,
            maskAttributeFn,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            onStylesheetLoad,
            stylesheetLoadTimeout,
            keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if (isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && isShadowRoot(n.parentNode) && isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === NodeType$1.Element && serializedNode.tagName === "iframe") onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror,
                blockClass,
                blockSelector,
                unblockSelector,
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                skipChild: false,
                inlineStylesheet,
                maskInputOptions,
                maskAttributeFn,
                maskTextFn,
                maskInputFn,
                slimDOMOptions,
                dataURLOptions,
                inlineImages,
                recordCanvas,
                preserveWhiteSpace,
                onSerialize,
                onIframeLoad,
                iframeLoadTimeout,
                onStylesheetLoad,
                stylesheetLoadTimeout,
                keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = serializeNodeWithId(n, {
                doc,
                mirror,
                blockClass,
                blockSelector,
                unblockSelector,
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                skipChild: false,
                inlineStylesheet,
                maskInputOptions,
                maskAttributeFn,
                maskTextFn,
                maskInputFn,
                slimDOMOptions,
                dataURLOptions,
                inlineImages,
                recordCanvas,
                preserveWhiteSpace,
                onSerialize,
                onIframeLoad,
                iframeLoadTimeout,
                onStylesheetLoad,
                stylesheetLoadTimeout,
                keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function snapshot(n, options) {
    const { mirror = new Mirror(), blockClass = "rr-block", blockSelector = null, unblockSelector = null, maskAllText = false, maskTextClass = "rr-mask", unmaskTextClass = null, maskTextSelector = null, unmaskTextSelector = null, inlineStylesheet = true, inlineImages = false, recordCanvas = false, maskAllInputs = false, maskAttributeFn, maskTextFn, maskInputFn, slimDOM = false, dataURLOptions, preserveWhiteSpace, onSerialize, onIframeLoad, iframeLoadTimeout, onStylesheetLoad, stylesheetLoadTimeout, keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return serializeNodeWithId(n, {
        doc: n,
        mirror,
        blockClass,
        blockSelector,
        unblockSelector,
        maskAllText,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        skipChild: false,
        inlineStylesheet,
        maskInputOptions,
        maskAttributeFn,
        maskTextFn,
        maskInputFn,
        slimDOMOptions,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        preserveWhiteSpace,
        onSerialize,
        onIframeLoad,
        iframeLoadTimeout,
        onStylesheetLoad,
        stylesheetLoadTimeout,
        keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function _optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let _mirror = {
    map: {},
    getId () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) _mirror = new Proxy(_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) nowTimestamp = ()=>new Date().getTime();
function getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : _optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || _optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || _optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : _optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || _optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || _optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function isIgnored(n, mirror) {
    return mirror.getId(n) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror) {
    if (isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return isAncestorRemoved(target.parentNode, mirror);
}
function legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function hasShadowRoot(n) {
    return Boolean(_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, _utils._nullishCoalesce)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function getShadowHost(n) {
    let shadowHost = null;
    if (_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || shadowHostInDom(n);
}
const cachedImplementations = {};
function getImplementation(name) {
    const cached = cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame(...rest) {
    return getImplementation("requestAnimationFrame")(...rest);
}
function setTimeout$1(...rest) {
    return getImplementation("setTimeout")(...rest);
}
function clearTimeout$1(...rest) {
    return getImplementation("clearTimeout")(...rest);
}
var EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})(EventType || {});
var IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})(PointerTypes || {});
function _optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function isNodeInLinkedList(n) {
    return "__ln" in n;
}
class DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = _optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const moveKey = (id, parentId)=>`${id}@${parentId}`;
class MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = IGNORED_NODE;
                while(nextId === IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !inDom(n)) return;
                const parentId = isShadowRoot(n.parentNode) ? this.mirror.getId(getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if (isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if (isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if (hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId,
                        nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if (isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!isAncestorInSet(this.droppedSet, n) && !isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if (isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if (isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = getInputType(target);
                            const tagName = target.tagName;
                            value = getInputValue(target, tagName, type);
                            const isInputMasked = shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName,
                                type
                            });
                            const forceMask = needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = transformAttribute(this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if (isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || isIgnored(n, this.mirror) || !isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if (isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[moveKey(nodeId, parentId)]) deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId,
                            id: nodeId,
                            isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if (isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if (hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return _isParentRemoved(removes, n, mirror);
}
function _isParentRemoved(removes, n, mirror) {
    const { parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return _isParentRemoved(removes, parentNode, mirror);
}
function isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return _isAncestorInSet(set, n);
}
function _isAncestorInSet(set, n) {
    const { parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return _isAncestorInSet(set, parentNode);
}
let errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
function unregisterErrorHandler() {
    errorHandler = undefined;
}
const callbackWrapper = (cb)=>{
    if (!errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function _optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const mutationBuffers = [];
function getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function initMutationObserver(options, rootEl) {
    const mutationBuffer = new MutationBuffer();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = _optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor(callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function initMoveObserver({ mousemoveCb, sampling, doc, mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = throttle$1(callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = callbackWrapper(throttle$1(callbackWrapper((evt)=>{
        const target = getEventTarget(evt);
        const { clientX, clientY } = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        on("mousemove", updatePosition, doc),
        on("touchmove", updatePosition, doc),
        on("drag", updatePosition, doc)
    ];
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initMouseInteractionObserver({ mouseInteractionCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = getEventTarget(event);
            if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = PointerTypes.Pen;
                        break;
                }
                if (pointerType === PointerTypes.Touch) {
                    if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else PointerTypes.Pen;
            } else if (legacy_isTouchEvent(event)) pointerType = PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === PointerTypes.Mouse) pointerType = null;
            } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX, clientY } = e;
            callbackWrapper(mouseInteractionCb)({
                type: MouseInteractions[thisEventKey],
                id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType
                }
            });
        };
    };
    Object.keys(MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch(MouseInteractions[eventKey]){
            case MouseInteractions.MouseDown:
            case MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case MouseInteractions.TouchStart:
            case MouseInteractions.TouchEnd:
                return;
        }
        handlers.push(on(eventName, handler, doc));
    });
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initScrollObserver({ scrollCb, doc, mirror, blockClass, blockSelector, unblockSelector, sampling }) {
    const updatePosition = callbackWrapper(throttle$1(callbackWrapper((evt)=>{
        const target = getEventTarget(evt);
        if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = getWindowScroll(doc.defaultView);
            scrollCb({
                id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return on("scroll", updatePosition, doc);
}
function initViewportResizeObserver({ viewportResizeCb }, { win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = callbackWrapper(throttle$1(callbackWrapper(()=>{
        const height = getWindowHeight();
        const width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return on("resize", updateDimension, win);
}
const INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const lastInputValueMap = new WeakMap();
function initInputObserver({ inputCb, doc, mirror, blockClass, blockSelector, unblockSelector, ignoreClass, ignoreSelector, maskInputOptions, maskInputFn, sampling, userTriggeredOnInput, maskTextClass, unmaskTextClass, maskTextSelector, unmaskTextSelector }) {
    function eventHandler(event) {
        let target = getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = getInputType(target);
        let text = getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = shouldMaskInput({
            maskInputOptions,
            tagName,
            type
        });
        const forceMask = needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text,
            isChecked,
            userTriggered
        } : {
            text,
            isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: getInputValue(el, tagName, type),
                    maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            callbackWrapper(inputCb)({
                ...v,
                id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>on(eventName, callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>hookSetter(p[0], p[1], {
            set () {
                callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if (hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId,
        id
    };
}
function initStyleSheetObserver({ styleSheetRuleCb, mirror, stylesheetManager }, { win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id,
                styleId,
                adds: [
                    {
                        rule,
                        index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id,
                styleId,
                removes: [
                    {
                        index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id,
                    styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id,
                    styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if (canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if (canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if (canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if (canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id,
                    styleId,
                    adds: [
                        {
                            rule,
                            index: [
                                ...getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id, styleId } = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id,
                    styleId,
                    removes: [
                        {
                            index: [
                                ...getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function initAdoptedStyleSheetObserver({ mirror, stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? _optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : _optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = _optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor(_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return _optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = _optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function initStyleDeclarationObserver({ styleDeclarationCb, mirror, ignoreCSSAttributes, stylesheetManager }, { win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id, styleId } = getIdAndStyleId(_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id,
                styleId,
                set: {
                    property,
                    value,
                    priority
                },
                index: getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id, styleId } = getIdAndStyleId(_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id,
                styleId,
                remove: {
                    property
                },
                index: getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function initMediaInteractionObserver({ mediaInteractionCb, blockClass, blockSelector, unblockSelector, mirror, sampling, doc }) {
    const handler = callbackWrapper((type)=>throttle$1(callbackWrapper((event)=>{
            const target = getEventTarget(event);
            if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime, volume, muted, playbackRate } = target;
            mediaInteractionCb({
                type,
                id: mirror.getId(target),
                currentTime,
                volume,
                muted,
                playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        on("play", handler(0), doc),
        on("pause", handler(1), doc),
        on("seeked", handler(2), doc),
        on("volumechange", handler(3), doc),
        on("ratechange", handler(4), doc)
    ];
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initFontObserver({ fontCb, doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family,
            buffer: typeof source !== "string",
            descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout$1(callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function initSelectionObserver(param) {
    const { doc, mirror, blockClass, blockSelector, unblockSelector, selectionCb } = param;
    let collapsed = true;
    const updateSelection = callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && _optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer, startOffset, endContainer, endOffset } = range;
            const blocked = isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset,
                end: mirror.getId(endContainer),
                endOffset
            });
        }
        selectionCb({
            ranges
        });
    });
    updateSelection();
    return on("selectionchange", updateSelection);
}
function initCustomElementObserver({ doc, customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = initMutationObserver(o, o.doc);
    const mousemoveHandler = initMoveObserver(o);
    const mouseInteractionHandler = initMouseInteractionObserver(o);
    const scrollHandler = initScrollObserver(o);
    const viewportResizeHandler = initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = initInputObserver(o);
    const mediaInteractionHandler = initMediaInteractionObserver(o);
    const styleSheetObserver = initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? initFontObserver(o) : ()=>{};
    const selectionObserver = initSelectionObserver(o);
    const customElementObserver = initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return callbackWrapper(()=>{
        mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function _optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        _optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case EventType.Meta:
            case EventType.Load:
            case EventType.DomContentLoaded:
                return false;
            case EventType.Plugin:
                return e;
            case EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case IncrementalSource.Drag:
                    case IncrementalSource.TouchMove:
                    case IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case IncrementalSource.ViewportResize:
                        return false;
                    case IncrementalSource.MediaInteraction:
                    case IncrementalSource.MouseInteraction:
                    case IncrementalSource.Scroll:
                    case IncrementalSource.CanvasMutation:
                    case IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case IncrementalSource.StyleSheetRule:
                    case IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case IncrementalSource.Font:
                        return e;
                    case IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        _optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = initMutationObserver({
            ...this.bypassOptions,
            doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push(initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push(initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push(patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: stringifyRule(r),
                            index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let wrappedEmit;
let _takeFullSnapshot;
const mirror = createMirror();
function record(options = {}) {
    const { emit, checkoutEveryNms, checkoutEveryNth, blockClass = "rr-block", blockSelector = null, unblockSelector = null, ignoreClass = "rr-ignore", ignoreSelector = null, maskAllText = false, maskTextClass = "rr-mask", unmaskTextClass = null, maskTextSelector = null, unmaskTextSelector = null, inlineStylesheet = true, maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn, maskInputFn, maskTextFn, maxCanvasSize = null, packFn, sampling = {}, dataURLOptions = {}, mousemoveWait, recordCanvas = false, recordCrossOriginIframes = false, recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput = false, collectFonts = false, inlineImages = false, plugins, keepIframeSrcFn = ()=>false, ignoreCSSAttributes = new Set([]), errorHandler, onMutation, getCanvasManager } = options;
    registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = nowTimestamp();
        if ((0, _utils._optionalChain)([
            mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== EventType.FullSnapshot && !(e.type === EventType.IncrementalSnapshot && e.data.source === IncrementalSource.Mutation)) mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, _utils._optionalChain)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === EventType.IncrementalSnapshot) {
            if (e.data.source === IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
                source: IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
                source: IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
                source: IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
                source: IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new IframeManagerNoop() : new IframeManager({
        mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes,
        wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new ProcessedNodeManager();
    const canvasManager = _getCanvasManager(getCanvasManager, {
        mirror,
        win: window,
        mutationCb: (p)=>wrappedEmit({
                type: EventType.IncrementalSnapshot,
                data: {
                    source: IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas,
        blockClass,
        blockSelector,
        unblockSelector,
        maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions,
        errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new ShadowDomManagerNoop() : new ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation,
            blockClass,
            blockSelector,
            unblockSelector,
            maskAllText,
            maskTextClass,
            unmaskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            inlineStylesheet,
            maskInputOptions,
            dataURLOptions,
            maskAttributeFn,
            maskTextFn,
            maskInputFn,
            recordCanvas,
            inlineImages,
            sampling,
            slimDOMOptions,
            iframeManager,
            stylesheetManager,
            canvasManager,
            keepIframeSrcFn,
            processedNodeManager
        },
        mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        wrappedEmit({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        mutationBuffers.forEach((buf)=>buf.lock());
        const node = snapshot(document, {
            mirror,
            blockClass,
            blockSelector,
            unblockSelector,
            maskAllText,
            maskTextClass,
            unmaskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn,
            maskInputFn,
            maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions,
            recordCanvas,
            inlineImages,
            onSerialize: (n)=>{
                if (isSerializedIframe(n, mirror)) iframeManager.addIframe(n);
                if (isSerializedStylesheet(n, mirror)) stylesheetManager.trackLinkElement(n);
                if (hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        wrappedEmit({
            type: EventType.FullSnapshot,
            data: {
                node,
                initialOffset: getWindowScroll(window)
            }
        });
        mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
    };
    _takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return callbackWrapper(initObservers)({
                onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source,
                            positions
                        }
                    }),
                mouseInteractionCb: (d)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass,
                ignoreClass,
                ignoreSelector,
                maskAllText,
                maskTextClass,
                unmaskTextClass,
                maskTextSelector,
                unmaskTextSelector,
                maskInputOptions,
                inlineStylesheet,
                sampling,
                recordCanvas,
                inlineImages,
                userTriggeredOnInput,
                collectFonts,
                doc,
                maskAttributeFn,
                maskInputFn,
                maskTextFn,
                keepIframeSrcFn,
                blockSelector,
                unblockSelector,
                slimDOMOptions,
                dataURLOptions,
                mirror,
                iframeManager,
                stylesheetManager,
                shadowDomManager,
                processedNodeManager,
                canvasManager,
                ignoreCSSAttributes,
                plugins: (0, _utils._optionalChain)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>wrappedEmit({
                                        type: EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push(on("DOMContentLoaded", ()=>{
                wrappedEmit({
                    type: EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push(on("load", ()=>{
                wrappedEmit({
                    type: EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            _takeFullSnapshot = undefined;
            unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function takeFullSnapshot(isCheckout) {
    if (!_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    _takeFullSnapshot(isCheckout);
}
record.mirror = mirror;
record.takeFullSnapshot = takeFullSnapshot;
function _getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new CanvasManagerNoop();
    }
}
const ReplayEventTypeIncrementalSnapshot = 3;
const ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, _utils.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function getClosestInteractive(element) {
    const closestInteractive = element.closest(INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function getClickTargetNode(event) {
    const target = getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return getClosestInteractive(target);
}
/** Get the event target node. */ function getTargetNode(event) {
    if (isEventWithTarget(event)) return event.target;
    return event;
}
function isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function onWindowOpen(cb) {
    // Ensure to only register this once
    if (!handlers) {
        handlers = [];
        monkeyPatchWindowOpen();
    }
    handlers.push(cb);
    return ()=>{
        const pos = handlers ? handlers.indexOf(cb) : -1;
        if (pos > -1) handlers.splice(pos, 1);
    };
}
function monkeyPatchWindowOpen() {
    (0, _utils.fill)(WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if (handlers) try {
                handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply(WINDOW, args);
        };
    });
}
/** Handle a click. */ function handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount, clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs,
                    endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function ignoreElement(node, ignoreSelector) {
    if (!SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!isIncrementalEvent(event)) return;
        const { source } = event.data;
        if (source === IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if (isIncrementalMouseInteraction(event)) {
            const { type, id } = event.data;
            const node = record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function isIncrementalEvent(event) {
    return event.type === ReplayEventTypeIncrementalSnapshot;
}
function isIncrementalMouseInteraction(event) {
    return event.data.source === IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if (ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) handleClick(replay.clickDetector, result, getClickTargetNode(handlerData.event));
        addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function getBaseDomBreadcrumb(target, message) {
    const nodeId = record.mirror.getId(target);
    const node = nodeId && record.mirror.getNode(nodeId);
    const meta = node && record.mirror.getMeta(node);
    const element = meta && isElement(meta) ? meta : null;
    return {
        message,
        data: element ? {
            nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function handleDom(handlerData) {
    const { target, message } = getDomTarget(handlerData);
    return createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...getBaseDomBreadcrumb(target, message)
    });
}
function getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
        message = (0, _utils.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target,
        message
    };
}
function isElement(node) {
    return node.type === NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function getKeyboardBreadcrumb(event) {
    const { metaKey, shiftKey, ctrlKey, altKey, key, target } = event;
    // never capture for input fields
    if (!target || isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, _utils.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = getBaseDomBreadcrumb(target, message);
    return createBreadcrumb({
        category: "ui.keyDown",
        message,
        data: {
            ...baseBreadcrumb.data,
            metaKey,
            shiftKey,
            ctrlKey,
            altKey,
            key
        }
    });
}
function isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: createResourceEntry,
    paint: createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function createPerformanceEntries(entries) {
    return entries.map(createPerformanceEntry).filter(Boolean);
}
function createPerformanceEntry(entry) {
    if (!ENTRY_TYPES[entry.entryType]) return null;
    return ENTRY_TYPES[entry.entryType](entry);
}
function getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, _utils.browserPerformanceTimeOrigin) || WINDOW.performance.timeOrigin) + time) / 1000;
}
function createPaintEntry(entry) {
    const { duration, entryType, name, startTime } = entry;
    const start = getAbsoluteTime(startTime);
    return {
        type: entryType,
        name,
        start,
        end: start + duration,
        data: undefined
    };
}
function createNavigationEntry(entry) {
    const { entryType, name, decodedBodySize, duration, domComplete, encodedBodySize, domContentLoadedEventStart, domContentLoadedEventEnd, domInteractive, loadEventStart, loadEventEnd, redirectCount, startTime, transferSize, type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: getAbsoluteTime(startTime),
        end: getAbsoluteTime(domComplete),
        name,
        data: {
            size: transferSize,
            decodedBodySize,
            encodedBodySize,
            duration,
            domInteractive,
            domContentLoadedEventStart,
            domContentLoadedEventEnd,
            loadEventStart,
            loadEventEnd,
            domComplete,
            redirectCount
        }
    };
}
function createResourceEntry(entry) {
    const { entryType, initiatorType, name, responseEnd, startTime, decodedBodySize, encodedBodySize, responseStatus, transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: getAbsoluteTime(startTime),
        end: getAbsoluteTime(responseEnd),
        name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize,
            encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end,
        data: {
            value,
            size: value,
            nodeId: element ? record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, _tracing.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, _tracing.addLcpInstrumentationHandler)(({ metric })=>{
        replay.replayPerformanceEntries.push(getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function e() {
    const e = new Blob([
        r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function logInfo(message, shouldAddBreadcrumb) {
    if (!DEBUG_BUILD) return;
    (0, _utils.logger).info(message);
    if (shouldAddBreadcrumb) addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!DEBUG_BUILD) return;
    (0, _utils.logger).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        addLogBreadcrumb(message);
    }, 0);
}
function addLogBreadcrumb(message) {
    (0, _core.addBreadcrumb)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) throw new EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    DEBUG_BUILD && (0, _utils.logger).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id,
                method,
                arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class EventBufferProxy {
    constructor(worker){
        this._fallback = new EventBufferArray();
        this._compression = new EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events, hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function createEventBuffer({ useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = _loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    logInfo("[Replay] Using simple buffer");
    return new EventBufferArray();
}
function _loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || _getWorkerUrl();
        if (!workerUrl) return;
        logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new EventBufferProxy(worker);
    } catch (error) {
        logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function _getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return e();
    return "";
}
/** If sessionStorage is available. */ function hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in WINDOW && !!WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function clearSession(replay) {
    deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function deleteSession() {
    if (!hasSessionStorage()) return;
    try {
        WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, _utils.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id,
        started,
        lastActivity,
        segmentId,
        sampled,
        previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function saveSession(session) {
    if (!hasSessionStorage()) return;
    try {
        WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function getSessionSampleType(sessionSampleRate, allowBuffering) {
    return isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function createSession({ sessionSampleRate, allowBuffering, stickySession = false }, { previousSessionId } = {}) {
    const sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = makeSession({
        sampled,
        previousSessionId
    });
    if (stickySession) saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function fetchSession(traceInternals) {
    if (!hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function isSessionExpired(session, { maxReplayDuration, sessionIdleExpire, targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function shouldRefreshSession(session, { sessionIdleExpire, maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!isSessionExpired(session, {
        sessionIdleExpire,
        maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function loadOrCreateSession({ traceInternals, sessionIdleExpire, maxReplayDuration, previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        logInfoNextTick("[Replay] Creating new session", traceInternals);
        return createSession(sessionOptions, {
            previousSessionId
        });
    }
    if (!shouldRefreshSession(existingSession, {
        sessionIdleExpire,
        maxReplayDuration
    })) return existingSession;
    logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function isCustomEvent(event) {
    return event.type === EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function addEventSync(replay, event, isCheckout) {
    if (!shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    _addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function addEvent(replay, event, isCheckout) {
    if (!shouldAddEvent(replay, event)) return Promise.resolve(null);
    return _addEvent(replay, event, isCheckout);
}
async function _addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        DEBUG_BUILD && (0, _utils.logger).error(error);
        await replay.stop({
            reason
        });
        const client = (0, _core.getClient)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && isCustomEvent(event)) return callback(event);
    } catch (error) {
        DEBUG_BUILD && (0, _utils.logger).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !isErrorEvent(event) && !isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if (isTransactionEvent(event)) {
            handleTransactionEvent(replay, event);
            return;
        }
        handleErrorEvent(replay, event);
    };
}
function handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function isBaseTransportSend() {
    const client = (0, _core.getClient)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !isErrorEvent(event)) return;
        handleHydrationError(replay, event);
    };
}
function handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = createBreadcrumb({
            category: "replay.hydrate-error"
        });
        addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if (isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if (isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            DEBUG_BUILD && (0, _utils.logger).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function createPerformanceSpans(replay, entries) {
    return entries.map(({ type, start, end, name, data })=>{
        const response = replay.throttledAddEvent({
            type: EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function handleHistory(handlerData) {
    const { from, to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, _core.isSentryRequestUrl)(url, (0, _core.getClient)());
}
/** Add a performance entry breadcrumb */ function addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if (shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function handleFetch(handlerData) {
    const { startTimestamp, endTimestamp, fetchData, response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method, url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = handleFetch(handlerData);
        addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function handleXhr(handlerData) {
    const { startTimestamp, endTimestamp, xhr } = handlerData;
    const sentryXhrData = xhr[0, _utils.SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method, url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method,
            statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = handleXhr(handlerData);
        addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = _serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            _serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    DEBUG_BUILD && (0, _utils.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp, endTimestamp, url, method, statusCode, request, response } = data;
    const result = {
        type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, _utils.dropUndefinedKeys)({
            method,
            statusCode,
            request,
            response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers
    };
    if (!body) return {
        headers,
        size: bodySize
    };
    const info = {
        headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings } = normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings
    };
    return info;
}
/** Filter a set of headers */ function getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function _serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body
    };
    const exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = _strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body
    };
}
function _strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function urlMatches(url, urls) {
    const fullUrl = getFullUrl(url);
    return (0, _utils.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function getFullUrl(url, baseURI = WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith(WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await _prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = makeNetworkReplayBreadcrumb("resource.fetch", data);
        addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        DEBUG_BUILD && (0, _utils.logger).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input, response } = hint;
    const body = input ? _getFetchRequestArgBody(input) : undefined;
    const reqSize = getBodySize(body, options.textEncoder);
    const resSize = response ? parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function _prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp = now, endTimestamp = now } = hint;
    const { url, method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? _getRequestInfo(options, hint.input, requestBodySize) : buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await _getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp,
        endTimestamp,
        url,
        method,
        statusCode,
        request,
        response
    };
}
function _getRequestInfo({ networkCaptureBodies, networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = _getFetchRequestArgBody(input);
    const [bodyStr, warning] = getBodyString(requestBody);
    const data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function _getResponseInfo(captureDetails, { networkCaptureBodies, textEncoder, networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await _parseFetchResponseBody(response);
    const result = getResponseData(bodyText, {
        networkCaptureBodies,
        textEncoder,
        responseBodySize,
        captureDetails,
        headers
    });
    if (warning) return mergeWarning(result, warning);
    return result;
}
function getResponseData(bodyText, { networkCaptureBodies, textEncoder, responseBodySize, captureDetails, headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return buildNetworkRequestOrResponse(headers, size, bodyText);
        return buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function _parseFetchResponseBody(response) {
    const res = _tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await _tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function _getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return getAllowedHeaders(headers, allowedHeaders);
}
function _tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function _tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        _getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function _getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = _prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = makeNetworkReplayBreadcrumb("resource.xhr", data);
        addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        DEBUG_BUILD && (0, _utils.logger).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr, input } = hint;
    if (!xhr) return;
    const reqSize = getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? parseContentLengthHeader(xhr.getResponseHeader("content-length")) : _getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function _prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp = now, endTimestamp = now, input, xhr } = hint;
    const { url, method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
        const request = buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp,
            endTimestamp,
            url,
            method,
            statusCode,
            request,
            response
        };
    }
    const xhrInfo = xhr[0, _utils.SENTRY_XHR_DATA_KEY];
    const networkRequestHeaders = xhrInfo ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = getAllowedHeaders(getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp,
        endTimestamp,
        url,
        method,
        statusCode,
        request: requestWarning ? mergeWarning(request, requestWarning) : request,
        response: responseWarning ? mergeWarning(response, responseWarning) : response
    };
}
function getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function _getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return _parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function _parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    DEBUG_BUILD && (0, _utils.logger).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function _getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function handleNetworkBreadcrumbs(replay) {
    const client = (0, _core.getClient)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls, networkDetailDenyUrls, networkCaptureBodies, networkRequestHeaders, networkResponseHeaders } = replay.getOptions();
        const options = {
            replay,
            textEncoder,
            networkDetailAllowUrls,
            networkDetailDenyUrls,
            networkCaptureBodies,
            networkRequestHeaders,
            networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, _utils.addFetchInstrumentationHandler)(handleFetchSpanListener(replay));
            (0, _utils.addXhrInstrumentationHandler)(handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        DEBUG_BUILD && (0, _utils.logger).warn("Error when enriching network breadcrumb");
    }
}
function _isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function _isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function _isXhrHint(hint) {
    return hint && hint.xhr;
}
function _isFetchHint(hint) {
    return hint && hint.response;
}
let _LAST_BREADCRUMB = null;
function isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = handleScope(scope);
        if (!result) return;
        addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if (_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    _LAST_BREADCRUMB = newBreadcrumb;
    if (!isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return normalizeConsoleBreadcrumb(newBreadcrumb);
    return createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, _utils.normalize)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, _core.getCurrentScope)();
    const client = (0, _core.getClient)();
    scope.addScopeListener(handleScopeListener(replay));
    (0, _utils.addClickKeypressInstrumentationHandler)(handleDomListener(replay));
    (0, _utils.addHistoryInstrumentationHandler)(handleHistorySpanListener(replay));
    handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = handleGlobalEventListener(replay, !hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, _core.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (hasHooks(client)) {
        client.on("beforeSendEvent", handleBeforeSendEvent(replay));
        client.on("afterSendEvent", handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all(createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            createMemoryEntry(WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit,
                totalJSHeapSize,
                usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            DEBUG_BUILD && (0, _utils.logger).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    addEventSync(replay, createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, _utils.createEnvelope)((0, _utils.createEventEnvelopeHeaders)(replayEvent, (0, _utils.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function prepareRecordingData({ recordingData, headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function prepareReplayEvent({ client, scope, replayId: event_id, event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id,
        integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, _core.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, _core.getIsolationScope)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name, version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function sendReplayRequest({ recordingData, replayId, segmentId: segment_id, eventContext, timestamp, session }) {
    const preparedRecordingData = prepareRecordingData({
        recordingData,
        headers: {
            segment_id
        }
    });
    const { urls, errorIds, traceIds, initialTimestamp } = eventContext;
    const client = (0, _core.getClient)();
    const scope = (0, _core.getCurrentScope)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls,
        replay_id: replayId,
        segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await prepareReplayEvent({
        scope,
        client,
        replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error(UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, _utils.updateRateLimits)({}, response);
    if ((0, _utils.isRateLimited)(rateLimits, "replay")) throw new RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function sendReplay(replayData, retryConfig = {
    count: 0,
    interval: RETRY_BASE_INTERVAL
}) {
    const { recordingData, options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof TransportStatusCodeError || err instanceof RateLimitError) throw err;
        // Capture error for every failed replay
        (0, _core.setContext)("Replays", {
            _retryCount: retryConfig.count
        });
        if (DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, _core.captureException)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= RETRY_MAX_COUNT) {
            const error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const THROTTLED = "__THROTTLED";
const SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? SKIPPED : THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options, recordingOptions }){
        ReplayContainer.prototype.__init.call(this);
        ReplayContainer.prototype.__init2.call(this);
        ReplayContainer.prototype.__init3.call(this);
        ReplayContainer.prototype.__init4.call(this);
        ReplayContainer.prototype.__init5.call(this);
        ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = throttle((event, isCheckout)=>addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout, slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate, sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: BUFFER_CHECKOUT_TIME
                },
                emit: getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush = false, reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${WINDOW.location.pathname}${WINDOW.location.hash}${WINDOW.location.search}`;
        const url = `${WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === THROTTLED) {
            const breadcrumb = createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !addEventSync(this, {
                    type: ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, _core.getCurrentScope)().getTransaction();
        const attributes = lastTransaction && (0, _core.spanToJSON)(lastTransaction).data || {};
        const source = attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, _core.spanToJSON)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        DEBUG_BUILD && (0, _utils.logger).error("[Replay]", error);
        if (DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, _core.captureException)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if (shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            WINDOW.addEventListener("blur", this._handleWindowBlur);
            WINDOW.addEventListener("focus", this._handleWindowFocus);
            WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            WINDOW.removeEventListener("blur", this._handleWindowBlur);
            WINDOW.removeEventListener("focus", this._handleWindowFocus);
            WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if (WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all(createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session, eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            DEBUG_BUILD && (0, _utils.logger).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await sendReplay({
                replayId,
                recordingData,
                segmentId,
                eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, _core.getClient)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                DEBUG_BUILD && (0, _utils.logger).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                DEBUG_BUILD && (0, _utils.logger).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, _utils.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function getPrivacyOptions({ mask, unmask, block, unblock, ignore, // eslint-disable-next-line deprecation/deprecation
blockClass, // eslint-disable-next-line deprecation/deprecation
blockSelector, // eslint-disable-next-line deprecation/deprecation
maskTextClass, // eslint-disable-next-line deprecation/deprecation
maskTextSelector, // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function maskAttribute({ el, key, maskAttributes, maskAllText, privacyOptions, value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let _initialized = false;
const replayIntegration$1 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new Replay$1(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class Replay$1 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay = DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY, minReplayDuration = MIN_REPLAY_DURATION, maxReplayDuration = MAX_REPLAY_DURATION, stickySession = true, useCompression = true, workerUrl, _experiments = {}, sessionSampleRate, errorSampleRate, maskAllText = true, maskAllInputs = true, blockAllMedia = true, mutationBreadcrumbLimit = 750, mutationLimit = 10000, slowClickTimeout = 7000, slowClickIgnoreSelectors = [], networkDetailAllowUrls = [], networkDetailDenyUrls = [], networkCaptureBodies = true, networkRequestHeaders = [], networkResponseHeaders = [], mask = [], maskAttributes = [
        "title",
        "placeholder"
    ], unmask = [], block = [], unblock = [], ignore = [], maskFn, beforeAddRecordingEvent, beforeErrorSampling, // eslint-disable-next-line deprecation/deprecation
    blockClass, // eslint-disable-next-line deprecation/deprecation
    blockSelector, // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, // eslint-disable-next-line deprecation/deprecation
    maskTextClass, // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = Replay$1.id;
        const privacyOptions = getPrivacyOptions({
            mask,
            unmask,
            block,
            unblock,
            ignore,
            blockClass,
            blockSelector,
            maskTextClass,
            maskTextSelector,
            ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs,
            maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>maskAttribute({
                    maskAttributes,
                    maskAllText,
                    privacyOptions,
                    key,
                    value,
                    el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay,
            flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
            stickySession,
            sessionSampleRate,
            errorSampleRate,
            useCompression,
            workerUrl,
            blockAllMedia,
            maskAllInputs,
            maskAllText,
            mutationBreadcrumbLimit,
            mutationLimit,
            slowClickTimeout,
            slowClickIgnoreSelectors,
            networkDetailAllowUrls,
            networkDetailDenyUrls,
            networkCaptureBodies,
            networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent,
            beforeErrorSampling,
            _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, _utils.isBrowser)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return _initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        _initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, _utils.isBrowser)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, _core.getClient)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
Replay$1.__initStatic();
/** Parse Replay-related options from SDK options */ function loadReplayOptionsFromClient(initialOptions) {
    const client = (0, _core.getClient)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, _utils.dropUndefinedKeys)(initialOptions)
    };
    if (!opt) {
        (0, _utils.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, _utils.consoleSandbox)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function _getMergedNetworkHeaders(headers) {
    return [
        ...DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function getReplay$1() {
    const client = (0, _core.getClient)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const getReplay = getReplay$1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const replayIntegration = replayIntegration$1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class Replay extends Replay$1 {
}

},{"@sentry/utils":"5XfgR","@sentry/core":"3UnXU","@sentry-internal/tracing":"5gs22","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jwrAU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplayCanvas", ()=>ReplayCanvas);
parcelHelpers.export(exports, "replayCanvasIntegration", ()=>replayCanvasIntegration);
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
var NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));
function elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if (elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
const DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let _mirror = {
    map: {},
    getId () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) _mirror = new Proxy(_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
/[1-9][0-9]{12}/.test(Date.now().toString());
function closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
const cachedImplementations = {};
function getImplementation(name) {
    const cached = cachedImplementations[name];
    if (cached) return cached;
    const document = window.document;
    let impl = window[name];
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {}
    return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame(...rest) {
    return getImplementation("requestAnimationFrame")(...rest);
}
function setTimeout(...rest) {
    return getImplementation("setTimeout")(...rest);
}
var CanvasContext = /* @__PURE__ */ ((CanvasContext2)=>{
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
})(CanvasContext || {});
let errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
const callbackWrapper = (cb)=>{
    if (!errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
var encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const canvasVarMap = new Map();
function variableListFor(ctx, ctor) {
    let contextMap = canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const saveWebGLVar = (value, win, ctx)=>{
    if (!value || !(isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = encode(value);
        return {
            rr_type: name,
            base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src } = value;
        return {
            rr_type: name,
            src
        };
    } else if (value instanceof HTMLCanvasElement) {
        const name = "HTMLImageElement";
        const src = value.toDataURL();
        return {
            rr_type: name,
            src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if (isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const serializeArgs = (args, win, ctx)=>{
    return args.map((arg)=>serializeArg(arg, win, ctx));
};
const isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) setTimeout(()=>{
                    const recordArgs = serializeArgs(args, win, this);
                    cb(this.canvas, {
                        type: CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        const hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: CanvasContext["2D"],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    const handlers = [];
    try {
        const restoreHandler = patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    const ctxName = getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === "object") {
                            const contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props){
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) continue;
        try {
            if (typeof prototype[prop] !== "function") continue;
            const restoreHandler = patch(prototype, prop, function(original) {
                return function(...args) {
                    const result = original.apply(this, args);
                    saveWebGLVar(result, win, this);
                    if ("tagName" in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                        const recordArgs = serializeArgs(args, win, this);
                        const mutation = {
                            type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            const hookHandler = hookSetter(prototype, prop, {
                set (v) {
                    cb(this.canvas, {
                        type,
                        property: prop,
                        args: [
                            v
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
var r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function t() {
    const t = new Blob([
        r
    ]);
    return URL.createObjectURL(t);
}
class CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = (target, mutation)=>{
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        const { sampling = "all", win, blockClass, blockSelector, unblockSelector, maxCanvasSize, recordCanvas, dataURLOptions, errorHandler } = options;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) registerErrorHandler(errorHandler);
        if (options.enableManualSnapshot) return;
        callbackWrapper(()=>{
            if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                dataURLOptions
            });
        })();
    }
    initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
        const rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
        this.resetObservers = ()=>{
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    }
    initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
        const canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
        const canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    snapshot(canvasElement) {
        const { options } = this;
        const rafId = this.takeSnapshot(true, options.sampling === "all" ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
        this.resetObservers = ()=>{
            cancelAnimationFrame(rafId);
        };
    }
    takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
        const snapshotInProgressMap = new Map();
        const worker = new Worker(t());
        worker.onmessage = (e)=>{
            const data = e.data;
            const { id } = data;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in data)) return;
            const { base64, type, width, height } = data;
            this.mutationCb({
                id,
                type: CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64
                                            }
                                        ],
                                        type
                                    }
                                ]
                            },
                            0,
                            0,
                            width,
                            height
                        ]
                    }
                ]
            });
        };
        const timeBetweenSnapshots = 1000 / fps;
        let lastSnapshotTime = 0;
        let rafId;
        const getCanvas = (canvasElement)=>{
            if (canvasElement) return [
                canvasElement
            ];
            const matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach((canvas)=>{
                if (!isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        const takeCanvasSnapshots = (timestamp)=>{
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = onRequestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            getCanvas(canvasElement).forEach((canvas)=>{
                const id = this.mirror.getId(canvas);
                if (snapshotInProgressMap.get(id)) return;
                if (!canvas.width || !canvas.height) return;
                snapshotInProgressMap.set(id, true);
                if (!isManualSnapshot && [
                    "webgl",
                    "webgl2"
                ].includes(canvas.__context)) {
                    const context = canvas.getContext(canvas.__context);
                    if ((0, _utils._optionalChain)([
                        context,
                        "optionalAccess",
                        (_)=>_.getContextAttributes,
                        "call",
                        (_2)=>_2(),
                        "optionalAccess",
                        (_3)=>_3.preserveDrawingBuffer
                    ]) === false) context.clear(context.COLOR_BUFFER_BIT);
                }
                createImageBitmap(canvas).then((bitmap)=>{
                    worker.postMessage({
                        id,
                        bitmap,
                        width: canvas.width,
                        height: canvas.height,
                        dataURLOptions,
                        maxCanvasSize
                    }, [
                        bitmap
                    ]);
                }).catch((error)=>{
                    callbackWrapper(()=>{
                        throw error;
                    })();
                });
            });
            rafId = onRequestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = onRequestAnimationFrame(takeCanvasSnapshots);
        return rafId;
    }
    startPendingCanvasMutationFlusher() {
        onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            onRequestAnimationFrame(setLatestRAFTimestamp);
        };
        onRequestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        onRequestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const { type, ...rest } = value;
            return rest;
        });
        const { type } = valuesWithType[0];
        this.mutationCb({
            id,
            type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
const CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: "image/webp",
            quality: 0.5
        }
    }
};
const INTEGRATION_NAME = "ReplayCanvas";
const DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ const _replayCanvasIntegration = (options = {})=>{
    const [maxCanvasWidth, maxCanvasHeight] = options.maxCanvasSize || [];
    const _canvasOptions = {
        quality: options.quality || "medium",
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    let canvasManagerResolve;
    const _canvasManager = new Promise((resolve)=>canvasManagerResolve = resolve);
    return {
        name: INTEGRATION_NAME,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce () {},
        getOptions () {
            const { quality, enableManualSnapshot, maxCanvasSize } = _canvasOptions;
            return {
                enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: (getCanvasManagerOptions)=>{
                    const manager = new CanvasManager({
                        ...getCanvasManagerOptions,
                        enableManualSnapshot,
                        maxCanvasSize,
                        errorHandler: (err)=>{
                            try {
                                if (typeof err === "object") err.__rrweb__ = true;
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    });
                    canvasManagerResolve(manager);
                    return manager;
                },
                ...CANVAS_QUALITY[quality || "medium"] || CANVAS_QUALITY.medium
            };
        },
        async snapshot (canvasElement) {
            const canvasManager = await _canvasManager;
            canvasManager.snapshot(canvasElement);
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ const replayCanvasIntegration = (0, _core.defineIntegration)(_replayCanvasIntegration);
/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */ // eslint-disable-next-line deprecation/deprecation
const ReplayCanvas = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, replayCanvasIntegration);

},{"@sentry/utils":"5XfgR","@sentry/core":"3UnXU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iFDZX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feedback", ()=>Feedback);
parcelHelpers.export(exports, "feedbackIntegration", ()=>feedbackIntegration);
parcelHelpers.export(exports, "sendFeedback", ()=>sendFeedback);
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
const WINDOW = (0, _utils.GLOBAL_OBJ);
const LIGHT_BACKGROUND = "#ffffff";
const INHERIT = "inherit";
const SUBMIT_COLOR = "rgba(108, 95, 199, 1)";
const LIGHT_THEME = {
    fontFamily: "system-ui, 'Helvetica Neue', Arial, sans-serif",
    fontSize: "14px",
    background: LIGHT_BACKGROUND,
    backgroundHover: "#f6f6f7",
    foreground: "#2b2233",
    border: "1.5px solid rgba(41, 35, 47, 0.13)",
    borderRadius: "25px",
    boxShadow: "0px 4px 24px 0px rgba(43, 34, 51, 0.12)",
    success: "#268d75",
    error: "#df3338",
    submitBackground: "rgba(88, 74, 192, 1)",
    submitBackgroundHover: SUBMIT_COLOR,
    submitBorder: SUBMIT_COLOR,
    submitOutlineFocus: "#29232f",
    submitForeground: LIGHT_BACKGROUND,
    submitForegroundHover: LIGHT_BACKGROUND,
    cancelBackground: "transparent",
    cancelBackgroundHover: "var(--background-hover)",
    cancelBorder: "var(--border)",
    cancelOutlineFocus: "var(--input-outline-focus)",
    cancelForeground: "var(--foreground)",
    cancelForegroundHover: "var(--foreground)",
    inputBackground: INHERIT,
    inputForeground: INHERIT,
    inputBorder: "var(--border)",
    inputOutlineFocus: SUBMIT_COLOR,
    formBorderRadius: "20px",
    formContentBorderRadius: "6px"
};
const DEFAULT_THEME = {
    light: LIGHT_THEME,
    dark: {
        ...LIGHT_THEME,
        background: "#29232f",
        backgroundHover: "#352f3b",
        foreground: "#ebe6ef",
        border: "1.5px solid rgba(235, 230, 239, 0.15)",
        success: "#2da98c",
        error: "#f55459"
    }
};
const ACTOR_LABEL = "Report a Bug";
const CANCEL_BUTTON_LABEL = "Cancel";
const SUBMIT_BUTTON_LABEL = "Send Bug Report";
const FORM_TITLE = "Report a Bug";
const EMAIL_PLACEHOLDER = "your.email@example.org";
const EMAIL_LABEL = "Email";
const MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
const MESSAGE_LABEL = "Description";
const NAME_PLACEHOLDER = "Your Name";
const NAME_LABEL = "Name";
const IS_REQUIRED_LABEL = "(required)";
const SUCCESS_MESSAGE_TEXT = "Thank you for your report!";
const FEEDBACK_WIDGET_SOURCE = "widget";
const FEEDBACK_API_SOURCE = "api";
/**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */ async function prepareFeedbackEvent({ client, scope, event }) {
    const eventHint = {};
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, _core.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, _core.getIsolationScope)());
    if (preparedEvent === null) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "feedback", event);
        return null;
    }
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    return preparedEvent;
}
/**
 * Send feedback using transport
 */ async function sendFeedbackRequest({ feedback: { message, email, name, source, url } }, { includeReplay = true } = {}) {
    const client = (0, _core.getClient)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn) return;
    const baseEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name,
                message,
                url,
                source
            }
        },
        type: "feedback"
    };
    return (0, _core.withScope)(async (scope)=>{
        // No use for breadcrumbs in feedback
        scope.clearBreadcrumbs();
        if ([
            FEEDBACK_API_SOURCE,
            FEEDBACK_WIDGET_SOURCE
        ].includes(String(source))) scope.setLevel("info");
        const feedbackEvent = await prepareFeedbackEvent({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            scope: scope,
            client,
            event: baseEvent
        });
        if (!feedbackEvent) return;
        if (client.emit) client.emit("beforeSendFeedback", feedbackEvent, {
            includeReplay: Boolean(includeReplay)
        });
        const envelope = (0, _core.createEventEnvelope)(feedbackEvent, dsn, client.getOptions()._metadata, client.getOptions().tunnel);
        let response;
        try {
            response = await transport.send(envelope);
        } catch (err) {
            const error = new Error("Unable to send Feedback");
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
        if (!response) return;
        // Require valid status codes, otherwise can assume feedback was not sent successfully
        if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new Error("Unable to send Feedback");
        return response;
    });
}
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * Public API to send a Feedback item to Sentry
 */ function sendFeedback({ name, email, message, source = FEEDBACK_API_SOURCE, url = (0, _utils.getLocationHref)() }, options = {}) {
    if (!message) throw new Error("Unable to submit feedback with empty message");
    return sendFeedbackRequest({
        feedback: {
            name,
            email,
            message,
            url,
            source
        }
    }, options);
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function mergeOptions(defaultOptions, optionOverrides) {
    return {
        ...defaultOptions,
        ...optionOverrides,
        themeDark: {
            ...defaultOptions.themeDark,
            ...optionOverrides.themeDark
        },
        themeLight: {
            ...defaultOptions.themeLight,
            ...optionOverrides.themeLight
        }
    };
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createActorStyles(d) {
    const style = d.createElement("style");
    style.textContent = `
.widget__actor {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  line-height: 16px;

  display: flex;
  align-items: center;
  gap: 8px;

  border-radius: var(--border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 16px;
  text-decoration: none;
  z-index: 9000;

  color: var(--foreground);
  background-color: var(--background);
  border: var(--border);
  box-shadow: var(--box-shadow);
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
}

.widget__actor:hover {
  background-color: var(--background-hover);
}

.widget__actor svg {
  width: 16px;
  height: 16px;
}

.widget__actor--hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.widget__actor__text {
}

@media (max-width: 600px) {
  .widget__actor__text {
    display: none;
  }
}

.feedback-icon path {
  fill: var(--foreground);
}
`;
    return style;
}
/**
 * Creates <style> element for widget dialog
 */ function createDialogStyles(d) {
    const style = d.createElement("style");
    style.textContent = `
.dialog {
  line-height: 25px;
  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  position: fixed;
  inset: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);

  border: var(--border);
  border-radius: var(--form-border-radius);
  background-color: var(--background);
  color: var(--foreground);

  width: 320px;
  max-width: 100%;
  max-height: calc(100% - 2rem);
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}

.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  padding: 24px 24px 0 24px;
  margin: 0;
  margin-bottom: 16px;
}

.brand-link {
  display: inline-flex;
}

.error {
  color: var(--error);
  margin-bottom: 16px;
}

.form {
  display: grid;
  overflow: auto;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
}

.form__error-container {
  color: var(--error);
}

.form__error-container--hidden {
  display: none;
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: grid;
  gap: 4px;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  line-height: inherit;
  background-color: var(--input-background);
  box-sizing: border-box;
  border: var(--input-border);
  border-radius: var(--form-content-border-radius);
  color: var(--input-foreground);
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 500;
  padding: 6px 12px;
}

.form__input::placeholder {
  color: var(--input-foreground);
  opacity: 0.65;
}

.form__input:focus-visible {
  outline: 1px auto var(--input-outline-focus);
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.btn-group {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.btn {
  line-height: inherit;
  border: var(--cancel-border);
  border-radius: var(--form-content-border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 6px 16px;
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  background-color: var(--submit-background);
  border-color: var(--submit-border);
  color: var(--submit-foreground);
}
.btn--primary:hover {
  background-color: var(--submit-background-hover);
  color: var(--submit-foreground-hover);
}
.btn--primary:focus-visible {
  outline: 1px auto var(--submit-outline-focus);
}

.btn--default {
  background-color: var(--cancel-background);
  color: var(--cancel-foreground);
  font-weight: 500;
}
.btn--default:hover {
  background-color: var(--cancel-background-hover);
  color: var(--cancel-foreground-hover);
}
.btn--default:focus-visible {
  outline: 1px auto var(--cancel-outline-focus);
}

.success-message {
  background-color: var(--background);
  border: var(--border);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  font-weight: 600;
  color: var(--success);
  padding: 12px 24px;
  line-height: 25px;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success-icon path {
  fill: var(--success);
}
`;
    return style;
}
function getThemedCssVariables(theme) {
    return `
  --background: ${theme.background};
  --background-hover: ${theme.backgroundHover};
  --foreground: ${theme.foreground};
  --error: ${theme.error};
  --success: ${theme.success};
  --border: ${theme.border};
  --border-radius: ${theme.borderRadius};
  --box-shadow: ${theme.boxShadow};

  --submit-background: ${theme.submitBackground};
  --submit-background-hover: ${theme.submitBackgroundHover};
  --submit-border: ${theme.submitBorder};
  --submit-outline-focus: ${theme.submitOutlineFocus};
  --submit-foreground: ${theme.submitForeground};
  --submit-foreground-hover: ${theme.submitForegroundHover};

  --cancel-background: ${theme.cancelBackground};
  --cancel-background-hover: ${theme.cancelBackgroundHover};
  --cancel-border: ${theme.cancelBorder};
  --cancel-outline-focus: ${theme.cancelOutlineFocus};
  --cancel-foreground: ${theme.cancelForeground};
  --cancel-foreground-hover: ${theme.cancelForegroundHover};

  --input-background: ${theme.inputBackground};
  --input-foreground: ${theme.inputForeground};
  --input-border: ${theme.inputBorder};
  --input-outline-focus: ${theme.inputOutlineFocus};

  --form-border-radius: ${theme.formBorderRadius};
  --form-content-border-radius: ${theme.formContentBorderRadius};
  `;
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createMainStyles(d, colorScheme, themes) {
    const style = d.createElement("style");
    style.textContent = `
:host {
  --bottom: 1rem;
  --right: 1rem;
  --top: auto;
  --left: auto;
  --z-index: 100000;
  --font-family: ${themes.light.fontFamily};
  --font-size: ${themes.light.fontSize};

  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${getThemedCssVariables(colorScheme === "dark" ? themes.dark : themes.light)}
}

${colorScheme === "system" ? `
@media (prefers-color-scheme: dark) {
  :host {
    ${getThemedCssVariables(themes.dark)}
  }
}` : ""}
}`;
    return style;
}
/**
 * Creates shadow host
 */ function createShadowHost({ id, colorScheme, themeDark, themeLight }) {
    try {
        const doc = WINDOW.document;
        // Create the host
        const host = doc.createElement("div");
        host.id = id;
        // Create the shadow root
        const shadow = host.attachShadow({
            mode: "open"
        });
        shadow.appendChild(createMainStyles(doc, colorScheme, {
            dark: themeDark,
            light: themeLight
        }));
        shadow.appendChild(createDialogStyles(doc));
        return {
            shadow,
            host
        };
    } catch (e) {
        // Shadow DOM probably not supported
        (0, _utils.logger).warn("[Feedback] Browser does not support shadow DOM API");
        throw new Error("Browser does not support shadow DOM API.");
    }
}
/**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */ async function handleFeedbackSubmit(dialog, feedback, options) {
    if (!dialog) // Not sure when this would happen
    return;
    const showFetchError = ()=>{
        if (!dialog) return;
        dialog.showError("There was a problem submitting feedback, please wait and try again.");
    };
    dialog.hideError();
    try {
        const resp = await sendFeedback({
            ...feedback,
            source: FEEDBACK_WIDGET_SOURCE
        }, options);
        // Success!
        return resp;
    } catch (err) {
        DEBUG_BUILD && (0, _utils.logger).error(err);
        showFetchError();
    }
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(([key, val])=>{
        el.setAttributeNS(null, key, val);
    });
    return el;
}
const SIZE = 20;
const XMLNS$2 = "http://www.w3.org/2000/svg";
/**
 * Feedback Icon
 */ function Icon() {
    const createElementNS = (tagName)=>WINDOW.document.createElementNS(XMLNS$2, tagName);
    const svg = setAttributesNS(createElementNS("svg"), {
        class: "feedback-icon",
        width: `${SIZE}`,
        height: `${SIZE}`,
        viewBox: `0 0 ${SIZE} ${SIZE}`,
        fill: "none"
    });
    const g = setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_80)"
    });
    const path = setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z"
    });
    svg.appendChild(g).appendChild(path);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_80"
    });
    const speakerRect = setAttributesNS(createElementNS("rect"), {
        width: `${SIZE}`,
        height: `${SIZE}`,
        fill: "white"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */ function createElement(tagName, attributes, ...children) {
    const doc = WINDOW.document;
    const element = doc.createElement(tagName);
    if (attributes) Object.entries(attributes).forEach(([attribute, attributeValue])=>{
        if (attribute === "className" && typeof attributeValue === "string") // JSX does not allow class as a valid name
        element.setAttribute("class", attributeValue);
        else if (typeof attributeValue === "boolean" && attributeValue) element.setAttribute(attribute, "");
        else if (typeof attributeValue === "string") element.setAttribute(attribute, attributeValue);
        else if (attribute.startsWith("on") && typeof attributeValue === "function") element.addEventListener(attribute.substring(2).toLowerCase(), attributeValue);
    });
    for (const child of children)appendChild(element, child);
    return element;
}
function appendChild(parent, child) {
    const doc = WINDOW.document;
    if (typeof child === "undefined" || child === null) return;
    if (Array.isArray(child)) for (const value of child)appendChild(parent, value);
    else if (child === false) ;
    else if (typeof child === "string") parent.appendChild(doc.createTextNode(child));
    else if (child instanceof Node) parent.appendChild(child);
    else parent.appendChild(doc.createTextNode(String(child)));
}
/**
 *
 */ function Actor({ buttonLabel, onClick }) {
    function _handleClick(e) {
        onClick && onClick(e);
    }
    const el = createElement("button", {
        type: "button",
        className: "widget__actor",
        ["aria-label"]: buttonLabel,
        ["aria-hidden"]: "false"
    }, Icon().el, buttonLabel ? createElement("span", {
        className: "widget__actor__text"
    }, buttonLabel) : null);
    el.addEventListener("click", _handleClick);
    return {
        get el () {
            return el;
        },
        show: ()=>{
            el.classList.remove("widget__actor--hidden");
            el.setAttribute("aria-hidden", "false");
        },
        hide: ()=>{
            el.classList.add("widget__actor--hidden");
            el.setAttribute("aria-hidden", "true");
        }
    };
}
/**
 *
 */ function SubmitButton({ label }) {
    const el = createElement("button", {
        type: "submit",
        className: "btn btn--primary",
        ["aria-label"]: label
    }, label);
    return {
        el
    };
}
function retrieveStringValue(formData, key) {
    const value = formData.get(key);
    if (typeof value === "string") return value.trim();
    return "";
}
/**
 * Creates the form element
 */ function Form({ nameLabel, namePlaceholder, emailLabel, emailPlaceholder, messageLabel, messagePlaceholder, isRequiredLabel, cancelButtonLabel, submitButtonLabel, showName, showEmail, isNameRequired, isEmailRequired, defaultName, defaultEmail, onCancel, onSubmit }) {
    const { el: submitEl } = SubmitButton({
        label: submitButtonLabel
    });
    function handleSubmit(e) {
        e.preventDefault();
        if (!(e.target instanceof HTMLFormElement)) return;
        try {
            if (onSubmit) {
                const formData = new FormData(e.target);
                const feedback = {
                    name: retrieveStringValue(formData, "name"),
                    email: retrieveStringValue(formData, "email"),
                    message: retrieveStringValue(formData, "message")
                };
                onSubmit(feedback);
            }
        } catch (e2) {
        // pass
        }
    }
    const errorEl = createElement("div", {
        className: "form__error-container form__error-container--hidden",
        ["aria-hidden"]: "true"
    });
    function showError(message) {
        errorEl.textContent = message;
        errorEl.classList.remove("form__error-container--hidden");
        errorEl.setAttribute("aria-hidden", "false");
    }
    function hideError() {
        errorEl.textContent = "";
        errorEl.classList.add("form__error-container--hidden");
        errorEl.setAttribute("aria-hidden", "true");
    }
    const nameEl = createElement("input", {
        id: "name",
        type: showName ? "text" : "hidden",
        ["aria-hidden"]: showName ? "false" : "true",
        name: "name",
        required: isNameRequired,
        className: "form__input",
        placeholder: namePlaceholder,
        value: defaultName
    });
    const emailEl = createElement("input", {
        id: "email",
        type: showEmail ? "text" : "hidden",
        ["aria-hidden"]: showEmail ? "false" : "true",
        name: "email",
        required: isEmailRequired,
        className: "form__input",
        placeholder: emailPlaceholder,
        value: defaultEmail
    });
    const messageEl = createElement("textarea", {
        id: "message",
        autoFocus: "true",
        rows: "5",
        name: "message",
        required: true,
        className: "form__input form__input--textarea",
        placeholder: messagePlaceholder
    });
    const cancelEl = createElement("button", {
        type: "button",
        className: "btn btn--default",
        ["aria-label"]: cancelButtonLabel,
        onClick: (e)=>{
            onCancel && onCancel(e);
        }
    }, cancelButtonLabel);
    const formEl = createElement("form", {
        className: "form",
        onSubmit: handleSubmit
    }, [
        errorEl,
        showName && createElement("label", {
            htmlFor: "name",
            className: "form__label"
        }, [
            createElement("span", {
                className: "form__label__text"
            }, nameLabel, isNameRequired && createElement("span", {
                className: "form__label__text--required"
            }, ` ${isRequiredLabel}`)),
            nameEl
        ]),
        !showName && nameEl,
        showEmail && createElement("label", {
            htmlFor: "email",
            className: "form__label"
        }, [
            createElement("span", {
                className: "form__label__text"
            }, emailLabel, isEmailRequired && createElement("span", {
                className: "form__label__text--required"
            }, ` ${isRequiredLabel}`)),
            emailEl
        ]),
        !showEmail && emailEl,
        createElement("label", {
            htmlFor: "message",
            className: "form__label"
        }, [
            createElement("span", {
                className: "form__label__text"
            }, messageLabel, createElement("span", {
                className: "form__label__text--required"
            }, ` ${isRequiredLabel}`)),
            messageEl
        ]),
        createElement("div", {
            className: "btn-group"
        }, [
            submitEl,
            cancelEl
        ])
    ]);
    return {
        get el () {
            return formEl;
        },
        showError,
        hideError
    };
}
const XMLNS$1 = "http://www.w3.org/2000/svg";
/**
 * Sentry Logo
 */ function Logo({ colorScheme }) {
    const createElementNS = (tagName)=>WINDOW.document.createElementNS(XMLNS$1, tagName);
    const svg = setAttributesNS(createElementNS("svg"), {
        class: "sentry-logo",
        width: "32",
        height: "30",
        viewBox: "0 0 72 66",
        fill: "none"
    });
    const path = setAttributesNS(createElementNS("path"), {
        transform: "translate(11, 11)",
        d: "M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
    });
    svg.append(path);
    const defs = createElementNS("defs");
    const style = createElementNS("style");
    style.textContent = `
    path {
      fill: ${colorScheme === "dark" ? "#fff" : "#362d59"};
    }`;
    if (colorScheme === "system") style.textContent += `
    @media (prefers-color-scheme: dark) {
      path: {
        fill: '#fff';
      }
    }
    `;
    defs.append(style);
    svg.append(defs);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function Dialog({ formTitle, showBranding, showName, showEmail, isNameRequired, isEmailRequired, colorScheme, defaultName, defaultEmail, onClosed, onCancel, onSubmit, ...textLabels }) {
    let el = null;
    /**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */ function handleDialogClick() {
        close();
        // Only this should trigger `onClose`, we don't want the `close()` method to
        // trigger it, otherwise it can cause cycles.
        onClosed && onClosed();
    }
    /**
   * Close the dialog
   */ function close() {
        if (el) el.open = false;
    }
    /**
   * Opens the dialog
   */ function open() {
        if (el) el.open = true;
    }
    /**
   * Check if dialog is currently opened
   */ function checkIsOpen() {
        return el && el.open === true || false;
    }
    const { el: formEl, showError, hideError } = Form({
        showEmail,
        showName,
        isEmailRequired,
        isNameRequired,
        defaultName,
        defaultEmail,
        onSubmit,
        onCancel,
        ...textLabels
    });
    el = createElement("dialog", {
        className: "dialog",
        open: true,
        onClick: handleDialogClick
    }, createElement("div", {
        className: "dialog__content",
        onClick: (e)=>{
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, createElement("h2", {
        className: "dialog__header"
    }, formTitle, showBranding && createElement("a", {
        className: "brand-link",
        target: "_blank",
        href: "https://sentry.io/welcome/",
        title: "Powered by Sentry",
        rel: "noopener noreferrer"
    }, Logo({
        colorScheme
    }).el)), formEl));
    return {
        get el () {
            return el;
        },
        showError,
        hideError,
        open,
        close,
        checkIsOpen
    };
}
const WIDTH = 16;
const HEIGHT = 17;
const XMLNS = "http://www.w3.org/2000/svg";
/**
 * Success Icon (checkmark)
 */ function SuccessIcon() {
    const createElementNS = (tagName)=>WINDOW.document.createElementNS(XMLNS, tagName);
    const svg = setAttributesNS(createElementNS("svg"), {
        class: "success-icon",
        width: `${WIDTH}`,
        height: `${HEIGHT}`,
        viewBox: `0 0 ${WIDTH} ${HEIGHT}`,
        fill: "none"
    });
    const g = setAttributesNS(createElementNS("g"), {
        clipPath: "url(#clip0_57_156)"
    });
    const path2 = setAttributesNS(createElementNS("path"), {
        ["fill-rule"]: "evenodd",
        ["clip-rule"]: "evenodd",
        d: "M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z"
    });
    const path = setAttributesNS(createElementNS("path"), {
        d: "M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z"
    });
    svg.appendChild(g).append(path, path2);
    const speakerDefs = createElementNS("defs");
    const speakerClipPathDef = setAttributesNS(createElementNS("clipPath"), {
        id: "clip0_57_156"
    });
    const speakerRect = setAttributesNS(createElementNS("rect"), {
        width: `${WIDTH}`,
        height: `${WIDTH}`,
        fill: "white",
        transform: "translate(0 0.5)"
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function SuccessMessage({ message, onRemove }) {
    function remove() {
        if (!el) return;
        el.remove();
        onRemove && onRemove();
    }
    const el = createElement("div", {
        className: "success-message",
        onClick: remove
    }, SuccessIcon().el, message);
    return {
        el,
        remove
    };
}
/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */ function createWidget({ shadow, options: { shouldCreateActor = true, ...options }, attachTo }) {
    let actor;
    let dialog;
    let isDialogOpen = false;
    /**
   * Show the success message for 5 seconds
   */ function showSuccessMessage() {
        if (!shadow) return;
        try {
            const success = SuccessMessage({
                message: options.successMessageText,
                onRemove: ()=>{
                    if (timeoutId) clearTimeout(timeoutId);
                    showActor();
                }
            });
            if (!success.el) throw new Error("Unable to show success message");
            shadow.appendChild(success.el);
            const timeoutId = setTimeout(()=>{
                if (success) success.remove();
            }, 5000);
        } catch (err) {
            // TODO: error handling
            (0, _utils.logger).error(err);
        }
    }
    /**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */ async function _handleFeedbackSubmit(feedback) {
        if (!dialog) return;
        // Simple validation for now, just check for non-empty required fields
        const emptyField = [];
        if (options.isNameRequired && !feedback.name) emptyField.push(options.nameLabel);
        if (options.isEmailRequired && !feedback.email) emptyField.push(options.emailLabel);
        if (!feedback.message) emptyField.push(options.messageLabel);
        if (emptyField.length > 0) {
            dialog.showError(`Please enter in the following required fields: ${emptyField.join(", ")}`);
            return;
        }
        const result = await handleFeedbackSubmit(dialog, feedback);
        // Error submitting feedback
        if (!result) {
            if (options.onSubmitError) options.onSubmitError();
            return;
        }
        // Success
        removeDialog();
        showSuccessMessage();
        if (options.onSubmitSuccess) options.onSubmitSuccess();
    }
    /**
   * Internal handler when dialog is opened
   */ function handleOpenDialog() {
        // Flush replay if integration exists
        const client = (0, _core.getClient)();
        const replay = client && client.getIntegrationByName && client.getIntegrationByName("Replay");
        if (!replay) return;
        replay.flush().catch((err)=>{
            DEBUG_BUILD && (0, _utils.logger).error(err);
        });
    }
    /**
   * Displays the default actor
   */ function showActor() {
        actor && actor.show();
    }
    /**
   * Hides the default actor
   */ function hideActor() {
        actor && actor.hide();
    }
    /**
   * Removes the default actor element
   */ function removeActor() {
        actor && actor.el && actor.el.remove();
    }
    /**
   *
   */ function openDialog() {
        try {
            if (dialog) {
                dialog.open();
                isDialogOpen = true;
                if (options.onFormOpen) options.onFormOpen();
                handleOpenDialog();
                return;
            }
            const userKey = options.useSentryUser;
            const scope = (0, _core.getCurrentScope)();
            const user = scope && scope.getUser();
            dialog = Dialog({
                colorScheme: options.colorScheme,
                showBranding: options.showBranding,
                showName: options.showName || options.isNameRequired,
                showEmail: options.showEmail || options.isEmailRequired,
                isNameRequired: options.isNameRequired,
                isEmailRequired: options.isEmailRequired,
                formTitle: options.formTitle,
                cancelButtonLabel: options.cancelButtonLabel,
                submitButtonLabel: options.submitButtonLabel,
                emailLabel: options.emailLabel,
                emailPlaceholder: options.emailPlaceholder,
                messageLabel: options.messageLabel,
                messagePlaceholder: options.messagePlaceholder,
                nameLabel: options.nameLabel,
                namePlaceholder: options.namePlaceholder,
                isRequiredLabel: options.isRequiredLabel,
                defaultName: userKey && user && user[userKey.name] || "",
                defaultEmail: userKey && user && user[userKey.email] || "",
                onClosed: ()=>{
                    showActor();
                    isDialogOpen = false;
                    if (options.onFormClose) options.onFormClose();
                },
                onCancel: ()=>{
                    closeDialog();
                    showActor();
                },
                onSubmit: _handleFeedbackSubmit
            });
            if (!dialog.el) throw new Error("Unable to open Feedback dialog");
            shadow.appendChild(dialog.el);
            // Hides the default actor whenever dialog is opened
            hideActor();
            if (options.onFormOpen) options.onFormOpen();
            handleOpenDialog();
        } catch (err) {
            // TODO: Error handling?
            (0, _utils.logger).error(err);
        }
    }
    /**
   * Closes the dialog
   */ function closeDialog() {
        if (dialog) {
            dialog.close();
            isDialogOpen = false;
            if (options.onFormClose) options.onFormClose();
        }
    }
    /**
   * Removes the dialog element from DOM
   */ function removeDialog() {
        if (dialog) {
            closeDialog();
            const dialogEl = dialog.el;
            dialogEl && dialogEl.remove();
            dialog = undefined;
        }
    }
    /**
   *
   */ function handleActorClick() {
        // Open dialog
        if (!isDialogOpen) openDialog();
        // Hide actor button
        hideActor();
    }
    if (attachTo) attachTo.addEventListener("click", handleActorClick);
    else if (shouldCreateActor) {
        actor = Actor({
            buttonLabel: options.buttonLabel,
            onClick: handleActorClick
        });
        actor.el && shadow.appendChild(actor.el);
    }
    return {
        get actor () {
            return actor;
        },
        get dialog () {
            return dialog;
        },
        showActor,
        hideActor,
        removeActor,
        openDialog,
        closeDialog,
        removeDialog
    };
}
const doc = WINDOW.document;
const feedbackIntegration = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new Feedback(options);
};
/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */ class Feedback {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Feedback";
    }
    /**
   * @inheritDoc
   */ /**
   * Feedback configuration options
   */ /**
   * Reference to widget element that is created when autoInject is true
   */ /**
   * List of all widgets that are created from the integration
   */ /**
   * Reference to the host element where widget is inserted
   */ /**
   * Refernce to Shadow DOM root
   */ /**
   * Tracks if actor styles have ever been inserted into shadow DOM
   */ constructor({ autoInject = true, id = "sentry-feedback", isEmailRequired = false, isNameRequired = false, showBranding = true, showEmail = true, showName = true, useSentryUser = {
        email: "email",
        name: "username"
    }, themeDark, themeLight, colorScheme = "system", buttonLabel = ACTOR_LABEL, cancelButtonLabel = CANCEL_BUTTON_LABEL, submitButtonLabel = SUBMIT_BUTTON_LABEL, formTitle = FORM_TITLE, emailPlaceholder = EMAIL_PLACEHOLDER, emailLabel = EMAIL_LABEL, messagePlaceholder = MESSAGE_PLACEHOLDER, messageLabel = MESSAGE_LABEL, namePlaceholder = NAME_PLACEHOLDER, nameLabel = NAME_LABEL, isRequiredLabel = IS_REQUIRED_LABEL, successMessageText = SUCCESS_MESSAGE_TEXT, onFormClose, onFormOpen, onSubmitError, onSubmitSuccess } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = Feedback.id;
        // tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
        this.options = {
            autoInject,
            showBranding,
            id,
            isEmailRequired,
            isNameRequired,
            showEmail,
            showName,
            useSentryUser,
            colorScheme,
            themeDark: {
                ...DEFAULT_THEME.dark,
                ...themeDark
            },
            themeLight: {
                ...DEFAULT_THEME.light,
                ...themeLight
            },
            buttonLabel,
            cancelButtonLabel,
            submitButtonLabel,
            formTitle,
            emailLabel,
            emailPlaceholder,
            messageLabel,
            messagePlaceholder,
            nameLabel,
            namePlaceholder,
            isRequiredLabel,
            successMessageText,
            onFormClose,
            onFormOpen,
            onSubmitError,
            onSubmitSuccess
        };
    }
    /**
   * Setup and initialize feedback container
   */ setupOnce() {
        if (!(0, _utils.isBrowser)()) return;
        try {
            this._cleanupWidgetIfExists();
            const { autoInject } = this.options;
            if (!autoInject) // Nothing to do here
            return;
            this._createWidget(this.options);
        } catch (err) {
            DEBUG_BUILD && (0, _utils.logger).error(err);
        }
    }
    /**
   * Allows user to open the dialog box. Creates a new widget if
   * `autoInject` was false, otherwise re-uses the default widget that was
   * created during initialization of the integration.
   */ openDialog() {
        if (!this._widget) this._createWidget({
            ...this.options,
            shouldCreateActor: false
        });
        if (!this._widget) return;
        this._widget.openDialog();
    }
    /**
   * Closes the dialog for the default widget, if it exists
   */ closeDialog() {
        if (!this._widget) // Nothing to do if widget does not exist
        return;
        this._widget.closeDialog();
    }
    /**
   * Adds click listener to attached element to open a feedback dialog
   */ attachTo(el, optionOverrides) {
        try {
            const options = mergeOptions(this.options, optionOverrides || {});
            return this._ensureShadowHost(options, ({ shadow })=>{
                const targetEl = typeof el === "string" ? doc.querySelector(el) : typeof el.addEventListener === "function" ? el : null;
                if (!targetEl) {
                    DEBUG_BUILD && (0, _utils.logger).error("[Feedback] Unable to attach to target element");
                    return null;
                }
                const widget = createWidget({
                    shadow,
                    options,
                    attachTo: targetEl
                });
                this._widgets.add(widget);
                if (!this._widget) this._widget = widget;
                return widget;
            });
        } catch (err) {
            DEBUG_BUILD && (0, _utils.logger).error(err);
            return null;
        }
    }
    /**
   * Creates a new widget. Accepts partial options to override any options passed to constructor.
   */ createWidget(optionOverrides) {
        try {
            return this._createWidget(mergeOptions(this.options, optionOverrides || {}));
        } catch (err) {
            DEBUG_BUILD && (0, _utils.logger).error(err);
            return null;
        }
    }
    /**
   * Removes a single widget
   */ removeWidget(widget) {
        if (!widget) return false;
        try {
            if (this._widgets.has(widget)) {
                widget.removeActor();
                widget.removeDialog();
                this._widgets.delete(widget);
                if (this._widget === widget) // TODO: is more clean-up needed? e.g. call remove()
                this._widget = null;
                return true;
            }
        } catch (err) {
            DEBUG_BUILD && (0, _utils.logger).error(err);
        }
        return false;
    }
    /**
   * Returns the default (first-created) widget
   */ getWidget() {
        return this._widget;
    }
    /**
   * Removes the Feedback integration (including host, shadow DOM, and all widgets)
   */ remove() {
        if (this._host) this._host.remove();
        this._initialize();
    }
    /**
   * Initializes values of protected properties
   */ _initialize() {
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
    }
    /**
   * Clean-up the widget if it already exists in the DOM. This shouldn't happen
   * in prod, but can happen in development with hot module reloading.
   */ _cleanupWidgetIfExists() {
        if (this._host) this.remove();
        const existingFeedback = doc.querySelector(`#${this.options.id}`);
        if (existingFeedback) existingFeedback.remove();
    }
    /**
   * Creates a new widget, after ensuring shadow DOM exists
   */ _createWidget(options) {
        return this._ensureShadowHost(options, ({ shadow })=>{
            const widget = createWidget({
                shadow,
                options
            });
            if (!this._hasInsertedActorStyles && widget.actor) {
                shadow.appendChild(createActorStyles(doc));
                this._hasInsertedActorStyles = true;
            }
            this._widgets.add(widget);
            if (!this._widget) this._widget = widget;
            return widget;
        });
    }
    /**
   * Ensures that shadow DOM exists and is added to the DOM
   */ _ensureShadowHost(options, cb) {
        let needsAppendHost = false;
        // Don't create if it already exists
        if (!this._shadow || !this._host) {
            const { id, colorScheme, themeLight, themeDark } = options;
            const { shadow, host } = createShadowHost({
                id,
                colorScheme,
                themeLight,
                themeDark
            });
            this._shadow = shadow;
            this._host = host;
            needsAppendHost = true;
        }
        // set data attribute on host for different themes
        this._host.dataset.sentryFeedbackColorscheme = options.colorScheme;
        const result = cb({
            shadow: this._shadow,
            host: this._host
        });
        if (needsAppendHost) doc.body.appendChild(this._host);
        return result;
    }
}
Feedback.__initStatic();

},{"@sentry/utils":"5XfgR","@sentry/core":"3UnXU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"YWzCw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaptureConsole", ()=>(0, _captureconsoleJs.CaptureConsole));
parcelHelpers.export(exports, "captureConsoleIntegration", ()=>(0, _captureconsoleJs.captureConsoleIntegration));
parcelHelpers.export(exports, "Debug", ()=>(0, _debugJs.Debug));
parcelHelpers.export(exports, "debugIntegration", ()=>(0, _debugJs.debugIntegration));
parcelHelpers.export(exports, "Dedupe", ()=>(0, _dedupeJs.Dedupe));
parcelHelpers.export(exports, "dedupeIntegration", ()=>(0, _dedupeJs.dedupeIntegration));
parcelHelpers.export(exports, "ExtraErrorData", ()=>(0, _extraerrordataJs.ExtraErrorData));
parcelHelpers.export(exports, "extraErrorDataIntegration", ()=>(0, _extraerrordataJs.extraErrorDataIntegration));
parcelHelpers.export(exports, "Offline", ()=>(0, _offlineJs.Offline));
parcelHelpers.export(exports, "ReportingObserver", ()=>(0, _reportingobserverJs.ReportingObserver));
parcelHelpers.export(exports, "reportingObserverIntegration", ()=>(0, _reportingobserverJs.reportingObserverIntegration));
parcelHelpers.export(exports, "RewriteFrames", ()=>(0, _rewriteframesJs.RewriteFrames));
parcelHelpers.export(exports, "rewriteFramesIntegration", ()=>(0, _rewriteframesJs.rewriteFramesIntegration));
parcelHelpers.export(exports, "SessionTiming", ()=>(0, _sessiontimingJs.SessionTiming));
parcelHelpers.export(exports, "sessionTimingIntegration", ()=>(0, _sessiontimingJs.sessionTimingIntegration));
parcelHelpers.export(exports, "Transaction", ()=>(0, _transactionJs.Transaction));
parcelHelpers.export(exports, "HttpClient", ()=>(0, _httpclientJs.HttpClient));
parcelHelpers.export(exports, "httpClientIntegration", ()=>(0, _httpclientJs.httpClientIntegration));
parcelHelpers.export(exports, "ContextLines", ()=>(0, _contextlinesJs.ContextLines));
parcelHelpers.export(exports, "contextLinesIntegration", ()=>(0, _contextlinesJs.contextLinesIntegration));
var _captureconsoleJs = require("./captureconsole.js");
var _debugJs = require("./debug.js");
var _dedupeJs = require("./dedupe.js");
var _extraerrordataJs = require("./extraerrordata.js");
var _offlineJs = require("./offline.js");
var _reportingobserverJs = require("./reportingobserver.js");
var _rewriteframesJs = require("./rewriteframes.js");
var _sessiontimingJs = require("./sessiontiming.js");
var _transactionJs = require("./transaction.js");
var _httpclientJs = require("./httpclient.js");
var _contextlinesJs = require("./contextlines.js");

},{"./captureconsole.js":"dyll9","./debug.js":"iBeM4","./dedupe.js":"kcjw7","./extraerrordata.js":"5IfGe","./offline.js":false,"./reportingobserver.js":"hm3WY","./rewriteframes.js":"c9u5a","./sessiontiming.js":"9VGn0","./transaction.js":false,"./httpclient.js":"a9vdr","./contextlines.js":"cZgzg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dyll9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaptureConsole", ()=>CaptureConsole);
parcelHelpers.export(exports, "captureConsoleIntegration", ()=>captureConsoleIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
const INTEGRATION_NAME = "CaptureConsole";
const _captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, _utils.CONSOLE_LEVELS);
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!("console" in (0, _utils.GLOBAL_OBJ))) return;
            (0, _utils.addConsoleInstrumentationHandler)(({ args, level })=>{
                if ((0, _core.getClient)() !== client || !levels.includes(level)) return;
                consoleHandler(args, level);
            });
        }
    };
};
const captureConsoleIntegration = (0, _core.defineIntegration)(_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const CaptureConsole = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, captureConsoleIntegration);
function consoleHandler(args, level) {
    const captureContext = {
        level: (0, _utils.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, _core.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            (0, _utils.addExceptionMechanism)(event, {
                handled: false,
                type: "console"
            });
            return event;
        });
        if (level === "assert" && args[0] === false) {
            const message = `Assertion failed: ${(0, _utils.safeJoin)(args.slice(1), " ") || "console.assert"}`;
            scope.setExtra("arguments", args.slice(1));
            (0, _core.captureMessage)(message, captureContext);
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (level === "error" && error) {
            (0, _core.captureException)(error, captureContext);
            return;
        }
        const message = (0, _utils.safeJoin)(args, " ");
        (0, _core.captureMessage)(message, captureContext);
    });
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iBeM4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Debug", ()=>Debug);
parcelHelpers.export(exports, "debugIntegration", ()=>debugIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
const INTEGRATION_NAME = "Debug";
const _debugIntegration = (options = {})=>{
    const _options = {
        debugger: false,
        stringify: false,
        ...options
    };
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!client.on) return;
            client.on("beforeSendEvent", (event, hint)=>{
                if (_options.debugger) // eslint-disable-next-line no-debugger
                debugger;
                /* eslint-disable no-console */ (0, _utils.consoleSandbox)(()=>{
                    if (_options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint && Object.keys(hint).length) console.log(JSON.stringify(hint, null, 2));
                    } else {
                        console.log(event);
                        if (hint && Object.keys(hint).length) console.log(hint);
                    }
                });
            /* eslint-enable no-console */ });
        }
    };
};
const debugIntegration = (0, _core.defineIntegration)(_debugIntegration);
/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production.
 *
 * @deprecated Use `debugIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const Debug = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, debugIntegration);

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kcjw7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dedupe", ()=>Dedupe);
parcelHelpers.export(exports, "_shouldDropEvent", ()=>_shouldDropEvent);
parcelHelpers.export(exports, "dedupeIntegration", ()=>dedupeIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
const INTEGRATION_NAME = "Dedupe";
const _dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const dedupeIntegration = (0, _core.defineIntegration)(_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const Dedupe = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, dedupeIntegration);
/** only exported for tests. */ function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = _getExceptionFromEvent(previousEvent);
    const currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = _getFramesFromEvent(currentEvent);
    let previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","./debug-build.js":"5ryzo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5ryzo":[function(require,module,exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", ()=>DEBUG_BUILD);
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5IfGe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtraErrorData", ()=>ExtraErrorData);
parcelHelpers.export(exports, "extraErrorDataIntegration", ()=>extraErrorDataIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
const INTEGRATION_NAME = "ExtraErrorData";
const _extraErrorDataIntegration = (options = {})=>{
    const depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    const captureErrorCause = options.captureErrorCause || false;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, hint) {
            return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
const extraErrorDataIntegration = (0, _core.defineIntegration)(_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const ExtraErrorData = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, extraErrorDataIntegration);
function _enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause) {
    if (!hint.originalException || !(0, _utils.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = _extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, _utils.normalize)(errorData, depth);
        if ((0, _utils.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, _utils.addNonEnumerableProperty)(normalizedErrorData, "__sentry_skip_normalization__", true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function _extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, _utils.isError)(value) ? value.toString() : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, _utils.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, _utils.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","./debug-build.js":"5ryzo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hm3WY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportingObserver", ()=>ReportingObserver);
parcelHelpers.export(exports, "reportingObserverIntegration", ()=>reportingObserverIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
const WINDOW = (0, _utils.GLOBAL_OBJ);
const INTEGRATION_NAME = "ReportingObserver";
const SETUP_CLIENTS = new WeakMap();
const _reportingObserverIntegration = (options = {})=>{
    const types = options.types || [
        "crash",
        "deprecation",
        "intervention"
    ];
    /** Handler for the reporting observer. */ function handler(reports) {
        if (!SETUP_CLIENTS.has((0, _core.getClient)())) return;
        for (const report of reports)(0, _core.withScope)((scope)=>{
            scope.setExtra("url", report.url);
            const label = `ReportingObserver [${report.type}]`;
            let details = "No details available";
            if (report.body) {
                // Object.keys doesn't work on ReportBody, as all properties are inheirted
                const plainBody = {};
                // eslint-disable-next-line guard-for-in
                for(const prop in report.body)plainBody[prop] = report.body[prop];
                scope.setExtra("body", plainBody);
                if (report.type === "crash") {
                    const body = report.body;
                    // A fancy way to create a message out of crashId OR reason OR both OR fallback
                    details = [
                        body.crashId || "",
                        body.reason || ""
                    ].join(" ").trim() || details;
                } else {
                    const body = report.body;
                    details = body.message || details;
                }
            }
            (0, _core.captureMessage)(`${label}: ${details}`);
        });
    }
    return {
        name: INTEGRATION_NAME,
        setupOnce () {
            if (!(0, _utils.supportsReportingObserver)()) return;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            const observer = new WINDOW.ReportingObserver(handler, {
                buffered: true,
                types
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            observer.observe();
        },
        setup (client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
const reportingObserverIntegration = (0, _core.defineIntegration)(_reportingObserverIntegration);
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 * @deprecated Use `reportingObserverIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const ReportingObserver = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, reportingObserverIntegration);

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c9u5a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RewriteFrames", ()=>RewriteFrames);
parcelHelpers.export(exports, "rewriteFramesIntegration", ()=>rewriteFramesIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
const INTEGRATION_NAME = "RewriteFrames";
const _rewriteFramesIntegration = (options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const iteratee = options.iteratee || ((frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "") // remove Windows-style prefix
            .replace(/\\/g, "/") // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, _utils.relative)(root, filename) : (0, _utils.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
};
const rewriteFramesIntegration = (0, _core.defineIntegration)(_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const RewriteFrames = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, rewriteFramesIntegration);

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9VGn0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionTiming", ()=>SessionTiming);
parcelHelpers.export(exports, "sessionTimingIntegration", ()=>sessionTimingIntegration);
var _core = require("@sentry/core");
const INTEGRATION_NAME = "SessionTiming";
const _sessionTimingIntegration = ()=>{
    const startTime = Date.now();
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event) {
            const now = Date.now();
            return {
                ...event,
                extra: {
                    ...event.extra,
                    ["session:start"]: startTime,
                    ["session:duration"]: now - startTime,
                    ["session:end"]: now
                }
            };
        }
    };
};
const sessionTimingIntegration = (0, _core.defineIntegration)(_sessionTimingIntegration);
/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const SessionTiming = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, sessionTimingIntegration);

},{"@sentry/core":"3UnXU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a9vdr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpClient", ()=>HttpClient);
parcelHelpers.export(exports, "httpClientIntegration", ()=>httpClientIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
const INTEGRATION_NAME = "HttpClient";
const _httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            _wrapFetch(client, _options);
            _wrapXHR(client, _options);
        }
    };
};
const httpClientIntegration = (0, _core.defineIntegration)(_httpClientIntegration);
/**
 * Create events for failed client side HTTP requests.
 * @deprecated Use `httpClientIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const HttpClient = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function _fetchResponseHandler(options, requestInfo, response, requestInit) {
    if (_shouldCaptureResponse(options, response.status, response.url)) {
        const request = _getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if (_shouldSendDefaultPii()) [{ headers: requestHeaders, cookies: requestCookies }, { headers: responseHeaders, cookies: responseCookies }] = [
            {
                cookieHeader: "Cookie",
                obj: request
            },
            {
                cookieHeader: "Set-Cookie",
                obj: response
            }
        ].map(({ cookieHeader, obj })=>{
            const headers = _extractFetchHeaders(obj.headers);
            let cookies;
            try {
                const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
                if (cookieString) cookies = _parseCookieString(cookieString);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Could not extract cookies from header ${cookieHeader}`);
            }
            return {
                headers,
                cookies
            };
        });
        const event = _createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders,
            responseHeaders,
            requestCookies,
            responseCookies
        });
        (0, _core.captureEvent)(event);
    }
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function _xhrResponseHandler(options, xhr, method, headers) {
    if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if (_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || undefined;
                if (cookieString) responseCookies = _parseCookieString(cookieString);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Could not extract cookies from response headers");
            }
            try {
                responseHeaders = _getXHRResponseHeaders(xhr);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("Could not extract headers from response");
            }
            requestHeaders = headers;
        }
        const event = _createEvent({
            url: xhr.responseURL,
            method,
            status: xhr.status,
            requestHeaders,
            // Can't access request cookies from XHR
            responseHeaders,
            responseCookies
        });
        (0, _core.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function _getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers["Content-Length"] || headers["content-length"];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function _parseCookieString(cookieString) {
    return cookieString.split("; ").reduce((acc, cookie)=>{
        const [key, value] = cookie.split("=");
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function _extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function _getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function _isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === "string") return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function _isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === "number") return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function _wrapFetch(client, options) {
    if (!(0, _utils.supportsNativeFetch)()) return;
    (0, _utils.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, _core.getClient)() !== client) return;
        const { response, args } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        _fetchResponseHandler(options, requestInfo, response, requestInit);
    });
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function _wrapXHR(client, options) {
    if (!("XMLHttpRequest" in (0, _utils.GLOBAL_OBJ))) return;
    (0, _utils.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, _core.getClient)() !== client) return;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, _utils.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method, request_headers: headers } = sentryXhrData;
        try {
            _xhrResponseHandler(options, xhr, method, headers);
        } catch (e) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("Error while extracting response event form XHR response", e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function _shouldCaptureResponse(options, status, url) {
    return _isInGivenStatusRanges(options.failedRequestStatusCodes, status) && _isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, _core.isSentryRequestUrl)(url, (0, _core.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function _createEvent(data) {
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message,
        exception: {
            values: [
                {
                    type: "Error",
                    value: message
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: _getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, _utils.addExceptionMechanism)(event, {
        type: "http.client",
        handled: false
    });
    return event;
}
function _getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function _shouldSendDefaultPii() {
    const client = (0, _core.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","./debug-build.js":"5ryzo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cZgzg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextLines", ()=>ContextLines);
parcelHelpers.export(exports, "applySourceContextToFrame", ()=>applySourceContextToFrame);
parcelHelpers.export(exports, "contextLinesIntegration", ()=>contextLinesIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
const WINDOW = (0, _utils.GLOBAL_OBJ);
const DEFAULT_LINES_OF_CONTEXT = 7;
const INTEGRATION_NAME = "ContextLines";
const _contextLinesIntegration = (options = {})=>{
    const contextLines = options.frameContextLines != null ? options.frameContextLines : DEFAULT_LINES_OF_CONTEXT;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event) {
            return addSourceContext(event, contextLines);
        }
    };
};
const contextLinesIntegration = (0, _core.defineIntegration)(_contextLinesIntegration);
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 *
 * @deprecated Use `contextLinesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const ContextLines = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, contextLinesIntegration);
/**
 * Processes an event and adds context lines.
 */ function addSourceContext(event, contextLines) {
    const doc = WINDOW.document;
    const htmlFilename = WINDOW.location && (0, _utils.stripUrlQueryAndFragment)(WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    const exceptions = event.exception && event.exception.values;
    if (!exceptions || !exceptions.length) return event;
    const html = doc.documentElement.innerHTML;
    if (!html) return event;
    const htmlLines = [
        "<!DOCTYPE html>",
        "<html>",
        ...html.split("\n"),
        "</html>"
    ];
    exceptions.forEach((exception)=>{
        const stacktrace = exception.stacktrace;
        if (stacktrace && stacktrace.frames) stacktrace.frames = stacktrace.frames.map((frame)=>applySourceContextToFrame(frame, htmlLines, htmlFilename, contextLines));
    });
    return event;
}
/**
 * Only exported for testing
 */ function applySourceContextToFrame(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, _utils.addContextToFrame)(htmlLines, frame, linesOfContext);
    return frame;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1WFrj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "insert", ()=>insert);
parcelHelpers.export(exports, "makeBrowserOfflineTransport", ()=>makeBrowserOfflineTransport);
parcelHelpers.export(exports, "pop", ()=>pop);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function promisifyRequest(request) {
    return new Promise((resolve, reject)=>{
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
/** Create or open an IndexedDb store */ function createStore(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = promisifyRequest(request);
    return (callback)=>dbp.then((db)=>callback(db.transaction(storeName, "readwrite").objectStore(storeName)));
}
function keys(store) {
    return promisifyRequest(store.getAllKeys());
}
/** Insert into the store */ function insert(store, value, maxQueueSize) {
    return store((store)=>{
        return keys(store).then((keys)=>{
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, Math.max(...keys, 0) + 1);
            return promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function pop(store) {
    return store((store)=>{
        return keys(store).then((keys)=>{
            if (keys.length === 0) return undefined;
            return promisifyRequest(store.get(keys[0])).then((value)=>{
                store.delete(keys[0]);
                return promisifyRequest(store.transaction).then(()=>value);
            });
        });
    });
}
function createIndexedDbStore(options) {
    let store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = createStore(options.dbName || "sentry-offline", options.storeName || "queue");
        return store;
    }
    return {
        insert: async (env)=>{
            try {
                const serialized = await (0, _utils.serializeEnvelope)(env, options.textEncoder);
                await insert(getStore(), serialized, options.maxQueueSize || 30);
            } catch (_) {
            //
            }
        },
        pop: async ()=>{
            try {
                const deserialized = await pop(getStore());
                if (deserialized) return (0, _utils.parseEnvelope)(deserialized, options.textEncoder || new TextEncoder(), options.textDecoder || new TextDecoder());
            } catch (_) {
            //
            }
            return undefined;
        }
    };
}
function makeIndexedDbOfflineTransport(createTransport) {
    return (options)=>createTransport({
            ...options,
            createStore: createIndexedDbStore
        });
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function makeBrowserOfflineTransport(createTransport) {
    return makeIndexedDbOfflineTransport((0, _core.makeOfflineTransport)(createTransport));
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2zbwO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onProfilingStartRouteTransaction", ()=>onProfilingStartRouteTransaction);
parcelHelpers.export(exports, "startProfileForTransaction", ()=>startProfileForTransaction);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var _utilsJs = require("./utils.js");
/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function onProfilingStartRouteTransaction(transaction) {
    if (!transaction) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log("[Profiling] Transaction is undefined, skipping profiling");
        return transaction;
    }
    if ((0, _utilsJs.shouldProfileTransaction)(transaction)) return startProfileForTransaction(transaction);
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function startProfileForTransaction(transaction) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, _utilsJs.isAutomatedPageLoadTransaction)(transaction)) startTimestamp = (0, _utils.timestampInSeconds)() * 1000;
    const profiler = (0, _utilsJs.startJSSelfProfile)();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return transaction;
    if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] started profiling transaction: ${(0, _core.spanToJSON)(transaction).description}`);
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, _utils.uuid4)();
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
        if (!transaction) return null;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return null;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, _helpersJs.WINDOW).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] stopped profiling of transaction: ${(0, _core.spanToJSON)(transaction).description}`);
            // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] profiler returned null profile for: ${(0, _core.spanToJSON)(transaction).description}`, "this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started");
                return null;
            }
            (0, _utilsJs.addProfileToGlobalCache)(profileId, profile);
            return null;
        }).catch((error)=>{
            if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log("[Profiling] error while stopping profiler:", error);
            return null;
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, _helpersJs.WINDOW).setTimeout(()=>{
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log("[Profiling] max profile duration elapsed, stopping profiling for:", (0, _core.spanToJSON)(transaction).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, _utilsJs.MAX_PROFILE_DURATION_MS));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = transaction.end.bind(transaction);
    /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext("profile", {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    }
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../debug-build.js":"auUOe","../helpers.js":"2KfuB","./utils.js":"glvQ2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"glvQ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_PROFILE_DURATION_MS", ()=>MAX_PROFILE_DURATION_MS);
parcelHelpers.export(exports, "addProfileToGlobalCache", ()=>addProfileToGlobalCache);
parcelHelpers.export(exports, "addProfilesToEnvelope", ()=>addProfilesToEnvelope);
parcelHelpers.export(exports, "applyDebugMetadata", ()=>applyDebugMetadata);
parcelHelpers.export(exports, "convertJSSelfProfileToSampledFormat", ()=>convertJSSelfProfileToSampledFormat);
parcelHelpers.export(exports, "createProfilePayload", ()=>createProfilePayload);
parcelHelpers.export(exports, "createProfilingEvent", ()=>createProfilingEvent);
parcelHelpers.export(exports, "enrichWithThreadInformation", ()=>enrichWithThreadInformation);
parcelHelpers.export(exports, "findProfiledTransactionsFromEnvelope", ()=>findProfiledTransactionsFromEnvelope);
parcelHelpers.export(exports, "getActiveProfilesCount", ()=>getActiveProfilesCount);
parcelHelpers.export(exports, "isAutomatedPageLoadTransaction", ()=>isAutomatedPageLoadTransaction);
parcelHelpers.export(exports, "isValidSampleRate", ()=>isValidSampleRate);
parcelHelpers.export(exports, "shouldProfileTransaction", ()=>shouldProfileTransaction);
parcelHelpers.export(exports, "startJSSelfProfile", ()=>startJSSelfProfile);
parcelHelpers.export(exports, "takeProfileFromGlobalCache", ()=>takeProfileFromGlobalCache);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/* eslint-disable max-lines */ const MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const THREAD_ID_STRING = String(0);
const THREAD_NAME = "main";
// Machine properties (eval only once)
let OS_PLATFORM = "";
let OS_PLATFORM_VERSION = "";
let OS_ARCH = "";
let OS_BROWSER = (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.userAgent || "";
let OS_MODEL = "";
const OS_LOCALE = (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.language || (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.languages && (0, _helpersJs.WINDOW).navigator.languages[0] || "";
function isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const userAgentData = (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.userAgentData;
if (isUserAgentData(userAgentData)) userAgentData.getHighEntropyValues([
    "architecture",
    "model",
    "platform",
    "platformVersion",
    "fullVersionList"
]).then((ua)=>{
    OS_PLATFORM = ua.platform || "";
    OS_ARCH = ua.architecture || "";
    OS_MODEL = ua.model || "";
    OS_PLATFORM_VERSION = ua.platformVersion || "";
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function enrichWithThreadInformation(profile) {
    if (!isProcessedJSSelfProfile(profile)) return profile;
    return convertJSSelfProfileToSampledFormat(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function getTraceId(event) {
    const traceId = event && event.contexts && event.contexts["trace"] && event.contexts["trace"]["trace_id"];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== "string") return "";
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function createProfilePayload(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = getTraceId(event);
    const enrichedThreadProfile = enrichWithThreadInformation(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1000 : Date.now();
    const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1000 : Date.now();
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || (0, _core.DEFAULT_ENVIRONMENT),
        runtime: {
            name: "javascript",
            version: (0, _helpersJs.WINDOW).navigator.userAgent
        },
        os: {
            name: OS_PLATFORM,
            version: OS_PLATFORM_VERSION,
            build_number: OS_BROWSER
        },
        device: {
            locale: OS_LOCALE,
            model: OS_MODEL,
            manufacturer: OS_BROWSER,
            architecture: OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: applyDebugMetadata(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0, _utils.uuid4)(),
                trace_id: traceId,
                active_thread_id: THREAD_ID_STRING,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function isAutomatedPageLoadTransaction(transaction) {
    return transaction.op === "pageload";
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function convertJSSelfProfileToSampledFormat(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [THREAD_ID_STRING]: {
                name: THREAD_NAME
            }
        }
    };
    if (!input.samples.length) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : (0, _utils.browserPerformanceTimeOrigin) || 0;
    const adjustForOriginChange = origin - ((0, _utils.browserPerformanceTimeOrigin) || origin);
    for(let i = 0; i < input.samples.length; i++){
        const jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: THREAD_ID_STRING
            };
            continue;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: THREAD_ID_STRING
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function addProfilesToEnvelope(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: "profile"
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function findProfiledTransactionsFromEnvelope(envelope) {
    const events = [];
    (0, _utils.forEachEnvelopeItem)(envelope, (item, type)=>{
        if (type !== "transaction") return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event && event.contexts && event.contexts["profile"] && event.contexts["profile"]["profile_id"]) events.push(item[j]);
        }
    });
    return events;
}
const debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function applyDebugMetadata(resource_paths) {
    const debugIdMap = (0, _utils.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return [];
    const client = (0, _core.getClient)();
    const options = client && client.getOptions();
    const stackParser = options && options.stackParser;
    if (!stackParser) return [];
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            const file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, _debugBuildJs.DEBUG_BUILD) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, _utils.logger).log("[Profiling] Discarding profile because it contains less than 2 samples");
        return false;
    }
    if (!profile.frames.length) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log("[Profiling] Discarding profile because it contains no frames");
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let PROFILING_CONSTRUCTOR_FAILED = false;
const MAX_PROFILE_DURATION_MS = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function startJSSelfProfile() {
    // Feature support check first
    const JSProfilerConstructor = (0, _helpersJs.WINDOW).Profiler;
    if (!isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, _debugBuildJs.DEBUG_BUILD) {
            (0, _utils.logger).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, _utils.logger).log("[Profiling] Disabling profiling for current user session.");
        }
        PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function shouldProfileTransaction(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if (PROFILING_CONSTRUCTOR_FAILED) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        return false;
    }
    if (!transaction.isRecording()) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log("[Profiling] Discarding profile because transaction was not sampled.");
        return false;
    }
    const client = (0, _core.getClient)();
    const options = client && client.getOptions();
    if (!options) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(profilesSampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function createProfilingEvent(profile_id, start_timestamp, profile, event) {
    if (!isValidProfile(profile)) return null;
    return createProfilePayload(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
const PROFILE_MAP = new Map();
/**
 *
 */ function getActiveProfilesCount() {
    return PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function takeProfileFromGlobalCache(profile_id) {
    const profile = PROFILE_MAP.get(profile_id);
    if (profile) PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function addProfileToGlobalCache(profile_id, profile) {
    PROFILE_MAP.set(profile_id, profile);
    if (PROFILE_MAP.size > 30) {
        const last = PROFILE_MAP.keys().next().value;
        PROFILE_MAP.delete(last);
    }
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../debug-build.js":"auUOe","../helpers.js":"2KfuB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bQAVq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "BrowserProfilingIntegration", ()=>BrowserProfilingIntegration);
parcelHelpers.export(exports, "browserProfilingIntegration", ()=>browserProfilingIntegration);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubextensionsJs = require("./hubextensions.js");
var _utilsJs = require("./utils.js");
const INTEGRATION_NAME = "BrowserProfiling";
const _browserProfilingIntegration = ()=>{
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            const scope = (0, _core.getCurrentScope)();
            // eslint-disable-next-line deprecation/deprecation
            const transaction = scope.getTransaction();
            if (transaction && (0, _utilsJs.isAutomatedPageLoadTransaction)(transaction)) {
                if ((0, _utilsJs.shouldProfileTransaction)(transaction)) (0, _hubextensionsJs.startProfileForTransaction)(transaction);
            }
            if (typeof client.on !== "function") {
                (0, _utils.logger).warn("[Profiling] Client does not support hooks, profiling will be disabled");
                return;
            }
            client.on("startTransaction", (transaction)=>{
                if ((0, _utilsJs.shouldProfileTransaction)(transaction)) (0, _hubextensionsJs.startProfileForTransaction)(transaction);
            });
            client.on("beforeEnvelope", (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, _utilsJs.getActiveProfilesCount)()) return;
                const profiledTransactionEvents = (0, _utilsJs.findProfiledTransactionsFromEnvelope)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction && profiledTransaction.contexts;
                    const profile_id = context && context["profile"] && context["profile"]["profile_id"];
                    const start_timestamp = context && context["profile"] && context["profile"]["start_timestamp"];
                    if (typeof profile_id !== "string") {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    if (!profile_id) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    // Remove the profile from the transaction context before sending, relay will take care of the rest.
                    if (context && context["profile"]) delete context.profile;
                    const profile = (0, _utilsJs.takeProfileFromGlobalCache)(profile_id);
                    if (!profile) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, _utilsJs.createProfilingEvent)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, _utilsJs.addProfilesToEnvelope)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
const browserProfilingIntegration = (0, _core.defineIntegration)(_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const BrowserProfilingIntegration = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, browserProfilingIntegration);

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","../debug-build.js":"auUOe","./hubextensions.js":"2zbwO","./utils.js":"glvQ2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Ccf8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
/**
 * Inits the React SDK
 */ function init(options) {
    const opts = {
        ...options
    };
    (0, _core.applySdkMetadata)(opts, "react");
    (0, _browser.init)(opts);
}

},{"@sentry/browser":"7DFlu","@sentry/core":"3UnXU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gRpnr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Profiler", ()=>Profiler);
parcelHelpers.export(exports, "UNKNOWN_COMPONENT", ()=>UNKNOWN_COMPONENT);
parcelHelpers.export(exports, "useProfiler", ()=>useProfiler);
parcelHelpers.export(exports, "withProfiler", ()=>withProfiler);
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _constantsJs = require("./constants.js");
const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";
const UNKNOWN_COMPONENT = "unknown";
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */ class Profiler extends _react.Component {
    /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */ /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */ // eslint-disable-next-line @typescript-eslint/member-ordering
    static __initStatic() {
        this.defaultProps = {
            disabled: false,
            includeRender: true,
            includeUpdates: true
        };
    }
    constructor(props){
        super(props);
        const { name, disabled = false } = this.props;
        if (disabled) return;
        this._mountSpan = (0, _browser.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, _constantsJs.REACT_MOUNT_OP),
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
    }
    // If a component mounted, we can finish the mount activity.
    componentDidMount() {
        if (this._mountSpan) this._mountSpan.end();
    }
    shouldComponentUpdate({ updateProps, includeUpdates = true }) {
        // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
        // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
        // We are just trying to give baseline clues for further investigation.
        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
            // See what props haved changed between the previous props, and the current props. This is
            // set as data on the span. We just store the prop keys as the values could be potenially very large.
            const changedProps = Object.keys(updateProps).filter((k)=>updateProps[k] !== this.props.updateProps[k]);
            if (changedProps.length > 0) {
                const now = (0, _utils.timestampInSeconds)();
                this._updateSpan = (0, _core.withActiveSpan)(this._mountSpan, ()=>{
                    return (0, _browser.startInactiveSpan)({
                        name: `<${this.props.name}>`,
                        onlyIfParent: true,
                        op: (0, _constantsJs.REACT_UPDATE_OP),
                        origin: "auto.ui.react.profiler",
                        startTimestamp: now,
                        attributes: {
                            "ui.component_name": this.props.name,
                            "ui.react.changed_props": changedProps
                        }
                    });
                });
            }
        }
        return true;
    }
    componentDidUpdate() {
        if (this._updateSpan) {
            this._updateSpan.end();
            this._updateSpan = undefined;
        }
    }
    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
    componentWillUnmount() {
        const endTimestamp = (0, _utils.timestampInSeconds)();
        const { name, includeRender = true } = this.props;
        if (this._mountSpan && includeRender) {
            const startTimestamp = (0, _core.spanToJSON)(this._mountSpan).timestamp;
            (0, _core.withActiveSpan)(this._mountSpan, ()=>{
                const renderSpan = (0, _browser.startInactiveSpan)({
                    onlyIfParent: true,
                    name: `<${name}>`,
                    op: (0, _constantsJs.REACT_RENDER_OP),
                    origin: "auto.ui.react.profiler",
                    startTimestamp,
                    attributes: {
                        "ui.component_name": name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            });
        }
    }
    render() {
        return this.props.children;
    }
}
Profiler.__initStatic();
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withProfiler(WrappedComponent, // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    const componentDisplayName = options && options.name || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    const Wrapped = (props)=>_react.createElement(Profiler, {
            ...options,
            name: componentDisplayName,
            updateProps: props,
            __self: this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 159
            }
        }, _react.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 160
            }
        }));
    Wrapped.displayName = `profiler(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, _hoistNonReactStaticsDefault.default)(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */ function useProfiler(name, options = {
    disabled: false,
    hasRenderSpan: true
}) {
    const [mountSpan] = _react.useState(()=>{
        if (options && options.disabled) return undefined;
        return (0, _browser.startInactiveSpan)({
            name: `<${name}>`,
            onlyIfParent: true,
            op: (0, _constantsJs.REACT_MOUNT_OP),
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
    });
    _react.useEffect(()=>{
        if (mountSpan) mountSpan.end();
        return ()=>{
            if (mountSpan && options.hasRenderSpan) {
                const startTimestamp = (0, _core.spanToJSON)(mountSpan).timestamp;
                const endTimestamp = (0, _utils.timestampInSeconds)();
                const renderSpan = (0, _browser.startInactiveSpan)({
                    name: `<${name}>`,
                    onlyIfParent: true,
                    op: (0, _constantsJs.REACT_RENDER_OP),
                    origin: "auto.ui.react.profiler",
                    startTimestamp,
                    attributes: {
                        "ui.component_name": name
                    }
                });
                if (renderSpan) // Have to cast to Span because the type of _mountSpan is Span | undefined
                // and not getting narrowed properly
                renderSpan.end(endTimestamp);
            }
        };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

},{"@sentry/browser":"7DFlu","@sentry/core":"3UnXU","@sentry/utils":"5XfgR","hoist-non-react-statics":"bIZ8D","react":"cOWTg","./constants.js":"EwMJ5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"EwMJ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REACT_MOUNT_OP", ()=>REACT_MOUNT_OP);
parcelHelpers.export(exports, "REACT_RENDER_OP", ()=>REACT_RENDER_OP);
parcelHelpers.export(exports, "REACT_UPDATE_OP", ()=>REACT_UPDATE_OP);
const REACT_RENDER_OP = "ui.react.render";
const REACT_UPDATE_OP = "ui.react.update";
const REACT_MOUNT_OP = "ui.react.mount";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4ZAzP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
parcelHelpers.export(exports, "UNKNOWN_COMPONENT", ()=>UNKNOWN_COMPONENT);
parcelHelpers.export(exports, "isAtLeastReact17", ()=>isAtLeastReact17);
parcelHelpers.export(exports, "withErrorBoundary", ()=>withErrorBoundary);
var _browser = require("@sentry/browser");
var _utils = require("@sentry/utils");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _debugBuildJs = require("./debug-build.js");
const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function isAtLeastReact17(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const UNKNOWN_COMPONENT = "unknown";
const INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class ErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        ErrorBoundary.prototype.__init.call(this);
        this.state = INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, _browser.getClient)();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on("afterSendEvent", (event)=>{
                if (!event.type && event.event_id === this._lastEventId) // eslint-disable-next-line deprecation/deprecation
                (0, _browser.showReportDialog)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, { componentStack }) {
        const { beforeCapture, onError, showDialog, dialogOptions } = this.props;
        (0, _browser.withScope)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if (isAtLeastReact17(_react.version) && (0, _utils.isError)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, _browser.captureException)(error, {
                captureContext: {
                    contexts: {
                        react: {
                            componentStack
                        }
                    }
                },
                // If users provide a fallback component we can assume they are handling the error.
                // Therefore, we set the mechanism depending on the presence of the fallback prop.
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, _browser.showReportDialog)({
                    ...dialogOptions,
                    eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error,
                componentStack,
                eventId
            });
        });
    }
    componentDidMount() {
        const { onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error, componentStack, eventId } = this.state;
        const { onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset } = this.props;
            const { error, componentStack, eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState(INITIAL_STATE);
        };
    }
    render() {
        const { fallback, children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if (_react.isValidElement(element)) return element;
            if (fallback) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    const Wrapped = (props)=>_react.createElement(ErrorBoundary, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 240
            }
        }, _react.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 241
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, _hoistNonReactStaticsDefault.default)(Wrapped, WrappedComponent);
    return Wrapped;
}

},{"@sentry/browser":"7DFlu","@sentry/utils":"5XfgR","hoist-non-react-statics":"bIZ8D","react":"cOWTg","./debug-build.js":"32UL0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"32UL0":[function(require,module,exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", ()=>DEBUG_BUILD);
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iKT04":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createReduxEnhancer", ()=>createReduxEnhancer);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/* eslint-disable @typescript-eslint/no-explicit-any */ const ACTION_BREADCRUMB_CATEGORY = "redux.action";
const ACTION_BREADCRUMB_TYPE = "info";
const defaultOptions = {
    attachReduxState: true,
    actionTransformer: (action)=>action,
    stateTransformer: (state)=>state || null
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */ function createReduxEnhancer(enhancerOptions) {
    // Note: We return an any type as to not have type conflicts.
    const options = {
        ...defaultOptions,
        ...enhancerOptions
    };
    return (next)=>(reducer, initialState)=>{
            options.attachReduxState && (0, _core.getGlobalScope)().addEventProcessor((event, hint)=>{
                try {
                    // @ts-expect-error try catch to reduce bundle size
                    if (event.type === undefined && event.contexts.state.state.type === "redux") hint.attachments = [
                        ...hint.attachments || [],
                        // @ts-expect-error try catch to reduce bundle size
                        {
                            filename: "redux_state.json",
                            data: JSON.stringify(event.contexts.state.state.value)
                        }
                    ];
                } catch (_) {
                // empty
                }
                return event;
            });
            const sentryReducer = (state, action)=>{
                const newState = reducer(state, action);
                const scope = (0, _core.getCurrentScope)();
                /* Action breadcrumbs */ const transformedAction = options.actionTransformer(action);
                if (typeof transformedAction !== "undefined" && transformedAction !== null) scope.addBreadcrumb({
                    category: ACTION_BREADCRUMB_CATEGORY,
                    data: transformedAction,
                    type: ACTION_BREADCRUMB_TYPE
                });
                /* Set latest state to scope */ const transformedState = options.stateTransformer(newState);
                if (typeof transformedState !== "undefined" && transformedState !== null) {
                    const client = (0, _core.getClient)();
                    const options = client && client.getOptions();
                    const normalizationDepth = options && options.normalizeDepth || 3; // default state normalization depth to 3
                    // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
                    const newStateContext = {
                        state: {
                            type: "redux",
                            value: transformedState
                        }
                    };
                    (0, _utils.addNonEnumerableProperty)(newStateContext, "__sentry_override_normalization_depth__", 3 + // 3 layers for `state.value.transformedState`
                    normalizationDepth);
                    scope.setContext("state", newStateContext);
                } else scope.setContext("state", null);
                /* Allow user to configure scope with latest state */ const { configureScopeWithState } = options;
                if (typeof configureScopeWithState === "function") configureScopeWithState(scope, newState);
                return newState;
            };
            return next(sentryReducer, initialState);
        };
}

},{"@sentry/core":"3UnXU","@sentry/utils":"5XfgR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"if1Yw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactRouterV3BrowserTracingIntegration", ()=>reactRouterV3BrowserTracingIntegration);
parcelHelpers.export(exports, "reactRouterV3Instrumentation", ()=>reactRouterV3Instrumentation);
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV3BrowserTracingIntegration(options) {
    const integration = (0, _browser.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history, routes, match, instrumentPageLoad = true, instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startPageloadCallback = (startSpanOptions)=>{
                (0, _browser.startBrowserTracingPageLoadSpan)(client, startSpanOptions);
                return undefined;
            };
            const startNavigationCallback = (startSpanOptions)=>{
                (0, _browser.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            const instrumentation = reactRouterV3Instrumentation(history, routes, match);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, instrumentNavigation);
        }
    };
}
/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 *
 * @deprecated Use `reactRouterV3BrowserTracingIntegration()` instead
 */ function reactRouterV3Instrumentation(history, routes, match) {
    return (startTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        let activeTransaction;
        let prevName;
        // Have to use window.location because history.location might not be defined.
        if (startTransactionOnPageLoad && (0, _browser.WINDOW) && (0, _browser.WINDOW).location) normalizeTransactionName(routes, (0, _browser.WINDOW).location, match, (localName, source = "url")=>{
            prevName = localName;
            activeTransaction = startTransaction({
                name: prevName,
                attributes: {
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v3",
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                }
            });
        });
        if (startTransactionOnLocationChange && history.listen) history.listen((location)=>{
            if (location.action === "PUSH" || location.action === "POP") {
                if (activeTransaction) activeTransaction.end();
                normalizeTransactionName(routes, location, match, (localName, source = "url")=>{
                    prevName = localName;
                    const attributes = {
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.react.reactrouter_v3",
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                    };
                    activeTransaction = startTransaction({
                        name: prevName,
                        attributes
                    });
                });
            }
        });
    };
}
/**
 * Normalize transaction names using `Router.match`
 */ function normalizeTransactionName(appRoutes, location, match, callback) {
    let name = location.pathname;
    match({
        location,
        routes: appRoutes
    }, (error, _redirectLocation, renderProps)=>{
        if (error || !renderProps) return callback(name);
        const routePath = getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === "/*") return callback(name);
        name = routePath;
        return callback(name, "route");
    });
}
/**
 * Generate route name from array of routes
 */ function getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) return "";
    const routesWithPaths = routes.filter((route)=>!!route.path);
    let index = -1;
    for(let x = routesWithPaths.length - 1; x >= 0; x--){
        const route = routesWithPaths[x];
        if (route.path && route.path.startsWith("/")) {
            index = x;
            break;
        }
    }
    return routesWithPaths.slice(index).filter(({ path })=>!!path).map(({ path })=>path).join("");
}

},{"@sentry/browser":"7DFlu","@sentry/core":"3UnXU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j7aOD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactRouterV4BrowserTracingIntegration", ()=>reactRouterV4BrowserTracingIntegration);
parcelHelpers.export(exports, "reactRouterV4Instrumentation", ()=>reactRouterV4Instrumentation);
parcelHelpers.export(exports, "reactRouterV5BrowserTracingIntegration", ()=>reactRouterV5BrowserTracingIntegration);
parcelHelpers.export(exports, "reactRouterV5Instrumentation", ()=>reactRouterV5Instrumentation);
parcelHelpers.export(exports, "withSentryRouting", ()=>withSentryRouting);
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx";
// We need to disable eslint no-explict-any because any is required for the
// react-router typings.
let activeTransaction;
/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV4BrowserTracingIntegration(options) {
    const integration = (0, _browser.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history, routes, matchPath, instrumentPageLoad = true, instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startPageloadCallback = (startSpanOptions)=>{
                (0, _browser.startBrowserTracingPageLoadSpan)(client, startSpanOptions);
                return undefined;
            };
            const startNavigationCallback = (startSpanOptions)=>{
                (0, _browser.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            const instrumentation = reactRouterV4Instrumentation(history, routes, matchPath);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, instrumentNavigation);
        }
    };
}
/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV5BrowserTracingIntegration(options) {
    const integration = (0, _browser.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { history, routes, matchPath } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startPageloadCallback = (startSpanOptions)=>{
                (0, _browser.startBrowserTracingPageLoadSpan)(client, startSpanOptions);
                return undefined;
            };
            const startNavigationCallback = (startSpanOptions)=>{
                (0, _browser.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            const instrumentation = reactRouterV5Instrumentation(history, routes, matchPath);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, options.instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, options.instrumentNavigation);
        }
    };
}
/**
 * @deprecated Use `browserTracingReactRouterV4()` instead.
 */ function reactRouterV4Instrumentation(history, routes, matchPath) {
    return createReactRouterInstrumentation(history, "reactrouter_v4", routes, matchPath);
}
/**
 * @deprecated Use `browserTracingReactRouterV5()` instead.
 */ function reactRouterV5Instrumentation(history, routes, matchPath) {
    return createReactRouterInstrumentation(history, "reactrouter_v5", routes, matchPath);
}
function createReactRouterInstrumentation(history, instrumentationName, allRoutes = [], matchPath) {
    function getInitPathName() {
        if (history && history.location) return history.location.pathname;
        if ((0, _browser.WINDOW) && (0, _browser.WINDOW).location) return (0, _browser.WINDOW).location.pathname;
        return undefined;
    }
    /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */ function normalizeTransactionName(pathname) {
        if (allRoutes.length === 0 || !matchPath) return [
            pathname,
            "url"
        ];
        const branches = matchRoutes(allRoutes, pathname, matchPath);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let x = 0; x < branches.length; x++){
            if (branches[x].match.isExact) return [
                branches[x].match.path,
                "route"
            ];
        }
        return [
            pathname,
            "url"
        ];
    }
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = getInitPathName();
        if (startTransactionOnPageLoad && initPathName) {
            const [name, source] = normalizeTransactionName(initPathName);
            activeTransaction = customStartTransaction({
                name,
                attributes: {
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: `auto.pageload.react.${instrumentationName}`,
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                }
            });
        }
        if (startTransactionOnLocationChange && history.listen) history.listen((location, action)=>{
            if (action && (action === "PUSH" || action === "POP")) {
                if (activeTransaction) activeTransaction.end();
                const [name, source] = normalizeTransactionName(location.pathname);
                activeTransaction = customStartTransaction({
                    name,
                    attributes: {
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: `auto.navigation.react.${instrumentationName}`,
                        [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source
                    }
                });
            }
        });
    };
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */ function matchRoutes(routes, pathname, matchPath, branch = []) {
    routes.some((route)=>{
        const match = route.path ? matchPath(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
         : computeRootMatch(pathname); // use default "root" match
        if (match) {
            branch.push({
                route,
                match
            });
            if (route.routes) matchRoutes(route.routes, pathname, matchPath, branch);
        }
        return !!match;
    });
    return branch;
}
function computeRootMatch(pathname) {
    return {
        path: "/",
        url: "/",
        params: {},
        isExact: pathname === "/"
    };
}
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function withSentryRouting(Route) {
    const componentDisplayName = Route.displayName || Route.name;
    const WrappedRoute = (props)=>{
        if (props && props.computedMatch && props.computedMatch.isExact) {
            const route = props.computedMatch.path;
            const activeRootSpan = getActiveRootSpan();
            if (activeRootSpan) {
                activeRootSpan.updateName(route);
                activeRootSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), "route");
            }
        }
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params:
        // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
        return _react.createElement(Route, {
            ...props,
            __self: this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 279
            }
        });
    };
    WrappedRoute.displayName = `sentryRoute(${componentDisplayName})`;
    (0, _hoistNonReactStaticsDefault.default)(WrappedRoute, Route);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if (activeTransaction) return activeTransaction;
    const span = (0, _core.getActiveSpan)();
    const rootSpan = span ? (0, _core.getRootSpan)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, _core.spanToJSON)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}

},{"@sentry/browser":"7DFlu","@sentry/core":"3UnXU","hoist-non-react-statics":"bIZ8D","react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4bZtQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactRouterV6BrowserTracingIntegration", ()=>reactRouterV6BrowserTracingIntegration);
parcelHelpers.export(exports, "reactRouterV6Instrumentation", ()=>reactRouterV6Instrumentation);
parcelHelpers.export(exports, "withSentryReactRouterV6Routing", ()=>withSentryReactRouterV6Routing);
parcelHelpers.export(exports, "wrapCreateBrowserRouter", ()=>wrapCreateBrowserRouter);
parcelHelpers.export(exports, "wrapUseRoutes", ()=>wrapUseRoutes);
var _browser = require("@sentry/browser");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _debugBuildJs = require("./debug-build.js");
const _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let activeTransaction;
let _useEffect;
let _useLocation;
let _useNavigationType;
let _createRoutesFromChildren;
let _matchRoutes;
let _customStartTransaction;
let _startTransactionOnLocationChange;
let _stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV6BrowserTracingIntegration(options) {
    const integration = (0, _browser.browserTracingIntegration)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename, instrumentPageLoad = true, instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, _browser.startBrowserTracingNavigationSpan)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, _browser.WINDOW) && (0, _browser.WINDOW).location && (0, _browser.WINDOW).location.pathname;
            if (instrumentPageLoad && initPathName) (0, _browser.startBrowserTracingPageLoadSpan)(client, {
                name: initPathName,
                attributes: {
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                    [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            _useEffect = useEffect;
            _useLocation = useLocation;
            _useNavigationType = useNavigationType;
            _matchRoutes = matchRoutes;
            _createRoutesFromChildren = createRoutesFromChildren;
            _stripBasename = stripBasename || false;
            _customStartTransaction = startNavigationCallback;
            _startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function reactRouterV6Instrumentation(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, _browser.WINDOW) && (0, _browser.WINDOW).location && (0, _browser.WINDOW).location.pathname;
        if (startTransactionOnPageLoad && initPathName) activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "pageload",
                [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        _useEffect = useEffect;
        _useLocation = useLocation;
        _useNavigationType = useNavigationType;
        _matchRoutes = matchRoutes;
        _createRoutesFromChildren = createRoutesFromChildren;
        _stripBasename = stripBasename || false;
        _customStartTransaction = customStartTransaction;
        _startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        _stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                _stripBasename ? stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, _utils.getNumberOfUrlSegments)(pathBuilder) !== (0, _utils.getNumberOfUrlSegments)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        (_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        (_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        _stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
}
function handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);
    if (_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if (activeTransaction) activeTransaction.end();
        const [name, source] = getNormalizedName(routes, location, branches, basename);
        activeTransaction = _customStartTransaction({
            name,
            attributes: {
                [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: source,
                [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "navigation",
                [(0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(Routes) {
    if (!_useEffect || !_useLocation || !_useNavigationType || !_createRoutesFromChildren || !_matchRoutes || !_customStartTransaction) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${_useEffect}. useLocation: ${_useLocation}. useNavigationType: ${_useNavigationType}.
      createRoutesFromChildren: ${_createRoutesFromChildren}. matchRoutes: ${_matchRoutes}. customStartTransaction: ${_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = _useLocation();
        const navigationType = _useNavigationType();
        _useEffect(()=>{
            const routes = _createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                updatePageloadTransaction(getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return _react.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, _hoistNonReactStaticsDefault.default)(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function wrapUseRoutes(origUseRoutes) {
    if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes || !_customStartTransaction) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes, locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = _useLocation();
        const navigationType = _useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        _useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                updatePageloadTransaction(getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return _react.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function wrapCreateBrowserRouter(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if (_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if (activeTransaction) return activeTransaction;
    const span = (0, _core.getActiveSpan)();
    const rootSpan = span ? (0, _core.getRootSpan)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, _core.spanToJSON)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}

},{"@sentry/browser":"7DFlu","@sentry/core":"3UnXU","@sentry/utils":"5XfgR","hoist-non-react-statics":"bIZ8D","react":"cOWTg","./debug-build.js":"32UL0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"91Vyq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesEsmJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryEsmJs.useQuery));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderEsmJs.QueryClientProvider));
parcelHelpers.export(exports, "defaultContext", ()=>(0, _queryClientProviderEsmJs.defaultContext));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderEsmJs.useQueryClient));
parcelHelpers.export(exports, "Hydrate", ()=>(0, _hydrateEsmJs.Hydrate));
parcelHelpers.export(exports, "useHydrate", ()=>(0, _hydrateEsmJs.useHydrate));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingEsmJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useIsMutatingEsmJs.useIsMutating));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationEsmJs.useMutation));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryEsmJs.useInfiniteQuery));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringEsmJs.IsRestoringProvider));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringEsmJs.useIsRestoring));
var _setBatchUpdatesFnEsmJs = require("./setBatchUpdatesFn.esm.js");
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _useQueriesEsmJs = require("./useQueries.esm.js");
var _useQueryEsmJs = require("./useQuery.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _hydrateEsmJs = require("./Hydrate.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _useIsFetchingEsmJs = require("./useIsFetching.esm.js");
var _useIsMutatingEsmJs = require("./useIsMutating.esm.js");
var _useMutationEsmJs = require("./useMutation.esm.js");
var _useInfiniteQueryEsmJs = require("./useInfiniteQuery.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");

},{"./setBatchUpdatesFn.esm.js":"86yUs","@tanstack/query-core":"97qaq","./useQueries.esm.js":false,"./useQuery.esm.js":"iaSzV","./QueryClientProvider.esm.js":"97POi","./Hydrate.esm.js":false,"./QueryErrorResetBoundary.esm.js":false,"./useIsFetching.esm.js":false,"./useIsMutating.esm.js":"4SRLx","./useMutation.esm.js":"dGn1J","./useInfiniteQuery.esm.js":false,"./isRestoring.esm.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"86yUs":[function(require,module,exports) {
var _queryCore = require("@tanstack/query-core");
var _reactBatchedUpdatesEsmJs = require("./reactBatchedUpdates.esm.js");
(0, _queryCore.notifyManager).setBatchNotifyFunction((0, _reactBatchedUpdatesEsmJs.unstable_batchedUpdates));

},{"@tanstack/query-core":"97qaq","./reactBatchedUpdates.esm.js":"66lqj"}],"97qaq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryerEsmJs.CancelledError));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryerEsmJs.isCancelledError));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCacheEsmJs.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClientEsmJs.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserverEsmJs.QueryObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserverEsmJs.QueriesObserver));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserverEsmJs.InfiniteQueryObserver));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCacheEsmJs.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserverEsmJs.MutationObserver));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManagerEsmJs.notifyManager));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManagerEsmJs.focusManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManagerEsmJs.onlineManager));
parcelHelpers.export(exports, "hashQueryKey", ()=>(0, _utilsEsmJs.hashQueryKey));
parcelHelpers.export(exports, "isError", ()=>(0, _utilsEsmJs.isError));
parcelHelpers.export(exports, "isServer", ()=>(0, _utilsEsmJs.isServer));
parcelHelpers.export(exports, "matchQuery", ()=>(0, _utilsEsmJs.matchQuery));
parcelHelpers.export(exports, "parseFilterArgs", ()=>(0, _utilsEsmJs.parseFilterArgs));
parcelHelpers.export(exports, "parseMutationArgs", ()=>(0, _utilsEsmJs.parseMutationArgs));
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>(0, _utilsEsmJs.parseMutationFilterArgs));
parcelHelpers.export(exports, "parseQueryArgs", ()=>(0, _utilsEsmJs.parseQueryArgs));
parcelHelpers.export(exports, "replaceEqualDeep", ()=>(0, _utilsEsmJs.replaceEqualDeep));
parcelHelpers.export(exports, "defaultShouldDehydrateMutation", ()=>(0, _hydrationEsmJs.defaultShouldDehydrateMutation));
parcelHelpers.export(exports, "defaultShouldDehydrateQuery", ()=>(0, _hydrationEsmJs.defaultShouldDehydrateQuery));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydrationEsmJs.dehydrate));
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydrationEsmJs.hydrate));
parcelHelpers.export(exports, "Query", ()=>(0, _queryEsmJs.Query));
var _retryerEsmJs = require("./retryer.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _queryClientEsmJs = require("./queryClient.esm.js");
var _queryObserverEsmJs = require("./queryObserver.esm.js");
var _queriesObserverEsmJs = require("./queriesObserver.esm.js");
var _infiniteQueryObserverEsmJs = require("./infiniteQueryObserver.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _mutationObserverEsmJs = require("./mutationObserver.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _hydrationEsmJs = require("./hydration.esm.js");
var _queryEsmJs = require("./query.esm.js");

},{"./retryer.esm.js":false,"./queryCache.esm.js":false,"./queryClient.esm.js":"OmDKG","./queryObserver.esm.js":"336XF","./queriesObserver.esm.js":false,"./infiniteQueryObserver.esm.js":false,"./mutationCache.esm.js":false,"./mutationObserver.esm.js":"1eK5m","./notifyManager.esm.js":"fFChl","./focusManager.esm.js":false,"./onlineManager.esm.js":false,"./utils.esm.js":"bY77Q","./hydration.esm.js":false,"./query.esm.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hfSBY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function canFetch(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, _onlineManagerEsmJs.onlineManager).isOnline() : true;
}
class CancelledError {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new CancelledError(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, _focusManagerEsmJs.focusManager).isFocused() || config.networkMode !== "always" && !(0, _onlineManagerEsmJs.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, _utilsEsmJs.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if (canFetch(config.networkMode)) run();
    else pause().then(run);
    return {
        promise,
        cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry,
        continueRetry
    };
}

},{"./focusManager.esm.js":"1TEAN","./onlineManager.esm.js":"guSwG","./utils.esm.js":"bY77Q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1TEAN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
class FocusManager extends (0, _subscribableEsmJs.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const focusManager = new FocusManager();

},{"./subscribable.esm.js":"EcH6j","./utils.esm.js":"bY77Q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"EcH6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
class Subscribable {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bY77Q":[function(require,module,exports) {
// TYPES
// UTILS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "getAbortController", ()=>getAbortController);
parcelHelpers.export(exports, "hashQueryKey", ()=>hashQueryKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isQueryKey", ()=>isQueryKey);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "parseFilterArgs", ()=>parseFilterArgs);
parcelHelpers.export(exports, "parseMutationArgs", ()=>parseMutationArgs);
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>parseMutationFilterArgs);
parcelHelpers.export(exports, "parseQueryArgs", ()=>parseQueryArgs);
parcelHelpers.export(exports, "partialDeepEqual", ()=>partialDeepEqual);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceAt", ()=>replaceAt);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "scheduleMicrotask", ()=>scheduleMicrotask);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
const isServer = typeof window === "undefined" || "Deno" in window;
function noop() {
    return undefined;
}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
    if (!isQueryKey(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function parseMutationArgs(arg1, arg2, arg3) {
    if (isQueryKey(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function parseFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function matchQuery(filters, query) {
    const { type = "all", exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (isQueryKey(queryKey)) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, fetching, predicate, mutationKey } = filters;
    if (isQueryKey(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function hashQueryKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function partialMatchKey(a, b) {
    return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function partialDeepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!partialDeepEqual(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function replaceEqualDeep(a, b) {
    if (a === b) return a;
    const array = isPlainArray(a) && isPlainArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = replaceEqualDeep(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function shallowEqualObjects(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function isQueryKey(value) {
    return Array.isArray(value);
}
function isError(value) {
    return value instanceof Error;
}
function sleep(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function scheduleMicrotask(callback) {
    sleep(0).then(callback);
}
function getAbortController() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function replaceData(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
    return data;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"guSwG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
const onlineEvents = [
    "online",
    "offline"
];
class OnlineManager extends (0, _subscribableEsmJs.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const onlineManager = new OnlineManager();

},{"./subscribable.esm.js":"EcH6j","./utils.esm.js":"bY77Q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ieZAJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _utilsEsmJs = require("./utils.esm.js");
var _queryEsmJs = require("./query.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class QueryCache extends (0, _subscribableEsmJs.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utilsEsmJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryEsmJs.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, _utilsEsmJs.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, _utilsEsmJs.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}

},{"./utils.esm.js":"bY77Q","./query.esm.js":"dhkBO","./notifyManager.esm.js":"fFChl","./subscribable.esm.js":"EcH6j","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dhkBO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
var _utilsEsmJs = require("./utils.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
var _removableEsmJs = require("./removable.esm.js");
// CLASS
class Query extends (0, _removableEsmJs.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsEsmJs.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state,
            setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, _utilsEsmJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, _utilsEsmJs.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, _retryerEsmJs.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, _retryerEsmJs.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, _retryerEsmJs.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, _retryerEsmJs.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, _retryerEsmJs.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action
            });
        });
    }
}
function getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}

},{"./utils.esm.js":"bY77Q","./logger.esm.js":"jED4P","./notifyManager.esm.js":"fFChl","./retryer.esm.js":"hfSBY","./removable.esm.js":"gTvtF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jED4P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLogger", ()=>defaultLogger);
const defaultLogger = console;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fFChl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _utilsEsmJs = require("./utils.esm.js");
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch,
        batchCalls,
        schedule,
        setNotifyFunction,
        setBatchNotifyFunction
    };
} // SINGLETON
const notifyManager = createNotifyManager();

},{"./utils.esm.js":"bY77Q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gTvtF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _utilsEsmJs = require("./utils.esm.js");
class Removable {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsEsmJs.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, _utilsEsmJs.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

},{"./utils.esm.js":"bY77Q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"OmDKG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _utilsEsmJs = require("./utils.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _infiniteQueryBehaviorEsmJs = require("./infiniteQueryBehavior.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
// CLASS
class QueryClient {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, _queryCacheEsmJs.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, _mutationCacheEsmJs.MutationCache)();
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, _focusManagerEsmJs.focusManager).subscribe(()=>{
            if ((0, _focusManagerEsmJs.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, _onlineManagerEsmJs.onlineManager).subscribe(()=>{
            if ((0, _onlineManagerEsmJs.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, _utilsEsmJs.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, _utilsEsmJs.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, _infiniteQueryBehaviorEsmJs.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(queryKey) === (0, _utilsEsmJs.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(mutationKey) === (0, _utilsEsmJs.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, _utilsEsmJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}

},{"./utils.esm.js":"bY77Q","./queryCache.esm.js":"ieZAJ","./mutationCache.esm.js":"7HuVU","./focusManager.esm.js":"1TEAN","./onlineManager.esm.js":"guSwG","./notifyManager.esm.js":"fFChl","./infiniteQueryBehavior.esm.js":"ePcgv","./logger.esm.js":"jED4P","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7HuVU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _mutationEsmJs = require("./mutation.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class MutationCache extends (0, _subscribableEsmJs.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, _mutationEsmJs.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation
        });
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, _notifyManagerEsmJs.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, _utilsEsmJs.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}

},{"./notifyManager.esm.js":"fFChl","./mutation.esm.js":"9M3pF","./utils.esm.js":"bY77Q","./subscribable.esm.js":"EcH6j","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9M3pF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _removableEsmJs = require("./removable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
// CLASS
class Mutation extends (0, _removableEsmJs.Removable) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.observers = [];
        this.state = config.state || getDefaultState();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, _retryerEsmJs.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount,
                        error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, _retryerEsmJs.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action
            });
        });
    }
}
function getDefaultState() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

},{"./logger.esm.js":"jED4P","./notifyManager.esm.js":"fFChl","./removable.esm.js":"gTvtF","./retryer.esm.js":"hfSBY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ePcgv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextPageParam", ()=>getNextPageParam);
parcelHelpers.export(exports, "getPreviousPageParam", ()=>getPreviousPageParam);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
function infiniteQueryBehavior() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function getNextPageParam(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function hasNextPage(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = getNextPageParam(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function hasPreviousPage(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = getPreviousPageParam(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"336XF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _utilsEsmJs = require("./utils.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
class QueryObserver extends (0, _subscribableEsmJs.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if (shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, _utilsEsmJs.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if (shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, _utilsEsmJs.isServer) || this.currentResult.isStale || !(0, _utilsEsmJs.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, _utilsEsmJs.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, _utilsEsmJs.isServer) || this.options.enabled === false || !(0, _utilsEsmJs.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, _focusManagerEsmJs.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state } = query;
        let { dataUpdatedAt, error, errorUpdatedAt, fetchStatus, status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, _retryerEsmJs.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status,
            fetchStatus,
            isLoading,
            isSuccess: status === "success",
            isError,
            isInitialLoading: isLoading && isFetching,
            data,
            dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData,
            isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, _utilsEsmJs.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, _retryerEsmJs.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, _utilsEsmJs.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

},{"./utils.esm.js":"bY77Q","./notifyManager.esm.js":"fFChl","./focusManager.esm.js":"1TEAN","./subscribable.esm.js":"EcH6j","./retryer.esm.js":"hfSBY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1eK5m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationObserver", ()=>MutationObserver);
var _mutationEsmJs = require("./mutation.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
// CLASS
class MutationObserver extends (0, _subscribableEsmJs.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, _utilsEsmJs.shallowEqualObjects)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, _mutationEsmJs.getDefaultState)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener })=>{
                listener(this.currentResult);
            });
        });
    }
}

},{"./mutation.esm.js":"9M3pF","./notifyManager.esm.js":"fFChl","./subscribable.esm.js":"EcH6j","./utils.esm.js":"bY77Q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"66lqj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>unstable_batchedUpdates);
var _reactDom = require("react-dom");
"use client";
const unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

},{"react-dom":"aPjLf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iaSzV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryEsmJs = require("./useBaseQuery.esm.js");
"use client";
function useQuery(arg1, arg2, arg3) {
    const parsedOptions = (0, _queryCore.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQueryEsmJs.useBaseQuery)(parsedOptions, (0, _queryCore.QueryObserver));
}

},{"@tanstack/query-core":"97qaq","./useBaseQuery.esm.js":"dtBqn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dtBqn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");
var _errorBoundaryUtilsEsmJs = require("./errorBoundaryUtils.esm.js");
var _suspenseEsmJs = require("./suspense.esm.js");
"use client";
function useBaseQuery(options, Observer) {
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, _isRestoringEsmJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, _suspenseEsmJs.ensureStaleTime)(defaultedOptions);
    (0, _errorBoundaryUtilsEsmJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, _errorBoundaryUtilsEsmJs.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = _react.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, _suspenseEsmJs.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, _suspenseEsmJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, _errorBoundaryUtilsEsmJs.getHasError)({
        result,
        errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"cOWTg","@tanstack/query-core":"97qaq","./useSyncExternalStore.esm.js":"dBNIE","./QueryErrorResetBoundary.esm.js":"exjqr","./QueryClientProvider.esm.js":"97POi","./isRestoring.esm.js":"4F81M","./errorBoundaryUtils.esm.js":"dymA0","./suspense.esm.js":"bv8E0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dBNIE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>useSyncExternalStore);
var _indexJs = require("use-sync-external-store/shim/index.js");
"use client";
const useSyncExternalStore = (0, _indexJs.useSyncExternalStore);

},{"use-sync-external-store/shim/index.js":"gf66g","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gf66g":[function(require,module,exports) {
"use strict";
module.exports = require("8b974a2950a0796c");

},{"8b974a2950a0796c":"e2Tzh"}],"e2Tzh":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("2f7d03d9688f598f");
function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
function q(a, b) {
    var d = b(), f = l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    n(function() {
        c.value = d;
        c.getSnapshot = b;
        r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    m(function() {
        r(c) && g({
            inst: c
        });
        return a(function() {
            r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    p(d);
    return d;
}
function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !k(a, d);
    } catch (f) {
        return !0;
    }
}
function t(a, b) {
    return b();
}
var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
exports.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;

},{"2f7d03d9688f598f":"cOWTg"}],"exjqr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
var _react = require("react");
"use client";
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const QueryErrorResetBoundaryContext = /*#__PURE__*/ _react.createContext(createValue()); // HOOK
const useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext); // COMPONENT
const QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /*#__PURE__*/ _react.createElement(QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"97POi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "defaultContext", ()=>defaultContext);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
var _react = require("react");
"use client";
const defaultContext = /*#__PURE__*/ _react.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/ _react.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = defaultContext;
        return window.ReactQueryClientContext;
    }
    return defaultContext;
}
const useQueryClient = ({ context } = {})=>{
    const queryClient = _react.useContext(getQueryClientContext(context, _react.useContext(QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const QueryClientProvider = ({ client, children, context, contextSharing = false })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ _react.createElement(QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: client
    }, children));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4F81M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
var _react = require("react");
"use client";
const IsRestoringContext = /*#__PURE__*/ _react.createContext(false);
const useIsRestoring = ()=>_react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dymA0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
var _react = require("react");
var _utilsEsmJs = require("./utils.esm.js");
"use client";
const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const getHasError = ({ result, errorResetBoundary, useErrorBoundary, query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, _utilsEsmJs.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

},{"react":"cOWTg","./utils.esm.js":"lY873","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lY873":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
function shouldThrowError(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bv8E0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensureStaleTime", ()=>ensureStaleTime);
parcelHelpers.export(exports, "fetchOptimistic", ()=>fetchOptimistic);
parcelHelpers.export(exports, "shouldSuspend", ()=>shouldSuspend);
parcelHelpers.export(exports, "willFetch", ()=>willFetch);
const ensureStaleTime = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const willFetch = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4SRLx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMutating", ()=>useIsMutating);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
"use client";
function useIsMutating(arg1, arg2, arg3) {
    const [filters, options = {}] = (0, _queryCore.parseMutationFilterArgs)(arg1, arg2, arg3);
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const mutationCache = queryClient.getMutationCache();
    return (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>mutationCache.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        mutationCache
    ]), ()=>queryClient.isMutating(filters), ()=>queryClient.isMutating(filters));
}

},{"react":"cOWTg","@tanstack/query-core":"97qaq","./useSyncExternalStore.esm.js":"dBNIE","./QueryClientProvider.esm.js":"97POi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dGn1J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutation", ()=>useMutation);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
"use client";
function useMutation(arg1, arg2, arg3) {
    const options = (0, _queryCore.parseMutationArgs)(arg1, arg2, arg3);
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const [observer] = _react.useState(()=>new (0, _queryCore.MutationObserver)(queryClient, options));
    _react.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = _react.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch(noop);
    }, [
        observer
    ]);
    if (result.error && (0, _utilsEsmJs.shouldThrowError)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

},{"react":"cOWTg","@tanstack/query-core":"97qaq","./useSyncExternalStore.esm.js":"dBNIE","./QueryClientProvider.esm.js":"97POi","./utils.esm.js":"lY873","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eBrdC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerStyleSheet", ()=>mt);
parcelHelpers.export(exports, "StyleSheetConsumer", ()=>$e);
parcelHelpers.export(exports, "StyleSheetContext", ()=>Me);
parcelHelpers.export(exports, "StyleSheetManager", ()=>Le);
parcelHelpers.export(exports, "ThemeConsumer", ()=>Qe);
parcelHelpers.export(exports, "ThemeContext", ()=>Ke);
parcelHelpers.export(exports, "ThemeProvider", ()=>tt);
parcelHelpers.export(exports, "__PRIVATE__", ()=>yt);
parcelHelpers.export(exports, "createGlobalStyle", ()=>dt);
parcelHelpers.export(exports, "css", ()=>at);
parcelHelpers.export(exports, "default", ()=>ut);
parcelHelpers.export(exports, "isStyledComponent", ()=>se);
parcelHelpers.export(exports, "keyframes", ()=>ht);
parcelHelpers.export(exports, "styled", ()=>ut);
parcelHelpers.export(exports, "useTheme", ()=>et);
parcelHelpers.export(exports, "version", ()=>v);
parcelHelpers.export(exports, "withTheme", ()=>ft);
var _tslib = require("tslib");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
var _stylis = require("stylis");
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var process = require("50571207bc3cae02");
var f = ("undefined" != typeof process && void 0 !== process.env && undefined, "data-styled"), m = "active", y = "data-styled-version", v = "6.1.8", g = "/*!sc*/\n", S = "undefined" != typeof window && "HTMLElement" in window, w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof process && process.env, "undefined" != typeof process && process.env, false)), b = {}, E = /invalid hook call/i, N = new Set, P = function(t, n) {
    var o, s, i, a, e;
}, _ = Object.freeze([]), C = Object.freeze({});
function I(e, t, n) {
    return void 0 === n && (n = C), e.theme !== n.theme && e.theme || t || n.theme;
}
var A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, D = /(^-|-$)/g;
function R(e) {
    return e.replace(O, "-").replace(D, "");
}
var T = /(a)(d)/gi, k = 52, j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > k; t = t / k | 0)n = j(t % k) + n;
    return (j(t % k) + n).replace(T, "$1-$2");
}
var V, F = 5381, M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $ = function(e) {
    return M(F, e);
};
function z(e) {
    return x($(e) >>> 0);
}
function B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function L(e) {
    return "string" == typeof e && true;
}
var G = "function" == typeof Symbol && Symbol.for, Y = G ? Symbol.for("react.memo") : 60115, W = G ? Symbol.for("react.forward_ref") : 60112, q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, J = ((V = {})[W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, V[Y] = U, V);
function X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === Y ? U : "$$typeof" in e ? J[e.$$typeof] : q;
}
var Z = Object.defineProperty, K = Object.getOwnPropertyNames, Q = Object.getOwnPropertySymbols, ee = Object.getOwnPropertyDescriptor, te = Object.getPrototypeOf, ne = Object.prototype;
function oe(e, t, n) {
    if ("string" != typeof t) {
        if (ne) {
            var o = te(t);
            o && o !== ne && oe(e, o, n);
        }
        var r = K(t);
        Q && (r = r.concat(Q(t)));
        for(var s = X(e), i = X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in H || n && n[c] || i && c in i || s && c in s)) {
                var l = ee(t, c);
                try {
                    Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function re(e) {
    return "function" == typeof e;
}
function se(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = le(e[o], t[o]);
    else if (ce(t)) for(var o in t)e[o] = le(e[o], t[o]);
    return e;
}
function ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var pe = {};
function de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat(g);
        return t;
    }, e;
}(), me = new Map, ye = new Map, ve = 1, ge = function(e) {
    if (me.has(e)) return me.get(e);
    for(; ye.has(ve);)ve++;
    var t = ve++;
    return me.set(e, t), ye.set(t, e), t;
}, Se = function(e, t) {
    ve = t + 1, me.set(e, t), ye.set(t, e);
}, we = "style[".concat(f, "][").concat(y, '="').concat(v, '"]'), be = new RegExp("^".concat(f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Ee = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, Ne = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split(g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match(be);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && (Se(u, l), Ee(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function Pe() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var _e = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat(f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute(f, m), o.setAttribute(y, v);
    var i = Pe();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, Ce = function() {
    function e(e) {
        this.element = _e(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), Ie = function() {
    function e(e) {
        this.element = _e(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), Ae = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), Oe = S, De = {
    isServer: !S,
    useCSSOMInjection: !w
}, Re = function() {
    function e(e, n, o) {
        void 0 === e && (e = C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, De), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && S && Oe && (Oe = !1, function(e) {
            for(var t = document.querySelectorAll(we), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute(f) !== m && (Ne(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return ye.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat(f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat(g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return ge(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new Ae(n) : t ? new Ce(n) : new Ie(n);
        }(this.options), new fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if (ge(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules(ge(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup(ge(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), Te = /&/g, ke = /^\s*\/\/.*$/gm;
function je(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = je(e.children, t)), e;
    });
}
function xe(e) {
    var t, n, o, r = void 0 === e ? C : e, s = r.options, i = void 0 === s ? C : s, a = r.plugins, c = void 0 === a ? _ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === _stylis.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace(Te, n).replace(o, l));
    }), i.prefix && u.push(_stylis.prefixer), u.push(_stylis.stringify);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace(ke, ""), l = _stylis.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = je(l, i.namespace));
        var p = [];
        return _stylis.serialize(l, _stylis.middleware(u.concat(_stylis.rulesheet(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || he(15), M(e, t.name);
    }, F).toString() : "", p;
}
var Ve = new Re, Fe = xe(), Me = (0, _reactDefault.default).createContext({
    shouldForwardProp: void 0,
    styleSheet: Ve,
    stylis: Fe
}), $e = Me.Consumer, ze = (0, _reactDefault.default).createContext(void 0);
function Be() {
    return (0, _react.useContext)(Me);
}
function Le(e) {
    var t = (0, _react.useState)(e.stylisPlugins), n = t[0], r = t[1], c = Be().styleSheet, l = (0, _react.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, _react.useMemo)(function() {
        return xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, _react.useEffect)(function() {
        (0, _shallowequalDefault.default)(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, _react.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, _reactDefault.default).createElement(Me.Provider, {
        value: d
    }, (0, _reactDefault.default).createElement(ze.Provider, {
        value: u
    }, e.children));
}
var Ge = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = Fe);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, ue(this, function() {
            throw he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = Fe), this.name + e.hash;
    }, e;
}(), Ye = function(e) {
    return e >= "A" && e <= "Z";
};
function We(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        Ye(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var qe = function(e) {
    return null == e || !1 === e || "" === e;
}, He = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !qe(i) && (Array.isArray(i) && i.isCss || re(i) ? r.push("".concat(We(s), ":"), i, ";") : ce(i) ? r.push.apply(r, (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([
            "".concat(s, " {")
        ], He(i), !1), [
            "}"
        ], !1)) : r.push("".concat(We(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, _unitlessDefault.default) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function Ue(e, t, n, o) {
    if (qe(e)) return [];
    if (se(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if (re(e)) {
        if (!re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return Ue(r, t, n, o);
    }
    var s;
    return e instanceof Ge ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : ce(e) ? He(e) : Array.isArray(e) ? Array.prototype.concat.apply(_, e.map(function(e) {
        return Ue(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function Je(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if (re(n) && !se(n)) return !1;
    }
    return !0;
}
var Xe = $(v), Ze = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && Je(e), this.componentId = t, this.baseHash = M(Xe, t), this.baseStyle = n, Re.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = ie(o, this.staticRulesId);
            else {
                var r = ae(Ue(this.rules, e, t, n)), s = x(M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = ae(Ue(u, e, t, n));
                    a = M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = ie(o, d);
            }
        }
        return o;
    }, e;
}(), Ke = (0, _reactDefault.default).createContext(void 0), Qe = Ke.Consumer;
function et() {
    var e = (0, _react.useContext)(Ke);
    if (!e) throw he(18);
    return e;
}
function tt(e) {
    var n = (0, _reactDefault.default).useContext(Ke), r = (0, _react.useMemo)(function() {
        return function(e, n) {
            if (!e) throw he(14);
            if (re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw he(8);
            return n ? (0, _tslib.__assign)((0, _tslib.__assign)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, _reactDefault.default).createElement(Ke.Provider, {
        value: r
    }, e.children) : null;
}
var nt = {}, ot = new Set;
function rt(e, r, s) {
    var i = se(e), a = e, c = !L(e), p = r.attrs, d = void 0 === p ? _ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : R(e);
        nt[n] = (nt[n] || 0) + 1;
        var o = "".concat(n, "-").concat(z(v + n + nt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return L(e) ? "styled.".concat(e) : "Styled(".concat(B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat(R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new Ze(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, _reactDefault.default).useContext(Ke), m = Be(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = I(r, f, c) || C, g = function(e, n, o) {
                for(var r, s = (0, _tslib.__assign)((0, _tslib.__assign)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? ie(s[c], a[c]) : "style" === c ? (0, _tslib.__assign)((0, _tslib.__assign)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = Be(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[L(S) && !A.has(S) ? "class" : "className"] = N, w.ref = s, (0, _react.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, _reactDefault.default).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function st(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var it = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function at(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if (re(t) || ce(t)) return it(Ue(st(_, (0, _tslib.__spreadArray)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? Ue(r) : it(Ue(st(r, n)));
}
function ct(n, o, r) {
    if (void 0 === r && (r = C), !o) throw he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, at.apply(void 0, (0, _tslib.__spreadArray)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return ct(n, o, (0, _tslib.__assign)((0, _tslib.__assign)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return ct(n, o, (0, _tslib.__assign)((0, _tslib.__assign)({}, r), e));
    }, s;
}
var lt = function(e) {
    return ct(rt, e);
}, ut = lt;
A.forEach(function(e) {
    ut[e] = lt(e);
});
var pt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = Je(e), Re.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o(ae(Ue(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && Re.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function dt(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = at.apply(void 0, (0, _tslib.__spreadArray)([
        n
    ], r, !1)), a = "sc-global-".concat(z(JSON.stringify(i))), c = new pt(i, a);
    var l = function(e) {
        var t = Be(), n = (0, _reactDefault.default).useContext(Ke), r = (0, _reactDefault.default).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, _reactDefault.default).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, b, o, s);
        else {
            var i = (0, _tslib.__assign)((0, _tslib.__assign)({}, n), {
                theme: I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, _reactDefault.default).memo(l);
}
function ht(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = ae(at.apply(void 0, (0, _tslib.__spreadArray)([
        t
    ], n, !1))), s = z(r);
    return new Ge(s, r);
}
function ft(e) {
    var n = (0, _reactDefault.default).forwardRef(function(n, r) {
        var s = I(n, (0, _reactDefault.default).useContext(Ke), e.defaultProps);
        return (0, _reactDefault.default).createElement(e, (0, _tslib.__assign)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat(B(e), ")"), oe(n, e);
}
var mt = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = Pe(), o = ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat(f, '="true"'),
                "".concat(y, '="').concat(v, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw he(2);
            var r = ((n = {})[f] = "", n[y] = v, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = Pe();
            return s && (r.nonce = s), [
                (0, _reactDefault.default).createElement("style", (0, _tslib.__assign)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new Re({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw he(2);
        return (0, _reactDefault.default).createElement(Le, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw he(3);
    }, e;
}(), yt = {
    StyleSheet: Re,
    mainSheet: Ve
};
var vt = "__sc-".concat(f, "__");

},{"50571207bc3cae02":"b4AGK","tslib":"7uFVL","@emotion/is-prop-valid":"kjOQx","react":"cOWTg","shallowequal":"6DR0Y","stylis":"4B3Ub","@emotion/unitless":"d5OTS","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7uFVL":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6DR0Y":[function(require,module,exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"4B3Ub":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>g);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>k);
parcelHelpers.export(exports, "alloc", ()=>X);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>U);
parcelHelpers.export(exports, "char", ()=>P);
parcelHelpers.export(exports, "character", ()=>I);
parcelHelpers.export(exports, "characters", ()=>J);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>F);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>fe);
parcelHelpers.export(exports, "commenter", ()=>ce);
parcelHelpers.export(exports, "compile", ()=>te);
parcelHelpers.export(exports, "copy", ()=>L);
parcelHelpers.export(exports, "dealloc", ()=>Y);
parcelHelpers.export(exports, "declaration", ()=>oe);
parcelHelpers.export(exports, "delimit", ()=>Z);
parcelHelpers.export(exports, "delimiter", ()=>ne);
parcelHelpers.export(exports, "escaping", ()=>ae);
parcelHelpers.export(exports, "filter", ()=>D);
parcelHelpers.export(exports, "from", ()=>$);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>se);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>G);
parcelHelpers.export(exports, "lift", ()=>N);
parcelHelpers.export(exports, "line", ()=>E);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>he);
parcelHelpers.export(exports, "namespace", ()=>de);
parcelHelpers.export(exports, "next", ()=>R);
parcelHelpers.export(exports, "node", ()=>K);
parcelHelpers.export(exports, "parse", ()=>ue);
parcelHelpers.export(exports, "peek", ()=>T);
parcelHelpers.export(exports, "position", ()=>H);
parcelHelpers.export(exports, "prefix", ()=>le);
parcelHelpers.export(exports, "prefixer", ()=>we);
parcelHelpers.export(exports, "prev", ()=>Q);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>ie);
parcelHelpers.export(exports, "rulesheet", ()=>be);
parcelHelpers.export(exports, "serialize", ()=>ve);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>V);
parcelHelpers.export(exports, "stringify", ()=>pe);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>W);
parcelHelpers.export(exports, "tokenize", ()=>_);
parcelHelpers.export(exports, "tokenizer", ()=>re);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>ee);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var g = "@layer";
var k = Math.abs;
var $ = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r, a) {
    return e.indexOf(r, a);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
function D(e, r) {
    return e.filter(function(e) {
        return !j(e, r);
    });
}
var E = 1;
var F = 1;
var G = 0;
var H = 0;
var I = 0;
var J = "";
function K(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: E,
        column: F,
        length: t,
        return: "",
        siblings: u
    };
}
function L(e, r) {
    return m(K("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function N(e) {
    while(e.root)e = L(e.root, {
        children: [
            e
        ]
    });
    q(e, e.siblings);
}
function P() {
    return I;
}
function Q() {
    I = H > 0 ? O(J, --H) : 0;
    if (F--, I === 10) F = 1, E--;
    return I;
}
function R() {
    I = H < G ? O(J, H++) : 0;
    if (F++, I === 10) F = 1, E++;
    return I;
}
function T() {
    return O(J, H);
}
function U() {
    return H;
}
function V(e, r) {
    return A(J, e, r);
}
function W(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function X(e) {
    return E = F = 1, G = M(J = e), H = 0, [];
}
function Y(e) {
    return J = "", e;
}
function Z(e) {
    return y(V(H - 1, ne(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function _(e) {
    return Y(re(X(e)));
}
function ee(e) {
    while(I = T())if (I < 33) R();
    else break;
    return W(e) > 2 || W(I) > 3 ? "" : " ";
}
function re(e) {
    while(R())switch(W(I)){
        case 0:
            q(se(H - 1), e);
            break;
        case 2:
            q(Z(I), e);
            break;
        default:
            q($(I), e);
    }
    return e;
}
function ae(e, r) {
    while(--r && R())if (I < 48 || I > 102 || I > 57 && I < 65 || I > 70 && I < 97) break;
    return V(e, U() + (r < 6 && T() == 32 && R() == 32));
}
function ne(e) {
    while(R())switch(I){
        case e:
            return H;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) ne(I);
            break;
        case 40:
            if (e === 41) ne(e);
            break;
        case 92:
            R();
            break;
    }
    return H;
}
function ce(e, r) {
    while(R())if (e + I === 57) break;
    else if (e + I === 84 && T() === 47) break;
    return "/*" + V(r, H - 1) + "*" + $(e === 47 ? e : R());
}
function se(e) {
    while(!W(T()))R();
    return V(e, H);
}
function te(e) {
    return Y(ue("", null, null, null, [
        ""
    ], e = X(e), 0, [
        0
    ], e));
}
function ue(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var m = "";
    var x = c;
    var y = s;
    var j = n;
    var A = m;
    while(w)switch(h = g, g = R()){
        case 40:
            if (h != 108 && O(A, l - 1) == 58) {
                if (C(A += z(Z(g), "&", "&\f"), "&\f", k(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            A += Z(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            A += ee(h);
            break;
        case 92:
            A += ae(U() - 1, 7);
            continue;
        case 47:
            switch(T()){
                case 42:
                case 47:
                    q(fe(ce(R(), U()), r, a, i), i);
                    break;
                default:
                    A += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(A) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) A = z(A, /\f/g, "");
                    if (p > 0 && M(A) - l) q(p > 32 ? oe(A + ";", n, a, l - 1, i) : oe(z(A, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    A += ";";
                default:
                    q(j = ie(A, r, a, f, o, c, u, m, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) ue(A, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && O(A, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                ue(e, j, j, n && q(ie(e, j, j, 0, 0, c, u, m, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                ue(A, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, m = A = "", l = t;
            break;
        case 58:
            l = 1 + M(A), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && Q() == 125) continue;
            }
            switch(A += $(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (A += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(A) - 1) * d, d = 1;
                    break;
                case 64:
                    if (T() === 45) A += Z(R());
                    v = T(), o = l = M(m = A += se(U())), g++;
                    break;
                case 45:
                    if (h === 45 && M(A) == 2) b = 0;
            }
    }
    return s;
}
function ie(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = S(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = A(e, p + 1, p = k(d = u[w])), x = e; $ < b; ++$)if (x = y(d > 0 ? h[$] + " " + m : z(m, /&\f/g, h[$]))) f[g++] = x;
    return K(e, r, a, s === 0 ? c : i, f, o, l, v);
}
function fe(e, r, a, c) {
    return K(e, r, a, n, $(P()), A(e, 2, -2), 0, c);
}
function oe(e, r, a, n, c) {
    return K(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n, c);
}
function le(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span", 0) ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span", 0) ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch", 0) ? le(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function ve(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function pe(e, r, a, t) {
    switch(e.type){
        case g:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + ve(e.children, t) + "}";
        case c:
            if (!M(e.value = e.props.join(","))) return "";
    }
    return M(a = ve(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function he(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function be(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function we(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = le(n.value, n.length, u);
                return;
            case h:
                return ve([
                    L(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(u = n.props, function(c) {
                    switch(j(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            N(L(n, {
                                props: [
                                    z(c, /:(read-\w+)/, ":" + r + "$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    c
                                ]
                            }));
                            m(n, {
                                props: D(u, i)
                            });
                            break;
                        case "::placeholder":
                            N(L(n, {
                                props: [
                                    z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    z(c, /:(plac\w+)/, ":" + r + "$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    z(c, /:(plac\w+)/, e + "input-$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    c
                                ]
                            }));
                            m(n, {
                                props: D(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function de(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(_(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d5OTS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cbJvB":[function(require,module,exports) {
"use strict";
require("747173efb87bfabe");
require("be641bf347268f7a");
require("2f84f14cd628c9a1");
var entryUnbind = require("ae5fd73da9da7b45");
module.exports = entryUnbind("String", "replaceAll");

},{"747173efb87bfabe":"d5XN4","be641bf347268f7a":"37UTQ","2f84f14cd628c9a1":"2WviQ","ae5fd73da9da7b45":"jHZEH"}],"d5XN4":[function(require,module,exports) {
"use strict";
var $ = require("72ba4de9841213e");
var exec = require("d4ebaff1663cc5b9");
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== exec
}, {
    exec: exec
});

},{"72ba4de9841213e":"7LilS","d4ebaff1663cc5b9":"lDRD3"}],"7LilS":[function(require,module,exports) {
"use strict";
var global = require("6643b6592ad59b23");
var getOwnPropertyDescriptor = require("2ec751f39e500b85").f;
var createNonEnumerableProperty = require("b4567636b28a3b3a");
var defineBuiltIn = require("50460aa43dd4048a");
var defineGlobalProperty = require("581238c99f8c2c30");
var copyConstructorProperties = require("566a383894c688bc");
var isForced = require("f0e2e697f04e8ad9");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = global;
    else if (STATIC) target = global[TARGET] || defineGlobalProperty(TARGET, {});
    else target = global[TARGET] && global[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
        defineBuiltIn(target, key, sourceProperty, options);
    }
};

},{"6643b6592ad59b23":"j6YVW","2ec751f39e500b85":"lYAdJ","b4567636b28a3b3a":"br79i","50460aa43dd4048a":"cyjCn","581238c99f8c2c30":"4GyjI","566a383894c688bc":"kfsfg","f0e2e697f04e8ad9":"bpPW6"}],"lYAdJ":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("c04e6fb248689dba");
var call = require("553ec943aa2a4554");
var propertyIsEnumerableModule = require("bbc5e69071aa2fbd");
var createPropertyDescriptor = require("1d2ffbfd99e01f41");
var toIndexedObject = require("c4ea69a78a643d87");
var toPropertyKey = require("8ab18ff766aa2ab9");
var hasOwn = require("3761c5d34b7aa48f");
var IE8_DOM_DEFINE = require("c4dfcc26308f1b4a");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"c04e6fb248689dba":"55NyN","553ec943aa2a4554":"hBrD1","bbc5e69071aa2fbd":"5K18u","1d2ffbfd99e01f41":"ehEJ3","c4ea69a78a643d87":"1GuaN","8ab18ff766aa2ab9":"cfNtP","3761c5d34b7aa48f":"36o5K","c4dfcc26308f1b4a":"iHNmT"}],"5K18u":[function(require,module,exports) {
"use strict";
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],"1GuaN":[function(require,module,exports) {
"use strict";
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require("9d8f8f50ac9468eb");
var requireObjectCoercible = require("f7224aed72953ac4");
module.exports = function(it) {
    return IndexedObject(requireObjectCoercible(it));
};

},{"9d8f8f50ac9468eb":"jC9rj","f7224aed72953ac4":"1YCCJ"}],"jC9rj":[function(require,module,exports) {
"use strict";
var uncurryThis = require("7ba7e65983d7b662");
var fails = require("df551e12a7c872dd");
var classof = require("1d34ea813cebff9c");
var $Object = Object;
var split = uncurryThis("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return classof(it) === "String" ? split(it, "") : $Object(it);
} : $Object;

},{"7ba7e65983d7b662":"37Z8T","df551e12a7c872dd":"2EuIj","1d34ea813cebff9c":"gYVXX"}],"kfsfg":[function(require,module,exports) {
"use strict";
var hasOwn = require("d91d786cc71453ce");
var ownKeys = require("88cb809f98beddc6");
var getOwnPropertyDescriptorModule = require("10ea642aad5f7c21");
var definePropertyModule = require("39ff598ce822187e");
module.exports = function(target, source, exceptions) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

},{"d91d786cc71453ce":"36o5K","88cb809f98beddc6":"RcMcd","10ea642aad5f7c21":"lYAdJ","39ff598ce822187e":"iTMdX"}],"RcMcd":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("3cc1e4329d869e34");
var uncurryThis = require("2b8e77cbdbe3db7a");
var getOwnPropertyNamesModule = require("d703bcb62fcda216");
var getOwnPropertySymbolsModule = require("157674bad2772c6d");
var anObject = require("a09e060b9cae3c6c");
var concat = uncurryThis([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"3cc1e4329d869e34":"lFcMR","2b8e77cbdbe3db7a":"37Z8T","d703bcb62fcda216":"aCD4z","157674bad2772c6d":"avT9k","a09e060b9cae3c6c":"90Dm0"}],"aCD4z":[function(require,module,exports) {
"use strict";
var internalObjectKeys = require("6d8591e17a49376c");
var enumBugKeys = require("2c933f93dd98f385");
var hiddenKeys = enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
};

},{"6d8591e17a49376c":"29Y98","2c933f93dd98f385":"fzUSW"}],"29Y98":[function(require,module,exports) {
"use strict";
var uncurryThis = require("363ee0e6bb4f46a7");
var hasOwn = require("3183fe0b0bf6f6ac");
var toIndexedObject = require("28192ac12e934672");
var indexOf = require("a5f9c5d8e993ccd6").indexOf;
var hiddenKeys = require("57775908f1581bc6");
var push = uncurryThis([].push);
module.exports = function(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
    return result;
};

},{"363ee0e6bb4f46a7":"37Z8T","3183fe0b0bf6f6ac":"36o5K","28192ac12e934672":"1GuaN","a5f9c5d8e993ccd6":"hnJlD","57775908f1581bc6":"butZz"}],"hnJlD":[function(require,module,exports) {
"use strict";
var toIndexedObject = require("d5dcbcd68ac5acd0");
var toAbsoluteIndex = require("212b13aecfa48226");
var lengthOfArrayLike = require("e5a8b3e1da4c5637");
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
};

},{"d5dcbcd68ac5acd0":"1GuaN","212b13aecfa48226":"lfuqb","e5a8b3e1da4c5637":"kSAsj"}],"lfuqb":[function(require,module,exports) {
"use strict";
var toIntegerOrInfinity = require("72fe0a53ad43912c");
var max = Math.max;
var min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"72fe0a53ad43912c":"lQoKl"}],"fzUSW":[function(require,module,exports) {
"use strict";
// IE8- don't enum bug keys
module.exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];

},{}],"avT9k":[function(require,module,exports) {
"use strict";
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],"bpPW6":[function(require,module,exports) {
"use strict";
var fails = require("10299561ea0c7870");
var isCallable = require("8b1ecdaf59f07210");
var replacement = /#|\.prototype\./;
var isForced = function(feature, detection) {
    var value = data[normalize(feature)];
    return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = "N";
var POLYFILL = isForced.POLYFILL = "P";
module.exports = isForced;

},{"10299561ea0c7870":"2EuIj","8b1ecdaf59f07210":"aHyPE"}],"lDRD3":[function(require,module,exports) {
"use strict";
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = require("698f504b4733b02d");
var uncurryThis = require("6d0d2df39383a10b");
var toString = require("382af5492ddc18e6");
var regexpFlags = require("96e0244464229d3");
var stickyHelpers = require("3bd1d72d4987e0ff");
var shared = require("12c3e6e355312395");
var create = require("38d060dff8e4ab54");
var getInternalState = require("aec1e11e2cd92d19").get;
var UNSUPPORTED_DOT_ALL = require("7d9db6b4177b833a");
var UNSUPPORTED_NCG = require("b26a8ca5152d0a8d");
var nativeReplace = shared("native-string-replace", String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis("".charAt);
var indexOf = uncurryThis("".indexOf);
var replace = uncurryThis("".replace);
var stringSlice = uncurryThis("".slice);
var UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    call(nativeExec, re1, "a");
    call(nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
if (PATCH) patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = call(patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = replace(flags, "y", "");
        if (indexOf(flags, "g") === -1) flags += "g";
        strCopy = stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if (NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = call(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = stringSlice(match.input, charsAdded);
            match[0] = stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    call(nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
module.exports = patchedExec;

},{"698f504b4733b02d":"hBrD1","6d0d2df39383a10b":"37Z8T","382af5492ddc18e6":"b5sI8","96e0244464229d3":"dNPA1","3bd1d72d4987e0ff":"eMEEm","12c3e6e355312395":"8H71l","38d060dff8e4ab54":"49nuE","aec1e11e2cd92d19":"lNt2C","7d9db6b4177b833a":"2UAIZ","b26a8ca5152d0a8d":"90BJk"}],"b5sI8":[function(require,module,exports) {
"use strict";
var classof = require("3e4265f3f6994add");
var $String = String;
module.exports = function(argument) {
    if (classof(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $String(argument);
};

},{"3e4265f3f6994add":"qAq9Y"}],"eMEEm":[function(require,module,exports) {
"use strict";
var fails = require("797bef35e651cb5e");
var global = require("89bc0b5a5d5c9f99");
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;
var UNSUPPORTED_Y = fails(function() {
    var re = $RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function() {
    return !$RegExp("a", "y").sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y || fails(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") !== null;
});
module.exports = {
    BROKEN_CARET: BROKEN_CARET,
    MISSED_STICKY: MISSED_STICKY,
    UNSUPPORTED_Y: UNSUPPORTED_Y
};

},{"797bef35e651cb5e":"2EuIj","89bc0b5a5d5c9f99":"j6YVW"}],"49nuE":[function(require,module,exports) {
"use strict";
/* global ActiveXObject -- old IE, WSH */ var anObject = require("3bbe31d8f504111f");
var definePropertiesModule = require("a9712f03fc468b49");
var enumBugKeys = require("d9e0c389f84efa79");
var hiddenKeys = require("8a43b6a211717cde");
var html = require("78d31e3a50d79c6e");
var documentCreateElement = require("e29f7e32a0583f3");
var sharedKey = require("a6edaba97f293fc9");
var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement("iframe");
    var JS = "java" + SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

},{"3bbe31d8f504111f":"90Dm0","a9712f03fc468b49":"eWqvt","d9e0c389f84efa79":"fzUSW","8a43b6a211717cde":"butZz","78d31e3a50d79c6e":"gguv1","e29f7e32a0583f3":"kZUwH","a6edaba97f293fc9":"6I2Cd"}],"eWqvt":[function(require,module,exports) {
"use strict";
var DESCRIPTORS = require("aa39c539d0a1ec3f");
var V8_PROTOTYPE_DEFINE_BUG = require("2e9118dcee7eb93e");
var definePropertyModule = require("d88f5f00164c2da2");
var anObject = require("12ac356c5e06e57d");
var toIndexedObject = require("3cbdc44082c2f8b8");
var objectKeys = require("634da70e74fce29b");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};

},{"aa39c539d0a1ec3f":"55NyN","2e9118dcee7eb93e":"26J45","d88f5f00164c2da2":"iTMdX","12ac356c5e06e57d":"90Dm0","3cbdc44082c2f8b8":"1GuaN","634da70e74fce29b":"gyDcs"}],"gyDcs":[function(require,module,exports) {
"use strict";
var internalObjectKeys = require("fb982c683f43ec98");
var enumBugKeys = require("7cabc30df1982d48");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
};

},{"fb982c683f43ec98":"29Y98","7cabc30df1982d48":"fzUSW"}],"gguv1":[function(require,module,exports) {
"use strict";
var getBuiltIn = require("14cb391fa4a0dda8");
module.exports = getBuiltIn("document", "documentElement");

},{"14cb391fa4a0dda8":"lFcMR"}],"2UAIZ":[function(require,module,exports) {
"use strict";
var fails = require("e4784e58ea762065");
var global = require("16fc714d526e0528");
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;
module.exports = fails(function() {
    var re = $RegExp(".", "s");
    return !(re.dotAll && re.test("\n") && re.flags === "s");
});

},{"e4784e58ea762065":"2EuIj","16fc714d526e0528":"j6YVW"}],"90BJk":[function(require,module,exports) {
"use strict";
var fails = require("b9b1a0fbdd999ded");
var global = require("504ba50ed83b9e32");
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;
module.exports = fails(function() {
    var re = $RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});

},{"b9b1a0fbdd999ded":"2EuIj","504ba50ed83b9e32":"j6YVW"}],"37UTQ":[function(require,module,exports) {
"use strict";
var apply = require("f8fd16f994f85406");
var call = require("b5234e1018cb2916");
var uncurryThis = require("c3560c75b4ad1ef2");
var fixRegExpWellKnownSymbolLogic = require("c4a2369a79c5aaa2");
var fails = require("daa534dec0372986");
var anObject = require("317f495e148be81e");
var isCallable = require("36464dd17d2a7224");
var isNullOrUndefined = require("cea091f017783d94");
var toIntegerOrInfinity = require("3847a5ff118f8ebb");
var toLength = require("effd88adfbb6b4bc");
var toString = require("953b724c90cd8db6");
var requireObjectCoercible = require("154963922e7c9354");
var advanceStringIndex = require("90f011aa61b831b4");
var getMethod = require("af552ab4c89e35be");
var getSubstitution = require("3726cfd8dc51c82c");
var regExpExec = require("6de55154ce28598");
var wellKnownSymbol = require("4b6a0c7e75a1080a");
var REPLACE = wellKnownSymbol("replace");
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis("".indexOf);
var stringSlice = uncurryThis("".slice);
var maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[REPLACE]) return /./[REPLACE]("a", "$0") === "";
    return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
fixRegExpWellKnownSymbolLogic("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = requireObjectCoercible(this);
            var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
            return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = anObject(this);
            var S = toString(string);
            if (typeof replaceValue == "string" && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = isCallable(replaceValue);
            if (!functionalReplace) replaceValue = toString(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = regExpExec(rx, S);
                if (result === null) break;
                push(results, result);
                if (!global) break;
                var matchStr = toString(result[0]);
                if (matchStr === "") rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = toString(result[0]);
                var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                    replacement = toString(apply(replaceValue, undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + stringSlice(S, nextSourcePosition);
        }
    ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

},{"f8fd16f994f85406":"4bXqH","b5234e1018cb2916":"hBrD1","c3560c75b4ad1ef2":"37Z8T","c4a2369a79c5aaa2":"iwP9O","daa534dec0372986":"2EuIj","317f495e148be81e":"90Dm0","36464dd17d2a7224":"aHyPE","cea091f017783d94":"aUt9w","3847a5ff118f8ebb":"lQoKl","effd88adfbb6b4bc":"kZQ1D","953b724c90cd8db6":"b5sI8","154963922e7c9354":"1YCCJ","90f011aa61b831b4":"iPj0s","af552ab4c89e35be":"fhwn3","3726cfd8dc51c82c":"fNdtZ","6de55154ce28598":"3COL6","4b6a0c7e75a1080a":"lTRfe"}],"4bXqH":[function(require,module,exports) {
"use strict";
var NATIVE_BIND = require("d07466971ded2aca");
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
    return call.apply(apply, arguments);
});

},{"d07466971ded2aca":"3ippH"}],"iwP9O":[function(require,module,exports) {
"use strict";
// TODO: Remove from `core-js@4` since it's moved to entry points
require("a7057ee05361671");
var call = require("771b9a32e3d08596");
var defineBuiltIn = require("5a9ef6cc43262548");
var regexpExec = require("b286e3fd8e91d745");
var fails = require("f56adef42dd3c42");
var wellKnownSymbol = require("39c5bea895574e43");
var createNonEnumerableProperty = require("1c6881441295e4f4");
var SPECIES = wellKnownSymbol("species");
var RegExpPrototype = RegExp.prototype;
module.exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !fails(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: call(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: call(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        defineBuiltIn(String.prototype, KEY, methods[0]);
        defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], "sham", true);
};

},{"a7057ee05361671":"d5XN4","771b9a32e3d08596":"hBrD1","5a9ef6cc43262548":"cyjCn","b286e3fd8e91d745":"lDRD3","f56adef42dd3c42":"2EuIj","39c5bea895574e43":"lTRfe","1c6881441295e4f4":"br79i"}],"iPj0s":[function(require,module,exports) {
"use strict";
var charAt = require("7830b1b106fe9c2f").charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function(S, index, unicode) {
    return index + (unicode ? charAt(S, index).length : 1);
};

},{"7830b1b106fe9c2f":"f4QHi"}],"f4QHi":[function(require,module,exports) {
"use strict";
var uncurryThis = require("8b9beff9818f042");
var toIntegerOrInfinity = require("d3e375e7697978fb");
var toString = require("545a72c28133c459");
var requireObjectCoercible = require("5bafa9e5b372669c");
var charAt = uncurryThis("".charAt);
var charCodeAt = uncurryThis("".charCodeAt);
var stringSlice = uncurryThis("".slice);
var createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = toString(requireObjectCoercible($this));
        var position = toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod(true)
};

},{"8b9beff9818f042":"37Z8T","d3e375e7697978fb":"lQoKl","545a72c28133c459":"b5sI8","5bafa9e5b372669c":"1YCCJ"}],"fNdtZ":[function(require,module,exports) {
"use strict";
var uncurryThis = require("3cf51fea5d34c201");
var toObject = require("999f669befd62c27");
var floor = Math.floor;
var charAt = uncurryThis("".charAt);
var replace = uncurryThis("".replace);
var stringSlice = uncurryThis("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = toObject(namedCaptures);
        symbols = SUBSTITUTION_SYMBOLS;
    }
    return replace(replacement, symbols, function(match, ch) {
        var capture;
        switch(charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return stringSlice(str, 0, position);
            case "'":
                return stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};

},{"3cf51fea5d34c201":"37Z8T","999f669befd62c27":"jzUbe"}],"3COL6":[function(require,module,exports) {
"use strict";
var call = require("fe012fd0e62b041c");
var anObject = require("953f0ef3a583db2e");
var isCallable = require("7b1bebb22aa6d09f");
var classof = require("41458309d054e6d9");
var regexpExec = require("2da13aa8500d5870");
var $TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function(R, S) {
    var exec = R.exec;
    if (isCallable(exec)) {
        var result = call(exec, R, S);
        if (result !== null) anObject(result);
        return result;
    }
    if (classof(R) === "RegExp") return call(regexpExec, R, S);
    throw new $TypeError("RegExp#exec called on incompatible receiver");
};

},{"fe012fd0e62b041c":"hBrD1","953f0ef3a583db2e":"90Dm0","7b1bebb22aa6d09f":"aHyPE","41458309d054e6d9":"gYVXX","2da13aa8500d5870":"lDRD3"}],"2WviQ":[function(require,module,exports) {
"use strict";
var $ = require("69381acad0f1f180");
var call = require("be2b5a787b4341ed");
var uncurryThis = require("70979a707458e2bc");
var requireObjectCoercible = require("ede342a754b29b08");
var isCallable = require("7b33c58d7c6a633e");
var isNullOrUndefined = require("bc393499bad934a6");
var isRegExp = require("1f633e1cea7bfece");
var toString = require("5a07dc19106ad672");
var getMethod = require("40b88ab8d2a68602");
var getRegExpFlags = require("c009564a6e08e49f");
var getSubstitution = require("49118a84cede6c94");
var wellKnownSymbol = require("d9c85063e2fa18d1");
var IS_PURE = require("179cb9efb80dcae1");
var REPLACE = wellKnownSymbol("replace");
var $TypeError = TypeError;
var indexOf = uncurryThis("".indexOf);
var replace = uncurryThis("".replace);
var stringSlice = uncurryThis("".slice);
var max = Math.max;
// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({
    target: "String",
    proto: true
}, {
    replaceAll: function replaceAll(searchValue, replaceValue) {
        var O = requireObjectCoercible(this);
        var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
        var position = 0;
        var endOfLastMatch = 0;
        var result = "";
        if (!isNullOrUndefined(searchValue)) {
            IS_REG_EXP = isRegExp(searchValue);
            if (IS_REG_EXP) {
                flags = toString(requireObjectCoercible(getRegExpFlags(searchValue)));
                if (!~indexOf(flags, "g")) throw new $TypeError("`.replaceAll` does not allow non-global regexes");
            }
            replacer = getMethod(searchValue, REPLACE);
            if (replacer) return call(replacer, searchValue, O, replaceValue);
            else if (IS_PURE && IS_REG_EXP) return replace(toString(O), searchValue, replaceValue);
        }
        string = toString(O);
        searchString = toString(searchValue);
        functionalReplace = isCallable(replaceValue);
        if (!functionalReplace) replaceValue = toString(replaceValue);
        searchLength = searchString.length;
        advanceBy = max(1, searchLength);
        position = indexOf(string, searchString);
        while(position !== -1){
            replacement = functionalReplace ? toString(replaceValue(searchString, position, string)) : getSubstitution(searchString, string, position, [], undefined, replaceValue);
            result += stringSlice(string, endOfLastMatch, position) + replacement;
            endOfLastMatch = position + searchLength;
            position = position + advanceBy > string.length ? -1 : indexOf(string, searchString, position + advanceBy);
        }
        if (endOfLastMatch < string.length) result += stringSlice(string, endOfLastMatch);
        return result;
    }
});

},{"69381acad0f1f180":"7LilS","be2b5a787b4341ed":"hBrD1","70979a707458e2bc":"37Z8T","ede342a754b29b08":"1YCCJ","7b33c58d7c6a633e":"aHyPE","bc393499bad934a6":"aUt9w","1f633e1cea7bfece":"60vUe","5a07dc19106ad672":"b5sI8","40b88ab8d2a68602":"fhwn3","c009564a6e08e49f":"5bTTW","49118a84cede6c94":"fNdtZ","d9c85063e2fa18d1":"lTRfe","179cb9efb80dcae1":"8k1hD"}],"60vUe":[function(require,module,exports) {
"use strict";
var isObject = require("4ca57df9821dbfa3");
var classof = require("b867bee476fc5018");
var wellKnownSymbol = require("42cd33b6dbd61bee");
var MATCH = wellKnownSymbol("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === "RegExp");
};

},{"4ca57df9821dbfa3":"ffNuE","b867bee476fc5018":"gYVXX","42cd33b6dbd61bee":"lTRfe"}],"5bTTW":[function(require,module,exports) {
"use strict";
var call = require("fd54476372f3a204");
var hasOwn = require("a12d2126c329f45");
var isPrototypeOf = require("815509f48e0b1e36");
var regExpFlags = require("37fba4854c4ab846");
var RegExpPrototype = RegExp.prototype;
module.exports = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in RegExpPrototype) && !hasOwn(R, "flags") && isPrototypeOf(RegExpPrototype, R) ? call(regExpFlags, R) : flags;
};

},{"fd54476372f3a204":"hBrD1","a12d2126c329f45":"36o5K","815509f48e0b1e36":"hQKZd","37fba4854c4ab846":"dNPA1"}],"jHZEH":[function(require,module,exports) {
"use strict";
var global = require("6eb3e9eabff44728");
var uncurryThis = require("31d5922eb0be10f2");
module.exports = function(CONSTRUCTOR, METHOD) {
    return uncurryThis(global[CONSTRUCTOR].prototype[METHOD]);
};

},{"6eb3e9eabff44728":"j6YVW","31d5922eb0be10f2":"37Z8T"}],"dC0Jd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _auth0React = require("@auth0/auth0-react");
var _polaris = require("@shopify/polaris");
var _enJson = require("@shopify/polaris/locales/en.json");
var _enJsonDefault = parcelHelpers.interopDefault(_enJson);
var _nbJson = require("@shopify/polaris/locales/nb.json");
var _nbJsonDefault = parcelHelpers.interopDefault(_nbJson);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _navigationHelpers = require("../../helpers/navigation.helpers");
var _useAppTitle = require("../../hooks/useAppTitle");
var _useAppTitleDefault = parcelHelpers.interopDefault(_useAppTitle);
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _usePageNavigation = require("../../hooks/usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
var _errorBoundary = require("../ErrorBoundary/ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _globalStyles = require("../GlobalStyles/GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _routes = require("../Routes/Routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
var _sectionMargin = require("../SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _navigationToolbar = require("./NavigationToolbar/NavigationToolbar");
var _navigationToolbarDefault = parcelHelpers.interopDefault(_navigationToolbar);
var _pageNavigationMenu = require("./PageNavigationMenu/PageNavigationMenu");
var _pageNavigationMenuDefault = parcelHelpers.interopDefault(_pageNavigationMenu);
var _adapterLink = require("./AdapterLink");
var _adapterLinkDefault = parcelHelpers.interopDefault(_adapterLink);
var _liveChat = require("./LiveChat");
var _liveChatDefault = parcelHelpers.interopDefault(_liveChat);
var _snackbar = require("./Snackbar");
var _snackbarDefault = parcelHelpers.interopDefault(_snackbar);
var _stylesCss = require("@shopify/polaris/build/esm/styles.css");
const isDevelopment = false;
const App = ()=>{
    const { isAuthenticated, isLoading } = (0, _useAuthDefault.default)();
    const { showNavigationMenu } = (0, _usePageNavigationDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const showToolbar = (0, _navigationHelpers.shouldShowToolbar)();
    (0, _useAppTitleDefault.default)();
    const translations = language === "en" ? (0, _enJsonDefault.default) : (0, _nbJsonDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.AppProvider), {
        linkComponent: (0, _adapterLinkDefault.default),
        i18n: translations,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _errorBoundaryDefault.default), {
            children: [
                !isDevelopment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveChatDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Frame), {
                    topBar: isAuthenticated && !showToolbar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationToolbarDefault.default), {}) : null,
                    navigation: showNavigationMenu ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageNavigationMenuDefault.default), {}) : null,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _errorBoundaryDefault.default), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                                gap: "8",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPageWrapper, {
                                    children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Loading), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routesDefault.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snackbarDefault.default), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {})
            ]
        })
    });
};
const StyledPageWrapper = (0, _styledComponentsDefault.default).div`
  // allow page wrapper to extend to the entire width of the viewport
  max-width: 100%;

  margin-top: var(--p-space-8);
`;
/**
 * Wrap with Auth0's withAuthenticationRequired.
 * Anonymous users will be redirected to the Auth0-login page
 * and returned to the page they were redirected from after login
 */ exports.default = (0, _auth0React.withAuthenticationRequired)(App, {
    returnTo: `${window.location.pathname}${window.location.search}${window.location.hash}`
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@auth0/auth0-react":"bI3g5","@shopify/polaris":"ek5a0","@shopify/polaris/locales/en.json":"aiBhP","@shopify/polaris/locales/nb.json":"5JYgy","styled-components":"eBrdC","../../helpers/navigation.helpers":"adimP","../../hooks/useAppTitle":"51tmg","../../hooks/useAuth":"k9r0q","../../hooks/useLanguage":"2W6IE","../../hooks/usePageNavigation":"1o5Hm","../ErrorBoundary/ErrorBoundary":"7RMaM","../GlobalStyles/GlobalStyles":"7HsoD","../Routes/Routes":"jBlTw","../SectionMargin/SectionMargin":"l3u8a","./NavigationToolbar/NavigationToolbar":"h6cF9","./PageNavigationMenu/PageNavigationMenu":"d1LgG","./AdapterLink":"1rEwl","./LiveChat":"7Xe3D","./Snackbar":"hrOS0","@shopify/polaris/build/esm/styles.css":"awtT9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bI3g5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Auth0Context", ()=>Auth0Context);
parcelHelpers.export(exports, "Auth0Provider", ()=>Auth0Provider);
parcelHelpers.export(exports, "AuthenticationError", ()=>u);
parcelHelpers.export(exports, "GenericError", ()=>d);
parcelHelpers.export(exports, "InMemoryCache", ()=>P);
parcelHelpers.export(exports, "LocalStorageCache", ()=>z);
parcelHelpers.export(exports, "MfaRequiredError", ()=>m);
parcelHelpers.export(exports, "MissingRefreshTokenError", ()=>f);
parcelHelpers.export(exports, "OAuthError", ()=>OAuthError);
parcelHelpers.export(exports, "PopupCancelledError", ()=>p);
parcelHelpers.export(exports, "PopupTimeoutError", ()=>h);
parcelHelpers.export(exports, "TimeoutError", ()=>l);
parcelHelpers.export(exports, "User", ()=>ie);
parcelHelpers.export(exports, "initialContext", ()=>initialContext);
parcelHelpers.export(exports, "useAuth0", ()=>useAuth0);
parcelHelpers.export(exports, "withAuth0", ()=>withAuth0);
parcelHelpers.export(exports, "withAuthenticationRequired", ()=>withAuthenticationRequired);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var global = arguments[3];
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function e(e, t) {
    var i = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
    }
    return i;
}
"function" == typeof SuppressedError && SuppressedError;
var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var n = o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, i) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [
                    i
                ]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(i, o) {
                    e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
                });
            }, this.unlock = function(t) {
                var i = e.locked.get(t);
                if (void 0 !== i && 0 !== i.length) {
                    var o = i.pop();
                    e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return i.getInstance();
    };
});
i(n);
var a = i(o(function(e, i) {
    var o = t && t.__awaiter || function(e, t, i, o) {
        return new (i || (i = Promise))(function(n, a) {
            function r(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    a(e);
                }
            }
            function s(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    a(e);
                }
            }
            function c(e) {
                e.done ? n(e.value) : new i(function(t) {
                    t(e.value);
                }).then(r, s);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, a = t && t.__generator || function(e, t) {
        var i, o, n, a, r = {
            label: 0,
            sent: function() {
                if (1 & n[0]) throw n[1];
                return n[1];
            },
            trys: [],
            ops: []
        };
        return a = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this;
        }), a;
        function s(a) {
            return function(s) {
                return function(a) {
                    if (i) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                        switch(o = 0, n && (a = [
                            2 & a[0],
                            n.value
                        ]), a[0]){
                            case 0:
                            case 1:
                                n = a;
                                break;
                            case 4:
                                return r.label++, {
                                    value: a[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, o = a[1], a = [
                                    0
                                ];
                                continue;
                            case 7:
                                a = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                    r.label = a[1];
                                    break;
                                }
                                if (6 === a[0] && r.label < n[1]) {
                                    r.label = n[1], n = a;
                                    break;
                                }
                                if (n && r.label < n[2]) {
                                    r.label = n[2], r.ops.push(a);
                                    break;
                                }
                                n[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        a = t.call(e, r);
                    } catch (e) {
                        a = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        i = n = 0;
                    }
                    if (5 & a[0]) throw a[1];
                    return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                    };
                }([
                    a,
                    s
                ]);
            };
        }
    }, r = t;
    Object.defineProperty(i, "__esModule", {
        value: !0
    });
    var s = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function d(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function u(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++)i += t[Math.floor(Math.random() * t.length)];
        return i;
    }
    var l = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, i) {
            return void 0 === i && (i = 5e3), o(this, void 0, void 0, function() {
                var o, n, r, l, h, p, m;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
                        case 1:
                            return Date.now() < n ? [
                                4,
                                d(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return a.sent(), null !== l.getItemSync(r) ? [
                                3,
                                5
                            ] : (h = this.id + "-" + t + "-" + o, [
                                4,
                                d(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return a.sent(), l.setItemSync(r, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: h,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                d(30)
                            ];
                        case 4:
                            return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(n)
                            ];
                        case 6:
                            a.sent(), a.label = 7;
                        case 7:
                            return o = Date.now() + u(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var i = this;
                return a(this, function(r) {
                    return setTimeout(function() {
                        return o(i, void 0, void 0, function() {
                            var i, o, r;
                            return a(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return [
                                            4,
                                            n.default().lock(t)
                                        ];
                                    case 1:
                                        return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? (n.default().unlock(t), [
                                            2
                                        ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : (n.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return a(this, function(i) {
                    switch(i.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(i) {
                                    var o = !1, n = Date.now(), a = !1;
                                    function r() {
                                        if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - n);
                                            t > 0 ? setTimeout(i, t) : i(null);
                                        }
                                    }
                                    window.addEventListener("storage", r), e.addToWaiting(r);
                                    var s = setTimeout(r, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return i.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return a(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var i, o, r, d;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [
                                2
                            ] : (d = JSON.parse(r)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                n.default().lock(d.iat)
                            ];
                        case 1:
                            a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var i = Date.now() - 5e3, o = t, n = [], a = 0;;){
                var r = o.keySync(a);
                if (null === r) break;
                n.push(r), a++;
            }
            for(var c = !1, d = 0; d < n.length; d++){
                var u = n[d];
                if (u.includes(s)) {
                    var l = o.getItemSync(u);
                    if (null !== l) {
                        var h = JSON.parse(l);
                        (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    i.default = l;
}));
const r = {
    timeoutInSeconds: 60
}, s = {
    name: "auth0-spa-js",
    version: "2.1.3"
}, c = ()=>Date.now();
class d extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, d.prototype);
    }
    static fromPayload({ error: e, error_description: t }) {
        return new d(e, t);
    }
}
class u extends d {
    constructor(e, t, i, o = null){
        super(e, t), this.state = i, this.appState = o, Object.setPrototypeOf(this, u.prototype);
    }
}
class l extends d {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, l.prototype);
    }
}
class h extends l {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, h.prototype);
    }
}
class p extends d {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, p.prototype);
    }
}
class m extends d {
    constructor(e, t, i){
        super(e, t), this.mfa_token = i, Object.setPrototypeOf(this, m.prototype);
    }
}
class f extends d {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${g(e, [
            "default"
        ])}', scope: '${g(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, f.prototype);
    }
}
function g(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const w = ()=>window.crypto, y = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from(w().getRandomValues(new Uint8Array(43))).forEach((i)=>t += e[i % e.length]), t;
}, k = (e)=>btoa(e), v = (t)=>{
    var { clientId: i } = t, o = e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, i)=>Object.assign(Object.assign({}, t), {
                [i]: e[i]
            }), {}))(Object.assign({
        client_id: i
    }, o))).toString();
}, b = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), _ = async (e, t)=>{
    const i = await fetch(e, t);
    return {
        ok: i.ok,
        json: await i.json()
    };
}, I = async (e, t, i)=>{
    const o = new AbortController;
    let n;
    return t.signal = o.signal, Promise.race([
        _(e, t),
        new Promise((e, t)=>{
            n = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, i);
        })
    ]).finally(()=>{
        clearTimeout(n);
    });
}, S = async (e, t, i, o, n, a, r)=>{
    var s, c;
    return s = {
        auth: {
            audience: t,
            scope: i
        },
        timeout: n,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: r
    }, c = a, new Promise(function(e, t) {
        const i = new MessageChannel;
        i.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
        }, c.postMessage(s, [
            i.port2
        ]);
    });
}, O = async (e, t, i, o, n, a, r = 1e4)=>n ? S(e, t, i, o, r, n, a) : I(e, o, r);
async function T(t, i) {
    var { baseUrl: o, timeout: n, audience: a, scope: r, auth0Client: c, useFormData: u } = t, l = e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    const h = u ? v(l) : JSON.stringify(l);
    return await async function(t, i, o, n, a, r, s) {
        let c, u = null;
        for(let e = 0; e < 3; e++)try {
            c = await O(t, o, n, a, r, s, i), u = null;
            break;
        } catch (e) {
            u = e;
        }
        if (u) throw u;
        const l = c.json, { error: h, error_description: p } = l, g = e(l, [
            "error",
            "error_description"
        ]), { ok: w } = c;
        if (!w) {
            const e = p || `HTTP error. Unable to fetch ${t}`;
            if ("mfa_required" === h) throw new m(h, e, g.mfa_token);
            if ("missing_refresh_token" === h) throw new f(o, n);
            throw new d(h || "request_error", e);
        }
        return g;
    }(`${o}/oauth/token`, n, a || "default", r, {
        method: "POST",
        body: h,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || s))
        }
    }, i, u);
}
const j = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class C {
    constructor(e, t = "@@auth0spajs@@", i){
        this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, i, o, n] = e.split("::");
        return new C({
            clientId: i,
            scope: n,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: i, client_id: o } = e;
        return new C({
            scope: t,
            audience: i,
            clientId: o
        });
    }
}
class z {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class P {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, i) {
                    e[t] = i;
                },
                get (t) {
                    const i = e[t];
                    if (i) return i;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class x {
    constructor(e, t, i){
        this.cache = e, this.keyManifest = t, this.nowProvider = i || c;
    }
    async setIdToken(e, t, i) {
        var o;
        const n = this.getIdTokenCacheKey(e);
        await this.cache.set(n, {
            id_token: t,
            decodedToken: i
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0) {
        var i;
        let o = await this.cache.get(e.toKey());
        if (!o) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            i && (o = await this.cache.get(i));
        }
        if (!o) return;
        const n = await this.nowProvider(), a = Math.floor(n / 1e3);
        return o.expiresAt - t < a ? o.body.refresh_token ? (o.body = {
            refresh_token: o.body.refresh_token
        }, await this.cache.set(e.toKey(), o), o.body) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : o.body;
    }
    async set(e) {
        var t;
        const i = new C({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(i.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey()));
    }
    async clear(e) {
        var t;
        const i = await this.getCacheKeys();
        i && (await i.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new C({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var i;
            const o = C.fromKey(t), n = new Set(o.scope && o.scope.split(" ")), a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [], r = o.scope && a.reduce((e, t)=>e && n.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
        })[0];
    }
}
class Z {
    constructor(e, t, i){
        this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const K = (e)=>"number" == typeof e, W = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], E = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [i, o, n] = t;
        if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
        const a = JSON.parse(b(o)), r = {
            __raw: e
        }, s = {};
        return Object.keys(a).forEach((e)=>{
            r[e] = a[e], W.includes(e) || (s[e] = a[e]);
        }), {
            encoded: {
                header: i,
                payload: o,
                signature: n
            },
            header: JSON.parse(b(i)),
            claims: r,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const i = e.leeway || 60, o = new Date(e.now || Date.now()), n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);
    if (null != t.claims.nbf && K(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - i), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && K(t.claims.auth_time)) {
        const n = new Date(0);
        if (n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > n) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`);
    }
    if (e.organization) {
        const i = e.organization.trim();
        if (i.startsWith("org_")) {
            const e = i;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = i.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var R = o(function(e, i) {
    var o = t && t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, i = 1, o = arguments.length; i < o; i++)for(var n in t = arguments[i])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
        }, o.apply(this, arguments);
    };
    function n(e, t) {
        if (!t) return "";
        var i = "; " + e;
        return !0 === t ? i : i + "=" + t;
    }
    function a(e, t, i) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
        }(i);
    }
    function r(e) {
        for(var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++){
            var a = i[n].split("="), r = a.slice(1).join("=");
            '"' === r.charAt(0) && (r = r.slice(1, -1));
            try {
                t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function s() {
        return r(document.cookie);
    }
    function c(e, t, i) {
        document.cookie = a(e, t, o({
            path: "/"
        }, i));
    }
    i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function(e) {
        return s()[e];
    }, i.set = c, i.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
i(R), R.encode, R.parse, R.getAll;
var U = R.get, L = R.set, D = R.remove;
const X = {
    get (e) {
        const t = U(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), L(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), D(e, i);
    }
}, N = {
    get (e) {
        const t = X.get(e);
        return t || X.get(`_legacy_${e}`);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), L(`_legacy_${e}`, JSON.stringify(t), o), X.save(e, t, i);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), D(e, i), X.remove(e, t), X.remove(`_legacy_${e}`, t);
    }
}, J = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function F(e, t, i) {
    var o = void 0 === t ? null : t, n = function(e, t) {
        var i = atob(e);
        if (t) {
            for(var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n)o[n] = i.charCodeAt(n);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return i;
    }(e, void 0 !== i && i), a = n.indexOf("\n", 10) + 1, r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        r
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var H, Y, G, V, M = (H = "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", Y = null, G = !1, function(e) {
    return V = V || F(H, Y, G), new Worker(V, e);
});
const A = {};
class B {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const i = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        i.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...i
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const i = new Set(t.keys);
            return i.delete(e), i.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...i
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
}
const $ = {
    memory: ()=>(new P).enclosedCache,
    localstorage: ()=>new z
}, q = (e)=>$[e], Q = (t)=>{
    const { openUrl: i, onRedirect: o } = t, n = e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, n), {
        openUrl: !1 === i || i ? i : o
    });
}, ee = new a;
class te {
    constructor(e){
        let t, i;
        if (this.userCache = (new P).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !q(t)) throw new Error(`Invalid cache location "${t}"`);
            i = q(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? X : N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : J;
        var n;
        this.scope = j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || c, this.cacheManager = new x(i, i.allKeys ? void 0 : new B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : `https://${n}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new M);
    }
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || s)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${v(e)}`);
    }
    async _verifyIdToken(e, t, i) {
        const o = await this.nowProvider();
        var n;
        return E({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: i,
            leeway: this.options.leeway,
            max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, i) {
        const o = k(y()), n = k(y()), a = y(), r = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(a)), s = ((e, t, i, o, n, a, r, s)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), i), {
                scope: j(t, i.scope),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: n,
                redirect_uri: r || e.authorizationParams.redirect_uri,
                code_challenge: a,
                code_challenge_method: "S256"
            }))(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode), c = this._authorizeUrl(s);
        return {
            nonce: n,
            code_verifier: a,
            scope: s.scope,
            audience: s.audience || "default",
            redirect_uri: s.redirect_uri,
            state: o,
            url: c
        };
    }
    async loginWithPopup(e, t) {
        var i;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, i = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const n = await ((e)=>new Promise((t, i)=>{
                let o;
                const n = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", o, !1), i(new p(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(n), i(new h(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                        if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", o, !1), e.popup.close(), r.data.response.error) return i(d.fromPayload(r.data.response));
                        t(r.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== n.state) throw new d("state_mismatch", "Invalid state");
        const a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: n.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var i;
        const o = Q(t), { openUrl: n, fragment: a, appState: r } = o, s = e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, l = e(d, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: r
        }), c && {
            organization: c
        }));
        const h = a ? `${u}#${a}` : u;
        n ? await n(h) : window.location.assign(h);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: i, code: o, error: n, error_description: a } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), r = this.transactionManager.get();
        if (!r) throw new d("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), n) throw new u(n, a || n, i, r.appState);
        if (!r.code_verifier || r.state && r.state !== i) throw new d("state_mismatch", "Invalid state");
        const s = r.organization, c = r.nonce, l = r.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: r.audience,
            scope: r.scope,
            code_verifier: r.code_verifier,
            grant_type: "authorization_code",
            code: o
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: c,
            organization: s
        }), {
            appState: r.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const i = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), o = await ((e, t)=>{
            let i = A[t];
            return i || (i = e().finally(()=>{
                delete A[t], i = null;
            }), A[t] = i), i;
        })(()=>this._getTokenSilently(i), `${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);
        return e.detailedResponse ? o : null == o ? void 0 : o.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: i } = t, o = e(t, [
            "cacheMode"
        ]);
        if ("off" !== i) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (e) return e;
        }
        if ("cache-only" !== i) {
            if (!await (async (e, t = 3)=>{
                for(let i = 0; i < t; i++)if (await e()) return !0;
                return !1;
            })(()=>ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new l;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, access_token: n, oauthTokenScope: a, expires_in: r } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    access_token: n
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: r
                });
            } finally{
                await ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var i;
        const o = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
            })
        });
        t = Object.assign(Object.assign({}, r), t), await this.loginWithPopup(o, t);
        return (await this.cacheManager.get(new C({
            scope: o.authorizationParams.scope,
            audience: o.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }))).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const i = t.logoutParams || {}, { federated: o } = i, n = e(i, [
            "federated"
        ]), a = o ? "&federated" : "";
        return this._url(`/v2/logout?${v(Object.assign({
            clientId: t.clientId
        }, n))}`) + a;
    }
    async logout(t = {}) {
        const i = Q(t), { openUrl: o } = i, n = e(i, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@");
        const a = this._buildLogoutUrl(n);
        o ? await o(a) : !1 !== o && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), i = this.cookieStorage.get(this.orgHintCookieName);
        i && !t.organization && (t.organization = i);
        const { url: o, state: n, nonce: a, code_verifier: r, redirect_uri: s, scope: c, audience: u } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new d("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const i = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((e, t, i = 60)=>new Promise((o, n)=>{
                    const a = window.document.createElement("iframe");
                    a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                    const r = ()=>{
                        window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        n(new l), r();
                    }, 1e3 * i);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const i = e.source;
                        i && i.close(), e.data.response.error ? n(d.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                }))(o, this.domainUrl, i);
            if (n !== h.state) throw new d("state_mismatch", "Invalid state");
            const p = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, p), {
                scope: c,
                oauthTokenScope: p.scope,
                audience: u
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new C({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }));
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new f(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
        try {
            const n = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
            }), o && {
                timeout: o
            }));
            return Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
    }
    async _saveEntryInCache(t) {
        const { id_token: i, decodedToken: o } = t, n = e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: i,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(n);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new C({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), i = this.userCache.get("@@user@@");
        return t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: i }) {
        const o = await this.cacheManager.get(new C({
            scope: e,
            audience: t,
            clientId: i
        }), 60);
        if (o && o.access_token) {
            const { access_token: e, oauthTokenScope: t, expires_in: i } = o, n = await this._getIdTokenFromCache();
            return n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: e
            }, t ? {
                scope: t
            } : null), {
                expires_in: i
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: i, organization: o } = t || {}, n = await T(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs
        }, e), this.worker), a = await this._verifyIdToken(n.id_token, i, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
            decodedToken: a,
            scope: e.scope,
            audience: e.audience || "default"
        }), n.scope ? {
            oauthTokenScope: n.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || a.claims.org_id), Object.assign(Object.assign({}, n), {
            decodedToken: a
        });
    }
}
class ie {
}
/**
 * The initial auth state.
 */ var initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
/**
 * @ignore
 */ var stub = function() {
    throw new Error("You forgot to wrap your component in <Auth0Provider>.");
};
/**
 * @ignore
 */ var initialContext = __assign(__assign({}, initialAuthState), {
    buildAuthorizeUrl: stub,
    buildLogoutUrl: stub,
    getAccessTokenSilently: stub,
    getAccessTokenWithPopup: stub,
    getIdTokenClaims: stub,
    loginWithRedirect: stub,
    loginWithPopup: stub,
    logout: stub,
    handleRedirectCallback: stub
});
/**
 * The Auth0 Context
 */ var Auth0Context = (0, _react.createContext)(initialContext);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var OAuthError = /** @class */ function(_super) {
    __extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var CODE_RE = /[?&]code=[^&]+/;
var STATE_RE = /[?&]state=[^&]+/;
var ERROR_RE = /[?&]error=[^&]+/;
var hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) && STATE_RE.test(searchParams);
};
var normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === "object" && "error" in error && typeof error.error === "string") {
            if ("error_description" in error && typeof error.error_description === "string") return new OAuthError(error.error, error.error_description);
            return new OAuthError(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var loginError = normalizeErrorFn("Login failed");
var tokenError = normalizeErrorFn("Get access token failed");
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var deprecateRedirectUri = function(options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn("Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version");
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn("Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version");
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var reducer = function(state, action) {
    switch(action.type){
        case "LOGIN_POPUP_STARTED":
            return __assign(__assign({}, state), {
                isLoading: true
            });
        case "LOGIN_POPUP_COMPLETE":
        case "INITIALISED":
            return __assign(__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case "HANDLE_REDIRECT_COMPLETE":
        case "GET_ACCESS_TOKEN_COMPLETE":
            if (state.user === action.user) return state;
            return __assign(__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case "LOGOUT":
            return __assign(__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case "ERROR":
            return __assign(__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var toAuth0ClientOptions = function(opts) {
    deprecateRedirectUri(opts);
    return __assign(__assign({}, opts), {
        auth0Client: {
            name: "auth0-react",
            version: "2.2.4"
        }
    });
};
/**
 * @ignore
 */ var defaultOnRedirectCallback = function(appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var Auth0Provider = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? Auth0Context : _b, clientOpts = __rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, _react.useState)(function() {
        return new te(toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, _react.useReducer)(reducer, initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return __awaiter(void 0, void 0, void 0, function() {
                var user, appState, error_1;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!(hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            appState = _a.sent().appState;
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _a.sent();
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _a.sent();
                            _a.label = 6;
                        case 6:
                            dispatch({
                                type: "INITIALISED",
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _a.sent();
                            dispatch({
                                type: "ERROR",
                                error: loginError(error_1)
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback
    ]);
    var loginWithRedirect = (0, _react.useCallback)(function(opts) {
        deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, _react.useCallback)(function(options, config) {
        return __awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: "LOGIN_POPUP_STARTED"
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({
                            type: "ERROR",
                            error: loginError(error_2)
                        });
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: "LOGIN_POPUP_COMPLETE",
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var logout = (0, _react.useCallback)(function(opts) {
        if (opts === void 0) opts = {};
        return __awaiter(void 0, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: "LOGOUT"
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, _react.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, _react.useCallback)(function(opts, config) {
        return __awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getIdTokenClaims = (0, _react.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, _react.useCallback)(function(url) {
        return __awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "HANDLE_REDIRECT_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var contextValue = (0, _react.useMemo)(function() {
        return __assign(__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback
    ]);
    return (0, _reactDefault.default).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var useAuth0 = function(context) {
    if (context === void 0) context = Auth0Context;
    return (0, _react.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var withAuth0 = function(Component, context) {
    if (context === void 0) context = Auth0Context;
    return function WithAuth(props) {
        return (0, _reactDefault.default).createElement(context.Consumer, null, function(auth) {
            return (0, _reactDefault.default).createElement(Component, __assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var defaultOnRedirecting = function() {
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null);
};
/**
* @ignore
*/ var defaultOnBeforeAuthentication = function() {
    return __awaiter(void 0, void 0, void 0, function() {
        return __generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var withAuthenticationRequired = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? Auth0Context : _d;
        var _e = useAuth0(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, _react.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = __assign(__assign({}, loginOptions), {
                appState: __assign(__assign({}, loginOptions && loginOptions.appState), {
                    returnTo: typeof returnTo === "function" ? returnTo() : returnTo
                })
            });
            (function() {
                return __awaiter(_this, void 0, void 0, function() {
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, _reactDefault.default).createElement(Component, __assign({}, props)) : onRedirecting();
    };
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ek5a0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE", ()=>(0, _configureJs.DEFAULT_LOCALE));
parcelHelpers.export(exports, "SUPPORTED_LOCALES", ()=>(0, _configureJs.SUPPORTED_LOCALES));
parcelHelpers.export(exports, "Key", ()=>(0, _typesJs.Key));
parcelHelpers.export(exports, "DATA_ATTRIBUTE", ()=>(0, _sharedJs.DATA_ATTRIBUTE));
parcelHelpers.export(exports, "hexToRgb", ()=>(0, _colorTransformersJs.hexToRgb));
parcelHelpers.export(exports, "hsbToHex", ()=>(0, _colorTransformersJs.hsbToHex));
parcelHelpers.export(exports, "hsbToRgb", ()=>(0, _colorTransformersJs.hsbToRgb));
parcelHelpers.export(exports, "hslToRgb", ()=>(0, _colorTransformersJs.hslToRgb));
parcelHelpers.export(exports, "rgbString", ()=>(0, _colorTransformersJs.rgbString));
parcelHelpers.export(exports, "rgbToHex", ()=>(0, _colorTransformersJs.rgbToHex));
parcelHelpers.export(exports, "rgbToHsb", ()=>(0, _colorTransformersJs.rgbToHsb));
parcelHelpers.export(exports, "rgbToHsl", ()=>(0, _colorTransformersJs.rgbToHsl));
parcelHelpers.export(exports, "rgbaString", ()=>(0, _colorTransformersJs.rgbaString));
parcelHelpers.export(exports, "_SECRET_INTERNAL_WITHIN_CONTENT_CONTEXT", ()=>(0, _withinContentContextJs.WithinContentContext));
parcelHelpers.export(exports, "useEventListener", ()=>(0, _useEventListenerJs.useEventListener));
parcelHelpers.export(exports, "useIndexResourceState", ()=>(0, _useIndexResourceStateJs.useIndexResourceState));
parcelHelpers.export(exports, "useBreakpoints", ()=>(0, _breakpointsJs.useBreakpoints));
parcelHelpers.export(exports, "AppProvider", ()=>(0, _appProviderJs.AppProvider));
parcelHelpers.export(exports, "AccountConnection", ()=>(0, _accountConnectionJs.AccountConnection));
parcelHelpers.export(exports, "ActionList", ()=>(0, _actionListJs.ActionList));
parcelHelpers.export(exports, "ActionMenu", ()=>(0, _actionMenuJs.ActionMenu));
parcelHelpers.export(exports, "AlphaCard", ()=>(0, _alphaCardJs.AlphaCard));
parcelHelpers.export(exports, "AlphaFilters", ()=>(0, _alphaFiltersJs.AlphaFilters));
parcelHelpers.export(exports, "VerticalStack", ()=>(0, _verticalStackJs.VerticalStack));
parcelHelpers.export(exports, "AlphaTabs", ()=>(0, _alphaTabsJs.AlphaTabs));
parcelHelpers.export(exports, "Autocomplete", ()=>(0, _autocompleteJs.Autocomplete));
parcelHelpers.export(exports, "Avatar", ()=>(0, _avatarJs.Avatar));
parcelHelpers.export(exports, "Backdrop", ()=>(0, _backdropJs.Backdrop));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeJs.Badge));
parcelHelpers.export(exports, "BadgeProgressValue", ()=>(0, _typesJs1.ProgressValue));
parcelHelpers.export(exports, "BadgeStatusValue", ()=>(0, _typesJs1.StatusValue));
parcelHelpers.export(exports, "Banner", ()=>(0, _bannerJs.Banner));
parcelHelpers.export(exports, "Bleed", ()=>(0, _bleedJs.Bleed));
parcelHelpers.export(exports, "Box", ()=>(0, _boxJs.Box));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbsJs.Breadcrumbs));
parcelHelpers.export(exports, "UnstableBulkActions", ()=>(0, _bulkActionsJs.BulkActions));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonJs.Button));
parcelHelpers.export(exports, "buttonFrom", ()=>(0, _utilsJs.buttonFrom));
parcelHelpers.export(exports, "buttonsFrom", ()=>(0, _utilsJs.buttonsFrom));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupJs.ButtonGroup));
parcelHelpers.export(exports, "CalloutCard", ()=>(0, _calloutCardJs.CalloutCard));
parcelHelpers.export(exports, "Caption", ()=>(0, _captionJs.Caption));
parcelHelpers.export(exports, "Card", ()=>(0, _cardJs.Card));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxJs.Checkbox));
parcelHelpers.export(exports, "ChoiceList", ()=>(0, _choiceListJs.ChoiceList));
parcelHelpers.export(exports, "Collapsible", ()=>(0, _collapsibleJs.Collapsible));
parcelHelpers.export(exports, "ColorPicker", ()=>(0, _colorPickerJs.ColorPicker));
parcelHelpers.export(exports, "HorizontalGrid", ()=>(0, _horizontalGridJs.HorizontalGrid));
parcelHelpers.export(exports, "Combobox", ()=>(0, _comboboxJs.Combobox));
parcelHelpers.export(exports, "Connected", ()=>(0, _connectedJs.Connected));
parcelHelpers.export(exports, "ContextualSaveBar", ()=>(0, _contextualSaveBarJs.ContextualSaveBar));
parcelHelpers.export(exports, "DataTable", ()=>(0, _dataTableJs.DataTable));
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePickerJs.DatePicker));
parcelHelpers.export(exports, "DescriptionList", ()=>(0, _descriptionListJs.DescriptionList));
parcelHelpers.export(exports, "DisplayText", ()=>(0, _displayTextJs.DisplayText));
parcelHelpers.export(exports, "Divider", ()=>(0, _dividerJs.Divider));
parcelHelpers.export(exports, "DropZone", ()=>(0, _dropZoneJs.DropZone));
parcelHelpers.export(exports, "EmptySearchResult", ()=>(0, _emptySearchResultJs.EmptySearchResult));
parcelHelpers.export(exports, "EmptyState", ()=>(0, _emptyStateJs.EmptyState));
parcelHelpers.export(exports, "EventListener", ()=>(0, _eventListenerJs.EventListener));
parcelHelpers.export(exports, "ExceptionList", ()=>(0, _exceptionListJs.ExceptionList));
parcelHelpers.export(exports, "Filters", ()=>(0, _filtersJs.Filters));
parcelHelpers.export(exports, "Focus", ()=>(0, _focusJs.Focus));
parcelHelpers.export(exports, "FooterHelp", ()=>(0, _footerHelpJs.FooterHelp));
parcelHelpers.export(exports, "Form", ()=>(0, _formJs.Form));
parcelHelpers.export(exports, "FormLayout", ()=>(0, _formLayoutJs.FormLayout));
parcelHelpers.export(exports, "Frame", ()=>(0, _frameJs.Frame));
parcelHelpers.export(exports, "DEFAULT_TOAST_DURATION", ()=>(0, _toastJs.DEFAULT_TOAST_DURATION));
parcelHelpers.export(exports, "DEFAULT_TOAST_DURATION_WITH_ACTION", ()=>(0, _toastJs.DEFAULT_TOAST_DURATION_WITH_ACTION));
parcelHelpers.export(exports, "FullscreenBar", ()=>(0, _fullscreenBarJs.FullscreenBar));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridJs.Grid));
parcelHelpers.export(exports, "Heading", ()=>(0, _headingJs.Heading));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconJs.Icon));
parcelHelpers.export(exports, "Image", ()=>(0, _imageJs.Image));
parcelHelpers.export(exports, "IndexFilters", ()=>(0, _indexFiltersJs.IndexFilters));
parcelHelpers.export(exports, "useSetIndexFiltersMode", ()=>(0, _useSetIndexFiltersModeJs.useSetIndexFiltersMode));
parcelHelpers.export(exports, "IndexFiltersMode", ()=>(0, _typesJs2.IndexFiltersMode));
parcelHelpers.export(exports, "IndexTable", ()=>(0, _indexTableJs.IndexTable));
parcelHelpers.export(exports, "Indicator", ()=>(0, _indicatorJs.Indicator));
parcelHelpers.export(exports, "HorizontalStack", ()=>(0, _horizontalStackJs.HorizontalStack));
parcelHelpers.export(exports, "InlineCode", ()=>(0, _inlineCodeJs.InlineCode));
parcelHelpers.export(exports, "InlineError", ()=>(0, _inlineErrorJs.InlineError));
parcelHelpers.export(exports, "errorTextID", ()=>(0, _inlineErrorJs.errorTextID));
parcelHelpers.export(exports, "KeyboardKey", ()=>(0, _keyboardKeyJs.KeyboardKey));
parcelHelpers.export(exports, "KeypressListener", ()=>(0, _keypressListenerJs.KeypressListener));
parcelHelpers.export(exports, "KonamiCode", ()=>(0, _konamiCodeJs.KonamiCode));
parcelHelpers.export(exports, "Label", ()=>(0, _labelJs.Label));
parcelHelpers.export(exports, "labelID", ()=>(0, _labelJs.labelID));
parcelHelpers.export(exports, "Labelled", ()=>(0, _labelledJs.Labelled));
parcelHelpers.export(exports, "Layout", ()=>(0, _layoutJs.Layout));
parcelHelpers.export(exports, "LegacyCard", ()=>(0, _legacyCardJs.LegacyCard));
parcelHelpers.export(exports, "LegacyFilters", ()=>(0, _legacyFiltersJs.LegacyFilters));
parcelHelpers.export(exports, "LegacyStack", ()=>(0, _legacyStackJs.LegacyStack));
parcelHelpers.export(exports, "LegacyTabs", ()=>(0, _legacyTabsJs.LegacyTabs));
parcelHelpers.export(exports, "Link", ()=>(0, _linkJs.Link));
parcelHelpers.export(exports, "List", ()=>(0, _listJs.List));
parcelHelpers.export(exports, "AutoSelection", ()=>(0, _listboxJs.AutoSelection));
parcelHelpers.export(exports, "Listbox", ()=>(0, _listboxJs.Listbox));
parcelHelpers.export(exports, "Loading", ()=>(0, _loadingJs.Loading));
parcelHelpers.export(exports, "MediaCard", ()=>(0, _mediaCardJs.MediaCard));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalJs.Modal));
parcelHelpers.export(exports, "Navigation", ()=>(0, _navigationJs.Navigation));
parcelHelpers.export(exports, "isNavigationItemActive", ()=>(0, _itemJs.isNavigationItemActive));
parcelHelpers.export(exports, "OptionList", ()=>(0, _optionListJs.OptionList));
parcelHelpers.export(exports, "Page", ()=>(0, _pageJs.Page));
parcelHelpers.export(exports, "PageActions", ()=>(0, _pageActionsJs.PageActions));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationJs.Pagination));
parcelHelpers.export(exports, "PolarisTestProvider", ()=>(0, _polarisTestProviderJs.PolarisTestProvider));
parcelHelpers.export(exports, "Popover", ()=>(0, _popoverJs.Popover));
parcelHelpers.export(exports, "PopoverCloseSource", ()=>(0, _popoverOverlayJs.PopoverCloseSource));
parcelHelpers.export(exports, "Portal", ()=>(0, _portalJs.Portal));
parcelHelpers.export(exports, "PortalsManager", ()=>(0, _portalsManagerJs.PortalsManager));
parcelHelpers.export(exports, "PositionedOverlay", ()=>(0, _positionedOverlayJs.PositionedOverlay));
parcelHelpers.export(exports, "ProgressBar", ()=>(0, _progressBarJs.ProgressBar));
parcelHelpers.export(exports, "RadioButton", ()=>(0, _radioButtonJs.RadioButton));
parcelHelpers.export(exports, "RangeSlider", ()=>(0, _rangeSliderJs.RangeSlider));
parcelHelpers.export(exports, "ResourceItem", ()=>(0, _resourceItemJs.ResourceItem));
parcelHelpers.export(exports, "ResourceList", ()=>(0, _resourceListJs.ResourceList));
parcelHelpers.export(exports, "Scrollable", ()=>(0, _scrollableJs.Scrollable));
parcelHelpers.export(exports, "ScrollLock", ()=>(0, _scrollLockJs.ScrollLock));
parcelHelpers.export(exports, "Select", ()=>(0, _selectJs.Select));
parcelHelpers.export(exports, "SelectAllActions", ()=>(0, _selectAllActionsJs.SelectAllActions));
parcelHelpers.export(exports, "SettingToggle", ()=>(0, _settingToggleJs.SettingToggle));
parcelHelpers.export(exports, "Sheet", ()=>(0, _sheetJs.Sheet));
parcelHelpers.export(exports, "SkeletonBodyText", ()=>(0, _skeletonBodyTextJs.SkeletonBodyText));
parcelHelpers.export(exports, "SkeletonDisplayText", ()=>(0, _skeletonDisplayTextJs.SkeletonDisplayText));
parcelHelpers.export(exports, "SkeletonPage", ()=>(0, _skeletonPageJs.SkeletonPage));
parcelHelpers.export(exports, "SkeletonTabs", ()=>(0, _skeletonTabsJs.SkeletonTabs));
parcelHelpers.export(exports, "SkeletonThumbnail", ()=>(0, _skeletonThumbnailJs.SkeletonThumbnail));
parcelHelpers.export(exports, "Spinner", ()=>(0, _spinnerJs.Spinner));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackJs.Stack));
parcelHelpers.export(exports, "Sticky", ()=>(0, _stickyJs.Sticky));
parcelHelpers.export(exports, "Subheading", ()=>(0, _subheadingJs.Subheading));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsJs.Tabs));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagJs.Tag));
parcelHelpers.export(exports, "Text", ()=>(0, _textJs.Text));
parcelHelpers.export(exports, "TextContainer", ()=>(0, _textContainerJs.TextContainer));
parcelHelpers.export(exports, "TextField", ()=>(0, _textFieldJs.TextField));
parcelHelpers.export(exports, "TextStyle", ()=>(0, _textStyleJs.TextStyle));
parcelHelpers.export(exports, "Thumbnail", ()=>(0, _thumbnailJs.Thumbnail));
parcelHelpers.export(exports, "Toast", ()=>(0, _toastJs1.Toast));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipJs.Tooltip));
parcelHelpers.export(exports, "TopBar", ()=>(0, _topBarJs.TopBar));
parcelHelpers.export(exports, "TrapFocus", ()=>(0, _trapFocusJs.TrapFocus));
parcelHelpers.export(exports, "Truncate", ()=>(0, _truncateJs.Truncate));
parcelHelpers.export(exports, "UnstyledButton", ()=>(0, _unstyledButtonJs.UnstyledButton));
parcelHelpers.export(exports, "unstyledButtonFrom", ()=>(0, _utilsJs1.unstyledButtonFrom));
parcelHelpers.export(exports, "UnstyledLink", ()=>(0, _unstyledLinkJs.UnstyledLink));
parcelHelpers.export(exports, "VideoThumbnail", ()=>(0, _videoThumbnailJs.VideoThumbnail));
parcelHelpers.export(exports, "VisuallyHidden", ()=>(0, _visuallyHiddenJs.VisuallyHidden));
parcelHelpers.export(exports, "_SECRET_INTERNAL_SCROLL_LOCK_MANAGER_CONTEXT", ()=>(0, _contextJs.ScrollLockManagerContext));
parcelHelpers.export(exports, "useIndexTableContainerScroll", ()=>(0, _hooksJs.useContainerScroll));
parcelHelpers.export(exports, "useIndexTableRowHovered", ()=>(0, _hooksJs.useRowHovered));
parcelHelpers.export(exports, "useIndexTableRowSelected", ()=>(0, _hooksJs.useRowSelected));
parcelHelpers.export(exports, "INDEX_TABLE_SELECT_ALL_ITEMS", ()=>(0, _typesJs3.SELECT_ALL_ITEMS));
parcelHelpers.export(exports, "IndexTableSelectionType", ()=>(0, _typesJs3.SelectionType));
parcelHelpers.export(exports, "useEphemeralPresenceManager", ()=>(0, _hooksJs1.useReadOnlyEphemeralPresenceManager));
var _configureJs = require("./configure.js");
var _typesJs = require("./types.js");
var _sharedJs = require("./components/shared.js");
var _colorTransformersJs = require("./utilities/color-transformers.js");
var _withinContentContextJs = require("./utilities/within-content-context.js");
var _useEventListenerJs = require("./utilities/use-event-listener.js");
var _useIndexResourceStateJs = require("./utilities/use-index-resource-state.js");
var _breakpointsJs = require("./utilities/breakpoints.js");
var _appProviderJs = require("./components/AppProvider/AppProvider.js");
var _accountConnectionJs = require("./components/AccountConnection/AccountConnection.js");
var _actionListJs = require("./components/ActionList/ActionList.js");
var _actionMenuJs = require("./components/ActionMenu/ActionMenu.js");
var _alphaCardJs = require("./components/AlphaCard/AlphaCard.js");
var _alphaFiltersJs = require("./components/AlphaFilters/AlphaFilters.js");
var _verticalStackJs = require("./components/VerticalStack/VerticalStack.js");
var _alphaTabsJs = require("./components/AlphaTabs/AlphaTabs.js");
var _autocompleteJs = require("./components/Autocomplete/Autocomplete.js");
var _avatarJs = require("./components/Avatar/Avatar.js");
var _backdropJs = require("./components/Backdrop/Backdrop.js");
var _badgeJs = require("./components/Badge/Badge.js");
var _typesJs1 = require("./components/Badge/types.js");
var _bannerJs = require("./components/Banner/Banner.js");
var _bleedJs = require("./components/Bleed/Bleed.js");
var _boxJs = require("./components/Box/Box.js");
var _breadcrumbsJs = require("./components/Breadcrumbs/Breadcrumbs.js");
var _bulkActionsJs = require("./components/BulkActions/BulkActions.js");
var _buttonJs = require("./components/Button/Button.js");
var _utilsJs = require("./components/Button/utils.js");
var _buttonGroupJs = require("./components/ButtonGroup/ButtonGroup.js");
var _calloutCardJs = require("./components/CalloutCard/CalloutCard.js");
var _captionJs = require("./components/Caption/Caption.js");
var _cardJs = require("./components/Card/Card.js");
var _checkboxJs = require("./components/Checkbox/Checkbox.js");
var _choiceListJs = require("./components/ChoiceList/ChoiceList.js");
var _collapsibleJs = require("./components/Collapsible/Collapsible.js");
var _colorPickerJs = require("./components/ColorPicker/ColorPicker.js");
var _horizontalGridJs = require("./components/HorizontalGrid/HorizontalGrid.js");
var _comboboxJs = require("./components/Combobox/Combobox.js");
var _connectedJs = require("./components/Connected/Connected.js");
var _contextualSaveBarJs = require("./components/ContextualSaveBar/ContextualSaveBar.js");
var _dataTableJs = require("./components/DataTable/DataTable.js");
var _datePickerJs = require("./components/DatePicker/DatePicker.js");
var _descriptionListJs = require("./components/DescriptionList/DescriptionList.js");
var _displayTextJs = require("./components/DisplayText/DisplayText.js");
var _dividerJs = require("./components/Divider/Divider.js");
var _dropZoneJs = require("./components/DropZone/DropZone.js");
var _emptySearchResultJs = require("./components/EmptySearchResult/EmptySearchResult.js");
var _emptyStateJs = require("./components/EmptyState/EmptyState.js");
var _eventListenerJs = require("./components/EventListener/EventListener.js");
var _exceptionListJs = require("./components/ExceptionList/ExceptionList.js");
var _filtersJs = require("./components/Filters/Filters.js");
var _focusJs = require("./components/Focus/Focus.js");
var _footerHelpJs = require("./components/FooterHelp/FooterHelp.js");
var _formJs = require("./components/Form/Form.js");
var _formLayoutJs = require("./components/FormLayout/FormLayout.js");
var _frameJs = require("./components/Frame/Frame.js");
var _toastJs = require("./components/Frame/components/Toast/Toast.js");
var _fullscreenBarJs = require("./components/FullscreenBar/FullscreenBar.js");
var _gridJs = require("./components/Grid/Grid.js");
var _headingJs = require("./components/Heading/Heading.js");
var _iconJs = require("./components/Icon/Icon.js");
var _imageJs = require("./components/Image/Image.js");
var _indexFiltersJs = require("./components/IndexFilters/IndexFilters.js");
var _useSetIndexFiltersModeJs = require("./components/IndexFilters/hooks/useSetIndexFiltersMode/useSetIndexFiltersMode.js");
var _typesJs2 = require("./components/IndexFilters/types.js");
var _indexTableJs = require("./components/IndexTable/IndexTable.js");
var _indicatorJs = require("./components/Indicator/Indicator.js");
var _horizontalStackJs = require("./components/HorizontalStack/HorizontalStack.js");
var _inlineCodeJs = require("./components/InlineCode/InlineCode.js");
var _inlineErrorJs = require("./components/InlineError/InlineError.js");
var _keyboardKeyJs = require("./components/KeyboardKey/KeyboardKey.js");
var _keypressListenerJs = require("./components/KeypressListener/KeypressListener.js");
var _konamiCodeJs = require("./components/KonamiCode/KonamiCode.js");
var _labelJs = require("./components/Label/Label.js");
var _labelledJs = require("./components/Labelled/Labelled.js");
var _layoutJs = require("./components/Layout/Layout.js");
var _legacyCardJs = require("./components/LegacyCard/LegacyCard.js");
var _legacyFiltersJs = require("./components/LegacyFilters/LegacyFilters.js");
var _legacyStackJs = require("./components/LegacyStack/LegacyStack.js");
var _legacyTabsJs = require("./components/LegacyTabs/LegacyTabs.js");
var _linkJs = require("./components/Link/Link.js");
var _listJs = require("./components/List/List.js");
var _listboxJs = require("./components/Listbox/Listbox.js");
var _loadingJs = require("./components/Loading/Loading.js");
var _mediaCardJs = require("./components/MediaCard/MediaCard.js");
var _modalJs = require("./components/Modal/Modal.js");
var _navigationJs = require("./components/Navigation/Navigation.js");
var _itemJs = require("./components/Navigation/components/Item/Item.js");
var _optionListJs = require("./components/OptionList/OptionList.js");
var _pageJs = require("./components/Page/Page.js");
var _pageActionsJs = require("./components/PageActions/PageActions.js");
var _paginationJs = require("./components/Pagination/Pagination.js");
var _polarisTestProviderJs = require("./components/PolarisTestProvider/PolarisTestProvider.js");
var _popoverJs = require("./components/Popover/Popover.js");
var _popoverOverlayJs = require("./components/Popover/components/PopoverOverlay/PopoverOverlay.js");
var _portalJs = require("./components/Portal/Portal.js");
var _portalsManagerJs = require("./components/PortalsManager/PortalsManager.js");
var _positionedOverlayJs = require("./components/PositionedOverlay/PositionedOverlay.js");
var _progressBarJs = require("./components/ProgressBar/ProgressBar.js");
var _radioButtonJs = require("./components/RadioButton/RadioButton.js");
var _rangeSliderJs = require("./components/RangeSlider/RangeSlider.js");
var _resourceItemJs = require("./components/ResourceItem/ResourceItem.js");
var _resourceListJs = require("./components/ResourceList/ResourceList.js");
var _scrollableJs = require("./components/Scrollable/Scrollable.js");
var _scrollLockJs = require("./components/ScrollLock/ScrollLock.js");
var _selectJs = require("./components/Select/Select.js");
var _selectAllActionsJs = require("./components/SelectAllActions/SelectAllActions.js");
var _settingToggleJs = require("./components/SettingToggle/SettingToggle.js");
var _sheetJs = require("./components/Sheet/Sheet.js");
var _skeletonBodyTextJs = require("./components/SkeletonBodyText/SkeletonBodyText.js");
var _skeletonDisplayTextJs = require("./components/SkeletonDisplayText/SkeletonDisplayText.js");
var _skeletonPageJs = require("./components/SkeletonPage/SkeletonPage.js");
var _skeletonTabsJs = require("./components/SkeletonTabs/SkeletonTabs.js");
var _skeletonThumbnailJs = require("./components/SkeletonThumbnail/SkeletonThumbnail.js");
var _spinnerJs = require("./components/Spinner/Spinner.js");
var _stackJs = require("./components/Stack/Stack.js");
var _stickyJs = require("./components/Sticky/Sticky.js");
var _subheadingJs = require("./components/Subheading/Subheading.js");
var _tabsJs = require("./components/Tabs/Tabs.js");
var _tagJs = require("./components/Tag/Tag.js");
var _textJs = require("./components/Text/Text.js");
var _textContainerJs = require("./components/TextContainer/TextContainer.js");
var _textFieldJs = require("./components/TextField/TextField.js");
var _textStyleJs = require("./components/TextStyle/TextStyle.js");
var _thumbnailJs = require("./components/Thumbnail/Thumbnail.js");
var _toastJs1 = require("./components/Toast/Toast.js");
var _tooltipJs = require("./components/Tooltip/Tooltip.js");
var _topBarJs = require("./components/TopBar/TopBar.js");
var _trapFocusJs = require("./components/TrapFocus/TrapFocus.js");
var _truncateJs = require("./components/Truncate/Truncate.js");
var _unstyledButtonJs = require("./components/UnstyledButton/UnstyledButton.js");
var _utilsJs1 = require("./components/UnstyledButton/utils.js");
var _unstyledLinkJs = require("./components/UnstyledLink/UnstyledLink.js");
var _videoThumbnailJs = require("./components/VideoThumbnail/VideoThumbnail.js");
var _visuallyHiddenJs = require("./components/VisuallyHidden/VisuallyHidden.js");
var _contextJs = require("./utilities/scroll-lock-manager/context.js");
var _hooksJs = require("./utilities/index-table/hooks.js");
var _typesJs3 = require("./utilities/index-provider/types.js");
var _hooksJs1 = require("./utilities/ephemeral-presence-manager/hooks.js");

},{"./configure.js":"7QPjK","./types.js":false,"./components/shared.js":false,"./utilities/color-transformers.js":false,"./utilities/within-content-context.js":false,"./utilities/use-event-listener.js":false,"./utilities/use-index-resource-state.js":false,"./utilities/breakpoints.js":false,"./components/AppProvider/AppProvider.js":"frb7s","./components/AccountConnection/AccountConnection.js":false,"./components/ActionList/ActionList.js":"kU0n2","./components/ActionMenu/ActionMenu.js":false,"./components/AlphaCard/AlphaCard.js":false,"./components/AlphaFilters/AlphaFilters.js":false,"./components/VerticalStack/VerticalStack.js":"5lUFs","./components/AlphaTabs/AlphaTabs.js":false,"./components/Autocomplete/Autocomplete.js":"5oUbF","./components/Avatar/Avatar.js":"foVF7","./components/Backdrop/Backdrop.js":false,"./components/Badge/Badge.js":"8ckUl","./components/Badge/types.js":false,"./components/Banner/Banner.js":"kY0jw","./components/Bleed/Bleed.js":"3Epca","./components/Box/Box.js":"lbjkG","./components/Breadcrumbs/Breadcrumbs.js":false,"./components/BulkActions/BulkActions.js":false,"./components/Button/Button.js":"6Szv4","./components/Button/utils.js":false,"./components/ButtonGroup/ButtonGroup.js":"QiqnY","./components/CalloutCard/CalloutCard.js":false,"./components/Caption/Caption.js":false,"./components/Card/Card.js":"iJwHi","./components/Checkbox/Checkbox.js":"1FKW4","./components/ChoiceList/ChoiceList.js":"jZjIN","./components/Collapsible/Collapsible.js":"6rL9J","./components/ColorPicker/ColorPicker.js":false,"./components/HorizontalGrid/HorizontalGrid.js":false,"./components/Combobox/Combobox.js":"g7Upk","./components/Connected/Connected.js":false,"./components/ContextualSaveBar/ContextualSaveBar.js":false,"./components/DataTable/DataTable.js":"iSEKt","./components/DatePicker/DatePicker.js":false,"./components/DescriptionList/DescriptionList.js":false,"./components/DisplayText/DisplayText.js":false,"./components/Divider/Divider.js":"hHEpE","./components/DropZone/DropZone.js":"im56V","./components/EmptySearchResult/EmptySearchResult.js":"5KiAk","./components/EmptyState/EmptyState.js":"hUfJM","./components/EventListener/EventListener.js":false,"./components/ExceptionList/ExceptionList.js":false,"./components/Filters/Filters.js":"bpXQf","./components/Focus/Focus.js":false,"./components/FooterHelp/FooterHelp.js":false,"./components/Form/Form.js":"9cuP6","./components/FormLayout/FormLayout.js":"gfbei","./components/Frame/Frame.js":"gkl0a","./components/Frame/components/Toast/Toast.js":false,"./components/FullscreenBar/FullscreenBar.js":false,"./components/Grid/Grid.js":"nsfg9","./components/Heading/Heading.js":false,"./components/Icon/Icon.js":"6HPny","./components/Image/Image.js":"5iL1c","./components/IndexFilters/IndexFilters.js":false,"./components/IndexFilters/hooks/useSetIndexFiltersMode/useSetIndexFiltersMode.js":false,"./components/IndexFilters/types.js":false,"./components/IndexTable/IndexTable.js":false,"./components/Indicator/Indicator.js":false,"./components/HorizontalStack/HorizontalStack.js":"fotqA","./components/InlineCode/InlineCode.js":false,"./components/InlineError/InlineError.js":"50FAH","./components/KeyboardKey/KeyboardKey.js":false,"./components/KeypressListener/KeypressListener.js":false,"./components/KonamiCode/KonamiCode.js":false,"./components/Label/Label.js":"3Lqh1","./components/Labelled/Labelled.js":false,"./components/Layout/Layout.js":"1zYQX","./components/LegacyCard/LegacyCard.js":false,"./components/LegacyFilters/LegacyFilters.js":false,"./components/LegacyStack/LegacyStack.js":false,"./components/LegacyTabs/LegacyTabs.js":false,"./components/Link/Link.js":"1G7gV","./components/List/List.js":"8HAOc","./components/Listbox/Listbox.js":"1WNFN","./components/Loading/Loading.js":"kUUpl","./components/MediaCard/MediaCard.js":false,"./components/Modal/Modal.js":"bzxRZ","./components/Navigation/Navigation.js":"lXsCP","./components/Navigation/components/Item/Item.js":false,"./components/OptionList/OptionList.js":"c7mhZ","./components/Page/Page.js":"liTk6","./components/PageActions/PageActions.js":false,"./components/Pagination/Pagination.js":"2TJ4a","./components/PolarisTestProvider/PolarisTestProvider.js":false,"./components/Popover/Popover.js":"cE1F7","./components/Popover/components/PopoverOverlay/PopoverOverlay.js":false,"./components/Portal/Portal.js":false,"./components/PortalsManager/PortalsManager.js":false,"./components/PositionedOverlay/PositionedOverlay.js":false,"./components/ProgressBar/ProgressBar.js":"5UjAK","./components/RadioButton/RadioButton.js":"kQXJ7","./components/RangeSlider/RangeSlider.js":false,"./components/ResourceItem/ResourceItem.js":"1PRfM","./components/ResourceList/ResourceList.js":"jDAwW","./components/Scrollable/Scrollable.js":"587xt","./components/ScrollLock/ScrollLock.js":false,"./components/Select/Select.js":"hd4LW","./components/SelectAllActions/SelectAllActions.js":false,"./components/SettingToggle/SettingToggle.js":false,"./components/Sheet/Sheet.js":false,"./components/SkeletonBodyText/SkeletonBodyText.js":"gk4cr","./components/SkeletonDisplayText/SkeletonDisplayText.js":"2tci5","./components/SkeletonPage/SkeletonPage.js":"lJoR3","./components/SkeletonTabs/SkeletonTabs.js":false,"./components/SkeletonThumbnail/SkeletonThumbnail.js":false,"./components/Spinner/Spinner.js":"43SMY","./components/Stack/Stack.js":"jShHf","./components/Sticky/Sticky.js":false,"./components/Subheading/Subheading.js":false,"./components/Tabs/Tabs.js":false,"./components/Tag/Tag.js":"3F2gH","./components/Text/Text.js":"l8Av9","./components/TextContainer/TextContainer.js":false,"./components/TextField/TextField.js":"5K1ky","./components/TextStyle/TextStyle.js":false,"./components/Thumbnail/Thumbnail.js":"7733U","./components/Toast/Toast.js":"dMuTw","./components/Tooltip/Tooltip.js":"k7vL7","./components/TopBar/TopBar.js":"iNaTF","./components/TrapFocus/TrapFocus.js":false,"./components/Truncate/Truncate.js":"2lEop","./components/UnstyledButton/UnstyledButton.js":false,"./components/UnstyledButton/utils.js":false,"./components/UnstyledLink/UnstyledLink.js":false,"./components/VideoThumbnail/VideoThumbnail.js":false,"./components/VisuallyHidden/VisuallyHidden.js":false,"./utilities/scroll-lock-manager/context.js":false,"./utilities/index-table/hooks.js":false,"./utilities/index-provider/types.js":false,"./utilities/ephemeral-presence-manager/hooks.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7QPjK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE", ()=>DEFAULT_LOCALE);
parcelHelpers.export(exports, "SUPPORTED_LOCALES", ()=>SUPPORTED_LOCALES);
if (typeof window !== "undefined") {
    window.Polaris = window.Polaris || {};
    window.Polaris.VERSION = "10.50.1";
}
const DEFAULT_LOCALE = "en";
const SUPPORTED_LOCALES = [
    "cs",
    "da",
    "de",
    "en",
    "es",
    "fi",
    "fr",
    "it",
    "ja",
    "ko",
    "nb",
    "nl",
    "pl",
    "pt-BR",
    "pt-PT",
    "sv",
    "th",
    "tr",
    "vi",
    "zh-CN",
    "zh-TW"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6NE7w":[function(require,module,exports) {
/* eslint-disable @shopify/strict-component-boundaries */ /* eslint-enable @shopify/strict-component-boundaries */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Key", ()=>Key);
let Key;
(function(Key) {
    Key[Key["Backspace"] = 8] = "Backspace";
    Key[Key["Tab"] = 9] = "Tab";
    Key[Key["Enter"] = 13] = "Enter";
    Key[Key["Shift"] = 16] = "Shift";
    Key[Key["Ctrl"] = 17] = "Ctrl";
    Key[Key["Alt"] = 18] = "Alt";
    Key[Key["Pause"] = 19] = "Pause";
    Key[Key["CapsLock"] = 20] = "CapsLock";
    Key[Key["Escape"] = 27] = "Escape";
    Key[Key["Space"] = 32] = "Space";
    Key[Key["PageUp"] = 33] = "PageUp";
    Key[Key["PageDown"] = 34] = "PageDown";
    Key[Key["End"] = 35] = "End";
    Key[Key["Home"] = 36] = "Home";
    Key[Key["LeftArrow"] = 37] = "LeftArrow";
    Key[Key["UpArrow"] = 38] = "UpArrow";
    Key[Key["RightArrow"] = 39] = "RightArrow";
    Key[Key["DownArrow"] = 40] = "DownArrow";
    Key[Key["Insert"] = 45] = "Insert";
    Key[Key["Delete"] = 46] = "Delete";
    Key[Key["Key0"] = 48] = "Key0";
    Key[Key["Key1"] = 49] = "Key1";
    Key[Key["Key2"] = 50] = "Key2";
    Key[Key["Key3"] = 51] = "Key3";
    Key[Key["Key4"] = 52] = "Key4";
    Key[Key["Key5"] = 53] = "Key5";
    Key[Key["Key6"] = 54] = "Key6";
    Key[Key["Key7"] = 55] = "Key7";
    Key[Key["Key8"] = 56] = "Key8";
    Key[Key["Key9"] = 57] = "Key9";
    Key[Key["KeyA"] = 65] = "KeyA";
    Key[Key["KeyB"] = 66] = "KeyB";
    Key[Key["KeyC"] = 67] = "KeyC";
    Key[Key["KeyD"] = 68] = "KeyD";
    Key[Key["KeyE"] = 69] = "KeyE";
    Key[Key["KeyF"] = 70] = "KeyF";
    Key[Key["KeyG"] = 71] = "KeyG";
    Key[Key["KeyH"] = 72] = "KeyH";
    Key[Key["KeyI"] = 73] = "KeyI";
    Key[Key["KeyJ"] = 74] = "KeyJ";
    Key[Key["KeyK"] = 75] = "KeyK";
    Key[Key["KeyL"] = 76] = "KeyL";
    Key[Key["KeyM"] = 77] = "KeyM";
    Key[Key["KeyN"] = 78] = "KeyN";
    Key[Key["KeyO"] = 79] = "KeyO";
    Key[Key["KeyP"] = 80] = "KeyP";
    Key[Key["KeyQ"] = 81] = "KeyQ";
    Key[Key["KeyR"] = 82] = "KeyR";
    Key[Key["KeyS"] = 83] = "KeyS";
    Key[Key["KeyT"] = 84] = "KeyT";
    Key[Key["KeyU"] = 85] = "KeyU";
    Key[Key["KeyV"] = 86] = "KeyV";
    Key[Key["KeyW"] = 87] = "KeyW";
    Key[Key["KeyX"] = 88] = "KeyX";
    Key[Key["KeyY"] = 89] = "KeyY";
    Key[Key["KeyZ"] = 90] = "KeyZ";
    Key[Key["LeftMeta"] = 91] = "LeftMeta";
    Key[Key["RightMeta"] = 92] = "RightMeta";
    Key[Key["Select"] = 93] = "Select";
    Key[Key["Numpad0"] = 96] = "Numpad0";
    Key[Key["Numpad1"] = 97] = "Numpad1";
    Key[Key["Numpad2"] = 98] = "Numpad2";
    Key[Key["Numpad3"] = 99] = "Numpad3";
    Key[Key["Numpad4"] = 100] = "Numpad4";
    Key[Key["Numpad5"] = 101] = "Numpad5";
    Key[Key["Numpad6"] = 102] = "Numpad6";
    Key[Key["Numpad7"] = 103] = "Numpad7";
    Key[Key["Numpad8"] = 104] = "Numpad8";
    Key[Key["Numpad9"] = 105] = "Numpad9";
    Key[Key["Multiply"] = 106] = "Multiply";
    Key[Key["Add"] = 107] = "Add";
    Key[Key["Subtract"] = 109] = "Subtract";
    Key[Key["Decimal"] = 110] = "Decimal";
    Key[Key["Divide"] = 111] = "Divide";
    Key[Key["F1"] = 112] = "F1";
    Key[Key["F2"] = 113] = "F2";
    Key[Key["F3"] = 114] = "F3";
    Key[Key["F4"] = 115] = "F4";
    Key[Key["F5"] = 116] = "F5";
    Key[Key["F6"] = 117] = "F6";
    Key[Key["F7"] = 118] = "F7";
    Key[Key["F8"] = 119] = "F8";
    Key[Key["F9"] = 120] = "F9";
    Key[Key["F10"] = 121] = "F10";
    Key[Key["F11"] = 122] = "F11";
    Key[Key["F12"] = 123] = "F12";
    Key[Key["NumLock"] = 144] = "NumLock";
    Key[Key["ScrollLock"] = 145] = "ScrollLock";
    Key[Key["Semicolon"] = 186] = "Semicolon";
    Key[Key["Equals"] = 187] = "Equals";
    Key[Key["Comma"] = 188] = "Comma";
    Key[Key["Dash"] = 189] = "Dash";
    Key[Key["Period"] = 190] = "Period";
    Key[Key["ForwardSlash"] = 191] = "ForwardSlash";
    Key[Key["GraveAccent"] = 192] = "GraveAccent";
    Key[Key["OpenBracket"] = 219] = "OpenBracket";
    Key[Key["BackSlash"] = 220] = "BackSlash";
    Key[Key["CloseBracket"] = 221] = "CloseBracket";
    Key[Key["SingleQuote"] = 222] = "SingleQuote";
})(Key || (Key = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lFbIK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATA_ATTRIBUTE", ()=>DATA_ATTRIBUTE);
parcelHelpers.export(exports, "dataPolarisTopBar", ()=>dataPolarisTopBar);
parcelHelpers.export(exports, "headerCell", ()=>headerCell);
parcelHelpers.export(exports, "layer", ()=>layer);
parcelHelpers.export(exports, "overlay", ()=>overlay);
parcelHelpers.export(exports, "portal", ()=>portal);
parcelHelpers.export(exports, "scrollable", ()=>scrollable);
parcelHelpers.export(exports, "unstyled", ()=>unstyled);
const scrollable = {
    props: {
        "data-polaris-scrollable": true
    },
    selector: "[data-polaris-scrollable]"
};
const overlay = {
    props: {
        "data-polaris-overlay": true
    },
    selector: "[data-polaris-overlay]"
};
const layer = {
    props: {
        "data-polaris-layer": true
    },
    selector: "[data-polaris-layer]"
};
const unstyled = {
    props: {
        "data-polaris-unstyled": true
    },
    selector: "[data-polaris-unstyled]"
};
const dataPolarisTopBar = {
    props: {
        "data-polaris-top-bar": true
    },
    selector: "[data-polaris-top-bar]"
};
const headerCell = {
    props: {
        "data-polaris-header-cell": true
    },
    selector: "[data-polaris-header-cell]"
};
const portal = {
    props: [
        "data-portal-id"
    ],
    selector: "[data-portal-id]"
};
const DATA_ATTRIBUTE = {
    overlay,
    layer
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cUmFU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithinContentContext", ()=>WithinContentContext);
var _react = require("react");
const WithinContentContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1MHbT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEventListener", ()=>useEventListener);
var _react = require("react");
var _useIsomorphicLayoutEffectJs = require("./use-isomorphic-layout-effect.js");
/**
 * Acceptable target elements for `useEventListener`.
 */ /**
 * React hook encapsulating the boilerplate logic for adding and removing event listeners.
 */ function useEventListener(eventName, handler, target, options) {
    const handlerRef = (0, _react.useRef)(handler);
    const optionsRef = (0, _react.useRef)(options);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        handlerRef.current = handler;
    }, [
        handler
    ]);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, _react.useEffect)(()=>{
        if (!(typeof eventName === "string" && target !== null)) return;
        let targetElement;
        if (typeof target === "undefined") targetElement = window;
        else if ("current" in target) {
            if (target.current === null) return;
            targetElement = target.current;
        } else targetElement = target;
        const eventOptions = optionsRef.current;
        const eventListener = (event)=>handlerRef.current(event);
        targetElement.addEventListener(eventName, eventListener, eventOptions);
        return ()=>{
            targetElement.removeEventListener(eventName, eventListener, eventOptions);
        };
    }, [
        eventName,
        target
    ]);
}

},{"react":"cOWTg","./use-isomorphic-layout-effect.js":"2th17","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2th17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var _targetJs = require("./target.js");
// eslint-disable-next-line no-restricted-imports
const useIsomorphicLayoutEffect = (0, _targetJs.isServer) ? (0, _react.useEffect) : (0, _react.useLayoutEffect);

},{"react":"cOWTg","./target.js":"8v8ju","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8v8ju":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServer", ()=>isServer);
const isServer = typeof window === "undefined" || typeof document === "undefined";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"icMVM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBreakpointsQueryEntries", ()=>getBreakpointsQueryEntries);
parcelHelpers.export(exports, "navigationBarCollapsed", ()=>navigationBarCollapsed);
parcelHelpers.export(exports, "stackedContent", ()=>stackedContent);
parcelHelpers.export(exports, "useBreakpoints", ()=>useBreakpoints);
var _react = require("react");
var _polarisTokens = require("@shopify/polaris-tokens");
var _targetJs = require("./target.js");
var _useIsomorphicLayoutEffectJs = require("./use-isomorphic-layout-effect.js");
const Breakpoints = {
    // TODO: Update to smDown
    navigationBarCollapsed: "767.95px",
    // TODO: Update to lgDown
    stackedContent: "1039.95px"
};
const noWindowMatches = {
    media: "",
    addListener: noop,
    removeListener: noop,
    matches: false,
    onchange: noop,
    addEventListener: noop,
    removeEventListener: noop,
    dispatchEvent: (_)=>true
};
function noop() {}
function navigationBarCollapsed() {
    return typeof window === "undefined" ? noWindowMatches : window.matchMedia(`(max-width: ${Breakpoints.navigationBarCollapsed})`);
}
function stackedContent() {
    return typeof window === "undefined" ? noWindowMatches : window.matchMedia(`(max-width: ${Breakpoints.stackedContent})`);
}
/**
 * Directional alias for each Polaris `breakpoints` token.
 *
 * @example 'smUp' | 'smDown' | 'smOnly' | 'mdUp' | etc.
 */ const breakpointsQueryEntries = getBreakpointsQueryEntries((0, _polarisTokens.breakpoints));
function getMatches(defaults) {
    if (!(0, _targetJs.isServer)) return Object.fromEntries(breakpointsQueryEntries.map(([directionAlias, query])=>[
            directionAlias,
            window.matchMedia(query).matches
        ]));
    if (typeof defaults === "object" && defaults !== null) return Object.fromEntries(breakpointsQueryEntries.map(([directionAlias])=>{
        var _defaults$directionAl;
        return [
            directionAlias,
            (_defaults$directionAl = defaults[directionAlias]) !== null && _defaults$directionAl !== void 0 ? _defaults$directionAl : false
        ];
    }));
    return Object.fromEntries(breakpointsQueryEntries.map(([directionAlias])=>[
            directionAlias,
            defaults !== null && defaults !== void 0 ? defaults : false
        ]));
}
/**
 * Retrieves media query matches for each directional Polaris `breakpoints` alias.
 *
 * @example
 * const {smUp} = useBreakpoints();
 * return smUp && 'Hello world';
 *
 * @example
 * const {mdUp} = useBreakpoints({defaults: {mdUp: true}});
 * mdUp //=> `true` during SSR
 *
 * @example
 * const breakpoints = useBreakpoints({defaults: true});
 * breakpoints //=> All values will be `true` during SSR
 */ function useBreakpoints(options) {
    const [breakpoints, setBreakpoints] = (0, _react.useState)(getMatches(options === null || options === void 0 ? void 0 : options.defaults));
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        const mediaQueryLists = breakpointsQueryEntries.map(([_, query])=>window.matchMedia(query));
        const handler = ()=>setBreakpoints(getMatches());
        mediaQueryLists.forEach((mql)=>{
            if (mql.addListener) mql.addListener(handler);
            else mql.addEventListener("change", handler);
        });
        return ()=>{
            mediaQueryLists.forEach((mql)=>{
                if (mql.removeListener) mql.removeListener(handler);
                else mql.removeEventListener("change", handler);
            });
        };
    }, []);
    return breakpoints;
}
/**
 * Converts `breakpoints` tokens into directional media query entries.
 *
 * @example
 * const breakpointsQueryEntries = getBreakpointsQueryEntries(breakpoints);
 * breakpointsQueryEntries === [
 *   ['xsUp', '(min-width: ...)'],
 *   ['xsDown', '(max-width: ...)'],
 *   ['xsOnly', '(min-width: ...) and (max-width: ...)'],
 *   ['smUp', '(min-width: ...) and (max-width: ...)'],
 *   ['mdUp', '(min-width: ...) and (max-width: ...)'],
 *   // etc.
 * ]
 */ function getBreakpointsQueryEntries(breakpoints) {
    const mediaConditionEntries = Object.entries((0, _polarisTokens.getMediaConditions)(breakpoints));
    return mediaConditionEntries.map(([breakpointsToken, mediaConditions])=>Object.entries(mediaConditions).map(([direction, mediaCondition])=>{
            const breakpointsAlias = breakpointsToken.split("-")[1]; // e.g. smUp, smDown, smOnly, etc.
            const directionAlias = `${breakpointsAlias}${capitalize(direction)}`;
            return [
                directionAlias,
                mediaCondition
            ];
        })).flat();
}
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

},{"react":"cOWTg","@shopify/polaris-tokens":"5ENVX","./target.js":"8v8ju","./use-isomorphic-layout-effect.js":"2th17","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5ENVX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMetadata", ()=>(0, _metadataMjs.createMetadata));
parcelHelpers.export(exports, "metadata", ()=>(0, _metadataMjs.metadata));
parcelHelpers.export(exports, "createVar", ()=>(0, _utilitiesMjs.createVar));
parcelHelpers.export(exports, "getCustomPropertyNames", ()=>(0, _utilitiesMjs.getCustomPropertyNames));
parcelHelpers.export(exports, "getKeyframeNames", ()=>(0, _utilitiesMjs.getKeyframeNames));
parcelHelpers.export(exports, "getMediaConditions", ()=>(0, _utilitiesMjs.getMediaConditions));
parcelHelpers.export(exports, "getUnit", ()=>(0, _utilitiesMjs.getUnit));
parcelHelpers.export(exports, "isKeyOf", ()=>(0, _utilitiesMjs.isKeyOf));
parcelHelpers.export(exports, "rem", ()=>(0, _utilitiesMjs.rem));
parcelHelpers.export(exports, "removeMetadata", ()=>(0, _utilitiesMjs.removeMetadata));
parcelHelpers.export(exports, "toEm", ()=>(0, _utilitiesMjs.toEm));
parcelHelpers.export(exports, "toPx", ()=>(0, _utilitiesMjs.toPx));
parcelHelpers.export(exports, "toRem", ()=>(0, _utilitiesMjs.toRem));
parcelHelpers.export(exports, "tokensToRems", ()=>(0, _utilitiesMjs.tokensToRems));
parcelHelpers.export(exports, "border", ()=>border);
parcelHelpers.export(exports, "breakpoints", ()=>breakpoints);
parcelHelpers.export(exports, "color", ()=>color);
parcelHelpers.export(exports, "colors", ()=>colors);
parcelHelpers.export(exports, "depth", ()=>depth);
parcelHelpers.export(exports, "font", ()=>font);
parcelHelpers.export(exports, "legacy", ()=>legacy);
parcelHelpers.export(exports, "motion", ()=>motion);
parcelHelpers.export(exports, "shadow", ()=>shadow);
parcelHelpers.export(exports, "shape", ()=>shape);
parcelHelpers.export(exports, "space", ()=>space);
parcelHelpers.export(exports, "spacing", ()=>spacing);
parcelHelpers.export(exports, "tokens", ()=>tokens);
parcelHelpers.export(exports, "zIndex", ()=>zIndex);
var _metadataMjs = require("../src/metadata.mjs");
var _utilitiesMjs = require("../src/utilities.mjs");
var breakpoints = {
    "breakpoints-xs": "0rem",
    "breakpoints-sm": "30.625rem",
    "breakpoints-md": "48rem",
    "breakpoints-lg": "65rem",
    "breakpoints-xl": "90rem"
};
var border = {
    "border-radius-05": "0.125rem",
    "border-radius-1": "0.25rem",
    "border-radius-2": "0.5rem",
    "border-radius-3": "0.75rem",
    "border-radius-4": "1rem",
    "border-radius-5": "1.25rem",
    "border-radius-6": "1.875rem",
    "border-radius-full": "624.9375rem",
    "border-width-1": "0.0625rem",
    "border-width-2": "0.125rem",
    "border-width-3": "0.1875rem",
    "border-width-4": "0.25rem",
    "border-width-5": "0.3125rem"
};
var color = {
    "color-bg-inverse": "rgba(31, 33, 36, 1)",
    "color-bg-inset-strong": "rgba(97, 106, 117, 1)",
    "color-bg-inverse-hover": "rgba(97, 106, 117, 1)",
    "color-bg-inverse-active": "rgba(135, 144, 155, 1)",
    "color-bg-strong-hover": "rgba(202, 206, 211, 1)",
    "color-bg-strong-active": "rgba(202, 206, 211, 1)",
    "color-bg-strong": "rgba(221, 224, 228, 1)",
    "color-bg-subdued-active": "rgba(235, 236, 239, 1)",
    "color-bg-disabled": "rgba(235, 236, 239, 1)",
    "color-bg-interactive-disabled": "rgba(235, 236, 239, 1)",
    "color-bg-app": "rgba(241, 242, 244, 1)",
    "color-bg-app-active": "rgba(221, 224, 228, 1)",
    "color-bg-app-hover": "rgba(235, 236, 239, 1)",
    "color-bg-app-selected": "rgba(235, 236, 239, 1)",
    "color-bg-active": "rgba(235, 236, 239, 1)",
    "color-bg-subdued-hover": "rgba(241, 242, 244, 1)",
    "color-bg-inset": "rgba(241, 242, 244, 1)",
    "color-bg-hover": "rgba(241, 242, 244, 1)",
    "color-bg-subdued": "rgba(249, 250, 251, 1)",
    "color-bg-input": "rgba(255, 255, 255, 1)",
    "color-bg": "rgba(255, 255, 255, 1)",
    "color-bg-primary-active": "rgba(12, 59, 47, 1)",
    "color-bg-primary-hover": "rgba(18, 84, 67, 1)",
    "color-bg-primary": "rgba(0, 122, 92, 1)",
    "color-bg-success-strong": "rgba(22, 166, 121, 1)",
    "color-bg-success": "rgba(161, 237, 208, 1)",
    "color-bg-primary-subdued-active": "rgba(192, 242, 221, 1)",
    "color-bg-success-subdued-active": "rgba(192, 242, 221, 1)",
    "color-bg-success-subdued": "rgba(224, 248, 238, 1)",
    "color-bg-primary-subdued-hover": "rgba(224, 248, 238, 1)",
    "color-bg-success-subdued-hover": "rgba(240, 253, 248, 1)",
    "color-bg-primary-subdued": "rgba(240, 253, 248, 1)",
    "color-bg-primary-subdued-selected": "rgba(240, 253, 248, 1)",
    "color-bg-critical-strong-active": "rgba(115, 24, 7, 1)",
    "color-bg-critical-strong-hover": "rgba(159, 32, 10, 1)",
    "color-bg-critical-strong": "rgba(197, 40, 12, 1)",
    "color-bg-critical-subdued-active": "rgba(251, 197, 188, 1)",
    "color-bg-critical": "rgba(251, 197, 188, 1)",
    "color-bg-critical-subdued": "rgba(253, 226, 221, 1)",
    "color-bg-critical-subdued-hover": "rgba(254, 243, 241, 1)",
    "color-bg-caution-strong": "rgba(216, 155, 13, 1)",
    "color-bg-caution": "rgba(248, 217, 144, 1)",
    "color-bg-caution-subdued-active": "rgba(250, 229, 178, 1)",
    "color-bg-caution-subdued": "rgba(252, 240, 212, 1)",
    "color-bg-caution-subdued-hover": "rgba(254, 248, 236, 1)",
    "color-bg-info-strong": "rgba(42, 172, 187, 1)",
    "color-bg-info-subdued-active": "rgba(184, 233, 239, 1)",
    "color-bg-info": "rgba(184, 233, 239, 1)",
    "color-bg-info-subdued": "rgba(222, 245, 247, 1)",
    "color-bg-info-subdued-hover": "rgba(238, 250, 251, 1)",
    "color-bg-interactive-active": "rgba(14, 53, 108, 1)",
    "color-bg-interactive-hover": "rgba(20, 73, 149, 1)",
    "color-bg-interactive": "rgba(36, 99, 188, 1)",
    "color-bg-interactive-subdued-active": "rgba(187, 212, 247, 1)",
    "color-bg-interactive-subdued-hover": "rgba(232, 240, 253, 1)",
    "color-bg-interactive-subdued": "rgba(240, 245, 253, 1)",
    "color-bg-interactive-selected": "rgba(240, 245, 253, 1)",
    "color-bg-warning": "rgba(250, 201, 168, 1)",
    "color-bg-magic-strong": "rgba(121, 69, 227, 1)",
    "color-bg-magic-hover": "rgba(226, 214, 250, 1)",
    "color-bg-magic-active": "rgba(203, 180, 248, 1)",
    "color-bg-magic": "rgba(236, 227, 253, 1)",
    "color-bg-magic-subdued-hover": "rgba(236, 227, 253, 1)",
    "color-bg-magic-subdued-active": "rgba(226, 214, 250, 1)",
    "color-bg-magic-subdued": "rgba(242, 237, 253, 1)",
    "color-border-input-hover": "rgba(97, 106, 117, 1)",
    "color-border-inverse": "rgba(97, 106, 117, 1)",
    "color-border-strong-hover": "rgba(135, 144, 155, 1)",
    "color-border-input": "rgba(171, 177, 186, 1)",
    "color-border-hover": "rgba(171, 177, 186, 1)",
    "color-border-strong": "rgba(171, 177, 186, 1)",
    "color-border": "rgba(202, 206, 211, 1)",
    "color-border-disabled": "rgba(221, 224, 228, 1)",
    "color-border-subdued": "rgba(221, 224, 228, 1)",
    "color-border-interactive-disabled": "rgba(221, 224, 228, 1)",
    "color-border-primary": "rgba(0, 122, 92, 1)",
    "color-border-success": "rgba(22, 166, 121, 1)",
    "color-border-success-subdued": "rgba(80, 220, 169, 1)",
    "color-border-critical-active": "rgba(67, 14, 4, 1)",
    "color-border-critical-hover": "rgba(115, 24, 7, 1)",
    "color-border-critical": "rgba(197, 40, 12, 1)",
    "color-border-critical-subdued": "rgba(245, 107, 82, 1)",
    "color-border-caution": "rgba(216, 155, 13, 1)",
    "color-border-caution-subdued": "rgba(245, 196, 82, 1)",
    "color-border-info": "rgba(59, 195, 211, 1)",
    "color-border-info-subdued": "rgba(109, 211, 222, 1)",
    "color-border-interactive-active": "rgba(14, 53, 108, 1)",
    "color-border-interactive-hover": "rgba(20, 73, 149, 1)",
    "color-border-interactive": "rgba(62, 125, 213, 1)",
    "color-border-interactive-focus": "rgba(62, 125, 213, 1)",
    "color-border-interactive-subdued": "rgba(187, 212, 247, 1)",
    "color-border-magic-strong": "rgba(121, 69, 227, 1)",
    "color-border-magic": "rgba(173, 139, 241, 1)",
    "color-icon-hover": "rgba(31, 33, 36, 1)",
    "color-icon": "rgba(97, 106, 117, 1)",
    "color-icon-active": "rgba(31, 33, 36, 1)",
    "color-icon-subdued": "rgba(135, 144, 155, 1)",
    "color-icon-disabled": "rgba(171, 177, 186, 1)",
    "color-icon-interactive-disabled": "rgba(171, 177, 186, 1)",
    "color-icon-inverse": "rgba(221, 224, 228, 1)",
    "color-icon-on-color": "rgba(255, 255, 255, 1)",
    "color-icon-primary": "rgba(0, 122, 92, 1)",
    "color-icon-success": "rgba(22, 166, 121, 1)",
    "color-icon-critical": "rgba(197, 40, 12, 1)",
    "color-icon-caution": "rgba(183, 126, 11, 1)",
    "color-icon-info": "rgba(42, 172, 187, 1)",
    "color-icon-warning": "rgba(242, 117, 34, 1)",
    "color-icon-interactive-active": "rgba(14, 53, 108, 1)",
    "color-icon-interactive-hover": "rgba(20, 73, 149, 1)",
    "color-icon-interactive": "rgba(36, 99, 188, 1)",
    "color-icon-interactive-inverse": "rgba(102, 153, 225, 1)",
    "color-icon-magic": "rgba(121, 69, 227, 1)",
    "color-text": "rgba(31, 33, 36, 1)",
    "color-text-subdued": "rgba(97, 106, 117, 1)",
    "color-text-disabled": "rgba(135, 144, 155, 1)",
    "color-text-interactive-disabled": "rgba(135, 144, 155, 1)",
    "color-text-inverse-subdued": "rgba(171, 177, 186, 1)",
    "color-text-inverse": "rgba(241, 242, 244, 1)",
    "color-text-on-color": "rgba(255, 255, 255, 1)",
    "color-text-success-strong": "rgba(12, 59, 47, 1)",
    "color-text-success": "rgba(0, 122, 92, 1)",
    "color-text-primary": "rgba(0, 122, 92, 1)",
    "color-text-primary-hover": "rgba(18, 84, 67, 1)",
    "color-text-critical-strong": "rgba(67, 14, 4, 1)",
    "color-text-critical-active": "rgba(115, 24, 7, 1)",
    "color-text-critical": "rgba(197, 40, 12, 1)",
    "color-text-caution-strong": "rgba(77, 46, 5, 1)",
    "color-text-caution": "rgba(135, 92, 8, 1)",
    "color-text-info-strong": "rgba(16, 65, 71, 1)",
    "color-text-info": "rgba(32, 130, 141, 1)",
    "color-text-warning-strong": "rgba(77, 36, 5, 1)",
    "color-text-interactive-active": "rgba(14, 53, 108, 1)",
    "color-text-interactive-hover": "rgba(20, 73, 149, 1)",
    "color-text-interactive": "rgba(36, 99, 188, 1)",
    "color-text-interactive-inverse": "rgba(102, 153, 225, 1)",
    "color-text-magic-strong": "rgba(49, 13, 120, 1)",
    "color-text-magic": "rgba(90, 36, 205, 1)"
};
var colors = {
    "background": "rgba(246, 246, 247, 1)",
    "background-hovered": "rgba(241, 242, 243, 1)",
    "background-pressed": "rgba(237, 238, 239, 1)",
    "background-selected": "rgba(237, 238, 239, 1)",
    "surface": "rgba(255, 255, 255, 1)",
    "surface-dark": "rgba(32, 33, 35, 1)",
    "surface-neutral": "rgba(228, 229, 231, 1)",
    "surface-neutral-hovered": "rgba(219, 221, 223, 1)",
    "surface-neutral-pressed": "rgba(201, 204, 208, 1)",
    "surface-neutral-disabled": "rgba(241, 242, 243, 1)",
    "surface-neutral-subdued": "rgba(246, 246, 247, 1)",
    "surface-neutral-subdued-dark": "rgba(68, 71, 74, 1)",
    "surface-subdued": "rgba(250, 251, 251, 1)",
    "surface-disabled": "rgba(250, 251, 251, 1)",
    "surface-hovered": "rgba(246, 246, 247, 1)",
    "surface-hovered-dark": "rgba(47, 49, 51, 1)",
    "surface-pressed": "rgba(241, 242, 243, 1)",
    "surface-pressed-dark": "rgba(62, 64, 67, 1)",
    "surface-depressed": "rgba(237, 238, 239, 1)",
    "surface-search-field": "rgba(241, 242, 243, 1)",
    "surface-search-field-dark": "rgba(47, 49, 51, 1)",
    "backdrop": "rgba(0, 0, 0, 0.5)",
    "overlay": "rgba(255, 255, 255, 0.5)",
    "shadow-color-picker": "rgba(0, 0, 0, 0.5)",
    "shadow-color-picker-dragger": "rgba(33, 43, 54, 0.32)",
    "hint-from-direct-light": "rgba(0, 0, 0, 0.15)",
    "border": "rgba(140, 145, 150, 1)",
    "border-on-dark": "rgba(80, 83, 86, 1)",
    "border-neutral-subdued": "rgba(186, 191, 195, 1)",
    "border-hovered": "rgba(153, 158, 164, 1)",
    "border-disabled": "rgba(210, 213, 216, 1)",
    "border-subdued": "rgba(201, 204, 207, 1)",
    "border-depressed": "rgba(87, 89, 89, 1)",
    "border-shadow": "rgba(174, 180, 185, 1)",
    "border-shadow-subdued": "rgba(186, 191, 196, 1)",
    "divider": "rgba(225, 227, 229, 1)",
    "divider-dark": "rgba(69, 71, 73, 1)",
    "icon": "rgba(92, 95, 98, 1)",
    "icon-on-dark": "rgba(166, 172, 178, 1)",
    "icon-hovered": "rgba(26, 28, 29, 1)",
    "icon-pressed": "rgba(68, 71, 74, 1)",
    "icon-disabled": "rgba(186, 190, 195, 1)",
    "icon-subdued": "rgba(140, 145, 150, 1)",
    "text": "rgba(32, 34, 35, 1)",
    "text-on-dark": "rgba(227, 229, 231, 1)",
    "text-disabled": "rgba(140, 145, 150, 1)",
    "text-subdued": "rgba(109, 113, 117, 1)",
    "text-subdued-on-dark": "rgba(153, 159, 164, 1)",
    "interactive": "rgba(44, 110, 203, 1)",
    "interactive-on-dark": "rgba(54, 163, 255, 1)",
    "interactive-disabled": "rgba(189, 193, 204, 1)",
    "interactive-hovered": "rgba(31, 81, 153, 1)",
    "interactive-pressed": "rgba(16, 50, 98, 1)",
    "interactive-pressed-on-dark": "rgba(136, 188, 255, 1)",
    "focused": "rgba(69, 143, 255, 1)",
    "surface-selected": "rgba(242, 247, 254, 1)",
    "surface-selected-hovered": "rgba(237, 244, 254, 1)",
    "surface-selected-pressed": "rgba(229, 239, 253, 1)",
    "icon-on-interactive": "rgba(255, 255, 255, 1)",
    "text-on-interactive": "rgba(255, 255, 255, 1)",
    "action-secondary": "rgba(255, 255, 255, 1)",
    "action-secondary-disabled": "rgba(255, 255, 255, 1)",
    "action-secondary-hovered": "rgba(246, 246, 247, 1)",
    "action-secondary-hovered-dark": "rgba(84, 87, 91, 1)",
    "action-secondary-pressed": "rgba(241, 242, 243, 1)",
    "action-secondary-pressed-dark": "rgba(96, 100, 103, 1)",
    "action-secondary-depressed": "rgba(109, 113, 117, 1)",
    "action-primary": "rgba(0, 128, 96, 1)",
    "action-primary-disabled": "rgba(241, 241, 241, 1)",
    "action-primary-hovered": "rgba(0, 110, 82, 1)",
    "action-primary-pressed": "rgba(0, 94, 70, 1)",
    "action-primary-depressed": "rgba(0, 61, 44, 1)",
    "icon-on-primary": "rgba(255, 255, 255, 1)",
    "text-on-primary": "rgba(255, 255, 255, 1)",
    "text-primary": "rgba(0, 123, 92, 1)",
    "text-primary-hovered": "rgba(0, 108, 80, 1)",
    "text-primary-pressed": "rgba(0, 92, 68, 1)",
    "surface-primary-selected": "rgba(241, 248, 245, 1)",
    "surface-primary-selected-hovered": "rgba(179, 208, 195, 1)",
    "surface-primary-selected-pressed": "rgba(162, 188, 176, 1)",
    "border-critical": "rgba(253, 87, 73, 1)",
    "border-critical-subdued": "rgba(224, 179, 178, 1)",
    "border-critical-disabled": "rgba(255, 167, 163, 1)",
    "icon-critical": "rgba(215, 44, 13, 1)",
    "surface-critical": "rgba(254, 211, 209, 1)",
    "surface-critical-subdued": "rgba(255, 244, 244, 1)",
    "surface-critical-subdued-hovered": "rgba(255, 240, 240, 1)",
    "surface-critical-subdued-pressed": "rgba(255, 233, 232, 1)",
    "surface-critical-subdued-depressed": "rgba(254, 188, 185, 1)",
    "text-critical": "rgba(215, 44, 13, 1)",
    "action-critical": "rgba(216, 44, 13, 1)",
    "action-critical-disabled": "rgba(241, 241, 241, 1)",
    "action-critical-hovered": "rgba(188, 34, 0, 1)",
    "action-critical-pressed": "rgba(162, 27, 0, 1)",
    "action-critical-depressed": "rgba(108, 15, 0, 1)",
    "icon-on-critical": "rgba(255, 255, 255, 1)",
    "text-on-critical": "rgba(255, 255, 255, 1)",
    "interactive-critical": "rgba(216, 44, 13, 1)",
    "interactive-critical-disabled": "rgba(253, 147, 141, 1)",
    "interactive-critical-hovered": "rgba(205, 41, 12, 1)",
    "interactive-critical-pressed": "rgba(103, 15, 3, 1)",
    "border-warning": "rgba(185, 137, 0, 1)",
    "border-warning-subdued": "rgba(225, 184, 120, 1)",
    "icon-warning": "rgba(185, 137, 0, 1)",
    "surface-warning": "rgba(255, 215, 157, 1)",
    "surface-warning-subdued": "rgba(255, 245, 234, 1)",
    "surface-warning-subdued-hovered": "rgba(255, 242, 226, 1)",
    "surface-warning-subdued-pressed": "rgba(255, 235, 211, 1)",
    "text-warning": "rgba(145, 106, 0, 1)",
    "border-highlight": "rgba(68, 157, 167, 1)",
    "border-highlight-subdued": "rgba(152, 198, 205, 1)",
    "icon-highlight": "rgba(0, 160, 172, 1)",
    "surface-highlight": "rgba(164, 232, 242, 1)",
    "surface-highlight-subdued": "rgba(235, 249, 252, 1)",
    "surface-highlight-subdued-hovered": "rgba(228, 247, 250, 1)",
    "surface-highlight-subdued-pressed": "rgba(213, 243, 248, 1)",
    "text-highlight": "rgba(52, 124, 132, 1)",
    "border-success": "rgba(0, 164, 124, 1)",
    "border-success-subdued": "rgba(149, 201, 180, 1)",
    "icon-success": "rgba(0, 127, 95, 1)",
    "surface-success": "rgba(174, 233, 209, 1)",
    "surface-success-subdued": "rgba(241, 248, 245, 1)",
    "surface-success-subdued-hovered": "rgba(236, 246, 241, 1)",
    "surface-success-subdued-pressed": "rgba(226, 241, 234, 1)",
    "text-success": "rgba(0, 128, 96, 1)",
    "icon-attention": "rgba(138, 97, 22, 1)",
    "surface-attention": "rgba(255, 234, 138, 1)",
    "decorative-one-icon": "rgba(126, 87, 0, 1)",
    "decorative-one-surface": "rgba(255, 201, 107, 1)",
    "decorative-one-text": "rgba(61, 40, 0, 1)",
    "decorative-two-icon": "rgba(175, 41, 78, 1)",
    "decorative-two-surface": "rgba(255, 196, 176, 1)",
    "decorative-two-text": "rgba(73, 11, 28, 1)",
    "decorative-three-icon": "rgba(0, 109, 65, 1)",
    "decorative-three-surface": "rgba(146, 230, 181, 1)",
    "decorative-three-text": "rgba(0, 47, 25, 1)",
    "decorative-four-icon": "rgba(0, 106, 104, 1)",
    "decorative-four-surface": "rgba(145, 224, 214, 1)",
    "decorative-four-text": "rgba(0, 45, 45, 1)",
    "decorative-five-icon": "rgba(174, 43, 76, 1)",
    "decorative-five-surface": "rgba(253, 201, 208, 1)",
    "decorative-five-text": "rgba(79, 14, 31, 1)"
};
var depth = {
    "shadow-transparent": "0 0 0 0 transparent",
    "shadow-faint": "0 1px 0 0 rgba(22, 29, 37, 0.05)",
    "shadow-base": "0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15)",
    "shadow-deep": "0 0 0 1px rgba(6, 44, 82, 0.1), 0 2px 16px rgba(33, 43, 54, 0.08)",
    "shadow-button": "0 1px 0 rgba(0, 0, 0, 0.05)",
    "shadow-top-bar": "0 2px 2px -1px rgba(0, 0, 0, 0.15)",
    "shadow-card": "0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.15)",
    "shadow-popover": "0 3px 6px -3px rgba(23, 24, 24, 0.08), 0 8px 20px -4px rgba(23, 24, 24, 0.12)",
    "shadow-layer": "0 31px 41px 0 rgba(32, 42, 53, 0.2), 0 2px 16px 0 rgba(32, 42, 54, 0.08)",
    "shadow-modal": "0 26px 80px rgba(0, 0, 0, 0.2), 0 0px 1px rgba(0, 0, 0, 0.2)",
    "shadows-inset-button": "inset 0 -1px 0 rgba(0, 0, 0, 0.2)",
    "shadows-inset-button-pressed": "inset 0 1px 0 rgba(0, 0, 0, 0.15)"
};
var font = {
    "font-family-sans": "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    "font-family-mono": "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace",
    "font-size-75": "0.75rem",
    "font-size-100": "0.875rem",
    "font-size-200": "1rem",
    "font-size-300": "1.25rem",
    "font-size-400": "1.5rem",
    "font-size-500": "1.75rem",
    "font-size-600": "2rem",
    "font-size-700": "2.5rem",
    "font-weight-regular": "400",
    "font-weight-medium": "500",
    "font-weight-semibold": "600",
    "font-weight-bold": "700",
    "font-line-height-1": "1rem",
    "font-line-height-2": "1.25rem",
    "font-line-height-3": "1.5rem",
    "font-line-height-4": "1.75rem",
    "font-line-height-5": "2rem",
    "font-line-height-6": "2.5rem",
    "font-line-height-7": "3rem"
};
var legacy = {
    "override-loading-z-index": "514",
    "choice-size": "1.25rem",
    "icon-size-small": "0.5rem",
    "icon-size-medium": "1.25rem",
    "choice-margin": "0.0625rem",
    "control-border-width": "0.125rem",
    "banner-border-default": "inset 0 0.0625rem 0 0 var(--p-color-border-strong), inset 0 0 0 0.0625rem var(--p-color-border-strong)",
    "banner-border-success": "inset 0 0.0625rem 0 0 var(--p-color-border-success-subdued), inset 0 0 0 0.0625rem var(--p-color-border-success-subdued)",
    "banner-border-highlight": "inset 0 0.0625rem 0 0 var(--p-color-border-info-subdued), inset 0 0 0 0.0625rem var(--p-color-border-info-subdued)",
    "banner-border-warning": "inset 0 0.0625rem 0 0 var(--p-color-border-caution-subdued), inset 0 0 0 0.0625rem var(--p-color-border-caution-subdued)",
    "banner-border-critical": "inset 0 0.0625rem 0 0 var(--p-color-border-critical-subdued), inset 0 0 0 0.0625rem var(--p-color-border-critical-subdued)",
    "thin-border-subdued": "0.0625rem solid var(--p-color-border-subdued)",
    "text-field-spinner-offset": "0.125rem",
    "text-field-focus-ring-offset": "-0.25rem",
    "button-group-item-spacing": "-0.0625rem",
    "range-slider-thumb-size-base": "1rem",
    "range-slider-thumb-size-active": "1.5rem",
    "frame-offset": "0rem"
};
var motion = {
    "duration-0": "0ms",
    "duration-50": "50ms",
    "duration-100": "100ms",
    "duration-150": "150ms",
    "duration-200": "200ms",
    "duration-250": "250ms",
    "duration-300": "300ms",
    "duration-350": "350ms",
    "duration-400": "400ms",
    "duration-450": "450ms",
    "duration-500": "500ms",
    "duration-5000": "5000ms",
    "ease": "cubic-bezier(0.25, 0.1, 0.25, 1)",
    "ease-in": "cubic-bezier(0.42, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.58, 1)",
    "ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)",
    "linear": "cubic-bezier(0, 0, 1, 1)",
    "keyframes-bounce": "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }",
    "keyframes-fade-in": "{ to { opacity: 1 } }",
    "keyframes-pulse": "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }",
    "keyframes-spin": "{ to { transform: rotate(1turn) } }",
    "keyframes-appear-above": "{ from { transform: translateY(var(--p-space-1)); opacity: 0; } to { transform: none; opacity: 1; } }",
    "keyframes-appear-below": "{ from { transform: translateY(calc(var(--p-space-1) * -1)); opacity: 0; } to { transform: none; opacity: 1; } }",
    "motion-duration-0": "0ms",
    "motion-duration-50": "50ms",
    "motion-duration-100": "100ms",
    "motion-duration-150": "150ms",
    "motion-duration-200": "200ms",
    "motion-duration-250": "250ms",
    "motion-duration-300": "300ms",
    "motion-duration-350": "350ms",
    "motion-duration-400": "400ms",
    "motion-duration-450": "450ms",
    "motion-duration-500": "500ms",
    "motion-duration-5000": "5000ms",
    "motion-ease": "cubic-bezier(0.25, 0.1, 0.25, 1)",
    "motion-ease-in": "cubic-bezier(0.42, 0, 1, 1)",
    "motion-ease-out": "cubic-bezier(0, 0, 0.58, 1)",
    "motion-ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)",
    "motion-linear": "cubic-bezier(0, 0, 1, 1)",
    "motion-keyframes-bounce": "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }",
    "motion-keyframes-fade-in": "{ to { opacity: 1 } }",
    "motion-keyframes-pulse": "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }",
    "motion-keyframes-spin": "{ to { transform: rotate(1turn) } }",
    "motion-keyframes-appear-above": "{ from { transform: translateY(var(--p-space-1)); opacity: 0; } to { transform: none; opacity: 1; } }",
    "motion-keyframes-appear-below": "{ from { transform: translateY(calc(var(--p-space-1) * -1)); opacity: 0; } to { transform: none; opacity: 1; } }"
};
var shadow = {
    "shadow-inset-lg": "inset 0rem 0rem 0.4375rem 0.125rem rgba(31, 33, 36, 0.18)",
    "shadow-inset-md": "inset 0rem 0.125rem 0.25rem rgba(31, 33, 36, 0.32)",
    "shadow-inset-sm": "inset 0rem 0rem 0.1875rem rgba(31, 33, 36, 0.56)",
    "shadow-none": "none",
    "shadow-xs": "0rem 0rem 0.125rem rgba(31, 33, 36, 0.24)",
    "shadow-sm": "0rem 0.0625rem 0.0625rem rgba(31, 33, 36, 0.1)",
    "shadow-md": "0rem 0.125rem 0.25rem rgba(31, 33, 36, 0.1), 0rem 0.0625rem 0.375rem rgba(31, 33, 36, 0.05)",
    "shadow-lg": "0rem 0.25rem 0.75rem rgba(31, 33, 36, 0.2), 0rem 0.125rem 0.375rem rgba(31, 33, 36, 0.05)",
    "shadow-xl": "0rem 0.25rem 1.125rem -0.125rem rgba(31, 33, 36, 0.08), 0rem 0.75rem 1.125rem -0.125rem rgba(31, 33, 36, 0.15)",
    "shadow-2xl": "0rem 2rem 2rem rgba(31, 33, 36, 0.15), 0rem 2rem 3.5rem -0.125rem rgba(31, 33, 36, 0.16)"
};
var shape = {
    "border-radius-05": "0.125rem",
    "border-radius-1": "0.25rem",
    "border-radius-2": "0.5rem",
    "border-radius-3": "0.75rem",
    "border-radius-4": "1rem",
    "border-radius-5": "1.25rem",
    "border-radius-6": "1.875rem",
    "border-radius-full": "624.9375rem",
    "border-radius-base": "0.1875rem",
    "border-radius-large": "0.375rem",
    "border-radius-half": "50%",
    "border-width-1": "0.0625rem",
    "border-width-2": "0.125rem",
    "border-width-3": "0.1875rem",
    "border-width-4": "0.25rem",
    "border-width-5": "0.3125rem",
    "border-base": "var(--p-border-width-1) solid var(--p-color-border-subdued)",
    "border-dark": "var(--p-border-width-1) solid var(--p-color-border)",
    "border-transparent": "var(--p-border-width-1) solid transparent",
    "border-divider": "var(--p-border-width-1) solid var(--p-color-border-subdued)",
    "border-divider-on-dark": "var(--p-border-width-1) solid var(--p-color-border-inverse)"
};
var spacing = {
    "space-0": "0",
    "space-025": "0.0625rem",
    "space-05": "0.125rem",
    "space-1": "0.25rem",
    "space-2": "0.5rem",
    "space-3": "0.75rem",
    "space-4": "1rem",
    "space-5": "1.25rem",
    "space-6": "1.5rem",
    "space-8": "2rem",
    "space-10": "2.5rem",
    "space-12": "3rem",
    "space-16": "4rem",
    "space-20": "5rem",
    "space-24": "6rem",
    "space-28": "7rem",
    "space-32": "8rem"
};
var space = {
    "space-0": "0",
    "space-025": "0.0625rem",
    "space-05": "0.125rem",
    "space-1": "0.25rem",
    "space-2": "0.5rem",
    "space-3": "0.75rem",
    "space-4": "1rem",
    "space-5": "1.25rem",
    "space-6": "1.5rem",
    "space-8": "2rem",
    "space-10": "2.5rem",
    "space-12": "3rem",
    "space-16": "4rem",
    "space-20": "5rem",
    "space-24": "6rem",
    "space-28": "7rem",
    "space-32": "8rem"
};
var zIndex = {
    "z-index-1": "100",
    "z-index-2": "400",
    "z-index-3": "510",
    "z-index-4": "512",
    "z-index-5": "513",
    "z-index-6": "514",
    "z-index-7": "515",
    "z-index-8": "516",
    "z-index-9": "517",
    "z-index-10": "518",
    "z-index-11": "519",
    "z-index-12": "520",
    "z-1": "100",
    "z-2": "400",
    "z-3": "510",
    "z-4": "512",
    "z-5": "513",
    "z-6": "514",
    "z-7": "515",
    "z-8": "516",
    "z-9": "517",
    "z-10": "518",
    "z-11": "519",
    "z-12": "520"
};
var tokens = {
    "breakpoints": {
        "breakpoints-xs": "0rem",
        "breakpoints-sm": "30.625rem",
        "breakpoints-md": "48rem",
        "breakpoints-lg": "65rem",
        "breakpoints-xl": "90rem"
    },
    "border": {
        "border-radius-05": "0.125rem",
        "border-radius-1": "0.25rem",
        "border-radius-2": "0.5rem",
        "border-radius-3": "0.75rem",
        "border-radius-4": "1rem",
        "border-radius-5": "1.25rem",
        "border-radius-6": "1.875rem",
        "border-radius-full": "624.9375rem",
        "border-width-1": "0.0625rem",
        "border-width-2": "0.125rem",
        "border-width-3": "0.1875rem",
        "border-width-4": "0.25rem",
        "border-width-5": "0.3125rem"
    },
    "color": {
        "color-bg-inverse": "rgba(31, 33, 36, 1)",
        "color-bg-inset-strong": "rgba(97, 106, 117, 1)",
        "color-bg-inverse-hover": "rgba(97, 106, 117, 1)",
        "color-bg-inverse-active": "rgba(135, 144, 155, 1)",
        "color-bg-strong-hover": "rgba(202, 206, 211, 1)",
        "color-bg-strong-active": "rgba(202, 206, 211, 1)",
        "color-bg-strong": "rgba(221, 224, 228, 1)",
        "color-bg-subdued-active": "rgba(235, 236, 239, 1)",
        "color-bg-disabled": "rgba(235, 236, 239, 1)",
        "color-bg-interactive-disabled": "rgba(235, 236, 239, 1)",
        "color-bg-app": "rgba(241, 242, 244, 1)",
        "color-bg-app-active": "rgba(221, 224, 228, 1)",
        "color-bg-app-hover": "rgba(235, 236, 239, 1)",
        "color-bg-app-selected": "rgba(235, 236, 239, 1)",
        "color-bg-active": "rgba(235, 236, 239, 1)",
        "color-bg-subdued-hover": "rgba(241, 242, 244, 1)",
        "color-bg-inset": "rgba(241, 242, 244, 1)",
        "color-bg-hover": "rgba(241, 242, 244, 1)",
        "color-bg-subdued": "rgba(249, 250, 251, 1)",
        "color-bg-input": "rgba(255, 255, 255, 1)",
        "color-bg": "rgba(255, 255, 255, 1)",
        "color-bg-primary-active": "rgba(12, 59, 47, 1)",
        "color-bg-primary-hover": "rgba(18, 84, 67, 1)",
        "color-bg-primary": "rgba(0, 122, 92, 1)",
        "color-bg-success-strong": "rgba(22, 166, 121, 1)",
        "color-bg-success": "rgba(161, 237, 208, 1)",
        "color-bg-primary-subdued-active": "rgba(192, 242, 221, 1)",
        "color-bg-success-subdued-active": "rgba(192, 242, 221, 1)",
        "color-bg-success-subdued": "rgba(224, 248, 238, 1)",
        "color-bg-primary-subdued-hover": "rgba(224, 248, 238, 1)",
        "color-bg-success-subdued-hover": "rgba(240, 253, 248, 1)",
        "color-bg-primary-subdued": "rgba(240, 253, 248, 1)",
        "color-bg-primary-subdued-selected": "rgba(240, 253, 248, 1)",
        "color-bg-critical-strong-active": "rgba(115, 24, 7, 1)",
        "color-bg-critical-strong-hover": "rgba(159, 32, 10, 1)",
        "color-bg-critical-strong": "rgba(197, 40, 12, 1)",
        "color-bg-critical-subdued-active": "rgba(251, 197, 188, 1)",
        "color-bg-critical": "rgba(251, 197, 188, 1)",
        "color-bg-critical-subdued": "rgba(253, 226, 221, 1)",
        "color-bg-critical-subdued-hover": "rgba(254, 243, 241, 1)",
        "color-bg-caution-strong": "rgba(216, 155, 13, 1)",
        "color-bg-caution": "rgba(248, 217, 144, 1)",
        "color-bg-caution-subdued-active": "rgba(250, 229, 178, 1)",
        "color-bg-caution-subdued": "rgba(252, 240, 212, 1)",
        "color-bg-caution-subdued-hover": "rgba(254, 248, 236, 1)",
        "color-bg-info-strong": "rgba(42, 172, 187, 1)",
        "color-bg-info-subdued-active": "rgba(184, 233, 239, 1)",
        "color-bg-info": "rgba(184, 233, 239, 1)",
        "color-bg-info-subdued": "rgba(222, 245, 247, 1)",
        "color-bg-info-subdued-hover": "rgba(238, 250, 251, 1)",
        "color-bg-interactive-active": "rgba(14, 53, 108, 1)",
        "color-bg-interactive-hover": "rgba(20, 73, 149, 1)",
        "color-bg-interactive": "rgba(36, 99, 188, 1)",
        "color-bg-interactive-subdued-active": "rgba(187, 212, 247, 1)",
        "color-bg-interactive-subdued-hover": "rgba(232, 240, 253, 1)",
        "color-bg-interactive-subdued": "rgba(240, 245, 253, 1)",
        "color-bg-interactive-selected": "rgba(240, 245, 253, 1)",
        "color-bg-warning": "rgba(250, 201, 168, 1)",
        "color-bg-magic-strong": "rgba(121, 69, 227, 1)",
        "color-bg-magic-hover": "rgba(226, 214, 250, 1)",
        "color-bg-magic-active": "rgba(203, 180, 248, 1)",
        "color-bg-magic": "rgba(236, 227, 253, 1)",
        "color-bg-magic-subdued-hover": "rgba(236, 227, 253, 1)",
        "color-bg-magic-subdued-active": "rgba(226, 214, 250, 1)",
        "color-bg-magic-subdued": "rgba(242, 237, 253, 1)",
        "color-border-input-hover": "rgba(97, 106, 117, 1)",
        "color-border-inverse": "rgba(97, 106, 117, 1)",
        "color-border-strong-hover": "rgba(135, 144, 155, 1)",
        "color-border-input": "rgba(171, 177, 186, 1)",
        "color-border-hover": "rgba(171, 177, 186, 1)",
        "color-border-strong": "rgba(171, 177, 186, 1)",
        "color-border": "rgba(202, 206, 211, 1)",
        "color-border-disabled": "rgba(221, 224, 228, 1)",
        "color-border-subdued": "rgba(221, 224, 228, 1)",
        "color-border-interactive-disabled": "rgba(221, 224, 228, 1)",
        "color-border-primary": "rgba(0, 122, 92, 1)",
        "color-border-success": "rgba(22, 166, 121, 1)",
        "color-border-success-subdued": "rgba(80, 220, 169, 1)",
        "color-border-critical-active": "rgba(67, 14, 4, 1)",
        "color-border-critical-hover": "rgba(115, 24, 7, 1)",
        "color-border-critical": "rgba(197, 40, 12, 1)",
        "color-border-critical-subdued": "rgba(245, 107, 82, 1)",
        "color-border-caution": "rgba(216, 155, 13, 1)",
        "color-border-caution-subdued": "rgba(245, 196, 82, 1)",
        "color-border-info": "rgba(59, 195, 211, 1)",
        "color-border-info-subdued": "rgba(109, 211, 222, 1)",
        "color-border-interactive-active": "rgba(14, 53, 108, 1)",
        "color-border-interactive-hover": "rgba(20, 73, 149, 1)",
        "color-border-interactive": "rgba(62, 125, 213, 1)",
        "color-border-interactive-focus": "rgba(62, 125, 213, 1)",
        "color-border-interactive-subdued": "rgba(187, 212, 247, 1)",
        "color-border-magic-strong": "rgba(121, 69, 227, 1)",
        "color-border-magic": "rgba(173, 139, 241, 1)",
        "color-icon-hover": "rgba(31, 33, 36, 1)",
        "color-icon": "rgba(97, 106, 117, 1)",
        "color-icon-active": "rgba(31, 33, 36, 1)",
        "color-icon-subdued": "rgba(135, 144, 155, 1)",
        "color-icon-disabled": "rgba(171, 177, 186, 1)",
        "color-icon-interactive-disabled": "rgba(171, 177, 186, 1)",
        "color-icon-inverse": "rgba(221, 224, 228, 1)",
        "color-icon-on-color": "rgba(255, 255, 255, 1)",
        "color-icon-primary": "rgba(0, 122, 92, 1)",
        "color-icon-success": "rgba(22, 166, 121, 1)",
        "color-icon-critical": "rgba(197, 40, 12, 1)",
        "color-icon-caution": "rgba(183, 126, 11, 1)",
        "color-icon-info": "rgba(42, 172, 187, 1)",
        "color-icon-warning": "rgba(242, 117, 34, 1)",
        "color-icon-interactive-active": "rgba(14, 53, 108, 1)",
        "color-icon-interactive-hover": "rgba(20, 73, 149, 1)",
        "color-icon-interactive": "rgba(36, 99, 188, 1)",
        "color-icon-interactive-inverse": "rgba(102, 153, 225, 1)",
        "color-icon-magic": "rgba(121, 69, 227, 1)",
        "color-text": "rgba(31, 33, 36, 1)",
        "color-text-subdued": "rgba(97, 106, 117, 1)",
        "color-text-disabled": "rgba(135, 144, 155, 1)",
        "color-text-interactive-disabled": "rgba(135, 144, 155, 1)",
        "color-text-inverse-subdued": "rgba(171, 177, 186, 1)",
        "color-text-inverse": "rgba(241, 242, 244, 1)",
        "color-text-on-color": "rgba(255, 255, 255, 1)",
        "color-text-success-strong": "rgba(12, 59, 47, 1)",
        "color-text-success": "rgba(0, 122, 92, 1)",
        "color-text-primary": "rgba(0, 122, 92, 1)",
        "color-text-primary-hover": "rgba(18, 84, 67, 1)",
        "color-text-critical-strong": "rgba(67, 14, 4, 1)",
        "color-text-critical-active": "rgba(115, 24, 7, 1)",
        "color-text-critical": "rgba(197, 40, 12, 1)",
        "color-text-caution-strong": "rgba(77, 46, 5, 1)",
        "color-text-caution": "rgba(135, 92, 8, 1)",
        "color-text-info-strong": "rgba(16, 65, 71, 1)",
        "color-text-info": "rgba(32, 130, 141, 1)",
        "color-text-warning-strong": "rgba(77, 36, 5, 1)",
        "color-text-interactive-active": "rgba(14, 53, 108, 1)",
        "color-text-interactive-hover": "rgba(20, 73, 149, 1)",
        "color-text-interactive": "rgba(36, 99, 188, 1)",
        "color-text-interactive-inverse": "rgba(102, 153, 225, 1)",
        "color-text-magic-strong": "rgba(49, 13, 120, 1)",
        "color-text-magic": "rgba(90, 36, 205, 1)"
    },
    "colors": {
        "background": "rgba(246, 246, 247, 1)",
        "background-hovered": "rgba(241, 242, 243, 1)",
        "background-pressed": "rgba(237, 238, 239, 1)",
        "background-selected": "rgba(237, 238, 239, 1)",
        "surface": "rgba(255, 255, 255, 1)",
        "surface-dark": "rgba(32, 33, 35, 1)",
        "surface-neutral": "rgba(228, 229, 231, 1)",
        "surface-neutral-hovered": "rgba(219, 221, 223, 1)",
        "surface-neutral-pressed": "rgba(201, 204, 208, 1)",
        "surface-neutral-disabled": "rgba(241, 242, 243, 1)",
        "surface-neutral-subdued": "rgba(246, 246, 247, 1)",
        "surface-neutral-subdued-dark": "rgba(68, 71, 74, 1)",
        "surface-subdued": "rgba(250, 251, 251, 1)",
        "surface-disabled": "rgba(250, 251, 251, 1)",
        "surface-hovered": "rgba(246, 246, 247, 1)",
        "surface-hovered-dark": "rgba(47, 49, 51, 1)",
        "surface-pressed": "rgba(241, 242, 243, 1)",
        "surface-pressed-dark": "rgba(62, 64, 67, 1)",
        "surface-depressed": "rgba(237, 238, 239, 1)",
        "surface-search-field": "rgba(241, 242, 243, 1)",
        "surface-search-field-dark": "rgba(47, 49, 51, 1)",
        "backdrop": "rgba(0, 0, 0, 0.5)",
        "overlay": "rgba(255, 255, 255, 0.5)",
        "shadow-color-picker": "rgba(0, 0, 0, 0.5)",
        "shadow-color-picker-dragger": "rgba(33, 43, 54, 0.32)",
        "hint-from-direct-light": "rgba(0, 0, 0, 0.15)",
        "border": "rgba(140, 145, 150, 1)",
        "border-on-dark": "rgba(80, 83, 86, 1)",
        "border-neutral-subdued": "rgba(186, 191, 195, 1)",
        "border-hovered": "rgba(153, 158, 164, 1)",
        "border-disabled": "rgba(210, 213, 216, 1)",
        "border-subdued": "rgba(201, 204, 207, 1)",
        "border-depressed": "rgba(87, 89, 89, 1)",
        "border-shadow": "rgba(174, 180, 185, 1)",
        "border-shadow-subdued": "rgba(186, 191, 196, 1)",
        "divider": "rgba(225, 227, 229, 1)",
        "divider-dark": "rgba(69, 71, 73, 1)",
        "icon": "rgba(92, 95, 98, 1)",
        "icon-on-dark": "rgba(166, 172, 178, 1)",
        "icon-hovered": "rgba(26, 28, 29, 1)",
        "icon-pressed": "rgba(68, 71, 74, 1)",
        "icon-disabled": "rgba(186, 190, 195, 1)",
        "icon-subdued": "rgba(140, 145, 150, 1)",
        "text": "rgba(32, 34, 35, 1)",
        "text-on-dark": "rgba(227, 229, 231, 1)",
        "text-disabled": "rgba(140, 145, 150, 1)",
        "text-subdued": "rgba(109, 113, 117, 1)",
        "text-subdued-on-dark": "rgba(153, 159, 164, 1)",
        "interactive": "rgba(44, 110, 203, 1)",
        "interactive-on-dark": "rgba(54, 163, 255, 1)",
        "interactive-disabled": "rgba(189, 193, 204, 1)",
        "interactive-hovered": "rgba(31, 81, 153, 1)",
        "interactive-pressed": "rgba(16, 50, 98, 1)",
        "interactive-pressed-on-dark": "rgba(136, 188, 255, 1)",
        "focused": "rgba(69, 143, 255, 1)",
        "surface-selected": "rgba(242, 247, 254, 1)",
        "surface-selected-hovered": "rgba(237, 244, 254, 1)",
        "surface-selected-pressed": "rgba(229, 239, 253, 1)",
        "icon-on-interactive": "rgba(255, 255, 255, 1)",
        "text-on-interactive": "rgba(255, 255, 255, 1)",
        "action-secondary": "rgba(255, 255, 255, 1)",
        "action-secondary-disabled": "rgba(255, 255, 255, 1)",
        "action-secondary-hovered": "rgba(246, 246, 247, 1)",
        "action-secondary-hovered-dark": "rgba(84, 87, 91, 1)",
        "action-secondary-pressed": "rgba(241, 242, 243, 1)",
        "action-secondary-pressed-dark": "rgba(96, 100, 103, 1)",
        "action-secondary-depressed": "rgba(109, 113, 117, 1)",
        "action-primary": "rgba(0, 128, 96, 1)",
        "action-primary-disabled": "rgba(241, 241, 241, 1)",
        "action-primary-hovered": "rgba(0, 110, 82, 1)",
        "action-primary-pressed": "rgba(0, 94, 70, 1)",
        "action-primary-depressed": "rgba(0, 61, 44, 1)",
        "icon-on-primary": "rgba(255, 255, 255, 1)",
        "text-on-primary": "rgba(255, 255, 255, 1)",
        "text-primary": "rgba(0, 123, 92, 1)",
        "text-primary-hovered": "rgba(0, 108, 80, 1)",
        "text-primary-pressed": "rgba(0, 92, 68, 1)",
        "surface-primary-selected": "rgba(241, 248, 245, 1)",
        "surface-primary-selected-hovered": "rgba(179, 208, 195, 1)",
        "surface-primary-selected-pressed": "rgba(162, 188, 176, 1)",
        "border-critical": "rgba(253, 87, 73, 1)",
        "border-critical-subdued": "rgba(224, 179, 178, 1)",
        "border-critical-disabled": "rgba(255, 167, 163, 1)",
        "icon-critical": "rgba(215, 44, 13, 1)",
        "surface-critical": "rgba(254, 211, 209, 1)",
        "surface-critical-subdued": "rgba(255, 244, 244, 1)",
        "surface-critical-subdued-hovered": "rgba(255, 240, 240, 1)",
        "surface-critical-subdued-pressed": "rgba(255, 233, 232, 1)",
        "surface-critical-subdued-depressed": "rgba(254, 188, 185, 1)",
        "text-critical": "rgba(215, 44, 13, 1)",
        "action-critical": "rgba(216, 44, 13, 1)",
        "action-critical-disabled": "rgba(241, 241, 241, 1)",
        "action-critical-hovered": "rgba(188, 34, 0, 1)",
        "action-critical-pressed": "rgba(162, 27, 0, 1)",
        "action-critical-depressed": "rgba(108, 15, 0, 1)",
        "icon-on-critical": "rgba(255, 255, 255, 1)",
        "text-on-critical": "rgba(255, 255, 255, 1)",
        "interactive-critical": "rgba(216, 44, 13, 1)",
        "interactive-critical-disabled": "rgba(253, 147, 141, 1)",
        "interactive-critical-hovered": "rgba(205, 41, 12, 1)",
        "interactive-critical-pressed": "rgba(103, 15, 3, 1)",
        "border-warning": "rgba(185, 137, 0, 1)",
        "border-warning-subdued": "rgba(225, 184, 120, 1)",
        "icon-warning": "rgba(185, 137, 0, 1)",
        "surface-warning": "rgba(255, 215, 157, 1)",
        "surface-warning-subdued": "rgba(255, 245, 234, 1)",
        "surface-warning-subdued-hovered": "rgba(255, 242, 226, 1)",
        "surface-warning-subdued-pressed": "rgba(255, 235, 211, 1)",
        "text-warning": "rgba(145, 106, 0, 1)",
        "border-highlight": "rgba(68, 157, 167, 1)",
        "border-highlight-subdued": "rgba(152, 198, 205, 1)",
        "icon-highlight": "rgba(0, 160, 172, 1)",
        "surface-highlight": "rgba(164, 232, 242, 1)",
        "surface-highlight-subdued": "rgba(235, 249, 252, 1)",
        "surface-highlight-subdued-hovered": "rgba(228, 247, 250, 1)",
        "surface-highlight-subdued-pressed": "rgba(213, 243, 248, 1)",
        "text-highlight": "rgba(52, 124, 132, 1)",
        "border-success": "rgba(0, 164, 124, 1)",
        "border-success-subdued": "rgba(149, 201, 180, 1)",
        "icon-success": "rgba(0, 127, 95, 1)",
        "surface-success": "rgba(174, 233, 209, 1)",
        "surface-success-subdued": "rgba(241, 248, 245, 1)",
        "surface-success-subdued-hovered": "rgba(236, 246, 241, 1)",
        "surface-success-subdued-pressed": "rgba(226, 241, 234, 1)",
        "text-success": "rgba(0, 128, 96, 1)",
        "icon-attention": "rgba(138, 97, 22, 1)",
        "surface-attention": "rgba(255, 234, 138, 1)",
        "decorative-one-icon": "rgba(126, 87, 0, 1)",
        "decorative-one-surface": "rgba(255, 201, 107, 1)",
        "decorative-one-text": "rgba(61, 40, 0, 1)",
        "decorative-two-icon": "rgba(175, 41, 78, 1)",
        "decorative-two-surface": "rgba(255, 196, 176, 1)",
        "decorative-two-text": "rgba(73, 11, 28, 1)",
        "decorative-three-icon": "rgba(0, 109, 65, 1)",
        "decorative-three-surface": "rgba(146, 230, 181, 1)",
        "decorative-three-text": "rgba(0, 47, 25, 1)",
        "decorative-four-icon": "rgba(0, 106, 104, 1)",
        "decorative-four-surface": "rgba(145, 224, 214, 1)",
        "decorative-four-text": "rgba(0, 45, 45, 1)",
        "decorative-five-icon": "rgba(174, 43, 76, 1)",
        "decorative-five-surface": "rgba(253, 201, 208, 1)",
        "decorative-five-text": "rgba(79, 14, 31, 1)"
    },
    "depth": {
        "shadow-transparent": "0 0 0 0 transparent",
        "shadow-faint": "0 1px 0 0 rgba(22, 29, 37, 0.05)",
        "shadow-base": "0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15)",
        "shadow-deep": "0 0 0 1px rgba(6, 44, 82, 0.1), 0 2px 16px rgba(33, 43, 54, 0.08)",
        "shadow-button": "0 1px 0 rgba(0, 0, 0, 0.05)",
        "shadow-top-bar": "0 2px 2px -1px rgba(0, 0, 0, 0.15)",
        "shadow-card": "0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.15)",
        "shadow-popover": "0 3px 6px -3px rgba(23, 24, 24, 0.08), 0 8px 20px -4px rgba(23, 24, 24, 0.12)",
        "shadow-layer": "0 31px 41px 0 rgba(32, 42, 53, 0.2), 0 2px 16px 0 rgba(32, 42, 54, 0.08)",
        "shadow-modal": "0 26px 80px rgba(0, 0, 0, 0.2), 0 0px 1px rgba(0, 0, 0, 0.2)",
        "shadows-inset-button": "inset 0 -1px 0 rgba(0, 0, 0, 0.2)",
        "shadows-inset-button-pressed": "inset 0 1px 0 rgba(0, 0, 0, 0.15)"
    },
    "font": {
        "font-family-sans": "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
        "font-family-mono": "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace",
        "font-size-75": "0.75rem",
        "font-size-100": "0.875rem",
        "font-size-200": "1rem",
        "font-size-300": "1.25rem",
        "font-size-400": "1.5rem",
        "font-size-500": "1.75rem",
        "font-size-600": "2rem",
        "font-size-700": "2.5rem",
        "font-weight-regular": "400",
        "font-weight-medium": "500",
        "font-weight-semibold": "600",
        "font-weight-bold": "700",
        "font-line-height-1": "1rem",
        "font-line-height-2": "1.25rem",
        "font-line-height-3": "1.5rem",
        "font-line-height-4": "1.75rem",
        "font-line-height-5": "2rem",
        "font-line-height-6": "2.5rem",
        "font-line-height-7": "3rem"
    },
    "legacy": {
        "override-loading-z-index": "514",
        "choice-size": "1.25rem",
        "icon-size-small": "0.5rem",
        "icon-size-medium": "1.25rem",
        "choice-margin": "0.0625rem",
        "control-border-width": "0.125rem",
        "banner-border-default": "inset 0 0.0625rem 0 0 var(--p-color-border-strong), inset 0 0 0 0.0625rem var(--p-color-border-strong)",
        "banner-border-success": "inset 0 0.0625rem 0 0 var(--p-color-border-success-subdued), inset 0 0 0 0.0625rem var(--p-color-border-success-subdued)",
        "banner-border-highlight": "inset 0 0.0625rem 0 0 var(--p-color-border-info-subdued), inset 0 0 0 0.0625rem var(--p-color-border-info-subdued)",
        "banner-border-warning": "inset 0 0.0625rem 0 0 var(--p-color-border-caution-subdued), inset 0 0 0 0.0625rem var(--p-color-border-caution-subdued)",
        "banner-border-critical": "inset 0 0.0625rem 0 0 var(--p-color-border-critical-subdued), inset 0 0 0 0.0625rem var(--p-color-border-critical-subdued)",
        "thin-border-subdued": "0.0625rem solid var(--p-color-border-subdued)",
        "text-field-spinner-offset": "0.125rem",
        "text-field-focus-ring-offset": "-0.25rem",
        "button-group-item-spacing": "-0.0625rem",
        "range-slider-thumb-size-base": "1rem",
        "range-slider-thumb-size-active": "1.5rem",
        "frame-offset": "0rem"
    },
    "motion": {
        "duration-0": "0ms",
        "duration-50": "50ms",
        "duration-100": "100ms",
        "duration-150": "150ms",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-350": "350ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-5000": "5000ms",
        "ease": "cubic-bezier(0.25, 0.1, 0.25, 1)",
        "ease-in": "cubic-bezier(0.42, 0, 1, 1)",
        "ease-out": "cubic-bezier(0, 0, 0.58, 1)",
        "ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)",
        "linear": "cubic-bezier(0, 0, 1, 1)",
        "keyframes-bounce": "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }",
        "keyframes-fade-in": "{ to { opacity: 1 } }",
        "keyframes-pulse": "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }",
        "keyframes-spin": "{ to { transform: rotate(1turn) } }",
        "keyframes-appear-above": "{ from { transform: translateY(var(--p-space-1)); opacity: 0; } to { transform: none; opacity: 1; } }",
        "keyframes-appear-below": "{ from { transform: translateY(calc(var(--p-space-1) * -1)); opacity: 0; } to { transform: none; opacity: 1; } }",
        "motion-duration-0": "0ms",
        "motion-duration-50": "50ms",
        "motion-duration-100": "100ms",
        "motion-duration-150": "150ms",
        "motion-duration-200": "200ms",
        "motion-duration-250": "250ms",
        "motion-duration-300": "300ms",
        "motion-duration-350": "350ms",
        "motion-duration-400": "400ms",
        "motion-duration-450": "450ms",
        "motion-duration-500": "500ms",
        "motion-duration-5000": "5000ms",
        "motion-ease": "cubic-bezier(0.25, 0.1, 0.25, 1)",
        "motion-ease-in": "cubic-bezier(0.42, 0, 1, 1)",
        "motion-ease-out": "cubic-bezier(0, 0, 0.58, 1)",
        "motion-ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)",
        "motion-linear": "cubic-bezier(0, 0, 1, 1)",
        "motion-keyframes-bounce": "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }",
        "motion-keyframes-fade-in": "{ to { opacity: 1 } }",
        "motion-keyframes-pulse": "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }",
        "motion-keyframes-spin": "{ to { transform: rotate(1turn) } }",
        "motion-keyframes-appear-above": "{ from { transform: translateY(var(--p-space-1)); opacity: 0; } to { transform: none; opacity: 1; } }",
        "motion-keyframes-appear-below": "{ from { transform: translateY(calc(var(--p-space-1) * -1)); opacity: 0; } to { transform: none; opacity: 1; } }"
    },
    "shadow": {
        "shadow-inset-lg": "inset 0rem 0rem 0.4375rem 0.125rem rgba(31, 33, 36, 0.18)",
        "shadow-inset-md": "inset 0rem 0.125rem 0.25rem rgba(31, 33, 36, 0.32)",
        "shadow-inset-sm": "inset 0rem 0rem 0.1875rem rgba(31, 33, 36, 0.56)",
        "shadow-none": "none",
        "shadow-xs": "0rem 0rem 0.125rem rgba(31, 33, 36, 0.24)",
        "shadow-sm": "0rem 0.0625rem 0.0625rem rgba(31, 33, 36, 0.1)",
        "shadow-md": "0rem 0.125rem 0.25rem rgba(31, 33, 36, 0.1), 0rem 0.0625rem 0.375rem rgba(31, 33, 36, 0.05)",
        "shadow-lg": "0rem 0.25rem 0.75rem rgba(31, 33, 36, 0.2), 0rem 0.125rem 0.375rem rgba(31, 33, 36, 0.05)",
        "shadow-xl": "0rem 0.25rem 1.125rem -0.125rem rgba(31, 33, 36, 0.08), 0rem 0.75rem 1.125rem -0.125rem rgba(31, 33, 36, 0.15)",
        "shadow-2xl": "0rem 2rem 2rem rgba(31, 33, 36, 0.15), 0rem 2rem 3.5rem -0.125rem rgba(31, 33, 36, 0.16)"
    },
    "shape": {
        "border-radius-05": "0.125rem",
        "border-radius-1": "0.25rem",
        "border-radius-2": "0.5rem",
        "border-radius-3": "0.75rem",
        "border-radius-4": "1rem",
        "border-radius-5": "1.25rem",
        "border-radius-6": "1.875rem",
        "border-radius-full": "624.9375rem",
        "border-radius-base": "0.1875rem",
        "border-radius-large": "0.375rem",
        "border-radius-half": "50%",
        "border-width-1": "0.0625rem",
        "border-width-2": "0.125rem",
        "border-width-3": "0.1875rem",
        "border-width-4": "0.25rem",
        "border-width-5": "0.3125rem",
        "border-base": "var(--p-border-width-1) solid var(--p-color-border-subdued)",
        "border-dark": "var(--p-border-width-1) solid var(--p-color-border)",
        "border-transparent": "var(--p-border-width-1) solid transparent",
        "border-divider": "var(--p-border-width-1) solid var(--p-color-border-subdued)",
        "border-divider-on-dark": "var(--p-border-width-1) solid var(--p-color-border-inverse)"
    },
    "spacing": {
        "space-0": "0",
        "space-025": "0.0625rem",
        "space-05": "0.125rem",
        "space-1": "0.25rem",
        "space-2": "0.5rem",
        "space-3": "0.75rem",
        "space-4": "1rem",
        "space-5": "1.25rem",
        "space-6": "1.5rem",
        "space-8": "2rem",
        "space-10": "2.5rem",
        "space-12": "3rem",
        "space-16": "4rem",
        "space-20": "5rem",
        "space-24": "6rem",
        "space-28": "7rem",
        "space-32": "8rem"
    },
    "space": {
        "space-0": "0",
        "space-025": "0.0625rem",
        "space-05": "0.125rem",
        "space-1": "0.25rem",
        "space-2": "0.5rem",
        "space-3": "0.75rem",
        "space-4": "1rem",
        "space-5": "1.25rem",
        "space-6": "1.5rem",
        "space-8": "2rem",
        "space-10": "2.5rem",
        "space-12": "3rem",
        "space-16": "4rem",
        "space-20": "5rem",
        "space-24": "6rem",
        "space-28": "7rem",
        "space-32": "8rem"
    },
    "zIndex": {
        "z-index-1": "100",
        "z-index-2": "400",
        "z-index-3": "510",
        "z-index-4": "512",
        "z-index-5": "513",
        "z-index-6": "514",
        "z-index-7": "515",
        "z-index-8": "516",
        "z-index-9": "517",
        "z-index-10": "518",
        "z-index-11": "519",
        "z-index-12": "520",
        "z-1": "100",
        "z-2": "400",
        "z-3": "510",
        "z-4": "512",
        "z-5": "513",
        "z-6": "514",
        "z-7": "515",
        "z-8": "516",
        "z-9": "517",
        "z-10": "518",
        "z-11": "519",
        "z-12": "520"
    }
};

},{"../src/metadata.mjs":"53mR0","../src/utilities.mjs":"l5EX7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"53mR0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMetadata", ()=>createMetadata);
parcelHelpers.export(exports, "metadata", ()=>metadata);
var _utilitiesMjs = require("./utilities.mjs");
var _breakpointsMjs = require("./token-groups/breakpoints.mjs");
var _borderMjs = require("./token-groups/border.mjs");
var _depthMjs = require("./token-groups/depth.mjs");
var _fontMjs = require("./token-groups/font.mjs");
var _legacyMjs = require("./token-groups/legacy.mjs");
var _colorMjs = require("./token-groups/color.mjs");
var _colorsMjs = require("./token-groups/colors.mjs");
var _motionMjs = require("./token-groups/motion.mjs");
var _shadowMjs = require("./token-groups/shadow.mjs");
var _shapeMjs = require("./token-groups/shape.mjs");
var _spacingMjs = require("./token-groups/spacing.mjs");
var _spaceMjs = require("./token-groups/space.mjs");
var _zIndexMjs = require("./token-groups/zIndex.mjs");
var metadata = createMetadata({
    breakpoints: (0, _utilitiesMjs.tokensToRems)((0, _breakpointsMjs.breakpoints)),
    border: (0, _utilitiesMjs.tokensToRems)((0, _borderMjs.border)),
    color: (0, _colorMjs.color),
    colors: (0, _colorsMjs.colors),
    depth: (0, _depthMjs.depth),
    font: (0, _utilitiesMjs.tokensToRems)((0, _fontMjs.font)),
    legacy: (0, _utilitiesMjs.tokensToRems)((0, _legacyMjs.legacy)),
    motion: (0, _motionMjs.motion),
    shadow: (0, _utilitiesMjs.tokensToRems)((0, _shadowMjs.shadow)),
    shape: (0, _utilitiesMjs.tokensToRems)((0, _shapeMjs.shape)),
    spacing: (0, _utilitiesMjs.tokensToRems)((0, _spacingMjs.spacing)),
    space: (0, _utilitiesMjs.tokensToRems)((0, _spaceMjs.space)),
    zIndex: (0, _zIndexMjs.zIndex)
});
/**
 * Identity function that simply returns the provided tokens with metadata, but additionally
 * validates the input matches the `Metadata` type exactly and infers all members.
 */ function createMetadata(metadata) {
    return metadata;
}

},{"./utilities.mjs":"l5EX7","./token-groups/breakpoints.mjs":"aykUa","./token-groups/border.mjs":"dNL72","./token-groups/depth.mjs":"4IBwQ","./token-groups/font.mjs":"jrpe9","./token-groups/legacy.mjs":"dUq4R","./token-groups/color.mjs":"fNaSv","./token-groups/colors.mjs":"dXAkK","./token-groups/motion.mjs":"fUndk","./token-groups/shadow.mjs":"iEO6W","./token-groups/shape.mjs":"ksTY2","./token-groups/spacing.mjs":"gSVo5","./token-groups/space.mjs":"fiVmm","./token-groups/zIndex.mjs":"aWYjz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l5EX7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createVar", ()=>createVar);
parcelHelpers.export(exports, "getCustomPropertyNames", ()=>getCustomPropertyNames);
parcelHelpers.export(exports, "getKeyframeNames", ()=>getKeyframeNames);
parcelHelpers.export(exports, "getMediaConditions", ()=>getMediaConditions);
parcelHelpers.export(exports, "getUnit", ()=>getUnit);
parcelHelpers.export(exports, "isKeyOf", ()=>isKeyOf);
parcelHelpers.export(exports, "rem", ()=>rem);
parcelHelpers.export(exports, "removeMetadata", ()=>removeMetadata);
parcelHelpers.export(exports, "toEm", ()=>toEm);
parcelHelpers.export(exports, "toPx", ()=>toPx);
parcelHelpers.export(exports, "toRem", ()=>toRem);
parcelHelpers.export(exports, "tokensToRems", ()=>tokensToRems);
var _rollupPluginBabelHelpersMjs = require("../_virtual/_rollupPluginBabelHelpers.mjs");
var _templateObject;
var BASE_FONT_SIZE = 16;
var UNIT_PX = "px";
var UNIT_EM = "em";
var UNIT_REM = "rem"; // https://regex101.com/r/zvY2bu/1
var DIGIT_REGEX = new RegExp(String.raw(_templateObject || (_templateObject = (0, _rollupPluginBabelHelpersMjs.taggedTemplateLiteral)([
    "-?d+(?:.d+|d*)"
], [
    "-?\\d+(?:\\.\\d+|\\d*)"
]))));
var UNIT_REGEX = new RegExp("".concat(UNIT_PX, "|").concat(UNIT_EM, "|").concat(UNIT_REM));
function getUnit() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var unit = value.match(new RegExp("".concat(DIGIT_REGEX.source, "(").concat(UNIT_REGEX.source, ")")));
    return unit && unit[1];
}
function toPx() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var unit = getUnit(value);
    if (!unit) return value;
    if (unit === UNIT_PX) return value;
    if (unit === UNIT_EM || unit === UNIT_REM) return "".concat(parseFloat(value) * BASE_FONT_SIZE).concat(UNIT_PX);
}
function toEm() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BASE_FONT_SIZE;
    var unit = getUnit(value);
    if (!unit) return value;
    if (unit === UNIT_EM) return value;
    if (unit === UNIT_PX) return "".concat(parseFloat(value) / fontSize).concat(UNIT_EM);
    if (unit === UNIT_REM) return "".concat(parseFloat(value) * BASE_FONT_SIZE / fontSize).concat(UNIT_EM);
}
function toRem() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var unit = getUnit(value);
    if (!unit) return value;
    if (unit === UNIT_REM) return value;
    if (unit === UNIT_EM) return "".concat(parseFloat(value)).concat(UNIT_REM);
    if (unit === UNIT_PX) return "".concat(parseFloat(value) / BASE_FONT_SIZE).concat(UNIT_REM);
}
function rem(value) {
    return value.replace(new RegExp("".concat(DIGIT_REGEX.source, "(").concat(UNIT_PX, ")"), "g"), function(px) {
        var _toRem;
        return (_toRem = toRem(px)) !== null && _toRem !== void 0 ? _toRem : px;
    });
}
function tokensToRems(tokenGroup) {
    return Object.fromEntries(Object.entries(tokenGroup).map(function(_ref) {
        var _ref2 = (0, _rollupPluginBabelHelpersMjs.slicedToArray)(_ref, 2), token = _ref2[0], properties = _ref2[1];
        return [
            token,
            (0, _rollupPluginBabelHelpersMjs.objectSpread2)((0, _rollupPluginBabelHelpersMjs.objectSpread2)({}, properties), {}, {
                value: rem(properties.value)
            })
        ];
    }) // We loose the `tokenGroup` inference after transforming the object with
    );
}
function createVar(token) {
    return "--p-".concat(token);
}
/**
 * Allowed Polaris keyframes.
 *
 * Result: ['p-keyframes-fade-in', 'p-keyframes-spin', etc...]
 */ function getKeyframeNames(motionTokenGroup) {
    return Object.keys(motionTokenGroup).map(function(token) {
        return token.startsWith("keyframes") ? "p-".concat(token) : null;
    }).filter(Boolean);
}
/**
 * Allowed Polaris token custom properties.
 *
 * Result: ['--p-background', '--p-text', etc...]
 */ function getCustomPropertyNames(tokens) {
    return Object.entries(tokens).map(function(_ref3) {
        var _ref4 = (0, _rollupPluginBabelHelpersMjs.slicedToArray)(_ref3, 2);
        _ref4[0];
        var tokenGroup = _ref4[1];
        return Object.keys(tokenGroup).map(function(token) {
            return createVar(token);
        });
    }).flat();
}
function removeMetadata(tokenGroup) {
    return Object.fromEntries(Object.entries(tokenGroup).map(function(entry) {
        var _ref5 = entry, _ref6 = (0, _rollupPluginBabelHelpersMjs.slicedToArray)(_ref5, 2), tokenName = _ref6[0], value = _ref6[1].value;
        return [
            tokenName,
            value
        ];
    }));
}
function getMediaConditions(breakpoints) {
    var breakpointEntries = Object.entries(breakpoints);
    var lastBreakpointIndex = breakpointEntries.length - 1;
    return Object.fromEntries(breakpointEntries.map(function(entry, index) {
        var _ref7 = entry, _ref8 = (0, _rollupPluginBabelHelpersMjs.slicedToArray)(_ref7, 2), breakpointsTokenName = _ref8[0], breakpoint = _ref8[1];
        var upMediaCondition = getUpMediaCondition(breakpoint);
        var downMediaCondition = getDownMediaCondition(breakpoint);
        var onlyMediaCondition = index === lastBreakpointIndex ? upMediaCondition : "".concat(upMediaCondition, " and ").concat(getDownMediaCondition(breakpointEntries[index + 1][1]));
        return [
            breakpointsTokenName,
            {
                // Media condition for the current breakpoint and up
                up: upMediaCondition,
                // Media condition for current breakpoint and down
                down: downMediaCondition,
                // Media condition for only the current breakpoint
                only: onlyMediaCondition
            }
        ];
    }));
}
function getUpMediaCondition(breakpoint) {
    return "(min-width: ".concat(toEm(breakpoint), ")");
}
/**
 * Down media condition breakpoints are being subtracted by 0.04px to prevent
 * them from overwriting up media queries. We experimented with multiple offsets
 * and felt that 0.04px would be the safest across different pixel densities,
 * while being representable in ems with 4 decimal places of precision.
 */ function getDownMediaCondition(breakpoint) {
    var _toPx;
    var offsetBreakpoint = parseFloat((_toPx = toPx(breakpoint)) !== null && _toPx !== void 0 ? _toPx : "") - 0.04;
    return "(max-width: ".concat(toEm("".concat(offsetBreakpoint, "px")), ")");
}
function isKeyOf(obj, key) {
    return Object.keys(obj).includes(key);
}

},{"../_virtual/_rollupPluginBabelHelpers.mjs":"014Ew","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"014Ew":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayLikeToArray", ()=>_arrayLikeToArray);
parcelHelpers.export(exports, "arrayWithHoles", ()=>_arrayWithHoles);
parcelHelpers.export(exports, "defineProperty", ()=>_defineProperty);
parcelHelpers.export(exports, "iterableToArrayLimit", ()=>_iterableToArrayLimit);
parcelHelpers.export(exports, "nonIterableRest", ()=>_nonIterableRest);
parcelHelpers.export(exports, "objectSpread2", ()=>_objectSpread2);
parcelHelpers.export(exports, "slicedToArray", ()=>_slicedToArray);
parcelHelpers.export(exports, "taggedTemplateLiteral", ()=>_taggedTemplateLiteral);
parcelHelpers.export(exports, "unsupportedIterableToArray", ()=>_unsupportedIterableToArray);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aykUa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpoints", ()=>breakpoints);
var breakpoints = {
    "breakpoints-xs": {
        value: "0px",
        description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
    },
    "breakpoints-sm": {
        value: "490px",
        description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
    },
    "breakpoints-md": {
        value: "768px",
        description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
    },
    "breakpoints-lg": {
        value: "1040px",
        description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
    },
    "breakpoints-xl": {
        value: "1440px",
        description: "Commonly used for sizing containers (e.g. max-width). See below for media query usage."
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dNL72":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "border", ()=>border);
var border = {
    "border-radius-05": {
        value: "2px"
    },
    "border-radius-1": {
        value: "4px"
    },
    "border-radius-2": {
        value: "8px"
    },
    "border-radius-3": {
        value: "12px"
    },
    "border-radius-4": {
        value: "16px"
    },
    "border-radius-5": {
        value: "20px"
    },
    "border-radius-6": {
        value: "30px"
    },
    "border-radius-full": {
        value: "9999px"
    },
    "border-width-1": {
        value: "1px"
    },
    "border-width-2": {
        value: "2px"
    },
    "border-width-3": {
        value: "3px"
    },
    "border-width-4": {
        value: "4px"
    },
    "border-width-5": {
        value: "5px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4IBwQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "depth", ()=>depth);
var depth = {
    "shadow-transparent": {
        value: "0 0 0 0 transparent"
    },
    "shadow-faint": {
        value: "0 1px 0 0 rgba(22, 29, 37, 0.05)"
    },
    "shadow-base": {
        value: "0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15)"
    },
    "shadow-deep": {
        value: "0 0 0 1px rgba(6, 44, 82, 0.1), 0 2px 16px rgba(33, 43, 54, 0.08)"
    },
    "shadow-button": {
        value: "0 1px 0 rgba(0, 0, 0, 0.05)"
    },
    "shadow-top-bar": {
        value: "0 2px 2px -1px rgba(0, 0, 0, 0.15)"
    },
    "shadow-card": {
        value: "0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.15)"
    },
    "shadow-popover": {
        value: "0 3px 6px -3px rgba(23, 24, 24, 0.08), 0 8px 20px -4px rgba(23, 24, 24, 0.12)"
    },
    "shadow-layer": {
        value: "0 31px 41px 0 rgba(32, 42, 53, 0.2), 0 2px 16px 0 rgba(32, 42, 54, 0.08)"
    },
    "shadow-modal": {
        value: "0 26px 80px rgba(0, 0, 0, 0.2), 0 0px 1px rgba(0, 0, 0, 0.2)"
    },
    "shadows-inset-button": {
        value: "inset 0 -1px 0 rgba(0, 0, 0, 0.2)"
    },
    "shadows-inset-button-pressed": {
        value: "inset 0 1px 0 rgba(0, 0, 0, 0.15)"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jrpe9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "font", ()=>font);
var font = {
    "font-family-sans": {
        value: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif"
    },
    "font-family-mono": {
        value: "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace"
    },
    "font-size-75": {
        value: "12px"
    },
    "font-size-100": {
        value: "14px"
    },
    "font-size-200": {
        value: "16px"
    },
    "font-size-300": {
        value: "20px"
    },
    "font-size-400": {
        value: "24px"
    },
    "font-size-500": {
        value: "28px"
    },
    "font-size-600": {
        value: "32px"
    },
    "font-size-700": {
        value: "40px"
    },
    "font-weight-regular": {
        value: "400"
    },
    "font-weight-medium": {
        value: "500"
    },
    "font-weight-semibold": {
        value: "600"
    },
    "font-weight-bold": {
        value: "700"
    },
    "font-line-height-1": {
        value: "16px"
    },
    "font-line-height-2": {
        value: "20px"
    },
    "font-line-height-3": {
        value: "24px"
    },
    "font-line-height-4": {
        value: "28px"
    },
    "font-line-height-5": {
        value: "32px"
    },
    "font-line-height-6": {
        value: "40px"
    },
    "font-line-height-7": {
        value: "48px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dUq4R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "legacy", ()=>legacy);
var legacy = {
    "override-loading-z-index": {
        value: "514"
    },
    "choice-size": {
        value: "20px"
    },
    "icon-size-small": {
        value: "8px"
    },
    "icon-size-medium": {
        value: "20px"
    },
    "choice-margin": {
        value: "1px"
    },
    "control-border-width": {
        value: "2px"
    },
    "banner-border-default": {
        value: "inset 0 1px 0 0 var(--p-color-border-strong), inset 0 0 0 1px var(--p-color-border-strong)"
    },
    "banner-border-success": {
        value: "inset 0 1px 0 0 var(--p-color-border-success-subdued), inset 0 0 0 1px var(--p-color-border-success-subdued)"
    },
    "banner-border-highlight": {
        value: "inset 0 1px 0 0 var(--p-color-border-info-subdued), inset 0 0 0 1px var(--p-color-border-info-subdued)"
    },
    "banner-border-warning": {
        value: "inset 0 1px 0 0 var(--p-color-border-caution-subdued), inset 0 0 0 1px var(--p-color-border-caution-subdued)"
    },
    "banner-border-critical": {
        value: "inset 0 1px 0 0 var(--p-color-border-critical-subdued), inset 0 0 0 1px var(--p-color-border-critical-subdued)"
    },
    "thin-border-subdued": {
        value: "1px solid var(--p-color-border-subdued)"
    },
    "text-field-spinner-offset": {
        value: "2px"
    },
    "text-field-focus-ring-offset": {
        value: "-4px"
    },
    "button-group-item-spacing": {
        value: "-1px"
    },
    "range-slider-thumb-size-base": {
        value: "16px"
    },
    "range-slider-thumb-size-active": {
        value: "24px"
    },
    "frame-offset": {
        value: "0px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fNaSv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>color);
var _colorsMjs = require("../colors.mjs");
var color = {
    "color-bg-inverse": {
        value: (0, _colorsMjs.gray)[900],
        description: ""
    },
    "color-bg-inset-strong": {
        value: (0, _colorsMjs.gray)[800],
        description: ""
    },
    "color-bg-inverse-hover": {
        value: (0, _colorsMjs.gray)[800],
        description: ""
    },
    "color-bg-inverse-active": {
        value: (0, _colorsMjs.gray)[700],
        description: ""
    },
    "color-bg-strong-hover": {
        value: (0, _colorsMjs.gray)[500],
        description: ""
    },
    "color-bg-strong-active": {
        value: (0, _colorsMjs.gray)[500],
        description: ""
    },
    "color-bg-strong": {
        value: (0, _colorsMjs.gray)[400],
        description: ""
    },
    "color-bg-subdued-active": {
        value: (0, _colorsMjs.gray)[300],
        description: ""
    },
    "color-bg-disabled": {
        value: (0, _colorsMjs.gray)[300],
        description: ""
    },
    "color-bg-interactive-disabled": {
        value: (0, _colorsMjs.gray)[300],
        description: ""
    },
    "color-bg-app": {
        value: (0, _colorsMjs.gray)[200],
        description: ""
    },
    "color-bg-app-active": {
        value: (0, _colorsMjs.gray)[400],
        description: ""
    },
    "color-bg-app-hover": {
        value: (0, _colorsMjs.gray)[300],
        description: ""
    },
    "color-bg-app-selected": {
        value: (0, _colorsMjs.gray)[300],
        description: ""
    },
    "color-bg-active": {
        value: (0, _colorsMjs.gray)[300],
        description: ""
    },
    "color-bg-subdued-hover": {
        value: (0, _colorsMjs.gray)[200],
        description: ""
    },
    "color-bg-inset": {
        value: (0, _colorsMjs.gray)[200],
        description: ""
    },
    "color-bg-hover": {
        value: (0, _colorsMjs.gray)[200],
        description: ""
    },
    "color-bg-subdued": {
        value: (0, _colorsMjs.gray)[100],
        description: ""
    },
    "color-bg-input": {
        value: (0, _colorsMjs.gray)[50],
        description: ""
    },
    "color-bg": {
        value: (0, _colorsMjs.gray)[50],
        description: ""
    },
    "color-bg-primary-active": {
        value: (0, _colorsMjs.green)[900],
        description: ""
    },
    "color-bg-primary-hover": {
        value: (0, _colorsMjs.green)[800],
        description: ""
    },
    "color-bg-primary": {
        value: (0, _colorsMjs.green)[700],
        description: ""
    },
    "color-bg-success-strong": {
        value: (0, _colorsMjs.green)[600],
        description: ""
    },
    "color-bg-success": {
        value: (0, _colorsMjs.green)[300],
        description: ""
    },
    "color-bg-primary-subdued-active": {
        value: (0, _colorsMjs.green)[200],
        description: ""
    },
    "color-bg-success-subdued-active": {
        value: (0, _colorsMjs.green)[200],
        description: ""
    },
    "color-bg-success-subdued": {
        value: (0, _colorsMjs.green)[100],
        description: ""
    },
    "color-bg-primary-subdued-hover": {
        value: (0, _colorsMjs.green)[100],
        description: ""
    },
    "color-bg-success-subdued-hover": {
        value: (0, _colorsMjs.green)[50],
        description: ""
    },
    "color-bg-primary-subdued": {
        value: (0, _colorsMjs.green)[50],
        description: ""
    },
    "color-bg-primary-subdued-selected": {
        value: (0, _colorsMjs.green)[50],
        description: ""
    },
    "color-bg-critical-strong-active": {
        value: (0, _colorsMjs.red)[800],
        description: ""
    },
    "color-bg-critical-strong-hover": {
        value: (0, _colorsMjs.red)[700],
        description: ""
    },
    "color-bg-critical-strong": {
        value: (0, _colorsMjs.red)[600],
        description: ""
    },
    "color-bg-critical-subdued-active": {
        value: (0, _colorsMjs.red)[200],
        description: ""
    },
    "color-bg-critical": {
        value: (0, _colorsMjs.red)[200],
        description: ""
    },
    "color-bg-critical-subdued": {
        value: (0, _colorsMjs.red)[100],
        description: ""
    },
    "color-bg-critical-subdued-hover": {
        value: (0, _colorsMjs.red)[50],
        description: ""
    },
    "color-bg-caution-strong": {
        value: (0, _colorsMjs.yellow)[600],
        description: ""
    },
    "color-bg-caution": {
        value: (0, _colorsMjs.yellow)[300],
        description: ""
    },
    "color-bg-caution-subdued-active": {
        value: (0, _colorsMjs.yellow)[200],
        description: ""
    },
    "color-bg-caution-subdued": {
        value: (0, _colorsMjs.yellow)[100],
        description: ""
    },
    "color-bg-caution-subdued-hover": {
        value: (0, _colorsMjs.yellow)[50],
        description: ""
    },
    "color-bg-info-strong": {
        value: (0, _colorsMjs.teal)[600],
        description: ""
    },
    "color-bg-info-subdued-active": {
        value: (0, _colorsMjs.teal)[200],
        description: ""
    },
    "color-bg-info": {
        value: (0, _colorsMjs.teal)[200],
        description: ""
    },
    "color-bg-info-subdued": {
        value: (0, _colorsMjs.teal)[100],
        description: ""
    },
    "color-bg-info-subdued-hover": {
        value: (0, _colorsMjs.teal)[50],
        description: ""
    },
    "color-bg-interactive-active": {
        value: (0, _colorsMjs.blue)[800],
        description: ""
    },
    "color-bg-interactive-hover": {
        value: (0, _colorsMjs.blue)[700],
        description: ""
    },
    "color-bg-interactive": {
        value: (0, _colorsMjs.blue)[600],
        description: ""
    },
    "color-bg-interactive-subdued-active": {
        value: (0, _colorsMjs.blue)[200],
        description: ""
    },
    "color-bg-interactive-subdued-hover": {
        value: (0, _colorsMjs.blue)[100],
        description: ""
    },
    "color-bg-interactive-subdued": {
        value: (0, _colorsMjs.blue)[50],
        description: ""
    },
    "color-bg-interactive-selected": {
        value: (0, _colorsMjs.blue)[50],
        description: ""
    },
    "color-bg-warning": {
        value: (0, _colorsMjs.orange)[200],
        description: ""
    },
    "color-bg-magic-strong": {
        value: (0, _colorsMjs.purple)[500],
        description: ""
    },
    "color-bg-magic-hover": {
        value: (0, _colorsMjs.purple)[200],
        description: ""
    },
    "color-bg-magic-active": {
        value: (0, _colorsMjs.purple)[300],
        description: ""
    },
    "color-bg-magic": {
        value: (0, _colorsMjs.purple)[100],
        description: ""
    },
    "color-bg-magic-subdued-hover": {
        value: (0, _colorsMjs.purple)[100],
        description: ""
    },
    "color-bg-magic-subdued-active": {
        value: (0, _colorsMjs.purple)[200],
        description: ""
    },
    "color-bg-magic-subdued": {
        value: (0, _colorsMjs.purple)[50],
        description: ""
    },
    "color-border-input-hover": {
        value: (0, _colorsMjs.gray)[800],
        description: ""
    },
    "color-border-inverse": {
        value: (0, _colorsMjs.gray)[800],
        description: ""
    },
    "color-border-strong-hover": {
        value: (0, _colorsMjs.gray)[700],
        description: ""
    },
    "color-border-input": {
        value: (0, _colorsMjs.gray)[600],
        description: ""
    },
    "color-border-hover": {
        value: (0, _colorsMjs.gray)[600],
        description: ""
    },
    "color-border-strong": {
        value: (0, _colorsMjs.gray)[600],
        description: ""
    },
    "color-border": {
        value: (0, _colorsMjs.gray)[500],
        description: ""
    },
    "color-border-disabled": {
        value: (0, _colorsMjs.gray)[400],
        description: ""
    },
    "color-border-subdued": {
        value: (0, _colorsMjs.gray)[400],
        description: ""
    },
    "color-border-interactive-disabled": {
        value: (0, _colorsMjs.gray)[400],
        description: ""
    },
    "color-border-primary": {
        value: (0, _colorsMjs.green)[700],
        description: ""
    },
    "color-border-success": {
        value: (0, _colorsMjs.green)[600],
        description: ""
    },
    "color-border-success-subdued": {
        value: (0, _colorsMjs.green)[400],
        description: ""
    },
    "color-border-critical-active": {
        value: (0, _colorsMjs.red)[900],
        description: ""
    },
    "color-border-critical-hover": {
        value: (0, _colorsMjs.red)[800],
        description: ""
    },
    "color-border-critical": {
        value: (0, _colorsMjs.red)[600],
        description: ""
    },
    "color-border-critical-subdued": {
        value: (0, _colorsMjs.red)[400],
        description: ""
    },
    "color-border-caution": {
        value: (0, _colorsMjs.yellow)[600],
        description: ""
    },
    "color-border-caution-subdued": {
        value: (0, _colorsMjs.yellow)[400],
        description: ""
    },
    "color-border-info": {
        value: (0, _colorsMjs.teal)[500],
        description: ""
    },
    "color-border-info-subdued": {
        value: (0, _colorsMjs.teal)[400],
        description: ""
    },
    "color-border-interactive-active": {
        value: (0, _colorsMjs.blue)[800],
        description: ""
    },
    "color-border-interactive-hover": {
        value: (0, _colorsMjs.blue)[700],
        description: ""
    },
    "color-border-interactive": {
        value: (0, _colorsMjs.blue)[500],
        description: ""
    },
    "color-border-interactive-focus": {
        value: (0, _colorsMjs.blue)[500],
        description: ""
    },
    "color-border-interactive-subdued": {
        value: (0, _colorsMjs.blue)[200],
        description: ""
    },
    "color-border-magic-strong": {
        value: (0, _colorsMjs.purple)[500],
        description: ""
    },
    "color-border-magic": {
        value: (0, _colorsMjs.purple)[400],
        description: ""
    },
    "color-icon-hover": {
        value: (0, _colorsMjs.gray)[900],
        description: ""
    },
    "color-icon": {
        value: (0, _colorsMjs.gray)[800],
        description: ""
    },
    "color-icon-active": {
        value: (0, _colorsMjs.gray)[900],
        description: ""
    },
    "color-icon-subdued": {
        value: (0, _colorsMjs.gray)[700],
        description: ""
    },
    "color-icon-disabled": {
        value: (0, _colorsMjs.gray)[600],
        description: ""
    },
    "color-icon-interactive-disabled": {
        value: (0, _colorsMjs.gray)[600],
        description: ""
    },
    "color-icon-inverse": {
        value: (0, _colorsMjs.gray)[400],
        description: ""
    },
    "color-icon-on-color": {
        value: (0, _colorsMjs.gray)[50],
        description: ""
    },
    "color-icon-primary": {
        value: (0, _colorsMjs.green)[700],
        description: ""
    },
    "color-icon-success": {
        value: (0, _colorsMjs.green)[600],
        description: ""
    },
    "color-icon-critical": {
        value: (0, _colorsMjs.red)[600],
        description: ""
    },
    "color-icon-caution": {
        value: (0, _colorsMjs.yellow)[700],
        description: ""
    },
    "color-icon-info": {
        value: (0, _colorsMjs.teal)[600],
        description: ""
    },
    "color-icon-warning": {
        value: (0, _colorsMjs.orange)[500],
        description: ""
    },
    "color-icon-interactive-active": {
        value: (0, _colorsMjs.blue)[800],
        description: ""
    },
    "color-icon-interactive-hover": {
        value: (0, _colorsMjs.blue)[700],
        description: ""
    },
    "color-icon-interactive": {
        value: (0, _colorsMjs.blue)[600],
        description: ""
    },
    "color-icon-interactive-inverse": {
        value: (0, _colorsMjs.blue)[400],
        description: ""
    },
    "color-icon-magic": {
        value: (0, _colorsMjs.purple)[500],
        description: ""
    },
    "color-text": {
        value: (0, _colorsMjs.gray)[900],
        description: ""
    },
    "color-text-subdued": {
        value: (0, _colorsMjs.gray)[800],
        description: ""
    },
    "color-text-disabled": {
        value: (0, _colorsMjs.gray)[700],
        description: ""
    },
    "color-text-interactive-disabled": {
        value: (0, _colorsMjs.gray)[700],
        description: ""
    },
    "color-text-inverse-subdued": {
        value: (0, _colorsMjs.gray)[600],
        description: ""
    },
    "color-text-inverse": {
        value: (0, _colorsMjs.gray)[200],
        description: ""
    },
    "color-text-on-color": {
        value: (0, _colorsMjs.gray)[50],
        description: ""
    },
    "color-text-success-strong": {
        value: (0, _colorsMjs.green)[900],
        description: ""
    },
    "color-text-success": {
        value: (0, _colorsMjs.green)[700],
        description: ""
    },
    "color-text-primary": {
        value: (0, _colorsMjs.green)[700],
        description: ""
    },
    "color-text-primary-hover": {
        value: (0, _colorsMjs.green)[800],
        description: ""
    },
    "color-text-critical-strong": {
        value: (0, _colorsMjs.red)[900],
        description: ""
    },
    "color-text-critical-active": {
        value: (0, _colorsMjs.red)[800],
        description: ""
    },
    "color-text-critical": {
        value: (0, _colorsMjs.red)[600],
        description: ""
    },
    "color-text-caution-strong": {
        value: (0, _colorsMjs.yellow)[900],
        description: ""
    },
    "color-text-caution": {
        value: (0, _colorsMjs.yellow)[800],
        description: ""
    },
    "color-text-info-strong": {
        value: (0, _colorsMjs.teal)[900],
        description: ""
    },
    "color-text-info": {
        value: (0, _colorsMjs.teal)[700],
        description: ""
    },
    "color-text-warning-strong": {
        value: (0, _colorsMjs.orange)[900],
        description: ""
    },
    "color-text-interactive-active": {
        value: (0, _colorsMjs.blue)[800],
        description: ""
    },
    "color-text-interactive-hover": {
        value: (0, _colorsMjs.blue)[700],
        description: ""
    },
    "color-text-interactive": {
        value: (0, _colorsMjs.blue)[600],
        description: ""
    },
    "color-text-interactive-inverse": {
        value: (0, _colorsMjs.blue)[400],
        description: ""
    },
    "color-text-magic-strong": {
        value: (0, _colorsMjs.purple)[800],
        description: ""
    },
    "color-text-magic": {
        value: (0, _colorsMjs.purple)[600],
        description: ""
    }
};

},{"../colors.mjs":"jMEi4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jMEi4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blue", ()=>blue);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "green", ()=>green);
parcelHelpers.export(exports, "orange", ()=>orange);
parcelHelpers.export(exports, "purple", ()=>purple);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "teal", ()=>teal);
parcelHelpers.export(exports, "yellow", ()=>yellow);
var gray = {
    50: "rgba(255, 255, 255, 1)",
    100: "rgba(249, 250, 251, 1)",
    200: "rgba(241, 242, 244, 1)",
    300: "rgba(235, 236, 239, 1)",
    400: "rgba(221, 224, 228, 1)",
    500: "rgba(202, 206, 211, 1)",
    600: "rgba(171, 177, 186, 1)",
    700: "rgba(135, 144, 155, 1)",
    800: "rgba(97, 106, 117, 1)",
    900: "rgba(31, 33, 36, 1)"
};
var green = {
    50: "rgba(240, 253, 248, 1)",
    100: "rgba(224, 248, 238, 1)",
    200: "rgba(192, 242, 221, 1)",
    300: "rgba(161, 237, 208, 1)",
    400: "rgba(80, 220, 169, 1)",
    500: "rgba(35, 196, 140, 1)",
    600: "rgba(22, 166, 121, 1)",
    700: "rgba(0, 122, 92, 1)",
    800: "rgba(18, 84, 67, 1)",
    900: "rgba(12, 59, 47, 1)"
};
var blue = {
    50: "rgba(240, 245, 253, 1)",
    100: "rgba(232, 240, 253, 1)",
    200: "rgba(187, 212, 247, 1)",
    300: "rgba(147, 186, 241, 1)",
    400: "rgba(102, 153, 225, 1)",
    500: "rgba(62, 125, 213, 1)",
    600: "rgba(36, 99, 188, 1)",
    700: "rgba(20, 73, 149, 1)",
    800: "rgba(14, 53, 108, 1)",
    900: "rgba(16, 41, 76, 1)"
};
var red = {
    50: "rgba(254, 243, 241, 1)",
    100: "rgba(253, 226, 221, 1)",
    200: "rgba(251, 197, 188, 1)",
    300: "rgba(247, 148, 130, 1)",
    400: "rgba(245, 107, 82, 1)",
    500: "rgba(242, 65, 34, 1)",
    600: "rgba(197, 40, 12, 1)",
    700: "rgba(159, 32, 10, 1)",
    800: "rgba(115, 24, 7, 1)",
    900: "rgba(67, 14, 4, 1)"
};
var yellow = {
    50: "rgba(254, 248, 236, 1)",
    100: "rgba(252, 240, 212, 1)",
    200: "rgba(250, 229, 178, 1)",
    300: "rgba(248, 217, 144, 1)",
    400: "rgba(245, 196, 82, 1)",
    500: "rgba(242, 179, 34, 1)",
    600: "rgba(216, 155, 13, 1)",
    700: "rgba(183, 126, 11, 1)",
    800: "rgba(135, 92, 8, 1)",
    900: "rgba(77, 46, 5, 1)"
};
var teal = {
    50: "rgba(238, 250, 251, 1)",
    100: "rgba(222, 245, 247, 1)",
    200: "rgba(184, 233, 239, 1)",
    300: "rgba(147, 222, 231, 1)",
    400: "rgba(109, 211, 222, 1)",
    500: "rgba(59, 195, 211, 1)",
    600: "rgba(42, 172, 187, 1)",
    700: "rgba(32, 130, 141, 1)",
    800: "rgba(23, 92, 100, 1)",
    900: "rgba(16, 65, 71, 1)"
};
var orange = {
    50: "rgba(254, 243, 236, 1)",
    100: "rgba(253, 231, 217, 1)",
    200: "rgba(250, 201, 168, 1)",
    300: "rgba(247, 177, 130, 1)",
    400: "rgba(245, 147, 82, 1)",
    500: "rgba(242, 117, 34, 1)",
    600: "rgba(216, 101, 13, 1)",
    700: "rgba(164, 76, 10, 1)",
    800: "rgba(111, 52, 7, 1)",
    900: "rgba(77, 36, 5, 1)"
};
var purple = {
    50: "rgba(242, 237, 253, 1)",
    100: "rgba(236, 227, 253, 1)",
    200: "rgba(226, 214, 250, 1)",
    300: "rgba(203, 180, 248, 1)",
    400: "rgba(173, 139, 241, 1)",
    500: "rgba(121, 69, 227, 1)",
    600: "rgba(90, 36, 205, 1)",
    700: "rgba(67, 21, 158, 1)",
    800: "rgba(49, 13, 120, 1)",
    900: "rgba(36, 8, 73, 1)"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dXAkK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colors", ()=>colors);
var colors = {
    background: {
        value: "rgba(246, 246, 247, 1)",
        description: "For use as a background color, in components such as Page and Frame backgrounds."
    },
    "background-hovered": {
        value: "rgba(241, 242, 243, 1)",
        description: "For use when an action or navigation is used on a background."
    },
    "background-pressed": {
        value: "rgba(237, 238, 239, 1)",
        description: "For use when an action or navigation is used on a background."
    },
    "background-selected": {
        value: "rgba(237, 238, 239, 1)",
        description: "For use in the selected item in navigation"
    },
    surface: {
        value: "rgba(255, 255, 255, 1)",
        description: "For use as a background color, in components such as Card, Modal, and Popover."
    },
    "surface-dark": {
        value: "rgba(32, 33, 35, 1)",
        description: "For use as a dark background color, in components such as Card, Modal, and Popover."
    },
    "surface-neutral": {
        value: "rgba(228, 229, 231, 1)",
        description: "For use as a background color in neutral badges."
    },
    "surface-neutral-hovered": {
        value: "rgba(219, 221, 223, 1)",
        description: "For use as a hovered background color in neutral badges."
    },
    "surface-neutral-pressed": {
        value: "rgba(201, 204, 208, 1)",
        description: "For use as a pressed background color in neutral badges."
    },
    "surface-neutral-disabled": {
        value: "rgba(241, 242, 243, 1)",
        description: "For use as a disabled background color in neutral badges."
    },
    "surface-neutral-subdued": {
        value: "rgba(246, 246, 247, 1)",
        description: "For use as a background color in neutral banners."
    },
    "surface-neutral-subdued-dark": {
        value: "rgba(68, 71, 74, 1)",
        description: "For use as a dark background color in neutral banners."
    },
    "surface-subdued": {
        value: "rgba(250, 251, 251, 1)",
        description: "For use as a subdued background color, in components such as Card, Modal, and Popover."
    },
    "surface-disabled": {
        value: "rgba(250, 251, 251, 1)",
        description: "For use as a surface color on disabled interactive elements such as option list items and action list items when in a disabled state."
    },
    "surface-hovered": {
        value: "rgba(246, 246, 247, 1)",
        description: "For use as a surface color on interactive elements such as resource list items and action list items when in a hovered state."
    },
    "surface-hovered-dark": {
        value: "rgba(47, 49, 51, 1)",
        description: "For use as a dark surface color on interactive elements such as resource list items and action list items when in a hovered state."
    },
    "surface-pressed": {
        value: "rgba(241, 242, 243, 1)",
        description: "For use as a surface color on interactive elements such as resource list items and action list items when in a pressed state."
    },
    "surface-pressed-dark": {
        value: "rgba(62, 64, 67, 1)",
        description: "For use as a dark surface color on interactive elements such as resource list items and action list items when in a pressed state."
    },
    "surface-depressed": {
        value: "rgba(237, 238, 239, 1)",
        description: "For use as a surface color on interactive elements such as resource list items and action list items when in a depressed state."
    },
    "surface-search-field": {
        value: "rgba(241, 242, 243, 1)",
        description: "For use as a background color, in components on surface elements such as SearchField"
    },
    "surface-search-field-dark": {
        value: "rgba(47, 49, 51, 1)",
        description: "For use as a dark background color, in components on surface elements such as SearchField"
    },
    backdrop: {
        value: "rgba(0, 0, 0, 0.5)",
        description: "For use as the background color of the backdrop component for navigation and modal. This color has an alpha of `0.5`."
    },
    overlay: {
        value: "rgba(255, 255, 255, 0.5)",
        description: "For use as the background color of elements which lay on top of surfaces to obscure their contents. This color has an alpha of `0.5`."
    },
    "shadow-color-picker": {
        value: "rgba(0, 0, 0, 0.5)"
    },
    "shadow-color-picker-dragger": {
        value: "rgba(33, 43, 54, 0.32)"
    },
    "hint-from-direct-light": {
        value: "rgba(0, 0, 0, 0.15)",
        description: "For use in building shadows scrollables."
    },
    border: {
        value: "rgba(140, 145, 150, 1)",
        description: "For use as the default border on elements."
    },
    "border-on-dark": {
        value: "rgba(80, 83, 86, 1)",
        description: "For use as the default border on dark elements."
    },
    "border-neutral-subdued": {
        value: "rgba(186, 191, 195, 1)",
        description: "For use as the border on banners."
    },
    "border-hovered": {
        value: "rgba(153, 158, 164, 1)",
        description: "Used for borders on hovered interactive elements"
    },
    "border-disabled": {
        value: "rgba(210, 213, 216, 1)",
        description: "Used for disabled borders on interactive elements"
    },
    "border-subdued": {
        value: "rgba(201, 204, 207, 1)",
        description: "For use as a subdued border on elements."
    },
    "border-depressed": {
        value: "rgba(87, 89, 89, 1)",
        description: "For use as a border on depressed elements."
    },
    "border-shadow": {
        value: "rgba(174, 180, 185, 1)",
        description: "For use as an additional bottom border on elements."
    },
    "border-shadow-subdued": {
        value: "rgba(186, 191, 196, 1)",
        description: "For use as an additional, subdued bottom border on elements."
    },
    divider: {
        value: "rgba(225, 227, 229, 1)",
        description: "For use as a divider between elements."
    },
    "divider-dark": {
        value: "rgba(69, 71, 73, 1)",
        description: "For use as a dark divider between elements."
    },
    icon: {
        value: "rgba(92, 95, 98, 1)",
        description: "For use as the fill color of icons."
    },
    "icon-on-dark": {
        value: "rgba(166, 172, 178, 1)",
        description: "For use as the fill color of dark icons."
    },
    "icon-hovered": {
        value: "rgba(26, 28, 29, 1)",
        description: "For use as the fill color of hovered icons."
    },
    "icon-pressed": {
        value: "rgba(68, 71, 74, 1)",
        description: "For use as the fill color of pressed icons."
    },
    "icon-disabled": {
        value: "rgba(186, 190, 195, 1)",
        description: "For use as the fill color of disabled icons."
    },
    "icon-subdued": {
        value: "rgba(140, 145, 150, 1)",
        description: "For use as the fill color of subdued icons."
    },
    text: {
        value: "rgba(32, 34, 35, 1)",
        description: "For use as a text color."
    },
    "text-on-dark": {
        value: "rgba(227, 229, 231, 1)",
        description: "For use as a text color on dark elements."
    },
    "text-disabled": {
        value: "rgba(140, 145, 150, 1)",
        description: "For use as a disabled text color and as a placeholder text color."
    },
    "text-subdued": {
        value: "rgba(109, 113, 117, 1)",
        description: "For use as a subdued text color."
    },
    "text-subdued-on-dark": {
        value: "rgba(153, 159, 164, 1)",
        description: "For use as a subdued text color on dark elements."
    },
    interactive: {
        value: "rgba(44, 110, 203, 1)",
        description: "Used for links, plain buttons, and as the fill color for selected checkboxes and radio buttons."
    },
    "interactive-on-dark": {
        value: "rgba(54, 163, 255, 1)",
        description: "Used for links, plain buttons, and as the fill color for selected checkboxes and radio buttons when on a dark element."
    },
    "interactive-disabled": {
        value: "rgba(189, 193, 204, 1)",
        description: "Used for disabled links and plain buttons."
    },
    "interactive-hovered": {
        value: "rgba(31, 81, 153, 1)",
        description: "Used for hovered links and plain buttons."
    },
    "interactive-pressed": {
        value: "rgba(16, 50, 98, 1)",
        description: "Used for pressed links and plain buttons."
    },
    "interactive-pressed-on-dark": {
        value: "rgba(136, 188, 255, 1)",
        description: "Used for pressed links and plain buttons on dark elements."
    },
    focused: {
        value: "rgba(69, 143, 255, 1)",
        description: "For use in the focus ring on interactive elements."
    },
    "surface-selected": {
        value: "rgba(242, 247, 254, 1)",
        description: "For use as a surface color in selected interactive elements, in components such as action list and resource list."
    },
    "surface-selected-hovered": {
        value: "rgba(237, 244, 254, 1)",
        description: "For use as a surface color in selected interactive elements that are hovered, in components such as action list and resource list."
    },
    "surface-selected-pressed": {
        value: "rgba(229, 239, 253, 1)",
        description: "For use as a surface color in selected interactive elements that are pressed, in components such as action list and resource list."
    },
    "icon-on-interactive": {
        value: "rgba(255, 255, 255, 1)",
        description: "For use as a fill color for icons on interactive elements."
    },
    "text-on-interactive": {
        value: "rgba(255, 255, 255, 1)",
        description: "For use as a text color on interactive elements."
    },
    "action-secondary": {
        value: "rgba(255, 255, 255, 1)",
        description: "Used for secondary buttons and tertiary buttons, as well as in form elements as a background color and pontentially other secondary surfaces."
    },
    "action-secondary-disabled": {
        value: "rgba(255, 255, 255, 1)",
        description: "Used as a disabled state for secondary buttons"
    },
    "action-secondary-hovered": {
        value: "rgba(246, 246, 247, 1)",
        description: "Used as a hovered state for secondary buttons"
    },
    "action-secondary-hovered-dark": {
        value: "rgba(84, 87, 91, 1)",
        description: "Used as a dark hovered state for secondary buttons"
    },
    "action-secondary-pressed": {
        value: "rgba(241, 242, 243, 1)",
        description: "Used as a pressed state for secondary buttons"
    },
    "action-secondary-pressed-dark": {
        value: "rgba(96, 100, 103, 1)",
        description: "Used as a dark pressed state for secondary buttons"
    },
    "action-secondary-depressed": {
        value: "rgba(109, 113, 117, 1)",
        description: "Used as a depressed state for secondary buttons"
    },
    "action-primary": {
        value: "rgba(0, 128, 96, 1)",
        description: "Used as the background color for primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
    },
    "action-primary-disabled": {
        value: "rgba(241, 241, 241, 1)",
        description: "Used as the background color for disabled primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
    },
    "action-primary-hovered": {
        value: "rgba(0, 110, 82, 1)",
        description: "Used as the background color for hovered primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
    },
    "action-primary-pressed": {
        value: "rgba(0, 94, 70, 1)",
        description: "Used as the background color for pressed primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
    },
    "action-primary-depressed": {
        value: "rgba(0, 61, 44, 1)",
        description: "Used as the background color for pressed primary actions, and as the fill color for icons and the text color in navigation and tabs to communicate interaction states."
    },
    "icon-on-primary": {
        value: "rgba(255, 255, 255, 1)",
        description: "For use as a fill color for icons on primary actions. Not for use in icons on navigation and tabs."
    },
    "text-on-primary": {
        value: "rgba(255, 255, 255, 1)",
        description: "For use as a text color on primary actions. Not for use in text on navigation and tabs."
    },
    "text-primary": {
        value: "rgba(0, 123, 92, 1)",
        description: "For use as primary text color on background. For use in text in components such as Navigation."
    },
    "text-primary-hovered": {
        value: "rgba(0, 108, 80, 1)",
        description: "For use as primary hovered text color on background. For use in text in components such as Navigation."
    },
    "text-primary-pressed": {
        value: "rgba(0, 92, 68, 1)",
        description: "For use as primary pressed text color on background. For use in text in components such as Navigation."
    },
    "surface-primary-selected": {
        value: "rgba(241, 248, 245, 1)",
        description: "Used as a surface color to indicate selected interactive states in navigation and tabs."
    },
    "surface-primary-selected-hovered": {
        value: "rgba(179, 208, 195, 1)",
        description: "Used as a surface color to indicate selected interactive states that are hovered in navigation and tabs."
    },
    "surface-primary-selected-pressed": {
        value: "rgba(162, 188, 176, 1)",
        description: "Used as a surface color to indicate selected interactive states that are pressed in navigation and tabs."
    },
    "border-critical": {
        value: "rgba(253, 87, 73, 1)",
        description: "For use as a border on critical components such as an outline on interactive elements in an error state."
    },
    "border-critical-subdued": {
        value: "rgba(224, 179, 178, 1)",
        description: "For use as a border on critical components such as banners."
    },
    "border-critical-disabled": {
        value: "rgba(255, 167, 163, 1)",
        description: "For use as a disabled border on critical components such as banners, and as an outline on interactive elements in an error state."
    },
    "icon-critical": {
        value: "rgba(215, 44, 13, 1)",
        description: "For use as an icon fill color on top of critical elements."
    },
    "surface-critical": {
        value: "rgba(254, 211, 209, 1)",
        description: "For use as a surface color on critical elements including badges."
    },
    "surface-critical-subdued": {
        value: "rgba(255, 244, 244, 1)",
        description: "For use as a subdued surface color on critical elements including banners."
    },
    "surface-critical-subdued-hovered": {
        value: "rgba(255, 240, 240, 1)",
        description: "For use as a surface color on critical interactive elements including action list items in a hovered state."
    },
    "surface-critical-subdued-pressed": {
        value: "rgba(255, 233, 232, 1)",
        description: "For use as a surface color on critical interactive elements including action list items in a pressed state."
    },
    "surface-critical-subdued-depressed": {
        value: "rgba(254, 188, 185, 1)",
        description: "For use as a surface color on critical interactive elements including action list items in a depressed state."
    },
    "text-critical": {
        value: "rgba(215, 44, 13, 1)",
        description: "For use as a text color in inert critical elements such as exception list. Not for use as a text color on banners and badges."
    },
    "action-critical": {
        value: "rgba(216, 44, 13, 1)",
        description: "For use as the background color for destructive buttons, and as the background color for error toast messages."
    },
    "action-critical-disabled": {
        value: "rgba(241, 241, 241, 1)",
        description: "For use as the background color for disabled destructive buttons, and as the background color for error toast messages."
    },
    "action-critical-hovered": {
        value: "rgba(188, 34, 0, 1)",
        description: "For use as the background color for hovered destructive buttons, and as the background color for error toast messages."
    },
    "action-critical-pressed": {
        value: "rgba(162, 27, 0, 1)",
        description: "For use as the background color for pressed destructive buttons, and as the background color for error toast messages."
    },
    "action-critical-depressed": {
        value: "rgba(108, 15, 0, 1)",
        description: "For use as the background color for depressed destructive buttons, and as the background color for error toast messages."
    },
    "icon-on-critical": {
        value: "rgba(255, 255, 255, 1)",
        description: "For use as a fill color for icons on critical actions."
    },
    "text-on-critical": {
        value: "rgba(255, 255, 255, 1)",
        description: "For use as a text color on critical actions."
    },
    "interactive-critical": {
        value: "rgba(216, 44, 13, 1)",
        description: "For use as the text color for destructive interactive elements: links, plain buttons, error state of selected checkboxes and radio buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
    },
    "interactive-critical-disabled": {
        value: "rgba(253, 147, 141, 1)",
        description: "For use as a text color in disabled destructive plain buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
    },
    "interactive-critical-hovered": {
        value: "rgba(205, 41, 12, 1)",
        description: "For use as a text color in hovered destructive plain buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
    },
    "interactive-critical-pressed": {
        value: "rgba(103, 15, 3, 1)",
        description: "For use as a text color in pressed destructive plain buttons, as well as a text color on destructive action list items. Not for use on critical banners and badges."
    },
    "border-warning": {
        value: "rgba(185, 137, 0, 1)",
        description: "For use as a border on warning components such as..."
    },
    "border-warning-subdued": {
        value: "rgba(225, 184, 120, 1)",
        description: "For use as a border on warning components such as banners."
    },
    "icon-warning": {
        value: "rgba(185, 137, 0, 1)",
        description: "For use as an icon fill color on top of warning elements."
    },
    "surface-warning": {
        value: "rgba(255, 215, 157, 1)",
        description: "For use as a surface color on warning elements including badges."
    },
    "surface-warning-subdued": {
        value: "rgba(255, 245, 234, 1)",
        description: "For use as a subdued surface color on warning elements including banners."
    },
    "surface-warning-subdued-hovered": {
        value: "rgba(255, 242, 226, 1)",
        description: "For use as a subdued surface color on warning elements including banners."
    },
    "surface-warning-subdued-pressed": {
        value: "rgba(255, 235, 211, 1)",
        description: "For use as a subdued surface color on warning elements including banners."
    },
    "text-warning": {
        value: "rgba(145, 106, 0, 1)",
        description: "For use as a text color in inert critical elements such as exception list. Not for use as a text color on banners and badges."
    },
    "border-highlight": {
        value: "rgba(68, 157, 167, 1)",
        description: "For use as a border on informational components such as..."
    },
    "border-highlight-subdued": {
        value: "rgba(152, 198, 205, 1)",
        description: "For use as a border on informational components such as banners."
    },
    "icon-highlight": {
        value: "rgba(0, 160, 172, 1)",
        description: "For use as an icon fill color on top of informational elements."
    },
    "surface-highlight": {
        value: "rgba(164, 232, 242, 1)",
        description: "For use as a surface color on information elements including badges."
    },
    "surface-highlight-subdued": {
        value: "rgba(235, 249, 252, 1)",
        description: "For use as a surface color on information elements including banners."
    },
    "surface-highlight-subdued-hovered": {
        value: "rgba(228, 247, 250, 1)",
        description: "For use as a surface color on information elements including banners."
    },
    "surface-highlight-subdued-pressed": {
        value: "rgba(213, 243, 248, 1)",
        description: "For use as a surface color on information elements including banners."
    },
    "text-highlight": {
        value: "rgba(52, 124, 132, 1)",
        description: "For use as a text color in inert informational elements. Not for use as a text color on banners and badges."
    },
    "border-success": {
        value: "rgba(0, 164, 124, 1)",
        description: "For use as a border on success components such as text inputs."
    },
    "border-success-subdued": {
        value: "rgba(149, 201, 180, 1)",
        description: "For use as a border on success components such as banners."
    },
    "icon-success": {
        value: "rgba(0, 127, 95, 1)",
        description: "For use as an icon fill color on top of success elements."
    },
    "surface-success": {
        value: "rgba(174, 233, 209, 1)",
        description: "For use as a surface color on success elements including badges."
    },
    "surface-success-subdued": {
        value: "rgba(241, 248, 245, 1)",
        description: "For use as a surface color on information elements including banners."
    },
    "surface-success-subdued-hovered": {
        value: "rgba(236, 246, 241, 1)",
        description: "For use as a surface color on information elements including banners."
    },
    "surface-success-subdued-pressed": {
        value: "rgba(226, 241, 234, 1)",
        description: "For use as a surface color on information elements including banners."
    },
    "text-success": {
        value: "rgba(0, 128, 96, 1)",
        description: "For use as a text color in inert success elements. Not for use as a text color on banners and badges."
    },
    "icon-attention": {
        value: "rgba(138, 97, 22, 1)"
    },
    "surface-attention": {
        value: "rgba(255, 234, 138, 1)"
    },
    "decorative-one-icon": {
        value: "rgba(126, 87, 0, 1)",
        description: "For use as a decorative icon color that is applied on a decorative surface."
    },
    "decorative-one-surface": {
        value: "rgba(255, 201, 107, 1)",
        description: "For use as a decorative surface color."
    },
    "decorative-one-text": {
        value: "rgba(61, 40, 0, 1)",
        description: "For use as a decorative text color that is applied on a decorative surface."
    },
    "decorative-two-icon": {
        value: "rgba(175, 41, 78, 1)",
        description: "For use as a decorative icon color that is applied on a decorative surface."
    },
    "decorative-two-surface": {
        value: "rgba(255, 196, 176, 1)",
        description: "For use as a decorative surface color."
    },
    "decorative-two-text": {
        value: "rgba(73, 11, 28, 1)",
        description: "For use as a decorative text color that is applied on a decorative surface."
    },
    "decorative-three-icon": {
        value: "rgba(0, 109, 65, 1)",
        description: "For use as a decorative icon color that is applied on a decorative surface."
    },
    "decorative-three-surface": {
        value: "rgba(146, 230, 181, 1)",
        description: "For use as a decorative surface color."
    },
    "decorative-three-text": {
        value: "rgba(0, 47, 25, 1)",
        description: "For use as a decorative text color that is applied on a decorative surface."
    },
    "decorative-four-icon": {
        value: "rgba(0, 106, 104, 1)",
        description: "For use as a decorative icon color that is applied on a decorative surface."
    },
    "decorative-four-surface": {
        value: "rgba(145, 224, 214, 1)",
        description: "For use as a decorative surface color."
    },
    "decorative-four-text": {
        value: "rgba(0, 45, 45, 1)",
        description: "For use as a decorative text color that is applied on a decorative surface."
    },
    "decorative-five-icon": {
        value: "rgba(174, 43, 76, 1)",
        description: "For use as a decorative icon color that is applied on a decorative surface."
    },
    "decorative-five-surface": {
        value: "rgba(253, 201, 208, 1)",
        description: "For use as a decorative surface color."
    },
    "decorative-five-text": {
        value: "rgba(79, 14, 31, 1)",
        description: "For use as a decorative text color that is applied on a decorative surface."
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fUndk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motion", ()=>motion);
var motion = {
    "duration-0": {
        value: "0ms"
    },
    "duration-50": {
        value: "50ms"
    },
    "duration-100": {
        value: "100ms"
    },
    "duration-150": {
        value: "150ms"
    },
    "duration-200": {
        value: "200ms"
    },
    "duration-250": {
        value: "250ms"
    },
    "duration-300": {
        value: "300ms"
    },
    "duration-350": {
        value: "350ms"
    },
    "duration-400": {
        value: "400ms"
    },
    "duration-450": {
        value: "450ms"
    },
    "duration-500": {
        value: "500ms"
    },
    "duration-5000": {
        value: "5000ms"
    },
    ease: {
        value: "cubic-bezier(0.25, 0.1, 0.25, 1)",
        description: "Responds quickly and finishes with control. A great default for any user interaction."
    },
    "ease-in": {
        value: "cubic-bezier(0.42, 0, 1, 1)",
        description: "Starts slowly and finishes at top speed. Use sparingly."
    },
    "ease-out": {
        value: "cubic-bezier(0, 0, 0.58, 1)",
        description: "Starts at top speed and finishes slowly. Use sparingly."
    },
    "ease-in-out": {
        value: "cubic-bezier(0.42, 0, 0.58, 1)",
        description: "Starts and finishes with equal speed. A good default for transitions triggered by the system."
    },
    linear: {
        value: "cubic-bezier(0, 0, 1, 1)",
        description: "Moves with constant speed. Use for continuous and mechanical animations, such as rotating spinners."
    },
    "keyframes-bounce": {
        value: "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }"
    },
    "keyframes-fade-in": {
        value: "{ to { opacity: 1 } }"
    },
    "keyframes-pulse": {
        value: "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }"
    },
    "keyframes-spin": {
        value: "{ to { transform: rotate(1turn) } }"
    },
    "keyframes-appear-above": {
        value: "{ from { transform: translateY(var(--p-space-1)); opacity: 0; } to { transform: none; opacity: 1; } }"
    },
    "keyframes-appear-below": {
        value: "{ from { transform: translateY(calc(var(--p-space-1) * -1)); opacity: 0; } to { transform: none; opacity: 1; } }"
    },
    "motion-duration-0": {
        value: "0ms"
    },
    "motion-duration-50": {
        value: "50ms"
    },
    "motion-duration-100": {
        value: "100ms"
    },
    "motion-duration-150": {
        value: "150ms"
    },
    "motion-duration-200": {
        value: "200ms"
    },
    "motion-duration-250": {
        value: "250ms"
    },
    "motion-duration-300": {
        value: "300ms"
    },
    "motion-duration-350": {
        value: "350ms"
    },
    "motion-duration-400": {
        value: "400ms"
    },
    "motion-duration-450": {
        value: "450ms"
    },
    "motion-duration-500": {
        value: "500ms"
    },
    "motion-duration-5000": {
        value: "5000ms"
    },
    "motion-ease": {
        value: "cubic-bezier(0.25, 0.1, 0.25, 1)",
        description: "Responds quickly and finishes with control. A great default for any user interaction."
    },
    "motion-ease-in": {
        value: "cubic-bezier(0.42, 0, 1, 1)",
        description: "Starts slowly and finishes at top speed. Use sparingly."
    },
    "motion-ease-out": {
        value: "cubic-bezier(0, 0, 0.58, 1)",
        description: "Starts at top speed and finishes slowly. Use sparingly."
    },
    "motion-ease-in-out": {
        value: "cubic-bezier(0.42, 0, 0.58, 1)",
        description: "Starts and finishes with equal speed. A good default for transitions triggered by the system."
    },
    "motion-linear": {
        value: "cubic-bezier(0, 0, 1, 1)",
        description: "Moves with constant speed. Use for continuous and mechanical animations, such as rotating spinners."
    },
    "motion-keyframes-bounce": {
        value: "{ from, 65%, 85% { transform: scale(1) } 75% { transform: scale(0.85) } 82.5% { transform: scale(1.05) } }"
    },
    "motion-keyframes-fade-in": {
        value: "{ to { opacity: 1 } }"
    },
    "motion-keyframes-pulse": {
        value: "{ from, 75% { transform: scale(0.85); opacity: 1; } to { transform: scale(2.5); opacity: 0; } }"
    },
    "motion-keyframes-spin": {
        value: "{ to { transform: rotate(1turn) } }"
    },
    "motion-keyframes-appear-above": {
        value: "{ from { transform: translateY(var(--p-space-1)); opacity: 0; } to { transform: none; opacity: 1; } }"
    },
    "motion-keyframes-appear-below": {
        value: "{ from { transform: translateY(calc(var(--p-space-1) * -1)); opacity: 0; } to { transform: none; opacity: 1; } }"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iEO6W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shadow", ()=>shadow);
var shadow = {
    "shadow-inset-lg": {
        value: "inset 0px 0px 7px 2px rgba(31, 33, 36, 0.18)"
    },
    "shadow-inset-md": {
        value: "inset 0px 2px 4px rgba(31, 33, 36, 0.32)"
    },
    "shadow-inset-sm": {
        value: "inset 0px 0px 3px rgba(31, 33, 36, 0.56)"
    },
    "shadow-none": {
        value: "none"
    },
    "shadow-xs": {
        value: "0px 0px 2px rgba(31, 33, 36, 0.24)"
    },
    "shadow-sm": {
        value: "0px 1px 1px rgba(31, 33, 36, 0.1)"
    },
    "shadow-md": {
        value: "0px 2px 4px rgba(31, 33, 36, 0.1), 0px 1px 6px rgba(31, 33, 36, 0.05)"
    },
    "shadow-lg": {
        value: "0px 4px 12px rgba(31, 33, 36, 0.2), 0px 2px 6px rgba(31, 33, 36, 0.05)"
    },
    "shadow-xl": {
        value: "0px 4px 18px -2px rgba(31, 33, 36, 0.08), 0px 12px 18px -2px rgba(31, 33, 36, 0.15)"
    },
    "shadow-2xl": {
        value: "0px 32px 32px rgba(31, 33, 36, 0.15), 0px 32px 56px -2px rgba(31, 33, 36, 0.16)"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ksTY2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shape", ()=>shape);
var shape = {
    "border-radius-05": {
        value: "2px"
    },
    "border-radius-1": {
        value: "4px"
    },
    "border-radius-2": {
        value: "8px"
    },
    "border-radius-3": {
        value: "12px"
    },
    "border-radius-4": {
        value: "16px"
    },
    "border-radius-5": {
        value: "20px"
    },
    "border-radius-6": {
        value: "30px"
    },
    "border-radius-full": {
        value: "9999px"
    },
    "border-radius-base": {
        value: "3px"
    },
    "border-radius-large": {
        value: "6px"
    },
    "border-radius-half": {
        value: "50%"
    },
    "border-width-1": {
        value: "1px"
    },
    "border-width-2": {
        value: "2px"
    },
    "border-width-3": {
        value: "3px"
    },
    "border-width-4": {
        value: "4px"
    },
    "border-width-5": {
        value: "5px"
    },
    "border-base": {
        value: "var(--p-border-width-1) solid var(--p-color-border-subdued)"
    },
    "border-dark": {
        value: "var(--p-border-width-1) solid var(--p-color-border)"
    },
    "border-transparent": {
        value: "var(--p-border-width-1) solid transparent"
    },
    "border-divider": {
        value: "var(--p-border-width-1) solid var(--p-color-border-subdued)"
    },
    "border-divider-on-dark": {
        value: "var(--p-border-width-1) solid var(--p-color-border-inverse)"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gSVo5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spacing", ()=>spacing);
var spacing = {
    "space-0": {
        value: "0"
    },
    "space-025": {
        value: "1px"
    },
    "space-05": {
        value: "2px"
    },
    "space-1": {
        value: "4px"
    },
    "space-2": {
        value: "8px"
    },
    "space-3": {
        value: "12px"
    },
    "space-4": {
        value: "16px"
    },
    "space-5": {
        value: "20px"
    },
    "space-6": {
        value: "24px"
    },
    "space-8": {
        value: "32px"
    },
    "space-10": {
        value: "40px"
    },
    "space-12": {
        value: "48px"
    },
    "space-16": {
        value: "64px"
    },
    "space-20": {
        value: "80px"
    },
    "space-24": {
        value: "96px"
    },
    "space-28": {
        value: "112px"
    },
    "space-32": {
        value: "128px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fiVmm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "space", ()=>space);
var space = {
    "space-0": {
        value: "0"
    },
    "space-025": {
        value: "1px"
    },
    "space-05": {
        value: "2px"
    },
    "space-1": {
        value: "4px"
    },
    "space-2": {
        value: "8px"
    },
    "space-3": {
        value: "12px"
    },
    "space-4": {
        value: "16px"
    },
    "space-5": {
        value: "20px"
    },
    "space-6": {
        value: "24px"
    },
    "space-8": {
        value: "32px"
    },
    "space-10": {
        value: "40px"
    },
    "space-12": {
        value: "48px"
    },
    "space-16": {
        value: "64px"
    },
    "space-20": {
        value: "80px"
    },
    "space-24": {
        value: "96px"
    },
    "space-28": {
        value: "112px"
    },
    "space-32": {
        value: "128px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aWYjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zIndex", ()=>zIndex);
var zIndex = {
    "z-index-1": {
        value: "100"
    },
    "z-index-2": {
        value: "400"
    },
    "z-index-3": {
        value: "510"
    },
    "z-index-4": {
        value: "512"
    },
    "z-index-5": {
        value: "513"
    },
    "z-index-6": {
        value: "514"
    },
    "z-index-7": {
        value: "515"
    },
    "z-index-8": {
        value: "516"
    },
    "z-index-9": {
        value: "517"
    },
    "z-index-10": {
        value: "518"
    },
    "z-index-11": {
        value: "519"
    },
    "z-index-12": {
        value: "520"
    },
    "z-1": {
        value: "100"
    },
    "z-2": {
        value: "400"
    },
    "z-3": {
        value: "510"
    },
    "z-4": {
        value: "512"
    },
    "z-5": {
        value: "513"
    },
    "z-6": {
        value: "514"
    },
    "z-7": {
        value: "515"
    },
    "z-8": {
        value: "516"
    },
    "z-9": {
        value: "517"
    },
    "z-10": {
        value: "518"
    },
    "z-11": {
        value: "519"
    },
    "z-12": {
        value: "520"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"frb7s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppProvider", ()=>AppProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _appProviderScssJs = require("./AppProvider.scss.js");
var _globalScssJs = require("./global.scss.js");
var _stickyManagerJs = require("../../utilities/sticky-manager/sticky-manager.js");
var _scrollLockManagerJs = require("../../utilities/scroll-lock-manager/scroll-lock-manager.js");
var _uniqueIdFactoryJs = require("../../utilities/unique-id/unique-id-factory.js");
var _i18NJs = require("../../utilities/i18n/I18n.js");
var _contextJs = require("../../utilities/features/context.js");
var _contextJs1 = require("../../utilities/i18n/context.js");
var _contextJs2 = require("../../utilities/scroll-lock-manager/context.js");
var _contextJs3 = require("../../utilities/sticky-manager/context.js");
var _contextJs4 = require("../../utilities/unique-id/context.js");
var _contextJs5 = require("../../utilities/link/context.js");
var _mediaQueryProviderJs = require("../MediaQueryProvider/MediaQueryProvider.js");
var _portalsManagerJs = require("../PortalsManager/PortalsManager.js");
var _focusManagerJs = require("../FocusManager/FocusManager.js");
var _ephemeralPresenceManagerJs = require("../EphemeralPresenceManager/EphemeralPresenceManager.js");
class AppProvider extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.stickyManager = void 0;
        this.scrollLockManager = void 0;
        this.uniqueIdFactory = void 0;
        this.setBodyStyles = ()=>{
            document.body.style.backgroundColor = "var(--p-color-bg-app)";
            document.body.style.color = "var(--p-color-text)";
        };
        this.stickyManager = new (0, _stickyManagerJs.StickyManager)();
        this.scrollLockManager = new (0, _scrollLockManagerJs.ScrollLockManager)();
        this.uniqueIdFactory = new (0, _uniqueIdFactoryJs.UniqueIdFactory)((0, _uniqueIdFactoryJs.globalIdGeneratorFactory));
        const { i18n, linkComponent } = this.props; // eslint-disable-next-line react/state-in-constructor
        this.state = {
            link: linkComponent,
            intl: new (0, _i18NJs.I18n)(i18n)
        };
    }
    componentDidMount() {
        if (document != null) {
            this.stickyManager.setContainer(document);
            this.setBodyStyles();
        }
    }
    componentDidUpdate({ i18n: prevI18n, linkComponent: prevLinkComponent }) {
        const { i18n, linkComponent } = this.props;
        if (i18n === prevI18n && linkComponent === prevLinkComponent) return;
        this.setState({
            link: linkComponent,
            intl: new (0, _i18NJs.I18n)(i18n)
        });
    }
    render() {
        const { children, features = {} } = this.props;
        const { intl, link } = this.state;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.FeaturesContext).Provider, {
            value: features
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs1.I18nContext).Provider, {
            value: intl
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs2.ScrollLockManagerContext).Provider, {
            value: this.scrollLockManager
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs3.StickyManagerContext).Provider, {
            value: this.stickyManager
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs4.UniqueIdFactoryContext).Provider, {
            value: this.uniqueIdFactory
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs5.LinkContext).Provider, {
            value: link
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _mediaQueryProviderJs.MediaQueryProvider), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalsManagerJs.PortalsManager), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusManagerJs.FocusManager), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _ephemeralPresenceManagerJs.EphemeralPresenceManager), null, children))))))))));
    }
}

},{"react":"cOWTg","./AppProvider.scss.js":"lYaIR","./global.scss.js":"9yznr","../../utilities/sticky-manager/sticky-manager.js":"9IoVo","../../utilities/scroll-lock-manager/scroll-lock-manager.js":"aCI0u","../../utilities/unique-id/unique-id-factory.js":"4Mnif","../../utilities/i18n/I18n.js":"hqceV","../../utilities/features/context.js":"i4XQ2","../../utilities/i18n/context.js":"byRrd","../../utilities/scroll-lock-manager/context.js":"iq0lt","../../utilities/sticky-manager/context.js":"drNXT","../../utilities/unique-id/context.js":"jR0XA","../../utilities/link/context.js":"82weN","../MediaQueryProvider/MediaQueryProvider.js":"gLQ4W","../PortalsManager/PortalsManager.js":"hP47q","../FocusManager/FocusManager.js":"7iota","../EphemeralPresenceManager/EphemeralPresenceManager.js":"dZ3wD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lYaIR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AppProvider);
var AppProvider = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9yznr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>global);
var global = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9IoVo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyManager", ()=>StickyManager);
var _polarisTokens = require("@shopify/polaris-tokens");
var _debounceJs = require("../debounce.js");
var _sharedJs = require("../../components/shared.js");
var _breakpointsJs = require("../breakpoints.js");
var _geometryJs = require("../geometry.js");
const SIXTY_FPS = 1000 / 60;
class StickyManager {
    constructor(container){
        this.stickyItems = [];
        this.stuckItems = [];
        this.container = null;
        this.topBarOffset = 0;
        this.handleResize = (0, _debounceJs.debounce)(()=>{
            this.manageStickyItems();
        }, SIXTY_FPS, {
            leading: true,
            trailing: true,
            maxWait: SIXTY_FPS
        });
        this.handleScroll = (0, _debounceJs.debounce)(()=>{
            this.manageStickyItems();
        }, SIXTY_FPS, {
            leading: true,
            trailing: true,
            maxWait: SIXTY_FPS
        });
        if (container) this.setContainer(container);
    }
    registerStickyItem(stickyItem) {
        this.stickyItems.push(stickyItem);
    }
    unregisterStickyItem(nodeToRemove) {
        const nodeIndex = this.stickyItems.findIndex(({ stickyNode })=>nodeToRemove === stickyNode);
        this.stickyItems.splice(nodeIndex, 1);
    }
    setContainer(el) {
        this.container = el;
        if (isDocument(el)) this.setTopBarOffset(el);
        this.container.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleResize);
        this.manageStickyItems();
    }
    removeScrollListener() {
        if (this.container) {
            this.container.removeEventListener("scroll", this.handleScroll);
            window.removeEventListener("resize", this.handleResize);
        }
    }
    manageStickyItems() {
        if (this.stickyItems.length <= 0) return;
        const scrollTop = this.container ? scrollTopFor(this.container) : 0;
        const containerTop = (0, _geometryJs.getRectForNode)(this.container).top + this.topBarOffset;
        this.stickyItems.forEach((stickyItem)=>{
            const { handlePositioning } = stickyItem;
            const { sticky, top, left, width } = this.evaluateStickyItem(stickyItem, scrollTop, containerTop);
            this.updateStuckItems(stickyItem, sticky);
            handlePositioning(sticky, top, left, width);
        });
    }
    evaluateStickyItem(stickyItem, scrollTop, containerTop) {
        const { stickyNode, placeHolderNode, boundingElement, offset, disableWhenStacked } = stickyItem;
        if (disableWhenStacked && (0, _breakpointsJs.stackedContent)().matches) return {
            sticky: false,
            top: 0,
            left: 0,
            width: "auto"
        };
        const stickyOffset = offset ? this.getOffset(stickyNode) + parseInt((0, _polarisTokens.space)["space-5"], 10) : this.getOffset(stickyNode);
        const scrollPosition = scrollTop + stickyOffset;
        const placeHolderNodeCurrentTop = placeHolderNode.getBoundingClientRect().top - containerTop + scrollTop;
        const top = containerTop + stickyOffset;
        const width = placeHolderNode.getBoundingClientRect().width;
        const left = placeHolderNode.getBoundingClientRect().left;
        let sticky;
        if (boundingElement == null) sticky = scrollPosition >= placeHolderNodeCurrentTop;
        else {
            var _stickyNode$firstElem;
            const stickyItemHeight = stickyNode.getBoundingClientRect().height || ((_stickyNode$firstElem = stickyNode.firstElementChild) === null || _stickyNode$firstElem === void 0 ? void 0 : _stickyNode$firstElem.getBoundingClientRect().height) || 0;
            const stickyItemBottomPosition = boundingElement.getBoundingClientRect().bottom - stickyItemHeight + scrollTop - containerTop;
            sticky = scrollPosition >= placeHolderNodeCurrentTop && scrollPosition < stickyItemBottomPosition;
        }
        return {
            sticky,
            top,
            left,
            width
        };
    }
    updateStuckItems(item, sticky) {
        const { stickyNode } = item;
        if (sticky && !this.isNodeStuck(stickyNode)) this.addStuckItem(item);
        else if (!sticky && this.isNodeStuck(stickyNode)) this.removeStuckItem(item);
    }
    addStuckItem(stickyItem) {
        this.stuckItems.push(stickyItem);
    }
    removeStuckItem(stickyItem) {
        const { stickyNode: nodeToRemove } = stickyItem;
        const nodeIndex = this.stuckItems.findIndex(({ stickyNode })=>nodeToRemove === stickyNode);
        this.stuckItems.splice(nodeIndex, 1);
    }
    getOffset(node) {
        if (this.stuckItems.length === 0) return 0;
        let offset = 0;
        let count = 0;
        const stuckNodesLength = this.stuckItems.length;
        const nodeRect = (0, _geometryJs.getRectForNode)(node);
        while(count < stuckNodesLength){
            const stuckNode = this.stuckItems[count].stickyNode;
            if (stuckNode !== node) {
                const stuckNodeRect = (0, _geometryJs.getRectForNode)(stuckNode);
                if (!horizontallyOverlaps(nodeRect, stuckNodeRect)) offset += (0, _geometryJs.getRectForNode)(stuckNode).height;
            } else break;
            count++;
        }
        return offset;
    }
    isNodeStuck(node) {
        const nodeFound = this.stuckItems.findIndex(({ stickyNode })=>node === stickyNode);
        return nodeFound >= 0;
    }
    setTopBarOffset(container) {
        const topbarElement = container.querySelector(`:not(${(0, _sharedJs.scrollable).selector}) ${(0, _sharedJs.dataPolarisTopBar).selector}`);
        this.topBarOffset = topbarElement ? topbarElement.clientHeight : 0;
    }
}
function isDocument(node) {
    return node === document;
}
function scrollTopFor(container) {
    return isDocument(container) ? document.body.scrollTop || document.documentElement.scrollTop : container.scrollTop;
}
function horizontallyOverlaps(rect1, rect2) {
    const rect1Left = rect1.left;
    const rect1Right = rect1.left + rect1.width;
    const rect2Left = rect2.left;
    const rect2Right = rect2.left + rect2.width;
    return rect2Right < rect1Left || rect1Right < rect2Left;
}

},{"@shopify/polaris-tokens":"5ENVX","../debounce.js":"bvJet","../../components/shared.js":"lFbIK","../breakpoints.js":"icMVM","../geometry.js":"eKkn4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bvJet":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
function debounce(func, waitArg, options) {
    let lastArgs;
    let lastThis;
    let maxWait;
    let result;
    let timerId;
    let lastCallTime;
    let lastInvokeTime = 0;
    let leading = false;
    let maxing = false;
    let trailing = true; // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
    const useRAF = !waitArg && waitArg !== 0;
    if (typeof func !== "function") throw new TypeError("Expected a function");
    const wait = waitArg || 0;
    if (typeof options === "object") {
        leading = Boolean(options.leading);
        maxing = "maxWait" in options;
        maxWait = maxing ? Math.max(Number(options.maxWait) || 0, wait) : undefined;
        trailing = "trailing" in options ? Boolean(options.trailing) : trailing;
    }
    function invokeFunc(time) {
        const args = lastArgs;
        const thisArg = lastThis;
        lastArgs = undefined;
        lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function startTimer(pendingFunc, wait) {
        if (useRAF) {
            cancelAnimationFrame(timerId);
            return requestAnimationFrame(pendingFunc);
        }
        return setTimeout(pendingFunc, wait);
    }
    function cancelTimer(id) {
        if (useRAF) return cancelAnimationFrame(id);
        clearTimeout(id);
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time; // Start the timer for the trailing edge.
        timerId = startTimer(timerExpired, wait); // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        const timeSinceLastCall = time - lastCallTime;
        const timeSinceLastInvoke = time - lastInvokeTime;
        const timeWaiting = wait - timeSinceLastCall;
        return maxing && maxWait ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        const timeSinceLastCall = time - lastCallTime;
        const timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && maxWait && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        const time = Date.now();
        if (shouldInvoke(time)) return trailingEdge(time);
         // Restart the timer.
        timerId = startTimer(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
         // eslint-disable-next-line no-multi-assign
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) cancelTimer(timerId);
        lastInvokeTime = 0; // eslint-disable-next-line no-multi-assign
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(Date.now());
    }
    function pending() {
        return timerId !== undefined;
    }
    function debounced(...args) {
        const time = Date.now();
        const isInvoking = shouldInvoke(time);
        lastArgs = args; // eslint-disable-next-line consistent-this, @typescript-eslint/no-this-alias
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = startTimer(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = startTimer(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    debounced.pending = pending;
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eKkn4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rect", ()=>Rect);
parcelHelpers.export(exports, "getRectForNode", ()=>getRectForNode);
class Rect {
    static get zero() {
        return new Rect();
    }
    constructor({ top = 0, left = 0, width = 0, height = 0 } = {}){
        this.top = void 0;
        this.left = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = top;
        this.left = left;
        this.width = width;
        this.height = height;
    }
    get center() {
        return {
            x: this.left + this.width / 2,
            y: this.top + this.height / 2
        };
    }
}
function getRectForNode(node) {
    if (!(node instanceof Element)) return new Rect({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const rect = node.getBoundingClientRect();
    return new Rect({
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aCI0u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCROLL_LOCKING_ATTRIBUTE", ()=>SCROLL_LOCKING_ATTRIBUTE);
parcelHelpers.export(exports, "ScrollLockManager", ()=>ScrollLockManager);
var _targetJs = require("../target.js");
const SCROLL_LOCKING_ATTRIBUTE = "data-lock-scrolling";
const SCROLL_LOCKING_HIDDEN_ATTRIBUTE = "data-lock-scrolling-hidden";
const SCROLL_LOCKING_WRAPPER_ATTRIBUTE = "data-lock-scrolling-wrapper";
let scrollPosition = 0;
function isScrollBarVisible() {
    const { body } = document;
    return body.scrollHeight > body.clientHeight;
}
class ScrollLockManager {
    constructor(){
        this.scrollLocks = 0;
        this.locked = false;
    }
    registerScrollLock() {
        this.scrollLocks += 1;
        this.handleScrollLocking();
    }
    unregisterScrollLock() {
        this.scrollLocks -= 1;
        this.handleScrollLocking();
    }
    handleScrollLocking() {
        if (0, _targetJs.isServer) return;
        const { scrollLocks } = this;
        const { body } = document;
        const wrapper = body.firstElementChild;
        if (scrollLocks === 0) {
            body.removeAttribute(SCROLL_LOCKING_ATTRIBUTE);
            body.removeAttribute(SCROLL_LOCKING_HIDDEN_ATTRIBUTE);
            if (wrapper) wrapper.removeAttribute(SCROLL_LOCKING_WRAPPER_ATTRIBUTE);
            window.scroll(0, scrollPosition);
            this.locked = false;
        } else if (scrollLocks > 0 && !this.locked) {
            scrollPosition = window.pageYOffset;
            body.setAttribute(SCROLL_LOCKING_ATTRIBUTE, "");
            if (!isScrollBarVisible()) body.setAttribute(SCROLL_LOCKING_HIDDEN_ATTRIBUTE, "");
            if (wrapper) {
                wrapper.setAttribute(SCROLL_LOCKING_WRAPPER_ATTRIBUTE, "");
                wrapper.scrollTop = scrollPosition;
            }
            this.locked = true;
        }
    }
    resetScrollPosition() {
        scrollPosition = 0;
    }
}

},{"../target.js":"8v8ju","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4Mnif":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UniqueIdFactory", ()=>UniqueIdFactory);
parcelHelpers.export(exports, "globalIdGeneratorFactory", ()=>globalIdGeneratorFactory);
class UniqueIdFactory {
    constructor(idGeneratorFactory){
        this.idGeneratorFactory = void 0;
        this.idGenerators = {};
        this.idGeneratorFactory = idGeneratorFactory;
    }
    nextId(prefix) {
        if (!this.idGenerators[prefix]) this.idGenerators[prefix] = this.idGeneratorFactory(prefix);
        return this.idGenerators[prefix]();
    }
}
function globalIdGeneratorFactory(prefix = "") {
    let index = 1;
    return ()=>`Polaris${prefix}${index++}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hqceV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _getJs = require("../get.js");
var _mergeJs = require("../merge.js");
const REPLACE_REGEX = /{([^}]*)}/g;
class I18n {
    /**
   * @param translation A locale object or array of locale objects that overrides default translations. If specifying an array then your desired language dictionary should come first, followed by your fallback language dictionaries
   */ constructor(translation){
        this.translation = {};
        // slice the array to make a shallow copy of it, so we don't accidentally
        // modify the original translation array
        this.translation = Array.isArray(translation) ? (0, _mergeJs.merge)(...translation.slice().reverse()) : translation;
    }
    translate(id, replacements) {
        const text = (0, _getJs.get)(this.translation, id, "");
        if (!text) return "";
        if (replacements) return text.replace(REPLACE_REGEX, (match)=>{
            const replacement = match.substring(1, match.length - 1);
            if (replacements[replacement] === undefined) {
                const replacementData = JSON.stringify(replacements);
                throw new Error(`Error in translation for key '${id}'. No replacement found for key '${replacement}'. The following replacements were passed: '${replacementData}'`);
            } // This could be a string or a number, but JS doesn't mind which it gets
            // and can handle that cast internally. So let it, to save us calling
            // toString() on what's already a string in 90% of cases.
            return replacements[replacement];
        });
        return text;
    }
    translationKeyExists(path) {
        return Boolean((0, _getJs.get)(this.translation, path));
    }
}

},{"../get.js":"cdN52","../merge.js":"lBdFP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cdN52":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
const OBJECT_NOTATION_MATCHER = /\[(.*?)\]|(\w+)/g;
function get(obj, keypath, defaultValue) {
    if (obj == null) return undefined;
    const keys = Array.isArray(keypath) ? keypath : getKeypath(keypath);
    let acc = obj; // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < keys.length; i++){
        const val = acc[keys[i]];
        if (val === undefined) return defaultValue;
        acc = val;
    }
    return acc;
}
function getKeypath(str) {
    const path = [];
    let result;
    while(result = OBJECT_NOTATION_MATCHER.exec(str)){
        const [, first, second] = result;
        path.push(first || second);
    }
    return path;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lBdFP":[function(require,module,exports) {
// Unfortunately, this is how we have to type this at the moment.
// There is currently a proposal to support variadic kinds.
// https://github.com/Microsoft/TypeScript/issues/5453
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
function merge(...objs) {
    let final = {};
    for (const obj of objs)final = mergeRecursively(final, obj);
    return final;
}
function mergeRecursively(inputObjA, objB) {
    const objA = Array.isArray(inputObjA) ? [
        ...inputObjA
    ] : {
        ...inputObjA
    };
    for(const key in objB){
        if (!Object.prototype.hasOwnProperty.call(objB, key)) continue;
        else if (isMergeableValue(objB[key]) && isMergeableValue(objA[key])) objA[key] = mergeRecursively(objA[key], objB[key]);
        else objA[key] = objB[key];
    }
    return objA;
}
function isMergeableValue(value) {
    return value !== null && typeof value === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i4XQ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeaturesContext", ()=>FeaturesContext);
var _react = require("react");
const FeaturesContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"byRrd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nContext", ()=>I18nContext);
var _react = require("react");
const I18nContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iq0lt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollLockManagerContext", ()=>ScrollLockManagerContext);
var _react = require("react");
const ScrollLockManagerContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"drNXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyManagerContext", ()=>StickyManagerContext);
var _react = require("react");
const StickyManagerContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jR0XA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UniqueIdFactoryContext", ()=>UniqueIdFactoryContext);
var _react = require("react");
const UniqueIdFactoryContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"82weN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
var _react = require("react");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gLQ4W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MediaQueryProvider", ()=>MediaQueryProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounceJs = require("../../utilities/debounce.js");
var _breakpointsJs = require("../../utilities/breakpoints.js");
var _contextJs = require("../../utilities/media-query/context.js");
var _eventListenerJs = require("../EventListener/EventListener.js");
const MediaQueryProvider = function MediaQueryProvider({ children }) {
    const [isNavigationCollapsed, setIsNavigationCollapsed] = (0, _react.useState)((0, _breakpointsJs.navigationBarCollapsed)().matches); // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleResize = (0, _react.useCallback)((0, _debounceJs.debounce)(()=>{
        if (isNavigationCollapsed !== (0, _breakpointsJs.navigationBarCollapsed)().matches) setIsNavigationCollapsed(!isNavigationCollapsed);
    }, 40, {
        trailing: true,
        leading: true,
        maxWait: 40
    }), [
        isNavigationCollapsed
    ]);
    (0, _react.useEffect)(()=>{
        setIsNavigationCollapsed((0, _breakpointsJs.navigationBarCollapsed)().matches);
    }, []);
    const context = (0, _react.useMemo)(()=>({
            isNavigationCollapsed
        }), [
        isNavigationCollapsed
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.MediaQueryContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
        event: "resize",
        handler: handleResize
    }), children);
};

},{"react":"cOWTg","../../utilities/debounce.js":"bvJet","../../utilities/breakpoints.js":"icMVM","../../utilities/media-query/context.js":"4MqDR","../EventListener/EventListener.js":"jV8kW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4MqDR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MediaQueryContext", ()=>MediaQueryContext);
var _react = require("react");
const MediaQueryContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jV8kW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventListener", ()=>EventListener);
var _react = require("react");
/** @deprecated Use the useEventListener hook instead. */ class EventListener extends (0, _react.PureComponent) {
    componentDidMount() {
        this.attachListener();
    }
    componentDidUpdate({ passive, ...detachProps }) {
        this.detachListener(detachProps);
        this.attachListener();
    }
    componentWillUnmount() {
        this.detachListener();
    }
    render() {
        return null;
    }
    attachListener() {
        const { event, handler, capture, passive } = this.props;
        window.addEventListener(event, handler, {
            capture,
            passive
        });
    }
    detachListener(prevProps) {
        const { event, handler, capture } = prevProps || this.props;
        window.removeEventListener(event, handler, capture);
    }
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hP47q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalsManager", ()=>PortalsManager);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsAfterInitialMountJs = require("../../utilities/use-is-after-initial-mount.js");
var _contextJs = require("../../utilities/portals/context.js");
var _portalsContainerJs = require("./components/PortalsContainer/PortalsContainer.js");
function PortalsManager({ children, container }) {
    const isMounted = (0, _useIsAfterInitialMountJs.useIsAfterInitialMount)();
    const ref = (0, _react.useRef)(null);
    const contextValue = (0, _react.useMemo)(()=>{
        if (container) return {
            container
        };
        else if (isMounted) return {
            container: ref.current
        };
        else return {
            container: null
        };
    }, [
        container,
        isMounted
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.PortalsManagerContext).Provider, {
        value: contextValue
    }, children, container ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalsContainerJs.PortalsContainer), {
        ref: ref
    }));
}

},{"react":"cOWTg","../../utilities/use-is-after-initial-mount.js":"aJ8qM","../../utilities/portals/context.js":"2SMv8","./components/PortalsContainer/PortalsContainer.js":"cya9F","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aJ8qM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsAfterInitialMount", ()=>useIsAfterInitialMount);
var _react = require("react");
/**
 * useIsAfterInitialMount will trigger a re-render to provide
 * you with an updated value. Using this you enhance server-side
 * code that can only run on the client.
 * @returns MutableRefObject<T> - Returns a ref object with the
 * results from invoking initial value
 * @example
 * function ComponentExample({children}) {
 *  const isMounted = useIsAfterInitialMount();
 *  const content = isMounted ? children : null;
 *
 *  return <>{content}</>;
 * }
 */ function useIsAfterInitialMount() {
    const [isAfterInitialMount, setIsAfterInitialMount] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setIsAfterInitialMount(true);
    }, []);
    return isAfterInitialMount;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2SMv8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalsManagerContext", ()=>PortalsManagerContext);
var _react = require("react");
const PortalsManagerContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cya9F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalsContainer", ()=>PortalsContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function PortalsContainerComponent(_props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: "PolarisPortalsContainer",
        ref: ref
    });
}
const PortalsContainer = /*#__PURE__*/ (0, _react.forwardRef)(PortalsContainerComponent);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7iota":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _contextJs = require("../../utilities/focus-manager/context.js");
function FocusManager({ children }) {
    const [trapFocusList, setTrapFocusList] = (0, _react.useState)([]);
    const add = (0, _react.useCallback)((id)=>{
        setTrapFocusList((list)=>[
                ...list,
                id
            ]);
    }, []);
    const remove = (0, _react.useCallback)((id)=>{
        let removed = true;
        setTrapFocusList((list)=>{
            const clone = [
                ...list
            ];
            const index = clone.indexOf(id);
            if (index === -1) removed = false;
            else clone.splice(index, 1);
            return clone;
        });
        return removed;
    }, []);
    const value = (0, _react.useMemo)(()=>({
            trapFocusList,
            add,
            remove
        }), [
        add,
        trapFocusList,
        remove
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.FocusManagerContext).Provider, {
        value: value
    }, children);
}

},{"react":"cOWTg","../../utilities/focus-manager/context.js":"hElrI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hElrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManagerContext", ()=>FocusManagerContext);
var _react = require("react");
const FocusManagerContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dZ3wD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EphemeralPresenceManager", ()=>EphemeralPresenceManager);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _contextJs = require("../../utilities/ephemeral-presence-manager/context.js");
const defaultState = {
    tooltip: 0
};
function EphemeralPresenceManager({ children }) {
    const [presenceCounter, setPresenceCounter] = (0, _react.useState)(defaultState);
    const addPresence = (0, _react.useCallback)((key)=>{
        setPresenceCounter((prevList)=>({
                ...prevList,
                [key]: prevList[key] + 1
            }));
    }, []);
    const removePresence = (0, _react.useCallback)((key)=>{
        setPresenceCounter((prevList)=>({
                ...prevList,
                [key]: prevList[key] - 1
            }));
    }, []);
    const value = (0, _react.useMemo)(()=>({
            presenceList: Object.entries(presenceCounter).reduce((previousValue, currentValue)=>{
                const [key, value] = currentValue;
                return {
                    ...previousValue,
                    [key]: value >= 1
                };
            }, {}),
            presenceCounter,
            addPresence,
            removePresence
        }), [
        addPresence,
        removePresence,
        presenceCounter
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.EphemeralPresenceManagerContext).Provider, {
        value: value
    }, children);
}

},{"react":"cOWTg","../../utilities/ephemeral-presence-manager/context.js":"zFanZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"zFanZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EphemeralPresenceManagerContext", ()=>EphemeralPresenceManagerContext);
var _react = require("react");
const EphemeralPresenceManagerContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kU0n2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionList", ()=>ActionList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focusJs = require("../../utilities/focus.js");
var _typesJs = require("../../types.js");
var _sectionJs = require("./components/Section/Section.js");
var _keypressListenerJs = require("../KeypressListener/KeypressListener.js");
var _boxJs = require("../Box/Box.js");
var _itemJs = require("./components/Item/Item.js");
function ActionList({ items, sections = [], actionRole, onActionAnyItem }) {
    let finalSections = [];
    const actionListRef = (0, _react.useRef)(null);
    if (items) finalSections = [
        {
            items
        },
        ...sections
    ];
    else if (sections) finalSections = sections;
    const hasMultipleSections = finalSections.length > 1;
    const elementRole = hasMultipleSections && actionRole === "menuitem" ? "menu" : undefined;
    const elementTabIndex = hasMultipleSections && actionRole === "menuitem" ? -1 : undefined;
    const sectionMarkup = finalSections.map((section, index)=>{
        return section.items.length > 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionJs.Section), {
            key: typeof section.title === "string" ? section.title : index,
            section: section,
            hasMultipleSections: hasMultipleSections,
            actionRole: actionRole,
            onActionAnyItem: onActionAnyItem,
            isFirst: index === 0
        }) : null;
    });
    const handleFocusPreviousItem = (evt)=>{
        evt.preventDefault();
        if (actionListRef.current && evt.target) {
            if (actionListRef.current.contains(evt.target)) (0, _focusJs.wrapFocusPreviousFocusableMenuItem)(actionListRef.current, evt.target);
        }
    };
    const handleFocusNextItem = (evt)=>{
        evt.preventDefault();
        if (actionListRef.current && evt.target) {
            if (actionListRef.current.contains(evt.target)) (0, _focusJs.wrapFocusNextFocusableMenuItem)(actionListRef.current, evt.target);
        }
    };
    const listeners = actionRole === "menuitem" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyEvent: "keydown",
        keyCode: (0, _typesJs.Key).DownArrow,
        handler: handleFocusNextItem
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyEvent: "keydown",
        keyCode: (0, _typesJs.Key).UpArrow,
        handler: handleFocusPreviousItem
    })) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        as: hasMultipleSections ? "ul" : "div",
        ref: actionListRef,
        role: elementRole,
        tabIndex: elementTabIndex
    }, listeners, sectionMarkup);
}
ActionList.Item = (0, _itemJs.Item);

},{"react":"cOWTg","../../utilities/focus.js":"b0pEc","../../types.js":"6NE7w","./components/Section/Section.js":"h706v","../KeypressListener/KeypressListener.js":"1eFmF","../Box/Box.js":"lbjkG","./components/Item/Item.js":"ckM9Y","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b0pEc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findFirstFocusableNode", ()=>findFirstFocusableNode);
parcelHelpers.export(exports, "findFirstFocusableNodeIncludingDisabled", ()=>findFirstFocusableNodeIncludingDisabled);
parcelHelpers.export(exports, "findFirstKeyboardFocusableNode", ()=>findFirstKeyboardFocusableNode);
parcelHelpers.export(exports, "findLastKeyboardFocusableNode", ()=>findLastKeyboardFocusableNode);
parcelHelpers.export(exports, "focusFirstFocusableNode", ()=>focusFirstFocusableNode);
parcelHelpers.export(exports, "focusFirstKeyboardFocusableNode", ()=>focusFirstKeyboardFocusableNode);
parcelHelpers.export(exports, "focusLastKeyboardFocusableNode", ()=>focusLastKeyboardFocusableNode);
parcelHelpers.export(exports, "focusNextFocusableNode", ()=>focusNextFocusableNode);
parcelHelpers.export(exports, "handleMouseUpByBlurring", ()=>handleMouseUpByBlurring);
parcelHelpers.export(exports, "nextFocusableNode", ()=>nextFocusableNode);
parcelHelpers.export(exports, "wrapFocusNextFocusableMenuItem", ()=>wrapFocusNextFocusableMenuItem);
parcelHelpers.export(exports, "wrapFocusPreviousFocusableMenuItem", ()=>wrapFocusPreviousFocusableMenuItem);
var _isElementInViewportJs = require("./is-element-in-viewport.js");
const FOCUSABLE_SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not([aria-disabled="true"]):not([tabindex="-1"]):not(:disabled),*[tabindex]';
const KEYBOARD_FOCUSABLE_SELECTORS = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not([aria-disabled="true"]):not([tabindex="-1"]):not(:disabled),*[tabindex]:not([tabindex="-1"])';
const MENUITEM_FOCUSABLE_SELECTORS = 'a[role="menuitem"],frame[role="menuitem"],iframe[role="menuitem"],input[role="menuitem"]:not([type=hidden]):not(:disabled),select[role="menuitem"]:not(:disabled),textarea[role="menuitem"]:not(:disabled),button[role="menuitem"]:not(:disabled),*[tabindex]:not([tabindex="-1"])';
const handleMouseUpByBlurring = ({ currentTarget })=>currentTarget.blur();
function nextFocusableNode(node, filter) {
    const allFocusableElements = [
        ...document.querySelectorAll(FOCUSABLE_SELECTOR)
    ];
    const sliceLocation = allFocusableElements.indexOf(node) + 1;
    const focusableElementsAfterNode = allFocusableElements.slice(sliceLocation);
    for (const focusableElement of focusableElementsAfterNode){
        if ((0, _isElementInViewportJs.isElementInViewport)(focusableElement) && (!filter || filter && filter(focusableElement))) return focusableElement;
    }
    return null;
}
function findFirstFocusableNode(element, onlyDescendants = true) {
    if (!onlyDescendants && matches(element, FOCUSABLE_SELECTOR)) return element;
    return element.querySelector(FOCUSABLE_SELECTOR);
} // Popover needs to be able to find its activator even if it is disabled, which FOCUSABLE_SELECTOR doesn't support.
function findFirstFocusableNodeIncludingDisabled(element) {
    const focusableSelector = `a,button,frame,iframe,input:not([type=hidden]),select,textarea,*[tabindex]`;
    if (matches(element, focusableSelector)) return element;
    return element.querySelector(focusableSelector);
}
function focusFirstFocusableNode(element, onlyDescendants = true) {
    var _findFirstFocusableNo;
    (_findFirstFocusableNo = findFirstFocusableNode(element, onlyDescendants)) === null || _findFirstFocusableNo === void 0 || _findFirstFocusableNo.focus();
}
function focusNextFocusableNode(node, filter) {
    const nextFocusable = nextFocusableNode(node, filter);
    if (nextFocusable && nextFocusable instanceof HTMLElement) {
        nextFocusable.focus();
        return true;
    }
    return false;
}
function findFirstKeyboardFocusableNode(element, onlyDescendants = true) {
    if (!onlyDescendants && matches(element, KEYBOARD_FOCUSABLE_SELECTORS)) return element;
    return element.querySelector(KEYBOARD_FOCUSABLE_SELECTORS);
}
function focusFirstKeyboardFocusableNode(element, onlyDescendants = true) {
    const firstFocusable = findFirstKeyboardFocusableNode(element, onlyDescendants);
    if (firstFocusable) {
        firstFocusable.focus();
        return true;
    }
    return false;
}
function findLastKeyboardFocusableNode(element, onlyDescendants = true) {
    if (!onlyDescendants && matches(element, KEYBOARD_FOCUSABLE_SELECTORS)) return element;
    const allFocusable = element.querySelectorAll(KEYBOARD_FOCUSABLE_SELECTORS);
    return allFocusable[allFocusable.length - 1];
}
function focusLastKeyboardFocusableNode(element, onlyDescendants = true) {
    const lastFocusable = findLastKeyboardFocusableNode(element, onlyDescendants);
    if (lastFocusable) {
        lastFocusable.focus();
        return true;
    }
    return false;
}
function wrapFocusPreviousFocusableMenuItem(parentElement, currentFocusedElement) {
    const allFocusableChildren = getMenuFocusableDescendants(parentElement);
    const currentItemIdx = getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement);
    if (currentItemIdx === -1) allFocusableChildren[0].focus();
    else allFocusableChildren[(currentItemIdx - 1 + allFocusableChildren.length) % allFocusableChildren.length].focus();
}
function wrapFocusNextFocusableMenuItem(parentElement, currentFocusedElement) {
    const allFocusableChildren = getMenuFocusableDescendants(parentElement);
    const currentItemIdx = getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement);
    if (currentItemIdx === -1) allFocusableChildren[0].focus();
    else allFocusableChildren[(currentItemIdx + 1) % allFocusableChildren.length].focus();
}
function getMenuFocusableDescendants(element) {
    return element.querySelectorAll(MENUITEM_FOCUSABLE_SELECTORS);
}
function getCurrentFocusedElementIndex(allFocusableChildren, currentFocusedElement) {
    let currentItemIdx = 0;
    for (const focusableChild of allFocusableChildren){
        if (focusableChild === currentFocusedElement) break;
        currentItemIdx++;
    }
    return currentItemIdx === allFocusableChildren.length ? -1 : currentItemIdx;
}
function matches(node, selector) {
    if (node.matches) return node.matches(selector);
    const matches = (node.ownerDocument || document).querySelectorAll(selector);
    let i = matches.length;
    while(--i >= 0 && matches.item(i) !== node)return i > -1;
}

},{"./is-element-in-viewport.js":"6mn85","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6mn85":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElementInViewport", ()=>isElementInViewport);
function isElementInViewport(element) {
    const { top, left, bottom, right } = element.getBoundingClientRect();
    return top >= 0 && right <= window.innerWidth && bottom <= window.innerHeight && left >= 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h706v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _itemJs = require("../Item/Item.js");
var _boxJs = require("../../../Box/Box.js");
var _textJs = require("../../../Text/Text.js");
function Section({ section, hasMultipleSections, isFirst, actionRole, onActionAnyItem }) {
    const handleAction = (itemOnAction)=>{
        return ()=>{
            if (itemOnAction) itemOnAction();
            if (onActionAnyItem) onActionAnyItem();
        };
    };
    const actionMarkup = section.items.map(({ content, helpText, onAction, ...item }, index)=>{
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: `${content}-${index}`,
            role: actionRole === "menuitem" ? "presentation" : undefined
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), Object.assign({
            content: content,
            helpText: helpText,
            role: actionRole,
            onAction: handleAction(onAction)
        }, item)));
    });
    let titleMarkup = null;
    if (section.title) titleMarkup = typeof section.title === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: "4",
        paddingInlineStart: "4",
        paddingBlockEnd: "2",
        paddingInlineEnd: "4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "p",
        variant: "headingXs"
    }, section.title)) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        padding: "2"
    }, section.title);
    let sectionRole;
    switch(actionRole){
        case "option":
            sectionRole = "presentation";
            break;
        case "menuitem":
            sectionRole = !hasMultipleSections ? "menu" : "presentation";
            break;
        default:
            sectionRole = undefined;
            break;
    }
    const sectionMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, titleMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), Object.assign({
        as: "ul",
        padding: "2"
    }, hasMultipleSections && {
        paddingBlockStart: "0"
    }, sectionRole && {
        role: sectionRole
    }, {
        tabIndex: !hasMultipleSections ? -1 : undefined
    }), actionMarkup));
    return hasMultipleSections ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), Object.assign({
        as: "li",
        role: "presentation",
        borderColor: "border-subdued"
    }, !isFirst && {
        borderBlockStartWidth: "1"
    }, !section.title && {
        paddingBlockStart: "2"
    }), sectionMarkup) : sectionMarkup;
}

},{"react":"cOWTg","../Item/Item.js":"ckM9Y","../../../Box/Box.js":"lbjkG","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ckM9Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "TruncateText", ()=>TruncateText);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisTokens = require("@shopify/polaris-tokens");
var _cssJs = require("../../../../utilities/css.js");
var _actionListScssJs = require("../../ActionList.scss.js");
var _actionListScssJsDefault = parcelHelpers.interopDefault(_actionListScssJs);
var _focusJs = require("../../../../utilities/focus.js");
var _useIsomorphicLayoutEffectJs = require("../../../../utilities/use-isomorphic-layout-effect.js");
var _badgeJs = require("../../../Badge/Badge.js");
var _tooltipJs = require("../../../Tooltip/Tooltip.js");
var _unstyledLinkJs = require("../../../UnstyledLink/UnstyledLink.js");
var _horizontalStackJs = require("../../../HorizontalStack/HorizontalStack.js");
var _iconJs = require("../../../Icon/Icon.js");
var _boxJs = require("../../../Box/Box.js");
var _textJs = require("../../../Text/Text.js");
var _scrollableJs = require("../../../Scrollable/Scrollable.js");
function Item({ id, badge, content, accessibilityLabel, helpText, url, onAction, onMouseEnter, icon, image, prefix, suffix, disabled, external, destructive, ellipsis, truncate, active, role }) {
    const className = (0, _cssJs.classNames)((0, _actionListScssJsDefault.default).Item, disabled && (0, _actionListScssJsDefault.default).disabled, destructive && (0, _actionListScssJsDefault.default).destructive, active && (0, _actionListScssJsDefault.default).active);
    let prefixMarkup = null;
    if (prefix) prefixMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _actionListScssJsDefault.default).Prefix
    }, prefix);
    else if (icon) prefixMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _actionListScssJsDefault.default).Prefix
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: icon
    }));
    else if (image) prefixMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        role: "presentation",
        className: (0, _actionListScssJsDefault.default).Prefix,
        style: {
            backgroundImage: `url(${image}`
        }
    });
    let contentText = content || "";
    if (truncate && content) contentText = /*#__PURE__*/ (0, _reactDefault.default).createElement(TruncateText, null, content);
    else if (ellipsis) contentText = `${content}\u{2026}`;
    const contentMarkup = helpText ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), null, contentText), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        color: "subdued",
        as: "span"
    }, helpText)) : contentText;
    const badgeMarkup = badge && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _actionListScssJsDefault.default).Suffix
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badgeJs.Badge), {
        status: badge.status
    }, badge.content));
    const suffixMarkup = suffix && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _actionListScssJsDefault.default).Suffix
    }, suffix));
    const textMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _actionListScssJsDefault.default).Text
    }, contentMarkup);
    const contentElement = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        blockAlign: "center",
        gap: "4",
        wrap: !truncate
    }, prefixMarkup, textMarkup, badgeMarkup, suffixMarkup);
    const scrollMarkup = active ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollableJs.Scrollable).ScrollTo, null) : null;
    const control = url ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
        id: id,
        url: disabled ? null : url,
        className: className,
        external: external,
        "aria-label": accessibilityLabel,
        onClick: disabled ? null : onAction,
        role: role
    }, contentElement) : /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        id: id,
        type: "button",
        className: className,
        disabled: disabled,
        "aria-label": accessibilityLabel,
        onClick: onAction,
        onMouseUp: (0, _focusJs.handleMouseUpByBlurring),
        role: role,
        onMouseEnter: onMouseEnter
    }, contentElement);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, scrollMarkup, control);
}
const TruncateText = ({ children })=>{
    const textRef = (0, _react.useRef)(null);
    const [isOverflowing, setIsOverflowing] = (0, _react.useState)(false);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        if (textRef.current) setIsOverflowing(textRef.current.scrollWidth > textRef.current.offsetWidth);
    }, [
        children
    ]);
    const text = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        truncate: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        width: "100%",
        ref: textRef
    }, children));
    return isOverflowing ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
        zIndexOverride: Number((0, _polarisTokens.zIndex)["z-6"]),
        preferredPosition: "above",
        hoverDelay: 1000,
        content: children
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        truncate: true
    }, children)) : text;
};

},{"react":"cOWTg","@shopify/polaris-tokens":"5ENVX","../../../../utilities/css.js":"lGt6N","../../ActionList.scss.js":"8IvHf","../../../../utilities/focus.js":"b0pEc","../../../../utilities/use-isomorphic-layout-effect.js":"2th17","../../../Badge/Badge.js":"8ckUl","../../../Tooltip/Tooltip.js":"k7vL7","../../../UnstyledLink/UnstyledLink.js":"4o3DP","../../../HorizontalStack/HorizontalStack.js":"fotqA","../../../Icon/Icon.js":"6HPny","../../../Box/Box.js":"lbjkG","../../../Text/Text.js":"l8Av9","../../../Scrollable/Scrollable.js":"587xt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lGt6N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classNames", ()=>classNames);
parcelHelpers.export(exports, "getResponsiveProps", ()=>getResponsiveProps);
parcelHelpers.export(exports, "getResponsiveValue", ()=>getResponsiveValue);
parcelHelpers.export(exports, "sanitizeCustomProperties", ()=>sanitizeCustomProperties);
parcelHelpers.export(exports, "variationName", ()=>variationName);
function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function variationName(name, value) {
    return `${name}${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}
function sanitizeCustomProperties(styles) {
    const nonNullValues = Object.entries(styles).filter(([_, value])=>value != null);
    return nonNullValues.length ? Object.fromEntries(nonNullValues) : undefined;
}
function getResponsiveProps(componentName, componentProp, tokenSubgroup, responsiveProp) {
    if (!responsiveProp) return {};
    if (typeof responsiveProp === "string") return {
        [`--pc-${componentName}-${componentProp}-xs`]: `var(--p-${tokenSubgroup}-${responsiveProp})`
    };
    return Object.fromEntries(Object.entries(responsiveProp).map(([breakpointAlias, aliasOrScale])=>[
            `--pc-${componentName}-${componentProp}-${breakpointAlias}`,
            `var(--p-${tokenSubgroup}-${aliasOrScale})`
        ]));
}
function getResponsiveValue(componentName, componentProp, responsiveProp) {
    if (!responsiveProp) return {};
    if (typeof responsiveProp === "string") return {
        [`--pc-${componentName}-${componentProp}-xs`]: responsiveProp
    };
    return Object.fromEntries(Object.entries(responsiveProp).map(([breakpointAlias, responsiveValue])=>[
            `--pc-${componentName}-${componentProp}-${breakpointAlias}`,
            responsiveValue
        ]));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8IvHf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Item": "Polaris-ActionList__Item",
    "active": "Polaris-ActionList--active",
    "destructive": "Polaris-ActionList--destructive",
    "disabled": "Polaris-ActionList--disabled",
    "Prefix": "Polaris-ActionList__Prefix",
    "Suffix": "Polaris-ActionList__Suffix",
    "Text": "Polaris-ActionList__Text"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8ckUl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _withinFilterContextJs = require("../../utilities/within-filter-context.js");
var _badgeScssJs = require("./Badge.scss.js");
var _badgeScssJsDefault = parcelHelpers.interopDefault(_badgeScssJs);
var _utilsJs = require("./utils.js");
var _pipJs = require("./components/Pip/Pip.js");
var _iconJs = require("../Icon/Icon.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _textJs = require("../Text/Text.js");
const DEFAULT_SIZE = "medium";
function Badge({ children, status, progress, icon, size = DEFAULT_SIZE, statusAndProgressLabelOverride }) {
    const i18n = (0, _hooksJs.useI18n)();
    const withinFilter = (0, _react.useContext)((0, _withinFilterContextJs.WithinFilterContext));
    const className = (0, _cssJs.classNames)((0, _badgeScssJsDefault.default).Badge, status && (0, _badgeScssJsDefault.default)[(0, _cssJs.variationName)("status", status)], icon && (0, _badgeScssJsDefault.default).icon, size && size !== DEFAULT_SIZE && (0, _badgeScssJsDefault.default)[(0, _cssJs.variationName)("size", size)], withinFilter && (0, _badgeScssJsDefault.default).withinFilter);
    const accessibilityLabel = statusAndProgressLabelOverride ? statusAndProgressLabelOverride : (0, _utilsJs.getDefaultAccessibilityLabel)(i18n, progress, status);
    let accessibilityMarkup = Boolean(accessibilityLabel) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, accessibilityLabel);
    if (progress && !icon) accessibilityMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _badgeScssJsDefault.default).PipContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pipJs.Pip), {
        progress: progress,
        status: status,
        accessibilityLabelOverride: accessibilityLabel
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    }, accessibilityMarkup, icon && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _badgeScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: icon
    })), children && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        variant: "bodySm",
        fontWeight: status === "new" ? "medium" : undefined
    }, children));
}
Badge.Pip = (0, _pipJs.Pip);

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/within-filter-context.js":"8qxM0","./Badge.scss.js":"gHwI3","./utils.js":"llRUy","./components/Pip/Pip.js":"5Qmux","../Icon/Icon.js":"6HPny","../../utilities/i18n/hooks.js":"hhMhA","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8qxM0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithinFilterContext", ()=>WithinFilterContext);
var _react = require("react");
const WithinFilterContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gHwI3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Badge": "Polaris-Badge",
    "statusSuccess": "Polaris-Badge--statusSuccess",
    "statusInfo": "Polaris-Badge--statusInfo",
    "statusAttention": "Polaris-Badge--statusAttention",
    "statusWarning": "Polaris-Badge--statusWarning",
    "statusCritical": "Polaris-Badge--statusCritical",
    "statusNew": "Polaris-Badge--statusNew",
    "withinFilter": "Polaris-Badge--withinFilter",
    "Icon": "Polaris-Badge__Icon",
    "PipContainer": "Polaris-Badge__PipContainer"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"llRUy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultAccessibilityLabel", ()=>getDefaultAccessibilityLabel);
var _typesJs = require("./types.js");
function getDefaultAccessibilityLabel(i18n, progress, status) {
    let progressLabel = "";
    let statusLabel = "";
    if (!progress && !status) return "";
    switch(progress){
        case (0, _typesJs.ProgressValue).Incomplete:
            progressLabel = i18n.translate("Polaris.Badge.PROGRESS_LABELS.incomplete");
            break;
        case (0, _typesJs.ProgressValue).PartiallyComplete:
            progressLabel = i18n.translate("Polaris.Badge.PROGRESS_LABELS.partiallyComplete");
            break;
        case (0, _typesJs.ProgressValue).Complete:
            progressLabel = i18n.translate("Polaris.Badge.PROGRESS_LABELS.complete");
            break;
    }
    switch(status){
        case (0, _typesJs.StatusValue).Info:
            statusLabel = i18n.translate("Polaris.Badge.STATUS_LABELS.info");
            break;
        case (0, _typesJs.StatusValue).Success:
            statusLabel = i18n.translate("Polaris.Badge.STATUS_LABELS.success");
            break;
        case (0, _typesJs.StatusValue).Warning:
            statusLabel = i18n.translate("Polaris.Badge.STATUS_LABELS.warning");
            break;
        case (0, _typesJs.StatusValue).Critical:
            statusLabel = i18n.translate("Polaris.Badge.STATUS_LABELS.critical");
            break;
        case (0, _typesJs.StatusValue).Attention:
            statusLabel = i18n.translate("Polaris.Badge.STATUS_LABELS.attention");
            break;
        case (0, _typesJs.StatusValue).New:
            statusLabel = i18n.translate("Polaris.Badge.STATUS_LABELS.new");
            break;
    }
    if (!status && progress) return progressLabel;
    else if (status && !progress) return statusLabel;
    else return i18n.translate("Polaris.Badge.progressAndStatus", {
        progressLabel,
        statusLabel
    });
}

},{"./types.js":"e8lke","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e8lke":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressValue", ()=>ProgressValue);
parcelHelpers.export(exports, "StatusValue", ()=>StatusValue);
let StatusValue;
(function(StatusValue) {
    StatusValue["Info"] = "info";
    StatusValue["Success"] = "success";
    StatusValue["Warning"] = "warning";
    StatusValue["Critical"] = "critical";
    StatusValue["Attention"] = "attention";
    StatusValue["New"] = "new";
})(StatusValue || (StatusValue = {}));
let ProgressValue;
(function(ProgressValue) {
    ProgressValue["Incomplete"] = "incomplete";
    ProgressValue["PartiallyComplete"] = "partiallyComplete";
    ProgressValue["Complete"] = "complete";
})(ProgressValue || (ProgressValue = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Qmux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pip", ()=>Pip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _utilsJs = require("../../utils.js");
var _pipScssJs = require("./Pip.scss.js");
var _pipScssJsDefault = parcelHelpers.interopDefault(_pipScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _textJs = require("../../../Text/Text.js");
function Pip({ status, progress = "complete", accessibilityLabelOverride }) {
    const i18n = (0, _hooksJs.useI18n)();
    const className = (0, _cssJs.classNames)((0, _pipScssJsDefault.default).Pip, status && (0, _pipScssJsDefault.default)[(0, _cssJs.variationName)("status", status)], progress && (0, _pipScssJsDefault.default)[(0, _cssJs.variationName)("progress", progress)]);
    const accessibilityLabel = accessibilityLabelOverride ? accessibilityLabelOverride : (0, _utilsJs.getDefaultAccessibilityLabel)(i18n, progress, status);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, accessibilityLabel));
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../utils.js":"llRUy","./Pip.scss.js":"2w2qI","../../../../utilities/i18n/hooks.js":"hhMhA","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2w2qI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Pip": "Polaris-Badge-Pip",
    "statusInfo": "Polaris-Badge-Pip--statusInfo",
    "statusSuccess": "Polaris-Badge-Pip--statusSuccess",
    "statusNew": "Polaris-Badge-Pip--statusNew",
    "statusAttention": "Polaris-Badge-Pip--statusAttention",
    "statusWarning": "Polaris-Badge-Pip--statusWarning",
    "statusCritical": "Polaris-Badge-Pip--statusCritical",
    "progressIncomplete": "Polaris-Badge-Pip--progressIncomplete",
    "progressPartiallyComplete": "Polaris-Badge-Pip--progressPartiallyComplete",
    "progressComplete": "Polaris-Badge-Pip--progressComplete"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hhMhA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useI18n", ()=>useI18n);
var _react = require("react");
var _errorsJs = require("../errors.js");
var _contextJs = require("./context.js");
function useI18n() {
    const i18n = (0, _react.useContext)((0, _contextJs.I18nContext));
    if (!i18n) throw new (0, _errorsJs.MissingAppProviderError)("No i18n was provided.");
    return i18n;
}

},{"react":"cOWTg","../errors.js":"HUtaY","./context.js":"byRrd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"HUtaY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MissingAppProviderError", ()=>MissingAppProviderError);
class MissingAppProviderError extends Error {
    constructor(message = ""){
        super(`${message ? `${message} ` : message}Your application must be wrapped in an <AppProvider> component. See https://polaris.shopify.com/components/app-provider for implementation instructions.`);
        this.name = "MissingAppProviderError";
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l8Av9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _textScssJs = require("./Text.scss.js");
var _textScssJsDefault = parcelHelpers.interopDefault(_textScssJs);
const Text = ({ alignment, as, breakWord, children, color, fontWeight, id, numeric = false, truncate = false, variant, visuallyHidden = false })=>{
    const Component = as || (visuallyHidden ? "span" : "p");
    const className = (0, _cssJs.classNames)((0, _textScssJsDefault.default).root, variant && (0, _textScssJsDefault.default)[variant], fontWeight && (0, _textScssJsDefault.default)[fontWeight], (alignment || truncate) && (0, _textScssJsDefault.default).block, alignment && (0, _textScssJsDefault.default)[alignment], breakWord && (0, _textScssJsDefault.default).break, color && (0, _textScssJsDefault.default)[color], numeric && (0, _textScssJsDefault.default).numeric, truncate && (0, _textScssJsDefault.default).truncate, visuallyHidden && (0, _textScssJsDefault.default).visuallyHidden);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, Object.assign({
        className: className
    }, id && {
        id
    }), children);
};

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Text.scss.js":"klqCo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"klqCo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "root": "Polaris-Text--root",
    "block": "Polaris-Text--block",
    "truncate": "Polaris-Text--truncate",
    "visuallyHidden": "Polaris-Text--visuallyHidden",
    "start": "Polaris-Text--start",
    "center": "Polaris-Text--center",
    "end": "Polaris-Text--end",
    "justify": "Polaris-Text--justify",
    "success": "Polaris-Text--success",
    "critical": "Polaris-Text--critical",
    "warning": "Polaris-Text--warning",
    "subdued": "Polaris-Text--subdued",
    "text-inverse": "Polaris-Text__text--inverse",
    "headingXs": "Polaris-Text--headingXs",
    "headingSm": "Polaris-Text--headingSm",
    "headingMd": "Polaris-Text--headingMd",
    "headingLg": "Polaris-Text--headingLg",
    "headingXl": "Polaris-Text--headingXl",
    "heading2xl": "Polaris-Text--heading2xl",
    "heading3xl": "Polaris-Text--heading3xl",
    "heading4xl": "Polaris-Text--heading4xl",
    "bodySm": "Polaris-Text--bodySm",
    "bodyMd": "Polaris-Text--bodyMd",
    "bodyLg": "Polaris-Text--bodyLg",
    "regular": "Polaris-Text--regular",
    "medium": "Polaris-Text--medium",
    "semibold": "Polaris-Text--semibold",
    "bold": "Polaris-Text--bold",
    "break": "Polaris-Text--break",
    "numeric": "Polaris-Text--numeric"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6HPny":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon", ()=>Icon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _iconScssJs = require("./Icon.scss.js");
var _iconScssJsDefault = parcelHelpers.interopDefault(_iconScssJs);
var _textJs = require("../Text/Text.js");
const COLORS_WITH_BACKDROPS = [
    "base",
    "critical",
    "highlight",
    "success",
    "warning"
];
function Icon({ source, color, backdrop, accessibilityLabel }) {
    let sourceType;
    if (typeof source === "function") sourceType = "function";
    else if (source === "placeholder") sourceType = "placeholder";
    else sourceType = "external";
    backdrop && color && COLORS_WITH_BACKDROPS.includes(color);
    const className = (0, _cssJs.classNames)((0, _iconScssJsDefault.default).Icon, color && (0, _iconScssJsDefault.default)[(0, _cssJs.variationName)("color", color)], color && (0, _iconScssJsDefault.default).applyColor, backdrop && (0, _iconScssJsDefault.default).hasBackdrop);
    const SourceComponent = source;
    const contentMarkup = {
        function: /*#__PURE__*/ (0, _reactDefault.default).createElement(SourceComponent, {
            className: (0, _iconScssJsDefault.default).Svg,
            focusable: "false",
            "aria-hidden": "true"
        }),
        placeholder: /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _iconScssJsDefault.default).Placeholder
        }),
        external: /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
            className: (0, _iconScssJsDefault.default).Img,
            src: `data:image/svg+xml;utf8,${source}`,
            alt: "",
            "aria-hidden": "true"
        })
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, accessibilityLabel), contentMarkup[sourceType]);
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Icon.scss.js":"d2F2Q","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d2F2Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Icon": "Polaris-Icon",
    "applyColor": "Polaris-Icon--applyColor",
    "hasBackdrop": "Polaris-Icon--hasBackdrop",
    "colorBase": "Polaris-Icon--colorBase",
    "colorSubdued": "Polaris-Icon--colorSubdued",
    "colorCritical": "Polaris-Icon--colorCritical",
    "colorInteractive": "Polaris-Icon--colorInteractive",
    "colorWarning": "Polaris-Icon--colorWarning",
    "colorHighlight": "Polaris-Icon--colorHighlight",
    "colorSuccess": "Polaris-Icon--colorSuccess",
    "colorPrimary": "Polaris-Icon--colorPrimary",
    "colorMagic": "Polaris-Icon--colorMagic",
    "Svg": "Polaris-Icon__Svg",
    "Img": "Polaris-Icon__Img",
    "Placeholder": "Polaris-Icon__Placeholder"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k7vL7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focusJs = require("../../utilities/focus.js");
var _useToggleJs = require("../../utilities/use-toggle.js");
var _cssJs = require("../../utilities/css.js");
var _tooltipScssJs = require("./Tooltip.scss.js");
var _tooltipScssJsDefault = parcelHelpers.interopDefault(_tooltipScssJs);
var _hooksJs = require("../../utilities/ephemeral-presence-manager/hooks.js");
var _tooltipOverlayJs = require("./components/TooltipOverlay/TooltipOverlay.js");
var _hooksJs1 = require("../../utilities/unique-id/hooks.js");
var _portalJs = require("../Portal/Portal.js");
const HOVER_OUT_TIMEOUT = 150;
function Tooltip({ children, content, dismissOnMouseOut, active: originalActive, hoverDelay, preferredPosition = "above", activatorWrapper = "span", accessibilityLabel, width = "default", padding = "default", borderRadius = "1", zIndexOverride, hasUnderline, persistOnClick, onOpen, onClose }) {
    const WrapperComponent = activatorWrapper;
    const { value: active, setTrue: setActiveTrue, setFalse: handleBlur } = (0, _useToggleJs.useToggle)(Boolean(originalActive));
    const { value: persist, toggle: togglePersisting } = (0, _useToggleJs.useToggle)(Boolean(originalActive) && Boolean(persistOnClick));
    const [activatorNode, setActivatorNode] = (0, _react.useState)(null);
    const { presenceList, addPresence, removePresence } = (0, _hooksJs.useEphemeralPresenceManager)();
    const id = (0, _hooksJs1.useUniqueId)("TooltipContent");
    const activatorContainer = (0, _react.useRef)(null);
    const mouseEntered = (0, _react.useRef)(false);
    const [shouldAnimate, setShouldAnimate] = (0, _react.useState)(Boolean(!originalActive));
    const hoverDelayTimeout = (0, _react.useRef)(null);
    const hoverOutTimeout = (0, _react.useRef)(null);
    const handleFocus = (0, _react.useCallback)(()=>{
        if (originalActive !== false) setActiveTrue();
    }, [
        originalActive,
        setActiveTrue
    ]);
    (0, _react.useEffect)(()=>{
        const firstFocusable = activatorContainer.current ? (0, _focusJs.findFirstFocusableNode)(activatorContainer.current) : null;
        const accessibilityNode = firstFocusable || activatorContainer.current;
        if (!accessibilityNode) return;
        accessibilityNode.tabIndex = 0;
        accessibilityNode.setAttribute("aria-describedby", id);
        accessibilityNode.setAttribute("data-polaris-tooltip-activator", "true");
    }, [
        id,
        children
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (hoverDelayTimeout.current) clearTimeout(hoverDelayTimeout.current);
            if (hoverOutTimeout.current) clearTimeout(hoverOutTimeout.current);
        };
    }, []);
    const handleOpen = (0, _react.useCallback)(()=>{
        setShouldAnimate(!presenceList.tooltip && !active);
        onOpen === null || onOpen === void 0 || onOpen();
        addPresence("tooltip");
    }, [
        addPresence,
        presenceList.tooltip,
        onOpen,
        active
    ]);
    const handleClose = (0, _react.useCallback)(()=>{
        onClose === null || onClose === void 0 || onClose();
        setShouldAnimate(false);
        hoverOutTimeout.current = setTimeout(()=>{
            removePresence("tooltip");
        }, HOVER_OUT_TIMEOUT);
    }, [
        removePresence,
        onClose
    ]);
    const handleKeyUp = (0, _react.useCallback)((event)=>{
        if (event.key !== "Escape") return;
        handleClose === null || handleClose === void 0 || handleClose();
        handleBlur();
        persistOnClick && togglePersisting();
    }, [
        handleBlur,
        handleClose,
        persistOnClick,
        togglePersisting
    ]);
    const portal = activatorNode ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalJs.Portal), {
        idPrefix: "tooltip"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipOverlayJs.TooltipOverlay), {
        id: id,
        preferredPosition: preferredPosition,
        activator: activatorNode,
        active: active,
        accessibilityLabel: accessibilityLabel,
        onClose: noop,
        preventInteraction: dismissOnMouseOut,
        width: width,
        padding: padding,
        borderRadius: borderRadius,
        zIndexOverride: zIndexOverride,
        instant: !shouldAnimate
    }, content)) : null;
    const wrapperClassNames = (0, _cssJs.classNames)(activatorWrapper === "div" && (0, _tooltipScssJsDefault.default).TooltipContainer, hasUnderline && (0, _tooltipScssJsDefault.default).HasUnderline);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapperComponent, {
        onFocus: ()=>{
            handleOpen();
            handleFocus();
        },
        onBlur: ()=>{
            handleClose();
            handleBlur();
            if (persistOnClick) togglePersisting();
        },
        onMouseLeave: handleMouseLeave,
        onMouseOver: handleMouseEnterFix,
        onMouseDown: persistOnClick ? togglePersisting : undefined,
        ref: setActivator,
        onKeyUp: handleKeyUp,
        className: wrapperClassNames
    }, children, portal);
    function setActivator(node) {
        const activatorContainerRef = activatorContainer;
        if (node == null) {
            activatorContainerRef.current = null;
            setActivatorNode(null);
            return;
        }
        node.firstElementChild instanceof HTMLElement && setActivatorNode(node.firstElementChild);
        activatorContainerRef.current = node;
    }
    function handleMouseEnter() {
        mouseEntered.current = true;
        if (hoverDelay && !presenceList.tooltip) hoverDelayTimeout.current = setTimeout(()=>{
            handleOpen();
            handleFocus();
        }, hoverDelay);
        else {
            handleOpen();
            handleFocus();
        }
    }
    function handleMouseLeave() {
        if (hoverDelayTimeout.current) {
            clearTimeout(hoverDelayTimeout.current);
            hoverDelayTimeout.current = null;
        }
        mouseEntered.current = false;
        handleClose();
        if (!persist) handleBlur();
    } // https://github.com/facebook/react/issues/10109
    // Mouseenter event not triggered when cursor moves from disabled button
    function handleMouseEnterFix() {
        !mouseEntered.current && handleMouseEnter();
    }
}
function noop() {}

},{"react":"cOWTg","../../utilities/focus.js":"b0pEc","../../utilities/use-toggle.js":"2kpDL","../../utilities/css.js":"lGt6N","./Tooltip.scss.js":"l7gYW","../../utilities/ephemeral-presence-manager/hooks.js":"jITbl","./components/TooltipOverlay/TooltipOverlay.js":"51g8c","../../utilities/unique-id/hooks.js":"2JfcO","../Portal/Portal.js":"3wn3c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2kpDL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToggle", ()=>useToggle);
var _react = require("react");
/**
 * Returns a stateful value, and a set of memoized functions to toggle it,
 * set it to true and set it to false
 */ function useToggle(initialState) {
    const [value, setState] = (0, _react.useState)(initialState);
    return {
        value,
        toggle: (0, _react.useCallback)(()=>setState((state)=>!state), []),
        setTrue: (0, _react.useCallback)(()=>setState(true), []),
        setFalse: (0, _react.useCallback)(()=>setState(false), [])
    };
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l7gYW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "TooltipContainer": "Polaris-Tooltip__TooltipContainer",
    "HasUnderline": "Polaris-Tooltip__HasUnderline"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jITbl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEphemeralPresenceManager", ()=>useEphemeralPresenceManager);
parcelHelpers.export(exports, "useReadOnlyEphemeralPresenceManager", ()=>useReadOnlyEphemeralPresenceManager);
var _react = require("react");
var _contextJs = require("./context.js");
function useEphemeralPresenceManager() {
    const ephemeralPresenceManager = (0, _react.useContext)((0, _contextJs.EphemeralPresenceManagerContext));
    if (!ephemeralPresenceManager) throw new Error("No ephemeral presence manager was provided. Your application must be wrapped in an <AppProvider> component. See https://polaris.shopify.com/components/app-provider for implementation instructions.");
    return ephemeralPresenceManager;
}
function useReadOnlyEphemeralPresenceManager() {
    const { presenceList, presenceCounter } = useEphemeralPresenceManager();
    return {
        presenceList,
        presenceCounter
    };
}

},{"react":"cOWTg","./context.js":"zFanZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"51g8c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipOverlay", ()=>TooltipOverlay);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _sharedJs = require("../../../shared.js");
var _tooltipOverlayScssJs = require("./TooltipOverlay.scss.js");
var _tooltipOverlayScssJsDefault = parcelHelpers.interopDefault(_tooltipOverlayScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _positionedOverlayJs = require("../../../PositionedOverlay/PositionedOverlay.js");
function TooltipOverlay({ active, activator, preferredPosition = "above", preventInteraction, id, children, accessibilityLabel, width, padding, borderRadius, zIndexOverride, instant }) {
    const i18n = (0, _hooksJs.useI18n)();
    const markup = active ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _positionedOverlayJs.PositionedOverlay), {
        active: active,
        activator: activator,
        preferredPosition: preferredPosition,
        preventInteraction: preventInteraction,
        render: renderTooltip,
        zIndexOverride: zIndexOverride
    }) : null;
    return markup;
    function renderTooltip(overlayDetails) {
        const { measuring, desiredHeight, positioning, chevronOffset } = overlayDetails;
        const containerClassName = (0, _cssJs.classNames)((0, _tooltipOverlayScssJsDefault.default).TooltipOverlay, measuring && (0, _tooltipOverlayScssJsDefault.default).measuring, !measuring && (0, _tooltipOverlayScssJsDefault.default).measured, instant && (0, _tooltipOverlayScssJsDefault.default).instant, positioning === "above" && (0, _tooltipOverlayScssJsDefault.default).positionedAbove);
        const contentClassName = (0, _cssJs.classNames)((0, _tooltipOverlayScssJsDefault.default).Content, width && (0, _tooltipOverlayScssJsDefault.default)[width]);
        const contentStyles = measuring ? undefined : {
            minHeight: desiredHeight
        };
        const style = {
            "--pc-tooltip-chevron-x-pos": `${chevronOffset}px`,
            "--pc-tooltip-border-radius": borderRadius ? `var(--p-border-radius-${borderRadius})` : undefined,
            "--pc-tooltip-padding": padding && padding === "default" ? "var(--p-space-1) var(--p-space-2)" : `var(--p-space-${padding})`
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
            style: style,
            className: containerClassName
        }, (0, _sharedJs.layer).props), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            id: id,
            role: "tooltip",
            className: contentClassName,
            style: {
                ...contentStyles,
                ...style
            },
            "aria-label": accessibilityLabel ? i18n.translate("Polaris.TooltipOverlay.accessibilityLabel", {
                label: accessibilityLabel
            }) : undefined
        }, children));
    }
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../shared.js":"lFbIK","./TooltipOverlay.scss.js":"i9DHY","../../../../utilities/i18n/hooks.js":"hhMhA","../../../PositionedOverlay/PositionedOverlay.js":"2r8yP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i9DHY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "TooltipOverlay": "Polaris-Tooltip-TooltipOverlay",
    "positionedAbove": "Polaris-Tooltip-TooltipOverlay--positionedAbove",
    "measuring": "Polaris-Tooltip-TooltipOverlay--measuring",
    "measured": "Polaris-Tooltip-TooltipOverlay--measured",
    "instant": "Polaris-Tooltip-TooltipOverlay--instant",
    "Content": "Polaris-Tooltip-TooltipOverlay__Content",
    "default": "Polaris-Tooltip-TooltipOverlay--default",
    "wide": "Polaris-Tooltip-TooltipOverlay--wide"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2r8yP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PositionedOverlay", ()=>PositionedOverlay);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _geometryJs = require("../../utilities/geometry.js");
var _sharedJs = require("../shared.js");
var _mathJs = require("./utilities/math.js");
var _positionedOverlayScssJs = require("./PositionedOverlay.scss.js");
var _positionedOverlayScssJsDefault = parcelHelpers.interopDefault(_positionedOverlayScssJs);
var _scrollableJs = require("../Scrollable/Scrollable.js");
var _eventListenerJs = require("../EventListener/EventListener.js");
const OBSERVER_CONFIG = {
    childList: true,
    subtree: true,
    characterData: true,
    attributeFilter: [
        "style"
    ]
};
class PositionedOverlay extends (0, _react.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            measuring: true,
            activatorRect: (0, _geometryJs.getRectForNode)(this.props.activator),
            right: undefined,
            left: undefined,
            top: 0,
            height: 0,
            width: null,
            positioning: "below",
            zIndex: null,
            outsideScrollableContainer: false,
            lockPosition: false,
            chevronOffset: 0
        };
        this.overlay = null;
        this.scrollableContainers = [];
        this.observer = void 0;
        this.overlayDetails = ()=>{
            const { measuring, left, right, positioning, height, activatorRect, chevronOffset } = this.state;
            return {
                measuring,
                left,
                right,
                desiredHeight: height,
                positioning,
                activatorRect,
                chevronOffset
            };
        };
        this.setOverlay = (node)=>{
            this.overlay = node;
        };
        this.setScrollableContainers = ()=>{
            const containers = [];
            let scrollableContainer = (0, _scrollableJs.Scrollable).forNode(this.props.activator);
            if (scrollableContainer) {
                containers.push(scrollableContainer);
                while((_scrollableContainer = scrollableContainer) !== null && _scrollableContainer !== void 0 && _scrollableContainer.parentElement){
                    var _scrollableContainer;
                    scrollableContainer = (0, _scrollableJs.Scrollable).forNode(scrollableContainer.parentElement);
                    containers.push(scrollableContainer);
                }
            }
            this.scrollableContainers = containers;
        };
        this.registerScrollHandlers = ()=>{
            this.scrollableContainers.forEach((node)=>{
                node.addEventListener("scroll", this.handleMeasurement);
            });
        };
        this.unregisterScrollHandlers = ()=>{
            this.scrollableContainers.forEach((node)=>{
                node.removeEventListener("scroll", this.handleMeasurement);
            });
        };
        this.handleMeasurement = ()=>{
            const { lockPosition, top } = this.state;
            this.observer.disconnect();
            this.setState(({ left, top, right })=>({
                    left,
                    right,
                    top,
                    height: 0,
                    positioning: "below",
                    measuring: true
                }), ()=>{
                if (this.overlay == null || this.firstScrollableContainer == null) return;
                const { activator, preferredPosition = "below", preferredAlignment = "center", onScrollOut, fullWidth, fixed, preferInputActivator = true } = this.props;
                const preferredActivator = preferInputActivator ? activator.querySelector("input") || activator : activator;
                const activatorRect = (0, _geometryJs.getRectForNode)(preferredActivator);
                const currentOverlayRect = (0, _geometryJs.getRectForNode)(this.overlay);
                const scrollableElement = isDocument(this.firstScrollableContainer) ? document.body : this.firstScrollableContainer;
                const scrollableContainerRect = (0, _geometryJs.getRectForNode)(scrollableElement);
                const overlayRect = fullWidth ? new (0, _geometryJs.Rect)({
                    ...currentOverlayRect,
                    width: activatorRect.width
                }) : currentOverlayRect; // If `body` is 100% height, it still acts as though it were not constrained to that size. This adjusts for that.
                if (scrollableElement === document.body) scrollableContainerRect.height = document.body.scrollHeight;
                let topBarOffset = 0;
                const topBarElement = scrollableElement.querySelector(`${(0, _sharedJs.dataPolarisTopBar).selector}`);
                if (topBarElement) topBarOffset = topBarElement.clientHeight;
                const overlayMargins = this.overlay.firstElementChild && this.overlay.firstChild instanceof HTMLElement ? getMarginsForNode(this.overlay.firstElementChild) : {
                    activator: 0,
                    container: 0,
                    horizontal: 0
                };
                const containerRect = (0, _mathJs.windowRect)();
                const zIndexForLayer = getZIndexForLayerFromNode(activator);
                const zIndex = zIndexForLayer == null ? zIndexForLayer : zIndexForLayer + 1;
                const verticalPosition = (0, _mathJs.calculateVerticalPosition)(activatorRect, overlayRect, overlayMargins, scrollableContainerRect, containerRect, preferredPosition, fixed, topBarOffset);
                const horizontalPosition = (0, _mathJs.calculateHorizontalPosition)(activatorRect, overlayRect, containerRect, overlayMargins, preferredAlignment);
                const chevronOffset = activatorRect.center.x - horizontalPosition;
                this.setState({
                    measuring: false,
                    activatorRect: (0, _geometryJs.getRectForNode)(activator),
                    left: preferredAlignment !== "right" ? horizontalPosition : undefined,
                    right: preferredAlignment === "right" ? horizontalPosition : undefined,
                    top: lockPosition ? top : verticalPosition.top,
                    lockPosition: Boolean(fixed),
                    height: verticalPosition.height || 0,
                    width: fullWidth ? overlayRect.width : null,
                    positioning: verticalPosition.positioning,
                    outsideScrollableContainer: onScrollOut != null && (0, _mathJs.rectIsOutsideOfRect)(activatorRect, (0, _mathJs.intersectionWithViewport)(scrollableContainerRect)),
                    zIndex,
                    chevronOffset
                }, ()=>{
                    if (!this.overlay) return;
                    this.observer.observe(this.overlay, OBSERVER_CONFIG);
                    this.observer.observe(activator, OBSERVER_CONFIG);
                });
            });
        };
        this.observer = new MutationObserver(this.handleMeasurement);
    }
    componentDidMount() {
        this.setScrollableContainers();
        if (this.scrollableContainers.length && !this.props.fixed) this.registerScrollHandlers();
        this.handleMeasurement();
    }
    componentWillUnmount() {
        this.observer.disconnect();
        if (this.scrollableContainers.length && !this.props.fixed) this.unregisterScrollHandlers();
    }
    componentDidUpdate() {
        const { outsideScrollableContainer, top } = this.state;
        const { onScrollOut, active } = this.props;
        if (active && onScrollOut != null && top !== 0 && outsideScrollableContainer) onScrollOut();
    }
    render() {
        const { left, right, top, zIndex, width } = this.state;
        const { render, fixed, preventInteraction, classNames: propClassNames, zIndexOverride } = this.props;
        const style = {
            top: top == null || isNaN(top) ? undefined : top,
            left: left == null || isNaN(left) ? undefined : left,
            right: right == null || isNaN(right) ? undefined : right,
            width: width == null || isNaN(width) ? undefined : width,
            zIndex: zIndexOverride || zIndex || undefined
        };
        const className = (0, _cssJs.classNames)((0, _positionedOverlayScssJsDefault.default).PositionedOverlay, fixed && (0, _positionedOverlayScssJsDefault.default).fixed, preventInteraction && (0, _positionedOverlayScssJsDefault.default).preventInteraction, propClassNames);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: className,
            style: style,
            ref: this.setOverlay
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
            event: "resize",
            handler: this.handleMeasurement
        }), render(this.overlayDetails()));
    }
    get firstScrollableContainer() {
        var _this$scrollableConta;
        return (_this$scrollableConta = this.scrollableContainers[0]) !== null && _this$scrollableConta !== void 0 ? _this$scrollableConta : null;
    }
    forceUpdatePosition() {
        // Wait a single animation frame before re-measuring.
        // Consumer's may also need to setup their own timers for
        // triggering forceUpdatePosition() `children` use animation.
        // Ideally, forceUpdatePosition() is fired at the end of a transition event.
        requestAnimationFrame(this.handleMeasurement);
    }
}
function getMarginsForNode(node) {
    const nodeStyles = window.getComputedStyle(node);
    return {
        activator: parseFloat(nodeStyles.marginTop || "0"),
        container: parseFloat(nodeStyles.marginBottom || "0"),
        horizontal: parseFloat(nodeStyles.marginLeft || "0")
    };
}
function getZIndexForLayerFromNode(node) {
    const layerNode = node.closest((0, _sharedJs.layer).selector) || document.body;
    const zIndex = layerNode === document.body ? "auto" : parseInt(window.getComputedStyle(layerNode).zIndex || "0", 10);
    return zIndex === "auto" || isNaN(zIndex) ? null : zIndex;
}
function isDocument(node) {
    return node === document;
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/geometry.js":"eKkn4","../shared.js":"lFbIK","./utilities/math.js":"eD4RH","./PositionedOverlay.scss.js":"hFtaN","../Scrollable/Scrollable.js":"587xt","../EventListener/EventListener.js":"jV8kW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eD4RH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateHorizontalPosition", ()=>calculateHorizontalPosition);
parcelHelpers.export(exports, "calculateVerticalPosition", ()=>calculateVerticalPosition);
parcelHelpers.export(exports, "intersectionWithViewport", ()=>intersectionWithViewport);
parcelHelpers.export(exports, "rectIsOutsideOfRect", ()=>rectIsOutsideOfRect);
parcelHelpers.export(exports, "windowRect", ()=>windowRect);
var _geometryJs = require("../../../utilities/geometry.js");
function calculateVerticalPosition(activatorRect, overlayRect, overlayMargins, scrollableContainerRect, containerRect, preferredPosition, fixed, topBarOffset = 0) {
    const activatorTop = activatorRect.top;
    const activatorBottom = activatorTop + activatorRect.height;
    const spaceAbove = activatorRect.top - topBarOffset;
    const spaceBelow = containerRect.height - activatorRect.top - activatorRect.height;
    const desiredHeight = overlayRect.height;
    const verticalMargins = overlayMargins.activator + overlayMargins.container;
    const minimumSpaceToScroll = overlayMargins.container;
    const distanceToTopScroll = activatorRect.top - Math.max(scrollableContainerRect.top, 0);
    const distanceToBottomScroll = containerRect.top + Math.min(containerRect.height, scrollableContainerRect.top + scrollableContainerRect.height) - (activatorRect.top + activatorRect.height);
    const enoughSpaceFromTopScroll = distanceToTopScroll >= minimumSpaceToScroll;
    const enoughSpaceFromBottomScroll = distanceToBottomScroll >= minimumSpaceToScroll;
    const heightIfBelow = Math.min(spaceBelow, desiredHeight);
    const heightIfAbove = Math.min(spaceAbove, desiredHeight);
    const containerRectTop = fixed ? 0 : containerRect.top;
    const positionIfAbove = {
        height: heightIfAbove - verticalMargins,
        top: activatorTop + containerRectTop - heightIfAbove,
        positioning: "above"
    };
    const positionIfBelow = {
        height: heightIfBelow - verticalMargins,
        top: activatorBottom + containerRectTop,
        positioning: "below"
    };
    if (preferredPosition === "above") return (enoughSpaceFromTopScroll || distanceToTopScroll >= distanceToBottomScroll && !enoughSpaceFromBottomScroll) && (spaceAbove > desiredHeight || spaceAbove > spaceBelow) ? positionIfAbove : positionIfBelow;
    if (preferredPosition === "below") return (enoughSpaceFromBottomScroll || distanceToBottomScroll >= distanceToTopScroll && !enoughSpaceFromTopScroll) && (spaceBelow > desiredHeight || spaceBelow > spaceAbove) ? positionIfBelow : positionIfAbove;
    if (enoughSpaceFromTopScroll && enoughSpaceFromBottomScroll) return spaceAbove > spaceBelow ? positionIfAbove : positionIfBelow;
    return distanceToTopScroll > minimumSpaceToScroll ? positionIfAbove : positionIfBelow;
}
function calculateHorizontalPosition(activatorRect, overlayRect, containerRect, overlayMargins, preferredAlignment) {
    const maximum = containerRect.width - overlayRect.width;
    if (preferredAlignment === "left") return Math.min(maximum, Math.max(0, activatorRect.left - overlayMargins.horizontal));
    else if (preferredAlignment === "right") {
        const activatorRight = containerRect.width - (activatorRect.left + activatorRect.width);
        return Math.min(maximum, Math.max(0, activatorRight - overlayMargins.horizontal));
    }
    return Math.min(maximum, Math.max(0, activatorRect.center.x - overlayRect.width / 2));
}
function rectIsOutsideOfRect(inner, outer) {
    const { center } = inner;
    return center.y < outer.top || center.y > outer.top + outer.height;
}
function intersectionWithViewport(rect, viewport = windowRect()) {
    const top = Math.max(rect.top, 0);
    const left = Math.max(rect.left, 0);
    const bottom = Math.min(rect.top + rect.height, viewport.height);
    const right = Math.min(rect.left + rect.width, viewport.width);
    return new (0, _geometryJs.Rect)({
        top,
        left,
        height: bottom - top,
        width: right - left
    });
}
function windowRect() {
    return new (0, _geometryJs.Rect)({
        top: window.scrollY,
        left: window.scrollX,
        height: window.innerHeight,
        width: document.body.clientWidth
    });
}

},{"../../../utilities/geometry.js":"eKkn4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hFtaN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "PositionedOverlay": "Polaris-PositionedOverlay",
    "fixed": "Polaris-PositionedOverlay--fixed",
    "calculating": "Polaris-PositionedOverlay--calculating",
    "preventInteraction": "Polaris-PositionedOverlay--preventInteraction"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"587xt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scrollable", ()=>Scrollable);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounceJs = require("../../utilities/debounce.js");
var _cssJs = require("../../utilities/css.js");
var _sharedJs = require("../shared.js");
var _useLazyRefJs = require("../../utilities/use-lazy-ref.js");
var _useComponentDidMountJs = require("../../utilities/use-component-did-mount.js");
var _contextJs = require("./context.js");
var _scrollableScssJs = require("./Scrollable.scss.js");
var _scrollableScssJsDefault = parcelHelpers.interopDefault(_scrollableScssJs);
var _scrollToJs = require("./components/ScrollTo/ScrollTo.js");
var _stickyManagerJs = require("../../utilities/sticky-manager/sticky-manager.js");
var _contextJs1 = require("../../utilities/sticky-manager/context.js");
const MAX_SCROLL_HINT_DISTANCE = 100;
const LOW_RES_BUFFER = 2;
const ScrollableComponent = /*#__PURE__*/ (0, _react.forwardRef)(({ children, className, horizontal = true, vertical = true, shadow, hint, focusable, onScrolledToBottom, ...rest }, forwardedRef)=>{
    const [topShadow, setTopShadow] = (0, _react.useState)(false);
    const [bottomShadow, setBottomShadow] = (0, _react.useState)(false);
    const stickyManager = (0, _useLazyRefJs.useLazyRef)(()=>new (0, _stickyManagerJs.StickyManager)());
    const scrollArea = (0, _react.useRef)(null);
    const scrollTo = (0, _react.useCallback)((scrollY, options = {})=>{
        var _scrollArea$current;
        const optionsBehavior = options.behavior || "smooth";
        const behavior = prefersReducedMotion() ? "auto" : optionsBehavior; // @ts-expect-error TS removed "instant" option but browsers support it.
        (_scrollArea$current = scrollArea.current) === null || _scrollArea$current === void 0 || _scrollArea$current.scrollTo({
            top: scrollY,
            behavior
        });
    }, []);
    const defaultRef = (0, _react.useRef)();
    (0, _react.useImperativeHandle)(forwardedRef || defaultRef, ()=>({
            scrollTo
        }));
    const handleScroll = (0, _react.useCallback)(()=>{
        const currentScrollArea = scrollArea.current;
        if (!currentScrollArea) return;
        requestAnimationFrame(()=>{
            const { scrollTop, clientHeight, scrollHeight } = currentScrollArea;
            const canScroll = Boolean(scrollHeight > clientHeight);
            const isBelowTopOfScroll = Boolean(scrollTop > 0);
            const isAtBottomOfScroll = Boolean(scrollTop + clientHeight >= scrollHeight - LOW_RES_BUFFER);
            setTopShadow(isBelowTopOfScroll);
            setBottomShadow(!isAtBottomOfScroll);
            if (canScroll && isAtBottomOfScroll && onScrolledToBottom) onScrolledToBottom();
        });
    }, [
        onScrolledToBottom
    ]);
    (0, _useComponentDidMountJs.useComponentDidMount)(()=>{
        handleScroll();
        if (hint) requestAnimationFrame(()=>performScrollHint(scrollArea.current));
    });
    (0, _react.useEffect)(()=>{
        var _stickyManager$curren;
        const currentScrollArea = scrollArea.current;
        if (!currentScrollArea) return;
        const handleResize = (0, _debounceJs.debounce)(handleScroll, 50, {
            trailing: true
        });
        (_stickyManager$curren = stickyManager.current) === null || _stickyManager$curren === void 0 || _stickyManager$curren.setContainer(currentScrollArea);
        currentScrollArea.addEventListener("scroll", handleScroll);
        globalThis.addEventListener("resize", handleResize);
        return ()=>{
            currentScrollArea.removeEventListener("scroll", handleScroll);
            globalThis.removeEventListener("resize", handleResize);
        };
    }, [
        stickyManager,
        handleScroll
    ]);
    const finalClassName = (0, _cssJs.classNames)(className, (0, _scrollableScssJsDefault.default).Scrollable, vertical && (0, _scrollableScssJsDefault.default).vertical, horizontal && (0, _scrollableScssJsDefault.default).horizontal, shadow && topShadow && (0, _scrollableScssJsDefault.default).hasTopShadow, shadow && bottomShadow && (0, _scrollableScssJsDefault.default).hasBottomShadow);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.ScrollableContext).Provider, {
        value: scrollTo
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs1.StickyManagerContext).Provider, {
        value: stickyManager.current
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
        className: finalClassName
    }, (0, _sharedJs.scrollable).props, rest, {
        ref: scrollArea // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        ,
        tabIndex: focusable ? 0 : undefined
    }), children)));
});
ScrollableComponent.displayName = "Scrollable";
function prefersReducedMotion() {
    try {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (err) {
        return false;
    }
}
function performScrollHint(elem) {
    if (!elem || prefersReducedMotion()) return;
    const scrollableDistance = elem.scrollHeight - elem.clientHeight;
    const distanceToPeek = Math.min(MAX_SCROLL_HINT_DISTANCE, scrollableDistance) - LOW_RES_BUFFER;
    const goBackToTop = ()=>{
        requestAnimationFrame(()=>{
            if (elem.scrollTop >= distanceToPeek) {
                elem.removeEventListener("scroll", goBackToTop);
                elem.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        });
    };
    elem.addEventListener("scroll", goBackToTop);
    elem.scrollTo({
        top: MAX_SCROLL_HINT_DISTANCE,
        behavior: "smooth"
    });
}
const forNode = (node)=>{
    const closestElement = node.closest((0, _sharedJs.scrollable).selector);
    return closestElement instanceof HTMLElement ? closestElement : document;
};
// @ts-expect-error - expected functions/sub-components are assigned after declaration
const Scrollable = ScrollableComponent;
Scrollable.ScrollTo = (0, _scrollToJs.ScrollTo);
Scrollable.forNode = forNode;

},{"react":"cOWTg","../../utilities/debounce.js":"bvJet","../../utilities/css.js":"lGt6N","../shared.js":"lFbIK","../../utilities/use-lazy-ref.js":"brnXH","../../utilities/use-component-did-mount.js":"b8lBX","./context.js":"eLQJB","./Scrollable.scss.js":"cBDPJ","./components/ScrollTo/ScrollTo.js":"aesei","../../utilities/sticky-manager/sticky-manager.js":"9IoVo","../../utilities/sticky-manager/context.js":"drNXT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"brnXH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLazyRef", ()=>useLazyRef);
var _react = require("react");
const UNIQUE_IDENTIFIER = Symbol("unique_identifier");
/**
 * useLazyRef provides a lazy initial value, similar to lazy
 * initial state the initialValue is the value used during
 * initialization and disregarded after that. Use this hook
 * for expensive initialization.
 * @param initialValue - A function that will return the initial
 * value and be disregarded after that
 * @returns MutableRefObject<T> - Returns a ref object with the
 * results from invoking initial value
 * @example
 * function ComponentExample() {
 *  const title = useLazyRef(() => someExpensiveComputation());
 *  return <h1>{title.current}</h1>;
 * }
 */ function useLazyRef(initialValue) {
    const lazyRef = (0, _react.useRef)(UNIQUE_IDENTIFIER);
    if (lazyRef.current === UNIQUE_IDENTIFIER) lazyRef.current = initialValue();
    return lazyRef;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b8lBX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComponentDidMount", ()=>useComponentDidMount);
var _react = require("react");
var _useIsAfterInitialMountJs = require("./use-is-after-initial-mount.js");
/**
 * Similarly to the life-cycle method componentDidMount, useComponentDidMount
 * will be invoked after the component has mounted, and only the initial mount.
 * @param callback Defines a callback to invoke once the component has
 * initially mounted.
 * @example
 * function Playground({active}) {
 *  useComponentDidMount(() => {
 *    if (active) {
 *      console.warning(`Component has mounted.`);
 *    }
 *  });
 *
 *  return null;
 * }
 */ function useComponentDidMount(callback) {
    const isAfterInitialMount = (0, _useIsAfterInitialMountJs.useIsAfterInitialMount)();
    const hasInvokedLifeCycle = (0, _react.useRef)(false);
    if (isAfterInitialMount && !hasInvokedLifeCycle.current) {
        hasInvokedLifeCycle.current = true;
        return callback();
    }
}

},{"react":"cOWTg","./use-is-after-initial-mount.js":"aJ8qM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eLQJB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollableContext", ()=>ScrollableContext);
var _react = require("react");
const ScrollableContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cBDPJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Scrollable": "Polaris-Scrollable",
    "horizontal": "Polaris-Scrollable--horizontal",
    "vertical": "Polaris-Scrollable--vertical",
    "hasTopShadow": "Polaris-Scrollable--hasTopShadow",
    "hasBottomShadow": "Polaris-Scrollable--hasBottomShadow"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aesei":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollTo", ()=>ScrollTo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _contextJs = require("../../context.js");
var _hooksJs = require("../../../../utilities/unique-id/hooks.js");
function ScrollTo() {
    const anchorNode = (0, _react.useRef)(null);
    const scrollToPosition = (0, _react.useContext)((0, _contextJs.ScrollableContext));
    (0, _react.useEffect)(()=>{
        if (!scrollToPosition || !anchorNode.current) return;
        scrollToPosition(anchorNode.current.offsetTop);
    }, [
        scrollToPosition
    ]);
    const id = (0, _hooksJs.useUniqueId)(`ScrollTo`); // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        id: id,
        ref: anchorNode
    });
}

},{"react":"cOWTg","../../context.js":"eLQJB","../../../../utilities/unique-id/hooks.js":"2JfcO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2JfcO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUniqueId", ()=>useUniqueId);
var _react = require("react");
var _errorsJs = require("../errors.js");
var _contextJs = require("./context.js");
/**
 * Returns a unique id that remains consistent across multiple re-renders of the
 * same hook
 * @param prefix Defines a prefix for the ID. You probably want to set this to
 *   the name of the component you're calling `useUniqueId` in.
 * @param overrideId Defines a fixed value to use instead of generating a unique
 *   ID. Useful for components that allow consumers to specify their own ID.
 */ function useUniqueId(prefix = "", overrideId = "") {
    const idFactory = (0, _react.useContext)((0, _contextJs.UniqueIdFactoryContext)); // By using a ref to store the uniqueId for each invocation of the hook and
    // checking that it is not already populated we ensure that we don’t generate
    // a new ID on every re-render of a component.
    const uniqueIdRef = (0, _react.useRef)(null);
    if (!idFactory) throw new (0, _errorsJs.MissingAppProviderError)("No UniqueIdFactory was provided.");
     // If an override was specified, then use that instead of using a unique ID
    // Hooks can’t be called conditionally so this has to go after all use* calls
    if (overrideId) return overrideId;
     // If a unique id has not yet been generated, then get a new one
    if (!uniqueIdRef.current) uniqueIdRef.current = idFactory.nextId(prefix);
    return uniqueIdRef.current;
}

},{"react":"cOWTg","../errors.js":"HUtaY","./context.js":"jR0XA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3wn3c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>Portal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _hooksJs = require("../../utilities/portals/hooks.js");
var _hooksJs1 = require("../../utilities/unique-id/hooks.js");
function Portal({ children, idPrefix = "", onPortalCreated = noop }) {
    const { container } = (0, _hooksJs.usePortalsManager)();
    const uniqueId = (0, _hooksJs1.useUniqueId)("portal");
    const portalId = idPrefix !== "" ? `${idPrefix}-${uniqueId}` : uniqueId;
    (0, _react.useEffect)(()=>{
        onPortalCreated();
    }, [
        onPortalCreated
    ]);
    return container ? /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-portal-id": portalId
    }, children), container) : null;
}
function noop() {}

},{"react":"cOWTg","react-dom":"aPjLf","../../utilities/portals/hooks.js":"7el5o","../../utilities/unique-id/hooks.js":"2JfcO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7el5o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePortalsManager", ()=>usePortalsManager);
var _react = require("react");
var _contextJs = require("./context.js");
function usePortalsManager() {
    const portalsManager = (0, _react.useContext)((0, _contextJs.PortalsManagerContext));
    if (!portalsManager) throw new Error("No portals manager was provided. Your application must be wrapped in an <AppProvider> component. See https://polaris.shopify.com/components/app-provider for implementation instructions.");
    return portalsManager;
}

},{"react":"cOWTg","./context.js":"2SMv8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4o3DP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnstyledLink", ()=>UnstyledLink);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sharedJs = require("../shared.js");
var _hooksJs = require("../../utilities/link/hooks.js");
// Wrapping forwardRef in a memo gets a name set since
// https://github.com/facebook/react/issues/16722
// but eslint-plugin-react doesn't know that just yet
// eslint-disable-next-line react/display-name
const UnstyledLink = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(function UnstyledLink(props, _ref) {
    const LinkComponent = (0, _hooksJs.useLink)();
    if (LinkComponent) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LinkComponent, Object.assign({}, (0, _sharedJs.unstyled).props, props));
    const { external, url, target: targetProp, ...rest } = props;
    let target;
    if (external) target = "_blank";
    else target = targetProp !== null && targetProp !== void 0 ? targetProp : undefined;
    const rel = target === "_blank" ? "noopener noreferrer" : undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", Object.assign({
        target: target
    }, rest, {
        href: url,
        rel: rel
    }, (0, _sharedJs.unstyled).props));
}));

},{"react":"cOWTg","../shared.js":"lFbIK","../../utilities/link/hooks.js":"hbA5c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hbA5c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLink", ()=>useLink);
var _react = require("react");
var _contextJs = require("./context.js");
function useLink() {
    return (0, _react.useContext)((0, _contextJs.LinkContext));
}

},{"react":"cOWTg","./context.js":"82weN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fotqA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalStack", ()=>HorizontalStack);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _horizontalStackScssJs = require("./HorizontalStack.scss.js");
var _horizontalStackScssJsDefault = parcelHelpers.interopDefault(_horizontalStackScssJs);
const HorizontalStack = function HorizontalStack({ align, blockAlign, gap, wrap = true, children }) {
    const style = {
        "--pc-horizontal-stack-align": align,
        "--pc-horizontal-stack-block-align": blockAlign,
        "--pc-horizontal-stack-wrap": wrap ? "wrap" : "nowrap",
        ...(0, _cssJs.getResponsiveProps)("horizontal-stack", "gap", "space", gap)
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _horizontalStackScssJsDefault.default).HorizontalStack,
        style: style
    }, children);
};

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./HorizontalStack.scss.js":"4yLnc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4yLnc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "HorizontalStack": "Polaris-HorizontalStack"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lbjkG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>Box);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _boxScssJs = require("./Box.scss.js");
var _boxScssJsDefault = parcelHelpers.interopDefault(_boxScssJs);
const Box = /*#__PURE__*/ (0, _react.forwardRef)(({ as = "div", background, borderColor, borderStyle, borderWidth, borderBlockStartWidth, borderBlockEndWidth, borderInlineStartWidth, borderInlineEndWidth, borderRadius, borderRadiusEndStart, borderRadiusEndEnd, borderRadiusStartStart, borderRadiusStartEnd, children, color, id, minHeight, minWidth, maxWidth, overflowX, overflowY, outlineColor, outlineStyle, outlineWidth, padding, paddingBlockStart, paddingBlockEnd, paddingInlineStart, paddingInlineEnd, role, shadow, tabIndex, width, printHidden, visuallyHidden, position, insetBlockStart, insetBlockEnd, insetInlineStart, insetInlineEnd, zIndex, opacity, ...restProps }, ref)=>{
    // eslint-disable-next-line no-nested-ternary
    const borderStyleValue = borderStyle ? borderStyle : borderColor || borderWidth || borderBlockStartWidth || borderBlockEndWidth || borderInlineStartWidth || borderInlineEndWidth ? "solid" : undefined; // eslint-disable-next-line no-nested-ternary
    const outlineStyleValue = outlineStyle ? outlineStyle : outlineColor || outlineWidth ? "solid" : undefined;
    const style = {
        "--pc-box-color": color ? `var(--p-color-${color})` : undefined,
        "--pc-box-background": background ? `var(--p-color-${background})` : undefined,
        // eslint-disable-next-line no-nested-ternary
        "--pc-box-border-color": borderColor ? borderColor === "transparent" ? "transparent" : `var(--p-color-${borderColor})` : undefined,
        "--pc-box-border-style": borderStyleValue,
        "--pc-box-border-radius": borderRadius ? `var(--p-border-radius-${borderRadius})` : undefined,
        "--pc-box-border-radius-end-start": borderRadiusEndStart ? `var(--p-border-radius-${borderRadiusEndStart})` : undefined,
        "--pc-box-border-radius-end-end": borderRadiusEndEnd ? `var(--p-border-radius-${borderRadiusEndEnd})` : undefined,
        "--pc-box-border-radius-start-start": borderRadiusStartStart ? `var(--p-border-radius-${borderRadiusStartStart})` : undefined,
        "--pc-box-border-radius-start-end": borderRadiusStartEnd ? `var(--p-border-radius-${borderRadiusStartEnd})` : undefined,
        "--pc-box-border-width": borderWidth ? `var(--p-border-width-${borderWidth})` : undefined,
        "--pc-box-border-block-start-width": borderBlockStartWidth ? `var(--p-border-width-${borderBlockStartWidth})` : undefined,
        "--pc-box-border-block-end-width": borderBlockEndWidth ? `var(--p-border-width-${borderBlockEndWidth})` : undefined,
        "--pc-box-border-inline-start-width": borderInlineStartWidth ? `var(--p-border-width-${borderInlineStartWidth})` : undefined,
        "--pc-box-border-inline-end-width": borderInlineEndWidth ? `var(--p-border-width-${borderInlineEndWidth})` : undefined,
        "--pc-box-min-height": minHeight,
        "--pc-box-min-width": minWidth,
        "--pc-box-max-width": maxWidth,
        "--pc-box-outline-color": outlineColor ? `var(--p-color-${outlineColor})` : undefined,
        "--pc-box-outline-style": outlineStyleValue,
        "--pc-box-outline-width": outlineWidth ? `var(--p-border-width-${outlineWidth})` : undefined,
        "--pc-box-overflow-x": overflowX,
        "--pc-box-overflow-y": overflowY,
        ...(0, _cssJs.getResponsiveProps)("box", "padding-block-end", "space", paddingBlockEnd || padding),
        ...(0, _cssJs.getResponsiveProps)("box", "padding-block-start", "space", paddingBlockStart || padding),
        ...(0, _cssJs.getResponsiveProps)("box", "padding-inline-start", "space", paddingInlineStart || padding),
        ...(0, _cssJs.getResponsiveProps)("box", "padding-inline-end", "space", paddingInlineEnd || padding),
        "--pc-box-shadow": shadow ? `var(--p-shadow-${shadow})` : undefined,
        "--pc-box-width": width,
        position,
        "--pc-box-inset-block-start": insetBlockStart ? `var(--p-space-${insetBlockStart})` : undefined,
        "--pc-box-inset-block-end": insetBlockEnd ? `var(--p-space-${insetBlockEnd})` : undefined,
        "--pc-box-inset-inline-start": insetInlineStart ? `var(--p-space-${insetInlineStart})` : undefined,
        "--pc-box-inset-inline-end": insetInlineEnd ? `var(--p-space-${insetInlineEnd})` : undefined,
        zIndex,
        opacity
    };
    const className = (0, _cssJs.classNames)((0, _boxScssJsDefault.default).Box, visuallyHidden && (0, _boxScssJsDefault.default).visuallyHidden, printHidden && (0, _boxScssJsDefault.default).printHidden, as === "ul" && (0, _boxScssJsDefault.default).listReset);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(as, {
        className,
        id,
        ref,
        style: (0, _cssJs.sanitizeCustomProperties)(style),
        role,
        tabIndex,
        ...restProps
    }, children);
});
Box.displayName = "Box";

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Box.scss.js":"g7mPn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g7mPn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "listReset": "Polaris-Box--listReset",
    "Box": "Polaris-Box",
    "visuallyHidden": "Polaris-Box--visuallyHidden",
    "printHidden": "Polaris-Box--printHidden"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1eFmF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeypressListener", ()=>KeypressListener);
var _react = require("react");
var _useIsomorphicLayoutEffectJs = require("../../utilities/use-isomorphic-layout-effect.js");
function KeypressListener({ keyCode, handler, keyEvent = "keyup", options, useCapture }) {
    const tracked = (0, _react.useRef)({
        handler,
        keyCode
    });
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        tracked.current = {
            handler,
            keyCode
        };
    }, [
        handler,
        keyCode
    ]);
    const handleKeyEvent = (0, _react.useCallback)((event)=>{
        const { handler, keyCode } = tracked.current;
        if (event.keyCode === keyCode) handler(event);
    }, []);
    (0, _react.useEffect)(()=>{
        document.addEventListener(keyEvent, handleKeyEvent, useCapture || options);
        return ()=>{
            document.removeEventListener(keyEvent, handleKeyEvent, useCapture || options);
        };
    }, [
        keyEvent,
        handleKeyEvent,
        useCapture,
        options
    ]);
    return null;
}

},{"react":"cOWTg","../../utilities/use-isomorphic-layout-effect.js":"2th17","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dboRA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
parcelHelpers.export(exports, "hasGroupsWithActions", ()=>hasGroupsWithActions);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _actionMenuScssJs = require("./ActionMenu.scss.js");
var _actionMenuScssJsDefault = parcelHelpers.interopDefault(_actionMenuScssJs);
var _rollupActionsJs = require("./components/RollupActions/RollupActions.js");
var _actionsJs = require("./components/Actions/Actions.js");
function ActionMenu({ actions = [], groups = [], rollup, rollupActionsLabel, onActionRollup }) {
    if (actions.length === 0 && groups.length === 0) return null;
    const actionMenuClassNames = (0, _cssJs.classNames)((0, _actionMenuScssJsDefault.default).ActionMenu, rollup && (0, _actionMenuScssJsDefault.default).rollup);
    const rollupSections = groups.map((group)=>convertGroupToSection(group));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: actionMenuClassNames
    }, rollup ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rollupActionsJs.RollupActions), {
        accessibilityLabel: rollupActionsLabel,
        items: actions,
        sections: rollupSections
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionsJs.Actions), {
        actions: actions,
        groups: groups,
        onActionRollup: onActionRollup
    }));
}
function hasGroupsWithActions(groups = []) {
    return groups.length === 0 ? false : groups.some((group)=>group.actions.length > 0);
}
function convertGroupToSection({ title, actions, disabled }) {
    return {
        title,
        items: actions.map((action)=>({
                ...action,
                disabled: disabled || action.disabled
            }))
    };
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./ActionMenu.scss.js":"5xxbJ","./components/RollupActions/RollupActions.js":"iM4oC","./components/Actions/Actions.js":"kawC2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5xxbJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ActionMenu": "Polaris-ActionMenu"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iM4oC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RollupActions", ()=>RollupActions);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _useToggleJs = require("../../../../utilities/use-toggle.js");
var _rollupActionsScssJs = require("./RollupActions.scss.js");
var _rollupActionsScssJsDefault = parcelHelpers.interopDefault(_rollupActionsScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _buttonJs = require("../../../Button/Button.js");
var _popoverJs = require("../../../Popover/Popover.js");
var _actionListJs = require("../../../ActionList/ActionList.js");
function RollupActions({ accessibilityLabel, items = [], sections = [] }) {
    const i18n = (0, _hooksJs.useI18n)();
    const { value: rollupOpen, toggle: toggleRollupOpen } = (0, _useToggleJs.useToggle)(false);
    if (items.length === 0 && sections.length === 0) return null;
    const activatorMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _rollupActionsScssJsDefault.default).RollupActivator
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        outline: true,
        icon: (0, _polarisIcons.HorizontalDotsMinor),
        accessibilityLabel: accessibilityLabel || i18n.translate("Polaris.ActionMenu.RollupActions.rollupButton"),
        onClick: toggleRollupOpen
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
        active: rollupOpen,
        activator: activatorMarkup,
        preferredAlignment: "right",
        onClose: toggleRollupOpen,
        hideOnPrint: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
        items: items,
        sections: sections,
        onActionAnyItem: toggleRollupOpen
    }));
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/use-toggle.js":"2kpDL","./RollupActions.scss.js":"76aLD","../../../../utilities/i18n/hooks.js":"hhMhA","../../../Button/Button.js":"6Szv4","../../../Popover/Popover.js":"cE1F7","../../../ActionList/ActionList.js":"kU0n2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"zOlgc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbandonedCartMajor", ()=>(0, _abandonedCartMajorSvgMjs.S));
parcelHelpers.export(exports, "AccessibilityMajor", ()=>(0, _accessibilityMajorSvgMjs.S));
parcelHelpers.export(exports, "ActivitiesMajor", ()=>(0, _activitiesMajorSvgMjs.S));
parcelHelpers.export(exports, "AddCodeMajor", ()=>(0, _addCodeMajorSvgMjs.S));
parcelHelpers.export(exports, "AddImageMajor", ()=>(0, _addImageMajorSvgMjs.S));
parcelHelpers.export(exports, "AddMajor", ()=>(0, _addMajorSvgMjs.S));
parcelHelpers.export(exports, "AddNoteMajor", ()=>(0, _addNoteMajorSvgMjs.S));
parcelHelpers.export(exports, "AddProductMajor", ()=>(0, _addProductMajorSvgMjs.S));
parcelHelpers.export(exports, "AdjustMinor", ()=>(0, _adjustMinorSvgMjs.S));
parcelHelpers.export(exports, "AffiliateMajor", ()=>(0, _affiliateMajorSvgMjs.S));
parcelHelpers.export(exports, "AlertMinor", ()=>(0, _alertMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsBarHorizontalMinor", ()=>(0, _analyticsBarHorizontalMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsBarStackedMinor", ()=>(0, _analyticsBarStackedMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsCohortMinor", ()=>(0, _analyticsCohortMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsDonutMinor", ()=>(0, _analyticsDonutMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsFunnelMinor", ()=>(0, _analyticsFunnelMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsLineMinor", ()=>(0, _analyticsLineMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsMajor", ()=>(0, _analyticsMajorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsMinor", ()=>(0, _analyticsMinorSvgMjs.S));
parcelHelpers.export(exports, "AnalyticsTableMinor", ()=>(0, _analyticsTableMinorSvgMjs.S));
parcelHelpers.export(exports, "AnyClickModelMinor", ()=>(0, _anyClickModelMinorSvgMjs.S));
parcelHelpers.export(exports, "AppExtensionMinor", ()=>(0, _appExtensionMinorSvgMjs.S));
parcelHelpers.export(exports, "AppsMajor", ()=>(0, _appsMajorSvgMjs.S));
parcelHelpers.export(exports, "AppsMinor", ()=>(0, _appsMinorSvgMjs.S));
parcelHelpers.export(exports, "ArchiveMajor", ()=>(0, _archiveMajorSvgMjs.S));
parcelHelpers.export(exports, "ArchiveMinor", ()=>(0, _archiveMinorSvgMjs.S));
parcelHelpers.export(exports, "ArrowDownMinor", ()=>(0, _arrowDownMinorSvgMjs.S));
parcelHelpers.export(exports, "ArrowLeftMinor", ()=>(0, _arrowLeftMinorSvgMjs.S));
parcelHelpers.export(exports, "ArrowRightMinor", ()=>(0, _arrowRightMinorSvgMjs.S));
parcelHelpers.export(exports, "ArrowUpMinor", ()=>(0, _arrowUpMinorSvgMjs.S));
parcelHelpers.export(exports, "AttachmentMajor", ()=>(0, _attachmentMajorSvgMjs.S));
parcelHelpers.export(exports, "AutomationMajor", ()=>(0, _automationMajorSvgMjs.S));
parcelHelpers.export(exports, "BackspaceMajor", ()=>(0, _backspaceMajorSvgMjs.S));
parcelHelpers.export(exports, "BalanceMajor", ()=>(0, _balanceMajorSvgMjs.S));
parcelHelpers.export(exports, "BankMajor", ()=>(0, _bankMajorSvgMjs.S));
parcelHelpers.export(exports, "BarcodeMajor", ()=>(0, _barcodeMajorSvgMjs.S));
parcelHelpers.export(exports, "BehaviorMajor", ()=>(0, _behaviorMajorSvgMjs.S));
parcelHelpers.export(exports, "BehaviorMinor", ()=>(0, _behaviorMinorSvgMjs.S));
parcelHelpers.export(exports, "BillingStatementDollarMajor", ()=>(0, _billingStatementDollarMajorSvgMjs.S));
parcelHelpers.export(exports, "BillingStatementEuroMajor", ()=>(0, _billingStatementEuroMajorSvgMjs.S));
parcelHelpers.export(exports, "BillingStatementPoundMajor", ()=>(0, _billingStatementPoundMajorSvgMjs.S));
parcelHelpers.export(exports, "BillingStatementRupeeMajor", ()=>(0, _billingStatementRupeeMajorSvgMjs.S));
parcelHelpers.export(exports, "BillingStatementYenMajor", ()=>(0, _billingStatementYenMajorSvgMjs.S));
parcelHelpers.export(exports, "BlockMinor", ()=>(0, _blockMinorSvgMjs.S));
parcelHelpers.export(exports, "BlockquoteMajor", ()=>(0, _blockquoteMajorSvgMjs.S));
parcelHelpers.export(exports, "BlogMajor", ()=>(0, _blogMajorSvgMjs.S));
parcelHelpers.export(exports, "BugMajor", ()=>(0, _bugMajorSvgMjs.S));
parcelHelpers.export(exports, "ButtonCornerPillMajor", ()=>(0, _buttonCornerPillMajorSvgMjs.S));
parcelHelpers.export(exports, "ButtonCornerRoundedMajor", ()=>(0, _buttonCornerRoundedMajorSvgMjs.S));
parcelHelpers.export(exports, "ButtonCornerSquareMajor", ()=>(0, _buttonCornerSquareMajorSvgMjs.S));
parcelHelpers.export(exports, "ButtonMinor", ()=>(0, _buttonMinorSvgMjs.S));
parcelHelpers.export(exports, "BuyButtonButtonLayoutMajor", ()=>(0, _buyButtonButtonLayoutMajorSvgMjs.S));
parcelHelpers.export(exports, "BuyButtonHorizontalLayoutMajor", ()=>(0, _buyButtonHorizontalLayoutMajorSvgMjs.S));
parcelHelpers.export(exports, "BuyButtonMajor", ()=>(0, _buyButtonMajorSvgMjs.S));
parcelHelpers.export(exports, "BuyButtonVerticalLayoutMajor", ()=>(0, _buyButtonVerticalLayoutMajorSvgMjs.S));
parcelHelpers.export(exports, "CalendarMajor", ()=>(0, _calendarMajorSvgMjs.S));
parcelHelpers.export(exports, "CalendarMinor", ()=>(0, _calendarMinorSvgMjs.S));
parcelHelpers.export(exports, "CalendarTickMajor", ()=>(0, _calendarTickMajorSvgMjs.S));
parcelHelpers.export(exports, "CalendarTimeMinor", ()=>(0, _calendarTimeMinorSvgMjs.S));
parcelHelpers.export(exports, "CameraMajor", ()=>(0, _cameraMajorSvgMjs.S));
parcelHelpers.export(exports, "CancelMajor", ()=>(0, _cancelMajorSvgMjs.S));
parcelHelpers.export(exports, "CancelMinor", ()=>(0, _cancelMinorSvgMjs.S));
parcelHelpers.export(exports, "CancelSmallMinor", ()=>(0, _cancelSmallMinorSvgMjs.S));
parcelHelpers.export(exports, "CapitalMajor", ()=>(0, _capitalMajorSvgMjs.S));
parcelHelpers.export(exports, "CapturePaymentMinor", ()=>(0, _capturePaymentMinorSvgMjs.S));
parcelHelpers.export(exports, "CardReaderChipMajor", ()=>(0, _cardReaderChipMajorSvgMjs.S));
parcelHelpers.export(exports, "CardReaderMajor", ()=>(0, _cardReaderMajorSvgMjs.S));
parcelHelpers.export(exports, "CardReaderTapMajor", ()=>(0, _cardReaderTapMajorSvgMjs.S));
parcelHelpers.export(exports, "CaretDownMinor", ()=>(0, _caretDownMinorSvgMjs.S));
parcelHelpers.export(exports, "CaretUpMinor", ()=>(0, _caretUpMinorSvgMjs.S));
parcelHelpers.export(exports, "CartDownMajor", ()=>(0, _cartDownMajorSvgMjs.S));
parcelHelpers.export(exports, "CartMajor", ()=>(0, _cartMajorSvgMjs.S));
parcelHelpers.export(exports, "CartUpMajor", ()=>(0, _cartUpMajorSvgMjs.S));
parcelHelpers.export(exports, "CashDollarMajor", ()=>(0, _cashDollarMajorSvgMjs.S));
parcelHelpers.export(exports, "CashDollarMinor", ()=>(0, _cashDollarMinorSvgMjs.S));
parcelHelpers.export(exports, "CashEuroMajor", ()=>(0, _cashEuroMajorSvgMjs.S));
parcelHelpers.export(exports, "CashPoundMajor", ()=>(0, _cashPoundMajorSvgMjs.S));
parcelHelpers.export(exports, "CashRupeeMajor", ()=>(0, _cashRupeeMajorSvgMjs.S));
parcelHelpers.export(exports, "CashYenMajor", ()=>(0, _cashYenMajorSvgMjs.S));
parcelHelpers.export(exports, "CategoriesMajor", ()=>(0, _categoriesMajorSvgMjs.S));
parcelHelpers.export(exports, "ChannelsMajor", ()=>(0, _channelsMajorSvgMjs.S));
parcelHelpers.export(exports, "ChatMajor", ()=>(0, _chatMajorSvgMjs.S));
parcelHelpers.export(exports, "ChecklistAlternateMajor", ()=>(0, _checklistAlternateMajorSvgMjs.S));
parcelHelpers.export(exports, "ChecklistMajor", ()=>(0, _checklistMajorSvgMjs.S));
parcelHelpers.export(exports, "CheckoutMajor", ()=>(0, _checkoutMajorSvgMjs.S));
parcelHelpers.export(exports, "ChevronDownMinor", ()=>(0, _chevronDownMinorSvgMjs.S));
parcelHelpers.export(exports, "ChevronLeftMinor", ()=>(0, _chevronLeftMinorSvgMjs.S));
parcelHelpers.export(exports, "ChevronRightMinor", ()=>(0, _chevronRightMinorSvgMjs.S));
parcelHelpers.export(exports, "ChevronUpMinor", ()=>(0, _chevronUpMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleAlertMajor", ()=>(0, _circleAlertMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleCancelMajor", ()=>(0, _circleCancelMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleCancelMinor", ()=>(0, _circleCancelMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleChevronDownMinor", ()=>(0, _circleChevronDownMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleChevronLeftMinor", ()=>(0, _circleChevronLeftMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleChevronRightMinor", ()=>(0, _circleChevronRightMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleChevronUpMinor", ()=>(0, _circleChevronUpMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleDisableMinor", ()=>(0, _circleDisableMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleDisabledMajor", ()=>(0, _circleDisabledMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleDotsMajor", ()=>(0, _circleDotsMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleDownMajor", ()=>(0, _circleDownMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleInformationMajor", ()=>(0, _circleInformationMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleLeftMajor", ()=>(0, _circleLeftMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleMinusMajor", ()=>(0, _circleMinusMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleMinusMinor", ()=>(0, _circleMinusMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleMinusOutlineMinor", ()=>(0, _circleMinusOutlineMinorSvgMjs.S));
parcelHelpers.export(exports, "CirclePlusMajor", ()=>(0, _circlePlusMajorSvgMjs.S));
parcelHelpers.export(exports, "CirclePlusMinor", ()=>(0, _circlePlusMinorSvgMjs.S));
parcelHelpers.export(exports, "CirclePlusOutlineMinor", ()=>(0, _circlePlusOutlineMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleRightMajor", ()=>(0, _circleRightMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleTickMajor", ()=>(0, _circleTickMajorSvgMjs.S));
parcelHelpers.export(exports, "CircleTickMinor", ()=>(0, _circleTickMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleTickOutlineMinor", ()=>(0, _circleTickOutlineMinorSvgMjs.S));
parcelHelpers.export(exports, "CircleUpMajor", ()=>(0, _circleUpMajorSvgMjs.S));
parcelHelpers.export(exports, "ClipboardMinor", ()=>(0, _clipboardMinorSvgMjs.S));
parcelHelpers.export(exports, "ClockMajor", ()=>(0, _clockMajorSvgMjs.S));
parcelHelpers.export(exports, "ClockMinor", ()=>(0, _clockMinorSvgMjs.S));
parcelHelpers.export(exports, "CodeMajor", ()=>(0, _codeMajorSvgMjs.S));
parcelHelpers.export(exports, "CodeMinor", ()=>(0, _codeMinorSvgMjs.S));
parcelHelpers.export(exports, "CollectionReferenceMinor", ()=>(0, _collectionReferenceMinorSvgMjs.S));
parcelHelpers.export(exports, "CollectionsMajor", ()=>(0, _collectionsMajorSvgMjs.S));
parcelHelpers.export(exports, "ColorNoneMinor", ()=>(0, _colorNoneMinorSvgMjs.S));
parcelHelpers.export(exports, "ColorsMajor", ()=>(0, _colorsMajorSvgMjs.S));
parcelHelpers.export(exports, "Column1Major", ()=>(0, _column1MajorSvgMjs.S));
parcelHelpers.export(exports, "ColumnWithTextMajor", ()=>(0, _columnWithTextMajorSvgMjs.S));
parcelHelpers.export(exports, "Columns2Major", ()=>(0, _columns2MajorSvgMjs.S));
parcelHelpers.export(exports, "Columns3Major", ()=>(0, _columns3MajorSvgMjs.S));
parcelHelpers.export(exports, "Columns3Minor", ()=>(0, _columns3MinorSvgMjs.S));
parcelHelpers.export(exports, "ComposeMajor", ()=>(0, _composeMajorSvgMjs.S));
parcelHelpers.export(exports, "ConfettiMajor", ()=>(0, _confettiMajorSvgMjs.S));
parcelHelpers.export(exports, "ConnectMinor", ()=>(0, _connectMinorSvgMjs.S));
parcelHelpers.export(exports, "ContentMinor", ()=>(0, _contentMinorSvgMjs.S));
parcelHelpers.export(exports, "ConversationMinor", ()=>(0, _conversationMinorSvgMjs.S));
parcelHelpers.export(exports, "CreditCardCancelMajor", ()=>(0, _creditCardCancelMajorSvgMjs.S));
parcelHelpers.export(exports, "CreditCardMajor", ()=>(0, _creditCardMajorSvgMjs.S));
parcelHelpers.export(exports, "CreditCardPercentMajor", ()=>(0, _creditCardPercentMajorSvgMjs.S));
parcelHelpers.export(exports, "CreditCardSecureMajor", ()=>(0, _creditCardSecureMajorSvgMjs.S));
parcelHelpers.export(exports, "CurrencyConvertMinor", ()=>(0, _currencyConvertMinorSvgMjs.S));
parcelHelpers.export(exports, "CustomerMinusMajor", ()=>(0, _customerMinusMajorSvgMjs.S));
parcelHelpers.export(exports, "CustomerPlusMajor", ()=>(0, _customerPlusMajorSvgMjs.S));
parcelHelpers.export(exports, "CustomersMajor", ()=>(0, _customersMajorSvgMjs.S));
parcelHelpers.export(exports, "CustomersMinor", ()=>(0, _customersMinorSvgMjs.S));
parcelHelpers.export(exports, "DataDrivenModelMinor", ()=>(0, _dataDrivenModelMinorSvgMjs.S));
parcelHelpers.export(exports, "DataVisualizationMajor", ()=>(0, _dataVisualizationMajorSvgMjs.S));
parcelHelpers.export(exports, "DecimalMinor", ()=>(0, _decimalMinorSvgMjs.S));
parcelHelpers.export(exports, "DeleteMajor", ()=>(0, _deleteMajorSvgMjs.S));
parcelHelpers.export(exports, "DeleteMinor", ()=>(0, _deleteMinorSvgMjs.S));
parcelHelpers.export(exports, "DesktopMajor", ()=>(0, _desktopMajorSvgMjs.S));
parcelHelpers.export(exports, "DetailedPopUpMajor", ()=>(0, _detailedPopUpMajorSvgMjs.S));
parcelHelpers.export(exports, "DiamondAlertMajor", ()=>(0, _diamondAlertMajorSvgMjs.S));
parcelHelpers.export(exports, "DiamondAlertMinor", ()=>(0, _diamondAlertMinorSvgMjs.S));
parcelHelpers.export(exports, "DigitalMediaReceiverMajor", ()=>(0, _digitalMediaReceiverMajorSvgMjs.S));
parcelHelpers.export(exports, "DiscountAutomaticMajor", ()=>(0, _discountAutomaticMajorSvgMjs.S));
parcelHelpers.export(exports, "DiscountCodeMajor", ()=>(0, _discountCodeMajorSvgMjs.S));
parcelHelpers.export(exports, "DiscountsMajor", ()=>(0, _discountsMajorSvgMjs.S));
parcelHelpers.export(exports, "DiscountsMinor", ()=>(0, _discountsMinorSvgMjs.S));
parcelHelpers.export(exports, "DisputeMinor", ()=>(0, _disputeMinorSvgMjs.S));
parcelHelpers.export(exports, "DnsSettingsMajor", ()=>(0, _dnsSettingsMajorSvgMjs.S));
parcelHelpers.export(exports, "DockFloatingMajor", ()=>(0, _dockFloatingMajorSvgMjs.S));
parcelHelpers.export(exports, "DockSideMajor", ()=>(0, _dockSideMajorSvgMjs.S));
parcelHelpers.export(exports, "DomainNewMajor", ()=>(0, _domainNewMajorSvgMjs.S));
parcelHelpers.export(exports, "DomainRedirectMinor", ()=>(0, _domainRedirectMinorSvgMjs.S));
parcelHelpers.export(exports, "DomainsMajor", ()=>(0, _domainsMajorSvgMjs.S));
parcelHelpers.export(exports, "DraftOrdersMajor", ()=>(0, _draftOrdersMajorSvgMjs.S));
parcelHelpers.export(exports, "DragDropMajor", ()=>(0, _dragDropMajorSvgMjs.S));
parcelHelpers.export(exports, "DragHandleMinor", ()=>(0, _dragHandleMinorSvgMjs.S));
parcelHelpers.export(exports, "DropdownMinor", ()=>(0, _dropdownMinorSvgMjs.S));
parcelHelpers.export(exports, "DuplicateMinor", ()=>(0, _duplicateMinorSvgMjs.S));
parcelHelpers.export(exports, "DynamicSourceMajor", ()=>(0, _dynamicSourceMajorSvgMjs.S));
parcelHelpers.export(exports, "DynamicSourceMinor", ()=>(0, _dynamicSourceMinorSvgMjs.S));
parcelHelpers.export(exports, "EditMajor", ()=>(0, _editMajorSvgMjs.S));
parcelHelpers.export(exports, "EditMinor", ()=>(0, _editMinorSvgMjs.S));
parcelHelpers.export(exports, "EmailMajor", ()=>(0, _emailMajorSvgMjs.S));
parcelHelpers.export(exports, "EmailNewsletterMajor", ()=>(0, _emailNewsletterMajorSvgMjs.S));
parcelHelpers.export(exports, "EmbedMinor", ()=>(0, _embedMinorSvgMjs.S));
parcelHelpers.export(exports, "EnableSelectionMinor", ()=>(0, _enableSelectionMinorSvgMjs.S));
parcelHelpers.export(exports, "EnterMajor", ()=>(0, _enterMajorSvgMjs.S));
parcelHelpers.export(exports, "EnvelopeMajor", ()=>(0, _envelopeMajorSvgMjs.S));
parcelHelpers.export(exports, "ExchangeMajor", ()=>(0, _exchangeMajorSvgMjs.S));
parcelHelpers.export(exports, "ExistingInventoryMajor", ()=>(0, _existingInventoryMajorSvgMjs.S));
parcelHelpers.export(exports, "ExitMajor", ()=>(0, _exitMajorSvgMjs.S));
parcelHelpers.export(exports, "ExploreImagesMajor", ()=>(0, _exploreImagesMajorSvgMjs.S));
parcelHelpers.export(exports, "ExportMinor", ()=>(0, _exportMinorSvgMjs.S));
parcelHelpers.export(exports, "ExtendMajor", ()=>(0, _extendMajorSvgMjs.S));
parcelHelpers.export(exports, "ExtendMinor", ()=>(0, _extendMinorSvgMjs.S));
parcelHelpers.export(exports, "ExternalMinor", ()=>(0, _externalMinorSvgMjs.S));
parcelHelpers.export(exports, "ExternalSmallMinor", ()=>(0, _externalSmallMinorSvgMjs.S));
parcelHelpers.export(exports, "EyeDropperMinor", ()=>(0, _eyeDropperMinorSvgMjs.S));
parcelHelpers.export(exports, "FaviconMajor", ()=>(0, _faviconMajorSvgMjs.S));
parcelHelpers.export(exports, "FavoriteMajor", ()=>(0, _favoriteMajorSvgMjs.S));
parcelHelpers.export(exports, "FeaturedCollectionMajor", ()=>(0, _featuredCollectionMajorSvgMjs.S));
parcelHelpers.export(exports, "FeaturedContentMajor", ()=>(0, _featuredContentMajorSvgMjs.S));
parcelHelpers.export(exports, "FileMinor", ()=>(0, _fileMinorSvgMjs.S));
parcelHelpers.export(exports, "FilterMajor", ()=>(0, _filterMajorSvgMjs.S));
parcelHelpers.export(exports, "FilterMinor", ()=>(0, _filterMinorSvgMjs.S));
parcelHelpers.export(exports, "FinancesMajor", ()=>(0, _financesMajorSvgMjs.S));
parcelHelpers.export(exports, "FinancesMinor", ()=>(0, _financesMinorSvgMjs.S));
parcelHelpers.export(exports, "FirstClickModelMinor", ()=>(0, _firstClickModelMinorSvgMjs.S));
parcelHelpers.export(exports, "FirstOrderMajor", ()=>(0, _firstOrderMajorSvgMjs.S));
parcelHelpers.export(exports, "FirstVisitMajor", ()=>(0, _firstVisitMajorSvgMjs.S));
parcelHelpers.export(exports, "FlagMajor", ()=>(0, _flagMajorSvgMjs.S));
parcelHelpers.export(exports, "FlipCameraMajor", ()=>(0, _flipCameraMajorSvgMjs.S));
parcelHelpers.export(exports, "FolderDownMajor", ()=>(0, _folderDownMajorSvgMjs.S));
parcelHelpers.export(exports, "FolderMajor", ()=>(0, _folderMajorSvgMjs.S));
parcelHelpers.export(exports, "FolderMinusMajor", ()=>(0, _folderMinusMajorSvgMjs.S));
parcelHelpers.export(exports, "FolderPlusMajor", ()=>(0, _folderPlusMajorSvgMjs.S));
parcelHelpers.export(exports, "FolderUpMajor", ()=>(0, _folderUpMajorSvgMjs.S));
parcelHelpers.export(exports, "FollowUpEmailMajor", ()=>(0, _followUpEmailMajorSvgMjs.S));
parcelHelpers.export(exports, "FoodMajor", ()=>(0, _foodMajorSvgMjs.S));
parcelHelpers.export(exports, "FooterMajor", ()=>(0, _footerMajorSvgMjs.S));
parcelHelpers.export(exports, "FormsMajor", ()=>(0, _formsMajorSvgMjs.S));
parcelHelpers.export(exports, "FraudProtectMajor", ()=>(0, _fraudProtectMajorSvgMjs.S));
parcelHelpers.export(exports, "FraudProtectMinor", ()=>(0, _fraudProtectMinorSvgMjs.S));
parcelHelpers.export(exports, "FraudProtectPendingMajor", ()=>(0, _fraudProtectPendingMajorSvgMjs.S));
parcelHelpers.export(exports, "FraudProtectPendingMinor", ()=>(0, _fraudProtectPendingMinorSvgMjs.S));
parcelHelpers.export(exports, "FraudProtectUnprotectedMajor", ()=>(0, _fraudProtectUnprotectedMajorSvgMjs.S));
parcelHelpers.export(exports, "FraudProtectUnprotectedMinor", ()=>(0, _fraudProtectUnprotectedMinorSvgMjs.S));
parcelHelpers.export(exports, "FulfillmentFulfilledMajor", ()=>(0, _fulfillmentFulfilledMajorSvgMjs.S));
parcelHelpers.export(exports, "FulfillmentOnHoldMajor", ()=>(0, _fulfillmentOnHoldMajorSvgMjs.S));
parcelHelpers.export(exports, "GamesConsoleMajor", ()=>(0, _gamesConsoleMajorSvgMjs.S));
parcelHelpers.export(exports, "GiftCardMajor", ()=>(0, _giftCardMajorSvgMjs.S));
parcelHelpers.export(exports, "GiftCardMinor", ()=>(0, _giftCardMinorSvgMjs.S));
parcelHelpers.export(exports, "GlobeMajor", ()=>(0, _globeMajorSvgMjs.S));
parcelHelpers.export(exports, "GlobeMinor", ()=>(0, _globeMinorSvgMjs.S));
parcelHelpers.export(exports, "GrammarMajor", ()=>(0, _grammarMajorSvgMjs.S));
parcelHelpers.export(exports, "HashtagMajor", ()=>(0, _hashtagMajorSvgMjs.S));
parcelHelpers.export(exports, "HashtagMinor", ()=>(0, _hashtagMinorSvgMjs.S));
parcelHelpers.export(exports, "HeaderMajor", ()=>(0, _headerMajorSvgMjs.S));
parcelHelpers.export(exports, "HeartMajor", ()=>(0, _heartMajorSvgMjs.S));
parcelHelpers.export(exports, "HideKeyboardMajor", ()=>(0, _hideKeyboardMajorSvgMjs.S));
parcelHelpers.export(exports, "HideMinor", ()=>(0, _hideMinorSvgMjs.S));
parcelHelpers.export(exports, "HintMajor", ()=>(0, _hintMajorSvgMjs.S));
parcelHelpers.export(exports, "HomeMajor", ()=>(0, _homeMajorSvgMjs.S));
parcelHelpers.export(exports, "HomeMinor", ()=>(0, _homeMinorSvgMjs.S));
parcelHelpers.export(exports, "HorizontalDotsMinor", ()=>(0, _horizontalDotsMinorSvgMjs.S));
parcelHelpers.export(exports, "IconsMajor", ()=>(0, _iconsMajorSvgMjs.S));
parcelHelpers.export(exports, "IdentityCardMajor", ()=>(0, _identityCardMajorSvgMjs.S));
parcelHelpers.export(exports, "IllustrationMajor", ()=>(0, _illustrationMajorSvgMjs.S));
parcelHelpers.export(exports, "ImageAltMajor", ()=>(0, _imageAltMajorSvgMjs.S));
parcelHelpers.export(exports, "ImageAltMinor", ()=>(0, _imageAltMinorSvgMjs.S));
parcelHelpers.export(exports, "ImageMajor", ()=>(0, _imageMajorSvgMjs.S));
parcelHelpers.export(exports, "ImageWithTextMajor", ()=>(0, _imageWithTextMajorSvgMjs.S));
parcelHelpers.export(exports, "ImageWithTextOverlayMajor", ()=>(0, _imageWithTextOverlayMajorSvgMjs.S));
parcelHelpers.export(exports, "ImagesMajor", ()=>(0, _imagesMajorSvgMjs.S));
parcelHelpers.export(exports, "ImportMinor", ()=>(0, _importMinorSvgMjs.S));
parcelHelpers.export(exports, "ImportStoreMajor", ()=>(0, _importStoreMajorSvgMjs.S));
parcelHelpers.export(exports, "InactiveLocationMajor", ()=>(0, _inactiveLocationMajorSvgMjs.S));
parcelHelpers.export(exports, "InactiveLocationMinor", ()=>(0, _inactiveLocationMinorSvgMjs.S));
parcelHelpers.export(exports, "IncomingMajor", ()=>(0, _incomingMajorSvgMjs.S));
parcelHelpers.export(exports, "InfoMinor", ()=>(0, _infoMinorSvgMjs.S));
parcelHelpers.export(exports, "InsertDynamicSourceMajor", ()=>(0, _insertDynamicSourceMajorSvgMjs.S));
parcelHelpers.export(exports, "InsertDynamicSourceMinor", ()=>(0, _insertDynamicSourceMinorSvgMjs.S));
parcelHelpers.export(exports, "InstallMinor", ()=>(0, _installMinorSvgMjs.S));
parcelHelpers.export(exports, "InventoryMajor", ()=>(0, _inventoryMajorSvgMjs.S));
parcelHelpers.export(exports, "InviteMinor", ()=>(0, _inviteMinorSvgMjs.S));
parcelHelpers.export(exports, "IqMajor", ()=>(0, _iqMajorSvgMjs.S));
parcelHelpers.export(exports, "JobsMajor", ()=>(0, _jobsMajorSvgMjs.S));
parcelHelpers.export(exports, "KeyMajor", ()=>(0, _keyMajorSvgMjs.S));
parcelHelpers.export(exports, "KeyboardMajor", ()=>(0, _keyboardMajorSvgMjs.S));
parcelHelpers.export(exports, "KeyboardMinor", ()=>(0, _keyboardMinorSvgMjs.S));
parcelHelpers.export(exports, "LabelPrinterMajor", ()=>(0, _labelPrinterMajorSvgMjs.S));
parcelHelpers.export(exports, "LandingPageMajor", ()=>(0, _landingPageMajorSvgMjs.S));
parcelHelpers.export(exports, "LanguageMinor", ()=>(0, _languageMinorSvgMjs.S));
parcelHelpers.export(exports, "LastClickModelMinor", ()=>(0, _lastClickModelMinorSvgMjs.S));
parcelHelpers.export(exports, "LastNonDirectClickModelMinor", ()=>(0, _lastNonDirectClickModelMinorSvgMjs.S));
parcelHelpers.export(exports, "LegalMajor", ()=>(0, _legalMajorSvgMjs.S));
parcelHelpers.export(exports, "LinearModelMinor", ()=>(0, _linearModelMinorSvgMjs.S));
parcelHelpers.export(exports, "LinkMinor", ()=>(0, _linkMinorSvgMjs.S));
parcelHelpers.export(exports, "ListMajor", ()=>(0, _listMajorSvgMjs.S));
parcelHelpers.export(exports, "ListMinor", ()=>(0, _listMinorSvgMjs.S));
parcelHelpers.export(exports, "LiveViewMajor", ()=>(0, _liveViewMajorSvgMjs.S));
parcelHelpers.export(exports, "LocationMajor", ()=>(0, _locationMajorSvgMjs.S));
parcelHelpers.export(exports, "LocationsMinor", ()=>(0, _locationsMinorSvgMjs.S));
parcelHelpers.export(exports, "LockMajor", ()=>(0, _lockMajorSvgMjs.S));
parcelHelpers.export(exports, "LockMinor", ()=>(0, _lockMinorSvgMjs.S));
parcelHelpers.export(exports, "LogOutMinor", ()=>(0, _logOutMinorSvgMjs.S));
parcelHelpers.export(exports, "LogoBlockMajor", ()=>(0, _logoBlockMajorSvgMjs.S));
parcelHelpers.export(exports, "MagicMajor", ()=>(0, _magicMajorSvgMjs.S));
parcelHelpers.export(exports, "MagicMinor", ()=>(0, _magicMinorSvgMjs.S));
parcelHelpers.export(exports, "ManagedStoreMajor", ()=>(0, _managedStoreMajorSvgMjs.S));
parcelHelpers.export(exports, "MarkFulfilledMinor", ()=>(0, _markFulfilledMinorSvgMjs.S));
parcelHelpers.export(exports, "MarkPaidMinor", ()=>(0, _markPaidMinorSvgMjs.S));
parcelHelpers.export(exports, "MarketingMajor", ()=>(0, _marketingMajorSvgMjs.S));
parcelHelpers.export(exports, "MarketingMinor", ()=>(0, _marketingMinorSvgMjs.S));
parcelHelpers.export(exports, "MarketsMajor", ()=>(0, _marketsMajorSvgMjs.S));
parcelHelpers.export(exports, "MaximizeMajor", ()=>(0, _maximizeMajorSvgMjs.S));
parcelHelpers.export(exports, "MaximizeMinor", ()=>(0, _maximizeMinorSvgMjs.S));
parcelHelpers.export(exports, "MeasurementMinor", ()=>(0, _measurementMinorSvgMjs.S));
parcelHelpers.export(exports, "MentionMajor", ()=>(0, _mentionMajorSvgMjs.S));
parcelHelpers.export(exports, "MergeMinor", ()=>(0, _mergeMinorSvgMjs.S));
parcelHelpers.export(exports, "MetafieldsMajor", ()=>(0, _metafieldsMajorSvgMjs.S));
parcelHelpers.export(exports, "MetafieldsMinor", ()=>(0, _metafieldsMinorSvgMjs.S));
parcelHelpers.export(exports, "MetaobjectMinor", ()=>(0, _metaobjectMinorSvgMjs.S));
parcelHelpers.export(exports, "MetaobjectReferenceMinor", ()=>(0, _metaobjectReferenceMinorSvgMjs.S));
parcelHelpers.export(exports, "MicrophoneMajor", ()=>(0, _microphoneMajorSvgMjs.S));
parcelHelpers.export(exports, "MinimizeMajor", ()=>(0, _minimizeMajorSvgMjs.S));
parcelHelpers.export(exports, "MinimizeMinor", ()=>(0, _minimizeMinorSvgMjs.S));
parcelHelpers.export(exports, "MinusMajor", ()=>(0, _minusMajorSvgMjs.S));
parcelHelpers.export(exports, "MinusMinor", ()=>(0, _minusMinorSvgMjs.S));
parcelHelpers.export(exports, "MobileAcceptMajor", ()=>(0, _mobileAcceptMajorSvgMjs.S));
parcelHelpers.export(exports, "MobileBackArrowMajor", ()=>(0, _mobileBackArrowMajorSvgMjs.S));
parcelHelpers.export(exports, "MobileCancelMajor", ()=>(0, _mobileCancelMajorSvgMjs.S));
parcelHelpers.export(exports, "MobileChevronMajor", ()=>(0, _mobileChevronMajorSvgMjs.S));
parcelHelpers.export(exports, "MobileHamburgerMajor", ()=>(0, _mobileHamburgerMajorSvgMjs.S));
parcelHelpers.export(exports, "MobileHorizontalDotsMajor", ()=>(0, _mobileHorizontalDotsMajorSvgMjs.S));
parcelHelpers.export(exports, "MobileMajor", ()=>(0, _mobileMajorSvgMjs.S));
parcelHelpers.export(exports, "MobilePlusMajor", ()=>(0, _mobilePlusMajorSvgMjs.S));
parcelHelpers.export(exports, "MobileVerticalDotsMajor", ()=>(0, _mobileVerticalDotsMajorSvgMjs.S));
parcelHelpers.export(exports, "MonerisMajor", ()=>(0, _monerisMajorSvgMjs.S));
parcelHelpers.export(exports, "MoneyMinor", ()=>(0, _moneyMinorSvgMjs.S));
parcelHelpers.export(exports, "NatureMajor", ()=>(0, _natureMajorSvgMjs.S));
parcelHelpers.export(exports, "NavigationMajor", ()=>(0, _navigationMajorSvgMjs.S));
parcelHelpers.export(exports, "NoteMajor", ()=>(0, _noteMajorSvgMjs.S));
parcelHelpers.export(exports, "NoteMinor", ()=>(0, _noteMinorSvgMjs.S));
parcelHelpers.export(exports, "NotificationMajor", ()=>(0, _notificationMajorSvgMjs.S));
parcelHelpers.export(exports, "OnlineStoreMajor", ()=>(0, _onlineStoreMajorSvgMjs.S));
parcelHelpers.export(exports, "OnlineStoreMinor", ()=>(0, _onlineStoreMinorSvgMjs.S));
parcelHelpers.export(exports, "OrderStatusMinor", ()=>(0, _orderStatusMinorSvgMjs.S));
parcelHelpers.export(exports, "OrdersMajor", ()=>(0, _ordersMajorSvgMjs.S));
parcelHelpers.export(exports, "OrdersMinor", ()=>(0, _ordersMinorSvgMjs.S));
parcelHelpers.export(exports, "OrganizationMajor", ()=>(0, _organizationMajorSvgMjs.S));
parcelHelpers.export(exports, "OutgoingMajor", ()=>(0, _outgoingMajorSvgMjs.S));
parcelHelpers.export(exports, "PackageMajor", ()=>(0, _packageMajorSvgMjs.S));
parcelHelpers.export(exports, "PageDownMajor", ()=>(0, _pageDownMajorSvgMjs.S));
parcelHelpers.export(exports, "PageMajor", ()=>(0, _pageMajorSvgMjs.S));
parcelHelpers.export(exports, "PageMinusMajor", ()=>(0, _pageMinusMajorSvgMjs.S));
parcelHelpers.export(exports, "PagePlusMajor", ()=>(0, _pagePlusMajorSvgMjs.S));
parcelHelpers.export(exports, "PageReferenceMinor", ()=>(0, _pageReferenceMinorSvgMjs.S));
parcelHelpers.export(exports, "PageUpMajor", ()=>(0, _pageUpMajorSvgMjs.S));
parcelHelpers.export(exports, "PaginationEndMinor", ()=>(0, _paginationEndMinorSvgMjs.S));
parcelHelpers.export(exports, "PaginationStartMinor", ()=>(0, _paginationStartMinorSvgMjs.S));
parcelHelpers.export(exports, "PaintBrushMajor", ()=>(0, _paintBrushMajorSvgMjs.S));
parcelHelpers.export(exports, "PaperCheckMajor", ()=>(0, _paperCheckMajorSvgMjs.S));
parcelHelpers.export(exports, "PaperCheckMinor", ()=>(0, _paperCheckMinorSvgMjs.S));
parcelHelpers.export(exports, "PasskeyMajor", ()=>(0, _passkeyMajorSvgMjs.S));
parcelHelpers.export(exports, "PasskeyMinor", ()=>(0, _passkeyMinorSvgMjs.S));
parcelHelpers.export(exports, "PauseCircleMajor", ()=>(0, _pauseCircleMajorSvgMjs.S));
parcelHelpers.export(exports, "PauseMajor", ()=>(0, _pauseMajorSvgMjs.S));
parcelHelpers.export(exports, "PauseMinor", ()=>(0, _pauseMinorSvgMjs.S));
parcelHelpers.export(exports, "PaymentsMajor", ()=>(0, _paymentsMajorSvgMjs.S));
parcelHelpers.export(exports, "PersonalizedTextMajor", ()=>(0, _personalizedTextMajorSvgMjs.S));
parcelHelpers.export(exports, "PhoneInMajor", ()=>(0, _phoneInMajorSvgMjs.S));
parcelHelpers.export(exports, "PhoneMajor", ()=>(0, _phoneMajorSvgMjs.S));
parcelHelpers.export(exports, "PhoneOutMajor", ()=>(0, _phoneOutMajorSvgMjs.S));
parcelHelpers.export(exports, "PinMajor", ()=>(0, _pinMajorSvgMjs.S));
parcelHelpers.export(exports, "PinMinor", ()=>(0, _pinMinorSvgMjs.S));
parcelHelpers.export(exports, "PinUnfilledMajor", ()=>(0, _pinUnfilledMajorSvgMjs.S));
parcelHelpers.export(exports, "PinUnfilledMinor", ()=>(0, _pinUnfilledMinorSvgMjs.S));
parcelHelpers.export(exports, "PlanMajor", ()=>(0, _planMajorSvgMjs.S));
parcelHelpers.export(exports, "PlanMinor", ()=>(0, _planMinorSvgMjs.S));
parcelHelpers.export(exports, "PlayCircleMajor", ()=>(0, _playCircleMajorSvgMjs.S));
parcelHelpers.export(exports, "PlayMajor", ()=>(0, _playMajorSvgMjs.S));
parcelHelpers.export(exports, "PlayMinor", ()=>(0, _playMinorSvgMjs.S));
parcelHelpers.export(exports, "PlusMinor", ()=>(0, _plusMinorSvgMjs.S));
parcelHelpers.export(exports, "PointOfSaleMajor", ()=>(0, _pointOfSaleMajorSvgMjs.S));
parcelHelpers.export(exports, "PopularMajor", ()=>(0, _popularMajorSvgMjs.S));
parcelHelpers.export(exports, "PositionBasedModelMinor", ()=>(0, _positionBasedModelMinorSvgMjs.S));
parcelHelpers.export(exports, "PriceLookupMinor", ()=>(0, _priceLookupMinorSvgMjs.S));
parcelHelpers.export(exports, "PrintMajor", ()=>(0, _printMajorSvgMjs.S));
parcelHelpers.export(exports, "PrintMinor", ()=>(0, _printMinorSvgMjs.S));
parcelHelpers.export(exports, "ProductCostMajor", ()=>(0, _productCostMajorSvgMjs.S));
parcelHelpers.export(exports, "ProductReferenceMinor", ()=>(0, _productReferenceMinorSvgMjs.S));
parcelHelpers.export(exports, "ProductReturnsMinor", ()=>(0, _productReturnsMinorSvgMjs.S));
parcelHelpers.export(exports, "ProductsMajor", ()=>(0, _productsMajorSvgMjs.S));
parcelHelpers.export(exports, "ProductsMinor", ()=>(0, _productsMinorSvgMjs.S));
parcelHelpers.export(exports, "ProfileMajor", ()=>(0, _profileMajorSvgMjs.S));
parcelHelpers.export(exports, "ProfileMinor", ()=>(0, _profileMinorSvgMjs.S));
parcelHelpers.export(exports, "PromoteMinor", ()=>(0, _promoteMinorSvgMjs.S));
parcelHelpers.export(exports, "QuestionMarkInverseMajor", ()=>(0, _questionMarkInverseMajorSvgMjs.S));
parcelHelpers.export(exports, "QuestionMarkInverseMinor", ()=>(0, _questionMarkInverseMinorSvgMjs.S));
parcelHelpers.export(exports, "QuestionMarkMajor", ()=>(0, _questionMarkMajorSvgMjs.S));
parcelHelpers.export(exports, "QuestionMarkMinor", ()=>(0, _questionMarkMinorSvgMjs.S));
parcelHelpers.export(exports, "QuickSaleMajor", ()=>(0, _quickSaleMajorSvgMjs.S));
parcelHelpers.export(exports, "ReadTimeMinor", ()=>(0, _readTimeMinorSvgMjs.S));
parcelHelpers.export(exports, "ReceiptMajor", ()=>(0, _receiptMajorSvgMjs.S));
parcelHelpers.export(exports, "RecentSearchesMajor", ()=>(0, _recentSearchesMajorSvgMjs.S));
parcelHelpers.export(exports, "RedoMajor", ()=>(0, _redoMajorSvgMjs.S));
parcelHelpers.export(exports, "ReferralCodeMajor", ()=>(0, _referralCodeMajorSvgMjs.S));
parcelHelpers.export(exports, "ReferralMajor", ()=>(0, _referralMajorSvgMjs.S));
parcelHelpers.export(exports, "RefreshMajor", ()=>(0, _refreshMajorSvgMjs.S));
parcelHelpers.export(exports, "RefreshMinor", ()=>(0, _refreshMinorSvgMjs.S));
parcelHelpers.export(exports, "RefundMajor", ()=>(0, _refundMajorSvgMjs.S));
parcelHelpers.export(exports, "RefundMinor", ()=>(0, _refundMinorSvgMjs.S));
parcelHelpers.export(exports, "RemoveProductMajor", ()=>(0, _removeProductMajorSvgMjs.S));
parcelHelpers.export(exports, "RepeatOrderMajor", ()=>(0, _repeatOrderMajorSvgMjs.S));
parcelHelpers.export(exports, "ReplaceMajor", ()=>(0, _replaceMajorSvgMjs.S));
parcelHelpers.export(exports, "ReplayMinor", ()=>(0, _replayMinorSvgMjs.S));
parcelHelpers.export(exports, "ReportMinor", ()=>(0, _reportMinorSvgMjs.S));
parcelHelpers.export(exports, "ReportsMajor", ()=>(0, _reportsMajorSvgMjs.S));
parcelHelpers.export(exports, "ResetMinor", ()=>(0, _resetMinorSvgMjs.S));
parcelHelpers.export(exports, "ResourcesMajor", ()=>(0, _resourcesMajorSvgMjs.S));
parcelHelpers.export(exports, "ReturnMinor", ()=>(0, _returnMinorSvgMjs.S));
parcelHelpers.export(exports, "ReturnsMajor", ()=>(0, _returnsMajorSvgMjs.S));
parcelHelpers.export(exports, "RichTextMinor", ()=>(0, _richTextMinorSvgMjs.S));
parcelHelpers.export(exports, "RiskMajor", ()=>(0, _riskMajorSvgMjs.S));
parcelHelpers.export(exports, "RiskMinor", ()=>(0, _riskMinorSvgMjs.S));
parcelHelpers.export(exports, "Rows2Major", ()=>(0, _rows2MajorSvgMjs.S));
parcelHelpers.export(exports, "SandboxMajor", ()=>(0, _sandboxMajorSvgMjs.S));
parcelHelpers.export(exports, "SaveMinor", ()=>(0, _saveMinorSvgMjs.S));
parcelHelpers.export(exports, "SearchMajor", ()=>(0, _searchMajorSvgMjs.S));
parcelHelpers.export(exports, "SearchMinor", ()=>(0, _searchMinorSvgMjs.S));
parcelHelpers.export(exports, "SectionMajor", ()=>(0, _sectionMajorSvgMjs.S));
parcelHelpers.export(exports, "SecureMajor", ()=>(0, _secureMajorSvgMjs.S));
parcelHelpers.export(exports, "SelectMinor", ()=>(0, _selectMinorSvgMjs.S));
parcelHelpers.export(exports, "SendMajor", ()=>(0, _sendMajorSvgMjs.S));
parcelHelpers.export(exports, "SettingsMajor", ()=>(0, _settingsMajorSvgMjs.S));
parcelHelpers.export(exports, "SettingsMinor", ()=>(0, _settingsMinorSvgMjs.S));
parcelHelpers.export(exports, "ShareIosMinor", ()=>(0, _shareIosMinorSvgMjs.S));
parcelHelpers.export(exports, "ShareMinor", ()=>(0, _shareMinorSvgMjs.S));
parcelHelpers.export(exports, "ShipmentMajor", ()=>(0, _shipmentMajorSvgMjs.S));
parcelHelpers.export(exports, "ShopcodesMajor", ()=>(0, _shopcodesMajorSvgMjs.S));
parcelHelpers.export(exports, "SidebarLeftMajor", ()=>(0, _sidebarLeftMajorSvgMjs.S));
parcelHelpers.export(exports, "SidebarRightMajor", ()=>(0, _sidebarRightMajorSvgMjs.S));
parcelHelpers.export(exports, "SimplifyMajor", ()=>(0, _simplifyMajorSvgMjs.S));
parcelHelpers.export(exports, "SimplifyMinor", ()=>(0, _simplifyMinorSvgMjs.S));
parcelHelpers.export(exports, "SlideshowMajor", ()=>(0, _slideshowMajorSvgMjs.S));
parcelHelpers.export(exports, "SmileyHappyMajor", ()=>(0, _smileyHappyMajorSvgMjs.S));
parcelHelpers.export(exports, "SmileyJoyMajor", ()=>(0, _smileyJoyMajorSvgMjs.S));
parcelHelpers.export(exports, "SmileyNeutralMajor", ()=>(0, _smileyNeutralMajorSvgMjs.S));
parcelHelpers.export(exports, "SmileySadMajor", ()=>(0, _smileySadMajorSvgMjs.S));
parcelHelpers.export(exports, "SocialAdMajor", ()=>(0, _socialAdMajorSvgMjs.S));
parcelHelpers.export(exports, "SocialPostMajor", ()=>(0, _socialPostMajorSvgMjs.S));
parcelHelpers.export(exports, "SoftPackMajor", ()=>(0, _softPackMajorSvgMjs.S));
parcelHelpers.export(exports, "SortAscendingMajor", ()=>(0, _sortAscendingMajorSvgMjs.S));
parcelHelpers.export(exports, "SortDescendingMajor", ()=>(0, _sortDescendingMajorSvgMjs.S));
parcelHelpers.export(exports, "SortMinor", ()=>(0, _sortMinorSvgMjs.S));
parcelHelpers.export(exports, "SoundMajor", ()=>(0, _soundMajorSvgMjs.S));
parcelHelpers.export(exports, "StarFilledMinor", ()=>(0, _starFilledMinorSvgMjs.S));
parcelHelpers.export(exports, "StarOutlineMinor", ()=>(0, _starOutlineMinorSvgMjs.S));
parcelHelpers.export(exports, "StatusActiveMajor", ()=>(0, _statusActiveMajorSvgMjs.S));
parcelHelpers.export(exports, "StoreMajor", ()=>(0, _storeMajorSvgMjs.S));
parcelHelpers.export(exports, "StoreMinor", ()=>(0, _storeMinorSvgMjs.S));
parcelHelpers.export(exports, "StoreStatusMajor", ()=>(0, _storeStatusMajorSvgMjs.S));
parcelHelpers.export(exports, "TabletMajor", ()=>(0, _tabletMajorSvgMjs.S));
parcelHelpers.export(exports, "TapChipMajor", ()=>(0, _tapChipMajorSvgMjs.S));
parcelHelpers.export(exports, "TaxMajor", ()=>(0, _taxMajorSvgMjs.S));
parcelHelpers.export(exports, "TeamMajor", ()=>(0, _teamMajorSvgMjs.S));
parcelHelpers.export(exports, "TemplateMajor", ()=>(0, _templateMajorSvgMjs.S));
parcelHelpers.export(exports, "TemplateMinor", ()=>(0, _templateMinorSvgMjs.S));
parcelHelpers.export(exports, "TextAlignmentCenterMajor", ()=>(0, _textAlignmentCenterMajorSvgMjs.S));
parcelHelpers.export(exports, "TextAlignmentLeftMajor", ()=>(0, _textAlignmentLeftMajorSvgMjs.S));
parcelHelpers.export(exports, "TextAlignmentRightMajor", ()=>(0, _textAlignmentRightMajorSvgMjs.S));
parcelHelpers.export(exports, "TextBlockMajor", ()=>(0, _textBlockMajorSvgMjs.S));
parcelHelpers.export(exports, "TextMajor", ()=>(0, _textMajorSvgMjs.S));
parcelHelpers.export(exports, "ThemeEditMajor", ()=>(0, _themeEditMajorSvgMjs.S));
parcelHelpers.export(exports, "ThemeStoreMajor", ()=>(0, _themeStoreMajorSvgMjs.S));
parcelHelpers.export(exports, "ThemesMajor", ()=>(0, _themesMajorSvgMjs.S));
parcelHelpers.export(exports, "ThumbsDownMajor", ()=>(0, _thumbsDownMajorSvgMjs.S));
parcelHelpers.export(exports, "ThumbsDownMinor", ()=>(0, _thumbsDownMinorSvgMjs.S));
parcelHelpers.export(exports, "ThumbsUpMajor", ()=>(0, _thumbsUpMajorSvgMjs.S));
parcelHelpers.export(exports, "ThumbsUpMinor", ()=>(0, _thumbsUpMinorSvgMjs.S));
parcelHelpers.export(exports, "TickMinor", ()=>(0, _tickMinorSvgMjs.S));
parcelHelpers.export(exports, "TickSmallMinor", ()=>(0, _tickSmallMinorSvgMjs.S));
parcelHelpers.export(exports, "TimeDecayModelMinor", ()=>(0, _timeDecayModelMinorSvgMjs.S));
parcelHelpers.export(exports, "TimelineAttachmentMajor", ()=>(0, _timelineAttachmentMajorSvgMjs.S));
parcelHelpers.export(exports, "TipsMajor", ()=>(0, _tipsMajorSvgMjs.S));
parcelHelpers.export(exports, "TitleMinor", ()=>(0, _titleMinorSvgMjs.S));
parcelHelpers.export(exports, "ToggleMinor", ()=>(0, _toggleMinorSvgMjs.S));
parcelHelpers.export(exports, "ToolsMajor", ()=>(0, _toolsMajorSvgMjs.S));
parcelHelpers.export(exports, "TransactionFeeDollarMajor", ()=>(0, _transactionFeeDollarMajorSvgMjs.S));
parcelHelpers.export(exports, "TransactionFeeEuroMajor", ()=>(0, _transactionFeeEuroMajorSvgMjs.S));
parcelHelpers.export(exports, "TransactionFeePoundMajor", ()=>(0, _transactionFeePoundMajorSvgMjs.S));
parcelHelpers.export(exports, "TransactionFeeRupeeMajor", ()=>(0, _transactionFeeRupeeMajorSvgMjs.S));
parcelHelpers.export(exports, "TransactionFeeYenMajor", ()=>(0, _transactionFeeYenMajorSvgMjs.S));
parcelHelpers.export(exports, "TransactionMajor", ()=>(0, _transactionMajorSvgMjs.S));
parcelHelpers.export(exports, "TransferInMajor", ()=>(0, _transferInMajorSvgMjs.S));
parcelHelpers.export(exports, "TransferMajor", ()=>(0, _transferMajorSvgMjs.S));
parcelHelpers.export(exports, "TransferOutMajor", ()=>(0, _transferOutMajorSvgMjs.S));
parcelHelpers.export(exports, "TransferWithinShopifyMajor", ()=>(0, _transferWithinShopifyMajorSvgMjs.S));
parcelHelpers.export(exports, "TransportMajor", ()=>(0, _transportMajorSvgMjs.S));
parcelHelpers.export(exports, "TroubleshootMajor", ()=>(0, _troubleshootMajorSvgMjs.S));
parcelHelpers.export(exports, "TypeMajor", ()=>(0, _typeMajorSvgMjs.S));
parcelHelpers.export(exports, "TypeMinor", ()=>(0, _typeMinorSvgMjs.S));
parcelHelpers.export(exports, "UndoMajor", ()=>(0, _undoMajorSvgMjs.S));
parcelHelpers.export(exports, "UnfulfilledMajor", ()=>(0, _unfulfilledMajorSvgMjs.S));
parcelHelpers.export(exports, "UnknownDeviceMajor", ()=>(0, _unknownDeviceMajorSvgMjs.S));
parcelHelpers.export(exports, "UpdateInventoryMajor", ()=>(0, _updateInventoryMajorSvgMjs.S));
parcelHelpers.export(exports, "UploadMajor", ()=>(0, _uploadMajorSvgMjs.S));
parcelHelpers.export(exports, "VariantMajor", ()=>(0, _variantMajorSvgMjs.S));
parcelHelpers.export(exports, "ViewMajor", ()=>(0, _viewMajorSvgMjs.S));
parcelHelpers.export(exports, "ViewMinor", ()=>(0, _viewMinorSvgMjs.S));
parcelHelpers.export(exports, "ViewportNarrowMajor", ()=>(0, _viewportNarrowMajorSvgMjs.S));
parcelHelpers.export(exports, "ViewportShortMajor", ()=>(0, _viewportShortMajorSvgMjs.S));
parcelHelpers.export(exports, "ViewportTallMajor", ()=>(0, _viewportTallMajorSvgMjs.S));
parcelHelpers.export(exports, "ViewportWideMajor", ()=>(0, _viewportWideMajorSvgMjs.S));
parcelHelpers.export(exports, "VocabularyMajor", ()=>(0, _vocabularyMajorSvgMjs.S));
parcelHelpers.export(exports, "VolumeMinor", ()=>(0, _volumeMinorSvgMjs.S));
parcelHelpers.export(exports, "WandMajor", ()=>(0, _wandMajorSvgMjs.S));
parcelHelpers.export(exports, "WandMinor", ()=>(0, _wandMinorSvgMjs.S));
parcelHelpers.export(exports, "WearableMajor", ()=>(0, _wearableMajorSvgMjs.S));
parcelHelpers.export(exports, "WeightMinor", ()=>(0, _weightMinorSvgMjs.S));
parcelHelpers.export(exports, "WholesaleMajor", ()=>(0, _wholesaleMajorSvgMjs.S));
parcelHelpers.export(exports, "WifiMajor", ()=>(0, _wifiMajorSvgMjs.S));
var _abandonedCartMajorSvgMjs = require("./icons/AbandonedCartMajor.svg.mjs");
var _accessibilityMajorSvgMjs = require("./icons/AccessibilityMajor.svg.mjs");
var _activitiesMajorSvgMjs = require("./icons/ActivitiesMajor.svg.mjs");
var _addCodeMajorSvgMjs = require("./icons/AddCodeMajor.svg.mjs");
var _addImageMajorSvgMjs = require("./icons/AddImageMajor.svg.mjs");
var _addMajorSvgMjs = require("./icons/AddMajor.svg.mjs");
var _addNoteMajorSvgMjs = require("./icons/AddNoteMajor.svg.mjs");
var _addProductMajorSvgMjs = require("./icons/AddProductMajor.svg.mjs");
var _adjustMinorSvgMjs = require("./icons/AdjustMinor.svg.mjs");
var _affiliateMajorSvgMjs = require("./icons/AffiliateMajor.svg.mjs");
var _alertMinorSvgMjs = require("./icons/AlertMinor.svg.mjs");
var _analyticsBarHorizontalMinorSvgMjs = require("./icons/AnalyticsBarHorizontalMinor.svg.mjs");
var _analyticsBarStackedMinorSvgMjs = require("./icons/AnalyticsBarStackedMinor.svg.mjs");
var _analyticsCohortMinorSvgMjs = require("./icons/AnalyticsCohortMinor.svg.mjs");
var _analyticsDonutMinorSvgMjs = require("./icons/AnalyticsDonutMinor.svg.mjs");
var _analyticsFunnelMinorSvgMjs = require("./icons/AnalyticsFunnelMinor.svg.mjs");
var _analyticsLineMinorSvgMjs = require("./icons/AnalyticsLineMinor.svg.mjs");
var _analyticsMajorSvgMjs = require("./icons/AnalyticsMajor.svg.mjs");
var _analyticsMinorSvgMjs = require("./icons/AnalyticsMinor.svg.mjs");
var _analyticsTableMinorSvgMjs = require("./icons/AnalyticsTableMinor.svg.mjs");
var _anyClickModelMinorSvgMjs = require("./icons/AnyClickModelMinor.svg.mjs");
var _appExtensionMinorSvgMjs = require("./icons/AppExtensionMinor.svg.mjs");
var _appsMajorSvgMjs = require("./icons/AppsMajor.svg.mjs");
var _appsMinorSvgMjs = require("./icons/AppsMinor.svg.mjs");
var _archiveMajorSvgMjs = require("./icons/ArchiveMajor.svg.mjs");
var _archiveMinorSvgMjs = require("./icons/ArchiveMinor.svg.mjs");
var _arrowDownMinorSvgMjs = require("./icons/ArrowDownMinor.svg.mjs");
var _arrowLeftMinorSvgMjs = require("./icons/ArrowLeftMinor.svg.mjs");
var _arrowRightMinorSvgMjs = require("./icons/ArrowRightMinor.svg.mjs");
var _arrowUpMinorSvgMjs = require("./icons/ArrowUpMinor.svg.mjs");
var _attachmentMajorSvgMjs = require("./icons/AttachmentMajor.svg.mjs");
var _automationMajorSvgMjs = require("./icons/AutomationMajor.svg.mjs");
var _backspaceMajorSvgMjs = require("./icons/BackspaceMajor.svg.mjs");
var _balanceMajorSvgMjs = require("./icons/BalanceMajor.svg.mjs");
var _bankMajorSvgMjs = require("./icons/BankMajor.svg.mjs");
var _barcodeMajorSvgMjs = require("./icons/BarcodeMajor.svg.mjs");
var _behaviorMajorSvgMjs = require("./icons/BehaviorMajor.svg.mjs");
var _behaviorMinorSvgMjs = require("./icons/BehaviorMinor.svg.mjs");
var _billingStatementDollarMajorSvgMjs = require("./icons/BillingStatementDollarMajor.svg.mjs");
var _billingStatementEuroMajorSvgMjs = require("./icons/BillingStatementEuroMajor.svg.mjs");
var _billingStatementPoundMajorSvgMjs = require("./icons/BillingStatementPoundMajor.svg.mjs");
var _billingStatementRupeeMajorSvgMjs = require("./icons/BillingStatementRupeeMajor.svg.mjs");
var _billingStatementYenMajorSvgMjs = require("./icons/BillingStatementYenMajor.svg.mjs");
var _blockMinorSvgMjs = require("./icons/BlockMinor.svg.mjs");
var _blockquoteMajorSvgMjs = require("./icons/BlockquoteMajor.svg.mjs");
var _blogMajorSvgMjs = require("./icons/BlogMajor.svg.mjs");
var _bugMajorSvgMjs = require("./icons/BugMajor.svg.mjs");
var _buttonCornerPillMajorSvgMjs = require("./icons/ButtonCornerPillMajor.svg.mjs");
var _buttonCornerRoundedMajorSvgMjs = require("./icons/ButtonCornerRoundedMajor.svg.mjs");
var _buttonCornerSquareMajorSvgMjs = require("./icons/ButtonCornerSquareMajor.svg.mjs");
var _buttonMinorSvgMjs = require("./icons/ButtonMinor.svg.mjs");
var _buyButtonButtonLayoutMajorSvgMjs = require("./icons/BuyButtonButtonLayoutMajor.svg.mjs");
var _buyButtonHorizontalLayoutMajorSvgMjs = require("./icons/BuyButtonHorizontalLayoutMajor.svg.mjs");
var _buyButtonMajorSvgMjs = require("./icons/BuyButtonMajor.svg.mjs");
var _buyButtonVerticalLayoutMajorSvgMjs = require("./icons/BuyButtonVerticalLayoutMajor.svg.mjs");
var _calendarMajorSvgMjs = require("./icons/CalendarMajor.svg.mjs");
var _calendarMinorSvgMjs = require("./icons/CalendarMinor.svg.mjs");
var _calendarTickMajorSvgMjs = require("./icons/CalendarTickMajor.svg.mjs");
var _calendarTimeMinorSvgMjs = require("./icons/CalendarTimeMinor.svg.mjs");
var _cameraMajorSvgMjs = require("./icons/CameraMajor.svg.mjs");
var _cancelMajorSvgMjs = require("./icons/CancelMajor.svg.mjs");
var _cancelMinorSvgMjs = require("./icons/CancelMinor.svg.mjs");
var _cancelSmallMinorSvgMjs = require("./icons/CancelSmallMinor.svg.mjs");
var _capitalMajorSvgMjs = require("./icons/CapitalMajor.svg.mjs");
var _capturePaymentMinorSvgMjs = require("./icons/CapturePaymentMinor.svg.mjs");
var _cardReaderChipMajorSvgMjs = require("./icons/CardReaderChipMajor.svg.mjs");
var _cardReaderMajorSvgMjs = require("./icons/CardReaderMajor.svg.mjs");
var _cardReaderTapMajorSvgMjs = require("./icons/CardReaderTapMajor.svg.mjs");
var _caretDownMinorSvgMjs = require("./icons/CaretDownMinor.svg.mjs");
var _caretUpMinorSvgMjs = require("./icons/CaretUpMinor.svg.mjs");
var _cartDownMajorSvgMjs = require("./icons/CartDownMajor.svg.mjs");
var _cartMajorSvgMjs = require("./icons/CartMajor.svg.mjs");
var _cartUpMajorSvgMjs = require("./icons/CartUpMajor.svg.mjs");
var _cashDollarMajorSvgMjs = require("./icons/CashDollarMajor.svg.mjs");
var _cashDollarMinorSvgMjs = require("./icons/CashDollarMinor.svg.mjs");
var _cashEuroMajorSvgMjs = require("./icons/CashEuroMajor.svg.mjs");
var _cashPoundMajorSvgMjs = require("./icons/CashPoundMajor.svg.mjs");
var _cashRupeeMajorSvgMjs = require("./icons/CashRupeeMajor.svg.mjs");
var _cashYenMajorSvgMjs = require("./icons/CashYenMajor.svg.mjs");
var _categoriesMajorSvgMjs = require("./icons/CategoriesMajor.svg.mjs");
var _channelsMajorSvgMjs = require("./icons/ChannelsMajor.svg.mjs");
var _chatMajorSvgMjs = require("./icons/ChatMajor.svg.mjs");
var _checklistAlternateMajorSvgMjs = require("./icons/ChecklistAlternateMajor.svg.mjs");
var _checklistMajorSvgMjs = require("./icons/ChecklistMajor.svg.mjs");
var _checkoutMajorSvgMjs = require("./icons/CheckoutMajor.svg.mjs");
var _chevronDownMinorSvgMjs = require("./icons/ChevronDownMinor.svg.mjs");
var _chevronLeftMinorSvgMjs = require("./icons/ChevronLeftMinor.svg.mjs");
var _chevronRightMinorSvgMjs = require("./icons/ChevronRightMinor.svg.mjs");
var _chevronUpMinorSvgMjs = require("./icons/ChevronUpMinor.svg.mjs");
var _circleAlertMajorSvgMjs = require("./icons/CircleAlertMajor.svg.mjs");
var _circleCancelMajorSvgMjs = require("./icons/CircleCancelMajor.svg.mjs");
var _circleCancelMinorSvgMjs = require("./icons/CircleCancelMinor.svg.mjs");
var _circleChevronDownMinorSvgMjs = require("./icons/CircleChevronDownMinor.svg.mjs");
var _circleChevronLeftMinorSvgMjs = require("./icons/CircleChevronLeftMinor.svg.mjs");
var _circleChevronRightMinorSvgMjs = require("./icons/CircleChevronRightMinor.svg.mjs");
var _circleChevronUpMinorSvgMjs = require("./icons/CircleChevronUpMinor.svg.mjs");
var _circleDisableMinorSvgMjs = require("./icons/CircleDisableMinor.svg.mjs");
var _circleDisabledMajorSvgMjs = require("./icons/CircleDisabledMajor.svg.mjs");
var _circleDotsMajorSvgMjs = require("./icons/CircleDotsMajor.svg.mjs");
var _circleDownMajorSvgMjs = require("./icons/CircleDownMajor.svg.mjs");
var _circleInformationMajorSvgMjs = require("./icons/CircleInformationMajor.svg.mjs");
var _circleLeftMajorSvgMjs = require("./icons/CircleLeftMajor.svg.mjs");
var _circleMinusMajorSvgMjs = require("./icons/CircleMinusMajor.svg.mjs");
var _circleMinusMinorSvgMjs = require("./icons/CircleMinusMinor.svg.mjs");
var _circleMinusOutlineMinorSvgMjs = require("./icons/CircleMinusOutlineMinor.svg.mjs");
var _circlePlusMajorSvgMjs = require("./icons/CirclePlusMajor.svg.mjs");
var _circlePlusMinorSvgMjs = require("./icons/CirclePlusMinor.svg.mjs");
var _circlePlusOutlineMinorSvgMjs = require("./icons/CirclePlusOutlineMinor.svg.mjs");
var _circleRightMajorSvgMjs = require("./icons/CircleRightMajor.svg.mjs");
var _circleTickMajorSvgMjs = require("./icons/CircleTickMajor.svg.mjs");
var _circleTickMinorSvgMjs = require("./icons/CircleTickMinor.svg.mjs");
var _circleTickOutlineMinorSvgMjs = require("./icons/CircleTickOutlineMinor.svg.mjs");
var _circleUpMajorSvgMjs = require("./icons/CircleUpMajor.svg.mjs");
var _clipboardMinorSvgMjs = require("./icons/ClipboardMinor.svg.mjs");
var _clockMajorSvgMjs = require("./icons/ClockMajor.svg.mjs");
var _clockMinorSvgMjs = require("./icons/ClockMinor.svg.mjs");
var _codeMajorSvgMjs = require("./icons/CodeMajor.svg.mjs");
var _codeMinorSvgMjs = require("./icons/CodeMinor.svg.mjs");
var _collectionReferenceMinorSvgMjs = require("./icons/CollectionReferenceMinor.svg.mjs");
var _collectionsMajorSvgMjs = require("./icons/CollectionsMajor.svg.mjs");
var _colorNoneMinorSvgMjs = require("./icons/ColorNoneMinor.svg.mjs");
var _colorsMajorSvgMjs = require("./icons/ColorsMajor.svg.mjs");
var _column1MajorSvgMjs = require("./icons/Column1Major.svg.mjs");
var _columnWithTextMajorSvgMjs = require("./icons/ColumnWithTextMajor.svg.mjs");
var _columns2MajorSvgMjs = require("./icons/Columns2Major.svg.mjs");
var _columns3MajorSvgMjs = require("./icons/Columns3Major.svg.mjs");
var _columns3MinorSvgMjs = require("./icons/Columns3Minor.svg.mjs");
var _composeMajorSvgMjs = require("./icons/ComposeMajor.svg.mjs");
var _confettiMajorSvgMjs = require("./icons/ConfettiMajor.svg.mjs");
var _connectMinorSvgMjs = require("./icons/ConnectMinor.svg.mjs");
var _contentMinorSvgMjs = require("./icons/ContentMinor.svg.mjs");
var _conversationMinorSvgMjs = require("./icons/ConversationMinor.svg.mjs");
var _creditCardCancelMajorSvgMjs = require("./icons/CreditCardCancelMajor.svg.mjs");
var _creditCardMajorSvgMjs = require("./icons/CreditCardMajor.svg.mjs");
var _creditCardPercentMajorSvgMjs = require("./icons/CreditCardPercentMajor.svg.mjs");
var _creditCardSecureMajorSvgMjs = require("./icons/CreditCardSecureMajor.svg.mjs");
var _currencyConvertMinorSvgMjs = require("./icons/CurrencyConvertMinor.svg.mjs");
var _customerMinusMajorSvgMjs = require("./icons/CustomerMinusMajor.svg.mjs");
var _customerPlusMajorSvgMjs = require("./icons/CustomerPlusMajor.svg.mjs");
var _customersMajorSvgMjs = require("./icons/CustomersMajor.svg.mjs");
var _customersMinorSvgMjs = require("./icons/CustomersMinor.svg.mjs");
var _dataDrivenModelMinorSvgMjs = require("./icons/DataDrivenModelMinor.svg.mjs");
var _dataVisualizationMajorSvgMjs = require("./icons/DataVisualizationMajor.svg.mjs");
var _decimalMinorSvgMjs = require("./icons/DecimalMinor.svg.mjs");
var _deleteMajorSvgMjs = require("./icons/DeleteMajor.svg.mjs");
var _deleteMinorSvgMjs = require("./icons/DeleteMinor.svg.mjs");
var _desktopMajorSvgMjs = require("./icons/DesktopMajor.svg.mjs");
var _detailedPopUpMajorSvgMjs = require("./icons/DetailedPopUpMajor.svg.mjs");
var _diamondAlertMajorSvgMjs = require("./icons/DiamondAlertMajor.svg.mjs");
var _diamondAlertMinorSvgMjs = require("./icons/DiamondAlertMinor.svg.mjs");
var _digitalMediaReceiverMajorSvgMjs = require("./icons/DigitalMediaReceiverMajor.svg.mjs");
var _discountAutomaticMajorSvgMjs = require("./icons/DiscountAutomaticMajor.svg.mjs");
var _discountCodeMajorSvgMjs = require("./icons/DiscountCodeMajor.svg.mjs");
var _discountsMajorSvgMjs = require("./icons/DiscountsMajor.svg.mjs");
var _discountsMinorSvgMjs = require("./icons/DiscountsMinor.svg.mjs");
var _disputeMinorSvgMjs = require("./icons/DisputeMinor.svg.mjs");
var _dnsSettingsMajorSvgMjs = require("./icons/DnsSettingsMajor.svg.mjs");
var _dockFloatingMajorSvgMjs = require("./icons/DockFloatingMajor.svg.mjs");
var _dockSideMajorSvgMjs = require("./icons/DockSideMajor.svg.mjs");
var _domainNewMajorSvgMjs = require("./icons/DomainNewMajor.svg.mjs");
var _domainRedirectMinorSvgMjs = require("./icons/DomainRedirectMinor.svg.mjs");
var _domainsMajorSvgMjs = require("./icons/DomainsMajor.svg.mjs");
var _draftOrdersMajorSvgMjs = require("./icons/DraftOrdersMajor.svg.mjs");
var _dragDropMajorSvgMjs = require("./icons/DragDropMajor.svg.mjs");
var _dragHandleMinorSvgMjs = require("./icons/DragHandleMinor.svg.mjs");
var _dropdownMinorSvgMjs = require("./icons/DropdownMinor.svg.mjs");
var _duplicateMinorSvgMjs = require("./icons/DuplicateMinor.svg.mjs");
var _dynamicSourceMajorSvgMjs = require("./icons/DynamicSourceMajor.svg.mjs");
var _dynamicSourceMinorSvgMjs = require("./icons/DynamicSourceMinor.svg.mjs");
var _editMajorSvgMjs = require("./icons/EditMajor.svg.mjs");
var _editMinorSvgMjs = require("./icons/EditMinor.svg.mjs");
var _emailMajorSvgMjs = require("./icons/EmailMajor.svg.mjs");
var _emailNewsletterMajorSvgMjs = require("./icons/EmailNewsletterMajor.svg.mjs");
var _embedMinorSvgMjs = require("./icons/EmbedMinor.svg.mjs");
var _enableSelectionMinorSvgMjs = require("./icons/EnableSelectionMinor.svg.mjs");
var _enterMajorSvgMjs = require("./icons/EnterMajor.svg.mjs");
var _envelopeMajorSvgMjs = require("./icons/EnvelopeMajor.svg.mjs");
var _exchangeMajorSvgMjs = require("./icons/ExchangeMajor.svg.mjs");
var _existingInventoryMajorSvgMjs = require("./icons/ExistingInventoryMajor.svg.mjs");
var _exitMajorSvgMjs = require("./icons/ExitMajor.svg.mjs");
var _exploreImagesMajorSvgMjs = require("./icons/ExploreImagesMajor.svg.mjs");
var _exportMinorSvgMjs = require("./icons/ExportMinor.svg.mjs");
var _extendMajorSvgMjs = require("./icons/ExtendMajor.svg.mjs");
var _extendMinorSvgMjs = require("./icons/ExtendMinor.svg.mjs");
var _externalMinorSvgMjs = require("./icons/ExternalMinor.svg.mjs");
var _externalSmallMinorSvgMjs = require("./icons/ExternalSmallMinor.svg.mjs");
var _eyeDropperMinorSvgMjs = require("./icons/EyeDropperMinor.svg.mjs");
var _faviconMajorSvgMjs = require("./icons/FaviconMajor.svg.mjs");
var _favoriteMajorSvgMjs = require("./icons/FavoriteMajor.svg.mjs");
var _featuredCollectionMajorSvgMjs = require("./icons/FeaturedCollectionMajor.svg.mjs");
var _featuredContentMajorSvgMjs = require("./icons/FeaturedContentMajor.svg.mjs");
var _fileMinorSvgMjs = require("./icons/FileMinor.svg.mjs");
var _filterMajorSvgMjs = require("./icons/FilterMajor.svg.mjs");
var _filterMinorSvgMjs = require("./icons/FilterMinor.svg.mjs");
var _financesMajorSvgMjs = require("./icons/FinancesMajor.svg.mjs");
var _financesMinorSvgMjs = require("./icons/FinancesMinor.svg.mjs");
var _firstClickModelMinorSvgMjs = require("./icons/FirstClickModelMinor.svg.mjs");
var _firstOrderMajorSvgMjs = require("./icons/FirstOrderMajor.svg.mjs");
var _firstVisitMajorSvgMjs = require("./icons/FirstVisitMajor.svg.mjs");
var _flagMajorSvgMjs = require("./icons/FlagMajor.svg.mjs");
var _flipCameraMajorSvgMjs = require("./icons/FlipCameraMajor.svg.mjs");
var _folderDownMajorSvgMjs = require("./icons/FolderDownMajor.svg.mjs");
var _folderMajorSvgMjs = require("./icons/FolderMajor.svg.mjs");
var _folderMinusMajorSvgMjs = require("./icons/FolderMinusMajor.svg.mjs");
var _folderPlusMajorSvgMjs = require("./icons/FolderPlusMajor.svg.mjs");
var _folderUpMajorSvgMjs = require("./icons/FolderUpMajor.svg.mjs");
var _followUpEmailMajorSvgMjs = require("./icons/FollowUpEmailMajor.svg.mjs");
var _foodMajorSvgMjs = require("./icons/FoodMajor.svg.mjs");
var _footerMajorSvgMjs = require("./icons/FooterMajor.svg.mjs");
var _formsMajorSvgMjs = require("./icons/FormsMajor.svg.mjs");
var _fraudProtectMajorSvgMjs = require("./icons/FraudProtectMajor.svg.mjs");
var _fraudProtectMinorSvgMjs = require("./icons/FraudProtectMinor.svg.mjs");
var _fraudProtectPendingMajorSvgMjs = require("./icons/FraudProtectPendingMajor.svg.mjs");
var _fraudProtectPendingMinorSvgMjs = require("./icons/FraudProtectPendingMinor.svg.mjs");
var _fraudProtectUnprotectedMajorSvgMjs = require("./icons/FraudProtectUnprotectedMajor.svg.mjs");
var _fraudProtectUnprotectedMinorSvgMjs = require("./icons/FraudProtectUnprotectedMinor.svg.mjs");
var _fulfillmentFulfilledMajorSvgMjs = require("./icons/FulfillmentFulfilledMajor.svg.mjs");
var _fulfillmentOnHoldMajorSvgMjs = require("./icons/FulfillmentOnHoldMajor.svg.mjs");
var _gamesConsoleMajorSvgMjs = require("./icons/GamesConsoleMajor.svg.mjs");
var _giftCardMajorSvgMjs = require("./icons/GiftCardMajor.svg.mjs");
var _giftCardMinorSvgMjs = require("./icons/GiftCardMinor.svg.mjs");
var _globeMajorSvgMjs = require("./icons/GlobeMajor.svg.mjs");
var _globeMinorSvgMjs = require("./icons/GlobeMinor.svg.mjs");
var _grammarMajorSvgMjs = require("./icons/GrammarMajor.svg.mjs");
var _hashtagMajorSvgMjs = require("./icons/HashtagMajor.svg.mjs");
var _hashtagMinorSvgMjs = require("./icons/HashtagMinor.svg.mjs");
var _headerMajorSvgMjs = require("./icons/HeaderMajor.svg.mjs");
var _heartMajorSvgMjs = require("./icons/HeartMajor.svg.mjs");
var _hideKeyboardMajorSvgMjs = require("./icons/HideKeyboardMajor.svg.mjs");
var _hideMinorSvgMjs = require("./icons/HideMinor.svg.mjs");
var _hintMajorSvgMjs = require("./icons/HintMajor.svg.mjs");
var _homeMajorSvgMjs = require("./icons/HomeMajor.svg.mjs");
var _homeMinorSvgMjs = require("./icons/HomeMinor.svg.mjs");
var _horizontalDotsMinorSvgMjs = require("./icons/HorizontalDotsMinor.svg.mjs");
var _iconsMajorSvgMjs = require("./icons/IconsMajor.svg.mjs");
var _identityCardMajorSvgMjs = require("./icons/IdentityCardMajor.svg.mjs");
var _illustrationMajorSvgMjs = require("./icons/IllustrationMajor.svg.mjs");
var _imageAltMajorSvgMjs = require("./icons/ImageAltMajor.svg.mjs");
var _imageAltMinorSvgMjs = require("./icons/ImageAltMinor.svg.mjs");
var _imageMajorSvgMjs = require("./icons/ImageMajor.svg.mjs");
var _imageWithTextMajorSvgMjs = require("./icons/ImageWithTextMajor.svg.mjs");
var _imageWithTextOverlayMajorSvgMjs = require("./icons/ImageWithTextOverlayMajor.svg.mjs");
var _imagesMajorSvgMjs = require("./icons/ImagesMajor.svg.mjs");
var _importMinorSvgMjs = require("./icons/ImportMinor.svg.mjs");
var _importStoreMajorSvgMjs = require("./icons/ImportStoreMajor.svg.mjs");
var _inactiveLocationMajorSvgMjs = require("./icons/InactiveLocationMajor.svg.mjs");
var _inactiveLocationMinorSvgMjs = require("./icons/InactiveLocationMinor.svg.mjs");
var _incomingMajorSvgMjs = require("./icons/IncomingMajor.svg.mjs");
var _infoMinorSvgMjs = require("./icons/InfoMinor.svg.mjs");
var _insertDynamicSourceMajorSvgMjs = require("./icons/InsertDynamicSourceMajor.svg.mjs");
var _insertDynamicSourceMinorSvgMjs = require("./icons/InsertDynamicSourceMinor.svg.mjs");
var _installMinorSvgMjs = require("./icons/InstallMinor.svg.mjs");
var _inventoryMajorSvgMjs = require("./icons/InventoryMajor.svg.mjs");
var _inviteMinorSvgMjs = require("./icons/InviteMinor.svg.mjs");
var _iqMajorSvgMjs = require("./icons/IqMajor.svg.mjs");
var _jobsMajorSvgMjs = require("./icons/JobsMajor.svg.mjs");
var _keyMajorSvgMjs = require("./icons/KeyMajor.svg.mjs");
var _keyboardMajorSvgMjs = require("./icons/KeyboardMajor.svg.mjs");
var _keyboardMinorSvgMjs = require("./icons/KeyboardMinor.svg.mjs");
var _labelPrinterMajorSvgMjs = require("./icons/LabelPrinterMajor.svg.mjs");
var _landingPageMajorSvgMjs = require("./icons/LandingPageMajor.svg.mjs");
var _languageMinorSvgMjs = require("./icons/LanguageMinor.svg.mjs");
var _lastClickModelMinorSvgMjs = require("./icons/LastClickModelMinor.svg.mjs");
var _lastNonDirectClickModelMinorSvgMjs = require("./icons/LastNonDirectClickModelMinor.svg.mjs");
var _legalMajorSvgMjs = require("./icons/LegalMajor.svg.mjs");
var _linearModelMinorSvgMjs = require("./icons/LinearModelMinor.svg.mjs");
var _linkMinorSvgMjs = require("./icons/LinkMinor.svg.mjs");
var _listMajorSvgMjs = require("./icons/ListMajor.svg.mjs");
var _listMinorSvgMjs = require("./icons/ListMinor.svg.mjs");
var _liveViewMajorSvgMjs = require("./icons/LiveViewMajor.svg.mjs");
var _locationMajorSvgMjs = require("./icons/LocationMajor.svg.mjs");
var _locationsMinorSvgMjs = require("./icons/LocationsMinor.svg.mjs");
var _lockMajorSvgMjs = require("./icons/LockMajor.svg.mjs");
var _lockMinorSvgMjs = require("./icons/LockMinor.svg.mjs");
var _logOutMinorSvgMjs = require("./icons/LogOutMinor.svg.mjs");
var _logoBlockMajorSvgMjs = require("./icons/LogoBlockMajor.svg.mjs");
var _magicMajorSvgMjs = require("./icons/MagicMajor.svg.mjs");
var _magicMinorSvgMjs = require("./icons/MagicMinor.svg.mjs");
var _managedStoreMajorSvgMjs = require("./icons/ManagedStoreMajor.svg.mjs");
var _markFulfilledMinorSvgMjs = require("./icons/MarkFulfilledMinor.svg.mjs");
var _markPaidMinorSvgMjs = require("./icons/MarkPaidMinor.svg.mjs");
var _marketingMajorSvgMjs = require("./icons/MarketingMajor.svg.mjs");
var _marketingMinorSvgMjs = require("./icons/MarketingMinor.svg.mjs");
var _marketsMajorSvgMjs = require("./icons/MarketsMajor.svg.mjs");
var _maximizeMajorSvgMjs = require("./icons/MaximizeMajor.svg.mjs");
var _maximizeMinorSvgMjs = require("./icons/MaximizeMinor.svg.mjs");
var _measurementMinorSvgMjs = require("./icons/MeasurementMinor.svg.mjs");
var _mentionMajorSvgMjs = require("./icons/MentionMajor.svg.mjs");
var _mergeMinorSvgMjs = require("./icons/MergeMinor.svg.mjs");
var _metafieldsMajorSvgMjs = require("./icons/MetafieldsMajor.svg.mjs");
var _metafieldsMinorSvgMjs = require("./icons/MetafieldsMinor.svg.mjs");
var _metaobjectMinorSvgMjs = require("./icons/MetaobjectMinor.svg.mjs");
var _metaobjectReferenceMinorSvgMjs = require("./icons/MetaobjectReferenceMinor.svg.mjs");
var _microphoneMajorSvgMjs = require("./icons/MicrophoneMajor.svg.mjs");
var _minimizeMajorSvgMjs = require("./icons/MinimizeMajor.svg.mjs");
var _minimizeMinorSvgMjs = require("./icons/MinimizeMinor.svg.mjs");
var _minusMajorSvgMjs = require("./icons/MinusMajor.svg.mjs");
var _minusMinorSvgMjs = require("./icons/MinusMinor.svg.mjs");
var _mobileAcceptMajorSvgMjs = require("./icons/MobileAcceptMajor.svg.mjs");
var _mobileBackArrowMajorSvgMjs = require("./icons/MobileBackArrowMajor.svg.mjs");
var _mobileCancelMajorSvgMjs = require("./icons/MobileCancelMajor.svg.mjs");
var _mobileChevronMajorSvgMjs = require("./icons/MobileChevronMajor.svg.mjs");
var _mobileHamburgerMajorSvgMjs = require("./icons/MobileHamburgerMajor.svg.mjs");
var _mobileHorizontalDotsMajorSvgMjs = require("./icons/MobileHorizontalDotsMajor.svg.mjs");
var _mobileMajorSvgMjs = require("./icons/MobileMajor.svg.mjs");
var _mobilePlusMajorSvgMjs = require("./icons/MobilePlusMajor.svg.mjs");
var _mobileVerticalDotsMajorSvgMjs = require("./icons/MobileVerticalDotsMajor.svg.mjs");
var _monerisMajorSvgMjs = require("./icons/MonerisMajor.svg.mjs");
var _moneyMinorSvgMjs = require("./icons/MoneyMinor.svg.mjs");
var _natureMajorSvgMjs = require("./icons/NatureMajor.svg.mjs");
var _navigationMajorSvgMjs = require("./icons/NavigationMajor.svg.mjs");
var _noteMajorSvgMjs = require("./icons/NoteMajor.svg.mjs");
var _noteMinorSvgMjs = require("./icons/NoteMinor.svg.mjs");
var _notificationMajorSvgMjs = require("./icons/NotificationMajor.svg.mjs");
var _onlineStoreMajorSvgMjs = require("./icons/OnlineStoreMajor.svg.mjs");
var _onlineStoreMinorSvgMjs = require("./icons/OnlineStoreMinor.svg.mjs");
var _orderStatusMinorSvgMjs = require("./icons/OrderStatusMinor.svg.mjs");
var _ordersMajorSvgMjs = require("./icons/OrdersMajor.svg.mjs");
var _ordersMinorSvgMjs = require("./icons/OrdersMinor.svg.mjs");
var _organizationMajorSvgMjs = require("./icons/OrganizationMajor.svg.mjs");
var _outgoingMajorSvgMjs = require("./icons/OutgoingMajor.svg.mjs");
var _packageMajorSvgMjs = require("./icons/PackageMajor.svg.mjs");
var _pageDownMajorSvgMjs = require("./icons/PageDownMajor.svg.mjs");
var _pageMajorSvgMjs = require("./icons/PageMajor.svg.mjs");
var _pageMinusMajorSvgMjs = require("./icons/PageMinusMajor.svg.mjs");
var _pagePlusMajorSvgMjs = require("./icons/PagePlusMajor.svg.mjs");
var _pageReferenceMinorSvgMjs = require("./icons/PageReferenceMinor.svg.mjs");
var _pageUpMajorSvgMjs = require("./icons/PageUpMajor.svg.mjs");
var _paginationEndMinorSvgMjs = require("./icons/PaginationEndMinor.svg.mjs");
var _paginationStartMinorSvgMjs = require("./icons/PaginationStartMinor.svg.mjs");
var _paintBrushMajorSvgMjs = require("./icons/PaintBrushMajor.svg.mjs");
var _paperCheckMajorSvgMjs = require("./icons/PaperCheckMajor.svg.mjs");
var _paperCheckMinorSvgMjs = require("./icons/PaperCheckMinor.svg.mjs");
var _passkeyMajorSvgMjs = require("./icons/PasskeyMajor.svg.mjs");
var _passkeyMinorSvgMjs = require("./icons/PasskeyMinor.svg.mjs");
var _pauseCircleMajorSvgMjs = require("./icons/PauseCircleMajor.svg.mjs");
var _pauseMajorSvgMjs = require("./icons/PauseMajor.svg.mjs");
var _pauseMinorSvgMjs = require("./icons/PauseMinor.svg.mjs");
var _paymentsMajorSvgMjs = require("./icons/PaymentsMajor.svg.mjs");
var _personalizedTextMajorSvgMjs = require("./icons/PersonalizedTextMajor.svg.mjs");
var _phoneInMajorSvgMjs = require("./icons/PhoneInMajor.svg.mjs");
var _phoneMajorSvgMjs = require("./icons/PhoneMajor.svg.mjs");
var _phoneOutMajorSvgMjs = require("./icons/PhoneOutMajor.svg.mjs");
var _pinMajorSvgMjs = require("./icons/PinMajor.svg.mjs");
var _pinMinorSvgMjs = require("./icons/PinMinor.svg.mjs");
var _pinUnfilledMajorSvgMjs = require("./icons/PinUnfilledMajor.svg.mjs");
var _pinUnfilledMinorSvgMjs = require("./icons/PinUnfilledMinor.svg.mjs");
var _planMajorSvgMjs = require("./icons/PlanMajor.svg.mjs");
var _planMinorSvgMjs = require("./icons/PlanMinor.svg.mjs");
var _playCircleMajorSvgMjs = require("./icons/PlayCircleMajor.svg.mjs");
var _playMajorSvgMjs = require("./icons/PlayMajor.svg.mjs");
var _playMinorSvgMjs = require("./icons/PlayMinor.svg.mjs");
var _plusMinorSvgMjs = require("./icons/PlusMinor.svg.mjs");
var _pointOfSaleMajorSvgMjs = require("./icons/PointOfSaleMajor.svg.mjs");
var _popularMajorSvgMjs = require("./icons/PopularMajor.svg.mjs");
var _positionBasedModelMinorSvgMjs = require("./icons/PositionBasedModelMinor.svg.mjs");
var _priceLookupMinorSvgMjs = require("./icons/PriceLookupMinor.svg.mjs");
var _printMajorSvgMjs = require("./icons/PrintMajor.svg.mjs");
var _printMinorSvgMjs = require("./icons/PrintMinor.svg.mjs");
var _productCostMajorSvgMjs = require("./icons/ProductCostMajor.svg.mjs");
var _productReferenceMinorSvgMjs = require("./icons/ProductReferenceMinor.svg.mjs");
var _productReturnsMinorSvgMjs = require("./icons/ProductReturnsMinor.svg.mjs");
var _productsMajorSvgMjs = require("./icons/ProductsMajor.svg.mjs");
var _productsMinorSvgMjs = require("./icons/ProductsMinor.svg.mjs");
var _profileMajorSvgMjs = require("./icons/ProfileMajor.svg.mjs");
var _profileMinorSvgMjs = require("./icons/ProfileMinor.svg.mjs");
var _promoteMinorSvgMjs = require("./icons/PromoteMinor.svg.mjs");
var _questionMarkInverseMajorSvgMjs = require("./icons/QuestionMarkInverseMajor.svg.mjs");
var _questionMarkInverseMinorSvgMjs = require("./icons/QuestionMarkInverseMinor.svg.mjs");
var _questionMarkMajorSvgMjs = require("./icons/QuestionMarkMajor.svg.mjs");
var _questionMarkMinorSvgMjs = require("./icons/QuestionMarkMinor.svg.mjs");
var _quickSaleMajorSvgMjs = require("./icons/QuickSaleMajor.svg.mjs");
var _readTimeMinorSvgMjs = require("./icons/ReadTimeMinor.svg.mjs");
var _receiptMajorSvgMjs = require("./icons/ReceiptMajor.svg.mjs");
var _recentSearchesMajorSvgMjs = require("./icons/RecentSearchesMajor.svg.mjs");
var _redoMajorSvgMjs = require("./icons/RedoMajor.svg.mjs");
var _referralCodeMajorSvgMjs = require("./icons/ReferralCodeMajor.svg.mjs");
var _referralMajorSvgMjs = require("./icons/ReferralMajor.svg.mjs");
var _refreshMajorSvgMjs = require("./icons/RefreshMajor.svg.mjs");
var _refreshMinorSvgMjs = require("./icons/RefreshMinor.svg.mjs");
var _refundMajorSvgMjs = require("./icons/RefundMajor.svg.mjs");
var _refundMinorSvgMjs = require("./icons/RefundMinor.svg.mjs");
var _removeProductMajorSvgMjs = require("./icons/RemoveProductMajor.svg.mjs");
var _repeatOrderMajorSvgMjs = require("./icons/RepeatOrderMajor.svg.mjs");
var _replaceMajorSvgMjs = require("./icons/ReplaceMajor.svg.mjs");
var _replayMinorSvgMjs = require("./icons/ReplayMinor.svg.mjs");
var _reportMinorSvgMjs = require("./icons/ReportMinor.svg.mjs");
var _reportsMajorSvgMjs = require("./icons/ReportsMajor.svg.mjs");
var _resetMinorSvgMjs = require("./icons/ResetMinor.svg.mjs");
var _resourcesMajorSvgMjs = require("./icons/ResourcesMajor.svg.mjs");
var _returnMinorSvgMjs = require("./icons/ReturnMinor.svg.mjs");
var _returnsMajorSvgMjs = require("./icons/ReturnsMajor.svg.mjs");
var _richTextMinorSvgMjs = require("./icons/RichTextMinor.svg.mjs");
var _riskMajorSvgMjs = require("./icons/RiskMajor.svg.mjs");
var _riskMinorSvgMjs = require("./icons/RiskMinor.svg.mjs");
var _rows2MajorSvgMjs = require("./icons/Rows2Major.svg.mjs");
var _sandboxMajorSvgMjs = require("./icons/SandboxMajor.svg.mjs");
var _saveMinorSvgMjs = require("./icons/SaveMinor.svg.mjs");
var _searchMajorSvgMjs = require("./icons/SearchMajor.svg.mjs");
var _searchMinorSvgMjs = require("./icons/SearchMinor.svg.mjs");
var _sectionMajorSvgMjs = require("./icons/SectionMajor.svg.mjs");
var _secureMajorSvgMjs = require("./icons/SecureMajor.svg.mjs");
var _selectMinorSvgMjs = require("./icons/SelectMinor.svg.mjs");
var _sendMajorSvgMjs = require("./icons/SendMajor.svg.mjs");
var _settingsMajorSvgMjs = require("./icons/SettingsMajor.svg.mjs");
var _settingsMinorSvgMjs = require("./icons/SettingsMinor.svg.mjs");
var _shareIosMinorSvgMjs = require("./icons/ShareIosMinor.svg.mjs");
var _shareMinorSvgMjs = require("./icons/ShareMinor.svg.mjs");
var _shipmentMajorSvgMjs = require("./icons/ShipmentMajor.svg.mjs");
var _shopcodesMajorSvgMjs = require("./icons/ShopcodesMajor.svg.mjs");
var _sidebarLeftMajorSvgMjs = require("./icons/SidebarLeftMajor.svg.mjs");
var _sidebarRightMajorSvgMjs = require("./icons/SidebarRightMajor.svg.mjs");
var _simplifyMajorSvgMjs = require("./icons/SimplifyMajor.svg.mjs");
var _simplifyMinorSvgMjs = require("./icons/SimplifyMinor.svg.mjs");
var _slideshowMajorSvgMjs = require("./icons/SlideshowMajor.svg.mjs");
var _smileyHappyMajorSvgMjs = require("./icons/SmileyHappyMajor.svg.mjs");
var _smileyJoyMajorSvgMjs = require("./icons/SmileyJoyMajor.svg.mjs");
var _smileyNeutralMajorSvgMjs = require("./icons/SmileyNeutralMajor.svg.mjs");
var _smileySadMajorSvgMjs = require("./icons/SmileySadMajor.svg.mjs");
var _socialAdMajorSvgMjs = require("./icons/SocialAdMajor.svg.mjs");
var _socialPostMajorSvgMjs = require("./icons/SocialPostMajor.svg.mjs");
var _softPackMajorSvgMjs = require("./icons/SoftPackMajor.svg.mjs");
var _sortAscendingMajorSvgMjs = require("./icons/SortAscendingMajor.svg.mjs");
var _sortDescendingMajorSvgMjs = require("./icons/SortDescendingMajor.svg.mjs");
var _sortMinorSvgMjs = require("./icons/SortMinor.svg.mjs");
var _soundMajorSvgMjs = require("./icons/SoundMajor.svg.mjs");
var _starFilledMinorSvgMjs = require("./icons/StarFilledMinor.svg.mjs");
var _starOutlineMinorSvgMjs = require("./icons/StarOutlineMinor.svg.mjs");
var _statusActiveMajorSvgMjs = require("./icons/StatusActiveMajor.svg.mjs");
var _storeMajorSvgMjs = require("./icons/StoreMajor.svg.mjs");
var _storeMinorSvgMjs = require("./icons/StoreMinor.svg.mjs");
var _storeStatusMajorSvgMjs = require("./icons/StoreStatusMajor.svg.mjs");
var _tabletMajorSvgMjs = require("./icons/TabletMajor.svg.mjs");
var _tapChipMajorSvgMjs = require("./icons/TapChipMajor.svg.mjs");
var _taxMajorSvgMjs = require("./icons/TaxMajor.svg.mjs");
var _teamMajorSvgMjs = require("./icons/TeamMajor.svg.mjs");
var _templateMajorSvgMjs = require("./icons/TemplateMajor.svg.mjs");
var _templateMinorSvgMjs = require("./icons/TemplateMinor.svg.mjs");
var _textAlignmentCenterMajorSvgMjs = require("./icons/TextAlignmentCenterMajor.svg.mjs");
var _textAlignmentLeftMajorSvgMjs = require("./icons/TextAlignmentLeftMajor.svg.mjs");
var _textAlignmentRightMajorSvgMjs = require("./icons/TextAlignmentRightMajor.svg.mjs");
var _textBlockMajorSvgMjs = require("./icons/TextBlockMajor.svg.mjs");
var _textMajorSvgMjs = require("./icons/TextMajor.svg.mjs");
var _themeEditMajorSvgMjs = require("./icons/ThemeEditMajor.svg.mjs");
var _themeStoreMajorSvgMjs = require("./icons/ThemeStoreMajor.svg.mjs");
var _themesMajorSvgMjs = require("./icons/ThemesMajor.svg.mjs");
var _thumbsDownMajorSvgMjs = require("./icons/ThumbsDownMajor.svg.mjs");
var _thumbsDownMinorSvgMjs = require("./icons/ThumbsDownMinor.svg.mjs");
var _thumbsUpMajorSvgMjs = require("./icons/ThumbsUpMajor.svg.mjs");
var _thumbsUpMinorSvgMjs = require("./icons/ThumbsUpMinor.svg.mjs");
var _tickMinorSvgMjs = require("./icons/TickMinor.svg.mjs");
var _tickSmallMinorSvgMjs = require("./icons/TickSmallMinor.svg.mjs");
var _timeDecayModelMinorSvgMjs = require("./icons/TimeDecayModelMinor.svg.mjs");
var _timelineAttachmentMajorSvgMjs = require("./icons/TimelineAttachmentMajor.svg.mjs");
var _tipsMajorSvgMjs = require("./icons/TipsMajor.svg.mjs");
var _titleMinorSvgMjs = require("./icons/TitleMinor.svg.mjs");
var _toggleMinorSvgMjs = require("./icons/ToggleMinor.svg.mjs");
var _toolsMajorSvgMjs = require("./icons/ToolsMajor.svg.mjs");
var _transactionFeeDollarMajorSvgMjs = require("./icons/TransactionFeeDollarMajor.svg.mjs");
var _transactionFeeEuroMajorSvgMjs = require("./icons/TransactionFeeEuroMajor.svg.mjs");
var _transactionFeePoundMajorSvgMjs = require("./icons/TransactionFeePoundMajor.svg.mjs");
var _transactionFeeRupeeMajorSvgMjs = require("./icons/TransactionFeeRupeeMajor.svg.mjs");
var _transactionFeeYenMajorSvgMjs = require("./icons/TransactionFeeYenMajor.svg.mjs");
var _transactionMajorSvgMjs = require("./icons/TransactionMajor.svg.mjs");
var _transferInMajorSvgMjs = require("./icons/TransferInMajor.svg.mjs");
var _transferMajorSvgMjs = require("./icons/TransferMajor.svg.mjs");
var _transferOutMajorSvgMjs = require("./icons/TransferOutMajor.svg.mjs");
var _transferWithinShopifyMajorSvgMjs = require("./icons/TransferWithinShopifyMajor.svg.mjs");
var _transportMajorSvgMjs = require("./icons/TransportMajor.svg.mjs");
var _troubleshootMajorSvgMjs = require("./icons/TroubleshootMajor.svg.mjs");
var _typeMajorSvgMjs = require("./icons/TypeMajor.svg.mjs");
var _typeMinorSvgMjs = require("./icons/TypeMinor.svg.mjs");
var _undoMajorSvgMjs = require("./icons/UndoMajor.svg.mjs");
var _unfulfilledMajorSvgMjs = require("./icons/UnfulfilledMajor.svg.mjs");
var _unknownDeviceMajorSvgMjs = require("./icons/UnknownDeviceMajor.svg.mjs");
var _updateInventoryMajorSvgMjs = require("./icons/UpdateInventoryMajor.svg.mjs");
var _uploadMajorSvgMjs = require("./icons/UploadMajor.svg.mjs");
var _variantMajorSvgMjs = require("./icons/VariantMajor.svg.mjs");
var _viewMajorSvgMjs = require("./icons/ViewMajor.svg.mjs");
var _viewMinorSvgMjs = require("./icons/ViewMinor.svg.mjs");
var _viewportNarrowMajorSvgMjs = require("./icons/ViewportNarrowMajor.svg.mjs");
var _viewportShortMajorSvgMjs = require("./icons/ViewportShortMajor.svg.mjs");
var _viewportTallMajorSvgMjs = require("./icons/ViewportTallMajor.svg.mjs");
var _viewportWideMajorSvgMjs = require("./icons/ViewportWideMajor.svg.mjs");
var _vocabularyMajorSvgMjs = require("./icons/VocabularyMajor.svg.mjs");
var _volumeMinorSvgMjs = require("./icons/VolumeMinor.svg.mjs");
var _wandMajorSvgMjs = require("./icons/WandMajor.svg.mjs");
var _wandMinorSvgMjs = require("./icons/WandMinor.svg.mjs");
var _wearableMajorSvgMjs = require("./icons/WearableMajor.svg.mjs");
var _weightMinorSvgMjs = require("./icons/WeightMinor.svg.mjs");
var _wholesaleMajorSvgMjs = require("./icons/WholesaleMajor.svg.mjs");
var _wifiMajorSvgMjs = require("./icons/WifiMajor.svg.mjs");
var _react = require("react");

},{"./icons/AbandonedCartMajor.svg.mjs":false,"./icons/AccessibilityMajor.svg.mjs":false,"./icons/ActivitiesMajor.svg.mjs":false,"./icons/AddCodeMajor.svg.mjs":false,"./icons/AddImageMajor.svg.mjs":false,"./icons/AddMajor.svg.mjs":false,"./icons/AddNoteMajor.svg.mjs":false,"./icons/AddProductMajor.svg.mjs":false,"./icons/AdjustMinor.svg.mjs":false,"./icons/AffiliateMajor.svg.mjs":false,"./icons/AlertMinor.svg.mjs":false,"./icons/AnalyticsBarHorizontalMinor.svg.mjs":false,"./icons/AnalyticsBarStackedMinor.svg.mjs":false,"./icons/AnalyticsCohortMinor.svg.mjs":false,"./icons/AnalyticsDonutMinor.svg.mjs":false,"./icons/AnalyticsFunnelMinor.svg.mjs":false,"./icons/AnalyticsLineMinor.svg.mjs":false,"./icons/AnalyticsMajor.svg.mjs":false,"./icons/AnalyticsMinor.svg.mjs":false,"./icons/AnalyticsTableMinor.svg.mjs":false,"./icons/AnyClickModelMinor.svg.mjs":false,"./icons/AppExtensionMinor.svg.mjs":false,"./icons/AppsMajor.svg.mjs":false,"./icons/AppsMinor.svg.mjs":false,"./icons/ArchiveMajor.svg.mjs":false,"./icons/ArchiveMinor.svg.mjs":false,"./icons/ArrowDownMinor.svg.mjs":false,"./icons/ArrowLeftMinor.svg.mjs":"3IFjm","./icons/ArrowRightMinor.svg.mjs":false,"./icons/ArrowUpMinor.svg.mjs":false,"./icons/AttachmentMajor.svg.mjs":false,"./icons/AutomationMajor.svg.mjs":false,"./icons/BackspaceMajor.svg.mjs":false,"./icons/BalanceMajor.svg.mjs":false,"./icons/BankMajor.svg.mjs":false,"./icons/BarcodeMajor.svg.mjs":false,"./icons/BehaviorMajor.svg.mjs":false,"./icons/BehaviorMinor.svg.mjs":false,"./icons/BillingStatementDollarMajor.svg.mjs":false,"./icons/BillingStatementEuroMajor.svg.mjs":false,"./icons/BillingStatementPoundMajor.svg.mjs":false,"./icons/BillingStatementRupeeMajor.svg.mjs":false,"./icons/BillingStatementYenMajor.svg.mjs":false,"./icons/BlockMinor.svg.mjs":false,"./icons/BlockquoteMajor.svg.mjs":false,"./icons/BlogMajor.svg.mjs":false,"./icons/BugMajor.svg.mjs":false,"./icons/ButtonCornerPillMajor.svg.mjs":false,"./icons/ButtonCornerRoundedMajor.svg.mjs":false,"./icons/ButtonCornerSquareMajor.svg.mjs":false,"./icons/ButtonMinor.svg.mjs":false,"./icons/BuyButtonButtonLayoutMajor.svg.mjs":false,"./icons/BuyButtonHorizontalLayoutMajor.svg.mjs":false,"./icons/BuyButtonMajor.svg.mjs":false,"./icons/BuyButtonVerticalLayoutMajor.svg.mjs":false,"./icons/CalendarMajor.svg.mjs":false,"./icons/CalendarMinor.svg.mjs":false,"./icons/CalendarTickMajor.svg.mjs":false,"./icons/CalendarTimeMinor.svg.mjs":false,"./icons/CameraMajor.svg.mjs":false,"./icons/CancelMajor.svg.mjs":false,"./icons/CancelMinor.svg.mjs":"5HNSI","./icons/CancelSmallMinor.svg.mjs":"8ldPz","./icons/CapitalMajor.svg.mjs":false,"./icons/CapturePaymentMinor.svg.mjs":false,"./icons/CardReaderChipMajor.svg.mjs":false,"./icons/CardReaderMajor.svg.mjs":false,"./icons/CardReaderTapMajor.svg.mjs":false,"./icons/CaretDownMinor.svg.mjs":"jCawW","./icons/CaretUpMinor.svg.mjs":"4vNg0","./icons/CartDownMajor.svg.mjs":false,"./icons/CartMajor.svg.mjs":false,"./icons/CartUpMajor.svg.mjs":false,"./icons/CashDollarMajor.svg.mjs":false,"./icons/CashDollarMinor.svg.mjs":false,"./icons/CashEuroMajor.svg.mjs":false,"./icons/CashPoundMajor.svg.mjs":false,"./icons/CashRupeeMajor.svg.mjs":false,"./icons/CashYenMajor.svg.mjs":false,"./icons/CategoriesMajor.svg.mjs":false,"./icons/ChannelsMajor.svg.mjs":false,"./icons/ChatMajor.svg.mjs":false,"./icons/ChecklistAlternateMajor.svg.mjs":false,"./icons/ChecklistMajor.svg.mjs":false,"./icons/CheckoutMajor.svg.mjs":false,"./icons/ChevronDownMinor.svg.mjs":"9mErA","./icons/ChevronLeftMinor.svg.mjs":"5b53p","./icons/ChevronRightMinor.svg.mjs":"l8LOR","./icons/ChevronUpMinor.svg.mjs":"6Co36","./icons/CircleAlertMajor.svg.mjs":"e2Guh","./icons/CircleCancelMajor.svg.mjs":false,"./icons/CircleCancelMinor.svg.mjs":"alh6z","./icons/CircleChevronDownMinor.svg.mjs":false,"./icons/CircleChevronLeftMinor.svg.mjs":false,"./icons/CircleChevronRightMinor.svg.mjs":false,"./icons/CircleChevronUpMinor.svg.mjs":false,"./icons/CircleDisableMinor.svg.mjs":false,"./icons/CircleDisabledMajor.svg.mjs":false,"./icons/CircleDotsMajor.svg.mjs":false,"./icons/CircleDownMajor.svg.mjs":false,"./icons/CircleInformationMajor.svg.mjs":"kprfa","./icons/CircleLeftMajor.svg.mjs":false,"./icons/CircleMinusMajor.svg.mjs":false,"./icons/CircleMinusMinor.svg.mjs":false,"./icons/CircleMinusOutlineMinor.svg.mjs":false,"./icons/CirclePlusMajor.svg.mjs":false,"./icons/CirclePlusMinor.svg.mjs":false,"./icons/CirclePlusOutlineMinor.svg.mjs":false,"./icons/CircleRightMajor.svg.mjs":false,"./icons/CircleTickMajor.svg.mjs":"eneQq","./icons/CircleTickMinor.svg.mjs":false,"./icons/CircleTickOutlineMinor.svg.mjs":"9X9VA","./icons/CircleUpMajor.svg.mjs":false,"./icons/ClipboardMinor.svg.mjs":false,"./icons/ClockMajor.svg.mjs":false,"./icons/ClockMinor.svg.mjs":false,"./icons/CodeMajor.svg.mjs":false,"./icons/CodeMinor.svg.mjs":false,"./icons/CollectionReferenceMinor.svg.mjs":false,"./icons/CollectionsMajor.svg.mjs":false,"./icons/ColorNoneMinor.svg.mjs":false,"./icons/ColorsMajor.svg.mjs":false,"./icons/Column1Major.svg.mjs":false,"./icons/ColumnWithTextMajor.svg.mjs":false,"./icons/Columns2Major.svg.mjs":false,"./icons/Columns3Major.svg.mjs":false,"./icons/Columns3Minor.svg.mjs":false,"./icons/ComposeMajor.svg.mjs":false,"./icons/ConfettiMajor.svg.mjs":false,"./icons/ConnectMinor.svg.mjs":false,"./icons/ContentMinor.svg.mjs":false,"./icons/ConversationMinor.svg.mjs":false,"./icons/CreditCardCancelMajor.svg.mjs":false,"./icons/CreditCardMajor.svg.mjs":false,"./icons/CreditCardPercentMajor.svg.mjs":false,"./icons/CreditCardSecureMajor.svg.mjs":false,"./icons/CurrencyConvertMinor.svg.mjs":false,"./icons/CustomerMinusMajor.svg.mjs":false,"./icons/CustomerPlusMajor.svg.mjs":false,"./icons/CustomersMajor.svg.mjs":false,"./icons/CustomersMinor.svg.mjs":false,"./icons/DataDrivenModelMinor.svg.mjs":false,"./icons/DataVisualizationMajor.svg.mjs":false,"./icons/DecimalMinor.svg.mjs":false,"./icons/DeleteMajor.svg.mjs":false,"./icons/DeleteMinor.svg.mjs":false,"./icons/DesktopMajor.svg.mjs":false,"./icons/DetailedPopUpMajor.svg.mjs":false,"./icons/DiamondAlertMajor.svg.mjs":"ha33g","./icons/DiamondAlertMinor.svg.mjs":"8URCb","./icons/DigitalMediaReceiverMajor.svg.mjs":false,"./icons/DiscountAutomaticMajor.svg.mjs":false,"./icons/DiscountCodeMajor.svg.mjs":false,"./icons/DiscountsMajor.svg.mjs":false,"./icons/DiscountsMinor.svg.mjs":false,"./icons/DisputeMinor.svg.mjs":false,"./icons/DnsSettingsMajor.svg.mjs":false,"./icons/DockFloatingMajor.svg.mjs":false,"./icons/DockSideMajor.svg.mjs":false,"./icons/DomainNewMajor.svg.mjs":false,"./icons/DomainRedirectMinor.svg.mjs":false,"./icons/DomainsMajor.svg.mjs":false,"./icons/DraftOrdersMajor.svg.mjs":false,"./icons/DragDropMajor.svg.mjs":false,"./icons/DragHandleMinor.svg.mjs":false,"./icons/DropdownMinor.svg.mjs":false,"./icons/DuplicateMinor.svg.mjs":false,"./icons/DynamicSourceMajor.svg.mjs":false,"./icons/DynamicSourceMinor.svg.mjs":false,"./icons/EditMajor.svg.mjs":false,"./icons/EditMinor.svg.mjs":false,"./icons/EmailMajor.svg.mjs":false,"./icons/EmailNewsletterMajor.svg.mjs":false,"./icons/EmbedMinor.svg.mjs":false,"./icons/EnableSelectionMinor.svg.mjs":"aXogV","./icons/EnterMajor.svg.mjs":false,"./icons/EnvelopeMajor.svg.mjs":false,"./icons/ExchangeMajor.svg.mjs":false,"./icons/ExistingInventoryMajor.svg.mjs":false,"./icons/ExitMajor.svg.mjs":false,"./icons/ExploreImagesMajor.svg.mjs":false,"./icons/ExportMinor.svg.mjs":false,"./icons/ExtendMajor.svg.mjs":false,"./icons/ExtendMinor.svg.mjs":false,"./icons/ExternalMinor.svg.mjs":false,"./icons/ExternalSmallMinor.svg.mjs":false,"./icons/EyeDropperMinor.svg.mjs":false,"./icons/FaviconMajor.svg.mjs":false,"./icons/FavoriteMajor.svg.mjs":false,"./icons/FeaturedCollectionMajor.svg.mjs":false,"./icons/FeaturedContentMajor.svg.mjs":false,"./icons/FileMinor.svg.mjs":false,"./icons/FilterMajor.svg.mjs":false,"./icons/FilterMinor.svg.mjs":false,"./icons/FinancesMajor.svg.mjs":false,"./icons/FinancesMinor.svg.mjs":false,"./icons/FirstClickModelMinor.svg.mjs":false,"./icons/FirstOrderMajor.svg.mjs":false,"./icons/FirstVisitMajor.svg.mjs":false,"./icons/FlagMajor.svg.mjs":false,"./icons/FlipCameraMajor.svg.mjs":false,"./icons/FolderDownMajor.svg.mjs":false,"./icons/FolderMajor.svg.mjs":false,"./icons/FolderMinusMajor.svg.mjs":false,"./icons/FolderPlusMajor.svg.mjs":false,"./icons/FolderUpMajor.svg.mjs":false,"./icons/FollowUpEmailMajor.svg.mjs":false,"./icons/FoodMajor.svg.mjs":false,"./icons/FooterMajor.svg.mjs":false,"./icons/FormsMajor.svg.mjs":false,"./icons/FraudProtectMajor.svg.mjs":false,"./icons/FraudProtectMinor.svg.mjs":false,"./icons/FraudProtectPendingMajor.svg.mjs":false,"./icons/FraudProtectPendingMinor.svg.mjs":false,"./icons/FraudProtectUnprotectedMajor.svg.mjs":false,"./icons/FraudProtectUnprotectedMinor.svg.mjs":false,"./icons/FulfillmentFulfilledMajor.svg.mjs":false,"./icons/FulfillmentOnHoldMajor.svg.mjs":false,"./icons/GamesConsoleMajor.svg.mjs":false,"./icons/GiftCardMajor.svg.mjs":false,"./icons/GiftCardMinor.svg.mjs":false,"./icons/GlobeMajor.svg.mjs":false,"./icons/GlobeMinor.svg.mjs":false,"./icons/GrammarMajor.svg.mjs":false,"./icons/HashtagMajor.svg.mjs":false,"./icons/HashtagMinor.svg.mjs":false,"./icons/HeaderMajor.svg.mjs":false,"./icons/HeartMajor.svg.mjs":false,"./icons/HideKeyboardMajor.svg.mjs":false,"./icons/HideMinor.svg.mjs":false,"./icons/HintMajor.svg.mjs":false,"./icons/HomeMajor.svg.mjs":false,"./icons/HomeMinor.svg.mjs":false,"./icons/HorizontalDotsMinor.svg.mjs":"dJM7P","./icons/IconsMajor.svg.mjs":false,"./icons/IdentityCardMajor.svg.mjs":false,"./icons/IllustrationMajor.svg.mjs":false,"./icons/ImageAltMajor.svg.mjs":false,"./icons/ImageAltMinor.svg.mjs":false,"./icons/ImageMajor.svg.mjs":false,"./icons/ImageWithTextMajor.svg.mjs":false,"./icons/ImageWithTextOverlayMajor.svg.mjs":false,"./icons/ImagesMajor.svg.mjs":false,"./icons/ImportMinor.svg.mjs":false,"./icons/ImportStoreMajor.svg.mjs":false,"./icons/InactiveLocationMajor.svg.mjs":false,"./icons/InactiveLocationMinor.svg.mjs":false,"./icons/IncomingMajor.svg.mjs":false,"./icons/InfoMinor.svg.mjs":false,"./icons/InsertDynamicSourceMajor.svg.mjs":false,"./icons/InsertDynamicSourceMinor.svg.mjs":false,"./icons/InstallMinor.svg.mjs":false,"./icons/InventoryMajor.svg.mjs":false,"./icons/InviteMinor.svg.mjs":false,"./icons/IqMajor.svg.mjs":false,"./icons/JobsMajor.svg.mjs":false,"./icons/KeyMajor.svg.mjs":false,"./icons/KeyboardMajor.svg.mjs":false,"./icons/KeyboardMinor.svg.mjs":false,"./icons/LabelPrinterMajor.svg.mjs":false,"./icons/LandingPageMajor.svg.mjs":false,"./icons/LanguageMinor.svg.mjs":false,"./icons/LastClickModelMinor.svg.mjs":false,"./icons/LastNonDirectClickModelMinor.svg.mjs":false,"./icons/LegalMajor.svg.mjs":false,"./icons/LinearModelMinor.svg.mjs":false,"./icons/LinkMinor.svg.mjs":false,"./icons/ListMajor.svg.mjs":false,"./icons/ListMinor.svg.mjs":false,"./icons/LiveViewMajor.svg.mjs":false,"./icons/LocationMajor.svg.mjs":false,"./icons/LocationsMinor.svg.mjs":false,"./icons/LockMajor.svg.mjs":false,"./icons/LockMinor.svg.mjs":false,"./icons/LogOutMinor.svg.mjs":false,"./icons/LogoBlockMajor.svg.mjs":false,"./icons/MagicMajor.svg.mjs":false,"./icons/MagicMinor.svg.mjs":false,"./icons/ManagedStoreMajor.svg.mjs":false,"./icons/MarkFulfilledMinor.svg.mjs":false,"./icons/MarkPaidMinor.svg.mjs":false,"./icons/MarketingMajor.svg.mjs":false,"./icons/MarketingMinor.svg.mjs":false,"./icons/MarketsMajor.svg.mjs":false,"./icons/MaximizeMajor.svg.mjs":false,"./icons/MaximizeMinor.svg.mjs":false,"./icons/MeasurementMinor.svg.mjs":false,"./icons/MentionMajor.svg.mjs":false,"./icons/MergeMinor.svg.mjs":false,"./icons/MetafieldsMajor.svg.mjs":false,"./icons/MetafieldsMinor.svg.mjs":false,"./icons/MetaobjectMinor.svg.mjs":false,"./icons/MetaobjectReferenceMinor.svg.mjs":false,"./icons/MicrophoneMajor.svg.mjs":false,"./icons/MinimizeMajor.svg.mjs":false,"./icons/MinimizeMinor.svg.mjs":false,"./icons/MinusMajor.svg.mjs":false,"./icons/MinusMinor.svg.mjs":"kSyOM","./icons/MobileAcceptMajor.svg.mjs":false,"./icons/MobileBackArrowMajor.svg.mjs":false,"./icons/MobileCancelMajor.svg.mjs":"ginwG","./icons/MobileChevronMajor.svg.mjs":false,"./icons/MobileHamburgerMajor.svg.mjs":"7ZvYa","./icons/MobileHorizontalDotsMajor.svg.mjs":false,"./icons/MobileMajor.svg.mjs":false,"./icons/MobilePlusMajor.svg.mjs":false,"./icons/MobileVerticalDotsMajor.svg.mjs":false,"./icons/MonerisMajor.svg.mjs":false,"./icons/MoneyMinor.svg.mjs":false,"./icons/NatureMajor.svg.mjs":false,"./icons/NavigationMajor.svg.mjs":false,"./icons/NoteMajor.svg.mjs":false,"./icons/NoteMinor.svg.mjs":false,"./icons/NotificationMajor.svg.mjs":false,"./icons/OnlineStoreMajor.svg.mjs":false,"./icons/OnlineStoreMinor.svg.mjs":false,"./icons/OrderStatusMinor.svg.mjs":false,"./icons/OrdersMajor.svg.mjs":false,"./icons/OrdersMinor.svg.mjs":false,"./icons/OrganizationMajor.svg.mjs":false,"./icons/OutgoingMajor.svg.mjs":false,"./icons/PackageMajor.svg.mjs":false,"./icons/PageDownMajor.svg.mjs":false,"./icons/PageMajor.svg.mjs":false,"./icons/PageMinusMajor.svg.mjs":false,"./icons/PagePlusMajor.svg.mjs":false,"./icons/PageReferenceMinor.svg.mjs":false,"./icons/PageUpMajor.svg.mjs":false,"./icons/PaginationEndMinor.svg.mjs":false,"./icons/PaginationStartMinor.svg.mjs":false,"./icons/PaintBrushMajor.svg.mjs":false,"./icons/PaperCheckMajor.svg.mjs":false,"./icons/PaperCheckMinor.svg.mjs":false,"./icons/PasskeyMajor.svg.mjs":false,"./icons/PasskeyMinor.svg.mjs":false,"./icons/PauseCircleMajor.svg.mjs":false,"./icons/PauseMajor.svg.mjs":false,"./icons/PauseMinor.svg.mjs":false,"./icons/PaymentsMajor.svg.mjs":false,"./icons/PersonalizedTextMajor.svg.mjs":false,"./icons/PhoneInMajor.svg.mjs":false,"./icons/PhoneMajor.svg.mjs":false,"./icons/PhoneOutMajor.svg.mjs":false,"./icons/PinMajor.svg.mjs":false,"./icons/PinMinor.svg.mjs":false,"./icons/PinUnfilledMajor.svg.mjs":false,"./icons/PinUnfilledMinor.svg.mjs":false,"./icons/PlanMajor.svg.mjs":false,"./icons/PlanMinor.svg.mjs":false,"./icons/PlayCircleMajor.svg.mjs":false,"./icons/PlayMajor.svg.mjs":false,"./icons/PlayMinor.svg.mjs":false,"./icons/PlusMinor.svg.mjs":"cXa0u","./icons/PointOfSaleMajor.svg.mjs":false,"./icons/PopularMajor.svg.mjs":false,"./icons/PositionBasedModelMinor.svg.mjs":false,"./icons/PriceLookupMinor.svg.mjs":false,"./icons/PrintMajor.svg.mjs":false,"./icons/PrintMinor.svg.mjs":false,"./icons/ProductCostMajor.svg.mjs":false,"./icons/ProductReferenceMinor.svg.mjs":false,"./icons/ProductReturnsMinor.svg.mjs":false,"./icons/ProductsMajor.svg.mjs":false,"./icons/ProductsMinor.svg.mjs":false,"./icons/ProfileMajor.svg.mjs":false,"./icons/ProfileMinor.svg.mjs":false,"./icons/PromoteMinor.svg.mjs":false,"./icons/QuestionMarkInverseMajor.svg.mjs":false,"./icons/QuestionMarkInverseMinor.svg.mjs":false,"./icons/QuestionMarkMajor.svg.mjs":false,"./icons/QuestionMarkMinor.svg.mjs":false,"./icons/QuickSaleMajor.svg.mjs":false,"./icons/ReadTimeMinor.svg.mjs":false,"./icons/ReceiptMajor.svg.mjs":false,"./icons/RecentSearchesMajor.svg.mjs":false,"./icons/RedoMajor.svg.mjs":false,"./icons/ReferralCodeMajor.svg.mjs":false,"./icons/ReferralMajor.svg.mjs":false,"./icons/RefreshMajor.svg.mjs":false,"./icons/RefreshMinor.svg.mjs":false,"./icons/RefundMajor.svg.mjs":false,"./icons/RefundMinor.svg.mjs":false,"./icons/RemoveProductMajor.svg.mjs":false,"./icons/RepeatOrderMajor.svg.mjs":false,"./icons/ReplaceMajor.svg.mjs":false,"./icons/ReplayMinor.svg.mjs":false,"./icons/ReportMinor.svg.mjs":false,"./icons/ReportsMajor.svg.mjs":false,"./icons/ResetMinor.svg.mjs":false,"./icons/ResourcesMajor.svg.mjs":false,"./icons/ReturnMinor.svg.mjs":false,"./icons/ReturnsMajor.svg.mjs":false,"./icons/RichTextMinor.svg.mjs":false,"./icons/RiskMajor.svg.mjs":false,"./icons/RiskMinor.svg.mjs":false,"./icons/Rows2Major.svg.mjs":false,"./icons/SandboxMajor.svg.mjs":false,"./icons/SaveMinor.svg.mjs":false,"./icons/SearchMajor.svg.mjs":false,"./icons/SearchMinor.svg.mjs":"5oHx3","./icons/SectionMajor.svg.mjs":false,"./icons/SecureMajor.svg.mjs":false,"./icons/SelectMinor.svg.mjs":"k7bR9","./icons/SendMajor.svg.mjs":false,"./icons/SettingsMajor.svg.mjs":false,"./icons/SettingsMinor.svg.mjs":false,"./icons/ShareIosMinor.svg.mjs":false,"./icons/ShareMinor.svg.mjs":false,"./icons/ShipmentMajor.svg.mjs":false,"./icons/ShopcodesMajor.svg.mjs":false,"./icons/SidebarLeftMajor.svg.mjs":false,"./icons/SidebarRightMajor.svg.mjs":false,"./icons/SimplifyMajor.svg.mjs":false,"./icons/SimplifyMinor.svg.mjs":false,"./icons/SlideshowMajor.svg.mjs":false,"./icons/SmileyHappyMajor.svg.mjs":false,"./icons/SmileyJoyMajor.svg.mjs":false,"./icons/SmileyNeutralMajor.svg.mjs":false,"./icons/SmileySadMajor.svg.mjs":false,"./icons/SocialAdMajor.svg.mjs":false,"./icons/SocialPostMajor.svg.mjs":false,"./icons/SoftPackMajor.svg.mjs":false,"./icons/SortAscendingMajor.svg.mjs":"2dI1k","./icons/SortDescendingMajor.svg.mjs":"35v6r","./icons/SortMinor.svg.mjs":false,"./icons/SoundMajor.svg.mjs":false,"./icons/StarFilledMinor.svg.mjs":false,"./icons/StarOutlineMinor.svg.mjs":false,"./icons/StatusActiveMajor.svg.mjs":false,"./icons/StoreMajor.svg.mjs":false,"./icons/StoreMinor.svg.mjs":false,"./icons/StoreStatusMajor.svg.mjs":false,"./icons/TabletMajor.svg.mjs":false,"./icons/TapChipMajor.svg.mjs":false,"./icons/TaxMajor.svg.mjs":false,"./icons/TeamMajor.svg.mjs":false,"./icons/TemplateMajor.svg.mjs":false,"./icons/TemplateMinor.svg.mjs":false,"./icons/TextAlignmentCenterMajor.svg.mjs":false,"./icons/TextAlignmentLeftMajor.svg.mjs":false,"./icons/TextAlignmentRightMajor.svg.mjs":false,"./icons/TextBlockMajor.svg.mjs":false,"./icons/TextMajor.svg.mjs":false,"./icons/ThemeEditMajor.svg.mjs":false,"./icons/ThemeStoreMajor.svg.mjs":false,"./icons/ThemesMajor.svg.mjs":false,"./icons/ThumbsDownMajor.svg.mjs":false,"./icons/ThumbsDownMinor.svg.mjs":false,"./icons/ThumbsUpMajor.svg.mjs":false,"./icons/ThumbsUpMinor.svg.mjs":false,"./icons/TickMinor.svg.mjs":"5ShwD","./icons/TickSmallMinor.svg.mjs":"jdLIp","./icons/TimeDecayModelMinor.svg.mjs":false,"./icons/TimelineAttachmentMajor.svg.mjs":false,"./icons/TipsMajor.svg.mjs":false,"./icons/TitleMinor.svg.mjs":false,"./icons/ToggleMinor.svg.mjs":false,"./icons/ToolsMajor.svg.mjs":false,"./icons/TransactionFeeDollarMajor.svg.mjs":false,"./icons/TransactionFeeEuroMajor.svg.mjs":false,"./icons/TransactionFeePoundMajor.svg.mjs":false,"./icons/TransactionFeeRupeeMajor.svg.mjs":false,"./icons/TransactionFeeYenMajor.svg.mjs":false,"./icons/TransactionMajor.svg.mjs":false,"./icons/TransferInMajor.svg.mjs":false,"./icons/TransferMajor.svg.mjs":false,"./icons/TransferOutMajor.svg.mjs":false,"./icons/TransferWithinShopifyMajor.svg.mjs":false,"./icons/TransportMajor.svg.mjs":false,"./icons/TroubleshootMajor.svg.mjs":false,"./icons/TypeMajor.svg.mjs":false,"./icons/TypeMinor.svg.mjs":false,"./icons/UndoMajor.svg.mjs":false,"./icons/UnfulfilledMajor.svg.mjs":false,"./icons/UnknownDeviceMajor.svg.mjs":false,"./icons/UpdateInventoryMajor.svg.mjs":false,"./icons/UploadMajor.svg.mjs":"63ncc","./icons/VariantMajor.svg.mjs":false,"./icons/ViewMajor.svg.mjs":false,"./icons/ViewMinor.svg.mjs":false,"./icons/ViewportNarrowMajor.svg.mjs":false,"./icons/ViewportShortMajor.svg.mjs":false,"./icons/ViewportTallMajor.svg.mjs":false,"./icons/ViewportWideMajor.svg.mjs":false,"./icons/VocabularyMajor.svg.mjs":false,"./icons/VolumeMinor.svg.mjs":false,"./icons/WandMajor.svg.mjs":false,"./icons/WandMinor.svg.mjs":false,"./icons/WearableMajor.svg.mjs":false,"./icons/WeightMinor.svg.mjs":false,"./icons/WholesaleMajor.svg.mjs":false,"./icons/WifiMajor.svg.mjs":false,"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3IFjm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgArrowLeftMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgArrowLeftMinor = function SvgArrowLeftMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M17 9h-11.586l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3.293-3.293h11.586a1 1 0 1 0 0-2z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5HNSI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCancelMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCancelMinor = function SvgCancelMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8ldPz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCancelSmallMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCancelSmallMinor = function SvgCancelSmallMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.707 5.293a1 1 0 0 0-1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293 3.293 3.293a1 1 0 0 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 0 0-1.414-1.414l-3.293 3.293-3.293-3.293Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jCawW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCaretDownMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCaretDownMinor = function SvgCaretDownMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M13.098 8h-6.196c-.751 0-1.172.754-.708 1.268l3.098 3.432c.36.399 1.055.399 1.416 0l3.098-3.433c.464-.513.043-1.267-.708-1.267Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4vNg0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCaretUpMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCaretUpMinor = function SvgCaretUpMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.902 12h6.196c.751 0 1.172-.754.708-1.268l-3.098-3.432c-.36-.399-1.055-.399-1.416 0l-3.098 3.433c-.464.513-.043 1.267.708 1.267Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9mErA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgChevronDownMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgChevronDownMinor = function SvgChevronDownMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 14a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 1 1 1.414-1.414l4.293 4.293 4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5a.997.997 0 0 1-.707.293z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5b53p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgChevronLeftMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgChevronLeftMinor = function SvgChevronLeftMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l8LOR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgChevronRightMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgChevronRightMinor = function SvgChevronRightMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Co36":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgChevronUpMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgChevronUpMinor = function SvgChevronUpMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15 13a.997.997 0 0 1-.707-.293l-4.293-4.293-4.293 4.293a.999.999 0 1 1-1.414-1.414l5-5a.999.999 0 0 1 1.414 0l5 5a.999.999 0 0 1-.707 1.707z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e2Guh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCircleAlertMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCircleAlertMajor = function SvgCircleAlertMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10 0c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm-1 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"alh6z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCircleCancelMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCircleCancelMinor = function SvgCircleCancelMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-2.293 4.293a1 1 0 0 0-1.414 1.414l2.293 2.293-2.293 2.293a1 1 0 1 0 1.414 1.414l2.293-2.293 2.293 2.293a1 1 0 1 0 1.414-1.414l-2.293-2.293 2.293-2.293a1 1 0 0 0-1.414-1.414l-2.293 2.293-2.293-2.293z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kprfa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCircleInformationMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCircleInformationMajor = function SvgCircleInformationMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10 20c5.514 0 10-4.486 10-10s-4.486-10-10-10-10 4.486-10 10 4.486 10 10 10zm1-6a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0v4zm-1-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eneQq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCircleTickMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCircleTickMajor = function SvgCircleTickMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M0 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm15.2-1.8a1 1 0 0 0-1.4-1.4l-4.8 4.8-2.3-2.3a1 1 0 0 0-1.4 1.4l3 3c.4.4 1 .4 1.4 0l5.5-5.5z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9X9VA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgCircleTickOutlineMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgCircleTickOutlineMinor = function SvgCircleTickOutlineMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-14c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm-1 9a.997.997 0 0 1-.707-.293l-2-2a1 1 0 1 1 1.414-1.414l1.293 1.293 3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a.996.996 0 0 1-.707.293z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ha33g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgDiamondAlertMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgDiamondAlertMajor = function SvgDiamondAlertMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11.768.768a2.5 2.5 0 0 0-3.536 0l-7.464 7.464a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536l-7.464-7.464zm-2.768 5.232a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8URCb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgDiamondAlertMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgDiamondAlertMinor = function SvgDiamondAlertMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M11.42 2.588a2.007 2.007 0 0 0-2.84 0l-5.992 5.993a2.007 2.007 0 0 0 0 2.838l5.993 5.993a2.007 2.007 0 0 0 2.838 0l5.993-5.993a2.007 2.007 0 0 0 0-2.838l-5.993-5.993Zm-2.223 4.2a.803.803 0 1 1 1.606 0v3.212a.803.803 0 1 1-1.606 0v-3.211Zm1.606 6.423a.803.803 0 1 1-1.606 0 .803.803 0 0 1 1.606 0Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aXogV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgEnableSelectionMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgEnableSelectionMinor = function SvgEnableSelectionMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M4.5 3a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.5-1.5h-11zm9.207 5.707a1 1 0 0 0-1.414-1.414l-3.293 3.293-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dJM7P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgHorizontalDotsMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgHorizontalDotsMinor = function SvgHorizontalDotsMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6 10a2 2 0 1 1-4.001-.001 2 2 0 0 1 4.001.001zm6 0a2 2 0 1 1-4.001-.001 2 2 0 0 1 4.001.001zm6 0a2 2 0 1 1-4.001-.001 2 2 0 0 1 4.001.001z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kSyOM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgMinusMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgMinusMinor = function SvgMinusMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.167 9h-8.334c-.46 0-.833.448-.833 1s.372 1 .833 1h8.334c.46 0 .833-.448.833-1s-.373-1-.833-1"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ginwG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgMobileCancelMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgMobileCancelMajor = function SvgMobileCancelMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m11.414 10 6.293-6.293a1 1 0 1 0-1.414-1.414l-6.293 6.293-6.293-6.293a1 1 0 0 0-1.414 1.414l6.293 6.293-6.293 6.293a1 1 0 1 0 1.414 1.414l6.293-6.293 6.293 6.293a.998.998 0 0 0 1.707-.707.999.999 0 0 0-.293-.707l-6.293-6.293z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7ZvYa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgMobileHamburgerMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgMobileHamburgerMajor = function SvgMobileHamburgerMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M19 11h-18a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2zm0-7h-18a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2zm0 14h-18a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cXa0u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgPlusMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgPlusMinor = function SvgPlusMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 4a1 1 0 0 0-1 1v4h-4a1 1 0 1 0 0 2h4v4a1 1 0 1 0 2 0v-4h4a1 1 0 1 0 0-2h-4v-4a1 1 0 0 0-1-1Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5oHx3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgSearchMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgSearchMinor = function SvgSearchMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm9.707 4.293-4.82-4.82a5.968 5.968 0 0 0 1.113-3.473 6 6 0 0 0-12 0 6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k7bR9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgSelectMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgSelectMinor = function SvgSelectMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.676 9h4.648c.563 0 .879-.603.53-1.014l-2.323-2.746a.708.708 0 0 0-1.062 0l-2.324 2.746c-.347.411-.032 1.014.531 1.014Zm4.648 2h-4.648c-.563 0-.878.603-.53 1.014l2.323 2.746c.27.32.792.32 1.062 0l2.323-2.746c.349-.411.033-1.014-.53-1.014Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2dI1k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgSortAscendingMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgSortAscendingMajor = function SvgSortAscendingMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12.324 9h-4.648c-.563 0-.878-.603-.53-1.014l2.323-2.746a.708.708 0 0 1 1.062 0l2.323 2.746c.349.411.033 1.014-.53 1.014Z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.676 11h4.648c.563 0 .879.603.53 1.014l-2.323 2.746a.708.708 0 0 1-1.062 0l-2.324-2.746c-.347-.411-.032-1.014.531-1.014Z",
        fillOpacity: 0.5
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"35v6r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgSortDescendingMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgSortDescendingMajor = function SvgSortDescendingMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12.324 9h-4.648c-.563 0-.878-.603-.53-1.014l2.323-2.746a.708.708 0 0 1 1.062 0l2.323 2.746c.349.411.033 1.014-.53 1.014Z",
        fillOpacity: 0.5
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.676 11h4.648c.563 0 .879.603.53 1.014l-2.323 2.746a.708.708 0 0 1-1.062 0l-2.324-2.746c-.347-.411-.032-1.014.531-1.014Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5ShwD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgTickMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgTickMinor = function SvgTickMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m7.293 14.707-3-3a.999.999 0 1 1 1.414-1.414l2.236 2.236 6.298-7.18a.999.999 0 1 1 1.518 1.3l-7 8a1 1 0 0 1-.72.35 1.017 1.017 0 0 1-.746-.292z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jdLIp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgTickSmallMinor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgTickSmallMinor = function SvgTickSmallMinor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.723 6.237a.94.94 0 0 1 .053 1.277l-5.366 6.193a.834.834 0 0 1-.611.293.83.83 0 0 1-.622-.264l-2.927-3.097a.94.94 0 0 1 0-1.278.82.82 0 0 1 1.207 0l2.297 2.43 4.763-5.498a.821.821 0 0 1 1.206-.056Z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"63ncc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SvgUploadMajor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SvgUploadMajor = function SvgUploadMajor(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({
        viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M20 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm-14.707-1.707 4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414l-2.293-2.293v7.586a1 1 0 1 1-2 0v-7.586l-2.293 2.293a1 1 0 0 1-1.414-1.414z"
    }));
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"76aLD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "RollupActivator": "Polaris-ActionMenu-RollupActions__RollupActivator"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Szv4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _focusJs = require("../../utilities/focus.js");
var _useDisableInteractionJs = require("../../utilities/use-disable-interaction.js");
var _buttonScssJs = require("./Button.scss.js");
var _buttonScssJsDefault = parcelHelpers.interopDefault(_buttonScssJs);
var _spinnerJs = require("../Spinner/Spinner.js");
var _popoverJs = require("../Popover/Popover.js");
var _actionListJs = require("../ActionList/ActionList.js");
var _unstyledButtonJs = require("../UnstyledButton/UnstyledButton.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _iconJs = require("../Icon/Icon.js");
const DEFAULT_SIZE = "medium";
function Button({ id, children, url, disabled, external, download, target, submit, loading, pressed, accessibilityLabel, role, ariaControls, ariaExpanded, ariaDescribedBy, ariaChecked, onClick, onFocus, onBlur, onKeyDown, onKeyPress, onKeyUp, onMouseEnter, onTouchStart, onPointerDown, icon, primary, outline, destructive, disclosure, plain, monochrome, removeUnderline, size = DEFAULT_SIZE, textAlign, fullWidth, connectedDisclosure, dataPrimaryLink }) {
    const i18n = (0, _hooksJs.useI18n)();
    const isDisabled = disabled || loading;
    const className = (0, _cssJs.classNames)((0, _buttonScssJsDefault.default).Button, primary && (0, _buttonScssJsDefault.default).primary, outline && (0, _buttonScssJsDefault.default).outline, destructive && (0, _buttonScssJsDefault.default).destructive, primary && plain && (0, _buttonScssJsDefault.default).primaryPlain, isDisabled && (0, _buttonScssJsDefault.default).disabled, loading && (0, _buttonScssJsDefault.default).loading, plain && !primary && (0, _buttonScssJsDefault.default).plain, pressed && !disabled && !url && (0, _buttonScssJsDefault.default).pressed, monochrome && (0, _buttonScssJsDefault.default).monochrome, size && size !== DEFAULT_SIZE && (0, _buttonScssJsDefault.default)[(0, _cssJs.variationName)("size", size)], textAlign && (0, _buttonScssJsDefault.default)[(0, _cssJs.variationName)("textAlign", textAlign)], fullWidth && (0, _buttonScssJsDefault.default).fullWidth, icon && children == null && (0, _buttonScssJsDefault.default).iconOnly, connectedDisclosure && (0, _buttonScssJsDefault.default).connectedDisclosure, removeUnderline && (0, _buttonScssJsDefault.default).removeUnderline);
    const disclosureMarkup = disclosure ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _buttonScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _buttonScssJsDefault.default).DisclosureIcon, loading && (0, _buttonScssJsDefault.default).hidden)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: loading ? "placeholder" : getDisclosureIconSource(disclosure)
    }))) : null;
    const iconSource = isIconSource(icon) ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: loading ? "placeholder" : icon
    }) : icon;
    const iconMarkup = iconSource ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _cssJs.classNames)((0, _buttonScssJsDefault.default).Icon, loading && (0, _buttonScssJsDefault.default).hidden)
    }, iconSource) : null;
    const childMarkup = children ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _cssJs.classNames)((0, _buttonScssJsDefault.default).Text, removeUnderline && (0, _buttonScssJsDefault.default).removeUnderline) // Fixes Safari bug that doesn't re-render button text to correct color
        ,
        key: disabled ? "text-disabled" : "text"
    }, children) : null;
    const spinnerSVGMarkup = loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _buttonScssJsDefault.default).Spinner
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerJs.Spinner), {
        size: "small",
        accessibilityLabel: i18n.translate("Polaris.Button.spinnerAccessibilityLabel")
    })) : null;
    const [disclosureActive, setDisclosureActive] = (0, _react.useState)(false);
    const toggleDisclosureActive = (0, _react.useCallback)(()=>{
        setDisclosureActive((disclosureActive)=>!disclosureActive);
    }, []);
    const handleClick = (0, _useDisableInteractionJs.useDisableClick)(disabled, toggleDisclosureActive);
    let connectedDisclosureMarkup;
    if (connectedDisclosure) {
        const connectedDisclosureClassName = (0, _cssJs.classNames)((0, _buttonScssJsDefault.default).Button, primary && (0, _buttonScssJsDefault.default).primary, outline && (0, _buttonScssJsDefault.default).outline, size && size !== DEFAULT_SIZE && (0, _buttonScssJsDefault.default)[(0, _cssJs.variationName)("size", size)], textAlign && (0, _buttonScssJsDefault.default)[(0, _cssJs.variationName)("textAlign", textAlign)], destructive && (0, _buttonScssJsDefault.default).destructive, connectedDisclosure.disabled && (0, _buttonScssJsDefault.default).disabled, (0, _buttonScssJsDefault.default).iconOnly, (0, _buttonScssJsDefault.default).ConnectedDisclosure, monochrome && (0, _buttonScssJsDefault.default).monochrome);
        const defaultLabel = i18n.translate("Polaris.Button.connectedDisclosureAccessibilityLabel");
        const { disabled, accessibilityLabel: disclosureLabel = defaultLabel } = connectedDisclosure;
        const connectedDisclosureActivator = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            className: connectedDisclosureClassName,
            "aria-disabled": disabled,
            "aria-label": disclosureLabel,
            "aria-describedby": ariaDescribedBy,
            "aria-checked": ariaChecked,
            onClick: handleClick,
            onMouseUp: (0, _focusJs.handleMouseUpByBlurring),
            tabIndex: disabled ? -1 : undefined
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _buttonScssJsDefault.default).Icon
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
            source: (0, _polarisIcons.CaretDownMinor)
        })));
        connectedDisclosureMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
            active: disclosureActive,
            onClose: toggleDisclosureActive,
            activator: connectedDisclosureActivator,
            preferredAlignment: "right"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
            items: connectedDisclosure.actions,
            onActionAnyItem: toggleDisclosureActive
        }));
    }
    const commonProps = {
        id,
        className,
        accessibilityLabel,
        ariaDescribedBy,
        role,
        onClick,
        onFocus,
        onBlur,
        onMouseUp: (0, _focusJs.handleMouseUpByBlurring),
        onMouseEnter,
        onTouchStart,
        "data-primary-link": dataPrimaryLink
    };
    const linkProps = {
        url,
        external,
        download,
        target
    };
    const actionProps = {
        submit,
        disabled: isDisabled,
        loading,
        ariaControls,
        ariaExpanded,
        ariaChecked,
        pressed,
        onKeyDown,
        onKeyUp,
        onKeyPress,
        onPointerDown
    };
    const buttonMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledButtonJs.UnstyledButton), Object.assign({}, commonProps, linkProps, actionProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _buttonScssJsDefault.default).Content
    }, spinnerSVGMarkup, iconMarkup, childMarkup, disclosureMarkup));
    return connectedDisclosureMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _buttonScssJsDefault.default).ConnectedDisclosureWrapper
    }, buttonMarkup, connectedDisclosureMarkup) : buttonMarkup;
}
function isIconSource(x) {
    return typeof x === "string" || typeof x === "object" && x.body || typeof x === "function";
}
function getDisclosureIconSource(disclosure) {
    if (disclosure === "select") return 0, _polarisIcons.SelectMinor;
    return disclosure === "up" ? (0, _polarisIcons.CaretUpMinor) : (0, _polarisIcons.CaretDownMinor);
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","../../utilities/focus.js":"b0pEc","../../utilities/use-disable-interaction.js":"fl0Fy","./Button.scss.js":"b2QUq","../Spinner/Spinner.js":"43SMY","../Popover/Popover.js":"cE1F7","../ActionList/ActionList.js":"kU0n2","../UnstyledButton/UnstyledButton.js":"5Z7tL","../../utilities/i18n/hooks.js":"hhMhA","../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fl0Fy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDisableClick", ()=>useDisableClick);
var _react = require("react");
/**
 * useDisableInteraction provides the original event handler but disables interaction
 * if the boolean passed is true.
 * @param disabled - A boolean value that determines if the button should
 * be disabled
 * @param handleEvent - The original event handler
 * @returns Function - The original event handler but with interactions disabled if the
 * provided boolean is true
 * @example
 * function ComponentExample() {
 * const handleClick = () => {
 *  console.log('disable me');
 * };
 * const handleClickEvent = useDisableInteraction(true, handleClick);
 * return <button onClick={handleClickEvent}>Im Disabled</button>;
 * }
 */ function useDisableClick(disabled, handleClick) {
    const handleClickWrapper = (0, _react.useCallback)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        disabled
    ]);
    if (!disabled) return handleClick;
    return handleClickWrapper;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b2QUq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Button": "Polaris-Button",
    "pressed": "Polaris-Button--pressed",
    "disabled": "Polaris-Button--disabled",
    "connectedDisclosure": "Polaris-Button--connectedDisclosure",
    "Content": "Polaris-Button__Content",
    "plain": "Polaris-Button--plain",
    "textAlignLeft": "Polaris-Button--textAlignLeft",
    "textAlignStart": "Polaris-Button--textAlignStart",
    "textAlignCenter": "Polaris-Button--textAlignCenter",
    "textAlignRight": "Polaris-Button--textAlignRight",
    "textAlignEnd": "Polaris-Button--textAlignEnd",
    "Icon": "Polaris-Button__Icon",
    "fullWidth": "Polaris-Button--fullWidth",
    "hidden": "Polaris-Button--hidden",
    "Spinner": "Polaris-Button__Spinner",
    "primary": "Polaris-Button--primary",
    "destructive": "Polaris-Button--destructive",
    "primaryPlain": "Polaris-Button--primaryPlain",
    "outline": "Polaris-Button--outline",
    "loading": "Polaris-Button--loading",
    "removeUnderline": "Polaris-Button--removeUnderline",
    "iconOnly": "Polaris-Button--iconOnly",
    "sizeSlim": "Polaris-Button--sizeSlim",
    "sizeLarge": "Polaris-Button--sizeLarge",
    "sizeMicro": "Polaris-Button--sizeMicro",
    "monochrome": "Polaris-Button--monochrome",
    "Text": "Polaris-Button__Text",
    "ConnectedDisclosureWrapper": "Polaris-Button__ConnectedDisclosureWrapper",
    "ConnectedDisclosure": "Polaris-Button__ConnectedDisclosure"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"43SMY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Spinner", ()=>Spinner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _useIsAfterInitialMountJs = require("../../utilities/use-is-after-initial-mount.js");
var _spinnerScssJs = require("./Spinner.scss.js");
var _spinnerScssJsDefault = parcelHelpers.interopDefault(_spinnerScssJs);
var _textJs = require("../Text/Text.js");
function Spinner({ size = "large", accessibilityLabel, hasFocusableParent }) {
    const isAfterInitialMount = (0, _useIsAfterInitialMountJs.useIsAfterInitialMount)();
    const className = (0, _cssJs.classNames)((0, _spinnerScssJsDefault.default).Spinner, size && (0, _spinnerScssJsDefault.default)[(0, _cssJs.variationName)("size", size)]);
    const spinnerSVGMarkup = size === "large" ? /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 44 44",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.542 1.487A21.507 21.507 0 00.5 22c0 11.874 9.626 21.5 21.5 21.5 9.847 0 18.364-6.675 20.809-16.072a1.5 1.5 0 00-2.904-.756C37.803 34.755 30.473 40.5 22 40.5 11.783 40.5 3.5 32.217 3.5 22c0-8.137 5.3-15.247 12.942-17.65a1.5 1.5 0 10-.9-2.863z"
    })) : /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z"
    }));
    const spanAttributes = {
        ...!hasFocusableParent && {
            role: "status"
        }
    };
    const accessibilityLabelMarkup = (isAfterInitialMount || !hasFocusableParent) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, accessibilityLabel);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    }, spinnerSVGMarkup), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", spanAttributes, accessibilityLabelMarkup));
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/use-is-after-initial-mount.js":"aJ8qM","./Spinner.scss.js":"bqIPe","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bqIPe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Spinner": "Polaris-Spinner",
    "sizeSmall": "Polaris-Spinner--sizeSmall",
    "sizeLarge": "Polaris-Spinner--sizeLarge"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cE1F7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverCloseSource", ()=>(0, _popoverOverlayJs.PopoverCloseSource));
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focusJs = require("../../utilities/focus.js");
var _sharedJs = require("../shared.js");
var _setActivatorAttributesJs = require("./set-activator-attributes.js");
var _portalJs = require("../Portal/Portal.js");
var _popoverOverlayJs = require("./components/PopoverOverlay/PopoverOverlay.js");
var _paneJs = require("./components/Pane/Pane.js");
var _sectionJs = require("./components/Section/Section.js");
var _hooksJs = require("../../utilities/unique-id/hooks.js");
// TypeScript can't generate types that correctly infer the typing of
// subcomponents so explicitly state the subcomponents in the type definition.
// Letting this be implicit works in this project but fails in projects that use
// generated *.d.ts files.
const PopoverComponent = /*#__PURE__*/ (0, _react.forwardRef)(function Popover({ activatorWrapper = "div", children, onClose, activator, preventFocusOnClose, active, fixed, ariaHaspopup, preferInputActivator = true, zIndexOverride, ...rest }, ref) {
    const [activatorNode, setActivatorNode] = (0, _react.useState)();
    const overlayRef = (0, _react.useRef)(null);
    const activatorContainer = (0, _react.useRef)(null);
    const WrapperComponent = activatorWrapper;
    const id = (0, _hooksJs.useUniqueId)("popover");
    function forceUpdatePosition() {
        var _overlayRef$current;
        (_overlayRef$current = overlayRef.current) === null || _overlayRef$current === void 0 || _overlayRef$current.forceUpdatePosition();
    }
    (0, _react.useImperativeHandle)(ref, ()=>{
        return {
            forceUpdatePosition
        };
    });
    const setAccessibilityAttributes = (0, _react.useCallback)(()=>{
        if (activatorContainer.current == null) return;
        const firstFocusable = (0, _focusJs.findFirstFocusableNodeIncludingDisabled)(activatorContainer.current);
        const focusableActivator = firstFocusable || activatorContainer.current;
        const activatorDisabled = "disabled" in focusableActivator && Boolean(focusableActivator.disabled);
        (0, _setActivatorAttributesJs.setActivatorAttributes)(focusableActivator, {
            id,
            active,
            ariaHaspopup,
            activatorDisabled
        });
    }, [
        id,
        active,
        ariaHaspopup
    ]);
    const handleClose = (source)=>{
        onClose(source);
        if (activatorContainer.current == null || preventFocusOnClose) return;
        if (source === (0, _popoverOverlayJs.PopoverCloseSource).FocusOut && activatorNode) {
            const focusableActivator = (0, _focusJs.findFirstFocusableNodeIncludingDisabled)(activatorNode) || (0, _focusJs.findFirstFocusableNodeIncludingDisabled)(activatorContainer.current) || activatorContainer.current;
            if (!(0, _focusJs.focusNextFocusableNode)(focusableActivator, isInPortal)) focusableActivator.focus();
        } else if (source === (0, _popoverOverlayJs.PopoverCloseSource).EscapeKeypress && activatorNode) {
            const focusableActivator = (0, _focusJs.findFirstFocusableNodeIncludingDisabled)(activatorNode) || (0, _focusJs.findFirstFocusableNodeIncludingDisabled)(activatorContainer.current) || activatorContainer.current;
            if (focusableActivator) focusableActivator.focus();
            else (0, _focusJs.focusNextFocusableNode)(focusableActivator, isInPortal);
        }
    };
    (0, _react.useEffect)(()=>{
        if (!activatorNode && activatorContainer.current) setActivatorNode(activatorContainer.current.firstElementChild);
        else if (activatorNode && activatorContainer.current && !activatorContainer.current.contains(activatorNode)) setActivatorNode(activatorContainer.current.firstElementChild);
        setAccessibilityAttributes();
    }, [
        activatorNode,
        setAccessibilityAttributes
    ]);
    (0, _react.useEffect)(()=>{
        if (activatorNode && activatorContainer.current) setActivatorNode(activatorContainer.current.firstElementChild);
        setAccessibilityAttributes();
    }, [
        activatorNode,
        setAccessibilityAttributes
    ]);
    const portal = activatorNode ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalJs.Portal), {
        idPrefix: "popover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverOverlayJs.PopoverOverlay), Object.assign({
        ref: overlayRef,
        id: id,
        activator: activatorNode,
        preferInputActivator: preferInputActivator,
        onClose: handleClose,
        active: active,
        fixed: fixed,
        zIndexOverride: zIndexOverride
    }, rest), children)) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapperComponent, {
        ref: activatorContainer
    }, (0, _react.Children).only(activator), portal);
});
function isInPortal(element) {
    let parentElement = element.parentElement;
    while(parentElement){
        if (parentElement.matches((0, _sharedJs.portal).selector)) return false;
        parentElement = parentElement.parentElement;
    }
    return true;
}
const Popover = Object.assign(PopoverComponent, {
    Pane: (0, _paneJs.Pane),
    Section: (0, _sectionJs.Section)
});

},{"react":"cOWTg","../../utilities/focus.js":"b0pEc","../shared.js":"lFbIK","./set-activator-attributes.js":"16tYI","../Portal/Portal.js":"3wn3c","./components/PopoverOverlay/PopoverOverlay.js":"7V3Ze","./components/Pane/Pane.js":"1RFKW","./components/Section/Section.js":"kDsGp","../../utilities/unique-id/hooks.js":"2JfcO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"16tYI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setActivatorAttributes", ()=>setActivatorAttributes);
function setActivatorAttributes(activator, { id, active = false, ariaHaspopup, activatorDisabled = false }) {
    if (!activatorDisabled) activator.tabIndex = activator.tabIndex || 0;
    activator.setAttribute("aria-controls", id);
    activator.setAttribute("aria-owns", id);
    activator.setAttribute("aria-expanded", String(active));
    if (ariaHaspopup != null) activator.setAttribute("aria-haspopup", String(ariaHaspopup));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7V3Ze":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverCloseSource", ()=>PopoverCloseSource);
parcelHelpers.export(exports, "PopoverOverlay", ()=>PopoverOverlay);
parcelHelpers.export(exports, "nodeContainsDescendant", ()=>nodeContainsDescendant);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisTokens = require("@shopify/polaris-tokens");
var _focusJs = require("../../../../utilities/focus.js");
var _cssJs = require("../../../../utilities/css.js");
var _componentsJs = require("../../../../utilities/components.js");
var _typesJs = require("../../../../types.js");
var _sharedJs = require("../../../shared.js");
var _popoverScssJs = require("../../Popover.scss.js");
var _popoverScssJsDefault = parcelHelpers.interopDefault(_popoverScssJs);
var _keypressListenerJs = require("../../../KeypressListener/KeypressListener.js");
var _positionedOverlayJs = require("../../../PositionedOverlay/PositionedOverlay.js");
var _paneJs = require("../Pane/Pane.js");
var _contextJs = require("../../../../utilities/portals/context.js");
var _eventListenerJs = require("../../../EventListener/EventListener.js");
var _boxJs = require("../../../Box/Box.js");
let PopoverCloseSource;
(function(PopoverCloseSource) {
    PopoverCloseSource[PopoverCloseSource["Click"] = 0] = "Click";
    PopoverCloseSource[PopoverCloseSource["EscapeKeypress"] = 1] = "EscapeKeypress";
    PopoverCloseSource[PopoverCloseSource["FocusOut"] = 2] = "FocusOut";
    PopoverCloseSource[PopoverCloseSource["ScrollOut"] = 3] = "ScrollOut";
})(PopoverCloseSource || (PopoverCloseSource = {}));
var TransitionStatus;
(function(TransitionStatus) {
    TransitionStatus["Entering"] = "entering";
    TransitionStatus["Entered"] = "entered";
    TransitionStatus["Exiting"] = "exiting";
    TransitionStatus["Exited"] = "exited";
})(TransitionStatus || (TransitionStatus = {}));
class PopoverOverlay extends (0, _react.PureComponent) {
    constructor(props){
        super(props);
        this.context = void 0;
        this.state = {
            transitionStatus: this.props.active ? TransitionStatus.Entering : TransitionStatus.Exited
        };
        this.contentNode = /*#__PURE__*/ (0, _react.createRef)();
        this.enteringTimer = void 0;
        this.overlayRef = void 0;
        this.renderPopover = (overlayDetails)=>{
            const { measuring, desiredHeight, positioning } = overlayDetails;
            const { id, children, sectioned, fullWidth, fullHeight, fluidContent, hideOnPrint, autofocusTarget, captureOverscroll } = this.props;
            const className = (0, _cssJs.classNames)((0, _popoverScssJsDefault.default).Popover, positioning === "above" && (0, _popoverScssJsDefault.default).positionedAbove, fullWidth && (0, _popoverScssJsDefault.default).fullWidth, measuring && (0, _popoverScssJsDefault.default).measuring, hideOnPrint && (0, _popoverScssJsDefault.default)["PopoverOverlay-hideOnPrint"]);
            const contentStyles = measuring ? undefined : {
                height: desiredHeight
            };
            const contentClassNames = (0, _cssJs.classNames)((0, _popoverScssJsDefault.default).Content, fullHeight && (0, _popoverScssJsDefault.default)["Content-fullHeight"], fluidContent && (0, _popoverScssJsDefault.default)["Content-fluidContent"]);
            const content = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                id: id,
                tabIndex: autofocusTarget === "none" ? undefined : -1,
                className: contentClassNames,
                style: contentStyles,
                ref: this.contentNode
            }, renderPopoverContent(children, {
                captureOverscroll,
                sectioned
            }));
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
                className: className
            }, (0, _sharedJs.overlay).props), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
                event: "click",
                handler: this.handleClick
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
                event: "touchstart",
                handler: this.handleClick
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
                keyCode: (0, _typesJs.Key).Escape,
                handler: this.handleEscape
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _popoverScssJsDefault.default).FocusTracker // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                ,
                tabIndex: 0,
                onFocus: this.handleFocusFirstItem
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
                position: "relative",
                overflowX: "hidden",
                overflowY: "hidden",
                background: "bg",
                borderRadius: "2"
            }, content), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _popoverScssJsDefault.default).FocusTracker // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                ,
                tabIndex: 0,
                onFocus: this.handleFocusLastItem
            }));
        };
        this.handleClick = (event)=>{
            const target = event.target;
            const { contentNode, props: { activator, onClose, preventCloseOnChildOverlayClick } } = this;
            const composedPath = event.composedPath();
            const wasDescendant = preventCloseOnChildOverlayClick ? wasPolarisPortalDescendant(composedPath, this.context.container) : wasContentNodeDescendant(composedPath, contentNode);
            const isActivatorDescendant = nodeContainsDescendant(activator, target);
            if (wasDescendant || isActivatorDescendant || this.state.transitionStatus !== TransitionStatus.Entered) return;
            onClose(PopoverCloseSource.Click);
        };
        this.handleScrollOut = ()=>{
            this.props.onClose(PopoverCloseSource.ScrollOut);
        };
        this.handleEscape = (event)=>{
            const target = event.target;
            const { contentNode, props: { activator } } = this;
            const composedPath = event.composedPath();
            const wasDescendant = wasContentNodeDescendant(composedPath, contentNode);
            const isActivatorDescendant = nodeContainsDescendant(activator, target);
            if (wasDescendant || isActivatorDescendant) this.props.onClose(PopoverCloseSource.EscapeKeypress);
        };
        this.handleFocusFirstItem = ()=>{
            this.props.onClose(PopoverCloseSource.FocusOut);
        };
        this.handleFocusLastItem = ()=>{
            this.props.onClose(PopoverCloseSource.FocusOut);
        };
        this.overlayRef = /*#__PURE__*/ (0, _react.createRef)();
    }
    forceUpdatePosition() {
        var _this$overlayRef$curr;
        (_this$overlayRef$curr = this.overlayRef.current) === null || _this$overlayRef$curr === void 0 || _this$overlayRef$curr.forceUpdatePosition();
    }
    changeTransitionStatus(transitionStatus, cb) {
        this.setState({
            transitionStatus
        }, cb); // Forcing a reflow to enable the animation
        this.contentNode.current && this.contentNode.current.getBoundingClientRect();
    }
    componentDidMount() {
        if (this.props.active) {
            this.focusContent();
            this.changeTransitionStatus(TransitionStatus.Entered);
        }
    }
    componentDidUpdate(oldProps) {
        if (this.props.active && !oldProps.active) {
            this.focusContent();
            this.changeTransitionStatus(TransitionStatus.Entering, ()=>{
                this.clearTransitionTimeout();
                this.enteringTimer = window.setTimeout(()=>{
                    this.setState({
                        transitionStatus: TransitionStatus.Entered
                    });
                }, parseInt((0, _polarisTokens.motion)["duration-100"], 10));
            });
        }
        if (!this.props.active && oldProps.active) {
            this.clearTransitionTimeout();
            this.setState({
                transitionStatus: TransitionStatus.Exited
            });
        }
    }
    componentWillUnmount() {
        this.clearTransitionTimeout();
    }
    render() {
        const { active, activator, fullWidth, preferredPosition = "below", preferredAlignment = "center", preferInputActivator = true, fixed, zIndexOverride } = this.props;
        const { transitionStatus } = this.state;
        if (transitionStatus === TransitionStatus.Exited && !active) return null;
        const className = (0, _cssJs.classNames)((0, _popoverScssJsDefault.default).PopoverOverlay, transitionStatus === TransitionStatus.Entering && (0, _popoverScssJsDefault.default)["PopoverOverlay-entering"], transitionStatus === TransitionStatus.Entered && (0, _popoverScssJsDefault.default)["PopoverOverlay-open"], transitionStatus === TransitionStatus.Exiting && (0, _popoverScssJsDefault.default)["PopoverOverlay-exiting"]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _positionedOverlayJs.PositionedOverlay), {
            ref: this.overlayRef,
            fullWidth: fullWidth,
            active: active,
            activator: activator,
            preferInputActivator: preferInputActivator,
            preferredPosition: preferredPosition,
            preferredAlignment: preferredAlignment,
            render: this.renderPopover.bind(this),
            fixed: fixed,
            onScrollOut: this.handleScrollOut,
            classNames: className,
            zIndexOverride: zIndexOverride
        });
    }
    clearTransitionTimeout() {
        if (this.enteringTimer) window.clearTimeout(this.enteringTimer);
    }
    focusContent() {
        const { autofocusTarget = "container" } = this.props;
        if (autofocusTarget === "none" || this.contentNode == null) return;
        requestAnimationFrame(()=>{
            if (this.contentNode.current == null) return;
            const focusableChild = (0, _focusJs.findFirstKeyboardFocusableNode)(this.contentNode.current);
            if (focusableChild && autofocusTarget === "first-node") focusableChild.focus({
                preventScroll: false
            });
            else this.contentNode.current.focus({
                preventScroll: false
            });
        });
    }
}
PopoverOverlay.contextType = (0, _contextJs.PortalsManagerContext);
function renderPopoverContent(children, props) {
    const childrenArray = (0, _react.Children).toArray(children);
    if ((0, _componentsJs.isElementOfType)(childrenArray[0], (0, _paneJs.Pane))) return childrenArray;
    return (0, _componentsJs.wrapWithComponent)(childrenArray, (0, _paneJs.Pane), props);
}
function nodeContainsDescendant(rootNode, descendant) {
    if (rootNode === descendant) return true;
    let parent = descendant.parentNode;
    while(parent != null){
        if (parent === rootNode) return true;
        parent = parent.parentNode;
    }
    return false;
}
function wasContentNodeDescendant(composedPath, contentNode) {
    return contentNode.current != null && composedPath.includes(contentNode.current);
}
function wasPolarisPortalDescendant(composedPath, portalsContainerElement) {
    return composedPath.some((eventTarget)=>eventTarget instanceof Node && (portalsContainerElement === null || portalsContainerElement === void 0 ? void 0 : portalsContainerElement.contains(eventTarget)));
}

},{"react":"cOWTg","@shopify/polaris-tokens":"5ENVX","../../../../utilities/focus.js":"b0pEc","../../../../utilities/css.js":"lGt6N","../../../../utilities/components.js":"6Xyqa","../../../../types.js":"6NE7w","../../../shared.js":"lFbIK","../../Popover.scss.js":"9yuqd","../../../KeypressListener/KeypressListener.js":"1eFmF","../../../PositionedOverlay/PositionedOverlay.js":"2r8yP","../Pane/Pane.js":"1RFKW","../../../../utilities/portals/context.js":"2SMv8","../../../EventListener/EventListener.js":"jV8kW","../../../Box/Box.js":"lbjkG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Xyqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConditionalRender", ()=>ConditionalRender);
parcelHelpers.export(exports, "ConditionalWrapper", ()=>ConditionalWrapper);
parcelHelpers.export(exports, "elementChildren", ()=>elementChildren);
parcelHelpers.export(exports, "isElementOfType", ()=>isElementOfType);
parcelHelpers.export(exports, "wrapWithComponent", ()=>wrapWithComponent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// `Component`. If `props` is passed, those will be added as props on the
// wrapped component. If `element` is null, the component is not wrapped.
function wrapWithComponent(element, Component, props) {
    if (element == null) return null;
    return isElementOfType(element, Component) ? element : /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, element);
} // In development, we compare based on the name of the function because
// React Hot Loader proxies React components in order to make updates. In
// production we can simply compare the components for equality.
const isComponent = (AComponent, AnotherComponent)=>AComponent === AnotherComponent; // Checks whether `element` is a React element of type `Component` (or one of
// the passed components, if `Component` is an array of React components).
function isElementOfType(element, Component) {
    var _element$props;
    if (element == null || !/*#__PURE__*/ (0, _react.isValidElement)(element) || typeof element.type === "string") return false;
    const { type: defaultType } = element; // Type override allows components to bypass default wrapping behavior. Ex: Stack, ResourceList...
    // See https://github.com/Shopify/app-extension-libs/issues/996#issuecomment-710437088
    const overrideType = (_element$props = element.props) === null || _element$props === void 0 ? void 0 : _element$props.__type__;
    const type = overrideType || defaultType;
    const Components = Array.isArray(Component) ? Component : [
        Component
    ];
    return Components.some((AComponent)=>typeof type !== "string" && isComponent(AComponent, type));
} // Returns all children that are valid elements as an array. Can optionally be
// filtered by passing `predicate`.
function elementChildren(children, predicate = ()=>true) {
    return (0, _react.Children).toArray(children).filter((child)=>/*#__PURE__*/ (0, _react.isValidElement)(child) && predicate(child));
}
function ConditionalWrapper({ condition, wrapper, children }) {
    return condition ? wrapper(children) : children;
}
function ConditionalRender({ condition, children }) {
    return condition ? children : null;
}
function hotReloadComponentCheck(AComponent, AnotherComponent) {
    const componentName = AComponent.name;
    const anotherComponentName = AnotherComponent.displayName;
    return AComponent === AnotherComponent || Boolean(componentName) && componentName === anotherComponentName;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9yuqd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Popover": "Polaris-Popover",
    "PopoverOverlay": "Polaris-Popover__PopoverOverlay",
    "PopoverOverlay-entering": "Polaris-Popover__PopoverOverlay--entering",
    "PopoverOverlay-open": "Polaris-Popover__PopoverOverlay--open",
    "measuring": "Polaris-Popover--measuring",
    "PopoverOverlay-exiting": "Polaris-Popover__PopoverOverlay--exiting",
    "fullWidth": "Polaris-Popover--fullWidth",
    "Content": "Polaris-Popover__Content",
    "positionedAbove": "Polaris-Popover--positionedAbove",
    "Content-fullHeight": "Polaris-Popover__Content--fullHeight",
    "Content-fluidContent": "Polaris-Popover__Content--fluidContent",
    "Pane": "Polaris-Popover__Pane",
    "Pane-fixed": "Polaris-Popover__Pane--fixed",
    "Pane-captureOverscroll": "Polaris-Popover__Pane--captureOverscroll",
    "Section": "Polaris-Popover__Section",
    "FocusTracker": "Polaris-Popover__FocusTracker",
    "PopoverOverlay-hideOnPrint": "Polaris-Popover__PopoverOverlay--hideOnPrint"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1RFKW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pane", ()=>Pane);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _componentsJs = require("../../../../utilities/components.js");
var _popoverScssJs = require("../../Popover.scss.js");
var _popoverScssJsDefault = parcelHelpers.interopDefault(_popoverScssJs);
var _sectionJs = require("../Section/Section.js");
var _scrollableJs = require("../../../Scrollable/Scrollable.js");
function Pane({ captureOverscroll = false, fixed, sectioned, children, height, onScrolledToBottom }) {
    const className = (0, _cssJs.classNames)((0, _popoverScssJsDefault.default).Pane, fixed && (0, _popoverScssJsDefault.default)["Pane-fixed"], captureOverscroll && (0, _popoverScssJsDefault.default)["Pane-captureOverscroll"]);
    const content = sectioned ? (0, _componentsJs.wrapWithComponent)(children, (0, _sectionJs.Section), {}) : children;
    const style = height ? {
        height,
        maxHeight: height,
        minHeight: height
    } : undefined;
    return fixed ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: style,
        className: className
    }, content) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollableJs.Scrollable), {
        shadow: true,
        className: className,
        style: style,
        onScrolledToBottom: onScrolledToBottom
    }, content);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/components.js":"6Xyqa","../../Popover.scss.js":"9yuqd","../Section/Section.js":"kDsGp","../../../Scrollable/Scrollable.js":"587xt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kDsGp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _popoverScssJs = require("../../Popover.scss.js");
var _popoverScssJsDefault = parcelHelpers.interopDefault(_popoverScssJs);
var _boxJs = require("../../../Box/Box.js");
function Section({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _popoverScssJsDefault.default).Section
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        padding: "4"
    }, children));
}

},{"react":"cOWTg","../../Popover.scss.js":"9yuqd","../../../Box/Box.js":"lbjkG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Z7tL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnstyledButton", ()=>UnstyledButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focusJs = require("../../utilities/focus.js");
var _useDisableInteractionJs = require("../../utilities/use-disable-interaction.js");
var _unstyledLinkJs = require("../UnstyledLink/UnstyledLink.js");
function UnstyledButton({ id, children, className, url, external, target, download, submit, disabled, loading, pressed, accessibilityLabel, role, ariaControls, ariaExpanded, ariaDescribedBy, ariaChecked, onClick, onFocus, onBlur, onKeyDown, onKeyPress, onKeyUp, onMouseEnter, onTouchStart, ...rest }) {
    let buttonMarkup;
    const commonProps = {
        id,
        className,
        "aria-label": accessibilityLabel
    };
    const interactiveProps = {
        ...commonProps,
        role,
        onClick,
        onFocus,
        onBlur,
        onMouseUp: (0, _focusJs.handleMouseUpByBlurring),
        onMouseEnter,
        onTouchStart
    };
    const handleClick = (0, _useDisableInteractionJs.useDisableClick)(disabled, onClick);
    if (url) buttonMarkup = disabled ? /*#__PURE__*/ // Render an `<a>` so toggling disabled/enabled state changes only the
    // `href` attribute instead of replacing the whole element.
    (0, _reactDefault.default).createElement("a", commonProps, children) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), Object.assign({}, interactiveProps, {
        url: url,
        external: external,
        target: target,
        download: download
    }, rest), children);
    else buttonMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", Object.assign({}, interactiveProps, {
        "aria-disabled": disabled,
        type: submit ? "submit" : "button",
        "aria-busy": loading ? true : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-describedby": ariaDescribedBy,
        "aria-checked": ariaChecked,
        "aria-pressed": pressed,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onKeyPress: onKeyPress,
        onClick: handleClick,
        tabIndex: disabled ? -1 : undefined
    }, rest), children);
    return buttonMarkup;
}

},{"react":"cOWTg","../../utilities/focus.js":"b0pEc","../../utilities/use-disable-interaction.js":"fl0Fy","../UnstyledLink/UnstyledLink.js":"4o3DP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kawC2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Actions", ()=>Actions);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounceJs = require("../../../../utilities/debounce.js");
var _useEventListenerJs = require("../../../../utilities/use-event-listener.js");
var _useIsomorphicLayoutEffectJs = require("../../../../utilities/use-isomorphic-layout-effect.js");
var _actionsScssJs = require("./Actions.scss.js");
var _actionsScssJsDefault = parcelHelpers.interopDefault(_actionsScssJs);
var _menuGroupJs = require("../MenuGroup/MenuGroup.js");
var _buttonGroupJs = require("../../../ButtonGroup/ButtonGroup.js");
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _secondaryActionJs = require("../SecondaryAction/SecondaryAction.js");
const ACTION_SPACING = 8;
function Actions({ actions = [], groups = [], onActionRollup }) {
    const i18n = (0, _hooksJs.useI18n)();
    const actionsLayoutRef = (0, _react.useRef)(null);
    const menuGroupWidthRef = (0, _react.useRef)(0);
    const availableWidthRef = (0, _react.useRef)(0);
    const actionsAndGroupsLengthRef = (0, _react.useRef)(0);
    const timesMeasured = (0, _react.useRef)(0);
    const actionWidthsRef = (0, _react.useRef)([]);
    const rollupActiveRef = (0, _react.useRef)(null);
    const [activeMenuGroup, setActiveMenuGroup] = (0, _react.useState)(undefined);
    const [measuredActions, setMeasuredActions] = (0, _react.useState)({
        showable: [],
        rolledUp: []
    });
    const defaultRollupGroup = {
        title: i18n.translate("Polaris.ActionMenu.Actions.moreActions"),
        actions: []
    };
    const lastMenuGroup = [
        ...groups
    ].pop();
    const lastMenuGroupWidth = [
        ...actionWidthsRef.current
    ].pop() || 0;
    const handleActionsOffsetWidth = (0, _react.useCallback)((width)=>{
        actionWidthsRef.current = [
            ...actionWidthsRef.current,
            width
        ];
    }, []);
    const handleMenuGroupToggle = (0, _react.useCallback)((group)=>setActiveMenuGroup(activeMenuGroup ? undefined : group), [
        activeMenuGroup
    ]);
    const handleMenuGroupClose = (0, _react.useCallback)(()=>setActiveMenuGroup(undefined), []);
    const updateActions = (0, _react.useCallback)(()=>{
        let actionsAndGroups = [
            ...actions,
            ...groups
        ];
        if (groups.length > 0) // We don't want to include actions from the last group
        // since it is always rendered with its own actions
        actionsAndGroups = [
            ...actionsAndGroups
        ].slice(0, actionsAndGroups.length - 1);
        setMeasuredActions((currentMeasuredActions)=>{
            const showable = actionsAndGroups.slice(0, currentMeasuredActions.showable.length);
            const rolledUp = actionsAndGroups.slice(currentMeasuredActions.showable.length, actionsAndGroups.length);
            return {
                showable,
                rolledUp
            };
        });
    }, [
        actions,
        groups
    ]);
    const measureActions = (0, _react.useCallback)(()=>{
        if (actionWidthsRef.current.length === 0 || availableWidthRef.current === 0) return;
        const actionsAndGroups = [
            ...actions,
            ...groups
        ];
        if (actionsAndGroups.length === 1) {
            setMeasuredActions({
                showable: actionsAndGroups,
                rolledUp: []
            });
            return;
        }
        let currentAvailableWidth = availableWidthRef.current;
        let newShowableActions = [];
        let newRolledUpActions = [];
        actionsAndGroups.forEach((action, index)=>{
            const canFitAction = actionWidthsRef.current[index] + menuGroupWidthRef.current + ACTION_SPACING + lastMenuGroupWidth <= currentAvailableWidth;
            if (canFitAction) {
                currentAvailableWidth -= actionWidthsRef.current[index] + ACTION_SPACING * 2;
                newShowableActions = [
                    ...newShowableActions,
                    action
                ];
            } else {
                currentAvailableWidth = 0; // Find last group if it exists and always render it as a rolled up action below
                if (action === lastMenuGroup) return;
                newRolledUpActions = [
                    ...newRolledUpActions,
                    action
                ];
            }
        });
        if (onActionRollup) {
            // Note: Do not include last group actions since we are skipping `lastMenuGroup` above
            // as it is always rendered with its own actions
            const isRollupActive = newShowableActions.length < actionsAndGroups.length - 1;
            if (rollupActiveRef.current !== isRollupActive) {
                onActionRollup(isRollupActive);
                rollupActiveRef.current = isRollupActive;
            }
        }
        setMeasuredActions({
            showable: newShowableActions,
            rolledUp: newRolledUpActions
        });
        timesMeasured.current += 1;
        actionsAndGroupsLengthRef.current = actionsAndGroups.length;
    }, [
        actions,
        groups,
        lastMenuGroup,
        lastMenuGroupWidth,
        onActionRollup
    ]);
    const handleResize = (0, _react.useMemo)(()=>(0, _debounceJs.debounce)(()=>{
            if (!actionsLayoutRef.current) return;
            availableWidthRef.current = actionsLayoutRef.current.offsetWidth; // Set timesMeasured to 0 to allow re-measuring
            timesMeasured.current = 0;
            measureActions();
        }, 50, {
            leading: false,
            trailing: true
        }), [
        measureActions
    ]);
    (0, _useEventListenerJs.useEventListener)("resize", handleResize);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        if (!actionsLayoutRef.current) return;
        availableWidthRef.current = actionsLayoutRef.current.offsetWidth;
        if (// This accounts for the initial paint and re-flow
        timesMeasured.current >= 2 && [
            ...actions,
            ...groups
        ].length === actionsAndGroupsLengthRef.current) {
            updateActions();
            return;
        }
        measureActions();
    }, [
        actions,
        groups,
        measureActions,
        updateActions
    ]);
    const actionsMarkup = actions.map((action)=>{
        if (measuredActions.showable.length > 0 || measuredActions.rolledUp.includes(action)) return null;
        const { content, onAction, ...rest } = action;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _secondaryActionJs.SecondaryAction), Object.assign({
            key: content,
            onClick: onAction
        }, rest, {
            getOffsetWidth: handleActionsOffsetWidth
        }), content);
    });
    const rollUppableActionsMarkup = measuredActions.showable.length > 0 ? measuredActions.showable.map((action)=>action.content && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _secondaryActionJs.SecondaryAction), Object.assign({
            key: action.content
        }, action, {
            getOffsetWidth: handleActionsOffsetWidth
        }), action.content)) : null;
    const filteredGroups = [
        ...groups,
        defaultRollupGroup
    ].filter((group)=>{
        return groups.length === 0 ? group : group === lastMenuGroup || !measuredActions.rolledUp.some((rolledUpGroup)=>isMenuGroup(rolledUpGroup) && rolledUpGroup.title === group.title);
    });
    const groupsMarkup = filteredGroups.map((group)=>{
        const { title, actions: groupActions, ...rest } = group;
        const isDefaultGroup = group === defaultRollupGroup;
        const isLastMenuGroup = group === lastMenuGroup;
        const [finalRolledUpActions, finalRolledUpSectionGroups] = measuredActions.rolledUp.reduce(([actions, sections], action)=>{
            if (isMenuGroup(action)) sections.push({
                title: action.title,
                items: action.actions.map((sectionAction)=>({
                        ...sectionAction,
                        disabled: action.disabled || sectionAction.disabled
                    }))
            });
            else actions.push(action);
            return [
                actions,
                sections
            ];
        }, [
            [],
            []
        ]);
        if (!isDefaultGroup && !isLastMenuGroup) // Render a normal MenuGroup with just its actions
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuGroupJs.MenuGroup), Object.assign({
            key: title,
            title: title,
            active: title === activeMenuGroup,
            actions: groupActions
        }, rest, {
            onOpen: handleMenuGroupToggle,
            onClose: handleMenuGroupClose,
            getOffsetWidth: handleActionsOffsetWidth
        }));
        else if (!isDefaultGroup && isLastMenuGroup) // render the last, rollup group with its actions and finalRolledUpActions
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuGroupJs.MenuGroup), Object.assign({
            key: title,
            title: title,
            active: title === activeMenuGroup,
            actions: [
                ...finalRolledUpActions,
                ...groupActions
            ],
            sections: finalRolledUpSectionGroups
        }, rest, {
            onOpen: handleMenuGroupToggle,
            onClose: handleMenuGroupClose,
            getOffsetWidth: handleActionsOffsetWidth
        }));
        else if (isDefaultGroup && groups.length === 0 && finalRolledUpActions.length) // Render the default group to rollup into if one does not exist
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuGroupJs.MenuGroup), Object.assign({
            key: title,
            title: title,
            active: title === activeMenuGroup,
            actions: finalRolledUpActions,
            sections: finalRolledUpSectionGroups
        }, rest, {
            onOpen: handleMenuGroupToggle,
            onClose: handleMenuGroupClose,
            getOffsetWidth: handleActionsOffsetWidth
        }));
    });
    const groupedActionsMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), {
        spacing: "extraTight"
    }, rollUppableActionsMarkup, actionsMarkup, groupsMarkup);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _actionsScssJsDefault.default).ActionsLayout,
        ref: actionsLayoutRef
    }, groupedActionsMarkup);
}
function isMenuGroup(actionOrMenuGroup) {
    return "title" in actionOrMenuGroup;
}

},{"react":"cOWTg","../../../../utilities/debounce.js":"bvJet","../../../../utilities/use-event-listener.js":"1MHbT","../../../../utilities/use-isomorphic-layout-effect.js":"2th17","./Actions.scss.js":"bi0R7","../MenuGroup/MenuGroup.js":"aRq9s","../../../ButtonGroup/ButtonGroup.js":"QiqnY","../../../../utilities/i18n/hooks.js":"hhMhA","../SecondaryAction/SecondaryAction.js":"5thmU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bi0R7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ActionsLayout": "Polaris-ActionMenu-Actions__ActionsLayout"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aRq9s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuGroup", ()=>MenuGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _menuGroupScssJs = require("./MenuGroup.scss.js");
var _menuGroupScssJsDefault = parcelHelpers.interopDefault(_menuGroupScssJs);
var _secondaryActionJs = require("../SecondaryAction/SecondaryAction.js");
var _popoverJs = require("../../../Popover/Popover.js");
var _actionListJs = require("../../../ActionList/ActionList.js");
function MenuGroup({ accessibilityLabel, active, actions, details, title, icon, disabled, onClick, onClose, onOpen, getOffsetWidth, sections }) {
    const handleClose = (0, _react.useCallback)(()=>{
        onClose(title);
    }, [
        onClose,
        title
    ]);
    const handleOpen = (0, _react.useCallback)(()=>{
        onOpen(title);
    }, [
        onOpen,
        title
    ]);
    const handleClick = (0, _react.useCallback)(()=>{
        if (onClick) onClick(handleOpen);
        else handleOpen();
    }, [
        onClick,
        handleOpen
    ]);
    const handleOffsetWidth = (0, _react.useCallback)((width)=>{
        if (!getOffsetWidth) return;
        getOffsetWidth(width);
    }, [
        getOffsetWidth
    ]);
    const popoverActivator = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _secondaryActionJs.SecondaryAction), {
        disclosure: true,
        disabled: disabled,
        icon: icon,
        accessibilityLabel: accessibilityLabel,
        onClick: handleClick,
        getOffsetWidth: handleOffsetWidth
    }, title);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
        active: Boolean(active),
        activator: popoverActivator,
        preferredAlignment: "left",
        onClose: handleClose,
        hideOnPrint: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
        items: actions,
        sections: sections,
        onActionAnyItem: handleClose
    }), details && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _menuGroupScssJsDefault.default).Details
    }, details));
}

},{"react":"cOWTg","./MenuGroup.scss.js":"49PDP","../SecondaryAction/SecondaryAction.js":"5thmU","../../../Popover/Popover.js":"cE1F7","../../../ActionList/ActionList.js":"kU0n2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"49PDP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Details": "Polaris-ActionMenu-MenuGroup__Details"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5thmU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondaryAction", ()=>SecondaryAction);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _secondaryActionScssJs = require("./SecondaryAction.scss.js");
var _secondaryActionScssJsDefault = parcelHelpers.interopDefault(_secondaryActionScssJs);
var _buttonJs = require("../../../Button/Button.js");
var _tooltipJs = require("../../../Tooltip/Tooltip.js");
function SecondaryAction({ children, destructive, helpText, onAction, getOffsetWidth, ...rest }) {
    const secondaryActionsRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        var _secondaryActionsRef$;
        if (!getOffsetWidth || !secondaryActionsRef.current) return;
        getOffsetWidth((_secondaryActionsRef$ = secondaryActionsRef.current) === null || _secondaryActionsRef$ === void 0 ? void 0 : _secondaryActionsRef$.offsetWidth);
    }, [
        getOffsetWidth
    ]);
    const buttonMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), Object.assign({
        onClick: onAction
    }, rest), children);
    const actionMarkup = helpText ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
        content: helpText
    }, buttonMarkup) : buttonMarkup;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _cssJs.classNames)((0, _secondaryActionScssJsDefault.default).SecondaryAction, destructive && (0, _secondaryActionScssJsDefault.default).destructive),
        ref: secondaryActionsRef
    }, actionMarkup);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./SecondaryAction.scss.js":"hB1WQ","../../../Button/Button.js":"6Szv4","../../../Tooltip/Tooltip.js":"k7vL7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hB1WQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "SecondaryAction": "Polaris-ActionMenu-SecondaryAction",
    "destructive": "Polaris-ActionMenu-SecondaryAction--destructive"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"QiqnY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonGroup", ()=>ButtonGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _componentsJs = require("../../utilities/components.js");
var _buttonGroupScssJs = require("./ButtonGroup.scss.js");
var _buttonGroupScssJsDefault = parcelHelpers.interopDefault(_buttonGroupScssJs);
var _itemJs = require("./components/Item/Item.js");
function ButtonGroup({ children, spacing, segmented, fullWidth, connectedTop, noWrap }) {
    const className = (0, _cssJs.classNames)((0, _buttonGroupScssJsDefault.default).ButtonGroup, spacing && (0, _buttonGroupScssJsDefault.default)[spacing], segmented && (0, _buttonGroupScssJsDefault.default).segmented, fullWidth && (0, _buttonGroupScssJsDefault.default).fullWidth, noWrap && (0, _buttonGroupScssJsDefault.default).noWrap);
    const contents = (0, _componentsJs.elementChildren)(children).map((child, index)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), {
            button: child,
            key: index
        }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        "data-buttongroup-segmented": segmented,
        "data-buttongroup-connected-top": connectedTop,
        "data-buttongroup-full-width": fullWidth,
        "data-buttongroup-no-wrap": noWrap
    }, contents);
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/components.js":"6Xyqa","./ButtonGroup.scss.js":"d0vGR","./components/Item/Item.js":"fxJWf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d0vGR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ButtonGroup": "Polaris-ButtonGroup",
    "Item": "Polaris-ButtonGroup__Item",
    "Item-plain": "Polaris-ButtonGroup__Item--plain",
    "segmented": "Polaris-ButtonGroup--segmented",
    "Item-focused": "Polaris-ButtonGroup__Item--focused",
    "fullWidth": "Polaris-ButtonGroup--fullWidth",
    "extraTight": "Polaris-ButtonGroup--extraTight",
    "tight": "Polaris-ButtonGroup--tight",
    "loose": "Polaris-ButtonGroup--loose",
    "noWrap": "Polaris-ButtonGroup--noWrap"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fxJWf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useToggleJs = require("../../../../utilities/use-toggle.js");
var _cssJs = require("../../../../utilities/css.js");
var _buttonGroupScssJs = require("../../ButtonGroup.scss.js");
var _buttonGroupScssJsDefault = parcelHelpers.interopDefault(_buttonGroupScssJs);
function Item({ button }) {
    const { value: focused, setTrue: forceTrueFocused, setFalse: forceFalseFocused } = (0, _useToggleJs.useToggle)(false);
    const className = (0, _cssJs.classNames)((0, _buttonGroupScssJsDefault.default).Item, focused && (0, _buttonGroupScssJsDefault.default)["Item-focused"], button.props.plain && (0, _buttonGroupScssJsDefault.default)["Item-plain"]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        onFocus: forceTrueFocused,
        onBlur: forceFalseFocused
    }, button);
}

},{"react":"cOWTg","../../../../utilities/use-toggle.js":"2kpDL","../../../../utilities/css.js":"lGt6N","../../ButtonGroup.scss.js":"d0vGR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5lUFs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalStack", ()=>VerticalStack);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _verticalStackScssJs = require("./VerticalStack.scss.js");
var _verticalStackScssJsDefault = parcelHelpers.interopDefault(_verticalStackScssJs);
const VerticalStack = ({ as = "div", children, align, inlineAlign, gap, id, reverseOrder = false, ...restProps })=>{
    const className = (0, _cssJs.classNames)((0, _verticalStackScssJsDefault.default).VerticalStack, (as === "ul" || as === "ol") && (0, _verticalStackScssJsDefault.default).listReset, as === "fieldset" && (0, _verticalStackScssJsDefault.default).fieldsetReset);
    const style = {
        "--pc-vertical-stack-align": align ? `${align}` : "",
        "--pc-vertical-stack-inline-align": inlineAlign ? `${inlineAlign}` : "",
        "--pc-vertical-stack-order": reverseOrder ? "column-reverse" : "column",
        ...(0, _cssJs.getResponsiveProps)("vertical-stack", "gap", "space", gap)
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(as, {
        className,
        style: (0, _cssJs.sanitizeCustomProperties)(style),
        ...restProps
    }, children);
};

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./VerticalStack.scss.js":"5K3Vp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5K3Vp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "VerticalStack": "Polaris-VerticalStack",
    "listReset": "Polaris-VerticalStack--listReset",
    "fieldsetReset": "Polaris-VerticalStack--fieldsetReset"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5oUbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Autocomplete", ()=>Autocomplete);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _optionsJs = require("../../utilities/options.js");
var _autocompleteScssJs = require("./Autocomplete.scss.js");
var _autocompleteScssJsDefault = parcelHelpers.interopDefault(_autocompleteScssJs);
var _mappedOptionJs = require("./components/MappedOption/MappedOption.js");
var _listboxJs = require("../Listbox/Listbox.js");
var _comboboxJs = require("../Combobox/Combobox.js");
var _mappedActionJs = require("./components/MappedAction/MappedAction.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
// TypeScript can't generate types that correctly infer the typing of
// subcomponents so explicitly state the subcomponents in the type definition.
// Letting this be implicit works in this project but fails in projects that use
// generated *.d.ts files.
const Autocomplete = function Autocomplete({ options, selected, textField, preferredPosition, listTitle, allowMultiple, loading, actionBefore, willLoadMoreResults, emptyState, onSelect, onLoadMoreResults }) {
    const i18n = (0, _hooksJs.useI18n)();
    const buildMappedOptionFromOption = (0, _react.useCallback)((options)=>{
        return options.map((option)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _mappedOptionJs.MappedOption), Object.assign({
                key: option.id || option.value
            }, option, {
                selected: selected.includes(option.value),
                singleSelection: !allowMultiple
            })));
    }, [
        selected,
        allowMultiple
    ]);
    const optionsMarkup = (0, _react.useMemo)(()=>{
        const conditionalOptions = loading && !willLoadMoreResults ? [] : options;
        if ((0, _optionsJs.isSection)(conditionalOptions)) {
            const noOptionsAvailable = conditionalOptions.every(({ options })=>options.length === 0);
            if (noOptionsAvailable) return null;
            const optionsMarkup = conditionalOptions.map(({ options, title })=>{
                if (options.length === 0) return null;
                const optionMarkup = buildMappedOptionFromOption(options);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).Section, {
                    divider: false,
                    title: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).Header, null, title),
                    key: title
                }, optionMarkup);
            });
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _autocompleteScssJsDefault.default).SectionWrapper
            }, optionsMarkup);
        }
        const optionList = conditionalOptions.length > 0 ? buildMappedOptionFromOption(conditionalOptions) : null;
        if (listTitle) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).Section, {
            divider: false,
            title: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).Header, null, listTitle)
        }, optionList);
        return optionList;
    }, [
        listTitle,
        loading,
        options,
        willLoadMoreResults,
        buildMappedOptionFromOption
    ]);
    const loadingMarkup = loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).Loading, {
        accessibilityLabel: i18n.translate("Polaris.Autocomplete.spinnerAccessibilityLabel")
    }) : null;
    const updateSelection = (0, _react.useCallback)((newSelection)=>{
        if (actionBefore && newSelection === actionBefore.content) {
            actionBefore.onAction && actionBefore.onAction();
            return;
        }
        if (allowMultiple) {
            if (selected.includes(newSelection)) onSelect(selected.filter((option)=>option !== newSelection));
            else onSelect([
                ...selected,
                newSelection
            ]);
        } else onSelect([
            newSelection
        ]);
    }, [
        allowMultiple,
        onSelect,
        selected,
        actionBefore
    ]);
    const actionMarkup = actionBefore && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _mappedActionJs.MappedAction), actionBefore);
    const emptyStateMarkup = emptyState && options.length < 1 && !loading && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "status"
    }, emptyState);
    const autoSelection = actionBefore ? (0, _listboxJs.AutoSelection).First : undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _comboboxJs.Combobox), {
        activator: textField,
        allowMultiple: allowMultiple,
        onScrolledToBottom: onLoadMoreResults,
        preferredPosition: preferredPosition,
        willLoadMoreOptions: willLoadMoreResults
    }, actionMarkup || optionsMarkup || loadingMarkup || emptyStateMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox), {
        autoSelection: autoSelection,
        onSelect: updateSelection
    }, actionMarkup, optionsMarkup && (!loading || willLoadMoreResults) ? optionsMarkup : null, loadingMarkup, emptyStateMarkup) : null);
};
Autocomplete.TextField = (0, _comboboxJs.Combobox).TextField;

},{"react":"cOWTg","../../utilities/options.js":"7XDjE","./Autocomplete.scss.js":"c4W4f","./components/MappedOption/MappedOption.js":"Mk5Bj","../Listbox/Listbox.js":"1WNFN","../Combobox/Combobox.js":"g7Upk","./components/MappedAction/MappedAction.js":"kWhoG","../../utilities/i18n/hooks.js":"hhMhA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7XDjE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSection", ()=>isSection);
function isSection(arr) {
    return typeof arr[0] === "object" && Object.prototype.hasOwnProperty.call(arr[0], "options");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c4W4f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Loading": "Polaris-Autocomplete__Loading",
    "SectionWrapper": "Polaris-Autocomplete__SectionWrapper"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"Mk5Bj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MappedOption", ()=>MappedOption);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _mappedOptionScssJs = require("./MappedOption.scss.js");
var _mappedOptionScssJsDefault = parcelHelpers.interopDefault(_mappedOptionScssJs);
var _listboxJs = require("../../../Listbox/Listbox.js");
const MappedOption = /*#__PURE__*/ (0, _react.memo)(function MappedOption({ label, value, disabled, media, selected, singleSelection }) {
    const mediaClassNames = (0, _cssJs.classNames)((0, _mappedOptionScssJsDefault.default).Media, disabled && (0, _mappedOptionScssJsDefault.default).disabledMedia, singleSelection && (0, _mappedOptionScssJsDefault.default).singleSelectionMedia);
    const mediaMarkup = media ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: mediaClassNames
    }, media) : null;
    const accessibilityLabel = typeof label === "string" ? label : undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).Option, {
        accessibilityLabel: accessibilityLabel,
        key: value,
        selected: selected,
        value: value,
        disabled: disabled
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).TextOption, {
        selected: selected,
        disabled: disabled
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _mappedOptionScssJsDefault.default).Content
    }, mediaMarkup, label)));
});

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./MappedOption.scss.js":"8Ect3","../../../Listbox/Listbox.js":"1WNFN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Ect3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Content": "Polaris-Autocomplete-MappedOption__Content",
    "Media": "Polaris-Autocomplete-MappedOption__Media",
    "singleSelectionMedia": "Polaris-Autocomplete-MappedOption--singleSelectionMedia",
    "disabledMedia": "Polaris-Autocomplete-MappedOption--disabledMedia"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1WNFN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoSelection", ()=>AutoSelection);
parcelHelpers.export(exports, "Listbox", ()=>Listbox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounceJs = require("../../utilities/debounce.js");
var _useToggleJs = require("../../utilities/use-toggle.js");
var _typesJs = require("../../types.js");
var _sharedJs = require("../shared.js");
var _listboxScssJs = require("./Listbox.scss.js");
var _listboxScssJsDefault = parcelHelpers.interopDefault(_listboxScssJs);
var _hooksJs = require("../../utilities/combobox/hooks.js");
var _utilitiesJs = require("../../utilities/listbox/utilities.js");
var _contextJs = require("../../utilities/listbox/context.js");
var _textOptionJs = require("./components/TextOption/TextOption.js");
var _loadingJs = require("./components/Loading/Loading.js");
var _sectionJs = require("./components/Section/Section.js");
var _headerJs = require("./components/Header/Header.js");
var _actionJs = require("./components/Action/Action.js");
var _hooksJs1 = require("../../utilities/unique-id/hooks.js");
var _keypressListenerJs = require("../KeypressListener/KeypressListener.js");
var _textJs = require("../Text/Text.js");
var _optionJs = require("./components/Option/Option.js");
let AutoSelection;
(function(AutoSelection) {
    AutoSelection["FirstSelected"] = "FIRST_SELECTED";
    AutoSelection["First"] = "FIRST";
    AutoSelection["None"] = "NONE";
})(AutoSelection || (AutoSelection = {}));
const OPTION_SELECTOR = "[data-listbox-option]";
const OPTION_VALUE_ATTRIBUTE = "data-listbox-option-value";
const OPTION_ACTION_ATTRIBUTE = "data-listbox-option-action";
const OPTION_FOCUS_ATTRIBUTE = "data-focused";
function Listbox({ children, autoSelection = AutoSelection.FirstSelected, enableKeyboardControl, accessibilityLabel, customListId, onSelect, onActiveOptionChange }) {
    const [loading, setLoading] = (0, _react.useState)();
    const [activeOption, setActiveOption] = (0, _react.useState)();
    const [lazyLoading, setLazyLoading] = (0, _react.useState)(false);
    const [currentOptions, setCurrentOptions] = (0, _react.useState)([]);
    const { value: keyboardEventsEnabled, setTrue: enableKeyboardEvents, setFalse: disableKeyboardEvents } = (0, _useToggleJs.useToggle)(Boolean(enableKeyboardControl));
    const uniqueId = (0, _hooksJs1.useUniqueId)("Listbox");
    const listId = customListId || uniqueId;
    const scrollableRef = (0, _react.useRef)(null);
    const listboxRef = (0, _react.useRef)(null);
    const { listboxId, textFieldLabelId, textFieldFocused, willLoadMoreOptions, setActiveOptionId, setListboxId, onOptionSelected, onKeyToBottom } = (0, _hooksJs.useComboboxListbox)();
    const inCombobox = Boolean(setActiveOptionId);
    (0, _react.useEffect)(()=>{
        if (setListboxId && !listboxId) setListboxId(listId);
    }, [
        setListboxId,
        listboxId,
        listId
    ]);
    const getNavigableOptions = (0, _react.useCallback)(()=>{
        if (!listboxRef.current) return [];
        return [
            ...new Set(listboxRef.current.querySelectorAll(OPTION_SELECTOR))
        ];
    }, []);
    const getFirstNavigableOption = (0, _react.useCallback)((currentOptions)=>{
        const hasSelectedOptions = currentOptions.some((option)=>option.getAttribute("aria-selected") === "true");
        let elementIndex = 0;
        const element = currentOptions.find((option, index)=>{
            const isInteractable = option.getAttribute("aria-disabled") !== "true";
            let isFirstNavigableOption;
            if (hasSelectedOptions && autoSelection === AutoSelection.FirstSelected) {
                const isSelected = option.getAttribute("aria-selected") === "true";
                isFirstNavigableOption = isSelected && isInteractable;
            } else isFirstNavigableOption = isInteractable;
            if (isFirstNavigableOption) elementIndex = index;
            return isFirstNavigableOption;
        });
        if (!element) return;
        return {
            element,
            index: elementIndex
        };
    }, [
        autoSelection
    ]);
    const handleScrollIntoView = (0, _react.useCallback)((option)=>{
        const { current: scrollable } = scrollableRef;
        if (scrollable) (0, _utilitiesJs.scrollOptionIntoView)(option.element, scrollable);
    }, []);
    const handleScrollIntoViewDebounced = (0, _debounceJs.debounce)(handleScrollIntoView, 50);
    const handleKeyToBottom = (0, _react.useCallback)(()=>{
        if (onKeyToBottom) {
            setLazyLoading(true);
            return Promise.resolve(onKeyToBottom());
        }
    }, [
        onKeyToBottom
    ]);
    const handleChangeActiveOption = (0, _react.useCallback)((nextOption)=>{
        if (!nextOption) return setActiveOption(undefined);
        activeOption === null || activeOption === void 0 || activeOption.element.removeAttribute(OPTION_FOCUS_ATTRIBUTE);
        nextOption.element.setAttribute(OPTION_FOCUS_ATTRIBUTE, "true");
        handleScrollIntoViewDebounced(nextOption);
        setActiveOption(nextOption);
        setActiveOptionId === null || setActiveOptionId === void 0 || setActiveOptionId(nextOption.domId);
        onActiveOptionChange === null || onActiveOptionChange === void 0 || onActiveOptionChange(nextOption.value, nextOption.domId);
    }, [
        activeOption,
        setActiveOptionId,
        onActiveOptionChange,
        handleScrollIntoViewDebounced
    ]);
    const getFormattedOption = (0, _react.useCallback)((element, index)=>{
        return {
            element,
            index,
            domId: element.id,
            value: element.getAttribute(OPTION_VALUE_ATTRIBUTE) || "",
            disabled: element.getAttribute("aria-disabled") === "true",
            isAction: element.getAttribute(OPTION_ACTION_ATTRIBUTE) === "true"
        };
    }, []);
    const resetActiveOption = (0, _react.useCallback)(()=>{
        var _nextOption, _nextOption2, _nextOption3;
        let nextOption;
        const nextOptions = getNavigableOptions();
        const nextActiveOption = getFirstNavigableOption(nextOptions);
        if (nextOptions.length === 0 && currentOptions.length > 0) {
            setCurrentOptions(nextOptions);
            handleChangeActiveOption();
            return;
        }
        if (nextActiveOption) {
            const { element, index } = nextActiveOption;
            nextOption = getFormattedOption(element, index);
        }
        const optionIsAlreadyActive = activeOption !== undefined && ((_nextOption = nextOption) === null || _nextOption === void 0 ? void 0 : _nextOption.domId) === (activeOption === null || activeOption === void 0 ? void 0 : activeOption.domId);
        const actionContentHasUpdated = (activeOption === null || activeOption === void 0 ? void 0 : activeOption.isAction) && ((_nextOption2 = nextOption) === null || _nextOption2 === void 0 ? void 0 : _nextOption2.isAction) && ((_nextOption3 = nextOption) === null || _nextOption3 === void 0 ? void 0 : _nextOption3.value) !== (activeOption === null || activeOption === void 0 ? void 0 : activeOption.value);
        const currentValues = currentOptions.map((option)=>option.getAttribute(OPTION_VALUE_ATTRIBUTE));
        const nextValues = nextOptions.map((option)=>option.getAttribute(OPTION_VALUE_ATTRIBUTE));
        const listIsUnchanged = nextValues.length === currentValues.length && nextValues.every((value, index)=>{
            return currentValues[index] === value;
        });
        const listIsAppended = currentValues.length !== 0 && nextValues.length > currentValues.length && currentValues.every((value, index)=>{
            return nextValues[index] === value;
        });
        if (listIsUnchanged) {
            if (optionIsAlreadyActive && actionContentHasUpdated) {
                setCurrentOptions(nextOptions);
                handleChangeActiveOption(nextOption);
            }
            return;
        }
        if (listIsAppended) {
            setCurrentOptions(nextOptions);
            return;
        }
        setCurrentOptions(nextOptions);
        if (lazyLoading) {
            setLazyLoading(false);
            return;
        }
        handleChangeActiveOption(nextOption);
    }, [
        lazyLoading,
        currentOptions,
        activeOption,
        getFirstNavigableOption,
        getNavigableOptions,
        getFormattedOption,
        handleChangeActiveOption
    ]);
    (0, _react.useEffect)(()=>{
        if (autoSelection !== AutoSelection.None && !loading && children && (0, _react.Children).count(children) > 0) resetActiveOption();
    }, [
        children,
        autoSelection,
        activeOption,
        loading,
        resetActiveOption
    ]);
    (0, _react.useEffect)(()=>{
        if (listboxRef.current) scrollableRef.current = listboxRef.current.closest((0, _sharedJs.scrollable).selector);
    }, []);
    (0, _react.useEffect)(()=>{
        if (enableKeyboardControl && !keyboardEventsEnabled) enableKeyboardEvents();
    }, [
        enableKeyboardControl,
        keyboardEventsEnabled,
        enableKeyboardEvents
    ]);
    const onOptionSelect = (0, _react.useCallback)((option)=>{
        handleChangeActiveOption(option);
        if (onOptionSelected) onOptionSelected();
        if (onSelect) onSelect(option.value);
    }, [
        handleChangeActiveOption,
        onSelect,
        onOptionSelected
    ]);
    const getNextIndex = (0, _react.useCallback)((currentIndex, lastIndex, direction)=>{
        let nextIndex;
        if (direction === "down") {
            if (currentIndex === lastIndex) nextIndex = willLoadMoreOptions ? currentIndex + 1 : 0;
            else nextIndex = currentIndex + 1;
        } else nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
        return nextIndex;
    }, [
        willLoadMoreOptions
    ]);
    const getNextValidOption = (0, _react.useCallback)(async (key)=>{
        const lastIndex = currentOptions.length - 1;
        let currentIndex = (activeOption === null || activeOption === void 0 ? void 0 : activeOption.index) || 0;
        let nextIndex = 0;
        let element = activeOption === null || activeOption === void 0 ? void 0 : activeOption.element;
        let totalOptions = -1;
        if (!activeOption && autoSelection === AutoSelection.None) {
            const nextOptions = getNavigableOptions();
            const nextActiveOption = getFirstNavigableOption(nextOptions);
            setCurrentOptions(nextOptions);
            return {
                element: nextActiveOption === null || nextActiveOption === void 0 ? void 0 : nextActiveOption.element,
                nextIndex: (nextActiveOption === null || nextActiveOption === void 0 ? void 0 : nextActiveOption.index) || 0
            };
        }
        while(totalOptions++ < lastIndex){
            var _element;
            nextIndex = getNextIndex(currentIndex, lastIndex, key);
            element = currentOptions[nextIndex];
            const triggerLazyLoad = nextIndex >= lastIndex;
            const isDisabled = ((_element = element) === null || _element === void 0 ? void 0 : _element.getAttribute("aria-disabled")) === "true";
            if (triggerLazyLoad && willLoadMoreOptions) await handleKeyToBottom();
            if (isDisabled) {
                currentIndex = nextIndex;
                element = undefined;
                continue;
            }
            break;
        }
        return {
            element,
            nextIndex
        };
    }, [
        autoSelection,
        currentOptions,
        activeOption,
        willLoadMoreOptions,
        getNextIndex,
        handleKeyToBottom,
        getFirstNavigableOption,
        getNavigableOptions
    ]);
    const handleArrow = (0, _react.useCallback)(async (type, event)=>{
        event.preventDefault();
        const { element, nextIndex } = await getNextValidOption(type);
        if (!element) return;
        const nextOption = getFormattedOption(element, nextIndex);
        handleChangeActiveOption(nextOption);
    }, [
        getFormattedOption,
        getNextValidOption,
        handleChangeActiveOption
    ]);
    const handleDownArrow = (0, _react.useCallback)((event)=>{
        handleArrow("down", event);
    }, [
        handleArrow
    ]);
    const handleUpArrow = (0, _react.useCallback)((event)=>{
        handleArrow("up", event);
    }, [
        handleArrow
    ]);
    const handleEnter = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (activeOption) onOptionSelect(activeOption);
    }, [
        activeOption,
        onOptionSelect
    ]);
    const handleFocus = (0, _react.useCallback)(()=>{
        if (enableKeyboardControl) return;
        enableKeyboardEvents();
    }, [
        enableKeyboardControl,
        enableKeyboardEvents
    ]);
    const handleBlur = (0, _react.useCallback)((event)=>{
        event.stopPropagation();
        if (keyboardEventsEnabled) {
            const nextActiveOption = getFirstNavigableOption(currentOptions);
            if (nextActiveOption) {
                const { element, index } = nextActiveOption;
                const nextOption = getFormattedOption(element, index);
                handleChangeActiveOption(nextOption);
            }
        }
        if (enableKeyboardControl) return;
        disableKeyboardEvents();
    }, [
        enableKeyboardControl,
        currentOptions,
        keyboardEventsEnabled,
        disableKeyboardEvents,
        getFirstNavigableOption,
        getFormattedOption,
        handleChangeActiveOption
    ]);
    const listeners = keyboardEventsEnabled || textFieldFocused ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyEvent: "keydown",
        keyCode: (0, _typesJs.Key).DownArrow,
        handler: handleDownArrow
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyEvent: "keydown",
        keyCode: (0, _typesJs.Key).UpArrow,
        handler: handleUpArrow
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyEvent: "keydown",
        keyCode: (0, _typesJs.Key).Enter,
        handler: handleEnter
    })) : null;
    const listboxContext = (0, _react.useMemo)(()=>({
            onOptionSelect,
            setLoading
        }), [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, listeners, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-live": "polite"
    }, loading ? loading : null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.ListboxContext).Provider, {
        value: listboxContext
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.WithinListboxContext).Provider, {
        value: true
    }, children ? /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        tabIndex: 0,
        role: "listbox",
        className: (0, _listboxScssJsDefault.default).Listbox,
        "aria-label": inCombobox ? undefined : accessibilityLabel,
        "aria-labelledby": textFieldLabelId,
        "aria-busy": Boolean(loading),
        "aria-activedescendant": activeOption && activeOption.domId,
        id: listId,
        onFocus: inCombobox ? undefined : handleFocus,
        onBlur: inCombobox ? undefined : handleBlur,
        ref: listboxRef
    }, children) : null)));
}
Listbox.Option = (0, _optionJs.Option);
Listbox.TextOption = (0, _textOptionJs.TextOption);
Listbox.Loading = (0, _loadingJs.Loading);
Listbox.Section = (0, _sectionJs.Section);
Listbox.Header = (0, _headerJs.Header);
Listbox.Action = (0, _actionJs.Action);

},{"react":"cOWTg","../../utilities/debounce.js":"bvJet","../../utilities/use-toggle.js":"2kpDL","../../types.js":"6NE7w","../shared.js":"lFbIK","./Listbox.scss.js":"eCIra","../../utilities/combobox/hooks.js":"4BDUc","../../utilities/listbox/utilities.js":"awoLu","../../utilities/listbox/context.js":"gt98u","./components/TextOption/TextOption.js":"bpqCU","./components/Loading/Loading.js":"cFHqF","./components/Section/Section.js":"rayd1","./components/Header/Header.js":"aMphR","./components/Action/Action.js":"lPtJ5","../../utilities/unique-id/hooks.js":"2JfcO","../KeypressListener/KeypressListener.js":"1eFmF","../Text/Text.js":"l8Av9","./components/Option/Option.js":"h2VMv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eCIra":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Listbox": "Polaris-Listbox"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4BDUc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComboboxListbox", ()=>useComboboxListbox);
parcelHelpers.export(exports, "useComboboxTextField", ()=>useComboboxTextField);
var _react = require("react");
var _contextJs = require("./context.js");
function useComboboxTextField() {
    const context = (0, _react.useContext)((0, _contextJs.ComboboxTextFieldContext));
    if (!context) throw new Error("No Combobox was provided. Your component must be wrapped in a <Combobox> component.");
    return context;
}
function useComboboxListbox() {
    const context = (0, _react.useContext)((0, _contextJs.ComboboxListboxContext));
    return context;
}

},{"react":"cOWTg","./context.js":"bt3uj","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bt3uj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxListboxContext", ()=>ComboboxListboxContext);
parcelHelpers.export(exports, "ComboboxListboxOptionContext", ()=>ComboboxListboxOptionContext);
parcelHelpers.export(exports, "ComboboxTextFieldContext", ()=>ComboboxTextFieldContext);
var _react = require("react");
const ComboboxTextFieldContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const ComboboxListboxContext = /*#__PURE__*/ (0, _react.createContext)({});
const ComboboxListboxOptionContext = /*#__PURE__*/ (0, _react.createContext)({});

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"awoLu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrollOptionIntoView", ()=>scrollOptionIntoView);
function scrollOptionIntoView(option, scrollable) {
    const listTop = scrollable.scrollTop;
    const listBottom = listTop + scrollable.clientHeight;
    const { offsetHeight: optionHeight } = option;
    const { offsetTop: optionTop } = option;
    const optionBottom = optionTop + optionHeight;
    const isVisible = optionTop > listTop && optionBottom < listBottom;
    if (!isVisible) {
        let top = 0;
        if (optionBottom > listBottom) top = optionBottom + optionHeight * 0.85 - listBottom;
        else if (optionTop < listTop) top = optionTop - optionHeight * 0.15 - listTop;
        requestAnimationFrame(()=>{
            scrollable.scrollBy({
                top,
                behavior: "auto"
            });
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gt98u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionContext", ()=>ActionContext);
parcelHelpers.export(exports, "ListboxContext", ()=>ListboxContext);
parcelHelpers.export(exports, "WithinListboxContext", ()=>WithinListboxContext);
var _react = require("react");
const ListboxContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
const WithinListboxContext = /*#__PURE__*/ (0, _react.createContext)(false);
const ActionContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bpqCU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextOption", ()=>TextOption);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _contextJs = require("../../../../utilities/combobox/context.js");
var _contextJs1 = require("../../../../utilities/listbox/context.js");
var _textOptionScssJs = require("./TextOption.scss.js");
var _textOptionScssJsDefault = parcelHelpers.interopDefault(_textOptionScssJs);
var _checkboxJs = require("../../../Checkbox/Checkbox.js");
const TextOption = /*#__PURE__*/ (0, _react.memo)(function TextOption({ children, selected, disabled }) {
    const { allowMultiple } = (0, _react.useContext)((0, _contextJs.ComboboxListboxOptionContext));
    const isAction = (0, _react.useContext)((0, _contextJs1.ActionContext));
    const textOptionClassName = (0, _cssJs.classNames)((0, _textOptionScssJsDefault.default).TextOption, selected && !allowMultiple && (0, _textOptionScssJsDefault.default).selected, disabled && (0, _textOptionScssJsDefault.default).disabled, allowMultiple && (0, _textOptionScssJsDefault.default).allowMultiple, isAction && (0, _textOptionScssJsDefault.default).isAction);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: textOptionClassName
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textOptionScssJsDefault.default).Content
    }, allowMultiple && !isAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textOptionScssJsDefault.default).Checkbox
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkboxJs.Checkbox), {
        disabled: disabled,
        checked: selected,
        label: children
    })) : children));
});

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/combobox/context.js":"bt3uj","../../../../utilities/listbox/context.js":"gt98u","./TextOption.scss.js":"fytXX","../../../Checkbox/Checkbox.js":"1FKW4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fytXX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "TextOption": "Polaris-Listbox-TextOption",
    "allowMultiple": "Polaris-Listbox-TextOption--allowMultiple",
    "isAction": "Polaris-Listbox-TextOption--isAction",
    "selected": "Polaris-Listbox-TextOption--selected",
    "disabled": "Polaris-Listbox-TextOption--disabled",
    "Content": "Polaris-Listbox-TextOption__Content",
    "Checkbox": "Polaris-Listbox-TextOption__Checkbox"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1FKW4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _useToggleJs = require("../../utilities/use-toggle.js");
var _contextJs = require("../../utilities/listbox/context.js");
var _checkboxScssJs = require("./Checkbox.scss.js");
var _checkboxScssJsDefault = parcelHelpers.interopDefault(_checkboxScssJs);
var _choiceJs = require("../Choice/Choice.js");
var _inlineErrorJs = require("../InlineError/InlineError.js");
var _hooksJs = require("../../utilities/unique-id/hooks.js");
var _iconJs = require("../Icon/Icon.js");
const Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(function Checkbox({ ariaControls, ariaDescribedBy: ariaDescribedByProp, label, labelHidden, checked = false, helpText, disabled, id: idProp, name, value, error, onChange, onFocus, onBlur }, ref) {
    const inputNode = (0, _react.useRef)(null);
    const id = (0, _hooksJs.useUniqueId)("Checkbox", idProp);
    const { value: mouseOver, setTrue: handleMouseOver, setFalse: handleMouseOut } = (0, _useToggleJs.useToggle)(false);
    const isWithinListbox = (0, _react.useContext)((0, _contextJs.WithinListboxContext));
    (0, _react.useImperativeHandle)(ref, ()=>({
            focus: ()=>{
                if (inputNode.current) inputNode.current.focus();
            }
        }));
    const handleBlur = ()=>{
        onBlur && onBlur();
    };
    const handleOnClick = ()=>{
        if (onChange == null || inputNode.current == null || disabled) return;
        onChange(inputNode.current.checked, id);
        inputNode.current.focus();
    };
    const describedBy = [];
    if (error && typeof error !== "boolean") describedBy.push((0, _inlineErrorJs.errorTextID)(id));
    if (helpText) describedBy.push((0, _choiceJs.helpTextID)(id));
    if (ariaDescribedByProp) describedBy.push(ariaDescribedByProp);
    const ariaDescribedBy = describedBy.length ? describedBy.join(" ") : undefined;
    const wrapperClassName = (0, _cssJs.classNames)((0, _checkboxScssJsDefault.default).Checkbox, error && (0, _checkboxScssJsDefault.default).error);
    const backdropClassName = (0, _cssJs.classNames)((0, _checkboxScssJsDefault.default).Backdrop, mouseOver && (0, _checkboxScssJsDefault.default).hover);
    const isIndeterminate = checked === "indeterminate";
    const isChecked = !isIndeterminate && Boolean(checked);
    const indeterminateAttributes = isIndeterminate ? {
        indeterminate: "true",
        "aria-checked": "mixed"
    } : {
        "aria-checked": isChecked
    };
    const iconSource = isIndeterminate ? (0, _polarisIcons.MinusMinor) : (0, _polarisIcons.TickSmallMinor);
    const inputClassName = (0, _cssJs.classNames)((0, _checkboxScssJsDefault.default).Input, isIndeterminate && (0, _checkboxScssJsDefault.default)["Input-indeterminate"]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _choiceJs.Choice), {
        id: id,
        label: label,
        labelHidden: labelHidden,
        helpText: helpText,
        error: error,
        disabled: disabled,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: wrapperClassName
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", Object.assign({
        ref: inputNode,
        id: id,
        name: name,
        value: value,
        type: "checkbox",
        checked: isChecked,
        disabled: disabled,
        className: inputClassName,
        onBlur: handleBlur,
        onChange: noop,
        onClick: handleOnClick,
        onFocus: onFocus,
        "aria-invalid": error != null,
        "aria-controls": ariaControls,
        "aria-describedby": ariaDescribedBy,
        role: isWithinListbox ? "presentation" : "checkbox"
    }, indeterminateAttributes)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: backdropClassName,
        onClick: stopPropagation,
        onKeyUp: stopPropagation
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _checkboxScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: iconSource
    }))));
});
function noop() {}
function stopPropagation(event) {
    event.stopPropagation();
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","../../utilities/use-toggle.js":"2kpDL","../../utilities/listbox/context.js":"gt98u","./Checkbox.scss.js":"jgY1Y","../Choice/Choice.js":"87upD","../InlineError/InlineError.js":"50FAH","../../utilities/unique-id/hooks.js":"2JfcO","../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jgY1Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Checkbox": "Polaris-Checkbox",
    "Input": "Polaris-Checkbox__Input",
    "Backdrop": "Polaris-Checkbox__Backdrop",
    "Input-indeterminate": "Polaris-Checkbox__Input--indeterminate",
    "Icon": "Polaris-Checkbox__Icon",
    "hover": "Polaris-Checkbox--hover",
    "error": "Polaris-Checkbox--error"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"87upD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Choice", ()=>Choice);
parcelHelpers.export(exports, "helpTextID", ()=>helpTextID);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _choiceScssJs = require("./Choice.scss.js");
var _choiceScssJsDefault = parcelHelpers.interopDefault(_choiceScssJs);
var _textJs = require("../Text/Text.js");
var _inlineErrorJs = require("../InlineError/InlineError.js");
function Choice({ id, label, disabled, error, children, labelHidden, helpText, onClick, onMouseOut, onMouseOver }) {
    const className = (0, _cssJs.classNames)((0, _choiceScssJsDefault.default).Choice, labelHidden && (0, _choiceScssJsDefault.default).labelHidden, disabled && (0, _choiceScssJsDefault.default).disabled);
    const labelMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: className,
        htmlFor: id,
        onClick: onClick,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _choiceScssJsDefault.default).Control
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _choiceScssJsDefault.default).Label
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, label)));
    const helpTextMarkup = helpText ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _choiceScssJsDefault.default).HelpText,
        id: helpTextID(id)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        color: "subdued"
    }, helpText)) : null;
    const errorMarkup = error && typeof error !== "boolean" && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _choiceScssJsDefault.default).Error
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inlineErrorJs.InlineError), {
        message: error,
        fieldID: id
    }));
    const descriptionMarkup = helpTextMarkup || errorMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _choiceScssJsDefault.default).Descriptions
    }, errorMarkup, helpTextMarkup) : null;
    return descriptionMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, labelMarkup, descriptionMarkup) : labelMarkup;
}
function helpTextID(id) {
    return `${id}HelpText`;
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Choice.scss.js":"9vKBP","../Text/Text.js":"l8Av9","../InlineError/InlineError.js":"50FAH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9vKBP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Choice": "Polaris-Choice",
    "labelHidden": "Polaris-Choice--labelHidden",
    "Label": "Polaris-Choice__Label",
    "Control": "Polaris-Choice__Control",
    "disabled": "Polaris-Choice--disabled",
    "Descriptions": "Polaris-Choice__Descriptions",
    "HelpText": "Polaris-Choice__HelpText"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"50FAH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineError", ()=>InlineError);
parcelHelpers.export(exports, "errorTextID", ()=>errorTextID);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _inlineErrorScssJs = require("./InlineError.scss.js");
var _inlineErrorScssJsDefault = parcelHelpers.interopDefault(_inlineErrorScssJs);
var _iconJs = require("../Icon/Icon.js");
function InlineError({ message, fieldID }) {
    if (!message) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: errorTextID(fieldID),
        className: (0, _inlineErrorScssJsDefault.default).InlineError
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _inlineErrorScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.DiamondAlertMinor)
    })), message);
}
function errorTextID(id) {
    return `${id}Error`;
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","./InlineError.scss.js":"4s8yM","../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4s8yM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "InlineError": "Polaris-InlineError",
    "Icon": "Polaris-InlineError__Icon"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cFHqF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Loading", ()=>Loading);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loadingScssJs = require("./Loading.scss.js");
var _loadingScssJsDefault = parcelHelpers.interopDefault(_loadingScssJs);
var _hooksJs = require("../../../../utilities/listbox/hooks.js");
var _spinnerJs = require("../../../Spinner/Spinner.js");
const Loading = /*#__PURE__*/ (0, _react.memo)(function LoadingOption({ children, accessibilityLabel: label }) {
    const { setLoading } = (0, _hooksJs.useListbox)();
    (0, _react.useEffect)(()=>{
        setLoading(label);
        return ()=>{
            setLoading(undefined);
        };
    }, [
        label,
        setLoading
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: (0, _loadingScssJsDefault.default).ListItem,
        role: "presentation"
    }, children ? children : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _loadingScssJsDefault.default).Loading
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerJs.Spinner), {
        size: "small",
        accessibilityLabel: label
    })));
});

},{"react":"cOWTg","./Loading.scss.js":"coENi","../../../../utilities/listbox/hooks.js":"6mIHW","../../../Spinner/Spinner.js":"43SMY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"coENi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ListItem": "Polaris-Listbox-Loading__ListItem",
    "Loading": "Polaris-Listbox-Loading"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6mIHW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useListbox", ()=>useListbox);
var _react = require("react");
var _contextJs = require("./context.js");
function useListbox() {
    const listbox = (0, _react.useContext)((0, _contextJs.ListboxContext));
    if (!listbox) throw new Error("No Listbox was provided. Listbox components must be wrapped in a Listbox");
    return listbox;
}

},{"react":"cOWTg","./context.js":"gt98u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"rayd1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _selectorsJs = require("./selectors.js");
var _contextJs = require("./context.js");
var _sectionScssJs = require("./Section.scss.js");
var _sectionScssJsDefault = parcelHelpers.interopDefault(_sectionScssJs);
var _hooksJs = require("../../../../utilities/unique-id/hooks.js");
function Section({ children, divider = true, title }) {
    const sectionId = (0, _hooksJs.useUniqueId)("ListboxSection");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.SectionContext).Provider, {
        value: sectionId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", Object.assign({
        role: "presentation"
    }, (0, _selectorsJs.listboxSectionDataSelector).props), title, /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        role: "group",
        "aria-labelledby": sectionId,
        className: (0, _cssJs.classNames)((0, _sectionScssJsDefault.default).SectionGroup, !divider && (0, _sectionScssJsDefault.default).noDivider)
    }, children)));
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./selectors.js":"5IQxd","./context.js":"8kScN","./Section.scss.js":"9AH0W","../../../../utilities/unique-id/hooks.js":"2JfcO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5IQxd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listboxSectionDataSelector", ()=>listboxSectionDataSelector);
parcelHelpers.export(exports, "listboxWithinSectionDataSelector", ()=>listboxWithinSectionDataSelector);
const listboxSectionDataSelector = {
    props: {
        "data-polaris-listbox-section-item": true
    },
    selector: "[data-polaris-listbox-section-item]"
};
const listboxWithinSectionDataSelector = {
    attribute: "data-polaris-listbox-within-section-item"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8kScN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionContext", ()=>SectionContext);
var _react = require("react");
const SectionContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9AH0W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "SectionGroup": "Polaris-Listbox-Section__SectionGroup",
    "noDivider": "Polaris-Listbox-Section--noDivider"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aMphR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooksJs = require("../Section/hooks.js");
var _boxJs = require("../../../Box/Box.js");
var _textJs = require("../../../Text/Text.js");
function Header({ children }) {
    const sectionId = (0, _hooksJs.useSection)() || "";
    const content = typeof children === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: "2",
        paddingInlineStart: "4",
        paddingBlockEnd: "2",
        paddingInlineEnd: "4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        variant: "headingXs",
        color: "subdued"
    }, children)) : children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-hidden": true,
        id: sectionId
    }, content);
}

},{"react":"cOWTg","../Section/hooks.js":"89xgE","../../../Box/Box.js":"lbjkG","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"89xgE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSection", ()=>useSection);
var _react = require("react");
var _contextJs = require("./context.js");
function useSection() {
    const context = (0, _react.useContext)((0, _contextJs.SectionContext));
    return context;
}

},{"react":"cOWTg","./context.js":"8kScN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lPtJ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _contextJs = require("../../../../utilities/listbox/context.js");
var _actionScssJs = require("./Action.scss.js");
var _actionScssJsDefault = parcelHelpers.interopDefault(_actionScssJs);
var _optionJs = require("../Option/Option.js");
var _textOptionJs = require("../TextOption/TextOption.js");
var _iconJs = require("../../../Icon/Icon.js");
function Action(props) {
    const { selected, disabled, children, icon, divider } = props;
    const iconMarkup = icon && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _actionScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        color: "subdued",
        source: icon
    }));
    const className = (0, _cssJs.classNames)((0, _actionScssJsDefault.default).Action, divider && (0, _actionScssJsDefault.default).ActionDivider);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.ActionContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _optionJs.Option), props, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textOptionJs.TextOption), {
        selected: selected,
        disabled: disabled
    }, iconMarkup, children))));
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/listbox/context.js":"gt98u","./Action.scss.js":"3gLS7","../Option/Option.js":"h2VMv","../TextOption/TextOption.js":"bpqCU","../../../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3gLS7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Action": "Polaris-Listbox-Action",
    "ActionDivider": "Polaris-Listbox-Action__ActionDivider",
    "Icon": "Polaris-Listbox-Action__Icon"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h2VMv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Option", ()=>Option);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _contextJs = require("../../../../utilities/listbox/context.js");
var _optionScssJs = require("./Option.scss.js");
var _optionScssJsDefault = parcelHelpers.interopDefault(_optionScssJs);
var _hooksJs = require("../../../../utilities/listbox/hooks.js");
var _contextJs1 = require("../../../../utilities/autocomplete/context.js");
var _hooksJs1 = require("../Section/hooks.js");
var _selectorsJs = require("../Section/selectors.js");
var _textOptionJs = require("../TextOption/TextOption.js");
var _hooksJs2 = require("../../../../utilities/unique-id/hooks.js");
var _unstyledLinkJs = require("../../../UnstyledLink/UnstyledLink.js");
const Option = /*#__PURE__*/ (0, _react.memo)(function Option({ value, children, selected, disabled = false, accessibilityLabel, divider }) {
    const { onOptionSelect } = (0, _hooksJs.useListbox)();
    const isAction = (0, _react.useContext)((0, _contextJs.ActionContext));
    const { role, url, external, onAction, destructive } = (0, _react.useContext)((0, _contextJs1.MappedActionContext));
    const listItemRef = (0, _react.useRef)(null);
    const domId = (0, _hooksJs2.useUniqueId)("ListboxOption");
    const sectionId = (0, _hooksJs1.useSection)();
    const isWithinSection = Boolean(sectionId);
    const handleOptionSelect = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        onAction && onAction();
        if (listItemRef.current && !onAction) onOptionSelect({
            domId,
            value,
            element: listItemRef.current,
            disabled
        });
    }, [
        domId,
        onOptionSelect,
        value,
        disabled,
        onAction
    ]); // prevents lost of focus on Textfield
    const handleMouseDown = (event)=>{
        event.preventDefault();
    };
    const content = typeof children === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textOptionJs.TextOption), {
        selected: selected,
        disabled: disabled
    }, children) : children;
    const sectionAttributes = {
        [(0, _selectorsJs.listboxWithinSectionDataSelector).attribute]: isWithinSection
    };
    const legacyRoleSupport = role || "option";
    const contentMarkup = url ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
        url: url,
        external: external
    }, content) : content;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", Object.assign({}, sectionAttributes, {
        "data-listbox-option": true,
        "data-listbox-option-action": isAction,
        "data-listbox-option-value": value,
        "data-listbox-option-destructive": destructive,
        "data-within-section": isWithinSection,
        className: (0, _cssJs.classNames)((0, _optionScssJsDefault.default).Option, divider && (0, _optionScssJsDefault.default).divider),
        id: domId,
        ref: listItemRef,
        tabIndex: -1,
        role: legacyRoleSupport,
        "aria-label": accessibilityLabel,
        "aria-selected": selected,
        "aria-disabled": disabled,
        onClick: disabled ? undefined : handleOptionSelect,
        onKeyDown: disabled ? undefined : handleOptionSelect,
        onMouseDown: handleMouseDown
    }), contentMarkup);
});

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/listbox/context.js":"gt98u","./Option.scss.js":"fvpA7","../../../../utilities/listbox/hooks.js":"6mIHW","../../../../utilities/autocomplete/context.js":"7rsIk","../Section/hooks.js":"89xgE","../Section/selectors.js":"5IQxd","../TextOption/TextOption.js":"bpqCU","../../../../utilities/unique-id/hooks.js":"2JfcO","../../../UnstyledLink/UnstyledLink.js":"4o3DP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fvpA7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Option": "Polaris-Listbox-Option",
    "divider": "Polaris-Listbox-Option--divider"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7rsIk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MappedActionContext", ()=>MappedActionContext);
var _react = require("react");
const MappedActionContext = /*#__PURE__*/ (0, _react.createContext)({});

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g7Upk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Combobox", ()=>Combobox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _comboboxScssJs = require("./Combobox.scss.js");
var _comboboxScssJsDefault = parcelHelpers.interopDefault(_comboboxScssJs);
var _contextJs = require("../../utilities/combobox/context.js");
var _textFieldJs = require("./components/TextField/TextField.js");
var _popoverJs = require("../Popover/Popover.js");
function Combobox({ activator, allowMultiple, children, preferredPosition = "below", willLoadMoreOptions, height, onScrolledToBottom, onClose }) {
    const [popoverActive, setPopoverActive] = (0, _react.useState)(false);
    const [activeOptionId, setActiveOptionId] = (0, _react.useState)();
    const [textFieldLabelId, setTextFieldLabelId] = (0, _react.useState)();
    const [listboxId, setListboxId] = (0, _react.useState)();
    const [textFieldFocused, setTextFieldFocused] = (0, _react.useState)(false);
    const shouldOpen = Boolean(!popoverActive && (0, _react.Children).count(children) > 0);
    const ref = (0, _react.useRef)(null);
    const handleClose = (0, _react.useCallback)(()=>{
        setPopoverActive(false);
        onClose === null || onClose === void 0 || onClose();
        setActiveOptionId(undefined);
    }, [
        onClose
    ]);
    const handleOpen = (0, _react.useCallback)(()=>{
        setPopoverActive(true);
        setActiveOptionId(undefined);
    }, []);
    const onOptionSelected = (0, _react.useCallback)(()=>{
        var _ref$current;
        if (!allowMultiple) {
            handleClose();
            setActiveOptionId(undefined);
            return;
        }
        (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.forceUpdatePosition();
    }, [
        allowMultiple,
        handleClose
    ]);
    const handleFocus = (0, _react.useCallback)(()=>{
        if (shouldOpen) handleOpen();
    }, [
        shouldOpen,
        handleOpen
    ]);
    const handleChange = (0, _react.useCallback)(()=>{
        if (shouldOpen) handleOpen();
    }, [
        shouldOpen,
        handleOpen
    ]);
    const handleBlur = (0, _react.useCallback)(()=>{
        if (popoverActive) handleClose();
    }, [
        popoverActive,
        handleClose
    ]);
    const textFieldContextValue = (0, _react.useMemo)(()=>({
            activeOptionId,
            expanded: popoverActive,
            listboxId,
            setTextFieldFocused,
            setTextFieldLabelId,
            onTextFieldFocus: handleFocus,
            onTextFieldChange: handleChange,
            onTextFieldBlur: handleBlur
        }), [
        activeOptionId,
        popoverActive,
        listboxId,
        setTextFieldFocused,
        setTextFieldLabelId,
        handleFocus,
        handleChange,
        handleBlur
    ]);
    const listboxOptionContextValue = (0, _react.useMemo)(()=>({
            allowMultiple
        }), [
        allowMultiple
    ]);
    const listboxContextValue = (0, _react.useMemo)(()=>({
            listboxId,
            textFieldLabelId,
            textFieldFocused,
            willLoadMoreOptions,
            onOptionSelected,
            setActiveOptionId,
            setListboxId,
            onKeyToBottom: onScrolledToBottom
        }), [
        listboxId,
        textFieldLabelId,
        textFieldFocused,
        willLoadMoreOptions,
        onOptionSelected,
        setActiveOptionId,
        setListboxId,
        onScrolledToBottom
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
        ref: ref,
        active: popoverActive,
        activator: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.ComboboxTextFieldContext).Provider, {
            value: textFieldContextValue
        }, activator),
        autofocusTarget: "none",
        preventFocusOnClose: true,
        fullWidth: true,
        preferInputActivator: false,
        preferredPosition: preferredPosition,
        onClose: handleClose
    }, (0, _react.Children).count(children) > 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover).Pane, {
        onScrolledToBottom: onScrolledToBottom,
        height: height
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.ComboboxListboxContext).Provider, {
        value: listboxContextValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.ComboboxListboxOptionContext).Provider, {
        value: listboxOptionContextValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _comboboxScssJsDefault.default).Listbox
    }, children)))) : null);
}
Combobox.TextField = (0, _textFieldJs.TextField);

},{"react":"cOWTg","./Combobox.scss.js":"tQjTM","../../utilities/combobox/context.js":"bt3uj","./components/TextField/TextField.js":"bERkQ","../Popover/Popover.js":"cE1F7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"tQjTM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Listbox": "Polaris-Combobox__Listbox"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bERkQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", ()=>TextField);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooksJs = require("../../../../utilities/combobox/hooks.js");
var _hooksJs1 = require("../../../../utilities/unique-id/hooks.js");
var _labelJs = require("../../../Label/Label.js");
var _textFieldJs = require("../../../TextField/TextField.js");
function TextField({ value, id: idProp, type = "text", ariaAutocomplete = "list", onFocus, onBlur, onChange, ...rest }) {
    const comboboxTextFieldContext = (0, _hooksJs.useComboboxTextField)();
    const { activeOptionId, listboxId, expanded, setTextFieldFocused, setTextFieldLabelId, onTextFieldFocus, onTextFieldChange, onTextFieldBlur } = comboboxTextFieldContext;
    const uniqueId = (0, _hooksJs1.useUniqueId)("ComboboxTextField");
    const textFieldId = (0, _react.useMemo)(()=>idProp || uniqueId, [
        uniqueId,
        idProp
    ]);
    const labelId = (0, _react.useMemo)(()=>(0, _labelJs.labelID)(idProp || uniqueId), [
        uniqueId,
        idProp
    ]);
    (0, _react.useEffect)(()=>{
        if (setTextFieldLabelId) setTextFieldLabelId(labelId);
    }, [
        labelId,
        setTextFieldLabelId
    ]);
    const handleFocus = (0, _react.useCallback)((event)=>{
        if (onFocus) onFocus(event);
        if (onTextFieldFocus) onTextFieldFocus();
        if (setTextFieldFocused) setTextFieldFocused(true);
    }, [
        onFocus,
        onTextFieldFocus,
        setTextFieldFocused
    ]);
    const handleBlur = (0, _react.useCallback)((event)=>{
        if (onBlur) onBlur(event);
        if (onTextFieldBlur) onTextFieldBlur();
        if (setTextFieldFocused) setTextFieldFocused(false);
    }, [
        onBlur,
        onTextFieldBlur,
        setTextFieldFocused
    ]);
    const handleChange = (0, _react.useCallback)((value, id)=>{
        if (onChange) onChange(value, id);
        if (onTextFieldChange) onTextFieldChange(value);
    }, [
        onChange,
        onTextFieldChange
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textFieldJs.TextField), Object.assign({}, rest, {
        value: value,
        id: textFieldId,
        type: type,
        ariaAutocomplete: ariaAutocomplete,
        "aria-haspopup": "listbox",
        ariaActiveDescendant: activeOptionId,
        ariaControls: listboxId,
        role: "combobox",
        ariaExpanded: expanded,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onChange: handleChange
    }));
}

},{"react":"cOWTg","../../../../utilities/combobox/hooks.js":"4BDUc","../../../../utilities/unique-id/hooks.js":"2JfcO","../../../Label/Label.js":"3Lqh1","../../../TextField/TextField.js":"5K1ky","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3Lqh1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "labelID", ()=>labelID);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _labelScssJs = require("./Label.scss.js");
var _labelScssJsDefault = parcelHelpers.interopDefault(_labelScssJs);
function labelID(id) {
    return `${id}Label`;
}
function Label({ children, id, hidden, requiredIndicator }) {
    const className = (0, _cssJs.classNames)((0, _labelScssJsDefault.default).Label, hidden && (0, _labelScssJsDefault.default).hidden);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        id: labelID(id),
        htmlFor: id,
        className: (0, _cssJs.classNames)((0, _labelScssJsDefault.default).Text, requiredIndicator && (0, _labelScssJsDefault.default).RequiredIndicator)
    }, children));
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Label.scss.js":"bzhpR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bzhpR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Label": "Polaris-Label",
    "hidden": "Polaris-Label--hidden",
    "Text": "Polaris-Label__Text",
    "RequiredIndicator": "Polaris-Label__RequiredIndicator"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5K1ky":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", ()=>TextField);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _useIsAfterInitialMountJs = require("../../utilities/use-is-after-initial-mount.js");
var _typesJs = require("../../types.js");
var _useEventListenerJs = require("../../utilities/use-event-listener.js");
var _textFieldScssJs = require("./TextField.scss.js");
var _textFieldScssJsDefault = parcelHelpers.interopDefault(_textFieldScssJs);
var _spinnerJs = require("./components/Spinner/Spinner.js");
var _labelledJs = require("../Labelled/Labelled.js");
var _connectedJs = require("../Connected/Connected.js");
var _resizerJs = require("./components/Resizer/Resizer.js");
var _labelJs = require("../Label/Label.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../utilities/unique-id/hooks.js");
var _textJs = require("../Text/Text.js");
var _iconJs = require("../Icon/Icon.js");
function TextField({ prefix, suffix, verticalContent, placeholder, value = "", helpText, label, labelAction, labelHidden, disabled, clearButton, readOnly, autoFocus, focused, multiline, error, connectedRight, connectedLeft, type = "text", name, id: idProp, role, step, largeStep, autoComplete, max, maxLength, maxHeight, min, minLength, pattern, inputMode, spellCheck, ariaOwns, ariaControls, ariaExpanded, ariaActiveDescendant, ariaAutocomplete, showCharacterCount, align, requiredIndicator, monospaced, selectTextOnFocus, suggestion, onClearButtonClick, onChange, onSpinnerChange, onFocus, onBlur, borderless }) {
    const i18n = (0, _hooksJs.useI18n)();
    const [height, setHeight] = (0, _react.useState)(null);
    const [focus, setFocus] = (0, _react.useState)(Boolean(focused));
    const isAfterInitial = (0, _useIsAfterInitialMountJs.useIsAfterInitialMount)();
    const id = (0, _hooksJs1.useUniqueId)("TextField", idProp);
    const inputRef = (0, _react.useRef)(null);
    const textAreaRef = (0, _react.useRef)(null);
    const prefixRef = (0, _react.useRef)(null);
    const suffixRef = (0, _react.useRef)(null);
    const verticalContentRef = (0, _react.useRef)(null);
    const buttonPressTimer = (0, _react.useRef)();
    const spinnerRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const input = multiline ? textAreaRef.current : inputRef.current;
        if (!input || focused === undefined) return;
        focused ? input.focus() : input.blur();
    }, [
        focused,
        verticalContent,
        multiline
    ]);
    (0, _react.useEffect)(()=>{
        const input = inputRef.current;
        const isSupportedInputType = type === "text" || type === "tel" || type === "search" || type === "url" || type === "password";
        if (!input || !isSupportedInputType || !suggestion) return;
        input.setSelectionRange(value.length, suggestion.length);
    }, [
        focus,
        value,
        type,
        suggestion
    ]);
    const normalizedValue = suggestion ? suggestion : value;
    const normalizedStep = step != null ? step : 1;
    const normalizedMax = max != null ? max : Infinity;
    const normalizedMin = min != null ? min : -Infinity;
    const className = (0, _cssJs.classNames)((0, _textFieldScssJsDefault.default).TextField, Boolean(normalizedValue) && (0, _textFieldScssJsDefault.default).hasValue, disabled && (0, _textFieldScssJsDefault.default).disabled, readOnly && (0, _textFieldScssJsDefault.default).readOnly, error && (0, _textFieldScssJsDefault.default).error, multiline && (0, _textFieldScssJsDefault.default).multiline, focus && (0, _textFieldScssJsDefault.default).focus, borderless && (0, _textFieldScssJsDefault.default).borderless);
    const inputType = type === "currency" ? "text" : type;
    const isNumericType = type === "number" || type === "integer";
    const prefixMarkup = prefix ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textFieldScssJsDefault.default).Prefix,
        id: `${id}-Prefix`,
        ref: prefixRef
    }, prefix) : null;
    const suffixMarkup = suffix ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textFieldScssJsDefault.default).Suffix,
        id: `${id}-Suffix`,
        ref: suffixRef
    }, suffix) : null;
    let characterCountMarkup = null;
    if (showCharacterCount) {
        const characterCount = normalizedValue.length;
        const characterCountLabel = maxLength ? i18n.translate("Polaris.TextField.characterCountWithMaxLength", {
            count: characterCount,
            limit: maxLength
        }) : i18n.translate("Polaris.TextField.characterCount", {
            count: characterCount
        });
        const characterCountClassName = (0, _cssJs.classNames)((0, _textFieldScssJsDefault.default).CharacterCount, multiline && (0, _textFieldScssJsDefault.default).AlignFieldBottom);
        const characterCountText = !maxLength ? characterCount : `${characterCount}/${maxLength}`;
        characterCountMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            id: `${id}-CharacterCounter`,
            className: characterCountClassName,
            "aria-label": characterCountLabel,
            "aria-live": focus ? "polite" : "off",
            "aria-atomic": "true",
            onClick: handleClickChild
        }, characterCountText);
    }
    const clearButtonVisible = normalizedValue !== "";
    const clearButtonMarkup = clearButton && clearButtonVisible ? /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: (0, _textFieldScssJsDefault.default).ClearButton,
        onClick: handleClearButtonPress,
        disabled: disabled
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, i18n.translate("Polaris.Common.clear")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.CircleCancelMinor),
        color: "base"
    })) : null;
    const handleNumberChange = (0, _react.useCallback)((steps, stepAmount = normalizedStep)=>{
        if (onChange == null && onSpinnerChange == null) return;
         // Returns the length of decimal places in a number
        const dpl = (num)=>(num.toString().split(".")[1] || []).length;
        const numericValue = value ? parseFloat(value) : 0;
        if (isNaN(numericValue)) return;
         // Making sure the new value has the same length of decimal places as the
        // step / value has.
        const decimalPlaces = type === "integer" ? 0 : Math.max(dpl(numericValue), dpl(stepAmount));
        const newValue = Math.min(Number(normalizedMax), Math.max(numericValue + steps * stepAmount, Number(normalizedMin)));
        if (onSpinnerChange != null) onSpinnerChange(String(newValue.toFixed(decimalPlaces)), id);
        else if (onChange != null) onChange(String(newValue.toFixed(decimalPlaces)), id);
    }, [
        id,
        normalizedMax,
        normalizedMin,
        onChange,
        onSpinnerChange,
        normalizedStep,
        type,
        value
    ]);
    const handleButtonRelease = (0, _react.useCallback)(()=>{
        clearTimeout(buttonPressTimer.current);
    }, []);
    const handleButtonPress = (0, _react.useCallback)((onChange)=>{
        const minInterval = 50;
        const decrementBy = 10;
        let interval = 200;
        const onChangeInterval = ()=>{
            if (interval > minInterval) interval -= decrementBy;
            onChange(0);
            buttonPressTimer.current = window.setTimeout(onChangeInterval, interval);
        };
        buttonPressTimer.current = window.setTimeout(onChangeInterval, interval);
        document.addEventListener("mouseup", handleButtonRelease, {
            once: true
        });
    }, [
        handleButtonRelease
    ]);
    const spinnerMarkup = isNumericType && step !== 0 && !disabled && !readOnly ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerJs.Spinner), {
        onClick: handleClickChild,
        onChange: handleNumberChange,
        onMouseDown: handleButtonPress,
        onMouseUp: handleButtonRelease,
        ref: spinnerRef,
        onBlur: handleOnBlur
    }) : null;
    const style = multiline && height ? {
        height,
        maxHeight
    } : null;
    const handleExpandingResize = (0, _react.useCallback)((height)=>{
        setHeight(height);
    }, []);
    const resizer = multiline && isAfterInitial ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _resizerJs.Resizer), {
        contents: normalizedValue || placeholder,
        currentHeight: height,
        minimumLines: typeof multiline === "number" ? multiline : 1,
        onHeightChange: handleExpandingResize
    }) : null;
    const describedBy = [];
    if (error) describedBy.push(`${id}Error`);
    if (helpText) describedBy.push((0, _labelledJs.helpTextID)(id));
    if (showCharacterCount) describedBy.push(`${id}-CharacterCounter`);
    const labelledBy = [];
    if (prefix) labelledBy.push(`${id}-Prefix`);
    if (suffix) labelledBy.push(`${id}-Suffix`);
    if (verticalContent) labelledBy.push(`${id}-VerticalContent`);
    labelledBy.unshift((0, _labelJs.labelID)(id));
    const inputClassName = (0, _cssJs.classNames)((0, _textFieldScssJsDefault.default).Input, align && (0, _textFieldScssJsDefault.default)[(0, _cssJs.variationName)("Input-align", align)], suffix && (0, _textFieldScssJsDefault.default)["Input-suffixed"], clearButton && (0, _textFieldScssJsDefault.default)["Input-hasClearButton"], monospaced && (0, _textFieldScssJsDefault.default).monospaced, suggestion && (0, _textFieldScssJsDefault.default).suggestion);
    const handleOnFocus = (event)=>{
        setFocus(true);
        if (selectTextOnFocus && !suggestion) {
            const input = multiline ? textAreaRef.current : inputRef.current;
            input === null || input === void 0 || input.select();
        }
        if (onFocus) onFocus(event);
    };
    (0, _useEventListenerJs.useEventListener)("wheel", handleOnWheel, inputRef);
    function handleOnWheel(event) {
        if (document.activeElement === event.target && isNumericType) event.stopPropagation();
    }
    const input = /*#__PURE__*/ (0, _react.createElement)(multiline ? "textarea" : "input", {
        name,
        id,
        disabled,
        readOnly,
        role,
        autoFocus,
        value: normalizedValue,
        placeholder,
        style,
        autoComplete,
        className: inputClassName,
        ref: multiline ? textAreaRef : inputRef,
        min,
        max,
        step,
        minLength,
        maxLength,
        spellCheck,
        pattern,
        inputMode,
        type: inputType,
        rows: getRows(multiline),
        "aria-describedby": describedBy.length ? describedBy.join(" ") : undefined,
        "aria-labelledby": labelledBy.join(" "),
        "aria-invalid": Boolean(error),
        "aria-owns": ariaOwns,
        "aria-activedescendant": ariaActiveDescendant,
        "aria-autocomplete": ariaAutocomplete,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-required": requiredIndicator,
        ...normalizeAriaMultiline(multiline),
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        onClick: handleClickChild,
        onKeyPress: handleKeyPress,
        onKeyDown: handleKeyDown,
        onChange: !suggestion ? handleChange : undefined,
        onInput: suggestion ? handleChange : undefined
    });
    const inputWithVerticalContentMarkup = verticalContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textFieldScssJsDefault.default).VerticalContent,
        id: `${id}-VerticalContent`,
        ref: verticalContentRef,
        onClick: handleClickChild
    }, verticalContent, input) : null;
    const inputMarkup = verticalContent ? inputWithVerticalContentMarkup : input;
    const backdropMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _textFieldScssJsDefault.default).Backdrop, connectedLeft && (0, _textFieldScssJsDefault.default)["Backdrop-connectedLeft"], connectedRight && (0, _textFieldScssJsDefault.default)["Backdrop-connectedRight"])
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _labelledJs.Labelled), {
        label: label,
        id: id,
        error: error,
        action: labelAction,
        labelHidden: labelHidden,
        helpText: helpText,
        requiredIndicator: requiredIndicator
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _connectedJs.Connected), {
        left: connectedLeft,
        right: connectedRight
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        onClick: handleClick
    }, prefixMarkup, inputMarkup, suffixMarkup, characterCountMarkup, clearButtonMarkup, spinnerMarkup, backdropMarkup, resizer)));
    function handleChange(event) {
        onChange && onChange(event.currentTarget.value, id);
    }
    function handleClick(event) {
        var _inputRef$current, _inputRef$current3;
        const { target } = event; // For TextFields used with Combobox, focus needs to be set again even
        // if the TextField is already focused to trigger the logic to open the
        // Combobox activator
        const inputRefRole = inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.getAttribute("role");
        if (target === inputRef.current && inputRefRole === "combobox") {
            var _inputRef$current2;
            (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.focus();
            handleOnFocus(event);
            return;
        }
        if (isPrefixOrSuffix(target) || isVerticalContent(target) || isInput(target) || isSpinner(target) || focus) return;
        (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.focus();
    }
    function handleClickChild(event) {
        if (!isSpinner(event.target) && !isInput(event.target)) event.stopPropagation();
        if (isPrefixOrSuffix(event.target) || isVerticalContent(event.target) || isInput(event.target) || focus) return;
        setFocus(true);
    }
    function handleClearButtonPress() {
        onClearButtonClick && onClearButtonClick(id);
    }
    function handleKeyPress(event) {
        const { key, which } = event;
        const numbersSpec = /[\d.,eE+-]$/;
        const integerSpec = /[\deE+-]$/;
        if (!isNumericType || which === (0, _typesJs.Key).Enter || type === "number" && numbersSpec.test(key) || type === "integer" && integerSpec.test(key)) return;
        event.preventDefault();
    }
    function handleKeyDown(event) {
        if (!isNumericType) return;
        const { key, which } = event;
        if ((which === (0, _typesJs.Key).Home || key === "Home") && min !== undefined) {
            if (onSpinnerChange != null) onSpinnerChange(String(min), id);
            else if (onChange != null) onChange(String(min), id);
        }
        if ((which === (0, _typesJs.Key).End || key === "End") && max !== undefined) {
            if (onSpinnerChange != null) onSpinnerChange(String(max), id);
            else if (onChange != null) onChange(String(max), id);
        }
        if ((which === (0, _typesJs.Key).PageUp || key === "PageUp") && largeStep !== undefined) handleNumberChange(1, largeStep);
        if ((which === (0, _typesJs.Key).PageDown || key === "PageDown") && largeStep !== undefined) handleNumberChange(-1, largeStep);
    }
    function handleOnBlur(event) {
        setFocus(false);
        if (onBlur) onBlur(event);
    }
    function isInput(target) {
        return target instanceof HTMLElement && inputRef.current && (inputRef.current.contains(target) || inputRef.current.contains(document.activeElement));
    }
    function isPrefixOrSuffix(target) {
        return target instanceof Element && (prefixRef.current && prefixRef.current.contains(target) || suffixRef.current && suffixRef.current.contains(target));
    }
    function isSpinner(target) {
        return target instanceof Element && spinnerRef.current && spinnerRef.current.contains(target);
    }
    function isVerticalContent(target) {
        return target instanceof Element && verticalContentRef.current && (verticalContentRef.current.contains(target) || verticalContentRef.current.contains(document.activeElement));
    }
}
function getRows(multiline) {
    if (!multiline) return undefined;
    return typeof multiline === "number" ? multiline : 1;
}
function normalizeAriaMultiline(multiline) {
    if (!multiline) return undefined;
    return Boolean(multiline) || typeof multiline === "number" && multiline > 0 ? {
        "aria-multiline": true
    } : undefined;
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","../../utilities/use-is-after-initial-mount.js":"aJ8qM","../../types.js":"6NE7w","../../utilities/use-event-listener.js":"1MHbT","./TextField.scss.js":"6uph9","./components/Spinner/Spinner.js":"bq0hv","../Labelled/Labelled.js":"bvXVq","../Connected/Connected.js":"c5E6C","./components/Resizer/Resizer.js":"4IZWo","../Label/Label.js":"3Lqh1","../../utilities/i18n/hooks.js":"hhMhA","../../utilities/unique-id/hooks.js":"2JfcO","../Text/Text.js":"l8Av9","../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6uph9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "TextField": "Polaris-TextField",
    "ClearButton": "Polaris-TextField__ClearButton",
    "multiline": "Polaris-TextField--multiline",
    "Input": "Polaris-TextField__Input",
    "hasValue": "Polaris-TextField--hasValue",
    "focus": "Polaris-TextField--focus",
    "VerticalContent": "Polaris-TextField__VerticalContent",
    "Backdrop": "Polaris-TextField__Backdrop",
    "error": "Polaris-TextField--error",
    "readOnly": "Polaris-TextField--readOnly",
    "disabled": "Polaris-TextField--disabled",
    "Prefix": "Polaris-TextField__Prefix",
    "suggestion": "Polaris-TextField--suggestion",
    "borderless": "Polaris-TextField--borderless",
    "Input-hasClearButton": "Polaris-TextField__Input--hasClearButton",
    "Input-suffixed": "Polaris-TextField__Input--suffixed",
    "Input-alignRight": "Polaris-TextField__Input--alignRight",
    "Input-alignLeft": "Polaris-TextField__Input--alignLeft",
    "Input-alignCenter": "Polaris-TextField__Input--alignCenter",
    "Suffix": "Polaris-TextField__Suffix",
    "CharacterCount": "Polaris-TextField__CharacterCount",
    "AlignFieldBottom": "Polaris-TextField__AlignFieldBottom",
    "Spinner": "Polaris-TextField__Spinner",
    "SpinnerIcon": "Polaris-TextField__SpinnerIcon",
    "Resizer": "Polaris-TextField__Resizer",
    "DummyInput": "Polaris-TextField__DummyInput",
    "Segment": "Polaris-TextField__Segment",
    "monospaced": "Polaris-TextField--monospaced"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bq0hv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Spinner", ()=>Spinner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _textFieldScssJs = require("../../TextField.scss.js");
var _textFieldScssJsDefault = parcelHelpers.interopDefault(_textFieldScssJs);
var _iconJs = require("../../../Icon/Icon.js");
const Spinner = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function Spinner({ onChange, onClick, onMouseDown, onMouseUp, onBlur }, ref) {
    function handleStep(step) {
        return ()=>onChange(step);
    }
    function handleMouseDown(onChange) {
        return (event)=>{
            if (event.button !== 0) return;
            onMouseDown(onChange);
        };
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textFieldScssJsDefault.default).Spinner,
        onClick: onClick,
        "aria-hidden": true,
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        className: (0, _textFieldScssJsDefault.default).Segment,
        tabIndex: -1,
        onClick: handleStep(1),
        onMouseDown: handleMouseDown(handleStep(1)),
        onMouseUp: onMouseUp,
        onBlur: onBlur
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textFieldScssJsDefault.default).SpinnerIcon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.CaretUpMinor)
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "button",
        className: (0, _textFieldScssJsDefault.default).Segment,
        tabIndex: -1,
        onClick: handleStep(-1),
        onMouseDown: handleMouseDown(handleStep(-1)),
        onMouseUp: onMouseUp,
        onBlur: onBlur
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _textFieldScssJsDefault.default).SpinnerIcon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.CaretDownMinor)
    }))));
});

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../TextField.scss.js":"6uph9","../../../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bvXVq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "labelID", ()=>(0, _labelJs.labelID));
parcelHelpers.export(exports, "Labelled", ()=>Labelled);
parcelHelpers.export(exports, "helpTextID", ()=>helpTextID);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _labelledScssJs = require("./Labelled.scss.js");
var _labelledScssJsDefault = parcelHelpers.interopDefault(_labelledScssJs);
var _inlineErrorJs = require("../InlineError/InlineError.js");
var _labelJs = require("../Label/Label.js");
var _utilsJs = require("../Button/utils.js");
var _textJs = require("../Text/Text.js");
function Labelled({ id, label, error, action, helpText, children, labelHidden, requiredIndicator, ...rest }) {
    const className = (0, _cssJs.classNames)(labelHidden && (0, _labelledScssJsDefault.default).hidden);
    const actionMarkup = action ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _labelledScssJsDefault.default).Action
    }, (0, _utilsJs.buttonFrom)(action, {
        plain: true
    })) : null;
    const helpTextMarkup = helpText ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _labelledScssJsDefault.default).HelpText,
        id: helpTextID(id)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        color: "subdued",
        breakWord: true
    }, helpText)) : null;
    const errorMarkup = error && typeof error !== "boolean" && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _labelledScssJsDefault.default).Error
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inlineErrorJs.InlineError), {
        message: error,
        fieldID: id
    }));
    const labelMarkup = label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _labelledScssJsDefault.default).LabelWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _labelJs.Label), Object.assign({
        id: id,
        requiredIndicator: requiredIndicator
    }, rest, {
        hidden: false
    }), label), actionMarkup) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, labelMarkup, children, errorMarkup, helpTextMarkup);
}
function helpTextID(id) {
    return `${id}HelpText`;
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Labelled.scss.js":"jFZQ2","../InlineError/InlineError.js":"50FAH","../Label/Label.js":"3Lqh1","../Button/utils.js":"drbMl","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jFZQ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "hidden": "Polaris-Labelled--hidden",
    "LabelWrapper": "Polaris-Labelled__LabelWrapper",
    "HelpText": "Polaris-Labelled__HelpText",
    "Error": "Polaris-Labelled__Error",
    "Action": "Polaris-Labelled__Action"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"drbMl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buttonFrom", ()=>buttonFrom);
parcelHelpers.export(exports, "buttonsFrom", ()=>buttonsFrom);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonJs = require("./Button.js");
function buttonsFrom(actions, overrides = {}) {
    if (Array.isArray(actions)) return actions.map((action, index)=>buttonFrom(action, overrides, index));
    else {
        const action = actions;
        return buttonFrom(action, overrides);
    }
}
function buttonFrom({ content, onAction, ...action }, overrides, key) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), Object.assign({
        key: key,
        onClick: onAction
    }, action, overrides), content);
}

},{"react":"cOWTg","./Button.js":"6Szv4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c5E6C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Connected", ()=>Connected);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _connectedScssJs = require("./Connected.scss.js");
var _connectedScssJsDefault = parcelHelpers.interopDefault(_connectedScssJs);
var _itemJs = require("./components/Item/Item.js");
function Connected({ children, left, right }) {
    const leftConnectionMarkup = left ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), {
        position: "left"
    }, left) : null;
    const rightConnectionMarkup = right ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), {
        position: "right"
    }, right) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _connectedScssJsDefault.default).Connected
    }, leftConnectionMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), {
        position: "primary"
    }, children), rightConnectionMarkup);
}

},{"react":"cOWTg","./Connected.scss.js":"gW1Pm","./components/Item/Item.js":"i0iPd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gW1Pm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Connected": "Polaris-Connected",
    "Item": "Polaris-Connected__Item",
    "Item-primary": "Polaris-Connected__Item--primary",
    "Item-focused": "Polaris-Connected__Item--focused"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i0iPd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _useToggleJs = require("../../../../utilities/use-toggle.js");
var _connectedScssJs = require("../../Connected.scss.js");
var _connectedScssJsDefault = parcelHelpers.interopDefault(_connectedScssJs);
function Item({ children, position }) {
    const { value: focused, setTrue: forceTrueFocused, setFalse: forceFalseFocused } = (0, _useToggleJs.useToggle)(false);
    const className = (0, _cssJs.classNames)((0, _connectedScssJsDefault.default).Item, focused && (0, _connectedScssJsDefault.default)["Item-focused"], position === "primary" ? (0, _connectedScssJsDefault.default)["Item-primary"] : (0, _connectedScssJsDefault.default)["Item-connection"]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        onBlur: forceFalseFocused,
        onFocus: forceTrueFocused,
        className: className
    }, children);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/use-toggle.js":"2kpDL","../../Connected.scss.js":"gW1Pm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4IZWo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resizer", ()=>Resizer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsomorphicLayoutEffectJs = require("../../../../utilities/use-isomorphic-layout-effect.js");
var _textFieldScssJs = require("../../TextField.scss.js");
var _textFieldScssJsDefault = parcelHelpers.interopDefault(_textFieldScssJs);
var _eventListenerJs = require("../../../EventListener/EventListener.js");
function Resizer({ contents, currentHeight: currentHeightProp = null, minimumLines, onHeightChange }) {
    const contentNode = (0, _react.useRef)(null);
    const minimumLinesNode = (0, _react.useRef)(null);
    const animationFrame = (0, _react.useRef)();
    const currentHeight = (0, _react.useRef)(currentHeightProp);
    if (currentHeightProp !== currentHeight.current) currentHeight.current = currentHeightProp;
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (animationFrame.current) cancelAnimationFrame(animationFrame.current);
        };
    }, []);
    const minimumLinesMarkup = minimumLines ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: minimumLinesNode,
        className: (0, _textFieldScssJsDefault.default).DummyInput,
        dangerouslySetInnerHTML: {
            __html: getContentsForMinimumLines(minimumLines)
        }
    }) : null;
    const handleHeightCheck = (0, _react.useCallback)(()=>{
        if (animationFrame.current) cancelAnimationFrame(animationFrame.current);
        animationFrame.current = requestAnimationFrame(()=>{
            if (!contentNode.current || !minimumLinesNode.current) return;
            const newHeight = Math.max(contentNode.current.offsetHeight, minimumLinesNode.current.offsetHeight);
            if (newHeight !== currentHeight.current) onHeightChange(newHeight);
        });
    }, [
        onHeightChange
    ]);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        handleHeightCheck();
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-hidden": true,
        className: (0, _textFieldScssJsDefault.default).Resizer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
        event: "resize",
        handler: handleHeightCheck
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: contentNode,
        className: (0, _textFieldScssJsDefault.default).DummyInput,
        dangerouslySetInnerHTML: {
            __html: getFinalContents(contents)
        }
    }), minimumLinesMarkup);
}
const ENTITIES_TO_REPLACE = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\n": "<br>",
    "\r": ""
};
const REPLACE_REGEX = new RegExp(`[${Object.keys(ENTITIES_TO_REPLACE).join()}]`, "g");
function replaceEntity(entity) {
    return ENTITIES_TO_REPLACE[entity];
}
function getContentsForMinimumLines(minimumLines) {
    let content = "";
    for(let line = 0; line < minimumLines; line++)content += "<br>";
    return content;
}
function getFinalContents(contents) {
    return contents ? `${contents.replace(REPLACE_REGEX, replaceEntity)}<br>` : "<br>";
}

},{"react":"cOWTg","../../../../utilities/use-isomorphic-layout-effect.js":"2th17","../../TextField.scss.js":"6uph9","../../../EventListener/EventListener.js":"jV8kW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kWhoG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MappedAction", ()=>MappedAction);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _mappedActionScssJs = require("./MappedAction.scss.js");
var _mappedActionScssJsDefault = parcelHelpers.interopDefault(_mappedActionScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _iconJs = require("../../../Icon/Icon.js");
var _badgeJs = require("../../../Badge/Badge.js");
var _textJs = require("../../../Text/Text.js");
var _contextJs = require("../../../../utilities/autocomplete/context.js");
var _listboxJs = require("../../../Listbox/Listbox.js");
function MappedAction({ active, content, disabled, icon, image, prefix, suffix, ellipsis, role, url, external, onAction, destructive, badge, helpText, wrapOverflow = false }) {
    const i18n = (0, _hooksJs.useI18n)();
    let prefixMarkup = null;
    const contentOverflowStyle = wrapOverflow ? (0, _mappedActionScssJsDefault.default).ContentWrap : undefined;
    if (prefix) prefixMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _mappedActionScssJsDefault.default).Prefix
    }, prefix);
    else if (icon) prefixMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _mappedActionScssJsDefault.default).Prefix
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: icon
    }));
    else if (image) prefixMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "presentation",
        className: (0, _mappedActionScssJsDefault.default).Prefix,
        style: {
            backgroundImage: `url(${image}`
        }
    });
    const badgeMarkup = badge && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _mappedActionScssJsDefault.default).Suffix
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badgeJs.Badge), {
        status: badge.status
    }, badge.content));
    const suffixMarkup = suffix && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _mappedActionScssJsDefault.default).Suffix
    }, suffix);
    const contentText = ellipsis && content ? i18n.translate("Polaris.Autocomplete.ellipsis", {
        content
    }) : content;
    const contentMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _mappedActionScssJsDefault.default).Text
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: contentOverflowStyle
    }, contentText), helpText ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        color: "subdued",
        as: "span"
    }, helpText) : null);
    const context = (0, _react.useMemo)(()=>({
            role,
            url,
            external,
            onAction,
            destructive
        }), [
        role,
        url,
        external,
        onAction,
        destructive
    ]);
    const actionClassNames = (0, _cssJs.classNames)((0, _mappedActionScssJsDefault.default).Action, disabled && (0, _mappedActionScssJsDefault.default).disabled, destructive && (0, _mappedActionScssJsDefault.default).destructive, active && (0, _mappedActionScssJsDefault.default).selected);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.MappedActionContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _mappedActionScssJsDefault.default).ActionContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listboxJs.Listbox).Action, {
        selected: active,
        disabled: disabled,
        value: content || ""
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: actionClassNames
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _mappedActionScssJsDefault.default).Content
    }, prefixMarkup, contentMarkup, badgeMarkup, suffixMarkup)))));
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./MappedAction.scss.js":"jLVOT","../../../../utilities/i18n/hooks.js":"hhMhA","../../../Icon/Icon.js":"6HPny","../../../Badge/Badge.js":"8ckUl","../../../Text/Text.js":"l8Av9","../../../../utilities/autocomplete/context.js":"7rsIk","../../../Listbox/Listbox.js":"1WNFN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jLVOT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ActionContainer": "Polaris-Autocomplete-MappedAction__ActionContainer",
    "Action": "Polaris-Autocomplete-MappedAction__Action",
    "destructive": "Polaris-Autocomplete-MappedAction--destructive",
    "selected": "Polaris-Autocomplete-MappedAction--selected",
    "disabled": "Polaris-Autocomplete-MappedAction--disabled",
    "Prefix": "Polaris-Autocomplete-MappedAction__Prefix",
    "Suffix": "Polaris-Autocomplete-MappedAction__Suffix",
    "Content": "Polaris-Autocomplete-MappedAction__Content",
    "Text": "Polaris-Autocomplete-MappedAction__Text",
    "ContentWrap": "Polaris-Autocomplete-MappedAction__ContentWrap"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"foVF7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Avatar", ()=>Avatar);
parcelHelpers.export(exports, "STYLE_CLASSES", ()=>STYLE_CLASSES);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _useIsAfterInitialMountJs = require("../../utilities/use-is-after-initial-mount.js");
var _avatarScssJs = require("./Avatar.scss.js");
var _avatarScssJsDefault = parcelHelpers.interopDefault(_avatarScssJs);
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _imageJs = require("../Image/Image.js");
var Status;
(function(Status) {
    Status["Pending"] = "PENDING";
    Status["Loaded"] = "LOADED";
    Status["Errored"] = "ERRORED";
})(Status || (Status = {}));
const STYLE_CLASSES = [
    "one",
    "two",
    "three",
    "four",
    "five"
];
/**
 * Computes a rudimentary hash from a string by xoring the character codes
 * of all characters
 */ function xorHash(str) {
    let hash = 0;
    for (const char of str)hash ^= char.charCodeAt(0);
    return hash;
}
function styleClass(name) {
    return name ? STYLE_CLASSES[xorHash(name) % STYLE_CLASSES.length] : STYLE_CLASSES[0];
}
function Avatar({ name, source, onError, initials, customer, size = "medium", shape = "round", accessibilityLabel }) {
    const i18n = (0, _hooksJs.useI18n)();
    const isAfterInitialMount = (0, _useIsAfterInitialMountJs.useIsAfterInitialMount)();
    const [status, setStatus] = (0, _react.useState)(Status.Pending); // If the source changes, set the status back to pending
    (0, _react.useEffect)(()=>{
        setStatus(Status.Pending);
    }, [
        source
    ]);
    const handleError = (0, _react.useCallback)(()=>{
        setStatus(Status.Errored);
        if (onError) onError();
    }, [
        onError
    ]);
    const handleLoad = (0, _react.useCallback)(()=>{
        setStatus(Status.Loaded);
    }, []);
    const hasImage = source && status !== Status.Errored;
    const nameString = name || initials;
    let label;
    if (accessibilityLabel) label = accessibilityLabel;
    else if (name) label = name;
    else if (initials) {
        const splitInitials = initials.split("").join(" ");
        label = i18n.translate("Polaris.Avatar.labelWithInitials", {
            initials: splitInitials
        });
    } else label = i18n.translate("Polaris.Avatar.label");
    const className = (0, _cssJs.classNames)((0, _avatarScssJsDefault.default).Avatar, size && (0, _avatarScssJsDefault.default)[(0, _cssJs.variationName)("size", size)], hasImage && status === Status.Loaded && (0, _avatarScssJsDefault.default).imageHasLoaded, shape && (0, _avatarScssJsDefault.default)[(0, _cssJs.variationName)("shape", shape)], !customer && !source && (0, _avatarScssJsDefault.default)[(0, _cssJs.variationName)("style", styleClass(nameString))]);
    const textClassName = (0, _cssJs.classNames)((0, _avatarScssJsDefault.default).Text, ((initials === null || initials === void 0 ? void 0 : initials.length) || 0) > 2 && (0, _avatarScssJsDefault.default).long);
    const imageClassName = (0, _cssJs.classNames)((0, _avatarScssJsDefault.default).Image, status !== Status.Loaded && (0, _avatarScssJsDefault.default).hidden);
    const imageMarkUp = source && isAfterInitialMount && status !== Status.Errored ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
        className: imageClassName,
        source: source,
        alt: "",
        role: "presentation",
        onLoad: handleLoad,
        onError: handleError
    }) : null; // Use `dominant-baseline: central` instead of `dy` when Edge supports it.
    const verticalOffset = "0.35em";
    const avatarBody = customer || !initials ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "currentColor",
        d: "M8.28 27.5A14.95 14.95 0 0120 21.8c4.76 0 8.97 2.24 11.72 5.7a14.02 14.02 0 01-8.25 5.91 14.82 14.82 0 01-6.94 0 14.02 14.02 0 01-8.25-5.9zM13.99 12.78a6.02 6.02 0 1112.03 0 6.02 6.02 0 01-12.03 0z"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("text", {
        className: textClassName,
        x: "50%",
        y: "50%",
        dy: verticalOffset,
        fill: "currentColor",
        textAnchor: "middle"
    }, initials);
    const svgMarkup = hasImage ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _avatarScssJsDefault.default).Initials
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        className: (0, _avatarScssJsDefault.default).Svg,
        viewBox: "0 0 40 40"
    }, avatarBody));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "aria-label": label,
        role: "img",
        className: className
    }, svgMarkup, imageMarkUp);
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/use-is-after-initial-mount.js":"aJ8qM","./Avatar.scss.js":"dguC6","../../utilities/i18n/hooks.js":"hhMhA","../Image/Image.js":"5iL1c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dguC6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Avatar": "Polaris-Avatar",
    "Text": "Polaris-Avatar__Text",
    "long": "Polaris-Avatar--long",
    "shapeRound": "Polaris-Avatar--shapeRound",
    "shapeSquare": "Polaris-Avatar--shapeSquare",
    "hidden": "Polaris-Avatar--hidden",
    "sizeExtraSmall": "Polaris-Avatar--sizeExtraSmall",
    "sizeSmall": "Polaris-Avatar--sizeSmall",
    "sizeMedium": "Polaris-Avatar--sizeMedium",
    "sizeLarge": "Polaris-Avatar--sizeLarge",
    "styleOne": "Polaris-Avatar--styleOne",
    "styleTwo": "Polaris-Avatar--styleTwo",
    "styleThree": "Polaris-Avatar--styleThree",
    "styleFour": "Polaris-Avatar--styleFour",
    "styleFive": "Polaris-Avatar--styleFive",
    "imageHasLoaded": "Polaris-Avatar--imageHasLoaded",
    "Image": "Polaris-Avatar__Image",
    "Initials": "Polaris-Avatar__Initials",
    "Svg": "Polaris-Avatar__Svg"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5iL1c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Image", ()=>Image);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Image({ alt, sourceSet, source, crossOrigin, onLoad, className, ...rest }) {
    const finalSourceSet = sourceSet ? sourceSet.map(({ source: subSource, descriptor })=>`${subSource} ${descriptor}`).join(",") : null;
    const handleLoad = (0, _react.useCallback)(()=>{
        if (onLoad) onLoad();
    }, [
        onLoad
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("img", Object.assign({
        alt: alt,
        src: source,
        crossOrigin: crossOrigin,
        className: className,
        onLoad: handleLoad
    }, finalSourceSet ? {
        srcSet: finalSourceSet
    } : {}, rest));
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dJt5R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Backdrop", ()=>Backdrop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _backdropScssJs = require("./Backdrop.scss.js");
var _backdropScssJsDefault = parcelHelpers.interopDefault(_backdropScssJs);
var _scrollLockJs = require("../ScrollLock/ScrollLock.js");
function Backdrop(props) {
    const { onClick, onTouchStart, belowNavigation, transparent, setClosing } = props;
    const className = (0, _cssJs.classNames)((0, _backdropScssJsDefault.default).Backdrop, belowNavigation && (0, _backdropScssJsDefault.default).belowNavigation, transparent && (0, _backdropScssJsDefault.default).transparent);
    const handleMouseDown = ()=>{
        if (setClosing) setClosing(true);
    };
    const handleClick = ()=>{
        if (setClosing) setClosing(false);
        if (onClick) onClick();
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollLockJs.ScrollLock), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        onClick: handleClick,
        onTouchStart: onTouchStart,
        onMouseDown: handleMouseDown
    }));
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Backdrop.scss.js":"mvME4","../ScrollLock/ScrollLock.js":"92GHE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"mvME4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Backdrop": "Polaris-Backdrop",
    "transparent": "Polaris-Backdrop--transparent",
    "belowNavigation": "Polaris-Backdrop--belowNavigation"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"92GHE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollLock", ()=>ScrollLock);
var _react = require("react");
var _scrollLockScssJs = require("./ScrollLock.scss.js");
var _hooksJs = require("../../utilities/scroll-lock-manager/hooks.js");
// Even though this has no args, reference ScrollLockProps so the prop explorer
// in the styleguide works without warnings about unfound props
function ScrollLock(_) {
    const scrollLockManager = (0, _hooksJs.useScrollLockManager)();
    (0, _react.useEffect)(()=>{
        scrollLockManager.registerScrollLock();
        return ()=>{
            scrollLockManager.unregisterScrollLock();
        };
    }, [
        scrollLockManager
    ]);
    return null;
}

},{"react":"cOWTg","./ScrollLock.scss.js":"efaEL","../../utilities/scroll-lock-manager/hooks.js":"i6Ymb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"efaEL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScrollLock);
var ScrollLock = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i6Ymb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollLockManager", ()=>useScrollLockManager);
var _react = require("react");
var _errorsJs = require("../errors.js");
var _contextJs = require("./context.js");
function useScrollLockManager() {
    const scrollLockManager = (0, _react.useContext)((0, _contextJs.ScrollLockManagerContext));
    if (!scrollLockManager) throw new (0, _errorsJs.MissingAppProviderError)("No ScrollLockManager was provided.");
    return scrollLockManager;
}

},{"react":"cOWTg","../errors.js":"HUtaY","./context.js":"iq0lt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kY0jw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Banner", ()=>Banner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _bannerContextJs = require("../../utilities/banner-context.js");
var _withinContentContextJs = require("../../utilities/within-content-context.js");
var _bannerScssJs = require("./Banner.scss.js");
var _bannerScssJsDefault = parcelHelpers.interopDefault(_bannerScssJs);
var _utilsJs = require("../UnstyledButton/utils.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _spinnerJs = require("../Spinner/Spinner.js");
var _boxJs = require("../Box/Box.js");
var _buttonJs = require("../Button/Button.js");
var _iconJs = require("../Icon/Icon.js");
var _textJs = require("../Text/Text.js");
var _buttonGroupJs = require("../ButtonGroup/ButtonGroup.js");
var _unstyledLinkJs = require("../UnstyledLink/UnstyledLink.js");
var _unstyledButtonJs = require("../UnstyledButton/UnstyledButton.js");
const Banner = /*#__PURE__*/ (0, _react.forwardRef)(function Banner({ icon, action, secondaryAction, title, children, status, onDismiss, stopAnnouncements, hideIcon }, bannerRef) {
    const withinContentContainer = (0, _react.useContext)((0, _withinContentContextJs.WithinContentContext));
    const i18n = (0, _hooksJs.useI18n)();
    const { wrapperRef, handleKeyUp, handleBlur, handleMouseUp, shouldShowFocus } = useBannerFocus(bannerRef);
    const { defaultIcon, iconColor, ariaRoleType } = useBannerAttributes(status);
    const iconName = icon || defaultIcon;
    const className = (0, _cssJs.classNames)((0, _bannerScssJsDefault.default).Banner, status && (0, _bannerScssJsDefault.default)[(0, _cssJs.variationName)("status", status)], onDismiss && (0, _bannerScssJsDefault.default).hasDismiss, shouldShowFocus && (0, _bannerScssJsDefault.default).keyFocused, withinContentContainer ? (0, _bannerScssJsDefault.default).withinContentContainer : (0, _bannerScssJsDefault.default).withinPage);
    let headingMarkup = null;
    if (title) headingMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "h2",
        variant: "headingMd",
        breakWord: true
    }, title);
    const spinnerMarkup = action !== null && action !== void 0 && action.loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        disabled: true,
        "aria-busy": true,
        className: (0, _cssJs.classNames)((0, _bannerScssJsDefault.default).Button, (0, _bannerScssJsDefault.default).loading)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _bannerScssJsDefault.default).Spinner
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerJs.Spinner), {
        size: "small",
        accessibilityLabel: i18n.translate("Polaris.Button.spinnerAccessibilityLabel")
    })), action.content) : null;
    const primaryActionMarkup = action ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingInlineEnd: "2"
    }, action.loading ? spinnerMarkup : (0, _utilsJs.unstyledButtonFrom)(action, {
        className: `${(0, _bannerScssJsDefault.default).Button} ${(0, _bannerScssJsDefault.default).PrimaryAction}`
    })) : null;
    const secondaryActionMarkup = secondaryAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement(SecondaryActionFrom, {
        action: secondaryAction
    }) : null;
    const actionMarkup = action || secondaryAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: withinContentContainer ? "3" : "4",
        paddingBlockEnd: withinContentContainer ? "1" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), null, primaryActionMarkup, secondaryActionMarkup)) : null;
    let contentMarkup = null;
    if (children || actionMarkup) contentMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: "05",
        paddingBlockEnd: "05"
    }, children, actionMarkup);
    const dismissButton = onDismiss && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _bannerScssJsDefault.default).Dismiss
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        plain: true,
        icon: (0, _polarisIcons.CancelSmallMinor),
        onClick: onDismiss,
        accessibilityLabel: "Dismiss notification"
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bannerContextJs.BannerContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        ,
        tabIndex: 0,
        ref: wrapperRef,
        role: ariaRoleType,
        "aria-live": stopAnnouncements ? "off" : "polite",
        onMouseUp: handleMouseUp,
        onKeyUp: handleKeyUp,
        onBlur: handleBlur
    }, dismissButton, hideIcon ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingInlineEnd: "4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: iconName,
        color: iconColor
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _bannerScssJsDefault.default).ContentWrapper
    }, headingMarkup, contentMarkup)));
});
function SecondaryActionFrom({ action }) {
    if (action.url) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
        className: (0, _bannerScssJsDefault.default).SecondaryAction,
        url: action.url,
        external: action.external,
        target: action.target
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _bannerScssJsDefault.default).Text
    }, action.content));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledButtonJs.UnstyledButton), {
        className: (0, _bannerScssJsDefault.default).SecondaryAction,
        onClick: action.onAction
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _bannerScssJsDefault.default).Text
    }, action.content));
}
function useBannerAttributes(status) {
    switch(status){
        case "success":
            return {
                defaultIcon: (0, _polarisIcons.CircleTickMajor),
                iconColor: "success",
                ariaRoleType: "status"
            };
        case "info":
            return {
                defaultIcon: (0, _polarisIcons.CircleInformationMajor),
                iconColor: "highlight",
                ariaRoleType: "status"
            };
        case "warning":
            return {
                defaultIcon: (0, _polarisIcons.CircleAlertMajor),
                iconColor: "warning",
                ariaRoleType: "alert"
            };
        case "critical":
            return {
                defaultIcon: (0, _polarisIcons.DiamondAlertMajor),
                iconColor: "critical",
                ariaRoleType: "alert"
            };
        default:
            return {
                defaultIcon: (0, _polarisIcons.CircleInformationMajor),
                iconColor: "base",
                ariaRoleType: "status"
            };
    }
}
function useBannerFocus(bannerRef) {
    const wrapperRef = (0, _react.useRef)(null);
    const [shouldShowFocus, setShouldShowFocus] = (0, _react.useState)(false);
    (0, _react.useImperativeHandle)(bannerRef, ()=>({
            focus: ()=>{
                var _wrapperRef$current;
                (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 || _wrapperRef$current.focus();
                setShouldShowFocus(true);
            }
        }), []);
    const handleKeyUp = (event)=>{
        if (event.target === wrapperRef.current) setShouldShowFocus(true);
    };
    const handleBlur = ()=>setShouldShowFocus(false);
    const handleMouseUp = (event)=>{
        event.currentTarget.blur();
        setShouldShowFocus(false);
    };
    return {
        wrapperRef,
        handleKeyUp,
        handleBlur,
        handleMouseUp,
        shouldShowFocus
    };
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","../../utilities/banner-context.js":"bgwGz","../../utilities/within-content-context.js":"cUmFU","./Banner.scss.js":"kLAfq","../UnstyledButton/utils.js":"47HYW","../../utilities/i18n/hooks.js":"hhMhA","../Spinner/Spinner.js":"43SMY","../Box/Box.js":"lbjkG","../Button/Button.js":"6Szv4","../Icon/Icon.js":"6HPny","../Text/Text.js":"l8Av9","../ButtonGroup/ButtonGroup.js":"QiqnY","../UnstyledLink/UnstyledLink.js":"4o3DP","../UnstyledButton/UnstyledButton.js":"5Z7tL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bgwGz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BannerContext", ()=>BannerContext);
var _react = require("react");
const BannerContext = /*#__PURE__*/ (0, _react.createContext)(false);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kLAfq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Banner": "Polaris-Banner",
    "statusCritical": "Polaris-Banner--statusCritical",
    "PrimaryAction": "Polaris-Banner__PrimaryAction",
    "Button": "Polaris-Banner__Button",
    "statusWarning": "Polaris-Banner--statusWarning",
    "statusInfo": "Polaris-Banner--statusInfo",
    "statusSuccess": "Polaris-Banner--statusSuccess",
    "ContentWrapper": "Polaris-Banner__ContentWrapper",
    "withinContentContainer": "Polaris-Banner--withinContentContainer",
    "Dismiss": "Polaris-Banner__Dismiss",
    "keyFocused": "Polaris-Banner--keyFocused",
    "withinPage": "Polaris-Banner--withinPage",
    "Ribbon": "Polaris-Banner__Ribbon",
    "hasDismiss": "Polaris-Banner--hasDismiss",
    "SecondaryAction": "Polaris-Banner__SecondaryAction",
    "Text": "Polaris-Banner__Text",
    "pressed": "Polaris-Banner--pressed",
    "loading": "Polaris-Banner--loading",
    "Spinner": "Polaris-Banner__Spinner"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"47HYW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstyledButtonFrom", ()=>unstyledButtonFrom);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _unstyledButtonJs = require("./UnstyledButton.js");
function unstyledButtonFrom({ content, onAction, ...action }, overrides, key) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledButtonJs.UnstyledButton), Object.assign({
        key: key,
        onClick: onAction
    }, action, overrides), content);
}

},{"react":"cOWTg","./UnstyledButton.js":"5Z7tL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3Epca":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bleed", ()=>Bleed);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _bleedScssJs = require("./Bleed.scss.js");
var _bleedScssJsDefault = parcelHelpers.interopDefault(_bleedScssJs);
const Bleed = ({ marginInline, marginBlock, marginBlockStart, marginBlockEnd, marginInlineStart, marginInlineEnd, children })=>{
    const getNegativeMargins = (direction)=>{
        const xAxis = [
            "marginInlineStart",
            "marginInlineEnd"
        ];
        const yAxis = [
            "marginBlockStart",
            "marginBlockEnd"
        ];
        const directionValues = {
            marginBlockStart,
            marginBlockEnd,
            marginInlineStart,
            marginInlineEnd,
            marginInline,
            marginBlock
        };
        if (directionValues[direction]) return directionValues[direction];
        else if (xAxis.includes(direction) && marginInline) return directionValues.marginInline;
        else if (yAxis.includes(direction) && marginBlock) return directionValues.marginBlock;
    };
    const negativeMarginBlockStart = getNegativeMargins("marginBlockStart");
    const negativeMarginBlockEnd = getNegativeMargins("marginBlockEnd");
    const negativeMarginInlineStart = getNegativeMargins("marginInlineStart");
    const negativeMarginInlineEnd = getNegativeMargins("marginInlineEnd");
    const style = {
        ...(0, _cssJs.getResponsiveProps)("bleed", "margin-block-start", "space", negativeMarginBlockStart),
        ...(0, _cssJs.getResponsiveProps)("bleed", "margin-block-end", "space", negativeMarginBlockEnd),
        ...(0, _cssJs.getResponsiveProps)("bleed", "margin-inline-start", "space", negativeMarginInlineStart),
        ...(0, _cssJs.getResponsiveProps)("bleed", "margin-inline-end", "space", negativeMarginInlineEnd)
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _bleedScssJsDefault.default).Bleed,
        style: (0, _cssJs.sanitizeCustomProperties)(style)
    }, children);
};

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Bleed.scss.js":"bmskQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bmskQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Bleed": "Polaris-Bleed"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bUGef":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", ()=>Breadcrumbs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _focusJs = require("../../utilities/focus.js");
var _breadcrumbsScssJs = require("./Breadcrumbs.scss.js");
var _breadcrumbsScssJsDefault = parcelHelpers.interopDefault(_breadcrumbsScssJs);
var _iconJs = require("../Icon/Icon.js");
var _textJs = require("../Text/Text.js");
var _unstyledLinkJs = require("../UnstyledLink/UnstyledLink.js");
function Breadcrumbs({ breadcrumbs, backAction }) {
    const breadcrumb = backAction !== null && backAction !== void 0 ? backAction : Array.isArray(breadcrumbs) ? breadcrumbs[breadcrumbs.length - 1] : breadcrumbs;
    if (breadcrumb == null) return null;
    const { content } = breadcrumb;
    const contentMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _breadcrumbsScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.ArrowLeftMinor)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, content));
    const breadcrumbMarkup = "url" in breadcrumb ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
        key: content,
        url: breadcrumb.url,
        className: (0, _breadcrumbsScssJsDefault.default).Breadcrumb,
        onMouseUp: (0, _focusJs.handleMouseUpByBlurring),
        "aria-label": breadcrumb.accessibilityLabel
    }, contentMarkup) : /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        key: content,
        className: (0, _breadcrumbsScssJsDefault.default).Breadcrumb,
        onClick: breadcrumb.onAction,
        onMouseUp: (0, _focusJs.handleMouseUpByBlurring),
        type: "button",
        "aria-label": breadcrumb.accessibilityLabel
    }, contentMarkup);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        role: "navigation"
    }, breadcrumbMarkup);
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/focus.js":"b0pEc","./Breadcrumbs.scss.js":"atNG0","../Icon/Icon.js":"6HPny","../Text/Text.js":"l8Av9","../UnstyledLink/UnstyledLink.js":"4o3DP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"atNG0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Breadcrumb": "Polaris-Breadcrumbs__Breadcrumb",
    "Icon": "Polaris-Breadcrumbs__Icon",
    "Content": "Polaris-Breadcrumbs__Content"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hluSh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BulkActions", ()=>BulkActions);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _debounceJs = require("../../utilities/debounce.js");
var _cssJs = require("../../utilities/css.js");
var _clampJs = require("../../utilities/clamp.js");
var _bulkActionsScssJs = require("./BulkActions.scss.js");
var _bulkActionsScssJsDefault = parcelHelpers.interopDefault(_bulkActionsScssJs);
var _bulkActionMenuJs = require("./components/BulkActionMenu/BulkActionMenu.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _bulkActionButtonJs = require("./components/BulkActionButton/BulkActionButton.js");
var _popoverJs = require("../Popover/Popover.js");
var _actionListJs = require("../ActionList/ActionList.js");
var _eventListenerJs = require("../EventListener/EventListener.js");
var _horizontalStackJs = require("../HorizontalStack/HorizontalStack.js");
const MAX_PROMOTED_ACTIONS = 2;
const BUTTONS_NODE_ADDITIONAL_WIDTH = 64;
class BulkActionsInner extends (0, _react.PureComponent) {
    constructor(...args){
        super(...args);
        this.state = {
            popoverVisible: false,
            containerWidth: 0,
            measuring: true
        };
        this.containerNode = null;
        this.buttonsNode = null;
        this.moreActionsNode = null;
        this.groupNode = /*#__PURE__*/ (0, _react.createRef)();
        this.promotedActionsWidths = [];
        this.bulkActionsWidth = 0;
        this.addedMoreActionsWidthForMeasuring = 0;
        this.handleResize = (0, _debounceJs.debounce)(()=>{
            const { popoverVisible } = this.state;
            if (this.containerNode) {
                const containerWidth = this.containerNode.getBoundingClientRect().width;
                if (containerWidth > 0) this.setState({
                    containerWidth
                });
            }
            if (popoverVisible) this.setState({
                popoverVisible: false
            });
        }, 50, {
            trailing: true
        });
        this.setButtonsNode = (node)=>{
            this.buttonsNode = node;
        };
        this.setContainerNode = (node)=>{
            this.containerNode = node;
        };
        this.setMoreActionsNode = (node)=>{
            this.moreActionsNode = node;
        };
        this.togglePopover = ()=>{
            if (this.props.onMoreActionPopoverToggle) this.props.onMoreActionPopoverToggle(this.state.popoverVisible);
            this.setState(({ popoverVisible })=>({
                    popoverVisible: !popoverVisible
                }));
        };
        this.handleMeasurement = (width)=>{
            const { measuring } = this.state;
            if (measuring) this.promotedActionsWidths.push(width);
        };
    }
    numberOfPromotedActionsToRender() {
        const { promotedActions } = this.props;
        const { containerWidth, measuring } = this.state;
        if (!promotedActions) return 0;
        const containerWidthMinusAdditionalWidth = Math.max(0, containerWidth - BUTTONS_NODE_ADDITIONAL_WIDTH);
        if (containerWidthMinusAdditionalWidth >= this.bulkActionsWidth || measuring) return promotedActions.length;
        let sufficientSpace = false;
        let counter = promotedActions.length - 1;
        let totalWidth = 0;
        while(!sufficientSpace && counter >= 0){
            totalWidth += this.promotedActionsWidths[counter];
            const widthWithRemovedAction = this.bulkActionsWidth - totalWidth + this.addedMoreActionsWidthForMeasuring;
            if (containerWidthMinusAdditionalWidth >= widthWithRemovedAction) sufficientSpace = true;
            else counter--;
        }
        return (0, _clampJs.clamp)(counter, 0, promotedActions.length);
    }
    actionSections() {
        const { actions } = this.props;
        if (!actions || actions.length === 0) return;
        if (instanceOfBulkActionListSectionArray(actions)) return actions;
        if (instanceOfBulkActionArray(actions)) return [
            {
                items: actions
            }
        ];
    }
    rolledInPromotedActions() {
        const { promotedActions } = this.props;
        const numberOfPromotedActionsToRender = this.numberOfPromotedActionsToRender();
        if (!promotedActions || promotedActions.length === 0 || numberOfPromotedActionsToRender >= promotedActions.length) return [];
        const rolledInPromotedActions = promotedActions.map((action)=>{
            if (instanceOfMenuGroupDescriptor(action)) return {
                items: [
                    ...action.actions
                ]
            };
            return {
                items: [
                    action
                ]
            };
        });
        return rolledInPromotedActions.slice(numberOfPromotedActionsToRender);
    }
    componentDidMount() {
        const { actions, promotedActions } = this.props;
        if (promotedActions && !actions && this.moreActionsNode) this.addedMoreActionsWidthForMeasuring = this.moreActionsNode.getBoundingClientRect().width;
        this.bulkActionsWidth = this.buttonsNode ? this.buttonsNode.getBoundingClientRect().width - this.addedMoreActionsWidthForMeasuring : 0;
        if (this.containerNode) this.setState({
            containerWidth: this.containerNode.getBoundingClientRect().width,
            measuring: false
        });
    }
    render() {
        const { selectMode, disabled, promotedActions, i18n, isSticky, width } = this.props;
        const actionSections = this.actionSections();
        promotedActions && promotedActions.length;
        const { popoverVisible, measuring } = this.state;
        const numberOfPromotedActionsToRender = this.numberOfPromotedActionsToRender();
        const promotedActionsMarkup = promotedActions && numberOfPromotedActionsToRender > 0 ? [
            ...promotedActions
        ].slice(0, numberOfPromotedActionsToRender).map((action, index)=>{
            if (instanceOfMenuGroupDescriptor(action)) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bulkActionMenuJs.BulkActionMenu), Object.assign({
                key: index
            }, action, {
                isNewBadgeInBadgeActions: this.isNewBadgeInBadgeActions()
            }));
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bulkActionButtonJs.BulkActionButton), Object.assign({
                key: index,
                disabled: disabled
            }, action, {
                handleMeasurement: this.handleMeasurement
            }));
        }) : null;
        const rolledInPromotedActions = this.rolledInPromotedActions();
        const activatorLabel = !promotedActions || promotedActions && numberOfPromotedActionsToRender === 0 && !measuring ? i18n.translate("Polaris.ResourceList.BulkActions.actionsActivatorLabel") : i18n.translate("Polaris.ResourceList.BulkActions.moreActionsActivatorLabel");
        let combinedActions = [];
        if (actionSections && rolledInPromotedActions.length > 0) combinedActions = [
            ...rolledInPromotedActions,
            ...actionSections
        ];
        else if (actionSections) combinedActions = actionSections;
        else if (rolledInPromotedActions.length > 0) combinedActions = [
            ...rolledInPromotedActions
        ];
        const actionsPopover = actionSections || rolledInPromotedActions.length > 0 || measuring ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _bulkActionsScssJsDefault.default).Popover,
            ref: this.setMoreActionsNode
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
            active: popoverVisible,
            activator: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bulkActionButtonJs.BulkActionButton), {
                disclosure: true,
                showContentInButton: !promotedActionsMarkup,
                onAction: this.togglePopover,
                content: activatorLabel,
                disabled: disabled,
                indicator: this.isNewBadgeInBadgeActions()
            }),
            preferredAlignment: "right",
            onClose: this.togglePopover
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
            sections: combinedActions,
            onActionAnyItem: this.togglePopover
        }))) : null;
        const groupContent = promotedActionsMarkup || actionsPopover ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
            gap: "3"
        }, promotedActionsMarkup, actionsPopover) : null;
        if (!groupContent) return null;
        const group = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), {
            timeout: 100,
            in: selectMode,
            key: "group",
            nodeRef: this.groupNode
        }, (status)=>{
            const groupClassName = (0, _cssJs.classNames)((0, _bulkActionsScssJsDefault.default).Group, !isSticky && (0, _bulkActionsScssJsDefault.default)["Group-not-sticky"], !measuring && isSticky && (0, _bulkActionsScssJsDefault.default)[`Group-${status}`], measuring && (0, _bulkActionsScssJsDefault.default)["Group-measuring"]);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: groupClassName,
                ref: this.groupNode,
                style: {
                    width
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
                event: "resize",
                handler: this.handleResize
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _bulkActionsScssJsDefault.default).ButtonGroupWrapper,
                ref: this.setButtonsNode
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _bulkActionsScssJsDefault.default).ButtonGroupInner
            }, groupContent)));
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.setContainerNode
        }, group);
    }
    isNewBadgeInBadgeActions() {
        const actions = this.actionSections();
        if (!actions) return false;
        for (const action of actions)for (const item of action.items){
            var _item$badge;
            if (((_item$badge = item.badge) === null || _item$badge === void 0 ? void 0 : _item$badge.status) === "new") return true;
        }
        return false;
    }
}
function instanceOfBulkActionListSectionArray(actions) {
    const validList = actions.filter((action)=>{
        return action.items;
    });
    return actions.length === validList.length;
}
function instanceOfBulkActionArray(actions) {
    const validList = actions.filter((action)=>{
        return !action.items;
    });
    return actions.length === validList.length;
}
function instanceOfMenuGroupDescriptor(action) {
    return "title" in action;
}
function BulkActions(props) {
    const i18n = (0, _hooksJs.useI18n)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BulkActionsInner, Object.assign({}, props, {
        i18n: i18n
    }));
}

},{"react":"cOWTg","react-transition-group":"1qdFK","../../utilities/debounce.js":"bvJet","../../utilities/css.js":"lGt6N","../../utilities/clamp.js":"acbcz","./BulkActions.scss.js":"8lrzU","./components/BulkActionMenu/BulkActionMenu.js":"5BiYE","../../utilities/i18n/hooks.js":"hhMhA","./components/BulkActionButton/BulkActionButton.js":"kJXMW","../Popover/Popover.js":"cE1F7","../ActionList/ActionList.js":"kU0n2","../EventListener/EventListener.js":"jV8kW","../HorizontalStack/HorizontalStack.js":"fotqA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1qdFK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"2s8cc","./ReplaceTransition":false,"./SwitchTransition":false,"./TransitionGroup":"7Ha7Q","./Transition":"b7ufm","./config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2s8cc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ""
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"73iO2","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"hwWkd","@babel/runtime/helpers/esm/inheritsLoose":"9ThIf","prop-types":"jc0Wl","dom-helpers/addClass":"jE7c3","dom-helpers/removeClass":"3I0vh","react":"cOWTg","./Transition":"b7ufm","./utils/PropTypes":"9cYrM","./utils/reflow":"fWs8g","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jE7c3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

},{"./hasClass":"3rgaQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3rgaQ":[function(require,module,exports) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3I0vh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b7ufm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"hwWkd","@babel/runtime/helpers/esm/inheritsLoose":"9ThIf","prop-types":"jc0Wl","react":"cOWTg","react-dom":"aPjLf","./config":"732ku","./utils/PropTypes":"9cYrM","./TransitionGroupContext":"eZOaU","./utils/reflow":"fWs8g","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"732ku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9cYrM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"jc0Wl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eZOaU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fWs8g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Ha7Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"hwWkd","@babel/runtime/helpers/esm/extends":"73iO2","@babel/runtime/helpers/esm/assertThisInitialized":"9HsxM","@babel/runtime/helpers/esm/inheritsLoose":"9ThIf","prop-types":"jc0Wl","react":"cOWTg","./TransitionGroupContext":"eZOaU","./utils/ChildMapping":"7qIaH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9HsxM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7qIaH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, "appear", props),
            enter: getProp(child, "enter", props),
            exit: getProp(child, "exit", props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
    });
    return children;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"acbcz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
function clamp(number, min, max) {
    if (number < min) return min;
    if (number > max) return max;
    return number;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8lrzU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Group": "Polaris-BulkActions__Group",
    "Group-not-sticky": "Polaris-BulkActions--groupNotSticky",
    "Group-entering": "Polaris-BulkActions__Group--entering",
    "Group-exiting": "Polaris-BulkActions__Group--exiting",
    "Group-entered": "Polaris-BulkActions__Group--entered",
    "Group-exited": "Polaris-BulkActions__Group--exited",
    "Group-measuring": "Polaris-BulkActions__Group--measuring",
    "ButtonGroupWrapper": "Polaris-BulkActions__ButtonGroupWrapper",
    "BulkActionButton": "Polaris-BulkActions__BulkActionButton",
    "disabled": "Polaris-BulkActions--disabled"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5BiYE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BulkActionMenu", ()=>BulkActionMenu);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useToggleJs = require("../../../../utilities/use-toggle.js");
var _bulkActionButtonJs = require("../BulkActionButton/BulkActionButton.js");
var _popoverJs = require("../../../Popover/Popover.js");
var _actionListJs = require("../../../ActionList/ActionList.js");
function BulkActionMenu({ title, actions, isNewBadgeInBadgeActions }) {
    const { value: isVisible, toggle: toggleMenuVisibility } = (0, _useToggleJs.useToggle)(false);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
        active: isVisible,
        activator: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bulkActionButtonJs.BulkActionButton), {
            disclosure: true,
            showContentInButton: true,
            onAction: toggleMenuVisibility,
            content: title,
            indicator: isNewBadgeInBadgeActions
        }),
        onClose: toggleMenuVisibility,
        preferInputActivator: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
        items: actions,
        onActionAnyItem: toggleMenuVisibility
    })));
}

},{"react":"cOWTg","../../../../utilities/use-toggle.js":"2kpDL","../BulkActionButton/BulkActionButton.js":"kJXMW","../../../Popover/Popover.js":"cE1F7","../../../ActionList/ActionList.js":"kU0n2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kJXMW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BulkActionButton", ()=>BulkActionButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _useComponentDidMountJs = require("../../../../utilities/use-component-did-mount.js");
var _bulkActionsScssJs = require("../../BulkActions.scss.js");
var _bulkActionsScssJsDefault = parcelHelpers.interopDefault(_bulkActionsScssJs);
var _indicatorJs = require("../../../Indicator/Indicator.js");
var _tooltipJs = require("../../../Tooltip/Tooltip.js");
var _buttonJs = require("../../../Button/Button.js");
var _iconJs = require("../../../Icon/Icon.js");
function BulkActionButton({ handleMeasurement, url, external, onAction, content, disclosure, accessibilityLabel, disabled, indicator, showContentInButton }) {
    const bulkActionButton = (0, _react.useRef)(null);
    (0, _useComponentDidMountJs.useComponentDidMount)(()=>{
        if (handleMeasurement && bulkActionButton.current) {
            const width = bulkActionButton.current.getBoundingClientRect().width;
            handleMeasurement(width);
        }
    });
    const isActivatorForMoreActionsPopover = disclosure && !showContentInButton;
    const buttonContent = isActivatorForMoreActionsPopover ? undefined : content;
    const buttonMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        external: external,
        url: url,
        accessibilityLabel: isActivatorForMoreActionsPopover ? content : accessibilityLabel,
        disclosure: disclosure && showContentInButton,
        onClick: onAction,
        disabled: disabled,
        size: "slim",
        icon: isActivatorForMoreActionsPopover ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
            source: (0, _polarisIcons.HorizontalDotsMinor),
            color: "base"
        }) : undefined
    }, buttonContent);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _bulkActionsScssJsDefault.default).BulkActionButton,
        ref: bulkActionButton
    }, isActivatorForMoreActionsPopover ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
        content: content,
        preferredPosition: "above"
    }, buttonMarkup) : buttonMarkup, indicator && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _indicatorJs.Indicator), null));
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/use-component-did-mount.js":"b8lBX","../../BulkActions.scss.js":"8lrzU","../../../Indicator/Indicator.js":"1Dymx","../../../Tooltip/Tooltip.js":"k7vL7","../../../Button/Button.js":"6Szv4","../../../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1Dymx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Indicator", ()=>Indicator);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _indicatorScssJs = require("./Indicator.scss.js");
var _indicatorScssJsDefault = parcelHelpers.interopDefault(_indicatorScssJs);
function Indicator({ pulse = true }) {
    const className = (0, _cssJs.classNames)((0, _indicatorScssJsDefault.default).Indicator, pulse && (0, _indicatorScssJsDefault.default).pulseIndicator);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    });
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Indicator.scss.js":"dHpV4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dHpV4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Indicator": "Polaris-Indicator",
    "pulseIndicator": "Polaris-Indicator--pulseIndicator"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iJwHi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", ()=>Card);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _useToggleJs = require("../../utilities/use-toggle.js");
var _withinContentContextJs = require("../../utilities/within-content-context.js");
var _cardScssJs = require("./Card.scss.js");
var _cardScssJsDefault = parcelHelpers.interopDefault(_cardScssJs);
var _headerJs = require("./components/Header/Header.js");
var _sectionJs = require("./components/Section/Section.js");
var _subsectionJs = require("./components/Subsection/Subsection.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _utilsJs = require("../Button/utils.js");
var _popoverJs = require("../Popover/Popover.js");
var _buttonJs = require("../Button/Button.js");
var _actionListJs = require("../ActionList/ActionList.js");
var _buttonGroupJs = require("../ButtonGroup/ButtonGroup.js");
// TypeScript can't generate types that correctly infer the typing of
// subcomponents so explicitly state the subcomponents in the type definition.
// Letting this be implicit works in this project but fails in projects that use
// generated *.d.ts files.
/** @deprecated Use AlphaCard instead. */ const Card = function Card({ children, hideOnPrint, title, subdued, sectioned, actions, primaryFooterAction, secondaryFooterActions, secondaryFooterActionsDisclosureText, footerActionAlignment = "right" }) {
    const i18n = (0, _hooksJs.useI18n)();
    const { value: secondaryActionsPopoverOpen, toggle: toggleSecondaryActionsPopoverOpen } = (0, _useToggleJs.useToggle)(false);
    const className = (0, _cssJs.classNames)((0, _cardScssJsDefault.default).Card, subdued && (0, _cardScssJsDefault.default).subdued, hideOnPrint && (0, _cardScssJsDefault.default).hideOnPrint);
    const headerMarkup = title || actions ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headerJs.Header), {
        actions: actions,
        title: title
    }) : null;
    const content = sectioned ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionJs.Section), null, children) : children;
    const primaryFooterActionMarkup = primaryFooterAction ? (0, _utilsJs.buttonFrom)(primaryFooterAction, {
        primary: true
    }) : null;
    let secondaryFooterActionsMarkup = null;
    if (secondaryFooterActions && secondaryFooterActions.length) {
        if (secondaryFooterActions.length === 1) secondaryFooterActionsMarkup = (0, _utilsJs.buttonFrom)(secondaryFooterActions[0]);
        else secondaryFooterActionsMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
            active: secondaryActionsPopoverOpen,
            activator: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
                disclosure: true,
                onClick: toggleSecondaryActionsPopoverOpen
            }, secondaryFooterActionsDisclosureText || i18n.translate("Polaris.Common.more")),
            onClose: toggleSecondaryActionsPopoverOpen
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
            items: secondaryFooterActions
        })));
    }
    const footerMarkup = primaryFooterActionMarkup || secondaryFooterActionsMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _cardScssJsDefault.default).Footer, footerActionAlignment === "left" && (0, _cardScssJsDefault.default).LeftJustified)
    }, footerActionAlignment === "right" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), null, secondaryFooterActionsMarkup, primaryFooterActionMarkup) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), null, primaryFooterActionMarkup, secondaryFooterActionsMarkup)) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _withinContentContextJs.WithinContentContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, headerMarkup, content, footerMarkup));
}; // eslint-disable-next-line import/no-deprecated
Card.Header = (0, _headerJs.Header); // eslint-disable-next-line import/no-deprecated
Card.Section = (0, _sectionJs.Section); // eslint-disable-next-line import/no-deprecated
Card.Subsection = (0, _subsectionJs.Subsection);

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/use-toggle.js":"2kpDL","../../utilities/within-content-context.js":"cUmFU","./Card.scss.js":"11lcu","./components/Header/Header.js":"kkshE","./components/Section/Section.js":"5WI56","./components/Subsection/Subsection.js":"6DE9Q","../../utilities/i18n/hooks.js":"hhMhA","../Button/utils.js":"drbMl","../Popover/Popover.js":"cE1F7","../Button/Button.js":"6Szv4","../ActionList/ActionList.js":"kU0n2","../ButtonGroup/ButtonGroup.js":"QiqnY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"11lcu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Card": "Polaris-Card",
    "subdued": "Polaris-Card--subdued",
    "Section-hideOnPrint": "Polaris-Card__Section--hideOnPrint",
    "hideOnPrint": "Polaris-Card--hideOnPrint",
    "Header": "Polaris-Card__Header",
    "Section": "Polaris-Card__Section",
    "Section-fullWidth": "Polaris-Card__Section--fullWidth",
    "Section-flush": "Polaris-Card__Section--flush",
    "Section-subdued": "Polaris-Card__Section--subdued",
    "SectionHeader": "Polaris-Card__SectionHeader",
    "Subsection": "Polaris-Card__Subsection",
    "Footer": "Polaris-Card__Footer",
    "LeftJustified": "Polaris-Card__LeftJustified"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kkshE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cardScssJs = require("../../Card.scss.js");
var _cardScssJsDefault = parcelHelpers.interopDefault(_cardScssJs);
var _buttonGroupJs = require("../../../ButtonGroup/ButtonGroup.js");
var _utilsJs = require("../../../Button/utils.js");
var _legacyStackJs = require("../../../LegacyStack/LegacyStack.js");
var _textJs = require("../../../Text/Text.js");
/** @deprecated Use LegacyCard or AlphaCard instead. */ function Header({ children, title, actions }) {
    const actionMarkup = actions ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), null, (0, _utilsJs.buttonsFrom)(actions, {
        plain: true
    })) : null;
    const titleMarkup = /*#__PURE__*/ (0, _react.isValidElement)(title) ? title : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        variant: "headingMd",
        as: "h2"
    }, title);
    const headingMarkup = actionMarkup || children ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack), {
        alignment: "baseline"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack).Item, {
        fill: true
    }, titleMarkup), actionMarkup, children) : titleMarkup;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cardScssJsDefault.default).Header
    }, headingMarkup);
}

},{"react":"cOWTg","../../Card.scss.js":"11lcu","../../../ButtonGroup/ButtonGroup.js":"QiqnY","../../../Button/utils.js":"drbMl","../../../LegacyStack/LegacyStack.js":"5pyyM","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5pyyM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LegacyStack", ()=>LegacyStack);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _componentsJs = require("../../utilities/components.js");
var _legacyStackScssJs = require("./LegacyStack.scss.js");
var _legacyStackScssJsDefault = parcelHelpers.interopDefault(_legacyStackScssJs);
var _itemJs = require("./components/Item/Item.js");
const LegacyStack = /*#__PURE__*/ (0, _react.memo)(function Stack({ children, vertical, spacing, distribution, alignment, wrap }) {
    const className = (0, _cssJs.classNames)((0, _legacyStackScssJsDefault.default).LegacyStack, vertical && (0, _legacyStackScssJsDefault.default).vertical, spacing && (0, _legacyStackScssJsDefault.default)[(0, _cssJs.variationName)("spacing", spacing)], distribution && (0, _legacyStackScssJsDefault.default)[(0, _cssJs.variationName)("distribution", distribution)], alignment && (0, _legacyStackScssJsDefault.default)[(0, _cssJs.variationName)("alignment", alignment)], wrap === false && (0, _legacyStackScssJsDefault.default).noWrap);
    const itemMarkup = (0, _componentsJs.elementChildren)(children).map((child, index)=>{
        const props = {
            key: index
        };
        return (0, _componentsJs.wrapWithComponent)(child, (0, _itemJs.Item), props);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, itemMarkup);
});
LegacyStack.Item = (0, _itemJs.Item);

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/components.js":"6Xyqa","./LegacyStack.scss.js":"idFUu","./components/Item/Item.js":"4molL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"idFUu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "LegacyStack": "Polaris-LegacyStack",
    "Item": "Polaris-LegacyStack__Item",
    "noWrap": "Polaris-LegacyStack--noWrap",
    "spacingNone": "Polaris-LegacyStack--spacingNone",
    "spacingExtraTight": "Polaris-LegacyStack--spacingExtraTight",
    "spacingTight": "Polaris-LegacyStack--spacingTight",
    "spacingBaseTight": "Polaris-LegacyStack--spacingBaseTight",
    "spacingLoose": "Polaris-LegacyStack--spacingLoose",
    "spacingExtraLoose": "Polaris-LegacyStack--spacingExtraLoose",
    "distributionLeading": "Polaris-LegacyStack--distributionLeading",
    "distributionTrailing": "Polaris-LegacyStack--distributionTrailing",
    "distributionCenter": "Polaris-LegacyStack--distributionCenter",
    "distributionEqualSpacing": "Polaris-LegacyStack--distributionEqualSpacing",
    "distributionFill": "Polaris-LegacyStack--distributionFill",
    "distributionFillEvenly": "Polaris-LegacyStack--distributionFillEvenly",
    "alignmentLeading": "Polaris-LegacyStack--alignmentLeading",
    "alignmentTrailing": "Polaris-LegacyStack--alignmentTrailing",
    "alignmentCenter": "Polaris-LegacyStack--alignmentCenter",
    "alignmentFill": "Polaris-LegacyStack--alignmentFill",
    "alignmentBaseline": "Polaris-LegacyStack--alignmentBaseline",
    "vertical": "Polaris-LegacyStack--vertical",
    "Item-fill": "Polaris-LegacyStack__Item--fill"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4molL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _legacyStackScssJs = require("../../LegacyStack.scss.js");
var _legacyStackScssJsDefault = parcelHelpers.interopDefault(_legacyStackScssJs);
function Item({ children, fill }) {
    const className = (0, _cssJs.classNames)((0, _legacyStackScssJsDefault.default).Item, fill && (0, _legacyStackScssJsDefault.default)["Item-fill"]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, children);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../LegacyStack.scss.js":"idFUu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5WI56":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _cardScssJs = require("../../Card.scss.js");
var _cardScssJsDefault = parcelHelpers.interopDefault(_cardScssJs);
var _buttonGroupJs = require("../../../ButtonGroup/ButtonGroup.js");
var _utilsJs = require("../../../Button/utils.js");
var _legacyStackJs = require("../../../LegacyStack/LegacyStack.js");
var _textJs = require("../../../Text/Text.js");
/** @deprecated Use LegacyCard or AlphaCard instead. */ function Section({ children, title, subdued, flush, fullWidth, actions, hideOnPrint }) {
    const className = (0, _cssJs.classNames)((0, _cardScssJsDefault.default).Section, flush && (0, _cardScssJsDefault.default)["Section-flush"], subdued && (0, _cardScssJsDefault.default)["Section-subdued"], fullWidth && (0, _cardScssJsDefault.default)["Section-fullWidth"], hideOnPrint && (0, _cardScssJsDefault.default)["Section-hideOnPrint"]);
    const actionMarkup = actions ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), null, (0, _utilsJs.buttonsFrom)(actions, {
        plain: true
    })) : null;
    const titleMarkup = typeof title === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        variant: "headingSm",
        as: "h3"
    }, title) : title;
    const titleAreaMarkup = titleMarkup || actionMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cardScssJsDefault.default).SectionHeader
    }, actionMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack), {
        alignment: "baseline"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack).Item, {
        fill: true
    }, titleMarkup), actionMarkup) : titleMarkup) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, titleAreaMarkup, children);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../Card.scss.js":"11lcu","../../../ButtonGroup/ButtonGroup.js":"QiqnY","../../../Button/utils.js":"drbMl","../../../LegacyStack/LegacyStack.js":"5pyyM","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6DE9Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subsection", ()=>Subsection);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cardScssJs = require("../../Card.scss.js");
var _cardScssJsDefault = parcelHelpers.interopDefault(_cardScssJs);
/** @deprecated Use LegacyCard or AlphaCard instead. */ function Subsection({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cardScssJsDefault.default).Subsection
    }, children);
}

},{"react":"cOWTg","../../Card.scss.js":"11lcu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jZjIN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChoiceList", ()=>ChoiceList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _choiceListScssJs = require("./ChoiceList.scss.js");
var _choiceListScssJsDefault = parcelHelpers.interopDefault(_choiceListScssJs);
var _bleedJs = require("../Bleed/Bleed.js");
var _radioButtonJs = require("../RadioButton/RadioButton.js");
var _hooksJs = require("../../utilities/unique-id/hooks.js");
var _boxJs = require("../Box/Box.js");
var _inlineErrorJs = require("../InlineError/InlineError.js");
var _verticalStackJs = require("../VerticalStack/VerticalStack.js");
var _checkboxJs = require("../Checkbox/Checkbox.js");
function ChoiceList({ title, titleHidden, allowMultiple, choices, selected, onChange = noop, error, disabled = false, name: nameProp }) {
    // Type asserting to any is required for TS3.2 but can be removed when we update to 3.3
    // see https://github.com/Microsoft/TypeScript/issues/28768
    const ControlComponent = allowMultiple ? (0, _checkboxJs.Checkbox) : (0, _radioButtonJs.RadioButton);
    const name = (0, _hooksJs.useUniqueId)("ChoiceList", nameProp);
    const finalName = allowMultiple ? `${name}[]` : name;
    const titleMarkup = title ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        as: "legend",
        paddingBlockEnd: {
            xs: "5",
            md: "1"
        },
        visuallyHidden: titleHidden
    }, title) : null;
    const choicesMarkup = choices.map((choice)=>{
        const { value, id, label, helpText, disabled: choiceDisabled, describedByError } = choice;
        function handleChange(checked) {
            onChange(updateSelectedChoices(choice, checked, selected, allowMultiple), name);
        }
        const isSelected = choiceIsSelected(choice, selected);
        const renderedChildren = choice.renderChildren ? choice.renderChildren(isSelected) : null;
        const children = renderedChildren ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _choiceListScssJsDefault.default).ChoiceChildren
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            paddingBlockStart: {
                xs: "4",
                md: "0"
            }
        }, renderedChildren)) : null;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: value
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bleedJs.Bleed), {
            marginBlockEnd: helpText ? {
                xs: "1",
                md: "0"
            } : {
                xs: "0"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ControlComponent, {
            name: finalName,
            value: value,
            id: id,
            label: label,
            disabled: choiceDisabled || disabled,
            checked: choiceIsSelected(choice, selected),
            helpText: helpText,
            onChange: handleChange,
            ariaDescribedBy: error && describedByError ? (0, _inlineErrorJs.errorTextID)(finalName) : null
        }), children));
    });
    const errorMarkup = error && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: {
            xs: "0",
            md: "1"
        },
        paddingBlockEnd: "2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inlineErrorJs.InlineError), {
        message: error,
        fieldID: finalName
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
        as: "fieldset",
        gap: {
            xs: "4",
            md: "0"
        },
        "aria-invalid": error != null,
        id: finalName
    }, titleMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
        as: "ul",
        gap: {
            xs: "4",
            md: "0"
        }
    }, choicesMarkup), errorMarkup);
}
function noop() {}
function choiceIsSelected({ value }, selected) {
    return selected.includes(value);
}
function updateSelectedChoices({ value }, checked, selected, allowMultiple = false) {
    if (checked) return allowMultiple ? [
        ...selected,
        value
    ] : [
        value
    ];
    return selected.filter((selectedChoice)=>selectedChoice !== value);
}

},{"react":"cOWTg","./ChoiceList.scss.js":"Lt3sy","../Bleed/Bleed.js":"3Epca","../RadioButton/RadioButton.js":"kQXJ7","../../utilities/unique-id/hooks.js":"2JfcO","../Box/Box.js":"lbjkG","../InlineError/InlineError.js":"50FAH","../VerticalStack/VerticalStack.js":"5lUFs","../Checkbox/Checkbox.js":"1FKW4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"Lt3sy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ChoiceChildren": "Polaris-ChoiceList__ChoiceChildren"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kQXJ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioButton", ()=>RadioButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useToggleJs = require("../../utilities/use-toggle.js");
var _cssJs = require("../../utilities/css.js");
var _radioButtonScssJs = require("./RadioButton.scss.js");
var _radioButtonScssJsDefault = parcelHelpers.interopDefault(_radioButtonScssJs);
var _hooksJs = require("../../utilities/unique-id/hooks.js");
var _choiceJs = require("../Choice/Choice.js");
function RadioButton({ ariaDescribedBy: ariaDescribedByProp, label, labelHidden, helpText, checked, disabled, onChange, onFocus, onBlur, id: idProp, name: nameProp, value }) {
    const id = (0, _hooksJs.useUniqueId)("RadioButton", idProp);
    const name = nameProp || id;
    const inputNode = (0, _react.useRef)(null);
    const { value: mouseOver, setTrue: handleMouseOver, setFalse: handleMouseOut } = (0, _useToggleJs.useToggle)(false);
    const handleBlur = ()=>{
        onBlur && onBlur();
    };
    function handleChange({ currentTarget }) {
        onChange && onChange(currentTarget.checked, id);
    }
    const describedBy = [];
    if (helpText) describedBy.push((0, _choiceJs.helpTextID)(id));
    if (ariaDescribedByProp) describedBy.push(ariaDescribedByProp);
    const ariaDescribedBy = describedBy.length ? describedBy.join(" ") : undefined;
    const inputClassName = (0, _cssJs.classNames)((0, _radioButtonScssJsDefault.default).Input);
    const backdropClassName = (0, _cssJs.classNames)((0, _radioButtonScssJsDefault.default).Backdrop, mouseOver && (0, _radioButtonScssJsDefault.default).hover);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _choiceJs.Choice), {
        label: label,
        labelHidden: labelHidden,
        disabled: disabled,
        id: id,
        helpText: helpText,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _radioButtonScssJsDefault.default).RadioButton
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: id,
        name: name,
        value: value,
        type: "radio",
        checked: checked,
        disabled: disabled,
        className: inputClassName,
        onChange: handleChange,
        onFocus: onFocus,
        onBlur: handleBlur,
        "aria-describedby": ariaDescribedBy,
        ref: inputNode
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: backdropClassName
    })));
}

},{"react":"cOWTg","../../utilities/use-toggle.js":"2kpDL","../../utilities/css.js":"lGt6N","./RadioButton.scss.js":"dpyrI","../../utilities/unique-id/hooks.js":"2JfcO","../Choice/Choice.js":"87upD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dpyrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "RadioButton": "Polaris-RadioButton",
    "Input": "Polaris-RadioButton__Input",
    "Backdrop": "Polaris-RadioButton__Backdrop",
    "hover": "Polaris-RadioButton--hover"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6rL9J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Collapsible", ()=>Collapsible);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _collapsibleScssJs = require("./Collapsible.scss.js");
var _collapsibleScssJsDefault = parcelHelpers.interopDefault(_collapsibleScssJs);
function Collapsible({ id, expandOnPrint, open, transition = true, preventMeasuringOnChildrenUpdate: _preventMeasuringOnChildrenUpdate, children, onAnimationEnd }) {
    const [height, setHeight] = (0, _react.useState)(0);
    const [isOpen, setIsOpen] = (0, _react.useState)(open);
    const [animationState, setAnimationState] = (0, _react.useState)("idle");
    const collapsibleContainer = (0, _react.useRef)(null);
    const isFullyOpen = animationState === "idle" && open && isOpen;
    const isFullyClosed = animationState === "idle" && !open && !isOpen;
    const content = expandOnPrint || !isFullyClosed ? children : null;
    const wrapperClassName = (0, _cssJs.classNames)((0, _collapsibleScssJsDefault.default).Collapsible, isFullyClosed && (0, _collapsibleScssJsDefault.default).isFullyClosed, expandOnPrint && (0, _collapsibleScssJsDefault.default).expandOnPrint);
    const transitionDisabled = isTransitionDisabled(transition);
    const transitionStyles = typeof transition === "object" && {
        transitionDuration: transition.duration,
        transitionTimingFunction: transition.timingFunction
    };
    const collapsibleStyles = {
        ...transitionStyles,
        maxHeight: isFullyOpen ? "none" : `${height}px`,
        overflow: isFullyOpen ? "visible" : "hidden"
    };
    const handleCompleteAnimation = (0, _react.useCallback)(({ target })=>{
        if (target === collapsibleContainer.current) {
            setAnimationState("idle");
            setIsOpen(open);
            onAnimationEnd && onAnimationEnd();
        }
    }, [
        onAnimationEnd,
        open
    ]);
    const startAnimation = (0, _react.useCallback)(()=>{
        if (transitionDisabled) {
            setIsOpen(open);
            setAnimationState("idle");
            if (open && collapsibleContainer.current) setHeight(collapsibleContainer.current.scrollHeight);
            else setHeight(0);
        } else setAnimationState("measuring");
    }, [
        open,
        transitionDisabled
    ]);
    (0, _react.useEffect)(()=>{
        if (open !== isOpen) startAnimation();
         // startAnimation should only be fired if the open state changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open,
        isOpen
    ]);
    (0, _react.useEffect)(()=>{
        if (!open || !collapsibleContainer.current) return; // If collapsible defaults to open, set an initial height
        setHeight(collapsibleContainer.current.scrollHeight); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(()=>{
        if (!collapsibleContainer.current) return;
        switch(animationState){
            case "idle":
                break;
            case "measuring":
                setHeight(collapsibleContainer.current.scrollHeight);
                setAnimationState("animating");
                break;
            case "animating":
                setHeight(open ? collapsibleContainer.current.scrollHeight : 0);
        }
    }, [
        animationState,
        open,
        isOpen
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: id,
        style: collapsibleStyles,
        ref: collapsibleContainer,
        className: wrapperClassName,
        onTransitionEnd: handleCompleteAnimation,
        "aria-hidden": !open
    }, content);
}
const zeroDurationRegex = /^0(ms|s)$/;
function isTransitionDisabled(transitionProp) {
    if (typeof transitionProp === "boolean") return !transitionProp;
    const { duration } = transitionProp;
    if (duration && zeroDurationRegex.test(duration.trim())) return true;
    return false;
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Collapsible.scss.js":"lcAvg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lcAvg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Collapsible": "Polaris-Collapsible",
    "isFullyClosed": "Polaris-Collapsible--isFullyClosed",
    "expandOnPrint": "Polaris-Collapsible--expandOnPrint"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6vqWM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalGrid", ()=>HorizontalGrid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _horizontalGridScssJs = require("./HorizontalGrid.scss.js");
var _horizontalGridScssJsDefault = parcelHelpers.interopDefault(_horizontalGridScssJs);
function HorizontalGrid({ children, columns, gap, alignItems }) {
    const style = {
        ...(0, _cssJs.getResponsiveValue)("horizontal-grid", "grid-template-columns", formatHorizontalGrid(columns)),
        ...(0, _cssJs.getResponsiveProps)("horizontal-grid", "gap", "space", gap),
        "--pc-horizontal-grid-align-items": alignItems
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _horizontalGridScssJsDefault.default).HorizontalGrid,
        style: (0, _cssJs.sanitizeCustomProperties)(style)
    }, children);
}
function formatHorizontalGrid(columns) {
    if (typeof columns === "object" && columns !== null && !Array.isArray(columns)) return Object.fromEntries(Object.entries(columns).map(([breakpointAlias, breakpointHorizontalGrid])=>[
            breakpointAlias,
            getColumnValue(breakpointHorizontalGrid)
        ]));
    return getColumnValue(columns);
}
function getColumnValue(columns) {
    if (!columns) return undefined;
    if (typeof columns === "number" || !isNaN(Number(columns))) return `repeat(${Number(columns)}, minmax(0, 1fr))`;
    if (typeof columns === "string") return columns;
    return columns.map((column)=>{
        switch(column){
            case "oneThird":
                return "minmax(0, 1fr)";
            case "oneHalf":
                return "minmax(0, 1fr)";
            case "twoThirds":
                return "minmax(0, 2fr)";
        }
    }).join(" ");
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./HorizontalGrid.scss.js":"989ZL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"989ZL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "HorizontalGrid": "Polaris-HorizontalGrid"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iSEKt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataTable", ()=>DataTable);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _debounceJs = require("../../utilities/debounce.js");
var _cssJs = require("../../utilities/css.js");
var _sharedJs = require("../shared.js");
var _utilitiesJs = require("./utilities.js");
var _dataTableScssJs = require("./DataTable.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _cellJs = require("./components/Cell/Cell.js");
var _afterInitialMountJs = require("../AfterInitialMount/AfterInitialMount.js");
var _stickyJs = require("../Sticky/Sticky.js");
var _navigationJs = require("./components/Navigation/Navigation.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _eventListenerJs = require("../EventListener/EventListener.js");
const getRowClientHeights = (rows)=>{
    const heights = [];
    if (!rows) return heights;
    rows.forEach((row)=>{
        heights.push(row.clientHeight);
    });
    return heights;
};
class DataTableInner extends (0, _react.PureComponent) {
    constructor(...args){
        super(...args);
        this.state = {
            condensed: false,
            columnVisibilityData: [],
            isScrolledFarthestLeft: true,
            isScrolledFarthestRight: false,
            rowHovered: undefined
        };
        this.dataTable = /*#__PURE__*/ (0, _react.createRef)();
        this.scrollContainer = /*#__PURE__*/ (0, _react.createRef)();
        this.table = /*#__PURE__*/ (0, _react.createRef)();
        this.stickyTable = /*#__PURE__*/ (0, _react.createRef)();
        this.stickyNav = null;
        this.headerNav = null;
        this.tableHeadings = [];
        this.stickyHeadings = [];
        this.tableHeadingWidths = [];
        this.stickyHeaderActive = false;
        this.scrollStopTimer = null;
        this.handleResize = (0, _debounceJs.debounce)(()=>{
            const { table: { current: table }, scrollContainer: { current: scrollContainer } } = this;
            let condensed = false;
            if (table && scrollContainer) // safari sometimes incorrectly sets the scrollwidth too large by 1px
            condensed = table.scrollWidth > scrollContainer.clientWidth + 1;
            this.setState({
                condensed,
                ...this.calculateColumnVisibilityData(condensed)
            });
        });
        this.setCellRef = ({ ref, index, inStickyHeader })=>{
            if (ref == null) return;
            if (inStickyHeader) {
                this.stickyHeadings[index] = ref;
                const button = ref.querySelector("button");
                if (button == null) return;
                button.addEventListener("focus", this.handleHeaderButtonFocus);
            } else {
                this.tableHeadings[index] = ref;
                this.tableHeadingWidths[index] = ref.clientWidth;
            }
        };
        this.changeHeadingFocus = ()=>{
            const { tableHeadings, stickyHeadings, stickyNav, headerNav } = this;
            const stickyFocusedItemIndex = stickyHeadings.findIndex((item)=>{
                var _document$activeEleme;
                return item === ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.parentElement);
            });
            const tableFocusedItemIndex = tableHeadings.findIndex((item)=>{
                var _document$activeEleme2;
                return item === ((_document$activeEleme2 = document.activeElement) === null || _document$activeEleme2 === void 0 ? void 0 : _document$activeEleme2.parentElement);
            });
            const arrowsInStickyNav = stickyNav === null || stickyNav === void 0 ? void 0 : stickyNav.querySelectorAll("button");
            const arrowsInHeaderNav = headerNav === null || headerNav === void 0 ? void 0 : headerNav.querySelectorAll("button");
            let stickyFocusedNavIndex = -1;
            arrowsInStickyNav === null || arrowsInStickyNav === void 0 || arrowsInStickyNav.forEach((item, index)=>{
                if (item === document.activeElement) stickyFocusedNavIndex = index;
            });
            let headerFocusedNavIndex = -1;
            arrowsInHeaderNav === null || arrowsInHeaderNav === void 0 || arrowsInHeaderNav.forEach((item, index)=>{
                if (item === document.activeElement) headerFocusedNavIndex = index;
            });
            if (stickyFocusedItemIndex < 0 && tableFocusedItemIndex < 0 && stickyFocusedNavIndex < 0 && headerFocusedNavIndex < 0) return null;
            let button;
            if (stickyFocusedItemIndex >= 0) button = tableHeadings[stickyFocusedItemIndex].querySelector("button");
            else if (tableFocusedItemIndex >= 0) button = stickyHeadings[tableFocusedItemIndex].querySelector("button");
            if (stickyFocusedNavIndex >= 0) button = arrowsInHeaderNav === null || arrowsInHeaderNav === void 0 ? void 0 : arrowsInHeaderNav[stickyFocusedNavIndex];
            else if (headerFocusedNavIndex >= 0) button = arrowsInStickyNav === null || arrowsInStickyNav === void 0 ? void 0 : arrowsInStickyNav[headerFocusedNavIndex];
            if (button == null) return null;
            button.style.visibility = "visible";
            button.focus();
            button.style.removeProperty("visibility");
        };
        this.calculateColumnVisibilityData = (condensed)=>{
            const fixedFirstColumns = this.fixedFirstColumns();
            const { table: { current: table }, scrollContainer: { current: scrollContainer }, dataTable: { current: dataTable } } = this;
            const { stickyHeader } = this.props;
            if ((stickyHeader || condensed) && table && scrollContainer && dataTable) {
                const headerCells = table.querySelectorAll((0, _sharedJs.headerCell).selector);
                const rightMostHeader = headerCells[fixedFirstColumns - 1];
                const nthColumnWidth = fixedFirstColumns ? rightMostHeader.offsetLeft + rightMostHeader.offsetWidth : 0;
                if (headerCells.length > 0) {
                    const firstVisibleColumnIndex = headerCells.length - 1;
                    const tableLeftVisibleEdge = scrollContainer.scrollLeft + nthColumnWidth;
                    const tableRightVisibleEdge = scrollContainer.scrollLeft + dataTable.offsetWidth;
                    const tableData = {
                        firstVisibleColumnIndex,
                        tableLeftVisibleEdge,
                        tableRightVisibleEdge
                    };
                    const columnVisibilityData = [
                        ...headerCells
                    ].map((0, _utilitiesJs.measureColumn)(tableData));
                    const lastColumn = columnVisibilityData[columnVisibilityData.length - 1];
                    const isScrolledFarthestLeft = fixedFirstColumns ? tableLeftVisibleEdge === nthColumnWidth : tableLeftVisibleEdge === 0;
                    return {
                        columnVisibilityData,
                        ...(0, _utilitiesJs.getPrevAndCurrentColumns)(tableData, columnVisibilityData),
                        isScrolledFarthestLeft,
                        isScrolledFarthestRight: lastColumn.rightEdge <= tableRightVisibleEdge
                    };
                }
            }
            return {
                columnVisibilityData: [],
                previousColumn: undefined,
                currentColumn: undefined
            };
        };
        this.handleHeaderButtonFocus = (event)=>{
            var _this$state$columnVis;
            const fixedFirstColumns = this.fixedFirstColumns();
            if (this.scrollContainer.current == null || event.target == null || this.state.columnVisibilityData.length === 0) return;
            const target = event.target;
            const currentCell = target.parentNode;
            const tableScrollLeft = this.scrollContainer.current.scrollLeft;
            const tableViewableWidth = this.scrollContainer.current.offsetWidth;
            const tableRightEdge = tableScrollLeft + tableViewableWidth;
            const nthColumnWidth = this.state.columnVisibilityData.length > 0 ? (_this$state$columnVis = this.state.columnVisibilityData[fixedFirstColumns]) === null || _this$state$columnVis === void 0 ? void 0 : _this$state$columnVis.rightEdge : 0;
            const currentColumnLeftEdge = currentCell.offsetLeft;
            const currentColumnRightEdge = currentCell.offsetLeft + currentCell.offsetWidth;
            if (tableScrollLeft > currentColumnLeftEdge - nthColumnWidth) this.scrollContainer.current.scrollLeft = currentColumnLeftEdge - nthColumnWidth;
            if (currentColumnRightEdge > tableRightEdge) this.scrollContainer.current.scrollLeft = currentColumnRightEdge - tableViewableWidth;
        };
        this.stickyHeaderScrolling = ()=>{
            const { current: stickyTable } = this.stickyTable;
            const { current: scrollContainer } = this.scrollContainer;
            if (stickyTable == null || scrollContainer == null) return;
            stickyTable.scrollLeft = scrollContainer.scrollLeft;
        };
        this.scrollListener = ()=>{
            var _this$scrollContainer;
            if (this.scrollStopTimer) clearTimeout(this.scrollStopTimer);
            this.scrollStopTimer = setTimeout(()=>{
                this.setState((prevState)=>({
                        ...this.calculateColumnVisibilityData(prevState.condensed)
                    }));
            }, 100);
            this.setState({
                isScrolledFarthestLeft: ((_this$scrollContainer = this.scrollContainer.current) === null || _this$scrollContainer === void 0 ? void 0 : _this$scrollContainer.scrollLeft) === 0
            });
            if (this.props.stickyHeader && this.stickyHeaderActive) this.stickyHeaderScrolling();
        };
        this.handleHover = (row)=>()=>{
                this.setState({
                    rowHovered: row
                });
            };
        this.handleFocus = (event)=>{
            var _this$state$columnVis2;
            const fixedFirstColumns = this.fixedFirstColumns();
            if (this.scrollContainer.current == null || event.target == null) return;
            const currentCell = event.target.parentNode;
            const fixedNthColumn = this.props;
            const nthColumnWidth = fixedNthColumn ? (_this$state$columnVis2 = this.state.columnVisibilityData[fixedFirstColumns]) === null || _this$state$columnVis2 === void 0 ? void 0 : _this$state$columnVis2.rightEdge : 0;
            const currentColumnLeftEdge = currentCell.offsetLeft;
            const desiredScrollLeft = currentColumnLeftEdge - nthColumnWidth;
            if (this.scrollContainer.current.scrollLeft > desiredScrollLeft) this.scrollContainer.current.scrollLeft = desiredScrollLeft;
             // focus fixed first column if present
        };
        this.navigateTable = (direction)=>{
            var _this$state$columnVis3;
            const fixedFirstColumns = this.fixedFirstColumns();
            const { currentColumn, previousColumn } = this.state;
            const nthColumnWidth = (_this$state$columnVis3 = this.state.columnVisibilityData[fixedFirstColumns - 1]) === null || _this$state$columnVis3 === void 0 ? void 0 : _this$state$columnVis3.rightEdge;
            if (!currentColumn || !previousColumn) return;
            let prevWidths = 0;
            for(let index = 0; index < currentColumn.index; index++)prevWidths += this.state.columnVisibilityData[index].width;
            const { current: scrollContainer } = this.scrollContainer;
            const handleScroll = ()=>{
                let newScrollLeft = 0;
                if (fixedFirstColumns) newScrollLeft = direction === "right" ? prevWidths - nthColumnWidth + currentColumn.width : prevWidths - previousColumn.width - nthColumnWidth;
                else newScrollLeft = direction === "right" ? currentColumn.rightEdge : previousColumn.leftEdge;
                if (scrollContainer) {
                    scrollContainer.scrollLeft = newScrollLeft;
                    requestAnimationFrame(()=>{
                        this.setState((prevState)=>({
                                ...this.calculateColumnVisibilityData(prevState.condensed)
                            }));
                    });
                }
            };
            return handleScroll;
        };
        this.renderHeading = ({ heading, headingIndex, inFixedNthColumn, inStickyHeader })=>{
            const { sortable, truncate = false, columnContentTypes, defaultSortDirection, initialSortColumnIndex = 0, verticalAlign, firstColumnMinWidth } = this.props;
            const fixedFirstColumns = this.fixedFirstColumns();
            const { sortDirection = defaultSortDirection, sortedColumnIndex = initialSortColumnIndex, isScrolledFarthestLeft } = this.state;
            let sortableHeadingProps;
            const headingCellId = `heading-cell-${headingIndex}`;
            const stickyHeaderId = `stickyheader-${headingIndex}`;
            const id = inStickyHeader ? stickyHeaderId : headingCellId;
            if (sortable) {
                const isSortable = sortable[headingIndex];
                const isSorted = isSortable && sortedColumnIndex === headingIndex;
                const direction = isSorted ? sortDirection : "none";
                sortableHeadingProps = {
                    defaultSortDirection,
                    sorted: isSorted,
                    sortable: isSortable,
                    sortDirection: direction,
                    onSort: this.defaultOnSort(headingIndex),
                    fixedNthColumn: fixedFirstColumns,
                    inFixedNthColumn: fixedFirstColumns
                };
            }
            const stickyCellWidth = inStickyHeader ? this.tableHeadingWidths[headingIndex] : undefined;
            const fixedCellVisible = !isScrolledFarthestLeft;
            const cellProps = {
                header: true,
                stickyHeadingCell: inStickyHeader,
                content: heading,
                contentType: columnContentTypes[headingIndex],
                nthColumn: headingIndex < fixedFirstColumns,
                fixedFirstColumns,
                truncate,
                headingIndex,
                ...sortableHeadingProps,
                verticalAlign,
                handleFocus: this.handleFocus,
                stickyCellWidth,
                fixedCellVisible,
                firstColumnMinWidth
            };
            if (inFixedNthColumn && inStickyHeader) {
                var _this$state$columnVis4;
                // need two cells for fixed first column (actual cell and the overlapping one)
                // the sticky cell is second so that the index is associated with the sticky
                // cell and not the underlying one. This helps `changeHeadingFocus` to put
                // focus on the right cell when switching from sticky to non-sticky headers
                return [
                    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cellJs.Cell), Object.assign({
                        key: id
                    }, cellProps, {
                        setRef: (ref)=>{
                            this.setCellRef({
                                ref,
                                index: headingIndex,
                                inStickyHeader
                            });
                        },
                        inFixedNthColumn: false
                    })),
                    /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cellJs.Cell), Object.assign({
                        key: `${id}-sticky`
                    }, cellProps, {
                        setRef: (ref)=>{
                            this.setCellRef({
                                ref,
                                index: headingIndex,
                                inStickyHeader
                            });
                        },
                        inFixedNthColumn: Boolean(fixedFirstColumns),
                        lastFixedFirstColumn: headingIndex === fixedFirstColumns - 1,
                        style: {
                            left: (_this$state$columnVis4 = this.state.columnVisibilityData[headingIndex]) === null || _this$state$columnVis4 === void 0 ? void 0 : _this$state$columnVis4.leftEdge
                        }
                    }))
                ];
            }
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cellJs.Cell), Object.assign({
                key: id
            }, cellProps, {
                setRef: (ref)=>{
                    this.setCellRef({
                        ref,
                        index: headingIndex,
                        inStickyHeader
                    });
                },
                lastFixedFirstColumn: headingIndex === fixedFirstColumns - 1,
                inFixedNthColumn: inFixedNthColumn
            }));
        };
        this.totalsRowHeading = ()=>{
            const { i18n, totals, totalsName } = this.props;
            const totalsLabel = totalsName ? totalsName : {
                singular: i18n.translate("Polaris.DataTable.totalRowHeading"),
                plural: i18n.translate("Polaris.DataTable.totalsRowHeading")
            };
            return totals && totals.filter((total)=>total !== "").length > 1 ? totalsLabel.plural : totalsLabel.singular;
        };
        this.renderTotals = ({ total, index })=>{
            const fixedFirstColumns = this.fixedFirstColumns();
            const id = `totals-cell-${index}`;
            const { truncate = false, verticalAlign, columnContentTypes } = this.props;
            let content;
            let contentType;
            if (index === 0) content = this.totalsRowHeading();
            if (total !== "" && index > 0) {
                contentType = columnContentTypes[index];
                content = total;
            }
            const totalInFooter = this.props.showTotalsInFooter;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cellJs.Cell), {
                total: true,
                totalInFooter: totalInFooter,
                nthColumn: index <= fixedFirstColumns - 1,
                firstColumn: index === 0,
                key: id,
                content: content,
                contentType: contentType,
                truncate: truncate,
                verticalAlign: verticalAlign
            });
        };
        this.getColSpan = (rowLength, headingsLength, contentTypesLength, cellIndex)=>{
            // We decided that it shouldn't be possible to have fixed "n" columns and content that spans multiple columns
            const fixedFirstColumns = this.fixedFirstColumns();
            if (fixedFirstColumns) return 1;
            const rowLen = rowLength ? rowLength : 1;
            const colLen = headingsLength ? headingsLength : contentTypesLength;
            const colSpan = Math.floor(colLen / rowLen);
            const remainder = colLen % rowLen;
            return cellIndex === 0 ? colSpan + remainder : colSpan;
        };
        this.defaultRenderRow = ({ row, index, inFixedNthColumn, rowHeights })=>{
            const { columnContentTypes, truncate = false, verticalAlign, hoverable = true, headings } = this.props;
            const { condensed } = this.state;
            const fixedFirstColumns = this.fixedFirstColumns();
            const className = (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).TableRow, hoverable && (0, _dataTableScssJsDefault.default).hoverable);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
                key: `row-${index}`,
                className: className,
                onMouseEnter: this.handleHover(index),
                onMouseLeave: this.handleHover()
            }, row.map((content, cellIndex)=>{
                const hovered = index === this.state.rowHovered;
                const id = `cell-${cellIndex}-row-${index}`;
                const colSpan = this.getColSpan(row.length, headings.length, columnContentTypes.length, cellIndex);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cellJs.Cell), {
                    key: id,
                    content: content,
                    contentType: columnContentTypes[cellIndex],
                    nthColumn: cellIndex <= fixedFirstColumns - 1,
                    firstColumn: cellIndex === 0,
                    truncate: truncate,
                    verticalAlign: verticalAlign,
                    colSpan: colSpan,
                    hovered: hovered,
                    style: rowHeights ? {
                        height: `${rowHeights[index]}px`
                    } : {},
                    inFixedNthColumn: condensed && inFixedNthColumn
                });
            }));
        };
        this.defaultOnSort = (headingIndex)=>{
            const { onSort, defaultSortDirection = "ascending", initialSortColumnIndex } = this.props;
            const { sortDirection = defaultSortDirection, sortedColumnIndex = initialSortColumnIndex } = this.state;
            let newSortDirection = defaultSortDirection;
            if (sortedColumnIndex === headingIndex) newSortDirection = sortDirection === "ascending" ? "descending" : "ascending";
            const handleSort = ()=>{
                this.setState({
                    sortDirection: newSortDirection,
                    sortedColumnIndex: headingIndex
                }, ()=>{
                    if (onSort) onSort(headingIndex, newSortDirection);
                });
            };
            return handleSort;
        };
    }
    componentDidMount() {
        this.handleResize();
    }
    componentDidUpdate(prevProps) {
        if ((0, _reactFastCompareDefault.default)(prevProps, this.props)) return;
        this.handleResize();
    }
    componentWillUnmount() {
        this.handleResize.cancel();
    }
    render() {
        var _this$table$current, _this$table$current2, _columnVisibilityData;
        const { headings, totals, showTotalsInFooter, rows, footerContent, hideScrollIndicator = false, increasedTableDensity = false, hasZebraStripingOnData = false, stickyHeader = false, hasFixedFirstColumn: fixedFirstColumn = false } = this.props;
        const { condensed, columnVisibilityData, isScrolledFarthestLeft, isScrolledFarthestRight } = this.state;
        const fixedFirstColumns = this.fixedFirstColumns();
        const rowCountIsEven = rows.length % 2 === 0;
        const className = (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).DataTable, condensed && (0, _dataTableScssJsDefault.default).condensed, totals && (0, _dataTableScssJsDefault.default).ShowTotals, showTotalsInFooter && (0, _dataTableScssJsDefault.default).ShowTotalsInFooter, hasZebraStripingOnData && (0, _dataTableScssJsDefault.default).ZebraStripingOnData, hasZebraStripingOnData && rowCountIsEven && (0, _dataTableScssJsDefault.default).RowCountIsEven);
        const wrapperClassName = (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).TableWrapper, condensed && (0, _dataTableScssJsDefault.default).condensed, increasedTableDensity && (0, _dataTableScssJsDefault.default).IncreasedTableDensity, stickyHeader && (0, _dataTableScssJsDefault.default).StickyHeaderEnabled);
        const headingMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, headings.map((heading, index)=>this.renderHeading({
                heading,
                headingIndex: index,
                inFixedNthColumn: false,
                inStickyHeader: false
            })));
        const totalsMarkup = totals ? /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, totals.map((total, index)=>this.renderTotals({
                total,
                index
            }))) : null;
        const nthColumns = rows.map((row)=>row.slice(0, fixedFirstColumns));
        const nthHeadings = headings.slice(0, fixedFirstColumns);
        const nthTotals = totals === null || totals === void 0 ? void 0 : totals.slice(0, fixedFirstColumns);
        const tableHeaderRows = (_this$table$current = this.table.current) === null || _this$table$current === void 0 ? void 0 : _this$table$current.children[0].childNodes;
        const tableBodyRows = (_this$table$current2 = this.table.current) === null || _this$table$current2 === void 0 ? void 0 : _this$table$current2.children[1].childNodes;
        const headerRowHeights = getRowClientHeights(tableHeaderRows);
        const bodyRowHeights = getRowClientHeights(tableBodyRows);
        const fixedNthColumnMarkup = condensed && fixedFirstColumns !== 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
            className: (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).FixedFirstColumn, !isScrolledFarthestLeft && (0, _dataTableScssJsDefault.default).separate),
            style: {
                width: `${(_columnVisibilityData = columnVisibilityData[fixedFirstColumns - 1]) === null || _columnVisibilityData === void 0 ? void 0 : _columnVisibilityData.rightEdge}px`
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            style: {
                height: `${headerRowHeights[0]}px`
            }
        }, nthHeadings.map((heading, index)=>this.renderHeading({
                heading,
                headingIndex: index,
                inFixedNthColumn: true,
                inStickyHeader: false
            }))), totals && !showTotalsInFooter && /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            style: {
                height: `${headerRowHeights[1]}px`
            }
        }, nthTotals === null || nthTotals === void 0 ? void 0 : nthTotals.map((total, index)=>this.renderTotals({
                total,
                index
            })))), /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", null, nthColumns.map((row, index)=>this.defaultRenderRow({
                row,
                index,
                inFixedNthColumn: true,
                rowHeights: bodyRowHeights
            }))), totals && showTotalsInFooter && /*#__PURE__*/ (0, _reactDefault.default).createElement("tfoot", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, nthTotals === null || nthTotals === void 0 ? void 0 : nthTotals.map((total, index)=>this.renderTotals({
                total,
                index
            })))));
        const bodyMarkup = rows.map((row, index)=>this.defaultRenderRow({
                row,
                index,
                inFixedNthColumn: false
            }));
        const footerMarkup = footerContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _dataTableScssJsDefault.default).Footer
        }, footerContent) : null;
        const headerTotalsMarkup = !showTotalsInFooter ? totalsMarkup : null;
        const footerTotalsMarkup = showTotalsInFooter ? /*#__PURE__*/ (0, _reactDefault.default).createElement("tfoot", null, totalsMarkup) : null;
        const navigationMarkup = (location)=>hideScrollIndicator ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _navigationJs.Navigation), {
                columnVisibilityData: columnVisibilityData,
                isScrolledFarthestLeft: isScrolledFarthestLeft,
                isScrolledFarthestRight: isScrolledFarthestRight,
                navigateTableLeft: this.navigateTable("left"),
                navigateTableRight: this.navigateTable("right"),
                fixedFirstColumns: fixedFirstColumns,
                setRef: (ref)=>{
                    if (location === "header") this.headerNav = ref;
                    else if (location === "sticky") this.stickyNav = ref;
                }
            });
        const stickyHeaderMarkup = stickyHeader ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _afterInitialMountJs.AfterInitialMount), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _dataTableScssJsDefault.default).StickyHeaderWrapper,
            role: "presentation"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stickyJs.Sticky), {
            boundingElement: this.dataTable.current,
            onStickyChange: (isSticky)=>{
                this.changeHeadingFocus();
                this.stickyHeaderActive = isSticky;
            }
        }, (isSticky)=>{
            const stickyHeaderInnerClassNames = (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).StickyHeaderInner, isSticky && (0, _dataTableScssJsDefault.default)["StickyHeaderInner-isSticky"]);
            const stickyHeaderTableClassNames = (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).StickyHeaderTable, !isScrolledFarthestLeft && (0, _dataTableScssJsDefault.default).separate);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: stickyHeaderInnerClassNames
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, navigationMarkup("sticky")), /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
                className: stickyHeaderTableClassNames,
                ref: this.stickyTable
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
                className: (0, _dataTableScssJsDefault.default).StickyTableHeadingsRow
            }, headings.map((heading, index)=>{
                return this.renderHeading({
                    heading,
                    headingIndex: index,
                    inFixedNthColumn: Boolean(index <= fixedFirstColumns - 1 && fixedFirstColumns),
                    inStickyHeader: true
                });
            })))));
        }))) : null;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: wrapperClassName,
            ref: this.dataTable
        }, stickyHeaderMarkup, navigationMarkup("header"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _dataTableScssJsDefault.default).ScrollContainer,
            ref: this.scrollContainer
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
            event: "resize",
            handler: this.handleResize
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
            capture: true,
            passive: true,
            event: "scroll",
            handler: this.scrollListener
        }), fixedNthColumnMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
            className: (0, _dataTableScssJsDefault.default).Table,
            ref: this.table
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", null, headingMarkup, headerTotalsMarkup), /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", null, bodyMarkup), footerTotalsMarkup)), footerMarkup));
    }
    fixedFirstColumns() {
        const { hasFixedFirstColumn, fixedFirstColumns = 0, headings } = this.props;
        const numberOfFixedFirstColumns = hasFixedFirstColumn && !fixedFirstColumns ? 1 : fixedFirstColumns;
        if (numberOfFixedFirstColumns >= headings.length) return 0;
        return numberOfFixedFirstColumns;
    }
}
function DataTable(props) {
    const i18n = (0, _hooksJs.useI18n)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(DataTableInner, Object.assign({}, props, {
        i18n: i18n
    }));
}

},{"react":"cOWTg","react-fast-compare":"5bxip","../../utilities/debounce.js":"bvJet","../../utilities/css.js":"lGt6N","../shared.js":"lFbIK","./utilities.js":"lBgNd","./DataTable.scss.js":"awIoC","./components/Cell/Cell.js":"11suV","../AfterInitialMount/AfterInitialMount.js":"eAabc","../Sticky/Sticky.js":"4ehrN","./components/Navigation/Navigation.js":"blZ04","../../utilities/i18n/hooks.js":"hhMhA","../EventListener/EventListener.js":"jV8kW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5bxip":[function(require,module,exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"lBgNd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPrevAndCurrentColumns", ()=>getPrevAndCurrentColumns);
parcelHelpers.export(exports, "isEdgeVisible", ()=>isEdgeVisible);
parcelHelpers.export(exports, "measureColumn", ()=>measureColumn);
function measureColumn(tableData) {
    return function(column, index) {
        const { firstVisibleColumnIndex, tableLeftVisibleEdge: tableStart, tableRightVisibleEdge: tableEnd } = tableData;
        const leftEdge = column.offsetLeft;
        const rightEdge = leftEdge + column.offsetWidth;
        const isVisibleLeft = isEdgeVisible(leftEdge, tableStart, tableEnd, "left");
        const isVisibleRight = isEdgeVisible(rightEdge, tableStart, tableEnd, "right");
        const isVisible = isVisibleLeft || isVisibleRight;
        const width = column.offsetWidth;
        if (isVisible) tableData.firstVisibleColumnIndex = Math.min(firstVisibleColumnIndex, index);
        return {
            leftEdge,
            rightEdge,
            isVisible,
            width,
            index
        };
    };
}
function isEdgeVisible(position, start, end, edgeType) {
    const minVisiblePixels = 30;
    return position >= start + (edgeType === "left" ? 0 : minVisiblePixels) && position <= end - minVisiblePixels;
}
function getPrevAndCurrentColumns(tableData, columnData) {
    const { firstVisibleColumnIndex } = tableData;
    const previousColumnIndex = Math.max(firstVisibleColumnIndex - 1, 0);
    const previousColumn = columnData[previousColumnIndex];
    const currentColumn = columnData[firstVisibleColumnIndex];
    return {
        previousColumn,
        currentColumn
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"awIoC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "DataTable": "Polaris-DataTable",
    "condensed": "Polaris-DataTable--condensed",
    "Navigation": "Polaris-DataTable__Navigation",
    "IncreasedTableDensity": "Polaris-DataTable__IncreasedTableDensity",
    "Pip": "Polaris-DataTable__Pip",
    "Pip-visible": "Polaris-DataTable__Pip--visible",
    "ScrollContainer": "Polaris-DataTable__ScrollContainer",
    "Table": "Polaris-DataTable__Table",
    "TableRow": "Polaris-DataTable__TableRow",
    "Cell": "Polaris-DataTable__Cell",
    "ZebraStripingOnData": "Polaris-DataTable__ZebraStripingOnData",
    "RowCountIsEven": "Polaris-DataTable__RowCountIsEven",
    "ShowTotalsInFooter": "Polaris-DataTable__ShowTotalsInFooter",
    "Cell-separate": "Polaris-DataTable__Cell--separate",
    "Cell-firstColumn": "Polaris-DataTable__Cell--firstColumn",
    "Cell-numeric": "Polaris-DataTable__Cell--numeric",
    "Cell-truncated": "Polaris-DataTable__Cell--truncated",
    "Cell-header": "Polaris-DataTable__Cell--header",
    "Cell-sortable": "Polaris-DataTable__Cell--sortable",
    "Heading-left": "Polaris-DataTable__Heading--left",
    "Cell-verticalAlignTop": "Polaris-DataTable__Cell--verticalAlignTop",
    "Cell-verticalAlignBottom": "Polaris-DataTable__Cell--verticalAlignBottom",
    "Cell-verticalAlignMiddle": "Polaris-DataTable__Cell--verticalAlignMiddle",
    "Cell-verticalAlignBaseline": "Polaris-DataTable__Cell--verticalAlignBaseline",
    "hoverable": "Polaris-DataTable--hoverable",
    "Cell-hovered": "Polaris-DataTable__Cell--hovered",
    "Icon": "Polaris-DataTable__Icon",
    "Heading": "Polaris-DataTable__Heading",
    "StickyHeaderEnabled": "Polaris-DataTable__StickyHeaderEnabled",
    "StickyHeaderWrapper": "Polaris-DataTable__StickyHeaderWrapper",
    "Cell-sorted": "Polaris-DataTable__Cell--sorted",
    "Cell-total": "Polaris-DataTable__Cell--total",
    "ShowTotals": "Polaris-DataTable__ShowTotals",
    "Cell-total-footer": "Polaris-DataTable--cellTotalFooter",
    "Footer": "Polaris-DataTable__Footer",
    "StickyHeaderInner": "Polaris-DataTable__StickyHeaderInner",
    "StickyHeaderInner-isSticky": "Polaris-DataTable__StickyHeaderInner--isSticky",
    "StickyHeaderTable": "Polaris-DataTable__StickyHeaderTable",
    "FixedFirstColumn": "Polaris-DataTable__FixedFirstColumn",
    "StickyTableHeadingsRow": "Polaris-DataTable__StickyTableHeadingsRow",
    "TooltipContent": "Polaris-DataTable__TooltipContent"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"11suV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cell", ()=>Cell);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../../../utilities/css.js");
var _sharedJs = require("../../../shared.js");
var _dataTableScssJs = require("../../DataTable.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _tooltipJs = require("../../../Tooltip/Tooltip.js");
var _iconJs = require("../../../Icon/Icon.js");
function Cell({ content, contentType, nthColumn, firstColumn, truncate, header, total, totalInFooter, sorted, sortable, sortDirection, inFixedNthColumn, verticalAlign = "top", defaultSortDirection = "ascending", onSort, colSpan, setRef = ()=>{}, stickyHeadingCell = false, stickyCellWidth, hovered = false, handleFocus = ()=>{}, hasFixedNthColumn = false, fixedCellVisible = false, firstColumnMinWidth, style, lastFixedFirstColumn }) {
    const i18n = (0, _hooksJs.useI18n)();
    const numeric = contentType === "numeric";
    const className = (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).Cell, (0, _dataTableScssJsDefault.default)[`Cell-${(0, _cssJs.variationName)("verticalAlign", verticalAlign)}`], firstColumn && (0, _dataTableScssJsDefault.default)["Cell-firstColumn"], truncate && (0, _dataTableScssJsDefault.default)["Cell-truncated"], header && (0, _dataTableScssJsDefault.default)["Cell-header"], total && (0, _dataTableScssJsDefault.default)["Cell-total"], totalInFooter && (0, _dataTableScssJsDefault.default)["Cell-total-footer"], numeric && (0, _dataTableScssJsDefault.default)["Cell-numeric"], sortable && (0, _dataTableScssJsDefault.default)["Cell-sortable"], sorted && (0, _dataTableScssJsDefault.default)["Cell-sorted"], stickyHeadingCell && (0, _dataTableScssJsDefault.default).StickyHeaderCell, hovered && (0, _dataTableScssJsDefault.default)["Cell-hovered"], lastFixedFirstColumn && inFixedNthColumn && fixedCellVisible && (0, _dataTableScssJsDefault.default)["Cell-separate"], nthColumn && inFixedNthColumn && stickyHeadingCell && (0, _dataTableScssJsDefault.default).FixedFirstColumn);
    const headerClassName = (0, _cssJs.classNames)(header && (0, _dataTableScssJsDefault.default).Heading, header && contentType === "text" && (0, _dataTableScssJsDefault.default)["Heading-left"]);
    const iconClassName = (0, _cssJs.classNames)(sortable && (0, _dataTableScssJsDefault.default).Icon);
    const direction = sorted && sortDirection ? sortDirection : defaultSortDirection;
    const source = direction === "descending" ? (0, _polarisIcons.SortDescendingMajor) : (0, _polarisIcons.SortAscendingMajor);
    const oppositeDirection = sortDirection === "ascending" ? "descending" : "ascending";
    const sortAccessibilityLabel = i18n.translate("Polaris.DataTable.sortAccessibilityLabel", {
        direction: sorted ? oppositeDirection : direction
    });
    const iconMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: iconClassName
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: source,
        accessibilityLabel: sortAccessibilityLabel
    }));
    const focusable = !(stickyHeadingCell && hasFixedNthColumn && nthColumn && !inFixedNthColumn);
    const sortableHeadingContent = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        className: headerClassName,
        onClick: onSort,
        onFocus: handleFocus,
        tabIndex: focusable ? 0 : -1
    }, iconMarkup, content);
    const columnHeadingContent = sortable ? sortableHeadingContent : content;
    const colSpanProp = colSpan && colSpan > 1 ? {
        colSpan
    } : {};
    const minWidthStyles = nthColumn && firstColumnMinWidth ? {
        minWidth: firstColumnMinWidth
    } : {
        minWidth: stickyCellWidth
    };
    const stickyHeading = /*#__PURE__*/ (0, _reactDefault.default).createElement("th", Object.assign({
        ref: setRef
    }, (0, _sharedJs.headerCell).props, colSpanProp, {
        className: className,
        "aria-sort": sortDirection,
        style: {
            ...style,
            ...minWidthStyles
        },
        "data-index-table-sticky-heading": true
    }), columnHeadingContent);
    const headingMarkup = header ? /*#__PURE__*/ (0, _reactDefault.default).createElement("th", Object.assign({}, (0, _sharedJs.headerCell).props, {
        "aria-sort": sortDirection
    }, colSpanProp, {
        ref: setRef,
        className: className,
        scope: "col",
        style: {
            ...minWidthStyles
        }
    }), columnHeadingContent) : /*#__PURE__*/ (0, _reactDefault.default).createElement("th", Object.assign({}, colSpanProp, {
        ref: setRef,
        className: className,
        scope: "row",
        style: {
            ...minWidthStyles
        }
    }), truncate ? /*#__PURE__*/ (0, _reactDefault.default).createElement(TruncatedText, {
        className: (0, _dataTableScssJsDefault.default).TooltipContent
    }, content) : content);
    const cellMarkup = header || firstColumn || nthColumn ? headingMarkup : /*#__PURE__*/ (0, _reactDefault.default).createElement("td", Object.assign({
        className: className
    }, colSpanProp), content);
    return stickyHeadingCell ? stickyHeading : cellMarkup;
}
const TruncatedText = ({ children, className = "" })=>{
    const textRef = (0, _react.useRef)(null);
    const { current } = textRef;
    const text = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ref: textRef,
        className: className
    }, children);
    return (current === null || current === void 0 ? void 0 : current.scrollWidth) > (current === null || current === void 0 ? void 0 : current.offsetWidth) ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
        content: textRef.current.innerText
    }, text) : text;
};

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/css.js":"lGt6N","../../../shared.js":"lFbIK","../../DataTable.scss.js":"awIoC","../../../../utilities/i18n/hooks.js":"hhMhA","../../../Tooltip/Tooltip.js":"k7vL7","../../../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eAabc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AfterInitialMount", ()=>AfterInitialMount);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsAfterInitialMountJs = require("../../utilities/use-is-after-initial-mount.js");
function AfterInitialMount({ children, onMount, fallback = null }) {
    const isMounted = (0, _useIsAfterInitialMountJs.useIsAfterInitialMount)();
    const content = isMounted ? children : fallback;
    (0, _react.useEffect)(()=>{
        if (isMounted && onMount) onMount();
    }, [
        isMounted,
        onMount
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, content);
}

},{"react":"cOWTg","../../utilities/use-is-after-initial-mount.js":"aJ8qM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4ehrN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sticky", ()=>Sticky);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _geometryJs = require("../../utilities/geometry.js");
var _hooksJs = require("../../utilities/sticky-manager/hooks.js");
class StickyInner extends (0, _react.Component) {
    constructor(...args){
        super(...args);
        this.state = {
            isSticky: false,
            style: {}
        };
        this.placeHolderNode = null;
        this.stickyNode = null;
        this.setPlaceHolderNode = (node)=>{
            this.placeHolderNode = node;
        };
        this.setStickyNode = (node)=>{
            this.stickyNode = node;
        };
        this.handlePositioning = (stick, top = 0, left = 0, width = 0)=>{
            const { isSticky } = this.state;
            if (stick && !isSticky || !stick && isSticky) {
                this.adjustPlaceHolderNode(stick);
                this.setState({
                    isSticky: !isSticky
                }, ()=>{
                    if (this.props.onStickyChange == null) return null;
                    this.props.onStickyChange(!isSticky);
                    if (this.props.boundingElement == null) return null;
                    this.props.boundingElement.toggleAttribute("data-sticky-active");
                });
            }
            const style = stick ? {
                position: "fixed",
                top,
                left,
                width
            } : {};
            this.setState({
                style
            });
        };
        this.adjustPlaceHolderNode = (add)=>{
            if (this.placeHolderNode && this.stickyNode) this.placeHolderNode.style.paddingBottom = add ? `${(0, _geometryJs.getRectForNode)(this.stickyNode).height}px` : "0px";
        };
    }
    componentDidMount() {
        const { boundingElement, offset = false, disableWhenStacked = false, stickyManager } = this.props;
        if (!this.stickyNode || !this.placeHolderNode) return;
        stickyManager.registerStickyItem({
            stickyNode: this.stickyNode,
            placeHolderNode: this.placeHolderNode,
            handlePositioning: this.handlePositioning,
            offset,
            boundingElement,
            disableWhenStacked
        });
    }
    componentWillUnmount() {
        const { stickyManager } = this.props;
        if (!this.stickyNode) return;
        stickyManager.unregisterStickyItem(this.stickyNode);
    }
    render() {
        const { style, isSticky } = this.state;
        const { children } = this.props;
        const childrenContent = isFunction(children) ? children(isSticky) : children;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.setPlaceHolderNode
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.setStickyNode,
            style: style
        }, childrenContent));
    }
} // This should have a typeguard instead of using Function
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(arg) {
    return typeof arg === "function";
}
function Sticky(props) {
    const stickyManager = (0, _hooksJs.useStickyManager)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StickyInner, Object.assign({}, props, {
        stickyManager: stickyManager
    }));
}

},{"react":"cOWTg","../../utilities/geometry.js":"eKkn4","../../utilities/sticky-manager/hooks.js":"7j8Aw","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7j8Aw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStickyManager", ()=>useStickyManager);
var _react = require("react");
var _errorsJs = require("../errors.js");
var _contextJs = require("./context.js");
function useStickyManager() {
    const stickyManager = (0, _react.useContext)((0, _contextJs.StickyManagerContext));
    if (!stickyManager) throw new (0, _errorsJs.MissingAppProviderError)("No StickyManager was provided.");
    return stickyManager;
}

},{"react":"cOWTg","../errors.js":"HUtaY","./context.js":"drNXT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"blZ04":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Navigation", ()=>Navigation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../../../utilities/css.js");
var _dataTableScssJs = require("../../DataTable.scss.js");
var _dataTableScssJsDefault = parcelHelpers.interopDefault(_dataTableScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _buttonJs = require("../../../Button/Button.js");
function Navigation({ columnVisibilityData, isScrolledFarthestLeft, isScrolledFarthestRight, navigateTableLeft, navigateTableRight, fixedFirstColumns, setRef = ()=>{} }) {
    const i18n = (0, _hooksJs.useI18n)();
    const pipMarkup = columnVisibilityData.map((column, index)=>{
        if (index < fixedFirstColumns) return;
        const className = (0, _cssJs.classNames)((0, _dataTableScssJsDefault.default).Pip, column.isVisible && (0, _dataTableScssJsDefault.default)["Pip-visible"]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: className,
            key: `pip-${index}`
        });
    });
    const leftA11yLabel = i18n.translate("Polaris.DataTable.navAccessibilityLabel", {
        direction: "left"
    });
    const rightA11yLabel = i18n.translate("Polaris.DataTable.navAccessibilityLabel", {
        direction: "right"
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _dataTableScssJsDefault.default).Navigation,
        ref: setRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        plain: true,
        icon: (0, _polarisIcons.ChevronLeftMinor),
        disabled: isScrolledFarthestLeft,
        accessibilityLabel: leftA11yLabel,
        onClick: navigateTableLeft
    }), pipMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        plain: true,
        icon: (0, _polarisIcons.ChevronRightMinor),
        disabled: isScrolledFarthestRight,
        accessibilityLabel: rightA11yLabel,
        onClick: navigateTableRight
    }));
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/css.js":"lGt6N","../../DataTable.scss.js":"awIoC","../../../../utilities/i18n/hooks.js":"hhMhA","../../../Button/Button.js":"6Szv4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hHEpE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Divider", ()=>Divider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dividerScssJs = require("./Divider.scss.js");
var _dividerScssJsDefault = parcelHelpers.interopDefault(_dividerScssJs);
const Divider = ({ borderColor = "border-subdued", borderWidth = "1" })=>{
    const borderColorValue = borderColor === "transparent" ? borderColor : `var(--p-color-${borderColor})`;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("hr", {
        className: (0, _dividerScssJsDefault.default).Divider,
        style: {
            borderBlockStart: `var(--p-border-width-${borderWidth}) solid ${borderColorValue}`
        }
    });
};

},{"react":"cOWTg","./Divider.scss.js":"jTfMh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jTfMh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Divider": "Polaris-Divider"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"im56V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZone", ()=>DropZone);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _debounceJs = require("../../utilities/debounce.js");
var _cssJs = require("../../utilities/css.js");
var _capitalizeJs = require("../../utilities/capitalize.js");
var _targetJs = require("../../utilities/target.js");
var _useComponentDidMountJs = require("../../utilities/use-component-did-mount.js");
var _useToggleJs = require("../../utilities/use-toggle.js");
var _useEventListenerJs = require("../../utilities/use-event-listener.js");
var _contextJs = require("./context.js");
var _indexJs = require("./utils/index.js");
var _dropZoneScssJs = require("./DropZone.scss.js");
var _dropZoneScssJsDefault = parcelHelpers.interopDefault(_dropZoneScssJs);
var _fileUploadJs = require("./components/FileUpload/FileUpload.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../utilities/unique-id/hooks.js");
var _verticalStackJs = require("../VerticalStack/VerticalStack.js");
var _iconJs = require("../Icon/Icon.js");
var _textJs = require("../Text/Text.js");
var _labelledJs = require("../Labelled/Labelled.js");
// TypeScript can't generate types that correctly infer the typing of
// subcomponents so explicitly state the subcomponents in the type definition.
// Letting this be implicit works in this project but fails in projects that use
// generated *.d.ts files.
const DropZone = function DropZone({ dropOnPage, label, labelAction, labelHidden, children, disabled = false, outline = true, accept, active, overlay = true, allowMultiple = (0, _indexJs.defaultAllowMultiple), overlayText, errorOverlayText, id: idProp, type = "file", onClick, error, openFileDialog, variableHeight, onFileDialogClose, customValidator, onDrop, onDropAccepted, onDropRejected, onDragEnter, onDragOver, onDragLeave }) {
    const node = (0, _react.useRef)(null);
    const inputRef = (0, _react.useRef)(null);
    const dragTargets = (0, _react.useRef)([]); // eslint-disable-next-line react-hooks/exhaustive-deps
    const adjustSize = (0, _react.useCallback)((0, _debounceJs.debounce)(()=>{
        if (!node.current) return;
        if (variableHeight) {
            setMeasuring(false);
            return;
        }
        let size = "large";
        const width = node.current.getBoundingClientRect().width;
        if (width < 100) size = "small";
        else if (width < 160) size = "medium";
        setSize(size);
        measuring && setMeasuring(false);
    }, 50, {
        trailing: true
    }), []);
    const [dragging, setDragging] = (0, _react.useState)(false);
    const [internalError, setInternalError] = (0, _react.useState)(false);
    const { value: focused, setTrue: handleFocus, setFalse: handleBlur } = (0, _useToggleJs.useToggle)(false);
    const [size, setSize] = (0, _react.useState)("large");
    const [measuring, setMeasuring] = (0, _react.useState)(true);
    const i18n = (0, _hooksJs.useI18n)();
    const getValidatedFiles = (0, _react.useCallback)((files)=>{
        const acceptedFiles = [];
        const rejectedFiles = [];
        Array.from(files).forEach((file)=>{
            !(0, _indexJs.fileAccepted)(file, accept) || customValidator && !customValidator(file) ? rejectedFiles.push(file) : acceptedFiles.push(file);
        });
        if (!allowMultiple) {
            acceptedFiles.splice(1, acceptedFiles.length);
            rejectedFiles.push(...acceptedFiles.slice(1));
        }
        return {
            files,
            acceptedFiles,
            rejectedFiles
        };
    }, [
        accept,
        allowMultiple,
        customValidator
    ]);
    const handleDrop = (0, _react.useCallback)((event)=>{
        stopEvent(event);
        if (disabled) return;
        const fileList = (0, _indexJs.getDataTransferFiles)(event);
        const { files, acceptedFiles, rejectedFiles } = getValidatedFiles(fileList);
        dragTargets.current = [];
        setDragging(false);
        setInternalError(rejectedFiles.length > 0);
        onDrop && onDrop(files, acceptedFiles, rejectedFiles);
        onDropAccepted && acceptedFiles.length && onDropAccepted(acceptedFiles);
        onDropRejected && rejectedFiles.length && onDropRejected(rejectedFiles);
        if (!(event.target && "value" in event.target)) return;
        event.target.value = "";
    }, [
        disabled,
        getValidatedFiles,
        onDrop,
        onDropAccepted,
        onDropRejected
    ]);
    const handleDragEnter = (0, _react.useCallback)((event)=>{
        stopEvent(event);
        if (disabled) return;
        const fileList = (0, _indexJs.getDataTransferFiles)(event);
        if (event.target && !dragTargets.current.includes(event.target)) dragTargets.current.push(event.target);
        if (dragging) return;
        const { rejectedFiles } = getValidatedFiles(fileList);
        setDragging(true);
        setInternalError(rejectedFiles.length > 0);
        onDragEnter && onDragEnter();
    }, [
        disabled,
        dragging,
        getValidatedFiles,
        onDragEnter
    ]);
    const handleDragOver = (0, _react.useCallback)((event)=>{
        stopEvent(event);
        if (disabled) return;
        onDragOver && onDragOver();
    }, [
        disabled,
        onDragOver
    ]);
    const handleDragLeave = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        if (disabled) return;
        dragTargets.current = dragTargets.current.filter((el)=>{
            const compareNode = dropOnPage && !(0, _targetJs.isServer) ? document : node.current;
            return el !== event.target && compareNode && compareNode.contains(el);
        });
        if (dragTargets.current.length > 0) return;
        setDragging(false);
        setInternalError(false);
        onDragLeave && onDragLeave();
    }, [
        dropOnPage,
        disabled,
        onDragLeave
    ]);
    const dropNode = dropOnPage && !(0, _targetJs.isServer) ? document : node.current;
    (0, _useEventListenerJs.useEventListener)("drop", handleDrop, dropNode);
    (0, _useEventListenerJs.useEventListener)("dragover", handleDragOver, dropNode);
    (0, _useEventListenerJs.useEventListener)("dragenter", handleDragEnter, dropNode);
    (0, _useEventListenerJs.useEventListener)("dragleave", handleDragLeave, dropNode);
    (0, _useEventListenerJs.useEventListener)("resize", adjustSize, (0, _targetJs.isServer) ? null : window);
    (0, _useComponentDidMountJs.useComponentDidMount)(()=>{
        adjustSize();
    });
    const id = (0, _hooksJs1.useUniqueId)("DropZone", idProp);
    const typeSuffix = (0, _capitalizeJs.capitalize)(type);
    const allowMultipleKey = (0, _indexJs.createAllowMultipleKey)(allowMultiple);
    const overlayTextWithDefault = overlayText === undefined ? i18n.translate(`Polaris.DropZone.${allowMultipleKey}.overlayText${typeSuffix}`) : overlayText;
    const errorOverlayTextWithDefault = errorOverlayText === undefined ? i18n.translate(`Polaris.DropZone.errorOverlayText${typeSuffix}`) : errorOverlayText;
    const labelValue = label || i18n.translate(`Polaris.DropZone.${allowMultipleKey}.label${typeSuffix}`);
    const labelHiddenValue = label ? labelHidden : true;
    const classes = (0, _cssJs.classNames)((0, _dropZoneScssJsDefault.default).DropZone, outline && (0, _dropZoneScssJsDefault.default).hasOutline, focused && (0, _dropZoneScssJsDefault.default).focused, (active || dragging) && (0, _dropZoneScssJsDefault.default).isDragging, disabled && (0, _dropZoneScssJsDefault.default).isDisabled, (internalError || error) && (0, _dropZoneScssJsDefault.default).hasError, !variableHeight && (0, _dropZoneScssJsDefault.default)[(0, _cssJs.variationName)("size", size)], measuring && (0, _dropZoneScssJsDefault.default).measuring);
    const dragOverlay = (active || dragging) && !internalError && !error && overlay && overlayMarkup((0, _polarisIcons.UploadMajor), "interactive", overlayTextWithDefault);
    const dragErrorOverlay = dragging && (internalError || error) && overlayMarkup((0, _polarisIcons.CircleAlertMajor), "critical", errorOverlayTextWithDefault);
    const context = (0, _react.useMemo)(()=>({
            disabled,
            focused,
            size,
            type: type || "file",
            measuring,
            allowMultiple
        }), [
        disabled,
        focused,
        measuring,
        size,
        type,
        allowMultiple
    ]);
    const open = (0, _react.useCallback)(()=>{
        if (!inputRef.current) return;
        inputRef.current.click();
    }, [
        inputRef
    ]);
    const triggerFileDialog = (0, _react.useCallback)(()=>{
        open();
        onFileDialogClose === null || onFileDialogClose === void 0 || onFileDialogClose();
    }, [
        open,
        onFileDialogClose
    ]);
    function overlayMarkup(icon, color, text) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _dropZoneScssJsDefault.default).Overlay
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
            gap: "2",
            inlineAlign: "center"
        }, size === "small" && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
            source: icon,
            color: color
        }), (size === "medium" || size === "large") && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
            variant: "bodySm",
            as: "p",
            fontWeight: "bold"
        }, text)));
    }
    function handleClick(event) {
        if (disabled) return;
        return onClick ? onClick(event) : open();
    }
    (0, _react.useEffect)(()=>{
        if (openFileDialog) triggerFileDialog();
    }, [
        openFileDialog,
        triggerFileDialog
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.DropZoneContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _labelledJs.Labelled), {
        id: id,
        label: labelValue,
        action: labelAction,
        labelHidden: labelHiddenValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: node,
        className: classes,
        "aria-disabled": disabled,
        onClick: handleClick,
        onDragStart: stopEvent
    }, dragOverlay, dragErrorOverlay, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        variant: "bodySm",
        as: "span",
        visuallyHidden: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: id,
        accept: accept,
        disabled: disabled,
        multiple: allowMultiple,
        onChange: handleDrop,
        onFocus: handleFocus,
        onBlur: handleBlur,
        type: "file",
        ref: inputRef,
        autoComplete: "off"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _dropZoneScssJsDefault.default).Container
    }, children))));
};
function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
DropZone.FileUpload = (0, _fileUploadJs.FileUpload);

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/debounce.js":"bvJet","../../utilities/css.js":"lGt6N","../../utilities/capitalize.js":"dRJoN","../../utilities/target.js":"8v8ju","../../utilities/use-component-did-mount.js":"b8lBX","../../utilities/use-toggle.js":"2kpDL","../../utilities/use-event-listener.js":"1MHbT","./context.js":"ja8SO","./utils/index.js":"kp4YW","./DropZone.scss.js":"7PISr","./components/FileUpload/FileUpload.js":"897cC","../../utilities/i18n/hooks.js":"hhMhA","../../utilities/unique-id/hooks.js":"2JfcO","../VerticalStack/VerticalStack.js":"5lUFs","../Icon/Icon.js":"6HPny","../Text/Text.js":"l8Av9","../Labelled/Labelled.js":"bvXVq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dRJoN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
function capitalize(word = "") {
    const wordLower = word.toLowerCase();
    return wordLower.charAt(0).toUpperCase() + wordLower.slice(1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ja8SO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropZoneContext", ()=>DropZoneContext);
var _react = require("react");
var _indexJs = require("./utils/index.js");
const DropZoneContext = /*#__PURE__*/ (0, _react.createContext)({
    disabled: false,
    focused: false,
    size: "extraLarge",
    type: "file",
    measuring: false,
    allowMultiple: (0, _indexJs.defaultAllowMultiple)
});

},{"react":"cOWTg","./utils/index.js":"kp4YW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kp4YW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAllowMultipleKey", ()=>createAllowMultipleKey);
parcelHelpers.export(exports, "defaultAllowMultiple", ()=>defaultAllowMultiple);
parcelHelpers.export(exports, "fileAccepted", ()=>fileAccepted);
parcelHelpers.export(exports, "getDataTransferFiles", ()=>getDataTransferFiles);
const dragEvents = [
    "dragover",
    "dragenter",
    "drop"
];
function fileAccepted(file, accept) {
    return file.type === "application/x-moz-file" || accepts(file, accept);
}
function getDataTransferFiles(event) {
    if (isDragEvent(event) && event.dataTransfer) {
        const dt = event.dataTransfer;
        if (dt.files && dt.files.length) return Array.from(dt.files);
        else if (dt.items && dt.items.length) // Chrome is the only browser that allows to read the file list on drag
        // events and uses `items` instead of `files` in this case.
        return Array.from(dt.items);
    } else if (isChangeEvent(event) && event.target.files) // Return files from even when a file was selected from an upload dialog
    return Array.from(event.target.files);
    return [];
}
function accepts(file, acceptedFiles) {
    if (file && acceptedFiles) {
        const fileName = file.name || "";
        const mimeType = file.type || "";
        const baseMimeType = mimeType.replace(/\/.*$/, "");
        const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        return acceptedFilesArray.some((type)=>{
            const validType = type.trim();
            if (validType.startsWith(".")) return fileName.toLowerCase().endsWith(validType.toLowerCase());
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
}
function isDragEvent(event) {
    return dragEvents.indexOf(event.type) > 0;
}
function isChangeEvent(event) {
    return Object.prototype.hasOwnProperty.call(event, "target");
}
const defaultAllowMultiple = true;
function createAllowMultipleKey(allowMultiple) {
    return allowMultiple ? "allowMultiple" : "single";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7PISr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "DropZone": "Polaris-DropZone",
    "focused": "Polaris-DropZone--focused",
    "hasOutline": "Polaris-DropZone--hasOutline",
    "isDisabled": "Polaris-DropZone--isDisabled",
    "isDragging": "Polaris-DropZone--isDragging",
    "sizeLarge": "Polaris-DropZone--sizeLarge",
    "sizeMedium": "Polaris-DropZone--sizeMedium",
    "sizeSmall": "Polaris-DropZone--sizeSmall",
    "measuring": "Polaris-DropZone--measuring",
    "Container": "Polaris-DropZone__Container",
    "Overlay": "Polaris-DropZone__Overlay",
    "hasError": "Polaris-DropZone--hasError"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"897cC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileUpload", ()=>FileUpload);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _capitalizeJs = require("../../../../utilities/capitalize.js");
var _contextJs = require("../../context.js");
var _indexJs = require("../../utils/index.js");
var _fileUploadScssJs = require("./FileUpload.scss.js");
var _fileUploadScssJsDefault = parcelHelpers.interopDefault(_fileUploadScssJs);
var _uploadArrowSvgJs = require("../../images/upload-arrow.svg.js");
var _uploadArrowSvgJsDefault = parcelHelpers.interopDefault(_uploadArrowSvgJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _verticalStackJs = require("../../../VerticalStack/VerticalStack.js");
var _textJs = require("../../../Text/Text.js");
function FileUpload(props) {
    const i18n = (0, _hooksJs.useI18n)();
    const { size, measuring, type, disabled, allowMultiple } = (0, _react.useContext)((0, _contextJs.DropZoneContext));
    const typeSuffix = (0, _capitalizeJs.capitalize)(type);
    const allowMultipleKey = (0, _indexJs.createAllowMultipleKey)(allowMultiple);
    const { actionTitle = i18n.translate(`Polaris.DropZone.${allowMultipleKey}.actionTitle${typeSuffix}`), actionHint } = props;
    const actionClassNames = (0, _cssJs.classNames)((0, _fileUploadScssJsDefault.default).Action, disabled && (0, _fileUploadScssJsDefault.default).disabled);
    const actionMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: actionClassNames
    }, actionTitle);
    const fileUploadClassName = (0, _cssJs.classNames)((0, _fileUploadScssJsDefault.default).FileUpload, measuring && (0, _fileUploadScssJsDefault.default).measuring, size === "large" && (0, _fileUploadScssJsDefault.default).large, size === "small" && (0, _fileUploadScssJsDefault.default).small);
    const actionHintMarkup = actionHint && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        variant: "bodySm",
        as: "p",
        color: "subdued"
    }, actionHint);
    let viewMarkup;
    switch(size){
        case "large":
            viewMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
                inlineAlign: "center",
                gap: "2"
            }, actionMarkup, actionHintMarkup);
            break;
        case "medium":
            viewMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
                inlineAlign: "center",
                gap: "2"
            }, actionMarkup, actionHintMarkup);
            break;
        case "small":
            viewMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("img", {
                width: "20",
                src: (0, _uploadArrowSvgJsDefault.default),
                alt: ""
            });
            break;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: fileUploadClassName
    }, viewMarkup);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/capitalize.js":"dRJoN","../../context.js":"ja8SO","../../utils/index.js":"kp4YW","./FileUpload.scss.js":"fMYwi","../../images/upload-arrow.svg.js":"e0Dfa","../../../../utilities/i18n/hooks.js":"hhMhA","../../../VerticalStack/VerticalStack.js":"5lUFs","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fMYwi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "FileUpload": "Polaris-DropZone-FileUpload",
    "large": "Polaris-DropZone-FileUpload--large",
    "small": "Polaris-DropZone-FileUpload--small",
    "Action": "Polaris-DropZone-FileUpload__Action",
    "disabled": "Polaris-DropZone-FileUpload--disabled",
    "ActionTitle": "Polaris-DropZone-FileUpload__ActionTitle",
    "ActionTitle-disabled": "Polaris-DropZone-FileUpload__ActionTitle--disabled",
    "ActionTitle-focused": "Polaris-DropZone-FileUpload__ActionTitle--focused"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e0Dfa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>uploadArrow);
var img = "data:image/svg+xml,%3csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M20 10a10 10 0 11-20 0 10 10 0 0120 0zM5.3 8.3l4-4a1 1 0 011.4 0l4 4a1 1 0 01-1.4 1.4L11 7.4V15a1 1 0 11-2 0V7.4L6.7 9.7a1 1 0 01-1.4-1.4z' fill='%235C5F62'/%3e%3c/svg%3e";
var uploadArrow = img;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5KiAk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptySearchResult", ()=>EmptySearchResult);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emptySearchSvgJs = require("./illustrations/empty-search.svg.js");
var _emptySearchSvgJsDefault = parcelHelpers.interopDefault(_emptySearchSvgJs);
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _legacyStackJs = require("../LegacyStack/LegacyStack.js");
var _textJs = require("../Text/Text.js");
var _imageJs = require("../Image/Image.js");
function EmptySearchResult({ title, description, withIllustration }) {
    const i18n = (0, _hooksJs.useI18n)();
    const altText = i18n.translate("Polaris.EmptySearchResult.altText");
    const descriptionMarkup = description ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, description) : null;
    const illustrationMarkup = withIllustration ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
        alt: altText,
        source: (0, _emptySearchSvgJsDefault.default),
        draggable: false
    }) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack), {
        alignment: "center",
        vertical: true
    }, illustrationMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        variant: "headingLg",
        as: "p"
    }, title), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        color: "subdued",
        as: "span"
    }, descriptionMarkup));
}

},{"react":"cOWTg","./illustrations/empty-search.svg.js":"5haLe","../../utilities/i18n/hooks.js":"hhMhA","../LegacyStack/LegacyStack.js":"5pyyM","../Text/Text.js":"l8Av9","../Image/Image.js":"5iL1c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5haLe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>emptySearch);
var img = "data:image/svg+xml,%3csvg width='60' height='60' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M41.87 24a17.87 17.87 0 11-35.74 0 17.87 17.87 0 0135.74 0zm-3.15 18.96a24 24 0 114.24-4.24L59.04 54.8a3 3 0 11-4.24 4.24L38.72 42.96z' fill='%238C9196'/%3e%3c/svg%3e";
var emptySearch = img;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hUfJM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyState", ()=>EmptyState);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _withinContentContextJs = require("../../utilities/within-content-context.js");
var _emptyStateScssJs = require("./EmptyState.scss.js");
var _emptyStateScssJsDefault = parcelHelpers.interopDefault(_emptyStateScssJs);
var _utilsJs = require("../Button/utils.js");
var _boxJs = require("../Box/Box.js");
var _verticalStackJs = require("../VerticalStack/VerticalStack.js");
var _imageJs = require("../Image/Image.js");
var _textJs = require("../Text/Text.js");
var _horizontalStackJs = require("../HorizontalStack/HorizontalStack.js");
function EmptyState({ children, heading, image, largeImage, imageContained, fullWidth = false, action, secondaryAction, footerContent }) {
    const withinContentContainer = (0, _react.useContext)((0, _withinContentContextJs.WithinContentContext));
    const imageContainedClass = (0, _cssJs.classNames)(imageContained && (0, _emptyStateScssJsDefault.default).imageContained);
    const imageMarkup = largeImage ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
        alt: "",
        role: "presentation",
        source: largeImage,
        className: imageContainedClass,
        sourceSet: [
            {
                source: image,
                descriptor: "568w"
            },
            {
                source: largeImage,
                descriptor: "1136w"
            }
        ],
        sizes: "(max-width: 568px) 60vw"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
        className: imageContainedClass,
        role: "presentation",
        alt: "",
        source: image
    });
    const secondaryActionMarkup = secondaryAction ? (0, _utilsJs.buttonFrom)(secondaryAction, {}) : null;
    const footerContentMarkup = footerContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: "4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        color: "subdued",
        alignment: "center"
    }, footerContent)) : null;
    const headingSize = withinContentContainer ? "headingLg" : "headingXl";
    const primaryActionMarkup = action ? (0, _utilsJs.buttonFrom)(action, {
        primary: true,
        size: "medium"
    }) : null;
    const headingMarkup = heading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockEnd: "4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        variant: headingSize,
        as: "p",
        alignment: "center"
    }, heading)) : null;
    const childrenMarkup = children ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        color: "subdued",
        alignment: "center"
    }, children) : null;
    const textContentMarkup = headingMarkup || children ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockEnd: "6"
    }, headingMarkup, childrenMarkup) : null;
    const actionsMarkup = primaryActionMarkup || secondaryActionMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        align: "center",
        gap: "2"
    }, secondaryActionMarkup, primaryActionMarkup) : null;
    const detailsMarkup = textContentMarkup || actionsMarkup || footerContentMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        maxWidth: fullWidth ? "100%" : "400px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
        inlineAlign: "center"
    }, textContentMarkup, actionsMarkup, footerContentMarkup)) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingInlineStart: "0",
        paddingInlineEnd: "0",
        paddingBlockStart: "5",
        paddingBlockEnd: "16"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
        inlineAlign: "center"
    }, imageMarkup, detailsMarkup));
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/within-content-context.js":"cUmFU","./EmptyState.scss.js":"7hDhp","../Button/utils.js":"drbMl","../Box/Box.js":"lbjkG","../VerticalStack/VerticalStack.js":"5lUFs","../Image/Image.js":"5iL1c","../Text/Text.js":"l8Av9","../HorizontalStack/HorizontalStack.js":"fotqA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7hDhp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "imageContained": "Polaris-EmptyState--imageContained"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bpXQf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Filters", ()=>Filters);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _focusJs = require("../../utilities/focus.js");
var _withinFilterContextJs = require("../../utilities/within-filter-context.js");
var _typesJs = require("../../types.js");
var _filtersScssJs = require("./Filters.scss.js");
var _filtersScssJsDefault = parcelHelpers.interopDefault(_filtersScssJs);
var _contextJs = require("../../utilities/resource-list/context.js");
var _collapsibleJs = require("../Collapsible/Collapsible.js");
var _connectedFilterControlJs = require("./components/ConnectedFilterControl/ConnectedFilterControl.js");
var _tagsWrapperJs = require("./components/TagsWrapper/TagsWrapper.js");
var _tagJs = require("../Tag/Tag.js");
var _sheetJs = require("../Sheet/Sheet.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../utilities/media-query/hooks.js");
var _scrollLockJs = require("../ScrollLock/ScrollLock.js");
var _badgeJs = require("../Badge/Badge.js");
var _textJs = require("../Text/Text.js");
var _iconJs = require("../Icon/Icon.js");
var _focusJs1 = require("../Focus/Focus.js");
var _buttonJs = require("../Button/Button.js");
var _textFieldJs = require("../TextField/TextField.js");
var _scrollableJs = require("../Scrollable/Scrollable.js");
var _keypressListenerJs = require("../KeypressListener/KeypressListener.js");
var _legacyStackJs = require("../LegacyStack/LegacyStack.js");
var Suffix;
(function(Suffix) {
    Suffix["Filter"] = "Filter";
    Suffix["Shortcut"] = "Shortcut";
})(Suffix || (Suffix = {}));
class FiltersInner extends (0, _react.Component) {
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            open: false,
            readyForFocus: false
        };
        this.moreFiltersButtonContainer = /*#__PURE__*/ (0, _react.createRef)();
        this.moreFiltersDoneButtonContainer = /*#__PURE__*/ (0, _react.createRef)();
        this.focusNode = /*#__PURE__*/ (0, _react.createRef)();
        this.closeFilters = ()=>{
            this.setState({
                open: false
            }, ()=>{
                if (this.moreFiltersButtonContainer.current) (0, _focusJs.focusFirstFocusableNode)(this.moreFiltersButtonContainer.current, false);
            });
        };
        this.toggleFilters = ()=>{
            if (this.state.open === true) this.closeFilters();
            else this.openFilters();
        };
        this.setReadyForFocus = (newState)=>()=>{
                this.setState({
                    readyForFocus: newState
                });
            };
        this.handleClearAll = ()=>{
            this.props.onClearAll();
            this.moreFiltersDoneButtonContainer.current && (0, _focusJs.focusFirstFocusableNode)(this.moreFiltersDoneButtonContainer.current, false);
        };
    }
    render() {
        const { filters, queryValue, onQueryBlur, onQueryChange, onQueryFocus, focused, onClearAll, appliedFilters, onQueryClear, queryPlaceholder, children, disabled = false, helpText, hideTags, hideQueryField, disableQueryField = false, i18n, mediaQuery: { isNavigationCollapsed } } = this.props;
        const { resourceName } = this.context;
        const { open, readyForFocus } = this.state;
        const backdropMarkup = open ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollLockJs.ScrollLock), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _filtersScssJsDefault.default).Backdrop,
            onClick: this.closeFilters
        })) : null;
        const filtersContentMarkup = filters.map((filter, index)=>{
            const filterIsOpen = this.state[`${filter.key}${Suffix.Filter}`] === true;
            const icon = filterIsOpen ? (0, _polarisIcons.ChevronUpMinor) : (0, _polarisIcons.ChevronDownMinor);
            const className = (0, _cssJs.classNames)((0, _filtersScssJsDefault.default).FilterTriggerContainer, filterIsOpen && (0, _filtersScssJsDefault.default).open, index === 0 && (0, _filtersScssJsDefault.default).first, filters.length !== 1 && index === filters.length - 1 && (0, _filtersScssJsDefault.default).last);
            const appliedFilterContent = this.getAppliedFilterContent(filter.key);
            const appliedFilterBadgeMarkup = appliedFilterContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _filtersScssJsDefault.default).AppliedFilterBadgeContainer
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badgeJs.Badge), {
                status: "new"
            }, appliedFilterContent)) : null;
            const collapsibleID = `${filter.key}Collapsible`;
            const buttonClassName = (0, _cssJs.classNames)((0, _filtersScssJsDefault.default).FilterTrigger);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                key: filter.key,
                className: className
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
                onClick: ()=>this.toggleFilter(filter.key),
                className: buttonClassName,
                id: `${filter.key}ToggleButton`,
                type: "button",
                "aria-controls": collapsibleID,
                "aria-expanded": filterIsOpen
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _filtersScssJsDefault.default).FilterTriggerLabelContainer
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", {
                className: (0, _filtersScssJsDefault.default).FilterTriggerTitle
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
                as: "span",
                color: this.props.disabled || filter.disabled ? "subdued" : undefined
            }, filter.label)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _filtersScssJsDefault.default).FilterTriggerIcon
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
                source: icon,
                color: "base"
            }))), appliedFilterBadgeMarkup), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collapsibleJs.Collapsible), {
                id: collapsibleID,
                open: filterIsOpen,
                onAnimationEnd: this.setReadyForFocus(true)
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _filtersScssJsDefault.default).FilterNodeContainer
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusJs1.Focus), {
                disabled: !filterIsOpen || !readyForFocus || !open,
                root: this.focusNode
            }, this.generateFilterMarkup(filter)))));
        });
        const appliedFiltersCount = appliedFilters ? appliedFilters.length : 0;
        const moreFiltersLabel = hideTags && appliedFiltersCount > 0 ? i18n.translate("Polaris.Filters.moreFiltersWithCount", {
            count: appliedFiltersCount
        }) : i18n.translate("Polaris.Filters.moreFilters");
        const rightActionMarkup = filters.length ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.moreFiltersButtonContainer
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            onClick: this.toggleFilters,
            disabled: disabled
        }, moreFiltersLabel)) : null;
        const filterResourceName = resourceName || {
            singular: i18n.translate("Polaris.ResourceList.defaultItemSingular"),
            plural: i18n.translate("Polaris.ResourceList.defaultItemPlural")
        };
        const transformedFilters = this.transformFilters(filters);
        const filtersControlMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _connectedFilterControlJs.ConnectedFilterControl), {
            rightPopoverableActions: transformedFilters,
            rightAction: rightActionMarkup,
            auxiliary: children,
            disabled: disabled,
            forceShowMorefiltersButton: filters.length > transformedFilters.length,
            queryFieldHidden: hideQueryField
        }, hideQueryField ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textFieldJs.TextField), {
            placeholder: queryPlaceholder || i18n.translate("Polaris.Filters.filter", {
                resourceName: filterResourceName.plural
            }),
            onChange: onQueryChange,
            onBlur: onQueryBlur,
            onFocus: onQueryFocus,
            value: queryValue,
            focused: focused,
            label: queryPlaceholder || i18n.translate("Polaris.Filters.filter", {
                resourceName: filterResourceName.plural
            }),
            labelHidden: true,
            prefix: /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _filtersScssJsDefault.default).SearchIcon
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
                source: (0, _polarisIcons.SearchMinor)
            })),
            clearButton: true,
            onClearButtonClick: onQueryClear,
            disabled: disabled || disableQueryField,
            autoComplete: "off"
        }));
        const filtersContainerHeaderClassname = (0, _cssJs.classNames)((0, _filtersScssJsDefault.default).FiltersContainerHeader);
        const filtersDesktopHeaderMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: filtersContainerHeaderClassname
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
            variant: "headingLg",
            as: "h3"
        }, moreFiltersLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            icon: (0, _polarisIcons.CancelSmallMinor),
            plain: true,
            accessibilityLabel: i18n.translate("Polaris.Filters.cancel"),
            onClick: this.closeFilters
        }));
        const filtersMobileHeaderMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: filtersContainerHeaderClassname
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            icon: (0, _polarisIcons.CancelSmallMinor),
            plain: true,
            accessibilityLabel: i18n.translate("Polaris.Filters.cancel"),
            onClick: this.closeFilters
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
            variant: "headingLg",
            as: "h3"
        }, moreFiltersLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            onClick: this.closeFilters,
            primary: true
        }, i18n.translate("Polaris.Filters.done")));
        const filtersDesktopFooterClassname = (0, _cssJs.classNames)((0, _filtersScssJsDefault.default).FiltersContainerFooter);
        const filtersDesktopFooterMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: filtersDesktopFooterClassname
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            onClick: this.handleClearAll,
            disabled: !this.hasAppliedFilters()
        }, i18n.translate("Polaris.Filters.clearAllFilters")), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.moreFiltersDoneButtonContainer
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            onClick: this.closeFilters,
            primary: true
        }, i18n.translate("Polaris.Filters.done"))));
        const filtersMobileFooterMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _filtersScssJsDefault.default).FiltersMobileContainerFooter
        }, this.hasAppliedFilters() ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            onClick: onClearAll,
            fullWidth: true
        }, i18n.translate("Polaris.Filters.clearAllFilters")) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _filtersScssJsDefault.default).EmptyFooterState
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
            color: "subdued",
            as: "span"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, i18n.translate("Polaris.Filters.noFiltersApplied")))));
        const shouldHideTagsContainer = !appliedFilters || appliedFilters.length < 1;
        const tagsMarkup = !hideTags ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tagsWrapperJs.TagsWrapper), {
            hidden: shouldHideTagsContainer
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _filtersScssJsDefault.default).TagsContainer,
            "aria-live": "polite"
        }, (appliedFilters || []).map((filter)=>{
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tagJs.Tag), {
                key: filter.key,
                onRemove: ()=>{
                    filter.onRemove(filter.key);
                },
                disabled: disabled
            }, filter.label);
        }))) : null;
        const filtersMobileContainerContentClassName = (0, _cssJs.classNames)((0, _filtersScssJsDefault.default).FiltersMobileContainerContent);
        const filtersDesktopContainerContentClassName = (0, _cssJs.classNames)((0, _filtersScssJsDefault.default).FiltersDesktopContainerContent);
        const filtersContainerMarkup = isNavigationCollapsed ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sheetJs.Sheet), {
            accessibilityLabel: moreFiltersLabel,
            open: open,
            onClose: this.closeFilters,
            onEntered: this.setReadyForFocus(true),
            onExit: this.setReadyForFocus(false)
        }, filtersMobileHeaderMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollableJs.Scrollable), {
            className: filtersMobileContainerContentClassName,
            shadow: true
        }, filtersContentMarkup, filtersMobileFooterMarkup)) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sheetJs.Sheet), {
            accessibilityLabel: moreFiltersLabel,
            open: open,
            onClose: this.closeFilters,
            onEntered: this.setReadyForFocus(true),
            onExit: this.setReadyForFocus(false)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _filtersScssJsDefault.default).FiltersContainer
        }, filtersDesktopHeaderMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollableJs.Scrollable), {
            className: filtersDesktopContainerContentClassName,
            shadow: true
        }, filtersContentMarkup), filtersDesktopFooterMarkup));
        const helpTextMarkup = helpText ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            id: "FiltersHelpText",
            className: (0, _filtersScssJsDefault.default).HelpText
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
            color: "subdued",
            as: "span"
        }, helpText)) : null;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _withinFilterContextJs.WithinFilterContext).Provider, {
            value: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _filtersScssJsDefault.default).Filters
        }, filtersControlMarkup, filtersContainerMarkup, tagsMarkup, helpTextMarkup, backdropMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
            keyCode: (0, _typesJs.Key).Escape,
            handler: this.closeFilters
        })));
    }
    hasAppliedFilters() {
        const { appliedFilters, queryValue } = this.props;
        const filtersApplied = Boolean(appliedFilters && appliedFilters.length > 0);
        const queryApplied = Boolean(queryValue && queryValue !== "");
        return filtersApplied || queryApplied;
    }
    getAppliedFilterContent(key) {
        const { appliedFilters } = this.props;
        if (!appliedFilters) return undefined;
        const filter = appliedFilters.find((filter)=>filter.key === key);
        return filter == null ? undefined : filter.label;
    }
    getAppliedFilterRemoveHandler(key) {
        const { appliedFilters } = this.props;
        if (!appliedFilters) return undefined;
        const filter = appliedFilters.find((filter)=>filter.key === key);
        return filter == null ? undefined : filter.onRemove;
    }
    openFilters() {
        this.setState({
            open: true
        });
    }
    toggleFilter(key) {
        if (this.state[`${key}${Suffix.Filter}`] === true) this.setState({
            readyForFocus: false,
            [`${key}${Suffix.Filter}`]: false
        });
        else this.setState({
            readyForFocus: false,
            [`${key}${Suffix.Filter}`]: true
        });
    }
    openFilterShortcut(key) {
        this.setState({
            [`${key}${Suffix.Shortcut}`]: true
        });
    }
    closeFilterShortcut(key) {
        this.setState({
            [`${key}${Suffix.Shortcut}`]: false
        });
    }
    toggleFilterShortcut(key) {
        if (this.state[`${key}${Suffix.Shortcut}`] === true) this.closeFilterShortcut(key);
        else this.openFilterShortcut(key);
    }
    transformFilters(filters) {
        const transformedActions = [];
        getShortcutFilters(filters).forEach((filter)=>{
            const { key, label, disabled } = filter;
            transformedActions.push({
                popoverContent: this.generateFilterMarkup(filter),
                popoverOpen: Boolean(this.state[`${key}${Suffix.Shortcut}`]),
                key,
                content: label,
                disabled,
                onAction: ()=>this.toggleFilterShortcut(key)
            });
        });
        return transformedActions;
    }
    generateFilterMarkup(filter) {
        const i18n = this.props.i18n;
        const removeCallback = this.getAppliedFilterRemoveHandler(filter.key);
        const removeHandler = removeCallback == null ? undefined : ()=>{
            removeCallback(filter.key);
        };
        const clearButtonMarkup = !filter.hideClearButton && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            plain: true,
            disabled: removeHandler == null,
            onClick: removeHandler,
            accessibilityLabel: i18n.translate("Polaris.Filters.clearLabel", {
                filterName: filter.label
            })
        }, i18n.translate("Polaris.Filters.clear"));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.focusNode
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack), {
            vertical: true,
            spacing: "tight"
        }, filter.filter, clearButtonMarkup));
    }
}
FiltersInner.contextType = (0, _contextJs.ResourceListContext);
function getShortcutFilters(filters) {
    return filters.filter((filter)=>filter.shortcut === true);
}
function Filters(props) {
    const i18n = (0, _hooksJs.useI18n)();
    const mediaQuery = (0, _hooksJs1.useMediaQuery)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FiltersInner, Object.assign({}, props, {
        i18n: i18n,
        mediaQuery: mediaQuery
    }));
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","../../utilities/focus.js":"b0pEc","../../utilities/within-filter-context.js":"8qxM0","../../types.js":"6NE7w","./Filters.scss.js":"hDfKc","../../utilities/resource-list/context.js":"jzPOe","../Collapsible/Collapsible.js":"6rL9J","./components/ConnectedFilterControl/ConnectedFilterControl.js":"ktKoN","./components/TagsWrapper/TagsWrapper.js":"17iuG","../Tag/Tag.js":"3F2gH","../Sheet/Sheet.js":"fp9iv","../../utilities/i18n/hooks.js":"hhMhA","../../utilities/media-query/hooks.js":"jzbEF","../ScrollLock/ScrollLock.js":"92GHE","../Badge/Badge.js":"8ckUl","../Text/Text.js":"l8Av9","../Icon/Icon.js":"6HPny","../Focus/Focus.js":"3ikK9","../Button/Button.js":"6Szv4","../TextField/TextField.js":"5K1ky","../Scrollable/Scrollable.js":"587xt","../KeypressListener/KeypressListener.js":"1eFmF","../LegacyStack/LegacyStack.js":"5pyyM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hDfKc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Filters": "Polaris-Filters",
    "FiltersContainer": "Polaris-Filters__FiltersContainer",
    "FiltersContainerHeader": "Polaris-Filters__FiltersContainerHeader",
    "FiltersDesktopContainerContent": "Polaris-Filters__FiltersDesktopContainerContent",
    "FiltersMobileContainerContent": "Polaris-Filters__FiltersMobileContainerContent",
    "FiltersContainerFooter": "Polaris-Filters__FiltersContainerFooter",
    "FiltersMobileContainerFooter": "Polaris-Filters__FiltersMobileContainerFooter",
    "EmptyFooterState": "Polaris-Filters__EmptyFooterState",
    "FilterTriggerContainer": "Polaris-Filters__FilterTriggerContainer",
    "FilterTrigger": "Polaris-Filters__FilterTrigger",
    "FilterTriggerTitle": "Polaris-Filters__FilterTriggerTitle",
    "AppliedFilterBadgeContainer": "Polaris-Filters__AppliedFilterBadgeContainer",
    "open": "Polaris-Filters--open",
    "FilterTriggerLabelContainer": "Polaris-Filters__FilterTriggerLabelContainer",
    "first": "Polaris-Filters--first",
    "last": "Polaris-Filters--last",
    "FilterNodeContainer": "Polaris-Filters__FilterNodeContainer",
    "SearchIcon": "Polaris-Filters__SearchIcon",
    "Backdrop": "Polaris-Filters__Backdrop",
    "HelpText": "Polaris-Filters__HelpText",
    "TagsContainer": "Polaris-Filters__TagsContainer"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jzPOe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceListContext", ()=>ResourceListContext);
var _react = require("react");
const ResourceListContext = /*#__PURE__*/ (0, _react.createContext)({});

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ktKoN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectedFilterControl", ()=>ConnectedFilterControl);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounceJs = require("../../../../utilities/debounce.js");
var _cssJs = require("../../../../utilities/css.js");
var _connectedFilterControlScssJs = require("./ConnectedFilterControl.scss.js");
var _connectedFilterControlScssJsDefault = parcelHelpers.interopDefault(_connectedFilterControlScssJs);
var _itemJs = require("./components/Item/Item.js");
var _eventListenerJs = require("../../../EventListener/EventListener.js");
var _buttonJs = require("../../../Button/Button.js");
var _popoverJs = require("../../../Popover/Popover.js");
const FILTER_FIELD_MIN_WIDTH = 150;
class ConnectedFilterControl extends (0, _react.Component) {
    constructor(...args){
        super(...args);
        this.state = {
            availableWidth: 0,
            proxyButtonsWidth: {}
        };
        this.container = /*#__PURE__*/ (0, _react.createRef)();
        this.proxyButtonContainer = /*#__PURE__*/ (0, _react.createRef)();
        this.moreFiltersButtonContainer = /*#__PURE__*/ (0, _react.createRef)();
        this.handleResize = (0, _debounceJs.debounce)(()=>{
            this.measureProxyButtons();
            this.measureAvailableWidth();
        }, 40, {
            leading: true,
            trailing: true,
            maxWait: 40
        });
    }
    componentDidMount() {
        this.handleResize();
    }
    render() {
        const { children, rightPopoverableActions, rightAction, auxiliary, forceShowMorefiltersButton = true, queryFieldHidden } = this.props;
        const actionsToRender = rightPopoverableActions != null ? this.getActionsToRender(rightPopoverableActions) : [];
        const className = (0, _cssJs.classNames)((0, _connectedFilterControlScssJsDefault.default).ConnectedFilterControl, rightPopoverableActions && (0, _connectedFilterControlScssJsDefault.default).right);
        const shouldRenderMoreFiltersButton = forceShowMorefiltersButton || rightPopoverableActions && rightPopoverableActions.length !== actionsToRender.length;
        const RightContainerClassName = (0, _cssJs.classNames)((0, _connectedFilterControlScssJsDefault.default).RightContainer, !shouldRenderMoreFiltersButton && (0, _connectedFilterControlScssJsDefault.default).RightContainerWithoutMoreFilters, queryFieldHidden && (0, _connectedFilterControlScssJsDefault.default).queryFieldHidden);
        const rightMarkup = actionsToRender.length > 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: RightContainerClassName
        }, this.popoverFrom(actionsToRender)) : null;
        const moreFiltersButtonContainerClassname = (0, _cssJs.classNames)((0, _connectedFilterControlScssJsDefault.default).MoreFiltersButtonContainer, actionsToRender.length === 0 && (0, _connectedFilterControlScssJsDefault.default).onlyButtonVisible);
        const rightActionMarkup = rightAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.moreFiltersButtonContainer,
            className: moreFiltersButtonContainerClassname
        }, shouldRenderMoreFiltersButton && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), null, rightAction)) : null;
        const proxyButtonMarkup = rightPopoverableActions ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _connectedFilterControlScssJsDefault.default).ProxyButtonContainer,
            ref: this.proxyButtonContainer,
            "aria-hidden": true
        }, rightPopoverableActions.map((action)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                key: action.key,
                "data-key": action.key
            }, this.activatorButtonFrom(action, {
                proxy: true
            })))) : null;
        const auxMarkup = auxiliary ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _connectedFilterControlScssJsDefault.default).AuxiliaryContainer
        }, auxiliary) : null;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, proxyButtonMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _connectedFilterControlScssJsDefault.default).Wrapper
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: className,
            ref: this.container
        }, children ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _connectedFilterControlScssJsDefault.default).CenterContainer
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), null, children)) : null, rightMarkup, rightActionMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
            event: "resize",
            handler: this.handleResize
        })), auxMarkup));
    }
    measureProxyButtons() {
        if (this.proxyButtonContainer.current) {
            const proxyButtonsWidth = {}; // this number is magical, but tweaking it solved the problem of items overlapping
            const tolerance = 78;
            if (this.proxyButtonContainer.current) Array.from(this.proxyButtonContainer.current.children).forEach((element)=>{
                const buttonWidth = element.getBoundingClientRect().width + tolerance;
                const buttonKey = element instanceof HTMLElement && element.dataset.key;
                if (buttonKey) proxyButtonsWidth[buttonKey] = buttonWidth;
            });
            this.setState({
                proxyButtonsWidth
            });
        }
    }
    measureAvailableWidth() {
        if (this.container.current && this.moreFiltersButtonContainer.current) {
            const containerWidth = this.container.current.getBoundingClientRect().width;
            const moreFiltersButtonWidth = this.moreFiltersButtonContainer.current.getBoundingClientRect().width;
            const filtersActionWidth = 0;
            const filterFieldMinWidth = this.props.queryFieldHidden ? 0 : FILTER_FIELD_MIN_WIDTH;
            const availableWidth = containerWidth - filterFieldMinWidth - moreFiltersButtonWidth - filtersActionWidth;
            this.setState({
                availableWidth
            });
        }
    }
    getActionsToRender(actions) {
        let remainingWidth = this.state.availableWidth;
        const actionsToReturn = [];
        for(let i = 0; remainingWidth > 0 && i < actions.length; i++){
            const action = actions[i];
            const actionWidth = this.state.proxyButtonsWidth[action.key];
            if (actionWidth <= remainingWidth) {
                actionsToReturn.push(action);
                remainingWidth -= actionWidth;
            } else break;
        }
        return actionsToReturn;
    }
    activatorButtonFrom(action, options) {
        const id = options !== null && options !== void 0 && options.proxy ? undefined : `Activator-${action.key}`;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
            onClick: action.onAction,
            disclosure: true,
            disabled: this.props.disabled || action.disabled,
            id: id
        }, action.content);
    }
    popoverFrom(actions) {
        return actions.map((action)=>{
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), {
                key: action.key
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
                active: action.popoverOpen,
                activator: this.activatorButtonFrom(action),
                onClose: action.onAction,
                preferredAlignment: "left",
                sectioned: true
            }, action.popoverContent));
        });
    }
}

},{"react":"cOWTg","../../../../utilities/debounce.js":"bvJet","../../../../utilities/css.js":"lGt6N","./ConnectedFilterControl.scss.js":"NsXDH","./components/Item/Item.js":"jmlsk","../../../EventListener/EventListener.js":"jV8kW","../../../Button/Button.js":"6Szv4","../../../Popover/Popover.js":"cE1F7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"NsXDH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ConnectedFilterControl": "Polaris-Filters-ConnectedFilterControl",
    "CenterContainer": "Polaris-Filters-ConnectedFilterControl__CenterContainer",
    "right": "Polaris-Filters-ConnectedFilterControl--right",
    "Item": "Polaris-Filters-ConnectedFilterControl__Item",
    "Item-focused": "Polaris-Filters-ConnectedFilterControl__Item--focused",
    "ProxyButtonContainer": "Polaris-Filters-ConnectedFilterControl__ProxyButtonContainer",
    "RightContainer": "Polaris-Filters-ConnectedFilterControl__RightContainer",
    "MoreFiltersButtonContainer": "Polaris-Filters-ConnectedFilterControl__MoreFiltersButtonContainer",
    "queryFieldHidden": "Polaris-Filters-ConnectedFilterControl--queryFieldHidden",
    "RightContainerWithoutMoreFilters": "Polaris-Filters-ConnectedFilterControl__RightContainerWithoutMoreFilters",
    "onlyButtonVisible": "Polaris-Filters-ConnectedFilterControl--onlyButtonVisible",
    "Wrapper": "Polaris-Filters-ConnectedFilterControl__Wrapper",
    "AuxiliaryContainer": "Polaris-Filters-ConnectedFilterControl__AuxiliaryContainer"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jmlsk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../../../utilities/css.js");
var _useToggleJs = require("../../../../../../utilities/use-toggle.js");
var _connectedFilterControlScssJs = require("../../ConnectedFilterControl.scss.js");
var _connectedFilterControlScssJsDefault = parcelHelpers.interopDefault(_connectedFilterControlScssJs);
function Item({ children }) {
    const { value: focused, setTrue: forceTrueFocused, setFalse: forceFalseFocused } = (0, _useToggleJs.useToggle)(false);
    const className = (0, _cssJs.classNames)((0, _connectedFilterControlScssJsDefault.default).Item, focused && (0, _connectedFilterControlScssJsDefault.default)["Item-focused"]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        onBlur: forceFalseFocused,
        onFocus: forceTrueFocused,
        className: className
    }, children);
}

},{"react":"cOWTg","../../../../../../utilities/css.js":"lGt6N","../../../../../../utilities/use-toggle.js":"2kpDL","../../ConnectedFilterControl.scss.js":"NsXDH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"17iuG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagsWrapper", ()=>TagsWrapper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _textJs = require("../../../Text/Text.js");
function TagsWrapper({ children, hidden }) {
    if (hidden) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, children);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
}

},{"react":"cOWTg","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3F2gH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _focusJs = require("../../utilities/focus.js");
var _tagScssJs = require("./Tag.scss.js");
var _tagScssJsDefault = parcelHelpers.interopDefault(_tagScssJs);
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _iconJs = require("../Icon/Icon.js");
function Tag({ children, disabled = false, onClick, onRemove, accessibilityLabel, url }) {
    const i18n = (0, _hooksJs.useI18n)();
    const segmented = onRemove && url;
    const className = (0, _cssJs.classNames)((0, _tagScssJsDefault.default).Tag, disabled && (0, _tagScssJsDefault.default).disabled, onClick && (0, _tagScssJsDefault.default).clickable, onRemove && (0, _tagScssJsDefault.default).removable, url && !disabled && (0, _tagScssJsDefault.default).linkable, segmented && (0, _tagScssJsDefault.default).segmented);
    if (onClick) return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        disabled: disabled,
        className: className,
        onClick: onClick
    }, children);
    let tagTitle = accessibilityLabel;
    if (!tagTitle) tagTitle = typeof children === "string" ? children : undefined;
    const ariaLabel = i18n.translate("Polaris.Tag.ariaLabel", {
        children: tagTitle || ""
    });
    const removeButton = onRemove ? /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        "aria-label": ariaLabel,
        className: (0, _cssJs.classNames)((0, _tagScssJsDefault.default).Button, segmented && (0, _tagScssJsDefault.default).segmented),
        onClick: onRemove,
        onMouseUp: (0, _focusJs.handleMouseUpByBlurring),
        disabled: disabled
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.CancelSmallMinor)
    })) : null;
    const tagContent = url && !disabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        className: (0, _cssJs.classNames)((0, _tagScssJsDefault.default).Link, segmented && (0, _tagScssJsDefault.default).segmented),
        href: url
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        title: tagTitle,
        className: (0, _tagScssJsDefault.default).LinkText
    }, children)) : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        title: tagTitle,
        className: (0, _tagScssJsDefault.default).TagText
    }, children);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    }, tagContent, removeButton);
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","../../utilities/focus.js":"b0pEc","./Tag.scss.js":"7NIaQ","../../utilities/i18n/hooks.js":"hhMhA","../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7NIaQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Tag": "Polaris-Tag",
    "disabled": "Polaris-Tag--disabled",
    "clickable": "Polaris-Tag--clickable",
    "removable": "Polaris-Tag--removable",
    "linkable": "Polaris-Tag--linkable",
    "TagText": "Polaris-Tag__TagText",
    "Button": "Polaris-Tag__Button",
    "segmented": "Polaris-Tag--segmented",
    "Link": "Polaris-Tag__Link",
    "LinkText": "Polaris-Tag__LinkText"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fp9iv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sheet", ()=>Sheet);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _polarisTokens = require("@shopify/polaris-tokens");
var _focusJs = require("../../utilities/focus.js");
var _cssJs = require("../../utilities/css.js");
var _typesJs = require("../../types.js");
var _sharedJs = require("../shared.js");
var _sheetScssJs = require("./Sheet.scss.js");
var _sheetScssJsDefault = parcelHelpers.interopDefault(_sheetScssJs);
var _hooksJs = require("../../utilities/media-query/hooks.js");
var _portalJs = require("../Portal/Portal.js");
var _trapFocusJs = require("../TrapFocus/TrapFocus.js");
var _keypressListenerJs = require("../KeypressListener/KeypressListener.js");
var _backdropJs = require("../Backdrop/Backdrop.js");
const BOTTOM_CLASS_NAMES = {
    enter: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Bottom, (0, _sheetScssJsDefault.default).enterBottom),
    enterActive: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Bottom, (0, _sheetScssJsDefault.default).enterBottomActive),
    exit: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Bottom, (0, _sheetScssJsDefault.default).exitBottom),
    exitActive: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Bottom, (0, _sheetScssJsDefault.default).exitBottomActive)
};
const RIGHT_CLASS_NAMES = {
    enter: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Right, (0, _sheetScssJsDefault.default).enterRight),
    enterActive: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Right, (0, _sheetScssJsDefault.default).enterRightActive),
    exit: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Right, (0, _sheetScssJsDefault.default).exitRight),
    exitActive: (0, _cssJs.classNames)((0, _sheetScssJsDefault.default).Right, (0, _sheetScssJsDefault.default).exitRightActive)
};
/** @deprecated Use Modal instead or avoid modal patterns all together. */ function Sheet({ children, open, onClose, onEntered, onExit, accessibilityLabel, activator }) {
    const { isNavigationCollapsed } = (0, _hooksJs.useMediaQuery)();
    const container = (0, _react.useRef)(null);
    const activatorRef = (0, _react.useRef)(null);
    const handleClose = (0, _react.useCallback)(()=>{
        onClose();
        const activatorElement = activator && isRef(activator) ? activator && activator.current : activatorRef.current;
        if (activatorElement) requestAnimationFrame(()=>(0, _focusJs.focusFirstFocusableNode)(activatorElement));
    }, [
        activator,
        onClose
    ]);
    (0, _react.useEffect)(()=>{}, []);
    const activatorMarkup = activator && !isRef(activator) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: activatorRef
    }, activator) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, activatorMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalJs.Portal), {
        idPrefix: "sheet"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.CSSTransition), {
        nodeRef: container,
        classNames: isNavigationCollapsed ? BOTTOM_CLASS_NAMES : RIGHT_CLASS_NAMES,
        timeout: parseInt((0, _polarisTokens.motion)["duration-300"], 10),
        in: open,
        mountOnEnter: true,
        unmountOnExit: true,
        onEntered: onEntered,
        onExit: onExit
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
        className: (0, _sheetScssJsDefault.default).Container
    }, (0, _sharedJs.layer).props, (0, _sharedJs.overlay).props, {
        ref: container
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trapFocusJs.TrapFocus), {
        trapping: open
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "dialog",
        "aria-modal": true,
        tabIndex: -1,
        className: (0, _sheetScssJsDefault.default).Sheet,
        "aria-label": accessibilityLabel
    }, children)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyCode: (0, _typesJs.Key).Escape,
        handler: handleClose
    }), open && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _backdropJs.Backdrop), {
        transparent: true,
        onClick: handleClose
    })));
}
function isRef(ref) {
    return Object.prototype.hasOwnProperty.call(ref, "current");
}

},{"react":"cOWTg","react-transition-group":"1qdFK","@shopify/polaris-tokens":"5ENVX","../../utilities/focus.js":"b0pEc","../../utilities/css.js":"lGt6N","../../types.js":"6NE7w","../shared.js":"lFbIK","./Sheet.scss.js":"87QgA","../../utilities/media-query/hooks.js":"jzbEF","../Portal/Portal.js":"3wn3c","../TrapFocus/TrapFocus.js":"izXDF","../KeypressListener/KeypressListener.js":"1eFmF","../Backdrop/Backdrop.js":"dJt5R","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"87QgA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Sheet": "Polaris-Sheet",
    "Container": "Polaris-Sheet__Container",
    "Bottom": "Polaris-Sheet__Bottom",
    "enterBottom": "Polaris-Sheet--enterBottom",
    "enterBottomActive": "Polaris-Sheet--enterBottomActive",
    "exitBottom": "Polaris-Sheet--exitBottom",
    "exitBottomActive": "Polaris-Sheet--exitBottomActive",
    "Right": "Polaris-Sheet__Right",
    "enterRight": "Polaris-Sheet--enterRight",
    "enterRightActive": "Polaris-Sheet--enterRightActive",
    "exitRight": "Polaris-Sheet--exitRight",
    "exitRightActive": "Polaris-Sheet--exitRightActive"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jzbEF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMediaQuery", ()=>useMediaQuery);
var _react = require("react");
var _contextJs = require("./context.js");
function useMediaQuery() {
    const mediaQuery = (0, _react.useContext)((0, _contextJs.MediaQueryContext));
    if (!mediaQuery) throw new Error("No mediaQuery was provided. Your application must be wrapped in an <AppProvider> component. See https://polaris.shopify.com/components/app-provider for implementation instructions.");
    return mediaQuery;
}

},{"react":"cOWTg","./context.js":"4MqDR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"izXDF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrapFocus", ()=>TrapFocus);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _typesJs = require("../../types.js");
var _focusJs = require("../../utilities/focus.js");
var _sharedJs = require("../shared.js");
var _hooksJs = require("../../utilities/focus-manager/hooks.js");
var _focusJs1 = require("../Focus/Focus.js");
var _eventListenerJs = require("../EventListener/EventListener.js");
var _keypressListenerJs = require("../KeypressListener/KeypressListener.js");
function TrapFocus({ trapping = true, children }) {
    const { canSafelyFocus } = (0, _hooksJs.useFocusManager)({
        trapping
    });
    const focusTrapWrapper = (0, _react.useRef)(null);
    const [disableFocus, setDisableFocus] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        const disable = canSafelyFocus && !(focusTrapWrapper.current && focusTrapWrapper.current.contains(document.activeElement)) ? !trapping : true;
        setDisableFocus(disable);
    }, [
        canSafelyFocus,
        trapping
    ]);
    const handleFocusIn = (event)=>{
        const containerContentsHaveFocus = focusTrapWrapper.current && focusTrapWrapper.current.contains(document.activeElement);
        if (trapping === false || !focusTrapWrapper.current || containerContentsHaveFocus || event.target instanceof Element && event.target.matches(`${(0, _sharedJs.portal).selector} *`)) return;
        if (canSafelyFocus && event.target instanceof HTMLElement && focusTrapWrapper.current !== event.target && !focusTrapWrapper.current.contains(event.target)) (0, _focusJs.focusFirstFocusableNode)(focusTrapWrapper.current);
    };
    const handleTab = (event)=>{
        if (trapping === false || !focusTrapWrapper.current) return;
        const firstFocusableNode = (0, _focusJs.findFirstKeyboardFocusableNode)(focusTrapWrapper.current);
        const lastFocusableNode = (0, _focusJs.findLastKeyboardFocusableNode)(focusTrapWrapper.current);
        if (event.target === lastFocusableNode && !event.shiftKey) {
            event.preventDefault();
            (0, _focusJs.focusFirstKeyboardFocusableNode)(focusTrapWrapper.current);
        }
        if (event.target === firstFocusableNode && event.shiftKey) {
            event.preventDefault();
            (0, _focusJs.focusLastKeyboardFocusableNode)(focusTrapWrapper.current);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusJs1.Focus), {
        disabled: disableFocus,
        root: focusTrapWrapper.current
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: focusTrapWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
        event: "focusin",
        handler: handleFocusIn
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyCode: (0, _typesJs.Key).Tab,
        keyEvent: "keydown",
        handler: handleTab
    }), children));
}

},{"react":"cOWTg","../../types.js":"6NE7w","../../utilities/focus.js":"b0pEc","../shared.js":"lFbIK","../../utilities/focus-manager/hooks.js":"816B3","../Focus/Focus.js":"3ikK9","../EventListener/EventListener.js":"jV8kW","../KeypressListener/KeypressListener.js":"1eFmF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"816B3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFocusManager", ()=>useFocusManager);
var _react = require("react");
var _errorsJs = require("../errors.js");
var _contextJs = require("./context.js");
var _hooksJs = require("../unique-id/hooks.js");
function useFocusManager({ trapping }) {
    const focusManager = (0, _react.useContext)((0, _contextJs.FocusManagerContext));
    const id = (0, _hooksJs.useUniqueId)();
    if (!focusManager) throw new (0, _errorsJs.MissingAppProviderError)("No FocusManager was provided.");
    const { trapFocusList, add: addFocusItem, remove: removeFocusItem } = focusManager;
    const canSafelyFocus = trapFocusList[0] === id;
    const value = (0, _react.useMemo)(()=>({
            canSafelyFocus
        }), [
        canSafelyFocus
    ]);
    (0, _react.useEffect)(()=>{
        if (!trapping) return;
        addFocusItem(id);
        return ()=>{
            removeFocusItem(id);
        };
    }, [
        addFocusItem,
        id,
        removeFocusItem,
        trapping
    ]);
    return value;
}

},{"react":"cOWTg","../errors.js":"HUtaY","./context.js":"hElrI","../unique-id/hooks.js":"2JfcO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3ikK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Focus", ()=>Focus);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focusJs = require("../../utilities/focus.js");
const Focus = /*#__PURE__*/ (0, _react.memo)(function Focus({ children, disabled, root }) {
    (0, _react.useEffect)(()=>{
        if (disabled || !root) return;
        const node = isRef(root) ? root.current : root;
        if (!node || node.querySelector("[autofocus]")) return;
        (0, _focusJs.focusFirstFocusableNode)(node, false);
    }, [
        disabled,
        root
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
});
function isRef(ref) {
    return ref.current !== undefined;
}

},{"react":"cOWTg","../../utilities/focus.js":"b0pEc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9cuP6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _textJs = require("../Text/Text.js");
function Form({ acceptCharset, action, autoComplete, children, encType, implicitSubmit = true, method = "post", name, noValidate, preventDefault = true, target, onSubmit }) {
    const i18n = (0, _hooksJs.useI18n)();
    const handleSubmit = (0, _react.useCallback)((event)=>{
        if (!preventDefault) return;
        event.preventDefault();
        onSubmit(event);
    }, [
        onSubmit,
        preventDefault
    ]);
    const autoCompleteInputs = normalizeAutoComplete(autoComplete);
    const submitMarkup = implicitSubmit ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "submit",
        "aria-hidden": "true",
        tabIndex: -1
    }, i18n.translate("Polaris.Common.submit"))) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("form", {
        acceptCharset: acceptCharset,
        action: action,
        autoComplete: autoCompleteInputs,
        encType: encType,
        method: method,
        name: name,
        noValidate: noValidate,
        target: target,
        onSubmit: handleSubmit
    }, submitMarkup, children);
}
function normalizeAutoComplete(autoComplete) {
    if (autoComplete == null) return autoComplete;
    return autoComplete ? "on" : "off";
}

},{"react":"cOWTg","../../utilities/i18n/hooks.js":"hhMhA","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gfbei":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormLayout", ()=>FormLayout);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _componentsJs = require("../../utilities/components.js");
var _formLayoutScssJs = require("./FormLayout.scss.js");
var _formLayoutScssJsDefault = parcelHelpers.interopDefault(_formLayoutScssJs);
var _groupJs = require("./components/Group/Group.js");
var _itemJs = require("./components/Item/Item.js");
const FormLayout = /*#__PURE__*/ (0, _react.memo)(function FormLayout({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _formLayoutScssJsDefault.default).FormLayout
    }, (0, _react.Children).map(children, wrapChildren));
});
FormLayout.Group = (0, _groupJs.Group);
function wrapChildren(child, index) {
    if ((0, _componentsJs.isElementOfType)(child, (0, _groupJs.Group))) return child;
    const props = {
        key: index
    };
    return (0, _componentsJs.wrapWithComponent)(child, (0, _itemJs.Item), props);
}

},{"react":"cOWTg","../../utilities/components.js":"6Xyqa","./FormLayout.scss.js":"46xfC","./components/Group/Group.js":"34q36","./components/Item/Item.js":"hUg4t","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"46xfC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "FormLayout": "Polaris-FormLayout",
    "Title": "Polaris-FormLayout__Title",
    "Items": "Polaris-FormLayout__Items",
    "Item": "Polaris-FormLayout__Item",
    "grouped": "Polaris-FormLayout--grouped",
    "condensed": "Polaris-FormLayout--condensed"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"34q36":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Group", ()=>Group);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _componentsJs = require("../../../../utilities/components.js");
var _formLayoutScssJs = require("../../FormLayout.scss.js");
var _formLayoutScssJsDefault = parcelHelpers.interopDefault(_formLayoutScssJs);
var _itemJs = require("../Item/Item.js");
var _hooksJs = require("../../../../utilities/unique-id/hooks.js");
var _boxJs = require("../../../Box/Box.js");
function Group({ children, condensed, title, helpText }) {
    const className = (0, _cssJs.classNames)(condensed ? (0, _formLayoutScssJsDefault.default).condensed : (0, _formLayoutScssJsDefault.default).grouped);
    const id = (0, _hooksJs.useUniqueId)("FormLayoutGroup");
    let helpTextElement = null;
    let helpTextID;
    let titleElement = null;
    let titleID;
    if (helpText) {
        helpTextID = `${id}HelpText`;
        helpTextElement = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            id: helpTextID,
            paddingBlockStart: "2",
            paddingInlineStart: "5",
            paddingBlockEnd: "0",
            paddingInlineEnd: "5",
            color: "text-subdued"
        }, helpText);
    }
    if (title) {
        titleID = `${id}Title`;
        titleElement = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            id: titleID,
            className: (0, _formLayoutScssJsDefault.default).Title
        }, title);
    }
    const itemsMarkup = (0, _react.Children).map(children, (child)=>(0, _componentsJs.wrapWithComponent)(child, (0, _itemJs.Item), {}));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "group",
        className: className,
        "aria-labelledby": titleID,
        "aria-describedby": helpTextID
    }, titleElement, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _formLayoutScssJsDefault.default).Items
    }, itemsMarkup), helpTextElement);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/components.js":"6Xyqa","../../FormLayout.scss.js":"46xfC","../Item/Item.js":"hUg4t","../../../../utilities/unique-id/hooks.js":"2JfcO","../../../Box/Box.js":"lbjkG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hUg4t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _formLayoutScssJs = require("../../FormLayout.scss.js");
var _formLayoutScssJsDefault = parcelHelpers.interopDefault(_formLayoutScssJs);
function Item({ children }) {
    return children ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _formLayoutScssJsDefault.default).Item
    }, children) : null;
}

},{"react":"cOWTg","../../FormLayout.scss.js":"46xfC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gkl0a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Frame", ()=>Frame);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _reactTransitionGroup = require("react-transition-group");
var _polarisTokens = require("@shopify/polaris-tokens");
var _cssJs = require("../../utilities/css.js");
var _sharedJs = require("../shared.js");
var _setRootPropertyJs = require("../../utilities/set-root-property.js");
var _frameScssJs = require("./Frame.scss.js");
var _frameScssJsDefault = parcelHelpers.interopDefault(_frameScssJs);
var _loadingJs = require("./components/Loading/Loading.js");
var _cssanimationJs = require("./components/CSSAnimation/CSSAnimation.js");
var _contextualSaveBarJs = require("./components/ContextualSaveBar/ContextualSaveBar.js");
var _contextJs = require("../../utilities/frame/context.js");
var _toastManagerJs = require("./components/ToastManager/ToastManager.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../utilities/media-query/hooks.js");
var _trapFocusJs = require("../TrapFocus/TrapFocus.js");
var _iconJs = require("../Icon/Icon.js");
var _backdropJs = require("../Backdrop/Backdrop.js");
var _eventListenerJs = require("../EventListener/EventListener.js");
const APP_FRAME_MAIN = "AppFrameMain";
const APP_FRAME_NAV = "AppFrameNav";
const APP_FRAME_TOP_BAR = "AppFrameTopBar";
const APP_FRAME_LOADING_BAR = "AppFrameLoadingBar";
class FrameInner extends (0, _react.PureComponent) {
    constructor(...args){
        super(...args);
        this.state = {
            skipFocused: false,
            globalRibbonHeight: 0,
            loadingStack: 0,
            toastMessages: [],
            showContextualSaveBar: false
        };
        this.contextualSaveBar = null;
        this.globalRibbonContainer = null;
        this.navigationNode = /*#__PURE__*/ (0, _react.createRef)();
        this.setGlobalRibbonHeight = ()=>{
            const { globalRibbonContainer } = this;
            if (globalRibbonContainer) this.setState({
                globalRibbonHeight: globalRibbonContainer.offsetHeight
            }, this.setGlobalRibbonRootProperty);
        };
        this.setOffset = ()=>{
            const { offset = "0px" } = this.props;
            (0, _setRootPropertyJs.setRootProperty)("--pc-frame-offset", offset);
        };
        this.setGlobalRibbonRootProperty = ()=>{
            const { globalRibbonHeight } = this.state;
            (0, _setRootPropertyJs.setRootProperty)("--pc-frame-global-ribbon-height", `${globalRibbonHeight}px`);
        };
        this.showToast = (toast)=>{
            this.setState(({ toastMessages })=>{
                const hasToastById = toastMessages.find(({ id })=>id === toast.id) != null;
                return {
                    toastMessages: hasToastById ? toastMessages : [
                        ...toastMessages,
                        toast
                    ]
                };
            });
        };
        this.hideToast = ({ id })=>{
            this.setState(({ toastMessages })=>{
                return {
                    toastMessages: toastMessages.filter(({ id: toastId })=>id !== toastId)
                };
            });
        };
        this.setContextualSaveBar = (props)=>{
            const { showContextualSaveBar } = this.state;
            this.contextualSaveBar = {
                ...props
            };
            if (showContextualSaveBar === true) this.forceUpdate();
            else this.setState({
                showContextualSaveBar: true
            });
        };
        this.removeContextualSaveBar = ()=>{
            this.contextualSaveBar = null;
            this.setState({
                showContextualSaveBar: false
            });
        };
        this.startLoading = ()=>{
            this.setState(({ loadingStack })=>({
                    loadingStack: loadingStack + 1
                }));
        };
        this.stopLoading = ()=>{
            this.setState(({ loadingStack })=>({
                    loadingStack: Math.max(0, loadingStack - 1)
                }));
        };
        this.handleResize = ()=>{
            if (this.props.globalRibbon) this.setGlobalRibbonHeight();
        };
        this.handleFocus = ()=>{
            this.setState({
                skipFocused: true
            });
        };
        this.handleBlur = ()=>{
            this.setState({
                skipFocused: false
            });
        };
        this.handleClick = (event)=>{
            const { skipToContentTarget } = this.props;
            if (skipToContentTarget && skipToContentTarget.current) {
                skipToContentTarget.current.focus();
                event === null || event === void 0 || event.preventDefault();
            }
        };
        this.handleNavigationDismiss = ()=>{
            const { onNavigationDismiss } = this.props;
            if (onNavigationDismiss != null) onNavigationDismiss();
        };
        this.setGlobalRibbonContainer = (node)=>{
            this.globalRibbonContainer = node;
        };
        this.handleNavKeydown = (event)=>{
            const { key } = event;
            const { mediaQuery: { isNavigationCollapsed }, showMobileNavigation } = this.props;
            const mobileNavShowing = isNavigationCollapsed && showMobileNavigation;
            if (mobileNavShowing && key === "Escape") this.handleNavigationDismiss();
        };
    }
    componentDidMount() {
        this.handleResize();
        if (this.props.globalRibbon) return;
        this.setGlobalRibbonRootProperty();
        this.setOffset();
    }
    componentDidUpdate(prevProps) {
        if (this.props.globalRibbon !== prevProps.globalRibbon) this.setGlobalRibbonHeight();
        this.setOffset();
    }
    render() {
        const { skipFocused, loadingStack, toastMessages, showContextualSaveBar } = this.state;
        const { logo, children, navigation, topBar, globalRibbon, showMobileNavigation = false, skipToContentTarget, i18n, mediaQuery: { isNavigationCollapsed } } = this.props;
        const navClassName = (0, _cssJs.classNames)((0, _frameScssJsDefault.default).Navigation, showMobileNavigation && (0, _frameScssJsDefault.default)["Navigation-visible"]);
        const mobileNavHidden = isNavigationCollapsed && !showMobileNavigation;
        const mobileNavShowing = isNavigationCollapsed && showMobileNavigation;
        const tabIndex = mobileNavShowing ? 0 : -1;
        const mobileNavAttributes = {
            ...mobileNavShowing && {
                "aria-modal": true,
                role: "dialog"
            }
        };
        const navigationMarkup = navigation ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trapFocusJs.TrapFocus), {
            trapping: mobileNavShowing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.CSSTransition), {
            nodeRef: this.navigationNode,
            appear: isNavigationCollapsed,
            exit: isNavigationCollapsed,
            in: showMobileNavigation,
            timeout: parseInt((0, _polarisTokens.motion)["duration-300"], 10),
            classNames: navTransitionClasses
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
            key: "NavContent"
        }, mobileNavAttributes, {
            "aria-label": i18n.translate("Polaris.Frame.navigationLabel"),
            ref: this.navigationNode,
            className: navClassName,
            onKeyDown: this.handleNavKeydown,
            id: APP_FRAME_NAV,
            hidden: mobileNavHidden
        }), navigation, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            className: (0, _frameScssJsDefault.default).NavigationDismiss,
            onClick: this.handleNavigationDismiss,
            "aria-hidden": mobileNavHidden || !isNavigationCollapsed && !showMobileNavigation,
            "aria-label": i18n.translate("Polaris.Frame.Navigation.closeMobileNavigationLabel"),
            tabIndex: tabIndex
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
            source: (0, _polarisIcons.MobileCancelMajor)
        }))))) : null;
        const loadingMarkup = loadingStack > 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _frameScssJsDefault.default).LoadingBar,
            id: APP_FRAME_LOADING_BAR
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingJs.Loading), null)) : null;
        const contextualSaveBarMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cssanimationJs.CSSAnimation), {
            in: showContextualSaveBar,
            className: (0, _frameScssJsDefault.default).ContextualSaveBar,
            type: "fade"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextualSaveBarJs.ContextualSaveBar), this.contextualSaveBar));
        const topBarMarkup = topBar ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
            className: (0, _frameScssJsDefault.default).TopBar
        }, (0, _sharedJs.layer).props, (0, _sharedJs.dataPolarisTopBar).props, {
            id: APP_FRAME_TOP_BAR
        }), topBar) : null;
        const globalRibbonMarkup = globalRibbon ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _frameScssJsDefault.default).GlobalRibbonContainer,
            ref: this.setGlobalRibbonContainer
        }, globalRibbon) : null;
        const skipClassName = (0, _cssJs.classNames)((0, _frameScssJsDefault.default).Skip, skipFocused && (0, _frameScssJsDefault.default).focused);
        const skipTarget = skipToContentTarget !== null && skipToContentTarget !== void 0 && skipToContentTarget.current ? skipToContentTarget.current.id : APP_FRAME_MAIN;
        const skipMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: skipClassName
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: `#${skipTarget}`,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onClick: this.handleClick
        }, i18n.translate("Polaris.Frame.skipToContent")));
        const navigationAttributes = navigation ? {
            "data-has-navigation": true
        } : {};
        const frameClassName = (0, _cssJs.classNames)((0, _frameScssJsDefault.default).Frame, navigation && (0, _frameScssJsDefault.default).hasNav, topBar && (0, _frameScssJsDefault.default).hasTopBar);
        const navigationOverlayMarkup = showMobileNavigation && isNavigationCollapsed ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _backdropJs.Backdrop), {
            belowNavigation: true,
            onClick: this.handleNavigationDismiss,
            onTouchStart: this.handleNavigationDismiss
        }) : null; // This is probably a legit error but I don't have the time to refactor this
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        const context = {
            logo,
            showToast: this.showToast,
            hideToast: this.hideToast,
            startLoading: this.startLoading,
            stopLoading: this.stopLoading,
            setContextualSaveBar: this.setContextualSaveBar,
            removeContextualSaveBar: this.removeContextualSaveBar
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.FrameContext).Provider, {
            value: context
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
            className: frameClassName
        }, (0, _sharedJs.layer).props, navigationAttributes), skipMarkup, topBarMarkup, navigationMarkup, contextualSaveBarMarkup, loadingMarkup, navigationOverlayMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("main", {
            className: (0, _frameScssJsDefault.default).Main,
            id: APP_FRAME_MAIN,
            "data-has-global-ribbon": Boolean(globalRibbon)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _frameScssJsDefault.default).Content
        }, children)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toastManagerJs.ToastManager), {
            toastMessages: toastMessages
        }), globalRibbonMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
            event: "resize",
            handler: this.handleResize
        })));
    }
}
const navTransitionClasses = {
    enter: (0, _cssJs.classNames)((0, _frameScssJsDefault.default)["Navigation-enter"]),
    enterActive: (0, _cssJs.classNames)((0, _frameScssJsDefault.default)["Navigation-enterActive"]),
    enterDone: (0, _cssJs.classNames)((0, _frameScssJsDefault.default)["Navigation-enterActive"]),
    exit: (0, _cssJs.classNames)((0, _frameScssJsDefault.default)["Navigation-exit"]),
    exitActive: (0, _cssJs.classNames)((0, _frameScssJsDefault.default)["Navigation-exitActive"])
};
function Frame(props) {
    const i18n = (0, _hooksJs.useI18n)();
    const mediaQuery = (0, _hooksJs1.useMediaQuery)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FrameInner, Object.assign({}, props, {
        i18n: i18n,
        mediaQuery: mediaQuery
    }));
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","react-transition-group":"1qdFK","@shopify/polaris-tokens":"5ENVX","../../utilities/css.js":"lGt6N","../shared.js":"lFbIK","../../utilities/set-root-property.js":"bTQth","./Frame.scss.js":"bk4cK","./components/Loading/Loading.js":"9rFCW","./components/CSSAnimation/CSSAnimation.js":"bsCOF","./components/ContextualSaveBar/ContextualSaveBar.js":"crm52","../../utilities/frame/context.js":"0vqts","./components/ToastManager/ToastManager.js":"jyxQn","../../utilities/i18n/hooks.js":"hhMhA","../../utilities/media-query/hooks.js":"jzbEF","../TrapFocus/TrapFocus.js":"izXDF","../Icon/Icon.js":"6HPny","../Backdrop/Backdrop.js":"dJt5R","../EventListener/EventListener.js":"jV8kW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bTQth":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setRootProperty", ()=>setRootProperty);
function setRootProperty(name, value, node) {
    if (!document) return;
    const element = node || document.documentElement;
    element.style.setProperty(name, value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bk4cK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Frame": "Polaris-Frame",
    "Navigation": "Polaris-Frame__Navigation",
    "hasTopBar": "Polaris-Frame--hasTopBar",
    "Navigation-enter": "Polaris-Frame__Navigation--enter",
    "Navigation-enterActive": "Polaris-Frame__Navigation--enterActive",
    "Navigation-exit": "Polaris-Frame__Navigation--exit",
    "Navigation-exitActive": "Polaris-Frame__Navigation--exitActive",
    "NavigationDismiss": "Polaris-Frame__NavigationDismiss",
    "Navigation-visible": "Polaris-Frame__Navigation--visible",
    "TopBar": "Polaris-Frame__TopBar",
    "ContextualSaveBar": "Polaris-Frame__ContextualSaveBar",
    "Main": "Polaris-Frame__Main",
    "hasNav": "Polaris-Frame--hasNav",
    "Content": "Polaris-Frame__Content",
    "GlobalRibbonContainer": "Polaris-Frame__GlobalRibbonContainer",
    "LoadingBar": "Polaris-Frame__LoadingBar",
    "Skip": "Polaris-Frame__Skip",
    "focused": "Polaris-Frame--focused",
    "pressed": "Polaris-Frame--pressed"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9rFCW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Loading", ()=>Loading);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsMountedRefJs = require("../../../../utilities/use-is-mounted-ref.js");
var _loadingScssJs = require("./Loading.scss.js");
var _loadingScssJsDefault = parcelHelpers.interopDefault(_loadingScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
const STUCK_THRESHOLD = 99;
function Loading() {
    const i18n = (0, _hooksJs.useI18n)();
    const isMountedRef = (0, _useIsMountedRefJs.useIsMountedRef)();
    const [progress, setProgress] = (0, _react.useState)(0);
    const [animating, setAnimating] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (progress >= STUCK_THRESHOLD || animating) return;
        requestAnimationFrame(()=>{
            if (!isMountedRef.current) return;
            const step = Math.max((STUCK_THRESHOLD - progress) / 10, 1);
            setAnimating(true);
            setProgress(progress + step);
        });
    }, [
        progress,
        animating,
        isMountedRef
    ]);
    const customStyles = {
        transform: `scaleX(${Math.floor(progress) / 100})`
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _loadingScssJsDefault.default).Loading,
        "aria-valuenow": progress,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        role: "progressbar",
        "aria-label": i18n.translate("Polaris.Loading.label")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _loadingScssJsDefault.default).Level,
        style: customStyles,
        onTransitionEnd: ()=>setAnimating(false)
    }));
}

},{"react":"cOWTg","../../../../utilities/use-is-mounted-ref.js":"1Gr7T","./Loading.scss.js":"36Fim","../../../../utilities/i18n/hooks.js":"hhMhA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1Gr7T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMountedRef", ()=>useIsMountedRef);
var _react = require("react");
/**
 * Returns a MutatableRefObject containing a boolean value that
 * represents a components mounted status.
 * @returns MutableRefObject<boolean> The mounted status
 */ function useIsMountedRef() {
    const isMounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"36Fim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Loading": "Polaris-Frame-Loading",
    "Level": "Polaris-Frame-Loading__Level"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bsCOF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSAnimation", ()=>CSSAnimation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _cssanimationScssJs = require("./CSSAnimation.scss.js");
var _cssanimationScssJsDefault = parcelHelpers.interopDefault(_cssanimationScssJs);
var TransitionStatus;
(function(TransitionStatus) {
    TransitionStatus["Entering"] = "entering";
    TransitionStatus["Entered"] = "entered";
    TransitionStatus["Exiting"] = "exiting";
    TransitionStatus["Exited"] = "exited";
})(TransitionStatus || (TransitionStatus = {}));
function CSSAnimation({ in: inProp, className, type, children }) {
    const [transitionStatus, setTransitionStatus] = (0, _react.useState)(inProp ? TransitionStatus.Entering : TransitionStatus.Exited);
    const isMounted = (0, _react.useRef)(false);
    const node = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!isMounted.current) return;
        transitionStatus === TransitionStatus.Entering && changeTransitionStatus(TransitionStatus.Entered);
    }, [
        transitionStatus
    ]);
    (0, _react.useEffect)(()=>{
        if (!isMounted.current) return;
        inProp && changeTransitionStatus(TransitionStatus.Entering);
        !inProp && changeTransitionStatus(TransitionStatus.Exiting);
    }, [
        inProp
    ]);
    (0, _react.useEffect)(()=>{
        isMounted.current = true;
    }, []);
    const wrapperClassName = (0, _cssJs.classNames)(className, (0, _cssanimationScssJsDefault.default)[(0, _cssJs.variationName)("start", type)], inProp && (0, _cssanimationScssJsDefault.default)[(0, _cssJs.variationName)("end", type)]);
    const content = transitionStatus === TransitionStatus.Exited && !inProp ? null : children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: wrapperClassName,
        ref: node,
        onTransitionEnd: handleTransitionEnd
    }, content);
    function handleTransitionEnd() {
        transitionStatus === TransitionStatus.Exiting && changeTransitionStatus(TransitionStatus.Exited);
    }
    function changeTransitionStatus(transitionStatus) {
        setTransitionStatus(transitionStatus); // Forcing a reflow to enable the animation
        if (transitionStatus === TransitionStatus.Entering) node.current && node.current.getBoundingClientRect();
    }
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./CSSAnimation.scss.js":"6O3mJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6O3mJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "startFade": "Polaris-Frame-CSSAnimation--startFade",
    "endFade": "Polaris-Frame-CSSAnimation--endFade"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"crm52":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextualSaveBar", ()=>ContextualSaveBar);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _getWidthJs = require("../../../../utilities/get-width.js");
var _useToggleJs = require("../../../../utilities/use-toggle.js");
var _contextualSaveBarScssJs = require("./ContextualSaveBar.scss.js");
var _contextualSaveBarScssJsDefault = parcelHelpers.interopDefault(_contextualSaveBarScssJs);
var _discardConfirmationModalJs = require("./components/DiscardConfirmationModal/DiscardConfirmationModal.js");
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../../../utilities/frame/hooks.js");
var _buttonJs = require("../../../Button/Button.js");
var _imageJs = require("../../../Image/Image.js");
var _textJs = require("../../../Text/Text.js");
var _legacyStackJs = require("../../../LegacyStack/LegacyStack.js");
function ContextualSaveBar({ alignContentFlush, message, saveAction, discardAction, fullWidth, contextControl, secondaryMenu }) {
    const i18n = (0, _hooksJs.useI18n)();
    const { logo } = (0, _hooksJs1.useFrame)();
    const { value: discardConfirmationModalVisible, toggle: toggleDiscardConfirmationModal, setFalse: closeDiscardConfirmationModal } = (0, _useToggleJs.useToggle)(false);
    const handleDiscardAction = (0, _react.useCallback)(()=>{
        if (discardAction && discardAction.onAction) discardAction.onAction();
        closeDiscardConfirmationModal();
    }, [
        closeDiscardConfirmationModal,
        discardAction
    ]);
    const discardActionContent = discardAction && discardAction.content ? discardAction.content : i18n.translate("Polaris.ContextualSaveBar.discard");
    let discardActionHandler;
    if (discardAction && discardAction.discardConfirmationModal) discardActionHandler = toggleDiscardConfirmationModal;
    else if (discardAction) discardActionHandler = discardAction.onAction;
    const discardConfirmationModalMarkup = discardAction && discardAction.onAction && discardAction.discardConfirmationModal && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _discardConfirmationModalJs.DiscardConfirmationModal), {
        open: discardConfirmationModalVisible,
        onCancel: toggleDiscardConfirmationModal,
        onDiscard: handleDiscardAction
    });
    const discardActionMarkup = discardAction && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        url: discardAction.url,
        onClick: discardActionHandler,
        loading: discardAction.loading,
        disabled: discardAction.disabled,
        accessibilityLabel: discardAction.content
    }, discardActionContent);
    const saveActionContent = saveAction && saveAction.content ? saveAction.content : i18n.translate("Polaris.ContextualSaveBar.save");
    const saveActionMarkup = saveAction && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        primary: true,
        url: saveAction.url,
        onClick: saveAction.onAction,
        loading: saveAction.loading,
        disabled: saveAction.disabled,
        accessibilityLabel: saveAction.content
    }, saveActionContent);
    const width = (0, _getWidthJs.getWidth)(logo, 104);
    const imageMarkup = logo && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
        style: {
            width
        },
        source: logo.contextualSaveBarSource || "",
        alt: ""
    });
    const logoMarkup = alignContentFlush || contextControl ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _contextualSaveBarScssJsDefault.default).LogoContainer,
        style: {
            width
        }
    }, imageMarkup);
    const contextControlMarkup = contextControl ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _contextualSaveBarScssJsDefault.default).ContextControl
    }, contextControl) : null;
    const contentsClassName = (0, _cssJs.classNames)((0, _contextualSaveBarScssJsDefault.default).Contents, fullWidth && (0, _contextualSaveBarScssJsDefault.default).fullWidth);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _contextualSaveBarScssJsDefault.default).ContextualSaveBar
    }, contextControlMarkup, logoMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: contentsClassName
    }, message && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "h2",
        variant: "headingMd",
        color: "text-inverse",
        truncate: true
    }, message), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _contextualSaveBarScssJsDefault.default).ActionContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack), {
        spacing: "tight",
        wrap: false
    }, secondaryMenu, discardActionMarkup, saveActionMarkup)))), discardConfirmationModalMarkup);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/get-width.js":"j1LQp","../../../../utilities/use-toggle.js":"2kpDL","./ContextualSaveBar.scss.js":"hgdCb","./components/DiscardConfirmationModal/DiscardConfirmationModal.js":"8Va7E","../../../../utilities/i18n/hooks.js":"hhMhA","../../../../utilities/frame/hooks.js":"3aY41","../../../Button/Button.js":"6Szv4","../../../Image/Image.js":"5iL1c","../../../Text/Text.js":"l8Av9","../../../LegacyStack/LegacyStack.js":"5pyyM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j1LQp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWidth", ()=>getWidth);
var _pluckDeepJs = require("./pluck-deep.js");
function getWidth(value = {}, defaultWidth = 0, key = "width") {
    const width = typeof value === "number" ? value : (0, _pluckDeepJs.pluckDeep)(value, key);
    return width ? `${width}px` : `${defaultWidth}px`;
}

},{"./pluck-deep.js":"aHvzb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aHvzb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pluckDeep", ()=>pluckDeep);
var _isObjectJs = require("./is-object.js");
function pluckDeep(obj, key) {
    if (!obj) return null;
    const keys = Object.keys(obj);
    for (const currKey of keys){
        if (currKey === key) return obj[key];
        if ((0, _isObjectJs.isObject)(obj[currKey])) {
            const plucked = pluckDeep(obj[currKey], key);
            if (plucked) return plucked;
        }
    }
    return null;
}

},{"./is-object.js":"6btuO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6btuO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hgdCb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ContextualSaveBar": "Polaris-Frame-ContextualSaveBar",
    "LogoContainer": "Polaris-Frame-ContextualSaveBar__LogoContainer",
    "ContextControl": "Polaris-Frame-ContextualSaveBar__ContextControl",
    "Contents": "Polaris-Frame-ContextualSaveBar__Contents",
    "fullWidth": "Polaris-Frame-ContextualSaveBar--fullWidth",
    "ActionContainer": "Polaris-Frame-ContextualSaveBar__ActionContainer",
    "Action": "Polaris-Frame-ContextualSaveBar__Action"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Va7E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiscardConfirmationModal", ()=>DiscardConfirmationModal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooksJs = require("../../../../../../utilities/i18n/hooks.js");
var _modalJs = require("../../../../../Modal/Modal.js");
function DiscardConfirmationModal({ open, onDiscard, onCancel }) {
    const i18n = (0, _hooksJs.useI18n)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalJs.Modal), {
        title: i18n.translate("Polaris.DiscardConfirmationModal.title"),
        open: open,
        onClose: onCancel,
        primaryAction: {
            content: i18n.translate("Polaris.DiscardConfirmationModal.primaryAction"),
            destructive: true,
            onAction: onDiscard
        },
        secondaryActions: [
            {
                content: i18n.translate("Polaris.DiscardConfirmationModal.secondaryAction"),
                onAction: onCancel
            }
        ],
        sectioned: true
    }, i18n.translate("Polaris.DiscardConfirmationModal.message"));
}

},{"react":"cOWTg","../../../../../../utilities/i18n/hooks.js":"hhMhA","../../../../../Modal/Modal.js":"bzxRZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bzxRZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>Modal);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _focusJs = require("../../utilities/focus.js");
var _hooksJs = require("../../utilities/unique-id/hooks.js");
var _withinContentContextJs = require("../../utilities/within-content-context.js");
var _componentsJs = require("../../utilities/components.js");
var _modalScssJs = require("./Modal.scss.js");
var _modalScssJsDefault = parcelHelpers.interopDefault(_modalScssJs);
var _sectionJs = require("./components/Section/Section.js");
var _dialogJs = require("./components/Dialog/Dialog.js");
var _headerJs = require("./components/Header/Header.js");
var _backdropJs = require("../Backdrop/Backdrop.js");
var _footerJs = require("./components/Footer/Footer.js");
var _hooksJs1 = require("../../utilities/i18n/hooks.js");
var _boxJs = require("../Box/Box.js");
var _scrollableJs = require("../Scrollable/Scrollable.js");
var _portalJs = require("../Portal/Portal.js");
var _horizontalStackJs = require("../HorizontalStack/HorizontalStack.js");
var _spinnerJs = require("../Spinner/Spinner.js");
const IFRAME_LOADING_HEIGHT = 200;
const DEFAULT_IFRAME_CONTENT_HEIGHT = 400;
const Modal = function Modal({ children, title, titleHidden = false, src, iFrameName, open, instant, sectioned, loading, large, small, limitHeight, footer, primaryAction, secondaryActions, onScrolledToBottom, activator, onClose, onIFrameLoad, onTransitionEnd, noScroll, fullScreen }) {
    const [iframeHeight, setIframeHeight] = (0, _react.useState)(IFRAME_LOADING_HEIGHT);
    const [closing, setClosing] = (0, _react.useState)(false);
    const headerId = (0, _hooksJs.useUniqueId)("modal-header");
    const activatorRef = (0, _react.useRef)(null);
    const i18n = (0, _hooksJs1.useI18n)();
    const iframeTitle = i18n.translate("Polaris.Modal.iFrameTitle");
    let dialog;
    let backdrop;
    const handleEntered = (0, _react.useCallback)(()=>{
        if (onTransitionEnd) onTransitionEnd();
    }, [
        onTransitionEnd
    ]);
    const handleExited = (0, _react.useCallback)(()=>{
        setIframeHeight(IFRAME_LOADING_HEIGHT);
        const activatorElement = activator && isRef(activator) ? activator && activator.current : activatorRef.current;
        if (activatorElement) requestAnimationFrame(()=>(0, _focusJs.focusFirstFocusableNode)(activatorElement));
    }, [
        activator
    ]);
    const handleIFrameLoad = (0, _react.useCallback)((evt)=>{
        const iframe = evt.target;
        if (iframe && iframe.contentWindow) try {
            setIframeHeight(iframe.contentWindow.document.body.scrollHeight);
        } catch (_error) {
            setIframeHeight(DEFAULT_IFRAME_CONTENT_HEIGHT);
        }
        if (onIFrameLoad != null) onIFrameLoad(evt);
    }, [
        onIFrameLoad
    ]);
    if (open) {
        const footerMarkup = !footer && !primaryAction && !secondaryActions ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _footerJs.Footer), {
            primaryAction: primaryAction,
            secondaryActions: secondaryActions
        }, footer);
        const content = sectioned ? (0, _componentsJs.wrapWithComponent)(children, (0, _sectionJs.Section), {
            titleHidden
        }) : children;
        const body = loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            padding: "4"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
            gap: "4",
            align: "center",
            blockAlign: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerJs.Spinner), null))) : content;
        const scrollContainerMarkup = noScroll ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            width: "100%",
            overflowX: "hidden"
        }, body) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollableJs.Scrollable), {
            shadow: true,
            className: (0, _modalScssJsDefault.default).Body,
            onScrolledToBottom: onScrolledToBottom
        }, body);
        const bodyMarkup = src ? /*#__PURE__*/ (0, _reactDefault.default).createElement("iframe", {
            name: iFrameName,
            title: iframeTitle,
            src: src,
            className: (0, _modalScssJsDefault.default).IFrame,
            onLoad: handleIFrameLoad,
            style: {
                height: `${iframeHeight}px`
            }
        }) : scrollContainerMarkup;
        dialog = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dialogJs.Dialog), {
            instant: instant,
            labelledBy: headerId,
            onClose: onClose,
            onEntered: handleEntered,
            onExited: handleExited,
            large: large,
            small: small,
            limitHeight: limitHeight,
            fullScreen: fullScreen,
            setClosing: setClosing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headerJs.Header), {
            titleHidden: titleHidden,
            id: headerId,
            closing: closing,
            onClose: onClose
        }, title), bodyMarkup, footerMarkup);
        backdrop = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _backdropJs.Backdrop), {
            setClosing: setClosing,
            onClick: onClose
        });
    }
    const animated = !instant;
    const activatorMarkup = activator && !isRef(activator) ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        ref: activatorRef
    }, activator) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _withinContentContextJs.WithinContentContext).Provider, {
        value: true
    }, activatorMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalJs.Portal), {
        idPrefix: "modal"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.TransitionGroup), {
        appear: animated,
        enter: animated,
        exit: animated
    }, dialog), backdrop));
};
function isRef(ref) {
    return Object.prototype.hasOwnProperty.call(ref, "current");
}
Modal.Section = (0, _sectionJs.Section);

},{"react":"cOWTg","react-transition-group":"1qdFK","../../utilities/focus.js":"b0pEc","../../utilities/unique-id/hooks.js":"2JfcO","../../utilities/within-content-context.js":"cUmFU","../../utilities/components.js":"6Xyqa","./Modal.scss.js":"5KHtd","./components/Section/Section.js":"gDJ72","./components/Dialog/Dialog.js":"aLBtI","./components/Header/Header.js":"gyBez","../Backdrop/Backdrop.js":"dJt5R","./components/Footer/Footer.js":"axDxG","../../utilities/i18n/hooks.js":"hhMhA","../Box/Box.js":"lbjkG","../Scrollable/Scrollable.js":"587xt","../Portal/Portal.js":"3wn3c","../HorizontalStack/HorizontalStack.js":"fotqA","../Spinner/Spinner.js":"43SMY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5KHtd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Body": "Polaris-Modal__Body",
    "IFrame": "Polaris-Modal__IFrame"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gDJ72":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _sectionScssJs = require("./Section.scss.js");
var _sectionScssJsDefault = parcelHelpers.interopDefault(_sectionScssJs);
var _boxJs = require("../../../Box/Box.js");
function Section({ children, flush = false, subdued = false, titleHidden = false }) {
    const className = (0, _cssJs.classNames)((0, _sectionScssJsDefault.default).Section, titleHidden && (0, _sectionScssJsDefault.default).titleHidden);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), Object.assign({
        as: "section",
        padding: flush ? "0" : "5"
    }, titleHidden && {
        paddingInlineEnd: "0"
    }, subdued && {
        background: "bg-subdued"
    }), children));
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./Section.scss.js":"RO0sn","../../../Box/Box.js":"lbjkG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"RO0sn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Section": "Polaris-Modal-Section",
    "titleHidden": "Polaris-Modal-Section--titleHidden"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aLBtI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _polarisTokens = require("@shopify/polaris-tokens");
var _cssJs = require("../../../../utilities/css.js");
var _focusJs = require("../../../../utilities/focus.js");
var _typesJs = require("../../../../types.js");
var _dialogScssJs = require("./Dialog.scss.js");
var _dialogScssJsDefault = parcelHelpers.interopDefault(_dialogScssJs);
var _trapFocusJs = require("../../../TrapFocus/TrapFocus.js");
var _keypressListenerJs = require("../../../KeypressListener/KeypressListener.js");
function Dialog({ instant, labelledBy, children, onClose, onExited, onEntered, large, small, limitHeight, fullScreen, setClosing, ...props }) {
    const containerNode = (0, _react.useRef)(null);
    const classes = (0, _cssJs.classNames)((0, _dialogScssJsDefault.default).Modal, small && (0, _dialogScssJsDefault.default).sizeSmall, large && (0, _dialogScssJsDefault.default).sizeLarge, limitHeight && (0, _dialogScssJsDefault.default).limitHeight, fullScreen && (0, _dialogScssJsDefault.default).fullScreen);
    const TransitionChild = instant ? (0, _reactTransitionGroup.Transition) : FadeUp;
    (0, _react.useEffect)(()=>{
        containerNode.current && !containerNode.current.contains(document.activeElement) && (0, _focusJs.focusFirstFocusableNode)(containerNode.current);
    }, []);
    const handleKeyDown = ()=>{
        if (setClosing) setClosing(true);
    };
    const handleKeyUp = ()=>{
        if (setClosing) setClosing(false);
        onClose();
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TransitionChild, Object.assign({}, props, {
        nodeRef: containerNode,
        mountOnEnter: true,
        unmountOnExit: true,
        timeout: parseInt((0, _polarisTokens.motion)["duration-200"], 10),
        onEntered: onEntered,
        onExited: onExited
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _dialogScssJsDefault.default).Container,
        "data-polaris-layer": true,
        "data-polaris-overlay": true,
        ref: containerNode
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trapFocusJs.TrapFocus), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "dialog",
        "aria-modal": true,
        "aria-label": labelledBy,
        "aria-labelledby": labelledBy,
        tabIndex: -1,
        className: (0, _dialogScssJsDefault.default).Dialog
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyCode: (0, _typesJs.Key).Escape,
        keyEvent: "keydown",
        handler: handleKeyDown
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyCode: (0, _typesJs.Key).Escape,
        handler: handleKeyUp
    }), children)))));
}
const fadeUpClasses = {
    appear: (0, _cssJs.classNames)((0, _dialogScssJsDefault.default).animateFadeUp, (0, _dialogScssJsDefault.default).entering),
    appearActive: (0, _cssJs.classNames)((0, _dialogScssJsDefault.default).animateFadeUp, (0, _dialogScssJsDefault.default).entered),
    enter: (0, _cssJs.classNames)((0, _dialogScssJsDefault.default).animateFadeUp, (0, _dialogScssJsDefault.default).entering),
    enterActive: (0, _cssJs.classNames)((0, _dialogScssJsDefault.default).animateFadeUp, (0, _dialogScssJsDefault.default).entered),
    exit: (0, _cssJs.classNames)((0, _dialogScssJsDefault.default).animateFadeUp, (0, _dialogScssJsDefault.default).exiting),
    exitActive: (0, _cssJs.classNames)((0, _dialogScssJsDefault.default).animateFadeUp, (0, _dialogScssJsDefault.default).exited)
};
function FadeUp({ children, ...props }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.CSSTransition), Object.assign({}, props, {
        classNames: fadeUpClasses
    }), children);
}

},{"react":"cOWTg","react-transition-group":"1qdFK","@shopify/polaris-tokens":"5ENVX","../../../../utilities/css.js":"lGt6N","../../../../utilities/focus.js":"b0pEc","../../../../types.js":"6NE7w","./Dialog.scss.js":"aEloS","../../../TrapFocus/TrapFocus.js":"izXDF","../../../KeypressListener/KeypressListener.js":"1eFmF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aEloS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Container": "Polaris-Modal-Dialog__Container",
    "Dialog": "Polaris-Modal-Dialog",
    "Modal": "Polaris-Modal-Dialog__Modal",
    "limitHeight": "Polaris-Modal-Dialog--limitHeight",
    "sizeSmall": "Polaris-Modal-Dialog--sizeSmall",
    "sizeLarge": "Polaris-Modal-Dialog--sizeLarge",
    "fullScreen": "Polaris-Modal-Dialog--fullScreen",
    "animateFadeUp": "Polaris-Modal-Dialog--animateFadeUp",
    "entering": "Polaris-Modal-Dialog--entering",
    "exiting": "Polaris-Modal-Dialog--exiting",
    "exited": "Polaris-Modal-Dialog--exited",
    "entered": "Polaris-Modal-Dialog--entered"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gyBez":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _horizontalGridJs = require("../../../HorizontalGrid/HorizontalGrid.js");
var _closeButtonJs = require("../CloseButton/CloseButton.js");
var _boxJs = require("../../../Box/Box.js");
var _horizontalStackJs = require("../../../HorizontalStack/HorizontalStack.js");
var _textJs = require("../../../Text/Text.js");
function Header({ id, children, closing, titleHidden, onClose }) {
    const titleHiddenMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        position: "absolute",
        insetInlineEnd: "0",
        zIndex: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        align: "end",
        blockAlign: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeButtonJs.CloseButton), {
        titleHidden: titleHidden,
        onClick: onClose
    })));
    if (titleHidden || !children) return titleHiddenMarkup;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: "4",
        paddingBlockEnd: "4",
        paddingInlineStart: "5",
        paddingInlineEnd: "5",
        borderBlockEndWidth: "1",
        borderColor: "border-subdued"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalGridJs.HorizontalGrid), {
        columns: {
            xs: "1fr auto"
        },
        gap: "4"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        blockAlign: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        id: id,
        as: "h2",
        variant: "headingLg",
        breakWord: true
    }, children)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeButtonJs.CloseButton), {
        pressed: closing,
        titleHidden: titleHidden,
        onClick: onClose
    })));
}

},{"react":"cOWTg","../../../HorizontalGrid/HorizontalGrid.js":"6vqWM","../CloseButton/CloseButton.js":"ductO","../../../Box/Box.js":"lbjkG","../../../HorizontalStack/HorizontalStack.js":"fotqA","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ductO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseButton", ()=>CloseButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../../../utilities/css.js");
var _closeButtonScssJs = require("./CloseButton.scss.js");
var _closeButtonScssJsDefault = parcelHelpers.interopDefault(_closeButtonScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _iconJs = require("../../../Icon/Icon.js");
function CloseButton({ pressed, titleHidden = false, onClick }) {
    const i18n = (0, _hooksJs.useI18n)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: onClick,
        className: (0, _cssJs.classNames)((0, _closeButtonScssJsDefault.default).CloseButton, titleHidden && (0, _closeButtonScssJsDefault.default).titleHidden, pressed && (0, _closeButtonScssJsDefault.default).pressed),
        "aria-label": i18n.translate("Polaris.Common.close")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.MobileCancelMajor),
        color: "base"
    }));
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/css.js":"lGt6N","./CloseButton.scss.js":"6cERf","../../../../utilities/i18n/hooks.js":"hhMhA","../../../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6cERf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "CloseButton": "Polaris-Modal-CloseButton",
    "pressed": "Polaris-Modal-CloseButton--pressed",
    "titleHidden": "Polaris-Modal-CloseButton--titleHidden"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"axDxG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utilsJs = require("../../../Button/utils.js");
var _horizontalStackJs = require("../../../HorizontalStack/HorizontalStack.js");
var _boxJs = require("../../../Box/Box.js");
function Footer({ primaryAction, secondaryActions, children }) {
    const primaryActionButton = primaryAction && (0, _utilsJs.buttonsFrom)(primaryAction, {
        primary: true
    }) || null;
    const secondaryActionButtons = secondaryActions && (0, _utilsJs.buttonsFrom)(secondaryActions) || null;
    const actions = primaryActionButton || secondaryActionButtons ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "2"
    }, secondaryActionButtons, primaryActionButton) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        blockAlign: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        borderColor: "border-subdued",
        borderBlockStartWidth: "1",
        minHeight: "var(--p-space-16)",
        padding: "4",
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        blockAlign: "center",
        align: "space-between"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), null, children), actions)));
}

},{"react":"cOWTg","../../../Button/utils.js":"drbMl","../../../HorizontalStack/HorizontalStack.js":"fotqA","../../../Box/Box.js":"lbjkG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3aY41":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFrame", ()=>useFrame);
var _react = require("react");
var _contextJs = require("./context.js");
function useFrame() {
    const frame = (0, _react.useContext)((0, _contextJs.FrameContext));
    if (!frame) throw new Error("No Frame context was provided. Your component must be wrapped in a <Frame> component. See https://polaris.shopify.com/components/frame for implementation instructions.");
    return frame;
}

},{"react":"cOWTg","./context.js":"0vqts","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"0vqts":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FrameContext", ()=>FrameContext);
var _react = require("react");
const FrameContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jyxQn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToastManager", ()=>ToastManager);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _cssJs = require("../../../../utilities/css.js");
var _useDeepEffectJs = require("../../../../utilities/use-deep-effect.js");
var _useDeepCallbackJs = require("../../../../utilities/use-deep-callback.js");
var _toastManagerScssJs = require("./ToastManager.scss.js");
var _toastManagerScssJsDefault = parcelHelpers.interopDefault(_toastManagerScssJs);
var _toastJs = require("../Toast/Toast.js");
var _portalJs = require("../../../Portal/Portal.js");
var _eventListenerJs = require("../../../EventListener/EventListener.js");
const ToastManager = /*#__PURE__*/ (0, _react.memo)(function ToastManager({ toastMessages }) {
    const toastNodes = [];
    const updateToasts = (0, _useDeepCallbackJs.useDeepCallback)(()=>{
        let targetInPos = 0;
        toastMessages.forEach((_, index)=>{
            const currentToast = toastNodes[index];
            if (!currentToast.current) return;
            targetInPos += currentToast.current.clientHeight;
            currentToast.current.style.setProperty("--pc-toast-manager-translate-y-in", `-${targetInPos}px`);
            currentToast.current.style.setProperty("--pc-toast-manager-translate-y-out", `${-targetInPos + 150}px`);
        });
    }, [
        toastMessages,
        toastNodes
    ]);
    (0, _useDeepEffectJs.useDeepEffect)(()=>{
        updateToasts();
    }, [
        toastMessages
    ]);
    const toastsMarkup = toastMessages.map((toast, index)=>{
        const toastNode = /*#__PURE__*/ (0, _react.createRef)();
        toastNodes[index] = toastNode;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.CSSTransition), {
            nodeRef: toastNodes[index],
            key: toast.id,
            timeout: {
                enter: 0,
                exit: 400
            },
            classNames: toastClasses
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: toastNode
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toastJs.Toast), toast)));
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalJs.Portal), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
        event: "resize",
        handler: updateToasts
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _toastManagerScssJsDefault.default).ToastManager,
        "aria-live": "assertive"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.TransitionGroup), {
        component: null
    }, toastsMarkup)));
});
const toastClasses = {
    enter: (0, _cssJs.classNames)((0, _toastManagerScssJsDefault.default).ToastWrapper, (0, _toastManagerScssJsDefault.default)["ToastWrapper-enter"]),
    enterDone: (0, _cssJs.classNames)((0, _toastManagerScssJsDefault.default).ToastWrapper, (0, _toastManagerScssJsDefault.default)["ToastWrapper-enter-done"]),
    exit: (0, _cssJs.classNames)((0, _toastManagerScssJsDefault.default).ToastWrapper, (0, _toastManagerScssJsDefault.default)["ToastWrapper-exit"])
};

},{"react":"cOWTg","react-transition-group":"1qdFK","../../../../utilities/css.js":"lGt6N","../../../../utilities/use-deep-effect.js":"4eElT","../../../../utilities/use-deep-callback.js":"7T8Nm","./ToastManager.scss.js":"5ksUn","../Toast/Toast.js":"1PleR","../../../Portal/Portal.js":"3wn3c","../../../EventListener/EventListener.js":"jV8kW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4eElT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepEffect", ()=>useDeepEffect);
var _react = require("react");
var _useDeepCompareRefJs = require("./use-deep-compare-ref.js");
/**
 * A replacement for React's useEffect that'll allow for custom and deep
 * compares of the dependency list.
 * @see {@link https://reactjs.org/docs/hooks-reference.html#useeffect}
 * @param callback Accepts a callback that's forwarded to React's useEffect
 * @param dependencies A dependency array similar to React's useEffect however it utilizes a deep compare
 * @param customCompare Opportunity to provide a custom compare function
 * @example
 * function ComponentExample() {
 *  const [, forceUpdate] = useState();
 *  const obj = {a: 1};
 *
 *  useDeepEffect(() => {
 *    console.log('useDeepEffect invocation');
 *    forceUpdate(obj);
 *  }, [obj]);
 *
 *  return null;
 * }
 */ function useDeepEffect(callback, dependencies, customCompare) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _react.useEffect)(callback, (0, _useDeepCompareRefJs.useDeepCompareRef)(dependencies, customCompare));
}

},{"react":"cOWTg","./use-deep-compare-ref.js":"jIiev","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jIiev":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepCompareRef", ()=>useDeepCompareRef);
var _react = require("react");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
/**
 * Allows for custom or deep comparison of a dependency list. Useful to keep a consistent dependency
 * list across reference changes.
 * @param dependencies A dependency array similar to React's useEffect / useCallback / useMemo
 * @param comparator An optional function to compare dependencies that'll default to a deep comparison
 * @returns A dependency list
 * @see {@link https://github.com/Shopify/polaris-react/blob/main/src/utilities/use-deep-effect.tsx}
 * @see {@link https://github.com/Shopify/polaris-react/blob/main/src/utilities/use-deep-callback.tsx}
 * @example
 * function useDeepEffectExample(callback, dependencies, customCompare) {
 *  useEffect(callback, useDeepCompareRef(dependencies, customCompare));
 * }
 */ function useDeepCompareRef(dependencies, comparator = (0, _reactFastCompareDefault.default)) {
    const dependencyList = (0, _react.useRef)(dependencies);
    if (!comparator(dependencyList.current, dependencies)) dependencyList.current = dependencies;
    return dependencyList.current;
}

},{"react":"cOWTg","react-fast-compare":"5bxip","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7T8Nm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepCallback", ()=>useDeepCallback);
var _react = require("react");
var _useDeepCompareRefJs = require("./use-deep-compare-ref.js");
/**
 * A replacement for React's useCallback that'll allow for custom and deep compares.
 * @see {@link https://reactjs.org/docs/hooks-reference.html#usecallback}
 * @param callback Accepts a callback that's forwarded to React's useCallback
 * @param dependencies A dependency array similar to React's useCallback however it utilizes a deep compare
 * @param customCompare Opportunity to provide a custom compare function
 * @returns A memoized callback
 * @example
 * const Child = memo(function Child({onClick}) {
 *   console.log('Child has rendered.');
 *   return <button onClick={onClick}>Click me</button>;
 * });
 *
 * function ComponentExample() {
 *   const [timesClicked, setTimesClicked] = useState(0);
 *
 *   const handleClick = useDeepCallback(() => {
 *     setTimesClicked((timesClicked) => timesClicked + 1);
 *     // New reference every render
 *   }, [{}]);
 *
 *   return (
 *     <>
 *       <div>Times clicked: {timesClicked}</div>
 *       <Child onClick={handleClick} />
 *     </>
 *   );
 * }
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function useDeepCallback(callback, dependencies, customCompare) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, _react.useCallback)(callback, (0, _useDeepCompareRefJs.useDeepCompareRef)(dependencies, customCompare));
}

},{"react":"cOWTg","./use-deep-compare-ref.js":"jIiev","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5ksUn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ToastManager": "Polaris-Frame-ToastManager",
    "ToastWrapper": "Polaris-Frame-ToastManager__ToastWrapper",
    "ToastWrapper-enter": "Polaris-Frame-ToastManager__ToastWrapper--enter",
    "ToastWrapper-exit": "Polaris-Frame-ToastManager__ToastWrapper--exit",
    "ToastWrapper-enter-done": "Polaris-Frame-ToastManager--toastWrapperEnterDone"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1PleR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_TOAST_DURATION", ()=>DEFAULT_TOAST_DURATION);
parcelHelpers.export(exports, "DEFAULT_TOAST_DURATION_WITH_ACTION", ()=>DEFAULT_TOAST_DURATION_WITH_ACTION);
parcelHelpers.export(exports, "Toast", ()=>Toast);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../../../utilities/css.js");
var _typesJs = require("../../../../types.js");
var _toastScssJs = require("./Toast.scss.js");
var _toastScssJsDefault = parcelHelpers.interopDefault(_toastScssJs);
var _iconJs = require("../../../Icon/Icon.js");
var _buttonJs = require("../../../Button/Button.js");
var _keypressListenerJs = require("../../../KeypressListener/KeypressListener.js");
var _horizontalStackJs = require("../../../HorizontalStack/HorizontalStack.js");
var _textJs = require("../../../Text/Text.js");
const DEFAULT_TOAST_DURATION = 5000;
const DEFAULT_TOAST_DURATION_WITH_ACTION = 10000;
function Toast({ content, onDismiss, duration, error, action }) {
    (0, _react.useEffect)(()=>{
        let timeoutDuration = duration || DEFAULT_TOAST_DURATION;
        if (action && !duration) timeoutDuration = DEFAULT_TOAST_DURATION_WITH_ACTION;
        else if (action && duration && duration < DEFAULT_TOAST_DURATION_WITH_ACTION) // eslint-disable-next-line no-console
        console.log("Toast with action should persist for at least 10,000 milliseconds to give the merchant enough time to act on it.");
        const timer = setTimeout(onDismiss, timeoutDuration);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        action,
        duration,
        onDismiss
    ]);
    const dismissMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: (0, _toastScssJsDefault.default).CloseButton,
        onClick: onDismiss
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.CancelSmallMinor)
    }));
    const actionMarkup = action ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _toastScssJsDefault.default).Action
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        plain: true,
        monochrome: true,
        size: "slim",
        onClick: action.onAction
    }, action.content)) : null;
    const leadingIconMarkup = error ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _toastScssJsDefault.default).LeadingIcon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.DiamondAlertMinor),
        color: "base"
    })) : null;
    const className = (0, _cssJs.classNames)((0, _toastScssJsDefault.default).Toast, error && (0, _toastScssJsDefault.default).error);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
        keyCode: (0, _typesJs.Key).Escape,
        handler: onDismiss
    }), leadingIconMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        blockAlign: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        fontWeight: "medium"
    }, content)), actionMarkup, dismissMarkup);
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/css.js":"lGt6N","../../../../types.js":"6NE7w","./Toast.scss.js":"eyt1D","../../../Icon/Icon.js":"6HPny","../../../Button/Button.js":"6Szv4","../../../KeypressListener/KeypressListener.js":"1eFmF","../../../HorizontalStack/HorizontalStack.js":"fotqA","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eyt1D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Toast": "Polaris-Frame-Toast",
    "Action": "Polaris-Frame-Toast__Action",
    "error": "Polaris-Frame-Toast--error",
    "CloseButton": "Polaris-Frame-Toast__CloseButton",
    "LeadingIcon": "Polaris-Frame-Toast__LeadingIcon"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"nsfg9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Grid", ()=>Grid);
parcelHelpers.export(exports, "formatAreas", ()=>formatAreas);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _gridScssJs = require("./Grid.scss.js");
var _gridScssJsDefault = parcelHelpers.interopDefault(_gridScssJs);
var _cellJs = require("./components/Cell/Cell.js");
const Grid = function Grid({ gap, areas, children, columns }) {
    const style = {
        "--pc-grid-gap-xs": gap === null || gap === void 0 ? void 0 : gap.xs,
        "--pc-grid-gap-sm": gap === null || gap === void 0 ? void 0 : gap.sm,
        "--pc-grid-gap-md": gap === null || gap === void 0 ? void 0 : gap.md,
        "--pc-grid-gap-lg": gap === null || gap === void 0 ? void 0 : gap.lg,
        "--pc-grid-gap-xl": gap === null || gap === void 0 ? void 0 : gap.xl,
        "--pc-grid-columns-xs": columns === null || columns === void 0 ? void 0 : columns.xs,
        "--pc-grid-columns-sm": columns === null || columns === void 0 ? void 0 : columns.sm,
        "--pc-grid-columns-md": columns === null || columns === void 0 ? void 0 : columns.md,
        "--pc-grid-columns-lg": columns === null || columns === void 0 ? void 0 : columns.lg,
        "--pc-grid-columns-xl": columns === null || columns === void 0 ? void 0 : columns.xl,
        "--pc-grid-areas-xs": formatAreas(areas === null || areas === void 0 ? void 0 : areas.xs),
        "--pc-grid-areas-sm": formatAreas(areas === null || areas === void 0 ? void 0 : areas.sm),
        "--pc-grid-areas-md": formatAreas(areas === null || areas === void 0 ? void 0 : areas.md),
        "--pc-grid-areas-lg": formatAreas(areas === null || areas === void 0 ? void 0 : areas.lg),
        "--pc-grid-areas-xl": formatAreas(areas === null || areas === void 0 ? void 0 : areas.xl)
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _gridScssJsDefault.default).Grid,
        style: style
    }, children);
};
function formatAreas(areas) {
    if (!areas) return;
    return `'${areas === null || areas === void 0 ? void 0 : areas.join(`' '`)}'`;
}
Grid.Cell = (0, _cellJs.Cell);

},{"react":"cOWTg","./Grid.scss.js":"bo9pj","./components/Cell/Cell.js":"eEiDs","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bo9pj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Grid": "Polaris-Grid"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eEiDs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cell", ()=>Cell);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _cellScssJs = require("./Cell.scss.js");
var _cellScssJsDefault = parcelHelpers.interopDefault(_cellScssJs);
function Cell({ area: gridArea, column, columnSpan, row, children }) {
    const className = (0, _cssJs.classNames)((0, _cellScssJsDefault.default).Cell, (columnSpan === null || columnSpan === void 0 ? void 0 : columnSpan.xs) && (0, _cellScssJsDefault.default)[`Cell-${columnSpan.xs}-column-xs`], (columnSpan === null || columnSpan === void 0 ? void 0 : columnSpan.sm) && (0, _cellScssJsDefault.default)[`Cell-${columnSpan.sm}-column-sm`], (columnSpan === null || columnSpan === void 0 ? void 0 : columnSpan.md) && (0, _cellScssJsDefault.default)[`Cell-${columnSpan.md}-column-md`], (columnSpan === null || columnSpan === void 0 ? void 0 : columnSpan.lg) && (0, _cellScssJsDefault.default)[`Cell-${columnSpan.lg}-column-lg`], (columnSpan === null || columnSpan === void 0 ? void 0 : columnSpan.xl) && (0, _cellScssJsDefault.default)[`Cell-${columnSpan.xl}-column-xl`]);
    const style = {
        gridArea,
        "--pc-column-xs": column === null || column === void 0 ? void 0 : column.xs,
        "--pc-column-sm": column === null || column === void 0 ? void 0 : column.sm,
        "--pc-column-md": column === null || column === void 0 ? void 0 : column.md,
        "--pc-column-lg": column === null || column === void 0 ? void 0 : column.lg,
        "--pc-column-xl": column === null || column === void 0 ? void 0 : column.xl,
        "--pc-row-xs": row === null || row === void 0 ? void 0 : row.xs,
        "--pc-row-sm": row === null || row === void 0 ? void 0 : row.sm,
        "--pc-row-md": row === null || row === void 0 ? void 0 : row.md,
        "--pc-row-lg": row === null || row === void 0 ? void 0 : row.lg,
        "--pc-row-xl": row === null || row === void 0 ? void 0 : row.xl
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        style: style
    }, children);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./Cell.scss.js":"lMWXN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lMWXN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Cell": "Polaris-Grid-Cell",
    "Cell-1-column-xs": "Polaris-Grid-Cell--cell_1ColumnXs",
    "Cell-2-column-xs": "Polaris-Grid-Cell--cell_2ColumnXs",
    "Cell-3-column-xs": "Polaris-Grid-Cell--cell_3ColumnXs",
    "Cell-4-column-xs": "Polaris-Grid-Cell--cell_4ColumnXs",
    "Cell-5-column-xs": "Polaris-Grid-Cell--cell_5ColumnXs",
    "Cell-6-column-xs": "Polaris-Grid-Cell--cell_6ColumnXs",
    "Cell-1-column-sm": "Polaris-Grid-Cell--cell_1ColumnSm",
    "Cell-2-column-sm": "Polaris-Grid-Cell--cell_2ColumnSm",
    "Cell-3-column-sm": "Polaris-Grid-Cell--cell_3ColumnSm",
    "Cell-4-column-sm": "Polaris-Grid-Cell--cell_4ColumnSm",
    "Cell-5-column-sm": "Polaris-Grid-Cell--cell_5ColumnSm",
    "Cell-6-column-sm": "Polaris-Grid-Cell--cell_6ColumnSm",
    "Cell-1-column-md": "Polaris-Grid-Cell--cell_1ColumnMd",
    "Cell-2-column-md": "Polaris-Grid-Cell--cell_2ColumnMd",
    "Cell-3-column-md": "Polaris-Grid-Cell--cell_3ColumnMd",
    "Cell-4-column-md": "Polaris-Grid-Cell--cell_4ColumnMd",
    "Cell-5-column-md": "Polaris-Grid-Cell--cell_5ColumnMd",
    "Cell-6-column-md": "Polaris-Grid-Cell--cell_6ColumnMd",
    "Cell-1-column-lg": "Polaris-Grid-Cell--cell_1ColumnLg",
    "Cell-2-column-lg": "Polaris-Grid-Cell--cell_2ColumnLg",
    "Cell-3-column-lg": "Polaris-Grid-Cell--cell_3ColumnLg",
    "Cell-4-column-lg": "Polaris-Grid-Cell--cell_4ColumnLg",
    "Cell-5-column-lg": "Polaris-Grid-Cell--cell_5ColumnLg",
    "Cell-6-column-lg": "Polaris-Grid-Cell--cell_6ColumnLg",
    "Cell-7-column-lg": "Polaris-Grid-Cell--cell_7ColumnLg",
    "Cell-8-column-lg": "Polaris-Grid-Cell--cell_8ColumnLg",
    "Cell-9-column-lg": "Polaris-Grid-Cell--cell_9ColumnLg",
    "Cell-10-column-lg": "Polaris-Grid-Cell--cell_10ColumnLg",
    "Cell-11-column-lg": "Polaris-Grid-Cell--cell_11ColumnLg",
    "Cell-12-column-lg": "Polaris-Grid-Cell--cell_12ColumnLg",
    "Cell-1-column-xl": "Polaris-Grid-Cell--cell_1ColumnXl",
    "Cell-2-column-xl": "Polaris-Grid-Cell--cell_2ColumnXl",
    "Cell-3-column-xl": "Polaris-Grid-Cell--cell_3ColumnXl",
    "Cell-4-column-xl": "Polaris-Grid-Cell--cell_4ColumnXl",
    "Cell-5-column-xl": "Polaris-Grid-Cell--cell_5ColumnXl",
    "Cell-6-column-xl": "Polaris-Grid-Cell--cell_6ColumnXl",
    "Cell-7-column-xl": "Polaris-Grid-Cell--cell_7ColumnXl",
    "Cell-8-column-xl": "Polaris-Grid-Cell--cell_8ColumnXl",
    "Cell-9-column-xl": "Polaris-Grid-Cell--cell_9ColumnXl",
    "Cell-10-column-xl": "Polaris-Grid-Cell--cell_10ColumnXl",
    "Cell-11-column-xl": "Polaris-Grid-Cell--cell_11ColumnXl",
    "Cell-12-column-xl": "Polaris-Grid-Cell--cell_12ColumnXl"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1zYQX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layout", ()=>Layout);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layoutScssJs = require("./Layout.scss.js");
var _layoutScssJsDefault = parcelHelpers.interopDefault(_layoutScssJs);
var _annotatedSectionJs = require("./components/AnnotatedSection/AnnotatedSection.js");
var _sectionJs = require("./components/Section/Section.js");
const Layout = function Layout({ sectioned, children }) {
    const content = sectioned ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionJs.Section), null, children) : children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _layoutScssJsDefault.default).Layout
    }, content);
};
Layout.AnnotatedSection = (0, _annotatedSectionJs.AnnotatedSection);
Layout.Section = (0, _sectionJs.Section);

},{"react":"cOWTg","./Layout.scss.js":"diyWn","./components/AnnotatedSection/AnnotatedSection.js":"cArYX","./components/Section/Section.js":"8o7jy","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"diyWn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Layout": "Polaris-Layout",
    "Section": "Polaris-Layout__Section",
    "Section-secondary": "Polaris-Layout__Section--secondary",
    "Section-fullWidth": "Polaris-Layout__Section--fullWidth",
    "Section-oneHalf": "Polaris-Layout__Section--oneHalf",
    "Section-oneThird": "Polaris-Layout__Section--oneThird",
    "AnnotatedSection": "Polaris-Layout__AnnotatedSection",
    "AnnotationWrapper": "Polaris-Layout__AnnotationWrapper",
    "AnnotationContent": "Polaris-Layout__AnnotationContent",
    "Annotation": "Polaris-Layout__Annotation"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cArYX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnnotatedSection", ()=>AnnotatedSection);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _layoutScssJs = require("../../Layout.scss.js");
var _layoutScssJsDefault = parcelHelpers.interopDefault(_layoutScssJs);
var _textContainerJs = require("../../../TextContainer/TextContainer.js");
var _textJs = require("../../../Text/Text.js");
var _boxJs = require("../../../Box/Box.js");
function AnnotatedSection({ children, title, description, id }) {
    const descriptionMarkup = typeof description === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, description) : description;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _layoutScssJsDefault.default).AnnotatedSection
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _layoutScssJsDefault.default).AnnotationWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _layoutScssJsDefault.default).Annotation
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textContainerJs.TextContainer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        id: id,
        variant: "headingMd",
        as: "h2"
    }, title), descriptionMarkup && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        color: "text-subdued"
    }, descriptionMarkup))), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _layoutScssJsDefault.default).AnnotationContent
    }, children)));
}

},{"react":"cOWTg","../../Layout.scss.js":"diyWn","../../../TextContainer/TextContainer.js":"kkkE5","../../../Text/Text.js":"l8Av9","../../../Box/Box.js":"lbjkG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kkkE5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextContainer", ()=>TextContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _textContainerScssJs = require("./TextContainer.scss.js");
var _textContainerScssJsDefault = parcelHelpers.interopDefault(_textContainerScssJs);
/** @deprecated Use VerticalStack instead */ function TextContainer({ spacing, children }) {
    const className = (0, _cssJs.classNames)((0, _textContainerScssJsDefault.default).TextContainer, spacing && (0, _textContainerScssJsDefault.default)[(0, _cssJs.variationName)("spacing", spacing)]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, children);
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./TextContainer.scss.js":"eIc36","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eIc36":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "TextContainer": "Polaris-TextContainer",
    "spacingTight": "Polaris-TextContainer--spacingTight",
    "spacingLoose": "Polaris-TextContainer--spacingLoose"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8o7jy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _layoutScssJs = require("../../Layout.scss.js");
var _layoutScssJsDefault = parcelHelpers.interopDefault(_layoutScssJs);
function Section({ children, secondary, fullWidth, oneHalf, oneThird }) {
    const className = (0, _cssJs.classNames)((0, _layoutScssJsDefault.default).Section, secondary && (0, _layoutScssJsDefault.default)["Section-secondary"], fullWidth && (0, _layoutScssJsDefault.default)["Section-fullWidth"], oneHalf && (0, _layoutScssJsDefault.default)["Section-oneHalf"], oneThird && (0, _layoutScssJsDefault.default)["Section-oneThird"]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, children);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../Layout.scss.js":"diyWn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1G7gV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bannerContextJs = require("../../utilities/banner-context.js");
var _cssJs = require("../../utilities/css.js");
var _linkScssJs = require("./Link.scss.js");
var _linkScssJsDefault = parcelHelpers.interopDefault(_linkScssJs);
var _unstyledLinkJs = require("../UnstyledLink/UnstyledLink.js");
function Link({ url, children, onClick, external, target, id, monochrome, removeUnderline, accessibilityLabel, dataPrimaryLink }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bannerContextJs.BannerContext).Consumer, null, (BannerContext)=>{
        const shouldBeMonochrome = monochrome || BannerContext;
        const className = (0, _cssJs.classNames)((0, _linkScssJsDefault.default).Link, shouldBeMonochrome && (0, _linkScssJsDefault.default).monochrome, removeUnderline && (0, _linkScssJsDefault.default).removeUnderline);
        return url ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
            onClick: onClick,
            className: className,
            url: url,
            external: external,
            target: target,
            id: id,
            "aria-label": accessibilityLabel,
            "data-primary-link": dataPrimaryLink
        }, children) : /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            onClick: onClick,
            className: className,
            id: id,
            "aria-label": accessibilityLabel,
            "data-primary-link": dataPrimaryLink
        }, children);
    });
}

},{"react":"cOWTg","../../utilities/banner-context.js":"bgwGz","../../utilities/css.js":"lGt6N","./Link.scss.js":"kcSRY","../UnstyledLink/UnstyledLink.js":"4o3DP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kcSRY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Link": "Polaris-Link",
    "monochrome": "Polaris-Link--monochrome",
    "removeUnderline": "Polaris-Link--removeUnderline"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8HAOc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "List", ()=>List);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _listScssJs = require("./List.scss.js");
var _listScssJsDefault = parcelHelpers.interopDefault(_listScssJs);
var _itemJs = require("./components/Item/Item.js");
const List = function List({ children, spacing = "loose", type = "bullet" }) {
    const className = (0, _cssJs.classNames)((0, _listScssJsDefault.default).List, spacing && (0, _listScssJsDefault.default)[(0, _cssJs.variationName)("spacing", spacing)], type && (0, _listScssJsDefault.default)[(0, _cssJs.variationName)("type", type)]);
    const ListElement = type === "bullet" ? "ul" : "ol";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ListElement, {
        className: className
    }, children);
};
List.Item = (0, _itemJs.Item);

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./List.scss.js":"5ykDT","./components/Item/Item.js":"3zm2t","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5ykDT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "List": "Polaris-List",
    "typeNumber": "Polaris-List--typeNumber",
    "Item": "Polaris-List__Item",
    "spacingLoose": "Polaris-List--spacingLoose"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3zm2t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listScssJs = require("../../List.scss.js");
var _listScssJsDefault = parcelHelpers.interopDefault(_listScssJs);
function Item({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: (0, _listScssJsDefault.default).Item
    }, children);
}

},{"react":"cOWTg","../../List.scss.js":"5ykDT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kUUpl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Loading", ()=>Loading);
var _react = require("react");
var _hooksJs = require("../../utilities/frame/hooks.js");
const Loading = /*#__PURE__*/ (0, _react.memo)(function Loading() {
    const { startLoading, stopLoading } = (0, _hooksJs.useFrame)();
    (0, _react.useEffect)(()=>{
        startLoading();
        return ()=>{
            stopLoading();
        };
    }, [
        startLoading,
        stopLoading
    ]);
    return null;
});

},{"react":"cOWTg","../../utilities/frame/hooks.js":"3aY41","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lXsCP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Navigation", ()=>Navigation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _withinContentContextJs = require("../../utilities/within-content-context.js");
var _cssJs = require("../../utilities/css.js");
var _getWidthJs = require("../../utilities/get-width.js");
var _contextJs = require("./context.js");
var _navigationScssJs = require("./Navigation.scss.js");
var _navigationScssJsDefault = parcelHelpers.interopDefault(_navigationScssJs);
var _sectionJs = require("./components/Section/Section.js");
var _hooksJs = require("../../utilities/frame/hooks.js");
var _unstyledLinkJs = require("../UnstyledLink/UnstyledLink.js");
var _imageJs = require("../Image/Image.js");
var _scrollableJs = require("../Scrollable/Scrollable.js");
var _itemJs = require("./components/Item/Item.js");
const Navigation = function Navigation({ children, contextControl, location, onDismiss, ariaLabelledBy, logoSuffix }) {
    const { logo } = (0, _hooksJs.useFrame)();
    const width = (0, _getWidthJs.getWidth)(logo, 104);
    const logoMarkup = logo ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).LogoContainer, logoSuffix && (0, _navigationScssJsDefault.default).hasLogoSuffix)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
        url: logo.url || "",
        className: (0, _navigationScssJsDefault.default).LogoLink,
        style: {
            width
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
        source: logo.topBarSource || "",
        alt: logo.accessibilityLabel || "",
        className: (0, _navigationScssJsDefault.default).Logo,
        style: {
            width
        }
    })), logoSuffix) : null;
    const mediaMarkup = contextControl ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _navigationScssJsDefault.default).ContextControl
    }, contextControl) : logoMarkup;
    const context = (0, _react.useMemo)(()=>({
            location,
            onNavigationDismiss: onDismiss
        }), [
        location,
        onDismiss
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.NavigationContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _withinContentContextJs.WithinContentContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        className: (0, _navigationScssJsDefault.default).Navigation,
        "aria-labelledby": ariaLabelledBy
    }, mediaMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollableJs.Scrollable), {
        className: (0, _navigationScssJsDefault.default).PrimaryNavigation
    }, children))));
};
Navigation.Item = (0, _itemJs.Item);
Navigation.Section = (0, _sectionJs.Section);

},{"react":"cOWTg","../../utilities/within-content-context.js":"cUmFU","../../utilities/css.js":"lGt6N","../../utilities/get-width.js":"j1LQp","./context.js":"bOr8Y","./Navigation.scss.js":"iNdo8","./components/Section/Section.js":"boeLu","../../utilities/frame/hooks.js":"3aY41","../UnstyledLink/UnstyledLink.js":"4o3DP","../Image/Image.js":"5iL1c","../Scrollable/Scrollable.js":"587xt","./components/Item/Item.js":"3eufM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bOr8Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavigationContext", ()=>NavigationContext);
var _react = require("react");
const NavigationContext = /*#__PURE__*/ (0, _react.createContext)({
    location: ""
});

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iNdo8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Navigation": "Polaris-Navigation",
    "UserMenu": "Polaris-Navigation__UserMenu",
    "ContextControl": "Polaris-Navigation__ContextControl",
    "PrimaryNavigation": "Polaris-Navigation__PrimaryNavigation",
    "LogoContainer": "Polaris-Navigation__LogoContainer",
    "hasLogoSuffix": "Polaris-Navigation--hasLogoSuffix",
    "Logo": "Polaris-Navigation__Logo",
    "LogoLink": "Polaris-Navigation__LogoLink",
    "Item": "Polaris-Navigation__Item",
    "Icon-resized": "Polaris-Navigation__Icon--resized",
    "ItemInnerWrapper": "Polaris-Navigation__ItemInnerWrapper",
    "Item-selected": "Polaris-Navigation__Item--selected",
    "Item-disabled": "Polaris-Navigation__Item--disabled",
    "Icon": "Polaris-Navigation__Icon",
    "Badge": "Polaris-Navigation__Badge",
    "ListItem-hasAction": "Polaris-Navigation__ListItem--hasAction",
    "subNavigationActive": "Polaris-Navigation--subNavigationActive",
    "Item-child-active": "Polaris-Navigation--itemChildActive",
    "ListItem": "Polaris-Navigation__ListItem",
    "RollupSection": "Polaris-Navigation__RollupSection",
    "SecondaryNavigation": "Polaris-Navigation__SecondaryNavigation",
    "ItemWrapper": "Polaris-Navigation__ItemWrapper",
    "ItemInnerDisabled": "Polaris-Navigation__ItemInnerDisabled",
    "ItemInnerWrapper-selected": "Polaris-Navigation__ItemInnerWrapper--selected",
    "Text": "Polaris-Navigation__Text",
    "Text-truncated": "Polaris-Navigation__Text--truncated",
    "SecondaryActions": "Polaris-Navigation__SecondaryActions",
    "ItemWithFloatingActions": "Polaris-Navigation__ItemWithFloatingActions",
    "ItemInnerWrapper-display-actions-on-hover": "Polaris-Navigation--itemInnerWrapperDisplayActionsOnHover",
    "SecondaryAction": "Polaris-Navigation__SecondaryAction",
    "List": "Polaris-Navigation__List",
    "SecondaryNavigation-noIcon": "Polaris-Navigation__SecondaryNavigation--noIcon",
    "Section": "Polaris-Navigation__Section",
    "Section-fill": "Polaris-Navigation__Section--fill",
    "Section-withSeparator": "Polaris-Navigation__Section--withSeparator",
    "SectionHeading": "Polaris-Navigation__SectionHeading",
    "Action": "Polaris-Navigation__Action",
    "RollupToggle": "Polaris-Navigation__RollupToggle",
    "Indicator": "Polaris-Navigation__Indicator"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"boeLu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", ()=>Section);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../../../utilities/css.js");
var _useToggleJs = require("../../../../utilities/use-toggle.js");
var _navigationScssJs = require("../../Navigation.scss.js");
var _navigationScssJsDefault = parcelHelpers.interopDefault(_navigationScssJs);
var _itemJs = require("../Item/Item.js");
var _hooksJs = require("../../../../utilities/media-query/hooks.js");
var _iconJs = require("../../../Icon/Icon.js");
var _tooltipJs = require("../../../Tooltip/Tooltip.js");
var _textJs = require("../../../Text/Text.js");
var _hooksJs1 = require("../../../../utilities/unique-id/hooks.js");
var _collapsibleJs = require("../../../Collapsible/Collapsible.js");
function Section({ title, fill, action, items, rollup, separator }) {
    const { value: expanded, toggle: toggleExpanded, setFalse: setExpandedFalse } = (0, _useToggleJs.useToggle)(false);
    const animationFrame = (0, _react.useRef)(null);
    const { isNavigationCollapsed } = (0, _hooksJs.useMediaQuery)();
    const [expandedIndex, setExpandedIndex] = (0, _react.useState)();
    const handleClick = (onClick, hasSubNavItems)=>{
        return ()=>{
            if (onClick) onClick();
            if (animationFrame.current) cancelAnimationFrame(animationFrame.current);
            if (!hasSubNavItems || !isNavigationCollapsed) animationFrame.current = requestAnimationFrame(setExpandedFalse);
        };
    };
    (0, _react.useEffect)(()=>{
        return ()=>{
            animationFrame.current && cancelAnimationFrame(animationFrame.current);
        };
    });
    const className = (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).Section, separator && (0, _navigationScssJsDefault.default)["Section-withSeparator"], fill && (0, _navigationScssJsDefault.default)["Section-fill"]);
    const buttonMarkup = action && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: (0, _navigationScssJsDefault.default).Action,
        "aria-label": action.accessibilityLabel,
        onClick: action.onClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: action.icon
    }));
    const actionMarkup = action && (action.tooltip ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), action.tooltip, buttonMarkup) : buttonMarkup);
    const sectionHeadingMarkup = title && /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: (0, _navigationScssJsDefault.default).SectionHeading
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        variant: "headingXs",
        color: "subdued"
    }, title), actionMarkup);
    const itemsMarkup = items.map((item, index)=>{
        const { onClick, label, subNavigationItems, ...rest } = item;
        const hasSubNavItems = subNavigationItems != null && subNavigationItems.length > 0;
        const handleToggleExpandedState = ()=>{
            if (expandedIndex === index) setExpandedIndex(-1);
            else setExpandedIndex(index);
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _itemJs.Item), Object.assign({
            key: label
        }, rest, {
            label: label,
            subNavigationItems: subNavigationItems,
            onClick: handleClick(onClick, hasSubNavItems),
            onToggleExpandedState: handleToggleExpandedState,
            expanded: expandedIndex === index
        }));
    });
    const toggleClassName = (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).Item, (0, _navigationScssJsDefault.default).RollupToggle);
    const ariaLabel = rollup && (expanded ? rollup.hide : rollup.view);
    const toggleRollup = rollup && items.length > rollup.after && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _navigationScssJsDefault.default).ListItem,
        key: "List Item"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _navigationScssJsDefault.default).ItemWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _navigationScssJsDefault.default).ItemInnerWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: toggleClassName,
        onClick: toggleExpanded,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _navigationScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.HorizontalDotsMinor)
    }))))));
    const activeItemIndex = items.findIndex((item)=>{
        if (!rollup) return false;
        return rollup.activePath === item.url || item.url && rollup.activePath.startsWith(item.url) || (item.subNavigationItems ? item.subNavigationItems.some(({ url: itemUrl })=>rollup.activePath.startsWith(itemUrl)) : false);
    });
    const sectionItems = rollup ? itemsMarkup.slice(0, rollup.after) : itemsMarkup;
    const additionalItems = rollup ? itemsMarkup.slice(rollup.after) : [];
    if (rollup && activeItemIndex !== -1 && activeItemIndex > rollup.after - 1) sectionItems.push(...additionalItems.splice(activeItemIndex - rollup.after, 1));
    const additionalItemsId = (0, _hooksJs1.useUniqueId)("AdditionalItems");
    const activeItemsMarkup = rollup && additionalItems.length > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: (0, _navigationScssJsDefault.default).RollupSection
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collapsibleJs.Collapsible), {
        id: additionalItemsId,
        open: expanded
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        className: (0, _navigationScssJsDefault.default).List
    }, additionalItems)), toggleRollup);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        className: className
    }, sectionHeadingMarkup, sectionItems, activeItemsMarkup);
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/css.js":"lGt6N","../../../../utilities/use-toggle.js":"2kpDL","../../Navigation.scss.js":"iNdo8","../Item/Item.js":"3eufM","../../../../utilities/media-query/hooks.js":"jzbEF","../../../Icon/Icon.js":"6HPny","../../../Tooltip/Tooltip.js":"k7vL7","../../../Text/Text.js":"l8Av9","../../../../utilities/unique-id/hooks.js":"2JfcO","../../../Collapsible/Collapsible.js":"6rL9J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3eufM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "ItemSecondaryAction", ()=>ItemSecondaryAction);
parcelHelpers.export(exports, "MAX_SECONDARY_ACTIONS", ()=>MAX_SECONDARY_ACTIONS);
parcelHelpers.export(exports, "isNavigationItemActive", ()=>isNavigationItemActive);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsomorphicLayoutEffectJs = require("../../../../utilities/use-isomorphic-layout-effect.js");
var _cssJs = require("../../../../utilities/css.js");
var _contextJs = require("../../context.js");
var _navigationScssJs = require("../../Navigation.scss.js");
var _navigationScssJsDefault = parcelHelpers.interopDefault(_navigationScssJs);
var _secondaryJs = require("./components/Secondary/Secondary.js");
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../../../utilities/media-query/hooks.js");
var _hooksJs2 = require("../../../../utilities/unique-id/hooks.js");
var _indicatorJs = require("../../../Indicator/Indicator.js");
var _iconJs = require("../../../Icon/Icon.js");
var _badgeJs = require("../../../Badge/Badge.js");
var _tooltipJs = require("../../../Tooltip/Tooltip.js");
var _unstyledLinkJs = require("../../../UnstyledLink/UnstyledLink.js");
var _unstyledButtonJs = require("../../../UnstyledButton/UnstyledButton.js");
const MAX_SECONDARY_ACTIONS = 2;
const TOOLTIP_HOVER_DELAY = 1000;
var MatchState;
(function(MatchState) {
    MatchState[MatchState["MatchForced"] = 0] = "MatchForced";
    MatchState[MatchState["MatchUrl"] = 1] = "MatchUrl";
    MatchState[MatchState["MatchPaths"] = 2] = "MatchPaths";
    MatchState[MatchState["Excluded"] = 3] = "Excluded";
    MatchState[MatchState["NoMatch"] = 4] = "NoMatch";
})(MatchState || (MatchState = {}));
function Item({ url, icon, label, subNavigationItems = [], secondaryAction, secondaryActions, displayActionsOnHover, disabled, onClick, accessibilityLabel, selected: selectedOverride, badge, new: isNew, matches, exactMatch, matchPaths, excludePaths, external, onToggleExpandedState, expanded, shouldResizeIcon, truncateText }) {
    const i18n = (0, _hooksJs.useI18n)();
    const { isNavigationCollapsed } = (0, _hooksJs1.useMediaQuery)();
    const secondaryNavigationId = (0, _hooksJs2.useUniqueId)("SecondaryNavigation");
    const { location, onNavigationDismiss } = (0, _react.useContext)((0, _contextJs.NavigationContext));
    const navTextRef = (0, _react.useRef)(null);
    const [isTruncated, setIsTruncated] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!isNavigationCollapsed && expanded) onToggleExpandedState === null || onToggleExpandedState === void 0 || onToggleExpandedState();
    }, [
        expanded,
        isNavigationCollapsed,
        onToggleExpandedState
    ]);
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(()=>{
        const navTextNode = navTextRef.current;
        if (truncateText && navTextNode) setIsTruncated(navTextNode.scrollHeight > navTextNode.clientHeight);
    }, [
        truncateText
    ]);
    const tabIndex = disabled ? -1 : 0;
    const hasNewChild = subNavigationItems.filter((subNavigationItem)=>subNavigationItem.new).length > 0;
    const indicatorMarkup = hasNewChild ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _navigationScssJsDefault.default).Indicator
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _indicatorJs.Indicator), {
        pulse: true
    })) : null;
    const iconMarkup = icon ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).Icon, shouldResizeIcon && (0, _navigationScssJsDefault.default)["Icon-resized"])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: icon
    })) : null;
    let badgeMarkup = null;
    if (isNew) badgeMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badgeJs.Badge), {
        status: "new"
    }, i18n.translate("Polaris.Badge.STATUS_LABELS.new"));
    else if (typeof badge === "string") badgeMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badgeJs.Badge), {
        status: "new"
    }, badge);
    else badgeMarkup = badge;
    const wrappedBadgeMarkup = badgeMarkup == null ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _navigationScssJsDefault.default).Badge
    }, badgeMarkup);
    const itemLabelMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).Text, truncateText && (0, _navigationScssJsDefault.default)["Text-truncated"]),
        ref: navTextRef
    }, label, indicatorMarkup);
    if (url == null) {
        const className = (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).Item, disabled && (0, _navigationScssJsDefault.default)["Item-disabled"], selectedOverride && (0, _navigationScssJsDefault.default)["Item-selected"]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            className: (0, _navigationScssJsDefault.default).ListItem
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _navigationScssJsDefault.default).ItemWrapper
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).ItemInnerWrapper, disabled && (0, _navigationScssJsDefault.default).ItemInnerDisabled)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            className: className,
            disabled: disabled,
            "aria-disabled": disabled,
            "aria-label": accessibilityLabel,
            onClick: getClickHandler(onClick)
        }, iconMarkup, itemLabelMarkup, wrappedBadgeMarkup))));
    }
    const actions = secondaryActions || secondaryAction && [
        secondaryAction
    ];
    if (actions && actions.length > MAX_SECONDARY_ACTIONS) actions.length = MAX_SECONDARY_ACTIONS;
    const secondaryActionMarkup = actions !== null && actions !== void 0 && actions.length ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _navigationScssJsDefault.default).SecondaryActions
    }, actions.map((action)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(ItemSecondaryAction, Object.assign({
            key: action.accessibilityLabel
        }, action, {
            tabIndex: tabIndex,
            disabled: disabled
        })))) : null;
    const itemContentMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, iconMarkup, itemLabelMarkup, secondaryActionMarkup ? null : wrappedBadgeMarkup);
    const outerContentMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, secondaryActionMarkup ? wrappedBadgeMarkup : null);
    const matchState = matchStateForItem({
        url,
        matches,
        exactMatch,
        matchPaths,
        excludePaths
    }, location);
    const matchingSubNavigationItems = subNavigationItems.filter((item)=>{
        const subMatchState = matchStateForItem(item, location);
        return subMatchState === MatchState.MatchForced || subMatchState === MatchState.MatchUrl || subMatchState === MatchState.MatchPaths;
    });
    const childIsActive = matchingSubNavigationItems.length > 0;
    const selected = selectedOverride == null ? matchState === MatchState.MatchForced || matchState === MatchState.MatchUrl || matchState === MatchState.MatchPaths : selectedOverride;
    const showExpanded = selected || expanded || childIsActive;
    const canBeActive = subNavigationItems.length === 0 || !childIsActive;
    const itemClassName = (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).Item, disabled && (0, _navigationScssJsDefault.default)["Item-disabled"], selected && canBeActive && (0, _navigationScssJsDefault.default)["Item-selected"], showExpanded && (0, _navigationScssJsDefault.default).subNavigationActive, childIsActive && (0, _navigationScssJsDefault.default)["Item-child-active"]);
    let secondaryNavigationMarkup = null;
    if (subNavigationItems.length > 0) {
        const longestMatch = matchingSubNavigationItems.sort(({ url: firstUrl }, { url: secondUrl })=>secondUrl.length - firstUrl.length)[0];
        const SecondaryNavigationClassName = (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).SecondaryNavigation, !icon && (0, _navigationScssJsDefault.default)["SecondaryNavigation-noIcon"]);
        secondaryNavigationMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: SecondaryNavigationClassName
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _secondaryJs.Secondary), {
            expanded: showExpanded,
            id: secondaryNavigationId
        }, subNavigationItems.map((item)=>{
            const { label, ...rest } = item;
            const onClick = ()=>{
                if (onNavigationDismiss) onNavigationDismiss();
                if (item.onClick && item.onClick !== onNavigationDismiss) item.onClick();
            };
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Item, Object.assign({
                key: label
            }, rest, {
                label: label,
                matches: item === longestMatch,
                onClick: onClick,
                truncateText: truncateText
            }));
        })));
    }
    const className = (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).ListItem, Boolean(actions && actions.length) && (0, _navigationScssJsDefault.default)["ListItem-hasAction"]);
    const itemLinkMarkup = ()=>{
        const linkMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), Object.assign({
            url: url,
            className: itemClassName,
            external: external,
            tabIndex: tabIndex,
            "aria-disabled": disabled,
            "aria-label": accessibilityLabel,
            onClick: getClickHandler(onClick)
        }, normalizeAriaAttributes(secondaryNavigationId, subNavigationItems.length > 0, showExpanded)), itemContentMarkup);
        return isTruncated ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
            hoverDelay: TOOLTIP_HOVER_DELAY,
            content: label,
            preferredPosition: "above"
        }, linkMarkup) : linkMarkup;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _navigationScssJsDefault.default).ItemWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _navigationScssJsDefault.default).ItemInnerWrapper, selected && canBeActive && (0, _navigationScssJsDefault.default)["ItemInnerWrapper-selected"], displayActionsOnHover && (0, _navigationScssJsDefault.default)["ItemInnerWrapper-display-actions-on-hover"], disabled && (0, _navigationScssJsDefault.default).ItemInnerDisabled)
    }, displayActionsOnHover && secondaryActionMarkup && wrappedBadgeMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _navigationScssJsDefault.default).ItemWithFloatingActions
    }, itemLinkMarkup(), secondaryActionMarkup) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, itemLinkMarkup(), secondaryActionMarkup), outerContentMarkup)), secondaryNavigationMarkup);
    function getClickHandler(onClick) {
        return (event)=>{
            const { currentTarget } = event;
            if (currentTarget.getAttribute("href") === location) event.preventDefault();
            if (subNavigationItems && subNavigationItems.length > 0 && isNavigationCollapsed) {
                event.preventDefault();
                onToggleExpandedState === null || onToggleExpandedState === void 0 || onToggleExpandedState();
            } else if (onNavigationDismiss) {
                onNavigationDismiss();
                if (onClick && onClick !== onNavigationDismiss) onClick();
                return;
            }
            if (onClick) onClick();
        };
    }
}
function ItemSecondaryAction({ url, icon, accessibilityLabel, tooltip, onClick, disabled, tabIndex }) {
    const markup = url ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
        external: true,
        url: url,
        className: (0, _navigationScssJsDefault.default).SecondaryAction,
        tabIndex: tabIndex,
        "aria-disabled": disabled,
        "aria-label": accessibilityLabel,
        onClick: onClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: icon
    })) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledButtonJs.UnstyledButton), {
        className: (0, _navigationScssJsDefault.default).SecondaryAction,
        tabIndex: tabIndex,
        disabled: disabled,
        accessibilityLabel: accessibilityLabel,
        onClick: onClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: icon
    }));
    return tooltip ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), tooltip, " ", markup, " ") : markup;
}
function isNavigationItemActive(navigationItem, currentPath) {
    const matchState = matchStateForItem(navigationItem, currentPath);
    const matchingSubNavigationItems = navigationItem.subNavigationItems && navigationItem.subNavigationItems.filter((item)=>{
        const subMatchState = matchStateForItem(item, currentPath);
        return subMatchState === MatchState.MatchForced || subMatchState === MatchState.MatchUrl || subMatchState === MatchState.MatchPaths;
    });
    const childIsActive = matchingSubNavigationItems && matchingSubNavigationItems.length > 0;
    const selected = matchState === MatchState.MatchForced || matchState === MatchState.MatchUrl || matchState === MatchState.MatchPaths;
    return selected || childIsActive;
}
function normalizePathname(pathname) {
    const barePathname = pathname.split("?")[0].split("#")[0];
    return barePathname.endsWith("/") ? barePathname : `${barePathname}/`;
}
function safeEqual(location, path) {
    return normalizePathname(location) === normalizePathname(path);
}
function safeStartsWith(location, path) {
    return normalizePathname(location).startsWith(normalizePathname(path));
}
function matchStateForItem({ url, matches, exactMatch, matchPaths, excludePaths }, location) {
    if (url == null) return MatchState.NoMatch;
    if (matches) return MatchState.MatchForced;
    if (matches === false || excludePaths && excludePaths.some((path)=>safeStartsWith(location, path))) return MatchState.Excluded;
    if (matchPaths && matchPaths.some((path)=>safeStartsWith(location, path))) return MatchState.MatchPaths;
    const matchesUrl = exactMatch ? safeEqual(location, url) : safeStartsWith(location, url);
    return matchesUrl ? MatchState.MatchUrl : MatchState.NoMatch;
}
function normalizeAriaAttributes(controlId, hasSubMenu, expanded) {
    return hasSubMenu ? {
        "aria-expanded": expanded,
        "aria-controls": controlId
    } : undefined;
}

},{"react":"cOWTg","../../../../utilities/use-isomorphic-layout-effect.js":"2th17","../../../../utilities/css.js":"lGt6N","../../context.js":"bOr8Y","../../Navigation.scss.js":"iNdo8","./components/Secondary/Secondary.js":"gXcu7","../../../../utilities/i18n/hooks.js":"hhMhA","../../../../utilities/media-query/hooks.js":"jzbEF","../../../../utilities/unique-id/hooks.js":"2JfcO","../../../Indicator/Indicator.js":"1Dymx","../../../Icon/Icon.js":"6HPny","../../../Badge/Badge.js":"8ckUl","../../../Tooltip/Tooltip.js":"k7vL7","../../../UnstyledLink/UnstyledLink.js":"4o3DP","../../../UnstyledButton/UnstyledButton.js":"5Z7tL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gXcu7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Secondary", ()=>Secondary);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _navigationScssJs = require("../../../../Navigation.scss.js");
var _navigationScssJsDefault = parcelHelpers.interopDefault(_navigationScssJs);
var _hooksJs = require("../../../../../../utilities/unique-id/hooks.js");
var _collapsibleJs = require("../../../../../Collapsible/Collapsible.js");
function Secondary({ id, children, expanded }) {
    const uid = (0, _hooksJs.useUniqueId)("SecondaryNavigation");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collapsibleJs.Collapsible), {
        id: id || uid,
        open: expanded,
        transition: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        className: (0, _navigationScssJsDefault.default).List
    }, children));
}

},{"react":"cOWTg","../../../../Navigation.scss.js":"iNdo8","../../../../../../utilities/unique-id/hooks.js":"2JfcO","../../../../../Collapsible/Collapsible.js":"6rL9J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c7mhZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptionList", ()=>OptionList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _optionsJs = require("../../utilities/options.js");
var _arraysJs = require("../../utilities/arrays.js");
var _useDeepEffectJs = require("../../utilities/use-deep-effect.js");
var _optionJs = require("./components/Option/Option.js");
var _hooksJs = require("../../utilities/unique-id/hooks.js");
var _boxJs = require("../Box/Box.js");
var _bleedJs = require("../Bleed/Bleed.js");
var _textJs = require("../Text/Text.js");
function OptionList({ options, sections, title, selected, allowMultiple, role, optionRole, verticalAlign, onChange, id: idProp, onPointerEnterOption, onFocusOption }) {
    const [normalizedOptions, setNormalizedOptions] = (0, _react.useState)(createNormalizedOptions(options, sections, title));
    const id = (0, _hooksJs.useUniqueId)("OptionList", idProp);
    (0, _useDeepEffectJs.useDeepEffect)(()=>{
        setNormalizedOptions(createNormalizedOptions(options || [], sections || [], title));
    }, [
        options,
        sections,
        title
    ], optionArraysAreEqual);
    const handleClick = (0, _react.useCallback)((sectionIndex, optionIndex)=>{
        const selectedValue = normalizedOptions[sectionIndex].options[optionIndex].value;
        const foundIndex = selected.indexOf(selectedValue);
        if (allowMultiple) {
            const newSelection = foundIndex === -1 ? [
                selectedValue,
                ...selected
            ] : [
                ...selected.slice(0, foundIndex),
                ...selected.slice(foundIndex + 1, selected.length)
            ];
            onChange(newSelection);
            return;
        }
        onChange([
            selectedValue
        ]);
    }, [
        normalizedOptions,
        selected,
        allowMultiple,
        onChange
    ]);
    const handlePointerEnter = (0, _react.useCallback)((sectionIndex, optionIndex)=>{
        if (!onPointerEnterOption) return;
        const selectedValue = normalizedOptions[sectionIndex].options[optionIndex].value;
        onPointerEnterOption(selectedValue);
    }, [
        normalizedOptions,
        onPointerEnterOption
    ]);
    const handleFocus = (0, _react.useCallback)((sectionIndex, optionIndex)=>{
        if (!onFocusOption) return;
        const selectedValue = normalizedOptions[sectionIndex].options[optionIndex].value;
        onFocusOption(selectedValue);
    }, [
        normalizedOptions,
        onFocusOption
    ]);
    const optionsExist = normalizedOptions.length > 0;
    const optionsMarkup = optionsExist ? normalizedOptions.map(({ title, options }, sectionIndex)=>{
        const isFirstOption = sectionIndex === 0;
        const titleMarkup = title ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            paddingBlockStart: isFirstOption ? "2" : "4",
            paddingInlineStart: "2",
            paddingBlockEnd: "2",
            paddingInlineEnd: "2",
            borderColor: "border-subdued",
            borderBlockStartWidth: !isFirstOption ? "1" : undefined
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
            as: "p",
            variant: "headingXs"
        }, title)) : null;
        const optionsMarkup = options && options.map((option, optionIndex)=>{
            const isSelected = selected.includes(option.value);
            const optionId = option.id || `${id}-${sectionIndex}-${optionIndex}`;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _optionJs.Option), Object.assign({
                key: optionId
            }, option, {
                id: optionId,
                section: sectionIndex,
                index: optionIndex,
                onClick: handleClick,
                select: isSelected,
                allowMultiple: allowMultiple,
                verticalAlign: verticalAlign,
                role: optionRole,
                onPointerEnter: handlePointerEnter,
                onFocus: handleFocus
            }));
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            key: title || `noTitle-${sectionIndex}`,
            as: "li",
            paddingBlockStart: isFirstOption ? undefined : "2"
        }, titleMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bleedJs.Bleed), {
            marginBlockStart: title ? undefined : "05"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            as: "ul",
            id: `${id}-${sectionIndex}`,
            role: role
        }, optionsMarkup)));
    }) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        as: "ul",
        role: role,
        padding: "2"
    }, optionsMarkup);
}
function createNormalizedOptions(options, sections, title) {
    if (options == null) {
        const section = {
            options: [],
            title
        };
        return sections == null ? [] : [
            section,
            ...sections
        ];
    }
    if (sections == null) return [
        {
            title,
            options
        }
    ];
    return [
        {
            title,
            options
        },
        ...sections
    ];
}
function optionArraysAreEqual(firstArray, secondArray) {
    if ((0, _optionsJs.isSection)(firstArray) && (0, _optionsJs.isSection)(secondArray)) return (0, _arraysJs.arraysAreEqual)(firstArray, secondArray, testSectionsPropEquality);
    return (0, _arraysJs.arraysAreEqual)(firstArray, secondArray);
}
function testSectionsPropEquality(previousSection, currentSection) {
    const { options: previousOptions } = previousSection;
    const { options: currentOptions } = currentSection;
    const optionsAreEqual = (0, _arraysJs.arraysAreEqual)(previousOptions, currentOptions);
    const titlesAreEqual = previousSection.title === currentSection.title;
    return optionsAreEqual && titlesAreEqual;
}

},{"react":"cOWTg","../../utilities/options.js":"7XDjE","../../utilities/arrays.js":"6DiWI","../../utilities/use-deep-effect.js":"4eElT","./components/Option/Option.js":"i5vyj","../../utilities/unique-id/hooks.js":"2JfcO","../Box/Box.js":"lbjkG","../Bleed/Bleed.js":"3Epca","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6DiWI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arraysAreEqual", ()=>arraysAreEqual);
function arraysAreEqual(firstArray, secondArray, comparator) {
    if (firstArray.length !== secondArray.length) return false;
    return firstArray.every((firstItem, index)=>{
        const secondItem = secondArray[index];
        if (comparator != null) return comparator(firstItem, secondItem);
        return firstItem === secondItem;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i5vyj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Option", ()=>Option);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useToggleJs = require("../../../../utilities/use-toggle.js");
var _cssJs = require("../../../../utilities/css.js");
var _optionScssJs = require("./Option.scss.js");
var _optionScssJsDefault = parcelHelpers.interopDefault(_optionScssJs);
var _checkboxJs = require("../Checkbox/Checkbox.js");
var _scrollableJs = require("../../../Scrollable/Scrollable.js");
function Option({ label, value, id, select, active, allowMultiple, disabled, role, media, onClick, section, index, verticalAlign, onPointerEnter, onFocus }) {
    const { value: focused, toggle: toggleFocused } = (0, _useToggleJs.useToggle)(false);
    const handleClick = (0, _react.useCallback)(()=>{
        if (disabled) return;
        onClick(section, index);
    }, [
        disabled,
        index,
        onClick,
        section
    ]);
    const handlePointerEnter = (0, _react.useCallback)(()=>{
        if (disabled) return;
        onPointerEnter(section, index);
    }, [
        disabled,
        onPointerEnter,
        section,
        index
    ]);
    const handleFocus = (0, _react.useCallback)(()=>{
        toggleFocused();
        onFocus(section, index);
    }, [
        toggleFocused,
        onFocus,
        section,
        index
    ]);
    const mediaMarkup = media ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _optionScssJsDefault.default).Media
    }, media) : null;
    const singleSelectClassName = (0, _cssJs.classNames)((0, _optionScssJsDefault.default).SingleSelectOption, focused && (0, _optionScssJsDefault.default).focused, disabled && (0, _optionScssJsDefault.default).disabled, select && (0, _optionScssJsDefault.default).select, active && (0, _optionScssJsDefault.default).active, verticalAlign && (0, _optionScssJsDefault.default)[(0, _cssJs.variationName)("verticalAlign", verticalAlign)]);
    const multiSelectClassName = (0, _cssJs.classNames)((0, _optionScssJsDefault.default).Label, disabled && (0, _optionScssJsDefault.default).disabled, active && (0, _optionScssJsDefault.default).active, select && (0, _optionScssJsDefault.default).select, verticalAlign && (0, _optionScssJsDefault.default)[(0, _cssJs.variationName)("verticalAlign", verticalAlign)]);
    const checkBoxRole = role === "option" ? "presentation" : undefined;
    const optionMarkup = allowMultiple ? /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: id,
        className: multiSelectClassName
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _optionScssJsDefault.default).Checkbox
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkboxJs.Checkbox), {
        id: id,
        value: value,
        checked: select,
        active: active,
        disabled: disabled,
        onChange: handleClick,
        role: checkBoxRole
    })), mediaMarkup, label) : /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        id: id,
        type: "button",
        className: singleSelectClassName,
        onClick: handleClick,
        disabled: disabled,
        onFocus: handleFocus,
        onBlur: toggleFocused,
        "aria-pressed": active
    }, mediaMarkup, label);
    const scrollMarkup = active ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollableJs.Scrollable).ScrollTo, null) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        key: id,
        className: (0, _optionScssJsDefault.default).Option,
        tabIndex: -1,
        onPointerEnter: handlePointerEnter
    }, scrollMarkup, optionMarkup);
}

},{"react":"cOWTg","../../../../utilities/use-toggle.js":"2kpDL","../../../../utilities/css.js":"lGt6N","./Option.scss.js":"agvjF","../Checkbox/Checkbox.js":"ib9o2","../../../Scrollable/Scrollable.js":"587xt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"agvjF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Option": "Polaris-OptionList-Option",
    "SingleSelectOption": "Polaris-OptionList-Option__SingleSelectOption",
    "focused": "Polaris-OptionList-Option--focused",
    "active": "Polaris-OptionList-Option--active",
    "select": "Polaris-OptionList-Option--select",
    "disabled": "Polaris-OptionList-Option--disabled",
    "Media": "Polaris-OptionList-Option__Media",
    "Label": "Polaris-OptionList-Option__Label",
    "Checkbox": "Polaris-OptionList-Option__Checkbox",
    "verticalAlignTop": "Polaris-OptionList-Option--verticalAlignTop",
    "verticalAlignCenter": "Polaris-OptionList-Option--verticalAlignCenter",
    "verticalAlignBottom": "Polaris-OptionList-Option--verticalAlignBottom"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ib9o2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../../../utilities/css.js");
var _checkboxScssJs = require("./Checkbox.scss.js");
var _checkboxScssJsDefault = parcelHelpers.interopDefault(_checkboxScssJs);
var _hooksJs = require("../../../../utilities/unique-id/hooks.js");
var _iconJs = require("../../../Icon/Icon.js");
function Checkbox({ id: idProp, checked = false, disabled, active, onChange, name, value, role }) {
    const id = (0, _hooksJs.useUniqueId)("Checkbox", idProp);
    const className = (0, _cssJs.classNames)((0, _checkboxScssJsDefault.default).Checkbox, active && (0, _checkboxScssJsDefault.default).active);
    const inputClassName = (0, _cssJs.classNames)((0, _checkboxScssJsDefault.default).Input);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: id,
        name: name,
        value: value,
        type: "checkbox",
        checked: checked,
        disabled: disabled,
        className: inputClassName,
        "aria-checked": checked,
        onChange: onChange,
        role: role
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _checkboxScssJsDefault.default).Backdrop
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _checkboxScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.TickSmallMinor)
    })));
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/css.js":"lGt6N","./Checkbox.scss.js":"ewgZ3","../../../../utilities/unique-id/hooks.js":"2JfcO","../../../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ewgZ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Checkbox": "Polaris-OptionList-Checkbox",
    "active": "Polaris-OptionList-Checkbox--active",
    "Backdrop": "Polaris-OptionList-Checkbox__Backdrop",
    "Input": "Polaris-OptionList-Checkbox__Input",
    "Input-indeterminate": "Polaris-OptionList-Checkbox__Input--indeterminate",
    "Icon": "Polaris-OptionList-Checkbox__Icon",
    "hover": "Polaris-OptionList-Checkbox--hover"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"liTk6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Page", ()=>Page);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _isInterfaceJs = require("../../utilities/is-interface.js");
var _isReactElementJs = require("../../utilities/is-react-element.js");
var _pageScssJs = require("./Page.scss.js");
var _pageScssJsDefault = parcelHelpers.interopDefault(_pageScssJs);
var _headerJs = require("./components/Header/Header.js");
function Page({ children, fullWidth, narrowWidth, divider, ...rest }) {
    const pageClassName = (0, _cssJs.classNames)((0, _pageScssJsDefault.default).Page, fullWidth && (0, _pageScssJsDefault.default).fullWidth, narrowWidth && (0, _pageScssJsDefault.default).narrowWidth);
    const hasHeaderContent = rest.title != null && rest.title !== "" || rest.subtitle != null && rest.subtitle !== "" || rest.primaryAction != null || rest.secondaryActions != null && ((0, _isInterfaceJs.isInterface)(rest.secondaryActions) && rest.secondaryActions.length > 0 || (0, _isReactElementJs.isReactElement)(rest.secondaryActions)) || rest.actionGroups != null && rest.actionGroups.length > 0 || rest.breadcrumbs != null && Array.isArray(rest.breadcrumbs) && rest.breadcrumbs.length > 0 || rest.breadcrumbs != null || rest.backAction != null;
    const contentClassName = (0, _cssJs.classNames)(!hasHeaderContent && (0, _pageScssJsDefault.default).Content, divider && hasHeaderContent && (0, _pageScssJsDefault.default).divider);
    const headerMarkup = hasHeaderContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headerJs.Header), rest) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: pageClassName
    }, headerMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: contentClassName
    }, children));
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/is-interface.js":"71vUS","../../utilities/is-react-element.js":"l3ZVA","./Page.scss.js":"6Q4rK","./components/Header/Header.js":"f2sUd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"71vUS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInterface", ()=>isInterface);
var _react = require("react");
function isInterface(x) {
    return !/*#__PURE__*/ (0, _react.isValidElement)(x) && x !== undefined;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l3ZVA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isReactElement", ()=>isReactElement);
var _react = require("react");
function isReactElement(x) {
    return /*#__PURE__*/ (0, _react.isValidElement)(x) && x !== undefined;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Q4rK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Page": "Polaris-Page",
    "fullWidth": "Polaris-Page--fullWidth",
    "narrowWidth": "Polaris-Page--narrowWidth",
    "Content": "Polaris-Page__Content",
    "divider": "Polaris-Page--divider"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f2sUd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _componentsJs = require("../../../../utilities/components.js");
var _isInterfaceJs = require("../../../../utilities/is-interface.js");
var _isReactElementJs = require("../../../../utilities/is-react-element.js");
var _headerScssJs = require("./Header.scss.js");
var _headerScssJsDefault = parcelHelpers.interopDefault(_headerScssJs);
var _breadcrumbsJs = require("../../../Breadcrumbs/Breadcrumbs.js");
var _paginationJs = require("../../../Pagination/Pagination.js");
var _titleJs = require("./components/Title/Title.js");
var _actionMenuJs = require("../../../ActionMenu/ActionMenu.js");
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../../../utilities/media-query/hooks.js");
var _boxJs = require("../../../Box/Box.js");
var _textJs = require("../../../Text/Text.js");
var _horizontalStackJs = require("../../../HorizontalStack/HorizontalStack.js");
var _utilsJs = require("../../../Button/utils.js");
var _tooltipJs = require("../../../Tooltip/Tooltip.js");
const SHORT_TITLE = 20;
const REALLY_SHORT_TITLE = 8;
const LONG_TITLE = 34;
function Header({ title, subtitle, titleMetadata, additionalMetadata, titleHidden = false, primaryAction, pagination, additionalNavigation, breadcrumbs, backAction, secondaryActions = [], actionGroups = [], compactTitle = false, onActionRollup }) {
    const i18n = (0, _hooksJs.useI18n)();
    const { isNavigationCollapsed } = (0, _hooksJs1.useMediaQuery)();
    const isSingleRow = !primaryAction && !pagination && ((0, _isInterfaceJs.isInterface)(secondaryActions) && !secondaryActions.length || (0, _isReactElementJs.isReactElement)(secondaryActions)) && !actionGroups.length;
    let breadcrumbMarkup = null;
    if (backAction) breadcrumbMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).BreadcrumbWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        maxWidth: "100%",
        paddingInlineEnd: "4",
        printHidden: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbsJs.Breadcrumbs), {
        backAction: backAction
    })));
    else if (Array.isArray(breadcrumbs) && breadcrumbs.length > 0 || !Array.isArray(breadcrumbs) && breadcrumbs) breadcrumbMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).BreadcrumbWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        maxWidth: "100%",
        paddingInlineEnd: "4",
        printHidden: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _breadcrumbsJs.Breadcrumbs), {
        breadcrumbs: breadcrumbs
    })));
    const paginationMarkup = pagination && !isNavigationCollapsed ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).PaginationWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        printHidden: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationJs.Pagination), pagination))) : null;
    const additionalNavigationMarkup = additionalNavigation ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        align: "end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        printHidden: true
    }, additionalNavigation)) : null;
    const pageTitleMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).TitleWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _titleJs.Title), {
        title: title,
        subtitle: subtitle,
        titleMetadata: titleMetadata,
        compactTitle: compactTitle
    }));
    const primaryActionMarkup = primaryAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement(PrimaryActionMarkup, {
        primaryAction: primaryAction
    }) : null;
    let actionMenuMarkup = null;
    if ((0, _isInterfaceJs.isInterface)(secondaryActions) && (secondaryActions.length > 0 || (0, _actionMenuJs.hasGroupsWithActions)(actionGroups))) actionMenuMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionMenuJs.ActionMenu), {
        actions: secondaryActions,
        groups: actionGroups,
        rollup: isNavigationCollapsed,
        rollupActionsLabel: title ? i18n.translate("Polaris.Page.Header.rollupActionsLabel", {
            title
        }) : undefined,
        onActionRollup: onActionRollup
    });
    else if ((0, _isReactElementJs.isReactElement)(secondaryActions)) actionMenuMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, secondaryActions);
    const navigationMarkup = breadcrumbMarkup || paginationMarkup || additionalNavigationMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        printHidden: true,
        paddingBlockEnd: "1",
        paddingInlineEnd: actionMenuMarkup && isNavigationCollapsed ? "10" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        align: "space-between",
        blockAlign: "center"
    }, breadcrumbMarkup, additionalNavigationMarkup, paginationMarkup)) : null;
    const additionalMetadataMarkup = additionalMetadata ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).AdditionalMetaData
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        color: "subdued",
        as: "span"
    }, additionalMetadata)) : null;
    const headerClassNames = (0, _cssJs.classNames)(isSingleRow && (0, _headerScssJsDefault.default).isSingleRow, navigationMarkup && (0, _headerScssJsDefault.default).hasNavigation, actionMenuMarkup && (0, _headerScssJsDefault.default).hasActionMenu, isNavigationCollapsed && (0, _headerScssJsDefault.default).mobileView, !breadcrumbMarkup && (0, _headerScssJsDefault.default).noBreadcrumbs, title && title.length < LONG_TITLE && (0, _headerScssJsDefault.default).mediumTitle, title && title.length > LONG_TITLE && (0, _headerScssJsDefault.default).longTitle);
    const { slot1, slot2, slot3, slot4, slot5, slot6 } = determineLayout({
        actionMenuMarkup,
        additionalMetadataMarkup,
        additionalNavigationMarkup,
        breadcrumbMarkup,
        isNavigationCollapsed,
        pageTitleMarkup,
        paginationMarkup,
        primaryActionMarkup,
        title
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        position: "relative",
        paddingBlockStart: {
            xs: "4",
            md: "5"
        },
        paddingBlockEnd: {
            xs: "4",
            md: "5"
        },
        paddingInlineStart: {
            xs: "4",
            sm: "0"
        },
        paddingInlineEnd: {
            xs: "4",
            sm: "0"
        },
        visuallyHidden: titleHidden
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: headerClassNames
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _componentsJs.ConditionalRender), {
        condition: [
            slot1,
            slot2,
            slot3,
            slot4
        ].some(notNull)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).Row
    }, slot1, slot2, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _componentsJs.ConditionalRender), {
        condition: [
            slot3,
            slot4
        ].some(notNull)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).RightAlign
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _componentsJs.ConditionalWrapper), {
        condition: [
            slot3,
            slot4
        ].every(notNull),
        wrapper: (children)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _headerScssJsDefault.default).Actions
            }, children)
    }, slot3, slot4))))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _componentsJs.ConditionalRender), {
        condition: [
            slot5,
            slot6
        ].some(notNull)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).Row
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4"
    }, slot5), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _componentsJs.ConditionalRender), {
        condition: slot6 != null
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).RightAlign
    }, slot6))))));
}
function PrimaryActionMarkup({ primaryAction }) {
    const { isNavigationCollapsed } = (0, _hooksJs1.useMediaQuery)();
    let actionMarkup;
    if ((0, _isInterfaceJs.isInterface)(primaryAction)) {
        const { primary: isPrimary, helpText } = primaryAction;
        const primary = isPrimary === undefined ? true : isPrimary;
        const content = (0, _utilsJs.buttonFrom)(shouldShowIconOnly(isNavigationCollapsed, primaryAction), {
            primary
        });
        actionMarkup = helpText ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
            content: helpText
        }, content) : content;
    } else actionMarkup = primaryAction;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _headerScssJsDefault.default).PrimaryActionWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        printHidden: true
    }, actionMarkup));
}
function shouldShowIconOnly(isMobile, action) {
    let { content, accessibilityLabel, icon } = action;
    if (icon == null) return {
        ...action,
        icon: undefined
    };
    if (isMobile) {
        accessibilityLabel = accessibilityLabel || content;
        content = undefined;
    } else icon = undefined;
    return {
        ...action,
        content,
        accessibilityLabel,
        icon
    };
}
function notNull(value) {
    return value != null;
}
function determineLayout({ actionMenuMarkup, additionalMetadataMarkup, additionalNavigationMarkup, breadcrumbMarkup, isNavigationCollapsed, pageTitleMarkup, paginationMarkup, primaryActionMarkup, title }) {
    //    Header Layout
    // |----------------------------------------------------|
    // | slot1 | slot2 |                    | slot3 | slot4 |
    // |----------------------------------------------------|
    // | slot5 |                                    | slot6 |
    // |----------------------------------------------------|
    //
    const layouts = {
        mobileCompact: {
            slots: {
                slot1: null,
                slot2: pageTitleMarkup,
                slot3: actionMenuMarkup,
                slot4: primaryActionMarkup,
                slot5: additionalMetadataMarkup,
                slot6: additionalNavigationMarkup
            },
            condition: isNavigationCollapsed && breadcrumbMarkup == null && title != null && title.length <= REALLY_SHORT_TITLE
        },
        mobileDefault: {
            slots: {
                slot1: breadcrumbMarkup,
                slot2: pageTitleMarkup,
                slot3: actionMenuMarkup,
                slot4: primaryActionMarkup,
                slot5: additionalMetadataMarkup,
                slot6: additionalNavigationMarkup
            },
            condition: isNavigationCollapsed
        },
        desktopCompact: {
            slots: {
                slot1: breadcrumbMarkup,
                slot2: pageTitleMarkup,
                slot3: actionMenuMarkup,
                slot4: primaryActionMarkup,
                slot5: additionalMetadataMarkup,
                slot6: additionalNavigationMarkup
            },
            condition: !isNavigationCollapsed && paginationMarkup == null && actionMenuMarkup == null && title != null && title.length <= SHORT_TITLE
        },
        desktopDefault: {
            slots: {
                slot1: breadcrumbMarkup,
                slot2: pageTitleMarkup,
                slot3: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, actionMenuMarkup, primaryActionMarkup),
                slot4: paginationMarkup,
                slot5: additionalMetadataMarkup,
                slot6: additionalNavigationMarkup
            },
            condition: !isNavigationCollapsed
        }
    };
    const layout = Object.values(layouts).find((layout)=>layout.condition) || layouts.desktopDefault;
    return layout.slots;
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../../../utilities/components.js":"6Xyqa","../../../../utilities/is-interface.js":"71vUS","../../../../utilities/is-react-element.js":"l3ZVA","./Header.scss.js":"jErbz","../../../Breadcrumbs/Breadcrumbs.js":"bUGef","../../../Pagination/Pagination.js":"2TJ4a","./components/Title/Title.js":"c90j6","../../../ActionMenu/ActionMenu.js":"dboRA","../../../../utilities/i18n/hooks.js":"hhMhA","../../../../utilities/media-query/hooks.js":"jzbEF","../../../Box/Box.js":"lbjkG","../../../Text/Text.js":"l8Av9","../../../HorizontalStack/HorizontalStack.js":"fotqA","../../../Button/utils.js":"drbMl","../../../Tooltip/Tooltip.js":"k7vL7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jErbz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "TitleWrapper": "Polaris-Page-Header__TitleWrapper",
    "BreadcrumbWrapper": "Polaris-Page-Header__BreadcrumbWrapper",
    "PaginationWrapper": "Polaris-Page-Header__PaginationWrapper",
    "PrimaryActionWrapper": "Polaris-Page-Header__PrimaryActionWrapper",
    "Row": "Polaris-Page-Header__Row",
    "mobileView": "Polaris-Page-Header--mobileView",
    "RightAlign": "Polaris-Page-Header__RightAlign",
    "noBreadcrumbs": "Polaris-Page-Header--noBreadcrumbs",
    "AdditionalMetaData": "Polaris-Page-Header__AdditionalMetaData",
    "Actions": "Polaris-Page-Header__Actions",
    "longTitle": "Polaris-Page-Header--longTitle",
    "mediumTitle": "Polaris-Page-Header--mediumTitle",
    "isSingleRow": "Polaris-Page-Header--isSingleRow"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2TJ4a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", ()=>Pagination);
var _polarisIcons = require("@shopify/polaris-icons");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isInputFocusedJs = require("../../utilities/is-input-focused.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _keypressListenerJs = require("../KeypressListener/KeypressListener.js");
var _buttonGroupJs = require("../ButtonGroup/ButtonGroup.js");
var _tooltipJs = require("../Tooltip/Tooltip.js");
var _buttonJs = require("../Button/Button.js");
var _textJs = require("../Text/Text.js");
function Pagination({ hasNext, hasPrevious, nextURL, previousURL, onNext, onPrevious, nextTooltip, previousTooltip, nextKeys, previousKeys, accessibilityLabel, accessibilityLabels, label }) {
    const i18n = (0, _hooksJs.useI18n)();
    const node = /*#__PURE__*/ (0, _react.createRef)();
    const navLabel = accessibilityLabel || i18n.translate("Polaris.Pagination.pagination");
    const previousLabel = (accessibilityLabels === null || accessibilityLabels === void 0 ? void 0 : accessibilityLabels.previous) || i18n.translate("Polaris.Pagination.previous");
    const nextLabel = (accessibilityLabels === null || accessibilityLabels === void 0 ? void 0 : accessibilityLabels.next) || i18n.translate("Polaris.Pagination.next");
    const prev = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        outline: true,
        icon: (0, _polarisIcons.ChevronLeftMinor),
        accessibilityLabel: previousLabel,
        url: previousURL,
        onClick: onPrevious,
        disabled: !hasPrevious,
        id: "previousURL"
    });
    const constructedPrevious = previousTooltip && hasPrevious ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
        activatorWrapper: "span",
        content: previousTooltip
    }, prev) : prev;
    const next = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        outline: true,
        icon: (0, _polarisIcons.ChevronRightMinor),
        accessibilityLabel: nextLabel,
        url: nextURL,
        onClick: onNext,
        disabled: !hasNext,
        id: "nextURL"
    });
    const constructedNext = nextTooltip && hasNext ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipJs.Tooltip), {
        activatorWrapper: "span",
        content: nextTooltip
    }, next) : next;
    const previousHandler = onPrevious || noop;
    const previousButtonEvents = previousKeys && (previousURL || onPrevious) && hasPrevious && previousKeys.map((key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
            key: key,
            keyCode: key,
            handler: previousURL ? handleCallback(clickPaginationLink("previousURL", node)) : handleCallback(previousHandler)
        }));
    const nextHandler = onNext || noop;
    const nextButtonEvents = nextKeys && (nextURL || onNext) && hasNext && nextKeys.map((key)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keypressListenerJs.KeypressListener), {
            key: key,
            keyCode: key,
            handler: nextURL ? handleCallback(clickPaginationLink("nextURL", node)) : handleCallback(nextHandler)
        }));
    const labelTextMarkup = hasNext && hasPrevious ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, label) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        color: "subdued",
        as: "span"
    }, label);
    const labelMarkup = label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "aria-live": "polite"
    }, labelTextMarkup) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", {
        "aria-label": navLabel,
        ref: node
    }, previousButtonEvents, nextButtonEvents, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), {
        segmented: !label
    }, constructedPrevious, labelMarkup, constructedNext));
}
function clickPaginationLink(id, node) {
    return ()=>{
        if (node.current == null) return;
        const link = node.current.querySelector(`#${id}`);
        if (link) link.click();
    };
}
function handleCallback(fn) {
    return ()=>{
        if ((0, _isInputFocusedJs.isInputFocused)()) return;
        fn();
    };
}
function noop() {}

},{"@shopify/polaris-icons":"zOlgc","react":"cOWTg","../../utilities/is-input-focused.js":"jp6Ef","../../utilities/i18n/hooks.js":"hhMhA","../KeypressListener/KeypressListener.js":"1eFmF","../ButtonGroup/ButtonGroup.js":"QiqnY","../Tooltip/Tooltip.js":"k7vL7","../Button/Button.js":"6Szv4","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jp6Ef":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInputFocused", ()=>isInputFocused);
var EditableTarget;
(function(EditableTarget) {
    EditableTarget["Input"] = "INPUT";
    EditableTarget["Textarea"] = "TEXTAREA";
    EditableTarget["Select"] = "SELECT";
    EditableTarget["ContentEditable"] = "contenteditable";
})(EditableTarget || (EditableTarget = {}));
function isInputFocused() {
    if (document == null || document.activeElement == null) return false;
    const { tagName } = document.activeElement;
    return tagName === EditableTarget.Input || tagName === EditableTarget.Textarea || tagName === EditableTarget.Select || document.activeElement.hasAttribute(EditableTarget.ContentEditable);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c90j6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Title", ()=>Title);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../../../utilities/css.js");
var _titleScssJs = require("./Title.scss.js");
var _titleScssJsDefault = parcelHelpers.interopDefault(_titleScssJs);
function Title({ title, subtitle, titleMetadata, compactTitle }) {
    const className = (0, _cssJs.classNames)((0, _titleScssJsDefault.default).Title, subtitle && (0, _titleScssJsDefault.default).TitleWithSubtitle);
    const titleMarkup = title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", {
        className: className
    }, title) : null;
    const titleMetadataMarkup = titleMetadata ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _titleScssJsDefault.default).TitleMetadata
    }, titleMetadata) : null;
    const wrappedTitleMarkup = titleMetadata ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _titleScssJsDefault.default).TitleWithMetadataWrapper
    }, titleMarkup, titleMetadataMarkup) : titleMarkup;
    const subtitleMarkup = subtitle ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _titleScssJsDefault.default).SubTitle, compactTitle && (0, _titleScssJsDefault.default).SubtitleCompact)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, subtitle)) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, wrappedTitleMarkup, subtitleMarkup);
}

},{"react":"cOWTg","../../../../../../utilities/css.js":"lGt6N","./Title.scss.js":"e59Ki","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e59Ki":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Title": "Polaris-Header-Title",
    "TitleWithSubtitle": "Polaris-Header-Title__TitleWithSubtitle",
    "SubTitle": "Polaris-Header-Title__SubTitle",
    "SubtitleCompact": "Polaris-Header-Title__SubtitleCompact",
    "TitleWithMetadataWrapper": "Polaris-Header-Title__TitleWithMetadataWrapper",
    "TitleMetadata": "Polaris-Header-Title__TitleMetadata"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5UjAK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", ()=>ProgressBar);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _polarisTokens = require("@shopify/polaris-tokens");
var _cssJs = require("../../utilities/css.js");
var _progressBarScssJs = require("./ProgressBar.scss.js");
var _progressBarScssJsDefault = parcelHelpers.interopDefault(_progressBarScssJs);
var _hooksJs = require("../../utilities/i18n/hooks.js");
function ProgressBar({ progress = 0, size = "medium", color = "highlight", animated: hasAppearAnimation = true, ariaLabelledBy }) {
    const i18n = (0, _hooksJs.useI18n)();
    const indicatorRef = (0, _react.useRef)(null);
    const className = (0, _cssJs.classNames)((0, _progressBarScssJsDefault.default).ProgressBar, size && (0, _progressBarScssJsDefault.default)[(0, _cssJs.variationName)("size", size)], color && (0, _progressBarScssJsDefault.default)[(0, _cssJs.variationName)("color", color)]);
    const warningMessage = i18n.translate(progress < 0 ? "Polaris.ProgressBar.negativeWarningMessage" : "Polaris.ProgressBar.exceedWarningMessage", {
        progress
    });
    const parsedProgress = parseProgress(progress, warningMessage);
    const progressBarDuration = hasAppearAnimation ? (0, _polarisTokens.motion)["duration-500"] : (0, _polarisTokens.motion)["duration-0"];
    /* eslint-disable @shopify/jsx-no-hardcoded-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("progress", {
        "aria-labelledby": ariaLabelledBy,
        className: (0, _progressBarScssJsDefault.default).Progress,
        value: parsedProgress,
        max: "100"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.CSSTransition), {
        in: true,
        appear: true,
        timeout: parseInt(progressBarDuration, 10),
        nodeRef: indicatorRef,
        classNames: {
            appearActive: (0, _progressBarScssJsDefault.default).IndicatorAppearActive,
            appearDone: (0, _progressBarScssJsDefault.default).IndicatorAppearDone
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: indicatorRef,
        className: (0, _progressBarScssJsDefault.default).Indicator,
        style: {
            "--pc-progress-bar-duration": progressBarDuration,
            "--pc-progress-bar-percent": parsedProgress / 100
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _progressBarScssJsDefault.default).Label
    }, parsedProgress, "%")))) /* eslint-enable @shopify/jsx-no-hardcoded-content */ ;
}
function parseProgress(progress, warningMessage) {
    let progressWidth;
    if (progress < 0) progressWidth = 0;
    else if (progress > 100) progressWidth = 100;
    else progressWidth = progress;
    return progressWidth;
}

},{"react":"cOWTg","react-transition-group":"1qdFK","@shopify/polaris-tokens":"5ENVX","../../utilities/css.js":"lGt6N","./ProgressBar.scss.js":"hIGpJ","../../utilities/i18n/hooks.js":"hhMhA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hIGpJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ProgressBar": "Polaris-ProgressBar",
    "sizeSmall": "Polaris-ProgressBar--sizeSmall",
    "sizeMedium": "Polaris-ProgressBar--sizeMedium",
    "sizeLarge": "Polaris-ProgressBar--sizeLarge",
    "colorHighlight": "Polaris-ProgressBar--colorHighlight",
    "colorPrimary": "Polaris-ProgressBar--colorPrimary",
    "colorSuccess": "Polaris-ProgressBar--colorSuccess",
    "colorCritical": "Polaris-ProgressBar--colorCritical",
    "Indicator": "Polaris-ProgressBar__Indicator",
    "IndicatorAppearActive": "Polaris-ProgressBar__IndicatorAppearActive",
    "IndicatorAppearDone": "Polaris-ProgressBar__IndicatorAppearDone",
    "Progress": "Polaris-ProgressBar__Progress",
    "Label": "Polaris-ProgressBar__Label"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1PRfM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceItem", ()=>ResourceItem);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _breakpointsJs = require("../../utilities/breakpoints.js");
var _cssJs = require("../../utilities/css.js");
var _resourceItemScssJs = require("./ResourceItem.scss.js");
var _resourceItemScssJsDefault = parcelHelpers.interopDefault(_resourceItemScssJs);
var _typesJs = require("../../utilities/resource-list/types.js");
var _contextJs = require("../../utilities/resource-list/context.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _bleedJs = require("../Bleed/Bleed.js");
var _boxJs = require("../Box/Box.js");
var _checkboxJs = require("../Checkbox/Checkbox.js");
var _buttonGroupJs = require("../ButtonGroup/ButtonGroup.js");
var _utilsJs = require("../Button/utils.js");
var _popoverJs = require("../Popover/Popover.js");
var _buttonJs = require("../Button/Button.js");
var _actionListJs = require("../ActionList/ActionList.js");
var _horizontalGridJs = require("../HorizontalGrid/HorizontalGrid.js");
var _horizontalStackJs = require("../HorizontalStack/HorizontalStack.js");
var _unstyledLinkJs = require("../UnstyledLink/UnstyledLink.js");
var _uniqueIdFactoryJs = require("../../utilities/unique-id/unique-id-factory.js");
const getUniqueCheckboxID = (0, _uniqueIdFactoryJs.globalIdGeneratorFactory)("ResourceListItemCheckbox");
const getUniqueOverlayID = (0, _uniqueIdFactoryJs.globalIdGeneratorFactory)("ResourceListItemOverlay");
class BaseResourceItem extends (0, _react.Component) {
    constructor(...args){
        super(...args);
        this.state = {
            actionsMenuVisible: false,
            focused: false,
            focusedInner: false,
            selected: isSelected(this.props.id, this.props.context.selectedItems)
        };
        this.node = null;
        this.checkboxId = getUniqueCheckboxID();
        this.overlayId = getUniqueOverlayID();
        this.buttonOverlay = /*#__PURE__*/ (0, _react.createRef)();
        this.setNode = (node)=>{
            this.node = node;
        };
        this.handleFocus = (event)=>{
            if (event.target === this.buttonOverlay.current || this.node && event.target === this.node.querySelector(`#${this.overlayId}`)) this.setState({
                focused: true,
                focusedInner: false
            });
            else if (this.node && this.node.contains(event.target)) this.setState({
                focused: true,
                focusedInner: true
            });
        };
        this.handleBlur = ({ relatedTarget })=>{
            if (this.node && relatedTarget instanceof Element && this.node.contains(relatedTarget)) return;
            this.setState({
                focused: false,
                focusedInner: false
            });
        };
        this.handleMouseOut = ()=>{
            this.state.focused && this.setState({
                focused: false,
                focusedInner: false
            });
        };
        this.handleLargerSelectionArea = (event)=>{
            stopPropagation(event);
            this.handleSelection(!this.state.selected, event.nativeEvent.shiftKey);
        };
        this.handleSelection = (value, shiftKey)=>{
            const { id, sortOrder, context: { onSelectionChange } } = this.props;
            if (id == null || onSelectionChange == null) return;
            this.setState({
                focused: value,
                focusedInner: value
            });
            onSelectionChange(value, id, sortOrder, shiftKey);
        };
        this.handleClick = (event)=>{
            stopPropagation(event);
            const { id, onClick, url, context: { selectMode } } = this.props;
            const { ctrlKey, metaKey } = event.nativeEvent;
            const anchor = this.node && this.node.querySelector("a");
            if (selectMode) {
                this.handleLargerSelectionArea(event);
                return;
            }
            if (anchor === event.target) return;
            if (onClick) onClick(id);
            if (url && (ctrlKey || metaKey)) {
                window.open(url, "_blank");
                return;
            }
            if (url && anchor) anchor.click();
        };
        this.handleKeyUp = (event)=>{
            const { onClick = noop, context: { selectMode } } = this.props;
            const { key } = event;
            if (key === "Enter" && this.props.url && !selectMode) onClick();
        };
        this.handleActionsClick = ()=>{
            this.setState(({ actionsMenuVisible })=>({
                    actionsMenuVisible: !actionsMenuVisible
                }));
        };
        this.handleCloseRequest = ()=>{
            this.setState({
                actionsMenuVisible: false
            });
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const selected = isSelected(nextProps.id, nextProps.context.selectedItems);
        if (prevState.selected === selected) return null;
        return {
            selected
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { children: nextChildren, context: { selectedItems: nextSelectedItems, ...restNextContext }, ...restNextProps } = nextProps;
        const { children, context: { selectedItems, ...restContext }, ...restProps } = this.props;
        const nextSelectMode = nextProps.context.selectMode;
        return !(0, _reactFastCompareDefault.default)(this.state, nextState) || this.props.context.selectMode !== nextSelectMode || !nextProps.context.selectMode && (!(0, _reactFastCompareDefault.default)(restProps, restNextProps) || !(0, _reactFastCompareDefault.default)(restContext, restNextContext));
    }
    render() {
        const { children, url, external, media, shortcutActions, ariaControls, ariaExpanded, persistActions = false, accessibilityLabel, name, context: { selectable, selectMode, hasBulkActions, loading, resourceName }, i18n, verticalAlignment, dataHref, breakpoints } = this.props;
        const { actionsMenuVisible, focused, focusedInner, selected } = this.state;
        let ownedMarkup = null;
        let handleMarkup = null;
        if (selectable) {
            const checkboxAccessibilityLabel = name || accessibilityLabel || i18n.translate("Polaris.Common.checkbox");
            handleMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                onClick: this.handleLargerSelectionArea
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bleedJs.Bleed), {
                marginBlock: "2",
                marginInline: "3"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
                zIndex: "var(--pc-resource-item-content-stacking-order)",
                paddingInlineStart: "3",
                paddingInlineEnd: "3",
                paddingBlockStart: "3",
                paddingBlockEnd: "2"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                onClick: stopPropagation
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                onChange: this.handleLargerSelectionArea
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkboxJs.Checkbox), {
                id: this.checkboxId,
                label: checkboxAccessibilityLabel,
                labelHidden: true,
                checked: selected,
                disabled: loading
            }))))));
        }
        if (media || selectable) ownedMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
            gap: "4",
            blockAlign: media && selectable ? "center" : getAlignment(verticalAlignment)
        }, handleMarkup, media);
        const className = (0, _cssJs.classNames)((0, _resourceItemScssJsDefault.default).ResourceItem, focused && (0, _resourceItemScssJsDefault.default).focused, selectable && (0, _resourceItemScssJsDefault.default).selectable, selected && (0, _resourceItemScssJsDefault.default).selected, selectMode && (0, _resourceItemScssJsDefault.default).selectMode, persistActions && (0, _resourceItemScssJsDefault.default).persistActions, focusedInner && (0, _resourceItemScssJsDefault.default).focusedInner);
        const listItemClassName = (0, _cssJs.classNames)((0, _resourceItemScssJsDefault.default).ListItem, focused && !focusedInner && (0, _resourceItemScssJsDefault.default).focused, hasBulkActions && (0, _resourceItemScssJsDefault.default).hasBulkActions);
        let actionsMarkup = null;
        let disclosureMarkup = null;
        if (shortcutActions && !loading) {
            if (persistActions) {
                actionsMarkup = breakpoints !== null && breakpoints !== void 0 && breakpoints.lgUp ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: (0, _resourceItemScssJsDefault.default).Actions,
                    onClick: stopPropagation
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), null, (0, _utilsJs.buttonsFrom)(shortcutActions, {
                    plain: true
                }))) : null;
                const disclosureAccessibilityLabel = name ? i18n.translate("Polaris.ResourceList.Item.actionsDropdownLabel", {
                    accessibilityLabel: name
                }) : i18n.translate("Polaris.ResourceList.Item.actionsDropdown");
                disclosureMarkup = !selectMode && breakpoints !== null && breakpoints !== void 0 && breakpoints.lgDown ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    onClick: stopPropagation
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
                    activator: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
                        accessibilityLabel: disclosureAccessibilityLabel,
                        onClick: this.handleActionsClick,
                        plain: true,
                        icon: (0, _polarisIcons.HorizontalDotsMinor)
                    }),
                    onClose: this.handleCloseRequest,
                    active: actionsMenuVisible
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
                    items: shortcutActions
                }))) : null;
            } else if (breakpoints !== null && breakpoints !== void 0 && breakpoints.lgUp) actionsMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: (0, _resourceItemScssJsDefault.default).Actions,
                onClick: stopPropagation
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
                position: "absolute",
                insetBlockStart: "4",
                insetInlineEnd: "5"
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonGroupJs.ButtonGroup), {
                segmented: true
            }, (0, _utilsJs.buttonsFrom)(shortcutActions, {
                size: "slim"
            }))));
        }
        const containerMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            id: this.props.id,
            position: "relative",
            padding: "3",
            paddingInlineStart: {
                xs: "4",
                sm: "5"
            },
            paddingInlineEnd: {
                xs: "4",
                sm: "5"
            },
            zIndex: "var(--pc-resource-item-content-stacking-order)"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalGridJs.HorizontalGrid), {
            columns: {
                xs: "1fr auto"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalGridJs.HorizontalGrid), {
            columns: {
                xs: media || selectable ? "auto 1fr" : "1fr"
            },
            gap: "5"
        }, ownedMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
            gap: "4",
            blockAlign: getAlignment(verticalAlignment)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
            width: "100%",
            padding: "0",
            paddingInlineStart: "0",
            paddingInlineEnd: "0"
        }, children))), actionsMarkup, disclosureMarkup));
        const tabIndex = loading ? -1 : 0;
        const ariaLabel = accessibilityLabel || i18n.translate("Polaris.ResourceList.Item.viewItem", {
            itemName: name || resourceName && resourceName.singular || ""
        });
        const accessibleMarkup = url ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
            "aria-describedby": this.props.id,
            "aria-label": ariaLabel,
            className: (0, _resourceItemScssJsDefault.default).Link,
            url: url,
            external: external,
            tabIndex: tabIndex,
            id: this.overlayId
        }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            className: (0, _resourceItemScssJsDefault.default).Button,
            "aria-label": ariaLabel,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            onClick: this.handleClick,
            tabIndex: tabIndex,
            ref: this.buttonOverlay
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            className: listItemClassName,
            "data-href": dataHref
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _resourceItemScssJsDefault.default).ItemWrapper
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: this.setNode,
            className: className,
            onClick: this.handleClick,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onKeyUp: this.handleKeyUp,
            onMouseOut: this.handleMouseOut,
            "data-href": url
        }, accessibleMarkup, containerMarkup)));
    }
}
function noop() {}
function stopPropagation(event) {
    event.stopPropagation();
}
function isSelected(id, selectedItems) {
    return Boolean(selectedItems && (Array.isArray(selectedItems) && selectedItems.includes(id) || selectedItems === (0, _typesJs.SELECT_ALL_ITEMS)));
}
function ResourceItem(props) {
    const breakpoints = (0, _breakpointsJs.useBreakpoints)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BaseResourceItem, Object.assign({}, props, {
        breakpoints: breakpoints,
        context: (0, _react.useContext)((0, _contextJs.ResourceListContext)),
        i18n: (0, _hooksJs.useI18n)()
    }));
}
function getAlignment(alignment) {
    switch(alignment){
        case "leading":
            return "start";
        case "trailing":
            return "end";
        case "center":
            return "center";
        case "fill":
            return "stretch";
        case "baseline":
            return "baseline";
        default:
            return "start";
    }
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","react-fast-compare":"5bxip","../../utilities/breakpoints.js":"icMVM","../../utilities/css.js":"lGt6N","./ResourceItem.scss.js":"5n3fn","../../utilities/resource-list/types.js":"9wLsf","../../utilities/resource-list/context.js":"jzPOe","../../utilities/i18n/hooks.js":"hhMhA","../Bleed/Bleed.js":"3Epca","../Box/Box.js":"lbjkG","../Checkbox/Checkbox.js":"1FKW4","../ButtonGroup/ButtonGroup.js":"QiqnY","../Button/utils.js":"drbMl","../Popover/Popover.js":"cE1F7","../Button/Button.js":"6Szv4","../ActionList/ActionList.js":"kU0n2","../HorizontalGrid/HorizontalGrid.js":"6vqWM","../HorizontalStack/HorizontalStack.js":"fotqA","../UnstyledLink/UnstyledLink.js":"4o3DP","../../utilities/unique-id/unique-id-factory.js":"4Mnif","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5n3fn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ResourceItem": "Polaris-ResourceItem",
    "Actions": "Polaris-ResourceItem__Actions",
    "ItemWrapper": "Polaris-ResourceItem__ItemWrapper",
    "focusedInner": "Polaris-ResourceItem--focusedInner",
    "focused": "Polaris-ResourceItem--focused",
    "selected": "Polaris-ResourceItem--selected",
    "Link": "Polaris-ResourceItem__Link",
    "Button": "Polaris-ResourceItem__Button",
    "selectable": "Polaris-ResourceItem--selectable",
    "selectMode": "Polaris-ResourceItem--selectMode",
    "ListItem": "Polaris-ResourceItem__ListItem"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9wLsf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SELECT_ALL_ITEMS", ()=>SELECT_ALL_ITEMS);
const SELECT_ALL_ITEMS = "All";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jDAwW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResourceList", ()=>ResourceList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _polarisTokens = require("@shopify/polaris-tokens");
var _debounceJs = require("../../utilities/debounce.js");
var _cssJs = require("../../utilities/css.js");
var _componentsJs = require("../../utilities/components.js");
var _useLazyRefJs = require("../../utilities/use-lazy-ref.js");
var _resourceListScssJs = require("./ResourceList.scss.js");
var _resourceListScssJsDefault = parcelHelpers.interopDefault(_resourceListScssJs);
var _selectJs = require("../Select/Select.js");
var _resourceItemJs = require("../ResourceItem/ResourceItem.js");
var _typesJs = require("../../utilities/resource-list/types.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _useIsBulkActionsStickyJs = require("../BulkActions/hooks/use-is-bulk-actions-sticky.js");
var _selectAllActionsJs = require("../SelectAllActions/SelectAllActions.js");
var _buttonJs = require("../Button/Button.js");
var _checkableButtonJs = require("../CheckableButton/CheckableButton.js");
var _stickyJs = require("../Sticky/Sticky.js");
var _emptySearchResultJs = require("../EmptySearchResult/EmptySearchResult.js");
var _spinnerJs = require("../Spinner/Spinner.js");
var _contextJs = require("../../utilities/resource-list/context.js");
var _eventListenerJs = require("../EventListener/EventListener.js");
var _bulkActionsJs = require("../BulkActions/BulkActions.js");
const SMALL_SPINNER_HEIGHT = 28;
const LARGE_SPINNER_HEIGHT = 45;
function getAllItemsOnPage(items, idForItem) {
    return items.map((item, index)=>{
        return idForItem(item, index);
    });
}
const isBreakpointsXS = ()=>{
    var _toPx;
    return typeof window === "undefined" ? false : window.innerWidth < parseFloat((_toPx = (0, _polarisTokens.toPx)((0, _polarisTokens.tokens).breakpoints["breakpoints-sm"])) !== null && _toPx !== void 0 ? _toPx : "");
};
function defaultIdForItem(item, index) {
    return Object.prototype.hasOwnProperty.call(item, "id") ? item.id : index.toString();
}
function ResourceList({ items, filterControl, flushFilters, emptyState, emptySearchState, resourceName: resourceNameProp, promotedBulkActions, bulkActions, selectedItems = [], isFiltered, selectable, hasMoreItems, loading, headerContent, showHeader, totalItemsCount, sortValue, sortOptions, alternateTool, onSortChange, onSelectionChange, renderItem, idForItem = defaultIdForItem, resolveItemId }) {
    const i18n = (0, _hooksJs.useI18n)();
    const [selectMode, setSelectMode] = (0, _react.useState)(Boolean(selectedItems && selectedItems.length > 0));
    const [loadingPosition, setLoadingPositionState] = (0, _react.useState)(0);
    const [lastSelected, setLastSelected] = (0, _react.useState)();
    const [smallScreen, setSmallScreen] = (0, _react.useState)(isBreakpointsXS());
    const forceUpdate = (0, _react.useReducer)((x = 0)=>x + 1, 0)[1];
    const checkableButtonRef = (0, _react.useRef)(null);
    const { bulkActionsIntersectionRef, tableMeasurerRef, isBulkActionsSticky, bulkActionsAbsoluteOffset, bulkActionsMaxWidth, bulkActionsOffsetLeft, computeTableDimensions } = (0, _useIsBulkActionsStickyJs.useIsBulkActionsSticky)(selectMode);
    (0, _react.useEffect)(()=>{
        computeTableDimensions();
    }, [
        computeTableDimensions,
        items.length
    ]);
    const defaultResourceName = (0, _useLazyRefJs.useLazyRef)(()=>({
            singular: i18n.translate("Polaris.ResourceList.defaultItemSingular"),
            plural: i18n.translate("Polaris.ResourceList.defaultItemPlural")
        }));
    const listRef = (0, _react.useRef)(null);
    const handleSelectMode = (selectMode)=>{
        setSelectMode(selectMode);
        if (!selectMode && onSelectionChange) onSelectionChange([]);
    };
    const handleResize = (0, _debounceJs.debounce)(()=>{
        const newSmallScreen = isBreakpointsXS();
        if (selectedItems && selectedItems.length === 0 && selectMode && !newSmallScreen) handleSelectMode(false);
        if (smallScreen !== newSmallScreen) setSmallScreen(newSmallScreen);
    }, 50, {
        leading: true,
        trailing: true,
        maxWait: 50
    });
    const isSelectable = Boolean(promotedBulkActions && promotedBulkActions.length > 0 || bulkActions && bulkActions.length > 0 || selectable) && !smallScreen;
    const selectAllSelectState = ()=>{
        let selectState = "indeterminate";
        if (!selectedItems || Array.isArray(selectedItems) && selectedItems.length === 0) selectState = false;
        else if (selectedItems === (0, _typesJs.SELECT_ALL_ITEMS) || Array.isArray(selectedItems) && selectedItems.length === items.length) selectState = true;
        return selectState;
    };
    const resourceName = resourceNameProp ? resourceNameProp : defaultResourceName.current;
    const headerTitle = ()=>{
        const itemsCount = items.length;
        const resource = !loading && (!totalItemsCount && itemsCount === 1 || totalItemsCount === 1) ? resourceName.singular : resourceName.plural;
        if (loading) return i18n.translate("Polaris.ResourceList.loading", {
            resource
        });
        else if (totalItemsCount) return i18n.translate("Polaris.ResourceList.showingTotalCount", {
            itemsCount,
            totalItemsCount,
            resource
        });
        else if (headerContent) return headerContent;
        else return i18n.translate("Polaris.ResourceList.showing", {
            itemsCount,
            resource
        });
    };
    const selectAllActionsLabel = ()=>{
        const selectedItemsCount = selectedItems === (0, _typesJs.SELECT_ALL_ITEMS) ? `${items.length}+` : selectedItems.length;
        return i18n.translate("Polaris.ResourceList.selected", {
            selectedItemsCount
        });
    };
    const selectAllActionsAccessibilityLabel = ()=>{
        const selectedItemsCount = selectedItems.length;
        const totalItemsCount = items.length;
        const allSelected = selectedItemsCount === totalItemsCount;
        if (totalItemsCount === 1 && allSelected) return i18n.translate("Polaris.ResourceList.a11yCheckboxDeselectAllSingle", {
            resourceNameSingular: resourceName.singular
        });
        else if (totalItemsCount === 1) return i18n.translate("Polaris.ResourceList.a11yCheckboxSelectAllSingle", {
            resourceNameSingular: resourceName.singular
        });
        else if (allSelected) return i18n.translate("Polaris.ResourceList.a11yCheckboxDeselectAllMultiple", {
            itemsLength: items.length,
            resourceNamePlural: resourceName.plural
        });
        else return i18n.translate("Polaris.ResourceList.a11yCheckboxSelectAllMultiple", {
            itemsLength: items.length,
            resourceNamePlural: resourceName.plural
        });
    };
    const paginatedSelectAllText = ()=>{
        if (!isSelectable || !hasMoreItems) return;
        if (selectedItems === (0, _typesJs.SELECT_ALL_ITEMS)) return i18n.translate(isFiltered ? "Polaris.ResourceList.allFilteredItemsSelected" : "Polaris.ResourceList.allItemsSelected", {
            itemsLength: items.length,
            resourceNamePlural: resourceName.plural
        });
    };
    const paginatedSelectAllAction = ()=>{
        if (!isSelectable || !hasMoreItems) return;
        const actionText = selectedItems === (0, _typesJs.SELECT_ALL_ITEMS) ? i18n.translate("Polaris.Common.undo") : i18n.translate(isFiltered ? "Polaris.ResourceList.selectAllFilteredItems" : "Polaris.ResourceList.selectAllItems", {
            itemsLength: items.length,
            resourceNamePlural: resourceName.plural
        });
        return {
            content: actionText,
            onAction: handleSelectAllItemsInStore
        };
    };
    const emptySearchResultText = {
        title: i18n.translate("Polaris.ResourceList.emptySearchResultTitle", {
            resourceNamePlural: resourceName.plural
        }),
        description: i18n.translate("Polaris.ResourceList.emptySearchResultDescription")
    };
    const handleSelectAllItemsInStore = ()=>{
        const newlySelectedItems = selectedItems === (0, _typesJs.SELECT_ALL_ITEMS) ? getAllItemsOnPage(items, idForItem) : (0, _typesJs.SELECT_ALL_ITEMS);
        if (onSelectionChange) onSelectionChange(newlySelectedItems);
    };
    const setLoadingPosition = (0, _react.useCallback)(()=>{
        if (listRef.current != null) {
            if (typeof window === "undefined") return;
            const overlay = listRef.current.getBoundingClientRect();
            const viewportHeight = Math.max(document.documentElement ? document.documentElement.clientHeight : 0, window.innerHeight || 0);
            const overflow = viewportHeight - overlay.height;
            const spinnerHeight = items.length === 1 ? SMALL_SPINNER_HEIGHT : LARGE_SPINNER_HEIGHT;
            const spinnerPosition = overflow > 0 ? (overlay.height - spinnerHeight) / 2 : (viewportHeight - overlay.top - spinnerHeight) / 2;
            setLoadingPositionState(spinnerPosition);
        }
    }, [
        listRef,
        items.length
    ]);
    const itemsExist = items.length > 0;
    (0, _react.useEffect)(()=>{
        if (loading) setLoadingPosition();
    }, [
        loading,
        setLoadingPosition
    ]);
    (0, _react.useEffect)(()=>{
        if (selectedItems && selectedItems.length > 0 && !selectMode) setSelectMode(true);
        if ((!selectedItems || selectedItems.length === 0) && !isBreakpointsXS()) setSelectMode(false);
    }, [
        selectedItems,
        selectMode
    ]);
    (0, _react.useEffect)(()=>{
        forceUpdate();
    }, [
        forceUpdate,
        items
    ]);
    const renderItemWithId = (item, index)=>{
        const id = idForItem(item, index);
        const itemContent = renderItem(item, id, index);
        return itemContent;
    };
    const handleMultiSelectionChange = (lastSelected, currentSelected, resolveItemId)=>{
        const min = Math.min(lastSelected, currentSelected);
        const max = Math.max(lastSelected, currentSelected);
        return items.slice(min, max + 1).map(resolveItemId);
    };
    const handleSelectionChange = (selected, id, sortOrder, shiftKey)=>{
        if (selectedItems == null || onSelectionChange == null) return;
        let newlySelectedItems = selectedItems === (0, _typesJs.SELECT_ALL_ITEMS) ? getAllItemsOnPage(items, idForItem) : [
            ...selectedItems
        ];
        if (sortOrder !== undefined) setLastSelected(sortOrder);
        const lastSelectedFromState = lastSelected;
        let selectedIds = [
            id
        ];
        if (shiftKey && lastSelectedFromState != null && sortOrder !== undefined && resolveItemId) selectedIds = handleMultiSelectionChange(lastSelectedFromState, sortOrder, resolveItemId);
        newlySelectedItems = [
            ...new Set([
                ...newlySelectedItems,
                ...selectedIds
            ])
        ];
        if (!selected) for (const selectedId of selectedIds)newlySelectedItems.splice(newlySelectedItems.indexOf(selectedId), 1);
        if (newlySelectedItems.length === 0 && !isBreakpointsXS()) handleSelectMode(false);
        else if (newlySelectedItems.length > 0) handleSelectMode(true);
        if (onSelectionChange) onSelectionChange(newlySelectedItems);
    };
    const handleToggleAll = ()=>{
        let newlySelectedItems;
        if (Array.isArray(selectedItems) && selectedItems.length === items.length || selectedItems === (0, _typesJs.SELECT_ALL_ITEMS)) newlySelectedItems = [];
        else newlySelectedItems = items.map((item, index)=>{
            return idForItem(item, index);
        });
        if (newlySelectedItems.length === 0 && !isBreakpointsXS()) handleSelectMode(false);
        else if (newlySelectedItems.length > 0) handleSelectMode(true);
        if (onSelectionChange) onSelectionChange(newlySelectedItems);
         // setTimeout ensures execution after the Transition on BulkActions
        setTimeout(()=>{
            var _checkableButtonRef$c;
            checkableButtonRef === null || checkableButtonRef === void 0 || (_checkableButtonRef$c = checkableButtonRef.current) === null || _checkableButtonRef$c === void 0 || _checkableButtonRef$c.focus();
        }, 0);
    };
    const selectAllActionsMarkup = isSelectable ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).SelectAllActionsWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectAllActionsJs.SelectAllActions), {
        label: selectAllActionsLabel(),
        accessibilityLabel: selectAllActionsAccessibilityLabel(),
        selected: selectAllSelectState(),
        onToggleAll: handleToggleAll,
        selectMode: selectMode,
        paginatedSelectAllAction: paginatedSelectAllAction(),
        paginatedSelectAllText: paginatedSelectAllText(),
        disabled: loading,
        ref: checkableButtonRef
    })) : null;
    const bulkActionClassNames = (0, _cssJs.classNames)((0, _resourceListScssJsDefault.default).BulkActionsWrapper, isBulkActionsSticky && (0, _resourceListScssJsDefault.default).BulkActionsWrapperSticky);
    const bulkActionsMarkup = isSelectable && selectMode && (bulkActions || promotedBulkActions) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: bulkActionClassNames,
        style: {
            top: isBulkActionsSticky ? undefined : bulkActionsAbsoluteOffset,
            width: bulkActionsMaxWidth,
            left: isBulkActionsSticky ? bulkActionsOffsetLeft : undefined
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _bulkActionsJs.BulkActions), {
        selectMode: selectMode,
        onSelectModeToggle: handleSelectMode,
        promotedActions: promotedBulkActions,
        actions: bulkActions,
        disabled: loading,
        isSticky: isBulkActionsSticky,
        width: bulkActionsMaxWidth
    })) : null;
    const filterControlMarkup = filterControl ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)(!flushFilters && (0, _resourceListScssJsDefault.default).FiltersWrapper)
    }, filterControl) : null;
    const sortingSelectMarkup = sortOptions && sortOptions.length > 0 && !alternateTool ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).SortWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectJs.Select), {
        label: i18n.translate("Polaris.ResourceList.sortingLabel"),
        labelInline: !smallScreen,
        labelHidden: smallScreen,
        options: sortOptions,
        onChange: onSortChange,
        value: sortValue,
        disabled: selectMode
    })) : null;
    const alternateToolMarkup = alternateTool && !sortingSelectMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).AlternateToolWrapper
    }, alternateTool) : null;
    const headerTitleMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).HeaderTitleWrapper
    }, headerTitle());
    const selectButtonMarkup = isSelectable ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).SelectButtonWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        disabled: selectMode,
        icon: (0, _polarisIcons.EnableSelectionMinor),
        onClick: ()=>handleSelectMode(true)
    }, i18n.translate("Polaris.ResourceList.selectButtonText"))) : null;
    const checkableButtonMarkup = isSelectable ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).CheckableButtonWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkableButtonJs.CheckableButton), {
        accessibilityLabel: selectAllActionsAccessibilityLabel(),
        label: headerTitle(),
        onToggleAll: handleToggleAll,
        disabled: loading,
        ref: checkableButtonRef
    })) : null;
    const needsHeader = isSelectable || sortOptions && sortOptions.length > 0 || alternateTool;
    const headerWrapperOverlay = loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default)["HeaderWrapper-overlay"]
    }) : null;
    const showEmptyState = emptyState && !itemsExist && !loading;
    const showEmptySearchState = !showEmptyState && filterControl && !itemsExist && !loading;
    const headerMarkup = !showEmptyState && showHeader !== false && !showEmptySearchState && (showHeader || needsHeader) && listRef.current && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).HeaderOuterWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stickyJs.Sticky), {
        boundingElement: listRef.current
    }, (isSticky)=>{
        const headerClassName = (0, _cssJs.classNames)((0, _resourceListScssJsDefault.default).HeaderWrapper, sortOptions && sortOptions.length > 0 && !alternateTool && (0, _resourceListScssJsDefault.default)["HeaderWrapper-hasSort"], alternateTool && (0, _resourceListScssJsDefault.default)["HeaderWrapper-hasAlternateTool"], isSelectable && (0, _resourceListScssJsDefault.default)["HeaderWrapper-hasSelect"], loading && (0, _resourceListScssJsDefault.default)["HeaderWrapper-disabled"], isSelectable && selectMode && (0, _resourceListScssJsDefault.default)["HeaderWrapper-inSelectMode"], isSticky && (0, _resourceListScssJsDefault.default)["HeaderWrapper-isSticky"]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: headerClassName
        }, headerWrapperOverlay, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _resourceListScssJsDefault.default).HeaderContentWrapper
        }, headerTitleMarkup, checkableButtonMarkup, alternateToolMarkup, sortingSelectMarkup, selectButtonMarkup), selectAllActionsMarkup);
    }), bulkActionsMarkup);
    const emptySearchStateMarkup = showEmptySearchState ? emptySearchState || /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _resourceListScssJsDefault.default).EmptySearchResultWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _emptySearchResultJs.EmptySearchResult), Object.assign({}, emptySearchResultText, {
        withIllustration: true
    }))) : null;
    const emptyStateMarkup = showEmptyState ? emptyState : null;
    const defaultTopPadding = 8;
    const topPadding = loadingPosition > 0 ? loadingPosition : defaultTopPadding;
    const spinnerStyle = {
        paddingTop: `${topPadding}px`
    };
    const spinnerSize = items.length < 2 ? "small" : "large";
    const loadingOverlay = loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: (0, _resourceListScssJsDefault.default).SpinnerContainer,
        style: spinnerStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _spinnerJs.Spinner), {
        size: spinnerSize,
        accessibilityLabel: "Items are loading"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
        className: (0, _resourceListScssJsDefault.default).LoadingOverlay
    })) : null;
    const className = (0, _cssJs.classNames)((0, _resourceListScssJsDefault.default).ItemWrapper, loading && (0, _resourceListScssJsDefault.default)["ItemWrapper-isLoading"]);
    const loadingWithoutItemsMarkup = loading && !itemsExist ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        tabIndex: -1
    }, loadingOverlay) : null;
    const resourceListClassName = (0, _cssJs.classNames)((0, _resourceListScssJsDefault.default).ResourceList, loading && (0, _resourceListScssJsDefault.default).disabledPointerEvents, selectMode && (0, _resourceListScssJsDefault.default).disableTextSelection);
    const listMarkup = itemsExist ? /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
        className: resourceListClassName,
        ref: listRef,
        "aria-live": "polite",
        "aria-busy": loading
    }, loadingOverlay, (0, _react.Children).toArray(items.map(renderItemWithId))) : null; // This is probably a legit error but I don't have the time to refactor this
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const context = {
        selectable: isSelectable,
        selectedItems,
        selectMode,
        hasBulkActions: Boolean(bulkActions),
        resourceName,
        loading,
        onSelectionChange: handleSelectionChange
    };
    const resourceListWrapperClasses = (0, _cssJs.classNames)((0, _resourceListScssJsDefault.default).ResourceListWrapper, Boolean(bulkActionsMarkup) && selectMode && bulkActions && (0, _resourceListScssJsDefault.default).ResourceListWrapperWithBulkActions);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextJs.ResourceListContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _eventListenerJs.EventListener), {
        event: "resize",
        handler: handleResize
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: resourceListWrapperClasses,
        ref: tableMeasurerRef
    }, filterControlMarkup, headerMarkup, listMarkup, emptySearchStateMarkup, emptyStateMarkup, loadingWithoutItemsMarkup), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: bulkActionsIntersectionRef
    }));
}
ResourceList.Item = (0, _resourceItemJs.ResourceItem);

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","@shopify/polaris-tokens":"5ENVX","../../utilities/debounce.js":"bvJet","../../utilities/css.js":"lGt6N","../../utilities/components.js":"6Xyqa","../../utilities/use-lazy-ref.js":"brnXH","./ResourceList.scss.js":"1FLys","../Select/Select.js":"hd4LW","../ResourceItem/ResourceItem.js":"1PRfM","../../utilities/resource-list/types.js":"9wLsf","../../utilities/i18n/hooks.js":"hhMhA","../BulkActions/hooks/use-is-bulk-actions-sticky.js":"jZAOX","../SelectAllActions/SelectAllActions.js":"aDqPE","../Button/Button.js":"6Szv4","../CheckableButton/CheckableButton.js":"84lvb","../Sticky/Sticky.js":"4ehrN","../EmptySearchResult/EmptySearchResult.js":"5KiAk","../Spinner/Spinner.js":"43SMY","../../utilities/resource-list/context.js":"jzPOe","../EventListener/EventListener.js":"jV8kW","../BulkActions/BulkActions.js":"hluSh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1FLys":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "FiltersWrapper": "Polaris-ResourceList__FiltersWrapper",
    "ResourceList": "Polaris-ResourceList",
    "HeaderOuterWrapper": "Polaris-ResourceList__HeaderOuterWrapper",
    "HeaderWrapper-disabled": "Polaris-ResourceList__HeaderWrapper--disabled",
    "HeaderWrapper-overlay": "Polaris-ResourceList__HeaderWrapper--overlay",
    "HeaderWrapper": "Polaris-ResourceList__HeaderWrapper",
    "HeaderWrapper-isSticky": "Polaris-ResourceList__HeaderWrapper--isSticky",
    "HeaderContentWrapper": "Polaris-ResourceList__HeaderContentWrapper",
    "HeaderWrapper-inSelectMode": "Polaris-ResourceList__HeaderWrapper--inSelectMode",
    "SortWrapper": "Polaris-ResourceList__SortWrapper",
    "AlternateToolWrapper": "Polaris-ResourceList__AlternateToolWrapper",
    "HeaderWrapper-hasSelect": "Polaris-ResourceList__HeaderWrapper--hasSelect",
    "HeaderWrapper-hasAlternateTool": "Polaris-ResourceList__HeaderWrapper--hasAlternateTool",
    "HeaderWrapper-hasSort": "Polaris-ResourceList__HeaderWrapper--hasSort",
    "HeaderTitleWrapper": "Polaris-ResourceList__HeaderTitleWrapper",
    "BulkActionsWrapper": "Polaris-ResourceList__BulkActionsWrapper",
    "BulkActionsWrapperSticky": "Polaris-ResourceList__BulkActionsWrapperSticky",
    "SelectAllActionsWrapper": "Polaris-ResourceList__SelectAllActionsWrapper",
    "CheckableButtonWrapper": "Polaris-ResourceList__CheckableButtonWrapper",
    "SelectButtonWrapper": "Polaris-ResourceList__SelectButtonWrapper",
    "EmptySearchResultWrapper": "Polaris-ResourceList__EmptySearchResultWrapper",
    "ResourceListWrapper": "Polaris-ResourceList__ResourceListWrapper",
    "ResourceListWrapperWithBulkActions": "Polaris-ResourceList__ResourceListWrapperWithBulkActions",
    "ItemWrapper": "Polaris-ResourceList__ItemWrapper",
    "ItemWrapper-isLoading": "Polaris-ResourceList__ItemWrapper--isLoading",
    "SpinnerContainer": "Polaris-ResourceList__SpinnerContainer",
    "LoadingOverlay": "Polaris-ResourceList__LoadingOverlay",
    "DisabledPointerEvents": "Polaris-ResourceList__DisabledPointerEvents",
    "disableTextSelection": "Polaris-ResourceList--disableTextSelection"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hd4LW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _selectScssJs = require("./Select.scss.js");
var _selectScssJsDefault = parcelHelpers.interopDefault(_selectScssJs);
var _hooksJs = require("../../utilities/unique-id/hooks.js");
var _iconJs = require("../Icon/Icon.js");
var _labelledJs = require("../Labelled/Labelled.js");
var _boxJs = require("../Box/Box.js");
var _textJs = require("../Text/Text.js");
const PLACEHOLDER_VALUE = "";
function Select({ options: optionsProp, label, labelAction, labelHidden: labelHiddenProp, labelInline, disabled, helpText, placeholder, id: idProp, name, value = PLACEHOLDER_VALUE, error, onChange, onFocus, onBlur, requiredIndicator }) {
    const id = (0, _hooksJs.useUniqueId)("Select", idProp);
    const labelHidden = labelInline ? true : labelHiddenProp;
    const className = (0, _cssJs.classNames)((0, _selectScssJsDefault.default).Select, error && (0, _selectScssJsDefault.default).error, disabled && (0, _selectScssJsDefault.default).disabled);
    const handleChange = onChange ? (event)=>onChange(event.currentTarget.value, id) : undefined;
    const describedBy = [];
    if (helpText) describedBy.push((0, _labelledJs.helpTextID)(id));
    if (error) describedBy.push(`${id}Error`);
    const options = optionsProp || [];
    let normalizedOptions = options.map(normalizeOption);
    if (placeholder) normalizedOptions = [
        {
            label: placeholder,
            value: PLACEHOLDER_VALUE,
            disabled: true
        },
        ...normalizedOptions
    ];
    const inlineLabelMarkup = labelInline && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingInlineEnd: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        color: "subdued",
        truncate: true
    }, label));
    const selectedOption = getSelectedOption(normalizedOptions, value);
    const prefixMarkup = selectedOption.prefix && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _selectScssJsDefault.default).Prefix
    }, selectedOption.prefix);
    const contentMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _selectScssJsDefault.default).Content,
        "aria-hidden": true,
        "aria-disabled": disabled
    }, inlineLabelMarkup, prefixMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _selectScssJsDefault.default).SelectedOption
    }, selectedOption.label), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _selectScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.SelectMinor)
    })));
    const optionsMarkup = normalizedOptions.map(renderOption);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _labelledJs.Labelled), {
        id: id,
        label: label,
        error: error,
        action: labelAction,
        labelHidden: labelHidden,
        helpText: helpText,
        requiredIndicator: requiredIndicator
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("select", {
        id: id,
        name: name,
        value: value,
        className: (0, _selectScssJsDefault.default).Input,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: handleChange,
        "aria-invalid": Boolean(error),
        "aria-describedby": describedBy.length ? describedBy.join(" ") : undefined,
        "aria-required": requiredIndicator
    }, optionsMarkup), contentMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _selectScssJsDefault.default).Backdrop
    })));
}
function isString(option) {
    return typeof option === "string";
}
function isGroup(option) {
    return typeof option === "object" && "options" in option && option.options != null;
}
function normalizeStringOption(option) {
    return {
        label: option,
        value: option
    };
}
/**
 * Converts a string option (and each string option in a Group) into
 * an Option object.
 */ function normalizeOption(option) {
    if (isString(option)) return normalizeStringOption(option);
    else if (isGroup(option)) {
        const { title, options } = option;
        return {
            title,
            options: options.map((option)=>{
                return isString(option) ? normalizeStringOption(option) : option;
            })
        };
    }
    return option;
}
/**
 * Gets the text to display in the UI, for the currently selected option
 */ function getSelectedOption(options, value) {
    const flatOptions = flattenOptions(options);
    let selectedOption = flatOptions.find((option)=>value === option.value);
    if (selectedOption === undefined) // Get the first visible option (not the hidden placeholder)
    selectedOption = flatOptions.find((option)=>!option.hidden);
    return selectedOption || {
        value: "",
        label: ""
    };
}
/**
 * Ungroups an options array
 */ function flattenOptions(options) {
    let flatOptions = [];
    options.forEach((optionOrGroup)=>{
        if (isGroup(optionOrGroup)) flatOptions = flatOptions.concat(optionOrGroup.options);
        else flatOptions.push(optionOrGroup);
    });
    return flatOptions;
}
function renderSingleOption(option) {
    const { value, label, prefix: _prefix, ...rest } = option;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("option", Object.assign({
        key: value,
        value: value
    }, rest), label);
}
function renderOption(optionOrGroup) {
    if (isGroup(optionOrGroup)) {
        const { title, options } = optionOrGroup;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("optgroup", {
            label: title,
            key: title
        }, options.map(renderSingleOption));
    }
    return renderSingleOption(optionOrGroup);
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","./Select.scss.js":"6SxDe","../../utilities/unique-id/hooks.js":"2JfcO","../Icon/Icon.js":"6HPny","../Labelled/Labelled.js":"bvXVq","../Box/Box.js":"lbjkG","../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6SxDe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Select": "Polaris-Select",
    "disabled": "Polaris-Select--disabled",
    "Content": "Polaris-Select__Content",
    "InlineLabel": "Polaris-Select__InlineLabel",
    "Icon": "Polaris-Select__Icon",
    "Backdrop": "Polaris-Select__Backdrop",
    "SelectedOption": "Polaris-Select__SelectedOption",
    "Prefix": "Polaris-Select__Prefix",
    "Input": "Polaris-Select__Input",
    "error": "Polaris-Select--error",
    "hover": "Polaris-Select--hover"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jZAOX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsBulkActionsSticky", ()=>useIsBulkActionsSticky);
var _react = require("react");
var _debounceJs = require("../../../utilities/debounce.js");
const DEBOUNCE_PERIOD = 250;
const PADDING_IN_SELECT_MODE = 92;
function useIsBulkActionsSticky(selectMode) {
    const hasIOSupport = typeof window !== "undefined" && Boolean(window.IntersectionObserver);
    const [isBulkActionsSticky, setIsSticky] = (0, _react.useState)(false);
    const [bulkActionsAbsoluteOffset, setBulkActionsAbsoluteOffset] = (0, _react.useState)(0);
    const [bulkActionsMaxWidth, setBulkActionsMaxWidth] = (0, _react.useState)(0);
    const [bulkActionsOffsetLeft, setBulkActionsOffsetLeft] = (0, _react.useState)(0);
    const bulkActionsIntersectionRef = (0, _react.useRef)(null);
    const tableMeasurerRef = (0, _react.useRef)(null);
    const handleIntersect = (entries)=>{
        entries.forEach((entry)=>{
            setIsSticky(!entry.isIntersecting);
        });
    };
    const options = {
        root: null,
        rootMargin: "-12px",
        threshold: 0
    };
    const observerRef = (0, _react.useRef)(hasIOSupport ? new IntersectionObserver(handleIntersect, options) : null);
    const computeTableDimensions = (0, _react.useCallback)(()=>{
        const node = tableMeasurerRef.current;
        if (!node) return {
            maxWidth: 0,
            offsetHeight: 0,
            offsetLeft: 0
        };
        const box = node.getBoundingClientRect();
        const paddingHeight = selectMode ? PADDING_IN_SELECT_MODE : 0;
        const offsetHeight = box.height - paddingHeight;
        const maxWidth = box.width;
        const offsetLeft = box.left;
        setBulkActionsAbsoluteOffset(offsetHeight);
        setBulkActionsMaxWidth(maxWidth);
        setBulkActionsOffsetLeft(offsetLeft);
    }, [
        selectMode
    ]);
    (0, _react.useEffect)(()=>{
        computeTableDimensions();
        const debouncedComputeTableHeight = (0, _debounceJs.debounce)(computeTableDimensions, DEBOUNCE_PERIOD, {
            trailing: true
        });
        window.addEventListener("resize", debouncedComputeTableHeight);
        return ()=>window.removeEventListener("resize", debouncedComputeTableHeight);
    }, [
        computeTableDimensions
    ]);
    (0, _react.useEffect)(()=>{
        const observer = observerRef.current;
        if (!observer) return;
        const node = bulkActionsIntersectionRef.current;
        if (node) observer.observe(node);
        return ()=>{
            observer === null || observer === void 0 || observer.disconnect();
        };
    }, [
        bulkActionsIntersectionRef
    ]);
    return {
        bulkActionsIntersectionRef,
        tableMeasurerRef,
        isBulkActionsSticky,
        bulkActionsAbsoluteOffset,
        bulkActionsMaxWidth,
        bulkActionsOffsetLeft,
        computeTableDimensions
    };
}

},{"react":"cOWTg","../../../utilities/debounce.js":"bvJet","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aDqPE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectAllActions", ()=>SelectAllActions);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _cssJs = require("../../utilities/css.js");
var _selectAllActionsScssJs = require("./SelectAllActions.scss.js");
var _selectAllActionsScssJsDefault = parcelHelpers.interopDefault(_selectAllActionsScssJs);
var _checkableButtonJs = require("../CheckableButton/CheckableButton.js");
var _unstyledButtonJs = require("../UnstyledButton/UnstyledButton.js");
const SelectAllActions = /*#__PURE__*/ (0, _react.forwardRef)(function SelectAllActions({ accessibilityLabel, label, selected, selectMode, paginatedSelectAllText, paginatedSelectAllAction, disabled, onToggleAll }, ref) {
    const paginatedSelectAllActionMarkup = paginatedSelectAllAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledButtonJs.UnstyledButton), {
        className: (0, _selectAllActionsScssJsDefault.default).AllAction,
        onClick: paginatedSelectAllAction.onAction,
        size: "slim",
        disabled: disabled
    }, paginatedSelectAllAction.content) : null;
    const hasTextAndAction = paginatedSelectAllText && paginatedSelectAllAction;
    const paginatedSelectAllMarkup = paginatedSelectAllActionMarkup ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _selectAllActionsScssJsDefault.default).PaginatedSelectAll
    }, paginatedSelectAllActionMarkup) : null;
    const ariaLive = hasTextAndAction ? "polite" : undefined;
    const checkableButtonProps = {
        accessibilityLabel,
        label: hasTextAndAction ? paginatedSelectAllText : label,
        selected,
        onToggleAll,
        disabled,
        ariaLive,
        ref
    };
    const markup = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), {
        timeout: 0,
        in: selectMode,
        key: "markup"
    }, (status)=>{
        const wrapperClasses = (0, _cssJs.classNames)((0, _selectAllActionsScssJsDefault.default).SelectAllActions, (0, _selectAllActionsScssJsDefault.default)[`SelectAllActions-${status}`]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: wrapperClasses
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkableButtonJs.CheckableButton), checkableButtonProps), paginatedSelectAllMarkup);
    });
    return markup;
});

},{"react":"cOWTg","react-transition-group":"1qdFK","../../utilities/css.js":"lGt6N","./SelectAllActions.scss.js":"a0z0d","../CheckableButton/CheckableButton.js":"84lvb","../UnstyledButton/UnstyledButton.js":"5Z7tL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a0z0d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "SelectAllActions": "Polaris-SelectAllActions",
    "SelectAllActions-entering": "Polaris-SelectAllActions__SelectAllActions--entering",
    "SelectAllActions-exiting": "Polaris-SelectAllActions__SelectAllActions--exiting",
    "SelectAllActions-entered": "Polaris-SelectAllActions__SelectAllActions--entered",
    "SelectAllActions-exited": "Polaris-SelectAllActions__SelectAllActions--exited",
    "PaginatedSelectAll": "Polaris-SelectAllActions__PaginatedSelectAll",
    "AllAction": "Polaris-SelectAllActions__AllAction"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"84lvb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckableButton", ()=>CheckableButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _checkableButtonScssJs = require("./CheckableButton.scss.js");
var _checkableButtonScssJsDefault = parcelHelpers.interopDefault(_checkableButtonScssJs);
var _checkboxJs = require("../Checkbox/Checkbox.js");
const CheckableButton = /*#__PURE__*/ (0, _react.forwardRef)(function CheckableButton({ accessibilityLabel, label = "", onToggleAll, selected, disabled, ariaLive }, ref) {
    const checkBoxRef = (0, _react.useRef)(null);
    function focus() {
        var _checkBoxRef$current;
        checkBoxRef === null || checkBoxRef === void 0 || (_checkBoxRef$current = checkBoxRef.current) === null || _checkBoxRef$current === void 0 || _checkBoxRef$current.focus();
    }
    (0, _react.useImperativeHandle)(ref, ()=>{
        return {
            focus
        };
    });
    const className = (0, _cssJs.classNames)((0, _checkableButtonScssJsDefault.default).CheckableButton);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        onClick: onToggleAll
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _checkableButtonScssJsDefault.default).Checkbox
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkboxJs.Checkbox), {
        label: accessibilityLabel,
        labelHidden: true,
        checked: selected,
        disabled: disabled,
        onChange: onToggleAll,
        ref: checkBoxRef
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _checkableButtonScssJsDefault.default).Label,
        "aria-live": ariaLive
    }, label));
});

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./CheckableButton.scss.js":"cejAf","../Checkbox/Checkbox.js":"1FKW4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cejAf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "CheckableButton": "Polaris-CheckableButton",
    "Checkbox": "Polaris-CheckableButton__Checkbox",
    "Label": "Polaris-CheckableButton__Label"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gk4cr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonBodyText", ()=>SkeletonBodyText);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeletonBodyTextScssJs = require("./SkeletonBodyText.scss.js");
var _skeletonBodyTextScssJsDefault = parcelHelpers.interopDefault(_skeletonBodyTextScssJs);
function SkeletonBodyText({ lines = 3 }) {
    const bodyTextLines = [];
    for(let i = 0; i < lines; i++)bodyTextLines.push(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _skeletonBodyTextScssJsDefault.default).SkeletonBodyText,
        key: i
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, bodyTextLines);
}

},{"react":"cOWTg","./SkeletonBodyText.scss.js":"64YMc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"64YMc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "SkeletonBodyText": "Polaris-SkeletonBodyText"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2tci5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonDisplayText", ()=>SkeletonDisplayText);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _skeletonDisplayTextScssJs = require("./SkeletonDisplayText.scss.js");
var _skeletonDisplayTextScssJsDefault = parcelHelpers.interopDefault(_skeletonDisplayTextScssJs);
function SkeletonDisplayText({ size = "medium" }) {
    const className = (0, _cssJs.classNames)((0, _skeletonDisplayTextScssJsDefault.default).DisplayText, size && (0, _skeletonDisplayTextScssJsDefault.default)[(0, _cssJs.variationName)("size", size)]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    });
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./SkeletonDisplayText.scss.js":"jYEJg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jYEJg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "DisplayText": "Polaris-SkeletonDisplayText__DisplayText",
    "sizeSmall": "Polaris-SkeletonDisplayText--sizeSmall",
    "sizeMedium": "Polaris-SkeletonDisplayText--sizeMedium",
    "sizeLarge": "Polaris-SkeletonDisplayText--sizeLarge",
    "sizeExtraLarge": "Polaris-SkeletonDisplayText--sizeExtraLarge"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lJoR3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonPage", ()=>SkeletonPage);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeletonPageScssJs = require("./SkeletonPage.scss.js");
var _skeletonPageScssJsDefault = parcelHelpers.interopDefault(_skeletonPageScssJs);
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _boxJs = require("../Box/Box.js");
var _verticalStackJs = require("../VerticalStack/VerticalStack.js");
var _horizontalStackJs = require("../HorizontalStack/HorizontalStack.js");
function SkeletonPage({ children, fullWidth, narrowWidth, primaryAction, title = "", backAction, breadcrumbs }) {
    const i18n = (0, _hooksJs.useI18n)();
    const titleContent = title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", {
        className: (0, _skeletonPageScssJsDefault.default).Title
    }, title) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _skeletonPageScssJsDefault.default).SkeletonTitle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        background: "bg-strong",
        minWidth: "120px",
        minHeight: "28px",
        borderRadius: "1"
    }));
    const primaryActionMarkup = primaryAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        id: "SkeletonPage-PrimaryAction",
        borderRadius: "1",
        background: "bg-strong",
        minHeight: "2.25rem",
        minWidth: "6.25rem"
    }) : null;
    const breadcrumbMarkup = breadcrumbs || backAction ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        borderRadius: "1",
        background: "bg-strong",
        minHeight: "2.25rem",
        minWidth: "2.25rem",
        maxWidth: "2.25rem"
    }) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), {
        gap: "4",
        inlineAlign: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), Object.assign({
        width: "100%",
        padding: "0",
        paddingInlineStart: {
            sm: "6"
        },
        paddingInlineEnd: {
            sm: "6"
        },
        maxWidth: "var(--pc-skeleton-page-max-width)",
        "aria-label": i18n.translate("Polaris.SkeletonPage.loadingLabel"),
        role: "status"
    }, narrowWidth && {
        maxWidth: "var(--pc-skeleton-page-max-width-narrow)"
    }, fullWidth && {
        maxWidth: "none"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _verticalStackJs.VerticalStack), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: {
            xs: "4",
            md: "5"
        },
        paddingBlockEnd: {
            xs: "4",
            md: "5"
        },
        paddingInlineStart: {
            xs: "4",
            sm: "0"
        },
        paddingInlineEnd: {
            xs: "4",
            sm: "0"
        },
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4",
        align: "space-between",
        blockAlign: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalStackJs.HorizontalStack), {
        gap: "4"
    }, breadcrumbMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockStart: "1",
        paddingBlockEnd: "1"
    }, titleContent)), primaryActionMarkup)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        paddingBlockEnd: "2",
        width: "100%"
    }, children))));
}

},{"react":"cOWTg","./SkeletonPage.scss.js":"3Rqrh","../../utilities/i18n/hooks.js":"hhMhA","../Box/Box.js":"lbjkG","../VerticalStack/VerticalStack.js":"5lUFs","../HorizontalStack/HorizontalStack.js":"fotqA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3Rqrh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Title": "Polaris-SkeletonPage__Title",
    "SkeletonTitle": "Polaris-SkeletonPage__SkeletonTitle"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jShHf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Stack", ()=>Stack);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _componentsJs = require("../../utilities/components.js");
var _stackScssJs = require("./Stack.scss.js");
var _stackScssJsDefault = parcelHelpers.interopDefault(_stackScssJs);
var _itemJs = require("./components/Item/Item.js");
/** @deprecated Use LegacyStack or VerticalStack instead. */ const Stack = /*#__PURE__*/ (0, _react.memo)(function Stack({ children, vertical, spacing, distribution, alignment, wrap }) {
    const className = (0, _cssJs.classNames)((0, _stackScssJsDefault.default).Stack, vertical && (0, _stackScssJsDefault.default).vertical, spacing && (0, _stackScssJsDefault.default)[(0, _cssJs.variationName)("spacing", spacing)], distribution && (0, _stackScssJsDefault.default)[(0, _cssJs.variationName)("distribution", distribution)], alignment && (0, _stackScssJsDefault.default)[(0, _cssJs.variationName)("alignment", alignment)], wrap === false && (0, _stackScssJsDefault.default).noWrap);
    const itemMarkup = (0, _componentsJs.elementChildren)(children).map((child, index)=>{
        const props = {
            key: index
        }; // eslint-disable-next-line import/no-deprecated
        return (0, _componentsJs.wrapWithComponent)(child, (0, _itemJs.Item), props);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, itemMarkup);
}); // eslint-disable-next-line import/no-deprecated
Stack.Item = (0, _itemJs.Item);

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","../../utilities/components.js":"6Xyqa","./Stack.scss.js":"dKj9a","./components/Item/Item.js":"942sn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dKj9a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Stack": "Polaris-Stack",
    "Item": "Polaris-Stack__Item",
    "noWrap": "Polaris-Stack--noWrap",
    "spacingNone": "Polaris-Stack--spacingNone",
    "spacingExtraTight": "Polaris-Stack--spacingExtraTight",
    "spacingTight": "Polaris-Stack--spacingTight",
    "spacingBaseTight": "Polaris-Stack--spacingBaseTight",
    "spacingLoose": "Polaris-Stack--spacingLoose",
    "spacingExtraLoose": "Polaris-Stack--spacingExtraLoose",
    "distributionLeading": "Polaris-Stack--distributionLeading",
    "distributionTrailing": "Polaris-Stack--distributionTrailing",
    "distributionCenter": "Polaris-Stack--distributionCenter",
    "distributionEqualSpacing": "Polaris-Stack--distributionEqualSpacing",
    "distributionFill": "Polaris-Stack--distributionFill",
    "distributionFillEvenly": "Polaris-Stack--distributionFillEvenly",
    "alignmentLeading": "Polaris-Stack--alignmentLeading",
    "alignmentTrailing": "Polaris-Stack--alignmentTrailing",
    "alignmentCenter": "Polaris-Stack--alignmentCenter",
    "alignmentFill": "Polaris-Stack--alignmentFill",
    "alignmentBaseline": "Polaris-Stack--alignmentBaseline",
    "vertical": "Polaris-Stack--vertical",
    "Item-fill": "Polaris-Stack__Item--fill"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"942sn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _stackScssJs = require("../../Stack.scss.js");
var _stackScssJsDefault = parcelHelpers.interopDefault(_stackScssJs);
/** @deprecated Use LegacyStack or VerticalStack instead. */ function Item({ children, fill }) {
    const className = (0, _cssJs.classNames)((0, _stackScssJsDefault.default).Item, fill && (0, _stackScssJsDefault.default)["Item-fill"]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className
    }, children);
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","../../Stack.scss.js":"dKj9a","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7733U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Thumbnail", ()=>Thumbnail);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../utilities/css.js");
var _thumbnailScssJs = require("./Thumbnail.scss.js");
var _thumbnailScssJsDefault = parcelHelpers.interopDefault(_thumbnailScssJs);
var _imageJs = require("../Image/Image.js");
var _iconJs = require("../Icon/Icon.js");
function Thumbnail({ source, alt, size = "medium", transparent }) {
    const className = (0, _cssJs.classNames)((0, _thumbnailScssJsDefault.default).Thumbnail, size && (0, _thumbnailScssJsDefault.default)[(0, _cssJs.variationName)("size", size)], transparent && (0, _thumbnailScssJsDefault.default).transparent);
    const content = typeof source === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
        alt: alt,
        source: source
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        accessibilityLabel: alt,
        source: source
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className
    }, content);
}

},{"react":"cOWTg","../../utilities/css.js":"lGt6N","./Thumbnail.scss.js":"5I2qC","../Image/Image.js":"5iL1c","../Icon/Icon.js":"6HPny","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5I2qC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Thumbnail": "Polaris-Thumbnail",
    "sizeExtraSmall": "Polaris-Thumbnail--sizeExtraSmall",
    "sizeSmall": "Polaris-Thumbnail--sizeSmall",
    "sizeMedium": "Polaris-Thumbnail--sizeMedium",
    "sizeLarge": "Polaris-Thumbnail--sizeLarge",
    "transparent": "Polaris-Thumbnail--transparent"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dMuTw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toast", ()=>Toast);
var _react = require("react");
var _useDeepEffectJs = require("../../utilities/use-deep-effect.js");
var _hooksJs = require("../../utilities/unique-id/hooks.js");
var _hooksJs1 = require("../../utilities/frame/hooks.js");
// that the interface defining the props is defined in this file, not imported
// from elsewhere. This silly workaround ensures that the Props Explorer table
// is generated correctly.
const Toast = /*#__PURE__*/ (0, _react.memo)(function Toast(props) {
    const id = (0, _hooksJs.useUniqueId)("Toast");
    const { showToast, hideToast } = (0, _hooksJs1.useFrame)();
    (0, _useDeepEffectJs.useDeepEffect)(()=>{
        showToast({
            id,
            ...props
        });
        return ()=>{
            hideToast({
                id
            });
        };
    }, [
        props
    ]);
    return null;
});

},{"react":"cOWTg","../../utilities/use-deep-effect.js":"4eElT","../../utilities/unique-id/hooks.js":"2JfcO","../../utilities/frame/hooks.js":"3aY41","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iNaTF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopBar", ()=>TopBar);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../utilities/css.js");
var _getWidthJs = require("../../utilities/get-width.js");
var _useToggleJs = require("../../utilities/use-toggle.js");
var _topBarScssJs = require("./TopBar.scss.js");
var _topBarScssJsDefault = parcelHelpers.interopDefault(_topBarScssJs);
var _searchJs = require("./components/Search/Search.js");
var _searchFieldJs = require("./components/SearchField/SearchField.js");
var _userMenuJs = require("./components/UserMenu/UserMenu.js");
var _hooksJs = require("../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../utilities/frame/hooks.js");
var _iconJs = require("../Icon/Icon.js");
var _unstyledLinkJs = require("../UnstyledLink/UnstyledLink.js");
var _imageJs = require("../Image/Image.js");
var _menuJs = require("./components/Menu/Menu.js");
// TypeScript can't generate types that correctly infer the typing of
// subcomponents so explicitly state the subcomponents in the type definition.
// Letting this be implicit works in this project but fails in projects that use
// generated *.d.ts files.
const TopBar = function TopBar({ showNavigationToggle, userMenu, searchResults, searchField, secondaryMenu, searchResultsVisible, searchResultsOverlayVisible = false, onNavigationToggle, onSearchResultsDismiss, contextControl, logoSuffix }) {
    const i18n = (0, _hooksJs.useI18n)();
    const { logo } = (0, _hooksJs1.useFrame)();
    const { value: focused, setTrue: forceTrueFocused, setFalse: forceFalseFocused } = (0, _useToggleJs.useToggle)(false);
    const iconClassName = (0, _cssJs.classNames)((0, _topBarScssJsDefault.default).NavigationIcon, focused && (0, _topBarScssJsDefault.default).focused);
    const navigationButtonMarkup = showNavigationToggle ? /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        className: iconClassName,
        onClick: onNavigationToggle,
        onFocus: forceTrueFocused,
        onBlur: forceFalseFocused,
        "aria-label": i18n.translate("Polaris.TopBar.toggleMenuLabel")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _topBarScssJsDefault.default).IconWrapper
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.MobileHamburgerMajor)
    }))) : null;
    const width = (0, _getWidthJs.getWidth)(logo, 104);
    let contextMarkup;
    if (contextControl) contextMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _topBarScssJsDefault.default).ContextControl
    }, contextControl);
    else if (logo) {
        const className = (0, _cssJs.classNames)((0, _topBarScssJsDefault.default).LogoContainer, showNavigationToggle || searchField ? (0, _topBarScssJsDefault.default).LogoDisplayControl : (0, _topBarScssJsDefault.default).LogoDisplayContainer, logoSuffix && (0, _topBarScssJsDefault.default).hasLogoSuffix);
        contextMarkup = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _unstyledLinkJs.UnstyledLink), {
            url: logo.url || "",
            className: (0, _topBarScssJsDefault.default).LogoLink,
            style: {
                width
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _imageJs.Image), {
            source: logo.topBarSource || "",
            alt: logo.accessibilityLabel || "",
            className: (0, _topBarScssJsDefault.default).Logo,
            style: {
                width
            }
        })), logoSuffix);
    }
    const searchMarkup = searchField ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, searchField, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchJs.Search), {
        visible: searchResultsVisible,
        onDismiss: onSearchResultsDismiss,
        overlayVisible: searchResultsOverlayVisible
    }, searchResults)) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _topBarScssJsDefault.default).TopBar
    }, navigationButtonMarkup, contextMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _topBarScssJsDefault.default).Contents
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _topBarScssJsDefault.default).SearchField
    }, searchMarkup), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _topBarScssJsDefault.default).SecondaryMenu
    }, secondaryMenu), userMenu));
};
TopBar.Menu = (0, _menuJs.Menu);
TopBar.SearchField = (0, _searchFieldJs.SearchField);
TopBar.UserMenu = (0, _userMenuJs.UserMenu);

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../utilities/css.js":"lGt6N","../../utilities/get-width.js":"j1LQp","../../utilities/use-toggle.js":"2kpDL","./TopBar.scss.js":"bW9L4","./components/Search/Search.js":"b4K5Q","./components/SearchField/SearchField.js":"gUDV2","./components/UserMenu/UserMenu.js":"dK4t0","../../utilities/i18n/hooks.js":"hhMhA","../../utilities/frame/hooks.js":"3aY41","../Icon/Icon.js":"6HPny","../UnstyledLink/UnstyledLink.js":"4o3DP","../Image/Image.js":"5iL1c","./components/Menu/Menu.js":"ahk1i","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bW9L4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "TopBar": "Polaris-TopBar",
    "LogoDisplayControl": "Polaris-TopBar__LogoDisplayControl",
    "LogoDisplayContainer": "Polaris-TopBar__LogoDisplayContainer",
    "LogoContainer": "Polaris-TopBar__LogoContainer",
    "hasLogoSuffix": "Polaris-TopBar--hasLogoSuffix",
    "Logo": "Polaris-TopBar__Logo",
    "LogoLink": "Polaris-TopBar__LogoLink",
    "ContextControl": "Polaris-TopBar__ContextControl",
    "NavigationIcon": "Polaris-TopBar__NavigationIcon",
    "focused": "Polaris-TopBar--focused",
    "IconWrapper": "Polaris-TopBar__IconWrapper",
    "Contents": "Polaris-TopBar__Contents",
    "SearchField": "Polaris-TopBar__SearchField",
    "SecondaryMenu": "Polaris-TopBar__SecondaryMenu"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b4K5Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Search", ()=>Search);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _searchScssJs = require("./Search.scss.js");
var _searchScssJsDefault = parcelHelpers.interopDefault(_searchScssJs);
var _searchDismissOverlayJs = require("../SearchDismissOverlay/SearchDismissOverlay.js");
function Search({ visible, children, onDismiss, overlayVisible = false }) {
    if (children == null) return null;
    const overlayMarkup = visible ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchDismissOverlayJs.SearchDismissOverlay), {
        onDismiss: onDismiss,
        visible: overlayVisible
    }) : null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, overlayMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _searchScssJsDefault.default).Search, visible && (0, _searchScssJsDefault.default).visible)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _searchScssJsDefault.default).SearchContent
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _searchScssJsDefault.default).Results
    }, children))));
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./Search.scss.js":"duKnD","../SearchDismissOverlay/SearchDismissOverlay.js":"kdqBQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"duKnD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Search": "Polaris-TopBar-Search",
    "SearchContent": "Polaris-TopBar-Search__SearchContent",
    "visible": "Polaris-TopBar-Search--visible",
    "Results": "Polaris-TopBar-Search__Results"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kdqBQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchDismissOverlay", ()=>SearchDismissOverlay);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssJs = require("../../../../utilities/css.js");
var _searchDismissOverlayScssJs = require("./SearchDismissOverlay.scss.js");
var _searchDismissOverlayScssJsDefault = parcelHelpers.interopDefault(_searchDismissOverlayScssJs);
var _scrollLockJs = require("../../../ScrollLock/ScrollLock.js");
function SearchDismissOverlay({ onDismiss, visible }) {
    const node = (0, _react.useRef)(null);
    const handleDismiss = (0, _react.useCallback)(({ target })=>{
        if (target === node.current && onDismiss != null) onDismiss();
    }, [
        onDismiss
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, visible ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scrollLockJs.ScrollLock), null) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: node,
        className: (0, _cssJs.classNames)((0, _searchDismissOverlayScssJsDefault.default).SearchDismissOverlay, visible && (0, _searchDismissOverlayScssJsDefault.default).visible),
        onClick: handleDismiss
    }));
}

},{"react":"cOWTg","../../../../utilities/css.js":"lGt6N","./SearchDismissOverlay.scss.js":"9xVx9","../../../ScrollLock/ScrollLock.js":"92GHE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9xVx9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "SearchDismissOverlay": "Polaris-TopBar-SearchDismissOverlay",
    "visible": "Polaris-TopBar-SearchDismissOverlay--visible"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gUDV2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polarisIcons = require("@shopify/polaris-icons");
var _cssJs = require("../../../../utilities/css.js");
var _searchFieldScssJs = require("./SearchField.scss.js");
var _searchFieldScssJsDefault = parcelHelpers.interopDefault(_searchFieldScssJs);
var _hooksJs = require("../../../../utilities/i18n/hooks.js");
var _hooksJs1 = require("../../../../utilities/unique-id/hooks.js");
var _iconJs = require("../../../Icon/Icon.js");
var _textJs = require("../../../Text/Text.js");
function SearchField({ value, focused, active, placeholder, onChange, onFocus, onBlur, onCancel, showFocusBorder }) {
    const i18n = (0, _hooksJs.useI18n)();
    const [forceActive, setForceActive] = (0, _react.useState)(false);
    const input = (0, _react.useRef)(null);
    const searchId = (0, _hooksJs1.useUniqueId)("SearchField");
    const handleChange = (0, _react.useCallback)(({ currentTarget })=>{
        onChange(currentTarget.value);
    }, [
        onChange
    ]);
    const handleFocus = (0, _react.useCallback)(()=>onFocus && onFocus(), [
        onFocus
    ]);
    const handleBlur = (0, _react.useCallback)(()=>onBlur && onBlur(), [
        onBlur
    ]);
    const handleClear = (0, _react.useCallback)(()=>{
        onCancel && onCancel();
        if (!input.current) return;
        input.current.value = "";
        onChange("");
        input.current.focus();
    }, [
        onCancel,
        onChange
    ]);
    (0, _react.useEffect)(()=>{
        if (!input.current) return;
        if (focused) input.current.focus();
        else input.current.blur();
    }, [
        focused
    ]);
    const clearMarkup = value !== "" && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        "aria-label": i18n.translate("Polaris.TopBar.SearchField.clearButtonLabel"),
        className: (0, _searchFieldScssJsDefault.default).Clear,
        onClick: handleClear,
        onBlur: ()=>{
            setForceActive(false);
            handleClear();
        },
        onFocus: ()=>{
            handleFocus();
            setForceActive(true);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.CircleCancelMinor)
    }));
    const className = (0, _cssJs.classNames)((0, _searchFieldScssJsDefault.default).SearchField, (focused || active || forceActive) && (0, _searchFieldScssJsDefault.default).focused);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "span",
        visuallyHidden: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: searchId
    }, i18n.translate("Polaris.TopBar.SearchField.search"))), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: searchId,
        className: (0, _searchFieldScssJsDefault.default).Input,
        placeholder: placeholder,
        type: "search",
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        ref: input,
        value: value,
        onChange: handleChange,
        onKeyDown: preventDefault
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _searchFieldScssJsDefault.default).Icon
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconJs.Icon), {
        source: (0, _polarisIcons.SearchMinor)
    })), clearMarkup, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _cssJs.classNames)((0, _searchFieldScssJsDefault.default).Backdrop, showFocusBorder && (0, _searchFieldScssJsDefault.default).BackdropShowFocusBorder)
    }));
}
function preventDefault(event) {
    if (event.key === "Enter") event.preventDefault();
}

},{"react":"cOWTg","@shopify/polaris-icons":"zOlgc","../../../../utilities/css.js":"lGt6N","./SearchField.scss.js":"khsV0","../../../../utilities/i18n/hooks.js":"hhMhA","../../../../utilities/unique-id/hooks.js":"2JfcO","../../../Icon/Icon.js":"6HPny","../../../Text/Text.js":"l8Av9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"khsV0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "SearchField": "Polaris-TopBar-SearchField",
    "focused": "Polaris-TopBar-SearchField--focused",
    "Input": "Polaris-TopBar-SearchField__Input",
    "Backdrop": "Polaris-TopBar-SearchField__Backdrop",
    "BackdropShowFocusBorder": "Polaris-TopBar-SearchField__BackdropShowFocusBorder",
    "Icon": "Polaris-TopBar-SearchField__Icon",
    "Clear": "Polaris-TopBar-SearchField__Clear"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dK4t0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserMenu", ()=>UserMenu);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _userMenuScssJs = require("./UserMenu.scss.js");
var _userMenuScssJsDefault = parcelHelpers.interopDefault(_userMenuScssJs);
var _messageIndicatorJs = require("../../../MessageIndicator/MessageIndicator.js");
var _menuJs = require("../Menu/Menu.js");
var _textJs = require("../../../Text/Text.js");
var _avatarJs = require("../../../Avatar/Avatar.js");
function UserMenu({ name, detail, avatar, initials, actions, message, onToggle, open, accessibilityLabel, customActivator, customWidth }) {
    const showIndicator = Boolean(message);
    const activatorContentMarkup = customActivator ? customActivator : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _userMenuScssJsDefault.default).Details
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "p",
        alignment: "start",
        fontWeight: "medium",
        truncate: true
    }, name), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        as: "p",
        variant: "bodySm",
        alignment: "start",
        color: "subdued",
        truncate: true
    }, detail)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageIndicatorJs.MessageIndicator), {
        active: showIndicator
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _avatarJs.Avatar), {
        shape: "square",
        size: "small",
        initials: initials && initials.replace(" ", ""),
        source: avatar
    })));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuJs.Menu), {
        activatorContent: activatorContentMarkup,
        open: open,
        onOpen: onToggle,
        onClose: onToggle,
        actions: actions,
        message: message,
        accessibilityLabel: accessibilityLabel,
        customWidth: customWidth
    });
}

},{"react":"cOWTg","./UserMenu.scss.js":"97mq0","../../../MessageIndicator/MessageIndicator.js":"fBll6","../Menu/Menu.js":"ahk1i","../../../Text/Text.js":"l8Av9","../../../Avatar/Avatar.js":"foVF7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"97mq0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Details": "Polaris-TopBar-UserMenu__Details"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fBll6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessageIndicator", ()=>MessageIndicator);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _messageIndicatorScssJs = require("./MessageIndicator.scss.js");
var _messageIndicatorScssJsDefault = parcelHelpers.interopDefault(_messageIndicatorScssJs);
function MessageIndicator({ children, active }) {
    const indicatorMarkup = active && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _messageIndicatorScssJsDefault.default).MessageIndicator
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _messageIndicatorScssJsDefault.default).MessageIndicatorWrapper
    }, indicatorMarkup, children);
}

},{"react":"cOWTg","./MessageIndicator.scss.js":"9hOjI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9hOjI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "MessageIndicatorWrapper": "Polaris-MessageIndicator__MessageIndicatorWrapper",
    "MessageIndicator": "Polaris-MessageIndicator"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ahk1i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _menuScssJs = require("./Menu.scss.js");
var _menuScssJsDefault = parcelHelpers.interopDefault(_menuScssJs);
var _messageJs = require("./components/Message/Message.js");
var _popoverJs = require("../../../Popover/Popover.js");
var _boxJs = require("../../../Box/Box.js");
var _actionListJs = require("../../../ActionList/ActionList.js");
function Menu(props) {
    const { actions, onOpen, onClose, open, activatorContent, message, accessibilityLabel, customWidth } = props;
    const badgeProps = message && message.badge && {
        content: message.badge.content,
        status: message.badge.status
    };
    const messageMarkup = message && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageJs.Message), {
        title: message.title,
        description: message.description,
        action: {
            onClick: message.action.onClick,
            content: message.action.content
        },
        link: {
            to: message.link.to,
            content: message.link.content
        },
        badge: badgeProps
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover), {
        activator: /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _menuScssJsDefault.default).ActivatorWrapper
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            type: "button",
            className: (0, _menuScssJsDefault.default).Activator,
            onClick: onOpen,
            "aria-label": accessibilityLabel
        }, activatorContent)),
        active: open,
        onClose: onClose,
        fixed: true,
        fullHeight: true,
        preferredAlignment: "right"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _menuScssJsDefault.default).MenuItems
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _boxJs.Box), {
        width: customWidth
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionListJs.ActionList), {
        actionRole: "menuitem",
        onActionAnyItem: onClose,
        sections: actions
    }), messageMarkup)));
}

},{"react":"cOWTg","./Menu.scss.js":"l327K","./components/Message/Message.js":"fOqtk","../../../Popover/Popover.js":"cE1F7","../../../Box/Box.js":"lbjkG","../../../ActionList/ActionList.js":"kU0n2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l327K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "ActivatorWrapper": "Polaris-TopBar-Menu__ActivatorWrapper",
    "Activator": "Polaris-TopBar-Menu__Activator",
    "MenuItems": "Polaris-TopBar-Menu__MenuItems",
    "Section": "Polaris-TopBar-Menu__Section"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fOqtk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Message", ()=>Message);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _messageScssJs = require("./Message.scss.js");
var _messageScssJsDefault = parcelHelpers.interopDefault(_messageScssJs);
var _linkJs = require("../../../../../Link/Link.js");
var _badgeJs = require("../../../../../Badge/Badge.js");
var _popoverJs = require("../../../../../Popover/Popover.js");
var _legacyStackJs = require("../../../../../LegacyStack/LegacyStack.js");
var _textContainerJs = require("../../../../../TextContainer/TextContainer.js");
var _textJs = require("../../../../../Text/Text.js");
var _buttonJs = require("../../../../../Button/Button.js");
function Message({ title, description, action, link, badge }) {
    const badgeMarkup = badge && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badgeJs.Badge), {
        status: badge.status
    }, badge.content);
    const { to, content: linkContent } = link;
    const { onClick, content: actionContent } = action;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _messageScssJsDefault.default).Section
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _popoverJs.Popover).Section, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _legacyStackJs.LegacyStack), {
        vertical: true,
        spacing: "tight"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textContainerJs.TextContainer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textJs.Text), {
        variant: "headingMd",
        as: "h2"
    }, title, badgeMarkup), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, description)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _linkJs.Link), {
        url: to
    }, linkContent), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonJs.Button), {
        plain: true,
        onClick: onClick
    }, actionContent))));
}

},{"react":"cOWTg","./Message.scss.js":"8AgUI","../../../../../Link/Link.js":"1G7gV","../../../../../Badge/Badge.js":"8ckUl","../../../../../Popover/Popover.js":"cE1F7","../../../../../LegacyStack/LegacyStack.js":"5pyyM","../../../../../TextContainer/TextContainer.js":"kkkE5","../../../../../Text/Text.js":"l8Av9","../../../../../Button/Button.js":"6Szv4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8AgUI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Section": "Polaris-Menu-Message__Section"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2lEop":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Truncate", ()=>Truncate);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _truncateScssJs = require("./Truncate.scss.js");
var _truncateScssJsDefault = parcelHelpers.interopDefault(_truncateScssJs);
function Truncate({ children }) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: (0, _truncateScssJsDefault.default).Truncate
    }, children);
}

},{"react":"cOWTg","./Truncate.scss.js":"lu3fL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lu3fL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var styles = {
    "Truncate": "Polaris-Truncate"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aiBhP":[function(require,module,exports) {
module.exports = JSON.parse('{"Polaris":{"ActionMenu":{"Actions":{"moreActions":"More actions"},"RollupActions":{"rollupButton":"View actions"}},"Avatar":{"label":"Avatar","labelWithInitials":"Avatar with initials {initials}"},"Autocomplete":{"spinnerAccessibilityLabel":"Loading","ellipsis":"{content}\u2026"},"Badge":{"PROGRESS_LABELS":{"incomplete":"Incomplete","partiallyComplete":"Partially complete","complete":"Complete"},"STATUS_LABELS":{"info":"Info","success":"Success","warning":"Warning","critical":"Critical","attention":"Attention","new":"New"},"progressAndStatus":"{statusLabel} {progressLabel}"},"Button":{"spinnerAccessibilityLabel":"Loading","connectedDisclosureAccessibilityLabel":"Related actions"},"Common":{"checkbox":"checkbox","undo":"Undo","cancel":"Cancel","clear":"Clear","close":"Close","submit":"Submit","more":"More"},"ContextualSaveBar":{"save":"Save","discard":"Discard"},"DataTable":{"sortAccessibilityLabel":"sort {direction} by","navAccessibilityLabel":"Scroll table {direction} one column","totalsRowHeading":"Totals","totalRowHeading":"Total"},"DatePicker":{"previousMonth":"Show previous month, {previousMonthName} {showPreviousYear}","nextMonth":"Show next month, {nextMonth} {nextYear}","today":"Today ","start":"Start of range","end":"End of range","months":{"january":"January","february":"February","march":"March","april":"April","may":"May","june":"June","july":"July","august":"August","september":"September","october":"October","november":"November","december":"December"},"days":{"monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday","sunday":"Sunday"},"daysAbbreviated":{"monday":"Mo","tuesday":"Tu","wednesday":"We","thursday":"Th","friday":"Fr","saturday":"Sa","sunday":"Su"}},"DiscardConfirmationModal":{"title":"Discard all unsaved changes","message":"If you discard changes, you\u2019ll delete any edits you made since you last saved.","primaryAction":"Discard changes","secondaryAction":"Continue editing"},"DropZone":{"single":{"overlayTextFile":"Drop file to upload","overlayTextImage":"Drop image to upload","overlayTextVideo":"Drop video to upload","actionTitleFile":"Add file","actionTitleImage":"Add image","actionTitleVideo":"Add video","actionHintFile":"or drop file to upload","actionHintImage":"or drop image to upload","actionHintVideo":"or drop video to upload","labelFile":"Upload file","labelImage":"Upload image","labelVideo":"Upload video"},"allowMultiple":{"overlayTextFile":"Drop files to upload","overlayTextImage":"Drop images to upload","overlayTextVideo":"Drop videos to upload","actionTitleFile":"Add files","actionTitleImage":"Add images","actionTitleVideo":"Add videos","actionHintFile":"or drop files to upload","actionHintImage":"or drop images to upload","actionHintVideo":"or drop videos to upload","labelFile":"Upload files","labelImage":"Upload images","labelVideo":"Upload videos"},"errorOverlayTextFile":"File type is not valid","errorOverlayTextImage":"Image type is not valid","errorOverlayTextVideo":"Video type is not valid"},"EmptySearchResult":{"altText":"Empty search results"},"Frame":{"skipToContent":"Skip to content","navigationLabel":"Navigation","Navigation":{"closeMobileNavigationLabel":"Close navigation"}},"FullscreenBar":{"back":"Back","accessibilityLabel":"Exit fullscreen mode"},"Filters":{"moreFilters":"More filters","moreFiltersWithCount":"More filters ({count})","filter":"Filter {resourceName}","noFiltersApplied":"No filters applied","cancel":"Cancel","done":"Done","clearAllFilters":"Clear all filters","clear":"Clear","clearLabel":"Clear {filterName}","addFilter":"Add filter","clearFilters":"Clear all"},"FilterPill":{"clear":"Clear"},"IndexFilters":{"searchFilterTooltip":"Search and filter (F)","searchFilterAccessibilityLabel":"Search and filter results","sort":"Sort your results","addView":"Add a new view","newView":"Custom search","SortButton":{"ariaLabel":"Sort the results","tooltip":"Sort","title":"Sort by","sorting":{"asc":"Ascending","desc":"Descending","az":"A-Z","za":"Z-A"}},"UpdateButtons":{"cancel":"Cancel","update":"Update","save":"Save","saveAs":"Save as","modal":{"title":"Save view as","label":"Name","sameName":"A view with this name already exists. Please choose a different name.","save":"Save","cancel":"Cancel"}}},"IndexProvider":{"defaultItemSingular":"Item","defaultItemPlural":"Items","allItemsSelected":"All {itemsLength}+ {resourceNamePlural} are selected","selected":"{selectedItemsCount} selected","a11yCheckboxDeselectAllSingle":"Deselect {resourceNameSingular}","a11yCheckboxSelectAllSingle":"Select {resourceNameSingular}","a11yCheckboxDeselectAllMultiple":"Deselect all {itemsLength} {resourceNamePlural}","a11yCheckboxSelectAllMultiple":"Select all {itemsLength} {resourceNamePlural}"},"IndexTable":{"emptySearchTitle":"No {resourceNamePlural} found","emptySearchDescription":"Try changing the filters or search term","onboardingBadgeText":"New","resourceLoadingAccessibilityLabel":"Loading {resourceNamePlural}\u2026","selectAllLabel":"Select all {resourceNamePlural}","selected":"{selectedItemsCount} selected","undo":"Undo","selectAllItems":"Select all {itemsLength}+ {resourceNamePlural}","selectItem":"Select {resourceName}","selectButtonText":"Select","sortAccessibilityLabel":"sort {direction} by"},"Loading":{"label":"Page loading bar"},"Modal":{"iFrameTitle":"body markup","modalWarning":"These required properties are missing from Modal: {missingProps}"},"Page":{"Header":{"rollupActionsLabel":"View actions for {title}"}},"Pagination":{"previous":"Previous","next":"Next","pagination":"Pagination"},"ProgressBar":{"negativeWarningMessage":"Values passed to the progress prop shouldn\u2019t be negative. Resetting {progress} to 0.","exceedWarningMessage":"Values passed to the progress prop shouldn\u2019t exceed 100. Setting {progress} to 100."},"ResourceList":{"sortingLabel":"Sort by","defaultItemSingular":"item","defaultItemPlural":"items","showing":"Showing {itemsCount} {resource}","showingTotalCount":"Showing {itemsCount} of {totalItemsCount} {resource}","loading":"Loading {resource}","selected":"{selectedItemsCount} selected","allItemsSelected":"All {itemsLength}+ {resourceNamePlural} in your store are selected","allFilteredItemsSelected":"All {itemsLength}+ {resourceNamePlural} in this filter are selected","selectAllItems":"Select all {itemsLength}+ {resourceNamePlural} in your store","selectAllFilteredItems":"Select all {itemsLength}+ {resourceNamePlural} in this filter","emptySearchResultTitle":"No {resourceNamePlural} found","emptySearchResultDescription":"Try changing the filters or search term","selectButtonText":"Select","a11yCheckboxDeselectAllSingle":"Deselect {resourceNameSingular}","a11yCheckboxSelectAllSingle":"Select {resourceNameSingular}","a11yCheckboxDeselectAllMultiple":"Deselect all {itemsLength} {resourceNamePlural}","a11yCheckboxSelectAllMultiple":"Select all {itemsLength} {resourceNamePlural}","Item":{"actionsDropdownLabel":"Actions for {accessibilityLabel}","actionsDropdown":"Actions dropdown","viewItem":"View details for {itemName}"},"BulkActions":{"actionsActivatorLabel":"Actions","moreActionsActivatorLabel":"More actions","warningMessage":"To provide a better user experience. There should only be a maximum of {maxPromotedActions} promoted actions."}},"SkeletonPage":{"loadingLabel":"Page loading"},"Tabs":{"newViewAccessibilityLabel":"Create new view","newViewTooltip":"Create view","toggleTabsLabel":"More views","Tab":{"rename":"Rename view","duplicate":"Duplicate view","edit":"Edit view","editColumns":"Edit columns","delete":"Delete view","copy":"Copy of {name}","deleteModal":{"title":"Delete view?","description":"This can\u2019t be undone. {viewName} view will no longer be available in your admin.","cancel":"Cancel","delete":"Delete view"}},"RenameModal":{"title":"Rename view","label":"Name","cancel":"Cancel","create":"Save","errors":{"sameName":"A view with this name already exists. Please choose a different name."}},"DuplicateModal":{"title":"Duplicate view","label":"Name","cancel":"Cancel","create":"Create view","errors":{"sameName":"A view with this name already exists. Please choose a different name."}},"CreateViewModal":{"title":"Create new view","label":"Name","cancel":"Cancel","create":"Create view","errors":{"sameName":"A view with this name already exists. Please choose a different name."}}},"Tag":{"ariaLabel":"Remove {children}"},"TextField":{"characterCount":"{count} characters","characterCountWithMaxLength":"{count} of {limit} characters used"},"TooltipOverlay":{"accessibilityLabel":"Tooltip: {label}"},"TopBar":{"toggleMenuLabel":"Toggle menu","SearchField":{"clearButtonLabel":"Clear","search":"Search"}},"MediaCard":{"dismissButton":"Dismiss","popoverButton":"Actions"},"VideoThumbnail":{"playButtonA11yLabel":{"default":"Play video","defaultWithDuration":"Play video of length {duration}","duration":{"hours":{"other":{"only":"{hourCount} hours","andMinutes":"{hourCount} hours and {minuteCount} minutes","andMinute":"{hourCount} hours and {minuteCount} minute","minutesAndSeconds":"{hourCount} hours, {minuteCount} minutes, and {secondCount} seconds","minutesAndSecond":"{hourCount} hours, {minuteCount} minutes, and {secondCount} second","minuteAndSeconds":"{hourCount} hours, {minuteCount} minute, and {secondCount} seconds","minuteAndSecond":"{hourCount} hours, {minuteCount} minute, and {secondCount} second","andSeconds":"{hourCount} hours and {secondCount} seconds","andSecond":"{hourCount} hours and {secondCount} second"},"one":{"only":"{hourCount} hour","andMinutes":"{hourCount} hour and {minuteCount} minutes","andMinute":"{hourCount} hour and {minuteCount} minute","minutesAndSeconds":"{hourCount} hour, {minuteCount} minutes, and {secondCount} seconds","minutesAndSecond":"{hourCount} hour, {minuteCount} minutes, and {secondCount} second","minuteAndSeconds":"{hourCount} hour, {minuteCount} minute, and {secondCount} seconds","minuteAndSecond":"{hourCount} hour, {minuteCount} minute, and {secondCount} second","andSeconds":"{hourCount} hour and {secondCount} seconds","andSecond":"{hourCount} hour and {secondCount} second"}},"minutes":{"other":{"only":"{minuteCount} minutes","andSeconds":"{minuteCount} minutes and {secondCount} seconds","andSecond":"{minuteCount} minutes and {secondCount} second"},"one":{"only":"{minuteCount} minute","andSeconds":"{minuteCount} minute and {secondCount} seconds","andSecond":"{minuteCount} minute and {secondCount} second"}},"seconds":{"other":"{secondCount} seconds","one":"{secondCount} second"}}}}}}');

},{}],"5JYgy":[function(require,module,exports) {
module.exports = JSON.parse('{"Polaris":{"Avatar":{"label":"Avatar","labelWithInitials":"Avatar med initialene {initials}"},"Autocomplete":{"spinnerAccessibilityLabel":"Laster inn","ellipsis":"{content} \u2026"},"Badge":{"PROGRESS_LABELS":{"incomplete":"Ufullstendig","partiallyComplete":"Delvis fullf\xf8rt","complete":"Ferdig"},"STATUS_LABELS":{"info":"Info","success":"Vellykket","warning":"Advarsel","attention":"Obs","new":"Ny","critical":"Kritisk"},"progressAndStatus":"{statusLabel} {progressLabel}"},"Button":{"spinnerAccessibilityLabel":"Laster inn","connectedDisclosureAccessibilityLabel":"Relaterte handlinger"},"Common":{"checkbox":"avmerkingsboks","undo":"Angre","cancel":"Avbryt","clear":"Fjern","close":"Lukk","submit":"Send inn","more":"Mer"},"ContextualSaveBar":{"save":"Lagre","discard":"Forkast"},"DataTable":{"sortAccessibilityLabel":"sortere {direction} etter","navAccessibilityLabel":"Rull tabell {direction} en kolonne","totalsRowHeading":"Totalt","totalRowHeading":"Total"},"DatePicker":{"previousMonth":"Vis forrige m\xe5ned, {previousMonthName} {showPreviousYear}","nextMonth":"Vis neste m\xe5ned, {nextMonth} {nextYear}","today":"I dag ","months":{"january":"Januar","february":"Februar","march":"Mars","april":"April","may":"Mai","june":"Juni","july":"Juli","august":"August","september":"September","october":"Oktober","november":"November","december":"Desember"},"daysAbbreviated":{"monday":"man","tuesday":"tir","wednesday":"ons","thursday":"tor","friday":"fre","saturday":"l\xf8r","sunday":"s\xf8n"},"days":{"monday":"Mandag","tuesday":"Tirsdag","wednesday":"Onsdag","thursday":"Torsdag","friday":"Fredag","saturday":"L\xf8rdag","sunday":"S\xf8ndag"},"start":"Start av intervall","end":"Slutt p\xe5 intervall"},"DiscardConfirmationModal":{"title":"Forkast alle ulagrede endringer","message":"Hvis du forkaster endringer, sletter du alt du har gjort siden du sist gang du lagret.","primaryAction":"Forkast endringer","secondaryAction":"Fortsett redigering"},"DropZone":{"errorOverlayTextFile":"Filtypen er ikke gyldig","errorOverlayTextImage":"Bildetypen er ikke gyldig","single":{"overlayTextFile":"Slipp fil for \xe5 laste opp","overlayTextImage":"Slipp bilde for \xe5 laste opp","actionTitleFile":"Legg til en fil","actionTitleImage":"Legg til bilde","actionHintFile":"eller slipp filen for \xe5 laste den opp","actionHintImage":"eller slipp bildet for \xe5 laste opp","labelFile":"Last opp fil","labelImage":"Last opp bilde","overlayTextVideo":"Slipp video for \xe5 laste opp","actionTitleVideo":"Legg til video","actionHintVideo":"eller slipp video for \xe5 laste opp","labelVideo":"Last opp video"},"allowMultiple":{"overlayTextFile":"Slipp filer for \xe5 laste opp","overlayTextImage":"Slipp bilder for \xe5 laste opp","actionTitleFile":"Legg til filer","actionTitleImage":"Legg til bilder","actionHintFile":"eller slipp filer for \xe5 laste opp","actionHintImage":"eller slipp bilder for \xe5 laste opp","labelFile":"Last opp filer","labelImage":"Laste opp bilder","overlayTextVideo":"Slipp videoer for \xe5 laste opp","actionTitleVideo":"Legg til videoer","actionHintVideo":"eller slipp videoer for \xe5 laste opp","labelVideo":"Last opp videoer"},"errorOverlayTextVideo":"Videotypen er ugyldig"},"EmptySearchResult":{"altText":"T\xf8m s\xf8keresultater"},"Frame":{"skipToContent":"G\xe5 videre til innholdet","Navigation":{"closeMobileNavigationLabel":"Lukk navigasjon"},"navigationLabel":"Navigasjon"},"ActionMenu":{"RollupActions":{"rollupButton":"Vis handlinger"},"Actions":{"moreActions":"Flere handlinger"}},"Filters":{"moreFilters":"Flere filtre","filter":"Filter {resourceName}","noFiltersApplied":"Ingen filtre ble brukt","cancel":"Avbryt","done":"Ferdig","clearAllFilters":"Fjern alle filtre","clear":"Fjern","clearLabel":"Fjern {filterName}","moreFiltersWithCount":"Flere filtre ({count})","addFilter":"Legg til filter","clearFilters":"Fjern alle"},"Modal":{"iFrameTitle":"br\xf8dtekstp\xe5slag","modalWarning":"Disse n\xf8dvendige egenskapene mangler fra Modal: {missingProps}"},"Pagination":{"previous":"Forrige","next":"Neste","pagination":"Sideinndeling"},"ProgressBar":{"negativeWarningMessage":"Verdier som er overf\xf8rt til fremgangsrekvisitten, b\xf8r ikke v\xe6re negative. Tilbakestiller {progress} til 0.","exceedWarningMessage":"Verdier som er overf\xf8rt til fremgangsrekvisitten, b\xf8r ikke overstige 100. Setter {progress} til 100."},"ResourceList":{"sortingLabel":"Sorter etter","defaultItemSingular":"vare","defaultItemPlural":"varer","showing":"Viser {itemsCount} {resource}","loading":"Laster inn {resource}","selected":"{selectedItemsCount} valgt","allItemsSelected":"Alle {itemsLength} + {resourceNamePlural} i butikken din er valgt","selectAllItems":"Velg alle {itemsLength}+ {resourceNamePlural} i butikken din","emptySearchResultTitle":"Fant ingen {resourceNamePlural}","emptySearchResultDescription":"Pr\xf8v \xe5 endre filtrene eller s\xf8keord","selectButtonText":"Velg","a11yCheckboxDeselectAllSingle":"Opphev valg av {resourceNameSingular}","a11yCheckboxSelectAllSingle":"Velg {resourceNameSingular}","a11yCheckboxDeselectAllMultiple":"Opphev alle valg av {itemsLength} {resourceNamePlural}","a11yCheckboxSelectAllMultiple":"Velg alle {itemsLength} {resourceNamePlural}","Item":{"actionsDropdownLabel":"Handlinger for {accessibilityLabel}","actionsDropdown":"Handlinger-rullegardin","viewItem":"Vis detaljer for {itemName}"},"BulkActions":{"actionsActivatorLabel":"Handlinger","moreActionsActivatorLabel":"Flere handlinger","warningMessage":"For \xe5 gi en bedre brukeropplevelse. Det b\xf8r ikke v\xe6re mer enn {maxPromotedActions} promoterte handlinger."},"showingTotalCount":"Viser {itemsCount} av {totalItemsCount} {resource}","allFilteredItemsSelected":"Alle {itemsLength} + {resourceNamePlural} i dette filteret er valgt","selectAllFilteredItems":"Velg alle {itemsLength}+ {resourceNamePlural} i dette filteret"},"SkeletonPage":{"loadingLabel":"Siden laster"},"Tabs":{"toggleTabsLabel":"Flere visninger","newViewAccessibilityLabel":"Opprett en ny visning","newViewTooltip":"Opprett visning","Tab":{"rename":"Gi visning nytt navn","duplicate":"Dupliser visning","edit":"Rediger visning","editColumns":"Rediger kolonner","delete":"Slett visning","copy":"Kopi av {name}","deleteModal":{"title":"Slett visning?","description":"Dette kan ikke omgj\xf8res i ettertid. {viewName}-visningen vil ikke lenger v\xe6re tilgjengelig i administrator.","cancel":"Avbryt","delete":"Slett visning"}},"RenameModal":{"title":"Gi visning nytt navn","label":"Navn","cancel":"Avbryt","create":"Lagre","errors":{"sameName":"Det finnes allerede en visning med dette navnet. Velg et annet navn."}},"DuplicateModal":{"title":"Dupliser visning","label":"Navn","cancel":"Avbryt","create":"Opprett visning","errors":{"sameName":"Det finnes allerede en visning med dette navnet. Velg et annet navn."}},"CreateViewModal":{"title":"Opprett en ny visning","label":"Navn","cancel":"Avbryt","create":"Opprett visning","errors":{"sameName":"Det finnes allerede en visning med dette navnet. Velg et annet navn."}}},"Tag":{"ariaLabel":"Fjern {children}"},"TextField":{"characterCount":"{count} tegn","characterCountWithMaxLength":"{count} av {limit} tegn brukt"},"TopBar":{"toggleMenuLabel":"Aktiver/deaktiver meny","SearchField":{"clearButtonLabel":"Fjern","search":"S\xf8k"}},"MediaCard":{"popoverButton":"Handlinger","dismissButton":"Avvis"},"VideoThumbnail":{"playButtonA11yLabel":{"default":"Spill av video","defaultWithDuration":"Spill video med lengde {duration}","duration":{"hours":{"other":{"only":"{hourCount} timer","andMinutes":"{hourCount} timer og {minuteCount} minutter","andMinute":"{hourCount} timer og {minuteCount} minutt","minutesAndSeconds":"{hourCount} timer, {minuteCount} minutter og {secondCount} sekunder","minutesAndSecond":"{hourCount} timer, {minuteCount} minutter og {secondCount} sekund","minuteAndSeconds":"{hourCount} timer, {minuteCount} minutt og {secondCount} sekunder","minuteAndSecond":"{hourCount} timer, {minuteCount} minutt og {secondCount} sekund","andSeconds":"{hourCount} timer og {secondCount} sekunder","andSecond":"{hourCount} timer og {secondCount} sekund"},"one":{"only":"{hourCount} time","andMinutes":"{hourCount} time og {minuteCount} minutter","andMinute":"{hourCount} time og {minuteCount} minutt","minutesAndSeconds":"{hourCount} time, {minuteCount} minutter og {secondCount} sekunder","minutesAndSecond":"{hourCount} time, {minuteCount} minutter og {secondCount} sekund","minuteAndSeconds":"{hourCount} time, {minuteCount} minutt og {secondCount} sekunder","minuteAndSecond":"{hourCount} time, {minuteCount} minutt og {secondCount} sekund","andSeconds":"{hourCount} time og {secondCount} sekunder","andSecond":"{hourCount} time og {secondCount} sekund"}},"minutes":{"other":{"only":"{minuteCount} minutter","andSeconds":"{minuteCount} minutter og {secondCount} sekunder","andSecond":"{minuteCount} minutter og {secondCount} sekund"},"one":{"only":"{minuteCount} minutt","andSeconds":"{minuteCount} minutt og {secondCount} sekunder","andSecond":"{minuteCount} minutt og {secondCount} sekund"}},"seconds":{"other":"{secondCount} sekunder","one":"{secondCount} sekund"}}}},"Loading":{"label":"Sidelastingslinje"},"TooltipOverlay":{"accessibilityLabel":"Verkt\xf8ytips: {label}"},"IndexProvider":{"defaultItemSingular":"Vare","defaultItemPlural":"Varer","allItemsSelected":"Alle {itemsLength} + {resourceNamePlural} er valgt","selected":"{selectedItemsCount} valgt","a11yCheckboxDeselectAllSingle":"Opphev valg av {resourceNameSingular}","a11yCheckboxSelectAllSingle":"Velg {resourceNameSingular}","a11yCheckboxDeselectAllMultiple":"Opphev alle valg av {itemsLength} {resourceNamePlural}","a11yCheckboxSelectAllMultiple":"Velg alle {itemsLength} {resourceNamePlural}"},"IndexTable":{"emptySearchTitle":"Fant ingen {resourceNamePlural}","emptySearchDescription":"Pr\xf8v \xe5 endre filtrene eller s\xf8keord","onboardingBadgeText":"Ny","resourceLoadingAccessibilityLabel":"Laster inn {resourceNamePlural} \u2026","selectAllLabel":"Velg alle {resourceNamePlural}","selected":"{selectedItemsCount} valgt","undo":"Angre","selectAllItems":"Velg alle {itemsLength} {resourceNamePlural}","selectItem":"Velg {resourceName}","selectButtonText":"Velg","sortAccessibilityLabel":"sorter {direction} etter"},"Page":{"Header":{"rollupActionsLabel":"Vis handlinger for {title}"}},"FullscreenBar":{"back":"Tilbake","accessibilityLabel":"Avslutt fullskjermmodus"},"FilterPill":{"clear":"Fjern"},"IndexFilters":{"searchFilterTooltip":"S\xf8k og filtrer (F)","searchFilterAccessibilityLabel":"S\xf8k og filtrer resultater","sort":"Sorter resultatene","addView":"Legg til en ny visning","newView":"Tilpasset s\xf8k","SortButton":{"ariaLabel":"Sorter resultatene","tooltip":"Sorter","title":"Sorter etter","sorting":{"asc":"Stigende","desc":"Synkende","az":"A\u2013\xc5","za":"\xc5\u2013A"}},"UpdateButtons":{"cancel":"Avbryt","update":"Oppdater","save":"Lagre","saveAs":"Lagre som","modal":{"title":"Lagre visningen som","label":"Navn","sameName":"Det finnes allerede en visning med dette navnet. Velg et annet navn.","save":"Lagre","cancel":"Avbryt"}}}}}');

},{}],"adimP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDetailsPageURL", ()=>getDetailsPageURL);
parcelHelpers.export(exports, "getManualCompanyPath", ()=>getManualCompanyPath);
parcelHelpers.export(exports, "getCompanyPath", ()=>getCompanyPath);
parcelHelpers.export(exports, "shouldShowToolbar", ()=>shouldShowToolbar);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../constants/routes");
const getDetailsPageURL = (customerId, customerType, assignmentId)=>{
    return assignmentId ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).ASSIGNMENT_DETAILS, {
        customerId,
        id: assignmentId
    }) : (0, _reactRouterDom.generatePath)(customerType === "company" ? (0, _routes.ROUTES).COMPANY_DETAILS : (0, _routes.ROUTES).PERSON_DETAILS, {
        id: customerId
    });
};
const getManualCompanyPath = (customerId, status)=>{
    switch(status){
        case "FETCHING_DATA":
        case "SCREENING_CONFIG":
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_SCREENING, {
                id: customerId
            });
        // case "ASSIGNMENT_CONFIG":
        //   return generatePath(ROUTES.MANUAL_COMPANY_ONBOARDING_ASSIGNMENTS, { id: customerId });
        case "SIGNATURE_CONFIG":
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_DISCLOSURES, {
                id: customerId
            });
        case "READY":
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_SUMMARY, {
                id: customerId
            });
        default:
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_DETAILS, {
                id: customerId
            });
    }
};
const getCompanyPath = (customerId, status)=>{
    switch(status){
        case "FETCHING_DATA":
        case "SCREENING_CONFIG":
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_ONBOARDING_SCREENING, {
                id: customerId
            });
        // case "ASSIGNMENT_CONFIG":
        //   return generatePath(ROUTES.COMPANY_ONBOARDING_ASSIGNMENTS, { id: customerId });
        case "SIGNATURE_CONFIG":
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_ONBOARDING_DISCLOSURES, {
                id: customerId
            });
        case "READY":
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_ONBOARDING_SUMMARY, {
                id: customerId
            });
        default:
            return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_DETAILS, {
                id: customerId
            });
    }
};
const shouldShowToolbar = ()=>(0, _reactRouterDom.matchPath)(location.pathname, {
        path: [
            (0, _routes.ROUTES).EXPIRED
        ]
    }) !== null;

},{"react-router-dom":"1ee65","../constants/routes":"ihtm8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ihtm8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ROUTES", ()=>ROUTES);
parcelHelpers.export(exports, "ONBOARDING_COMPANY_WIZARD_ROUTES", ()=>ONBOARDING_COMPANY_WIZARD_ROUTES);
parcelHelpers.export(exports, "ONBOARDING_MANUAL_COMPANY_WIZARD_ROUTES", ()=>ONBOARDING_MANUAL_COMPANY_WIZARD_ROUTES);
parcelHelpers.export(exports, "ONBOARDING_PERSON_ROUTES", ()=>ONBOARDING_PERSON_ROUTES);
var ROUTES;
(function(ROUTES) {
    ROUTES["HOME"] = "/";
    ROUTES["SETTINGS_USERS"] = "/settings/users";
    ROUTES["SETTINGS_TAGS"] = "/settings/tags";
    ROUTES["SETTINGS_QUESTIONNAIRES_LIST"] = "/settings/questionnaires";
    ROUTES["SETTINGS_QUESTIONNAIRE_DETAILS"] = "/settings/questionnaire/:id";
    ROUTES["SETTINGS_REVIEW_CHECKLISTS_LIST"] = "/settings/checklists";
    ROUTES["SETTINGS_REVIEW_CHECKLIST_DETAILS_NEW"] = "/settings/checklist/new";
    ROUTES["SETTINGS_REVIEW_CHECKLIST_DETAILS"] = "/settings/checklist/:id";
    ROUTES["SETTINGS_FOLLOWUP"] = "/settings/followup";
    ROUTES["SETTINGS_FOLLOWUP_NOTIFICATIONS"] = "/settings/followup-notifications";
    ROUTES["SETTINGS_AUTO_REMINDERS"] = "/settings/reminders";
    ROUTES["SETTINGS_MEASURES"] = "/settings/measures";
    ROUTES["SETTINGS_ONBOARDING"] = "/settings/onboarding";
    ROUTES["SETTINGS_DISCLOSURE"] = "/settings/disclosure";
    ROUTES["SETTINGS_GUIDELINE"] = "/settings/guideline";
    ROUTES["SETTINGS_CUSTOMER_NOTIFICATIONS"] = "/settings/customer-info-notifications";
    ROUTES["DASHBOARD"] = "/dashboard";
    ROUTES["COMPANY_DETAILS"] = "/companies/:id";
    ROUTES["PERSON_DETAILS"] = "/persons/:id";
    ROUTES["MATCH_CASE_DETAILS"] = "/customers/:customerId/match-cases/:id";
    ROUTES["ASSIGNMENT_DETAILS"] = "/customers/:customerId/assignment/:id";
    ROUTES["CUSTOMER_REVIEW"] = "/customers/:customerId/review/:id";
    ROUTES["CUSTOMER_REVIEW_NEW"] = "/customers/:customerId/review/new";
    ROUTES["CUSTOMER_ASSIGNMENT_REVIEW_NEW"] = "/customers/:customerId/assignment/:assignmentId/review/new";
    ROUTES["COMPANY_ONBOARDING_ASSIGNMENTS"] = "/companies/:id/assignments";
    ROUTES["COMPANY_ONBOARDING_SCREENING"] = "/companies/:id/screening";
    ROUTES["COMPANY_ONBOARDING_DISCLOSURES"] = "/companies/:id/request-onboarding-disclosures";
    ROUTES["COMPANY_ONBOARDING_SUMMARY"] = "/companies/:id/summary";
    ROUTES["COMPANY_REQUEST_DISCLOSURES"] = "/companies/:id/request-disclosure";
    ROUTES["IMPORT_CUSTOMERS"] = "/import/companies";
    ROUTES["COMPANY_CHANGE_SCREENING"] = "/companies/:id/change-screening";
    ROUTES["COMPANY_ASSIGNMENT_REQUEST_DISCLOSURES"] = "/companies/:id/assignment/:assignmentId/request-disclosure";
    ROUTES["PERSON_ASSIGNMENT_REQUEST_DISCLOSURES"] = "/persons/:id/assignment/:assignmentId/request-disclosure";
    ROUTES["PERSON_REQUEST_DISCLOSURES"] = "/persons/:id/request-disclosure";
    ROUTES["PERSON_CHANGE_SCREENING"] = "/persons/:id/change-screening";
    ROUTES["ONBOARDING_NEW_PERSON"] = "/onboarding/person/new";
    ROUTES["ONBOARDING_SAVED_PERSON"] = "/onboarding/person/:id";
    ROUTES["MANUAL_COMPANY_ONBOARDING_EDIT"] = "/manual-companies/:id/edit";
    ROUTES["MANUAL_COMPANY_ONBOARDING_ASSIGNMENTS"] = "/manual-companies/:id/assignments";
    ROUTES["MANUAL_COMPANY_ONBOARDING_SCREENING"] = "/manual-companies/:id/screening";
    ROUTES["MANUAL_COMPANY_ONBOARDING_DISCLOSURES"] = "/manual-companies/:id/request-onboarding-disclosures";
    ROUTES["MANUAL_COMPANY_ONBOARDING_SUMMARY"] = "/manual-companies/:id/summary";
    ROUTES["CUSTOMERS"] = "/customers";
    ROUTES["COMPANY_LOOKUP"] = "/lookup";
    ROUTES["COMPANY_LOOKUP_RESULT"] = "/lookup/:orgId";
    ROUTES["PROJECTS_LIST"] = "/projects";
    ROUTES["PLAN_UPGRADE_PROJECTS_LIST"] = "/projects-upgrade-plan";
    ROUTES["PROJECT_DETAILS"] = "/project/:id";
    ROUTES["ACCESS_DENIED"] = "/denied";
    ROUTES["EXPIRED"] = "/expired";
    ROUTES["LOGOUT"] = "/logout";
})(ROUTES || (ROUTES = {}));
const ONBOARDING_COMPANY_WIZARD_ROUTES = [
    "/companies/:id/screening",
    "/companies/:id/assignments",
    "/companies/:id/request-onboarding-disclosures",
    "/companies/:id/summary"
];
const ONBOARDING_MANUAL_COMPANY_WIZARD_ROUTES = [
    "/manual-companies/:id/edit",
    "/manual-companies/:id/screening",
    "/companies/:id/assignments",
    "/manual-companies/:id/request-onboarding-disclosures",
    "/manual-companies/:id/summary"
];
const ONBOARDING_PERSON_ROUTES = [
    "/onboarding/person/new",
    "/onboarding/person/:id"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"51tmg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useAppTitle = (suffix)=>{
    const baseTitle = `Kjenn din kunde${" - staging"}`;
    (0, _react.useEffect)(()=>{
        document.title = baseTitle + (suffix ? ` - ${suffix}` : "");
        return ()=>{
            document.title = baseTitle;
        };
    }, [
        baseTitle,
        suffix
    ]);
};
exports.default = useAppTitle;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k9r0q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _authProvider = require("../providers/AuthProvider/AuthProvider");
/**
 * Use the `useAuth` hook in your components to access the auth state and methods.
 */ const useAuth = ()=>(0, _react.useContext)((0, _authProvider.AuthContext));
exports.default = useAuth;

},{"react":"cOWTg","../providers/AuthProvider/AuthProvider":"jnIYf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jnIYf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthProvider", ()=>AuthProvider);
parcelHelpers.export(exports, "AuthContext", ()=>AuthContext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _auth0React = require("@auth0/auth0-react");
var _react1 = require("@sentry/react");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _sessionState = require("../../constants/session-state");
var _authProviderAuthSessionService = require("./AuthProvider.authSessionService");
const AuthProvider = ({ children })=>{
    const history = (0, _reactRouterDom.useHistory)();
    // A function that routes the user to the right place
    // after login (we currently use Auth0's universal login form)
    const onRedirectCallback = (appState)=>{
        history.push(appState?.returnTo || window.location.pathname);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _auth0React.Auth0Provider), {
        domain: "beaufort-dev.eu.auth0.com",
        clientId: "hhWyeq2EMg8gDZAq2vST9V4jJPtgf18z",
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: "https://beaufort.io"
        },
        onRedirectCallback: onRedirectCallback,
        cacheLocation: "localstorage",
        useRefreshTokens: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BeaufortAuthProvider, {
            children: children
        })
    });
};
const stub = ()=>{
    throw new Error("You forgot to wrap your component in <AuthProvider>.");
};
const initialContext = {
    isAuthenticated: false,
    isLoading: true,
    getAccessTokenSilently: stub,
    getAccessTokenWithPopup: stub,
    getIdTokenClaims: stub,
    loginWithRedirect: stub,
    loginWithPopup: stub,
    logout: stub,
    handleRedirectCallback: stub
};
const AuthContext = /*#__PURE__*/ (0, _react.createContext)(initialContext);
/**
 * This provider extends Auth0's auth context and performs the
 * authentication of the user at both Auth0 and Beaufort.
 *
 * It gets and refreshes the access token for the API, and handles session
 * expiry due to user inactivity.
 *
 * It returns a consumable auth context with the auth state and, if authenticated,
 * the "Beaufort user". If the user authentication fails, e.g. no Beaufort-user exists
 * for the Auth0-user/email, the user is immediately logged out.
 */ const BeaufortAuthProvider = ({ children })=>{
    const auth0context = (0, _auth0React.useAuth0)();
    const [beaufortUser, setBeaufortUser] = (0, _react.useState)();
    /**
   * Override Auth0's logout function to default to return to window.location.origin
   */ const logout = (0, _react.useCallback)((options)=>{
        return auth0context.logout(options || {
            logoutParams: {
                returnTo: `${window.location.origin}/logout`
            }
        });
    }, [
        auth0context.logout
    ]);
    /**
   * Init and terminate auth session service which gets and refreshes
   * the user session and API access token, and handles session expiry
   */ (0, _react.useEffect)(()=>{
        if (auth0context.isAuthenticated) {
            (0, _authProviderAuthSessionService.authSessionService).init(auth0context.getAccessTokenSilently);
            return ()=>{
                (0, _authProviderAuthSessionService.authSessionService).terminate();
            };
        }
    }, [
        auth0context.getAccessTokenSilently,
        auth0context.isAuthenticated
    ]);
    /**
   * Function that authenticates the "Beaufort-user"
   *
   * If successful, it should return the authenticated Beaufort-user
   *
   * If no Beaufort-user exists for the Auth0-user (ie. there are no
   * Beaufort-user with the Auth0-user's email), the request will result
   * in a 401. In this case, log out immediately
   */ const authenticateBeaufortUser = ()=>{
        (0, _apiDefault.default).getLoggedInUser().then((beaufortUser)=>{
            // User successfully authenticated with Beaufort!
            setBeaufortUser(beaufortUser);
        }).catch(()=>{
            const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            localStorage.setItem((0, _sessionState.REDIRECT_TO_AFTER_LOGOUT_KEY), returnTo);
            // Assume 401
            // -> No Beaufort user found for the Auth0-user/email
            // -> Log out immediately as the user should have no access
            // --> The user should basically never be considered "logged in"
            logout();
        });
    };
    /**
   * Once the Auth0-user is authenticated, try to authenticate
   * the "Beaufort-user"
   */ (0, _react.useEffect)(()=>{
        if (auth0context.isAuthenticated && !beaufortUser) authenticateBeaufortUser();
    }, [
        auth0context.isAuthenticated,
        beaufortUser
    ]);
    /**
   * Set Sentry-user to the Beaufort user or the Auth0 user
   * depending on what is defined
   */ (0, _react.useEffect)(()=>{
        if (beaufortUser) _react1.setUser({
            email: beaufortUser.email,
            provider: "Beaufort",
            organization: beaufortUser.organization.name,
            features: beaufortUser.features || {},
            permission: beaufortUser.permissions
        });
        else if (auth0context.user?.email) _react1.setUser({
            email: auth0context.user.email,
            provider: "Auth0"
        });
    }, [
        auth0context.user,
        beaufortUser
    ]);
    /**
   * Capture Auth0-error if one occurs
   */ (0, _react.useEffect)(()=>{
        if (auth0context.error) _react1.captureException(auth0context.error);
    }, [
        auth0context.error
    ]);
    const context = {
        ...auth0context,
        user: beaufortUser,
        logout,
        // isLoading should be true as long as auth0 is loading or we haven't
        // authenticated the Beaufort user
        isLoading: auth0context.isLoading || beaufortUser === undefined,
        // isAuthenticated should only be true when the user has been authenticated
        // with both Auth0 and Beaufort
        isAuthenticated: auth0context.isAuthenticated && beaufortUser !== undefined
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuthContext.Provider, {
        value: context,
        children: children
    });
};
exports.default = AuthProvider;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@auth0/auth0-react":"bI3g5","@sentry/react":"akCRS","../../api":"f6lXD","../../constants/session-state":"g0N7C","./AuthProvider.authSessionService":"lpZZM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f6lXD":[function(require,module,exports) {
// import all exported methods from client.generated.ts into client namespace
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clientGenerated = require("./client.generated");
// export all types defined in client.generated.ts as if they were defined in api
parcelHelpers.exportAll(_clientGenerated, exports);
// export module client as default export
exports.default = _clientGenerated;

},{"./client.generated":"7mNzR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7mNzR":[function(require,module,exports) {
/**
 * Beaufort API
 * 1.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaults", ()=>defaults);
parcelHelpers.export(exports, "servers", ()=>servers);
/**
 * Person Onboarding
 */ parcelHelpers.export(exports, "startPersonOnboarding", ()=>startPersonOnboarding);
/**
 * Complete Company Onboarding
 */ parcelHelpers.export(exports, "completeCompanyOnboarding", ()=>completeCompanyOnboarding);
/**
 * Get Customer By External Id
 */ parcelHelpers.export(exports, "getCustomerByExternalId", ()=>getCustomerByExternalId);
/**
 * Delete Customer By External Id
 */ parcelHelpers.export(exports, "deleteCustomerByExternalId", ()=>deleteCustomerByExternalId);
/**
 * Get Customer By National Id
 */ parcelHelpers.export(exports, "getCustomerByNationalId", ()=>getCustomerByNationalId);
/**
 * Get Customer Updates
 */ parcelHelpers.export(exports, "getCustomerUpdates", ()=>getCustomerUpdates);
/**
 * Get Organization Updates
 */ parcelHelpers.export(exports, "getOrganizationUpdates", ()=>getOrganizationUpdates);
/**
 * Get Internal Kyc Preview Link
 */ parcelHelpers.export(exports, "getInternalKycPreviewLink", ()=>getInternalKycPreviewLink);
/**
 * Get Disclosure Preview Link
 */ parcelHelpers.export(exports, "getDisclosurePreviewLink", ()=>getDisclosurePreviewLink);
/**
 * Company Info
 */ parcelHelpers.export(exports, "getCompanyInfo", ()=>getCompanyInfo);
/**
 * Company Ownership
 */ parcelHelpers.export(exports, "getCompanyOwnership", ()=>getCompanyOwnership);
/**
 * Company Roles
 */ parcelHelpers.export(exports, "getCompanyRoles", ()=>getCompanyRoles);
/**
 * Country Risk And Tax Havens
 */ parcelHelpers.export(exports, "getCountryRiskAndTaxHavens", ()=>getCountryRiskAndTaxHavens);
/**
 * Industry Risk
 */ parcelHelpers.export(exports, "getIndustryRisk", ()=>getIndustryRisk);
/**
 * Create Company Customer
 */ parcelHelpers.export(exports, "createCompanyCustomer", ()=>createCompanyCustomer);
/**
 * Create Person Customer
 */ parcelHelpers.export(exports, "createPersonCustomer", ()=>createPersonCustomer);
/**
 * Get Person Customer Details
 */ parcelHelpers.export(exports, "getPersonCustomerDetails", ()=>getPersonCustomerDetails);
/**
 * Update Person Customer
 */ parcelHelpers.export(exports, "updatePerson", ()=>updatePerson);
/**
 * Get Company Screening Configuration
 */ parcelHelpers.export(exports, "getCompanyScreeningConfiguration", ()=>getCompanyScreeningConfiguration);
/**
 * Put Company Screening Configuration
 */ parcelHelpers.export(exports, "updateCompanyScreeningConfiguration", ()=>updateCompanyScreeningConfiguration);
/**
 * Patch Company Screening Configuration
 */ parcelHelpers.export(exports, "stopCompanyScreeningConfiguration", ()=>stopCompanyScreeningConfiguration);
/**
 * Stop Company Screening Configuration
 */ parcelHelpers.export(exports, "stopCompanyScreening", ()=>stopCompanyScreening);
/**
 * Stop Person Screening Configuration
 */ parcelHelpers.export(exports, "stopPersonScreening", ()=>stopPersonScreening);
/**
 * Get Person Screening Configuration
 */ parcelHelpers.export(exports, "getPersonScreeningConfiguration", ()=>getPersonScreeningConfiguration);
/**
 * Put Person Screening Configuration
 */ parcelHelpers.export(exports, "updatePersonScreeningConfiguration", ()=>updatePersonScreeningConfiguration);
/**
 * Patch Person Screening Configuration
 */ parcelHelpers.export(exports, "setPersonScreeningConfiguration", ()=>setPersonScreeningConfiguration);
/**
 * Get Company Signature Configuration
 */ parcelHelpers.export(exports, "getCompanySignatureConfiguration", ()=>getCompanySignatureConfiguration);
/**
 * Put Company Signature Configuration
 */ parcelHelpers.export(exports, "updateCompanySignatureConfiguration", ()=>updateCompanySignatureConfiguration);
/**
 * Remind Signer
 */ parcelHelpers.export(exports, "remindSigner", ()=>remindSigner);
/**
 * Get File Download Url
 */ parcelHelpers.export(exports, "getFileDownloadUrl", ()=>getFileDownloadUrl);
/**
 * Get Customer List
 */ parcelHelpers.export(exports, "getCustomers", ()=>getCustomers);
/**
 * Get Customer Counts
 */ parcelHelpers.export(exports, "getCustomerCounts", ()=>getCustomerCounts);
/**
 * Get Customer Details
 */ parcelHelpers.export(exports, "getCustomerDetails", ()=>getCustomerDetails);
/**
 * Delete Customer
 */ parcelHelpers.export(exports, "archiveCustomer", ()=>archiveCustomer);
/**
 * Update Customer Details
 */ parcelHelpers.export(exports, "updateCustomerDetails", ()=>updateCustomerDetails);
/**
 * Get Company Customer Details
 */ parcelHelpers.export(exports, "getCompanyCustomerDetails", ()=>getCompanyCustomerDetails);
/**
 * Update Company Customer
 */ parcelHelpers.export(exports, "updateCompanyCustomer", ()=>updateCompanyCustomer);
/**
 * Quick Review Company Info Update
 */ parcelHelpers.export(exports, "quickReviewCompanyInfoUpdate", ()=>quickReviewCompanyInfoUpdate);
/**
 * Get Customer Matches
 */ parcelHelpers.export(exports, "getCustomerMatches", ()=>getCustomerMatches);
/**
 * Get Customer Match Detail
 */ parcelHelpers.export(exports, "getCustomerMatchDetails", ()=>getCustomerMatchDetails);
/**
 * Get Customer Match Cases
 */ parcelHelpers.export(exports, "getCustomerMatchCases", ()=>getCustomerMatchCases);
/**
 * Get Customer Match Case Detail
 */ parcelHelpers.export(exports, "getCustomerMatchCaseDetails", ()=>getCustomerMatchCaseDetails);
/**
 * Create Match Review
 */ parcelHelpers.export(exports, "createMatchReview", ()=>createMatchReview);
/**
 * Create Customer Review
 */ parcelHelpers.export(exports, "createCustomerReview", ()=>createCustomerReview);
/**
 * Update Customer Review
 */ parcelHelpers.export(exports, "updateCustomerReview", ()=>updateCustomerReview);
/**
 * Create Draft Customer Review
 */ parcelHelpers.export(exports, "createDraftCustomerReview", ()=>createDraftCustomerReview);
/**
 * Update Draft Customer Review
 */ parcelHelpers.export(exports, "updateDraftCustomerReview", ()=>updateDraftCustomerReview);
/**
 * Delete Customer Review
 */ parcelHelpers.export(exports, "deleteCustomerReview", ()=>deleteCustomerReview);
/**
 * Approve Customer Review
 */ parcelHelpers.export(exports, "approveCustomerReview", ()=>approveCustomerReview);
/**
 * Reject Customer Review
 */ parcelHelpers.export(exports, "rejectCustomerReview", ()=>rejectCustomerReview);
/**
 * Create Customer Review Measure
 */ parcelHelpers.export(exports, "addCustomerReviewMeasure", ()=>addCustomerReviewMeasure);
/**
 * Update Customer Review Measure
 */ parcelHelpers.export(exports, "updateCustomerReviewMeasure", ()=>updateCustomerReviewMeasure);
/**
 * Remove Customer Review Measure
 */ parcelHelpers.export(exports, "removeCustomerReviewMeasure", ()=>removeCustomerReviewMeasure);
/**
 * Move Customer Review Measure
 */ parcelHelpers.export(exports, "moveCustomerReviewMeasure", ()=>moveCustomerReviewMeasure);
/**
 * Start Company Screening
 */ parcelHelpers.export(exports, "startCompanyScreening", ()=>startCompanyScreening);
/**
 * Start Person Screening
 */ parcelHelpers.export(exports, "startPersonScreening", ()=>startPersonScreening);
/**
 * Finish Onboarding
 */ parcelHelpers.export(exports, "finishOnboarding", ()=>finishOnboarding);
/**
 * Cancel Onboarding
 */ parcelHelpers.export(exports, "cancelOnboarding", ()=>cancelOnboarding);
/**
 * Create Company Role
 */ parcelHelpers.export(exports, "createCompanyRole", ()=>createCompanyRole);
/**
 * Sync Company Role
 */ parcelHelpers.export(exports, "syncCompanyRole", ()=>syncCompanyRole);
/**
 * Sync Company Owner
 */ parcelHelpers.export(exports, "syncCompanyOwner", ()=>syncCompanyOwner);
/**
 * Delete Company Role
 */ parcelHelpers.export(exports, "deleteCompanyRole", ()=>deleteCompanyRole);
/**
 * Update Company Role
 */ parcelHelpers.export(exports, "updateCompanyRole", ()=>updateCompanyRole);
/**
 * Create Company Owner
 */ parcelHelpers.export(exports, "createCompanyOwner", ()=>createCompanyOwner);
/**
 * Delete Company Owner
 */ parcelHelpers.export(exports, "deleteCompanyOwner", ()=>deleteCompanyOwner);
/**
 * Update Company Owner
 */ parcelHelpers.export(exports, "updateCompanyOwner", ()=>updateCompanyOwner);
/**
 * Get Person Signature Configuration
 */ parcelHelpers.export(exports, "getPersonSignatureConfiguration", ()=>getPersonSignatureConfiguration);
/**
 * Patch Person Signature Configuration
 */ parcelHelpers.export(exports, "setPersonSignatureConfiguration", ()=>setPersonSignatureConfiguration);
/**
 * Patch Person Signature
 */ parcelHelpers.export(exports, "updatePersonSignature", ()=>updatePersonSignature);
/**
 * Patch Company Signature
 */ parcelHelpers.export(exports, "updateCompanySignature", ()=>updateCompanySignature);
/**
 * Create Company Customer Match Review
 */ parcelHelpers.export(exports, "createCompanyCustomerMatchReview", ()=>createCompanyCustomerMatchReview);
/**
 * Delete Customer Signature
 */ parcelHelpers.export(exports, "deleteCustomerSignature", ()=>deleteCustomerSignature);
/**
 * Get Report For Customer
 */ parcelHelpers.export(exports, "getCustomerReport", ()=>getCustomerReport);
/**
 * Get Screening Report For Customer
 */ parcelHelpers.export(exports, "getScreeningReport", ()=>getScreeningReport);
/**
 * Create Company Customer Disclosure Document
 */ parcelHelpers.export(exports, "createCompanyCustomerDisclosureDocument", ()=>createCompanyCustomerDisclosureDocument);
/**
 * Create Person Customer Disclosure Document
 */ parcelHelpers.export(exports, "createPersonCustomerDisclosureDocument", ()=>createPersonCustomerDisclosureDocument);
/**
 * Download Customer Attachment
 */ parcelHelpers.export(exports, "downloadCustomerAttachment", ()=>downloadCustomerAttachment);
/**
 * Get Customer Attachment List
 */ parcelHelpers.export(exports, "getCustomerAttachments", ()=>getCustomerAttachments);
/**
 * Generate Customer Attachment Metadata
 */ parcelHelpers.export(exports, "addCustomerAttachment", ()=>addCustomerAttachment);
/**
 * Delete Customer Attachment
 */ parcelHelpers.export(exports, "deleteCustomerAttachment", ()=>deleteCustomerAttachment);
/**
 * Get Customer Attachment Signatures
 */ parcelHelpers.export(exports, "getAttachmentSignatures", ()=>getAttachmentSignatures);
/**
 * Update Customer Attachment Signatures
 */ parcelHelpers.export(exports, "updateAttachmentSignatures", ()=>updateAttachmentSignatures);
/**
 * Download Signed Customer Attachment
 */ parcelHelpers.export(exports, "downloadSignedCustomerAttachment", ()=>downloadSignedCustomerAttachment);
/**
 * Delete Signed Customer Attachment
 */ parcelHelpers.export(exports, "deleteSignedCustomerAttachment", ()=>deleteSignedCustomerAttachment);
/**
 * Batch Set Follow Up Date On Customers
 */ parcelHelpers.export(exports, "batchSetFollowUpDateOnCustomers", ()=>batchSetFollowUpDateOnCustomers);
/**
 * Batch Set Responsible Users On Customers
 */ parcelHelpers.export(exports, "batchSetResponsibleUsersOnCustomers", ()=>batchSetResponsibleUsersOnCustomers);
/**
 * Archive Customers
 */ parcelHelpers.export(exports, "archiveCustomers", ()=>archiveCustomers);
/**
 * Delete Customers
 */ parcelHelpers.export(exports, "deleteCustomers", ()=>deleteCustomers);
/**
 * Restore Customers
 */ parcelHelpers.export(exports, "restoreCustomers", ()=>restoreCustomers);
/**
 * Batch Assign Labels To Customers
 */ parcelHelpers.export(exports, "batchAssignLabelsToCustomers", ()=>batchAssignLabelsToCustomers);
/**
 * Batch Set Labels To Customers
 */ parcelHelpers.export(exports, "batchSetLabelsOnCustomers", ()=>batchSetLabelsOnCustomers);
/**
 * Batch Create And Assign Label To Customers
 */ parcelHelpers.export(exports, "batchCreateAndAssignLabelOnCustomers", ()=>batchCreateAndAssignLabelOnCustomers);
/**
 * Batch Unassign Labels From Customers
 */ parcelHelpers.export(exports, "batchUnassignLabelsFromCustomers", ()=>batchUnassignLabelsFromCustomers);
/**
 * Confirm Ownership Update
 */ parcelHelpers.export(exports, "confirmOwnershipUpdate", ()=>confirmOwnershipUpdate);
/**
 * Reject Ownership Update
 */ parcelHelpers.export(exports, "rejectOwnershipUpdate", ()=>rejectOwnershipUpdate);
/**
 * Confirm All Ownership Updates
 */ parcelHelpers.export(exports, "confirmAllOwnershipUpdates", ()=>confirmAllOwnershipUpdates);
/**
 * Create Customer Assignment
 */ parcelHelpers.export(exports, "createCustomerAssignment", ()=>createCustomerAssignment);
/**
 * Get Customer Assignment Details
 */ parcelHelpers.export(exports, "getCustomerAssignmentDetails", ()=>getCustomerAssignmentDetails);
/**
 * Update Customer Assignment
 */ parcelHelpers.export(exports, "updateCustomerAssignment", ()=>updateCustomerAssignment);
/**
 * Archive Customer Assignment
 */ parcelHelpers.export(exports, "archiveCustomerAssignment", ()=>archiveCustomerAssignment);
/**
 * Restore Customer Assignment
 */ parcelHelpers.export(exports, "restoreCustomerAssignment", ()=>restoreCustomerAssignment);
/**
 * Create Customer Assignment Review
 */ parcelHelpers.export(exports, "createCustomerAssignmentReview", ()=>createCustomerAssignmentReview);
/**
 * Download Customer Assignment Attachment
 */ parcelHelpers.export(exports, "downloadCustomerAssignmentAttachment", ()=>downloadCustomerAssignmentAttachment);
/**
 * Get Customer Assignment Attachment List
 */ parcelHelpers.export(exports, "getCustomerAssignmentAttachments", ()=>getCustomerAssignmentAttachments);
/**
 * Generate Customer Assignment Attachment Metadata
 */ parcelHelpers.export(exports, "addCustomerAssignmentAttachment", ()=>addCustomerAssignmentAttachment);
/**
 * Delete Customer Assignment Attachment
 */ parcelHelpers.export(exports, "deleteCustomerAssignmentAttachment", ()=>deleteCustomerAssignmentAttachment);
/**
 * Get Customer Assignment Attachment Signatures
 */ parcelHelpers.export(exports, "getCustomerAssignmentAttachmentSignatures", ()=>getCustomerAssignmentAttachmentSignatures);
/**
 * Update Customer Assignment Attachment Signatures
 */ parcelHelpers.export(exports, "updateCustomerAssignmentAttachmentSignatures", ()=>updateCustomerAssignmentAttachmentSignatures);
/**
 * Download Signed Customer Assignment Attachment
 */ parcelHelpers.export(exports, "downloadSignedCustomerAssignmentAttachment", ()=>downloadSignedCustomerAssignmentAttachment);
/**
 * Delete Signed Customer Assignment Attachment
 */ parcelHelpers.export(exports, "deleteSignedCustomerAssignmentAttachment", ()=>deleteSignedCustomerAssignmentAttachment);
/**
 * Get Customer Ownership Tree
 */ parcelHelpers.export(exports, "getCustomerOwnershipTree", ()=>getCustomerOwnershipTree);
/**
 * Get Company Ownership Tree
 */ parcelHelpers.export(exports, "getCompanyOwnershipTree", ()=>getCompanyOwnershipTree);
/**
 * List Customer Notations
 */ parcelHelpers.export(exports, "listCustomerNotations", ()=>listCustomerNotations);
/**
 * Create Customer Notation
 */ parcelHelpers.export(exports, "createCustomerNotation", ()=>createCustomerNotation);
/**
 * Get Customer Notation
 */ parcelHelpers.export(exports, "getCustomerNotation", ()=>getCustomerNotation);
/**
 * Update Customer Notation
 */ parcelHelpers.export(exports, "updateCustomerNotation", ()=>updateCustomerNotation);
/**
 * Delete Customer Notation
 */ parcelHelpers.export(exports, "deleteCustomerNotation", ()=>deleteCustomerNotation);
/**
 * List Customer Review Notations
 */ parcelHelpers.export(exports, "listCustomerReviewNotations", ()=>listCustomerReviewNotations);
/**
 * Create Customer Review Notation
 */ parcelHelpers.export(exports, "createCustomerReviewNotation", ()=>createCustomerReviewNotation);
/**
 * Get Customer Review Notation
 */ parcelHelpers.export(exports, "getCustomerReviewNotation", ()=>getCustomerReviewNotation);
/**
 * Update Customer Review Notation
 */ parcelHelpers.export(exports, "updateCustomerReviewNotation", ()=>updateCustomerReviewNotation);
/**
 * Delete Customer Review Notation
 */ parcelHelpers.export(exports, "deleteCustomerReviewNotation", ()=>deleteCustomerReviewNotation);
/**
 * List Kar Lookups
 */ parcelHelpers.export(exports, "listKarLookups", ()=>listKarLookups);
/**
 * Create Kar Lookup
 */ parcelHelpers.export(exports, "createKarLookup", ()=>createKarLookup);
/**
 * Get Project List
 */ parcelHelpers.export(exports, "getProjects", ()=>getProjects);
/**
 * Create Project
 */ parcelHelpers.export(exports, "createProject", ()=>createProject);
/**
 * Get Project
 */ parcelHelpers.export(exports, "getProject", ()=>getProject);
/**
 * Update Project
 */ parcelHelpers.export(exports, "updateProject", ()=>updateProject);
/**
 * Get Project Customers Details
 */ parcelHelpers.export(exports, "getProjectCustomersDetails", ()=>getProjectCustomersDetails);
/**
 * Create Project Review
 */ parcelHelpers.export(exports, "createProjectReview", ()=>createProjectReview);
/**
 * Get Project Attachment List
 */ parcelHelpers.export(exports, "getProjectAttachments", ()=>getProjectAttachments);
/**
 * Generate Project Attachment Metadata
 */ parcelHelpers.export(exports, "addProjectAttachment", ()=>addProjectAttachment);
/**
 * Download Project Attachment
 */ parcelHelpers.export(exports, "downloadProjectAttachment", ()=>downloadProjectAttachment);
/**
 * Delete Project Attachment
 */ parcelHelpers.export(exports, "deleteProjectAttachment", ()=>deleteProjectAttachment);
/**
 * Get Project Attachment Signatures
 */ parcelHelpers.export(exports, "getProjectAttachmentSignatures", ()=>getProjectAttachmentSignatures);
/**
 * Update Project Attachment Signatures
 */ parcelHelpers.export(exports, "updateProjectAttachmentSignatures", ()=>updateProjectAttachmentSignatures);
/**
 * Download Signed Project Attachment
 */ parcelHelpers.export(exports, "downloadSignedProjectAttachment", ()=>downloadSignedProjectAttachment);
/**
 * Delete Signed Project Attachment
 */ parcelHelpers.export(exports, "deleteSignedProjectAttachment", ()=>deleteSignedProjectAttachment);
/**
 * Batch Assign Labels To Project Customers
 */ parcelHelpers.export(exports, "batchAssignLabelsToProjectCustomers", ()=>batchAssignLabelsToProjectCustomers);
/**
 * Batch Set Labels To Project Customers
 */ parcelHelpers.export(exports, "batchSetLabelsOnProjectCustomers", ()=>batchSetLabelsOnProjectCustomers);
/**
 * Batch Create And Assign Label To Project Customers
 */ parcelHelpers.export(exports, "batchCreateAndAssignLabelOnProjectCustomers", ()=>batchCreateAndAssignLabelOnProjectCustomers);
/**
 * Batch Unassign Labels From Project Customers
 */ parcelHelpers.export(exports, "batchUnassignLabelsFromProjectCustomers", ()=>batchUnassignLabelsFromProjectCustomers);
/**
 * Generate Attachment Upload Id And Url
 */ parcelHelpers.export(exports, "generateAttachmentUploadIdAndUrl", ()=>generateAttachmentUploadIdAndUrl);
/**
 * List Users
 */ parcelHelpers.export(exports, "getAllUsersAndGroups", ()=>getAllUsersAndGroups);
/**
 * Create User
 */ parcelHelpers.export(exports, "createUser", ()=>createUser);
/**
 * Update User
 */ parcelHelpers.export(exports, "updateUser", ()=>updateUser);
/**
 * List Labels
 */ parcelHelpers.export(exports, "getAllLabels", ()=>getAllLabels);
/**
 * Create Label
 */ parcelHelpers.export(exports, "createLabel", ()=>createLabel);
/**
 * Delete Label
 */ parcelHelpers.export(exports, "deleteLabel", ()=>deleteLabel);
/**
 * Update Label
 */ parcelHelpers.export(exports, "updateLabel", ()=>updateLabel);
/**
 * Get All Industry Codes
 */ parcelHelpers.export(exports, "listAllIndustryCodes", ()=>listAllIndustryCodes);
/**
 * List Questionnaires
 */ parcelHelpers.export(exports, "listQuestionnaires", ()=>listQuestionnaires);
/**
 * Create Questionnaire
 */ parcelHelpers.export(exports, "createQuestionnaire", ()=>createQuestionnaire);
/**
 * Questionnaires Summary
 */ parcelHelpers.export(exports, "getQuestionnairesSummary", ()=>getQuestionnairesSummary);
/**
 * Get Questionnaire
 */ parcelHelpers.export(exports, "getQuestionnaire", ()=>getQuestionnaire);
/**
 * Update Questionnaire
 */ parcelHelpers.export(exports, "updateQuestionnaire", ()=>updateQuestionnaire);
/**
 * Archive Questionnaire
 */ parcelHelpers.export(exports, "archiveQuestionnaire", ()=>archiveQuestionnaire);
/**
 * Generate Questionnaire Preview Request
 */ parcelHelpers.export(exports, "generateQuestionnairePreviewRequest", ()=>generateQuestionnairePreviewRequest);
/**
 * Get Measure Configs
 */ parcelHelpers.export(exports, "getGlobalMeasureConfigs", ()=>getGlobalMeasureConfigs);
/**
 * Create Measure Config
 */ parcelHelpers.export(exports, "createGlobalMeasureConfig", ()=>createGlobalMeasureConfig);
/**
 * Update Measure Config
 */ parcelHelpers.export(exports, "updateGlobalMeasureConfig", ()=>updateGlobalMeasureConfig);
/**
 * Archive Measure Config
 */ parcelHelpers.export(exports, "archiveGlobalMeasureConfig", ()=>archiveGlobalMeasureConfig);
/**
 * Move Measure Config
 */ parcelHelpers.export(exports, "moveGlobalMeasureConfig", ()=>moveGlobalMeasureConfig);
/**
 * Get Follow Up Settings
 */ parcelHelpers.export(exports, "getFollowUpSettings", ()=>getFollowUpSettings);
/**
 * Update Follow Up Settings
 */ parcelHelpers.export(exports, "updateFollowUpSettings", ()=>updateFollowUpSettings);
/**
 * Get Customer Notification Settings
 */ parcelHelpers.export(exports, "getCustomerNotificationSettings", ()=>getCustomerNotificationSettings);
/**
 * Update Customer Notification Settings
 */ parcelHelpers.export(exports, "updateCustomerNotificationSettings", ()=>updateCustomerNotificationSettings);
/**
 * Get Person Onboarding Settings
 */ parcelHelpers.export(exports, "getPersonOnboardingSettings", ()=>getPersonOnboardingSettings);
/**
 * Update Person Onboarding Settings
 */ parcelHelpers.export(exports, "updatePersonOnboardingSettings", ()=>updatePersonOnboardingSettings);
/**
 * Update Review Settings
 */ parcelHelpers.export(exports, "updateReviewSettings", ()=>updateReviewSettings);
/**
 * Get All Review Checklists
 */ parcelHelpers.export(exports, "getReviewChecklists", ()=>getReviewChecklists);
/**
 * Create Review Checklist
 */ parcelHelpers.export(exports, "createReviewChecklist", ()=>createReviewChecklist);
/**
 * Get Review Checklist
 */ parcelHelpers.export(exports, "getReviewChecklist", ()=>getReviewChecklist);
/**
 * Update Review Checklist
 */ parcelHelpers.export(exports, "updateReviewChecklist", ()=>updateReviewChecklist);
/**
 * Archive Review Checklist
 */ parcelHelpers.export(exports, "archiveReviewChecklist", ()=>archiveReviewChecklist);
/**
 * Restore Review Checklist
 */ parcelHelpers.export(exports, "restoreReviewChecklist", ()=>restoreReviewChecklist);
/**
 * Get Review Guideline
 */ parcelHelpers.export(exports, "getReviewGuideline", ()=>getReviewGuideline);
/**
 * Update Review Guideline
 */ parcelHelpers.export(exports, "updateReviewGuideline", ()=>updateReviewGuideline);
/**
 * Get Disclosure Settings
 */ parcelHelpers.export(exports, "getDisclosureSettings", ()=>getDisclosureSettings);
/**
 * Update Disclosure Settings
 */ parcelHelpers.export(exports, "updateDisclosureSettings", ()=>updateDisclosureSettings);
/**
 * Preview Disclosure Settings
 */ parcelHelpers.export(exports, "previewDisclosureSettings", ()=>previewDisclosureSettings);
/**
 * Get Dashboard
 */ parcelHelpers.export(exports, "getDashboard", ()=>getDashboard);
/**
 * Get Assignment Industries
 */ parcelHelpers.export(exports, "getAssignmentIndustries", ()=>getAssignmentIndustries);
/**
 * Auth verification
 */ parcelHelpers.export(exports, "getWhoAmI", ()=>getWhoAmI);
/**
 * User auth
 */ parcelHelpers.export(exports, "getLoggedInUser", ()=>getLoggedInUser);
/**
 * Generate Hubspot Identification Token
 */ parcelHelpers.export(exports, "generateHubspotIdentificationToken", ()=>generateHubspotIdentificationToken);
/**
 * Lookup Postal Code
 */ parcelHelpers.export(exports, "lookupPostalCode", ()=>lookupPostalCode);
/**
 * Get Status Message List
 */ parcelHelpers.export(exports, "getStatusMessageList", ()=>getStatusMessageList);
var _runtime = require("oazapfts/lib/runtime");
var _query = require("oazapfts/lib/runtime/query");
const defaults = {
    baseUrl: "/"
};
const oazapfts = _runtime.runtime(defaults);
const servers = {};
function startPersonOnboarding(personOnboarding, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/onboarding/person", oazapfts.json({
        ...opts,
        method: "POST",
        body: personOnboarding
    })));
}
function completeCompanyOnboarding(companyOnboarding, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/onboarding/company", oazapfts.json({
        ...opts,
        method: "POST",
        body: companyOnboarding
    })));
}
function getCustomerByExternalId(externalId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v1/customers/external-id/${encodeURIComponent(externalId)}`, {
        ...opts
    }));
}
function deleteCustomerByExternalId(externalId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v1/customers/external-id/${encodeURIComponent(externalId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function getCustomerByNationalId(getCustomerByNationalIdRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v1/customers/national-id", oazapfts.json({
        ...opts,
        method: "POST",
        body: getCustomerByNationalIdRequest
    })));
}
function getCustomerUpdates(customerId, start, end, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v1/customers/${encodeURIComponent(customerId)}/updates${_query.query(_query.explode({
        start,
        end
    }))}`, {
        ...opts
    }));
}
function getOrganizationUpdates(start, end, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v1/organizations/updates${_query.query(_query.explode({
        start,
        end
    }))}`, {
        ...opts
    }));
}
function getInternalKycPreviewLink({ subjectId } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/disclosures/kyc_preview_link${_query.query(_query.explode({
        subject_id: subjectId
    }))}`, {
        ...opts
    }));
}
function getDisclosurePreviewLink(signaturePreviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/disclosures/kyc_disclosure_preview_link", oazapfts.json({
        ...opts,
        method: "POST",
        body: signaturePreviewRequest
    })));
}
function getCompanyInfo(country, nationalId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/lookup/company/${encodeURIComponent(country)}/${encodeURIComponent(nationalId)}/info`, {
        ...opts
    }));
}
function getCompanyOwnership(country, nationalId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/lookup/company/${encodeURIComponent(country)}/${encodeURIComponent(nationalId)}/ownership`, {
        ...opts
    }));
}
function getCompanyRoles(country, nationalId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/lookup/company/${encodeURIComponent(country)}/${encodeURIComponent(nationalId)}/roles`, {
        ...opts
    }));
}
function getCountryRiskAndTaxHavens({ date, source } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/lookup/risk-countries${_query.query(_query.explode({
        date,
        source
    }))}`, {
        ...opts
    }));
}
function getIndustryRisk(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/lookup/risk-industries", {
        ...opts
    }));
}
function createCompanyCustomer(createCompanyCustomerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/companies", oazapfts.json({
        ...opts,
        method: "POST",
        body: createCompanyCustomerRequest
    })));
}
function createPersonCustomer(createPersonCustomerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/persons", oazapfts.json({
        ...opts,
        method: "POST",
        body: createPersonCustomerRequest
    })));
}
function getPersonCustomerDetails(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
function updatePerson(uuid, updatePersonCustomerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updatePersonCustomerRequest
    })));
}
function getCompanyScreeningConfiguration(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening`, {
        ...opts
    }));
}
function updateCompanyScreeningConfiguration(uuid, putCompanyScreeningConfigurationRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: putCompanyScreeningConfigurationRequest
    })));
}
function stopCompanyScreeningConfiguration(uuid, patchCompanyScreeningConfigurationRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchCompanyScreeningConfigurationRequest
    })));
}
function stopCompanyScreening(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening/stop`, {
        ...opts,
        method: "PUT"
    }));
}
function stopPersonScreening(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening/stop`, {
        ...opts,
        method: "PUT"
    }));
}
function getPersonScreeningConfiguration(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening`, {
        ...opts
    }));
}
function updatePersonScreeningConfiguration(uuid, personScreeningConfigurationRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: personScreeningConfigurationRequest
    })));
}
function setPersonScreeningConfiguration(uuid, personScreeningConfigurationRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: personScreeningConfigurationRequest
    })));
}
function getCompanySignatureConfiguration(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/signatures`, {
        ...opts
    }));
}
function updateCompanySignatureConfiguration(uuid, putCompanySignatureConfigurationRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: putCompanySignatureConfigurationRequest
    })));
}
function remindSigner(uuid, signatureUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureUuid)}/remind`, {
        ...opts,
        method: "POST"
    }));
}
function getFileDownloadUrl(fileUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/get_download_url/${encodeURIComponent(fileUuid)}`, {
        ...opts
    }));
}
function getCustomers({ limit, offset, $type, status, riskLevel, responsibleIds, responsibleUsers, ordering, createdAfter, createdBefore, screeningType, countryCode, labels, followUpAfter, followUpBefore, hasPendingDisclosures, hasPendingAttachments, hasPendingAssignments, q, industryCodes, isPep, isSanctioned, isArchived, unhandledOwnershipUpdates, isFollowUpExpired, hasUnresolvedCases, hasPendingMeasures, hasPendingTasks } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${_query.query(_query.explode({
        limit,
        offset,
        "type": $type,
        status,
        risk_level: riskLevel,
        responsible_ids: responsibleIds,
        responsible_users: responsibleUsers,
        ordering,
        created_after: createdAfter,
        created_before: createdBefore,
        screening_type: screeningType,
        country_code: countryCode,
        labels,
        follow_up_after: followUpAfter,
        follow_up_before: followUpBefore,
        has_pending_disclosures: hasPendingDisclosures,
        has_pending_attachments: hasPendingAttachments,
        has_pending_assignments: hasPendingAssignments,
        q,
        industry_codes: industryCodes,
        is_pep: isPep,
        is_sanctioned: isSanctioned,
        is_archived: isArchived,
        unhandled_ownership_updates: unhandledOwnershipUpdates,
        is_follow_up_expired: isFollowUpExpired,
        has_unresolved_cases: hasUnresolvedCases,
        has_pending_measures: hasPendingMeasures,
        has_pending_tasks: hasPendingTasks
    }))}`, {
        ...opts
    }));
}
function getCustomerCounts({ limit, offset, $type, status, riskLevel, responsibleIds, responsibleUsers, ordering, createdAfter, createdBefore, screeningType, countryCode, labels, followUpAfter, followUpBefore, hasPendingDisclosures, hasPendingAttachments, hasPendingAssignments, q, industryCodes, isPep, isSanctioned, isArchived, unhandledOwnershipUpdates, isFollowUpExpired, hasUnresolvedCases, hasPendingMeasures, hasPendingTasks } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/counts${_query.query(_query.explode({
        limit,
        offset,
        "type": $type,
        status,
        risk_level: riskLevel,
        responsible_ids: responsibleIds,
        responsible_users: responsibleUsers,
        ordering,
        created_after: createdAfter,
        created_before: createdBefore,
        screening_type: screeningType,
        country_code: countryCode,
        labels,
        follow_up_after: followUpAfter,
        follow_up_before: followUpBefore,
        has_pending_disclosures: hasPendingDisclosures,
        has_pending_attachments: hasPendingAttachments,
        has_pending_assignments: hasPendingAssignments,
        q,
        industry_codes: industryCodes,
        is_pep: isPep,
        is_sanctioned: isSanctioned,
        is_archived: isArchived,
        unhandled_ownership_updates: unhandledOwnershipUpdates,
        is_follow_up_expired: isFollowUpExpired,
        has_unresolved_cases: hasUnresolvedCases,
        has_pending_measures: hasPendingMeasures,
        has_pending_tasks: hasPendingTasks
    }))}`, {
        ...opts
    }));
}
function getCustomerDetails(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
function archiveCustomer(uuid, { purge } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}${_query.query(_query.explode({
        purge
    }))}`, {
        ...opts,
        method: "DELETE"
    }));
}
function updateCustomerDetails(uuid, updateCustomerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateCustomerRequest
    })));
}
function getCompanyCustomerDetails(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
function updateCompanyCustomer(uuid, updateCompanyCustomerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateCompanyCustomerRequest
    })));
}
function quickReviewCompanyInfoUpdate(uuid, infoUpdateId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/info-updates/${encodeURIComponent(infoUpdateId)}/quick-review`, {
        ...opts,
        method: "POST"
    }));
}
function getCustomerMatches(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/matches`, {
        ...opts
    }));
}
function getCustomerMatchDetails(uuid, matchId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/matches/${encodeURIComponent(matchId)}`, {
        ...opts
    }));
}
function getCustomerMatchCases(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/match-cases`, {
        ...opts
    }));
}
function getCustomerMatchCaseDetails(uuid, caseId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/match-cases/${encodeURIComponent(caseId)}`, {
        ...opts
    }));
}
function createMatchReview(uuid, caseId, createMatchReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/match-cases/${encodeURIComponent(caseId)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createMatchReviewRequest
    })));
}
function createCustomerReview(uuid, createCustomerReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createCustomerReviewRequest
    })));
}
function updateCustomerReview(uuid, reviewUuid, updateCustomerReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateCustomerReviewRequest
    })));
}
function createDraftCustomerReview(uuid, createDraftCustomerReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/draft_reviews/`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createDraftCustomerReviewRequest
    })));
}
function updateDraftCustomerReview(uuid, reviewUuid, updateDraftCustomerReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/draft_reviews/${encodeURIComponent(reviewUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateDraftCustomerReviewRequest
    })));
}
function deleteCustomerReview(uuid, reviewId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function approveCustomerReview(uuid, reviewUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/approve`, {
        ...opts,
        method: "POST"
    }));
}
function rejectCustomerReview(uuid, reviewUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/reject`, {
        ...opts,
        method: "POST"
    }));
}
function addCustomerReviewMeasure(uuid, reviewUuid, createMeasureRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createMeasureRequest
    })));
}
function updateCustomerReviewMeasure(uuid, reviewUuid, measureUuid, updateMeasureRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures/${encodeURIComponent(measureUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateMeasureRequest
    })));
}
function removeCustomerReviewMeasure(uuid, reviewUuid, measureUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures/${encodeURIComponent(measureUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function moveCustomerReviewMeasure(uuid, reviewUuid, measureUuid, moveMeasureRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/reviews/${encodeURIComponent(reviewUuid)}/measures/${encodeURIComponent(measureUuid)}/move`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: moveMeasureRequest
    })));
}
function startCompanyScreening(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/screening/start`, {
        ...opts,
        method: "POST"
    }));
}
function startPersonScreening(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/screening/start`, {
        ...opts,
        method: "POST"
    }));
}
function finishOnboarding(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/onboarding/finish`, {
        ...opts,
        method: "POST"
    }));
}
function cancelOnboarding(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/onboarding/cancel`, {
        ...opts,
        method: "POST"
    }));
}
function createCompanyRole(uuid, createRoleRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/roles`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createRoleRequest
    })));
}
function syncCompanyRole(uuid, syncRoleRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/sync_role`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: syncRoleRequest
    })));
}
function syncCompanyOwner(uuid, syncOwnerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/sync_owner`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: syncOwnerRequest
    })));
}
function deleteCompanyRole(uuid, roleId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/roles/${encodeURIComponent(roleId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function updateCompanyRole(uuid, roleId, updateRoleRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/roles/${encodeURIComponent(roleId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateRoleRequest
    })));
}
function createCompanyOwner(uuid, createOwnerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/owners`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createOwnerRequest
    })));
}
function deleteCompanyOwner(uuid, ownerId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/owners/${encodeURIComponent(ownerId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function updateCompanyOwner(uuid, ownerId, updateOwnerRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/owners/${encodeURIComponent(ownerId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateOwnerRequest
    })));
}
function getPersonSignatureConfiguration(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/signatures`, {
        ...opts
    }));
}
function setPersonSignatureConfiguration(uuid, patchPersonSignatureConfigurationRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: patchPersonSignatureConfigurationRequest
    })));
}
function updatePersonSignature(uuid, signatureId, updateSignatureRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateSignatureRequest
    })));
}
function updateCompanySignature(uuid, signatureId, updateSignatureRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureId)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateSignatureRequest
    })));
}
function createCompanyCustomerMatchReview(uuid, caseId, createMatchReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/match-cases/${encodeURIComponent(caseId)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createMatchReviewRequest
    })));
}
function deleteCustomerSignature(uuid, signatureId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/signatures/${encodeURIComponent(signatureId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function getCustomerReport(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/report`, {
        ...opts
    }));
}
function getScreeningReport(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/screening_report`, {
        ...opts
    }));
}
function createCompanyCustomerDisclosureDocument(uuid, createCompanyCustomerDisclosureDocumentRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/disclosure-documents`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createCompanyCustomerDisclosureDocumentRequest
    })));
}
function createPersonCustomerDisclosureDocument(uuid, createPersonCustomerDisclosureDocumentRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/persons/${encodeURIComponent(uuid)}/disclosure-documents`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createPersonCustomerDisclosureDocumentRequest
    })));
}
function downloadCustomerAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/download`, {
        ...opts
    }));
}
function getCustomerAttachments(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments`, {
        ...opts
    }));
}
function addCustomerAttachment(uuid, createAttachmentMetadataRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAttachmentMetadataRequest
    })));
}
function deleteCustomerAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function getAttachmentSignatures(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, {
        ...opts
    }));
}
function updateAttachmentSignatures(uuid, attachmentUuid, updateAttachmentSignaturesRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateAttachmentSignaturesRequest
    })));
}
function downloadSignedCustomerAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts
    }));
}
function deleteSignedCustomerAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts,
        method: "DELETE"
    }));
}
function batchSetFollowUpDateOnCustomers(batchSetFollowUpDateOnCustomersRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/follow_up_date", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchSetFollowUpDateOnCustomersRequest
    })));
}
function batchSetResponsibleUsersOnCustomers(batchSetResponsibleUsersOnCustomers, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/responsible_users", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchSetResponsibleUsersOnCustomers
    })));
}
function archiveCustomers(batchCustomersRequestBase, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/archive", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchCustomersRequestBase
    })));
}
function deleteCustomers(batchCustomersRequestBase, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/delete", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchCustomersRequestBase
    })));
}
function restoreCustomers(batchCustomersRequestBase, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/restore", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: batchCustomersRequestBase
    })));
}
function batchAssignLabelsToCustomers(labelsOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/assign-label", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
function batchSetLabelsOnCustomers(labelsOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/set-label", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
function batchCreateAndAssignLabelOnCustomers(titleOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/create-and-assign-label", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: titleOnTargets
    })));
}
function batchUnassignLabelsFromCustomers(labelsOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/customers/batch/unassign-labels", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
function confirmOwnershipUpdate(uuid, updateId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/ownership_updates/${encodeURIComponent(updateId)}/confirm`, {
        ...opts,
        method: "POST"
    }));
}
function rejectOwnershipUpdate(uuid, updateId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/ownership_updates/${encodeURIComponent(updateId)}/reject`, {
        ...opts,
        method: "POST"
    }));
}
function confirmAllOwnershipUpdates(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(uuid)}/ownership_updates/confirm_all`, {
        ...opts,
        method: "POST"
    }));
}
function createCustomerAssignment(customerUuid, createOrUpdateAssignmentRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createOrUpdateAssignmentRequest
    })));
}
function getCustomerAssignmentDetails(customerUuid, assignmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}`, {
        ...opts
    }));
}
function updateCustomerAssignment(customerUuid, assignmentUuid, createOrUpdateAssignmentRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: createOrUpdateAssignmentRequest
    })));
}
function archiveCustomerAssignment(customerUuid, assignmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function restoreCustomerAssignment(customerUuid, assignmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/restore`, {
        ...opts,
        method: "POST"
    }));
}
function createCustomerAssignmentReview(customerUuid, assignmentUuid, createAssignmentReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAssignmentReviewRequest
    })));
}
function downloadCustomerAssignmentAttachment(customerUuid, assignmentUuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/download`, {
        ...opts
    }));
}
function getCustomerAssignmentAttachments(customerUuid, assignmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments`, {
        ...opts
    }));
}
function addCustomerAssignmentAttachment(customerUuid, assignmentUuid, createAttachmentMetadataRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAttachmentMetadataRequest
    })));
}
function deleteCustomerAssignmentAttachment(customerUuid, assignmentUuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function getCustomerAssignmentAttachmentSignatures(customerUuid, assignmentUuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, {
        ...opts
    }));
}
function updateCustomerAssignmentAttachmentSignatures(customerUuid, assignmentUuid, attachmentUuid, updateAttachmentSignaturesRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateAttachmentSignaturesRequest
    })));
}
function downloadSignedCustomerAssignmentAttachment(customerUuid, assignmentUuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts
    }));
}
function deleteSignedCustomerAssignmentAttachment(customerUuid, assignmentUuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/assignments/${encodeURIComponent(assignmentUuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts,
        method: "DELETE"
    }));
}
function getCustomerOwnershipTree(customerUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerUuid)}/ownership_tree`, {
        ...opts
    }));
}
function getCompanyOwnershipTree(companyUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/companies/${encodeURIComponent(companyUuid)}/ownership_tree`, {
        ...opts
    }));
}
function listCustomerNotations(customerId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/notations`, {
        ...opts
    }));
}
function createCustomerNotation(customerId, baseNotation, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/notations`, oazapfts.json({
        ...opts,
        method: "POST",
        body: baseNotation
    })));
}
function getCustomerNotation(customerId, notationId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts
    }));
}
function updateCustomerNotation(customerId, notationId, baseNotation, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/notations/${encodeURIComponent(notationId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: baseNotation
    })));
}
function deleteCustomerNotation(customerId, notationId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function listCustomerReviewNotations(customerId, reviewId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations`, {
        ...opts
    }));
}
function createCustomerReviewNotation(customerId, reviewId, baseNotation, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations`, oazapfts.json({
        ...opts,
        method: "POST",
        body: baseNotation
    })));
}
function getCustomerReviewNotation(customerId, reviewId, notationId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts
    }));
}
function updateCustomerReviewNotation(customerId, reviewId, notationId, baseNotation, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations/${encodeURIComponent(notationId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: baseNotation
    })));
}
function deleteCustomerReviewNotation(customerId, reviewId, notationId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/reviews/${encodeURIComponent(reviewId)}/notations/${encodeURIComponent(notationId)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function listKarLookups(customerId, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/kar_lookup`, {
        ...opts
    }));
}
function createKarLookup(customerId, karLookupRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/customers/${encodeURIComponent(customerId)}/kar_lookup`, oazapfts.json({
        ...opts,
        method: "POST",
        body: karLookupRequest
    })));
}
function getProjects({ limit, offset, status, q, responsibleIds, responsibleUsers, createdAfter, createdBefore, ordering, isVitec } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${_query.query(_query.explode({
        limit,
        offset,
        status,
        q,
        responsible_ids: responsibleIds,
        responsible_users: responsibleUsers,
        created_after: createdAfter,
        created_before: createdBefore,
        ordering,
        is_vitec: isVitec
    }))}`, {
        ...opts
    }));
}
function createProject(createProjectRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/projects/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createProjectRequest
    })));
}
function getProject(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
function updateProject(uuid, updateProjectRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateProjectRequest
    })));
}
function getProjectCustomersDetails(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/customers`, {
        ...opts
    }));
}
function createProjectReview(uuid, createProjectReviewRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/reviews`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createProjectReviewRequest
    })));
}
function getProjectAttachments(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments`, {
        ...opts
    }));
}
function addProjectAttachment(uuid, createAttachmentMetadataRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createAttachmentMetadataRequest
    })));
}
function downloadProjectAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/download`, {
        ...opts
    }));
}
function deleteProjectAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function getProjectAttachmentSignatures(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, {
        ...opts
    }));
}
function updateProjectAttachmentSignatures(uuid, attachmentUuid, updateAttachmentSignaturesRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signatures`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateAttachmentSignaturesRequest
    })));
}
function downloadSignedProjectAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts
    }));
}
function deleteSignedProjectAttachment(uuid, attachmentUuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(uuid)}/attachments/${encodeURIComponent(attachmentUuid)}/signed_document`, {
        ...opts,
        method: "DELETE"
    }));
}
function batchAssignLabelsToProjectCustomers(projectUuid, labelsOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-assign-label-to-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
function batchSetLabelsOnProjectCustomers(projectUuid, labelsOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-set-label-on-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
function batchCreateAndAssignLabelOnProjectCustomers(projectUuid, titleOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-create-and-assign-label-on-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: titleOnTargets
    })));
}
function batchUnassignLabelsFromProjectCustomers(projectUuid, labelsOnTargets, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/projects/${encodeURIComponent(projectUuid)}/batch-unassign-labels-from-customers`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelsOnTargets
    })));
}
function generateAttachmentUploadIdAndUrl(attachmentUploadRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/attachments/upload", oazapfts.json({
        ...opts,
        method: "POST",
        body: attachmentUploadRequest
    })));
}
function getAllUsersAndGroups(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/users/", {
        ...opts
    }));
}
function createUser(createUserRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/users/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createUserRequest
    })));
}
function updateUser(uuid, updateUserRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/users/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateUserRequest
    })));
}
function getAllLabels({ q } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/labels/${_query.query(_query.explode({
        q
    }))}`, {
        ...opts
    }));
}
function createLabel(labelData, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/labels/", oazapfts.json({
        ...opts,
        method: "POST",
        body: labelData
    })));
}
function deleteLabel(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/labels/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function updateLabel(uuid, labelData, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/labels/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: labelData
    })));
}
function listAllIndustryCodes(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/labels/industry-codes/", {
        ...opts
    }));
}
function listQuestionnaires(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/questionnaires/", {
        ...opts
    }));
}
function createQuestionnaire(createQuestionnaireRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/questionnaires/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createQuestionnaireRequest
    })));
}
function getQuestionnairesSummary(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/questionnaires/summary", {
        ...opts
    }));
}
function getQuestionnaire(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/questionnaires/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
function updateQuestionnaire(uuid, updateQuestionnaireRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/questionnaires/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateQuestionnaireRequest
    })));
}
function archiveQuestionnaire(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/questionnaires/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function generateQuestionnairePreviewRequest(createQuestionnaireRequest, { customerType } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/questionnaires/preview${_query.query(_query.explode({
        customer_type: customerType
    }))}`, oazapfts.json({
        ...opts,
        method: "POST",
        body: createQuestionnaireRequest
    })));
}
function getGlobalMeasureConfigs(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/measures/", {
        ...opts
    }));
}
function createGlobalMeasureConfig(createUpdateGlobalMeasureConfigRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/measures/", oazapfts.json({
        ...opts,
        method: "POST",
        body: createUpdateGlobalMeasureConfigRequest
    })));
}
function updateGlobalMeasureConfig(uuid, createUpdateGlobalMeasureConfigRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/measures/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: createUpdateGlobalMeasureConfigRequest
    })));
}
function archiveGlobalMeasureConfig(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/measures/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function moveGlobalMeasureConfig(uuid, moveMeasureRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/measures/${encodeURIComponent(uuid)}/move`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: moveMeasureRequest
    })));
}
function getFollowUpSettings(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/follow_up", {
        ...opts
    }));
}
function updateFollowUpSettings(updateFollowUpSettingsRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/follow_up", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateFollowUpSettingsRequest
    })));
}
function getCustomerNotificationSettings(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/customer_notifications", {
        ...opts
    }));
}
function updateCustomerNotificationSettings(updateCustomerNotificationSettingsRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/customer_notifications", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateCustomerNotificationSettingsRequest
    })));
}
function getPersonOnboardingSettings(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/onboarding/person", {
        ...opts
    }));
}
function updatePersonOnboardingSettings(updatePersonOnboardingSettingsRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/onboarding/person", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updatePersonOnboardingSettingsRequest
    })));
}
function updateReviewSettings(updateReviewSettingsRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/review", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: updateReviewSettingsRequest
    })));
}
function getReviewChecklists(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/review/checklists", {
        ...opts
    }));
}
function createReviewChecklist(createReviewChecklistRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/review/checklists", oazapfts.json({
        ...opts,
        method: "POST",
        body: createReviewChecklistRequest
    })));
}
function getReviewChecklist(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}`, {
        ...opts
    }));
}
function updateReviewChecklist(uuid, createReviewChecklistRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: createReviewChecklistRequest
    })));
}
function archiveReviewChecklist(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}`, {
        ...opts,
        method: "DELETE"
    }));
}
function restoreReviewChecklist(uuid, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/organizations/settings/review/checklists/${encodeURIComponent(uuid)}/restore`, {
        ...opts,
        method: "POST"
    }));
}
function getReviewGuideline(customerType, { timestamp } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/organizations/settings/review-guideline/${encodeURIComponent(customerType)}${_query.query(_query.explode({
        timestamp
    }))}`, {
        ...opts
    }));
}
function updateReviewGuideline(customerType, updateReviewGuidelineRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/organizations/settings/review-guideline/${encodeURIComponent(customerType)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateReviewGuidelineRequest
    })));
}
function getDisclosureSettings(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/disclosure", {
        ...opts
    }));
}
function updateDisclosureSettings(updateDisclosureSettingsRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/disclosure", oazapfts.json({
        ...opts,
        method: "PUT",
        body: updateDisclosureSettingsRequest
    })));
}
function previewDisclosureSettings(disclosureSettings, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/organizations/settings/disclosure/preview", oazapfts.json({
        ...opts,
        method: "POST",
        body: disclosureSettings
    })));
}
function getDashboard({ includeArchivedCustomers, interval, customerType, startDate, endDate, project, labelIds, responsibleUserIds } = {}, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/v2/dashboard/${_query.query(_query.explode({
        include_archived_customers: includeArchivedCustomers,
        interval,
        customer_type: customerType,
        start_date: startDate,
        end_date: endDate,
        project,
        label_ids: labelIds,
        responsible_user_ids: responsibleUserIds
    }))}`, {
        ...opts
    }));
}
function getAssignmentIndustries(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/v2/assignments/industries", {
        ...opts
    }));
}
function getWhoAmI(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/auth/whoami", {
        ...opts
    }));
}
function getLoggedInUser(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/auth/user", {
        ...opts
    }));
}
function generateHubspotIdentificationToken(hubspotIdentificationTokenGenerationRequest, opts) {
    return oazapfts.ok(oazapfts.fetchJson("/hubspot/token", oazapfts.json({
        ...opts,
        method: "POST",
        body: hubspotIdentificationTokenGenerationRequest
    })));
}
function lookupPostalCode(country, q, opts) {
    return oazapfts.ok(oazapfts.fetchJson(`/bring/lookup-postal-code${_query.query(_query.explode({
        country,
        q
    }))}`, {
        ...opts
    }));
}
function getStatusMessageList(opts) {
    return oazapfts.ok(oazapfts.fetchJson("/service/status-message/", {
        ...opts
    }));
}

},{"oazapfts/lib/runtime":"glYYY","oazapfts/lib/runtime/query":"jOzON","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"glYYY":[function(require,module,exports) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.runtime = void 0;
const qs = __importStar(require("e2d5df4a28e01285"));
const util_1 = require("72b2f40fdf088d3a");
const __1 = require("aec35cafd3912e5e");
function runtime(defaults) {
    function fetchText(url, req) {
        return __awaiter(this, void 0, void 0, function*() {
            const res = yield doFetch(url, req);
            let data;
            try {
                data = yield res.text();
            } catch (err) {}
            return {
                status: res.status,
                headers: res.headers,
                contentType: res.headers.get("content-type"),
                data
            };
        });
    }
    function fetchJson(url, req = {}) {
        return __awaiter(this, void 0, void 0, function*() {
            const { status, headers, contentType, data } = yield fetchText(url, Object.assign(Object.assign({}, req), {
                headers: Object.assign({
                    Accept: "application/json"
                }, req.headers)
            }));
            const isJson = contentType ? contentType.includes("json") : false;
            if (isJson) return {
                status,
                headers,
                data: data ? JSON.parse(data) : null
            };
            return {
                status,
                headers,
                data
            };
        });
    }
    function fetchBlob(url, req = {}) {
        return __awaiter(this, void 0, void 0, function*() {
            const res = yield doFetch(url, req);
            let data;
            try {
                data = yield res.blob();
            } catch (err) {}
            return {
                status: res.status,
                headers: res.headers,
                data
            };
        });
    }
    function doFetch(url, req = {}) {
        return __awaiter(this, void 0, void 0, function*() {
            const _a = Object.assign(Object.assign({}, defaults), req), { baseUrl, headers, fetch: customFetch } = _a, init = __rest(_a, [
                "baseUrl",
                "headers",
                "fetch"
            ]);
            const href = (0, util_1.joinUrl)(baseUrl, url);
            const res = yield (customFetch || fetch)(href, Object.assign(Object.assign({}, init), {
                headers: (0, util_1.stripUndefined)(Object.assign(Object.assign({}, defaults.headers), headers))
            }));
            return res;
        });
    }
    /* TODO: maybe we want to get rid of this checks (ensureJsonContentType & ensureFormContentType)
    in a future major release (ref https://github.com/oazapfts/oazapfts/pull/456) */ function ensureJsonContentType(contentTypeHeader) {
        return (contentTypeHeader === null || contentTypeHeader === void 0 ? void 0 : contentTypeHeader.match(/\bjson\b/i)) ? contentTypeHeader : "application/json";
    }
    function ensureFormContentType(contentTypeHeader) {
        return (contentTypeHeader === null || contentTypeHeader === void 0 ? void 0 : contentTypeHeader.startsWith("application/x-www-form-urlencoded")) ? contentTypeHeader : "application/x-www-form-urlencoded";
    }
    function ensureMultipartContentType(contentTypeHeader) {
        return (contentTypeHeader === null || contentTypeHeader === void 0 ? void 0 : contentTypeHeader.startsWith("multipart/form-data")) ? contentTypeHeader : "multipart/form-data";
    }
    return {
        ok: __1.ok,
        fetchText,
        fetchJson,
        fetchBlob,
        json (_a) {
            var { body, headers } = _a, req = __rest(_a, [
                "body",
                "headers"
            ]);
            return Object.assign(Object.assign(Object.assign({}, req), body != null && {
                body: JSON.stringify(body)
            }), {
                headers: Object.assign(Object.assign({}, headers), {
                    "Content-Type": ensureJsonContentType(String(headers === null || headers === void 0 ? void 0 : headers["Content-Type"]))
                })
            });
        },
        form (_a) {
            var { body, headers } = _a, req = __rest(_a, [
                "body",
                "headers"
            ]);
            return Object.assign(Object.assign(Object.assign({}, req), body != null && {
                body: qs.form(body)
            }), {
                headers: Object.assign(Object.assign({}, headers), {
                    "Content-Type": ensureFormContentType(String(headers === null || headers === void 0 ? void 0 : headers["Content-Type"]))
                })
            });
        },
        multipart (_a) {
            var { body, headers } = _a, req = __rest(_a, [
                "body",
                "headers"
            ]);
            if (body == null) return req;
            const data = new (defaults.formDataConstructor || req.formDataConstructor || FormData)();
            const append = (name, value)=>{
                if (typeof value === "string" || value instanceof Blob) data.append(name, value);
                else data.append(name, new Blob([
                    JSON.stringify(value)
                ], {
                    type: "application/json"
                }));
            };
            Object.entries(body).forEach(([name, value])=>{
                if (Array.isArray(value)) value.forEach((v)=>append(name, v));
                else append(name, value);
            });
            return Object.assign(Object.assign({}, req), {
                body: data,
                headers: Object.assign(Object.assign({}, headers), {
                    "Content-Type": ensureMultipartContentType(String(headers === null || headers === void 0 ? void 0 : headers["Content-Type"]))
                })
            });
        }
    };
}
exports.runtime = runtime;

},{"e2d5df4a28e01285":"jOzON","72b2f40fdf088d3a":"cOXRA","aec35cafd3912e5e":"cxkkw"}],"jOzON":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.space = exports.pipe = exports.form = exports.json = exports.explode = exports.deep = exports.query = void 0;
const util_1 = require("588e6e130bef5f0a");
/**
 * Join params using an ampersand and prepends a questionmark if not empty.
 */ function query(...params) {
    const s = params.filter(Boolean).join("&");
    return s && `?${s}`;
}
exports.query = query;
/**
 * Serializes nested objects according to the `deepObject` style specified in
 * https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.0.0.md#style-values
 */ function deep(params, [k, v] = util_1.encodeReserved) {
    const qk = (0, util_1.encode)([
        (s)=>s,
        k
    ]);
    const qv = (0, util_1.encode)([
        (s)=>s,
        v
    ]);
    // don't add index to arrays
    // https://github.com/expressjs/body-parser/issues/289
    const visit = (obj, prefix = "")=>Object.entries(obj).filter(([, v])=>v !== undefined).map(([prop, v])=>{
            const index = Array.isArray(obj) ? "" : prop;
            const key = prefix ? qk`${prefix}[${index}]` : prop;
            if (typeof v === "object") return visit(v, key);
            return qv`${key}=${v}`;
        }).join("&");
    return visit(params);
}
exports.deep = deep;
/**
 * Property values of type array or object generate separate parameters
 * for each value of the array, or key-value-pair of the map.
 * For other types of properties this property has no effect.
 * See https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.0.0.md#encoding-object
 */ function explode(params, encoders = util_1.encodeReserved) {
    const q = (0, util_1.encode)(encoders);
    return Object.entries(params).filter(([, value])=>value !== undefined).map(([name, value])=>{
        if (Array.isArray(value)) return value.map((v)=>q`${name}=${v}`).join("&");
        if (typeof value === "object") return explode(value, encoders);
        return q`${name}=${value}`;
    }).join("&");
}
exports.explode = explode;
function json(params, encoders = util_1.encodeReserved) {
    const q = (0, util_1.encode)(encoders);
    return Object.entries(params).filter(([, value])=>value !== undefined).map(([name, value])=>{
        const v = JSON.stringify(value);
        return q`${name}=${v}`;
    }).join("&");
}
exports.json = json;
exports.form = (0, util_1.delimited)();
exports.pipe = (0, util_1.delimited)("|");
exports.space = (0, util_1.delimited)("%20");

},{"588e6e130bef5f0a":"cOXRA"}],"cOXRA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.joinUrl = exports.stripUndefined = exports.delimited = exports.encode = exports.allowReserved = exports.encodeReserved = void 0;
// Encode param names and values as URIComponent
exports.encodeReserved = [
    encodeURIComponent,
    encodeURIComponent
];
exports.allowReserved = [
    encodeURIComponent,
    encodeURI
];
/**
 * Creates a tag-function to encode template strings with the given encoders.
 */ function encode(encoders, delimiter = ",") {
    const q = (v, i)=>{
        const encoder = encoders[i % encoders.length];
        if (typeof v === "undefined") return "";
        if (typeof v === "object") {
            if (Array.isArray(v)) return v.map(encoder).join(delimiter);
            const flat = Object.entries(v).reduce((flat, entry)=>[
                    ...flat,
                    ...entry
                ], []);
            return flat.map(encoder).join(delimiter);
        }
        return encoder(String(v));
    };
    return (strings, ...values)=>{
        return strings.reduce((prev, s, i)=>{
            return `${prev}${s}${q(values[i], i)}`;
        }, "");
    };
}
exports.encode = encode;
/**
 * Separate array values by the given delimiter.
 */ function delimited(delimiter = ",") {
    return (params, encoders = exports.encodeReserved)=>Object.entries(params).filter(([, value])=>value !== undefined).map(([name, value])=>encode(encoders, delimiter)`${name}=${value}`).join("&");
}
exports.delimited = delimited;
/**
 * Deeply remove all properties with undefined values.
 */ function stripUndefined(obj) {
    return obj && JSON.parse(JSON.stringify(obj));
}
exports.stripUndefined = stripUndefined;
function joinUrl(...parts) {
    return parts.filter(Boolean).map((s, i)=>i === 0 ? s : s.replace(/^\/+/, "")).map((s, i, a)=>i === a.length - 1 ? s : s.replace(/\/+$/, "")).join("/");
}
exports.joinUrl = joinUrl;

},{}],"cxkkw":[function(require,module,exports) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HttpError = exports.optimistic = exports.okify = exports.ok = exports.SUCCESS_CODES = exports.handle = void 0;
/**
 * Utility function to handle different status codes.
 *
 * Example:
 *
 * const userId = await handle(api.register({ email, password }), {
 *   200: (user: User) => user.id,
 *   400: (err: string) => console.log(err),
 * })
 **/ function handle(promise, handler) {
    return __awaiter(this, void 0, void 0, function*() {
        const { status, data, headers } = yield promise;
        const statusHandler = handler[status];
        if (statusHandler) return statusHandler(data);
        if (handler.default) return handler.default(status, data);
        throw new HttpError(status, data, headers);
    });
}
exports.handle = handle;
exports.SUCCESS_CODES = [
    200,
    201,
    202,
    204
];
/**
 * Utility function to directly return any successful response
 * and throw a HttpError otherwise.
 *
 * Example:
 *
 * try {
 *   const userId = await ok(api.register({ email, password }));
 * }
 * catch (err) {
 *   console.log(err.status)
 * }
 */ function ok(promise) {
    return __awaiter(this, void 0, void 0, function*() {
        const res = yield promise;
        if (exports.SUCCESS_CODES.some((s)=>s == res.status)) return res.data;
        throw new HttpError(res.status, res.data, res.headers);
    });
}
exports.ok = ok;
/**
 * Utility function to wrap an API function with `ok(...)`.
 */ function okify(fn) {
    return (...args)=>ok(fn(...args));
}
exports.okify = okify;
/**
 * Utility to `okify` each function of an API.
 */ function optimistic(api) {
    const okApi = {};
    Object.entries(api).forEach(([key, value])=>{
        okApi[key] = typeof value === "function" ? okify(value) : value;
    });
    return okApi;
}
exports.optimistic = optimistic;
class HttpError extends Error {
    constructor(status, data, headers){
        super(`Error: ${status}`);
        this.status = status;
        this.data = data;
        this.headers = headers;
    }
}
exports.HttpError = HttpError;

},{}],"g0N7C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CUSTOMERS_LIST_SEARCH", ()=>CUSTOMERS_LIST_SEARCH);
parcelHelpers.export(exports, "DASHBOARD_SEARCH", ()=>DASHBOARD_SEARCH);
parcelHelpers.export(exports, "NEW_CUSTOMER_REVIEW", ()=>NEW_CUSTOMER_REVIEW);
parcelHelpers.export(exports, "REDIRECT_TO_AFTER_LOGOUT_KEY", ()=>REDIRECT_TO_AFTER_LOGOUT_KEY);
const CUSTOMERS_LIST_SEARCH = "customers-list-search";
const DASHBOARD_SEARCH = "dashboard-search";
const NEW_CUSTOMER_REVIEW = "new-customer-review";
const REDIRECT_TO_AFTER_LOGOUT_KEY = "redirect-to-after-logout";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lpZZM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authSessionService", ()=>authSessionService);
var _react = require("@sentry/react");
var _numbersUtils = require("../../utils/numbersUtils");
var _authProviderHelpers = require("./AuthProvider.helpers");
/**
 * Interval for checking the user session and refreshing the API access token
 * if the user is active.
 *
 * Setting the interval to 45 seconds is reasonable as the access token will be
 * taken from the cache unless it's within 60 seconds of expiring (see
 * https://github.com/auth0/auth0-spa-js/blob/4c0c755c51781ed8da7cd43b0f33da1c9166b963/src/Auth0Client.ts#L1165),
 * in which case we will get a new token by calling Auth0's API.
 */ const CHECK_SESSION_INTERVAL_IN_MS = 45000;
/**
 * This service is initialized (and terminated) from `BeaufortAuthProvider`.
 *
 * This service is responsible for:
 * - Monitoring user activity using a `visibilityState`-event listener and an interval
 *    for regularly checking the session, refreshing the access token and redirecting
 *    to `/expired` if the user has been inactive for too long
 * - API fetch interceptor which gets API access token (usually from cache, or from Auth0
 *    if near expiry) before each request to the API
 */ class AuthSessionService {
    #getAccessTokenSilently = undefined;
    lastActive;
    checkSessionInterval;
    constructor(){
        this.getAccessTokenOrRedirectToExpired = this.getAccessTokenOrRedirectToExpired.bind(this);
        this.apiFetchInterceptor = this.apiFetchInterceptor.bind(this);
    }
    /**
   * Inits the auth session service. Called from `BeaufortAuthProvider`.
   * Sets `this.#getAccessTokenSilently` and `this.lastActive` and creates/starts
   * the visibilityState-event listener and `this.checkSessionInterval`
   */ init = (getAccessTokenSilently)=>{
        this.#getAccessTokenSilently = getAccessTokenSilently;
        // Set this.lastActive to now before creating the interval and event listener
        this.lastActive = new Date();
        document.addEventListener("visibilitychange", this.checkSessionOnVisibilityStateChange);
        if (!this.checkSessionInterval) this.checkSessionInterval = setInterval(()=>this.checkSession(), CHECK_SESSION_INTERVAL_IN_MS);
    };
    /**
   * "Terminate" the service by clearing its properties, event listener and interval.
   * Will be called when `BeaufortAuthProvider` unmounts
   */ terminate = ()=>{
        this.#getAccessTokenSilently = undefined;
        this.lastActive = undefined;
        document.removeEventListener("visibilitychange", this.checkSessionOnVisibilityStateChange);
        this.checkSessionInterval && clearInterval(this.checkSessionInterval);
    };
    /**
   * Checks if the user (tab) has been inactive for longer than the session lifetime
   * set in Auth0. Note that the session may still be active as the user may be
   * active in another tab, so the user should NOT be automatically logged out or redirected
   * to /expired. Instead, `this.getAccessTokenOrRedirectToExpired` should be called.
   *
   * (Auth0 recommends setting up a rolling timer that aligns with the maximum inactivity
   * lifetime of the Auth0 session. This should be the same as the value set in the Auth0 Dashboard:
   *  Settings -> Advanced -> Login Session Management -> Inactivity timeout
   * See https://auth0.com/docs/manage-users/sessions/session-lifetime-limits)
   */ hasExceededInactivityLifetime = ()=>{
        if (!this.lastActive) return false;
        if (!(0, _numbersUtils.isNumber)("30")) return false;
        const now = new Date();
        const userInactivityInMs = now.getTime() - this.lastActive.getTime();
        return userInactivityInMs >= "30" * 60000;
    };
    /**
   * This function is called every 45 seconds to check the auth/user session:
   * - If user is active, set lastActive to now and try to refresh the Auth0
   *    session + API access token
   * - If user is inactive, check if user has been inactive for longer than the
   *    Auth0's inactivity lifetime. If so, try to refresh the access token. This
   *    may still succeed, as the user may have been active in another tab. If not,
   *    the user will be redirected to /expired
   */ checkSession = ()=>{
        // Do nothing if already in /expired page
        if ((0, _authProviderHelpers.isInExpiredPage)()) return;
        if (document.visibilityState === "visible") {
            this.lastActive = new Date();
            this.getAccessTokenOrRedirectToExpired();
        } else if (this.hasExceededInactivityLifetime()) this.getAccessTokenOrRedirectToExpired();
    };
    /**
   * This function checks the user session every time the visibilityState, i.e.
   * the user activity, changes:
   * - If the user just became active, try to refresh access token. The user will
   *    be redirected to /expired if he/she has been inactive for too long
   * - If the user just became inactive, force fetch an access token from
   *    Auth0 (by setting cacheMode to "off" to synchronize this and Auth0's
   *    "session inactivity timers"
   * Sets `lastActive` to now
   */ checkSessionOnVisibilityStateChange = ()=>{
        // Do nothing if already in /expired page
        if ((0, _authProviderHelpers.isInExpiredPage)()) return;
        if (document.visibilityState === "visible") this.getAccessTokenOrRedirectToExpired();
        else this.getAccessTokenOrRedirectToExpired({
            cacheMode: "off"
        });
        this.lastActive = new Date();
    };
    /**
   * Tries to get an access token silently (without prompting the user)
   * to be used to call the Beaufort API.
   *
   * If the user's Auth0 session has expired, redirect the user
   * to the /expired page.
   */ async getAccessTokenOrRedirectToExpired(options = {
        redirectToExpired: true
    }) {
        if (!this.#getAccessTokenSilently) return;
        // Do nothing if already in /expired page
        if ((0, _authProviderHelpers.isInExpiredPage)()) return;
        // Try to get/refresh the access token silently for the Beaufort API
        try {
            const token = await this.#getAccessTokenSilently(options);
            return token;
        } catch (e) {
            // do not send the exception to Sentry as this is a normal Auth0 flow
            // Sentry.captureException(e, {
            //   level: "debug",
            //   tags: {
            //     location: "getAccessTokenOrRedirectToExpired"
            //   }
            // });
            // The user session has expired, meaning the user must log in
            // again to be able to get a new access token
            // --> Redirect the user to the /expired page (unless disabled)
            if (options.redirectToExpired) (0, _authProviderHelpers.redirectToExpiredPage)();
            return;
        }
    }
    /**
   * A fetch interceptor to be used to intercept any request to the (Beaufort) API
   *
   * This fetch interceptor ensures the access token is refreshed and gets set
   * as a bearer token in the auth header before any request to the API
   *
   * If, for some reason, the request still fails with 401, the user is redirected
   * to the /expired page. Exception: request to the /auth/ endpoint - this is handled
   * in `BeaufortAuthProvider` (see `authenticateBeaufortUser`)
   */ apiFetchInterceptor(input, init) {
        return new Promise((resolve, reject)=>{
            const isAuthUserRequest = input.toString().includes("/auth/user");
            // Get/refresh access token
            // Note: if the request is authenticating the user, this is the initial
            // request to the API. If so, we should NOT redirect to /expired if getting
            // the access token fails or the request fails, as it will be handled in
            // `BeaufortAuthProvider.authenticateBeaufortUser` (the user will be logged out)
            this.getAccessTokenOrRedirectToExpired({
                redirectToExpired: !isAuthUserRequest
            }).then((token)=>{
                // Set auth header using token as bearer token
                const requestInit = init || {};
                if (token) {
                    const requestHeaders = new Headers(requestInit.headers);
                    requestHeaders.set("Authorization", `Bearer ${token}`);
                    requestInit.headers = requestHeaders;
                }
                // Then fetch
                // Failsafe: if 401, assume that the auth token has expired
                // and redirect to the /expired page (exception: auth request)
                fetch(input, requestInit).then((response)=>{
                    // Do not intercept auth requests (handled by `BeaufortAuthProvider`)
                    if (isAuthUserRequest) return resolve(response);
                    if (response.status === 401) {
                        // report on errors to the API
                        _react.captureMessage(`Got 401 error for ${input}`, {
                            level: "debug",
                            tags: {
                                location: "apiFetchInterceptor:fetch[401]"
                            }
                        });
                        !isAuthUserRequest && (0, _authProviderHelpers.redirectToExpiredPage)();
                        reject();
                    } else resolve(response);
                }).catch((error)=>{
                    const status = error?.response?.status || error?.status;
                    const name = error?.name;
                    if (status === 401) !isAuthUserRequest && (0, _authProviderHelpers.redirectToExpiredPage)();
                    else if (name !== "AbortError" && name === "TypeError") // do not send AbortError or TypeError to sentry
                    // report on error from the API if it does not have expired status
                    _react.captureException(error, {
                        level: "debug",
                        tags: {
                            location: "apiFetchInterceptor:catch[inner]"
                        }
                    });
                    reject(error);
                });
            }).catch((reason)=>{
                // report on errors to the API
                _react.captureException(reason, {
                    level: "debug",
                    tags: {
                        location: "apiFetchInterceptor:catch[outer]"
                    }
                });
                reject();
            });
        });
    }
}
const authSessionService = new AuthSessionService();

},{"@sentry/react":"akCRS","../../utils/numbersUtils":"2RGyl","./AuthProvider.helpers":"kL6Fp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2RGyl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isNumberInRange", ()=>isNumberInRange);
const isNumber = (value)=>{
    if (typeof value === "number" && !isNaN(value)) return true;
    else if (typeof value === "string") try {
        const parsedValue = parseFloat(value);
        return !isNaN(parsedValue);
    } catch (e) {
        return false;
    }
    else return false;
};
const isNumberInRange = (value, min, max)=>{
    return isNumber(value) && value > min && value <= max;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kL6Fp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInExpiredPage", ()=>isInExpiredPage);
parcelHelpers.export(exports, "redirectToExpiredPage", ()=>redirectToExpiredPage);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
var _history = require("../../utils/history");
var _historyDefault = parcelHelpers.interopDefault(_history);
const isInExpiredPage = ()=>{
    return (0, _reactRouterDom.matchPath)(window.location.pathname, {
        path: (0, _routes.ROUTES).EXPIRED
    }) !== null;
};
const redirectToExpiredPage = ()=>{
    // No need to redirect to the expired page if we're already there
    if (isInExpiredPage()) return;
    // Redirect to the expired page
    (0, _historyDefault.default).push((0, _routes.ROUTES).EXPIRED, {
        sessionExpiryURL: window.location.href
    });
};

},{"react-router-dom":"1ee65","../../constants/routes":"ihtm8","../../utils/history":"c4gdf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c4gdf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _history = require("history");
exports.default = (0, _history.createBrowserHistory)();

},{"history":"9nqhJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2W6IE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _languageProvider = require("../providers/LanguageProvider");
const useLanguage = ()=>{
    const [language] = (0, _react.useContext)((0, _languageProvider.LanguageContext));
    return language;
};
exports.default = useLanguage;

},{"react":"cOWTg","../providers/LanguageProvider":"iHLZe","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iHLZe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageContext", ()=>LanguageContext);
parcelHelpers.export(exports, "LanguageContextProvider", ()=>LanguageContextProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _enJson = require("../../assets/i18n/en.json");
var _enJsonDefault = parcelHelpers.interopDefault(_enJson);
var _noJson = require("../../assets/i18n/no.json");
var _noJsonDefault = parcelHelpers.interopDefault(_noJson);
var _languages = require("../constants/languages");
var _useStorage = require("../hooks/useStorage");
var _util = require("../utils/util");
const Messages = {
    nb: (0, _noJsonDefault.default),
    en: (0, _enJsonDefault.default)
};
const LanguageContext = /*#__PURE__*/ (0, _react.createContext)([
    (0, _languages.DEFAULT_LANGUAGE),
    (0, _util.noop)
]);
const LanguageContextProvider = ({ children })=>{
    const [language, setLanguage] = (0, _useStorage.useLocalStorage)((0, _languages.LANGUAGE_KEY), (0, _languages.DEFAULT_LANGUAGE));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LanguageContext.Provider, {
        value: [
            language,
            setLanguage
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.IntlProvider), {
            locale: language,
            messages: Messages[language],
            children: children
        })
    });
};

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","../../assets/i18n/en.json":"gKxmb","../../assets/i18n/no.json":"eUw6t","../constants/languages":"ecnY7","../hooks/useStorage":"aERXD","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8H1wU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _intl.createIntlCache));
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>(0, _intl.UnsupportedFormatterError));
parcelHelpers.export(exports, "InvalidConfigError", ()=>(0, _intl.InvalidConfigError));
parcelHelpers.export(exports, "MissingDataError", ()=>(0, _intl.MissingDataError));
parcelHelpers.export(exports, "MessageFormatError", ()=>(0, _intl.MessageFormatError));
parcelHelpers.export(exports, "MissingTranslationError", ()=>(0, _intl.MissingTranslationError));
parcelHelpers.export(exports, "ReactIntlErrorCode", ()=>(0, _intl.IntlErrorCode));
parcelHelpers.export(exports, "ReactIntlError", ()=>(0, _intl.IntlError));
parcelHelpers.export(exports, "FormattedNumberParts", ()=>(0, _createFormattedComponent.FormattedNumberParts));
parcelHelpers.export(exports, "FormattedListParts", ()=>(0, _createFormattedComponent.FormattedListParts));
parcelHelpers.export(exports, "FormattedDateTimeRange", ()=>(0, _dateTimeRangeDefault.default));
parcelHelpers.export(exports, "FormattedMessage", ()=>(0, _messageDefault.default));
parcelHelpers.export(exports, "FormattedPlural", ()=>(0, _pluralDefault.default));
parcelHelpers.export(exports, "FormattedRelativeTime", ()=>(0, _relativeDefault.default));
parcelHelpers.export(exports, "IntlContext", ()=>(0, _injectIntl.Context));
parcelHelpers.export(exports, "IntlProvider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "RawIntlProvider", ()=>(0, _injectIntl.Provider));
parcelHelpers.export(exports, "createIntl", ()=>(0, _createIntl.createIntl));
parcelHelpers.export(exports, "injectIntl", ()=>(0, _injectIntlDefault.default));
parcelHelpers.export(exports, "useIntl", ()=>(0, _useIntlDefault.default));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
parcelHelpers.export(exports, "FormattedDate", ()=>FormattedDate);
parcelHelpers.export(exports, "FormattedTime", ()=>FormattedTime);
parcelHelpers.export(exports, "FormattedNumber", ()=>FormattedNumber);
parcelHelpers.export(exports, "FormattedList", ()=>FormattedList);
parcelHelpers.export(exports, "FormattedDisplayName", ()=>FormattedDisplayName);
parcelHelpers.export(exports, "FormattedDateParts", ()=>FormattedDateParts);
parcelHelpers.export(exports, "FormattedTimeParts", ()=>FormattedTimeParts);
var _createFormattedComponent = require("./src/components/createFormattedComponent");
var _injectIntl = require("./src/components/injectIntl");
var _injectIntlDefault = parcelHelpers.interopDefault(_injectIntl);
var _useIntl = require("./src/components/useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var _provider = require("./src/components/provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _createIntl = require("./src/components/createIntl");
var _relative = require("./src/components/relative");
var _relativeDefault = parcelHelpers.interopDefault(_relative);
var _plural = require("./src/components/plural");
var _pluralDefault = parcelHelpers.interopDefault(_plural);
var _message = require("./src/components/message");
var _messageDefault = parcelHelpers.interopDefault(_message);
var _dateTimeRange = require("./src/components/dateTimeRange");
var _dateTimeRangeDefault = parcelHelpers.interopDefault(_dateTimeRange);
var _intl = require("@formatjs/intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}
var FormattedDate = (0, _createFormattedComponent.createFormattedComponent)("formatDate");
var FormattedTime = (0, _createFormattedComponent.createFormattedComponent)("formatTime");
var FormattedNumber = (0, _createFormattedComponent.createFormattedComponent)("formatNumber");
var FormattedList = (0, _createFormattedComponent.createFormattedComponent)("formatList");
var FormattedDisplayName = (0, _createFormattedComponent.createFormattedComponent)("formatDisplayName");
var FormattedDateParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)("formatDate");
var FormattedTimeParts = (0, _createFormattedComponent.createFormattedDateTimePartsComponent)("formatTime");

},{"./src/components/createFormattedComponent":"ghqea","./src/components/injectIntl":false,"./src/components/useIntl":"4AQbI","./src/components/provider":"4caaY","./src/components/createIntl":false,"./src/components/relative":false,"./src/components/plural":false,"./src/components/message":false,"./src/components/dateTimeRange":false,"@formatjs/intl":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ghqea":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormattedNumberParts", ()=>FormattedNumberParts);
parcelHelpers.export(exports, "FormattedListParts", ()=>FormattedListParts);
parcelHelpers.export(exports, "createFormattedDateTimePartsComponent", ()=>createFormattedDateTimePartsComponent);
parcelHelpers.export(exports, "createFormattedComponent", ()=>createFormattedComponent);
var _tslib = require("tslib");
var _react = require("react");
var _useIntl = require("./useIntl");
var _useIntlDefault = parcelHelpers.interopDefault(_useIntl);
var DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})(DisplayName || (DisplayName = {}));
var DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})(DisplayNameParts || (DisplayNameParts = {}));
var FormattedNumberParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
FormattedNumberParts.displayName = "FormattedNumberParts";
var FormattedListParts = function(props) {
    var intl = (0, _useIntlDefault.default)();
    var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
FormattedNumberParts.displayName = "FormattedNumberParts";
function createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = DisplayNameParts[name];
    return ComponentParts;
}
function createFormattedComponent(name) {
    var Component = function(props) {
        var intl = (0, _useIntlDefault.default)();
        var value = props.value, children = props.children, formatProps = (0, _tslib.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || _react.Fragment;
        return _react.createElement(Text, null, formattedValue);
    };
    Component.displayName = DisplayName[name];
    return Component;
}

},{"tslib":"e8g7m","react":"cOWTg","./useIntl":"4AQbI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e8g7m":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4AQbI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useIntl);
var _react = require("react");
var _injectIntl = require("./injectIntl");
var _utils = require("../utils");
function useIntl() {
    var intl = _react.useContext((0, _injectIntl.Context));
    (0, _utils.invariantIntlContext)(intl);
    return intl;
}

},{"react":"cOWTg","./injectIntl":"1w00v","../utils":"6QnYi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1w00v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "default", ()=>injectIntl);
var _tslib = require("tslib");
var _react = require("react");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _utils = require("../utils");
function getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = _react.createContext(null)) : _react.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return _react.createElement(IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, _utils.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return _react.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, _hoistNonReactStaticsDefault.default)(_react.forwardRef(function(props, ref) {
        return _react.createElement(WithIntl, (0, _tslib.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, _hoistNonReactStaticsDefault.default)(WithIntl, WrappedComponent);
}

},{"tslib":"e8g7m","react":"cOWTg","hoist-non-react-statics":"bIZ8D","../utils":"6QnYi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6QnYi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariantIntlContext", ()=>invariantIntlContext);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ parcelHelpers.export(exports, "assignUniqueKeysToParts", ()=>assignUniqueKeysToParts);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
var _tslib = require("tslib");
var _react = require("react");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intl = require("@formatjs/intl");
function invariantIntlContext(intl) {
    (0, _ecma402Abstract.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var DEFAULT_INTL_CONFIG = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _intl.DEFAULT_INTL_CONFIG)), {
    textComponent: _react.Fragment
});
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(_react.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

},{"tslib":"e8g7m","react":"cOWTg","@formatjs/ecma402-abstract":"f6VxE","@formatjs/intl":"axe5F","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f6VxE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_formatToParts", ()=>(0, _formatToPartsDefault.default));
parcelHelpers.export(exports, "getInternalSlot", ()=>(0, _utils.getInternalSlot));
parcelHelpers.export(exports, "getMultiInternalSlots", ()=>(0, _utils.getMultiInternalSlots));
parcelHelpers.export(exports, "isLiteralPart", ()=>(0, _utils.isLiteralPart));
parcelHelpers.export(exports, "setInternalSlot", ()=>(0, _utils.setInternalSlot));
parcelHelpers.export(exports, "setMultiInternalSlots", ()=>(0, _utils.setMultiInternalSlots));
parcelHelpers.export(exports, "getMagnitude", ()=>(0, _utils.getMagnitude));
parcelHelpers.export(exports, "defineProperty", ()=>(0, _utils.defineProperty));
parcelHelpers.export(exports, "isMissingLocaleDataError", ()=>(0, _data.isMissingLocaleDataError));
parcelHelpers.export(exports, "invariant", ()=>(0, _utils.invariant));
var _canonicalizeLocaleList = require("./CanonicalizeLocaleList");
parcelHelpers.exportAll(_canonicalizeLocaleList, exports);
var _canonicalizeTimeZoneName = require("./CanonicalizeTimeZoneName");
parcelHelpers.exportAll(_canonicalizeTimeZoneName, exports);
var _coerceOptionsToObject = require("./CoerceOptionsToObject");
parcelHelpers.exportAll(_coerceOptionsToObject, exports);
var _getNumberOption = require("./GetNumberOption");
parcelHelpers.exportAll(_getNumberOption, exports);
var _getOption = require("./GetOption");
parcelHelpers.exportAll(_getOption, exports);
var _getOptionsObject = require("./GetOptionsObject");
parcelHelpers.exportAll(_getOptionsObject, exports);
var _getStringOrBooleanOption = require("./GetStringOrBooleanOption");
parcelHelpers.exportAll(_getStringOrBooleanOption, exports);
var _isSanctionedSimpleUnitIdentifier = require("./IsSanctionedSimpleUnitIdentifier");
parcelHelpers.exportAll(_isSanctionedSimpleUnitIdentifier, exports);
var _isValidTimeZoneName = require("./IsValidTimeZoneName");
parcelHelpers.exportAll(_isValidTimeZoneName, exports);
var _isWellFormedCurrencyCode = require("./IsWellFormedCurrencyCode");
parcelHelpers.exportAll(_isWellFormedCurrencyCode, exports);
var _isWellFormedUnitIdentifier = require("./IsWellFormedUnitIdentifier");
parcelHelpers.exportAll(_isWellFormedUnitIdentifier, exports);
var _applyUnsignedRoundingMode = require("./NumberFormat/ApplyUnsignedRoundingMode");
parcelHelpers.exportAll(_applyUnsignedRoundingMode, exports);
var _collapseNumberRange = require("./NumberFormat/CollapseNumberRange");
parcelHelpers.exportAll(_collapseNumberRange, exports);
var _computeExponent = require("./NumberFormat/ComputeExponent");
parcelHelpers.exportAll(_computeExponent, exports);
var _computeExponentForMagnitude = require("./NumberFormat/ComputeExponentForMagnitude");
parcelHelpers.exportAll(_computeExponentForMagnitude, exports);
var _currencyDigits = require("./NumberFormat/CurrencyDigits");
parcelHelpers.exportAll(_currencyDigits, exports);
var _formatApproximately = require("./NumberFormat/FormatApproximately");
parcelHelpers.exportAll(_formatApproximately, exports);
var _formatNumericRange = require("./NumberFormat/FormatNumericRange");
parcelHelpers.exportAll(_formatNumericRange, exports);
var _formatNumericRangeToParts = require("./NumberFormat/FormatNumericRangeToParts");
parcelHelpers.exportAll(_formatNumericRangeToParts, exports);
var _formatNumericToParts = require("./NumberFormat/FormatNumericToParts");
parcelHelpers.exportAll(_formatNumericToParts, exports);
var _formatNumericToString = require("./NumberFormat/FormatNumericToString");
parcelHelpers.exportAll(_formatNumericToString, exports);
var _getUnsignedRoundingMode = require("./NumberFormat/GetUnsignedRoundingMode");
parcelHelpers.exportAll(_getUnsignedRoundingMode, exports);
var _initializeNumberFormat = require("./NumberFormat/InitializeNumberFormat");
parcelHelpers.exportAll(_initializeNumberFormat, exports);
var _partitionNumberPattern = require("./NumberFormat/PartitionNumberPattern");
parcelHelpers.exportAll(_partitionNumberPattern, exports);
var _partitionNumberRangePattern = require("./NumberFormat/PartitionNumberRangePattern");
parcelHelpers.exportAll(_partitionNumberRangePattern, exports);
var _setNumberFormatDigitOptions = require("./NumberFormat/SetNumberFormatDigitOptions");
parcelHelpers.exportAll(_setNumberFormatDigitOptions, exports);
var _setNumberFormatUnitOptions = require("./NumberFormat/SetNumberFormatUnitOptions");
parcelHelpers.exportAll(_setNumberFormatUnitOptions, exports);
var _toRawFixed = require("./NumberFormat/ToRawFixed");
parcelHelpers.exportAll(_toRawFixed, exports);
var _toRawPrecision = require("./NumberFormat/ToRawPrecision");
parcelHelpers.exportAll(_toRawPrecision, exports);
var _formatToParts = require("./NumberFormat/format_to_parts");
var _formatToPartsDefault = parcelHelpers.interopDefault(_formatToParts);
var _partitionPattern = require("./PartitionPattern");
parcelHelpers.exportAll(_partitionPattern, exports);
var _supportedLocales = require("./SupportedLocales");
parcelHelpers.exportAll(_supportedLocales, exports);
var _utils = require("./utils");
var _data = require("./data");
var _relativeTime = require("./types/relative-time");
parcelHelpers.exportAll(_relativeTime, exports);
var _dateTime = require("./types/date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _list = require("./types/list");
parcelHelpers.exportAll(_list, exports);
var _pluralRules = require("./types/plural-rules");
parcelHelpers.exportAll(_pluralRules, exports);
var _number = require("./types/number");
parcelHelpers.exportAll(_number, exports);
var _displaynames = require("./types/displaynames");
parcelHelpers.exportAll(_displaynames, exports);
var _262 = require("./262");
parcelHelpers.exportAll(_262, exports);

},{"./CanonicalizeLocaleList":false,"./CanonicalizeTimeZoneName":false,"./CoerceOptionsToObject":false,"./GetNumberOption":false,"./GetOption":false,"./GetOptionsObject":false,"./GetStringOrBooleanOption":false,"./IsSanctionedSimpleUnitIdentifier":false,"./IsValidTimeZoneName":false,"./IsWellFormedCurrencyCode":false,"./IsWellFormedUnitIdentifier":false,"./NumberFormat/ApplyUnsignedRoundingMode":false,"./NumberFormat/CollapseNumberRange":false,"./NumberFormat/ComputeExponent":false,"./NumberFormat/ComputeExponentForMagnitude":false,"./NumberFormat/CurrencyDigits":false,"./NumberFormat/FormatApproximately":false,"./NumberFormat/FormatNumericRange":false,"./NumberFormat/FormatNumericRangeToParts":false,"./NumberFormat/FormatNumericToParts":false,"./NumberFormat/FormatNumericToString":false,"./NumberFormat/GetUnsignedRoundingMode":false,"./NumberFormat/InitializeNumberFormat":false,"./NumberFormat/PartitionNumberPattern":false,"./NumberFormat/PartitionNumberRangePattern":false,"./NumberFormat/SetNumberFormatDigitOptions":false,"./NumberFormat/SetNumberFormatUnitOptions":false,"./NumberFormat/ToRawFixed":false,"./NumberFormat/ToRawPrecision":false,"./NumberFormat/format_to_parts":false,"./PartitionPattern":false,"./SupportedLocales":false,"./utils":"fBPVw","./data":false,"./types/relative-time":false,"./types/date-time":false,"./types/list":false,"./types/plural-rules":false,"./types/number":false,"./types/displaynames":false,"./262":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fBPVw":[function(require,module,exports) {
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMagnitude", ()=>getMagnitude);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "setInternalSlot", ()=>setInternalSlot);
parcelHelpers.export(exports, "setMultiInternalSlots", ()=>setMultiInternalSlots);
parcelHelpers.export(exports, "getInternalSlot", ()=>getInternalSlot);
parcelHelpers.export(exports, "getMultiInternalSlots", ()=>getMultiInternalSlots);
parcelHelpers.export(exports, "isLiteralPart", ()=>isLiteralPart);
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ parcelHelpers.export(exports, "defineProperty", ()=>defineProperty);
parcelHelpers.export(exports, "UNICODE_EXTENSION_SEQUENCE_REGEX", ()=>UNICODE_EXTENSION_SEQUENCE_REGEX);
parcelHelpers.export(exports, "invariant", ()=>invariant);
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === "literal";
}
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"axe5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntlCache", ()=>(0, _utils.createIntlCache));
parcelHelpers.export(exports, "filterProps", ()=>(0, _utils.filterProps));
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>(0, _utils.DEFAULT_INTL_CONFIG));
parcelHelpers.export(exports, "createFormatters", ()=>(0, _utils.createFormatters));
parcelHelpers.export(exports, "getNamedFormat", ()=>(0, _utils.getNamedFormat));
parcelHelpers.export(exports, "formatMessage", ()=>(0, _message.formatMessage));
parcelHelpers.export(exports, "formatDate", ()=>(0, _dateTime.formatDate));
parcelHelpers.export(exports, "formatDateToParts", ()=>(0, _dateTime.formatDateToParts));
parcelHelpers.export(exports, "formatTime", ()=>(0, _dateTime.formatTime));
parcelHelpers.export(exports, "formatTimeToParts", ()=>(0, _dateTime.formatTimeToParts));
parcelHelpers.export(exports, "formatDisplayName", ()=>(0, _displayName.formatDisplayName));
parcelHelpers.export(exports, "formatList", ()=>(0, _list.formatList));
parcelHelpers.export(exports, "formatPlural", ()=>(0, _plural.formatPlural));
parcelHelpers.export(exports, "formatRelativeTime", ()=>(0, _relativeTime.formatRelativeTime));
parcelHelpers.export(exports, "formatNumber", ()=>(0, _number.formatNumber));
parcelHelpers.export(exports, "formatNumberToParts", ()=>(0, _number.formatNumberToParts));
parcelHelpers.export(exports, "createIntl", ()=>(0, _createIntl.createIntl));
parcelHelpers.export(exports, "defineMessages", ()=>defineMessages);
parcelHelpers.export(exports, "defineMessage", ()=>defineMessage);
var _types = require("./src/types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./src/utils");
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _message = require("./src/message");
var _dateTime = require("./src/dateTime");
var _displayName = require("./src/displayName");
var _list = require("./src/list");
var _plural = require("./src/plural");
var _relativeTime = require("./src/relativeTime");
var _number = require("./src/number");
var _createIntl = require("./src/create-intl");
function defineMessages(msgs) {
    return msgs;
}
function defineMessage(msg) {
    return msg;
}

},{"./src/types":false,"./src/utils":"BrLEO","./src/error":false,"./src/message":"a9fDf","./src/dateTime":false,"./src/displayName":false,"./src/list":false,"./src/plural":false,"./src/relativeTime":false,"./src/number":false,"./src/create-intl":"gJ3hC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"BrLEO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "DEFAULT_INTL_CONFIG", ()=>DEFAULT_INTL_CONFIG);
parcelHelpers.export(exports, "createIntlCache", ()=>createIntlCache);
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ parcelHelpers.export(exports, "createFormatters", ()=>createFormatters);
parcelHelpers.export(exports, "getNamedFormat", ()=>getNamedFormat);
var _tslib = require("tslib");
var _intlMessageformat = require("intl-messageformat");
var _fastMemoize = require("@formatjs/fast-memoize");
var _error = require("./error");
function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var defaultErrorHandler = function(error) {};
var defaultWarnHandler = function(warning) {};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createFormatters(cache) {
    if (cache === void 0) cache = createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getNumberFormat = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    var getPluralRules = (0, _fastMemoize.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: (0, _fastMemoize.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, _fastMemoize.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, _intlMessageformat.IntlMessageFormat)(message, locales, overrideFormats, (0, _tslib.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getRelativeTimeFormat: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDisplayNames: (0, _fastMemoize.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, _error.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

},{"tslib":"e8g7m","intl-messageformat":"9jb2d","@formatjs/fast-memoize":"etj2Z","./error":"dWbmG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9jb2d":[function(require,module,exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", ()=>(0, _core.IntlMessageFormat));
var _core = require("./src/core");
parcelHelpers.exportAll(_core, exports);
var _error = require("./src/error");
parcelHelpers.exportAll(_error, exports);
var _formatters = require("./src/formatters");
parcelHelpers.exportAll(_formatters, exports);
exports.default = (0, _core.IntlMessageFormat);

},{"./src/core":"bJWHB","./src/error":"eAHoB","./src/formatters":"6FHWS","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bJWHB":[function(require,module,exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlMessageFormat", ()=>IntlMessageFormat);
var _tslib = require("tslib");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _fastMemoize = require("@formatjs/fast-memoize");
var _formatters = require("./formatters");
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, _tslib.__assign)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getDateTimeFormat: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: (0, _fastMemoize.strategies).variadic
        }),
        getPluralRules: (0, _fastMemoize.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, _tslib.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: (0, _fastMemoize.strategies).variadic
        })
    };
}
var IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, _formatters.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, _formatters.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, _tslib.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, _tslib.__assign)((0, _tslib.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, _icuMessageformatParser.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

},{"tslib":"e8g7m","@formatjs/icu-messageformat-parser":"cH6GA","@formatjs/fast-memoize":"etj2Z","./formatters":"6FHWS","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cH6GA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "_Parser", ()=>_Parser);
var _tslib = require("tslib");
var _error = require("./error");
var _parser = require("./parser");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
function pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, _types.isSelectElement)(el) || (0, _types.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            pruneLocation(el.options[k].value);
        }
        else if ((0, _types.isNumberElement)(el) && (0, _types.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, _types.isDateElement)(el) || (0, _types.isTimeElement)(el)) && (0, _types.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, _types.isTagElement)(el)) pruneLocation(el.children);
    });
}
function parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, _tslib.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, _parser.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, _error.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) pruneLocation(result.val);
    return result.val;
}
var _Parser = (0, _parser.Parser);

},{"tslib":"e8g7m","./error":"6YuBX","./parser":"7T6cn","./types":"lTJ2J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6YuBX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorKind", ()=>ErrorKind);
var ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7T6cn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _tslib = require("tslib");
var _error = require("./error");
var _types = require("./types");
var _regexGenerated = require("./regex.generated");
var _icuSkeletonParser = require("@formatjs/icu-skeleton-parser");
var _dateTimePatternGenerator = require("./date-time-pattern-generator");
var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, _regexGenerated.SPACE_SEPARATOR_REGEX).source, "*$"));
function createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec("a")) === null || _a === void 0 ? void 0 : _a[0]) === "a";
} catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var fromCodePoint = hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var fromEntries = // native
hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var codePointAt = hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var trimStart = hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace(SPACE_SEPARATOR_START_REGEX, "");
};
var trimEnd = hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace(SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = codePointAt(s, index);
        if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return fromCodePoint.apply(void 0, match);
};
var Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, _types.TYPE).pound,
                    location: createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !_isAlpha(this.char())) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, _error.ErrorKind).UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, _types.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, _error.ErrorKind).UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, _error.ErrorKind).INVALID_TAG, createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && _isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, _types.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, _error.ErrorKind).EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, _types.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, _error.ErrorKind).MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = trimEnd(result.val);
                    if (style.length === 0) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, _types.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, _error.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, _dateTimePatternGenerator.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, _types.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, _types.TYPE).date : (0, _types.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, _types.TYPE).number : argType === "date" ? (0, _types.TYPE).date : (0, _types.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0, _tslib.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, _types.TYPE).select,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, _types.TYPE).plural,
                        value: value,
                        options: fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, _error.ErrorKind).INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, _error.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, _error.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, _icuSkeletonParser.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, _error.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, _types.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, _icuSkeletonParser.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, _error.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, _error.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, _error.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, _error.ErrorKind).MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && _isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function _isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function _isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function _isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

},{"tslib":"e8g7m","./error":"6YuBX","./types":"lTJ2J","./regex.generated":"8Xy1E","@formatjs/icu-skeleton-parser":"3nkTK","./date-time-pattern-generator":"7O8zf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lTJ2J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPE", ()=>TYPE);
parcelHelpers.export(exports, "SKELETON_TYPE", ()=>SKELETON_TYPE);
/**
 * Type Guards
 */ parcelHelpers.export(exports, "isLiteralElement", ()=>isLiteralElement);
parcelHelpers.export(exports, "isArgumentElement", ()=>isArgumentElement);
parcelHelpers.export(exports, "isNumberElement", ()=>isNumberElement);
parcelHelpers.export(exports, "isDateElement", ()=>isDateElement);
parcelHelpers.export(exports, "isTimeElement", ()=>isTimeElement);
parcelHelpers.export(exports, "isSelectElement", ()=>isSelectElement);
parcelHelpers.export(exports, "isPluralElement", ()=>isPluralElement);
parcelHelpers.export(exports, "isPoundElement", ()=>isPoundElement);
parcelHelpers.export(exports, "isTagElement", ()=>isTagElement);
parcelHelpers.export(exports, "isNumberSkeleton", ()=>isNumberSkeleton);
parcelHelpers.export(exports, "isDateTimeSkeleton", ()=>isDateTimeSkeleton);
parcelHelpers.export(exports, "createLiteralElement", ()=>createLiteralElement);
parcelHelpers.export(exports, "createNumberElement", ()=>createNumberElement);
var TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Xy1E":[function(require,module,exports) {
// @generated from regex-gen.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SPACE_SEPARATOR_REGEX", ()=>SPACE_SEPARATOR_REGEX);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3nkTK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dateTime = require("./date-time");
parcelHelpers.exportAll(_dateTime, exports);
var _number = require("./number");
parcelHelpers.exportAll(_number, exports);

},{"./date-time":"4h7DW","./number":"6CJhR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4h7DW":[function(require,module,exports) {
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ parcelHelpers.export(exports, "parseDateTimeSkeleton", ()=>parseDateTimeSkeleton);
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6CJhR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseNumberSkeletonFromString", ()=>parseNumberSkeletonFromString);
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ parcelHelpers.export(exports, "parseNumberSkeleton", ()=>parseNumberSkeleton);
var _tslib = require("tslib");
var _regexGenerated = require("./regex.generated");
function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, _regexGenerated.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace(SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, all), parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace(INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace(FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

},{"tslib":"e8g7m","./regex.generated":"5AY26","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5AY26":[function(require,module,exports) {
// @generated from regex-gen.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WHITE_SPACE_REGEX", ()=>WHITE_SPACE_REGEX);
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7O8zf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ parcelHelpers.export(exports, "getBestPattern", ()=>getBestPattern);
var _timeDataGenerated = require("./time-data.generated");
function getBestPattern(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, _timeDataGenerated.timeData)[regionTag || ""] || (0, _timeDataGenerated.timeData)[languageTag || ""] || (0, _timeDataGenerated.timeData)["".concat(languageTag, "-001")] || (0, _timeDataGenerated.timeData)["001"];
    return hourCycles[0];
}

},{"./time-data.generated":"90epH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"90epH":[function(require,module,exports) {
// @generated from time-data-gen.ts
// prettier-ignore  
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeData", ()=>timeData);
var timeData = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"etj2Z":[function(require,module,exports) {
//
// Main
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
parcelHelpers.export(exports, "strategies", ()=>strategies);
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    }
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6FHWS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PART_TYPE", ()=>PART_TYPE);
parcelHelpers.export(exports, "isFormatXMLElementFn", ()=>isFormatXMLElementFn);
// TODO(skeleton): add skeleton support
parcelHelpers.export(exports, "formatToParts", ()=>formatToParts);
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
var _error = require("./error");
var PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== PART_TYPE.literal || part.type !== PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === "function";
}
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, _icuMessageformatParser.isLiteralElement)(els[0])) return [
        {
            type: PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, _icuMessageformatParser.isLiteralElement)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, _icuMessageformatParser.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, _error.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, _icuMessageformatParser.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? PART_TYPE.literal : PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, _icuMessageformatParser.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, _icuMessageformatParser.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, _icuMessageformatParser.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, _icuMessageformatParser.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) throw new (0, _error.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? PART_TYPE.literal : PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, _icuMessageformatParser.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, _icuMessageformatParser.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, _error.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, _error.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, _error.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

},{"@formatjs/icu-messageformat-parser":"cH6GA","./error":"eAHoB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eAHoB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "FormatError", ()=>FormatError);
parcelHelpers.export(exports, "InvalidValueError", ()=>InvalidValueError);
parcelHelpers.export(exports, "InvalidValueTypeError", ()=>InvalidValueTypeError);
parcelHelpers.export(exports, "MissingValueError", ()=>MissingValueError);
var _tslib = require("tslib");
var ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var InvalidValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError);
var InvalidValueTypeError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError);
var MissingValueError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError);

},{"tslib":"e8g7m","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dWbmG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntlErrorCode", ()=>IntlErrorCode);
parcelHelpers.export(exports, "IntlError", ()=>IntlError);
parcelHelpers.export(exports, "UnsupportedFormatterError", ()=>UnsupportedFormatterError);
parcelHelpers.export(exports, "InvalidConfigError", ()=>InvalidConfigError);
parcelHelpers.export(exports, "MissingDataError", ()=>MissingDataError);
parcelHelpers.export(exports, "IntlFormatError", ()=>IntlFormatError);
parcelHelpers.export(exports, "MessageFormatError", ()=>MessageFormatError);
parcelHelpers.export(exports, "MissingTranslationError", ()=>MissingTranslationError);
var _tslib = require("tslib");
var IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var UnsupportedFormatterError = /** @class */ function(_super) {
    (0, _tslib.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError);
var InvalidConfigError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError);
var MissingDataError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError);
var IntlFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}(IntlError);
var MessageFormatError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError);
var MissingTranslationError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError);

},{"tslib":"e8g7m","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a9fDf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatMessage", ()=>formatMessage);
var _tslib = require("tslib");
var _ecma402Abstract = require("@formatjs/ecma402-abstract");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var _icuMessageformatParser = require("@formatjs/icu-messageformat-parser");
function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, _tslib.__assign)((0, _tslib.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, _tslib.__assign)((0, _tslib.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, _intlMessageformat.IntlMessageFormat).formats;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, mfFormats), f1), {
        date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var formatMessage = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, _ecma402Abstract.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, _icuMessageformatParser.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultRichTextElements), values || {});
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, _error.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, _error.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, _tslib.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, _error.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};

},{"tslib":"e8g7m","@formatjs/ecma402-abstract":"f6VxE","intl-messageformat":"9jb2d","./error":"dWbmG","@formatjs/icu-messageformat-parser":"cH6GA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jpgL7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "formatDateTimeRange", ()=>formatDateTimeRange);
parcelHelpers.export(exports, "formatDateToParts", ()=>formatDateToParts);
parcelHelpers.export(exports, "formatTimeToParts", ()=>formatTimeToParts);
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, _tslib.__assign)((0, _tslib.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, _utils.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, _utils.filterProps)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return getFormatter(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}

},{"tslib":"e8g7m","./utils":"BrLEO","./error":"dWbmG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gDEFz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDisplayName", ()=>formatDisplayName);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, _intlMessageformat.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)("Error formatting display name.", locale, e));
    }
}

},{"./utils":"BrLEO","intl-messageformat":"9jb2d","./error":"dWbmG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aRRLw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatList", ()=>formatList);
parcelHelpers.export(exports, "formatListToParts", ()=>formatListToParts);
var _tslib = require("tslib");
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, _intlMessageformat.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, _tslib.__assign)((0, _tslib.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, _error.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}

},{"tslib":"e8g7m","./utils":"BrLEO","intl-messageformat":"9jb2d","./error":"dWbmG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1SZfZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatPlural", ()=>formatPlural);
var _utils = require("./utils");
var _error = require("./error");
var _intlMessageformat = require("intl-messageformat");
var PLURAL_FORMAT_OPTIONS = [
    "type"
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, _intlMessageformat.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, _utils.filterProps)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, _error.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

},{"./utils":"BrLEO","./error":"dWbmG","intl-messageformat":"9jb2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cu6Sg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelativeTime", ()=>formatRelativeTime);
var _utils = require("./utils");
var _intlMessageformat = require("intl-messageformat");
var _error = require("./error");
var RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, _utils.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, _intlMessageformat.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, _intlMessageformat.ErrorCode).MISSING_INTL_API));
    try {
        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

},{"./utils":"BrLEO","intl-messageformat":"9jb2d","./error":"dWbmG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h5X8W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormatter", ()=>getFormatter);
parcelHelpers.export(exports, "formatNumber", ()=>formatNumber);
parcelHelpers.export(exports, "formatNumberToParts", ()=>formatNumberToParts);
var _error = require("./error");
var _utils = require("./utils");
var NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    // ES2023 NumberFormat
    "trailingZeroDisplay",
    "roundingPriority",
    "roundingIncrement",
    "roundingMode"
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, _utils.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, _utils.filterProps)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, _error.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}

},{"./error":"dWbmG","./utils":"BrLEO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gJ3hC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _utils = require("./utils");
var _error = require("./error");
var _number = require("./number");
var _relativeTime = require("./relativeTime");
var _dateTime = require("./dateTime");
var _plural = require("./plural");
var _message = require("./message");
var _list = require("./list");
var _displayName = require("./displayName");
function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function createIntl(config, cache) {
    var formatters = (0, _utils.createFormatters)(cache);
    var resolvedConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, _error.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, _error.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    verifyConfigMessages(resolvedConfig);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, _number.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, _number.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, _relativeTime.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, _dateTime.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, _dateTime.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, _dateTime.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, _dateTime.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, _dateTime.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, _plural.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, _message.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, _list.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, _list.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, _displayName.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

},{"tslib":"e8g7m","./utils":"BrLEO","./error":"dWbmG","./number":"h5X8W","./relativeTime":"cu6Sg","./dateTime":"jpgL7","./plural":"1SZfZ","./message":"a9fDf","./list":"aRRLw","./displayName":"gDEFz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4caaY":[function(require,module,exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _intl = require("@formatjs/intl");
var _react = require("react");
var _utils = require("../utils");
var _injectIntl = require("./injectIntl");
var _createIntl = require("./createIntl");
function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var IntlProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, _intl.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, _createIntl.createIntl)(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0, _utils.shallowEqual)(prevConfig, config)) return {
            intl: (0, _createIntl.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, _utils.invariantIntlContext)(this.state.intl);
        return _react.createElement((0, _injectIntl.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, _utils.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}(_react.PureComponent);
exports.default = IntlProvider;

},{"tslib":"e8g7m","@formatjs/intl":"axe5F","react":"cOWTg","../utils":"6QnYi","./injectIntl":"1w00v","./createIntl":"8r79e","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8r79e":[function(require,module,exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createIntl", ()=>createIntl);
var _tslib = require("tslib");
var _intl = require("@formatjs/intl");
var _react = require("react");
var _utils = require("../utils");
var _intlMessageformat = require("intl-messageformat");
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, _intlMessageformat.isFormatXMLElementFn)(v) ? (0, _utils.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, _intl.formatMessage).apply(void 0, (0, _tslib.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return _react.Children.toArray(chunks);
    return chunks;
};
var createIntl = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, _tslib.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, _intl.createIntl)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _utils.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, coreIntl), {
        formatMessage: formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

},{"tslib":"e8g7m","@formatjs/intl":"axe5F","react":"cOWTg","../utils":"6QnYi","intl-messageformat":"9jb2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gKxmb":[function(require,module,exports) {
module.exports = JSON.parse('{"access-denied.description":"Please contact us if you would like access","access-denied.title":"Unfortunately, you do not have access here","archive-assignment.confirmation-modal.description":"Are you sure you want to archive \xab{name}\xbb?","archive-assignment.confirmation-modal.labels.button.archive":"Archive {name}","archive-assignment.confirmation-modal.title":"Archive assignment","archive-customer.confirmation-modal.description":"Are you sure you want to archive {name}?\\nArchived customers are not visible in the customer overview.\\nBy using a filter you can still see your archived customers.","archive-customer.confirmation-modal.description.monitoring":"The active screening will get cancelled by archiving a customer.\\nAre you sure you want to archive {name}?\\nArchived customers are not visible in the customer overview.\\nBy using a filter you can still see your archived customers.","archive-customer.confirmation-modal.labels.button.archive":"Archive {name}","archive-customer.confirmation-modal.title":"Archive customer","assignment.selector.error.message":"Choose an assignment","attachments.actions.delete-attachment":"Remove document","attachments.actions.delete-signed-attachment":"Remove signed document","attachments.actions.download-attachment":"Download document","attachments.actions.download-signed-attachment":"Download signed document","attachments.actions.edit-signature":"Edit E-signatures","attachments.actions.section.signed.document.title":"Signed document","attachments.actions.signature.help-text":"E-signatures are only available for PDF files","attachments.actions.view-signature":"View E-signatures","attachments.cancel.confirmation.description":"Changes are not saved.\\nBy canceling, the specified recipients will not be able to access document signing.","attachments.cancel.confirmation.title":"Unsaved changes","attachments.cancel.confirmation.yes":"Cancel and discard changes","attachments.customer.upload.assignment.select":"Select where you want to put the document","attachments.delete.confirmation.description":"Are you sure you want to delete the document: {name} ?","attachments.delete.confirmation.signed.description":"Are you sure you want to delete signed document: {name}?\\nSince this action cannot be undone, it is recommended to download it before deletion.","attachments.delete.confirmation.signed.title":"Remove signed document","attachments.delete.confirmation.signed.yes":"Remove signed document","attachments.delete.confirmation.title":"Remove document","attachments.delete.confirmation.yes":"Remove document","attachments.labels.empty":"There are no uploaded documents","attachments.labels.loading":"Loading...","attachments.labels.signature-status.expired":"Expired","attachments.labels.signature-status.not-activated":"(not activated)","attachments.labels.signature-status.not-signed":"{signed} of {total} have signed","attachments.labels.signature-status.pending":"Awaiting signature","attachments.labels.signature-status.signed":"Signed","attachments.labels.signature-status.unsignable":"Unsignable","attachments.section.title":"Documents","attachments.section.title-with-signatures":"Documents and e-signature","attachments.signatures.modal.button.add-recipient":"Add recipient","attachments.signatures.modal.copy-link":"Copy signing link","attachments.signatures.modal.descriptions.unsignable-attachment":"The uploaded document cannot be signed and must be re-uploaded. Verify that the document is not password protected or corrupted.","attachments.signatures.modal.heading":"Recipients","attachments.signatures.modal.labels.automatic-email":"Automatic e-mail","attachments.signatures.modal.labels.create-links":"Create links","attachments.signatures.modal.labels.deleted-signed-document":"Signed document deleted by {name}, {date}","attachments.signatures.modal.labels.email-sent":"{count, plural, =1 {Email} other {Emails}} sent","attachments.signatures.modal.labels.missing-url":"Link not yet created","attachments.signatures.modal.labels.national-id":"Verify social security number","attachments.signatures.modal.labels.national-id.placeholder":"The recipient\'s social security number ({maxDigits} digits)","attachments.signatures.modal.labels.saved-changes":"Changes saved","attachments.signatures.modal.labels.send-emails-and-create-links":"Send emails and create links","attachments.signatures.modal.labels.unsaved-changes":"Changes not saved","attachments.signatures.modal.labels.unsignable-attachment":"Attachment is unsignable","attachments.signatures.modal.name.placeholder":"Recipient name","attachments.signatures.modal.table.column.date-signed":"DATE SIGNED","attachments.signatures.modal.title":"Signature for \xab{filename}\xbb","attachments.table.header.assignment":"ASSIGNMENT","attachments.table.header.created.by":"UPLOADED BY","attachments.table.header.created.date":"UPLOADED","attachments.table.header.document":"DOCUMENT","attachments.table.header.signature-status":"SIGNATURES STATUS","attachments.table.messages.uploading":"Uploading {count, plural, =1 {} other {# attachments}} ...","attachments.upload.button":"Upload document","attachments.upload.button.available-file-types":"Allowed filetypes:","auto-reminders-settings.description":"KDK can automatically notify your recipients of the KYC form in the event of a lack of response. The reminder is sent by e-mail, and only applies to recipients who have been sent a KYC form by e-mail.","auto-reminders-settings.form.label":"When should the reminder be sent?","auto-reminders-settings.limit-options.label":"How many times should we send automatic reminders by e-mail?","auto-reminders-settings.page.title":"Auto Reminders","auto-reminders-settings.send-options.bi-weekly":"Bi-weekly","auto-reminders-settings.send-options.custom":"Custom","auto-reminders-settings.send-options.custom.placeholder":"Number of days","auto-reminders-settings.send-options.not-set":"Do not send automatic reminders","auto-reminders-settings.send-options.weekly":"Weekly","badge.archived":"Archived","badge.negative-news":"Adverse media","badge.other":"Other","badge.pep":"PEP","badge.sanctioned":"Sanction","bulk.actions.add-to-existing-project.label":"Add to existing project","bulk.actions.add-to-new-project.label":"Add to new project","bulk.actions.archive.confirmation.description":"Are you sure you want to archive {names}?","bulk.actions.archive.confirmation.title":"Archive customers","bulk.actions.archive.success.message":"Archived {count, plural, =1 {customer} other {# customers}}","bulk.actions.change-screening-type.label":"Screening settings","bulk.actions.delete.confirmation.check":"I confirm I wish to delete the selected customers","bulk.actions.delete.confirmation.description":"You are about to delete the selected customers permanently from Kjenn Din Kunde.\\nThis can not be undone.\\nAre you sure you want to delete: {names}?","bulk.actions.delete.confirmation.title":"Delete customers","bulk.actions.delete.success.message":"Deleted {count, plural, =1 {customer} other {# customers}}","bulk.actions.followup.label":"Set follow-up date","bulk.actions.followup.success.message":"Follow-up date changed","bulk.actions.reject-match-cases.confirmation.description":"Are you sure you want to reject {count, plural, =1 {1 match case} other {# match cases}}?","bulk.actions.reject-match-cases.confirmation.title":"Reject match cases","bulk.actions.reject-match-cases.success.message":"Rejected {count, plural, =1 {match case} other {# match cases}}","bulk.actions.responsible.label":"Change responsible users","bulk.actions.responsible.success.message":"Responsible users changed","bulk.actions.restore.confirmation.description":"Are you sure you want to restore {names}?","bulk.actions.restore.confirmation.title":"Restore customers","bulk.actions.restore.success.message":"Restored {count, plural, =1 {customer} other {# customers}}","bulk.actions.screening-type.success.message":"Screening settings was changed","button.go.back":"Back","button.go.next":"Next","change-screening.buttons.save":"Modify screening","change-screening.buttons.start-screening":"Start new screening","change-screening.buttons.stop-monitoring":"Stop screening","change-screening.stop-screening.description":"You will no longer receive updates on any new matches against PEP, sanctions and adverse media on people who have been screened.","change-screening.stop-screening.description-person":"You will no longer receive updates on any new matches against PEP, sanctions and adverse media on the person.","change-screening.stop-screening.title":"Are you sure you want to stop screening?","change-screening.titles.choose-screening-type":"Select type of screening","change-screening.titles.new-screening":"New screening","change-screening.titles.screening-owners":"Screening of owners","change-screening.titles.screening-person":"Screening of","change-screening.titles.screening-roles":"Screening of role holders","change-screening.titles.screening-title":"Change screening","checklists.preview.modal.title":"Preview checklist \\"{name}\\"","common.address.addressline1":"Address line 1","common.address.addressline2":"Address line 2","common.address.city":"City","common.address.country":"Address country","common.address.county":"County","common.address.postal.code":"Postal code","common.answered.label":"Answered by {name}, {timestamp, date, ::yyyyMMdd}","common.badge.new-info":"NEW INFO","common.banner.followup-expired.description":"The follow-up for this customer is set to {followup, date, ::yyyyMMdd}. Make the necessary follow-up routines, and leave a new assessment of the customer.","common.banner.followup-expired.title":"Ongoing follow-up is due","common.banner.possible.match.description":"Possible match as PEP, sanction or adverse media.","common.banner.possible.match.title":"Possible match","common.buttons.action.edit":"Change info","common.buttons.actions.archive-assignment":"Archive assignment","common.buttons.actions.archive-customer":"Archive customer","common.buttons.actions.button":"Actions","common.buttons.actions.change-screening":"Change screening","common.buttons.actions.create-assignment":"Create assignment","common.buttons.actions.delete-customer":"Delete customer","common.buttons.actions.download.report":"Download report","common.buttons.actions.edit-assignment":"Edit assignment details","common.buttons.actions.edit-company-info":"Edit company details","common.buttons.actions.edit-person-info":"Edit person details","common.buttons.actions.new-assignment":"New assignment","common.buttons.actions.new-assignment-disclosure":"Add KYC questions to assignment","common.buttons.actions.new-disclosure":"Send KYC questions","common.buttons.actions.new-screening":"New screening","common.buttons.actions.restore-assignment":"Restore assignment","common.buttons.actions.restore-customer":"Restore customer","common.buttons.actions.skip-step":"Skip this step","common.buttons.move-down":"Move down","common.buttons.move-up":"Move up","common.country-select.choose-country-option":"Choose country","common.date-input.placeholder":"dd/mm/yyyy","common.errors.company-external-id.exists":"A customer with the same external ID already exists","common.errors.company-national-id.exists":"A customer with the same org.no. already exists","common.errors.company.exists":"A similar company customer already exists","common.errors.email.not-unique":"Email already exists","common.errors.file-size-exceeded":"Uploaded files cannot be larger than {max, number}mb. \\nReduce the file size and try again.","common.errors.generic":"An error happened","common.errors.generic.failed-action":"Failed to {actionLabel} ({message})","common.errors.invalid.account-number":"Error in account number. Check that you have included all 11 digits.","common.errors.invalid.address":"Invalid address","common.errors.invalid.birth.date":"Invalid birthdate","common.errors.invalid.citizenship":"Invalid citizenship","common.errors.invalid.comment":"Invalid comment","common.errors.invalid.company.national-id":"Invalid org.no.","common.errors.invalid.email":"Invalid email","common.errors.invalid.empty.mobile-phone":"Empty phone number","common.errors.invalid.empty.name":"Empty name","common.errors.invalid.empty.title":"Empty title","common.errors.invalid.first.name":"Invalid firstname","common.errors.invalid.last.name":"Invalid lastname","common.errors.invalid.missing.last.name":"Last name is missing","common.errors.invalid.name.exists":"Name already exists","common.errors.invalid.national-id.exists":"National ID already exists","common.errors.invalid.person.national-id":"Invalid personal number","common.errors.invalid.person.national-id-country":"Choose a country from the list","common.errors.person-external-id.exists":"A customer with the same external ID already exists","common.errors.person-national-id.exists":"A customer with the same personal number already exists","common.errors.person.exists":"A similar person customer already exists","common.errors.required.first.name":"First name required","common.errors.required.last.name":"Last name required","common.group.role.key.compliance-officer":"Compliance Officer","common.group.role.key.kdk-admin":"KDK Admin","common.group.role.key.mlro":"MLRO","common.labels.address":"Address","common.labels.approve":"Approve","common.labels.approved":"Approved","common.labels.archived-by":"Archived by {name}, {timestamp, date, ::yyyyMMdd}","common.labels.bank-id":"BankID","common.labels.birth_date":"Date of birth","common.labels.both-customer-types":"Both types of customers","common.labels.business-address":"Business address","common.labels.calculated-ubo":"The ownership share indicates that the person is to be considered the ultimate beneficial owner","common.labels.change-seen":"Change seen","common.labels.citizenship":"Citizenship","common.labels.collapse-all":"Collapse all","common.labels.comment":"Comment","common.labels.complete":"Complete","common.labels.completed-by":"Completed by {name}, {timestamp, date, ::yyyyMMdd}","common.labels.confirmed-by":"Confirmed by {name}, {timestamp, date, ::yyyyMMdd}","common.labels.country":"Country","common.labels.country-of-origin":"Country of origin","common.labels.country-of-residence":"Country of residence","common.labels.create-tag":"Create Tag","common.labels.created-by":"Created by {name}, {timestamp, date, ::yyyyMMdd}","common.labels.customer-relationship":"Customer relationship","common.labels.customer-type":"Choose the type of customers the custom questions should be displayed for:","common.labels.customer-type.company":"Company","common.labels.customer-type.person":"Person","common.labels.customer.risk":"customer risk","common.labels.description":"Description","common.labels.editorial-explanation":"Editorial explanation","common.labels.email":"Email","common.labels.end-date":"End date","common.labels.expand-all":"Expand all","common.labels.file.upload":"Upload file","common.labels.first_name":"First name","common.labels.go-to-support-page":"Go to the support page","common.labels.groups":"Groups","common.labels.include-assignment":"Include assignment","common.labels.kyc":"KYC","common.labels.kyc-responses":"KYC responses","common.labels.last_name":"Last name","common.labels.manual-ubo":"Manually marked as UBO","common.labels.mark-person-as-pep":"Person is PEP","common.labels.mark-person-as-sanctioned":"Person is sanctioned","common.labels.missing-information":"Missing information","common.labels.mobile-phone":"Mobile number","common.labels.modified-by":"Last modified by {name}, {timestamp, date, ::yyyyMMdd}","common.labels.more-information-at":"More information at","common.labels.name":"Name","common.labels.national-id":"National ID","common.labels.national-id-country":"National ID country","common.labels.nationality":"Nationality","common.labels.office-address":"Office address","common.labels.pep-position-country":"Country of employment for PEP","common.labels.photo":"Photo","common.labels.reject":"Reject","common.labels.rejected":"Rejected","common.labels.rejected-by":"Rejected by {name}, {timestamp, date, ::yyyyMMdd}","common.labels.risk-category.geographical":"Geographical risk","common.labels.risk-category.industry":"Industry risk","common.labels.risk-category.pep":"PEP","common.labels.risk-category.sanction":"Sanction","common.labels.risk-response":"Risk response","common.labels.risk-type":"Risk type","common.labels.save-changes":"Save changes","common.labels.save-settings":"Save settings","common.labels.saved-successfully":"Changes saved","common.labels.selected-customers-count":"Selected customers: {count, number}","common.labels.show-less":"Show less","common.labels.show-more":"Show more","common.labels.show-more-with-count":"Show {count, number} more","common.labels.start-date":"Start date","common.labels.take-me-back":"Take me back","common.labels.title":"Title","common.labels.triggered-when":"Triggered when:","common.labels.try-again":"Try again","common.labels.ubo":"UBO","common.labels.unidentified-owner":"Unidentified owner","common.language.english":"English","common.language.norwegian":"Norwegian","common.loading.data":"Retrieving data","common.month":"{months, plural, =1 {1 month} other {# months}}","common.multiple-names.full":"{fullnames} and {count, number} others","common.multiple-names.short":"{fullnames} and {lastname}","common.reviewed.label":"Reviewed by {name}, {timestamp, date, ::yyyyMMdd}","common.roles.ACCOUNTANT":"Accountant","common.roles.ALTERNATE_BOARD_MEMBER":"Alternate board member","common.roles.AUDITOR":"Auditor","common.roles.BOARD_MEMBER":"Board member","common.roles.CEO":"CEO","common.roles.CHAIRMAN":"Chairman","common.roles.COMPLEMENTARY":"Complementary","common.roles.CONTACT_PERSON":"Contact person","common.roles.DEPUTY_BOARD_MEMBER":"Deputy board member","common.roles.DEPUTY_CHAIRMAN":"Deputy chairman","common.roles.MANAGER":"Manager","common.roles.MANAGING_DIRECTOR":"Managing director","common.roles.NORWEGIAN_REPRESENTATIVE":"Norwegian representative (NUF)","common.roles.OBSERVER":"Observer","common.roles.PARTICIPANT_FULL_RESPONSIBILITY":"Participant with full responsibility","common.roles.PARTICIPANT_PART_RESPONSIBILITY":"Participant with shared responsibility","common.roles.PROCURA":"Procura","common.roles.PROCURA_JOINTLY":"Procura jointly","common.roles.PROCURA_SEPARATELY":"Procura separately","common.roles.PROPRIETOR":"Proprietor","common.roles.REPRESENTATIVE":"Representative","common.roles.SIGNATURE":"Signature","common.roles.SIGNATURE_JOINTLY":"Signature jointly","common.roles.SIGNATURE_SEPARATELY":"Signature separately","common.roles.TRUSTEE":"Trustee","common.roles.UNKNOWN_ROLE":"Unknown role","common.roles.not.in.use":"not in use","common.roles.null":"Unknown role","common.share-class.CLASS_A":"CLASS A SHARES","common.share-class.CLASS_B":"CLASS B SHARES","common.share-class.CLASS_C":"CLASS C SHARES","common.share-class.CLASS_D":"CLASS D SHARES","common.share-class.CLASS_E":"CLASS E SHARES","common.share-class.CLASS_F":"CLASS F SHARES","common.share-class.CLASS_G":"CLASS G SHARES","common.share-class.CLASS_H":"CLASS H SHARES","common.share-class.CLASS_I":"CLASS I SHARES","common.share-class.CLASS_J":"CLASS J SHARES","common.share-class.EXTRAORDINARY_SHARES":"EXTRAORDINARY SHARES","common.share-class.ISIN":"ISIN","common.share-class.ORDINARY_SHARES":"ORDINARY SHARES","common.share-class.PREFERRED_SHARES":"PREFERRED SHARES","common.share-class.UNKNOWN_SHARE_CLASS":"UNKNOWN SHARES","common.vitec.synced":"Synced to Vitec","common.vitec.synchronize":"Synchronize to Vitec","common.year":"{years, plural, =1 {1 year} other {# years}}","company-card.errors.fetch-failed-action":"Fetch company information","company-form.headings.details":"Company details","company-form.labels.country":"Country","company-form.labels.external-id":"External ID","company-form.labels.name":"Company name","company-form.labels.national-id":"Org.no.","company.details.caption.address":"ADDRESS","company.details.caption.address.postal":"POSTAL ADDRESS","company.details.caption.address.visit":"VISITING ADDRESS","company.details.caption.closure_date":"Closure Date","company.details.caption.company.type":"ORG. FORM","company.details.caption.country":"COUNTRY","company.details.caption.employees":"EMPLOYEES","company.details.caption.est":"ESTABLISHED","company.details.caption.external-id":"ID","company.details.caption.industry-codes":"INDUSTRY CODES","company.details.caption.is_bankrupt":"Bankrupt","company.details.caption.name":"NAME","company.details.caption.national_id":"ORG.NO.","company.details.caption.registered-in-foundation":"REGISTERED IN FOUNDATION REGISTRY","company.details.caption.registered-in-vat":"REGISTERED IN VAT REGISTRY","company.details.caption.under_forced_liquidation":"UNDER FORCED LIQUIDATION","company.details.caption.under_liquidation":"UNDER LIQUIDATION","company.details.caption.website":"HOMEPAGE","company.details.changes.tooltip.banner":"Changes in company details are shown as \\"New\\" until it is marked as \\"Change seen\\" or a new customer review has been made","company.details.changes.tooltip.button.label":"New customer review","company.details.new-role.tooltip.banner":"New roles are marked as \xabNew\xbb until a new screening has been performed","company.details.new-role.tooltip.button.label":"Change screening","company.details.onboarding.no-screening-performed":"No screening performed","company.details.onboarding.title":"Covered by screening","company.details.screening.title":"who is covered by screening","company.details.title":"company details","company.owners.archive.description":"Are you sure you want to archive: <bold>{name}</bold>?","company.owners.hide-historical-owners":"Hide historical owners","company.owners.title":"Ownership overview","company.owners.view-historical-owners":"View historical owners","company.owners.warning.foreign-company":"The shareholder register provides information that a company has shares in your customer, but the information is incomplete. Contact the customer to get an overview of the ownership and control structure and real rights holders.","company.owners.warning.unidentified-owner":"Your customer has owner(s) in the ownership structure that cannot be identified from the Shareholder Register. Contact the customer to get an overview of the ownership and control structure and real rights holders.","company.roles.title":"Role Holders","component.filter.country.title":"Country","component.filter.customer.option.company.title":"Company","component.filter.customer.option.person.title":"Person","component.filter.customer.title":"Customer type","component.filter.risk.title":"Risk","component.filter.screening.title":"Screening type","component.filters.all.title":"All","component.filters.archive.option.include-archived-customers":"Show archived customers","component.filters.archive.title":"Archived customers","component.filters.button.reset":"Reset","component.filters.created-after.title":"Added after","component.filters.created-before.title":"Added before","component.filters.created.applied.range.MONTH":"Added in the last month","component.filters.created.applied.range.WEEK":"Added in the last week","component.filters.created.applied.range.YEAR":"Added in the last year","component.filters.created.labels.after":"Added after {date}","component.filters.created.labels.before":"Added before {date}","component.filters.created.range.ALL":"All","component.filters.created.range.CUSTOM":"Custom range","component.filters.created.range.MONTH":"Last month","component.filters.created.range.WEEK":"Last week","component.filters.created.range.YEAR":"Last year","component.filters.created.title":"Added","component.filters.followup-after.title":"Follow-up after","component.filters.followup-before.title":"Follow-up before","component.filters.followup-expired.title":"Follow-up expired","component.filters.followup.applied.range.MONTH":"Follow-up in the next month","component.filters.followup.applied.range.WEEK":"Follow-up in the next week","component.filters.followup.applied.range.YEAR":"Follow-up in 12 months","component.filters.followup.labels.after":"Follow-up after {date}","component.filters.followup.labels.before":"Follow-up before {date}","component.filters.followup.option.expired":"Follow-up expired","component.filters.followup.range.ALL":"All","component.filters.followup.range.CUSTOM":"Custom range","component.filters.followup.range.MONTH":"Next month","component.filters.followup.range.WEEK":"Next week","component.filters.followup.range.YEAR":"Next year","component.filters.followup.title":"Follow-up","component.filters.include.archive.title":"Include archived customers","component.filters.industry-type.title":"Industry Type","component.filters.marked-as.option.pep":"PEP","component.filters.marked-as.option.sanction":"Sanctioned","component.filters.marked-as.title":"Marked as (PEP/Sanctioned)","component.filters.match.option.open.matches":"Open matches","component.filters.match.text.open.matches":"Has unreviewed matches","component.filters.match.text.pep.matches":"Marked as PEP","component.filters.match.text.sanction.matches":"Marked as sanctioned","component.filters.ownership-updates.label":"Only show customers with updated shareholder data","component.filters.ownership-updates.title":"Ownership updates","component.filters.pending-measures.option":"Has pending measures","component.filters.pending-measures.title":"Has pending measures","component.filters.project.option.active":"Active","component.filters.project.option.inactive":"Inactive","component.filters.responsible.user.inactive":"Inactive","component.filters.saved-filters.delete-filter":"Delete saved filter","component.filters.saved-filters.deleted.message":"Saved filter deleted","component.filters.saved-filters.empty.message":"Add filters to the customer list and click \u201CSave filters\u201D to save","component.filters.saved-filters.filter-name":"Filter name","component.filters.saved-filters.my-customers":"My customers","component.filters.saved-filters.save-filters.label":"Save filters","component.filters.saved-filters.saved.message":"Filters saved \uD83C\uDF89","component.filters.saved-filters.title":"Saved filters","component.filters.saved-filters.without-filters":"Without filters","component.filters.screening.option.monitoring":"Continuous","component.filters.screening.option.one-time":"One time","component.filters.status.approved":"Approved","component.filters.status.draft-review":"Draft Review","component.filters.status.not-ready":"Not ready","component.filters.status.rejected":"Rejected","component.filters.status.review-approval-required":"Pending review approval","component.filters.status.review-required":"Review Required","component.filters.status.started":"Started","component.filters.status.title":"Status","component.filters.tags.title":"Tags","component.filters.text.and":"and","component.filters.unresolved-matched.title":"Matches","component.notes.delete.confirmation.description":"Are you sure you want to delete the note?","component.notes.delete.confirmation.title":"Delete note","component.notes.labels.save-note":"Save note","component.notes.title":"Notes {count, plural, =0 {} other {(#)}}","component.pagination.labels.select-limit":"Show {limit} customers","component.pagination.labels.showing":"Showing {start, number} - {end, number} of {count, number}","component.questionnaires-list.empty":"You haven\u2019t created any custom KYC-questions yet. It can be created [here]({link}).  \\nPS. It is the Money Laundering Officer / Compliance Officer in your company who creates this in Settings.","component.questionnaires-list.filter.label":"Filter questionnaires:","component.questionnaires-list.loading":"Loading questionnaires","component.questionnaires-list.loading.error-action":"Get questionnaires list","component.review.checklist.added.toast.message":"New checklist added.","component.review.checklist.added.toast.scroll.label":"View checklist","component.review.checklist.create-instance":"Use template","component.review.checklist.form.remove.confirmation.description":"Are you sure you want to remove the checklist \xab{name}\xbb?","component.review.checklist.form.remove.confirmation.title":"Remove checklist","component.review.checklist.select.button.label.add":"Add checklist","component.review.checklist.select.checklists-list.filter.label":"Filter checklists:","component.review.checklist.select.checklists-list.loading":"Loading checklists","component.review.checklist.select.checklists-list.loading.error":"Something went wrong when retrieving the checklists","component.review.checklist.template.title":"Choose template","component.search.customers.hint":"Search customers","component.users-list.all-users.title":"All Users","component.users-list.filter.label":"Filter users:","component.users-list.loading":"Loading users","component.users-list.loading.error-action":"Get users list","copy-label.buttons.copy.tooltip":"Copy to clipboard","customer-assignments.completed":"Completed","customer-assignments.details.assignment-description":"Assignment description","customer-assignments.details.assignment-industry-type":"Assignment industry","customer-assignments.details.assignment-purpose":"Assignment purpose","customer-assignments.details.assignment-risk":"Assignment risk","customer-assignments.empty":"This customer has no assignments yet.","customer-assignments.list.filter.hide-archived-assignments":"Hide archived assignments ({count, number})","customer-assignments.list.filter.show-archived-assignments":"Show archived assignments ({count, number})","customer-assignments.list.header.added":"ADDED","customer-assignments.list.header.name":"NAME","customer-assignments.list.header.responsible":"RESPONSIBLE USERS","customer-assignments.list.header.risk":"RISK","customer-assignments.list.header.status":"STATUS","customer-assignments.modal.assignment-description":"Assignment description","customer-assignments.modal.assignment-industry":"Assignment industry type (optional)","customer-assignments.modal.assignment-industry.placeholder":"Choose an industry from the list","customer-assignments.modal.assignment-name":"Assignment name","customer-assignments.modal.assignment-purpose":"Assignment purpose (optional)","customer-assignments.modal.assignment-purpose.placeholder":"Choose from list or define a new purpose","customer-assignments.modal.assignment-purpose.placeholder-without-description":"Choose a purpose from the list","customer-assignments.no-disclosures.text":"There are no KYC requests sent in this assignment.","customer-assignments.no-disclosures.title":"Add KYC requests to this assignment by clicking the button below. Add KYC to Assignment.","customer-assignments.review.button.action":"Review assignment","customer-assignments.review.button.change":"Change review","customer-assignments.review.not-reviewed":"The assignment has not been reviewed yet","customer-assignments.review.status.pending":"Pending review","customer-assignments.review.status.waiting":"Awaiting identification","customer-assignments.review.title":"Assignment review","customer-assignments.title":"Customer assignments","customer-notifications-settings.description":"Select how often you want to receive updates on company information from the Register of Legal Entities. Select <bold>immediate</bold> if you want email for each company update, select <bold>daily</bold> if you want email that collects daily updates, select <bold>weekly</bold> if you want email that collects weekly updates.","customer-notifications-settings.frequency.label":"How often would you like to receive email notifications?","customer-notifications-settings.frequency.options.daily":"Daily","customer-notifications-settings.frequency.options.immediately":"Immediately","customer-notifications-settings.frequency.options.weekly":"Weekly","customer-notifications-settings.page.title":"Company information updates","customer-projects.empty":"No projects were found.","customer-review-assignment.labels.include-assignment":"Select what the risk assessment applies to","customer-review-guideline-settings.labels.guideline.header":"Guideline header","customer-review-guideline-settings.page.description":"Customize the customer review guidelines","customer-review-guideline-settings.page.reset.confirmation.description":"Are you sure you want to reset the customer review guidelines back to default?\\nThis will erase all the changes that were made to both Person and Company guidelines.","customer-review-guideline-settings.page.reset.confirmation.title":"Reset customer review guidelines","customer-review-guideline-settings.page.title":"Customer review guidelines","customer.checklist.review.form.header":"Checklists","customer.details.archived-date":"Archived by {name}, {timestamp, date, ::yyyyMMdd}","customer.notes.placeholder":"Leave a note about the customer","customers.list.column.added":"ADDED","customers.list.column.customer":"CUSTOMER","customers.list.column.customers.count":"CUSTOMERS COUNT","customers.list.column.external-id":"ID","customers.list.column.report":"REPORT","customers.list.column.responsible.users":"RESPONSIBLE USERS","customers.list.column.risk":"RISK","customers.list.column.tasks":"TASKS","customers.list.empty.content":"There were no customers matching your search and/or filter selections","customers.list.empty.title":"Your search returned no results","customers.list.external-id.tooltip":"External ID: {id}","customers.list.fresh-customer.content":"Then it\'s probably time to get started!","customers.list.fresh-customer.label":"Now I am ready!","customers.list.fresh-customer.title":"You haven\'t added any customers yet?","customers.list.header.customers.count":"Number of customers: {count, number} {selected, plural, =0 {} other {(# selected)}}","customers.list.header.customers.count.all":"Number of customers: {count, number} (all selected)","customers.list.header.selected.count":"{count} selected","customers.list.paging.limit.select.label":"Show {limit} items","customers.list.paging.next":"Next","customers.list.paging.previous":"Previous","customers.list.paging.showing":"Showing {start} - {end} of {count}","customers.list.tabs.labels.all":"All customers ({count, number})","customers.list.tabs.labels.pending-tasks":"Customers with pending tasks","customers.list.title":"Customers","dashboard.filters.date.from":"From: {date}","dashboard.filters.date.interval.ANNUALLY":"Last year","dashboard.filters.date.interval.CUSTOM_DATE_RANGE":"Custom range","dashboard.filters.date.interval.DAILY":"Last day","dashboard.filters.date.interval.MONTHLY":"Last month","dashboard.filters.date.interval.QUARTERLY":"Last quarter","dashboard.filters.date.interval.WEEKLY":"Last week","dashboard.filters.date.title":"Date range","dashboard.filters.date.until":"Until: {date}","dashboard.widgets.active-customers.title":"My Customers","dashboard.widgets.industry-types.empty.message":"No industries found","dashboard.widgets.industry-types.filter.placeholder":"Filter industries","dashboard.widgets.industry-types.title":"Industry Types","dashboard.widgets.marked-as-pep.title":"Customers marked as PEP","dashboard.widgets.marked-as-sanctioned.title":"Sanctioned Customers","dashboard.widgets.pending-tasks.title":"Customers with pending tasks","dashboard.widgets.risk-data.PEP":"Politically Exposed Person","dashboard.widgets.risk-data.by.assignment.title":"AML reporting for real estate brokerage businesses - by assignment","dashboard.widgets.risk-data.by.assignment.tooltip":"The figures are linked to assignments imported from Vitec Next and include archived assignments.\\n\\nThe figures are taken from the KYC response(s), with the exception of PEP status and connection to high-risk countries. PEP status depends on whether the customer is marked as PEP in Know Your Customer. High risk country affiliation is a combination of information registered in Know Your Customer and KYC response.","dashboard.widgets.risk-data.by.customer.title":"AML reporting for real estate brokerage businesses - by customer","dashboard.widgets.risk-data.by.customer.tooltip":"The figures include all customers who have answered at least one KYC form, and include archived customers.\\n\\nThe figures are taken from the KYC response(s), with the exception of PEP status and connection to high-risk countries. PEP status depends on whether the customer is marked as PEP in Know Your Customer. High risk country affiliation is a combination of information registered in Know Your Customer and KYC response.","dashboard.widgets.risk-data.construction-industry":"Industry affiliation in the construction industry","dashboard.widgets.risk-data.financed-crowdfunding":"Funded by crowdfunding","dashboard.widgets.risk-data.financed-crypto":"Funded by cryptocurrency or crypto art","dashboard.widgets.risk-data.high-risk-country":"Connection to high-risk countries","dashboard.widgets.risk-data.high-risk-industry":"Industry affiliation to other high risk industries","dashboard.widgets.risk-data.missing-funding-documentation":"Renovated with unknown origin of financing","dashboard.widgets.risk-data.missing-work-documentation":"Renovated whole/parts without invoice","dashboard.widgets.risk-levels.title":"Risk level - all customers","dashboard.widgets.status.title":"Approve and Rejected","default.add":"Add","default.archive":"Archive","default.cancel":"Cancel","default.categories":"categories","default.change":"Change","default.close":"Close","default.confirm":"Confirm","default.copy":"Copy","default.create":"Create","default.days":"{days, plural, =1 {day} other {days}}","default.delete":"Delete","default.down-from":"Down from {value}","default.edit":"Edit","default.email":"E-mail","default.expired":"Expired","default.hide":"Hide","default.history":"history","default.home":"Home","default.inactive":"Inactive","default.industries":"industries","default.invalid":"Invalid","default.keep":"Keep","default.link":"Link","default.loading":"Loading","default.mandatory":"Mandatory","default.months":"{months, plural, =1 {month} other {months}}","default.new":"New","default.next":"Next","default.no":"No","default.normal":"Normal","default.or":"or","default.preview":"Preview","default.previous":"Previous","default.reject":"Reject","default.remove":"Remove","default.required":"Required","default.reset":"Reset","default.restore":"Restore","default.risk":"Risk","default.save":"Save","default.save-changes":"Save changes","default.search":"Search","default.send":"Send","default.show":"Show","default.status":"Status","default.support-portal":"support portal","default.times":"{count, plural, =1 {time} other {# times}}","default.unknown":"Unknown","default.up-from":"Up from {value}","default.view":"View","default.years":"{years, plural, =1 {year} other {years}}","default.yes":"Yes","delete-customer.confirmation-modal.description":"You are about to delete {name} permanently from Kjenn Din Kunde.\\nThis can not be undone.\\nAre you sure you want to delete this customer?","delete-customer.confirmation-modal.labels.button.delete":"Delete {name}","delete-customer.confirmation-modal.success.message":"{name} was deleted","delete-customer.confirmation-modal.title":"Delete customer","details.banners.critical-update.content":"There have been changes in this customer, which have consequences for the customer relationship.","details.banners.critical-update.title":"Company changes that have consequences","details.banners.ownership-updates.content":"We have received updated information from the Shareholder Register, and therefore have new information on licensees belonging to this customer.","details.banners.ownership-updates.link-label":"See updates","details.banners.screening.in.progress.content":"Waiting for results of screening","details.banners.screening.in.progress.title":"Screening in progress","details.basic-info.customer-risk":"Customer risk","details.basic-info.follow-up":"Ongoing follow-up","details.basic-info.marked-as":"Marked as","details.basic-info.screening-type":"Screening type","details.basic-info.status":"Review Status","details.reviews.approved-by":"Approved by: ","details.reviews.assignment-review.accepted":"Assignment accepted","details.reviews.assignment-review.rejected":"Assignment rejected","details.reviews.awaiting-approval":"Awaiting approval","details.reviews.awaiting-approval-with-names":"Awaiting approval by {names}","details.reviews.awaiting-measures":"Waiting to complete measures","details.reviews.confirm.approve":"Approve review","details.reviews.confirm.approve-reject.title":"Rationale","details.reviews.confirm.cancel.description":"Are you sure you want to discard changes?","details.reviews.confirm.cancel.title":"Discard changes","details.reviews.confirm.delete.description":"Are you sure you want to delete the review?\\n(This operation can not be undone)","details.reviews.confirm.delete.title":"Delete review","details.reviews.confirm.reject":"Reject review","details.reviews.confirm.reject.description":"By rejecting the assessment, it must be redone by the employee.","details.reviews.confirmed-by":"Confirmed by: ","details.reviews.customer-review.accepted":"Customer relationship accepted","details.reviews.customer-review.rejected":"Customer relationship rejected","details.reviews.draft":"Draft review","details.reviews.labels.cancel":"Yes, discard changes","details.reviews.labels.confirm-delete":"Yes, delete review","details.reviews.labels.delete":"Delete review","details.reviews.labels.save-and-continue":"Save and continue later","details.reviews.measures.comment.label":"Actions taken:","details.reviews.measures.edit-measure":"Take action","details.reviews.measures.form.completed.label":"Has this been resolved?","details.reviews.measures.form.description.label":"Describe actions","details.reviews.measures.form.description.placeholder":"Enter results from measure taken","details.reviews.measures.header":"measures","details.reviews.measures.remove-confirmation.description":"Are you sure you want to remove the measure \xab{name}\xbb?","details.reviews.measures.remove-confirmation.title":"Remove measure","details.reviews.messages.saved":"Review is saved","details.reviews.pending-measures":"The review is not completed until all the measures have been completed","details.reviews.rejected-by":"Rejected by: ","details.reviews.reviewed-by":"Reviewed by: ","details.reviews.risk-set-from-x-to-y":"Customer risk changed from {beforeRisk} to {risk}","details.reviews.risk-set-to-x":"Customer risk set to {risk}","disclosure-card.completed.subtitle":"Completed at {timestamp, date, ::yyyyMMdd}","disclosure-card.content-language":"CONTENT LANGUAGE","disclosure-card.date-tile":"DATE CREATED","disclosure-card.email-tile":"EMAIL ADDRESS","disclosure-card.expired-banner.description":"No more automatic reminders will be sent. You must now send a reminder manually, or contact the customer directly.","disclosure-card.expired-banner.title":"Missing KYC response","disclosure-card.identification.label":"Identified person ({method})","disclosure-card.link-tile":"LINK","disclosure-card.next-notification.subtitle":"Next reminder: {timestamp, date, ::yyyyMMdd}","disclosure-card.notified.subtitle":"Last notified at {timestamp, date, ::yyyyMMdd}","disclosure-card.pin-tile":"PIN","disclosure-card.recipient-tile":"RECIPIENT","disclosure-card.scope-tile":"INCLUDED","disclosure-card.status-tile":"STATUS","disclosure-collapsible.hide":"Hide answers","disclosure-collapsible.show":"Show answers","disclosure-documents.empty":"No requests sent","disclosure-documents.title":"KYC and identification","disclosure-request.banner.no.signing-basis":"Signing basis does not exist","disclosure-request.banner.signatory-rights":"Signatory rights in {company}","disclosure-request.button.add-representative":"Add representative","disclosure-request.button.send":"Create request","disclosure-request.column.content-language":"Content language","disclosure-request.column.custom-questionnaires":"Add your own KYC-questions","disclosure-request.column.customer":"Customer","disclosure-request.column.email":"E-mail address","disclosure-request.column.sending-method":"Sending method","disclosure-request.field.email.placeholder":"Receivers e-mail address","disclosure-request.field.use_pep_disclosure":"PEP questions","disclosure-request.field.use_standard_disclosure":"KYC questions (inc. PEP questions)","disclosure-request.field.use_verification":"Identification (BankID)","disclosure-request.title":"Send request regarding identification and KYC questions","disclosure-request.toggle.automatic-email":"Send e-mail","disclosure-status.completed":"Completed","disclosure-status.expired":"Expired","disclosure-status.waiting":"Awaiting answer","disclosure-status.warning":"Found {count, plural, =1 {1 high risk answer} other {# high risk answers}}","disclosure.fileset.document-type.ARTICLES_OF_ASSOCIATION":"Articles of Association","disclosure.fileset.document-type.COMPANY_STRUCTURE":"Company Structure","disclosure.fileset.document-type.FAMILY_OWNERSHIP":"Family Ownership","disclosure.fileset.document-type.HOMEOWNER_AGREEMENT":"UBO Agreement","disclosure.fileset.document-type.HOMEOWNER_POWER_OF_ATTORNEY":"Power of Attorney","disclosure.fileset.document-type.POWER_OF_ATTORNEY":"Power of Attorney","disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT":"Private loan agreement","disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT_DEVELOPED_PROPERTY":"Private loan agreement","disclosure.fileset.document-type.PROPERTY_OWNERSHIP_STRUCTURE":"Property ownership Structure","disclosure.fileset.document-type.SHAREHOLDER_BOOK":"Shareholder Book","disclosure.fileset.document-type.UBO_AGREEMENT":"UBO Agreement","disclosure.fileset.document-type.UPGRADE_FUNDING_DOCUMENTATION":"Upgrade funding documentation","disclosure.fileset.document-type.UPGRADE_WORK_DOCUMENTATION":"Upgrade work documentation","disclosure.foreign-assignment-description":"Countries other than Norway that are involved in the assignment","disclosure.settings.page.description":"Customize the content sent to your customers by email (identification and KYC) to make it more personal. You have the option to upload your own logo and write a custom text which will be visible in the email. (Your logo will also be visible on the forms which are created and sent as a link.)","disclosure.settings.page.labels.email.due-diligence.identification":"Identification with BankID","disclosure.settings.page.labels.email.due-diligence.kyc":"Questions relevant for the customer relationship","disclosure.settings.page.labels.email.due-diligence.list.title":"The due diligence contains:","disclosure.settings.page.labels.email.header":"Hi, (Name of customer).","disclosure.settings.page.labels.email.subject.company":"COMPANY NAME is conducting a due diligence","disclosure.settings.page.labels.email.subject.person":"COMPANY NAME is conducting a due diligence","disclosure.settings.page.labels.logo":"Upload your own logo","disclosure.settings.page.labels.supported-filetypes":"You can upload .jpg or .png (up to {limit} KB)","disclosure.settings.page.labels.text":"Add your own text in the email","disclosure.settings.page.tabs.customer-type.company":"Company customers","disclosure.settings.page.tabs.customer-type.person":"Person customers","disclosure.settings.page.title":"Logo and text","disclosure.source-of-funds":"Source of Funds","disclosure.timestamp":"Answered","disclosure.ubo-agreements-description":"Information regarding agreement(s) and person(s) who have actual control over the company","disclosure.ubo-agreements-exists":"Are there articles of association, shareholder agreement(s) or other agreement that have provisions on who (directly or indirectly) controls the company?","disclosure.ubo-company-control.heading":"Questions regarding ultimate beneficial owners and company control","disclosure.ubo-company-structure-description":"Information regarding the company structure in the company","disclosure.ubo-company-structure-exists":"Is the company you are acting on the behald of, part of a company structure?","disclosure.ubo-family-members-description":"Information regarding family members which collectively exercise actual control over the company","disclosure.ubo-family-members-exists":"Do family members collectively, directly or indirectly, own more than 25% of the voting shares, or collectively exercise actual control over the company?","disclosure.ubo-share-classes-description":"Information regarding share classes in the company","disclosure.ubo-share-classes-exists":"Are there multiple share classes in the company you are acting on the behalf of?","disclosure.ubo-structure-changes-description":"Information regarding changes in the ownership structure","disclosure.ubo-structure-changes-exists":"Have there been changes in the ownership structure?","disclosure.usage-of-funds":"What will the funds from the sale be used for?","display-name.suffixes.labels.birth-date":"(b. {birthDate, date, ::yyyy})","display-name.suffixes.labels.org-id":"(org.no. {orgId})","email.invalid.address.error":"Invalid address","email.placeholder.text":"Email address","email.required.error":"Email required","error.message.unknown":"An error occurred","error.page.description":"Give it a few seconds and try again","error.page.title":"Unfortunately, an error has occurred...","expired.actions.logout":"Log in","expired.description":"For security reasons, you will be logged out after 30 minutes (if you are not active)","expired.heading":"You must log in again","fetch.identification.info.card.note":"This is further described in chapter 4.3 of Finanstilsynets guide to the Money Laundering Act.","fetch.identification.info.card.text":"Companies subject to reporting under the Money Laundering Act are in accordance to \xa712 in the law regarding measures against money laundering and financing of terror obliged to obtain identification from customers when it is a physical person, as well as for physical persons acting on behalf a company.","fetch.identification.info.card.title":"Why is obtaining identification necessary?","followup-notifications.settings.intervals.description":"Choose how often you want to receive notification of pending/expired follow-ups by email. The email contains a link to Know Your Customer with a filter view of the customers you need to follow up.","followup-notifications.settings.page.title":"Customer follow-up interval","followup-settings.intervals.description":"You can define follow-up intervals for each risk level. When the follow-up date for a customer expires, the customer\'s status changes to \\"awaiting follow-up\\". The customer must then be risk assessed again.","followup-settings.intervals.labels.custom-interval":"Custom interval","followup-settings.intervals.labels.custom-interval.placeholder":"Number of months","followup-settings.intervals.labels.no-interval":"No interval","followup-settings.page.link-to-notifications":"PS. Under <link>, you can define how often you want to receive email notifications about pending/expired follow-ups.","followup-settings.page.title":"Customer follow-up","followup.modal.labels.date":"Select a new follow-up date","followup.modal.message":"Set follow-up date for {names}","followup.modal.title":"Set Follow Up Date","followup.select.empty.label":"Select follow up date","followup.select.error-action":"Set follow-up date","followup.select.expired.label":"Expired: {followup, date, ::yyyyMMdd}","followup.select.label":"Next: {followup, date, ::yyyyMMdd}","followup.select.success.message":"Follow-up date successfully changed","followup.select.title":"Custom date on next follow-up","high-risk-countries.list.EU":"EU","high-risk-countries.list.EU_TAX_HAVEN":"EU Tax Haven","high-risk-countries.list.FATF":"FATF","import-customers.wizard.labels.finished":"Finished importing","import-customers.wizard.labels.first-row-contains-headers":"First row contains headers","import-customers.wizard.labels.import-companies.button":"Import companies","import-customers.wizard.labels.import-people.button":"Import people","import-customers.wizard.labels.importing":"Importing {count, number} out of {total, number} rows","import-customers.wizard.page.title.companies":"Import Companies","import-customers.wizard.page.title.people":"Import People","import-customers.wizard.page.welcome.description":"Welcome to the customers import wizard","import-customers.wizard.page.welcome.title":"Welcome to the customers import wizard","import-customers.wizard.status.IMPORTED":"Imported successfully","import-customers.wizard.status.IMPORTING":"Importing...","import-customers.wizard.status.IMPORT_ERROR":"Failed to import","import-customers.wizard.status.INITIAL":"Read from file","import-customers.wizard.status.READY_FOR_IMPORT":"Ready for import","import-customers.wizard.status.VALIDATION_ERROR":"Validation error","import-customers.wizard.table.hide-column-button.tooltip":"Hide column","import-customers.wizard.validation-error.duplicate-org-id":"Duplicate Org. ID found","import-customers.wizard.validation-error.invalid-org-id":"Invalid Org. ID","import-customers.wizard.validation-error.responsible-user-not-found":"Responsible user not found","import-customers.wizard.warning.missing-columns":"{count, plural, one {This column} other {These columns}} must be selected: {names}","import-customers.wizard.warning.multiple-columns":"{count, plural, one {This column} other {These columns}} must be selected only once: {names}","in.progress":"In progress","industry-info.labels.industry-code":"Industry code","industry-info.labels.possible-risk":"Possible risk","industry-types.filter.label":"Filter industry types","kar.form.labels.account-number":"Account number","kar.form.labels.check-account-number":"Check account number","kar.form.labels.customer-number":"Social security number / Org.nr","kar.form.result.by":"Time of search: {timestamp, date, ::yyyyMMdd HH:mm} - performed by {name}","kar.form.result.failure":"The account number <bold>{accountNumber}</bold> does not belong to <bold>{name} ({nationalId})</bold>","kar.form.result.success":"The account number <bold>{accountNumber}</bold> belongs to <bold>{name} ({nationalId})</bold>","kar.form.title":"Verify account information","kar.table.status.failure.tooltip":"No link between account number and social security number / org. no.","kar.title":"KAR-register","links.go-back":"Back to {name}","lookup.again":"Lookup again","lookup.button.search":"Lookup company","lookup.correct.customer":"This is correct customer","lookup.error.company.bankrupt":"The company is bankrupt","lookup.error.company.closed":"The company is closed/deleted","lookup.error.company.not.found":"Could not find a company with this number {orgId}","lookup.error.company.under-forced-liquidation":"The company is under forced liquidation or dissolution","lookup.error.company.under-liquidation":"The company is under liquidation","lookup.error.title":"Cannot register company","lookup.error.wrong.orgid":"Wrong org number","lookup.input.placeholder":"Org.no. (9 digits)","lookup.search.title":"Search for the company using org number","lookup.title":"Confirm customer","match-cases-section.count.label":"Number of match cases: {count, number} {selected, plural, =0 {} other {(# selected)}}","match.basic-info.id":"ID:","match.basic-info.last-updated":"Last updated:","match.basic-info.match-date":"Date on match:","match.relations.ACTING":"ACTING FOR OR ON BEHALF OF","match.relations.CHILD":"CHILD","match.relations.DAUGHTER":"DAUGHTER","match.relations.FATHER":"FATHER","match.relations.MOTHER":"MOTHER","match.relations.PARENT":"PARENT","match.relations.RELATIVE":"RELATIVE","match.relations.SIBLING":"SIBLING","match.relations.SPOUSE":"SPOUSE","match.relations.WIFE":"WIFE","matches.button.confirm.match.description-company":"The match applies to the right company and is relevant","matches.button.confirm.match.description-person":"The match applies to the right person and is relevant","matches.button.decline.match.description-company":"The match does not apply to the right company, or is not relevant","matches.button.decline.match.description-person":"The match does not apply to the right person, or is not relevant","matches.button.hide.rejected.matches":"Hide rejected matches ({count})","matches.button.review-next-match":"Review next match","matches.button.show.rejected.matches":"Show rejected matches ({count})","matches.help-text.pep.description":"Assess whether the information in the match entails that your customer/representative is a PEP, or a closely related family member or known associate of a PEP.\\n\\n**Which positions and functions are covered by the PEP definition?**\\n\\nPolitically exposed persons (PEP) are individuals who hold, or have held, the following positions or functions according to the [Anti-Money Laundering Act \xa7 2 letter f](https://lovdata.no/lov/2018-06-01-23/\xa72).\\n\\nSpecific _national_ positions are specified below.\\n\\n\\n\\n* Head of state, head of government, minister and assistant minister\\n    * _The king_\\n    * _The prime minister_\\n    * _cabinet ministers_\\n    * _state secretaries_\\n* Member of parliament \\n    * _Members of parliament, regular or permanent deputy members_\\n* Member of a governing body of a political party\\n    * _Main board or equivalent high-ranking body in political parties represented in parliament (municipal and county councils are not included)_\\n* Member of a high-level judicial body making decisions that cannot, or only exceptionally, be appealed\\n    * _Judges in the Supreme Court, temporary and permanent positions_\\n    * _Judges in the Court of Appeal (only employees in the judicial system, not lay judges/alternate judges), temporary and permanent positions_\\n    * _Norwegian judges at international courts, e.g., the European Court of Human Rights (ECHR), the EFTA Court, the UN Court (ICJ)_\\n* Member of the board of of national audit, audit court or central bank\\n    * _Members and alternate members of the board of auditors in the National Audit Office_\\n    * _Board of directors of Norges Bank_\\n* Ambassador or charg\xe9 d\'affaires \\n    * _Norwegian ambassador or charg\xe9 d\'affaires at a Norwegian embassy (consuls are not included)_\\n* High-ranking military officer \\n    * _Chief of Defense_\\n    * _Leaders in the various branches of defense: general, lieutenant general, and major general (equivalent to admiral, vice admiral, and rear admiral in the navy)_\\n* Member of an administrative, managerial or controlling body of a \u201Cstate enterprise\u201D*\\n    * _Board of directors and CEO in state enterprises_\\n`*`_\\"State enterprises\\" are state-owned companies responsible for public tasks falling within the public administration. The decisive factor is whether they involve state authorities, even if represented by a corporation. State-owned companies that do not perform tasks involving public administration fall outside the definition._\\n_Excludes subsidiaries, self-owned institutions (typically foundations) wholly or partially financed by public funds, local enterprises (such as county and municipal enterprises)_\\n\\n* Director, board member or other person in the senior management of an international organization\\n    * _Persons nominated, appointed, or employed by a government, department, or minister in an international organization established by entering into a formal international political agreement, e.g., EFTA, NATO, and the UN (non-profit organizations are not included)._\\n\\n**Who is defined as a closely related family member to a PEP?**\\n\\n\\n\\n* Parents\\n* Spouse, registered partner, or cohabitant \\n* Children, as well as the children\'s spouse, registered partner, or cohabitant \\n\\nSiblings, stepchildren, and stepparents are not included in the definition. Adopted children are considered equal to biological children.\\n\\n**Who is defined as a known associate of a PEP?**\\n\\nA known associate is defined as a person known to:\\n\\n\\n\\n* have joint beneficial ownership of a company with a politically exposed person\\n* Have a close business relationship with a politically exposed person\\n* Be the sole beneficial owner of a company established in reality to benefit a politically exposed person\\n\\n_More information in the [guidance to the Anti-Money Laundering Act](https://www.finanstilsynet.no/nyhetsarkiv/rundskriv/2022/veileder-til-hvitvaskingsloven/)._","matches.help-text.pep.title":"How to assess PEP matches?","matches.labels.details":"What is the match about?","matches.labels.negative-news":"Adverse media","matches.labels.negative-news.helper-text-company":"The company is linked to adverse media that could indicate a higher risk","matches.labels.negative-news.helper-text-person":"The person is linked to adverse media that could indicate a higher risk","matches.labels.other":"Other","matches.labels.other.helper-text-company":"The company is linked to other types of events (describe in the free text field)","matches.labels.other.helper-text-person":"The person is linked to other types of events (describe in the free text field)","matches.labels.pep":"PEP","matches.labels.pep.detailed":"PEP (Politically Exposed Person)","matches.labels.pep.detailed.tooltip":"Politically exposed persons (PEP) are persons who hold a special public office and may therefore be exposed to bribery and other corruption","matches.labels.pep.helper-text":"The person in question is a politically exposed person, or closely related to one (according to the definition in the Anti-Money Laundering Act)","matches.labels.rejected-by":"Rejected by {name}, {timestamp, date, ::yyyyMMdd}","matches.labels.relations":"Relationships / affiliations","matches.labels.review.description":"Rationale","matches.labels.review.description.placeholder":"Review description","matches.labels.sanction":"Sanction","matches.labels.sanction.helper-text-company":"The company is sanctioned and listed in the sanctions list","matches.labels.sanction.helper-text-person":"The person is sanctioned and listed in the sanctions list","matches.labels.sanctions":"Sanctions","matches.labels.source":"Source: ","matches.labels.source.name":"Source name: ","matches.labels.source.publication-source":"Publication source:","matches.labels.source.publisher":"Publisher:","matches.labels.source.url":"Source:","matches.navigation.tooltip":"{summary} on {name}","matches.review.approved":"Match confirmed","matches.review.denied":"Match denied","matches.text.no.confirmed.matches":"No confirmed matches","matches.text.no.matches":"No matches found \uD83C\uDF89","matches.title.compare.companies":"Compare companies","matches.title.compare.persons":"Compare persons","matches.title.details.matches":"Matches during screening","matches.titles.assessment":"Review screening match","matches.titles.categories":"CATEGORIES","matches.titles.comments":"COMMENTS","matches.titles.company-customer":"Company details","matches.titles.data-source":"Match from data source","matches.titles.events":"EVENTS","matches.titles.geographic-affiliation":"Geographic affiliation","matches.titles.key-information":"Key Information","matches.titles.listings":"LISTINGS","matches.titles.matches-against-data-source":"MATCH AGAINST DATA SOURCE","matches.titles.person-customer":"Personal details","matches.titles.positions":"POSITIONS","matches.titles.relations":"RELATIONS","matches.titles.relevant-links":"RELEVANT LINKS","matches.titles.sources":"SOURCES","matches.titles.summary":"SUMMARY","measures-settings.page.description":"Here you can create measures that you can use in the risk assessment of your customers.","measures-settings.page.filter.hide-archived-measures":"Hide inactive measures","measures-settings.page.filter.show-archived-measures":"Show inactive measures","measures-settings.page.title":"Measures","measures.confirm-archive.description":"Are you sure you want to archive \xab{name}\xbb?.\\nThis will not remove existing measures.","measures.confirm-archive.labels.archive.button":"Archive measure","measures.confirm-archive.title":"Archive Measure","measures.confirm-remove.description":"Are you sure you want to remove the measure?","measures.confirm-remove.title":"Remove measure","measures.errors.empty-measure":"Measure is empty","measures.list.loading.error-action":"Get measures list","measures.list.loading.label":"Loading measures","measures.modal.empty-state":"There are currently no measures","measures.modal.errors.description-validation-error":"Description required","measures.modal.errors.title-not-unique-validation-error":"Title already exists","measures.modal.errors.title-validation-error":"Title required","measures.modal.title.add":"Add Measure","measures.modal.title.update":"Edit Measure","measures.modal.title.view":"Measure","measures.popover.labels.button":"Add measure","measures.popover.labels.filter":"Add new measure","measures.popover.labels.global-list.empty":"There are no existing measures","measures.popover.labels.global-list.title":"Choose existing measures","measures.popover.labels.new-empty-measure":"New measure","menu.import.companies":"Import Companies","menu.language.english":"Language: English","menu.language.norwegian":"Language: Norwegian","menu.logout":"Log out","menu.plan-upgrade":"AML-package: {packageName}","menu.settings":"Settings","menu.support-email":"Contact support","menu.whats-new":"What\'s new?","missing-required-permission.banner.description":"Only {roles} can change these settings","modals.company.edit.title":"Edit company details","modals.copy.link.button":"Copy link","modals.copy.link.button.copied":"Copied","modals.delete.signature.button":"Delete KYC request","modals.delete.signature.description":"Are you sure you want to delete the KYC request to {name}?","modals.delete.signature.title":"Delete KYC request","modals.headings.address":"Address","modals.headings.personal-information":"Personal Information","modals.owner.confirm.archive.description":"Are you sure you want to archive {owner}?","modals.owner.confirm.archive.title":"Archive owner","modals.owner.headings.ownership-in-company":"Ownership in company","modals.owner.labels.percent_share":"Ownership share in %","modals.owner.messages.owner-restored":"Owner \xab{name}\xbb was restored","modals.owner.title.add":"Add owner","modals.owner.title.update":"Update owner","modals.owner.tooltips.archive-disabled":"You can\'t archive an owner that is being screened","modals.person.edit.title":"Edit person details","modals.remind.signer.button":"Send reminder","modals.remind.signer.title":"Send reminder to receiver","modals.role.confirm.delete.description":"Are you sure you want to delete {role} from the list of role holders?\\nThis action cannot be undone.","modals.role.confirm.delete.title":"Delete role holder","modals.role.headings.role-in-company":"Role in company","modals.role.labels.role_type":"Role","modals.role.labels.select.placeholder":"Choose role type","modals.role.title.add":"Add role holder","modals.role.title.update":"Update role holder","modals.role.tooltips.delete-disabled":"You can\'t delete a role that is being screened","modals.update.signature.button":"Save changes","modals.update.signature.customer":"CUSTOMER","modals.update.signature.error.duplicate-email":"This email is already used for another recipient","modals.update.signature.title":"Edit recipient info","nav-bar.dashboard":"Dashboard","nav-bar.new-customer":"Register customer","nav-bar.new-customer.company":"Company customer","nav-bar.new-customer.person":"Person customer","nav-bar.overview":"Customers","navigation.page.customers.title":"Customers","navigation.settings.checklists.label":"Checklists","navigation.settings.internal-tools.kyc-previewer.label":"KYC Previewer","navigation.settings.internal-tools.section.title":"Internal Tools","navigation.settings.kyc.auto-reminder.label":"KYC reminders of customers","navigation.settings.kyc.custom-questionnaires.label":"Create KYC-questions","navigation.settings.notifications.customer-info.label":"Company updates","navigation.settings.notifications.section.title":"Notifications","navigation.settings.onboarding.person.title":"Person customer","navigation.settings.onboarding.section.title":"Customer registration","navigation.settings.risk-management.section.title":"Risk management","navigation.settings.users.section.title":"Users management","navigation.settings.users.title":"All users","new-company-customer.country-options.no":"Norwegian company","new-company-customer.country-options.other":"Foreign company","new-company-customer.texts.manual":"Fill in the company\'s information manually","new-company-customer.titles.manual":"Register foreign company","new-company-customer.titles.norwegian":"Register Norwegian company","not-found.description":"This page may have been moved, deleted, or perhaps there is an error in the url","not-found.title":"Hmm, this page has gone missing","not.specified":"Not specified","notifications-settings.followup.form.label":"How often would you like to receive email notifications?","notifications-settings.followup.form.label.monthly":"Once a month","notifications-settings.followup.form.label.no-notification":"No notifications","notifications-settings.followup.form.label.weekly":"Once a week","onboarding-settings.page.description":"Here you can choose which settings will apply to the registration of all new customers. Your choices will then be pre-filled for new customer registrations.","onboarding-settings.page.title":"Onboarding of personal customers","onboarding-summary.signature-table-column.content-language":"CONTENT LANGUAGE","onboarding-summary.signature-table-column.email-or-url":"EMAIL/LINK","onboarding-summary.signature-table-column.name":"NAME","onboarding-summary.signature-table-column.scope":"SCOPE","onboarding-summary.title":"Summary","onboarding.assignments-and-attachments.description":"Create an assignment for the customer and upload the necessary documents related to the assignment or customer relationship.","onboarding.assignments-and-attachments.title":"Assignment and documents","onboarding.assignments.description":"Create an assignment for the customer","onboarding.assignments.title":"Assignment","onboarding.associated-project.title":"Associated project","onboarding.bar.company.assignments-and-attachments.title":"Assignment and attachments","onboarding.bar.company.assignments.title":"Assignment","onboarding.bar.company.disclosures.title":"KYC","onboarding.bar.company.screening.title":"Screening","onboarding.bar.company.summary.title":"Summary","onboarding.bar.manual-company.information.title":"Information","onboarding.cancel.and.delete":"Abort registration","onboarding.cancel.and.save":"Save and continue later","onboarding.cancel.confirm.description":"Are you sure you want to cancel the registration of {name}?\\nIf you cancel the registration, {name} will be deleted, and you will have to perform the registration again.","onboarding.cancel.confirm.title":"Cancel registration","onboarding.cancel.onboarding":"Close","onboarding.disclosures.company-description":"You are obligated to assess the person/persons that are acting on behalf of the customer, according to the Money Laundering Act. Choose the concerned ones.","onboarding.disclosures.duplicate.emails.error":"Det er tastet inn samme e-postadresse til flere personer. Se over e-postadressene.","onboarding.disclosures.person-description":"You are obligated to assess your customer, according to the Money Laundering Act.","onboarding.disclosures.person.require-disclosure":"Identify and/or send KYC questions","onboarding.disclosures.send-email.text":"A unique link for electronic identification will be created, which will be available from the customer page. You are responsible for sending the link to the person concerned.","onboarding.disclosures.title":"Identification and KYC questions","onboarding.new.person.title":"Onboard Person","onboarding.screening-type.monitoring.helper.text":"Notifications will be continuously provided if the following people are flagged against PEP and/or sanctions lists, as well as adverse media articles.","onboarding.screening-type.one-time.helper.text":"Screens the customer one time against PEP and sanctions lists, as well as adverse media articles, before the customer relationship is up for review. Notifications will not be given regarding changes in owners or the control structure.","onboarding.status.draft-review":"Draft {count, plural, =1 {review} other {reviews}}","onboarding.status.ready-for-review":"Ready for review","onboarding.status.started":"Started","outstanding-shares.banner.description":"The shareholder register lacks information about <bold>{outstandingShares, number}</bold> shares of <bold>{totalShares, number}</bold>.\\nIt is therefore recommended to contact the customer to obtain a complete share register.\\nAfterwards, the undisclosed information about owners and real rights holder(s) can be updated manually below.","outstanding-shares.banner.title":"Outstanding shares","owners.card.buttons.add-owner":"Add beneficial owner","owners.card.cannot-have-shareholders":"This company type ({companyType}) cannot have shareholders, so we do not identify owners with shares for this company.","owners.card.manual.no-owners":"No owners.","owners.card.newly-founded.no-owners":"This company was founded after the Norwegian Aksjon\xe6rregisteret was updated (December 31).\\nCheck whether the customer has provided correct/updated information in the KYC form after the KYC form has been answered.","owners.card.no-owners":"There are no owners who own/control (directly or indirectly) 5 percent or more (source: Norwegian Aksjon\xe6rregisteret)","ownership-update.actions.labels.confirm-all-updates":"Confirm all changes","ownership-update.actions.labels.ignore":"Ignore","ownership-update.banner.description":"We have received important updates that affect the ownership of this customer. \\nThe information is taken from the Norwegian Shareholder Register {year}, and thus reflect the ownership as it was at the end of {year}. You have to approve or ignore the changes.","ownership-update.banner.finished.description":"There are no more ownership updates! \uD83C\uDF89","ownership-update.confirm-all.modal.action.label":"Go to screening settings","ownership-update.confirm-all.modal.content":"This does not affect the screening. You must change this manually if necessary, e.g. if new owners should be screened, or expired owners should be removed from screening.","ownership-update.confirm-all.modal.title":"Great! Then it\u2019s done! \uD83C\uDF89","ownership-update.description.update":"Last updated from The shareholder register {year}","ownership-update.info.label":"Ownership updates","ownership-update.reject.confirmation.modal.action.label":"Ignore change","ownership-update.reject.confirmation.modal.content.add":"Ignoring the change is deleted <bold>{name}</bold> from the list of licensees.","ownership-update.reject.confirmation.modal.content.delete":"Ignoring the change maintains location <bold>{name}</bold> in the list of licensees.","ownership-update.reject.confirmation.modal.content.update":"By ignoring the change, the ownership share is added <bold>{name}</bold> back to {value}.","ownership-update.reject.confirmation.modal.title":"Are you sure you want to ignore the change?","ownership.view.table":"Owners","ownership.view.tree":"Ownership structure","ownership.view.tree.info":"Information is taken directly from Aksjon\xe6rregisteret. We include all individuals with ownership of at least 5%, or chains of ownership of at least 25%.","pending-tasks.labels.awaiting-disclosures":"Awaiting answer on {count, plural, =1 {1 KYC request} other {# KYC requests}}","pending-tasks.labels.awaiting-documents":"Awaiting completion of {count, plural, =1 {1 e-signature request} other {# e-signature requests}}","pending-tasks.labels.open-matches":"Awaiting review of {count, plural, =1 {1 match} other {# matches}}","pending.tasks.labels.approve-review":"Approve customer review","pending.tasks.labels.days-since-onboarding":"{days, plural, =0 {request sent today} =1 {1 day since request} other {# days since request}}","pending.tasks.labels.finish-onboarding":"Continue registering","pending.tasks.labels.followup-customer":"Follow-up customer","pending.tasks.labels.open-draft-review":"Open draft review","pending.tasks.labels.remind-recipients":"Remind recipients","pending.tasks.labels.review-customer":"Review customer","pending.tasks.labels.review-matches":"Review {count, plural, =1 {match} other {matches}}","pending.tasks.labels.review-measures":"Review {count, plural, =1 {measure} other {measures}}","pending.tasks.labels.review-ownership-updates":"Review ownership updates","pending.tasks.labels.see-draft-reviews":"See draft reviews","pending.tasks.labels.see-pending-disclosures":"See {count, plural, =1 {request} other {requests}}","pending.tasks.labels.see-pending-documents":"See {count, plural, =1 {document} other {documents}}","pending.tasks.status.approve-review":"Approve/Reject review","pending.tasks.status.followup":"Follow-up: {days, plural, =-1 {expired} =0 {today} =1 {in 1 day} other {in # days}}","pending.tasks.status.review-measures":"{count, number} pending {count, plural, =1 {measure} other {measures}}","pending.tasks.status.waiting-for-approval":"Pending review approval","pending.tasks.status.waiting-for-approval.subtitle":"Requested on {timestamp, date, ::yyyyMMdd} from {names}","person-name.description.manually-created":"Created by {name}, {timestamp, date, ::yyyyMMdd}","person.customer.details.personal.number":"Personal number","person.details.caption.address":"ADDRESS","person.details.caption.birth.date":"BIRTHDATE","person.details.caption.citizenship":"CITIZENSHIP","person.details.caption.externalId":"ID","person.details.caption.first.name":"FIRST NAME","person.details.caption.last.name":"LAST NAME","person.details.caption.origin":"COUNTRY OF BIRTH","person.details.caption.person.number":"PERSONAL NUMBER","person.details.caption.residence":"COUNTRY OF RESIDENCE","person.details.title":"person details","personal.number.placeholder.no":"ddmmyyXXXXX","plan-conversion.add-to-projects.description":"Upgrade your AML plan to enable projects.","plan-conversion.attachments.description":"Upgrade your AML package to access document upload and email signing.","plan-conversion.banner.labels.link":"See the different AML packages","plan-conversion.customer-action.label":"Upgrade your AML plan for this function","plan-conversion.messages.access-feature":"Oppgrader din AML-pakke for \xe5 f\xe5 tilgang til denne funksjonen.","plan-conversion.modal.title":"Upgrade your AML package","plan-conversion.projects.description":"Projects is a function that lets you gather several customers in one overview. This makes it easy to have full overview of all customers that belong to the same project.","plan-conversion.projects.image.alt-text":"Project details image","project.actions.labels.edit":"Edit project details","project.actions.labels.end-project":"End project","project.actions.labels.reactivate":"Reactivate project","project.banner.vitec.imported.text":"Start with registering the customer. The customer report is automatically uploaded to Vitec when reviewing a customer.","project.banner.vitec.label":"This project is imported from Vitec","project.button.imported-from-vitec":"Vitec","project.customers.actions.remove-from-project":"Remove from project","project.customers.buttons.add-customers":"Add customers","project.customers.buttons.add-existing-customers":"Add existing customers","project.customers.buttons.add-new-company-customer":"Add new company","project.customers.buttons.add-new-person-customer":"Add new person","project.customers.empty.header":"No customers are listed in this project.","project.customers.empty.message":"Add customers to the project by pressing the \\"Add customers\\" button above.","project.customers.modal.title":"Add customers to project \xab{name}\xbb","project.customers.title":"Customers in project","project.details.labels.description":"Add project description","project.details.labels.name":"Enter project name","project.end.confirmation.action.label":"End project \xab{name}\xbb","project.end.confirmation.description":"Are you sure you want to end project \xab{name}\xbb ?","project.end.confirmation.title":"End project","project.info.labels.created":"Created","project.info.labels.description":"Description","project.info.labels.project-managers":"Project managers","project.info.labels.status":"Status","project.info.manager.empty.user":"Select project manager","project.info.manager.error":"Failed to assign new project manager","project.notes.placeholder":"Leave a note about the project","project.remove-customers.confirmation.action.label":"Remove customers","project.remove-customers.confirmation.description":"Are you sure you want to remove {names} from project \xab{projectName}\xbb ?","project.remove-customers.confirmation.title":"Remove customers","project.remove-customers.success.message":"Removed {count, plural, =1 {customer} other {# customers}}","project.status.ACTIVE":"Active","project.status.INACTIVE":"Inactive","project.vitec.customers.empty.message":"Add customers to the project by pressing the Vitec link.","projects.common.labels.create.project":"Create Project","projects.common.labels.update.project":"Update Project","projects.list.column.name":"PROJECT NAME","projects.list.column.status":"STATUS","projects.list.empty.projects.header":"You have not created any projects yet.","projects.list.empty.projects.message":"Create your first project by pressing the button in the top right corner.","projects.list.filters.search.hint":"Search projects","projects.modal.empty.search.description":"Check if you have typed correctly, or add the customer directly from the project","projects.modal.empty.search.title":"Unfortunately, we could not find this project","projects.modal.filters.search.hint":"Search for project","projects.modal.success.message":"{count, plural, =1 {1 customer} other {# customers}} added to project","projects.modal.title":"Add to project","projects.page.header.projects.count":"Number of projects: {count} {selected, plural, =0 {} other {, # selected}}","projects.page.title":"Projects","question.editor.buttons.delete.label":"Delete question","question.editor.errors.duplicate-question":"The same question already exists","question.editor.errors.empty-question":"Write a question","question.editor.questions-table.empty.label":"You have not yet added any questions to this list","questionnaire.archive.confirmation.description":"Are you sure you want to archive the questionnaire \\"{name}\\"?","questionnaire.archive.confirmation.title":"Archive questionnaire","questionnaire.choices-table.button.add.label":"Add answer option","questionnaire.choices-table.description.label":"Answer option {index}","questionnaire.choices-table.errors.empty-option":"Empty option","questionnaire.details.page.invalid":"Invalid questionnaire","questionnaire.details.page.title.new-questionnaire":"Create your own KYC-questions","questionnaire.page.add-questionnaire.button.label":"Create KYC-questions","questionnaire.page.filter.hide-archived-questionnaires":"Hide archived questionnaires","questionnaire.page.filter.placeholder":"Filter custom questionnaires by name","questionnaire.page.filter.show-archived-questionnaires":"Show archived questionnaires","questionnaire.page.header.description":"The KYC form you send to your customers consists of predefined questions tailored to your industry. Here you have the opportunity to create custom questionnaires that can be sent to your customers, either together with the industry-tailored KYC form, or alone","questionnaire.page.title":"Create your own KYC-questions","questionnaire.preview.modal.title":"Preview questionnaire \\"{name}\\"","questionnaire.question.description.label":"Question in {language}","questionnaire.question.type.boolean":"Yes/No","questionnaire.question.type.multiple-choice":"Multiple choice","questionnaire.question.type.multiple-country-choice":"Multiple countries","questionnaire.question.type.single-choice":"Single choice","questionnaire.question.type.single-country-choice":"Single country","questionnaire.question.type.text":"Text field","questionnaire.title.label":"Title in {language}","questions.editor.buttons.add-question.label":"Add question","responsible-users.label":"Responsible users","responsible.empty.users":"Select responsible users","responsible.error":"Failed to assign responsible users","responsible.label":"Responsible user","responsible.modal.message":"Set responsible users for {names}","responsible.modal.title":"Set Responsible Users","review.checklist.answer.error.empty-additional-info":"You must enter a description in the text field above","review.checklist.answer.placeholder":"Elaborate here:","review.checklist.details.page.messages.created-successfully":"The review checklist \xab{name}\xbb was created successfully","review.checklist.details.page.title.edit-checklist":"Edit checklist","review.checklist.details.page.title.new-checklist":"Create checklist","review.checklist.duplicate.modal.success.message":"The checklist was copied and saved as \xab{name}\xbb","review.checklist.duplicate.modal.title":"Make a copy of checklist \xab{name}\xbb","review.checklist.editor.condition-type.purpose":"Assignment type","review.checklist.editor.condition-type.risk":"Risk category","review.checklist.editor.condition-type.tags":"Tags","review.checklist.editor.empty.name":"You need to give the check list a name","review.checklist.editor.labels.customer-type":"The checklist should apply to:","review.checklist.editor.labels.required":"Should the checklist be mandatory?","review.checklist.editor.labels.risk-type":"What conditions should trigger the checklist to be added?","review.checklist.editor.labels.selection-type":"Should the checklist be automatically added to the risk review?","review.checklist.editor.labels.yes-always":"Yes, always","review.checklist.editor.labels.yes-choose":"Ja, select condition","review.checklist.editor.selection-type.always":"Always","review.checklist.editor.selection-type.automatic":"Automatically","review.checklist.editor.selection-type.manual":"Manually","review.checklist.editor.tips.banner.description":"1. Give the checklist a name and description, as well as which customer type it should apply to.\\n2. Select whether it should be added automatically to the risk assessment, or select what should trigger the checklist. \\n3. Select whether the checklist should be mandatory for all users.\\n4. Add questions and formulate these as \\"Yes\\"/\\"No\\" questions\\n5. If \\"Yes\\", it is required for the case manager to elaborate further\\n6. Click the \\"Preview\\" button to display the checklist as it will appear in the actual risk assessment","review.checklist.editor.tips.banner.title":"Creation of checklists","review.checklist.preview.modal.title":"Preview checklist \xab{name}\xbb","review.checklist.template.instance.modal.title":"Create a checklist from template: {name}","review.checklist.template.preview.modal.title":"Preview template: {name}","review.checklists.archive.confirmation.description":"Are you sure you want to archive the checklist \xab{name}\xbb?","review.checklists.archive.confirmation.title":"Archive checklist","review.checklists.page.add.button.label":"Create checklist","review.checklists.page.filter.hide-archived-checklists":"Hide archived checklists","review.checklists.page.filter.placeholder":"Filter review checklists by name","review.checklists.page.filter.show-archived-checklists":"Show archived checklists","review.checklists.page.header.description":"Here you can create your own checklists that can be used in the risk assessment of your customers.\\nYou can create new checklists, or take a template and adapt it to your business.","review.checklists.page.table.header":"My checklists","review.checklists.page.title":"Custom Checklists","review.status.APPROVED":"Approved","review.status.NOT_READY":"Not ready - screening in progress","review.status.REJECTED":"Rejected","review.status.REVIEW_REQUIRED":"Review required","reviews.approval-form.title":"Review approval","reviews.header.banner.pending-disclosures.button.label":"See remaining pending KYC and identification {count, plural, =1 {request} other {requests}}","reviews.header.banner.pending-disclosures.description":"There {count, plural, =1 {is 1} other {are #}} pending KYC and identification {count, plural, =1 {request} other {requests}}. These may provide information that affects how you want to risk assess your customer","reviews.header.banner.unreviewed-match-cases.button.label":"See remaining {count, plural, =1 {match} other {matches}}","reviews.header.banner.unreviewed-match-cases.description":"There {count, plural, =1 {is 1 possible match} other {are # possible matches}} that should be reviewed before you can review your customer","reviews.header.title":"Reviews","reviews.labels.ask-for-confirmation":"Ask for confirmation","reviews.labels.change-review":"New review","reviews.labels.customer-risk":"The customer belongs to a risk exposed industry","reviews.labels.mark-as":"Mark customer as","reviews.labels.mark-as.pep":"PEP","reviews.labels.mark-as.sanction":"Sanction","reviews.labels.new-review":"New review","reviews.labels.no-reviews":"There are no reviews on the customer or associated assignments","reviews.labels.perform-a-review":"Perform a review","reviews.labels.relationship.change":"Assign risk","reviews.labels.review-header":"Review","reviews.labels.review-label":"Rationale","reviews.labels.review.assessment":"Approve/Reject review","reviews.labels.risk-indicators":"Risk indicators{count, plural, =0 {} other {: #}}","reviews.labels.risk-tags":"Organize with tags","reviews.labels.select-user-for-confirmation":"Select user for confirmation","reviews.labels.toggle.hide-previous":"Hide previous reviews ({count, number})","reviews.labels.toggle.show-previous":"Show previous reviews ({count, number})","reviews.labels.unmark-as":"Unmarked as {badges}","reviews.placeholders.review-rational":"Explain rationale for the review that has been made","reviews.titles.checklist":"Customer Review Checklist","reviews.titles.existing-reviews":"Existing reviews","reviews.titles.guideline-tips":"Tips on what a good review should contain","reviews.titles.review-customer":"Review Customer","reviews.titles.risk-review":"Risk review","risk-indicators.geographic-risk.description":"Person(s) responsible for reporting, in accordance with the money laundering act \xa7 4-10, should conduct enhanced due diligence for customers and ultimate beneficial owners which are established in high risk countries.","risk-indicators.geographic-risk.title":"{country} found in the following list(s) of high risk countries: {listNames}","risk-indicators.labels.confirmed-matches":"CONFIRMED MATCHES: {count, number}","risk-indicators.labels.disclosure-risk":"KYC ANSWERS{count, plural, =0 {} other {: #}}","risk-indicators.labels.geographic-risk":"GEOGRAPHIC RISK{count, plural, =0 {} other {: #}}","risk-indicators.labels.industry-risk":"INDUSTRY RISK{count, plural, =0 {} other {: #}}","risk-indicators.labels.personnel-risk":"ROLES AND OWNERS RISK{count, plural, =0 {} other {: #}}","risklabel.HIGH":"High","risklabel.LOW":"Low","risklabel.MEDIUM":"Medium","risklabel.NOT_SET":"Not Set","risklabel.null":"Not Set","roles.button.labels.hide-expired-roles":"Hide expired roles","roles.button.labels.show-expired-roles":"Show expired roles ({count, number})","roles.messages.no-roles":"No roles","screening-type.MONITORING":"Continuous","screening-type.NONE":"NONE","screening-type.NOT_SET":"NONE","screening-type.ONE_TIME":"One time","screening-type.label.monitoring":"Continuous","screening-type.label.one-time":"One time","screening-type.modal.message":"Enter screening settings for {names}","screening-type.modal.title":"Choose screening","screening-type.tooltip.person.screening.monitoring":"The person is set to continuous screening","screening-type.tooltip.person.screening.none":"The person is not set to continuous screening","screening.buttons.add-role":"Add role","screening.errors.content":"Try again a bit later","screening.errors.description":"Give it a few seconds and try again. Or go get yourself a coffee :)","screening.errors.heading":"Sorry, this is taking way too long...","screening.infobox.owners.definition":"An (ultimate) beneficial owner is a person who, alone or together with others, can exercise (ultimate) effective control over the company. There are several examples of this:\\n\\n\u2022 A person who alone holds more than 25% of the shares/votes\\n\\n\u2022 Family members who together (directly or indirectly) hold more than 25% of the shares/votes\\n\\n\u2022 A person who, via special articles of association, shareholder agreement(s) or other agreements, controls the company.\\n\\nYou can read more about identifying beneficial owners in the Norwegian Money Laundering Act: https://lovdata.no/lov/2018-06-01-23/\xa714","screening.infobox.owners.text.manual":"Beneficial owners must be added manually when registering foreign companies.","screening.infobox.owners.text.norwegian":"For companies that can have shareholders, we identify natural persons who own 5 percent or more throughout the ownership structure (source: Norwegian Aksjon\xe6rregisteret). You are responsible for verifying these, and, if needed, update and/or add missing beneficial owners.","screening.infobox.owners.title":"What is a beneficial owner?","screening.infobox.roles.definition":"A role holder is a person who holds a role in the company. Examples of this are board members, CEO, and persons who can sign on behalf of the company (have signature/power of attorney rights).","screening.infobox.roles.text.manual":"Role holders must be added manually when registering foreign companies.","screening.infobox.roles.text.norwegian":"We identify persons who, at the time of registration, is registered with roles in the company (source: Br\xf8nn\xf8ysundregistrene).","screening.infobox.roles.title":"What is a role?","screening.messages.retrieving-details":"Retrieving customer data","screening.messages.specify-owners":"Specify beneficial owners in the company","screening.messages.specify-roles":"Specify roles in the company","screening.owners.is_ubo.description":"This person owns more than 25% of the shares in the company (or owns more than 25% of the shares in a company that owns more than 25% of the shares of the customer, etc.), which indicates that the person can be regarded as an ultimate beneficial owner (UBO). See the Norwegian Money Laundering Act: https://lovdata.no/lov/2018-06-01-23/\xa714","screening.roles.is_ubo.description":"Because of the company type ({companyType}), this role ({roleType}) may be considered an alternative UBO.","screening.snackbar.started":"New screening started","screening.snackbar.stopped":"Screening control stopped","screening.snackbar.updated":"Screening control updated","screening.status.active":"Active","screening.status.finished":"(performed {finished, date, ::yyyyMMdd})","screening.status.range":"(started {started, date, ::yyyyMMdd}, stopped {stopped, date, ::yyyyMMdd})","screening.titles.banner.description":"The customer will not be notified that you are conducting a customer check.","screening.titles.banner.title":"Screening is made unnoticed.","screening.titles.customer":"Customer","screening.titles.owners":"Beneficial owners","screening.titles.roles":"Roles","screening.titles.screening":"Screening","screening.titles.screening-frequency":"Choose the frequency of screening","screening.titles.screening.description":"Select the people to be included in the screening. The people presented consist of shareholders with a 5 percent or higher shareholding and identified role holders of the company you are going to register.","screening.titles.screening.manual.description":"Add owners and roles to the company customer you are registering. Remember to check all you want to include in the screening.","screening.titles.screening.without-shareholders.description":"Select the people to be included in the screening. The people presented consist of identified role holders of the company you are going to register.","shares-classes.banner.description":"There are different share classes in {name}. Please note that a person may have voting rights in the customer beyond those resulting from the ownership stake when different share classes with different voting rights have been issued (e.g. A and B shares). This may have an impact on who is to be regarded as the ultimate beneficial owner(s). You should therefore obtain the articles of association from your customer and examine this.","shares-classes.banner.title":"Several share classes identified: {shares}","shares-classes.banner.url-label":"Read more on our support portal","signature.actions.copy.link":"Copy link","signature.actions.delete.signature":"Delete KYC request","signature.actions.edit.signature":"Edit recipient info","signature.actions.remind.signer":"Remind recipient","signature.configuration.form.buttons.preview":"See how the KYC looks for the customer","signature.configuration.form.labels.choose.language":"Select language for emails and KYC questions","signature.configuration.form.labels.choose.send.method":"Select send method","signature.configuration.form.labels.custom.kyc.questions":"Custom KYC questions","signature.configuration.form.labels.disclosure":"KYC questions","signature.configuration.form.labels.disclosure.full":"Full (inc. PEP questions)","signature.configuration.form.labels.disclosure.pep":"PEP questions only","signature.configuration.form.labels.e-signatures":"Send document for e-signing","signature.configuration.form.labels.preview":"Preview of KYC","signature.configuration.form.labels.verification":"Include credentials with:","signature.email.not.provided":"Link available on customer page","signature.modal.and.tooltips.copy.link":"Copy signing link","signature.signing-method.no":"Norwegian BankID","signature.signing-method.se":"Swedish BankID","signature.snackbar.deleted":"KYC request deleted","signature.tooltips.remind.signer":"Remind signer","signing-user-info.address":"Address","signing-user-info.birth-date":"Date of birth","signing-user-info.name.mismatch.warning.tooltip":"Is this the right person?","summary.description":"Look over the summary and make changes if necessary. When you start the screening, the customer will receive a link with electronic identification and a customer questionnaire.","summary.project.title":"Project","summary.responsible-user":"Responsible user","summary.screening-type":"Screening type","summary.signers.start.screening":"Register customer and start screening","summary.signers.text.skipped":"This step was skipped","summary.signers.title":"Recipients of credentials and KYC questions","summary.signers.title.empty":"No representatives selected","summary.text.no-owners":"No owners will be screened","summary.text.no-roles":"No roles will be screened","summary.text.screening.company":"Screening of company","summary.text.screening.owners":"Screening of owners","summary.text.screening.roles":"Screening of roles","table.column.active":"ACTIVE","table.column.address":"ADDRESS","table.column.country":"COUNTRY","table.column.customer-number":"PERSONAL NUMBER / ORG.NR","table.column.customerTypes":"CUSTOMER TYPES","table.column.date.of.birth":"DATE OF BIRTH","table.column.details":"DETAILS","table.column.email":"EMAIL","table.column.email.or.url":"EMAIL/LINK","table.column.gender":"GENDER","table.column.groups":"GROUPS","table.column.id":"ID","table.column.ignore":"IGNORE","table.column.last.updated":"LAST UPDATED","table.column.link":"LINK","table.column.measure":"MEASURE","table.column.name":"NAME","table.column.name-from-search":"NAME FROM SEARCH","table.column.name-on-match":"NAME ON MATCH","table.column.national.id":"NATIONAL ID","table.column.person":"PERSON","table.column.pin":"PIN","table.column.previous-search":"PREVIOUS SEARCH","table.column.questions":"QUESTIONS","table.column.required":"REQUIRED","table.column.responsible-user":"RESPONSIBLE USER","table.column.role":"ROLE","table.column.search-by":"SEARCH BY","table.column.shares":"SHARE","table.column.status":"STATUS","table.column.time-of-search":"TIME OF SEARCH","table.column.title":"TITLE","table.column.ubo":"OWNER","table.column.used":"USED","table.row.owner":"Shareholder","tags.button.label":"Tags","tags.editor.add-and-apply-button":"Add and apply \xab{tag}\xbb","tags.editor.existing-tags":"Existing tags","tags.editor.filter-tags":"Filter tags:","tags.editor.new-tag-input":"New tag","tags.modal.empty-state":"There are currently no tags.","tags.modal.tag.color":"Color","tags.modal.tag.delete-tag":"Delete tag","tags.modal.tag.delete-tag.description":"By deleting the tag \xab{name}\xbb it is also removed from all projects and associated customers.","tags.modal.tag.name":"Tag name in {language}","tags.modal.tag.placeholder":"Tag name","tags.modal.tag.validation-error":"Tag must be unique and not empty","tags.modal.title.add-tag":"Add Tag","tags.modal.title.edit-tags":"Edit Tags","tags.modal.title.update-tag":"Edit Tag","tags.page.assigned-tag.delete.description":"Assigned tag can not be deleted","tags.page.filter.placeholder":"Filter tags by name","tags.page.subtitle":"Create tags to easily group customers/clients. Tags can easily be added to any customer/client and filtered on both in the customer list and on the dashboard.","tags.page.title":"Organize with tags","tags.popover.success.message":"Assigned tag","ubo.manual-override.description":"Changes should be justified in the comment field below.\\n(You will have to change the screening manually if necessary, e.g. if new beneficial owners are to be screened)","ubo.manual-override.title":"Person is ultimate beneficial owner (UBO)","users.modal.empty-group":"No group","users.modal.label.activate":"Activate","users.modal.label.deactivate":"Deactivate","users.modal.title.add-user":"Add User","users.modal.title.update-user":"Update User","users.page.add-user.button-label":"Add User","users.page.filter.hide-inactive-users":"Hide inactive users ({count, number})","users.page.filter.placeholder":"Filter users by name","users.page.filter.show-inactive-users":"Show inactive users ({count, number})","users.page.table.empty":"No users were found","users.page.title":"Users","vitec.modal.banner.description":"This person has no mobile phone number. Vitec Next requires the person\'s mobile number so that the contact card can be imported.","vitec.modal.toast.message.error":"Failed to import {name} to Vitec Next ({error})","vitec.modal.toast.message.success":"{name} was successfully imported to Vitec Next","vitec.report.upload.status.COMPLETED":"Uploaded to Vitec","vitec.report.upload.status.FAILED":"Upload failed","vitec.report.upload.status.WAITING":"Awaiting review"}');

},{}],"eUw6t":[function(require,module,exports) {
module.exports = JSON.parse('{"access-denied.description":"Ta kontakt med oss dersom du \xf8nsker tilgang","access-denied.title":"Her har du dessverre ikke tilgang","archive-assignment.confirmation-modal.description":"Er du sikker p\xe5 at du vil arkivere \xab{name}\xbb?","archive-assignment.confirmation-modal.labels.button.archive":"Arkiver {name}","archive-assignment.confirmation-modal.title":"Arkiver oppdrag","archive-customer.confirmation-modal.description":"Er du sikker p\xe5 at du vil arkivere {name}?\\nArkiverte kunder er ikke synlige i kundeoversikten.\\nDu kan derimot benytte et visningsfilter for \xe5 finne dine arkiverte kunder.","archive-customer.confirmation-modal.description.monitoring":"Ved \xe5 arkivere denne kunden vil den aktive monitoreringen avsluttes.\\nEr du sikker p\xe5 at du fortsatt vil arkivere {name}?\\nArkiverte kunder er ikke synlige i kundeoversikten.\\nDu kan derimot benytte et visningsfilter for \xe5 finne dine arkiverte kunder.","archive-customer.confirmation-modal.labels.button.archive":"Arkiver {name}","archive-customer.confirmation-modal.title":"Arkiver kunde","assignment.selector.error.message":"Velg et oppdrag","attachments.actions.delete-attachment":"Slett dokument","attachments.actions.delete-signed-attachment":"Slett signert dokument","attachments.actions.download-attachment":"Last ned dokument","attachments.actions.download-signed-attachment":"Last ned signert dokument","attachments.actions.edit-signature":"Valg for e-signatur","attachments.actions.section.signed.document.title":"Signert dokument","attachments.actions.signature.help-text":"E-signaturer er kun tilgjengelig for PDF-filer","attachments.actions.view-signature":"Vis e-signatur","attachments.cancel.confirmation.description":"Endringer er ikke lagret.\\nVed \xe5 avbryte vil ikke de angitte motakerne f\xe5 tilgang til signering av dokumentet","attachments.cancel.confirmation.title":"Endringer ikke lagret","attachments.cancel.confirmation.yes":"Avbryt og forkast endringer","attachments.customer.upload.assignment.select":"Velg hvor du vil legge dokumentet","attachments.delete.confirmation.description":"Er du sikker p\xe5 at du \xf8nsker \xe5 slette dokumentet {name} ?","attachments.delete.confirmation.signed.description":"Er du sikker p\xe5 at du har lyst til \xe5 slette det signerte dokumentet: {name}?\\nSiden denne handlingen ikke kan angres, anbefaler vi deg \xe5 laste ned dokumentet f\xf8r du sletter det.","attachments.delete.confirmation.signed.title":"Slett signert dokument","attachments.delete.confirmation.signed.yes":"Slett signert dokument","attachments.delete.confirmation.title":"Slett dokument","attachments.delete.confirmation.yes":"Slett dokument","attachments.labels.empty":"Det er ingen opplastede dokumenter","attachments.labels.loading":"Laster...","attachments.labels.signature-status.expired":"Utg\xe5tt","attachments.labels.signature-status.not-activated":"(ikke aktivert)","attachments.labels.signature-status.not-signed":"{signed} av {total} har signert","attachments.labels.signature-status.pending":"Venter signatur","attachments.labels.signature-status.signed":"Signert","attachments.labels.signature-status.unsignable":"Usignerbar","attachments.section.title":"Dokumenter","attachments.section.title-with-signatures":"Dokumenter og e-signering","attachments.signatures.modal.button.add-recipient":"Legg til mottaker","attachments.signatures.modal.copy-link":"Kopier signeringslink","attachments.signatures.modal.descriptions.unsignable-attachment":"Dokumentet som ble lastet opp kan ikke signeres og m\xe5 lastes opp p\xe5 nytt. Verifiser at dokumentet ikke er passordbeskyttet og at dokumentet ikke er \xf8delagt.","attachments.signatures.modal.heading":"Mottakere","attachments.signatures.modal.labels.automatic-email":"Automatisk e-post","attachments.signatures.modal.labels.create-links":"Opprett link","attachments.signatures.modal.labels.deleted-signed-document":"Signert dokument slettet av {name}, {date}","attachments.signatures.modal.labels.email-sent":"E-post sendt","attachments.signatures.modal.labels.missing-url":"Link er enda ikke opprettet","attachments.signatures.modal.labels.national-id":"Verifiser f\xf8dselsnummer","attachments.signatures.modal.labels.national-id.placeholder":"Mottakerens f\xf8dselsnummer ({maxDigits} sifre)","attachments.signatures.modal.labels.saved-changes":"Endringer lagret","attachments.signatures.modal.labels.send-emails-and-create-links":"Send e-post og opprett link","attachments.signatures.modal.labels.unsaved-changes":"Endringer ikke lagret","attachments.signatures.modal.labels.unsignable-attachment":"Dokumentet kan ikke signeres","attachments.signatures.modal.name.placeholder":"Mottakerens navn","attachments.signatures.modal.table.column.date-signed":"DATO SIGNERT","attachments.signatures.modal.title":"Signatur p\xe5 \xab{filename}\xbb","attachments.table.header.assignment":"OPPDRAG","attachments.table.header.created.by":"LASTET OPP AV","attachments.table.header.created.date":"LASTET OPP","attachments.table.header.document":"DOKUMENT","attachments.table.header.signature-status":"SIGNERINGSSTATUS","attachments.table.messages.uploading":"Laster opp {count, plural, =1{} other {# dokumenter}}...","attachments.upload.button":"Last opp dokument","attachments.upload.button.available-file-types":"Disse filtypene st\xf8ttes:","auto-reminders-settings.description":"Kjenn Din Kunde kan automatisk varsle dine mottakere av legitimering- og KYC-foresp\xf8rsler ved mangel p\xe5 besvarelse. P\xe5minnelsen sendes per e-post, og gjelder bare for mottakere som blir tilsendt foresp\xf8rsel p\xe5 e-post.","auto-reminders-settings.form.label":"N\xe5r skal p\xe5minnelsen sendes?","auto-reminders-settings.limit-options.label":"Hvor mange ganger skal vi sende automatisk p\xe5minnelse p\xe5 e-post?","auto-reminders-settings.page.title":"KYC-p\xe5minnelse","auto-reminders-settings.send-options.bi-weekly":"Etter to uker","auto-reminders-settings.send-options.custom":"Egendefinert","auto-reminders-settings.send-options.custom.placeholder":"Antall dager","auto-reminders-settings.send-options.not-set":"Ikke send automatiske p\xe5minnelser","auto-reminders-settings.send-options.weekly":"Etter \xe9n uke","badge.archived":"Arkivert","badge.negative-news":"Negative nyheter","badge.other":"Annet","badge.pep":"PEP","badge.sanctioned":"Sanksjon","bulk.actions.add-to-existing-project.label":"Legg til i eksisterende prosjekt","bulk.actions.add-to-new-project.label":"Legg til i nytt prosjekt","bulk.actions.archive.confirmation.description":"Er du sikker p\xe5 at du vil arkivere {names}?","bulk.actions.archive.confirmation.title":"Arkiver kunder","bulk.actions.archive.success.message":"{count, plural, =1 {kunde} other {# kunder}} arkivert","bulk.actions.change-screening-type.label":"Screening-innstillinger","bulk.actions.delete.confirmation.check":"Jeg bekrefter at jeg \xf8nsker \xe5 slette de valgte kundene","bulk.actions.delete.confirmation.description":"Du er i ferd med \xe5 slette markerte kunder permanent fra Kjenn Din Kunde.\\nDette kan ikke reverseres.\\nEr du helt sikker p\xe5 at du vil slette: {names}? ","bulk.actions.delete.confirmation.title":"Slett kunder","bulk.actions.delete.success.message":"{count, plural, =1 {kunde} other {# kunder}} Slettet","bulk.actions.followup.label":"Velg en oppf\xf8lgingsdato","bulk.actions.followup.success.message":"Screening type endret","bulk.actions.reject-match-cases.confirmation.description":"Er du sikker p\xe5 at du vil avkrefte {count, number} treff?","bulk.actions.reject-match-cases.confirmation.title":"Avkreft treff","bulk.actions.reject-match-cases.success.message":"{count, number} treff avkreftet","bulk.actions.responsible.label":"Velg ansvarlig","bulk.actions.responsible.success.message":"Ansvarlige brukere endret","bulk.actions.restore.confirmation.description":"Er du sikker p\xe5 at du vil gjenopprette {names}?","bulk.actions.restore.confirmation.title":"Gjenopprett kunder","bulk.actions.restore.success.message":"{count, plural, =1 {kunde} other {# kunder}} gjenopprettet","bulk.actions.screening-type.success.message":"Screening-innstillinger ble endret","button.go.back":"Tilbake","button.go.next":"G\xe5 videre","change-screening.buttons.save":"Endre screening","change-screening.buttons.start-screening":"Start ny screening","change-screening.buttons.stop-monitoring":"Stopp screening","change-screening.stop-screening.description":"Du vil ikke lenger motta oppdateringer p\xe5 eventuelle nye treff mot PEP, sanksjon og negative nyheter p\xe5 personer som har v\xe6rt under kontroll.","change-screening.stop-screening.description-person":"Du vil ikke lenger motta oppdateringer p\xe5 eventuelle nye treff mot PEP, sanksjon og negative nyheter p\xe5 vedkommende.","change-screening.stop-screening.title":"Er du sikker p\xe5 at du vil stoppe screeningen?","change-screening.titles.choose-screening-type":"Velg type screening","change-screening.titles.new-screening":"Ny screening","change-screening.titles.screening-owners":"Screening av rettighetshavere","change-screening.titles.screening-person":"Screening utf\xf8res p\xe5","change-screening.titles.screening-roles":"Screening av rolleinnehavere","change-screening.titles.screening-title":"Endre screening","common.address.addressline1":"Adresselinje 1","common.address.addressline2":"Adresselinje 2","common.address.city":"Poststed","common.address.country":"Adresseland","common.address.county":"Fylke","common.address.postal.code":"Postnummer","common.answered.label":"Besvart av {name}, {timestamp, date, ::yyyyMMdd}","common.badge.new-info":"NY INFO","common.banner.followup-expired.description":"L\xf8pende oppf\xf8lging p\xe5 denne kunden er satt til {followup, date, ::yyyyMMdd}. Gj\xf8r de n\xf8dvendige oppf\xf8lgingsrutinene, og legg igjen en ny vurdering av kunden.","common.banner.followup-expired.title":"Kunden venter l\xf8pende oppf\xf8lging","common.banner.possible.match.description":"Mulig treff p\xe5 PEP, sanksjon eller negative nyheter.","common.banner.possible.match.title":"Mulig treff","common.buttons.action.edit":"Endre info","common.buttons.actions.archive-assignment":"Arkiver oppdrag","common.buttons.actions.archive-customer":"Arkiver kunde","common.buttons.actions.button":"Handlinger","common.buttons.actions.change-screening":"Endre screening","common.buttons.actions.create-assignment":"Opprett oppdrag","common.buttons.actions.delete-customer":"Slett kunde","common.buttons.actions.download.report":"Last ned rapport","common.buttons.actions.edit-assignment":"Rediger oppdragsdetaljer","common.buttons.actions.edit-company-info":"Endre selskapsdetaljer","common.buttons.actions.edit-person-info":"Endre persondetaljer","common.buttons.actions.new-assignment":"Nytt oppdrag","common.buttons.actions.new-assignment-disclosure":"Send KYC-sp\xf8rsm\xe5l knyttet til oppdraget","common.buttons.actions.new-disclosure":"Send KYC-sp\xf8rsm\xe5l","common.buttons.actions.new-screening":"Ny screening","common.buttons.actions.restore-assignment":"Gjenopprett oppdrag","common.buttons.actions.restore-customer":"Gjenopprett kunde","common.buttons.actions.skip-step":"Hopp over dette steget","common.buttons.move-down":"Flytt ned","common.buttons.move-up":"Flytte opp","common.country-select.choose-country-option":"Velg land","common.date-input.placeholder":"dd/mm/\xe5\xe5\xe5\xe5","common.errors.company-external-id.exists":"En kunde med samme eksterne ID finnes allerede","common.errors.company-national-id.exists":"En kunde med samme org.nr. finnes allerede","common.errors.company.exists":"En tilsvarende selskapskunde finnes allerede","common.errors.email.not-unique":"E-post eksisterer allerede","common.errors.file-size-exceeded":"Opplastede filer kan ikke v\xe6re st\xf8rre enn {max, number}mb. \\nReduser st\xf8rrelsen p\xe5 filen og pr\xf8v igjen.","common.errors.generic":"Noe gikk galt","common.errors.generic.failed-action":"Kunne ikke {actionLabel} ({message})","common.errors.invalid.account-number":"Feil i kontonummer. Sjekk at du har f\xe5tt med alle 11 sifre.","common.errors.invalid.address":"Ugyldig adresse","common.errors.invalid.birth.date":"Ugyldig f\xf8dselsdato","common.errors.invalid.citizenship":"Ugyldig statsborgerskap","common.errors.invalid.comment":"Ugyldig kommentar","common.errors.invalid.company.national-id":"Ugyldig org.nr.","common.errors.invalid.email":"Ugyldig e-post","common.errors.invalid.empty.mobile-phone":"Tomt mobilnummer","common.errors.invalid.empty.name":"Tomt navn","common.errors.invalid.empty.title":"Tom tittel","common.errors.invalid.first.name":"Ugyldig fornavn","common.errors.invalid.last.name":"Ugyldig etternavn","common.errors.invalid.missing.last.name":"Mangler etternavn","common.errors.invalid.name.exists":"Navnet finnes allerede","common.errors.invalid.national-id.exists":"F\xf8dselsnummer finnes allerede","common.errors.invalid.person.national-id":"Ugyldig personnummer","common.errors.invalid.person.national-id-country":"Velg land fra listen","common.errors.person-external-id.exists":"En kunde med samme eksterne ID finnes allerede","common.errors.person-national-id.exists":"En kunde med samme personnummer finnes allerede","common.errors.person.exists":"En tilsvarende personkunde finnes allerede","common.errors.required.first.name":"Fornavn p\xe5krevd","common.errors.required.last.name":"Etternavn p\xe5krevd","common.group.role.key.compliance-officer":"Etterlevelsesansvarlig","common.group.role.key.kdk-admin":"Brukeradmin","common.group.role.key.mlro":"Hvitvaskingsansvarlig","common.labels.address":"Adresse","common.labels.approve":"Godkjenn","common.labels.approved":"Godkjent","common.labels.archived-by":"Arkivert av {name}, {timestamp, date, ::yyyyMMdd}","common.labels.bank-id":"BankID","common.labels.birth_date":"F\xf8dselsdato","common.labels.both-customer-types":"Begge typer kunder","common.labels.business-address":"Forretningsadresse","common.labels.calculated-ubo":"Eierandelen indikerer at personen er \xe5 anse som reell rettighetshaver","common.labels.change-seen":"Endring sett","common.labels.citizenship":"Statsborgerskap","common.labels.collapse-all":"Skjul alle","common.labels.comment":"Kommentar","common.labels.complete":"Fullf\xf8r","common.labels.completed-by":"Fullf\xf8rt av {name}, {timestamp, date, ::yyyyMMdd}","common.labels.confirmed-by":"Bekreftet av {name}, {timestamp, date, ::yyyyMMdd}","common.labels.country":"Land","common.labels.country-of-origin":"F\xf8deland","common.labels.country-of-residence":"Bosteds/oppholdsland","common.labels.create-tag":"Opprett Tag","common.labels.created-by":"Opprettet av {name}, {timestamp, date, ::yyyyMMdd}","common.labels.customer-relationship":"Kundeforhold","common.labels.customer-type":"Velg hva slags type kunde(r) sp\xf8rreskjemaet skal gjelde for:","common.labels.customer-type.company":"Selskap","common.labels.customer-type.person":"Person","common.labels.customer.risk":"kunderisiko","common.labels.description":"Beskrivelse","common.labels.editorial-explanation":"Redaksjonell forklaring","common.labels.email":"E-post","common.labels.end-date":"Sluttdato","common.labels.expand-all":"Utvid alle","common.labels.file.upload":"Last opp fil","common.labels.first_name":"Fornavn","common.labels.go-to-support-page":"G\xe5 til supportsiden","common.labels.groups":"Grupper","common.labels.include-assignment":"Inkluder oppdrag","common.labels.kyc":"KYC","common.labels.kyc-responses":"KYC-besvarelser","common.labels.last_name":"Etternavn","common.labels.manual-ubo":"Manuelt markert som reell rettighetshaver","common.labels.mark-person-as-pep":"Personen er PEP","common.labels.mark-person-as-sanctioned":"Personen er sanksjonert","common.labels.missing-information":"Manglende informasjon","common.labels.mobile-phone":"Mobilnummer","common.labels.modified-by":"Sist endret av {name}, {timestamp, date, ::yyyyMMdd}","common.labels.more-information-at":"Mer informasjon p\xe5 v\xe5r","common.labels.name":"Navn","common.labels.national-id":"F\xf8dselsnummer","common.labels.national-id-country":"Land tilknyttet f\xf8dselsnummer","common.labels.nationality":"Statsborgerskap","common.labels.office-address":"Kontoradresse","common.labels.pep-position-country":"Ansettelsesland for stillingen til PEP","common.labels.photo":"Bilde","common.labels.reject":"Avsl\xe5","common.labels.rejected":"Avsl\xe5tt","common.labels.rejected-by":"Avsl\xe5tt av {name}, {timestamp, date, ::yyyyMMdd}","common.labels.risk-category.geographical":"Geografisk risiko","common.labels.risk-category.industry":"Bransjerisiko","common.labels.risk-category.pep":"PEP","common.labels.risk-category.sanction":"Sanksjon","common.labels.risk-response":"Risikobesvarelse","common.labels.risk-type":"risikotype","common.labels.save-changes":"Lagre endringer","common.labels.save-settings":"Lagre innstillinger","common.labels.saved-successfully":"Endringer lagret","common.labels.selected-customers-count":"Markerte kunder: {count, number}","common.labels.show-less":"Vis mindre","common.labels.show-more":"Vis mer","common.labels.show-more-with-count":"Vis fler ({count, number})","common.labels.start-date":"Startdato","common.labels.take-me-back":"Ta meg tilbake","common.labels.title":"Tittel","common.labels.triggered-when":"Trigges ved:","common.labels.try-again":"Pr\xf8v igjen","common.labels.ubo":"Reell rettighetshaver","common.labels.unidentified-owner":"Uidentifisert eier","common.language.english":"engelsk","common.language.norwegian":"norsk","common.loading.data":"Henter data","common.month":"{months, plural, =1 {1 m\xe5ned} other {# m\xe5neder}}","common.multiple-names.full":"{fullnames} og {count, number} andre","common.multiple-names.short":"{fullnames} og {lastname}","common.reviewed.label":"Vurdert av {name}, {timestamp, date, ::yyyyMMdd}","common.roles.ACCOUNTANT":"Regnskapsf\xf8rer","common.roles.ALTERNATE_BOARD_MEMBER":"Varamedlem","common.roles.AUDITOR":"Revisor","common.roles.BOARD_MEMBER":"Styremedlem","common.roles.CEO":"Daglig leder","common.roles.CHAIRMAN":"Styrets leder","common.roles.COMPLEMENTARY":"Komplementar","common.roles.CONTACT_PERSON":"Kontaktperson","common.roles.DEPUTY_BOARD_MEMBER":"Varamedlem","common.roles.DEPUTY_CHAIRMAN":"Nestleder","common.roles.MANAGER":"Forretningsf\xf8rer","common.roles.MANAGING_DIRECTOR":"Bestyrende reder","common.roles.NORWEGIAN_REPRESENTATIVE":"Norsk representant (NUF)","common.roles.OBSERVER":"Observat\xf8r","common.roles.PARTICIPANT_FULL_RESPONSIBILITY":"Deltaker med solidarisk ansvar (fullt ansvarlig)","common.roles.PARTICIPANT_PART_RESPONSIBILITY":"Deltaker med proratarisk ansvar (delt ansvar)","common.roles.PROCURA":"Prokura","common.roles.PROCURA_JOINTLY":"Prokura i fellesskap","common.roles.PROCURA_SEPARATELY":"Prokura hver for seg","common.roles.PROPRIETOR":"Innehaver","common.roles.REPRESENTATIVE":"Representant","common.roles.SIGNATURE":"Signatur","common.roles.SIGNATURE_JOINTLY":"Signatur i fellesskap","common.roles.SIGNATURE_SEPARATELY":"Signatur hver for seg","common.roles.TRUSTEE":"Bobestyrer","common.roles.UNKNOWN_ROLE":"Ukjent rolle","common.roles.not.in.use":"ikke i bruk","common.roles.null":"Ukjent rolle","common.share-class.CLASS_A":"A-AKSJER","common.share-class.CLASS_B":"B-AKSJER","common.share-class.CLASS_C":"C-AKSJER","common.share-class.CLASS_D":"D-AKSJER","common.share-class.CLASS_E":"E-AKSJER","common.share-class.CLASS_F":"F-AKSJER","common.share-class.CLASS_G":"G-AKSJER","common.share-class.CLASS_H":"H-AKSJER","common.share-class.CLASS_I":"I-AKSJER","common.share-class.CLASS_J":"J-AKSJER","common.share-class.EXTRAORDINARY_SHARES":"EKSTRAORDIN\xc6RE AKSJER","common.share-class.ISIN":"ISIN","common.share-class.ORDINARY_SHARES":"ORDIN\xc6RE AKSJER","common.share-class.PREFERRED_SHARES":"PREFERANSE AKSJER","common.share-class.UNKNOWN_SHARE_CLASS":"UKJENT AKSJEKLASSE","common.vitec.synced":"Synkronisert til Vitec","common.vitec.synchronize":"Synkroniser til Vitec","common.year":"{years, number} \xe5r","company-card.errors.fetch-failed-action":"Hente selskapsopplysninger","company-form.headings.details":"Selskapsdetaljer","company-form.labels.country":"Land","company-form.labels.external-id":"Ekstern ID","company-form.labels.name":"Selskapsnavn","company-form.labels.national-id":"Org.nr.","company.details.caption.address":"ADRESSE","company.details.caption.address.postal":"POSTADRESSE","company.details.caption.address.visit":"BES\xd8KSADRESSE","company.details.caption.closure_date":"Avslutningsdato","company.details.caption.company.type":"ORGANISASJONSFORM","company.details.caption.country":"LAND","company.details.caption.employees":"ANSATTE","company.details.caption.est":"ETABLERT","company.details.caption.external-id":"ID","company.details.caption.industry-codes":"N\xc6RINGSKODER","company.details.caption.is_bankrupt":"KONKURS","company.details.caption.name":"NAVN","company.details.caption.national_id":"ORG.NR.","company.details.caption.registered-in-foundation":"I STIFTELSESREGISTERET","company.details.caption.registered-in-vat":"I MVA-REGISTERET","company.details.caption.under_forced_liquidation":"UNDER TVANGSLIKVIDASJON ELLER OPPL\xd8SNING","company.details.caption.under_liquidation":"UNDER AVVIKLING","company.details.caption.website":"HJEMMESIDE","company.details.changes.tooltip.banner":"Endringer i selskapsdetaljer vises som \xabNy\xbb inntil det er markert som \xabEndring sett\xbb eller det er foretatt en ny kundevurdering","company.details.changes.tooltip.button.label":"Ny kundervurdering","company.details.new-role.tooltip.banner":"Nye rolleinnehavere er markert som \xabNy\xbb inntil det er foretatt en endring p\xe5 screeningen","company.details.new-role.tooltip.button.label":"Endre screening","company.details.onboarding.no-screening-performed":"Ingen screening gjennomf\xf8rt","company.details.onboarding.title":"Disse er omfattet av screeningen","company.details.screening.title":"hvem som er omfattet av screeningen","company.details.title":"selskapsdetaljer","company.owners.archive.description":"Er du sikker p\xe5 at du vil arkivere: <bold>{name}</bold>?","company.owners.hide-historical-owners":"Skjul historiske rettighetshavere","company.owners.title":"Eierskapsinformasjon","company.owners.view-historical-owners":"Vis historiske rettighetshavere","company.owners.warning.foreign-company":"Aksjon\xe6rregisteret gir informasjon om at et selskap har eierandeler i din kunde, men informasjonen er mangelfull. Kontakt kunden for \xe5 f\xe5 en oversikt over eierskaps- og kontrollstrukturen og reelle rettighetshavere.","company.owners.warning.unidentified-owner":"Din kunde har eier(e) i eierstrukturen som ikke kan identifiseres fra Aksjon\xe6rregisteret. Kontakt kunden for \xe5 f\xe5 en oversikt over eierskaps- og kontrollstrukturen og reelle rettighetshavere.","company.roles.title":"Rolleinnehavere","component.filter.country.title":"Land","component.filter.customer.option.company.title":"Selskap","component.filter.customer.option.person.title":"Person","component.filter.customer.title":"Kunde","component.filter.risk.title":"Kunderisiko","component.filter.screening.title":"Type screening","component.filters.all.title":"Alle","component.filters.archive.option.include-archived-customers":"Vis arkiverte kunder","component.filters.archive.title":"Arkiverte kunder","component.filters.button.reset":"Nullstill","component.filters.created-after.title":"Lagt til etter","component.filters.created-before.title":"Lagt til f\xf8r","component.filters.created.applied.range.MONTH":"Lagt til den siste m\xe5neden","component.filters.created.applied.range.WEEK":"Lagt til den siste uken","component.filters.created.applied.range.YEAR":"Lagt til det siste \xe5ret","component.filters.created.labels.after":"Lagt til etter {date}","component.filters.created.labels.before":"Lagt til f\xf8r {date}","component.filters.created.range.ALL":"Alle","component.filters.created.range.CUSTOM":"Egendefinert tidsintervall","component.filters.created.range.MONTH":"Siste m\xe5ned","component.filters.created.range.WEEK":"Siste uke","component.filters.created.range.YEAR":"Siste \xe5r","component.filters.created.title":"Lagt til","component.filters.followup-after.title":"Oppf\xf8lging etter","component.filters.followup-before.title":"Oppf\xf8lging f\xf8r","component.filters.followup-expired.title":"Oppf\xf8lging utl\xf8pt","component.filters.followup.applied.range.MONTH":"Oppf\xf8lging neste m\xe5ned","component.filters.followup.applied.range.WEEK":"Oppf\xf8lging neste uke","component.filters.followup.applied.range.YEAR":"Oppf\xf8lging om ett \xe5r","component.filters.followup.labels.after":"Oppf\xf8lging til etter {date}","component.filters.followup.labels.before":"Oppf\xf8lging til f\xf8r {date}","component.filters.followup.option.expired":"Oppf\xf8lging utl\xf8pt","component.filters.followup.range.ALL":"Alle","component.filters.followup.range.CUSTOM":"Egendefinert tidsintervall","component.filters.followup.range.MONTH":"Neste m\xe5ned","component.filters.followup.range.WEEK":"Neste uke","component.filters.followup.range.YEAR":"Neste \xe5r","component.filters.followup.title":"Oppf\xf8lging","component.filters.include.archive.title":"Inkluder arkiverte kunder","component.filters.industry-type.title":"Bransjer","component.filters.marked-as.option.pep":"PEP","component.filters.marked-as.option.sanction":"Sanksjon","component.filters.marked-as.title":"Markert som (PEP/Sanksjon)","component.filters.match.option.open.matches":"Uvurderte treff","component.filters.match.text.open.matches":"Har uvurderte treff","component.filters.match.text.pep.matches":"Markert som PEP","component.filters.match.text.sanction.matches":"Markert som sanksjon","component.filters.ownership-updates.label":"Vis bare kunder med oppdatert informasjon fra Aksjon\xe6rregisteret","component.filters.ownership-updates.title":"Oppdatering p\xe5 eierforhold","component.filters.pending-measures.option":"Har ventende tiltak","component.filters.pending-measures.title":"Har ventende tiltak","component.filters.project.option.active":"Aktivt","component.filters.project.option.inactive":"Inaktiv","component.filters.responsible.user.inactive":"Inaktiv","component.filters.saved-filters.delete-filter":"Slett lagret filter","component.filters.saved-filters.deleted.message":"Filter slettet","component.filters.saved-filters.empty.message":"Legg til filtre i kundelisten og klikk \u201CLagre filter\u201C for \xe5 lagre","component.filters.saved-filters.filter-name":"filter navn","component.filters.saved-filters.my-customers":"Mine kunder","component.filters.saved-filters.save-filters.label":"Lagre filter","component.filters.saved-filters.saved.message":"Filtre lagret \uD83C\uDF89","component.filters.saved-filters.title":"Lagrede filtre","component.filters.saved-filters.without-filters":"Uten filter","component.filters.screening.option.monitoring":"L\xf8pende","component.filters.screening.option.one-time":"Kun enkeltst\xe5ende","component.filters.status.approved":"Godkjent","component.filters.status.draft-review":"Vurderingsutkast","component.filters.status.not-ready":"Ikke vurdert","component.filters.status.rejected":"Avsl\xe5tt","component.filters.status.review-approval-required":"Venter bekreftelse p\xe5 vurdering","component.filters.status.review-required":"Klar for vurdering","component.filters.status.started":"P\xe5begynt","component.filters.status.title":"Status","component.filters.tags.title":"Tags","component.filters.text.and":"og","component.filters.unresolved-matched.title":"Treff","component.notes.delete.confirmation.description":"Er du sikker p\xe5 at du \xf8nsker \xe5 slette notaten?","component.notes.delete.confirmation.title":"Slett notat","component.notes.labels.save-note":"Lagre notat","component.notes.title":"Notater {count, plural, =0 {} other {(#)}}","component.pagination.labels.select-limit":"Vis {limit} kunder","component.pagination.labels.showing":"Viser {start, number} - {end, number} av {count, number}","component.questionnaires-list.empty":"Dere har ikke opprettet noen egne KYC-sp\xf8rsm\xe5l. Det kan opprettes [her]({link}).  \\nPS. Det er Hvitvaskingsansvarlig / Etterlevelsesansvarlig i deres selskap som oppretter dette i Innstillinger.","component.questionnaires-list.filter.label":"Filtrer egendefinerte sp\xf8rreskjemaer:","component.questionnaires-list.loading":"Laster egendefinerte sp\xf8rreskjemaer","component.questionnaires-list.loading.error-action":"Hente egendefinerte sp\xf8rreskjema","component.review.checklist.added.toast.message":"Ny sjekkliste lagt til.","component.review.checklist.added.toast.scroll.label":"Se sjekklisten","component.review.checklist.create-instance":"Bruk mal","component.review.checklist.form.remove.confirmation.description":"Er du sikker p\xe5 at du vil fjerne \xab{name}\xbb?","component.review.checklist.form.remove.confirmation.title":"Slett sjekkliste","component.review.checklist.select.button.label.add":"Legg til sjekkliste","component.review.checklist.select.checklists-list.filter.label":"Filtrer egendefinerte sjekklister:","component.review.checklist.select.checklists-list.loading":"Laster egendefinert sjekkliste","component.review.checklist.select.checklists-list.loading.error":"Noe gikk galt ved henting av sjekklister","component.review.checklist.template.title":"Velg mal","component.search.customers.hint":"S\xf8k p\xe5 kunde","component.users-list.all-users.title":"Alle Brukere","component.users-list.filter.label":"Filtrer brukere:","component.users-list.loading":"Laster brukere","component.users-list.loading.error-action":"Hente brukere","copy-label.buttons.copy.tooltip":"Kopier til utklippstavle","customer-assignments.completed":"Fullf\xf8rt","customer-assignments.details.assignment-description":"Oppdragsbeskrivelse","customer-assignments.details.assignment-industry-type":"Oppdragets bransje","customer-assignments.details.assignment-purpose":"Oppdragstype","customer-assignments.details.assignment-risk":"Oppdragsrisiko","customer-assignments.empty":"Det er ikke registrert noen oppdrag p\xe5 denne kunden.","customer-assignments.list.filter.hide-archived-assignments":"Skjul arkiverte oppdrag ({count, number})","customer-assignments.list.filter.show-archived-assignments":"Vis arkiverte oppdrag ({count, number})","customer-assignments.list.header.added":"LAGT TIL","customer-assignments.list.header.name":"TITTEL","customer-assignments.list.header.responsible":"ANSVARLIG BRUKERE","customer-assignments.list.header.risk":"OPPDRAGSRISIKO","customer-assignments.list.header.status":"STATUS","customer-assignments.modal.assignment-description":"Oppdragsbeskrivelse","customer-assignments.modal.assignment-industry":"Bransje som oppdraget tilh\xf8rer (valgfritt)","customer-assignments.modal.assignment-industry.placeholder":"Velg en bransje fra listen","customer-assignments.modal.assignment-name":"Oppdragsnavn","customer-assignments.modal.assignment-purpose":"Oppdragstype (valgfritt)","customer-assignments.modal.assignment-purpose.placeholder":"Velg fra liste eller definer et nytt form\xe5l","customer-assignments.modal.assignment-purpose.placeholder-without-description":"Velg form\xe5l fra liste","customer-assignments.no-disclosures.text":"Det er ingen KYC-foresp\xf8rsler knyttet til dette oppdraget.","customer-assignments.no-disclosures.title":"Send KYC-foresp\xf8rsler knyttet til dette oppdraget ved \xe5 trykke p\xe5 knappen under.","customer-assignments.review.button.action":"Vurder oppdrag","customer-assignments.review.button.change":"Oppdater risikovurdering","customer-assignments.review.not-reviewed":"Oppdraget har ikke blitt vurdert","customer-assignments.review.status.pending":"Venter vurdering","customer-assignments.review.status.waiting":"Venter legitimering","customer-assignments.review.title":"Risikovurdering av oppdrag","customer-assignments.title":"Oppdrag","customer-notifications-settings.description":"Velg hvor ofte du vil motta oppdateringer p\xe5 selskapsinformasjon fra Enhetsregisteret. Velg <bold>umiddelbart</bold> dersom du \xf8nsker e-post for hver selskapsoppdatering, velg <bold>daglig</bold> dersom du \xf8nsker e-post som samler opp daglige oppdateringer, velg <bold>ukentlig</bold> dersom du \xf8nsker e-post som samler opp ukentlige oppdateringer.","customer-notifications-settings.frequency.label":"Hvor ofte vil du motta varsling p\xe5 e-post?","customer-notifications-settings.frequency.options.daily":"Daglig","customer-notifications-settings.frequency.options.immediately":"Umiddelbart","customer-notifications-settings.frequency.options.weekly":"Ukentlig","customer-notifications-settings.page.title":"Oppdateringer p\xe5 selskapsinformasjon","customer-projects.empty":"Ingen prosjekter funnet","customer-review-assignment.labels.include-assignment":"Velg hva risikovurderingen gjelder","customer-review-guideline-settings.labels.guideline.header":"Overskrift","customer-review-guideline-settings.page.description":"Dersom du \xf8nsker \xe5 lage dine egne rutiner for kundevurdering kan du endre p\xe5 teksten under. Du kan n\xe5r som helst endre tilbake til den opprinnelige teksten ved \xe5 tilbakestille. PS. Velger du \xe5 tilbakestille, gjelder dette p\xe5 b\xe5de person og selskapskunder.","customer-review-guideline-settings.page.reset.confirmation.description":"Er du sikker p\xe5 at du vil tilbakestille til den opprinnelige teksten fra systemet?\\nDette vil slette endringene du har gjort b\xe5de p\xe5 personkunder og selskapskunder.","customer-review-guideline-settings.page.reset.confirmation.title":"Tilbakestill rutiner for kundevurdering","customer-review-guideline-settings.page.title":"Rutiner for kundevurdering","customer.checklist.review.form.header":"Sjekklister","customer.details.archived-date":"Arkivert av {name}, {timestamp, date, ::yyyyMMdd}","customer.notes.placeholder":"Legg igjen notater om kunden","customers.list.column.added":"LAGT TIL","customers.list.column.customer":"KUNDE","customers.list.column.customers.count":"ANTALL KUNDER","customers.list.column.external-id":"ID","customers.list.column.report":"RAPPORT","customers.list.column.responsible.users":"ANSVARLIG BRUKER","customers.list.column.risk":"KUNDERISIKO","customers.list.column.tasks":"OPPGAVER","customers.list.empty.content":"Det var ingen kunder som matchet s\xf8ket og/eller filtervalgene dine","customers.list.empty.title":"S\xf8ket ditt ga ingen treff","customers.list.external-id.tooltip":"Ekstern ID: {id}","customers.list.fresh-customer.content":"Da er det vel p\xe5 tide \xe5 komme i gang!","customers.list.fresh-customer.label":"N\xe5 er jeg klar!","customers.list.fresh-customer.title":"Har du ikke lagt inn noen kunder enn\xe5?","customers.list.header.customers.count":"Antall kunder: {count, number} {selected, plural, =0 {} other {(# valgt)}}","customers.list.header.customers.count.all":"Antall kunder: {count, number} (alle valgt)","customers.list.header.selected.count":"{count} valgt","customers.list.paging.limit.select.label":"Vis {limit} kunder","customers.list.paging.next":"Neste","customers.list.paging.previous":"Forrige","customers.list.paging.showing":"Viser {start} - {end} av {count}","customers.list.tabs.labels.all":"Alle kunder ({count, number})","customers.list.tabs.labels.pending-tasks":"Kunder med utest\xe5ende oppgaver","customers.list.title":"Kunder","dashboard.filters.date.from":"Fra: {date}","dashboard.filters.date.interval.ANNUALLY":"Siste \xe5r","dashboard.filters.date.interval.CUSTOM_DATE_RANGE":"Egendefinert tidsintervall","dashboard.filters.date.interval.DAILY":"Siste dag","dashboard.filters.date.interval.MONTHLY":"Siste m\xe5ned","dashboard.filters.date.interval.QUARTERLY":"Siste kvartal","dashboard.filters.date.interval.WEEKLY":"Siste uke","dashboard.filters.date.title":"Tidsintervall","dashboard.filters.date.until":"Til: {date}","dashboard.widgets.active-customers.title":"Mine kunder","dashboard.widgets.industry-types.empty.message":"Ingen bransjer funnet","dashboard.widgets.industry-types.filter.placeholder":"Filtrer p\xe5 bransjer","dashboard.widgets.industry-types.title":"Bransje","dashboard.widgets.marked-as-pep.title":"Kunder med PEP status","dashboard.widgets.marked-as-sanctioned.title":"Sanksjonerte kunder","dashboard.widgets.pending-tasks.title":"Kunder med utest\xe5ende oppgaver","dashboard.widgets.risk-data.PEP":"Politisk Eksponert Person","dashboard.widgets.risk-data.by.assignment.title":"AML-rapportering for eiendomsmeglingsvirksomheter - oppdrag importert fra Vitec Next","dashboard.widgets.risk-data.by.assignment.tooltip":"Tallene er linket mot oppdrag importert fra Vitec Next, og inkluderer arkiverte oppdrag.\\n\\nTallene er hentet fra KYC-besvarelse(r), med unntak av PEP-status og tilknytning til h\xf8yrisikoland.\\n\\nPEP-status avhenger av om en kunde i oppdraget er markert som PEP i Kjenn Din Kunde.\\n\\nTilknytning til h\xf8yrisikoland er en kombinasjon av informasjon registrert i Kjenn Din Kunde og KYC-besvarelse.","dashboard.widgets.risk-data.by.customer.title":"AML-rapportering for eiendomsmeglingsvirksomheter - tall per kunde","dashboard.widgets.risk-data.by.customer.tooltip":"Tallene inkluderer alle kunder som har besvart minst ett KYC-skjema, og inkluderer arkiverte kunder.\\n\\nTallene er hentet fra KYC-besvarelse(r), med unntak av PEP-status og tilknytning til h\xf8yrisikoland.\\n\\nPEP-status avhenger av om kunden er markert som PEP i Kjenn Din Kunde.\\n\\nTilknytning til h\xf8yrisikoland er en kombinasjon av informasjon registrert i Kjenn Din Kunde og KYC-besvarelse.","dashboard.widgets.risk-data.construction-industry":"Bransjetilh\xf8righet i bygg- og anleggsbransjen","dashboard.widgets.risk-data.financed-crowdfunding":"Finansiert av folkefinansiering","dashboard.widgets.risk-data.financed-crypto":"Finansiert av kryptovaluta eller kryptokunst","dashboard.widgets.risk-data.high-risk-country":"Tilknytning til h\xf8yrisikoland","dashboard.widgets.risk-data.high-risk-industry":"Bransjetilh\xf8righet innen andre h\xf8yrisikobransjer","dashboard.widgets.risk-data.missing-funding-documentation":"Renovert med finansiering av ukjent opprinnelse","dashboard.widgets.risk-data.missing-work-documentation":"Renovert hele/deler uten faktura","dashboard.widgets.risk-levels.title":"Risikoniv\xe5 - alle kunder","dashboard.widgets.status.title":"Status kundeforhold","default.add":"Legg til","default.archive":"Arkiver","default.cancel":"Avbryt","default.categories":"kategorier","default.change":"Endring","default.close":"Lukk","default.confirm":"Bekreft","default.copy":"Kopi\xe9r","default.create":"Opprett","default.days":"{days, plural, =1 {dag} other {dager}}","default.delete":"Slett","default.down-from":"Ned fra {value}","default.edit":"Rediger","default.email":"E-post","default.expired":"Utg\xe5tt","default.hide":"Skjul","default.history":"historikk","default.home":"Hjem","default.inactive":"Inaktiv","default.industries":"bransjer","default.invalid":"Ugyldig","default.keep":"Behold","default.link":"Link","default.loading":"Laster","default.mandatory":"Obligatorisk","default.months":"{months, plural, =1 {m\xe5ned} other {m\xe5neder}}","default.new":"Ny","default.next":"Neste","default.no":"Nei","default.normal":"Normalt","default.or":"eller","default.preview":"Forh\xe5ndsvis","default.previous":"Forrige","default.reject":"Avkreft","default.remove":"Slett","default.required":"P\xe5krevd","default.reset":"Tilbakestill","default.restore":"Gjenopprett","default.risk":"Risiko","default.save":"Lagre","default.save-changes":"Lagre endringer","default.search":"S\xf8k","default.send":"Send","default.show":"Vis","default.status":"Status","default.support-portal":"supportportal","default.times":"{count, plural, =1 {ganger} other {# ganger}}","default.unknown":"Ukjent","default.up-from":"Opp fra {value}","default.view":"Utsikt","default.years":"{years, plural, =1 {\xe5r} other {\xe5r}}","default.yes":"Ja","delete-customer.confirmation-modal.description":"Du er i ferd med \xe5 slette {name} permanent fra Kjenn Din Kunde.\\nDette kan ikke reverseres.\\nEr du helt sikker p\xe5 at du vil slette denne kunden?","delete-customer.confirmation-modal.labels.button.delete":"Slett {name}","delete-customer.confirmation-modal.success.message":"{name} slettet","delete-customer.confirmation-modal.title":"Slett kunde","details.banners.critical-update.content":"Det har skjedd endringer p\xe5 selskapet som kan medf\xf8re konsekvenser for kundeforholdet.","details.banners.critical-update.title":"Selskapsendringer som kan medf\xf8re konsekvenser","details.banners.ownership-updates.content":"Vi har f\xe5tt oppdatert informasjon fra Aksjon\xe6rregisteret, og har derfor ny informasjon p\xe5 rettighetshavere tilh\xf8rende denne kunden.","details.banners.ownership-updates.link-label":"Se oppdateringene","details.banners.screening.in.progress.content":"Venter p\xe5 resultater fra screeningen","details.banners.screening.in.progress.title":"Screening p\xe5g\xe5r","details.basic-info.customer-risk":"Kunderisiko","details.basic-info.follow-up":"L\xf8pende oppf\xf8lging","details.basic-info.marked-as":"Markert som","details.basic-info.screening-type":"Type screening","details.basic-info.status":"Kundeforhold","details.reviews.approved-by":"Oppdatert av: ","details.reviews.assignment-review.accepted":"Oppdrag vurdert","details.reviews.assignment-review.rejected":"Oppdrag avsl\xe5tt","details.reviews.awaiting-approval":"Venter bekreftelse","details.reviews.awaiting-approval-with-names":"Venter bekreftelse av {names}","details.reviews.awaiting-measures":"Venter utf\xf8relse av tiltak","details.reviews.confirm.approve":"Godkjenn vurdering","details.reviews.confirm.approve-reject.title":"Begrunnelse","details.reviews.confirm.cancel.description":"Er du sikker p\xe5 at du vil avbryte endringene?","details.reviews.confirm.cancel.title":"Avbryt endringer","details.reviews.confirm.delete.description":"Er du sikker p\xe5 at du vil slette denne vurderingen?\\n(Denne handlingen kan ikke angres)","details.reviews.confirm.delete.title":"Slette vurderingen","details.reviews.confirm.reject":"Avsl\xe5 vurdering","details.reviews.confirm.reject.description":"Ved \xe5 avsl\xe5 vurderingen m\xe5 gj\xf8res p\xe5 nytt av den ansatte.","details.reviews.confirmed-by":"Bekreftet av: ","details.reviews.customer-review.accepted":"Kundeforhold godkjent","details.reviews.customer-review.rejected":"Kundeforhold avsl\xe5tt","details.reviews.draft":"Vurderingsutkast","details.reviews.labels.cancel":"Ja, avbryt","details.reviews.labels.confirm-delete":"Ja, slett vurdering","details.reviews.labels.delete":"Slett vurdering","details.reviews.labels.save-and-continue":"Lagre og fortsett senere","details.reviews.measures.comment.label":"Utf\xf8rte tiltak:","details.reviews.measures.edit-measure":"Utf\xf8r tiltak","details.reviews.measures.form.completed.label":"Har tilstrekkelige tiltak blitt utf\xf8rt?","details.reviews.measures.form.description.label":"Beskriv utf\xf8rte tiltak","details.reviews.measures.form.description.placeholder":"Dokumenter resultatet fra utf\xf8rt tiltak","details.reviews.measures.header":"Tiltak","details.reviews.measures.remove-confirmation.description":"Er du sikker p\xe5 at du vil fjerne \xab{name}\xbb?","details.reviews.measures.remove-confirmation.title":"Slett tiltak","details.reviews.messages.saved":"Vurderingen er lagret","details.reviews.pending-measures":"Vurderingen er ikke ansett ferdig f\xf8r alle tiltakene er blitt utf\xf8rt","details.reviews.rejected-by":"Avsl\xe5tt av: ","details.reviews.reviewed-by":"Vurdert av: ","details.reviews.risk-set-from-x-to-y":"Kunderisiko endret fra {beforeRisk} til {risk}","details.reviews.risk-set-to-x":"Kunderisiko satt til {risk}","disclosure-card.completed.subtitle":"Fullf\xf8rt {timestamp, date, ::yyyyMMdd}","disclosure-card.content-language":"INNHOLDSSPR\xc5K","disclosure-card.date-tile":"DATO OPPRETTET","disclosure-card.email-tile":"E-POSTADRESSE","disclosure-card.expired-banner.description":"Det vil ikke sendes ut flere automatiske p\xe5minnelser. Du m\xe5 n\xe5 sende p\xe5minnelse manuelt, eller kontakte kunden direkte.","disclosure-card.expired-banner.title":"Manglende besvarelse","disclosure-card.identification.label":"Identifisert person ({method})","disclosure-card.link-tile":"LINK","disclosure-card.next-notification.subtitle":"Neste p\xe5minnelse sendes: {timestamp, date, ::yyyyMMdd}","disclosure-card.notified.subtitle":"P\xe5minnelse sendt: {timestamp, date, ::yyyyMMdd}","disclosure-card.pin-tile":"PIN","disclosure-card.recipient-tile":"MOTTAKER","disclosure-card.scope-tile":"INKLUDERT","disclosure-card.status-tile":"STATUS","disclosure-collapsible.hide":"Skjul besvarelse","disclosure-collapsible.show":"Vis besvarelse","disclosure-documents.empty":"Ingen foresp\xf8rsler sendt","disclosure-documents.title":"KYC-sp\xf8rsm\xe5l og legitimering","disclosure-request.banner.no.signing-basis":"Signeringsgrunnlag finnes ikke","disclosure-request.banner.signatory-rights":"Signaturrett i {company}","disclosure-request.button.add-representative":"Legg til representant","disclosure-request.button.send":"Opprett foresp\xf8rsel","disclosure-request.column.content-language":"Innholdsspr\xe5k","disclosure-request.column.custom-questionnaires":"Legg til egne KYC-sp\xf8rsm\xe5l","disclosure-request.column.customer":"Kunde","disclosure-request.column.email":"E-postadresse","disclosure-request.column.sending-method":"Sendemetode","disclosure-request.field.email.placeholder":"Mottakerens e-postadresse","disclosure-request.field.use_pep_disclosure":"Kun PEP-sp\xf8rsm\xe5l","disclosure-request.field.use_standard_disclosure":"KYC-sp\xf8rsm\xe5l (inkl. PEP-sp\xf8rsm\xe5l)","disclosure-request.field.use_verification":"Legitimering (BankID)","disclosure-request.title":"Send foresp\xf8rsel om legitimasjon og KYC-sp\xf8rsm\xe5l","disclosure-request.toggle.automatic-email":"Send e-post","disclosure-status.completed":"Fullf\xf8rt","disclosure-status.expired":"Utg\xe5tt","disclosure-status.waiting":"Venter besvarelse","disclosure-status.warning":"Oppdaget {count, plural, =1 {1 h\xf8yrisikobesvarelse} other {# h\xf8yrisikobesvarelser}}","disclosure.fileset.document-type.ARTICLES_OF_ASSOCIATION":"Vedtekter","disclosure.fileset.document-type.COMPANY_STRUCTURE":"Selskapsstruktur","disclosure.fileset.document-type.FAMILY_OWNERSHIP":"Beskrivelse av familiens felles eierskap","disclosure.fileset.document-type.HOMEOWNER_AGREEMENT":"Avtale med hjemmelshaver","disclosure.fileset.document-type.HOMEOWNER_POWER_OF_ATTORNEY":"Fullmakt","disclosure.fileset.document-type.POWER_OF_ATTORNEY":"Fullmakt","disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT":"L\xe5neavtale","disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT_DEVELOPED_PROPERTY":"L\xe5neavtale","disclosure.fileset.document-type.PROPERTY_OWNERSHIP_STRUCTURE":"Eierforhold/eierbr\xf8k","disclosure.fileset.document-type.SHAREHOLDER_BOOK":"Aksjeeierbok","disclosure.fileset.document-type.UBO_AGREEMENT":"Aksjon\xe6ravtale","disclosure.fileset.document-type.UPGRADE_FUNDING_DOCUMENTATION":"Dokumentasjon p\xe5 finansiering","disclosure.fileset.document-type.UPGRADE_WORK_DOCUMENTATION":"Dokumentasjon p\xe5 utf\xf8rt arbeid","disclosure.foreign-assignment-description":"Andre land enn Norge som er involvert i oppdraget","disclosure.settings.page.description":"Tilpass innholdet som sendes dine kunder p\xe5 e-post (innhenting av legitimering og KYC), slik at det blir mer personlig. Du har mulighet til \xe5 laste opp egen logo, samt skrive en egendefinert tekst som vises i e-posten. (Logoen deres vil ogs\xe5 v\xe6re synlig p\xe5 sp\xf8rreskjemaer som opprettes og sendes som link.)","disclosure.settings.page.labels.email.due-diligence.identification":"Legitimering med BankID","disclosure.settings.page.labels.email.due-diligence.kyc":"Sp\xf8rsm\xe5l relevant for kundeforholdet","disclosure.settings.page.labels.email.due-diligence.list.title":"Bakgrunnsunders\xf8kelsen inneholder:","disclosure.settings.page.labels.email.header":"Hei, (Navn p\xe5 kunde).","disclosure.settings.page.labels.email.subject.company":"SELSKAPSNAVN gjennomf\xf8rer en kundekontroll av SLUTTKUNDESELSKAP","disclosure.settings.page.labels.email.subject.person":"SELSKAPSNAVN gjennomf\xf8rer en kundekontroll","disclosure.settings.page.labels.logo":"Last opp egen logo","disclosure.settings.page.labels.supported-filetypes":"Du kan laste opp .jpg eller .png (opp til {limit} KB)","disclosure.settings.page.labels.text":"Legg til egen tekst i e-post","disclosure.settings.page.tabs.customer-type.company":"Selskapskunder","disclosure.settings.page.tabs.customer-type.person":"Personkunder","disclosure.settings.page.title":"Egen logo og tekst","disclosure.source-of-funds":"Midlenes opprinnelse","disclosure.timestamp":"Besvart","disclosure.ubo-agreements-description":"Informasjon om avtale(r) og hvilke(n) person(er) som har reell kontroll over selskapet","disclosure.ubo-agreements-exists":"Foreligger det vedtekter, aksjon\xe6ravtale(r) eller annen avtale som har bestemmelser om hvem som i realiteten (direkte eller indirekte) kontrollerer selskapet?","disclosure.ubo-company-control.heading":"Sp\xf8rsm\xe5l om reelle rettighetshavere og selskapskontroll","disclosure.ubo-company-structure-description":"Informasjon om selskapsstrukuren i selskapet","disclosure.ubo-company-structure-exists":"Er selskapet du handler p\xe5 vegne av, en del av en selskapsstruktur?","disclosure.ubo-family-members-description":"Informasjon om familiemedlemmer som til sammen ut\xf8ver reell kontroll over selskapet","disclosure.ubo-family-members-exists":"Er det familiemedlemmer som til sammen (direkte eller indirekte) innehar mer enn 25% av aksjene/stemmene eller til sammen ut\xf8ver reell kontroll over selskapet?","disclosure.ubo-share-classes-description":"Informasjon om aksjeklasser i selskapet","disclosure.ubo-share-classes-exists":"Er det flere aksjeklasser i selskapet du handler p\xe5 vegne av?","disclosure.ubo-structure-changes-description":"Informasjon om endringer i eierstrukturen","disclosure.ubo-structure-changes-exists":"Har det skjedd endringer i eierstrukturen?","disclosure.usage-of-funds":"Hvordan skal midlene etter salget benyttes?","display-name.suffixes.labels.birth-date":"(f. {birthDate, date, ::yyyy})","display-name.suffixes.labels.org-id":"(org.nr. {orgId})","email.invalid.address.error":"Ugyldig adresse","email.placeholder.text":"Skriv inn e-postadresse","email.required.error":"E-postadresse p\xe5krevd","error.message.unknown":"Det oppstod en feil","error.page.description":"Gi det noen sekunder og pr\xf8v igjen","error.page.title":"Det har dessverre skjedd en feil ...","expired.actions.logout":"Logg inn","expired.description":"Av sikkerhetsmessige hensyn logges du ut etter 30 minutter (hvis du ikke er aktiv)","expired.heading":"Du m\xe5 logge inn p\xe5 nytt","fetch.identification.info.card.note":"Dette er videre beskrevet i kapittel 4.3 i Finanstilsynets veileder til hvitvaskingsloven.","fetch.identification.info.card.text":"Rapporteringspliktige foretak underlagt hvitvaskingsloven er i henhold til \xa712 i lov om tiltak mot hvitvasking og terrorfinansiering pliktig til innhente legitimasjon fra kunder n\xe5r dette er en fysisk person, samt for fysiske personer som handler p\xe5 vegne av et foretak.","fetch.identification.info.card.title":"Hvorfor m\xe5 man innhente legitimasjon?","followup-notifications.settings.intervals.description":"Velg hvor ofte du vil motta varsling om ventende/utl\xf8pte oppf\xf8lginger p\xe5 e-post. E-posten inneholder link til Kjenn Din Kunde med filtervisning p\xe5 kundene som du skal f\xf8lge opp.","followup-notifications.settings.page.title":"Kundeoppf\xf8lging intervall","followup-settings.intervals.description":"Du kan definere oppf\xf8lgingsintervall for hvert risikoniv\xe5. N\xe5r oppf\xf8lgingsdatoen for en kunde utl\xf8per, endres kundens status til \\"venter oppf\xf8lging\\". Kunden m\xe5 da risikovurderes p\xe5 nytt. Merk at du ogs\xe5 kan sette en egendefinert oppf\xf8lgingsdato for en kunde fra kundesiden.","followup-settings.intervals.labels.custom-interval":"Egendefinert intervall","followup-settings.intervals.labels.custom-interval.placeholder":"Antall m\xe5neder","followup-settings.intervals.labels.no-interval":"Ingen intervall","followup-settings.page.link-to-notifications":"PS. Under <link> kan du definere hvor ofte du vil motta varsling p\xe5 e-post om ventende/utl\xf8pte oppf\xf8lginger.","followup-settings.page.title":"Kundeoppf\xf8lging","followup.modal.labels.date":"Velg en ny oppf\xf8lgingsdato","followup.modal.message":"Angi oppf\xf8lgingsdato for {names}","followup.modal.title":"Angi oppf\xf8lgingsdato","followup.select.empty.label":"Velg oppf\xf8lgingsdato","followup.select.error-action":"Angi oppf\xf8lgingsdato","followup.select.expired.label":"Utl\xf8pt: {followup, date, ::yyyyMMdd}","followup.select.label":"Neste: {followup, date, ::yyyyMMdd}","followup.select.success.message":"Oppf\xf8lgingsdato ble endret","followup.select.title":"Egendefinert dato p\xe5 neste oppf\xf8lging","high-risk-countries.list.EU":"EU","high-risk-countries.list.EU_TAX_HAVEN":"EU skatteparadis","high-risk-countries.list.FATF":"FATF","import-customers.wizard.labels.finished":"Importering fullf\xf8rt","import-customers.wizard.labels.first-row-contains-headers":"F\xf8rste rad inneholder overskrifter","import-customers.wizard.labels.import-companies.button":"Importer selskapskunder","import-customers.wizard.labels.import-people.button":"Importer personkunder","import-customers.wizard.labels.importing":"Importerer {count, number} av {total, number} rader","import-customers.wizard.page.title.companies":"Importer selskap","import-customers.wizard.page.title.people":"Importer person","import-customers.wizard.page.welcome.description":"Velkommen til kundeimportveiviseren","import-customers.wizard.page.welcome.title":"Velkommen til kundeimportveiviseren","import-customers.wizard.status.IMPORTED":"Importering vellykket","import-customers.wizard.status.IMPORTING":"Importerer...","import-customers.wizard.status.IMPORT_ERROR":"Kunne ikke importere","import-customers.wizard.status.INITIAL":"Les fra fil","import-customers.wizard.status.READY_FOR_IMPORT":"Klar for importering","import-customers.wizard.status.VALIDATION_ERROR":"Valideringsfeil","import-customers.wizard.table.hide-column-button.tooltip":"Skjul kolonne","import-customers.wizard.validation-error.duplicate-org-id":"Duplikat orgnr. funnet","import-customers.wizard.validation-error.invalid-org-id":"Ugyldig orgnr.","import-customers.wizard.validation-error.responsible-user-not-found":"Ansvarlig bruker ikke funnet","import-customers.wizard.warning.missing-columns":"{count, plural, one {Denne kolonnen er p\xe5krevd} other {Disse kolonnene er p\xe5krevde}}: {names}","import-customers.wizard.warning.multiple-columns":"{count, plural, one {Denne kolonnen} other {Disse kolonnene}} kan kun velges \xe9n gang: {names}","in.progress":"P\xe5g\xe5r","industry-info.labels.industry-code":"N\xe6ringskode","industry-info.labels.possible-risk":"Mulig risiko","industry-types.filter.label":"Filtrer p\xe5 bransjer","kar.form.labels.account-number":"Kontonummer","kar.form.labels.check-account-number":"Sjekk kontonummer","kar.form.labels.customer-number":"Personnummer / Org.nr","kar.form.result.by":"Tidspunkt for s\xf8k: {timestamp, date, ::yyyyMMdd HH:mm} - Utf\xf8rt av {name}","kar.form.result.failure":"Kontonummer <bold>{accountNumber}</bold> tilh\xf8rer ikke <bold>{name} ({nationalId})</bold>","kar.form.result.success":"Kontonummer <bold>{accountNumber}</bold> tilh\xf8rer <bold>{name} ({nationalId})</bold>","kar.form.title":"Verifiser kontoinformasjon","kar.table.status.failure.tooltip":"Ingen kobling mellom kontonummer og personnummer / org. nr.","kar.title":"KAR-register","links.go-back":"Tilbake til {name}","lookup.again":"S\xf8k p\xe5 nytt","lookup.button.search":"S\xf8k opp selskap","lookup.correct.customer":"Dette er riktig kunde","lookup.error.company.bankrupt":"Selskapet er konkurs","lookup.error.company.closed":"Selskapet er nedlagt/slettet","lookup.error.company.not.found":"Kunne ikke finne selskap med organisasjonsnummer {orgId}","lookup.error.company.under-forced-liquidation":"Selskapet er under tvangsavvikling eller oppl\xf8sning","lookup.error.company.under-liquidation":"Selskapet er under avvikling","lookup.error.title":"Kan ikke registrere kunde","lookup.error.wrong.orgid":"Feil orgnr","lookup.input.placeholder":"Orgnr. (9 siffer)","lookup.search.title":"S\xf8k opp selskapet ved bruk av org.nr.","lookup.title":"Bekreft kunde","match-cases-section.count.label":"Antall treff: {count, number} {selected, plural, =0 {} other {(# valgt)}}","match.basic-info.id":"ID:","match.basic-info.last-updated":"Sist oppdatert:","match.basic-info.match-date":"Dato p\xe5 treff:","match.relations.ACTING":"HANDLER FOR ELLER P\xc5 VEGNE AV","match.relations.CHILD":"BARN","match.relations.DAUGHTER":"DATTER","match.relations.FATHER":"FAR","match.relations.MOTHER":"MOR","match.relations.PARENT":"FORELDER","match.relations.RELATIVE":"SLEKTNING","match.relations.SIBLING":"S\xd8SKEN","match.relations.SPOUSE":"EKTEFELLE","match.relations.WIFE":"EKTEFELLE","matches.button.confirm.match.description-company":"Treffet gjelder riktig selskap og er relevant","matches.button.confirm.match.description-person":"Treffet gjelder riktig person og er relevant","matches.button.decline.match.description-company":"Treffet gjelder ikke riktig selskap, eller er ikke relevant","matches.button.decline.match.description-person":"Treffet gjelder ikke riktig person, eller er ikke relevant","matches.button.hide.rejected.matches":"Skjul avkreftede treff ({count})","matches.button.review-next-match":"Vurder neste treff","matches.button.show.rejected.matches":"Vis avkreftede treff ({count})","matches.help-text.pep.description":"Vurder om opplysningene i treffet medf\xf8rer at din kunde/representant er PEP, eller n\xe6rt familiemedlem eller kjent medarbeider til en PEP.\\n\\n**Hvilke stillinger/verv omfattes av PEP-definisjonen?**\\n\\nPolitisk eksponerte personer (PEP) er personer som innehar, eller har innehatt, f\xf8lgende stillinger og verv iht. [hvitvaskingsloven \xa7 2 bokstav f](https://lovdata.no/lov/2018-06-01-23/\xa72) (spesifikke _nasjonale_ stillinger er spesifisert nedenfor):\\n\\n\\n\\n* Statsoverhode, regjeringssjef, minister eller assisterende minister\\n    * _kongen_\\n    * _statsministeren_\\n    * _statsr\xe5d_\\n    * _statssekret\xe6r_\\n* Medlem av nasjonalforsamling\\n    * _stortingsrepresentanter_\\n    * _faste eller varige vararepresentanter p\xe5 Stortinget_\\n* Medlem av styrende organ i politisk parti\\n    * _hovedstyre eller tilsvarende h\xf8ytst\xe5ende organ i politiske partier representert p\xe5 Stortinget (kommunestyre og fylkesting omfattes ikke)_\\n* Medlem av h\xf8yere rettsinstans som treffer beslutning som ikke eller bare unntaksvis kan ankes\\n    * _dommere i H\xf8yesterett, midlertidige og faste stillinger_\\n    * _dommere i lagmannsretten (kun ansatte i domstolsapparatet, ikke lekdommere/meddommere), midlertidige og faste stillinger_\\n    * _norske dommere ved internasjonale domstoler, f.eks. Den europeiske menneskerettighetsdomstolen (EMD), EFTA-domstolen, FN-domstolen (ICJ)_\\n* Medlem av styre i riksrevisjon, revisjonsdomstol eller sentralbank\\n    * _medlemmer og varamedlemmer av riksrevisjonskollegium i Riksrevisjonen_\\n    * _styret i Norges Bank_\\n* Ambassad\xf8r eller charg\xe9 d\u2019affaires\\n    * _norsk ambassad\xf8r eller charg\xe9 d\u2019affaires ved norsk ambassade (konsul omfattes ikke)_\\n* Milit\xe6r offiser av h\xf8yere rang\\n    * _forsvarssjefen_\\n    * _\xf8verste ledere i de ulike forsvarsgrenene: general, generall\xf8ytnant og generalmajor (tilsvarer admiral, viseadmiral og kontreadmiral i sj\xf8forsvaret)_\\n* Medlem av administrativt, ledende eller kontrollerende organ i \xabstatlig foretak\xbb*\\n    * _styret og administrerende direkt\xf8r i statlige foretak_\\n`*` _\xabStatlige foretak\xbb er statlige selskaper som ivaretar offentlige oppgaver som h\xf8rer inn under den offentlige administrasjonen, som f.eks. de regionale helseforetakene (RHF) og Bane NOR. Det avgj\xf8rende er om det dreier seg om statlige myndigheter, selv om disse representeres ved et foretak. Statseide selskaper som ikke utf\xf8rer oppgaver som omfatter offentlig forvaltning, faller utenfor definisjonen._\\n_Omfatter ikke datterselskap av slike selskaper, selveiende institusjoner (typisk stiftelser) som helt eller delvis er finansiert av offentlige midler eller lokale foretak (som fylkeskommunale og kommunale foretak)._\\n\\n* Direkt\xf8r, styremedlem eller annen person i den \xf8verste ledelsen i en internasjonal organisasjon\\n    * _personer som er innstilt, utpekt eller ansatt av regjering, departement eller minister i en internasjonal organisasjon som er opprettet ved inng\xe5else av en formell internasjonal politisk avtale, f.eks. EFTA, NATO og FN (omfatter ikke ideelle organisasjoner)_\\n\\n \\n\\n**Hvem er definert som n\xe6rt familiemedlem til en PEP?**\\n\\n\\n\\n* Foreldre\\n* Ektefelle, registrert partner eller samboer\\n* Barn, samt barns ektefelle, registrert partner eller samboer\\n\\nS\xf8sken, stebarn og steforeldre omfattes ikke av definisjonen. Adoptivbarn er likestilte med biologiske barn.\\n\\n**Hvem er definert som kjent medarbeider til en PEP?**\\n\\nKjent medarbeider er definert som en person som er kjent for \xe5:\\n\\n\\n\\n* V\xe6re reell rettighetshaver i felleskap med politisk eksponert person\\n* Ha n\xe6r forretningsforbindelse til politisk eksponert person\\n* V\xe6re eneste reelle rettighetshaver i selskap som i realiteten er etablert for \xe5 begunstige politisk eksponert person\\n\\n_Se mer informasjon i [veilederen til hvitvaskingsloven](https://www.finanstilsynet.no/nyhetsarkiv/rundskriv/2022/veileder-til-hvitvaskingsloven/)_","matches.help-text.pep.title":"Hvordan vurdere PEP-treff?","matches.labels.details":"Hva gjelder treffet?","matches.labels.negative-news":"Negative nyheter","matches.labels.negative-news.helper-text-company":"Selskapet er knyttet til negative nyheter som kan indikere h\xf8yere risiko","matches.labels.negative-news.helper-text-person":"Vedkommende er knyttet til negative nyheter som kan indikere h\xf8yere risiko","matches.labels.other":"Annet","matches.labels.other.helper-text-company":"Selskapet er knyttet til andre typer hendelser (beskriv i fritekstfeltet)","matches.labels.other.helper-text-person":"Vedkommende er knyttet til andre typer hendelser (beskriv i fritekstfeltet)","matches.labels.pep":"PEP","matches.labels.pep.detailed":"PEP (Politically Exposed Person)","matches.labels.pep.detailed.tooltip":"Politisk eksponerte personer (PEP) er personer som innehar et s\xe6rskilt offentlig tillitsverv og derfor kan v\xe6re eksponert for bestikkelser og annen korrupsjon","matches.labels.pep.helper-text":"Vedkommende er en politisk eksponert person, eller n\xe6rt knyttet til en (iht. til definisjonen i hvitvaskingsloven)","matches.labels.rejected-by":"Avkreftet av {name}, {timestamp, date, ::yyyyMMdd}","matches.labels.relations":"Relasjoner / tilknytninger","matches.labels.review.description":"Begrunnelse","matches.labels.review.description.placeholder":"Begrunn vurderingen","matches.labels.sanction":"Sanksjon","matches.labels.sanction.helper-text-company":"Selskapet er sanksjonert og oppf\xf8rt i sanksjonslisten","matches.labels.sanction.helper-text-person":"Vedkommende er sanksjonert og oppf\xf8rt i sanksjonslisten","matches.labels.sanctions":"Sanksjoner","matches.labels.source":"Kilde: ","matches.labels.source.name":"Kildenavn:","matches.labels.source.publication-source":"Publikasjonskilde:","matches.labels.source.publisher":"Utgiver:","matches.labels.source.url":"Kilde:","matches.navigation.tooltip":"{summary} p\xe5 {name}","matches.review.approved":"Treff bekreftet","matches.review.denied":"Treff avkreftet","matches.text.no.confirmed.matches":"Ingen bekreftede treff","matches.text.no.matches":"Ingen treff funnet \uD83C\uDF89","matches.title.compare.companies":"Sammenligning av selskapsinfo","matches.title.compare.persons":"Sammenligning av personalia","matches.title.details.matches":"Treff p\xe5 screening","matches.titles.assessment":"Vurdering av treff","matches.titles.categories":"KATEGORIER","matches.titles.comments":"BEMERKNINGER","matches.titles.company-customer":"Din Kunde/Representant","matches.titles.data-source":"Treff mot datakilde","matches.titles.events":"HENDELSER","matches.titles.geographic-affiliation":"Geografisk tilknytning","matches.titles.key-information":"N\xf8kkelinformasjon","matches.titles.listings":"OPPF\xd8RINGER","matches.titles.matches-against-data-source":"TREFF MOT DATAKILDE","matches.titles.person-customer":"Personalia","matches.titles.positions":"STILLINGER","matches.titles.relations":"RELASJONER","matches.titles.relevant-links":"RELEVANTE LENKER","matches.titles.sources":"KILDER","matches.titles.summary":"OPPSUMMERING","measures-settings.page.description":"Her kan du opprette tiltak du kan benytte i risikovurderingen av dine kunder.","measures-settings.page.filter.hide-archived-measures":"Skjul arkiverte tiltak","measures-settings.page.filter.show-archived-measures":"Vis arkiverte tiltak","measures-settings.page.title":"Tiltak","measures.confirm-archive.description":"Er du sikker p\xe5 at du vil arkivere tiltaket \xab{name}\xbb?.\\nDette vil ikke fjerne eksisterende tiltak.","measures.confirm-archive.labels.archive.button":"Arkiver tiltak","measures.confirm-archive.title":"Arkiver tiltak","measures.confirm-remove.description":"Er du sikker p\xe5 at du vil slette tiltaket \xab{name}\xbb?","measures.confirm-remove.title":"Slett tiltak","measures.errors.empty-measure":"Tomt tiltak","measures.list.loading.error-action":"F\xe5 liste over tiltak","measures.list.loading.label":"Laster tiltak","measures.modal.empty-state":"Det er forel\xf8pig ingen tiltak","measures.modal.errors.description-validation-error":"Beskrivelse er p\xe5krevd","measures.modal.errors.title-not-unique-validation-error":"Tittel eksisterer allerede","measures.modal.errors.title-validation-error":"Tittel er p\xe5krevd","measures.modal.title.add":"Opprett tiltak","measures.modal.title.update":"Endre tiltak","measures.modal.title.view":"Se tiltak","measures.popover.labels.button":"Legg til tiltak","measures.popover.labels.filter":"Opprett nytt tiltak","measures.popover.labels.global-list.empty":"Det finnes ingen eksisterende tiltak","measures.popover.labels.global-list.title":"Velg eksisterende tiltak","measures.popover.labels.new-empty-measure":"Opprett nytt tiltak","menu.import.companies":"Importer selskaper","menu.language.english":"Spr\xe5k: Engelsk","menu.language.norwegian":"Spr\xe5k: Norsk","menu.logout":"Logg ut","menu.plan-upgrade":"AML-pakke: {packageName}","menu.settings":"Innstillinger","menu.support-email":"Kontakt support","menu.whats-new":"Hva er nytt?","missing-required-permission.banner.description":"Kun {roles} kan endre disse innstillingene","modals.company.edit.title":"Endre selskapsdetaljer","modals.copy.link.button":"Kopier link","modals.copy.link.button.copied":"Kopiert","modals.delete.signature.button":"Slett KYC-foresp\xf8rsel","modals.delete.signature.description":"Er du sikker p\xe5 at du \xf8nsker \xe5 slette KYC-foresp\xf8rselen til {name}?","modals.delete.signature.title":"Slett KYC-foresp\xf8rsel","modals.headings.address":"Adresse","modals.headings.personal-information":"Personopplysninger","modals.owner.confirm.archive.description":"Er du sikker p\xe5 at du vil arkivere rettighetshaveren {owner}?","modals.owner.confirm.archive.title":"Arkiver rettighetshaver","modals.owner.headings.ownership-in-company":"Eierandel i selskapet","modals.owner.labels.percent_share":"Eierandel i %","modals.owner.messages.owner-restored":"Rettighetshaveren \xab{name}\xbb ble gjenopprettet","modals.owner.title.add":"Legg til rettighetshaver","modals.owner.title.update":"Endre rettighetshaver","modals.owner.tooltips.archive-disabled":"Du kan ikke arkive en rettighetshaver som screenes","modals.person.edit.title":"Endre persondetaljer","modals.remind.signer.button":"Send p\xe5minnelse","modals.remind.signer.title":"Send p\xe5minnelse til mottaker","modals.role.confirm.delete.description":"Er du sikker p\xe5 at du vil slette {role} fra listen over rolleinnehavere?\\nHandlingen kan ikke angres.","modals.role.confirm.delete.title":"Slett rolleinnehaver","modals.role.headings.role-in-company":"Rolle i selskapet","modals.role.labels.role_type":"Rolle","modals.role.labels.select.placeholder":"Velg rolle","modals.role.title.add":"Legg til rolleinnehaver","modals.role.title.update":"Endre rolleinnehaver","modals.role.tooltips.delete-disabled":"Du kan ikke slette en rolle som screenes","modals.update.signature.button":"Lagre endringer","modals.update.signature.customer":"KUNDE","modals.update.signature.error.duplicate-email":"Denne e-posten er allerede brukt for en annen mottaker","modals.update.signature.title":"Rediger mottakerinfo","nav-bar.dashboard":"Dashboard","nav-bar.new-customer":"Registrer kunde","nav-bar.new-customer.company":"Selskapskunde","nav-bar.new-customer.person":"Personkunde","nav-bar.overview":"Kunder","navigation.page.customers.title":"Kunder","navigation.settings.checklists.label":"Sjekklister","navigation.settings.internal-tools.kyc-previewer.label":"KYC Previewer","navigation.settings.internal-tools.section.title":"Internal Tools","navigation.settings.kyc.auto-reminder.label":"KYC-p\xe5minnelse til kunde","navigation.settings.kyc.custom-questionnaires.label":"Egne KYC-sp\xf8rsm\xe5l","navigation.settings.notifications.customer-info.label":"Selskapsoppdateringer","navigation.settings.notifications.section.title":"Varslinger","navigation.settings.onboarding.person.title":"Personkunder","navigation.settings.onboarding.section.title":"Kunderegistrering","navigation.settings.risk-management.section.title":"Risikoh\xe5ndtering","navigation.settings.users.section.title":"Brukeradministrasjon","navigation.settings.users.title":"Alle brukere","new-company-customer.country-options.no":"Norsk selskap","new-company-customer.country-options.other":"Utenlandsk selskap","new-company-customer.texts.manual":"Fyll inn selskapets informasjon manuelt","new-company-customer.titles.manual":"Registrer utenlandsk selskap","new-company-customer.titles.norwegian":"Registrer norsk selskap","not-found.description":"Siden er kanskje flyttet, slettet, eller kanskje det er feil i url\u2019n","not-found.title":"Hmm, her var det jo ingenting?","not.specified":"Ikke oppf\xf8rt","notifications-settings.followup.form.label":"Hvor ofte vil du motta varsling p\xe5 e-post?","notifications-settings.followup.form.label.monthly":"\xc9n gang i m\xe5neden","notifications-settings.followup.form.label.no-notification":"Ingen varsling","notifications-settings.followup.form.label.weekly":"\xc9n gang i uken","onboarding-settings.page.description":"Her kan du velge hvilke innstillinger som skal gjelde for registrering av alle nye kunder. Valgene dine blir da forh\xe5ndsutfylt ved nye kunderegistreringer.","onboarding-settings.page.title":"Registrering av personkunder","onboarding-summary.signature-table-column.content-language":"INNHOLDSSPR\xc5K","onboarding-summary.signature-table-column.email-or-url":"E-POST/LINK","onboarding-summary.signature-table-column.name":"NAVN","onboarding-summary.signature-table-column.scope":"OMFANG","onboarding-summary.title":"Oppsummering","onboarding.assignments-and-attachments.description":"Opprett et oppdrag p\xe5 kunden og last opp n\xf8dvendige dokumenter tilh\xf8rende oppdraget eller kundeforholdet.","onboarding.assignments-and-attachments.title":"Oppdrag og dokumenter","onboarding.assignments.description":"Opprett et oppdrag p\xe5 kunden","onboarding.assignments.title":"Oppdrag","onboarding.associated-project.title":"Tilh\xf8rende prosjekt","onboarding.bar.company.assignments-and-attachments.title":"Oppdrag og dokumenter","onboarding.bar.company.assignments.title":"Oppdrag","onboarding.bar.company.disclosures.title":"KYC","onboarding.bar.company.screening.title":"Screening","onboarding.bar.company.summary.title":"Oppsummering","onboarding.bar.manual-company.information.title":"Opplysninger","onboarding.cancel.and.delete":"Avbryt registrering","onboarding.cancel.and.save":"Lagre og fortsett senere","onboarding.cancel.confirm.description":"Er du sikker p\xe5 at du \xf8nsker \xe5 avbryte registreringen av {name}?\\nDersom du avbryter registreringen vil {name} bli slettet, og du m\xe5 eventuelt starte registreringen p\xe5 nytt.","onboarding.cancel.confirm.title":"Avbryt registrering","onboarding.cancel.onboarding":"Lukk","onboarding.disclosures.company-description":"I henhold til hvitvaskingsloven m\xe5 det gjennomf\xf8res en kundekontroll p\xe5 den/de som skal handle p\xe5 vegne av kunden. Velg hvem dette gjelder.","onboarding.disclosures.duplicate.emails.error":"Det er tastet inn samme e-postadresse til flere personer. Se over e-postadressene.","onboarding.disclosures.person-description":"I henhold til hvitvaskingsloven m\xe5 det gjennomf\xf8res en kundekontroll p\xe5 kunden.","onboarding.disclosures.person.require-disclosure":"Legitimer og/eller send KYC-sp\xf8rsm\xe5l","onboarding.disclosures.send-email.text":"Det blir opprettet en unik link til legitimering og KYC-sp\xf8rsm\xe5l som er tilgjengelig fra kundesiden. Du er selv ansvarlig for \xe5 sende denne til vedkommende.","onboarding.disclosures.title":"Legitimering og KYC-sp\xf8rsm\xe5l","onboarding.new.person.title":"Registrer personkunde","onboarding.screening-type.monitoring.helper.text":"Det informeres fortl\xf8pende dersom det oppst\xe5r nye treff mot PEP, sanksjon eller negative nyheter.","onboarding.screening-type.one-time.helper.text":"Kontrollerer kunden \xe9n gang mot PEP- og sanksjonslister, samt negative nyheter, f\xf8r kundeforholdet er oppe til vurdering.","onboarding.status.draft-review":"Vurderingsutkast","onboarding.status.ready-for-review":"Klar for vurdering","onboarding.status.started":"P\xe5begynt","outstanding-shares.banner.description":"Aksjon\xe6rregisteret mangler opplysninger om <bold>{outstandingShares, number}</bold> aksjer av <bold>{totalShares, number}</bold>.\\nDet anbefales derfor \xe5 kontakte kunden for \xe5 f\xe5 fremlagt en fullstending aksjeeierbok.\\nDeretter kan opplysningene om eiere og reell(e) rettinghetshaver(e) oppdateres manuelt under.","outstanding-shares.banner.title":"Utest\xe5ende aksjer","owners.card.buttons.add-owner":"Legg til rettighetshaver","owners.card.cannot-have-shareholders":"Denne selskapsformen ({companyType}) kan ikke ha aksjon\xe6rer, s\xe5 vi identifiserer ikke rettighetshavere med aksjeeierandel for dette selskapet.","owners.card.manual.no-owners":"Ingen rettighetshavere.","owners.card.newly-founded.no-owners":"Dette selskapet er etablert etter at Aksjon\xe6rregisteret ble oppdatert (31. desember).\\nUnders\xf8k om kunden har oppgitt riktig/oppdatert informasjon i KYC-skjemaet etter at KYC skjemaet er besvart.","owners.card.no-owners":"Det er ingen rettighetshavere som eier/kontroller (direkte eller indirekte) 5 prosent eller mer (kilde: Aksjon\xe6rregisteret)","ownership-update.actions.labels.confirm-all-updates":"Bekreft alle oppdateringer","ownership-update.actions.labels.ignore":"Ignorer","ownership-update.banner.description":"Vi har f\xe5tt viktige oppdateringer som p\xe5virker eierforholdene hos denne kunden.\\nInformasjonen er hentet fra Aksjon\xe6rregisteret {year}, og reflekterer dermed eierforholdene slik de fremstod 31.12.{year}. Du m\xe5 bekrefte eller ignorere de oppf\xf8rte endringene.","ownership-update.banner.finished.description":"Det er ingen flere eierskapsoppdateringer p\xe5 denne kunden. \uD83C\uDF89","ownership-update.confirm-all.modal.action.label":"G\xe5 til screening-innstillinger","ownership-update.confirm-all.modal.content":"Dette p\xe5virker ikke screeningen. Du m\xe5 endre dette manuelt ved behov, f.eks. hvis nye rettighetshavere skal screenes, eller utg\xe5ende rettighetshavere skal fjernes fra screeningen.","ownership-update.confirm-all.modal.title":"Flott! Da var det gjort! \uD83C\uDF89","ownership-update.description.update":"Sist oppdatert fra Aksjon\xe6rregisteret {year}","ownership-update.info.label":"Oppdatering p\xe5 eierforhold","ownership-update.reject.confirmation.modal.action.label":"Ignorer endring","ownership-update.reject.confirmation.modal.content.add":"Ved \xe5 ignorere endringen slettes <bold>{name}</bold> fra listen over rettighetshavere.","ownership-update.reject.confirmation.modal.content.delete":"Ved \xe5 ignorere endringen beholdes <bold>{name}</bold> i listen over rettighetshavere.","ownership-update.reject.confirmation.modal.content.update":"Ved \xe5 ignorere endringen settes eierandelen til <bold>{name}</bold> tilbake til {value}.","ownership-update.reject.confirmation.modal.title":"Er du sikker p\xe5 at du vil ignorere endringen?","ownership.view.table":"Rettighetshavere","ownership.view.tree":"Eierskapsstruktur","ownership.view.tree.info":"Informasjonen er tatt direkte fra Aksjon\xe6rregisteret. Vi inkluderer alle personer med minst 5% eierandel, eller som ved indirekte eierskap eier minst 25% i hvert ledd.","pending-tasks.labels.awaiting-disclosures":"Venter besvarelse av {count, plural, =1 {1 KYC-foresp\xf8rsel} other {# KYC-foresp\xf8rsler}}","pending-tasks.labels.awaiting-documents":"Venter ferdigstilling av {count, plural, =1 {1 e-signaturforesp\xf8rsel} other {# e-signaturforesp\xf8rsler}}","pending-tasks.labels.open-matches":"Venter vurdering av {count, number} treff","pending.tasks.labels.approve-review":"Se vurdering","pending.tasks.labels.days-since-onboarding":"{days, plural, =0 {foresp\xf8rsel sendt i dag} =1 {1 dag siden foresp\xf8rselen} other {# dager siden foresp\xf8rselen}}","pending.tasks.labels.finish-onboarding":"Fortsett registrering","pending.tasks.labels.followup-customer":"Venter oppf\xf8lging","pending.tasks.labels.open-draft-review":"\xc5pne vurderingsutkast","pending.tasks.labels.remind-recipients":"P\xe5minn mottakere","pending.tasks.labels.review-customer":"Vurder kunde","pending.tasks.labels.review-matches":"Vurder {count, plural, =1 {treffet} other {treff}}","pending.tasks.labels.review-measures":"Utf\xf8r tiltak","pending.tasks.labels.review-ownership-updates":"Vurder oppdatering p\xe5 eierforhold","pending.tasks.labels.see-draft-reviews":"Se vurderingsutkast","pending.tasks.labels.see-pending-disclosures":"Se {count, plural, =1 {foresp\xf8rsel} other {foresp\xf8rsler}}","pending.tasks.labels.see-pending-documents":"Se {count, plural, =1 {dokument} other {dokumenter}}","pending.tasks.status.approve-review":"Godkjenn/avsl\xe5 vurdering","pending.tasks.status.followup":"Oppf\xf8lging: {days, plural, =-1 {utg\xe5tt} =0 {i dag} =1 {1 day} other {om # dager}}","pending.tasks.status.review-measures":"{count, number} ventende tiltak","pending.tasks.status.waiting-for-approval":"Venter bekreftelse p\xe5 vurdering","pending.tasks.status.waiting-for-approval.subtitle":"Forespurt p\xe5 {timestamp, date, ::yyyyMMdd} av {names}","person-name.description.manually-created":"Lagt til av {name}, {timestamp, date, ::yyyyMMdd}","person.customer.details.personal.number":"Personnummer","person.details.caption.address":"ADRESSE","person.details.caption.birth.date":"F\xd8DSELSDATO","person.details.caption.citizenship":"STATSBORGERSKAP","person.details.caption.externalId":"ID","person.details.caption.first.name":"FORNAVN","person.details.caption.last.name":"ETTERNAVN","person.details.caption.origin":"F\xd8DELAND","person.details.caption.person.number":"PERSONNUMMER","person.details.caption.residence":"BOSTEDS/OPPHOLDSLAND","person.details.title":"kundedetaljer","personal.number.placeholder.no":"ddmm\xe5\xe5XXXXX","plan-conversion.add-to-projects.description":"Oppgrader AML-pakken din for \xe5 aktivere prosjekter.","plan-conversion.attachments.description":"Oppgrader din AML-pakke for \xe5 f\xe5 tilgang til dokumentopplastning og e-signering.","plan-conversion.banner.labels.link":"Se de ulike AML-pakkene","plan-conversion.customer-action.label":"Oppgrader din AML-pakke for denne funksjonen","plan-conversion.messages.access-feature":"Oppgrader din AML-pakke for \xe5 f\xe5 tilgang til denne funksjonen.","plan-conversion.modal.title":"Oppgrader din AML-pakke","plan-conversion.projects.description":"Prosjekter er en funksjon som gj\xf8r det mulig \xe5 samle flere kunder i samme oversikt, som gj\xf8r det enklere \xe5 ha full kontroll over ulike kunder tilh\xf8rende ett og samme prosjekt.","plan-conversion.projects.image.alt-text":"Prosjektdetaljer bilde","project.actions.labels.edit":"Rediger prosjektdetaljer","project.actions.labels.end-project":"Avslutt prosjekt","project.actions.labels.reactivate":"Reaktiver prosjekt","project.banner.vitec.imported.text":"Start med \xe5 registrere kunden. Kunderapporten lastes automatisk opp til Vitec n\xe5r du er ferdig med vurdering av kunden.","project.banner.vitec.label":"Dette prosjektet er importert fra Vitec","project.button.imported-from-vitec":"Vitec","project.customers.actions.remove-from-project":"Fjern fra prosjekt","project.customers.buttons.add-customers":"Legg til kunder","project.customers.buttons.add-existing-customers":"Eksisterende kunder","project.customers.buttons.add-new-company-customer":"Registrer ny selskapskunde","project.customers.buttons.add-new-person-customer":"Registrer ny personkunde","project.customers.empty.header":"Det er ikke oppf\xf8rt noen kunder i dette prosjektet.","project.customers.empty.message":"Legg til kunder i prosjektet ved \xe5 trykke p\xe5 knappen \xabLegg til kunder\xbb ovenfor.","project.customers.modal.title":"Legg til kunder i prosjekt \xab{name}\xbb","project.customers.title":"Kunder i prosjekt","project.details.labels.description":"Legg til prosjektbeskrivelse","project.details.labels.name":"Angi navn p\xe5 prosjekt","project.end.confirmation.action.label":"Avslutt prosjekt \xab{name}\xbb","project.end.confirmation.description":"Er du sikker p\xe5 at du vil avslutte prosjektet \xab{name}\xbb ?","project.end.confirmation.title":"Avslutt prosjekt","project.info.labels.created":"Opprettet","project.info.labels.description":"Beskrivelse","project.info.labels.project-managers":"Prosjektansvarlig","project.info.labels.status":"Status","project.info.manager.empty.user":"Velg prosjektansvarlig","project.info.manager.error":"Noe gikk galt ved lagring av prosjektansvarlig","project.notes.placeholder":"Legg igjen notater om prosjektet","project.remove-customers.confirmation.action.label":"Fjern kunder","project.remove-customers.confirmation.description":"Er du sikker p\xe5 at du vil fjerne {names} fra prosjektet \xab{projectName}\xbb ?","project.remove-customers.confirmation.title":"Fjern kunder","project.remove-customers.success.message":"Fjernet {count, plural, =1 {kunden} other {# kunder}}","project.status.ACTIVE":"Aktiv","project.status.INACTIVE":"Inaktiv","project.vitec.customers.empty.message":"Legg til kunder i prosjektet ved \xe5 trykke p\xe5 knappen Vitec ovenfor.","projects.common.labels.create.project":"Opprett prosjekt","projects.common.labels.update.project":"Oppdater prosjektet","projects.list.column.name":"PROSJEKTNAVN","projects.list.column.status":"STATUS","projects.list.empty.projects.header":"Du har ikke opprettet noen prosjekter enda.","projects.list.empty.projects.message":"Opprett ditt f\xf8rste prosjekt ved \xe5 trykke p\xe5 knappen \xf8verst i h\xf8yre hj\xf8rne.","projects.list.filters.search.hint":"S\xf8k p\xe5 prosjekter","projects.modal.empty.search.description":"Sjekk om du har skrevet riktig, eventuelt legg til kunden direkte fra prosjektet","projects.modal.empty.search.title":"Dette prosjektet kunne vi dessverre ikke finne","projects.modal.filters.search.hint":"S\xf8k p\xe5 prosjekt","projects.modal.success.message":"{count, plural, =1 {1 kunde} other {# kunder}} lagt til prosjekt","projects.modal.title":"Legg til i prosjekt","projects.page.header.projects.count":"Antall prosjekter: {count} {selected, plural, =0 {} other {, # valgt}}","projects.page.title":"Prosjekter","question.editor.buttons.delete.label":"Slett sp\xf8rsm\xe5l","question.editor.errors.duplicate-question":"Samme sp\xf8rsm\xe5l finnes allerede","question.editor.errors.empty-question":"Skriv inn sp\xf8rsm\xe5l","question.editor.questions-table.empty.label":"Du har forel\xf8pig ikke lagt til noen sp\xf8rsm\xe5l i denne listen","questionnaire.archive.confirmation.description":"Er du sikker p\xe5 at du vil arkivere sp\xf8rreskjemaet \\"{name}\\"?","questionnaire.archive.confirmation.title":"Arkiver sp\xf8rreskjemaet","questionnaire.choices-table.button.add.label":"Legg til svaralternativ","questionnaire.choices-table.description.label":"Svaralternativ {index}","questionnaire.choices-table.errors.empty-option":"Tomt svaralternativ","questionnaire.details.page.invalid":"Ugyldig sp\xf8rreskjema","questionnaire.details.page.title.new-questionnaire":"Egne KYC-sp\xf8rsm\xe5l","questionnaire.page.add-questionnaire.button.label":"Opprett egne KYC-sp\xf8rsm\xe5l","questionnaire.page.filter.hide-archived-questionnaires":"Skjul arkiverte sp\xf8rreskjemaer","questionnaire.page.filter.placeholder":"Filtr\xe9r egendefinerte sp\xf8rreskjemaer etter navn","questionnaire.page.filter.show-archived-questionnaires":"Vis arkiverte sp\xf8rreskjemaer","questionnaire.page.header.description":"Her kan du opprette egne KYC-sp\xf8rsm\xe5l som kan sendes dine kunder, enten som en del av v\xe5re bransjetilpassede KYC-skjemaer, eller frittst\xe5ende.","questionnaire.page.title":"Egne KYC-sp\xf8rsm\xe5l","questionnaire.preview.modal.title":"Forh\xe5ndsvis sp\xf8rreskjema \\"{name}\\"","questionnaire.question.description.label":"Sp\xf8rsm\xe5l p\xe5 {language}","questionnaire.question.type.boolean":"Ja/Nei","questionnaire.question.type.multiple-choice":"Flervalg","questionnaire.question.type.multiple-country-choice":"Flervalg med land","questionnaire.question.type.single-choice":"Rullegardinmeny","questionnaire.question.type.single-country-choice":"Rullegardinmeny med land","questionnaire.question.type.text":"Tekstfelt","questionnaire.title.label":"Tittel p\xe5 {language}","questions.editor.buttons.add-question.label":"Legg til sp\xf8rsm\xe5l","responsible-users.label":"Ansvarlige brukere","responsible.empty.users":"Velg ansvarlige brukere","responsible.error":"Noe gikk galt ved lagring av ansvarlig","responsible.label":"Ansvarlig","responsible.modal.message":"Angi ansvarlig brukere for {names}","responsible.modal.title":"Angi ansvarlig brukere","review.checklist.answer.error.empty-additional-info":"Du m\xe5 legge inn en beskrivelse i tekstfeltet over","review.checklist.answer.placeholder":"Utdyp her:","review.checklist.details.page.messages.created-successfully":"Sjekklisten \xab{name}\xbb ble opprettet","review.checklist.details.page.title.edit-checklist":"Endre sjekkliste","review.checklist.details.page.title.new-checklist":"Opprett sjekkliste","review.checklist.duplicate.modal.success.message":"Sjekklisten er kopiert og lagret som \xab{name}\xbb","review.checklist.duplicate.modal.title":"Lag kopi av sjekklisten \xab{name}\xbb","review.checklist.editor.condition-type.purpose":"Oppdragstype","review.checklist.editor.condition-type.risk":"Risikokategori","review.checklist.editor.condition-type.tags":"Tags","review.checklist.editor.empty.name":"Du m\xe5 gi sjekklisten et navn","review.checklist.editor.labels.customer-type":"Sjekklisten skal gjelde for:","review.checklist.editor.labels.required":"Skal sjekklisten v\xe6re obligatorisk?","review.checklist.editor.labels.risk-type":"Hvilke betingelser skal trigge at sjekklisten legges til?","review.checklist.editor.labels.selection-type":"Skal sjekklisten legges automatisk til i risikovurderingen?","review.checklist.editor.labels.yes-always":"Ja, alltid","review.checklist.editor.labels.yes-choose":"Ja, velg betingelser","review.checklist.editor.selection-type.always":"Alltid","review.checklist.editor.selection-type.automatic":"Automatisk","review.checklist.editor.selection-type.manual":"Manuelt","review.checklist.editor.tips.banner.description":"1. Gi sjekklisten navn og beskrivelse, samt hvilken kundetype denne skal gjelde for.\\n2. Velg om den skal legges til\xa0automatisk i risikovurderingen, eller velg hva som skal trigge sjekklisten. \\n3. Velg om sjekklisten skal v\xe6re obigatorisk for alle brukere.\\n4. Legg til sp\xf8rsm\xe5l og formuler disse som \\"Ja\\"/\\"Nei\\"-sp\xf8rsm\xe5l\\n5. Ved \\"Ja\\" er det p\xe5krevd for saksbehandler \xe5 utdype ytterligere\\n6. Klikker du p\xe5 knappen \\"Forh\xe5ndsvis\\" vises sjekklisten slik den vil fremst\xe5 i selve risikovurderingen","review.checklist.editor.tips.banner.title":"Opprettelse av sjekklister","review.checklist.preview.modal.title":"Forh\xe5ndsvis sjekkliste \xab{name}\xbb","review.checklist.template.instance.modal.title":"Opprett sjekkliste fra mal: {name}","review.checklist.template.preview.modal.title":"Forh\xe5ndsvis mal: {name}","review.checklists.archive.confirmation.description":"Er du sikker p\xe5 at du vil arkivere sjekklisten \xab{name}\xbb?","review.checklists.archive.confirmation.title":"Arkiver sjekklisten","review.checklists.page.add.button.label":"Opprett sjekkliste","review.checklists.page.filter.hide-archived-checklists":"Skjul arkiverte sjekklister","review.checklists.page.filter.placeholder":"Filtr\xe9r sjekklister etter navn","review.checklists.page.filter.show-archived-checklists":"Vis arkiverte sjekklister","review.checklists.page.header.description":"Her kan du opprette egne sjekklister som kan benyttes i risikovurderingen av dine kunder.\\nDu kan opprette nye sjekklister, eller ta utgangspunkt i en mal og tilpasse denne til din virksomhet.","review.checklists.page.table.header":"Mine sjekklister","review.checklists.page.title":"Sjekklister","review.status.APPROVED":"Godkjent","review.status.NOT_READY":"Ikke klar - screening p\xe5g\xe5r","review.status.REJECTED":"Avsl\xe5tt","review.status.REVIEW_REQUIRED":"Klar for vurdering","reviews.header.banner.pending-disclosures.button.label":"Se gjenst\xe5ende KYC- og legitimasjonsforesp\xf8rsler","reviews.header.banner.pending-disclosures.description":"Det er {count, plural, =1 {1 ubesvart KYC- og legitimasjonsforesp\xf8rsel} other {# ubesvarte KYC- og legitimasjonsforesp\xf8rsler}}. Disse kan gi informasjon som p\xe5virker hvordan du \xf8nsker \xe5 risikovurdere kunden din","reviews.header.banner.unreviewed-match-cases.button.label":"Se gjenst\xe5ende treff","reviews.header.banner.unreviewed-match-cases.description":"Det er {count, number} mulige treff som b\xf8r vurderes f\xf8r du vurderer din kunde.","reviews.header.title":"Risikovurdering","reviews.labels.ask-for-confirmation":"Be om bekreftelse p\xe5 vurdering","reviews.labels.change-review":"Ny vurdering","reviews.labels.customer-risk":"Kunden tilh\xf8rer en risikobransje","reviews.labels.mark-as":"Marker kunde som","reviews.labels.mark-as.pep":"PEP","reviews.labels.mark-as.sanction":"Sanksjon","reviews.labels.new-review":"Ny vurdering","reviews.labels.no-reviews":"Det finnes ingen vurderinger p\xe5 kunden eller tilknyttede oppdrag","reviews.labels.perform-a-review":"Utf\xf8r vurdering","reviews.labels.relationship.change":"Angi risiko","reviews.labels.review-header":"Vurdering","reviews.labels.review-label":"Begrunnelse","reviews.labels.review.assessment":"Godkjenn/avsl\xe5 vurdering","reviews.labels.risk-indicators":"Risikoindikatorer{count, plural, =0 {} other {: #}}","reviews.labels.risk-tags":"Organiser med tags","reviews.labels.select-user-for-confirmation":"Velg hvem som skal bekrefte vurderingen","reviews.labels.toggle.hide-previous":"Skjul tidligere vurderinger ({count, number})","reviews.labels.toggle.show-previous":"Vis tidligere vurderinger ({count, number})","reviews.labels.unmark-as":"Fjernet merking som {badges}","reviews.placeholders.review-rational":"Begrunn vurderingen som er foretatt","reviews.titles.checklist":"Sjekkliste for kundevurdering","reviews.titles.existing-reviews":"Eksisterende vurderinger","reviews.titles.guideline-tips":"Tips til hva en god vurdering b\xf8r inneholde","reviews.titles.review-customer":"Risikovurdering av kunde","reviews.titles.risk-review":"Risikovurdering","risk-indicators.geographic-risk.description":"Rapporteringspliktige etter hvitvaskingsregelverket skal gjennomf\xf8re forsterkede kundetiltak med hensyn til kundeforhold og transaksjoner som involverer h\xf8yrisikoland, jf. hvitvaskingsforskriften \xa7 4-10.","risk-indicators.geographic-risk.title":"{country} funnet i f\xf8lgende liste(r) over h\xf8yrisikoland: {listNames}","risk-indicators.labels.confirmed-matches":"BEKREFTEDE TREFF: {count, number}","risk-indicators.labels.disclosure-risk":"KYC-BESVARELSER{count, plural, =0 {} other {: #}}","risk-indicators.labels.geographic-risk":"GEOGRAFISK RISIKO{count, plural, =0 {} other {: #}}","risk-indicators.labels.industry-risk":"BRANSJERISIKO{count, plural, =0 {} other {: #}}","risk-indicators.labels.personnel-risk":"ROLLEINNEHAVER OG RETTIGHETSHAVERE{count, plural, =0 {} other {: #}}","risklabel.HIGH":"H\xf8y","risklabel.LOW":"Lav","risklabel.MEDIUM":"Medium","risklabel.NOT_SET":"Uvurdert","risklabel.null":"Ikke vurdert","roles.button.labels.hide-expired-roles":"Skjul utg\xe5tte rolleinnehavere","roles.button.labels.show-expired-roles":"Vis utg\xe5tte rolleinnehavere ({count, number})","roles.messages.no-roles":"Ingen roller","screening-type.MONITORING":"L\xf8pende","screening-type.NONE":"-","screening-type.NOT_SET":"-","screening-type.ONE_TIME":"Kun enkeltst\xe5ende","screening-type.label.monitoring":"L\xf8pende","screening-type.label.one-time":"Kun enkeltst\xe5ende","screening-type.modal.message":"Angi screening-innstillinger for {names}","screening-type.modal.title":"Velg screening","screening-type.tooltip.person.screening.monitoring":"Personen er satt i l\xf8pende screening","screening-type.tooltip.person.screening.none":"Personen er ikke satt i l\xf8pende screening","screening.buttons.add-role":"Legg til rolleinnehaver","screening.errors.content":"Pr\xf8v igjen litt senere","screening.errors.description":"Gi det noen sekunder og pr\xf8v igjen. Eventuelt hent deg en kaffe :)","screening.errors.heading":"Beklager, dette tar altfor lang tid ...","screening.infobox.owners.definition":"En (reell) rettighetshaver er en person som, alene eller sammen med andre, kan ut\xf8ve (reell) kontroll over selskapet. Det er flere eksempler p\xe5 dette:\\n\\n\u2022 En person som alene innehar mer enn 25 % av aksjene/stemmene\\n\\n\u2022 Familiemedlemmer som til sammen (direkte eller indirekte) innehar mer enn 25% av aksjene/stemmene\\n\\n\u2022 En person, som via spesielle vedtekter, aksjon\xe6ravtale(r) eller annen avtale kontrollerer selskapet.\\n\\nDu kan lese mer om identifisering av reelle rettighetshavere i Hvitvaskingsloven: https://lovdata.no/lov/2018-06-01-23/\xa714","screening.infobox.owners.text.manual":"Rettighetshavere m\xe5 manuelt legges til ved registrering av utenlandske selskaper.","screening.infobox.owners.text.norwegian":"For selskap som kan ha aksjon\xe6rer (f.eks. aksjeselskap), identifiserer vi fysiske personer som eier 5 prosent eller mer gjennom hele eierstrukturen (kilde: Aksjon\xe6rregisteret). Du er selv ansvarlig for \xe5 kontrollere disse, og eventuelt oppdatere og/eller legge til manglende rettighetshavere.","screening.infobox.owners.title":"Hva er en rettighetshaver?","screening.infobox.roles.definition":"En rolleinnehaver er en person som har en rolle i selskapet. Eksempler p\xe5 dette er styremedlemmer, daglig leder/administrerende direkt\xf8r, og personer som kan signere p\xe5 vegne av selskapet (har signatur/prokurarett).","screening.infobox.roles.text.manual":"Rolleinnehavere m\xe5 manuelt legges til ved registrering av utenlandske selskaper.","screening.infobox.roles.text.norwegian":"Vi identifiserer personer som, ved tidspunktet for registreringen, er registrert med roller i selskapet (kilde: Br\xf8nn\xf8ysundregistrene).","screening.infobox.roles.title":"Hva er en rolleinnehaver?","screening.messages.retrieving-details":"Henter kundedata","screening.messages.specify-owners":"Oppgi selskapets rettighetshavere","screening.messages.specify-roles":"Oppgi selskapets rolleinnehavere","screening.owners.is_ubo.description":"Denne personen eier mer enn 25% av aksjene i kunden (eller mer enn 25% av aksjene i et selskap som eier mer enn 25% av kunden, etc.), som indikerer at personen er \xe5 anse som reell rettighetshaver. Se Hvitvaskingsloven: https://lovdata.no/lov/2018-06-01-23/\xa714","screening.roles.is_ubo.description":"I denne typen foretak ({companyType}) kan denne rollen ({roleType}) v\xe6re en alternativ reell rettighetshaver.","screening.snackbar.started":"Ny screening startet","screening.snackbar.stopped":"Screening avsluttet","screening.snackbar.updated":"Screening endret","screening.status.active":"Aktiv","screening.status.finished":"(utf\xf8rt {finished, date, ::yyyyMMdd})","screening.status.range":"(startet {started, date, ::yyyyMMdd}, avsluttet {stopped, date, ::yyyyMMdd})","screening.titles.banner.description":"Kunden vil ikke bli varslet om at du foretar en screening.","screening.titles.banner.title":"Screeningen gj\xf8res ubemerket.","screening.titles.customer":"Kunde","screening.titles.owners":"Rettighetshavere","screening.titles.roles":"Rolleinnehavere","screening.titles.screening":"Screening","screening.titles.screening-frequency":"Velg type screening","screening.titles.screening.description":"Velg personene som screeningen skal utf\xf8res p\xe5. Personene som er presentert best\xe5r av rettighetshavere med 5 prosent eller h\xf8yere eierandel og identifiserte rolleinnhavere.","screening.titles.screening.manual.description":"Legg til rettighetshavere og rolleinnehavere tilh\xf8rende selskapskunden du skal registrere. Husk \xe5 krysse av alle som skal inkluderes i screeningen.","screening.titles.screening.without-shareholders.description":"Velg personene som screeningen skal utf\xf8res p\xe5. Personene som er presentert best\xe5r av identifiserte rolleinnhavere.","shares-classes.banner.description":"Det er identifisert flere aksjeklasser i {name}. V\xe6r oppmerksom p\xe5 at en person kan ha stemmerettigheter utover de som f\xf8lger av eierandelen n\xe5r det er utstedt ulike aksjeklasser med ulik stemmerett (f.eks. A- og B-aksjer). Dette kan ha betydning for hvem som er \xe5 anse som reell(e) rettighetshaver(e). Du b\xf8r derfor innhente vedtektene fra din kunde og unders\xf8ke dette.","shares-classes.banner.title":"Flere aksjeklasser identifisert: {shares}","shares-classes.banner.url-label":"Les mer p\xe5 v\xe5r supportportal","signature.actions.copy.link":"Kopier link","signature.actions.delete.signature":"Slett KYC-foresp\xf8rsel","signature.actions.edit.signature":"Rediger mottakerinfo","signature.actions.remind.signer":"P\xe5minn mottaker","signature.configuration.form.buttons.preview":"Se hvordan KYC-skjemaet ser ut for kunden","signature.configuration.form.labels.choose.language":"Velg spr\xe5k p\xe5 e-post og KYC-sp\xf8rsm\xe5l","signature.configuration.form.labels.choose.send.method":"Velg sendemetode","signature.configuration.form.labels.custom.kyc.questions":"Egendefinerte KYC-sp\xf8rsm\xe5l","signature.configuration.form.labels.disclosure":"KYC-sp\xf8rsm\xe5l","signature.configuration.form.labels.disclosure.full":"Full KYC (inkl. PEP-sp\xf8rsm\xe5l)","signature.configuration.form.labels.disclosure.pep":"Kun PEP-sp\xf8rsm\xe5l","signature.configuration.form.labels.e-signatures":"Send dokument til e-signering","signature.configuration.form.labels.preview":"Forh\xe5ndsvisning av KYC","signature.configuration.form.labels.verification":"Inkluder legitimasjon med:","signature.email.not.provided":"Link tilgjengelig p\xe5 kundesiden","signature.modal.and.tooltips.copy.link":"Kopier signeringslink","signature.signing-method.no":"Norsk BankID","signature.signing-method.se":"Svensk BankID","signature.snackbar.deleted":"KYC-foresp\xf8rsel slettet","signature.tooltips.remind.signer":"P\xe5minn mottaker","signing-user-info.address":"Adresse","signing-user-info.birth-date":"F\xf8dselsdato","signing-user-info.name.mismatch.warning.tooltip":"Er dette riktig person?","summary.description":"Se over oppsummeringen og gj\xf8r endringer hvis n\xf8dvendig. N\xe5r du starter screeningen vil kunden motta en lenke med elektronisk identifisering og KYC-sp\xf8rsm\xe5l.","summary.project.title":"Prosjekt","summary.responsible-user":"Ansvarlig","summary.screening-type":"Type screening","summary.signers.start.screening":"Registrer kunde og start screening","summary.signers.text.skipped":"Dette steget er blitt hoppet over","summary.signers.title":"Mottakere av legitimering og KYC-sp\xf8rsm\xe5l","summary.signers.title.empty":"Ingen representanter valgt","summary.text.no-owners":"Ingen rettighetshavere blir screenet","summary.text.no-roles":"Ingen rolleinnehavere blir screenet","summary.text.screening.company":"Screening av selskap","summary.text.screening.owners":"Screening av rettighetshavere","summary.text.screening.roles":"Screening av rolleinnehavere","table.column.active":"AKTIV","table.column.address":"ADRESSE","table.column.country":"LAND","table.column.customer-number":"PERSONNUMMER / ORG.NR","table.column.customerTypes":"KUNDETYPER","table.column.date.of.birth":"F\xd8DSELSDATO","table.column.details":"DETALJER","table.column.email":"E-POST","table.column.email.or.url":"E-POST/LINK","table.column.gender":"KJ\xd8NN","table.column.groups":"GRUPPER","table.column.id":"ID","table.column.ignore":"OVERSE","table.column.last.updated":"SIST OPPDATERT","table.column.link":"LENKE","table.column.measure":"TILTAK","table.column.name":"NAVN","table.column.name-from-search":"NAVN FRA OPPSLAG","table.column.name-on-match":"NAVN P\xc5 TREFF","table.column.national.id":"F\xd8DSELSNUMMER","table.column.person":"PERSON","table.column.pin":"PIN","table.column.previous-search":"TIDLIGERE S\xd8K","table.column.questions":"SP\xd8RSM\xc5L","table.column.required":"OBLIGATORISK","table.column.responsible-user":"ANSVARLIG BRUKER","table.column.role":"ROLLE","table.column.search-by":"S\xd8KT P\xc5 AV","table.column.shares":"EIERANDEL","table.column.status":"STATUS","table.column.time-of-search":"TIDSPUNKT FOR S\xd8K","table.column.title":"TITTEL","table.column.ubo":"AKSJON\xc6R","table.column.used":"BENYTTES","table.row.owner":"Aksjon\xe6r","tags.button.label":"Tags","tags.editor.add-and-apply-button":"Opprett og tildel \xab{tag}\xbb","tags.editor.existing-tags":"Eksisterende tags","tags.editor.filter-tags":"Filtrer p\xe5 tags:","tags.editor.new-tag-input":"Opprett tag","tags.modal.empty-state":"Du har ikke opprettet noen tags.","tags.modal.tag.color":"Velg farge p\xe5 tag","tags.modal.tag.delete-tag":"Slett tag","tags.modal.tag.delete-tag.description":"Sletter du tag \xabBingo\xbb fjernes den ogs\xe5 fra alle prosjekter og tilh\xf8rende kunder.","tags.modal.tag.name":"Navngi tag p\xe5 {language}","tags.modal.tag.placeholder":"Navngi tag","tags.modal.tag.validation-error":"Angi navn p\xe5 tag","tags.modal.title.add-tag":"Opprett tag","tags.modal.title.edit-tags":"Endre tags","tags.modal.title.update-tag":"Endre tag","tags.page.assigned-tag.delete.description":"Tags i bruk kan ikke slettes","tags.page.filter.placeholder":"S\xf8k etter tag","tags.page.subtitle":"Opprett tags for enkelt \xe5 kunne gruppere kunder/klienter. Tags kan enkelt legges til en hvilken som helst kunde/klient og filtreres p\xe5 b\xe5de i kundelisten og p\xe5 dashboard.","tags.page.title":"Organiser med tags","tags.popover.success.message":"Tildelt etikett","ubo.manual-override.description":"Endringer b\xf8r begrunnes i kommentarfeltet under.\\n(Du m\xe5 endre screeningen manuelt ved behov, f.eks. hvis nye reelle rettighetshavere skal screenes)","ubo.manual-override.title":"Personen er reell rettighetshaver","users.modal.empty-group":"Ingen gruppe","users.modal.label.activate":"Aktivere","users.modal.label.deactivate":"Deaktivere","users.modal.title.add-user":"Opprett bruker","users.modal.title.update-user":"Oppdater bruker","users.page.add-user.button-label":"Opprett bruker","users.page.filter.hide-inactive-users":"Skjul deaktiverte brukere ({count, number})","users.page.filter.placeholder":"Filtr\xe9r brukere etter navn","users.page.filter.show-inactive-users":"Vis deaktiverte brukere ({count, number})","users.page.table.empty":"Ingen brukere ble funnet","users.page.title":"Brukere","vitec.modal.banner.description":"Denne personen har ingen mobilnummer oppf\xf8rt. Vitec Next krever vedkommendes mobilnummer for at kontaktkortet kan importeres.","vitec.modal.toast.message.error":"Kunne ikke importere {name} til Vitec Next ({error})","vitec.modal.toast.message.success":"{name} ble lastet opp til Vitec Next","vitec.report.upload.status.COMPLETED":"Lastet opp til Vitec","vitec.report.upload.status.FAILED":"Opplasting feilet","vitec.report.upload.status.WAITING":"Venter vurdering"}');

},{}],"ecnY7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LANGUAGE", ()=>DEFAULT_LANGUAGE);
parcelHelpers.export(exports, "SUPPORTED_LANGUAGES", ()=>SUPPORTED_LANGUAGES);
parcelHelpers.export(exports, "LANGUAGES_TO_COUNTRY_CODES", ()=>LANGUAGES_TO_COUNTRY_CODES);
parcelHelpers.export(exports, "LANGUAGES_FLAGS", ()=>LANGUAGES_FLAGS);
parcelHelpers.export(exports, "LANGUAGE_KEY", ()=>LANGUAGE_KEY);
var _unicode = require("country-flag-icons/unicode");
var _unicodeDefault = parcelHelpers.interopDefault(_unicode);
const DEFAULT_LANGUAGE = "nb";
const SUPPORTED_LANGUAGES = [
    "nb",
    "en"
];
const LANGUAGES_TO_COUNTRY_CODES = {
    nb: "NO",
    en: "US"
};
const LANGUAGES_FLAGS = {
    nb: (0, _unicodeDefault.default)("NO"),
    en: (0, _unicodeDefault.default)("US")
};
const LANGUAGE_KEY = "kdk-language";

},{"country-flag-icons/unicode":"4CF3d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4CF3d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _unicodeJsDefault.default));
var _unicodeJs = require("../modules/unicode.js");
var _unicodeJsDefault = parcelHelpers.interopDefault(_unicodeJs);

},{"../modules/unicode.js":"6ACrG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6ACrG":[function(require,module,exports) {
/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCountryFlag);
function getCountryFlag(country) {
    return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */ function getRegionalIndicatorSymbol(letter) {
    return String.fromCodePoint(127397 + letter.toUpperCase().charCodeAt(0));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aERXD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocalStorage", ()=>useLocalStorage);
parcelHelpers.export(exports, "useSessionStorage", ()=>useSessionStorage);
var _react = require("react");
var _react1 = require("@sentry/react");
var _reactTable = require("@tanstack/react-table");
var _util = require("../utils/util");
const createStorageHook = (storage)=>function useStorage(key, initialState) {
        const getInitialValue = ()=>(0, _reactTable.isFunction)(initialState) ? initialState() : initialState;
        const initialStateJSONStr = (0, _react.useRef)();
        // State to store our value
        // Pass initial state function to useState so logic is only executed once
        const [storedValue, setStoredValue] = (0, _react.useState)(()=>{
            try {
                // Get from storage by key
                const item = storage.getItem(key);
                // Parse stored json or if doesn't exists return initialValue
                const initialValue = item ? JSON.parse(item) : getInitialValue();
                initialStateJSONStr.current = JSON.stringify(initialValue);
                return initialValue;
            } catch (error) {
                _react1.captureException(error, {
                    level: "warning"
                });
                // If error also return initialValue
                return getInitialValue();
            }
        });
        // Return a wrapped version of useState's setter function that ...
        // ... persists the new value to storage.
        function setValue(value) {
            try {
                // Allow value to be a function so we have same API as useState
                const valueToStore = value instanceof Function ? value(storedValue) : value;
                // Save to storage
                storage.setItem(key, JSON.stringify(valueToStore));
                // Save state
                setStoredValue((0, _util.clone)(valueToStore));
            } catch (error) {
                // A more advanced implementation would handle the error case
                _react1.captureException(error, {
                    level: "warning"
                });
            }
        }
        const clear = ()=>{
            storage.removeItem(key);
            initialStateJSONStr.current = JSON.stringify(storedValue);
        };
        const changed = (0, _react.useMemo)(()=>JSON.stringify(storedValue) !== initialStateJSONStr.current, [
            storedValue,
            initialStateJSONStr.current
        ]);
        return [
            storedValue,
            setValue,
            clear,
            changed
        ];
    };
const useLocalStorage = createStorageHook(window.localStorage);
const useSessionStorage = createStorageHook(window.sessionStorage);

},{"react":"cOWTg","@sentry/react":"akCRS","@tanstack/react-table":"86D8M","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"86D8M":[function(require,module,exports) {
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flexRender", ()=>flexRender);
parcelHelpers.export(exports, "useReactTable", ()=>useReactTable);
var _react = require("react");
var _tableCore = require("@tanstack/table-core");
parcelHelpers.exportAll(_tableCore, exports);
//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function flexRender(Comp, props) {
    return !Comp ? null : isReactComponent(Comp) ? /*#__PURE__*/ _react.createElement(Comp, props) : Comp;
}
function isReactComponent(component) {
    return isClassComponent(component) || typeof component === "function" || isExoticComponent(component);
}
function isClassComponent(component) {
    return typeof component === "function" && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function isExoticComponent(component) {
    return typeof component === "object" && typeof component.$$typeof === "symbol" && [
        "react.memo",
        "react.forward_ref"
    ].includes(component.$$typeof.description);
}
function useReactTable(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = _react.useState(()=>({
            current: (0, _tableCore.createTable)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = _react.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}

},{"react":"cOWTg","@tanstack/table-core":"5Fl23","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Fl23":[function(require,module,exports) {
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnSizing", ()=>ColumnSizing);
parcelHelpers.export(exports, "Expanding", ()=>Expanding);
parcelHelpers.export(exports, "Filters", ()=>Filters);
parcelHelpers.export(exports, "Grouping", ()=>Grouping);
parcelHelpers.export(exports, "Headers", ()=>Headers);
parcelHelpers.export(exports, "Ordering", ()=>Ordering);
parcelHelpers.export(exports, "Pagination", ()=>Pagination);
parcelHelpers.export(exports, "Pinning", ()=>Pinning);
parcelHelpers.export(exports, "RowSelection", ()=>RowSelection);
parcelHelpers.export(exports, "Sorting", ()=>Sorting);
parcelHelpers.export(exports, "Visibility", ()=>Visibility);
parcelHelpers.export(exports, "aggregationFns", ()=>aggregationFns);
parcelHelpers.export(exports, "buildHeaderGroups", ()=>buildHeaderGroups);
parcelHelpers.export(exports, "createCell", ()=>createCell);
parcelHelpers.export(exports, "createColumn", ()=>createColumn);
parcelHelpers.export(exports, "createColumnHelper", ()=>createColumnHelper);
parcelHelpers.export(exports, "createRow", ()=>createRow);
parcelHelpers.export(exports, "createTable", ()=>createTable);
parcelHelpers.export(exports, "defaultColumnSizing", ()=>defaultColumnSizing);
parcelHelpers.export(exports, "expandRows", ()=>expandRows);
parcelHelpers.export(exports, "filterFns", ()=>filterFns);
parcelHelpers.export(exports, "flattenBy", ()=>flattenBy);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "getCoreRowModel", ()=>getCoreRowModel);
parcelHelpers.export(exports, "getExpandedRowModel", ()=>getExpandedRowModel);
parcelHelpers.export(exports, "getFacetedMinMaxValues", ()=>getFacetedMinMaxValues);
parcelHelpers.export(exports, "getFacetedRowModel", ()=>getFacetedRowModel);
parcelHelpers.export(exports, "getFacetedUniqueValues", ()=>getFacetedUniqueValues);
parcelHelpers.export(exports, "getFilteredRowModel", ()=>getFilteredRowModel);
parcelHelpers.export(exports, "getGroupedRowModel", ()=>getGroupedRowModel);
parcelHelpers.export(exports, "getPaginationRowModel", ()=>getPaginationRowModel);
parcelHelpers.export(exports, "getSortedRowModel", ()=>getSortedRowModel);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
parcelHelpers.export(exports, "isRowSelected", ()=>isRowSelected);
parcelHelpers.export(exports, "isSubRowSelected", ()=>isSubRowSelected);
parcelHelpers.export(exports, "makeStateUpdater", ()=>makeStateUpdater);
parcelHelpers.export(exports, "memo", ()=>memo);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "orderColumns", ()=>orderColumns);
parcelHelpers.export(exports, "passiveEventSupported", ()=>passiveEventSupported);
parcelHelpers.export(exports, "reSplitAlphaNumeric", ()=>reSplitAlphaNumeric);
parcelHelpers.export(exports, "selectRowsFn", ()=>selectRowsFn);
parcelHelpers.export(exports, "shouldAutoRemoveFilter", ()=>shouldAutoRemoveFilter);
parcelHelpers.export(exports, "sortingFns", ()=>sortingFns);
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function noop() {
//
}
function makeStateUpdater(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: functionalUpdate(updater, old[key])
            };
        });
    };
}
function isFunction(d) {
    return d instanceof Function;
}
function isNumberArray(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === "number");
}
function flattenBy(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function memo(getDeps, fn, opts) {
    let deps = [];
    let result;
    return ()=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function createColumn(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace(".", "_") : undefined) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes(".")) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split(".")){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn,
        parent: parent,
        depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: memo(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, {
            key: "column.getFlatColumns",
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
            }
        }),
        getLeafColumns: memo(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, {
            key: "column.getLeafColumns",
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
            }
        })
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to uknown, because we know more than the compiler here.
    return column;
}
//
function createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id,
        column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table,
                header: header,
                column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const Headers = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = buildHeaderGroups(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugHeaders;
            }
        });
        table.getCenterHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return buildHeaderGroups(allColumns, leafColumns, table, "center");
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugHeaders;
            }
        });
        table.getLeftHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return buildHeaderGroups(allColumns, orderedLeafColumns, table, "left");
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA3;
                return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugHeaders;
            }
        });
        table.getRightHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return buildHeaderGroups(allColumns, orderedLeafColumns, table, "right");
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA4;
                return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugHeaders;
            }
        });
        // Footer Groups
        table.getFooterGroups = memo(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA5;
                return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugHeaders;
            }
        });
        table.getLeftFooterGroups = memo(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA6;
                return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugHeaders;
            }
        });
        table.getCenterFooterGroups = memo(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA7;
                return (_table$options$debugA7 = table.options.debugAll) != null ? _table$options$debugA7 : table.options.debugHeaders;
            }
        });
        table.getRightFooterGroups = memo(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA8;
                return (_table$options$debugA8 = table.options.debugAll) != null ? _table$options$debugA8 : table.options.debugHeaders;
            }
        });
        // Flat Headers
        table.getFlatHeaders = memo(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA9;
                return (_table$options$debugA9 = table.options.debugAll) != null ? _table$options$debugA9 : table.options.debugHeaders;
            }
        });
        table.getLeftFlatHeaders = memo(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA10;
                return (_table$options$debugA10 = table.options.debugAll) != null ? _table$options$debugA10 : table.options.debugHeaders;
            }
        });
        table.getCenterFlatHeaders = memo(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA11;
                return (_table$options$debugA11 = table.options.debugAll) != null ? _table$options$debugA11 : table.options.debugHeaders;
            }
        });
        table.getRightFlatHeaders = memo(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA12;
                return (_table$options$debugA12 = table.options.debugAll) != null ? _table$options$debugA12 : table.options.debugHeaders;
            }
        });
        // Leaf Headers
        table.getCenterLeafHeaders = memo(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA13;
                return (_table$options$debugA13 = table.options.debugAll) != null ? _table$options$debugA13 : table.options.debugHeaders;
            }
        });
        table.getLeftLeafHeaders = memo(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA14;
                return (_table$options$debugA14 = table.options.debugAll) != null ? _table$options$debugA14 : table.options.debugHeaders;
            }
        });
        table.getRightLeafHeaders = memo(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA15;
                return (_table$options$debugA15 = table.options.debugAll) != null ? _table$options$debugA15 : table.options.debugHeaders;
            }
        });
        table.getLeafHeaders = memo(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA16;
                return (_table$options$debugA16 = table.options.debugAll) != null ? _table$options$debugA16 : table.options.debugHeaders;
            }
        });
    }
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join("_"),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join("_"),
                    isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>createHeader(table, column, {
            depth: maxDepth,
            index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan,
                rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
//
//
const defaultColumnSizing = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const ColumnSizing = {
    getDefaultColumnDef: ()=>{
        return defaultColumnSizing;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: "onEnd",
            columnResizeDirection: "ltr",
            onColumnSizingChange: makeStateUpdater("columnSizing", table),
            onColumnSizingInfoChange: makeStateUpdater("columnSizingInfo", table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : defaultColumnSizing.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : defaultColumnSizing.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : defaultColumnSizing.maxSize);
        };
        column.getStart = (position)=>{
            const columns = !position ? table.getVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
            const index = columns.findIndex((d)=>d.id === column.id);
            if (index > 0) {
                const prevSiblingColumn = columns[index - 1];
                return prevSiblingColumn.getStart(position) + prevSiblingColumn.getSize();
            }
            return 0;
        };
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if (isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== "number") return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === "rtl" ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset,
                            deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === "onChange" || eventType === "end") table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset("move", clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset("end", clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = _contextDocument || typeof document !== "undefined" ? document : null;
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener("mousemove", mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("mouseup", mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener("touchmove", touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("touchend", touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = passiveEventSupported() ? {
                    passive: false
                } : false;
                if (isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let passiveSupported = null;
function passiveEventSupported() {
    if (typeof passiveSupported === "boolean") return passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener("test", noop, options);
        window.removeEventListener("test", noop);
    } catch (err) {
        supported = false;
    }
    passiveSupported = supported;
    return passiveSupported;
}
function isTouchStartEvent(e) {
    return e.type === "touchstart";
}
//
const Expanding = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: makeStateUpdater("expanded", table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === "boolean") return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split(".");
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
const includesString = (row, columnId, filterValue)=>{
    var _row$getValue;
    const search = filterValue.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
includesString.autoRemove = (val)=>testFalsey(val);
const includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
includesStringSensitive.autoRemove = (val)=>testFalsey(val);
const equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
equalsString.autoRemove = (val)=>testFalsey(val);
const arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
arrIncludes.autoRemove = (val)=>testFalsey(val) || !(val != null && val.length);
const arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
arrIncludesAll.autoRemove = (val)=>testFalsey(val) || !(val != null && val.length);
const arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
arrIncludesSome.autoRemove = (val)=>testFalsey(val) || !(val != null && val.length);
const equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
equals.autoRemove = (val)=>testFalsey(val);
const weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
weakEquals.autoRemove = (val)=>testFalsey(val);
const inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
inNumberRange.autoRemove = (val)=>testFalsey(val) || testFalsey(val[0]) && testFalsey(val[1]);
// Export
const filterFns = {
    includesString,
    includesStringSensitive,
    equalsString,
    arrIncludes,
    arrIncludesAll,
    arrIncludesSome,
    equals,
    weakEquals,
    inNumberRange
};
// Utils
function testFalsey(val) {
    return val === undefined || val === null || val === "";
}
//
const Filters = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            globalFilter: undefined,
            // filtersProgress: 1,
            // facetProgress: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: makeStateUpdater("columnFilters", table),
            onGlobalFilterChange: makeStateUpdater("globalFilter", table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100,
            globalFilterFn: "auto",
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === "string" || typeof value === "number";
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return filterFns.includesString;
            if (typeof value === "number") return filterFns.inNumberRange;
            if (typeof value === "boolean") return filterFns.equals;
            if (value !== null && typeof value === "object") return filterFns.equals;
            if (Array.isArray(value)) return filterFns.arrIncludes;
            return filterFns.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return isFunction(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : filterFns[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena2, _table$options$enable3, _table$options$enable4, _table$options$getCol;
            return ((_column$columnDef$ena2 = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena2 : true) && ((_table$options$enable3 = table.options.enableGlobalFilter) != null ? _table$options$enable3 : true) && ((_table$options$enable4 = table.options.enableFilters) != null ? _table$options$enable4 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousfilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = functionalUpdate(value, previousfilter ? previousfilter.value : undefined);
                //
                if (shouldAutoRemoveFilter(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousfilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    // () => [column.getFacetedRowModel()],
    // facetedRowModel => getRowModelMinMaxValues(facetedRowModel, column.id),
    },
    createRow: (row, table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return filterFns.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter3, _table$options$filter4;
            const { globalFilterFn: globalFilterFn } = table.options;
            return isFunction(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter3 = (_table$options$filter4 = table.options.filterFns) == null ? void 0 : _table$options$filter4[globalFilterFn]) != null ? _table$options$filter3 : filterFns[globalFilterFn];
        };
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = functionalUpdate(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if (shouldAutoRemoveFilter(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__");
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__");
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__");
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
function shouldAutoRemoveFilter(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === "number" ? nextValue : 0);
    }, 0);
};
const min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!isNumberArray(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const aggregationFns = {
    sum,
    min,
    max,
    extent,
    mean,
    median,
    unique,
    uniqueCount,
    count
};
//
const Grouping = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: makeStateUpdater("grouping", table),
            groupedColumnMode: "reorder"
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _ref, _ref2, _ref3, _column$columnDef$ena;
            return (_ref = (_ref2 = (_ref3 = (_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) != null ? _ref3 : table.options.enableGrouping) != null ? _ref2 : true) != null ? _ref : !!column.accessorFn;
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "number") return aggregationFns.sum;
            if (Object.prototype.toString.call(value) === "[object Date]") return aggregationFns.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return isFunction(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : aggregationFns[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === "remove") return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const Ordering = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: makeStateUpdater("columnOrder", table)
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = memo(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return orderColumns(orderedColumns, grouping, groupedColumnMode);
            }, {
            key: false
        });
    }
};
//
const defaultPageIndex = 0;
const defaultPageSize = 10;
const getDefaultPaginationState = ()=>({
        pageIndex: defaultPageIndex,
        pageSize: defaultPageSize
    });
const Pagination = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: makeStateUpdater("pagination", table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = functionalUpdate(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = functionalUpdate(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex,
                    pageSize
                };
            });
        };
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = functionalUpdate(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === "number") newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = memo(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getPrePaginationRowModel().rows.length / table.getState().pagination.pageSize);
        };
    }
};
//
const getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const Pinning = {
    getInitialState: (state)=>{
        return {
            columnPinning: getDefaultColumnPinningState(),
            rowPinning: getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: makeStateUpdater("columnPinning", table),
            onRowPinningChange: makeStateUpdater("rowPinning", table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === "right") {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === "left") {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left, right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? "left" : isRight ? "right" : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref2)=>{
                let { id } = _ref2;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref3)=>{
                let { id } = _ref3;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === "bottom") {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === "top") {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref4;
            const { enableRowPinning, enablePinning } = table.options;
            if (typeof enableRowPinning === "function") return enableRowPinning(row);
            return (_ref4 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref4 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top, bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? "top" : isBottom ? "bottom" : false;
        };
        row.getPinnedIndex = ()=>{
            var _table$_getPinnedRows, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_table$_getPinnedRows = table._getPinnedRows(position)) == null ? void 0 : _table$_getPinnedRows.map((_ref5)=>{
                let { id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
        row.getCenterVisibleCells = memo(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
            }
        });
        row.getLeftVisibleCells = memo(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                , 
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "left"
                }));
            return cells;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
            }
        });
        row.getRightVisibleCells = memo(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "right"
                }));
            return cells;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA3;
                return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugRows;
            }
        });
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = memo(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA4;
                return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
            }
        });
        table.getRightLeafColumns = memo(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA5;
                return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
            }
        });
        table.getCenterLeafColumns = memo(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA6;
                return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugColumns;
            }
        });
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState2;
            return table.setRowPinning(defaultState ? getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState2 = table.initialState) == null ? void 0 : _table$initialState2.rowPinning) != null ? _table$initialState$r : getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio2;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio2 = pinningState[position]) == null ? void 0 : _pinningState$positio2.length);
        };
        table._getPinnedRows = (position)=>memo(()=>[
                    table.getRowModel().rows,
                    table.getState().rowPinning[position]
                ], (visibleRows, pinnedRowIds)=>{
                var _table$options$keepPi;
                const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
                //account for expanded parent rows, but not pagination or filtering
                (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                    const row = table.getRow(rowId, true);
                    return row.getIsAllParentsExpanded() ? row : null;
                }) : //else get only visible rows that are pinned
                (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
                return rows.filter(Boolean).map((d)=>({
                        ...d,
                        position
                    }));
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA7;
                    return (_table$options$debugA7 = table.options.debugAll) != null ? _table$options$debugA7 : table.options.debugRows;
                }
            })();
        table.getTopRows = ()=>table._getPinnedRows("top");
        table.getBottomRows = ()=>table._getPinnedRows("bottom");
        table.getCenterRows = memo(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA8;
                return (_table$options$debugA8 = table.options.debugAll) != null ? _table$options$debugA8 : table.options.debugRows;
            }
        });
    }
};
//
const RowSelection = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: makeStateUpdater("rowSelection", table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = memo(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
        table.getFilteredSelectedRowModel = memo(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, {
            key: "getFilteredSelectedRowModel",
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugTable;
            }
        });
        table.getGroupedSelectedRowModel = memo(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, {
            key: "getGroupedSelectedRowModel",
            debug: ()=>{
                var _table$options$debugA3;
                return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugTable;
            }
        });
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== "undefined" ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection } = table.getState();
            return isRowSelected(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection } = table.getState();
            return isSubRowSelected(row, rowSelection) === "some";
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection } = table.getState();
            return isSubRowSelected(row, rowSelection) === "all";
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === "function") return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === "function") return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === "function") return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function selectRowsFn(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = isRowSelected(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function isRowSelected(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if (isRowSelected(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = isSubRowSelected(subRow, selection);
            if (subRowChildrenSelected === "all") someSelected = true;
            else if (subRowChildrenSelected === "some") {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? "all" : someSelected ? "some" : false;
}
const reSplitAlphaNumeric = /([0-9]+)/gm;
const alphanumeric = (rowA, rowB, columnId)=>{
    return compareAlphanumeric(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
const alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return compareAlphanumeric(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const text = (rowA, rowB, columnId)=>{
    return compareBasic(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const textCaseSensitive = (rowA, rowB, columnId)=>{
    return compareBasic(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
const datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const basic = (rowA, rowB, columnId)=>{
    return compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function toString(a) {
    if (typeof a === "number") {
        if (isNaN(a) || a === Infinity || a === -Infinity) return "";
        return String(a);
    }
    if (typeof a === "string") return a;
    return "";
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
    const b = bStr.split(reSplitAlphaNumeric).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const sortingFns = {
    alphanumeric,
    alphanumericCaseSensitive,
    text,
    textCaseSensitive,
    datetime,
    basic
};
//
const Sorting = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: "auto",
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: makeStateUpdater("sorting", table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === "[object Date]") return sortingFns.datetime;
                if (typeof value === "string") {
                    isString = true;
                    if (value.split(reSplitAlphaNumeric).length > 1) return sortingFns.alphanumeric;
                }
            }
            if (isString) return sortingFns.text;
            return sortingFns.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return "asc";
            return "desc";
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return isFunction(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : sortingFns[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== "undefined" && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = "toggle";
                    else sortAction = "add";
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = "replace";
                    else if (existingSorting) sortAction = "toggle";
                    else sortAction = "replace";
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === "toggle") {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = "remove";
                    }
                }
                if (sortAction === "add") {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === "toggle") // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === "remove") newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
            return sortDescFirst ? "desc" : "asc";
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === "desc" ? "asc" : "desc";
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? "desc" : "asc";
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
//
const Visibility = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: makeStateUpdater("columnVisibility", table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            return (_table$getState$colum = (_table$getState$colum2 = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum2[column.id]) != null ? _table$getState$colum : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = memo(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, {
            key: "row._getAllVisibleCells",
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
            }
        });
        row.getVisibleCells = memo(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], {
            key: false,
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
            }
        });
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return memo(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join("_")
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, {
                key,
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
                }
            });
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod("getVisibleFlatColumns", ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod("getVisibleLeafColumns", ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod("getLeftVisibleLeafColumns", ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod("getRightVisibleLeafColumns", ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod("getCenterVisibleLeafColumns", ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const features = [
    Headers,
    Visibility,
    Ordering,
    Pinning,
    Filters,
    Sorting,
    Grouping,
    Expanding,
    Pagination,
    RowSelection,
    ColumnSizing
];
//
function createTable(options) {
    var _options$initialState;
    if (options.debugAll || options.debugTable) console.info("Creating Table Instance...");
    let table = {
        _features: features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = functionalUpdate(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join(".") : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: memo(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, {
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
            },
            key: false
        }),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: memo(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = createColumn(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
            }
        }),
        getAllFlatColumns: memo(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA3;
                return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
            }
        }),
        _getAllFlatColumnsById: memo(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA4;
                return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
            }
        }),
        getAllLeafColumns: memo(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA5;
                return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
            }
        }),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function createCell(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row,
        column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: memo(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table,
                column,
                row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), {
            key: false,
            debug: ()=>table.options.debugAll
        })
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
const createRow = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id,
        index: rowIndex,
        original,
        depth,
        parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>flattenBy(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: memo(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return createCell(table, row, column, column.id);
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
            }
        }),
        _getAllCellsByColumnId: memo(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, {
            key: "row.getAllCellsByColumnId",
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
            }
        })
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
// type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function createColumnHelper() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === "function" ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
function getCoreRowModel() {
    return (table)=>memo(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = createRow(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return filterRowModelFromLeafs(rows, filterRowImpl, table);
    return filterRowModelFromRoot(rows, filterRowImpl, table);
}
function filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = createRow(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = createRow(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function getFilteredRowModel() {
    return (table)=>memo(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = columnFilters.map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push("__global__");
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return filterRows(rowModel.rows, filterRowsImpl, table);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function getFacetedRowModel() {
    return (table, columnId)=>memo(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? "__global__" : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return filterRows(preRowModel.rows, filterRowsImpl, table);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function getFacetedUniqueValues() {
    return (table, columnId)=>memo(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function getFacetedMinMaxValues() {
    return (table, columnId)=>memo(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            var _facetedRowModel$flat;
            if (!facetedRowModel) return undefined;
            const firstValue = (_facetedRowModel$flat = facetedRowModel.flatRows[0]) == null ? void 0 : _facetedRowModel$flat.getUniqueValues(columnId);
            if (typeof firstValue === "undefined") return undefined;
            let facetedMinMaxValues = [
                firstValue,
                firstValue
            ];
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (value < facetedMinMaxValues[0]) facetedMinMaxValues[0] = value;
                    else if (value > facetedMinMaxValues[1]) facetedMinMaxValues[1] = value;
                }
            }
            return facetedMinMaxValues;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function getSortedRowModel() {
    return (table)=>memo(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (columnInfo.sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) sortInt = aUndefined && bUndefined ? 0 : aUndefined ? columnInfo.sortUndefined : -columnInfo.sortUndefined;
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function getGroupedRowModel() {
    return (table)=>memo(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) return rowModel;
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = groupBy(rows, columnId);
                // Peform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? flattenBy(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = createRow(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue,
                        subRows,
                        leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._queue(()=>{
                    table._autoResetExpanded();
                    table._autoResetPageIndex();
                });
            }
        });
}
function groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function getExpandedRowModel() {
    return (table)=>memo(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return expandRows(rowModel);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
}
function expandRows(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function getPaginationRowModel(opts) {
    return (table)=>memo(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize, pageIndex } = pagination;
            let { rows, flatRows, rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = expandRows({
                rows,
                flatRows,
                rowsById
            });
            else paginatedRowModel = {
                rows,
                flatRows,
                rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4MniK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "isEmailEnabled", ()=>isEmailEnabled);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
parcelHelpers.export(exports, "isTranslationTextEmpty", ()=>isTranslationTextEmpty);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isNil", ()=>isNil);
/**
 * Checks if an unknown value is an object with a given property
 */ parcelHelpers.export(exports, "hasOwnProperty", ()=>hasOwnProperty);
/**
 * removes all empty values from an object
 */ parcelHelpers.export(exports, "removeEmptyValues", ()=>removeEmptyValues);
/**
 * Removes a property from an object
 */ parcelHelpers.export(exports, "removeProperty", ()=>removeProperty);
/**
 * Deep clones an item
 */ parcelHelpers.export(exports, "clone", ()=>clone);
var _stringUtils = require("./stringUtils");
function noop() {
// do nothing!
}
function isEmailEnabled(d) {
    return d.send_email === undefined || d.send_email;
}
let lastId = 0;
function uniqueId(prefix = "id") {
    lastId++;
    return `${prefix}${lastId}`;
}
function isTranslationTextEmpty(object) {
    if (object === undefined || object === null) return true;
    return Object.values(object).every((text)=>(0, _stringUtils.isEmptyString)(text));
}
function isEmpty(object) {
    if (object === undefined || object === null) return true;
    const objectType = typeof object;
    switch(objectType){
        case "string":
            return (0, _stringUtils.isEmptyString)(object);
        case "object":
            return Object.values(object).filter(Boolean).length === 0;
        // for all other types, if they're not null or undefined, then they're not empty
        // for example, a number with the value of 0 is not considered an empty value
        default:
            return false;
    }
}
function isNil(x) {
    return x === undefined || x === null;
}
function hasOwnProperty(x, prop) {
    if (typeof x === "object" && x) return Object.prototype.hasOwnProperty.call(x, prop);
    else return false;
}
function removeEmptyValues(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, value])=>typeof value !== "undefined" && value !== null));
}
function removeProperty(obj, key) {
    // this method uses destructuring in order to remove the property in [key] name
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [key]: _, ...newObj } = obj;
    return newObj;
}
function clone(item) {
    return JSON.parse(JSON.stringify(item));
}

},{"./stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4gVdA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmail", ()=>isEmail);
parcelHelpers.export(exports, "firstLetter", ()=>firstLetter);
parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
parcelHelpers.export(exports, "lowercaseFirstLetter", ()=>lowercaseFirstLetter);
parcelHelpers.export(exports, "compareNumericStrings", ()=>compareNumericStrings);
parcelHelpers.export(exports, "parseWebsite", ()=>parseWebsite);
parcelHelpers.export(exports, "appendCounter", ()=>appendCounter);
parcelHelpers.export(exports, "areNamesSimilar", ()=>areNamesSimilar);
parcelHelpers.export(exports, "bytesToMegaBytes", ()=>bytesToMegaBytes);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "filterRegEx", ()=>filterRegEx);
var _stringSimilarityJs = require("string-similarity-js");
var _stringSimilarityJsDefault = parcelHelpers.interopDefault(_stringSimilarityJs);
var _numbersUtils = require("./numbersUtils");
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const LETTERS_REGEX = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g;
// the threshold that below means 2 strings are not similar
// see: https://github.com/stephenjjbrown/string-similarity-js
const NAME_SIMILARITY_THRESHOLD = 0.6;
const isEmail = (str)=>Boolean(str) && EMAIL_REGEX.test(String(str).toLowerCase());
const firstLetter = (str)=>(str || "").substr(0, 1);
const isEmptyString = (str)=>typeof str !== "string" || str.length === 0 || str.trim().length === 0;
const lowercaseFirstLetter = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const compareNumericStrings = (str1, str2)=>Number(str1) > Number(str2);
const parseWebsite = (www)=>{
    if (!www) return undefined;
    if (www.startsWith("https") || www.startsWith("http")) return www;
    else return `http://${www}`;
};
const appendCounter = (label, count)=>!(0, _numbersUtils.isNumber)(count) || count === 0 ? label : `${label} (${count})`;
// returns a sorted words list without "-"
const getNameWords = (str)=>str.replaceAll("-", " ").split(" ");
const isInitial = (word)=>word.length === 1 || word.endsWith(".") && word.length === 2;
const areNamesSimilar = (name1, name2)=>{
    const name1Words = getNameWords(name1);
    const name2Words = getNameWords(name2);
    if (name1Words.length !== name2Words.length) return false;
    for(let index = 0; index < name1Words.length; index++){
        const word1 = name1Words[index];
        const word2 = name2Words[index];
        // first or last words of the name
        if (index === 0 || index === name1Words.length - 1) {
            if ((0, _stringSimilarityJsDefault.default)(word1, word2) < NAME_SIMILARITY_THRESHOLD) return false;
        } else {
            // middle words of the name
            // if one of the middle words in the name is an initial letter = compare only the first letters between the words
            if (isInitial(word1) || isInitial(word2)) return word1[0].toLocaleLowerCase() === word2[0].toLocaleLowerCase();
            else {
                // middle words are not initials - compare all the words based on their similarity
                if ((0, _stringSimilarityJsDefault.default)(word1, word2) < NAME_SIMILARITY_THRESHOLD) return false;
            }
        }
    }
    return true;
};
const bytesToMegaBytes = (bytes)=>(bytes / 1000000).toFixed(0);
const toKebabCase = (str = "")=>str.match(LETTERS_REGEX)?.map((x)=>x.toLowerCase()).join("-");
const filterRegEx = (term = "")=>new RegExp(term.replace(/\(|\)/g, ""), "i");

},{"string-similarity-js":"ksDXa","./numbersUtils":"2RGyl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ksDXa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringSimilarity = void 0;
/* global exports, Map */ /**
 * Calculate similarity between two strings
 * @param {string} str1 First string to match
 * @param {string} str2 Second string to match
 * @param {number} [substringLength=2] Optional. Length of substring to be used in calculating similarity. Default 2.
 * @param {boolean} [caseSensitive=false] Optional. Whether you want to consider case in string matching. Default false;
 * @returns Number between 0 and 1, with 0 being a low match score.
 */ var stringSimilarity = function(str1, str2, substringLength, caseSensitive) {
    if (substringLength === void 0) substringLength = 2;
    if (caseSensitive === void 0) caseSensitive = false;
    if (!caseSensitive) {
        str1 = str1.toLowerCase();
        str2 = str2.toLowerCase();
    }
    if (str1.length < substringLength || str2.length < substringLength) return 0;
    var map = new Map();
    for(var i = 0; i < str1.length - (substringLength - 1); i++){
        var substr1 = str1.substr(i, substringLength);
        map.set(substr1, map.has(substr1) ? map.get(substr1) + 1 : 1);
    }
    var match = 0;
    for(var j = 0; j < str2.length - (substringLength - 1); j++){
        var substr2 = str2.substr(j, substringLength);
        var count = map.has(substr2) ? map.get(substr2) : 0;
        if (count > 0) {
            map.set(substr2, count - 1);
            match++;
        }
    }
    return match * 2 / (str1.length + str2.length - (substringLength - 1) * 2);
};
exports.stringSimilarity = stringSimilarity;
exports.default = exports.stringSimilarity;

},{}],"1o5Hm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _pageNavigation = require("../providers/PageNavigation");
const usePageNavigation = ()=>{
    return (0, _react.useContext)((0, _pageNavigation.PageNavigationContext));
};
exports.default = usePageNavigation;

},{"react":"cOWTg","../providers/PageNavigation":"eJqkE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eJqkE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageNavigationContext", ()=>PageNavigationContext);
parcelHelpers.export(exports, "PageNavigationContextProvider", ()=>PageNavigationContextProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _pageAnchors = require("../constants/page-anchors");
var _useTimeout = require("../hooks/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _browserUtils = require("../utils/browserUtils");
var _util = require("../utils/util");
const PageNavigationContext = /*#__PURE__*/ (0, _react.createContext)({
    navigationSections: [],
    // initial value for PageNavigationContext requires empty methods
    setNavigationSections: (0, _util.noop),
    clearNavigationSections: (0, _util.noop),
    showNavigationMenu: false,
    isNavigationScrolling: false,
    navigateInPage: (0, _util.noop)
});
const PageNavigationContextProvider = ({ children })=>{
    const [navigationSections, setNavigationSections] = (0, _react.useState)([]);
    const [isNavigationScrolling, setIsNavigationScrolling] = (0, _react.useState)(false);
    (0, _useTimeoutDefault.default)(()=>setIsNavigationScrolling(false), 500, isNavigationScrolling);
    const location = (0, _reactRouterDom.useLocation)();
    const history = (0, _reactRouterDom.useHistory)();
    const showNavigationMenu = navigationSections.length > 0;
    const clearNavigationSections = ()=>setNavigationSections([]);
    const navigateInPage = (0, _react.useCallback)((anchor, options)=>{
        // remove hash if exists
        location.pathname = location.pathname.replace(/#.*$/, "");
        // add anchor
        location.hash = anchor === (0, _pageAnchors.PAGE_ANCHORS).TOP_SECTION ? "" : `#${anchor}`;
        history.replace(location);
        setIsNavigationScrolling(true);
        (0, _browserUtils.scrollInPage)(anchor, options || {
            behavior: "smooth"
        });
    }, [
        history,
        location
    ]);
    const value = {
        navigationSections,
        setNavigationSections,
        clearNavigationSections,
        showNavigationMenu,
        isNavigationScrolling,
        navigateInPage
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PageNavigationContext.Provider, {
        value: value,
        children: children
    });
};

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../constants/page-anchors":"4WmvA","../hooks/useTimeout":"4i6My","../utils/browserUtils":"4ShiW","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4WmvA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PAGE_ANCHORS", ()=>PAGE_ANCHORS);
var PAGE_ANCHORS;
(function(PAGE_ANCHORS) {
    PAGE_ANCHORS["TOP_SECTION"] = "root";
    PAGE_ANCHORS["COMPANY_ROLES_AND_OWNERS_SECTION"] = "roles";
    PAGE_ANCHORS["CUSTOMER_ASSIGNMENTS"] = "assignments";
    PAGE_ANCHORS["CUSTOMER_DETAILS"] = "details";
    PAGE_ANCHORS["CUSTOMER_DOCUMENTS"] = "documents";
    PAGE_ANCHORS["CUSTOMER_MATCH_CASES"] = "match-cases";
    PAGE_ANCHORS["DISCLOSURES_SECTION"] = "disclosures";
    PAGE_ANCHORS["PENDING_REVIEWS_SECTION"] = "pending-reviews";
    PAGE_ANCHORS["REVIEWS_SECTION"] = "reviews";
    PAGE_ANCHORS["REVIEW_CHECKLIST_FORM"] = "review-checklist-from";
})(PAGE_ANCHORS || (PAGE_ANCHORS = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4i6My":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useTimeout = (callback, delay, when = true)=>{
    const callbackRef = (0, _react.useRef)(callback);
    const timeoutRef = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const set = (0, _react.useCallback)(()=>{
        timeoutRef.current = window.setTimeout(()=>callbackRef.current(), delay);
    }, [
        delay
    ]);
    const clear = (0, _react.useCallback)(()=>{
        timeoutRef.current && window.clearTimeout(timeoutRef.current);
    }, []);
    (0, _react.useEffect)(()=>{
        if (when) set();
        return clear;
    }, [
        delay,
        set,
        clear,
        when
    ]);
    const reset = (0, _react.useCallback)(()=>{
        clear();
        set();
    }, [
        clear,
        set
    ]);
    return {
        reset,
        clear
    };
};
exports.default = useTimeout;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4ShiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isWindows10", ()=>isWindows10);
parcelHelpers.export(exports, "copyToClipboard", ()=>copyToClipboard);
parcelHelpers.export(exports, "scrollInPage", ()=>scrollInPage);
parcelHelpers.export(exports, "removeAnchor", ()=>removeAnchor);
parcelHelpers.export(exports, "isValidUrl", ()=>isValidUrl);
parcelHelpers.export(exports, "fileToBase64", ()=>fileToBase64);
/**
  convert base64 string to File
 */ parcelHelpers.export(exports, "base64ToFile", ()=>base64ToFile);
parcelHelpers.export(exports, "createAPIMethod", ()=>createAPIMethod);
var _stringUtils = require("./stringUtils");
function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function isWindows10() {
    return navigator.userAgent.toLowerCase().includes("Windows NT 10".toLowerCase());
}
const copyToClipboard = (text)=>{
    if (!text) return;
    navigator.clipboard.writeText(text);
};
const scrollInPage = (id, options)=>{
    const element = document.getElementById(id);
    if (!element) return;
    element.scrollIntoView(options);
};
const removeAnchor = (value)=>{
    if ((0, _stringUtils.isEmptyString)(value)) return value;
    const anchorIndex = value.indexOf("#");
    return anchorIndex > -1 ? value.substring(0, anchorIndex) : value;
};
function isValidUrl(string) {
    try {
        const url = new URL(string);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (e) {
        return false;
    }
}
const fileToBase64 = (file)=>{
    return new Promise((resolve)=>{
        const reader = new FileReader(); // Read file content on file loaded event
        reader.onload = function(event) {
            const result = event.target?.result;
            if (!result) resolve("");
            else if (typeof result === "string") // Convert data to base64
            resolve(btoa(result));
            else resolve(String.fromCharCode(...new Uint16Array(result)));
        };
        // start reading the content of the file
        reader.readAsDataURL(file);
    });
};
async function base64ToFile(content, filename, fileType) {
    try {
        const decodedContent = atob(content);
        const base64 = await fetch(decodedContent);
        const blob = await base64.blob();
        return new File([
            blob
        ], filename, {
            type: fileType
        });
    } catch (error) {
        return Promise.reject(`"${content}" is not a valid base64 string`);
    }
}
/**
 * Creates a typed fetch request
 * see: https://www.youtube.com/watch?v=deenC-vH14E
 */ const get = async (url, input, requestInit)=>{
    return fetch(`${url}?${new URLSearchParams(input).toString()}`, requestInit);
};
const post = async (url, input, requestInit = {})=>{
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(input),
        ...requestInit
    });
};
const createAPIMethod = (opts)=>(input)=>{
        const method = opts.method === "GET" ? get : post;
        return method(opts.url, input, opts.requestInit)// Imagine error handling here...
        .then((res)=>res.json());
    };

},{"./stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7RMaM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@sentry/react");
var _errorPage = require("../../pages/ErrorPage");
var _errorPageDefault = parcelHelpers.interopDefault(_errorPage);
/**
 * Use Sentry's ErrorBoundary with ErrorPage as default fallback component
 * -> Will automatically capture and report errors/exceptions to Sentry
 */ const ErrorBoundary = (props)=>{
    // If fallback is undefined, default to a fallback render function
    // that renders ErrorPage
    const { fallback } = props;
    let fallbackRenderFunction;
    if (fallback === undefined) /* eslint-disable react/prop-types */ fallbackRenderFunction = ({ error })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPageDefault.default), {
            error: error
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react1.ErrorBoundary, {
        ...props,
        fallback: fallback || fallbackRenderFunction,
        children: props.children
    });
};
exports.default = ErrorBoundary;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@sentry/react":"akCRS","../../pages/ErrorPage":"8Le05","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Le05":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@sentry/react");
var _polaris = require("@shopify/polaris");
var _errorSvg = require("../../assets/images/error.svg");
var _errorSvgDefault = parcelHelpers.interopDefault(_errorSvg);
var _kdkemptyState = require("../components/KDKEmptyState/KDKEmptyState");
var _kdkemptyStateDefault = parcelHelpers.interopDefault(_kdkemptyState);
var _useFormatMessage = require("../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../utils/util");
var _notFound = require("./NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
const ErrorPage = (props)=>{
    const { error } = props;
    const f = (0, _useFormatMessageDefault.default)();
    _react1.captureException(error, {
        level: "warning"
    });
    // Check if it's a 404-error
    let is404 = false;
    if ((0, _util.hasOwnProperty)(error, "status")) is404 = error.status === 404;
    else if ((0, _util.hasOwnProperty)(error, "response") && (0, _util.hasOwnProperty)(error.response, "status")) is404 = error.response.status === 404;
    if (is404) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFoundDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkemptyStateDefault.default), {
            header: f("error.page.title"),
            description: f("error.page.description"),
            image: (0, _errorSvgDefault.default),
            altImage: "Unknown error",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                primary: true,
                onClick: ()=>window.location.reload(),
                children: f("common.labels.try-again")
            })
        })
    });
};
exports.default = ErrorPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@sentry/react":"akCRS","@shopify/polaris":"ek5a0","../../assets/images/error.svg":"kX3Gl","../components/KDKEmptyState/KDKEmptyState":"bZwvm","../hooks/useFormatMessage":"8Y8fq","../utils/util":"4MniK","./NotFound":"6nx6g","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kX3Gl":[function(require,module,exports) {
module.exports = require("fec11baf1facf823").getBundleURL("kEMsi") + "error.4939cce4.svg";

},{"fec11baf1facf823":"75UoR"}],"bZwvm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const KDKEmptyState = (props)=>{
    const { header, description, image, altImage, children, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledContainer, {
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "10",
                    inlineAlign: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Image), {
                            height: 75,
                            alt: altImage,
                            source: image
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            inlineAlign: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "h2",
                                    variant: "headingLg",
                                    children: header
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "p",
                                    alignment: "center",
                                    children: description
                                })
                            ]
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const StyledContainer = (0, _styledComponentsDefault.default).div`
  margin-top: 30%;
  display: grid;
  place-content: center;

  .Polaris-Card {
    padding: var(--p-space-8) var(--p-space-16);
  }
`;
exports.default = KDKEmptyState;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Y8fq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormatMessage);
var _reactIntl = require("react-intl");
function useFormatMessage() {
    const intl = (0, _reactIntl.useIntl)();
    return (id, values)=>intl.formatMessage({
            id
        }, values);
}

},{"react-intl":"8H1wU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6nx6g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@sentry/react");
var _polaris = require("@shopify/polaris");
var _notFoundSvg = require("../../assets/images/not-found.svg");
var _notFoundSvgDefault = parcelHelpers.interopDefault(_notFoundSvg);
var _kdkemptyState = require("../components/KDKEmptyState/KDKEmptyState");
var _kdkemptyStateDefault = parcelHelpers.interopDefault(_kdkemptyState);
var _routes = require("../constants/routes");
var _useFormatMessage = require("../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const NotFound = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    // Report 404 to Sentry
    (0, _react.useEffect)(()=>{
        try {
            // Throw error with the URL in order to capture 404s for unique URLs
            throw new Error(`A user was redirected to the NotFound page from ${window.location.href}. This may or may not be an error - open the Sentry issue to see why the user was redirected`);
        } catch (e) {
            _react1.captureException(e, {
                level: "warning"
            });
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkemptyStateDefault.default), {
            header: f("not-found.title"),
            description: f("not-found.description"),
            image: (0, _notFoundSvgDefault.default),
            altImage: "404 - Page not found",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                primary: true,
                url: (0, _routes.ROUTES).HOME,
                children: f("common.labels.take-me-back")
            })
        })
    });
};
exports.default = NotFound;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@sentry/react":"akCRS","@shopify/polaris":"ek5a0","../../assets/images/not-found.svg":"d8SwY","../components/KDKEmptyState/KDKEmptyState":"bZwvm","../constants/routes":"ihtm8","../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d8SwY":[function(require,module,exports) {
module.exports = require("495c779f6c02f48a").getBundleURL("kEMsi") + "not-found.4dd1af4a.svg";

},{"495c779f6c02f48a":"75UoR"}],"7HsoD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _batonTurboWebMediumEot = require("../../../assets/fonts/BatonTurboWeb-Medium.eot");
var _batonTurboWebMediumEotDefault = parcelHelpers.interopDefault(_batonTurboWebMediumEot);
var _batonTurboWebMediumWoff = require("../../../assets/fonts/BatonTurboWeb-Medium.woff");
var _batonTurboWebMediumWoffDefault = parcelHelpers.interopDefault(_batonTurboWebMediumWoff);
var _batonTurboWebRegularEot = require("../../../assets/fonts/BatonTurboWeb-Regular.eot");
var _batonTurboWebRegularEotDefault = parcelHelpers.interopDefault(_batonTurboWebRegularEot);
var _batonTurboWebRegularWoff = require("../../../assets/fonts/BatonTurboWeb-Regular.woff");
var _batonTurboWebRegularWoffDefault = parcelHelpers.interopDefault(_batonTurboWebRegularWoff);
var _styles = require("../../constants/styles");
const GlobalStyles = (0, _styledComponents.createGlobalStyle)`
    // fonts
    @font-face {
        font-family: BatonTurboWeb;
        src: url(${(0, _batonTurboWebRegularEotDefault.default)});
        src: url(${(0, _batonTurboWebRegularWoffDefault.default)}) format("woff");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: BatonTurboWeb;
        src: url(${(0, _batonTurboWebMediumEotDefault.default)});
        src: url(${(0, _batonTurboWebMediumWoffDefault.default)}) format("woff");
        font-weight: 700;
        font-style: normal;
        font-display: swap;
    }

    html {
        font-size: 120%;
    }

    html,
    body,
    button {
        font-family: var(--p-font-family-sans);
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    // Polaris theme overrides
    :root {
        --p-font-family-sans: BatonTurboWeb, Arial, "sans-serif";
        --p-color-bg-primary: rgba(91, 105, 195, 1);
        --p-color-bg-primary-hover: rgba(74, 89, 179, 1);
        --p-color-bg-primary-active: rgba(62, 76, 154, 1);
        --p-color-bg-primary-depressed: rgba(39, 48, 102, 1);
        --p-color-text-primary: rgba(86, 101, 192, 1);
        --p-color-text-primary-hover: rgba(72, 87, 175, 1);
        --p-color-text-primary-active: rgba(60, 74, 150, 1);
        --p-background: rgba(246, 246, 248, 1);
        --p-background-selected-hovered: rgba(199, 200, 214, 1);
        --p-background-selected-pressed: rgba(179, 181, 199, 1);
    }

    // Polaris components overrides

    // Increase default page width from 63.5rem to 70rem
    .Polaris-Page:not(.Polaris-Page--fullWidth) {
        max-width: 70rem;

        // For small viewports - reduce gap of page
        @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
            margin: 0 var(--p-space-4);
        }
    }

    // Make Polaris top bar component use the same toolbar height as the rest of the design
    .Polaris-Frame__TopBar {
        height: var(--kdk-toolbar-height);
        box-shadow: var(--p-shadow-top-bar);
    }

    // Reduce default width of secondary layout element from 20rem to rem 10rem
    .Polaris-Layout__Section--secondary {
        flex: 10rem;
    }

    .Polaris-Frame--hasTopBar .Polaris-Frame__Main {
        padding-top: calc(var(--kdk-toolbar-height) + var(--kdk-message-offset));
    }

    .Polaris-TextField__Input {
        height: 1.5rem;
    }

    // Fix border of tables inside cards with the last row having a status background color by adding a border radius
    // to the first and last cells of the last table row (if it is inside a card)
    .Polaris-Card .Polaris-DataTable .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell:first-child {
        border-bottom-left-radius: var(--p-border-radius-2);
    }

    .Polaris-Card .Polaris-DataTable .Polaris-DataTable__TableRow:last-child .Polaris-DataTable__Cell:last-child {
        border-bottom-right-radius: var(--p-border-radius-2);
    }

    /*
    Set max-width of first column for Polaris DataTable
   */
    .Polaris-DataTable__Cell--firstColumn {
        max-width: 300px;
    }

    // Style for DataTable cells and headers with subdued Text
    .Polaris-DataTable__Cell--header,
    .Polaris-DataTable__Heading,
    .Polaris-DataTable__IncreasedTableDensity .Polaris-DataTable__Cell--header {
        color: var(--p-text-subdued);
        font-size: var(--kdk-font-size-50);
        font-weight: var(--p-font-weight-semibold);
        max-width: fit-content;
    }

    // Bump the z-index for modal on top of another modal to extends the backdrop to cover the lower modal
    #PolarisPortalsContainer > [data-portal-id|="modal"]:last-of-type .Polaris-Modal-Dialog__Container {
        z-index: var(--p-z-12);
    }

    #PolarisPortalsContainer > [data-portal-id|="modal"]:last-of-type .Polaris-Backdrop {
        z-index: var(--p-z-11);
    }

    // Move Hubspot chat widget when the Filters drawer is open
    body[data-lock-scrolling]:is(:has(.Polaris-Filters__FiltersContainer)) > #hubspot-messages-iframe-container.widget-align-right {
        right: 150px !important;
    }

    // disable closing Modals when clicking outside
    .Polaris-Backdrop {
        pointer-events: none;
    }

    // prevent the page from scrolling when reaching the end of the scrollable area
    .Polaris-Scrollable--vertical {
        overscroll-behavior-y: contain;
    }

    // make sure the spinner size is a square
    .Polaris-Spinner {
        line-height: 1;
    }

    .Polaris-Spinner--sizeSmall svg {
        max-height: 1.25rem;
    }

    // KDK colors

    :root {
        --kdk-toolbar-height: 3.5rem;
        --kdk-message-offset: 0px;
        --kdk-column-max-width: 300px;
        --kdk-followup-number-max-width: 15ch;
        --kdk-table-tree-node-gap: 4rem;
        --kdk-tag-height: var(--p-space-4);
        --kdk-font-size-50: 0.625rem;
        --kdk-surface-tag: rgb(255, 234, 138, 1);
        --kdk-red: hsl(350, 90%, 49%);
        --kdk-light-blue: hsl(187, 65%, 52%);
        --kdk-plain-button-hovered: hsl(240, 2%, 92%);

        // For small viewports - change max column width to be relative to the viewport
        @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
            --kdk-column-max-width: 75vw;
        }

        /* vitec external link */
        --kdk-blue-500: hsl(209, 100%, 58%);
        /* hover */
        --kdk-blue-525: hsl(209, 100%, 48%);
        /* active */
        --kdk-blue-550: hsl(209, 100%, 40%);
        /* toggle button */
        --kdk-blue-575: hsl(215, 64%, 48%);
        /* onboarding link bottom border, add item button */
        --kdk-blue-600: hsl(229, 100%, 61%);

        /* match page PEP tag */
        --kdk-yellow-500: hsl(43, 87%, 91%);
        /* match page PEP tag border */
        --kdk-yellow-600: hsl(42, 89%, 66%);

        /* match page Sanction tag */
        --kdk-red-500: hsl(0, 100%, 97%);

        --kdk-dark-grey: hsl(0, 0%, 40%);
        --kdk-dark-success: hsl(165, 100%, 25%);
        --kdk-dashboard-dark-border: hsl(211, 26%, 28%);
        --kdk-dashboard-dark-gradient-start: hsl(249, 37%, 11%);
        --kdk-dashboard-dark-gradient-end: hsl(212, 28%, 36%);
        --kdk-dashboard-customer-type-company: hsl(212, 55%, 31%);
        --kdk-dashboard-customer-type-person: hsl(212, 65%, 47%);
        --kdk-dashboard-risk-high-gradient-start: hsl(351, 100%, 69%);
        --kdk-dashboard-risk-high-gradient-end: hsl(350, 58%, 45%);
        --kdk-dashboard-risk-medium-gradient-start: hsl(39, 100%, 67%);
        --kdk-dashboard-risk-medium-gradient-end: hsl(39, 98%, 53%);
        --kdk-dashboard-risk-low-gradient-start: hsl(126, 41%, 39%);
        --kdk-dashboard-risk-low-gradient-end: hsl(126, 46%, 28%);
        --kdk-dashboard-widget-shadow: 0px 3px 20px rgba(0, 0, 0, 0.25);
    }

    // KDK Table

    // target the label inside a tree line - this selection is a workaround
    // for the lack of option to add a classname on an XArrow label
    // the class kdk-table-tree-line will be added to the XArrow container
    .kdk-table-tree-line > svg + div > * {
        // position the label above the line
        display: inline-block;
        transform: translate(-15%, -35%);
        padding: 0 2px;
        // hide tree line underneath the label
        background-color: var(--p-surface);

        transition: background-color var(--p-duration-200) var(--p-ease-in-out);
    }

    .Polaris-DataTable__TableRow:hover .kdk-table-tree-line > svg + div > * {
        background-color: var(--p-surface-hovered);
    }

`;
exports.default = GlobalStyles;

},{"styled-components":"eBrdC","../../../assets/fonts/BatonTurboWeb-Medium.eot":"5Xhz6","../../../assets/fonts/BatonTurboWeb-Medium.woff":"29w49","../../../assets/fonts/BatonTurboWeb-Regular.eot":"d4wK4","../../../assets/fonts/BatonTurboWeb-Regular.woff":"fVP53","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Xhz6":[function(require,module,exports) {
module.exports = require("51411faec2c55bc2").getBundleURL("kEMsi") + "BatonTurboWeb-Medium.8f9369de.eot";

},{"51411faec2c55bc2":"75UoR"}],"29w49":[function(require,module,exports) {
module.exports = require("f24767db6d3cb994").getBundleURL("kEMsi") + "BatonTurboWeb-Medium.dc3d13f3.woff";

},{"f24767db6d3cb994":"75UoR"}],"d4wK4":[function(require,module,exports) {
module.exports = require("e595ca46379461cd").getBundleURL("kEMsi") + "BatonTurboWeb-Regular.8391f47d.eot";

},{"e595ca46379461cd":"75UoR"}],"fVP53":[function(require,module,exports) {
module.exports = require("4e4c1a9188eaf28c").getBundleURL("kEMsi") + "BatonTurboWeb-Regular.0c6896ff.woff";

},{"4e4c1a9188eaf28c":"75UoR"}],"dZWds":[function(require,module,exports) {
// CSS custom variables are not supported inside media queries, so use a JS constant instead
// value is equivalent to Polaris medium breakpoint: --p-breakpoints-md
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MOBILE_BREAKPOINT", ()=>MOBILE_BREAKPOINT);
parcelHelpers.export(exports, "COPY_LABEL_MAX_WIDTH_IN_PX", ()=>COPY_LABEL_MAX_WIDTH_IN_PX);
parcelHelpers.export(exports, "COPY_LABEL_MOBILE_MAX_WIDTH_IN_PX", ()=>COPY_LABEL_MOBILE_MAX_WIDTH_IN_PX);
parcelHelpers.export(exports, "DEFAULT_TAG_COLOR", ()=>DEFAULT_TAG_COLOR);
parcelHelpers.export(exports, "TREE_LINE_COLOR", ()=>TREE_LINE_COLOR);
parcelHelpers.export(exports, "PRESET_COLORS_FOR_TAG_PICKER", ()=>PRESET_COLORS_FOR_TAG_PICKER);
parcelHelpers.export(exports, "PRESET_COLORS_FOR_INDUSTRY_TYPE_PIE_CHART", ()=>PRESET_COLORS_FOR_INDUSTRY_TYPE_PIE_CHART);
const MOBILE_BREAKPOINT = "48rem";
const COPY_LABEL_MAX_WIDTH_IN_PX = 250;
const COPY_LABEL_MOBILE_MAX_WIDTH_IN_PX = 180;
const DEFAULT_TAG_COLOR = "#FFEA8A";
const TREE_LINE_COLOR = "rgba(140, 145, 150, 1)";
const PRESET_COLORS_FOR_TAG_PICKER = [
    "#FF6900",
    DEFAULT_TAG_COLOR,
    "#7BDCB5",
    "#00D084",
    "#8ED1FC",
    "#4A90E2",
    "#ABB8C3",
    "#D0021B",
    "#F78DA7",
    "#9900EF"
];
const PRESET_COLORS_FOR_INDUSTRY_TYPE_PIE_CHART = [
    "#003f5c",
    "#2f4b7c",
    "#665191",
    "#a05195",
    "#d45087",
    "#f95d6a",
    "#ff7c43",
    "#ffa600"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jBlTw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _features = require("../../constants/features");
var _routes = require("../../constants/routes");
var _accessDenied = require("../../pages/AccessDenied");
var _accessDeniedDefault = parcelHelpers.interopDefault(_accessDenied);
var _companyChangeScreeningPage = require("../../pages/CompanyChangeScreeningPage/CompanyChangeScreeningPage");
var _companyChangeScreeningPageDefault = parcelHelpers.interopDefault(_companyChangeScreeningPage);
var _companyDetailsPage = require("../../pages/CompanyDetailsPage/CompanyDetailsPage");
var _companyDetailsPageDefault = parcelHelpers.interopDefault(_companyDetailsPage);
var _companyEditDisclosuresPage = require("../../pages/CompanyRequestDisclosuresPage/CompanyEditDisclosuresPage");
var _companyEditDisclosuresPageDefault = parcelHelpers.interopDefault(_companyEditDisclosuresPage);
var _customerAssignmentDetailsPage = require("../../pages/CustomerAssignmentDetailsPage/CustomerAssignmentDetailsPage");
var _customerAssignmentDetailsPageDefault = parcelHelpers.interopDefault(_customerAssignmentDetailsPage);
var _customerReviewPage = require("../../pages/CustomerReviewPage/CustomerReviewPage");
var _customerReviewPageDefault = parcelHelpers.interopDefault(_customerReviewPage);
var _customersListPage = require("../../pages/CustomersListPage/CustomersListPage");
var _customersListPageDefault = parcelHelpers.interopDefault(_customersListPage);
var _dashboardPage = require("../../pages/DashboardPage/DashboardPage");
var _dashboardPageDefault = parcelHelpers.interopDefault(_dashboardPage);
var _expired = require("../../pages/Expired");
var _expiredDefault = parcelHelpers.interopDefault(_expired);
var _importCustomersPage = require("../../pages/ImportCustomersPage/ImportCustomersPage");
var _importCustomersPageDefault = parcelHelpers.interopDefault(_importCustomersPage);
var _logoutRedirect = require("../../pages/LogoutRedirect/LogoutRedirect");
var _logoutRedirectDefault = parcelHelpers.interopDefault(_logoutRedirect);
var _matchPage = require("../../pages/MatchPage/MatchPage");
var _matchPageDefault = parcelHelpers.interopDefault(_matchPage);
var _notFound = require("../../pages/NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
var _onboardingCompanyAssignmentsPage = require("../../pages/OnboardingCompanyAssignmentsPage/OnboardingCompanyAssignmentsPage");
var _onboardingCompanyAssignmentsPageDefault = parcelHelpers.interopDefault(_onboardingCompanyAssignmentsPage);
var _onboardingCompanyDisclosuresPage = require("../../pages/OnboardingCompanyDisclosuresPage/OnboardingCompanyDisclosuresPage");
var _onboardingCompanyDisclosuresPageDefault = parcelHelpers.interopDefault(_onboardingCompanyDisclosuresPage);
var _onboardingCompanyLookupResultPage = require("../../pages/OnboardingCompanyLookupResultPage/OnboardingCompanyLookupResultPage");
var _onboardingCompanyLookupResultPageDefault = parcelHelpers.interopDefault(_onboardingCompanyLookupResultPage);
var _onboardingCompanyPage = require("../../pages/OnboardingCompanyPage/OnboardingCompanyPage");
var _onboardingCompanyPageDefault = parcelHelpers.interopDefault(_onboardingCompanyPage);
var _onboardingCompanyScreeningPage = require("../../pages/OnboardingCompanyScreeningPage/OnboardingCompanyScreeningPage");
var _onboardingCompanyScreeningPageDefault = parcelHelpers.interopDefault(_onboardingCompanyScreeningPage);
var _onboardingCompanySummaryPage = require("../../pages/OnboardingCompanySummaryPage/OnboardingCompanySummaryPage");
var _onboardingCompanySummaryPageDefault = parcelHelpers.interopDefault(_onboardingCompanySummaryPage);
var _onboardingManualCompanyPage = require("../../pages/OnboardingManualCompanyPage/OnboardingManualCompanyPage");
var _onboardingManualCompanyPageDefault = parcelHelpers.interopDefault(_onboardingManualCompanyPage);
var _onboardingPersonEditPage = require("../../pages/OnboardingPersonEditPage/OnboardingPersonEditPage");
var _onboardingPersonEditPageDefault = parcelHelpers.interopDefault(_onboardingPersonEditPage);
var _onboardingPersonNewPage = require("../../pages/OnboardingPersonNewPage/OnboardingPersonNewPage");
var _onboardingPersonNewPageDefault = parcelHelpers.interopDefault(_onboardingPersonNewPage);
var _personChangeScreeningPage = require("../../pages/PersonChangeScreeningPage/PersonChangeScreeningPage");
var _personChangeScreeningPageDefault = parcelHelpers.interopDefault(_personChangeScreeningPage);
var _personDetailsPage = require("../../pages/PersonDetailsPage/PersonDetailsPage");
var _personDetailsPageDefault = parcelHelpers.interopDefault(_personDetailsPage);
var _personRequestDisclosurePage = require("../../pages/PersonRequestDisclosurePage/PersonRequestDisclosurePage");
var _personRequestDisclosurePageDefault = parcelHelpers.interopDefault(_personRequestDisclosurePage);
var _planConversionProjectPage = require("../../pages/PlanConversionProjectPage/PlanConversionProjectPage");
var _planConversionProjectPageDefault = parcelHelpers.interopDefault(_planConversionProjectPage);
var _projectDetailsPage = require("../../pages/ProjectDetailsPage/ProjectDetailsPage");
var _projectDetailsPageDefault = parcelHelpers.interopDefault(_projectDetailsPage);
var _projectsListPage = require("../../pages/ProjectsListPage/ProjectsListPage");
var _projectsListPageDefault = parcelHelpers.interopDefault(_projectsListPage);
var _settingsAutoRemindersPage = require("../../pages/SettingsAutoRemindersPage/SettingsAutoRemindersPage");
var _settingsAutoRemindersPageDefault = parcelHelpers.interopDefault(_settingsAutoRemindersPage);
var _settingsCustomerIntoNotificationsPage = require("../../pages/SettingsCustomerIntoNotificationsPage/SettingsCustomerIntoNotificationsPage");
var _settingsCustomerIntoNotificationsPageDefault = parcelHelpers.interopDefault(_settingsCustomerIntoNotificationsPage);
var _settingsDisclosurePage = require("../../pages/SettingsDisclosurePage/SettingsDisclosurePage");
var _settingsDisclosurePageDefault = parcelHelpers.interopDefault(_settingsDisclosurePage);
var _settingsFollowupNotificationsPage = require("../../pages/SettingsFollowupNotificationsPage/SettingsFollowupNotificationsPage");
var _settingsFollowupNotificationsPageDefault = parcelHelpers.interopDefault(_settingsFollowupNotificationsPage);
var _settingsFollowupPage = require("../../pages/SettingsFollowupPage/SettingsFollowupPage");
var _settingsFollowupPageDefault = parcelHelpers.interopDefault(_settingsFollowupPage);
var _settingsGuidelinesPage = require("../../pages/SettingsGuidelinesPage/SettingsGuidelinesPage");
var _settingsGuidelinesPageDefault = parcelHelpers.interopDefault(_settingsGuidelinesPage);
var _settingsMeasuresPage = require("../../pages/SettingsMeasuresPage/SettingsMeasuresPage");
var _settingsMeasuresPageDefault = parcelHelpers.interopDefault(_settingsMeasuresPage);
var _settingsOnboardingPage = require("../../pages/SettingsOnboardingPage/SettingsOnboardingPage");
var _settingsOnboardingPageDefault = parcelHelpers.interopDefault(_settingsOnboardingPage);
var _settingsQuestionnaireDetailsPage = require("../../pages/SettingsQuestionnaireDetailsPage/SettingsQuestionnaireDetailsPage");
var _settingsQuestionnaireDetailsPageDefault = parcelHelpers.interopDefault(_settingsQuestionnaireDetailsPage);
var _settingsQuestionnairesListPage = require("../../pages/SettingsQuestionnairesListPage/SettingsQuestionnairesListPage");
var _settingsQuestionnairesListPageDefault = parcelHelpers.interopDefault(_settingsQuestionnairesListPage);
var _settingsReviewChecklistDetailsPage = require("../../pages/SettingsReviewChecklistDetailsPage/SettingsReviewChecklistDetailsPage");
var _settingsReviewChecklistDetailsPageDefault = parcelHelpers.interopDefault(_settingsReviewChecklistDetailsPage);
var _settingsReviewChecklistsListPage = require("../../pages/SettingsReviewChecklistsListPage/SettingsReviewChecklistsListPage");
var _settingsReviewChecklistsListPageDefault = parcelHelpers.interopDefault(_settingsReviewChecklistsListPage);
var _settingsTagsPage = require("../../pages/SettingsTagsPage/SettingsTagsPage");
var _settingsTagsPageDefault = parcelHelpers.interopDefault(_settingsTagsPage);
var _settingsUsersPage = require("../../pages/SettingsUsersPage/SettingsUsersPage");
var _settingsUsersPageDefault = parcelHelpers.interopDefault(_settingsUsersPage);
var _requireAuth = require("../RequireAuth/RequireAuth");
var _requireAuthDefault = parcelHelpers.interopDefault(_requireAuth);
var _redirectToCustomersList = require("./RedirectToCustomersList");
var _redirectToCustomersListDefault = parcelHelpers.interopDefault(_redirectToCustomersList);
const Routes = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_USERS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsUsersPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_TAGS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsTagsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_QUESTIONNAIRE_DETAILS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsQuestionnaireDetailsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_QUESTIONNAIRES_LIST,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsQuestionnairesListPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLIST_DETAILS_NEW,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsReviewChecklistDetailsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLIST_DETAILS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsReviewChecklistDetailsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLISTS_LIST,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsReviewChecklistsListPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_FOLLOWUP,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsFollowupPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_FOLLOWUP_NOTIFICATIONS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsFollowupNotificationsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_GUIDELINE,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsGuidelinesPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_AUTO_REMINDERS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsAutoRemindersPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_MEASURES,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsMeasuresPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_ONBOARDING,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsOnboardingPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_DISCLOSURE,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDisclosurePageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).SETTINGS_CUSTOMER_NOTIFICATIONS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsCustomerIntoNotificationsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).EXPIRED,
                exact: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expiredDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).ACCESS_DENIED,
                exact: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accessDeniedDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).DASHBOARD,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).PERSON_DETAILS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personDetailsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).PERSON_REQUEST_DISCLOSURES,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personRequestDisclosurePageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).PERSON_CHANGE_SCREENING,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personChangeScreeningPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/persons/:customerId/match-cases/:id",
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).PERSON_ASSIGNMENT_REQUEST_DISCLOSURES,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personRequestDisclosurePageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).ONBOARDING_NEW_PERSON,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingPersonNewPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).ONBOARDING_SAVED_PERSON,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingPersonEditPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_DETAILS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyDetailsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_REQUEST_DISCLOSURES,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyEditDisclosuresPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_CHANGE_SCREENING,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyChangeScreeningPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/companies/:customerId/match-cases/:id",
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_ASSIGNMENT_REQUEST_DISCLOSURES,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyEditDisclosuresPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_LOOKUP,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_LOOKUP_RESULT,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyLookupResultPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_ONBOARDING_SCREENING,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyScreeningPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_ONBOARDING_ASSIGNMENTS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyAssignmentsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_ONBOARDING_DISCLOSURES,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyDisclosuresPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).COMPANY_ONBOARDING_SUMMARY,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanySummaryPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_EDIT,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingManualCompanyPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_SCREENING,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyScreeningPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_ASSIGNMENTS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyAssignmentsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_DISCLOSURES,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyDisclosuresPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_SUMMARY,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanySummaryPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).MATCH_CASE_DETAILS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).ASSIGNMENT_DETAILS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerAssignmentDetailsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).CUSTOMER_REVIEW_NEW,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).CUSTOMER_REVIEW,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).CUSTOMER_ASSIGNMENT_REVIEW_NEW,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).HOME,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _redirectToCustomersListDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).CUSTOMERS,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListPageDefault.default), {})
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).PROJECTS_LIST,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        requiredFeatures: (0, _features.PROJECT_FEATURES),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectsListPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).PLAN_UPGRADE_PROJECTS_LIST,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planConversionProjectPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).PROJECT_DETAILS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        requiredFeatures: (0, _features.PROJECT_FEATURES),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectDetailsPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).IMPORT_CUSTOMERS,
                exact: true,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _requireAuthDefault.default), {
                        requiredFeatures: [
                            (0, _features.FeaturesTypes).IMPORT_WIZARD
                        ],
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersPageDefault.default), {})
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: (0, _routes.ROUTES).LOGOUT,
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoutRedirectDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFoundDefault.default), {})
            })
        ]
    });
};
exports.default = Routes;

},{"react/jsx-runtime":"enbMA","react-router-dom":"1ee65","../../constants/features":"d32hZ","../../constants/routes":"ihtm8","../../pages/AccessDenied":"5b6Vh","../../pages/CompanyChangeScreeningPage/CompanyChangeScreeningPage":"5reXq","../../pages/CompanyDetailsPage/CompanyDetailsPage":"jzTfO","../../pages/CompanyRequestDisclosuresPage/CompanyEditDisclosuresPage":"32RC4","../../pages/CustomerAssignmentDetailsPage/CustomerAssignmentDetailsPage":"cvr2Z","../../pages/CustomerReviewPage/CustomerReviewPage":"9aENb","../../pages/CustomersListPage/CustomersListPage":"lHtC7","../../pages/DashboardPage/DashboardPage":"4AZ8h","../../pages/Expired":"7RtRD","../../pages/ImportCustomersPage/ImportCustomersPage":"cFQBq","../../pages/LogoutRedirect/LogoutRedirect":"8Tij7","../../pages/MatchPage/MatchPage":"b4N08","../../pages/NotFound":"6nx6g","../../pages/OnboardingCompanyAssignmentsPage/OnboardingCompanyAssignmentsPage":"7uHQs","../../pages/OnboardingCompanyDisclosuresPage/OnboardingCompanyDisclosuresPage":"goxpF","../../pages/OnboardingCompanyLookupResultPage/OnboardingCompanyLookupResultPage":"7a3cj","../../pages/OnboardingCompanyPage/OnboardingCompanyPage":"4ekKK","../../pages/OnboardingCompanyScreeningPage/OnboardingCompanyScreeningPage":"3iLrz","../../pages/OnboardingCompanySummaryPage/OnboardingCompanySummaryPage":"2VQqu","../../pages/OnboardingManualCompanyPage/OnboardingManualCompanyPage":"lYxQH","../../pages/OnboardingPersonEditPage/OnboardingPersonEditPage":"ihi8l","../../pages/OnboardingPersonNewPage/OnboardingPersonNewPage":"b5kV5","../../pages/PersonChangeScreeningPage/PersonChangeScreeningPage":"enpd2","../../pages/PersonDetailsPage/PersonDetailsPage":"6F44I","../../pages/PersonRequestDisclosurePage/PersonRequestDisclosurePage":"8685K","../../pages/PlanConversionProjectPage/PlanConversionProjectPage":"aSxYy","../../pages/ProjectDetailsPage/ProjectDetailsPage":"jIjKD","../../pages/ProjectsListPage/ProjectsListPage":"f7VUG","../../pages/SettingsAutoRemindersPage/SettingsAutoRemindersPage":"3q1vG","../../pages/SettingsCustomerIntoNotificationsPage/SettingsCustomerIntoNotificationsPage":"1sbLP","../../pages/SettingsDisclosurePage/SettingsDisclosurePage":"ligA9","../../pages/SettingsFollowupNotificationsPage/SettingsFollowupNotificationsPage":"abnaO","../../pages/SettingsFollowupPage/SettingsFollowupPage":"iaLmF","../../pages/SettingsGuidelinesPage/SettingsGuidelinesPage":"8jD3v","../../pages/SettingsMeasuresPage/SettingsMeasuresPage":"9LhNc","../../pages/SettingsOnboardingPage/SettingsOnboardingPage":"bP3xm","../../pages/SettingsQuestionnaireDetailsPage/SettingsQuestionnaireDetailsPage":"eeCug","../../pages/SettingsQuestionnairesListPage/SettingsQuestionnairesListPage":"85JyS","../../pages/SettingsReviewChecklistDetailsPage/SettingsReviewChecklistDetailsPage":"hfkbR","../../pages/SettingsReviewChecklistsListPage/SettingsReviewChecklistsListPage":"3Mr7z","../../pages/SettingsTagsPage/SettingsTagsPage":"h8ir7","../../pages/SettingsUsersPage/SettingsUsersPage":"6AsjY","../RequireAuth/RequireAuth":"hchhm","./RedirectToCustomersList":"ysHSv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d32hZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeaturesTypes", ()=>FeaturesTypes);
parcelHelpers.export(exports, "PROJECT_FEATURES", ()=>PROJECT_FEATURES);
var FeaturesTypes;
(function(FeaturesTypes) {
    FeaturesTypes["ASSIGNMENTS__HIDE_DETAILS"] = "ASSIGNMENTS__HIDE_DETAILS";
    FeaturesTypes["ASSIGNMENT_INDUSTRIES"] = "ASSIGNMENT_INDUSTRIES";
    FeaturesTypes["ATTACHMENTS"] = "ATTACHMENTS";
    FeaturesTypes["AUTOMATIC_CUSTOMER_REVIEW_APPROVAL"] = "AUTOMATIC_CUSTOMER_REVIEW_APPROVAL";
    FeaturesTypes["CUSTOMERS_LIST__BATCH_CHANGE_SCREENING_ACTION"] = "CUSTOMERS_LIST__BATCH_CHANGE_SCREENING_ACTION";
    FeaturesTypes["CUSTOMERS_LIST__PAGINATION_ON_TOP"] = "CUSTOMERS_LIST__PAGINATION_ON_TOP";
    FeaturesTypes["CUSTOMER__HIDE_DOWNLOAD_REPORT_BUTTON"] = "CUSTOMER__HIDE_DOWNLOAD_REPORT_BUTTON";
    FeaturesTypes["CUSTOMER__KAR_INTEGRATION"] = "CUSTOMER__KAR_INTEGRATION";
    FeaturesTypes["DISCLOSURE_SETTINGS"] = "DISCLOSURE_SETTINGS";
    FeaturesTypes["DISCLOSURE__PREVIEW"] = "DISCLOSURE__PREVIEW";
    FeaturesTypes["ELECTRONIC_SIGNATURES"] = "ELECTRONIC_SIGNATURES";
    FeaturesTypes["ENFORCE_RESPONSIBLE_USER_FILTER"] = "ENFORCE_RESPONSIBLE_USER_FILTER";
    FeaturesTypes["EXTERNAL_ID"] = "EXTERNAL_ID";
    FeaturesTypes["HIGHER_ACCURACY_PERCENTAGES"] = "HIGHER_ACCURACY_PERCENTAGES";
    FeaturesTypes["HUBSPOT_LIVE_CHAT"] = "HUBSPOT_LIVE_CHAT";
    FeaturesTypes["IMPORT_WIZARD"] = "IMPORT_WIZARD";
    FeaturesTypes["KYC_PREVIEWER"] = "KYC_PREVIEWER";
    FeaturesTypes["MEASURES"] = "MEASURES";
    FeaturesTypes["PROJECTS"] = "PROJECTS";
    FeaturesTypes["REAL_ESTATE"] = "REAL_ESTATE";
    FeaturesTypes["RESPONSIBLE_USER"] = "RESPONSIBLE_USER";
    FeaturesTypes["REVIEW_CHECKLIST"] = "REVIEW_CHECKLIST";
    FeaturesTypes["REVIEW_LABELS"] = "REVIEW_LABELS";
    FeaturesTypes["REVIEW__AUTO_SET_RISK"] = "REVIEW__AUTO_SET_RISK";
    FeaturesTypes["REVIEW__CHECKLIST_DEFAULT_TO_NO"] = "REVIEW__CHECKLIST_DEFAULT_TO_NO";
    FeaturesTypes["REVIEW__DISABLE_FOR_UNANSWERED_DISCLOSURES"] = "REVIEW__DISABLE_FOR_UNANSWERED_DISCLOSURES";
    FeaturesTypes["REVIEW__DISABLE_MLRO_ADMINS_PRE_SELECTION_FOR_REVIEW_APPROVAL"] = "REVIEW__DISABLE_MLRO_ADMINS_PRE_SELECTION_FOR_REVIEW_APPROVAL";
    FeaturesTypes["REVIEW__ONLY_LIST_COMPLIANCE_ADMIN_APPROVAL_USERS"] = "REVIEW__ONLY_LIST_COMPLIANCE_ADMIN_APPROVAL_USERS";
    FeaturesTypes["REVIEW__SAVE_AND_CONTINUE"] = "REVIEW__SAVE_AND_CONTINUE";
    FeaturesTypes["SCREENING__MARK_ALL_OWNERS"] = "SCREENING__MARK_ALL_OWNERS";
    FeaturesTypes["SETTINGS__CUSTOMER_INFO_NOTIFICATIONS"] = "SETTINGS__CUSTOMER_INFO_NOTIFICATIONS";
    FeaturesTypes["SETTINGS__REVIEW_CHECKLISTS_IMPORT_EXPORT"] = "SETTINGS__REVIEW_CHECKLISTS_IMPORT_EXPORT";
    FeaturesTypes["VITEC_CREATE_VITEC_SPECIFIC_ASSIGNMENTS"] = "VITEC_CREATE_VITEC_SPECIFIC_ASSIGNMENTS";
    FeaturesTypes["VITEC_PROJECTS"] = "VITEC_PROJECTS";
    FeaturesTypes["VITEC_ROLES_SYNC"] = "VITEC_ROLES_SYNC";
    FeaturesTypes["VITEC_ROLES_SYNC_WITHOUT_PHONE"] = "VITEC_ROLES_SYNC_WITHOUT_PHONE";
})(FeaturesTypes || (FeaturesTypes = {}));
const PROJECT_FEATURES = [
    "PROJECTS",
    "VITEC_PROJECTS"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5b6Vh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _accessDeniedSvg = require("../../assets/images/access-denied.svg");
var _accessDeniedSvgDefault = parcelHelpers.interopDefault(_accessDeniedSvg);
var _kdkemptyState = require("../components/KDKEmptyState/KDKEmptyState");
var _kdkemptyStateDefault = parcelHelpers.interopDefault(_kdkemptyState);
var _routes = require("../constants/routes");
var _useFormatMessage = require("../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const AccessDenied = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkemptyStateDefault.default), {
        header: f("access-denied.title"),
        description: f("access-denied.description"),
        image: (0, _accessDeniedSvgDefault.default),
        altImage: "Access denied",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ButtonGroup), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                primary: true,
                url: (0, _routes.ROUTES).HOME,
                children: f("common.labels.take-me-back")
            })
        })
    });
};
exports.default = AccessDenied;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../assets/images/access-denied.svg":"YWXuL","../components/KDKEmptyState/KDKEmptyState":"bZwvm","../constants/routes":"ihtm8","../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"YWXuL":[function(require,module,exports) {
module.exports = require("2de6bb39ca1fd628").getBundleURL("kEMsi") + "access-denied.9fd2fa7a.svg";

},{"2de6bb39ca1fd628":"75UoR"}],"5reXq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _ownersCard = require("../../components/OwnersCard/OwnersCard");
var _ownersCardDefault = parcelHelpers.interopDefault(_ownersCard);
var _rolesCard = require("../../components/RolesCard/RolesCard");
var _rolesCardDefault = parcelHelpers.interopDefault(_rolesCard);
var _screeningEmptyState = require("../../components/ScreeningEmptyState/ScreeningEmptyState");
var _screeningEmptyStateDefault = parcelHelpers.interopDefault(_screeningEmptyState);
var _screeningSkeleton = require("../../components/ScreeningSkeleton/ScreeningSkeleton");
var _screeningSkeletonDefault = parcelHelpers.interopDefault(_screeningSkeleton);
var _screeningStatusBadge = require("../../components/ScreeningStatusBadge/ScreeningStatusBadge");
var _screeningStatusBadgeDefault = parcelHelpers.interopDefault(_screeningStatusBadge);
var _screeningTypeCard = require("../../components/ScreeningTypeCard/ScreeningTypeCard");
var _screeningTypeCardDefault = parcelHelpers.interopDefault(_screeningTypeCard);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _stopScreeningModal = require("../../components/StopScreeningModal/StopScreeningModal");
var _stopScreeningModalDefault = parcelHelpers.interopDefault(_stopScreeningModal);
var _queriesKeys = require("../../constants/queries-keys");
var _customerHelpers = require("../../helpers/customer.helpers");
var _ownersHelpers = require("../../helpers/owners.helpers");
var _personHelpers = require("../../helpers/person.helpers");
var _screening = require("../../helpers/screening");
var _useCustomerDetailsBackButton = require("../../hooks/useCustomerDetailsBackButton");
var _useCustomerDetailsBackButtonDefault = parcelHelpers.interopDefault(_useCustomerDetailsBackButton);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetCompanyScreeningConfiguration = require("../../hooks/useGetCompanyScreeningConfiguration");
var _useGetCompanyScreeningConfigurationDefault = parcelHelpers.interopDefault(_useGetCompanyScreeningConfiguration);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _errorPage = require("../ErrorPage");
var _errorPageDefault = parcelHelpers.interopDefault(_errorPage);
const CompanyChangeScreeningPage = ()=>{
    const { id: customerId } = (0, _reactRouter.useParams)();
    const [customerName, setCustomerName] = (0, _react.useState)("");
    const [owners, setOwners] = (0, _react.useState)([]);
    const [roles, setRoles] = (0, _react.useState)([]);
    const [screeningType, setScreeningType] = (0, _react.useState)("MONITORING");
    const [screeningStatus, setScreeningStatus] = (0, _react.useState)("MONITORING");
    const [isNewScreening, setIsNewScreening] = (0, _react.useState)(false);
    const [isControlConfirmationActive, setControlConfirmationActive] = (0, _react.useState)(false);
    const [selectedOwners, setSelectedOwners] = (0, _react.useState)([]);
    const [selectedRoles, setSelectedRoles] = (0, _react.useState)([]);
    const f = (0, _useFormatMessageDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const { backButtonURL, goToCustomerDetails } = (0, _useCustomerDetailsBackButtonDefault.default)(customerId, "company");
    // Get screening config and company customer details
    const companyCustomerDetailsQuery = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_DETAILS,
        customerId
    ], ()=>(0, _apiDefault.default).getCompanyCustomerDetails(customerId));
    const companyScreeningConfigQuery = (0, _useGetCompanyScreeningConfigurationDefault.default)(customerId);
    (0, _react.useEffect)(()=>{
        if (companyScreeningConfigQuery.isLoading || !companyScreeningConfigQuery.data) return;
        const tmp = companyScreeningConfigQuery.data;
        setCustomerName(tmp.customer_name);
        const { beneficial_owners: tmp_owners, roles: tmp_roles } = tmp;
        setRoles(tmp_roles.map((r)=>r.role));
        // Make all "active" (ie. not deleted) owners OR owners currently in screening config available for (de)selection
        setOwners(tmp_owners.filter((o)=>!o.owner.deleted || o.screening_required).map((o)=>o.owner));
        // Only preselect owners that currently are in the screening config
        // -> do not preselect other owners (eg. UBOs) to avoid confusion
        setSelectedOwners(tmp_owners.filter((beneficialOwner)=>beneficialOwner.screening_required && (0, _ownersHelpers.isOwnerPerson)(beneficialOwner.owner)).map((beneficialOwner)=>beneficialOwner.owner.id));
        setSelectedRoles(tmp_roles.filter((r)=>r.screening_required).map((r)=>r.role.id));
        if (tmp.screening_type) {
            setScreeningType(tmp.screening_type);
            setScreeningStatus(tmp.screening_status);
            setIsNewScreening(tmp.screening_status === "DONE");
        }
    }, [
        companyScreeningConfigQuery.data,
        companyScreeningConfigQuery.isLoading
    ]);
    const changeScreeningMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updateCompanyScreeningConfiguration(customerId, {
            roles: selectedRoles,
            owners: selectedOwners,
            screening_type: screeningType
        }), {
        onSuccess: ()=>{
            companyScreeningConfigQuery.invalidateQuery();
            const snackbarMessage = isNewScreening ? f("screening.snackbar.started") : f("screening.snackbar.updated");
            goToCustomerDetails(snackbarMessage);
        }
    });
    if (companyScreeningConfigQuery.isError || companyCustomerDetailsQuery.isError) {
        if (companyScreeningConfigQuery.isMaxRetriesReached) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningEmptyStateDefault.default), {});
        else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPageDefault.default), {
            error: companyScreeningConfigQuery.error || companyCustomerDetailsQuery.error
        });
    }
    const displaySkeleton = companyScreeningConfigQuery.isLoading || !companyScreeningConfigQuery.data || companyCustomerDetailsQuery.isLoading || !companyCustomerDetailsQuery.data;
    if (displaySkeleton) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningSkeletonDefault.default), {
        progress: companyScreeningConfigQuery.loadingProgress,
        message: f("screening.messages.retrieving-details")
    });
    const companyCustomer = companyCustomerDetailsQuery.data;
    const screening = {
        screening_status: screeningStatus,
        screening_type: screeningType
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                        url: backButtonURL,
                        displayLabel: customerName,
                        showAsLink: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "heading2xl",
                        as: "p",
                        children: !isNewScreening ? f("change-screening.titles.screening-title") : f("change-screening.titles.new-screening")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "4",
                                children: [
                                    !isNewScreening && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        blockAlign: "start",
                                        align: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                gap: "2",
                                                blockAlign: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                                        variant: "bodyMd",
                                                        as: "span",
                                                        fontWeight: "semibold",
                                                        children: [
                                                            f("default.status"),
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                        variant: "bodyMd",
                                                        as: "span",
                                                        children: f(`screening-type.${screeningType}`)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningStatusBadgeDefault.default), {
                                                        screening: screening
                                                    }),
                                                    (0, _screening.isScreeningActive)(screening) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Badge), {
                                                        status: "success",
                                                        progress: "complete",
                                                        children: f("screening.status.active")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                                onClick: ()=>setControlConfirmationActive(true),
                                                children: f("change-screening.buttons.stop-monitoring")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingLg",
                                        as: "p",
                                        children: f("change-screening.titles.screening-owners")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownersCardDefault.default), {
                                            customer: companyCustomer,
                                            isArchiveDisabled: ()=>true,
                                            selectable: true,
                                            owners: owners,
                                            selectedOwners: selectedOwners,
                                            onSelectionChange: setSelectedOwners,
                                            onArchive: (archivedOwnerId)=>{
                                                setOwners(owners.filter((owner)=>owner.id !== archivedOwnerId));
                                                if (selectedOwners.includes(archivedOwnerId)) setSelectedOwners(selectedOwners.filter((selectedOwner)=>selectedOwner !== archivedOwnerId));
                                            },
                                            onUpdate: (updatedOwner)=>{
                                                setOwners(owners.map((owner)=>owner.id === updatedOwner.id ? Object.assign(owner, updatedOwner) : owner));
                                                if ((0, _personHelpers.isUBO)(updatedOwner) && !selectedOwners.includes(updatedOwner.id)) setSelectedOwners([
                                                    ...selectedOwners,
                                                    updatedOwner.id
                                                ]);
                                            },
                                            onCreate: (createdOwner)=>{
                                                setOwners([
                                                    createdOwner
                                                ].concat(owners));
                                                if ((0, _personHelpers.isUBO)(createdOwner)) setSelectedOwners([
                                                    ...selectedOwners,
                                                    createdOwner.id
                                                ]);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                                        size: "medium"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingLg",
                                        as: "p",
                                        children: f("change-screening.titles.screening-roles")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rolesCardDefault.default), {
                                            customer: companyCustomer,
                                            roles: roles,
                                            selectedRoles: selectedRoles,
                                            selectable: true,
                                            companyCountry: companyCustomerDetailsQuery.data?.country,
                                            companyType: (0, _customerHelpers.getCompanyType)(language, companyCustomerDetailsQuery.data?.company_type),
                                            getIsDeleteDisabled: ()=>true,
                                            onSelectionChange: setSelectedRoles,
                                            onDelete: (deletedRoleId)=>{
                                                setRoles(roles.filter((role)=>role.id !== deletedRoleId));
                                                if (selectedRoles.includes(deletedRoleId)) setSelectedRoles(selectedRoles.filter((selectedRole)=>selectedRole !== deletedRoleId));
                                            },
                                            onUpdate: (updatedRole)=>setRoles(roles.map((role)=>role.id === updatedRole.id ? updatedRole : role)),
                                            onCreate: (createdRole)=>setRoles([
                                                    createdRole
                                                ].concat(roles))
                                        })
                                    }),
                                    isNewScreening && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                                                size: "medium"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                variant: "headingLg",
                                                as: "p",
                                                children: f("change-screening.titles.choose-screening-type")
                                            })
                                        ]
                                    }),
                                    isNewScreening && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningTypeCardDefault.default), {
                                                screeningType: screeningType,
                                                onScreeningTypeChange: (newValue)=>setScreeningType(newValue)
                                            })
                                        })
                                    }),
                                    changeScreeningMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                                        message: changeScreeningMutation.error
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "4",
                                        align: "end",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                                disabled: changeScreeningMutation.isLoading,
                                                onClick: ()=>goToCustomerDetails(),
                                                children: f("default.cancel")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                                primary: true,
                                                disabled: changeScreeningMutation.isLoading || !screeningType,
                                                loading: changeScreeningMutation.isLoading,
                                                onClick: changeScreeningMutation.mutate,
                                                children: isNewScreening ? f("change-screening.buttons.start-screening") : f("change-screening.buttons.save")
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            isControlConfirmationActive && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stopScreeningModalDefault.default), {
                id: customerId,
                isOpen: isControlConfirmationActive,
                isPerson: false,
                onStop: ()=>{
                    setControlConfirmationActive(false);
                    goToCustomerDetails(f("screening.snackbar.stopped"));
                },
                onClose: ()=>{
                    setControlConfirmationActive(false);
                }
            })
        ]
    });
};
exports.default = CompanyChangeScreeningPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router":"5RYYS","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/BackButton/BackButton":"4fa4k","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/OwnersCard/OwnersCard":"f1O1W","../../components/RolesCard/RolesCard":"7Zoco","../../components/ScreeningEmptyState/ScreeningEmptyState":"5Zeqa","../../components/ScreeningSkeleton/ScreeningSkeleton":"kuEJQ","../../components/ScreeningStatusBadge/ScreeningStatusBadge":"bGehF","../../components/ScreeningTypeCard/ScreeningTypeCard":"2sGBG","../../components/SectionMargin/SectionMargin":"l3u8a","../../components/StopScreeningModal/StopScreeningModal":"edWFg","../../constants/queries-keys":"6hYSF","../../helpers/customer.helpers":"dkhe3","../../helpers/owners.helpers":"lynDH","../../helpers/person.helpers":"6qOIE","../../helpers/screening":"aJP5k","../../hooks/useCustomerDetailsBackButton":"3YBG0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetCompanyScreeningConfiguration":"if7XX","../../hooks/useLanguage":"2W6IE","../ErrorPage":"8Le05","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4fa4k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactTable = require("@tanstack/react-table");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _chevronLeftSvg = require("../../../assets/icons/chevron-left.svg");
var _chevronLeftSvgDefault = parcelHelpers.interopDefault(_chevronLeftSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const BackButton = (props)=>{
    const { url, onClick, displayLabel, showAsLink, disabled } = props;
    const history = (0, _reactRouterDom.useHistory)();
    const f = (0, _useFormatMessageDefault.default)();
    const handleClick = ()=>{
        if (url) history.push(url);
        else if ((0, _reactTable.isFunction)(onClick)) onClick();
        else history.goBack();
    };
    if (showAsLink) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Link), {
        url: url,
        onClick: !url ? handleClick : undefined,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBackIcon, {
                width: "10px",
                height: "12px",
                source: (0, _chevronLeftSvgDefault.default)
            }),
            f("links.go-back", displayLabel ? {
                name: displayLabel
            } : undefined)
        ]
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
        onClick: handleClick,
        disabled: disabled,
        children: f("button.go.back")
    });
};
const StyledBackIcon = (0, _styledComponentsDefault.default)((0, _iconDefault.default))`
  display: inline-block;
`;
exports.default = BackButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-table":"86D8M","styled-components":"eBrdC","../../../assets/icons/chevron-left.svg":"abXPg","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"abXPg":[function(require,module,exports) {
module.exports = require("d33ace4e117244a7").getBundleURL("kEMsi") + "chevron-left.cbd10248.svg";

},{"d33ace4e117244a7":"75UoR"}],"eHSf0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const Icon = (props)=>{
    const { source } = props;
    if (typeof source === "string") // Custom SVG icon
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIcon, {
        ...props
    });
    else // Polaris icon
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Icon), {
        ...props
    });
};
const StyledIcon = (0, _styledComponentsDefault.default).div`
  &:before {
    display: block;
    content: " ";
    width: ${({ width = "20px" })=>width};
    height: ${({ height = "20px" })=>height};
    max-height: ${({ height = "20px" })=>height};
    margin-right: 4px;
    background-repeat: no-repeat;
    background-size: ${({ width = "20px", height = "20px" })=>`${width} ${height}`};
    background-image: ${({ useMask, source })=>useMask ? "none" : `url(${source})`};
    mask: ${({ useMask, source })=>useMask ? `url(${source})` : "initial"};
    mask-size: ${({ width = "20px", height = "20px" })=>`${width} ${height}`};
    background-color: ${({ useMask })=>useMask ? "currentColor" : "initial"};
  },
`;
exports.default = Icon;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2hHqH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useErrorParser = require("../../hooks/useErrorParser");
var _useErrorParserDefault = parcelHelpers.interopDefault(_useErrorParser);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ErrorPanel = (props)=>{
    const { fieldID = "", message, actionTitle, ...inlineErrorProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const parseError = (0, _useErrorParserDefault.default)();
    const { generalError = f("common.errors.generic") } = parseError(message);
    const actionLabel = (actionTitle || f("common.labels.save-changes")).toLocaleLowerCase();
    const displayMessage = f("common.errors.generic.failed-action", {
        actionLabel,
        message: generalError
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.InlineError), {
        fieldID: fieldID,
        message: displayMessage,
        ...inlineErrorProps
    });
};
exports.default = ErrorPanel;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useErrorParser":"daNOL","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"daNOL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@sentry/react");
var _errorsHelpers = require("../helpers/errors.helpers");
var _collectionUtils = require("../utils/collectionUtils");
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useErrorParser = (customerType)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const parseError = (error)=>{
        let generalError;
        const fieldsErrorsMap = new Map();
        // don't try to parse the error if it doesn't exist
        if ((0, _util.isNil)(error)) return {
            error,
            generalError,
            fieldsErrorsMap
        };
        if (typeof error === "string") return {
            error,
            generalError: error,
            fieldsErrorsMap
        };
        // Handle 422 validation errors (beaufort-api),
        if ((0, _errorsHelpers.isValidationError)(error)) error.data?.detail?.forEach((errorDetail)=>{
            const field = (0, _collectionUtils.last)(errorDetail?.loc);
            const unhandledFields = [];
            switch(field){
                case "first_name":
                    fieldsErrorsMap.set("first_name", f("common.errors.invalid.first.name"));
                    break;
                case "last_name":
                    fieldsErrorsMap.set("last_name", f("common.errors.invalid.last.name"));
                    break;
                case "birth_date":
                    fieldsErrorsMap.set("birth_date", f("common.errors.invalid.birth.date"));
                    break;
                case "national_id":
                    fieldsErrorsMap.set("national_id", f("common.errors.invalid.person.national-id"));
                    break;
                case "country_of_citizenship":
                    fieldsErrorsMap.set("country_of_citizenship", f("common.errors.invalid.citizenship"));
                    break;
                case "email":
                    fieldsErrorsMap.set("email", f("common.errors.invalid.email"));
                    break;
                case "address":
                    generalError = f("common.errors.invalid.address");
                    break;
                case "comment":
                    generalError = f("common.errors.invalid.comment");
                    break;
                default:
                    if (typeof field === "string" && !(0, _stringUtils.isEmptyString)(errorDetail?.msg)) unhandledFields.push(errorDetail?.msg);
                    break;
            }
            if (unhandledFields.length > 0) generalError = unhandledFields.join(", ");
        });
        else if ((0, _errorsHelpers.isConflictError)(error)) {
            const errorDetails = error?.data?.detail;
            if (customerType === "person") {
                if (errorDetails?.includes("national_id")) fieldsErrorsMap.set("national_id", f("common.errors.person-national-id.exists"));
                else generalError = f("common.errors.person.exists");
            } else if (customerType === "company") {
                if (errorDetails?.includes("national_id")) fieldsErrorsMap.set("national_id", f("common.errors.company-national-id.exists"));
                else if (errorDetails?.includes("external_id")) fieldsErrorsMap.set("external_id", f("common.errors.company-external-id.exists"));
                else generalError = f("common.errors.company.exists");
            }
        //  Handle 400 errors (from data service)
        } else if ((0, _errorsHelpers.isBadRequestError)(error)) {
            if (customerType === "company") {
                const companyOrgNumberError = error?.data?.subject?.legal_entity?.national_id;
                if (companyOrgNumberError) // company org number validation in server failed
                fieldsErrorsMap.set("national_id", f("common.errors.invalid.company.national-id"));
                else generalError = f("common.errors.company.exists");
            }
            if (customerType === "person") {
                const personNationalIdError = error?.data?.subject?.person?.national_id || error?.data?.person?.national_id;
                if (personNationalIdError) fieldsErrorsMap.set("national_id", f("common.errors.invalid.person.national-id"));
                else generalError = f("common.errors.company.exists");
            }
            if (error.data?.title && !(0, _util.isNil)(error.data?.title)) {
                const titles = (0, _errorsHelpers.getErrorTitles)(error.data.title);
                generalError = `${error.data?.detail}${titles ? `: ${titles}` : ""}`;
            }
        } else if (error instanceof Error) generalError = error.message || f("common.errors.generic");
        _react.addBreadcrumb({
            category: "front-end-error-parser",
            level: (0, _errorsHelpers.is4xxError)(error?.status) ? "warning" : "error",
            message: (0, _errorsHelpers.is4xxError)(error?.status) ? "Validation error" : "Server error",
            data: {
                error,
                generalError,
                fieldsErrorsMap
            }
        });
        return {
            error,
            generalError,
            fieldsErrorsMap
        };
    };
    return parseError;
};
exports.default = useErrorParser;

},{"@sentry/react":"akCRS","../helpers/errors.helpers":"9SYBd","../utils/collectionUtils":"gr5mc","../utils/stringUtils":"4gVdA","../utils/util":"4MniK","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9SYBd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBadRequestError", ()=>isBadRequestError);
parcelHelpers.export(exports, "isValidationError", ()=>isValidationError);
parcelHelpers.export(exports, "isConflictError", ()=>isConflictError);
parcelHelpers.export(exports, "getErrorTitles", ()=>getErrorTitles);
parcelHelpers.export(exports, "is4xxError", ()=>is4xxError);
const isBadRequestError = (error)=>error?.status === 400;
const isValidationError = (error)=>error?.status === 422;
const isConflictError = (error)=>error?.status === 409;
const getErrorTitles = (title)=>Array.isArray(title) ? title?.join(", ") : title;
const is4xxError = (status)=>typeof status === "number" && Number.isInteger(status) && status >= 400 && status < 500;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gr5mc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// see: https://www.30secondsofcode.org/js/s/toggle-element
parcelHelpers.export(exports, "toggleElement", ()=>toggleElement);
/**
 * swaps elements of indexes in an array
 */ parcelHelpers.export(exports, "swapElements", ()=>swapElements);
/**
 * replaces an item in an array using the item id and returns a new array
 */ parcelHelpers.export(exports, "updateItem", ()=>updateItem);
/**
 * removes an item in an array using the item id and returns a new array
 */ parcelHelpers.export(exports, "removeItem", ()=>removeItem);
/**
 *
 */ parcelHelpers.export(exports, "insertAt", ()=>insertAt);
/**
 * returns the first element of a given items
 */ parcelHelpers.export(exports, "first", ()=>first);
/**
 * returns the last element of a given items
 */ parcelHelpers.export(exports, "last", ()=>last);
/**
 * returns if the array is not empty
 */ parcelHelpers.export(exports, "hasContent", ()=>hasContent);
/**
 * return the difference between two arrays as a list of 2 arrays:
 * the first array has all elements that are in the first but not in the second array
 * the second array has all the elements that are in the second array but not the first array
 */ parcelHelpers.export(exports, "delta", ()=>delta);
/**
 * return a symmetrical difference between two arrays (all elements from both arrays that do not intersect)
 */ parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "pickIds", ()=>pickIds);
/**
 * Check if an array includes all elements from another array
 *
 * @see https://www.30secondsofcode.org/js/s/array-includes-any-or-all-values/
 */ parcelHelpers.export(exports, "includesAllItems", ()=>includesAllItems);
/**
 * convert an array of items to a map where key is calculated using keyGetter and value is a list
 * of items that have the same key
 */ parcelHelpers.export(exports, "groupBy", ()=>groupBy);
/**
 * Check if two arrays intersect
 *
 * @see: https://www.30secondsofcode.org/js/s/arrays-intersect/
 */ parcelHelpers.export(exports, "intersects", ()=>intersects);
parcelHelpers.export(exports, "sortByName", ()=>sortByName);
/**
  Filter duplicate items from an array based on the value of key field
 */ parcelHelpers.export(exports, "uniqueElementsBy", ()=>uniqueElementsBy);
function toggleElement(items, item) {
    return items.includes(item) ? items.filter((el)=>el !== item) : [
        ...items,
        item
    ];
}
function swapElements(elements, sourceIndex, targetIndex) {
    const result = [
        ...elements
    ];
    result[sourceIndex] = result.splice(targetIndex, 1, result[sourceIndex])[0];
    return result;
}
function updateItem(items, item) {
    return items.map((exitingItem)=>exitingItem.id === item.id ? item : exitingItem);
}
function removeItem(items, item) {
    return items.filter((exitingItem)=>exitingItem.id !== item.id);
}
function insertAt(elements, item, index) {
    const clone = [
        ...elements
    ];
    clone.splice(index + 1, 0, item);
    return clone;
}
function first(items) {
    return !Array.isArray(items) || items.length === 0 ? undefined : items[0];
}
function last(items) {
    return !Array.isArray(items) || items.length === 0 ? undefined : items[items.length - 1];
}
function hasContent(items) {
    return Array.isArray(items) && items.length > 0;
}
function delta(arrayA, arrayB) {
    return [
        arrayA.filter((a)=>!arrayB.includes(a)),
        arrayB.filter((b)=>!arrayA.includes(b))
    ];
}
function difference(arrayA, arrayB) {
    return arrayA.filter((x)=>!arrayB.includes(x)).concat(arrayB.filter((x)=>!arrayA.includes(x)));
}
const pickIds = (items)=>items.map((item)=>item.id);
function includesAllItems(arrayA = [], arrayB = []) {
    if (!hasContent(arrayA) || !hasContent(arrayB)) return false;
    const array = pickIds(arrayA);
    const values = pickIds(arrayB);
    return values.every((value)=>array.includes(value));
}
function groupBy(items, keyGetter) {
    const map = new Map();
    items.forEach((item)=>{
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) map.set(key, [
            item
        ]);
        else collection.push(item);
    });
    return map;
}
function intersects(a, b) {
    const s = new Set(b);
    return [
        ...new Set(a)
    ].some((x)=>s.has(x));
}
const sortByName = (q1, q2)=>q1.name.toLocaleLowerCase().localeCompare(q2.name.toLocaleLowerCase());
function uniqueElementsBy(items, key) {
    const ids = new Set(); // temp variable to keep track of accepted ids
    const uniqueSchedulesList = items.filter((item)=>!ids.has(item[key]) && ids.add(item[key]));
    return uniqueSchedulesList;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f1O1W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _customerHelpers = require("../../helpers/customer.helpers");
var _ownersHelpers = require("../../helpers/owners.helpers");
var _personHelpers = require("../../helpers/person.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _addItemButton = require("../AddItemButton/AddItemButton");
var _addItemButtonDefault = parcelHelpers.interopDefault(_addItemButton);
var _ownerModal = require("../OwnerModal/OwnerModal");
var _ownerModalDefault = parcelHelpers.interopDefault(_ownerModal);
var _ownershipView = require("../OwnershipView/OwnershipView");
var _ownershipViewDefault = parcelHelpers.interopDefault(_ownershipView);
const OwnersCard = (props)=>{
    const { customer, owners, readonly, hideAddButton, isArchiveDisabled, onArchive, onUpdate, onCreate, ...ownersTableProps } = props;
    const { can_have_shareholders } = customer;
    const f = (0, _useFormatMessageDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const [ownerData, setOwnerData] = (0, _react.useState)();
    const closeModal = ()=>setOwnerData(undefined);
    const companyType = (0, _customerHelpers.getCompanyType)(language, customer.company_type);
    const showOwnersTable = can_have_shareholders !== false;
    const editOwner = (owner)=>setOwnerData(owner);
    const emptyTableLabel = customer.is_manual ? f("owners.card.manual.no-owners") : (0, _ownersHelpers.wasFoundedAfterOwnershipRegistryWasPublished)(customer.founded_date) ? f("owners.card.newly-founded.no-owners") : f("owners.card.no-owners");
    const handleCreateOwner = (owner)=>{
        onCreate(owner);
        closeModal();
    };
    const handleUpdateOwner = (owner)=>{
        onUpdate(owner);
        closeModal();
    };
    const handleArchiveOwner = (ownerId)=>{
        onArchive(ownerId);
        closeModal();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !showOwnersTable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: f("owners.card.cannot-have-shareholders", {
                    companyType
                })
            }),
            showOwnersTable && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    owners.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledEmptyLabel, {
                            children: emptyTableLabel
                        })
                    }),
                    owners.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipViewDefault.default), {
                        customer: customer,
                        owners: owners,
                        readonly: readonly,
                        onEdit: editOwner,
                        onUpdate: handleUpdateOwner,
                        onArchive: onArchive,
                        ...ownersTableProps
                    }),
                    !hideAddButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addItemButtonDefault.default), {
                            onClick: ()=>setOwnerData((0, _personHelpers.createNewOwner)(customer.country)),
                            disabled: readonly,
                            children: f("owners.card.buttons.add-owner")
                        })
                    })
                ]
            }),
            ownerData && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerModalDefault.default), {
                customerId: customer.id,
                ownerData: ownerData,
                isArchiveDisabled: ownerData && isArchiveDisabled(ownerData.id),
                onArchive: handleArchiveOwner,
                onUpdate: handleUpdateOwner,
                onCreate: handleCreateOwner,
                onClose: closeModal
            })
        ]
    });
};
const StyledEmptyLabel = (0, _styledComponentsDefault.default).p`
  white-space: pre-line;
`;
exports.default = OwnersCard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/customer.helpers":"dkhe3","../../helpers/owners.helpers":"lynDH","../../helpers/person.helpers":"6qOIE","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useLanguage":"2W6IE","../AddItemButton/AddItemButton":"8Rs0C","../OwnerModal/OwnerModal":"fch5O","../OwnershipView/OwnershipView":"jF1O5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dkhe3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCompanyType", ()=>getCompanyType);
parcelHelpers.export(exports, "getTotalReviewsCount", ()=>getTotalReviewsCount);
parcelHelpers.export(exports, "convertToCreatePersonCustomerRequest", ()=>convertToCreatePersonCustomerRequest);
parcelHelpers.export(exports, "isCustomerPEP", ()=>isCustomerPEP);
parcelHelpers.export(exports, "isCustomerSanctioned", ()=>isCustomerSanctioned);
parcelHelpers.export(exports, "isPartialAddress", ()=>isPartialAddress);
var _languages = require("../constants/languages");
var _utilities = require("../types/utilities");
var _stringUtils = require("../utils/stringUtils");
var _personHelpers = require("./person.helpers");
const getCompanyType = (language, companyType)=>{
    let description;
    switch(language){
        case "en":
            description = companyType?.description_en;
            break;
        case 0, _languages.DEFAULT_LANGUAGE:
        default:
            description = companyType?.description_nb;
            break;
    }
    return description || companyType?.code || "-";
};
const getTotalReviewsCount = (customer)=>customer.reviews.length;
const convertToCreatePersonCustomerRequest = (person, defaultCountry)=>{
    const personCreateRequest = (0, _personHelpers.convertPersonToCreateRequest)(person);
    return {
        ...personCreateRequest,
        address: personCreateRequest.address || {
            country: defaultCountry
        },
        external_id: person.external_id,
        project_id: person.project_id
    };
};
const isMatchCasePEP = (match)=>match.status === "RESOLVED" && match.review?.is_pep;
const isRolePEP = (role)=>role.status !== "EXPIRED" && role.person.is_pep;
const isOwnerPEP = (owner)=>!owner.deleted && owner.person?.is_pep;
const isCustomerPEP = (customer)=>{
    if (customer.is_pep) return true;
    // check if there are match cases for the company
    if (customer.match_cases.some(isMatchCasePEP)) return true;
    // check for active roles/owners (for company customer) that are marked as PEP
    if (!(0, _utilities.isPersonCustomerDetails)(customer) && (customer.roles.some(isRolePEP) || customer.beneficial_owners.some(isOwnerPEP))) return true;
    return false;
};
const isMatchCaseSanctioned = (match)=>match.status === "RESOLVED" && match.review?.is_sanctioned;
const isRoleSanctioned = (role)=>role.status !== "EXPIRED" && role.person.is_sanctioned;
const isOwnerSanctioned = (owner)=>!owner.deleted && owner.person?.is_sanctioned;
const isCustomerSanctioned = (customer)=>{
    if (customer.is_sanctioned) return true;
    // check if there are match cases for the company
    if (customer.match_cases.some(isMatchCaseSanctioned)) return true;
    // check for active roles/owners (for company customer) that are marked as Sanctioned
    if (!(0, _utilities.isPersonCustomerDetails)(customer) && (customer.roles.some(isRoleSanctioned) || customer.beneficial_owners.some(isOwnerSanctioned))) return true;
    return false;
};
const isPartialAddress = (address)=>[
        address.address_line_1,
        address.address_line_2,
        address.city,
        address.county,
        address.postal_code
    ].some((part)=>!(0, _stringUtils.isEmptyString)(part));

},{"../constants/languages":"ecnY7","../types/utilities":"6zLpB","../utils/stringUtils":"4gVdA","./person.helpers":"6qOIE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6zLpB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPersonCustomer", ()=>isPersonCustomer);
parcelHelpers.export(exports, "isCompany", ()=>isCompany);
parcelHelpers.export(exports, "isManualCompany", ()=>isManualCompany);
parcelHelpers.export(exports, "isCompanySearchResult", ()=>isCompanySearchResult);
parcelHelpers.export(exports, "isPersonCustomerDetails", ()=>isPersonCustomerDetails);
parcelHelpers.export(exports, "isProject", ()=>isProject);
parcelHelpers.export(exports, "isAssignment", ()=>isAssignment);
parcelHelpers.export(exports, "getCustomerQueryKey", ()=>getCustomerQueryKey);
/**
 * Helper function that enables using generics in Props passed to React.forwardRef
 * see: https://www.totaltypescript.com/forwardref-with-generic-components#the-solution
 */ parcelHelpers.export(exports, "fixedForwardRef", ()=>fixedForwardRef);
var _react = require("react");
var _queriesKeys = require("../constants/queries-keys");
var _util = require("../utils/util");
const isPersonCustomer = (entity)=>entity.type === "person";
const isCompany = (customer)=>customer.type === "company";
const isManualCompany = (customer)=>isCompany(customer) && customer.is_manual;
const isCompanySearchResult = (customer)=>isCompany(customer) && Array.isArray(customer.related_search_results);
const isPersonCustomerDetails = (entity)=>entity.type === "person";
const isProject = (entity)=>entity.customers !== undefined;
const isAssignment = (entity)=>(0, _util.hasOwnProperty)(entity, "is_accepted");
const getCustomerQueryKey = (customer)=>{
    const queryKey = [
        customer.type === "company" ? (0, _queriesKeys.QUERIES_KEYS).COMPANY_DETAILS : (0, _queriesKeys.QUERIES_KEYS).PERSON_DETAILS,
        customer.id
    ];
    return queryKey;
};
function fixedForwardRef(render) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return _react.forwardRef(render);
}

},{"react":"cOWTg","../constants/queries-keys":"6hYSF","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6hYSF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QUERIES_KEYS", ()=>QUERIES_KEYS);
parcelHelpers.export(exports, "STALE_TIME", ()=>STALE_TIME);
parcelHelpers.export(exports, "RETRY_TIME", ()=>RETRY_TIME);
parcelHelpers.export(exports, "MAX_RETRIES", ()=>MAX_RETRIES);
var QUERIES_KEYS;
(function(QUERIES_KEYS) {
    QUERIES_KEYS["ALL_ASSIGNMENT_INDUSTRIES_AND_PURPOSES"] = "all-assignment-industries-purposes";
    QUERIES_KEYS["ALL_INDUSTRY_TYPES"] = "all-industry-types";
    QUERIES_KEYS["ALL_TAGS"] = "all-tags";
    QUERIES_KEYS["ASSIGNMENT_DETAILS"] = "assignment-details";
    QUERIES_KEYS["ATTACHMENTS"] = "attachments";
    QUERIES_KEYS["ATTACHMENT_SIGNATURES"] = "attachment-signatures";
    QUERIES_KEYS["COMPANY_DETAILS"] = "company-details";
    QUERIES_KEYS["COMPANY_ONBOARDING_DISCLOSURES"] = "company-onboarding-disclosures";
    QUERIES_KEYS["COMPANY_ONBOARDING_SUMMARY"] = "company-onboarding-summary";
    QUERIES_KEYS["COMPANY_OWNERSHIP_TREE"] = "company-ownership-tree";
    QUERIES_KEYS["COMPANY_REQUEST_DISCLOSURES"] = "company-request-disclosures";
    QUERIES_KEYS["COMPANY_SCREENING"] = "company-screening";
    QUERIES_KEYS["COUNTRY_RISK_AND_TAX_HAVENS"] = "country-risk-tax-havens";
    QUERIES_KEYS["CUSTOMERS_LIST"] = "customers";
    QUERIES_KEYS["CUSTOMER_COUNTS"] = "customer-counts";
    QUERIES_KEYS["CUSTOMER_MATCH_CASES"] = "customer-match-cases";
    QUERIES_KEYS["CUSTOMER_NOTES"] = "customer-notes";
    QUERIES_KEYS["CUSTOMER_NOTIFICATIONS_SETTINGS"] = "customer-notifications-settings";
    QUERIES_KEYS["CUSTOMER_REVIEW"] = "customer-review";
    QUERIES_KEYS["CUSTOMER_REVIEW_NOTES"] = "customer-review-notes";
    QUERIES_KEYS["CUSTOMER_REVIEW_GUIDELINE"] = "customer-review-guideline";
    QUERIES_KEYS["CUSTOMER_REVIEW_GUIDELINES_SETTINGS"] = "customer-review-guidelines-settings";
    QUERIES_KEYS["DASHBOARD"] = "dashboard";
    QUERIES_KEYS["DISCLOSURE_SETTINGS"] = "disclosure-settings";
    QUERIES_KEYS["FOLLOW_UP_SETTINGS"] = "followup-settings";
    QUERIES_KEYS["HUBSPOT_LIVE_CHAT"] = "hubspot-live-chat";
    QUERIES_KEYS["KYC_PREVIEW"] = "KYC-PREVIEW";
    QUERIES_KEYS["MATCH_DETAILS"] = "match-details";
    QUERIES_KEYS["MEASURES_SETTINGS"] = "measures-settings";
    QUERIES_KEYS["ONBOARDING_SETTINGS"] = "onboarding-settings";
    QUERIES_KEYS["PERSON_CHANGE_SCREENING"] = "person-change-screening";
    QUERIES_KEYS["PERSON_DETAILS"] = "person-details";
    QUERIES_KEYS["PERSON_ONBOARDING_DETAILS"] = "person-onboarding-details";
    QUERIES_KEYS["POSTAL_CODES_SUGGESTIONS"] = "postal-codes-suggestions";
    QUERIES_KEYS["PROJECTS"] = "projects";
    QUERIES_KEYS["PROJECT_DETAILS"] = "project-details";
    QUERIES_KEYS["QUESTIONNAIRES"] = "questionnaires";
    QUERIES_KEYS["QUESTIONNAIRES_SUMMARY"] = "questionnaires-summary";
    QUERIES_KEYS["REVIEW_CHECKLISTS"] = "review-checklists";
    QUERIES_KEYS["STATUS_MESSAGE"] = "status-message";
    QUERIES_KEYS["SUGGESTED_SIGNERS"] = "suggested-signers";
    QUERIES_KEYS["USERS"] = "users";
})(QUERIES_KEYS || (QUERIES_KEYS = {}));
const STALE_TIME = 3600000; // 1 hour;
const RETRY_TIME = 5000; // 5 seconds
const MAX_RETRIES = 10;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6qOIE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isManuallyCreated", ()=>isManuallyCreated);
parcelHelpers.export(exports, "convertPersonToUpdateRequest", ()=>convertPersonToUpdateRequest);
parcelHelpers.export(exports, "getPersonCountries", ()=>getPersonCountries);
parcelHelpers.export(exports, "getPersonUniqueCountries", ()=>getPersonUniqueCountries);
parcelHelpers.export(exports, "getPersonKey", ()=>getPersonKey);
parcelHelpers.export(exports, "getRoleOrOwnerKey", ()=>getRoleOrOwnerKey);
parcelHelpers.export(exports, "isUserCreatedPerson", ()=>isUserCreatedPerson);
parcelHelpers.export(exports, "isValidPerson", ()=>isValidPerson);
parcelHelpers.export(exports, "isValidPersonDateOfBirth", ()=>isValidPersonDateOfBirth);
parcelHelpers.export(exports, "convertPersonToCreateRequest", ()=>convertPersonToCreateRequest);
parcelHelpers.export(exports, "createNewRole", ()=>createNewRole);
parcelHelpers.export(exports, "createNewOwner", ()=>createNewOwner);
parcelHelpers.export(exports, "createNewPerson", ()=>createNewPerson);
parcelHelpers.export(exports, "isUBO", ()=>isUBO);
var _person = require("../constants/person");
var _dateUtils = require("../utils/dateUtils");
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
var _displayHelpers = require("./display.helpers");
const isManuallyCreated = (entity)=>!(0, _util.isNil)(entity.created_by);
const convertPersonToUpdateRequest = ({ first_name, last_name, birth_date, birth_year, country_of_origin, country_of_citizenship, country_of_residence, address, national_id_country, national_id, phone, email, is_pep, is_sanctioned })=>({
        first_name,
        last_name,
        birth_date,
        birth_year,
        country_of_origin,
        country_of_citizenship,
        country_of_residence,
        address,
        national_id_country,
        national_id,
        phone,
        email,
        is_pep,
        is_sanctioned
    });
const getPersonCountries = (person)=>{
    const countriesMap = new Map();
    if (!person) return countriesMap;
    if (person.country_of_origin) countriesMap.set("COUNTRY_OF_ORIGIN", person.country_of_origin);
    if (person.country_of_citizenship) countriesMap.set("COUNTRY_OF_CITIZENSHIP", person.country_of_citizenship);
    if (person.country_of_residence) countriesMap.set("COUNTRY_OF_RESIDENCE", person.country_of_residence);
    if (person.national_id_country) countriesMap.set("NATIONAL_ID_COUNTRY", person.national_id_country);
    if (person.address?.country) countriesMap.set("ADDRESS", person.address.country);
    return countriesMap;
};
const getPersonUniqueCountries = (person)=>{
    const countriesMap = getPersonCountries(person);
    const countriesSet = new Set(countriesMap.values());
    return [
        ...countriesSet.values()
    ];
};
const getPersonKey = (entity)=>`${(0, _displayHelpers.getFullName)(entity)}${new Date((0, _displayHelpers.getBirthDate)(entity)).getFullYear()}`;
const getRoleOrOwnerKey = (entity)=>getPersonKey(entity.person);
const isUserCreatedPerson = (personModalData)=>!personModalData.id || isManuallyCreated(personModalData);
const isValidPerson = (personModalData)=>{
    if ((0, _stringUtils.isEmptyString)(personModalData.person?.first_name)) return false;
    if ((0, _stringUtils.isEmptyString)(personModalData.person?.last_name)) return false;
    if ((0, _stringUtils.isEmptyString)(personModalData.person?.address?.country)) return false;
    if (isUserCreatedPerson(personModalData) && (0, _person.REQUIRED_FIELDS_FOR_NEW_PERSON).some((field)=>!personModalData.person || !personModalData.person[field])) return false;
    return true;
};
const isValidPersonDateOfBirth = (personModalData)=>{
    if (!(0, _dateUtils.isValidYear)(personModalData.person?.birth_year, (0, _person.MIN_BIRTH_DATE), (0, _person.MAX_BIRTH_DATE))) return false;
    // if creating a new person OR if the birthdate field is not empty then
    // validate the birthdate
    // (which means that if editing an existing persons it is allowed to have an empty birthdate)
    if (isUserCreatedPerson(personModalData) || !(0, _stringUtils.isEmptyString)(personModalData.person?.birth_date)) {
        if (!(0, _dateUtils.isValidDate)(personModalData.person?.birth_date, (0, _person.MIN_BIRTH_DATE), (0, _person.MAX_BIRTH_DATE))) return false;
    }
    return true;
};
const trimAddress = (a)=>{
    if (!a) return undefined;
    return {
        address_line_1: a.address_line_1?.trim() || "",
        address_line_2: a.address_line_2?.trim() || "",
        postal_code: a.postal_code?.trim() || "",
        city: a.city?.trim() || "",
        county: a.county?.trim() || "",
        country: a.country
    };
};
const convertPersonToCreateRequest = ({ first_name, last_name, birth_date, country_of_origin, country_of_citizenship, country_of_residence, address, national_id_country, national_id, phone, email })=>({
        first_name: first_name ? first_name.trim() : "",
        last_name: last_name ? last_name.trim() : "",
        birth_date: birth_date,
        country_of_origin,
        country_of_citizenship: country_of_citizenship,
        country_of_residence: country_of_residence,
        address: trimAddress(address),
        national_id_country,
        national_id,
        phone,
        email
    });
const createPersonWithDefaultCountry = (defaultCountry)=>{
    return {
        first_name: "",
        last_name: "",
        birth_date: "",
        country_of_origin: defaultCountry,
        country_of_citizenship: defaultCountry,
        country_of_residence: defaultCountry,
        national_id_country: defaultCountry,
        address: {
            country: defaultCountry
        }
    };
};
const createNewRole = (defaultCountry)=>({
        person: {
            ...createPersonWithDefaultCountry(defaultCountry),
            id: ""
        },
        is_new: false,
        is_ubo: false,
        status: "ACTIVE",
        type: "UNKNOWN_ROLE"
    });
const createNewOwner = (defaultCountry)=>({
        person: {
            ...createPersonWithDefaultCountry(defaultCountry),
            id: ""
        },
        is_ubo: false
    });
const createNewPerson = (defaultCountry)=>({
        ...createPersonWithDefaultCountry(defaultCountry)
    });
const isUBO = (person)=>person.custom_is_ubo ?? person.is_ubo;

},{"../constants/person":"dpk3a","../utils/dateUtils":"euvUV","../utils/stringUtils":"4gVdA","../utils/util":"4MniK","./display.helpers":"2q3xY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dpk3a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MIN_BIRTH_DATE", ()=>MIN_BIRTH_DATE);
parcelHelpers.export(exports, "MAX_BIRTH_DATE", ()=>MAX_BIRTH_DATE);
parcelHelpers.export(exports, "REQUIRED_FIELDS_FOR_NEW_PERSON", ()=>REQUIRED_FIELDS_FOR_NEW_PERSON);
parcelHelpers.export(exports, "MAX_LENGTH_OF_TEXT_INPUT_FIELD", ()=>MAX_LENGTH_OF_TEXT_INPUT_FIELD);
const MIN_BIRTH_DATE = new Date("1900-01-01");
const MAX_BIRTH_DATE = new Date();
const REQUIRED_FIELDS_FOR_NEW_PERSON = [
    "country_of_residence",
    "country_of_citizenship"
];
const MAX_LENGTH_OF_TEXT_INPUT_FIELD = 250;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"euvUV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidDate", ()=>isValidDate);
parcelHelpers.export(exports, "isValidYear", ()=>isValidYear);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatDateInput", ()=>formatDateInput);
parcelHelpers.export(exports, "parseYear", ()=>parseYear);
parcelHelpers.export(exports, "secondsBetweenDates", ()=>secondsBetweenDates);
parcelHelpers.export(exports, "daysBetweenDates", ()=>daysBetweenDates);
parcelHelpers.export(exports, "getRangeDate", ()=>getRangeDate);
parcelHelpers.export(exports, "transformDate", ()=>transformDate);
var _pagination = require("../constants/pagination");
var _numbersUtils = require("./numbersUtils");
const isValidDate = (dateValue, minDate, maxDate)=>{
    if (!dateValue) return false;
    // Check if valid date
    const date = new Date(dateValue);
    // Check if the resulting date object is an "Invalid Date"
    // An invalid date's time value is NaN (Not a Number)
    if (isNaN(date.valueOf())) return false;
    // Check if date is within min/max limits
    if (minDate && date < minDate) return false;
    if (maxDate && date > maxDate) return false;
    return true;
};
const isValidYear = (yearValue, minDate, maxDate)=>{
    if (!yearValue) return false;
    const year = (0, _numbersUtils.isNumber)(yearValue) ? yearValue : parseYear(yearValue);
    if (isNaN(year)) return false;
    if (minDate && year < minDate.getFullYear()) return false;
    if (maxDate && year > maxDate.getFullYear()) return false;
    return true;
};
const formatDate = (year, month, day)=>`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
const formatDateInput = (date)=>formatDate(String(date.getFullYear()), String(date.getMonth() + 1), String(date.getDate()));
const parseYear = (dateValue)=>parseInt(dateValue.split("-")[0], 10);
const secondsBetweenDates = (dateValueA, dateValueB)=>{
    if (!dateValueA || !dateValueB || !isValidDate(dateValueA) || !isValidDate(dateValueB)) return NaN;
    const dateA = new Date(dateValueA);
    const dateB = new Date(dateValueB);
    return Math.ceil(Math.abs((dateB.getTime() - dateA.getTime()) / 1000));
};
const daysBetweenDates = (dateValueA, dateValueB)=>{
    const seconds = secondsBetweenDates(dateValueA, dateValueB);
    if (isNaN(seconds)) return seconds;
    return Math.ceil(seconds / 86400);
};
const getRangeDate = (range, customDate, inThePast)=>{
    const now = new Date();
    // reset time properties
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    now.setMilliseconds(0);
    const action = inThePast ? -1 : 1;
    switch(range){
        case (0, _pagination.DateRange).WEEK:
            now.setDate(now.getDate() + action * 7);
            return now.toISOString();
        case (0, _pagination.DateRange).MONTH:
            now.setMonth(now.getMonth() + action * 1);
            return now.toISOString();
        case (0, _pagination.DateRange).YEAR:
            now.setFullYear(now.getFullYear() + action * 1);
            return now.toISOString();
        case (0, _pagination.DateRange).CUSTOM:
        default:
            return customDate;
    }
};
const transformDate = (d, year)=>year ? year : d ? d.split("-")[0] : undefined;

},{"../constants/pagination":"e05H0","./numbersUtils":"2RGyl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e05H0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SORT_BY_NAME_PARAMETER", ()=>SORT_BY_NAME_PARAMETER);
parcelHelpers.export(exports, "SORT_BY_ADDED_DATE_PARAMETER", ()=>SORT_BY_ADDED_DATE_PARAMETER);
parcelHelpers.export(exports, "CUSTOMERS_PER_PAGE", ()=>CUSTOMERS_PER_PAGE);
parcelHelpers.export(exports, "ORDER_NAME_PARAMETER", ()=>ORDER_NAME_PARAMETER);
parcelHelpers.export(exports, "PAGE_NAME_PARAMETER", ()=>PAGE_NAME_PARAMETER);
parcelHelpers.export(exports, "LIMIT_NAME_PARAMETER", ()=>LIMIT_NAME_PARAMETER);
parcelHelpers.export(exports, "QUERY_NAME_PARAMETER", ()=>QUERY_NAME_PARAMETER);
parcelHelpers.export(exports, "CREATED_RANGE_NAME_PARAMETER", ()=>CREATED_RANGE_NAME_PARAMETER);
parcelHelpers.export(exports, "CREATED_AFTER_NAME_PARAMETER", ()=>CREATED_AFTER_NAME_PARAMETER);
parcelHelpers.export(exports, "CREATED_BEFORE_NAME_PARAMETER", ()=>CREATED_BEFORE_NAME_PARAMETER);
parcelHelpers.export(exports, "FOLLOWUP_RANGE_NAME_PARAMETER", ()=>FOLLOWUP_RANGE_NAME_PARAMETER);
parcelHelpers.export(exports, "FOLLOWUP_AFTER_NAME_PARAMETER", ()=>FOLLOWUP_AFTER_NAME_PARAMETER);
parcelHelpers.export(exports, "FOLLOWUP_BEFORE_NAME_PARAMETER", ()=>FOLLOWUP_BEFORE_NAME_PARAMETER);
parcelHelpers.export(exports, "DASHBOARD_INTERVAL_NAME_PARAMETER", ()=>DASHBOARD_INTERVAL_NAME_PARAMETER);
parcelHelpers.export(exports, "DASHBOARD_START_NAME_PARAMETER", ()=>DASHBOARD_START_NAME_PARAMETER);
parcelHelpers.export(exports, "DASHBOARD_END_NAME_PARAMETER", ()=>DASHBOARD_END_NAME_PARAMETER);
parcelHelpers.export(exports, "DateRange", ()=>DateRange);
const SORT_BY_NAME_PARAMETER = "name";
const SORT_BY_ADDED_DATE_PARAMETER = "created";
const CUSTOMERS_PER_PAGE = 20;
const ORDER_NAME_PARAMETER = "order";
const PAGE_NAME_PARAMETER = "page";
const LIMIT_NAME_PARAMETER = "limit";
const QUERY_NAME_PARAMETER = "q";
const CREATED_RANGE_NAME_PARAMETER = "created";
const CREATED_AFTER_NAME_PARAMETER = "createdAfter";
const CREATED_BEFORE_NAME_PARAMETER = "createdBefore";
const FOLLOWUP_RANGE_NAME_PARAMETER = "followup";
const FOLLOWUP_AFTER_NAME_PARAMETER = "followupAfter";
const FOLLOWUP_BEFORE_NAME_PARAMETER = "followupBefore";
const DASHBOARD_INTERVAL_NAME_PARAMETER = "interval";
const DASHBOARD_START_NAME_PARAMETER = "from";
const DASHBOARD_END_NAME_PARAMETER = "until";
var DateRange;
(function(DateRange) {
    DateRange["WEEK"] = "WEEK";
    DateRange["MONTH"] = "MONTH";
    DateRange["YEAR"] = "YEAR";
    DateRange["CUSTOM"] = "CUSTOM";
})(DateRange || (DateRange = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2q3xY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFullName", ()=>getFullName);
parcelHelpers.export(exports, "getBirthDate", ()=>getBirthDate);
parcelHelpers.export(exports, "getPersonDisplayName", ()=>getPersonDisplayName);
parcelHelpers.export(exports, "getCompanyDisplayName", ()=>getCompanyDisplayName);
parcelHelpers.export(exports, "getCustomerName", ()=>getCustomerName);
parcelHelpers.export(exports, "getTranslationText", ()=>getTranslationText);
var _languages = require("../constants/languages");
var _utilities = require("../types/utilities");
var _numbersUtils = require("../utils/numbersUtils");
const getFullName = (person)=>`${person?.first_name || ""} ${person?.last_name || ""}`;
const getBirthDate = (person)=>person?.birth_date || ((0, _numbersUtils.isNumber)(person?.birth_year) ? person?.birth_year?.toFixed(0) : undefined);
const getPersonDisplayName = (person)=>`${person.first_name} ${person.last_name}`;
const getCompanyDisplayName = (company)=>`${company?.name || company?.national_id}`;
const getCustomerName = (customer)=>(0, _utilities.isCompany)(customer) ? getCompanyDisplayName(customer) : getPersonDisplayName(customer);
const getTranslationText = (language, text)=>text?.[language] || text?.[0, _languages.DEFAULT_LANGUAGE] || "";

},{"../constants/languages":"ecnY7","../types/utilities":"6zLpB","../utils/numbersUtils":"2RGyl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lynDH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOwnerCountries", ()=>getOwnerCountries);
parcelHelpers.export(exports, "isOwnerPerson", ()=>isOwnerPerson);
parcelHelpers.export(exports, "isAllowScreeningOwner", ()=>isAllowScreeningOwner);
parcelHelpers.export(exports, "getOwnerName", ()=>getOwnerName);
parcelHelpers.export(exports, "isValidOwner", ()=>isValidOwner);
parcelHelpers.export(exports, "wasFoundedAfterOwnershipRegistryWasPublished", ()=>wasFoundedAfterOwnershipRegistryWasPublished);
parcelHelpers.export(exports, "convertOwnerToUpdateOwnerRequest", ()=>convertOwnerToUpdateOwnerRequest);
var _ownershipUpdates = require("../constants/ownership-updates");
var _dateUtils = require("../utils/dateUtils");
var _numbersUtils = require("../utils/numbersUtils");
var _displayHelpers = require("./display.helpers");
var _personHelpers = require("./person.helpers");
const getOwnerCountries = (owner)=>{
    const countriesMap = (0, _personHelpers.getPersonCountries)(owner?.person);
    if (owner?.unknown_owner_address?.country) countriesMap.set("ADDRESS", owner?.unknown_owner_address?.country);
    if (owner?.company?.address?.country) countriesMap.set("ADDRESS", owner?.company?.address?.country);
    return countriesMap;
};
const isOwnerPerson = (owner)=>Boolean(owner && !owner.is_unknown && !owner.company && owner.person !== undefined);
const isAllowScreeningOwner = (owner)=>Boolean(owner?.id) && isOwnerPerson(owner);
const getOwnerName = (owner)=>owner.unknown_owner_name || owner.company?.name || (0, _displayHelpers.getFullName)(owner.person);
const isValidOwner = (owner)=>{
    if (!(0, _personHelpers.isValidPerson)(owner)) return false;
    if (!(0, _personHelpers.isValidPersonDateOfBirth)(owner)) return false;
    if (!(0, _numbersUtils.isNumberInRange)(owner.percent_share, 0, 100)) return false;
    return true;
};
const wasFoundedAfterOwnershipRegistryWasPublished = (foundedDate)=>{
    if (!(0, _dateUtils.isValidDate)(foundedDate)) return false;
    const foundedYear = (0, _dateUtils.parseYear)(foundedDate);
    return foundedYear > (0, _ownershipUpdates.LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR);
};
const convertOwnerToUpdateOwnerRequest = ({ percent_share, person, deleted, comment, custom_is_ubo })=>({
        person: person ? (0, _personHelpers.convertPersonToUpdateRequest)(person) : undefined,
        deleted,
        comment,
        custom_is_ubo,
        percent_share: percent_share ? parseFloat(percent_share) : undefined
    });

},{"../constants/ownership-updates":"k1X7w","../utils/dateUtils":"euvUV","../utils/numbersUtils":"2RGyl","./display.helpers":"2q3xY","./person.helpers":"6qOIE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k1X7w":[function(require,module,exports) {
/**
 * Latest owners registry (Aksjonærregisteret) update year
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR", ()=>LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR);
parcelHelpers.export(exports, "LATEST_OWNERSHIP_REGISTRY_DATE", ()=>LATEST_OWNERSHIP_REGISTRY_DATE);
const LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR = 2024;
const LATEST_OWNERSHIP_REGISTRY_DATE = new Date(LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR, 11, 31);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Rs0C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _plusSvg = require("../../../assets/icons/plus.svg");
var _plusSvgDefault = parcelHelpers.interopDefault(_plusSvg);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const AddItemButton = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        ...props,
        plain: true,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _plusSvgDefault.default),
            useMask: true
        }),
        textAlign: "left"
    });
};
exports.default = AddItemButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../assets/icons/plus.svg":"dOu0d","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dOu0d":[function(require,module,exports) {
module.exports = require("d9f992648cc4b75").getBundleURL("kEMsi") + "plus.63a4d2ad.svg";

},{"d9f992648cc4b75":"75UoR"}],"8exc0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const Button = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { truncate, round, warning, className = "", icon, hoverable, id, children, ...buttonProps } = props;
    const iconNode = typeof icon !== "string" ? icon : /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIconWrapper, {
        hoverable: hoverable,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: icon
        })
    });
    if (truncate || round || className || id) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTruncateWrapper, {
        className: className,
        truncate: truncate,
        round: round,
        warning: warning,
        id: id,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
            fullWidth: true,
            icon: iconNode,
            ...buttonProps,
            children: children
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
        icon: iconNode,
        ...buttonProps,
        children: children
    });
});
const StyledIconWrapper = (0, _styledComponentsDefault.default).div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ hoverable })=>hoverable && `
    padding: var(--p-space-1);
    
    &:hover {
      border-radius: var(--p-border-radius-1);
      background-color: var(--p-surface-hovered);
    }
  `}
`;
const StyledTruncateWrapper = (0, _styledComponentsDefault.default).span`
  & .Polaris-Button {
    ${({ round })=>round && `border-radius: 50%;`}

    &.Polaris-Button--pressed {
      ${({ warning })=>warning && `background-color: var(--p-surface-warning-subdued-pressed);
       `}
    }
    &:hover {
      ${({ warning })=>warning && `background-color: var(--p-surface-warning-subdued-pressed);
         box-shadow: var(--p-banner-border-warning);
         border: none;
       `}
    }
  }

  & .Polaris-Button__Text {
    ${({ truncate })=>truncate && `
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}
  }
`;
exports.default = Button;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fch5O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _displayHelpers = require("../../helpers/display.helpers");
var _ownersHelpers = require("../../helpers/owners.helpers");
var _personHelpers = require("../../helpers/person.helpers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useRestoreOwnerMutation = require("../../hooks/useRestoreOwnerMutation");
var _useRestoreOwnerMutationDefault = parcelHelpers.interopDefault(_useRestoreOwnerMutation);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _numbersUtils = require("../../utils/numbersUtils");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _ownerArchiveConfirm = require("../OwnerArchiveConfirm/OwnerArchiveConfirm");
var _ownerArchiveConfirmDefault = parcelHelpers.interopDefault(_ownerArchiveConfirm);
var _personForm = require("../PersonForm/PersonForm");
var _personFormDefault = parcelHelpers.interopDefault(_personForm);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _ubomanualOverride = require("../UBOManualOverride/UBOManualOverride");
var _ubomanualOverrideDefault = parcelHelpers.interopDefault(_ubomanualOverride);
const OwnerModal = (props)=>{
    const { ownerData, customerId, isArchiveDisabled, onArchive, onUpdate, onCreate, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const digits = features.HIGHER_ACCURACY_PERCENTAGES ? 3 : 2;
    const step = features.HIGHER_ACCURACY_PERCENTAGES ? 0.001 : 0.1;
    const formatPercentShare = (value)=>(0, _numbersUtils.isNumber)(value) ? Number(value).toFixed(digits) : "";
    const [owner, setOwner] = (0, _react.useState)(()=>({
            ...ownerData,
            percent_share: formatPercentShare(ownerData.percent_share)
        }));
    const [showArchiveConfirm, toggleArchiveConfirm, closeArchiveConfirm] = (0, _useOpenCloseDefault.default)();
    const [isFormValid, setIsFormValid] = (0, _react.useState)(owner.id !== undefined);
    const isUpdatingOwner = Boolean(owner.id);
    const isUserCreatedOwner = (0, _personHelpers.isUserCreatedPerson)(owner);
    const saveOwnerMutation = (0, _reactQuery.useMutation)(()=>{
        const { percent_share, comment } = owner;
        const percentShare = (0, _numbersUtils.isNumber)(percent_share) ? parseFloat(percent_share) : undefined;
        return isUpdatingOwner && owner.id ? (0, _apiDefault.default).updateCompanyOwner(customerId, owner.id, {
            percent_share: percentShare,
            comment,
            custom_is_ubo: owner.custom_is_ubo,
            person: (0, _personHelpers.convertPersonToUpdateRequest)(owner.person)
        }) : (0, _apiDefault.default).createCompanyOwner(customerId, {
            percent_share: percentShare || 0,
            comment,
            custom_is_ubo: owner.custom_is_ubo,
            person: (0, _personHelpers.convertPersonToCreateRequest)(owner.person)
        });
    }, {
        onSuccess: isUpdatingOwner ? onUpdate : onCreate
    });
    const restoreOwnerMutation = (0, _useRestoreOwnerMutationDefault.default)(customerId, owner);
    const handleRestore = ()=>{
        restoreOwnerMutation.mutate(undefined, {
            onSuccess: (updatedOwner)=>{
                setSnackbar(f("modals.owner.messages.owner-restored", {
                    name: (0, _displayHelpers.getFullName)(updatedOwner.person)
                }));
                onClose();
            }
        });
    };
    const handleChange = (key, value)=>setOwner((prevOwner)=>({
                ...prevOwner,
                [key]: value
            }));
    const saveNewOwner = ()=>saveOwnerMutation.mutate();
    const invalidPercentShareValue = !(0, _numbersUtils.isNumberInRange)(owner.percent_share, 0, 100);
    const isSaveDisabled = saveOwnerMutation.isLoading || !isFormValid || !(0, _ownersHelpers.isValidOwner)(owner) || ownerData.deleted;
    const percentSharePlaceholder = features.HIGHER_ACCURACY_PERCENTAGES ? "0.000" : "0.00";
    const readonly = ownerData.deleted || saveOwnerMutation.isLoading;
    const hasError = saveOwnerMutation.isError || restoreOwnerMutation.isError;
    const error = saveOwnerMutation.error || restoreOwnerMutation.error;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
        open: true,
        large: true,
        onClose: onClose,
        title: isUpdatingOwner ? f("modals.owner.title.update") : f("modals.owner.title.add"),
        primaryAction: {
            content: isUpdatingOwner ? f("default.save") : f("default.add"),
            onAction: saveNewOwner,
            disabled: isSaveDisabled,
            loading: saveOwnerMutation.isLoading
        },
        secondaryActions: [
            {
                content: f("default.cancel"),
                onAction: onClose
            }
        ],
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "4",
            blockAlign: "center",
            children: [
                isUpdatingOwner && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                    content: isArchiveDisabled ? f("modals.owner.tooltips.archive-disabled") : undefined,
                    preferredPosition: "above",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                        destructive: true,
                        disabled: isArchiveDisabled || readonly,
                        onClick: toggleArchiveConfirm,
                        children: f("default.archive")
                    })
                }),
                ownerData.deleted && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    loading: restoreOwnerMutation.isLoading,
                    onClick: handleRestore,
                    children: f("default.restore")
                }),
                hasError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: error
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingMd",
                            as: "h2",
                            children: f("modals.headings.personal-information")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personFormDefault.default), {
                            value: owner.person,
                            disabled: readonly,
                            birthDateIsRequired: isUserCreatedOwner,
                            isCreating: isUserCreatedOwner,
                            allowBirthYear: !isUserCreatedOwner,
                            onChange: (person)=>setOwner((prevOwner)=>({
                                        ...prevOwner,
                                        person
                                    })),
                            onValidityChange: setIsFormValid,
                            requiredFields: [
                                "country"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingMd",
                                    as: "h2",
                                    children: f("modals.owner.headings.ownership-in-company")
                                }),
                                owner.is_ubo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                    italic: true,
                                    children: f("common.labels.calculated-ubo")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                            distribution: "fillEvenly",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                    error: invalidPercentShareValue ? f("default.invalid") : undefined,
                                    placeholder: percentSharePlaceholder,
                                    min: 0,
                                    max: 100,
                                    label: f("modals.owner.labels.percent_share"),
                                    value: owner.percent_share || "",
                                    onBlur: ()=>handleChange("percent_share", formatPercentShare(owner.percent_share)),
                                    onChange: (newValue)=>handleChange("percent_share", newValue),
                                    disabled: readonly,
                                    suffix: "%",
                                    step: step,
                                    type: "number",
                                    autoComplete: "off",
                                    requiredIndicator: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ubomanualOverrideDefault.default), {
                                    checked: (0, _personHelpers.isUBO)(owner),
                                    onChange: (newValue)=>handleChange("custom_is_ubo", newValue),
                                    disabled: readonly
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                    inlineAlign: "start",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                            label: f("common.labels.mark-person-as-pep"),
                                            checked: owner.person?.is_pep,
                                            onChange: (newValue)=>setOwner((prevOwner)=>({
                                                        ...prevOwner,
                                                        person: {
                                                            ...prevOwner.person,
                                                            is_pep: newValue
                                                        }
                                                    })),
                                            disabled: readonly
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                            label: f("common.labels.mark-person-as-sanctioned"),
                                            checked: owner.person?.is_sanctioned,
                                            onChange: (newValue)=>setOwner((prevOwner)=>({
                                                        ...prevOwner,
                                                        person: {
                                                            ...prevOwner.person,
                                                            is_sanctioned: newValue
                                                        }
                                                    })),
                                            disabled: readonly
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                    placeholder: f("common.labels.comment"),
                    label: f("common.labels.comment"),
                    multiline: 3,
                    value: owner.comment || "",
                    onChange: (newValue)=>handleChange("comment", newValue),
                    disabled: readonly,
                    autoComplete: "off"
                })
            }),
            showArchiveConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerArchiveConfirmDefault.default), {
                customerId: customerId,
                owner: owner,
                onClose: closeArchiveConfirm,
                onAfterArchive: onArchive
            })
        ]
    });
};
exports.default = OwnerModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../helpers/display.helpers":"2q3xY","../../helpers/owners.helpers":"lynDH","../../helpers/person.helpers":"6qOIE","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useRestoreOwnerMutation":"jC2Ua","../../hooks/useSnackbar":"gQ3G9","../../utils/numbersUtils":"2RGyl","../CondensedText/CondensedText":"1FshD","../ErrorPanel/ErrorPanel":"2hHqH","../KDKTextField/KDKTextField":"b5QRp","../OwnerArchiveConfirm/OwnerArchiveConfirm":"2QKyq","../PersonForm/PersonForm":"8xv61","../TooltipWrapper/TooltipWrapper":"b5W2d","../UBOManualOverride/UBOManualOverride":"ak8eE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hvBWb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _authProvider = require("../providers/AuthProvider/AuthProvider");
const useFeatures = ()=>{
    const { user } = (0, _react.useContext)((0, _authProvider.AuthContext));
    const features = user?.features || {};
    return features;
};
exports.default = useFeatures;

},{"react":"cOWTg","../providers/AuthProvider/AuthProvider":"jnIYf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"idooG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useOpenClose = (initialValue = false)=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(initialValue);
    const open = (0, _react.useCallback)(()=>setIsOpen(true), []);
    const close = (0, _react.useCallback)(()=>setIsOpen(false), []);
    const toggle = (0, _react.useCallback)(()=>setIsOpen((preValue)=>!preValue), []);
    return [
        isOpen,
        toggle,
        close,
        open
    ];
};
exports.default = useOpenClose;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jC2Ua":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _ownersHelpers = require("../helpers/owners.helpers");
var _utilities = require("../types/utilities");
var _collectionUtils = require("../utils/collectionUtils");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useRestoreOwnerMutation = (customerId, owner)=>{
    const queryKey = (0, _utilities.getCustomerQueryKey)({
        id: customerId,
        type: "company"
    });
    const { updateQueryData } = (0, _useQueryDataDefault.default)(queryKey);
    const updateOwnerRequest = {
        ...(0, _ownersHelpers.convertOwnerToUpdateOwnerRequest)(owner),
        deleted: false
    };
    return (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updateCompanyOwner(customerId, owner.id, updateOwnerRequest), {
        onSuccess: (updateOwner)=>{
            updateQueryData((customer)=>customer.beneficial_owners = (0, _collectionUtils.updateItem)(customer.beneficial_owners, updateOwner));
        }
    });
};
exports.default = useRestoreOwnerMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../helpers/owners.helpers":"lynDH","../types/utilities":"6zLpB","../utils/collectionUtils":"gr5mc","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4laI9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCustomerDetailsQueryData", ()=>useCustomerDetailsQueryData);
var _react = require("@sentry/react");
var _reactQuery = require("@tanstack/react-query");
var _utilities = require("../types/utilities");
var _util = require("../utils/util");
function useQueryData(queryKey) {
    const queryClient = (0, _reactQuery.useQueryClient)();
    const getQueryData = ()=>queryClient.getQueryData(queryKey);
    const setQueryData = (queryData)=>queryClient.setQueryData(queryKey, queryData);
    /**
   * This method expects to receive a function that updates the queryData (which is mutable).
   * It will only be called if existing queryData exists
   */ const updateQueryData = (updater)=>{
        const queryData = getQueryData();
        if (queryData) try {
            // TODO fix refresh not working after calling setQueryData with the same queryData object
            // Temporary fix following upgrading react-query
            const newData = (0, _util.clone)(queryData);
            updater(newData);
            setQueryData(Array.isArray(newData) ? newData : {
                ...newData
            });
        } catch (e) {
            _react.captureException(e, {
                level: "warning"
            });
            console.error(`Failed to update query cache data.`, {
                queryKey,
                queryData
            });
        }
    };
    return {
        getQueryData,
        setQueryData,
        updateQueryData
    };
}
const useCustomerDetailsQueryData = (customer)=>useQueryData((0, _utilities.getCustomerQueryKey)(customer)).updateQueryData;
exports.default = useQueryData;

},{"@sentry/react":"akCRS","@tanstack/react-query":"91Vyq","../types/utilities":"6zLpB","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gQ3G9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _snackbarProvider = require("../providers/SnackbarProvider");
const useSnackbar = ()=>{
    return (0, _react.useContext)((0, _snackbarProvider.SnackbarContext));
};
exports.default = useSnackbar;

},{"react":"cOWTg","../providers/SnackbarProvider":"cSMb7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cSMb7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnackbarContext", ()=>SnackbarContext);
parcelHelpers.export(exports, "SnackbarProvider", ()=>SnackbarProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _util = require("../utils/util");
const initialSnackbar = {
    setSnackbar: (0, _util.noop),
    clearSnackbar: (0, _util.noop)
};
const SnackbarContext = /*#__PURE__*/ (0, _react.createContext)(initialSnackbar);
const SnackbarProvider = ({ children })=>{
    const [snackbar, setSnackbar] = (0, _react.useState)();
    const clearSnackbar = ()=>setSnackbar(undefined);
    const value = {
        snackbar,
        setSnackbar,
        clearSnackbar
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SnackbarContext.Provider, {
        value: value,
        children: children
    });
};

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1FshD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const CondensedText = (props)=>{
    const { italic, children, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCondensedText, {
        italic: italic,
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            color: "subdued",
            children: children
        })
    });
};
const StyledCondensedText = (0, _styledComponentsDefault.default).span`
  font-size: var(--kdk-font-size-50);
  font-weight: var(--p-font-weight-semibold);

  font-style: ${({ italic })=>italic ? "italic" : undefined};
`;
exports.default = CondensedText;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b5QRp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _durations = require("../../constants/durations");
var _useDebouncedValue = require("../../hooks/useDebouncedValue");
var _useDebouncedValueDefault = parcelHelpers.interopDefault(_useDebouncedValue);
const KDKTextField = (props)=>{
    const { debounceError, forceTouched = false, error, onBlur, onChange, onClearButtonClick, ...rest } = props;
    // if there's no error - don't wait to remove the error
    const debouncedError = (0, _useDebouncedValueDefault.default)(error, error ? (0, _durations.ERROR_DEBOUNCE_DELAY_IN_MILLISECONDS) : 0);
    const [touched, setTouched] = (0, _react.useState)(forceTouched);
    const errorToDisplay = !touched ? undefined : debounceError ? debouncedError : error;
    const handleOnBlur = (0, _react.useCallback)(()=>{
        setTouched(true);
        if (onBlur) onBlur();
    }, [
        onBlur
    ]);
    const handleOnChange = (0, _react.useCallback)((value, id)=>{
        setTouched(true);
        if (onChange) onChange(value, id);
    }, [
        onChange
    ]);
    const handleOnClearButtonClick = (0, _react.useCallback)((id)=>{
        setTouched(true);
        if (onClearButtonClick) onClearButtonClick(id);
    }, [
        onClearButtonClick
    ]);
    if (rest.verticalContent) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTextFieldWrapper, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
            error: errorToDisplay,
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onClearButtonClick: handleOnClearButtonClick,
            ...rest
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
        error: errorToDisplay,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onClearButtonClick: handleOnClearButtonClick,
        ...rest
    });
};
const StyledTextFieldWrapper = (0, _styledComponentsDefault.default).span`
  & .Polaris-TextField__Input {
    resize: none;
  }

  & .Polaris-TextField__VerticalContent {
    overflow: auto;
  }
`;
exports.default = KDKTextField;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/durations":"5sjIW","../../hooks/useDebouncedValue":"dXquE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5sjIW":[function(require,module,exports) {
// 2 seconds
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DURATION_SHORT_IN_MS", ()=>DURATION_SHORT_IN_MS);
parcelHelpers.export(exports, "DURATION_MEDIUM_IN_MS", ()=>DURATION_MEDIUM_IN_MS);
parcelHelpers.export(exports, "DURATION_VERY_LONG_IN_MS", ()=>DURATION_VERY_LONG_IN_MS);
parcelHelpers.export(exports, "ERROR_DEBOUNCE_DELAY_IN_MILLISECONDS", ()=>ERROR_DEBOUNCE_DELAY_IN_MILLISECONDS);
parcelHelpers.export(exports, "QUERY_SEARCH_DEBOUNCE_DELAY", ()=>QUERY_SEARCH_DEBOUNCE_DELAY);
parcelHelpers.export(exports, "SETTINGS_SEARCH_DEBOUNCE_DELAY", ()=>SETTINGS_SEARCH_DEBOUNCE_DELAY);
const DURATION_SHORT_IN_MS = 2000;
const DURATION_MEDIUM_IN_MS = 4000;
const DURATION_VERY_LONG_IN_MS = 600000;
const ERROR_DEBOUNCE_DELAY_IN_MILLISECONDS = 500;
const QUERY_SEARCH_DEBOUNCE_DELAY = 250; // in milliseconds
const SETTINGS_SEARCH_DEBOUNCE_DELAY = 125; // in milliseconds

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dXquE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useDebounce = require("./useDebounce");
var _useDebounceDefault = parcelHelpers.interopDefault(_useDebounce);
function useDebounceValue(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = (0, _react.useState)(value);
    (0, _useDebounceDefault.default)(()=>setDebouncedValue(value), delay, [
        value
    ]);
    return debouncedValue;
}
exports.default = useDebounceValue;

},{"react":"cOWTg","./useDebounce":"i1Evt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i1Evt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
const useDebounce = (callback, delay, dependencies)=>{
    const { reset, clear } = (0, _useTimeoutDefault.default)(callback, delay);
    (0, _react.useEffect)(reset, [
        ...dependencies || [],
        reset
    ]);
    (0, _react.useEffect)(clear, []);
};
exports.default = useDebounce;

},{"react":"cOWTg","./useTimeout":"4i6My","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2QKyq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const OwnerArchiveConfirm = (props)=>{
    const { customerId, owner, onClose, onAfterArchive } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        apiCall: ()=>(0, _apiDefault.default).deleteCompanyOwner(customerId, owner.id),
        title: f("modals.owner.confirm.archive.title"),
        description: f("modals.owner.confirm.archive.description", {
            owner: (0, _displayHelpers.getFullName)(owner.person)
        }),
        onNo: onClose,
        actionTitle: f("default.archive"),
        onSuccess: ()=>onAfterArchive(owner.id)
    });
};
exports.default = OwnerArchiveConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../api":"f6lXD","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"icP5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _util = require("../../utils/util");
var _confirm = require("../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
function ConfirmAction(props) {
    const { apiCall, onSuccess = (0, _util.noop), useSuccessToast, successTitle, onNo, isOpen, ...confirmProps } = props;
    const [showSuccessMessageToast, toggleSuccessMessageToast, closeSuccessMessageToast] = (0, _useOpenCloseDefault.default)();
    const [toastMessage, setToastMessage] = (0, _react.useState)(successTitle || "");
    // only update the toast message if it's not showing, or after it was closed
    (0, _react.useEffect)(()=>{
        if (!showSuccessMessageToast) setToastMessage(successTitle || "");
    }, [
        showSuccessMessageToast,
        successTitle
    ]);
    const mutation = (0, _reactQuery.useMutation)(apiCall, {
        onSuccess: (response)=>{
            if (useSuccessToast) toggleSuccessMessageToast();
            else onNo();
            onSuccess(response);
        }
    });
    const handleToastDismiss = ()=>{
        closeSuccessMessageToast();
        setToastMessage("");
        onNo();
    };
    const showConfirm = isOpen && (useSuccessToast ? !showSuccessMessageToast : true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
                isOpen: showConfirm,
                isActionInProgress: mutation.isLoading,
                onYes: ()=>mutation.mutate({}),
                onNo: onNo,
                error: mutation.error,
                ...confirmProps
            }),
            showSuccessMessageToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                onDismiss: handleToastDismiss,
                content: toastMessage
            })
        ]
    });
}
exports.default = ConfirmAction;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../hooks/useOpenClose":"idooG","../../utils/util":"4MniK","../Confirm/Confirm":"nqTPc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"nqTPc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../utils/util");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const Confirm = (props)=>{
    const { title, actionTitle, cancelTitle, description, descriptionAlign, error, onYes, onNo, isActionInProgress, isActionDisabled, isDestructive = true, isOpen = true, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const primaryAction = {
        content: actionTitle,
        onAction: onYes,
        destructive: isDestructive,
        loading: isActionInProgress,
        disabled: isActionDisabled
    };
    const cancelAction = {
        content: cancelTitle || f("default.cancel"),
        onAction: onNo,
        disabled: isActionInProgress
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: isOpen,
        onClose: onNo,
        title: title,
        primaryAction: primaryAction,
        secondaryActions: [
            cancelAction
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                align: "center",
                gap: "4",
                children: [
                    description && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledContent, {
                        align: descriptionAlign,
                        children: description
                    }),
                    children,
                    !(0, _util.isNil)(error) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: error,
                        actionTitle: actionTitle
                    })
                ]
            })
        })
    });
};
const StyledContent = (0, _styledComponentsDefault.default).p`
  white-space: pre-wrap;
  text-align: ${({ align })=>align || "center"};
`;
exports.default = Confirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../utils/util":"4MniK","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8xv61":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _person = require("../../constants/person");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dateUtils = require("../../utils/dateUtils");
var _stringUtils = require("../../utils/stringUtils");
var _addressForm = require("../AddressForm/AddressForm");
var _addressFormDefault = parcelHelpers.interopDefault(_addressForm);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _partialDateInput = require("../PartialDateInput/PartialDateInput");
var _partialDateInputDefault = parcelHelpers.interopDefault(_partialDateInput);
var _personContactDetails = require("./PersonContactDetails");
var _personContactDetailsDefault = parcelHelpers.interopDefault(_personContactDetails);
var _personCountries = require("./PersonCountries");
var _personCountriesDefault = parcelHelpers.interopDefault(_personCountries);
function PersonForm(props) {
    const { value, disabled, fieldsErrorMap = new Map(), birthDateIsRequired, isCreating, allowBirthYear, requiredFields = [], renderAsCards, onChange, onValidityChange, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [isNationalIdValid, setIsNationalIdValid] = (0, _react.useState)(true);
    const firstNameError = (0, _stringUtils.isEmptyString)(value.first_name) ? f("common.errors.required.first.name") : fieldsErrorMap.get("first_name");
    const lastNameError = (0, _stringUtils.isEmptyString)(value.last_name) ? f("common.errors.required.last.name") : fieldsErrorMap.get("last_name");
    // when creating a new person the full birthday should be set
    const isInvalidBirthDate = (!allowBirthYear || !(0, _stringUtils.isEmptyString)(value.birth_date)) && !(0, _dateUtils.isValidDate)(value.birth_date, (0, _person.MIN_BIRTH_DATE), (0, _person.MAX_BIRTH_DATE));
    const birthDateError = isInvalidBirthDate || !(0, _dateUtils.isValidYear)(value.birth_year, (0, _person.MIN_BIRTH_DATE), (0, _person.MAX_BIRTH_DATE)) ? f("common.errors.invalid.birth.date") : fieldsErrorMap.get("birth_date");
    const requiredCountries = isCreating ? (0, _person.REQUIRED_FIELDS_FOR_NEW_PERSON) : [];
    const isCountryOfCitizenshipValid = !isCreating || !(0, _stringUtils.isEmptyString)(value.country_of_citizenship);
    const isCountryOfResidenceValid = !isCreating || !(0, _stringUtils.isEmptyString)(value.country_of_residence);
    const isFormValid = !(0, _stringUtils.isEmptyString)(value.first_name) && !(0, _stringUtils.isEmptyString)(value.last_name) && // if date of birth is required, check if there's an error from PartialDateInput (birthDateError), otherwise
    // do not perform any validation on the date of birth input field
    (birthDateIsRequired ? (0, _stringUtils.isEmptyString)(birthDateError) : true) && isCountryOfCitizenshipValid && isCountryOfResidenceValid && isNationalIdValid;
    (0, _react.useEffect)(()=>onValidityChange(isFormValid), [
        isFormValid
    ]);
    const handleChange = (field, newValue)=>{
        const valueResult = {
            ...value,
            [field]: newValue
        };
        if (field === "country_of_residence" && (0, _stringUtils.isEmptyString)(value.national_id)) valueResult.national_id_country = newValue;
        onChange(valueResult);
    };
    const handleContactDetailsChange = (updateValue, isValid)=>{
        if (isValid !== undefined) setIsNationalIdValid(isValid);
        onChange(updateValue);
    };
    const handleBirthDateChange = (birthDate, year)=>{
        if (allowBirthYear && (0, _stringUtils.isEmptyString)(birthDate)) onChange({
            ...value,
            birth_date: undefined,
            birth_year: parseInt(year, 10)
        });
        else onChange({
            ...value,
            birth_date: birthDate,
            birth_year: parseInt(year, 10)
        });
    };
    // render form components as function in order to be able to render them
    // straight or inside Card components
    const personDetailsMarkup = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                    distribution: "fillEvenly",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                            value: value.first_name || "",
                            label: f("common.labels.first_name"),
                            onChange: (newValue)=>handleChange("first_name", newValue),
                            autoFocus: true,
                            placeholder: f("common.labels.first_name"),
                            disabled: disabled,
                            error: firstNameError,
                            maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD),
                            autoComplete: "off",
                            requiredIndicator: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                            value: value.last_name || "",
                            label: f("common.labels.last_name"),
                            onChange: (newValue)=>handleChange("last_name", newValue),
                            placeholder: f("common.labels.last_name"),
                            disabled: disabled,
                            error: lastNameError,
                            maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD),
                            autoComplete: "off",
                            requiredIndicator: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _partialDateInputDefault.default), {
                            dateValue: (0, _displayHelpers.getBirthDate)(value),
                            label: f("common.labels.birth_date"),
                            required: birthDateIsRequired,
                            disabled: disabled,
                            error: birthDateError,
                            onChange: handleBirthDateChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressFormDefault.default), {
                    value: value.address,
                    disabled: disabled,
                    onChange: (address)=>handleChange("address", address),
                    requiredFields: requiredFields
                })
            ]
        });
    const personCountriesMarkup = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personCountriesDefault.default), {
                    value: value,
                    disabled: disabled,
                    requiredFields: requiredCountries,
                    fieldsErrorMap: fieldsErrorMap,
                    onChange: handleChange
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personContactDetailsDefault.default), {
                    value: value,
                    disabled: disabled,
                    onChange: handleContactDetailsChange,
                    fieldsErrorMap: fieldsErrorMap
                }),
                children
            ]
        });
    if (renderAsCards) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: personDetailsMarkup()
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: personCountriesMarkup()
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            personDetailsMarkup(),
            personCountriesMarkup()
        ]
    });
}
exports.default = PersonForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/person":"dpk3a","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../utils/dateUtils":"euvUV","../../utils/stringUtils":"4gVdA","../AddressForm/AddressForm":"1P2a8","../KDKTextField/KDKTextField":"b5QRp","../PartialDateInput/PartialDateInput":"ggSeE","./PersonContactDetails":"jaJSI","./PersonCountries":"aOMk1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1P2a8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _countries = require("../../constants/countries");
var _integrations = require("../../constants/integrations");
var _person = require("../../constants/person");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _autoCompleteTextField = require("../AutoCompleteTextField/AutoCompleteTextField");
var _autoCompleteTextFieldDefault = parcelHelpers.interopDefault(_autoCompleteTextField);
var _countrySelect = require("../CountrySelect/CountrySelect");
var _countrySelectDefault = parcelHelpers.interopDefault(_countrySelect);
const AddressForm = (props)=>{
    const { value: address, disabled = false, requiredFields = [], onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const isQueryEnabled = Boolean(address?.country && (0, _integrations.SUPPORTED_COUNTRIES).includes(address?.country) && !(0, _stringUtils.isEmptyString)(address.postal_code));
    const { data, isLoading } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).POSTAL_CODES_SUGGESTIONS,
        address?.country,
        address?.postal_code
    ], ()=>(0, _apiDefault.default).lookupPostalCode(address?.country || (0, _countries.DEFAULT_COUNTRY), address?.postal_code || ""), {
        keepPreviousData: true,
        enabled: isQueryEnabled,
        staleTime: (0, _queriesKeys.STALE_TIME),
        retry: false
    });
    const suggestions = data?.postal_codes?.map((code)=>({
            value: code.postal_code,
            label: code.postal_code
        }));
    const onFieldChanged = (field, value)=>{
        // set new value as api.Address in order to avoid TypeScript error regarding undefined value in country field
        onChange({
            ...address,
            [field]: value
        });
    };
    const autofillAddress = (postalCode)=>{
        const suggestedPostalCode = data?.postal_codes?.find((code)=>code.postal_code === postalCode);
        if (suggestedPostalCode) {
            const city = suggestedPostalCode.city;
            const county = suggestedPostalCode.county;
            onChange({
                ...address,
                city,
                county
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                distribution: "fillEvenly",
                alignment: "trailing",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        value: address?.address_line_1 || "",
                        onChange: (newValue)=>onFieldChanged("address_line_1", newValue),
                        label: f("common.labels.address"),
                        placeholder: f("common.address.addressline1"),
                        disabled: disabled,
                        autoComplete: "off",
                        maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD),
                        requiredIndicator: requiredFields.includes("address_line_1")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        value: address?.address_line_2 || "",
                        onChange: (newValue)=>onFieldChanged("address_line_2", newValue),
                        label: f("common.address.addressline2"),
                        labelHidden: true,
                        placeholder: f("common.address.addressline2"),
                        disabled: disabled,
                        autoComplete: "off",
                        maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD),
                        requiredIndicator: requiredFields?.includes("address_line_2")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoCompleteTextFieldDefault.default), {
                        value: address?.postal_code || "",
                        onChange: (newValue)=>onFieldChanged("postal_code", newValue),
                        label: f("common.address.postal.code"),
                        placeholder: f("common.address.postal.code"),
                        disabled: disabled,
                        autoComplete: "off",
                        maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD),
                        requiredIndicator: requiredFields?.includes("postal_code"),
                        isLoading: isQueryEnabled && isLoading,
                        suggestions: suggestions,
                        onBlur: ()=>autofillAddress(address?.postal_code),
                        onSelection: (value)=>autofillAddress(value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout).Group, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        value: address?.city || "",
                        onChange: (newValue)=>onFieldChanged("city", newValue),
                        label: f("common.address.city"),
                        placeholder: f("common.address.city"),
                        disabled: disabled,
                        autoComplete: "off",
                        maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD),
                        requiredIndicator: requiredFields?.includes("city")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        value: address?.county || "",
                        onChange: (newValue)=>onFieldChanged("county", newValue),
                        label: f("common.address.county"),
                        placeholder: f("common.address.county"),
                        disabled: disabled,
                        autoComplete: "off",
                        maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD),
                        requiredIndicator: requiredFields?.includes("county")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countrySelectDefault.default), {
                        value: address?.country,
                        label: f("common.address.country"),
                        onSelect: (newValue)=>onFieldChanged("country", newValue || ""),
                        disabled: disabled,
                        requiredIndicator: requiredFields.includes("country"),
                        clearButton: false
                    })
                ]
            })
        ]
    });
};
exports.default = AddressForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/countries":"2hBLK","../../constants/integrations":"kD3Sk","../../constants/person":"dpk3a","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../AutoCompleteTextField/AutoCompleteTextField":"d4RYG","../CountrySelect/CountrySelect":"dlvog","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2hBLK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_COUNTRY", ()=>DEFAULT_COUNTRY);
const DEFAULT_COUNTRY = "NO";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kD3Sk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS", ()=>COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS);
parcelHelpers.export(exports, "SUPPORTED_COUNTRIES", ()=>SUPPORTED_COUNTRIES);
var _countries = require("./countries");
const COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS = [
    (0, _countries.DEFAULT_COUNTRY)
];
const SUPPORTED_COUNTRIES = [
    "NO",
    "DK",
    "SE",
    "FI",
    "NL",
    "DE",
    "US",
    "BE",
    "FO",
    "GL",
    "IS",
    "SJ"
];

},{"./countries":"2hBLK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d4RYG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _collectionUtils = require("../../utils/collectionUtils");
var _util = require("../../utils/util");
const AutoCompleteTextField = (props)=>{
    const { isLoading, suggestions = [], id = (0, _util.uniqueId)("AutoCompleteTextField"), value, onChange, onSelection, ...textFieldProps } = props;
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)([]);
    const [inputValue, setInputValue] = (0, _react.useState)(value);
    const handleChange = (text)=>{
        setInputValue(text);
        if (onChange) onChange(text, id);
    };
    const updateText = async (value)=>{
        handleChange(value);
    };
    const updateSelection = (selected)=>{
        const selectedTexts = selected.map((selectedItem)=>suggestions.find((option)=>option.value.match(selectedItem))?.label);
        const selectedValue = (0, _collectionUtils.first)(selectedTexts) || "";
        setSelectedOptions(selected);
        handleChange(selectedValue);
        if (onSelection) requestAnimationFrame(()=>onSelection(selectedValue));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete), {
        options: suggestions,
        selected: selectedOptions,
        onSelect: updateSelection,
        loading: isLoading,
        textField: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete).TextField, {
            onChange: updateText,
            value: inputValue,
            id: id,
            ...textFieldProps
        })
    });
};
exports.default = AutoCompleteTextField;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../utils/collectionUtils":"gr5mc","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dlvog":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _globeSvg = require("../../../assets/icons/globe.svg");
var _globeSvgDefault = parcelHelpers.interopDefault(_globeSvg);
var _useCountries = require("../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _stringUtils = require("../../utils/stringUtils");
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const CountrySelect = (props)=>{
    const { value, label, autoComplete, renderAsOptionsList, placeholder, onClearButtonClick, excludedCountries, onSelect, ...textFieldProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getCountriesOptions, getCountryName } = (0, _useCountriesDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const deselectedOptions = (0, _react.useMemo)(()=>getCountriesOptions(excludedCountries).map((option)=>({
                ...option,
                media: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                    country: option.value,
                    hideLabel: true
                })
            })), [
        excludedCountries,
        language
    ]);
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)(value ? [
        value
    ] : []);
    const [inputValue, setInputValue] = (0, _react.useState)(value ? getCountryName(value) : "");
    const [options, setOptions] = (0, _react.useState)(deselectedOptions);
    const updateText = (0, _react.useCallback)((value)=>{
        setInputValue(value);
        if (value === "") {
            setOptions(deselectedOptions);
            return;
        }
        const resultOptions = deselectedOptions.filter((option)=>option.label.match((0, _stringUtils.filterRegEx)(value)));
        setOptions(resultOptions);
    }, [
        deselectedOptions
    ]);
    const updateSelection = (selected)=>{
        setSelectedOptions(selected);
        onSelect(selected[0]);
        setInputValue(getCountryName(selected[0] || ""));
    };
    const clearInput = ()=>{
        updateText("");
        onSelect();
    };
    const TextFieldComponent = renderAsOptionsList ? (0, _polaris.TextField) : (0, _polaris.Autocomplete).TextField;
    const textField = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextFieldComponent, {
        onChange: updateText,
        ...textFieldProps,
        label: label || f("common.labels.country"),
        value: inputValue,
        prefix: selectedOptions.length === 0 || (0, _stringUtils.isEmptyString)(inputValue) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _globeSvgDefault.default)
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
            country: selectedOptions[0],
            hideLabel: true
        }),
        autoComplete: autoComplete || "off",
        placeholder: placeholder || f("common.country-select.choose-country-option"),
        clearButton: renderAsOptionsList ? false : !textFieldProps.disabled && textFieldProps.clearButton !== false,
        onClearButtonClick: onClearButtonClick || clearInput,
        onBlur: ()=>setInputValue(value ? getCountryName(value) : "")
    });
    return renderAsOptionsList ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            subdued: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledWrapper, {
                children: [
                    textField,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.OptionList), {
                        options: options,
                        selected: selectedOptions,
                        onChange: updateSelection
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete), {
        options: options,
        selected: selectedOptions,
        onSelect: updateSelection,
        textField: textField
    });
};
const StyledWrapper = (0, _styledComponentsDefault.default).div`
  position: relative;
  min-width: 30ch;
  max-width: 30ch;

  & > .Polaris-Labelled--hidden {
    position: sticky;
    top: 0;
    z-index: 10;
    background: var(--p-surface-subdued);
  }
`;
exports.default = CountrySelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/globe.svg":"kv6Wl","../../hooks/useCountries":"azDTp","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useLanguage":"2W6IE","../../utils/stringUtils":"4gVdA","../Country/Country":"eeWSc","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kv6Wl":[function(require,module,exports) {
module.exports = require("445954812f8e9ac2").getBundleURL("kEMsi") + "globe.b41623af.svg";

},{"445954812f8e9ac2":"75UoR"}],"azDTp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactIntl = require("react-intl");
var _unicode = require("country-flag-icons/unicode");
var _unicodeDefault = parcelHelpers.interopDefault(_unicode);
var _countriesHelpers = require("../helpers/countries.helpers");
var _countriesHelpersDefault = parcelHelpers.interopDefault(_countriesHelpers);
var _personHelpers = require("../helpers/person.helpers");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("./useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useGetCountryRiskAndTaxHavens = require("./useGetCountryRiskAndTaxHavens");
var _useGetCountryRiskAndTaxHavensDefault = parcelHelpers.interopDefault(_useGetCountryRiskAndTaxHavens);
const useCountries = ()=>{
    const intl = (0, _reactIntl.useIntl)();
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const { getCountryRiskAndTaxHavenList } = (0, _useGetCountryRiskAndTaxHavensDefault.default)();
    /**
   * Gets country name (in the current locale) given a country code
   * If no country is found for the country code it returns the country code
   */ const getCountryName = (countryCode, withFlag)=>{
        const country = localeCountries.find((country)=>country.code === countryCode);
        if (!country) return countryCode;
        return withFlag ? `${(0, _unicodeDefault.default)(countryCode)} ${country.name}` : country.name;
    };
    const localeCountries = (0, _react.useMemo)(()=>{
        return (0, _countriesHelpersDefault.default)[intl.locale];
    }, [
        intl.locale
    ]);
    const allCountriesOptions = (0, _react.useMemo)(()=>{
        const selectOptions = localeCountries.map((country)=>({
                label: getCountryName(country.code),
                value: country.code,
                disabled: false
            }));
        return selectOptions;
    }, [
        localeCountries
    ]);
    const getCountriesOptions = (excludedCountries)=>{
        if (!excludedCountries) return allCountriesOptions;
        return allCountriesOptions.filter((countryOption)=>typeof countryOption === "string" ? !excludedCountries.includes(countryOption) : !excludedCountries.includes(countryOption.value));
    };
    const getCountryRiskDescription = (country)=>country ? f("risk-indicators.geographic-risk.title", {
            country: getCountryName(country, true),
            listNames: formatMultipleNames(getCountryRiskAndTaxHavenList(country).map((listName)=>f(`high-risk-countries.list.${listName}`)))
        }) : undefined;
    const isHighRiskCountry = (country)=>getCountryRiskAndTaxHavenList(country).length > 0;
    const hasHighRiskCountries = (person)=>{
        const countries = (0, _personHelpers.getPersonCountries)(person);
        const highRiskCountriesSet = new Set([
            ...countries.values()
        ].flat().filter(isHighRiskCountry));
        return highRiskCountriesSet.size > 0;
    };
    return {
        getCountriesOptions,
        getCountryName,
        getCountryRiskDescription,
        isHighRiskCountry,
        hasHighRiskCountries
    };
};
exports.default = useCountries;

},{"react":"cOWTg","react-intl":"8H1wU","country-flag-icons/unicode":"4CF3d","../helpers/countries.helpers":"1PV4o","../helpers/person.helpers":"6qOIE","./useFormatMessage":"8Y8fq","./useFormatMultipleNames":"gogmY","./useGetCountryRiskAndTaxHavens":"4cjEp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1PV4o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchForCountryCode", ()=>searchForCountryCode);
var _i18NIsoCountries = require("i18n-iso-countries");
var _enJson = require("i18n-iso-countries/langs/en.json");
var _enJsonDefault = parcelHelpers.interopDefault(_enJson);
var _nbJson = require("i18n-iso-countries/langs/nb.json");
var _nbJsonDefault = parcelHelpers.interopDefault(_nbJson);
var _languages = require("../constants/languages");
var _collectionUtils = require("../utils/collectionUtils");
var _stringUtils = require("../utils/stringUtils");
const convertLocaleCountries = (countries)=>Object.keys(countries).map((key)=>({
            name: Array.isArray(countries[key]) ? countries[key].join(",") : countries[key],
            code: key
        }));
const COUNTRIES = {
    // this has to be repeated for all locales we want to be supported
    nb: convertLocaleCountries((0, _nbJsonDefault.default).countries).sort((0, _collectionUtils.sortByName)),
    en: convertLocaleCountries((0, _enJsonDefault.default).countries).sort((0, _collectionUtils.sortByName))
};
const searchForCountryCode = (countryName, language)=>{
    if (!countryName || (0, _stringUtils.isEmptyString)(countryName)) return undefined;
    const lang = language || (0, _languages.DEFAULT_LANGUAGE);
    if (lang === (0, _languages.DEFAULT_LANGUAGE)) (0, _i18NIsoCountries.registerLocale)((0, _nbJsonDefault.default));
    else if (lang === "en") (0, _i18NIsoCountries.registerLocale)((0, _enJsonDefault.default));
    return (0, _i18NIsoCountries.getAlpha2Code)(countryName, lang);
};
exports.default = COUNTRIES;

},{"i18n-iso-countries":"lDuP1","i18n-iso-countries/langs/en.json":"4eqSk","i18n-iso-countries/langs/nb.json":"a1iOF","../constants/languages":"ecnY7","../utils/collectionUtils":"gr5mc","../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lDuP1":[function(require,module,exports) {
"use strict";
const codes = require("f18765f3c606570b");
const supportedLocales = require("4ca5c28f34993e3d");
const removeDiacritics = require("f9eab4b480632e77").remove;
const registeredLocales = {};
/*
 * All codes map to ISO 3166-1 alpha-2
 */ const alpha2 = {}, alpha3 = {}, numeric = {}, invertedNumeric = {};
codes.forEach(function(codeInformation) {
    const s = codeInformation;
    alpha2[s[0]] = s[1];
    alpha3[s[1]] = s[0];
    numeric[s[2]] = s[0];
    invertedNumeric[s[0]] = s[2];
});
/**
 * @private
 * @param {number} code
 */ function formatNumericCode(code) {
    return String("000" + (code ? code : "")).slice(-3);
}
/**
 * @private
 * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
 * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
 * https://eslint.org/docs/rules/no-prototype-builtins
 */ function hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
/**
 * @private
 * Pass localeList through a filter and return a newLocaleList obj
 * with the same structure of the old localeList.
 *
 * @param {LocalizedCountryNames} localeList  Local List in raw
 * @param {Function} filter    callback to set filter rule
 * @return {String | String[]} new filtered Local List
 */ function localeFilter(localeList, filter) {
    return Object.keys(localeList).reduce(function(newLocaleList, alpha2) {
        const nameList = localeList[alpha2];
        newLocaleList[alpha2] = filter(nameList, alpha2);
        return newLocaleList;
    }, {});
}
/**
 * @private
 * Preserve for getName & getNames
 *
 * @param {GetNameOptions.select} type all | official | alias
 * @param countryNameList  string array of country's
 *                         official name and alias
 * @return {String | String[]} of a country name
 */ function filterNameBy(type, countryNameList) {
    switch(type){
        case "official":
            return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
        case "all":
            return typeof countryNameList === "string" ? [
                countryNameList
            ] : countryNameList;
        case "alias":
            return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
        default:
            throw new TypeError("LocaleNameType must be one of these: all, official, alias!");
    }
}
/**
 * Register countries in browsers' environment:
 * @param {object} localeData
 * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
 * @return void
 */ exports.registerLocale = function(localeData) {
    if (!localeData.locale) throw new TypeError("Missing localeData.locale");
    if (!localeData.countries) throw new TypeError("Missing localeData.countries");
    registeredLocales[localeData.locale] = localeData.countries;
};
/*
 * @param code Alpha-3 code
 * @return Alpha-2 code or undefined
 */ function alpha3ToAlpha2(code) {
    return alpha3[code];
}
exports.alpha3ToAlpha2 = alpha3ToAlpha2;
/*
 * @param code Alpha-2 code
 * @return Alpha-3 code or undefined
 */ function alpha2ToAlpha3(code) {
    return alpha2[code];
}
exports.alpha2ToAlpha3 = alpha2ToAlpha3;
/*
 * @param code Alpha-3 code
 * @return Numeric code or undefined
 */ function alpha3ToNumeric(code) {
    return invertedNumeric[alpha3ToAlpha2(code)];
}
exports.alpha3ToNumeric = alpha3ToNumeric;
/*
 * @param code Alpha-2 code
 * @return Numeric code or undefined
 */ function alpha2ToNumeric(code) {
    return invertedNumeric[code];
}
exports.alpha2ToNumeric = alpha2ToNumeric;
/*
 * @param code Numeric code
 * @return Alpha-3 code or undefined
 */ function numericToAlpha3(code) {
    const padded = formatNumericCode(code);
    return alpha2ToAlpha3(numeric[padded]);
}
exports.numericToAlpha3 = numericToAlpha3;
/*
 * @param code Numeric code
 * @return Alpha-2 code or undefined
 */ function numericToAlpha2(code) {
    const padded = formatNumericCode(code);
    return numeric[padded];
}
exports.numericToAlpha2 = numericToAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-3
 */ function toAlpha3(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return numericToAlpha3(code);
        if (code.length === 2) return alpha2ToAlpha3(code.toUpperCase());
        if (code.length === 3) return code.toUpperCase();
    }
    if (typeof code === "number") return numericToAlpha3(code);
    return undefined;
}
exports.toAlpha3 = toAlpha3;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-2
 */ function toAlpha2(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return numericToAlpha2(code);
        if (code.length === 2) return code.toUpperCase();
        if (code.length === 3) return alpha3ToAlpha2(code.toUpperCase());
    }
    if (typeof code === "number") return numericToAlpha2(code);
    return undefined;
}
exports.toAlpha2 = toAlpha2;
/**
 * @param {string | number | Alpha2Code | Alpha3Code} code
 * @param {String} lang          language for country name
 * @param {GetNameOptions} options
 * @return {String | String[] | undefined}  name
 */ exports.getName = function(code, lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    try {
        const codeMaps = registeredLocales[lang.toLowerCase()];
        const nameList = codeMaps[toAlpha2(code)];
        return filterNameBy(options.select, nameList);
    } catch (err) {
        return undefined;
    }
};
/**
 * @param {String} lang             language for country names
 * @param {GetNameOptions} options   getNames Options
 * @return {LocalizedCountryNames}  country code
 *                                  mapped to county name
 */ exports.getNames = function(lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    const localeList = registeredLocales[lang.toLowerCase()];
    if (localeList === undefined) return {};
    return localeFilter(localeList, function(nameList) {
        return filterNameBy(options.select, nameList);
    });
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ exports.getAlpha2Code = function(name, lang) {
    const normalizeString = (string)=>string.toLowerCase();
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ exports.getSimpleAlpha2Code = function(name, lang) {
    const normalizeString = (string)=>removeDiacritics(string.toLowerCase());
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
/*
 * @return Object of alpha-2 codes mapped to alpha-3 codes
 */ exports.getAlpha2Codes = function() {
    return alpha2;
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ exports.getAlpha3Code = function(name, lang) {
    const alpha2 = exports.getAlpha2Code(name, lang);
    if (alpha2) return exports.toAlpha3(alpha2);
    else return undefined;
};
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ exports.getSimpleAlpha3Code = function(name, lang) {
    const alpha2 = exports.getSimpleAlpha2Code(name, lang);
    if (alpha2) return exports.toAlpha3(alpha2);
    else return undefined;
};
/*
 * @return Object of alpha-3 codes mapped to alpha-2 codes
 */ exports.getAlpha3Codes = function() {
    return alpha3;
};
/*
 * @return Object of numeric codes mapped to alpha-2 codes
 */ exports.getNumericCodes = function() {
    return numeric;
};
/*
 * @return Array of registered languages
 */ exports.langs = function() {
    return Object.keys(registeredLocales);
};
/*
 * @return Array of supported languages
 */ exports.getSupportedLanguages = function() {
    return supportedLocales;
};
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return Boolean
 */ exports.isValid = function(code) {
    if (!code) return false;
    const coerced = code.toString().toUpperCase();
    return hasOwnProperty(alpha3, coerced) || hasOwnProperty(alpha2, coerced) || hasOwnProperty(numeric, coerced);
};

},{"f18765f3c606570b":"6XwMx","4ca5c28f34993e3d":"3QtdL","f9eab4b480632e77":"7pNHF"}],"6XwMx":[function(require,module,exports) {
module.exports = JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKX","983","ISO 3166-2:XK"]]');

},{}],"3QtdL":[function(require,module,exports) {
module.exports = JSON.parse('["br","cy","dv","sw","eu","af","am","ha","ku","ml","no","ps","sd","so","sq","ta","tg","tt","ug","ur","vi","ar","az","be","bg","bn","bs","ca","cs","da","de","el","en","es","et","fa","fi","fr","gl","he","hi","hr","hu","hy","id","is","it","ja","ka","kk","km","ko","ky","lt","lv","mk","mn","mr","ms","nb","nl","nn","pl","pt","ro","ru","sk","sl","sr","sv","th","tr","uk","uz","zh"]');

},{}],"7pNHF":[function(require,module,exports) {
exports.remove = removeDiacritics;
var replacementList = [
    {
        base: " ",
        chars: "\xa0"
    },
    {
        base: "0",
        chars: "\u07C0"
    },
    {
        base: "A",
        chars: "\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        chars: "\uA732"
    },
    {
        base: "AE",
        chars: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        chars: "\uA734"
    },
    {
        base: "AU",
        chars: "\uA736"
    },
    {
        base: "AV",
        chars: "\uA738\uA73A"
    },
    {
        base: "AY",
        chars: "\uA73C"
    },
    {
        base: "B",
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
    },
    {
        base: "C",
        chars: "\u24B8\uFF23\uA73E\u1E08\u0106C\u0108\u010A\u010C\xc7\u0187\u023B"
    },
    {
        base: "D",
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
    },
    {
        base: "Dh",
        chars: "\xd0"
    },
    {
        base: "DZ",
        chars: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        chars: "\u01F2\u01C5"
    },
    {
        base: "E",
        chars: "\u025B\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
    },
    {
        base: "F",
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
    },
    {
        base: "H",
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        chars: "\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
    },
    {
        base: "K",
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        chars: "\u01C7"
    },
    {
        base: "Lj",
        chars: "\u01C8"
    },
    {
        base: "M",
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
    },
    {
        base: "N",
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
    },
    {
        base: "NJ",
        chars: "\u01CA"
    },
    {
        base: "Nj",
        chars: "\u01CB"
    },
    {
        base: "O",
        chars: "\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OE",
        chars: "\u0152"
    },
    {
        base: "OI",
        chars: "\u01A2"
    },
    {
        base: "OO",
        chars: "\uA74E"
    },
    {
        base: "OU",
        chars: "\u0222"
    },
    {
        base: "P",
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "Th",
        chars: "\xde"
    },
    {
        base: "TZ",
        chars: "\uA728"
    },
    {
        base: "U",
        chars: "\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        chars: "\uA760"
    },
    {
        base: "W",
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        chars: "\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        chars: "\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
    },
    {
        base: "aa",
        chars: "\uA733"
    },
    {
        base: "ae",
        chars: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        chars: "\uA735"
    },
    {
        base: "au",
        chars: "\uA737"
    },
    {
        base: "av",
        chars: "\uA739\uA73B"
    },
    {
        base: "ay",
        chars: "\uA73D"
    },
    {
        base: "b",
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
    },
    {
        base: "c",
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
    },
    {
        base: "dh",
        chars: "\xf0"
    },
    {
        base: "dz",
        chars: "\u01F3\u01C6"
    },
    {
        base: "e",
        chars: "\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
    },
    {
        base: "f",
        chars: "\u24D5\uFF46\u1E1F\u0192"
    },
    {
        base: "ff",
        chars: "\uFB00"
    },
    {
        base: "fi",
        chars: "\uFB01"
    },
    {
        base: "fl",
        chars: "\uFB02"
    },
    {
        base: "ffi",
        chars: "\uFB03"
    },
    {
        base: "ffl",
        chars: "\uFB04"
    },
    {
        base: "g",
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
    },
    {
        base: "h",
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        chars: "\u0195"
    },
    {
        base: "i",
        chars: "\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
    },
    {
        base: "lj",
        chars: "\u01C9"
    },
    {
        base: "m",
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        chars: "\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
    },
    {
        base: "nj",
        chars: "\u01CC"
    },
    {
        base: "o",
        chars: "\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
    },
    {
        base: "oe",
        chars: "\u0153"
    },
    {
        base: "oi",
        chars: "\u01A3"
    },
    {
        base: "oo",
        chars: "\uA74F"
    },
    {
        base: "ou",
        chars: "\u0223"
    },
    {
        base: "p",
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
    },
    {
        base: "q",
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
    },
    {
        base: "ss",
        chars: "\xdf"
    },
    {
        base: "t",
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "th",
        chars: "\xfe"
    },
    {
        base: "tz",
        chars: "\uA729"
    },
    {
        base: "u",
        chars: "\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        chars: "\uA761"
    },
    {
        base: "w",
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        chars: "\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var diacriticsMap = {};
for(var i = 0; i < replacementList.length; i += 1){
    var chars = replacementList[i].chars;
    for(var j = 0; j < chars.length; j += 1)diacriticsMap[chars[j]] = replacementList[i].base;
}
function removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return diacriticsMap[c] || c;
    });
}
exports.replacementList = replacementList;
exports.diacriticsMap = diacriticsMap;

},{}],"4eqSk":[function(require,module,exports) {
module.exports = JSON.parse('{"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":["People\'s Republic of China","China"],"CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":["Republic of the Congo","Congo"],"CD":["Democratic Republic of the Congo","Congo"],"CK":"Cook Islands","CR":"Costa Rica","CI":["Cote d\'Ivoire","C\xf4te d\'Ivoire","Ivory Coast"],"HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":["Czech Republic","Czechia"],"DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":["Republic of The Gambia","The Gambia","Gambia"],"GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":["Islamic Republic of Iran","Iran"],"IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":["South Korea","Korea, Republic of","Republic of Korea"],"KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":["The Republic of North Macedonia","North Macedonia"],"MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":["State of Palestine","Palestine"],"PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":["Pitcairn","Pitcairn Islands"],"PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":["Taiwan, Province of China","Taiwan"],"TJ":"Tajikistan","TZ":["United Republic of Tanzania","Tanzania"],"TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":["T\xfcrkiye","Turkey"],"TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","United States","USA","U.S.A.","US","U.S."],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":["\xc5land Islands","Aland Islands"],"BQ":"Bonaire, Sint Eustatius and Saba","CW":"Cura\xe7ao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barth\xe9lemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}');

},{}],"a1iOF":[function(require,module,exports) {
module.exports = JSON.parse('{"locale":"nb","countries":{"AD":"Andorra","AE":"De forente arabiske emirater","AF":"Afghanistan","AG":"Antigua og Barbuda","AI":"Anguilla","AL":"Albania","AM":"Armenia","AO":"Angola","AQ":"Antarktis","AR":"Argentina","AS":"Amerikansk Samoa","AT":"\xd8sterrike","AU":"Australia","AW":"Aruba","AX":"\xc5land","AZ":"Aserbajdsjan","BA":"Bosnia-Hercegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgia","BF":"Burkina Faso","BG":"Bulgaria","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint-Barth\xe9lemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BQ":"Karibisk Nederland","BR":"Brasil","BS":"Bahamas","BT":"Bhutan","BV":"Bouvet\xf8ya","BW":"Botswana","BY":"Hviterussland","BZ":"Belize","CA":"Canada","CC":"Kokos\xf8yene","CD":"Kongo","CF":"Den sentralafrikanske republikk","CG":"Kongo-Brazzaville","CH":"Sveits","CI":"Elfenbenskysten","CK":"Cook\xf8yene","CL":"Chile","CM":"Kamerun","CN":"Kina","CO":"Colombia","CR":"Costa Rica","CU":"Cuba","CV":"Kapp Verde","CW":"Cura\xe7ao","CX":"Christmas\xf8ya","CY":"Kypros","CZ":"Tsjekkia","DE":"Tyskland","DJ":"Djibouti","DK":"Danmark","DM":"Dominica","DO":"Den dominikanske republikk","DZ":"Algerie","EC":"Ecuador","EE":"Estland","EG":"Egypt","EH":"Vest-Sahara","ER":"Eritrea","ES":"Spania","ET":"Etiopia","FI":"Finland","FJ":"Fiji","FK":"Falklands\xf8yene","FM":"Mikronesiaf\xf8derasjonen","FO":"F\xe6r\xf8yene","FR":"Frankrike","GA":"Gabon","GB":"Storbritannia","GD":"Grenada","GE":"Georgia","GF":"Fransk Guyana","GG":"Guernsey","GH":"Ghana","GI":"Gibraltar","GL":"Gr\xf8nland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Ekvatorial-Guinea","GR":"Hellas","GS":"S\xf8r-Georgia og de s\xf8re Sandwich\xf8yene","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hongkong","HM":"Heard- og McDonald-\xf8yene","HN":"Honduras","HR":"Kroatia","HT":"Haiti","HU":"Ungarn","ID":"Indonesia","IE":"Irland","IL":"Israel","IM":"Man","IN":"India","IO":"Britisk territorium i Indiahavet","IQ":"Irak","IR":"Iran","IS":"Island","IT":"Italia","JE":"Jersey","JM":"Jamaica","JO":"Jordan","JP":"Japan","KE":"Kenya","KG":"Kirgisistan","KH":"Kambodsja","KI":"Kiribati","KM":"Komorene","KN":"Saint Kitts og Nevis","KP":"Nord-Korea","KR":"S\xf8r-Korea","KW":"Kuwait","KY":"Cayman\xf8yene","KZ":"Kasakhstan","LA":"Laos","LB":"Libanon","LC":"Saint Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Litauen","LU":"Luxembourg","LV":"Latvia","LY":"Libya","MA":"Marokko","MC":"Monaco","MD":"Moldova","ME":"Montenegro","MF":"Saint-Martin","MG":"Madagaskar","MH":"Marshall\xf8yene","MK":"Nord-Makedonia","ML":"Mali","MM":"Myanmar (Burma)","MN":"Mongolia","MO":"Macao","MP":"Nord-Marianene","MQ":"Martinique","MR":"Mauritania","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldivene","MW":"Malawi","MX":"Mexico","MY":"Malaysia","MZ":"Mosambik","NA":"Namibia","NC":"Ny-Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NI":"Nicaragua","NL":"Nederland","NO":"Norge","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"New Zealand","OM":"Oman","PA":"Panama","PE":"Peru","PF":"Fransk Polynesia","PG":"Papua Ny-Guinea","PH":"Filippinene","PK":"Pakistan","PL":"Polen","PM":"Saint-Pierre-et-Miquelon","PN":"Pitcairn","PR":"Puerto Rico","PS":"De okkuperte palestinske omr\xe5dene","PT":"Portugal","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"R\xe9union","RO":"Romania","RS":"Serbia","RU":"Russland","RW":"Rwanda","SA":"Saudi-Arabia","SB":"Salomon\xf8yene","SC":"Seychellene","SD":"Sudan","SE":"Sverige","SG":"Singapore","SH":"St. Helena","SI":"Slovenia","SJ":"Svalbard og Jan Mayen","SK":"Slovakia","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Surinam","SS":"S\xf8r-Sudan","ST":"S\xe3o Tom\xe9 og Pr\xedncipe","SV":"El Salvador","SX":"Sint Maarten (Nederlandsk del)","SY":"Syria","SZ":"Eswatini","TC":"Turks- og Caicos\xf8yene","TD":"Tsjad","TF":"S\xf8re franske territorier","TG":"Togo","TH":"Thailand","TJ":"Tadsjikistan","TK":"Tokelau","TL":"\xd8st-Timor","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TR":"Tyrkia","TT":"Trinidad og Tobago","TV":"Tuvalu","TW":"Taiwan","TZ":"Tanzania","UA":"Ukraina","UG":"Uganda","UM":"USA, mindre, utenforliggende \xf8yer","US":"USA","UY":"Uruguay","UZ":"Usbekistan","VA":"Vatikanstaten","VC":"Saint Vincent og Grenadinene","VE":"Venezuela","VG":"Jomfru\xf8yene (Britisk)","VI":"Jomfru\xf8yene (USA)","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis- og Futuna\xf8yene","WS":"Samoa","YE":"Jemen","YT":"Mayotte","ZA":"S\xf8r-Afrika","ZM":"Zambia","ZW":"Zimbabwe","XK":"Kosovo"}}');

},{}],"gogmY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
/**
 * This hook return a function that takes a list of strings (usually names from the same type)
 * and returns a single string which is a join of these strings with commas and "and" keyword before the last name
 * It also determined how many of the given strings will be displayed fully and how many will be counted as "others".
 *
 * Example:
 *
 * const formatMultipleNames = useFormatMultipleNames();
 *
 * const namesLabel = formatMultipleNames(["John"]); // namesLabel = "John"
 * const namesLabel = formatMultipleNames(["John", "Paul"]); // namesLabel = "John and Paul"
 * const namesLabel = formatMultipleNames(["John", "Paul", "George"]); // namesLabel = "John, Paul and George"
 * const namesLabel = formatMultipleNames(["John", "Paul", "George", "Ringo"]); // namesLabel = "John, Paul, George and Ringo"
 * const namesLabel = formatMultipleNames(["John", "Paul", "George", "Ringo", "Pete"]); // namesLabel = "John, Paul, George and 2 others"
 * const namesLabel = formatMultipleNames(["John", "Paul", "George", "Ringo", "Pete"], 2); // namesLabel = "John, Paul and 3 others"
 *
 * cutoff - the number of names to display fully before counting the rest of the names.
 *
 */ const useFormatMultipleNames = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return (names, cutoff = 3)=>{
        if (!names || names.length === 0) return "";
        if (names.length === 1) return names[0];
        if (names.length - cutoff <= 1 || cutoff === 0) {
            const fullnames = names.slice(0, names.length - 1).join(", ");
            const lastname = names[names.length - 1];
            return f("common.multiple-names.short", {
                fullnames,
                lastname
            });
        }
        const fullnames = names.slice(0, cutoff).join(", ");
        const count = names.length - cutoff;
        return f("common.multiple-names.full", {
            fullnames,
            count
        });
    };
};
exports.default = useFormatMultipleNames;

},{"./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4cjEp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
const useGetCountryRiskAndTaxHavens = ()=>{
    const getCountryRiskAndTaxHavens = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).COUNTRY_RISK_AND_TAX_HAVENS
    ], ()=>(0, _apiDefault.default).getCountryRiskAndTaxHavens(), {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    const highRiskCountries = getCountryRiskAndTaxHavens.data?.countries || {};
    const getCountryRiskAndTaxHavenList = (country_code)=>{
        if (!country_code) return [];
        const highRiskCountriesListNames = [];
        const countryEntries = highRiskCountries[country_code];
        if (countryEntries) highRiskCountriesListNames.push(...Object.keys(countryEntries));
        return highRiskCountriesListNames;
    };
    return {
        getCountryRiskAndTaxHavenList
    };
};
exports.default = useGetCountryRiskAndTaxHavens;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eeWSc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactCountryFlag = require("react-country-flag");
var _reactCountryFlagDefault = parcelHelpers.interopDefault(_reactCountryFlag);
var _polaris = require("@shopify/polaris");
var _countriesHelpers = require("../../helpers/countries.helpers");
var _useCountries = require("../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _browserUtils = require("../../utils/browserUtils");
var _util = require("../../utils/util");
const useSVG = (0, _browserUtils.isWindows10)();
const Country = (props)=>{
    const { country, language, hideFlag, hideLabel, shortName, children, ...textTypeProps } = props;
    const { getCountryName } = (0, _useCountriesDefault.default)();
    if (!country && (0, _util.isNil)(country)) return null;
    const countryCode = country.length === 2 ? country : (0, _countriesHelpers.searchForCountryCode)(country, language);
    if (!countryCode) return null;
    const shouldRenderText = !hideLabel || children;
    const displayLabel = shortName ? getCountryName(countryCode).split(",")[0] : getCountryName(countryCode).replaceAll(",", ", ");
    if (!shouldRenderText && !hideFlag) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactCountryFlagDefault.default), {
        countryCode: countryCode,
        svg: useSVG
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            !hideFlag && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactCountryFlagDefault.default), {
                countryCode: countryCode,
                svg: useSVG
            }),
            shouldRenderText && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                as: "span",
                ...textTypeProps,
                children: [
                    !hideLabel && displayLabel,
                    children
                ]
            })
        ]
    });
};
exports.default = Country;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-country-flag":"8Uyta","@shopify/polaris":"ek5a0","../../helpers/countries.helpers":"1PV4o","../../hooks/useCountries":"azDTp","../../utils/browserUtils":"4ShiW","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Uyta":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactCountryFlag", ()=>ReactCountryFlag);
var _react = require("react");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _excluded = [
    "cdnSuffix",
    "cdnUrl",
    "countryCode",
    "style",
    "svg"
];
var DEFAULT_CDN_URL = "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/";
var DEFAULT_CDN_SUFFIX = "svg";
// offset between uppercase ascii and regional indicator symbols
var OFFSET = 127397;
var ReactCountryFlag = function ReactCountryFlag(_ref) {
    var _ref$cdnSuffix = _ref.cdnSuffix, cdnSuffix = _ref$cdnSuffix === void 0 ? DEFAULT_CDN_SUFFIX : _ref$cdnSuffix, _ref$cdnUrl = _ref.cdnUrl, cdnUrl = _ref$cdnUrl === void 0 ? DEFAULT_CDN_URL : _ref$cdnUrl, countryCode = _ref.countryCode, style = _ref.style, _ref$svg = _ref.svg, svg = _ref$svg === void 0 ? false : _ref$svg, props = _objectWithoutPropertiesLoose(_ref, _excluded);
    if (typeof countryCode !== "string") return null;
    if (svg) {
        var flagUrl = "" + cdnUrl + countryCode.toLowerCase() + "." + cdnSuffix;
        return (0, _react.createElement)("img", Object.assign({}, props, {
            src: flagUrl,
            style: _extends({
                display: "inline-block",
                width: "1em",
                height: "1em",
                verticalAlign: "middle"
            }, style)
        }));
    }
    var emoji = countryCode.toUpperCase().replace(/./g, function(_char) {
        return String.fromCodePoint(_char.charCodeAt(0) + OFFSET);
    });
    return (0, _react.createElement)("span", Object.assign({
        role: "img"
    }, props, {
        style: _extends({
            display: "inline-block",
            fontSize: "1em",
            lineHeight: "1em",
            verticalAlign: "middle"
        }, style)
    }), emoji);
};
exports.default = ReactCountryFlag;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ggSeE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useNonInitialEffect = require("../../hooks/useNonInitialEffect");
var _useNonInitialEffectDefault = parcelHelpers.interopDefault(_useNonInitialEffect);
var _dateUtils = require("../../utils/dateUtils");
var _numbersUtils = require("../../utils/numbersUtils");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
const PartialDateInput = (props)=>{
    const { dateValue, label, required, disabled, error, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const id = (0, _react.useId)();
    const [touched, setTouched] = (0, _react.useState)(false);
    const initialYear = dateValue?.split("-")[0];
    const [year, setYear] = (0, _react.useState)(initialYear || "");
    const [month, setMonth] = (0, _react.useState)(dateValue?.split("-")[1] || "");
    const [day, setDay] = (0, _react.useState)(dateValue?.split("-")[2] || "");
    const isPartiallyFilled = (0, _stringUtils.isEmptyString)(day) && (0, _stringUtils.isEmptyString)(month) || year.length < 4;
    (0, _useNonInitialEffectDefault.default)(()=>{
        // always return the changed year, but if the form is partially filled
        // return an empty value
        onChange(isPartiallyFilled ? "" : (0, _dateUtils.formatDate)(year, month, day), year);
    }, [
        day,
        month,
        year
    ]);
    const handleOnBlur = ()=>setTouched(true);
    const getOnChangeHandler = (setter, max)=>(value)=>{
            if (!isPartiallyFilled) setTouched(true);
            const numericValue = parseInt(value, 10);
            if ((0, _stringUtils.isEmptyString)(value) || (0, _numbersUtils.isNumberInRange)(numericValue, 0, max)) setter(value);
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Label), {
                id: id,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLabel, {
                    required: required,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TextFieldsWrapper, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        type: "number",
                        label: f("default.days", {
                            days: 1
                        }),
                        min: 1,
                        max: 31,
                        maxLength: 2,
                        inputMode: "numeric",
                        value: day,
                        onChange: getOnChangeHandler(setDay, 31),
                        autoComplete: "off",
                        disabled: disabled,
                        onBlur: initialYear ? handleOnBlur : (0, _util.noop),
                        error: touched && !!error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        type: "number",
                        label: f("default.months", {
                            months: 1
                        }),
                        min: 1,
                        max: 12,
                        maxLength: 2,
                        inputMode: "numeric",
                        value: month,
                        onChange: getOnChangeHandler(setMonth, 12),
                        autoComplete: "off",
                        disabled: disabled,
                        onBlur: initialYear ? handleOnBlur : (0, _util.noop),
                        error: touched && !!error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        type: "number",
                        label: f("default.years", {
                            years: 1
                        }),
                        maxLength: 4,
                        inputMode: "numeric",
                        value: year,
                        onChange: getOnChangeHandler(setYear, 9999),
                        autoComplete: "off",
                        disabled: disabled,
                        onBlur: handleOnBlur,
                        error: touched && !!error
                    })
                ]
            }),
            touched && error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.InlineError), {
                fieldID: id,
                message: error
            })
        ]
    });
};
const Wrapper = (0, _styledComponentsDefault.default).div`
  display: flex;
  flex-direction: column;
  gap: var(--p-space-1);
  position: relative;

  & .Polaris-Labelled__LabelWrapper {
    margin-bottom: 0;
  }
`;
const StyledLabel = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  ${Wrapper} & {
    position: absolute;
    top: calc(-1 * var(--p-space-4));
    width: 100%;
    text-align: center;
    text-transform: uppercase;
  }

  ${({ required })=>required && `
      &::after {
        content: "*";
        color: var(--p-text-critical);
        margin-left: var(--p-space-1);
      }
  `}
`;
const TextFieldsWrapper = (0, _styledComponentsDefault.default).div`
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  gap: var(--p-space-2);

  & > * {
    flex: 1;
  }

  & input {
    max-width: calc(6ch + 2 * var(--p-space-3));
    text-align: center;
  }

  & .Polaris-TextField__Spinner {
    display: none;
  }

  & .Polaris-Label {
    text-transform: capitalize;
  }
`;
exports.default = PartialDateInput;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useNonInitialEffect":"7lww1","../../utils/dateUtils":"euvUV","../../utils/numbersUtils":"2RGyl","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","../CondensedText/CondensedText":"1FshD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7lww1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useNonInitialEffect = (effect, deps)=>{
    const initialRender = (0, _react.useRef)(true);
    return (0, _react.useEffect)(()=>{
        let effectReturns;
        if (initialRender.current) initialRender.current = false;
        else effectReturns = effect();
        if (effectReturns && typeof effectReturns === "function") return effectReturns;
    }, deps);
};
exports.default = useNonInitialEffect;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jaJSI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _phoneSvg = require("../../../assets/icons/phone.svg");
var _phoneSvgDefault = parcelHelpers.interopDefault(_phoneSvg);
var _person = require("../../constants/person");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _emailField = require("../EmailField/EmailField");
var _emailFieldDefault = parcelHelpers.interopDefault(_emailField);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _nationalIdInput = require("./NationalIdInput/NationalIdInput");
var _nationalIdInputDefault = parcelHelpers.interopDefault(_nationalIdInput);
const PersonContactDetails = (props)=>{
    const { value, disabled, fieldsErrorMap = new Map(), onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        distribution: "fillEvenly",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nationalIdInputDefault.default), {
                country: value.national_id_country,
                nationalId: value.national_id,
                onChange: (isValid, country, nationalId)=>{
                    onChange({
                        ...value,
                        national_id_country: country,
                        national_id: nationalId
                    }, isValid);
                },
                disabled: disabled,
                enableCountrySelection: (0, _stringUtils.isEmptyString)(value.national_id_country),
                error: fieldsErrorMap.get("national_id") || fieldsErrorMap.get("national_id_country"),
                maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD)
            }, value.national_id_country),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                value: value.phone || "",
                label: f("common.labels.mobile-phone"),
                onChange: (newValue)=>onChange({
                        ...value,
                        phone: newValue
                    }),
                placeholder: f("common.labels.mobile-phone"),
                disabled: disabled,
                error: fieldsErrorMap.get("mobile_number"),
                prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _phoneSvgDefault.default)
                }),
                autoComplete: "off",
                maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailFieldDefault.default), {
                value: value.email || "",
                label: f("common.labels.email"),
                onChange: (newValue)=>onChange({
                        ...value,
                        email: newValue
                    }),
                disabled: disabled,
                error: fieldsErrorMap.get("email")
            })
        ]
    });
};
exports.default = PersonContactDetails;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/phone.svg":"ec9ze","../../constants/person":"dpk3a","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../EmailField/EmailField":"ebWLS","../extensions/Icon":"eHSf0","../KDKTextField/KDKTextField":"b5QRp","./NationalIdInput/NationalIdInput":"jv9I4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ec9ze":[function(require,module,exports) {
module.exports = require("da9127efabca9c6b").getBundleURL("kEMsi") + "phone.6017082e.svg";

},{"da9127efabca9c6b":"75UoR"}],"ebWLS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _emailSvg = require("../../../assets/icons/email.svg");
var _emailSvgDefault = parcelHelpers.interopDefault(_emailSvg);
var _person = require("../../constants/person");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const EmailField = (props)=>{
    const { label = "", disabled, required, placeholder, value = "", error, onChange } = props;
    const [focused, setFocused] = (0, _react.useState)(false);
    const f = (0, _useFormatMessageDefault.default)();
    const getErrorMessage = ()=>{
        if (required && focused && (0, _stringUtils.isEmptyString)(value)) return f("email.required.error");
        return !(0, _stringUtils.isEmptyString)(value) && !(0, _stringUtils.isEmail)(value) ? f("email.invalid.address.error") : undefined;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
        value: value || "",
        type: "email",
        disabled: disabled,
        prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _emailSvgDefault.default),
            useMask: true
        }),
        placeholder: placeholder || f("email.placeholder.text"),
        error: error || getErrorMessage(),
        onBlur: ()=>setFocused(false),
        onFocus: ()=>setFocused(true),
        onChange: onChange,
        label: label,
        labelHidden: (0, _stringUtils.isEmptyString)(label),
        autoComplete: "off",
        maxLength: (0, _person.MAX_LENGTH_OF_TEXT_INPUT_FIELD)
    });
};
exports.default = EmailField;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/email.svg":"bKu0l","../../constants/person":"dpk3a","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bKu0l":[function(require,module,exports) {
module.exports = require("ab3e59f03fb41340").getBundleURL("kEMsi") + "email.5d6e8d67.svg";

},{"ab3e59f03fb41340":"75UoR"}],"jv9I4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useCountries = require("../../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useNonInitialEffect = require("../../../hooks/useNonInitialEffect");
var _useNonInitialEffectDefault = parcelHelpers.interopDefault(_useNonInitialEffect);
var _stringUtils = require("../../../utils/stringUtils");
var _country = require("../../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _countrySelect = require("../../CountrySelect/CountrySelect");
var _countrySelectDefault = parcelHelpers.interopDefault(_countrySelect);
var _kdktextField = require("../../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _popoverButton = require("../../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _useNationalIdValidator = require("./useNationalIdValidator");
var _useNationalIdValidatorDefault = parcelHelpers.interopDefault(_useNationalIdValidator);
const NationalIdInput = (props)=>{
    const { country: initialCountry, nationalId: initialNationalId, enableCountrySelection, onChange, error, ...textFieldProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [country, setCountry] = (0, _react.useState)(initialCountry);
    const [nationalId, setNationalId] = (0, _react.useState)(initialNationalId || "");
    const { getCountryName } = (0, _useCountriesDefault.default)();
    const { placeholder, validator, length } = (0, _useNationalIdValidatorDefault.default)(country);
    const isCountryMissing = !country && !(0, _stringUtils.isEmptyString)(nationalId);
    const isNationalIdValid = nationalId && country ? validator(nationalId) : true;
    const nationalIdError = !isNationalIdValid ? f("common.errors.invalid.person.national-id") : isCountryMissing ? f("common.errors.invalid.person.national-id-country") : error;
    const isCountrySelectDisabled = textFieldProps.disabled && !enableCountrySelection;
    // call onChange action only after updating the internal state and calculating the validity of the national id
    (0, _useNonInitialEffectDefault.default)(()=>onChange(isNationalIdValid, country, nationalId), [
        country,
        nationalId,
        isNationalIdValid
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
        prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
            label: country ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: country,
                hideLabel: true
            }) : undefined,
            plain: true,
            removeUnderline: true,
            disclosure: "down",
            disabled: isCountrySelectDisabled,
            tooltip: country ? getCountryName(country) : undefined,
            render: (onClose)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countrySelectDefault.default), {
                    value: country,
                    onSelect: (newCountryValue)=>{
                        setCountry(newCountryValue);
                        onClose();
                    },
                    label: f("common.labels.national-id-country"),
                    labelHidden: true,
                    renderAsOptionsList: true,
                    disabled: isCountrySelectDisabled
                });
            }
        }),
        onChange: setNationalId,
        value: nationalId,
        placeholder: placeholder,
        label: f("person.customer.details.personal.number"),
        maxLength: length,
        minLength: length,
        autoComplete: "off",
        forceTouched: isCountryMissing,
        error: nationalIdError,
        ...textFieldProps
    });
};
exports.default = NationalIdInput;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../hooks/useCountries":"azDTp","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useNonInitialEffect":"7lww1","../../../utils/stringUtils":"4gVdA","../../Country/Country":"eeWSc","../../CountrySelect/CountrySelect":"dlvog","../../KDKTextField/KDKTextField":"b5QRp","../../PopoverButton/PopoverButton":"ihB8F","./useNationalIdValidator":"cX8Th","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ihB8F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _util = require("../../utils/util");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const PopoverButton = (props)=>{
    const { label, fluidContent, tooltip, preferredPosition, preferredAlignment, autofocusTarget = "first-node", useCaret, render, onClose = (0, _util.noop), disabled, ...buttonProps } = props;
    const [openPopover, togglePopover, closePopover] = (0, _useOpenCloseDefault.default)();
    const disclosure = useCaret ? openPopover ? "up" : "down" : buttonProps.disclosure;
    const activatorButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledActivatorButton, {
        ...buttonProps,
        subdued: disabled,
        disclosure: disclosure,
        disabled: disabled,
        // Due to the latest Polaris upgrade, disabling a `Button` also disables the `connectedDisclosure` menu (the split button).
        // This is a workaround that blocks the button onClick if the disabled property is true but without passing it to the
        // Button component itself
        onClick: ()=>disabled ? (0, _util.noop) : togglePopover(),
        children: label
    });
    const handleClose = ()=>{
        onClose();
        closePopover();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover), {
        active: openPopover,
        fluidContent: fluidContent,
        preferredPosition: preferredPosition,
        preferredAlignment: preferredAlignment,
        activator: tooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
            content: tooltip,
            dismissOnMouseOut: true,
            preferredPosition: "above",
            children: activatorButton
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: activatorButton
        }),
        onClose: handleClose,
        autofocusTarget: autofocusTarget,
        children: render(handleClose)
    });
};
// Due to the latest Polaris upgrade, disabling a `Button` also disables the `connectedDisclosure` menu (the split button).
// This is a workaround that renders the button as disabled without passing it the disabled property
const StyledActivatorButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  & .Polaris-Button {
    color: ${({ subdued })=>subdued ? "var(--p-text-disabled)" : undefined};
    padding: ${({ plain })=>plain ? "0" : undefined};
`;
exports.default = PopoverButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useOpenClose":"idooG","../../utils/util":"4MniK","../extensions/Button":"8exc0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b5W2d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
const TooltipWrapper = (props)=>{
    const { content, children } = props;
    if ((0, _util.isNil)(content) || typeof content === "string" && (0, _stringUtils.isEmptyString)(content)) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Tooltip), {
        ...props
    });
};
exports.default = TooltipWrapper;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cX8Th":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _norwegianNationalIdValidator = require("norwegian-national-id-validator");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../../utils/stringUtils");
const useNationalIdValidator = (country)=>{
    const f = (0, _useFormatMessageDefault.default)();
    switch(country){
        case "NO":
            return {
                placeholder: f("personal.number.placeholder.no"),
                validator: (0, _norwegianNationalIdValidator.validateNorwegianIdNumber),
                length: 11
            };
        default:
            return {
                placeholder: f("person.customer.details.personal.number"),
                validator: (nationalId)=>!(0, _stringUtils.isEmptyString)(nationalId),
                length: undefined
            };
    }
};
exports.default = useNationalIdValidator;

},{"norwegian-national-id-validator":"02IMN","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"02IMN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getGender = exports.isValidCheckDigits = exports.possibleBirthDateOfIdNumber = exports.idNumberContainsBirthDate = exports.possibleAgeOfPersonWithIdNumber = exports.possibleAgesOfPersonWithIdNumber = exports.validateNorwegianIdNumber = exports.Gender = exports.IDNumberType = exports.isValidDate = exports.diffYears = exports.NorwegianId = void 0;
/**
 * Object-oriented API for Norwegian National ID Validator
 * @example
 * ```javascript
 * import { NorwegianId } from 'norwegian-national-id-validator';
 *
 * const valid = NorwegianId('0000000000');
 * ```
 * @param idNumber norwegian social security number
 */ var NorwegianId = function(idNumber) {
    var valid = validateNorwegianIdNumber(idNumber);
    return {
        idNumber: idNumber,
        isValid: function() {
            return valid;
        },
        isBirthNumber: function() {
            return valid && idNumberType(idNumber) == IDNumberType.BirthNumber;
        },
        isDNumber: function() {
            return valid && idNumberType(idNumber) == IDNumberType.DNumber;
        },
        isHNumber: function() {
            return valid && idNumberType(idNumber) == IDNumberType.HNumber;
        },
        isFhNumber: function() {
            return valid && idNumberType(idNumber) == IDNumberType.FHNumber;
        },
        isMale: function() {
            return valid && getGender(idNumber) == Gender.Male;
        },
        isFemale: function() {
            return valid && getGender(idNumber) == Gender.Female;
        },
        age: function() {
            return possibleAgeOfPersonWithIdNumber(idNumber);
        },
        birthDate: function() {
            return valid && possibleBirthDateOfIdNumber(idNumber) || undefined;
        }
    };
};
exports.NorwegianId = NorwegianId;
/**
 * Calculated the difference betweeen two dates.
 * @param startDate Date instance
 * @param endDate Date instance
 * @private
 */ function diffYears(startDate, endDate) {
    var yStart = startDate.getFullYear();
    var mStart = startDate.getMonth();
    var dStart = startDate.getDate();
    var yEnd = endDate.getFullYear();
    var mEnd = endDate.getMonth();
    var dEnd = endDate.getDate();
    var diff = yStart - yEnd;
    if (mEnd > mStart || mEnd === mStart && dEnd > dStart) return diff - 1;
    return diff;
}
exports.diffYears = diffYears;
/**
 * Checks if a date is valid against another
 * @param date Date instance
 * @param expectedYear
 * @param expectedMonth
 * @param expectedDay
 */ function isValidDate(date, expectedYear, expectedMonth, expectedDay) {
    return date.getFullYear() === Number(expectedYear) && date.getMonth() + 1 === Number(expectedMonth) && date.getDate() === Number(expectedDay);
}
exports.isValidDate = isValidDate;
/** In Norway there are several different ID numbers */ var IDNumberType;
(function(IDNumberType) {
    /**
     * A national identity number (birth number) is an ID number for you who
     * have a residence permit and are going to live in Norway for more than
     * six months.
     */ IDNumberType[IDNumberType["BirthNumber"] = 0] = "BirthNumber";
    /**
     * A D number is a temporary identification number that you get if you have
     * applied for protection (asylum), or if you have a residence permit and
     * are going to stay in Norway for less than six months.
     */ IDNumberType[IDNumberType["DNumber"] = 1] = "DNumber";
    /**
     * A H number is a number used for assistance, a unique identification of a
     * person that does not have a national ID or a D number or in cases where
     * this is not known. A H number contains information about age and gender.
     */ IDNumberType[IDNumberType["HNumber"] = 2] = "HNumber";
    /**
     * A FH number is used in health care to uniquely identify patients that
     * does not have a known national ID or D number. A FH number does not have
     * any information about age or gender.
     */ IDNumberType[IDNumberType["FHNumber"] = 3] = "FHNumber";
})(IDNumberType = exports.IDNumberType || (exports.IDNumberType = {}));
/**
 * Birth numbers, D-number and H-number contains information about gender
 */ var Gender;
(function(Gender) {
    /** If the third last digit in the ID number is odd, it is a male */ Gender[Gender["Male"] = 0] = "Male";
    /** If the third last digit in the ID number is even, it is a female */ Gender[Gender["Female"] = 1] = "Female";
})(Gender = exports.Gender || (exports.Gender = {}));
/**
 * Checks if the given value is a valid Norwegian national identity number.
 * @example
 * ```javascript
 * import { validateNorwegianIdNumber } from 'norwegian-national-id-validator';
 * const valid = validateNorwegianIdNumber(0000000000);
 * ```
 * @param idNumber social security number
 * @returns `true` for valid, and `false` for invalid ID number.
 */ function validateNorwegianIdNumber(idNumber) {
    var trimmed = idNumber.trim();
    if (isNaN(Number(trimmed))) return false;
    if (trimmed.length !== 11) return false;
    if (!isValidCheckDigits(trimmed)) return false;
    var type = idNumberType(trimmed);
    if (type === IDNumberType.FHNumber) return true;
    else return possibleAgesOfPersonWithIdNumber(trimmed).length > 0;
}
exports.validateNorwegianIdNumber = validateNorwegianIdNumber;
/**
 * Find possible age of person based of ID number
 * @param elevenDigits Identification number
 */ function possibleAgesOfPersonWithIdNumber(elevenDigits) {
    var possibleAge = possibleAgeOfPersonWithIdNumber(elevenDigits);
    return possibleAge == null ? [] : [
        possibleAge
    ];
}
exports.possibleAgesOfPersonWithIdNumber = possibleAgesOfPersonWithIdNumber;
/**
 * Returns the age of a person with given Norwegian national identity number.
 * Returns `undefined` when birth date could not be determined (e.g. for FH-numbers and invalid ID-numbers).
 * @param elevenDigits Identification number
 */ function possibleAgeOfPersonWithIdNumber(elevenDigits) {
    var birthDate = possibleBirthDateOfIdNumber(elevenDigits);
    if (birthDate == null) return undefined;
    var years = diffYears(new Date(), birthDate);
    return years >= 0 && years < 125 ? years : undefined;
}
exports.possibleAgeOfPersonWithIdNumber = possibleAgeOfPersonWithIdNumber;
/**
 * Check if idNumber contains birth date
 * @param elevenDigits idNumber
 */ function idNumberContainsBirthDate(elevenDigits) {
    return idNumberType(elevenDigits) !== IDNumberType.FHNumber;
}
exports.idNumberContainsBirthDate = idNumberContainsBirthDate;
/**
 * Get possible birth date from ID number
 * @param elevenDigits IdNumber
 */ function possibleBirthDateOfIdNumber(elevenDigits) {
    if (elevenDigits.length !== 11) return undefined;
    var type = idNumberType(elevenDigits);
    switch(type){
        case IDNumberType.BirthNumber:
            return possibleBirthDateOfBirthNumber(elevenDigits);
        case IDNumberType.DNumber:
            return possibleBirthDateOfDNumber(elevenDigits);
        case IDNumberType.HNumber:
            return possibleBirthDateOfHNumber(elevenDigits);
    }
    return undefined;
}
exports.possibleBirthDateOfIdNumber = possibleBirthDateOfIdNumber;
/**
 * Get the ID number kind/type. This function does not validate, so
 * it should be combined with {@linkcode validateNorwegianIdNumber}.
 * @example
 * ```javascript
 * import { idNumberType, validateNorwegianIdNumber } from 'norwegian-national-id-validator';
 * if (validateNorwegianIdNumber(0000000000)) {
 *   const type = idNumberType(00000000000);
 * }
 * ```
 * @param elevenDigits IdNumber
 */ function idNumberType(elevenDigits) {
    var firstDigit = parseInt(elevenDigits[0]);
    if (firstDigit === 8 || firstDigit === 9) return IDNumberType.FHNumber;
    if (firstDigit >= 4 && firstDigit <= 7) return IDNumberType.DNumber;
    var thirdDigit = parseInt(elevenDigits[2]);
    if (thirdDigit === 4 || thirdDigit === 5) return IDNumberType.HNumber;
    else return IDNumberType.BirthNumber;
}
/**
 * Get possible birth date from BirthNumber
 * @param elevenDigits BirthNumber
 */ function possibleBirthDateOfBirthNumber(elevenDigits) {
    return getBirthDate(elevenDigits, IDNumberType.BirthNumber);
}
/**
 * Get possible birth date from HNumber
 * @param elevenDigits HNumber
 */ function possibleBirthDateOfHNumber(elevenDigits) {
    var correctedThirdDigit = (parseInt(elevenDigits[2]) - 4).toString();
    return getBirthDate(elevenDigits.slice(0, 2) + correctedThirdDigit + elevenDigits.slice(3, 11), IDNumberType.HNumber);
}
/**
 * Get possible birth date from DNumber
 * @param elevenDigits DNumber
 */ function possibleBirthDateOfDNumber(elevenDigits) {
    var correctedFirstDigit = (parseInt(elevenDigits[0]) - 4).toString();
    return getBirthDate(correctedFirstDigit + elevenDigits.slice(1, 11), IDNumberType.DNumber);
}
/**
 * @private
 */ function getBirthDate(elevenDigitsWithDDMMYY, idNumberType) {
    var DD = elevenDigitsWithDDMMYY.slice(0, 2);
    var MM = elevenDigitsWithDDMMYY.slice(2, 4);
    var YY = elevenDigitsWithDDMMYY.slice(4, 6);
    var YY_int = parseInt(YY);
    var ageGroupNumber = parseInt(elevenDigitsWithDDMMYY.slice(6, 9));
    var centuryPrefix = "20";
    if (ageGroupNumber >= 0 && ageGroupNumber < 500) centuryPrefix = "19";
    else if (idNumberType === IDNumberType.DNumber) centuryPrefix = "20";
    else if (ageGroupNumber >= 500 && ageGroupNumber < 750 && YY_int >= 54) centuryPrefix = "18";
    else if (ageGroupNumber >= 900 && ageGroupNumber < 1000 && YY_int >= 40) centuryPrefix = "19";
    var fullYear = "".concat(centuryPrefix).concat(YY);
    var isoStr = [
        fullYear,
        MM,
        DD
    ].join("-") + "T00:00:00";
    var birthDate = new Date(isoStr);
    if (!isValidDate(birthDate, fullYear, MM, DD)) return undefined;
    return birthDate;
}
/**
 * @private
 */ function isValidCheckDigits(elevenDigits) {
    var staticSequenceFirstCheckDigit = [
        3,
        7,
        6,
        1,
        8,
        9,
        4,
        5,
        2,
        1
    ];
    var staticSequenceSecondCheckDigit = [
        5,
        4,
        3,
        2,
        7,
        6,
        5,
        4,
        3,
        2,
        1
    ];
    var elevenDigitsArray = elevenDigits.split("").map(Number);
    return isValidCheckDigit(staticSequenceFirstCheckDigit, elevenDigitsArray) && isValidCheckDigit(staticSequenceSecondCheckDigit, elevenDigitsArray);
}
exports.isValidCheckDigits = isValidCheckDigits;
/**
 * @private
 */ function isValidCheckDigit(staticSequence, elevenDigits) {
    var productSum = staticSequence.reduce(function(acc, value, index) {
        return acc + value * elevenDigits[index];
    }, 0);
    return productSum % 11 === 0;
}
/**
 * Returns the gender based of ID number. Returns `undefined` when no gender
 * information is available.
 * @param elevenDigits ID number
 */ function getGender(elevenDigits) {
    if (elevenDigits.length != 11) return undefined;
    else if (idNumberType(elevenDigits) == IDNumberType.FHNumber) return undefined;
    var isFemale = Number(elevenDigits.charAt(8)) % 2 == 0;
    if (isFemale) return Gender.Female;
    else return Gender.Male;
}
exports.getGender = getGender;

},{}],"aOMk1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _countrySelect = require("../CountrySelect/CountrySelect");
var _countrySelectDefault = parcelHelpers.interopDefault(_countrySelect);
const PersonCountries = (props)=>{
    const { value, disabled, requiredFields, fieldsErrorMap = new Map(), onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        distribution: "fillEvenly",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countrySelectDefault.default), {
                value: value.country_of_residence,
                onSelect: (newValue)=>onChange("country_of_residence", newValue),
                disabled: disabled,
                error: fieldsErrorMap.get("country_of_residence"),
                label: f("common.labels.country-of-residence"),
                requiredIndicator: requiredFields.includes("country_of_residence"),
                clearButton: false
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countrySelectDefault.default), {
                value: value.country_of_origin,
                onSelect: (newValue)=>onChange("country_of_origin", newValue),
                disabled: disabled,
                error: fieldsErrorMap.get("country_of_origin"),
                label: f("common.labels.country-of-origin"),
                requiredIndicator: requiredFields.includes("country_of_origin"),
                clearButton: false
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countrySelectDefault.default), {
                value: value.country_of_citizenship,
                onSelect: (newValue)=>onChange("country_of_citizenship", newValue),
                disabled: disabled,
                error: fieldsErrorMap.get("country_of_citizenship"),
                label: f("common.labels.citizenship"),
                requiredIndicator: requiredFields.includes("country_of_citizenship"),
                clearButton: false
            })
        ]
    });
};
exports.default = PersonCountries;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../CountrySelect/CountrySelect":"dlvog","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ak8eE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const UBOManualOverride = (props)=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
        ...props,
        label: f("ubo.manual-override.title"),
        helpText: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledHelpText, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("ubo.manual-override.description")
            })
        })
    });
};
const StyledHelpText = (0, _styledComponentsDefault.default).span`
  white-space: pre-wrap;
`;
exports.default = UBOManualOverride;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jF1O5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _hideOnMobile = require("../HideOnMobile/HideOnMobile");
var _hideOnMobileDefault = parcelHelpers.interopDefault(_hideOnMobile);
var _ownersTable = require("../OwnersCard/OwnersTable/OwnersTable");
var _ownersTableDefault = parcelHelpers.interopDefault(_ownersTable);
var _ownershipStructureTree = require("../OwnershipStructureTree/OwnershipStructureTree");
var _ownershipStructureTreeDefault = parcelHelpers.interopDefault(_ownershipStructureTree);
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
const TABLE_VIEW_INDEX = 0;
const TREE_VIEW_INDEX = 1;
const OwnershipView = (props)=>{
    const { customer, allowOwnershipTree, onViewTypeChange, ...ownersTableProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [selectedTabIndex, setSelectedTabIndex] = (0, _react.useState)(TABLE_VIEW_INDEX);
    const [queryText, setQueryText] = (0, _react.useState)("");
    const clearQueryText = (0, _react.useCallback)(()=>setQueryText(""), []);
    const { isLoading, isError, data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_OWNERSHIP_TREE,
        customer.id
    ], ()=>(0, _apiDefault.default).getCustomerOwnershipTree(customer.id), {
        retry: false,
        staleTime: (0, _queriesKeys.STALE_TIME),
        retryOnMount: false,
        enabled: customer.has_ownership_tree && allowOwnershipTree
    });
    (0, _react.useEffect)(()=>{
        if (onViewTypeChange) onViewTypeChange(selectedTabIndex === TREE_VIEW_INDEX ? "tree" : "table");
    }, [
        selectedTabIndex
    ]);
    const showTable = selectedTabIndex === TABLE_VIEW_INDEX;
    const showTree = selectedTabIndex === TREE_VIEW_INDEX;
    const tabs = [
        {
            id: "table",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("ownership.view.table")
            })
        },
        {
            id: "tree",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("ownership.view.tree")
            })
        }
    ];
    if (customer.has_ownership_tree && isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        blockAlign: "center",
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "h2",
                variant: "headingMd",
                children: f("default.loading")
            })
        ]
    });
    if (!allowOwnershipTree || isError || !customer.has_ownership_tree || !data || !data.ownership_tree) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownersTableDefault.default), {
        customer: customer,
        ...ownersTableProps
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hideOnMobileDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ButtonGroup), {
                            segmented: true,
                            children: tabs.map((tab, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    pressed: selectedTabIndex === index,
                                    onClick: ()=>setSelectedTabIndex(index),
                                    outline: true,
                                    children: tab.content
                                }, tab.id))
                        }),
                        showTree && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                            value: queryText,
                            onChange: setQueryText,
                            labelHidden: true,
                            placeholder: f("default.search"),
                            clearButton: true,
                            onClearButtonClick: clearQueryText
                        })
                    ]
                })
            }),
            showTable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownersTableDefault.default), {
                customer: customer,
                ...ownersTableProps
            }),
            showTree && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipStructureTreeDefault.default), {
                        rootNode: data.ownership_tree.root_node,
                        searchTerm: queryText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        italic: true,
                        children: f("ownership.view.tree.info")
                    })
                ]
            })
        ]
    });
};
exports.default = OwnershipView;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../CondensedText/CondensedText":"1FshD","../extensions/Button":"8exc0","../HideOnMobile/HideOnMobile":"fcHQN","../OwnersCard/OwnersTable/OwnersTable":"iwKSA","../OwnershipStructureTree/OwnershipStructureTree":"lugoD","../SearchTextField/SearchTextField":"k5bRy","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fcHQN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
const HideOnMobile = (props)=>{
    const { children, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWrapper, {
        ...rest,
        children: children
    });
};
const StyledWrapper = (0, _styledComponentsDefault.default).div`
  // For small viewports - hide
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    display: none;
  }
`;
exports.default = HideOnMobile;

},{"react/jsx-runtime":"enbMA","styled-components":"eBrdC","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iwKSA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactTable = require("@tanstack/react-table");
var _tables = require("../../../constants/tables");
var _integrationHelpers = require("../../../helpers/integration.helpers");
var _ownersHelpers = require("../../../helpers/owners.helpers");
var _personHelpers = require("../../../helpers/person.helpers");
var _useFeatures = require("../../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../../utils/util");
var _reactTable1 = require("../../ReactTable/ReactTable");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable1);
var _ownerActions = require("./OwnerActions/OwnerActions");
var _ownerActionsDefault = parcelHelpers.interopDefault(_ownerActions);
var _ownerName = require("./OwnerName/OwnerName");
var _ownerNameDefault = parcelHelpers.interopDefault(_ownerName);
var _vitecOwnerSync = require("./VitecOwnerSync/VitecOwnerSync");
var _vitecOwnerSyncDefault = parcelHelpers.interopDefault(_vitecOwnerSync);
var _ownerCountries = require("./OwnerCountries");
var _ownerCountriesDefault = parcelHelpers.interopDefault(_ownerCountries);
var _ownerPercentShare = require("./OwnerPercentShare");
var _ownerPercentShareDefault = parcelHelpers.interopDefault(_ownerPercentShare);
var _useGetOwnerWarning = require("./useGetOwnerWarning");
var _useGetOwnerWarningDefault = parcelHelpers.interopDefault(_useGetOwnerWarning);
var _warningWrapper = require("./WarningWrapper");
var _warningWrapperDefault = parcelHelpers.interopDefault(_warningWrapper);
const OwnersTable = (props)=>{
    const { customer, owners, readonly, selectable, selectedOwners = [], screenedOwnersIds, getOwnershipUpdate = ()=>undefined, onEdit, onUpdate, onArchive, onSelectionChange = (0, _util.noop), onOwnershipUpdateReject, onOwnershipUpdateConfirm, ...dataTableProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { getOwnerWarning, hasWarnings } = (0, _useGetOwnerWarningDefault.default)();
    const showVitecSync = features.VITEC_ROLES_SYNC && features.VITEC_PROJECTS && (0, _integrationHelpers.isVitecProject)(customer);
    const screenableOwners = owners.filter((0, _ownersHelpers.isOwnerPerson));
    const handleSelection = (selectedIds, fromSelectAll)=>{
        if (fromSelectAll && selectedIds.length === 0) {
            const selection = screenableOwners.filter((owner)=>(0, _personHelpers.isUBO)(owner)).map((owner)=>owner.id);
            onSelectionChange(selection);
            return;
        }
        const validSelection = selectedIds.filter((ownerId)=>(0, _ownersHelpers.isAllowScreeningOwner)(screenableOwners.find((owner)=>owner.id === ownerId)));
        onSelectionChange(validSelection);
    };
    const getOwnerScreenType = (owner)=>{
        if (!screenedOwnersIds || owner.is_unknown) return undefined;
        if (screenedOwnersIds.includes(owner.id)) return "MONITORING";
        else return "NONE";
    };
    const columns = (0, _react.useMemo)(()=>{
        const columnHelper = (0, _reactTable.createColumnHelper)();
        const columns = [
            columnHelper.accessor((row)=>row.id, {
                header: f("table.column.name"),
                enableSorting: false,
                size: (0, _tables.MAIN_COLUMN_SIZE),
                cell: (props)=>{
                    const owner = props.row.original;
                    const update = getOwnershipUpdate(owner);
                    const showWarning = hasWarnings(owner);
                    const warning = getOwnerWarning(owner);
                    const screeningType = getOwnerScreenType(owner);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningWrapperDefault.default), {
                        showWarning: showWarning,
                        description: warning?.description,
                        url: warning?.url,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerNameDefault.default), {
                            owner: owner,
                            update: update,
                            screeningType: screeningType,
                            wrap: true
                        })
                    });
                }
            }),
            columnHelper.accessor((row)=>row.id, {
                header: f("table.column.shares"),
                enableSorting: false,
                size: (0, _tables.ROLES_AND_OWNERS_INFO_COLUMN_SIZE),
                id: "shares",
                cell: (props)=>{
                    const owner = props.row.original;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerPercentShareDefault.default), {
                        owner: owner,
                        update: getOwnershipUpdate(owner)
                    });
                }
            }),
            columnHelper.accessor((row)=>row.id, {
                header: f("table.column.country"),
                enableSorting: false,
                id: "countries",
                cell: (props)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerCountriesDefault.default), {
                        owner: props.row.original
                    });
                }
            }),
            columnHelper.accessor((row)=>row.id, {
                id: "actions",
                header: "",
                size: 1,
                enableSorting: false,
                cell: (props)=>{
                    const owner = props.row.original;
                    const update = getOwnershipUpdate(owner);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        blockAlign: "center",
                        align: "space-between",
                        wrap: false,
                        children: [
                            showVitecSync && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vitecOwnerSyncDefault.default), {
                                customerId: customer.id,
                                owner: owner,
                                onUpdate: onUpdate,
                                readonly: readonly
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerActionsDefault.default), {
                                customer: customer,
                                owner: owner,
                                update: update,
                                readonly: readonly,
                                onEdit: onEdit,
                                onOwnershipUpdateReject: onOwnershipUpdateReject,
                                onOwnershipUpdateConfirm: onOwnershipUpdateConfirm,
                                onAfterArchive: onArchive
                            })
                        ]
                    });
                }
            })
        ];
        return columns;
    }, [
        getOwnershipUpdate,
        readonly
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTableDefault.default), {
        columns: columns,
        data: owners,
        selectable: selectable,
        selectedIds: selectedOwners,
        getRowId: (owner)=>owner.id,
        isRowSelectable: (row)=>(0, _ownersHelpers.isAllowScreeningOwner)(row),
        getRowProps: (owner)=>({
                warningBanner: hasWarnings(owner)
            }),
        onSelectionChange: handleSelection,
        ...dataTableProps
    });
};
exports.default = OwnersTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-table":"86D8M","../../../constants/tables":"01ORG","../../../helpers/integration.helpers":"keU9B","../../../helpers/owners.helpers":"lynDH","../../../helpers/person.helpers":"6qOIE","../../../hooks/useFeatures":"hvBWb","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/util":"4MniK","../../ReactTable/ReactTable":"iNTSb","./OwnerActions/OwnerActions":"6YlAI","./OwnerName/OwnerName":"eQr1s","./VitecOwnerSync/VitecOwnerSync":"7ISCL","./OwnerCountries":"jfzeA","./OwnerPercentShare":"kPLOa","./useGetOwnerWarning":"97XmT","./WarningWrapper":"axfxv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"01ORG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAIN_COLUMN_WIDTH", ()=>MAIN_COLUMN_WIDTH);
parcelHelpers.export(exports, "MAIN_COLUMN_SIZE", ()=>MAIN_COLUMN_SIZE);
parcelHelpers.export(exports, "MAIN_OWNERS_COLUMN_SIZE", ()=>MAIN_OWNERS_COLUMN_SIZE);
parcelHelpers.export(exports, "USER_NAME_COLUMN_WIDTH", ()=>USER_NAME_COLUMN_WIDTH);
parcelHelpers.export(exports, "ROLES_AND_OWNERS_INFO_COLUMN_SIZE", ()=>ROLES_AND_OWNERS_INFO_COLUMN_SIZE);
parcelHelpers.export(exports, "SELECTION_COLUMN_ID", ()=>SELECTION_COLUMN_ID);
const MAIN_COLUMN_WIDTH = "50%";
const MAIN_COLUMN_SIZE = 50;
const MAIN_OWNERS_COLUMN_SIZE = 75;
const USER_NAME_COLUMN_WIDTH = "35%";
const ROLES_AND_OWNERS_INFO_COLUMN_SIZE = 15;
const SELECTION_COLUMN_ID = "selection";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"keU9B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVitecProject", ()=>isVitecProject);
const isVitecProject = (entity)=>Boolean(entity.integrations?.vitec_data);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iNTSb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactTable = require("@tanstack/react-table");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _tables = require("../../constants/tables");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _reactTableSkeleton = require("./ReactTableSkeleton");
var _reactTableSkeletonDefault = parcelHelpers.interopDefault(_reactTableSkeleton);
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHeaderCell = require("./TableHeaderCell");
var _tableHeaderCellDefault = parcelHelpers.interopDefault(_tableHeaderCell);
var _tableRow = require("./TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
function ReactTable(props) {
    const { columns, data, sortLocally, sortedColumnId, sortedDirection, selectedIds = [], selectable, expandable, showTreeLines, globalFilter, isLoading, headerContent = null, footerContent = null, getRowId, isRowSelectable = ()=>selectable, getSubRows, getRowProps = ()=>({}), getRowLineLabel, onSortChange = (0, _util.noop), onSelectionChange = (0, _util.noop), ...rest } = props;
    // when sorting locally there's no need to provide an initial sorting state
    const [localSortingState, setLocalSorting] = (0, _react.useState)([]);
    // when not sorting locally, the sorting state is created from the component props
    const externalSortingState = !sortLocally && sortedColumnId && sortedDirection ? [
        {
            id: sortedColumnId,
            desc: sortedDirection === "descending"
        }
    ] : undefined;
    const handleSortChange = (0, _react.useCallback)((header)=>{
        if (sortLocally) header.column.toggleSorting();
        else onSortChange(header.column.id, sortedDirection === "ascending" ? "descending" : "ascending");
    }, [
        sortLocally,
        onSortChange
    ]);
    const selectionState = Object.fromEntries(selectedIds.map((id)=>[
            id,
            true
        ]));
    const handleSelectionChange = (0, _react.useCallback)((updater)=>{
        const updatedSelectionState = (0, _reactTable.isFunction)(updater) ? updater(selectionState) : updater;
        // TODO find a way to detect if the selection change was initiated from the header or from a row
        const fromSelectAll = false;
        onSelectionChange(Object.entries(updatedSelectionState).filter(([, selected])=>selected).map(([id])=>id), fromSelectAll);
    }, [
        onSelectionChange,
        selectionState
    ]);
    if (selectable) columns.unshift({
        id: (0, _tables.SELECTION_COLUMN_ID),
        size: 1,
        header: ()=>{
            const checkedState = table.getIsSomeRowsSelected() ? "indeterminate" : table.getIsAllRowsSelected();
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                labelHidden: true,
                label: "",
                checked: checkedState,
                onChange: ()=>table.toggleAllPageRowsSelected(table.getIsSomeRowsSelected() ? false : !table.getIsAllRowsSelected())
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                labelHidden: true,
                label: "",
                checked: row.getIsSelected(),
                disabled: !isRowSelectable(row.original),
                onChange: row.getToggleSelectedHandler()
            })
    });
    const table = (0, _reactTable.useReactTable)({
        columns,
        data,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        getSortedRowModel: sortLocally ? (0, _reactTable.getSortedRowModel)() : undefined,
        getExpandedRowModel: expandable ? (0, _reactTable.getExpandedRowModel)() : undefined,
        getFilteredRowModel: (0, _reactTable.getFilteredRowModel)(),
        filterFromLeafRows: true,
        state: {
            sorting: externalSortingState || localSortingState,
            rowSelection: selectionState,
            globalFilter
        },
        defaultColumn: {
            size: 0,
            minSize: undefined
        },
        initialState: {
            // expand the root node by default
            expanded: true
        },
        manualSorting: !sortLocally,
        enableMultiSort: false,
        enableSortingRemoval: false,
        getSubRows,
        getRowId,
        enableRowSelection: (row)=>Boolean(isRowSelectable(row.original)),
        onSortingChange: setLocalSorting,
        onRowSelectionChange: handleSelectionChange
    });
    // find the column name by trying to render the header
    // if it returns a string - use that
    // otherwise try the meta.label value
    const getColumnLabel = (0, _react.useCallback)((columnId)=>{
        const header = table.getHeaderGroups().map((headersGroup)=>headersGroup.headers).flat().find((header)=>header.id === columnId);
        const headerLabel = !header || header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext());
        const columnLabel = typeof headerLabel === "string" ? headerLabel : header?.column.columnDef.meta?.label || "";
        return columnLabel;
    }, []);
    const visibleColumnsCount = columns.length - (selectable ? 1 : 0);
    const isExpandingColumn = (0, _react.useCallback)((index)=>expandable ? index === (selectable ? 1 : 0) : false, [
        expandable,
        selectable
    ]);
    (0, _react.useEffect)(()=>{
        if ((0, _stringUtils.isEmptyString)(globalFilter) || table.getIsAllRowsExpanded()) return;
        table.toggleAllRowsExpanded(true);
    }, [
        globalFilter,
        table
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "Polaris-DataTable",
            children: [
                headerContent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledHeader, {
                    children: headerContent
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "Polaris-DataTable__ScrollContainer",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledTable, {
                            className: "Polaris-DataTable__Table",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                    children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                            children: headerGroup.headers.map((header, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderCellDefault.default), {
                                                    header: header,
                                                    expandable: isExpandingColumn(index),
                                                    onSortChange: handleSortChange
                                                }, header.id))
                                        }, headerGroup.id))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                                    children: [
                                        table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                                ...getRowProps(row.original),
                                                depth: row.depth,
                                                expanded: row.getIsExpanded(),
                                                children: row.getVisibleCells().map((cell, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                        cell: cell,
                                                        columnLabel: getColumnLabel(cell.column.id),
                                                        isExpandableCell: isExpandingColumn(index),
                                                        showTreeLines: showTreeLines,
                                                        getRowLineLabel: getRowLineLabel,
                                                        children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                    }, cell.id))
                                            }, row.id)),
                                        isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTableSkeletonDefault.default), {
                                            columns: visibleColumnsCount
                                        })
                                    ]
                                })
                            ]
                        }),
                        footerContent && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "Polaris-DataTable__Footer",
                            children: footerContent
                        })
                    ]
                })
            ]
        })
    });
}
const StyledTable = (0, _styledComponentsDefault.default).table`
  // For small viewports - set background color to light gray in order to improve rows gaps
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    background-color: var(--p-color-bg-app);
  }
`;
const StyledHeader = (0, _styledComponentsDefault.default).div`
  padding: var(--p-space-4);
  background: var(--p-color-bg-subdued);
  color: var(--p-color-text-subdued);
  text-align: center;
  border-bottom-left-radius: var(--p-border-radius-2);
  border-bottom-right-radius: var(--p-border-radius-2);
`;
exports.default = ReactTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-table":"86D8M","styled-components":"eBrdC","../../constants/styles":"dZWds","../../constants/tables":"01ORG","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","./ReactTableSkeleton":"9wCWK","./TableCell":"7tt5F","./TableHeaderCell":"3WuPv","./TableRow":"dsCl0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9wCWK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
const ReactTableSkeleton = (props)=>{
    const { lines = 4, columns = 5 } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: Array.from({
            length: lines
        }, (_, rowIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                className: "Polaris-DataTable__TableRow",
                children: Array.from({
                    length: columns
                }, (_, colIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                        className: "Polaris-DataTable__Cell",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 1
                        })
                    }, colIndex))
            }, rowIndex))
    });
};
exports.default = ReactTableSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7tt5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _tables = require("../../constants/tables");
var _expandButton = require("../ExpandButton/ExpandButton");
var _expandButtonDefault = parcelHelpers.interopDefault(_expandButton);
var _treeLine = require("./TreeLine");
var _treeLineDefault = parcelHelpers.interopDefault(_treeLine);
function TableCell(props) {
    const { cell, columnLabel, className, isExpandableCell, showTreeLines, getRowLineLabel, ...rest } = props;
    const { row, column } = cell;
    const classes = (0, _classnamesDefault.default)("Polaris-DataTable__Cell", "Polaris-DataTable__Cell--verticalAlignTop", "Polaris-DataTable__Cell--firstColumn", className);
    const isSelectionColumn = column.id === (0, _tables.SELECTION_COLUMN_ID);
    const canExpand = isExpandableCell && row.getCanExpand();
    const isLeaf = isExpandableCell && !row.getCanExpand();
    // @ts-ignore
    const centered = column.columnDef.meta?.centered === true;
    const parent = row.getParentRow();
    // endNodeRef could either be of the expand/collapse button or of a leaf node
    const endNodeRef = (0, _react.useRef)(null);
    if (isExpandableCell) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableCell, {
        ...rest,
        className: classes,
        "data-col-label": columnLabel,
        isSelection: isSelectionColumn,
        depth: row.depth,
        isExpandableCell: true,
        centered: centered,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "center",
            wrap: false,
            children: [
                canExpand && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandButtonDefault.default), {
                    id: `parent-id-${row.id}`,
                    ref: endNodeRef,
                    expanded: row.getIsExpanded(),
                    onChange: row.toggleExpanded
                }),
                isLeaf && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLeafWrapper, {
                    ref: endNodeRef,
                    children: rest.children
                }),
                !isLeaf && rest.children,
                showTreeLines && parent && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _treeLineDefault.default), {
                    start: `parent-id-${parent.id}`,
                    end: endNodeRef,
                    labels: getRowLineLabel ? {
                        end: getRowLineLabel(row.original)
                    } : undefined,
                    isLeaf: isLeaf
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableCell, {
        ...rest,
        className: classes,
        "data-col-label": columnLabel,
        isSelection: isSelectionColumn,
        centered: centered
    });
}
const StyledTableCell = (0, _styledComponentsDefault.default).td`
  --horizontal-offset: ${({ depth })=>depth ? `calc(${depth} * var(--kdk-table-tree-node-gap))` : undefined};
  padding-left: ${({ isExpandableCell })=>isExpandableCell ? "var(--horizontal-offset, var(--p-space-2))" : undefined};

  text-align: ${({ centered })=>centered ? "center" : undefined};

  // For small viewports - hide the selection (checkbox) cell, reduce cell padding, add a pseudo element
  // with the column label above the cell content
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    display: ${({ isSelection })=>isSelection ? "none" : undefined};

    padding: var(--p-space-2);

    max-width: unset;

    text-align: left;

    &::before {
      content: attr(data-col-label);
      display: block;
      color: var(--p-text-subdued);
      font-size: var(--kdk-font-size-50);
      font-weight: var(--p-font-weight-semibold);
      line-height: 1.2;
    }
  }
`;
const StyledLeafWrapper = (0, _styledComponentsDefault.default).div`
  padding-left: var(--p-space-4);
`;
exports.default = TableCell;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","classnames":"2uoUy","styled-components":"eBrdC","../../constants/styles":"dZWds","../../constants/tables":"01ORG","../ExpandButton/ExpandButton":"eG1on","./TreeLine":"c4Ugj","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2uoUy":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"eG1on":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _chevronDownSvg = require("../../../assets/icons/chevron-down.svg");
var _chevronDownSvgDefault = parcelHelpers.interopDefault(_chevronDownSvg);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const ExpandButton = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { expanded, onChange, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
        plain: true,
        removeUnderline: true,
        icon: (0, _chevronDownSvgDefault.default),
        hoverable: true,
        expanded: expanded,
        onClick: ()=>onChange(!expanded),
        ref: ref,
        ...rest
    });
});
const StyledButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  --rotation: ${({ expanded })=>expanded ? "0deg" : "-90deg"};

  & img {
    transform: rotate(var(--rotation));
    transition: transform var(--p-ease) var(--p-duration-150);
  }
`;
exports.default = ExpandButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","../../../assets/icons/chevron-down.svg":"4Iap0","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4Iap0":[function(require,module,exports) {
module.exports = require("96260d10d6a1168").getBundleURL("kEMsi") + "chevron-down.380d6a72.svg";

},{"96260d10d6a1168":"75UoR"}],"c4Ugj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactXarrows = require("react-xarrows");
var _reactXarrowsDefault = parcelHelpers.interopDefault(_reactXarrows);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _styles = require("../../constants/styles");
const TreeLine = (props)=>{
    const { isLeaf, ...XArrowProps } = props;
    // @see GlobalStyles.tsx to see the styling adjustments for tree lines for leaves
    const classes = (0, _classnamesDefault.default)("kdk-table-tree-line", {
        leaf: isLeaf
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactXarrowsDefault.default), {
        startAnchor: [
            "bottom"
        ],
        endAnchor: [
            "left"
        ],
        path: "grid",
        gridBreak: "0%",
        showHead: false,
        strokeWidth: 2,
        color: (0, _styles.TREE_LINE_COLOR),
        passProps: {
            strokeLinecap: "round",
            strokeLinejoin: "round"
        },
        divContainerProps: {
            className: classes.toString()
        },
        ...XArrowProps
    });
};
exports.default = TreeLine;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-xarrows":"kF4hq","classnames":"2uoUy","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kF4hq":[function(require,module,exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory(require("9eea94e602d2573a"), require("38808aaba5723947"), require("b9a0a1fcaa1d0d5b"));
})(this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE_prop_types__) {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ "./src/Xarrow/utils/buzzier.js": /*!*************************************!*\
  !*** ./src/Xarrow/utils/buzzier.js ***!
  \*************************************/ /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "bzFunction": function() {
                        return /* binding */ bzFunction;
                    },
                    /* harmony export */ "buzzierMinSols": function() {
                        return /* binding */ buzzierMinSols;
                    }
                });
                // Buzier curve calculations
                /**
 * returns buzzier curve function with 2 controls points
 * bzCurve with 2 control points function(4 points total):  bz = (1−t)^3*p1 + 3(1−t)^2*t*p2 +3(1−t)*t^2*p3 + t^3*p4
 */ var bzFunction = function bzFunction(p1, p2, p3, p4) {
                    return function(t) {
                        return Math.pow(1 - t, 3) * p1 + 3 * Math.pow(1 - t, 2) * t * p2 + 3 * (1 - t) * Math.pow(t, 2) * p3 + Math.pow(t, 3) * p4;
                    };
                };
                /**
 * returns 2 solutions from extram points for buzzier curve with 2 controls points
 */ var buzzierMinSols = function buzzierMinSols(p1, p2, p3, p4) {
                    var bz = bzFunction(p1, p2, p3, p4); // dt(bz) = -3 p1 (1 - t)^2 + 3 p2 (1 - t)^2 - 6 p2 (1 - t) t + 6 p3 (1 - t) t - 3 p3 t^2 + 3 p4 t^2
                    // when p1=(x1,y1),p2=(cpx1,cpy1),p3=(cpx2,cpy2),p4=(x2,y2)
                    // then extrema points is when dt(bz) = 0
                    // solutions =>  t = ((-6 p1 + 12 p2 - 6 p3) ± sqrt((6 p1 - 12 p2 + 6 p3)^2 - 4 (3 p2 - 3 p1) (-3 p1 + 9 p2 - 9 p3 + 3 p4)))/(2 (-3 p1 + 9 p2 - 9 p3 + 3 p4))  when (p1 + 3 p3!=3 p2 + p4)
                    // if we mark A=(-6 p1 + 12 p2 - 6 p3) and B=(6 p1 - 12 p2 + 6 p3)^2 - 4 (3 p2 - 3 p1) (-3 p1 + 9 p2 - 9 p3 + 3 p4)) and C =(2 (-3 p1 + 9 p2 - 9 p3 + 3 p4) then
                    // tSol = A ± sqrt(B)
                    // then solution we want is: bz(tSol)
                    var A = -6 * p1 + 12 * p2 - 6 * p3;
                    var B = Math.pow(-6 * p1 + 12 * p2 - 6 * p3, 2) - 4 * (3 * p2 - 3 * p1) * (-3 * p1 + 9 * p2 - 9 * p3 + 3 * p4);
                    var C = 2 * (-3 * p1 + 9 * p2 - 9 * p3 + 3 * p4);
                    var sol1 = bz((A + Math.sqrt(B)) / C);
                    var sol2 = bz((A - Math.sqrt(B)) / C);
                    return [
                        sol1,
                        sol2
                    ];
                };
            /***/ },
            /***/ "./src/Xarrow/Xarrow.tsx": /*!*******************************!*\
  !*** ./src/Xarrow/Xarrow.tsx ***!
  \*******************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    Object.defineProperty(o, k2, {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    });
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                    Object.defineProperty(o, "default", {
                        enumerable: true,
                        value: v
                    });
                } : function(o, v) {
                    o["default"] = v;
                });
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                    }
                    __setModuleDefault(result, mod);
                    return result;
                };
                var __spreadArray = this && this.__spreadArray || function(to, from) {
                    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                    return to;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
                var useXarrowProps_1 = __importDefault(__webpack_require__(/*! ./useXarrowProps */ "./src/Xarrow/useXarrowProps.ts"));
                var Xwrapper_1 = __webpack_require__(/*! ../Xwrapper */ "./src/Xwrapper.tsx");
                var propTypes_1 = __importDefault(__webpack_require__(/*! ./propTypes */ "./src/Xarrow/propTypes.ts"));
                var GetPosition_1 = __webpack_require__(/*! ./utils/GetPosition */ "./src/Xarrow/utils/GetPosition.tsx");
                var log = console.log;
                var Xarrow = function(props) {
                    // log('xarrow update');
                    var _a;
                    var mainRef = react_1.useRef({
                        svgRef: react_1.useRef(null),
                        lineRef: react_1.useRef(null),
                        headRef: react_1.useRef(null),
                        tailRef: react_1.useRef(null),
                        lineDrawAnimRef: react_1.useRef(null),
                        lineDashAnimRef: react_1.useRef(null),
                        headOpacityAnimRef: react_1.useRef(null)
                    });
                    var _b = mainRef.current, svgRef = _b.svgRef, lineRef = _b.lineRef, headRef = _b.headRef, tailRef = _b.tailRef, lineDrawAnimRef = _b.lineDrawAnimRef, lineDashAnimRef = _b.lineDashAnimRef, headOpacityAnimRef = _b.headOpacityAnimRef;
                    react_1.useContext(Xwrapper_1.XarrowContext);
                    var xProps = useXarrowProps_1.default(props, mainRef.current);
                    var propsRefs = xProps[0];
                    var labels = propsRefs.labels, lineColor = propsRefs.lineColor, headColor = propsRefs.headColor, tailColor = propsRefs.tailColor, strokeWidth = propsRefs.strokeWidth, showHead = propsRefs.showHead, showTail = propsRefs.showTail, dashness = propsRefs.dashness, headShape = propsRefs.headShape, tailShape = propsRefs.tailShape, showXarrow = propsRefs.showXarrow, animateDrawing = propsRefs.animateDrawing, zIndex = propsRefs.zIndex, passProps = propsRefs.passProps, arrowBodyProps = propsRefs.arrowBodyProps, arrowHeadProps = propsRefs.arrowHeadProps, arrowTailProps = propsRefs.arrowTailProps, SVGcanvasProps = propsRefs.SVGcanvasProps, divContainerProps = propsRefs.divContainerProps, divContainerStyle = propsRefs.divContainerStyle, SVGcanvasStyle = propsRefs.SVGcanvasStyle, _debug = propsRefs._debug, shouldUpdatePosition = propsRefs.shouldUpdatePosition;
                    animateDrawing = props.animateDrawing;
                    var _c = react_1.useState(!animateDrawing), drawAnimEnded = _c[0], setDrawAnimEnded = _c[1];
                    var _d = react_1.useState({}), setRender = _d[1];
                    var forceRerender = function() {
                        return setRender({});
                    };
                    var _e = react_1.useState({
                        //initial state
                        cx0: 0,
                        cy0: 0,
                        cw: 0,
                        ch: 0,
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 0,
                        dx: 0,
                        dy: 0,
                        absDx: 0,
                        absDy: 0,
                        cpx1: 0,
                        cpy1: 0,
                        cpx2: 0,
                        cpy2: 0,
                        headOrient: 0,
                        tailOrient: 0,
                        arrowHeadOffset: {
                            x: 0,
                            y: 0
                        },
                        arrowTailOffset: {
                            x: 0,
                            y: 0
                        },
                        headOffset: 0,
                        excRight: 0,
                        excLeft: 0,
                        excUp: 0,
                        excDown: 0,
                        startPoints: [],
                        endPoints: [],
                        mainDivPos: {
                            x: 0,
                            y: 0
                        },
                        xSign: 1,
                        ySign: 1,
                        lineLength: 0,
                        fHeadSize: 1,
                        fTailSize: 1,
                        arrowPath: "",
                        labelStartPos: {
                            x: 0,
                            y: 0
                        },
                        labelMiddlePos: {
                            x: 0,
                            y: 0
                        },
                        labelEndPos: {
                            x: 0,
                            y: 0
                        }
                    }), st = _e[0], setSt = _e[1];
                    /**
     * The Main logic of path calculation for the arrow.
     * calculate new path, adjusting canvas, and set state based on given properties.
     * */ react_1.useLayoutEffect(function() {
                        if (shouldUpdatePosition.current) {
                            // log('xarrow getPosition');
                            var pos = GetPosition_1.getPosition(xProps, mainRef);
                            // log('pos', pos);
                            setSt(pos);
                            shouldUpdatePosition.current = false;
                        }
                    });
                    // log('st', st);
                    var xOffsetHead = st.x2 - st.arrowHeadOffset.x;
                    var yOffsetHead = st.y2 - st.arrowHeadOffset.y;
                    var xOffsetTail = st.x1 - st.arrowTailOffset.x;
                    var yOffsetTail = st.y1 - st.arrowTailOffset.y;
                    var dashoffset = dashness.strokeLen + dashness.nonStrokeLen;
                    var animDirection = 1;
                    if (dashness.animation < 0) {
                        dashness.animation *= -1;
                        animDirection = -1;
                    }
                    var dashArray, animation, animRepeatCount, animStartValue, animEndValue = 0;
                    if (animateDrawing && drawAnimEnded == false) {
                        if (typeof animateDrawing === "boolean") animateDrawing = 1;
                        animation = animateDrawing + "s";
                        dashArray = st.lineLength;
                        animStartValue = st.lineLength;
                        animRepeatCount = 1;
                        if (animateDrawing < 0) {
                            _a = [
                                animEndValue,
                                animStartValue
                            ], animStartValue = _a[0], animEndValue = _a[1];
                            animation = animateDrawing * -1 + "s";
                        }
                    } else {
                        dashArray = dashness.strokeLen + " " + dashness.nonStrokeLen;
                        animation = 1 / dashness.animation + "s";
                        animStartValue = dashoffset * animDirection;
                        animRepeatCount = "indefinite";
                        animEndValue = 0;
                    }
                    // handle draw animation
                    react_1.useLayoutEffect(function() {
                        if (lineRef.current) setSt(function(prevSt) {
                            var _a, _b;
                            return __assign(__assign({}, prevSt), {
                                lineLength: (_b = (_a = lineRef.current) === null || _a === void 0 ? void 0 : _a.getTotalLength()) !== null && _b !== void 0 ? _b : 0
                            });
                        });
                    }, [
                        lineRef.current
                    ]);
                    // set all props on first render
                    react_1.useEffect(function() {
                        var monitorDOMchanges = function() {
                            window.addEventListener("resize", forceRerender);
                            var handleDrawAmimEnd = function() {
                                var _a, _b;
                                setDrawAnimEnded(true);
                                // @ts-ignore
                                (_a = headOpacityAnimRef.current) === null || _a === void 0 || _a.beginElement();
                                // @ts-ignore
                                (_b = lineDashAnimRef.current) === null || _b === void 0 || _b.beginElement();
                            };
                            var handleDrawAmimBegin = function() {
                                return headRef.current.style.opacity = "0";
                            };
                            if (lineDrawAnimRef.current && headRef.current) {
                                lineDrawAnimRef.current.addEventListener("endEvent", handleDrawAmimEnd);
                                lineDrawAnimRef.current.addEventListener("beginEvent", handleDrawAmimBegin);
                            }
                            return function() {
                                window.removeEventListener("resize", forceRerender);
                                if (lineDrawAnimRef.current) {
                                    lineDrawAnimRef.current.removeEventListener("endEvent", handleDrawAmimEnd);
                                    if (headRef.current) lineDrawAnimRef.current.removeEventListener("beginEvent", handleDrawAmimBegin);
                                }
                            };
                        };
                        var cleanMonitorDOMchanges = monitorDOMchanges();
                        return function() {
                            setDrawAnimEnded(false);
                            cleanMonitorDOMchanges();
                        };
                    }, [
                        showXarrow
                    ]);
                    //todo: could make some advanced generic typescript inferring. for example get type from headShape.elem:T and
                    // tailShape.elem:K force the type for passProps,arrowHeadProps,arrowTailProps property. for now `as any` is used to
                    // avoid typescript conflicts
                    // so todo- fix all the `passProps as any` assertions
                    return react_1.default.createElement("div", __assign({}, divContainerProps, {
                        style: __assign({
                            position: "absolute",
                            zIndex: zIndex
                        }, divContainerStyle)
                    }), showXarrow ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("svg", __assign({
                        ref: svgRef,
                        width: st.cw,
                        height: st.ch,
                        style: __assign({
                            position: "absolute",
                            left: st.cx0,
                            top: st.cy0,
                            pointerEvents: "none",
                            border: _debug ? "1px dashed yellow" : null
                        }, SVGcanvasStyle),
                        overflow: "auto"
                    }, SVGcanvasProps), react_1.default.createElement("path", __assign({
                        ref: lineRef,
                        d: st.arrowPath,
                        stroke: lineColor,
                        strokeDasharray: dashArray,
                        // strokeDasharray={'0 0'}
                        strokeWidth: strokeWidth,
                        fill: "transparent",
                        pointerEvents: "visibleStroke"
                    }, passProps, arrowBodyProps), react_1.default.createElement(react_1.default.Fragment, null, drawAnimEnded ? react_1.default.createElement(react_1.default.Fragment, null, dashness.animation ? react_1.default.createElement("animate", {
                        ref: lineDashAnimRef,
                        attributeName: "stroke-dashoffset",
                        values: dashoffset * animDirection + ";0",
                        dur: 1 / dashness.animation + "s",
                        repeatCount: "indefinite"
                    }) : null) : react_1.default.createElement(react_1.default.Fragment, null, animateDrawing ? react_1.default.createElement("animate", {
                        ref: lineDrawAnimRef,
                        id: "svgEndAnimate",
                        attributeName: "stroke-dashoffset",
                        values: animStartValue + ";" + animEndValue,
                        dur: animation,
                        repeatCount: animRepeatCount
                    }) : null))), showTail ? react_1.default.createElement("g", __assign({
                        fill: tailColor,
                        pointerEvents: "auto",
                        transform: "translate(" + xOffsetTail + "," + yOffsetTail + ") rotate(" + st.tailOrient + ") scale(" + st.fTailSize + ")"
                    }, passProps, arrowTailProps), tailShape.svgElem) : null, showHead ? react_1.default.createElement("g", __assign({
                        ref: headRef,
                        // d={normalArrowShape}
                        fill: headColor,
                        pointerEvents: "auto",
                        transform: "translate(" + xOffsetHead + "," + yOffsetHead + ") rotate(" + st.headOrient + ") scale(" + st.fHeadSize + ")",
                        opacity: animateDrawing && !drawAnimEnded ? 0 : 1
                    }, passProps, arrowHeadProps), react_1.default.createElement("animate", {
                        ref: headOpacityAnimRef,
                        dur: "0.4",
                        attributeName: "opacity",
                        from: "0",
                        to: "1",
                        begin: "indefinite",
                        repeatCount: "0",
                        fill: "freeze"
                    }), headShape.svgElem) : null, _debug ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("circle", {
                        r: "5",
                        cx: st.cpx1,
                        cy: st.cpy1,
                        fill: "green"
                    }), react_1.default.createElement("circle", {
                        r: "5",
                        cx: st.cpx2,
                        cy: st.cpy2,
                        fill: "blue"
                    }), react_1.default.createElement("rect", {
                        x: st.excLeft,
                        y: st.excUp,
                        width: st.absDx,
                        height: st.absDy,
                        fill: "none",
                        stroke: "pink",
                        strokeWidth: "2px"
                    })) : null), labels.start ? react_1.default.createElement("div", {
                        style: {
                            transform: st.dx < 0 ? "translate(-100% , -50%)" : "translate(-0% , -50%)",
                            width: "max-content",
                            position: "absolute",
                            left: st.cx0 + st.labelStartPos.x,
                            top: st.cy0 + st.labelStartPos.y - strokeWidth - 5
                        }
                    }, labels.start) : null, labels.middle ? react_1.default.createElement("div", {
                        style: {
                            display: "table",
                            width: "max-content",
                            transform: "translate(-50% , -50%)",
                            position: "absolute",
                            left: st.cx0 + st.labelMiddlePos.x,
                            top: st.cy0 + st.labelMiddlePos.y
                        }
                    }, labels.middle) : null, labels.end ? react_1.default.createElement("div", {
                        style: {
                            transform: st.dx > 0 ? "translate(-100% , -50%)" : "translate(-0% , -50%)",
                            width: "max-content",
                            position: "absolute",
                            left: st.cx0 + st.labelEndPos.x,
                            top: st.cy0 + st.labelEndPos.y + strokeWidth + 5
                        }
                    }, labels.end) : null, _debug ? react_1.default.createElement(react_1.default.Fragment, null, __spreadArray(__spreadArray([], st.startPoints), st.endPoints).map(function(p, i) {
                        return react_1.default.createElement("div", {
                            key: i,
                            style: {
                                background: "gray",
                                opacity: 0.5,
                                borderRadius: "50%",
                                transform: "translate(-50%, -50%)",
                                height: 5,
                                width: 5,
                                position: "absolute",
                                left: p.x - st.mainDivPos.x,
                                top: p.y - st.mainDivPos.y
                            }
                        });
                    })) : null) : null);
                };
                //////////////////////////////
                // propTypes
                Xarrow.propTypes = propTypes_1.default;
                exports.default = Xarrow;
            /***/ },
            /***/ "./src/Xarrow/anchors.ts": /*!*******************************!*\
  !*** ./src/Xarrow/anchors.ts ***!
  \*******************************/ /***/ function(module1, exports, __webpack_require__) {
                /* module decorator */ module1 = __webpack_require__.nmd(module1);
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.calcAnchors = void 0;
                var getAnchorsDefaultOffsets = function(width, height) {
                    return {
                        middle: {
                            x: width * 0.5,
                            y: height * 0.5
                        },
                        left: {
                            x: 0,
                            y: height * 0.5
                        },
                        right: {
                            x: width,
                            y: height * 0.5
                        },
                        top: {
                            x: width * 0.5,
                            y: 0
                        },
                        bottom: {
                            x: width * 0.5,
                            y: height
                        }
                    };
                };
                var calcAnchors = function(anchors, anchorPos) {
                    // now prepare this list of anchors to object expected by the `getShortestLine` function
                    return anchors.map(function(anchor) {
                        var defsOffsets = getAnchorsDefaultOffsets(anchorPos.right - anchorPos.x, anchorPos.bottom - anchorPos.y);
                        var _a = defsOffsets[anchor.position], x = _a.x, y = _a.y;
                        return {
                            x: anchorPos.x + x + anchor.offset.x,
                            y: anchorPos.y + y + anchor.offset.y,
                            anchor: anchor
                        };
                    });
                };
                exports.calcAnchors = calcAnchors;
                __webpack_require__.c[__webpack_require__.s];
            /***/ },
            /***/ "./src/Xarrow/propTypes.ts": /*!*********************************!*\
  !*** ./src/Xarrow/propTypes.ts ***!
  \*********************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var prop_types_1 = __importDefault(__webpack_require__(/*! prop-types */ "prop-types"));
                var constants_1 = __webpack_require__(/*! ../constants */ "./src/constants.tsx");
                var pAnchorPositionType = prop_types_1.default.oneOf(constants_1.cAnchorEdge);
                var pAnchorCustomPositionType = prop_types_1.default.exact({
                    position: pAnchorPositionType.isRequired,
                    offset: prop_types_1.default.exact({
                        x: prop_types_1.default.number,
                        y: prop_types_1.default.number
                    }).isRequired
                });
                var _pAnchorType = prop_types_1.default.oneOfType([
                    pAnchorPositionType,
                    pAnchorCustomPositionType
                ]);
                var pAnchorType = prop_types_1.default.oneOfType([
                    _pAnchorType,
                    prop_types_1.default.arrayOf(_pAnchorType)
                ]);
                var pRefType = prop_types_1.default.oneOfType([
                    prop_types_1.default.string,
                    prop_types_1.default.exact({
                        current: prop_types_1.default.any
                    })
                ]);
                var _pLabelType = prop_types_1.default.oneOfType([
                    prop_types_1.default.element,
                    prop_types_1.default.string
                ]);
                var pLabelsType = prop_types_1.default.exact({
                    start: _pLabelType,
                    middle: _pLabelType,
                    end: _pLabelType
                });
                var pSvgEdgeShapeType = prop_types_1.default.oneOf(Object.keys(constants_1.arrowShapes));
                // const pSvgElemType = PT.oneOf(cSvgElems);
                var pSvgElemType = prop_types_1.default.any;
                var pSvgEdgeType = prop_types_1.default.oneOfType([
                    pSvgEdgeShapeType,
                    prop_types_1.default.exact({
                        svgElem: pSvgElemType,
                        offsetForward: prop_types_1.default.number
                    }).isRequired
                ]);
                var XarrowPropTypes = {
                    start: pRefType.isRequired,
                    end: pRefType.isRequired,
                    startAnchor: pAnchorType,
                    endAnchor: pAnchorType,
                    labels: prop_types_1.default.oneOfType([
                        _pLabelType,
                        pLabelsType
                    ]),
                    color: prop_types_1.default.string,
                    lineColor: prop_types_1.default.string,
                    showHead: prop_types_1.default.bool,
                    headColor: prop_types_1.default.string,
                    headSize: prop_types_1.default.number,
                    tailSize: prop_types_1.default.number,
                    tailColor: prop_types_1.default.string,
                    strokeWidth: prop_types_1.default.number,
                    showTail: prop_types_1.default.bool,
                    path: prop_types_1.default.oneOf(constants_1.cPaths),
                    showXarrow: prop_types_1.default.bool,
                    curveness: prop_types_1.default.number,
                    gridBreak: prop_types_1.default.string,
                    dashness: prop_types_1.default.oneOfType([
                        prop_types_1.default.bool,
                        prop_types_1.default.object
                    ]),
                    headShape: pSvgEdgeType,
                    tailShape: pSvgEdgeType,
                    animateDrawing: prop_types_1.default.oneOfType([
                        prop_types_1.default.bool,
                        prop_types_1.default.number
                    ]),
                    zIndex: prop_types_1.default.number,
                    passProps: prop_types_1.default.object,
                    arrowBodyProps: prop_types_1.default.object,
                    arrowHeadProps: prop_types_1.default.object,
                    arrowTailProps: prop_types_1.default.object,
                    SVGcanvasProps: prop_types_1.default.object,
                    divContainerProps: prop_types_1.default.object,
                    _extendSVGcanvas: prop_types_1.default.number,
                    _debug: prop_types_1.default.bool,
                    _cpx1Offset: prop_types_1.default.number,
                    _cpy1Offset: prop_types_1.default.number,
                    _cpx2Offset: prop_types_1.default.number,
                    _cpy2Offset: prop_types_1.default.number
                };
                exports.default = XarrowPropTypes;
            /***/ },
            /***/ "./src/Xarrow/useXarrowProps.ts": /*!**************************************!*\
  !*** ./src/Xarrow/useXarrowProps.ts ***!
  \**************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    Object.defineProperty(o, k2, {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    });
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                    Object.defineProperty(o, "default", {
                        enumerable: true,
                        value: v
                    });
                } : function(o, v) {
                    o["default"] = v;
                });
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                    }
                    __setModuleDefault(result, mod);
                    return result;
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
                var utils_1 = __webpack_require__(/*! ./utils */ "./src/Xarrow/utils/index.ts");
                var lodash_1 = __importDefault(__webpack_require__(/*! lodash */ "lodash"));
                var constants_1 = __webpack_require__(/*! ../constants */ "./src/constants.tsx");
                var parseLabels = function(label) {
                    var parsedLabel = {
                        start: null,
                        middle: null,
                        end: null
                    };
                    if (label) {
                        if (typeof label === "string" || react_1.default.isValidElement(label)) parsedLabel.middle = label;
                        else for(var key in label)parsedLabel[key] = label[key];
                    }
                    return parsedLabel;
                };
                var parseAnchor = function(anchor) {
                    // convert to array
                    var anchorChoice = Array.isArray(anchor) ? anchor : [
                        anchor
                    ];
                    //convert to array of objects
                    var anchorChoice2 = anchorChoice.map(function(anchorChoice) {
                        if (typeof anchorChoice === "string") return {
                            position: anchorChoice
                        };
                        else return anchorChoice;
                    });
                    //remove any invalid anchor names
                    anchorChoice2 = anchorChoice2.filter(function(an) {
                        return constants_1.cAnchorEdge.includes(an.position);
                    });
                    if (anchorChoice2.length == 0) anchorChoice2 = [
                        {
                            position: "auto"
                        }
                    ];
                    //replace any 'auto' with ['left','right','bottom','top']
                    var autosAncs = anchorChoice2.filter(function(an) {
                        return an.position === "auto";
                    });
                    if (autosAncs.length > 0) {
                        anchorChoice2 = anchorChoice2.filter(function(an) {
                            return an.position !== "auto";
                        });
                        anchorChoice2.push.apply(anchorChoice2, autosAncs.flatMap(function(anchorObj) {
                            return [
                                "left",
                                "right",
                                "top",
                                "bottom"
                            ].map(function(anchorName) {
                                return __assign(__assign({}, anchorObj), {
                                    position: anchorName
                                });
                            });
                        }));
                    }
                    // default values
                    var anchorChoice3 = anchorChoice2.map(function(anchorChoice) {
                        if (typeof anchorChoice === "object") {
                            var anchorChoiceCustom = anchorChoice;
                            if (!anchorChoiceCustom.position) anchorChoiceCustom.position = "auto";
                            if (!anchorChoiceCustom.offset) anchorChoiceCustom.offset = {
                                x: 0,
                                y: 0
                            };
                            if (!anchorChoiceCustom.offset.y) anchorChoiceCustom.offset.y = 0;
                            if (!anchorChoiceCustom.offset.x) anchorChoiceCustom.offset.x = 0;
                            anchorChoiceCustom;
                            return anchorChoiceCustom;
                        } else return anchorChoice;
                    });
                    return anchorChoice3;
                };
                var parseDashness = function(dashness, props) {
                    var dashStroke = 0, dashNone = 0, animDashSpeed, animDirection = 1;
                    if (typeof dashness === "object") {
                        dashStroke = dashness.strokeLen || props.strokeWidth * 2;
                        dashNone = dashness.strokeLen ? dashness.nonStrokeLen : props.strokeWidth;
                        animDashSpeed = dashness.animation ? dashness.animation : null;
                    } else if (typeof dashness === "boolean" && dashness) {
                        dashStroke = props.strokeWidth * 2;
                        dashNone = props.strokeWidth;
                        animDashSpeed = null;
                    }
                    return {
                        strokeLen: dashStroke,
                        nonStrokeLen: dashNone,
                        animation: animDashSpeed,
                        animDirection: animDirection
                    };
                };
                var parseEdgeShape = function(svgEdge) {
                    if (typeof svgEdge == "string") {
                        if (svgEdge in constants_1.arrowShapes) svgEdge = constants_1.arrowShapes[svgEdge];
                        else {
                            console.warn("'" + svgEdge + "' is not supported arrow shape. the supported arrow shapes is one of " + constants_1.cArrowShapes + ".\n           reverting to default shape.");
                            svgEdge = constants_1.arrowShapes["arrow1"];
                        }
                    }
                    svgEdge;
                    if ((svgEdge === null || svgEdge === void 0 ? void 0 : svgEdge.offsetForward) === undefined) svgEdge.offsetForward = 0.25;
                    if ((svgEdge === null || svgEdge === void 0 ? void 0 : svgEdge.svgElem) === undefined) svgEdge.svgElem = "path";
                    // if (svgEdge?.svgProps === undefined) svgEdge.svgProps = arrowShapes.arrow1.svgProps;
                    return svgEdge;
                };
                var parseGridBreak = function(gridBreak) {
                    var resGridBreak = utils_1.xStr2absRelative(gridBreak);
                    if (!resGridBreak) resGridBreak = {
                        relative: 0.5,
                        abs: 0
                    };
                    return resGridBreak;
                };
                /**
 * should be wrapped with any changed prop that is affecting the points path positioning
 * @param propVal
 * @param updateRef
 */ var withUpdate = function(propVal, updateRef) {
                    if (updateRef) updateRef.current = true;
                    return propVal;
                };
                var noParse = function(userProp) {
                    return userProp;
                };
                var noParseWithUpdatePos = function(userProp, _, updatePos) {
                    return withUpdate(userProp, updatePos);
                };
                var parseNumWithUpdatePos = function(userProp, _, updatePos) {
                    return withUpdate(Number(userProp), updatePos);
                };
                var parseNum = function(userProp) {
                    return Number(userProp);
                };
                var parsePropsFuncs = {
                    start: function(userProp) {
                        return utils_1.getElementByPropGiven(userProp);
                    },
                    end: function(userProp) {
                        return utils_1.getElementByPropGiven(userProp);
                    },
                    startAnchor: function(userProp, _, updatePos) {
                        return withUpdate(parseAnchor(userProp), updatePos);
                    },
                    endAnchor: function(userProp, _, updatePos) {
                        return withUpdate(parseAnchor(userProp), updatePos);
                    },
                    labels: function(userProp) {
                        return parseLabels(userProp);
                    },
                    color: noParse,
                    lineColor: function(userProp, propsRefs) {
                        return userProp || propsRefs.color;
                    },
                    headColor: function(userProp, propsRefs) {
                        return userProp || propsRefs.color;
                    },
                    tailColor: function(userProp, propsRefs) {
                        return userProp || propsRefs.color;
                    },
                    strokeWidth: parseNumWithUpdatePos,
                    showHead: noParseWithUpdatePos,
                    headSize: parseNumWithUpdatePos,
                    showTail: noParseWithUpdatePos,
                    tailSize: parseNumWithUpdatePos,
                    path: noParseWithUpdatePos,
                    curveness: parseNumWithUpdatePos,
                    gridBreak: function(userProp, _, updatePos) {
                        return withUpdate(parseGridBreak(userProp), updatePos);
                    },
                    // // gridRadius = strokeWidth * 2, //todo
                    dashness: function(userProp, propsRefs) {
                        return parseDashness(userProp, propsRefs);
                    },
                    headShape: function(userProp) {
                        return parseEdgeShape(userProp);
                    },
                    tailShape: function(userProp) {
                        return parseEdgeShape(userProp);
                    },
                    showXarrow: noParse,
                    animateDrawing: noParse,
                    zIndex: parseNum,
                    passProps: noParse,
                    arrowBodyProps: noParseWithUpdatePos,
                    arrowHeadProps: noParseWithUpdatePos,
                    arrowTailProps: noParseWithUpdatePos,
                    SVGcanvasProps: noParseWithUpdatePos,
                    divContainerProps: noParseWithUpdatePos,
                    divContainerStyle: noParseWithUpdatePos,
                    SVGcanvasStyle: noParseWithUpdatePos,
                    _extendSVGcanvas: noParseWithUpdatePos,
                    _debug: noParseWithUpdatePos,
                    _cpx1Offset: noParseWithUpdatePos,
                    _cpy1Offset: noParseWithUpdatePos,
                    _cpx2Offset: noParseWithUpdatePos,
                    _cpy2Offset: noParseWithUpdatePos
                };
                //build dependencies
                var propsDeps = {};
                //each prop depends on himself
                for(var propName in parsePropsFuncs)propsDeps[propName] = [
                    propName
                ];
                // 'lineColor', 'headColor', 'tailColor' props also depends on 'color' prop
                for(var _i = 0, _a = [
                    "lineColor",
                    "headColor",
                    "tailColor"
                ]; _i < _a.length; _i++){
                    var propName = _a[_i];
                    propsDeps[propName].push("color");
                }
                var parseGivenProps = function(props, propsRef) {
                    var _a;
                    for(var _i = 0, _b = Object.entries(props); _i < _b.length; _i++){
                        var _c = _b[_i], name_1 = _c[0], val = _c[1];
                        propsRef[name_1] = (_a = parsePropsFuncs === null || parsePropsFuncs === void 0 ? void 0 : parsePropsFuncs[name_1]) === null || _a === void 0 ? void 0 : _a.call(parsePropsFuncs, val, propsRef);
                    }
                    return propsRef;
                };
                var defaultProps = {
                    start: null,
                    end: null,
                    startAnchor: "auto",
                    endAnchor: "auto",
                    labels: null,
                    color: "CornflowerBlue",
                    lineColor: null,
                    headColor: null,
                    tailColor: null,
                    strokeWidth: 4,
                    showHead: true,
                    headSize: 6,
                    showTail: false,
                    tailSize: 6,
                    path: "smooth",
                    curveness: 0.8,
                    gridBreak: "50%",
                    // gridRadius : strokeWidth * 2, //todo
                    dashness: false,
                    headShape: "arrow1",
                    tailShape: "arrow1",
                    showXarrow: true,
                    animateDrawing: false,
                    zIndex: 0,
                    passProps: {},
                    arrowBodyProps: {},
                    arrowHeadProps: {},
                    arrowTailProps: {},
                    SVGcanvasProps: {},
                    divContainerProps: {},
                    divContainerStyle: {},
                    SVGcanvasStyle: {},
                    _extendSVGcanvas: 0,
                    _debug: false,
                    _cpx1Offset: 0,
                    _cpy1Offset: 0,
                    _cpx2Offset: 0,
                    _cpy2Offset: 0
                };
                var initialParsedProps = {};
                initialParsedProps = parseGivenProps(defaultProps, initialParsedProps);
                var initialValVars = {
                    startPos: {
                        x: 0,
                        y: 0,
                        right: 0,
                        bottom: 0
                    },
                    endPos: {
                        x: 0,
                        y: 0,
                        right: 0,
                        bottom: 0
                    }
                };
                // const parseAllProps = () => parseGivenProps(defaultProps, initialParsedProps);
                function deepCompareEquals(a, b) {
                    return lodash_1.default.isEqual(a, b);
                }
                function useDeepCompareMemoize(value) {
                    var ref = react_1.useRef();
                    // it can be done by using useMemo as well
                    // but useRef is rather cleaner and easier
                    if (!deepCompareEquals(value, ref.current)) ref.current = value;
                    return ref.current;
                }
                function useDeepCompareEffect(callback, dependencies) {
                    react_1.useLayoutEffect(callback, dependencies.map(useDeepCompareMemoize));
                }
                /**
 * smart hook that provides parsed props to Xarrow and will trigger rerender whenever given prop is changed.
 */ var useXarrowProps = function(userProps, refs) {
                    var _a = react_1.useState(initialParsedProps), propsRefs = _a[0], setPropsRefs = _a[1];
                    var shouldUpdatePosition = react_1.useRef(false);
                    // const _propsRefs = useRef(initialParsedProps);
                    // const propsRefs = _propsRefs.current;
                    propsRefs["shouldUpdatePosition"] = shouldUpdatePosition;
                    var curProps = __assign(__assign({}, defaultProps), userProps);
                    var _loop_1 = function(propName) {
                        react_1.useLayoutEffect(function() {
                            var _a;
                            propsRefs[propName] = (_a = parsePropsFuncs === null || parsePropsFuncs === void 0 ? void 0 : parsePropsFuncs[propName]) === null || _a === void 0 ? void 0 : _a.call(parsePropsFuncs, curProps[propName], propsRefs, shouldUpdatePosition);
                            // console.log('prop update:', propName, 'with value', propsRefs[propName]);
                            setPropsRefs(__assign({}, propsRefs));
                        }, propsDeps[propName].map(function(name) {
                            return userProps[name];
                        }));
                    };
                    // react states the number of hooks per render must stay constant,
                    // this is ok we are using these hooks in a loop, because the number of props in defaultProps is constant,
                    // so the number of hook we will fire each render will always be the same.
                    // update the value of the ref that represents the corresponding prop
                    // for example: if given 'start' prop would change call getElementByPropGiven(props.start) and save value into propsRefs.start.current
                    // why to save refs to props parsed values? some of the props require relatively expensive computations(like 'start' and 'startAnchor').
                    // this will always run in the same order and THAT'S WAY ITS LEGAL
                    for(var propName in defaultProps)_loop_1(propName);
                    // rerender whenever position of start element or end element changes
                    var _b = react_1.useState(initialValVars), valVars = _b[0], setValVars = _b[1];
                    var startPos = utils_1.getElemPos(propsRefs.start);
                    useDeepCompareEffect(function() {
                        valVars.startPos = startPos;
                        shouldUpdatePosition.current = true;
                        setValVars(__assign({}, valVars));
                    // console.log('start update pos', startPos);
                    }, [
                        startPos
                    ]);
                    var endPos = utils_1.getElemPos(propsRefs.end);
                    useDeepCompareEffect(function() {
                        valVars.endPos = endPos;
                        shouldUpdatePosition.current = true;
                        setValVars(__assign({}, valVars));
                    // console.log('end update pos', endPos);
                    }, [
                        endPos
                    ]);
                    react_1.useLayoutEffect(function() {
                        // console.log('svg shape changed!');
                        shouldUpdatePosition.current = true;
                        setValVars(__assign({}, valVars));
                    }, [
                        propsRefs.headShape.svgElem,
                        propsRefs.tailShape.svgElem
                    ]);
                    return [
                        propsRefs,
                        valVars
                    ];
                };
                exports.default = useXarrowProps;
            /***/ },
            /***/ "./src/Xarrow/utils/GetPosition.tsx": /*!******************************************!*\
  !*** ./src/Xarrow/utils/GetPosition.tsx ***!
  \******************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getPosition = void 0;
                var anchors_1 = __webpack_require__(/*! ../anchors */ "./src/Xarrow/anchors.ts");
                var index_1 = __webpack_require__(/*! ./index */ "./src/Xarrow/utils/index.ts");
                var lodash_1 = __importDefault(__webpack_require__(/*! lodash */ "lodash"));
                var constants_1 = __webpack_require__(/*! ../../constants */ "./src/constants.tsx");
                var buzzier_1 = __webpack_require__(/*! ./buzzier */ "./src/Xarrow/utils/buzzier.js");
                /**
 * The Main logic of path calculation for the arrow.
 * calculate new path, adjusting canvas, and set state based on given properties.
 * */ var getPosition = function(xProps, mainRef) {
                    var _a, _b;
                    var _c, _d;
                    var propsRefs = xProps[0], valVars = xProps[1];
                    var startAnchor = propsRefs.startAnchor, endAnchor = propsRefs.endAnchor, strokeWidth = propsRefs.strokeWidth, showHead = propsRefs.showHead, headSize = propsRefs.headSize, showTail = propsRefs.showTail, tailSize = propsRefs.tailSize, path = propsRefs.path, curveness = propsRefs.curveness, gridBreak = propsRefs.gridBreak, headShape = propsRefs.headShape, tailShape = propsRefs.tailShape, _extendSVGcanvas = propsRefs._extendSVGcanvas, _cpx1Offset = propsRefs._cpx1Offset, _cpy1Offset = propsRefs._cpy1Offset, _cpx2Offset = propsRefs._cpx2Offset, _cpy2Offset = propsRefs._cpy2Offset;
                    var startPos = valVars.startPos, endPos = valVars.endPos;
                    var _e = mainRef.current, svgRef = _e.svgRef, lineRef = _e.lineRef;
                    var headOrient = 0;
                    var tailOrient = 0;
                    // convert startAnchor and endAnchor to list of objects represents allowed anchors.
                    var startPoints = anchors_1.calcAnchors(startAnchor, startPos);
                    var endPoints = anchors_1.calcAnchors(endAnchor, endPos);
                    // choose the smallest path for 2 points from these possibilities.
                    var _f = index_1.getShortestLine(startPoints, endPoints), chosenStart = _f.chosenStart, chosenEnd = _f.chosenEnd;
                    var startAnchorPosition = chosenStart.anchor.position, endAnchorPosition = chosenEnd.anchor.position;
                    var startPoint = lodash_1.default.pick(chosenStart, [
                        "x",
                        "y"
                    ]), endPoint = lodash_1.default.pick(chosenEnd, [
                        "x",
                        "y"
                    ]);
                    var mainDivPos = index_1.getSvgPos(svgRef);
                    var cx0 = Math.min(startPoint.x, endPoint.x) - mainDivPos.x;
                    var cy0 = Math.min(startPoint.y, endPoint.y) - mainDivPos.y;
                    var dx = endPoint.x - startPoint.x;
                    var dy = endPoint.y - startPoint.y;
                    var absDx = Math.abs(endPoint.x - startPoint.x);
                    var absDy = Math.abs(endPoint.y - startPoint.y);
                    var xSign = dx > 0 ? 1 : -1;
                    var ySign = dy > 0 ? 1 : -1;
                    var _g = [
                        headShape.offsetForward,
                        tailShape.offsetForward
                    ], headOffset = _g[0], tailOffset = _g[1];
                    var fHeadSize = headSize * strokeWidth; //factored head size
                    var fTailSize = tailSize * strokeWidth; //factored head size
                    // const { current: _headBox } = headBox;
                    var xHeadOffset = 0;
                    var yHeadOffset = 0;
                    var xTailOffset = 0;
                    var yTailOffset = 0;
                    var _headOffset = fHeadSize * headOffset;
                    var _tailOffset = fTailSize * tailOffset;
                    var cu = Number(curveness);
                    // gridRadius = Number(gridRadius);
                    if (!constants_1.cPaths.includes(path)) path = "smooth";
                    if (path === "straight") {
                        cu = 0;
                        path = "smooth";
                    }
                    var biggerSide = headSize > tailSize ? headSize : tailSize;
                    var _calc = strokeWidth + strokeWidth * biggerSide / 2;
                    var excRight = _calc;
                    var excLeft = _calc;
                    var excUp = _calc;
                    var excDown = _calc;
                    excLeft += Number(_extendSVGcanvas);
                    excRight += Number(_extendSVGcanvas);
                    excUp += Number(_extendSVGcanvas);
                    excDown += Number(_extendSVGcanvas);
                    ////////////////////////////////////
                    // arrow point to point calculations
                    var x1 = 0, x2 = absDx, y1 = 0, y2 = absDy;
                    if (dx < 0) _a = [
                        x2,
                        x1
                    ], x1 = _a[0], x2 = _a[1];
                    if (dy < 0) _b = [
                        y2,
                        y1
                    ], y1 = _b[0], y2 = _b[1];
                    ////////////////////////////////////
                    // arrow curviness and arrowhead placement calculations
                    if (cu === 0) {
                        // in case of straight path
                        var headAngel = Math.atan(absDy / absDx);
                        if (showHead) {
                            x2 -= fHeadSize * (1 - headOffset) * xSign * Math.cos(headAngel);
                            y2 -= fHeadSize * (1 - headOffset) * ySign * Math.sin(headAngel);
                            headAngel *= ySign;
                            if (xSign < 0) headAngel = (Math.PI - headAngel * xSign) * xSign;
                            xHeadOffset = Math.cos(headAngel) * _headOffset - Math.sin(headAngel) * fHeadSize / 2;
                            yHeadOffset = Math.cos(headAngel) * fHeadSize / 2 + Math.sin(headAngel) * _headOffset;
                            headOrient = headAngel * 180 / Math.PI;
                        }
                        var tailAngel = Math.atan(absDy / absDx);
                        if (showTail) {
                            x1 += fTailSize * (1 - tailOffset) * xSign * Math.cos(tailAngel);
                            y1 += fTailSize * (1 - tailOffset) * ySign * Math.sin(tailAngel);
                            tailAngel *= -ySign;
                            if (xSign > 0) tailAngel = (Math.PI - tailAngel * xSign) * xSign;
                            xTailOffset = Math.cos(tailAngel) * _tailOffset - Math.sin(tailAngel) * fTailSize / 2;
                            yTailOffset = Math.cos(tailAngel) * fTailSize / 2 + Math.sin(tailAngel) * _tailOffset;
                            tailOrient = tailAngel * 180 / Math.PI;
                        }
                    } else {
                        // in case of smooth path
                        if (endAnchorPosition === "middle") {
                            // in case a middle anchor is chosen for endAnchor choose from which side to attach to the middle of the element
                            if (absDx > absDy) endAnchorPosition = xSign ? "left" : "right";
                            else endAnchorPosition = ySign ? "top" : "bottom";
                        }
                        if (showHead) {
                            if ([
                                "left",
                                "right"
                            ].includes(endAnchorPosition)) {
                                xHeadOffset += _headOffset * xSign;
                                x2 -= fHeadSize * (1 - headOffset) * xSign; //same!
                                yHeadOffset += fHeadSize * xSign / 2;
                                if (endAnchorPosition === "left") {
                                    headOrient = 0;
                                    if (xSign < 0) headOrient += 180;
                                } else {
                                    headOrient = 180;
                                    if (xSign > 0) headOrient += 180;
                                }
                            } else if ([
                                "top",
                                "bottom"
                            ].includes(endAnchorPosition)) {
                                xHeadOffset += fHeadSize * -ySign / 2;
                                yHeadOffset += _headOffset * ySign;
                                y2 -= fHeadSize * ySign - yHeadOffset;
                                if (endAnchorPosition === "top") {
                                    headOrient = 270;
                                    if (ySign > 0) headOrient += 180;
                                } else {
                                    headOrient = 90;
                                    if (ySign < 0) headOrient += 180;
                                }
                            }
                        }
                    }
                    if (showTail && cu !== 0) {
                        if ([
                            "left",
                            "right"
                        ].includes(startAnchorPosition)) {
                            xTailOffset += _tailOffset * -xSign;
                            x1 += fTailSize * xSign + xTailOffset;
                            yTailOffset += -(fTailSize * xSign) / 2;
                            if (startAnchorPosition === "left") {
                                tailOrient = 180;
                                if (xSign < 0) tailOrient += 180;
                            } else {
                                tailOrient = 0;
                                if (xSign > 0) tailOrient += 180;
                            }
                        } else if ([
                            "top",
                            "bottom"
                        ].includes(startAnchorPosition)) {
                            yTailOffset += _tailOffset * -ySign;
                            y1 += fTailSize * ySign + yTailOffset;
                            xTailOffset += fTailSize * ySign / 2;
                            if (startAnchorPosition === "top") {
                                tailOrient = 90;
                                if (ySign > 0) tailOrient += 180;
                            } else {
                                tailOrient = 270;
                                if (ySign < 0) tailOrient += 180;
                            }
                        }
                    }
                    var arrowHeadOffset = {
                        x: xHeadOffset,
                        y: yHeadOffset
                    };
                    var arrowTailOffset = {
                        x: xTailOffset,
                        y: yTailOffset
                    };
                    var cpx1 = x1, cpy1 = y1, cpx2 = x2, cpy2 = y2;
                    var curvesPossibilities = {};
                    if (path === "smooth") curvesPossibilities = {
                        hh: function() {
                            //horizontal - from right to left or the opposite
                            cpx1 += absDx * cu * xSign;
                            cpx2 -= absDx * cu * xSign;
                        },
                        vv: function() {
                            //vertical - from top to bottom or opposite
                            cpy1 += absDy * cu * ySign;
                            cpy2 -= absDy * cu * ySign;
                        },
                        hv: function() {
                            // start horizontally then vertically
                            // from v side to h side
                            cpx1 += absDx * cu * xSign;
                            cpy2 -= absDy * cu * ySign;
                        },
                        vh: function() {
                            // start vertically then horizontally
                            // from h side to v side
                            cpy1 += absDy * cu * ySign;
                            cpx2 -= absDx * cu * xSign;
                        }
                    };
                    else if (path === "grid") curvesPossibilities = {
                        hh: function() {
                            cpx1 += (absDx * gridBreak.relative + gridBreak.abs) * xSign;
                            cpx2 -= (absDx * (1 - gridBreak.relative) - gridBreak.abs) * xSign;
                            if (showHead) {
                                cpx1 -= fHeadSize * (1 - headOffset) / 2 * xSign;
                                cpx2 += fHeadSize * (1 - headOffset) / 2 * xSign;
                            }
                            if (showTail) {
                                cpx1 -= fTailSize * (1 - tailOffset) / 2 * xSign;
                                cpx2 += fTailSize * (1 - tailOffset) / 2 * xSign;
                            }
                        },
                        vv: function() {
                            cpy1 += (absDy * gridBreak.relative + gridBreak.abs) * ySign;
                            cpy2 -= (absDy * (1 - gridBreak.relative) - gridBreak.abs) * ySign;
                            if (showHead) {
                                cpy1 -= fHeadSize * (1 - headOffset) / 2 * ySign;
                                cpy2 += fHeadSize * (1 - headOffset) / 2 * ySign;
                            }
                            if (showTail) {
                                cpy1 -= fTailSize * (1 - tailOffset) / 2 * ySign;
                                cpy2 += fTailSize * (1 - tailOffset) / 2 * ySign;
                            }
                        },
                        hv: function() {
                            cpx1 = x2;
                        },
                        vh: function() {
                            cpy1 = y2;
                        }
                    };
                    // smart select best curve for the current anchors
                    var selectedCurviness = "";
                    if ([
                        "left",
                        "right"
                    ].includes(startAnchorPosition)) selectedCurviness += "h";
                    else if ([
                        "bottom",
                        "top"
                    ].includes(startAnchorPosition)) selectedCurviness += "v";
                    else if (startAnchorPosition === "middle") selectedCurviness += "m";
                    if ([
                        "left",
                        "right"
                    ].includes(endAnchorPosition)) selectedCurviness += "h";
                    else if ([
                        "bottom",
                        "top"
                    ].includes(endAnchorPosition)) selectedCurviness += "v";
                    else if (endAnchorPosition === "middle") selectedCurviness += "m";
                    if (absDx > absDy) selectedCurviness = selectedCurviness.replace(/m/g, "h");
                    else selectedCurviness = selectedCurviness.replace(/m/g, "v");
                    curvesPossibilities[selectedCurviness]();
                    cpx1 += _cpx1Offset;
                    cpy1 += _cpy1Offset;
                    cpx2 += _cpx2Offset;
                    cpy2 += _cpy2Offset;
                    ////////////////////////////////////
                    // canvas smart size adjustments
                    var _h = buzzier_1.buzzierMinSols(x1, cpx1, cpx2, x2), xSol1 = _h[0], xSol2 = _h[1];
                    var _j = buzzier_1.buzzierMinSols(y1, cpy1, cpy2, y2), ySol1 = _j[0], ySol2 = _j[1];
                    if (xSol1 < 0) excLeft += -xSol1;
                    if (xSol2 > absDx) excRight += xSol2 - absDx;
                    if (ySol1 < 0) excUp += -ySol1;
                    if (ySol2 > absDy) excDown += ySol2 - absDy;
                    if (path === "grid") {
                        excLeft += _calc;
                        excRight += _calc;
                        excUp += _calc;
                        excDown += _calc;
                    }
                    x1 += excLeft;
                    x2 += excLeft;
                    y1 += excUp;
                    y2 += excUp;
                    cpx1 += excLeft;
                    cpx2 += excLeft;
                    cpy1 += excUp;
                    cpy2 += excUp;
                    var cw = absDx + excLeft + excRight, ch = absDy + excUp + excDown;
                    cx0 -= excLeft;
                    cy0 -= excUp;
                    //labels
                    var bzx = buzzier_1.bzFunction(x1, cpx1, cpx2, x2);
                    var bzy = buzzier_1.bzFunction(y1, cpy1, cpy2, y2);
                    var labelStartPos = {
                        x: bzx(0.01),
                        y: bzy(0.01)
                    };
                    var labelMiddlePos = {
                        x: bzx(0.5),
                        y: bzy(0.5)
                    };
                    var labelEndPos = {
                        x: bzx(0.99),
                        y: bzy(0.99)
                    };
                    var arrowPath;
                    if (path === "grid") // todo: support gridRadius
                    //  arrowPath = `M ${x1} ${y1} L  ${cpx1 - 10} ${cpy1} a10,10 0 0 1 10,10
                    // L ${cpx2} ${cpy2 - 10} a10,10 0 0 0 10,10 L  ${x2} ${y2}`;
                    arrowPath = "M " + x1 + " " + y1 + " L  " + cpx1 + " " + cpy1 + " L " + cpx2 + " " + cpy2 + " " + x2 + " " + y2;
                    else if (path === "smooth") arrowPath = "M " + x1 + " " + y1 + " C " + cpx1 + " " + cpy1 + ", " + cpx2 + " " + cpy2 + ", " + x2 + " " + y2;
                    return {
                        cx0: cx0,
                        cy0: cy0,
                        x1: x1,
                        x2: x2,
                        y1: y1,
                        y2: y2,
                        cw: cw,
                        ch: ch,
                        cpx1: cpx1,
                        cpy1: cpy1,
                        cpx2: cpx2,
                        cpy2: cpy2,
                        dx: dx,
                        dy: dy,
                        absDx: absDx,
                        absDy: absDy,
                        headOrient: headOrient,
                        tailOrient: tailOrient,
                        labelStartPos: labelStartPos,
                        labelMiddlePos: labelMiddlePos,
                        labelEndPos: labelEndPos,
                        excLeft: excLeft,
                        excRight: excRight,
                        excUp: excUp,
                        excDown: excDown,
                        headOffset: _headOffset,
                        arrowHeadOffset: arrowHeadOffset,
                        arrowTailOffset: arrowTailOffset,
                        startPoints: startPoints,
                        endPoints: endPoints,
                        mainDivPos: mainDivPos,
                        xSign: xSign,
                        ySign: ySign,
                        lineLength: (_d = (_c = lineRef.current) === null || _c === void 0 ? void 0 : _c.getTotalLength()) !== null && _d !== void 0 ? _d : 0,
                        fHeadSize: fHeadSize,
                        fTailSize: fTailSize,
                        arrowPath: arrowPath
                    };
                };
                exports.getPosition = getPosition;
            /***/ },
            /***/ "./src/Xarrow/utils/index.ts": /*!***********************************!*\
  !*** ./src/Xarrow/utils/index.ts ***!
  \***********************************/ /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getSvgPos = exports.getElemPos = exports.getShortestLine = exports.xStr2absRelative = exports.factorDpathStr = exports.getElementByPropGiven = void 0;
                var getElementByPropGiven = function(ref) {
                    var myRef;
                    if (typeof ref === "string") // myRef = document.getElementById(ref);
                    myRef = document.getElementById(ref);
                    else myRef = ref === null || ref === void 0 ? void 0 : ref.current;
                    return myRef;
                };
                exports.getElementByPropGiven = getElementByPropGiven;
                // receives string representing a d path and factoring only the numbers
                var factorDpathStr = function(d, factor) {
                    var l = d.split(/(\d+(?:\.\d+)?)/);
                    l = l.map(function(s) {
                        if (Number(s)) return (Number(s) * factor).toString();
                        else return s;
                    });
                    return l.join("");
                };
                exports.factorDpathStr = factorDpathStr;
                // return relative,abs
                var xStr2absRelative = function(str) {
                    if (typeof str !== "string") return {
                        abs: 0,
                        relative: 0.5
                    };
                    var sp = str.split("%");
                    var absLen = 0, percentLen = 0;
                    if (sp.length == 1) {
                        var p = parseFloat(sp[0]);
                        if (!isNaN(p)) {
                            absLen = p;
                            return {
                                abs: absLen,
                                relative: 0
                            };
                        }
                    } else if (sp.length == 2) {
                        var _a = [
                            parseFloat(sp[0]),
                            parseFloat(sp[1])
                        ], p1 = _a[0], p2 = _a[1];
                        if (!isNaN(p1)) percentLen = p1 / 100;
                        if (!isNaN(p2)) absLen = p2;
                        if (!isNaN(p1) || !isNaN(p2)) return {
                            abs: absLen,
                            relative: percentLen
                        };
                    }
                };
                exports.xStr2absRelative = xStr2absRelative;
                var dist = function(p1, p2) {
                    //length of line
                    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
                };
                var getShortestLine = function(sPoints, ePoints) {
                    // closes tPair Of Points which feet to the specified anchors
                    var minDist = Infinity, d = Infinity;
                    var closestPair;
                    sPoints.forEach(function(sp) {
                        ePoints.forEach(function(ep) {
                            d = dist(sp, ep);
                            if (d < minDist) {
                                minDist = d;
                                closestPair = {
                                    chosenStart: sp,
                                    chosenEnd: ep
                                };
                            }
                        });
                    });
                    return closestPair;
                };
                exports.getShortestLine = getShortestLine;
                var getElemPos = function(elem) {
                    if (!elem) return {
                        x: 0,
                        y: 0,
                        right: 0,
                        bottom: 0
                    };
                    var pos = elem.getBoundingClientRect();
                    return {
                        x: pos.left,
                        y: pos.top,
                        right: pos.right,
                        bottom: pos.bottom
                    };
                };
                exports.getElemPos = getElemPos;
                var getSvgPos = function(svgRef) {
                    if (!svgRef.current) return {
                        x: 0,
                        y: 0
                    };
                    var _a = svgRef.current.getBoundingClientRect(), xarrowElemX = _a.left, xarrowElemY = _a.top;
                    var xarrowStyle = getComputedStyle(svgRef.current);
                    var xarrowStyleLeft = Number(xarrowStyle.left.slice(0, -2));
                    var xarrowStyleTop = Number(xarrowStyle.top.slice(0, -2));
                    return {
                        x: xarrowElemX - xarrowStyleLeft,
                        y: xarrowElemY - xarrowStyleTop
                    };
                };
                exports.getSvgPos = getSvgPos;
            /***/ },
            /***/ "./src/Xwrapper.tsx": /*!**************************!*\
  !*** ./src/Xwrapper.tsx ***!
  \**************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    Object.defineProperty(o, k2, {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    });
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
                    Object.defineProperty(o, "default", {
                        enumerable: true,
                        value: v
                    });
                } : function(o, v) {
                    o["default"] = v;
                });
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
                    }
                    __setModuleDefault(result, mod);
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XarrowContext = exports.XelemContext = void 0;
                var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
                exports.XelemContext = react_1.default.createContext(null);
                exports.XarrowContext = react_1.default.createContext(null);
                var updateRef = {};
                var updateRefCount = 0;
                var log = console.log;
                var XarrowProvider = function(_a) {
                    var children = _a.children, instanceCount = _a.instanceCount;
                    var _b = react_1.useState({}), setRender = _b[1];
                    var updateXarrow = function() {
                        return setRender({});
                    };
                    react_1.useEffect(function() {
                        instanceCount.current = updateRefCount; // so this instance would know what is id
                        updateRef[instanceCount.current] = updateXarrow;
                    }, []);
                    // log('XarrowProvider', updateRefCount);
                    return react_1.default.createElement(exports.XarrowContext.Provider, {
                        value: updateXarrow
                    }, children);
                };
                var XelemProvider = function(_a) {
                    var children = _a.children, instanceCount = _a.instanceCount;
                    return react_1.default.createElement(exports.XelemContext.Provider, {
                        value: updateRef[instanceCount.current]
                    }, children);
                };
                var Xwrapper = function(_a) {
                    var children = _a.children;
                    var instanceCount = react_1.useRef(updateRefCount);
                    var _b = react_1.useState({}), setRender = _b[1];
                    react_1.useEffect(function() {
                        updateRefCount++;
                        setRender({});
                        return function() {
                            delete updateRef[instanceCount.current];
                        };
                    }, []);
                    return react_1.default.createElement(XelemProvider, {
                        instanceCount: instanceCount
                    }, react_1.default.createElement(XarrowProvider, {
                        instanceCount: instanceCount
                    }, children));
                };
                exports.default = Xwrapper;
            /***/ },
            /***/ "./src/constants.tsx": /*!***************************!*\
  !*** ./src/constants.tsx ***!
  \***************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.cArrowShapes = exports.arrowShapes = exports.cSvgElems = exports.cPaths = exports.cAnchorEdge = void 0;
                // constants used for typescript and proptypes definitions
                var react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
                exports.cAnchorEdge = [
                    "middle",
                    "left",
                    "right",
                    "top",
                    "bottom",
                    "auto"
                ];
                exports.cPaths = [
                    "smooth",
                    "grid",
                    "straight"
                ];
                exports.cSvgElems = [
                    "circle",
                    "ellipse",
                    "line",
                    "path",
                    "polygon",
                    "polyline",
                    "rect"
                ];
                //default arrows svgs
                exports.arrowShapes = {
                    arrow1: {
                        svgElem: react_1.default.createElement("path", {
                            d: "M 0 0 L 1 0.5 L 0 1 L 0.25 0.5 z"
                        }),
                        offsetForward: 0.25
                    },
                    heart: {
                        svgElem: react_1.default.createElement("path", {
                            d: "M 0,0.25 A 0.125,0.125 0,0,1 0.5,0.25 A 0.125,0.125 0,0,1 1,0.25 Q 1,0.625 0.5,1 Q 0,0.625 0,0.25 z"
                        }),
                        offsetForward: 0.1
                    },
                    circle: {
                        svgElem: react_1.default.createElement("circle", {
                            r: 0.5,
                            cx: 0.5,
                            cy: 0.5
                        }),
                        offsetForward: 0
                    }
                };
                exports.cArrowShapes = Object.keys(exports.arrowShapes);
            /***/ },
            /***/ "./src/index.tsx": /*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    Object.defineProperty(o, k2, {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    });
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.useXarrow = exports.Xwrapper = exports.default = void 0;
                var Xarrow_1 = __webpack_require__(/*! ./Xarrow/Xarrow */ "./src/Xarrow/Xarrow.tsx");
                Object.defineProperty(exports, "default", {
                    enumerable: true,
                    get: function() {
                        return __importDefault(Xarrow_1).default;
                    }
                });
                __exportStar(__webpack_require__(/*! ./types */ "./src/types.ts"), exports);
                __exportStar(__webpack_require__(/*! ./constants */ "./src/constants.tsx"), exports);
                var Xwrapper_1 = __webpack_require__(/*! ./Xwrapper */ "./src/Xwrapper.tsx");
                Object.defineProperty(exports, "Xwrapper", {
                    enumerable: true,
                    get: function() {
                        return __importDefault(Xwrapper_1).default;
                    }
                });
                var useXarrow_1 = __webpack_require__(/*! ./useXarrow */ "./src/useXarrow.tsx");
                Object.defineProperty(exports, "useXarrow", {
                    enumerable: true,
                    get: function() {
                        return __importDefault(useXarrow_1).default;
                    }
                });
            /***/ },
            /***/ "./src/types.ts": /*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/ /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ "./src/useXarrow.tsx": /*!***************************!*\
  !*** ./src/useXarrow.tsx ***!
  \***************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var react_1 = __webpack_require__(/*! react */ "react");
                var Xwrapper_1 = __webpack_require__(/*! ./Xwrapper */ "./src/Xwrapper.tsx");
                var useXarrow = function() {
                    var _a = react_1.useState({}), setRender = _a[1];
                    var reRender = function() {
                        return setRender({});
                    };
                    var updateXarrow = react_1.useContext(Xwrapper_1.XelemContext);
                    if (!updateXarrow) updateXarrow = function() {};
                    // throw new Error(
                    //   "'Xwrapper' is required around element using 'useXarrow' hook! wrap your xarrows and connected elements with Xwrapper! "
                    // );
                    react_1.useLayoutEffect(function() {
                        updateXarrow();
                    });
                    return reRender;
                };
                exports.default = useXarrow;
            /***/ },
            /***/ "lodash": /*!*************************!*\
  !*** external "lodash" ***!
  \*************************/ /***/ function(module1) {
                module1.exports = __WEBPACK_EXTERNAL_MODULE_lodash__;
            /***/ },
            /***/ "prop-types": /*!*****************************!*\
  !*** external "prop-types" ***!
  \*****************************/ /***/ function(module1) {
                module1.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;
            /***/ },
            /***/ "react": /*!************************!*\
  !*** external "react" ***!
  \************************/ /***/ function(module1) {
                module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = __webpack_module_cache__;
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/node module decorator */ /******/ !function() {
            /******/ __webpack_require__.nmd = function(module1) {
                /******/ module1.paths = [];
                /******/ if (!module1.children) module1.children = [];
                /******/ return module1;
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ /******/ /******/ // module cache are used so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ var __webpack_exports__ = __webpack_require__(__webpack_require__.s = "./src/index.tsx");
        /******/ /******/ return __webpack_exports__;
    /******/ }();
});

},{"9eea94e602d2573a":"cOWTg","38808aaba5723947":"2Y3mz","b9a0a1fcaa1d0d5b":"jc0Wl"}],"2Y3mz":[function(require,module,exports) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.18.1";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`", INVALID_TEMPL_IMPORTS_ERROR_TEXT = "Invalid `imports` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === "__proto__" && !hasOwnProperty.call(object, "__proto__")) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === "constructor" || key === "prototype") && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"3WuPv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _reactTable = require("@tanstack/react-table");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _numbersUtils = require("../../utils/numbersUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function TableHeaderCell(props) {
    const { header, expandable, onSortChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const table = header.getContext().table;
    const className = (0, _classnamesDefault.default)("Polaris-DataTable__Cell Polaris-DataTable__Cell--header", {
        "Polaris-DataTable__Cell--firstColumn": expandable,
        "Polaris-DataTable__Cell--sortable": header.column.getCanSort(),
        "Polaris-DataTable__Cell--sorted": header.column.getIsSorted()
    });
    const headerLabel = header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext());
    const canExpand = expandable && table.getCanSomeRowsExpand();
    const size = header.column.columnDef.size;
    // @ts-ignore
    const centered = header.column.columnDef.meta?.centered === true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableHead, {
        className: className,
        colSpan: header.colSpan,
        size: size,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "center",
            align: centered ? "center" : undefined,
            children: [
                canExpand && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    size: "slim",
                    onClick: ()=>table.toggleAllRowsExpanded(),
                    children: table.getIsAllRowsExpanded() ? f("common.labels.collapse-all") : f("common.labels.expand-all")
                }),
                !header.column.getCanSort() && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableHeader, {
                    children: headerLabel
                }),
                header.column.getCanSort() && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledHeaderButton, {
                    className: "Polaris-DataTable__Heading",
                    onClick: ()=>onSortChange(header),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableHeader, {
                            children: headerLabel
                        }),
                        header.column.getIsSorted() && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "Polaris-DataTable__Icon",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: header.column.getIsSorted() === "asc" ? (0, _polarisIcons.CaretUpMinor) : (0, _polarisIcons.CaretDownMinor)
                            })
                        })
                    ]
                })
            ]
        })
    }, header.id);
}
const StyledTableHead = (0, _styledComponentsDefault.default).th`
  width: ${({ size })=>size && (0, _numbersUtils.isNumber)(size) ? `${size}%` : undefined};

  // For small viewports - hide table headers (they will be shown above each cell)
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    display: none;
  }
`;
const StyledHeaderButton = (0, _styledComponentsDefault.default).button`
  display: flex;
  align-items: center;
`;
const StyledTableHeader = (0, _styledComponentsDefault.default).div`
  white-space: normal;
  line-height: 1.2;
  user-select: none;
`;
exports.default = TableHeaderCell;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","@tanstack/react-table":"86D8M","classnames":"2uoUy","styled-components":"eBrdC","../../constants/styles":"dZWds","../../hooks/useFormatMessage":"8Y8fq","../../utils/numbersUtils":"2RGyl","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dsCl0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _types = require("../extensions/types");
const formatCustomPropertyName = (status, suffix = "")=>status ? `var(${(0, _types.STATUS_TO_CUSTOM_PROPERTY_NAME)[status]}${suffix})` : `var(--p-surface${suffix})`;
const TableRow = (props)=>{
    const { className, expanded, ...rest } = props;
    const classes = (0, _classnamesDefault.default)("Polaris-DataTable__TableRow Polaris-DataTable--hoverable", className);
    const showSeparator = Boolean(!expanded && rest.depth === 0);
    // when rendering a row as a banner, add rows before and after the given row
    // in order to add space (margin) between the banner row and the rows adjacent to it.
    // this is done because margins don't work for table rows
    if (rest.warningBanner) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSpacerRow, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBannerRow, {
                ...rest,
                className: classes
            }),
            showSeparator && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSpacerRow, {})
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableRow, {
        ...rest,
        className: classes
    });
};
const StyledTableRow = (0, _styledComponentsDefault.default).tr`
  // create css custom variables for regular status that do not come pre-defined in Polaris for use in formatCustomPropertyName
  --p-surface-regular-subdued: hsl(180, 11%, 96%);
  --p-surface-regular-subdued-hovered: hsl(180, 14%, 94%);

  & .Polaris-DataTable__Cell {
    background-color: var(--p-surface ${({ status })=>status ? `-${status}-subdued` : ""});
    background-color: ${({ status })=>status ? formatCustomPropertyName(status) : undefined};
  }

  &:hover .Polaris-DataTable__Cell {
    background: ${({ status })=>formatCustomPropertyName(status, "-hovered")};
  }

  & > td {
    // hide the rows separator if this is a regular (non warning) sub row
    border-top: ${({ depth, warningBanner })=>!warningBanner && depth && depth > 0 ? "none !important" : undefined};
  }

  // For small viewports - render cells in a column (as cards) and remove the borders between cells
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    display: grid;
    margin: var(--p-space-8) 0;
    border-radius: var(--p-border-radius-2);
    box-shadow: var(--p-shadow-card);
    border: var(--p-border-divider);

    & + & .Polaris-DataTable__Cell {
      border-top: none;
    }
  }
`;
const StyledBannerRow = (0, _styledComponentsDefault.default)(StyledTableRow)`
  --border-style: solid var(--p-border-width-1) var(--p-border-subdued);
  --warning-border-radius: var(--p-border-radius-2);

  // For small viewports - hide cells border
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    --border-style: none;
    --warning-border-radius: 0;
  }

  & .Polaris-DataTable__Cell {
    border-top: var(--border-style);
    border-bottom: var(--border-style);
    background-color: var(--p-background);

    &:first-child {
      border-left: var(--border-style);
      border-top-left-radius: var(--warning-border-radius);
      border-bottom-left-radius: var(--warning-border-radius);
    }

    &:last-child {
      border-right: var(--border-style);
      border-top-right-radius: var(--warning-border-radius);
      border-bottom-right-radius: var(--warning-border-radius);
      margin-right: var(--p-space-4);
    }
  }

  &:hover .Polaris-DataTable__Cell {
    background-color: var(--p-background-hovered);
    --border-style: solid var(--p-border-width-1) var(--p-border-hovered);
  }
`;
const StyledSpacerRow = (0, _styledComponentsDefault.default).tr`
  height: var(--p-space-4);
  position: relative;

  // For small viewports - hide the spacer row since the gap between rows is set by ReactTable
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    height: 0;
  }

  & + &::before {
    content: "";
    position: absolute;
    inset: 0;
    display: block;
    border-top: var(--p-border-divider);
  }
`;
exports.default = /*#__PURE__*/ (0, _react.memo)(TableRow);

},{"react/jsx-runtime":"enbMA","react":"cOWTg","classnames":"2uoUy","styled-components":"eBrdC","../../constants/styles":"dZWds","../extensions/types":"k0aig","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k0aig":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STATUS_TO_CUSTOM_PROPERTY_NAME", ()=>STATUS_TO_CUSTOM_PROPERTY_NAME);
const STATUS_TO_CUSTOM_PROPERTY_NAME = {
    info: "--p-surface-highlight-subdued",
    success: "--p-surface-success-subdued",
    warning: "--p-surface-warning-subdued",
    critical: "--p-surface-critical-subdued",
    regular: "--p-surface-regular-subdued"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6YlAI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _archiveboxSvg = require("../../../../../assets/icons/archivebox.svg");
var _archiveboxSvgDefault = parcelHelpers.interopDefault(_archiveboxSvg);
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _ownersHelpers = require("../../../../helpers/owners.helpers");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useRichFormatMessage = require("../../../../hooks/useRichFormatMessage");
var _useRichFormatMessageDefault = parcelHelpers.interopDefault(_useRichFormatMessage);
var _stringUtils = require("../../../../utils/stringUtils");
var _util = require("../../../../utils/util");
var _confirmAction = require("../../../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _editButton = require("../../../EditButton/EditButton");
var _editButtonDefault = parcelHelpers.interopDefault(_editButton);
var _button = require("../../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _ownershipUpdateActions = require("./OwnershipUpdateActions");
var _ownershipUpdateActionsDefault = parcelHelpers.interopDefault(_ownershipUpdateActions);
const OwnerActions = (props)=>{
    const { customer, owner, update, readonly, onEdit = (0, _util.noop), onOwnershipUpdateReject = (0, _util.noop), onOwnershipUpdateConfirm = (0, _util.noop), onAfterArchive = (0, _util.noop) } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const richFormatMessage = (0, _useRichFormatMessageDefault.default)();
    const [showArchiveConfirm, toggleArchiveConfirm, closeArchiveConfirm] = (0, _useOpenCloseDefault.default)();
    const archiveOwner = (ownerId)=>(0, _apiDefault.default).deleteCompanyOwner(customer.id, ownerId);
    const ownerName = (0, _stringUtils.isEmptyString)((0, _ownersHelpers.getOwnerName)(owner)) ? f("common.labels.unidentified-owner") : (0, _ownersHelpers.getOwnerName)(owner);
    if (update && customer) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipUpdateActionsDefault.default), {
        customer: customer,
        update: update,
        readonly: readonly,
        onOwnershipUpdateReject: onOwnershipUpdateReject,
        onOwnershipUpdateConfirm: onOwnershipUpdateConfirm
    });
    // for Person owners (known or unknown) - enable editing the owner details
    if (!owner.company && !(0, _util.isNil)(owner.person)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editButtonDefault.default), {
        onEdit: ()=>onEdit(owner),
        readonly: readonly
    });
    else if (owner.company || owner.is_unknown) // for unknown owners which are not a person - either a company or not known
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: f("default.archive"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: toggleArchiveConfirm,
                    plain: true,
                    fullWidth: true,
                    monochrome: true,
                    disabled: readonly || owner.deleted,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _archiveboxSvgDefault.default),
                        width: "22px",
                        height: "22px"
                    })
                })
            }),
            showArchiveConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: ()=>archiveOwner(owner.id),
                title: f("default.archive"),
                actionTitle: f("default.archive"),
                onNo: closeArchiveConfirm,
                onSuccess: ()=>onAfterArchive(owner.id),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: richFormatMessage("company.owners.archive.description", {
                        name: ownerName
                    })
                })
            })
        ]
    });
    return null;
};
exports.default = OwnerActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../../assets/icons/archivebox.svg":"cyEGJ","../../../../api":"f6lXD","../../../../helpers/owners.helpers":"lynDH","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useOpenClose":"idooG","../../../../hooks/useRichFormatMessage":"6rmtK","../../../../utils/stringUtils":"4gVdA","../../../../utils/util":"4MniK","../../../ConfirmAction/ConfirmAction":"icP5J","../../../EditButton/EditButton":"frWXb","../../../extensions/Button":"8exc0","../../../extensions/Icon":"eHSf0","../../../TooltipWrapper/TooltipWrapper":"b5W2d","./OwnershipUpdateActions":"fiQzX","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cyEGJ":[function(require,module,exports) {
module.exports = require("8c64ba343efa9f2a").getBundleURL("kEMsi") + "archivebox.c92926c8.svg";

},{"8c64ba343efa9f2a":"75UoR"}],"6rmtK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
const useRichFormatMessage = ()=>{
    const intl = (0, _reactIntl.useIntl)();
    // only accepts valid keys, not any string, values
    return (id, values)=>intl.formatMessage({
            id
        }, {
            ...values,
            bold: (str)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    fontWeight: "semibold",
                    children: str
                })
        });
};
exports.default = useRichFormatMessage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"frWXb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _pencil24CircleSvg = require("../../../assets/icons/pencil-24-circle.svg");
var _pencil24CircleSvgDefault = parcelHelpers.interopDefault(_pencil24CircleSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _showOnMobile = require("../ShowOnMobile/ShowOnMobile");
var _showOnMobileDefault = parcelHelpers.interopDefault(_showOnMobile);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const EditButton = (props)=>{
    const { readonly, onEdit } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
        content: f("common.buttons.action.edit"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            plain: true,
            onClick: onEdit,
            size: "slim",
            disabled: readonly,
            removeUnderline: true,
            monochrome: true,
            hoverable: true,
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _pencil24CircleSvgDefault.default)
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _showOnMobileDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: f("common.buttons.action.edit")
                })
            })
        })
    });
};
exports.default = EditButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/pencil-24-circle.svg":"k9MFP","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../ShowOnMobile/ShowOnMobile":"fzlW0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k9MFP":[function(require,module,exports) {
module.exports = require("ecca1add9e475bb3").getBundleURL("kEMsi") + "pencil-24-circle.011a35d6.svg";

},{"ecca1add9e475bb3":"75UoR"}],"fzlW0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
const ShowOnMobile = (props)=>{
    const { children, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWrapper, {
        ...rest,
        children: children
    });
};
const StyledWrapper = (0, _styledComponentsDefault.default).div`
  display: none;

  // For small viewports - show
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    display: revert;
  }
`;
exports.default = ShowOnMobile;

},{"react/jsx-runtime":"enbMA","styled-components":"eBrdC","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fiQzX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _ownershipUpdateRejectConfirmation = require("../../OwnershipUpdateRejectConfirmation/OwnershipUpdateRejectConfirmation");
var _ownershipUpdateRejectConfirmationDefault = parcelHelpers.interopDefault(_ownershipUpdateRejectConfirmation);
const OwnershipUpdateActions = (props)=>{
    const { customer, update, readonly, onOwnershipUpdateReject, onOwnershipUpdateConfirm } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showRejectConfirmation, toggleRejectConfirmation, closeRejectConfirmation] = (0, _useOpenCloseDefault.default)();
    const confirmUpdateMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).confirmOwnershipUpdate(customer.id, update.id), {
        onSuccess: (updatedOwner)=>onOwnershipUpdateConfirm(update, updatedOwner)
    });
    const handleConfirm = ()=>confirmUpdateMutation.mutate();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "2",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: toggleRejectConfirmation,
                        plain: true,
                        destructive: true,
                        size: "slim",
                        disabled: confirmUpdateMutation.isLoading || readonly,
                        children: f("ownership-update.actions.labels.ignore")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: handleConfirm,
                        size: "slim",
                        loading: confirmUpdateMutation.isLoading,
                        disabled: readonly,
                        children: f("default.confirm")
                    })
                ]
            }),
            showRejectConfirmation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipUpdateRejectConfirmationDefault.default), {
                customer: customer,
                update: update,
                onClose: closeRejectConfirmation,
                onSuccess: onOwnershipUpdateReject
            })
        ]
    });
};
exports.default = OwnershipUpdateActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../api":"f6lXD","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useOpenClose":"idooG","../../../extensions/Button":"8exc0","../../OwnershipUpdateRejectConfirmation/OwnershipUpdateRejectConfirmation":"hncgs","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hncgs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirmAction = require("../../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _ownershipUpdateRejectDescription = require("./OwnershipUpdateRejectDescription");
var _ownershipUpdateRejectDescriptionDefault = parcelHelpers.interopDefault(_ownershipUpdateRejectDescription);
const OwnershipUpdateRejectConfirmation = (props)=>{
    const { customer, update, onClose, onSuccess } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        isDestructive: true,
        apiCall: ()=>(0, _apiDefault.default).rejectOwnershipUpdate(customer.id, update.id),
        title: f("ownership-update.reject.confirmation.modal.title"),
        cancelTitle: f("default.cancel"),
        actionTitle: f("ownership-update.reject.confirmation.modal.action.label"),
        onNo: onClose,
        onSuccess: ()=>onSuccess(update),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipUpdateRejectDescriptionDefault.default), {
            update: update
        })
    });
};
exports.default = OwnershipUpdateRejectConfirmation;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../api":"f6lXD","../../../hooks/useFormatMessage":"8Y8fq","../../ConfirmAction/ConfirmAction":"icP5J","./OwnershipUpdateRejectDescription":"iFtRZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iFtRZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useDisplayName = require("../../../hooks/useDisplayName");
var _useDisplayNameDefault = parcelHelpers.interopDefault(_useDisplayName);
var _useFormatOwnershipPercentage = require("../../../hooks/useFormatOwnershipPercentage");
var _useFormatOwnershipPercentageDefault = parcelHelpers.interopDefault(_useFormatOwnershipPercentage);
var _useRichFormatMessage = require("../../../hooks/useRichFormatMessage");
var _useRichFormatMessageDefault = parcelHelpers.interopDefault(_useRichFormatMessage);
const OwnershipUpdateRejectDescription = (props)=>{
    const { update } = props;
    const richFormat = (0, _useRichFormatMessageDefault.default)();
    const formatDisplayName = (0, _useDisplayNameDefault.default)();
    const formatPercent = (0, _useFormatOwnershipPercentageDefault.default)();
    const getActionDescription = ()=>{
        const value = update.field_changes.find((field)=>field.field_name === "percent_share")?.old;
        const percentShare = formatPercent(value);
        const displayName = formatDisplayName(update);
        switch(update.update_type){
            case "ADDED":
                return richFormat("ownership-update.reject.confirmation.modal.content.add", {
                    name: displayName
                });
            case "DELETED":
                return richFormat("ownership-update.reject.confirmation.modal.content.delete", {
                    name: displayName
                });
            case "UPDATED":
                return richFormat("ownership-update.reject.confirmation.modal.content.update", {
                    name: displayName,
                    value: percentShare
                });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        children: getActionDescription()
    });
};
exports.default = OwnershipUpdateRejectDescription;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useDisplayName":"aWMpm","../../../hooks/useFormatOwnershipPercentage":"ihLqM","../../../hooks/useRichFormatMessage":"6rmtK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aWMpm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _displayHelpers = require("../helpers/display.helpers");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useDisplayName = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const formatDisplayName = (person)=>{
        const birthYear = (0, _displayHelpers.getBirthDate)(person);
        const birthYearStr = birthYear ? f("display-name.suffixes.labels.birth-date", {
            birthDate: new Date(birthYear)
        }) : undefined;
        const displayName = [
            (0, _displayHelpers.getFullName)(person),
            birthYearStr
        ].filter(Boolean).join(" ");
        return displayName;
    };
    return formatDisplayName;
};
exports.default = useDisplayName;

},{"../helpers/display.helpers":"2q3xY","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ihLqM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _numbersUtils = require("../utils/numbersUtils");
var _stringUtils = require("../utils/stringUtils");
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
const formatPercent = (str = "", digits = 2)=>{
    if ((0, _stringUtils.isEmptyString)(str)) return "-";
    if (str.endsWith("%")) return str;
    const value = parseFloat(str);
    if ((0, _numbersUtils.isNumber)(value)) return value.toFixed(digits) + "%";
    return str.concat("%");
};
const useFormatOwnershipPercentage = ()=>{
    const features = (0, _useFeaturesDefault.default)();
    const accuracy = features.HIGHER_ACCURACY_PERCENTAGES ? 3 : 2;
    return (value, digits = accuracy)=>formatPercent(value, digits);
};
exports.default = useFormatOwnershipPercentage;

},{"../utils/numbersUtils":"2RGyl","../utils/stringUtils":"4gVdA","./useFeatures":"hvBWb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eQr1s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ownershipUpdates = require("../../../../constants/ownership-updates");
var _ownersHelpers = require("../../../../helpers/owners.helpers");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../../../utils/stringUtils");
var _rowHighlighter = require("../../../extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _personName = require("../../../PersonName/PersonName");
var _personNameDefault = parcelHelpers.interopDefault(_personName);
var _ownerNameHelpers = require("./OwnerName.helpers");
var _ownershipUpdateBadge = require("./OwnershipUpdateBadge");
var _ownershipUpdateBadgeDefault = parcelHelpers.interopDefault(_ownershipUpdateBadge);
const OwnerName = (props)=>{
    const { owner, update, screeningType, searchTerm, ...personNameProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    // if there is an update OR that owner was previously updated from the ownership registry
    const showUpdateFromOwnersRegistry = update || (0, _ownerNameHelpers.isUpdatedByOwnershipRegistry)(owner);
    const additionalSubtitles = [];
    if (showUpdateFromOwnersRegistry) additionalSubtitles.push({
        subtitle: f("ownership-update.description.update", {
            year: (0, _ownershipUpdates.LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR)
        }),
        dateString: (0, _ownershipUpdates.LATEST_OWNERSHIP_REGISTRY_DATE).toString()
    });
    const ownerName = (0, _stringUtils.isEmptyString)((0, _ownersHelpers.getOwnerName)(owner)) ? f("default.unknown") : (0, _ownersHelpers.getOwnerName)(owner);
    const uboTooltip = owner.custom_is_ubo ? f("common.labels.manual-ubo") : f("screening.owners.is_ubo.description");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
        highlight: update !== undefined,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personNameDefault.default), {
            entity: owner,
            type: owner.company ? "company" : owner.person ? "person" : undefined,
            name: ownerName,
            deleted: owner.deleted === true,
            screeningType: screeningType,
            additionalSubtitles: additionalSubtitles,
            uboTooltip: uboTooltip,
            searchTerm: searchTerm,
            ...personNameProps,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipUpdateBadgeDefault.default), {
                update: update
            })
        })
    });
};
exports.default = OwnerName;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../constants/ownership-updates":"k1X7w","../../../../helpers/owners.helpers":"lynDH","../../../../hooks/useFormatMessage":"8Y8fq","../../../../utils/stringUtils":"4gVdA","../../../extensions/RowHighlighter":"9EbPr","../../../PersonName/PersonName":"iFxbp","./OwnerName.helpers":"b9YWT","./OwnershipUpdateBadge":"eRCe7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9EbPr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _tableRowModifier = require("./TableRowModifier");
var _tableRowModifierDefault = parcelHelpers.interopDefault(_tableRowModifier);
const RowHighlighter = (props)=>{
    const { children, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledRowHighlighter, {
        ...rest,
        children: children
    });
};
const StyledRowHighlighter = (0, _styledComponentsDefault.default)((0, _tableRowModifierDefault.default))`
  & .Polaris-DataTable__Cell {
    ${(props)=>props.highlight && `background: var(--p-surface-highlight-subdued);
      --p-surface-hovered: var(--p-surface-highlight-subdued-hovered);
    `}
    ${(props)=>props.warning && `background: var(--p-surface-warning-subdued);
      --p-surface-hovered: var(--p-surface-warning-subdued-hovered);
  `}
  }

  ${(props)=>props.subdued && `opacity: 0.9; filter: grayscale(1);`}
  ${(props)=>props.clickable && `cursor: pointer;`}
`;
exports.default = RowHighlighter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","./TableRowModifier":"ddBxA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ddBxA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// Since @shopify/Polaris data tables don't allow to access the table rows
// use this table cell wrapper to modify the cells row directly
// It's a hack that can be removed once we use a different component to render tables
const TableRowModifier = (props)=>{
    const { children, className, ...rowProps } = props;
    const cellRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (cellRef.current) {
            let tableRow = cellRef.current;
            while(tableRow && tableRow.tagName !== "TR")tableRow = tableRow.parentElement;
            if (className) className.split(" ").forEach((name)=>tableRow?.classList.add(name));
            Object.keys(rowProps).forEach((name)=>tableRow?.setAttribute(name, String(rowProps[name])));
            return ()=>{
                if (className) className.split(" ").forEach((name)=>tableRow?.classList.remove(name));
                for(const name in rowProps)tableRow?.setAttribute(name, "");
            };
        }
    }, [
        cellRef.current,
        className
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: cellRef,
        children: children
    });
};
exports.default = TableRowModifier;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iFxbp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _displayHelpers = require("../../helpers/display.helpers");
var _personHelpers = require("../../helpers/person.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _badges = require("../Badges/Badges");
var _badgesDefault = parcelHelpers.interopDefault(_badges);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _personNameHelpers = require("./PersonName.helpers");
var _screeningType = require("./ScreeningType");
var _screeningTypeDefault = parcelHelpers.interopDefault(_screeningType);
const PersonName = (props)=>{
    const { entity, deleted, additionalSubtitles = [], screeningType, uboTooltip, children, ...displayNameProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const subtitles = [
        ...additionalSubtitles
    ];
    if ((0, _personHelpers.isManuallyCreated)(entity) && entity.created_dt) subtitles.push({
        subtitle: f("person-name.description.manually-created", {
            name: getUserDisplayName(entity.created_by),
            timestamp: new Date(entity.created_dt)
        }),
        dateString: entity.created_dt
    });
    else if ((0, _personNameHelpers.isManuallyUpdated)(entity) && entity.updated_dt) subtitles.push({
        subtitle: f("common.labels.modified-by", {
            name: getUserDisplayName(entity.updated_by),
            timestamp: new Date(entity.updated_dt)
        }),
        dateString: entity.updated_dt
    });
    // sort subtitles based on their dates
    subtitles.sort((entryA, entryB)=>new Date(entryA.dateString).getTime() - new Date(entryB.dateString).getTime());
    const updateInfoSubtitles = subtitles.length === 0 ? undefined : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
        children: subtitles.map(({ subtitle })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                italic: true,
                children: subtitle
            }, subtitle))
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPersonNameWrapper, {
        subdued: deleted,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "2",
            wrap: false,
            blockAlign: "center",
            children: [
                screeningType && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningTypeDefault.default), {
                    screeningType: screeningType
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                    birthDate: (0, _displayHelpers.getBirthDate)(entity.person),
                    comment: entity.comment,
                    subtitle: updateInfoSubtitles,
                    type: displayNameProps.type || entity.person ? "person" : undefined,
                    ...displayNameProps,
                    name: displayNameProps.name || (0, _displayHelpers.getFullName)(entity.person),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        children: [
                            deleted && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                                size: "xsmall",
                                children: f("default.expired")
                            }),
                            (0, _personHelpers.isUBO)(entity) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                                content: uboTooltip,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                                    size: "xsmall",
                                    status: "warning",
                                    children: f("common.labels.ubo")
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgesDefault.default), {
                                isPep: entity.person?.is_pep,
                                isSanctioned: entity.person?.is_sanctioned
                            }),
                            children
                        ]
                    })
                })
            ]
        })
    });
};
const StyledPersonNameWrapper = (0, _styledComponentsDefault.default).div`
  ${({ subdued })=>subdued && `opacity: 0.5; filter: grayscale(1);`}
`;
exports.default = PersonName;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/display.helpers":"2q3xY","../../helpers/person.helpers":"6qOIE","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../Badges/Badges":"cI72s","../CondensedText/CondensedText":"1FshD","../DisplayName/DisplayName":"gKd5g","../extensions/Badge":"9irVp","../TooltipWrapper/TooltipWrapper":"b5W2d","./PersonName.helpers":"gsHLg","./ScreeningType":"ac1b6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"edBne":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _displayHelpers = require("../helpers/display.helpers");
var _stringUtils = require("../utils/stringUtils");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUsers = require("./useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
/**
 * returns a function that finds and returns the full username of a give user id
 */ const useGetUserName = (...useGetUserProps)=>{
    const { users, isSingleUser, getUserGroupsDisplayName } = (0, _useGetUsersDefault.default)(...useGetUserProps);
    const f = (0, _useFormatMessageDefault.default)();
    const getUserDisplayName = (user)=>{
        const name = (0, _displayHelpers.getFullName)(user);
        const suffixes = [];
        const groupsNames = getUserGroupsDisplayName(user);
        if (!(0, _stringUtils.isEmptyString)(groupsNames) && !isSingleUser) suffixes.push(groupsNames);
        if (user && !user.is_active) suffixes.push(f("default.inactive").toLocaleLowerCase());
        return `${name}${suffixes.length === 0 ? "" : ` (${suffixes.join(" - ")})`}`;
    };
    const getUserFullName = (0, _react.useCallback)((userId)=>getUserDisplayName(users.find((user)=>user.id === userId)), [
        users
    ]);
    return {
        getUserFullName,
        getUserDisplayName
    };
};
exports.default = useGetUserName;

},{"react":"cOWTg","../helpers/display.helpers":"2q3xY","../utils/stringUtils":"4gVdA","./useFormatMessage":"8Y8fq","./useGetUsers":"c83Pg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c83Pg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _collectionUtils = require("../utils/collectionUtils");
var _stringUtils = require("../utils/stringUtils");
var _useTranslateGroup = require("./useTranslateGroup");
var _useTranslateGroupDefault = parcelHelpers.interopDefault(_useTranslateGroup);
// set the stale time to 1 hour to avoid multiple calls to getAllUsersAndGroups when navigating
// between customers list and customer details pages
const useGetUsers = (fetchOnInit = true)=>{
    const { isLoading, error, data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).USERS
    ], ()=>(0, _apiDefault.default).getAllUsersAndGroups(), {
        enabled: fetchOnInit,
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    const getGroupName = (0, _useTranslateGroupDefault.default)();
    const groups = data?.groups || [];
    const groupsMap = Object.fromEntries(groups.map((group)=>[
            group.id,
            getGroupName(group)
        ]));
    const activeUsers = (0, _react.useMemo)(()=>(data?.users || []).filter((user)=>user.is_active), [
        data?.users
    ]);
    const getUserGroupsDisplayName = (user)=>(user?.groups || []).map((groupId)=>groupsMap[groupId]).filter((groupName)=>!(0, _stringUtils.isEmptyString)(groupName)).join(", ");
    const isSingleUser = activeUsers.length === 1;
    const getFilteredUsers = (0, _react.useCallback)((groupsKeys)=>{
        if (!groupsKeys || groupsKeys.length === 0) return data?.users;
        const groupsIds = groups.filter((group)=>group.role_key && groupsKeys.includes(group.role_key)).map((group)=>group.id);
        return data?.users.filter((user)=>(0, _collectionUtils.intersects)(groupsIds, user.groups || []));
    }, [
        data?.users,
        groups
    ]);
    return {
        isLoading,
        error,
        users: data?.users || [],
        groups,
        activeUsers,
        isSingleUser,
        getUserGroupsDisplayName,
        getFilteredUsers
    };
};
exports.default = useGetUsers;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../utils/collectionUtils":"gr5mc","../utils/stringUtils":"4gVdA","./useTranslateGroup":"b4II6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b4II6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useTranslateGroup = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return (group)=>{
        switch(group.role_key){
            case "MLRO":
                return f("common.group.role.key.mlro");
            case "COMPLIANCE_OFFICER":
                return f("common.group.role.key.compliance-officer");
            case "KDK_ADMIN":
                return f("common.group.role.key.kdk-admin");
            default:
                return group.name;
        }
    };
};
exports.default = useTranslateGroup;

},{"./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cI72s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DISPLAY_BADGE_PROPS", ()=>DISPLAY_BADGE_PROPS);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
const DISPLAY_BADGE_PROPS = {
    size: "xsmall",
    status: "default-dark"
};
const Badges = (props)=>{
    const { isPep, isSanctioned, hasNegativeNews, isOther, showHyphenIfNotSet, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const hasBadges = Boolean(children || isPep || isSanctioned || hasNegativeNews || isOther);
    if (!hasBadges) return showHyphenIfNotSet ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        children: "-"
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        children: [
            children,
            isPep && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                ...DISPLAY_BADGE_PROPS,
                children: f("badge.pep")
            }),
            isSanctioned && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                ...DISPLAY_BADGE_PROPS,
                children: f("badge.sanctioned")
            }),
            hasNegativeNews && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                ...DISPLAY_BADGE_PROPS,
                children: f("badge.negative-news")
            }),
            isOther && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                ...DISPLAY_BADGE_PROPS,
                children: f("badge.other")
            })
        ]
    });
};
exports.default = Badges;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../extensions/Badge":"9irVp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9irVp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const Badge = ({ size, status, className, children, ...props })=>{
    const isExtraSmall = size === "xsmall";
    const isDark = status === "default-dark";
    const isSevere = status === "severe";
    const isSuccessDark = status === "success-dark";
    // for "xsmall" size = pass "small" size value to Polaris Badge to avoid typescript conflicts
    // but style the badge to look extra small
    const badgeSize = isExtraSmall ? "small" : size;
    // for "default-dark" status = pass "undefined" status value to Polaris Badge to avoid typescript conflicts
    // but style the badge to look dark
    const badgeStatus = isDark || isSuccessDark ? undefined : status;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBadge, {
        isExtraSmall: isExtraSmall,
        isDark: isDark,
        isSevere: isSevere,
        isSuccessDark: isSuccessDark,
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Badge), {
            size: badgeSize,
            status: badgeStatus,
            ...props,
            children: children
        })
    });
};
const StyledBadge = (0, _styledComponentsDefault.default).span`
  ${(props)=>props.isExtraSmall && `& .Polaris-Badge > .Polaris-Text--root {
      font-size: var(--kdk-font-size-50);
      font-weight: var(--p-font-weight-semibold);
      line-height: 1;
      padding: var(--p-space-025);
  }`}

  ${(props)=>props.isDark && `& .Polaris-Badge {
      color: var(--p-text-on-dark);
      background-color: var(--kdk-dark-grey);
  }`}

  ${(props)=>props.isSevere && `& .Polaris-Badge {
      background-color: var(--kdk-red);
      color: var(--p-text-on-primary);
  }`}
  
  ${(props)=>props.isSuccessDark && `& .Polaris-Badge {
      color: var(--p-text-on-dark);
      background-color: var(--kdk-dark-success);
  }`}
`;
exports.default = Badge;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gKd5g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _companySvg = require("../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _infoBlueSvg = require("../../../assets/icons/info-blue.svg");
var _infoBlueSvgDefault = parcelHelpers.interopDefault(_infoBlueSvg);
var _personSvg = require("../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../utils/util");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const DisplayName = (props)=>{
    const { type, name, birthDate, comment, strong, subdued, roleType, subtitle, wrap, searchTerm, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const displayName = roleType ? `${name} (${f((0, _roleTypesDefault.default)[roleType])})` : name;
    const showIcon = type === "person" || type === "company";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: subtitle ? "start" : "center",
        wrap: false,
        children: [
            showIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIcon, {
                source: type === "person" ? (0, _personSvgDefault.default) : (0, _companySvgDefault.default),
                width: "20px",
                height: "20px",
                useMask: true,
                subdued: subdued
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledContainer, {
                        flowWrap: wrap,
                        children: [
                            !(0, _util.isNil)(displayName) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledName, {
                                title: displayName,
                                whiteSpaceWrap: wrap,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: strong ? "semibold" : undefined,
                                    color: subdued ? "subdued" : undefined,
                                    children: [
                                        searchTerm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                                            searchWords: [
                                                searchTerm
                                            ],
                                            textToHighlight: displayName
                                        }),
                                        !searchTerm && displayName
                                    ]
                                })
                            }),
                            birthDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBirthYear, {
                                children: f("display-name.suffixes.labels.birth-date", {
                                    birthDate: new Date(birthDate)
                                })
                            }),
                            comment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                                content: comment,
                                dismissOnMouseOut: true,
                                preferredPosition: "above",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _infoBlueSvgDefault.default)
                                })
                            }),
                            children
                        ]
                    }),
                    subtitle
                ]
            })
        ]
    });
};
const StyledIcon = (0, _styledComponentsDefault.default)((0, _iconDefault.default))`
  color: ${({ subdued })=>subdued ? "var(--p-text-subdued)" : "inherit"};
`;
const StyledContainer = (0, _styledComponentsDefault.default).div`
  display: flex;
  align-items: center;
  gap: var(--p-space-05);

  flex-flow: ${({ flowWrap })=>flowWrap ? "wrap" : "row"};

  & > a {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const StyledName = (0, _styledComponentsDefault.default).span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: ${({ whiteSpaceWrap })=>whiteSpaceWrap ? "break-spaces" : "nowrap"};
`;
const StyledBirthYear = (0, _styledComponentsDefault.default).div`
  white-space: nowrap;
`;
exports.default = DisplayName;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/company.svg":"luBbc","../../../assets/icons/info-blue.svg":"kCjLz","../../../assets/icons/person.svg":"1Xt5L","../../constants/role-types":"fAycz","../../hooks/useFormatMessage":"8Y8fq","../../utils/util":"4MniK","../extensions/Icon":"eHSf0","../TextHighlighter/TextHighlighter":"43Xhz","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"luBbc":[function(require,module,exports) {
module.exports = require("defa2f9528287c9c").getBundleURL("kEMsi") + "company.89454a7a.svg";

},{"defa2f9528287c9c":"75UoR"}],"kCjLz":[function(require,module,exports) {
module.exports = require("2be29caedcebe7d3").getBundleURL("kEMsi") + "info-blue.1726a725.svg";

},{"2be29caedcebe7d3":"75UoR"}],"1Xt5L":[function(require,module,exports) {
module.exports = require("f817bfccee10446").getBundleURL("kEMsi") + "person.c8f4d5f2.svg";

},{"f817bfccee10446":"75UoR"}],"fAycz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const RoleTypes = {
    null: "common.roles.null",
    UNKNOWN_ROLE: "common.roles.UNKNOWN_ROLE",
    CEO: "common.roles.CEO",
    PROPRIETOR: "common.roles.PROPRIETOR",
    CHAIRMAN: "common.roles.CHAIRMAN",
    DEPUTY_CHAIRMAN: "common.roles.DEPUTY_CHAIRMAN",
    BOARD_MEMBER: "common.roles.BOARD_MEMBER",
    ALTERNATE_BOARD_MEMBER: "common.roles.ALTERNATE_BOARD_MEMBER",
    CONTACT_PERSON: "common.roles.CONTACT_PERSON",
    MANAGER: "common.roles.MANAGER",
    MANAGING_DIRECTOR: "common.roles.MANAGING_DIRECTOR",
    ACCOUNTANT: "common.roles.ACCOUNTANT",
    AUDITOR: "common.roles.AUDITOR",
    TRUSTEE: "common.roles.TRUSTEE",
    NORWEGIAN_REPRESENTATIVE: "common.roles.NORWEGIAN_REPRESENTATIVE",
    // This role doesn't require entering date of birth when creating a new role
    REPRESENTATIVE: "common.roles.REPRESENTATIVE",
    OBSERVER: "common.roles.OBSERVER",
    PARTICIPANT_PART_RESPONSIBILITY: "common.roles.PARTICIPANT_PART_RESPONSIBILITY",
    PARTICIPANT_FULL_RESPONSIBILITY: "common.roles.PARTICIPANT_FULL_RESPONSIBILITY",
    COMPLEMENTARY: "common.roles.COMPLEMENTARY",
    SIGNATURE: "common.roles.SIGNATURE",
    SIGNATURE_JOINTLY: "common.roles.SIGNATURE_JOINTLY",
    SIGNATURE_SEPARATELY: "common.roles.SIGNATURE_SEPARATELY",
    PROCURA: "common.roles.PROCURA",
    PROCURA_JOINTLY: "common.roles.PROCURA_JOINTLY",
    PROCURA_SEPARATELY: "common.roles.PROCURA_SEPARATELY",
    // DEPRECATED
    DEPUTY_BOARD_MEMBER: "common.roles.DEPUTY_BOARD_MEMBER"
};
exports.default = RoleTypes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"43Xhz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactHighlightWords = require("react-highlight-words");
var _reactHighlightWordsDefault = parcelHelpers.interopDefault(_reactHighlightWords);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const TextHighlighter = (0, _styledComponentsDefault.default)((0, _reactHighlightWordsDefault.default)).attrs({
    autoEscape: true
})`
  & > mark {
    background: inherit;
    color: inherit;
    font-weight: var(--p-font-weight-bold);
  }
`;
exports.default = TextHighlighter;

},{"react-highlight-words":"gVZPP","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gVZPP":[function(require,module,exports) {
module.exports = /******/ function(modules) {
    /******/ // The module cache
    /******/ var installedModules = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ /******/ // Check if module is in cache
        /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
        /******/ /******/ // Create a new module (and put it into the cache)
        /******/ var module1 = installedModules[moduleId] = {
            /******/ exports: {},
            /******/ id: moduleId,
            /******/ loaded: false
        };
        /******/ /******/ // Execute the module function
        /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
        /******/ /******/ // Flag the module as loaded
        /******/ module1.loaded = true;
        /******/ /******/ // Return the exports of the module
        /******/ return module1.exports;
    /******/ }
    /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
    /******/ __webpack_require__.m = modules;
    /******/ /******/ // expose the module cache
    /******/ __webpack_require__.c = installedModules;
    /******/ /******/ // __webpack_public_path__
    /******/ __webpack_require__.p = "";
    /******/ /******/ // Load entry module and return exports
    /******/ return __webpack_require__(0);
/******/ }([
    /* 0 */ /***/ function(module1, exports, __webpack_require__) {
        module1.exports = __webpack_require__(1);
    /***/ },
    /* 1 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        var _Highlighter = __webpack_require__(2);
        var _Highlighter2 = _interopRequireDefault(_Highlighter);
        exports["default"] = _Highlighter2["default"];
        module1.exports = exports["default"];
    /***/ },
    /* 2 */ /***/ function(module1, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        exports["default"] = Highlighter;
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                "default": obj
            };
        }
        function _objectWithoutProperties(obj, keys) {
            var target = {};
            for(var i in obj){
                if (keys.indexOf(i) >= 0) continue;
                if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
                target[i] = obj[i];
            }
            return target;
        }
        var _highlightWordsCore = __webpack_require__(3);
        var _propTypes = __webpack_require__(4);
        var _propTypes2 = _interopRequireDefault(_propTypes);
        var _react = __webpack_require__(14);
        var _memoizeOne = __webpack_require__(15);
        var _memoizeOne2 = _interopRequireDefault(_memoizeOne);
        Highlighter.propTypes = {
            activeClassName: _propTypes2["default"].string,
            activeIndex: _propTypes2["default"].number,
            activeStyle: _propTypes2["default"].object,
            autoEscape: _propTypes2["default"].bool,
            className: _propTypes2["default"].string,
            findChunks: _propTypes2["default"].func,
            highlightClassName: _propTypes2["default"].oneOfType([
                _propTypes2["default"].object,
                _propTypes2["default"].string
            ]),
            highlightStyle: _propTypes2["default"].object,
            highlightTag: _propTypes2["default"].oneOfType([
                _propTypes2["default"].node,
                _propTypes2["default"].func,
                _propTypes2["default"].string
            ]),
            sanitize: _propTypes2["default"].func,
            searchWords: _propTypes2["default"].arrayOf(_propTypes2["default"].oneOfType([
                _propTypes2["default"].string,
                _propTypes2["default"].instanceOf(RegExp)
            ])).isRequired,
            textToHighlight: _propTypes2["default"].string.isRequired,
            unhighlightTag: _propTypes2["default"].oneOfType([
                _propTypes2["default"].node,
                _propTypes2["default"].func,
                _propTypes2["default"].string
            ]),
            unhighlightClassName: _propTypes2["default"].string,
            unhighlightStyle: _propTypes2["default"].object
        };
        /**
	 * Highlights all occurrences of search terms (searchText) within a string (textToHighlight).
	 * This function returns an array of strings and <span>s (wrapping highlighted words).
	 */ function Highlighter(_ref) {
            var _ref$activeClassName = _ref.activeClassName;
            var activeClassName = _ref$activeClassName === undefined ? "" : _ref$activeClassName;
            var _ref$activeIndex = _ref.activeIndex;
            var activeIndex = _ref$activeIndex === undefined ? -1 : _ref$activeIndex;
            var activeStyle = _ref.activeStyle;
            var autoEscape = _ref.autoEscape;
            var _ref$caseSensitive = _ref.caseSensitive;
            var caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive;
            var className = _ref.className;
            var findChunks = _ref.findChunks;
            var _ref$highlightClassName = _ref.highlightClassName;
            var highlightClassName = _ref$highlightClassName === undefined ? "" : _ref$highlightClassName;
            var _ref$highlightStyle = _ref.highlightStyle;
            var highlightStyle = _ref$highlightStyle === undefined ? {} : _ref$highlightStyle;
            var _ref$highlightTag = _ref.highlightTag;
            var highlightTag = _ref$highlightTag === undefined ? "mark" : _ref$highlightTag;
            var sanitize = _ref.sanitize;
            var searchWords = _ref.searchWords;
            var textToHighlight = _ref.textToHighlight;
            var _ref$unhighlightTag = _ref.unhighlightTag;
            var unhighlightTag = _ref$unhighlightTag === undefined ? "span" : _ref$unhighlightTag;
            var _ref$unhighlightClassName = _ref.unhighlightClassName;
            var unhighlightClassName = _ref$unhighlightClassName === undefined ? "" : _ref$unhighlightClassName;
            var unhighlightStyle = _ref.unhighlightStyle;
            var rest = _objectWithoutProperties(_ref, [
                "activeClassName",
                "activeIndex",
                "activeStyle",
                "autoEscape",
                "caseSensitive",
                "className",
                "findChunks",
                "highlightClassName",
                "highlightStyle",
                "highlightTag",
                "sanitize",
                "searchWords",
                "textToHighlight",
                "unhighlightTag",
                "unhighlightClassName",
                "unhighlightStyle"
            ]);
            var chunks = (0, _highlightWordsCore.findAll)({
                autoEscape: autoEscape,
                caseSensitive: caseSensitive,
                findChunks: findChunks,
                sanitize: sanitize,
                searchWords: searchWords,
                textToHighlight: textToHighlight
            });
            var HighlightTag = highlightTag;
            var highlightIndex = -1;
            var highlightClassNames = "";
            var highlightStyles = undefined;
            var lowercaseProps = function lowercaseProps(object) {
                var mapped = {};
                for(var key in object)mapped[key.toLowerCase()] = object[key];
                return mapped;
            };
            var memoizedLowercaseProps = (0, _memoizeOne2["default"])(lowercaseProps);
            return (0, _react.createElement)("span", _extends({
                className: className
            }, rest, {
                children: chunks.map(function(chunk, index) {
                    var text = textToHighlight.substr(chunk.start, chunk.end - chunk.start);
                    if (chunk.highlight) {
                        highlightIndex++;
                        var highlightClass = undefined;
                        if (typeof highlightClassName === "object") {
                            if (!caseSensitive) {
                                highlightClassName = memoizedLowercaseProps(highlightClassName);
                                highlightClass = highlightClassName[text.toLowerCase()];
                            } else highlightClass = highlightClassName[text];
                        } else highlightClass = highlightClassName;
                        var isActive = highlightIndex === +activeIndex;
                        highlightClassNames = highlightClass + " " + (isActive ? activeClassName : "");
                        highlightStyles = isActive === true && activeStyle != null ? Object.assign({}, highlightStyle, activeStyle) : highlightStyle;
                        var props = {
                            children: text,
                            className: highlightClassNames,
                            key: index,
                            style: highlightStyles
                        };
                        // Don't attach arbitrary props to DOM elements; this triggers React DEV warnings (https://fb.me/react-unknown-prop)
                        // Only pass through the highlightIndex attribute for custom components.
                        if (typeof HighlightTag !== "string") props.highlightIndex = highlightIndex;
                        return (0, _react.createElement)(HighlightTag, props);
                    } else return (0, _react.createElement)(unhighlightTag, {
                        children: text,
                        className: unhighlightClassName,
                        key: index,
                        style: unhighlightStyle
                    });
                })
            }));
        }
        module1.exports = exports["default"];
    /***/ },
    /* 3 */ /***/ function(module1, exports) {
        module1.exports = /******/ function(modules) {
            /******/ // The module cache
            /******/ var installedModules = {};
            /******/ /******/ // The require function
            /******/ function __webpack_require__(moduleId) {
                /******/ /******/ // Check if module is in cache
                /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                /******/ /******/ // Create a new module (and put it into the cache)
                /******/ var module1 = installedModules[moduleId] = {
                    /******/ exports: {},
                    /******/ id: moduleId,
                    /******/ loaded: false
                };
                /******/ /******/ // Execute the module function
                /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                /******/ /******/ // Flag the module as loaded
                /******/ module1.loaded = true;
                /******/ /******/ // Return the exports of the module
                /******/ return module1.exports;
            /******/ }
            /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
            /******/ __webpack_require__.m = modules;
            /******/ /******/ // expose the module cache
            /******/ __webpack_require__.c = installedModules;
            /******/ /******/ // __webpack_public_path__
            /******/ __webpack_require__.p = "";
            /******/ /******/ // Load entry module and return exports
            /******/ return __webpack_require__(0);
        /******/ }([
            /* 0 */ /***/ function(module1, exports, __webpack_require__) {
                module1.exports = __webpack_require__(1);
            /***/ },
            /* 1 */ /***/ function(module1, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _utils = __webpack_require__(2);
                Object.defineProperty(exports, "combineChunks", {
                    enumerable: true,
                    get: function get() {
                        return _utils.combineChunks;
                    }
                });
                Object.defineProperty(exports, "fillInChunks", {
                    enumerable: true,
                    get: function get() {
                        return _utils.fillInChunks;
                    }
                });
                Object.defineProperty(exports, "findAll", {
                    enumerable: true,
                    get: function get() {
                        return _utils.findAll;
                    }
                });
                Object.defineProperty(exports, "findChunks", {
                    enumerable: true,
                    get: function get() {
                        return _utils.findChunks;
                    }
                });
            /***/ },
            /* 2 */ /***/ function(module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /**
		 * Creates an array of chunk objects representing both higlightable and non highlightable pieces of text that match each search word.
		 * @return Array of "chunks" (where a Chunk is { start:number, end:number, highlight:boolean })
		 */ var findAll = exports.findAll = function findAll(_ref) {
                    var autoEscape = _ref.autoEscape, _ref$caseSensitive = _ref.caseSensitive, caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive, _ref$findChunks = _ref.findChunks, findChunks = _ref$findChunks === undefined ? defaultFindChunks : _ref$findChunks, sanitize = _ref.sanitize, searchWords = _ref.searchWords, textToHighlight = _ref.textToHighlight;
                    return fillInChunks({
                        chunksToHighlight: combineChunks({
                            chunks: findChunks({
                                autoEscape: autoEscape,
                                caseSensitive: caseSensitive,
                                sanitize: sanitize,
                                searchWords: searchWords,
                                textToHighlight: textToHighlight
                            })
                        }),
                        totalLength: textToHighlight ? textToHighlight.length : 0
                    });
                };
                /**
		 * Takes an array of {start:number, end:number} objects and combines chunks that overlap into single chunks.
		 * @return {start:number, end:number}[]
		 */ var combineChunks = exports.combineChunks = function combineChunks(_ref2) {
                    var chunks = _ref2.chunks;
                    chunks = chunks.sort(function(first, second) {
                        return first.start - second.start;
                    }).reduce(function(processedChunks, nextChunk) {
                        // First chunk just goes straight in the array...
                        if (processedChunks.length === 0) return [
                            nextChunk
                        ];
                        else {
                            // ... subsequent chunks get checked to see if they overlap...
                            var prevChunk = processedChunks.pop();
                            if (nextChunk.start <= prevChunk.end) {
                                // It may be the case that prevChunk completely surrounds nextChunk, so take the
                                // largest of the end indeces.
                                var endIndex = Math.max(prevChunk.end, nextChunk.end);
                                processedChunks.push({
                                    start: prevChunk.start,
                                    end: endIndex
                                });
                            } else processedChunks.push(prevChunk, nextChunk);
                            return processedChunks;
                        }
                    }, []);
                    return chunks;
                };
                /**
		 * Examine text for any matches.
		 * If we find matches, add them to the returned array as a "chunk" object ({start:number, end:number}).
		 * @return {start:number, end:number}[]
		 */ var defaultFindChunks = function defaultFindChunks(_ref3) {
                    var autoEscape = _ref3.autoEscape, caseSensitive = _ref3.caseSensitive, _ref3$sanitize = _ref3.sanitize, sanitize = _ref3$sanitize === undefined ? identity : _ref3$sanitize, searchWords = _ref3.searchWords, textToHighlight = _ref3.textToHighlight;
                    textToHighlight = sanitize(textToHighlight);
                    return searchWords.filter(function(searchWord) {
                        return searchWord;
                    }) // Remove empty words
                    .reduce(function(chunks, searchWord) {
                        searchWord = sanitize(searchWord);
                        if (autoEscape) searchWord = escapeRegExpFn(searchWord);
                        var regex = new RegExp(searchWord, caseSensitive ? "g" : "gi");
                        var match = void 0;
                        while(match = regex.exec(textToHighlight)){
                            var start = match.index;
                            var end = regex.lastIndex;
                            // We do not return zero-length matches
                            if (end > start) chunks.push({
                                start: start,
                                end: end
                            });
                            // Prevent browsers like Firefox from getting stuck in an infinite loop
                            // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/
                            if (match.index == regex.lastIndex) regex.lastIndex++;
                        }
                        return chunks;
                    }, []);
                };
                // Allow the findChunks to be overridden in findAll,
                // but for backwards compatibility we export as the old name
                exports.findChunks = defaultFindChunks;
                /**
		 * Given a set of chunks to highlight, create an additional set of chunks
		 * to represent the bits of text between the highlighted text.
		 * @param chunksToHighlight {start:number, end:number}[]
		 * @param totalLength number
		 * @return {start:number, end:number, highlight:boolean}[]
		 */ var fillInChunks = exports.fillInChunks = function fillInChunks(_ref4) {
                    var chunksToHighlight = _ref4.chunksToHighlight, totalLength = _ref4.totalLength;
                    var allChunks = [];
                    var append = function append(start, end, highlight) {
                        if (end - start > 0) allChunks.push({
                            start: start,
                            end: end,
                            highlight: highlight
                        });
                    };
                    if (chunksToHighlight.length === 0) append(0, totalLength, false);
                    else {
                        var lastIndex = 0;
                        chunksToHighlight.forEach(function(chunk) {
                            append(lastIndex, chunk.start, false);
                            append(chunk.start, chunk.end, true);
                            lastIndex = chunk.end;
                        });
                        append(lastIndex, totalLength, false);
                    }
                    return allChunks;
                };
                function identity(value) {
                    return value;
                }
                function escapeRegExpFn(str) {
                    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
                }
            /***/ }
        ]);
    //# sourceMappingURL=index.js.map
    /***/ },
    /* 4 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            if (process.env.NODE_ENV !== "production") {
                var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
                var isValidElement = function(object) {
                    return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
                };
                // By explicitly using `prop-types` you are opting into new development behavior.
                // http://fb.me/prop-types-in-prod
                var throwOnDirectAccess = true;
                module1.exports = __webpack_require__(6)(isValidElement, throwOnDirectAccess);
            } else // By explicitly using `prop-types` you are opting into new production behavior.
            // http://fb.me/prop-types-in-prod
            module1.exports = __webpack_require__(13)();
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 5 */ /***/ function(module1, exports) {
        // shim for using process in browser
        var process = module1.exports = {};
        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.
        var cachedSetTimeout;
        var cachedClearTimeout;
        function defaultSetTimout() {
            throw new Error("setTimeout has not been defined");
        }
        function defaultClearTimeout() {
            throw new Error("clearTimeout has not been defined");
        }
        (function() {
            try {
                if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                else cachedSetTimeout = defaultSetTimout;
            } catch (e) {
                cachedSetTimeout = defaultSetTimout;
            }
            try {
                if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                else cachedClearTimeout = defaultClearTimeout;
            } catch (e) {
                cachedClearTimeout = defaultClearTimeout;
            }
        })();
        function runTimeout(fun) {
            if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
            return setTimeout(fun, 0);
            // if setTimeout wasn't available but was latter defined
            if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                cachedSetTimeout = setTimeout;
                return setTimeout(fun, 0);
            }
            try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedSetTimeout(fun, 0);
            } catch (e) {
                try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                    return cachedSetTimeout.call(null, fun, 0);
                } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                    return cachedSetTimeout.call(this, fun, 0);
                }
            }
        }
        function runClearTimeout(marker) {
            if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
            return clearTimeout(marker);
            // if clearTimeout wasn't available but was latter defined
            if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                cachedClearTimeout = clearTimeout;
                return clearTimeout(marker);
            }
            try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedClearTimeout(marker);
            } catch (e) {
                try {
                    // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                    return cachedClearTimeout.call(null, marker);
                } catch (e) {
                    // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                    // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                    return cachedClearTimeout.call(this, marker);
                }
            }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;
        function cleanUpNextTick() {
            if (!draining || !currentQueue) return;
            draining = false;
            if (currentQueue.length) queue = currentQueue.concat(queue);
            else queueIndex = -1;
            if (queue.length) drainQueue();
        }
        function drainQueue() {
            if (draining) return;
            var timeout = runTimeout(cleanUpNextTick);
            draining = true;
            var len = queue.length;
            while(len){
                currentQueue = queue;
                queue = [];
                while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                queueIndex = -1;
                len = queue.length;
            }
            currentQueue = null;
            draining = false;
            runClearTimeout(timeout);
        }
        process.nextTick = function(fun) {
            var args = new Array(arguments.length - 1);
            if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
            queue.push(new Item(fun, args));
            if (queue.length === 1 && !draining) runTimeout(drainQueue);
        };
        // v8 likes predictible objects
        function Item(fun, array) {
            this.fun = fun;
            this.array = array;
        }
        Item.prototype.run = function() {
            this.fun.apply(null, this.array);
        };
        process.title = "browser";
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ""; // empty string to avoid regexp issues
        process.versions = {};
        function noop() {}
        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;
        process.listeners = function(name) {
            return [];
        };
        process.binding = function(name) {
            throw new Error("process.binding is not supported");
        };
        process.cwd = function() {
            return "/";
        };
        process.chdir = function(dir) {
            throw new Error("process.chdir is not supported");
        };
        process.umask = function() {
            return 0;
        };
    /***/ },
    /* 6 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            var emptyFunction = __webpack_require__(7);
            var invariant = __webpack_require__(8);
            var warning = __webpack_require__(9);
            var assign = __webpack_require__(10);
            var ReactPropTypesSecret = __webpack_require__(11);
            var checkPropTypes = __webpack_require__(12);
            module1.exports = function(isValidElement, throwOnDirectAccess) {
                /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
                /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */ function getIteratorFn(maybeIterable) {
                    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if (typeof iteratorFn === "function") return iteratorFn;
                }
                /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */ var ANONYMOUS = "<<anonymous>>";
                // Important!
                // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                var ReactPropTypes = {
                    array: createPrimitiveTypeChecker("array"),
                    bool: createPrimitiveTypeChecker("boolean"),
                    func: createPrimitiveTypeChecker("function"),
                    number: createPrimitiveTypeChecker("number"),
                    object: createPrimitiveTypeChecker("object"),
                    string: createPrimitiveTypeChecker("string"),
                    symbol: createPrimitiveTypeChecker("symbol"),
                    any: createAnyTypeChecker(),
                    arrayOf: createArrayOfTypeChecker,
                    element: createElementTypeChecker(),
                    instanceOf: createInstanceTypeChecker,
                    node: createNodeChecker(),
                    objectOf: createObjectOfTypeChecker,
                    oneOf: createEnumTypeChecker,
                    oneOfType: createUnionTypeChecker,
                    shape: createShapeTypeChecker,
                    exact: createStrictShapeTypeChecker
                };
                /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */ /*eslint-disable no-self-compare*/ function is(x, y) {
                    // SameValue algorithm
                    if (x === y) // Steps 1-5, 7-10
                    // Steps 6.b-6.e: +0 != -0
                    return x !== 0 || 1 / x === 1 / y;
                    else // Step 6.a: NaN == NaN
                    return x !== x && y !== y;
                }
                /*eslint-enable no-self-compare*/ /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */ function PropTypeError(message) {
                    this.message = message;
                    this.stack = "";
                }
                // Make `instanceof Error` still work for returned errors.
                PropTypeError.prototype = Error.prototype;
                function createChainableTypeChecker(validate) {
                    if (process.env.NODE_ENV !== "production") {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                    }
                    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                        componentName = componentName || ANONYMOUS;
                        propFullName = propFullName || propName;
                        if (secret !== ReactPropTypesSecret) {
                            if (throwOnDirectAccess) // New behavior only for users of `prop-types` package
                            invariant(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
                                // Old behavior for people using React.PropTypes
                                var cacheKey = componentName + ":" + propName;
                                if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                                manualPropTypeWarningCount < 3) {
                                    warning(false, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", propFullName, componentName);
                                    manualPropTypeCallCache[cacheKey] = true;
                                    manualPropTypeWarningCount++;
                                }
                            }
                        }
                        if (props[propName] == null) {
                            if (isRequired) {
                                if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                            }
                            return null;
                        } else return validate(props, propName, componentName, location, propFullName);
                    }
                    var chainedCheckType = checkType.bind(null, false);
                    chainedCheckType.isRequired = checkType.bind(null, true);
                    return chainedCheckType;
                }
                function createPrimitiveTypeChecker(expectedType) {
                    function validate(props, propName, componentName, location, propFullName, secret) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== expectedType) {
                            // `propValue` being instance of, say, date/regexp, pass the 'object'
                            // check, but we can offer a more precise error message here rather than
                            // 'of type `object`'.
                            var preciseType = getPreciseType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createAnyTypeChecker() {
                    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
                }
                function createArrayOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                        var propValue = props[propName];
                        if (!Array.isArray(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                        }
                        for(var i = 0; i < propValue.length; i++){
                            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createElementTypeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createInstanceTypeChecker(expectedClass) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!(props[propName] instanceof expectedClass)) {
                            var expectedClassName = expectedClass.name || ANONYMOUS;
                            var actualClassName = getClassName(props[propName]);
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createEnumTypeChecker(expectedValues) {
                    if (!Array.isArray(expectedValues)) {
                        process.env.NODE_ENV !== "production" && warning(false, "Invalid argument supplied to oneOf, expected an instance of array.");
                        return emptyFunction.thatReturnsNull;
                    }
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        for(var i = 0; i < expectedValues.length; i++){
                            if (is(propValue, expectedValues[i])) return null;
                        }
                        var valuesString = JSON.stringify(expectedValues);
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                    }
                    return createChainableTypeChecker(validate);
                }
                function createObjectOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                        for(var key in propValue)if (propValue.hasOwnProperty(key)) {
                            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error instanceof Error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createUnionTypeChecker(arrayOfTypeCheckers) {
                    if (!Array.isArray(arrayOfTypeCheckers)) {
                        process.env.NODE_ENV !== "production" && warning(false, "Invalid argument supplied to oneOfType, expected an instance of array.");
                        return emptyFunction.thatReturnsNull;
                    }
                    for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                        var checker = arrayOfTypeCheckers[i];
                        if (typeof checker !== "function") {
                            warning(false, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i);
                            return emptyFunction.thatReturnsNull;
                        }
                    }
                    function validate(props, propName, componentName, location, propFullName) {
                        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                            var checker = arrayOfTypeCheckers[i];
                            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) return null;
                        }
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`."));
                    }
                    return createChainableTypeChecker(validate);
                }
                function createNodeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                        for(var key in shapeTypes){
                            var checker = shapeTypes[key];
                            if (!checker) continue;
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function createStrictShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                        // We need to check all keys in case some are required but missing from
                        // props.
                        var allKeys = assign({}, props[propName], shapeTypes);
                        for(var key in allKeys){
                            var checker = shapeTypes[key];
                            if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }
                function isNode(propValue) {
                    switch(typeof propValue){
                        case "number":
                        case "string":
                        case "undefined":
                            return true;
                        case "boolean":
                            return !propValue;
                        case "object":
                            if (Array.isArray(propValue)) return propValue.every(isNode);
                            if (propValue === null || isValidElement(propValue)) return true;
                            var iteratorFn = getIteratorFn(propValue);
                            if (iteratorFn) {
                                var iterator = iteratorFn.call(propValue);
                                var step;
                                if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                                    if (!isNode(step.value)) return false;
                                }
                                else // Iterator will provide entry [k,v] tuples rather than values.
                                while(!(step = iterator.next()).done){
                                    var entry = step.value;
                                    if (entry) {
                                        if (!isNode(entry[1])) return false;
                                    }
                                }
                            } else return false;
                            return true;
                        default:
                            return false;
                    }
                }
                function isSymbol(propType, propValue) {
                    // Native Symbol.
                    if (propType === "symbol") return true;
                    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                    if (propValue["@@toStringTag"] === "Symbol") return true;
                    // Fallback for non-spec compliant Symbols which are polyfilled.
                    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
                    return false;
                }
                // Equivalent of `typeof` but with special handling for array and regexp.
                function getPropType(propValue) {
                    var propType = typeof propValue;
                    if (Array.isArray(propValue)) return "array";
                    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
                    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                    // passes PropTypes.object.
                    return "object";
                    if (isSymbol(propType, propValue)) return "symbol";
                    return propType;
                }
                // This handles more types than `getPropType`. Only used for error messages.
                // See `createPrimitiveTypeChecker`.
                function getPreciseType(propValue) {
                    if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
                    var propType = getPropType(propValue);
                    if (propType === "object") {
                        if (propValue instanceof Date) return "date";
                        else if (propValue instanceof RegExp) return "regexp";
                    }
                    return propType;
                }
                // Returns a string that is postfixed to a warning about an invalid type.
                // For example, "undefined" or "of type array"
                function getPostfixForTypeWarning(value) {
                    var type = getPreciseType(value);
                    switch(type){
                        case "array":
                        case "object":
                            return "an " + type;
                        case "boolean":
                        case "date":
                        case "regexp":
                            return "a " + type;
                        default:
                            return type;
                    }
                }
                // Returns class name of the object, if any.
                function getClassName(propValue) {
                    if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
                    return propValue.constructor.name;
                }
                ReactPropTypes.checkPropTypes = checkPropTypes;
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
            };
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 7 */ /***/ function(module1, exports) {
        "use strict";
        /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */ function makeEmptyFunction(arg) {
            return function() {
                return arg;
            };
        }
        /**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */ var emptyFunction = function emptyFunction() {};
        emptyFunction.thatReturns = makeEmptyFunction;
        emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
        emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
        emptyFunction.thatReturnsNull = makeEmptyFunction(null);
        emptyFunction.thatReturnsThis = function() {
            return this;
        };
        emptyFunction.thatReturnsArgument = function(arg) {
            return arg;
        };
        module1.exports = emptyFunction;
    /***/ },
    /* 8 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            /**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */ var validateFormat = function validateFormat(format) {};
            if (process.env.NODE_ENV !== "production") validateFormat = function validateFormat(format) {
                if (format === undefined) throw new Error("invariant requires an error message argument");
            };
            function invariant(condition, format, a, b, c, d, e, f) {
                validateFormat(format);
                if (!condition) {
                    var error;
                    if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                    else {
                        var args = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        var argIndex = 0;
                        error = new Error(format.replace(/%s/g, function() {
                            return args[argIndex++];
                        }));
                        error.name = "Invariant Violation";
                    }
                    error.framesToPop = 1; // we don't care about invariant's own frame
                    throw error;
                }
            }
            module1.exports = invariant;
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 9 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            var emptyFunction = __webpack_require__(7);
            /**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */ var warning = emptyFunction;
            if (process.env.NODE_ENV !== "production") {
                var printWarning = function printWarning(format) {
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    var argIndex = 0;
                    var message = "Warning: " + format.replace(/%s/g, function() {
                        return args[argIndex++];
                    });
                    if (typeof console !== "undefined") console.error(message);
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) {}
                };
                warning = function warning(condition, format) {
                    if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
                    if (format.indexOf("Failed Composite propType: ") === 0) return; // Ignore CompositeComponent proptype check.
                    if (!condition) {
                        for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
                        printWarning.apply(undefined, [
                            format
                        ].concat(args));
                    }
                };
            }
            module1.exports = warning;
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 10 */ /***/ function(module1, exports) {
        /*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/ "use strict";
        /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;
        function toObject(val) {
            if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(val);
        }
        function shouldUseNative() {
            try {
                if (!Object.assign) return false;
                // Detect buggy property enumeration order in older V8 versions.
                // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                test1[5] = "de";
                if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test2 = {};
                for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                });
                if (order2.join("") !== "0123456789") return false;
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test3 = {};
                "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                });
                if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                return true;
            } catch (err) {
                // We don't expect any of the above to throw, but better to be safe.
                return false;
            }
        }
        module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
            var from;
            var to = toObject(target);
            var symbols;
            for(var s = 1; s < arguments.length; s++){
                from = Object(arguments[s]);
                for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                }
            }
            return to;
        };
    /***/ },
    /* 11 */ /***/ function(module1, exports) {
        /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */ "use strict";
        var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        module1.exports = ReactPropTypesSecret;
    /***/ },
    /* 12 */ /***/ function(module1, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */ (function(process) {
            "use strict";
            if (process.env.NODE_ENV !== "production") {
                var invariant = __webpack_require__(8);
                var warning = __webpack_require__(9);
                var ReactPropTypesSecret = __webpack_require__(11);
                var loggedTypeFailures = {};
            }
            /**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                if (process.env.NODE_ENV !== "production") {
                    for(var typeSpecName in typeSpecs)if (typeSpecs.hasOwnProperty(typeSpecName)) {
                        var error;
                        // Prop type validation may throw. In case they do, we don't want to
                        // fail the render phase where it didn't fail before. So we log it.
                        // After these have been cleaned up, we'll let them throw.
                        try {
                            // This is intentionally an invariant that gets caught. It's the same
                            // behavior as without this statement except with a better message.
                            invariant(typeof typeSpecs[typeSpecName] === "function", "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", componentName || "React class", location, typeSpecName, typeof typeSpecs[typeSpecName]);
                            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                        } catch (ex) {
                            error = ex;
                        }
                        warning(!error || error instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error);
                        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                            // Only monitor this failure once because there tends to be a lot of the
                            // same error.
                            loggedTypeFailures[error.message] = true;
                            var stack = getStack ? getStack() : "";
                            warning(false, "Failed %s type: %s%s", location, error.message, stack != null ? stack : "");
                        }
                    }
                }
            }
            module1.exports = checkPropTypes;
        /* WEBPACK VAR INJECTION */ }).call(exports, __webpack_require__(5));
    /***/ },
    /* 13 */ /***/ function(module1, exports, __webpack_require__) {
        /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */ "use strict";
        var emptyFunction = __webpack_require__(7);
        var invariant = __webpack_require__(8);
        var ReactPropTypesSecret = __webpack_require__(11);
        module1.exports = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                invariant(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Important!
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim
            };
            ReactPropTypes.checkPropTypes = emptyFunction;
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
    /***/ },
    /* 14 */ /***/ function(module1, exports) {
        module1.exports = require("6a05f3b52573f4a6");
    /***/ },
    /* 15 */ /***/ function(module1, exports) {
        "use strict";
        var simpleIsEqual = function simpleIsEqual(a, b) {
            return a === b;
        };
        function index(resultFn) {
            var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
            var lastThis = void 0;
            var lastArgs = [];
            var lastResult = void 0;
            var calledOnce = false;
            var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
                return isEqual(newArg, lastArgs[index]);
            };
            var result = function result() {
                for(var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++)newArgs[_key] = arguments[_key];
                if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) return lastResult;
                calledOnce = true;
                lastThis = this;
                lastArgs = newArgs;
                lastResult = resultFn.apply(this, newArgs);
                return lastResult;
            };
            return result;
        }
        module1.exports = index;
    /***/ }
]);

},{"6a05f3b52573f4a6":"cOWTg"}],"gsHLg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isManuallyUpdated", ()=>isManuallyUpdated);
var _personHelpers = require("../../helpers/person.helpers");
const isManuallyUpdated = (entity)=>!(0, _personHelpers.isManuallyCreated)(entity) && Boolean(entity.updated_by);

},{"../../helpers/person.helpers":"6qOIE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ac1b6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _screeningActiveSvg = require("../../../assets/icons/screening_active.svg");
var _screeningActiveSvgDefault = parcelHelpers.interopDefault(_screeningActiveSvg);
var _screeningInactiveSvg = require("../../../assets/icons/screening_inactive.svg");
var _screeningInactiveSvgDefault = parcelHelpers.interopDefault(_screeningInactiveSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const ScreeningType = (props)=>{
    const { screeningType } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (screeningType !== "NONE" && screeningType !== "MONITORING") return null;
    const tooltipContent = screeningType === "MONITORING" ? f("screening-type.tooltip.person.screening.monitoring") : f("screening-type.tooltip.person.screening.none");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
        content: tooltipContent,
        dismissOnMouseOut: true,
        preferredPosition: "above",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: screeningType === "MONITORING" ? (0, _screeningActiveSvgDefault.default) : (0, _screeningInactiveSvgDefault.default)
        })
    });
};
exports.default = ScreeningType;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../assets/icons/screening_active.svg":"gRePr","../../../assets/icons/screening_inactive.svg":"gWCr8","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gRePr":[function(require,module,exports) {
module.exports = require("de7ccb97ffd1b692").getBundleURL("kEMsi") + "screening_active.69a9527c.svg";

},{"de7ccb97ffd1b692":"75UoR"}],"gWCr8":[function(require,module,exports) {
module.exports = require("176f69c9bf5ccbae").getBundleURL("kEMsi") + "screening_inactive.b319bf68.svg";

},{"176f69c9bf5ccbae":"75UoR"}],"b9YWT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUpdatedByOwnershipRegistry", ()=>isUpdatedByOwnershipRegistry);
var _dateUtils = require("../../../../utils/dateUtils");
var _util = require("../../../../utils/util");
const isUpdatedByOwnershipRegistry = (owner)=>{
    // Owner was manually updated by a user
    if (!(0, _util.isNil)(owner.updated_by)) return false;
    // updated_by is nil, which we assume that means the update comes from a registry
    // Now we need to check if the owner actually has been updated:
    // Because Django automatically adds an updated timestamp on creation,
    // we need to compare the created and updated timestamps to check if the
    // owner actually has been updated. If there is less than two seconds between
    // the owner's created and updated timestamp, we assume that the owner has
    // _not_ been updated
    return (0, _dateUtils.secondsBetweenDates)(owner.created_dt, owner.updated_dt) > 2;
};

},{"../../../../utils/dateUtils":"euvUV","../../../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eRCe7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _badge = require("../../../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
const OwnershipUpdateBadge = (props)=>{
    const { update } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!update) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            update.update_type === "ADDED" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                size: "xsmall",
                status: "info",
                children: f("default.new")
            }),
            update.update_type === "UPDATED" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                size: "xsmall",
                status: "info",
                children: f("default.change")
            }),
            update.update_type === "DELETED" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                size: "xsmall",
                children: f("default.expired")
            })
        ]
    });
};
exports.default = OwnershipUpdateBadge;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../hooks/useFormatMessage":"8Y8fq","../../../extensions/Badge":"9irVp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7ISCL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _ownersHelpers = require("../../../../helpers/owners.helpers");
var _personHelpers = require("../../../../helpers/person.helpers");
var _vitecPersonSync = require("../../../VitecPersonSync/VitecPersonSync");
var _vitecPersonSyncDefault = parcelHelpers.interopDefault(_vitecPersonSync);
const VitecOwnerSync = (props)=>{
    const { customerId, owner, readonly, onUpdate } = props;
    if (!(0, _ownersHelpers.isOwnerPerson)(owner)) return null;
    const syncToVitec = ()=>(0, _apiDefault.default).syncCompanyOwner(customerId, {
            owner_id: owner.id
        });
    const updateOwner = (phone)=>(0, _apiDefault.default).updateCompanyOwner(customerId, owner.id, {
            person: {
                ...(0, _personHelpers.convertPersonToUpdateRequest)(owner.person),
                phone
            },
            percent_share: parseFloat(owner.percent_share || "0"),
            comment: owner.comment
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vitecPersonSyncDefault.default), {
        entity: owner,
        isSyncedToVitec: owner.synced_with_vitec,
        readonly: readonly,
        syncToVitecAPICall: syncToVitec,
        updatePersonAPICall: updateOwner,
        onAfterUpdate: onUpdate
    });
};
exports.default = VitecOwnerSync;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../api":"f6lXD","../../../../helpers/owners.helpers":"lynDH","../../../../helpers/person.helpers":"6qOIE","../../../VitecPersonSync/VitecPersonSync":"LkMXw","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"LkMXw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _arrowCircularSvg = require("../../../assets/icons/arrow-circular.svg");
var _arrowCircularSvgDefault = parcelHelpers.interopDefault(_arrowCircularSvg);
var _checkmarkGreenSvg = require("../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _displayHelpers = require("../../helpers/display.helpers");
var _useErrorParser = require("../../hooks/useErrorParser");
var _useErrorParserDefault = parcelHelpers.interopDefault(_useErrorParser);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _stringUtils = require("../../utils/stringUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _personPhoneNumberModal = require("../OwnersCard/OwnersTable/VitecOwnerSync/PersonPhoneNumberModal");
var _personPhoneNumberModalDefault = parcelHelpers.interopDefault(_personPhoneNumberModal);
function VitecPersonSync(props) {
    const { entity, isSyncedToVitec, readonly, syncToVitecAPICall, updatePersonAPICall, onAfterUpdate } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const [phoneNumber, setPhoneNumber] = (0, _react.useState)(entity.person?.phone || "");
    const [showPhoneNumberModal, togglePhoneNumberModal, closePhoneNumberModal] = (0, _useOpenCloseDefault.default)();
    const [showResultToast, toggleResultToast, closeResultToast] = (0, _useOpenCloseDefault.default)();
    const parseError = (0, _useErrorParserDefault.default)("person");
    const syncToVitecMutation = (0, _reactQuery.useMutation)(syncToVitecAPICall, {
        onSuccess: (updatedPerson)=>{
            onAfterUpdate(updatedPerson);
            toggleResultToast();
        },
        onError: toggleResultToast
    });
    const { generalError } = parseError(syncToVitecMutation.error);
    const syncToVitec = (entityToSync = entity)=>syncToVitecMutation.mutate(entityToSync);
    const handlePhoneNumberModalClose = ()=>{
        closePhoneNumberModal();
        setPhoneNumber(""); // clear
    };
    const handleUpdate = (entity)=>{
        handlePhoneNumberModalClose();
        syncToVitec(entity);
    };
    const handleSyncButtonClick = ()=>{
        const isPhoneNumberMissing = !features.VITEC_ROLES_SYNC_WITHOUT_PHONE && (0, _stringUtils.isEmptyString)(phoneNumber);
        if (isPhoneNumberMissing) togglePhoneNumberModal();
        else syncToVitec();
    };
    if (isSyncedToVitec) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _checkmarkGreenSvgDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("common.vitec.synced")
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                size: "slim",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _arrowCircularSvgDefault.default),
                    useMask: true
                }),
                onClick: handleSyncButtonClick,
                loading: syncToVitecMutation.isLoading,
                disabled: readonly,
                children: f("common.vitec.synchronize")
            }),
            showPhoneNumberModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personPhoneNumberModalDefault.default), {
                phoneNumber: phoneNumber,
                onChange: setPhoneNumber,
                apiCall: ()=>updatePersonAPICall(phoneNumber),
                onUpdate: handleUpdate,
                onClose: handlePhoneNumberModalClose,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
                    status: "info",
                    title: f("vitec.modal.banner.description")
                })
            }),
            showResultToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: syncToVitecMutation.isError ? f("vitec.modal.toast.message.error", {
                    name: (0, _displayHelpers.getFullName)(entity.person),
                    error: generalError
                }) : f("vitec.modal.toast.message.success", {
                    name: (0, _displayHelpers.getFullName)(entity.person)
                }),
                onDismiss: closeResultToast,
                error: syncToVitecMutation.isError
            })
        ]
    });
}
exports.default = VitecPersonSync;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../assets/icons/arrow-circular.svg":"jEHse","../../../assets/icons/checkmark-green.svg":"8HW5l","../../helpers/display.helpers":"2q3xY","../../hooks/useErrorParser":"daNOL","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../utils/stringUtils":"4gVdA","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../OwnersCard/OwnersTable/VitecOwnerSync/PersonPhoneNumberModal":"c8iXx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jEHse":[function(require,module,exports) {
module.exports = require("d83204c63ae1cae9").getBundleURL("kEMsi") + "arrow-circular.f7fed9d0.svg";

},{"d83204c63ae1cae9":"75UoR"}],"8HW5l":[function(require,module,exports) {
module.exports = require("d782137c009117a4").getBundleURL("kEMsi") + "checkmark-green.184c5d03.svg";

},{"d782137c009117a4":"75UoR"}],"c8iXx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../../../utils/stringUtils");
var _confirmAction = require("../../../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _kdktextField = require("../../../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
function PersonPhoneNumberModal(props) {
    const { apiCall, phoneNumber, onChange, onClose, onUpdate, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const invalidPhoneNumber = (0, _stringUtils.isEmptyString)(phoneNumber);
    const error = invalidPhoneNumber ? f("common.errors.invalid.empty.mobile-phone") : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _confirmActionDefault.default), {
        apiCall: apiCall,
        title: f("common.labels.missing-information"),
        actionTitle: f("default.save"),
        isActionDisabled: invalidPhoneNumber,
        isDestructive: false,
        onNo: onClose,
        onSuccess: onUpdate,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                    label: f("common.labels.mobile-phone"),
                    value: phoneNumber,
                    onChange: onChange,
                    autoComplete: "on",
                    autoFocus: true,
                    error: error
                })
            })
        ]
    });
}
exports.default = PersonPhoneNumberModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../hooks/useFormatMessage":"8Y8fq","../../../../utils/stringUtils":"4gVdA","../../../ConfirmAction/ConfirmAction":"icP5J","../../../KDKTextField/KDKTextField":"b5QRp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jfzeA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ownersHelpers = require("../../../helpers/owners.helpers");
var _countriesWithWarnings = require("../../CountriesWithWarnings/CountriesWithWarnings");
var _countriesWithWarningsDefault = parcelHelpers.interopDefault(_countriesWithWarnings);
const OwnerCountries = (props)=>{
    const { owner } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countriesWithWarningsDefault.default), {
        fieldCountryMap: (0, _ownersHelpers.getOwnerCountries)(owner)
    });
};
exports.default = OwnerCountries;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../helpers/owners.helpers":"lynDH","../../CountriesWithWarnings/CountriesWithWarnings":"btHEn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"btHEn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useCountries = require("../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _warning = require("../Warning/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _multipleCountries = require("./MultipleCountries");
var _multipleCountriesDefault = parcelHelpers.interopDefault(_multipleCountries);
const CountriesWithWarnings = (props)=>{
    const { fieldCountryMap } = props;
    const { getCountryRiskDescription, isHighRiskCountry } = (0, _useCountriesDefault.default)();
    const highRiskCountriesSet = new Set([
        ...fieldCountryMap.values()
    ].flat().filter(isHighRiskCountry));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: highRiskCountriesSet ? "2" : "0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multipleCountriesDefault.default), {
                countries: fieldCountryMap
            }),
            [
                ...highRiskCountriesSet
            ].map((country)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {
                    children: getCountryRiskDescription(country)
                }, country))
        ]
    });
};
exports.default = CountriesWithWarnings;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useCountries":"azDTp","../Warning/Warning":"e8oAf","./MultipleCountries":"bx2dQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e8oAf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const Warning = (props)=>{
    const { children, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWarningText, {
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            color: "subdued",
            children: children
        })
    });
};
const StyledWarningText = (0, _styledComponentsDefault.default).span`
  white-space: pre-wrap;
  font-size: var(--p-font-size-75);
  font-style: italic;
  line-height: var(--p-font-line-height-1);
`;
exports.default = Warning;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bx2dQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _riskHelpers = require("../../helpers/risk.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetCountryFieldTranslation = require("../../hooks/useGetCountryFieldTranslation");
var _useGetCountryFieldTranslationDefault = parcelHelpers.interopDefault(_useGetCountryFieldTranslation);
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const MultipleCountries = (props)=>{
    const { countries } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const getCountryFieldTranslation = (0, _useGetCountryFieldTranslationDefault.default)();
    // group all fields by country
    const fieldsByCountryMap = (0, _riskHelpers.groupByCountry)(countries);
    const showMultipleCountries = Object.keys(fieldsByCountryMap).length > 1;
    const getTooltipContent = (country, fieldTypes)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTooltipContentWrapper, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                        country: country,
                        fontWeight: "semibold"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List), {
                        children: fieldTypes.map((fieldType)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                                children: getCountryFieldTranslation(fieldType)
                            }, fieldType))
                    })
                ]
            })
        });
    if (countries.size === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            children: f("default.unknown")
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
        gap: "1",
        children: [
            ...Object.entries(fieldsByCountryMap)
        ].map(([country, fieldTypes])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: getTooltipContent(country, fieldTypes),
                preferredPosition: "above",
                dismissOnMouseOut: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCountry, {
                    country: country,
                    hideLabel: showMultipleCountries,
                    showMultipleCountries: showMultipleCountries
                }, country)
            }, country))
    });
};
const StyledCountry = (0, _styledComponentsDefault.default)((0, _countryDefault.default))`
  // increase font size if only showing country flags without labels
  font-size: ${({ showMultipleCountries })=>showMultipleCountries ? "var(--p-font-size-100)" : "inherit"};
  white-space: break-spaces;
`;
const StyledTooltipContentWrapper = (0, _styledComponentsDefault.default).div`
  padding: var(--p-space-4);
`;
exports.default = MultipleCountries;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/risk.helpers":"1qPrk","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetCountryFieldTranslation":"7MDus","../Country/Country":"eeWSc","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1qPrk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIndustryRiskCount", ()=>getIndustryRiskCount);
parcelHelpers.export(exports, "groupByCountry", ()=>groupByCountry);
parcelHelpers.export(exports, "getUnifiedCustomerDisclosureRiskInformation", ()=>getUnifiedCustomerDisclosureRiskInformation);
parcelHelpers.export(exports, "isGeographicalRiskIndicator", ()=>isGeographicalRiskIndicator);
parcelHelpers.export(exports, "groupRiskInformationByPersonName", ()=>groupRiskInformationByPersonName);
parcelHelpers.export(exports, "getPersonnelRiskInformation", ()=>getPersonnelRiskInformation);
var _utilities = require("../types/utilities");
var _collectionUtils = require("../utils/collectionUtils");
var _disclosuresHelpers = require("./disclosures.helpers");
var _personHelpers = require("./person.helpers");
const getIndustryRiskCount = (industryRisk)=>(industryRisk?.industry_types.industry_code_1?.has_risk ? 1 : 0) + (industryRisk?.industry_types.industry_code_2?.has_risk ? 1 : 0) + (industryRisk?.industry_types.industry_code_3?.has_risk ? 1 : 0);
const groupByCountry = (countryFields)=>{
    return [
        ...countryFields.entries()
    ].reduce((map, [fieldType, countries])=>{
        [
            countries
        ].flat().forEach((country)=>map[country] = [
                ...map[country] || [],
                fieldType
            ]);
        return map;
    }, {});
};
const getUnifiedCustomerDisclosureRiskInformation = (customer)=>{
    const disclosuresRiskInformation = [];
    (0, _disclosuresHelpers.traverseSignedSignatures)(customer, (signature)=>{
        signature.disclosure_answers?.sections.flatMap((section)=>section.answers).forEach((answer)=>{
            answer.risk_indicators?.forEach((riskIndicator)=>{
                if (!isGeographicalRiskIndicator(riskIndicator.type)) disclosuresRiskInformation.push({
                    signature,
                    riskIndicator,
                    answer
                });
            });
        });
    });
    return disclosuresRiskInformation;
};
const isGeographicalRiskIndicator = (riskIndicatorType)=>riskIndicatorType === "HIGH_RISK_COUNTRY";
const groupRiskInformationByPersonName = (countriesRisk)=>{
    // group risk information people to avoid showing the same person with different roles
    // only a single person will be shown with multiple roles (if exists)
    const peopleByNameMap = (0, _collectionUtils.groupBy)(countriesRisk, (risk)=>risk.person ? (0, _personHelpers.getPersonKey)(risk.person) : risk.name);
    const groupedRiskInformation = [
        ...peopleByNameMap.values()
    ].map((people)=>({
            // people is a list of all the roles/owners with the same name + birth year
            // deconstruct the entire list into a single object and add all the different role types / ownership
            // to types field
            ...Object.assign({}, ...people),
            types: people.map((risk)=>risk.role?.type).filter(Boolean)
        }));
    return groupedRiskInformation;
};
const getRolesRiskInformation = (customer)=>{
    return customer.roles.filter((role)=>role.person?.is_pep || role.person?.is_sanctioned).map((role)=>({
            isPep: Boolean(role.person?.is_pep),
            isSanctioned: Boolean(role.person?.is_sanctioned),
            person: role.person,
            customerType: "person",
            role: role
        }));
};
const getOwnersRiskInformation = (customer)=>{
    return customer.beneficial_owners.filter((owner)=>owner.person?.is_pep || owner.person?.is_sanctioned).map((owner)=>({
            isPep: Boolean(owner.person?.is_pep),
            isSanctioned: Boolean(owner.person?.is_sanctioned),
            person: owner.person,
            customerType: owner.company ? "company" : "person",
            owner: owner
        }));
};
const getPersonnelRiskInformation = (customer)=>{
    if ((0, _utilities.isPersonCustomerDetails)(customer)) return [];
    const rolesRiskInformation = getRolesRiskInformation(customer);
    const ownersRiskInformation = getOwnersRiskInformation(customer);
    return [
        ...rolesRiskInformation,
        ...ownersRiskInformation
    ];
};

},{"../types/utilities":"6zLpB","../utils/collectionUtils":"gr5mc","./disclosures.helpers":"6yWoC","./person.helpers":"6qOIE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6yWoC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "traverseSignedSignatures", ()=>traverseSignedSignatures);
parcelHelpers.export(exports, "getRiskDescriptions", ()=>getRiskDescriptions);
parcelHelpers.export(exports, "isKYCSelected", ()=>isKYCSelected);
parcelHelpers.export(exports, "isValidSignatureConfiguration", ()=>isValidSignatureConfiguration);
var _collectionUtils = require("../utils/collectionUtils");
const traverseSignedSignatures = (customer, callback)=>{
    customer.disclosure_documents.sort((doc1, doc2)=>{
        const doc1Date = doc1.signed_dt ? new Date(doc1.signed_dt).getTime() : 0;
        const doc2Date = doc2.signed_dt ? new Date(doc2.signed_dt).getTime() : 0;
        return doc2Date - doc1Date;
    }).filter((disclosure)=>disclosure.is_signed).forEach((disclosure)=>disclosure.signatures.filter((signature)=>signature.status == "SIGNED").forEach(callback));
};
const getRiskDescriptions = ({ description, additional_description = [] })=>[
        description,
        additional_description
    ].flat().filter(Boolean);
const isKYCSelected = (signature)=>Boolean(signature.use_standard_disclosure || signature.use_pep_disclosure);
const isValidSignatureConfiguration = (signature)=>signature.use_verification || isKYCSelected(signature) || (0, _collectionUtils.hasContent)(signature.questionnaire_ids);

},{"../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7MDus":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useGetCountryFieldTranslation = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const getCountryFieldTranslation = (0, _react.useCallback)((countryField)=>{
        switch(countryField){
            case "COUNTRY_OF_ORIGIN":
                return f("common.labels.country-of-origin");
            case "COUNTRY_OF_CITIZENSHIP":
                return f("common.labels.citizenship");
            case "COUNTRY_OF_RESIDENCE":
                return f("common.labels.country-of-residence");
            case "NATIONAL_ID_COUNTRY":
                return f("common.labels.national-id-country");
            case "COUNTRY":
                return f("common.labels.country");
            case "ADDRESS":
                return f("common.labels.address");
            case "OFFICE_ADDRESS":
                return f("common.labels.office-address");
            case "BUSINESS_ADDRESS":
                return f("common.labels.business-address");
            case "PEP_POSITION_COUNTRY":
                return f("common.labels.pep-position-country");
            case "KYC_INVOLVED_WITH_FOREIGN_COUNTRY":
                return f("disclosure.foreign-assignment-description");
            default:
                return countryField;
        }
    }, []);
    return getCountryFieldTranslation;
};
exports.default = useGetCountryFieldTranslation;

},{"react":"cOWTg","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kPLOa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatOwnershipPercentage = require("../../../hooks/useFormatOwnershipPercentage");
var _useFormatOwnershipPercentageDefault = parcelHelpers.interopDefault(_useFormatOwnershipPercentage);
var _stringUtils = require("../../../utils/stringUtils");
var _condensedText = require("../../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
const OwnerPercentShare = (props)=>{
    const { owner, update } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const formatPercent = (0, _useFormatOwnershipPercentageDefault.default)();
    const hasUpdate = update?.update_type === "UPDATED";
    const fieldChange = update?.field_changes?.find((change)=>change.field_name === "percent_share");
    const updateLabel = (0, _stringUtils.compareNumericStrings)(fieldChange?.new, fieldChange?.old) ? f("default.up-from", {
        value: formatPercent(fieldChange?.old)
    }) : f("default.down-from", {
        value: formatPercent(fieldChange?.old)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "0",
        align: "start",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                color: owner.deleted ? "subdued" : undefined,
                children: formatPercent(owner.percent_share)
            }),
            hasUpdate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                children: updateLabel
            })
        ]
    });
};
exports.default = OwnerPercentShare;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useFormatOwnershipPercentage":"ihLqM","../../../utils/stringUtils":"4gVdA","../../CondensedText/CondensedText":"1FshD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"97XmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _countries = require("../../../constants/countries");
var _externalUrls = require("../../../constants/external-urls");
var _ownersHelpers = require("../../../helpers/owners.helpers");
var _useCountries = require("../../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useGetOwnerWarning = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const { isHighRiskCountry } = (0, _useCountriesDefault.default)();
    const getOwnerWarning = (owner)=>{
        const isForeignCompany = owner.company && owner.company.address?.country !== (0, _countries.DEFAULT_COUNTRY);
        if (isForeignCompany) return {
            description: f("company.owners.warning.foreign-company"),
            url: (0, _externalUrls.UNKNOWN_OWNER_SUPPORT_PAGE)
        };
        if (owner.is_unknown) return {
            description: f("company.owners.warning.unidentified-owner"),
            url: (0, _externalUrls.UNKNOWN_OWNER_SUPPORT_PAGE)
        };
    };
    const hasWarnings = (owner)=>{
        const countries = (0, _ownersHelpers.getOwnerCountries)(owner);
        const highRiskCountriesSet = new Set([
            ...countries.values()
        ].flat().filter(isHighRiskCountry));
        const warning = getOwnerWarning(owner);
        return warning !== undefined || highRiskCountriesSet.size > 0;
    };
    return {
        getOwnerWarning,
        hasWarnings
    };
};
exports.default = useGetOwnerWarning;

},{"../../../constants/countries":"2hBLK","../../../constants/external-urls":"bvBLe","../../../helpers/owners.helpers":"lynDH","../../../hooks/useCountries":"azDTp","../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bvBLe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLAN_CONVERSION_PAGE", ()=>PLAN_CONVERSION_PAGE);
parcelHelpers.export(exports, "SUPPORT_EMAIL", ()=>SUPPORT_EMAIL);
parcelHelpers.export(exports, "SHARES_CLASSES_SUPPORT_PAGE", ()=>SHARES_CLASSES_SUPPORT_PAGE);
parcelHelpers.export(exports, "UNKNOWN_OWNER_SUPPORT_PAGE", ()=>UNKNOWN_OWNER_SUPPORT_PAGE);
parcelHelpers.export(exports, "WHATS_NEW_TRELLO_BOARD", ()=>WHATS_NEW_TRELLO_BOARD);
const PLAN_CONVERSION_PAGE = "https://www.beaufort.io/priser";
const SUPPORT_EMAIL = "support-kdk@stoe.no";
const SHARES_CLASSES_SUPPORT_PAGE = "https://support.beaufort.io/knowledge/aksjeklasser";
const UNKNOWN_OWNER_SUPPORT_PAGE = "https://support.beaufort.io/knowledge/uidentifiserte-eiere-fra-aksjonaerregisteret";
const WHATS_NEW_TRELLO_BOARD = "https://trello.com/invite/b/XEoBlM8S/ATTI43094f2ae0add5043c39ebda9455b96eB44B6FDD/\uD83D\uDE80-nyheter-i-kjenn-din-kunde";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"axfxv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _triangleFilledExclamationSvg = require("../../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _warning = require("../../Warning/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
const WarningWrapper = (props)=>{
    const { showWarning, description, url, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "2",
        wrap: false,
        blockAlign: "baseline",
        children: [
            showWarning && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _triangleFilledExclamationSvgDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    children,
                    description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {
                        children: description
                    }),
                    url && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLinkLabel, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    children: f("common.labels.more-information-at")
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLink, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                                        url: url,
                                        external: true,
                                        monochrome: false,
                                        children: f("default.support-portal")
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const StyledLinkLabel = (0, _styledComponentsDefault.default).span`
  font-size: var(--p-font-size-75);
  line-height: var(--p-font-line-height-1);
`;
const StyledLink = (0, _styledComponentsDefault.default)(StyledLinkLabel)`
  color: var(--p-interactive);
`;
exports.default = WarningWrapper;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../../../hooks/useFormatMessage":"8Y8fq","../../extensions/Icon":"eHSf0","../../Warning/Warning":"e8oAf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4pLP6":[function(require,module,exports) {
module.exports = require("977ec35af69e1d44").getBundleURL("kEMsi") + "triangle-filled-exclamation.3e9912d3.svg";

},{"977ec35af69e1d44":"75UoR"}],"lugoD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTable = require("@tanstack/react-table");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _tables = require("../../constants/tables");
var _ownersHelpers = require("../../helpers/owners.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatOwnershipPercentage = require("../../hooks/useFormatOwnershipPercentage");
var _useFormatOwnershipPercentageDefault = parcelHelpers.interopDefault(_useFormatOwnershipPercentage);
var _util = require("../../utils/util");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _ownerCountries = require("../OwnersCard/OwnersTable/OwnerCountries");
var _ownerCountriesDefault = parcelHelpers.interopDefault(_ownerCountries);
var _ownerName = require("../OwnersCard/OwnersTable/OwnerName/OwnerName");
var _ownerNameDefault = parcelHelpers.interopDefault(_ownerName);
var _useGetOwnerWarning = require("../OwnersCard/OwnersTable/useGetOwnerWarning");
var _useGetOwnerWarningDefault = parcelHelpers.interopDefault(_useGetOwnerWarning);
var _reactTable1 = require("../ReactTable/ReactTable");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable1);
var _warningWrapperTooltip = require("../WarningWrapperTooltip/WarningWrapperTooltip");
var _warningWrapperTooltipDefault = parcelHelpers.interopDefault(_warningWrapperTooltip);
const calcRelativePercentage = (ownership)=>Math.max(...ownership.map((branch)=>branch.percent_owned));
// convert api.OwnershipTreeNode to a simpler node structure
const convertOwnershipTreeNode = (treeNode, relative_percentage)=>{
    const owner = treeNode.owner;
    const node = {
        owner: {
            ...owner,
            id: owner.id + (0, _util.uniqueId)("ownership-node")
        },
        nodes: treeNode.children.map((child)=>convertOwnershipTreeNode(child.node, calcRelativePercentage(child.ownership))),
        relative_percentage: relative_percentage ? relative_percentage.toString() : ""
    };
    return node;
};
const OwnershipStructureTree = (props)=>{
    const { rootNode, searchTerm } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const formatPercent = (0, _useFormatOwnershipPercentageDefault.default)();
    const { getOwnerWarning, hasWarnings } = (0, _useGetOwnerWarningDefault.default)();
    const columns = (0, _react.useMemo)(()=>{
        const columnHelper = (0, _reactTable.createColumnHelper)();
        return [
            columnHelper.accessor((row)=>(0, _ownersHelpers.getOwnerName)(row.owner), {
                header: f("table.column.name"),
                id: "name",
                filterFn: "includesStringSensitive",
                size: (0, _tables.MAIN_OWNERS_COLUMN_SIZE),
                cell: (props)=>{
                    const owner = props.row.original.owner;
                    const showWarning = hasWarnings(owner);
                    const warning = getOwnerWarning(owner);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningWrapperTooltipDefault.default), {
                        showWarning: showWarning,
                        description: warning?.description,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerNameDefault.default), {
                            owner: owner,
                            searchTerm: searchTerm
                        })
                    });
                }
            }),
            columnHelper.accessor((row)=>row.owner.percent_share, {
                header: f("table.column.shares"),
                id: "percent",
                cell: ({ getValue })=>(0, _util.isEmpty)(getValue()) ? "" : formatPercent(getValue())
            }),
            columnHelper.accessor((row)=>row.owner.id, {
                header: f("table.column.country"),
                enableSorting: false,
                id: "countries",
                cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerCountriesDefault.default), {
                        owner: props.row.original.owner
                    })
            })
        ];
    }, [
        searchTerm
    ]);
    const nodes = (0, _react.useMemo)(()=>[
            convertOwnershipTreeNode(rootNode)
        ], [
        rootNode.owner.id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTable, {
        columns: columns,
        data: nodes,
        expandable: true,
        showTreeLines: true,
        globalFilter: searchTerm,
        sortLocally: true,
        getRowId: (node)=>node.owner.id,
        getSubRows: (node)=>node.nodes,
        getRowLineLabel: (node)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                children: formatPercent(node.relative_percentage, 0)
            })
    });
};
const StyledTable = (0, _styledComponentsDefault.default)((0, _reactTableDefault.default))`
  & .Polaris-DataTable__TableRow + .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {
    border-top: none;
  }

  & .Polaris-DataTable__Cell {
    padding-top: var(--p-space-2);
    padding-bottom: var(--p-space-2);
  }
`;
exports.default = /*#__PURE__*/ (0, _react.memo)(OwnershipStructureTree);

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-table":"86D8M","styled-components":"eBrdC","../../constants/tables":"01ORG","../../helpers/owners.helpers":"lynDH","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatOwnershipPercentage":"ihLqM","../../utils/util":"4MniK","../CondensedText/CondensedText":"1FshD","../OwnersCard/OwnersTable/OwnerCountries":"jfzeA","../OwnersCard/OwnersTable/OwnerName/OwnerName":"eQr1s","../OwnersCard/OwnersTable/useGetOwnerWarning":"97XmT","../ReactTable/ReactTable":"iNTSb","../WarningWrapperTooltip/WarningWrapperTooltip":"5lEda","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5lEda":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _triangleFilledExclamationSvg = require("../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _warning = require("../Warning/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
const WarningWrapperTooltip = (props)=>{
    const { showWarning, description, children } = props;
    if (!showWarning) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {
                    children: description
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _triangleFilledExclamationSvgDefault.default)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                gap: "2",
                children: children
            })
        ]
    });
};
exports.default = WarningWrapperTooltip;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","../Warning/Warning":"e8oAf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k5bRy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const SearchTextField = (props)=>{
    const { label, ...textFieldProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
        label: label || textFieldProps.placeholder || f("default.search"),
        autoComplete: "off",
        inputMode: "search",
        prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Icon), {
            source: (0, _polarisIcons.SearchMinor)
        }),
        ...textFieldProps
    });
};
exports.default = SearchTextField;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Zoco":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _personHelpers = require("../../helpers/person.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _addItemButton = require("../AddItemButton/AddItemButton");
var _addItemButtonDefault = parcelHelpers.interopDefault(_addItemButton);
var _roleModal = require("../RoleModal/RoleModal");
var _roleModalDefault = parcelHelpers.interopDefault(_roleModal);
var _rolesTable = require("./RolesTable/RolesTable");
var _rolesTableDefault = parcelHelpers.interopDefault(_rolesTable);
const RolesCard = (props)=>{
    const { roles, readonly, companyCountry, hideAddButton, customer, getIsDeleteDisabled, onCreate, onUpdate, onDelete, ...rolesTableProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [modalRole, setModalRole] = (0, _react.useState)();
    const closeModal = ()=>setModalRole(undefined);
    const editRole = (role)=>setModalRole(role);
    const handleCreateRole = (role)=>{
        onCreate(role);
        closeModal();
    };
    const handleUpdateRole = (role)=>{
        onUpdate(role);
        closeModal();
    };
    const handleDeleteRole = (roleId)=>{
        onDelete(roleId);
        closeModal();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            roles.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: f("roles.messages.no-roles")
            }),
            roles.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rolesTableDefault.default), {
                roles: roles,
                customer: customer,
                onEdit: editRole,
                onUpdate: onUpdate,
                readonly: readonly,
                ...rolesTableProps
            }),
            !hideAddButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addItemButtonDefault.default), {
                    onClick: ()=>setModalRole((0, _personHelpers.createNewRole)(companyCountry)),
                    disabled: readonly,
                    children: f("screening.buttons.add-role")
                })
            }),
            modalRole && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleModalDefault.default), {
                customer: customer,
                dataRole: modalRole,
                onClose: closeModal,
                isDeleteDisabled: getIsDeleteDisabled(modalRole.id),
                onCreate: handleCreateRole,
                onUpdate: handleUpdateRole,
                onDelete: handleDeleteRole
            })
        ]
    });
};
exports.default = RolesCard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/person.helpers":"6qOIE","../../hooks/useFormatMessage":"8Y8fq","../AddItemButton/AddItemButton":"8Rs0C","../RoleModal/RoleModal":"ijQn9","./RolesTable/RolesTable":"13vNz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ijQn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _displayHelpers = require("../../helpers/display.helpers");
var _personHelpers = require("../../helpers/person.helpers");
var _rolesHelpers = require("../../helpers/roles.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _personForm = require("../PersonForm/PersonForm");
var _personFormDefault = parcelHelpers.interopDefault(_personForm);
var _roleTypeSelect = require("../RoleTypeSelect/RoleTypeSelect");
var _roleTypeSelectDefault = parcelHelpers.interopDefault(_roleTypeSelect);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _ubomanualOverride = require("../UBOManualOverride/UBOManualOverride");
var _ubomanualOverrideDefault = parcelHelpers.interopDefault(_ubomanualOverride);
const RoleModal = (props)=>{
    const { dataRole, customer, isDeleteDisabled, onDelete, onUpdate, onCreate, onClose } = props;
    const [role, setRole] = (0, _react.useState)({
        ...dataRole
    });
    const isUpdatingRole = Boolean(role.id);
    const [showDeleteConfirm, toggleDeleteConfirm, closeDeleteConfirm] = (0, _useOpenCloseDefault.default)(false);
    const [isFormValid, setIsFormValid] = (0, _react.useState)(role.id !== undefined);
    const f = (0, _useFormatMessageDefault.default)();
    const saveRoleMutation = (0, _reactQuery.useMutation)(()=>{
        const { type = "UNKNOWN_ROLE", comment } = role;
        return isUpdatingRole && role.id ? (0, _apiDefault.default).updateCompanyRole(customer.id, role.id, {
            type,
            comment,
            custom_is_ubo: role.custom_is_ubo,
            person: (0, _personHelpers.convertPersonToUpdateRequest)(role.person)
        }) : (0, _apiDefault.default).createCompanyRole(customer.id, {
            type,
            comment,
            custom_is_ubo: role.custom_is_ubo,
            person: (0, _personHelpers.convertPersonToCreateRequest)(role.person)
        });
    }, {
        onSuccess: (updatedRole)=>{
            isUpdatingRole ? onUpdate(updatedRole) : onCreate({
                ...updatedRole,
                is_new: true
            });
        }
    });
    const handleChange = (key, value)=>setRole((prevRole)=>({
                ...prevRole,
                [key]: value
            }));
    const saveNewRole = ()=>saveRoleMutation.mutate();
    const isSaveButtonDisabled = saveRoleMutation.isLoading || !isFormValid || !(0, _rolesHelpers.isValidRole)(role);
    const isBirthDateRequired = (0, _personHelpers.isUserCreatedPerson)(role) && (0, _rolesHelpers.isDateOfBirthRequired)(role.type);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
        open: true,
        large: true,
        onClose: onClose,
        title: isUpdatingRole ? f("modals.role.title.update") : f("modals.role.title.add"),
        primaryAction: {
            content: isUpdatingRole ? f("default.save") : f("default.add"),
            onAction: saveNewRole,
            loading: saveRoleMutation.isLoading,
            disabled: isSaveButtonDisabled
        },
        secondaryActions: [
            {
                content: f("default.cancel"),
                onAction: onClose
            }
        ],
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "4",
            blockAlign: "center",
            children: [
                isUpdatingRole && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                    content: isDeleteDisabled ? f("modals.role.tooltips.delete-disabled") : "",
                    preferredPosition: "above",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                        destructive: true,
                        disabled: isDeleteDisabled || saveRoleMutation.isLoading,
                        onClick: toggleDeleteConfirm,
                        children: f("default.delete")
                    })
                }),
                saveRoleMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: saveRoleMutation.error
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingMd",
                            as: "h2",
                            children: f("modals.headings.personal-information")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personFormDefault.default), {
                            value: role.person,
                            disabled: saveRoleMutation.isLoading,
                            isCreating: (0, _personHelpers.isUserCreatedPerson)(role),
                            birthDateIsRequired: isBirthDateRequired,
                            allowBirthYear: !(0, _personHelpers.isUserCreatedPerson)(role),
                            onChange: (person)=>setRole((prevRole)=>({
                                        ...prevRole,
                                        person
                                    })),
                            onValidityChange: setIsFormValid
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingMd",
                                    as: "h2",
                                    children: f("modals.role.headings.role-in-company")
                                }),
                                role.is_ubo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                    italic: true,
                                    children: f("common.labels.calculated-ubo")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                            distribution: "fillEvenly",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleTypeSelectDefault.default), {
                                    roleType: role.type,
                                    disabled: saveRoleMutation.isLoading,
                                    onChange: (newValue)=>handleChange("type", newValue)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ubomanualOverrideDefault.default), {
                                    checked: (0, _personHelpers.isUBO)(role),
                                    onChange: (newValue)=>handleChange("custom_is_ubo", newValue),
                                    disabled: saveRoleMutation.isLoading
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                    inlineAlign: "start",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                            label: f("common.labels.mark-person-as-pep"),
                                            checked: role.person.is_pep,
                                            onChange: (newValue)=>setRole((prevRole)=>({
                                                        ...prevRole,
                                                        person: {
                                                            ...prevRole.person,
                                                            is_pep: newValue
                                                        }
                                                    })),
                                            disabled: saveRoleMutation.isLoading
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                            label: f("common.labels.mark-person-as-sanctioned"),
                                            checked: role.person.is_sanctioned,
                                            onChange: (newValue)=>setRole((prevRole)=>({
                                                        ...prevRole,
                                                        person: {
                                                            ...prevRole.person,
                                                            is_sanctioned: newValue
                                                        }
                                                    })),
                                            disabled: saveRoleMutation.isLoading
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                    placeholder: f("common.labels.comment"),
                    label: f("common.labels.comment"),
                    multiline: 3,
                    value: role.comment || "",
                    onChange: (newValue)=>handleChange("comment", newValue),
                    disabled: saveRoleMutation.isLoading,
                    autoComplete: "off"
                })
            }),
            showDeleteConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: ()=>(0, _apiDefault.default).deleteCompanyRole(customer.id, role.id),
                title: f("modals.role.confirm.delete.title"),
                description: f("modals.role.confirm.delete.description", {
                    role: (0, _displayHelpers.getFullName)(role.person)
                }),
                onNo: closeDeleteConfirm,
                actionTitle: f("default.delete"),
                onSuccess: ()=>onDelete(role.id)
            })
        ]
    });
};
exports.default = RoleModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../helpers/display.helpers":"2q3xY","../../helpers/person.helpers":"6qOIE","../../helpers/roles.helpers":"31Kd7","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../CondensedText/CondensedText":"1FshD","../ConfirmAction/ConfirmAction":"icP5J","../ErrorPanel/ErrorPanel":"2hHqH","../PersonForm/PersonForm":"8xv61","../RoleTypeSelect/RoleTypeSelect":"63zvi","../TooltipWrapper/TooltipWrapper":"b5W2d","../UBOManualOverride/UBOManualOverride":"ak8eE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"31Kd7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDateOfBirthRequired", ()=>isDateOfBirthRequired);
parcelHelpers.export(exports, "isValidRole", ()=>isValidRole);
var _stringUtils = require("../utils/stringUtils");
var _personHelpers = require("./person.helpers");
const isDateOfBirthRequired = (roleType)=>roleType !== "REPRESENTATIVE";
const isValidRole = (role)=>{
    if (!(0, _personHelpers.isValidPerson)(role)) return false;
    if ((0, _stringUtils.isEmptyString)(role.type)) return false;
    if (isDateOfBirthRequired(role.type)) {
        if (!(0, _personHelpers.isValidPersonDateOfBirth)(role)) return false;
    }
    return true;
};

},{"../utils/stringUtils":"4gVdA","./person.helpers":"6qOIE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"63zvi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _stringUtils = require("../../utils/stringUtils");
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
const RoleTypeSelect = (props)=>{
    const { roleType, disabled, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const [inputValue, setInputValue] = (0, _react.useState)(f((0, _roleTypesDefault.default)[roleType]));
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)([
        roleType
    ]);
    const deselectedOptions = (0, _react.useMemo)(()=>Object.keys((0, _roleTypesDefault.default)).filter((roleType)=>{
            return roleType !== "null" && roleType !== "DEPUTY_BOARD_MEMBER" || roleType === "DEPUTY_BOARD_MEMBER" && roleType === "DEPUTY_BOARD_MEMBER";
        }).map((roleType)=>({
                value: roleType,
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                    searchWords: [
                        inputValue
                    ],
                    textToHighlight: roleType === "DEPUTY_BOARD_MEMBER" ? `${f((0, _roleTypesDefault.default)[roleType])} (${f(`common.roles.not.in.use`)})` : f((0, _roleTypesDefault.default)[roleType])
                })
            })), [
        language,
        inputValue
    ]);
    const [options, setOptions] = (0, _react.useState)(deselectedOptions);
    const updateText = (0, _react.useCallback)((value)=>{
        setInputValue(value);
        if ((0, _stringUtils.isEmptyString)(value)) setOptions(deselectedOptions);
        else {
            const resultOptions = deselectedOptions.filter((option)=>f((0, _roleTypesDefault.default)[option.value]).match((0, _stringUtils.filterRegEx)(value)));
            setOptions(resultOptions);
        }
    }, [
        deselectedOptions
    ]);
    const updateSelection = (0, _react.useCallback)((selected)=>{
        setSelectedOptions(selected);
        const selectedLabels = selected.map((selectedItem)=>f((0, _roleTypesDefault.default)[selectedItem]));
        setInputValue(selectedLabels[0] || "");
        onChange(selected[0]);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete), {
        options: options,
        selected: selectedOptions,
        onSelect: updateSelection,
        allowMultiple: false,
        textField: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete).TextField, {
            onChange: updateText,
            onBlur: ()=>setInputValue(f((0, _roleTypesDefault.default)[roleType])),
            label: f("modals.role.labels.role_type"),
            value: inputValue,
            prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Icon), {
                source: (0, _polarisIcons.SearchMinor),
                color: "base"
            }),
            placeholder: f("modals.role.labels.select.placeholder"),
            inputMode: "search",
            autoComplete: "off",
            disabled: disabled,
            selectTextOnFocus: true,
            requiredIndicator: true
        })
    });
};
exports.default = RoleTypeSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","../../constants/role-types":"fAycz","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useLanguage":"2W6IE","../../utils/stringUtils":"4gVdA","../TextHighlighter/TextHighlighter":"43Xhz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"13vNz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactTable = require("@tanstack/react-table");
var _tables = require("../../../constants/tables");
var _integrationHelpers = require("../../../helpers/integration.helpers");
var _useCountries = require("../../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useFeatures = require("../../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../../utils/util");
var _reactTable1 = require("../../ReactTable/ReactTable");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable1);
var _roleType = require("../../RoleType/RoleType");
var _roleTypeDefault = parcelHelpers.interopDefault(_roleType);
var _roleActions = require("./RoleActions");
var _roleActionsDefault = parcelHelpers.interopDefault(_roleActions);
var _roleCountries = require("./RoleCountries");
var _roleCountriesDefault = parcelHelpers.interopDefault(_roleCountries);
var _roleName = require("./RoleName");
var _roleNameDefault = parcelHelpers.interopDefault(_roleName);
var _vitecRoleSync = require("./VitecRoleSync");
var _vitecRoleSyncDefault = parcelHelpers.interopDefault(_vitecRoleSync);
const RolesTable = (props)=>{
    const { customer, roles, selectedRoles = [], expiredRoles = [], selectable, readonly, showUpdates, companyType, getRoleScreeningType = ()=>undefined, onEdit, onUpdate, onSelectionChange = (0, _util.noop), ...dataTableProps } = props;
    const { hasHighRiskCountries } = (0, _useCountriesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const showVitecSync = features.VITEC_ROLES_SYNC && features.VITEC_PROJECTS && (0, _integrationHelpers.isVitecProject)(customer);
    const columns = (0, _react.useMemo)(()=>{
        const columnHelper = (0, _reactTable.createColumnHelper)();
        const columns = [
            columnHelper.accessor((row)=>row.id, {
                header: f("table.column.name"),
                enableSorting: false,
                size: (0, _tables.MAIN_COLUMN_SIZE),
                cell: (props)=>{
                    const role = props.row.original;
                    const showWarning = hasHighRiskCountries(role.person);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleNameDefault.default), {
                        role: role,
                        showWarning: showWarning,
                        showUpdates: showUpdates,
                        screeningType: getRoleScreeningType(role),
                        companyType: companyType,
                        deleted: expiredRoles.includes(role.id)
                    });
                }
            }),
            columnHelper.accessor((row)=>row.id, {
                header: f("table.column.title"),
                enableSorting: false,
                size: (0, _tables.ROLES_AND_OWNERS_INFO_COLUMN_SIZE),
                id: "title",
                cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleTypeDefault.default), {
                        role: props.row.original
                    })
            }),
            columnHelper.accessor((row)=>row.id, {
                header: f("table.column.country"),
                enableSorting: false,
                id: "countries",
                cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleCountriesDefault.default), {
                        role: props.row.original
                    })
            }),
            columnHelper.accessor((row)=>row.id, {
                id: "actions",
                header: "",
                size: 1,
                enableSorting: false,
                cell: (props)=>{
                    const role = props.row.original;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        blockAlign: "baseline",
                        align: "space-between",
                        wrap: false,
                        children: [
                            showVitecSync && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vitecRoleSyncDefault.default), {
                                customerId: customer.id,
                                role: role,
                                onUpdate: onUpdate
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleActionsDefault.default), {
                                role: role,
                                readonly: readonly,
                                onEdit: onEdit
                            })
                        ]
                    });
                }
            })
        ];
        return columns;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTableDefault.default), {
        columns: columns,
        data: roles,
        selectable: selectable,
        selectedIds: selectedRoles,
        getRowId: (role)=>role.id,
        getRowProps: (role)=>({
                warningBanner: hasHighRiskCountries(role.person)
            }),
        onSelectionChange: onSelectionChange,
        ...dataTableProps
    });
};
exports.default = RolesTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-table":"86D8M","../../../constants/tables":"01ORG","../../../helpers/integration.helpers":"keU9B","../../../hooks/useCountries":"azDTp","../../../hooks/useFeatures":"hvBWb","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/util":"4MniK","../../ReactTable/ReactTable":"iNTSb","../../RoleType/RoleType":"eHoEr","./RoleActions":"cBuLq","./RoleCountries":"jLIgk","./RoleName":"iA3rs","./VitecRoleSync":"4W0OL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eHoEr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const RoleType = (props)=>{
    const { role, ...rest } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!role?.type) return null;
    const roleTypeDescription = f((0, _roleTypesDefault.default)[role.type]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        title: roleTypeDescription,
        className: "Polaris-DataTable__Cell--truncated",
        ...rest,
        children: roleTypeDescription
    });
};
exports.default = RoleType;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../constants/role-types":"fAycz","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cBuLq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _util = require("../../../utils/util");
var _editButton = require("../../EditButton/EditButton");
var _editButtonDefault = parcelHelpers.interopDefault(_editButton);
const RoleActions = (props)=>{
    const { role, readonly, onEdit = (0, _util.noop) } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editButtonDefault.default), {
        onEdit: ()=>onEdit(role),
        readonly: readonly
    });
};
exports.default = RoleActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../utils/util":"4MniK","../../EditButton/EditButton":"frWXb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jLIgk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _personHelpers = require("../../../helpers/person.helpers");
var _countriesWithWarnings = require("../../CountriesWithWarnings/CountriesWithWarnings");
var _countriesWithWarningsDefault = parcelHelpers.interopDefault(_countriesWithWarnings);
const RoleCountries = (props)=>{
    const { role } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countriesWithWarningsDefault.default), {
        fieldCountryMap: (0, _personHelpers.getPersonCountries)(role.person)
    });
};
exports.default = RoleCountries;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../helpers/person.helpers":"6qOIE","../../CountriesWithWarnings/CountriesWithWarnings":"btHEn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iA3rs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _triangleFilledExclamationSvg = require("../../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _roleTypes = require("../../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _customDate = require("../../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _badge = require("../../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _rowHighlighter = require("../../extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _personName = require("../../PersonName/PersonName");
var _personNameDefault = parcelHelpers.interopDefault(_personName);
const RoleName = (props)=>{
    const { role, screeningType, companyType, showUpdates, showWarning, deleted } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const isNew = role.is_new && showUpdates;
    const expired = role.status === "EXPIRED" && showUpdates;
    const uboTooltip = role.custom_is_ubo ? f("common.labels.manual-ubo") : f("screening.roles.is_ubo.description", {
        companyType: companyType,
        roleType: f((0, _roleTypesDefault.default)[role.type])
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
        highlight: isNew,
        subdued: expired,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: showWarning ? "4" : "0",
            wrap: false,
            children: [
                showWarning && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _triangleFilledExclamationSvgDefault.default)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personNameDefault.default), {
                    entity: role,
                    deleted: deleted,
                    uboTooltip: uboTooltip,
                    screeningType: screeningType,
                    wrap: true,
                    children: isNew && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badgeDefault.default), {
                        size: "xsmall",
                        status: "info",
                        children: [
                            f("default.new"),
                            " (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                date: role.updated_dt
                            }),
                            ")"
                        ]
                    })
                })
            ]
        })
    });
};
exports.default = RoleName;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../../../constants/role-types":"fAycz","../../../hooks/useFormatMessage":"8Y8fq","../../CustomDate/CustomDate":"5KD00","../../extensions/Badge":"9irVp","../../extensions/Icon":"eHSf0","../../extensions/RowHighlighter":"9EbPr","../../PersonName/PersonName":"iFxbp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5KD00":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIntl = require("react-intl");
const CustomDate = (props)=>{
    const { date } = props;
    return date ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIntl.FormattedDate), {
        value: date,
        year: "2-digit",
        month: "2-digit",
        day: "2-digit"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "-"
    });
};
exports.default = CustomDate;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4W0OL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _personHelpers = require("../../../helpers/person.helpers");
var _vitecPersonSync = require("../../VitecPersonSync/VitecPersonSync");
var _vitecPersonSyncDefault = parcelHelpers.interopDefault(_vitecPersonSync);
const VitecRoleSync = (props)=>{
    const { customerId, role, onUpdate } = props;
    const syncToVitec = ()=>(0, _apiDefault.default).syncCompanyRole(customerId, {
            role_id: role.id
        });
    const updateRole = (phone)=>(0, _apiDefault.default).updateCompanyRole(customerId, role.id, {
            person: {
                ...(0, _personHelpers.convertPersonToUpdateRequest)(role.person),
                phone
            },
            comment: role.comment,
            type: role.type,
            status: role.status
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vitecPersonSyncDefault.default), {
        entity: role,
        isSyncedToVitec: role.synced_with_vitec,
        syncToVitecAPICall: syncToVitec,
        updatePersonAPICall: updateRole,
        onAfterUpdate: onUpdate
    });
};
exports.default = VitecRoleSync;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../api":"f6lXD","../../../helpers/person.helpers":"6qOIE","../../VitecPersonSync/VitecPersonSync":"LkMXw","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Zeqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _timeoutSvg = require("../../../assets/images/timeout.svg");
var _timeoutSvgDefault = parcelHelpers.interopDefault(_timeoutSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _kdkemptyState = require("../KDKEmptyState/KDKEmptyState");
var _kdkemptyStateDefault = parcelHelpers.interopDefault(_kdkemptyState);
const ScreeningEmptyState = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkemptyStateDefault.default), {
        header: f("screening.errors.heading"),
        description: f("screening.errors.description"),
        image: (0, _timeoutSvgDefault.default),
        altImage: "Action timeout",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
            primary: true,
            onClick: ()=>window.location.reload(),
            children: f("screening.errors.content")
        })
    });
};
exports.default = ScreeningEmptyState;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../../assets/images/timeout.svg":"f7w1Q","../../hooks/useFormatMessage":"8Y8fq","../KDKEmptyState/KDKEmptyState":"bZwvm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f7w1Q":[function(require,module,exports) {
module.exports = require("a47619e4dc0a1b56").getBundleURL("kEMsi") + "timeout.661b8f7c.svg";

},{"a47619e4dc0a1b56":"75UoR"}],"kuEJQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ScreeningSkeleton = (props)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const { progress = 15, message = f("common.loading.data") } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "headingLg",
                    as: "p",
                    children: message
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ProgressBar), {
                    progress: progress,
                    size: "small"
                })
            ]
        })
    });
};
exports.default = ScreeningSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bGehF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ScreeningStatusBadge = (props)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const { screening } = props;
    const { screening_status, screening_type } = screening;
    const isDone = screening_status === "DONE" && (screening_type === "ONE_TIME" || screening_type === "MONITORING");
    if (!isDone) return null;
    const screeningStarted = screening.screening_started ? new Date(screening.screening_started) : undefined;
    const screeningStopped = screening.screening_stopped ? new Date(screening.screening_stopped) : undefined;
    if (!screeningStarted) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            screening_type === "ONE_TIME" && f("screening.status.finished", {
                finished: screeningStarted
            }),
            screening_type === "MONITORING" && screeningStopped && f("screening.status.range", {
                started: screeningStarted,
                stopped: screeningStopped
            })
        ]
    });
};
exports.default = ScreeningStatusBadge;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2sGBG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ScreeningTypeCard = (props)=>{
    const { readonly, screeningType, onScreeningTypeChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: f("screening-type.label.monitoring")
                }),
                helpText: f("onboarding.screening-type.monitoring.helper.text"),
                checked: screeningType === "MONITORING",
                id: "MONITORING",
                name: "screeningType",
                onChange: ()=>onScreeningTypeChange("MONITORING"),
                disabled: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: f("screening-type.label.one-time")
                }),
                helpText: f("onboarding.screening-type.one-time.helper.text"),
                id: "ONE_TIME",
                name: "screeningType",
                checked: screeningType === "ONE_TIME",
                onChange: ()=>onScreeningTypeChange("ONE_TIME"),
                disabled: readonly
            })
        ]
    });
};
exports.default = ScreeningTypeCard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l3u8a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
exports.default = (0, _styledComponentsDefault.default).div`
  height: ${({ size })=>size === "medium" ? "1.5rem" : "var(--kdk-toolbar-height)"};

  &::before {
    content: "";
    display: ${({ divider })=>divider ? "block" : "none"};
    height: 50%;
    width: 100%;
    border-bottom: var(--p-border-divider);
  }
`;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"edWFg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const StopScreeningModal = (props)=>{
    const { id, isOpen, isPerson = false, onStop, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        isDestructive: true,
        isOpen: isOpen,
        actionTitle: f("change-screening.buttons.stop-monitoring"),
        cancelTitle: f("default.close"),
        title: f("change-screening.stop-screening.title"),
        apiCall: ()=>isPerson ? (0, _apiDefault.default).stopPersonScreening(id) : (0, _apiDefault.default).stopCompanyScreening(id),
        description: isPerson ? f("change-screening.stop-screening.description-person") : f("change-screening.stop-screening.description"),
        onNo: onClose,
        onSuccess: onStop
    });
};
exports.default = StopScreeningModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../api":"f6lXD","../../hooks/useFormatMessage":"8Y8fq","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aJP5k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScreeningStarting", ()=>isScreeningStarting);
parcelHelpers.export(exports, "isScreeningActive", ()=>isScreeningActive);
const isScreeningStarting = (screening)=>[
        "NOT_STARTED",
        "STARTING"
    ].includes(screening?.screening_status || "");
const isScreeningActive = (screening)=>screening?.screening_status === "MONITORING" && screening?.screening_type === "MONITORING";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3YBG0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _navigationHelpers = require("../helpers/navigation.helpers");
var _useSnackbar = require("./useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
const useCustomerDetailsBackButton = (customerId, customerType, assignmentId)=>{
    const location = (0, _reactRouterDom.useLocation)();
    const history = (0, _reactRouterDom.useHistory)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const state = location.state || {};
    const { fromCustomerDetails, fromCustomerAssignmentDetails } = state;
    // returning undefined as a URL will cause the BackButton component to call history.goBack() instead of a regular url
    const backButtonURL = fromCustomerDetails || fromCustomerAssignmentDetails ? undefined : (0, _navigationHelpers.getDetailsPageURL)(customerId, customerType, assignmentId);
    const goToCustomerDetails = (snackbarMessage)=>{
        if (snackbarMessage) setSnackbar(snackbarMessage);
        if (backButtonURL) history.push(backButtonURL, state);
        else history.goBack();
    };
    return {
        backButtonURL,
        goToCustomerDetails
    };
};
exports.default = useCustomerDetailsBackButton;

},{"react-router-dom":"1ee65","../helpers/navigation.helpers":"adimP","./useSnackbar":"gQ3G9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"if7XX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
class RetryError extends Error {
    constructor(message){
        super(message);
    }
}
/**
 * query to fetch screening info but extend the number of retries and the period between each try attempt
 * since data-service might take a while before returning roles and owners after creating a new company customer
 */ const useGetCompanyScreeningConfiguration = (customerId)=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { isLoading, isError, error, failureCount, ...rest } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_SCREENING,
        customerId
    ], async ()=>{
        const response = await (0, _apiDefault.default).getCompanyScreeningConfiguration(customerId);
        if (!response?.beneficial_owners_fetched || !response?.roles_fetched) throw new RetryError("Fetching roles and owners again.");
        return Promise.resolve(response);
    }, {
        retry: (0, _queriesKeys.MAX_RETRIES),
        retryDelay: (0, _queriesKeys.RETRY_TIME)
    });
    const loadingProgress = isLoading ? Math.round(failureCount / (0, _queriesKeys.MAX_RETRIES) * 100) : 100;
    const invalidateQuery = ()=>queryClient.invalidateQueries([
            (0, _queriesKeys.QUERIES_KEYS).COMPANY_SCREENING,
            customerId
        ]);
    const isMaxRetriesReached = isError && error instanceof RetryError;
    return {
        isLoading,
        failureCount,
        isError,
        error,
        isMaxRetriesReached,
        loadingProgress,
        invalidateQuery,
        ...rest
    };
};
exports.default = useGetCompanyScreeningConfiguration;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jzTfO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _cardNavigationSection = require("../../components/CardNavigationSection/CardNavigationSection");
var _cardNavigationSectionDefault = parcelHelpers.interopDefault(_cardNavigationSection);
var _collapsibleSection = require("../../components/CollapsibleSection/CollapsibleSection");
var _collapsibleSectionDefault = parcelHelpers.interopDefault(_collapsibleSection);
var _companyInfoTable = require("../../components/CompanyInfoTable/CompanyInfoTable");
var _companyInfoTableDefault = parcelHelpers.interopDefault(_companyInfoTable);
var _companyScreeningSection = require("../../components/CompanyScreeningSection/CompanyScreeningSection");
var _companyScreeningSectionDefault = parcelHelpers.interopDefault(_companyScreeningSection);
var _useCompanyHasCriticalUpdates = require("../../components/CustomerDetailsHeader/CustomerDetailsBanner/useCompanyHasCriticalUpdates");
var _useCompanyHasCriticalUpdatesDefault = parcelHelpers.interopDefault(_useCompanyHasCriticalUpdates);
var _customerDetailsHeader = require("../../components/CustomerDetailsHeader/CustomerDetailsHeader");
var _customerDetailsHeaderDefault = parcelHelpers.interopDefault(_customerDetailsHeader);
var _customerFeaturesSection = require("../../components/CustomerFeaturesSection/CustomerFeaturesSection");
var _customerFeaturesSectionDefault = parcelHelpers.interopDefault(_customerFeaturesSection);
var _customerNotesSection = require("../../components/CustomerNotesSection/CustomerNotesSection");
var _customerNotesSectionDefault = parcelHelpers.interopDefault(_customerNotesSection);
var _customerReviewsSection = require("../../components/CustomerReviewsSection/CustomerReviewsSection");
var _customerReviewsSectionDefault = parcelHelpers.interopDefault(_customerReviewsSection);
var _detailsSkeleton = require("../../components/DetailsSkeleton/DetailsSkeleton");
var _detailsSkeletonDefault = parcelHelpers.interopDefault(_detailsSkeleton);
var _disclosureDocumentSection = require("../../components/DisclosureDocumentSection/DisclosureDocumentSection");
var _disclosureDocumentSectionDefault = parcelHelpers.interopDefault(_disclosureDocumentSection);
var _matchCasesSection = require("../../components/MatchCasesSection/MatchCasesSection");
var _matchCasesSectionDefault = parcelHelpers.interopDefault(_matchCasesSection);
var _navigationSection = require("../../components/NavigationSection/NavigationSection");
var _navigationSectionDefault = parcelHelpers.interopDefault(_navigationSection);
var _newInfoBadge = require("../../components/NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
var _rolesAndOwnersSection = require("../../components/RolesAndOwnersSection/RolesAndOwnersSection");
var _rolesAndOwnersSectionDefault = parcelHelpers.interopDefault(_rolesAndOwnersSection);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _pageAnchors = require("../../constants/page-anchors");
var _queriesKeys = require("../../constants/queries-keys");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _screening = require("../../helpers/screening");
var _useAppTitle = require("../../hooks/useAppTitle");
var _useAppTitleDefault = parcelHelpers.interopDefault(_useAppTitle);
var _useCustomerDetailsRefresh = require("../../hooks/useCustomerDetailsRefresh");
var _useCustomerDetailsRefreshDefault = parcelHelpers.interopDefault(_useCustomerDetailsRefresh);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CompanyDetailsPage = ({ data: customer })=>{
    const f = (0, _useFormatMessageDefault.default)();
    (0, _useAppTitleDefault.default)(customer.name);
    (0, _useCustomerDetailsRefreshDefault.default)(customer);
    const hasFinishedOnboarding = (0, _onboardingHelpers.isOnboardingFinished)(customer);
    const hasCriticalUpdates = (0, _useCompanyHasCriticalUpdatesDefault.default)(customer);
    const readonly = customer.is_archived || !hasFinishedOnboarding;
    const hasNewInfo = customer.info_updates.some((info)=>!info.is_reviewed);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationSectionDefault.default), {
                                anchor: (0, _pageAnchors.PAGE_ANCHORS).TOP_SECTION,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerDetailsHeaderDefault.default), {
                                    customer: customer
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                            flush: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationSectionDefault.default), {
                                anchor: (0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_DETAILS,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsibleSectionDefault.default), {
                                    showPrefix: true,
                                    expanded: hasCriticalUpdates,
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                variant: "bodyMd",
                                                as: "span",
                                                children: f("company.details.title")
                                            }),
                                            hasNewInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                                        ]
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoTableDefault.default), {
                                        companyDetails: customer,
                                        infoUpdates: customer.info_updates,
                                        readonly: readonly
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_MATCH_CASES,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCasesSectionDefault.default), {
                                    customerId: customer.id,
                                    customerType: customer.type,
                                    hasFinishedOnboarding: hasFinishedOnboarding,
                                    matchCases: customer.match_cases,
                                    isScreeningStarting: (0, _screening.isScreeningStarting)(customer.screening),
                                    isScreeningActive: (0, _screening.isScreeningActive)(customer.screening),
                                    readonly: readonly
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                flush: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsibleSectionDefault.default), {
                                    showPrefix: true,
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "bodyMd",
                                        as: "span",
                                        children: f("company.details.screening.title")
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyScreeningSectionDefault.default), {
                                        customer: customer
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).COMPANY_ROLES_AND_OWNERS_SECTION,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rolesAndOwnersSectionDefault.default), {
                        customer: customer,
                        readonly: readonly
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).DISCLOSURES_SECTION,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureDocumentSectionDefault.default), {
                        customerId: customer.id,
                        customerType: "company",
                        disclosureDocuments: customer.disclosure_documents,
                        readonly: readonly,
                        addButtonLabel: f("common.buttons.actions.new-disclosure"),
                        emptyLabel: f("disclosure-documents.empty"),
                        assignments: customer.assignments
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerFeaturesSectionDefault.default), {
                        customer: customer,
                        readonly: readonly
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).REVIEWS_SECTION,
                    bottom: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewsSectionDefault.default), {
                        customer: customer,
                        readonly: readonly
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerNotesSectionDefault.default), {
                        customer: customer,
                        readonly: readonly
                    })
                })
            ]
        })
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(CompanyDetailsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).COMPANY_DETAILS,
    apiFunction: (0, _apiDefault.default).getCompanyCustomerDetails,
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/CardNavigationSection/CardNavigationSection":"fANmn","../../components/CollapsibleSection/CollapsibleSection":"3po8A","../../components/CompanyInfoTable/CompanyInfoTable":"1wVTl","../../components/CompanyScreeningSection/CompanyScreeningSection":"2Jdh4","../../components/CustomerDetailsHeader/CustomerDetailsBanner/useCompanyHasCriticalUpdates":"imh2d","../../components/CustomerDetailsHeader/CustomerDetailsHeader":"ah8Q4","../../components/CustomerFeaturesSection/CustomerFeaturesSection":"2kHZk","../../components/CustomerNotesSection/CustomerNotesSection":"5nVqt","../../components/CustomerReviewsSection/CustomerReviewsSection":"jtFVT","../../components/DetailsSkeleton/DetailsSkeleton":"lj8DC","../../components/DisclosureDocumentSection/DisclosureDocumentSection":"434BH","../../components/MatchCasesSection/MatchCasesSection":"6mVwc","../../components/NavigationSection/NavigationSection":"ayv4V","../../components/NewInfoBadge/NewInfoBadge":"7fmsH","../../components/RolesAndOwnersSection/RolesAndOwnersSection":"5g4hf","../../components/SectionMargin/SectionMargin":"l3u8a","../../constants/page-anchors":"4WmvA","../../constants/queries-keys":"6hYSF","../../helpers/onboarding.helpers":"fMYah","../../helpers/screening":"aJP5k","../../hooks/useAppTitle":"51tmg","../../hooks/useCustomerDetailsRefresh":"hSjF4","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1i0FH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withAsyncPage", ()=>withAsyncPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _react1 = require("@sentry/react");
var _reactQuery = require("@tanstack/react-query");
var _usePageNavigation = require("../../hooks/usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
var _errorPage = require("../../pages/ErrorPage");
var _errorPageDefault = parcelHelpers.interopDefault(_errorPage);
var _browserUtils = require("../../utils/browserUtils");
function AsyncPage(props) {
    const { queryKey, apiFunction, skeleton = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: "Loading..."
    }), paramNames = [], render, ...pageProps } = props;
    const params = (0, _reactRouterDom.useParams)();
    const paramValues = paramNames.map((paramName)=>(0, _browserUtils.removeAnchor)(params[paramName]));
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { navigateInPage } = (0, _usePageNavigationDefault.default)();
    const reactQueryKey = [
        queryKey,
        ...paramValues
    ];
    const { isLoading, isError, error, data } = (0, _reactQuery.useQuery)(reactQueryKey, ({ signal })=>apiFunction(...paramValues, {
            signal
        }), {
        /**
       * Default query retry function
       * Retry 3 times before failing
       */ retry: 3
    });
    (0, _react.useLayoutEffect)(()=>{
        // do not depend on data changes when navigating into a page
        // because that will cause any change in the data to re-scroll the page
        // use isLoading and isError in order to navigate into the page only once
        // after the data was fetched
        if (isLoading || isError) return;
        const handler = requestAnimationFrame(()=>{
            navigateInPage(location.hash ? location.hash.substring(1) : "root", {
                block: "start"
            });
        });
        return ()=>{
            cancelAnimationFrame(handler);
        };
    }, [
        isLoading,
        isError
    ]);
    if (isLoading) return skeleton;
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPageDefault.default), {
        error: error
    });
    if (!data) {
        const queryData = queryClient.getQueryData(reactQueryKey);
        _react1.addBreadcrumb({
            category: "rendering",
            level: "warning",
            message: `Data is undefined for query key: ${reactQueryKey.toString()}`,
            data: {
                reactQueryKey,
                data,
                queryData
            }
        });
    }
    return render(data, pageProps);
}
function withAsyncPage(Component, { ...props }) {
    return ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AsyncPage, {
            ...props,
            render: (data, ...componentProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                    data: data,
                    ...componentProps
                })
        });
}

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@sentry/react":"akCRS","@tanstack/react-query":"91Vyq","../../hooks/usePageNavigation":"1o5Hm","../../pages/ErrorPage":"8Le05","../../utils/browserUtils":"4ShiW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fANmn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _navigationSection = require("../NavigationSection/NavigationSection");
var _navigationSectionDefault = parcelHelpers.interopDefault(_navigationSection);
const CardNavigationSection = (props)=>{
    const { children, ...navigationSectionProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationSectionDefault.default), {
        ...navigationSectionProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: children
            })
        })
    });
};
exports.default = CardNavigationSection;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../NavigationSection/NavigationSection":"ayv4V","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ayv4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactRouterDom = require("react-router-dom");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _pageAnchors = require("../../constants/page-anchors");
var _usePageNavigation = require("../../hooks/usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
// top 10% of the viewport
const TOP_ROOT_MARGIN = "0% 0% -90% 0%";
// bottom 10% of the viewport
const BOTTOM_ROOT_MARGIN = "90% 0% 0% 0%";
const NavigationSection = (props)=>{
    const { anchor, bottom, children } = props;
    const location = (0, _reactRouterDom.useLocation)();
    const history = (0, _reactRouterDom.useHistory)();
    const { isNavigationScrolling } = (0, _usePageNavigationDefault.default)();
    const rootMargin = (0, _react.useMemo)(()=>bottom ? BOTTOM_ROOT_MARGIN : TOP_ROOT_MARGIN, [
        bottom
    ]);
    const handleChange = (0, _react.useCallback)((inView)=>{
        if (inView && anchor) {
            location.hash = anchor === (0, _pageAnchors.PAGE_ANCHORS).TOP_SECTION ? "" : `#${anchor}`;
            history.replace(location);
        }
    }, [
        anchor,
        location.pathname
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInView, {
        id: anchor,
        onChange: handleChange,
        rootMargin: rootMargin,
        skip: isNavigationScrolling,
        children: children
    });
};
const StyledInView = (0, _styledComponentsDefault.default)((0, _reactIntersectionObserver.InView))`
  scroll-margin-top: calc(var(--kdk-toolbar-height) + var(--kdk-message-offset) + var(--p-space-4));
`;
exports.default = NavigationSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intersection-observer":"lkP3E","react-router-dom":"1ee65","styled-components":"eBrdC","../../constants/page-anchors":"4WmvA","../../hooks/usePageNavigation":"1o5Hm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lkP3E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InView", ()=>InView);
parcelHelpers.export(exports, "defaultFallbackInView", ()=>defaultFallbackInView);
parcelHelpers.export(exports, "observe", ()=>observe);
parcelHelpers.export(exports, "useInView", ()=>useInView);
// src/InView.tsx
var _react = require("react");
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
    unsupportedValue = inView;
}
function getRootId(root) {
    if (!root) return "0";
    if (RootIds.has(root)) return RootIds.get(root);
    rootId += 1;
    RootIds.set(root, rootId.toString());
    return RootIds.get(root);
}
function optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
    }).toString();
}
function createObserver(options) {
    let id = optionsToId(options);
    let instance = observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id,
            observer,
            elements
        };
        observerMap.set(id, instance);
    }
    return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id, observer, elements } = createObserver(options);
    let callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function isPlainChildren(props) {
    return typeof props.children !== "function";
}
var InView = class extends _react.Component {
    constructor(props){
        super(props);
        __publicField(this, "node", null);
        __publicField(this, "_unobserveCb", null);
        __publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        __publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!isPlainChildren(this.props)) this.setState({
                inView,
                entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold, root, rootMargin, trackVisibility, delay, fallbackInView } = this.props;
        this._unobserveCb = observe(this.node, this.handleChange, {
            threshold,
            root,
            rootMargin,
            // @ts-ignore
            trackVisibility,
            // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children } = this.props;
        if (typeof children === "function") {
            const { inView, entry } = this.state;
            return children({
                inView,
                entry,
                ref: this.handleNode
            });
        }
        const { as, triggerOnce, threshold, root, rootMargin, onChange, skip, trackVisibility, delay, initialInView, fallbackInView, ...props } = this.props;
        return _react.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function useInView({ threshold, delay, trackVisibility, rootMargin, root, triggerOnce, skip, initialInView, fallbackInView, onChange } = {}) {
    var _a;
    const [ref, setRef] = _react.useState(null);
    const callback = _react.useRef();
    const [state, setState] = _react.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    _react.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = observe(ref, (inView, entry)=>{
            setState({
                inView,
                entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root,
            rootMargin,
            threshold,
            // @ts-ignore
            trackVisibility,
            // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = _react.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3po8A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CollapsibleSection = (props)=>{
    const { title, expanded, showPrefix, withoutHeader, status, standalone, className, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [isExpanded, toggleExpanded] = (0, _useOpenCloseDefault.default)(expanded);
    const ButtonTitle = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            children: [
                showPrefix && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: isExpanded ? f("default.hide") : f("default.show")
                }),
                title
            ]
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledButton, {
                onClick: toggleExpanded,
                removeUnderline: true,
                monochrome: true,
                fullWidth: true,
                plain: true,
                textAlign: "left",
                disclosure: isExpanded ? "up" : "down",
                withPadding: !withoutHeader,
                isExpanded: isExpanded,
                status: status,
                standalone: standalone,
                className: className,
                children: [
                    withoutHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonTitle, {}),
                    !withoutHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        fontWeight: "semibold",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonTitle, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                open: isExpanded,
                id: "",
                children: children
            })
        ]
    });
};
const StyledButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  display: inline-block;
  padding: var(--p-space-2) 1px;

  & .Polaris-Button {
    border-top-left-radius: ${({ standalone })=>standalone ? "var(--p-border-radius-2)" : 0};
    border-top-right-radius: ${({ standalone })=>standalone ? "var(--p-border-radius-2)" : 0};
    padding: ${({ withPadding })=>withPadding ? "var(--p-space-3)" : "0"};

    border-bottom-left-radius: ${({ isExpanded })=>isExpanded ? 0 : "var(--p-border-radius-2)"};
    border-bottom-right-radius: ${({ isExpanded })=>isExpanded ? 0 : "var(--p-border-radius-2)"};
  }

  & .Polaris-Button.Polaris-Button--plain {
    border: var(--p-border-width-1) solid transparent;
  }

  & .Polaris-Button.Polaris-Button--plain .Polaris-Button__Content {
    width: 100%;
    padding: ${({ withPadding })=>withPadding ? "var(--p-space-2)" : "0"};
    background: ${({ status })=>status ? `var(--p-color-bg-${status}-subdued)` : undefined};
  }

  & .Polaris-Button.Polaris-Button--plain:active .Polaris-Button__Content {
    margin: 0;
  }

  &:hover .Polaris-Button {
    background: ${({ status })=>status ? undefined : "var(--kdk-plain-button-hovered)"};
  }

  &:hover .Polaris-Button .Polaris-Button__Content {
    background: ${({ status })=>status ? `var(--p-color-bg-${status}-subdued-hover)` : undefined};
  }
`;
exports.default = CollapsibleSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1wVTl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _companyDetails = require("../../constants/company-details");
var _riskHelpers = require("../../helpers/risk.helpers");
var _updates = require("../../helpers/updates");
var _useCountries = require("../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _useYesNo = require("../../hooks/useYesNo");
var _useYesNoDefault = parcelHelpers.interopDefault(_useYesNo);
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _addressInfo = require("../AddressInfo/AddressInfo");
var _addressInfoDefault = parcelHelpers.interopDefault(_addressInfo);
var _companyCustomerForm = require("../CompanyCustomerForm/CompanyCustomerForm");
var _companyInfoValue = require("../CompanyInfoValue/CompanyInfoValue");
var _companyInfoValueDefault = parcelHelpers.interopDefault(_companyInfoValue);
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _editCustomerDetailsButton = require("../EditCustomerDetailsButton/EditCustomerDetailsButton");
var _editCustomerDetailsButtonDefault = parcelHelpers.interopDefault(_editCustomerDetailsButton);
var _infoTable = require("../InfoTable/InfoTable");
var _infoTableDefault = parcelHelpers.interopDefault(_infoTable);
const formatIndustryCode = (industryCode, language)=>[
        industryCode.code,
        (language === "en" ? industryCode.description_en : industryCode.description_nb) || industryCode.description
    ].filter((e)=>!!e).join(" \u2014 ");
const CompanyInfoTable = (props)=>{
    const { companyDetails, infoUpdates, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const { getCountryRiskDescription, isHighRiskCountry } = (0, _useCountriesDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const yesNo = (0, _useYesNoDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const updates = (0, _react.useMemo)(()=>infoUpdates.reduce((fieldUpdates, currentInfoUpdate)=>{
            currentInfoUpdate.field_changes.forEach((infoUpdateFieldChange)=>{
                if (!fieldUpdates.has(infoUpdateFieldChange.field_name)) fieldUpdates.set(infoUpdateFieldChange.field_name, {
                    changes: [],
                    ids: []
                });
                if (infoUpdateFieldChange.new !== infoUpdateFieldChange.old) {
                    fieldUpdates.get(infoUpdateFieldChange.field_name).changes.push({
                        ...infoUpdateFieldChange,
                        timestamp: currentInfoUpdate.timestamp,
                        isReviewed: currentInfoUpdate.is_reviewed
                    });
                    fieldUpdates.get(infoUpdateFieldChange.field_name).ids.push(currentInfoUpdate.id);
                }
            });
            return fieldUpdates;
        }, new Map()), [
        infoUpdates
    ]);
    const hasUnreviewedUpdates = (...fieldNames)=>fieldNames.some((fieldName)=>(0, _updates.hasUnreviewedChanges)(updates.get(fieldName)?.changes));
    const industryCodesMap = {
        industry_code_1: companyDetails.industry_code_1,
        industry_code_2: companyDetails.industry_code_2,
        industry_code_3: companyDetails.industry_code_3
    };
    const hasIndustryCode = Object.values(industryCodesMap).some((industryCode)=>!(0, _util.isNil)(industryCode));
    const hasIndustryCodeChanges = Object.keys(industryCodesMap).some((fieldName)=>(0, _collectionUtils.hasContent)(updates.get(fieldName)?.changes));
    const shouldDisplayIndustryCode = hasIndustryCode || hasIndustryCodeChanges;
    const companyInfoRows = (0, _react.useMemo)(()=>{
        const createBooleanValueInfoRow = (fieldName, label)=>({
                label,
                isHighlight: hasUnreviewedUpdates(fieldName),
                isWarning: (0, _companyDetails.CRITICAL_COMPANY_DETAILS_FIELDS).includes(fieldName),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                    customerId: companyDetails.id,
                    infoUpdateIds: updates.get(fieldName)?.ids,
                    value: yesNo(companyDetails[fieldName]),
                    changes: updates.get(fieldName)?.changes,
                    hideHistory: true,
                    status: (0, _companyDetails.CRITICAL_COMPANY_DETAILS_FIELDS).includes(fieldName) ? "critical" : "info"
                })
            });
        const hasValueOrUpdate = (field)=>!(0, _util.isNil)(companyDetails[field]) || (0, _collectionUtils.hasContent)(updates.get(field)?.changes);
        /**
     * Checks if a company info field should be displayed or not
     * - If the field has a value or an update, it should be displayed
     * - If the company customer is manual, all fields that can be manually
     *    defined should be displayed even if they have no value
     * - Else, the field should not be displayed
     */ const shouldDisplayField = (fieldName)=>{
            if (hasValueOrUpdate(fieldName)) return true;
            if (companyDetails.is_manual) return (0, _companyCustomerForm.isFieldInCompanyCustomerForm)(fieldName);
            return false;
        };
        // Always display name, country and national ID
        const rows = [
            {
                label: f("company.details.caption.name"),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                    customerId: companyDetails.id,
                    infoUpdateIds: updates.get("name")?.ids,
                    value: companyDetails.name,
                    changes: updates.get("name")?.changes
                }),
                isHighlight: hasUnreviewedUpdates("name")
            },
            {
                label: f("company.details.caption.country"),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                    customerId: companyDetails.id,
                    value: companyDetails.country,
                    render: (value)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                            country: value
                        })
                }),
                isWarning: isHighRiskCountry(companyDetails.country),
                warningDescription: getCountryRiskDescription(companyDetails.country)
            },
            {
                label: f("company.details.caption.national_id"),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                    customerId: companyDetails.id,
                    value: companyDetails.national_id
                })
            }
        ];
        if (shouldDisplayField("company_type")) rows.push({
            label: f("company.details.caption.company.type"),
            isHighlight: hasUnreviewedUpdates("company_type"),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                customerId: companyDetails.id,
                infoUpdateIds: updates.get("company_type")?.ids,
                value: companyDetails?.company_type?.code ? companyDetails.company_type.code + (companyDetails.company_type?.description_nb && ` (${companyDetails.company_type.description_nb})`) : "-",
                changes: updates.get("company_type")?.changes
            })
        });
        if (shouldDisplayIndustryCode) rows.push({
            label: f("company.details.caption.industry-codes"),
            isHighlight: hasUnreviewedUpdates(...Object.keys(industryCodesMap)),
            isWarning: (0, _riskHelpers.getIndustryRiskCount)(companyDetails.risk_information) > 0,
            warningDescription: Object.values(companyDetails.risk_information?.industry_types || {}).map((industry)=>industry?.risk_description).filter((e)=>!!e).join("; "),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                gap: "4",
                children: Object.entries(industryCodesMap).map(([fieldName, industryCode])=>industryCode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                        customerId: companyDetails.id,
                        infoUpdateIds: updates.get(fieldName)?.ids,
                        value: formatIndustryCode(industryCode, language),
                        changes: updates.get(fieldName)?.changes
                    }, fieldName) : null)
            })
        });
        if (shouldDisplayField("founded_date")) rows.push({
            label: f("company.details.caption.est"),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                customerId: companyDetails.id,
                value: companyDetails.founded_date || "-"
            })
        });
        if (shouldDisplayField("number_of_employees")) rows.push({
            label: f("company.details.caption.employees"),
            isHighlight: hasUnreviewedUpdates("number_of_employees"),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                customerId: companyDetails.id,
                infoUpdateIds: updates.get("number_of_employees")?.ids,
                value: companyDetails.number_of_employees ? formatNumber(companyDetails.number_of_employees) : "-",
                changes: updates.get("number_of_employees")?.changes
            })
        });
        if (shouldDisplayField("business_address")) rows.push({
            label: f("company.details.caption.address.visit"),
            isHighlight: hasUnreviewedUpdates("business_address"),
            isWarning: isHighRiskCountry(companyDetails.business_address?.country),
            warningDescription: getCountryRiskDescription(companyDetails.business_address?.country),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                customerId: companyDetails.id,
                infoUpdateIds: updates.get("business_address")?.ids,
                value: companyDetails.business_address,
                changes: updates.get("business_address")?.changes,
                render: (value)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                        address: value
                    })
            })
        });
        if (shouldDisplayField("mailing_address")) rows.push({
            label: f("company.details.caption.address.postal"),
            isHighlight: hasUnreviewedUpdates("mailing_address"),
            isWarning: isHighRiskCountry(companyDetails.mailing_address?.country),
            warningDescription: getCountryRiskDescription(companyDetails.mailing_address?.country),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                customerId: companyDetails.id,
                infoUpdateIds: updates.get("mailing_address")?.ids,
                value: companyDetails.mailing_address,
                changes: updates.get("mailing_address")?.changes,
                render: (value)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                        address: value
                    })
            })
        });
        if (shouldDisplayField("office_address")) rows.push({
            label: f("common.labels.office-address").toUpperCase(),
            isHighlight: hasUnreviewedUpdates("office_address"),
            isWarning: isHighRiskCountry(companyDetails.office_address?.country),
            warningDescription: getCountryRiskDescription(companyDetails.office_address?.country),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                infoUpdateIds: updates.get("office_address")?.ids,
                customerId: companyDetails.id,
                value: companyDetails.office_address,
                changes: updates.get("office_address")?.changes,
                render: (value)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                        address: value
                    })
            })
        });
        if (shouldDisplayField("website")) {
            const website = (0, _stringUtils.parseWebsite)(companyDetails.website);
            rows.push({
                label: f("company.details.caption.website"),
                isHighlight: hasUnreviewedUpdates("website"),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                    customerId: companyDetails.id,
                    infoUpdateIds: updates.get("website")?.ids,
                    value: website,
                    changes: updates.get("website")?.changes,
                    render: (value)=>(0, _stringUtils.isEmptyString)(value) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: f("not.specified")
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: (0, _stringUtils.parseWebsite)(value),
                            target: "_blank",
                            rel: "noreferrer",
                            children: value.replace(/https?:\/\//, "")
                        })
                })
            });
        }
        if (shouldDisplayField("registered_in_vat_registry")) rows.push(createBooleanValueInfoRow("registered_in_vat_registry", f("company.details.caption.registered-in-vat")));
        if (shouldDisplayField("registered_in_foundation_registry")) rows.push(createBooleanValueInfoRow("registered_in_foundation_registry", f("company.details.caption.registered-in-foundation")));
        // The following fields should always be displayed if they have a truthy value,
        // as they could indicate a higher risk on the company customer
        if (companyDetails.is_bankrupt) rows.push(createBooleanValueInfoRow("is_bankrupt", f("company.details.caption.is_bankrupt")));
        if (companyDetails.under_liquidation) rows.push(createBooleanValueInfoRow("under_liquidation", f("company.details.caption.under_liquidation")));
        if (companyDetails.under_forced_liquidation_or_dissolution) rows.push(createBooleanValueInfoRow("under_forced_liquidation_or_dissolution", f("company.details.caption.under_forced_liquidation")));
        if (companyDetails.closure_date) rows.push({
            label: f("company.details.caption.closure_date"),
            isHighlight: hasUnreviewedUpdates("closure_date"),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                customerId: companyDetails.id,
                infoUpdateIds: updates.get("closure_date")?.ids,
                value: companyDetails.closure_date,
                changes: updates.get("closure_date")?.changes,
                hideHistory: true
            })
        });
        // Add external ID field first if feature is enabled and company has an external ID
        if (features.EXTERNAL_ID && companyDetails.external_id) rows.unshift({
            label: f("company.details.caption.external-id"),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueDefault.default), {
                customerId: companyDetails.id,
                value: companyDetails.external_id
            })
        });
        return rows;
    }, [
        companyDetails,
        updates,
        language
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                customer: companyDetails,
                readonly: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTableDefault.default), {
                rows: companyInfoRows,
                useCondensedLabels: true
            })
        ]
    });
};
const StyledButton = (0, _styledComponentsDefault.default)((0, _editCustomerDetailsButtonDefault.default))`
  margin: var(--p-space-4);
`;
exports.default = CompanyInfoTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/company-details":"2I1G6","../../helpers/risk.helpers":"1qPrk","../../helpers/updates":"fILPY","../../hooks/useCountries":"azDTp","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useLanguage":"2W6IE","../../hooks/useYesNo":"dfOzB","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","../AddressInfo/AddressInfo":"9YtjF","../CompanyCustomerForm/CompanyCustomerForm":"2nMmk","../CompanyInfoValue/CompanyInfoValue":"iI9pq","../Country/Country":"eeWSc","../EditCustomerDetailsButton/EditCustomerDetailsButton":"aUsoK","../InfoTable/InfoTable":"b83NY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2I1G6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CRITICAL_COMPANY_DETAILS_FIELDS", ()=>CRITICAL_COMPANY_DETAILS_FIELDS);
parcelHelpers.export(exports, "NORWEGIAN_COMPANY_NATIONAL_ID_REGEX", ()=>NORWEGIAN_COMPANY_NATIONAL_ID_REGEX);
const CRITICAL_COMPANY_DETAILS_FIELDS = [
    "is_bankrupt",
    "under_liquidation",
    "under_forced_liquidation_or_dissolution",
    "closure_date"
];
const NORWEGIAN_COMPANY_NATIONAL_ID_REGEX = /^(?=.*\d)[\d ]+$/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fILPY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasUnreviewedChanges", ()=>hasUnreviewedChanges);
var _util = require("../utils/util");
const isEmptyChange = (change)=>(0, _util.isEmpty)(change.old) && (0, _util.isEmpty)(change.new);
function hasUnreviewedChanges(changes) {
    if (!changes) return false;
    return changes.some((change)=>!change.isReviewed && !isEmptyChange(change));
}

},{"../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dfOzB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useYesNo = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return (value)=>value ? f("default.yes") : f("default.no");
};
exports.default = useYesNo;

},{"./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9YtjF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
const AddressInfo = (props)=>{
    const { address, shortCountryName } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!address) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: f("not.specified")
    });
    const addressLabel = [
        address.address_line_1,
        address.address_line_2,
        address.postal_code,
        address.city
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        wrap: false,
        children: [
            addressLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: addressLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: address.country,
                shortName: shortCountryName
            })
        ]
    });
};
exports.default = AddressInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../Country/Country":"eeWSc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2nMmk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFieldInCompanyCustomerForm", ()=>isFieldInCompanyCustomerForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _integrations = require("../../constants/integrations");
var _useErrorParser = require("../../hooks/useErrorParser");
var _useErrorParserDefault = parcelHelpers.interopDefault(_useErrorParser);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useProjectPermissions = require("../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
var _stringUtils = require("../../utils/stringUtils");
var _associatedProjectSection = require("../AssociatedProjectSection/AssociatedProjectSection");
var _associatedProjectSectionDefault = parcelHelpers.interopDefault(_associatedProjectSection);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _companyForm = require("./CompanyForm");
var _companyFormDefault = parcelHelpers.interopDefault(_companyForm);
const CompanyCustomerFormFields = {
    name: true,
    country: true,
    national_id: true,
    business_address: true,
    external_id: true,
    project_id: false,
    responsible_user_email: false
};
const isFieldInCompanyCustomerForm = (fieldName)=>{
    return fieldName in CompanyCustomerFormFields;
};
const CompanyCustomerForm = (props)=>{
    const { companyCustomer, onAfterSubmit, submitLabel, projectId, projectName, onCancel } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { isProjectsEnabled } = (0, _useProjectPermissionsDefault.default)();
    const parseError = (0, _useErrorParserDefault.default)("company");
    const [companyFormValues, setCompanyFormValues] = (0, _react.useState)();
    const [externalId, setExternalId] = (0, _react.useState)(companyCustomer?.external_id || "");
    // If companyCustomer was provided, we're updating an existing company customer
    // Else, we're creating a new company customer
    const saveCompanyCustomerMutation = (0, _reactQuery.useMutation)((payload)=>companyCustomer ? (0, _apiDefault.default).updateCompanyCustomer(companyCustomer.id, payload) : (0, _apiDefault.default).createCompanyCustomer({
            ...payload,
            project_id: projectId
        }), {
        onSuccess: (response)=>{
            onAfterSubmit(response);
        }
    });
    const { generalError, fieldsErrorsMap } = parseError(saveCompanyCustomerMutation.error);
    /**
   * Form/payload is valid if the name, national_id, country and business_address is set
   * Additionally, country must be a country we haven't integrated with
   */ const isValid = Boolean(companyFormValues?.name && companyFormValues?.nationalId && companyFormValues?.country && !(0, _stringUtils.isEmptyString)(companyFormValues?.address.country));
    /**
   * Create or update company customer, then call the onAfterSubmit-callback
   */ const handleSubmit = ()=>{
        if (!isValid || !companyFormValues) return;
        const payload = {
            name: companyFormValues.name,
            national_id: companyFormValues.nationalId,
            country: companyFormValues.country,
            business_address: companyFormValues.address,
            external_id: externalId
        };
        saveCompanyCustomerMutation.mutate(payload);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyFormDefault.default), {
                company: companyCustomer,
                excludedCountries: (0, _integrations.COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS),
                onChange: (v)=>setCompanyFormValues(v),
                disabled: saveCompanyCustomerMutation.isLoading,
                nationalIdError: fieldsErrorsMap.get("national_id")
            }),
            isProjectsEnabled && projectId && projectName && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _associatedProjectSectionDefault.default), {
                projectName: projectName
            }),
            features?.EXTERNAL_ID && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        value: externalId,
                        disabled: saveCompanyCustomerMutation.isLoading,
                        label: f("company-form.labels.external-id"),
                        placeholder: f("company-form.labels.external-id"),
                        onChange: (v)=>setExternalId(v),
                        maxLength: 50,
                        error: fieldsErrorsMap.get("external_id"),
                        autoComplete: "off"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        generalError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                            message: generalError
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "4",
                            align: "end",
                            children: [
                                onCancel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                    onClick: onCancel,
                                    disabled: saveCompanyCustomerMutation.isLoading,
                                    children: f("default.cancel")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                    primary: true,
                                    loading: saveCompanyCustomerMutation.isLoading,
                                    disabled: !isValid,
                                    onClick: handleSubmit,
                                    children: submitLabel || f("default.next")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = CompanyCustomerForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/integrations":"kD3Sk","../../hooks/useErrorParser":"daNOL","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useProjectPermissions":"23Tgs","../../utils/stringUtils":"4gVdA","../AssociatedProjectSection/AssociatedProjectSection":"jmfTp","../ErrorPanel/ErrorPanel":"2hHqH","./CompanyForm":"bfcJl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"23Tgs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
/**
 * Projects should be enabled/accessible for users/orgs with either
 * of the PROJECTS or VITEC_PROJECTS feature
 */ const isProjectsEnabled = (features)=>{
    return features.PROJECTS || features.VITEC_PROJECTS ? true : false;
};
/**
 * In order to _create_ a project, or add customers to a project,
 * the user/org. must have the PROJECTS feature
 */ const isCreateOrAddToProjectEnabled = (features)=>{
    return features.PROJECTS ? true : false;
};
const useProjectPermissions = ()=>{
    const features = (0, _useFeaturesDefault.default)();
    return {
        isProjectsEnabled: isProjectsEnabled(features),
        isCreateOrAddToProjectEnabled: isCreateOrAddToProjectEnabled(features)
    };
};
exports.default = useProjectPermissions;

},{"./useFeatures":"hvBWb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jmfTp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const AssociatedProjectSection = (props)=>{
    const { projectName } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
        title: f("onboarding.associated-project.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                disabled: true,
                value: projectName,
                label: f("onboarding.associated-project.title"),
                labelHidden: true,
                autoComplete: "off",
                maxLength: 50
            })
        })
    });
};
exports.default = AssociatedProjectSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bfcJl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _addressForm = require("../AddressForm/AddressForm");
var _addressFormDefault = parcelHelpers.interopDefault(_addressForm);
var _countrySelect = require("../CountrySelect/CountrySelect");
var _countrySelectDefault = parcelHelpers.interopDefault(_countrySelect);
/**
 * A company form section that should be part of another form
 * Renders company field inputs and calls the onChange-callback
 * whenever a field has been changed with all the field values of
 * the company form
 */ const CompanyForm = (props)=>{
    const { company, onChange, disabled = false, excludedCountries, nationalIdError } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [name, setName] = (0, _react.useState)(company?.name || "");
    const [nationalId, setNationalId] = (0, _react.useState)(company?.national_id || "");
    const [country, setCountry] = (0, _react.useState)(company?.country);
    const [address, setAddress] = (0, _react.useState)(company?.business_address || {});
    /**
   * Whenever any of the fields has changed, call the onChange-callback
   */ (0, _react.useEffect)(()=>{
        onChange({
            name: name,
            nationalId: nationalId,
            country: country,
            address: address
        });
    }, [
        name,
        nationalId,
        country,
        address
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "h1",
                            variant: "headingMd",
                            children: f("company-form.headings.details")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                            distribution: "fillEvenly",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                    autoFocus: true,
                                    value: name,
                                    label: f("company-form.labels.name"),
                                    placeholder: f("company-form.labels.name"),
                                    onChange: (v)=>setName(v),
                                    autoComplete: "off",
                                    requiredIndicator: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                    value: nationalId,
                                    label: f("company-form.labels.national-id"),
                                    placeholder: f("company-form.labels.national-id"),
                                    onChange: (v)=>setNationalId(v),
                                    error: nationalIdError,
                                    autoComplete: "off",
                                    requiredIndicator: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countrySelectDefault.default), {
                                    value: country,
                                    disabled: disabled,
                                    label: f("company-form.labels.country"),
                                    excludedCountries: excludedCountries,
                                    onSelect: (country)=>setCountry(country),
                                    requiredIndicator: true
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingMd",
                            as: "h2",
                            children: f("common.labels.business-address")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressFormDefault.default), {
                            value: address,
                            onChange: (v)=>setAddress(v),
                            disabled: disabled,
                            requiredFields: [
                                "country"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = CompanyForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../AddressForm/AddressForm":"1P2a8","../CountrySelect/CountrySelect":"dlvog","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iI9pq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _updates = require("../../helpers/updates");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _collectionUtils = require("../../utils/collectionUtils");
var _util = require("../../utils/util");
var _companyInfoValueTooltip = require("../CompanyInfoValueTooltip/CompanyInfoValueTooltip");
var _companyInfoValueTooltipDefault = parcelHelpers.interopDefault(_companyInfoValueTooltip);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
// If a value has more than 3 of changes, render the first 3 changes and the rest inside a collapsible panel
const UPDATES_CUTOFF = 3;
const defaultRenderer = (value)=>typeof value === "string" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        variant: "bodyMd",
        as: "span",
        children: value
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: value
    });
const ExpiredValue = (props)=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "baseline",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "bodyMd",
                as: "span",
                color: "subdued",
                children: props.render(props.change.old || "-")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                children: [
                    "(",
                    f("default.expired"),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                        date: props.change.timestamp
                    }),
                    ")"
                ]
            })
        ]
    });
};
const CompanyInfoValue = (props)=>{
    const { customerId, infoUpdateIds, value, changes = [], hideHistory, status = "info", render = defaultRenderer } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showTooltip, toggleTooltip, closeTooltip] = (0, _useOpenCloseDefault.default)();
    const [showMoreChanges, toggleShowMoreChanges] = (0, _useOpenCloseDefault.default)();
    if (!(0, _collectionUtils.hasContent)(changes)) return render(value);
    const lastUpdatedDate = (0, _collectionUtils.first)(changes)?.timestamp;
    const showNewInfoBadge = customerId !== undefined && infoUpdateIds !== undefined && (0, _updates.hasUnreviewedChanges)(changes);
    const displayChange = changes.filter((change)=>!(0, _util.isEmpty)(change.old));
    const collapsibleLabel = showMoreChanges ? f("common.labels.show-less") : f("common.labels.show-more-with-count", {
        count: displayChange.length - UPDATES_CUTOFF
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                blockAlign: "center",
                children: [
                    render(value),
                    showNewInfoBadge && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover), {
                        preferredPosition: "above",
                        active: showTooltip,
                        onClose: toggleTooltip,
                        activator: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledNewInfoBadge, {
                            onClick: toggleTooltip,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                                size: "small",
                                status: status,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                    variant: "bodySm",
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: [
                                        f("default.new"),
                                        " (",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                            date: lastUpdatedDate
                                        }),
                                        ")"
                                    ]
                                })
                            })
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyInfoValueTooltipDefault.default), {
                            customerId: customerId,
                            infoUpdateIds: infoUpdateIds,
                            onClose: closeTooltip
                        })
                    })
                ]
            }),
            !hideHistory && displayChange.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    displayChange.slice(0, UPDATES_CUTOFF).map((change, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpiredValue, {
                            change: change,
                            render: render
                        }, index)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                        id: "",
                        open: showMoreChanges,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: displayChange.slice(UPDATES_CUTOFF).map((change, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpiredValue, {
                                    change: change,
                                    render: render
                                }, index))
                        })
                    }),
                    displayChange.length > UPDATES_CUTOFF && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            plain: true,
                            onClick: toggleShowMoreChanges,
                            children: collapsibleLabel
                        })
                    })
                ]
            })
        ]
    });
};
const StyledNewInfoBadge = (0, _styledComponentsDefault.default).div`
  cursor: pointer;
  & .Polaris-Badge {
    padding: 0 0.5rem;
    border-color: transparent;
  }

  &:hover .Polaris-Badge {
    filter: brightness(85%);
  }

  &:active .Polaris-Badge {
    filter: brightness(75%);
  }
`;
exports.default = CompanyInfoValue;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/updates":"fILPY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../utils/collectionUtils":"gr5mc","../../utils/util":"4MniK","../CompanyInfoValueTooltip/CompanyInfoValueTooltip":"ell4y","../CondensedText/CondensedText":"1FshD","../CustomDate/CustomDate":"5KD00","../extensions/Badge":"9irVp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ell4y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _chevronRightSvg = require("../../../assets/icons/chevron-right.svg");
var _chevronRightSvgDefault = parcelHelpers.interopDefault(_chevronRightSvg);
var _pageAnchors = require("../../constants/page-anchors");
var _useAcknowledgeCompanyInfoChangeMutation = require("../../hooks/useAcknowledgeCompanyInfoChangeMutation");
var _useAcknowledgeCompanyInfoChangeMutationDefault = parcelHelpers.interopDefault(_useAcknowledgeCompanyInfoChangeMutation);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePageNavigation = require("../../hooks/usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const CompanyInfoValueTooltip = (props)=>{
    const { customerId, infoUpdateIds, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { navigateInPage } = (0, _usePageNavigationDefault.default)();
    const acknowledgeCompanyInfoChangeMutation = (0, _useAcknowledgeCompanyInfoChangeMutationDefault.default)(customerId, infoUpdateIds);
    const scrollToReviews = ()=>navigateInPage((0, _pageAnchors.PAGE_ANCHORS).REVIEWS_SECTION);
    const acknowledgeChange = ()=>acknowledgeCompanyInfoChangeMutation.mutate(undefined, {
            onSuccess: onClose
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        children: f("company.details.changes.tooltip.banner")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        align: "space-between",
                        blockAlign: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        plain: true,
                                        onClick: scrollToReviews,
                                        disabled: acknowledgeCompanyInfoChangeMutation.isLoading,
                                        children: f("company.details.changes.tooltip.button.label")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _chevronRightSvgDefault.default),
                                        width: "8px",
                                        height: "14px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                outline: true,
                                size: "slim",
                                onClick: acknowledgeChange,
                                loading: acknowledgeCompanyInfoChangeMutation.isLoading,
                                children: f("common.labels.change-seen")
                            })
                        ]
                    }),
                    acknowledgeCompanyInfoChangeMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: acknowledgeCompanyInfoChangeMutation.error
                    })
                ]
            })
        })
    });
};
exports.default = CompanyInfoValueTooltip;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/chevron-right.svg":"eUCtc","../../constants/page-anchors":"4WmvA","../../hooks/useAcknowledgeCompanyInfoChangeMutation":"grI4w","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePageNavigation":"1o5Hm","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eUCtc":[function(require,module,exports) {
module.exports = require("3b1c5006d99473ba").getBundleURL("kEMsi") + "chevron-right.a0a23595.svg";

},{"3b1c5006d99473ba":"75UoR"}],"grI4w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useQueryData = require("./useQueryData");
const useAcknowledgeCompanyInfoChangeMutation = (customerId, infoUpdateIds)=>{
    const updateCustomerDetails = (0, _useQueryData.useCustomerDetailsQueryData)({
        id: customerId,
        type: "company"
    });
    // do not try to acknowledge the same infoUpdateId more than once
    const uniqueInfoUpdateIds = [
        ...new Set(infoUpdateIds).values()
    ];
    return (0, _reactQuery.useMutation)(()=>Promise.all(uniqueInfoUpdateIds.map((infoUpdateId)=>(0, _apiDefault.default).quickReviewCompanyInfoUpdate(customerId, infoUpdateId))), {
        onSuccess: ()=>{
            updateCustomerDetails((prevData)=>prevData.info_updates = prevData.info_updates.filter((infoUpdate)=>!uniqueInfoUpdateIds.includes(infoUpdate.id)));
        }
    });
};
exports.default = useAcknowledgeCompanyInfoChangeMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aUsoK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pencilSvg = require("../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _utilities = require("../../types/utilities");
var _editCompanyCustomerInfoModal = require("../EditCompanyCustomerInfoModal/EditCompanyCustomerInfoModal");
var _editCompanyCustomerInfoModalDefault = parcelHelpers.interopDefault(_editCompanyCustomerInfoModal);
var _editPersonCustomerDetailsModal = require("../EditPersonCustomerDetailsModal/EditPersonCustomerDetailsModal");
var _editPersonCustomerDetailsModalDefault = parcelHelpers.interopDefault(_editPersonCustomerDetailsModal);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const EditCustomerDetailsButton = (props)=>{
    const { customer, readonly, ...buttonProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showEditModal, toggleEditModal, closeEditModal] = (0, _useOpenCloseDefault.default)();
    const buttonLabel = customer.type === "person" ? f("common.buttons.actions.edit-person-info") : f("common.buttons.actions.edit-company-info");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            customer.is_manual && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                icon: (0, _pencilSvgDefault.default),
                onClick: toggleEditModal,
                disabled: readonly,
                size: "slim",
                fullWidth: false,
                ...buttonProps,
                children: buttonLabel
            }),
            showEditModal && !(0, _utilities.isPersonCustomerDetails)(customer) && customer.is_manual && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editCompanyCustomerInfoModalDefault.default), {
                companyCustomer: customer,
                onClose: closeEditModal
            }),
            showEditModal && (0, _utilities.isPersonCustomerDetails)(customer) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editPersonCustomerDetailsModalDefault.default), {
                person: customer,
                onClose: closeEditModal
            })
        ]
    });
};
exports.default = EditCustomerDetailsButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../assets/icons/pencil.svg":"gEWpJ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../types/utilities":"6zLpB","../EditCompanyCustomerInfoModal/EditCompanyCustomerInfoModal":"3O9ld","../EditPersonCustomerDetailsModal/EditPersonCustomerDetailsModal":"fWBcX","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gEWpJ":[function(require,module,exports) {
module.exports = require("6d374b2846370e88").getBundleURL("kEMsi") + "pencil.8571f611.svg";

},{"6d374b2846370e88":"75UoR"}],"3O9ld":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../types/utilities");
var _companyCustomerForm = require("../CompanyCustomerForm/CompanyCustomerForm");
var _companyCustomerFormDefault = parcelHelpers.interopDefault(_companyCustomerForm);
const EditCompanyCustomerInfoModal = (props)=>{
    const { companyCustomer, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getQueryData, setQueryData } = (0, _useQueryDataDefault.default)((0, _utilities.getCustomerQueryKey)(companyCustomer));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        onClose: onClose,
        title: f("modals.company.edit.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyCustomerFormDefault.default), {
            companyCustomer: companyCustomer,
            submitLabel: f("default.save"),
            onCancel: onClose,
            onAfterSubmit: (updatedCompanyDetails)=>{
                // Update query data on QUERIES_KEYS.COMPANY_DETAILS query
                const currentCompanyDetailsData = getQueryData();
                if (currentCompanyDetailsData) setQueryData({
                    ...currentCompanyDetailsData,
                    ...updatedCompanyDetails,
                    // NOTE: `api.CompanyCustomer.address` is the same as `business_address`
                    // This will/should be fixed/improved in beaufort-api, but
                    // do this as a quick-fix for now
                    business_address: updatedCompanyDetails.address
                });
                // Close modal
                onClose();
            }
        })
    });
};
exports.default = EditCompanyCustomerInfoModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../types/utilities":"6zLpB","../CompanyCustomerForm/CompanyCustomerForm":"2nMmk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fWBcX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useDefaultCountry = require("../../hooks/useDefaultCountry");
var _useDefaultCountryDefault = parcelHelpers.interopDefault(_useDefaultCountry);
var _useErrorParser = require("../../hooks/useErrorParser");
var _useErrorParserDefault = parcelHelpers.interopDefault(_useErrorParser);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _stringUtils = require("../../utils/stringUtils");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _personForm = require("../PersonForm/PersonForm");
var _personFormDefault = parcelHelpers.interopDefault(_personForm);
const EditPersonCustomerDetailsModal = (props)=>{
    const { person: originalPerson, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { getQueryData, setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PERSON_DETAILS,
        originalPerson.id
    ]);
    const defaultCountry = (0, _useDefaultCountryDefault.default)();
    const parseError = (0, _useErrorParserDefault.default)("person");
    const [person, setPerson, changed] = (0, _useChangedStateDefault.default)({
        ...originalPerson
    });
    const [isFormValid, setIsFormValid] = (0, _react.useState)(true);
    const updatePersonMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updatePerson(person.id, {
            first_name: person.first_name,
            last_name: person.last_name,
            birth_date: person.birth_date || "",
            country_of_origin: person.country_of_origin,
            country_of_citizenship: person.country_of_citizenship || defaultCountry,
            country_of_residence: person.country_of_residence || defaultCountry,
            address: person.address,
            phone: person.phone,
            email: person.email,
            national_id_country: person.national_id_country,
            national_id: person.national_id,
            external_id: person.external_id
        }), {
        onSuccess: (updatedPerson)=>{
            const personData = getQueryData();
            if (personData) {
                const updatedPersonData = {
                    ...personData,
                    ...updatedPerson
                };
                setQueryData(updatedPersonData);
            }
            onClose();
        }
    });
    const handleChange = (key, value)=>setPerson((prevPerson)=>({
                ...prevPerson,
                [key]: value
            }));
    const saveAction = {
        content: f("default.save"),
        onAction: ()=>updatePersonMutation.mutate(),
        loading: updatePersonMutation.isLoading,
        disabled: !changed || updatePersonMutation.isLoading || !isFormValid || (0, _stringUtils.isEmptyString)(person.address?.country)
    };
    const cancelAction = {
        content: f("default.cancel"),
        onAction: onClose,
        disabled: updatePersonMutation.isLoading
    };
    const { generalError, fieldsErrorsMap } = parseError(updatePersonMutation.error);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
        open: true,
        large: true,
        onClose: onClose,
        title: f("modals.person.edit.title"),
        primaryAction: saveAction,
        secondaryActions: [
            cancelAction
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personFormDefault.default), {
                    value: person,
                    isCreating: false,
                    birthDateIsRequired: true,
                    disabled: updatePersonMutation.isLoading,
                    onChange: setPerson,
                    onValidityChange: setIsFormValid,
                    fieldsErrorMap: fieldsErrorsMap,
                    children: features?.EXTERNAL_ID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                        distribution: "fillEvenly",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                value: person.external_id || "",
                                onChange: (newValue)=>handleChange("external_id", newValue),
                                placeholder: f("company-form.labels.external-id"),
                                label: f("company-form.labels.external-id"),
                                disabled: updatePersonMutation.isLoading,
                                maxLength: 50,
                                error: fieldsErrorsMap.get("external_id"),
                                autoComplete: "off"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {})
                        ]
                    })
                })
            }),
            generalError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: generalError
                })
            })
        ]
    });
};
exports.default = EditPersonCustomerDetailsModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../hooks/useChangedState":"170jW","../../hooks/useDefaultCountry":"9Xjpj","../../hooks/useErrorParser":"daNOL","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../utils/stringUtils":"4gVdA","../ErrorPanel/ErrorPanel":"2hHqH","../PersonForm/PersonForm":"8xv61","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"170jW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Same as useState, but with an additional changed value that indicates if the current state value
 * differs from the initial value
 *
 * @param initialState
 */ function useChangedState(initialState) {
    // @ts-ignore
    const initialStateJSONStr = JSON.stringify(typeof initialState === "function" ? initialState() : initialState);
    const [value, setValue] = (0, _react.useState)(initialState);
    const changed = (0, _react.useMemo)(()=>JSON.stringify(value) !== initialStateJSONStr, [
        value
    ]);
    return [
        value,
        setValue,
        changed
    ];
}
exports.default = useChangedState;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9Xjpj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _countries = require("../constants/countries");
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
const useDefaultCountry = ()=>{
    const { user } = (0, _useAuthDefault.default)();
    return user?.organization.country || (0, _countries.DEFAULT_COUNTRY);
};
exports.default = useDefaultCountry;

},{"../constants/countries":"2hBLK","./useAuth":"k9r0q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b83NY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _tables = require("../../constants/tables");
var _dataTableCellChild = require("../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _infoRow = require("../InfoRow/InfoRow");
var _infoRowDefault = parcelHelpers.interopDefault(_infoRow);
const InfoTable = (props)=>{
    const { rows, loading, error, useCondensedLabels, showActionsColumn, vertical, ...dataTableProps } = props;
    const createRow = (infoRow)=>{
        if (!infoRow) return [];
        const { value, isHeading, label, suffix } = infoRow;
        const labelOrHeadingElement = isHeading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            variant: "headingSm",
            as: "h3",
            children: label
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoRowDefault.default), {
            ...infoRow,
            useCondensedLabels: useCondensedLabels
        });
        const valueElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledValueContainer, {
            children: value
        });
        const row = vertical ? [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                align: "start",
                gap: "4",
                children: [
                    labelOrHeadingElement,
                    value && valueElement,
                    suffix
                ]
            })
        ] : [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                width: (0, _tables.MAIN_COLUMN_WIDTH),
                children: labelOrHeadingElement
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                align: "start",
                children: [
                    valueElement,
                    suffix
                ]
            })
        ];
        return row;
    };
    const displayRows = loading || error ? loading ? [
        [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            })
        ]
    ] : [
        [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: error
            })
        ]
    ] : rows.filter(Boolean).map((infoRow)=>createRow(infoRow));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDataTableWrapper, {
        fixed: !showActionsColumn,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
            columnContentTypes: vertical ? [
                "text"
            ] : [
                "text",
                "text"
            ],
            headings: [],
            rows: displayRows,
            stickyHeader: true,
            ...dataTableProps
        })
    });
};
const StyledValueContainer = (0, _styledComponentsDefault.default).div`
  white-space: normal;
`;
const StyledDataTableWrapper = (0, _styledComponentsDefault.default).div`
  & .Polaris-DataTable__Table {
    table-layout: ${({ fixed })=>fixed ? "fixed" : undefined};
  }
`;
exports.default = InfoTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/tables":"01ORG","../DataTableCellChild/DataTableCellChild":"boueG","../ErrorPanel/ErrorPanel":"2hHqH","../InfoRow/InfoRow":"4fiWD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"boueG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// Since @shopify/Polaris data tables don't allow setting or changing the colspan property
// of a table cell, use this class to modify the cell directly
// It's a hack that can be removed once we use a different component to render tables
const DataTableCellChild = (props)=>{
    const { children, className, onClick, ...tableCellProps } = props;
    const cellRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (cellRef.current) {
            const tableCell = cellRef.current.parentElement;
            if (tableCell) // @ts-ignore
            Object.keys(tableCellProps).forEach((name)=>tableCell?.setAttribute(name, String(tableCellProps[name])));
            return ()=>{
                for(const name in tableCellProps)tableCell?.setAttribute(name, "");
            };
        }
    }, [
        cellRef.current,
        props
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: cellRef,
        className: className,
        onClick: onClick,
        children: children
    });
};
exports.default = DataTableCellChild;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4fiWD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _triangleFilledExclamationSvg = require("../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _rowHighlighter = require("../extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const InfoRow = (props)=>{
    const { label, isWarning, warningDescription, isHighlight, useCondensedLabels, prefix, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
        warning: isWarning,
        highlight: isHighlight,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "2",
            blockAlign: "center",
            wrap: false,
            children: [
                isWarning && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                    content: warningDescription,
                    preferredPosition: "above",
                    dismissOnMouseOut: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _triangleFilledExclamationSvgDefault.default)
                    })
                }),
                prefix,
                label && useCondensedLabels && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                    children: label
                }),
                label && !useCondensedLabels && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    color: "subdued",
                    children: label
                }),
                children
            ]
        })
    });
};
exports.default = InfoRow;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","../extensions/RowHighlighter":"9EbPr","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2Jdh4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _tables = require("../../constants/tables");
var _displayHelpers = require("../../helpers/display.helpers");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dataTableCellChild = require("../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _useCompanyScreeningSection = require("./useCompanyScreeningSection");
var _useCompanyScreeningSectionDefault = parcelHelpers.interopDefault(_useCompanyScreeningSection);
const CompanyScreeningSection = (props)=>{
    const { customer } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const hasFinishedOnboarding = (0, _onboardingHelpers.isOnboardingFinished)(customer);
    const { entitiesToDisplay } = (0, _useCompanyScreeningSectionDefault.default)(customer);
    const rows = [
        // show company name first
        [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                width: (0, _tables.MAIN_COLUMN_WIDTH),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                    strong: true,
                    type: "company",
                    name: customer.name,
                    children: customer.national_id && f("display-name.suffixes.labels.org-id", {
                        orgId: customer.national_id
                    })
                })
            }),
            f("screening.titles.customer")
        ],
        // show roles and owners
        ...entitiesToDisplay.map((entity)=>[
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                    width: (0, _tables.MAIN_COLUMN_WIDTH),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                        type: entity.person ? "person" : "company",
                        name: (0, _displayHelpers.getFullName)(entity.person),
                        birthDate: (0, _displayHelpers.getBirthDate)(entity.person),
                        comment: entity.comment
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: entity.types.join(", ")
                })
            ])
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            hasFinishedOnboarding && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                columnContentTypes: [
                    "text",
                    "text"
                ],
                headings: [
                    f("table.column.name"),
                    f("table.column.title")
                ],
                rows: rows
            }),
            !hasFinishedOnboarding && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: f("company.details.onboarding.no-screening-performed")
            })
        ]
    });
};
exports.default = CompanyScreeningSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/tables":"01ORG","../../helpers/display.helpers":"2q3xY","../../helpers/onboarding.helpers":"fMYah","../../hooks/useFormatMessage":"8Y8fq","../DataTableCellChild/DataTableCellChild":"boueG","../DisplayName/DisplayName":"gKd5g","./useCompanyScreeningSection":"lUkR3","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fMYah":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOnboardingFinished", ()=>isOnboardingFinished);
parcelHelpers.export(exports, "stripOrgId", ()=>stripOrgId);
parcelHelpers.export(exports, "isCompanyOnboardingDisabled", ()=>isCompanyOnboardingDisabled);
parcelHelpers.export(exports, "convertSignatureToCompanyRoleSignatureConfiguration", ()=>convertSignatureToCompanyRoleSignatureConfiguration);
var _collectionUtils = require("../utils/collectionUtils");
var _stringUtils = require("../utils/stringUtils");
const isOnboardingFinished = (customer)=>customer.onboarding_status === "DONE";
const stripOrgId = (id)=>parseInt(id ? id.replace(/\W/g, "") : id, 10);
const isCompanyOnboardingDisabled = ({ is_bankrupt, closure_date, under_forced_liquidation_or_dissolution })=>under_forced_liquidation_or_dissolution || is_bankrupt || !(0, _stringUtils.isEmptyString)(closure_date);
const convertSignatureToCompanyRoleSignatureConfiguration = (signature)=>({
        id: signature.role_id,
        email: signature.email,
        send_email: signature.send_email,
        use_standard_disclosure: signature.use_standard_disclosure,
        use_pep_disclosure: signature.use_pep_disclosure,
        use_verification: signature.use_verification,
        questionnaire_ids: (0, _collectionUtils.hasContent)(signature.questionnaire_ids) ? signature.questionnaire_ids : undefined,
        language: signature.language,
        assignment_id: signature.assignment_id
    });

},{"../utils/collectionUtils":"gr5mc","../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lUkR3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRole", ()=>isRole);
var _react = require("react");
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _personHelpers = require("../../helpers/person.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../utils/collectionUtils");
const isRole = (ownerOrRole)=>ownerOrRole.type !== undefined;
const useCompanyScreeningSection = (customer)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const screeningRoles = (customer.screening?.roles || []).map((role)=>role.role);
    const screeningOwners = (customer.screening?.beneficial_owners || []).map((beneficialOwner)=>beneficialOwner.owner);
    // TODO compare roles/owners persons by person id once the backend starts deduplicating them
    // const getEntityKey = (entity: api.Role | api.Owner) => entity.person!.id;
    const entitiesToDisplay = (0, _react.useMemo)(()=>{
        const screening = [
            ...screeningRoles,
            ...screeningOwners
        ].filter((entity)=>entity.person?.id !== undefined);
        const entitiesMap = (0, _collectionUtils.groupBy)(screening, (0, _personHelpers.getRoleOrOwnerKey));
        const entitiesToDisplay = [
            ...entitiesMap.values()
        ].map((entities)=>({
                ...Object.assign({}, ...entities),
                types: entities.map((entity)=>isRole(entity) ? f((0, _roleTypesDefault.default)[entity.type]) : f("table.row.owner"))
            }));
        return entitiesToDisplay;
    }, [
        screeningRoles,
        screeningOwners
    ]);
    return {
        entitiesToDisplay
    };
};
exports.default = useCompanyScreeningSection;

},{"react":"cOWTg","../../constants/role-types":"fAycz","../../helpers/person.helpers":"6qOIE","../../hooks/useFormatMessage":"8Y8fq","../../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"imh2d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _companyDetails = require("../../../constants/company-details");
// returns true if there are critical, unreviewed updates to critical company details fields
const useCompanyHasCriticalUpdates = (companyDetails)=>Boolean(companyDetails?.info_updates && // find at least one info update
    companyDetails.info_updates.some((infoUpdate)=>{
        return !infoUpdate.is_reviewed && // that contains updates to critical fields that were false and now are true
        infoUpdate.field_changes.find((fieldChange)=>{
            const fieldName = fieldChange.field_name;
            return fieldChange.new && !fieldChange.old && (0, _companyDetails.CRITICAL_COMPANY_DETAILS_FIELDS).includes(fieldName);
        });
    }));
exports.default = useCompanyHasCriticalUpdates;

},{"../../../constants/company-details":"2I1G6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ah8Q4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../helpers/display.helpers");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _pendingTasksHelpers = require("../../helpers/pending-tasks.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _archivedBadge = require("../ArchivedBadge/ArchivedBadge");
var _archivedBadgeDefault = parcelHelpers.interopDefault(_archivedBadge);
var _backButton = require("../BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _displayTagsWrapper = require("../DisplayTagsWrapper/DisplayTagsWrapper");
var _displayTagsWrapperDefault = parcelHelpers.interopDefault(_displayTagsWrapper);
var _pendingTasksBanner = require("../PendingTasksBanner/PendingTasksBanner");
var _pendingTasksBannerDefault = parcelHelpers.interopDefault(_pendingTasksBanner);
var _basicCustomerInfo = require("./BasicCustomerInfo/BasicCustomerInfo");
var _basicCustomerInfoDefault = parcelHelpers.interopDefault(_basicCustomerInfo);
var _customerActionsMenu = require("./CustomerActionsMenu/CustomerActionsMenu");
var _customerActionsMenuDefault = parcelHelpers.interopDefault(_customerActionsMenu);
var _customerDetailsBanners = require("./CustomerDetailsBanner/CustomerDetailsBanners");
var _customerDetailsBannersDefault = parcelHelpers.interopDefault(_customerDetailsBanners);
var _useCustomerDetailsBanners = require("./CustomerDetailsBanner/useCustomerDetailsBanners");
var _useCustomerDetailsBannersDefault = parcelHelpers.interopDefault(_useCustomerDetailsBanners);
var _customerTagPopover = require("./CustomerTagPopover");
var _customerTagPopoverDefault = parcelHelpers.interopDefault(_customerTagPopover);
var _useCustomerBackButton = require("./useCustomerBackButton");
var _useCustomerBackButtonDefault = parcelHelpers.interopDefault(_useCustomerBackButton);
const CustomerDetailsHeader = (props)=>{
    const { customer } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const { backButtonDisplayLabel, backButtonURL } = (0, _useCustomerBackButtonDefault.default)();
    // since Polaris Stack renders gap even for empty components, we need to decide if there are any banners
    // to show and only then render CustomerDetailsBanners
    const { showBanners } = (0, _useCustomerDetailsBannersDefault.default)(customer);
    const hasFinishedOnboarding = (0, _onboardingHelpers.isOnboardingFinished)(customer);
    const readonly = customer.is_archived || !hasFinishedOnboarding;
    const isMonitoring = customer.screening_status.screening_status === "MONITORING" && customer.screening_status.screening_stopped !== undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                    showAsLink: true,
                    displayLabel: backButtonDisplayLabel,
                    url: backButtonURL
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                        alignment: "center",
                        spacing: "tight",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "heading2xl",
                                as: "p",
                                children: (0, _displayHelpers.getCustomerName)(customer)
                            }),
                            customer.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archivedBadgeDefault.default), {
                                customer: customer
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayTagsWrapperDefault.default), {
                                tags: customer.labels
                            }),
                            !readonly && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerTagPopoverDefault.default), {
                                customer: customer
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                fill: true
                            }),
                            hasFinishedOnboarding && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerActionsMenuDefault.default), {
                                customer: customer,
                                isMonitoring: isMonitoring
                            })
                        ]
                    }),
                    customer.is_archived && customer.archived_by && customer.archiving_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        italic: true,
                        children: f("customer.details.archived-date", {
                            name: getUserDisplayName(customer.archived_by),
                            timestamp: new Date(customer.archiving_dt)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _basicCustomerInfoDefault.default), {
                        customer: customer,
                        screening: customer.screening_status,
                        readonly: readonly
                    }),
                    (0, _pendingTasksHelpers.hasPendingTasks)(customer) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendingTasksBannerDefault.default), {
                        customer: customer
                    })
                ]
            }),
            showBanners && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerDetailsBannersDefault.default), {
                customer: customer
            })
        ]
    });
};
exports.default = CustomerDetailsHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/display.helpers":"2q3xY","../../helpers/onboarding.helpers":"fMYah","../../helpers/pending-tasks.helpers":"dLOfL","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../ArchivedBadge/ArchivedBadge":"8eATJ","../BackButton/BackButton":"4fa4k","../CondensedText/CondensedText":"1FshD","../DisplayTagsWrapper/DisplayTagsWrapper":"2idSA","../PendingTasksBanner/PendingTasksBanner":"5xyTg","./BasicCustomerInfo/BasicCustomerInfo":"jy64a","./CustomerActionsMenu/CustomerActionsMenu":"aEgFg","./CustomerDetailsBanner/CustomerDetailsBanners":"c5E3z","./CustomerDetailsBanner/useCustomerDetailsBanners":"5Qpgd","./CustomerTagPopover":"3P2R2","./useCustomerBackButton":"4St21","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dLOfL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasPendingTasks", ()=>hasPendingTasks);
parcelHelpers.export(exports, "hasActionablePendingTasks", ()=>hasActionablePendingTasks);
const hasPendingTasks = (customer)=>!customer.is_archived && (customer.pending_tasks || []).length > 0;
const isActionableTask = (pendingTask)=>{
    switch(pendingTask.type){
        case "APPROVE_CUSTOMER_REVIEW":
            return pendingTask.is_possible_to_approve;
        default:
            return true;
    }
};
const hasActionablePendingTasks = (customer)=>!customer.is_archived && (customer.pending_tasks || []).filter(isActionableTask).length > 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8eATJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _badges = require("../Badges/Badges");
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const ArchivedBadge = (props)=>{
    const { customer } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const tooltipContent = customer?.archived_by && customer?.archiving_dt ? f("customer.details.archived-date", {
        name: getUserDisplayName(customer.archived_by),
        timestamp: new Date(customer.archiving_dt)
    }) : null;
    if (tooltipContent) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
        content: tooltipContent,
        dismissOnMouseOut: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
            ...(0, _badges.DISPLAY_BADGE_PROPS),
            status: undefined,
            children: f("badge.archived")
        })
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
        ...(0, _badges.DISPLAY_BADGE_PROPS),
        status: undefined,
        children: f("badge.archived")
    });
};
exports.default = ArchivedBadge;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../Badges/Badges":"cI72s","../extensions/Badge":"9irVp","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2idSA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _kdktag = require("../KDKTag/KDKTag");
var _kdktagDefault = parcelHelpers.interopDefault(_kdktag);
const DisplayTagsWrapper = (props)=>{
    const { tags, readonly, onRemove, children } = props;
    const language = (0, _useLanguageDefault.default)();
    if (!tags || tags.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        spacing: "extraTight",
        alignment: "leading",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLabelsContainer, {
                children: tags.map((tag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktagDefault.default), {
                        tag: tag,
                        language: language,
                        onRemove: onRemove && !readonly ? ()=>onRemove(tag) : undefined
                    }, tag.id))
            })
        ]
    });
};
const StyledLabelsContainer = (0, _styledComponentsDefault.default).div`
  display: flex;
  gap: var(--p-space-1);

  // shrink all tags evenly but show at least 4 characters of each tag (if possible)
  & > * {
    transition: flex-shrink var(--p-ease-in-out) var(--p-duration-150);
    min-width: 4ch;
    flex-shrink: 1;
  }

  // expand the hovered tag to show all of its content
  & > *:hover {
    flex-shrink: 0;
  }
`;
exports.default = DisplayTagsWrapper;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useLanguage":"2W6IE","../KDKTag/KDKTag":"8koxk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8koxk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _tagHelpers = require("../../helpers/tag.helpers");
var _stringUtils = require("../../utils/stringUtils");
var _tag = require("../Tag/Tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
const KDKTag = (props)=>{
    const { tag, highlightText, language, ...tagProps } = props;
    const { color } = tag;
    const tagTitle = (0, _tagHelpers.getTagTitle)(tag, language);
    const showTextHighlights = !(0, _stringUtils.isEmptyString)(highlightText);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagDefault.default), {
        color: color,
        ...tagProps,
        children: [
            !showTextHighlights && tagTitle,
            showTextHighlights && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                searchWords: [
                    highlightText
                ],
                textToHighlight: tagTitle
            })
        ]
    });
};
exports.default = /*#__PURE__*/ (0, _react.memo)(KDKTag);

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../helpers/tag.helpers":"ecpII","../../utils/stringUtils":"4gVdA","../Tag/Tag":"4KuO7","../TextHighlighter/TextHighlighter":"43Xhz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ecpII":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTagTitle", ()=>getTagTitle);
var _languages = require("../constants/languages");
var _languageUtils = require("../utils/languageUtils");
const language = (0, _languageUtils.getLanguage)();
const getTagTitle = (tag, forceLanguage)=>tag.title[forceLanguage || language] || tag.title[0, _languages.DEFAULT_LANGUAGE];

},{"../constants/languages":"ecnY7","../utils/languageUtils":"a4UFz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a4UFz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLanguage", ()=>getLanguage);
var _languages = require("../constants/languages");
const getLanguage = ()=>window.localStorage.getItem((0, _languages.LANGUAGE_KEY)) ?? (0, _languages.DEFAULT_LANGUAGE);

},{"../constants/languages":"ecnY7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4KuO7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useGetFontColorContrast = require("../../hooks/useGetFontColorContrast");
var _useGetFontColorContrastDefault = parcelHelpers.interopDefault(_useGetFontColorContrast);
const Tag = (props)=>{
    const { color, className, ...tagProps } = props;
    const textColor = (0, _useGetFontColorContrastDefault.default)(color);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTagWrapper, {
        color: textColor,
        backgroundColor: color,
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Tag), {
            ...tagProps
        })
    });
};
const StyledTagWrapper = (0, _styledComponentsDefault.default).span`
  & .Polaris-Tag {
    padding: var(--p-space-05) var(--p-space-2);
    --p-color-bg-strong: ${({ backgroundColor })=>backgroundColor || "var(--kdk-surface-tag)"};
    --p-color-text: ${({ color })=>color};
    border-radius: var(--p-border-radius-05);
    line-height: var(--kdk-tag-height);
    min-height: var(--kdk-tag-height);
  }

  & .Polaris-Tag.Polaris-Tag--removable {
    padding-right: 0;
  }

  & .Polaris-Tag.Polaris-Tag--removable .Polaris-Tag__Button:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%);
  }

  & .Polaris-Tag__TagText {
    font-size: var(--p-font-size-75);
    line-height: var(--kdk-tag-height);
    min-height: var(--kdk-tag-height);
    padding: 0;
    user-select: none;
  }

  & .Polaris-Tag__Button .Polaris-Icon {
    width: 1rem;
    height: 1rem;
  }

  & .Polaris-Tag__Button .Polaris-Icon svg {
    fill: ${({ color })=>color};
  }
`;
exports.default = Tag;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useGetFontColorContrast":"gZSob","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gZSob":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fontColorContrast = require("font-color-contrast");
var _fontColorContrastDefault = parcelHelpers.interopDefault(_fontColorContrast);
const colorsCache = new Map();
const useGetFontColorContrast = (color)=>{
    if (!color) return undefined;
    if (!colorsCache.has(color)) {
        const fontColor = (0, _fontColorContrastDefault.default)(color);
        // set #000000 (black) color to undefined in order to render this color with polaris text color (--p-text)
        // which is the default and it will not be override if returned value is undefined
        colorsCache.set(color, fontColor === "#000000" ? undefined : fontColor);
    }
    return colorsCache.get(color);
};
exports.default = useGetFontColorContrast;

},{"font-color-contrast":"4mNu4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4mNu4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const FontColorContrast_1 = require("dbc04855a494a834");
function fontColorContrast(hexColorOrRedOrArray, greenOrThreshold, blue, threshold) {
    const fcc = new FontColorContrast_1.FontColorContrast(hexColorOrRedOrArray, greenOrThreshold, blue, threshold);
    return fcc.getColor();
}
exports.default = fontColorContrast;

},{"dbc04855a494a834":"cPZk5"}],"cPZk5":[function(require,module,exports) {
"use strict";
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FontColorContrast_hexColorOrRedOrArray, _FontColorContrast_greenOrThreshold, _FontColorContrast_blue, _FontColorContrast_threshold;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FontColorContrast = exports.NumberType = void 0;
const cssNamedColors_1 = require("72d907e4502289cd");
var NumberType;
(function(NumberType) {
    NumberType[NumberType["COLOR"] = 255] = "COLOR";
    NumberType[NumberType["RGB"] = 16777215] = "RGB";
    NumberType[NumberType["THRESHOLD"] = 1] = "THRESHOLD";
})(NumberType = exports.NumberType || (exports.NumberType = {}));
class FontColorContrast {
    /**
     * Sets the #params in the instance
     * @param hexColorOrRedOrArray One of the options: hex color number, hex color string, named CSS color, array with red, green and blue or string or the red portion of the color
     * @param greenOrThreshold The green portion of the color or the contrast threshold to control the resulting font color
     * @param blue The blue portion of the color
     * @param threshold Contrast threshold to control the resulting font color
     */ constructor(hexColorOrRedOrArray, greenOrThreshold, blue, threshold){
        this.red = 0;
        this.green = 0;
        this.blue = 0;
        _FontColorContrast_hexColorOrRedOrArray.set(this, void 0);
        _FontColorContrast_greenOrThreshold.set(this, void 0);
        _FontColorContrast_blue.set(this, void 0);
        _FontColorContrast_threshold.set(this, void 0);
        /**
         * Contrast threshold to control the resulting font color, float values from 0 to 1. Default is 0.5
         */ this.threshold = 0.5;
        __classPrivateFieldSet(this, _FontColorContrast_hexColorOrRedOrArray, hexColorOrRedOrArray, "f");
        __classPrivateFieldSet(this, _FontColorContrast_greenOrThreshold, greenOrThreshold, "f");
        __classPrivateFieldSet(this, _FontColorContrast_blue, blue, "f");
        __classPrivateFieldSet(this, _FontColorContrast_threshold, threshold, "f");
    }
    /**
     * Analyses the color (normally used in the background) and retrieves what color (black or white) has a better contrast.
     * @returns The best contrast between black and white
     */ getColor() {
        if (this.isRgb()) this.setColorsFromRgbNumbers();
        else if (this.isHexString()) this.setColorsFromHexString();
        else if (this.isNumber()) this.setColorsFromNumber();
        else if (this.isArray()) this.setColorsFromArray();
        else return "#ffffff";
        return this.contrastFromHSP();
    }
    /**
     * Checks if the color is set as RGB on each param
     * @returns True if color is set as RGB on each param
     */ isRgb() {
        return FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f"), NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_blue, "f"), NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"), NumberType.THRESHOLD);
    }
    /**
     * Checks if color is set on the first param as a hex string and removes the hash of it
     * @returns True if color is a hex string
     */ isHexString() {
        const [cleanString, hexNum] = this.getCleanStringAndHexNum();
        if (FontColorContrast.isValidNumber(hexNum, NumberType.RGB) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.THRESHOLD) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_blue, "f")) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"))) {
            __classPrivateFieldSet(this, _FontColorContrast_hexColorOrRedOrArray, cleanString, "f");
            return true;
        }
        return false;
    }
    /**
     * Checks if color is set on the first param as a number
     * @returns True if color is a valid RGB nunbernumber
     */ isNumber() {
        return FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f"), NumberType.RGB) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.THRESHOLD) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_blue, "f")) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"));
    }
    /**
     * Checks if color is set as an RGB array
     * @returns True if color is set as an RGB array
     */ isArray() {
        return Array.isArray(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")) && __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").length === 3 && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[0], NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[1], NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[2], NumberType.COLOR) && FontColorContrast.isValidNumber(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"), NumberType.THRESHOLD) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_blue, "f")) && FontColorContrast.isNotSet(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"));
    }
    /**
     * Converts a color array or separated in RGB to the respective RGB values
     * @example All these examples produces the same value
     * arrayOrRgbToRGB(0, 0xcc, 153)
     * arrayOrRgbToRGB(0x0, 0xcc, 153)
     * arrayOrRgbToRGB(0, 204, 0x99)
     */ setColorsFromRgbNumbers() {
        this.red = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f");
        this.green = __classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f");
        this.blue = __classPrivateFieldGet(this, _FontColorContrast_blue, "f");
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_threshold, "f"));
    }
    /**
     * Converts a color array or separated in RGB to the respective RGB values
     * @param this.#hexColorOrRedOrArray The RGB array
     * @param threshold The threshold
     * @example All these examples produces the same value
     * arrayOrRgbToRGB([0, 0xcc, 153])
     * arrayOrRgbToRGB([0x0, 0xcc, 153])
     * arrayOrRgbToRGB([0, 204, 0x99])
     */ setColorsFromArray() {
        this.red = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[0];
        this.green = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[1];
        this.blue = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[2];
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"));
    }
    /**
     * Converts a ColorIntensity string or number, with all possibilities (e.g. '#009', '009', '#000099', '000099', 153, 0x00099) to the respective RGB values
     * @param hexColor The color string or number
     * @param threshold The threshold
     * @example All these examples produces the same value
     * hexColorToRGB('#0C9')
     * hexColorToRGB('0C9')
     * hexColorToRGB('#00CC99')
     * hexColorToRGB('00cc99')
     * hexColorToRGB(52377)
     * hexColorToRGB(0x00Cc99)
     */ setColorsFromHexString() {
        switch(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").length){
            // Color has one char for each color, so they must be repeated
            case 3:
                this.red = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[0].repeat(2), 16);
                this.green = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[1].repeat(2), 16);
                this.blue = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f")[2].repeat(2), 16);
                break;
            // All chars are filled, so no transformation is needed
            default:
                this.red = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").substring(0, 2), 16);
                this.green = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").substring(2, 4), 16);
                this.blue = parseInt(__classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").substring(4, 6), 16);
                break;
        }
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"));
    }
    /**
     * Converts the RGB number and sets the respective RGB values.
     */ setColorsFromNumber() {
        /*
         * The RGB color has 24 bits (8 bits per color).
         * This function uses binary operations for better performance, but can be tricky to understand. A 24 bits color could be represented as RRRRRRRR GGGGGGGG BBBBBBBB (the first 8 bits are red, the middle 8 bits are green and the last 8 bits are blue).
         * To get each color we perform some RIGHT SHIFT and AND operations.
         * Gets the first 8 bits of the color by shifting it 16 bits
         * RIGHT SHIFT operation (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Right_shift)
         * AND operation (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_AND)
         */ // To get red, we shift the 24 bits number 16 bits to the right, leaving the number only with the leftmost 8 bits (RRRRRRRR)
        this.red = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") >> 16;
        // To get green, the middle 8 bits, we shift it by 8 bits (removing all blue bits - RRRRRRRR GGGGGGGG) and use an AND operation with "0b0000000011111111 = 0xff" to get only the rightmost bits (GGGGGGGG)
        this.green = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") >> 8 & 0xff;
        // To get blue we use an AND operation with "0b000000000000000011111111 = 0xff" to get only the rightmost bits (BBBBBBBB)
        this.blue = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") & 0xff;
        this.setThreshold(__classPrivateFieldGet(this, _FontColorContrast_greenOrThreshold, "f"));
    }
    /**
     * Sets the threshold to the passed value (if valid - less than or equal 1) or the dafault (0.5)
     * @param threshold The passed threshold or undefined if not passed
     */ setThreshold(threshold) {
        this.threshold = threshold || this.threshold;
    }
    /**
     * Verifies if a number is a valid color number (numberType = NumberType.COLOR = 0xff) or a valid RGB (numberType = NumberType.RGB = 0xffffff) or a valid threshold (numberType = NumberType.THRESHOLD = 1)
     * @param num The number to be checked
     * @param numberType The type of number to be chacked that defines maximum value of the number (default = NumberType.COLOR = 0xff)
     * @returns True if the number is valid
     */ static isValidNumber(num, numberType) {
        if (numberType === NumberType.THRESHOLD && (num === undefined || num === null)) return true;
        return typeof num === "number" && (numberType !== NumberType.THRESHOLD && Number.isInteger(num) || numberType === NumberType.THRESHOLD) && num !== undefined && num !== null && num >= 0 && num <= numberType;
    }
    /**
     * Verifies if a string is a valig string to be used as a color and if true, returns the correspondent hex number
     * @returns Array with an empty string and false if the string is invalid or an array with the clean string and the converted string number]
     */ getCleanStringAndHexNum() {
        if (typeof __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f") !== "string") return [
            "",
            false
        ];
        const cleanRegEx = /(#|\s)/ig;
        const namedColor = cssNamedColors_1.cssNamedColors.find((color)=>color.name === __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f"));
        if (namedColor) __classPrivateFieldSet(this, _FontColorContrast_hexColorOrRedOrArray, namedColor.hex.replace(cleanRegEx, ""), "f");
        const cleanString = __classPrivateFieldGet(this, _FontColorContrast_hexColorOrRedOrArray, "f").replace(cleanRegEx, "");
        if (cleanString.length !== 3 && cleanString.length !== 6) return [
            "",
            false
        ];
        const hexNum = Number("0x" + cleanString);
        return [
            cleanString,
            hexNum
        ];
    }
    /**
     * Verifies if a value is not set
     * @param value The value that should be undefined or null
     * @returns True if the value is not set
     */ static isNotSet(value) {
        return value === undefined || value === null;
    }
    /**
     * Calculates the best color (black or white) to contrast with the passed RGB color using the algorithm from https://alienryderflex.com/hsp.html
     * @returns Black or White depending on the best possible contrast
     */ contrastFromHSP() {
        const pRed = 0.299;
        const pGreen = 0.587;
        const pBlue = 0.114;
        const contrast = Math.sqrt(pRed * Math.pow(this.red / 255, 2) + pGreen * Math.pow(this.green / 255, 2) + pBlue * Math.pow(this.blue / 255, 2));
        return contrast > this.threshold ? "#000000" : "#ffffff";
    }
}
exports.FontColorContrast = FontColorContrast;
_FontColorContrast_hexColorOrRedOrArray = new WeakMap(), _FontColorContrast_greenOrThreshold = new WeakMap(), _FontColorContrast_blue = new WeakMap(), _FontColorContrast_threshold = new WeakMap();

},{"72d907e4502289cd":"4juM0"}],"4juM0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cssNamedColors = void 0;
exports.cssNamedColors = [
    {
        name: "aliceblue",
        hex: "#f0f8ff"
    },
    {
        name: "antiquewhite",
        hex: "#faebd7"
    },
    {
        name: "aqua",
        hex: "#00ffff"
    },
    {
        name: "aquamarine",
        hex: "#7fffd4"
    },
    {
        name: "azure",
        hex: "#f0ffff"
    },
    {
        name: "beige",
        hex: "#f5f5dc"
    },
    {
        name: "bisque",
        hex: "#ffe4c4"
    },
    {
        name: "black",
        hex: "#000000"
    },
    {
        name: "blanchedalmond",
        hex: "#ffebcd"
    },
    {
        name: "blue",
        hex: "#0000ff"
    },
    {
        name: "blueviolet",
        hex: "#8a2be2"
    },
    {
        name: "brown",
        hex: "#a52a2a"
    },
    {
        name: "burlywood",
        hex: "#deb887"
    },
    {
        name: "cadetblue",
        hex: "#5f9ea0"
    },
    {
        name: "chartreuse",
        hex: "#7fff00"
    },
    {
        name: "chocolate",
        hex: "#d2691e"
    },
    {
        name: "coral",
        hex: "#ff7f50"
    },
    {
        name: "cornflowerblue",
        hex: "#6495ed"
    },
    {
        name: "cornsilk",
        hex: "#fff8dc"
    },
    {
        name: "crimson",
        hex: "#dc143c"
    },
    {
        name: "cyan",
        hex: "#00ffff"
    },
    {
        name: "darkblue",
        hex: "#00008b"
    },
    {
        name: "darkcyan",
        hex: "#008b8b"
    },
    {
        name: "darkgoldenrod",
        hex: "#b8860b"
    },
    {
        name: "darkgray",
        hex: "#a9a9a9"
    },
    {
        name: "darkgreen",
        hex: "#006400"
    },
    {
        name: "darkgrey",
        hex: "#a9a9a9"
    },
    {
        name: "darkkhaki",
        hex: "#bdb76b"
    },
    {
        name: "darkmagenta",
        hex: "#8b008b"
    },
    {
        name: "darkolivegreen",
        hex: "#556b2f"
    },
    {
        name: "darkorange",
        hex: "#ff8c00"
    },
    {
        name: "darkorchid",
        hex: "#9932cc"
    },
    {
        name: "darkred",
        hex: "#8b0000"
    },
    {
        name: "darksalmon",
        hex: "#e9967a"
    },
    {
        name: "darkseagreen",
        hex: "#8fbc8f"
    },
    {
        name: "darkslateblue",
        hex: "#483d8b"
    },
    {
        name: "darkslategray",
        hex: "#2f4f4f"
    },
    {
        name: "darkslategrey",
        hex: "#2f4f4f"
    },
    {
        name: "darkturquoise",
        hex: "#00ced1"
    },
    {
        name: "darkviolet",
        hex: "#9400d3"
    },
    {
        name: "deeppink",
        hex: "#ff1493"
    },
    {
        name: "deepskyblue",
        hex: "#00bfff"
    },
    {
        name: "dimgray",
        hex: "#696969"
    },
    {
        name: "dimgrey",
        hex: "#696969"
    },
    {
        name: "dodgerblue",
        hex: "#1e90ff"
    },
    {
        name: "firebrick",
        hex: "#b22222"
    },
    {
        name: "floralwhite",
        hex: "#fffaf0"
    },
    {
        name: "forestgreen",
        hex: "#228b22"
    },
    {
        name: "fuchsia",
        hex: "#ff00ff"
    },
    {
        name: "gainsboro",
        hex: "#dcdcdc"
    },
    {
        name: "ghostwhite",
        hex: "#f8f8ff"
    },
    {
        name: "gold",
        hex: "#ffd700"
    },
    {
        name: "goldenrod",
        hex: "#daa520"
    },
    {
        name: "gray",
        hex: "#808080"
    },
    {
        name: "green",
        hex: "#008000"
    },
    {
        name: "greenyellow",
        hex: "#adff2f"
    },
    {
        name: "grey",
        hex: "#808080"
    },
    {
        name: "honeydew",
        hex: "#f0fff0"
    },
    {
        name: "hotpink",
        hex: "#ff69b4"
    },
    {
        name: "indianred",
        hex: "#cd5c5c"
    },
    {
        name: "indigo",
        hex: "#4b0082"
    },
    {
        name: "ivory",
        hex: "#fffff0"
    },
    {
        name: "khaki",
        hex: "#f0e68c"
    },
    {
        name: "lavender",
        hex: "#e6e6fa"
    },
    {
        name: "lavenderblush",
        hex: "#fff0f5"
    },
    {
        name: "lawngreen",
        hex: "#7cfc00"
    },
    {
        name: "lemonchiffon",
        hex: "#fffacd"
    },
    {
        name: "lightblue",
        hex: "#add8e6"
    },
    {
        name: "lightcoral",
        hex: "#f08080"
    },
    {
        name: "lightcyan",
        hex: "#e0ffff"
    },
    {
        name: "lightgoldenrodyellow",
        hex: "#fafad2"
    },
    {
        name: "lightgray",
        hex: "#d3d3d3"
    },
    {
        name: "lightgreen",
        hex: "#90ee90"
    },
    {
        name: "lightgrey",
        hex: "#d3d3d3"
    },
    {
        name: "lightpink",
        hex: "#ffb6c1"
    },
    {
        name: "lightsalmon",
        hex: "#ffa07a"
    },
    {
        name: "lightseagreen",
        hex: "#20b2aa"
    },
    {
        name: "lightskyblue",
        hex: "#87cefa"
    },
    {
        name: "lightslategray",
        hex: "#778899"
    },
    {
        name: "lightslategrey",
        hex: "#778899"
    },
    {
        name: "lightsteelblue",
        hex: "#b0c4de"
    },
    {
        name: "lightyellow",
        hex: "#ffffe0"
    },
    {
        name: "lime",
        hex: "#00ff00"
    },
    {
        name: "limegreen",
        hex: "#32cd32"
    },
    {
        name: "linen",
        hex: "#faf0e6"
    },
    {
        name: "magenta",
        hex: "#ff00ff"
    },
    {
        name: "maroon",
        hex: "#800000"
    },
    {
        name: "mediumaquamarine",
        hex: "#66cdaa"
    },
    {
        name: "mediumblue",
        hex: "#0000cd"
    },
    {
        name: "mediumorchid",
        hex: "#ba55d3"
    },
    {
        name: "mediumpurple",
        hex: "#9370db"
    },
    {
        name: "mediumseagreen",
        hex: "#3cb371"
    },
    {
        name: "mediumslateblue",
        hex: "#7b68ee"
    },
    {
        name: "mediumspringgreen",
        hex: "#00fa9a"
    },
    {
        name: "mediumturquoise",
        hex: "#48d1cc"
    },
    {
        name: "mediumvioletred",
        hex: "#c71585"
    },
    {
        name: "midnightblue",
        hex: "#191970"
    },
    {
        name: "mintcream",
        hex: "#f5fffa"
    },
    {
        name: "mistyrose",
        hex: "#ffe4e1"
    },
    {
        name: "moccasin",
        hex: "#ffe4b5"
    },
    {
        name: "navajowhite",
        hex: "#ffdead"
    },
    {
        name: "navy",
        hex: "#000080"
    },
    {
        name: "oldlace",
        hex: "#fdf5e6"
    },
    {
        name: "olive",
        hex: "#808000"
    },
    {
        name: "olivedrab",
        hex: "#6b8e23"
    },
    {
        name: "orange",
        hex: "#ffa500"
    },
    {
        name: "orangered",
        hex: "#ff4500"
    },
    {
        name: "orchid",
        hex: "#da70d6"
    },
    {
        name: "palegoldenrod",
        hex: "#eee8aa"
    },
    {
        name: "palegreen",
        hex: "#98fb98"
    },
    {
        name: "paleturquoise",
        hex: "#afeeee"
    },
    {
        name: "palevioletred",
        hex: "#db7093"
    },
    {
        name: "papayawhip",
        hex: "#ffefd5"
    },
    {
        name: "peachpuff",
        hex: "#ffdab9"
    },
    {
        name: "peru",
        hex: "#cd853f"
    },
    {
        name: "pink",
        hex: "#ffc0cb"
    },
    {
        name: "plum",
        hex: "#dda0dd"
    },
    {
        name: "powderblue",
        hex: "#b0e0e6"
    },
    {
        name: "purple",
        hex: "#800080"
    },
    {
        name: "red",
        hex: "#ff0000"
    },
    {
        name: "rosybrown",
        hex: "#bc8f8f"
    },
    {
        name: "royalblue",
        hex: "#4169e1"
    },
    {
        name: "saddlebrown",
        hex: "#8b4513"
    },
    {
        name: "salmon",
        hex: "#fa8072"
    },
    {
        name: "sandybrown",
        hex: "#f4a460"
    },
    {
        name: "seagreen",
        hex: "#2e8b57"
    },
    {
        name: "seashell",
        hex: "#fff5ee"
    },
    {
        name: "sienna",
        hex: "#a0522d"
    },
    {
        name: "silver",
        hex: "#c0c0c0"
    },
    {
        name: "skyblue",
        hex: "#87ceeb"
    },
    {
        name: "slateblue",
        hex: "#6a5acd"
    },
    {
        name: "slategray",
        hex: "#708090"
    },
    {
        name: "slategrey",
        hex: "#708090"
    },
    {
        name: "snow",
        hex: "#fffafa"
    },
    {
        name: "springgreen",
        hex: "#00ff7f"
    },
    {
        name: "steelblue",
        hex: "#4682b4"
    },
    {
        name: "tan",
        hex: "#d2b48c"
    },
    {
        name: "teal",
        hex: "#008080"
    },
    {
        name: "thistle",
        hex: "#d8bfd8"
    },
    {
        name: "tomato",
        hex: "#ff6347"
    },
    {
        name: "turquoise",
        hex: "#40e0d0"
    },
    {
        name: "violet",
        hex: "#ee82ee"
    },
    {
        name: "wheat",
        hex: "#f5deb3"
    },
    {
        name: "white",
        hex: "#ffffff"
    },
    {
        name: "whitesmoke",
        hex: "#f5f5f5"
    },
    {
        name: "yellow",
        hex: "#ffff00"
    },
    {
        name: "yellowgreen",
        hex: "#9acd32"
    },
    {
        name: "rebeccapurple",
        hex: "#663399"
    }
];

},{}],"5xyTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _usePageNavigation = require("../../hooks/usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
var _usePendingTask = require("../../hooks/usePendingTask");
var _usePendingTaskDefault = parcelHelpers.interopDefault(_usePendingTask);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _separatorStackWrapper = require("../SeparatorStackWrapper/SeparatorStackWrapper");
var _separatorStackWrapperDefault = parcelHelpers.interopDefault(_separatorStackWrapper);
const PendingTasksBanner = (props)=>{
    const { customer } = props;
    const { navigateInPage } = (0, _usePageNavigationDefault.default)();
    const getPendingTaskStatuses = (0, _usePendingTaskDefault.default)(customer);
    const pendingTasks = customer.pending_tasks;
    // filter "Ready for assessment" (REVIEW_CUSTOMER) if there is more than 1 task
    // since reviewing is not possible while other tasks are not completed yet
    const pendingDisplayTasks = !pendingTasks || pendingTasks.length < 2 ? pendingTasks : pendingTasks.filter((pendingTask)=>pendingTask.type !== "REVIEW_CUSTOMER");
    const tasks = pendingDisplayTasks?.map(getPendingTaskStatuses).flat() || [];
    const showAsList = tasks.length > 3;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _kdkbannerDefault.default), {
        hideIcon: true,
        hideBorder: true,
        status: "info",
        children: [
            showAsList && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                inlineAlign: "start",
                children: tasks.map((task, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        plain: true,
                        monochrome: !task.anchor && !task.url,
                        removeUnderline: !task.anchor && !task.url,
                        icon: task.icon,
                        url: task.anchor ? undefined : task.url,
                        onClick: task.anchor ? ()=>navigateInPage(task.anchor) : undefined,
                        children: task.title
                    }, index))
            }),
            !showAsList && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    children: tasks.map((task, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            plain: true,
                            monochrome: !task.anchor && !task.url,
                            removeUnderline: !task.anchor && !task.url,
                            icon: task.icon,
                            url: task.anchor ? undefined : task.url,
                            onClick: task.anchor ? ()=>navigateInPage(task.anchor) : undefined,
                            children: task.title
                        }, index))
                })
            })
        ]
    });
};
const StyledWrapper = (0, _styledComponentsDefault.default)((0, _separatorStackWrapperDefault.default))`
  // For small viewports - always render as a list
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    & .Polaris-Stack {
      flex-direction: column;

      & .Polaris-Stack__Item + .Polaris-Stack__Item {
        border-left: none;
        padding-left: 0;
      }
    }

    & .Polaris-Button {
      text-align: left;
    }
  }
`;
exports.default = PendingTasksBanner;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/styles":"dZWds","../../hooks/usePageNavigation":"1o5Hm","../../hooks/usePendingTask":"41VLN","../extensions/Button":"8exc0","../KDKBanner/KDKBanner":"3zPW6","../SeparatorStackWrapper/SeparatorStackWrapper":"9GfEY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"41VLN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _statusApproveReviewSvg = require("../../assets/icons/status-approve-review.svg");
var _statusApproveReviewSvgDefault = parcelHelpers.interopDefault(_statusApproveReviewSvg);
var _statusFollowUpSvg = require("../../assets/icons/status-follow-up.svg");
var _statusFollowUpSvgDefault = parcelHelpers.interopDefault(_statusFollowUpSvg);
var _statusOpenMatchesSvg = require("../../assets/icons/status-open-matches.svg");
var _statusOpenMatchesSvgDefault = parcelHelpers.interopDefault(_statusOpenMatchesSvg);
var _statusOpenMeasuresSvg = require("../../assets/icons/status-open-measures.svg");
var _statusOpenMeasuresSvgDefault = parcelHelpers.interopDefault(_statusOpenMeasuresSvg);
var _statusOwnershipUpdatesSvg = require("../../assets/icons/status-ownership-updates.svg");
var _statusOwnershipUpdatesSvgDefault = parcelHelpers.interopDefault(_statusOwnershipUpdatesSvg);
var _statusReadySvg = require("../../assets/icons/status-ready.svg");
var _statusReadySvgDefault = parcelHelpers.interopDefault(_statusReadySvg);
var _statusStartedSvg = require("../../assets/icons/status-started.svg");
var _statusStartedSvgDefault = parcelHelpers.interopDefault(_statusStartedSvg);
var _statusWaitingSvg = require("../../assets/icons/status-waiting.svg");
var _statusWaitingSvgDefault = parcelHelpers.interopDefault(_statusWaitingSvg);
var _pageAnchors = require("../constants/page-anchors");
var _routes = require("../constants/routes");
var _utilities = require("../types/utilities");
var _dateUtils = require("../utils/dateUtils");
var _stringUtils = require("../utils/stringUtils");
var _useCustomerPath = require("./useCustomerPath");
var _useCustomerPathDefault = parcelHelpers.interopDefault(_useCustomerPath);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("./useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useGetUserName = require("./useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
const usePendingTask = (customer)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const { getCustomerPath } = (0, _useCustomerPathDefault.default)();
    const customerUrl = getCustomerPath(customer.id, customer.type);
    const getFinishOnboardingTask = (task)=>{
        const { onboarding_status } = task;
        return {
            title: f("onboarding.status.started"),
            icon: (0, _statusStartedSvgDefault.default),
            url: getCustomerPath(customer.id, customer.type, onboarding_status, (0, _utilities.isManualCompany)(customer)),
            urlLabel: f("pending.tasks.labels.finish-onboarding")
        };
    };
    const getPendingDisclosuresTask = (task)=>{
        const { count } = task;
        const anchor = (0, _pageAnchors.PAGE_ANCHORS).DISCLOSURES_SECTION;
        const url = `${customerUrl}#${anchor}`;
        const urlLabel = f("pending.tasks.labels.see-pending-disclosures", {
            count
        });
        return {
            title: f("pending-tasks.labels.awaiting-disclosures", {
                count
            }),
            icon: (0, _statusWaitingSvgDefault.default),
            url,
            urlLabel,
            anchor
        };
    };
    const getPendingDocumentsTask = (task)=>{
        const { count } = task;
        const anchor = (0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_DOCUMENTS;
        const url = `${customerUrl}#${anchor}`;
        const urlLabel = f("pending.tasks.labels.see-pending-documents", {
            count
        });
        return {
            title: f("pending-tasks.labels.awaiting-documents", {
                count
            }),
            icon: (0, _statusWaitingSvgDefault.default),
            url,
            anchor,
            urlLabel
        };
    };
    const getReviewCustomerTask = ()=>{
        const reviewPageURL = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMER_REVIEW_NEW, {
            customerId: customer.id
        });
        const url = reviewPageURL;
        return {
            title: f("onboarding.status.ready-for-review"),
            icon: (0, _statusReadySvgDefault.default),
            url,
            urlLabel: f("pending.tasks.labels.review-customer")
        };
    };
    const getDraftReviewTask = (task)=>{
        const count = task.review_ids.length;
        if (count === 1) {
            const url = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMER_REVIEW, {
                customerId: customer.id,
                id: task.review_ids[0]
            });
            return {
                title: f("onboarding.status.draft-review", {
                    count
                }),
                icon: (0, _statusWaitingSvgDefault.default),
                url,
                urlLabel: f("pending.tasks.labels.open-draft-review")
            };
        } else {
            const anchor = (0, _pageAnchors.PAGE_ANCHORS).PENDING_REVIEWS_SECTION;
            const url = `${customerUrl}#${anchor}`;
            return {
                title: f("onboarding.status.draft-review", {
                    count
                }),
                icon: (0, _statusWaitingSvgDefault.default),
                url,
                urlLabel: f("pending.tasks.labels.see-draft-reviews"),
                anchor
            };
        }
    };
    const getOwnershipUpdatesTask = ()=>{
        const anchor = (0, _pageAnchors.PAGE_ANCHORS).COMPANY_ROLES_AND_OWNERS_SECTION;
        const url = `${customerUrl}#${anchor}`;
        return {
            title: f("ownership-update.info.label"),
            icon: (0, _statusOwnershipUpdatesSvgDefault.default),
            url,
            urlLabel: f("pending.tasks.labels.review-ownership-updates"),
            anchor
        };
    };
    const getReviewMatchesTask = (task)=>{
        const { count, match_case_ids } = task;
        const anchor = (0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_MATCH_CASES;
        const customerDetailsUrl = `${customerUrl}#${anchor}`;
        // if count === 1 -> change the URL to the single match case page
        const url = count === 1 && match_case_ids && match_case_ids.length === 1 ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MATCH_CASE_DETAILS, {
            customerId: customer.id,
            id: match_case_ids[0]
        }) : customerDetailsUrl;
        // TODO if count > 1 -> generate multiple tasks and a summary task as well
        return {
            title: f("pending-tasks.labels.open-matches", {
                count
            }),
            icon: (0, _statusOpenMatchesSvgDefault.default),
            url,
            urlLabel: f("pending.tasks.labels.review-matches", {
                count
            }),
            anchor: count === 1 ? undefined : anchor
        };
    };
    const getFollowUpCustomerTask = (task)=>{
        const { has_expired, follow_up_date } = task;
        const daysUntilExpire = has_expired ? -1 : (0, _dateUtils.daysBetweenDates)(follow_up_date, new Date().toISOString());
        return {
            title: f("pending.tasks.status.followup", {
                days: daysUntilExpire
            }),
            icon: (0, _statusFollowUpSvgDefault.default),
            url: customerUrl,
            urlLabel: f("pending.tasks.labels.followup-customer")
        };
    };
    const getApproveCustomerReviewTask = (task)=>{
        const { is_possible_to_approve, approval_users, approval_request_date, review_id } = task;
        if (is_possible_to_approve) {
            const pendingReviewsSectionURL = `${customerUrl}#${(0, _pageAnchors.PAGE_ANCHORS).PENDING_REVIEWS_SECTION}`;
            const reviewPageURL = review_id ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMER_REVIEW, {
                customerId: customer.id,
                id: review_id
            }) : pendingReviewsSectionURL;
            const url = review_id ? reviewPageURL : pendingReviewsSectionURL;
            const anchor = review_id ? undefined : (0, _pageAnchors.PAGE_ANCHORS).PENDING_REVIEWS_SECTION;
            return {
                title: f("pending.tasks.status.approve-review"),
                icon: (0, _statusApproveReviewSvgDefault.default),
                url,
                urlLabel: f("pending.tasks.labels.approve-review"),
                anchor
            };
        } else {
            const approversNames = formatMultipleNames(approval_users?.map((user)=>getUserDisplayName(user)), 1);
            return {
                title: f("pending.tasks.status.waiting-for-approval"),
                subtitle: !(0, _stringUtils.isEmptyString)(approversNames) && approval_request_date ? f("pending.tasks.status.waiting-for-approval.subtitle", {
                    names: approversNames,
                    timestamp: new Date(approval_request_date)
                }) : undefined,
                icon: (0, _statusApproveReviewSvgDefault.default),
                anchor: (0, _pageAnchors.PAGE_ANCHORS).PENDING_REVIEWS_SECTION
            };
        }
    };
    const getCompletePendingMeasureTask = (task)=>{
        const { count } = task;
        const anchor = (0, _pageAnchors.PAGE_ANCHORS).REVIEWS_SECTION;
        const url = `${customerUrl}#${anchor}`;
        return {
            title: f("pending.tasks.status.review-measures", {
                count
            }),
            icon: (0, _statusOpenMeasuresSvgDefault.default),
            url,
            urlLabel: f("pending.tasks.labels.review-measures", {
                count
            }),
            anchor
        };
    };
    const getPendingTaskStatuses = (pendingTask)=>{
        switch(pendingTask.type){
            case "APPROVE_CUSTOMER_REVIEW":
                return [
                    getApproveCustomerReviewTask(pendingTask)
                ];
            case "COMPLETE_PENDING_MEASURES":
                return [
                    getCompletePendingMeasureTask(pendingTask)
                ];
            case "FINISH_ONBOARDING":
                return [
                    getFinishOnboardingTask(pendingTask)
                ];
            case "FOLLOW_UP_CUSTOMER":
                return [
                    getFollowUpCustomerTask(pendingTask)
                ];
            case "REVIEW_CUSTOMER":
                return [
                    getReviewCustomerTask()
                ];
            case "CONTINUE_DRAFT_REVIEWS":
                return [
                    getDraftReviewTask(pendingTask)
                ];
            case "REVIEW_MATCHES":
                return [
                    getReviewMatchesTask(pendingTask)
                ];
            case "REVIEW_OWNERSHIP_UPDATES":
                return [
                    getOwnershipUpdatesTask()
                ];
            case "CHECK_CUSTOMER_DISCLOSURES":
                return [
                    getPendingDisclosuresTask(pendingTask)
                ];
            case "CHECK_CUSTOMER_ATTACHMENTS":
                return [
                    getPendingDocumentsTask(pendingTask)
                ];
            default:
                return [];
        }
    };
    return getPendingTaskStatuses;
};
exports.default = usePendingTask;

},{"react-router-dom":"1ee65","../../assets/icons/status-approve-review.svg":"2WCjG","../../assets/icons/status-follow-up.svg":"j2fgw","../../assets/icons/status-open-matches.svg":"3psDV","../../assets/icons/status-open-measures.svg":"8jNzK","../../assets/icons/status-ownership-updates.svg":"7vX29","../../assets/icons/status-ready.svg":"aTvVr","../../assets/icons/status-started.svg":"7c5gZ","../../assets/icons/status-waiting.svg":"cOhJt","../constants/page-anchors":"4WmvA","../constants/routes":"ihtm8","../types/utilities":"6zLpB","../utils/dateUtils":"euvUV","../utils/stringUtils":"4gVdA","./useCustomerPath":"gJfCj","./useFormatMessage":"8Y8fq","./useFormatMultipleNames":"gogmY","./useGetUserName":"edBne","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2WCjG":[function(require,module,exports) {
module.exports = require("a00715d17538d231").getBundleURL("kEMsi") + "status-approve-review.f93a1cb6.svg";

},{"a00715d17538d231":"75UoR"}],"j2fgw":[function(require,module,exports) {
module.exports = require("94c4a4ef28a98132").getBundleURL("kEMsi") + "status-follow-up.fcc2b3ce.svg";

},{"94c4a4ef28a98132":"75UoR"}],"3psDV":[function(require,module,exports) {
module.exports = require("7e98fe892f5cfa83").getBundleURL("kEMsi") + "status-open-matches.d594b4fc.svg";

},{"7e98fe892f5cfa83":"75UoR"}],"8jNzK":[function(require,module,exports) {
module.exports = require("666fc6599fa697d6").getBundleURL("kEMsi") + "status-open-measures.55e20f4d.svg";

},{"666fc6599fa697d6":"75UoR"}],"7vX29":[function(require,module,exports) {
module.exports = require("c42dfe10d96e5878").getBundleURL("kEMsi") + "status-ownership-updates.0e3b0305.svg";

},{"c42dfe10d96e5878":"75UoR"}],"aTvVr":[function(require,module,exports) {
module.exports = require("5c0ef745d08a84ae").getBundleURL("kEMsi") + "status-ready.802e83cf.svg";

},{"5c0ef745d08a84ae":"75UoR"}],"7c5gZ":[function(require,module,exports) {
module.exports = require("8e11a6a0e754d39c").getBundleURL("kEMsi") + "status-started.f854b6aa.svg";

},{"8e11a6a0e754d39c":"75UoR"}],"cOhJt":[function(require,module,exports) {
module.exports = require("9ca9b0758b4751e8").getBundleURL("kEMsi") + "status-waiting.431f74da.svg";

},{"9ca9b0758b4751e8":"75UoR"}],"gJfCj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _onboarding = require("../constants/onboarding");
var _routes = require("../constants/routes");
var _navigationHelpers = require("../helpers/navigation.helpers");
const useCustomerPath = ()=>{
    const getCustomerPath = (customerId, customerType, onboardingStatus, isManual)=>{
        const isOnboarding = onboardingStatus && (0, _onboarding.ONBOARDING_STATUSES).includes(onboardingStatus);
        if (customerType === "person") {
            if (isOnboarding) return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).ONBOARDING_SAVED_PERSON, {
                id: customerId
            });
            else return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PERSON_DETAILS, {
                id: customerId
            });
        }
        // If onboarding a company manually, the link should start with "manual-companies"
        const isManualCompany = isOnboarding && customerType === "company" && isManual;
        if (isManualCompany) return (0, _navigationHelpers.getManualCompanyPath)(customerId, onboardingStatus);
        else return (0, _navigationHelpers.getCompanyPath)(customerId, onboardingStatus);
    };
    return {
        getCustomerPath
    };
};
exports.default = useCustomerPath;

},{"react-router-dom":"1ee65","../constants/onboarding":"lQH9P","../constants/routes":"ihtm8","../helpers/navigation.helpers":"adimP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lQH9P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ONBOARDING_STATUSES", ()=>ONBOARDING_STATUSES);
parcelHelpers.export(exports, "ONBOARDING_SCREENING_TYPES", ()=>ONBOARDING_SCREENING_TYPES);
parcelHelpers.export(exports, "DEFAULT_ONBOARDING_CONFIGURATION", ()=>DEFAULT_ONBOARDING_CONFIGURATION);
const ONBOARDING_STATUSES = [
    "FETCHING_DATA",
    "SCREENING_CONFIG",
    // "ASSIGNMENT_CONFIG",
    "SIGNATURE_CONFIG",
    "READY"
];
const ONBOARDING_SCREENING_TYPES = [
    "MONITORING",
    "ONE_TIME"
];
const DEFAULT_ONBOARDING_CONFIGURATION = {
    screening_type: "MONITORING",
    signature_settings: {
        use_verification: true,
        use_standard_disclosure: true,
        use_pep_disclosure: false,
        language: "nb",
        send_email: true,
        questionnaire_ids: []
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3zPW6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const KDKBanner = (props)=>{
    const { hideBorder, className, id, ...bannerProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBanner, {
        hideBorder: hideBorder,
        className: className,
        id: id,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
            ...bannerProps
        })
    });
};
const StyledBanner = (0, _styledComponentsDefault.default).div`
  & > .Polaris-Banner {
    border: ${({ hideBorder })=>hideBorder ? "none" : undefined};
  }
`;
exports.default = KDKBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9GfEY":[function(require,module,exports) {
// add separator lines between all stack items that are not the first or the last
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const SeparatorStackWrapper = (0, _styledComponentsDefault.default).div`
  & > .Polaris-Stack > .Polaris-Stack__Item + .Polaris-Stack__Item {
    border-left: var(--p-border-divider);
    padding-left: var(--p-space-4);
  }
`;
exports.default = SeparatorStackWrapper;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jy64a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFeatures = require("../../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _badges = require("../../Badges/Badges");
var _badgesDefault = parcelHelpers.interopDefault(_badges);
var _customerResponsibleUsersSelect = require("../../CustomerResponsibleUsersSelect/CustomerResponsibleUsersSelect");
var _customerResponsibleUsersSelectDefault = parcelHelpers.interopDefault(_customerResponsibleUsersSelect);
var _customerApprovalStatus = require("../../CustomerStatus/CustomerApprovalStatus");
var _customerApprovalStatusDefault = parcelHelpers.interopDefault(_customerApprovalStatus);
var _detailsGrid = require("../../DetailsGrid/DetailsGrid");
var _detailsGridDefault = parcelHelpers.interopDefault(_detailsGrid);
var _kdkbanner = require("../../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _risk = require("../../Risk/Risk");
var _riskDefault = parcelHelpers.interopDefault(_risk);
var _screeningStatusBadge = require("../../ScreeningStatusBadge/ScreeningStatusBadge");
var _screeningStatusBadgeDefault = parcelHelpers.interopDefault(_screeningStatusBadge);
var _followupSelect = require("./FollowupSelect");
var _followupSelectDefault = parcelHelpers.interopDefault(_followupSelect);
const BasicCustomerInfo = (props)=>{
    const { customer, screening, readonly } = props;
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        hideIcon: true,
        hideBorder: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailsGridDefault.default), {
            rows: 3,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    as: "span",
                    children: [
                        f("details.basic-info.status"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerApprovalStatusDefault.default), {
                        customer: customer,
                        detailed: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    as: "span",
                    children: [
                        f("details.basic-info.customer-risk"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDefault.default), {
                        risk: customer.risk_level
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    as: "span",
                    children: [
                        f("details.basic-info.marked-as"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgesDefault.default), {
                    isPep: customer.is_pep,
                    isSanctioned: customer.is_sanctioned,
                    showHyphenIfNotSet: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    as: "span",
                    children: [
                        f("details.basic-info.screening-type"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        blockAlign: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: f(`screening-type.${screening.screening_type || "NOT_SET"}`)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningStatusBadgeDefault.default), {
                                screening: screening
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    as: "span",
                    children: [
                        f("details.basic-info.follow-up"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _followupSelectDefault.default), {
                    customer: customer,
                    readonly: readonly
                }),
                features.RESPONSIBLE_USER && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: `${f("responsible-users.label")}:`
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerResponsibleUsersSelectDefault.default), {
                            customer: customer,
                            readonly: readonly
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = BasicCustomerInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFeatures":"hvBWb","../../../hooks/useFormatMessage":"8Y8fq","../../Badges/Badges":"cI72s","../../CustomerResponsibleUsersSelect/CustomerResponsibleUsersSelect":"2eTbl","../../CustomerStatus/CustomerApprovalStatus":"54xm8","../../DetailsGrid/DetailsGrid":"dIEbw","../../KDKBanner/KDKBanner":"3zPW6","../../Risk/Risk":"9VLEF","../../ScreeningStatusBadge/ScreeningStatusBadge":"bGehF","./FollowupSelect":"hNpPP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2eTbl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _usersSelect = require("../UsersSelect/UsersSelect");
var _usersSelectDefault = parcelHelpers.interopDefault(_usersSelect);
const CustomerResponsibleUsersSelect = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const updateResponsibleUsers = (responsibleUserIds)=>(0, _apiDefault.default).updateCustomerDetails(customer.id, {
            responsible_users: responsibleUserIds
        }).then((response)=>response.responsible_users || []);
    const updateQueryCache = (responsibleUsers)=>updateQueryData((queryData)=>queryData.responsible_users = responsibleUsers);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersSelectDefault.default), {
        selectedUsers: customer.responsible_users || [],
        emptySelectionLabel: f("responsible.empty.users"),
        updateErrorMessage: f("responsible.error"),
        readonly: readonly,
        strong: true,
        onUserSelection: updateResponsibleUsers,
        onAfterUserSelection: updateQueryCache
    });
};
exports.default = CustomerResponsibleUsersSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../api":"f6lXD","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../UsersSelect/UsersSelect":"k1Nxo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k1Nxo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _multipleUsersInitials = require("../MultipleUsersInitials/MultipleUsersInitials");
var _multipleUsersInitialsDefault = parcelHelpers.interopDefault(_multipleUsersInitials);
var _usersList = require("../UsersList/UsersList");
var _usersListDefault = parcelHelpers.interopDefault(_usersList);
const UsersSelect = (props)=>{
    const { selectedUsers, emptySelectionLabel, updateErrorMessage, readonly, excludeCurrentUser, strong, onUserSelection, onAfterUserSelection } = props;
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const [active, toggleActive, close] = (0, _useOpenCloseDefault.default)();
    const [selectionChanged, setSelectionChanged] = (0, _react.useState)(false);
    const selectedUsersIds = selectedUsers.map((user)=>user.id);
    const userSelectionMutation = (0, _reactQuery.useMutation)((selectedUserIds)=>onUserSelection(selectedUserIds), {
        onSuccess: onAfterUserSelection
    });
    const usersDisplayName = selectedUsers.length === 0 ? emptySelectionLabel : formatMultipleNames(selectedUsers.map(getUserDisplayName), 2);
    const usersTooltip = selectedUsers.length === 0 ? "" : formatMultipleNames(selectedUsers.map(getUserDisplayName), 0);
    const activator = /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
        id: "user-select",
        onClick: toggleActive,
        size: "slim",
        plain: true,
        textAlign: "left",
        // this is to fix a bug with @polaris that hides the loading indicator if button is monochrome
        monochrome: !userSelectionMutation.isLoading,
        loading: userSelectionMutation.isLoading,
        disabled: readonly,
        disclosure: active ? "up" : "down",
        removeUnderline: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "2",
            blockAlign: "center",
            wrap: false,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multipleUsersInitialsDefault.default), {
                    users: selectedUsers
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDisplayLabel, {
                    title: usersTooltip,
                    strong: strong,
                    children: usersDisplayName
                })
            ]
        })
    });
    function handleSelectionChange(selectedIds) {
        if (selectedIds.length > selectedUsersIds.length) setSelectionChanged(true);
        userSelectionMutation.mutate(selectedIds);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover), {
                active: active,
                activator: activator,
                onClose: close,
                autofocusTarget: "first-node",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersListDefault.default), {
                        selectedUserIds: selectedUsersIds,
                        onChange: handleSelectionChange,
                        allowMultiple: true,
                        selectedFirst: !selectionChanged,
                        excludeCurrentUser: excludeCurrentUser,
                        readonly: userSelectionMutation.isLoading
                    })
                })
            }),
            userSelectionMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: updateErrorMessage,
                fieldID: "user-select"
            })
        ]
    });
};
const StyledButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  & .Polaris-Button {
    padding: ${({ plain })=>plain ? "0" : undefined};
  }
`;
const StyledDisplayLabel = (0, _styledComponentsDefault.default).div`
  font-weight: ${({ strong })=>strong ? "var(--p-font-weight-bold)" : undefined};
  max-width: 100%;
`;
exports.default = UsersSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../hooks/useFormatMultipleNames":"gogmY","../../hooks/useGetUserName":"edBne","../../hooks/useOpenClose":"idooG","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Button":"8exc0","../MultipleUsersInitials/MultipleUsersInitials":"2srna","../UsersList/UsersList":"dqxGe","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2srna":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _userInitials = require("../UserInitials/UserInitials");
var _userInitialsDefault = parcelHelpers.interopDefault(_userInitials);
const MultipleUsersInitials = (props)=>{
    const { users, responsive } = props;
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const usersToDisplay = users.filter(Boolean);
    if (usersToDisplay.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInitialsContainerWrapper, {
        border: usersToDisplay.length > 1,
        responsive: responsive,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack), {
            spacing: "extraTight",
            wrap: false,
            alignment: "fill",
            children: usersToDisplay.map((user)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledElement, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userInitialsDefault.default), {
                            user: user,
                            tooltip: getUserDisplayName(user)
                        }),
                        responsive && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: responsive ? undefined : "semibold",
                            truncate: true,
                            children: getUserDisplayName(user)
                        })
                    ]
                }, user.id))
        })
    });
};
const StyledInitialsContainerWrapper = (0, _styledComponentsDefault.default).div`
  // set spacing to be negative to create overlapping effect when multiple initials are rendered
  & > .Polaris-Stack {
    --pc-stack-spacing: calc(var(--p-space-1) * -2);

    // For small viewports - and only if set as responsive -
    // render responsible users as a list without overlapping UserInitials
    ${({ responsive })=>responsive && `
      @media (max-width: ${0, _styles.MOBILE_BREAKPOINT}) {
        --pc-stack-spacing: var(--p-space-1);
        flex-direction: column;
      }
    `};
  }

  & .Polaris-Avatar {
    border-color: ${({ border })=>border ? "var(--p-surface)" : undefined};
  }
`;
const StyledElement = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-columns: min-content 1fr;
  align-items: center;
  gap: var(--p-space-1);

  & > .Polaris-Text--root {
    display: none;

    // For small viewports - show responsible user name
    @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
      display: revert;
    }
  }
`;
exports.default = MultipleUsersInitials;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/styles":"dZWds","../../hooks/useGetUserName":"edBne","../UserInitials/UserInitials":"97rVK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"97rVK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _userInitialsHelpers = require("./UserInitials.helpers");
const UserInitials = (props)=>{
    const { user, tooltip, hideOnNoUser } = props;
    if (hideOnNoUser && !user) return null;
    const avatar = /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledAvatar, {
        showInitials: user !== undefined,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Avatar), {
            size: "small",
            customer: false,
            initials: user && (0, _userInitialsHelpers.getUserInitials)(user)
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
        content: tooltip,
        preferredPosition: "above",
        dismissOnMouseOut: true,
        children: avatar
    });
};
const StyledAvatar = (0, _styledComponentsDefault.default).div`
  & .Polaris-Avatar {
    min-width: var(--p-space-6);
    width: var(--p-space-6);
    border: solid var(--p-border-width-2) transparent;
    background: ${({ showInitials })=>showInitials ? "var(--p-decorative-one-surface)" : "initial"};
  }

  & .Polaris-Avatar .Polaris-Avatar__Text {
    font-size: var(--p-font-size-200);
    font-weight: var(--p-font-weight-bold);
  }
,
`;
exports.default = UserInitials;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../TooltipWrapper/TooltipWrapper":"b5W2d","./UserInitials.helpers":"7mgUd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7mgUd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserInitials", ()=>getUserInitials);
var _stringUtils = require("../../utils/stringUtils");
const getUserInitials = (user)=>`${(0, _stringUtils.firstLetter)(user?.first_name)}${(0, _stringUtils.firstLetter)(user?.last_name)}`;

},{"../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dqxGe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _personSvg = require("../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useGetUsers = require("../../hooks/useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
var _collectionUtils = require("../../utils/collectionUtils");
var _entitiesList = require("../EntitiesList/EntitiesList");
var _entitiesListDefault = parcelHelpers.interopDefault(_entitiesList);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const UsersList = (props)=>{
    const { selectedUserIds, showAllUsersOption, excludeCurrentUser, filterGroups, onChange, ...actionListProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { user: currentUser } = (0, _useAuthDefault.default)();
    const { getFilteredUsers, isLoading, error } = (0, _useGetUsersDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const users = getFilteredUsers(filterGroups);
    const displayUsers = (0, _react.useMemo)(()=>(excludeCurrentUser ? users?.filter((user)=>user.id !== currentUser?.id) : users) || [], [
        excludeCurrentUser,
        users
    ]);
    const clearSelection = ()=>onChange([]);
    const handleSelect = (user)=>onChange((0, _collectionUtils.toggleElement)(selectedUserIds, user.id));
    const allUsersActionItem = {
        content: f("component.users-list.all-users.title"),
        suffix: !actionListProps.allowMultiple && selectedUserIds.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _polarisIcons.TickSmallMinor)
        }) : null,
        prefix: actionListProps.allowMultiple ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
            label: "",
            labelHidden: true,
            checked: selectedUserIds.length === 0
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _personSvgDefault.default)
        }),
        onAction: clearSelection
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("component.users-list.loading")
            }),
            ";"
        ]
    });
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: error,
        actionTitle: f("component.users-list.loading.error-action")
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entitiesListDefault.default), {
        entities: displayUsers,
        selectedIds: selectedUserIds,
        getEntityLabel: (user)=>getUserDisplayName(user),
        getEntityPrefix: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _personSvgDefault.default)
            }),
        isEntityDisabled: (user)=>!user.is_active,
        prefixActionListItemDescriptor: showAllUsersOption ? allUsersActionItem : undefined,
        filterLabel: f("component.users-list.filter.label"),
        onSelect: handleSelect,
        ...actionListProps
    });
};
exports.default = UsersList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","../../../assets/icons/person.svg":"1Xt5L","../../hooks/useAuth":"k9r0q","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useGetUsers":"c83Pg","../../utils/collectionUtils":"gr5mc","../EntitiesList/EntitiesList":"ce1Sz","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ce1Sz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _stringUtils = require("../../utils/stringUtils");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _stickyWrapper = require("../StickyWrapper/StickyWrapper");
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
function EntitiesList(props) {
    const { entities, selectedIds, readonly, filterLabel, hideFilter, allowMultiple, selectedFirst, prefixActionListItemDescriptor, getEntityLabel, getEntityHelpText = ()=>null, getEntityPrefix = ()=>null, isEntityDisabled, onSelect, children, ...actionListProps } = props;
    const [inputValue, setInputValue] = (0, _react.useState)("");
    const mapEntityToActionItem = (entity)=>allowMultiple ? {
            content: getEntityLabel(entity),
            helpText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                truncate: true,
                children: getEntityHelpText(entity)
            }),
            onAction: ()=>onSelect(entity),
            prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                label: "",
                labelHidden: true,
                checked: selectedIds.includes(entity.id),
                disabled: readonly || isEntityDisabled(entity)
            }),
            disabled: readonly || isEntityDisabled(entity),
            truncate: true
        } : {
            content: getEntityLabel(entity),
            helpText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: getEntityHelpText(entity),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    truncate: true,
                    children: getEntityHelpText(entity)
                })
            }),
            onAction: ()=>onSelect(entity),
            suffix: selectedIds.includes(entity.id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _polarisIcons.TickSmallMinor)
            }) : null,
            prefix: getEntityPrefix(entity),
            active: selectedIds.includes(entity.id),
            disabled: readonly || isEntityDisabled(entity),
            truncate: true
        };
    const filterEntity = (entity)=>(!isEntityDisabled(entity) || selectedIds.includes(entity.id)) && getEntityLabel(entity).match((0, _stringUtils.filterRegEx)(inputValue));
    const sortEntities = (entityA, entityB)=>{
        return selectedIds.includes(entityA.id) === selectedIds.includes(entityB.id) ? getEntityLabel(entityA).localeCompare(getEntityLabel(entityB)) : selectedIds.includes(entityA.id) ? -1 : 1;
    };
    const actionItems = (0, _react.useMemo)(()=>{
        const sortedEntities = selectedFirst ? entities.sort(sortEntities) : entities;
        const items = sortedEntities.filter(filterEntity).map(mapEntityToActionItem);
        if (prefixActionListItemDescriptor) items.unshift(prefixActionListItemDescriptor);
        return items;
    }, [
        selectedFirst,
        entities,
        selectedIds,
        inputValue,
        prefixActionListItemDescriptor
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stickyWrapper.StickyWrapper), {
        children: [
            !hideFilter && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                        label: filterLabel,
                        value: inputValue,
                        disabled: readonly,
                        onChange: setInputValue
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ActionList), {
                items: actionItems,
                ...actionListProps
            })
        ]
    });
}
exports.default = EntitiesList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","../../utils/stringUtils":"4gVdA","../extensions/Icon":"eHSf0","../SearchTextField/SearchTextField":"k5bRy","../StickyWrapper/StickyWrapper":"dIiqP","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dIiqP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyWrapper", ()=>StickyWrapper);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const StickyWrapper = (0, _styledComponentsDefault.default).div`
  position: relative;

  & > div:first-of-type {
    position: sticky;
    top: 0;
    background-color: var(--p-surface);
    z-index: var(--p-z-1);
    // use negative margins to hide the box shadow of the popover when scrolling
    padding: var(--p-space-2) var(--p-space-4);
    margin: 0 calc(-1 * var(--p-space-4));
  }
`;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"54xm8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _checkmarkGreenSvg = require("../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _subtractRedSvg = require("../../../assets/icons/subtract-red.svg");
var _subtractRedSvgDefault = parcelHelpers.interopDefault(_subtractRedSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const ReviewStatusIcons = {
    APPROVED: (0, _checkmarkGreenSvgDefault.default),
    REJECTED: (0, _subtractRedSvgDefault.default),
    NOT_READY: undefined,
    REVIEW_REQUIRED: undefined
};
const CustomerApprovalStatus = (props)=>{
    const { customer, detailed, ...rest } = props;
    const { review_status } = customer;
    const f = (0, _useFormatMessageDefault.default)();
    const icon = ReviewStatusIcons[review_status];
    const title = f(`review.status.${review_status}`);
    // in detailed view - render status with a label
    if (detailed) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        wrap: false,
        blockAlign: "center",
        children: [
            icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: icon,
                height: "16px",
                width: "16px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: title
            })
        ]
    });
    if (review_status !== "APPROVED" && review_status !== "REJECTED") return null;
    // in status mode - render status as an icon with a tooltip
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
            content: title,
            preferredPosition: "above",
            dismissOnMouseOut: true,
            children: icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: icon,
                height: "16px",
                width: "16px"
            })
        })
    });
};
exports.default = CustomerApprovalStatus;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../../assets/icons/checkmark-green.svg":"8HW5l","../../../assets/icons/subtract-red.svg":"5bCre","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5bCre":[function(require,module,exports) {
module.exports = require("fa95937befa3436f").getBundleURL("kEMsi") + "subtract-red.17c73de5.svg";

},{"fa95937befa3436f":"75UoR"}],"dIEbw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
// arranges pairs of 2 elements (like label and value) in 2 columns
// the number of rows to display should be known in advanced
const DetailsGrid = (0, _styledComponentsDefault.default).div`
  display: grid;
  gap: var(--p-space-2) var(--p-space-4);

  grid-template-columns: repeat(2, max-content auto);
  grid-auto-flow: row dense;

  // select all the first X odd elements and move them to the first grid column
  & > *:nth-child(-2n + ${({ rows })=>rows * 2 - 1}) {
    grid-column: 1;
  }

  // select all the first X event elements and move them to the second grid column
  & > *:nth-child(-2n + ${({ rows })=>rows * 2}) {
    grid-column: 2;
  }

  // For small viewports layout in a single column
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    grid-template-columns: auto;
    gap: 0;

    & > * {
      grid-column: unset !important;
    }

    & > *:nth-child(even) {
      margin-bottom: var(--p-space-4);
    }
  }
`;
exports.default = DetailsGrid;

},{"styled-components":"eBrdC","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9VLEF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _statusBadge = require("../StatusBadge/StatusBadge");
var _statusBadgeDefault = parcelHelpers.interopDefault(_statusBadge);
const RISK_LEVEL_TO_STATUS = {
    LOW: "success",
    MEDIUM: "warning",
    HIGH: "critical",
    NOT_SET: "info" // use status info for "NOT_SET" since no status styles will be applied to all statues
};
const Risk = (props)=>{
    const { risk, labelSuffix } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!risk) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        children: "-"
    });
    const riskLabel = f(`risklabel.${risk}`);
    const displayLabel = labelSuffix ? `${riskLabel} ${labelSuffix}` : riskLabel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusBadgeDefault.default), {
        size: "xsmall",
        status: risk ? RISK_LEVEL_TO_STATUS[risk] : undefined,
        children: displayLabel.toUpperCase()
    });
};
exports.default = Risk;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../StatusBadge/StatusBadge":"ddW4c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ddW4c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _dashedBorderSvg = require("../../../assets/images/dashed-border.svg");
var _dashedBorderSvgDefault = parcelHelpers.interopDefault(_dashedBorderSvg);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
const StatusBadge = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBadge, {
        ...props
    });
};
const StyledBadge = (0, _styledComponentsDefault.default)((0, _badgeDefault.default))`
  & .Polaris-Badge {
    white-space: nowrap;
    border-style: solid;
    border-width: var(--p-border-width-2);
    --pc-badge-vertical-padding: var(--p-space-1);
  }

  & .Polaris-Badge--statusInfo {
    // hide border in order for SVG dashed border to render properly
    border: none;

    // add missing border with to internal padding in order to make the badge the same size as other statuses
    --pc-badge-vertical-padding: calc(var(--p-space-1) + var(--p-border-width-2));
    --pc-badge-horizontal-padding: calc(var(--p-space-2) + var(--p-border-width-2));

    // set background color to white
    background-color: var(--p-color-bg);

    // set background image as an SVG that will render the border (as in Figma design)
    background-image: url(${(0, _dashedBorderSvgDefault.default)});
  }

  & .Polaris-Badge--statusSuccess {
    border-color: var(--p-color-border-success);
    background-color: var(--p-color-bg-success-subdued);
  }

  & .Polaris-Badge--statusWarning {
    border-color: var(--p-color-border-caution);
    background-color: var(--p-color-bg-caution-subdued);
  }

  & .Polaris-Badge--statusCritical {
    border-color: var(--p-color-border-critical);
    background-color: var(--p-color-bg-critical-subdued);
  }
`;
exports.default = StatusBadge;

},{"react/jsx-runtime":"enbMA","styled-components":"eBrdC","../../../assets/images/dashed-border.svg":"4pUZx","../extensions/Badge":"9irVp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4pUZx":[function(require,module,exports) {
module.exports = require("7cdb1f4c5dedbff0").getBundleURL("kEMsi") + "dashed-border.505f1231.svg";

},{"7cdb1f4c5dedbff0":"75UoR"}],"hNpPP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _triangleFilledExclamationSvg = require("../../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _followup = require("../../../constants/followup");
var _useChangedState = require("../../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../../hooks/useQueryData");
var _useSnackbar = require("../../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _stringUtils = require("../../../utils/stringUtils");
var _util = require("../../../utils/util");
var _dateInput = require("../../DateInput/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
var _errorPanel = require("../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _popoverButton = require("../../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
const MIN_FOLLOWUP_DATE = new Date();
const FollowupSelect = (props)=>{
    const { customer, readonly } = props;
    const { follow_up_date, is_follow_up_expired } = customer;
    const [followupDate, setFollowupDate, changed] = (0, _useChangedStateDefault.default)(follow_up_date || "");
    const followupNotSet = (0, _util.isNil)(follow_up_date);
    const f = (0, _useFormatMessageDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const updateFollowupMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updateCustomerDetails(customer.id, {
            follow_up_date: followupDate
        }), {
        onSuccess: (response)=>{
            updateQueryData((queryData)=>queryData.follow_up_date = response.follow_up_date);
            setSnackbar(f("followup.select.success.message"));
        }
    });
    const followup = follow_up_date ? new Date(follow_up_date) : new Date();
    const maxFollowupDate = new Date(new Date(followup).setFullYear(followup.getFullYear() + (0, _followup.MAX_FOLLOWUP_INTERVAL_IN_MONTHS) / 12));
    const invalidDate = (0, _stringUtils.isEmptyString)(followupDate) || new Date(followupDate).getTime() < MIN_FOLLOWUP_DATE.getTime() || new Date(followupDate).getTime() > maxFollowupDate.getTime();
    const displayLabel = followupNotSet ? f("followup.select.empty.label") : is_follow_up_expired ? f("followup.select.expired.label", {
        followup
    }) : f("followup.select.label", {
        followup
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
        id: "followup-select",
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
            as: "span",
            fontWeight: "semibold",
            children: [
                " ",
                displayLabel
            ]
        }),
        size: "slim",
        textAlign: "left",
        plain: true,
        monochrome: true,
        useCaret: true,
        removeUnderline: true,
        disabled: readonly,
        icon: is_follow_up_expired ? (0, _triangleFilledExclamationSvgDefault.default) : undefined,
        onClose: ()=>{
            updateFollowupMutation.reset();
            setFollowupDate(follow_up_date || "");
        },
        render: (onClose)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: f("followup.select.title")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                            label: f("followup.select.title"),
                            labelHidden: true,
                            onChange: setFollowupDate,
                            minDate: MIN_FOLLOWUP_DATE,
                            maxDate: maxFollowupDate,
                            value: followupDate,
                            autoComplete: "off",
                            disabled: updateFollowupMutation.isLoading
                        }),
                        updateFollowupMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                            message: updateFollowupMutation.error,
                            actionTitle: f("followup.select.error-action"),
                            fieldID: "followup-select"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "2",
                            align: "end",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    disabled: updateFollowupMutation.isLoading,
                                    onClick: onClose,
                                    children: f("default.cancel")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    primary: true,
                                    loading: updateFollowupMutation.isLoading,
                                    disabled: invalidDate || !changed,
                                    onClick: ()=>updateFollowupMutation.mutate(undefined, {
                                            onSuccess: onClose
                                        }),
                                    children: f("default.save")
                                })
                            ]
                        })
                    ]
                })
            })
    });
};
exports.default = FollowupSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../../../api":"f6lXD","../../../constants/followup":"kBYmS","../../../hooks/useChangedState":"170jW","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useQueryData":"4laI9","../../../hooks/useSnackbar":"gQ3G9","../../../utils/stringUtils":"4gVdA","../../../utils/util":"4MniK","../../DateInput/DateInput":"6BAM5","../../ErrorPanel/ErrorPanel":"2hHqH","../../extensions/Button":"8exc0","../../PopoverButton/PopoverButton":"ihB8F","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kBYmS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERVALS_IN_MONTHS", ()=>INTERVALS_IN_MONTHS);
parcelHelpers.export(exports, "MAX_FOLLOWUP_INTERVAL_IN_MONTHS", ()=>MAX_FOLLOWUP_INTERVAL_IN_MONTHS);
const INTERVALS_IN_MONTHS = [
    6,
    12,
    24,
    60
]; // 6 months, 1 year, 2 years, 5 years
const MAX_FOLLOWUP_INTERVAL_IN_MONTHS = 60; // 5 years

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6BAM5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _browserUtils = require("../../utils/browserUtils");
var _dateUtils = require("../../utils/dateUtils");
var _stringUtils = require("../../utils/stringUtils");
const DateInput = (props)=>{
    const { minDate, maxDate, ...textFieldProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [isFocused, setIsFocused] = (0, _react.useState)(false);
    // Safari on desktop does not show a placeholder when value is empty (is shows the current date instead)
    // For this edge case, if isEmptySafari === true, render the input date as a text field with a placeholder
    const isEmptySafari = (0, _browserUtils.isSafari)() && (0, _stringUtils.isEmptyString)(textFieldProps.value) && !isFocused;
    const handleOnFocus = (0, _react.useCallback)((event)=>{
        setIsFocused(true);
        textFieldProps.onFocus && textFieldProps.onFocus(event);
    }, [
        textFieldProps.onFocus
    ]);
    const handleOnBlur = (0, _react.useCallback)((event)=>{
        setIsFocused(false);
        textFieldProps.onBlur && textFieldProps.onBlur(event);
    }, [
        textFieldProps.onBlur
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
        min: minDate ? (0, _dateUtils.formatDateInput)(minDate) : undefined,
        max: maxDate ? (0, _dateUtils.formatDateInput)(maxDate) : undefined,
        maxLength: 10,
        minLength: 10,
        type: isEmptySafari ? "text" : "date",
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        placeholder: f("common.date-input.placeholder"),
        ...textFieldProps
    });
};
exports.default = DateInput;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../utils/browserUtils":"4ShiW","../../utils/dateUtils":"euvUV","../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aEgFg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _archiveboxSvg = require("../../../../assets/icons/archivebox.svg");
var _archiveboxSvgDefault = parcelHelpers.interopDefault(_archiveboxSvg);
var _arrowDownRectangleSvg = require("../../../../assets/icons/arrow-down-rectangle.svg");
var _arrowDownRectangleSvgDefault = parcelHelpers.interopDefault(_arrowDownRectangleSvg);
var _foldersSvg = require("../../../../assets/icons/folders.svg");
var _foldersSvgDefault = parcelHelpers.interopDefault(_foldersSvg);
var _pencilSvg = require("../../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _restoreSvg = require("../../../../assets/icons/restore.svg");
var _restoreSvgDefault = parcelHelpers.interopDefault(_restoreSvg);
var _starFilledSvg = require("../../../../assets/icons/star-filled.svg");
var _starFilledSvgDefault = parcelHelpers.interopDefault(_starFilledSvg);
var _trashSvg = require("../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _permissions = require("../../../constants/permissions");
var _integrationHelpers = require("../../../helpers/integration.helpers");
var _useErrorParser = require("../../../hooks/useErrorParser");
var _useErrorParserDefault = parcelHelpers.interopDefault(_useErrorParser);
var _useFeatures = require("../../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useProjectPermissions = require("../../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
var _useQueryData = require("../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../../types/utilities");
var _actionsDropdown = require("../../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _addToProjectModal = require("../../CustomersListBulkActions/AddToProjectModal/AddToProjectModal");
var _addToProjectModalDefault = parcelHelpers.interopDefault(_addToProjectModal);
var _editCompanyCustomerInfoModal = require("../../EditCompanyCustomerInfoModal/EditCompanyCustomerInfoModal");
var _editCompanyCustomerInfoModalDefault = parcelHelpers.interopDefault(_editCompanyCustomerInfoModal);
var _editPersonCustomerDetailsModal = require("../../EditPersonCustomerDetailsModal/EditPersonCustomerDetailsModal");
var _editPersonCustomerDetailsModalDefault = parcelHelpers.interopDefault(_editPersonCustomerDetailsModal);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _customerArchiveConfirmation = require("./CustomerArchiveConfirmation");
var _customerArchiveConfirmationDefault = parcelHelpers.interopDefault(_customerArchiveConfirmation);
var _customerDeleteConfirmation = require("./CustomerDeleteConfirmation");
var _customerDeleteConfirmationDefault = parcelHelpers.interopDefault(_customerDeleteConfirmation);
var _planConversionModal = require("./PlanConversionModal");
var _planConversionModalDefault = parcelHelpers.interopDefault(_planConversionModal);
var _useDownload = require("./useDownload");
var _useDownloadDefault = parcelHelpers.interopDefault(_useDownload);
const CustomerActionsMenu = (props)=>{
    const { customer, isMonitoring } = props;
    const [showCustomerEditModal, toggleCustomerEditModal, closeCustomerEditModal] = (0, _useOpenCloseDefault.default)();
    const [showArchiveCustomerConfirm, toggleArchiveCustomerConfirm, closeArchiveCustomerConfirm] = (0, _useOpenCloseDefault.default)();
    const [showDeleteCustomerConfirm, toggleDeleteCustomerConfirm, closeDeleteCustomerConfirm] = (0, _useOpenCloseDefault.default)();
    const [showAddToProjectModal, toggleAddToProjectModal, closeAddToProjectModal] = (0, _useOpenCloseDefault.default)();
    const [showPlanConversionModal, togglePlanConversionModal, closePlanConversionModal] = (0, _useOpenCloseDefault.default)();
    const [planConversionMessage, setPlanConversionMessage] = (0, _react.useState)("");
    const parseError = (0, _useErrorParserDefault.default)(customer.type);
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { setQueryData } = (0, _useQueryDataDefault.default)((0, _utilities.getCustomerQueryKey)(customer));
    const { isCreateOrAddToProjectEnabled } = (0, _useProjectPermissionsDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const download = (0, _useDownloadDefault.default)();
    const downloadReportMutation = (0, _reactQuery.useMutation)(()=>download(`/customers/${customer.id}/report`));
    const restoreCustomerMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updateCustomerDetails(customer.id, {
            is_archived: false
        }), {
        onSuccess: async (response)=>setQueryData(response)
    });
    const downloadReport = ()=>downloadReportMutation.mutate();
    const restoreCustomer = ()=>restoreCustomerMutation.mutate();
    const openPlanConversionModal = (content)=>{
        setPlanConversionMessage(content);
        togglePlanConversionModal();
    };
    const editableCustomer = customer.type === "person" || customer.type === "company" && customer.is_manual;
    const editCustomerInfoAction = {
        content: customer.type === "person" ? f("common.buttons.actions.edit-person-info") : f("common.buttons.actions.edit-company-info"),
        onAction: toggleCustomerEditModal,
        image: (0, _pencilSvgDefault.default),
        disabled: customer.is_archived
    };
    const wrapAMLPackageAction = (action, planConversionContent, featureEnabled)=>{
        if (featureEnabled) return action;
        else // Show info about upgrading AML plan/package if needed feature is NOT enabled, and
        // feature for "nudging" the user/org about upgrading its AML package IS enabled
        return {
            ...action,
            onAction: ()=>openPlanConversionModal(planConversionContent),
            suffix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _starFilledSvgDefault.default)
            }),
            helpText: f("plan-conversion.customer-action.label")
        };
    };
    const isCustomerFromVitecProject = Boolean(customer.projects?.some((0, _integrationHelpers.isVitecProject)));
    const actions = [];
    if (!features.CUSTOMER__HIDE_DOWNLOAD_REPORT_BUTTON) actions.push({
        content: f("common.buttons.actions.download.report"),
        onAction: downloadReport,
        image: (0, _arrowDownRectangleSvgDefault.default),
        disabled: downloadReportMutation.isLoading
    });
    if (editableCustomer) actions.push(editCustomerInfoAction);
    const addToProjectAction = wrapAMLPackageAction({
        content: f("bulk.actions.add-to-existing-project.label"),
        image: (0, _foldersSvgDefault.default),
        onAction: toggleAddToProjectModal,
        disabled: customer.is_archived
    }, f("plan-conversion.add-to-projects.description"), isCreateOrAddToProjectEnabled);
    // hide action to add a customer to a project if the customer has one or mote Vitec projects associated with them
    if (!isCustomerFromVitecProject && addToProjectAction) actions.push(addToProjectAction);
    if (customer.is_archived) {
        actions.push({
            content: f("common.buttons.actions.restore-customer"),
            onAction: restoreCustomer,
            image: (0, _restoreSvgDefault.default),
            disabled: restoreCustomerMutation.isLoading
        });
        if (isPermittedTo((0, _permissions.PERMISSIONS_TYPES).DELETE_CUSTOMER)) actions.push({
            content: f("common.buttons.actions.delete-customer"),
            onAction: toggleDeleteCustomerConfirm,
            image: (0, _trashSvgDefault.default)
        });
    }
    if (!customer.is_archived) actions.push({
        content: f("common.buttons.actions.archive-customer"),
        onAction: toggleArchiveCustomerConfirm,
        image: (0, _archiveboxSvgDefault.default)
    });
    const isLoading = downloadReportMutation.isLoading || restoreCustomerMutation.isLoading;
    const isError = downloadReportMutation.isError || restoreCustomerMutation.isError;
    const { generalError = f("common.errors.generic") } = parseError(downloadReportMutation.error || restoreCustomerMutation.error);
    const actionLabel = restoreCustomerMutation.isError ? f("common.buttons.actions.restore-customer").toLocaleLowerCase() : f("common.buttons.actions.download.report").toLocaleLowerCase();
    const displayMessage = f("common.errors.generic.failed-action", {
        actionLabel,
        message: generalError
    });
    const resetErroneousMutation = ()=>{
        if (downloadReportMutation.isError) downloadReportMutation.reset();
        else if (restoreCustomerMutation.isError) restoreCustomerMutation.reset();
    };
    // if there's only 1 action - set cutoff to 1 (which will render the single action menu as a button)
    // otherwise, set cutoff to 0 (which will render the action menu as a dropdown menu)
    const showSingleActionAsButton = actions.length === 1 ? 1 : 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: actions,
                loading: isLoading,
                cutoff: showSingleActionAsButton,
                primary: true,
                size: "medium"
            }),
            showCustomerEditModal && (0, _utilities.isPersonCustomerDetails)(customer) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editPersonCustomerDetailsModalDefault.default), {
                person: customer,
                onClose: closeCustomerEditModal
            }),
            showCustomerEditModal && !(0, _utilities.isPersonCustomerDetails)(customer) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editCompanyCustomerInfoModalDefault.default), {
                companyCustomer: customer,
                onClose: closeCustomerEditModal
            }),
            showAddToProjectModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addToProjectModalDefault.default), {
                customers: [
                    customer
                ],
                hideCustomersCount: true,
                onClose: closeAddToProjectModal
            }),
            isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: displayMessage,
                error: true,
                onDismiss: resetErroneousMutation
            }),
            showArchiveCustomerConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerArchiveConfirmationDefault.default), {
                customer: customer,
                isMonitoring: isMonitoring,
                onClose: closeArchiveCustomerConfirm
            }),
            showDeleteCustomerConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerDeleteConfirmationDefault.default), {
                customer: customer,
                onClose: closeDeleteCustomerConfirm
            }),
            showPlanConversionModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planConversionModalDefault.default), {
                onClose: closePlanConversionModal,
                content: planConversionMessage
            })
        ]
    });
};
exports.default = CustomerActionsMenu;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../assets/icons/archivebox.svg":"cyEGJ","../../../../assets/icons/arrow-down-rectangle.svg":"TDXIu","../../../../assets/icons/folders.svg":"7c7Qz","../../../../assets/icons/pencil.svg":"gEWpJ","../../../../assets/icons/restore.svg":"hwxcs","../../../../assets/icons/star-filled.svg":"hGLQA","../../../../assets/icons/trash.svg":"jqW55","../../../api":"f6lXD","../../../constants/permissions":"jhCn5","../../../helpers/integration.helpers":"keU9B","../../../hooks/useErrorParser":"daNOL","../../../hooks/useFeatures":"hvBWb","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useOpenClose":"idooG","../../../hooks/usePermissions":"4CdYX","../../../hooks/useProjectPermissions":"23Tgs","../../../hooks/useQueryData":"4laI9","../../../types/utilities":"6zLpB","../../ActionsDropdown/ActionsDropdown":"izRYG","../../CustomersListBulkActions/AddToProjectModal/AddToProjectModal":"hXY5u","../../EditCompanyCustomerInfoModal/EditCompanyCustomerInfoModal":"3O9ld","../../EditPersonCustomerDetailsModal/EditPersonCustomerDetailsModal":"fWBcX","../../extensions/Icon":"eHSf0","./CustomerArchiveConfirmation":"lyJ2u","./CustomerDeleteConfirmation":"hhSh7","./PlanConversionModal":"6OBFD","./useDownload":"cwQpd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"TDXIu":[function(require,module,exports) {
module.exports = require("a055acfff091e041").getBundleURL("kEMsi") + "arrow-down-rectangle.921533ac.svg";

},{"a055acfff091e041":"75UoR"}],"7c7Qz":[function(require,module,exports) {
module.exports = require("ceeddc304fe5a55a").getBundleURL("kEMsi") + "folders.86995256.svg";

},{"ceeddc304fe5a55a":"75UoR"}],"hwxcs":[function(require,module,exports) {
module.exports = require("a76d2a8ada919f0f").getBundleURL("kEMsi") + "restore.98d9fc7c.svg";

},{"a76d2a8ada919f0f":"75UoR"}],"hGLQA":[function(require,module,exports) {
module.exports = require("661e083967fb3dc8").getBundleURL("kEMsi") + "star-filled.9bf97db3.svg";

},{"661e083967fb3dc8":"75UoR"}],"jqW55":[function(require,module,exports) {
module.exports = require("6fc5f7168f1d99b1").getBundleURL("kEMsi") + "trash.1cf834a7.svg";

},{"6fc5f7168f1d99b1":"75UoR"}],"jhCn5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PERMISSIONS_TYPES", ()=>PERMISSIONS_TYPES);
parcelHelpers.export(exports, "MLRO_GROUP_KEY", ()=>MLRO_GROUP_KEY);
parcelHelpers.export(exports, "COMPLIANCE_OFFICER_GROUP_KEY", ()=>COMPLIANCE_OFFICER_GROUP_KEY);
var PERMISSIONS_TYPES;
(function(PERMISSIONS_TYPES) {
    PERMISSIONS_TYPES["DELETE_CUSTOMER"] = "delete_subject";
    PERMISSIONS_TYPES["ADMIN_USER"] = "admin_user";
    PERMISSIONS_TYPES["EDIT_SETTINGS"] = "edit_settings";
})(PERMISSIONS_TYPES || (PERMISSIONS_TYPES = {}));
const MLRO_GROUP_KEY = "MLRO";
const COMPLIANCE_OFFICER_GROUP_KEY = "COMPLIANCE_OFFICER";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4CdYX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
const usePermissions = ()=>{
    const { user } = (0, _useAuthDefault.default)();
    const permissions = user?.permissions || [];
    const isPermittedTo = (permission)=>permissions.includes(permission);
    return {
        isPermittedTo
    };
};
exports.default = usePermissions;

},{"./useAuth":"k9r0q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"izRYG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const ActionsDropdown = (props)=>{
    const { items = [], sections, hideTitle, hideIcon, forceOpen = false, icon, iconWidth, iconHeight, title, size = "slim", cutoff = 0, // distribution,
    ...buttonProps } = props;
    const [popoverActive, togglePopoverActive, closePopover] = (0, _useOpenCloseDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const showButtonGroup = cutoff > 0;
    const showPopover = items.length - cutoff > 0;
    const buttonIcon = hideIcon ? undefined : icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
        source: icon,
        width: iconWidth || "12px",
        height: iconHeight || "12px"
    }) : (0, _polarisIcons.HorizontalDotsMinor);
    const actionsLink = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        icon: buttonIcon,
        size: size,
        onClick: togglePopoverActive,
        ...buttonProps,
        children: hideTitle ? undefined : title || f("common.buttons.actions.button")
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "2",
        children: [
            showButtonGroup && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ButtonGroup), {
                children: items.slice(0, cutoff).map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                        active: Boolean(item.suffix || item.helpText),
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "1",
                            blockAlign: "center",
                            wrap: false,
                            children: [
                                item.suffix,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    color: "subdued",
                                    children: item.helpText
                                })
                            ]
                        }),
                        preferredPosition: "mostSpace",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            onClick: item.onAction,
                            size: size,
                            icon: item.icon || item.image || item.prefix,
                            ...item,
                            children: item.content
                        }, index)
                    }, index))
            }),
            showPopover && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover), {
                active: popoverActive || forceOpen,
                activator: actionsLink,
                onClose: closePopover,
                ariaHaspopup: false,
                sectioned: false,
                preferredAlignment: "left",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover).Pane, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ActionList), {
                        items: items.slice(cutoff),
                        sections: sections,
                        onActionAnyItem: closePopover
                    })
                })
            })
        ]
    });
};
exports.default = ActionsDropdown;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hXY5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _folderSvg = require("../../../../assets/icons/folder.svg");
var _folderSvgDefault = parcelHelpers.interopDefault(_folderSvg);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../../constants/queries-keys");
var _routes = require("../../../constants/routes");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _errorPanel = require("../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _projectsResourceList = require("./ProjectsResourceList");
var _projectsResourceListDefault = parcelHelpers.interopDefault(_projectsResourceList);
const AddToProjectModal = (props)=>{
    const { customers, hideCustomersCount, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const [showSuccessToast, toggleSuccessToast, closeSuccessToast] = (0, _useOpenCloseDefault.default)();
    const [selectedProjectsIds, setSelectedProjectIds] = (0, _react.useState)([]);
    const [selectedProject, setSelectedProject] = (0, _react.useState)();
    const [page, setPage] = (0, _react.useState)(0);
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customers[0]);
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        selectedProjectsIds[0]
    ]);
    const assignToProjectMutation = (0, _reactQuery.useMutation)(async ()=>{
        const project = await (0, _apiDefault.default).getProject(selectedProjectsIds[0]);
        const existingCustomersIds = project.customers.map((customer)=>customer.id);
        const selectedCustomersIds = customers.map((customer)=>customer.id);
        const customersIds = [
            ...new Set([
                ...existingCustomersIds,
                ...selectedCustomersIds
            ])
        ];
        return (0, _apiDefault.default).updateProject(selectedProjectsIds[0], {
            customer_ids: customersIds
        });
    }, {
        onSuccess: (updatedProject)=>{
            setQueryData(updatedProject);
            setSelectedProject(updatedProject);
            // if a single customer was provided, update the customer details
            if (customers.length === 1) updateQueryData((queryData)=>queryData.projects = [
                    ...queryData.projects || [],
                    {
                        ...updatedProject,
                        customer_count: updatedProject.customers.length
                    }
                ]);
            toggleSuccessToast();
        }
    });
    const saveAction = {
        content: f("default.add"),
        onAction: ()=>assignToProjectMutation.mutate(),
        disabled: assignToProjectMutation.isLoading || selectedProjectsIds.length === 0,
        loading: assignToProjectMutation.isLoading
    };
    const cancelAction = {
        content: f("default.cancel"),
        onAction: ()=>onClose(),
        disabled: assignToProjectMutation.isLoading
    };
    const navigateToProjectAction = {
        content: selectedProject?.name || "",
        icon: (0, _folderSvgDefault.default),
        onAction: ()=>history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
                id: selectedProject.id
            })),
        disabled: !selectedProject
    };
    const handleToastDismiss = ()=>{
        closeSuccessToast();
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
                // if the toast is visible, hide the modal;
                open: !showSuccessToast,
                title: f("projects.modal.title"),
                onClose: onClose,
                primaryAction: saveAction,
                secondaryActions: [
                    cancelAction
                ],
                onScrolledToBottom: ()=>setPage(page + 1),
                footer: hideCustomersCount ? undefined : f("common.labels.selected-customers-count", {
                    count: customers.length
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectsResourceListDefault.default), {
                            selectedIds: selectedProjectsIds,
                            page: page,
                            resetPage: ()=>setPage(0),
                            onSelectionChange: setSelectedProjectIds
                        })
                    }),
                    assignToProjectMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: assignToProjectMutation.error
                    })
                ]
            }),
            showSuccessToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: f("projects.modal.success.message", {
                    count: customers.length
                }),
                action: navigateToProjectAction,
                onDismiss: handleToastDismiss,
                duration: 8000
            })
        ]
    });
};
exports.default = AddToProjectModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../assets/icons/folder.svg":"b2aWC","../../../api":"f6lXD","../../../constants/queries-keys":"6hYSF","../../../constants/routes":"ihtm8","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useOpenClose":"idooG","../../../hooks/useQueryData":"4laI9","../../ErrorPanel/ErrorPanel":"2hHqH","./ProjectsResourceList":"cXTQM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b2aWC":[function(require,module,exports) {
module.exports = require("78d6877ebebf1946").getBundleURL("kEMsi") + "folder.c9149cec.svg";

},{"78d6877ebebf1946":"75UoR"}],"cXTQM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../../constants/queries-keys");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _entitiesResourceList = require("../../EntitiesResourceList/EntitiesResourceList");
var _entitiesResourceListDefault = parcelHelpers.interopDefault(_entitiesResourceList);
var _projectName = require("../../ProjectName/ProjectName");
var _projectNameDefault = parcelHelpers.interopDefault(_projectName);
const ProjectsResourceList = (props)=>{
    const { ...resourceListProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entitiesResourceListDefault.default), {
        getEntities: (searchParams)=>// exclude Vitec projects when adding customers to existing projects
            // since customers are added to these projects from Vitec
            (0, _apiDefault.default).getProjects({
                ...searchParams,
                status: "ACTIVE",
                isVitec: "0"
            }).then((response)=>response.projects),
        queryKey: (0, _queriesKeys.QUERIES_KEYS).PROJECTS,
        queryPlaceholder: f("projects.modal.filters.search.hint"),
        renderItem: (projectListItem)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectNameDefault.default), {
                project: projectListItem
            }),
        emptySearchState: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.EmptySearchResult), {
            title: f("projects.modal.empty.search.title"),
            description: f("projects.modal.empty.search.description"),
            withIllustration: true
        }),
        ...resourceListProps
    });
};
exports.default = ProjectsResourceList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../api":"f6lXD","../../../constants/queries-keys":"6hYSF","../../../hooks/useFormatMessage":"8Y8fq","../../EntitiesResourceList/EntitiesResourceList":"f9nUU","../../ProjectName/ProjectName":"IXkOY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f9nUU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _durations = require("../../constants/durations");
var _pagination = require("../../constants/pagination");
var _useDebounce = require("../../hooks/useDebounce");
var _useDebounceDefault = parcelHelpers.interopDefault(_useDebounce);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
/**
 * This list should be used in conjunction with a Modal where the Modal keeps a current page state
 * and increases it when onScrolledToBottom is triggered.
 */ function EntitiesResourceList(props) {
    const { getEntities, queryKey, allowMultiple, queryPlaceholder, renderItem, selectedIds, existingEntities = [], page, resetPage, onSelectionChange, ...rest } = props;
    const [q, setQ] = (0, _react.useState)("");
    const [entities, setEntities] = (0, _react.useState)(existingEntities);
    const [queryText, setQueryText] = (0, _react.useState)(q);
    (0, _useDebounceDefault.default)(()=>setQ(queryText), (0, _durations.QUERY_SEARCH_DEBOUNCE_DELAY), [
        queryText
    ]);
    const searchParams = {
        offset: (0, _pagination.CUSTOMERS_PER_PAGE) * page,
        q,
        limit: (0, _pagination.CUSTOMERS_PER_PAGE)
    };
    const { isLoading, isError, error, data } = (0, _reactQuery.useQuery)([
        queryKey,
        ...Object.values(searchParams)
    ], ()=>{
        return getEntities(searchParams);
    });
    const existingEntitiesIds = existingEntities.map((entity)=>entity.id);
    (0, _react.useEffect)(()=>{
        const hasExistingEntities = existingEntities?.length > 0;
        const entities = data || [];
        const filteredEntities = hasExistingEntities ? entities.filter((entity)=>!existingEntitiesIds.includes(entity.id)) : entities;
        setEntities((currentEntities)=>[
                ...currentEntities,
                ...filteredEntities
            ]);
    }, [
        data
    ]);
    // "All" is a value that is passed by ResourceList when selecting all values - it's disabled in this component
    // but the type for it still remains.
    const handleSelectionChange = (newSelectedIds)=>{
        if (newSelectedIds === "All") return;
        if (allowMultiple || selectedIds.length === 0) onSelectionChange(newSelectedIds);
        else onSelectionChange(newSelectedIds.filter((id)=>!selectedIds.includes(id)));
    };
    const handleFilterQueryChange = (filterInput)=>{
        setQueryText(filterInput);
        setEntities(existingEntities);
        resetPage();
    };
    const toggleResourceItemSelection = (entityId)=>{
        if (selectedIds.includes(entityId)) handleSelectionChange(selectedIds.filter((id)=>id !== entityId));
        else handleSelectionChange([
            ...selectedIds,
            entityId
        ]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ResourceList), {
                items: entities,
                idForItem: (entity)=>entity.id,
                renderItem: (entity)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ResourceItem), {
                        id: entity.id,
                        url: "",
                        onClick: ()=>toggleResourceItemSelection(entity.id),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                            alignment: "center",
                            spacing: "none",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                    fill: true,
                                    children: renderItem(entity)
                                }),
                                !allowMultiple && selectedIds.includes(entity.id) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                    source: (0, _polarisIcons.TickMinor),
                                    color: "highlight"
                                })
                            ]
                        })
                    }),
                loading: isLoading,
                selectable: allowMultiple,
                selectedItems: selectedIds,
                onSelectionChange: handleSelectionChange,
                showHeader: false,
                isFiltered: q !== "",
                filterControl: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Filters), {
                    queryPlaceholder: queryPlaceholder,
                    focused: true,
                    queryValue: queryText,
                    onQueryChange: handleFilterQueryChange,
                    onQueryClear: ()=>handleFilterQueryChange(""),
                    onClearAll: ()=>handleFilterQueryChange(""),
                    filters: []
                }),
                ...rest
            }),
            isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: error
            })
        ]
    });
}
const StyledWrapper = (0, _styledComponentsDefault.default).div`
  position: relative;

  & .Polaris-ResourceList__FiltersWrapper {
    position: sticky;
    top: 0;
    z-index: 10;
    background: var(--p-surface);
  }
`;
exports.default = EntitiesResourceList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../constants/durations":"5sjIW","../../constants/pagination":"e05H0","../../hooks/useDebounce":"i1Evt","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"IXkOY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _projectSvg = require("../../../assets/icons/project.svg");
var _projectSvgDefault = parcelHelpers.interopDefault(_projectSvg);
var _routes = require("../../constants/routes");
var _integrationHelpers = require("../../helpers/integration.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _externalNavigationLink = require("../ExternalNavigationLink/ExternalNavigationLink");
var _externalNavigationLinkDefault = parcelHelpers.interopDefault(_externalNavigationLink);
const ProjectName = (props)=>{
    const { project, renderAsLink } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const name = project.name;
    const isVitec = (0, _integrationHelpers.isVitecProject)(project);
    const vitecUrl = project.integrations?.vitec_data?.vitec_url;
    const projectDisplayName = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _projectSvgDefault.default),
                width: "20px",
                height: "20px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledProjectName, {
                children: name
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "2",
        blockAlign: "center",
        wrap: false,
        children: [
            renderAsLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
                    id: project.id
                }),
                children: projectDisplayName
            }),
            !renderAsLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: projectDisplayName
            }),
            isVitec && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalNavigationLinkDefault.default), {
                url: vitecUrl,
                children: f("project.button.imported-from-vitec")
            })
        ]
    });
};
const StyledProjectName = (0, _styledComponentsDefault.default).div`
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.default = ProjectName;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/project.svg":"b4tRC","../../constants/routes":"ihtm8","../../helpers/integration.helpers":"keU9B","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","../ExternalNavigationLink/ExternalNavigationLink":"51TTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b4tRC":[function(require,module,exports) {
module.exports = require("382b79ae0f04cbd5").getBundleURL("kEMsi") + "project.fc43e938.svg";

},{"382b79ae0f04cbd5":"75UoR"}],"51TTg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _externalLinkWhiteIconSvg = require("../../../assets/icons/external-link-white-icon.svg");
var _externalLinkWhiteIconSvgDefault = parcelHelpers.interopDefault(_externalLinkWhiteIconSvg);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const ExternalNavigationLink = (props)=>{
    const { children, ...linkProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
            external: true,
            removeUnderline: true,
            ...linkProps,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                wrap: false,
                spacing: "extraTight",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _externalLinkWhiteIconSvgDefault.default)
                    })
                ]
            })
        })
    });
};
const StyledButton = (0, _styledComponentsDefault.default).div`
  & .Polaris-Stack {
    color: var(--p-text-on-primary);
    background-color: var(--kdk-blue-500);
    border-radius: var(--p-border-radius-05);
    line-height: 1;

    &:hover {
      background-color: var(--kdk-blue-525);
    }

    &:active {
      background-color: var(--kdk-blue-550);
    }
  }
`;
exports.default = ExternalNavigationLink;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/external-link-white-icon.svg":"81MLk","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"81MLk":[function(require,module,exports) {
module.exports = require("a230add9d49f7a4f").getBundleURL("kEMsi") + "external-link-white-icon.3cdd0fca.svg";

},{"a230add9d49f7a4f":"75UoR"}],"lyJ2u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _displayHelpers = require("../../../helpers/display.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../../hooks/useQueryData");
var _confirmAction = require("../../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const CustomerArchiveConfirmation = (props)=>{
    const { customer, isMonitoring, onClose } = props;
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const f = (0, _useFormatMessageDefault.default)();
    const name = (0, _displayHelpers.getCustomerName)(customer);
    const content = isMonitoring ? f("archive-customer.confirmation-modal.description.monitoring", {
        name
    }) : f("archive-customer.confirmation-modal.description", {
        name
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        title: f("archive-customer.confirmation-modal.title"),
        description: content,
        apiCall: ()=>(0, _apiDefault.default).archiveCustomer(customer.id),
        onSuccess: ()=>updateQueryData((queryData)=>queryData.is_archived = true),
        onNo: onClose,
        actionTitle: f("archive-customer.confirmation-modal.labels.button.archive", {
            name
        }),
        isDestructive: true
    });
};
exports.default = CustomerArchiveConfirmation;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../api":"f6lXD","../../../helpers/display.helpers":"2q3xY","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useQueryData":"4laI9","../../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hhSh7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _routes = require("../../../constants/routes");
var _displayHelpers = require("../../../helpers/display.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSnackbar = require("../../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _confirmAction = require("../../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const CustomerDeleteConfirmation = (props)=>{
    const { customer, onClose } = props;
    const history = (0, _reactRouterDom.useHistory)();
    const f = (0, _useFormatMessageDefault.default)();
    const name = (0, _displayHelpers.getCustomerName)(customer);
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const handleDeleteSuccess = ()=>{
        setSnackbar(f("delete-customer.confirmation-modal.success.message", {
            name
        }));
        history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).HOME));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        title: f("delete-customer.confirmation-modal.title"),
        description: f("delete-customer.confirmation-modal.description", {
            name
        }),
        apiCall: ()=>(0, _apiDefault.default).deleteCustomers({
                customer_ids: [
                    customer.id
                ]
            }),
        onSuccess: handleDeleteSuccess,
        onNo: onClose,
        actionTitle: f("delete-customer.confirmation-modal.labels.button.delete", {
            name
        }),
        isDestructive: true
    });
};
exports.default = CustomerDeleteConfirmation;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../../../api":"f6lXD","../../../constants/routes":"ihtm8","../../../helpers/display.helpers":"2q3xY","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useSnackbar":"gQ3G9","../../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6OBFD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _planConversionBanner = require("../../PlanConversionBanner/PlanConversionBanner");
var _planConversionBannerDefault = parcelHelpers.interopDefault(_planConversionBanner);
const PlanConversionModal = (props)=>{
    const { onClose, ...bannerProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        title: f("plan-conversion.modal.title"),
        onClose: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planConversionBannerDefault.default), {
                ...bannerProps
            })
        })
    });
};
exports.default = PlanConversionModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","../../PlanConversionBanner/PlanConversionBanner":"78R1i","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"78R1i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _starFilledSvg = require("../../../assets/icons/star-filled.svg");
var _starFilledSvgDefault = parcelHelpers.interopDefault(_starFilledSvg);
var _externalUrls = require("../../constants/external-urls");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const PlanConversionBanner = (props)=>{
    const { content } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _starFilledSvgDefault.default),
                width: "30px",
                height: "30px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: content
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                url: (0, _externalUrls.PLAN_CONVERSION_PAGE),
                external: true,
                children: f("plan-conversion.banner.labels.link")
            })
        ]
    });
};
exports.default = PlanConversionBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/star-filled.svg":"hGLQA","../../constants/external-urls":"bvBLe","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cwQpd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDownload);
var _downloadUtils = require("../../../utils/downloadUtils");
var _downloadUtilsDefault = parcelHelpers.interopDefault(_downloadUtils);
function useDownload() {
    const performDownload = (url, filename)=>{
        const download_url = `${"https://services.dev.beaufort.io/v2"}${url}`;
        return (0, _downloadUtilsDefault.default)(download_url, filename);
    };
    return performDownload;
}

},{"../../../utils/downloadUtils":"kTJ5o","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kTJ5o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFetch = require("../hooks/useFetch");
var _useFetchDefault = parcelHelpers.interopDefault(_useFetch);
var _filenameUtils = require("./filenameUtils");
const DEFAULT_FILE_NAME = "default_file.pdf";
const download = (url, filename)=>{
    const fetch = (0, _useFetchDefault.default)();
    return new Promise((resolve, reject)=>{
        fetch(url).then((response)=>{
            response.arrayBuffer().then((data)=>{
                if (response.status !== 200) reject(response.statusText);
                else {
                    const headers = response.headers;
                    const link = document.createElement("a");
                    const type = headers.get("content-type");
                    link.href = window.URL.createObjectURL(new Blob([
                        data
                    ], {
                        type
                    }));
                    link.style.display = "none";
                    link.setAttribute("download", filename || extractFilenameFromHeaders(headers));
                    document.body.appendChild(link);
                    link.click();
                    resolve(true);
                }
            }).catch((e)=>reject(e));
        }).catch((e)=>reject(e));
    });
};
const extractFilenameFromHeaders = (headers)=>{
    if (headers.has("content-disposition")) {
        const headerFilename = headers.get("content-disposition") || "";
        return (0, _filenameUtils.cleanupFilename)(headerFilename.split('"')[1]) || "default_file.pdf";
    } else return DEFAULT_FILE_NAME;
};
exports.default = download;

},{"../hooks/useFetch":"9uRF8","./filenameUtils":"2FnJx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9uRF8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
const isHeadersAMap = (headers)=>{
    return headers.get !== undefined;
};
const useFetch = ()=>{
    const augmentedFetch = (input, init)=>{
        const fetchInit = init || {};
        if (fetchInit.headers) {
            if (isHeadersAMap(fetchInit.headers)) for(const header in (0, _apiDefault.default).defaults.headers)fetchInit.headers.set(header, (0, _apiDefault.default).defaults.headers[header]);
            else for(const header in (0, _apiDefault.default).defaults.headers)fetchInit.headers[header] = (0, _apiDefault.default).defaults.headers[header];
        } else fetchInit.headers = (0, _apiDefault.default).defaults.headers;
        return (0, _apiDefault.default).defaults.fetch(input, fetchInit);
    };
    return augmentedFetch;
};
exports.default = useFetch;

},{"../api":"f6lXD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2FnJx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPDFAttachment", ()=>isPDFAttachment);
parcelHelpers.export(exports, "addSuffixToFilename", ()=>addSuffixToFilename);
parcelHelpers.export(exports, "cleanupFilename", ()=>cleanupFilename);
parcelHelpers.export(exports, "convertToValidFilename", ()=>convertToValidFilename);
var _stringUtils = require("./stringUtils");
const isPDFAttachment = (attachment)=>attachment.filename.toLowerCase().endsWith(".pdf");
const addSuffixToFilename = (filename = "", suffix)=>{
    if ((0, _stringUtils.isEmptyString)(suffix) || (0, _stringUtils.isEmptyString)(filename)) return filename;
    const extensionIndex = filename.lastIndexOf(".");
    return `${filename.substring(0, extensionIndex)}${suffix}${filename.substring(extensionIndex)}`;
};
const cleanupFilename = (filename)=>{
    if (filename) return filename.split("/").pop();
    return filename;
};
function convertToValidFilename(name) {
    return name.replace(/[\\/|\\:*?"<>]/g, "-");
}

},{"./stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c5E3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _criticalUpdatesBanner = require("./CriticalUpdatesBanner");
var _criticalUpdatesBannerDefault = parcelHelpers.interopDefault(_criticalUpdatesBanner);
var _followupExpiredBanner = require("./FollowupExpiredBanner");
var _followupExpiredBannerDefault = parcelHelpers.interopDefault(_followupExpiredBanner);
var _ownershipUpdatesBanner = require("./OwnershipUpdatesBanner");
var _ownershipUpdatesBannerDefault = parcelHelpers.interopDefault(_ownershipUpdatesBanner);
var _useCustomerDetailsBanners = require("./useCustomerDetailsBanners");
var _useCustomerDetailsBannersDefault = parcelHelpers.interopDefault(_useCustomerDetailsBanners);
const CustomerDetailsBanners = (props)=>{
    const { customer } = props;
    const { hasCriticalUpdates, hasOwnershipUpdates, hasFollowupDateExpired } = (0, _useCustomerDetailsBannersDefault.default)(customer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            hasCriticalUpdates && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _criticalUpdatesBannerDefault.default), {}),
            hasOwnershipUpdates && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipUpdatesBannerDefault.default), {}),
            hasFollowupDateExpired && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _followupExpiredBannerDefault.default), {
                customer: customer
            })
        ]
    });
};
exports.default = CustomerDetailsBanners;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","./CriticalUpdatesBanner":"agSG6","./FollowupExpiredBanner":"cVfn9","./OwnershipUpdatesBanner":"i9kYm","./useCustomerDetailsBanners":"5Qpgd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"agSG6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CriticalUpdatesBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "critical",
        title: f("details.banners.critical-update.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
            gap: "4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: f("details.banners.critical-update.content")
            })
        })
    });
};
exports.default = CriticalUpdatesBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cVfn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dateUtils = require("../../../utils/dateUtils");
const FollowupExpiredBanner = (props)=>{
    const { customer } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { follow_up_date } = customer;
    if (!(0, _dateUtils.isValidDate)(follow_up_date)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        title: f("common.banner.followup-expired.title"),
        status: "warning",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: f("common.banner.followup-expired.description", {
                followup: new Date(follow_up_date)
            })
        })
    });
};
exports.default = FollowupExpiredBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/dateUtils":"euvUV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i9kYm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _chevronRightSvg = require("../../../../assets/icons/chevron-right.svg");
var _chevronRightSvgDefault = parcelHelpers.interopDefault(_chevronRightSvg);
var _pageAnchors = require("../../../constants/page-anchors");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _browserUtils = require("../../../utils/browserUtils");
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const OwnershipUpdatesBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const navigateToCompanyOwnersSection = ()=>(0, _browserUtils.scrollInPage)((0, _pageAnchors.PAGE_ANCHORS).COMPANY_ROLES_AND_OWNERS_SECTION, {
            behavior: "smooth"
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Banner), {
        status: "info",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: f("details.banners.ownership-updates.content")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                blockAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                        plain: true,
                        onClick: navigateToCompanyOwnersSection,
                        children: f("details.banners.ownership-updates.link-label")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _chevronRightSvgDefault.default),
                        width: "8px",
                        height: "14px"
                    })
                ]
            })
        ]
    });
};
exports.default = OwnershipUpdatesBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../assets/icons/chevron-right.svg":"eUCtc","../../../constants/page-anchors":"4WmvA","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/browserUtils":"4ShiW","../../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Qpgd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilities = require("../../../types/utilities");
var _dateUtils = require("../../../utils/dateUtils");
var _useCompanyHasCriticalUpdates = require("./useCompanyHasCriticalUpdates");
var _useCompanyHasCriticalUpdatesDefault = parcelHelpers.interopDefault(_useCompanyHasCriticalUpdates);
const useCustomerDetailsBanners = (customer)=>{
    const { is_follow_up_expired, follow_up_date } = customer;
    const hasCriticalUpdates = (0, _useCompanyHasCriticalUpdatesDefault.default)((0, _utilities.isPersonCustomerDetails)(customer) ? undefined : customer);
    const hasFollowupDateExpired = is_follow_up_expired && (0, _dateUtils.isValidDate)(follow_up_date);
    const hasOwnershipUpdates = !(0, _utilities.isPersonCustomerDetails)(customer) && Boolean(customer.updates.ownership && customer.updates.ownership.length > 0);
    const showBanners = hasCriticalUpdates || hasFollowupDateExpired || hasOwnershipUpdates;
    return {
        showBanners,
        hasCriticalUpdates,
        hasFollowupDateExpired,
        hasOwnershipUpdates
    };
};
exports.default = useCustomerDetailsBanners;

},{"../../../types/utilities":"6zLpB","../../../utils/dateUtils":"euvUV","./useCompanyHasCriticalUpdates":"imh2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3P2R2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _plusMajorSvg = require("../../../assets/icons/plus-major.svg");
var _plusMajorSvgDefault = parcelHelpers.interopDefault(_plusMajorSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tagsEditorPopover = require("../TagsEditorPopover/TagsEditorPopover");
var _tagsEditorPopoverDefault = parcelHelpers.interopDefault(_tagsEditorPopover);
const CustomerTagPopover = (props)=>{
    const { customer, readonly } = props;
    const { allTags } = (0, _useTagsDefault.default)();
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const f = (0, _useFormatMessageDefault.default)();
    const updateCustomerTags = (customers)=>updateQueryData((queryData)=>queryData.labels = customers[0].labels);
    const assignTagMutation = (0, _reactQuery.useMutation)((labelsIds)=>(0, _apiDefault.default).batchSetLabelsOnCustomers({
            target_ids: [
                customer.id
            ],
            label_ids: labelsIds
        }), {
        onSuccess: ({ customers })=>updateCustomerTags(customers)
    });
    const createAndAssignTagMutation = (0, _reactQuery.useMutation)((title)=>(0, _apiDefault.default).batchCreateAndAssignLabelOnCustomers({
            target_ids: [
                customer.id
            ],
            title
        }), {
        onSuccess: ({ customers })=>{
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS
            ]);
            updateCustomerTags(customers);
        }
    });
    const isLoading = assignTagMutation.isLoading || createAndAssignTagMutation.isLoading;
    const handleSelectionChange = async (selectedTags)=>await assignTagMutation.mutate(selectedTags.map((tag)=>tag.id));
    const createTagAndAssign = async (text)=>await createAndAssignTagMutation.mutate(text);
    const hasTags = Boolean(customer.labels && customer.labels.length > 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCustomerTagPopover, {
        tags: allTags,
        selectedTags: customer.labels,
        onSelectionChange: handleSelectionChange,
        onNewTag: createTagAndAssign,
        size: "slim",
        disabled: readonly || isLoading,
        // change button appearance based on if there are any assigned labels or not
        monochrome: true,
        removeUnderline: true,
        tooltip: hasTags ? f("tags.modal.title.edit-tags") : undefined,
        label: hasTags ? undefined : f("common.labels.create-tag"),
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _plusMajorSvgDefault.default),
            width: "10px",
            height: "10px",
            useMask: true
        })
    });
};
const StyledCustomerTagPopover = (0, _styledComponentsDefault.default)((0, _tagsEditorPopoverDefault.default))`
  & .Polaris-Button {
    border: var(--p-border-divider);
    border-radius: var(--p-border-radius-1);
    min-height: 1.325rem;
    box-shadow: none;
    min-width: 1.6rem;

    & *::before {
      margin: 0;
    }
  }

  & .Polaris-Button__Text {
    font-size: var(--p-font-size-75);
  }
`;
exports.default = CustomerTagPopover;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../assets/icons/plus-major.svg":"fCy4K","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../hooks/useTags":"31uzS","../extensions/Icon":"eHSf0","../TagsEditorPopover/TagsEditorPopover":"auX01","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fCy4K":[function(require,module,exports) {
module.exports = require("bd27bd81651690a7").getBundleURL("kEMsi") + "plus-major.5e3027f4.svg";

},{"bd27bd81651690a7":"75UoR"}],"31uzS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
// set the stale time to 1 hour to avoid multiple calls to getAllTags
const useTags = ()=>{
    const getAllTagsQuery = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS
    ], ()=>(0, _apiDefault.default).getAllLabels(), {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    const allTags = getAllTagsQuery.data?.labels || [];
    const tagsMap = (0, _react.useMemo)(()=>Object.fromEntries(allTags.map((tag)=>[
                tag.id,
                tag
            ])), [
        allTags
    ]);
    const findTag = (0, _react.useCallback)((tagId)=>tagsMap[tagId], [
        tagsMap
    ]);
    const findTagByTitle = (0, _react.useCallback)((title)=>allTags.find((tag)=>tag.title.nb === title || tag.title.en === title), [
        allTags
    ]);
    return {
        allTags,
        findTag,
        findTagByTitle
    };
};
exports.default = useTags;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"auX01":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tagSvg = require("../../../assets/icons/tag.svg");
var _tagSvgDefault = parcelHelpers.interopDefault(_tagSvg);
var _tagHelpers = require("../../helpers/tag.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _popoverButton = require("../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _popoverStickyWrapper = require("../PopoverStickyWrapper/PopoverStickyWrapper");
var _popoverStickyWrapperDefault = parcelHelpers.interopDefault(_popoverStickyWrapper);
var _tagsChoiceList = require("../TagsChoiceList/TagsChoiceList");
var _tagsChoiceListDefault = parcelHelpers.interopDefault(_tagsChoiceList);
var _newTagForm = require("./NewTagForm");
var _newTagFormDefault = parcelHelpers.interopDefault(_newTagForm);
const TagsEditorPopover = (props)=>{
    const { tags, selectedTags, partiallySelectedTags, onSelectionChange, onNewTag, enableReadonlySelection, ...popoverButtonProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [filterValue, setFilterValue] = (0, _react.useState)("");
    const handleNewTag = (onClose)=>async (tagTitle)=>{
            // use the given value from NewTagForm to create a tag were both languages (Norwegian and English)
            // have the same value
            onNewTag && await onNewTag({
                nb: tagTitle,
                en: tagTitle
            });
            onClose();
        };
    const filterTagExists = (0, _react.useMemo)(()=>tags?.some((tag)=>(0, _tagHelpers.getTagTitle)(tag).toLocaleLowerCase() === filterValue.toLocaleLowerCase()), [
        tags,
        filterValue
    ]);
    const disableAddButton = filterTagExists || popoverButtonProps.disabled;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
        label: f("tags.button.label"),
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _tagSvgDefault.default),
            useMask: true
        }),
        size: "slim",
        ...popoverButtonProps,
        render: (onClose)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverStickyWrapperDefault.default), {
                filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newTagFormDefault.default), {
                    disabled: disableAddButton,
                    onNewTag: onNewTag ? handleNewTag(onClose) : undefined,
                    onTagValueChange: setFilterValue
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsChoiceListDefault.default), {
                    tags: tags,
                    selectedTags: selectedTags,
                    partiallySelectedTags: partiallySelectedTags,
                    disabled: popoverButtonProps.disabled,
                    enableReadonlySelection: enableReadonlySelection,
                    filterValue: filterValue,
                    onSelectionChange: onSelectionChange
                })
            })
    });
};
exports.default = TagsEditorPopover;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../assets/icons/tag.svg":"jZ7nZ","../../helpers/tag.helpers":"ecpII","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","../PopoverButton/PopoverButton":"ihB8F","../PopoverStickyWrapper/PopoverStickyWrapper":"8BYj1","../TagsChoiceList/TagsChoiceList":"knnR1","./NewTagForm":"c5Z3J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jZ7nZ":[function(require,module,exports) {
module.exports = require("a7ed91897789d269").getBundleURL("kEMsi") + "tag.39dcae41.svg";

},{"a7ed91897789d269":"75UoR"}],"8BYj1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const PopoverStickyWrapper = (props)=>{
    const { filter, width = "25ch", height = "18.75rem", children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFormWrapper, {
        $width: width,
        $height: height,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
            children: [
                filter && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: filter
                }),
                children && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: children
                })
            ]
        })
    });
};
const StyledFormWrapper = (0, _styledComponentsDefault.default).div`
  height: ${({ $height })=>$height};
  width: ${({ $width })=>$width};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: auto;

  & > .Polaris-Card {
    flex: 1;
    ƒlex: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  & .Polaris-Card__Section:first-of-type {
    padding-bottom: var(--p-space-1);
  }

  & .Polaris-Card__Section:last-of-type {
    flex: auto;
    overflow-y: auto;
  }

  & .Polaris-Card__Section:last-of-type > :first-child {
    overflow-x: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }
`;
exports.default = PopoverStickyWrapper;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"knnR1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tagHelpers = require("../../helpers/tag.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _indeterminateChoiceList = require("../IndeterminateChoiceList/IndeterminateChoiceList");
var _indeterminateChoiceListDefault = parcelHelpers.interopDefault(_indeterminateChoiceList);
var _kdktag = require("../KDKTag/KDKTag");
var _kdktagDefault = parcelHelpers.interopDefault(_kdktag);
const TagsChoiceList = (props)=>{
    const { tags = [], selectedTags: initialSelection = [], partiallySelectedTags = [], disabled, filterValue = "", titleHidden, enableReadonlySelection, onSelectionChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [selectedTags, setSelectedTags] = (0, _react.useState)(initialSelection);
    const selectedTagIds = selectedTags.map((tag)=>tag.id);
    const partiallySelectedTagIds = partiallySelectedTags.map((tag)=>tag.id);
    const choices = (0, _react.useMemo)(()=>tags.filter((tag)=>(0, _tagHelpers.getTagTitle)(tag).toLocaleLowerCase().includes(filterValue.toLocaleLowerCase())).map((tag)=>({
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktagDefault.default), {
                    tag: tag,
                    highlightText: filterValue.toLocaleLowerCase()
                }),
                value: tag.id,
                disabled: !enableReadonlySelection && tag.read_only
            })), [
        tags,
        filterValue
    ]);
    const handleSelectionChange = (selectedIds)=>{
        const filteredTags = tags.filter((tag)=>selectedIds.includes(tag.id));
        onSelectionChange(filteredTags);
        setSelectedTags(filteredTags);
    };
    if (choices.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indeterminateChoiceListDefault.default), {
        title: f("tags.editor.existing-tags"),
        titleHidden: titleHidden,
        allowMultiple: true,
        choices: choices,
        selected: selectedTagIds,
        indeterminate: partiallySelectedTagIds,
        disabled: disabled,
        onChange: handleSelectionChange
    });
};
exports.default = TagsChoiceList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../helpers/tag.helpers":"ecpII","../../hooks/useFormatMessage":"8Y8fq","../IndeterminateChoiceList/IndeterminateChoiceList":"4XAgg","../KDKTag/KDKTag":"8koxk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4XAgg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChoiceList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _util = require("../../utils/util");
function ChoiceList({ title, titleHidden, allowMultiple, choices, selected, onChange = (0, _util.noop), error, disabled = false, name: nameProp, indeterminate = [] }) {
    const ControlComponent = allowMultiple ? (0, _polaris.Checkbox) : (0, _polaris.RadioButton);
    const name = (0, _util.uniqueId)("ChoiceList" + nameProp);
    const finalName = allowMultiple ? `${name}[]` : name;
    const titleMarkup = title ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Box), {
        as: "legend",
        paddingBlockEnd: {
            xs: "5",
            md: "1"
        },
        visuallyHidden: titleHidden,
        children: title
    }) : null;
    const choicesMarkup = choices.map((choice)=>{
        const { value, id, label, helpText, disabled: choiceDisabled, describedByError } = choice;
        function handleChange(checked) {
            onChange(updateSelectedChoices(choice, checked, selected, allowMultiple), name);
        }
        const isSelected = choiceIsSelected(choice, selected);
        const checked = isSelected ? true : indeterminate.includes(choice.value) ? "indeterminate" : false;
        const renderedChildren = choice.renderChildren ? choice.renderChildren(isSelected) : null;
        const children = renderedChildren ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Box), {
                paddingBlockStart: {
                    xs: "4",
                    md: "0"
                },
                children: renderedChildren
            })
        }) : null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Bleed), {
                marginBlockEnd: helpText ? {
                    xs: "1",
                    md: "0"
                } : {
                    xs: "0"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ControlComponent, {
                        name: finalName,
                        value: value,
                        id: id,
                        label: label,
                        disabled: choiceDisabled || disabled,
                        // The union of RadioButton and Checkbox returns a checked property that is boolean only
                        // But Checkbox check property can also accept "indeterminate" values
                        // @ts-ignore
                        checked: allowMultiple ? checked : Boolean(checked),
                        helpText: helpText,
                        onChange: handleChange,
                        ariaDescribedBy: error && describedByError ? (0, _polaris.errorTextID)(finalName) : undefined
                    }),
                    children
                ]
            })
        }, value);
    });
    const errorMarkup = error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Box), {
        paddingBlockStart: {
            xs: "0",
            md: "1"
        },
        paddingBlockEnd: "2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.InlineError), {
            message: error,
            fieldID: finalName
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        as: "fieldset",
        gap: {
            xs: "4",
            md: "0"
        },
        "aria-invalid": error != null,
        id: finalName,
        children: [
            titleMarkup,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                as: "ul",
                gap: {
                    xs: "4",
                    md: "0"
                },
                children: choicesMarkup
            }),
            errorMarkup
        ]
    });
}
function choiceIsSelected({ value }, selected) {
    return selected.includes(value);
}
function updateSelectedChoices({ value }, checked, selected, allowMultiple = false) {
    if (checked) return allowMultiple ? [
        ...selected,
        value
    ] : [
        value
    ];
    return selected.filter((selectedChoice)=>selectedChoice !== value);
}

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c5Z3J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _plusMajorSvg = require("../../../assets/icons/plus-major.svg");
var _plusMajorSvgDefault = parcelHelpers.interopDefault(_plusMajorSvg);
var _tagHelpers = require("../../helpers/tag.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
const NewTagForm = (props)=>{
    const { disabled, onTagValueChange, onNewTag } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { allTags } = (0, _useTagsDefault.default)();
    const [newTagValue, setNewTagValue] = (0, _react.useState)("");
    (0, _react.useEffect)(()=>onTagValueChange && onTagValueChange(newTagValue), [
        newTagValue
    ]);
    const handleNewTag = onNewTag ? async ()=>await onNewTag(newTagValue.trim()) : (0, _util.noop);
    const isDuplicateTag = new Set(allTags.map((tag)=>(0, _tagHelpers.getTagTitle)(tag).toLocaleLowerCase())).has(newTagValue.trim().toLocaleLowerCase());
    const showAddButton = onNewTag && (allTags.length === 0 || !(0, _stringUtils.isEmptyString)(newTagValue));
    const isInvalidNewTag = isDuplicateTag || (0, _stringUtils.isEmptyString)(newTagValue.trim());
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Form), {
        onSubmit: handleNewTag,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                    label: onNewTag ? f("tags.editor.new-tag-input") : f("default.search"),
                    value: newTagValue,
                    onChange: setNewTagValue,
                    placeholder: f("default.search")
                }),
                showAddButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    plain: true,
                    removeUnderline: true,
                    submit: true,
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _plusMajorSvgDefault.default),
                        width: "12px",
                        height: "12px",
                        useMask: true
                    }),
                    disabled: isInvalidNewTag || disabled,
                    children: f("tags.editor.add-and-apply-button", {
                        tag: newTagValue
                    })
                })
            ]
        })
    });
};
exports.default = NewTagForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/plus-major.svg":"fCy4K","../../helpers/tag.helpers":"ecpII","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useTags":"31uzS","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../SearchTextField/SearchTextField":"k5bRy","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4St21":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
/**
 * A customer details pages could either be navigated to from the customers list, a project details page or directly
 * via a URL with customer ID
 */ const useCustomerBackButton = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const f = (0, _useFormatMessageDefault.default)();
    const fromCustomersList = location.state?.fromCustomersList === true;
    const fromProject = location.state?.fromProject;
    // if true - this mean to use history.back() instead of an HTML anchor
    const useNavigateBack = fromCustomersList || fromProject !== undefined;
    // undefined url will cause BackButton.tsx to use history.back() (which is preferred since it
    // stored all the URL search parameters, sorting and pagination state) instead of an HTML anchor
    const backButtonURL = useNavigateBack ? undefined : (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMERS);
    const backButtonDisplayLabel = fromProject ? fromProject.name : f("navigation.page.customers.title");
    return {
        backButtonDisplayLabel,
        backButtonURL
    };
};
exports.default = useCustomerBackButton;

},{"react-router-dom":"1ee65","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2kHZk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _customerTabbedFeatures = require("../../constants/customer-tabbed-features");
var _queriesKeys = require("../../constants/queries-keys");
var _attachments = require("../../helpers/attachments");
var _useAttachmentsAPI = require("../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetAttachmentsDisplayTitle = require("../../hooks/useGetAttachmentsDisplayTitle");
var _useGetAttachmentsDisplayTitleDefault = parcelHelpers.interopDefault(_useGetAttachmentsDisplayTitle);
var _useProjectPermissions = require("../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
var _stringUtils = require("../../utils/stringUtils");
var _addAssignmentButton = require("../AddAssignmentButton/AddAssignmentButton");
var _addAssignmentButtonDefault = parcelHelpers.interopDefault(_addAssignmentButton);
var _addToProjectButton = require("../AddToProjectButton/AddToProjectButton");
var _addToProjectButtonDefault = parcelHelpers.interopDefault(_addToProjectButton);
var _customerAttachmentsSection = require("../CustomerAttachmentsSection/CustomerAttachmentsSection");
var _customerAttachmentsSectionDefault = parcelHelpers.interopDefault(_customerAttachmentsSection);
var _customerUploadDocumentButton = require("../CustomerUploadDocumentButton/CustomerUploadDocumentButton");
var _customerUploadDocumentButtonDefault = parcelHelpers.interopDefault(_customerUploadDocumentButton);
var _kdktabs = require("../KDKTabs/KDKTabs");
var _kdktabsDefault = parcelHelpers.interopDefault(_kdktabs);
var _assignmentsSection = require("./AssignmentsSection");
var _assignmentsSectionDefault = parcelHelpers.interopDefault(_assignmentsSection);
var _karLookupSection = require("./KarLookupSection");
var _karLookupSectionDefault = parcelHelpers.interopDefault(_karLookupSection);
var _projectsSection = require("./ProjectsSection");
var _projectsSectionDefault = parcelHelpers.interopDefault(_projectsSection);
const CustomerFeaturesSection = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    // get the anchor of the page from the location and remove the hash sign if exists
    const pageAnchor = location.hash.startsWith("#") ? location.hash.substring(1) : location.hash;
    const attachmentsDisplayTitle = (0, _useGetAttachmentsDisplayTitleDefault.default)();
    const { entityId, getAttachments } = (0, _useAttachmentsAPIDefault.default)(customer);
    const attachmentsQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
        entityId
    ];
    const { data } = (0, _reactQuery.useQuery)(attachmentsQueryKey, ()=>getAttachments(entityId));
    // do not count archived assignments in tab header
    const activeAssignmentCount = customer.assignments?.filter((assignment)=>!assignment.is_archived).length;
    const assignmentsTitle = (0, _stringUtils.appendCounter)(f("customer-assignments.title"), activeAssignmentCount);
    // do not count inactive projects in tab header
    const activeProjectsCount = customer.projects?.filter((project)=>project.status === "ACTIVE").length;
    const projectsTitle = (0, _stringUtils.appendCounter)(f("projects.page.title"), activeProjectsCount);
    // do not count attachments from archived assignments
    const activeAttachmentsCount = data?.attachment_list.filter((0, _attachments.isActiveAttachment)).length;
    const attachmentsTitle = (0, _stringUtils.appendCounter)(attachmentsDisplayTitle, activeAttachmentsCount);
    const { isProjectsEnabled } = (0, _useProjectPermissionsDefault.default)();
    const [uploadingFilesCount, setUploadingFilesCount] = (0, _react.useState)(0);
    const tabs = [];
    const assignmentsTab = {
        id: (0, _customerTabbedFeatures.CustomerFeatureEnum).ASSIGNMENTS,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            fontWeight: "semibold",
            children: assignmentsTitle
        })
    };
    const projectsTab = {
        id: (0, _customerTabbedFeatures.CustomerFeatureEnum).PROJECTS,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            fontWeight: "semibold",
            children: projectsTitle
        })
    };
    const documentsTab = {
        id: (0, _customerTabbedFeatures.CustomerFeatureEnum).ATTACHMENTS,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            fontWeight: "semibold",
            children: attachmentsTitle
        })
    };
    const karTab = {
        id: (0, _customerTabbedFeatures.CustomerFeatureEnum).KAR,
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            fontWeight: "semibold",
            children: f("kar.title")
        })
    };
    if (!features.ASSIGNMENTS__HIDE_DETAILS) tabs.push(assignmentsTab);
    if (isProjectsEnabled || !isProjectsEnabled) tabs.push(projectsTab);
    if (features.ATTACHMENTS || !features.ATTACHMENTS) tabs.push(documentsTab);
    if (features.CUSTOMER__KAR_INTEGRATION) tabs.push(karTab);
    const [selectedTabIndex, setSelectedTabIndex] = (0, _react.useState)(()=>// if pageAnchor is not found, return 0 and not -1
        Math.max(tabs.findIndex((tab)=>tab.id === pageAnchor), 0));
    (0, _react.useEffect)(()=>{
        const selectedTabIndex = tabs.findIndex((tab)=>tab.id === pageAnchor);
        if (selectedTabIndex >= 0) setSelectedTabIndex(selectedTabIndex);
    }, [
        pageAnchor,
        tabs
    ]);
    const showAssignments = selectedTabIndex === tabs.indexOf(assignmentsTab);
    const showProjects = selectedTabIndex === tabs.indexOf(projectsTab);
    const showAttachments = selectedTabIndex === tabs.indexOf(documentsTab);
    const showKar = selectedTabIndex === tabs.indexOf(karTab);
    const assignments = customer.assignments?.filter((assignment)=>!assignment.is_archived);
    if (tabs.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledFeaturesWrapper, {
        id: tabs[selectedTabIndex].id,
        children: [
            showAssignments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addAssignmentButtonDefault.default), {
                customer: customer,
                readonly: readonly
            }),
            showProjects && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addToProjectButtonDefault.default), {
                customer: customer,
                readonly: readonly
            }),
            showAttachments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerUploadDocumentButtonDefault.default), {
                entity: customer,
                assignments: assignments,
                readonly: readonly,
                onFileUploadingStart: (filesCount)=>setUploadingFilesCount(filesCount),
                onFileUploadingFinish: ()=>setUploadingFilesCount(0)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktabsDefault.default), {
                tabs: tabs,
                selected: selectedTabIndex,
                onSelect: setSelectedTabIndex,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        showAssignments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentsSectionDefault.default), {
                            customer: customer
                        }),
                        showProjects && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectsSectionDefault.default), {
                            projects: customer.projects
                        }),
                        showAttachments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerAttachmentsSectionDefault.default), {
                            customer: customer,
                            uploadingFilesCount: uploadingFilesCount,
                            readonly: readonly
                        }),
                        showKar && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _karLookupSectionDefault.default), {
                            customer: customer
                        })
                    ]
                })
            })
        ]
    });
};
const StyledFeaturesWrapper = (0, _styledComponentsDefault.default).div`
  padding-top: var(--p-space-2);
  position: relative;
`;
exports.default = CustomerFeaturesSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../constants/customer-tabbed-features":"bcTSx","../../constants/queries-keys":"6hYSF","../../helpers/attachments":"6o6Ej","../../hooks/useAttachmentsAPI":"7xA5e","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetAttachmentsDisplayTitle":"e3tqV","../../hooks/useProjectPermissions":"23Tgs","../../utils/stringUtils":"4gVdA","../AddAssignmentButton/AddAssignmentButton":"yQGTs","../AddToProjectButton/AddToProjectButton":"9dVdI","../CustomerAttachmentsSection/CustomerAttachmentsSection":"8mEf4","../CustomerUploadDocumentButton/CustomerUploadDocumentButton":"iVpsA","../KDKTabs/KDKTabs":"hryzj","./AssignmentsSection":"fDQWW","./KarLookupSection":"bZwgZ","./ProjectsSection":"cMRvk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bcTSx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomerFeatureEnum", ()=>CustomerFeatureEnum);
var CustomerFeatureEnum;
(function(CustomerFeatureEnum) {
    CustomerFeatureEnum["ASSIGNMENTS"] = "assignments";
    CustomerFeatureEnum["PROJECTS"] = "projects";
    CustomerFeatureEnum["ATTACHMENTS"] = "attachments";
    CustomerFeatureEnum["KAR"] = "kar";
})(CustomerFeatureEnum || (CustomerFeatureEnum = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6o6Ej":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isActiveAttachment", ()=>isActiveAttachment);
parcelHelpers.export(exports, "isValidFile", ()=>isValidFile);
var _files = require("../constants/files");
const isActiveAttachment = (attachment)=>!attachment.assignment_is_archived;
const isValidFile = (file)=>file.size <= (0, _files.MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD);

},{"../constants/files":"kmOPp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kmOPp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCEPTED_FILE_TYPES", ()=>ACCEPTED_FILE_TYPES);
parcelHelpers.export(exports, "MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD", ()=>MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD);
const ACCEPTED_FILE_TYPES = [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".csv",
    ".ppt",
    ".pptx",
    ".txt",
    ".jpg",
    ".jpeg",
    ".png",
    ".heic"
];
const MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD = 25000000; // 25mb;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7xA5e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _utilities = require("../types/utilities");
// the customer attachments list contains attachments that are either directly from the customer
// and also all the attachments from all the assignments of that customer
// if an attachment has an assignment_id set, then the API that should be returned
// if the assignments API
const useAttachmentsAPI = (entity, attachment)=>{
    const entityId = entity.id;
    if ((0, _utilities.isProject)(entity)) return {
        entityId,
        getAttachments: (0, _apiDefault.default).getProjectAttachments,
        addAttachment: (0, _apiDefault.default).addProjectAttachment,
        downloadAttachment: (0, _apiDefault.default).downloadProjectAttachment,
        deleteAttachment: (0, _apiDefault.default).deleteProjectAttachment,
        getAttachmentSignatures: (0, _apiDefault.default).getProjectAttachmentSignatures,
        updateAttachmentSignatures: (0, _apiDefault.default).updateProjectAttachmentSignatures,
        downloadSignedDocumentAttachment: (0, _apiDefault.default).downloadSignedProjectAttachment,
        deleteSignedAttachment: (0, _apiDefault.default).deleteSignedProjectAttachment
    };
    else if ((0, _utilities.isAssignment)(entity) || attachment?.assignment_id) {
        // if attachment.assignment_id is defined, then the attachment belongs to an assignment
        // and the attachments APIs for assignments should be used instead of the customer attachments APIs
        // in this scenario, the customerId is the entity id, since we only show attachments from assignments in the customer
        // details page
        const customerId = (0, _utilities.isAssignment)(entity) ? entity.customer_id : entityId;
        return {
            // if the attachment has an assignment, then the entityId should be the assignment id (as if the entity was an assignment)
            entityId: attachment?.assignment_id || entityId,
            getAttachments: (assignmentId)=>(0, _apiDefault.default).getCustomerAssignmentAttachments(customerId, assignmentId),
            addAttachment: (assignmentId, createAttachmentMetadataRequest)=>(0, _apiDefault.default).addCustomerAssignmentAttachment(customerId, assignmentId, createAttachmentMetadataRequest),
            downloadAttachment: (assignmentId, attachmentId)=>(0, _apiDefault.default).downloadCustomerAssignmentAttachment(customerId, assignmentId, attachmentId),
            deleteAttachment: (assignmentId, attachmentId)=>(0, _apiDefault.default).deleteCustomerAssignmentAttachment(customerId, assignmentId, attachmentId),
            getAttachmentSignatures: (assignmentId, attachmentId)=>(0, _apiDefault.default).getCustomerAssignmentAttachmentSignatures(customerId, assignmentId, attachmentId),
            updateAttachmentSignatures: (assignmentId, attachmentId, updateAttachmentSignaturesRequest)=>(0, _apiDefault.default).updateCustomerAssignmentAttachmentSignatures(customerId, assignmentId, attachmentId, updateAttachmentSignaturesRequest),
            downloadSignedDocumentAttachment: (assignmentId, attachmentId)=>(0, _apiDefault.default).downloadSignedCustomerAssignmentAttachment(customerId, assignmentId, attachmentId),
            deleteSignedAttachment: (assignmentId, attachmentId)=>(0, _apiDefault.default).deleteSignedCustomerAssignmentAttachment(customerId, assignmentId, attachmentId)
        };
    } else return {
        entityId,
        getAttachments: (0, _apiDefault.default).getCustomerAttachments,
        addAttachment: (0, _apiDefault.default).addCustomerAttachment,
        downloadAttachment: (0, _apiDefault.default).downloadCustomerAttachment,
        deleteAttachment: (0, _apiDefault.default).deleteCustomerAttachment,
        getAttachmentSignatures: (0, _apiDefault.default).getAttachmentSignatures,
        updateAttachmentSignatures: (0, _apiDefault.default).updateAttachmentSignatures,
        downloadSignedDocumentAttachment: (0, _apiDefault.default).downloadSignedCustomerAttachment,
        deleteSignedAttachment: (0, _apiDefault.default).deleteSignedCustomerAttachment
    };
};
exports.default = useAttachmentsAPI;

},{"../api":"f6lXD","../types/utilities":"6zLpB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e3tqV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useGetAttachmentsDisplayTitle = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    return features.ELECTRONIC_SIGNATURES ? f("attachments.section.title-with-signatures") : f("attachments.section.title");
};
exports.default = useGetAttachmentsDisplayTitle;

},{"./useFeatures":"hvBWb","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"yQGTs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../hooks/useQueryData");
var _assignmentModal = require("../AssignmentModal/AssignmentModal");
var _assignmentModalDefault = parcelHelpers.interopDefault(_assignmentModal);
var _floatPrimaryButton = require("../FloatPrimaryButton/FloatPrimaryButton");
var _floatPrimaryButtonDefault = parcelHelpers.interopDefault(_floatPrimaryButton);
const AddAssignmentButton = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const [isAssignmentModalOpen, toggleAssignmentModal, closeAssignmentModal] = (0, _useOpenCloseDefault.default)();
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const handleSaveAssignment = (assignment, isNew)=>{
        updateQueryData((queryData)=>queryData.assignments = [
                assignment,
                ...queryData.assignments || []
            ]);
        closeAssignmentModal();
        if (isNew) history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).ASSIGNMENT_DETAILS, {
            customerId: customer.id,
            id: assignment.id
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _floatPrimaryButtonDefault.default), {
                onClick: toggleAssignmentModal,
                disabled: readonly,
                children: f("common.buttons.actions.new-assignment")
            }),
            isAssignmentModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentModalDefault.default), {
                customerId: customer.id,
                onCancel: closeAssignmentModal,
                onSave: handleSaveAssignment
            })
        ]
    });
};
exports.default = AddAssignmentButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useQueryData":"4laI9","../AssignmentModal/AssignmentModal":"bVFci","../FloatPrimaryButton/FloatPrimaryButton":"c9hvU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bVFci":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dateInput = require("../DateInput/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _purposeChoicesSelect = require("../PurposeChoicesSelect/PurposeChoicesSelect");
var _purposeChoicesSelectDefault = parcelHelpers.interopDefault(_purposeChoicesSelect);
var _industryChoicesSelect = require("./IndustryChoicesSelect");
var _industryChoicesSelectDefault = parcelHelpers.interopDefault(_industryChoicesSelect);
const AssignmentModal = (props)=>{
    const { customerId, assignment, onCancel, onSave } = props;
    const isNew = assignment === undefined;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { user: currentUser } = (0, _useAuthDefault.default)();
    const responsibleUsersIds = isNew && currentUser ? [
        currentUser.id
    ] : (assignment?.responsible_users || []).map((user)=>user.id);
    const [assignmentDetails, setAssignmentDetails, changed] = (0, _useChangedStateDefault.default)({
        industry_type: assignment?.industry_type,
        name: assignment?.name || "",
        description: assignment?.description || "",
        purpose: assignment?.purpose,
        purpose_desc: assignment?.purpose_desc,
        responsible_users: responsibleUsersIds,
        start_date: assignment?.start_date,
        end_date: assignment?.end_date
    });
    const saveAssignmentMutation = (0, _reactQuery.useMutation)(()=>isNew ? (0, _apiDefault.default).createCustomerAssignment(customerId, assignmentDetails) : (0, _apiDefault.default).updateCustomerAssignment(customerId, assignment.id, assignmentDetails), {
        onSuccess: (response)=>onSave(response, isNew)
    });
    const saveAssignment = ()=>saveAssignmentMutation.mutate();
    const isInvalid = (0, _assignmentsHelpers.isInvalidAssignment)(assignmentDetails);
    const handleChange = (name, value)=>{
        setAssignmentDetails((prevState)=>({
                ...prevState,
                [name]: value
            }));
    };
    const handlePurposeChange = (purpose, purposeDescription)=>{
        setAssignmentDetails((prevState)=>({
                ...prevState,
                purpose,
                purpose_desc: purposeDescription
            }));
    };
    const title = isNew ? f("common.buttons.actions.new-assignment") : f("common.buttons.actions.edit-assignment");
    const disabled = assignment?.is_archived || saveAssignmentMutation.isLoading;
    const cancelAction = {
        content: assignment?.is_archived ? f("default.close") : f("default.cancel"),
        onAction: onCancel,
        disabled: saveAssignmentMutation.isLoading
    };
    const saveAction = {
        content: isNew ? f("default.create") : f("default.save"),
        onAction: saveAssignment,
        disabled: disabled || isInvalid || !changed,
        loading: saveAssignmentMutation.isLoading
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        onClose: onCancel,
        title: title,
        primaryAction: saveAction,
        secondaryActions: [
            cancelAction
        ],
        footer: saveAssignmentMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
            message: saveAssignmentMutation.error
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        label: f("customer-assignments.modal.assignment-name"),
                        placeholder: f("customer-assignments.modal.assignment-name"),
                        value: assignmentDetails.name,
                        onChange: (value)=>handleChange("name", value),
                        disabled: disabled,
                        autoFocus: true,
                        requiredIndicator: true,
                        autoComplete: "off"
                    }),
                    features.ASSIGNMENT_INDUSTRIES && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryChoicesSelectDefault.default), {
                        label: f("customer-assignments.modal.assignment-industry"),
                        placeholder: f("customer-assignments.modal.assignment-industry.placeholder"),
                        selectedIndustry: assignmentDetails.industry_type,
                        autoComplete: "off",
                        onChange: (industryType)=>handleChange("industry_type", industryType),
                        disabled: disabled || assignment?.industry_type !== undefined
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _purposeChoicesSelectDefault.default), {
                        industryType: assignmentDetails.industry_type,
                        hasPurposeDesc: assignmentDetails.purpose_desc !== undefined,
                        value: assignmentDetails.purpose || assignmentDetails.purpose_desc,
                        showDeprecatedPurposes: !isNew,
                        onChange: handlePurposeChange,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "8",
                        blockAlign: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                                label: f("common.labels.start-date"),
                                value: assignmentDetails.start_date || "",
                                onChange: (value)=>handleChange("start_date", value),
                                clearButton: true,
                                onClearButtonClick: ()=>handleChange("start_date", undefined),
                                disabled: disabled,
                                autoComplete: "off"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                                label: f("common.labels.end-date"),
                                value: assignmentDetails.end_date || "",
                                onChange: (value)=>handleChange("end_date", value),
                                clearButton: true,
                                onClearButtonClick: ()=>handleChange("end_date", undefined),
                                disabled: disabled,
                                autoComplete: "off"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        label: f("customer-assignments.modal.assignment-description"),
                        placeholder: f("customer-assignments.modal.assignment-description"),
                        value: assignmentDetails.description,
                        multiline: 3,
                        onChange: (value)=>handleChange("description", value),
                        disabled: disabled,
                        requiredIndicator: true,
                        autoComplete: "off"
                    })
                ]
            })
        })
    });
};
exports.default = AssignmentModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../helpers/assignments.helpers":"7t8rY","../../hooks/useAuth":"k9r0q","../../hooks/useChangedState":"170jW","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../DateInput/DateInput":"6BAM5","../ErrorPanel/ErrorPanel":"2hHqH","../PurposeChoicesSelect/PurposeChoicesSelect":"fbzrz","./IndustryChoicesSelect":"ibvbu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7t8rY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertAssignmentToUpdateRequest", ()=>convertAssignmentToUpdateRequest);
parcelHelpers.export(exports, "sortAssignmentsByDate", ()=>sortAssignmentsByDate);
parcelHelpers.export(exports, "isInvalidAssignment", ()=>isInvalidAssignment);
parcelHelpers.export(exports, "isActiveAssignment", ()=>isActiveAssignment);
var _stringUtils = require("../utils/stringUtils");
const convertAssignmentToUpdateRequest = (assignment)=>{
    const { name, description, industry_type, purpose, purpose_desc, responsible_users, start_date, end_date } = assignment;
    const responsibleUsersIds = responsible_users.map((user)=>user.id);
    return {
        name,
        description,
        industry_type,
        purpose,
        purpose_desc,
        start_date,
        end_date,
        responsible_users: responsibleUsersIds
    };
};
const sortAssignmentsByDate = (a1, a2)=>new Date(a2.created_dt).getTime() - new Date(a1.created_dt).getTime();
const isInvalidAssignment = (assignment)=>(0, _stringUtils.isEmptyString)(assignment.name) || (0, _stringUtils.isEmptyString)(assignment.description);
const isActiveAssignment = (assignment)=>!assignment.is_archived;

},{"../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fbzrz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetAssignmentIndustriesAndPurposes = require("../../hooks/useGetAssignmentIndustriesAndPurposes");
var _useGetAssignmentIndustriesAndPurposesDefault = parcelHelpers.interopDefault(_useGetAssignmentIndustriesAndPurposes);
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
const PurposeChoicesSelect = (props)=>{
    const { hasPurposeDesc, industryType, disablePurposeDescription, showDeprecatedPurposes, value, excludedOptions, onChange, ...textFieldProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getPurposes, getPurposeLabel, isLoading } = (0, _useGetAssignmentIndustriesAndPurposesDefault.default)();
    const purposes = getPurposes(industryType, !showDeprecatedPurposes);
    // list of all available purposes options
    const deselectedOptions = isLoading ? [] : purposes.filter((purpose)=>purpose.value === value || !excludedOptions?.includes(purpose.value)).map((purpose)=>({
            label: getPurposeLabel(purpose.value),
            value: purpose.value,
            disabled: purpose.is_deprecated
        }));
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)(value ? [
        value
    ] : []);
    const [inputValue, setInputValue] = (0, _react.useState)(()=>value ? getPurposeLabel(value) : value);
    const [options, setOptions] = (0, _react.useState)(deselectedOptions);
    // update inputValue if industries/purposes were not loaded yet
    (0, _react.useEffect)(()=>{
        if (isLoading) return;
        if (value) setInputValue(getPurposeLabel(value));
    }, [
        isLoading,
        getPurposeLabel,
        (0, _stringUtils.isEmptyString)(value)
    ]);
    (0, _react.useEffect)(()=>{
        if (industryType) {
            setOptions(deselectedOptions);
            if (!value?.includes(industryType) && !hasPurposeDesc) updateText("");
        } else if (options.length === 0) setOptions(deselectedOptions);
    }, [
        industryType,
        deselectedOptions.length,
        isLoading
    ]);
    const updateText = (0, _react.useCallback)((value)=>{
        setInputValue(value);
        setSelectedOptions([]);
        // do not trigger an update event if filter value changes
        if (!disablePurposeDescription) onChange(undefined, value);
        if (value === "") {
            setOptions(deselectedOptions);
            return;
        }
        const resultOptions = deselectedOptions.filter((option)=>option.label.match((0, _stringUtils.filterRegEx)(value))).map((option)=>({
                ...option,
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                    searchWords: [
                        value
                    ],
                    textToHighlight: option.label
                })
            }));
        setOptions(resultOptions);
    }, [
        deselectedOptions,
        onChange
    ]);
    // reset the selected value to the last known value
    const handleBlur = (0, _react.useCallback)(()=>{
        setOptions(deselectedOptions);
        updateSelection(value ? [
            value
        ] : []);
    }, [
        value,
        getPurposeLabel,
        isLoading
    ]);
    const updateSelection = (0, _react.useCallback)((selected)=>{
        setSelectedOptions(selected);
        setInputValue(getPurposeLabel((0, _collectionUtils.first)(selected)));
        onChange((0, _collectionUtils.first)(selected), undefined);
    }, [
        getPurposeLabel,
        isLoading,
        onChange
    ]);
    const clearInput = ()=>{
        updateText("");
        onChange(undefined, undefined);
    };
    const placeholder = disablePurposeDescription ? f("customer-assignments.modal.assignment-purpose.placeholder-without-description") : f("customer-assignments.modal.assignment-purpose.placeholder");
    const textField = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete).TextField, {
        onChange: updateText,
        onBlur: disablePurposeDescription ? handleBlur : undefined,
        label: f("customer-assignments.modal.assignment-purpose"),
        ...textFieldProps,
        autoComplete: "off",
        placeholder: placeholder,
        value: inputValue,
        clearButton: true,
        onClearButtonClick: clearInput
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete), {
        options: options,
        selected: selectedOptions,
        onSelect: updateSelection,
        textField: textField
    });
};
exports.default = PurposeChoicesSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetAssignmentIndustriesAndPurposes":"d3Dsc","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","../TextHighlighter/TextHighlighter":"43Xhz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d3Dsc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useTranslatedText = require("./useTranslatedText");
var _useTranslatedTextDefault = parcelHelpers.interopDefault(_useTranslatedText);
const useGetAssignmentIndustriesAndPurposes = ()=>{
    const t = (0, _useTranslatedTextDefault.default)();
    const getAllAssignmentIndustriesAndPurposesQuery = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).ALL_ASSIGNMENT_INDUSTRIES_AND_PURPOSES
    ], ()=>(0, _apiDefault.default).getAssignmentIndustries(), {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    const isLoading = getAllAssignmentIndustriesAndPurposesQuery.isLoading;
    const industries = getAllAssignmentIndustriesAndPurposesQuery.data?.industries || [];
    const default_purposes = getAllAssignmentIndustriesAndPurposesQuery.data?.default_purposes || [];
    const allPurposes = (0, _react.useMemo)(()=>[
            default_purposes,
            industries.flatMap((industry)=>industry.purposes)
        ].flat(), [
        isLoading
    ]);
    const getPurposes = (0, _react.useCallback)((industryType, filterDeprecated)=>{
        // Return the default purposes for the organization the user is signed in as.
        const purposes = industryType ? industries.find((industry)=>industry.value === industryType)?.purposes || [] : default_purposes;
        return filterDeprecated ? purposes.filter((purpose)=>!purpose.is_deprecated) : purposes;
    }, [
        industries,
        default_purposes
    ]);
    const getPurposeLabel = (0, _react.useCallback)((purpose)=>{
        if (!purpose || isLoading) return "";
        const purposeLabel = allPurposes.find((entry)=>entry.value === purpose)?.label;
        return purposeLabel ? t(purposeLabel) : purpose;
    }, [
        allPurposes,
        isLoading
    ]);
    return {
        industries,
        getPurposes,
        getPurposeLabel,
        isLoading
    };
};
exports.default = useGetAssignmentIndustriesAndPurposes;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useTranslatedText":"lODeq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lODeq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _languages = require("../constants/languages");
var _useLanguage = require("./useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
const useTranslatedText = ()=>{
    const language = (0, _useLanguageDefault.default)();
    const getTranslatedText = (text)=>text[language] || text[0, _languages.DEFAULT_LANGUAGE];
    return getTranslatedText;
};
exports.default = useTranslatedText;

},{"../constants/languages":"ecnY7","./useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ibvbu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useGetAssignmentIndustriesAndPurposes = require("../../hooks/useGetAssignmentIndustriesAndPurposes");
var _useGetAssignmentIndustriesAndPurposesDefault = parcelHelpers.interopDefault(_useGetAssignmentIndustriesAndPurposes);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _stringUtils = require("../../utils/stringUtils");
const IndustryChoicesSelect = (props)=>{
    const { selectedIndustry, onChange, ...textFieldProps } = props;
    const { industries } = (0, _useGetAssignmentIndustriesAndPurposesDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const getIndustryLabel = (value)=>industries.find((industry)=>industry.value === value)?.label[language];
    const deselectedOptions = industries.map((industry)=>({
            label: getIndustryLabel(industry.value) || industry.value,
            value: industry.value
        }));
    const [inputValue, setInputValue] = (0, _react.useState)("");
    const [options, setOptions] = (0, _react.useState)(deselectedOptions);
    // update options and input value after industries were loaded
    (0, _react.useEffect)(()=>{
        if (industries.length > 0) {
            setOptions(deselectedOptions);
            setInputValue(getIndustryLabel(selectedIndustry) || "");
        }
    }, [
        industries.length
    ]);
    const updateText = (0, _react.useCallback)((value)=>{
        setInputValue(value);
        if (value === "") {
            setOptions(deselectedOptions);
            return;
        }
        const resultOptions = deselectedOptions.filter((option)=>option.label.match((0, _stringUtils.filterRegEx)(value)));
        setOptions(resultOptions);
    }, [
        deselectedOptions
    ]);
    const updateSelection = (0, _react.useCallback)((selected)=>{
        const matchedOptionLabel = options.find((option)=>option.value === selected)?.label;
        onChange(selected);
        setInputValue(matchedOptionLabel || "");
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Combobox), {
        activator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Combobox).TextField, {
            onChange: updateText,
            clearButton: true,
            onClearButtonClick: ()=>updateSelection(undefined),
            value: inputValue,
            ...textFieldProps
        }),
        children: options.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Listbox), {
            onSelect: updateSelection,
            children: options?.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Listbox).Option, {
                    value: option.value,
                    selected: selectedIndustry === option.value,
                    children: option.label
                }, option.value))
        }) : null
    });
};
exports.default = IndustryChoicesSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useGetAssignmentIndustriesAndPurposes":"d3Dsc","../../hooks/useLanguage":"2W6IE","../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c9hvU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
const FloatPrimaryButton = (0, _styledComponentsDefault.default)((0, _addButtonDefault.default))`
  float: right;

  // For small viewports - render button as a regular block element
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    float: revert;
    display: inline-block;
  }
`;
exports.default = FloatPrimaryButton;

},{"styled-components":"eBrdC","../../constants/styles":"dZWds","../AddButton/AddButton":"WJGEt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"WJGEt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _plusMajorWhiteSvg = require("../../../assets/icons/plus-major-white.svg");
var _plusMajorWhiteSvgDefault = parcelHelpers.interopDefault(_plusMajorWhiteSvg);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const AddButton = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        ref: ref,
        ...props,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _plusMajorWhiteSvgDefault.default),
            width: "12px",
            height: "12px"
        }),
        primary: true
    });
});
exports.default = AddButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../assets/icons/plus-major-white.svg":"5HqsJ","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5HqsJ":[function(require,module,exports) {
module.exports = require("7891611e36fd2022").getBundleURL("kEMsi") + "plus-major-white.156b00bc.svg";

},{"7891611e36fd2022":"75UoR"}],"9dVdI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _starFilledSvg = require("../../../assets/icons/star-filled.svg");
var _starFilledSvgDefault = parcelHelpers.interopDefault(_starFilledSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useProjectPermissions = require("../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
var _planConversionModal = require("../CustomerDetailsHeader/CustomerActionsMenu/PlanConversionModal");
var _planConversionModalDefault = parcelHelpers.interopDefault(_planConversionModal);
var _addToProjectModal = require("../CustomersListBulkActions/AddToProjectModal/AddToProjectModal");
var _addToProjectModalDefault = parcelHelpers.interopDefault(_addToProjectModal);
var _floatPrimaryButton = require("../FloatPrimaryButton/FloatPrimaryButton");
var _floatPrimaryButtonDefault = parcelHelpers.interopDefault(_floatPrimaryButton);
const AddToProjectButton = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isProjectsEnabled, isCreateOrAddToProjectEnabled } = (0, _useProjectPermissionsDefault.default)();
    const [showAddToProjectModal, toggleAddToProjectModal, closeAddToProjectModal] = (0, _useOpenCloseDefault.default)();
    const [showPlanConversionModal, togglePlanConversionModal, closePlanConversionModal] = (0, _useOpenCloseDefault.default)();
    const showAMLConversionAction = !isProjectsEnabled;
    const disabled = readonly || !isCreateOrAddToProjectEnabled && !showAMLConversionAction;
    const buttonIcon = showAMLConversionAction ? (0, _starFilledSvgDefault.default) : undefined; // will default to plus icon
    const buttonAction = showAMLConversionAction ? togglePlanConversionModal : toggleAddToProjectModal;
    const buttonLabel = showAMLConversionAction ? f("plan-conversion.customer-action.label") : f("bulk.actions.add-to-existing-project.label");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _floatPrimaryButtonDefault.default), {
                icon: buttonIcon,
                onClick: buttonAction,
                disabled: disabled,
                children: buttonLabel
            }),
            showAddToProjectModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addToProjectModalDefault.default), {
                customers: [
                    customer
                ],
                hideCustomersCount: true,
                onClose: closeAddToProjectModal
            }),
            showPlanConversionModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planConversionModalDefault.default), {
                onClose: closePlanConversionModal,
                content: f("plan-conversion.add-to-projects.description")
            })
        ]
    });
};
exports.default = AddToProjectButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../assets/icons/star-filled.svg":"hGLQA","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useProjectPermissions":"23Tgs","../CustomerDetailsHeader/CustomerActionsMenu/PlanConversionModal":"6OBFD","../CustomersListBulkActions/AddToProjectModal/AddToProjectModal":"hXY5u","../FloatPrimaryButton/FloatPrimaryButton":"c9hvU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8mEf4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _attachments = require("../../helpers/attachments");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _attachmentsSection = require("../AttachmentsSection/AttachmentsSection");
var _attachmentsSectionDefault = parcelHelpers.interopDefault(_attachmentsSection);
const CustomerAttachmentsSection = (props)=>{
    const { customer, uploadingFilesCount, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const fetchSuggestedSigners = ()=>Promise.resolve([
            customer
        ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
        gap: "2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentsSectionDefault.default), {
            entity: customer,
            fetchSuggestedSigners: fetchSuggestedSigners,
            readonly: readonly,
            hideTitle: true,
            uploadingFilesCount: uploadingFilesCount,
            filterAttachment: (0, _attachments.isActiveAttachment),
            getFilterLabels: (filteredAttachmentsCount)=>({
                    hide: f("customer-assignments.list.filter.hide-archived-assignments", {
                        count: filteredAttachmentsCount
                    }),
                    show: f("customer-assignments.list.filter.show-archived-assignments", {
                        count: filteredAttachmentsCount
                    })
                })
        })
    });
};
exports.default = CustomerAttachmentsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/attachments":"6o6Ej","../../hooks/useFormatMessage":"8Y8fq","../AttachmentsSection/AttachmentsSection":"1J3Nq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1J3Nq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _queriesKeys = require("../../constants/queries-keys");
var _useAttachmentsAPI = require("../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetAttachmentsDisplayTitle = require("../../hooks/useGetAttachmentsDisplayTitle");
var _useGetAttachmentsDisplayTitleDefault = parcelHelpers.interopDefault(_useGetAttachmentsDisplayTitle);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _utilities = require("../../types/utilities");
var _attachmentSignaturesModal = require("./AttachmentActions/AttachmentSignaturesModal/AttachmentSignaturesModal");
var _attachmentSignaturesModalDefault = parcelHelpers.interopDefault(_attachmentSignaturesModal);
var _attachmentsPlanConversionBanner = require("./AttachmentsPlanConversionBanner");
var _attachmentsPlanConversionBannerDefault = parcelHelpers.interopDefault(_attachmentsPlanConversionBanner);
var _attachmentsTable = require("./AttachmentsTable");
var _attachmentsTableDefault = parcelHelpers.interopDefault(_attachmentsTable);
const AttachmentsSection = (props)=>{
    const { entity, fetchSuggestedSigners, readonly, hideTitle, uploadingFilesCount, hideSignatures, hideEmptyState, filterAttachment, getFilterLabels, children } = props;
    const [selectedAttachment, setSelectedAttachment] = (0, _react.useState)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { entityId, getAttachments } = (0, _useAttachmentsAPIDefault.default)(entity);
    const attachmentsDisplayTitle = (0, _useGetAttachmentsDisplayTitleDefault.default)();
    const attachmentsQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
        entityId
    ];
    const { isLoading, isError, error, data } = (0, _reactQuery.useQuery)(attachmentsQueryKey, ()=>getAttachments(entityId));
    const [isShowingFilteredAttachments, toggleShowFilteredAttachments] = (0, _useOpenCloseDefault.default)();
    const allAttachments = data?.attachment_list || [];
    const attachments = filterAttachment ? allAttachments.filter(filterAttachment) : allAttachments;
    const filteredAttachmentsCount = allAttachments.length - attachments.length;
    const hasFilteredAttachments = filteredAttachmentsCount > 0;
    const filterLabels = getFilterLabels ? getFilterLabels(filteredAttachmentsCount) : {
        hide: f("default.hide"),
        show: f("default.show")
    };
    const filterAttachmentsLabel = isShowingFilteredAttachments ? filterLabels.hide : filterLabels.show;
    const attachmentsToDisplay = isShowingFilteredAttachments ? allAttachments : attachments;
    const clearSelectedAttachmentIdToOpen = ()=>setSelectedAttachment(undefined);
    if (isError) console.error(error);
    const showPlanConversion = !features.ATTACHMENTS;
    const isEmpty = !isLoading && uploadingFilesCount === 0 && attachmentsToDisplay.length === 0;
    const showTable = attachmentsToDisplay.length > 0 || uploadingFilesCount > 0;
    if (showPlanConversion) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentsPlanConversionBannerDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: hideTitle ? "0" : "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        blockAlign: "baseline",
                        align: "space-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "4",
                                children: [
                                    !hideTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingMd",
                                        as: "h2",
                                        children: attachmentsDisplayTitle
                                    }),
                                    isEmpty && hideTitle && !hideEmptyState && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                        children: f("attachments.labels.empty")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                                inlineAlign: "end",
                                children: children
                            })
                        ]
                    }),
                    showTable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentsTableDefault.default), {
                        entity: entity,
                        attachments: attachmentsToDisplay,
                        uploadingFilesCount: uploadingFilesCount,
                        hideSignatures: hideSignatures,
                        onAttachmentSelected: setSelectedAttachment,
                        readonly: readonly
                    }),
                    !hideTitle && attachmentsToDisplay.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: isLoading || uploadingFilesCount > 0 ? f("attachments.labels.loading") : f("attachments.labels.empty")
                    })
                ]
            }),
            hasFilteredAttachments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    onClick: toggleShowFilteredAttachments,
                    disclosure: isShowingFilteredAttachments ? "up" : "down",
                    children: filterAttachmentsLabel
                })
            }),
            selectedAttachment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignaturesModalDefault.default), {
                entity: entity,
                attachment: selectedAttachment,
                fetchSuggestedSigners: fetchSuggestedSigners,
                readonly: readonly,
                initialPerson: (0, _utilities.isPersonCustomer)(entity) ? entity : undefined,
                onModalClose: clearSelectedAttachmentIdToOpen
            })
        ]
    });
};
exports.default = AttachmentsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../constants/queries-keys":"6hYSF","../../hooks/useAttachmentsAPI":"7xA5e","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetAttachmentsDisplayTitle":"e3tqV","../../hooks/useOpenClose":"idooG","../../types/utilities":"6zLpB","./AttachmentActions/AttachmentSignaturesModal/AttachmentSignaturesModal":"5jg7Q","./AttachmentsPlanConversionBanner":"87S3K","./AttachmentsTable":"l2FqJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5jg7Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _durations = require("../../../../constants/durations");
var _queriesKeys = require("../../../../constants/queries-keys");
var _displayHelpers = require("../../../../helpers/display.helpers");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _filenameUtils = require("../../../../utils/filenameUtils");
var _util = require("../../../../utils/util");
var _addItemButton = require("../../../AddItemButton/AddItemButton");
var _addItemButtonDefault = parcelHelpers.interopDefault(_addItemButton);
var _confirm = require("../../../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _errorPanel = require("../../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _attachmentsSectionHelpers = require("../../AttachmentsSection.helpers");
var _attachmentSignaturesTable = require("./AttachmentSignaturesTable/AttachmentSignaturesTable");
var _attachmentSignaturesTableDefault = parcelHelpers.interopDefault(_attachmentSignaturesTable);
var _attachmentSignaturesModalFooter = require("./AttachmentSignaturesModalFooter");
var _attachmentSignaturesModalFooterDefault = parcelHelpers.interopDefault(_attachmentSignaturesModalFooter);
var _attachmentSignedDocumentSection = require("./AttachmentSignedDocumentSection");
var _attachmentSignedDocumentSectionDefault = parcelHelpers.interopDefault(_attachmentSignedDocumentSection);
var _attachmentUnsignableSection = require("./AttachmentUnsignableSection");
var _attachmentUnsignableSectionDefault = parcelHelpers.interopDefault(_attachmentUnsignableSection);
var _useAttachmentSignaturesModal = require("./useAttachmentSignaturesModal");
var _useAttachmentSignaturesModalDefault = parcelHelpers.interopDefault(_useAttachmentSignaturesModal);
const AttachmentSignaturesModal = (props)=>{
    const { entity, attachment, initialPerson, fetchSuggestedSigners = (0, _util.noop), readonly, onModalClose } = props;
    const [savingError, setSavingError] = (0, _react.useState)();
    const [savedSuccessfully, setSavedSuccessfully] = (0, _react.useState)(false);
    const [showCancelConfirmation, setShowCancelConfirmation] = (0, _react.useState)(false);
    const [showSendEmailsToast, toggleSendEmailsToast, closeSendEmailsToast] = (0, _useOpenCloseDefault.default)();
    const [isModalVisible, setModalVisible] = (0, _react.useState)(true);
    const isSigned = (0, _attachmentsSectionHelpers.isAttachmentSigned)(attachment);
    const isSignable = (0, _attachmentsSectionHelpers.isAttachmentSignable)(attachment);
    const isAttachmentReadonly = readonly || isSigned || !isSignable;
    const showSignedDocumentSection = (0, _attachmentsSectionHelpers.hasSignedAttachment)(attachment) || (0, _attachmentsSectionHelpers.wasSignedAttachmentDeleted)(attachment);
    const f = (0, _useFormatMessageDefault.default)();
    const { isInitialEmpty, rows, isLoading, isSaving, isError, error, hasInvalidRows, hasUnsavedChanges, isEmailOnly, isLinkOnly, hasUnsentEmails, hasUnsavedLinks, createRow, saveChanges, ...rowsMethods } = (0, _useAttachmentSignaturesModalDefault.default)(entity, attachment);
    const { data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).SUGGESTED_SIGNERS,
        entity.id
    ], fetchSuggestedSigners, {
        enabled: fetchSuggestedSigners !== undefined
    });
    const customers = data || [];
    (0, _react.useEffect)(()=>{
        // creates a default signature if the table is empty
        if (isInitialEmpty && !isAttachmentReadonly) {
            const initialValues = {
                fullName: (0, _displayHelpers.getFullName)(initialPerson),
                email: initialPerson?.email,
                signer_id: initialPerson?.person_id,
                national_id: initialPerson?.national_id,
                send_email: true
            };
            createRow(initialValues, initialPerson !== undefined);
        }
    }, [
        isInitialEmpty,
        initialPerson,
        isAttachmentReadonly
    ]);
    const handleSaveChanges = async ()=>{
        try {
            setSavingError(undefined);
            setSavedSuccessfully(false);
            await saveChanges();
            setSavedSuccessfully(true);
            if (isEmailOnly && hasUnsentEmails) {
                // hide the modal
                setModalVisible(false);
                // show the success message toast
                toggleSendEmailsToast();
            }
        } catch (error) {
            setSavingError(error);
        }
    };
    const handleCancel = ()=>{
        if (hasUnsavedChanges) setShowCancelConfirmation(true);
        else closeModal();
    };
    const handleToastDismiss = ()=>{
        closeSendEmailsToast();
        closeModal();
    };
    const closeModal = ()=>{
        setSavingError(undefined);
        onModalClose();
    };
    const showTable = !isLoading && rows;
    const showError = isError || !(0, _util.isNil)(savingError);
    const isSaveDisabled = isLoading || hasInvalidRows || isAttachmentReadonly || isInitialEmpty && rows.length === 0;
    const title = f("attachments.signatures.modal.title", {
        filename: (0, _filenameUtils.cleanupFilename)(attachment.filename)
    });
    const getSaveActionLabel = ()=>{
        if (isEmailOnly && hasUnsentEmails) return f("default.send");
        else if (isLinkOnly && hasUnsavedLinks) return f("attachments.signatures.modal.labels.create-links");
        else if (hasUnsentEmails || hasUnsavedLinks) return f("attachments.signatures.modal.labels.send-emails-and-create-links");
        else return f("default.save-changes");
    };
    const saveActionLabel = getSaveActionLabel();
    const saveAction = {
        content: saveActionLabel,
        onAction: ()=>handleSaveChanges(),
        loading: isSaving,
        disabled: isSaveDisabled || !hasUnsavedChanges
    };
    const cancelAction = {
        content: hasUnsavedChanges ? f("default.cancel") : f("default.close"),
        onAction: ()=>handleCancel()
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
                // modal should remain visible until send email success Toast is displayed
                open: isModalVisible,
                large: true,
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "headingMd",
                    as: "h2",
                    children: title
                }),
                onClose: handleCancel,
                footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignaturesModalFooterDefault.default), {
                    hasUnsavedChanges: hasUnsavedChanges,
                    savedSuccessfully: savedSuccessfully
                }),
                primaryAction: saveAction,
                secondaryActions: [
                    cancelAction
                ],
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingMd",
                                    as: "h2",
                                    children: f("attachments.signatures.modal.heading")
                                }),
                                showError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                                    message: savingError || error
                                }),
                                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingXl",
                                    as: "p",
                                    children: f("default.loading")
                                })
                            ]
                        })
                    }),
                    showTable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignaturesTableDefault.default), {
                        customerId: entity.id,
                        rows: rows,
                        customers: customers,
                        readonly: readonly || !isSignable,
                        ...rowsMethods
                    }),
                    !isSignable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentUnsignableSectionDefault.default), {})
                    }),
                    showSignedDocumentSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignedDocumentSectionDefault.default), {
                            entity: entity,
                            attachment: attachment,
                            readonly: readonly
                        })
                    }),
                    !isAttachmentReadonly && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledStickySection, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addItemButtonDefault.default), {
                                disabled: isSaving || isAttachmentReadonly,
                                onClick: ()=>createRow(),
                                children: f("attachments.signatures.modal.button.add-recipient")
                            })
                        })
                    })
                ]
            }),
            showCancelConfirmation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
                title: f("attachments.cancel.confirmation.title"),
                description: f("attachments.cancel.confirmation.description"),
                onYes: closeModal,
                onNo: ()=>setShowCancelConfirmation(false),
                cancelTitle: f("button.go.back"),
                actionTitle: f("attachments.cancel.confirmation.yes")
            }),
            showSendEmailsToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: f("attachments.signatures.modal.labels.email-sent"),
                onDismiss: handleToastDismiss,
                duration: (0, _durations.DURATION_MEDIUM_IN_MS)
            })
        ]
    });
};
const StyledStickySection = (0, _styledComponentsDefault.default).div`
  position: sticky;
  bottom: 0;
  background-color: var(--p-surface);
  z-index: var(--p-z-1);
  border-top: var(--p-border-divider);
`;
exports.default = AttachmentSignaturesModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../../constants/durations":"5sjIW","../../../../constants/queries-keys":"6hYSF","../../../../helpers/display.helpers":"2q3xY","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useOpenClose":"idooG","../../../../utils/filenameUtils":"2FnJx","../../../../utils/util":"4MniK","../../../AddItemButton/AddItemButton":"8Rs0C","../../../Confirm/Confirm":"nqTPc","../../../ErrorPanel/ErrorPanel":"2hHqH","../../AttachmentsSection.helpers":"faQRx","./AttachmentSignaturesTable/AttachmentSignaturesTable":"kuIGP","./AttachmentSignaturesModalFooter":"5s2ez","./AttachmentSignedDocumentSection":"exlPi","./AttachmentUnsignableSection":"ePvLf","./useAttachmentSignaturesModal":"iggCd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"faQRx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSignedAttachment", ()=>hasSignedAttachment);
parcelHelpers.export(exports, "isAttachmentSigned", ()=>isAttachmentSigned);
parcelHelpers.export(exports, "isAttachmentSignable", ()=>isAttachmentSignable);
parcelHelpers.export(exports, "wasSignedAttachmentDeleted", ()=>wasSignedAttachmentDeleted);
parcelHelpers.export(exports, "mapToAttachmentSignature", ()=>mapToAttachmentSignature);
parcelHelpers.export(exports, "mapToCreateOrUpdateAttachmentSignature", ()=>mapToCreateOrUpdateAttachmentSignature);
var _displayHelpers = require("../../helpers/display.helpers");
var _util = require("../../utils/util");
const hasSignedAttachment = (attachment)=>attachment.signed_document_status === "EXISTS";
const isAttachmentSigned = (attachment)=>attachment.signature_status === "SIGNED";
const isAttachmentSignable = (attachment)=>attachment.signature_status !== "INVALID_FOR_SIGNING";
const wasSignedAttachmentDeleted = (attachment)=>attachment.signed_document_status === "DELETED";
const mapToAttachmentSignature = (saveSignature)=>({
        ...saveSignature,
        fullName: (0, _displayHelpers.getFullName)(saveSignature)
    });
const mapToCreateOrUpdateAttachmentSignature = (signature)=>{
    const { fullName, ...savedAttachmentProps } = (0, _util.removeProperty)(signature, "role");
    const indexOfSeparator = fullName.lastIndexOf(" ");
    // don't send first and last name if role is selected
    const first_name = signature.role ? undefined : fullName.substring(0, indexOfSeparator).trim();
    const last_name = signature.role ? undefined : fullName.substring(indexOfSeparator + 1).trim();
    // return all the signature props except fullName which is locally added
    return {
        ...savedAttachmentProps,
        first_name,
        last_name,
        role_id: signature.role?.id
    };
};

},{"../../helpers/display.helpers":"2q3xY","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kuIGP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _lockSvg = require("../../../../../../assets/icons/lock.svg");
var _lockSvgDefault = parcelHelpers.interopDefault(_lockSvg);
var _roleTypes = require("../../../../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _displayHelpers = require("../../../../../helpers/display.helpers");
var _useFormatMessage = require("../../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _utilities = require("../../../../../types/utilities");
var _copyLabel = require("../../../../CopyLabel/CopyLabel");
var _copyLabelDefault = parcelHelpers.interopDefault(_copyLabel);
var _customDate = require("../../../../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _dataTableCellChild = require("../../../../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _displayName = require("../../../../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _displayTagsWrapper = require("../../../../DisplayTagsWrapper/DisplayTagsWrapper");
var _displayTagsWrapperDefault = parcelHelpers.interopDefault(_displayTagsWrapper);
var _emailOrLinkButtonGroupInput = require("../../../../EmailOrLinkButtonGroupInput/EmailOrLinkButtonGroupInput");
var _emailOrLinkButtonGroupInputDefault = parcelHelpers.interopDefault(_emailOrLinkButtonGroupInput);
var _icon = require("../../../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdktextField = require("../../../../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _position = require("../../../../Position/Position");
var _positionDefault = parcelHelpers.interopDefault(_position);
var _toggleInput = require("../../../../ToggleInput/ToggleInput");
var _toggleInputDefault = parcelHelpers.interopDefault(_toggleInput);
var _attachmentSignatureActions = require("./AttachmentSignatureActions");
var _attachmentSignatureActionsDefault = parcelHelpers.interopDefault(_attachmentSignatureActions);
var _attachmentSignatureEmailOrLinkLabel = require("./AttachmentSignatureEmailOrLinkLabel");
var _attachmentSignatureEmailOrLinkLabelDefault = parcelHelpers.interopDefault(_attachmentSignatureEmailOrLinkLabel);
var _attachmentSignatureNameField = require("./AttachmentSignatureNameField");
var _attachmentSignatureNameFieldDefault = parcelHelpers.interopDefault(_attachmentSignatureNameField);
var _attachmentSignaturesTableHelpers = require("./AttachmentSignaturesTable.helpers");
var _attachmentSignatureStatusLabel = require("./AttachmentSignatureStatusLabel");
var _attachmentSignatureStatusLabelDefault = parcelHelpers.interopDefault(_attachmentSignatureStatusLabel);
var _attachmentTableCell = require("./AttachmentTableCell");
var _attachmentTableCellDefault = parcelHelpers.interopDefault(_attachmentTableCell);
const AttachmentSignaturesTable = (props)=>{
    const { customerId, rows, customers, readonly, editRow, updateProperty, deleteRow, selectSuggestion, clearSuggestion, saveRow, revertEditRow } = props;
    // selected attachment signature id to show copy link modal
    const [showCopyLinkModalRowId, setShowCopyLinkModalRowId] = (0, _react.useState)();
    const f = (0, _useFormatMessageDefault.default)();
    const isInitialState = rows.length === 0 || rows.length === 1 && rows[0].isCreating;
    const selectedSignersIds = rows.map((row)=>row.entity.signer_id);
    const suggestionsToDisplay = (0, _react.useMemo)(()=>{
        // this is a suggestion section with an empty name that holds all the person customers of the project
        // that do not belong to a company customer
        const suggestedPersonSection = {
            name: "",
            suggestions: []
        };
        const customersMap = {
            "": suggestedPersonSection
        };
        (customers || []).forEach((customer)=>{
            if ((0, _utilities.isPersonCustomerDetails)(customer)) // replace customer id with person id in order to provide the signatures API with the right id
            suggestedPersonSection.suggestions.push({
                ...customer,
                id: customer.person_id
            });
            else customersMap[customer.id] = {
                name: (0, _displayHelpers.getCompanyDisplayName)(customer),
                suggestions: customer.roles.map((role)=>({
                        ...role.person,
                        roleId: role.id,
                        roleType: role.type
                    }))
            };
        });
        const allCustomers = Object.values(customersMap);
        return allCustomers.map((customer)=>({
                ...customer,
                suggestions: customer.suggestions.filter((suggestedPerson)=>!selectedSignersIds.includes(suggestedPerson.id))
            }));
    }, [
        customers,
        selectedSignersIds
    ]);
    const getSubtitle = (entity)=>{
        const companyName = (0, _attachmentSignaturesTableHelpers.findPersonCompanyName)(entity.signer_id, customers);
        const roleType = entity.role?.type;
        if (!companyName && !roleType) return undefined;
        const displayLabel = `${roleType ? f((0, _roleTypesDefault.default)[roleType]) : ""}${companyName ? ` - ${companyName}` : ""}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _positionDefault.default), {
            children: displayLabel
        });
    };
    const renderViewRow = (row)=>[
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentTableCellDefault.default), {
                row: row,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayTagsWrapperDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                                name: row.entity.fullName,
                                type: "person",
                                comment: row.entity.role?.comment,
                                subtitle: getSubtitle(row.entity)
                            })
                        }),
                        row.entity.use_verification && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _lockSvgDefault.default)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentTableCellDefault.default), {
                row: row,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignatureEmailOrLinkLabelDefault.default), {
                    attachmentSignature: row.entity
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentTableCellDefault.default), {
                row: row,
                centered: row.entity.pin === undefined,
                children: row.entity.pin ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLabelDefault.default), {
                    size: "slim",
                    children: row.entity.pin
                }) : " - "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentTableCellDefault.default), {
                row: row,
                centered: row.isNew,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignatureStatusLabelDefault.default), {
                    status: row.isNew ? undefined : row.entity.status
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _attachmentTableCellDefault.default), {
                row: row,
                centered: row.entity.signed_dt === undefined,
                children: [
                    row.entity.signed_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                        date: new Date(row.entity.signed_dt).toString()
                    }),
                    !row.entity.signed_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: "-"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignatureActionsDefault.default), {
                customerId: customerId,
                attachmentSignature: row.entity,
                showCopyLinkModal: showCopyLinkModalRowId === row.entity.id,
                readonly: readonly || row.entity.status === "SIGNED",
                setShowCopyLinkModalRowId: setShowCopyLinkModalRowId,
                onModalClose: ()=>setShowCopyLinkModalRowId(undefined),
                onEdit: ()=>editRow(row),
                onDelete: ()=>deleteRow(row)
            })
        ];
    const renderEditRow = (row)=>[
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledEditRow, {
                colSpan: 6,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                    wrap: false,
                    alignment: "fill",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                            fill: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout).Group, {
                                        condensed: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignatureNameFieldDefault.default), {
                                                row: row,
                                                signerSuggestionSections: suggestionsToDisplay,
                                                selectedSignerSuggestionRoleType: row.entity.role?.type,
                                                onSelectSignerSuggestion: selectSuggestion,
                                                onClearSignerSuggestion: clearSuggestion,
                                                onNameChange: (row, name)=>updateProperty(row, "fullName", name)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                                wrap: false,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailOrLinkButtonGroupInputDefault.default), {
                                                        value: row.entity.send_email ? "email" : "link",
                                                        onChange: (value)=>updateProperty(row, "send_email", value === "email")
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack).Item, {
                                                        fill: true,
                                                        children: [
                                                            row.entity.send_email && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                                                label: f("email.placeholder.text"),
                                                                labelHidden: true,
                                                                type: "email",
                                                                autoComplete: "off",
                                                                placeholder: f("email.placeholder.text"),
                                                                value: row.entity.email,
                                                                onChange: (value)=>updateProperty(row, "email", value),
                                                                error: row.validationErrors.get("email"),
                                                                debounceError: true
                                                            }),
                                                            !row.entity.send_email && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWaitForLinkMessage, {
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                                    as: "span",
                                                                    children: f("attachments.signatures.modal.labels.missing-url")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                        alignment: "center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleInputDefault.default), {
                                                checked: row.entity.use_verification,
                                                onChange: ()=>{
                                                    updateProperty(row, "use_verification", !row.entity.use_verification);
                                                    if (!row.entity.use_verification) updateProperty(row, "national_id", undefined);
                                                },
                                                label: f("attachments.signatures.modal.labels.national-id")
                                            }),
                                            row.entity.use_verification && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                                fill: true,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                                    label: f("attachments.signatures.modal.labels.national-id.placeholder", {
                                                        maxDigits: 11
                                                    }),
                                                    labelHidden: true,
                                                    maxLength: 11,
                                                    autoComplete: "off",
                                                    disabled: !row.entity.use_verification,
                                                    placeholder: f("attachments.signatures.modal.labels.national-id.placeholder", {
                                                        maxDigits: 11
                                                    }),
                                                    value: row.entity.national_id,
                                                    onChange: (value)=>updateProperty(row, "national_id", value),
                                                    error: row.validationErrors.get("national_id"),
                                                    debounceError: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledActionButtonsGroup, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.ButtonGroup), {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        outline: true,
                                        destructive: true,
                                        onClick: ()=>row.isCreating ? deleteRow(row) : revertEditRow(row),
                                        children: f("default.cancel")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        outline: true,
                                        disabled: row.validationErrors.size !== 0,
                                        onClick: ()=>saveRow(row),
                                        children: f("default.confirm")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
        verticalAlign: "middle",
        columnContentTypes: [
            "text",
            "text",
            "text",
            "text",
            "text",
            "numeric"
        ],
        headings: isInitialState ? [] : [
            f("table.column.name"),
            f("table.column.email.or.url"),
            f("table.column.pin"),
            f("table.column.status"),
            f("attachments.signatures.modal.table.column.date-signed"),
            ""
        ],
        rows: rows.map((row)=>row.isEditing ? renderEditRow(row) : renderViewRow(row))
    });
};
// edit row should always have a background
// the margin/padding is to overwrite the hover color of the parent row element
const StyledEditRow = (0, _styledComponentsDefault.default)((0, _dataTableCellChildDefault.default))`
  background: white;
  margin: -1rem;
  padding: 1rem;
`;
// necessary styling to center message text vertically
const StyledWaitForLinkMessage = (0, _styledComponentsDefault.default).div`
  display: flex;
  height: 100%;

  & > * {
    margin: auto 0;
  }
`;
const StyledActionButtonsGroup = (0, _styledComponentsDefault.default).div`
  display: flex;
  height: 100%;
  padding-left: 1rem;
  border-left: solid thin #dfe3e8;
`;
exports.default = AttachmentSignaturesTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../../../assets/icons/lock.svg":"6vnRw","../../../../../constants/role-types":"fAycz","../../../../../helpers/display.helpers":"2q3xY","../../../../../hooks/useFormatMessage":"8Y8fq","../../../../../types/utilities":"6zLpB","../../../../CopyLabel/CopyLabel":"4tqGl","../../../../CustomDate/CustomDate":"5KD00","../../../../DataTableCellChild/DataTableCellChild":"boueG","../../../../DisplayName/DisplayName":"gKd5g","../../../../DisplayTagsWrapper/DisplayTagsWrapper":"2idSA","../../../../EmailOrLinkButtonGroupInput/EmailOrLinkButtonGroupInput":"giiOf","../../../../extensions/Icon":"eHSf0","../../../../KDKTextField/KDKTextField":"b5QRp","../../../../Position/Position":"kTPkn","../../../../ToggleInput/ToggleInput":"dDMC1","./AttachmentSignatureActions":"7lxkX","./AttachmentSignatureEmailOrLinkLabel":"loZUd","./AttachmentSignatureNameField":"dibC6","./AttachmentSignaturesTable.helpers":"lmd15","./AttachmentSignatureStatusLabel":"96Q3P","./AttachmentTableCell":"91LHX","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6vnRw":[function(require,module,exports) {
module.exports = require("e7718893e7bb2cf").getBundleURL("kEMsi") + "lock.a8408123.svg";

},{"e7718893e7bb2cf":"75UoR"}],"4tqGl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checkmarkWhiteSvg = require("../../../assets/icons/checkmark-white.svg");
var _checkmarkWhiteSvgDefault = parcelHelpers.interopDefault(_checkmarkWhiteSvg);
var _copySvg = require("../../../assets/icons/copy.svg");
var _copySvgDefault = parcelHelpers.interopDefault(_copySvg);
var _durations = require("../../constants/durations");
var _styles = require("../../constants/styles");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useTimeout = require("../../hooks/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _browserUtils = require("../../utils/browserUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const CopyLabel = (props)=>{
    const { maxWidth, children, ...buttonProps } = props;
    const [isCopied, setCopied] = (0, _react.useState)(false);
    const f = (0, _useFormatMessageDefault.default)();
    const content = children;
    const closeTooltip = ()=>setCopied(false);
    (0, _useTimeoutDefault.default)(()=>setCopied(false), (0, _durations.DURATION_SHORT_IN_MS), isCopied);
    const copyLink = ()=>{
        (0, _browserUtils.copyToClipboard)(content);
        setCopied(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover), {
        preferredPosition: "above",
        fluidContent: true,
        active: isCopied,
        onClose: closeTooltip,
        activator: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTrimmedButtonsWrapper, {
            maxWidth: maxWidth,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.ButtonGroup), {
                segmented: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                        content: f("copy-label.buttons.copy.tooltip"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _copySvgDefault.default)
                            }),
                            ...buttonProps,
                            onClick: copyLink
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                        content: content,
                        preferredPosition: "above",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            ...buttonProps,
                            onClick: copyLink,
                            children: content
                        })
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBanner, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _checkmarkWhiteSvgDefault.default)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: f("modals.copy.link.button.copied")
                })
            ]
        })
    });
};
const StyledBanner = (0, _styledComponentsDefault.default).div`
  display: flex;
  align-items: center;
  gap: var(--p-space-1);
  padding: var(--p-space-2) var(--p-space-3);
  color: var(--p-text-on-dark);
  background: var(--kdk-dark-success);
  stroke: var(--p-text-on-dark);
  fill: var(--p-text-on-dark);
`;
const StyledTrimmedButtonsWrapper = (0, _styledComponentsDefault.default).div`
  & .Polaris-Button__Text {
    max-width: ${({ maxWidth })=>maxWidth || `${0, _styles.COPY_LABEL_MAX_WIDTH_IN_PX}px`};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    // For small viewports - limit maximum width to 220px
    @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
      max-width: ${(0, _styles.COPY_LABEL_MOBILE_MAX_WIDTH_IN_PX)}px;
    }
  }
`;
exports.default = CopyLabel;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/checkmark-white.svg":"28TIk","../../../assets/icons/copy.svg":"9gsmj","../../constants/durations":"5sjIW","../../constants/styles":"dZWds","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useTimeout":"4i6My","../../utils/browserUtils":"4ShiW","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"28TIk":[function(require,module,exports) {
module.exports = require("74c6b6d31368f261").getBundleURL("kEMsi") + "checkmark-white.384db1ed.svg";

},{"74c6b6d31368f261":"75UoR"}],"9gsmj":[function(require,module,exports) {
module.exports = require("be3cb1a769c83b25").getBundleURL("kEMsi") + "copy.8beccb98.svg";

},{"be3cb1a769c83b25":"75UoR"}],"giiOf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const EmailOrLinkButtonGroupInput = (props)=>{
    const { value, onChange, disabled, className, ...buttonGroupProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const isEmail = value === "email";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.ButtonGroup), {
            segmented: true,
            ...buttonGroupProps,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    disabled: disabled,
                    size: "medium",
                    primary: isEmail,
                    onClick: ()=>onChange("email"),
                    children: f("default.email")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    disabled: disabled,
                    size: "medium",
                    primary: !isEmail,
                    onClick: ()=>onChange("link"),
                    children: f("default.link")
                })
            ]
        })
    });
};
exports.default = EmailOrLinkButtonGroupInput;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kTPkn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
const Position = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  text-transform: uppercase;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.default = Position;

},{"styled-components":"eBrdC","../CondensedText/CondensedText":"1FshD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dDMC1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactToggle = require("react-toggle");
var _reactToggleDefault = parcelHelpers.interopDefault(_reactToggle);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styleCss = require("react-toggle/style.css");
const ToggleInput = (props)=>{
    const { label, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "2",
        blockAlign: "center",
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledToggle, {
                id: "toggle",
                ...rest,
                icons: false
            }),
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: label
            })
        ]
    });
};
const StyledToggle = (0, _styledComponentsDefault.default)((0, _reactToggleDefault.default))`
  // Toggle Off
  &.react-toggle .react-toggle-track {
    background-color: var(--p-surface);
    border: solid var(--p-border-width-2) var(--p-border);
    width: 34px;
    height: 18px;
  }

  &.react-toggle .react-toggle-thumb {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: var(--p-border);
    border: none;
  }

  &.react-toggle:hover .react-toggle-track {
    background-color: var(--p-surface-selected-hovered);
  }

  // Toggle On
  &.react-toggle--checked .react-toggle-track {
    background-color: var(--p-surface);
    border-color: var(--kdk-blue-575);
  }

  &.react-toggle--checked .react-toggle-thumb {
    background-color: var(--kdk-blue-575);
    left: 19px;
  }
`;
exports.default = ToggleInput;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-toggle":"1F4mL","@shopify/polaris":"ek5a0","styled-components":"eBrdC","react-toggle/style.css":"hpTOT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1F4mL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("8aef1c092c549134");
var _react2 = _interopRequireDefault(_react);
var _classnames = require("786a6a79c4fb3ccd");
var _classnames2 = _interopRequireDefault(_classnames);
var _propTypes = require("efac1cd510e679d5");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _check = require("381481cf6dfa64e9");
var _check2 = _interopRequireDefault(_check);
var _x = require("f53a5db4c99f3f8d");
var _x2 = _interopRequireDefault(_x);
var _util = require("d8d1d91c25b011e8");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Toggle = function(_PureComponent) {
    _inherits(Toggle, _PureComponent);
    function Toggle(props) {
        _classCallCheck(this, Toggle);
        var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        _this.handleTouchMove = _this.handleTouchMove.bind(_this);
        _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.previouslyChecked = !!(props.checked || props.defaultChecked);
        _this.state = {
            checked: !!(props.checked || props.defaultChecked),
            hasFocus: false
        };
        return _this;
    }
    _createClass(Toggle, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.checked !== this.props.checked) // Disable linting rule here since this usage of setState inside
                // componentDidUpdate is OK; see
                // https://reactjs.org/docs/react-component.html#componentdidupdate
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    checked: !!this.props.checked
                });
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event) {
                if (this.props.disabled) return;
                var checkbox = this.input;
                if (event.target !== checkbox && !this.moved) {
                    this.previouslyChecked = checkbox.checked;
                    event.preventDefault();
                    checkbox.focus();
                    checkbox.click();
                    return;
                }
                var checked = this.props.hasOwnProperty("checked") ? this.props.checked : checkbox.checked;
                this.setState({
                    checked: checked
                });
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart(event) {
                if (this.props.disabled) return;
                this.startX = (0, _util.pointerCoord)(event).x;
                this.activated = true;
            }
        },
        {
            key: "handleTouchMove",
            value: function handleTouchMove(event) {
                if (!this.activated) return;
                this.moved = true;
                if (this.startX) {
                    var currentX = (0, _util.pointerCoord)(event).x;
                    if (this.state.checked && currentX + 15 < this.startX) {
                        this.setState({
                            checked: false
                        });
                        this.startX = currentX;
                        this.activated = true;
                    } else if (currentX - 15 > this.startX) {
                        this.setState({
                            checked: true
                        });
                        this.startX = currentX;
                        this.activated = currentX < this.startX + 5;
                    }
                }
            }
        },
        {
            key: "handleTouchEnd",
            value: function handleTouchEnd(event) {
                if (!this.moved) return;
                var checkbox = this.input;
                event.preventDefault();
                if (this.startX) {
                    var endX = (0, _util.pointerCoord)(event).x;
                    if (this.previouslyChecked === true && this.startX + 4 > endX) {
                        if (this.previouslyChecked !== this.state.checked) {
                            this.setState({
                                checked: false
                            });
                            this.previouslyChecked = this.state.checked;
                            checkbox.click();
                        }
                    } else if (this.startX - 4 < endX) {
                        if (this.previouslyChecked !== this.state.checked) {
                            this.setState({
                                checked: true
                            });
                            this.previouslyChecked = this.state.checked;
                            checkbox.click();
                        }
                    }
                    this.activated = false;
                    this.startX = null;
                    this.moved = false;
                }
            }
        },
        {
            key: "handleFocus",
            value: function handleFocus(event) {
                var onFocus = this.props.onFocus;
                if (onFocus) onFocus(event);
                this.setState({
                    hasFocus: true
                });
            }
        },
        {
            key: "handleBlur",
            value: function handleBlur(event) {
                var onBlur = this.props.onBlur;
                if (onBlur) onBlur(event);
                this.setState({
                    hasFocus: false
                });
            }
        },
        {
            key: "getIcon",
            value: function getIcon(type) {
                var icons = this.props.icons;
                if (!icons) return null;
                return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props = this.props, className = _props.className, _icons = _props.icons, inputProps = _objectWithoutProperties(_props, [
                    "className",
                    "icons"
                ]);
                var classes = (0, _classnames2.default)("react-toggle", {
                    "react-toggle--checked": this.state.checked,
                    "react-toggle--focus": this.state.hasFocus,
                    "react-toggle--disabled": this.props.disabled
                }, className);
                return _react2.default.createElement("div", {
                    className: classes,
                    onClick: this.handleClick,
                    onTouchStart: this.handleTouchStart,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd
                }, _react2.default.createElement("div", {
                    className: "react-toggle-track"
                }, _react2.default.createElement("div", {
                    className: "react-toggle-track-check"
                }, this.getIcon("checked")), _react2.default.createElement("div", {
                    className: "react-toggle-track-x"
                }, this.getIcon("unchecked"))), _react2.default.createElement("div", {
                    className: "react-toggle-thumb"
                }), _react2.default.createElement("input", _extends({}, inputProps, {
                    ref: function ref(_ref) {
                        _this2.input = _ref;
                    },
                    onFocus: this.handleFocus,
                    onBlur: this.handleBlur,
                    className: "react-toggle-screenreader-only",
                    type: "checkbox"
                })));
            }
        }
    ]);
    return Toggle;
}(_react.PureComponent);
exports.default = Toggle;
Toggle.displayName = "Toggle";
Toggle.defaultProps = {
    icons: {
        checked: _react2.default.createElement(_check2.default, null),
        unchecked: _react2.default.createElement(_x2.default, null)
    }
};
Toggle.propTypes = {
    checked: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    defaultChecked: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    className: _propTypes2.default.string,
    name: _propTypes2.default.string,
    value: _propTypes2.default.string,
    id: _propTypes2.default.string,
    "aria-labelledby": _propTypes2.default.string,
    "aria-label": _propTypes2.default.string,
    icons: _propTypes2.default.oneOfType([
        _propTypes2.default.bool,
        _propTypes2.default.shape({
            checked: _propTypes2.default.node,
            unchecked: _propTypes2.default.node
        })
    ])
};

},{"8aef1c092c549134":"cOWTg","786a6a79c4fb3ccd":"2uoUy","efac1cd510e679d5":"jc0Wl","381481cf6dfa64e9":"jIVcj","f53a5db4c99f3f8d":"f13yP","d8d1d91c25b011e8":"au1uP"}],"jIVcj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("f6657ea3b69bc62e");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function() {
    return _react2.default.createElement("svg", {
        width: "14",
        height: "11",
        viewBox: "0 0 14 11"
    }, _react2.default.createElement("path", {
        d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
        fill: "#fff",
        fillRule: "evenodd"
    }));
};

},{"f6657ea3b69bc62e":"cOWTg"}],"f13yP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("58b5453613ef4517");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function() {
    return _react2.default.createElement("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10"
    }, _react2.default.createElement("path", {
        d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
        fill: "#fff",
        fillRule: "evenodd"
    }));
};

},{"58b5453613ef4517":"cOWTg"}],"au1uP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pointerCoord = pointerCoord;
// Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts
function pointerCoord(event) {
    // get coordinates for either a mouse click
    // or a touch depending on the given event
    if (event) {
        var changedTouches = event.changedTouches;
        if (changedTouches && changedTouches.length > 0) {
            var touch = changedTouches[0];
            return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        var pageX = event.pageX;
        if (pageX !== undefined) return {
            x: pageX,
            y: event.pageY
        };
    }
    return {
        x: 0,
        y: 0
    };
}

},{}],"hpTOT":[function() {},{}],"7lxkX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _linkSvg = require("../../../../../../assets/icons/link.svg");
var _linkSvgDefault = parcelHelpers.interopDefault(_linkSvg);
var _pencilSvg = require("../../../../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _remindSvg = require("../../../../../../assets/icons/remind.svg");
var _remindSvgDefault = parcelHelpers.interopDefault(_remindSvg);
var _trashSvg = require("../../../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _useFormatMessage = require("../../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _actionsDropdown = require("../../../../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _confirm = require("../../../../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _copyLinkModal = require("../../../../CopyLinkModal/CopyLinkModal");
var _copyLinkModalDefault = parcelHelpers.interopDefault(_copyLinkModal);
var _remindSignerModal = require("../../../../RemindSignerModal/RemindSignerModal");
var _remindSignerModalDefault = parcelHelpers.interopDefault(_remindSignerModal);
const AttachmentSignatureActions = (props)=>{
    const { customerId, attachmentSignature, showCopyLinkModal, readonly, setShowCopyLinkModalRowId, onModalClose, onEdit, onDelete } = props;
    const [showReminder, toggleReminderModal, closeReminderModal] = (0, _useOpenCloseDefault.default)();
    const [showDeleteConfirmation, setShowDeleteConfirmation] = (0, _react.useState)(false);
    const f = (0, _useFormatMessageDefault.default)();
    const items = [
        {
            content: f("signature.actions.copy.link"),
            image: (0, _linkSvgDefault.default),
            disabled: attachmentSignature.signing_page_url === undefined,
            onAction: ()=>setShowCopyLinkModalRowId(attachmentSignature.id)
        },
        {
            content: f("signature.actions.remind.signer"),
            image: (0, _remindSvgDefault.default),
            disabled: !attachmentSignature.send_email || !attachmentSignature.id,
            onAction: ()=>toggleReminderModal()
        },
        {
            content: f("default.edit"),
            image: (0, _pencilSvgDefault.default),
            onAction: onEdit,
            disabled: readonly
        },
        {
            content: f("modals.delete.signature.button"),
            image: (0, _trashSvgDefault.default),
            onAction: ()=>setShowDeleteConfirmation(true),
            disabled: readonly
        }
    ];
    const handleDelete = ()=>{
        onDelete();
        setShowDeleteConfirmation(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: items,
                hideTitle: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLinkModalDefault.default), {
                title: f("attachments.signatures.modal.copy-link"),
                url: attachmentSignature.signing_page_url,
                open: showCopyLinkModal,
                onModalClose: onModalClose
            }),
            showReminder && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _remindSignerModalDefault.default), {
                open: true,
                customerId: customerId,
                signatureId: attachmentSignature.id,
                email: attachmentSignature.email,
                name: attachmentSignature.fullName,
                onModalClose: closeReminderModal
            }),
            showDeleteConfirmation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
                title: f("modals.delete.signature.button"),
                description: f("modals.delete.signature.description", {
                    name: attachmentSignature.fullName
                }),
                onYes: ()=>handleDelete(),
                onNo: ()=>setShowDeleteConfirmation(false),
                actionTitle: f("modals.delete.signature.button")
            })
        ]
    });
};
exports.default = AttachmentSignatureActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../../../assets/icons/link.svg":"23IE8","../../../../../../assets/icons/pencil.svg":"gEWpJ","../../../../../../assets/icons/remind.svg":"ddhEn","../../../../../../assets/icons/trash.svg":"jqW55","../../../../../hooks/useFormatMessage":"8Y8fq","../../../../../hooks/useOpenClose":"idooG","../../../../ActionsDropdown/ActionsDropdown":"izRYG","../../../../Confirm/Confirm":"nqTPc","../../../../CopyLinkModal/CopyLinkModal":"cWduD","../../../../RemindSignerModal/RemindSignerModal":"fob6T","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"23IE8":[function(require,module,exports) {
module.exports = require("3637f770749b04bb").getBundleURL("kEMsi") + "link.56b9e736.svg";

},{"3637f770749b04bb":"75UoR"}],"ddhEn":[function(require,module,exports) {
module.exports = require("432d075bc42e1d55").getBundleURL("kEMsi") + "remind.148dc4b8.svg";

},{"432d075bc42e1d55":"75UoR"}],"cWduD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _durations = require("../../constants/durations");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useTimeout = require("../../hooks/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _browserUtils = require("../../utils/browserUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CopyLinkModal = (props)=>{
    const { title, url, open, onModalClose } = props;
    const [isCopied, setCopied] = (0, _react.useState)(false);
    const f = (0, _useFormatMessageDefault.default)();
    (0, _useTimeoutDefault.default)(()=>setCopied(false), (0, _durations.DURATION_SHORT_IN_MS), isCopied);
    const copyLink = ()=>{
        (0, _browserUtils.copyToClipboard)(url);
        setCopied(true);
    };
    const closeModal = ()=>onModalClose();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: open,
        onClose: closeModal,
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLink, {
                        children: url
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: closeModal,
                                children: f("default.close")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCopyButton, {
                                monochrome: isCopied,
                                outline: isCopied,
                                primary: !isCopied,
                                success: isCopied,
                                icon: isCopied ? (0, _polarisIcons.CircleTickOutlineMinor) : undefined,
                                onClick: copyLink,
                                children: isCopied ? f("modals.copy.link.button.copied") : f("modals.copy.link.button")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const StyledLink = (0, _styledComponentsDefault.default).div`
  background-color: var(--p-surface-neutral);
  color: var(--p-text-subdued);
  padding: var(--p-space-2);
  border: var(--p-border-divider);
`;
const StyledCopyButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  ${({ success })=>success && `color: var(--kdk-dark-success);`}
`;
exports.default = CopyLinkModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","styled-components":"eBrdC","../../constants/durations":"5sjIW","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useTimeout":"4i6My","../../utils/browserUtils":"4ShiW","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fob6T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _emailView = require("../EmailView/EmailView");
var _emailViewDefault = parcelHelpers.interopDefault(_emailView);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const RemindSignerModal = (props)=>{
    const { customerId, signatureId, email, name, birthdate, open, onModalClose } = props;
    const [showSendEmailsToast, toggleSendEmailsToast, closeSendEmailsToast] = (0, _useOpenCloseDefault.default)();
    const sendReminderMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).remindSigner(customerId, signatureId), {
        onSuccess: ()=>toggleSendEmailsToast()
    });
    const f = (0, _useFormatMessageDefault.default)();
    const sendReminder = ()=>sendReminderMutation.mutate();
    const handleToastDismiss = ()=>{
        closeSendEmailsToast();
        onModalClose();
    };
    return(// modal should remain visible until send email success Toast is displayed
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
                open: open && !showSendEmailsToast,
                onClose: onModalClose,
                title: f("modals.remind.signer.title"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                                type: "person",
                                name: name,
                                birthDate: birthdate
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailViewDefault.default), {
                                children: email
                            }),
                            sendReminderMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                                message: sendReminderMutation.error
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "4",
                                align: "end",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        onClick: onModalClose,
                                        disabled: sendReminderMutation.isLoading,
                                        children: f("default.cancel")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        primary: true,
                                        onClick: sendReminder,
                                        loading: sendReminderMutation.isLoading,
                                        children: f("modals.remind.signer.button")
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            showSendEmailsToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: f("attachments.signatures.modal.labels.email-sent", {
                    count: 1
                }),
                onDismiss: handleToastDismiss,
                duration: 4000
            })
        ]
    }));
};
exports.default = RemindSignerModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../DisplayName/DisplayName":"gKd5g","../EmailView/EmailView":"6hcVY","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6hcVY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _emailSmallSvg = require("../../../assets/icons/email-small.svg");
var _emailSmallSvgDefault = parcelHelpers.interopDefault(_emailSmallSvg);
const StyledEmailView = (0, _styledComponentsDefault.default).div`
  &:before {
    display: inline-block;
    content: ' ';
    background-image: url(${(0, _emailSmallSvgDefault.default)});
    width: 20px;
    height: 12px;
    background-size: 16px 12px;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 10px;
  },
`;
exports.default = StyledEmailView;

},{"styled-components":"eBrdC","../../../assets/icons/email-small.svg":"kmvQO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kmvQO":[function(require,module,exports) {
module.exports = require("8fae511603281625").getBundleURL("kEMsi") + "email-small.c9ba2284.svg";

},{"8fae511603281625":"75UoR"}],"loZUd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _envelopeSvg = require("../../../../../../assets/icons/envelope.svg");
var _envelopeSvgDefault = parcelHelpers.interopDefault(_envelopeSvg);
var _useFormatMessage = require("../../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _copyLabel = require("../../../../CopyLabel/CopyLabel");
var _copyLabelDefault = parcelHelpers.interopDefault(_copyLabel);
var _icon = require("../../../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../../../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const AttachmentSignatureEmailOrLinkLabel = (props)=>{
    const { attachmentSignature } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (attachmentSignature.send_email) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
        content: attachmentSignature.email,
        preferredPosition: "above",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _envelopeSvgDefault.default)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledEmailLabel, {
                    children: attachmentSignature.email
                })
            ]
        })
    });
    if (!attachmentSignature.signing_page_url) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: f("attachments.signatures.modal.labels.missing-url")
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLabelDefault.default), {
        size: "slim",
        maxWidth: "15ch",
        children: attachmentSignature.signing_page_url
    });
};
const StyledEmailLabel = (0, _styledComponentsDefault.default).div`
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.default = AttachmentSignatureEmailOrLinkLabel;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../../../assets/icons/envelope.svg":"2dU70","../../../../../hooks/useFormatMessage":"8Y8fq","../../../../CopyLabel/CopyLabel":"4tqGl","../../../../extensions/Icon":"eHSf0","../../../../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2dU70":[function(require,module,exports) {
module.exports = require("7b9d4c645f8e46a").getBundleURL("kEMsi") + "envelope.52490e19.svg";

},{"7b9d4c645f8e46a":"75UoR"}],"dibC6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _durations = require("../../../../../constants/durations");
var _roleTypes = require("../../../../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _displayHelpers = require("../../../../../helpers/display.helpers");
var _useDebouncedValue = require("../../../../../hooks/useDebouncedValue");
var _useDebouncedValueDefault = parcelHelpers.interopDefault(_useDebouncedValue);
var _useFormatMessage = require("../../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _displayName = require("../../../../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
const AttachmentSignatureNameField = (props)=>{
    const { row, signerSuggestionSections, selectedSignerSuggestionRoleType, onNameChange, onSelectSignerSuggestion, onClearSignerSuggestion } = props;
    const error = row.validationErrors.get("fullName");
    // if there's no error - don't wait to remove the error
    const debouncedError = (0, _useDebouncedValueDefault.default)(error, error ? (0, _durations.ERROR_DEBOUNCE_DELAY_IN_MILLISECONDS) : 0);
    const f = (0, _useFormatMessageDefault.default)();
    const getPersonDisplayName = (person, roleType)=>roleType ? `${(0, _displayHelpers.getFullName)(person)} (${f((0, _roleTypesDefault.default)[roleType])})` : (0, _displayHelpers.getFullName)(person);
    const convertToOption = (suggestedPerson)=>({
            value: suggestedPerson.id,
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                type: "person",
                name: (0, _displayHelpers.getFullName)(suggestedPerson),
                roleType: suggestedPerson.roleType
            })
        });
    const nameOptions = (0, _react.useMemo)(()=>signerSuggestionSections.map((suggestionSection)=>({
                title: suggestionSection.name,
                options: suggestionSection.suggestions.map(convertToOption)
            })), [
        signerSuggestionSections
    ]);
    // this map is used when filtering the suggestions list according to the input value
    const suggestionsRolesMap = (0, _react.useMemo)(()=>new Map(signerSuggestionSections// flatMap converts an array of arrays into a single array ([[obj1], [obj2, obj3], [obj4]] -> [obj1, obj2, obj3, obj4])
        // by creating a new Map with an array of key roles ([role.id, role]) we can access a role by its person id
        .flatMap((suggestionSection)=>suggestionSection.suggestions).map((suggestedPerson)=>[
                suggestedPerson.id,
                suggestedPerson
            ])), [
        signerSuggestionSections
    ]);
    const filterNameOptions = (name)=>nameOptions.map((nameOption)=>({
                ...nameOption,
                options: nameOption.options.filter(({ value })=>{
                    const suggestedPerson = value ? suggestionsRolesMap.get(value) : undefined;
                    if (!suggestedPerson) return true;
                    // search for the suggested person based on its person id and check if their display name
                    // includes the search term
                    return getPersonDisplayName(suggestedPerson, suggestedPerson.roleType).toLowerCase().includes(name.toLowerCase());
                })
            }));
    const handleSuggestionSelect = (0, _react.useCallback)((personId)=>{
        const suggestPerson = suggestionsRolesMap.get(personId);
        onSelectSignerSuggestion({
            row,
            personId: suggestPerson.id,
            personName: (0, _displayHelpers.getFullName)(suggestPerson),
            email: suggestPerson.email,
            roleId: suggestPerson.roleId,
            roleType: suggestPerson.roleType
        });
    }, [
        signerSuggestionSections
    ]);
    const name = row.entity.fullName;
    const signerId = row.entity.signer_id;
    const isSuggestionSelected = signerId !== undefined;
    const displayName = selectedSignerSuggestionRoleType ? `${name} (${f((0, _roleTypesDefault.default)[selectedSignerSuggestionRoleType])})` : name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete), {
        options: signerId ? nameOptions : filterNameOptions(name),
        selected: signerId ? [
            signerId
        ] : [],
        allowMultiple: false,
        onSelect: ([signerId])=>handleSuggestionSelect(signerId),
        textField: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Autocomplete).TextField, {
            label: f("attachments.signatures.modal.name.placeholder"),
            labelHidden: true,
            autoFocus: !row.isLocked && nameOptions.length === 0,
            placeholder: f("attachments.signatures.modal.name.placeholder"),
            readOnly: isSuggestionSelected || row.isLocked,
            value: displayName,
            onChange: (value)=>onNameChange(row, value),
            clearButton: isSuggestionSelected,
            onClearButtonClick: ()=>onClearSignerSuggestion(row),
            error: debouncedError,
            autoComplete: "off"
        })
    });
};
exports.default = AttachmentSignatureNameField;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../../constants/durations":"5sjIW","../../../../../constants/role-types":"fAycz","../../../../../helpers/display.helpers":"2q3xY","../../../../../hooks/useDebouncedValue":"dXquE","../../../../../hooks/useFormatMessage":"8Y8fq","../../../../DisplayName/DisplayName":"gKd5g","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lmd15":[function(require,module,exports) {
// search for a person customer within customers list roles
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findPersonCompanyName", ()=>findPersonCompanyName);
var _displayHelpers = require("../../../../../helpers/display.helpers");
var _utilities = require("../../../../../types/utilities");
const findPersonCompanyName = (personId, customers)=>{
    if (!personId || !customers) return undefined;
    const companyCustomer = customers.find((customer)=>{
        if ((0, _utilities.isPersonCustomerDetails)(customer)) return undefined;
        else // if the customer contains a role with the same person.id then return the customer
        return customer.roles.find((role)=>role.person.id === personId) ? customer : undefined;
    });
    return companyCustomer ? (0, _displayHelpers.getCustomerName)(companyCustomer) : undefined;
};

},{"../../../../../helpers/display.helpers":"2q3xY","../../../../../types/utilities":"6zLpB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"96Q3P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../../../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _attachmentsSectionConstants = require("../../../AttachmentsSection.constants");
const AttachmentSignatureStatusTranslationKeys = {
    PENDING: "attachments.labels.signature-status.pending",
    EXPIRED: "attachments.labels.signature-status.expired",
    SIGNED: "attachments.labels.signature-status.signed",
    INVALID_FOR_SIGNING: "attachments.labels.signature-status.unsignable"
};
const AttachmentSignatureStatusLabel = (props)=>{
    const { status } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!status) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        children: "-"
    });
    const icon = (0, _attachmentsSectionConstants.AttachmentSignatureStatusIconsMap)[status];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        spacing: "extraTight",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: icon
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                children: f(AttachmentSignatureStatusTranslationKeys[status])
            })
        ]
    });
};
exports.default = AttachmentSignatureStatusLabel;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../../hooks/useFormatMessage":"8Y8fq","../../../../extensions/Icon":"eHSf0","../../../AttachmentsSection.constants":"fCLKG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fCLKG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttachmentSignatureStatusIconsMap", ()=>AttachmentSignatureStatusIconsMap);
var _checkmarkGreenSvg = require("../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _hourglassSvg = require("../../../assets/icons/hourglass.svg");
var _hourglassSvgDefault = parcelHelpers.interopDefault(_hourglassSvg);
var _subtractRedSvg = require("../../../assets/icons/subtract-red.svg");
var _subtractRedSvgDefault = parcelHelpers.interopDefault(_subtractRedSvg);
const AttachmentSignatureStatusIconsMap = {
    PENDING: (0, _hourglassSvgDefault.default),
    SIGNED: (0, _checkmarkGreenSvgDefault.default),
    EXPIRED: (0, _subtractRedSvgDefault.default),
    INVALID_FOR_SIGNING: (0, _subtractRedSvgDefault.default)
};

},{"../../../assets/icons/checkmark-green.svg":"8HW5l","../../../assets/icons/hourglass.svg":"4jWqV","../../../assets/icons/subtract-red.svg":"5bCre","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4jWqV":[function(require,module,exports) {
module.exports = require("707c6dd9be79a8b6").getBundleURL("kEMsi") + "hourglass.140e41eb.svg";

},{"707c6dd9be79a8b6":"75UoR"}],"91LHX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const AttachmentTableCell = (props)=>{
    const { row, centered, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledItalic, {
        italic: row.isModified,
        centered: centered,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            color: row.isModified ? "subdued" : undefined,
            children: children
        })
    });
};
const StyledItalic = (0, _styledComponentsDefault.default).span`
  text-align: ${({ centered })=>centered ? "center" : undefined};
  font-style: ${({ italic })=>italic ? "italic" : undefined};
`;
exports.default = AttachmentTableCell;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5s2ez":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checkmarkSvg = require("../../../../../assets/icons/checkmark.svg");
var _checkmarkSvgDefault = parcelHelpers.interopDefault(_checkmarkSvg);
var _infoCircleSvg = require("../../../../../assets/icons/info-circle.svg");
var _infoCircleSvgDefault = parcelHelpers.interopDefault(_infoCircleSvg);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const AttachmentSignaturesModalFooter = (props)=>{
    const { hasUnsavedChanges, savedSuccessfully } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!savedSuccessfully && !hasUnsavedChanges) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledChangeLabel, {
        hasUnsavedChanges: hasUnsavedChanges,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: hasUnsavedChanges ? (0, _infoCircleSvgDefault.default) : (0, _checkmarkSvgDefault.default),
                    useMask: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    variant: "bodySm",
                    as: "p",
                    children: [
                        hasUnsavedChanges && f("attachments.signatures.modal.labels.unsaved-changes"),
                        !hasUnsavedChanges && savedSuccessfully && f("attachments.signatures.modal.labels.saved-changes")
                    ]
                })
            ]
        })
    });
};
const StyledChangeLabel = (0, _styledComponentsDefault.default).div`
  color: ${({ hasUnsavedChanges })=>hasUnsavedChanges ? "var(--p-text-subdued)" : "var(--kdk-dark-success)"};
`;
exports.default = AttachmentSignaturesModalFooter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../../assets/icons/checkmark.svg":"hrEpz","../../../../../assets/icons/info-circle.svg":"7flZk","../../../../hooks/useFormatMessage":"8Y8fq","../../../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hrEpz":[function(require,module,exports) {
module.exports = require("41a96d0eb79e4195").getBundleURL("kEMsi") + "checkmark.20a24c77.svg";

},{"41a96d0eb79e4195":"75UoR"}],"7flZk":[function(require,module,exports) {
module.exports = require("150e6c83027fe52e").getBundleURL("kEMsi") + "info-circle.a67547b4.svg";

},{"150e6c83027fe52e":"75UoR"}],"exlPi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _arrowDownRectangleSvg = require("../../../../../assets/icons/arrow-down-rectangle.svg");
var _arrowDownRectangleSvgDefault = parcelHelpers.interopDefault(_arrowDownRectangleSvg);
var _fileSvg = require("../../../../../assets/icons/file.svg");
var _fileSvgDefault = parcelHelpers.interopDefault(_fileSvg);
var _trashSvg = require("../../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _displayHelpers = require("../../../../helpers/display.helpers");
var _useAttachmentDownload = require("../../../../hooks/useAttachmentDownload");
var _useAttachmentDownloadDefault = parcelHelpers.interopDefault(_useAttachmentDownload);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _filenameUtils = require("../../../../utils/filenameUtils");
var _actionsDropdown = require("../../../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _button = require("../../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _attachmentsSectionHelpers = require("../../AttachmentsSection.helpers");
var _deleteAttachmentConfirmation = require("../DeleteAttachmentConfirmation");
var _deleteAttachmentConfirmationDefault = parcelHelpers.interopDefault(_deleteAttachmentConfirmation);
const AttachmentSignedDocumentSection = (props)=>{
    const { entity, attachment, readonly } = props;
    const [showDeleteConfirmation, setShowDeleteConfirmation] = (0, _react.useState)(false);
    const f = (0, _useFormatMessageDefault.default)();
    const intl = (0, _reactIntl.useIntl)();
    const downloadAttachmentMutation = (0, _useAttachmentDownloadDefault.default)(entity, attachment);
    const hasSignedAttachmentFile = (0, _attachmentsSectionHelpers.hasSignedAttachment)(attachment);
    const hasSignedAttachmentDeleted = (0, _attachmentsSectionHelpers.wasSignedAttachmentDeleted)(attachment);
    const filename = (0, _filenameUtils.cleanupFilename)(attachment.filename);
    const name = (0, _displayHelpers.getFullName)(attachment.signed_document_deleted_by);
    const date = intl.formatDate(attachment.signed_document_deleted_timestamp);
    const actions = [
        {
            content: f("attachments.actions.download-signed-attachment"),
            image: (0, _arrowDownRectangleSvgDefault.default),
            disabled: downloadAttachmentMutation.isLoading,
            prefix: downloadAttachmentMutation.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            }) : null,
            onAction: ()=>downloadAttachmentMutation.mutate({
                    downloadSignedAttachment: true
                })
        },
        {
            content: f("attachments.actions.delete-signed-attachment"),
            image: (0, _trashSvgDefault.default),
            onAction: ()=>setShowDeleteConfirmation(true),
            disabled: readonly || downloadAttachmentMutation.isLoading
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "headingMd",
                as: "h2",
                children: f("attachments.actions.section.signed.document.title")
            }),
            hasSignedAttachmentFile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                blockAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDownloadSignedDocumentButton, {
                        plain: true,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: (0, _fileSvgDefault.default)
                        }),
                        truncate: true,
                        textAlign: "left",
                        loading: downloadAttachmentMutation.isLoading,
                        onClick: ()=>downloadAttachmentMutation.mutate({
                                downloadSignedAttachment: true
                            }),
                        children: filename
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                        items: actions,
                        hideTitle: true
                    })
                ]
            }),
            hasSignedAttachmentDeleted && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDeleteMessage, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    color: "subdued",
                    children: f("attachments.signatures.modal.labels.deleted-signed-document", {
                        name,
                        date
                    })
                })
            }),
            showDeleteConfirmation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteAttachmentConfirmationDefault.default), {
                entity: entity,
                attachment: attachment,
                deleteSignedAttachment: true,
                onModalClose: ()=>setShowDeleteConfirmation(false)
            })
        ]
    });
};
const StyledDownloadSignedDocumentButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  margin-left: -0.625rem;
  display: inline-block;
`;
const StyledDeleteMessage = (0, _styledComponentsDefault.default).div`
  font-style: italic;
`;
exports.default = AttachmentSignedDocumentSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../../assets/icons/arrow-down-rectangle.svg":"TDXIu","../../../../../assets/icons/file.svg":"bLqMZ","../../../../../assets/icons/trash.svg":"jqW55","../../../../helpers/display.helpers":"2q3xY","../../../../hooks/useAttachmentDownload":"7Wv1D","../../../../hooks/useFormatMessage":"8Y8fq","../../../../utils/filenameUtils":"2FnJx","../../../ActionsDropdown/ActionsDropdown":"izRYG","../../../extensions/Button":"8exc0","../../AttachmentsSection.helpers":"faQRx","../DeleteAttachmentConfirmation":"dazDM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bLqMZ":[function(require,module,exports) {
module.exports = require("d3d9cf1670384a50").getBundleURL("kEMsi") + "file.e4449673.svg";

},{"d3d9cf1670384a50":"75UoR"}],"7Wv1D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _downloadUtils = require("../utils/downloadUtils");
var _downloadUtilsDefault = parcelHelpers.interopDefault(_downloadUtils);
var _filenameUtils = require("../utils/filenameUtils");
var _useAttachmentsAPI = require("./useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
const useAttachmentDownload = (entity, attachment)=>{
    const { entityId, downloadAttachment, downloadSignedDocumentAttachment } = (0, _useAttachmentsAPIDefault.default)(entity, attachment);
    return (0, _reactQuery.useMutation)(async (params)=>{
        const data = params?.downloadSignedAttachment ? await downloadSignedDocumentAttachment(entityId, attachment.id) : await downloadAttachment(entityId, attachment.id);
        const filename = (0, _filenameUtils.addSuffixToFilename)((0, _filenameUtils.cleanupFilename)(attachment.filename), params?.downloadSignedAttachment ? " - signed" : "");
        return (0, _downloadUtilsDefault.default)(data?.download_url, filename);
    });
};
exports.default = useAttachmentDownload;

},{"@tanstack/react-query":"91Vyq","../utils/downloadUtils":"kTJ5o","../utils/filenameUtils":"2FnJx","./useAttachmentsAPI":"7xA5e","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dazDM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _queriesKeys = require("../../../constants/queries-keys");
var _useAttachmentsAPI = require("../../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _filenameUtils = require("../../../utils/filenameUtils");
var _confirm = require("../../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
const DeleteAttachmentConfirmation = (props)=>{
    const { entity, attachment, deleteSignedAttachment, onModalClose } = props;
    const queryClient = (0, _reactQuery.useQueryClient)();
    const f = (0, _useFormatMessageDefault.default)();
    const { entityId, deleteAttachment, deleteSignedAttachment: deleteSignedAttachmentCall } = (0, _useAttachmentsAPIDefault.default)(entity, attachment);
    const mutation = (0, _reactQuery.useMutation)(()=>deleteSignedAttachment ? deleteSignedAttachmentCall(entityId, attachment.id) : deleteAttachment(entityId, attachment.id), {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
                entityId
            ]);
            // if the attachment was from an assignment it means that entity is a customer
            // and it's cache should also be invalidated
            if (attachment.assignment_id) await queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
                entity.id
            ]);
            onModalClose();
        }
    });
    const filename = (0, _filenameUtils.cleanupFilename)(attachment.filename);
    const title = deleteSignedAttachment ? f("attachments.delete.confirmation.signed.title") : f("attachments.delete.confirmation.title");
    const description = deleteSignedAttachment ? f("attachments.delete.confirmation.signed.description", {
        name: filename
    }) : f("attachments.delete.confirmation.description", {
        name: filename
    });
    const deleteActionTitle = deleteSignedAttachment ? f("attachments.delete.confirmation.signed.yes") : f("attachments.delete.confirmation.yes");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
        title: title,
        description: description,
        onYes: ()=>mutation.mutate(),
        onNo: onModalClose,
        actionTitle: deleteActionTitle,
        isActionInProgress: mutation.isLoading,
        error: mutation.error
    });
};
exports.default = DeleteAttachmentConfirmation;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","../../../constants/queries-keys":"6hYSF","../../../hooks/useAttachmentsAPI":"7xA5e","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/filenameUtils":"2FnJx","../../Confirm/Confirm":"nqTPc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ePvLf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const AttachmentUnsignableSection = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "headingMd",
                as: "h2",
                children: f("attachments.signatures.modal.labels.unsignable-attachment")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("attachments.signatures.modal.descriptions.unsignable-attachment")
            })
        ]
    });
};
exports.default = AttachmentUnsignableSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iggCd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _queriesKeys = require("../../../../constants/queries-keys");
var _useAttachmentsAPI = require("../../../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _stringUtils = require("../../../../utils/stringUtils");
var _attachmentsSectionHelpers = require("../../AttachmentsSection.helpers");
var _attachmentSignaturesModalHelpers = require("./AttachmentSignaturesModal.helpers");
var _useEditableRows = require("./useEditableRows");
var _useEditableRowsDefault = parcelHelpers.interopDefault(_useEditableRows);
const hasUnsentEmail = (row)=>row.entity.send_email && (row.isNew || row.originalEntity?.email !== row.entity.email);
const hasUnsavedLink = (row)=>!row.entity.send_email && row.isNew;
const useAttachmentSignaturesModal = (entity, attachment)=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const f = (0, _useFormatMessageDefault.default)();
    const { entityId, getAttachmentSignatures, updateAttachmentSignatures } = (0, _useAttachmentsAPIDefault.default)(entity, attachment);
    const attachmentsSignaturesQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENT_SIGNATURES,
        entityId,
        attachment.id
    ];
    const { setQueryData } = (0, _useQueryDataDefault.default)(attachmentsSignaturesQueryKey);
    const { isLoading, isError: isLoadingError, error: loadingError, data } = (0, _reactQuery.useQuery)(attachmentsSignaturesQueryKey, ()=>getAttachmentSignatures(entityId, attachment.id));
    const saveAttachmentSignaturesMutation = (0, _reactQuery.useMutation)(({ updateAttachmentSignaturesRequest })=>updateAttachmentSignatures(entityId, attachment.id, updateAttachmentSignaturesRequest), {
        onSuccess: (response)=>{
            setQueryData(response);
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
                entityId
            ]);
        }
    });
    const attachedSignatures = (0, _react.useMemo)(()=>(data?.signatures || []).map((0, _attachmentsSectionHelpers.mapToAttachmentSignature)), [
        data
    ]);
    const { rows, updateProperty, saveRow, ...rowsMethods } = (0, _useEditableRowsDefault.default)({
        entities: attachedSignatures,
        createEmptyEntity: ()=>({
                id: String("new-row-" + Math.round(Math.random() * 1000000)),
                fullName: "",
                send_email: true,
                use_verification: false,
                signing_page_url: "",
                pin: "",
                status: "PENDING"
            }),
        isValidEntity: (entity, rows)=>{
            const validationErrors = new Map();
            // validate name
            const nameValidationError = (0, _attachmentSignaturesModalHelpers.isNameValid)(entity.fullName);
            if (nameValidationError) validationErrors.set("fullName", f(nameValidationError));
            else {
                const nonEmptyNames = rows.map((row)=>row.entity.fullName.trim().toLowerCase()).filter(Boolean);
                const allNames = new Set(nonEmptyNames);
                const isUniqueName = allNames.size === nonEmptyNames.length;
                if (!isUniqueName) validationErrors.set("fullName", f("common.errors.invalid.name.exists"));
            }
            // validate email
            const isEmailValid = !entity.send_email || (0, _stringUtils.isEmail)(entity.email);
            if (!isEmailValid) validationErrors.set("email", f("email.invalid.address.error"));
            else {
                const allEmails = rows.map((row)=>row.entity.email?.toLowerCase());
                const isUniqueEmail = !entity.send_email || allEmails.indexOf(entity.email?.toLowerCase()) === allEmails.lastIndexOf(entity.email?.toLowerCase());
                if (!isUniqueEmail) validationErrors.set("email", f("common.errors.email.not-unique"));
            }
            // validate national id
            const isValidNationalId = !entity.use_verification || (0, _attachmentSignaturesModalHelpers.isNationalIdValid)(entity.national_id);
            if (!isValidNationalId) validationErrors.set("national_id", f("common.errors.invalid.person.national-id"));
            else {
                const allNationalIds = rows.map((row)=>row.entity.national_id?.toLowerCase());
                const isUniqueNationalId = allNationalIds.indexOf(entity.national_id?.toLowerCase()) === allNationalIds.lastIndexOf(entity.national_id?.toLowerCase());
                if (entity.use_verification && !isUniqueNationalId) validationErrors.set("national_id", f("common.errors.invalid.national-id.exists"));
            }
            return validationErrors;
        },
        isEqualEntity: (firstEntity, secondEntity)=>{
            return firstEntity.fullName === secondEntity.fullName && firstEntity.send_email === secondEntity.send_email && firstEntity.email === secondEntity.email && firstEntity.role?.id === secondEntity.role?.id && firstEntity.use_verification === secondEntity.use_verification && firstEntity.national_id === secondEntity.national_id;
        }
    });
    const saveChanges = ()=>{
        const currentAttachmentSignatures = rows// remove local id from new rows
        .map((row)=>row.isNew ? {
                ...row.entity,
                id: undefined
            } : row.entity).map((0, _attachmentsSectionHelpers.mapToCreateOrUpdateAttachmentSignature));
        const previousAttachmentSignaturesCount = data?.signatures?.length || 0;
        // tells the server to delete the signicat document associated with signatures for this attachment
        const deleteSignaturesDocument = previousAttachmentSignaturesCount > 0 && currentAttachmentSignatures.length === 0;
        return saveAttachmentSignaturesMutation.mutateAsync({
            updateAttachmentSignaturesRequest: {
                signatures: currentAttachmentSignatures,
                delete: deleteSignaturesDocument
            }
        });
    };
    const selectSuggestion = ({ row, personId, personName, email, roleId, roleType })=>{
        updateProperty(row, "signer_id", personId);
        updateProperty(row, "fullName", personName);
        updateProperty(row, "email", email);
        updateProperty(row, "role", roleId ? {
            id: roleId,
            type: roleType,
            status: "ACTIVE"
        } : undefined);
    };
    const clearSuggestion = (row)=>{
        updateProperty(row, "signer_id", undefined);
        updateProperty(row, "fullName", "");
        updateProperty(row, "email", "");
        updateProperty(row, "role", undefined);
    };
    const handleSaveRow = (row)=>{
        if (!row.entity.send_email) row.entity.email = undefined;
        saveRow(row);
    };
    const hasInvalidRows = rows.find((row)=>row.isCreating || row.validationErrors.size !== 0) !== undefined;
    const hasUnsavedChanges = !hasInvalidRows && (rows.find((row)=>row.isModified) !== undefined || rows.length !== attachedSignatures.length);
    const isEmailOnly = rows.find((row)=>!row.entity.send_email) === undefined;
    const isLinkOnly = rows.find((row)=>row.entity.send_email) === undefined;
    const hasUnsentEmails = rows.filter(hasUnsentEmail).length > 0;
    const hasUnsavedLinks = rows.filter(hasUnsavedLink).length > 0;
    return {
        isLoading,
        isError: isLoadingError,
        error: loadingError || saveAttachmentSignaturesMutation.error,
        isInitialEmpty: !isLoading && data?.signatures.length === 0,
        isSaving: saveAttachmentSignaturesMutation.isLoading,
        hasInvalidRows,
        hasUnsavedChanges,
        isEmailOnly,
        isLinkOnly,
        hasUnsentEmails,
        hasUnsavedLinks,
        rows,
        updateProperty,
        saveRow: handleSaveRow,
        saveChanges,
        selectSuggestion,
        clearSuggestion,
        ...rowsMethods
    };
};
exports.default = useAttachmentSignaturesModal;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../../../../constants/queries-keys":"6hYSF","../../../../hooks/useAttachmentsAPI":"7xA5e","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useQueryData":"4laI9","../../../../utils/stringUtils":"4gVdA","../../AttachmentsSection.helpers":"faQRx","./AttachmentSignaturesModal.helpers":"2SyJ6","./useEditableRows":"76wlO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2SyJ6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNationalIdValid", ()=>isNationalIdValid);
parcelHelpers.export(exports, "isNameValid", ()=>isNameValid);
var _norwegianNationalIdValidator = require("norwegian-national-id-validator");
var NameValidationErrorType;
(function(NameValidationErrorType) {
    NameValidationErrorType["EMPTY"] = "common.errors.invalid.empty.name";
    NameValidationErrorType["MISSING_LAST_NAME"] = "common.errors.invalid.missing.last.name";
    NameValidationErrorType["INVALID_FIRST_NAME"] = "common.errors.invalid.first.name";
    NameValidationErrorType["INVALID_LAST_NAME"] = "common.errors.invalid.last.name";
})(NameValidationErrorType || (NameValidationErrorType = {}));
const isNationalIdValid = (nationalId)=>nationalId && (0, _norwegianNationalIdValidator.validateNorwegianIdNumber)(nationalId);
const isNameValid = (name)=>{
    if (!name || name.trim().length === 0) return "common.errors.invalid.empty.name";
    name = name.trim();
    const lastSeparatorIndex = name.lastIndexOf(" ");
    if (lastSeparatorIndex <= 0) {
        if (name.length < 2) return "common.errors.invalid.first.name";
        else return "common.errors.invalid.missing.last.name";
    }
    const lastName = name.substring(lastSeparatorIndex + 1);
    if (lastName.length < 2) return "common.errors.invalid.last.name";
};

},{"norwegian-national-id-validator":"02IMN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"76wlO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// converts an existing entity to a row
const convertToRow = (entity)=>({
        isNew: false,
        isCreating: false,
        isEditing: false,
        isModified: false,
        isLocked: false,
        validationErrors: new Map(),
        entity,
        originalEntity: {
            ...entity
        }
    });
/**
 * This hook is used to manage a list of editable rows
 *
 * Each row holds an entity and additional properties to indicate the row state
 * The hook provides functions to add/modify/delete rows
 * and returns a list of the current rows
 *
 * @param props
 */ const useEditableRows = (props)=>{
    const { entities, createEmptyEntity, isValidEntity, isEqualEntity } = props;
    const [rows, setRows] = (0, _react.useState)(entities.map(convertToRow));
    (0, _react.useEffect)(()=>{
        if (JSON.stringify(entities) !== JSON.stringify(rows.map((row)=>row.entity))) setRows(entities.map(convertToRow));
    }, [
        entities
    ]);
    const validateRows = (rowsToValidate = rows)=>{
        rowsToValidate.forEach((row)=>{
            row.validationErrors = isValidEntity(row.entity, rowsToValidate);
        });
    };
    // creates a new empty row and add it to the rows list
    const createRow = (defaultValues, isLocked)=>{
        const row = {
            isNew: true,
            isCreating: true,
            isEditing: true,
            isModified: false,
            isLocked: Boolean(isLocked),
            validationErrors: new Map().set("id", ""),
            entity: {
                ...createEmptyEntity(),
                ...defaultValues
            }
        };
        setRows((prevState)=>[
                ...prevState,
                row
            ]);
    };
    const saveRow = (row)=>{
        if (row.isCreating) {
            row.isCreating = false;
            row.isModified = true;
            row.originalEntity = {
                ...row.entity
            };
        }
        row.isEditing = false;
        setRow(row);
    };
    // removes the row to be deleted from the rows list
    const deleteRow = (row)=>{
        setRows((prevState)=>{
            const updatedRows = prevState.filter((currentRow)=>currentRow.entity.id !== row.entity.id);
            validateRows(updatedRows);
            return updatedRows;
        });
    };
    // updates a property on the row's entity
    const updateProperty = (row, key, value)=>{
        row.entity = {
            ...row.entity,
            [key]: value
        };
        row.isModified = row.originalEntity ? !isEqualEntity(row.entity, row.originalEntity) : true;
        validateRows();
        setRow(row);
    };
    // starts editing mode for the given row
    const editRow = (row)=>{
        row.isEditing = true;
        setRow(row);
    };
    // cancel changes to the given row
    const revertEditRow = (row)=>{
        row.isEditing = false;
        if (row.originalEntity) row.entity = {
            ...row.originalEntity
        };
        setRow(row);
    };
    // updates the rows list
    const setRow = (row)=>{
        setRows(rows.map((currentRow)=>currentRow.entity.id === row.entity.id ? {
                ...row
            } : currentRow));
    };
    return {
        rows,
        createRow,
        editRow,
        updateProperty,
        deleteRow,
        saveRow,
        revertEditRow
    };
};
exports.default = useEditableRows;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"87S3K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetAttachmentsDisplayTitle = require("../../hooks/useGetAttachmentsDisplayTitle");
var _useGetAttachmentsDisplayTitleDefault = parcelHelpers.interopDefault(_useGetAttachmentsDisplayTitle);
var _planConversionBanner = require("../PlanConversionBanner/PlanConversionBanner");
var _planConversionBannerDefault = parcelHelpers.interopDefault(_planConversionBanner);
const AttachmentsPlanConversionBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const attachmentsDisplayTitle = (0, _useGetAttachmentsDisplayTitleDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "headingMd",
                    as: "h2",
                    children: attachmentsDisplayTitle
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planConversionBannerDefault.default), {
                        content: f("plan-conversion.attachments.description")
                    })
                })
            })
        ]
    });
};
exports.default = AttachmentsPlanConversionBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetAttachmentsDisplayTitle":"e3tqV","../PlanConversionBanner/PlanConversionBanner":"78R1i","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l2FqJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _filenameUtils = require("../../utils/filenameUtils");
var _assignmentInfo = require("../AssignmentInfo/AssignmentInfo");
var _assignmentInfoDefault = parcelHelpers.interopDefault(_assignmentInfo);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _attachmentActions = require("./AttachmentActions/AttachmentActions");
var _attachmentActionsDefault = parcelHelpers.interopDefault(_attachmentActions);
var _attachmentDownloadButton = require("./AttachmentDownloadButton");
var _attachmentDownloadButtonDefault = parcelHelpers.interopDefault(_attachmentDownloadButton);
var _attachmentSignaturesStatus = require("./AttachmentSignaturesStatus");
var _attachmentSignaturesStatusDefault = parcelHelpers.interopDefault(_attachmentSignaturesStatus);
var _attachmentUploader = require("./AttachmentUploader");
var _attachmentUploaderDefault = parcelHelpers.interopDefault(_attachmentUploader);
const AttachmentsTable = (props)=>{
    const { entity, attachments, uploadingFilesCount, readonly, hideSignatures, onAttachmentSelected } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const { formatDate } = (0, _reactIntl.useIntl)();
    const [sortState, setSortState] = (0, _react.useState)({
        headerIndex: 0,
        direction: "none"
    });
    const signaturesEnabled = features.ELECTRONIC_SIGNATURES && !hideSignatures;
    const handleStatusClick = (attachment)=>{
        const isPDF = (0, _filenameUtils.isPDFAttachment)(attachment);
        if (isPDF) onAttachmentSelected(attachment);
    };
    const renderRow = (attachment)=>{
        const row = [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentDownloadButtonDefault.default), {
                entity: entity,
                attachment: attachment
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                truncate: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                            content: attachment.assignment_name,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentInfoDefault.default), {
                                assignmentName: attachment.assignment_name,
                                assignmentPurpose: attachment.assignment_purpose,
                                isArchived: attachment.assignment_is_archived
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            truncate: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentUploaderDefault.default), {
                                    user: attachment.created_by
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                date: new Date(attachment.created_dt).toString()
            })
        ];
        if (signaturesEnabled) row.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentSignaturesStatusDefault.default), {
            attachment: attachment,
            onClick: ()=>handleStatusClick(attachment)
        }));
        row.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentActionsDefault.default), {
            entity: entity,
            attachment: attachment,
            readonly: readonly,
            signaturesEnabled: signaturesEnabled,
            onSelectAttachment: onAttachmentSelected
        }));
        return row;
    };
    const tableContentTypes = signaturesEnabled ? [
        "text",
        "text",
        "text",
        "text",
        "numeric"
    ] : [
        "text",
        "text",
        "text",
        "numeric"
    ];
    const tableHeadings = [
        f("attachments.table.header.document"),
        `${f("attachments.table.header.assignment")} / ${f("attachments.table.header.created.by")}`,
        f("attachments.table.header.created.date")
    ];
    if (signaturesEnabled) tableHeadings.push(f("attachments.table.header.signature-status"));
    // an empty header for the actions column
    tableHeadings.push("");
    const getSortValue = (0, _react.useCallback)((attachment)=>{
        switch(sortState.headerIndex){
            case 0:
                return (0, _filenameUtils.cleanupFilename)(attachment.filename) || "";
            case 1:
                return attachment.assignment_name || getUserDisplayName(attachment.created_by);
            case 2:
                return formatDate(new Date(attachment.created_dt));
            case 3:
                return attachment.signature_status || "";
            default:
                return "";
        }
    }, [
        sortState.headerIndex
    ]);
    const rows = (0, _react.useMemo)(()=>{
        const sortedAttachments = [
            ...attachments
        ];
        if (sortState.direction !== "none") sortedAttachments.sort((a1, a2)=>getSortValue(a1).localeCompare(getSortValue(a2)) * (sortState.direction === "ascending" ? 1 : -1));
        return sortedAttachments.map((attachment)=>renderRow(attachment));
    }, [
        attachments,
        sortState.headerIndex,
        sortState.direction
    ]);
    const handleSort = (headerIndex, direction)=>setSortState({
            headerIndex,
            direction
        });
    const rowsToRender = uploadingFilesCount > 0 ? [
        [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("attachments.table.messages.uploading", {
                            count: uploadingFilesCount
                        })
                    })
                ]
            })
        ],
        ...rows
    ] : rows;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
        truncate: true,
        columnContentTypes: tableContentTypes,
        headings: tableHeadings,
        rows: rowsToRender,
        sortable: [
            true,
            true,
            true,
            true,
            true,
            false
        ],
        onSort: handleSort,
        hideScrollIndicator: true
    });
};
exports.default = AttachmentsTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../utils/filenameUtils":"2FnJx","../AssignmentInfo/AssignmentInfo":"ds7XR","../CondensedText/CondensedText":"1FshD","../CustomDate/CustomDate":"5KD00","../TooltipWrapper/TooltipWrapper":"b5W2d","./AttachmentActions/AttachmentActions":"idI9g","./AttachmentDownloadButton":"gYDXI","./AttachmentSignaturesStatus":"bU8fx","./AttachmentUploader":"2KwoT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ds7XR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _projectSvg = require("../../../assets/icons/project.svg");
var _projectSvgDefault = parcelHelpers.interopDefault(_projectSvg);
var _useGetAssignmentIndustriesAndPurposes = require("../../hooks/useGetAssignmentIndustriesAndPurposes");
var _useGetAssignmentIndustriesAndPurposesDefault = parcelHelpers.interopDefault(_useGetAssignmentIndustriesAndPurposes);
var _archivedBadge = require("../ArchivedBadge/ArchivedBadge");
var _archivedBadgeDefault = parcelHelpers.interopDefault(_archivedBadge);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const AssignmentInfo = (props)=>{
    const { assignmentName, assignmentPurpose, isArchived, assignmentStartDate } = props;
    const { getPurposeLabel } = (0, _useGetAssignmentIndustriesAndPurposesDefault.default)();
    if (!assignmentName && !assignmentPurpose) return null;
    const purpose = getPurposeLabel(assignmentPurpose);
    const { formatDate } = (0, _reactIntl.useIntl)();
    const formattedStartDate = formatDate(assignmentStartDate);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWrapper, {
        title: assignmentName,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "baseline",
            wrap: false,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _projectSvgDefault.default),
                    width: "16px",
                    height: "12px"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledWrapper, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            truncate: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "bold",
                                    children: assignmentName
                                }),
                                assignmentName && assignmentStartDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "regular",
                                    children: ` - ${formattedStartDate}`
                                })
                            ]
                        }),
                        purpose && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInfoText, {
                            children: purpose
                        })
                    ]
                }),
                isArchived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archivedBadgeDefault.default), {})
            ]
        })
    });
};
const StyledWrapper = (0, _styledComponentsDefault.default).div`
  line-height: var(--p-font-line-height-1);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const StyledInfoText = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  font-weight: var(--p-font-weight-bold);
  display: inline-block;
`;
exports.default = AssignmentInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/project.svg":"b4tRC","../../hooks/useGetAssignmentIndustriesAndPurposes":"d3Dsc","../ArchivedBadge/ArchivedBadge":"8eATJ","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"idI9g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _arrowDownRectangleSvg = require("../../../../assets/icons/arrow-down-rectangle.svg");
var _arrowDownRectangleSvgDefault = parcelHelpers.interopDefault(_arrowDownRectangleSvg);
var _penLineSvg = require("../../../../assets/icons/pen-line.svg");
var _penLineSvgDefault = parcelHelpers.interopDefault(_penLineSvg);
var _trashSvg = require("../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _useAttachmentDownload = require("../../../hooks/useAttachmentDownload");
var _useAttachmentDownloadDefault = parcelHelpers.interopDefault(_useAttachmentDownload);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _filenameUtils = require("../../../utils/filenameUtils");
var _actionsDropdown = require("../../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _attachmentsSectionHelpers = require("../AttachmentsSection.helpers");
var _deleteAttachmentConfirmation = require("./DeleteAttachmentConfirmation");
var _deleteAttachmentConfirmationDefault = parcelHelpers.interopDefault(_deleteAttachmentConfirmation);
const AttachmentActions = (props)=>{
    const { entity, attachment, readonly, signaturesEnabled, onSelectAttachment } = props;
    const [deleteConfirmationModalState, setDeleteConfirmationModalState] = (0, _react.useState)({
        open: false,
        deleteSignedAttachment: false
    });
    const f = (0, _useFormatMessageDefault.default)();
    const closeDeleteModal = ()=>setDeleteConfirmationModalState({
            ...deleteConfirmationModalState,
            open: false
        });
    const downloadAttachmentMutation = (0, _useAttachmentDownloadDefault.default)(entity, attachment);
    const actions = [];
    const isSigned = (0, _attachmentsSectionHelpers.isAttachmentSigned)(attachment);
    const isSignable = (0, _attachmentsSectionHelpers.isAttachmentSignable)(attachment);
    const hasSignedAttachmentFile = (0, _attachmentsSectionHelpers.hasSignedAttachment)(attachment);
    if (signaturesEnabled && isSignable) {
        const isPDF = (0, _filenameUtils.isPDFAttachment)(attachment);
        actions.push({
            content: readonly || isSigned ? f("attachments.actions.view-signature") : f("attachments.actions.edit-signature"),
            image: (0, _penLineSvgDefault.default),
            onAction: ()=>onSelectAttachment(attachment),
            disabled: !isPDF || downloadAttachmentMutation.isLoading,
            helpText: !isPDF ? f("attachments.actions.signature.help-text") : undefined
        });
    }
    if (isSignable) actions.push({
        content: f("attachments.actions.download-attachment"),
        image: (0, _arrowDownRectangleSvgDefault.default),
        disabled: downloadAttachmentMutation.isLoading,
        prefix: downloadAttachmentMutation.isLoading && !downloadAttachmentMutation.variables?.downloadSignedAttachment ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
            size: "small"
        }) : null,
        onAction: ()=>downloadAttachmentMutation.mutate({
                downloadSignedAttachment: false
            })
    });
    actions.push({
        content: f("attachments.actions.delete-attachment"),
        image: (0, _trashSvgDefault.default),
        onAction: ()=>setDeleteConfirmationModalState({
                open: true,
                deleteSignedAttachment: false
            }),
        disabled: readonly || isSigned || downloadAttachmentMutation.isLoading
    });
    const signedAttachmentSection = {
        title: f("attachments.actions.section.signed.document.title"),
        items: [
            {
                content: f("attachments.actions.download-signed-attachment"),
                image: (0, _arrowDownRectangleSvgDefault.default),
                disabled: downloadAttachmentMutation.isLoading,
                prefix: downloadAttachmentMutation.isLoading && downloadAttachmentMutation.variables?.downloadSignedAttachment ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                    size: "small"
                }) : null,
                onAction: ()=>downloadAttachmentMutation.mutate({
                        downloadSignedAttachment: true
                    })
            },
            {
                content: f("attachments.actions.delete-signed-attachment"),
                image: (0, _trashSvgDefault.default),
                onAction: ()=>setDeleteConfirmationModalState({
                        open: true,
                        deleteSignedAttachment: true
                    }),
                disabled: readonly || downloadAttachmentMutation.isLoading
            }
        ]
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                hideTitle: true,
                distribution: "trailing",
                items: actions,
                forceOpen: downloadAttachmentMutation.isLoading,
                sections: hasSignedAttachmentFile ? [
                    signedAttachmentSection
                ] : undefined
            }),
            deleteConfirmationModalState.open && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteAttachmentConfirmationDefault.default), {
                entity: entity,
                attachment: attachment,
                deleteSignedAttachment: deleteConfirmationModalState.deleteSignedAttachment,
                onModalClose: closeDeleteModal
            })
        ]
    });
};
exports.default = AttachmentActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../assets/icons/arrow-down-rectangle.svg":"TDXIu","../../../../assets/icons/pen-line.svg":"9iTi6","../../../../assets/icons/trash.svg":"jqW55","../../../hooks/useAttachmentDownload":"7Wv1D","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/filenameUtils":"2FnJx","../../ActionsDropdown/ActionsDropdown":"izRYG","../AttachmentsSection.helpers":"faQRx","./DeleteAttachmentConfirmation":"dazDM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9iTi6":[function(require,module,exports) {
module.exports = require("597261bb71bddc4c").getBundleURL("kEMsi") + "pen-line.3076bad4.svg";

},{"597261bb71bddc4c":"75UoR"}],"gYDXI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _fileSvg = require("../../../assets/icons/file.svg");
var _fileSvgDefault = parcelHelpers.interopDefault(_fileSvg);
var _useAttachmentDownload = require("../../hooks/useAttachmentDownload");
var _useAttachmentDownloadDefault = parcelHelpers.interopDefault(_useAttachmentDownload);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _filenameUtils = require("../../utils/filenameUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _attachmentsSectionHelpers = require("./AttachmentsSection.helpers");
const AttachmentDownloadButton = (props)=>{
    const { entity, attachment } = props;
    const [showMenu, setShowMenu] = (0, _react.useState)(false);
    const toggleShowMenu = ()=>setShowMenu(!showMenu);
    const f = (0, _useFormatMessageDefault.default)();
    const downloadAttachmentMutation = (0, _useAttachmentDownloadDefault.default)(entity, attachment);
    const isLoading = downloadAttachmentMutation.isLoading;
    const filename = (0, _filenameUtils.cleanupFilename)(attachment.filename);
    const showDownloadMenu = (0, _attachmentsSectionHelpers.hasSignedAttachment)(attachment);
    const downloadOriginalAttachmentActionItem = {
        content: f("attachments.actions.download-attachment"),
        onAction: ()=>downloadAttachmentMutation.mutate({
                downloadSignedAttachment: false
            }),
        disabled: isLoading
    };
    const downloadSignedAttachmentActionItem = {
        content: f("attachments.actions.download-signed-attachment"),
        onAction: ()=>downloadAttachmentMutation.mutate({
                downloadSignedAttachment: true
            }),
        disabled: isLoading
    };
    const handleDownloadButtonClick = ()=>{
        showDownloadMenu ? toggleShowMenu() : downloadOriginalAttachmentActionItem.onAction();
    };
    const downloadUnsignedAttachButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        plain: true,
        icon: (0, _fileSvgDefault.default),
        truncate: true,
        disclosure: showDownloadMenu,
        loading: isLoading,
        textAlign: "left",
        onClick: handleDownloadButtonClick,
        children: filename
    });
    if (showDownloadMenu) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover), {
        active: showMenu,
        activator: downloadUnsignedAttachButton,
        onClose: toggleShowMenu,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ActionList), {
            items: [
                downloadOriginalAttachmentActionItem,
                downloadSignedAttachmentActionItem
            ]
        })
    });
    else return downloadUnsignedAttachButton;
};
exports.default = AttachmentDownloadButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/file.svg":"bLqMZ","../../hooks/useAttachmentDownload":"7Wv1D","../../hooks/useFormatMessage":"8Y8fq","../../utils/filenameUtils":"2FnJx","../extensions/Button":"8exc0","./AttachmentsSection.helpers":"faQRx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bU8fx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _filenameUtils = require("../../utils/filenameUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _attachmentsSectionConstants = require("./AttachmentsSection.constants");
const AttachmentSignaturesStatus = (props)=>{
    const { attachment, onClick } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const isPDF = (0, _filenameUtils.isPDFAttachment)(attachment);
    const signed = attachment.completed_signature_count;
    const total = attachment.signature_count;
    const status = isPDF && attachment.signature_required && attachment.signature_status;
    const isActive = total > 0;
    const icon = status ? (0, _attachmentsSectionConstants.AttachmentSignatureStatusIconsMap)[status] : undefined;
    let label = f("attachments.labels.signature-status.not-activated");
    switch(status){
        case "EXPIRED":
            label = f("attachments.labels.signature-status.expired");
            break;
        case "SIGNED":
            label = f("attachments.labels.signature-status.signed", {
                signed,
                total
            });
            break;
        case "PENDING":
            if (isActive) label = f("attachments.labels.signature-status.not-signed", {
                signed,
                total
            });
            else label = f("attachments.labels.signature-status.not-activated");
            break;
        case "INVALID_FOR_SIGNING":
            label = f("attachments.labels.signature-status.unsignable");
            break;
        default:
            label = isPDF ? f("attachments.labels.signature-status.not-activated") : "-";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        onClick: onClick,
        icon: icon,
        disabled: !isPDF,
        plain: true,
        monochrome: true,
        removeUnderline: true,
        hoverable: true,
        children: label
    });
};
exports.default = AttachmentSignaturesStatus;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","../../utils/filenameUtils":"2FnJx","../extensions/Button":"8exc0","./AttachmentsSection.constants":"fCLKG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2KwoT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const AttachmentUploader = (props)=>{
    const { user } = props;
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const username = getUserDisplayName(user);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
        content: username,
        dismissOnMouseOut: true,
        preferredPosition: "above",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            children: username
        })
    });
};
exports.default = AttachmentUploader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useGetUserName":"edBne","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iVpsA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _queriesKeys = require("../../constants/queries-keys");
var _styles = require("../../constants/styles");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _collectionUtils = require("../../utils/collectionUtils");
var _acceptedFileTypesLabel = require("../AcceptedFileTypesLabel/AcceptedFileTypesLabel");
var _acceptedFileTypesLabelDefault = parcelHelpers.interopDefault(_acceptedFileTypesLabel);
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _addFileButton = require("../AddFileButton/AddFileButton");
var _addFileButtonDefault = parcelHelpers.interopDefault(_addFileButton);
var _assignmentInfo = require("../AssignmentInfo/AssignmentInfo");
var _assignmentInfoDefault = parcelHelpers.interopDefault(_assignmentInfo);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CustomerUploadDocumentButton = (props)=>{
    const { assignments, selectedAssignmentId, className, ...addFileButtonProps } = props;
    const { readonly, entity, onFileUploadingStart, onFileUploadingFinish } = addFileButtonProps;
    const f = (0, _useFormatMessageDefault.default)();
    const [selectedAssignment, setSelectedAssignment] = (0, _react.useState)(()=>assignments?.find((assignment)=>assignment.id === selectedAssignmentId));
    const [showAssignmentSelectionModal, toggleAssignmentSelectionModal, closeAssignmentSelectionModal] = (0, _useOpenCloseDefault.default)();
    const [isUploading, setIsUploading] = (0, _react.useState)(false);
    const customerAttachmentsQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
        entity.id
    ];
    const updateCustomerQueryData = (0, _useQueryDataDefault.default)(customerAttachmentsQueryKey).updateQueryData;
    (0, _react.useEffect)(()=>{
        setSelectedAssignment(assignments?.find((assignment)=>assignment.id === selectedAssignmentId));
    }, [
        selectedAssignmentId
    ]);
    const handleFileUploadingFinish = (addedAttachments)=>{
        onFileUploadingFinish(addedAttachments);
        setIsUploading(false);
        // if the attachment was uploaded to an assignment, also update the list of attachment on the customer
        if (selectedAssignment) updateCustomerQueryData((prevData)=>prevData.attachment_list = [
                ...addedAttachments,
                ...prevData.attachment_list
            ]);
    };
    const disabled = readonly || isUploading;
    if (!(0, _collectionUtils.hasContent)(assignments)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFloatButtonWrapper, {
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addFileButtonDefault.default), {
            ...addFileButtonProps
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledFloatButtonWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                disabled: disabled,
                onClick: toggleAssignmentSelectionModal,
                children: f("attachments.upload.button")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _acceptedFileTypesLabelDefault.default), {}),
            showAssignmentSelectionModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
                open: true,
                title: "",
                titleHidden: true,
                onClose: closeAssignmentSelectionModal,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "h3",
                                variant: "headingMd",
                                children: f("attachments.customer.upload.assignment.select")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                                            name: (0, _displayHelpers.getCustomerName)(entity),
                                            strong: true,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                                as: "span",
                                                fontWeight: "semibold",
                                                children: [
                                                    "(",
                                                    f("common.labels.customer-relationship").toLocaleLowerCase(),
                                                    ")"
                                                ]
                                            })
                                        }),
                                        checked: !selectedAssignment,
                                        onChange: ()=>setSelectedAssignment(undefined),
                                        disabled: disabled
                                    }),
                                    assignments?.map((assignment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentInfoDefault.default), {
                                                assignmentName: assignment.name,
                                                assignmentPurpose: assignment.purpose,
                                                assignmentStartDate: assignment.created_dt
                                            }),
                                            checked: selectedAssignment?.id === assignment.id,
                                            onChange: (newValue)=>setSelectedAssignment(newValue ? assignment : undefined),
                                            disabled: disabled
                                        }, assignment.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "2",
                                align: "end",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        onClick: closeAssignmentSelectionModal,
                                        children: f("default.cancel")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addFileButtonDefault.default), {
                                        entity: selectedAssignment ? {
                                            ...selectedAssignment,
                                            customer_id: entity.id
                                        } : entity,
                                        readonly: disabled,
                                        hideAcceptedFileTypesLabel: true,
                                        loading: isUploading,
                                        onFileUploadingStart: (filesCount)=>{
                                            onFileUploadingStart(filesCount);
                                            setIsUploading(true);
                                        },
                                        onFileUploadingFinish: (addedAttachments)=>{
                                            handleFileUploadingFinish(addedAttachments);
                                            closeAssignmentSelectionModal();
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const StyledFloatButtonWrapper = (0, _styledComponentsDefault.default).div`
  position: absolute;
  right: 0;
  top: calc(-1 * var(--p-space-1));

  // For small viewports - render button as a regular block element
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    position: revert;
  }
`;
exports.default = CustomerUploadDocumentButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/queries-keys":"6hYSF","../../constants/styles":"dZWds","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","../AcceptedFileTypesLabel/AcceptedFileTypesLabel":"1scWe","../AddButton/AddButton":"WJGEt","../AddFileButton/AddFileButton":"7ZmVz","../AssignmentInfo/AssignmentInfo":"ds7XR","../DisplayName/DisplayName":"gKd5g","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1scWe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _files = require("../../constants/files");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _infoTooltipLabel = require("../InfoTooltipLabel/InfoTooltipLabel");
var _infoTooltipLabelDefault = parcelHelpers.interopDefault(_infoTooltipLabel);
const AcceptedFileTypesLabel = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTooltipLabelDefault.default), {
        label: f("attachments.upload.button.available-file-types"),
        content: (0, _files.ACCEPTED_FILE_TYPES).join(", ")
    });
};
exports.default = AcceptedFileTypesLabel;

},{"react/jsx-runtime":"enbMA","../../constants/files":"kmOPp","../../hooks/useFormatMessage":"8Y8fq","../InfoTooltipLabel/InfoTooltipLabel":"9JlVB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9JlVB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _infoBlueSvg = require("../../../assets/icons/info-blue.svg");
var _infoBlueSvgDefault = parcelHelpers.interopDefault(_infoBlueSvg);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const InfoTooltipLabel = (props)=>{
    const { label, content } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                italic: true,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _infoBlueSvgDefault.default),
                    width: "14px",
                    height: "14px"
                })
            })
        ]
    });
};
exports.default = InfoTooltipLabel;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../../assets/icons/info-blue.svg":"kCjLz","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7ZmVz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@sentry/react");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _files = require("../../constants/files");
var _queriesKeys = require("../../constants/queries-keys");
var _attachments = require("../../helpers/attachments");
var _useAttachmentsAPI = require("../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../types/utilities");
var _filenameUtils = require("../../utils/filenameUtils");
var _stringUtils = require("../../utils/stringUtils");
var _acceptedFileTypesLabel = require("../AcceptedFileTypesLabel/AcceptedFileTypesLabel");
var _acceptedFileTypesLabelDefault = parcelHelpers.interopDefault(_acceptedFileTypesLabel);
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
const DEFAULT_DOCUMENT_FILENAME = "default-document";
const AddFileButton = (props)=>{
    const { entity, readonly, hideAcceptedFileTypesLabel, onFileUploadingStart, onFileUploadingFinish, ...buttonProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const [uploadError, setUploadedError] = (0, _react.useState)();
    const clearError = ()=>setUploadedError(undefined);
    const { entityId, addAttachment } = (0, _useAttachmentsAPIDefault.default)(entity);
    const showPlanConversion = !features.ATTACHMENTS;
    const attachmentsQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
        entityId
    ];
    const { updateQueryData } = (0, _useQueryDataDefault.default)(attachmentsQueryKey);
    const uploadFile = async (file)=>{
        const filename = (0, _filenameUtils.cleanupFilename)(file.name) || DEFAULT_DOCUMENT_FILENAME;
        try {
            // get upload_url
            const { upload_url, upload_id } = await (0, _apiDefault.default).generateAttachmentUploadIdAndUrl({
                filename,
                content_type: file.type,
                content_length: file.size
            });
            // upload the file to the cloud
            await fetch(upload_url, {
                method: "PUT",
                headers: {
                    // Set special headers that *must* be passed with requests to
                    // the signed upload URL
                    "X-Upload-Content-Length": `${file.size}`,
                    "X-Goog-Content-Length-Range": `0,${(0, _files.MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD)}`
                },
                body: file
            });
            // save the result
            const request = {
                filename,
                upload_id
            };
            const attachmentDetails = await addAttachment(entityId, request);
            // TODO remove this code once the API is fixed
            // hack to fix API no returning assignment details in attachment that were added to an assignment
            if ((0, _utilities.isAssignment)(entity)) {
                attachmentDetails.assignment_id = entity.id;
                attachmentDetails.assignment_name = entity.name;
                attachmentDetails.assignment_purpose = entity.purpose || entity.purpose_desc;
                attachmentDetails.assignment_is_archived = false;
            }
            updateQueryData((queryData)=>queryData.attachment_list = [
                    attachmentDetails,
                    ...queryData.attachment_list
                ]);
            return attachmentDetails;
        } catch (error) {
            console.log(error);
            setUploadedError(f("error.message.unknown"));
        }
    };
    const reportFileSizeExceeded = (size)=>{
        _react1.captureMessage(f("common.errors.file-size-exceeded", {
            max: (0, _stringUtils.bytesToMegaBytes)((0, _files.MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD))
        }) + ` filesize: ${size} bytes`, {
            level: "debug",
            tags: {
                location: "AddFileButton:handleFilesUpload[MAX_FILE_SIZE]"
            }
        });
    };
    const handleFilesUpload = async (files)=>{
        const attachments = [];
        const validFilesCount = files.filter((0, _attachments.isValidFile)).length;
        onFileUploadingStart(validFilesCount);
        for (const file of files)if ((0, _attachments.isValidFile)(file)) {
            const attachment = await uploadFile(file);
            if (attachment) attachments.push(attachment);
        } else {
            setUploadedError(f("common.errors.file-size-exceeded", {
                max: (0, _stringUtils.bytesToMegaBytes)((0, _files.MAXIMUM_FILE_SIZE_IN_BYTES_FOR_UPLOAD))
            }));
            reportFileSizeExceeded(file.size);
        }
        onFileUploadingFinish(attachments);
    };
    const disabled = readonly || showPlanConversion;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DropZone), {
                outline: false,
                variableHeight: true,
                disabled: readonly,
                accept: (0, _files.ACCEPTED_FILE_TYPES).join(","),
                onDropAccepted: handleFilesUpload,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                    disabled: disabled,
                    ...buttonProps,
                    children: f("attachments.upload.button")
                })
            }),
            !hideAcceptedFileTypesLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _acceptedFileTypesLabelDefault.default), {}),
            uploadError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: uploadError,
                error: true,
                onDismiss: clearError
            })
        ]
    });
};
exports.default = AddFileButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@sentry/react":"akCRS","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../constants/files":"kmOPp","../../constants/queries-keys":"6hYSF","../../helpers/attachments":"6o6Ej","../../hooks/useAttachmentsAPI":"7xA5e","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../types/utilities":"6zLpB","../../utils/filenameUtils":"2FnJx","../../utils/stringUtils":"4gVdA","../AcceptedFileTypesLabel/AcceptedFileTypesLabel":"1scWe","../AddButton/AddButton":"WJGEt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hryzj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const KDKTabs = (props)=>{
    const { className, centered, ...tabsProps } = props;
    const { tabs, selected, fitted, children, onSelect } = tabsProps;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabsContainer, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabsHeader, {
                fitted: fitted,
                className: className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    gap: "8",
                    align: centered ? "center" : undefined,
                    blockAlign: "stretch",
                    children: tabs.map(({ id, content, accessibilityLabel }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            onClick: ()=>onSelect && onSelect(index),
                            plain: true,
                            monochrome: true,
                            removeUnderline: true,
                            pressed: index === selected,
                            role: accessibilityLabel,
                            children: content
                        }, id))
                })
            }),
            children
        ]
    });
};
const TabsContainer = (0, _styledComponentsDefault.default).div`
  & > * + * {
    margin-top: var(--p-space-4);
  }
`;
const TabsHeader = (0, _styledComponentsDefault.default).div`
  padding: var(--p-space-4) var(--p-space-3) var(--p-space-2) var(--p-space-3);
  border-bottom: var(--p-border-divider);

  // // For small viewports
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    // layout the tabs vertically
    & > .Polaris-HorizontalStack {
      flex-direction: column;
      justify-content: start;
    }
  }

  & .Polaris-Button {
    position: relative;
    padding-bottom: var(--p-space-4);
    flex: ${({ fitted })=>fitted ? "1 1 0px" : undefined};

    color: var(--p-color-text-subdued);

    &::after {
      position: absolute;
      content: "";
      top: calc(100% - var(--p-border-width-3) / 2);

      height: 1px;

      border-radius: var(--p-border-radius-1) var(--p-border-radius-1) 0 0;
      border-top: solid var(--p-border-width-3) transparent;
    }
  }

  & .Polaris-Button:hover {
    color: var(--p-color-text);

    &::after {
      border-color: var(--p-border-subdued);
    }
  }

  & .Polaris-Button--pressed {
    color: var(--p-color-text);

    &::after {
      border-color: var(--p-color-bg-primary);
    }
  }
`;
exports.default = KDKTabs;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/styles":"dZWds","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fDQWW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _calendarSvg = require("../../../assets/icons/calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _archivedBadge = require("../ArchivedBadge/ArchivedBadge");
var _archivedBadgeDefault = parcelHelpers.interopDefault(_archivedBadge);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _dataTableCellChild = require("../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _multipleUsersInitials = require("../MultipleUsersInitials/MultipleUsersInitials");
var _multipleUsersInitialsDefault = parcelHelpers.interopDefault(_multipleUsersInitials);
const AssignmentsSection = (props)=>{
    const { customer } = props;
    const assignments = customer.assignments || [];
    const archivedAssignmentCount = assignments.filter((assignment)=>assignment.is_archived).length;
    const f = (0, _useFormatMessageDefault.default)();
    // show archived assignments by default is all the assignments are archived
    const [showArchivedAssignments, toggleArchivedAssignments] = (0, _useOpenCloseDefault.default)(archivedAssignmentCount === assignments.length);
    const hasAssignments = assignments.length > 0;
    const assignmentsToDisplay = showArchivedAssignments ? assignments : assignments.filter((assignment)=>!assignment.is_archived);
    const showFilter = archivedAssignmentCount > 0;
    const filterAssignmentsLabel = showArchivedAssignments ? f("customer-assignments.list.filter.hide-archived-assignments", {
        count: archivedAssignmentCount
    }) : f("customer-assignments.list.filter.show-archived-assignments", {
        count: archivedAssignmentCount
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            !hasAssignments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: f("customer-assignments.empty")
            }),
            hasAssignments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                verticalAlign: "middle",
                columnContentTypes: [
                    "text",
                    "text",
                    "text",
                    "text",
                    "text"
                ],
                headings: [
                    f("customer-assignments.list.header.name"),
                    // f("customer-assignments.list.header.risk"),
                    f("customer-assignments.list.header.responsible"),
                    // f("customer-assignments.list.header.status"),
                    f("customer-assignments.list.header.added")
                ],
                rows: assignmentsToDisplay.map((assignment)=>{
                    return [
                        // <DataTableCellChild width={"40%"}>
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                            width: "60%",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                blockAlign: "baseline",
                                gap: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                                        url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).ASSIGNMENT_DETAILS, {
                                            id: assignment.id,
                                            customerId: customer.id
                                        }),
                                        children: assignment.name
                                    }),
                                    assignment.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archivedBadgeDefault.default), {})
                                ]
                            })
                        }),
                        // <Risk risk={assignment.risk_level} />,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multipleUsersInitialsDefault.default), {
                            users: assignment.responsible_users
                        }),
                        // <AssignmentStatus assignment={assignment} />,
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "1",
                            blockAlign: "center",
                            wrap: false,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                    source: (0, _calendarSvgDefault.default)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                    date: assignment.created_dt
                                })
                            ]
                        })
                    ];
                })
            }),
            showFilter && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    onClick: toggleArchivedAssignments,
                    disclosure: showArchivedAssignments ? "up" : "down",
                    children: filterAssignmentsLabel
                })
            })
        ]
    });
};
exports.default = AssignmentsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../../assets/icons/calendar.svg":"kKBe6","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../ArchivedBadge/ArchivedBadge":"8eATJ","../CustomDate/CustomDate":"5KD00","../DataTableCellChild/DataTableCellChild":"boueG","../extensions/Icon":"eHSf0","../MultipleUsersInitials/MultipleUsersInitials":"2srna","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kKBe6":[function(require,module,exports) {
module.exports = require("ff09022517c29953").getBundleURL("kEMsi") + "calendar.58f765c4.svg";

},{"ff09022517c29953":"75UoR"}],"bZwgZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _karLookupForm = require("../KarLookupForm/KarLookupForm");
var _karLookupFormDefault = parcelHelpers.interopDefault(_karLookupForm);
var _karLookupsHistory = require("../KarLookupsHistory/KarLookupsHistory");
var _karLookupsHistoryDefault = parcelHelpers.interopDefault(_karLookupsHistory);
const KarLookupSection = (props)=>{
    const { customer } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Flex, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _karLookupFormDefault.default), {
                            customer: customer
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _karLookupsHistoryDefault.default), {
                            customerId: customer.id,
                            customerType: customer.type
                        })
                    ]
                })
            })
        ]
    });
};
const Flex = (0, _styledComponentsDefault.default).div`
  flex: 1;
`;
exports.default = KarLookupSection;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../KarLookupForm/KarLookupForm":"lK8Ah","../KarLookupsHistory/KarLookupsHistory":"gyBqa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lK8Ah":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _validateAccountNumber = require("norwegian-utils/validateAccountNumber");
var _validateAccountNumberDefault = parcelHelpers.interopDefault(_validateAccountNumber);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _karLookupFailureBanner = require("./KarLookupFailureBanner");
var _karLookupFailureBannerDefault = parcelHelpers.interopDefault(_karLookupFailureBanner);
var _karLookupSuccessBanner = require("./KarLookupSuccessBanner");
var _karLookupSuccessBannerDefault = parcelHelpers.interopDefault(_karLookupSuccessBanner);
const KarLookupForm = (props)=>{
    const { customer } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [accountNumber, setAccountNumber] = (0, _react.useState)("");
    const [nationalId, setNationalId] = (0, _react.useState)(customer.national_id || "");
    const [lookupResult, setLookupResult] = (0, _react.useState)();
    const clearResult = ()=>setLookupResult(undefined);
    const checkAccountMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).createKarLookup(customer.id, {
            account_number: accountNumber,
            national_id: nationalId
        }), {
        onMutate: clearResult,
        onSuccess: setLookupResult
    });
    const isNationalIdFilled = !(0, _stringUtils.isEmptyString)(customer.national_id);
    const isValidAccountNumber = (0, _validateAccountNumberDefault.default)(accountNumber);
    const isDisabled = !isValidAccountNumber || (0, _stringUtils.isEmptyString)(nationalId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        align: "space-between",
        blockAlign: "start",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "h4",
                        variant: "bodyMd",
                        fontWeight: "semibold",
                        children: f("kar.form.title")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.FormLayout), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout).Group, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                    label: f("kar.form.labels.account-number"),
                                    value: accountNumber,
                                    onChange: setAccountNumber,
                                    autoComplete: "on",
                                    debounceError: true,
                                    minLength: 11,
                                    disabled: checkAccountMutation.isLoading,
                                    error: !isValidAccountNumber ? f("common.errors.invalid.account-number") : undefined
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                    label: f("kar.form.labels.customer-number"),
                                    value: nationalId,
                                    onChange: setNationalId,
                                    autoComplete: "on",
                                    readOnly: isNationalIdFilled,
                                    disabled: checkAccountMutation.isLoading
                                })
                            ]
                        })
                    }),
                    lookupResult?.result && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _karLookupSuccessBannerDefault.default), {
                        customer: customer,
                        lookupResult: lookupResult
                    }),
                    lookupResult?.result === false && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _karLookupFailureBannerDefault.default), {
                        customer: customer,
                        lookupResult: lookupResult
                    }),
                    checkAccountMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: checkAccountMutation.error
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                primary: true,
                onClick: ()=>checkAccountMutation.mutate(),
                disabled: isDisabled,
                loading: checkAccountMutation.isLoading,
                children: f("kar.form.labels.check-account-number")
            })
        ]
    });
};
exports.default = KarLookupForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","norwegian-utils/validateAccountNumber":"3mCDu","../../api":"f6lXD","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../ErrorPanel/ErrorPanel":"2hHqH","../KDKTextField/KDKTextField":"b5QRp","./KarLookupFailureBanner":"bM0Jq","./KarLookupSuccessBanner":"3ePUh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3mCDu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = (accountNumber)=>{
    /* https://no.wikipedia.org/wiki/MOD11 */ const weights = [
        5,
        4,
        3,
        2,
        7,
        6,
        5,
        4,
        3,
        2
    ];
    const accountNumberWithoutSpacesAndPeriods = accountNumber.replace(/[\s.]+/g, "");
    if (accountNumberWithoutSpacesAndPeriods.length !== 11) return false;
    else {
        const controlDigit = parseInt(accountNumberWithoutSpacesAndPeriods.charAt(10), 10);
        const accountNumberWithoutControlDigit = accountNumberWithoutSpacesAndPeriods.substring(0, 10);
        let sum = 0;
        for(let index = 0; index < 10; index++)sum += parseInt(accountNumberWithoutControlDigit.charAt(index), 10) * weights[index];
        const reminder = sum % 11;
        return controlDigit === (reminder === 0 ? 0 : 11 - reminder);
    }
};

},{}],"bM0Jq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useRichFormatMessage = require("../../hooks/useRichFormatMessage");
var _useRichFormatMessageDefault = parcelHelpers.interopDefault(_useRichFormatMessage);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const KarLookupFailureBanner = (props)=>{
    const { customer, lookupResult } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const richFormat = (0, _useRichFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const customerName = (0, _displayHelpers.getCustomerName)(customer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _kdkbannerDefault.default), {
        status: "critical",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "p",
                children: richFormat("kar.form.result.failure", {
                    accountNumber: lookupResult.account_number,
                    name: customerName,
                    nationalId: lookupResult.national_id
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                children: f("kar.form.result.by", {
                    name: getUserDisplayName(lookupResult.created_by),
                    timestamp: new Date(lookupResult.timestamp)
                })
            })
        ]
    });
};
exports.default = KarLookupFailureBanner;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useRichFormatMessage":"6rmtK","../CondensedText/CondensedText":"1FshD","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3ePUh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useRichFormatMessage = require("../../hooks/useRichFormatMessage");
var _useRichFormatMessageDefault = parcelHelpers.interopDefault(_useRichFormatMessage);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const KarLookupSuccessBanner = (props)=>{
    const { customer, lookupResult } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const richFormat = (0, _useRichFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const customerName = (0, _displayHelpers.getCustomerName)(customer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _kdkbannerDefault.default), {
        status: "success",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "p",
                children: richFormat("kar.form.result.success", {
                    accountNumber: lookupResult.account_number,
                    name: customerName,
                    nationalId: lookupResult.national_id
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                children: f("kar.form.result.by", {
                    name: getUserDisplayName(lookupResult.created_by),
                    timestamp: new Date(lookupResult.timestamp)
                })
            })
        ]
    });
};
exports.default = KarLookupSuccessBanner;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useRichFormatMessage":"6rmtK","../CondensedText/CondensedText":"1FshD","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gyBqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collapsibleSection = require("../CollapsibleSection/CollapsibleSection");
var _collapsibleSectionDefault = parcelHelpers.interopDefault(_collapsibleSection);
var _karLookupHistoryTable = require("../KarLookupHistoryTable/KarLookupHistoryTable");
var _karLookupHistoryTableDefault = parcelHelpers.interopDefault(_karLookupHistoryTable);
const KarLookupsHistory = (props)=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsibleSectionDefault.default), {
        showPrefix: true,
        title: f("default.history"),
        withoutHeader: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _karLookupHistoryTableDefault.default), {
            ...props
        })
    });
};
exports.default = KarLookupsHistory;

},{"react/jsx-runtime":"enbMA","../../hooks/useFormatMessage":"8Y8fq","../CollapsibleSection/CollapsibleSection":"3po8A","../KarLookupHistoryTable/KarLookupHistoryTable":"jc046","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jc046":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _reactTable = require("@tanstack/react-table");
var _calendarSvg = require("../../../assets/icons/calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _companySvg = require("../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _personSvg = require("../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _karHelpers = require("../../helpers/kar.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _reactTable1 = require("../ReactTable/ReactTable");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable1);
var _karLookupResultStatus = require("./KarLookupResultStatus");
var _karLookupResultStatusDefault = parcelHelpers.interopDefault(_karLookupResultStatus);
const KarLookupHistoryTable = (props)=>{
    const { customerId, customerType } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatDate, formatTime } = (0, _reactIntl.useIntl)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const { isLoading, data, isError, error } = (0, _reactQuery.useQuery)([], ()=>(0, _apiDefault.default).listKarLookups(customerId));
    const rows = data?.results || [];
    const columns = (0, _react.useMemo)(()=>{
        const columnHelper = (0, _reactTable.createColumnHelper)();
        const columns = [
            columnHelper.accessor("account_number", {
                header: f("table.column.previous-search"),
                cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _karLookupResultStatusDefault.default), {
                        result: props.row.original
                    })
            }),
            columnHelper.accessor("national_id", {
                header: f("table.column.customer-number"),
                cell: (props)=>{
                    const isPerson = customerType === "person";
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        blockAlign: "center",
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: isPerson ? (0, _personSvgDefault.default) : (0, _companySvgDefault.default)
                            }),
                            isPerson ? props.getValue() : (0, _karHelpers.formatKARNationalNumber)(props.getValue())
                        ]
                    });
                }
            }),
            columnHelper.accessor("timestamp", {
                header: f("table.column.time-of-search"),
                cell: (props)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        blockAlign: "center",
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: (0, _calendarSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                as: "span",
                                children: [
                                    formatDate(props.getValue()),
                                    " ",
                                    formatTime(props.getValue())
                                ]
                            })
                        ]
                    });
                }
            }),
            columnHelper.accessor("created_by", {
                header: f("table.column.search-by"),
                cell: (props)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: getUserDisplayName(props.getValue())
                    });
                }
            })
        ];
        return columns;
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
        size: "small"
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: error
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTableDefault.default), {
        columns: columns,
        data: rows,
        getRowId: (row)=>row.id
    });
};
exports.default = KarLookupHistoryTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","@tanstack/react-table":"86D8M","../../../assets/icons/calendar.svg":"kKBe6","../../../assets/icons/company.svg":"luBbc","../../../assets/icons/person.svg":"1Xt5L","../../api":"f6lXD","../../helpers/kar.helpers":"dsrjm","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../CondensedText/CondensedText":"1FshD","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Icon":"eHSf0","../ReactTable/ReactTable":"iNTSb","./KarLookupResultStatus":"hmrWH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dsrjm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatKARAccountNumber", ()=>formatKARAccountNumber);
parcelHelpers.export(exports, "formatKARNationalNumber", ()=>formatKARNationalNumber);
var _formatAccountNumber = require("norwegian-utils/formatAccountNumber");
var _formatAccountNumberDefault = parcelHelpers.interopDefault(_formatAccountNumber);
var _formatOrganizationNumber = require("norwegian-utils/formatOrganizationNumber");
// @see https://github.com/unfold/norwegian-utils
const SPACE_SEPARATOR = "\xa0";
const formatKARAccountNumber = (accountNumber)=>(0, _formatAccountNumberDefault.default)(accountNumber).replaceAll(SPACE_SEPARATOR, ".");
const formatKARNationalNumber = (nationalNumber)=>(0, _formatOrganizationNumber.formatOrganizationNumber)(nationalNumber)?.replaceAll(SPACE_SEPARATOR, ".");

},{"norwegian-utils/formatAccountNumber":"9ELGy","norwegian-utils/formatOrganizationNumber":"8Ahrt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9ELGy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const ACCOUNT_CHUNKS = [
    4,
    2,
    5
];
exports.default = (accountNumber)=>{
    if (!accountNumber) return "";
    accountNumber = accountNumber.replace(/[\s.]+/g, "");
    let result = "";
    let part;
    let rest;
    ACCOUNT_CHUNKS.forEach((length, index)=>{
        if (accountNumber.length) {
            part = accountNumber.slice(0, length);
            rest = accountNumber.slice(length);
            result += part;
            accountNumber = rest;
            if (index < 2) result += "\xa0";
        }
    });
    return result.trim();
};

},{}],"8Ahrt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatOrganizationNumber = (orgNumber)=>{
    if (!orgNumber) return;
    orgNumber = orgNumber.replace(/ /g, "");
    if (orgNumber.length !== 9) return orgNumber;
    return orgNumber.substring(0, 3) + "\xa0" + orgNumber.substring(3, 6) + "\xa0" + orgNumber.substring(6);
};
exports.isValidOrganizationNumber = (orgNumber)=>{
    return !!/^\d{9}$/.test(orgNumber);
};

},{}],"hmrWH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _checkmarkGreenSvg = require("../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _exclamationmarkTriangleFilledRedSvg = require("../../../assets/icons/exclamationmark-triangle-filled-red.svg");
var _exclamationmarkTriangleFilledRedSvgDefault = parcelHelpers.interopDefault(_exclamationmarkTriangleFilledRedSvg);
var _karHelpers = require("../../helpers/kar.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const KarLookupResultStatus = (props)=>{
    const { result } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const icon = result.result ? (0, _checkmarkGreenSvgDefault.default) : (0, _exclamationmarkTriangleFilledRedSvgDefault.default);
    const tooltip = !result.result ? f("kar.table.status.failure.tooltip") : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: tooltip,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: icon
                })
            }),
            (0, _karHelpers.formatKARAccountNumber)(result.account_number)
        ]
    });
};
exports.default = KarLookupResultStatus;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../../assets/icons/checkmark-green.svg":"8HW5l","../../../assets/icons/exclamationmark-triangle-filled-red.svg":"984Es","../../helpers/kar.helpers":"dsrjm","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"984Es":[function(require,module,exports) {
module.exports = require("26d627160b2b47d1").getBundleURL("kEMsi") + "exclamationmark-triangle-filled-red.dd403069.svg";

},{"26d627160b2b47d1":"75UoR"}],"cMRvk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dataTableCellChild = require("../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _displayTagsWrapper = require("../DisplayTagsWrapper/DisplayTagsWrapper");
var _displayTagsWrapperDefault = parcelHelpers.interopDefault(_displayTagsWrapper);
var _projectName = require("../ProjectName/ProjectName");
var _projectNameDefault = parcelHelpers.interopDefault(_projectName);
var _projectStatus = require("../ProjectStatus/ProjectStatus");
var _projectStatusDefault = parcelHelpers.interopDefault(_projectStatus);
const ProjectsSection = (props)=>{
    const { projects = [] } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const columnContentTypes = [
        "text",
        "text",
        "text"
    ];
    const headings = [
        f("table.column.name"),
        f("table.column.role"),
        f("table.column.status")
    ];
    const renderProjectRow = (project)=>[
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectNameDefault.default), {
                project: project,
                renderAsLink: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayTagsWrapperDefault.default), {
                tags: project.customer_labels
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                width: "15%",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectStatusDefault.default), {
                    status: project.status
                })
            })
        ];
    const rows = (0, _react.useMemo)(()=>projects.map(renderProjectRow), [
        projects
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            projects.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                columnContentTypes: columnContentTypes,
                headings: headings,
                rows: rows
            }),
            projects.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: f("customer-projects.empty")
            })
        ]
    });
};
exports.default = ProjectsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../DataTableCellChild/DataTableCellChild":"boueG","../DisplayTagsWrapper/DisplayTagsWrapper":"2idSA","../ProjectName/ProjectName":"IXkOY","../ProjectStatus/ProjectStatus":"gsvYx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gsvYx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _inactiveIconSvg = require("../../../assets/icons/inactive-icon.svg");
var _inactiveIconSvgDefault = parcelHelpers.interopDefault(_inactiveIconSvg);
var _statusApprovedSvg = require("../../../assets/icons/status-approved.svg");
var _statusApprovedSvgDefault = parcelHelpers.interopDefault(_statusApprovedSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const PROJECT_STATUS_TRANSLATION_MAP = {
    ACTIVE: "project.status.ACTIVE",
    INACTIVE: "project.status.INACTIVE"
};
const ProjectStatus = (props)=>{
    const { status } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const icon = status === "ACTIVE" ? (0, _statusApprovedSvgDefault.default) : (0, _inactiveIconSvgDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: icon,
                width: "8px",
                height: "8px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f(PROJECT_STATUS_TRANSLATION_MAP[status])
            })
        ]
    });
};
exports.default = ProjectStatus;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/inactive-icon.svg":"6Aiud","../../../assets/icons/status-approved.svg":"3sfjj","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Aiud":[function(require,module,exports) {
module.exports = require("6c0eb31af5cf95ca").getBundleURL("kEMsi") + "inactive-icon.8d0a78ba.svg";

},{"6c0eb31af5cf95ca":"75UoR"}],"3sfjj":[function(require,module,exports) {
module.exports = require("3117b67e12958c95").getBundleURL("kEMsi") + "status-approved.d3e12338.svg";

},{"3117b67e12958c95":"75UoR"}],"5nVqt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _notesHelpers = require("../../helpers/notes.helpers");
var _useCustomerCreateNoteMutation = require("../../hooks/useCustomerCreateNoteMutation");
var _useCustomerCreateNoteMutationDefault = parcelHelpers.interopDefault(_useCustomerCreateNoteMutation);
var _useCustomerDeleteNoteMutation = require("../../hooks/useCustomerDeleteNoteMutation");
var _useCustomerDeleteNoteMutationDefault = parcelHelpers.interopDefault(_useCustomerDeleteNoteMutation);
var _useCustomerUpdateNoteMutation = require("../../hooks/useCustomerUpdateNoteMutation");
var _useCustomerUpdateNoteMutationDefault = parcelHelpers.interopDefault(_useCustomerUpdateNoteMutation);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _notesSection = require("../NotesSection/NotesSection");
var _notesSectionDefault = parcelHelpers.interopDefault(_notesSection);
const CustomerNotesSection = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { data, isLoading, isError, error } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTES,
        customer.id
    ], ()=>(0, _apiDefault.default).listCustomerNotations(customer.id));
    const createNoteMutation = (0, _useCustomerCreateNoteMutationDefault.default)(customer);
    const updateNoteMutation = (0, _useCustomerUpdateNoteMutationDefault.default)(customer);
    const deleteNoteMutation = (0, _useCustomerDeleteNoteMutationDefault.default)(customer);
    const [noteToDelete, setNoteToDelete] = (0, _react.useState)();
    const clearNoteToDelete = ()=>setNoteToDelete(undefined);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "2",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "p",
                children: f("default.loading")
            })
        ]
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: error
    });
    const notes = data?.map((0, _notesHelpers.convertNotationToNote)).sort((0, _notesHelpers.sortByNoteDate));
    const deleteNote = ()=>deleteNoteMutation.mutateAsync(noteToDelete.id, {
            onSuccess: clearNoteToDelete
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notesSectionDefault.default), {
                notes: notes,
                readonly: readonly,
                placeholder: f("customer.notes.placeholder"),
                createNoteMutation: createNoteMutation,
                onDelete: setNoteToDelete,
                onSave: (note)=>updateNoteMutation.mutateAsync({
                        noteId: note.id,
                        comment: note.text
                    }).then((0, _notesHelpers.convertNotationToNote))
            }),
            noteToDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: deleteNote,
                title: f("component.notes.delete.confirmation.title"),
                description: f("component.notes.delete.confirmation.description"),
                actionTitle: f("default.yes"),
                onNo: clearNoteToDelete,
                onSuccess: clearNoteToDelete
            })
        ]
    });
};
exports.default = CustomerNotesSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../helpers/notes.helpers":"10TqV","../../hooks/useCustomerCreateNoteMutation":"4OqjJ","../../hooks/useCustomerDeleteNoteMutation":"jMr72","../../hooks/useCustomerUpdateNoteMutation":"h9mbs","../../hooks/useFormatMessage":"8Y8fq","../ConfirmAction/ConfirmAction":"icP5J","../ErrorPanel/ErrorPanel":"2hHqH","../NotesSection/NotesSection":"jTr9t","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"10TqV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertNotationToNote", ()=>convertNotationToNote);
parcelHelpers.export(exports, "convertPreviewReviewToNote", ()=>convertPreviewReviewToNote);
parcelHelpers.export(exports, "sortByNoteDate", ()=>sortByNoteDate);
const convertNotationToNote = (customerNotation)=>({
        id: customerNotation.id,
        text: customerNotation.comment,
        user: customerNotation.user,
        date: customerNotation.updated_dt || customerNotation.created_dt
    });
const convertPreviewReviewToNote = (projectReview)=>({
        id: projectReview.id,
        text: projectReview.comment,
        user: projectReview.reviewed_by,
        date: projectReview.created_dt
    });
const sortByNoteDate = (a1, a2)=>new Date(a2.date).getTime() - new Date(a1.date).getTime();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4OqjJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useCustomerCreateNoteMutation = (customer)=>{
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTES,
        customer.id
    ]);
    const createNoteMutation = (0, _reactQuery.useMutation)((comment)=>(0, _apiDefault.default).createCustomerNotation(customer.id, {
            comment
        }), {
        onSuccess: (newNote)=>{
            updateQueryData((prevNotes)=>prevNotes.unshift(newNote));
        }
    });
    return createNoteMutation;
};
exports.default = useCustomerCreateNoteMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jMr72":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useCustomerDeleteNoteMutation = (customer)=>{
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTES,
        customer.id
    ]);
    const deleteNoteMutation = (0, _reactQuery.useMutation)((noteId)=>(0, _apiDefault.default).deleteCustomerNotation(customer.id, noteId), {
        onSuccess: (_, noteId)=>{
            updateQueryData((prevNotes)=>{
                const deletedNoteIndex = prevNotes.findIndex((note)=>note.id === noteId);
                if (deletedNoteIndex > -1) prevNotes.splice(deletedNoteIndex, 1);
            });
        }
    });
    return deleteNoteMutation;
};
exports.default = useCustomerDeleteNoteMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h9mbs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useCustomerUpdateNoteMutation = (customer)=>{
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTES,
        customer.id
    ]);
    const updateNoteMutation = (0, _reactQuery.useMutation)(({ noteId, comment })=>(0, _apiDefault.default).updateCustomerNotation(customer.id, noteId, {
            comment
        }), {
        onSuccess: (updatedNote)=>{
            updateQueryData((prevNotes)=>{
                const updatedNoteIndex = prevNotes.findIndex((note)=>note.id === updatedNote.id);
                if (updatedNoteIndex > -1) prevNotes.splice(updatedNoteIndex, 1, updatedNote);
            });
        }
    });
    return updateNoteMutation;
};
exports.default = useCustomerUpdateNoteMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jTr9t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _noteForm = require("./NoteForm");
var _noteFormDefault = parcelHelpers.interopDefault(_noteForm);
var _notesList = require("./NotesList");
var _notesListDefault = parcelHelpers.interopDefault(_notesList);
const NotesSection = (props)=>{
    const { notes = [], onDelete, onSave, readonly, placeholder, ...noteFormProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "headingMd",
                as: "h2",
                children: f("component.notes.title", {
                    count: notes.length
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noteFormDefault.default), {
                readonly: readonly,
                placeholder: placeholder,
                ...noteFormProps
            }),
            notes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notesListDefault.default), {
                        notes: notes,
                        placeholder: placeholder,
                        onDelete: readonly ? undefined : onDelete,
                        onSave: readonly ? undefined : onSave
                    })
                ]
            })
        ]
    });
};
exports.default = NotesSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","./NoteForm":"bBo5O","./NotesList":"4AdJL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bBo5O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const NoteForm = (props)=>{
    const { value, readonly, placeholder, createNoteMutation, onCancel } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [comment, setComment] = (0, _react.useState)(value || "");
    const handleCancel = ()=>{
        createNoteMutation.reset();
        setComment("");
        onCancel && onCancel();
    };
    const handleSubmit = ()=>{
        createNoteMutation.mutate(comment, {
            onSuccess: ()=>{
                setComment("");
            }
        });
    };
    const disabled = readonly || createNoteMutation.isLoading;
    const isSubmitDisabled = disabled || (0, _stringUtils.isEmptyString)(comment);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                label: placeholder,
                labelHidden: true,
                value: comment,
                placeholder: placeholder,
                onChange: setComment,
                multiline: 4,
                id: "text",
                autoComplete: "off",
                disabled: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                blockAlign: "center",
                align: "end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: handleCancel,
                        disabled: disabled,
                        children: f("default.cancel")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        primary: true,
                        disabled: isSubmitDisabled,
                        loading: createNoteMutation.isLoading,
                        onClick: handleSubmit,
                        children: f("component.notes.labels.save-note")
                    })
                ]
            }),
            createNoteMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: createNoteMutation.error
            })
        ]
    });
};
exports.default = NoteForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4AdJL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _noteCard = require("./NoteCard");
var _noteCardDefault = parcelHelpers.interopDefault(_noteCard);
const NotesList = (props)=>{
    const { notes, placeholder, hideSearch, onDelete, onSave } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [queryText, setQueryText] = (0, _react.useState)("");
    const clearQueryText = ()=>setQueryText("");
    const notesToDisplay = (0, _stringUtils.isEmptyString)(queryText) ? notes : notes.filter((note)=>note.text.toLocaleUpperCase().includes(queryText.toLocaleUpperCase()));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            !hideSearch && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                    labelHidden: true,
                    placeholder: f("default.search"),
                    value: queryText,
                    clearButton: true,
                    onChange: setQueryText,
                    onClearButtonClick: clearQueryText
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledScrollable, {
                horizontal: false,
                shadow: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                    gap: "2",
                    children: notesToDisplay.map((note, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noteCardDefault.default), {
                            note: note,
                            queryText: queryText,
                            placeholder: placeholder,
                            onDelete: onDelete ? ()=>onDelete(note) : undefined,
                            onSave: onSave
                        }, index))
                })
            })
        ]
    });
};
const StyledScrollable = (0, _styledComponentsDefault.default)((0, _polaris.Scrollable))`
  //  limit the height of the notes
  max-height: 20rem;
`;
exports.default = NotesList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../SearchTextField/SearchTextField":"k5bRy","./NoteCard":"avKPB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"avKPB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _calendarSvg = require("../../../assets/icons/calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _pencilSvg = require("../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _textBubbleSvg = require("../../../assets/icons/text-bubble.svg");
var _textBubbleSvgDefault = parcelHelpers.interopDefault(_textBubbleSvg);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _permissions = require("../../constants/permissions");
var _displayHelpers = require("../../helpers/display.helpers");
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _utilities = require("../../types/utilities");
var _stringUtils = require("../../utils/stringUtils");
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _flatCard = require("../FlatCard/FlatCard");
var _flatCardDefault = parcelHelpers.interopDefault(_flatCard);
var _markdownContent = require("../MarkdownContent/MarkdownContent");
var _markdownContentDefault = parcelHelpers.interopDefault(_markdownContent);
var _userInitials = require("../UserInitials/UserInitials");
var _userInitialsDefault = parcelHelpers.interopDefault(_userInitials);
var _noteForm = require("./NoteForm");
var _noteFormDefault = parcelHelpers.interopDefault(_noteForm);
const NoteCard = (props, ref)=>{
    const { note, queryText = "", placeholder = "", onDelete, onSave, ...rest } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatDate } = (0, _reactIntl.useIntl)();
    const { user } = (0, _useAuthDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [isEditing, toggleEditing] = (0, _useOpenCloseDefault.default)();
    // only the user who created the note OR KDK Admin can edit/delete the note
    const isEditable = user?.id === note.user?.id || isPermittedTo((0, _permissions.PERMISSIONS_TYPES).ADMIN_USER);
    const allowDelete = isEditable && onDelete !== undefined;
    const allowUpdate = isEditable && onSave !== undefined;
    const showEditor = isEditing && onSave !== undefined;
    const highlightedNote = (0, _react.useMemo)(()=>// highlight queryText in note.text by marking it as bold (**) using a regex to replace all occurrences of
        // queryText (case-insensitive) with **$1** were $1 is the matching text within note.text
        (0, _stringUtils.isEmptyString)(queryText) ? note.text : note.text.replace(new RegExp(`(${queryText.trim()})`, "ig"), `**$1**`), [
        note.text,
        queryText
    ]);
    const saveMutation = (0, _reactQuery.useMutation)((text)=>onSave ? onSave({
            ...note,
            text
        }) : Promise.resolve(note), {
        onSuccess: toggleEditing
    });
    const actions = [];
    if (allowUpdate) actions.push({
        content: f("default.edit"),
        onAction: toggleEditing,
        image: (0, _pencilSvgDefault.default)
    });
    if (allowDelete) actions.push({
        content: f("default.delete"),
        onAction: onDelete,
        image: (0, _trashSvgDefault.default)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flatCardDefault.default), {
        ref: ref,
        footer: showEditor ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noteFormDefault.default), {
            value: note.text,
            placeholder: placeholder,
            createNoteMutation: saveMutation,
            onCancel: toggleEditing
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "start",
            wrap: false,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIcon, {
                    source: (0, _textBubbleSvgDefault.default)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownContentDefault.default), {
                    content: highlightedNote
                })
            ]
        }),
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            align: "space-between",
            blockAlign: "baseline",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "8",
                    blockAlign: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "1",
                            blockAlign: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                    source: (0, _calendarSvgDefault.default)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "bodyMd",
                                    as: "span",
                                    children: formatDate(note.date)
                                })
                            ]
                        }),
                        note.user && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "1",
                            blockAlign: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userInitialsDefault.default), {
                                    user: note.user
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "bodyMd",
                                    as: "span",
                                    children: (0, _displayHelpers.getFullName)(note.user)
                                })
                            ]
                        })
                    ]
                }),
                actions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                    items: actions,
                    hideTitle: true,
                    plain: true
                })
            ]
        })
    });
};
const StyledIcon = (0, _styledComponentsDefault.default)((0, _iconDefault.default))`
  // adjust icon position to better align with first line of text in the note
  margin-top: var(--p-space-05);
`;
exports.default = (0, _utilities.fixedForwardRef)(NoteCard);

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../assets/icons/calendar.svg":"kKBe6","../../../assets/icons/pencil.svg":"gEWpJ","../../../assets/icons/text-bubble.svg":"52FbG","../../../assets/icons/trash.svg":"jqW55","../../constants/permissions":"jhCn5","../../helpers/display.helpers":"2q3xY","../../hooks/useAuth":"k9r0q","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../types/utilities":"6zLpB","../../utils/stringUtils":"4gVdA","../ActionsDropdown/ActionsDropdown":"izRYG","../extensions/Icon":"eHSf0","../FlatCard/FlatCard":"dh1eC","../MarkdownContent/MarkdownContent":"cPR47","../UserInitials/UserInitials":"97rVK","./NoteForm":"bBo5O","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"52FbG":[function(require,module,exports) {
module.exports = require("2f59d435e025c92a").getBundleURL("kEMsi") + "text-bubble.7df85c8b.svg";

},{"2f59d435e025c92a":"75UoR"}],"dh1eC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFlatCardFooter", ()=>StyledFlatCardFooter);
parcelHelpers.export(exports, "StyledFlatCardDivider", ()=>StyledFlatCardDivider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const FlatCard = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { footer, footerBorder, children, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledFlatCard, {
        ref: ref,
        ...rest,
        children: [
            children,
            footer && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFlatCardFooter, {
                footerBorder: footerBorder,
                children: footer
            })
        ]
    });
});
const StyledFlatCard = (0, _styledComponentsDefault.default).div`
  --kdk-flat-card-spacing-vertical: var(--p-space-2);
  --kdk-flat-card-spacing-horizontal: var(--p-space-4);

  border-radius: var(--p-border-radius-1);
  border: var(--p-border-width-1) solid var(--p-border-subdued);
  padding: var(--kdk-flat-card-spacing-vertical) var(--kdk-flat-card-spacing-horizontal);
  background: var(--p-surface);
`;
const StyledFlatCardFooter = (0, _styledComponentsDefault.default).div`
  padding: var(--kdk-flat-card-spacing-vertical) var(--kdk-flat-card-spacing-horizontal);
  margin: var(--kdk-flat-card-spacing-vertical) calc(-1 * var(--kdk-flat-card-spacing-horizontal))
    calc(-1 * var(--kdk-flat-card-spacing-vertical));

  background-color: var(--p-surface-neutral-subdued);

  border-bottom-left-radius: var(--p-border-radius-1);
  border-bottom-right-radius: var(--p-border-radius-1);

  border-top: var(--p-border-width-1) solid
    ${({ footerBorder })=>footerBorder ? "var(--p-border-subdued)" : "transparent"};
`;
const StyledFlatCardDivider = (0, _styledComponentsDefault.default).div`
  border-top: var(--p-border-width-1) solid var(--p-border-subdued);
  margin: var(--kdk-flat-card-spacing-vertical) calc(-1 * var(--kdk-flat-card-spacing-horizontal))
    calc(-1 * var(--kdk-flat-card-spacing-vertical));
`;
exports.default = FlatCard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cPR47":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _markdown = require("@lexical/markdown");
var _lexicalComposer = require("@lexical/react/LexicalComposer");
var _lexicalContentEditable = require("@lexical/react/LexicalContentEditable");
var _lexicalErrorBoundary = require("@lexical/react/LexicalErrorBoundary");
var _lexicalErrorBoundaryDefault = parcelHelpers.interopDefault(_lexicalErrorBoundary);
var _lexicalRichTextPlugin = require("@lexical/react/LexicalRichTextPlugin");
var _markdown1 = require("../../constants/markdown");
var _autoLinkPlugin = require("../MarkdownEditor/AutoLinkPlugin");
var _autoLinkPluginDefault = parcelHelpers.interopDefault(_autoLinkPlugin);
var _markdownStylesWrapper = require("../MarkdownEditor/MarkdownStylesWrapper");
var _markdownUpdatePlugin = require("../MarkdownUpdatePlugin/MarkdownUpdatePlugin");
var _markdownUpdatePluginDefault = parcelHelpers.interopDefault(_markdownUpdatePlugin);
const MarkdownContent = (props)=>{
    const { content } = props;
    const initialConfig = {
        ...(0, _markdown1.BASE_MARKDOWN_CONFIG),
        namespace: "markdown-reader",
        editable: false,
        editorState: ()=>(0, _markdown.$convertFromMarkdownString)(content || "", (0, _markdown1.TRANSFORMERS)),
        onError: console.error
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalComposer.LexicalComposer), {
        initialConfig: initialConfig,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _markdownStylesWrapper.MarkdownStylesWrapper), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalRichTextPlugin.RichTextPlugin), {
                    contentEditable: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalContentEditable.ContentEditable), {}),
                    placeholder: null,
                    ErrorBoundary: (0, _lexicalErrorBoundaryDefault.default)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownUpdatePluginDefault.default), {
                    value: content
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoLinkPluginDefault.default), {})
            ]
        })
    });
};
exports.default = MarkdownContent;

},{"react/jsx-runtime":"enbMA","@lexical/markdown":"a7yhR","@lexical/react/LexicalComposer":"dTVDi","@lexical/react/LexicalContentEditable":"3VJcw","@lexical/react/LexicalErrorBoundary":"epcXG","@lexical/react/LexicalRichTextPlugin":"eV9p8","../../constants/markdown":"6FvAU","../MarkdownEditor/AutoLinkPlugin":"aAd3r","../MarkdownEditor/MarkdownStylesWrapper":"glWzc","../MarkdownUpdatePlugin/MarkdownUpdatePlugin":"acWsl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a7yhR":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalMarkdown = require("e568a34524d5206");
module.exports = LexicalMarkdown;

},{"e568a34524d5206":"1RlgA"}],"1RlgA":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var k = require("9d63e336ae88718d"), t = require("2ac857f85d53c0d9"), z = require("2530bcccb4fa7a24"), B = require("be94b1bb5bc85472"), aa = require("216278ca2d244710"), G = require("d20f31748da862fe");
function H(a, b) {
    let c = {};
    for (let d of a)a = b(d), c[a] ? c[a].push(d) : c[a] = [
        d
    ];
    return c;
}
function I(a) {
    a = H(a, (b)=>b.type);
    return {
        element: a.element || [],
        textFormat: a["text-format"] || [],
        textMatch: a["text-match"] || []
    };
}
let J = /[!-/:-@[-`{-~\s]/;
function ba(a) {
    let b = I(a), c = b.textFormat.filter((d)=>1 === d.format.length);
    return (d)=>{
        let e = [];
        d = (d || k.$getRoot()).getChildren();
        for (let f of d)d = ca(f, b.element, c, b.textMatch), null != d && e.push(d);
        return e.join("\n\n");
    };
}
function ca(a, b, c, d) {
    for (let e of b)if (b = e.export(a, (f)=>K(f, c, d)), null != b) return b;
    return k.$isElementNode(a) ? K(a, c, d) : k.$isDecoratorNode(a) ? a.getTextContent() : null;
}
function K(a, b, c) {
    let d = [];
    a = a.getChildren();
    a: for (let e of a){
        for (let f of c)if (a = f.export(e, (g)=>K(g, b, c), (g, l)=>L(g, l, b)), null != a) {
            d.push(a);
            continue a;
        }
        k.$isLineBreakNode(e) ? d.push("\n") : k.$isTextNode(e) ? d.push(L(e, e.getTextContent(), b)) : k.$isElementNode(e) ? d.push(K(e, b, c)) : k.$isDecoratorNode(e) && d.push(e.getTextContent());
    }
    return d.join("");
}
function L(a, b, c) {
    let d = b.trim(), e = d, f = new Set;
    for (let l of c){
        c = l.format[0];
        let r = l.tag;
        if (M(a, c) && !f.has(c)) {
            f.add(c);
            var g = N(a, !0);
            M(g, c) || (e = r + e);
            g = N(a, !1);
            M(g, c) || (e += r);
        }
    }
    return b.replace(d, e);
}
function N(a, b) {
    let c = b ? a.getPreviousSibling() : a.getNextSibling();
    c || (a = a.getParentOrThrow(), a.isInline() && (c = b ? a.getPreviousSibling() : a.getNextSibling()));
    for(; c;){
        if (k.$isElementNode(c)) {
            if (!c.isInline()) break;
            a = b ? c.getLastDescendant() : c.getFirstDescendant();
            if (k.$isTextNode(a)) return a;
            c = b ? c.getPreviousSibling() : c.getNextSibling();
        }
        if (k.$isTextNode(c)) return c;
        if (!k.$isElementNode(c)) break;
    }
    return null;
}
function M(a, b) {
    return k.$isTextNode(a) && a.hasFormat(b);
}
let O = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement, da = O && "documentMode" in document ? document.documentMode : null;
O && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
O && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
O && "InputEvent" in window && !da && new window.InputEvent("input");
let P = O && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), Q = O && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
O && /Android/.test(navigator.userAgent);
let ea = O && /^(?=.*Chrome).*/i.test(navigator.userAgent), R = O && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !ea, fa = /^\s{0,3}$/, S = /^```(\w{1,10})?\s?$/;
function ha(a) {
    let b = I(a), c = ia(b.textFormat);
    return (d, e)=>{
        d = d.split("\n");
        var f = d.length;
        e = e || k.$getRoot();
        e.clear();
        for(let h = 0; h < f; h++){
            var g = d[h];
            a: {
                var l = d, r = h;
                var q = e;
                var y = l[r].match(S);
                if (y) {
                    for(var p = r, m = l.length; ++p < m;)if (l[p].match(S)) {
                        y = t.$createCodeNode(y[1]);
                        l = k.$createTextNode(l.slice(r + 1, p).join("\n"));
                        y.append(l);
                        q.append(y);
                        q = [
                            y,
                            p
                        ];
                        break a;
                    }
                }
                q = [
                    null,
                    r
                ];
            }
            let [n, v] = q;
            if (null != n) h = v;
            else {
                q = g;
                m = e;
                var w = b.element;
                p = c;
                l = b.textMatch;
                r = q.trim();
                y = k.$createTextNode(r);
                g = k.$createParagraphNode();
                g.append(y);
                m.append(g);
                for (let { regExp: x, replace: u } of w)if (m = q.match(x)) {
                    y.setTextContent(q.slice(m[0].length));
                    u(g, [
                        y
                    ], m, !0);
                    break;
                }
                T(y, p, l);
                g.isAttached() && 0 < r.length && (q = g.getPreviousSibling(), k.$isParagraphNode(q) || B.$isQuoteNode(q) || z.$isListNode(q)) && (p = q, z.$isListNode(q) && (q = q.getLastDescendant(), p = null == q ? null : aa.$findMatchingParent(q, z.$isListItemNode)), null != p && 0 < p.getTextContentSize() && (p.splice(p.getChildrenSize(), 0, [
                    k.$createLineBreakNode(),
                    ...g.getChildren()
                ]), g.remove()));
            }
        }
        d = e.getChildren();
        for (let h of d)d = h, k.$isParagraphNode(d) ? (f = d.getFirstChild(), d = null == f || 1 === d.getChildrenSize() && k.$isTextNode(f) && fa.test(f.getTextContent())) : d = !1, d && h.remove();
        null !== k.$getSelection() && e.selectEnd();
    };
}
function T(a, b, c) {
    var d = a.getTextContent();
    let e = ja(d, b);
    if (e) {
        var f, g;
        if (e[0] === d) var l = a;
        else {
            d = e.index || 0;
            let r = d + e[0].length;
            0 === d ? [l, f] = a.splitText(r) : [g, l, f] = a.splitText(d, r);
        }
        l.setTextContent(e[2]);
        if (a = b.transformersByTag[e[1]]) for (let r of a.format)l.hasFormat(r) || l.toggleFormat(r);
        l.hasFormat("code") || T(l, b, c);
        g && T(g, b, c);
        f && T(f, b, c);
    } else U(a, c);
}
function U(a, b) {
    a: for(; a;){
        for (let c of b){
            let d = a.getTextContent().match(c.importRegExp);
            if (!d) continue;
            let e = d.index || 0, f = e + d[0].length, g, l;
            0 === e ? [g, a] = a.splitText(f) : [, g, l] = a.splitText(e, f);
            l && U(l, b);
            c.replace(g, d);
            continue a;
        }
        break;
    }
}
function ja(a, b) {
    var c = a.match(b.openTagsRegExp);
    if (null == c) return null;
    for (let f of c){
        var d = f.replace(/^\s/, "");
        c = b.fullMatchRegExpByTag[d];
        if (null != c && (c = a.match(c), d = b.transformersByTag[d], null != c && null != d)) {
            if (!1 !== d.intraword) return c;
            var { index: e = 0 } = c;
            d = a[e - 1];
            e = a[e + c[0].length];
            if (!(d && !J.test(d) || e && !J.test(e))) return c;
        }
    }
    return null;
}
function ia(a) {
    let b = {}, c = {}, d = [];
    for (let e of a){
        ({ tag: a } = e);
        b[a] = e;
        let f = a.replace(/(\*|\^|\+)/g, "\\$1");
        d.push(f);
        c[a] = P || Q || R ? new RegExp(`(${f})(?![${f}\\s])(.*?[^${f}\\s])${f}(?!${f})`) : new RegExp(`(?<![\\\\${f}])(${f})((\\\\${f})?.*?[^${f}\\s](\\\\${f})?)((?<!\\\\)|(?<=\\\\\\\\))(${f})(?![\\\\${f}])`);
    }
    return {
        fullMatchRegExpByTag: c,
        openTagsRegExp: new RegExp((P || Q || R ? "" : "(?<![\\\\])") + "(" + d.join("|") + ")", "g"),
        transformersByTag: b
    };
}
function V(a, b, c) {
    let d = c.length;
    for(; b >= d; b--){
        let e = b - d;
        if (W(a, e, c, 0, d) && " " !== a[e + d]) return e;
    }
    return -1;
}
function W(a, b, c, d, e) {
    for(let f = 0; f < e; f++)if (a[b + f] !== c[d + f]) return !1;
    return !0;
}
let ka = (a)=>(b, c, d)=>{
        d = a(d);
        d.append(...c);
        b.replace(d);
        d.select(0, 0);
    }, X = (a)=>(b, c, d)=>{
        var e = b.getPreviousSibling(), f = b.getNextSibling();
        const g = z.$createListItemNode("check" === a ? "x" === d[3] : void 0);
        z.$isListNode(f) && f.getListType() === a ? (e = f.getFirstChild(), null !== e ? e.insertBefore(g) : f.append(g), b.remove()) : z.$isListNode(e) && e.getListType() === a ? (e.append(g), b.remove()) : (f = z.$createListNode(a, "number" === a ? Number(d[2]) : void 0), f.append(g), b.replace(f));
        g.append(...c);
        g.select(0, 0);
        (b = Math.floor(d[1].length / 4)) && g.setIndent(b);
    }, Y = (a, b, c)=>{
    const d = [];
    var e = a.getChildren();
    let f = 0;
    for (const l of e)if (z.$isListItemNode(l)) {
        if (1 === l.getChildrenSize() && (e = l.getFirstChild(), z.$isListNode(e))) {
            d.push(Y(e, b, c + 1));
            continue;
        }
        e = " ".repeat(4 * c);
        var g = a.getListType();
        g = "number" === g ? `${a.getStart() + f}. ` : "check" === g ? `- [${l.getChecked() ? "x" : " "}] ` : "- ";
        d.push(e + g + b(l));
        f++;
    }
    return d.join("\n");
}, la = {
    dependencies: [
        B.HeadingNode
    ],
    export: (a, b)=>{
        if (!B.$isHeadingNode(a)) return null;
        const c = Number(a.getTag().slice(1));
        return "#".repeat(c) + " " + b(a);
    },
    regExp: /^(#{1,6})\s/,
    replace: ka((a)=>B.$createHeadingNode("h" + a[1].length)),
    type: "element"
}, ma = {
    dependencies: [
        B.QuoteNode
    ],
    export: (a, b)=>{
        if (!B.$isQuoteNode(a)) return null;
        a = b(a).split("\n");
        b = [];
        for (const c of a)b.push("> " + c);
        return b.join("\n");
    },
    regExp: /^>\s/,
    replace: (a, b, c, d)=>{
        if (d && (c = a.getPreviousSibling(), B.$isQuoteNode(c))) {
            c.splice(c.getChildrenSize(), 0, [
                k.$createLineBreakNode(),
                ...b
            ]);
            c.select(0, 0);
            a.remove();
            return;
        }
        c = B.$createQuoteNode();
        c.append(...b);
        a.replace(c);
        c.select(0, 0);
    },
    type: "element"
}, na = {
    dependencies: [
        t.CodeNode
    ],
    export: (a)=>{
        if (!t.$isCodeNode(a)) return null;
        const b = a.getTextContent();
        return "```" + (a.getLanguage() || "") + (b ? "\n" + b : "") + "\n```";
    },
    regExp: /^```(\w{1,10})?\s/,
    replace: ka((a)=>t.$createCodeNode(a ? a[1] : void 0)),
    type: "element"
}, oa = {
    dependencies: [
        z.ListNode,
        z.ListItemNode
    ],
    export: (a, b)=>z.$isListNode(a) ? Y(a, b, 0) : null,
    regExp: /^(\s*)[-*+]\s/,
    replace: X("bullet"),
    type: "element"
}, pa = {
    dependencies: [
        z.ListNode,
        z.ListItemNode
    ],
    export: (a, b)=>z.$isListNode(a) ? Y(a, b, 0) : null,
    regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i,
    replace: X("check"),
    type: "element"
}, qa = {
    dependencies: [
        z.ListNode,
        z.ListItemNode
    ],
    export: (a, b)=>z.$isListNode(a) ? Y(a, b, 0) : null,
    regExp: /^(\s*)(\d{1,})\.\s/,
    replace: X("number"),
    type: "element"
}, ra = {
    format: [
        "code"
    ],
    tag: "`",
    type: "text-format"
}, sa = {
    format: [
        "highlight"
    ],
    tag: "==",
    type: "text-format"
}, ta = {
    format: [
        "bold",
        "italic"
    ],
    tag: "***",
    type: "text-format"
}, va = {
    format: [
        "bold",
        "italic"
    ],
    intraword: !1,
    tag: "___",
    type: "text-format"
}, wa = {
    format: [
        "bold"
    ],
    tag: "**",
    type: "text-format"
}, xa = {
    format: [
        "bold"
    ],
    intraword: !1,
    tag: "__",
    type: "text-format"
}, ya = {
    format: [
        "strikethrough"
    ],
    tag: "~~",
    type: "text-format"
}, za = {
    format: [
        "italic"
    ],
    tag: "*",
    type: "text-format"
}, Aa = {
    format: [
        "italic"
    ],
    intraword: !1,
    tag: "_",
    type: "text-format"
}, Ba = {
    dependencies: [
        G.LinkNode
    ],
    export: (a, b, c)=>{
        if (!G.$isLinkNode(a)) return null;
        b = (b = a.getTitle()) ? `[${a.getTextContent()}](${a.getURL()} "${b}")` : `[${a.getTextContent()}](${a.getURL()})`;
        const d = a.getFirstChild();
        return 1 === a.getChildrenSize() && k.$isTextNode(d) ? c(d, b) : b;
    },
    importRegExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
    regExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
    replace: (a, b)=>{
        const [, c, d, e] = b;
        b = G.$createLinkNode(d, {
            title: e
        });
        const f = k.$createTextNode(c);
        f.setFormat(a.getFormat());
        b.append(f);
        a.replace(b);
    },
    trigger: ")",
    type: "text-match"
}, Ca = [
    la,
    ma,
    na,
    oa,
    qa
], Da = [
    ra,
    ta,
    va,
    wa,
    xa,
    sa,
    za,
    Aa,
    ya
], Ea = [
    Ba
], Z = [
    ...Ca,
    ...Da,
    ...Ea
];
exports.$convertFromMarkdownString = function(a, b = Z, c) {
    return ha(b)(a, c);
};
exports.$convertToMarkdownString = function(a = Z, b) {
    return ba(a)(b);
};
exports.BOLD_ITALIC_STAR = ta;
exports.BOLD_ITALIC_UNDERSCORE = va;
exports.BOLD_STAR = wa;
exports.BOLD_UNDERSCORE = xa;
exports.CHECK_LIST = pa;
exports.CODE = na;
exports.ELEMENT_TRANSFORMERS = Ca;
exports.HEADING = la;
exports.HIGHLIGHT = sa;
exports.INLINE_CODE = ra;
exports.ITALIC_STAR = za;
exports.ITALIC_UNDERSCORE = Aa;
exports.LINK = Ba;
exports.ORDERED_LIST = qa;
exports.QUOTE = ma;
exports.STRIKETHROUGH = ya;
exports.TEXT_FORMAT_TRANSFORMERS = Da;
exports.TEXT_MATCH_TRANSFORMERS = Ea;
exports.TRANSFORMERS = Z;
exports.UNORDERED_LIST = oa;
exports.registerMarkdownShortcuts = function(a, b = Z) {
    let c = I(b), d = H(c.textFormat, ({ tag: f })=>f[f.length - 1]), e = H(c.textMatch, ({ trigger: f })=>f);
    for (let f of b)if (b = f.type, "element" === b || "text-match" === b) {
        b = f.dependencies;
        for (let g of b)if (!a.hasNode(g)) throw Error(`MarkdownShortcuts: missing dependency ${g.getType()} for transformer. Ensure node dependency is included in editor initial config.`);
    }
    return a.registerUpdateListener(({ tags: f, dirtyLeaves: g, editorState: l, prevEditorState: r })=>{
        if (!f.has("historic") && !a.isComposing()) {
            var q = l.read(k.$getSelection);
            f = r.read(k.$getSelection);
            if (k.$isRangeSelection(f) && k.$isRangeSelection(q) && q.isCollapsed()) {
                r = q.anchor.key;
                var y = q.anchor.offset, p = l._nodeMap.get(r);
                !k.$isTextNode(p) || !g.has(r) || 1 !== y && y > f.anchor.offset + 1 || a.update(()=>{
                    if (!p.hasFormat("code")) {
                        var m = p.getParent();
                        if (null !== m && !t.$isCodeNode(m)) {
                            var w = q.anchor.offset;
                            b: {
                                var h = c.element, n = m.getParent();
                                if (k.$isRootOrShadowRoot(n) && m.getFirstChild() === p && (n = p.getTextContent(), " " === n[w - 1])) {
                                    for (let { regExp: D, replace: E } of h)if ((h = n.match(D)) && h[0].length === w) {
                                        n = p.getNextSiblings();
                                        let [F, ua] = p.splitText(w);
                                        F.remove();
                                        n = ua ? [
                                            ua,
                                            ...n
                                        ] : n;
                                        E(m, n, h, !1);
                                        m = !0;
                                        break b;
                                    }
                                }
                                m = !1;
                            }
                            if (!m) {
                                b: {
                                    h = p.getTextContent();
                                    m = e[h[w - 1]];
                                    if (null != m) {
                                        w < h.length && (h = h.slice(0, w));
                                        for (x of m)if (m = h.match(x.regExp), null !== m) {
                                            h = m.index || 0;
                                            n = h + m[0].length;
                                            var v = void 0;
                                            0 === h ? [v] = p.splitText(n) : [, v] = p.splitText(h, n);
                                            v.selectNext(0, 0);
                                            x.replace(v, m);
                                            var x = !0;
                                            break b;
                                        }
                                    }
                                    x = !1;
                                }
                                if (!x) b: {
                                    n = p.getTextContent();
                                    --w;
                                    var u = n[w];
                                    if (x = d[u]) for (let D of x){
                                        var { tag: C } = D;
                                        x = C.length;
                                        let E = w - x + 1;
                                        if (!(1 < x && !W(n, E, C, 0, x) || " " === n[E - 1]) && (v = n[w + 1], !1 !== D.intraword || !v || J.test(v))) {
                                            m = v = p;
                                            h = V(n, E, C);
                                            for(var A = m; 0 > h && (A = A.getPreviousSibling()) && !k.$isLineBreakNode(A);)k.$isTextNode(A) && (h = A.getTextContent(), m = A, h = V(h, h.length, C));
                                            if (!(0 > h || m === v && h + x === E || (C = m.getTextContent(), 0 < h && C[h - 1] === u || (A = C[h - 1], !1 === D.intraword && A && !J.test(A))))) {
                                                n = v.getTextContent();
                                                n = n.slice(0, E) + n.slice(w + 1);
                                                v.setTextContent(n);
                                                n = m === v ? n : C;
                                                m.setTextContent(n.slice(0, h) + n.slice(h + x));
                                                n = k.$getSelection();
                                                u = k.$createRangeSelection();
                                                k.$setSelection(u);
                                                w = w - x * (m === v ? 2 : 1) + 1;
                                                u.anchor.set(m.__key, h, "text");
                                                u.focus.set(v.__key, w, "text");
                                                for (let F of D.format)u.hasFormat(F) || u.formatText(F);
                                                u.anchor.set(u.focus.key, u.focus.offset, u.focus.type);
                                                for (let F of D.format)u.hasFormat(F) && u.toggleFormat(F);
                                                k.$isRangeSelection(n) && (u.format = n.format);
                                                break b;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    });
};

},{"9d63e336ae88718d":"6uPvi","2ac857f85d53c0d9":"7QLm2","2530bcccb4fa7a24":"2CQxU","be94b1bb5bc85472":"kNqAc","216278ca2d244710":"1V3L7","d20f31748da862fe":"2MxRL"}],"6uPvi":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const Lexical = require("d09624b3a643c623");
module.exports = Lexical;

},{"d09624b3a643c623":"7jgq2"}],"7jgq2":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
let aa = {}, ba = {}, da = {}, ea = {}, ja = {}, ka = {}, la = {}, na = {}, oa = {}, pa = {}, qa = {}, ra = {}, sa = {}, ta = {}, ua = {}, va = {}, xa = {}, ya = {}, za = {}, Aa = {}, Ba = {}, Ca = {}, Fa = {}, Ga = {}, Ha = {}, Ja = {}, Ka = {}, La = {}, Ma = {}, Na = {}, Oa = {}, Pa = {}, Qa = {}, Ra = {}, Sa = {}, Ta = {};
function q(a) {
    let b = new URLSearchParams;
    b.append("code", a);
    for(let c = 1; c < arguments.length; c++)b.append("v", arguments[c]);
    throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?${b} for the full message or ` + "use the non-minified dev environment for full errors and additional helpful warnings.");
}
let Ua = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement, Va = Ua && "documentMode" in document ? document.documentMode : null, t = Ua && /Mac|iPod|iPhone|iPad/.test(navigator.platform), Xa = Ua && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), Ya = Ua && "InputEvent" in window && !Va ? "getTargetRanges" in new window.InputEvent("input") : !1, Za = Ua && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), $a = Ua && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, ab = Ua && /Android/.test(navigator.userAgent), bb = Ua && /^(?=.*Chrome).*/i.test(navigator.userAgent), cb = Ua && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !bb, db = Za || $a || cb ? "\xa0" : "\u200B", eb = Xa ? "\xa0" : db, fb = /^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/, gb = /^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/, hb = {
    bold: 1,
    code: 16,
    highlight: 128,
    italic: 2,
    strikethrough: 4,
    subscript: 32,
    superscript: 64,
    underline: 8
}, ib = {
    directionless: 1,
    unmergeable: 2
}, jb = {
    center: 2,
    end: 6,
    justify: 4,
    left: 1,
    right: 3,
    start: 5
}, kb = {
    2: "center",
    6: "end",
    4: "justify",
    1: "left",
    3: "right",
    5: "start"
}, ob = {
    normal: 0,
    segmented: 2,
    token: 1
}, pb = {
    0: "normal",
    2: "segmented",
    1: "token"
}, qb = !1, rb = 0;
function sb(a) {
    rb = a.timeStamp;
}
function tb(a, b, c) {
    return b.__lexicalLineBreak === a || void 0 !== a[`__lexicalKey_${c._key}`];
}
function ub(a) {
    return a.getEditorState().read(()=>{
        let b = u();
        return null !== b ? b.clone() : null;
    });
}
function vb(a, b, c) {
    qb = !0;
    let d = 100 < performance.now() - rb;
    try {
        v(a, ()=>{
            let e = u() || ub(a);
            var f = new Map, g = a.getRootElement(), h = a._editorState, k = a._blockCursorElement;
            let m = !1, n = "";
            for(var p = 0; p < b.length; p++){
                var l = b[p], r = l.type, w = l.target, y = wb(w, h);
                if (!(null === y && w !== g || x(y))) {
                    if ("characterData" === r) {
                        if (l = d && B(y)) a: {
                            l = e;
                            r = w;
                            var z = y;
                            if (C(l)) {
                                var A = l.anchor.getNode();
                                if (A.is(z) && l.format !== A.getFormat()) {
                                    l = !1;
                                    break a;
                                }
                            }
                            l = 3 === r.nodeType && z.isAttached();
                        }
                        l && (z = xb(a._window), r = l = null, null !== z && z.anchorNode === w && (l = z.anchorOffset, r = z.focusOffset), w = w.nodeValue, null !== w && yb(y, w, l, r, !1));
                    } else if ("childList" === r) {
                        m = !0;
                        r = l.addedNodes;
                        for(z = 0; z < r.length; z++){
                            A = r[z];
                            var Ia = zb(A), ca = A.parentNode;
                            null == ca || A === k || null !== Ia || "BR" === A.nodeName && tb(A, ca, a) || (Xa && (Ia = A.innerText || A.nodeValue) && (n += Ia), ca.removeChild(A));
                        }
                        l = l.removedNodes;
                        r = l.length;
                        if (0 < r) {
                            z = 0;
                            for(A = 0; A < r; A++)if (ca = l[A], "BR" === ca.nodeName && tb(ca, w, a) || k === ca) w.appendChild(ca), z++;
                            r !== z && (w === g && (y = h._nodeMap.get("root")), f.set(w, y));
                        }
                    }
                }
            }
            if (0 < f.size) for (let [Wa, ia] of f)if (E(ia)) for(f = ia.getChildrenKeys(), g = Wa.firstChild, h = 0; h < f.length; h++)k = a.getElementByKey(f[h]), null !== k && (null == g ? (Wa.appendChild(k), g = k) : g !== k && Wa.replaceChild(k, g), g = g.nextSibling);
            else B(ia) && ia.markDirty();
            f = c.takeRecords();
            if (0 < f.length) {
                for(g = 0; g < f.length; g++)for(k = f[g], h = k.addedNodes, k = k.target, p = 0; p < h.length; p++)y = h[p], w = y.parentNode, null == w || "BR" !== y.nodeName || tb(y, k, a) || w.removeChild(y);
                c.takeRecords();
            }
            null !== e && (m && (e.dirty = !0, Ab(e)), Xa && Bb(a) && e.insertRawText(n));
        });
    } finally{
        qb = !1;
    }
}
function Cb(a) {
    let b = a._observer;
    if (null !== b) {
        let c = b.takeRecords();
        vb(a, c, b);
    }
}
function Db(a) {
    0 === rb && Eb(a).addEventListener("textInput", sb, !0);
    a._observer = new MutationObserver((b, c)=>{
        vb(a, b, c);
    });
}
function Fb(a, b) {
    let c = a.__mode, d = a.__format;
    a = a.__style;
    let e = b.__mode, f = b.__format;
    b = b.__style;
    return (null === c || c === e) && (null === d || d === f) && (null === a || a === b);
}
function Gb(a, b) {
    let c = a.mergeWithSibling(b), d = F()._normalizedNodes;
    d.add(a.__key);
    d.add(b.__key);
    return c;
}
function Hb(a) {
    if ("" === a.__text && a.isSimpleText() && !a.isUnmergeable()) a.remove();
    else {
        for(var b; null !== (b = a.getPreviousSibling()) && B(b) && b.isSimpleText() && !b.isUnmergeable();)if ("" === b.__text) b.remove();
        else {
            Fb(b, a) && (a = Gb(b, a));
            break;
        }
        for(var c; null !== (c = a.getNextSibling()) && B(c) && c.isSimpleText() && !c.isUnmergeable();)if ("" === c.__text) c.remove();
        else {
            Fb(a, c) && Gb(a, c);
            break;
        }
    }
}
function Ib(a) {
    Jb(a.anchor);
    Jb(a.focus);
    return a;
}
function Jb(a) {
    for(; "element" === a.type;){
        var b = a.getNode(), c = a.offset;
        c === b.getChildrenSize() ? (b = b.getChildAtIndex(c - 1), c = !0) : (b = b.getChildAtIndex(c), c = !1);
        if (B(b)) {
            a.set(b.__key, c ? b.getTextContentSize() : 0, "text");
            break;
        } else if (!E(b)) break;
        a.set(b.__key, c ? b.getChildrenSize() : 0, "element");
    }
}
let Kb = 1, Lb = "function" === typeof queueMicrotask ? queueMicrotask : (a)=>{
    Promise.resolve().then(a);
};
function Mb(a) {
    let b = document.activeElement;
    if (null === b) return !1;
    let c = b.nodeName;
    return x(wb(a)) && ("INPUT" === c || "TEXTAREA" === c || "true" === b.contentEditable && null == b.__lexicalEditor);
}
function Tb(a, b, c) {
    let d = a.getRootElement();
    try {
        return null !== d && d.contains(b) && d.contains(c) && null !== b && !Mb(b) && Ub(b) === a;
    } catch (e) {
        return !1;
    }
}
function Ub(a) {
    for(; null != a;){
        let b = a.__lexicalEditor;
        if (null != b) return b;
        a = Vb(a);
    }
    return null;
}
function Wb(a) {
    return a.isToken() || a.isSegmented();
}
function Xb(a) {
    for(; null != a;){
        if (3 === a.nodeType) return a;
        a = a.firstChild;
    }
    return null;
}
function Yb(a, b, c) {
    let d = hb[b];
    if (null !== c && (a & d) === (c & d)) return a;
    a ^= d;
    "subscript" === b ? a &= ~hb.superscript : "superscript" === b && (a &= ~hb.subscript);
    return a;
}
function Zb(a, b) {
    if (null != b) a.__key = b;
    else {
        G();
        99 < $b && q(14);
        b = F();
        var c = ac(), d = "" + Kb++;
        c._nodeMap.set(d, a);
        E(a) ? b._dirtyElements.set(d, !0) : b._dirtyLeaves.add(d);
        b._cloneNotNeeded.add(d);
        b._dirtyType = 1;
        a.__key = d;
    }
}
function bc(a) {
    var b = a.getParent();
    if (null !== b) {
        let e = a.getWritable();
        b = b.getWritable();
        var c = a.getPreviousSibling();
        a = a.getNextSibling();
        if (null === c) {
            if (null !== a) {
                var d = a.getWritable();
                b.__first = a.__key;
                d.__prev = null;
            } else b.__first = null;
        } else {
            d = c.getWritable();
            if (null !== a) {
                let f = a.getWritable();
                f.__prev = d.__key;
                d.__next = f.__key;
            } else d.__next = null;
            e.__prev = null;
        }
        null === a ? null !== c ? (a = c.getWritable(), b.__last = c.__key, a.__next = null) : b.__last = null : (a = a.getWritable(), null !== c ? (c = c.getWritable(), c.__next = a.__key, a.__prev = c.__key) : a.__prev = null, e.__next = null);
        b.__size--;
        e.__parent = null;
    }
}
function cc(a) {
    99 < $b && q(14);
    var b = a.getLatest(), c = b.__parent, d = ac();
    let e = F(), f = d._nodeMap;
    d = e._dirtyElements;
    if (null !== c) a: for(; null !== c;){
        if (d.has(c)) break a;
        let g = f.get(c);
        if (void 0 === g) break;
        d.set(c, !1);
        c = g.__parent;
    }
    b = b.__key;
    e._dirtyType = 1;
    E(a) ? d.set(b, !0) : e._dirtyLeaves.add(b);
}
function H(a) {
    G();
    var b = F();
    let c = b._compositionKey;
    a !== c && (b._compositionKey = a, null !== c && (b = I(c), null !== b && b.getWritable()), null !== a && (a = I(a), null !== a && a.getWritable()));
}
function dc() {
    return ec() ? null : F()._compositionKey;
}
function I(a, b) {
    a = (b || ac())._nodeMap.get(a);
    return void 0 === a ? null : a;
}
function zb(a, b) {
    let c = F();
    a = a[`__lexicalKey_${c._key}`];
    return void 0 !== a ? I(a, b) : null;
}
function wb(a, b) {
    for(; null != a;){
        let c = zb(a, b);
        if (null !== c) return c;
        a = Vb(a);
    }
    return null;
}
function fc(a) {
    let b = Object.assign({}, a._decorators);
    return a._pendingDecorators = b;
}
function gc(a) {
    return a.read(()=>J().getTextContent());
}
function hc(a, b) {
    v(a, ()=>{
        var c = ac();
        if (!c.isEmpty()) {
            if ("root" === b) J().markDirty();
            else {
                c = c._nodeMap;
                for (let [, d] of c)d.markDirty();
            }
        }
    }, null === a._pendingEditorState ? {
        tag: "history-merge"
    } : void 0);
}
function J() {
    return ac()._nodeMap.get("root");
}
function Ab(a) {
    G();
    let b = ac();
    null !== a && (a.dirty = !0, a.setCachedNodes(null));
    b._selection = a;
}
function ic(a) {
    var b = F(), c;
    a: {
        for(c = a; null != c;){
            let d = c[`__lexicalKey_${b._key}`];
            if (void 0 !== d) {
                c = d;
                break a;
            }
            c = Vb(c);
        }
        c = null;
    }
    return null === c ? (b = b.getRootElement(), a === b ? I("root") : null) : I(c);
}
function jc(a) {
    return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(a);
}
function kc(a) {
    let b = [];
    for(; null !== a;)b.push(a), a = a._parentEditor;
    return b;
}
function lc() {
    return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function mc(a, b, c) {
    b = xb(b._window);
    if (null !== b) {
        var d = b.anchorNode, { anchorOffset: e, focusOffset: f } = b;
        if (null !== d && (b = 3 === d.nodeType ? d.nodeValue : null, d = wb(d), null !== b && B(d))) {
            if (b === db && c) {
                let g = c.length;
                b = c;
                f = e = g;
            }
            null !== b && yb(d, b, e, f, a);
        }
    }
}
function yb(a, b, c, d, e) {
    let f = a;
    if (f.isAttached() && (e || !f.isDirty())) {
        let m = f.isComposing(), n = b;
        (m || e) && b[b.length - 1] === db && (n = b.slice(0, -1));
        b = f.getTextContent();
        if (e || n !== b) {
            if ("" === n) {
                if (H(null), Za || $a || cb) f.remove();
                else {
                    let p = F();
                    setTimeout(()=>{
                        p.update(()=>{
                            f.isAttached() && f.remove();
                        });
                    }, 20);
                }
            } else {
                e = f.getParent();
                b = nc();
                var g = f.getTextContentSize(), h = dc(), k = f.getKey();
                f.isToken() || null !== h && k === h && !m || C(b) && (null !== e && !e.canInsertTextBefore() && 0 === b.anchor.offset || b.anchor.key === a.__key && 0 === b.anchor.offset && !f.canInsertTextBefore() && !m || b.focus.key === a.__key && b.focus.offset === g && !f.canInsertTextAfter() && !m) ? f.markDirty() : (a = u(), C(a) && null !== c && null !== d && (a.setTextNodeRange(f, c, f, d), f.isSegmented() && (c = f.getTextContent(), c = K(c), f.replace(c), f = c)), f.setTextContent(n));
            }
        }
    }
}
function oc(a, b) {
    if (b.isSegmented()) return !0;
    if (!a.isCollapsed()) return !1;
    a = a.anchor.offset;
    let c = b.getParentOrThrow(), d = b.isToken();
    return 0 === a ? ((a = !b.canInsertTextBefore() || !c.canInsertTextBefore() || d) || (b = b.getPreviousSibling(), a = (B(b) || E(b) && b.isInline()) && !b.canInsertTextAfter()), a) : a === b.getTextContentSize() ? !b.canInsertTextAfter() || !c.canInsertTextAfter() || d : !1;
}
function pc(a, b) {
    void 0 === a.__lexicalClassNameCache && (a.__lexicalClassNameCache = {});
    let c = a.__lexicalClassNameCache, d = c[b];
    if (void 0 !== d) return d;
    a = a[b];
    return "string" === typeof a ? (a = a.split(" "), c[b] = a) : a;
}
function qc(a, b, c, d, e) {
    0 !== c.size && (c = d.__type, d = d.__key, b = b.get(c), void 0 === b && q(33, c), c = b.klass, b = a.get(c), void 0 === b && (b = new Map, a.set(c, b)), a = b.get(d), c = "destroyed" === a && "created" === e, (void 0 === a || c) && b.set(d, c ? "updated" : e));
}
function rc(a, b, c) {
    let d = a.getParent(), e = c;
    null !== d && (b && 0 === c ? (e = a.getIndexWithinParent(), a = d) : b || c !== a.getChildrenSize() || (e = a.getIndexWithinParent() + 1, a = d));
    return a.getChildAtIndex(b ? e - 1 : e);
}
function sc(a, b) {
    var c = a.offset;
    if ("element" === a.type) return a = a.getNode(), rc(a, b, c);
    a = a.getNode();
    return b && 0 === c || !b && c === a.getTextContentSize() ? (c = b ? a.getPreviousSibling() : a.getNextSibling(), null === c ? rc(a.getParentOrThrow(), b, a.getIndexWithinParent() + (b ? 0 : 1)) : c) : null;
}
function Bb(a) {
    a = (a = Eb(a).event) && a.inputType;
    return "insertFromPaste" === a || "insertFromPasteAsQuotation" === a;
}
function tc(a) {
    return !L(a) && !a.isLastChild() && !a.isInline();
}
function uc(a, b) {
    a = a._keyToDOMMap.get(b);
    void 0 === a && q(75, b);
    return a;
}
function Vb(a) {
    a = a.assignedSlot || a.parentElement;
    return null !== a && 11 === a.nodeType ? a.host : a;
}
function vc(a, b) {
    for(a = a.getParent(); null !== a;){
        if (a.is(b)) return !0;
        a = a.getParent();
    }
    return !1;
}
function Eb(a) {
    a = a._window;
    null === a && q(78);
    return a;
}
function wc(a) {
    for(a = a.getParentOrThrow(); null !== a && !xc(a);)a = a.getParentOrThrow();
    return a;
}
function xc(a) {
    return L(a) || E(a) && a.isShadowRoot();
}
function yc(a) {
    a = a.constructor.clone(a);
    Zb(a, null);
    return a;
}
function zc(a) {
    var b = F();
    let c = a.constructor.getType();
    b = b._nodes.get(c);
    void 0 === b && q(97);
    b = b.replace;
    return null !== b ? (b = b(a), b instanceof a.constructor || q(98), b) : a;
}
function Ac(a, b) {
    a = a.getParent();
    !L(a) || E(b) || x(b) || q(99);
}
function Bc(a) {
    return (x(a) || E(a) && !a.canBeEmpty()) && !a.isInline();
}
function Cc(a, b, c) {
    c.style.removeProperty("caret-color");
    b._blockCursorElement = null;
    b = a.parentElement;
    null !== b && b.removeChild(a);
}
function xb(a) {
    return Ua ? (a || window).getSelection() : null;
}
function Dc(a, b) {
    for(; a !== J() && null != a;){
        if (b(a)) return a;
        a = a.getParent();
    }
    return null;
}
function Ec(a) {
    return 1 === a.nodeType;
}
function Fc(a) {
    if (x(a) && !a.isInline()) return !0;
    if (!E(a) || xc(a)) return !1;
    var b = a.getFirstChild();
    b = null === b || Gc(b) || B(b) || b.isInline();
    return !a.isInline() && !1 !== a.canBeEmpty() && b;
}
function Hc(a, b) {
    for(; null !== a && null !== a.getParent() && !b(a);)a = a.getParentOrThrow();
    return b(a) ? a : null;
}
function Ic(a, b, c, d, e, f) {
    for(a = a.getFirstChild(); null !== a;){
        let g = a.__key;
        a.__parent === b && (E(a) && Ic(a, g, c, d, e, f), c.has(g) || f.delete(g), e.push(g));
        a = a.getNextSibling();
    }
}
function Jc(a, b, c, d) {
    a = a._nodeMap;
    b = b._nodeMap;
    let e = [];
    for (let [f] of d){
        let g = b.get(f);
        void 0 === g || g.isAttached() || (E(g) && Ic(g, f, a, b, e, d), a.has(f) || d.delete(f), e.push(f));
    }
    for (let f of e)b.delete(f);
    for (let f of c)d = b.get(f), void 0 === d || d.isAttached() || (a.has(f) || c.delete(f), b.delete(f));
}
let M = "", N = "", Kc = "", Lc, O, Mc, Nc = !1, Oc = !1, Pc, Qc = null, Rc, Sc, Tc, Uc, dd, ed;
function fd(a, b) {
    let c = Tc.get(a);
    if (null !== b) {
        let d = gd(a);
        d.parentNode === b && b.removeChild(d);
    }
    Uc.has(a) || O._keyToDOMMap.delete(a);
    E(c) && (a = hd(c, Tc), id(a, 0, a.length - 1, null));
    void 0 !== c && qc(ed, Mc, Pc, c, "destroyed");
}
function id(a, b, c, d) {
    for(; b <= c; ++b){
        let e = a[b];
        void 0 !== e && fd(e, d);
    }
}
function jd(a, b) {
    a.setProperty("text-align", b);
}
function kd(a, b) {
    var c = Lc.theme.indent;
    if ("string" === typeof c) {
        let d = a.classList.contains(c);
        0 < b && !d ? a.classList.add(c) : 1 > b && d && a.classList.remove(c);
    }
    c = getComputedStyle(a).getPropertyValue("--lexical-indent-base-value") || "40px";
    a.style.setProperty("padding-inline-start", 0 === b ? "" : `calc(${b} * ${c})`);
}
function ld(a, b) {
    a = a.style;
    0 === b ? jd(a, "") : 1 === b ? jd(a, "left") : 2 === b ? jd(a, "center") : 3 === b ? jd(a, "right") : 4 === b ? jd(a, "justify") : 5 === b ? jd(a, "start") : 6 === b && jd(a, "end");
}
function md(a, b, c) {
    let d = Uc.get(a);
    void 0 === d && q(60);
    let e = d.createDOM(Lc, O);
    var f = O._keyToDOMMap;
    e["__lexicalKey_" + O._key] = a;
    f.set(a, e);
    B(d) ? e.setAttribute("data-lexical-text", "true") : x(d) && e.setAttribute("data-lexical-decorator", "true");
    if (E(d)) {
        a = d.__indent;
        f = d.__size;
        0 !== a && kd(e, a);
        if (0 !== f) {
            --f;
            a = hd(d, Uc);
            var g = N;
            N = "";
            nd(a, d, 0, f, e, null);
            od(d, e);
            N = g;
        }
        a = d.__format;
        0 !== a && ld(e, a);
        d.isInline() || pd(null, d, e);
        tc(d) && (M += "\n\n", Kc += "\n\n");
    } else f = d.getTextContent(), x(d) ? (g = d.decorate(O, Lc), null !== g && qd(a, g), e.contentEditable = "false") : B(d) && (d.isDirectionless() || (N += f)), M += f, Kc += f;
    null !== b && (null != c ? b.insertBefore(e, c) : (c = b.__lexicalLineBreak, null != c ? b.insertBefore(e, c) : b.appendChild(e)));
    qc(ed, Mc, Pc, d, "created");
    return e;
}
function nd(a, b, c, d, e, f) {
    let g = M;
    for(M = ""; c <= d; ++c)md(a[c], e, f);
    tc(b) && (M += "\n\n");
    e.__lexicalTextContent = M;
    M = g + M;
}
function rd(a, b) {
    a = b.get(a);
    return Gc(a) || x(a) && a.isInline();
}
function pd(a, b, c) {
    a = null !== a && (0 === a.__size || rd(a.__last, Tc));
    b = 0 === b.__size || rd(b.__last, Uc);
    a ? b || (b = c.__lexicalLineBreak, null != b && c.removeChild(b), c.__lexicalLineBreak = null) : b && (b = document.createElement("br"), c.__lexicalLineBreak = b, c.appendChild(b));
}
function od(a, b) {
    var c = b.__lexicalDir;
    if (b.__lexicalDirTextContent !== N || c !== Qc) {
        let f = "" === N;
        if (f) var d = Qc;
        else d = N, d = fb.test(d) ? "rtl" : gb.test(d) ? "ltr" : null;
        if (d !== c) {
            let g = b.classList, h = Lc.theme;
            var e = null !== c ? h[c] : void 0;
            let k = null !== d ? h[d] : void 0;
            void 0 !== e && ("string" === typeof e && (e = e.split(" "), e = h[c] = e), g.remove(...e));
            null === d || f && "ltr" === d ? b.removeAttribute("dir") : (void 0 !== k && ("string" === typeof k && (c = k.split(" "), k = h[d] = c), void 0 !== k && g.add(...k)), b.dir = d);
            Oc || (a.getWritable().__dir = d);
        }
        Qc = d;
        b.__lexicalDirTextContent = N;
        b.__lexicalDir = d;
    }
}
function hd(a, b) {
    let c = [];
    for(a = a.__first; null !== a;){
        let d = b.get(a);
        void 0 === d && q(101);
        c.push(a);
        a = d.__next;
    }
    return c;
}
function sd(a, b) {
    var c = Tc.get(a), d = Uc.get(a);
    void 0 !== c && void 0 !== d || q(61);
    var e = Nc || Sc.has(a) || Rc.has(a);
    let f = uc(O, a);
    if (c === d && !e) return E(c) ? (d = f.__lexicalTextContent, void 0 !== d && (M += d, Kc += d), d = f.__lexicalDirTextContent, void 0 !== d && (N += d)) : (d = c.getTextContent(), B(c) && !c.isDirectionless() && (N += d), Kc += d, M += d), f;
    c !== d && e && qc(ed, Mc, Pc, d, "updated");
    if (d.updateDOM(c, f, Lc)) return d = md(a, null, null), null === b && q(62), b.replaceChild(d, f), fd(a, null), d;
    if (E(c) && E(d)) {
        a = d.__indent;
        a !== c.__indent && kd(f, a);
        a = d.__format;
        a !== c.__format && ld(f, a);
        if (e) {
            a = N;
            N = "";
            e = M;
            var g = c.__size, h = d.__size;
            M = "";
            if (1 === g && 1 === h) {
                var k = c.__first;
                b = d.__first;
                if (k === b) sd(k, f);
                else {
                    var m = gd(k);
                    b = md(b, null, null);
                    f.replaceChild(b, m);
                    fd(k, null);
                }
            } else {
                b = hd(c, Tc);
                var n = hd(d, Uc);
                if (0 === g) 0 !== h && nd(n, d, 0, h - 1, f, null);
                else if (0 === h) 0 !== g && (k = null == f.__lexicalLineBreak, id(b, 0, g - 1, k ? null : f), k && (f.textContent = ""));
                else {
                    var p = b;
                    b = n;
                    n = g - 1;
                    g = h - 1;
                    let r = f.firstChild, w = 0;
                    for(h = 0; w <= n && h <= g;){
                        var l = p[w];
                        let y = b[h];
                        if (l === y) r = td(sd(y, f)), w++, h++;
                        else {
                            void 0 === k && (k = new Set(p));
                            void 0 === m && (m = new Set(b));
                            let z = m.has(l), A = k.has(y);
                            z ? (A ? (l = uc(O, y), l === r ? r = td(sd(y, f)) : (null != r ? f.insertBefore(l, r) : f.appendChild(l), sd(y, f)), w++) : md(y, f, r), h++) : (r = td(gd(l)), fd(l, f), w++);
                        }
                    }
                    k = w > n;
                    m = h > g;
                    k && !m ? (k = b[g + 1], k = void 0 === k ? null : O.getElementByKey(k), nd(b, d, h, g, f, k)) : m && !k && id(p, w, n, f);
                }
            }
            tc(d) && (M += "\n\n");
            f.__lexicalTextContent = M;
            M = e + M;
            od(d, f);
            N = a;
            L(d) || d.isInline() || pd(c, d, f);
        }
        tc(d) && (M += "\n\n", Kc += "\n\n");
    } else c = d.getTextContent(), x(d) ? (e = d.decorate(O, Lc), null !== e && qd(a, e)) : B(d) && !d.isDirectionless() && (N += c), M += c, Kc += c;
    !Oc && L(d) && d.__cachedText !== Kc && (d.getWritable().__cachedText = Kc);
    return f;
}
function qd(a, b) {
    let c = O._pendingDecorators, d = O._decorators;
    if (null === c) {
        if (d[a] === b) return;
        c = fc(O);
    }
    c[a] = b;
}
function td(a) {
    a = a.nextSibling;
    null !== a && a === O._blockCursorElement && (a = a.nextSibling);
    return a;
}
function gd(a) {
    let b = dd.get(a);
    void 0 === b && q(75, a);
    return b;
}
let ud = Object.freeze({}), Bd = [
    [
        "keydown",
        vd
    ],
    [
        "pointerdown",
        wd
    ],
    [
        "compositionstart",
        xd
    ],
    [
        "compositionend",
        yd
    ],
    [
        "input",
        zd
    ],
    [
        "click",
        Ad
    ],
    [
        "cut",
        ud
    ],
    [
        "copy",
        ud
    ],
    [
        "dragstart",
        ud
    ],
    [
        "dragover",
        ud
    ],
    [
        "dragend",
        ud
    ],
    [
        "paste",
        ud
    ],
    [
        "focus",
        ud
    ],
    [
        "blur",
        ud
    ],
    [
        "drop",
        ud
    ]
];
Ya && Bd.push([
    "beforeinput",
    (a, b)=>Cd(a, b)
]);
let Dd = 0, Ed = 0, Fd = 0, Gd = null, Hd = 0, Id = !1, Jd = !1, Kd = !1, Ld = !1, Md = [
    0,
    "",
    0,
    "root",
    0
];
function Nd(a, b, c, d, e) {
    let f = a.anchor, g = a.focus, h = f.getNode();
    var k = F();
    let m = xb(k._window), n = null !== m ? m.anchorNode : null, p = f.key;
    k = k.getElementByKey(p);
    let l = c.length;
    return p !== g.key || !B(h) || (!e && (!Ya || Fd < d + 50) || h.isDirty() && 2 > l || jc(c)) && f.offset !== g.offset && !h.isComposing() || Wb(h) || h.isDirty() && 1 < l || (e || !Ya) && null !== k && !h.isComposing() && n !== Xb(k) || null !== m && null !== b && (!b.collapsed || b.startContainer !== m.anchorNode || b.startOffset !== m.anchorOffset) || h.getFormat() !== a.format || h.getStyle() !== a.style || oc(a, h);
}
function Od(a, b) {
    return null !== a && null !== a.nodeValue && 3 === a.nodeType && 0 !== b && b !== a.nodeValue.length;
}
function Pd(a, b, c) {
    let { anchorNode: d, anchorOffset: e, focusNode: f, focusOffset: g } = a;
    if (Id && (Id = !1, Od(d, e) && Od(f, g))) return;
    v(b, ()=>{
        if (!c) Ab(null);
        else if (Tb(b, d, f)) {
            var h = u();
            if (C(h)) {
                var k = h.anchor, m = k.getNode();
                if (h.isCollapsed()) {
                    "Range" === a.type && a.anchorNode === a.focusNode && (h.dirty = !0);
                    var n = Eb(b).event;
                    n = n ? n.timeStamp : performance.now();
                    let [l, r, w, y, z] = Md;
                    var p = J();
                    p = !1 === b.isComposing() && "" === p.getTextContent();
                    if (n < z + 200 && k.offset === w && k.key === y) h.format = l, h.style = r;
                    else if ("text" === k.type) {
                        if (!B(m)) throw Error("Point.getNode() must return TextNode when type is text");
                        h.format = m.getFormat();
                        h.style = m.getStyle();
                    } else "element" !== k.type || p || (h.format = 0, h.style = "");
                } else {
                    k = 255;
                    m = !1;
                    n = h.getNodes();
                    p = n.length;
                    for(let l = 0; l < p; l++){
                        let r = n[l];
                        if (B(r) && (m = !0, k &= r.getFormat(), 0 === k)) break;
                    }
                    h.format = m ? k : 0;
                }
            }
            R(b, aa, void 0);
        }
    });
}
function Ad(a, b) {
    v(b, ()=>{
        let c = u();
        var d = xb(b._window);
        let e = nc();
        if (d) {
            if (C(c)) {
                let g = c.anchor;
                var f = g.getNode();
                "element" === g.type && 0 === g.offset && c.isCollapsed() && !L(f) && 1 === J().getChildrenSize() && f.getTopLevelElementOrThrow().isEmpty() && null !== e && c.is(e) ? (d.removeAllRanges(), c.dirty = !0) : 3 !== a.detail || c.isCollapsed() || (d = c.focus.getNode(), f !== d && (E(f) ? f.select(0) : f.getParentOrThrow().select(0)));
            } else "touch" === a.pointerType && (f = d.anchorNode, null !== f && (f = f.nodeType, 1 === f || 3 === f)) && (d = Qd(e, d, b, a), Ab(d));
        }
        R(b, ba, a);
    });
}
function wd(a, b) {
    let c = a.target;
    a = a.pointerType;
    c instanceof Node && "touch" !== a && v(b, ()=>{
        x(wb(c)) || (Jd = !0);
    });
}
function Rd(a) {
    if (!a.getTargetRanges) return null;
    a = a.getTargetRanges();
    return 0 === a.length ? null : a[0];
}
function Sd(a, b) {
    return a !== b || E(a) || E(b) || !a.isToken() || !b.isToken();
}
function Cd(a, b) {
    let c = a.inputType, d = Rd(a);
    "deleteCompositionText" === c || Xa && Bb(b) || "insertCompositionText" !== c && v(b, ()=>{
        let e = u();
        if ("deleteContentBackward" === c) {
            if (null === e) {
                var f = nc();
                if (!C(f)) return;
                Ab(f.clone());
            }
            if (C(e)) {
                ab && H(e.anchor.key);
                if (229 === Ed && a.timeStamp < Dd + 30 && b.isComposing() && e.anchor.key === e.focus.key) {
                    H(null);
                    Dd = 0;
                    setTimeout(()=>{
                        v(b, ()=>{
                            H(null);
                        });
                    }, 30);
                    if (C(e)) {
                        f = e.anchor.getNode();
                        f.markDirty();
                        e.format = f.getFormat();
                        if (!B(f)) throw Error("Anchor node must be a TextNode");
                        e.style = f.getStyle();
                    }
                    1 >= e.anchor.getNode().getTextContent().length && (a.preventDefault(), R(b, da, !0));
                } else H(null), a.preventDefault(), R(b, da, !0);
                return;
            }
        }
        if (C(e)) {
            f = a.data;
            null !== Gd && mc(!1, b, Gd);
            e.dirty && null === Gd || !e.isCollapsed() || L(e.anchor.getNode()) || null === d || e.applyDOMRange(d);
            Gd = null;
            var g = e.focus, h = e.anchor.getNode();
            g = g.getNode();
            if ("insertText" === c || "insertTranspose" === c) "\n" === f ? (a.preventDefault(), R(b, ea, !1)) : "\n\n" === f ? (a.preventDefault(), R(b, ja, void 0)) : null == f && a.dataTransfer ? (f = a.dataTransfer.getData("text/plain"), a.preventDefault(), e.insertRawText(f)) : null != f && Nd(e, d, f, a.timeStamp, !0) ? (a.preventDefault(), R(b, ka, f)) : Gd = f, Fd = a.timeStamp;
            else switch(a.preventDefault(), c){
                case "insertFromYank":
                case "insertFromDrop":
                case "insertReplacementText":
                    R(b, ka, a);
                    break;
                case "insertFromComposition":
                    H(null);
                    R(b, ka, a);
                    break;
                case "insertLineBreak":
                    H(null);
                    R(b, ea, !1);
                    break;
                case "insertParagraph":
                    H(null);
                    Kd && !$a ? (Kd = !1, R(b, ea, !1)) : R(b, ja, void 0);
                    break;
                case "insertFromPaste":
                case "insertFromPasteAsQuotation":
                    R(b, la, a);
                    break;
                case "deleteByComposition":
                    Sd(h, g) && R(b, na, a);
                    break;
                case "deleteByDrag":
                case "deleteByCut":
                    R(b, na, a);
                    break;
                case "deleteContent":
                    R(b, da, !1);
                    break;
                case "deleteWordBackward":
                    R(b, oa, !0);
                    break;
                case "deleteWordForward":
                    R(b, oa, !1);
                    break;
                case "deleteHardLineBackward":
                case "deleteSoftLineBackward":
                    R(b, pa, !0);
                    break;
                case "deleteContentForward":
                case "deleteHardLineForward":
                case "deleteSoftLineForward":
                    R(b, pa, !1);
                    break;
                case "formatStrikeThrough":
                    R(b, qa, "strikethrough");
                    break;
                case "formatBold":
                    R(b, qa, "bold");
                    break;
                case "formatItalic":
                    R(b, qa, "italic");
                    break;
                case "formatUnderline":
                    R(b, qa, "underline");
                    break;
                case "historyUndo":
                    R(b, ra, void 0);
                    break;
                case "historyRedo":
                    R(b, sa, void 0);
            }
        }
    });
}
function zd(a, b) {
    a.stopPropagation();
    v(b, ()=>{
        var c = u(), d = a.data, e = Rd(a);
        if (null != d && C(c) && Nd(c, e, d, a.timeStamp, !1)) {
            Ld && (Td(b, d), Ld = !1);
            var f = c.anchor, g = f.getNode();
            e = xb(b._window);
            if (null === e) return;
            let h = f.offset;
            if (f = Ya && !c.isCollapsed() && B(g) && null !== e.anchorNode) g = g.getTextContent().slice(0, h) + d + g.getTextContent().slice(h + c.focus.offset), e = e.anchorNode, f = g === (3 === e.nodeType ? e.nodeValue : null);
            f || R(b, ka, d);
            d = d.length;
            Xa && 1 < d && "insertCompositionText" === a.inputType && !b.isComposing() && (c.anchor.offset -= d);
            Za || $a || cb || !b.isComposing() || (Dd = 0, H(null));
        } else mc(!1, b, null !== d ? d : void 0), Ld && (Td(b, d || void 0), Ld = !1);
        G();
        c = F();
        Cb(c);
    });
    Gd = null;
}
function xd(a, b) {
    v(b, ()=>{
        let c = u();
        if (C(c) && !b.isComposing()) {
            let d = c.anchor, e = c.anchor.getNode();
            H(d.key);
            (a.timeStamp < Dd + 30 || "element" === d.type || !c.isCollapsed() || e.getFormat() !== c.format || B(e) && e.getStyle() !== c.style) && R(b, ka, eb);
        }
    });
}
function Td(a, b) {
    var c = a._compositionKey;
    H(null);
    if (null !== c && null != b) {
        if ("" === b) {
            b = I(c);
            a = Xb(a.getElementByKey(c));
            null !== a && null !== a.nodeValue && B(b) && yb(b, a.nodeValue, null, null, !0);
            return;
        }
        if ("\n" === b[b.length - 1] && (c = u(), C(c))) {
            b = c.focus;
            c.anchor.set(b.key, b.offset, b.type);
            R(a, Ba, null);
            return;
        }
    }
    mc(!0, a, b);
}
function yd(a, b) {
    Xa ? Ld = !0 : v(b, ()=>{
        Td(b, a.data);
    });
}
function vd(a, b) {
    Dd = a.timeStamp;
    Ed = a.keyCode;
    if (!b.isComposing()) {
        var { keyCode: c, shiftKey: d, ctrlKey: e, metaKey: f, altKey: g } = a;
        if (!R(b, ta, a)) {
            if (39 !== c || e || f || g) {
                if (39 !== c || g || d || !e && !f) {
                    if (37 !== c || e || f || g) {
                        if (37 !== c || g || d || !e && !f) {
                            if (38 !== c || e || f) {
                                if (40 !== c || e || f) {
                                    if (13 === c && d) Kd = !0, R(b, Ba, a);
                                    else if (32 === c) R(b, Ca, a);
                                    else if (t && e && 79 === c) a.preventDefault(), Kd = !0, R(b, ea, !0);
                                    else if (13 !== c || d) {
                                        var h = t ? g || f ? !1 : 8 === c || 72 === c && e : e || g || f ? !1 : 8 === c;
                                        h ? 8 === c ? R(b, Fa, a) : (a.preventDefault(), R(b, da, !0)) : 27 === c ? R(b, Ga, a) : (h = t ? d || g || f ? !1 : 46 === c || 68 === c && e : e || g || f ? !1 : 46 === c, h ? 46 === c ? R(b, Ha, a) : (a.preventDefault(), R(b, da, !1)) : 8 === c && (t ? g : e) ? (a.preventDefault(), R(b, oa, !0)) : 46 === c && (t ? g : e) ? (a.preventDefault(), R(b, oa, !1)) : t && f && 8 === c ? (a.preventDefault(), R(b, pa, !0)) : t && f && 46 === c ? (a.preventDefault(), R(b, pa, !1)) : 66 === c && !g && (t ? f : e) ? (a.preventDefault(), R(b, qa, "bold")) : 85 === c && !g && (t ? f : e) ? (a.preventDefault(), R(b, qa, "underline")) : 73 === c && !g && (t ? f : e) ? (a.preventDefault(), R(b, qa, "italic")) : 9 !== c || g || e || f ? 90 === c && !d && (t ? f : e) ? (a.preventDefault(), R(b, ra, void 0)) : (h = t ? 90 === c && f && d : 89 === c && e || 90 === c && e && d, h ? (a.preventDefault(), R(b, sa, void 0)) : Ud(b._editorState._selection) ? (h = d ? !1 : 67 === c ? t ? f : e : !1, h ? (a.preventDefault(), R(b, Oa, a)) : (h = d ? !1 : 88 === c ? t ? f : e : !1, h ? (a.preventDefault(), R(b, Pa, a)) : 65 === c && (t ? f : e) && (a.preventDefault(), R(b, Qa, a)))) : !Xa && 65 === c && (t ? f : e) && (a.preventDefault(), R(b, Qa, a))) : R(b, Ja, a));
                                    } else Kd = !1, R(b, Ba, a);
                                } else R(b, Aa, a);
                            } else R(b, za, a);
                        } else R(b, ya, a);
                    } else R(b, xa, a);
                } else R(b, va, a);
            } else R(b, ua, a);
            (e || d || g || f) && R(b, Ta, a);
        }
    }
}
function Vd(a) {
    let b = a.__lexicalEventHandles;
    void 0 === b && (b = [], a.__lexicalEventHandles = b);
    return b;
}
let Wd = new Map;
function Xd(a) {
    var b = a.target;
    let c = xb(null == b ? null : 9 === b.nodeType ? b.defaultView : b.ownerDocument.defaultView);
    if (null !== c) {
        var d = Ub(c.anchorNode);
        if (null !== d) {
            Jd && (Jd = !1, v(d, ()=>{
                var h = nc(), k = c.anchorNode;
                null !== k && (k = k.nodeType, 1 === k || 3 === k) && (h = Qd(h, c, d, a), Ab(h));
            }));
            b = kc(d);
            b = b[b.length - 1];
            var e = b._key, f = Wd.get(e), g = f || b;
            g !== d && Pd(c, g, !1);
            Pd(c, d, !0);
            d !== b ? Wd.set(e, d) : f && Wd.delete(e);
        }
    }
}
function Yd(a, b) {
    0 === Hd && a.ownerDocument.addEventListener("selectionchange", Xd);
    Hd++;
    a.__lexicalEditor = b;
    let c = Vd(a);
    for(let d = 0; d < Bd.length; d++){
        let [e, f] = Bd[d], g = "function" === typeof f ? (h)=>{
            !0 !== h._lexicalHandled && (h._lexicalHandled = !0, b.isEditable() && f(h, b));
        } : (h)=>{
            if (!0 !== h._lexicalHandled && (h._lexicalHandled = !0, b.isEditable())) switch(e){
                case "cut":
                    return R(b, Pa, h);
                case "copy":
                    return R(b, Oa, h);
                case "paste":
                    return R(b, la, h);
                case "dragstart":
                    return R(b, La, h);
                case "dragover":
                    return R(b, Ma, h);
                case "dragend":
                    return R(b, Na, h);
                case "focus":
                    return R(b, Ra, h);
                case "blur":
                    return R(b, Sa, h);
                case "drop":
                    return R(b, Ka, h);
            }
        };
        a.addEventListener(e, g);
        c.push(()=>{
            a.removeEventListener(e, g);
        });
    }
}
function Zd(a, b, c) {
    G();
    var d = a.__key;
    let e = a.getParent();
    if (null !== e) {
        var f = u();
        if (C(f) && E(a)) {
            var { anchor: g, focus: h } = f;
            var k = g.getNode();
            var m = h.getNode();
            vc(k, a) && g.set(a.__key, 0, "element");
            vc(m, a) && h.set(a.__key, 0, "element");
        }
        k = f;
        m = !1;
        if (C(k) && b) {
            f = k.anchor;
            let n = k.focus;
            f.key === d && ($d(f, a, e, a.getPreviousSibling(), a.getNextSibling()), m = !0);
            n.key === d && ($d(n, a, e, a.getPreviousSibling(), a.getNextSibling()), m = !0);
        } else Ud(k) && b && a.isSelected() && a.selectPrevious();
        C(k) && b && !m ? (d = a.getIndexWithinParent(), bc(a), ae(k, e, d, -1)) : bc(a);
        c || xc(e) || e.canBeEmpty() || !e.isEmpty() || Zd(e, b);
        b && L(e) && e.isEmpty() && e.selectEnd();
    }
}
class be {
    static getType() {
        q(64, this.name);
    }
    static clone() {
        q(65, this.name);
    }
    constructor(a){
        this.__type = this.constructor.getType();
        this.__next = this.__prev = this.__parent = null;
        Zb(this, a);
    }
    getType() {
        return this.__type;
    }
    isInline() {
        throw Error(`LexicalNode: Node ${this.constructor.name} does not implement .isInline().`);
    }
    isAttached() {
        for(var a = this.__key; null !== a;){
            if ("root" === a) return !0;
            a = I(a);
            if (null === a) break;
            a = a.__parent;
        }
        return !1;
    }
    isSelected(a) {
        a = a || u();
        if (null == a) return !1;
        let b = a.getNodes().some((c)=>c.__key === this.__key);
        return B(this) ? b : C(a) && "element" === a.anchor.type && "element" === a.focus.type && a.anchor.key === a.focus.key && a.anchor.offset === a.focus.offset ? !1 : b;
    }
    getKey() {
        return this.__key;
    }
    getIndexWithinParent() {
        var a = this.getParent();
        if (null === a) return -1;
        a = a.getFirstChild();
        let b = 0;
        for(; null !== a;){
            if (this.is(a)) return b;
            b++;
            a = a.getNextSibling();
        }
        return -1;
    }
    getParent() {
        let a = this.getLatest().__parent;
        return null === a ? null : I(a);
    }
    getParentOrThrow() {
        let a = this.getParent();
        null === a && q(66, this.__key);
        return a;
    }
    getTopLevelElement() {
        let a = this;
        for(; null !== a;){
            let b = a.getParent();
            if (xc(b)) {
                if (!E(a)) throw Error("Children of root nodes must be elements");
                return a;
            }
            a = b;
        }
        return null;
    }
    getTopLevelElementOrThrow() {
        let a = this.getTopLevelElement();
        null === a && q(67, this.__key);
        return a;
    }
    getParents() {
        let a = [], b = this.getParent();
        for(; null !== b;)a.push(b), b = b.getParent();
        return a;
    }
    getParentKeys() {
        let a = [], b = this.getParent();
        for(; null !== b;)a.push(b.__key), b = b.getParent();
        return a;
    }
    getPreviousSibling() {
        let a = this.getLatest().__prev;
        return null === a ? null : I(a);
    }
    getPreviousSiblings() {
        let a = [];
        var b = this.getParent();
        if (null === b) return a;
        for(b = b.getFirstChild(); null !== b && !b.is(this);)a.push(b), b = b.getNextSibling();
        return a;
    }
    getNextSibling() {
        let a = this.getLatest().__next;
        return null === a ? null : I(a);
    }
    getNextSiblings() {
        let a = [], b = this.getNextSibling();
        for(; null !== b;)a.push(b), b = b.getNextSibling();
        return a;
    }
    getCommonAncestor(a) {
        let b = this.getParents();
        var c = a.getParents();
        E(this) && b.unshift(this);
        E(a) && c.unshift(a);
        a = b.length;
        var d = c.length;
        if (0 === a || 0 === d || b[a - 1] !== c[d - 1]) return null;
        c = new Set(c);
        for(d = 0; d < a; d++){
            let e = b[d];
            if (c.has(e)) return e;
        }
        return null;
    }
    is(a) {
        return null == a ? !1 : this.__key === a.__key;
    }
    isBefore(a) {
        if (this === a) return !1;
        if (a.isParentOf(this)) return !0;
        if (this.isParentOf(a)) return !1;
        var b = this.getCommonAncestor(a);
        let c = this;
        for(;;){
            var d = c.getParentOrThrow();
            if (d === b) {
                d = c.getIndexWithinParent();
                break;
            }
            c = d;
        }
        for(c = a;;){
            a = c.getParentOrThrow();
            if (a === b) {
                b = c.getIndexWithinParent();
                break;
            }
            c = a;
        }
        return d < b;
    }
    isParentOf(a) {
        let b = this.__key;
        if (b === a.__key) return !1;
        for(; null !== a;){
            if (a.__key === b) return !0;
            a = a.getParent();
        }
        return !1;
    }
    getNodesBetween(a) {
        let b = this.isBefore(a), c = [], d = new Set;
        for(var e = this;;){
            var f = e.__key;
            d.has(f) || (d.add(f), c.push(e));
            if (e === a) break;
            f = E(e) ? b ? e.getFirstChild() : e.getLastChild() : null;
            if (null !== f) e = f;
            else if (f = b ? e.getNextSibling() : e.getPreviousSibling(), null !== f) e = f;
            else {
                e = e.getParentOrThrow();
                d.has(e.__key) || c.push(e);
                if (e === a) break;
                f = e;
                do null === f && q(68), e = b ? f.getNextSibling() : f.getPreviousSibling(), f = f.getParent(), null !== f && (null !== e || d.has(f.__key) || c.push(f));
                while (null === e);
            }
        }
        b || c.reverse();
        return c;
    }
    isDirty() {
        let a = F()._dirtyLeaves;
        return null !== a && a.has(this.__key);
    }
    getLatest() {
        let a = I(this.__key);
        null === a && q(113);
        return a;
    }
    getWritable() {
        G();
        var a = ac(), b = F();
        a = a._nodeMap;
        let c = this.__key, d = this.getLatest(), e = d.__parent;
        b = b._cloneNotNeeded;
        var f = u();
        ce(f) && f.setCachedNodes(null);
        if (b.has(c)) return cc(d), d;
        f = d.constructor.clone(d);
        f.__parent = e;
        f.__next = d.__next;
        f.__prev = d.__prev;
        E(d) && E(f) ? (f.__first = d.__first, f.__last = d.__last, f.__size = d.__size, f.__indent = d.__indent, f.__format = d.__format, f.__dir = d.__dir) : B(d) && B(f) && (f.__format = d.__format, f.__style = d.__style, f.__mode = d.__mode, f.__detail = d.__detail);
        b.add(c);
        f.__key = c;
        cc(f);
        a.set(c, f);
        return f;
    }
    getTextContent() {
        return "";
    }
    getTextContentSize() {
        return this.getTextContent().length;
    }
    createDOM() {
        q(70);
    }
    updateDOM() {
        q(71);
    }
    exportDOM(a) {
        return {
            element: this.createDOM(a._config, a)
        };
    }
    exportJSON() {
        q(72);
    }
    static importJSON() {
        q(18, this.name);
    }
    static transform() {
        return null;
    }
    remove(a) {
        Zd(this, !0, a);
    }
    replace(a, b) {
        G();
        var c = u();
        null !== c && (c = c.clone());
        Ac(this, a);
        let d = this.getLatest(), e = this.__key, f = a.__key, g = a.getWritable();
        a = this.getParentOrThrow().getWritable();
        let h = a.__size;
        bc(g);
        let k = d.getPreviousSibling(), m = d.getNextSibling(), n = d.__prev, p = d.__next, l = d.__parent;
        Zd(d, !1, !0);
        null === k ? a.__first = f : k.getWritable().__next = f;
        g.__prev = n;
        null === m ? a.__last = f : m.getWritable().__prev = f;
        g.__next = p;
        g.__parent = l;
        a.__size = h;
        if (b) {
            if (!E(this) || !E(g)) throw Error("includeChildren should only be true for ElementNodes");
            this.getChildren().forEach((r)=>{
                g.append(r);
            });
        }
        C(c) && (Ab(c), b = c.anchor, c = c.focus, b.key === e && de(b, g), c.key === e && de(c, g));
        dc() === e && H(f);
        return g;
    }
    insertAfter(a, b = !0) {
        G();
        Ac(this, a);
        var c = this.getWritable();
        let d = a.getWritable();
        var e = d.getParent();
        let f = u();
        var g = !1, h = !1;
        if (null !== e) {
            var k = a.getIndexWithinParent();
            bc(d);
            C(f) && (h = e.__key, g = f.anchor, e = f.focus, g = "element" === g.type && g.key === h && g.offset === k + 1, h = "element" === e.type && e.key === h && e.offset === k + 1);
        }
        e = this.getNextSibling();
        k = this.getParentOrThrow().getWritable();
        let m = d.__key, n = c.__next;
        null === e ? k.__last = m : e.getWritable().__prev = m;
        k.__size++;
        c.__next = m;
        d.__next = n;
        d.__prev = c.__key;
        d.__parent = c.__parent;
        b && C(f) && (b = this.getIndexWithinParent(), ae(f, k, b + 1), c = k.__key, g && f.anchor.set(c, b + 2, "element"), h && f.focus.set(c, b + 2, "element"));
        return a;
    }
    insertBefore(a, b = !0) {
        G();
        Ac(this, a);
        var c = this.getWritable();
        let d = a.getWritable(), e = d.__key;
        bc(d);
        let f = this.getPreviousSibling(), g = this.getParentOrThrow().getWritable(), h = c.__prev, k = this.getIndexWithinParent();
        null === f ? g.__first = e : f.getWritable().__next = e;
        g.__size++;
        c.__prev = e;
        d.__prev = h;
        d.__next = c.__key;
        d.__parent = c.__parent;
        c = u();
        b && C(c) && (b = this.getParentOrThrow(), ae(c, b, k));
        return a;
    }
    isParentRequired() {
        return !1;
    }
    createParentElementNode() {
        return ee();
    }
    selectStart() {
        return this.selectPrevious();
    }
    selectEnd() {
        return this.selectNext(0, 0);
    }
    selectPrevious(a, b) {
        G();
        let c = this.getPreviousSibling(), d = this.getParentOrThrow();
        return null === c ? d.select(0, 0) : E(c) ? c.select() : B(c) ? c.select(a, b) : (a = c.getIndexWithinParent() + 1, d.select(a, a));
    }
    selectNext(a, b) {
        G();
        let c = this.getNextSibling(), d = this.getParentOrThrow();
        return null === c ? d.select() : E(c) ? c.select(0, 0) : B(c) ? c.select(a, b) : (a = c.getIndexWithinParent(), d.select(a, a));
    }
    markDirty() {
        this.getWritable();
    }
}
function fe(a, b, c) {
    c = c || b.getParentOrThrow().getLastChild();
    let d = b;
    for(b = [
        b
    ]; d !== c;){
        if (!d.getNextSibling()) throw Error("insertRangeAfter: lastToInsert must be a later sibling of firstToInsert");
        d = d.getNextSibling();
        b.push(d);
    }
    for (let e of b)a = a.insertAfter(e);
}
class ge extends be {
    static getType() {
        return "linebreak";
    }
    static clone(a) {
        return new ge(a.__key);
    }
    constructor(a){
        super(a);
    }
    getTextContent() {
        return "\n";
    }
    createDOM() {
        return document.createElement("br");
    }
    updateDOM() {
        return !1;
    }
    static importDOM() {
        return {
            br: (a)=>{
                let b = a.parentElement, c, d;
                return null !== b && ((c = b.firstChild) === a || c.nextSibling === a && 3 === c.nodeType && null !== (c.textContent || "").match(/^( |\t|\r?\n)+$/)) && ((d = b.lastChild) === a || d.previousSibling === a && 3 === d.nodeType && null !== (d.textContent || "").match(/^( |\t|\r?\n)+$/)) ? null : {
                    conversion: he,
                    priority: 0
                };
            }
        };
    }
    static importJSON() {
        return ie();
    }
    exportJSON() {
        return {
            type: "linebreak",
            version: 1
        };
    }
}
function he() {
    return {
        node: ie()
    };
}
function ie() {
    return zc(new ge);
}
function Gc(a) {
    return a instanceof ge;
}
function je(a, b) {
    return b & 16 ? "code" : b & 128 ? "mark" : b & 32 ? "sub" : b & 64 ? "sup" : null;
}
function ke(a, b) {
    return b & 1 ? "strong" : b & 2 ? "em" : "span";
}
function le(a, b, c, d, e) {
    a = d.classList;
    d = pc(e, "base");
    void 0 !== d && a.add(...d);
    d = pc(e, "underlineStrikethrough");
    let f = !1, g = b & 8 && b & 4;
    var h = c & 8 && c & 4;
    void 0 !== d && (h ? (f = !0, g || a.add(...d)) : g && a.remove(...d));
    for(let k in hb)h = hb[k], d = pc(e, k), void 0 !== d && (c & h ? !f || "underline" !== k && "strikethrough" !== k ? (0 === (b & h) || g && "underline" === k || "strikethrough" === k) && a.add(...d) : b & h && a.remove(...d) : b & h && a.remove(...d));
}
function me(a, b, c) {
    let d = b.firstChild;
    c = c.isComposing();
    a += c ? db : "";
    if (null == d) b.textContent = a;
    else if (b = d.nodeValue, b !== a) {
        if (c || Xa) {
            c = b.length;
            let e = a.length, f = 0, g = 0;
            for(; f < c && f < e && b[f] === a[f];)f++;
            for(; g + f < c && g + f < e && b[c - g - 1] === a[e - g - 1];)g++;
            a = [
                f,
                c - f - g,
                a.slice(f, e - g)
            ];
            let [h, k, m] = a;
            0 !== k && d.deleteData(h, k);
            d.insertData(h, m);
        } else d.nodeValue = a;
    }
}
function ne(a, b) {
    b = document.createElement(b);
    b.appendChild(a);
    return b;
}
class oe extends be {
    static getType() {
        return "text";
    }
    static clone(a) {
        return new oe(a.__text, a.__key);
    }
    constructor(a, b){
        super(b);
        this.__text = a;
        this.__format = 0;
        this.__style = "";
        this.__detail = this.__mode = 0;
    }
    getFormat() {
        return this.getLatest().__format;
    }
    getDetail() {
        return this.getLatest().__detail;
    }
    getMode() {
        let a = this.getLatest();
        return pb[a.__mode];
    }
    getStyle() {
        return this.getLatest().__style;
    }
    isToken() {
        return 1 === this.getLatest().__mode;
    }
    isComposing() {
        return this.__key === dc();
    }
    isSegmented() {
        return 2 === this.getLatest().__mode;
    }
    isDirectionless() {
        return 0 !== (this.getLatest().__detail & 1);
    }
    isUnmergeable() {
        return 0 !== (this.getLatest().__detail & 2);
    }
    hasFormat(a) {
        a = hb[a];
        return 0 !== (this.getFormat() & a);
    }
    isSimpleText() {
        return "text" === this.__type && 0 === this.__mode;
    }
    getTextContent() {
        return this.getLatest().__text;
    }
    getFormatFlags(a, b) {
        let c = this.getLatest().__format;
        return Yb(c, a, b);
    }
    createDOM(a) {
        var b = this.__format, c = je(this, b);
        let d = ke(this, b), e = document.createElement(null === c ? d : c), f = e;
        this.hasFormat("code") && e.setAttribute("spellcheck", "false");
        null !== c && (f = document.createElement(d), e.appendChild(f));
        c = f;
        me(this.__text, c, this);
        a = a.theme.text;
        void 0 !== a && le(d, 0, b, c, a);
        b = this.__style;
        "" !== b && (e.style.cssText = b);
        return e;
    }
    updateDOM(a, b, c) {
        let d = this.__text;
        var e = a.__format, f = this.__format, g = je(this, e);
        let h = je(this, f);
        var k = ke(this, e);
        let m = ke(this, f);
        if ((null === g ? k : g) !== (null === h ? m : h)) return !0;
        if (g === h && k !== m) return e = b.firstChild, null == e && q(48), a = g = document.createElement(m), me(d, a, this), c = c.theme.text, void 0 !== c && le(m, 0, f, a, c), b.replaceChild(g, e), !1;
        k = b;
        null !== h && null !== g && (k = b.firstChild, null == k && q(49));
        me(d, k, this);
        c = c.theme.text;
        void 0 !== c && e !== f && le(m, e, f, k, c);
        f = this.__style;
        a.__style !== f && (b.style.cssText = f);
        return !1;
    }
    static importDOM() {
        return {
            "#text": ()=>({
                    conversion: pe,
                    priority: 0
                }),
            b: ()=>({
                    conversion: qe,
                    priority: 0
                }),
            code: ()=>({
                    conversion: re,
                    priority: 0
                }),
            em: ()=>({
                    conversion: re,
                    priority: 0
                }),
            i: ()=>({
                    conversion: re,
                    priority: 0
                }),
            s: ()=>({
                    conversion: re,
                    priority: 0
                }),
            span: ()=>({
                    conversion: se,
                    priority: 0
                }),
            strong: ()=>({
                    conversion: re,
                    priority: 0
                }),
            sub: ()=>({
                    conversion: re,
                    priority: 0
                }),
            sup: ()=>({
                    conversion: re,
                    priority: 0
                }),
            u: ()=>({
                    conversion: re,
                    priority: 0
                })
        };
    }
    static importJSON(a) {
        let b = K(a.text);
        b.setFormat(a.format);
        b.setDetail(a.detail);
        b.setMode(a.mode);
        b.setStyle(a.style);
        return b;
    }
    exportDOM(a) {
        ({ element: a } = super.exportDOM(a));
        null !== a && Ec(a) || q(132);
        a.style.whiteSpace = "pre-wrap";
        this.hasFormat("bold") && (a = ne(a, "b"));
        this.hasFormat("italic") && (a = ne(a, "i"));
        this.hasFormat("strikethrough") && (a = ne(a, "s"));
        this.hasFormat("underline") && (a = ne(a, "u"));
        return {
            element: a
        };
    }
    exportJSON() {
        return {
            detail: this.getDetail(),
            format: this.getFormat(),
            mode: this.getMode(),
            style: this.getStyle(),
            text: this.getTextContent(),
            type: "text",
            version: 1
        };
    }
    selectionTransform() {}
    setFormat(a) {
        let b = this.getWritable();
        b.__format = "string" === typeof a ? hb[a] : a;
        return b;
    }
    setDetail(a) {
        let b = this.getWritable();
        b.__detail = "string" === typeof a ? ib[a] : a;
        return b;
    }
    setStyle(a) {
        let b = this.getWritable();
        b.__style = a;
        return b;
    }
    toggleFormat(a) {
        let b = this.getFormat();
        a = Yb(b, a, null);
        return this.setFormat(a);
    }
    toggleDirectionless() {
        let a = this.getWritable();
        a.__detail ^= 1;
        return a;
    }
    toggleUnmergeable() {
        let a = this.getWritable();
        a.__detail ^= 2;
        return a;
    }
    setMode(a) {
        a = ob[a];
        if (this.__mode === a) return this;
        let b = this.getWritable();
        b.__mode = a;
        return b;
    }
    setTextContent(a) {
        if (this.__text === a) return this;
        let b = this.getWritable();
        b.__text = a;
        return b;
    }
    select(a, b) {
        G();
        let c = u();
        var d = this.getTextContent();
        let e = this.__key;
        "string" === typeof d ? (d = d.length, void 0 === a && (a = d), void 0 === b && (b = d)) : b = a = 0;
        if (C(c)) d = dc(), d !== c.anchor.key && d !== c.focus.key || H(e), c.setTextNodeRange(this, a, this, b);
        else return te(e, a, e, b, "text", "text");
        return c;
    }
    selectStart() {
        return this.select(0, 0);
    }
    selectEnd() {
        let a = this.getTextContentSize();
        return this.select(a, a);
    }
    spliceText(a, b, c, d) {
        let e = this.getWritable(), f = e.__text, g = c.length, h = a;
        0 > h && (h = g + h, 0 > h && (h = 0));
        let k = u();
        d && C(k) && (a += g, k.setTextNodeRange(e, a, e, a));
        b = f.slice(0, h) + c + f.slice(h + b);
        e.__text = b;
        return e;
    }
    canInsertTextBefore() {
        return !0;
    }
    canInsertTextAfter() {
        return !0;
    }
    splitText(...a) {
        G();
        var b = this.getLatest(), c = b.getTextContent(), d = b.__key, e = dc(), f = new Set(a);
        a = [];
        var g = c.length, h = "";
        for(var k = 0; k < g; k++)"" !== h && f.has(k) && (a.push(h), h = ""), h += c[k];
        "" !== h && a.push(h);
        f = a.length;
        if (0 === f) return [];
        if (a[0] === c) return [
            b
        ];
        var m = a[0];
        c = b.getParentOrThrow();
        k = b.getFormat();
        let n = b.getStyle(), p = b.__detail;
        g = !1;
        b.isSegmented() ? (h = K(m), h.__format = k, h.__style = n, h.__detail = p, g = !0) : (h = b.getWritable(), h.__text = m);
        b = u();
        h = [
            h
        ];
        m = m.length;
        for(let w = 1; w < f; w++){
            var l = a[w], r = l.length;
            l = K(l).getWritable();
            l.__format = k;
            l.__style = n;
            l.__detail = p;
            let y = l.__key;
            r = m + r;
            if (C(b)) {
                let z = b.anchor, A = b.focus;
                z.key === d && "text" === z.type && z.offset > m && z.offset <= r && (z.key = y, z.offset -= m, b.dirty = !0);
                A.key === d && "text" === A.type && A.offset > m && A.offset <= r && (A.key = y, A.offset -= m, b.dirty = !0);
            }
            e === d && H(y);
            m = r;
            h.push(l);
        }
        d = this.getPreviousSibling();
        e = this.getNextSibling();
        null !== d && cc(d);
        null !== e && cc(e);
        d = c.getWritable();
        e = this.getIndexWithinParent();
        g ? (d.splice(e, 0, h), this.remove()) : d.splice(e, 1, h);
        C(b) && ae(b, c, e, f - 1);
        return h;
    }
    mergeWithSibling(a) {
        var b = a === this.getPreviousSibling();
        b || a === this.getNextSibling() || q(50);
        var c = this.__key;
        let d = a.__key, e = this.__text, f = e.length;
        dc() === d && H(c);
        let g = u();
        if (C(g)) {
            let h = g.anchor, k = g.focus;
            null !== h && h.key === d && (ue(h, b, c, a, f), g.dirty = !0);
            null !== k && k.key === d && (ue(k, b, c, a, f), g.dirty = !0);
        }
        c = a.__text;
        this.setTextContent(b ? c + e : e + c);
        b = this.getWritable();
        a.remove();
        return b;
    }
    isTextEntity() {
        return !1;
    }
}
function se(a) {
    let b = "700" === a.style.fontWeight, c = "line-through" === a.style.textDecoration, d = "italic" === a.style.fontStyle, e = "underline" === a.style.textDecoration, f = a.style.verticalAlign;
    return {
        forChild: (g)=>{
            if (!B(g)) return g;
            b && g.toggleFormat("bold");
            c && g.toggleFormat("strikethrough");
            d && g.toggleFormat("italic");
            e && g.toggleFormat("underline");
            "sub" === f && g.toggleFormat("subscript");
            "super" === f && g.toggleFormat("superscript");
            return g;
        },
        node: null
    };
}
function qe(a) {
    let b = "normal" === a.style.fontWeight;
    return {
        forChild: (c)=>{
            B(c) && !b && c.toggleFormat("bold");
            return c;
        },
        node: null
    };
}
let ve = new WeakMap;
function pe(a) {
    null === a.parentElement && q(129);
    for(var b = a.textContent || "", c, d = a.parentNode, e = [
        a
    ]; null !== d && void 0 === (c = ve.get(d)) && !("PRE" === d.nodeName || 1 === d.nodeType && void 0 !== d.style && void 0 !== d.style.whiteSpace && d.style.whiteSpace.startsWith("pre"));)e.push(d), d = d.parentNode;
    c = void 0 === c ? d : c;
    for(d = 0; d < e.length; d++)ve.set(e[d], c);
    if (null !== c) {
        b = b.split(/(\r?\n|\t)/);
        a = [];
        e = b.length;
        for(c = 0; c < e; c++)d = b[c], "\n" === d || "\r\n" === d ? a.push(ie()) : "	" === d ? a.push(we()) : "" !== d && a.push(K(d));
        return {
            node: a
        };
    }
    b = b.replace(/\r/g, "").replace(/[ \t\n]+/g, " ");
    if ("" === b) return {
        node: null
    };
    if (" " === b[0]) {
        e = a;
        for(c = !0; null !== e && null !== (e = xe(e, !1));)if (d = e.textContent || "", 0 < d.length) {
            /[ \t\n]$/.test(d) && (b = b.slice(1));
            c = !1;
            break;
        }
        c && (b = b.slice(1));
    }
    if (" " === b[b.length - 1]) {
        for(e = !0; null !== a && null !== (a = xe(a, !0));)if (0 < (a.textContent || "").replace(/^( |\t|\r?\n)+/, "").length) {
            e = !1;
            break;
        }
        e && (b = b.slice(0, b.length - 1));
    }
    return "" === b ? {
        node: null
    } : {
        node: K(b)
    };
}
let ye = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/, "i");
function xe(a, b) {
    for(;;){
        for(var c = void 0; null === (c = b ? a.nextSibling : a.previousSibling);)if (a = a.parentElement, null === a) return null;
        a = c;
        if (1 === a.nodeType && (c = a.style.display, "" === c && null === a.nodeName.match(ye) || "" !== c && !c.startsWith("inline"))) return null;
        for(; null !== (c = b ? a.firstChild : a.lastChild);)a = c;
        if (3 === a.nodeType) return a;
        if ("BR" === a.nodeName) return null;
    }
}
let ze = {
    code: "code",
    em: "italic",
    i: "italic",
    s: "strikethrough",
    strong: "bold",
    sub: "subscript",
    sup: "superscript",
    u: "underline"
};
function re(a) {
    let b = ze[a.nodeName.toLowerCase()];
    return void 0 === b ? {
        node: null
    } : {
        forChild: (c)=>{
            B(c) && !c.hasFormat(b) && c.toggleFormat(b);
            return c;
        },
        node: null
    };
}
function K(a = "") {
    return zc(new oe(a));
}
function B(a) {
    return a instanceof oe;
}
class Ae extends oe {
    static getType() {
        return "tab";
    }
    static clone(a) {
        let b = new Ae(a.__key);
        b.__text = a.__text;
        b.__format = a.__format;
        b.__style = a.__style;
        return b;
    }
    constructor(a){
        super("	", a);
        this.__detail = 2;
    }
    static importDOM() {
        return null;
    }
    static importJSON(a) {
        let b = we();
        b.setFormat(a.format);
        b.setStyle(a.style);
        return b;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "tab",
            version: 1
        };
    }
    setTextContent() {
        q(126);
    }
    setDetail() {
        q(127);
    }
    setMode() {
        q(128);
    }
    canInsertTextBefore() {
        return !1;
    }
    canInsertTextAfter() {
        return !1;
    }
}
function we() {
    return zc(new Ae);
}
function Be(a) {
    return a instanceof Ae;
}
class Ce {
    constructor(a, b, c){
        this._selection = null;
        this.key = a;
        this.offset = b;
        this.type = c;
    }
    is(a) {
        return this.key === a.key && this.offset === a.offset && this.type === a.type;
    }
    isBefore(a) {
        let b = this.getNode(), c = a.getNode(), d = this.offset;
        a = a.offset;
        if (E(b)) {
            var e = b.getDescendantByIndex(d);
            b = null != e ? e : b;
        }
        E(c) && (e = c.getDescendantByIndex(a), c = null != e ? e : c);
        return b === c ? d < a : b.isBefore(c);
    }
    getNode() {
        let a = I(this.key);
        null === a && q(20);
        return a;
    }
    set(a, b, c) {
        let d = this._selection, e = this.key;
        this.key = a;
        this.offset = b;
        this.type = c;
        ec() || (dc() === e && H(a), null !== d && (d.setCachedNodes(null), d.dirty = !0));
    }
}
function S(a, b, c) {
    return new Ce(a, b, c);
}
function Me(a, b) {
    let c = b.__key, d = a.offset, e = "element";
    if (B(b)) e = "text", b = b.getTextContentSize(), d > b && (d = b);
    else if (!E(b)) {
        var f = b.getNextSibling();
        if (B(f)) c = f.__key, d = 0, e = "text";
        else if (f = b.getParent()) c = f.__key, d = b.getIndexWithinParent() + 1;
    }
    a.set(c, d, e);
}
function de(a, b) {
    if (E(b)) {
        let c = b.getLastDescendant();
        E(c) || B(c) ? Me(a, c) : Me(a, b);
    } else Me(a, b);
}
function Ne(a, b, c, d) {
    let e = a.getNode(), f = e.getChildAtIndex(a.offset), g = K(), h = L(e) ? ee().append(g) : g;
    g.setFormat(c);
    g.setStyle(d);
    null === f ? e.append(h) : f.insertBefore(h);
    a.is(b) && b.set(g.__key, 0, "text");
    a.set(g.__key, 0, "text");
}
function Oe(a, b, c, d) {
    a.key = b;
    a.offset = c;
    a.type = d;
}
class Pe {
    constructor(a, b){
        this.anchor = a;
        this.focus = b;
        a._selection = this;
        b._selection = this;
        this._cachedNodes = null;
        this.dirty = !1;
    }
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(a) {
        this._cachedNodes = a;
    }
    is(a) {
        return ce(a) ? this.anchor.is(a.anchor) && this.focus.is(a.focus) : !1;
    }
    isCollapsed() {
        return !1;
    }
    extract() {
        return this.getNodes();
    }
    isBackward() {
        return this.focus.isBefore(this.anchor);
    }
    getCharacterOffsets() {
        return Qe(this);
    }
}
class Re {
    constructor(a){
        this.dirty = !1;
        this._nodes = a;
        this._cachedNodes = null;
    }
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(a) {
        this._cachedNodes = a;
    }
    is(a) {
        if (!Ud(a)) return !1;
        let b = this._nodes, c = a._nodes;
        return b.size === c.size && Array.from(b).every((d)=>c.has(d));
    }
    add(a) {
        this.dirty = !0;
        this._nodes.add(a);
        this._cachedNodes = null;
    }
    delete(a) {
        this.dirty = !0;
        this._nodes.delete(a);
        this._cachedNodes = null;
    }
    clear() {
        this.dirty = !0;
        this._nodes.clear();
        this._cachedNodes = null;
    }
    has(a) {
        return this._nodes.has(a);
    }
    clone() {
        return new Re(new Set(this._nodes));
    }
    extract() {
        return this.getNodes();
    }
    insertRawText() {}
    insertText() {}
    insertNodes(a) {
        let b = this.getNodes(), c = b.length;
        var d = b[c - 1];
        if (B(d)) d = d.select();
        else {
            let e = d.getIndexWithinParent() + 1;
            d = d.getParentOrThrow().select(e, e);
        }
        d.insertNodes(a);
        for(a = 0; a < c; a++)b[a].remove();
    }
    getNodes() {
        var a = this._cachedNodes;
        if (null !== a) return a;
        var b = this._nodes;
        a = [];
        for (let c of b)b = I(c), null !== b && a.push(b);
        ec() || (this._cachedNodes = a);
        return a;
    }
    getTextContent() {
        let a = this.getNodes(), b = "";
        for(let c = 0; c < a.length; c++)b += a[c].getTextContent();
        return b;
    }
}
function C(a) {
    return a instanceof Se;
}
function ce(a) {
    return a instanceof Pe;
}
class Se extends Pe {
    constructor(a, b, c, d){
        super(a, b);
        this.format = c;
        this.style = d;
    }
    is(a) {
        return C(a) ? this.anchor.is(a.anchor) && this.focus.is(a.focus) && this.format === a.format && this.style === a.style : !1;
    }
    isCollapsed() {
        return this.anchor.is(this.focus);
    }
    getNodes() {
        var a = this._cachedNodes;
        if (null !== a) return a;
        a = this.anchor;
        var b = this.focus, c = a.isBefore(b), d = c ? a : b;
        c = c ? b : a;
        a = d.getNode();
        b = c.getNode();
        let e = d.offset;
        d = c.offset;
        E(a) && (c = a.getDescendantByIndex(e), a = null != c ? c : a);
        E(b) && (c = b.getDescendantByIndex(d), null !== c && c !== a && b.getChildAtIndex(d) === c && (c = c.getPreviousSibling()), b = null != c ? c : b);
        a = a.is(b) ? E(a) && 0 < a.getChildrenSize() ? [] : [
            a
        ] : a.getNodesBetween(b);
        ec() || (this._cachedNodes = a);
        return a;
    }
    setTextNodeRange(a, b, c, d) {
        Oe(this.anchor, a.__key, b, "text");
        Oe(this.focus, c.__key, d, "text");
        this._cachedNodes = null;
        this.dirty = !0;
    }
    getTextContent() {
        let a = this.getNodes();
        if (0 === a.length) return "";
        let b = a[0], c = a[a.length - 1], d = this.anchor, e = this.focus, f = d.isBefore(e), [g, h] = Qe(this), k = "", m = !0;
        for(let n = 0; n < a.length; n++){
            let p = a[n];
            if (E(p) && !p.isInline()) m || (k += "\n"), m = p.isEmpty() ? !1 : !0;
            else if (m = !1, B(p)) {
                let l = p.getTextContent();
                if (p === b) {
                    if (p === c) {
                        if ("element" !== d.type || "element" !== e.type || e.offset === d.offset) l = g < h ? l.slice(g, h) : l.slice(h, g);
                    } else l = f ? l.slice(g) : l.slice(h);
                } else p === c && (l = f ? l.slice(0, h) : l.slice(0, g));
                k += l;
            } else !x(p) && !Gc(p) || p === c && this.isCollapsed() || (k += p.getTextContent());
        }
        return k;
    }
    applyDOMRange(a) {
        let b = F(), c = b.getEditorState()._selection;
        a = Te(a.startContainer, a.startOffset, a.endContainer, a.endOffset, b, c);
        if (null !== a) {
            var [d, e] = a;
            Oe(this.anchor, d.key, d.offset, d.type);
            Oe(this.focus, e.key, e.offset, e.type);
            this._cachedNodes = null;
        }
    }
    clone() {
        let a = this.anchor, b = this.focus;
        return new Se(S(a.key, a.offset, a.type), S(b.key, b.offset, b.type), this.format, this.style);
    }
    toggleFormat(a) {
        this.format = Yb(this.format, a, null);
        this.dirty = !0;
    }
    setStyle(a) {
        this.style = a;
        this.dirty = !0;
    }
    hasFormat(a) {
        return 0 !== (this.format & hb[a]);
    }
    insertRawText(a) {
        a = a.split(/(\r?\n|\t)/);
        let b = [], c = a.length;
        for(let d = 0; d < c; d++){
            let e = a[d];
            "\n" === e || "\r\n" === e ? b.push(ie()) : "	" === e ? b.push(we()) : b.push(K(e));
        }
        this.insertNodes(b);
    }
    insertText(a) {
        var b = this.anchor, c = this.focus, d = this.isCollapsed() || b.isBefore(c), e = this.format, f = this.style;
        d && "element" === b.type ? Ne(b, c, e, f) : d || "element" !== c.type || Ne(c, b, e, f);
        var g = this.getNodes(), h = g.length, k = d ? c : b;
        c = (d ? b : c).offset;
        var m = k.offset;
        b = g[0];
        B(b) || q(26);
        d = b.getTextContent().length;
        var n = b.getParentOrThrow(), p = g[h - 1];
        if (this.isCollapsed() && c === d && (b.isSegmented() || b.isToken() || !b.canInsertTextAfter() || !n.canInsertTextAfter() && null === b.getNextSibling())) {
            var l = b.getNextSibling();
            B(l) && l.canInsertTextBefore() && !Wb(l) || (l = K(), l.setFormat(e), n.canInsertTextAfter() ? b.insertAfter(l) : n.insertAfter(l));
            l.select(0, 0);
            b = l;
            if ("" !== a) {
                this.insertText(a);
                return;
            }
        } else if (this.isCollapsed() && 0 === c && (b.isSegmented() || b.isToken() || !b.canInsertTextBefore() || !n.canInsertTextBefore() && null === b.getPreviousSibling())) {
            l = b.getPreviousSibling();
            if (!B(l) || Wb(l)) l = K(), l.setFormat(e), n.canInsertTextBefore() ? b.insertBefore(l) : n.insertBefore(l);
            l.select();
            b = l;
            if ("" !== a) {
                this.insertText(a);
                return;
            }
        } else if (b.isSegmented() && c !== d) n = K(b.getTextContent()), n.setFormat(e), b.replace(n), b = n;
        else if (!(this.isCollapsed() || "" === a || (l = p.getParent(), n.canInsertTextBefore() && n.canInsertTextAfter() && (!E(l) || l.canInsertTextBefore() && l.canInsertTextAfter())))) {
            this.insertText("");
            Ue(this.anchor, this.focus, null);
            this.insertText(a);
            return;
        }
        if (1 === h) {
            if (b.isToken()) a = K(a), a.select(), b.replace(a);
            else {
                g = b.getFormat();
                h = b.getStyle();
                if (c === m && (g !== e || h !== f)) {
                    if ("" === b.getTextContent()) b.setFormat(e), b.setStyle(f);
                    else {
                        g = K(a);
                        g.setFormat(e);
                        g.setStyle(f);
                        g.select();
                        0 === c ? b.insertBefore(g, !1) : ([h] = b.splitText(c), h.insertAfter(g, !1));
                        g.isComposing() && "text" === this.anchor.type && (this.anchor.offset -= a.length);
                        return;
                    }
                } else if (Be(b)) {
                    a = K(a);
                    a.setFormat(e);
                    a.setStyle(f);
                    a.select();
                    b.replace(a);
                    return;
                }
                b = b.spliceText(c, m - c, a, !0);
                "" === b.getTextContent() ? b.remove() : "text" === this.anchor.type && (b.isComposing() ? this.anchor.offset -= a.length : (this.format = g, this.style = h));
            }
        } else {
            e = new Set([
                ...b.getParentKeys(),
                ...p.getParentKeys()
            ]);
            l = E(b) ? b : b.getParentOrThrow();
            f = E(p) ? p : p.getParentOrThrow();
            n = p;
            if (!l.is(f) && f.isInline()) do n = f, f = f.getParentOrThrow();
            while (f.isInline());
            if ("text" === k.type && (0 !== m || "" === p.getTextContent()) || "element" === k.type && p.getIndexWithinParent() < m) {
                if (B(p) && !p.isToken() && m !== p.getTextContentSize()) {
                    if (p.isSegmented()) {
                        var r = K(p.getTextContent());
                        p.replace(r);
                        p = r;
                    }
                    L(k.getNode()) || "text" !== k.type || (p = p.spliceText(0, m, ""));
                    e.add(p.__key);
                } else k = p.getParentOrThrow(), k.canBeEmpty() || 1 !== k.getChildrenSize() ? p.remove() : k.remove();
            } else e.add(p.__key);
            k = f.getChildren();
            m = new Set(g);
            p = l.is(f);
            l = l.isInline() && null === b.getNextSibling() ? l : b;
            for(r = k.length - 1; 0 <= r; r--){
                let w = k[r];
                if (w.is(b) || E(w) && w.isParentOf(b)) break;
                w.isAttached() && (!m.has(w) || w.is(n) ? p || l.insertAfter(w, !1) : w.remove());
            }
            if (!p) for(k = f, f = null; null !== k;){
                m = k.getChildren();
                p = m.length;
                if (0 === p || m[p - 1].is(f)) e.delete(k.__key), f = k;
                k = k.getParent();
            }
            b.isToken() ? c === d ? b.select() : (a = K(a), a.select(), b.replace(a)) : (b = b.spliceText(c, d - c, a, !0), "" === b.getTextContent() ? b.remove() : b.isComposing() && "text" === this.anchor.type && (this.anchor.offset -= a.length));
            for(a = 1; a < h; a++)b = g[a], e.has(b.__key) || b.remove();
        }
    }
    removeText() {
        this.insertText("");
    }
    formatText(a) {
        if (this.isCollapsed()) this.toggleFormat(a), H(null);
        else {
            var b = this.getNodes(), c = [];
            for (var d of b)B(d) && c.push(d);
            var e = c.length;
            if (0 === e) this.toggleFormat(a), H(null);
            else {
                d = this.anchor;
                var f = this.focus, g = this.isBackward();
                b = g ? f : d;
                d = g ? d : f;
                var h = 0, k = c[0];
                f = "element" === b.type ? 0 : b.offset;
                "text" === b.type && f === k.getTextContentSize() && (h = 1, k = c[1], f = 0);
                if (null != k) {
                    g = k.getFormatFlags(a, null);
                    var m = e - 1, n = c[m];
                    e = "text" === d.type ? d.offset : n.getTextContentSize();
                    if (k.is(n)) f !== e && (0 === f && e === k.getTextContentSize() ? k.setFormat(g) : (a = k.splitText(f, e), a = 0 === f ? a[0] : a[1], a.setFormat(g), "text" === b.type && b.set(a.__key, 0, "text"), "text" === d.type && d.set(a.__key, e - f, "text")), this.format = g);
                    else {
                        0 !== f && ([, k] = k.splitText(f), f = 0);
                        k.setFormat(g);
                        var p = n.getFormatFlags(a, g);
                        0 < e && (e !== n.getTextContentSize() && ([n] = n.splitText(e)), n.setFormat(p));
                        for(h += 1; h < m; h++){
                            let l = c[h];
                            if (!l.isToken()) {
                                let r = l.getFormatFlags(a, p);
                                l.setFormat(r);
                            }
                        }
                        "text" === b.type && b.set(k.__key, f, "text");
                        "text" === d.type && d.set(n.__key, e, "text");
                        this.format = g | p;
                    }
                }
            }
        }
    }
    insertNodes(a) {
        if (0 !== a.length) {
            if ("root" === this.anchor.key) {
                this.insertParagraph();
                var b = u();
                if (!C(b)) throw Error("Expected RangeSelection after insertParagraph");
                return b.insertNodes(a);
            }
            var c = Hc(this.anchor.getNode(), Fc);
            b = a[a.length - 1];
            if ("__language" in c && E(c)) {
                if ("__language" in a[0]) this.insertText(a[0].getTextContent());
                else {
                    var d = Ve(this);
                    c.splice(d, 0, a);
                    b.selectEnd();
                }
            } else if (a.some((g)=>(E(g) || x(g)) && !g.isInline())) {
                b = We(a);
                a = b.getLastDescendant();
                var e = b.getChildren();
                b = E(c) && c.isEmpty() ? null : this.insertParagraph();
                d = e[e.length - 1];
                var f = e[0];
                if (((g)=>E(g) && Fc(g) && !g.isEmpty() && E(c) && (!c.isEmpty() || "__value" in c && "__checked" in c))(f)) {
                    if (!E(c)) throw Error("Expected 'firstBlock' to be an ElementNode");
                    c.append(...f.getChildren());
                    f = e[1];
                }
                f && fe(c, f);
                e = Hc(a, Fc);
                b && E(e) && ("__value" in b && "__checked" in b || Fc(d)) && (e.append(...b.getChildren()), b.remove());
                E(c) && c.isEmpty() && c.remove();
                a.selectEnd();
                a = E(c) ? c.getLastChild() : null;
                Gc(a) && e !== c && a.remove();
            } else {
                if (!E(c)) throw Error("Expected 'firstBlock' to be an ElementNode");
                d = Ve(this);
                c.splice(d, 0, a);
                b.selectEnd();
            }
        }
    }
    insertParagraph() {
        if ("root" === this.anchor.key) {
            var a = ee();
            J().splice(this.anchor.offset, 0, [
                a
            ]);
            a.select();
            return a;
        }
        var b = Ve(this);
        a = Hc(this.anchor.getNode(), Fc);
        if (!E(a)) throw Error("Expected ancestor to be an ElementNode");
        b = (b = a.getChildAtIndex(b)) ? [
            b,
            ...b.getNextSiblings()
        ] : [];
        return (a = a.insertNewAfter(this, !1)) ? (a.append(...b), a.selectStart(), a) : null;
    }
    insertLineBreak(a) {
        var b = ie();
        this.insertNodes([
            b
        ]);
        a && (a = b.getParentOrThrow(), b = b.getIndexWithinParent(), a.select(b, b));
    }
    extract() {
        var a = this.getNodes(), b = a.length, c = b - 1, d = this.anchor;
        let e = this.focus;
        var f = a[0];
        let g = a[c], [h, k] = Qe(this);
        if (0 === b) return [];
        if (1 === b) return B(f) && !this.isCollapsed() ? (a = h > k ? k : h, c = f.splitText(a, h > k ? h : k), a = 0 === a ? c[0] : c[1], null != a ? [
            a
        ] : []) : [
            f
        ];
        b = d.isBefore(e);
        B(f) && (d = b ? h : k, d === f.getTextContentSize() ? a.shift() : 0 !== d && ([, f] = f.splitText(d), a[0] = f));
        B(g) && (f = g.getTextContent().length, b = b ? k : h, 0 === b ? a.pop() : b !== f && ([g] = g.splitText(b), a[c] = g));
        return a;
    }
    modify(a, b, c) {
        var d = this.focus, e = this.anchor, f = "move" === a, g = sc(d, b);
        if (x(g) && !g.isIsolated()) f && g.isKeyboardSelectable() ? (b = Xe(), b.add(g.__key), Ab(b)) : (a = b ? g.getPreviousSibling() : g.getNextSibling(), B(a) ? (g = a.__key, b = b ? a.getTextContent().length : 0, d.set(g, b, "text"), f && e.set(g, b, "text")) : (c = g.getParentOrThrow(), E(a) ? (c = a.__key, g = b ? a.getChildrenSize() : 0) : (g = g.getIndexWithinParent(), c = c.__key, b || g++), d.set(c, g, "element"), f && e.set(c, g, "element")));
        else if (e = F(), d = xb(e._window)) {
            var h = e._blockCursorElement, k = e._rootElement;
            null === k || null === h || !E(g) || g.isInline() || g.canBeEmpty() || Cc(h, e, k);
            d.modify(a, b ? "backward" : "forward", c);
            if (0 < d.rangeCount && (g = d.getRangeAt(0), e = this.anchor.getNode(), e = L(e) ? e : wc(e), this.applyDOMRange(g), this.dirty = !0, !f)) {
                f = this.getNodes();
                a = [];
                c = !1;
                for(h = 0; h < f.length; h++)k = f[h], vc(k, e) ? a.push(k) : c = !0;
                c && 0 < a.length && (b ? (b = a[0], E(b) ? b.selectStart() : b.getParentOrThrow().selectStart()) : (b = a[a.length - 1], E(b) ? b.selectEnd() : b.getParentOrThrow().selectEnd()));
                if (d.anchorNode !== g.startContainer || d.anchorOffset !== g.startOffset) b = this.focus, f = this.anchor, d = f.key, g = f.offset, e = f.type, Oe(f, b.key, b.offset, b.type), Oe(b, d, g, e), this._cachedNodes = null;
            }
        }
    }
    deleteCharacter(a) {
        let b = this.isCollapsed();
        if (this.isCollapsed()) {
            var c = this.anchor, d = this.focus, e = c.getNode();
            if (!a && ("element" === c.type && E(e) && c.offset === e.getChildrenSize() || "text" === c.type && c.offset === e.getTextContentSize())) {
                var f = e.getParent();
                f = e.getNextSibling() || (null === f ? null : f.getNextSibling());
                if (E(f) && f.isShadowRoot()) return;
            }
            f = sc(d, a);
            if (x(f) && !f.isIsolated()) {
                f.isKeyboardSelectable() && E(e) && 0 === e.getChildrenSize() ? (e.remove(), a = Xe(), a.add(f.__key), Ab(a)) : (f.remove(), F().dispatchCommand(aa, void 0));
                return;
            }
            if (!a && E(f) && E(e) && e.isEmpty()) {
                e.remove();
                f.selectStart();
                return;
            }
            this.modify("extend", a, "character");
            if (!this.isCollapsed()) {
                f = "text" === d.type ? d.getNode() : null;
                e = "text" === c.type ? c.getNode() : null;
                if (null !== f && f.isSegmented()) {
                    if (c = d.offset, d = f.getTextContentSize(), f.is(e) || a && c !== d || !a && 0 !== c) {
                        Ye(f, a, c);
                        return;
                    }
                } else if (null !== e && e.isSegmented() && (c = c.offset, d = e.getTextContentSize(), e.is(f) || a && 0 !== c || !a && c !== d)) {
                    Ye(e, a, c);
                    return;
                }
                e = this.anchor;
                f = this.focus;
                c = e.getNode();
                d = f.getNode();
                if (c === d && "text" === e.type && "text" === f.type) {
                    var g = e.offset, h = f.offset;
                    let k = g < h;
                    d = k ? g : h;
                    h = k ? h : g;
                    g = h - 1;
                    d !== g && (c = c.getTextContent().slice(d, h), jc(c) || (a ? f.offset = g : e.offset = g));
                }
            } else if (a && 0 === c.offset && ("element" === c.type ? c.getNode() : c.getNode().getParentOrThrow()).collapseAtStart(this)) return;
        }
        this.removeText();
        a && !b && this.isCollapsed() && "element" === this.anchor.type && 0 === this.anchor.offset && (a = this.anchor.getNode(), a.isEmpty() && L(a.getParent()) && 0 === a.getIndexWithinParent() && a.collapseAtStart(this));
    }
    deleteLine(a) {
        this.isCollapsed() && ("text" === this.anchor.type && this.modify("extend", a, "lineboundary"), 0 === (a ? this.focus : this.anchor).offset && this.modify("extend", a, "character"));
        this.removeText();
    }
    deleteWord(a) {
        this.isCollapsed() && this.modify("extend", a, "word");
        this.removeText();
    }
}
function Ud(a) {
    return a instanceof Re;
}
function Ze(a) {
    let b = a.offset;
    if ("text" === a.type) return b;
    a = a.getNode();
    return b === a.getChildrenSize() ? a.getTextContent().length : 0;
}
function Qe(a) {
    let b = a.anchor;
    a = a.focus;
    return "element" === b.type && "element" === a.type && b.key === a.key && b.offset === a.offset ? [
        0,
        0
    ] : [
        Ze(b),
        Ze(a)
    ];
}
function Ye(a, b, c) {
    let d = a.getTextContent().split(/(?=\s)/g), e = d.length, f = 0, g = 0;
    for(let h = 0; h < e; h++){
        let k = d[h], m = h === e - 1;
        g = f;
        f += k.length;
        if (b && f === c || f > c || m) {
            d.splice(h, 1);
            m && (g = void 0);
            break;
        }
    }
    b = d.join("").trim();
    "" === b ? a.remove() : (a.setTextContent(b), a.select(g, g));
}
function $e(a, b, c, d) {
    var e = b;
    if (1 === a.nodeType) {
        let h = !1;
        var f = a.childNodes, g = f.length;
        e === g && (h = !0, e = g - 1);
        let k = f[e];
        g = !1;
        k === d._blockCursorElement ? (k = f[e + 1], g = !0) : null !== d._blockCursorElement && e--;
        d = ic(k);
        if (B(d)) e = h ? d.getTextContentSize() : 0;
        else {
            f = ic(a);
            if (null === f) return null;
            if (E(f)) {
                a = f.getChildAtIndex(e);
                if (b = E(a)) b = a.getParent(), b = null === c || null === b || !b.canBeEmpty() || b !== c.getNode();
                b && (c = h ? a.getLastDescendant() : a.getFirstDescendant(), null === c ? (f = a, e = 0) : (a = c, f = E(a) ? a : a.getParentOrThrow()));
                B(a) ? (d = a, f = null, e = h ? a.getTextContentSize() : 0) : a !== f && h && !g && e++;
            } else e = f.getIndexWithinParent(), e = 0 === b && x(f) && ic(a) === f ? e : e + 1, f = f.getParentOrThrow();
            if (E(f)) return S(f.__key, e, "element");
        }
    } else d = ic(a);
    return B(d) ? S(d.__key, e, "text") : null;
}
function af(a, b, c) {
    var d = a.offset, e = a.getNode();
    0 === d ? (d = e.getPreviousSibling(), e = e.getParent(), b) ? (c || !b) && null === d && E(e) && e.isInline() && (b = e.getPreviousSibling(), B(b) && (a.key = b.__key, a.offset = b.getTextContent().length)) : E(d) && !c && d.isInline() ? (a.key = d.__key, a.offset = d.getChildrenSize(), a.type = "element") : B(d) && (a.key = d.__key, a.offset = d.getTextContent().length) : d === e.getTextContent().length && (d = e.getNextSibling(), e = e.getParent(), b && E(d) && d.isInline() ? (a.key = d.__key, a.offset = 0, a.type = "element") : (c || b) && null === d && E(e) && e.isInline() && !e.canInsertTextAfter() && (b = e.getNextSibling(), B(b) && (a.key = b.__key, a.offset = 0)));
}
function Ue(a, b, c) {
    if ("text" === a.type && "text" === b.type) {
        var d = a.isBefore(b);
        let e = a.is(b);
        af(a, d, e);
        af(b, !d, e);
        e && (b.key = a.key, b.offset = a.offset, b.type = a.type);
        d = F();
        d.isComposing() && d._compositionKey !== a.key && C(c) && (d = c.anchor, c = c.focus, Oe(a, d.key, d.offset, d.type), Oe(b, c.key, c.offset, c.type));
    }
}
function Te(a, b, c, d, e, f) {
    if (null === a || null === c || !Tb(e, a, c)) return null;
    b = $e(a, b, C(f) ? f.anchor : null, e);
    if (null === b) return null;
    d = $e(c, d, C(f) ? f.focus : null, e);
    if (null === d || "element" === b.type && "element" === d.type && (a = ic(a), c = ic(c), x(a) && x(c))) return null;
    Ue(b, d, f);
    return [
        b,
        d
    ];
}
function te(a, b, c, d, e, f) {
    let g = ac();
    a = new Se(S(a, b, e), S(c, d, f), 0, "");
    a.dirty = !0;
    return g._selection = a;
}
function Xe() {
    return new Re(new Set);
}
function bf(a) {
    let b = a.getEditorState()._selection, c = xb(a._window);
    return C(b) || null == b ? Qd(b, c, a, null) : b.clone();
}
function Qd(a, b, c, d) {
    var e = c._window;
    if (null === e) return null;
    var f = (e = d || e.event) ? e.type : void 0;
    d = "selectionchange" === f;
    e = !qb && (d || "beforeinput" === f || "compositionstart" === f || "compositionend" === f || "click" === f && e && 3 === e.detail || "drop" === f || void 0 === f);
    let g;
    if (!C(a) || e) {
        if (null === b) return null;
        e = b.anchorNode;
        f = b.focusNode;
        g = b.anchorOffset;
        b = b.focusOffset;
        if (d && C(a) && !Tb(c, e, f)) return a.clone();
    } else return a.clone();
    c = Te(e, g, f, b, c, a);
    if (null === c) return null;
    let [h, k] = c;
    return new Se(h, k, C(a) ? a.format : 0, C(a) ? a.style : "");
}
function u() {
    return ac()._selection;
}
function nc() {
    return F()._editorState._selection;
}
function ae(a, b, c, d = 1) {
    var e = a.anchor, f = a.focus, g = e.getNode(), h = f.getNode();
    if (b.is(g) || b.is(h)) {
        g = b.__key;
        if (a.isCollapsed()) {
            if (b = e.offset, c <= b && 0 < d || c < b && 0 > d) c = Math.max(0, b + d), e.set(g, c, "element"), f.set(g, c, "element"), cf(a);
        } else {
            let m = a.isBackward();
            h = m ? f : e;
            var k = h.getNode();
            e = m ? e : f;
            f = e.getNode();
            b.is(k) && (k = h.offset, (c <= k && 0 < d || c < k && 0 > d) && h.set(g, Math.max(0, k + d), "element"));
            b.is(f) && (b = e.offset, (c <= b && 0 < d || c < b && 0 > d) && e.set(g, Math.max(0, b + d), "element"));
        }
        cf(a);
    }
}
function cf(a) {
    var b = a.anchor, c = b.offset;
    let d = a.focus;
    var e = d.offset, f = b.getNode(), g = d.getNode();
    if (a.isCollapsed()) E(f) && (g = f.getChildrenSize(), g = (e = c >= g) ? f.getChildAtIndex(g - 1) : f.getChildAtIndex(c), B(g) && (c = 0, e && (c = g.getTextContentSize()), b.set(g.__key, c, "text"), d.set(g.__key, c, "text")));
    else {
        if (E(f)) {
            let h = f.getChildrenSize();
            c = (a = c >= h) ? f.getChildAtIndex(h - 1) : f.getChildAtIndex(c);
            B(c) && (f = 0, a && (f = c.getTextContentSize()), b.set(c.__key, f, "text"));
        }
        E(g) && (c = g.getChildrenSize(), e = (b = e >= c) ? g.getChildAtIndex(c - 1) : g.getChildAtIndex(e), B(e) && (g = 0, b && (g = e.getTextContentSize()), d.set(e.__key, g, "text")));
    }
}
function df(a, b) {
    b = b.getEditorState()._selection;
    a = a._selection;
    if (C(a)) {
        var c = a.anchor;
        let d = a.focus, e;
        "text" === c.type && (e = c.getNode(), e.selectionTransform(b, a));
        "text" === d.type && (c = d.getNode(), e !== c && c.selectionTransform(b, a));
    }
}
function $d(a, b, c, d, e) {
    let f = null, g = 0, h = null;
    null !== d ? (f = d.__key, B(d) ? (g = d.getTextContentSize(), h = "text") : E(d) && (g = d.getChildrenSize(), h = "element")) : null !== e && (f = e.__key, B(e) ? h = "text" : E(e) && (h = "element"));
    null !== f && null !== h ? a.set(f, g, h) : (g = b.getIndexWithinParent(), -1 === g && (g = c.getChildrenSize()), a.set(c.__key, g, "element"));
}
function ue(a, b, c, d, e) {
    "text" === a.type ? (a.key = c, b || (a.offset += e)) : a.offset > d.getIndexWithinParent() && --a.offset;
}
function ef(a) {
    a instanceof ff || (a instanceof be ? (a = Dc(a, gf), gf(a) || q(114)) : (a = Dc(a.getNode(), gf), gf(a) || q(114)));
    let b = a.getParent();
    hf(b) || q(115);
    let c = b.getParent();
    jf(c) || q(116);
    return [
        a,
        b,
        c
    ];
}
function Ve(a) {
    a.isCollapsed() || a.removeText();
    var b = a.anchor;
    a = b.getNode();
    for(b = b.offset; !Fc(a);)[a, b] = kf(a, b);
    return b;
}
function kf(a, b) {
    var c = a.getParent();
    if (!c) return c = ee(), J().append(c), c.select(), [
        J(),
        0
    ];
    if (B(a)) {
        var d = a.splitText(b);
        if (0 === d.length) return [
            c,
            a.getIndexWithinParent()
        ];
        a = 0 === b ? 0 : 1;
        a = d[0].getIndexWithinParent() + a;
        return [
            c,
            a
        ];
    }
    if (!E(a) || 0 === b) return [
        c,
        a.getIndexWithinParent()
    ];
    if (d = a.getChildAtIndex(b)) b = new Se(S(a.__key, b, "element"), S(a.__key, b, "element"), 0, ""), (b = a.insertNewAfter(b)) && b.append(d, ...d.getNextSiblings());
    return [
        c,
        a.getIndexWithinParent() + 1
    ];
}
function We(a) {
    let b = ee(), c = null;
    for(let d = 0; d < a.length; d++){
        let e = a[d], f = Gc(e);
        if (f || x(e) && e.isInline() || E(e) && e.isInline() || B(e) || e.isParentRequired()) {
            if (null === c && (c = e.createParentElementNode(), b.append(c), f)) continue;
            null !== c && c.append(e);
        } else b.append(e), c = null;
    }
    return b;
}
let T = null, U = null, Z = !1, lf = !1, $b = 0, mf = {
    characterData: !0,
    childList: !0,
    subtree: !0
};
function ec() {
    return Z || null !== T && T._readOnly;
}
function G() {
    Z && q(13);
}
function ac() {
    null === T && q(15);
    return T;
}
function F() {
    null === U && q(16);
    return U;
}
function nf(a, b, c) {
    var d = b.__type;
    let e = a._nodes.get(d);
    void 0 === e && q(30, d);
    a = c.get(d);
    void 0 === a && (a = Array.from(e.transforms), c.set(d, a));
    c = a.length;
    for(d = 0; d < c && (a[d](b), b.isAttached()); d++);
}
function of(a, b) {
    b = b._dirtyLeaves;
    a = a._nodeMap;
    for (let c of b)b = a.get(c), B(b) && b.isAttached() && b.isSimpleText() && !b.isUnmergeable() && Hb(b);
}
function pf(a, b) {
    let c = b._dirtyLeaves, d = b._dirtyElements;
    a = a._nodeMap;
    let e = dc(), f = new Map;
    var g = c;
    let h = g.size;
    for(var k = d, m = k.size; 0 < h || 0 < m;){
        if (0 < h) {
            b._dirtyLeaves = new Set;
            for (let n of g)g = a.get(n), B(g) && g.isAttached() && g.isSimpleText() && !g.isUnmergeable() && Hb(g), void 0 !== g && void 0 !== g && g.__key !== e && g.isAttached() && nf(b, g, f), c.add(n);
            g = b._dirtyLeaves;
            h = g.size;
            if (0 < h) {
                $b++;
                continue;
            }
        }
        b._dirtyLeaves = new Set;
        b._dirtyElements = new Map;
        for (let n of k)if (k = n[0], m = n[1], "root" === k || m) g = a.get(k), void 0 !== g && void 0 !== g && g.__key !== e && g.isAttached() && nf(b, g, f), d.set(k, m);
        g = b._dirtyLeaves;
        h = g.size;
        k = b._dirtyElements;
        m = k.size;
        $b++;
    }
    b._dirtyLeaves = c;
    b._dirtyElements = d;
}
function qf(a, b) {
    var c = a.type, d = b.get(c);
    void 0 === d && q(17, c);
    c = d.klass;
    a.type !== c.getType() && q(18, c.name);
    c = c.importJSON(a);
    a = a.children;
    if (E(c) && Array.isArray(a)) for(d = 0; d < a.length; d++){
        let e = qf(a[d], b);
        c.append(e);
    }
    return c;
}
function rf(a, b) {
    let c = T, d = Z, e = U;
    T = a;
    Z = !0;
    U = null;
    try {
        return b();
    } finally{
        T = c, Z = d, U = e;
    }
}
function sf(a, b) {
    let c = a._pendingEditorState, d = a._rootElement, e = a._headless || null === d;
    if (null !== c) {
        var f = a._editorState, g = f._selection, h = c._selection, k = 0 !== a._dirtyType, m = T, n = Z, p = U, l = a._updating, r = a._observer, w = null;
        a._pendingEditorState = null;
        a._editorState = c;
        if (!e && k && null !== r) {
            U = a;
            T = c;
            Z = !1;
            a._updating = !0;
            try {
                let D = a._dirtyType, P = a._dirtyElements, Q = a._dirtyLeaves;
                r.disconnect();
                var y = D, z = P, A = Q;
                N = Kc = M = "";
                Nc = 2 === y;
                Qc = null;
                O = a;
                Lc = a._config;
                Mc = a._nodes;
                Pc = O._listeners.mutation;
                Rc = z;
                Sc = A;
                Tc = f._nodeMap;
                Uc = c._nodeMap;
                Oc = c._readOnly;
                dd = new Map(a._keyToDOMMap);
                let fa = new Map;
                ed = fa;
                sd("root", null);
                ed = dd = Lc = Uc = Tc = Sc = Rc = Mc = O = void 0;
                w = fa;
            } catch (D) {
                D instanceof Error && a._onError(D);
                if (lf) throw D;
                tf(a, null, d, c);
                Db(a);
                a._dirtyType = 2;
                lf = !0;
                sf(a, f);
                lf = !1;
                return;
            } finally{
                r.observe(d, mf), a._updating = l, T = m, Z = n, U = p;
            }
        }
        c._readOnly || (c._readOnly = !0);
        var Ia = a._dirtyLeaves, ca = a._dirtyElements, Wa = a._normalizedNodes, ia = a._updateTags, Vc = a._deferred;
        k && (a._dirtyType = 0, a._cloneNotNeeded.clear(), a._dirtyLeaves = new Set, a._dirtyElements = new Map, a._normalizedNodes = new Set, a._updateTags = new Set);
        var De = a._decorators, Nb = a._pendingDecorators || De, Hf = c._nodeMap, Wc;
        for(Wc in Nb)Hf.has(Wc) || (Nb === De && (Nb = fc(a)), delete Nb[Wc]);
        var ha = e ? null : xb(a._window);
        if (a._editable && null !== ha && (k || null === h || h.dirty)) {
            U = a;
            T = c;
            try {
                null !== r && r.disconnect();
                if (k || null === h || h.dirty) {
                    let D = a._blockCursorElement;
                    null !== D && Cc(D, a, d);
                    a: {
                        let P = ha.anchorNode, Q = ha.focusNode, fa = ha.anchorOffset, lb = ha.focusOffset, W = document.activeElement;
                        if (!(ia.has("collaboration") && W !== d || null !== W && Mb(W))) {
                            if (C(h)) {
                                var mb = h.anchor, Xc = h.focus, Ee = mb.key, If = Xc.key, Fe = uc(a, Ee), Ge = uc(a, If), Ob = mb.offset, He = Xc.offset, Yc = h.format, Zc = h.style, Ie = h.isCollapsed(), nb = Fe, Pb = Ge, $c = !1;
                                if ("text" === mb.type) {
                                    nb = Xb(Fe);
                                    let X = mb.getNode();
                                    $c = X.getFormat() !== Yc || X.getStyle() !== Zc;
                                } else C(g) && "text" === g.anchor.type && ($c = !0);
                                "text" === Xc.type && (Pb = Xb(Ge));
                                if (null !== nb && null !== Pb) {
                                    if (Ie && (null === g || $c || C(g) && (g.format !== Yc || g.style !== Zc))) {
                                        var Jf = performance.now();
                                        Md = [
                                            Yc,
                                            Zc,
                                            Ob,
                                            Ee,
                                            Jf
                                        ];
                                    }
                                    if (fa === Ob && lb === He && P === nb && Q === Pb && ("Range" !== ha.type || !Ie) && (null !== W && d.contains(W) || d.focus({
                                        preventScroll: !0
                                    }), "element" !== mb.type)) break a;
                                    try {
                                        ha.setBaseAndExtent(nb, Ob, Pb, He);
                                    } catch (X) {}
                                    if (!ia.has("skip-scroll-into-view") && h.isCollapsed() && null !== d && d === document.activeElement) {
                                        let X = h instanceof Se && "element" === h.anchor.type ? nb.childNodes[Ob] || null : 0 < ha.rangeCount ? ha.getRangeAt(0) : null;
                                        if (null !== X) {
                                            let Y;
                                            if (X instanceof Text) {
                                                let V = document.createRange();
                                                V.selectNode(X);
                                                Y = V.getBoundingClientRect();
                                            } else Y = X.getBoundingClientRect();
                                            let wa = d.ownerDocument, Da = wa.defaultView;
                                            if (null !== Da) for(var { top: ad, bottom: bd } = Y, Qb, Rb, ma = d; null !== ma;){
                                                let V = ma === wa.body;
                                                if (V) Qb = 0, Rb = Eb(a).innerHeight;
                                                else {
                                                    let Sb = ma.getBoundingClientRect();
                                                    Qb = Sb.top;
                                                    Rb = Sb.bottom;
                                                }
                                                let Ea = 0;
                                                ad < Qb ? Ea = -(Qb - ad) : bd > Rb && (Ea = bd - Rb);
                                                if (0 !== Ea) {
                                                    if (V) Da.scrollBy(0, Ea);
                                                    else {
                                                        let Sb = ma.scrollTop;
                                                        ma.scrollTop += Ea;
                                                        let Je = ma.scrollTop - Sb;
                                                        ad -= Je;
                                                        bd -= Je;
                                                    }
                                                }
                                                if (V) break;
                                                ma = Vb(ma);
                                            }
                                        }
                                    }
                                    Id = !0;
                                }
                            } else null !== g && Tb(a, P, Q) && ha.removeAllRanges();
                        }
                    }
                }
                a: {
                    let D = a._blockCursorElement;
                    if (C(h) && h.isCollapsed() && "element" === h.anchor.type && d.contains(document.activeElement)) {
                        let P = h.anchor, Q = P.getNode(), fa = P.offset, lb = Q.getChildrenSize(), W = !1, X = null;
                        if (fa === lb) {
                            let Y = Q.getChildAtIndex(fa - 1);
                            Bc(Y) && (W = !0);
                        } else {
                            let Y = Q.getChildAtIndex(fa);
                            if (Bc(Y)) {
                                let wa = Y.getPreviousSibling();
                                if (null === wa || Bc(wa)) W = !0, X = a.getElementByKey(Y.__key);
                            }
                        }
                        if (W) {
                            let Y = a.getElementByKey(Q.__key);
                            if (null === D) {
                                let wa = a._config.theme, Da = document.createElement("div");
                                Da.contentEditable = "false";
                                Da.setAttribute("data-lexical-cursor", "true");
                                let V = wa.blockCursor;
                                if (void 0 !== V) {
                                    if ("string" === typeof V) {
                                        let Ea = V.split(" ");
                                        V = wa.blockCursor = Ea;
                                    }
                                    void 0 !== V && Da.classList.add(...V);
                                }
                                a._blockCursorElement = D = Da;
                            }
                            d.style.caretColor = "transparent";
                            null === X ? Y.appendChild(D) : Y.insertBefore(D, X);
                            break a;
                        }
                    }
                    null !== D && Cc(D, a, d);
                }
                null !== r && r.observe(d, mf);
            } finally{
                U = p, T = m;
            }
        }
        if (null !== w) {
            var Kf = w;
            let D = Array.from(a._listeners.mutation), P = D.length;
            for(let Q = 0; Q < P; Q++){
                let [fa, lb] = D[Q], W = Kf.get(lb);
                void 0 !== W && fa(W, {
                    dirtyLeaves: Ia,
                    prevEditorState: f,
                    updateTags: ia
                });
            }
        }
        C(h) || null === h || null !== g && g.is(h) || a.dispatchCommand(aa, void 0);
        var cd = a._pendingDecorators;
        null !== cd && (a._decorators = cd, a._pendingDecorators = null, uf("decorator", a, !0, cd));
        var Lf = gc(b || f), Ke = gc(c);
        Lf !== Ke && uf("textcontent", a, !0, Ke);
        uf("update", a, !0, {
            dirtyElements: ca,
            dirtyLeaves: Ia,
            editorState: c,
            normalizedNodes: Wa,
            prevEditorState: b || f,
            tags: ia
        });
        a._deferred = [];
        if (0 !== Vc.length) {
            let D = a._updating;
            a._updating = !0;
            try {
                for(let P = 0; P < Vc.length; P++)Vc[P]();
            } finally{
                a._updating = D;
            }
        }
        var Le = a._updates;
        if (0 !== Le.length) {
            let D = Le.shift();
            if (D) {
                let [P, Q] = D;
                vf(a, P, Q);
            }
        }
    }
}
function uf(a, b, c, ...d) {
    let e = b._updating;
    b._updating = c;
    try {
        let f = Array.from(b._listeners[a]);
        for(a = 0; a < f.length; a++)f[a].apply(null, d);
    } finally{
        b._updating = e;
    }
}
function R(a, b, c) {
    if (!1 === a._updating || U !== a) {
        let f = !1;
        a.update(()=>{
            f = R(a, b, c);
        });
        return f;
    }
    let d = kc(a);
    for(let f = 4; 0 <= f; f--)for(let g = 0; g < d.length; g++){
        var e = d[g]._commands.get(b);
        if (void 0 !== e && (e = e[f], void 0 !== e)) {
            e = Array.from(e);
            let h = e.length;
            for(let k = 0; k < h; k++)if (!0 === e[k](c, a)) return !0;
        }
    }
    return !1;
}
function wf(a, b) {
    let c = a._updates;
    for(b = b || !1; 0 !== c.length;){
        var d = c.shift();
        if (d) {
            let [e, f] = d, g;
            void 0 !== f && (d = f.onUpdate, g = f.tag, f.skipTransforms && (b = !0), d && a._deferred.push(d), g && a._updateTags.add(g));
            e();
        }
    }
    return b;
}
function vf(a, b, c) {
    let d = a._updateTags;
    var e, f = e = !1;
    if (void 0 !== c) {
        var g = c.onUpdate;
        e = c.tag;
        null != e && d.add(e);
        e = c.skipTransforms || !1;
        f = c.discrete || !1;
    }
    g && a._deferred.push(g);
    c = a._editorState;
    g = a._pendingEditorState;
    let h = !1;
    if (null === g || g._readOnly) g = a._pendingEditorState = new xf(new Map((g || c)._nodeMap)), h = !0;
    g._flushSync = f;
    f = T;
    let k = Z, m = U, n = a._updating;
    T = g;
    Z = !1;
    a._updating = !0;
    U = a;
    try {
        h && (a._headless ? null != c._selection && (g._selection = c._selection.clone()) : g._selection = bf(a));
        let p = a._compositionKey;
        b();
        e = wf(a, e);
        df(g, a);
        0 !== a._dirtyType && (e ? of(g, a) : pf(g, a), wf(a), Jc(c, g, a._dirtyLeaves, a._dirtyElements));
        p !== a._compositionKey && (g._flushSync = !0);
        let l = g._selection;
        if (C(l)) {
            let r = g._nodeMap, w = l.focus.key;
            void 0 !== r.get(l.anchor.key) && void 0 !== r.get(w) || q(19);
        } else Ud(l) && 0 === l._nodes.size && (g._selection = null);
    } catch (p) {
        p instanceof Error && a._onError(p);
        a._pendingEditorState = c;
        a._dirtyType = 2;
        a._cloneNotNeeded.clear();
        a._dirtyLeaves = new Set;
        a._dirtyElements.clear();
        sf(a);
        return;
    } finally{
        T = f, Z = k, U = m, a._updating = n, $b = 0;
    }
    0 !== a._dirtyType || yf(g, a) ? g._flushSync ? (g._flushSync = !1, sf(a)) : h && Lb(()=>{
        sf(a);
    }) : (g._flushSync = !1, h && (d.clear(), a._deferred = [], a._pendingEditorState = null));
}
function v(a, b, c) {
    a._updating ? a._updates.push([
        b,
        c
    ]) : vf(a, b, c);
}
class zf extends be {
    constructor(a){
        super(a);
    }
    decorate() {
        q(47);
    }
    isIsolated() {
        return !1;
    }
    isInline() {
        return !0;
    }
    isKeyboardSelectable() {
        return !0;
    }
}
function x(a) {
    return a instanceof zf;
}
class Af extends be {
    constructor(a){
        super(a);
        this.__last = this.__first = null;
        this.__indent = this.__format = this.__size = 0;
        this.__dir = null;
    }
    getFormat() {
        return this.getLatest().__format;
    }
    getFormatType() {
        let a = this.getFormat();
        return kb[a] || "";
    }
    getIndent() {
        return this.getLatest().__indent;
    }
    getChildren() {
        let a = [], b = this.getFirstChild();
        for(; null !== b;)a.push(b), b = b.getNextSibling();
        return a;
    }
    getChildrenKeys() {
        let a = [], b = this.getFirstChild();
        for(; null !== b;)a.push(b.__key), b = b.getNextSibling();
        return a;
    }
    getChildrenSize() {
        return this.getLatest().__size;
    }
    isEmpty() {
        return 0 === this.getChildrenSize();
    }
    isDirty() {
        let a = F()._dirtyElements;
        return null !== a && a.has(this.__key);
    }
    isLastChild() {
        let a = this.getLatest(), b = this.getParentOrThrow().getLastChild();
        return null !== b && b.is(a);
    }
    getAllTextNodes() {
        let a = [], b = this.getFirstChild();
        for(; null !== b;){
            B(b) && a.push(b);
            if (E(b)) {
                let c = b.getAllTextNodes();
                a.push(...c);
            }
            b = b.getNextSibling();
        }
        return a;
    }
    getFirstDescendant() {
        let a = this.getFirstChild();
        for(; null !== a;){
            if (E(a)) {
                let b = a.getFirstChild();
                if (null !== b) {
                    a = b;
                    continue;
                }
            }
            break;
        }
        return a;
    }
    getLastDescendant() {
        let a = this.getLastChild();
        for(; null !== a;){
            if (E(a)) {
                let b = a.getLastChild();
                if (null !== b) {
                    a = b;
                    continue;
                }
            }
            break;
        }
        return a;
    }
    getDescendantByIndex(a) {
        let b = this.getChildren(), c = b.length;
        if (a >= c) return a = b[c - 1], E(a) && a.getLastDescendant() || a || null;
        a = b[a];
        return E(a) && a.getFirstDescendant() || a || null;
    }
    getFirstChild() {
        let a = this.getLatest().__first;
        return null === a ? null : I(a);
    }
    getFirstChildOrThrow() {
        let a = this.getFirstChild();
        null === a && q(45, this.__key);
        return a;
    }
    getLastChild() {
        let a = this.getLatest().__last;
        return null === a ? null : I(a);
    }
    getLastChildOrThrow() {
        let a = this.getLastChild();
        null === a && q(96, this.__key);
        return a;
    }
    getChildAtIndex(a) {
        var b = this.getChildrenSize();
        let c;
        if (a < b / 2) {
            c = this.getFirstChild();
            for(b = 0; null !== c && b <= a;){
                if (b === a) return c;
                c = c.getNextSibling();
                b++;
            }
            return null;
        }
        c = this.getLastChild();
        for(--b; null !== c && b >= a;){
            if (b === a) return c;
            c = c.getPreviousSibling();
            b--;
        }
        return null;
    }
    getTextContent() {
        let a = "", b = this.getChildren(), c = b.length;
        for(let d = 0; d < c; d++){
            let e = b[d];
            a += e.getTextContent();
            E(e) && d !== c - 1 && !e.isInline() && (a += "\n\n");
        }
        return a;
    }
    getTextContentSize() {
        let a = 0, b = this.getChildren(), c = b.length;
        for(let d = 0; d < c; d++){
            let e = b[d];
            a += e.getTextContentSize();
            E(e) && d !== c - 1 && !e.isInline() && (a += 2);
        }
        return a;
    }
    getDirection() {
        return this.getLatest().__dir;
    }
    hasFormat(a) {
        return "" !== a ? (a = jb[a], 0 !== (this.getFormat() & a)) : !1;
    }
    select(a, b) {
        G();
        let c = u(), d = a, e = b;
        var f = this.getChildrenSize();
        if (!this.canBeEmpty()) {
            if (0 === a && 0 === b) {
                if (a = this.getFirstChild(), B(a) || E(a)) return a.select(0, 0);
            } else if (!(void 0 !== a && a !== f || void 0 !== b && b !== f) && (a = this.getLastChild(), B(a) || E(a))) return a.select();
        }
        void 0 === d && (d = f);
        void 0 === e && (e = f);
        f = this.__key;
        if (C(c)) c.anchor.set(f, d, "element"), c.focus.set(f, e, "element"), c.dirty = !0;
        else return te(f, d, f, e, "element", "element");
        return c;
    }
    selectStart() {
        let a = this.getFirstDescendant();
        return a ? a.selectStart() : this.select();
    }
    selectEnd() {
        let a = this.getLastDescendant();
        return a ? a.selectEnd() : this.select();
    }
    clear() {
        let a = this.getWritable();
        this.getChildren().forEach((b)=>b.remove());
        return a;
    }
    append(...a) {
        return this.splice(this.getChildrenSize(), 0, a);
    }
    setDirection(a) {
        let b = this.getWritable();
        b.__dir = a;
        return b;
    }
    setFormat(a) {
        this.getWritable().__format = "" !== a ? jb[a] : 0;
        return this;
    }
    setIndent(a) {
        this.getWritable().__indent = a;
        return this;
    }
    splice(a, b, c) {
        let d = c.length, e = this.getChildrenSize(), f = this.getWritable(), g = f.__key;
        var h = [], k = [];
        let m = this.getChildAtIndex(a + b), n = null, p = e - b + d;
        if (0 !== a) {
            if (a === e) n = this.getLastChild();
            else {
                var l = this.getChildAtIndex(a);
                null !== l && (n = l.getPreviousSibling());
            }
        }
        if (0 < b) {
            var r = null === n ? this.getFirstChild() : n.getNextSibling();
            for(l = 0; l < b; l++){
                null === r && q(100);
                var w = r.getNextSibling(), y = r.__key;
                r = r.getWritable();
                bc(r);
                k.push(y);
                r = w;
            }
        }
        l = n;
        for(w = 0; w < d; w++){
            y = c[w];
            null !== l && y.is(l) && (n = l = l.getPreviousSibling());
            r = y.getWritable();
            r.__parent === g && p--;
            bc(r);
            let z = y.__key;
            null === l ? (f.__first = z, r.__prev = null) : (l = l.getWritable(), l.__next = z, r.__prev = l.__key);
            y.__key === g && q(76);
            r.__parent = g;
            h.push(z);
            l = y;
        }
        a + b === e ? null !== l && (l.getWritable().__next = null, f.__last = l.__key) : null !== m && (a = m.getWritable(), null !== l ? (b = l.getWritable(), a.__prev = l.__key, b.__next = m.__key) : a.__prev = null);
        f.__size = p;
        if (k.length && (a = u(), C(a))) {
            k = new Set(k);
            h = new Set(h);
            let { anchor: z, focus: A } = a;
            Bf(z, k, h) && $d(z, z.getNode(), this, n, m);
            Bf(A, k, h) && $d(A, A.getNode(), this, n, m);
            0 !== p || this.canBeEmpty() || xc(this) || this.remove();
        }
        return f;
    }
    exportJSON() {
        return {
            children: [],
            direction: this.getDirection(),
            format: this.getFormatType(),
            indent: this.getIndent(),
            type: "element",
            version: 1
        };
    }
    insertNewAfter() {
        return null;
    }
    canIndent() {
        return !0;
    }
    collapseAtStart() {
        return !1;
    }
    excludeFromCopy() {
        return !1;
    }
    canExtractContents() {
        return !0;
    }
    canReplaceWith() {
        return !0;
    }
    canInsertAfter() {
        return !0;
    }
    canBeEmpty() {
        return !0;
    }
    canInsertTextBefore() {
        return !0;
    }
    canInsertTextAfter() {
        return !0;
    }
    isInline() {
        return !1;
    }
    isShadowRoot() {
        return !1;
    }
    canMergeWith() {
        return !1;
    }
    extractWithChild() {
        return !1;
    }
}
function E(a) {
    return a instanceof Af;
}
function Bf(a, b, c) {
    for(a = a.getNode(); a;){
        let d = a.__key;
        if (b.has(d) && !c.has(d)) return !0;
        a = a.getParent();
    }
    return !1;
}
class Cf extends Af {
    static getType() {
        return "root";
    }
    static clone() {
        return new Cf;
    }
    constructor(){
        super("root");
        this.__cachedText = null;
    }
    getTopLevelElementOrThrow() {
        q(51);
    }
    getTextContent() {
        let a = this.__cachedText;
        return !ec() && 0 !== F()._dirtyType || null === a ? super.getTextContent() : a;
    }
    remove() {
        q(52);
    }
    replace() {
        q(53);
    }
    insertBefore() {
        q(54);
    }
    insertAfter() {
        q(55);
    }
    updateDOM() {
        return !1;
    }
    append(...a) {
        for(let b = 0; b < a.length; b++){
            let c = a[b];
            E(c) || x(c) || q(56);
        }
        return super.append(...a);
    }
    static importJSON(a) {
        let b = J();
        b.setFormat(a.format);
        b.setIndent(a.indent);
        b.setDirection(a.direction);
        return b;
    }
    exportJSON() {
        return {
            children: [],
            direction: this.getDirection(),
            format: this.getFormatType(),
            indent: this.getIndent(),
            type: "root",
            version: 1
        };
    }
    collapseAtStart() {
        return !0;
    }
}
function L(a) {
    return a instanceof Cf;
}
function yf(a, b) {
    b = b.getEditorState()._selection;
    a = a._selection;
    if (null !== a) {
        if (a.dirty || !a.is(b)) return !0;
    } else if (null !== b) return !0;
    return !1;
}
function Df() {
    return new xf(new Map([
        [
            "root",
            new Cf
        ]
    ]));
}
function Ef(a) {
    let b = a.exportJSON();
    var c = a.constructor;
    b.type !== c.getType() && q(130, c.name);
    if (E(a)) {
        let d = b.children;
        Array.isArray(d) || q(59, c.name);
        a = a.getChildren();
        for(c = 0; c < a.length; c++){
            let e = Ef(a[c]);
            d.push(e);
        }
    }
    return b;
}
class xf {
    constructor(a, b){
        this._nodeMap = a;
        this._selection = b || null;
        this._readOnly = this._flushSync = !1;
    }
    isEmpty() {
        return 1 === this._nodeMap.size && null === this._selection;
    }
    read(a) {
        return rf(this, a);
    }
    clone(a) {
        a = new xf(this._nodeMap, void 0 === a ? this._selection : a);
        a._readOnly = !0;
        return a;
    }
    toJSON() {
        return rf(this, ()=>({
                root: Ef(J())
            }));
    }
}
class Ff extends Af {
    static getType() {
        return "paragraph";
    }
    static clone(a) {
        return new Ff(a.__key);
    }
    createDOM(a) {
        let b = document.createElement("p");
        a = pc(a.theme, "paragraph");
        void 0 !== a && b.classList.add(...a);
        return b;
    }
    updateDOM() {
        return !1;
    }
    static importDOM() {
        return {
            p: ()=>({
                    conversion: Gf,
                    priority: 0
                })
        };
    }
    exportDOM(a) {
        ({ element: a } = super.exportDOM(a));
        if (a && Ec(a)) {
            this.isEmpty() && a.append(document.createElement("br"));
            var b = this.getFormatType();
            a.style.textAlign = b;
            if (b = this.getDirection()) a.dir = b;
            b = this.getIndent();
            0 < b && (a.style.textIndent = `${20 * b}px`);
        }
        return {
            element: a
        };
    }
    static importJSON(a) {
        let b = ee();
        b.setFormat(a.format);
        b.setIndent(a.indent);
        b.setDirection(a.direction);
        return b;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "paragraph",
            version: 1
        };
    }
    insertNewAfter(a, b) {
        a = ee();
        let c = this.getDirection();
        a.setDirection(c);
        this.insertAfter(a, b);
        return a;
    }
    collapseAtStart() {
        let a = this.getChildren();
        if (0 === a.length || B(a[0]) && "" === a[0].getTextContent().trim()) {
            if (null !== this.getNextSibling()) return this.selectNext(), this.remove(), !0;
            if (null !== this.getPreviousSibling()) return this.selectPrevious(), this.remove(), !0;
        }
        return !1;
    }
}
function Gf(a) {
    let b = ee();
    a.style && (b.setFormat(a.style.textAlign), a = parseInt(a.style.textIndent, 10) / 20, 0 < a && b.setIndent(a));
    return {
        node: b
    };
}
function ee() {
    return zc(new Ff);
}
function tf(a, b, c, d) {
    let e = a._keyToDOMMap;
    e.clear();
    a._editorState = Df();
    a._pendingEditorState = d;
    a._compositionKey = null;
    a._dirtyType = 0;
    a._cloneNotNeeded.clear();
    a._dirtyLeaves = new Set;
    a._dirtyElements.clear();
    a._normalizedNodes = new Set;
    a._updateTags = new Set;
    a._updates = [];
    a._blockCursorElement = null;
    d = a._observer;
    null !== d && (d.disconnect(), a._observer = null);
    null !== b && (b.textContent = "");
    null !== c && (c.textContent = "", e.set("root", c));
}
function Mf(a, b) {
    let c = new Map, d = new Set, e = (f)=>{
        Object.keys(f).forEach((g)=>{
            let h = c.get(g);
            void 0 === h && (h = [], c.set(g, h));
            h.push(f[g]);
        });
    };
    a.forEach((f)=>{
        f = null != f.klass.importDOM ? f.klass.importDOM.bind(f.klass) : null;
        null == f || d.has(f) || (d.add(f), f = f(), null !== f && e(f));
    });
    b && e(b);
    return c;
}
class Nf {
    constructor(a, b, c, d, e, f, g){
        this._parentEditor = b;
        this._rootElement = null;
        this._editorState = a;
        this._compositionKey = this._pendingEditorState = null;
        this._deferred = [];
        this._keyToDOMMap = new Map;
        this._updates = [];
        this._updating = !1;
        this._listeners = {
            decorator: new Set,
            editable: new Set,
            mutation: new Map,
            root: new Set,
            textcontent: new Set,
            update: new Set
        };
        this._commands = new Map;
        this._config = d;
        this._nodes = c;
        this._decorators = {};
        this._pendingDecorators = null;
        this._dirtyType = 0;
        this._cloneNotNeeded = new Set;
        this._dirtyLeaves = new Set;
        this._dirtyElements = new Map;
        this._normalizedNodes = new Set;
        this._updateTags = new Set;
        this._observer = null;
        this._key = lc();
        this._onError = e;
        this._htmlConversions = f;
        this._editable = g;
        this._headless = null !== b && b._headless;
        this._blockCursorElement = this._window = null;
    }
    isComposing() {
        return null != this._compositionKey;
    }
    registerUpdateListener(a) {
        let b = this._listeners.update;
        b.add(a);
        return ()=>{
            b.delete(a);
        };
    }
    registerEditableListener(a) {
        let b = this._listeners.editable;
        b.add(a);
        return ()=>{
            b.delete(a);
        };
    }
    registerDecoratorListener(a) {
        let b = this._listeners.decorator;
        b.add(a);
        return ()=>{
            b.delete(a);
        };
    }
    registerTextContentListener(a) {
        let b = this._listeners.textcontent;
        b.add(a);
        return ()=>{
            b.delete(a);
        };
    }
    registerRootListener(a) {
        let b = this._listeners.root;
        a(this._rootElement, null);
        b.add(a);
        return ()=>{
            a(null, this._rootElement);
            b.delete(a);
        };
    }
    registerCommand(a, b, c) {
        void 0 === c && q(35);
        let d = this._commands;
        d.has(a) || d.set(a, [
            new Set,
            new Set,
            new Set,
            new Set,
            new Set
        ]);
        let e = d.get(a);
        void 0 === e && q(36, String(a));
        let f = e[c];
        f.add(b);
        return ()=>{
            f.delete(b);
            e.every((g)=>0 === g.size) && d.delete(a);
        };
    }
    registerMutationListener(a, b) {
        void 0 === this._nodes.get(a.getType()) && q(37, a.name);
        let c = this._listeners.mutation;
        c.set(b, a);
        return ()=>{
            c.delete(b);
        };
    }
    registerNodeTransformToKlass(a, b) {
        var c = a.getType();
        c = this._nodes.get(c);
        void 0 === c && q(37, a.name);
        c.transforms.add(b);
        return c;
    }
    registerNodeTransform(a, b) {
        var c = this.registerNodeTransformToKlass(a, b);
        let d = [
            c
        ];
        c = c.replaceWithKlass;
        null != c && (c = this.registerNodeTransformToKlass(c, b), d.push(c));
        hc(this, a.getType());
        return ()=>{
            d.forEach((e)=>e.transforms.delete(b));
        };
    }
    hasNode(a) {
        return this._nodes.has(a.getType());
    }
    hasNodes(a) {
        return a.every(this.hasNode.bind(this));
    }
    dispatchCommand(a, b) {
        return R(this, a, b);
    }
    getDecorators() {
        return this._decorators;
    }
    getRootElement() {
        return this._rootElement;
    }
    getKey() {
        return this._key;
    }
    setRootElement(a) {
        let b = this._rootElement;
        if (a !== b) {
            let f = pc(this._config.theme, "root");
            var c = this._pendingEditorState || this._editorState;
            this._rootElement = a;
            tf(this, b, a, c);
            if (null !== b) {
                if (!this._config.disableEvents) {
                    0 !== Hd && (Hd--, 0 === Hd && b.ownerDocument.removeEventListener("selectionchange", Xd));
                    var d = b.__lexicalEditor;
                    if (null !== d && void 0 !== d) {
                        if (null !== d._parentEditor) {
                            var e = kc(d);
                            e = e[e.length - 1]._key;
                            Wd.get(e) === d && Wd.delete(e);
                        } else Wd.delete(d._key);
                        b.__lexicalEditor = null;
                    }
                    d = Vd(b);
                    for(e = 0; e < d.length; e++)d[e]();
                    b.__lexicalEventHandles = [];
                }
                null != f && b.classList.remove(...f);
            }
            null !== a ? (c = (c = a.ownerDocument) && c.defaultView || null, d = a.style, d.userSelect = "text", d.whiteSpace = "pre-wrap", d.wordBreak = "break-word", a.setAttribute("data-lexical-editor", "true"), this._window = c, this._dirtyType = 2, Db(this), this._updateTags.add("history-merge"), sf(this), this._config.disableEvents || Yd(a, this), null != f && a.classList.add(...f)) : (this._editorState = c, this._window = this._pendingEditorState = null);
            uf("root", this, !1, a, b);
        }
    }
    getElementByKey(a) {
        return this._keyToDOMMap.get(a) || null;
    }
    getEditorState() {
        return this._editorState;
    }
    setEditorState(a, b) {
        a.isEmpty() && q(38);
        Cb(this);
        let c = this._pendingEditorState, d = this._updateTags;
        b = void 0 !== b ? b.tag : null;
        null === c || c.isEmpty() || (null != b && d.add(b), sf(this));
        this._pendingEditorState = a;
        this._dirtyType = 2;
        this._dirtyElements.set("root", !1);
        this._compositionKey = null;
        null != b && d.add(b);
        sf(this);
    }
    parseEditorState(a, b) {
        a = "string" === typeof a ? JSON.parse(a) : a;
        let c = Df(), d = T, e = Z, f = U, g = this._dirtyElements, h = this._dirtyLeaves, k = this._cloneNotNeeded, m = this._dirtyType;
        this._dirtyElements = new Map;
        this._dirtyLeaves = new Set;
        this._cloneNotNeeded = new Set;
        this._dirtyType = 0;
        T = c;
        Z = !1;
        U = this;
        try {
            qf(a.root, this._nodes), b && b(), c._readOnly = !0;
        } catch (n) {
            n instanceof Error && this._onError(n);
        } finally{
            this._dirtyElements = g, this._dirtyLeaves = h, this._cloneNotNeeded = k, this._dirtyType = m, T = d, Z = e, U = f;
        }
        return c;
    }
    update(a, b) {
        v(this, a, b);
    }
    focus(a, b = {}) {
        let c = this._rootElement;
        null !== c && (c.setAttribute("autocapitalize", "off"), v(this, ()=>{
            let d = u(), e = J();
            null !== d ? d.dirty = !0 : 0 !== e.getChildrenSize() && ("rootStart" === b.defaultSelection ? e.selectStart() : e.selectEnd());
        }, {
            onUpdate: ()=>{
                c.removeAttribute("autocapitalize");
                a && a();
            },
            tag: "focus"
        }), null === this._pendingEditorState && c.removeAttribute("autocapitalize"));
    }
    blur() {
        var a = this._rootElement;
        null !== a && a.blur();
        a = xb(this._window);
        null !== a && a.removeAllRanges();
    }
    isEditable() {
        return this._editable;
    }
    setEditable(a) {
        this._editable !== a && (this._editable = a, uf("editable", this, !0, a));
    }
    toJSON() {
        return {
            editorState: this._editorState.toJSON()
        };
    }
}
class ff extends Af {
    constructor(a, b){
        super(b);
        this.__colSpan = a;
        this.__rowSpan = 1;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            colSpan: this.__colSpan,
            rowSpan: this.__rowSpan
        };
    }
    getColSpan() {
        return this.__colSpan;
    }
    setColSpan(a) {
        this.getWritable().__colSpan = a;
        return this;
    }
    getRowSpan() {
        return this.__rowSpan;
    }
    setRowSpan(a) {
        this.getWritable().__rowSpan = a;
        return this;
    }
}
function gf(a) {
    return a instanceof ff;
}
class Of extends Af {
}
function jf(a) {
    return a instanceof Of;
}
class Pf extends Af {
}
function hf(a) {
    return a instanceof Pf;
}
exports.$INTERNAL_isPointSelection = ce;
exports.$addUpdateTag = function(a) {
    G();
    F()._updateTags.add(a);
};
exports.$applyNodeReplacement = zc;
exports.$copyNode = yc;
exports.$createLineBreakNode = ie;
exports.$createNodeSelection = Xe;
exports.$createParagraphNode = ee;
exports.$createPoint = S;
exports.$createRangeSelection = function() {
    let a = S("root", 0, "element"), b = S("root", 0, "element");
    return new Se(a, b, 0, "");
};
exports.$createTabNode = we;
exports.$createTextNode = K;
exports.$getAdjacentNode = sc;
exports.$getNearestNodeFromDOMNode = wb;
exports.$getNearestRootOrShadowRoot = wc;
exports.$getNodeByKey = I;
exports.$getPreviousSelection = nc;
exports.$getRoot = J;
exports.$getSelection = u;
exports.$getTextContent = function() {
    let a = u();
    return null === a ? "" : a.getTextContent();
};
exports.$hasAncestor = vc;
exports.$hasUpdateTag = function(a) {
    return F()._updateTags.has(a);
};
exports.$insertNodes = function(a) {
    let b = u() || nc();
    null === b && (b = J().selectEnd());
    b.insertNodes(a);
};
exports.$isBlockElementNode = function(a) {
    return E(a) && !a.isInline();
};
exports.$isDecoratorNode = x;
exports.$isElementNode = E;
exports.$isInlineElementOrDecoratorNode = function(a) {
    return E(a) && a.isInline() || x(a) && a.isInline();
};
exports.$isLeafNode = function(a) {
    return B(a) || Gc(a) || x(a);
};
exports.$isLineBreakNode = Gc;
exports.$isNodeSelection = Ud;
exports.$isParagraphNode = function(a) {
    return a instanceof Ff;
};
exports.$isRangeSelection = C;
exports.$isRootNode = L;
exports.$isRootOrShadowRoot = xc;
exports.$isTabNode = Be;
exports.$isTextNode = B;
exports.$nodesOfType = function(a) {
    var b = ac();
    let c = b._readOnly, d = a.getType();
    b = b._nodeMap;
    let e = [];
    for (let [, f] of b)f instanceof a && f.__type === d && (c || f.isAttached()) && e.push(f);
    return e;
};
exports.$normalizeSelection__EXPERIMENTAL = Ib;
exports.$parseSerializedNode = function(a) {
    return qf(a, F()._nodes);
};
exports.$selectAll = function() {
    var a = J();
    a = a.select(0, a.getChildrenSize());
    Ab(Ib(a));
};
exports.$setCompositionKey = H;
exports.$setSelection = Ab;
exports.$splitNode = function(a, b) {
    let c = a.getChildAtIndex(b);
    null == c && (c = a);
    xc(a) && q(102);
    let d = (g)=>{
        const h = g.getParentOrThrow(), k = xc(h), m = g !== c || k ? yc(g) : g;
        if (k) {
            if (!E(g) || !E(m)) throw Error("Children of a root must be ElementNode");
            g.insertAfter(m);
            return [
                g,
                m,
                m
            ];
        }
        const [n, p, l] = d(h);
        g = g.getNextSiblings();
        l.append(m, ...g);
        return [
            n,
            p,
            m
        ];
    }, [e, f] = d(c);
    return [
        e,
        f
    ];
};
exports.BLUR_COMMAND = Sa;
exports.CAN_REDO_COMMAND = {};
exports.CAN_UNDO_COMMAND = {};
exports.CLEAR_EDITOR_COMMAND = {};
exports.CLEAR_HISTORY_COMMAND = {};
exports.CLICK_COMMAND = ba;
exports.COMMAND_PRIORITY_CRITICAL = 4;
exports.COMMAND_PRIORITY_EDITOR = 0;
exports.COMMAND_PRIORITY_HIGH = 3;
exports.COMMAND_PRIORITY_LOW = 1;
exports.COMMAND_PRIORITY_NORMAL = 2;
exports.CONTROLLED_TEXT_INSERTION_COMMAND = ka;
exports.COPY_COMMAND = Oa;
exports.CUT_COMMAND = Pa;
exports.DELETE_CHARACTER_COMMAND = da;
exports.DELETE_LINE_COMMAND = pa;
exports.DELETE_WORD_COMMAND = oa;
exports.DEPRECATED_$computeGridMap = function(a, b, c) {
    let d = [], e = null, f = null;
    a = a.getChildren();
    for(let n = 0; n < a.length; n++){
        var g = a[n];
        hf(g) || q(108);
        var h = g.getChildren();
        g = 0;
        for (let p of h){
            for(gf(p) || q(109); void 0 !== d[n] && void 0 !== d[n][g];)g++;
            h = n;
            var k = g, m = p;
            let l = {
                cell: m,
                startColumn: k,
                startRow: h
            }, r = m.__rowSpan, w = m.__colSpan;
            for(let y = 0; y < r; y++){
                void 0 === d[h + y] && (d[h + y] = []);
                for(let z = 0; z < w; z++)d[h + y][k + z] = l;
            }
            b.is(m) && (e = l);
            c.is(m) && (f = l);
            g += p.__colSpan;
        }
    }
    null === e && q(110);
    null === f && q(111);
    return [
        d,
        e,
        f
    ];
};
exports.DEPRECATED_$getGridCellNodeRect = function(a) {
    let [b, , c] = ef(a);
    a = c.getChildren();
    let d = a.length;
    var e = a[0].getChildren().length;
    let f = Array(d);
    for(var g = 0; g < d; g++)f[g] = Array(e);
    for(e = 0; e < d; e++){
        g = a[e].getChildren();
        let h = 0;
        for(let k = 0; k < g.length; k++){
            for(; f[e][h];)h++;
            let m = g[k], n = m.__rowSpan || 1, p = m.__colSpan || 1;
            for(let l = 0; l < n; l++)for(let r = 0; r < p; r++)f[e + l][h + r] = m;
            if (b === m) return {
                colSpan: p,
                columnIndex: h,
                rowIndex: e,
                rowSpan: n
            };
            h += p;
        }
    }
    return null;
};
exports.DEPRECATED_$getNodeTriplet = ef;
exports.DEPRECATED_$isGridCellNode = gf;
exports.DEPRECATED_$isGridNode = jf;
exports.DEPRECATED_$isGridRowNode = hf;
exports.DEPRECATED_GridCellNode = ff;
exports.DEPRECATED_GridNode = Of;
exports.DEPRECATED_GridRowNode = Pf;
exports.DRAGEND_COMMAND = Na;
exports.DRAGOVER_COMMAND = Ma;
exports.DRAGSTART_COMMAND = La;
exports.DROP_COMMAND = Ka;
exports.DecoratorNode = zf;
exports.ElementNode = Af;
exports.FOCUS_COMMAND = Ra;
exports.FORMAT_ELEMENT_COMMAND = {};
exports.FORMAT_TEXT_COMMAND = qa;
exports.INDENT_CONTENT_COMMAND = {};
exports.INSERT_LINE_BREAK_COMMAND = ea;
exports.INSERT_PARAGRAPH_COMMAND = ja;
exports.INSERT_TAB_COMMAND = {};
exports.INTERNAL_PointSelection = Pe;
exports.KEY_ARROW_DOWN_COMMAND = Aa;
exports.KEY_ARROW_LEFT_COMMAND = xa;
exports.KEY_ARROW_RIGHT_COMMAND = ua;
exports.KEY_ARROW_UP_COMMAND = za;
exports.KEY_BACKSPACE_COMMAND = Fa;
exports.KEY_DELETE_COMMAND = Ha;
exports.KEY_DOWN_COMMAND = ta;
exports.KEY_ENTER_COMMAND = Ba;
exports.KEY_ESCAPE_COMMAND = Ga;
exports.KEY_MODIFIER_COMMAND = Ta;
exports.KEY_SPACE_COMMAND = Ca;
exports.KEY_TAB_COMMAND = Ja;
exports.LineBreakNode = ge;
exports.MOVE_TO_END = va;
exports.MOVE_TO_START = ya;
exports.OUTDENT_CONTENT_COMMAND = {};
exports.PASTE_COMMAND = la;
exports.ParagraphNode = Ff;
exports.REDO_COMMAND = sa;
exports.REMOVE_TEXT_COMMAND = na;
exports.RootNode = Cf;
exports.SELECTION_CHANGE_COMMAND = aa;
exports.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND = {};
exports.SELECT_ALL_COMMAND = Qa;
exports.TabNode = Ae;
exports.TextNode = oe;
exports.UNDO_COMMAND = ra;
exports.createCommand = function() {
    return {};
};
exports.createEditor = function(a) {
    var b = a || {}, c = U, d = b.theme || {};
    let e = void 0 === a ? c : b.parentEditor || null, f = b.disableEvents || !1, g = Df(), h = b.namespace || (null !== e ? e._config.namespace : lc()), k = b.editorState, m = [
        Cf,
        oe,
        ge,
        Ae,
        Ff,
        ...b.nodes || []
    ], { onError: n, html: p } = b;
    b = void 0 !== b.editable ? b.editable : !0;
    if (void 0 === a && null !== c) a = c._nodes;
    else for(a = new Map, c = 0; c < m.length; c++){
        let r = m[c], w = null;
        var l = null;
        "function" !== typeof r && (l = r, r = l.replace, w = l.with, l = l.withKlass || null);
        let y = r.getType(), z = r.transform(), A = new Set;
        null !== z && A.add(z);
        a.set(y, {
            exportDOM: p && p.export ? p.export.get(r) : void 0,
            klass: r,
            replace: w,
            replaceWithKlass: l,
            transforms: A
        });
    }
    d = new Nf(g, e, a, {
        disableEvents: f,
        namespace: h,
        theme: d
    }, n ? n : console.error, Mf(a, p ? p.import : void 0), b);
    void 0 !== k && (d._pendingEditorState = k, d._dirtyType = 2);
    return d;
};
exports.getNearestEditorFromDOMNode = Ub;
exports.isCurrentlyReadOnlyMode = ec;
exports.isHTMLAnchorElement = function(a) {
    return Ec(a) && "A" === a.tagName;
};
exports.isHTMLElement = Ec;
exports.isSelectionCapturedInDecoratorInput = Mb;
exports.isSelectionWithinEditor = Tb;

},{}],"7QLm2":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalCode = require("305167b80721de91");
module.exports = LexicalCode;

},{"305167b80721de91":"6ADnM"}],"6ADnM":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var d = require("396460eb9a479a2e");
require("2b38c56a74784d02");
require("3c782d154ae5dbd7");
require("fe77af35f85a949");
require("189b9966e0ac081f");
require("b8279e37a0e10e5b");
require("12ebb08160f309a1");
require("98c5f5a665fdb73e");
require("9745718cde28845d");
require("44f2f22f20f6b971");
require("d1d13af9c3743381");
require("5dd906ed9131dbc1");
require("190b1441465a6023");
require("b4b54facaf6c4c29");
require("e44e24f17235505a");
var m = require("2cd1826e31d3d09f"), q = require("d5a7a7e74a00fcfc");
let v = (a)=>null != a && d.languages.hasOwnProperty(a) ? a : void 0;
function x(a, b) {
    for (let c of a.childNodes){
        if (m.isHTMLElement(c) && c.tagName === b) return !0;
        x(c, b);
    }
    return !1;
}
class y extends q.ElementNode {
    static getType() {
        return "code";
    }
    static clone(a) {
        return new y(a.__language, a.__key);
    }
    constructor(a, b){
        super(b);
        this.__language = v(a);
    }
    createDOM(a) {
        let b = document.createElement("code");
        m.addClassNamesToElement(b, a.theme.code);
        b.setAttribute("spellcheck", "false");
        (a = this.getLanguage()) && b.setAttribute("data-highlight-language", a);
        return b;
    }
    updateDOM(a, b) {
        let c = this.__language;
        a = a.__language;
        c ? c !== a && b.setAttribute("data-highlight-language", c) : a && b.removeAttribute("data-highlight-language");
        return !1;
    }
    exportDOM() {
        let a = document.createElement("pre");
        a.setAttribute("spellcheck", "false");
        let b = this.getLanguage();
        b && a.setAttribute("data-highlight-language", b);
        return {
            element: a
        };
    }
    static importDOM() {
        return {
            code: (a)=>null != a.textContent && (/\r?\n/.test(a.textContent) || x(a, "BR")) ? {
                    conversion: z,
                    priority: 1
                } : null,
            div: ()=>({
                    conversion: aa,
                    priority: 1
                }),
            pre: ()=>({
                    conversion: z,
                    priority: 0
                }),
            table: (a)=>A(a) ? {
                    conversion: ba,
                    priority: 3
                } : null,
            td: (a)=>{
                let b = a.closest("table");
                return a.classList.contains("js-file-line") ? {
                    conversion: ca,
                    priority: 3
                } : b && A(b) ? {
                    conversion: B,
                    priority: 3
                } : null;
            },
            tr: (a)=>(a = a.closest("table")) && A(a) ? {
                    conversion: B,
                    priority: 3
                } : null
        };
    }
    static importJSON(a) {
        let b = C(a.language);
        b.setFormat(a.format);
        b.setIndent(a.indent);
        b.setDirection(a.direction);
        return b;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            language: this.getLanguage(),
            type: "code",
            version: 1
        };
    }
    insertNewAfter(a, b = !0) {
        var c = this.getChildren(), e = c.length;
        if (2 <= e && "\n" === c[e - 1].getTextContent() && "\n" === c[e - 2].getTextContent() && a.isCollapsed() && a.anchor.key === this.__key && a.anchor.offset === e) return c[e - 1].remove(), c[e - 2].remove(), a = q.$createParagraphNode(), this.insertAfter(a, b), a;
        let { anchor: f, focus: g } = a;
        b = (f.isBefore(g) ? f : g).getNode();
        if (q.$isTextNode(b)) {
            e = D(b);
            for(c = [];;)if (q.$isTabNode(e)) c.push(q.$createTabNode()), e = e.getNextSibling();
            else if (E(e)) {
                for(var h = 0, k = e.getTextContent(), l = e.getTextContentSize(); h < l && " " === k[h]; h++);
                0 !== h && c.push(F(" ".repeat(h)));
                if (h !== l) break;
                e = e.getNextSibling();
            } else break;
            e = b.splitText(f.offset)[0];
            h = 0 === f.offset ? 0 : 1;
            h = e.getIndexWithinParent() + h;
            k = b.getParentOrThrow();
            l = [
                q.$createLineBreakNode(),
                ...c
            ];
            k.splice(h, 0, l);
            (c = c[c.length - 1]) ? c.select() : 0 === f.offset ? e.selectPrevious() : e.getNextSibling().selectNext(0, 0);
        }
        G(b) && ({ offset: a } = a.anchor, b.splice(a, 0, [
            q.$createLineBreakNode()
        ]), b.select(a + 1, a + 1));
        return null;
    }
    canIndent() {
        return !1;
    }
    collapseAtStart() {
        let a = q.$createParagraphNode();
        this.getChildren().forEach((b)=>a.append(b));
        this.replace(a);
        return !0;
    }
    setLanguage(a) {
        this.getWritable().__language = v(a);
    }
    getLanguage() {
        return this.getLatest().__language;
    }
}
function C(a) {
    return q.$applyNodeReplacement(new y(a));
}
function G(a) {
    return a instanceof y;
}
function z(a) {
    let b;
    m.isHTMLElement(a) && (b = a.getAttribute("data-highlight-language"));
    return {
        node: C(b)
    };
}
function aa(a) {
    let b = null !== a.style.fontFamily.match("monospace");
    return b || da(a) ? {
        after: (c)=>{
            let e = a.parentNode;
            null != e && a !== e.lastChild && c.push(q.$createLineBreakNode());
            return c;
        },
        node: b ? C() : null
    } : {
        node: null
    };
}
function ba() {
    return {
        node: C()
    };
}
function B() {
    return {
        node: null
    };
}
function ca(a) {
    return {
        after: (b)=>{
            a.parentNode && a.parentNode.nextSibling && b.push(q.$createLineBreakNode());
            return b;
        },
        node: null
    };
}
function da(a) {
    for(a = a.parentElement; null !== a;){
        if (null !== a.style.fontFamily.match("monospace")) return !0;
        a = a.parentElement;
    }
    return !1;
}
function A(a) {
    return a.classList.contains("js-file-line-container");
}
let H = {
    c: "C",
    clike: "C-like",
    cpp: "C++",
    css: "CSS",
    html: "HTML",
    java: "Java",
    js: "JavaScript",
    markdown: "Markdown",
    objc: "Objective-C",
    plain: "Plain Text",
    py: "Python",
    rust: "Rust",
    sql: "SQL",
    swift: "Swift",
    typescript: "TypeScript",
    xml: "XML"
}, I = {
    cpp: "cpp",
    java: "java",
    javascript: "js",
    md: "markdown",
    plaintext: "plain",
    python: "py",
    text: "plain",
    ts: "typescript"
};
function K(a) {
    return I[a] || a;
}
class L extends q.TextNode {
    constructor(a, b, c){
        super(a, c);
        this.__highlightType = b;
    }
    static getType() {
        return "code-highlight";
    }
    static clone(a) {
        return new L(a.__text, a.__highlightType || void 0, a.__key);
    }
    getHighlightType() {
        return this.getLatest().__highlightType;
    }
    createDOM(a) {
        let b = super.createDOM(a);
        a = M(a.theme, this.__highlightType);
        m.addClassNamesToElement(b, a);
        return b;
    }
    updateDOM(a, b, c) {
        let e = super.updateDOM(a, b, c);
        a = M(c.theme, a.__highlightType);
        c = M(c.theme, this.__highlightType);
        a !== c && (a && m.removeClassNamesFromElement(b, a), c && m.addClassNamesToElement(b, c));
        return e;
    }
    static importJSON(a) {
        let b = F(a.text, a.highlightType);
        b.setFormat(a.format);
        b.setDetail(a.detail);
        b.setMode(a.mode);
        b.setStyle(a.style);
        return b;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            highlightType: this.getHighlightType(),
            type: "code-highlight",
            version: 1
        };
    }
    setFormat() {
        return this;
    }
    isParentRequired() {
        return !0;
    }
    createParentElementNode() {
        return C();
    }
}
function M(a, b) {
    return b && a && a.codeHighlight && a.codeHighlight[b];
}
function F(a, b) {
    return q.$applyNodeReplacement(new L(a, b));
}
function E(a) {
    return a instanceof L;
}
function D(a) {
    let b = a;
    for(; E(a) || q.$isTabNode(a);)b = a, a = a.getPreviousSibling();
    return b;
}
function N(a) {
    let b = a;
    for(; E(a) || q.$isTabNode(a);)b = a, a = a.getNextSibling();
    return b;
}
let O = {
    defaultLanguage: "javascript",
    tokenize (a, b) {
        return d.tokenize(a, d.languages[b || ""] || d.languages[this.defaultLanguage]);
    }
};
function P(a, b) {
    let c = null;
    var e = null, f = a;
    let g = b, h = a.getTextContent();
    for(;;){
        if (0 === g) {
            f = f.getPreviousSibling();
            if (null === f) break;
            if (!(E(f) || q.$isTabNode(f) || q.$isLineBreakNode(f))) throw Error("Expected a valid Code Node: CodeHighlightNode, TabNode, LineBreakNode");
            if (q.$isLineBreakNode(f)) {
                c = {
                    node: f,
                    offset: 1
                };
                break;
            }
            g = Math.max(0, f.getTextContentSize() - 1);
            h = f.getTextContent();
        } else g--;
        let k = h[g];
        E(f) && " " !== k && (e = {
            node: f,
            offset: g
        });
    }
    if (null !== e) return e;
    e = null;
    b < a.getTextContentSize() ? E(a) && (e = a.getTextContent()[b]) : (f = a.getNextSibling(), E(f) && (e = f.getTextContent()[0]));
    if (null !== e && " " !== e) return c;
    a: for(e = a, f = a.getTextContent(), a = a.getTextContentSize();;){
        if (!E(e) || b === a) {
            e = e.getNextSibling();
            if (null === e || q.$isLineBreakNode(e)) {
                a = null;
                break a;
            }
            E(e) && (b = 0, f = e.getTextContent(), a = e.getTextContentSize());
        }
        if (E(e)) {
            if (" " !== f[b]) {
                a = {
                    node: e,
                    offset: b
                };
                break a;
            }
            b++;
        }
    }
    return null !== a ? a : c;
}
function Q(a) {
    a = N(a);
    if (q.$isLineBreakNode(a)) throw Error("Unexpected lineBreakNode in getEndOfCodeInLine");
    return a;
}
function R(a, b, c) {
    let e = a.getParent();
    G(e) ? S(e, b, c) : E(a) && a.replace(q.$createTextNode(a.__text));
}
let T = new Set;
function S(a, b, c) {
    let e = a.getKey();
    T.has(e) || (T.add(e), void 0 === a.getLanguage() && a.setLanguage(c.defaultLanguage), b.update(()=>{
        ea(e, ()=>{
            var f = q.$getNodeByKey(e);
            if (!G(f) || !f.isAttached()) return !1;
            var g = f.getTextContent();
            g = c.tokenize(g, f.getLanguage() || c.defaultLanguage);
            g = U(g);
            var h = f.getChildren();
            for(f = 0; f < h.length && V(h[f], g[f]);)f++;
            var k = h.length;
            let l = g.length, r = Math.min(k, l) - f, n = 0;
            for(; n < r;)if (n++, !V(h[k - n], g[l - n])) {
                n--;
                break;
            }
            h = f;
            k -= n;
            g = g.slice(f, l - n);
            let { from: p, to: w, nodesForReplacement: u } = {
                from: h,
                nodesForReplacement: g,
                to: k
            };
            return p !== w || u.length ? (a.splice(p, w - p, u), !0) : !1;
        });
    }, {
        onUpdate: ()=>{
            T.delete(e);
        },
        skipTransforms: !0
    }));
}
function U(a, b) {
    let c = [];
    for (let e of a)if ("string" === typeof e) {
        a = e.split(/(\n|\t)/);
        let f = a.length;
        for(let g = 0; g < f; g++){
            let h = a[g];
            "\n" === h || "\r\n" === h ? c.push(q.$createLineBreakNode()) : "	" === h ? c.push(q.$createTabNode()) : 0 < h.length && c.push(F(h, b));
        }
    } else ({ content: a } = e), "string" === typeof a ? c.push(...U([
        a
    ], e.type)) : Array.isArray(a) && c.push(...U(a, e.type));
    return c;
}
function ea(a, b) {
    a = q.$getNodeByKey(a);
    if (G(a) && a.isAttached()) {
        var c = q.$getSelection();
        if (q.$isRangeSelection(c)) {
            c = c.anchor;
            var e = c.offset, f = "element" === c.type && q.$isLineBreakNode(a.getChildAtIndex(c.offset - 1)), g = 0;
            if (!f) {
                let h = c.getNode();
                g = e + h.getPreviousSiblings().reduce((k, l)=>k + l.getTextContentSize(), 0);
            }
            b() && (f ? c.getNode().select(e, e) : a.getChildren().some((h)=>{
                let k = q.$isTextNode(h);
                if (k || q.$isLineBreakNode(h)) {
                    let l = h.getTextContentSize();
                    if (k && l >= g) return h.select(g, g), !0;
                    g -= l;
                }
                return !1;
            }));
        } else b();
    }
}
function V(a, b) {
    return E(a) && E(b) && a.__text === b.__text && a.__highlightType === b.__highlightType || q.$isTabNode(a) && q.$isTabNode(b) || q.$isLineBreakNode(a) && q.$isLineBreakNode(b);
}
function W(a) {
    if (!q.$isRangeSelection(a)) return !1;
    var b = a.anchor.getNode();
    a = a.focus.getNode();
    if (b.is(a) && G(b)) return !0;
    b = b.getParent();
    return G(b) && b.is(a.getParent());
}
function X(a) {
    a = a.getNodes();
    let b = [
        []
    ];
    if (1 === a.length && G(a[0])) return b;
    let c = b[0];
    for(let e = 0; e < a.length; e++){
        let f = a[e];
        if (!(E(f) || q.$isTabNode(f) || q.$isLineBreakNode(f))) throw Error("Expected selection to be inside CodeBlock and consisting of CodeHighlightNode, TabNode and LineBreakNode");
        q.$isLineBreakNode(f) ? 0 !== e && 0 < c.length && (c = [], b.push(c)) : c.push(f);
    }
    return b;
}
function fa(a) {
    var b = q.$getSelection();
    if (!q.$isRangeSelection(b) || !W(b)) return null;
    let c = a ? q.OUTDENT_CONTENT_COMMAND : q.INDENT_CONTENT_COMMAND;
    a = a ? q.OUTDENT_CONTENT_COMMAND : q.INSERT_TAB_COMMAND;
    if (1 < X(b).length) return c;
    var e = b.getNodes()[0];
    if (!(G(e) || E(e) || q.$isTabNode(e) || q.$isLineBreakNode(e))) throw Error("Expected selection firstNode to be CodeHighlightNode or TabNode");
    if (G(e)) return c;
    let f = D(e);
    e = N(e);
    var g = b.anchor;
    let h = b.focus;
    h.isBefore(g) ? b = h : (b = g, g = h);
    return null !== f && null !== e && b.key === f.getKey() && 0 === b.offset && g.key === e.getKey() && g.offset === e.getTextContentSize() ? c : a;
}
function Y(a) {
    var b = q.$getSelection();
    if (!q.$isRangeSelection(b) || !W(b)) return !1;
    var c = X(b);
    let e = c.length;
    if (1 < c.length) {
        for(b = 0; b < e; b++){
            var f = c[b];
            0 < f.length && (f = f[0], 0 === b && (f = D(f)), null !== f && (a === q.INDENT_CONTENT_COMMAND ? f.insertBefore(q.$createTabNode()) : q.$isTabNode(f) && f.remove()));
        }
        return !0;
    }
    c = b.getNodes()[0];
    if (!(G(c) || E(c) || q.$isTabNode(c) || q.$isLineBreakNode(c))) throw Error("Expected selection firstNode to be CodeHighlightNode or CodeTabNode");
    if (G(c)) return a === q.INDENT_CONTENT_COMMAND && b.insertNodes([
        q.$createTabNode()
    ]), !0;
    c = D(c);
    if (null === c) throw Error("Expected getFirstCodeNodeOfLine to return a valid Code Node");
    a === q.INDENT_CONTENT_COMMAND ? q.$isLineBreakNode(c) ? c.insertAfter(q.$createTabNode()) : c.insertBefore(q.$createTabNode()) : q.$isTabNode(c) && c.remove();
    return !0;
}
function Z(a, b) {
    let c = q.$getSelection();
    if (!q.$isRangeSelection(c)) return !1;
    let { anchor: e, focus: f } = c, g = e.offset, h = f.offset, k = e.getNode(), l = f.getNode();
    var r = a === q.KEY_ARROW_UP_COMMAND;
    if (!W(c) || !E(k) && !q.$isTabNode(k) || !E(l) && !q.$isTabNode(l)) return !1;
    if (!b.altKey) {
        if (c.isCollapsed()) {
            if (a = k.getParentOrThrow(), r && 0 === g && null === k.getPreviousSibling()) {
                if (null === a.getPreviousSibling()) return a.selectPrevious(), b.preventDefault(), !0;
            } else if (!r && g === k.getTextContentSize() && null === k.getNextSibling() && null === a.getNextSibling()) return a.selectNext(), b.preventDefault(), !0;
        }
        return !1;
    }
    let n;
    if (k.isBefore(l)) {
        var p = D(k);
        n = N(l);
    } else p = D(l), n = N(k);
    if (null == p || null == n) return !1;
    let w = p.getNodesBetween(n);
    for(let t = 0; t < w.length; t++){
        let J = w[t];
        if (!E(J) && !q.$isTabNode(J) && !q.$isLineBreakNode(J)) return !1;
    }
    b.preventDefault();
    b.stopPropagation();
    b = r ? p.getPreviousSibling() : n.getNextSibling();
    if (!q.$isLineBreakNode(b)) return !0;
    p = r ? b.getPreviousSibling() : b.getNextSibling();
    if (null == p) return !0;
    r = E(p) || q.$isTabNode(p) || q.$isLineBreakNode(p) ? r ? D(p) : N(p) : null;
    let u = null != r ? r : p;
    b.remove();
    w.forEach((t)=>t.remove());
    a === q.KEY_ARROW_UP_COMMAND ? (w.forEach((t)=>u.insertBefore(t)), u.insertBefore(b)) : (u.insertAfter(b), u = b, w.forEach((t)=>{
        u.insertAfter(t);
        u = t;
    }));
    c.setTextNodeRange(k, g, l, h);
    return !0;
}
function ha(a, b) {
    let c = q.$getSelection();
    if (!q.$isRangeSelection(c)) return !1;
    let { anchor: e, focus: f } = c;
    var g = e.getNode();
    let h = f.getNode();
    a = a === q.MOVE_TO_START;
    if (!E(g) && !q.$isTabNode(g) || !E(h) && !q.$isTabNode(h)) return !1;
    if (a) {
        if (g = P(h, f.offset), null !== g) {
            let { node: k, offset: l } = g;
            q.$isLineBreakNode(k) ? k.selectNext(0, 0) : c.setTextNodeRange(k, l, k, l);
        } else h.getParentOrThrow().selectStart();
    } else Q(h).select();
    b.preventDefault();
    b.stopPropagation();
    return !0;
}
exports.$createCodeHighlightNode = F;
exports.$createCodeNode = C;
exports.$isCodeHighlightNode = E;
exports.$isCodeNode = G;
exports.CODE_LANGUAGE_FRIENDLY_NAME_MAP = H;
exports.CODE_LANGUAGE_MAP = I;
exports.CodeHighlightNode = L;
exports.CodeNode = y;
exports.DEFAULT_CODE_LANGUAGE = "javascript";
exports.PrismTokenizer = O;
exports.getCodeLanguages = ()=>Object.keys(d.languages).filter((a)=>"function" !== typeof d.languages[a]).sort();
exports.getDefaultCodeLanguage = ()=>"javascript";
exports.getEndOfCodeInLine = Q;
exports.getFirstCodeNodeOfLine = D;
exports.getLanguageFriendlyName = function(a) {
    a = K(a);
    return H[a] || a;
};
exports.getLastCodeNodeOfLine = N;
exports.getStartOfCodeInLine = P;
exports.normalizeCodeLang = K;
exports.registerCodeHighlighting = function(a, b) {
    if (!a.hasNodes([
        y,
        L
    ])) throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
    null == b && (b = O);
    return m.mergeRegister(a.registerMutationListener(y, (c)=>{
        a.update(()=>{
            for (let [g, h] of c)if ("destroyed" !== h) {
                var e = q.$getNodeByKey(g);
                if (null !== e) a: {
                    var f = e;
                    e = a.getElementByKey(f.getKey());
                    if (null === e) break a;
                    f = f.getChildren();
                    let k = f.length;
                    if (k === e.__cachedChildrenLength) break a;
                    e.__cachedChildrenLength = k;
                    let l = "1", r = 1;
                    for(let n = 0; n < k; n++)q.$isLineBreakNode(f[n]) && (l += "\n" + ++r);
                    e.setAttribute("data-gutter", l);
                }
            }
        });
    }), a.registerNodeTransform(y, (c)=>S(c, a, b)), a.registerNodeTransform(q.TextNode, (c)=>R(c, a, b)), a.registerNodeTransform(L, (c)=>R(c, a, b)), a.registerCommand(q.KEY_TAB_COMMAND, (c)=>{
        let e = fa(c.shiftKey);
        if (null === e) return !1;
        c.preventDefault();
        a.dispatchCommand(e, void 0);
        return !0;
    }, q.COMMAND_PRIORITY_LOW), a.registerCommand(q.INSERT_TAB_COMMAND, ()=>{
        let c = q.$getSelection();
        if (!W(c)) return !1;
        q.$insertNodes([
            q.$createTabNode()
        ]);
        return !0;
    }, q.COMMAND_PRIORITY_LOW), a.registerCommand(q.INDENT_CONTENT_COMMAND, ()=>Y(q.INDENT_CONTENT_COMMAND), q.COMMAND_PRIORITY_LOW), a.registerCommand(q.OUTDENT_CONTENT_COMMAND, ()=>Y(q.OUTDENT_CONTENT_COMMAND), q.COMMAND_PRIORITY_LOW), a.registerCommand(q.KEY_ARROW_UP_COMMAND, (c)=>Z(q.KEY_ARROW_UP_COMMAND, c), q.COMMAND_PRIORITY_LOW), a.registerCommand(q.KEY_ARROW_DOWN_COMMAND, (c)=>Z(q.KEY_ARROW_DOWN_COMMAND, c), q.COMMAND_PRIORITY_LOW), a.registerCommand(q.MOVE_TO_END, (c)=>ha(q.MOVE_TO_END, c), q.COMMAND_PRIORITY_LOW), a.registerCommand(q.MOVE_TO_START, (c)=>ha(q.MOVE_TO_START, c), q.COMMAND_PRIORITY_LOW));
};

},{"396460eb9a479a2e":"5qtcC","2b38c56a74784d02":"9NM2u","3c782d154ae5dbd7":"3hgZ5","fe77af35f85a949":"dBewF","189b9966e0ac081f":"bYiLP","b8279e37a0e10e5b":"eKmW4","12ebb08160f309a1":"dl3vp","98c5f5a665fdb73e":"f5M7Y","9745718cde28845d":"2aH4u","44f2f22f20f6b971":"e6OOH","d1d13af9c3743381":"bOged","5dd906ed9131dbc1":"7NJJC","190b1441465a6023":"02ZpH","b4b54facaf6c4c29":"lta95","e44e24f17235505a":"eIPyO","2cd1826e31d3d09f":"1V3L7","d5a7a7e74a00fcfc":"6uPvi"}],"5qtcC":[function(require,module,exports) {
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var global = arguments[3];
var _self = typeof window !== "undefined" ? window // if in browser
 : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case "Object":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case "Array":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return "none";
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, "gi"), "");
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add("language-" + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === "undefined") return null;
                if (document.currentScript && document.currentScript.tagName === "SCRIPT" && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName("script");
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = "no-" + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === "Object" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === "Array" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run("before-all-elements-highlight", env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre") _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
            }
            _.hooks.run("before-sanity-check", env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) parent.setAttribute("tabindex", "0");
            if (!env.code) {
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run("before-tokenize", env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run("after-tokenize", env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == "string") return o;
        if (Array.isArray(o)) {
            var s = "";
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + "," + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + "," + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}(_self);
if (0, module.exports) module.exports = Prism;
// hack for components to work correctly in node.js
if (typeof global !== "undefined") global.Prism = Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ Prism.languages.markup = {
    "comment": {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    "prolog": {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    "doctype": {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            "string": {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            "punctuation": /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            "name": /[^\s<>'"]+/
        }
    },
    "cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    "tag": {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            "tag": {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    "punctuation": /^<\/?/,
                    "namespace": /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    "punctuation": [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            "punctuation": /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    "namespace": /^[^\s>\/:]+:/
                }
            }
        }
    },
    "entity": [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
Prism.languages.markup["tag"].inside["attr-value"].inside["entity"] = Prism.languages.markup["entity"];
Prism.languages.markup["doctype"].inside["internal-subset"].inside = Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add("wrap", function(env) {
    if (env.type === "entity") env.attributes["title"] = env.content.replace(/&amp;/, "&");
});
Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside["language-" + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: Prism.languages[lang]
        };
        includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside["language-" + lang] = {
            pattern: /[\s\S]+/,
            inside: Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        Prism.languages.insertBefore("markup", "cdata", def);
    }
});
Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        "value": {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                "language-" + lang
                            ],
                            inside: Prism.languages[lang]
                        },
                        "punctuation": [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;
Prism.languages.xml = Prism.languages.extend("markup", {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        "comment": /\/\*[\s\S]*?\*\//,
        "atrule": {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + string.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                "rule": /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                "keyword": {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        "url": {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                "function": /^url/i,
                "punctuation": /^\(|\)$/,
                "string": {
                    pattern: RegExp("^" + string.source + "$"),
                    alias: "url"
                }
            }
        },
        "selector": {
            pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + string.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        "string": {
            pattern: string,
            greedy: true
        },
        "property": {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        "important": /!important\b/i,
        "function": {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        "punctuation": /[(){};:,]/
    };
    Prism.languages.css["atrule"].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined("style", "css");
        markup.tag.addAttribute("style", "css");
    }
})(Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ Prism.languages.clike = {
    "comment": [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    "string": {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            "punctuation": /[.\\]/
        }
    },
    "keyword": /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    "boolean": /\b(?:false|true)\b/,
    "function": /\b\w+(?=\()/,
    "number": /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    "operator": /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    "punctuation": /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ Prism.languages.javascript = Prism.languages.extend("clike", {
    "class-name": [
        Prism.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    "keyword": [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    "function": /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    "number": {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    "operator": /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore("javascript", "keyword", {
    "regex": {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: Prism.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    "parameter": [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    "constant": /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore("javascript", "string", {
    "hashbang": {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            "interpolation": {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: Prism.languages.javascript
                }
            },
            "string": /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
});
Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined("script", "javascript");
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript");
}
Prism.languages.js = Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof Prism === "undefined" || typeof document === "undefined") return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + " while fetching file: " + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        "js": "javascript",
        "py": "python",
        "rb": "ruby",
        "ps1": "powershell",
        "psm1": "powershell",
        "sh": "bash",
        "bat": "batch",
        "h": "c",
        "tex": "latex"
    };
    var STATUS_ATTR = "data-src-status";
    var STATUS_LOADING = "loading";
    var STATUS_LOADED = "loaded";
    var STATUS_FAILED = "failed";
    var SELECTOR = "pre[data-src]:not([" + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ":not([" + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || "");
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    Prism.hooks.add("before-highlightall", function(env) {
        env.selector += ", " + SELECTOR;
    });
    Prism.hooks.add("before-sanity-check", function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ""; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement("CODE"));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute("data-src");
            var language = env.language;
            if (language === "none") {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    "none"
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            Prism.util.setLanguage(code, language);
            Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute("data-range"));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join("\n");
                    // add data-start for line numbers
                    if (!pre.hasAttribute("data-start")) pre.setAttribute("data-start", String(start + 1));
                }
                // highlight code
                code.textContent = text;
                Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ Prism.fileHighlight = function() {
        if (!logged) {
            console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.");
            logged = true;
        }
        Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();

},{}],"9NM2u":[function(require,module,exports) {
Prism.languages.clike = {
    "comment": [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    "string": {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            "punctuation": /[.\\]/
        }
    },
    "keyword": /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    "boolean": /\b(?:false|true)\b/,
    "function": /\b\w+(?=\()/,
    "number": /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    "operator": /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    "punctuation": /[{}[\];(),.:]/
};

},{}],"3hgZ5":[function(require,module,exports) {
Prism.languages.javascript = Prism.languages.extend("clike", {
    "class-name": [
        Prism.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    "keyword": [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    "function": /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    "number": {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    "operator": /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore("javascript", "keyword", {
    "regex": {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: Prism.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    "parameter": [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    "constant": /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore("javascript", "string", {
    "hashbang": {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            "interpolation": {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: Prism.languages.javascript
                }
            },
            "string": /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
});
Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined("script", "javascript");
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript");
}
Prism.languages.js = Prism.languages.javascript;

},{}],"dBewF":[function(require,module,exports) {
Prism.languages.markup = {
    "comment": {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    "prolog": {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    "doctype": {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            "string": {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            "punctuation": /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            "name": /[^\s<>'"]+/
        }
    },
    "cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    "tag": {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            "tag": {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    "punctuation": /^<\/?/,
                    "namespace": /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    "punctuation": [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            "punctuation": /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    "namespace": /^[^\s>\/:]+:/
                }
            }
        }
    },
    "entity": [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
Prism.languages.markup["tag"].inside["attr-value"].inside["entity"] = Prism.languages.markup["entity"];
Prism.languages.markup["doctype"].inside["internal-subset"].inside = Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add("wrap", function(env) {
    if (env.type === "entity") env.attributes["title"] = env.content.replace(/&amp;/, "&");
});
Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside["language-" + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: Prism.languages[lang]
        };
        includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside["language-" + lang] = {
            pattern: /[\s\S]+/,
            inside: Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        Prism.languages.insertBefore("markup", "cdata", def);
    }
});
Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        "value": {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                "language-" + lang
                            ],
                            inside: Prism.languages[lang]
                        },
                        "punctuation": [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;
Prism.languages.xml = Prism.languages.extend("markup", {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;

},{}],"bYiLP":[function(require,module,exports) {
(function(Prism1) {
    // Allow only one line break
    var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    /**
	 * This function is intended for the creation of the bold or italic pattern.
	 *
	 * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
	 *
	 * _Note:_ Keep in mind that this adds a capturing group.
	 *
	 * @param {string} pattern
	 * @returns {RegExp}
	 */ function createInline(pattern) {
        pattern = pattern.replace(/<inner>/g, function() {
            return inner;
        });
        return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + pattern + ")");
    }
    var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
    var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return tableCell;
    });
    var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
    Prism1.languages.markdown = Prism1.languages.extend("markup", {});
    Prism1.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                "punctuation": /^---|---$/,
                "front-matter": {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        "yaml",
                        "language-yaml"
                    ],
                    inside: Prism1.languages.yaml
                }
            }
        },
        "blockquote": {
            // > ...
            pattern: /^>(?:[\t ]*>)*/m,
            alias: "punctuation"
        },
        "table": {
            pattern: RegExp("^" + tableRow + tableLine + "(?:" + tableRow + ")*", "m"),
            inside: {
                "table-data-rows": {
                    pattern: RegExp("^(" + tableRow + tableLine + ")(?:" + tableRow + ")*$"),
                    lookbehind: true,
                    inside: {
                        "table-data": {
                            pattern: RegExp(tableCell),
                            inside: Prism1.languages.markdown
                        },
                        "punctuation": /\|/
                    }
                },
                "table-line": {
                    pattern: RegExp("^(" + tableRow + ")" + tableLine + "$"),
                    lookbehind: true,
                    inside: {
                        "punctuation": /\||:?-{3,}:?/
                    }
                },
                "table-header-row": {
                    pattern: RegExp("^" + tableRow + "$"),
                    inside: {
                        "table-header": {
                            pattern: RegExp(tableCell),
                            alias: "important",
                            inside: Prism1.languages.markdown
                        },
                        "punctuation": /\|/
                    }
                }
            }
        },
        "code": [
            {
                // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: "keyword"
            },
            {
                // ```optional language
                // code block
                // ```
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    "code-block": {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    "code-language": {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    "punctuation": /```/
                }
            }
        ],
        "title": [
            {
                // title 1
                // =======
                // title 2
                // -------
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: "important",
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                // # title 1
                // ###### title 6
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: "important",
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        "hr": {
            // ***
            // ---
            // * * *
            // -----------
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "list": {
            // * item
            // + item
            // - item
            // 1. item
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "url-reference": {
            // [id]: http://example.com "Optional title"
            // [id]: http://example.com 'Optional title'
            // [id]: http://example.com (Optional title)
            // [id]: <http://example.com> "Optional title"
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                "variable": {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                "string": /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                "punctuation": /^[\[\]!:]|[<>]/
            },
            alias: "url"
        },
        "bold": {
            // **strong**
            // __strong__
            // allow one nested instance of italic text using the same delimiter
            pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                "content": {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {} // see below
                },
                "punctuation": /\*\*|__/
            }
        },
        "italic": {
            // *em*
            // _em_
            // allow one nested instance of bold text using the same delimiter
            pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                "content": {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {} // see below
                },
                "punctuation": /[*_]/
            }
        },
        "strike": {
            // ~~strike through~~
            // ~strike~
            // eslint-disable-next-line regexp/strict
            pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                "content": {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {} // see below
                },
                "punctuation": /~~?/
            }
        },
        "code-snippet": {
            // `code`
            // ``code``
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                "code",
                "keyword"
            ]
        },
        "url": {
            // [example](http://example.com "Optional title")
            // [example][id]
            // [example] [id]
            pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                "operator": /^!/,
                "content": {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {} // see below
                },
                "variable": {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                "url": {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                "string": {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    });
    [
        "url",
        "bold",
        "italic",
        "strike"
    ].forEach(function(token) {
        [
            "url",
            "bold",
            "italic",
            "strike",
            "code-snippet"
        ].forEach(function(inside) {
            if (token !== inside) Prism1.languages.markdown[token].inside.content.inside[inside] = Prism1.languages.markdown[inside];
        });
    });
    Prism1.hooks.add("after-tokenize", function(env) {
        if (env.language !== "markdown" && env.language !== "md") return;
        function walkTokens(tokens) {
            if (!tokens || typeof tokens === "string") return;
            for(var i = 0, l = tokens.length; i < l; i++){
                var token = tokens[i];
                if (token.type !== "code") {
                    walkTokens(token.content);
                    continue;
                }
                /*
				 * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
				 * is optional. But the grammar is defined so that there is only one case we have to handle:
				 *
				 * token.content = [
				 *     <span class="punctuation">```</span>,
				 *     <span class="code-language">xxxx</span>,
				 *     '\n', // exactly one new lines (\r or \n or \r\n)
				 *     <span class="code-block">...</span>,
				 *     '\n', // exactly one new lines again
				 *     <span class="punctuation">```</span>
				 * ];
				 */ var codeLang = token.content[1];
                var codeBlock = token.content[3];
                if (codeLang && codeBlock && codeLang.type === "code-language" && codeBlock.type === "code-block" && typeof codeLang.content === "string") {
                    // this might be a language that Prism does not support
                    // do some replacements to support C++, C#, and F#
                    var lang = codeLang.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
                    // only use the first word
                    lang = (/[a-z][\w-]*/i.exec(lang) || [
                        ""
                    ])[0].toLowerCase();
                    var alias = "language-" + lang;
                    // add alias
                    if (!codeBlock.alias) codeBlock.alias = [
                        alias
                    ];
                    else if (typeof codeBlock.alias === "string") codeBlock.alias = [
                        codeBlock.alias,
                        alias
                    ];
                    else codeBlock.alias.push(alias);
                }
            }
        }
        walkTokens(env.tokens);
    });
    Prism1.hooks.add("wrap", function(env) {
        if (env.type !== "code-block") return;
        var codeLang = "";
        for(var i = 0, l = env.classes.length; i < l; i++){
            var cls = env.classes[i];
            var match = /language-(.+)/.exec(cls);
            if (match) {
                codeLang = match[1];
                break;
            }
        }
        var grammar = Prism1.languages[codeLang];
        if (!grammar) {
            if (codeLang && codeLang !== "none" && Prism1.plugins.autoloader) {
                var id = "md-" + new Date().valueOf() + "-" + Math.floor(Math.random() * 1e16);
                env.attributes["id"] = id;
                Prism1.plugins.autoloader.loadLanguages(codeLang, function() {
                    var ele = document.getElementById(id);
                    if (ele) ele.innerHTML = Prism1.highlight(ele.textContent, Prism1.languages[codeLang], codeLang);
                });
            }
        } else env.content = Prism1.highlight(textContent(env.content), grammar, codeLang);
    });
    var tagPattern = RegExp(Prism1.languages.markup.tag.pattern.source, "gi");
    /**
	 * A list of known entity names.
	 *
	 * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
	 *
	 * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
	 */ var KNOWN_ENTITY_NAMES = {
        "amp": "&",
        "lt": "<",
        "gt": ">",
        "quot": '"'
    };
    // IE 11 doesn't support `String.fromCodePoint`
    var fromCodePoint = String.fromCodePoint || String.fromCharCode;
    /**
	 * Returns the text content of a given HTML source code string.
	 *
	 * @param {string} html
	 * @returns {string}
	 */ function textContent(html) {
        // remove all tags
        var text = html.replace(tagPattern, "");
        // decode known entities
        text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
            code = code.toLowerCase();
            if (code[0] === "#") {
                var value;
                if (code[1] === "x") value = parseInt(code.slice(2), 16);
                else value = Number(code.slice(1));
                return fromCodePoint(value);
            } else {
                var known = KNOWN_ENTITY_NAMES[code];
                if (known) return known;
                // unable to decode
                return m;
            }
        });
        return text;
    }
    Prism1.languages.md = Prism1.languages.markdown;
})(Prism);

},{}],"eKmW4":[function(require,module,exports) {
Prism.languages.c = Prism.languages.extend("clike", {
    "comment": {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    "string": {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    "keyword": /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    "function": /\b[a-z_]\w*(?=\s*\()/i,
    "number": /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    "operator": />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});
Prism.languages.insertBefore("c", "string", {
    "char": {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
});
Prism.languages.insertBefore("c", "string", {
    "macro": {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: "property",
        inside: {
            "string": [
                {
                    // highlight the path of the include statement as a string
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                Prism.languages.c["string"]
            ],
            "char": Prism.languages.c["char"],
            "comment": Prism.languages.c["comment"],
            "macro-name": [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: "function"
                }
            ],
            // highlight macro directives as keywords
            "directive": {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: "keyword"
            },
            "directive-hash": /^#/,
            "punctuation": /##|\\(?=[\r\n])/,
            "expression": {
                pattern: /\S[\s\S]*/,
                inside: Prism.languages.c
            }
        }
    }
});
Prism.languages.insertBefore("c", "function", {
    // highlight predefined macros as constants
    "constant": /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});
delete Prism.languages.c["boolean"];

},{}],"dl3vp":[function(require,module,exports) {
(function(Prism1) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism1.languages.css = {
        "comment": /\/\*[\s\S]*?\*\//,
        "atrule": {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + string.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                "rule": /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                "keyword": {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        "url": {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                "function": /^url/i,
                "punctuation": /^\(|\)$/,
                "string": {
                    pattern: RegExp("^" + string.source + "$"),
                    alias: "url"
                }
            }
        },
        "selector": {
            pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + string.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        "string": {
            pattern: string,
            greedy: true
        },
        "property": {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        "important": /!important\b/i,
        "function": {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        "punctuation": /[(){};:,]/
    };
    Prism1.languages.css["atrule"].inside.rest = Prism1.languages.css;
    var markup = Prism1.languages.markup;
    if (markup) {
        markup.tag.addInlined("style", "css");
        markup.tag.addAttribute("style", "css");
    }
})(Prism);

},{}],"f5M7Y":[function(require,module,exports) {
Prism.languages.objectivec = Prism.languages.extend("c", {
    "string": {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "keyword": /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    "operator": /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});
delete Prism.languages.objectivec["class-name"];
Prism.languages.objc = Prism.languages.objectivec;

},{}],"2aH4u":[function(require,module,exports) {
Prism.languages.sql = {
    "comment": {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    "variable": [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    "string": {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    "identifier": {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            "punctuation": /^`|`$/
        }
    },
    "function": /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    "keyword": /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    "boolean": /\b(?:FALSE|NULL|TRUE)\b/i,
    "number": /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    "operator": /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    "punctuation": /[;[\]()`,.]/
};

},{}],"e6OOH":[function(require,module,exports) {
Prism.languages.python = {
    "comment": {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            "interpolation": {
                // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            "string": /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    "string": {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    "function": {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    "decorator": {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            "punctuation": /\./
        }
    },
    "keyword": /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    "builtin": /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    "boolean": /\b(?:False|None|True)\b/,
    "number": /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    "operator": /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    "punctuation": /[{}[\];(),.:]/
};
Prism.languages.python["string-interpolation"].inside["interpolation"].inside.rest = Prism.languages.python;
Prism.languages.py = Prism.languages.python;

},{}],"bOged":[function(require,module,exports) {
(function(Prism1) {
    var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
    for(var i = 0; i < 2; i++)// support 4 levels of nested comments
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return multilineComment;
    });
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    });
    Prism1.languages.rust = {
        "comment": [
            {
                pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        "string": {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        "char": {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        "attribute": {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                "string": null // see below
            }
        },
        // Closure params should not be confused with bitwise OR |
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null // see below
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        "variable": /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    "punctuation": /::/
                }
            }
        ],
        "keyword": [
            // https://github.com/rust-lang/reference/blob/master/src/keywords.md
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            // primitives and str
            // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
        // and Rust's naming conventions recommend snake_case anyway.
        // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
        "function": /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        "macro": {
            pattern: /\b\w+!/,
            alias: "property"
        },
        "constant": /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        "namespace": {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                "punctuation": /::/
            }
        },
        // Hex, oct, bin, dec numbers with visual separators and type suffix
        "number": /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        "boolean": /\b(?:false|true)\b/,
        "punctuation": /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        "operator": /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    };
    Prism1.languages.rust["closure-params"].inside.rest = Prism1.languages.rust;
    Prism1.languages.rust["attribute"].inside["string"] = Prism1.languages.rust["string"];
})(Prism);

},{}],"7NJJC":[function(require,module,exports) {
Prism.languages.swift = {
    "comment": {
        // Nested comments are supported up to 2 levels
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    "string-literal": [
        // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
        {
            pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                "interpolation": {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null // see below
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\\($/,
                    alias: "punctuation"
                },
                "punctuation": /\\(?=[\r\n])/,
                "string": /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")" + "\\2"),
            lookbehind: true,
            greedy: true,
            inside: {
                "interpolation": {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null // see below
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\#+\($/,
                    alias: "punctuation"
                },
                "string": /[\s\S]+/
            }
        }
    ],
    "directive": {
        // directives with conditions
        pattern: RegExp(/#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"),
        alias: "property",
        inside: {
            "directive-name": /^#\w+/,
            "boolean": /\b(?:false|true)\b/,
            "number": /\b\d+(?:\.\d+)*\b/,
            "operator": /!|&&|\|\||[<>]=?/,
            "punctuation": /[(),]/
        }
    },
    "literal": {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
    },
    "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
    },
    "attribute": {
        pattern: /@\w+/,
        alias: "atrule"
    },
    "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: "function"
    },
    "label": {
        // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: "important"
    },
    "keyword": /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    "boolean": /\b(?:false|true)\b/,
    "nil": {
        pattern: /\bnil\b/,
        alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    "omit": {
        pattern: /\b_\b/,
        alias: "keyword"
    },
    "number": /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    "function": /\b[a-z_]\w*(?=\s*\()/i,
    "constant": /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
    // This regex only supports ASCII operators.
    "operator": /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    "punctuation": /[{}[\]();,.:\\]/
};
Prism.languages.swift["string-literal"].forEach(function(rule) {
    rule.inside["interpolation"].inside = Prism.languages.swift;
});

},{}],"02ZpH":[function(require,module,exports) {
(function(Prism1) {
    Prism1.languages.typescript = Prism1.languages.extend("javascript", {
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        "builtin": /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    });
    // The keywords TypeScript adds to JavaScript
    Prism1.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.typescript["parameter"];
    delete Prism1.languages.typescript["literal-property"];
    // a version of typescript specifically for highlighting types
    var typeInside = Prism1.languages.extend("typescript", {});
    delete typeInside["class-name"];
    Prism1.languages.typescript["class-name"].inside = typeInside;
    Prism1.languages.insertBefore("typescript", "function", {
        "decorator": {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                "at": {
                    pattern: /^@/,
                    alias: "operator"
                },
                "function": /^[\s\S]+/
            }
        },
        "generic-function": {
            // e.g. foo<T extends "bar" | "baz">( ...
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                "function": /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                "generic": {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: typeInside
                }
            }
        }
    });
    Prism1.languages.ts = Prism1.languages.typescript;
})(Prism);

},{}],"lta95":[function(require,module,exports) {
(function(Prism1) {
    var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;
    // full package (optional) + parent classes (optional)
    var classNamePrefix = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
    // based on the java naming conventions
    var className = {
        pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: true,
        inside: {
            "namespace": {
                pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                inside: {
                    "punctuation": /\./
                }
            },
            "punctuation": /\./
        }
    };
    Prism1.languages.java = Prism1.languages.extend("clike", {
        "string": {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
            lookbehind: true,
            greedy: true
        },
        "class-name": [
            className,
            {
                // variables, parameters, and constructor references
                // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
                lookbehind: true,
                inside: className.inside
            },
            {
                // class names based on keyword
                // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + classNamePrefix + /[A-Z]\w*\b/.source),
                lookbehind: true,
                inside: className.inside
            }
        ],
        "keyword": keywords,
        "function": [
            Prism1.languages.clike.function,
            {
                pattern: /(::\s*)[a-z_]\w*/,
                lookbehind: true
            }
        ],
        "number": /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
        "operator": {
            pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
            lookbehind: true
        },
        "constant": /\b[A-Z][A-Z_\d]+\b/
    });
    Prism1.languages.insertBefore("java", "string", {
        "triple-quoted-string": {
            // http://openjdk.java.net/jeps/355#Description
            pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
            greedy: true,
            alias: "string"
        },
        "char": {
            pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
            greedy: true
        }
    });
    Prism1.languages.insertBefore("java", "class-name", {
        "annotation": {
            pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
            lookbehind: true,
            alias: "punctuation"
        },
        "generics": {
            pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
            inside: {
                "class-name": className,
                "keyword": keywords,
                "punctuation": /[<>(),.:]/,
                "operator": /[?&|]/
            }
        },
        "import": [
            {
                pattern: RegExp(/(\bimport\s+)/.source + classNamePrefix + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
                lookbehind: true,
                inside: {
                    "namespace": className.inside.namespace,
                    "punctuation": /\./,
                    "operator": /\*/,
                    "class-name": /\w+/
                }
            },
            {
                pattern: RegExp(/(\bimport\s+static\s+)/.source + classNamePrefix + /(?:\w+|\*)(?=\s*;)/.source),
                lookbehind: true,
                alias: "static",
                inside: {
                    "namespace": className.inside.namespace,
                    "static": /\b\w+$/,
                    "punctuation": /\./,
                    "operator": /\*/,
                    "class-name": /\w+/
                }
            }
        ],
        "namespace": {
            pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
                return keywords.source;
            })),
            lookbehind: true,
            inside: {
                "punctuation": /\./
            }
        }
    });
})(Prism);

},{}],"eIPyO":[function(require,module,exports) {
(function(Prism1) {
    var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
    var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return keyword.source;
    });
    Prism1.languages.cpp = Prism1.languages.extend("c", {
        "class-name": [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return keyword.source;
                })),
                lookbehind: true
            },
            // This is intended to capture the class name of method implementations like:
            //   void foo::bar() const {}
            // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
            // it starts with an uppercase letter. This approximation should give decent results.
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            // This will capture the class name before destructors like:
            //   Foo::~Foo() {}
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            // This also intends to capture the class name of method implementations but here the class has template
            // parameters, so it can't be a namespace (until C++ adds generic namespaces).
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        "keyword": keyword,
        "number": {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        "operator": />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        "boolean": /\b(?:false|true)\b/
    });
    Prism1.languages.insertBefore("cpp", "string", {
        "module": {
            // https://en.cppreference.com/w/cpp/language/modules
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + // header-name
            /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
            /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return modName;
            }) + ")"),
            lookbehind: true,
            greedy: true,
            inside: {
                "string": /^[<"][\s\S]+/,
                "operator": /:/,
                "punctuation": /\./
            }
        },
        "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: true
        }
    });
    Prism1.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                "function": /^\w+/,
                "generic": {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: Prism1.languages.cpp
                }
            }
        }
    });
    Prism1.languages.insertBefore("cpp", "operator", {
        "double-colon": {
            pattern: /::/,
            alias: "punctuation"
        }
    });
    Prism1.languages.insertBefore("cpp", "class-name", {
        // the base clause is an optional list of parent classes
        // https://en.cppreference.com/w/cpp/language/class
        "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: Prism1.languages.extend("cpp", {})
        }
    });
    Prism1.languages.insertBefore("inside", "double-colon", {
        // All untokenized words that are not namespaces should be class names
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, Prism1.languages.cpp["base-clause"]);
})(Prism);

},{}],"1V3L7":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalUtils = require("2a44a40a3b8143e5");
module.exports = LexicalUtils;

},{"2a44a40a3b8143e5":"aFOUk"}],"aFOUk":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var h = require("fe5c872c1d635e66"), B = require("89e9cf141ab7facc");
function C(a) {
    let b = new URLSearchParams;
    b.append("code", a);
    for(let c = 1; c < arguments.length; c++)b.append("v", arguments[c]);
    throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?${b} for the full message or ` + "use the non-minified dev environment for full errors and additional helpful warnings.");
}
function D(...a) {
    return ()=>{
        a.forEach((b)=>b());
    };
}
let E = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
};
function F(a, b, c) {
    function e() {
        if (null === g) throw Error("Unexpected null rootDOMNode");
        if (null === n) throw Error("Unexpected null parentDOMNode");
        let { left: p, top: z } = g.getBoundingClientRect();
        var q = n;
        let r = h.createRectsFromDOMRange(a, b);
        t.isConnected || q.append(t);
        q = !1;
        for(let x = 0; x < r.length; x++){
            var w = r[x];
            let u = k[x] || document.createElement("div"), y = u.style;
            "absolute" !== y.position && (y.position = "absolute", q = !0);
            var l = `${w.left - p}px`;
            y.left !== l && (y.left = l, q = !0);
            l = `${w.top - z}px`;
            y.top !== l && (u.style.top = l, q = !0);
            l = `${w.width}px`;
            y.width !== l && (u.style.width = l, q = !0);
            w = `${w.height}px`;
            y.height !== w && (u.style.height = w, q = !0);
            u.parentNode !== t && (t.append(u), q = !0);
            k[x] = u;
        }
        for(; k.length > r.length;)k.pop();
        q && c(k);
    }
    function d() {
        g = n = null;
        null !== m && m.disconnect();
        m = null;
        t.remove();
        for (let p of k)p.remove();
        k = [];
    }
    function f() {
        let p = a.getRootElement();
        if (null === p) return d();
        let z = p.parentElement;
        if (!(z instanceof HTMLElement)) return d();
        d();
        g = p;
        n = z;
        m = new MutationObserver((q)=>{
            let r = a.getRootElement(), w = r && r.parentElement;
            if (r !== g || w !== n) return f();
            for (let l of q)if (!t.contains(l.target)) return e();
        });
        m.observe(z, E);
        e();
    }
    let g = null, n = null, m = null, k = [], t = document.createElement("div"), A = a.registerRootListener(f);
    return ()=>{
        A();
        d();
    };
}
function G(a, b) {
    for (let c of b)if (a.type.startsWith(c)) return !0;
    return !1;
}
let H = (a, b)=>{
    for(; a !== B.$getRoot() && null != a;){
        if (b(a)) return a;
        a = a.getParent();
    }
    return null;
};
exports.$splitNode = B.$splitNode;
exports.isHTMLAnchorElement = B.isHTMLAnchorElement;
exports.isHTMLElement = B.isHTMLElement;
exports.$dfs = function(a, b) {
    let c = [];
    a = (a || B.$getRoot()).getLatest();
    b = b || (B.$isElementNode(a) ? a.getLastDescendant() : a);
    for(var e = a, d = 0; null !== (e = e.getParent());)d++;
    for(e = d; null !== a && !a.is(b);)if (c.push({
        depth: e,
        node: a
    }), B.$isElementNode(a) && 0 < a.getChildrenSize()) a = a.getFirstChild(), e++;
    else for(d = null; null === d && null !== a;)d = a.getNextSibling(), null === d ? (a = a.getParent(), e--) : a = d;
    null !== a && a.is(b) && c.push({
        depth: e,
        node: a
    });
    return c;
};
exports.$filter = function(a, b) {
    let c = [];
    for(let e = 0; e < a.length; e++){
        let d = b(a[e]);
        null !== d && c.push(d);
    }
    return c;
};
exports.$findMatchingParent = H;
exports.$getNearestBlockElementAncestorOrThrow = function(a) {
    let b = H(a, (c)=>B.$isElementNode(c) && !c.isInline());
    B.$isElementNode(b) || C(4, a.__key);
    return b;
};
exports.$getNearestNodeOfType = function(a, b) {
    for(; null != a;){
        if (a instanceof b) return a;
        a = a.getParent();
    }
    return null;
};
exports.$insertFirst = function(a, b) {
    let c = a.getFirstChild();
    null !== c ? c.insertBefore(b) : a.append(b);
};
exports.$insertNodeToNearestRoot = function(a) {
    var b = B.$getSelection() || B.$getPreviousSelection();
    if (B.$isRangeSelection(b)) {
        var { focus: c } = b;
        b = c.getNode();
        c = c.offset;
        if (B.$isRootOrShadowRoot(b)) c = b.getChildAtIndex(c), null == c ? b.append(a) : c.insertBefore(a), a.selectNext();
        else {
            let e, d;
            B.$isTextNode(b) ? (e = b.getParentOrThrow(), d = b.getIndexWithinParent(), 0 < c && (d += 1, b.splitText(c))) : (e = b, d = c);
            [, b] = B.$splitNode(e, d);
            b.insertBefore(a);
            b.selectStart();
        }
    } else null != b ? (b = b.getNodes(), b[b.length - 1].getTopLevelElementOrThrow().insertAfter(a)) : B.$getRoot().append(a), b = B.$createParagraphNode(), a.insertAfter(b), b.select();
    return a.getLatest();
};
exports.$restoreEditorState = function(a, b) {
    let c = new Map, e = a._pendingEditorState;
    for (let [d, f] of b._nodeMap){
        let g = h.$cloneWithProperties(f);
        if (B.$isTextNode(g)) {
            if (!B.$isTextNode(f)) throw Error("Expected node be a TextNode");
            g.__text = f.__text;
        }
        c.set(d, g);
    }
    e && (e._nodeMap = c);
    a._dirtyType = 2;
    a = b._selection;
    B.$setSelection(null === a ? null : a.clone());
};
exports.$wrapNodeInElement = function(a, b) {
    b = b();
    a.replace(b);
    b.append(a);
    return b;
};
exports.addClassNamesToElement = function(a, ...b) {
    b.forEach((c)=>{
        "string" === typeof c && (c = c.split(" ").filter((e)=>"" !== e), a.classList.add(...c));
    });
};
exports.isMimeType = G;
exports.markSelection = function(a, b) {
    function c(m) {
        m.read(()=>{
            var k = B.$getSelection();
            if (B.$isRangeSelection(k)) {
                var { anchor: t, focus: A } = k;
                k = t.getNode();
                var p = k.getKey(), z = t.offset, q = A.getNode(), r = q.getKey(), w = A.offset, l = a.getElementByKey(p), x = a.getElementByKey(r);
                p = null === e || null === l || z !== d || p !== e.getKey() || k !== e && (!(e instanceof B.TextNode) || k.updateDOM(e, l, a._config));
                r = null === f || null === x || w !== g || r !== f.getKey() || q !== f && (!(f instanceof B.TextNode) || q.updateDOM(f, x, a._config));
                if (p || r) {
                    l = a.getElementByKey(t.getNode().getKey());
                    var u = a.getElementByKey(A.getNode().getKey());
                    if (null !== l && null !== u && "SPAN" === l.tagName && "SPAN" === u.tagName) {
                        r = document.createRange();
                        A.isBefore(t) ? (p = u, x = A.offset, u = l, l = t.offset) : (p = l, x = t.offset, l = A.offset);
                        p = p.firstChild;
                        if (null === p) throw Error("Expected text node to be first child of span");
                        u = u.firstChild;
                        if (null === u) throw Error("Expected text node to be first child of span");
                        r.setStart(p, x);
                        r.setEnd(u, l);
                        n();
                        n = F(a, r, (y)=>{
                            for (let I of y){
                                let v = I.style;
                                "Highlight" !== v.background && (v.background = "Highlight");
                                "HighlightText" !== v.color && (v.color = "HighlightText");
                                "-1" !== v.zIndex && (v.zIndex = "-1");
                                "none" !== v.pointerEvents && (v.pointerEvents = "none");
                                "-1.5px" !== v.marginTop && (v.marginTop = "-1.5px");
                                "4px" !== v.paddingTop && (v.paddingTop = "4px");
                                "0px" !== v.paddingBottom && (v.paddingBottom = "0px");
                            }
                            void 0 !== b && b(y);
                        });
                    }
                }
                e = k;
                d = z;
                f = q;
                g = w;
            } else g = f = d = e = null, n(), n = ()=>{};
        });
    }
    let e = null, d = null, f = null, g = null, n = ()=>{};
    c(a.getEditorState());
    return D(a.registerUpdateListener(({ editorState: m })=>c(m)), n, ()=>{
        n();
    });
};
exports.mediaFileReader = function(a, b) {
    let c = a[Symbol.iterator]();
    return new Promise((e, d)=>{
        let f = [], g = ()=>{
            const { done: n, value: m } = c.next();
            if (n) return e(f);
            const k = new FileReader;
            k.addEventListener("error", d);
            k.addEventListener("load", ()=>{
                const t = k.result;
                "string" === typeof t && f.push({
                    file: m,
                    result: t
                });
                g();
            });
            G(m, b) ? k.readAsDataURL(m) : g();
        };
        g();
    });
};
exports.mergeRegister = D;
exports.objectKlassEquals = function(a, b) {
    return null !== a ? Object.getPrototypeOf(a).constructor.name === b.name : !1;
};
exports.positionNodeOnRange = F;
exports.registerNestedElementResolver = function(a, b, c, e) {
    return a.registerNodeTransform(b, (d)=>{
        a: {
            var f = d.getChildren();
            for(var g = 0; g < f.length; g++)if (f[g] instanceof b) {
                f = null;
                break a;
            }
            for(f = d; null !== f;)if (g = f, f = f.getParent(), f instanceof b) {
                f = {
                    child: g,
                    parent: f
                };
                break a;
            }
            f = null;
        }
        if (null !== f) {
            const { child: n, parent: m } = f;
            if (n.is(d)) {
                e(m, d);
                d = n.getNextSiblings();
                f = d.length;
                m.insertAfter(n);
                if (0 !== f) {
                    g = c(m);
                    n.insertAfter(g);
                    for(let k = 0; k < f; k++)g.append(d[k]);
                }
                m.canBeEmpty() || 0 !== m.getChildrenSize() || m.remove();
            }
        }
    });
};
exports.removeClassNamesFromElement = function(a, ...b) {
    b.forEach((c)=>{
        "string" === typeof c && a.classList.remove(...c.split(" "));
    });
};

},{"fe5c872c1d635e66":"57ffa","89e9cf141ab7facc":"6uPvi"}],"57ffa":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalSelection = require("6213c68781f143e7");
module.exports = LexicalSelection;

},{"6213c68781f143e7":"2a9Ww"}],"2a9Ww":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var k = require("df166b333087fd4d");
let u = new Map;
function v(a) {
    for(; null != a;){
        if (a.nodeType === Node.TEXT_NODE) return a;
        a = a.firstChild;
    }
    return null;
}
function w(a) {
    let b = a.parentNode;
    if (null == b) throw Error("Should never happen");
    return [
        b,
        Array.from(b.childNodes).indexOf(a)
    ];
}
function y(a) {
    let b = {};
    a = a.split(";");
    for (let d of a)if ("" !== d) {
        let [e, c] = d.split(/:([^]+)/);
        e && c && (b[e.trim()] = c.trim());
    }
    return b;
}
function z(a) {
    let b = u.get(a);
    void 0 === b && (b = y(a), u.set(a, b));
    return b;
}
function A(a) {
    let b = "";
    for(let d in a)d && (b += `${d}: ${a[d]};`);
    return b;
}
function B(a, b) {
    var d = z("getStyle" in a ? a.getStyle() : a.style);
    b = Object.entries(b).reduce((e, [c, f])=>{
        null === f ? delete e[c] : e[c] = f;
        return e;
    }, {
        ...d
    });
    d = A(b);
    a.setStyle(d);
    u.set(d, b);
}
function C(a, b) {
    var d = a.getNodes(), e = d.length;
    if (k.$isRangeSelection(a)) {
        --e;
        var c = d[0], f = d[e];
        if (a.isCollapsed() && k.$isRangeSelection(a)) B(a, b);
        else {
            var h = a.anchor, g = a.focus, l = c.getTextContent().length, n = g.offset, q = h.offset, p = h.isBefore(g), m = p ? q : n;
            a = p ? n : q;
            var r = p ? h.type : g.type, t = p ? g.type : h.type;
            g = p ? g.key : h.key;
            k.$isTextNode(c) && m === l && (p = c.getNextSibling(), k.$isTextNode(p) && (m = q = 0, c = p));
            if (1 === d.length) k.$isTextNode(c) && (m = "element" === r ? 0 : q > n ? n : q, a = "element" === t ? l : q > n ? q : n, m !== a && (0 === m && a === l ? (B(c, b), c.select(m, a)) : (d = c.splitText(m, a), d = 0 === m ? d[0] : d[1], B(d, b), d.select(0, a - m))));
            else for(k.$isTextNode(c) && m < c.getTextContentSize() && (0 !== m && (c = c.splitText(m)[1], m = 0, h.set(c.getKey(), m, "text")), B(c, b)), k.$isTextNode(f) && (m = f.getTextContent().length, f.__key !== g && 0 !== a && (a = m), a !== m && ([f] = f.splitText(a)), 0 !== a && B(f, b)), a = 1; a < e; a++)m = d[a], h = m.getKey(), k.$isTextNode(m) && h !== c.getKey() && h !== f.getKey() && !m.isToken() && B(m, b);
        }
    } else {
        c = k.$createRangeSelection();
        f = c.anchor;
        m = c.focus;
        for(h = 0; h < e; h++)l = d[h], k.DEPRECATED_$isGridCellNode(l) && (f.set(l.getKey(), 0, "element"), m.set(l.getKey(), l.getChildrenSize(), "element"), C(k.$normalizeSelection__EXPERIMENTAL(c), b));
        k.$setSelection(a);
    }
}
function D(a) {
    for(; null !== a && !k.$isRootOrShadowRoot(a);){
        let b = a.getLatest(), d = a.getParent();
        0 === b.getChildrenSize() && a.remove(!0);
        a = d;
    }
}
function E(a, b, d, e, c = null) {
    if (0 !== b.length) {
        var f = b[0], h = new Map, g = [];
        f = k.$isElementNode(f) ? f : f.getParentOrThrow();
        f.isInline() && (f = f.getParentOrThrow());
        for(var l = !1; null !== f;){
            var n = f.getPreviousSibling();
            if (null !== n) {
                f = n;
                l = !0;
                break;
            }
            f = f.getParentOrThrow();
            if (k.$isRootOrShadowRoot(f)) break;
        }
        n = new Set;
        for(var q = 0; q < d; q++){
            var p = b[q];
            k.$isElementNode(p) && 0 === p.getChildrenSize() && n.add(p.getKey());
        }
        var m = new Set;
        for(q = 0; q < d; q++){
            p = b[q];
            var r = p.getParent();
            null !== r && r.isInline() && (r = r.getParent());
            if (null !== r && k.$isLeafNode(p) && !m.has(p.getKey())) {
                if (p = r.getKey(), void 0 === h.get(p)) {
                    let t = e();
                    t.setFormat(r.getFormatType());
                    t.setIndent(r.getIndent());
                    g.push(t);
                    h.set(p, t);
                    r.getChildren().forEach((x)=>{
                        t.append(x);
                        m.add(x.getKey());
                        k.$isElementNode(x) && x.getChildrenKeys().forEach((I)=>m.add(I));
                    });
                    D(r);
                }
            } else if (n.has(p.getKey())) {
                if (!k.$isElementNode(p)) throw Error("Expected node in emptyElements to be an ElementNode");
                r = e();
                r.setFormat(p.getFormatType());
                r.setIndent(p.getIndent());
                g.push(r);
                p.remove(!0);
            }
        }
        if (null !== c) for(b = 0; b < g.length; b++)c.append(g[b]);
        b = null;
        if (k.$isRootOrShadowRoot(f)) {
            if (l) {
                if (null !== c) f.insertAfter(c);
                else for(c = g.length - 1; 0 <= c; c--)f.insertAfter(g[c]);
            } else if (l = f.getFirstChild(), k.$isElementNode(l) && (f = l), null === l) {
                if (c) f.append(c);
                else for(c = 0; c < g.length; c++)l = g[c], f.append(l), b = l;
            } else if (null !== c) l.insertBefore(c);
            else for(f = 0; f < g.length; f++)c = g[f], l.insertBefore(c), b = c;
        } else if (c) f.insertAfter(c);
        else for(c = g.length - 1; 0 <= c; c--)l = g[c], f.insertAfter(l), b = l;
        g = k.$getPreviousSelection();
        k.$isRangeSelection(g) && g.anchor.getNode().isAttached() && g.focus.getNode().isAttached() ? k.$setSelection(g.clone()) : null !== b ? b.selectEnd() : a.dirty = !0;
    }
}
function F(a, b, d, e) {
    a.modify(b ? "extend" : "move", d, e);
}
function G(a) {
    a = a.anchor.getNode();
    return "rtl" === (k.$isRootNode(a) ? a : a.getParentOrThrow()).getDirection();
}
function H(a) {
    if (k.$isDecoratorNode(a) && !a.isInline()) return !0;
    if (!k.$isElementNode(a) || k.$isRootOrShadowRoot(a)) return !1;
    var b = a.getFirstChild();
    b = null === b || k.$isLineBreakNode(b) || k.$isTextNode(b) || b.isInline();
    return !a.isInline() && !1 !== a.canBeEmpty() && b;
}
exports.$addNodeStyle = function(a) {
    a = a.getStyle();
    let b = y(a);
    u.set(a, b);
};
exports.$cloneWithProperties = function(a) {
    let b = a.constructor.clone(a);
    b.__parent = a.__parent;
    b.__next = a.__next;
    b.__prev = a.__prev;
    if (k.$isElementNode(a) && k.$isElementNode(b)) return b.__first = a.__first, b.__last = a.__last, b.__size = a.__size, b.__format = a.__format, b.__indent = a.__indent, b.__dir = a.__dir, b;
    k.$isTextNode(a) && k.$isTextNode(b) && (b.__format = a.__format, b.__style = a.__style, b.__mode = a.__mode, b.__detail = a.__detail);
    return b;
};
exports.$getSelectionStyleValueForProperty = function(a, b, d = "") {
    let e = null, c = a.getNodes();
    var f = a.anchor, h = a.focus, g = a.isBackward();
    let l = g ? h.offset : f.offset;
    f = g ? h.getNode() : f.getNode();
    if (a.isCollapsed() && "" !== a.style && (a = z(a.style), null !== a && b in a)) return a[b];
    for(a = 0; a < c.length; a++){
        var n = c[a];
        if ((0 === a || 0 !== l || !n.is(f)) && k.$isTextNode(n)) {
            if (h = b, g = d, n = n.getStyle(), n = z(n), h = null !== n ? n[h] || g : g, null === e) e = h;
            else if (e !== h) {
                e = "";
                break;
            }
        }
    }
    return null === e ? d : e;
};
exports.$isAtNodeEnd = function(a) {
    if ("text" === a.type) return a.offset === a.getNode().getTextContentSize();
    let b = a.getNode();
    if (!k.$isElementNode(b)) throw Error("isAtNodeEnd: node must be a TextNode or ElementNode");
    return a.offset === b.getChildrenSize();
};
exports.$isParentElementRTL = G;
exports.$moveCaretSelection = F;
exports.$moveCharacter = function(a, b, d) {
    let e = G(a);
    F(a, b, d ? !e : e, "character");
};
exports.$patchStyleText = C;
exports.$selectAll = function(a) {
    let b = a.anchor;
    a = a.focus;
    var d = b.getNode().getTopLevelElementOrThrow().getParentOrThrow();
    let e = d.getFirstDescendant();
    d = d.getLastDescendant();
    let c = "element", f = "element", h = 0;
    k.$isTextNode(e) ? c = "text" : k.$isElementNode(e) || null === e || (e = e.getParentOrThrow());
    k.$isTextNode(d) ? (f = "text", h = d.getTextContentSize()) : k.$isElementNode(d) || null === d || (d = d.getParentOrThrow());
    e && d && (b.set(e.getKey(), 0, c), a.set(d.getKey(), h, f));
};
exports.$setBlocksType = function(a, b) {
    if ("root" === a.anchor.key) {
        b = b();
        var d = k.$getRoot();
        (a = d.getFirstChild()) ? a.replace(b, !0) : d.append(b);
    } else {
        d = a.getNodes();
        for(a = a.anchor.getNode(); null !== a && null !== a.getParent() && !H(a);)a = a.getParentOrThrow();
        (a = H(a) ? a : null) && -1 === d.indexOf(a) && d.push(a);
        for(a = 0; a < d.length; a++){
            let e = d[a];
            if (!H(e)) continue;
            if (!k.$isElementNode(e)) throw Error("Expected block node to be an ElementNode");
            let c = b();
            c.setFormat(e.getFormatType());
            c.setIndent(e.getIndent());
            e.replace(c, !0);
        }
    }
};
exports.$shouldOverrideDefaultCharacterSelection = function(a, b) {
    a = k.$getAdjacentNode(a.focus, b);
    return k.$isDecoratorNode(a) && !a.isIsolated() || k.$isElementNode(a) && !a.isInline() && !a.canBeEmpty();
};
exports.$sliceSelectedTextNodeContent = function(a, b) {
    if (b.isSelected(a) && !b.isSegmented() && !b.isToken() && k.$INTERNAL_isPointSelection(a)) {
        var d = a.anchor.getNode(), e = a.focus.getNode(), c = b.is(d), f = b.is(e);
        if (c || f) {
            c = a.isBackward();
            let [h, g] = a.getCharacterOffsets();
            a = d.is(e);
            f = b.is(c ? e : d);
            e = b.is(c ? d : e);
            d = 0;
            let l = void 0;
            a ? (d = h > g ? g : h, l = h > g ? h : g) : f ? (d = c ? g : h, l = void 0) : e && (c = c ? h : g, d = 0, l = c);
            b.__text = b.__text.slice(d, l);
        }
    }
    return b;
};
exports.$wrapNodes = function(a, b, d = null) {
    var e = a.getNodes();
    let c = e.length;
    var f = a.anchor;
    if (0 === c || 1 === c && "element" === f.type && 0 === f.getNode().getChildrenSize()) {
        a = "text" === f.type ? f.getNode().getParentOrThrow() : f.getNode();
        e = a.getChildren();
        let g = b();
        g.setFormat(a.getFormatType());
        g.setIndent(a.getIndent());
        e.forEach((l)=>g.append(l));
        d && (g = d.append(g));
        a.replace(g);
    } else {
        f = null;
        var h = [];
        for(let g = 0; g < c; g++){
            let l = e[g];
            k.$isRootOrShadowRoot(l) ? (E(a, h, h.length, b, d), h = [], f = l) : null === f || null !== f && k.$hasAncestor(l, f) ? h.push(l) : (E(a, h, h.length, b, d), h = [
                l
            ]);
        }
        E(a, h, h.length, b, d);
    }
};
exports.createDOMRange = function(a, b, d, e, c) {
    let f = b.getKey(), h = e.getKey(), g = document.createRange(), l = a.getElementByKey(f);
    a = a.getElementByKey(h);
    k.$isTextNode(b) && (l = v(l));
    k.$isTextNode(e) && (a = v(a));
    if (void 0 === b || void 0 === e || null === l || null === a) return null;
    "BR" === l.nodeName && ([l, d] = w(l));
    "BR" === a.nodeName && ([a, c] = w(a));
    b = l.firstChild;
    l === a && null != b && "BR" === b.nodeName && 0 === d && 0 === c && (c = 1);
    try {
        g.setStart(l, d), g.setEnd(a, c);
    } catch (n) {
        return null;
    }
    !g.collapsed || d === c && f === h || (g.setStart(a, c), g.setEnd(l, d));
    return g;
};
exports.createRectsFromDOMRange = function(a, b) {
    var d = a.getRootElement();
    if (null === d) return [];
    a = d.getBoundingClientRect();
    d = getComputedStyle(d);
    d = parseFloat(d.paddingLeft) + parseFloat(d.paddingRight);
    b = Array.from(b.getClientRects());
    let e = b.length;
    b.sort((f, h)=>{
        let g = f.top - h.top;
        return 3 >= Math.abs(g) ? f.left - h.left : g;
    });
    let c;
    for(let f = 0; f < e; f++){
        let h = b[f], g = h.width + d === a.width;
        c && c.top <= h.top && c.top + c.height > h.top && c.left + c.width > h.left || g ? (b.splice(f--, 1), e--) : c = h;
    }
    return b;
};
exports.getStyleObjectFromCSS = z;
exports.trimTextContentFromAnchor = function(a, b, d) {
    let e = b.getNode();
    if (k.$isElementNode(e)) {
        var c = e.getDescendantByIndex(b.offset);
        null !== c && (e = c);
    }
    for(; 0 < d && null !== e;){
        k.$isElementNode(e) && (c = e.getLastDescendant(), null !== c && (e = c));
        var f = e.getPreviousSibling(), h = 0;
        if (null === f) {
            c = e.getParentOrThrow();
            for(var g = c.getPreviousSibling(); null === g;){
                c = c.getParent();
                if (null === c) {
                    f = null;
                    break;
                }
                g = c.getPreviousSibling();
            }
            null !== c && (h = c.isInline() ? 0 : 2, f = g);
        }
        g = e.getTextContent();
        "" === g && k.$isElementNode(e) && !e.isInline() && (g = "\n\n");
        c = g.length;
        if (!k.$isTextNode(e) || d >= c) g = e.getParent(), e.remove(), null == g || 0 !== g.getChildrenSize() || k.$isRootNode(g) || g.remove(), d -= c + h, e = f;
        else {
            let l = e.getKey();
            h = a.getEditorState().read(()=>{
                const q = k.$getNodeByKey(l);
                return k.$isTextNode(q) && q.isSimpleText() ? q.getTextContent() : null;
            });
            f = c - d;
            let n = g.slice(0, f);
            null !== h && h !== g ? (d = k.$getPreviousSelection(), c = e, e.isSimpleText() ? e.setTextContent(h) : (c = k.$createTextNode(h), e.replace(c)), k.$isRangeSelection(d) && d.isCollapsed() && (d = d.anchor.offset, c.select(d, d))) : e.isSimpleText() ? (h = b.key === l, g = b.offset, g < d && (g = c), d = h ? g - d : 0, c = h ? g : f, h && 0 === d ? ([d] = e.splitText(d, c), d.remove()) : ([, d] = e.splitText(d, c), d.remove())) : (d = k.$createTextNode(n), e.replace(d));
            d = 0;
        }
    }
};

},{"df166b333087fd4d":"6uPvi"}],"2CQxU":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalList = require("1b3536eb910fa2a8");
module.exports = LexicalList;

},{"1b3536eb910fa2a8":"1oPeE"}],"1oPeE":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var h = require("aec414567b815e7d"), k = require("a6abb413edf24772");
function l(a) {
    let b = new URLSearchParams;
    b.append("code", a);
    for(let c = 1; c < arguments.length; c++)b.append("v", arguments[c]);
    throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?${b} for the full message or ` + "use the non-minified dev environment for full errors and additional helpful warnings.");
}
function n(a) {
    let b = 1;
    for(a = a.getParent(); null != a;){
        if (p(a)) {
            a = a.getParent();
            if (q(a)) {
                b++;
                a = a.getParent();
                continue;
            }
            l(40);
        }
        break;
    }
    return b;
}
function r(a) {
    a = a.getParent();
    q(a) || l(40);
    let b = a;
    for(; null !== b;)b = b.getParent(), q(b) && (a = b);
    return a;
}
function t(a) {
    let b = [];
    a = a.getChildren().filter(p);
    for(let c = 0; c < a.length; c++){
        let d = a[c], e = d.getFirstChild();
        q(e) ? b = b.concat(t(e)) : b.push(d);
    }
    return b;
}
function u(a) {
    return p(a) && q(a.getFirstChild());
}
function v(a) {
    for(; null == a.getNextSibling() && null == a.getPreviousSibling();){
        let b = a.getParent();
        if (null == b || !p(a) && !q(a)) break;
        a = b;
    }
    a.remove();
}
function w(a) {
    return y().append(a);
}
function z(a, b) {
    return p(a) && (0 === b.length || 1 === b.length && a.is(b[0]) && 0 === a.getChildrenSize());
}
function B(a, b) {
    a.splice(a.getChildrenSize(), 0, b);
}
function C(a, b) {
    if (q(a)) return a;
    let c = a.getPreviousSibling(), d = a.getNextSibling(), e = y();
    e.setFormat(a.getFormatType());
    e.setIndent(a.getIndent());
    B(e, a.getChildren());
    if (q(c) && b === c.getListType()) return c.append(e), a.remove(), q(d) && b === d.getListType() && (B(c, d.getChildren()), d.remove()), c;
    if (q(d) && b === d.getListType()) return d.getFirstChildOrThrow().insertBefore(e), a.remove(), d;
    b = D(b);
    b.append(e);
    a.replace(b);
    E(b);
    return b;
}
function F(a, b) {
    var c = a.getLastChild();
    let d = b.getFirstChild();
    c && d && u(c) && u(d) && (F(c.getFirstChild(), d.getFirstChild()), d.remove());
    c = b.getChildren();
    0 < c.length && (a.append(...c), E(a));
    b.remove();
}
function E(a, b) {
    a = b || a.getChildren();
    if (void 0 !== a) for(b = 0; b < a.length; b++){
        let f = a[b];
        if (p(f)) {
            let g = f.getValue();
            var c = f, d = c.getParent(), e = 1;
            null != d && (q(d) ? e = d.getStart() : l(44));
            c = c.getPreviousSiblings();
            for(d = 0; d < c.length; d++){
                let m = c[d];
                p(m) && !q(m.getFirstChild()) && e++;
            }
            g !== e && f.setValue(e);
        }
    }
}
function G(a) {
    if (!u(a)) {
        var b = a.getParent(), c = b ? b.getParent() : void 0, d = c ? c.getParent() : void 0;
        if (q(d) && p(c) && q(b)) {
            var e = b ? b.getFirstChild() : void 0, f = b ? b.getLastChild() : void 0;
            if (a.is(e)) c.insertBefore(a), b.isEmpty() && c.remove();
            else if (a.is(f)) c.insertAfter(a), b.isEmpty() && c.remove();
            else {
                var g = b.getListType();
                e = y();
                let m = D(g);
                e.append(m);
                a.getPreviousSiblings().forEach((x)=>m.append(x));
                f = y();
                g = D(g);
                f.append(g);
                B(g, a.getNextSiblings());
                c.insertBefore(e);
                c.insertAfter(f);
                c.replace(a);
            }
            E(b);
            E(d);
        }
    }
}
class H extends h.ElementNode {
    static getType() {
        return "listitem";
    }
    static clone(a) {
        return new H(a.__value, a.__checked, a.__key);
    }
    constructor(a, b, c){
        super(c);
        this.__value = void 0 === a ? 1 : a;
        this.__checked = b;
    }
    createDOM(a) {
        let b = document.createElement("li"), c = this.getParent();
        q(c) && "check" === c.getListType() && I(b, this, null);
        b.value = this.__value;
        J(b, a.theme, this);
        return b;
    }
    updateDOM(a, b, c) {
        let d = this.getParent();
        q(d) && "check" === d.getListType() && I(b, this, a);
        b.value = this.__value;
        J(b, c.theme, this);
        return !1;
    }
    static transform() {
        return (a)=>{
            let b = a.getParent();
            if (q(b)) {
                E(b);
                if (!p(a)) throw Error("node is not a ListItemNode");
                "check" !== b.getListType() && null != a.getChecked() && a.setChecked(void 0);
            }
        };
    }
    static importDOM() {
        return {
            li: ()=>({
                    conversion: K,
                    priority: 0
                })
        };
    }
    static importJSON(a) {
        let b = y();
        b.setChecked(a.checked);
        b.setValue(a.value);
        b.setFormat(a.format);
        b.setDirection(a.direction);
        return b;
    }
    exportDOM(a) {
        a = this.createDOM(a._config);
        a.style.textAlign = this.getFormatType();
        return {
            element: a
        };
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            checked: this.getChecked(),
            type: "listitem",
            value: this.getValue(),
            version: 1
        };
    }
    append(...a) {
        for(let b = 0; b < a.length; b++){
            let c = a[b];
            if (h.$isElementNode(c) && this.canMergeWith(c)) {
                let d = c.getChildren();
                this.append(...d);
                c.remove();
            } else super.append(c);
        }
        return this;
    }
    replace(a, b) {
        if (p(a)) return super.replace(a);
        this.setIndent(0);
        let c = this.getParentOrThrow();
        if (!q(c)) return a;
        if (c.__first === this.getKey()) c.insertBefore(a);
        else if (c.__last === this.getKey()) c.insertAfter(a);
        else {
            let d = D(c.getListType()), e = this.getNextSibling();
            for(; e;){
                let f = e;
                e = e.getNextSibling();
                d.append(f);
            }
            c.insertAfter(a);
            a.insertAfter(d);
        }
        if (b) {
            if (!h.$isElementNode(a)) throw Error("includeChildren should only be true for ElementNodes");
            this.getChildren().forEach((d)=>{
                a.append(d);
            });
        }
        this.remove();
        0 === c.getChildrenSize() && c.remove();
        return a;
    }
    insertAfter(a, b = !0) {
        var c = this.getParentOrThrow();
        q(c) || l(39);
        var d = this.getNextSiblings();
        if (p(a)) return b = super.insertAfter(a, b), a = a.getParentOrThrow(), q(a) && E(a), b;
        if (q(a)) {
            c = a;
            a = a.getChildren();
            for(d = a.length - 1; 0 <= d; d--)c = a[d], this.insertAfter(c, b);
            return c;
        }
        c.insertAfter(a, b);
        if (0 !== d.length) {
            let e = D(c.getListType());
            d.forEach((f)=>e.append(f));
            a.insertAfter(e, b);
        }
        return a;
    }
    remove(a) {
        let b = this.getPreviousSibling(), c = this.getNextSibling();
        super.remove(a);
        b && c && u(b) && u(c) ? (F(b.getFirstChild(), c.getFirstChild()), c.remove()) : c && (a = c.getParent(), q(a) && E(a));
    }
    insertNewAfter(a, b = !0) {
        a = y(null == this.__checked ? void 0 : !1);
        this.insertAfter(a, b);
        return a;
    }
    collapseAtStart(a) {
        let b = h.$createParagraphNode();
        this.getChildren().forEach((f)=>b.append(f));
        var c = this.getParentOrThrow(), d = c.getParentOrThrow();
        let e = p(d);
        1 === c.getChildrenSize() ? e ? (c.remove(), d.select()) : (c.insertBefore(b), c.remove(), c = a.anchor, a = a.focus, d = b.getKey(), "element" === c.type && c.getNode().is(this) && c.set(d, c.offset, "element"), "element" === a.type && a.getNode().is(this) && a.set(d, a.offset, "element")) : (c.insertBefore(b), this.remove());
        return !0;
    }
    getValue() {
        return this.getLatest().__value;
    }
    setValue(a) {
        this.getWritable().__value = a;
    }
    getChecked() {
        return this.getLatest().__checked;
    }
    setChecked(a) {
        this.getWritable().__checked = a;
    }
    toggleChecked() {
        this.setChecked(!this.__checked);
    }
    getIndent() {
        var a = this.getParent();
        if (null === a) return this.getLatest().__indent;
        a = a.getParentOrThrow();
        let b = 0;
        for(; p(a);)a = a.getParentOrThrow().getParentOrThrow(), b++;
        return b;
    }
    setIndent(a) {
        "number" === typeof a && -1 < a || l(117);
        let b = this.getIndent();
        for(; b !== a;)if (b < a) {
            a: {
                var c = new Set;
                if (u(this) || c.has(this.getKey())) break a;
                let g = this.getParent();
                var d = this.getNextSibling(), e = this.getPreviousSibling();
                if (u(d) && u(e)) {
                    if (e = e.getFirstChild(), q(e)) {
                        e.append(this);
                        var f = d.getFirstChild();
                        q(f) && (f = f.getChildren(), B(e, f), d.remove(), c.add(d.getKey()));
                        E(e);
                    }
                } else u(d) ? (d = d.getFirstChild(), q(d) && (c = d.getFirstChild(), null !== c && c.insertBefore(this), E(d))) : u(e) ? (d = e.getFirstChild(), q(d) && (d.append(this), E(d))) : q(g) && (c = y(), f = D(g.getListType()), c.append(f), f.append(this), e ? e.insertAfter(c) : d ? d.insertBefore(c) : g.append(c), E(f));
                q(g) && E(g);
            }
            b++;
        } else G(this), b--;
        return this;
    }
    insertBefore(a) {
        if (p(a)) {
            let b = this.getParentOrThrow();
            if (q(b)) {
                let c = this.getNextSiblings();
                E(b, c);
            }
        }
        return super.insertBefore(a);
    }
    canInsertAfter(a) {
        return p(a);
    }
    canReplaceWith(a) {
        return p(a);
    }
    canMergeWith(a) {
        return h.$isParagraphNode(a) || p(a);
    }
    extractWithChild(a, b) {
        if (!h.$isRangeSelection(b)) return !1;
        a = b.anchor.getNode();
        let c = b.focus.getNode();
        return this.isParentOf(a) && this.isParentOf(c) && this.getTextContent().length === b.getTextContent().length;
    }
    isParentRequired() {
        return !0;
    }
    createParentElementNode() {
        return D("bullet");
    }
}
function J(a, b, c) {
    let d = [], e = [];
    var f = (b = b.list) ? b.listitem : void 0;
    if (b && b.nested) var g = b.nested.listitem;
    void 0 !== f && (f = f.split(" "), d.push(...f));
    if (b) {
        f = c.getParent();
        f = q(f) && "check" === f.getListType();
        let m = c.getChecked();
        f && !m || e.push(b.listitemUnchecked);
        f && m || e.push(b.listitemChecked);
        f && d.push(m ? b.listitemChecked : b.listitemUnchecked);
    }
    void 0 !== g && (g = g.split(" "), c.getChildren().some((m)=>q(m)) ? d.push(...g) : e.push(...g));
    0 < e.length && k.removeClassNamesFromElement(a, ...e);
    0 < d.length && k.addClassNamesToElement(a, ...d);
}
function I(a, b, c) {
    q(b.getFirstChild()) ? (a.removeAttribute("role"), a.removeAttribute("tabIndex"), a.removeAttribute("aria-checked")) : (a.setAttribute("role", "checkbox"), a.setAttribute("tabIndex", "-1"), c && b.__checked === c.__checked || a.setAttribute("aria-checked", b.getChecked() ? "true" : "false"));
}
function K(a) {
    a = k.isHTMLElement(a) && "true" === a.getAttribute("aria-checked");
    return {
        node: y(a)
    };
}
function y(a) {
    return h.$applyNodeReplacement(new H(void 0, a));
}
function p(a) {
    return a instanceof H;
}
class L extends h.ElementNode {
    static getType() {
        return "list";
    }
    static clone(a) {
        return new L(a.__listType || N[a.__tag], a.__start, a.__key);
    }
    constructor(a, b, c){
        super(c);
        this.__listType = a = N[a] || a;
        this.__tag = "number" === a ? "ol" : "ul";
        this.__start = b;
    }
    getTag() {
        return this.__tag;
    }
    setListType(a) {
        let b = this.getWritable();
        b.__listType = a;
        b.__tag = "number" === a ? "ol" : "ul";
    }
    getListType() {
        return this.__listType;
    }
    getStart() {
        return this.__start;
    }
    createDOM(a) {
        let b = document.createElement(this.__tag);
        1 !== this.__start && b.setAttribute("start", String(this.__start));
        b.__lexicalListType = this.__listType;
        O(b, a.theme, this);
        return b;
    }
    updateDOM(a, b, c) {
        if (a.__tag !== this.__tag) return !0;
        O(b, c.theme, this);
        return !1;
    }
    static importDOM() {
        return {
            ol: ()=>({
                    conversion: P,
                    priority: 0
                }),
            ul: ()=>({
                    conversion: P,
                    priority: 0
                })
        };
    }
    static importJSON(a) {
        let b = D(a.listType, a.start);
        b.setFormat(a.format);
        b.setIndent(a.indent);
        b.setDirection(a.direction);
        return b;
    }
    exportDOM(a) {
        ({ element: a } = super.exportDOM(a));
        a && k.isHTMLElement(a) && (1 !== this.__start && a.setAttribute("start", String(this.__start)), "check" === this.__listType && a.setAttribute("__lexicalListType", "check"));
        return {
            element: a
        };
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            listType: this.getListType(),
            start: this.getStart(),
            tag: this.getTag(),
            type: "list",
            version: 1
        };
    }
    canBeEmpty() {
        return !1;
    }
    canIndent() {
        return !1;
    }
    append(...a) {
        for(let c = 0; c < a.length; c++){
            var b = a[c];
            if (p(b)) super.append(b);
            else {
                let d = y();
                q(b) ? d.append(b) : h.$isElementNode(b) ? (b = h.$createTextNode(b.getTextContent()), d.append(b)) : d.append(b);
                super.append(d);
            }
        }
        E(this);
        return this;
    }
    extractWithChild(a) {
        return p(a);
    }
}
function O(a, b, c) {
    let d = [], e = [];
    var f = b.list;
    if (void 0 !== f) {
        let m = f[`${c.__tag}Depth`] || [];
        b = n(c) - 1;
        let x = b % m.length;
        var g = m[x];
        let M = f[c.__tag], A;
        f = f.nested;
        void 0 !== f && f.list && (A = f.list);
        void 0 !== M && d.push(M);
        if (void 0 !== g) for(g = g.split(" "), d.push(...g), g = 0; g < m.length; g++)g !== x && e.push(c.__tag + g);
        void 0 !== A && (c = A.split(" "), 1 < b ? d.push(...c) : e.push(...c));
    }
    0 < e.length && k.removeClassNamesFromElement(a, ...e);
    0 < d.length && k.addClassNamesToElement(a, ...d);
}
function Q(a) {
    let b = [];
    for(let d = 0; d < a.length; d++){
        var c = a[d];
        p(c) ? (b.push(c), c = c.getChildren(), 1 < c.length && c.forEach((e)=>{
            q(e) && b.push(w(e));
        })) : b.push(w(c));
    }
    return b;
}
function P(a) {
    let b = a.nodeName.toLowerCase(), c = null;
    "ol" === b ? c = D("number", a.start) : "ul" === b && (c = k.isHTMLElement(a) && "check" === a.getAttribute("__lexicallisttype") ? D("check") : D("bullet"));
    return {
        after: Q,
        node: c
    };
}
let N = {
    ol: "number",
    ul: "bullet"
};
function D(a, b = 1) {
    return h.$applyNodeReplacement(new L(a, b));
}
function q(a) {
    return a instanceof L;
}
let R = h.createCommand("INSERT_UNORDERED_LIST_COMMAND"), S = h.createCommand("INSERT_ORDERED_LIST_COMMAND"), T = h.createCommand("INSERT_CHECK_LIST_COMMAND"), U = h.createCommand("REMOVE_LIST_COMMAND");
exports.$createListItemNode = y;
exports.$createListNode = D;
exports.$getListDepth = n;
exports.$handleListInsertParagraph = function() {
    var a = h.$getSelection();
    if (!h.$isRangeSelection(a) || !a.isCollapsed()) return !1;
    a = a.anchor.getNode();
    if (!p(a) || 0 !== a.getChildrenSize()) return !1;
    var b = r(a), c = a.getParent();
    q(c) || l(40);
    let d = c.getParent(), e;
    if (h.$isRootOrShadowRoot(d)) e = h.$createParagraphNode(), b.insertAfter(e);
    else if (p(d)) e = y(), d.insertAfter(e);
    else return !1;
    e.select();
    b = a.getNextSiblings();
    if (0 < b.length) {
        let f = D(c.getListType());
        h.$isParagraphNode(e) ? e.insertAfter(f) : (c = y(), c.append(f), e.insertAfter(c));
        b.forEach((g)=>{
            g.remove();
            f.append(g);
        });
    }
    v(a);
    return !0;
};
exports.$isListItemNode = p;
exports.$isListNode = q;
exports.INSERT_CHECK_LIST_COMMAND = T;
exports.INSERT_ORDERED_LIST_COMMAND = S;
exports.INSERT_UNORDERED_LIST_COMMAND = R;
exports.ListItemNode = H;
exports.ListNode = L;
exports.REMOVE_LIST_COMMAND = U;
exports.insertList = function(a, b) {
    a.update(()=>{
        var c = h.$getSelection();
        if (h.$INTERNAL_isPointSelection(c)) {
            var d = c.getNodes();
            c = c.anchor.getNode();
            var e = c.getParent();
            if (z(c, d)) d = D(b), h.$isRootOrShadowRoot(e) ? (c.replace(d), e = y(), h.$isElementNode(c) && (e.setFormat(c.getFormatType()), e.setIndent(c.getIndent())), d.append(e)) : p(c) && (c = c.getParentOrThrow(), B(d, c.getChildren()), c.replace(d));
            else for(c = new Set, e = 0; e < d.length; e++){
                var f = d[e];
                if (h.$isElementNode(f) && f.isEmpty() && !p(f) && !c.has(f.getKey())) C(f, b);
                else if (h.$isLeafNode(f)) for(f = f.getParent(); null != f;){
                    let m = f.getKey();
                    if (q(f)) {
                        if (!c.has(m)) {
                            var g = D(b);
                            B(g, f.getChildren());
                            f.replace(g);
                            E(g);
                            c.add(m);
                        }
                        break;
                    } else {
                        g = f.getParent();
                        if (h.$isRootOrShadowRoot(g) && !c.has(m)) {
                            c.add(m);
                            C(f, b);
                            break;
                        }
                        f = g;
                    }
                }
            }
        }
    });
};
exports.removeList = function(a) {
    a.update(()=>{
        let b = h.$getSelection();
        if (h.$isRangeSelection(b)) {
            var c = new Set, d = b.getNodes(), e = b.anchor.getNode();
            if (z(e, d)) c.add(r(e));
            else for(e = 0; e < d.length; e++){
                var f = d[e];
                h.$isLeafNode(f) && (f = k.$getNearestNodeOfType(f, H), null != f && c.add(r(f)));
            }
            for (let g of c){
                c = g;
                d = t(g);
                for (let m of d)d = h.$createParagraphNode(), B(d, m.getChildren()), c.insertAfter(d), c = d, m.__key === b.anchor.key && b.anchor.set(d.getKey(), 0, "element"), m.__key === b.focus.key && b.focus.set(d.getKey(), 0, "element"), m.remove();
                g.remove();
            }
        }
    });
};

},{"aec414567b815e7d":"6uPvi","a6abb413edf24772":"1V3L7"}],"kNqAc":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalRichText = require("f826d064a69f4dae");
module.exports = LexicalRichText;

},{"f826d064a69f4dae":"6C9zH"}],"6C9zH":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var c = require("de14a812fdf5b205"), g = require("e63d2ee6db13bab4"), h = require("174640ec0422e48f"), k = require("325790c58da0c1ef");
function l(b, a) {
    return "undefined" !== typeof document.caretRangeFromPoint ? (b = document.caretRangeFromPoint(b, a), null === b ? null : {
        node: b.startContainer,
        offset: b.startOffset
    }) : "undefined" !== document.caretPositionFromPoint ? (b = document.caretPositionFromPoint(b, a), null === b ? null : {
        node: b.offsetNode,
        offset: b.offset
    }) : null;
}
let n = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement, p = n && "documentMode" in document ? document.documentMode : null;
n && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
n && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
let q = n && "InputEvent" in window && !p ? "getTargetRanges" in new window.InputEvent("input") : !1, r = n && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), t = n && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
n && /Android/.test(navigator.userAgent);
let u = n && /^(?=.*Chrome).*/i.test(navigator.userAgent), v = n && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !u, w = k.createCommand("DRAG_DROP_PASTE_FILE");
class x extends k.ElementNode {
    static getType() {
        return "quote";
    }
    static clone(b) {
        return new x(b.__key);
    }
    constructor(b){
        super(b);
    }
    createDOM(b) {
        let a = document.createElement("blockquote");
        h.addClassNamesToElement(a, b.theme.quote);
        return a;
    }
    updateDOM() {
        return !1;
    }
    static importDOM() {
        return {
            blockquote: ()=>({
                    conversion: y,
                    priority: 0
                })
        };
    }
    exportDOM(b) {
        ({ element: b } = super.exportDOM(b));
        if (b && h.isHTMLElement(b)) {
            this.isEmpty() && b.append(document.createElement("br"));
            var a = this.getFormatType();
            b.style.textAlign = a;
            if (a = this.getDirection()) b.dir = a;
        }
        return {
            element: b
        };
    }
    static importJSON(b) {
        let a = z();
        a.setFormat(b.format);
        a.setIndent(b.indent);
        a.setDirection(b.direction);
        return a;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "quote"
        };
    }
    insertNewAfter(b, a) {
        b = k.$createParagraphNode();
        let d = this.getDirection();
        b.setDirection(d);
        this.insertAfter(b, a);
        return b;
    }
    collapseAtStart() {
        let b = k.$createParagraphNode();
        this.getChildren().forEach((a)=>b.append(a));
        this.replace(b);
        return !0;
    }
}
function z() {
    return k.$applyNodeReplacement(new x);
}
class B extends k.ElementNode {
    static getType() {
        return "heading";
    }
    static clone(b) {
        return new B(b.__tag, b.__key);
    }
    constructor(b, a){
        super(a);
        this.__tag = b;
    }
    getTag() {
        return this.__tag;
    }
    createDOM(b) {
        let a = this.__tag, d = document.createElement(a);
        b = b.theme.heading;
        void 0 !== b && h.addClassNamesToElement(d, b[a]);
        return d;
    }
    updateDOM() {
        return !1;
    }
    static importDOM() {
        return {
            h1: ()=>({
                    conversion: C,
                    priority: 0
                }),
            h2: ()=>({
                    conversion: C,
                    priority: 0
                }),
            h3: ()=>({
                    conversion: C,
                    priority: 0
                }),
            h4: ()=>({
                    conversion: C,
                    priority: 0
                }),
            h5: ()=>({
                    conversion: C,
                    priority: 0
                }),
            h6: ()=>({
                    conversion: C,
                    priority: 0
                }),
            p: (b)=>{
                b = b.firstChild;
                return null !== b && D(b) ? {
                    conversion: ()=>({
                            node: null
                        }),
                    priority: 3
                } : null;
            },
            span: (b)=>D(b) ? {
                    conversion: ()=>({
                            node: E("h1")
                        }),
                    priority: 3
                } : null
        };
    }
    exportDOM(b) {
        ({ element: b } = super.exportDOM(b));
        if (b && h.isHTMLElement(b)) {
            this.isEmpty() && b.append(document.createElement("br"));
            var a = this.getFormatType();
            b.style.textAlign = a;
            if (a = this.getDirection()) b.dir = a;
        }
        return {
            element: b
        };
    }
    static importJSON(b) {
        let a = E(b.tag);
        a.setFormat(b.format);
        a.setIndent(b.indent);
        a.setDirection(b.direction);
        return a;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            tag: this.getTag(),
            type: "heading",
            version: 1
        };
    }
    insertNewAfter(b, a = !0) {
        let d = b ? b.anchor.offset : 0, e = d !== this.getTextContentSize() && b ? E(this.getTag()) : k.$createParagraphNode(), f = this.getDirection();
        e.setDirection(f);
        this.insertAfter(e, a);
        0 === d && !this.isEmpty() && b && (b = k.$createParagraphNode(), b.select(), this.replace(b, !0));
        return e;
    }
    collapseAtStart() {
        let b = this.isEmpty() ? k.$createParagraphNode() : E(this.getTag());
        this.getChildren().forEach((a)=>b.append(a));
        this.replace(b);
        return !0;
    }
    extractWithChild() {
        return !0;
    }
}
function D(b) {
    return "span" === b.nodeName.toLowerCase() ? "26pt" === b.style.fontSize : !1;
}
function C(b) {
    let a = b.nodeName.toLowerCase(), d = null;
    if ("h1" === a || "h2" === a || "h3" === a || "h4" === a || "h5" === a || "h6" === a) d = E(a), null !== b.style && d.setFormat(b.style.textAlign);
    return {
        node: d
    };
}
function y(b) {
    let a = z();
    null !== b.style && a.setFormat(b.style.textAlign);
    return {
        node: a
    };
}
function E(b) {
    return k.$applyNodeReplacement(new B(b));
}
function F(b, a) {
    b.preventDefault();
    a.update(()=>{
        let d = k.$getSelection(), e = b instanceof InputEvent || b instanceof KeyboardEvent ? null : b.clipboardData;
        null != e && k.$INTERNAL_isPointSelection(d) && c.$insertDataTransferForRichText(e, d, a);
    }, {
        tag: "paste"
    });
}
async function G(b, a) {
    await c.copyToClipboard(a, h.objectKlassEquals(b, ClipboardEvent) ? b : null);
    a.update(()=>{
        let d = k.$getSelection();
        k.$isRangeSelection(d) ? d.removeText() : k.$isNodeSelection(d) && d.getNodes().forEach((e)=>e.remove());
    });
}
function H(b) {
    let a = null;
    b instanceof DragEvent ? a = b.dataTransfer : b instanceof ClipboardEvent && (a = b.clipboardData);
    if (null === a) return [
        !1,
        [],
        !1
    ];
    var d = a.types;
    b = d.includes("Files");
    d = d.includes("text/html") || d.includes("text/plain");
    return [
        b,
        Array.from(a.files),
        d
    ];
}
function I(b) {
    var a = k.$getSelection();
    if (!k.$isRangeSelection(a)) return !1;
    let d = new Set;
    a = a.getNodes();
    for(let m = 0; m < a.length; m++){
        var e = a[m], f = e.getKey();
        d.has(f) || (e = h.$getNearestBlockElementAncestorOrThrow(e), f = e.getKey(), e.canIndent() && !d.has(f) && (d.add(f), b(e)));
    }
    return 0 < d.size;
}
function J(b) {
    b = k.$getNearestNodeFromDOMNode(b);
    return k.$isDecoratorNode(b);
}
exports.$createHeadingNode = E;
exports.$createQuoteNode = z;
exports.$isHeadingNode = function(b) {
    return b instanceof B;
};
exports.$isQuoteNode = function(b) {
    return b instanceof x;
};
exports.DRAG_DROP_PASTE = w;
exports.HeadingNode = B;
exports.QuoteNode = x;
exports.eventFiles = H;
exports.registerRichText = function(b) {
    return h.mergeRegister(b.registerCommand(k.CLICK_COMMAND, ()=>{
        const a = k.$getSelection();
        return k.$isNodeSelection(a) ? (a.clear(), !0) : !1;
    }, 0), b.registerCommand(k.DELETE_CHARACTER_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        d.deleteCharacter(a);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DELETE_WORD_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        d.deleteWord(a);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DELETE_LINE_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        d.deleteLine(a);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.CONTROLLED_TEXT_INSERTION_COMMAND, (a)=>{
        const d = k.$getSelection();
        if ("string" === typeof a) k.$INTERNAL_isPointSelection(d) && d.insertText(a);
        else {
            if (!k.$INTERNAL_isPointSelection(d)) return !1;
            const e = a.dataTransfer;
            null != e ? c.$insertDataTransferForRichText(e, d, b) : k.$isRangeSelection(d) && (a = a.data) && d.insertText(a);
        }
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.REMOVE_TEXT_COMMAND, ()=>{
        const a = k.$getSelection();
        if (!k.$isRangeSelection(a)) return !1;
        a.removeText();
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.FORMAT_TEXT_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        d.formatText(a);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.FORMAT_ELEMENT_COMMAND, (a)=>{
        var d = k.$getSelection();
        if (!k.$isRangeSelection(d) && !k.$isNodeSelection(d)) return !1;
        d = d.getNodes();
        for (const e of d)d = h.$findMatchingParent(e, (f)=>k.$isElementNode(f) && !f.isInline()), null !== d && d.setFormat(a);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INSERT_LINE_BREAK_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        d.insertLineBreak(a);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INSERT_PARAGRAPH_COMMAND, ()=>{
        const a = k.$getSelection();
        if (!k.$isRangeSelection(a)) return !1;
        a.insertParagraph();
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INSERT_TAB_COMMAND, ()=>{
        k.$insertNodes([
            k.$createTabNode()
        ]);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.INDENT_CONTENT_COMMAND, ()=>I((a)=>{
            const d = a.getIndent();
            a.setIndent(d + 1);
        }), k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.OUTDENT_CONTENT_COMMAND, ()=>I((a)=>{
            const d = a.getIndent();
            0 < d && a.setIndent(d - 1);
        }), k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_UP_COMMAND, (a)=>{
        var d = k.$getSelection();
        if (k.$isNodeSelection(d) && !J(a.target)) {
            if (a = d.getNodes(), 0 < a.length) return a[0].selectPrevious(), !0;
        } else if (k.$isRangeSelection(d) && (d = k.$getAdjacentNode(d.focus, !0), !a.shiftKey && k.$isDecoratorNode(d) && !d.isIsolated() && !d.isInline())) return d.selectPrevious(), a.preventDefault(), !0;
        return !1;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_DOWN_COMMAND, (a)=>{
        var d = k.$getSelection();
        if (k.$isNodeSelection(d)) {
            if (a = d.getNodes(), 0 < a.length) return a[0].selectNext(0, 0), !0;
        } else if (k.$isRangeSelection(d)) {
            let e = d.focus;
            if ("root" === e.key && e.offset === k.$getRoot().getChildrenSize()) return a.preventDefault(), !0;
            d = k.$getAdjacentNode(d.focus, !1);
            if (!a.shiftKey && k.$isDecoratorNode(d) && !d.isIsolated() && !d.isInline()) return d.selectNext(), a.preventDefault(), !0;
        }
        return !1;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_LEFT_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (k.$isNodeSelection(d)) {
            var e = d.getNodes();
            if (0 < e.length) return a.preventDefault(), e[0].selectPrevious(), !0;
        }
        return k.$isRangeSelection(d) ? g.$shouldOverrideDefaultCharacterSelection(d, !0) ? (e = a.shiftKey, a.preventDefault(), g.$moveCharacter(d, e, !0), !0) : !1 : !1;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ARROW_RIGHT_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (k.$isNodeSelection(d) && !J(a.target)) {
            var e = d.getNodes();
            if (0 < e.length) return a.preventDefault(), e[0].selectNext(0, 0), !0;
        }
        if (!k.$isRangeSelection(d)) return !1;
        e = a.shiftKey;
        return g.$shouldOverrideDefaultCharacterSelection(d, !1) ? (a.preventDefault(), g.$moveCharacter(d, e, !1), !0) : !1;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_BACKSPACE_COMMAND, (a)=>{
        if (J(a.target)) return !1;
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        a.preventDefault();
        ({ anchor: a } = d);
        const e = a.getNode();
        return d.isCollapsed() && 0 === a.offset && !k.$isRootNode(e) && 0 < h.$getNearestBlockElementAncestorOrThrow(e).getIndent() ? b.dispatchCommand(k.OUTDENT_CONTENT_COMMAND, void 0) : b.dispatchCommand(k.DELETE_CHARACTER_COMMAND, !0);
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_DELETE_COMMAND, (a)=>{
        if (J(a.target)) return !1;
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        a.preventDefault();
        return b.dispatchCommand(k.DELETE_CHARACTER_COMMAND, !1);
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ENTER_COMMAND, (a)=>{
        const d = k.$getSelection();
        if (!k.$isRangeSelection(d)) return !1;
        if (null !== a) {
            if ((t || r || v) && q) return !1;
            a.preventDefault();
            if (a.shiftKey) return b.dispatchCommand(k.INSERT_LINE_BREAK_COMMAND, !1);
        }
        return b.dispatchCommand(k.INSERT_PARAGRAPH_COMMAND, void 0);
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.KEY_ESCAPE_COMMAND, ()=>{
        const a = k.$getSelection();
        if (!k.$isRangeSelection(a)) return !1;
        b.blur();
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DROP_COMMAND, (a)=>{
        const [, d] = H(a);
        if (0 < d.length) {
            var e = l(a.clientX, a.clientY);
            if (null !== e) {
                const { offset: m, node: K } = e;
                var f = k.$getNearestNodeFromDOMNode(K);
                if (null !== f) {
                    e = k.$createRangeSelection();
                    if (k.$isTextNode(f)) e.anchor.set(f.getKey(), m, "text"), e.focus.set(f.getKey(), m, "text");
                    else {
                        const A = f.getParentOrThrow().getKey();
                        f = f.getIndexWithinParent() + 1;
                        e.anchor.set(A, f, "element");
                        e.focus.set(A, f, "element");
                    }
                    e = k.$normalizeSelection__EXPERIMENTAL(e);
                    k.$setSelection(e);
                }
                b.dispatchCommand(w, d);
            }
            a.preventDefault();
            return !0;
        }
        a = k.$getSelection();
        return k.$isRangeSelection(a) ? !0 : !1;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DRAGSTART_COMMAND, (a)=>{
        [a] = H(a);
        const d = k.$getSelection();
        return a && !k.$isRangeSelection(d) ? !1 : !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.DRAGOVER_COMMAND, (a)=>{
        var [d] = H(a);
        const e = k.$getSelection();
        if (d && !k.$isRangeSelection(e)) return !1;
        d = l(a.clientX, a.clientY);
        null !== d && (d = k.$getNearestNodeFromDOMNode(d.node), k.$isDecoratorNode(d) && a.preventDefault());
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.SELECT_ALL_COMMAND, ()=>{
        k.$selectAll();
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.COPY_COMMAND, (a)=>{
        c.copyToClipboard(b, h.objectKlassEquals(a, ClipboardEvent) ? a : null);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.CUT_COMMAND, (a)=>{
        G(a, b);
        return !0;
    }, k.COMMAND_PRIORITY_EDITOR), b.registerCommand(k.PASTE_COMMAND, (a)=>{
        const [, d, e] = H(a);
        if (0 < d.length && !e) return b.dispatchCommand(w, d), !0;
        if (k.isSelectionCapturedInDecoratorInput(a.target)) return !1;
        const f = k.$getSelection();
        return k.$INTERNAL_isPointSelection(f) ? (F(a, b), !0) : !1;
    }, k.COMMAND_PRIORITY_EDITOR));
};

},{"de14a812fdf5b205":"2lH0q","e63d2ee6db13bab4":"57ffa","174640ec0422e48f":"1V3L7","325790c58da0c1ef":"6uPvi"}],"2lH0q":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalClipboard = require("642b6d612b52654a");
module.exports = LexicalClipboard;

},{"642b6d612b52654a":"2Z8mI"}],"2Z8mI":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("ceb863274b1b5ea6"), m = require("afa39b316309b804"), q = require("304dc3cc2a9c3458"), r = require("777ab89d44b948ee");
function t(a) {
    let b = new URLSearchParams;
    b.append("code", a);
    for(let c = 1; c < arguments.length; c++)b.append("v", arguments[c]);
    throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?${b} for the full message or ` + "use the non-minified dev environment for full errors and additional helpful warnings.");
}
let u = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement;
function v(a) {
    let b = r.$getSelection();
    if (null == b) throw Error("Expected valid LexicalSelection");
    return r.$isRangeSelection(b) && b.isCollapsed() || 0 === b.getNodes().length ? "" : f.$generateHtmlFromNodes(a, b);
}
function w(a) {
    let b = r.$getSelection();
    if (null == b) throw Error("Expected valid LexicalSelection");
    return r.$isRangeSelection(b) && b.isCollapsed() || 0 === b.getNodes().length ? null : JSON.stringify(x(a, b));
}
function y(a, b, c) {
    a.dispatchCommand(r.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND, {
        nodes: b,
        selection: c
    }) || c.insertNodes(b);
}
function z(a, b, c, d = []) {
    let e = null != b ? c.isSelected(b) : !0, h = r.$isElementNode(c) && c.excludeFromCopy("html");
    var g = c;
    if (null !== b) {
        var k = m.$cloneWithProperties(c);
        g = k = r.$isTextNode(k) && null != b ? m.$sliceSelectedTextNodeContent(b, k) : k;
    }
    let n = r.$isElementNode(g) ? g.getChildren() : [];
    var l = g;
    k = l.exportJSON();
    var p = l.constructor;
    k.type !== p.getType() && t(58, p.name);
    r.$isElementNode(l) && (Array.isArray(k.children) || t(59, p.name));
    r.$isTextNode(g) && (g = g.__text, 0 < g.length ? k.text = g : e = !1);
    for(g = 0; g < n.length; g++)l = n[g], p = z(a, b, l, k.children), !e && r.$isElementNode(c) && p && c.extractWithChild(l, b, "clone") && (e = !0);
    if (e && !h) d.push(k);
    else if (Array.isArray(k.children)) for(a = 0; a < k.children.length; a++)d.push(k.children[a]);
    return e;
}
function x(a, b) {
    let c = [], d = r.$getRoot().getChildren();
    for(let e = 0; e < d.length; e++)z(a, b, d[e], c);
    return {
        namespace: a._config.namespace,
        nodes: c
    };
}
function A(a) {
    let b = [];
    for(let c = 0; c < a.length; c++){
        let d = r.$parseSerializedNode(a[c]);
        r.$isTextNode(d) && m.$addNodeStyle(d);
        b.push(d);
    }
    return b;
}
let B = null;
function C(a, b) {
    var c = u ? (a._window || window).getSelection() : null;
    if (!c) return !1;
    var d = c.anchorNode;
    c = c.focusNode;
    if (null !== d && null !== c && !r.isSelectionWithinEditor(a, d, c)) return !1;
    b.preventDefault();
    b = b.clipboardData;
    d = r.$getSelection();
    if (null === b || null === d) return !1;
    c = v(a);
    a = w(a);
    let e = "";
    null !== d && (e = d.getTextContent());
    null !== c && b.setData("text/html", c);
    null !== a && b.setData("application/x-lexical-editor", a);
    b.setData("text/plain", e);
    return !0;
}
exports.$generateJSONFromSelectedNodes = x;
exports.$generateNodesFromSerializedNodes = A;
exports.$getHtmlContent = v;
exports.$getLexicalContent = w;
exports.$insertDataTransferForPlainText = function(a, b) {
    a = a.getData("text/plain") || a.getData("text/uri-list");
    null != a && b.insertRawText(a);
};
exports.$insertDataTransferForRichText = function(a, b, c) {
    var d = a.getData("application/x-lexical-editor");
    if (d) try {
        let h = JSON.parse(d);
        if (h.namespace === c._config.namespace && Array.isArray(h.nodes)) {
            let g = A(h.nodes);
            return y(c, g, b);
        }
    } catch (h) {}
    if (d = a.getData("text/html")) try {
        var e = (new DOMParser).parseFromString(d, "text/html");
        let h = f.$generateNodesFromDOM(c, e);
        return y(c, h, b);
    } catch (h) {}
    a = a.getData("text/plain") || a.getData("text/uri-list");
    if (null != a) {
        if (r.$isRangeSelection(b)) for(a = a.split(/(\r?\n|\t)/), "" === a[a.length - 1] && a.pop(), c = 0; c < a.length; c++)e = a[c], "\n" === e || "\r\n" === e ? b.insertParagraph() : "	" === e ? b.insertNodes([
            r.$createTabNode()
        ]) : b.insertText(e);
        else b.insertRawText(a);
    }
};
exports.$insertGeneratedNodes = y;
exports.copyToClipboard = async function(a, b) {
    if (null !== B) return !1;
    if (null !== b) return new Promise((g)=>{
        a.update(()=>{
            g(C(a, b));
        });
    });
    var c = a.getRootElement();
    let d = null == a._window ? window.document : a._window.document, e = u ? (a._window || window).getSelection() : null;
    if (null === c || null === e) return !1;
    let h = d.createElement("span");
    h.style.cssText = "position: fixed; top: -1000px;";
    h.append(d.createTextNode("#"));
    c.append(h);
    c = new Range;
    c.setStart(h, 0);
    c.setEnd(h, 1);
    e.removeAllRanges();
    e.addRange(c);
    return new Promise((g)=>{
        let k = a.registerCommand(r.COPY_COMMAND, (n)=>{
            q.objectKlassEquals(n, ClipboardEvent) && (k(), null !== B && (window.clearTimeout(B), B = null), g(C(a, n)));
            return !0;
        }, r.COMMAND_PRIORITY_CRITICAL);
        B = window.setTimeout(()=>{
            k();
            B = null;
            g(!1);
        }, 50);
        d.execCommand("copy");
        h.remove();
    });
};

},{"ceb863274b1b5ea6":"dG8qY","afa39b316309b804":"57ffa","304dc3cc2a9c3458":"1V3L7","777ab89d44b948ee":"6uPvi"}],"dG8qY":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalHtml = require("7eb9175769a6777b");
module.exports = LexicalHtml;

},{"7eb9175769a6777b":"bd79j"}],"bd79j":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var m = require("852391ccdbd5e309"), p = require("ef5a8adc348bf653"), q = require("8737dab3e0e22b03");
function u(c, e, h, a = null) {
    let f = null != a ? e.isSelected(a) : !0, k = q.$isElementNode(e) && e.excludeFromCopy("html");
    var d = e;
    null !== a && (d = m.$cloneWithProperties(e), d = q.$isTextNode(d) && null != a ? m.$sliceSelectedTextNodeContent(a, d) : d);
    let g = q.$isElementNode(d) ? d.getChildren() : [];
    var b = c._nodes.get(d.getType());
    b = b && void 0 !== b.exportDOM ? b.exportDOM(c, d) : d.exportDOM(c);
    let { element: l, after: r } = b;
    if (!l) return !1;
    b = document.createDocumentFragment();
    for(let n = 0; n < g.length; n++){
        let t = g[n], x = u(c, t, b, a);
        !f && q.$isElementNode(e) && x && e.extractWithChild(t, a, "html") && (f = !0);
    }
    f && !k ? (p.isHTMLElement(l) && l.append(b), h.append(l), r && (c = r.call(d, l)) && l.replaceWith(c)) : h.append(b);
    return f;
}
let v = new Set([
    "STYLE",
    "SCRIPT"
]);
function w(c, e, h = new Map, a) {
    let f = [];
    if (v.has(c.nodeName)) return f;
    let k = null;
    var d, { nodeName: g } = c, b = e._htmlConversions.get(g.toLowerCase());
    g = null;
    if (void 0 !== b) for (d of b)b = d(c), null !== b && (null === g || (g.priority || 0) < (b.priority || 0)) && (g = b);
    g = (d = null !== g ? g.conversion : null) ? d(c) : null;
    d = null;
    if (null !== g) {
        d = g.after;
        b = g.node;
        k = Array.isArray(b) ? b[b.length - 1] : b;
        if (null !== k) {
            for (var [, l] of h)if (k = l(k, a), !k) break;
            k && f.push(...Array.isArray(b) ? b : [
                k
            ]);
        }
        null != g.forChild && h.set(c.nodeName, g.forChild);
    }
    c = c.childNodes;
    a = [];
    for(l = 0; l < c.length; l++)a.push(...w(c[l], e, new Map(h), k));
    null != d && (a = d(a));
    null == k ? f = f.concat(a) : q.$isElementNode(k) && k.append(...a);
    return f;
}
exports.$generateHtmlFromNodes = function(c, e) {
    if ("undefined" === typeof document || "undefined" === typeof window) throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
    let h = document.createElement("div"), a = q.$getRoot().getChildren();
    for(let f = 0; f < a.length; f++)u(c, a[f], h, e);
    return h.innerHTML;
};
exports.$generateNodesFromDOM = function(c, e) {
    e = e.body ? e.body.childNodes : [];
    let h = [];
    for(let f = 0; f < e.length; f++){
        var a = e[f];
        v.has(a.nodeName) || (a = w(a, c), null !== a && (h = h.concat(a)));
    }
    return h;
};

},{"852391ccdbd5e309":"57ffa","ef5a8adc348bf653":"1V3L7","8737dab3e0e22b03":"6uPvi"}],"2MxRL":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalLink = require("93dcb0801ea575f1");
module.exports = LexicalLink;

},{"93dcb0801ea575f1":"jIWKH"}],"jIWKH":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = require("e59d1415ab69a107"), m = require("49d5f866151e9859");
let n = new Set([
    "http:",
    "https:",
    "mailto:",
    "sms:",
    "tel:"
]);
class p extends m.ElementNode {
    static getType() {
        return "link";
    }
    static clone(a) {
        return new p(a.__url, {
            rel: a.__rel,
            target: a.__target,
            title: a.__title
        }, a.__key);
    }
    constructor(a, b = {}, e){
        super(e);
        let { target: h = null, rel: k = null, title: f = null } = b;
        this.__url = a;
        this.__target = h;
        this.__rel = k;
        this.__title = f;
    }
    createDOM(a) {
        let b = document.createElement("a");
        b.href = this.sanitizeUrl(this.__url);
        null !== this.__target && (b.target = this.__target);
        null !== this.__rel && (b.rel = this.__rel);
        null !== this.__title && (b.title = this.__title);
        l.addClassNamesToElement(b, a.theme.link);
        return b;
    }
    updateDOM(a, b) {
        let e = this.__url, h = this.__target, k = this.__rel, f = this.__title;
        e !== a.__url && (b.href = e);
        h !== a.__target && (h ? b.target = h : b.removeAttribute("target"));
        k !== a.__rel && (k ? b.rel = k : b.removeAttribute("rel"));
        f !== a.__title && (f ? b.title = f : b.removeAttribute("title"));
        return !1;
    }
    static importDOM() {
        return {
            a: ()=>({
                    conversion: q,
                    priority: 1
                })
        };
    }
    static importJSON(a) {
        let b = r(a.url, {
            rel: a.rel,
            target: a.target,
            title: a.title
        });
        b.setFormat(a.format);
        b.setIndent(a.indent);
        b.setDirection(a.direction);
        return b;
    }
    sanitizeUrl(a) {
        try {
            let b = new URL(a);
            if (!n.has(b.protocol)) return "about:blank";
        } catch (b) {}
        return a;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            rel: this.getRel(),
            target: this.getTarget(),
            title: this.getTitle(),
            type: "link",
            url: this.getURL(),
            version: 1
        };
    }
    getURL() {
        return this.getLatest().__url;
    }
    setURL(a) {
        this.getWritable().__url = a;
    }
    getTarget() {
        return this.getLatest().__target;
    }
    setTarget(a) {
        this.getWritable().__target = a;
    }
    getRel() {
        return this.getLatest().__rel;
    }
    setRel(a) {
        this.getWritable().__rel = a;
    }
    getTitle() {
        return this.getLatest().__title;
    }
    setTitle(a) {
        this.getWritable().__title = a;
    }
    insertNewAfter(a, b = !0) {
        a = r(this.__url, {
            rel: this.__rel,
            target: this.__target,
            title: this.__title
        });
        this.insertAfter(a, b);
        return a;
    }
    canInsertTextBefore() {
        return !1;
    }
    canInsertTextAfter() {
        return !1;
    }
    canBeEmpty() {
        return !1;
    }
    isInline() {
        return !0;
    }
    extractWithChild(a, b) {
        if (!m.$isRangeSelection(b)) return !1;
        a = b.anchor.getNode();
        let e = b.focus.getNode();
        return this.isParentOf(a) && this.isParentOf(e) && 0 < b.getTextContent().length;
    }
}
function q(a) {
    let b = null;
    if (l.isHTMLAnchorElement(a)) {
        let e = a.textContent;
        if (null !== e && "" !== e || 0 < a.children.length) b = r(a.getAttribute("href") || "", {
            rel: a.getAttribute("rel"),
            target: a.getAttribute("target"),
            title: a.getAttribute("title")
        });
    }
    return {
        node: b
    };
}
function r(a, b) {
    return m.$applyNodeReplacement(new p(a, b));
}
function u(a) {
    return a instanceof p;
}
class v extends p {
    static getType() {
        return "autolink";
    }
    static clone(a) {
        return new v(a.__url, {
            rel: a.__rel,
            target: a.__target,
            title: a.__title
        }, a.__key);
    }
    static importJSON(a) {
        let b = w(a.url, {
            rel: a.rel,
            target: a.target,
            title: a.title
        });
        b.setFormat(a.format);
        b.setIndent(a.indent);
        b.setDirection(a.direction);
        return b;
    }
    static importDOM() {
        return null;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "autolink",
            version: 1
        };
    }
    insertNewAfter(a, b = !0) {
        a = this.getParentOrThrow().insertNewAfter(a, b);
        return m.$isElementNode(a) ? (b = w(this.__url, {
            rel: this.__rel,
            target: this.__target,
            title: this.__title
        }), a.append(b), b) : null;
    }
}
function w(a, b) {
    return m.$applyNodeReplacement(new v(a, b));
}
let x = m.createCommand("TOGGLE_LINK_COMMAND");
function y(a, b) {
    for(; null !== a && null !== a.getParent() && !b(a);)a = a.getParentOrThrow();
    return b(a) ? a : null;
}
exports.$createAutoLinkNode = w;
exports.$createLinkNode = r;
exports.$isAutoLinkNode = function(a) {
    return a instanceof v;
};
exports.$isLinkNode = u;
exports.AutoLinkNode = v;
exports.LinkNode = p;
exports.TOGGLE_LINK_COMMAND = x;
exports.toggleLink = function(a, b = {}) {
    let { target: e, title: h } = b, k = void 0 === b.rel ? "noreferrer" : b.rel;
    b = m.$getSelection();
    if (m.$isRangeSelection(b)) {
        if (b = b.extract(), null === a) b.forEach((f)=>{
            f = f.getParent();
            if (u(f)) {
                let d = f.getChildren();
                for(let c = 0; c < d.length; c++)f.insertBefore(d[c]);
                f.remove();
            }
        });
        else {
            if (1 === b.length) {
                let c = y(b[0], u);
                if (null !== c) {
                    c.setURL(a);
                    void 0 !== e && c.setTarget(e);
                    null !== k && c.setRel(k);
                    void 0 !== h && c.setTitle(h);
                    return;
                }
            }
            let f = null, d = null;
            b.forEach((c)=>{
                var g = c.getParent();
                if (g !== d && null !== g && (!m.$isElementNode(c) || c.isInline())) {
                    if (u(g)) d = g, g.setURL(a), void 0 !== e && g.setTarget(e), null !== k && d.setRel(k), void 0 !== h && d.setTitle(h);
                    else if (g.is(f) || (f = g, d = r(a, {
                        rel: k,
                        target: e,
                        title: h
                    }), u(g) ? null === c.getPreviousSibling() ? g.insertBefore(d) : g.insertAfter(d) : c.insertBefore(d)), u(c)) {
                        if (!c.is(d)) {
                            if (null !== d) {
                                g = c.getChildren();
                                for(let t = 0; t < g.length; t++)d.append(g[t]);
                            }
                            c.remove();
                        }
                    } else null !== d && d.append(c);
                }
            });
        }
    }
};

},{"e59d1415ab69a107":"1V3L7","49d5f866151e9859":"6uPvi"}],"dTVDi":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalComposer = require("62400596efb4ef1e");
module.exports = LexicalComposer;

},{"62400596efb4ef1e":"dhhdX"}],"dhhdX":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("12464b8cb4bc0ec5"), f = require("a4bafe9676ed54e6"), g = require("fe0cd286d5f1ae75");
let m = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement;
var n = m ? g.useLayoutEffect : g.useEffect;
let p = {
    tag: "history-merge"
};
function q(a, c) {
    if (null !== c) {
        if (void 0 === c) a.update(()=>{
            var b = f.$getRoot();
            if (b.isEmpty()) {
                let d = f.$createParagraphNode();
                b.append(d);
                b = m ? document.activeElement : null;
                (null !== f.$getSelection() || null !== b && b === a.getRootElement()) && d.select();
            }
        }, p);
        else if (null !== c) switch(typeof c){
            case "string":
                let b = a.parseEditorState(c);
                a.setEditorState(b, p);
                break;
            case "object":
                a.setEditorState(c, p);
                break;
            case "function":
                a.update(()=>{
                    f.$getRoot().isEmpty() && c(a);
                }, p);
        }
    }
}
exports.LexicalComposer = function({ initialConfig: a, children: c }) {
    let b = g.useMemo(()=>{
        const { theme: d, namespace: h, editor__DEPRECATED: r, nodes: t, onError: u, editorState: v, html: w } = a, x = e.createLexicalComposerContext(null, d);
        let k = r || null;
        if (null === k) {
            const l = f.createEditor({
                editable: a.editable,
                html: w,
                namespace: h,
                nodes: t,
                onError: (y)=>u(y, l),
                theme: d
            });
            q(l, v);
            k = l;
        }
        return [
            k,
            x
        ];
    }, []);
    n(()=>{
        let d = a.editable, [h] = b;
        h.setEditable(void 0 !== d ? d : !0);
    }, []);
    return g.createElement(e.LexicalComposerContext.Provider, {
        value: b
    }, c);
};

},{"12464b8cb4bc0ec5":"2kfbx","a4bafe9676ed54e6":"6uPvi","fe0cd286d5f1ae75":"cOWTg"}],"2kfbx":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalComposerContext = require("ca74eb27cde545dd");
module.exports = LexicalComposerContext;

},{"ca74eb27cde545dd":"UDbuf"}],"UDbuf":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var d = require("a7c24b19bb275750");
function e(a) {
    let c = new URLSearchParams;
    c.append("code", a);
    for(let b = 1; b < arguments.length; b++)c.append("v", arguments[b]);
    throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?${c} for the full message or ` + "use the non-minified dev environment for full errors and additional helpful warnings.");
}
let f = d.createContext(null);
exports.LexicalComposerContext = f;
exports.createLexicalComposerContext = function(a, c) {
    let b = null;
    null != a && (b = a[1]);
    return {
        getTheme: function() {
            return null != c ? c : null != b ? b.getTheme() : null;
        }
    };
};
exports.useLexicalComposerContext = function() {
    let a = d.useContext(f);
    null == a && e(8);
    return a;
};

},{"a7c24b19bb275750":"cOWTg"}],"3VJcw":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalContentEditable = require("33ec7ea994c5ea9");
module.exports = LexicalContentEditable;

},{"33ec7ea994c5ea9":"jS6FK"}],"jS6FK":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var c = require("fd0da8807088ef25"), h = require("8870d4d0bd19f9d2");
function n() {
    n = Object.assign ? Object.assign.bind() : function(g) {
        for(var d = 1; d < arguments.length; d++){
            var e = arguments[d], b;
            for(b in e)Object.prototype.hasOwnProperty.call(e, b) && (g[b] = e[b]);
        }
        return g;
    };
    return n.apply(this, arguments);
}
var p = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement ? h.useLayoutEffect : h.useEffect;
exports.ContentEditable = function({ ariaActiveDescendant: g, ariaAutoComplete: d, ariaControls: e, ariaDescribedBy: b, ariaExpanded: q, ariaLabel: r, ariaLabelledBy: t, ariaMultiline: u, ariaOwns: v, ariaRequired: w, autoCapitalize: x, className: y, id: z, role: l = "textbox", spellCheck: A = !0, style: B, tabIndex: C, "data-testid": D, ...E }) {
    let [f] = c.useLexicalComposerContext(), [a, m] = h.useState(!1), F = h.useCallback((k)=>{
        f.setRootElement(k);
    }, [
        f
    ]);
    p(()=>{
        m(f.isEditable());
        return f.registerEditableListener((k)=>{
            m(k);
        });
    }, [
        f
    ]);
    return h.createElement("div", n({}, E, {
        "aria-activedescendant": a ? g : void 0,
        "aria-autocomplete": a ? d : "none",
        "aria-controls": a ? e : void 0,
        "aria-describedby": b,
        "aria-expanded": a ? "combobox" === l ? !!q : void 0 : void 0,
        "aria-label": r,
        "aria-labelledby": t,
        "aria-multiline": u,
        "aria-owns": a ? v : void 0,
        "aria-readonly": a ? void 0 : !0,
        "aria-required": w,
        autoCapitalize: x,
        className: y,
        contentEditable: a,
        "data-testid": D,
        id: z,
        ref: F,
        role: l,
        spellCheck: A,
        style: B,
        tabIndex: C
    }));
};

},{"fd0da8807088ef25":"2kfbx","8870d4d0bd19f9d2":"cOWTg"}],"epcXG":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalErrorBoundary = require("ad70c33854b7c658");
module.exports = LexicalErrorBoundary;

},{"ad70c33854b7c658":"bqeHl"}],"bqeHl":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var h = require("cf0f954fd9d1a328");
function m(b, c) {
    m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, a) {
        g.__proto__ = a;
        return g;
    };
    return m(b, c);
}
function n(b, c) {
    b.prototype = Object.create(c.prototype);
    b.prototype.constructor = b;
    m(b, c);
}
function r(b, c) {
    void 0 === b && (b = []);
    void 0 === c && (c = []);
    return b.length !== c.length || b.some(function(g, a) {
        return !Object.is(g, c[a]);
    });
}
var t = {
    error: null
}, u = function(b) {
    function c() {
        for(var a, d = arguments.length, f = Array(d), e = 0; e < d; e++)f[e] = arguments[e];
        a = b.call.apply(b, [
            this
        ].concat(f)) || this;
        a.state = t;
        a.resetErrorBoundary = function() {
            for(var k, p = arguments.length, q = Array(p), l = 0; l < p; l++)q[l] = arguments[l];
            null == a.props.onReset || (k = a.props).onReset.apply(k, q);
            a.reset();
        };
        return a;
    }
    n(c, b);
    c.getDerivedStateFromError = function(a) {
        return {
            error: a
        };
    };
    var g = c.prototype;
    g.reset = function() {
        this.setState(t);
    };
    g.componentDidCatch = function(a, d) {
        var f, e;
        null == (f = (e = this.props).onError) || f.call(e, a, d);
    };
    g.componentDidUpdate = function(a, d) {
        var f = this.props.resetKeys;
        if (null !== this.state.error && null !== d.error && r(a.resetKeys, f)) {
            var e, k;
            null == (e = (k = this.props).onResetKeysChange) || e.call(k, a.resetKeys, f);
            this.reset();
        }
    };
    g.render = function() {
        var a = this.state.error, d = this.props, f = d.fallbackRender, e = d.FallbackComponent;
        d = d.fallback;
        if (null !== a) {
            a = {
                error: a,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (h.isValidElement(d)) return d;
            if ("function" === typeof f) return f(a);
            if (e) return h.createElement(e, a);
            throw Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
        }
        return this.props.children;
    };
    return c;
}(h.Component);
module.exports = function({ children: b, onError: c }) {
    return h.createElement(u, {
        fallback: h.createElement("div", {
            style: {
                border: "1px solid #f00",
                color: "#f00",
                padding: "8px"
            }
        }, "An error was thrown."),
        onError: c
    }, b);
};

},{"cf0f954fd9d1a328":"cOWTg"}],"eV9p8":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalRichTextPlugin = require("409f186ccf4a912a");
module.exports = LexicalRichTextPlugin;

},{"409f186ccf4a912a":"ibgh9"}],"ibgh9":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = require("b2644595a0bf210"), g = require("1238272885e2211c"), l = require("184b60eba0ea616e"), m = require("188fc03b010f4f16"), n = require("9e829ad83809cd6b"), p = require("4b024b91593f79b5"), t = require("b20afd4f96495d34"), u = require("9f806c0239525bb3"), v = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement ? l.useLayoutEffect : l.useEffect;
function w(a) {
    return a.getEditorState().read(m.$canShowPlaceholderCurry(a.isComposing()));
}
function x(a) {
    let [d, c] = l.useState(()=>w(a));
    v(()=>{
        function e() {
            let f = w(a);
            c(f);
        }
        e();
        return n.mergeRegister(a.registerUpdateListener(()=>{
            e();
        }), a.registerEditableListener(()=>{
            e();
        }));
    }, [
        a
    ]);
    return d;
}
function y(a, d) {
    let [c, e] = l.useState(()=>a.getDecorators());
    v(()=>a.registerDecoratorListener((f)=>{
            p.flushSync(()=>{
                e(f);
            });
        }), [
        a
    ]);
    l.useEffect(()=>{
        e(a.getDecorators());
    }, [
        a
    ]);
    return l.useMemo(()=>{
        let f = [], q = Object.keys(c);
        for(let h = 0; h < q.length; h++){
            let k = q[h], A = l.createElement(d, {
                onError: (z)=>a._onError(z)
            }, l.createElement(l.Suspense, {
                fallback: null
            }, c[k])), r = a.getElementByKey(k);
            null !== r && f.push(p.createPortal(A, r, k));
        }
        return f;
    }, [
        d,
        c,
        a
    ]);
}
function B(a) {
    v(()=>n.mergeRegister(u.registerRichText(a), t.registerDragonSupport(a)), [
        a
    ]);
}
function C({ content: a }) {
    var [d] = b.useLexicalComposerContext();
    d = x(d);
    let c = g();
    return d ? "function" === typeof a ? a(c) : a : null;
}
exports.RichTextPlugin = function({ contentEditable: a, placeholder: d, ErrorBoundary: c }) {
    let [e] = b.useLexicalComposerContext();
    c = y(e, c);
    B(e);
    return l.createElement(l.Fragment, null, a, l.createElement(C, {
        content: d
    }), c);
};

},{"b2644595a0bf210":"2kfbx","1238272885e2211c":"gx1vo","184b60eba0ea616e":"cOWTg","188fc03b010f4f16":"51pTB","9e829ad83809cd6b":"1V3L7","4b024b91593f79b5":"aPjLf","b20afd4f96495d34":"4z6AY","9f806c0239525bb3":"kNqAc"}],"gx1vo":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const useLexicalEditable = require("149699190106c9d");
module.exports = useLexicalEditable;

},{"149699190106c9d":"gH89s"}],"gH89s":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = require("995c166e21bcc405"), k = require("cb388b319eab7339"), l = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement ? k.useLayoutEffect : k.useEffect;
function m(a) {
    let [c] = b.useLexicalComposerContext(), e = k.useMemo(()=>a(c), [
        c,
        a
    ]), d = k.useRef(e.initialValueFn()), [n, g] = k.useState(d.current);
    l(()=>{
        let { initialValueFn: p, subscribe: q } = e, f = p();
        d.current !== f && (d.current = f, g(f));
        return q((h)=>{
            d.current = h;
            g(h);
        });
    }, [
        e,
        a
    ]);
    return n;
}
function r(a) {
    return {
        initialValueFn: ()=>a.isEditable(),
        subscribe: (c)=>a.registerEditableListener(c)
    };
}
module.exports = function() {
    return m(r);
};

},{"995c166e21bcc405":"2kfbx","cb388b319eab7339":"cOWTg"}],"51pTB":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalText = require("9431c0500d3cfd39");
module.exports = LexicalText;

},{"9431c0500d3cfd39":"hVbhV"}],"hVbhV":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var g = require("fc70808f60a6c703");
function r(c, h = !0) {
    if (c) return !1;
    c = t();
    h && (c = c.trim());
    return "" === c;
}
function t() {
    return g.$getRoot().getTextContent();
}
function u(c) {
    if (!r(c, !1)) return !1;
    c = g.$getRoot().getChildren();
    let h = c.length;
    if (1 < h) return !1;
    for(let e = 0; e < h; e++){
        var b = c[e];
        if (g.$isDecoratorNode(b)) return !1;
        if (g.$isElementNode(b)) {
            if (!g.$isParagraphNode(b) || 0 !== b.__indent) return !1;
            b = b.getChildren();
            let n = b.length;
            for(let q = 0; q < n; q++)if (!g.$isTextNode(b[e])) return !1;
        }
    }
    return !0;
}
exports.$canShowPlaceholder = u;
exports.$canShowPlaceholderCurry = function(c) {
    return ()=>u(c);
};
exports.$findTextIntersectionFromCharacters = function(c, h) {
    var b = c.getFirstChild();
    c = 0;
    a: for(; null !== b;){
        if (g.$isElementNode(b)) {
            var e = b.getFirstChild();
            if (null !== e) {
                b = e;
                continue;
            }
        } else if (g.$isTextNode(b)) {
            e = b.getTextContentSize();
            if (c + e > h) return {
                node: b,
                offset: h - c
            };
            c += e;
        }
        e = b.getNextSibling();
        if (null !== e) b = e;
        else {
            for(b = b.getParent(); null !== b;){
                e = b.getNextSibling();
                if (null !== e) {
                    b = e;
                    continue a;
                }
                b = b.getParent();
            }
            break;
        }
    }
    return null;
};
exports.$isRootTextContentEmpty = r;
exports.$isRootTextContentEmptyCurry = function(c, h) {
    return ()=>r(c, h);
};
exports.$rootTextContent = t;
exports.registerLexicalTextEntity = function(c, h, b, e) {
    let n = (a)=>{
        const d = g.$createTextNode(a.getTextContent());
        d.setFormat(a.getFormat());
        a.replace(d);
    }, q = c.registerNodeTransform(g.TextNode, (a)=>{
        if (a.isSimpleText()) {
            var d = a.getPreviousSibling(), l = a.getTextContent(), m = a;
            if (g.$isTextNode(d)) {
                var k = d.getTextContent(), f = h(k + l);
                if (d instanceof b) {
                    if (null === f || 0 !== d.getLatest().__mode) {
                        n(d);
                        return;
                    }
                    f = f.end - k.length;
                    if (0 < f) {
                        m = l.slice(0, f);
                        m = k + m;
                        d.select();
                        d.setTextContent(m);
                        f === l.length ? a.remove() : (d = l.slice(f), a.setTextContent(d));
                        return;
                    }
                } else if (null === f || f.start < k.length) return;
            }
            for(;;){
                a = h(l);
                l = f = null === a ? "" : l.slice(a.end);
                if ("" === f) {
                    if (k = m.getNextSibling(), g.$isTextNode(k)) {
                        if (f = m.getTextContent() + k.getTextContent(), f = h(f), null === f) {
                            k instanceof b ? n(k) : k.markDirty();
                            break;
                        } else if (0 !== f.start) break;
                    }
                } else if (k = h(f), null !== k && 0 === k.start) break;
                if (null === a) break;
                if (0 === a.start && g.$isTextNode(d) && d.isTextEntity()) continue;
                let p;
                0 === a.start ? [p, m] = m.splitText(a.end) : [, p, m] = m.splitText(a.start, a.end);
                a = e(p);
                a.setFormat(p.getFormat());
                p.replace(a);
                if (null == m) break;
            }
        }
    });
    c = c.registerNodeTransform(b, (a)=>{
        var d = a.getTextContent();
        const l = h(d);
        null === l || 0 !== l.start ? n(a) : d.length > l.end ? a.splitText(l.end) : (d = a.getPreviousSibling(), g.$isTextNode(d) && d.isTextEntity() && (n(d), n(a)), d = a.getNextSibling(), g.$isTextNode(d) && d.isTextEntity() && (n(d), a instanceof b && n(a)));
    });
    return [
        q,
        c
    ];
};

},{"fc70808f60a6c703":"6uPvi"}],"4z6AY":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalDragon = require("14690c7ca22b4385");
module.exports = LexicalDragon;

},{"14690c7ca22b4385":"eJ87h"}],"eJ87h":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var g = require("2733015357a150dd");
exports.registerDragonSupport = function(m) {
    let t = window.location.origin, r = (l)=>{
        if (l.origin === t) {
            var h = m.getRootElement();
            if (document.activeElement === h && (h = l.data, "string" === typeof h)) {
                try {
                    var a = JSON.parse(h);
                } catch (k) {
                    return;
                }
                if (a && "nuanria_messaging" === a.protocol && "request" === a.type && (a = a.payload) && "makeChanges" === a.functionId && (a = a.args)) {
                    const [k, n, p, q, u] = a;
                    m.update(()=>{
                        const f = g.$getSelection();
                        if (g.$isRangeSelection(f)) {
                            var e = f.anchor;
                            let b = e.getNode(), c = 0, d = 0;
                            g.$isTextNode(b) && 0 <= k && 0 <= n && (c = k, d = k + n, f.setTextNodeRange(b, c, b, d));
                            if (c !== d || "" !== p) f.insertRawText(p), b = e.getNode();
                            g.$isTextNode(b) && (c = q, d = q + u, e = b.getTextContentSize(), c = c > e ? e : c, d = d > e ? e : d, f.setTextNodeRange(b, c, b, d));
                            l.stopImmediatePropagation();
                        }
                    });
                }
            }
        }
    };
    window.addEventListener("message", r, !0);
    return ()=>{
        window.removeEventListener("message", r, !0);
    };
};

},{"2733015357a150dd":"6uPvi"}],"6FvAU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE_MARKDOWN_CONFIG", ()=>BASE_MARKDOWN_CONFIG);
parcelHelpers.export(exports, "LINK_TRANSFORM", ()=>LINK_TRANSFORM);
parcelHelpers.export(exports, "TRANSFORMERS", ()=>TRANSFORMERS);
var _code = require("@lexical/code");
var _link = require("@lexical/link");
var _list = require("@lexical/list");
var _markdown = require("@lexical/markdown");
var _richText = require("@lexical/rich-text");
var _table = require("@lexical/table");
var _lexical = require("lexical");
var _markdownStylesWrapper = require("../components/MarkdownEditor/MarkdownStylesWrapper");
const BASE_MARKDOWN_CONFIG = {
    theme: (0, _markdownStylesWrapper.MarkdownTheme),
    nodes: [
        (0, _richText.HeadingNode),
        (0, _list.ListNode),
        (0, _list.ListItemNode),
        (0, _richText.QuoteNode),
        (0, _code.CodeNode),
        (0, _code.CodeHighlightNode),
        (0, _table.TableNode),
        (0, _table.TableCellNode),
        (0, _table.TableRowNode),
        (0, _link.AutoLinkNode),
        (0, _link.LinkNode)
    ]
};
/**
 * This is a patch to the markdown transformers in order to support nested lists
 * @see: https://github.com/facebook/lexical/issues/2214
 */ const listReplace = (listType, indentSize)=>{
    return (parentNode, children, match)=>{
        const previousNode = parentNode.getPreviousSibling();
        const listItem = (0, _list.$createListItemNode)(listType === "check" ? match[3] === "x" : undefined);
        if ((0, _list.$isListNode)(previousNode) && previousNode.getListType() === listType) {
            previousNode.append(listItem);
            parentNode.remove();
        } else {
            const list = (0, _list.$createListNode)(listType, listType === "number" ? Number(match[2]) : undefined);
            list.append(listItem);
            parentNode.replace(list);
        }
        listItem.append(...children);
        listItem.select(0, 0);
        const indent = Math.floor(match[1].length / indentSize);
        if (indent) listItem.setIndent(indent);
    };
};
const listExport = (listNode, exportChildren, depth, indentSize)=>{
    const output = [];
    const children = listNode.getChildren();
    let index = 0;
    for (const listItemNode of children)if ((0, _list.$isListItemNode)(listItemNode)) {
        if (listItemNode.getChildrenSize() === 1) {
            const firstChild = listItemNode.getFirstChild();
            if ((0, _list.$isListNode)(firstChild)) {
                output.push(listExport(firstChild, exportChildren, depth + 1, indentSize));
                continue;
            }
        }
        const indent = " ".repeat(depth * indentSize);
        const listType = listNode.getListType();
        const prefix = listType === "number" ? `${listNode.getStart() + index}. ` : listType === "check" ? `- [${listItemNode.getChecked() ? "x" : " "}] ` : "- ";
        output.push(indent + prefix + exportChildren(listItemNode));
        index++;
    }
    return output.join("\n");
};
const UNORDERED_LIST_TRANSFORM = {
    export: (node, exportChildren)=>{
        return (0, _list.$isListNode)(node) ? listExport(node, exportChildren, 0, 2) : null;
    },
    regExp: /^(\s*)[-*+]\s/,
    replace: listReplace("bullet", 2),
    type: "element",
    dependencies: []
};
const ORDERED_LIST_TRANSFORM = {
    export: (node, exportChildren)=>{
        return (0, _list.$isListNode)(node) ? listExport(node, exportChildren, 0, 3) : null;
    },
    regExp: /^(\s*)(\d{1,})\.\s/,
    replace: listReplace("number", 3),
    type: "element",
    dependencies: []
};
const LINK_TRANSFORM = {
    dependencies: [
        (0, _link.LinkNode)
    ],
    export: (node, exportChildren, exportFormat)=>{
        if (!(0, _link.$isLinkNode)(node)) return null;
        const title = node.getTitle();
        const linkContent = title ? `[${node.getTextContent()}](${node.getURL()} "${title}")` : `[${node.getTextContent()}](${node.getURL()})`;
        const firstChild = node.getFirstChild();
        // Add text styles only if link has single text node inside. If it's more
        // then one we ignore it as markdown does not support nested styles for links
        if (node.getChildrenSize() === 1 && (0, _lexical.$isTextNode)(firstChild)) return exportFormat(firstChild, linkContent);
        else return linkContent;
    },
    importRegExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
    regExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
    replace: (textNode, match)=>{
        const [, linkText, linkUrl, linkTitle] = match;
        const linkNode = (0, _link.$createLinkNode)(linkUrl, {
            title: linkTitle,
            rel: "noopener",
            target: "_target"
        });
        const linkTextNode = (0, _lexical.$createTextNode)(linkText);
        linkTextNode.setFormat(textNode.getFormat());
        linkNode.append(linkTextNode);
        textNode.replace(linkNode);
    },
    trigger: ")",
    type: "text-match"
};
const ELEMENT_TRANSFORMERS = [
    (0, _markdown.HEADING),
    (0, _markdown.QUOTE),
    (0, _markdown.CODE),
    ORDERED_LIST_TRANSFORM,
    (0, _markdown.CHECK_LIST),
    UNORDERED_LIST_TRANSFORM
];
// Order of text format transformers matters:
//
// - code should go first as it prevents any transformations inside
// - then longer tags match (e.g. ** or __ should go before * or _)
const TEXT_FORMAT_TRANSFORMERS = [
    (0, _markdown.INLINE_CODE),
    (0, _markdown.BOLD_ITALIC_STAR),
    (0, _markdown.BOLD_ITALIC_UNDERSCORE),
    (0, _markdown.BOLD_STAR),
    (0, _markdown.BOLD_UNDERSCORE),
    (0, _markdown.ITALIC_STAR),
    (0, _markdown.ITALIC_UNDERSCORE),
    (0, _markdown.STRIKETHROUGH)
];
const TEXT_MATCH_TRANSFORMERS = [
    LINK_TRANSFORM
];
const TRANSFORMERS = [
    ...ELEMENT_TRANSFORMERS,
    ...TEXT_FORMAT_TRANSFORMERS,
    ...TEXT_MATCH_TRANSFORMERS
]; /**
 * End of patch
 */ 

},{"@lexical/code":"7QLm2","@lexical/link":"2MxRL","@lexical/list":"2CQxU","@lexical/markdown":"a7yhR","@lexical/rich-text":"kNqAc","@lexical/table":"4T2bV","lexical":"6uPvi","../components/MarkdownEditor/MarkdownStylesWrapper":"glWzc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4T2bV":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalTable = require("4f3c539c8773d122");
module.exports = LexicalTable;

},{"4f3c539c8773d122":"9XnwO"}],"9XnwO":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var d = require("cb5443f41dd7b032"), v = require("903b00d6e14c7fbc");
function w(a) {
    let b = new URLSearchParams;
    b.append("code", a);
    for(let c = 1; c < arguments.length; c++)b.append("v", arguments[c]);
    throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?${b} for the full message or ` + "use the non-minified dev environment for full errors and additional helpful warnings.");
}
class y extends d.INTERNAL_PointSelection {
    constructor(a, b, c){
        super(b, c);
        this.gridKey = a;
    }
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(a) {
        this._cachedNodes = a;
    }
    is(a) {
        return z(a) ? this.gridKey === a.gridKey && this.anchor.is(a.anchor) && this.focus.is(a.focus) : !1;
    }
    set(a, b, c) {
        this.dirty = !0;
        this.gridKey = a;
        this.anchor.key = b;
        this.focus.key = c;
        this._cachedNodes = null;
    }
    clone() {
        return new y(this.gridKey, this.anchor, this.focus);
    }
    isCollapsed() {
        return !1;
    }
    extract() {
        return this.getNodes();
    }
    insertRawText() {}
    insertText() {}
    insertNodes(a) {
        let b = this.focus.getNode();
        if (!d.$isElementNode(b)) throw Error("Expected GridSelection focus to be an ElementNode");
        d.$normalizeSelection__EXPERIMENTAL(b.select(0, b.getChildrenSize())).insertNodes(a);
    }
    getShape() {
        var a = d.$getNodeByKey(this.anchor.key);
        d.DEPRECATED_$isGridCellNode(a) || w(103);
        a = d.DEPRECATED_$getGridCellNodeRect(a);
        if (null === a) throw Error("getCellRect: expected to find AnchorNode");
        var b = d.$getNodeByKey(this.focus.key);
        d.DEPRECATED_$isGridCellNode(b) || w(104);
        let c = d.DEPRECATED_$getGridCellNodeRect(b);
        if (null === c) throw Error("getCellRect: expected to find focusCellNode");
        b = Math.min(a.columnIndex, c.columnIndex);
        let e = Math.max(a.columnIndex, c.columnIndex), f = Math.min(a.rowIndex, c.rowIndex);
        a = Math.max(a.rowIndex, c.rowIndex);
        return {
            fromX: Math.min(b, e),
            fromY: Math.min(f, a),
            toX: Math.max(b, e),
            toY: Math.max(f, a)
        };
    }
    getNodes() {
        function a(t) {
            let { cell: x, startColumn: B, startRow: C } = t;
            q = Math.min(q, B);
            u = Math.min(u, C);
            h = Math.max(h, B + x.__colSpan - 1);
            l = Math.max(l, C + x.__rowSpan - 1);
        }
        var b = this._cachedNodes;
        if (null !== b) return b;
        var c = this.anchor.getNode();
        b = this.focus.getNode();
        var e = v.$findMatchingParent(c, d.DEPRECATED_$isGridCellNode);
        c = v.$findMatchingParent(b, d.DEPRECATED_$isGridCellNode);
        d.DEPRECATED_$isGridCellNode(e) || w(103);
        d.DEPRECATED_$isGridCellNode(c) || w(104);
        b = e.getParent();
        d.DEPRECATED_$isGridRowNode(b) || w(105);
        b = b.getParent();
        d.DEPRECATED_$isGridNode(b) || w(106);
        var f = c.getParents()[1];
        if (f !== b) {
            if (b.isParentOf(c)) {
                b = f.getParent();
                if (null == b) throw Error("Expected focusCellParent to have a parent");
                this.set(this.gridKey, c.getKey(), b.getKey());
            } else {
                b = b.getParent();
                if (null == b) throw Error("Expected gridParent to have a parent");
                this.set(this.gridKey, b.getKey(), c.getKey());
            }
            return this.getNodes();
        }
        let [k, g, m] = d.DEPRECATED_$computeGridMap(b, e, c), q = Math.min(g.startColumn, m.startColumn), u = Math.min(g.startRow, m.startRow), h = Math.max(g.startColumn + g.cell.__colSpan - 1, m.startColumn + m.cell.__colSpan - 1), l = Math.max(g.startRow + g.cell.__rowSpan - 1, m.startRow + m.cell.__rowSpan - 1);
        c = q;
        e = u;
        f = q;
        for(var n = u; q < c || u < e || h > f || l > n;){
            if (q < c) {
                var p = n - e;
                --c;
                for(var r = 0; r <= p; r++)a(k[e + r][c]);
            }
            if (u < e) for(p = f - c, --e, r = 0; r <= p; r++)a(k[e][c + r]);
            if (h > f) for(p = n - e, f += 1, r = 0; r <= p; r++)a(k[e + r][f]);
            if (l > n) for(p = f - c, n += 1, r = 0; r <= p; r++)a(k[n][c + r]);
        }
        b = [
            b
        ];
        c = null;
        for(e = u; e <= l; e++)for(f = q; f <= h; f++)({ cell: n } = k[e][f]), p = n.getParent(), d.DEPRECATED_$isGridRowNode(p) || w(107), p !== c && b.push(p), b.push(n, ...aa(n)), c = p;
        d.isCurrentlyReadOnlyMode() || (this._cachedNodes = b);
        return b;
    }
    getTextContent() {
        let a = this.getNodes(), b = "";
        for(let c = 0; c < a.length; c++)b += a[c].getTextContent();
        return b;
    }
}
function z(a) {
    return a instanceof y;
}
function A() {
    let a = d.$createPoint("root", 0, "element"), b = d.$createPoint("root", 0, "element");
    return new y("root", a, b);
}
function aa(a) {
    let b = [], c = [
        a
    ];
    for(; 0 < c.length;){
        let e = c.pop();
        void 0 === e && w(112);
        d.$isElementNode(e) && c.unshift(...e.getChildren());
        e !== a && b.push(e);
    }
    return b;
}
let ba = /^(\d+(?:\.\d+)?)px$/, D = {
    BOTH: 3,
    COLUMN: 2,
    NO_STATUS: 0,
    ROW: 1
};
class F extends d.DEPRECATED_GridCellNode {
    static getType() {
        return "tablecell";
    }
    static clone(a) {
        let b = new F(a.__headerState, a.__colSpan, a.__width, a.__key);
        b.__rowSpan = a.__rowSpan;
        b.__backgroundColor = a.__backgroundColor;
        return b;
    }
    static importDOM() {
        return {
            td: ()=>({
                    conversion: ca,
                    priority: 0
                }),
            th: ()=>({
                    conversion: ca,
                    priority: 0
                })
        };
    }
    static importJSON(a) {
        let b = a.rowSpan || 1, c = G(a.headerState, a.colSpan || 1, a.width || void 0);
        c.__rowSpan = b;
        c.__backgroundColor = a.backgroundColor || null;
        return c;
    }
    constructor(a = D.NO_STATUS, b = 1, c, e){
        super(b, e);
        this.__headerState = a;
        this.__width = c;
        this.__backgroundColor = null;
    }
    createDOM(a) {
        let b = document.createElement(this.getTag());
        this.__width && (b.style.width = `${this.__width}px`);
        1 < this.__colSpan && (b.colSpan = this.__colSpan);
        1 < this.__rowSpan && (b.rowSpan = this.__rowSpan);
        null !== this.__backgroundColor && (b.style.backgroundColor = this.__backgroundColor);
        v.addClassNamesToElement(b, a.theme.tableCell, this.hasHeader() && a.theme.tableCellHeader);
        return b;
    }
    exportDOM(a) {
        ({ element: a } = super.exportDOM(a));
        if (a) {
            var b = this.getParentOrThrow().getChildrenSize();
            a.style.border = "1px solid black";
            1 < this.__colSpan && (a.colSpan = this.__colSpan);
            1 < this.__rowSpan && (a.rowSpan = this.__rowSpan);
            a.style.width = `${this.getWidth() || Math.max(90, 700 / b)}px`;
            a.style.verticalAlign = "top";
            a.style.textAlign = "start";
            b = this.getBackgroundColor();
            null !== b ? a.style.backgroundColor = b : this.hasHeader() && (a.style.backgroundColor = "#f2f3f5");
        }
        return {
            element: a
        };
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            backgroundColor: this.getBackgroundColor(),
            headerState: this.__headerState,
            type: "tablecell",
            width: this.getWidth()
        };
    }
    getTag() {
        return this.hasHeader() ? "th" : "td";
    }
    setHeaderStyles(a) {
        this.getWritable().__headerState = a;
        return this.__headerState;
    }
    getHeaderStyles() {
        return this.getLatest().__headerState;
    }
    setWidth(a) {
        this.getWritable().__width = a;
        return this.__width;
    }
    getWidth() {
        return this.getLatest().__width;
    }
    getBackgroundColor() {
        return this.getLatest().__backgroundColor;
    }
    setBackgroundColor(a) {
        this.getWritable().__backgroundColor = a;
    }
    toggleHeaderStyle(a) {
        let b = this.getWritable();
        b.__headerState = (b.__headerState & a) === a ? b.__headerState - a : b.__headerState + a;
        return b;
    }
    hasHeaderState(a) {
        return (this.getHeaderStyles() & a) === a;
    }
    hasHeader() {
        return this.getLatest().__headerState !== D.NO_STATUS;
    }
    updateDOM(a) {
        return a.__headerState !== this.__headerState || a.__width !== this.__width || a.__colSpan !== this.__colSpan || a.__rowSpan !== this.__rowSpan || a.__backgroundColor !== this.__backgroundColor;
    }
    isShadowRoot() {
        return !0;
    }
    collapseAtStart() {
        return !0;
    }
    canBeEmpty() {
        return !1;
    }
    canIndent() {
        return !1;
    }
}
function ca(a) {
    var b = a.nodeName.toLowerCase();
    let c = void 0;
    ba.test(a.style.width) && (c = parseFloat(a.style.width));
    b = G("th" === b ? D.ROW : D.NO_STATUS, a.colSpan, c);
    b.__rowSpan = a.rowSpan;
    a = a.style.backgroundColor;
    "" !== a && (b.__backgroundColor = a);
    return {
        forChild: (e, f)=>{
            if (H(f) && !d.$isElementNode(e)) {
                f = d.$createParagraphNode();
                if (d.$isLineBreakNode(e) && "\n" === e.getTextContent()) return null;
                f.append(e);
                return f;
            }
            return e;
        },
        node: b
    };
}
function G(a, b = 1, c) {
    return d.$applyNodeReplacement(new F(a, b, c));
}
function H(a) {
    return a instanceof F;
}
class J extends d.DEPRECATED_GridRowNode {
    static getType() {
        return "tablerow";
    }
    static clone(a) {
        return new J(a.__height, a.__key);
    }
    static importDOM() {
        return {
            tr: ()=>({
                    conversion: da,
                    priority: 0
                })
        };
    }
    static importJSON(a) {
        return K(a.height);
    }
    constructor(a, b){
        super(b);
        this.__height = a;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "tablerow",
            version: 1
        };
    }
    createDOM(a) {
        let b = document.createElement("tr");
        this.__height && (b.style.height = `${this.__height}px`);
        v.addClassNamesToElement(b, a.theme.tableRow);
        return b;
    }
    isShadowRoot() {
        return !0;
    }
    setHeight(a) {
        this.getWritable().__height = a;
        return this.__height;
    }
    getHeight() {
        return this.getLatest().__height;
    }
    updateDOM(a) {
        return a.__height !== this.__height;
    }
    canBeEmpty() {
        return !1;
    }
    canIndent() {
        return !1;
    }
}
function da(a) {
    let b = void 0;
    ba.test(a.style.height) && (b = parseFloat(a.style.height));
    return {
        node: K(b)
    };
}
function K(a) {
    return d.$applyNodeReplacement(new J(a));
}
function L(a) {
    return a instanceof J;
}
let ea = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement;
class fa {
    constructor(a, b){
        this.isHighlightingCells = !1;
        this.focusY = this.focusX = this.anchorY = this.anchorX = -1;
        this.listenersToRemove = new Set;
        this.tableNodeKey = b;
        this.editor = a;
        this.grid = {
            cells: [],
            columns: 0,
            rows: 0
        };
        this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null;
        this.hasHijackedSelectionStyles = !1;
        this.trackTableGrid();
    }
    getGrid() {
        return this.grid;
    }
    removeListeners() {
        Array.from(this.listenersToRemove).forEach((a)=>a());
    }
    trackTableGrid() {
        let a = new MutationObserver((b)=>{
            this.editor.update(()=>{
                var c = !1;
                for(let e = 0; e < b.length; e++){
                    const f = b[e].target.nodeName;
                    if ("TABLE" === f || "TR" === f) {
                        c = !0;
                        break;
                    }
                }
                if (c) {
                    c = this.editor.getElementByKey(this.tableNodeKey);
                    if (!c) throw Error("Expected to find TableElement in DOM");
                    this.grid = M(c);
                }
            });
        });
        this.editor.update(()=>{
            let b = this.editor.getElementByKey(this.tableNodeKey);
            if (!b) throw Error("Expected to find TableElement in DOM");
            this.grid = M(b);
            a.observe(b, {
                childList: !0,
                subtree: !0
            });
        });
    }
    clearHighlight() {
        let a = this.editor;
        this.isHighlightingCells = !1;
        this.focusY = this.focusX = this.anchorY = this.anchorX = -1;
        this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null;
        this.hasHijackedSelectionStyles = !1;
        this.enableHighlightStyle();
        a.update(()=>{
            var b = d.$getNodeByKey(this.tableNodeKey);
            if (!N(b)) throw Error("Expected TableNode.");
            b = a.getElementByKey(this.tableNodeKey);
            if (!b) throw Error("Expected to find TableElement in DOM");
            b = M(b);
            R(a, b, null);
            d.$setSelection(null);
            a.dispatchCommand(d.SELECTION_CHANGE_COMMAND, void 0);
        });
    }
    enableHighlightStyle() {
        let a = this.editor;
        a.update(()=>{
            let b = a.getElementByKey(this.tableNodeKey);
            if (!b) throw Error("Expected to find TableElement in DOM");
            v.removeClassNamesFromElement(b, a._config.theme.tableSelection);
            b.classList.remove("disable-selection");
            this.hasHijackedSelectionStyles = !1;
        });
    }
    disableHighlightStyle() {
        let a = this.editor;
        a.update(()=>{
            let b = a.getElementByKey(this.tableNodeKey);
            if (!b) throw Error("Expected to find TableElement in DOM");
            v.addClassNamesToElement(b, a._config.theme.tableSelection);
            this.hasHijackedSelectionStyles = !0;
        });
    }
    updateTableGridSelection(a) {
        if (null != a && a.gridKey === this.tableNodeKey) {
            let b = this.editor;
            this.gridSelection = a;
            this.isHighlightingCells = !0;
            this.disableHighlightStyle();
            R(b, this.grid, this.gridSelection);
        } else null == a ? this.clearHighlight() : (this.tableNodeKey = a.gridKey, this.updateTableGridSelection(a));
    }
    setFocusCellForSelection(a, b = !1) {
        let c = this.editor;
        c.update(()=>{
            var e = d.$getNodeByKey(this.tableNodeKey);
            if (!N(e)) throw Error("Expected TableNode.");
            if (!c.getElementByKey(this.tableNodeKey)) throw Error("Expected to find TableElement in DOM");
            e = a.x;
            let f = a.y;
            this.focusCell = a;
            if (null !== this.anchorCell) {
                let k = ea ? (c._window || window).getSelection() : null;
                k && k.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
            }
            if (!this.isHighlightingCells && (this.anchorX !== e || this.anchorY !== f || b)) this.isHighlightingCells = !0, this.disableHighlightStyle();
            else if (e === this.focusX && f === this.focusY) return;
            this.focusX = e;
            this.focusY = f;
            this.isHighlightingCells && (e = d.$getNearestNodeFromDOMNode(a.elem), null != this.gridSelection && null != this.anchorCellNodeKey && H(e) && (e = e.getKey(), this.gridSelection = this.gridSelection.clone() || A(), this.focusCellNodeKey = e, this.gridSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), d.$setSelection(this.gridSelection), c.dispatchCommand(d.SELECTION_CHANGE_COMMAND, void 0), R(c, this.grid, this.gridSelection)));
        });
    }
    setAnchorCellForSelection(a) {
        this.isHighlightingCells = !1;
        this.anchorCell = a;
        this.anchorX = a.x;
        this.anchorY = a.y;
        this.editor.update(()=>{
            var b = d.$getNearestNodeFromDOMNode(a.elem);
            H(b) && (b = b.getKey(), this.gridSelection = null != this.gridSelection ? this.gridSelection.clone() : A(), this.anchorCellNodeKey = b);
        });
    }
    formatCells(a) {
        this.editor.update(()=>{
            let b = d.$getSelection();
            z(b) || w(11);
            let c = d.$createRangeSelection(), e = c.anchor, f = c.focus;
            b.getNodes().forEach((k)=>{
                H(k) && 0 !== k.getTextContentSize() && (e.set(k.getKey(), 0, "element"), f.set(k.getKey(), k.getChildrenSize(), "element"), c.formatText(a));
            });
            d.$setSelection(b);
            this.editor.dispatchCommand(d.SELECTION_CHANGE_COMMAND, void 0);
        });
    }
    clearText() {
        let a = this.editor;
        a.update(()=>{
            let b = d.$getNodeByKey(this.tableNodeKey);
            if (!N(b)) throw Error("Expected TableNode.");
            var c = d.$getSelection();
            z(c) || w(11);
            c = c.getNodes().filter(H);
            c.length === this.grid.columns * this.grid.rows ? (b.selectPrevious(), b.remove(), d.$getRoot().selectStart()) : (c.forEach((e)=>{
                if (d.$isElementNode(e)) {
                    let f = d.$createParagraphNode(), k = d.$createTextNode();
                    f.append(k);
                    e.append(f);
                    e.getChildren().forEach((g)=>{
                        g !== f && g.remove();
                    });
                }
            }), R(a, this.grid, null), d.$setSelection(null), a.dispatchCommand(d.SELECTION_CHANGE_COMMAND, void 0));
        });
    }
}
function ha(a) {
    for(; null != a;){
        let b = a.nodeName;
        if ("TD" === b || "TH" === b) {
            a = a._cell;
            if (void 0 === a) break;
            return a;
        }
        a = a.parentNode;
    }
    return null;
}
function M(a) {
    let b = [], c = {
        cells: b,
        columns: 0,
        rows: 0
    };
    var e = a.firstChild;
    let f = a = 0;
    for(b.length = 0; null != e;){
        var k = e.nodeName;
        if ("TD" === k || "TH" === k) {
            k = e;
            k = {
                elem: k,
                hasBackgroundColor: "" !== k.style.backgroundColor,
                highlighted: !1,
                x: a,
                y: f
            };
            e._cell = k;
            let g = b[f];
            void 0 === g && (g = b[f] = []);
            g[a] = k;
        } else if (k = e.firstChild, null != k) {
            e = k;
            continue;
        }
        k = e.nextSibling;
        if (null != k) a++, e = k;
        else if (k = e.parentNode, null != k) {
            e = k.nextSibling;
            if (null == e) break;
            f++;
            a = 0;
        }
    }
    c.columns = a + 1;
    c.rows = f + 1;
    return c;
}
function R(a, b, c) {
    let e = new Set(c ? c.getNodes() : []);
    ka(b, (f, k)=>{
        let g = f.elem;
        e.has(k) ? (f.highlighted = !0, la(a, f)) : (f.highlighted = !1, ma(a, f), g.getAttribute("style") || g.removeAttribute("style"));
    });
}
function ka(a, b) {
    ({ cells: a } = a);
    for(let c = 0; c < a.length; c++){
        let e = a[c];
        if (e) for(let f = 0; f < e.length; f++){
            let k = e[f];
            if (!k) continue;
            let g = d.$getNearestNodeFromDOMNode(k.elem);
            null !== g && b(k, g, {
                x: f,
                y: c
            });
        }
    }
}
function na(a, b) {
    b.disableHighlightStyle();
    ka(b.grid, (c)=>{
        c.highlighted = !0;
        la(a, c);
    });
}
function oa(a, b) {
    b.enableHighlightStyle();
    ka(b.grid, (c)=>{
        let e = c.elem;
        c.highlighted = !1;
        ma(a, c);
        e.getAttribute("style") || e.removeAttribute("style");
    });
}
let pa = (a, b, c, e, f)=>{
    const k = "forward" === f;
    switch(f){
        case "backward":
        case "forward":
            return c !== (k ? a.grid.columns - 1 : 0) ? (a = b.getCellNodeFromCordsOrThrow(c + (k ? 1 : -1), e, a.grid), k ? a.selectStart() : a.selectEnd()) : e !== (k ? a.grid.rows - 1 : 0) ? (a = b.getCellNodeFromCordsOrThrow(k ? 0 : a.grid.columns - 1, e + (k ? 1 : -1), a.grid), k ? a.selectStart() : a.selectEnd()) : k ? b.selectNext() : b.selectPrevious(), !0;
        case "up":
            return 0 !== e ? b.getCellNodeFromCordsOrThrow(c, e - 1, a.grid).selectEnd() : b.selectPrevious(), !0;
        case "down":
            return e !== a.grid.rows - 1 ? b.getCellNodeFromCordsOrThrow(c, e + 1, a.grid).selectStart() : b.selectNext(), !0;
        default:
            return !1;
    }
}, qa = (a, b, c, e, f)=>{
    const k = "forward" === f;
    switch(f){
        case "backward":
        case "forward":
            return c !== (k ? a.grid.columns - 1 : 0) && a.setFocusCellForSelection(b.getCellFromCordsOrThrow(c + (k ? 1 : -1), e, a.grid)), !0;
        case "up":
            return 0 !== e ? (a.setFocusCellForSelection(b.getCellFromCordsOrThrow(c, e - 1, a.grid)), !0) : !1;
        case "down":
            return e !== a.grid.rows - 1 ? (a.setFocusCellForSelection(b.getCellFromCordsOrThrow(c, e + 1, a.grid)), !0) : !1;
        default:
            return !1;
    }
};
function S(a, b) {
    if (d.$isRangeSelection(a) || z(a)) {
        let c = b.isParentOf(a.anchor.getNode());
        a = b.isParentOf(a.focus.getNode());
        return c && a;
    }
    return !1;
}
function la(a, b) {
    a = b.elem;
    b = d.$getNearestNodeFromDOMNode(a);
    H(b) || w(131);
    null === b.getBackgroundColor() ? a.style.setProperty("background-color", "rgb(172,206,247)") : a.style.setProperty("background-image", "linear-gradient(to right, rgba(172,206,247,0.85), rgba(172,206,247,0.85))");
    a.style.setProperty("caret-color", "transparent");
}
function ma(a, b) {
    a = b.elem;
    b = d.$getNearestNodeFromDOMNode(a);
    H(b) || w(131);
    null === b.getBackgroundColor() && a.style.removeProperty("background-color");
    a.style.removeProperty("background-image");
    a.style.removeProperty("caret-color");
}
function ra(a) {
    a = v.$findMatchingParent(a, H);
    return H(a) ? a : null;
}
function ta(a) {
    a = v.$findMatchingParent(a, N);
    return N(a) ? a : null;
}
function T(a, b, c, e, f) {
    let k = d.$getSelection();
    if (!S(k, e)) return !1;
    if (d.$isRangeSelection(k) && k.isCollapsed()) {
        if ("backward" === c || "forward" === c) return !1;
        let { anchor: u, focus: h } = k;
        var g = v.$findMatchingParent(u.getNode(), H), m = v.$findMatchingParent(h.getNode(), H);
        if (!H(g) || !g.is(m)) return !1;
        m = ta(g);
        if (m !== e && null != m) {
            var q = a.getElementByKey(m.getKey());
            if (null != q) return f.grid = M(q), T(a, b, c, m, f);
        }
        m = a.getElementByKey(g.__key);
        q = a.getElementByKey(u.key);
        if (null == q || null == m) return !1;
        if ("element" === u.type) m = q.getBoundingClientRect();
        else {
            m = window.getSelection();
            if (null === m || 0 === m.rangeCount) return !1;
            m = m.getRangeAt(0).getBoundingClientRect();
        }
        q = "up" === c ? g.getFirstChild() : g.getLastChild();
        if (null == q) return !1;
        a = a.getElementByKey(q.__key);
        if (null == a) return !1;
        a = a.getBoundingClientRect();
        if ("up" === c ? a.top > m.top - m.height : m.bottom + m.height > a.bottom) {
            U(b);
            a = e.getCordsFromCellNode(g, f.grid);
            if (b.shiftKey) c = e.getCellFromCordsOrThrow(a.x, a.y, f.grid), f.setAnchorCellForSelection(c), f.setFocusCellForSelection(c, !0);
            else return pa(f, e, a.x, a.y, c);
            return !0;
        }
    } else if (z(k)) {
        let { anchor: u, focus: h } = k;
        q = v.$findMatchingParent(u.getNode(), H);
        m = v.$findMatchingParent(h.getNode(), H);
        [g] = k.getNodes();
        a = a.getElementByKey(g.getKey());
        if (!H(q) || !H(m) || !N(g) || null == a) return !1;
        f.updateTableGridSelection(k);
        a = M(a);
        q = e.getCordsFromCellNode(q, a);
        q = e.getCellFromCordsOrThrow(q.x, q.y, a);
        f.setAnchorCellForSelection(q);
        U(b);
        if (b.shiftKey) return b = e.getCordsFromCellNode(m, a), qa(f, g, b.x, b.y, c);
        m.selectEnd();
        return !0;
    }
    return !1;
}
function U(a) {
    a.preventDefault();
    a.stopImmediatePropagation();
    a.stopPropagation();
}
class V extends d.DEPRECATED_GridNode {
    static getType() {
        return "table";
    }
    static clone(a) {
        return new V(a.__key);
    }
    static importDOM() {
        return {
            table: ()=>({
                    conversion: ua,
                    priority: 1
                })
        };
    }
    static importJSON() {
        return W();
    }
    constructor(a){
        super(a);
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: "table",
            version: 1
        };
    }
    createDOM(a) {
        let b = document.createElement("table");
        v.addClassNamesToElement(b, a.theme.table);
        return b;
    }
    updateDOM() {
        return !1;
    }
    exportDOM(a) {
        return {
            ...super.exportDOM(a),
            after: (b)=>{
                if (b) {
                    let c = b.cloneNode(), e = document.createElement("colgroup"), f = document.createElement("tbody");
                    v.isHTMLElement(b) && f.append(...b.children);
                    b = this.getFirstChildOrThrow();
                    if (!L(b)) throw Error("Expected to find row node.");
                    b = b.getChildrenSize();
                    for(let k = 0; k < b; k++){
                        let g = document.createElement("col");
                        e.append(g);
                    }
                    c.replaceChildren(e, f);
                    return c;
                }
            }
        };
    }
    canExtractContents() {
        return !1;
    }
    canBeEmpty() {
        return !1;
    }
    isShadowRoot() {
        return !0;
    }
    getCordsFromCellNode(a, b) {
        let { rows: c, cells: e } = b;
        for(b = 0; b < c; b++){
            var f = e[b];
            if (null != f && (f = f.findIndex((k)=>{
                if (k) return { elem: k } = k, d.$getNearestNodeFromDOMNode(k) === a;
            }), -1 !== f)) return {
                x: f,
                y: b
            };
        }
        throw Error("Cell not found in table.");
    }
    getCellFromCords(a, b, c) {
        ({ cells: c } = c);
        b = c[b];
        if (null == b) return null;
        a = b[a];
        return null == a ? null : a;
    }
    getCellFromCordsOrThrow(a, b, c) {
        a = this.getCellFromCords(a, b, c);
        if (!a) throw Error("Cell not found at cords.");
        return a;
    }
    getCellNodeFromCords(a, b, c) {
        a = this.getCellFromCords(a, b, c);
        if (null == a) return null;
        a = d.$getNearestNodeFromDOMNode(a.elem);
        return H(a) ? a : null;
    }
    getCellNodeFromCordsOrThrow(a, b, c) {
        a = this.getCellNodeFromCords(a, b, c);
        if (!a) throw Error("Node at cords not TableCellNode.");
        return a;
    }
    canSelectBefore() {
        return !0;
    }
    canIndent() {
        return !1;
    }
}
function ua() {
    return {
        node: W()
    };
}
function W() {
    return d.$applyNodeReplacement(new V);
}
function N(a) {
    return a instanceof V;
}
function va(a) {
    a = v.$findMatchingParent(a, (b)=>L(b));
    if (L(a)) return a;
    throw Error("Expected table cell to be inside of table row.");
}
function wa(a) {
    a = v.$findMatchingParent(a, (b)=>N(b));
    if (N(a)) return a;
    throw Error("Expected table cell to be inside of table.");
}
function xa(a, b) {
    let c = wa(a), { x: e, y: f } = c.getCordsFromCellNode(a, b);
    return {
        above: c.getCellNodeFromCords(e, f - 1, b),
        below: c.getCellNodeFromCords(e, f + 1, b),
        left: c.getCellNodeFromCords(e - 1, f, b),
        right: c.getCellNodeFromCords(e + 1, f, b)
    };
}
function Z(a) {
    let b = a.getFirstDescendant();
    null == b ? a.selectStart() : b.getParentOrThrow().selectStart();
}
function ya(a, b) {
    let c = a.getFirstChild();
    null !== c ? c.insertBefore(b) : a.append(b);
}
let za = d.createCommand("INSERT_TABLE_COMMAND");
exports.$createGridSelection = A;
exports.$createTableCellNode = G;
exports.$createTableNode = W;
exports.$createTableNodeWithDimensions = function(a, b, c = !0) {
    let e = W();
    for(let k = 0; k < a; k++){
        let g = K();
        for(let m = 0; m < b; m++){
            var f = D.NO_STATUS;
            "object" === typeof c ? (0 === k && c.rows && (f |= D.ROW), 0 === m && c.columns && (f |= D.COLUMN)) : c && (0 === k && (f |= D.ROW), 0 === m && (f |= D.COLUMN));
            f = G(f);
            let q = d.$createParagraphNode();
            q.append(d.$createTextNode());
            f.append(q);
            g.append(f);
        }
        e.append(g);
    }
    return e;
};
exports.$createTableRowNode = K;
exports.$deleteTableColumn = function(a, b) {
    let c = a.getChildren();
    for(let f = 0; f < c.length; f++){
        var e = c[f];
        if (L(e)) {
            e = e.getChildren();
            if (b >= e.length || 0 > b) throw Error("Table column target index out of range");
            e[b].remove();
        }
    }
    return a;
};
exports.$deleteTableColumn__EXPERIMENTAL = function() {
    var a = d.$getSelection();
    if (!d.$INTERNAL_isPointSelection(a)) throw Error("Expected a INTERNAL_PointSelection");
    var b = a.anchor.getNode();
    a = a.focus.getNode();
    let [c, , e] = d.DEPRECATED_$getNodeTriplet(b);
    [b] = d.DEPRECATED_$getNodeTriplet(a);
    let [f, k, g] = d.DEPRECATED_$computeGridMap(e, c, b);
    var { startColumn: m } = k;
    let { startRow: q, startColumn: u } = g;
    a = Math.min(m, u);
    m = Math.max(m + c.__colSpan - 1, u + b.__colSpan - 1);
    let h = m - a + 1;
    if (f[0].length === m - a + 1) e.selectPrevious(), e.remove();
    else {
        var l = f.length;
        for(let n = 0; n < l; n++)for(let p = a; p <= m; p++){
            let { cell: r, startColumn: t } = f[n][p];
            t < a ? p === a && r.setColSpan(r.__colSpan - Math.min(h, r.__colSpan - (a - t))) : t + r.__colSpan - 1 > m ? p === m && r.setColSpan(r.__colSpan - (m - t + 1)) : r.remove();
        }
        a = f[q];
        b = a[u + b.__colSpan];
        void 0 !== b ? ({ cell: b } = b, Z(b)) : ({ cell: b } = a[u - 1], Z(b));
    }
};
exports.$deleteTableRow__EXPERIMENTAL = function() {
    var a = d.$getSelection();
    if (!d.$INTERNAL_isPointSelection(a)) throw Error("Expected a INTERNAL_PointSelection");
    var b = a.anchor.getNode();
    a = a.focus.getNode();
    let [c, , e] = d.DEPRECATED_$getNodeTriplet(b);
    [a] = d.DEPRECATED_$getNodeTriplet(a);
    let [f, k, g] = d.DEPRECATED_$computeGridMap(e, c, a);
    ({ startRow: b } = k);
    var { startRow: m } = g;
    a = m + a.__rowSpan - 1;
    if (f.length === a - b + 1) e.remove();
    else {
        m = f[0].length;
        var q = f[a + 1], u = e.getChildAtIndex(a + 1);
        for(let l = a; l >= b; l--){
            for(var h = m - 1; 0 <= h; h--){
                let { cell: n, startRow: p, startColumn: r } = f[l][h];
                if (r === h && (l === b && p < b && n.setRowSpan(n.__rowSpan - (p - b)), p >= b && p + n.__rowSpan - 1 > a)) {
                    if (n.setRowSpan(n.__rowSpan - (a - p + 1)), null === u && w(122), 0 === h) ya(u, n);
                    else {
                        let { cell: t } = q[h - 1];
                        t.insertAfter(n);
                    }
                }
            }
            h = e.getChildAtIndex(l);
            d.DEPRECATED_$isGridRowNode(h) || w(123, String(l));
            h.remove();
        }
        void 0 !== q ? ({ cell: b } = q[0], Z(b)) : ({ cell: b } = f[b - 1][0], Z(b));
    }
};
exports.$getElementGridForTableNode = function(a, b) {
    a = a.getElementByKey(b.getKey());
    if (null == a) throw Error("Table Element Not Found");
    return M(a);
};
exports.$getTableCellNodeFromLexicalNode = function(a) {
    a = v.$findMatchingParent(a, (b)=>H(b));
    return H(a) ? a : null;
};
exports.$getTableColumnIndexFromTableCellNode = function(a) {
    return va(a).getChildren().findIndex((b)=>b.is(a));
};
exports.$getTableNodeFromLexicalNodeOrThrow = wa;
exports.$getTableRowIndexFromTableCellNode = function(a) {
    let b = va(a);
    return wa(b).getChildren().findIndex((c)=>c.is(b));
};
exports.$getTableRowNodeFromTableCellNodeOrThrow = va;
exports.$insertTableColumn = function(a, b, c = !0, e, f) {
    let k = a.getChildren(), g = [];
    for(let u = 0; u < k.length; u++){
        let h = k[u];
        if (L(h)) for(let l = 0; l < e; l++){
            var m = h.getChildren();
            if (b >= m.length || 0 > b) throw Error("Table column target index out of range");
            m = m[b];
            H(m) || w(12);
            let { left: n, right: p } = xa(m, f);
            var q = D.NO_STATUS;
            if (n && n.hasHeaderState(D.ROW) || p && p.hasHeaderState(D.ROW)) q |= D.ROW;
            q = G(q);
            q.append(d.$createParagraphNode());
            g.push({
                newTableCell: q,
                targetCell: m
            });
        }
    }
    g.forEach(({ newTableCell: u, targetCell: h })=>{
        c ? h.insertAfter(u) : h.insertBefore(u);
    });
    return a;
};
exports.$insertTableColumn__EXPERIMENTAL = function(a = !0) {
    function b() {
        let l = G(D.NO_STATUS).append(d.$createParagraphNode());
        null === u && (u = l);
        return l;
    }
    var c = d.$getSelection();
    if (!d.$INTERNAL_isPointSelection(c)) throw Error("Expected a PointSeleciton");
    var e = c.anchor.getNode();
    c = c.focus.getNode();
    [e] = d.DEPRECATED_$getNodeTriplet(e);
    let [f, , k] = d.DEPRECATED_$getNodeTriplet(c), [g, m, q] = d.DEPRECATED_$computeGridMap(k, f, e);
    e = g.length;
    c = a ? Math.max(m.startColumn, q.startColumn) : Math.min(m.startColumn, q.startColumn);
    a = a ? c + f.__colSpan - 1 : c - 1;
    c = k.getFirstChild();
    d.DEPRECATED_$isGridRowNode(c) || w(120);
    let u = null;
    var h = c;
    a: for(c = 0; c < e; c++){
        0 !== c && (h = h.getNextSibling(), d.DEPRECATED_$isGridRowNode(h) || w(121));
        let l = g[c];
        if (0 > a) {
            ya(h, b());
            continue;
        }
        let { cell: n, startColumn: p, startRow: r } = l[a];
        if (p + n.__colSpan - 1 <= a) {
            let t = n, x = r, B = a;
            for(; x !== c && 1 < t.__rowSpan;)if (B -= n.__colSpan, 0 <= B) {
                let { cell: C, startRow: I } = l[B];
                t = C;
                x = I;
            } else {
                h.append(b());
                continue a;
            }
            t.insertAfter(b());
        } else n.setColSpan(n.__colSpan + 1);
    }
    null !== u && Z(u);
};
exports.$insertTableRow = function(a, b, c = !0, e, f) {
    var k = a.getChildren();
    if (b >= k.length || 0 > b) throw Error("Table row target index out of range");
    b = k[b];
    if (L(b)) for(k = 0; k < e; k++){
        let m = b.getChildren(), q = m.length, u = K();
        for(let h = 0; h < q; h++){
            var g = m[h];
            H(g) || w(12);
            let { above: l, below: n } = xa(g, f);
            g = D.NO_STATUS;
            let p = l && l.getWidth() || n && n.getWidth() || void 0;
            if (l && l.hasHeaderState(D.COLUMN) || n && n.hasHeaderState(D.COLUMN)) g |= D.COLUMN;
            g = G(g, 1, p);
            g.append(d.$createParagraphNode());
            u.append(g);
        }
        c ? b.insertAfter(u) : b.insertBefore(u);
    }
    else throw Error("Row before insertion index does not exist.");
    return a;
};
exports.$insertTableRow__EXPERIMENTAL = function(a = !0) {
    var b = d.$getSelection();
    if (!d.$INTERNAL_isPointSelection(b)) throw Error("Expected a INTERNAL_PointSelection");
    b = b.focus.getNode();
    let [c, , e] = d.DEPRECATED_$getNodeTriplet(b), [f, k] = d.DEPRECATED_$computeGridMap(e, c, c);
    b = f[0].length;
    var { startRow: g } = k;
    if (a) {
        a = g + c.__rowSpan - 1;
        var m = f[a];
        g = K();
        for(var q = 0; q < b; q++){
            let { cell: u, startRow: h } = m[q];
            h + u.__rowSpan - 1 <= a ? g.append(G(D.NO_STATUS).append(d.$createParagraphNode())) : u.setRowSpan(u.__rowSpan + 1);
        }
        b = e.getChildAtIndex(a);
        d.DEPRECATED_$isGridRowNode(b) || w(119);
        b.insertAfter(g);
    } else {
        m = f[g];
        a = K();
        for(q = 0; q < b; q++){
            let { cell: u, startRow: h } = m[q];
            h === g ? a.append(G(D.NO_STATUS).append(d.$createParagraphNode())) : u.setRowSpan(u.__rowSpan + 1);
        }
        b = e.getChildAtIndex(g);
        d.DEPRECATED_$isGridRowNode(b) || w(119);
        b.insertBefore(a);
    }
};
exports.$isGridSelection = z;
exports.$isTableCellNode = H;
exports.$isTableNode = N;
exports.$isTableRowNode = L;
exports.$removeTableRowAtIndex = function(a, b) {
    let c = a.getChildren();
    if (b >= c.length || 0 > b) throw Error("Expected table cell to be inside of table row.");
    c[b].remove();
    return a;
};
exports.$unmergeCell = function() {
    var a = d.$getSelection();
    if (!d.$INTERNAL_isPointSelection(a)) throw Error("Expected a INTERNAL_PointSelection");
    a = a.anchor.getNode();
    let [b, c, e] = d.DEPRECATED_$getNodeTriplet(a);
    a = b.__colSpan;
    let f = b.__rowSpan;
    if (1 < a) {
        for(var k = 1; k < a; k++)b.insertAfter(G(D.NO_STATUS));
        b.setColSpan(1);
    }
    if (1 < f) {
        let [q, u] = d.DEPRECATED_$computeGridMap(e, b, b), { startColumn: h, startRow: l } = u, n;
        for(k = 1; k < f; k++){
            var g = l + k;
            let p = q[g];
            n = (n || c).getNextSibling();
            d.DEPRECATED_$isGridRowNode(n) || w(125);
            var m = null;
            for(let r = 0; r < h; r++){
                let t = p[r], x = t.cell;
                t.startRow === g && (m = x);
                1 < x.__colSpan && (r += x.__colSpan - 1);
            }
            if (null === m) for(m = 0; m < a; m++)ya(n, G(D.NO_STATUS));
            else for(g = 0; g < a; g++)m.insertAfter(G(D.NO_STATUS));
        }
        b.setRowSpan(1);
    }
};
exports.INSERT_TABLE_COMMAND = za;
exports.TableCellHeaderStates = D;
exports.TableCellNode = F;
exports.TableNode = V;
exports.TableRowNode = J;
exports.TableSelection = fa;
exports.applyTableHandlers = function(a, b, c, e) {
    function f(h) {
        h = a.getCordsFromCellNode(h, g.grid);
        return a.getCellFromCordsOrThrow(h.x, h.y, g.grid);
    }
    let k = c.getRootElement();
    if (null === k) throw Error("No root element.");
    let g = new fa(c, a.getKey()), m = c._window || window;
    b.__lexicalTableSelection = g;
    b.addEventListener("mousedown", (h)=>{
        setTimeout(()=>{
            if (0 === h.button && m) {
                var l = ha(h.target);
                null !== l && (U(h), g.setAnchorCellForSelection(l));
                var n = ()=>{
                    m.removeEventListener("mouseup", n);
                    m.removeEventListener("mousemove", p);
                }, p = (r)=>{
                    const t = ha(r.target);
                    null === t || g.anchorX === t.x && g.anchorY === t.y || (r.preventDefault(), g.setFocusCellForSelection(t));
                };
                m.addEventListener("mouseup", n);
                m.addEventListener("mousemove", p);
            }
        }, 0);
    });
    let q = (h)=>{
        0 === h.button && c.update(()=>{
            const l = d.$getSelection(), n = h.target;
            z(l) && l.gridKey === g.tableNodeKey && k.contains(n) && g.clearHighlight();
        });
    };
    m.addEventListener("mousedown", q);
    g.listenersToRemove.add(()=>m.removeEventListener("mousedown", q));
    g.listenersToRemove.add(c.registerCommand(d.KEY_ARROW_DOWN_COMMAND, (h)=>T(c, h, "down", a, g), d.COMMAND_PRIORITY_HIGH));
    g.listenersToRemove.add(c.registerCommand(d.KEY_ARROW_UP_COMMAND, (h)=>T(c, h, "up", a, g), d.COMMAND_PRIORITY_HIGH));
    g.listenersToRemove.add(c.registerCommand(d.KEY_ARROW_LEFT_COMMAND, (h)=>T(c, h, "backward", a, g), d.COMMAND_PRIORITY_HIGH));
    g.listenersToRemove.add(c.registerCommand(d.KEY_ARROW_RIGHT_COMMAND, (h)=>T(c, h, "forward", a, g), d.COMMAND_PRIORITY_HIGH));
    g.listenersToRemove.add(c.registerCommand(d.KEY_ESCAPE_COMMAND, (h)=>{
        var l = d.$getSelection();
        return z(l) && (l = v.$findMatchingParent(l.focus.getNode(), H), H(l)) ? (U(h), l.selectEnd(), !0) : !1;
    }, d.COMMAND_PRIORITY_HIGH));
    let u = (h)=>()=>{
            var l = d.$getSelection();
            if (!S(l, a)) return !1;
            if (z(l)) return g.clearText(), !0;
            if (d.$isRangeSelection(l)) {
                const r = v.$findMatchingParent(l.anchor.getNode(), (t)=>H(t));
                if (!H(r)) return !1;
                var n = l.anchor.getNode(), p = l.focus.getNode();
                n = a.isParentOf(n);
                p = a.isParentOf(p);
                if (n && !p || p && !n) return g.clearText(), !0;
                n = (p = v.$findMatchingParent(l.anchor.getNode(), (t)=>d.$isElementNode(t))) && v.$findMatchingParent(p, (t)=>d.$isElementNode(t) && H(t.getParent()));
                if (!d.$isElementNode(n) || !d.$isElementNode(p)) return !1;
                if (h === d.DELETE_LINE_COMMAND && null === n.getPreviousSibling()) return !0;
                if ((h === d.DELETE_CHARACTER_COMMAND || h === d.DELETE_WORD_COMMAND) && l.isCollapsed() && 0 === l.anchor.offset && p !== n) {
                    l = p.getChildren();
                    const t = d.$createParagraphNode();
                    l.forEach((x)=>t.append(x));
                    p.replace(t);
                    p.getWritable().__parent = r.getKey();
                    return !0;
                }
            }
            return !1;
        };
    [
        d.DELETE_WORD_COMMAND,
        d.DELETE_LINE_COMMAND,
        d.DELETE_CHARACTER_COMMAND
    ].forEach((h)=>{
        g.listenersToRemove.add(c.registerCommand(h, u(h), d.COMMAND_PRIORITY_CRITICAL));
    });
    b = (h)=>{
        const l = d.$getSelection();
        if (!S(l, a)) return !1;
        if (z(l)) return h.preventDefault(), h.stopPropagation(), g.clearText(), !0;
        d.$isRangeSelection(l) && (h = v.$findMatchingParent(l.anchor.getNode(), (n)=>H(n)), H(h));
        return !1;
    };
    g.listenersToRemove.add(c.registerCommand(d.KEY_BACKSPACE_COMMAND, b, d.COMMAND_PRIORITY_CRITICAL));
    g.listenersToRemove.add(c.registerCommand(d.KEY_DELETE_COMMAND, b, d.COMMAND_PRIORITY_CRITICAL));
    g.listenersToRemove.add(c.registerCommand(d.FORMAT_TEXT_COMMAND, (h)=>{
        let l = d.$getSelection();
        if (!S(l, a)) return !1;
        if (z(l)) return g.formatCells(h), !0;
        d.$isRangeSelection(l) && (h = v.$findMatchingParent(l.anchor.getNode(), (n)=>H(n)), H(h));
        return !1;
    }, d.COMMAND_PRIORITY_CRITICAL));
    g.listenersToRemove.add(c.registerCommand(d.CONTROLLED_TEXT_INSERTION_COMMAND, ()=>{
        var h = d.$getSelection();
        if (!S(h, a)) return !1;
        z(h) ? g.clearHighlight() : d.$isRangeSelection(h) && (h = v.$findMatchingParent(h.anchor.getNode(), (l)=>H(l)), H(h));
        return !1;
    }, d.COMMAND_PRIORITY_CRITICAL));
    e && g.listenersToRemove.add(c.registerCommand(d.KEY_TAB_COMMAND, (h)=>{
        var l = d.$getSelection();
        if (!d.$isRangeSelection(l) || !l.isCollapsed() || !S(l, a)) return !1;
        l = ra(l.anchor.getNode());
        if (null === l) return !1;
        U(h);
        l = a.getCordsFromCellNode(l, g.grid);
        pa(g, a, l.x, l.y, h.shiftKey ? "backward" : "forward");
        return !0;
    }, d.COMMAND_PRIORITY_CRITICAL));
    g.listenersToRemove.add(c.registerCommand(d.FOCUS_COMMAND, ()=>a.isSelected(), d.COMMAND_PRIORITY_HIGH));
    g.listenersToRemove.add(c.registerCommand(d.SELECTION_INSERT_CLIPBOARD_NODES_COMMAND, (h)=>{
        let { nodes: l, selection: n } = h;
        h = d.$INTERNAL_isPointSelection(n);
        var p = d.$isRangeSelection(n);
        h = p && null !== v.$findMatchingParent(n.anchor.getNode(), (E)=>d.DEPRECATED_$isGridCellNode(E)) && null !== v.$findMatchingParent(n.focus.getNode(), (E)=>d.DEPRECATED_$isGridCellNode(E)) || h && !p;
        if (1 !== l.length || !d.DEPRECATED_$isGridNode(l[0]) || !h) return !1;
        var { anchor: r } = n, t = l[0];
        h = t.getChildren();
        p = t.getFirstChildOrThrow().getChildrenSize();
        t = t.getChildrenSize();
        var x = v.$findMatchingParent(r.getNode(), (E)=>d.DEPRECATED_$isGridCellNode(E)), B = (r = x && v.$findMatchingParent(x, (E)=>d.DEPRECATED_$isGridRowNode(E))) && v.$findMatchingParent(r, (E)=>d.DEPRECATED_$isGridNode(E));
        if (!d.DEPRECATED_$isGridCellNode(x) || !d.DEPRECATED_$isGridRowNode(r) || !d.DEPRECATED_$isGridNode(B)) return !1;
        var C = r.getIndexWithinParent(), I = Math.min(B.getChildrenSize() - 1, C + t - 1);
        t = x.getIndexWithinParent();
        x = Math.min(r.getChildrenSize() - 1, t + p - 1);
        p = Math.min(t, x);
        r = Math.min(C, I);
        t = Math.max(t, x);
        C = Math.max(C, I);
        B = B.getChildren();
        I = 0;
        let ia, ja;
        for(x = r; x <= C; x++){
            var X = B[x];
            if (!d.DEPRECATED_$isGridRowNode(X)) return !1;
            var Y = h[I];
            if (!d.DEPRECATED_$isGridRowNode(Y)) return !1;
            X = X.getChildren();
            Y = Y.getChildren();
            let E = 0;
            for(let O = p; O <= t; O++){
                let P = X[O];
                if (!d.DEPRECATED_$isGridCellNode(P)) return !1;
                let sa = Y[E];
                if (!d.DEPRECATED_$isGridCellNode(sa)) return !1;
                x === r && O === p ? ia = P.getKey() : x === C && O === t && (ja = P.getKey());
                let Aa = P.getChildren();
                sa.getChildren().forEach((Q)=>{
                    d.$isTextNode(Q) && d.$createParagraphNode().append(Q);
                    P.append(Q);
                });
                Aa.forEach((Q)=>Q.remove());
                E++;
            }
            I++;
        }
        ia && ja && (h = A(), h.set(l[0].getKey(), ia, ja), d.$setSelection(h));
        return !0;
    }, d.COMMAND_PRIORITY_CRITICAL));
    g.listenersToRemove.add(c.registerCommand(d.SELECTION_CHANGE_COMMAND, ()=>{
        let h = d.$getSelection(), l = d.$getPreviousSelection();
        if (d.$isRangeSelection(h)) {
            let { anchor: x, focus: B } = h;
            var n = x.getNode(), p = B.getNode();
            n = ra(n);
            p = ra(p);
            var r = n && a.is(ta(n)), t = p && a.is(ta(p));
            let C = r !== t;
            t = r && t;
            r = h.isBackward();
            C ? (n = h.clone(), n.focus.set(a.getKey(), r ? 0 : a.getChildrenSize(), "element"), d.$setSelection(n), na(c, g)) : t && !n.is(p) && (g.setAnchorCellForSelection(f(n)), g.setFocusCellForSelection(f(p), !0));
        }
        if (h && !h.is(l) && (z(h) || z(l)) && g.gridSelection && !g.gridSelection.is(l)) return z(h) && h.gridKey === g.tableNodeKey ? g.updateTableGridSelection(h) : !z(h) && z(l) && l.gridKey === g.tableNodeKey && g.updateTableGridSelection(null), !1;
        g.hasHijackedSelectionStyles && !a.isSelected() ? oa(c, g) : !g.hasHijackedSelectionStyles && a.isSelected() && na(c, g);
        return !1;
    }, d.COMMAND_PRIORITY_CRITICAL));
    return g;
};
exports.getCellFromTarget = ha;
exports.getTableSelectionFromTableElement = function(a) {
    return a.__lexicalTableSelection;
};

},{"cb5443f41dd7b032":"6uPvi","903b00d6e14c7fbc":"1V3L7"}],"glWzc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarkdownTheme", ()=>MarkdownTheme);
parcelHelpers.export(exports, "MarkdownStylesWrapper", ()=>MarkdownStylesWrapper);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const MarkdownTheme = {
    placeholder: "editor-placeholder",
    paragraph: "editor-paragraph",
    quote: "editor-quote",
    heading: {
        h1: "editor-heading-h1",
        h2: "editor-heading-h2",
        h3: "editor-heading-h3",
        h4: "editor-heading-h4",
        h5: "editor-heading-h5",
        h6: "editor-heading-h6"
    },
    link: "editor-link",
    list: {
        nested: {
            listitem: "editor-nested-listitem"
        },
        ol: "editor-list-ol",
        ul: "editor-list-ul",
        listitem: "editor-listItem"
    },
    text: {
        bold: "editor-textBold",
        italic: "editor-textItalic",
        strikethrough: "editor-textStrikethrough"
    }
};
const MarkdownStylesWrapper = (0, _styledComponentsDefault.default).div`
  & .editor-textBold {
    font-weight: var(--p-font-weight-bold);
  }

  & .editor-textItalic {
    font-style: italic;
  }

  & .editor-textStrikethrough {
    text-decoration: line-through;
  }

  & .editor-heading-h1 {
    font-size: var(--p-font-size-300);
    margin-bottom: var(--p-space-2);
  }

  & .editor-heading-h2 {
    font-size: var(--p-font-size-200);
    margin-bottom: var(--p-space-2);
  }

  & .editor-heading-h3 {
    font-size: var(--p-font-size-100);
    margin-bottom: var(--p-space-2);
  }

  & .editor-heading-h4 {
    font-size: var(--p-font-size-75);
    margin-bottom: var(--p-space-2);
  }

  & .editor-heading-h5 {
    font-size: var(--p-font-size-75);
    margin-bottom: var(--p-space-2);
  }

  & .editor-heading-h6 {
    font-size: var(--p-font-size-75);
    margin-bottom: var(--p-space-2);
  }

  & .editor-quote {
    margin: 0;
    margin-left: var(--p-space-4);
    margin-bottom: var(--p-space-2);
    color: var(--p-text-subdued);
    border-left: solid 4px var(--p-text-disabled);
    padding-left: var(--p-space-2);
  }

  & .editor-paragraph {
    position: relative;
    margin-bottom: var(--p-space-2);
  }

  & ul,
  ol {
    margin: var(--p-space-1) 0;
  }

  .editor-paragraph:last-child {
    margin-bottom: 0;
  }

  & .editor-nested-listitem {
    list-style-type: none;
  }

  pre::-webkit-scrollbar {
    background: transparent;
    width: 10px;
  }

  pre::-webkit-scrollbar-thumb {
    background: #999;
  }
`;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aAd3r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lexicalAutoLinkPlugin = require("@lexical/react/LexicalAutoLinkPlugin");
const URL_REGEX = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
const MATCHERS = [
    (0, _lexicalAutoLinkPlugin.createLinkMatcherWithRegExp)(URL_REGEX, (text)=>{
        return text.startsWith("http") ? text : `https://${text}`;
    })
];
const AutoLinkPlugin = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalAutoLinkPlugin.AutoLinkPlugin), {
        matchers: MATCHERS
    });
};
exports.default = AutoLinkPlugin;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@lexical/react/LexicalAutoLinkPlugin":"25qHA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"25qHA":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalAutoLinkPlugin = require("67d9ce771cf987fd");
module.exports = LexicalAutoLinkPlugin;

},{"67d9ce771cf987fd":"ikqdB"}],"ikqdB":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var k = require("36544e12c0a4e30a"), n = require("fae32513bb4bb18b"), p = require("cc10507faff95177"), r = require("ab91dc7dee6f3971"), t = require("66f1ec2318d23288");
function u(a) {
    let c = new URLSearchParams;
    c.append("code", a);
    for(let b = 1; b < arguments.length; b++)c.append("v", arguments[b]);
    throw Error(`Minified Lexical error #${a}; visit https://lexical.dev/docs/error?${c} for the full message or ` + "use the non-minified dev environment for full errors and additional helpful warnings.");
}
function v(a, c) {
    for(let b = 0; b < c.length; b++){
        let d = c[b](a);
        if (d) return d;
    }
    return null;
}
let w = /[.,;\s]/;
function x(a) {
    a = a.getPreviousSibling();
    r.$isElementNode(a) && (a = a.getLastDescendant());
    var c;
    !(c = null === a || r.$isLineBreakNode(a)) && (c = r.$isTextNode(a)) && (a = a.getTextContent(), c = w.test(a[a.length - 1]));
    return c;
}
function y(a) {
    a = a.getNextSibling();
    r.$isElementNode(a) && (a = a.getFirstDescendant());
    return null === a || r.$isLineBreakNode(a) || r.$isTextNode(a) && w.test(a.getTextContent()[0]);
}
function z(a, c, b, d) {
    return (0 < a ? w.test(b[a - 1]) : x(d[0])) ? c < b.length ? w.test(b[c]) : y(d[d.length - 1]) : !1;
}
function A(a, c, b) {
    let d = [], f = [], e = [], g = 0, h = 0;
    for(a = [
        ...a
    ]; 0 < a.length;){
        let l = a[0], m = l.getTextContent().length, q = h;
        h + m <= c ? (d.push(l), g += m) : q >= b ? e.push(l) : f.push(l);
        h += m;
        a.shift();
    }
    return [
        g,
        d,
        f,
        e
    ];
}
function B(a, c, b, d) {
    let f = k.$createAutoLinkNode(d.url, d.attributes);
    if (1 === a.length) {
        var e = a[0];
        0 === c ? [h, e] = e.splitText(b) : [, h, e] = e.splitText(c, b);
        var g = r.$createTextNode(d.text);
        g.setFormat(h.getFormat());
        g.setDetail(h.getDetail());
        f.append(g);
        h.replace(f);
        return e;
    }
    if (1 < a.length) {
        d = a[0];
        var h = d.getTextContent().length;
        0 === c ? e = d : [, e] = d.splitText(c);
        c = [];
        for(d = 1; d < a.length; d++){
            let l = a[d], m = l.getTextContent().length, q = h, E = h + m;
            if (q < b) {
                if (E <= b) c.push(l);
                else {
                    let [F, G] = l.splitText(b - q);
                    c.push(F);
                    g = G;
                }
            }
            h += m;
        }
        a = (b = r.$getSelection()) ? b.getNodes().find(r.$isTextNode) : void 0;
        h = r.$createTextNode(e.getTextContent());
        h.setFormat(e.getFormat());
        h.setDetail(e.getDetail());
        f.append(h, ...c);
        a && a === e && (r.$isRangeSelection(b) ? h.select(b.anchor.offset, b.focus.offset) : r.$isNodeSelection(b) && h.select(0, h.getTextContent().length));
        e.replace(f);
        return g;
    }
}
function C(a, c, b) {
    var d = [
        ...a
    ];
    a = d.map((g)=>g.getTextContent()).join("");
    let f, e = 0;
    for(; (f = v(a, c)) && null !== f;){
        let g = f.index, h = g + f.length;
        if (z(e + g, e + h, a, d)) {
            let [l, , m, q] = A(d, e + g, e + h);
            d = (d = B(m, e + g - l, e + h - l, f)) ? [
                d,
                ...q
            ] : q;
            b(f.url, null);
            e = 0;
        } else e += h;
        a = a.substring(h);
    }
}
function D(a, c, b) {
    var d = a.getChildren();
    let f = d.length;
    for(let e = 0; e < f; e++){
        let g = d[e];
        if (!r.$isTextNode(g) || !g.isSimpleText()) {
            H(a);
            b(null, a.getURL());
            return;
        }
    }
    d = a.getTextContent();
    c = v(d, c);
    null === c || c.text !== d ? (H(a), b(null, a.getURL())) : x(a) && y(a) ? (d = a.getURL(), d !== c.url && (a.setURL(c.url), b(c.url, d)), c.attributes && (d = a.getRel(), d !== c.attributes.rel && (a.setRel(c.attributes.rel || null), b(c.attributes.rel || null, d)), d = a.getTarget(), d !== c.attributes.target && (a.setTarget(c.attributes.target || null), b(c.attributes.target || null, d)))) : (H(a), b(null, a.getURL()));
}
function H(a) {
    let c = a.getChildren();
    var b = c.length;
    for(--b; 0 <= b; b--)a.insertAfter(c[b]);
    a.remove();
    return c.map((d)=>d.getLatest());
}
function I(a, c, b) {
    t.useEffect(()=>{
        a.hasNodes([
            k.AutoLinkNode
        ]) || u(77);
        let d = (f, e)=>{
            b && b(f, e);
        };
        return p.mergeRegister(a.registerNodeTransform(r.TextNode, (f)=>{
            var e = f.getParentOrThrow(), g = f.getPreviousSibling();
            if (k.$isAutoLinkNode(e)) D(e, c, d);
            else if (!k.$isLinkNode(e)) {
                if (f.isSimpleText() && (w.test(f.getTextContent()[0]) || !k.$isAutoLinkNode(g))) {
                    e = [
                        f
                    ];
                    for(g = f.getNextSibling(); null !== g && r.$isTextNode(g) && g.isSimpleText();){
                        e.push(g);
                        if (/[\s]/.test(g.getTextContent())) break;
                        g = g.getNextSibling();
                    }
                    C(e, c, d);
                }
                let h = f.getPreviousSibling();
                e = f.getNextSibling();
                g = f.getTextContent();
                k.$isAutoLinkNode(h) && !w.test(g[0]) && (h.append(f), D(h, c, d), f = h.getURL(), b && b(null, f));
                k.$isAutoLinkNode(e) && !w.test(g[g.length - 1]) && (H(e), D(e, c, d), f = e.getURL(), b && b(null, f));
            }
        }));
    }, [
        a,
        c,
        b
    ]);
}
exports.AutoLinkPlugin = function({ matchers: a, onChange: c }) {
    let [b] = n.useLexicalComposerContext();
    I(b, a, c);
    return null;
};
exports.createLinkMatcherWithRegExp = function(a, c = (b)=>b) {
    return (b)=>{
        b = a.exec(b);
        return null === b ? null : {
            index: b.index,
            length: b[0].length,
            text: b[0],
            url: c(b[0])
        };
    };
};

},{"36544e12c0a4e30a":"2MxRL","fae32513bb4bb18b":"2kfbx","cc10507faff95177":"1V3L7","ab91dc7dee6f3971":"6uPvi","66f1ec2318d23288":"cOWTg"}],"acWsl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _markdown = require("@lexical/markdown");
var _lexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _markdown1 = require("../../constants/markdown");
var _useNonInitialEffect = require("../../hooks/useNonInitialEffect");
var _useNonInitialEffectDefault = parcelHelpers.interopDefault(_useNonInitialEffect);
const MarkdownUpdatePlugin = (props)=>{
    const { value } = props;
    const [editor] = (0, _lexicalComposerContext.useLexicalComposerContext)();
    (0, _useNonInitialEffectDefault.default)(()=>{
        editor.update(()=>{
            (0, _markdown.$convertFromMarkdownString)(value || "", (0, _markdown1.TRANSFORMERS));
        });
    }, [
        value,
        editor
    ]);
    return null;
};
exports.default = MarkdownUpdatePlugin;

},{"@lexical/markdown":"a7yhR","@lexical/react/LexicalComposerContext":"2kfbx","../../constants/markdown":"6FvAU","../../hooks/useNonInitialEffect":"7lww1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jtFVT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _pageAnchors = require("../../constants/page-anchors");
var _queriesKeys = require("../../constants/queries-keys");
var _reviewsHelpers = require("../../helpers/reviews.helpers");
var _useCustomerReviewBanner = require("../../hooks/useCustomerReviewBanner");
var _useCustomerReviewBannerDefault = parcelHelpers.interopDefault(_useCustomerReviewBanner);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _collectionUtils = require("../../utils/collectionUtils");
var _customerReviewsList = require("../CustomerReviewsList/CustomerReviewsList");
var _customerReviewsListDefault = parcelHelpers.interopDefault(_customerReviewsList);
var _customerReviewsListWithFilter = require("../CustomerReviewsListWithFilter/CustomerReviewsListWithFilter");
var _customerReviewsListWithFilterDefault = parcelHelpers.interopDefault(_customerReviewsListWithFilter);
var _customerReviewsSectionBanner = require("../CustomerReviewsSectionBanner/CustomerReviewsSectionBanner");
var _customerReviewsSectionBannerDefault = parcelHelpers.interopDefault(_customerReviewsSectionBanner);
var _newCustomerReviewButton = require("../NewCustomerReviewButton/NewCustomerReviewButton");
var _newCustomerReviewButtonDefault = parcelHelpers.interopDefault(_newCustomerReviewButton);
const CustomerReviewsSection = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const { isNewCustomerReviewDisabled } = (0, _useCustomerReviewBannerDefault.default)(customer);
    const pendingReviews = customer.reviews.filter((0, _reviewsHelpers.isPendingReview)).sort((0, _reviewsHelpers.sortByReviewDate));
    const reviews = customer.reviews.filter((0, _reviewsHelpers.isCompletedReview)).sort((0, _reviewsHelpers.sortByReviewDate));
    const handleReviewChange = (updatedReview)=>{
        // update customer details cache
        updateQueryData((queryData)=>queryData.reviews = (0, _collectionUtils.updateItem)(queryData.reviews, updatedReview));
        // update CUSTOMER REVIEW PAGE query cache in order to reflect changes in the measures
        queryClient.setQueryData([
            [
                (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW,
                customer.id,
                updatedReview.id
            ]
        ], {
            ...customer,
            reviews: (0, _collectionUtils.updateItem)(customer.reviews, updatedReview)
        });
        // try to update session storage of the review page with new data
        const itemKey = (0, _reviewsHelpers.getReviewStorageKey)(customer.id, updatedReview.id);
        const savedReviewContent = sessionStorage.getItem(itemKey);
        if (savedReviewContent) try {
            const savedReview = JSON.parse(savedReviewContent);
            if (savedReview) {
                // only update the measures and not the whole review since handleReviewChange is currently only
                // used in measures outside the review page
                savedReview.measures = updatedReview.measures;
                sessionStorage.setItem(itemKey, JSON.stringify(savedReview));
            }
        } catch (e) {
            sessionStorage.removeItem(itemKey);
        }
    };
    const showNewCustomerReviewButton = customer.reviews.length > 0 && (0, _reviewsHelpers.canCreateNewReview)(customer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                align: "space-between",
                blockAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "headingMd",
                        as: "h2",
                        children: f("reviews.header.title")
                    }),
                    showNewCustomerReviewButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newCustomerReviewButtonDefault.default), {
                        customer: customer,
                        disabled: readonly || isNewCustomerReviewDisabled,
                        children: f("reviews.labels.new-review")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewsSectionBannerDefault.default), {
                customer: customer,
                readonly: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: (0, _pageAnchors.PAGE_ANCHORS).PENDING_REVIEWS_SECTION,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewsListDefault.default), {
                    customer: customer,
                    reviews: pendingReviews,
                    readonly: readonly,
                    onReviewChange: handleReviewChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewsListWithFilterDefault.default), {
                customer: customer,
                reviews: reviews,
                readonly: readonly,
                onReviewChange: handleReviewChange
            })
        ]
    });
};
exports.default = CustomerReviewsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../constants/page-anchors":"4WmvA","../../constants/queries-keys":"6hYSF","../../helpers/reviews.helpers":"1oYIN","../../hooks/useCustomerReviewBanner":"1BJZA","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","../CustomerReviewsList/CustomerReviewsList":"5UAug","../CustomerReviewsListWithFilter/CustomerReviewsListWithFilter":"dTCCI","../CustomerReviewsSectionBanner/CustomerReviewsSectionBanner":"bvVIR","../NewCustomerReviewButton/NewCustomerReviewButton":"ajsqh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1oYIN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPendingDisclosuresCount", ()=>getPendingDisclosuresCount);
parcelHelpers.export(exports, "isInvalidReviewChecklistAnswers", ()=>isInvalidReviewChecklistAnswers);
parcelHelpers.export(exports, "convertCustomerReviewToOptionalCustomerReviewRequest", ()=>convertCustomerReviewToOptionalCustomerReviewRequest);
parcelHelpers.export(exports, "isPendingReview", ()=>isPendingReview);
parcelHelpers.export(exports, "isCompletedReview", ()=>isCompletedReview);
parcelHelpers.export(exports, "isReviewApprovalRequired", ()=>isReviewApprovalRequired);
parcelHelpers.export(exports, "isReviewRejected", ()=>isReviewRejected);
parcelHelpers.export(exports, "canCreateNewReview", ()=>canCreateNewReview);
parcelHelpers.export(exports, "sortByReviewDate", ()=>sortByReviewDate);
parcelHelpers.export(exports, "getReviewStorageKey", ()=>getReviewStorageKey);
var _sessionState = require("../constants/session-state");
var _stringUtils = require("../utils/stringUtils");
var _assignmentsHelpers = require("./assignments.helpers");
var _checklistsHelpers = require("./checklists.helpers");
const isPendingDisclosure = (disclosure)=>!disclosure.is_signed && disclosure.signature_required;
const isPendingDisclosureSignature = (signature)=>signature.status !== "SIGNED";
const isSignatureWithoutAssignment = (signature)=>(0, _stringUtils.isEmptyString)(signature.assignment_id);
const isSignatureAttachedToUser = (signature, assignments, userId)=>assignments?.find((assignment)=>assignment.id === signature.assignment_id)?.created_by?.id === userId;
const getPendingDisclosuresCount = (customer, userId)=>customer.disclosure_documents.filter(isPendingDisclosure).reduce((count, disclosure)=>count + disclosure.signatures.filter((signature)=>// count disclosures that are pending and either don't have an assignment attached to them
            // or they have an assignment that was created by the current user
            // this means that pending disclosures that were created by other users WILL NOT BE COUNTED
            isPendingDisclosureSignature(signature) && (isSignatureWithoutAssignment(signature) || isSignatureAttachedToUser(signature, customer.assignments, userId))).length, 0);
// a checklist answer is invalid if the answer is true and the description (additional_info) is empty
// OR if the entire checklist is required and there is no answer
const isInvalidReviewChecklistAnswer = (checklistAnswer, required)=>{
    const invalidAnswer = checklistAnswer.answer === true && (0, _stringUtils.isEmptyString)(checklistAnswer.additional_info);
    return required && checklistAnswer.answer === undefined || invalidAnswer;
};
const isInvalidReviewChecklistAnswers = (checklistAnswers, checklists)=>{
    const checklistId = checklistAnswers.checklist_id;
    const required = Boolean(checklists?.find((checklist)=>checklist.id === checklistId)?.is_required);
    return checklistAnswers.answers.some((checklistAnswer)=>isInvalidReviewChecklistAnswer(checklistAnswer, required));
};
const convertCustomerReviewToOptionalCustomerReviewRequest = (review)=>({
        id: review.id,
        accepted: review.accepted,
        risk_level: review.risk_level || "NOT_SET",
        is_pep: Boolean(review.is_pep),
        is_sanctioned: Boolean(review.is_sanctioned),
        requires_approval: review.requires_approval,
        approval_user_ids: review.approval_users?.map((user)=>user.id),
        labels: review.labels,
        measures: review.measures,
        comment: review.comment || "",
        assignment_id: review.assignment?.id,
        checklist_answers: review.checklist_answers?.map((0, _checklistsHelpers.convertChecklistAnswerToChecklistAnswerRequest))
    });
const isPendingReview = (review)=>review.status !== "COMPLETE" && review.status !== "ARCHIVED";
const isCompletedReview = (review)=>review.status === "COMPLETE" || review.status === "ARCHIVED";
const isReviewApprovalRequired = (review)=>isCompletedReview(review) && review.requires_approval && review.approval === undefined;
const isReviewRejected = (review)=>review.approval?.is_approved === false;
const canCreateNewReview = (customer)=>{
    // if there are no pending reviews and there is at least one existing review then EmptyReviewsBanner will not
    // be rendered and the new customer review button should be visible
    if (!customer.reviews.some(isPendingReview) && customer.reviews.length > 0) return true;
    // at least one pending review is not defined for an assignment or customer relationship
    const activeAssignmentsCount = customer.assignments?.filter((0, _assignmentsHelpers.isActiveAssignment)).length || 0;
    const reviewAssignmentsCount = customer.reviews.filter((review)=>isPendingReview(review) && Boolean(review.assignment?.id)).length;
    const hasCustomerRelationshipReview = customer.reviews.some((review)=>isPendingReview(review) && !review.assignment);
    return !hasCustomerRelationshipReview || activeAssignmentsCount !== reviewAssignmentsCount;
};
const sortByReviewDate = (reviewA, reviewB)=>isReviewRejected(reviewA) ? 1 : isReviewRejected(reviewB) ? -1 : reviewB.date.localeCompare(reviewA.date);
const getReviewStorageKey = (customerId, reviewId)=>[
        (0, _sessionState.NEW_CUSTOMER_REVIEW),
        customerId,
        reviewId || ""
    ].join("-");

},{"../constants/session-state":"g0N7C","../utils/stringUtils":"4gVdA","./assignments.helpers":"7t8rY","./checklists.helpers":"4fhyQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4fhyQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS", ()=>EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS);
parcelHelpers.export(exports, "createNewReviewChecklistQuestion", ()=>createNewReviewChecklistQuestion);
parcelHelpers.export(exports, "convertChecklistToCreateChecklistRequest", ()=>convertChecklistToCreateChecklistRequest);
parcelHelpers.export(exports, "isChecklistEmpty", ()=>isChecklistEmpty);
parcelHelpers.export(exports, "isChecklistPartiallyFilled", ()=>isChecklistPartiallyFilled);
parcelHelpers.export(exports, "isChecklistActive", ()=>isChecklistActive);
parcelHelpers.export(exports, "createChecklistAnswers", ()=>createChecklistAnswers);
parcelHelpers.export(exports, "convertChecklistAnswerToChecklistAnswerRequest", ()=>convertChecklistAnswerToChecklistAnswerRequest);
parcelHelpers.export(exports, "convertOptionalChecklistAnswersRequestToChecklistAnswersRequest", ()=>convertOptionalChecklistAnswersRequestToChecklistAnswersRequest);
parcelHelpers.export(exports, "getChecklistConditionType", ()=>getChecklistConditionType);
parcelHelpers.export(exports, "getChecklistSelectionType", ()=>getChecklistSelectionType);
parcelHelpers.export(exports, "getChecklistAnchorId", ()=>getChecklistAnchorId);
var _pageAnchors = require("../constants/page-anchors");
var _questions = require("../constants/questions");
var _collectionUtils = require("../utils/collectionUtils");
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
const EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS = {
    risk_categories: [],
    risk_levels: [],
    assignment_purposes: [],
    labels: [],
    is_always_select: false
};
const createNewReviewChecklistQuestion = ()=>({
        id: (0, _util.uniqueId)((0, _questions.NEW_QUESTION_PREFIX)),
        text: {
            en: "",
            nb: ""
        }
    });
const convertChecklistToCreateChecklistRequest = (checklist)=>({
        name: checklist.name,
        description: checklist.description,
        customer_type: checklist.customer_type,
        is_required: checklist.is_required,
        display_settings: checklist.display_settings ? {
            ...checklist.display_settings,
            label_ids: checklist.display_settings?.labels?.map((label)=>label.id),
            assignment_purposes: checklist.display_settings?.assignment_purposes.filter(Boolean)
        } : undefined,
        // strip id from questions
        questions: checklist.questions.map((question)=>(0, _util.removeProperty)(question, "id"))
    });
const isChecklistEmpty = (checklist)=>[
        ...checklist.values()
    ].every(({ answer, text })=>answer !== true && (0, _util.isEmpty)(text));
const isChecklistPartiallyFilled = (answers)=>answers?.some((answer)=>answer.answer !== undefined || !(0, _stringUtils.isEmptyString)(answer.additional_info));
const isChecklistActive = (checklist)=>!checklist.is_archived;
const createChecklistAnswers = (checklistReview, defaultAnswer)=>({
        checklist_id: checklistReview.id,
        version: checklistReview.version,
        answers: checklistReview.questions.map((question)=>({
                question_id: question.id,
                answer: defaultAnswer
            }))
    });
const convertChecklistQuestionAnswerToChecklistQuestionAnswerRequest = (checklistAnswer)=>({
        question_id: checklistAnswer.question_id,
        additional_info: checklistAnswer.additional_info,
        answer: checklistAnswer.answer
    });
const convertChecklistAnswerToChecklistAnswerRequest = (checklistAnswer)=>({
        checklist_id: checklistAnswer.checklist.id,
        version: checklistAnswer.checklist.version,
        answers: checklistAnswer.answers.map(convertChecklistQuestionAnswerToChecklistQuestionAnswerRequest)
    });
const convertOptionalChecklistQuestionAnswerRequestToChecklistQuestionAnswerRequest = (checklistAnswer)=>({
        ...checklistAnswer,
        answer: Boolean(checklistAnswer.answer)
    });
const convertOptionalChecklistAnswersRequestToChecklistAnswersRequest = (checklistAnswers)=>({
        ...checklistAnswers,
        answers: checklistAnswers.answers.filter((checklistAnswer)=>checklistAnswer.answer !== undefined).map(convertOptionalChecklistQuestionAnswerRequestToChecklistQuestionAnswerRequest)
    });
const getChecklistConditionType = (condition)=>{
    if ((0, _collectionUtils.hasContent)(condition?.risk_categories)) return "risk";
    if ((0, _collectionUtils.hasContent)(condition?.labels)) return "tag";
    if ((0, _collectionUtils.hasContent)(condition?.assignment_purposes)) return "purpose";
};
const getChecklistSelectionType = (condition)=>{
    if (condition?.is_always_select) return "always";
    if (getChecklistConditionType(condition)) return "automatic";
    return "manual";
};
const getChecklistAnchorId = (checklistId)=>`${(0, _pageAnchors.PAGE_ANCHORS).REVIEW_CHECKLIST_FORM}-${checklistId}`;

},{"../constants/page-anchors":"4WmvA","../constants/questions":"5Ewo5","../utils/collectionUtils":"gr5mc","../utils/stringUtils":"4gVdA","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Ewo5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEW_QUESTION_PREFIX", ()=>NEW_QUESTION_PREFIX);
parcelHelpers.export(exports, "NEW_QUESTION_CHOICE_PREFIX", ()=>NEW_QUESTION_CHOICE_PREFIX);
const NEW_QUESTION_PREFIX = "question";
const NEW_QUESTION_CHOICE_PREFIX = "question-choice";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1BJZA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _pageAnchors = require("../constants/page-anchors");
var _reviewsHelpers = require("../helpers/reviews.helpers");
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useCustomerPath = require("./useCustomerPath");
var _useCustomerPathDefault = parcelHelpers.interopDefault(_useCustomerPath);
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _usePageNavigation = require("./usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
const useCustomerReviewBanner = (customer, navigateFromExternalPage)=>{
    const { navigateInPage } = (0, _usePageNavigationDefault.default)();
    const { getCustomerPath } = (0, _useCustomerPathDefault.default)();
    const { user } = (0, _useAuthDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const features = (0, _useFeaturesDefault.default)();
    const unresolvedCaseCount = customer.unresolved_case_count || 0;
    const hasUnresolvedMatchCases = unresolvedCaseCount > 0;
    const pendingDisclosuresCount = (0, _reviewsHelpers.getPendingDisclosuresCount)(customer, user?.id);
    const hasPendingDisclosures = pendingDisclosuresCount > 0;
    // disable new customer reviews if there are pending reviews, unresolved match cases or pending disclosures
    const isNewCustomerReviewDisabled = Boolean(hasUnresolvedMatchCases || features.REVIEW__DISABLE_FOR_UNANSWERED_DISCLOSURES && hasPendingDisclosures);
    const navigateToMatchesSection = ()=>navigateFromExternalPage ? history.push(`${getCustomerPath(customer.id, customer.type)}#${(0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_MATCH_CASES}`) : navigateInPage((0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_MATCH_CASES);
    const navigateToDisclosuresSection = ()=>navigateFromExternalPage ? history.push(`${getCustomerPath(customer.id, customer.type)}#${(0, _pageAnchors.PAGE_ANCHORS).DISCLOSURES_SECTION}`) : navigateInPage((0, _pageAnchors.PAGE_ANCHORS).DISCLOSURES_SECTION);
    return {
        hasUnresolvedMatchCases,
        unresolvedCaseCount,
        hasPendingDisclosures,
        pendingDisclosuresCount,
        isNewCustomerReviewDisabled,
        navigateToMatchesSection,
        navigateToDisclosuresSection
    };
};
exports.default = useCustomerReviewBanner;

},{"react-router-dom":"1ee65","../constants/page-anchors":"4WmvA","../helpers/reviews.helpers":"1oYIN","./useAuth":"k9r0q","./useCustomerPath":"gJfCj","./useFeatures":"hvBWb","./usePageNavigation":"1o5Hm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5UAug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _customerReviewCard = require("../CustomerReviewCard/CustomerReviewCard");
var _customerReviewCardDefault = parcelHelpers.interopDefault(_customerReviewCard);
const CustomerReviewsList = (props)=>{
    const { customer, reviews, readonly, onReviewChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const getPreviouslyMarkedLabel = (currentReview, previousReview)=>{
        if (!previousReview) return undefined;
        const previouslyMarkedLabels = [];
        if (!currentReview.is_pep && previousReview.is_pep) previouslyMarkedLabels.push(f("badge.pep"));
        if (!currentReview.is_sanctioned && previousReview.is_sanctioned) previouslyMarkedLabels.push(f("badge.sanctioned"));
        if (previouslyMarkedLabels.length > 0) return f("reviews.labels.unmark-as", {
            badges: formatMultipleNames(previouslyMarkedLabels)
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
        gap: "6",
        children: reviews.map((review, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewCardDefault.default), {
                customer: customer,
                review: review,
                readonly: readonly,
                additionalInfoLabel: getPreviouslyMarkedLabel(review, index < reviews.length - 1 ? reviews[index + 1] : undefined),
                onChange: onReviewChange
            }, review.id))
    });
};
exports.default = CustomerReviewsList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../CustomerReviewCard/CustomerReviewCard":"7KXMz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7KXMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reviewsHelpers = require("../../helpers/reviews.helpers");
var _useCustomerReview = require("../../hooks/useCustomerReview");
var _useCustomerReviewDefault = parcelHelpers.interopDefault(_useCustomerReview);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../utils/util");
var _assignmentInfo = require("../AssignmentInfo/AssignmentInfo");
var _assignmentInfoDefault = parcelHelpers.interopDefault(_assignmentInfo);
var _badges = require("../Badges/Badges");
var _badgesDefault = parcelHelpers.interopDefault(_badges);
var _customerReviewApprovalReason = require("../CustomerReviewApprovalReason/CustomerReviewApprovalReason");
var _customerReviewApprovalReasonDefault = parcelHelpers.interopDefault(_customerReviewApprovalReason);
var _customerReviewCardPendingLabel = require("../CustomerReviewCardPendingLabel/CustomerReviewCardPendingLabel");
var _customerReviewCardPendingLabelDefault = parcelHelpers.interopDefault(_customerReviewCardPendingLabel);
var _customerReviewMeasures = require("../CustomerReviewMeasures/CustomerReviewMeasures");
var _customerReviewMeasuresDefault = parcelHelpers.interopDefault(_customerReviewMeasures);
var _customerReviewStatus = require("../CustomerReviewStatus/CustomerReviewStatus");
var _customerReviewStatusDefault = parcelHelpers.interopDefault(_customerReviewStatus);
var _displayTagsWrapper = require("../DisplayTagsWrapper/DisplayTagsWrapper");
var _displayTagsWrapperDefault = parcelHelpers.interopDefault(_displayTagsWrapper);
var _reviewCard = require("../ReviewCard/ReviewCard");
var _reviewCardDefault = parcelHelpers.interopDefault(_reviewCard);
var _reviewChecklistAnswers = require("../ReviewChecklistAnswers/ReviewChecklistAnswers");
var _reviewChecklistAnswersDefault = parcelHelpers.interopDefault(_reviewChecklistAnswers);
var _risk = require("../Risk/Risk");
var _riskDefault = parcelHelpers.interopDefault(_risk);
const CustomerReviewCard = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { customer, review, additionalInfoLabel, readonly, onChange } = props;
    const { isPending } = (0, _useCustomerReviewDefault.default)(review);
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const isRejected = (0, _reviewsHelpers.isReviewRejected)(review);
    const status = isPending || (0, _util.isNil)(review.accepted) || isRejected ? undefined : review.accepted ? "success" : "critical";
    const handleMeasuresChange = (measures)=>onChange({
            ...review,
            measures
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewCardDefault.default), {
        ref: ref,
        reviewStatus: status,
        reviewDate: review.date,
        reviewedBy: review.reviewed_by,
        approvedBy: review.approval?.approved_by,
        isRejected: isRejected,
        additionalTitleContent: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewCardPendingLabelDefault.default), {
                    customer: customer,
                    review: review,
                    readonly: readonly
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewApprovalReasonDefault.default), {
                    customerId: customer.id,
                    reviewId: review.id
                })
            ]
        }),
        reviewHeader: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "8",
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewStatusDefault.default), {
                    review: review
                }),
                review.risk_level && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDefault.default), {
                    risk: review.risk_level,
                    labelSuffix: f("common.labels.customer.risk")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgesDefault.default), {
                    isPep: review.is_pep,
                    isSanctioned: review.is_sanctioned
                }),
                additionalInfoLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: additionalInfoLabel
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayTagsWrapperDefault.default), {
                    tags: review.labels
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentInfoDefault.default), {
                    assignmentName: review.assignment?.name,
                    assignmentPurpose: review.assignment?.purpose
                })
            ]
        }),
        reviewContent: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistAnswersDefault.default), {
                    checklistAnswers: review.checklist_answers
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCommentText, {
                    forwardedAs: "p",
                    breakWord: true,
                    children: review.comment || ""
                })
            ]
        }),
        children: features.MEASURES && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasuresDefault.default), {
            customerId: customer.id,
            reviewId: review.id,
            measures: review.measures,
            onChange: handleMeasuresChange,
            readonly: readonly || isRejected
        })
    });
});
exports.default = CustomerReviewCard;
const StyledCommentText = (0, _styledComponentsDefault.default)((0, _polaris.Text))`
  white-space: pre-wrap;
`;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/reviews.helpers":"1oYIN","../../hooks/useCustomerReview":"8Ciom","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../utils/util":"4MniK","../AssignmentInfo/AssignmentInfo":"ds7XR","../Badges/Badges":"cI72s","../CustomerReviewApprovalReason/CustomerReviewApprovalReason":"9U4wC","../CustomerReviewCardPendingLabel/CustomerReviewCardPendingLabel":"jTrwn","../CustomerReviewMeasures/CustomerReviewMeasures":"aEvQG","../CustomerReviewStatus/CustomerReviewStatus":"9nG5T","../DisplayTagsWrapper/DisplayTagsWrapper":"2idSA","../ReviewCard/ReviewCard":"7p3dh","../ReviewChecklistAnswers/ReviewChecklistAnswers":"bfJQ8","../Risk/Risk":"9VLEF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Ciom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reviewsHelpers = require("../helpers/reviews.helpers");
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
const useCustomerReview = (review)=>{
    const { user: currentUser } = (0, _useAuthDefault.default)();
    const fromCurrentUser = review && currentUser && review.reviewed_by?.id === currentUser.id;
    const isRequiresApproval = Boolean(review && review.requires_approval && !review.approval?.approved_by);
    const isEditable = Boolean(fromCurrentUser && (0, _reviewsHelpers.isPendingReview)(review));
    const hasUncompletedPendingMeasures = review?.measures?.some((measure)=>!measure.is_completed);
    const isPending = isRequiresApproval || hasUncompletedPendingMeasures || review && (0, _reviewsHelpers.isPendingReview)(review);
    return {
        isRequiresApproval,
        isEditable,
        hasUncompletedPendingMeasures,
        isPending
    };
};
exports.default = useCustomerReview;

},{"../helpers/reviews.helpers":"1oYIN","./useAuth":"k9r0q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9U4wC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
const CustomerReviewApprovalReason = (props)=>{
    const { customerId, reviewId } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { data: notes } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_NOTES,
        customerId,
        reviewId
    ], ()=>(0, _apiDefault.default).listCustomerReviewNotations(customerId, reviewId));
    const comment = notes?.map((note)=>note.comment).join("\n");
    if ((0, _stringUtils.isEmptyString)(comment)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                as: "span",
                fontWeight: "semibold",
                children: [
                    f("reviews.labels.review-label"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: comment
            })
        ]
    });
};
exports.default = CustomerReviewApprovalReason;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jTrwn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _statusWaitingSvg = require("../../../assets/icons/status-waiting.svg");
var _statusWaitingSvgDefault = parcelHelpers.interopDefault(_statusWaitingSvg);
var _customerReviewCardEditButton = require("../CustomerReviewCardEditButton/CustomerReviewCardEditButton");
var _customerReviewCardEditButtonDefault = parcelHelpers.interopDefault(_customerReviewCardEditButton);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _useCustomerReviewCardPendingLabel = require("./useCustomerReviewCardPendingLabel");
var _useCustomerReviewCardPendingLabelDefault = parcelHelpers.interopDefault(_useCustomerReviewCardPendingLabel);
const CustomerReviewCardPendingLabel = (props)=>{
    const { customer, review, readonly } = props;
    const { pendingLabel } = (0, _useCustomerReviewCardPendingLabelDefault.default)(review);
    if (!pendingLabel) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        blockAlign: "center",
        align: "space-between",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                blockAlign: "center",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        width: "10px",
                        height: "12px",
                        source: (0, _statusWaitingSvgDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledItalicWrapper, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            color: "subdued",
                            children: pendingLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewCardEditButtonDefault.default), {
                customer: customer,
                review: review,
                readonly: readonly
            })
        ]
    });
};
const StyledItalicWrapper = (0, _styledComponentsDefault.default).span`
  font-style: italic;
`;
exports.default = CustomerReviewCardPendingLabel;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/status-waiting.svg":"cOhJt","../CustomerReviewCardEditButton/CustomerReviewCardEditButton":"3QDdA","../extensions/Icon":"eHSf0","./useCustomerReviewCardPendingLabel":"iopM0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3QDdA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _pencilSvg = require("../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _routes = require("../../constants/routes");
var _useCustomerReview = require("../../hooks/useCustomerReview");
var _useCustomerReviewDefault = parcelHelpers.interopDefault(_useCustomerReview);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const CustomerReviewCardEditButton = (props)=>{
    const { customer, review, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isEditable, isRequiresApproval } = (0, _useCustomerReviewDefault.default)(review);
    const url = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMER_REVIEW, {
        customerId: customer.id,
        id: review.id
    });
    if (isRequiresApproval && review.is_possible_to_approve) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        primary: true,
        disabled: readonly,
        url: url,
        children: f("reviews.labels.review.assessment")
    });
    else if (isEditable) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        primary: true,
        size: "slim",
        disabled: readonly,
        url: url,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _pencilSvgDefault.default),
            useMask: true
        }),
        children: f("default.edit")
    });
    else return null;
};
exports.default = CustomerReviewCardEditButton;

},{"react/jsx-runtime":"enbMA","react-router-dom":"1ee65","../../../assets/icons/pencil.svg":"gEWpJ","../../constants/routes":"ihtm8","../../hooks/useCustomerReview":"8Ciom","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iopM0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useCustomerReview = require("../../hooks/useCustomerReview");
var _useCustomerReviewDefault = parcelHelpers.interopDefault(_useCustomerReview);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _stringUtils = require("../../utils/stringUtils");
const useCustomerReviewCardPendingLabel = (review)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const { isRequiresApproval, hasUncompletedPendingMeasures, isPending } = (0, _useCustomerReviewDefault.default)(review);
    const approversNames = formatMultipleNames(review.approval_users?.map(getUserDisplayName));
    const approvalLabel = (0, _stringUtils.isEmptyString)(approversNames) ? f("details.reviews.awaiting-approval") : f("details.reviews.awaiting-approval-with-names", {
        names: approversNames
    });
    const pendingMeasuresLabel = hasUncompletedPendingMeasures ? f("details.reviews.awaiting-measures") : undefined;
    let pendingLabel = undefined;
    if (isRequiresApproval) pendingLabel = approvalLabel;
    else if (hasUncompletedPendingMeasures) pendingLabel = pendingMeasuresLabel;
    else if (isPending) pendingLabel = f("details.reviews.draft");
    return {
        pendingLabel
    };
};
exports.default = useCustomerReviewCardPendingLabel;

},{"../../hooks/useCustomerReview":"8Ciom","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../../hooks/useGetUserName":"edBne","../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aEvQG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFlipMove = require("react-flip-move");
var _reactFlipMoveDefault = parcelHelpers.interopDefault(_reactFlipMove);
var _polaris = require("@shopify/polaris");
var _measuresHelpers = require("../../helpers/measures.helpers");
var _collectionUtils = require("../../utils/collectionUtils");
var _customerReviewMeasure = require("./CustomerReviewMeasure");
var _customerReviewMeasureDefault = parcelHelpers.interopDefault(_customerReviewMeasure);
var _customerReviewMeasuresHeader = require("./CustomerReviewMeasuresHeader");
var _customerReviewMeasuresHeaderDefault = parcelHelpers.interopDefault(_customerReviewMeasuresHeader);
const CustomerReviewMeasures = (props)=>{
    const { customerId, reviewId, measures = [], readonly, onChange } = props;
    const handleMeasureAdd = (measure)=>onChange([
            measure,
            ...measures
        ]);
    const handleMeasureChange = (measure)=>onChange((0, _collectionUtils.updateItem)(measures, measure));
    const handleMeasureRemove = (measure)=>onChange((0, _collectionUtils.removeItem)(measures, measure));
    const handleMeasureCancel = (measure)=>{
        if ((0, _measuresHelpers.isNewMeasure)(measure)) handleMeasureRemove(measure);
        else handleMeasureChange(measure);
    };
    const handleOrderChange = (index, direction)=>{
        const targetIndex = direction === "up" ? index - 1 : index + 1;
        onChange((0, _collectionUtils.swapElements)(measures, index, targetIndex));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasuresHeaderDefault.default), {
                customerId: customerId,
                reviewId: reviewId,
                measures: measures,
                readonly: readonly,
                onAfterAdd: handleMeasureAdd
            }),
            measures.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                gap: "4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFlipMoveDefault.default), {
                    children: measures.map((measure, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasureDefault.default), {
                            customerId: customerId,
                            reviewId: reviewId,
                            measure: measure,
                            isFirst: index === 0,
                            isLast: index === measures.length - 1,
                            onChange: handleMeasureChange,
                            onCancel: handleMeasureCancel,
                            onAfterRemove: handleMeasureRemove,
                            onOrderChange: (direction)=>handleOrderChange(index, direction),
                            readonly: readonly
                        }, measure.id))
                })
            })
        ]
    });
};
exports.default = CustomerReviewMeasures;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-flip-move":"7Sobo","@shopify/polaris":"ek5a0","../../helpers/measures.helpers":"4P5ib","../../utils/collectionUtils":"gr5mc","./CustomerReviewMeasure":"9SWf7","./CustomerReviewMeasuresHeader":"bkFwe","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Sobo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function warnOnce(msg) {
    var hasWarned = false;
    return function() {
        if (!hasWarned) {
            console.warn(msg);
            hasWarned = true;
        }
    };
}
var statelessFunctionalComponentSupplied = warnOnce("\n>> Error, via react-flip-move <<\n\nYou provided a stateless functional component as a child to <FlipMove>. Unfortunately, SFCs aren't supported, because Flip Move needs access to the backing instances via refs, and SFCs don't have a public instance that holds that info.\n\nPlease wrap your components in a native element (eg. <div>), or a non-functional component.\n");
var primitiveNodeSupplied = warnOnce("\n>> Error, via react-flip-move <<\n\nYou provided a primitive (text or number) node as a child to <FlipMove>. Flip Move needs containers with unique keys to move children around.\n\nPlease wrap your value in a native element (eg. <span>), or a component.\n");
var invalidTypeForTimingProp = function invalidTypeForTimingProp(args) {
    return console.error("\n>> Error, via react-flip-move <<\n\nThe prop you provided for '" + args.prop + "' is invalid. It needs to be a positive integer, or a string that can be resolved to a number. The value you provided is '" + args.value + "'.\n\nAs a result,  the default value for this parameter will be used, which is '" + args.defaultValue + "'.\n");
};
var invalidEnterLeavePreset = function invalidEnterLeavePreset(args) {
    return console.error("\n>> Error, via react-flip-move <<\n\nThe enter/leave preset you provided is invalid. We don't currently have a '" + args.value + " preset.'\n\nAcceptable values are " + args.acceptableValues + ". The default value of '" + args.defaultValue + "' will be used.\n");
};
var parentNodePositionStatic = warnOnce("\n>> Warning, via react-flip-move <<\n\nWhen using \"wrapperless\" mode (by supplying 'typeName' of 'null'), strange things happen when the direct parent has the default \"static\" position.\n\nFlipMove has added 'position: relative' to this node, to ensure Flip Move animates correctly.\n\nTo avoid seeing this warning, simply apply a non-static position to that parent node.\n");
var childIsDisabled = warnOnce("\n>> Warning, via react-flip-move <<\n\nOne or more of Flip Move's child elements have the html attribute 'disabled' set to true.\n\nPlease note that this will cause animations to break in Internet Explorer 11 and below. Either remove the disabled attribute or set 'animation' to false.\n");
var enterPresets = {
    elevator: {
        from: {
            transform: "scale(0)",
            opacity: "0"
        },
        to: {
            transform: "",
            opacity: ""
        }
    },
    fade: {
        from: {
            opacity: "0"
        },
        to: {
            opacity: ""
        }
    },
    accordionVertical: {
        from: {
            transform: "scaleY(0)",
            transformOrigin: "center top"
        },
        to: {
            transform: "",
            transformOrigin: "center top"
        }
    },
    accordionHorizontal: {
        from: {
            transform: "scaleX(0)",
            transformOrigin: "left center"
        },
        to: {
            transform: "",
            transformOrigin: "left center"
        }
    },
    none: null
};
/**
 * React Flip Move | enterLeavePresets
 * (c) 2016-present Joshua Comeau
 *
 * This contains the master list of presets available for enter/leave animations,
 * along with the mapping between preset and styles.
 */ var leavePresets = {
    elevator: {
        from: {
            transform: "scale(1)",
            opacity: "1"
        },
        to: {
            transform: "scale(0)",
            opacity: "0"
        }
    },
    fade: {
        from: {
            opacity: "1"
        },
        to: {
            opacity: "0"
        }
    },
    accordionVertical: {
        from: {
            transform: "scaleY(1)",
            transformOrigin: "center top"
        },
        to: {
            transform: "scaleY(0)",
            transformOrigin: "center top"
        }
    },
    accordionHorizontal: {
        from: {
            transform: "scaleX(1)",
            transformOrigin: "left center"
        },
        to: {
            transform: "scaleX(0)",
            transformOrigin: "left center"
        }
    },
    none: null
};
// For now, appearPresets will be identical to enterPresets.
// Assigning a custom export in case we ever want to add appear-specific ones.
var appearPresets = enterPresets;
var defaultPreset = "elevator";
var disablePreset = "none";
var find = function find(predicate, arr) {
    for(var i = 0; i < arr.length; i++){
        if (predicate(arr[i], i, arr)) return arr[i];
    }
    return undefined;
};
var every = function every(predicate, arr) {
    for(var i = 0; i < arr.length; i++){
        if (!predicate(arr[i], i, arr)) return false;
    }
    return true;
};
// eslint-disable-next-line import/no-mutable-exports
var _isArray = function isArray(arr) {
    _isArray = Array.isArray || function(arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
    };
    return _isArray(arr);
};
var isElementAnSFC = function isElementAnSFC(element) {
    var isNativeDOMElement = typeof element.type === "string";
    if (isNativeDOMElement) return false;
    return typeof element.type === "function" && !element.type.prototype.isReactComponent;
};
function omit(obj) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (attrs.indexOf(key) === -1) result[key] = obj[key];
    });
    return result;
}
function arraysEqual(a, b) {
    var sameObject = a === b;
    if (sameObject) return true;
    var notBothArrays = !_isArray(a) || !_isArray(b);
    var differentLengths = a.length !== b.length;
    if (notBothArrays || differentLengths) return false;
    return every(function(element, index) {
        return element === b[index];
    }, a);
}
function memoizeString(fn) {
    var cache = {};
    return function(str) {
        if (!cache[str]) cache[str] = fn(str);
        return cache[str];
    };
}
var hyphenate = memoizeString(function(str) {
    return str.replace(/([A-Z])/g, "-$1").toLowerCase();
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
/**
 * React Flip Move | propConverter
 * (c) 2016-present Joshua Comeau
 *
 * Abstracted away a bunch of the messy business with props.
 *   - props flow types and defaultProps
 *   - Type conversion (We accept 'string' and 'number' values for duration,
 *     delay, and other fields, but we actually need them to be ints.)
 *   - Children conversion (we need the children to be an array. May not always
 *     be, if a single child is passed in.)
 *   - Resolving animation presets into their base CSS styles
 */ /* eslint-disable block-scoped-var */ // eslint-disable-next-line no-duplicate-imports
function propConverter(ComposedComponent) {
    var _class, _temp;
    return _temp = _class = function(_Component) {
        inherits(FlipMovePropConverter, _Component);
        function FlipMovePropConverter() {
            classCallCheck(this, FlipMovePropConverter);
            return possibleConstructorReturn(this, _Component.apply(this, arguments));
        }
        // eslint-disable-next-line class-methods-use-this
        FlipMovePropConverter.prototype.checkChildren = function checkChildren(children) {
            return;
        };
        FlipMovePropConverter.prototype.convertProps = function convertProps(props) {
            var workingProps = {
                // explicitly bypass the props that don't need conversion
                children: props.children,
                easing: props.easing,
                onStart: props.onStart,
                onFinish: props.onFinish,
                onStartAll: props.onStartAll,
                onFinishAll: props.onFinishAll,
                typeName: props.typeName,
                disableAllAnimations: props.disableAllAnimations,
                getPosition: props.getPosition,
                maintainContainerHeight: props.maintainContainerHeight,
                verticalAlignment: props.verticalAlignment,
                // Do string-to-int conversion for all timing-related props
                duration: this.convertTimingProp("duration"),
                delay: this.convertTimingProp("delay"),
                staggerDurationBy: this.convertTimingProp("staggerDurationBy"),
                staggerDelayBy: this.convertTimingProp("staggerDelayBy"),
                // Our enter/leave animations can be specified as boolean (default or
                // disabled), string (preset name), or object (actual animation values).
                // Let's standardize this so that they're always objects
                appearAnimation: this.convertAnimationProp(props.appearAnimation, appearPresets),
                enterAnimation: this.convertAnimationProp(props.enterAnimation, enterPresets),
                leaveAnimation: this.convertAnimationProp(props.leaveAnimation, leavePresets),
                delegated: {}
            };
            this.checkChildren(workingProps.children);
            // Gather any additional props;
            // they will be delegated to the ReactElement created.
            var primaryPropKeys = Object.keys(workingProps);
            var delegatedProps = omit(this.props, primaryPropKeys);
            // The FlipMove container element needs to have a non-static position.
            // We use `relative` by default, but it can be overridden by the user.
            // Now that we're delegating props, we need to merge this in.
            delegatedProps.style = _extends({
                position: "relative"
            }, delegatedProps.style);
            workingProps.delegated = delegatedProps;
            return workingProps;
        };
        FlipMovePropConverter.prototype.convertTimingProp = function convertTimingProp(prop) {
            var rawValue = this.props[prop];
            var value = typeof rawValue === "number" ? rawValue : parseInt(rawValue, 10);
            if (isNaN(value)) {
                var defaultValue = FlipMovePropConverter.defaultProps[prop];
                return defaultValue;
            }
            return value;
        };
        // eslint-disable-next-line class-methods-use-this
        FlipMovePropConverter.prototype.convertAnimationProp = function convertAnimationProp(animation, presets) {
            switch(typeof animation === "undefined" ? "undefined" : _typeof(animation)){
                case "boolean":
                    // If it's true, we want to use the default preset.
                    // If it's false, we want to use the 'none' preset.
                    return presets[animation ? defaultPreset : disablePreset];
                case "string":
                    var presetKeys = Object.keys(presets);
                    if (presetKeys.indexOf(animation) === -1) return presets[defaultPreset];
                    return presets[animation];
                default:
                    return animation;
            }
        };
        FlipMovePropConverter.prototype.render = function render() {
            return (0, _reactDefault.default).createElement(ComposedComponent, this.convertProps(this.props));
        };
        return FlipMovePropConverter;
    }((0, _react.Component)), _class.defaultProps = {
        easing: "ease-in-out",
        duration: 350,
        delay: 0,
        staggerDurationBy: 0,
        staggerDelayBy: 0,
        typeName: "div",
        enterAnimation: defaultPreset,
        leaveAnimation: defaultPreset,
        disableAllAnimations: false,
        getPosition: function getPosition(node) {
            return node.getBoundingClientRect();
        },
        maintainContainerHeight: false,
        verticalAlignment: "top"
    }, _temp;
}
/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 *
 * These methods read from and write to the DOM.
 * They almost always have side effects, and will hopefully become the
 * only spot in the codebase with impure functions.
 */ function applyStylesToDOMNode(_ref) {
    var domNode = _ref.domNode, styles = _ref.styles;
    // Can't just do an object merge because domNode.styles is no regular object.
    // Need to do it this way for the engine to fire its `set` listeners.
    Object.keys(styles).forEach(function(key) {
        domNode.style.setProperty(hyphenate(key), styles[key]);
    });
}
// Modified from Modernizr
function whichTransitionEvent() {
    var transitions = {
        transition: "transitionend",
        "-o-transition": "oTransitionEnd",
        "-moz-transition": "transitionend",
        "-webkit-transition": "webkitTransitionEnd"
    };
    // If we're running in a browserless environment (eg. SSR), it doesn't apply.
    // Return a placeholder string, for consistent type return.
    if (typeof document === "undefined") return "";
    var el = document.createElement("fakeelement");
    var match = find(function(t) {
        return el.style.getPropertyValue(t) !== undefined;
    }, Object.keys(transitions));
    // If no `transition` is found, we must be running in a browser so ancient,
    // React itself won't run. Return an empty string, for consistent type return
    return match ? transitions[match] : "";
}
var getRelativeBoundingBox = function getRelativeBoundingBox(_ref2) {
    var childDomNode = _ref2.childDomNode, parentDomNode = _ref2.parentDomNode, getPosition = _ref2.getPosition;
    var parentBox = getPosition(parentDomNode);
    var _getPosition = getPosition(childDomNode), top = _getPosition.top, left = _getPosition.left, right = _getPosition.right, bottom = _getPosition.bottom, width = _getPosition.width, height = _getPosition.height;
    return {
        top: top - parentBox.top,
        left: left - parentBox.left,
        right: parentBox.right - right,
        bottom: parentBox.bottom - bottom,
        width: width,
        height: height
    };
};
/** getPositionDelta
 * This method returns the delta between two bounding boxes, to figure out
 * how many pixels on each axis the element has moved.
 *
 */ var getPositionDelta = function getPositionDelta(_ref3) {
    var childDomNode = _ref3.childDomNode, childBoundingBox = _ref3.childBoundingBox, parentBoundingBox = _ref3.parentBoundingBox, getPosition = _ref3.getPosition;
    // TEMP: A mystery bug is sometimes causing unnecessary boundingBoxes to
    var defaultBox = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: 0,
        width: 0
    };
    // Our old box is its last calculated position, derived on mount or at the
    // start of the previous animation.
    var oldRelativeBox = childBoundingBox || defaultBox;
    var parentBox = parentBoundingBox || defaultBox;
    // Our new box is the new final resting place: Where we expect it to wind up
    // after the animation. First we get the box in absolute terms (AKA relative
    // to the viewport), and then we calculate its relative box (relative to the
    // parent container)
    var newAbsoluteBox = getPosition(childDomNode);
    var newRelativeBox = {
        top: newAbsoluteBox.top - parentBox.top,
        left: newAbsoluteBox.left - parentBox.left
    };
    return [
        oldRelativeBox.left - newRelativeBox.left,
        oldRelativeBox.top - newRelativeBox.top
    ];
};
/** removeNodeFromDOMFlow
 * This method does something very sneaky: it removes a DOM node from the
 * document flow, but without actually changing its on-screen position.
 *
 * It works by calculating where the node is, and then applying styles
 * so that it winds up being positioned absolutely, but in exactly the
 * same place.
 *
 * This is a vital part of the FLIP technique.
 */ var removeNodeFromDOMFlow = function removeNodeFromDOMFlow(childData, verticalAlignment) {
    var domNode = childData.domNode, boundingBox = childData.boundingBox;
    if (!domNode || !boundingBox) return;
    // For this to work, we have to offset any given `margin`.
    var computed = window.getComputedStyle(domNode);
    // We need to clean up margins, by converting and removing suffix:
    // eg. '21px' -> 21
    var marginAttrs = [
        "margin-top",
        "margin-left",
        "margin-right"
    ];
    var margins = marginAttrs.reduce(function(acc, margin) {
        var _babelHelpers$extends;
        var propertyVal = computed.getPropertyValue(margin);
        return _extends({}, acc, (_babelHelpers$extends = {}, _babelHelpers$extends[margin] = Number(propertyVal.replace("px", "")), _babelHelpers$extends));
    }, {});
    // If we're bottom-aligned, we need to add the height of the child to its
    // top offset. This is because, when the container is bottom-aligned, its
    // height shrinks from the top, not the bottom. We're removing this node
    // from the flow, so the top is going to drop by its height.
    var topOffset = verticalAlignment === "bottom" ? boundingBox.top - boundingBox.height : boundingBox.top;
    var styles = {
        position: "absolute",
        top: topOffset - margins["margin-top"] + "px",
        left: boundingBox.left - margins["margin-left"] + "px",
        right: boundingBox.right - margins["margin-right"] + "px"
    };
    applyStylesToDOMNode({
        domNode: domNode,
        styles: styles
    });
};
/** updateHeightPlaceholder
 * An optional property to FlipMove is a `maintainContainerHeight` boolean.
 * This property creates a node that fills space, so that the parent
 * container doesn't collapse when its children are removed from the
 * document flow.
 */ var updateHeightPlaceholder = function updateHeightPlaceholder(_ref4) {
    var domNode = _ref4.domNode, parentData = _ref4.parentData, getPosition = _ref4.getPosition;
    var parentDomNode = parentData.domNode;
    var parentBoundingBox = parentData.boundingBox;
    if (!parentDomNode || !parentBoundingBox) return;
    // We need to find the height of the container *without* the placeholder.
    // Since it's possible that the placeholder might already be present,
    // we first set its height to 0.
    // This allows the container to collapse down to the size of just its
    // content (plus container padding or borders if any).
    applyStylesToDOMNode({
        domNode: domNode,
        styles: {
            height: "0"
        }
    });
    // Find the distance by which the container would be collapsed by elements
    // leaving. We compare the freshly-available parent height with the original,
    // cached container height.
    var originalParentHeight = parentBoundingBox.height;
    var collapsedParentHeight = getPosition(parentDomNode).height;
    var reductionInHeight = originalParentHeight - collapsedParentHeight;
    // If the container has become shorter, update the padding element's
    // height to take up the difference. Otherwise set its height to zero,
    // so that it has no effect.
    var styles = {
        height: reductionInHeight > 0 ? reductionInHeight + "px" : "0"
    };
    applyStylesToDOMNode({
        domNode: domNode,
        styles: styles
    });
};
var getNativeNode = function getNativeNode(element) {
    // When running in a windowless environment, abort!
    if (typeof HTMLElement === "undefined") return null;
    // `element` may already be a native node.
    if (element instanceof HTMLElement) return element;
    // While ReactDOM's `findDOMNode` is discouraged, it's the only
    // publicly-exposed way to find the underlying DOM node for
    // composite components.
    var foundNode = (0, _reactDom.findDOMNode)(element);
    if (foundNode && foundNode.nodeType === Node.TEXT_NODE) // Text nodes are not supported
    return null;
    // eslint-disable-next-line flowtype/no-weak-types
    return foundNode;
};
var createTransitionString = function createTransitionString(index, props) {
    var delay = props.delay, duration = props.duration;
    var staggerDurationBy = props.staggerDurationBy, staggerDelayBy = props.staggerDelayBy, easing = props.easing;
    delay += index * staggerDelayBy;
    duration += index * staggerDurationBy;
    var cssProperties = [
        "transform",
        "opacity"
    ];
    return cssProperties.map(function(prop) {
        return prop + " " + duration + "ms " + easing + " " + delay + "ms";
    }).join(", ");
};
/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 *
 * For information on how this code is laid out, check out CODE_TOUR.md
 */ /* eslint-disable react/prop-types */ // eslint-disable-next-line no-duplicate-imports
var transitionEnd = whichTransitionEvent();
var noBrowserSupport = !transitionEnd;
function getKey(childData) {
    return childData.key || "";
}
function getElementChildren(children) {
    // Fix incomplete typing of Children.toArray
    // eslint-disable-next-line flowtype/no-weak-types
    return (0, _react.Children).toArray(children);
}
var FlipMove$1 = function(_Component) {
    inherits(FlipMove, _Component);
    function FlipMove() {
        var _temp, _this, _ret;
        classCallCheck(this, FlipMove);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.state = {
            children: getElementChildren(// `this.props` ought to always be defined at this point, but a report
            // was made about it not being defined in IE10.
            // TODO: Test in IE10, to see if there's an underlying cause that can
            // be addressed.
            _this.props ? _this.props.children : []).map(function(element) {
                return _extends({}, element, {
                    element: element,
                    appearing: true
                });
            })
        }, _this.childrenData = {}, _this.parentData = {
            domNode: null,
            boundingBox: null
        }, _this.heightPlaceholderData = {
            domNode: null
        }, _this.remainingAnimations = 0, _this.childrenToAnimate = [], _this.findDOMContainer = function() {
            // eslint-disable-next-line react/no-find-dom-node
            var domNode = (0, _reactDomDefault.default).findDOMNode(_this);
            var parentNode = domNode && domNode.parentNode;
            // This ought to be impossible, but handling it for Flow's sake.
            if (!parentNode || !(parentNode instanceof HTMLElement)) return;
            // If the parent node has static positioning, leave animations might look
            // really funky. Let's automatically apply `position: relative` in this
            // case, to prevent any quirkiness.
            if (window.getComputedStyle(parentNode).position === "static") {
                parentNode.style.position = "relative";
                parentNodePositionStatic();
            }
            _this.parentData.domNode = parentNode;
        }, _this.runAnimation = function() {
            var dynamicChildren = _this.state.children.filter(_this.doesChildNeedToBeAnimated);
            // Splitting DOM reads and writes to be peformed in batches
            var childrenInitialStyles = dynamicChildren.map(function(child) {
                return _this.computeInitialStyles(child);
            });
            dynamicChildren.forEach(function(child, index) {
                _this.remainingAnimations += 1;
                _this.childrenToAnimate.push(getKey(child));
                _this.animateChild(child, index, childrenInitialStyles[index]);
            });
            if (typeof _this.props.onStartAll === "function") _this.callChildrenHook(_this.props.onStartAll);
        }, _this.doesChildNeedToBeAnimated = function(child) {
            // If the child doesn't have a key, it's an immovable child (one that we
            // do not want to do FLIP stuff to.)
            if (!getKey(child)) return false;
            var childData = _this.getChildData(getKey(child));
            var childDomNode = childData.domNode;
            var childBoundingBox = childData.boundingBox;
            var parentBoundingBox = _this.parentData.boundingBox;
            if (!childDomNode) return false;
            var _this$props = _this.props, appearAnimation = _this$props.appearAnimation, enterAnimation = _this$props.enterAnimation, leaveAnimation = _this$props.leaveAnimation, getPosition = _this$props.getPosition;
            var isAppearingWithAnimation = child.appearing && appearAnimation;
            var isEnteringWithAnimation = child.entering && enterAnimation;
            var isLeavingWithAnimation = child.leaving && leaveAnimation;
            if (isAppearingWithAnimation || isEnteringWithAnimation || isLeavingWithAnimation) return true;
            // If it isn't entering/leaving, we want to animate it if it's
            // on-screen position has changed.
            var _getPositionDelta = getPositionDelta({
                childDomNode: childDomNode,
                childBoundingBox: childBoundingBox,
                parentBoundingBox: parentBoundingBox,
                getPosition: getPosition
            }), dX = _getPositionDelta[0], dY = _getPositionDelta[1];
            return dX !== 0 || dY !== 0;
        }, _temp), possibleConstructorReturn(_this, _ret);
    }
    // Copy props.children into state.
    // To understand why this is important (and not an anti-pattern), consider
    // how "leave" animations work. An item has "left" when the component
    // receives a new set of props that do NOT contain the item.
    // If we just render the props as-is, the item would instantly disappear.
    // We want to keep the item rendered for a little while, until its animation
    // can complete. Because we cannot mutate props, we make `state` the source
    // of truth.
    // FlipMove needs to know quite a bit about its children in order to do
    // its job. We store these as a property on the instance. We're not using
    // state, because we don't want changes to trigger re-renders, we just
    // need a place to keep the data for reference, when changes happen.
    // This field should not be accessed directly. Instead, use getChildData,
    // putChildData, etc...
    // Similarly, track the dom node and box of our parent element.
    // If `maintainContainerHeight` prop is set to true, we'll create a
    // placeholder element which occupies space so that the parent height
    // doesn't change when items are removed from the document flow (which
    // happens during leave animations)
    // Keep track of remaining animations so we know when to fire the
    // all-finished callback, and clean up after ourselves.
    // NOTE: we can't simply use childrenToAnimate.length to track remaining
    // animations, because we need to maintain the list of animating children,
    // to pass to the `onFinishAll` handler.
    FlipMove.prototype.componentDidMount = function componentDidMount() {
        // Because React 16 no longer requires wrapping elements, Flip Move can opt
        // to not wrap the children in an element. In that case, find the parent
        // element using `findDOMNode`.
        if (this.props.typeName === null) this.findDOMContainer();
        // Run our `appearAnimation` if it was requested, right after the
        // component mounts.
        var shouldTriggerFLIP = this.props.appearAnimation && !this.isAnimationDisabled(this.props);
        if (shouldTriggerFLIP) {
            this.prepForAnimation();
            this.runAnimation();
        }
    };
    FlipMove.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
        if (this.props.typeName === null) this.findDOMContainer();
        // If the children have been re-arranged, moved, or added/removed,
        // trigger the main FLIP animation.
        //
        // IMPORTANT: We need to make sure that the children have actually changed.
        // At the end of the transition, we clean up nodes that need to be removed.
        // We DON'T want this cleanup to trigger another update.
        var oldChildrenKeys = getElementChildren(this.props.children).map(function(d) {
            return d.key;
        });
        var nextChildrenKeys = getElementChildren(previousProps.children).map(function(d) {
            return d.key;
        });
        var shouldTriggerFLIP = !arraysEqual(oldChildrenKeys, nextChildrenKeys) && !this.isAnimationDisabled(this.props);
        if (shouldTriggerFLIP) {
            this.prepForAnimation();
            this.runAnimation();
        }
    };
    FlipMove.prototype.calculateNextSetOfChildren = function calculateNextSetOfChildren(nextChildren) {
        var _this2 = this;
        // We want to:
        //   - Mark all new children as `entering`
        //   - Pull in previous children that aren't in nextChildren, and mark them
        //     as `leaving`
        //   - Preserve the nextChildren list order, with leaving children in their
        //     appropriate places.
        //
        var updatedChildren = nextChildren.map(function(nextChild) {
            var child = _this2.findChildByKey(nextChild.key);
            // If the current child did exist, but it was in the midst of leaving,
            // we want to treat it as though it's entering
            var isEntering = !child || child.leaving;
            return _extends({}, nextChild, {
                element: nextChild,
                entering: isEntering
            });
        });
        // This is tricky. We want to keep the nextChildren's ordering, but with
        // any just-removed items maintaining their original position.
        // eg.
        //   this.state.children  = [ 1, 2, 3, 4 ]
        //   nextChildren         = [ 3, 1 ]
        //
        // In this example, we've removed the '2' & '4'
        // We want to end up with:  [ 2, 3, 1, 4 ]
        //
        // To accomplish that, we'll iterate through this.state.children. whenever
        // we find a match, we'll append our `leaving` flag to it, and insert it
        // into the nextChildren in its ORIGINAL position. Note that, as we keep
        // inserting old items into the new list, the "original" position will
        // keep incrementing.
        var numOfChildrenLeaving = 0;
        this.state.children.forEach(function(child, index) {
            var isLeaving = !find(function(_ref) {
                var key = _ref.key;
                return key === getKey(child);
            }, nextChildren);
            // If the child isn't leaving (or, if there is no leave animation),
            // we don't need to add it into the state children.
            if (!isLeaving || !_this2.props.leaveAnimation) return;
            var nextChild = _extends({}, child, {
                leaving: true
            });
            var nextChildIndex = index + numOfChildrenLeaving;
            updatedChildren.splice(nextChildIndex, 0, nextChild);
            numOfChildrenLeaving += 1;
        });
        return updatedChildren;
    };
    FlipMove.prototype.prepForAnimation = function prepForAnimation() {
        var _this3 = this;
        // Our animation prep consists of:
        // - remove children that are leaving from the DOM flow, so that the new
        //   layout can be accurately calculated,
        // - update the placeholder container height, if needed, to ensure that
        //   the parent's height doesn't collapse.
        var _props = this.props, leaveAnimation = _props.leaveAnimation, maintainContainerHeight = _props.maintainContainerHeight, getPosition = _props.getPosition;
        // we need to make all leaving nodes "invisible" to the layout calculations
        // that will take place in the next step (this.runAnimation).
        if (leaveAnimation) {
            var leavingChildren = this.state.children.filter(function(child) {
                return child.leaving;
            });
            leavingChildren.forEach(function(leavingChild) {
                var childData = _this3.getChildData(getKey(leavingChild));
                // Warn if child is disabled
                if (!_this3.isAnimationDisabled(_this3.props) && childData.domNode && childData.domNode.disabled) childIsDisabled();
                // We need to take the items out of the "flow" of the document, so that
                // its siblings can move to take its place.
                if (childData.boundingBox) removeNodeFromDOMFlow(childData, _this3.props.verticalAlignment);
            });
            if (maintainContainerHeight && this.heightPlaceholderData.domNode) updateHeightPlaceholder({
                domNode: this.heightPlaceholderData.domNode,
                parentData: this.parentData,
                getPosition: getPosition
            });
        }
        // For all children not in the middle of entering or leaving,
        // we need to reset the transition, so that the NEW shuffle starts from
        // the right place.
        this.state.children.forEach(function(child) {
            var _getChildData = _this3.getChildData(getKey(child)), domNode = _getChildData.domNode;
            // Ignore children that don't render DOM nodes (eg. by returning null)
            if (!domNode) return;
            if (!child.entering && !child.leaving) applyStylesToDOMNode({
                domNode: domNode,
                styles: {
                    transition: ""
                }
            });
        });
    };
    // eslint-disable-next-line camelcase
    FlipMove.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        // When the component is handed new props, we need to figure out the
        // "resting" position of all currently-rendered DOM nodes.
        // We store that data in this.parent and this.children,
        // so it can be used later to work out the animation.
        this.updateBoundingBoxCaches();
        // Convert opaque children object to array.
        var nextChildren = getElementChildren(nextProps.children);
        // Next, we need to update our state, so that it contains our new set of
        // children. If animation is disabled or unsupported, this is easy;
        // we just copy our props into state.
        // Assuming that we can animate, though, we have to do some work.
        // Essentially, we want to keep just-deleted nodes in the DOM for a bit
        // longer, so that we can animate them away.
        this.setState({
            children: this.isAnimationDisabled(nextProps) ? nextChildren.map(function(element) {
                return _extends({}, element, {
                    element: element
                });
            }) : this.calculateNextSetOfChildren(nextChildren)
        });
    };
    FlipMove.prototype.animateChild = function animateChild(child, index, childInitialStyles) {
        var _this4 = this;
        var _getChildData2 = this.getChildData(getKey(child)), domNode = _getChildData2.domNode;
        if (!domNode) return;
        // Apply the relevant style for this DOM node
        // This is the offset from its actual DOM position.
        // eg. if an item has been re-rendered 20px lower, we want to apply a
        // style of 'transform: translate(-20px)', so that it appears to be where
        // it started.
        // In FLIP terminology, this is the 'Invert' stage.
        applyStylesToDOMNode({
            domNode: domNode,
            styles: childInitialStyles
        });
        // Start by invoking the onStart callback for this child.
        if (this.props.onStart) this.props.onStart(child, domNode);
        // Next, animate the item from it's artificially-offset position to its
        // new, natural position.
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                // NOTE, RE: the double-requestAnimationFrame:
                // Sadly, this is the most browser-compatible way to do this I've found.
                // Essentially we need to set the initial styles outside of any request
                // callbacks to avoid batching them. Then, a frame needs to pass with
                // the styles above rendered. Then, on the second frame, we can apply
                // our final styles to perform the animation.
                // Our first order of business is to "undo" the styles applied in the
                // previous frames, while also adding a `transition` property.
                // This way, the item will smoothly transition from its old position
                // to its new position.
                // eslint-disable-next-line flowtype/require-variable-type
                var styles = {
                    transition: createTransitionString(index, _this4.props),
                    transform: "",
                    opacity: ""
                };
                if (child.appearing && _this4.props.appearAnimation) styles = _extends({}, styles, _this4.props.appearAnimation.to);
                else if (child.entering && _this4.props.enterAnimation) styles = _extends({}, styles, _this4.props.enterAnimation.to);
                else if (child.leaving && _this4.props.leaveAnimation) styles = _extends({}, styles, _this4.props.leaveAnimation.to);
                // In FLIP terminology, this is the 'Play' stage.
                applyStylesToDOMNode({
                    domNode: domNode,
                    styles: styles
                });
            });
        });
        this.bindTransitionEndHandler(child);
    };
    FlipMove.prototype.bindTransitionEndHandler = function bindTransitionEndHandler(child) {
        var _this5 = this;
        var _getChildData3 = this.getChildData(getKey(child)), domNode = _getChildData3.domNode;
        if (!domNode) return;
        // The onFinish callback needs to be bound to the transitionEnd event.
        // We also need to unbind it when the transition completes, so this ugly
        // inline function is required (we need it here so it closes over
        // dependent variables `child` and `domNode`)
        var transitionEndHandler = function transitionEndHandler(ev) {
            // It's possible that this handler is fired not on our primary transition,
            // but on a nested transition (eg. a hover effect). Ignore these cases.
            if (ev.target !== domNode) return;
            // Remove the 'transition' inline style we added. This is cleanup.
            domNode.style.transition = "";
            // Trigger any applicable onFinish/onFinishAll hooks
            _this5.triggerFinishHooks(child, domNode);
            domNode.removeEventListener(transitionEnd, transitionEndHandler);
            if (child.leaving) _this5.removeChildData(getKey(child));
        };
        domNode.addEventListener(transitionEnd, transitionEndHandler);
    };
    FlipMove.prototype.triggerFinishHooks = function triggerFinishHooks(child, domNode) {
        var _this6 = this;
        if (this.props.onFinish) this.props.onFinish(child, domNode);
        // Reduce the number of children we need to animate by 1,
        // so that we can tell when all children have finished.
        this.remainingAnimations -= 1;
        if (this.remainingAnimations === 0) {
            // Remove any items from the DOM that have left, and reset `entering`.
            var nextChildren = this.state.children.filter(function(_ref2) {
                var leaving = _ref2.leaving;
                return !leaving;
            }).map(function(item) {
                return _extends({}, item, {
                    // fix for Flow
                    element: item.element,
                    appearing: false,
                    entering: false
                });
            });
            this.setState({
                children: nextChildren
            }, function() {
                if (typeof _this6.props.onFinishAll === "function") _this6.callChildrenHook(_this6.props.onFinishAll);
                // Reset our variables for the next iteration
                _this6.childrenToAnimate = [];
            });
            // If the placeholder was holding the container open while elements were
            // leaving, we we can now set its height to zero.
            if (this.heightPlaceholderData.domNode) this.heightPlaceholderData.domNode.style.height = "0";
        }
    };
    FlipMove.prototype.callChildrenHook = function callChildrenHook(hook) {
        var _this7 = this;
        var elements = [];
        var domNodes = [];
        this.childrenToAnimate.forEach(function(childKey) {
            // If this was an exit animation, the child may no longer exist.
            // If so, skip it.
            var child = _this7.findChildByKey(childKey);
            if (!child) return;
            elements.push(child);
            if (_this7.hasChildData(childKey)) domNodes.push(_this7.getChildData(childKey).domNode);
        });
        hook(elements, domNodes);
    };
    FlipMove.prototype.updateBoundingBoxCaches = function updateBoundingBoxCaches() {
        var _this8 = this;
        // This is the ONLY place that parentData and childrenData's
        // bounding boxes are updated. They will be calculated at other times
        // to be compared to this value, but it's important that the cache is
        // updated once per update.
        var parentDomNode = this.parentData.domNode;
        if (!parentDomNode) return;
        this.parentData.boundingBox = this.props.getPosition(parentDomNode);
        // Splitting DOM reads and writes to be peformed in batches
        var childrenBoundingBoxes = [];
        this.state.children.forEach(function(child) {
            var childKey = getKey(child);
            // It is possible that a child does not have a `key` property;
            // Ignore these children, they don't need to be moved.
            if (!childKey) {
                childrenBoundingBoxes.push(null);
                return;
            }
            // In very rare circumstances, for reasons unknown, the ref is never
            // populated for certain children. In this case, avoid doing this update.
            // see: https://github.com/joshwcomeau/react-flip-move/pull/91
            if (!_this8.hasChildData(childKey)) {
                childrenBoundingBoxes.push(null);
                return;
            }
            var childData = _this8.getChildData(childKey);
            // If the child element returns null, we need to avoid trying to
            // account for it
            if (!childData.domNode || !child) {
                childrenBoundingBoxes.push(null);
                return;
            }
            childrenBoundingBoxes.push(getRelativeBoundingBox({
                childDomNode: childData.domNode,
                parentDomNode: parentDomNode,
                getPosition: _this8.props.getPosition
            }));
        });
        this.state.children.forEach(function(child, index) {
            var childKey = getKey(child);
            var childBoundingBox = childrenBoundingBoxes[index];
            if (!childKey) return;
            _this8.setChildData(childKey, {
                boundingBox: childBoundingBox
            });
        });
    };
    FlipMove.prototype.computeInitialStyles = function computeInitialStyles(child) {
        if (child.appearing) return this.props.appearAnimation ? this.props.appearAnimation.from : {};
        else if (child.entering) {
            if (!this.props.enterAnimation) return {};
            // If this child was in the middle of leaving, it still has its
            // absolute positioning styles applied. We need to undo those.
            return _extends({
                position: "",
                top: "",
                left: "",
                right: "",
                bottom: ""
            }, this.props.enterAnimation.from);
        } else if (child.leaving) return this.props.leaveAnimation ? this.props.leaveAnimation.from : {};
        var childData = this.getChildData(getKey(child));
        var childDomNode = childData.domNode;
        var childBoundingBox = childData.boundingBox;
        var parentBoundingBox = this.parentData.boundingBox;
        if (!childDomNode) return {};
        var _getPositionDelta2 = getPositionDelta({
            childDomNode: childDomNode,
            childBoundingBox: childBoundingBox,
            parentBoundingBox: parentBoundingBox,
            getPosition: this.props.getPosition
        }), dX = _getPositionDelta2[0], dY = _getPositionDelta2[1];
        return {
            transform: "translate(" + dX + "px, " + dY + "px)"
        };
    };
    // eslint-disable-next-line class-methods-use-this
    FlipMove.prototype.isAnimationDisabled = function isAnimationDisabled(props) {
        // If the component is explicitly passed a `disableAllAnimations` flag,
        // we can skip this whole process. Similarly, if all of the numbers have
        // been set to 0, there is no point in trying to animate; doing so would
        // only cause a flicker (and the intent is probably to disable animations)
        // We can also skip this rigamarole if there's no browser support for it.
        return noBrowserSupport || props.disableAllAnimations || props.duration === 0 && props.delay === 0 && props.staggerDurationBy === 0 && props.staggerDelayBy === 0;
    };
    FlipMove.prototype.findChildByKey = function findChildByKey(key) {
        return find(function(child) {
            return getKey(child) === key;
        }, this.state.children);
    };
    FlipMove.prototype.hasChildData = function hasChildData(key) {
        // Object has some built-in properties on its prototype, such as toString.  hasOwnProperty makes
        // sure that key is present on childrenData itself, not on its prototype.
        return Object.prototype.hasOwnProperty.call(this.childrenData, key);
    };
    FlipMove.prototype.getChildData = function getChildData(key) {
        return this.hasChildData(key) ? this.childrenData[key] : {};
    };
    FlipMove.prototype.setChildData = function setChildData(key, data) {
        this.childrenData[key] = _extends({}, this.getChildData(key), data);
    };
    FlipMove.prototype.removeChildData = function removeChildData(key) {
        delete this.childrenData[key];
        this.setState(function(prevState) {
            return _extends({}, prevState, {
                children: prevState.children.filter(function(child) {
                    return child.element.key !== key;
                })
            });
        });
    };
    FlipMove.prototype.createHeightPlaceholder = function createHeightPlaceholder() {
        var _this9 = this;
        var typeName = this.props.typeName;
        // If requested, create an invisible element at the end of the list.
        // Its height will be modified to prevent the container from collapsing
        // prematurely.
        var isContainerAList = typeName === "ul" || typeName === "ol";
        var placeholderType = isContainerAList ? "li" : "div";
        return (0, _react.createElement)(placeholderType, {
            key: "height-placeholder",
            ref: function ref(domNode) {
                _this9.heightPlaceholderData.domNode = domNode;
            },
            style: {
                visibility: "hidden",
                height: 0
            }
        });
    };
    FlipMove.prototype.childrenWithRefs = function childrenWithRefs() {
        var _this10 = this;
        // We need to clone the provided children, capturing a reference to the
        // underlying DOM node. Flip Move needs to use the React escape hatches to
        // be able to do its calculations.
        return this.state.children.map(function(child) {
            return (0, _react.cloneElement)(child.element, {
                ref: function ref(element) {
                    // Functional Components without a forwarded ref are not supported by FlipMove,
                    // because they don't have instances.
                    if (!element) return;
                    var domNode = getNativeNode(element);
                    _this10.setChildData(getKey(child), {
                        domNode: domNode
                    });
                }
            });
        });
    };
    FlipMove.prototype.render = function render() {
        var _this11 = this;
        var _props2 = this.props, typeName = _props2.typeName, delegated = _props2.delegated, leaveAnimation = _props2.leaveAnimation, maintainContainerHeight = _props2.maintainContainerHeight;
        var children = this.childrenWithRefs();
        if (leaveAnimation && maintainContainerHeight) children.push(this.createHeightPlaceholder());
        if (!typeName) return children;
        var props = _extends({}, delegated, {
            children: children,
            ref: function ref(node) {
                _this11.parentData.domNode = node;
            }
        });
        return (0, _react.createElement)(typeName, props);
    };
    return FlipMove;
}((0, _react.Component));
var enhancedFlipMove = /* #__PURE__ */ propConverter(FlipMove$1);
/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 */ exports.default = enhancedFlipMove;

},{"react":"cOWTg","react-dom":"aPjLf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4P5ib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNewMeasure", ()=>createNewMeasure);
parcelHelpers.export(exports, "isNewMeasure", ()=>isNewMeasure);
parcelHelpers.export(exports, "convertMeasureToCreateCustomMeasureRequest", ()=>convertMeasureToCreateCustomMeasureRequest);
parcelHelpers.export(exports, "isInvalidMeasure", ()=>isInvalidMeasure);
parcelHelpers.export(exports, "convertMeasureToUpdateCustomMeasureRequest", ()=>convertMeasureToUpdateCustomMeasureRequest);
parcelHelpers.export(exports, "isMeasureCompleted", ()=>isMeasureCompleted);
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
const NEW_MEASURE_PREFIX = "measure";
const createNewMeasure = ()=>({
        id: (0, _util.uniqueId)(NEW_MEASURE_PREFIX),
        title: "",
        description: "",
        is_completed: false
    });
const isNewMeasure = (measure)=>measure.id?.startsWith(NEW_MEASURE_PREFIX);
const convertMeasureToCreateCustomMeasureRequest = (measure)=>{
    return {
        id: isNewMeasure(measure) ? undefined : measure.id,
        title: measure.title,
        description: measure.description,
        measure_config_id: measure.measure_config_id,
        is_completed: measure.is_completed,
        completed_comment: measure.completed_comment
    };
};
const isInvalidMeasure = ({ title, description })=>(0, _stringUtils.isEmptyString)(title) || (0, _stringUtils.isEmptyString)(description);
const convertMeasureToUpdateCustomMeasureRequest = ({ title, description, is_completed, completed_comment })=>({
        title,
        description,
        is_completed,
        completed_comment
    });
const isMeasureCompleted = (measure)=>measure.is_completed && !(0, _util.isNil)(measure.updated_by);

},{"../utils/stringUtils":"4gVdA","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9SWf7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _pencilSvg = require("../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _measuresHelpers = require("../../helpers/measures.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _stringUtils = require("../../utils/stringUtils");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _customerReviewMeasureTitle = require("../CustomerReviewMeasureTitle/CustomerReviewMeasureTitle");
var _customerReviewMeasureTitleDefault = parcelHelpers.interopDefault(_customerReviewMeasureTitle);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _measureComment = require("../MeasureComment/MeasureComment");
var _measureCommentDefault = parcelHelpers.interopDefault(_measureComment);
var _measuresContainer = require("../MeasureContainer/MeasuresContainer");
var _measuresContainerDefault = parcelHelpers.interopDefault(_measuresContainer);
var _moveButtons = require("../MoveButtons/MoveButtons");
var _moveButtonsDefault = parcelHelpers.interopDefault(_moveButtons);
var _customerReviewMeasureDeleteButton = require("./CustomerReviewMeasureDeleteButton");
var _customerReviewMeasureDeleteButtonDefault = parcelHelpers.interopDefault(_customerReviewMeasureDeleteButton);
var _customerReviewMeasureForm = require("./CustomerReviewMeasureForm");
var _customerReviewMeasureFormDefault = parcelHelpers.interopDefault(_customerReviewMeasureForm);
const CustomerReviewMeasure = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { measure, readonly, isFirst, isLast, onChange, onCancel, onAfterRemove, onOrderChange, ...measuresProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const [isEditing, toggleEditing, closeEditing] = (0, _useOpenCloseDefault.default)((0, _measuresHelpers.isNewMeasure)(measure) && isFirst);
    const showComment = !isEditing;
    const showFooter = !isEditing && !measure.is_completed && !measure.completed_dt;
    const isEmptyComment = (0, _stringUtils.isEmptyString)(measure.completed_comment);
    const editButtonLabel = isEmptyComment ? f("details.reviews.measures.edit-measure") : f("default.edit");
    const moveMeasureMutation = (0, _reactQuery.useMutation)((direction)=>(0, _apiDefault.default).moveCustomerReviewMeasure(measuresProps.customerId, measuresProps.reviewId, measure.id, {
            direction: direction === "up" ? "UP" : "DOWN"
        }), {
        onMutate: onOrderChange
    });
    const handleMeasureChange = (updatedMeasure)=>{
        closeEditing();
        onChange(updatedMeasure);
    };
    const handleMeasureCancel = (measure)=>{
        closeEditing();
        onCancel(measure);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _measuresContainerDefault.default), {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
                hideBorder: true,
                hideIcon: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            inlineAlign: "start",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasureTitleDefault.default), {
                                    measure: measure
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(DescriptionText, {
                                    children: measure.description
                                })
                            ]
                        }),
                        showComment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measureCommentDefault.default), {
                            measure: measure
                        }),
                        isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasureFormDefault.default), {
                            measure: measure,
                            readonly: readonly,
                            onChange: handleMeasureChange,
                            onCancel: handleMeasureCancel,
                            ...measuresProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            align: "space-between",
                            children: [
                                measure.is_completed && measure.completed_dt ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                    italic: true,
                                    children: f("common.labels.completed-by", {
                                        name: getUserDisplayName(measure.completed_by),
                                        timestamp: new Date(measure.completed_dt)
                                    })
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                                showFooter && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasureDeleteButtonDefault.default), {
                                            measure: measure,
                                            ...measuresProps,
                                            readonly: readonly,
                                            onAfterRemove: onAfterRemove
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            primary: true,
                                            size: "slim",
                                            icon: isEmptyComment ? undefined : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                source: (0, _pencilSvgDefault.default),
                                                useMask: true
                                            }),
                                            onClick: toggleEditing,
                                            disabled: readonly,
                                            children: editButtonLabel
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveButtonsDefault.default), {
                spacing: "extraTight",
                disableMoveUp: isFirst,
                disableMoveDown: isLast,
                readonly: readonly,
                onOrderChange: (direction)=>moveMeasureMutation.mutate(direction)
            })
        ]
    });
});
const DescriptionText = (0, _styledComponentsDefault.default).div`
  white-space: pre;
`;
exports.default = CustomerReviewMeasure;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../assets/icons/pencil.svg":"gEWpJ","../../api":"f6lXD","../../helpers/measures.helpers":"4P5ib","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useOpenClose":"idooG","../../utils/stringUtils":"4gVdA","../CondensedText/CondensedText":"1FshD","../CustomerReviewMeasureTitle/CustomerReviewMeasureTitle":"5yiQg","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../KDKBanner/KDKBanner":"3zPW6","../MeasureComment/MeasureComment":"926Yy","../MeasureContainer/MeasuresContainer":"aCAsw","../MoveButtons/MoveButtons":"dsvCr","./CustomerReviewMeasureDeleteButton":"57qmB","./CustomerReviewMeasureForm":"2t00w","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5yiQg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checkmarkCircleFilledSuccessDarkSvg = require("../../../assets/icons/checkmark-circle-filled-success-dark.svg");
var _checkmarkCircleFilledSuccessDarkSvgDefault = parcelHelpers.interopDefault(_checkmarkCircleFilledSuccessDarkSvg);
var _triangleFilledExclamationMonochromeSvg = require("../../../assets/icons/triangle-filled-exclamation-monochrome.svg");
var _triangleFilledExclamationMonochromeSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationMonochromeSvg);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const CustomerReviewMeasureTitle = (props)=>{
    const { measure } = props;
    const statusIcon = measure.is_completed ? (0, _checkmarkCircleFilledSuccessDarkSvgDefault.default) : (0, _triangleFilledExclamationMonochromeSvgDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledKDKBanner, {
        status: measure.is_completed ? "success" : "warning",
        hideIcon: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            wrap: false,
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: statusIcon
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    breakWord: true,
                    children: measure.title
                })
            ]
        })
    });
};
const StyledKDKBanner = (0, _styledComponentsDefault.default)((0, _kdkbannerDefault.default))`
  & > .Polaris-Banner--withinContentContainer {
    padding: var(--p-space-1) var(--p-space-2) var(--p-space-05) var(--p-space-2);
  }
`;
exports.default = CustomerReviewMeasureTitle;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/checkmark-circle-filled-success-dark.svg":"7SReV","../../../assets/icons/triangle-filled-exclamation-monochrome.svg":"iabow","../extensions/Icon":"eHSf0","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7SReV":[function(require,module,exports) {
module.exports = require("f3c0877538c9078c").getBundleURL("kEMsi") + "checkmark-circle-filled-success-dark.27e24aa3.svg";

},{"f3c0877538c9078c":"75UoR"}],"iabow":[function(require,module,exports) {
module.exports = require("2cd7608b8a9f6982").getBundleURL("kEMsi") + "triangle-filled-exclamation-monochrome.0548a6ba.svg";

},{"2cd7608b8a9f6982":"75UoR"}],"926Yy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _textBubbleSvg = require("../../../assets/icons/text-bubble.svg");
var _textBubbleSvgDefault = parcelHelpers.interopDefault(_textBubbleSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const MeasureComment = (props)=>{
    const { measure } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if ((0, _stringUtils.isEmptyString)(measure.completed_comment)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                fontWeight: "semibold",
                children: f("details.reviews.measures.comment.label")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                blockAlign: "start",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _textBubbleSvgDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CommentText, {
                        children: measure.completed_comment
                    })
                ]
            })
        ]
    });
};
const CommentText = (0, _styledComponentsDefault.default).div`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
exports.default = MeasureComment;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/text-bubble.svg":"52FbG","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aCAsw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
const MeasuresContainer = (0, _styledComponentsDefault.default).div`
  display: flex;
  align-items: flex-start;
  gap: var(--p-space-4);

  & > :first-child {
    flex: 1;
  }

  & > :last-child {
    padding-top: var(--p-space-2);
  }

  & + & {
    margin-top: var(--p-space-4);
  }

  // hide move button in mobile view
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    & > :last-child {
      display: none;
    }
  }
`;
exports.default = MeasuresContainer;

},{"styled-components":"eBrdC","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dsvCr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _arrowDownSvg = require("../../../assets/icons/arrow-down.svg");
var _arrowDownSvgDefault = parcelHelpers.interopDefault(_arrowDownSvg);
var _arrowUpSvg = require("../../../assets/icons/arrow-up.svg");
var _arrowUpSvgDefault = parcelHelpers.interopDefault(_arrowUpSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const MoveButtons = (props)=>{
    const { disableMoveUp, disableMoveDown, readonly, onOrderChange, spacing = "tight", ...stackProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const moveUp = ()=>onOrderChange("up");
    const moveDown = ()=>onOrderChange("down");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        spacing: spacing,
        wrap: false,
        ...stackProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: f("common.buttons.move-up"),
                dismissOnMouseOut: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: moveUp,
                    disabled: disableMoveUp || readonly,
                    icon: (0, _arrowUpSvgDefault.default),
                    plain: true,
                    hoverable: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: f("common.buttons.move-down"),
                dismissOnMouseOut: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: moveDown,
                    disabled: disableMoveDown || readonly,
                    icon: (0, _arrowDownSvgDefault.default),
                    plain: true,
                    hoverable: true
                })
            })
        ]
    });
};
exports.default = MoveButtons;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/arrow-down.svg":"aYON8","../../../assets/icons/arrow-up.svg":"7MHWv","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aYON8":[function(require,module,exports) {
module.exports = require("e7a8181da4b4ecd3").getBundleURL("kEMsi") + "arrow-down.b3ca9e20.svg";

},{"e7a8181da4b4ecd3":"75UoR"}],"7MHWv":[function(require,module,exports) {
module.exports = require("6f73ed0b8f726ac8").getBundleURL("kEMsi") + "arrow-up.1c3097c7.svg";

},{"6f73ed0b8f726ac8":"75UoR"}],"57qmB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _removeMeasureConfirm = require("./RemoveMeasureConfirm");
var _removeMeasureConfirmDefault = parcelHelpers.interopDefault(_removeMeasureConfirm);
const CustomerReviewMeasureDeleteButton = (props)=>{
    const { customerId, reviewId, measure, readonly, onAfterRemove, ...buttonProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showRemoveConfirm, toggleRemoveConfirm, closeRemoveConfirm] = (0, _useOpenCloseDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                onClick: toggleRemoveConfirm,
                size: "slim",
                disabled: readonly,
                icon: (0, _trashSvgDefault.default),
                ...buttonProps,
                children: f("default.delete")
            }),
            showRemoveConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeMeasureConfirmDefault.default), {
                customerId: customerId,
                reviewId: reviewId,
                measure: measure,
                onNo: closeRemoveConfirm,
                onSuccess: ()=>onAfterRemove(measure)
            })
        ]
    });
};
exports.default = CustomerReviewMeasureDeleteButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../assets/icons/trash.svg":"jqW55","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","./RemoveMeasureConfirm":"5mGhm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5mGhm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const RemoveMeasureConfirm = (props)=>{
    const { customerId, reviewId, measure, ...confirmProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        title: f("details.reviews.measures.remove-confirmation.title"),
        description: f("details.reviews.measures.remove-confirmation.description", {
            name: measure.title
        }),
        actionTitle: f("default.delete"),
        apiCall: ()=>(0, _apiDefault.default).removeCustomerReviewMeasure(customerId, reviewId, measure.id),
        ...confirmProps
    });
};
exports.default = RemoveMeasureConfirm;

},{"react/jsx-runtime":"enbMA","../../api":"f6lXD","../../hooks/useFormatMessage":"8Y8fq","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2t00w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _measuresHelpers = require("../../helpers/measures.helpers");
var _completeMeasureForm = require("../CompleteMeasureForm/CompleteMeasureForm");
var _completeMeasureFormDefault = parcelHelpers.interopDefault(_completeMeasureForm);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const CustomerReviewMeasureForm = (props)=>{
    const { customerId, reviewId, measure, readonly, onChange, onCancel } = props;
    const saveMeasureMutation = (0, _reactQuery.useMutation)((measure)=>(0, _apiDefault.default).updateCustomerReviewMeasure(customerId, reviewId, measure.id, (0, _measuresHelpers.convertMeasureToUpdateCustomMeasureRequest)(measure)), {
        onSuccess: onChange
    });
    const save = (measure)=>saveMeasureMutation.mutate(measure);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completeMeasureFormDefault.default), {
                measure: measure,
                readonly: readonly,
                isLoading: saveMeasureMutation.isLoading,
                autoFocus: true,
                onSave: save,
                onCancel: onCancel
            }),
            saveMeasureMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: saveMeasureMutation.error
            })
        ]
    });
};
exports.default = CustomerReviewMeasureForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../helpers/measures.helpers":"4P5ib","../CompleteMeasureForm/CompleteMeasureForm":"lrJqR","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lrJqR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CompleteMeasureForm = (props)=>{
    const { measure, readonly, isLoading, autoFocus, onSave, onCancel } = props;
    const f = (0, _useFormatMessageDefault.default)();
    // mark measure that is edited for the first time as completed by default
    const isCompleted = measure.is_completed || !measure.updated_by && (0, _stringUtils.isEmptyString)(measure.completed_comment);
    const [workingMeasure, setWorkingMeasure, changed] = (0, _useChangedStateDefault.default)({
        ...measure,
        completed_comment: measure.completed_comment || "",
        is_completed: isCompleted
    });
    const handleMeasureChange = (field, value)=>setWorkingMeasure({
            ...workingMeasure,
            [field]: value
        });
    const save = ()=>onSave(workingMeasure);
    const cancel = ()=>onCancel({
            ...measure
        });
    const disabled = readonly || isLoading;
    const invalid = workingMeasure.is_completed && (0, _stringUtils.isEmptyString)(workingMeasure.completed_comment);
    const isSaveDisabled = readonly || invalid || !changed;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "semibold",
                        children: f("details.reviews.measures.form.description.label")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        label: f("details.reviews.measures.form.description.label"),
                        labelHidden: true,
                        placeholder: f("details.reviews.measures.form.description.placeholder"),
                        multiline: 4,
                        value: workingMeasure.completed_comment,
                        onChange: (value)=>handleMeasureChange("completed_comment", value),
                        autoComplete: "off",
                        autoFocus: autoFocus,
                        disabled: disabled
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                align: "space-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                fontWeight: "semibold",
                                children: f("details.reviews.measures.form.completed.label")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                label: f("default.yes"),
                                checked: workingMeasure.is_completed,
                                onChange: (value)=>handleMeasureChange("is_completed", value),
                                disabled: disabled
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        blockAlign: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: cancel,
                                size: "slim",
                                disabled: isLoading,
                                children: f("default.cancel")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: save,
                                size: "slim",
                                primary: true,
                                disabled: isSaveDisabled,
                                loading: isLoading,
                                children: f("default.save")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = CompleteMeasureForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useChangedState":"170jW","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bkFwe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _measuresHelpers = require("../../helpers/measures.helpers");
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _collectionUtils = require("../../utils/collectionUtils");
var _measureEditModal = require("../MeasureEditModal/MeasureEditModal");
var _measureEditModalDefault = parcelHelpers.interopDefault(_measureEditModal);
var _measurePopover = require("../MeasurePopover/MeasurePopover");
var _measurePopoverDefault = parcelHelpers.interopDefault(_measurePopover);
var _measuresHeader = require("./MeasuresHeader");
var _measuresHeaderDefault = parcelHelpers.interopDefault(_measuresHeader);
const CustomerReviewMeasuresHeader = (props)=>{
    const { customerId, reviewId, measures, readonly, onAfterAdd } = props;
    const [showEditMeasureModal, toggleEditMeasureModal, closeEditMeasureModal] = (0, _useOpenCloseDefault.default)();
    const addCustomerReviewMeasureMutation = (0, _reactQuery.useMutation)((measure)=>(0, _apiDefault.default).addCustomerReviewMeasure(customerId, reviewId, measure), {
        onSuccess: (newMeasure)=>{
            closeEditMeasureModal();
            onAfterAdd(newMeasure);
        }
    });
    const handleSelectionChange = (selectedMeasures)=>{
        const toggledMeasure = (0, _collectionUtils.difference)(selectedMeasures, measures)[0];
        if (toggledMeasure) addCustomerReviewMeasureMutation.mutate((0, _measuresHelpers.convertMeasureToCreateCustomMeasureRequest)(toggledMeasure));
    };
    const handleNewMeasure = ()=>toggleEditMeasureModal();
    const closeAndClear = ()=>{
        addCustomerReviewMeasureMutation.reset();
        closeEditMeasureModal();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _measuresHeaderDefault.default), {
        measures: measures,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measurePopoverDefault.default), {
                measures: measures,
                disabled: readonly,
                onChange: handleSelectionChange,
                onNewMeasure: handleNewMeasure,
                loading: addCustomerReviewMeasureMutation.isLoading
            }),
            showEditMeasureModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measureEditModalDefault.default), {
                measure: (0, _measuresHelpers.createNewMeasure)(),
                existingMeasures: measures,
                isNewMeasure: true,
                isLoading: addCustomerReviewMeasureMutation.isLoading,
                error: addCustomerReviewMeasureMutation.error,
                onSave: (measure)=>addCustomerReviewMeasureMutation.mutate((0, _measuresHelpers.convertMeasureToCreateCustomMeasureRequest)(measure)),
                onClose: closeAndClear
            })
        ]
    });
};
exports.default = CustomerReviewMeasuresHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../helpers/measures.helpers":"4P5ib","../../hooks/useOpenClose":"idooG","../../utils/collectionUtils":"gr5mc","../MeasureEditModal/MeasureEditModal":"748su","../MeasurePopover/MeasurePopover":"2GCSp","./MeasuresHeader":"jxkve","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"748su":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
function MeasureEditModal(props) {
    const { measure, existingMeasures, isNewMeasure, readonly, isLoading, error, onSave, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [currentMeasure, setCurrentMeasure] = (0, _react.useState)({
        ...measure
    });
    const handleUpdate = (value, property)=>{
        const updatedMeasure = {
            ...currentMeasure,
            [property]: value
        };
        setCurrentMeasure(updatedMeasure);
    };
    const saveMeasure = ()=>onSave({
            ...currentMeasure,
            title: currentMeasure.title.trim()
        });
    const disabled = readonly || isLoading;
    const modalTitle = disabled ? f("measures.modal.title.view") : isNewMeasure ? f("measures.modal.title.add") : f("measures.modal.title.update");
    const isDuplicateTitle = new Set(existingMeasures.map((measure)=>measure.id !== currentMeasure.id ? measure.title.toLowerCase() : "")).has(currentMeasure.title.trim().toLowerCase());
    // a measure title is invalid if it is empty or already exists in the unique Set of all other measures
    const isInvalidMeasure = (0, _stringUtils.isEmptyString)(currentMeasure.title.trim()) || (0, _stringUtils.isEmptyString)(currentMeasure.description.trim()) || isDuplicateTitle;
    const measureTitleError = (0, _stringUtils.isEmptyString)(currentMeasure.title) ? f("measures.modal.errors.title-validation-error") : isDuplicateTitle ? f("measures.modal.errors.title-not-unique-validation-error") : undefined;
    const saveAction = {
        content: isNewMeasure ? f("default.add") : f("default.save"),
        onAction: saveMeasure,
        disabled: isInvalidMeasure || disabled,
        loading: isLoading
    };
    const cancelAction = {
        content: readonly ? f("default.close") : f("default.cancel"),
        onAction: onClose,
        disabled: isLoading
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        title: modalTitle,
        onClose: onClose,
        primaryAction: saveAction,
        secondaryActions: [
            cancelAction
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.FormLayout).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                    autoFocus: true,
                                    label: f("common.labels.title"),
                                    value: currentMeasure.title,
                                    disabled: disabled,
                                    onChange: (value)=>handleUpdate(value, "title"),
                                    autoComplete: "off",
                                    error: measureTitleError
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.FormLayout).Group, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                    multiline: 4,
                                    label: f("common.labels.description"),
                                    value: currentMeasure.description,
                                    disabled: disabled,
                                    onChange: (value)=>handleUpdate(value, "description"),
                                    autoComplete: "off",
                                    error: (0, _stringUtils.isEmptyString)(currentMeasure.description) ? f("measures.modal.errors.description-validation-error") : undefined
                                })
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: error
                    })
                ]
            })
        })
    });
}
exports.default = MeasureEditModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../ErrorPanel/ErrorPanel":"2hHqH","../KDKTextField/KDKTextField":"b5QRp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2GCSp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _plusMajorSvg = require("../../../assets/icons/plus-major.svg");
var _plusMajorSvgDefault = parcelHelpers.interopDefault(_plusMajorSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../utils/collectionUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _popoverButton = require("../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _globalMeasuresList = require("./GlobalMeasuresList/GlobalMeasuresList");
var _globalMeasuresListDefault = parcelHelpers.interopDefault(_globalMeasuresList);
var _measurePopoverHelpers = require("./MeasurePopover.helpers");
const MeasurePopover = (props)=>{
    const { measures, allowCustomMeasure, onChange, onNewMeasure, ...popoverProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const handleNewMeasure = (onClose)=>{
        onClose();
        onNewMeasure();
    };
    const selectedGlobalMeasuresIds = measures.map((measure)=>measure.measure_config_id).filter(Boolean);
    const onSelectionChange = (selectedGlobalMeasures)=>{
        // selection changes only contain 1 change - either a global measure was selected or deselected
        // get the global measure id that was toggled (selected or deselected)
        const toggledGlobalMeasureId = (0, _collectionUtils.difference)(Object.keys(selectedGlobalMeasures), selectedGlobalMeasuresIds)[0];
        // search for the global measure in the given measure list - if found, then the global measure should be toggled
        // if the global measure was not found, then use the global measure selectedGlobalMeasures to toggle
        const toggledMeasure = measures.find((measure)=>measure.measure_config_id === toggledGlobalMeasureId);
        if (toggledMeasure) onChange((0, _collectionUtils.toggleElement)(measures, toggledMeasure));
        else {
            const newMeasure = (0, _measurePopoverHelpers.convertMeasureConfigToMeasure)(selectedGlobalMeasures[toggledGlobalMeasureId]);
            onChange((0, _collectionUtils.toggleElement)(measures, newMeasure));
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
        ...popoverProps,
        autofocusTarget: "none",
        label: f("measures.popover.labels.button"),
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _plusMajorSvgDefault.default),
            useMask: true,
            width: "12px",
            height: "12px"
        }),
        size: "slim",
        render: (onClose)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalMeasuresListDefault.default), {
                disabled: popoverProps.loading,
                selectedGlobalMeasuresIds: selectedGlobalMeasuresIds,
                onSelectionChange: onSelectionChange,
                children: allowCustomMeasure && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack), {
                    distribution: "fill",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: popoverProps.loading,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _plusMajorSvgDefault.default),
                            useMask: true,
                            width: "12px",
                            height: "12px"
                        }),
                        plain: true,
                        onClick: ()=>handleNewMeasure(onClose),
                        children: f("measures.popover.labels.new-empty-measure")
                    })
                })
            })
    });
};
exports.default = MeasurePopover;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/plus-major.svg":"fCy4K","../../hooks/useFormatMessage":"8Y8fq","../../utils/collectionUtils":"gr5mc","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../PopoverButton/PopoverButton":"ihB8F","./GlobalMeasuresList/GlobalMeasuresList":"5TgDU","./MeasurePopover.helpers":"7ibFi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5TgDU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _errorPanel = require("../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _popoverStickyWrapper = require("../../PopoverStickyWrapper/PopoverStickyWrapper");
var _popoverStickyWrapperDefault = parcelHelpers.interopDefault(_popoverStickyWrapper);
var _useGetMeasures = require("./useGetMeasures");
var _useGetMeasuresDefault = parcelHelpers.interopDefault(_useGetMeasures);
const GlobalMeasuresList = (props)=>{
    const { selectedGlobalMeasuresIds = [], disabled, onSelectionChange, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { data, isLoading, error } = (0, _useGetMeasuresDefault.default)();
    const globalMeasures = data?.measure_configs || [];
    const filterGlobalMeasure = (measure)=>!measure.is_archived || selectedGlobalMeasuresIds.includes(measure.id);
    const choices = (0, _react.useMemo)(()=>globalMeasures.filter(filterGlobalMeasure).map((measure)=>({
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: measure.title
                }),
                value: measure.id,
                disabled: selectedGlobalMeasuresIds.includes(measure.id)
            })), [
        globalMeasures,
        selectedGlobalMeasuresIds
    ]);
    const isEmpty = choices.length === 0;
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover).Section, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "2",
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                    size: "small"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: f("measures.list.loading.label")
                })
            ]
        })
    });
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: error,
        actionTitle: f("measures.list.loading.error-action")
    });
    const handleSelectionChange = (selectedGlobalMeasuresIds)=>// convert the selected ids to an object in which key = global measure id and value = global measure config
        // this is done in order to export the global measures configs outside this component
        onSelectionChange(Object.fromEntries(globalMeasures.filter((measure)=>selectedGlobalMeasuresIds.includes(measure.id)).map((measure)=>[
                measure.id,
                measure
            ])));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popoverStickyWrapperDefault.default), {
        filter: children,
        width: "40ch",
        height: isEmpty ? "8rem" : undefined,
        children: [
            !isEmpty && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: f("measures.popover.labels.global-list.title")
                }),
                allowMultiple: true,
                choices: choices,
                selected: selectedGlobalMeasuresIds,
                onChange: handleSelectionChange,
                disabled: disabled
            }),
            isEmpty && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                color: "subdued",
                children: f("measures.popover.labels.global-list.empty")
            })
        ]
    });
};
exports.default = GlobalMeasuresList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","../../ErrorPanel/ErrorPanel":"2hHqH","../../PopoverStickyWrapper/PopoverStickyWrapper":"8BYj1","./useGetMeasures":"5FfI6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5FfI6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../../constants/queries-keys");
// set the stale time to 1 hour to avoid multiple calls to listMeasures
const useGetMeasures = ()=>{
    return (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).MEASURES_SETTINGS
    ], (0, _apiDefault.default).getGlobalMeasureConfigs, {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
};
exports.default = useGetMeasures;

},{"@tanstack/react-query":"91Vyq","../../../api":"f6lXD","../../../constants/queries-keys":"6hYSF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7ibFi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertMeasureConfigToMeasure", ()=>convertMeasureConfigToMeasure);
var _measuresHelpers = require("../../helpers/measures.helpers");
const convertMeasureConfigToMeasure = ({ id, title, description })=>({
        ...(0, _measuresHelpers.createNewMeasure)(),
        title,
        description,
        measure_config_id: id
    });

},{"../../helpers/measures.helpers":"4P5ib","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jxkve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _statusBadge = require("../StatusBadge/StatusBadge");
var _statusBadgeDefault = parcelHelpers.interopDefault(_statusBadge);
const MeasuresHeader = (props)=>{
    const { measures, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const badgeStatus = measures.some((measure)=>!measure.is_completed) ? "warning" : "success";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        blockAlign: "center",
        align: "space-between",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                fontWeight: "bold",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "2",
                    blockAlign: "center",
                    children: [
                        f("details.reviews.measures.header"),
                        measures.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledStatusBadge, {
                            status: badgeStatus,
                            children: measures.length
                        })
                    ]
                })
            }),
            children
        ]
    });
};
const StyledStatusBadge = (0, _styledComponentsDefault.default)((0, _statusBadgeDefault.default))`
  & .Polaris-Badge {
    border-width: var(--p-border-width-1);
  }
`;
exports.default = MeasuresHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../StatusBadge/StatusBadge":"ddW4c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9nG5T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checkmarkGreenSvg = require("../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _circleCrossSvg = require("../../../assets/icons/circle-cross.svg");
var _circleCrossSvgDefault = parcelHelpers.interopDefault(_circleCrossSvg);
var _statusWaitingSvg = require("../../../assets/icons/status-waiting.svg");
var _statusWaitingSvgDefault = parcelHelpers.interopDefault(_statusWaitingSvg);
var _reviewsHelpers = require("../../helpers/reviews.helpers");
var _useCustomerReview = require("../../hooks/useCustomerReview");
var _useCustomerReviewDefault = parcelHelpers.interopDefault(_useCustomerReview);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../utils/util");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const CustomerReviewStatus = (props)=>{
    const { review } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { hasUncompletedPendingMeasures } = (0, _useCustomerReviewDefault.default)(review);
    const isPending = (0, _reviewsHelpers.isPendingReview)(review);
    const isReviewAcceptedOrRejected = !(0, _util.isNil)(review.accepted);
    const statusIcon = isPending ? (0, _statusWaitingSvgDefault.default) : review.accepted ? (0, _checkmarkGreenSvgDefault.default) : (0, _circleCrossSvgDefault.default);
    let statusLabel = undefined;
    if (review.accepted === true) statusLabel = review.assignment ? f("details.reviews.assignment-review.accepted") : f("details.reviews.customer-review.accepted");
    else if (review.accepted === false) statusLabel = review.assignment ? f("details.reviews.assignment-review.rejected") : f("details.reviews.customer-review.rejected");
    const subtitle = hasUncompletedPendingMeasures ? f("details.reviews.pending-measures") : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "baseline",
        children: [
            isReviewAcceptedOrRejected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: statusIcon,
                width: isPending ? "14px" : undefined,
                height: isPending ? "14px" : undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "semibold",
                        children: statusLabel
                    }),
                    subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledItalicWrapper, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            color: "subdued",
                            children: subtitle
                        })
                    })
                ]
            })
        ]
    });
};
const StyledItalicWrapper = (0, _styledComponentsDefault.default).span`
  font-style: italic;
`;
exports.default = CustomerReviewStatus;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/checkmark-green.svg":"8HW5l","../../../assets/icons/circle-cross.svg":"daUCT","../../../assets/icons/status-waiting.svg":"cOhJt","../../helpers/reviews.helpers":"1oYIN","../../hooks/useCustomerReview":"8Ciom","../../hooks/useFormatMessage":"8Y8fq","../../utils/util":"4MniK","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"daUCT":[function(require,module,exports) {
module.exports = require("7b990e6150088fc6").getBundleURL("kEMsi") + "circle-cross.17c73de5.svg";

},{"7b990e6150088fc6":"75UoR"}],"7p3dh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _calendarSvg = require("../../../assets/icons/calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _statusRejectedSvg = require("../../../assets/icons/status-rejected.svg");
var _statusRejectedSvgDefault = parcelHelpers.interopDefault(_statusRejectedSvg);
var _textBubbleSvg = require("../../../assets/icons/text-bubble.svg");
var _textBubbleSvgDefault = parcelHelpers.interopDefault(_textBubbleSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _userDisplayName = require("../UserDisplayName/UserDisplayName");
var _userDisplayNameDefault = parcelHelpers.interopDefault(_userDisplayName);
const ReviewCard = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { reviewStatus, reviewDate, reviewedBy, approvedBy, isRejected, additionalTitleContent, reviewHeader, reviewContent, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCard, {
        status: reviewStatus,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                        alignment: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                wrap: false,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _calendarSvgDefault.default)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                        date: reviewDate
                                    })
                                ]
                            }),
                            reviewedBy && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDisplayNameDefault.default), {
                                user: reviewedBy,
                                fontWeight: "regular",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    children: f("details.reviews.reviewed-by")
                                })
                            }),
                            approvedBy && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                blockAlign: "center",
                                wrap: false,
                                children: [
                                    isRejected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _statusRejectedSvgDefault.default),
                                        width: "16px",
                                        height: "16px"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDisplayNameDefault.default), {
                                        user: approvedBy,
                                        fontWeight: isRejected ? "bold" : "regular",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            as: "span",
                                            fontWeight: isRejected ? "bold" : undefined,
                                            children: reviewStatus === "success" ? f("details.reviews.confirmed-by") : f("details.reviews.rejected-by")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                fill: true,
                                children: additionalTitleContent
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: reviewHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledReviewHeader, {
                        disabled: isRejected,
                        children: reviewHeader
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                wrap: false,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _textBubbleSvgDefault.default)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        fontWeight: "semibold",
                                        children: f("reviews.labels.review-label")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledItalicWrapper, {
                                children: reviewContent
                            })
                        ]
                    })
                }),
                (0, _reactDefault.default).Children.toArray(children).filter((0, _reactDefault.default).isValidElement).map((child, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: child
                    }, index))
            ]
        })
    });
});
// add separator lines between all stack items that are not the first or the last
const StyledReviewHeader = (0, _styledComponentsDefault.default).div`
  & > .Polaris-HorizontalStack > * + * {
    padding-left: var(--p-space-6);
    border-left: thin solid var(--p-border-subdued);
  }
  filter: grayscale(${({ disabled })=>disabled ? 1 : 0});
`;
// apply Polaris status colors based on status value
const StyledCard = (0, _styledComponentsDefault.default).div`
  & > .Polaris-Card {
    box-shadow: none;
    border: solid var(--p-border-width-1) var(--p-border-subdued);
    border-radius: var(--p-border-radius-1);

    ${({ status })=>status && `
      background-color: var(--p-surface-${status}-subdued);
      border: solid var(--p-border-width-1) var(--p-border-${status}-subdued);
      --p-divider: var(--p-surface-${status});

    .Polaris-Card__Section + .Polaris-Card__Section {
      border-top-color: var(--p-border-${status}-subdued);
    }
    `}
  }

  .Polaris-Card__Section:empty {
    display: none;
  }
`;
const StyledItalicWrapper = (0, _styledComponentsDefault.default).span`
  font-style: italic;
  white-space: pre-wrap;
`;
exports.default = ReviewCard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/calendar.svg":"kKBe6","../../../assets/icons/status-rejected.svg":"4MfO9","../../../assets/icons/text-bubble.svg":"52FbG","../../hooks/useFormatMessage":"8Y8fq","../CustomDate/CustomDate":"5KD00","../extensions/Icon":"eHSf0","../UserDisplayName/UserDisplayName":"5vtSH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4MfO9":[function(require,module,exports) {
module.exports = require("87f62221a65e31a3").getBundleURL("kEMsi") + "status-rejected.fe7f7c23.svg";

},{"87f62221a65e31a3":"75UoR"}],"5vtSH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
const UserDisplayName = (props)=>{
    const { user, children, ...textProps } = props;
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    if (!user) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                fontWeight: "semibold",
                ...textProps,
                children: getUserDisplayName(user)
            })
        ]
    });
};
exports.default = UserDisplayName;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useGetUserName":"edBne","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bfJQ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
const ReviewChecklistAnswers = (props)=>{
    const { checklistAnswers } = props;
    if (!checklistAnswers) return null;
    const answers = checklistAnswers?.flatMap((checklistAnswer)=>checklistAnswer.answers.map((answer)=>answer.additional_info)).filter(Boolean);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List), {
        type: "bullet",
        spacing: "extraTight",
        children: answers.map((answer, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                children: answer
            }, index))
    });
};
exports.default = ReviewChecklistAnswers;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dTCCI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _customerReviewsList = require("../CustomerReviewsList/CustomerReviewsList");
var _customerReviewsListDefault = parcelHelpers.interopDefault(_customerReviewsList);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CustomerReviewsListWithFilter = (props)=>{
    const { reviews, ...customerReviewsListProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    // toggle between showing all reviews or only the first review
    const [showAllReviews, toggleShowAllReviews] = (0, _useOpenCloseDefault.default)();
    const showToggleButton = reviews.length > 1;
    const reviewsToDisplay = showAllReviews || reviews.length === 0 ? reviews : [
        reviews[0]
    ];
    const toggleReviewLabel = showAllReviews ? f("reviews.labels.toggle.hide-previous", {
        count: reviews.length - 1
    }) : f("reviews.labels.toggle.show-previous", {
        count: reviews.length - 1
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewsListDefault.default), {
                reviews: reviewsToDisplay,
                ...customerReviewsListProps
            }),
            showToggleButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: toggleShowAllReviews,
                    disclosure: showAllReviews ? "up" : "down",
                    children: toggleReviewLabel
                })
            })
        ]
    });
};
exports.default = CustomerReviewsListWithFilter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../CustomerReviewsList/CustomerReviewsList":"5UAug","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bvVIR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useCustomerReviewBanner = require("../../hooks/useCustomerReviewBanner");
var _useCustomerReviewBannerDefault = parcelHelpers.interopDefault(_useCustomerReviewBanner);
var _pendingDisclosuresBanner = require("../PendingDisclosuresBanner/PendingDisclosuresBanner");
var _pendingDisclosuresBannerDefault = parcelHelpers.interopDefault(_pendingDisclosuresBanner);
var _unreviewedMatchCasesBanner = require("../UnreviewedMatchCasesBanner/UnreviewedMatchCasesBanner");
var _unreviewedMatchCasesBannerDefault = parcelHelpers.interopDefault(_unreviewedMatchCasesBanner);
var _emptyReviewsBanner = require("./EmptyReviewsBanner");
var _emptyReviewsBannerDefault = parcelHelpers.interopDefault(_emptyReviewsBanner);
const CustomerReviewsSectionBanner = (props)=>{
    const { customer, readonly } = props;
    const { hasUnresolvedMatchCases, hasPendingDisclosures, unresolvedCaseCount, pendingDisclosuresCount, isNewCustomerReviewDisabled, navigateToMatchesSection, navigateToDisclosuresSection } = (0, _useCustomerReviewBannerDefault.default)(customer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            hasUnresolvedMatchCases && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unreviewedMatchCasesBannerDefault.default), {
                unresolvedCaseCount: unresolvedCaseCount,
                onNavigateToMatchesSection: navigateToMatchesSection
            }),
            hasPendingDisclosures && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendingDisclosuresBannerDefault.default), {
                pendingDisclosuresCount: pendingDisclosuresCount,
                onNavigateToDisclosuresSection: navigateToDisclosuresSection
            }),
            customer.reviews.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyReviewsBannerDefault.default), {
                customer: customer,
                readonly: readonly || isNewCustomerReviewDisabled
            })
        ]
    });
};
exports.default = CustomerReviewsSectionBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useCustomerReviewBanner":"1BJZA","../PendingDisclosuresBanner/PendingDisclosuresBanner":"a2nLX","../UnreviewedMatchCasesBanner/UnreviewedMatchCasesBanner":"daktN","./EmptyReviewsBanner":"2ibmI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a2nLX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const PendingDisclosuresBanner = (props)=>{
    const { pendingDisclosuresCount, onNavigateToDisclosuresSection } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "info",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
            alignment: "center",
            distribution: "equalSpacing",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: f("reviews.header.banner.pending-disclosures.description", {
                        count: pendingDisclosuresCount
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    plain: true,
                    onClick: onNavigateToDisclosuresSection,
                    children: f("reviews.header.banner.pending-disclosures.button.label", {
                        count: pendingDisclosuresCount
                    })
                })
            ]
        })
    });
};
exports.default = PendingDisclosuresBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"daktN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const UnreviewedMatchCasesBanner = (props)=>{
    const { unresolvedCaseCount, onNavigateToMatchesSection } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "info",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            blockAlign: "center",
            align: "space-between",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: f("reviews.header.banner.unreviewed-match-cases.description", {
                        count: unresolvedCaseCount
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    plain: true,
                    onClick: onNavigateToMatchesSection,
                    children: f("reviews.header.banner.unreviewed-match-cases.button.label", {
                        count: unresolvedCaseCount
                    })
                })
            ]
        })
    });
};
exports.default = UnreviewedMatchCasesBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2ibmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _newCustomerReviewButton = require("../NewCustomerReviewButton/NewCustomerReviewButton");
var _newCustomerReviewButtonDefault = parcelHelpers.interopDefault(_newCustomerReviewButton);
const EmptyReviewsBanner = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            inlineAlign: "center",
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: f("reviews.labels.no-reviews")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newCustomerReviewButtonDefault.default), {
                    customer: customer,
                    disabled: readonly,
                    children: f("reviews.labels.perform-a-review")
                })
            ]
        })
    });
};
exports.default = EmptyReviewsBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../NewCustomerReviewButton/NewCustomerReviewButton":"ajsqh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ajsqh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
const NewCustomerReviewButton = (props)=>{
    const { customer, ...buttonProps } = props;
    const url = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMER_REVIEW_NEW, {
        customerId: customer.id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
        url: url,
        ...buttonProps
    });
};
exports.default = NewCustomerReviewButton;

},{"react/jsx-runtime":"enbMA","react-router-dom":"1ee65","../../constants/routes":"ihtm8","../AddButton/AddButton":"WJGEt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lj8DC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
function DetailsSkeleton() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                    lines: 2
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 6
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 2
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 6
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 6
                        })
                    })
                })
            ]
        })
    });
}
exports.default = DetailsSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"434BH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _disclosureDocumentSignatureHeaders = require("../DisclosureDocumentSignatureHeaders/DisclosureDocumentSignatureHeaders");
var _disclosureDocumentSignatureHeadersDefault = parcelHelpers.interopDefault(_disclosureDocumentSignatureHeaders);
var _hideOnMobile = require("../HideOnMobile/HideOnMobile");
var _hideOnMobileDefault = parcelHelpers.interopDefault(_hideOnMobile);
var _disclosureDocumentSignature = require("./DisclosureDocumentSignature/DisclosureDocumentSignature");
var _disclosureDocumentSignatureDefault = parcelHelpers.interopDefault(_disclosureDocumentSignature);
var _disclosureDocumentSectionHelpers = require("./DisclosureDocumentSection.helpers");
const DisclosureDocumentSection = (props)=>{
    const { customerId, assignmentId, customerType, disclosureDocuments, readonly, addButtonLabel, emptyLabel, assignments } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const disclosureDocumentSignatures = disclosureDocuments.map((disclosureDocument)=>{
        // Get all emails used in document
        // -> emails should be unique for each document
        const existingEmails = disclosureDocument.signatures.map((s)=>s.email).filter((email)=>email !== undefined);
        return disclosureDocument.signatures.map((disclosureDocumentSignature)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureDocumentSignatureDefault.default), {
                customerId: customerId,
                customerType: customerType,
                signature: disclosureDocumentSignature,
                existingEmails: existingEmails,
                createdTimestamp: disclosureDocument.created_dt,
                readonly: readonly,
                assignments: assignments
            }, disclosureDocumentSignature.id));
    }).flat();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                align: "space-between",
                blockAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "headingMd",
                        as: "h2",
                        children: f("disclosure-documents.title")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                        url: (0, _disclosureDocumentSectionHelpers.createDisclosurePagePath)(customerId, customerType, assignmentId),
                        disabled: readonly,
                        children: addButtonLabel
                    })
                ]
            }),
            disclosureDocumentSignatures.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hideOnMobileDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureDocumentSignatureHeadersDefault.default), {})
            }),
            disclosureDocumentSignatures,
            disclosureDocumentSignatures.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: emptyLabel
            })
        ]
    });
};
exports.default = DisclosureDocumentSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../AddButton/AddButton":"WJGEt","../DisclosureDocumentSignatureHeaders/DisclosureDocumentSignatureHeaders":"hh7yh","../HideOnMobile/HideOnMobile":"fcHQN","./DisclosureDocumentSignature/DisclosureDocumentSignature":"75ljd","./DisclosureDocumentSection.helpers":"4EbjL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hh7yh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const DisclosureDocumentSignatureHeaders = (props)=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledHeaders, {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Grid), {
            columns: {
                xs: 1,
                md: 3,
                lg: 5
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    variant: "bodySm",
                    fontWeight: "semibold",
                    children: f("disclosure-card.status-tile")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    variant: "bodySm",
                    fontWeight: "semibold",
                    children: f("disclosure-card.recipient-tile")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    variant: "bodySm",
                    fontWeight: "semibold",
                    children: f("disclosure-card.scope-tile")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    variant: "bodySm",
                    fontWeight: "semibold",
                    children: f("disclosure-card.content-language")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    variant: "bodySm",
                    fontWeight: "semibold",
                    children: f("disclosure-card.date-tile")
                })
            ]
        })
    });
};
const StyledHeaders = (0, _styledComponentsDefault.default).div`
  padding: 0 var(--p-space-4);
`;
exports.default = DisclosureDocumentSignatureHeaders;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"75ljd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _calendarSvg = require("../../../../assets/icons/calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _docTextSvg = require("../../../../assets/icons/doc-text.svg");
var _docTextSvgDefault = parcelHelpers.interopDefault(_docTextSvg);
var _identitySvg = require("../../../../assets/icons/identity.svg");
var _identitySvgDefault = parcelHelpers.interopDefault(_identitySvg);
var _disclosuresHelpers = require("../../../helpers/disclosures.helpers");
var _displayHelpers = require("../../../helpers/display.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetDisclosureCountryRiskInformation = require("../../../hooks/useGetDisclosureCountryRiskInformation");
var _useGetDisclosureCountryRiskInformationDefault = parcelHelpers.interopDefault(_useGetDisclosureCountryRiskInformation);
var _useQueryData = require("../../../hooks/useQueryData");
var _customDate = require("../../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _displayName = require("../../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _flatCard = require("../../FlatCard/FlatCard");
var _flatCardDefault = parcelHelpers.interopDefault(_flatCard);
var _language = require("../../Language/Language");
var _languageDefault = parcelHelpers.interopDefault(_language);
var _position = require("../../Position/Position");
var _positionDefault = parcelHelpers.interopDefault(_position);
var _questionnaireDisplayName = require("../../QuestionnaireDisplayName/QuestionnaireDisplayName");
var _questionnaireDisplayNameDefault = parcelHelpers.interopDefault(_questionnaireDisplayName);
var _roleType = require("../../RoleType/RoleType");
var _roleTypeDefault = parcelHelpers.interopDefault(_roleType);
var _sectionTile = require("../../SectionTile/SectionTile");
var _sectionTileDefault = parcelHelpers.interopDefault(_sectionTile);
var _warningBadge = require("../../WarningBadge/WarningBadge");
var _warningBadgeDefault = parcelHelpers.interopDefault(_warningBadge);
var _signatureActions = require("./SignatureActions/SignatureActions");
var _signatureActionsDefault = parcelHelpers.interopDefault(_signatureActions);
var _completedDisclosureDocumentSignature = require("./CompletedDisclosureDocumentSignature");
var _completedDisclosureDocumentSignatureDefault = parcelHelpers.interopDefault(_completedDisclosureDocumentSignature);
var _disclosureStatus = require("./DisclosureStatus");
var _disclosureStatusDefault = parcelHelpers.interopDefault(_disclosureStatus);
var _expiredDisclosureDocumentSignatureBanner = require("./ExpiredDisclosureDocumentSignatureBanner");
var _expiredDisclosureDocumentSignatureBannerDefault = parcelHelpers.interopDefault(_expiredDisclosureDocumentSignatureBanner);
var _pendingDisclosureDocumentSignature = require("./PendingDisclosureDocumentSignature");
var _pendingDisclosureDocumentSignatureDefault = parcelHelpers.interopDefault(_pendingDisclosureDocumentSignature);
const DisclosureDocumentSignature = (props)=>{
    const { customerId, customerType, signature: initialSignature, createdTimestamp, existingEmails, readonly, assignments } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getSignatureRiskAnswersCount } = (0, _useGetDisclosureCountryRiskInformationDefault.default)();
    const [signature, setSignature] = (0, _react.useState)(initialSignature);
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)({
        id: customerId,
        type: customerType
    });
    const onSignatureDeleted = (deletedSignature)=>{
        updateQueryData((queryData)=>{
            queryData.disclosure_documents = queryData.disclosure_documents.map((disclosureDocument)=>({
                    ...disclosureDocument,
                    signatures: disclosureDocument.signatures.filter((signature)=>signature.id !== deletedSignature.id)
                }));
        });
    };
    const isSignatureComplete = signature.status === "SIGNED";
    const isSignatureExpired = signature.status === "EXPIRED";
    const signatureRiskAnswersCount = getSignatureRiskAnswersCount(signature);
    const haveHighRiskAnswers = isSignatureComplete && signatureRiskAnswersCount > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFlatCard, {
        footer: isSignatureComplete ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completedDisclosureDocumentSignatureDefault.default), {
            signature: signature
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendingDisclosureDocumentSignatureDefault.default), {
            signature: signature
        }),
        footerBorder: true,
        success: isSignatureComplete,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Grid), {
                    columns: {
                        xs: 1,
                        md: 3,
                        lg: 5
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                            title: f("disclosure-card.status-tile"),
                            gap: "1",
                            mobileOnly: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureStatusDefault.default), {
                                signature: signature
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                            title: f("disclosure-card.recipient-tile"),
                            gap: "1",
                            mobileOnly: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                                type: "person",
                                name: (0, _displayHelpers.getFullName)(signature.person),
                                birthDate: (0, _displayHelpers.getBirthDate)(signature.person),
                                wrap: true,
                                strong: true,
                                subtitle: initialSignature.role?.type ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _positionDefault.default), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleTypeDefault.default), {
                                        role: initialSignature.role
                                    })
                                }) : undefined
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                            gap: "6",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sectionTileDefault.default), {
                                title: f("disclosure-card.scope-tile"),
                                gap: "1",
                                mobileOnly: true,
                                children: [
                                    signature.use_verification && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "1",
                                        wrap: false,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                source: (0, _identitySvgDefault.default),
                                                width: "25px",
                                                height: "18px"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                truncate: true,
                                                children: f("disclosure-request.field.use_verification")
                                            })
                                        ]
                                    }),
                                    (0, _disclosuresHelpers.isKYCSelected)(signature) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "1",
                                        wrap: false,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                source: (0, _docTextSvgDefault.default)
                                            }),
                                            signature.use_standard_disclosure && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                truncate: true,
                                                children: f("disclosure-request.field.use_standard_disclosure")
                                            }),
                                            signature.use_pep_disclosure && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                truncate: true,
                                                children: f("disclosure-request.field.use_pep_disclosure")
                                            })
                                        ]
                                    }),
                                    signature.questionnaire_ids?.map((questionnaireId)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnaireDisplayNameDefault.default), {
                                            questionnaireId: questionnaireId
                                        }, questionnaireId))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                            title: f("disclosure-card.content-language"),
                            gap: "1",
                            mobileOnly: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageDefault.default), {
                                    language: signature.language
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                            title: f("disclosure-card.date-tile"),
                            gap: "1",
                            mobileOnly: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                align: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "1",
                                        blockAlign: "center",
                                        wrap: false,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                source: (0, _calendarSvgDefault.default)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                                date: createdTimestamp
                                            })
                                        ]
                                    }),
                                    !isSignatureComplete && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signatureActionsDefault.default), {
                                        customerId: customerId,
                                        customerType: customerType,
                                        signature: signature,
                                        existingEmails: existingEmails,
                                        readonly: readonly,
                                        assignments: assignments,
                                        onSignatureUpdated: setSignature,
                                        onSignatureDeleted: onSignatureDeleted
                                    })
                                ]
                            })
                        })
                    ]
                }),
                haveHighRiskAnswers && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningBadgeDefault.default), {
                    children: f("disclosure-status.warning", {
                        count: signatureRiskAnswersCount
                    })
                }),
                isSignatureExpired && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expiredDisclosureDocumentSignatureBannerDefault.default), {})
            ]
        })
    });
};
const StyledFlatCard = (0, _styledComponentsDefault.default)((0, _flatCardDefault.default))`
  border-color: ${({ success })=>success ? "var(--p-border-success-subdued)" : undefined};

  ${(0, _flatCard.StyledFlatCardFooter)} {
    border-color: ${({ success })=>success ? "var(--p-border-success-subdued)" : undefined};
    background-color: ${({ success })=>success ? "var(--p-surface-success-subdued)" : undefined};
  }
`;
exports.default = DisclosureDocumentSignature;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/calendar.svg":"kKBe6","../../../../assets/icons/doc-text.svg":"leosj","../../../../assets/icons/identity.svg":"aFw6Y","../../../helpers/disclosures.helpers":"6yWoC","../../../helpers/display.helpers":"2q3xY","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useGetDisclosureCountryRiskInformation":"isCim","../../../hooks/useQueryData":"4laI9","../../CustomDate/CustomDate":"5KD00","../../DisplayName/DisplayName":"gKd5g","../../extensions/Icon":"eHSf0","../../FlatCard/FlatCard":"dh1eC","../../Language/Language":"h9jd4","../../Position/Position":"kTPkn","../../QuestionnaireDisplayName/QuestionnaireDisplayName":"6wW4B","../../RoleType/RoleType":"eHoEr","../../SectionTile/SectionTile":"9KSoL","../../WarningBadge/WarningBadge":"28RLb","./SignatureActions/SignatureActions":"kKPjn","./CompletedDisclosureDocumentSignature":"bEgSk","./DisclosureStatus":"cOB61","./ExpiredDisclosureDocumentSignatureBanner":"5Wi3H","./PendingDisclosureDocumentSignature":"jJefj","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"leosj":[function(require,module,exports) {
module.exports = require("f28f5d0c1921ddaf").getBundleURL("kEMsi") + "doc-text.0848006a.svg";

},{"f28f5d0c1921ddaf":"75UoR"}],"aFw6Y":[function(require,module,exports) {
module.exports = require("e1ec593ac24309aa").getBundleURL("kEMsi") + "identity.98bce255.svg";

},{"e1ec593ac24309aa":"75UoR"}],"isCim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _disclosuresHelpers = require("../helpers/disclosures.helpers");
var _ownersHelpers = require("../helpers/owners.helpers");
var _personHelpers = require("../helpers/person.helpers");
var _riskHelpers = require("../helpers/risk.helpers");
var _utilities = require("../types/utilities");
var _collectionUtils = require("../utils/collectionUtils");
var _useCountries = require("./useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useTranslatedText = require("./useTranslatedText");
var _useTranslatedTextDefault = parcelHelpers.interopDefault(_useTranslatedText);
const useGetDisclosureCountryRiskInformation = ()=>{
    const { isHighRiskCountry } = (0, _useCountriesDefault.default)();
    const t = (0, _useTranslatedTextDefault.default)();
    const getDisclosuresCountryRiskInformation = (customer)=>{
        const countriesRiskInformation = [];
        (0, _disclosuresHelpers.traverseSignedSignatures)(customer, (signature)=>{
            signature.disclosure_answers?.sections.flatMap((section)=>section.answers).forEach((answer)=>{
                answer.risk_indicators?.forEach((riskIndicator)=>{
                    if ((0, _riskHelpers.isGeographicalRiskIndicator)(riskIndicator.type) && (0, _collectionUtils.hasContent)(riskIndicator.country_codes)) countriesRiskInformation.push({
                        signature,
                        fields: new Map([
                            [
                                t(answer.question.text),
                                riskIndicator.country_codes
                            ]
                        ])
                    });
                });
            });
        });
        return countriesRiskInformation;
    };
    const getPersonCountryRiskInformation = (countriesMap)=>{
        const highRiskCountryFieldMap = new Map([
            ...countriesMap.entries()
        ].filter(([, countries])=>[
                countries
            ].flat().filter(isHighRiskCountry).length > 0));
        return {
            fields: highRiskCountryFieldMap,
            customerType: "person"
        };
    };
    const getPersonCustomerCountriesRiskInformation = (person)=>{
        const disclosuresRiskInformation = getDisclosuresCountryRiskInformation(person);
        const personRiskInformation = getPersonCountryRiskInformation((0, _personHelpers.getPersonCountries)(person));
        personRiskInformation.person = person;
        if (personRiskInformation.fields.size > 0) return [
            ...disclosuresRiskInformation,
            personRiskInformation
        ];
        else return disclosuresRiskInformation;
    };
    const getCompanyCountryRiskInformation = (company)=>{
        const disclosuresRiskInformation = getDisclosuresCountryRiskInformation(company);
        const countriesRiskInformation = [];
        const companyCountryRiskInformation = {
            fields: new Map(),
            name: company.name,
            customerType: "company"
        };
        if (isHighRiskCountry(company.country)) companyCountryRiskInformation.fields.set("COUNTRY", company.country);
        if (isHighRiskCountry(company.address?.country)) companyCountryRiskInformation.fields.set("ADDRESS", company.address.country);
        if (isHighRiskCountry(company.business_address?.country)) companyCountryRiskInformation.fields.set("BUSINESS_ADDRESS", company.business_address.country);
        if (isHighRiskCountry(company.office_address?.country)) companyCountryRiskInformation.fields.set("OFFICE_ADDRESS", company.office_address.country);
        if (companyCountryRiskInformation.fields.size > 0) countriesRiskInformation.push(companyCountryRiskInformation);
        company.roles.forEach((role)=>{
            const roleCountryRiskInformation = getPersonCountryRiskInformation((0, _personHelpers.getPersonCountries)(role.person));
            if (roleCountryRiskInformation.fields.size > 0) countriesRiskInformation.push({
                ...roleCountryRiskInformation,
                person: role.person,
                role
            });
        });
        company.beneficial_owners.forEach((owner)=>{
            const ownerCountryRiskInformation = getPersonCountryRiskInformation((0, _ownersHelpers.getOwnerCountries)(owner));
            if (ownerCountryRiskInformation.fields.size > 0) countriesRiskInformation.push({
                ...ownerCountryRiskInformation,
                person: owner.person,
                owner
            });
        });
        return [
            ...disclosuresRiskInformation,
            ...countriesRiskInformation
        ];
    };
    const getCustomerCountryRiskInformation = (customer)=>{
        return (0, _utilities.isPersonCustomerDetails)(customer) ? getPersonCustomerCountriesRiskInformation(customer) : getCompanyCountryRiskInformation(customer);
    };
    const getSignatureRiskAnswersCount = (signature)=>{
        if (!signature.disclosure_answers) return 0;
        return signature.disclosure_answers.sections.flatMap((section)=>section.answers)// count the number answers with one or more risk indicators
        .reduce((result, answer)=>result + ((0, _collectionUtils.hasContent)(answer.risk_indicators) ? 1 : 0), 0);
    };
    return {
        getCustomerCountryRiskInformation,
        getSignatureRiskAnswersCount
    };
};
exports.default = useGetDisclosureCountryRiskInformation;

},{"../helpers/disclosures.helpers":"6yWoC","../helpers/owners.helpers":"lynDH","../helpers/person.helpers":"6qOIE","../helpers/risk.helpers":"1qPrk","../types/utilities":"6zLpB","../utils/collectionUtils":"gr5mc","./useCountries":"azDTp","./useTranslatedText":"lODeq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h9jd4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _languages = require("../../constants/languages");
var _useGetLanguageName = require("../../hooks/useGetLanguageName");
var _useGetLanguageNameDefault = parcelHelpers.interopDefault(_useGetLanguageName);
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
const Language = (props)=>{
    const { language } = props;
    const getLanguageName = (0, _useGetLanguageNameDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
        country: language ? (0, _languages.LANGUAGES_TO_COUNTRY_CODES)[language] : undefined,
        hideLabel: true,
        children: getLanguageName(language)
    });
};
exports.default = Language;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../constants/languages":"ecnY7","../../hooks/useGetLanguageName":"cbuaO","../Country/Country":"eeWSc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cbuaO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useGetLanguageName = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const getLanguageName = (language)=>{
        switch(language){
            case "en":
                return f("common.language.english");
            case "nb":
                return f("common.language.norwegian");
            default:
                return "-";
        }
    };
    return getLanguageName;
};
exports.default = useGetLanguageName;

},{"./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6wW4B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _docTextSvg = require("../../../assets/icons/doc-text.svg");
var _docTextSvgDefault = parcelHelpers.interopDefault(_docTextSvg);
var _infoBlueSvg = require("../../../assets/icons/info-blue.svg");
var _infoBlueSvgDefault = parcelHelpers.interopDefault(_infoBlueSvg);
var _useGetQuestionnairesSummary = require("../../hooks/useGetQuestionnairesSummary");
var _useGetQuestionnairesSummaryDefault = parcelHelpers.interopDefault(_useGetQuestionnairesSummary);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const QuestionnaireDisplayName = (props)=>{
    const { questionnaireId, questionnaire: questionnaireName, ...rest } = props;
    const { questionnairesSummary, isLoading } = (0, _useGetQuestionnairesSummaryDefault.default)();
    if (!questionnaireId && !questionnaireName) return null;
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
        size: "small"
    });
    const questionnaire = questionnaireName || questionnairesSummary.find((questionnaire)=>questionnaire.id === questionnaireId);
    if (!questionnaire) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledWrapper, {
        title: questionnaire.name,
        ...rest,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _docTextSvgDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Truncate), {
                children: questionnaire.name
            }),
            questionnaire.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: questionnaire.description,
                dismissOnMouseOut: true,
                preferredPosition: "above",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _infoBlueSvgDefault.default),
                    width: "17px",
                    height: "16px"
                })
            })
        ]
    });
};
const StyledWrapper = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--p-space-1);
`;
exports.default = QuestionnaireDisplayName;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/doc-text.svg":"leosj","../../../assets/icons/info-blue.svg":"kCjLz","../../hooks/useGetQuestionnairesSummary":"3Fs8h","../extensions/Icon":"eHSf0","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3Fs8h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _collectionUtils = require("../utils/collectionUtils");
// set the stale time to 1 hour to avoid multiple calls to listQuestionnaireNames
const useGetQuestionnairesSummary = (customerType)=>{
    const query = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES_SUMMARY
    ], (0, _apiDefault.default).getQuestionnairesSummary, {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    const filterQuestionnaire = ({ customer_type, is_archived })=>!is_archived && (customerType ? customer_type === "both" || customer_type === customerType : true);
    const questionnairesSummary = query.data?.questionnaire_summaries ? query.data.questionnaire_summaries.filter(filterQuestionnaire).sort((0, _collectionUtils.sortByName)) : [];
    const questionnairesSummaryByIdMap = (0, _react.useMemo)(()=>Object.fromEntries(questionnairesSummary.map((questionnaireSummary)=>[
                questionnaireSummary.id,
                questionnaireSummary
            ])), [
        questionnairesSummary
    ]);
    return {
        ...query,
        questionnairesSummary,
        questionnairesSummaryByIdMap
    };
};
exports.default = useGetQuestionnairesSummary;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9KSoL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _showOnMobile = require("../ShowOnMobile/ShowOnMobile");
var _showOnMobileDefault = parcelHelpers.interopDefault(_showOnMobile);
const SectionTile = (props)=>{
    const { title, children, mobileOnly, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        ...rest,
        children: [
            mobileOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _showOnMobileDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSubheading, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "headingXs",
                        as: "h3",
                        color: "subdued",
                        children: title
                    })
                })
            }),
            !mobileOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSubheading, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "headingXs",
                    as: "h3",
                    color: "subdued",
                    children: title
                })
            }),
            children
        ]
    });
};
const StyledSubheading = (0, _styledComponentsDefault.default).span`
  white-space: break-spaces;
`;
exports.default = SectionTile;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../ShowOnMobile/ShowOnMobile":"fzlW0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"28RLb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _triangleFilledExclamationMonochromeSvg = require("../../../assets/icons/triangle-filled-exclamation-monochrome.svg");
var _triangleFilledExclamationMonochromeSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationMonochromeSvg);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const WarningBadge = (props)=>{
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBadge, {
        status: "warning",
        size: "small",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            blockAlign: "center",
            wrap: false,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _triangleFilledExclamationMonochromeSvgDefault.default),
                    useMask: true,
                    width: "16px",
                    height: "16px"
                }),
                children
            ]
        })
    });
};
const StyledBadge = (0, _styledComponentsDefault.default)((0, _badgeDefault.default))`
  & > .Polaris-Badge {
    border-radius: var(--p-border-radius-1);
  }
`;
exports.default = WarningBadge;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/triangle-filled-exclamation-monochrome.svg":"iabow","../extensions/Badge":"9irVp","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kKPjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _linkSvg = require("../../../../../assets/icons/link.svg");
var _linkSvgDefault = parcelHelpers.interopDefault(_linkSvg);
var _pencilSvg = require("../../../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _remindSvg = require("../../../../../assets/icons/remind.svg");
var _remindSvgDefault = parcelHelpers.interopDefault(_remindSvg);
var _trashSvg = require("../../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _displayHelpers = require("../../../../helpers/display.helpers");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSnackbar = require("../../../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _util = require("../../../../utils/util");
var _actionsDropdown = require("../../../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _copyLinkModal = require("../../../CopyLinkModal/CopyLinkModal");
var _copyLinkModalDefault = parcelHelpers.interopDefault(_copyLinkModal);
var _remindSignerModal = require("../../../RemindSignerModal/RemindSignerModal");
var _remindSignerModalDefault = parcelHelpers.interopDefault(_remindSignerModal);
var _deleteSignatureModal = require("./DeleteSignatureModal");
var _deleteSignatureModalDefault = parcelHelpers.interopDefault(_deleteSignatureModal);
var _updateSignatureModal = require("./UpdateSignatureModal");
var _updateSignatureModalDefault = parcelHelpers.interopDefault(_updateSignatureModal);
const SignatureActions = (props)=>{
    const { customerId, customerType, signature: initialSignature, existingEmails, readonly, assignments, onSignatureUpdated, onSignatureDeleted, ...actionDropdownProps } = props;
    const [showEditSignatureModal, setShowEditSignatureModal] = (0, _react.useState)(false);
    const [showRemindSignerModal, setShowRemindSignerModal] = (0, _react.useState)(false);
    const [showCopySignatureLinkModal, setShowCopySignatureLinkModal] = (0, _react.useState)(false);
    const [showDeleteSignatureModal, setShowDeleteSignatureModal] = (0, _react.useState)(false);
    const [signature, setSignature] = (0, _react.useState)(initialSignature);
    const f = (0, _useFormatMessageDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const actions = [];
    actions.push({
        content: f("signature.actions.edit.signature"),
        image: (0, _pencilSvgDefault.default),
        onAction: ()=>setShowEditSignatureModal(true),
        disabled: readonly
    });
    if ((0, _util.isEmailEnabled)(signature) && signature.email) actions.push({
        content: f("signature.actions.remind.signer"),
        image: (0, _remindSvgDefault.default),
        onAction: ()=>setShowRemindSignerModal(true),
        disabled: readonly
    });
    actions.push({
        content: f("signature.actions.copy.link"),
        image: (0, _linkSvgDefault.default),
        onAction: ()=>setShowCopySignatureLinkModal(true)
    }, {
        content: f("signature.actions.delete.signature"),
        image: (0, _trashSvgDefault.default),
        onAction: ()=>setShowDeleteSignatureModal(true),
        disabled: readonly
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                hideTitle: true,
                items: actions,
                ...actionDropdownProps
            }),
            showEditSignatureModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateSignatureModalDefault.default), {
                customerId: customerId,
                customerType: customerType,
                signature: signature,
                existingEmails: existingEmails,
                assignments: assignments,
                onSignatureUpdated: (signature)=>{
                    setSignature(signature);
                    onSignatureUpdated(signature);
                },
                onClose: ()=>setShowEditSignatureModal(false)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _remindSignerModalDefault.default), {
                customerId: customerId,
                signatureId: signature.id,
                email: signature.email,
                name: (0, _displayHelpers.getFullName)(signature.person),
                birthdate: (0, _displayHelpers.getBirthDate)(signature.person),
                open: showRemindSignerModal,
                onModalClose: ()=>setShowRemindSignerModal(false)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLinkModalDefault.default), {
                title: f("signature.modal.and.tooltips.copy.link"),
                url: signature.signing_page_url,
                open: showCopySignatureLinkModal,
                onModalClose: ()=>setShowCopySignatureLinkModal(false)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteSignatureModalDefault.default), {
                customerId: customerId,
                signatureId: signature.id,
                signatureName: (0, _displayHelpers.getFullName)(signature.person),
                open: showDeleteSignatureModal,
                onSignatureDeleted: ()=>{
                    setSnackbar(f("signature.snackbar.deleted"));
                    onSignatureDeleted(signature);
                },
                onModalClose: ()=>setShowDeleteSignatureModal(false)
            })
        ]
    });
};
exports.default = SignatureActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../../assets/icons/link.svg":"23IE8","../../../../../assets/icons/pencil.svg":"gEWpJ","../../../../../assets/icons/remind.svg":"ddhEn","../../../../../assets/icons/trash.svg":"jqW55","../../../../helpers/display.helpers":"2q3xY","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useSnackbar":"gQ3G9","../../../../utils/util":"4MniK","../../../ActionsDropdown/ActionsDropdown":"izRYG","../../../CopyLinkModal/CopyLinkModal":"cWduD","../../../RemindSignerModal/RemindSignerModal":"fob6T","./DeleteSignatureModal":"04u0L","./UpdateSignatureModal":"l8mM1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"04u0L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirm = require("../../../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
const DeleteSignatureModal = (props)=>{
    const { customerId, signatureId, open, signatureName, onSignatureDeleted, onModalClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const mutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).deleteCustomerSignature(customerId, signatureId), {
        onSuccess: ()=>{
            closeModal();
            onSignatureDeleted();
        }
    });
    const closeModal = ()=>onModalClose();
    const deleteSignature = ()=>mutation.mutate();
    if (!open) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
        title: f("modals.delete.signature.title"),
        description: f("modals.delete.signature.description", {
            name: signatureName
        }),
        onYes: deleteSignature,
        onNo: closeModal,
        actionTitle: f("modals.delete.signature.button"),
        isActionInProgress: mutation.isLoading,
        error: mutation.error
    });
};
exports.default = DeleteSignatureModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","../../../../api":"f6lXD","../../../../hooks/useFormatMessage":"8Y8fq","../../../Confirm/Confirm":"nqTPc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l8mM1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _roleTypes = require("../../../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _displayHelpers = require("../../../../helpers/display.helpers");
var _useDisclosureAssignment = require("../../../../hooks/useDisclosureAssignment");
var _useDisclosureAssignmentDefault = parcelHelpers.interopDefault(_useDisclosureAssignment);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../../../hooks/useQueryData");
var _useValidateDisclosureForm = require("../../../../hooks/useValidateDisclosureForm");
var _useValidateDisclosureFormDefault = parcelHelpers.interopDefault(_useValidateDisclosureForm);
var _collectionUtils = require("../../../../utils/collectionUtils");
var _disclosureSignatureForm = require("../../../DisclosureSignatureForm/DisclosureSignatureForm");
var _disclosureSignatureFormDefault = parcelHelpers.interopDefault(_disclosureSignatureForm);
var _displayName = require("../../../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _errorPanel = require("../../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _sectionTile = require("../../../SectionTile/SectionTile");
var _sectionTileDefault = parcelHelpers.interopDefault(_sectionTile);
const UpdateSignatureModal = (props)=>{
    const { customerId, customerType, signature: initialSignature, existingEmails, assignments, onSignatureUpdated, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const validateForm = (0, _useValidateDisclosureFormDefault.default)();
    const updateCustomerQueryData = (0, _useQueryData.useCustomerDetailsQueryData)({
        type: customerType,
        id: customerId
    });
    const updateAssignmentInCustomerDetails = (assignment)=>updateCustomerQueryData((queryData)=>{
            if (queryData.assignments) queryData.assignments = (0, _collectionUtils.updateItem)(queryData.assignments, assignment);
        });
    const [signature, setSignature] = (0, _react.useState)(initialSignature);
    const { selectedAssignment, setSelectedAssignment, shouldUpdateAssignment, updateAssignmentMutation } = (0, _useDisclosureAssignmentDefault.default)(customerId, signature.assignment_id, assignments, updateAssignmentInCustomerDetails);
    const [isValid, setIsValid] = (0, _react.useState)(()=>validateForm([
            signature
        ]));
    const [validationError, setValidationError] = (0, _react.useState)();
    const checkForChanges = (signature)=>{
        return signature.use_standard_disclosure !== initialSignature.use_standard_disclosure || signature.use_pep_disclosure !== initialSignature.use_pep_disclosure || signature.use_verification !== initialSignature.use_verification || signature.email !== initialSignature.email || signature.send_email !== initialSignature.send_email || signature.language !== initialSignature.language || signature.questionnaire_ids?.join() !== initialSignature.questionnaire_ids?.join();
    };
    const onSignatureChange = (signature, isValid)=>{
        let hasNoDuplicates = true;
        const containsChanges = checkForChanges(signature);
        // Handle duplicate e-mails
        if (existingEmails.includes(signature.email || "")) {
            // If the signature being updates, uses the same duplicate
            // email, allow it
            if (initialSignature.email === signature.email) setValidationError(undefined);
            else {
                hasNoDuplicates = false;
                setValidationError(f("modals.update.signature.error.duplicate-email"));
            }
        } else setValidationError(undefined);
        setSignature(signature);
        setIsValid(isValid && hasNoDuplicates && containsChanges);
    };
    const updateSignatureMutation = (0, _reactQuery.useMutation)(async ()=>{
        setValidationError(undefined);
        const payload = {
            email: signature.email,
            send_email: signature.send_email,
            use_standard_disclosure: signature.use_standard_disclosure,
            use_pep_disclosure: signature.use_pep_disclosure,
            use_verification: signature.use_verification,
            language: signature.language,
            questionnaire_ids: signature.questionnaire_ids,
            assignment_id: selectedAssignment?.id
        };
        const apiCall = signature.role ? (0, _apiDefault.default).updateCompanySignature : (0, _apiDefault.default).updatePersonSignature;
        if (shouldUpdateAssignment) await updateAssignmentMutation.mutateAsync();
        return apiCall(customerId, signature.id, payload);
    }, {
        onSuccess: (signature)=>{
            onSignatureUpdated(signature);
            updateCustomerQueryData((customer)=>customer.disclosure_documents.forEach((disclosureDocument)=>disclosureDocument.signatures = (0, _collectionUtils.updateItem)(disclosureDocument.signatures, signature)));
            onClose();
        }
    });
    const title = signature.role ? f((0, _roleTypesDefault.default)[signature.role.type]) : f("modals.update.signature.customer");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        large: true,
        open: true,
        onClose: onClose,
        title: f("modals.update.signature.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                        title: title,
                        gap: "1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                            type: "person",
                            name: (0, _displayHelpers.getFullName)(signature.person),
                            birthDate: (0, _displayHelpers.getBirthDate)(signature.person)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureSignatureFormDefault.default), {
                        signature: signature,
                        customerId: customerId,
                        customerType: customerType,
                        signatureName: (0, _displayHelpers.getFullName)(signature.person),
                        onChange: onSignatureChange,
                        assignments: assignments,
                        selectedAssignment: selectedAssignment,
                        onAssignmentChange: setSelectedAssignment,
                        readonly: updateSignatureMutation.isLoading
                    }),
                    (validationError || updateSignatureMutation.isError) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: validationError || updateSignatureMutation.error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                onClick: onClose,
                                disabled: updateSignatureMutation.isLoading,
                                children: f("default.cancel")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                primary: true,
                                onClick: updateSignatureMutation.mutate,
                                loading: updateSignatureMutation.isLoading,
                                disabled: !isValid || updateSignatureMutation.isLoading,
                                children: f("modals.update.signature.button")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
exports.default = UpdateSignatureModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../api":"f6lXD","../../../../constants/role-types":"fAycz","../../../../helpers/display.helpers":"2q3xY","../../../../hooks/useDisclosureAssignment":"0tZFn","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useQueryData":"4laI9","../../../../hooks/useValidateDisclosureForm":"6IoRW","../../../../utils/collectionUtils":"gr5mc","../../../DisclosureSignatureForm/DisclosureSignatureForm":"ayCrt","../../../DisplayName/DisplayName":"gKd5g","../../../ErrorPanel/ErrorPanel":"2hHqH","../../../SectionTile/SectionTile":"9KSoL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"0tZFn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _assignmentsHelpers = require("../helpers/assignments.helpers");
var _collectionUtils = require("../utils/collectionUtils");
var _useChangedState = require("./useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useDisclosureAssignment = (customerId, assignmentId, assignments, onAssignmentUpdate)=>{
    const features = (0, _useFeaturesDefault.default)();
    // if assignmentId is set as a URL params - select the assignment that matches with its id
    // otherwise, if SHOW_ASSIGNMENTS_IN_DISCLOSURE_FORM is enabled, select the first assignment found
    const getInitialAssignment = ()=>assignments?.find((assignment)=>assignment.id === assignmentId) || (features.ASSIGNMENTS__HIDE_DETAILS ? (0, _collectionUtils.first)(assignments?.sort((0, _assignmentsHelpers.sortAssignmentsByDate))) : undefined);
    const [selectedAssignment, setSelectedAssignment, isAssignmentChanged] = (0, _useChangedStateDefault.default)(()=>getInitialAssignment());
    const hasAssignments = (0, _collectionUtils.hasContent)(assignments);
    (0, _react.useEffect)(()=>{
        if (!selectedAssignment && hasAssignments) setSelectedAssignment(getInitialAssignment());
    }, [
        hasAssignments
    ]);
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ASSIGNMENT_DETAILS,
        customerId,
        selectedAssignment?.id
    ]);
    const shouldUpdateAssignment = customerId && isAssignmentChanged && selectedAssignment;
    const updateAssignmentMutation = (0, _reactQuery.useMutation)(()=>// if SHOW_ASSIGNMENTS_IN_DISCLOSURE_FORM is enabled and was changed - update the assignment be
        (0, _apiDefault.default).updateCustomerAssignment(customerId, selectedAssignment.id, (0, _assignmentsHelpers.convertAssignmentToUpdateRequest)(selectedAssignment)), {
        onSuccess: (response)=>{
            // update assignment details with purpose changes
            updateQueryData((queryData)=>Object.assign(queryData, response));
            if (onAssignmentUpdate) onAssignmentUpdate(response);
        }
    });
    return {
        selectedAssignment,
        setSelectedAssignment,
        shouldUpdateAssignment,
        updateAssignmentMutation
    };
};
exports.default = useDisclosureAssignment;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../helpers/assignments.helpers":"7t8rY","../utils/collectionUtils":"gr5mc","./useChangedState":"170jW","./useFeatures":"hvBWb","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6IoRW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _disclosuresHelpers = require("../helpers/disclosures.helpers");
var _stringUtils = require("../utils/stringUtils");
const useValidateDisclosureForm = ()=>{
    const validateForm = (signatures, onValidation)=>{
        const hasValidSelection = signatures.every((0, _disclosuresHelpers.isValidSignatureConfiguration));
        let hasValidEmail = true;
        let hasDuplicates = false;
        const emailDuplicates = new Set();
        if (signatures.length > 0) signatures.forEach((signature)=>{
            const email = signature.email;
            if (signature.send_email) {
                if (!(0, _stringUtils.isEmail)(email)) hasValidEmail = false;
                if (emailDuplicates.has(email)) {
                    hasValidEmail = false;
                    hasDuplicates = true;
                } else if (email) emailDuplicates.add(email);
            }
        });
        const isValid = signatures.length > 0 && hasValidEmail && hasValidSelection;
        onValidation && onValidation(isValid, hasDuplicates);
        return isValid;
    };
    return validateForm;
};
exports.default = useValidateDisclosureForm;

},{"../helpers/disclosures.helpers":"6yWoC","../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ayCrt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useValidateDisclosureForm = require("../../hooks/useValidateDisclosureForm");
var _useValidateDisclosureFormDefault = parcelHelpers.interopDefault(_useValidateDisclosureForm);
var _emailField = require("../EmailField/EmailField");
var _emailFieldDefault = parcelHelpers.interopDefault(_emailField);
var _signatureConfigurationForm = require("../SignatureConfigurationForm/SignatureConfigurationForm");
var _signatureConfigurationFormDefault = parcelHelpers.interopDefault(_signatureConfigurationForm);
const DisclosureSignatureForm = (props)=>{
    const { signature, readonly, onChange, ...signatureFormProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const validateForm = (0, _useValidateDisclosureFormDefault.default)();
    const onFieldChange = (field, value)=>{
        const changedSignature = {
            ...signature,
            [field]: value
        };
        // Clear email if `send_email` is set to False
        if (field === "send_email" && value === false) changedSignature["email"] = undefined;
        // Perform validation
        const isValid = validateForm([
            changedSignature
        ]);
        onChange(changedSignature, isValid);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _signatureConfigurationFormDefault.default), {
        signature: signature,
        readonly: readonly,
        onSignatureChange: (updateSignature)=>onChange(updateSignature, validateForm([
                updateSignature
            ])),
        ...signatureFormProps,
        children: [
            signature.send_email && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailFieldDefault.default), {
                required: true,
                placeholder: f("disclosure-request.field.email.placeholder"),
                value: signature.email,
                disabled: readonly,
                onChange: (newEmail)=>onFieldChange("email", newEmail)
            }),
            !signature.send_email && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                color: "subdued",
                children: f("signature.email.not.provided")
            })
        ]
    });
};
exports.default = DisclosureSignatureForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useValidateDisclosureForm":"6IoRW","../EmailField/EmailField":"ebWLS","../SignatureConfigurationForm/SignatureConfigurationForm":"dMptb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dMptb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _docTextSvg = require("../../../assets/icons/doc-text.svg");
var _docTextSvgDefault = parcelHelpers.interopDefault(_docTextSvg);
var _fileSvg = require("../../../assets/icons/file.svg");
var _fileSvgDefault = parcelHelpers.interopDefault(_fileSvg);
var _identitySvg = require("../../../assets/icons/identity.svg");
var _identitySvgDefault = parcelHelpers.interopDefault(_identitySvg);
var _projectSvg = require("../../../assets/icons/project.svg");
var _projectSvgDefault = parcelHelpers.interopDefault(_projectSvg);
var _disclosuresHelpers = require("../../helpers/disclosures.helpers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useNonInitialEffect = require("../../hooks/useNonInitialEffect");
var _useNonInitialEffectDefault = parcelHelpers.interopDefault(_useNonInitialEffect);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _collectionUtils = require("../../utils/collectionUtils");
var _filenameUtils = require("../../utils/filenameUtils");
var _util = require("../../utils/util");
var _assignmentSelector = require("../AssignmentSelector/AssignmentSelector");
var _assignmentSelectorDefault = parcelHelpers.interopDefault(_assignmentSelector);
var _disclosurePreviewModal = require("../DisclosurePreviewModal/DisclosurePreviewModal");
var _disclosurePreviewModalDefault = parcelHelpers.interopDefault(_disclosurePreviewModal);
var _disclosureQuestionnaireSelect = require("../DisclosureSignatureForm/DisclosureQuestionnaireSelect/DisclosureQuestionnaireSelect");
var _disclosureQuestionnaireSelectDefault = parcelHelpers.interopDefault(_disclosureQuestionnaireSelect);
var _languageSelect = require("../DisclosureSignatureForm/LanguageSelect");
var _languageSelectDefault = parcelHelpers.interopDefault(_languageSelect);
var _emailOrLinkButtonGroupInput = require("../EmailOrLinkButtonGroupInput/EmailOrLinkButtonGroupInput");
var _emailOrLinkButtonGroupInputDefault = parcelHelpers.interopDefault(_emailOrLinkButtonGroupInput);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _purposeChoicesSelect = require("../PurposeChoicesSelect/PurposeChoicesSelect");
var _purposeChoicesSelectDefault = parcelHelpers.interopDefault(_purposeChoicesSelect);
var _signatureFormWrapper = require("../SignatureFormWrapper/SignatureFormWrapper");
var _signatureFormWrapperDefault = parcelHelpers.interopDefault(_signatureFormWrapper);
const SignatureConfigurationForm = (props)=>{
    const { signature, customerId, customerType, signatureName, readonly, assignments, selectedAssignment, disableAssignmentSelection, attachments, selectedAttachmentsIds, forceShowError, onSignatureChange, onAssignmentChange = (0, _util.noop), onAttachmentsSelectionChange = (0, _util.noop), children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const disclosureTypeInputName = (0, _util.uniqueId)("disclosure_type");
    const [showKYCOptions, toggleKYCOptions] = (0, _useOpenCloseDefault.default)((0, _disclosuresHelpers.isKYCSelected)(signature));
    const initialSignature = (0, _react.useRef)({
        ...signature
    });
    const onFieldChange = (field, value)=>onSignatureChange({
            ...signature,
            [field]: value
        });
    // if the purpose changed, is means an assignment was selected and therefor the selection is valid
    const onAssignmentPurposeChange = (purpose)=>onAssignmentChange({
            ...selectedAssignment,
            purpose
        }, true);
    const [showPreviewModal, togglePreviewModal, closePreviewModal] = (0, _useOpenCloseDefault.default)();
    (0, _useNonInitialEffectDefault.default)(()=>{
        // whenever use_standard_disclosure state changes - reset use_pep_disclosure to be false
        // because use_pep_disclosure cannot be true when use_standard_disclosure is true
        // and use_pep_disclosure cannot be true if showKYCOptions is false (the radio buttons are hidden)
        if (showKYCOptions) onSignatureChange({
            ...signature,
            use_standard_disclosure: initialSignature.current.use_standard_disclosure,
            use_pep_disclosure: initialSignature.current.use_pep_disclosure
        });
        else onSignatureChange({
            ...signature,
            use_standard_disclosure: false,
            use_pep_disclosure: false
        });
    }, [
        showKYCOptions
    ]);
    const showAssignments = (0, _collectionUtils.hasContent)(assignments);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _signatureFormWrapperDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    showAssignments && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentSelectorDefault.default), {
                                        assignments: assignments,
                                        selectedAssignment: selectedAssignment,
                                        onSelectionChange: onAssignmentChange,
                                        readonly: readonly || disableAssignmentSelection,
                                        forceShowError: forceShowError
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                        gap: "2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                gap: "1",
                                                blockAlign: "center",
                                                wrap: false,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                        source: (0, _projectSvgDefault.default),
                                                        width: "16px",
                                                        height: "12px"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                        as: "span",
                                                        fontWeight: "semibold",
                                                        children: f("customer-assignments.details.assignment-purpose")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _purposeChoicesSelectDefault.default), {
                                                industryType: selectedAssignment?.industry_type,
                                                hasPurposeDesc: false,
                                                disablePurposeDescription: true,
                                                disabled: readonly || selectedAssignment === undefined,
                                                labelHidden: true,
                                                multiline: 3,
                                                value: selectedAssignment?.purpose || "",
                                                onChange: onAssignmentPurposeChange
                                            }, selectedAssignment?.id || "selected-assignment")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                wrap: false,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _identitySvgDefault.default),
                                        width: "25px",
                                        height: "18px"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        fontWeight: "semibold",
                                        children: f("signature.configuration.form.labels.verification")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                label: f("common.labels.bank-id"),
                                checked: signature.use_verification,
                                onChange: (value)=>onFieldChange("use_verification", value),
                                disabled: readonly
                            })
                        ]
                    }),
                    (0, _collectionUtils.hasContent)(attachments) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        fontWeight: "semibold",
                                        children: f("signature.configuration.form.labels.e-signatures")
                                    }),
                                    attachments?.map((attachment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                            label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                gap: "1",
                                                wrap: false,
                                                blockAlign: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                        source: (0, _fileSvgDefault.default)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                        as: "span",
                                                        breakWord: true,
                                                        children: (0, _filenameUtils.cleanupFilename)(attachment.filename)
                                                    })
                                                ]
                                            }),
                                            checked: selectedAttachmentsIds?.includes(attachment.id),
                                            onChange: ()=>onAttachmentsSelectionChange((0, _collectionUtils.toggleElement)(selectedAttachmentsIds || [], attachment.id)),
                                            disabled: readonly
                                        }, attachment.id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                wrap: false,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _fileSvgDefault.default),
                                        width: "25px",
                                        height: "18px"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        fontWeight: "semibold",
                                        children: f("disclosure-request.field.use_standard_disclosure")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                label: f("signature.configuration.form.labels.disclosure"),
                                checked: showKYCOptions,
                                onChange: toggleKYCOptions,
                                disabled: readonly
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                                id: "use_standard_disclosure",
                                open: showKYCOptions,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                    gap: "2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                            disabled: readonly,
                                            checked: signature.use_standard_disclosure,
                                            onChange: ()=>onSignatureChange({
                                                    ...signature,
                                                    use_standard_disclosure: true,
                                                    use_pep_disclosure: false
                                                }),
                                            label: f("signature.configuration.form.labels.disclosure.full"),
                                            name: disclosureTypeInputName
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                            disabled: readonly,
                                            checked: signature.use_pep_disclosure === true,
                                            onChange: ()=>onSignatureChange({
                                                    ...signature,
                                                    use_standard_disclosure: false,
                                                    use_pep_disclosure: true
                                                }),
                                            label: f("signature.configuration.form.labels.disclosure.pep"),
                                            name: disclosureTypeInputName
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                wrap: false,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _docTextSvgDefault.default),
                                        width: "25px",
                                        height: "18px"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        fontWeight: "semibold",
                                        children: f("disclosure-request.column.custom-questionnaires")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureQuestionnaireSelectDefault.default), {
                                customerType: customerType,
                                questionnairesIds: signature.questionnaire_ids || [],
                                readonly: readonly,
                                onChange: (questionnaireIds)=>onFieldChange("questionnaire_ids", questionnaireIds)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                fontWeight: "semibold",
                                children: f("signature.configuration.form.labels.choose.language")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageSelectDefault.default), {
                                value: signature.language,
                                onChange: (language)=>onFieldChange("language", language),
                                disabled: readonly
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                fontWeight: "semibold",
                                children: f("signature.configuration.form.labels.choose.send.method")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailOrLinkButtonGroupInputDefault.default), {
                                fullWidth: true,
                                value: signature.send_email ? "email" : "link",
                                onChange: (value)=>onFieldChange("send_email", value === "email"),
                                disabled: readonly
                            }),
                            children
                        ]
                    }),
                    features.DISCLOSURE__PREVIEW && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        fontWeight: "semibold",
                                        children: f("signature.configuration.form.labels.preview")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        primary: true,
                                        textAlign: "left",
                                        disabled: readonly,
                                        onClick: togglePreviewModal,
                                        children: f("signature.configuration.form.buttons.preview")
                                    }),
                                    showPreviewModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosurePreviewModalDefault.default), {
                                        signature: {
                                            ...signature,
                                            subject_id: customerId,
                                            subject_type: customerType,
                                            subject_name: signatureName,
                                            assignment_id: selectedAssignment?.id
                                        },
                                        onClose: closePreviewModal
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = SignatureConfigurationForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/doc-text.svg":"leosj","../../../assets/icons/file.svg":"bLqMZ","../../../assets/icons/identity.svg":"aFw6Y","../../../assets/icons/project.svg":"b4tRC","../../helpers/disclosures.helpers":"6yWoC","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useNonInitialEffect":"7lww1","../../hooks/useOpenClose":"idooG","../../utils/collectionUtils":"gr5mc","../../utils/filenameUtils":"2FnJx","../../utils/util":"4MniK","../AssignmentSelector/AssignmentSelector":"3XY7s","../DisclosurePreviewModal/DisclosurePreviewModal":"8dUNC","../DisclosureSignatureForm/DisclosureQuestionnaireSelect/DisclosureQuestionnaireSelect":"jSolf","../DisclosureSignatureForm/LanguageSelect":"9t94t","../EmailOrLinkButtonGroupInput/EmailOrLinkButtonGroupInput":"giiOf","../extensions/Icon":"eHSf0","../PurposeChoicesSelect/PurposeChoicesSelect":"fbzrz","../SignatureFormWrapper/SignatureFormWrapper":"1F5gh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3XY7s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _projectSvg = require("../../../assets/icons/project.svg");
var _projectSvgDefault = parcelHelpers.interopDefault(_projectSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _collectionUtils = require("../../utils/collectionUtils");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const AssignmentSelector = (props)=>{
    const { assignments, selectedAssignment, readonly, hideIcon, forceShowError, onSelectionChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showAssignments, toggleAssignments] = (0, _useOpenCloseDefault.default)(selectedAssignment !== undefined);
    const [touched, setTouched] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (assignments && assignments.length > 0 && !showAssignments) toggleAssignments();
    }, [
        assignments?.length
    ]);
    (0, _react.useEffect)(()=>{
        // if the include assignment checkbox is checked and there is more than 1 assignment = an assignment must be selected
        // When there is only 1 assignment, the showAssignments checkbox is not rendered
        // only a single assignment checkbox
        const isValidSelection = showAssignments && assignments?.length !== 1 ? selectedAssignment !== undefined : true;
        // if showAssignments is true - use the selected assignment, otherwise, clear selected assignment
        if (showAssignments) onSelectionChange(selectedAssignment, isValidSelection);
        else onSelectionChange(undefined, isValidSelection);
    }, [
        showAssignments
    ]);
    const handleSelectionChange = (assignment)=>{
        setTouched(true);
        // if the include assignment checkbox is checked and there is more than 1 assignment = an assignment must be selected
        // When there is only 1 assignment, the showAssignments checkbox is not rendered
        // only a single assignment checkbox
        const isValidSelection = showAssignments && assignments?.length !== 1 ? assignment !== undefined : true;
        onSelectionChange(assignment, isValidSelection);
    };
    if (!assignments || assignments.length === 0) return null;
    const showError = touched && showAssignments && !selectedAssignment || forceShowError;
    const { formatDate } = (0, _reactIntl.useIntl)();
    const formatAssignmentName = (assignment)=>{
        if (!assignment) return "";
        return assignment.name + "" + (assignment.created_dt ? ` - ${formatDate(assignment.created_dt)}` : "");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                blockAlign: "center",
                wrap: false,
                children: [
                    !hideIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _projectSvgDefault.default),
                        width: "16px",
                        height: "12px"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "semibold",
                        children: f("customer-assignments.modal.assignment-name")
                    })
                ]
            }),
            assignments.length === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                label: formatAssignmentName((0, _collectionUtils.first)(assignments)),
                checked: selectedAssignment !== undefined,
                onChange: (newChecked)=>handleSelectionChange(newChecked ? (0, _collectionUtils.first)(assignments) : undefined),
                disabled: readonly
            }),
            assignments.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                        label: f("common.labels.include-assignment"),
                        checked: showAssignments,
                        onChange: toggleAssignments,
                        disabled: readonly
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                        id: "show_assignments_collapsible",
                        open: showAssignments,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: assignments.map((assignment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: formatAssignmentName(assignment),
                                    checked: selectedAssignment?.id === assignment.id,
                                    onChange: ()=>handleSelectionChange(assignment),
                                    disabled: readonly
                                }, assignment.id))
                        })
                    }),
                    showError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.InlineError), {
                        message: f("assignment.selector.error.message"),
                        fieldID: "show_assignments_collapsible"
                    })
                ]
            })
        ]
    });
};
exports.default = AssignmentSelector;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","../../../assets/icons/project.svg":"b4tRC","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../utils/collectionUtils":"gr5mc","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8dUNC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePreviewDisclosureMutation = require("../../hooks/usePreviewDisclosureMutation");
var _usePreviewDisclosureMutationDefault = parcelHelpers.interopDefault(_usePreviewDisclosureMutation);
var _previewModalAsync = require("../PreviewModalAsync/PreviewModalAsync");
var _previewModalAsyncDefault = parcelHelpers.interopDefault(_previewModalAsync);
const DisclosurePreviewModal = (props)=>{
    const { signature, onClose } = props;
    const { user } = (0, _useAuthDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const previewDisclosureMutation = (0, _usePreviewDisclosureMutationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewModalAsyncDefault.default), {
        getPreviewURLPromise: ()=>previewDisclosureMutation.mutateAsync({
                ...signature,
                organization_id: user?.organization.id
            }),
        title: f("default.preview"),
        loading: previewDisclosureMutation.isLoading,
        onClose: onClose
    });
};
exports.default = DisclosurePreviewModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useAuth":"k9r0q","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePreviewDisclosureMutation":"2QR3B","../PreviewModalAsync/PreviewModalAsync":"1u6BW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2QR3B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _util = require("../utils/util");
var _useFetch = require("./useFetch");
var _useFetchDefault = parcelHelpers.interopDefault(_useFetch);
const usePreviewDisclosureMutation = ()=>{
    const fetch = (0, _useFetchDefault.default)();
    const previewDisclosureMutation = (0, _reactQuery.useMutation)(async (signature)=>{
        const request = {
            ...(0, _util.removeProperty)(signature, "id"),
            send_email: false
        };
        const previewUrl = await (0, _apiDefault.default).getDisclosurePreviewLink(request);
        return await fetch(previewUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request)
        })// convert the response to an Object URL string that can be used inside an iFrame
        .then((res)=>res.blob()).then((blob)=>URL.createObjectURL(blob));
    });
    return previewDisclosureMutation;
};
exports.default = usePreviewDisclosureMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../utils/util":"4MniK","./useFetch":"9uRF8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1u6BW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _previewModal = require("../PreviewModal/PreviewModal");
var _previewModalDefault = parcelHelpers.interopDefault(_previewModal);
const PreviewModalAsync = (props)=>{
    const { getPreviewURLPromise, ...previewModalProps } = props;
    const { data, isFetching, error } = (0, _reactQuery.useQuery)([
        "preview-async-modal"
    ], getPreviewURLPromise, {
        refetchOnWindowFocus: false
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewModalDefault.default), {
        previewURL: data,
        ...previewModalProps,
        loading: isFetching,
        error: error
    });
};
exports.default = PreviewModalAsync;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","../PreviewModal/PreviewModal":"dCYRZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dCYRZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const PreviewModal = (props)=>{
    const { previewURL, error, large, onClose, children, ...modalProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const closeAction = {
        content: f("default.close"),
        onAction: onClose
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        large: large,
        onClose: onClose,
        primaryAction: closeAction,
        iFrameName: "preview-modal",
        ...modalProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            flush: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                inlineAlign: "stretch",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledPreviewContainer, {
                        large: large,
                        children: [
                            previewURL && /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                                src: previewURL,
                                name: "preview-modal"
                            }),
                            children
                        ]
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: error
                    })
                ]
            })
        })
    });
};
const StyledPreviewContainer = (0, _styledComponentsDefault.default).div`
  margin: 0 ${({ large })=>large ? "0" : "auto"};
  padding: 0 var(--p-space-4);
  overscroll-behavior: none;
  min-width: var(--p-breakpoints-sm);

  & > iframe {
    border: none;
    width: var(--p-breakpoints-sm);
    overscroll-behavior: none;
    min-height: 50vh;
  }
`;
exports.default = PreviewModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jSolf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _docTextSvg = require("jsx:../../../../assets/icons/doc-text.svg");
var _docTextSvgDefault = parcelHelpers.interopDefault(_docTextSvg);
var _infoBlueSvg = require("jsx:../../../../assets/icons/info-blue.svg");
var _infoBlueSvgDefault = parcelHelpers.interopDefault(_infoBlueSvg);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useGetQuestionnairesSummary = require("../../../hooks/useGetQuestionnairesSummary");
var _useGetQuestionnairesSummaryDefault = parcelHelpers.interopDefault(_useGetQuestionnairesSummary);
var _collectionUtils = require("../../../utils/collectionUtils");
var _errorPanel = require("../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _tooltipWrapper = require("../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _questionnairesSelect = require("./QuestionnairesSelect/QuestionnairesSelect");
var _questionnairesSelectDefault = parcelHelpers.interopDefault(_questionnairesSelect);
const DisclosureQuestionnaireSelect = (props)=>{
    const { questionnairesIds, customerType, readonly, onChange } = props;
    const { questionnairesSummaryByIdMap, isLoading, isError, error } = (0, _useGetQuestionnairesSummaryDefault.default)(customerType);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
        size: "small"
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: error
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairesSelectDefault.default), {
                ...props
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                gap: "2",
                children: questionnairesIds.map((questionnaireId)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledQuestionnaireNameWrapper, {
                        title: questionnairesSummaryByIdMap[questionnaireId].name,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Icon), {
                                source: (0, _docTextSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledQuestionnaireName, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        color: readonly ? "subdued" : undefined,
                                        truncate: true,
                                        children: questionnairesSummaryByIdMap[questionnaireId].name
                                    }),
                                    questionnairesSummaryByIdMap[questionnaireId].description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                                        content: questionnairesSummaryByIdMap[questionnaireId].description,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Icon), {
                                            source: (0, _infoBlueSvgDefault.default)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                disabled: readonly,
                                size: "slim",
                                icon: (0, _polarisIcons.CancelMinor),
                                onClick: ()=>onChange((0, _collectionUtils.toggleElement)(questionnairesIds, questionnaireId))
                            })
                        ]
                    }, questionnaireId))
            })
        ]
    });
};
const StyledQuestionnaireNameWrapper = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-columns: 2rem auto 2rem;

  background: var(--p-surface-subdued);

  border: var(--p-border-width-1) solid var(--p-border-subdued);
  border-radius: var(--p-border-radius-1);

  // reset Polaris button to have square size
  & > .Polaris-Button {
    border: none;
    box-shadow: none;
    padding: var(--p-space-1);
    min-width: auto;

    & > .Polaris-Button__Content {
      padding: 0;
    }
  }

  // reset Polaris icon width
  & > .Polaris-Icon {
    max-width: fit-content;
  }

  // draw lines between components
  & > *:not(:first-child):not(:last-child) {
    line-height: var(--p-font-line-height-4);
    padding: 0 var(--p-space-2);
    border-left: var(--p-border-width-1) solid var(--p-border-subdued);
    border-right: var(--p-border-width-1) solid var(--p-border-subdued);
  }
`;
const StyledQuestionnaireName = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-columns: fit-content(100%) 1rem;
  align-items: center;
  gap: var(--p-space-1);
`;
exports.default = DisclosureQuestionnaireSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","jsx:../../../../assets/icons/doc-text.svg":"9yF2K","jsx:../../../../assets/icons/info-blue.svg":"8fgW8","styled-components":"eBrdC","../../../hooks/useGetQuestionnairesSummary":"3Fs8h","../../../utils/collectionUtils":"gr5mc","../../ErrorPanel/ErrorPanel":"2hHqH","../../TooltipWrapper/TooltipWrapper":"b5W2d","./QuestionnairesSelect/QuestionnairesSelect":"3NUQV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9yF2K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDocText = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.5 2H11.44l1.3 1.3 1.96 1.96 1.3 1.3V17.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5Zm10.2 6h-4.2a.5.5 0 0 1-.5-.5V3.3H5.8a.5.5 0 0 0-.5.5v12.4a.5.5 0 0 0 .5.5h8.4a.5.5 0 0 0 .5-.5V8ZM7 10.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
            fill: "#1D1C31"
        })
    });
exports.default = SvgDocText;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8fgW8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInfoBlue = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 17,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8.5,
                cy: 8,
                r: 7.35,
                transform: "rotate(-180 8.5 8)",
                stroke: "#365BFF",
                strokeWidth: 1.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: 9.149,
                y: 6.65,
                width: 5,
                height: 1.3,
                rx: 0.51,
                transform: "rotate(90 9.15 6.65)",
                fill: "#365BFF"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: 8.887,
                y: 7.95,
                width: 1.962,
                height: 1.3,
                rx: 0.51,
                transform: "rotate(-180 8.887 7.95)",
                fill: "#365BFF"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: 10.074,
                y: 11.65,
                width: 3.15,
                height: 1.3,
                rx: 0.51,
                transform: "rotate(-180 10.074 11.65)",
                fill: "#365BFF"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8.399,
                cy: 4.636,
                r: 0.75,
                fill: "#365BFF"
            })
        ]
    });
exports.default = SvgInfoBlue;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3NUQV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _plusMajorSvg = require("../../../../../assets/icons/plus-major.svg");
var _plusMajorSvgDefault = parcelHelpers.interopDefault(_plusMajorSvg);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../../../utils/collectionUtils");
var _icon = require("../../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _popoverButton = require("../../../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _questionnairesList = require("./QuestionnairesList");
var _questionnairesListDefault = parcelHelpers.interopDefault(_questionnairesList);
const QuestionnairesSelect = (props)=>{
    const { questionnairesIds, customerType, readonly, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const handleQuestionnaireSelect = (onClose, questionnaire)=>{
        const selectedIds = !questionnaire ? [] : (0, _collectionUtils.toggleElement)(questionnairesIds, questionnaire.id);
        onClose();
        onChange(selectedIds);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
        label: f("default.add"),
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _plusMajorSvgDefault.default),
            width: "12px",
            height: "12px",
            useMask: true
        }),
        size: "slim",
        disabled: readonly,
        fullWidth: false,
        render: (onClose)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairesListDefault.default), {
                    selectedIds: questionnairesIds,
                    customerType: customerType,
                    readonly: readonly,
                    onSelect: (questionnaire)=>handleQuestionnaireSelect(onClose, questionnaire),
                    hideFilter: true
                })
            })
    });
};
exports.default = QuestionnairesSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../../assets/icons/plus-major.svg":"fCy4K","../../../../hooks/useFormatMessage":"8Y8fq","../../../../utils/collectionUtils":"gr5mc","../../../extensions/Icon":"eHSf0","../../../PopoverButton/PopoverButton":"ihB8F","./QuestionnairesList":"1cWVg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1cWVg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _docTextSvg = require("../../../../../assets/icons/doc-text.svg");
var _docTextSvgDefault = parcelHelpers.interopDefault(_docTextSvg);
var _routes = require("../../../../constants/routes");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetQuestionnairesSummary = require("../../../../hooks/useGetQuestionnairesSummary");
var _useGetQuestionnairesSummaryDefault = parcelHelpers.interopDefault(_useGetQuestionnairesSummary);
var _entitiesList = require("../../../EntitiesList/EntitiesList");
var _entitiesListDefault = parcelHelpers.interopDefault(_entitiesList);
var _errorPanel = require("../../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _icon = require("../../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _markdownContent = require("../../../MarkdownContent/MarkdownContent");
var _markdownContentDefault = parcelHelpers.interopDefault(_markdownContent);
const QuestionnairesList = (props)=>{
    const { customerType, ...entitiesListProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { questionnairesSummary, isLoading, error } = (0, _useGetQuestionnairesSummaryDefault.default)(customerType);
    const questionnaireSettingsURL = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_QUESTIONNAIRES_LIST);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("component.questionnaires-list.loading")
            }),
            ";"
        ]
    });
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: error,
        actionTitle: f("component.questionnaires-list.loading.error-action")
    });
    if (questionnairesSummary.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownContentDefault.default), {
        content: f("component.questionnaires-list.empty", {
            link: questionnaireSettingsURL
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entitiesListDefault.default), {
        entities: questionnairesSummary,
        getEntityLabel: (questionnaire)=>questionnaire.name,
        getEntityHelpText: (questionnaire)=>questionnaire.description,
        getEntityPrefix: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _docTextSvgDefault.default)
            }),
        isEntityDisabled: (questionnaire)=>questionnaire.is_archived,
        filterLabel: f("component.questionnaires-list.filter.label"),
        ...entitiesListProps
    });
};
exports.default = QuestionnairesList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../../../../assets/icons/doc-text.svg":"leosj","../../../../constants/routes":"ihtm8","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useGetQuestionnairesSummary":"3Fs8h","../../../EntitiesList/EntitiesList":"ce1Sz","../../../ErrorPanel/ErrorPanel":"2hHqH","../../../extensions/Icon":"eHSf0","../../../MarkdownContent/MarkdownContent":"cPR47","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9t94t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _languages = require("../../constants/languages");
var _useGetLanguageName = require("../../hooks/useGetLanguageName");
var _useGetLanguageNameDefault = parcelHelpers.interopDefault(_useGetLanguageName);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const LanguageSelect = (props)=>{
    const { value = (0, _languages.DEFAULT_LANGUAGE), onChange, ...buttonProps } = props;
    const getLanguageName = (0, _useGetLanguageNameDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ButtonGroup), {
        segmented: true,
        fullWidth: true,
        children: (0, _languages.SUPPORTED_LANGUAGES).map((language)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                ...buttonProps,
                primary: language === value,
                onClick: ()=>onChange(language),
                children: getLanguageName(language)
            }, language))
    });
};
exports.default = LanguageSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/languages":"ecnY7","../../hooks/useGetLanguageName":"cbuaO","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1F5gh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
const SignatureFormWrapper = (0, _styledComponentsDefault.default).div`
  --min: 15ch;

  display: grid;
  grid-gap: 0 var(--p-space-4);

  /* min() with 100% prevents overflow
  in extra narrow spaces */
  grid-template-columns: repeat(auto-fit, minmax(min(100%, var(--min)), 1fr));

  // in mobile view - set a vertical gap between components
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    grid-gap: var(--p-space-8) 0;
  }

  // draw lines between components
  & > *:not(:last-child) {
    padding-right: var(--p-space-4);
    border-right: var(--p-border-divider);

    @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
      border-right: revert;
      padding-right: revert;
    }
  }

  & .Polaris-Choice {
    border: var(--p-border-width-1) solid var(--p-border-subdued);
    border-radius: var(--p-border-radius-1);
    box-shadow: var(--p-shadow-button);
    padding: var(--p-space-2);
    width: 100%;

    &:hover:not(.Polaris-Choice--disabled) {
      background: var(--p-action-secondary-hovered);
    }

    &:active:not(.Polaris-Choice--disabled) {
      background: var(--p-action-secondary-pressed);
    }
  }
`;
exports.default = SignatureFormWrapper;

},{"styled-components":"eBrdC","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bEgSk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../../helpers/display.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _collectionUtils = require("../../../utils/collectionUtils");
var _assignmentInfo = require("../../AssignmentInfo/AssignmentInfo");
var _assignmentInfoDefault = parcelHelpers.interopDefault(_assignmentInfo);
var _disclosureAnswers = require("../../DisclosureAnswers/DisclosureAnswers");
var _disclosureAnswersDefault = parcelHelpers.interopDefault(_disclosureAnswers);
var _signingUserInfo = require("./SigningUserInfo");
var _signingUserInfoDefault = parcelHelpers.interopDefault(_signingUserInfo);
var _useGetSigningMetodLabel = require("./useGetSigningMetodLabel");
var _useGetSigningMetodLabelDefault = parcelHelpers.interopDefault(_useGetSigningMetodLabel);
const CompletedDisclosureDocumentSignature = (props)=>{
    const { signature, hideSignedUserInfo, useSmallButton, vertical, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [isDisclosureOpen, toggleDisclosureOpen] = (0, _useOpenCloseDefault.default)();
    const hasQuestionnaireAnswer = (0, _collectionUtils.hasContent)(signature.questionnaire_ids);
    if (!signature.signing_user_info && !signature.disclosure && !hasQuestionnaireAnswer) return null;
    const showSignedUserInfo = !hideSignedUserInfo && signature.signing_user_info !== undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Grid), {
                columns: {
                    xs: 1,
                    md: 3,
                    lg: 5
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Grid).Cell, {
                        columnSpan: showSignedUserInfo ? {
                            xs: 1,
                            md: 3
                        } : {
                            xs: 5
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            align: "space-between",
                            gap: "2",
                            children: [
                                signature.assignment_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentInfoDefault.default), {
                                    assignmentName: signature.assignment_name,
                                    assignmentPurpose: signature.assignment_purpose
                                }),
                                (signature.disclosure || hasQuestionnaireAnswer) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "1",
                                    align: "space-between",
                                    wrap: false,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                            onClick: toggleDisclosureOpen,
                                            removeUnderline: true,
                                            size: useSmallButton ? "slim" : undefined,
                                            children: isDisclosureOpen ? f("disclosure-collapsible.hide") : f("disclosure-collapsible.show")
                                        }),
                                        children
                                    ]
                                })
                            ]
                        })
                    }),
                    signature.signing_user_info && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Grid).Cell, {
                        columnSpan: {
                            xs: 1,
                            md: 2,
                            lg: 4
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signingUserInfoDefault.default), {
                            identificationMethodLabel: f("disclosure-card.identification.label", {
                                method: (0, _useGetSigningMetodLabelDefault.default)(signature)
                            }),
                            customerName: (0, _displayHelpers.getFullName)(signature.person),
                            signingUserInfo: signature.signing_user_info
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                id: signature.id + "-disclosure-collapsible",
                open: isDisclosureOpen,
                children: signature.disclosure_answers && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureAnswersDefault.default), {
                    disclosureSections: signature.disclosure_answers.sections,
                    vertical: vertical,
                    hoverable: false
                })
            })
        ]
    });
};
exports.default = CompletedDisclosureDocumentSignature;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../helpers/display.helpers":"2q3xY","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useOpenClose":"idooG","../../../utils/collectionUtils":"gr5mc","../../AssignmentInfo/AssignmentInfo":"ds7XR","../../DisclosureAnswers/DisclosureAnswers":"sDX50","./SigningUserInfo":"4hfGH","./useGetSigningMetodLabel":"eluD1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"sDX50":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _disclosuresHelpers = require("../../helpers/disclosures.helpers");
var _useTranslatedText = require("../../hooks/useTranslatedText");
var _useTranslatedTextDefault = parcelHelpers.interopDefault(_useTranslatedText);
var _filesetActions = require("../DisclosureDocumentSection/DisclosureDocumentSignature/FilesetActions");
var _filesetActionsDefault = parcelHelpers.interopDefault(_filesetActions);
var _infoTable = require("../InfoTable/InfoTable");
var _infoTableDefault = parcelHelpers.interopDefault(_infoTable);
var _disclosureAnswer = require("./DisclosureAnswer");
var _disclosureAnswerDefault = parcelHelpers.interopDefault(_disclosureAnswer);
const DisclosureAnswers = (props)=>{
    const { disclosureSections, ...infoTableProps } = props;
    const t = (0, _useTranslatedTextDefault.default)();
    const rows = [];
    disclosureSections.forEach((disclosureSection)=>{
        const header = disclosureSection.title && t(disclosureSection.title);
        if (header) rows.push({
            label: header,
            value: "",
            isHeading: true
        });
        disclosureSection.answers.forEach((answer)=>{
            const label = t(answer.question.text);
            const value = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureAnswerDefault.default), {
                answer: answer
            });
            rows.push({
                label,
                value,
                isWarning: answer.risk_indicators !== undefined && answer.risk_indicators.length > 0,
                warningDescription: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                    gap: "2",
                    children: answer.risk_indicators?.flatMap((0, _disclosuresHelpers.getRiskDescriptions)).map((description, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: t(description)
                        }, index))
                }),
                suffix: answer.uploaded_documents && answer.uploaded_documents.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesetActionsDefault.default), {
                    filesets: answer.uploaded_documents
                }) : undefined
            });
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTableDefault.default), {
        rows: rows,
        showActionsColumn: true,
        ...infoTableProps
    });
};
exports.default = DisclosureAnswers;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/disclosures.helpers":"6yWoC","../../hooks/useTranslatedText":"lODeq","../DisclosureDocumentSection/DisclosureDocumentSignature/FilesetActions":"jBoxv","../InfoTable/InfoTable":"b83NY","./DisclosureAnswer":"2mmVu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jBoxv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _fileSvg = require("../../../../assets/icons/file.svg");
var _fileSvgDefault = parcelHelpers.interopDefault(_fileSvg);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _downloadUtils = require("../../../utils/downloadUtils");
var _downloadUtilsDefault = parcelHelpers.interopDefault(_downloadUtils);
var _actionsDropdown = require("../../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _condensedText = require("../../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _filesetActionsHelpers = require("./FilesetActions.helpers");
const FilesetActions = (props)=>{
    const { filesets } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const downloadFileMutation = (0, _reactQuery.useMutation)(async (customerFile)=>{
        const downloadInfo = await (0, _apiDefault.default).getFileDownloadUrl(customerFile.id);
        return (0, _downloadUtilsDefault.default)(downloadInfo.download_url, (0, _filesetActionsHelpers.getFileName)(customerFile));
    });
    const isLoading = (fileId)=>downloadFileMutation.isLoading && downloadFileMutation.variables?.id == fileId;
    const allFiles = (0, _filesetActionsHelpers.flatAllFiles)(filesets);
    const items = allFiles.map(({ file, fileset })=>({
            content: (0, _filesetActionsHelpers.getFileName)(file),
            helpText: f(`disclosure.fileset.document-type.${(0, _filesetActionsHelpers.getFilesetType)(fileset)}`),
            prefix: isLoading(file.id) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _fileSvgDefault.default)
            }),
            disabled: downloadFileMutation.isLoading,
            onAction: ()=>downloadFileMutation.mutate(file)
        }));
    if (allFiles.length === 1) {
        const { file, fileset } = allFiles[0];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
            content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: (0, _filesetActionsHelpers.getFileName)(file)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f(`disclosure.fileset.document-type.${(0, _filesetActionsHelpers.getFilesetType)(fileset)}`)
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                icon: (0, _fileSvgDefault.default),
                plain: true,
                textAlign: "right",
                onClick: ()=>downloadFileMutation.mutate(file),
                loading: isLoading(file.id),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    truncate: true,
                    children: (0, _filesetActionsHelpers.getFileName)(file)
                })
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
        items: items,
        title: f("attachments.actions.download-attachment"),
        icon: (0, _fileSvgDefault.default),
        iconWidth: "20px",
        iconHeight: "20px",
        plain: true,
        monochrome: true,
        disclosure: true,
        forceOpen: downloadFileMutation.isLoading
    });
};
exports.default = FilesetActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../assets/icons/file.svg":"bLqMZ","../../../api":"f6lXD","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/downloadUtils":"kTJ5o","../../ActionsDropdown/ActionsDropdown":"izRYG","../../CondensedText/CondensedText":"1FshD","../../extensions/Button":"8exc0","../../extensions/Icon":"eHSf0","../../TooltipWrapper/TooltipWrapper":"b5W2d","./FilesetActions.helpers":"4ux5R","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4ux5R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flatAllFiles", ()=>flatAllFiles);
parcelHelpers.export(exports, "getFileName", ()=>getFileName);
parcelHelpers.export(exports, "getFilesetType", ()=>getFilesetType);
const flatAllFiles = (filesets)=>filesets.flatMap((fileset)=>fileset.files.map((file)=>({
                file,
                fileset
            })));
const getFileName = (file)=>"filename" in file ? file.filename : file.file_name;
const getFilesetType = (fileset)=>"document_type" in fileset ? fileset.document_type : fileset.type;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2mmVu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useTranslatedText = require("../../hooks/useTranslatedText");
var _useTranslatedTextDefault = parcelHelpers.interopDefault(_useTranslatedText);
var _useYesNo = require("../../hooks/useYesNo");
var _useYesNoDefault = parcelHelpers.interopDefault(_useYesNo);
var _stringUtils = require("../../utils/stringUtils");
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
const valueWithDescription = (values, additionalValue)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            values.length === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "p",
                children: values[0]
            }),
            values.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List), {
                spacing: "extraTight",
                children: values.map((value, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                        children: value
                    }, index))
            }),
            !(0, _stringUtils.isEmptyString)(additionalValue) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledItalicWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: additionalValue
                })
            })
        ]
    });
};
const DisclosureAnswer = (props)=>{
    const { answer } = props;
    const t = (0, _useTranslatedTextDefault.default)();
    const yesNo = (0, _useYesNoDefault.default)();
    switch(answer?.question.type){
        case "YES_NO":
            return valueWithDescription([
                yesNo(answer.raw_answer)
            ], answer.additional_info);
        case "TEXT":
            return valueWithDescription([
                answer.raw_answer
            ], answer.additional_info);
        case "SINGLE_CHOICE":
            return valueWithDescription([
                t(answer.answer)
            ], answer.additional_info);
        case "MULTIPLE_CHOICE":
            {
                const choices = answer.answer;
                return valueWithDescription(choices?.map((choice)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: t(choice)
                    })), answer.additional_info);
            }
        case "SINGLE_COUNTRY_CHOICE":
        case "MULTIPLE_COUNTRY_CHOICE":
            {
                // verify that countries is an array without empty cells
                const countries = (Array.isArray(answer.raw_answer) ? answer.raw_answer : [
                    answer.raw_answer
                ]).filter(Boolean);
                return valueWithDescription(countries?.map((country)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                        country: country
                    })), answer.additional_info);
            }
        default:
            return " - ";
    }
};
const StyledItalicWrapper = (0, _styledComponentsDefault.default).span`
  font-style: italic;
  white-space: pre-line;
`;
exports.default = DisclosureAnswer;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useTranslatedText":"lODeq","../../hooks/useYesNo":"dfOzB","../../utils/stringUtils":"4gVdA","../Country/Country":"eeWSc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4hfGH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _triangleFilledExclamationSvg = require("../../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../../utils/stringUtils");
var _addressInfo = require("../../AddressInfo/AddressInfo");
var _addressInfoDefault = parcelHelpers.interopDefault(_addressInfo);
var _condensedText = require("../../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _displayName = require("../../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _tooltipWrapper = require("../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const SigningUserInfo = (props)=>{
    const { identificationMethodLabel, signingUserInfo, customerName } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const showNameMatchWarning = (0, _react.useMemo)(()=>!(0, _stringUtils.areNamesSimilar)(customerName, signingUserInfo.name), [
        customerName,
        signingUserInfo.name
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "2",
                blockAlign: "center",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                        strong: true,
                        type: "person",
                        name: signingUserInfo.name
                    }),
                    showNameMatchWarning && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                        content: f("signing-user-info.name.mismatch.warning.tooltip"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _triangleFilledExclamationSvgDefault.default)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInfoText, {
                children: identificationMethodLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        blockAlign: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInfoEntry, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                    children: [
                                        f("signing-user-info.address"),
                                        ": "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInfoEntry, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                                        address: signingUserInfo.address
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledInfoEntry, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                children: [
                                    f("common.labels.national-id"),
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                children: signingUserInfo.social_no || f("not.specified")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledInfoEntry, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                children: [
                                    f("signing-user-info.birth-date"),
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                children: signingUserInfo.birth_date || f("not.specified")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const StyledInfoEntry = (0, _styledComponentsDefault.default).div`
  line-height: var(--p-font-line-height-1);
`;
const StyledInfoText = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  font-weight: var(--p-font-weight-bold);
`;
exports.default = SigningUserInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/stringUtils":"4gVdA","../../AddressInfo/AddressInfo":"9YtjF","../../CondensedText/CondensedText":"1FshD","../../DisplayName/DisplayName":"gKd5g","../../extensions/Icon":"eHSf0","../../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eluD1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useGetSigningMethodDisplayLabel = (signature)=>{
    const f = (0, _useFormatMessageDefault.default)();
    switch(signature.signing_method){
        case "NO_BANKID":
            return f("signature.signing-method.no");
        case "SIGNICAT_NO_BANKID":
            return f("signature.signing-method.no");
        case "SE_BANKID":
            return f("signature.signing-method.se");
        default:
            return "";
    }
};
exports.default = useGetSigningMethodDisplayLabel;

},{"../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cOB61":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _checkmarkGreenSvg = require("../../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _hourglassSvg = require("../../../../assets/icons/hourglass.svg");
var _hourglassSvgDefault = parcelHelpers.interopDefault(_hourglassSvg);
var _subtractRedSvg = require("../../../../assets/icons/subtract-red.svg");
var _subtractRedSvgDefault = parcelHelpers.interopDefault(_subtractRedSvg);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _condensedText = require("../../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const DisclosureStatus = (props)=>{
    const { signature } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const hasNextNotification = signature.status === "PENDING" && signature.next_notification_date;
    const getStatusInfo = ()=>{
        switch(signature.status){
            case "SIGNED":
                return {
                    statusIcon: (0, _checkmarkGreenSvgDefault.default),
                    statusLabel: f("disclosure-status.completed"),
                    statusSubtitle: signature.signed_dt ? f("disclosure-card.completed.subtitle", {
                        timestamp: new Date(signature.signed_dt)
                    }) : ""
                };
            case "PENDING":
                return {
                    statusIcon: (0, _hourglassSvgDefault.default),
                    statusLabel: f("disclosure-status.waiting"),
                    statusSubtitle: signature.previous_notification_date ? f("disclosure-card.notified.subtitle", {
                        timestamp: new Date(signature.previous_notification_date)
                    }) : ""
                };
            case "EXPIRED":
                return {
                    statusIcon: (0, _subtractRedSvgDefault.default),
                    statusLabel: f("disclosure-status.expired"),
                    statusSubtitle: signature.previous_notification_date ? f("disclosure-card.notified.subtitle", {
                        timestamp: new Date(signature.previous_notification_date)
                    }) : ""
                };
        }
    };
    const statusInfo = getStatusInfo();
    if (!statusInfo) return null;
    const { statusIcon, statusLabel, statusSubtitle } = statusInfo;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                spacing: "tight",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: statusIcon
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                        fill: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: statusLabel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: statusSubtitle
                    }),
                    hasNextNotification && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("disclosure-card.next-notification.subtitle", {
                            timestamp: new Date(signature.next_notification_date)
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = DisclosureStatus;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../assets/icons/checkmark-green.svg":"8HW5l","../../../../assets/icons/hourglass.svg":"4jWqV","../../../../assets/icons/subtract-red.svg":"5bCre","../../../hooks/useFormatMessage":"8Y8fq","../../CondensedText/CondensedText":"1FshD","../../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Wi3H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ExpiredDisclosureDocumentSignatureBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "warning",
        title: f("disclosure-card.expired-banner.title"),
        children: f("disclosure-card.expired-banner.description")
    });
};
exports.default = ExpiredDisclosureDocumentSignatureBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jJefj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../../constants/styles");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../../utils/util");
var _assignmentInfo = require("../../AssignmentInfo/AssignmentInfo");
var _assignmentInfoDefault = parcelHelpers.interopDefault(_assignmentInfo);
var _copyLabel = require("../../CopyLabel/CopyLabel");
var _copyLabelDefault = parcelHelpers.interopDefault(_copyLabel);
var _sectionTile = require("../../SectionTile/SectionTile");
var _sectionTileDefault = parcelHelpers.interopDefault(_sectionTile);
const PendingDisclosureDocumentSignature = (props)=>{
    const { signature } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const title = (0, _util.isEmailEnabled)(signature) ? f("disclosure-card.email-tile") : f("disclosure-card.link-tile");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledQuestionnaireName, {
        children: [
            signature.assignment_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentInfoDefault.default), {
                assignmentName: signature.assignment_name,
                assignmentPurpose: signature.assignment_purpose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                        title: title,
                        gap: "1",
                        children: (0, _util.isEmailEnabled)(signature) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: signature.email
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLabelDefault.default), {
                            size: "slim",
                            children: signature.signing_page_url
                        })
                    }),
                    signature.pin_code && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                        title: f("disclosure-card.pin-tile"),
                        gap: "1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLabelDefault.default), {
                            size: "slim",
                            children: signature.pin_code
                        })
                    })
                ]
            })
        ]
    });
};
const StyledQuestionnaireName = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: var(--p-space-8);

  // in mobile view - use one column
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    grid-template-columns: 1fr;
    gap: var(--p-space-4);
  }
`;
exports.default = PendingDisclosureDocumentSignature;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../constants/styles":"dZWds","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/util":"4MniK","../../AssignmentInfo/AssignmentInfo":"ds7XR","../../CopyLabel/CopyLabel":"4tqGl","../../SectionTile/SectionTile":"9KSoL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4EbjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDisclosurePagePath", ()=>createDisclosurePagePath);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
const createDisclosurePagePath = (customerId, customerType, assignmentId)=>{
    if (assignmentId) {
        if (customerType === "company") return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_ASSIGNMENT_REQUEST_DISCLOSURES, {
            id: customerId,
            assignmentId
        });
        else return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PERSON_ASSIGNMENT_REQUEST_DISCLOSURES, {
            id: customerId,
            assignmentId
        });
    } else {
        if (customerType === "company") return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_REQUEST_DISCLOSURES, {
            id: customerId
        });
        else return (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PERSON_REQUEST_DISCLOSURES, {
            id: customerId
        });
    }
};

},{"react-router-dom":"1ee65","../../constants/routes":"ihtm8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6mVwc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _gearWhiteSvg = require("../../../assets/icons/gear-white.svg");
var _gearWhiteSvgDefault = parcelHelpers.interopDefault(_gearWhiteSvg);
var _matches = require("../../constants/matches");
var _matchHelpers = require("../../helpers/match.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _matchCasesBulkActions = require("../MatchCasesBulkActions/MatchCasesBulkActions");
var _matchCasesBulkActionsDefault = parcelHelpers.interopDefault(_matchCasesBulkActions);
var _matchCasesTable = require("../MatchCasesTable/MatchCasesTable");
var _matchCasesTableDefault = parcelHelpers.interopDefault(_matchCasesTable);
var _possibleMatchBanner = require("../PossibleMatchBanner/PossibleMatchBanner");
var _possibleMatchBannerDefault = parcelHelpers.interopDefault(_possibleMatchBanner);
var _screeningStartedBanner = require("../ScreeningStartedBanner/ScreeningStartedBanner");
var _screeningStartedBannerDefault = parcelHelpers.interopDefault(_screeningStartedBanner);
const MatchCasesSection = (props)=>{
    const { customerId, customerType, hasFinishedOnboarding, matchCases, isScreeningStarting, isScreeningActive, readonly } = props;
    const [showRejectedMatches, toggleShowRejectedMatches] = (0, _useOpenCloseDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const [selectedIds, setSelectedIds] = (0, _react.useState)([]);
    const clearSelection = ()=>setSelectedIds([]);
    const hasUnresolvedMatchedCases = matchCases.length > 0 && matchCases.some((matchCase)=>matchCase.status !== "RESOLVED");
    const rejectedMatchCount = (0, _react.useMemo)(()=>matchCases.filter((0, _matchHelpers.isRejectedMatchCase)).length, [
        matchCases
    ]);
    const unresolvedMatchCasesCount = (0, _react.useMemo)(()=>matchCases.filter((0, _matchHelpers.isUnresolvedMatchCase)).length, [
        matchCases
    ]);
    const showBulkActions = unresolvedMatchCasesCount > (0, _matches.MATCH_CASES_BULK_ACTIONS_CUTOFF);
    let rowsToDisplay = matchCases;
    if (!showRejectedMatches) rowsToDisplay = matchCases.filter((m)=>!m.review || m.review && m.review.is_match);
    const showRejectedMatchCasesButton = matchCases.find((matchCase)=>matchCase.review?.is_match === false) !== undefined;
    const toggleRejectedMatchCasesButtonLabel = !showRejectedMatches ? f(`matches.button.show.rejected.matches`, {
        count: rejectedMatchCount
    }) : f(`matches.button.hide.rejected.matches`, {
        count: rejectedMatchCount
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                alignment: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "headingMd",
                        as: "h2",
                        children: f("screening.titles.screening")
                    }),
                    isScreeningActive && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Badge), {
                        status: "success",
                        progress: "complete",
                        children: f("screening.status.active")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                        fill: true
                    }),
                    hasFinishedOnboarding && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        icon: (0, _gearWhiteSvgDefault.default),
                        primary: true,
                        url: `${customerId}/change-screening`,
                        disabled: readonly,
                        children: f("common.buttons.actions.change-screening")
                    })
                ]
            }),
            isScreeningStarting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningStartedBannerDefault.default), {}),
            hasUnresolvedMatchedCases && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _possibleMatchBannerDefault.default), {}),
            rowsToDisplay.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    showBulkActions && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBulkActionsWrapper, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCasesBulkActionsDefault.default), {
                            customerId: customerId,
                            customerType: customerType,
                            totalMatchCasesCount: matchCases.length - rejectedMatchCount,
                            selectedMatchCasesIds: selectedIds,
                            readonly: readonly,
                            onAfterSuccess: clearSelection
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCasesTableDefault.default), {
                        matchCases: rowsToDisplay,
                        customerId: customerId,
                        unresolvedMatchCasesCount: unresolvedMatchCasesCount,
                        selectedIds: selectedIds,
                        onSelectionChange: setSelectedIds
                    })
                ]
            }),
            rowsToDisplay.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: rejectedMatchCount > 0 ? f("matches.text.no.confirmed.matches") : isScreeningStarting ? "" : f("matches.text.no.matches")
            }),
            showRejectedMatchCasesButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: toggleShowRejectedMatches,
                    textAlign: "left",
                    disclosure: !showRejectedMatches ? "down" : "up",
                    children: toggleRejectedMatchCasesButtonLabel
                })
            })
        ]
    });
};
const StyledBulkActionsWrapper = (0, _styledComponentsDefault.default).div`
  margin: var(--p-space-4);
`;
exports.default = MatchCasesSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/gear-white.svg":"7Z8Dg","../../constants/matches":"gcrL3","../../helpers/match.helpers":"4U2lJ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","../MatchCasesBulkActions/MatchCasesBulkActions":"jsRZA","../MatchCasesTable/MatchCasesTable":"1YrMn","../PossibleMatchBanner/PossibleMatchBanner":"gcWt1","../ScreeningStartedBanner/ScreeningStartedBanner":"bnK0k","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Z8Dg":[function(require,module,exports) {
module.exports = require("161584195710cc29").getBundleURL("kEMsi") + "gear-white.493e823c.svg";

},{"161584195710cc29":"75UoR"}],"gcrL3":[function(require,module,exports) {
/**
 * The number of unresolved match cases after which bulk action for rejecting match cases will be enabled
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MATCH_CASES_BULK_ACTIONS_CUTOFF", ()=>MATCH_CASES_BULK_ACTIONS_CUTOFF);
parcelHelpers.export(exports, "MATCH_ATTRIBUTE_ITEMS_CUTOFF", ()=>MATCH_ATTRIBUTE_ITEMS_CUTOFF);
parcelHelpers.export(exports, "MATCH_POSITIONS_AND_RELATIONS_CUTOFF", ()=>MATCH_POSITIONS_AND_RELATIONS_CUTOFF);
const MATCH_CASES_BULK_ACTIONS_CUTOFF = 3;
const MATCH_ATTRIBUTE_ITEMS_CUTOFF = 3;
const MATCH_POSITIONS_AND_RELATIONS_CUTOFF = 10;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4U2lJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRDCMatch", ()=>isRDCMatch);
parcelHelpers.export(exports, "isNotComplyAdvantageSource", ()=>isNotComplyAdvantageSource);
parcelHelpers.export(exports, "groupMatchAttributesByCode", ()=>groupMatchAttributesByCode);
parcelHelpers.export(exports, "groupComplyMatchFieldsByDescription", ()=>groupComplyMatchFieldsByDescription);
parcelHelpers.export(exports, "isConfirmedMatch", ()=>isConfirmedMatch);
parcelHelpers.export(exports, "isRejectedMatch", ()=>isRejectedMatch);
parcelHelpers.export(exports, "isConfirmedMatchCase", ()=>isConfirmedMatchCase);
parcelHelpers.export(exports, "isRejectedMatchCase", ()=>isRejectedMatchCase);
parcelHelpers.export(exports, "isUnresolvedMatchCase", ()=>isUnresolvedMatchCase);
parcelHelpers.export(exports, "findNextUnresolvedMatchCase", ()=>findNextUnresolvedMatchCase);
parcelHelpers.export(exports, "isEmptyMatchSource", ()=>isEmptyMatchSource);
parcelHelpers.export(exports, "sortBirthDatesByRelevance", ()=>sortBirthDatesByRelevance);
parcelHelpers.export(exports, "parseMatchAddress", ()=>parseMatchAddress);
parcelHelpers.export(exports, "sortAddressesByRelevance", ()=>sortAddressesByRelevance);
parcelHelpers.export(exports, "getSortMatchEventByRelevance", ()=>getSortMatchEventByRelevance);
parcelHelpers.export(exports, "getSortMatchSourceByRelevance", ()=>getSortMatchSourceByRelevance);
parcelHelpers.export(exports, "isPartialMatchAddress", ()=>isPartialMatchAddress);
var _countries = require("../constants/countries");
var _collectionUtils = require("../utils/collectionUtils");
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
var _countriesHelpers = require("./countries.helpers");
const isRDCMatch = (match)=>match.source.source_name === "RiskConnect";
const isNotComplyAdvantageSource = ({ source_key })=>source_key !== "complyadvantage";
function groupMatchAttributesByCode(match) {
    const nationalities = [];
    const citizenships = [];
    const countries_of_incorporations = [];
    const riskography = [];
    const occupations = [];
    const links = [];
    const remarks = [];
    const avatarImages = [];
    const yearOfIncorporations = [];
    match.attributes.forEach((a)=>{
        switch(a.code){
            case "NAT":
                nationalities.push(a);
                break;
            case "CTZ":
                citizenships.push(a);
                break;
            case "COI":
                countries_of_incorporations.push(a);
                break;
            case "SEX":
                break;
            case "RGP":
            case "SUM":
            case "BIO":
                riskography.push(a);
                break;
            case "IMG":
                avatarImages.push(a);
                break;
            case "OCU":
                occupations.push(a);
                break;
            case "URL":
                links.push(a);
                break;
            case "RMK":
                remarks.push(a);
                break;
            case "YOI":
                yearOfIncorporations.push(a);
                break;
            default:
                break;
        }
    });
    return {
        nationalities,
        citizenships,
        countries_of_incorporations,
        riskography,
        occupations,
        links,
        remarks,
        avatarImages,
        yearOfIncorporations
    };
}
const groupCountryAttributes = (attributes, newMatch)=>{
    // group attributes by value
    const attributesMap = (0, _collectionUtils.groupBy)(attributes, (attribute)=>attribute.value);
    const result = [
        ...attributesMap.keys()
    ].map((attributeValue)=>{
        // comply advantage countries are names in english
        const value = (0, _countriesHelpers.searchForCountryCode)(attributeValue, "en") || attributeValue;
        const sourcesKeys = (0, _collectionUtils.first)(attributesMap.get(attributeValue))?.source_key?.split(",");
        const sourcesNames = sourcesKeys?.map((sourceKey)=>sourceKey ? newMatch.sources[sourceKey]?.source_name : undefined).filter(Boolean);
        const is_reviewed = Boolean(attributesMap.get(attributeValue)?.every((attribute)=>attribute.is_reviewed));
        return {
            value,
            sourcesNames,
            is_reviewed
        };
    });
    // sort countries by name/country code but make Norway the first one if it exists
    result.sort((attrA, attrB)=>attrA.value === (0, _countries.DEFAULT_COUNTRY) ? -10 : attrB.value === (0, _countries.DEFAULT_COUNTRY) ? 10 : attrA.value.localeCompare(attrB.value));
    return result;
};
const groupComplyMatchFieldsByDescription = (newMatch)=>{
    // do not use complyadvantage sources
    const externalSources = [
        ...newMatch.sanction_sources,
        ...newMatch.pep_sources
    ];
    const sources = externalSources.map((sourceName)=>newMatch.sources[sourceName]);
    const countriesAttributes = [];
    const nationalitiesAttributes = [];
    sources.forEach((source)=>{
        source.attributes?.forEach((attribute)=>{
            switch(attribute.description){
                case "Country":
                    countriesAttributes.push(attribute);
                    break;
                case "Nationality":
                    nationalitiesAttributes.push(attribute);
                    break;
            }
        });
    });
    const countries = groupCountryAttributes(countriesAttributes, newMatch);
    const nationalities = groupCountryAttributes(nationalitiesAttributes, newMatch);
    return {
        countries,
        nationalities
    };
};
const isConfirmedMatch = (matchCaseDetails)=>matchCaseDetails.status === "RESOLVED" && !(0, _util.isNil)(matchCaseDetails.resolved_by) && matchCaseDetails.reviews.length > 0 && matchCaseDetails.reviews[0].is_match; // first review is the most recent review
const isRejectedMatch = (matchCaseDetails)=>matchCaseDetails.status === "RESOLVED" && !(0, _util.isNil)(matchCaseDetails.resolved_by) && matchCaseDetails.reviews.length > 0 && !matchCaseDetails.reviews[0].is_match; // first review is the most recent review
const isConfirmedMatchCase = (matchCase)=>matchCase.status === "RESOLVED" && matchCase.review?.is_match === true;
const isRejectedMatchCase = (matchCase)=>matchCase.status === "RESOLVED" && matchCase.review?.is_match === false;
const isUnresolvedMatchCase = (match)=>match.status !== "RESOLVED" && (0, _util.isNil)(match.review);
const findNextUnresolvedMatchCase = (matchCases = [], currentMatchCaseId)=>matchCases.find((matchCase)=>matchCase.id !== currentMatchCaseId && isUnresolvedMatchCase(matchCase));
const isEmptyMatchSource = ({ headline, publisher, publication_source, source_url })=>![
        headline,
        publisher,
        publication_source,
        source_url
    ].every((0, _stringUtils.isEmptyString));
const sortBirthDatesByRelevance = (sourceDate)=>{
    if ((0, _util.isNil)(sourceDate)) return undefined;
    return (matchBirthDate1, matchBirthDate2)=>{
        const date1 = matchBirthDate1.value;
        const date2 = matchBirthDate2.value;
        if (date1 === sourceDate) return -10;
        if (date2 === sourceDate) return 10;
        // check if the birthdate starts with a year
        if (sourceDate.startsWith(date1)) return -1;
        if (sourceDate.startsWith(date2)) return 1;
        return date1.localeCompare(date2);
    };
};
const calcAddressProximity = (source, match)=>{
    let proximity = 0;
    if (source.country === match.country_code) proximity += 100;
    if (source.city?.toLocaleLowerCase() === match.city?.toLocaleLowerCase()) proximity += 10;
    // TODO check additional address fields?
    return proximity;
};
const parseMatchAddress = (value)=>{
    const addressParts = [];
    const addressCountries = [];
    value.split(", ").flatMap((part)=>{
        const countryCode = (0, _countriesHelpers.searchForCountryCode)(part, "en");
        if (countryCode) addressCountries.push(countryCode);
        else addressParts.push(part);
    });
    // addresses contains only countries - do not return them
    if (addressParts.length === 0) return undefined;
    return {
        addr1: addressParts.join(", "),
        country_code: (0, _collectionUtils.first)(addressCountries),
        is_reviewed: true
    };
};
const sortAddressesByRelevance = (sourceAddresses)=>{
    if (!(0, _collectionUtils.hasContent)(sourceAddresses)) return undefined;
    return (matchAddress1, matchAddress2)=>{
        const address1Proximity = sourceAddresses.reduce((sum, address)=>sum + calcAddressProximity(address, matchAddress1), 0);
        const address2Proximity = sourceAddresses.reduce((sum, address)=>sum + calcAddressProximity(address, matchAddress2), 0);
        return address2Proximity - address1Proximity;
    };
};
const sortMatchEventByDate = (date1Str, date2Str)=>{
    if (!date1Str) return 100;
    if (!date2Str) return -100;
    const date1 = new Date(date1Str);
    const date2 = new Date(date2Str);
    return date2.getTime() - date1.getTime();
};
const getSortMatchEventByRelevance = (hasNewInfo)=>{
    const sortByRelevance = (match1, match2)=>{
        if (hasNewInfo(match1)) return -1;
        if (hasNewInfo(match2)) return 1;
        return sortMatchEventByDate(match1.amendedDate || match1.date, match2.amendedDate || match2.date);
    };
    return sortByRelevance;
};
const getSortMatchSourceByRelevance = (hasNewInfo)=>{
    const sortByRelevance = (source1, source2)=>{
        if (hasNewInfo(source1)) return -1;
        if (hasNewInfo(source2)) return 1;
        return sortMatchEventByDate(source1.entity_dt, source2.entity_dt);
    };
    return sortByRelevance;
};
const isPartialMatchAddress = (address)=>[
        address.addr1,
        address.addr2,
        address.city,
        address.state_prov
    ].some((part)=>!(0, _stringUtils.isEmptyString)(part));

},{"../constants/countries":"2hBLK","../utils/collectionUtils":"gr5mc","../utils/stringUtils":"4gVdA","../utils/util":"4MniK","./countries.helpers":"1PV4o","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jsRZA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _xmarkCircleSvg = require("../../../assets/icons/xmark-circle.svg");
var _xmarkCircleSvgDefault = parcelHelpers.interopDefault(_xmarkCircleSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _rejectMatchCasesConfirm = require("../RejectMatchCasesConfirm/RejectMatchCasesConfirm");
var _rejectMatchCasesConfirmDefault = parcelHelpers.interopDefault(_rejectMatchCasesConfirm);
const MatchCasesBulkActions = (props)=>{
    const { customerId, customerType, totalMatchCasesCount, selectedMatchCasesIds, readonly, onAfterSuccess } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showRejectConfirm, toggleRejectConfirm, closeRejectConfirm] = (0, _useOpenCloseDefault.default)();
    const bulkActions = [
        {
            content: f("bulk.actions.reject-match-cases.confirmation.title"),
            prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _xmarkCircleSvgDefault.default),
                useMask: true
            }),
            onAction: toggleRejectConfirm,
            disabled: selectedMatchCasesIds.length === 0
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "8",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("match-cases-section.count.label", {
                    count: totalMatchCasesCount,
                    selected: selectedMatchCasesIds.length
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: bulkActions,
                cutoff: 1,
                disabled: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rejectMatchCasesConfirmDefault.default), {
                isOpen: showRejectConfirm,
                customerId: customerId,
                customerType: customerType,
                matchCasesIds: selectedMatchCasesIds,
                onClose: closeRejectConfirm,
                onAfterSuccess: onAfterSuccess
            })
        ]
    });
};
exports.default = MatchCasesBulkActions;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../../assets/icons/xmark-circle.svg":"6JVeg","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../ActionsDropdown/ActionsDropdown":"izRYG","../extensions/Icon":"eHSf0","../RejectMatchCasesConfirm/RejectMatchCasesConfirm":"2GIqm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6JVeg":[function(require,module,exports) {
module.exports = require("581b5e1d7a0640af").getBundleURL("kEMsi") + "xmark-circle.96dbe7f9.svg";

},{"581b5e1d7a0640af":"75UoR"}],"2GIqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _stringUtils = require("../../utils/stringUtils");
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const RejectMatchCasesConfirm = (props)=>{
    const { isOpen, customerId, customerType, matchCasesIds, onClose, onAfterSuccess } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [description, setDescription] = (0, _react.useState)("");
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)({
        id: customerId,
        type: customerType
    });
    const rejectMatchCaseMutation = (0, _reactQuery.useMutation)(({ matchCaseId })=>(0, _apiDefault.default).createMatchReview(customerId, matchCaseId, {
            is_match: false,
            description
        }), {
        onSuccess: (matchReview, { matchCaseId })=>{
            updateQueryData((customerDetails)=>{
                customerDetails.match_cases = customerDetails.match_cases.map((matchCase)=>matchCase.id === matchCaseId ? {
                        ...matchCase,
                        review: matchReview,
                        status: "RESOLVED"
                    } : matchCase);
            });
        }
    });
    const rejectMatchCasesPromise = ()=>Promise.all(matchCasesIds.map((matchCaseId)=>rejectMatchCaseMutation.mutateAsync({
                matchCaseId
            })));
    const handleNo = ()=>{
        setDescription("");
        onClose();
    };
    const handleSuccess = ()=>{
        setDescription("");
        onAfterSuccess();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        isOpen: isOpen,
        apiCall: rejectMatchCasesPromise,
        title: f("bulk.actions.reject-match-cases.confirmation.title"),
        description: f("bulk.actions.reject-match-cases.confirmation.description", {
            count: matchCasesIds.length
        }),
        isDestructive: true,
        isActionDisabled: (0, _stringUtils.isEmptyString)(description),
        actionTitle: f("default.reject"),
        onNo: handleNo,
        onSuccess: handleSuccess,
        useSuccessToast: true,
        successTitle: f("bulk.actions.reject-match-cases.success.message", {
            count: matchCasesIds.length
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
            label: f("matches.labels.review.description.placeholder"),
            autoComplete: "on",
            multiline: 4,
            value: description,
            onChange: setDescription,
            requiredIndicator: true
        })
    });
};
exports.default = RejectMatchCasesConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../utils/stringUtils":"4gVdA","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1YrMn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactTable = require("@tanstack/react-table");
var _matches = require("../../constants/matches");
var _routes = require("../../constants/routes");
var _matchHelpers = require("../../helpers/match.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _matchCaseStatus = require("../MatchCaseStatus/MatchCaseStatus");
var _matchCaseStatusDefault = parcelHelpers.interopDefault(_matchCaseStatus);
var _reactTable1 = require("../ReactTable/ReactTable");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable1);
const MatchCasesTable = (props)=>{
    const { matchCases, customerId, unresolvedMatchCasesCount, selectedIds, onSelectionChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const columns = (0, _react.useMemo)(()=>{
        const columnHelper = (0, _reactTable.createColumnHelper)();
        const columns = [
            columnHelper.accessor("subject_name", {
                header: f("table.column.name")
            }),
            columnHelper.accessor("match_entity_name", {
                header: f("table.column.name-on-match"),
                enableSorting: true
            }),
            columnHelper.accessor("summary_text", {
                header: f("table.column.details"),
                id: "details",
                cell: ({ row, getValue })=>{
                    const matchCase = row.original;
                    const isResolved = matchCase.status === "RESOLVED";
                    const isUpdatedSinceLastReview = matchCase.review && !isResolved ? true : false;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                                url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MATCH_CASE_DETAILS, {
                                    customerId,
                                    id: matchCase.id
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCaseStatusDefault.default), {
                                    isResolved: isResolved,
                                    isConfirmed: (0, _matchHelpers.isConfirmedMatchCase)(matchCase),
                                    isUpdated: isUpdatedSinceLastReview,
                                    children: getValue()
                                })
                            }),
                            matchCase.review && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                children: matchCase.review.is_match ? f("common.labels.confirmed-by", {
                                    name: getUserDisplayName(matchCase.review.reviewed_by),
                                    timestamp: new Date(matchCase.review.created_dt)
                                }) : f("matches.labels.rejected-by", {
                                    name: getUserDisplayName(matchCase.review.reviewed_by),
                                    timestamp: new Date(matchCase.review.created_dt)
                                })
                            })
                        ]
                    });
                }
            }),
            columnHelper.accessor((row)=>row.updated_timestamp || row.timestamp, {
                header: f("table.column.last.updated"),
                id: "last-updated",
                cell: ({ getValue })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                        date: getValue()
                    })
            }),
            columnHelper.accessor("id", {
                header: f("table.column.id"),
                enableSorting: false
            })
        ];
        return columns;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTableDefault.default), {
        columns: columns,
        data: matchCases,
        selectable: unresolvedMatchCasesCount > (0, _matches.MATCH_CASES_BULK_ACTIONS_CUTOFF),
        selectedIds: selectedIds,
        sortLocally: true,
        onSelectionChange: onSelectionChange,
        isRowSelectable: (0, _matchHelpers.isUnresolvedMatchCase),
        getRowId: (row)=>row.id,
        getRowProps: (row)=>(0, _matchHelpers.isConfirmedMatchCase)(row) ? {
                status: "warning"
            } : row.status !== "RESOLVED" ? {
                status: "info"
            } : undefined
    });
};
exports.default = MatchCasesTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-table":"86D8M","../../constants/matches":"gcrL3","../../constants/routes":"ihtm8","../../helpers/match.helpers":"4U2lJ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../CondensedText/CondensedText":"1FshD","../CustomDate/CustomDate":"5KD00","../MatchCaseStatus/MatchCaseStatus":"4RV38","../ReactTable/ReactTable":"iNTSb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4RV38":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _circleCrossSvg = require("../../../assets/icons/circle-cross.svg");
var _circleCrossSvgDefault = parcelHelpers.interopDefault(_circleCrossSvg);
var _triangleFilledExclamationSvg = require("../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
const MatchCaseStatus = (props)=>{
    const { isUpdated, isResolved, isConfirmed, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMatchCaseStatus, {
        isResolved: isResolved,
        isConfirmed: isConfirmed,
        children: [
            children,
            isUpdated && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
        ]
    });
};
const StyledMatchCaseStatus = (0, _styledComponentsDefault.default).div`
  display: flex;
  align-items: center;

  &::before {
    background-image: url(${(props)=>props.isConfirmed ? (0, _triangleFilledExclamationSvgDefault.default) : (0, _circleCrossSvgDefault.default)});
    display: none;
  }

  ${(props)=>props.isResolved && `&::before {
      content: " ";
      display: inline-block;
      width: 20px;
      height: 20px;
      background-size: contain;
      margin-right: 8px;
      padding-right: 15px;
      background-position: center;
      background-repeat: no-repeat;
    }`}
`;
exports.default = MatchCaseStatus;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","../../../assets/icons/circle-cross.svg":"daUCT","../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../NewInfoBadge/NewInfoBadge":"7fmsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7fmsH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
const NewInfoBadge = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
        status: "info",
        size: "xsmall",
        children: f("common.badge.new-info")
    });
};
exports.default = NewInfoBadge;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","../extensions/Badge":"9irVp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gcWt1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const PossibleMatchBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        title: f("common.banner.possible.match.description"),
        status: "warning"
    });
};
exports.default = PossibleMatchBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bnK0k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const ScreeningStartedBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        status: "info",
        hideIcon: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                    size: "small"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "semibold",
                            children: f("details.banners.screening.in.progress.title")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: f("details.banners.screening.in.progress.content")
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = ScreeningStartedBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5g4hf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _ownershipUpdatesHelpers = require("../../helpers/ownership-updates.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _addOwnerButton = require("../AddOwnerButton/AddOwnerButton");
var _addOwnerButtonDefault = parcelHelpers.interopDefault(_addOwnerButton);
var _addRoleButton = require("../AddRoleButton/AddRoleButton");
var _addRoleButtonDefault = parcelHelpers.interopDefault(_addRoleButton);
var _companyOwners = require("../CompanyOwners/CompanyOwners");
var _companyOwnersDefault = parcelHelpers.interopDefault(_companyOwners);
var _companyOwnersHeaderHelpers = require("../CompanyOwners/CompanyOwnersHeader/CompanyOwnersHeader.helpers");
var _companyRoles = require("../CompanyRoles/CompanyRoles");
var _companyRolesDefault = parcelHelpers.interopDefault(_companyRoles);
var _kdktabs = require("../KDKTabs/KDKTabs");
var _kdktabsDefault = parcelHelpers.interopDefault(_kdktabs);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
const OWNERS_TAB_INDEX = 0;
const ROLES_TAB_INDEX = 1;
const RolesAndOwnersSection = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [selectedTabIndex, setSelectedTabIndex] = (0, _react.useState)(OWNERS_TAB_INDEX);
    const hasNewRoles = customer.roles.some((role)=>role.is_new);
    const showOwnersIndicator = (0, _ownershipUpdatesHelpers.hasOwnershipUpdates)(customer) || customer.has_outstanding_shares || (0, _companyOwnersHeaderHelpers.hasMultipleShareClasses)(customer.share_classes);
    const ownersTabTitle = (0, _stringUtils.appendCounter)(f("company.owners.title"), customer.beneficial_owners.filter((owner)=>!owner.deleted).length);
    const rolesTabTitle = (0, _stringUtils.appendCounter)(f("company.roles.title"), customer.roles.length);
    const tabs = [
        {
            id: "owners",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "bold",
                        children: ownersTabTitle
                    }),
                    showOwnersIndicator && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                ]
            })
        },
        {
            id: "roles",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "bold",
                        children: rolesTabTitle
                    }),
                    hasNewRoles && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                ]
            })
        }
    ];
    const screeningRoles = (customer.screening?.roles || []).map((role)=>role.role);
    const screeningOwners = (customer.screening?.beneficial_owners || []).map((beneficialOwner)=>beneficialOwner.owner);
    const isScreeningActive = customer.screening_status.screening_type === "MONITORING" && customer.screening_status.screening_status !== "DONE";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            selectedTabIndex === OWNERS_TAB_INDEX && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addOwnerButtonDefault.default), {
                customer: customer,
                readonly: readonly
            }),
            selectedTabIndex === ROLES_TAB_INDEX && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addRoleButtonDefault.default), {
                customer: customer,
                readonly: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _kdktabsDefault.default), {
                tabs: tabs,
                selected: selectedTabIndex,
                onSelect: setSelectedTabIndex,
                children: [
                    selectedTabIndex === OWNERS_TAB_INDEX && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyOwnersDefault.default), {
                        customer: customer,
                        readonly: readonly,
                        screeningOwners: screeningOwners,
                        isScreeningActive: isScreeningActive,
                        hideAddButton: true
                    }),
                    selectedTabIndex === ROLES_TAB_INDEX && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyRolesDefault.default), {
                        customer: customer,
                        readonly: readonly,
                        screeningRoles: screeningRoles,
                        isScreeningActive: isScreeningActive,
                        hideTitle: true,
                        hideAddButton: true
                    })
                ]
            })
        ]
    });
};
exports.default = RolesAndOwnersSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/ownership-updates.helpers":"cO78v","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../AddOwnerButton/AddOwnerButton":"6jUQo","../AddRoleButton/AddRoleButton":"MGXbC","../CompanyOwners/CompanyOwners":"36XXm","../CompanyOwners/CompanyOwnersHeader/CompanyOwnersHeader.helpers":"6o9Ax","../CompanyRoles/CompanyRoles":"j1clH","../KDKTabs/KDKTabs":"hryzj","../NewInfoBadge/NewInfoBadge":"7fmsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cO78v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasOwnershipUpdates", ()=>hasOwnershipUpdates);
const hasOwnershipUpdates = (customer)=>Boolean(customer.unhandled_ownership_updates && customer.unhandled_ownership_updates > 0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6jUQo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _personHelpers = require("../../helpers/person.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../utils/util");
var _useCompanyOwners = require("../CompanyOwners/useCompanyOwners");
var _useCompanyOwnersDefault = parcelHelpers.interopDefault(_useCompanyOwners);
var _floatPrimaryButton = require("../FloatPrimaryButton/FloatPrimaryButton");
var _floatPrimaryButtonDefault = parcelHelpers.interopDefault(_floatPrimaryButton);
var _ownerModal = require("../OwnerModal/OwnerModal");
var _ownerModalDefault = parcelHelpers.interopDefault(_ownerModal);
const AddOwnerButton = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { handleOwnerCreate } = (0, _useCompanyOwnersDefault.default)(customer);
    const [owner, setOwner] = (0, _react.useState)();
    const openModal = ()=>setOwner((0, _personHelpers.createNewOwner)(customer.country));
    const closeModal = ()=>setOwner(undefined);
    const handleCreateOwner = (newOwner)=>{
        handleOwnerCreate(newOwner);
        closeModal();
    };
    const disabled = readonly || !customer.is_manual && !customer.can_have_shareholders;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _floatPrimaryButtonDefault.default), {
                onClick: openModal,
                disabled: disabled,
                children: f("owners.card.buttons.add-owner")
            }),
            owner && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownerModalDefault.default), {
                customerId: customer.id,
                ownerData: owner,
                isArchiveDisabled: false,
                onArchive: (0, _util.noop),
                onUpdate: (0, _util.noop),
                onCreate: handleCreateOwner,
                onClose: closeModal
            })
        ]
    });
};
exports.default = AddOwnerButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../helpers/person.helpers":"6qOIE","../../hooks/useFormatMessage":"8Y8fq","../../utils/util":"4MniK","../CompanyOwners/useCompanyOwners":"eM3ID","../FloatPrimaryButton/FloatPrimaryButton":"c9hvU","../OwnerModal/OwnerModal":"fch5O","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eM3ID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _useConvertToDeletedEntity = require("../../hooks/useConvertToDeletedEntity");
var _useConvertToDeletedEntityDefault = parcelHelpers.interopDefault(_useConvertToDeletedEntity);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../types/utilities");
var _collectionUtils = require("../../utils/collectionUtils");
const UPDATE_TYPE_SORT_VALUE = {
    ADDED: 1,
    UPDATED: 2,
    DELETED: 3
};
// sort ownership updates by their type: ADDED first, then UPDATED and lastly DELETED
const sortOwnershipUpdatesByUpdateType = (updates)=>updates.filter(Boolean).sort((updateA, updateB)=>UPDATE_TYPE_SORT_VALUE[updateA.update_type] - UPDATE_TYPE_SORT_VALUE[updateB.update_type]);
// ownership update of type ADDED do not have an owner_id - so use the update.id as the owner.id
// until the ownership update is confirmed or rejected
const getOwnershipUpdateOwnerId = (update)=>update.update_type === "ADDED" ? update.id : update.owner_id;
/*
 * Merges an existing owner (if exists) with an ownership update to display values from the update
 * This is used to show updates info (for example, Added owner) in the OwnersTable.
 * If the owner exists - return the owner with info from the update.
 * Otherwise, create an owner from the update info
 */ const mergeOwnershipUpdateWithOwner = (update, existingOwner)=>Object.assign({}, existingOwner, {
        id: getOwnershipUpdateOwnerId(update),
        person: Object.assign({}, existingOwner?.person, {
            id: existingOwner?.person?.id,
            first_name: update.first_name,
            last_name: update.last_name,
            birth_year: update.birth_year,
            country_of_residence: update.country_code
        }),
        percent_share: update.update_type === "DELETED" ? existingOwner?.percent_share : update.field_changes.find((change)=>change.field_name === "percent_share")?.new,
        is_ubo: update.is_ubo
    });
const useCompanyOwners = (customer)=>{
    const { beneficial_owners } = customer;
    const queryClient = (0, _reactQuery.useQueryClient)();
    const convertToArchivedEntity = (0, _useConvertToDeletedEntityDefault.default)();
    const updates = sortOwnershipUpdatesByUpdateType(customer.updates.ownership || []);
    const getOwnershipUpdate = (0, _react.useCallback)((owner)=>updates.find((update)=>getOwnershipUpdateOwnerId(update) === owner.id), [
        updates
    ]);
    const { updateQueryData } = (0, _useQueryDataDefault.default)((0, _utilities.getCustomerQueryKey)(customer));
    const [showArchivedOwners, toggleArchivedOwners] = (0, _useOpenCloseDefault.default)(updates.length > 0);
    // sort owners by ownership updates first, then owners without updates
    const owners = [
        ...updates.map((update)=>mergeOwnershipUpdateWithOwner(update, beneficial_owners.find((owner)=>owner.id === update.owner_id))),
        ...beneficial_owners.filter((owner)=>!getOwnershipUpdate(owner))
    ];
    const ownersToDisplay = showArchivedOwners ? owners : owners.filter((owner)=>!owner.deleted);
    const hasArchivedOwners = owners.find((owner)=>owner.deleted);
    const handleOwnerCreate = (newOwner)=>{
        updateQueryData((companyDetails)=>companyDetails.beneficial_owners = [
                newOwner,
                ...companyDetails.beneficial_owners
            ]);
    };
    const handleOwnerUpdate = (updatedOwner)=>{
        updateQueryData((companyDetails)=>companyDetails.beneficial_owners = (0, _collectionUtils.updateItem)(companyDetails.beneficial_owners, updatedOwner));
        // invalidate the entire customer query in case the owner pep/sanctioned properties were changed
        // which could also change the roles if the owner also has a role in the company
        queryClient.invalidateQueries((0, _utilities.getCustomerQueryKey)(customer));
    };
    const handleOwnerArchive = (ownerId)=>{
        updateQueryData((companyDetails)=>companyDetails.beneficial_owners = companyDetails.beneficial_owners.map((currentOwner)=>currentOwner.id === ownerId ? {
                    ...convertToArchivedEntity(currentOwner),
                    deleted: true
                } : currentOwner));
    };
    const handleOwnershipUpdateReject = (update)=>{
        updateQueryData((companyDetails)=>{
            // remove update from updates list
            companyDetails.updates.ownership = companyDetails.updates.ownership?.filter((prevUpdate)=>prevUpdate.id !== update.id);
            if (update.update_type === "ADDED") // for ADDED owners - remove them from the owners table using their full name because their ID are null
            companyDetails.beneficial_owners = companyDetails.beneficial_owners.filter((owner)=>getOwnershipUpdateOwnerId(update) !== owner.id);
            else // for UPDATED or DELETED owners - revert to the original owner from beneficial_owners
            companyDetails.beneficial_owners = companyDetails.beneficial_owners.map((owner)=>update.owner_id !== owner.id ? owner : beneficial_owners.find((owner)=>owner.id === update.owner_id));
        });
    };
    const handleOwnershipUpdateConfirm = (update, updatedOwner)=>{
        updateQueryData((companyDetails)=>{
            // remove update from updates list
            companyDetails.updates.ownership = companyDetails.updates.ownership?.filter((prevUpdate)=>prevUpdate.id !== update.id);
            // update owner with updatedOwner
            companyDetails.beneficial_owners = (0, _collectionUtils.updateItem)(companyDetails.beneficial_owners, updatedOwner);
        });
    };
    return {
        owners: ownersToDisplay,
        hasArchivedOwners,
        showArchivedOwners,
        toggleArchivedOwners,
        getOwnershipUpdate,
        handleOwnerCreate,
        handleOwnerUpdate,
        handleOwnerArchive,
        handleOwnershipUpdateReject,
        handleOwnershipUpdateConfirm
    };
};
exports.default = useCompanyOwners;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../../hooks/useConvertToDeletedEntity":"auV9w","../../hooks/useOpenClose":"idooG","../../hooks/useQueryData":"4laI9","../../types/utilities":"6zLpB","../../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"auV9w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
const convertAuthUserToUser = ({ id, email, first_name, last_name, groups })=>({
        id,
        email,
        first_name,
        last_name,
        is_active: true,
        groups: groups?.map((group)=>group.id) || []
    });
function useConvertToDeletedEntity() {
    const { user: currentUser } = (0, _useAuthDefault.default)();
    const updated_by = convertAuthUserToUser(currentUser);
    const convertToDeletedEntity = (entity)=>{
        const updated_dt = new Date().toISOString();
        return {
            ...entity,
            updated_by,
            updated_dt
        };
    };
    return convertToDeletedEntity;
}
exports.default = useConvertToDeletedEntity;

},{"./useAuth":"k9r0q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"MGXbC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _personHelpers = require("../../helpers/person.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../types/utilities");
var _util = require("../../utils/util");
var _floatPrimaryButton = require("../FloatPrimaryButton/FloatPrimaryButton");
var _floatPrimaryButtonDefault = parcelHelpers.interopDefault(_floatPrimaryButton);
var _roleModal = require("../RoleModal/RoleModal");
var _roleModalDefault = parcelHelpers.interopDefault(_roleModal);
const AddRoleButton = (props)=>{
    const { customer, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)((0, _utilities.getCustomerQueryKey)(customer));
    const [modalRole, setModalRole] = (0, _react.useState)();
    const openModal = ()=>setModalRole((0, _personHelpers.createNewRole)(customer.country));
    const closeModal = ()=>setModalRole(undefined);
    const handleCreateRole = (createdRole)=>{
        updateQueryData((queryData)=>queryData.roles = queryData.roles.concat(createdRole));
        closeModal();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _floatPrimaryButtonDefault.default), {
                onClick: openModal,
                disabled: readonly,
                children: f("screening.buttons.add-role")
            }),
            modalRole && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleModalDefault.default), {
                customer: customer,
                dataRole: modalRole,
                onClose: closeModal,
                isDeleteDisabled: true,
                onCreate: handleCreateRole,
                onUpdate: (0, _util.noop),
                onDelete: (0, _util.noop)
            })
        ]
    });
};
exports.default = AddRoleButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../helpers/person.helpers":"6qOIE","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../types/utilities":"6zLpB","../../utils/util":"4MniK","../FloatPrimaryButton/FloatPrimaryButton":"c9hvU","../RoleModal/RoleModal":"ijQn9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"36XXm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _ownersCard = require("../OwnersCard/OwnersCard");
var _ownersCardDefault = parcelHelpers.interopDefault(_ownersCard);
var _companyOwnersHeader = require("./CompanyOwnersHeader/CompanyOwnersHeader");
var _companyOwnersHeaderDefault = parcelHelpers.interopDefault(_companyOwnersHeader);
var _useCompanyOwners = require("./useCompanyOwners");
var _useCompanyOwnersDefault = parcelHelpers.interopDefault(_useCompanyOwners);
const CompanyOwners = (props)=>{
    const { customer, screeningOwners = [], readonly, isScreeningActive, hideAddButton } = props;
    const { owners, hasArchivedOwners, showArchivedOwners, toggleArchivedOwners, getOwnershipUpdate, handleOwnerCreate, handleOwnerUpdate, handleOwnerArchive, handleOwnershipUpdateReject, handleOwnershipUpdateConfirm } = (0, _useCompanyOwnersDefault.default)(customer);
    const f = (0, _useFormatMessageDefault.default)();
    const [isConfirmAllLoading, setIsConfirmAllLoading] = (0, _react.useState)(false);
    const [ownershipViewType, setOwnershipViewType] = (0, _react.useState)("table");
    const isArchiveDisabled = (ownerId)=>isScreeningActive && Boolean(screeningOwners.find((screeningOwner)=>screeningOwner.id === ownerId));
    const screenedOwnersIds = isScreeningActive ? screeningOwners.map((owner)=>owner.id) : undefined;
    const handleConfirmAllOwnershipUpdates = (confirmingAllOwnershipUpdates)=>{
        setIsConfirmAllLoading(confirmingAllOwnershipUpdates);
    };
    const showArchivedOwnersToggle = hasArchivedOwners && ownershipViewType === "table";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyOwnersHeaderDefault.default), {
                customer: customer,
                onConfirmAllLoading: handleConfirmAllOwnershipUpdates
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownersCardDefault.default), {
                customer: customer,
                owners: owners,
                allowOwnershipTree: true,
                readonly: readonly || isConfirmAllLoading,
                hideAddButton: hideAddButton,
                isArchiveDisabled: isArchiveDisabled,
                screenedOwnersIds: screenedOwnersIds,
                getOwnershipUpdate: getOwnershipUpdate,
                onArchive: handleOwnerArchive,
                onUpdate: handleOwnerUpdate,
                onCreate: handleOwnerCreate,
                onOwnershipUpdateReject: handleOwnershipUpdateReject,
                onOwnershipUpdateConfirm: handleOwnershipUpdateConfirm,
                onViewTypeChange: setOwnershipViewType
            }),
            showArchivedOwnersToggle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    disclosure: showArchivedOwners ? "up" : "down",
                    onClick: toggleArchivedOwners,
                    children: showArchivedOwners ? f("company.owners.hide-historical-owners") : f("company.owners.view-historical-owners")
                })
            })
        ]
    });
};
exports.default = CompanyOwners;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","../OwnersCard/OwnersCard":"f1O1W","./CompanyOwnersHeader/CompanyOwnersHeader":"106rZ","./useCompanyOwners":"eM3ID","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"106rZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _ownershipUpdatesHelpers = require("../../../helpers/ownership-updates.helpers");
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../../types/utilities");
var _errorPanel = require("../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _companyFinishedOwnershipUpdatesBanner = require("./CompanyFinishedOwnershipUpdatesBanner");
var _companyFinishedOwnershipUpdatesBannerDefault = parcelHelpers.interopDefault(_companyFinishedOwnershipUpdatesBanner);
var _companyOwnersHeaderHelpers = require("./CompanyOwnersHeader.helpers");
var _companyOwnershipUpdatesBanner = require("./CompanyOwnershipUpdatesBanner");
var _companyOwnershipUpdatesBannerDefault = parcelHelpers.interopDefault(_companyOwnershipUpdatesBanner);
var _outstandingSharesBanner = require("./OutstandingSharesBanner");
var _outstandingSharesBannerDefault = parcelHelpers.interopDefault(_outstandingSharesBanner);
var _ownershipUpdatesCompleteModal = require("./OwnershipUpdatesCompleteModal");
var _ownershipUpdatesCompleteModalDefault = parcelHelpers.interopDefault(_ownershipUpdatesCompleteModal);
var _sharesClassesBanner = require("./SharesClassesBanner");
var _sharesClassesBannerDefault = parcelHelpers.interopDefault(_sharesClassesBanner);
const CompanyOwnersHeader = (props)=>{
    const { customer, onConfirmAllLoading } = props;
    const { updateQueryData } = (0, _useQueryDataDefault.default)((0, _utilities.getCustomerQueryKey)(customer));
    const [isConfirmedAllModalOpen, toggleConfirmedAllModal, closeConfirmedAllModal] = (0, _useOpenCloseDefault.default)();
    const confirmAllOwnershipUpdatesMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).confirmAllOwnershipUpdates(customer.id), {
        onMutate: ()=>onConfirmAllLoading(true),
        onSuccess: (updatedOwners)=>{
            updateQueryData((queryData)=>{
                queryData.beneficial_owners = updatedOwners.owners;
                queryData.updates.ownership = [];
            });
            toggleConfirmedAllModal();
            onConfirmAllLoading(false);
        }
    });
    // ownershipUpdatesExist means that the company has unhandled_ownership_updates > 0
    const ownershipUpdatesExist = (0, _ownershipUpdatesHelpers.hasOwnershipUpdates)(customer);
    // hasUnresolvedOwnersUpdates means that there are one or more updates in updates.ownership
    const hasUnresolvedOwnersUpdates = ownershipUpdatesExist && Boolean(customer.updates.ownership && customer.updates.ownership.length > 0);
    // finishedResolvingOwnershipUpdates - the company HAD ownership updates and they were all resolved
    const finishedResolvingOwnershipUpdates = ownershipUpdatesExist && !hasUnresolvedOwnersUpdates;
    const showSharesClassesBanner = (0, _companyOwnersHeaderHelpers.hasMultipleShareClasses)(customer.share_classes);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            customer.has_outstanding_shares && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outstandingSharesBannerDefault.default), {
                outstandingShares: customer.outstanding_share_count,
                totalShares: customer.total_share_count
            }),
            showSharesClassesBanner && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharesClassesBannerDefault.default), {
                customer: customer
            }),
            ownershipUpdatesExist && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    hasUnresolvedOwnersUpdates && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyOwnershipUpdatesBannerDefault.default), {
                        disabled: !hasUnresolvedOwnersUpdates,
                        loading: confirmAllOwnershipUpdatesMutation.isLoading,
                        onConfirmAll: ()=>confirmAllOwnershipUpdatesMutation.mutate()
                    }),
                    finishedResolvingOwnershipUpdates && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyFinishedOwnershipUpdatesBannerDefault.default), {}),
                    confirmAllOwnershipUpdatesMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: confirmAllOwnershipUpdatesMutation.error
                    })
                ]
            }),
            isConfirmedAllModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownershipUpdatesCompleteModalDefault.default), {
                customerId: customer.id,
                onClose: closeConfirmedAllModal
            })
        ]
    });
};
exports.default = CompanyOwnersHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../api":"f6lXD","../../../helpers/ownership-updates.helpers":"cO78v","../../../hooks/useOpenClose":"idooG","../../../hooks/useQueryData":"4laI9","../../../types/utilities":"6zLpB","../../ErrorPanel/ErrorPanel":"2hHqH","./CompanyFinishedOwnershipUpdatesBanner":"4HFOr","./CompanyOwnersHeader.helpers":"6o9Ax","./CompanyOwnershipUpdatesBanner":"29Fzy","./OutstandingSharesBanner":"ksSvj","./OwnershipUpdatesCompleteModal":"76Udl","./SharesClassesBanner":"gVHOo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4HFOr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CompanyFinishedOwnershipUpdatesBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "info",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            variant: "bodyMd",
            as: "span",
            fontWeight: "semibold",
            children: f("ownership-update.banner.finished.description")
        })
    });
};
exports.default = CompanyFinishedOwnershipUpdatesBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6o9Ax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasMultipleShareClasses", ()=>hasMultipleShareClasses);
const hasMultipleShareClasses = (shareClasses)=>Boolean(shareClasses && shareClasses.length > 1);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"29Fzy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _checkmarkSvg = require("../../../../assets/icons/checkmark.svg");
var _checkmarkSvgDefault = parcelHelpers.interopDefault(_checkmarkSvg);
var _ownershipUpdates = require("../../../constants/ownership-updates");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useRichFormatMessage = require("../../../hooks/useRichFormatMessage");
var _useRichFormatMessageDefault = parcelHelpers.interopDefault(_useRichFormatMessage);
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CompanyOwnershipUpdatesBanner = (props)=>{
    const { disabled, loading, onConfirmAll } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const richFormatMessage = (0, _useRichFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "info",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: richFormatMessage("ownership-update.banner.description", {
                        year: (0, _ownershipUpdates.LATEST_OWNERSHIP_REGISTRY_RECORD_YEAR)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        icon: (0, _checkmarkSvgDefault.default),
                        disabled: disabled,
                        loading: loading,
                        onClick: onConfirmAll,
                        children: f("ownership-update.actions.labels.confirm-all-updates")
                    })
                })
            ]
        })
    });
};
exports.default = CompanyOwnershipUpdatesBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../assets/icons/checkmark.svg":"hrEpz","../../../constants/ownership-updates":"k1X7w","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useRichFormatMessage":"6rmtK","../../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ksSvj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useRichFormatMessage = require("../../../hooks/useRichFormatMessage");
var _useRichFormatMessageDefault = parcelHelpers.interopDefault(_useRichFormatMessage);
const OutstandingSharesBanner = (props)=>{
    const { outstandingShares = 0, totalShares = 0 } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const richFormat = (0, _useRichFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "warning",
        title: f("outstanding-shares.banner.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledContent, {
            children: richFormat("outstanding-shares.banner.description", {
                outstandingShares,
                totalShares
            })
        })
    });
};
const StyledContent = (0, _styledComponentsDefault.default).p`
  white-space: pre-wrap;
`;
exports.default = OutstandingSharesBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useRichFormatMessage":"6rmtK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"76Udl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../../constants/routes");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirm = require("../../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
const OwnershipUpdatesCompleteModal = (props)=>{
    const { customerId, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const navigateToCustomerScreening = ()=>history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_CHANGE_SCREENING, {
            id: customerId
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
        title: f("ownership-update.confirm-all.modal.title"),
        description: f("ownership-update.confirm-all.modal.content"),
        onYes: navigateToCustomerScreening,
        onNo: onClose,
        isDestructive: false,
        cancelTitle: f("default.close"),
        actionTitle: f("ownership-update.confirm-all.modal.action.label")
    });
};
exports.default = OwnershipUpdatesCompleteModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../../../constants/routes":"ihtm8","../../../hooks/useFormatMessage":"8Y8fq","../../Confirm/Confirm":"nqTPc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gVHOo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _externalUrls = require("../../../constants/external-urls");
var _displayHelpers = require("../../../helpers/display.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const SharesClassesBanner = (props)=>{
    const { customer } = props;
    const { share_classes = [] } = customer;
    const f = (0, _useFormatMessageDefault.default)();
    const sharesDisplayName = share_classes.map((shareClass)=>f(`common.share-class.${shareClass}`)).filter(Boolean).join(" + ") || "-";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Banner), {
        status: "warning",
        title: f("shares-classes.banner.title", {
            shares: sharesDisplayName
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledContent, {
                children: f("shares-classes.banner.description", {
                    name: (0, _displayHelpers.getCustomerName)(customer)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                url: (0, _externalUrls.SHARES_CLASSES_SUPPORT_PAGE),
                external: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLink, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        fontWeight: "semibold",
                        children: f("shares-classes.banner.url-label")
                    })
                })
            })
        ]
    });
};
const StyledContent = (0, _styledComponentsDefault.default).p`
  white-space: pre-wrap;
`;
const StyledLink = (0, _styledComponentsDefault.default).span`
  color: var(--p-interactive);
`;
exports.default = SharesClassesBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../constants/external-urls":"bvBLe","../../../helpers/display.helpers":"2q3xY","../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j1clH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _customerHelpers = require("../../helpers/customer.helpers");
var _useConvertToDeletedEntity = require("../../hooks/useConvertToDeletedEntity");
var _useConvertToDeletedEntityDefault = parcelHelpers.interopDefault(_useConvertToDeletedEntity);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../types/utilities");
var _collectionUtils = require("../../utils/collectionUtils");
var _rolesCard = require("../RolesCard/RolesCard");
var _rolesCardDefault = parcelHelpers.interopDefault(_rolesCard);
const CompanyRoles = (props)=>{
    const { customer, screeningRoles = [], readonly, isScreeningActive, hideTitle, hideAddButton } = props;
    const { roles, expired_roles, company_type } = customer;
    const [showExpiredRoles, setShowExpiredRoles] = (0, _react.useState)(false);
    const f = (0, _useFormatMessageDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const language = (0, _useLanguageDefault.default)();
    const convertToDeletedEntity = (0, _useConvertToDeletedEntityDefault.default)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)((0, _utilities.getCustomerQueryKey)(customer));
    const toggleShowExpiredRoles = ()=>setShowExpiredRoles(!showExpiredRoles);
    const getRoleScreeningType = (roleId)=>{
        if (!isScreeningActive) return undefined;
        if (screeningRoles.find((screeningRole)=>screeningRole.id === roleId)) return "MONITORING";
        else return "NONE";
    };
    const rowsToDisplay = showExpiredRoles ? [
        ...roles,
        ...expired_roles
    ] : roles;
    const buttonLabel = showExpiredRoles ? f("roles.button.labels.hide-expired-roles") : f("roles.button.labels.show-expired-roles", {
        count: expired_roles.length
    });
    const handleCreateRole = (createdRole)=>{
        updateQueryData((queryData)=>queryData.roles = queryData.roles.concat(createdRole));
    };
    const handleUpdatedRole = (updatedRole)=>{
        updateQueryData((queryData)=>queryData.roles = (0, _collectionUtils.updateItem)(queryData.roles, updatedRole));
        // invalidate the entire customer query in case the role pep/sanctioned properties were changed
        // which could also change the roles if the role is also an owner of the company
        queryClient.invalidateQueries((0, _utilities.getCustomerQueryKey)(customer));
    };
    const handleDeleteRole = (deletedRoleId)=>updateQueryData((queryData)=>{
            const deletedRole = queryData.roles.find((role)=>role.id === deletedRoleId);
            if (deletedRole) queryData.expired_roles = [
                convertToDeletedEntity(deletedRole),
                ...queryData.expired_roles
            ];
            queryData.roles = queryData.roles.filter((role)=>role.id !== deletedRoleId);
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                gap: "4",
                children: !hideTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "headingMd",
                    as: "h2",
                    children: f("company.roles.title")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rolesCardDefault.default), {
                customer: customer,
                roles: rowsToDisplay,
                readonly: readonly,
                expiredRoles: expired_roles.map((role)=>role.id),
                companyCountry: customer.country,
                hideAddButton: hideAddButton,
                showUpdates: true,
                companyType: (0, _customerHelpers.getCompanyType)(language, company_type),
                getRoleScreeningType: (role)=>getRoleScreeningType(role.id),
                getIsDeleteDisabled: (roleId)=>getRoleScreeningType(roleId) === "MONITORING",
                onCreate: handleCreateRole,
                onUpdate: handleUpdatedRole,
                onDelete: handleDeleteRole
            }),
            expired_roles.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    onClick: toggleShowExpiredRoles,
                    textAlign: "left",
                    disclosure: showExpiredRoles ? "up" : "down",
                    children: buttonLabel
                })
            })
        ]
    });
};
exports.default = CompanyRoles;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../helpers/customer.helpers":"dkhe3","../../hooks/useConvertToDeletedEntity":"auV9w","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useLanguage":"2W6IE","../../hooks/useQueryData":"4laI9","../../types/utilities":"6zLpB","../../utils/collectionUtils":"gr5mc","../RolesCard/RolesCard":"7Zoco","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hSjF4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _screening = require("../helpers/screening");
var _utilities = require("../types/utilities");
const CUSTOMER_DETAILS_REFRESH_RETRIES_LIMIT = 5;
const CUSTOMER_DETAILS_REFRESH_RETRIES_DELAY = 2000;
// Refresh the customer details query cache in case the customer screening has not been finished and the customer
// is not archived in order to get the customer details after screening is finished without the user needing to
// manually refresh the page.
// This is done by calling invalidateCustomerDetails() up to 5 times max (and with a delay of 2 seconds between each retry)
const useCustomerDetailsRefresh = (customerDetails)=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [retriesCount, setRetriesCount] = (0, _react.useState)(0);
    const queryKey = (0, _utilities.getCustomerQueryKey)(customerDetails);
    const isScreeningStarted = (0, _screening.isScreeningStarting)(customerDetails.screening);
    const invalidateCustomerDetails = async ()=>await queryClient.invalidateQueries(queryKey);
    (0, _react.useEffect)(()=>{
        if (customerDetails.is_archived || !isScreeningStarted || retriesCount > CUSTOMER_DETAILS_REFRESH_RETRIES_LIMIT) return;
        const timeoutHandle = setTimeout(()=>{
            invalidateCustomerDetails().then(()=>setRetriesCount((prevCount)=>prevCount + 1));
        }, CUSTOMER_DETAILS_REFRESH_RETRIES_DELAY);
        return ()=>{
            if (timeoutHandle) clearTimeout(timeoutHandle);
        };
    }, [
        queryKey,
        customerDetails.is_archived,
        isScreeningStarted,
        retriesCount
    ]);
};
exports.default = useCustomerDetailsRefresh;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../helpers/screening":"aJP5k","../types/utilities":"6zLpB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"32RC4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addItemButton = require("../../components/AddItemButton/AddItemButton");
var _addItemButtonDefault = parcelHelpers.interopDefault(_addItemButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _companyDisclosureSignatureForm = require("../../components/CompanyDisclosureSignatureForm/CompanyDisclosureSignatureForm");
var _companyDisclosureSignatureFormDefault = parcelHelpers.interopDefault(_companyDisclosureSignatureForm);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _onboardingWizardPageSkeleton = require("../../components/OnboardingWizardPageSkeleton/OnboardingWizardPageSkeleton");
var _onboardingWizardPageSkeletonDefault = parcelHelpers.interopDefault(_onboardingWizardPageSkeleton);
var _roleModal = require("../../components/RoleModal/RoleModal");
var _roleModalDefault = parcelHelpers.interopDefault(_roleModal);
var _queriesKeys = require("../../constants/queries-keys");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _displayHelpers = require("../../helpers/display.helpers");
var _personHelpers = require("../../helpers/person.helpers");
var _useCustomerDetailsBackButton = require("../../hooks/useCustomerDetailsBackButton");
var _useCustomerDetailsBackButtonDefault = parcelHelpers.interopDefault(_useCustomerDetailsBackButton);
var _useDisclosureAssignment = require("../../hooks/useDisclosureAssignment");
var _useDisclosureAssignmentDefault = parcelHelpers.interopDefault(_useDisclosureAssignment);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _util = require("../../utils/util");
const CompanyRequestDisclosuresPage = ({ data })=>{
    const { id, assignmentId } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const updateCompanyQueryData = (0, _useQueryData.useCustomerDetailsQueryData)({
        id,
        type: "company"
    });
    const { updateQueryData: updateAssignmentQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ASSIGNMENT_DETAILS,
        id,
        assignmentId
    ]);
    const [signatures, setSignatures] = (0, _react.useState)(new Map());
    const [possibleSignatureRoles, setPossibleSignatureRoles] = (0, _react.useState)(data.possible_signers || []);
    const [isFormValid, setFormValid] = (0, _react.useState)(false);
    const [roleModal, setRoleModal] = (0, _react.useState)();
    const { data: companyDetails } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_DETAILS,
        id
    ], ()=>(0, _apiDefault.default).getCompanyCustomerDetails(id));
    const assignments = companyDetails?.assignments?.filter((assignment)=>(0, _assignmentsHelpers.isActiveAssignment)(assignment) || assignment.id === assignmentId);
    const { selectedAssignment, setSelectedAssignment, shouldUpdateAssignment, updateAssignmentMutation } = (0, _useDisclosureAssignmentDefault.default)(companyDetails?.id, assignmentId, assignments);
    // if features.ASSIGNMENTS__HIDE_DETAILS is enabled, do not use the assignment id to return to the
    // assignment details page since it is going to be hidden
    const { backButtonURL } = (0, _useCustomerDetailsBackButtonDefault.default)(id, "company", features.ASSIGNMENTS__HIDE_DETAILS ? undefined : selectedAssignment?.id);
    const backPageLabel = `${(0, _displayHelpers.getCompanyDisplayName)(companyDetails)}${!features.ASSIGNMENTS__HIDE_DETAILS && selectedAssignment ? ` / ${selectedAssignment.name}` : ""}`;
    const updateSignaturesMutation = (0, _reactQuery.useMutation)(async ()=>{
        const signaturesArray = [
            ...signatures.values()
        ];
        if (shouldUpdateAssignment) await updateAssignmentMutation.mutateAsync();
        return (0, _apiDefault.default).createCompanyCustomerDisclosureDocument(id, {
            signatures: signaturesArray,
            assignment_id: selectedAssignment?.id
        });
    }, {
        onSuccess: async (response)=>{
            if (assignmentId) // Add the newly created disclosure document to the start of the array of assignment details
            updateAssignmentQueryData((queryData)=>queryData.disclosure_documents.unshift(response));
            else // Add the newly created disclosure document to the start of the array of customer details
            updateCompanyQueryData((queryData)=>queryData.disclosure_documents.unshift(response));
            if (backButtonURL) history.push(backButtonURL);
            else history.goBack();
        }
    });
    const sendSignatures = ()=>updateSignaturesMutation.mutate();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                        url: backButtonURL,
                        displayLabel: backPageLabel,
                        showAsLink: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "heading2xl",
                        as: "p",
                        children: f("disclosure-request.title")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyDisclosureSignatureFormDefault.default), {
                        companySignatureConfiguration: data,
                        companyDetails: companyDetails,
                        signaturesByRoleId: signatures,
                        onChange: (signatures, isValid)=>{
                            setSignatures(signatures);
                            setFormValid(isValid);
                        },
                        assignments: assignments,
                        selectedAssignment: selectedAssignment,
                        setSelectedAssignment: setSelectedAssignment,
                        readonly: updateSignaturesMutation.isLoading,
                        footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addItemButtonDefault.default), {
                            onClick: ()=>setRoleModal((0, _personHelpers.createNewRole)(companyDetails.country)),
                            children: f("screening.buttons.add-role")
                        })
                    }),
                    updateSignaturesMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: updateSignaturesMutation.error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                                url: backButtonURL
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                primary: true,
                                disabled: updateSignaturesMutation.isLoading || !isFormValid || signatures.size == 0,
                                loading: updateSignaturesMutation.isLoading,
                                onClick: sendSignatures,
                                children: f("disclosure-request.button.send")
                            })
                        ]
                    })
                ]
            }),
            roleModal && companyDetails && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleModalDefault.default), {
                customer: companyDetails,
                dataRole: roleModal,
                onClose: ()=>setRoleModal(undefined),
                isDeleteDisabled: true,
                onDelete: (deleteRoleId)=>{
                    if (signatures.has(deleteRoleId)) {
                        signatures.delete(deleteRoleId);
                        setSignatures(new Map(signatures));
                    }
                    setRoleModal(undefined);
                },
                onUpdate: (0, _util.noop),
                onCreate: (role)=>{
                    const possibleSigners = possibleSignatureRoles;
                    possibleSigners.push(role);
                    setPossibleSignatureRoles(possibleSigners);
                    setRoleModal(undefined);
                }
            })
        ]
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(CompanyRequestDisclosuresPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).COMPANY_REQUEST_DISCLOSURES,
    apiFunction: (0, _apiDefault.default).getCompanySignatureConfiguration,
    paramNames: [
        "id",
        "assignmentId"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingWizardPageSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/AddItemButton/AddItemButton":"8Rs0C","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/BackButton/BackButton":"4fa4k","../../components/CompanyDisclosureSignatureForm/CompanyDisclosureSignatureForm":"7prlj","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/OnboardingWizardPageSkeleton/OnboardingWizardPageSkeleton":"hlp5z","../../components/RoleModal/RoleModal":"ijQn9","../../constants/queries-keys":"6hYSF","../../helpers/assignments.helpers":"7t8rY","../../helpers/display.helpers":"2q3xY","../../helpers/person.helpers":"6qOIE","../../hooks/useCustomerDetailsBackButton":"3YBG0","../../hooks/useDisclosureAssignment":"0tZFn","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7prlj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetOnboardingConfiguration = require("../../hooks/useGetOnboardingConfiguration");
var _useGetOnboardingConfigurationDefault = parcelHelpers.interopDefault(_useGetOnboardingConfiguration);
var _useValidateDisclosureForm = require("../../hooks/useValidateDisclosureForm");
var _useValidateDisclosureFormDefault = parcelHelpers.interopDefault(_useValidateDisclosureForm);
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
var _companyDisclosureAssignmentSelector = require("../CompanyDisclosureAssignmentSelector/CompanyDisclosureAssignmentSelector");
var _companyDisclosureAssignmentSelectorDefault = parcelHelpers.interopDefault(_companyDisclosureAssignmentSelector);
var _disclosureFormRow = require("../DisclosureFormRow/DisclosureFormRow");
var _disclosureFormRowDefault = parcelHelpers.interopDefault(_disclosureFormRow);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const CompanyDisclosureSignatureForm = (props)=>{
    const { companyDetails, companySignatureConfiguration, signaturesByRoleId: initialSignaturesByRoleId, // attachments,
    readonly, footer, onChange, ...assignmentSelectorProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const validateForm = (0, _useValidateDisclosureFormDefault.default)();
    const defaultSignatureConfiguration = (0, _useGetOnboardingConfigurationDefault.default)("company");
    const [signaturesByRoleId, setSignaturesByRoleId] = (0, _react.useState)(new Map());
    const [validationError, setValidationError] = (0, _react.useState)();
    const companyName = companyDetails?.name || "";
    const possibleSignatureRoles = companySignatureConfiguration.possible_signers || [];
    const signatureDescription = companySignatureConfiguration.signature_description;
    const signatureDescriptions = companySignatureConfiguration.signature_descriptions || [];
    const showAssignmentSelection = (0, _collectionUtils.hasContent)(assignmentSelectorProps.assignments);
    const selectedAssignment = assignmentSelectorProps.selectedAssignment;
    const onFormUpdate = (signatures)=>{
        validateForm(Array.from(signatures.values()), (isValid, hasDuplicates)=>{
            if (hasDuplicates) setValidationError(f("onboarding.disclosures.duplicate.emails.error"));
            else setValidationError(undefined);
            onChange(signatures, isValid);
        });
    };
    // Used to add existing data to the map (if for example a user navigates
    // from summary back to the KYC step during onboarding, we want to show
    // the existing signature configurations for roles)
    (0, _react.useEffect)(()=>{
        if (initialSignaturesByRoleId.size > 0) {
            setSignaturesByRoleId(initialSignaturesByRoleId);
            // Perform validation of the initial signature configurations
            onFormUpdate(initialSignaturesByRoleId);
        }
    }, [
        initialSignaturesByRoleId
    ]);
    const onSignerSelectionChange = (id, selected)=>{
        if (selected) {
            const email = companyDetails?.roles.find((role)=>role.id === id)?.person.email;
            signaturesByRoleId.set(id, {
                id,
                ...defaultSignatureConfiguration.signature_settings,
                email
            });
        } else signaturesByRoleId.delete(id);
        const updatedSignatures = new Map(signaturesByRoleId);
        setSignaturesByRoleId(updatedSignatures);
        onFormUpdate(updatedSignatures);
    };
    // Update a field when the signature configuration changes
    const onSignatureChange = (id, changedSignature)=>{
        if (signaturesByRoleId.has(id) && signaturesByRoleId.get(id) !== changedSignature) {
            signaturesByRoleId.set(id, changedSignature);
            const updatedSignatures = new Map(signaturesByRoleId);
            setSignaturesByRoleId(updatedSignatures);
            onFormUpdate(updatedSignatures);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
                status: "info",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "semibold",
                            children: f("disclosure-request.banner.signatory-rights", {
                                company: companyName
                            })
                        }),
                        signatureDescriptions.length === 0 && (0, _stringUtils.isEmptyString)(signatureDescription) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: f("disclosure-request.banner.no.signing-basis")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.List), {
                            children: [
                                !(0, _stringUtils.isEmptyString)(signatureDescription) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                                    children: signatureDescription
                                }),
                                signatureDescriptions.length > 0 && signatureDescriptions.map((description, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                                        children: description
                                    }, index))
                            ]
                        })
                    ]
                })
            }),
            showAssignmentSelection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyDisclosureAssignmentSelectorDefault.default), {
                        ...assignmentSelectorProps,
                        readonly: readonly
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                children: [
                    possibleSignatureRoles.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: f("roles.messages.no-roles")
                    }),
                    possibleSignatureRoles.map((signatureRole)=>{
                        const roleId = signatureRole.id;
                        const signature = signaturesByRoleId.get(roleId);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureFormRowDefault.default), {
                                roleType: signatureRole.type,
                                person: signatureRole.person,
                                selected: signaturesByRoleId.has(roleId),
                                signature: signature,
                                selectedAssignment: selectedAssignment,
                                // attachments={attachments}
                                // selectedAttachmentsIds={signature?.attachments_ids}
                                customerId: companyDetails?.id,
                                customerType: "company",
                                signatureName: (0, _displayHelpers.getFullName)(signatureRole.person),
                                readonly: readonly,
                                onChange: (signature)=>onSignatureChange(roleId, signature),
                                // onAttachmentsSelectionChange={(attachmentsIds) =>
                                //   onSignatureChange(roleId, { ...signature!, attachments_ids: attachmentsIds })
                                // }
                                onSelectionChanged: (value)=>onSignerSelectionChange(roleId, value)
                            })
                        }, roleId);
                    }),
                    footer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: footer
                    })
                ]
            }),
            validationError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: validationError
            })
        ]
    });
};
exports.default = CompanyDisclosureSignatureForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetOnboardingConfiguration":"27sqE","../../hooks/useValidateDisclosureForm":"6IoRW","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","../CompanyDisclosureAssignmentSelector/CompanyDisclosureAssignmentSelector":"63l2t","../DisclosureFormRow/DisclosureFormRow":"2d08v","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"27sqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@sentry/react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _onboarding = require("../constants/onboarding");
var _queriesKeys = require("../constants/queries-keys");
const useGetOnboardingConfiguration = (customerType)=>{
    const { isError, data, error } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).ONBOARDING_SETTINGS
    ], (0, _apiDefault.default).getPersonOnboardingSettings, {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    if (isError) {
        _react.captureException(error, {
            level: "warning"
        });
        return 0, _onboarding.DEFAULT_ONBOARDING_CONFIGURATION;
    }
    return customerType === "person" ? data : (0, _onboarding.DEFAULT_ONBOARDING_CONFIGURATION);
};
exports.default = useGetOnboardingConfiguration;

},{"@sentry/react":"akCRS","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/onboarding":"lQH9P","../constants/queries-keys":"6hYSF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"63l2t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _projectSvg = require("../../../assets/icons/project.svg");
var _projectSvgDefault = parcelHelpers.interopDefault(_projectSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _assignmentSelector = require("../AssignmentSelector/AssignmentSelector");
var _assignmentSelectorDefault = parcelHelpers.interopDefault(_assignmentSelector);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _purposeChoicesSelect = require("../PurposeChoicesSelect/PurposeChoicesSelect");
var _purposeChoicesSelectDefault = parcelHelpers.interopDefault(_purposeChoicesSelect);
var _signatureFormWrapper = require("../SignatureFormWrapper/SignatureFormWrapper");
var _signatureFormWrapperDefault = parcelHelpers.interopDefault(_signatureFormWrapper);
const CompanyDisclosureAssignmentSelector = (props)=>{
    const { selectedAssignment, assignments, readonly, setSelectedAssignment } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                fontWeight: "semibold",
                children: f("common.labels.include-assignment")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _signatureFormWrapperDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentSelectorDefault.default), {
                        assignments: assignments,
                        selectedAssignment: selectedAssignment,
                        onSelectionChange: setSelectedAssignment,
                        readonly: readonly
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                wrap: false,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: (0, _projectSvgDefault.default),
                                        width: "16px",
                                        height: "12px"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        fontWeight: "semibold",
                                        children: f("customer-assignments.details.assignment-purpose")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _purposeChoicesSelectDefault.default), {
                                industryType: selectedAssignment?.industry_type,
                                hasPurposeDesc: false,
                                disablePurposeDescription: true,
                                disabled: readonly || selectedAssignment === undefined,
                                labelHidden: true,
                                multiline: 2,
                                value: selectedAssignment?.purpose || selectedAssignment?.purpose_desc,
                                onChange: (purpose)=>setSelectedAssignment({
                                        ...selectedAssignment,
                                        purpose: purpose || ""
                                    })
                            }, selectedAssignment?.id || "selected-assignment")
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = CompanyDisclosureAssignmentSelector;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/project.svg":"b4tRC","../../hooks/useFormatMessage":"8Y8fq","../AssignmentSelector/AssignmentSelector":"3XY7s","../extensions/Icon":"eHSf0","../PurposeChoicesSelect/PurposeChoicesSelect":"fbzrz","../SignatureFormWrapper/SignatureFormWrapper":"1F5gh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2d08v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _disclosureSignatureForm = require("../DisclosureSignatureForm/DisclosureSignatureForm");
var _disclosureSignatureFormDefault = parcelHelpers.interopDefault(_disclosureSignatureForm);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _sectionTile = require("../SectionTile/SectionTile");
var _sectionTileDefault = parcelHelpers.interopDefault(_sectionTile);
const DisclosureFormRow = (props)=>{
    const { person, roleType, selected = true, signature, onSelectionChanged, ...disclosureSignatureFormProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const customerTitle = roleType ? f((0, _roleTypesDefault.default)[roleType]) : f("disclosure-request.column.customer");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                checked: selected,
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                    title: customerTitle,
                    gap: "1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                        type: "person",
                        name: (0, _displayHelpers.getFullName)(person),
                        birthDate: (0, _displayHelpers.getBirthDate)(person),
                        wrap: true,
                        strong: true
                    })
                }),
                onChange: (value)=>onSelectionChanged(value)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                open: selected,
                id: "DisclosureFormRow" + person?.id,
                children: signature && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureSignatureFormDefault.default), {
                    signature: signature,
                    ...disclosureSignatureFormProps
                })
            })
        ]
    });
};
exports.default = DisclosureFormRow;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/role-types":"fAycz","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../DisclosureSignatureForm/DisclosureSignatureForm":"ayCrt","../DisplayName/DisplayName":"gKd5g","../SectionTile/SectionTile":"9KSoL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hlp5z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
const OnboardingWizardPageSkeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                    size: "large"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                        lines: 1
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
                    status: "info",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                fontWeight: "semibold",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                    lines: 1
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                lines: 1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                lines: 1
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                        columnContentTypes: [
                            "text",
                            "text"
                        ],
                        headings: [],
                        rows: [
                            [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                    lines: 1
                                })
                            ],
                            [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                    lines: 1
                                })
                            ],
                            [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                    lines: 1
                                })
                            ]
                        ]
                    })
                })
            ]
        })
    });
exports.default = OnboardingWizardPageSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cvr2Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addFileButton = require("../../components/AddFileButton/AddFileButton");
var _addFileButtonDefault = parcelHelpers.interopDefault(_addFileButton);
var _archivedBadge = require("../../components/ArchivedBadge/ArchivedBadge");
var _archivedBadgeDefault = parcelHelpers.interopDefault(_archivedBadge);
var _assignmentActionsMenu = require("../../components/AssignmentActionsMenu/AssignmentActionsMenu");
var _assignmentActionsMenuDefault = parcelHelpers.interopDefault(_assignmentActionsMenu);
var _assignmentReviewsSection = require("../../components/AssignmentReviewsSection/AssignmentReviewsSection");
var _assignmentReviewsSectionDefault = parcelHelpers.interopDefault(_assignmentReviewsSection);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _attachmentsSection = require("../../components/AttachmentsSection/AttachmentsSection");
var _attachmentsSectionDefault = parcelHelpers.interopDefault(_attachmentsSection);
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _basicAssignmentInfo = require("../../components/BasicAssignmentInfo/BasicAssignmentInfo");
var _basicAssignmentInfoDefault = parcelHelpers.interopDefault(_basicAssignmentInfo);
var _cardNavigationSection = require("../../components/CardNavigationSection/CardNavigationSection");
var _cardNavigationSectionDefault = parcelHelpers.interopDefault(_cardNavigationSection);
var _detailsSkeleton = require("../../components/DetailsSkeleton/DetailsSkeleton");
var _detailsSkeletonDefault = parcelHelpers.interopDefault(_detailsSkeleton);
var _disclosureDocumentSection = require("../../components/DisclosureDocumentSection/DisclosureDocumentSection");
var _disclosureDocumentSectionDefault = parcelHelpers.interopDefault(_disclosureDocumentSection);
var _queriesKeys = require("../../constants/queries-keys");
var _navigationHelpers = require("../../helpers/navigation.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CustomerAssignmentDetailsPage = ({ data: assignment })=>{
    const { id, customerId } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const [uploadingFilesCount, setUploadingFilesCount] = (0, _react.useState)(0);
    const customerDetailsPageUrl = (0, _navigationHelpers.getDetailsPageURL)(customerId, assignment.customer_type);
    const readonly = assignment.is_archived;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                                url: customerDetailsPageUrl,
                                displayLabel: assignment.customer_name,
                                showAsLink: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                blockAlign: "baseline",
                                align: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        blockAlign: "baseline",
                                        gap: "2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                variant: "heading2xl",
                                                as: "p",
                                                children: assignment.name
                                            }),
                                            assignment.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archivedBadgeDefault.default), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentActionsMenuDefault.default), {
                                        assignment: assignment,
                                        readonly: readonly
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _basicAssignmentInfoDefault.default), {
                                assignment: assignment,
                                readonly: readonly
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureDocumentSectionDefault.default), {
                        assignmentId: id,
                        customerId: assignment.customer_id,
                        customerType: assignment.customer_type,
                        disclosureDocuments: assignment.disclosure_documents,
                        readonly: readonly,
                        addButtonLabel: f("common.buttons.actions.new-assignment-disclosure"),
                        emptyLabel: f("customer-assignments.no-disclosures.text")
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentsSectionDefault.default), {
                        entity: assignment,
                        uploadingFilesCount: uploadingFilesCount,
                        readonly: readonly,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addFileButtonDefault.default), {
                            entity: assignment,
                            onFileUploadingStart: (filesCount)=>setUploadingFilesCount(filesCount),
                            onFileUploadingFinish: ()=>setUploadingFilesCount(0),
                            readonly: readonly
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentReviewsSectionDefault.default), {
                        assignment: assignment,
                        readonly: readonly
                    })
                })
            ]
        })
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(CustomerAssignmentDetailsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).ASSIGNMENT_DETAILS,
    apiFunction: (0, _apiDefault.default).getCustomerAssignmentDetails,
    paramNames: [
        "customerId",
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AddFileButton/AddFileButton":"7ZmVz","../../components/ArchivedBadge/ArchivedBadge":"8eATJ","../../components/AssignmentActionsMenu/AssignmentActionsMenu":"l0oYI","../../components/AssignmentReviewsSection/AssignmentReviewsSection":"9EByu","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/AttachmentsSection/AttachmentsSection":"1J3Nq","../../components/BackButton/BackButton":"4fa4k","../../components/BasicAssignmentInfo/BasicAssignmentInfo":"fydIA","../../components/CardNavigationSection/CardNavigationSection":"fANmn","../../components/DetailsSkeleton/DetailsSkeleton":"lj8DC","../../components/DisclosureDocumentSection/DisclosureDocumentSection":"434BH","../../constants/queries-keys":"6hYSF","../../helpers/navigation.helpers":"adimP","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l0oYI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _reactQuery = require("@tanstack/react-query");
var _archiveboxSvg = require("../../../assets/icons/archivebox.svg");
var _archiveboxSvgDefault = parcelHelpers.interopDefault(_archiveboxSvg);
var _pencilSvg = require("../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _restoreSvg = require("../../../assets/icons/restore.svg");
var _restoreSvgDefault = parcelHelpers.interopDefault(_restoreSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _collectionUtils = require("../../utils/collectionUtils");
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _assignmentArchiveConfirmation = require("../AssignmentArchiveConfirmation/AssignmentArchiveConfirmation");
var _assignmentArchiveConfirmationDefault = parcelHelpers.interopDefault(_assignmentArchiveConfirmation);
var _assignmentModal = require("../AssignmentModal/AssignmentModal");
var _assignmentModalDefault = parcelHelpers.interopDefault(_assignmentModal);
const AssignmentActionsMenu = (props)=>{
    const { assignment, readonly } = props;
    const customerId = assignment.customer_id;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const [isEditAssignment, toggleEditAssignment, closeEditAssignment] = (0, _useOpenCloseDefault.default)();
    const [showArchiveConfirm, toggleArchiveConfirm, closeArchiveConfirm] = (0, _useOpenCloseDefault.default)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ASSIGNMENT_DETAILS,
        customerId,
        assignment.id
    ]);
    const updateCustomerQueryData = (0, _useQueryData.useCustomerDetailsQueryData)({
        id: customerId,
        type: assignment.customer_type
    });
    const restoreAssignmentMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).restoreCustomerAssignment(customerId, assignment.id), {
        onSuccess: async (updatedAssignment)=>{
            updateQueryData((queryData)=>Object.assign(queryData, updatedAssignment));
            updateCustomerQueryData((customerData)=>customerData.assignments = (0, _collectionUtils.updateItem)(customerData.assignments, updatedAssignment));
        }
    });
    const actions = [
        {
            content: f("common.buttons.actions.edit-assignment"),
            image: (0, _pencilSvgDefault.default),
            disabled: readonly,
            onAction: ()=>toggleEditAssignment()
        },
        {
            content: f("common.buttons.actions.new-assignment-disclosure"),
            icon: (0, _polarisIcons.PlusMinor),
            disabled: readonly,
            onAction: ()=>history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_ASSIGNMENT_REQUEST_DISCLOSURES, {
                    id: customerId,
                    assignmentId: assignment.id
                }))
        }
    ];
    if (assignment.is_archived) actions.push({
        content: f("common.buttons.actions.restore-assignment"),
        onAction: ()=>restoreAssignmentMutation.mutateAsync(),
        image: restoreAssignmentMutation.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
            size: "small"
        }) : (0, _restoreSvgDefault.default)
    });
    else actions.push({
        content: f("common.buttons.actions.archive-assignment"),
        onAction: toggleArchiveConfirm,
        image: (0, _archiveboxSvgDefault.default)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: actions,
                title: f("common.buttons.actions.button"),
                primary: true,
                size: "medium",
                forceOpen: restoreAssignmentMutation.isLoading
            }),
            isEditAssignment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentModalDefault.default), {
                assignment: assignment,
                customerId: customerId,
                onCancel: closeEditAssignment,
                onSave: (updatedAssignment)=>{
                    updateCustomerQueryData((queryData)=>queryData.assignments = queryData.assignments?.map((assignment)=>assignment.id === updatedAssignment.id ? updatedAssignment : assignment));
                    updateQueryData((queryData)=>queryData);
                    closeEditAssignment();
                }
            }),
            showArchiveConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentArchiveConfirmationDefault.default), {
                assignment: assignment,
                onClose: closeArchiveConfirm
            })
        ]
    });
};
exports.default = AssignmentActionsMenu;

},{"react/jsx-runtime":"enbMA","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","@tanstack/react-query":"91Vyq","../../../assets/icons/archivebox.svg":"cyEGJ","../../../assets/icons/pencil.svg":"gEWpJ","../../../assets/icons/restore.svg":"hwxcs","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","../ActionsDropdown/ActionsDropdown":"izRYG","../AssignmentArchiveConfirmation/AssignmentArchiveConfirmation":"i7ZYo","../AssignmentModal/AssignmentModal":"bVFci","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i7ZYo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _pageAnchors = require("../../constants/page-anchors");
var _queriesKeys = require("../../constants/queries-keys");
var _useCustomerPath = require("../../hooks/useCustomerPath");
var _useCustomerPathDefault = parcelHelpers.interopDefault(_useCustomerPath);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const AssignmentArchiveConfirmation = (props)=>{
    const { assignment, onClose } = props;
    const customerId = assignment.customer_id;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const { getCustomerPath } = (0, _useCustomerPathDefault.default)();
    const { updateQueryData: updateAssignmentQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ASSIGNMENT_DETAILS,
        customerId,
        assignment.id
    ]);
    const updateCustomerQueryData = (0, _useQueryData.useCustomerDetailsQueryData)({
        id: customerId,
        type: assignment.customer_type
    });
    const navigateToCustomerPage = ()=>{
        const customerURL = getCustomerPath(assignment.customer_id, assignment.customer_type);
        history.push(`${customerURL}#${(0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_ASSIGNMENTS}`);
    };
    const name = assignment.name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        title: f("archive-assignment.confirmation-modal.title"),
        description: f("archive-assignment.confirmation-modal.description", {
            name
        }),
        apiCall: ()=>(0, _apiDefault.default).archiveCustomerAssignment(customerId, assignment.id),
        onSuccess: ()=>{
            updateAssignmentQueryData((queryData)=>queryData.is_archived = true);
            updateCustomerQueryData((customerData)=>customerData.assignments = customerData.assignments?.map((customerAssignment)=>customerAssignment.id === assignment.id ? {
                        ...customerAssignment,
                        is_archived: true
                    } : customerAssignment));
            navigateToCustomerPage();
        },
        onNo: onClose,
        actionTitle: f("archive-assignment.confirmation-modal.labels.button.archive", {
            name
        }),
        isDestructive: true
    });
};
exports.default = AssignmentArchiveConfirmation;

},{"react/jsx-runtime":"enbMA","react-router-dom":"1ee65","../../api":"f6lXD","../../constants/page-anchors":"4WmvA","../../constants/queries-keys":"6hYSF","../../hooks/useCustomerPath":"gJfCj","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9EByu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _checkmarkGreenSvg = require("../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _circleCrossSvg = require("../../../assets/icons/circle-cross.svg");
var _circleCrossSvgDefault = parcelHelpers.interopDefault(_circleCrossSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _utilities = require("../../types/utilities");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _reviewCard = require("../ReviewCard/ReviewCard");
var _reviewCardDefault = parcelHelpers.interopDefault(_reviewCard);
var _risk = require("../Risk/Risk");
var _riskDefault = parcelHelpers.interopDefault(_risk);
const AssignmentReviewsSection = (props)=>{
    const { assignment, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    // TODO temporary workaround for the lack of Customer Reviews not returning in the assignment
    const { data } = (0, _reactQuery.useQuery)((0, _utilities.getCustomerQueryKey)(assignment), ()=>(0, _apiDefault.default).getCustomerDetails(assignment.customer_id));
    const customerReviews = data?.reviews.filter((review)=>review.assignment?.id === assignment.id) || [];
    const reviews = [
        ...assignment.reviews,
        ...customerReviews
    ];
    const hasReviews = reviews.length > 0;
    const customerReviewPageURL = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMER_ASSIGNMENT_REVIEW_NEW, {
        customerId: assignment.customer_id,
        assignmentId: assignment.id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                distribution: "equalSpacing",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "headingMd",
                        as: "h2",
                        children: f("customer-assignments.review.title")
                    }),
                    hasReviews && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        url: customerReviewPageURL,
                        disabled: readonly,
                        primary: true,
                        size: "slim",
                        children: f("reviews.labels.change-review")
                    })
                ]
            }),
            !hasReviews && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                inlineAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("customer-assignments.review.not-reviewed")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        url: customerReviewPageURL,
                        primary: true,
                        disabled: readonly,
                        children: f("customer-assignments.review.button.action")
                    })
                ]
            }),
            hasReviews && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    assignment.reviews.map((review)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewCardDefault.default), {
                            reviewedBy: review.reviewed_by,
                            reviewDate: review.created_dt,
                            reviewContent: review.comment,
                            reviewStatus: review.is_accepted ? "success" : "critical",
                            reviewHeader: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: review.is_accepted ? (0, _checkmarkGreenSvgDefault.default) : (0, _circleCrossSvgDefault.default)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "bodyMd",
                                        as: "span",
                                        children: review.is_accepted ? f("details.reviews.assignment-review.accepted") : f("details.reviews.assignment-review.rejected")
                                    }),
                                    review.risk_level && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDefault.default), {
                                        risk: review.risk_level,
                                        labelSuffix: f("common.labels.customer.risk")
                                    })
                                ]
                            })
                        }, review.id)),
                    customerReviews.map((review)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewCardDefault.default), {
                            reviewedBy: review.reviewed_by,
                            reviewDate: review.date,
                            reviewContent: review.comment,
                            reviewStatus: review.accepted ? "success" : "critical",
                            reviewHeader: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        source: review.accepted ? (0, _checkmarkGreenSvgDefault.default) : (0, _circleCrossSvgDefault.default)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "bodyMd",
                                        as: "span",
                                        children: review.accepted ? f("details.reviews.assignment-review.accepted") : f("details.reviews.assignment-review.rejected")
                                    }),
                                    review.risk_level && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDefault.default), {
                                        risk: review.risk_level,
                                        labelSuffix: f("common.labels.customer.risk")
                                    })
                                ]
                            })
                        }, review.id))
                ]
            })
        ]
    });
};
exports.default = AssignmentReviewsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../assets/icons/checkmark-green.svg":"8HW5l","../../../assets/icons/circle-cross.svg":"daUCT","../../api":"f6lXD","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../../types/utilities":"6zLpB","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../ReviewCard/ReviewCard":"7p3dh","../Risk/Risk":"9VLEF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fydIA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _detailsGrid = require("../../components/DetailsGrid/DetailsGrid");
var _detailsGridDefault = parcelHelpers.interopDefault(_detailsGrid);
var _kdkbanner = require("../../components/KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _assignmentResponsibleUsersSelect = require("../../pages/CustomerAssignmentDetailsPage/AssignmentResponsibleUsersSelect");
var _assignmentResponsibleUsersSelectDefault = parcelHelpers.interopDefault(_assignmentResponsibleUsersSelect);
var _assignmentIndustry = require("../AssignmentIndustry");
var _assignmentIndustryDefault = parcelHelpers.interopDefault(_assignmentIndustry);
var _assignmentPurpose = require("../AssignmentPurpose/AssignmentPurpose");
var _assignmentPurposeDefault = parcelHelpers.interopDefault(_assignmentPurpose);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _risk = require("../Risk/Risk");
var _riskDefault = parcelHelpers.interopDefault(_risk);
const BasicAssignmentInfo = (props)=>{
    const { assignment, readonly } = props;
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        hideIcon: true,
        hideBorder: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailsGridDefault.default), {
                    rows: 3,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            children: [
                                f("common.labels.start-date"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "bold",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                date: assignment.start_date
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            children: [
                                f("common.labels.end-date"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "bold",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                date: assignment.end_date
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            children: [
                                f("responsible.empty.users"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentResponsibleUsersSelectDefault.default), {
                            assignment: assignment,
                            readonly: readonly
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            children: [
                                f("customer-assignments.details.assignment-risk"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "bold",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDefault.default), {
                                risk: assignment.risk_level
                            })
                        }),
                        features.ASSIGNMENT_INDUSTRIES && assignment.industry_type && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                    as: "span",
                                    children: [
                                        f("customer-assignments.details.assignment-industry-type"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentIndustryDefault.default), {
                                    assignment: assignment
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            children: [
                                f("customer-assignments.details.assignment-purpose"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "bold",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentPurposeDefault.default), {
                                assignment: assignment
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            children: [
                                f("customer-assignments.details.assignment-description"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "bold",
                            children: assignment.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                            children: f("common.labels.created-by", {
                                name: getUserDisplayName(assignment.created_by),
                                timestamp: new Date(assignment.created_dt)
                            })
                        }),
                        assignment.archived_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                            children: f("common.labels.archived-by", {
                                name: getUserDisplayName(assignment.archived_by),
                                timestamp: new Date(assignment.archived_dt)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = BasicAssignmentInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../components/DetailsGrid/DetailsGrid":"dIEbw","../../components/KDKBanner/KDKBanner":"3zPW6","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../pages/CustomerAssignmentDetailsPage/AssignmentResponsibleUsersSelect":"1NbvT","../AssignmentIndustry":"iqNLH","../AssignmentPurpose/AssignmentPurpose":"1jViK","../CondensedText/CondensedText":"1FshD","../CustomDate/CustomDate":"5KD00","../Risk/Risk":"9VLEF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1NbvT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _usersSelect = require("../../components/UsersSelect/UsersSelect");
var _usersSelectDefault = parcelHelpers.interopDefault(_usersSelect);
var _queriesKeys = require("../../constants/queries-keys");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const AssignmentResponsibleUsersSelect = (props)=>{
    const { assignment, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ASSIGNMENT_DETAILS,
        assignment.customer_id,
        assignment.id
    ]);
    const updateResponsibleUsers = (responsibleUserIds)=>(0, _apiDefault.default).updateCustomerAssignment(assignment.customer_id, assignment.id, {
            ...(0, _assignmentsHelpers.convertAssignmentToUpdateRequest)(assignment),
            responsible_users: responsibleUserIds
        }).then((response)=>response.responsible_users);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersSelectDefault.default), {
        selectedUsers: assignment.responsible_users || [],
        emptySelectionLabel: f("responsible.empty.users"),
        updateErrorMessage: "responsible.error",
        readonly: readonly,
        strong: true,
        onUserSelection: updateResponsibleUsers,
        onAfterUserSelection: (responsibleUsers)=>{
            updateQueryData((queryData)=>queryData.responsible_users = responsibleUsers);
        }
    });
};
exports.default = AssignmentResponsibleUsersSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../api":"f6lXD","../../components/UsersSelect/UsersSelect":"k1Nxo","../../constants/queries-keys":"6hYSF","../../helpers/assignments.helpers":"7t8rY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iqNLH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../helpers/display.helpers");
var _useGetAssignmentIndustriesAndPurposes = require("../hooks/useGetAssignmentIndustriesAndPurposes");
var _useGetAssignmentIndustriesAndPurposesDefault = parcelHelpers.interopDefault(_useGetAssignmentIndustriesAndPurposes);
var _useLanguage = require("../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
const AssignmentIndustry = (props)=>{
    const { assignment } = props;
    const language = (0, _useLanguageDefault.default)();
    const { industries } = (0, _useGetAssignmentIndustriesAndPurposesDefault.default)();
    const industry = industries.find((industry)=>industry.value === assignment.industry_type);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        fontWeight: "bold",
        children: industry ? (0, _displayHelpers.getTranslationText)(language, industry.label) : ""
    });
};
exports.default = AssignmentIndustry;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../helpers/display.helpers":"2q3xY","../hooks/useGetAssignmentIndustriesAndPurposes":"d3Dsc","../hooks/useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1jViK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useGetAssignmentIndustriesAndPurposes = require("../../hooks/useGetAssignmentIndustriesAndPurposes");
var _useGetAssignmentIndustriesAndPurposesDefault = parcelHelpers.interopDefault(_useGetAssignmentIndustriesAndPurposes);
const AssignmentPurpose = (props)=>{
    const { assignment, ...textProps } = props;
    const { getPurposeLabel } = (0, _useGetAssignmentIndustriesAndPurposesDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        ...textProps,
        children: assignment.purpose ? getPurposeLabel(assignment.purpose) : assignment.purpose_desc
    });
};
exports.default = AssignmentPurpose;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useGetAssignmentIndustriesAndPurposes":"d3Dsc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9aENb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _customerReviewAddedChecklistsToast = require("../../components/CustomerReviewAddedChecklistsToast/CustomerReviewAddedChecklistsToast");
var _customerReviewAddedChecklistsToastDefault = parcelHelpers.interopDefault(_customerReviewAddedChecklistsToast);
var _customerReviewApprovalLabel = require("../../components/CustomerReviewApprovalLabel/CustomerReviewApprovalLabel");
var _customerReviewApprovalLabelDefault = parcelHelpers.interopDefault(_customerReviewApprovalLabel);
var _customerReviewApprovalSection = require("../../components/CustomerReviewApprovalSection/CustomerReviewApprovalSection");
var _customerReviewApprovalSectionDefault = parcelHelpers.interopDefault(_customerReviewApprovalSection);
var _customerReviewAssignmentSection = require("../../components/CustomerReviewAssignmentSection/CustomerReviewAssignmentSection");
var _customerReviewAssignmentSectionDefault = parcelHelpers.interopDefault(_customerReviewAssignmentSection);
var _customerReviewChecklistSection = require("../../components/CustomerReviewChecklistSection/CustomerReviewChecklistSection");
var _customerReviewChecklistSectionDefault = parcelHelpers.interopDefault(_customerReviewChecklistSection);
var _customerReviewControlsSection = require("../../components/CustomerReviewControlsSection/CustomerReviewControlsSection");
var _customerReviewControlsSectionDefault = parcelHelpers.interopDefault(_customerReviewControlsSection);
var _customerReviewDisclosuresSection = require("../../components/CustomerReviewDisclosuresSection/CustomerReviewDisclosuresSection");
var _customerReviewDisclosuresSectionDefault = parcelHelpers.interopDefault(_customerReviewDisclosuresSection);
var _customerReviewFormSection = require("../../components/CustomerReviewFormSection/CustomerReviewFormSection");
var _customerReviewFormSectionDefault = parcelHelpers.interopDefault(_customerReviewFormSection);
var _customerReviewGuidelineSection = require("../../components/CustomerReviewGuidelineSection/CustomerReviewGuidelineSection");
var _customerReviewGuidelineSectionDefault = parcelHelpers.interopDefault(_customerReviewGuidelineSection);
var _customerReviewMeasuresSection = require("../../components/CustomerReviewMeasuresSection/CustomerReviewMeasuresSection");
var _customerReviewMeasuresSectionDefault = parcelHelpers.interopDefault(_customerReviewMeasuresSection);
var _customerReviewPageBanner = require("../../components/CustomerReviewPageBanner/CustomerReviewPageBanner");
var _customerReviewPageBannerDefault = parcelHelpers.interopDefault(_customerReviewPageBanner);
var _customerReviewRiskLevelForm = require("../../components/CustomerReviewRiskLevelForm/CustomerReviewRiskLevelForm");
var _customerReviewRiskLevelFormDefault = parcelHelpers.interopDefault(_customerReviewRiskLevelForm);
var _customerReviewRiskSection = require("../../components/CustomerReviewRiskSection/CustomerReviewRiskSection");
var _customerReviewRiskSectionDefault = parcelHelpers.interopDefault(_customerReviewRiskSection);
var _userDisplayName = require("../../components/UserDisplayName/UserDisplayName");
var _userDisplayNameDefault = parcelHelpers.interopDefault(_userDisplayName);
var _queriesKeys = require("../../constants/queries-keys");
var _riskHelpers = require("../../helpers/risk.helpers");
var _useCustomerReviewMutations = require("../../hooks/useCustomerReviewMutations");
var _useCustomerReviewMutationsDefault = parcelHelpers.interopDefault(_useCustomerReviewMutations);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetDisclosureCountryRiskInformation = require("../../hooks/useGetDisclosureCountryRiskInformation");
var _useGetDisclosureCountryRiskInformationDefault = parcelHelpers.interopDefault(_useGetDisclosureCountryRiskInformation);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _utilities = require("../../types/utilities");
var _collectionUtils = require("../../utils/collectionUtils");
var _customerReviewSkeleton = require("./CustomerReviewSkeleton");
var _customerReviewSkeletonDefault = parcelHelpers.interopDefault(_customerReviewSkeleton);
var _useCustomerReviewPage = require("./useCustomerReviewPage");
var _useCustomerReviewPageDefault = parcelHelpers.interopDefault(_useCustomerReviewPage);
const CustomerReviewPage = ({ data: customer })=>{
    const { id, assignmentId } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { getCustomerCountryRiskInformation } = (0, _useGetDisclosureCountryRiskInformationDefault.default)();
    const industryRisk = (0, _utilities.isPersonCustomerDetails)(customer) ? undefined : customer.risk_information;
    const matchCases = customer.match_cases;
    const countriesRisk = getCustomerCountryRiskInformation(customer);
    const disclosuresRisk = (0, _riskHelpers.getUnifiedCustomerDisclosureRiskInformation)(customer);
    const personnelRisk = (0, _riskHelpers.getPersonnelRiskInformation)(customer);
    const riskIndicators = {
        industryRisk,
        matchCases,
        countriesRisk,
        disclosuresRisk,
        personnelRisk
    };
    const { previousPageLabel, readonly, review, reviewedBy, reviewDate, reviewApproval, isInvalidReview, canBeDeleted, isPossibleToApprove, isReviewChanged, signatures, assignments, savedChecklistAnswers, manuallyRemovedChecklistIds, addedChecklistsIds, resetAddedChecklists, setManuallyRemovedChecklistsIds, handleReviewChange, resetReviewIsChanged, setReview, onBackNavigation } = (0, _useCustomerReviewPageDefault.default)(customer, riskIndicators, id, assignmentId);
    const { saveMutation, completeMutation, isLoading } = (0, _useCustomerReviewMutationsDefault.default)(customer, review, id);
    //////// save review toast
    const [showSavedToast, toggleSavedToast, closeSavedToast] = (0, _useOpenCloseDefault.default)();
    // add some post-mutations changes after running save and complete review mutations
    const saveReview = (0, _reactQuery.useMutation)(saveMutation.mutateAsync, {
        onSuccess: ()=>{
            resetReviewIsChanged();
            toggleSavedToast();
        }
    });
    const completeReview = (0, _reactQuery.useMutation)(completeMutation.mutateAsync, {
        onSuccess: onBackNavigation
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                        showAsLink: true,
                        displayLabel: previousPageLabel,
                        onClick: onBackNavigation
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "heading2xl",
                                as: "p",
                                children: f("reviews.titles.risk-review")
                            }),
                            reviewedBy && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDisplayNameDefault.default), {
                                        user: reviewedBy,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            variant: "bodyMd",
                                            as: "span",
                                            children: f("details.reviews.reviewed-by")
                                        })
                                    }),
                                    reviewApproval && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewApprovalLabelDefault.default), {
                                        reviewApproval: reviewApproval
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewPageBannerDefault.default), {
                        customer: customer
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout).Section, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewGuidelineSectionDefault.default), {
                                        customerType: customer.type,
                                        timestamp: reviewDate
                                    }),
                                    (0, _collectionUtils.hasContent)(assignments) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewAssignmentSectionDefault.default), {
                                        customer: customer,
                                        reviewId: review.id,
                                        assignments: assignments,
                                        selectedAssignmentId: review.assignment_id,
                                        onAssignmentsChange: (assignmentId)=>handleReviewChange("assignment_id", assignmentId),
                                        readonly: isLoading || readonly
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewRiskSectionDefault.default), {
                                        customerId: customer.id,
                                        riskIndicators: riskIndicators
                                    }),
                                    features.REVIEW_CHECKLIST && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewChecklistSectionDefault.default), {
                                        customerType: customer.type,
                                        savedChecklistsAnswers: savedChecklistAnswers,
                                        checklistsAnswers: review.checklist_answers,
                                        addedChecklistsIds: addedChecklistsIds,
                                        manuallyRemovedChecklistIds: manuallyRemovedChecklistIds,
                                        setManuallyRemovedChecklistsIds: setManuallyRemovedChecklistsIds,
                                        onChecklistAnswersChange: (answers)=>handleReviewChange("checklist_answers", answers),
                                        readonly: isLoading || readonly
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewRiskLevelFormDefault.default), {
                                        riskLevel: review.risk_level,
                                        onRiskLevelChange: (riskLevel)=>handleReviewChange("risk_level", riskLevel),
                                        readonly: isLoading || readonly
                                    }),
                                    features.MEASURES && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasuresSectionDefault.default), {
                                        measures: review.measures || [],
                                        onChange: (measures)=>handleReviewChange("measures", measures),
                                        readonly: isLoading || readonly
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewFormSectionDefault.default), {
                                        review: review,
                                        readonly: isLoading || readonly,
                                        onFieldChange: handleReviewChange
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewApprovalSectionDefault.default), {
                                        review: review,
                                        onAcceptedChange: (accepted)=>handleReviewChange("accepted", accepted),
                                        onChange: setReview,
                                        readonly: isLoading || readonly
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewControlsSectionDefault.default), {
                                        customer: customer,
                                        reviewId: id,
                                        isPossibleToApprove: isPossibleToApprove,
                                        isInvalidReview: isInvalidReview,
                                        canBeDeleted: canBeDeleted,
                                        isDirty: isReviewChanged,
                                        readonly: readonly,
                                        saveReviewMutation: saveReview,
                                        completeReviewMutation: completeReview,
                                        onBackNavigation: ()=>{
                                            resetReviewIsChanged();
                                            onBackNavigation();
                                        }
                                    })
                                ]
                            }),
                            signatures.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                                oneThird: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewDisclosuresSectionDefault.default), {
                                    signatures: signatures
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewAddedChecklistsToastDefault.default), {
                addedChecklistsIds: addedChecklistsIds,
                onDismiss: resetAddedChecklists
            }),
            showSavedToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: f("details.reviews.messages.saved"),
                onDismiss: closeSavedToast
            })
        ]
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(CustomerReviewPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW,
    apiFunction: (customerId, _, options)=>(0, _apiDefault.default).getCustomerDetails(customerId, options),
    paramNames: [
        "customerId",
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/BackButton/BackButton":"4fa4k","../../components/CustomerReviewAddedChecklistsToast/CustomerReviewAddedChecklistsToast":"7YeMD","../../components/CustomerReviewApprovalLabel/CustomerReviewApprovalLabel":"dzNvi","../../components/CustomerReviewApprovalSection/CustomerReviewApprovalSection":"4JSc7","../../components/CustomerReviewAssignmentSection/CustomerReviewAssignmentSection":"6xiGy","../../components/CustomerReviewChecklistSection/CustomerReviewChecklistSection":"nfa1z","../../components/CustomerReviewControlsSection/CustomerReviewControlsSection":"2fXBG","../../components/CustomerReviewDisclosuresSection/CustomerReviewDisclosuresSection":"9LbW2","../../components/CustomerReviewFormSection/CustomerReviewFormSection":"jtZRa","../../components/CustomerReviewGuidelineSection/CustomerReviewGuidelineSection":"6v0ka","../../components/CustomerReviewMeasuresSection/CustomerReviewMeasuresSection":"a409G","../../components/CustomerReviewPageBanner/CustomerReviewPageBanner":"6Ct9K","../../components/CustomerReviewRiskLevelForm/CustomerReviewRiskLevelForm":"cVp0t","../../components/CustomerReviewRiskSection/CustomerReviewRiskSection":"jbkwi","../../components/UserDisplayName/UserDisplayName":"5vtSH","../../constants/queries-keys":"6hYSF","../../helpers/risk.helpers":"1qPrk","../../hooks/useCustomerReviewMutations":"7qDJg","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetDisclosureCountryRiskInformation":"isCim","../../hooks/useOpenClose":"idooG","../../types/utilities":"6zLpB","../../utils/collectionUtils":"gr5mc","./CustomerReviewSkeleton":"gn3Cd","./useCustomerReviewPage":"8OLgg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7YeMD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _durations = require("../../constants/durations");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _browserUtils = require("../../utils/browserUtils");
var _collectionUtils = require("../../utils/collectionUtils");
const CustomerReviewAddedChecklistsToast = (props)=>{
    const { addedChecklistsIds, ...toastProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (addedChecklistsIds.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
        content: f("component.review.checklist.added.toast.message"),
        duration: (0, _durations.DURATION_VERY_LONG_IN_MS),
        action: {
            content: f("component.review.checklist.added.toast.scroll.label"),
            onAction: ()=>(0, _browserUtils.scrollInPage)((0, _checklistsHelpers.getChecklistAnchorId)((0, _collectionUtils.first)(addedChecklistsIds)), {
                    behavior: "smooth"
                })
        },
        ...toastProps
    });
};
exports.default = CustomerReviewAddedChecklistsToast;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/durations":"5sjIW","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../../utils/browserUtils":"4ShiW","../../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dzNvi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _userDisplayName = require("../UserDisplayName/UserDisplayName");
var _userDisplayNameDefault = parcelHelpers.interopDefault(_userDisplayName);
const CustomerReviewApprovalLabel = (props)=>{
    const { reviewApproval } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userDisplayNameDefault.default), {
                user: reviewApproval.approved_by,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: f("details.reviews.approved-by")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                as: "span",
                fontWeight: "bold",
                children: [
                    " - ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                        date: reviewApproval.timestamp
                    })
                ]
            })
        ]
    });
};
exports.default = CustomerReviewApprovalLabel;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../CustomDate/CustomDate":"5KD00","../UserDisplayName/UserDisplayName":"5vtSH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4JSc7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _customerReviewAcceptForm = require("../CustomerReviewAcceptForm/CustomerReviewAcceptForm");
var _customerReviewAcceptFormDefault = parcelHelpers.interopDefault(_customerReviewAcceptForm);
var _customerReviewApprovalForm = require("../CustomerReviewApprovalForm/CustomerReviewApprovalForm");
var _customerReviewApprovalFormDefault = parcelHelpers.interopDefault(_customerReviewApprovalForm);
const CustomerReviewApprovalSection = (props)=>{
    const { review, readonly, onAcceptedChange, onChange } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                inlineAlign: "stretch",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewAcceptFormDefault.default), {
                        accepted: review.accepted,
                        onAcceptedChange: onAcceptedChange,
                        readonly: readonly
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBorderedWrapper, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewApprovalFormDefault.default), {
                                review: review,
                                onChange: onChange,
                                readonly: readonly
                            })
                        })
                    })
                ]
            })
        })
    });
};
const StyledBorderedWrapper = (0, _styledComponentsDefault.default).div`
  padding: var(--p-space-1) var(--p-space-4);
  border: solid var(--p-border-width-1) var(--p-border-subdued);
  border-radius: var(--p-border-radius-1);

  &:hover {
    border-color: var(--p-border-hovered);
  }
`;
exports.default = CustomerReviewApprovalSection;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../CustomerReviewAcceptForm/CustomerReviewAcceptForm":"iVw92","../CustomerReviewApprovalForm/CustomerReviewApprovalForm":"9pkOT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iVw92":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _fullWidthStatusRadioButton = require("../FullWidthStatusRadioButton/FullWidthStatusRadioButton");
var _fullWidthStatusRadioButtonDefault = parcelHelpers.interopDefault(_fullWidthStatusRadioButton);
const CustomerReviewAcceptForm = (props)=>{
    const { accepted, readonly, onAcceptedChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        distribution: "fill",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthStatusRadioButtonDefault.default), {
                label: f("common.labels.approve"),
                checked: accepted === true,
                name: "relationship",
                color: "green",
                onChange: ()=>onAcceptedChange(true),
                disabled: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthStatusRadioButtonDefault.default), {
                label: f("common.labels.reject"),
                checked: accepted === false,
                name: "relationship",
                color: "red",
                onChange: ()=>onAcceptedChange(false),
                disabled: readonly
            })
        ]
    });
};
exports.default = CustomerReviewAcceptForm;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../FullWidthStatusRadioButton/FullWidthStatusRadioButton":"3yHie","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3yHie":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _fullWidthRadioButton = require("../FullWidthRadioButton/FullWidthRadioButton");
var _fullWidthRadioButtonDefault = parcelHelpers.interopDefault(_fullWidthRadioButton);
const FullWidthStatusRadioButton = (0, _styledComponentsDefault.default)((0, _fullWidthRadioButtonDefault.default))`
  ${({ color })=>color === "red" && `
      --background-color-hovered: var(--p-color-bg-critical-subdued-hover);
      --background-color-active: var(--p-color-bg-critical-subdued-active);
      
      --background-color-selected: var(--p-color-bg-critical-subdued-hover);
      --background-color-selected-hovered: var(--p-color-bg-critical-subdued);
      --background-color-selected-active: var(--p-color-bg-critical-subdued-active);
      
      --border-color: var(--p-color-border-critical-subdued);
      --border-color-hovered: var(--p-color-border-critical);
      --border-color-active: var(--p-color-border-critical-hover);
      
      --border-color-selected: var(--p-color-bg-critical-strong);
      --border-color-selected-hovered: var(--p-color-border-critical);
      --border-color-selected-active: var(--p-color-border-critical-hover);
  `}

  ${({ color })=>color === "orange" && `
      --background-color-hovered: var(--p-color-bg-caution-subdued-hover);
      --background-color-active: var(--p-color-bg-caution-subdued-active);
      
      --background-color-selected: var(--p-color-bg-caution-subdued-hover);
      --background-color-selected-hovered: var(--p-color-bg-caution-subdued);
      --background-color-selected-active: var(--p-color-bg-caution-subdued-active);
      
      --border-color: var(--p-color-border-caution-subdued);
      --border-color-hovered: var(--p-color-border-caution);
      --border-color-active: var(--p-color-bg-caution-strong);
      
      --border-color-selected: var(--p-color-bg-caution-strong);
      --border-color-selected-hovered: var(--p-color-border-caution);
      --border-color-selected-active: var(--p-color-bg-caution-strong);
  `}
  
  ${({ color })=>color === "green" && `
      --background-color-hovered: var(--p-color-bg-success-subdued-hover);
      --background-color-active: var(--p-color-bg-success-subdued-active);
      
      --background-color-selected: var(--p-color-bg-success-subdued);
      --background-color-selected-hovered: var(--p-color-bg-success-subdued);
      --background-color-selected-active: var(--p-color-bg-success-subdued-active);
      
      --border-color: var(--p-color-border-success);
      --border-color-hovered: var(--p-color-border-success);
      --border-color-active: var(--p-color-bg-success-strong);
      
      --border-color-selected: var(--p-color-bg-success-strong);
      --border-color-selected-hovered: var(--p-color-border-success);
      --border-color-selected-active: var(--p-color-bg-success-strong);
  `}

  & .Polaris-Choice {
    border-width: var(--p-border-width-2);
  }
`;
exports.default = FullWidthStatusRadioButton;

},{"styled-components":"eBrdC","../FullWidthRadioButton/FullWidthRadioButton":"cK5m4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cK5m4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
const FullWidthRadioButton = (props)=>{
    const { checked, disabled, className, ...buttonProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledRadioButtonWrapper, {
        checked: checked,
        disabled: disabled,
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
            checked: checked,
            disabled: disabled,
            ...buttonProps
        })
    });
};
const StyledRadioButtonWrapper = (0, _styledComponentsDefault.default).span`
  --background-color: var(--p-surface);
  --background-color-hovered: var(--p-surface-neutral-hovered);
  --background-color-active: var(--p-surface-neutral-pressed);

  --background-color-selected: var(--p-surface-selected);
  --background-color-selected-hovered: var(--p-surface-selected-hovered);
  --background-color-selected-active: var(--p-surface-selected-pressed);

  --border-color: var(--p-border-subdued);
  --border-color-hovered: var(--p-border-hovered);
  --border-color-active: var(--p-border-pressed);

  --border-color-selected: var(--p-interactive);
  --border-color-selected-hovered: var(--p-action-primary-hovered);
  --border-color-selected-active: var(--p-action-primary-pressed);

  & .Polaris-Choice {
    border-radius: var(--p-border-radius-1);
    padding: var(--p-space-4);
    background-color: ${({ checked })=>checked ? "var(--background-color-selected)" : "var(--background-color)"};
    border: var(--p-border-width-1) solid
      ${({ checked })=>checked ? "var(--border-color-selected)" : "var(--border-color)"};

    ${({ checked, disabled })=>!disabled && `
        &:hover {
          background-color: ${checked ? "var(--background-color-selected-hovered)" : "var(--background-color-hovered)"};
          border-color: ${checked ? "var(--border-color-selected-hovered)" : " var(--border-color-hovered)"};
        }
    
        &:active {
          border-color: ${checked ? "var(--border-color-selected-active)" : " var(--border-color-active)"};
          background-color: ${checked ? "var(--background-color-selected-active)" : "var(--background-color-active)"};
        }
    `}

    & .Polaris-Choice__Label {
      user-select: none;
      font-weight: ${({ checked })=>checked ? "var(--p-font-weight-bold)" : undefined};
    }

    width: 100%;

    // For small viewports - render button as a regular block element
    @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
      padding: var(--p-space-2);
    }
  }
`;
exports.default = FullWidthRadioButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9pkOT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _permissions = require("../../constants/permissions");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useGetMLROUsers = require("../../hooks/useGetMLROUsers");
var _useGetMLROUsersDefault = parcelHelpers.interopDefault(_useGetMLROUsers);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useIsMLROUser = require("../../hooks/useIsMLROUser");
var _useIsMLROUserDefault = parcelHelpers.interopDefault(_useIsMLROUser);
var _popoverButton = require("../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _usersList = require("../UsersList/UsersList");
var _usersListDefault = parcelHelpers.interopDefault(_usersList);
const CustomerReviewApprovalForm = (props)=>{
    const { review, readonly, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const isMLROUser = (0, _useIsMLROUserDefault.default)();
    const mlroUsers = (0, _useGetMLROUsersDefault.default)();
    const { getUserFullName } = (0, _useGetUserNameDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const [selectionChanged, setSelectionChanged] = (0, _react.useState)(false);
    const { approval_user_ids = [] } = review;
    const handleRequiresApproval = (checked)=>{
        // pre-select the MLRO admins for approval if:
        // 1. User checked the approval checkbox
        // 2. The current user is NOT an MLRO admin
        // 3. REVIEW__DISABLE_MLRO_ADMINS_PRE_SELECTION_FOR_REVIEW_APPROVAL is disabled
        const shouldPreselectMLROAdmins = checked && !isMLROUser && !features.REVIEW__DISABLE_MLRO_ADMINS_PRE_SELECTION_FOR_REVIEW_APPROVAL;
        const initialApprovalUserIds = shouldPreselectMLROAdmins ? mlroUsers.map((user)=>user.id) : [];
        onChange({
            ...review,
            requires_approval: checked,
            approval_user_ids: initialApprovalUserIds
        });
    };
    const popoverLabel = approval_user_ids.length === 0 ? f("reviews.labels.select-user-for-confirmation") : formatMultipleNames(approval_user_ids.map((userId)=>getUserFullName(userId)), 1);
    const handleSelectionChange = (selectedIds)=>{
        setSelectionChanged(true);
        onChange({
            ...review,
            approval_user_ids: selectedIds
        });
    };
    const filteredGroups = features.REVIEW__ONLY_LIST_COMPLIANCE_ADMIN_APPROVAL_USERS ? [
        (0, _permissions.MLRO_GROUP_KEY),
        (0, _permissions.COMPLIANCE_OFFICER_GROUP_KEY)
    ] : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        align: "start",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                    label: f("reviews.labels.ask-for-confirmation"),
                    checked: review.requires_approval,
                    onChange: handleRequiresApproval,
                    disabled: readonly
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                id: "",
                open: Boolean(review.requires_approval),
                children: review.requires_approval && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
                    label: popoverLabel,
                    disclosure: true,
                    disabled: readonly,
                    preferredAlignment: "left",
                    render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersListDefault.default), {
                                    selectedUserIds: approval_user_ids,
                                    allowMultiple: true,
                                    excludeCurrentUser: true,
                                    selectedFirst: !selectionChanged,
                                    filterGroups: filteredGroups,
                                    onChange: handleSelectionChange
                                })
                            })
                        })
                })
            })
        ]
    });
};
exports.default = CustomerReviewApprovalForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/permissions":"jhCn5","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../../hooks/useGetMLROUsers":"cE2Tf","../../hooks/useGetUserName":"edBne","../../hooks/useIsMLROUser":"338u5","../PopoverButton/PopoverButton":"ihB8F","../UsersList/UsersList":"dqxGe","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cE2Tf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _permissions = require("../constants/permissions");
var _useGetUsers = require("./useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
const useGetMLROUsers = ()=>{
    const { activeUsers, groups } = (0, _useGetUsersDefault.default)();
    const MLRO_GROUP_ID = groups.find((group)=>group.role_key === (0, _permissions.MLRO_GROUP_KEY))?.id;
    return (0, _react.useMemo)(()=>activeUsers.filter((user)=>MLRO_GROUP_ID && user.groups?.includes(MLRO_GROUP_ID)), [
        activeUsers
    ]);
};
exports.default = useGetMLROUsers;

},{"react":"cOWTg","../constants/permissions":"jhCn5","./useGetUsers":"c83Pg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"338u5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _permissions = require("../constants/permissions");
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
const useIsMLROUser = ()=>{
    const { user } = (0, _useAuthDefault.default)();
    return Boolean(user?.groups?.find((group)=>group.role_key === (0, _permissions.MLRO_GROUP_KEY)) !== undefined);
};
exports.default = useIsMLROUser;

},{"../constants/permissions":"jhCn5","./useAuth":"k9r0q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6xiGy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _assignmentInfo = require("../AssignmentInfo/AssignmentInfo");
var _assignmentInfoDefault = parcelHelpers.interopDefault(_assignmentInfo);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _fullWidthRadioButton = require("../FullWidthRadioButton/FullWidthRadioButton");
var _fullWidthRadioButtonDefault = parcelHelpers.interopDefault(_fullWidthRadioButton);
var _useCustomerReviewAssignmentSelection = require("./useCustomerReviewAssignmentSelection");
var _useCustomerReviewAssignmentSelectionDefault = parcelHelpers.interopDefault(_useCustomerReviewAssignmentSelection);
const CustomerReviewAssignmentSection = (props)=>{
    const { customer, reviewId, assignments, selectedAssignmentId, readonly, onAssignmentsChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isCustomerRelationshipSelected, isCustomerRelationshipDisabled, isAssignmentDisabled, onAssignmentSelectionChange } = (0, _useCustomerReviewAssignmentSelectionDefault.default)(customer.reviews, onAssignmentsChange, reviewId, selectedAssignmentId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "headingSm",
                as: "h2",
                children: f("customer-review-assignment.labels.include-assignment")
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthRadioButtonDefault.default), {
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _displayNameDefault.default), {
                            name: (0, _displayHelpers.getCustomerName)(customer),
                            strong: true,
                            children: [
                                "(",
                                f("common.labels.customer-relationship"),
                                ")"
                            ]
                        }),
                        checked: isCustomerRelationshipSelected,
                        disabled: readonly || isCustomerRelationshipDisabled,
                        onChange: ()=>onAssignmentSelectionChange(undefined)
                    }),
                    assignments.map((assignment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthRadioButtonDefault.default), {
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentInfoDefault.default), {
                                assignmentName: assignment.name,
                                assignmentPurpose: assignment.purpose,
                                assignmentStartDate: assignment.created_dt,
                                isArchived: assignment.is_archived
                            }),
                            checked: selectedAssignmentId === assignment.id,
                            onChange: ()=>onAssignmentSelectionChange(assignment?.id),
                            disabled: readonly || isAssignmentDisabled(assignment)
                        }, assignment.id))
                ]
            })
        })
    });
};
exports.default = CustomerReviewAssignmentSection;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../AssignmentInfo/AssignmentInfo":"ds7XR","../DisplayName/DisplayName":"gKd5g","../FullWidthRadioButton/FullWidthRadioButton":"cK5m4","./useCustomerReviewAssignmentSelection":"1cRok","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1cRok":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _reviewsHelpers = require("../../helpers/reviews.helpers");
const useCustomerReviewAssignmentSelection = (reviews, onAssignmentsChange, reviewId, selectedAssignmentId)=>{
    // if there is a pending review that is NOT attached to an assignment then it is the customer relationship pending review
    const hasCustomerRelationshipPendingReview = reviews.some((review)=>(0, _reviewsHelpers.isPendingReview)(review) && !review.assignment);
    // set default touched to true in case there's already a customer relationship pending review
    // or that an assignment was already selected
    // touched is used to force the user to select what the review applies to by disabling checked of customer relationship
    // for new review
    const [touched, setTouched] = (0, _react.useState)(Boolean(reviewId && hasCustomerRelationshipPendingReview || selectedAssignmentId));
    // do not allow selecting an assignment that is not active or already has a pending review
    const isAssignmentDisabled = (assignment)=>!(0, _assignmentsHelpers.isActiveAssignment)(assignment) || reviews.some((review)=>(0, _reviewsHelpers.isPendingReview)(review) && review.assignment?.id === assignment.id);
    const onAssignmentSelectionChange = (assignmentId)=>{
        setTouched(true);
        onAssignmentsChange(assignmentId);
    };
    const isCustomerRelationshipSelected = touched && selectedAssignmentId === undefined;
    return {
        isCustomerRelationshipSelected,
        isCustomerRelationshipDisabled: hasCustomerRelationshipPendingReview,
        isAssignmentDisabled,
        onAssignmentSelectionChange
    };
};
exports.default = useCustomerReviewAssignmentSelection;

},{"react":"cOWTg","../../helpers/assignments.helpers":"7t8rY","../../helpers/reviews.helpers":"1oYIN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"nfa1z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _customerReviewChecklistForms = require("../CustomerReviewChecklistForms/CustomerReviewChecklistForms");
var _customerReviewChecklistFormsDefault = parcelHelpers.interopDefault(_customerReviewChecklistForms);
const CustomerReviewChecklistSection = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewChecklistFormsDefault.default), {
                ...props
            })
        })
    });
};
exports.default = CustomerReviewChecklistSection;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../CustomerReviewChecklistForms/CustomerReviewChecklistForms":"gBXJ0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gBXJ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _reviewChecklistForm = require("../ReviewChecklistForm/ReviewChecklistForm");
var _reviewChecklistFormDefault = parcelHelpers.interopDefault(_reviewChecklistForm);
var _reviewChecklistSelect = require("../ReviewChecklistSelect/ReviewChecklistSelect");
var _reviewChecklistSelectDefault = parcelHelpers.interopDefault(_reviewChecklistSelect);
var _useCustomerReviewChecklistForms = require("./useCustomerReviewChecklistForms");
var _useCustomerReviewChecklistFormsDefault = parcelHelpers.interopDefault(_useCustomerReviewChecklistForms);
const CustomerReviewChecklistForms = (props)=>{
    const { customerType, readonly, savedChecklistsAnswers, checklistsAnswers, addedChecklistsIds, manuallyRemovedChecklistIds, setManuallyRemovedChecklistsIds, onChecklistAnswersChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { loading, selectedChecklistsIds, checklistsAnswersMaps, getReviewChecklist, onSelectionChange, onChecklistRemove, onAnswerChange } = (0, _useCustomerReviewChecklistFormsDefault.default)(savedChecklistsAnswers || [], checklistsAnswers || [], manuallyRemovedChecklistIds, setManuallyRemovedChecklistsIds, onChecklistAnswersChange);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                align: "space-between",
                blockAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        blockAlign: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "h2",
                                variant: "headingSm",
                                children: f("customer.checklist.review.form.header")
                            }),
                            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistSelectDefault.default), {
                        checklistsIds: selectedChecklistsIds,
                        customerType: customerType,
                        onChange: onSelectionChange,
                        shouldDisplayConfirmation: (checklist)=>!(0, _checklistsHelpers.isChecklistEmpty)(checklistsAnswersMaps.get(checklist.id)),
                        readonly: readonly || loading
                    })
                ]
            }),
            !loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                gap: "4",
                children: checklistsAnswers?.map((checklistAnswers)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledKDKBanner, {
                        hideIcon: true,
                        hideBorder: true,
                        id: (0, _checklistsHelpers.getChecklistAnchorId)(checklistAnswers.checklist_id),
                        status: addedChecklistsIds.includes(checklistAnswers.checklist_id) ? "info" : undefined,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistFormDefault.default), {
                            checklist: getReviewChecklist(checklistAnswers),
                            answers: checklistsAnswersMaps.get(checklistAnswers.checklist_id),
                            onChange: (questionId, answer, text)=>onAnswerChange(checklistAnswers, questionId, answer, text),
                            onRemove: ()=>onChecklistRemove(checklistAnswers.checklist_id),
                            readonly: readonly
                        })
                    }, checklistAnswers.checklist_id))
            })
        ]
    });
};
const StyledKDKBanner = (0, _styledComponentsDefault.default)((0, _kdkbannerDefault.default))`
  scroll-margin-top: calc(var(--kdk-toolbar-height) + var(--kdk-message-offset) + var(--p-space-4));
`;
exports.default = CustomerReviewChecklistForms;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../KDKBanner/KDKBanner":"3zPW6","../ReviewChecklistForm/ReviewChecklistForm":"4ZXsH","../ReviewChecklistSelect/ReviewChecklistSelect":"05jor","./useCustomerReviewChecklistForms":"eVs0t","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4ZXsH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useTranslatedText = require("../../hooks/useTranslatedText");
var _useTranslatedTextDefault = parcelHelpers.interopDefault(_useTranslatedText);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reviewChecklistAnswerForm = require("../ReviewChecklistAnswerForm/ReviewChecklistAnswerForm");
var _reviewChecklistAnswerFormDefault = parcelHelpers.interopDefault(_reviewChecklistAnswerForm);
var _reviewChecklistRemoveConfirm = require("../ReviewChecklistRemoveConfirm/ReviewChecklistRemoveConfirm");
var _reviewChecklistRemoveConfirmDefault = parcelHelpers.interopDefault(_reviewChecklistRemoveConfirm);
const ReviewChecklistForm = (props)=>{
    const { checklist, answers, readonly, onChange, onRemove } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const t = (0, _useTranslatedTextDefault.default)();
    const [showConfirm, toggleShowConfirm, closeConfirm] = (0, _useOpenCloseDefault.default)();
    const onConfirmRemove = ()=>{
        closeConfirm();
        onRemove && onRemove();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                align: "space-between",
                blockAlign: "start",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Label), {
                                id: "",
                                requiredIndicator: checklist.is_required,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    variant: "headingMd",
                                    children: checklist.name
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "p",
                                color: "subdued",
                                children: checklist.description
                            })
                        ]
                    }),
                    onRemove && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledRemoveButton, {
                        icon: (0, _trashSvgDefault.default),
                        disabled: readonly || checklist.is_required,
                        onClick: (0, _checklistsHelpers.isChecklistEmpty)(answers) ? onRemove : toggleShowConfirm,
                        children: f("default.remove")
                    })
                ]
            }),
            checklist.questions.map((question)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistAnswerFormDefault.default), {
                    label: t(question.text),
                    answer: answers.get(question.id)?.answer,
                    text: answers.get(question.id)?.additional_info,
                    readonly: readonly,
                    onChange: (answer, text)=>onChange(question.id, answer, text)
                }, question.id)),
            showConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistRemoveConfirmDefault.default), {
                checklistName: checklist.name,
                onYes: onConfirmRemove,
                onNo: closeConfirm
            })
        ]
    });
};
const StyledRemoveButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default)).attrs({
    plain: true,
    monochrome: true,
    removeUnderline: true
})`
  // prevent button from shrinking in case the checklist description is too long
  flex: 0;
`;
exports.default = ReviewChecklistForm;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/trash.svg":"jqW55","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useTranslatedText":"lODeq","../extensions/Button":"8exc0","../ReviewChecklistAnswerForm/ReviewChecklistAnswerForm":"bzr5X","../ReviewChecklistRemoveConfirm/ReviewChecklistRemoveConfirm":"eyaGk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bzr5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _fullWidthRadioButton = require("../FullWidthRadioButton/FullWidthRadioButton");
var _fullWidthRadioButtonDefault = parcelHelpers.interopDefault(_fullWidthRadioButton);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
const ReviewChecklistAnswerForm = (props)=>{
    const { label, answer, text, readonly, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const id = (0, _util.uniqueId)("ReviewChecklistAnswerForm");
    const name = `${label}-answer`;
    const isEmptyText = answer === true && (0, _stringUtils.isEmptyString)(text);
    const error = isEmptyText ? f("review.checklist.answer.error.empty-additional-info") : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Label), {
                id: id,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                distribution: "fill",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthRadioButtonDefault.default), {
                        label: f("default.yes"),
                        checked: answer === true,
                        name: name,
                        onChange: ()=>onChange(true, text),
                        disabled: readonly
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthRadioButtonDefault.default), {
                        label: f("default.no"),
                        name: name,
                        checked: answer === false,
                        onChange: ()=>onChange(false, text),
                        disabled: readonly
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                id: id,
                open: answer === true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                    label: label,
                    placeholder: f("review.checklist.answer.placeholder"),
                    labelHidden: true,
                    autoComplete: "on",
                    multiline: 3,
                    autoFocus: true,
                    value: text || "",
                    disabled: readonly,
                    debounceError: true,
                    error: error,
                    onChange: (value)=>onChange(answer === true, value)
                })
            })
        ]
    });
};
exports.default = ReviewChecklistAnswerForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","../FullWidthRadioButton/FullWidthRadioButton":"cK5m4","../KDKTextField/KDKTextField":"b5QRp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eyaGk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirm = require("../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
const ReviewChecklistRemoveConfirm = (props)=>{
    const { checklistName, ...confirmProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
        title: f("component.review.checklist.form.remove.confirmation.title"),
        description: f("component.review.checklist.form.remove.confirmation.description", {
            name: checklistName
        }),
        actionTitle: f("default.remove"),
        ...confirmProps
    });
};
exports.default = ReviewChecklistRemoveConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","../Confirm/Confirm":"nqTPc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"05jor":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _plusMajorSvg = require("../../../assets/icons/plus-major.svg");
var _plusMajorSvgDefault = parcelHelpers.interopDefault(_plusMajorSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../utils/collectionUtils");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _popoverButton = require("../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _reviewChecklistRemoveConfirm = require("../ReviewChecklistRemoveConfirm/ReviewChecklistRemoveConfirm");
var _reviewChecklistRemoveConfirmDefault = parcelHelpers.interopDefault(_reviewChecklistRemoveConfirm);
var _reviewChecklistsList = require("./ReviewChecklistsList");
var _reviewChecklistsListDefault = parcelHelpers.interopDefault(_reviewChecklistsList);
const ReviewChecklistSelect = (props)=>{
    const { checklistsIds, customerType, readonly, onChange, shouldDisplayConfirmation } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [checklist, setChecklist] = (0, _react.useState)();
    const fireSelectionEvent = (onClose, checklist)=>{
        const selectedIds = !checklist ? [] : (0, _collectionUtils.toggleElement)(checklistsIds, checklist.id);
        onClose();
        setChecklist(undefined);
        onChange(selectedIds);
    };
    const handleChecklistSelect = (onClose, checklist)=>{
        if (checklist && checklistsIds.includes(checklist?.id) && shouldDisplayConfirmation(checklist)) setChecklist(checklist);
        else fireSelectionEvent(onClose, checklist);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
        label: f("component.review.checklist.select.button.label.add"),
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _plusMajorSvgDefault.default),
            width: "12px",
            height: "12px",
            useMask: true
        }),
        size: "slim",
        disabled: readonly,
        fullWidth: false,
        render: (onClose)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Popover).Section, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistsListDefault.default), {
                        selectedIds: checklistsIds,
                        customerType: customerType,
                        readonly: readonly,
                        onSelect: (checklist)=>handleChecklistSelect(onClose, checklist)
                    }),
                    checklist && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistRemoveConfirmDefault.default), {
                        checklistName: checklist.name,
                        onYes: ()=>fireSelectionEvent(onClose, checklist),
                        onNo: ()=>setChecklist(undefined)
                    })
                ]
            })
    });
};
exports.default = ReviewChecklistSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/plus-major.svg":"fCy4K","../../hooks/useFormatMessage":"8Y8fq","../../utils/collectionUtils":"gr5mc","../extensions/Icon":"eHSf0","../PopoverButton/PopoverButton":"ihB8F","../ReviewChecklistRemoveConfirm/ReviewChecklistRemoveConfirm":"eyaGk","./ReviewChecklistsList":"9ouop","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9ouop":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _checklistSvg = require("../../../assets/icons/Checklist.svg");
var _checklistSvgDefault = parcelHelpers.interopDefault(_checklistSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetReviewChecklists = require("../../hooks/useGetReviewChecklists");
var _useGetReviewChecklistsDefault = parcelHelpers.interopDefault(_useGetReviewChecklists);
var _entitiesList = require("../EntitiesList/EntitiesList");
var _entitiesListDefault = parcelHelpers.interopDefault(_entitiesList);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const ReviewChecklistsList = (props)=>{
    const { customerType, selectedIds, ...entitiesListProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { data, isLoading, error } = (0, _useGetReviewChecklistsDefault.default)();
    const checklistsToDisplay = data?.checklists.filter((checklist)=>// filter by customer type
        (!checklist.customer_type || checklist.customer_type === customerType || checklist.customer_type === "both") && // filter archived
        (!checklist.is_archived || selectedIds.includes(checklist.id)));
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                size: "small"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("component.review.checklist.select.checklists-list.loading")
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: error,
        actionTitle: f("component.review.checklist.select.checklists-list.loading.error")
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entitiesListDefault.default), {
        entities: checklistsToDisplay || [],
        selectedIds: selectedIds,
        getEntityLabel: (checklist)=>checklist.name,
        getEntityHelpText: (checklist)=>checklist.description,
        getEntityPrefix: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _checklistSvgDefault.default)
            }),
        isEntityDisabled: (checklist)=>checklist.is_archived || checklist.is_required && selectedIds.includes(checklist.id),
        selectedFirst: true,
        filterLabel: f("component.review.checklist.select.checklists-list.filter.label"),
        ...entitiesListProps
    });
};
exports.default = ReviewChecklistsList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/Checklist.svg":"5vsgR","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetReviewChecklists":"lxc8X","../EntitiesList/EntitiesList":"ce1Sz","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5vsgR":[function(require,module,exports) {
module.exports = require("6b068e3981883d85").getBundleURL("kEMsi") + "Checklist.ba951e88.svg";

},{"6b068e3981883d85":"75UoR"}],"lxc8X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
const useGetReviewChecklists = ()=>{
    return (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS
    ], (0, _apiDefault.default).getReviewChecklists, {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
};
exports.default = useGetReviewChecklists;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eVs0t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useGetReviewChecklists = require("../../hooks/useGetReviewChecklists");
var _useGetReviewChecklistsDefault = parcelHelpers.interopDefault(_useGetReviewChecklists);
var _collectionUtils = require("../../utils/collectionUtils");
// this hook handles handlers for managing checklist answers
const useCustomerReviewChecklistForms = (savedChecklistAnswers, checklistAnswers, manuallyRemovedChecklistIds, setManuallyRemovedChecklistsIds, onChecklistAnswersChange)=>{
    const features = (0, _useFeaturesDefault.default)();
    const { data, isLoading } = (0, _useGetReviewChecklistsDefault.default)();
    // a map of saved checklists from a saved/pending review
    const [savedChecklistAnswersMap, setSavedChecklistAnswersMap] = (0, _react.useState)(new Map(savedChecklistAnswers.map((checklistAnswers)=>[
            checklistAnswers.checklist.id,
            checklistAnswers.checklist
        ])));
    const selectedChecklistsIds = checklistAnswers.map((checklist)=>checklist.checklist_id) || [];
    const loading = isLoading && selectedChecklistsIds.length > 0;
    // a map that contains ALL the answers for multiple checklists
    const checklistsAnswersMaps = new Map(checklistAnswers.map((checklistAnswer)=>[
            checklistAnswer.checklist_id,
            new Map(checklistAnswer.answers.map((answer)=>[
                    answer.question_id,
                    answer
                ]))
        ]));
    const getReviewChecklist = (checklistAnswers)=>{
        const checklist = savedChecklistAnswersMap.get(checklistAnswers.checklist_id) || data?.checklists.find((reviewChecklist)=>reviewChecklist.id === checklistAnswers.checklist_id);
        return checklist;
    };
    const onSelectionChange = (checklistsIds)=>{
        // remove the added checklistsIds from the manually removed list since they were just added manually by the user
        setManuallyRemovedChecklistsIds([
            ...new Set([
                ...manuallyRemovedChecklistIds,
                ...(0, _collectionUtils.delta)(selectedChecklistsIds, checklistsIds)[0]
            ])
        ]);
        const defaultAnswer = features.REVIEW__CHECKLIST_DEFAULT_TO_NO ? false : undefined;
        const updatedChecklistAnswers = checklistsIds.map((checklistId)=>checklistAnswers.find((checklistAnswer)=>checklistAnswer.checklist_id === checklistId) || (0, _checklistsHelpers.createChecklistAnswers)(data.checklists.find((reviewChecklist)=>reviewChecklist.id === checklistId), defaultAnswer));
        onChecklistAnswersChange(updatedChecklistAnswers);
    };
    const onChecklistRemove = (checklistId)=>{
        // save the removed checklist id so it will not be automatically added again
        setManuallyRemovedChecklistsIds([
            ...new Set([
                ...manuallyRemovedChecklistIds,
                checklistId
            ])
        ]);
        setSavedChecklistAnswersMap((prevState)=>{
            // remove the checklist from saved answers checklists map if it exists there
            const updatedMap = new Map(prevState);
            updatedMap.delete(checklistId);
            return updatedMap;
        });
        onChecklistAnswersChange(checklistAnswers.filter((answer)=>checklistId !== answer.checklist_id) || []);
    };
    const onAnswerChange = (allAnswers, questionId, value, text)=>{
        let answers = allAnswers.answers;
        if (allAnswers.answers.some((answer)=>answer.question_id === questionId)) // update the answer with a matching question_id
        answers = allAnswers.answers.map((answer)=>answer.question_id === questionId ? {
                ...answer,
                answer: value,
                additional_info: value ? text : ""
            } : answer);
        else // add as a new answer
        answers.push({
            question_id: questionId,
            answer: value,
            additional_info: value ? text : ""
        });
        // update the answer in the given checklistAnswers (allAnswers)
        const updatedChecklistAnswers = {
            ...allAnswers,
            answers
        };
        // update all the checklist answers
        const updatedValues = checklistAnswers.map((checklistAnswer)=>checklistAnswer.checklist_id === allAnswers.checklist_id ? updatedChecklistAnswers : checklistAnswer);
        onChecklistAnswersChange(updatedValues);
    };
    return {
        loading,
        selectedChecklistsIds,
        checklistsAnswersMaps,
        getReviewChecklist,
        onSelectionChange,
        onChecklistRemove,
        onAnswerChange
    };
};
exports.default = useCustomerReviewChecklistForms;

},{"react":"cOWTg","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFeatures":"hvBWb","../../hooks/useGetReviewChecklists":"lxc8X","../../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2fXBG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _customerReviewApproveRejectToolbar = require("../CustomerReviewApproveRejectToolbar/CustomerReviewApproveRejectToolbar");
var _customerReviewApproveRejectToolbarDefault = parcelHelpers.interopDefault(_customerReviewApproveRejectToolbar);
var _customerReviewEditToolbar = require("../CustomerReviewEditToolbar/CustomerReviewEditToolbar");
var _customerReviewEditToolbarDefault = parcelHelpers.interopDefault(_customerReviewEditToolbar);
const CustomerReviewControlsSection = (props)=>{
    const { isPossibleToApprove, customer, reviewId, isInvalidReview, readonly, canBeDeleted, isDirty, saveReviewMutation, completeReviewMutation, onBackNavigation } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
            children: [
                isPossibleToApprove && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewApproveRejectToolbarDefault.default), {
                    customer: customer,
                    reviewId: reviewId,
                    onBackNavigation: onBackNavigation
                }),
                !isPossibleToApprove && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewEditToolbarDefault.default), {
                    customer: customer,
                    reviewId: reviewId,
                    isInvalidReview: isInvalidReview,
                    canBeDeleted: canBeDeleted,
                    isDirty: isDirty,
                    readonly: readonly,
                    onBackNavigation: onBackNavigation,
                    saveReviewMutation: saveReviewMutation,
                    completeReviewMutation: completeReviewMutation
                })
            ]
        })
    });
};
exports.default = CustomerReviewControlsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../CustomerReviewApproveRejectToolbar/CustomerReviewApproveRejectToolbar":"9x3Op","../CustomerReviewEditToolbar/CustomerReviewEditToolbar":"hlKX6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9x3Op":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _customerReviewApproveConfirm = require("../CustomerReviewApproveConfirm/CustomerReviewApproveConfirm");
var _customerReviewApproveConfirmDefault = parcelHelpers.interopDefault(_customerReviewApproveConfirm);
var _customerReviewRejectConfirm = require("../CustomerReviewRejectConfirm/CustomerReviewRejectConfirm");
var _customerReviewRejectConfirmDefault = parcelHelpers.interopDefault(_customerReviewRejectConfirm);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CustomerReviewApproveRejectToolbar = (props)=>{
    const { customer, reviewId, onBackNavigation } = props;
    const [action, setAction] = (0, _react.useState)();
    const clearAction = ()=>setAction(undefined);
    const f = (0, _useFormatMessageDefault.default)();
    const onSuccess = ()=>{
        clearAction();
        onBackNavigation();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        align: "space-between",
        blockAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                onClick: onBackNavigation,
                children: f("default.cancel")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                blockAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        destructive: true,
                        onClick: ()=>setAction("reject"),
                        children: f("details.reviews.confirm.reject")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledConfirmButton, {
                        primary: true,
                        monochrome: true,
                        onClick: ()=>setAction("approve"),
                        children: f("details.reviews.confirm.approve")
                    })
                ]
            }),
            action === "approve" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewApproveConfirmDefault.default), {
                customer: customer,
                reviewId: reviewId,
                onSuccess: onSuccess,
                onCancel: clearAction
            }),
            action === "reject" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewRejectConfirmDefault.default), {
                customer: customer,
                reviewId: reviewId,
                onSuccess: onSuccess,
                onCancel: clearAction
            })
        ]
    });
};
const StyledConfirmButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  & .Polaris-Button--primary {
    --pc-button-color: var(--kdk-dark-success);

    &:hover {
      background: var(--kdk-dark-success);
      filter: brightness(0.9);
    }
    &:active {
      background: var(--kdk-dark-success);
      filter: brightness(0.8);
    }
  }
`;
exports.default = CustomerReviewApproveRejectToolbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../CustomerReviewApproveConfirm/CustomerReviewApproveConfirm":"eyKn6","../CustomerReviewRejectConfirm/CustomerReviewRejectConfirm":"9qP0K","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eyKn6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useCustomerReviewApproveReject = require("../../hooks/useCustomerReviewApproveReject");
var _useCustomerReviewApproveRejectDefault = parcelHelpers.interopDefault(_useCustomerReviewApproveReject);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _confirm = require("../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
const CustomerReviewApproveConfirm = (props)=>{
    const { customer, reviewId, onSuccess, onCancel } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const [reason, setReason] = (0, _react.useState)("");
    const { approveReviewMutation } = (0, _useCustomerReviewApproveRejectDefault.default)(customer, reviewId);
    const handleReviewApprove = ()=>{
        setReason("");
        onSuccess();
        setSnackbar(f("common.labels.approved"));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
        isOpen: true,
        title: f("details.reviews.confirm.approve-reject.title"),
        onYes: ()=>approveReviewMutation.mutate(reason, {
                onSuccess: handleReviewApprove
            }),
        onNo: onCancel,
        isDestructive: false,
        actionTitle: f("details.reviews.confirm.approve"),
        cancelTitle: f("default.cancel"),
        isActionInProgress: approveReviewMutation.isLoading,
        error: approveReviewMutation.error,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
            label: f("details.reviews.confirm.approve-reject.title"),
            labelHidden: true,
            value: reason,
            multiline: 6,
            autoFocus: true,
            autoComplete: "on",
            disabled: approveReviewMutation.isLoading,
            onChange: setReason
        })
    });
};
exports.default = CustomerReviewApproveConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useCustomerReviewApproveReject":"11gMz","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSnackbar":"gQ3G9","../Confirm/Confirm":"nqTPc","../KDKTextField/KDKTextField":"b5QRp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"11gMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _utilities = require("../types/utilities");
var _collectionUtils = require("../utils/collectionUtils");
var _useCustomerReviewCreateNoteMutation = require("./useCustomerReviewCreateNoteMutation");
var _useCustomerReviewCreateNoteMutationDefault = parcelHelpers.interopDefault(_useCustomerReviewCreateNoteMutation);
var _useQueryData = require("./useQueryData");
const useCustomerReviewApproveReject = (customer, reviewId)=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const createNoteMutation = (0, _useCustomerReviewCreateNoteMutationDefault.default)(customer.id, reviewId);
    const handlePendingReviewApproval = (customerReviewApproval, reviewId)=>{
        updateQueryData((queryData)=>{
            const review = queryData.reviews.find((review)=>review.id === reviewId);
            queryData.reviews = (0, _collectionUtils.updateItem)(queryData.reviews, {
                ...review,
                approval: customerReviewApproval
            });
            if (customerReviewApproval.is_approved) {
                queryData.risk_level = review.risk_level || "NOT_SET";
                queryData.is_pep = Boolean(review.is_pep);
                queryData.is_sanctioned = Boolean(review.is_sanctioned);
            }
        });
        // invalidate the entire query in order to get the customer review status from the server
        // it might not change even though there's a customer review (for example, if there are unresolved match cases)
        queryClient.invalidateQueries((0, _utilities.getCustomerQueryKey)(customer));
    };
    const approveReviewMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).approveCustomerReview(customer.id, reviewId), {
        onSuccess: async (response, note)=>{
            await createNoteMutation.mutateAsync(note);
            handlePendingReviewApproval(response, reviewId);
        }
    });
    const rejectReviewMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).rejectCustomerReview(customer.id, reviewId), {
        onSuccess: async (response, note)=>{
            await createNoteMutation.mutateAsync(note);
            handlePendingReviewApproval(response, reviewId);
        }
    });
    return {
        approveReviewMutation,
        rejectReviewMutation
    };
};
exports.default = useCustomerReviewApproveReject;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../types/utilities":"6zLpB","../utils/collectionUtils":"gr5mc","./useCustomerReviewCreateNoteMutation":"kERLL","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kERLL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useCustomerReviewCreateNoteMutation = (customerId, reviewId)=>{
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_NOTES,
        customerId,
        reviewId
    ]);
    const createNoteMutation = (0, _reactQuery.useMutation)((comment)=>(0, _apiDefault.default).createCustomerReviewNotation(customerId, reviewId, {
            comment
        }), {
        onSuccess: (newNote)=>{
            updateQueryData((prevNotes)=>prevNotes.unshift(newNote));
        }
    });
    return createNoteMutation;
};
exports.default = useCustomerReviewCreateNoteMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9qP0K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useCustomerReviewApproveReject = require("../../hooks/useCustomerReviewApproveReject");
var _useCustomerReviewApproveRejectDefault = parcelHelpers.interopDefault(_useCustomerReviewApproveReject);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _confirm = require("../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
const CustomerReviewRejectConfirm = (props)=>{
    const { customer, reviewId, onSuccess, onCancel } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const [reason, setReason] = (0, _react.useState)("");
    const { rejectReviewMutation } = (0, _useCustomerReviewApproveRejectDefault.default)(customer, reviewId);
    const handleReviewReject = ()=>{
        setReason("");
        onSuccess();
        setSnackbar(f("common.labels.rejected"));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
        isOpen: true,
        title: f("details.reviews.confirm.approve-reject.title"),
        onYes: ()=>rejectReviewMutation.mutate(reason, {
                onSuccess: handleReviewReject
            }),
        onNo: onCancel,
        actionTitle: f("details.reviews.confirm.reject"),
        cancelTitle: f("default.cancel"),
        isActionInProgress: rejectReviewMutation.isLoading,
        descriptionAlign: "left",
        description: f("details.reviews.confirm.reject.description"),
        error: rejectReviewMutation.error,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
            label: f("details.reviews.confirm.approve-reject.title"),
            labelHidden: true,
            value: reason,
            multiline: 6,
            autoFocus: true,
            autoComplete: "on",
            disabled: rejectReviewMutation.isLoading,
            onChange: setReason
        })
    });
};
exports.default = CustomerReviewRejectConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useCustomerReviewApproveReject":"11gMz","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSnackbar":"gQ3G9","../Confirm/Confirm":"nqTPc","../KDKTextField/KDKTextField":"b5QRp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hlKX6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useCustomerReviewDelete = require("../../hooks/useCustomerReviewDelete");
var _useCustomerReviewDeleteDefault = parcelHelpers.interopDefault(_useCustomerReviewDelete);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _confirm = require("../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CustomerReviewEditToolbar = (props)=>{
    const { customer, reviewId, isInvalidReview, readonly, canBeDeleted, isDirty, onBackNavigation, saveReviewMutation, completeReviewMutation } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const [isDeleteConfirmOpen, toggleDeleteConfirm, closeDeleteConfirm] = (0, _useOpenCloseDefault.default)();
    const [isCancelConfirmOpen, toggleCancelConfirm, closeCancelConfirm] = (0, _useOpenCloseDefault.default)();
    const deleteCustomerReviewMutation = (0, _useCustomerReviewDeleteDefault.default)(customer, reviewId);
    const isLoading = saveReviewMutation.isLoading || completeReviewMutation.isLoading;
    const isError = saveReviewMutation.isError || completeReviewMutation.isError || deleteCustomerReviewMutation.isError;
    const error = saveReviewMutation.error || completeReviewMutation.error || deleteCustomerReviewMutation.error;
    const disabled = readonly || isLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                align: "space-between",
                blockAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "2",
                        children: [
                            canBeDeleted && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                disabled: disabled,
                                onClick: toggleDeleteConfirm,
                                children: f("details.reviews.labels.delete")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: isDirty && !readonly ? toggleCancelConfirm : onBackNavigation,
                                disabled: isLoading,
                                children: f("default.cancel")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "2",
                        children: [
                            features.REVIEW__SAVE_AND_CONTINUE && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: saveReviewMutation.mutate,
                                disabled: disabled,
                                loading: saveReviewMutation.isLoading,
                                children: f("details.reviews.labels.save-and-continue")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: completeReviewMutation.mutate,
                                primary: true,
                                disabled: disabled || isInvalidReview,
                                loading: completeReviewMutation.isLoading,
                                children: f("common.labels.complete")
                            }),
                            isDeleteConfirmOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                                apiCall: ()=>deleteCustomerReviewMutation.mutateAsync(),
                                title: f("details.reviews.confirm.delete.title"),
                                description: f("details.reviews.confirm.delete.description"),
                                onNo: closeDeleteConfirm,
                                onSuccess: onBackNavigation,
                                cancelTitle: f("default.no"),
                                actionTitle: f("details.reviews.labels.confirm-delete")
                            }),
                            isCancelConfirmOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
                                title: f("details.reviews.confirm.cancel.title"),
                                description: f("details.reviews.confirm.cancel.description"),
                                onNo: closeCancelConfirm,
                                onYes: onBackNavigation,
                                cancelTitle: f("default.no"),
                                actionTitle: f("details.reviews.labels.cancel")
                            })
                        ]
                    })
                ]
            }),
            isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: error
            })
        ]
    });
};
exports.default = CustomerReviewEditToolbar;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useCustomerReviewDelete":"72HEK","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../Confirm/Confirm":"nqTPc","../ConfirmAction/ConfirmAction":"icP5J","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"72HEK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useQueryData = require("./useQueryData");
const useCustomerReviewDelete = (customer, reviewId)=>{
    const updateQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const deleteCustomerReviewMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).deleteCustomerReview(customer.id, reviewId), {
        onSuccess: ()=>{
            updateQueryData((queryData)=>{
                queryData.reviews = queryData.reviews.filter((review)=>review.id !== reviewId);
            });
        }
    });
    return deleteCustomerReviewMutation;
};
exports.default = useCustomerReviewDelete;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9LbW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _completedSignature = require("./CompletedSignature");
var _completedSignatureDefault = parcelHelpers.interopDefault(_completedSignature);
const CustomerReviewDisclosuresSection = (props)=>{
    const { signatures } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            title: f("common.labels.kyc-responses"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Scrollable), {
                vertical: true,
                horizontal: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                    gap: "2",
                    children: signatures.map((signature)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completedSignatureDefault.default), {
                            signature: signature
                        }, signature.id))
                })
            })
        })
    });
};
exports.default = CustomerReviewDisclosuresSection;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","./CompletedSignature":"6hTtk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6hTtk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _checkmarkGreenSvg = require("jsx:../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetDisclosureCountryRiskInformation = require("../../hooks/useGetDisclosureCountryRiskInformation");
var _useGetDisclosureCountryRiskInformationDefault = parcelHelpers.interopDefault(_useGetDisclosureCountryRiskInformation);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _completedDisclosureDocumentSignature = require("../DisclosureDocumentSection/DisclosureDocumentSignature/CompletedDisclosureDocumentSignature");
var _completedDisclosureDocumentSignatureDefault = parcelHelpers.interopDefault(_completedDisclosureDocumentSignature);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _flatCard = require("../FlatCard/FlatCard");
var _flatCardDefault = parcelHelpers.interopDefault(_flatCard);
var _warningBadge = require("../WarningBadge/WarningBadge");
var _warningBadgeDefault = parcelHelpers.interopDefault(_warningBadge);
const CompletedSignature = (props)=>{
    const { signature } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getSignatureRiskAnswersCount } = (0, _useGetDisclosureCountryRiskInformationDefault.default)();
    const signatureRiskAnswersCount = getSignatureRiskAnswersCount(signature);
    const haveHighRiskAnswers = signatureRiskAnswersCount > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFlatCard, {
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completedDisclosureDocumentSignatureDefault.default), {
            signature: signature,
            hideSignedUserInfo: true,
            useSmallButton: true,
            vertical: true,
            children: haveHighRiskAnswers && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningBadgeDefault.default), {
                children: f("common.labels.risk-response")
            })
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "2",
            align: "space-between",
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "1",
                    blockAlign: "center",
                    wrap: false,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkGreenSvgDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                            name: (0, _displayHelpers.getFullName)(signature.person)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                        date: signature.signed_dt
                    })
                })
            ]
        })
    }, signature.id);
};
const StyledFlatCard = (0, _styledComponentsDefault.default)((0, _flatCardDefault.default))`
  border-color: var(--p-border-success-subdued);
  background-color: var(--p-surface-success-subdued);

  ${(0, _flatCard.StyledFlatCardFooter)} {
    border-top: none;
    border-color: var(--p-border-success-subdued);
    background-color: var(--p-surface-success-subdued);
  }
`;
exports.default = CompletedSignature;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","jsx:../../../assets/icons/checkmark-green.svg":"bZbD3","styled-components":"eBrdC","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetDisclosureCountryRiskInformation":"isCim","../CondensedText/CondensedText":"1FshD","../CustomDate/CustomDate":"5KD00","../DisclosureDocumentSection/DisclosureDocumentSignature/CompletedDisclosureDocumentSignature":"bEgSk","../DisplayName/DisplayName":"gKd5g","../FlatCard/FlatCard":"dh1eC","../WarningBadge/WarningBadge":"28RLb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bZbD3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckmarkGreen = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10z",
                fill: "#149421"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.179 13.305c.24.24.565.345.878.315.25-.02.497-.125.688-.317l5.025-5.024a1.092 1.092 0 0 0 0-1.545l-.04-.04a1.092 1.092 0 0 0-1.545 0L8.961 10.92 6.826 8.784a1.092 1.092 0 0 0-1.545 0l-.04.04a1.092 1.092 0 0 0 0 1.544l2.938 2.937zM5.937 8.78a.783.783 0 0 1 .67.222l2.353 2.352L6.608 9a.783.783 0 0 0-.67-.22zm7.905-2.09a.783.783 0 0 1 .669.222l.04.04a.785.785 0 0 1 0 1.11l-5.025 5.024a.78.78 0 0 1 .002 0l5.024-5.025a.785.785 0 0 0 0-1.11l-.04-.039a.783.783 0 0 0-.67-.221z",
                fill: "#fff"
            })
        ]
    });
exports.default = SvgCheckmarkGreen;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jtZRa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _reviewChecklistAnswers = require("../ReviewChecklistAnswers/ReviewChecklistAnswers");
var _reviewChecklistAnswersDefault = parcelHelpers.interopDefault(_reviewChecklistAnswers);
var _tagsEditor = require("../TagsEditor/TagsEditor");
var _tagsEditorDefault = parcelHelpers.interopDefault(_tagsEditor);
const CustomerReviewFormSection = (props)=>{
    const { review, readonly, onFieldChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
                hideIcon: true,
                hideBorder: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingSm",
                            as: "h2",
                            children: f("reviews.labels.review-header")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingXs",
                                    as: "h3",
                                    children: f("reviews.labels.review-label")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "p",
                                    color: "subdued",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistAnswersDefault.default), {
                                        checklistAnswers: review.checklist_answers
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                    label: f("reviews.labels.review-label"),
                                    labelHidden: true,
                                    value: review.comment,
                                    placeholder: f("reviews.placeholders.review-rational"),
                                    onChange: (value)=>onFieldChange("comment", value),
                                    multiline: 4,
                                    id: "text",
                                    autoComplete: "off",
                                    disabled: readonly
                                })
                            ]
                        }),
                        features.REVIEW_LABELS && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsEditorDefault.default), {
                                    tags: review.labels,
                                    readonly: readonly,
                                    onChange: (tags)=>onFieldChange("labels", tags),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingXs",
                                        as: "h3",
                                        children: f("reviews.labels.risk-tags")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingXs",
                                    as: "h3",
                                    children: f("reviews.labels.mark-as")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "8",
                                    blockAlign: "center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                            label: f("reviews.labels.mark-as.pep"),
                                            checked: review.is_pep,
                                            disabled: readonly,
                                            onChange: (value)=>onFieldChange("is_pep", value)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                            label: f("reviews.labels.mark-as.sanction"),
                                            checked: review.is_sanctioned,
                                            disabled: readonly,
                                            onChange: (value)=>onFieldChange("is_sanctioned", value)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
exports.default = CustomerReviewFormSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../KDKBanner/KDKBanner":"3zPW6","../KDKTextField/KDKTextField":"b5QRp","../ReviewChecklistAnswers/ReviewChecklistAnswers":"bfJQ8","../TagsEditor/TagsEditor":"99V3w","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"99V3w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _plusMajorSvg = require("../../../assets/icons/plus-major.svg");
var _plusMajorSvgDefault = parcelHelpers.interopDefault(_plusMajorSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _tagHelpers = require("../../helpers/tag.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _collectionUtils = require("../../utils/collectionUtils");
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdktag = require("../KDKTag/KDKTag");
var _kdktagDefault = parcelHelpers.interopDefault(_kdktag);
var _tagsEditorPopover = require("../TagsEditorPopover/TagsEditorPopover");
var _tagsEditorPopoverDefault = parcelHelpers.interopDefault(_tagsEditorPopover);
const TagsEditor = (props)=>{
    const { tags = [], readonly, onChange, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { allTags } = (0, _useTagsDefault.default)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS
    ]);
    const createNewTagMutation = (0, _reactQuery.useMutation)((0, _apiDefault.default).createLabel, {
        onSuccess: (newTag)=>{
            updateQueryData((queryData)=>{
                queryData.labels = [
                    ...queryData.labels,
                    newTag
                ].sort((tagA, tagB)=>(0, _tagHelpers.getTagTitle)(tagA).toLocaleLowerCase().localeCompare((0, _tagHelpers.getTagTitle)(tagB).toLocaleLowerCase()));
                queryData.count += 1;
            });
            onChange([
                ...tags,
                newTag
            ]);
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                distribution: "equalSpacing",
                alignment: "center",
                children: [
                    children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTagsEditorPopover, {
                        tags: allTags,
                        selectedTags: tags,
                        disabled: readonly,
                        label: f("common.labels.create-tag"),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _plusMajorSvgDefault.default),
                            useMask: true,
                            height: "12px",
                            width: "12px"
                        }),
                        onSelectionChange: onChange,
                        onNewTag: (title)=>createNewTagMutation.mutate({
                                title
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: tags.map((tag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktagDefault.default), {
                        tag: tag,
                        onRemove: !readonly ? ()=>onChange((0, _collectionUtils.removeItem)(tags, tag)) : undefined
                    }, tag.id))
            })
        ]
    });
};
const StyledTagsEditorPopover = (0, _styledComponentsDefault.default)((0, _tagsEditorPopoverDefault.default))`
  & .Polaris-Button {
    box-shadow: none;
  }
`;
exports.default = TagsEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../assets/icons/plus-major.svg":"fCy4K","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../helpers/tag.helpers":"ecpII","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../hooks/useTags":"31uzS","../../utils/collectionUtils":"gr5mc","../extensions/Icon":"eHSf0","../KDKTag/KDKTag":"8koxk","../TagsEditorPopover/TagsEditorPopover":"auX01","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6v0ka":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetCustomerReviewGuideline = require("../../hooks/useGetCustomerReviewGuideline");
var _useGetCustomerReviewGuidelineDefault = parcelHelpers.interopDefault(_useGetCustomerReviewGuideline);
var _collapsibleSection = require("../CollapsibleSection/CollapsibleSection");
var _collapsibleSectionDefault = parcelHelpers.interopDefault(_collapsibleSection);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _markdownContent = require("../MarkdownContent/MarkdownContent");
var _markdownContentDefault = parcelHelpers.interopDefault(_markdownContent);
const CustomerReviewGuidelineSection = (props)=>{
    const { customerType, timestamp } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const guideline = (0, _useGetCustomerReviewGuidelineDefault.default)(customerType, timestamp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsibleSectionDefault.default), {
            title: guideline?.title || f("reviews.titles.guideline-tips"),
            status: "info",
            standalone: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
                        hideIcon: true,
                        status: "info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownContentDefault.default), {
                            content: guideline?.text || ""
                        })
                    })
                })
            })
        })
    });
};
exports.default = CustomerReviewGuidelineSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetCustomerReviewGuideline":"g3nkB","../CollapsibleSection/CollapsibleSection":"3po8A","../KDKBanner/KDKBanner":"3zPW6","../MarkdownContent/MarkdownContent":"cPR47","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g3nkB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useLanguage = require("./useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
const useGetCustomerReviewGuideline = (customerType, timestamp)=>{
    // use useLanguage and not useTranslatedText in order to NOT fallback to the default language in case of an empty value
    const language = (0, _useLanguageDefault.default)();
    const timestampISOString = timestamp ? new Date(timestamp).toISOString() : undefined;
    const { data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_GUIDELINE,
        customerType,
        timestamp
    ].flat(), ()=>(0, _apiDefault.default).getReviewGuideline(customerType, {
            timestamp: timestampISOString
        }), {
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    const guideline = data ? {
        title: data.title[language],
        text: data.text_md[language]
    } : undefined;
    return guideline;
};
exports.default = useGetCustomerReviewGuideline;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a409G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFlipMove = require("react-flip-move");
var _reactFlipMoveDefault = parcelHelpers.interopDefault(_reactFlipMove);
var _polaris = require("@shopify/polaris");
var _measuresHelpers = require("../../helpers/measures.helpers");
var _collectionUtils = require("../../utils/collectionUtils");
var _measuresHeader = require("../CustomerReviewMeasures/MeasuresHeader");
var _measuresHeaderDefault = parcelHelpers.interopDefault(_measuresHeader);
var _measurePopover = require("../MeasurePopover/MeasurePopover");
var _measurePopoverDefault = parcelHelpers.interopDefault(_measurePopover);
var _measure = require("./Measure/Measure");
var _measureDefault = parcelHelpers.interopDefault(_measure);
const CustomerReviewMeasuresSection = (props)=>{
    const { measures, readonly, onChange } = props;
    const handleAdd = ()=>onChange([
            (0, _measuresHelpers.createNewMeasure)(),
            ...measures
        ]);
    const handleRemove = (id)=>onChange(measures.filter((measure)=>measure.id !== id));
    const handleMeasureChange = (measure)=>onChange(measures.map((currentMeasure)=>currentMeasure.id === measure.id ? measure : currentMeasure));
    const handleOrderChange = (index, direction)=>{
        const targetIndex = direction === "up" ? index - 1 : index + 1;
        onChange((0, _collectionUtils.swapElements)(measures, index, targetIndex));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measuresHeaderDefault.default), {
                        measures: measures,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measurePopoverDefault.default), {
                            measures: measures,
                            disabled: readonly,
                            onChange: onChange,
                            onNewMeasure: handleAdd
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFlipMoveDefault.default), {
                        children: measures.map((measure, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measureDefault.default), {
                                existingMeasures: measures,
                                isFirst: index === 0,
                                isLast: index === measures.length - 1,
                                measure: measure,
                                readonly: readonly || (0, _measuresHelpers.isMeasureCompleted)(measure),
                                onRemove: ()=>handleRemove(measure.id),
                                onChange: handleMeasureChange,
                                onOrderChange: (direction)=>handleOrderChange(index, direction)
                            }, measure.id))
                    })
                ]
            })
        })
    });
};
exports.default = CustomerReviewMeasuresSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-flip-move":"7Sobo","@shopify/polaris":"ek5a0","../../helpers/measures.helpers":"4P5ib","../../utils/collectionUtils":"gr5mc","../CustomerReviewMeasures/MeasuresHeader":"jxkve","../MeasurePopover/MeasurePopover":"2GCSp","./Measure/Measure":"lvkp1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lvkp1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _pencilSvg = require("../../../../assets/icons/pencil.svg");
var _pencilSvgDefault = parcelHelpers.interopDefault(_pencilSvg);
var _trashSvg = require("../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _measuresHelpers = require("../../../helpers/measures.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _stringUtils = require("../../../utils/stringUtils");
var _completedMeasureInfoLabel = require("../../CompletedMeasureInfoLabel/CompletedMeasureInfoLabel");
var _completedMeasureInfoLabelDefault = parcelHelpers.interopDefault(_completedMeasureInfoLabel);
var _completeMeasureForm = require("../../CompleteMeasureForm/CompleteMeasureForm");
var _completeMeasureFormDefault = parcelHelpers.interopDefault(_completeMeasureForm);
var _confirm = require("../../Confirm/Confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _customerReviewMeasureTitle = require("../../CustomerReviewMeasureTitle/CustomerReviewMeasureTitle");
var _customerReviewMeasureTitleDefault = parcelHelpers.interopDefault(_customerReviewMeasureTitle);
var _editButton = require("../../EditButton/EditButton");
var _editButtonDefault = parcelHelpers.interopDefault(_editButton);
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _measureComment = require("../../MeasureComment/MeasureComment");
var _measureCommentDefault = parcelHelpers.interopDefault(_measureComment);
var _measuresContainer = require("../../MeasureContainer/MeasuresContainer");
var _measuresContainerDefault = parcelHelpers.interopDefault(_measuresContainer);
var _moveButtons = require("../../MoveButtons/MoveButtons");
var _moveButtonsDefault = parcelHelpers.interopDefault(_moveButtons);
var _measureHelpers = require("./Measure.helpers");
var _measureForm = require("./MeasureForm");
var _measureFormDefault = parcelHelpers.interopDefault(_measureForm);
const Measure = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { measure, existingMeasures, isFirst, isLast, readonly, onRemove, onChange, onOrderChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const isCustom = (0, _measureHelpers.isCustomMeasure)(measure);
    const [isRemoveMeasureConfirmOpen, toggleRemoveMeasureConfirm, closeRemoveMeasureConfirm] = (0, _useOpenCloseDefault.default)();
    const [isEditing, setIsEditing] = (0, _react.useState)((0, _measuresHelpers.isNewMeasure)(measure) && isCustom);
    const [isCompleting, toggleCompleting, closeCompleting] = (0, _useOpenCloseDefault.default)();
    const isEmpty = (0, _measureHelpers.isEmptyMeasure)(measure);
    const showComment = !isEditing && !isCompleting;
    const isEmptyComment = (0, _stringUtils.isEmptyString)(measure.completed_comment);
    // if the user cancels the first custom measure (which is empty by default) then
    // remove the measure instead of saving it as an empty measure
    const shouldRemoveIfCanceled = isFirst && isCustom && isEmpty;
    const isDirty = !isEmpty;
    // show footer with edit/delete buttons only if:
    // 1. The current measure is not being edited (if it's a custom measure)
    // 2. It is not being completed (when the measure complete form is rendered)
    // 3. It was not completed outside the review
    const showFooter = !isEditing && !isCompleting && !readonly;
    const editButtonLabel = isEmptyComment ? f("details.reviews.measures.edit-measure") : f("default.edit");
    const startEditing = ()=>setIsEditing(true);
    const handleFormUpdate = (updatedMeasure)=>{
        setIsEditing(false);
        closeCompleting();
        onChange(updatedMeasure);
    };
    const handleFormCancel = ()=>{
        setIsEditing(false);
        closeCompleting();
        if (shouldRemoveIfCanceled) onRemove();
    };
    const handleRemove = ()=>{
        if (isCustom && isDirty && !isRemoveMeasureConfirmOpen) toggleRemoveMeasureConfirm();
        else {
            closeRemoveMeasureConfirm();
            onRemove();
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _measuresContainerDefault.default), {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
                hideBorder: true,
                hideIcon: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    align: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewMeasureTitleDefault.default), {
                                            measure: measure
                                        }),
                                        isCustom && !measure.is_completed && !measure.completed_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editButtonDefault.default), {
                                            readonly: readonly,
                                            onEdit: startEditing
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(DescriptionText, {
                                    children: measure.description
                                })
                            ]
                        }),
                        showComment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measureCommentDefault.default), {
                            measure: measure
                        }),
                        isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measureFormDefault.default), {
                            measure: measure,
                            existingMeasures: existingMeasures,
                            onSave: handleFormUpdate,
                            onCancel: handleFormCancel
                        }),
                        isCompleting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completeMeasureFormDefault.default), {
                            measure: measure,
                            readonly: readonly,
                            autoFocus: true,
                            onSave: handleFormUpdate,
                            onCancel: handleFormCancel
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "2",
                                    blockAlign: "start",
                                    align: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completedMeasureInfoLabelDefault.default), {
                                            measure: measure
                                        }),
                                        showFooter && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                            gap: "4",
                                            blockAlign: "center",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                    disabled: readonly,
                                                    size: "slim",
                                                    icon: (0, _trashSvgDefault.default),
                                                    onClick: handleRemove,
                                                    children: f("default.delete")
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                                    primary: true,
                                                    disabled: readonly,
                                                    size: "slim",
                                                    icon: isEmptyComment ? undefined : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                        source: (0, _pencilSvgDefault.default),
                                                        useMask: true
                                                    }),
                                                    onClick: toggleCompleting,
                                                    children: editButtonLabel
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isEmpty && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.InlineError), {
                                    message: f("measures.errors.empty-measure"),
                                    fieldID: ""
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveButtonsDefault.default), {
                spacing: "extraTight",
                disableMoveUp: isFirst,
                disableMoveDown: isLast,
                readonly: readonly,
                onOrderChange: onOrderChange
            }),
            isRemoveMeasureConfirmOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmDefault.default), {
                title: f("measures.confirm-remove.title"),
                description: f("measures.confirm-remove.description", {
                    name: measure.title
                }),
                actionTitle: f("default.remove"),
                onYes: handleRemove,
                onNo: closeRemoveMeasureConfirm
            })
        ]
    });
});
const DescriptionText = (0, _styledComponentsDefault.default).div`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
exports.default = Measure;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/pencil.svg":"gEWpJ","../../../../assets/icons/trash.svg":"jqW55","../../../helpers/measures.helpers":"4P5ib","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useOpenClose":"idooG","../../../utils/stringUtils":"4gVdA","../../CompletedMeasureInfoLabel/CompletedMeasureInfoLabel":"7rCn4","../../CompleteMeasureForm/CompleteMeasureForm":"lrJqR","../../Confirm/Confirm":"nqTPc","../../CustomerReviewMeasureTitle/CustomerReviewMeasureTitle":"5yiQg","../../EditButton/EditButton":"frWXb","../../extensions/Button":"8exc0","../../extensions/Icon":"eHSf0","../../KDKBanner/KDKBanner":"3zPW6","../../MeasureComment/MeasureComment":"926Yy","../../MeasureContainer/MeasuresContainer":"aCAsw","../../MoveButtons/MoveButtons":"dsvCr","./Measure.helpers":"hdrun","./MeasureForm":"cdITw","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7rCn4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
const CompletedMeasureInfoLabel = (props)=>{
    const { measure } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
        inlineAlign: "start",
        children: measure.is_completed && measure.completed_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
            children: f("common.labels.completed-by", {
                name: getUserDisplayName(measure.completed_by),
                timestamp: new Date(measure.completed_dt)
            })
        })
    });
};
exports.default = CompletedMeasureInfoLabel;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../CondensedText/CondensedText":"1FshD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hdrun":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmptyMeasure", ()=>isEmptyMeasure);
parcelHelpers.export(exports, "isCustomMeasure", ()=>isCustomMeasure);
var _stringUtils = require("../../../utils/stringUtils");
const isEmptyMeasure = ({ title, description })=>(0, _stringUtils.isEmptyString)(title) && (0, _stringUtils.isEmptyString)(description);
const isCustomMeasure = (measure)=>measure.measure_config_id === undefined;

},{"../../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cdITw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _measuresHelpers = require("../../../helpers/measures.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../../utils/stringUtils");
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _kdktextField = require("../../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
const MeasureForm = (props)=>{
    const { measure, existingMeasures, readonly, onSave, onCancel } = props;
    const [editableMeasure, setEditableMeasure] = (0, _react.useState)({
        ...measure
    });
    const f = (0, _useFormatMessageDefault.default)();
    const isDuplicateTitle = new Set(existingMeasures.map((existingMeasure)=>existingMeasure.id !== editableMeasure.id ? existingMeasure.title.toLowerCase() : "")).has(editableMeasure.title.trim().toLowerCase());
    const invalid = (0, _measuresHelpers.isInvalidMeasure)(editableMeasure) || isDuplicateTitle;
    const measureTitleError = (0, _stringUtils.isEmptyString)(editableMeasure.title) ? f("measures.modal.errors.title-validation-error") : isDuplicateTitle ? f("measures.modal.errors.title-not-unique-validation-error") : undefined;
    const handleFieldChange = (field, value)=>setEditableMeasure({
            ...editableMeasure,
            [field]: value
        });
    const cancel = ()=>{
        setEditableMeasure({
            ...measure
        });
        onCancel(editableMeasure);
    };
    const save = ()=>onSave(editableMeasure);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                value: editableMeasure.title,
                label: f("common.labels.title"),
                autoComplete: "off",
                autoFocus: true,
                onChange: (value)=>handleFieldChange("title", value),
                error: measureTitleError,
                disabled: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                value: editableMeasure.description,
                label: f("common.labels.description"),
                autoComplete: "off",
                multiline: 4,
                onChange: (value)=>handleFieldChange("description", value),
                disabled: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                align: "end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: cancel,
                        size: "slim",
                        children: f("default.cancel")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: readonly || invalid,
                        size: "slim",
                        onClick: save,
                        primary: true,
                        children: f("default.save")
                    })
                ]
            })
        ]
    });
};
exports.default = MeasureForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../helpers/measures.helpers":"4P5ib","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/stringUtils":"4gVdA","../../extensions/Button":"8exc0","../../KDKTextField/KDKTextField":"b5QRp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Ct9K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useCustomerReviewBanner = require("../../hooks/useCustomerReviewBanner");
var _useCustomerReviewBannerDefault = parcelHelpers.interopDefault(_useCustomerReviewBanner);
var _pendingDisclosuresBanner = require("../PendingDisclosuresBanner/PendingDisclosuresBanner");
var _pendingDisclosuresBannerDefault = parcelHelpers.interopDefault(_pendingDisclosuresBanner);
var _unreviewedMatchCasesBanner = require("../UnreviewedMatchCasesBanner/UnreviewedMatchCasesBanner");
var _unreviewedMatchCasesBannerDefault = parcelHelpers.interopDefault(_unreviewedMatchCasesBanner);
const CustomerReviewPageBanner = (props)=>{
    const { customer } = props;
    const { hasUnresolvedMatchCases, hasPendingDisclosures, unresolvedCaseCount, pendingDisclosuresCount, navigateToMatchesSection, navigateToDisclosuresSection } = (0, _useCustomerReviewBannerDefault.default)(customer, true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            hasUnresolvedMatchCases && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unreviewedMatchCasesBannerDefault.default), {
                unresolvedCaseCount: unresolvedCaseCount,
                onNavigateToMatchesSection: navigateToMatchesSection
            }),
            hasPendingDisclosures && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendingDisclosuresBannerDefault.default), {
                pendingDisclosuresCount: pendingDisclosuresCount,
                onNavigateToDisclosuresSection: navigateToDisclosuresSection
            })
        ]
    });
};
exports.default = CustomerReviewPageBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useCustomerReviewBanner":"1BJZA","../PendingDisclosuresBanner/PendingDisclosuresBanner":"a2nLX","../UnreviewedMatchCasesBanner/UnreviewedMatchCasesBanner":"daktN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cVp0t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _riskTypes = require("../../constants/risk-types");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _fullWidthStatusRadioButton = require("../FullWidthStatusRadioButton/FullWidthStatusRadioButton");
var _fullWidthStatusRadioButtonDefault = parcelHelpers.interopDefault(_fullWidthStatusRadioButton);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const RISK_LEVEL_TO_BUTTON_COLOR = {
    HIGH: "red",
    MEDIUM: "orange",
    LOW: "green",
    NOT_SET: undefined
};
const CustomerReviewRiskLevelForm = (props)=>{
    const { riskLevel, readonly, onRiskLevelChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
                hideIcon: true,
                hideBorder: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingSm",
                            as: "h2",
                            children: f("reviews.labels.relationship.change")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack), {
                            distribution: "fillEvenly",
                            children: (0, _riskTypes.RiskTypes).map((risk)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthStatusRadioButtonDefault.default), {
                                    id: `risk-level-${risk}`,
                                    label: f(`risklabel.${risk}`),
                                    name: "risk",
                                    checked: riskLevel === risk,
                                    onChange: ()=>onRiskLevelChange(risk),
                                    disabled: readonly,
                                    color: RISK_LEVEL_TO_BUTTON_COLOR[risk]
                                }, `risk-level-${risk}`))
                        })
                    ]
                })
            })
        })
    });
};
exports.default = CustomerReviewRiskLevelForm;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../constants/risk-types":"hJsRK","../../hooks/useFormatMessage":"8Y8fq","../FullWidthStatusRadioButton/FullWidthStatusRadioButton":"3yHie","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hJsRK":[function(require,module,exports) {
// the tool that is used to generate typescript types from beaufort-api (oazapfts)
// doesn't generate enums, but simple union types of strings
// since typescript does not allow creating an array of values from a union type
// this internal array of values is defined here
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RiskTypes", ()=>RiskTypes);
parcelHelpers.export(exports, "ReversedRiskTypes", ()=>ReversedRiskTypes);
const RiskTypes = [
    "LOW",
    "MEDIUM",
    "HIGH"
];
const ReversedRiskTypes = [
    ...RiskTypes
].reverse();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jbkwi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _riskIndicators = require("../RiskIndicators/RiskIndicators");
var _riskIndicatorsDefault = parcelHelpers.interopDefault(_riskIndicators);
var _useRiskIndicators = require("../RiskIndicators/useRiskIndicators");
var _useRiskIndicatorsDefault = parcelHelpers.interopDefault(_useRiskIndicators);
const CustomerReviewRiskSection = (props)=>{
    const { customerId, riskIndicators } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { showRiskIndicators, riskIndicatorsCount } = (0, _useRiskIndicatorsDefault.default)(riskIndicators);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: showRiskIndicators && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                blockAlign: "baseline",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                        variant: "headingSm",
                        as: "h2",
                        children: [
                            f("reviews.labels.risk-indicators", {
                                count: 0
                            }),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCounter, {
                        children: riskIndicatorsCount
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskIndicatorsDefault.default), {
                customerId: customerId,
                riskIndicators: riskIndicators
            })
        })
    });
};
const StyledCounter = (0, _styledComponentsDefault.default)((0, _badgeDefault.default))`
  & .Polaris-Badge {
    border: solid var(--p-border-width-1) var(--p-color-border-caution-subdued);
    background-color: var(--p-color-bg-caution-subdued);
  }
`;
exports.default = CustomerReviewRiskSection;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../extensions/Badge":"9irVp","../RiskIndicators/RiskIndicators":"lIJ7H","../RiskIndicators/useRiskIndicators":"eYp6X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lIJ7H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _industryRisk = require("../IndustryRisk/IndustryRisk");
var _industryRiskDefault = parcelHelpers.interopDefault(_industryRisk);
var _geographicRiskIndicator = require("./GeographicRiskIndicator/GeographicRiskIndicator");
var _geographicRiskIndicatorDefault = parcelHelpers.interopDefault(_geographicRiskIndicator);
var _disclosureRiskIndicator = require("./DisclosureRiskIndicator");
var _disclosureRiskIndicatorDefault = parcelHelpers.interopDefault(_disclosureRiskIndicator);
var _matchCaseRiskIndicator = require("./MatchCaseRiskIndicator");
var _matchCaseRiskIndicatorDefault = parcelHelpers.interopDefault(_matchCaseRiskIndicator);
var _personRiskIndicator = require("./PersonRiskIndicator");
var _personRiskIndicatorDefault = parcelHelpers.interopDefault(_personRiskIndicator);
var _useRiskIndicators = require("./useRiskIndicators");
var _useRiskIndicatorsDefault = parcelHelpers.interopDefault(_useRiskIndicators);
const RiskIndicators = (props)=>{
    const { customerId, riskIndicators } = props;
    const { showConfirmedMatches, confirmedMatchCases, showIndustryRisk, industryRiskCount, showGeographicRisk, countriesRisk, showDisclosuresRisk, disclosuresRisk, showPersonnelRisk, personnelRisk } = (0, _useRiskIndicatorsDefault.default)(riskIndicators);
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "8",
        children: [
            showConfirmedMatches && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("risk-indicators.labels.confirmed-matches", {
                            count: confirmedMatchCases.length
                        })
                    }),
                    confirmedMatchCases.map((matchCase)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCaseRiskIndicatorDefault.default), {
                            customerId: customerId,
                            matchCase: matchCase
                        }, matchCase.id))
                ]
            }),
            showIndustryRisk && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("risk-indicators.labels.industry-risk", {
                            count: industryRiskCount
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryRiskDefault.default), {
                        industryRisk: riskIndicators.industryRisk
                    })
                ]
            }),
            showDisclosuresRisk && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("risk-indicators.labels.disclosure-risk", {
                            count: disclosuresRisk.length
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: disclosuresRisk.map((disclosuresRiskInformation, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureRiskIndicatorDefault.default), {
                                disclosureRiskInformation: disclosuresRiskInformation
                            }, index))
                    })
                ]
            }),
            showGeographicRisk && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("risk-indicators.labels.geographic-risk", {
                            count: countriesRisk.length
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                as: "span",
                                fontWeight: "semibold",
                                children: [
                                    f("common.labels.editorial-explanation"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                color: "subdued",
                                children: f("risk-indicators.geographic-risk.description")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                        gap: "2",
                        children: countriesRisk.map((countryRiskInformation, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _geographicRiskIndicatorDefault.default), {
                                countryRiskInformation: countryRiskInformation
                            }, index))
                    })
                ]
            }),
            showPersonnelRisk && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("risk-indicators.labels.personnel-risk", {
                            count: personnelRisk.length
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: personnelRisk.map((personRiskInformation, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personRiskIndicatorDefault.default), {
                                personRiskInformation: personRiskInformation
                            }, index))
                    })
                ]
            })
        ]
    });
};
exports.default = RiskIndicators;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../CondensedText/CondensedText":"1FshD","../IndustryRisk/IndustryRisk":"6aep9","./GeographicRiskIndicator/GeographicRiskIndicator":"8E53o","./DisclosureRiskIndicator":"ff4Mv","./MatchCaseRiskIndicator":"82B6D","./PersonRiskIndicator":"fLpna","./useRiskIndicators":"eYp6X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6aep9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _industryInfo = require("./IndustryInfo");
var _industryInfoDefault = parcelHelpers.interopDefault(_industryInfo);
const IndustryRisk = (props)=>{
    const { industryRisk, title, showAllIndustryTypes } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                color: "subdued",
                children: title
            }),
            (showAllIndustryTypes || industryRisk?.industry_types?.industry_code_1?.has_risk) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryInfoDefault.default), {
                industry: industryRisk?.industry_types?.industry_code_1
            }),
            (showAllIndustryTypes || industryRisk?.industry_types?.industry_code_2?.has_risk) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryInfoDefault.default), {
                industry: industryRisk?.industry_types?.industry_code_2
            }),
            (showAllIndustryTypes || industryRisk?.industry_types?.industry_code_3?.has_risk) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryInfoDefault.default), {
                industry: industryRisk?.industry_types?.industry_code_3
            })
        ]
    });
};
exports.default = IndustryRisk;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","./IndustryInfo":"45yrg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"45yrg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _industryTypeWarningBadge = require("../IndustryTypeWarningBadge/IndustryTypeWarningBadge");
var _industryTypeWarningBadgeDefault = parcelHelpers.interopDefault(_industryTypeWarningBadge);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const IndustryInfo = (props)=>{
    const { industry } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!industry) return null;
    const industryCodeDescriptions = [
        industry.code,
        industry.industry_code_description
    ].filter((e)=>!!e).join(" \u2014 ");
    const showWarning = industry.has_risk;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        status: showWarning ? "warning" : "info",
        hideIcon: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "2",
            children: [
                showWarning && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryTypeWarningBadgeDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            blockAlign: "center",
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: [
                                        f("industry-info.labels.industry-code"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    children: industryCodeDescriptions
                                })
                            ]
                        }),
                        industry.risk_description && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: `${f("common.labels.editorial-explanation")}: `
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    children: industry.risk_description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = IndustryInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../IndustryTypeWarningBadge/IndustryTypeWarningBadge":"ifNmc","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ifNmc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _warningBadge = require("../WarningBadge/WarningBadge");
var _warningBadgeDefault = parcelHelpers.interopDefault(_warningBadge);
const IndustryTypeWarningBadge = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningBadgeDefault.default), {
        children: f("industry-info.labels.possible-risk")
    });
};
exports.default = IndustryTypeWarningBadge;

},{"react/jsx-runtime":"enbMA","../../hooks/useFormatMessage":"8Y8fq","../WarningBadge/WarningBadge":"28RLb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8E53o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _triangleFilledExclamationSvg = require("../../../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _riskIndicatorPersonName = require("../../RiskIndicatorPersonName/RiskIndicatorPersonName");
var _riskIndicatorPersonNameDefault = parcelHelpers.interopDefault(_riskIndicatorPersonName);
var _signedByLabel = require("../../SignedByLabel/SignedByLabel");
var _signedByLabelDefault = parcelHelpers.interopDefault(_signedByLabel);
var _countryRisk = require("./CountryRisk");
var _countryRiskDefault = parcelHelpers.interopDefault(_countryRisk);
const GeographicRiskIndicator = (props)=>{
    const { countryRiskInformation } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { signature, customerType } = countryRiskInformation;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        status: "warning",
        hideIcon: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "2",
            children: [
                signature && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "2",
                    blockAlign: "center",
                    wrap: false,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _triangleFilledExclamationSvgDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "semibold",
                            children: f("common.labels.kyc")
                        })
                    ]
                }),
                customerType && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskIndicatorPersonNameDefault.default), {
                    riskInformation: countryRiskInformation
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryRiskDefault.default), {
                    countryFields: countryRiskInformation.fields
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signedByLabelDefault.default), {
                    signature: signature
                })
            ]
        })
    });
};
exports.default = GeographicRiskIndicator;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","../../../hooks/useFormatMessage":"8Y8fq","../../extensions/Icon":"eHSf0","../../KDKBanner/KDKBanner":"3zPW6","../../RiskIndicatorPersonName/RiskIndicatorPersonName":"g59sF","../../SignedByLabel/SignedByLabel":"csvZH","./CountryRisk":"3rnoN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g59sF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _position = require("../Position/Position");
var _positionDefault = parcelHelpers.interopDefault(_position);
const RiskIndicatorPersonName = (props)=>{
    const { riskInformation } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const displayLabel = riskInformation.name || (0, _displayHelpers.getFullName)(riskInformation.person);
    const showPosition = Boolean(riskInformation.role || riskInformation.owner);
    const positionLabel = riskInformation.types ? riskInformation.types.map((roleType)=>f((0, _roleTypesDefault.default)[roleType])) : [];
    if (riskInformation.owner) positionLabel.push(f("table.row.owner"));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
        type: riskInformation.customerType,
        strong: true,
        name: displayLabel,
        birthDate: (0, _displayHelpers.getBirthDate)(riskInformation.person),
        subtitle: showPosition ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _positionDefault.default), {
            children: positionLabel.join(", ")
        }) : undefined
    });
};
exports.default = RiskIndicatorPersonName;

},{"react/jsx-runtime":"enbMA","../../constants/role-types":"fAycz","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../DisplayName/DisplayName":"gKd5g","../Position/Position":"kTPkn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"csvZH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
const SignedByLabel = (props)=>{
    const { signature } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!signature || !signature.signed_dt) return null;
    const roleType = signature.role?.type ? f((0, _roleTypesDefault.default)[signature.role.type]) : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
        italic: true,
        children: f("common.answered.label", {
            name: signature.signing_user_info?.name || `${(0, _displayHelpers.getFullName)(signature.person)}${roleType ? ` (${roleType})` : ""}`,
            timestamp: new Date(signature.signed_dt)
        })
    });
};
exports.default = SignedByLabel;

},{"react/jsx-runtime":"enbMA","../../constants/role-types":"fAycz","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../CondensedText/CondensedText":"1FshD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3rnoN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _riskHelpers = require("../../../helpers/risk.helpers");
var _useCountries = require("../../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useGetCountryFieldTranslation = require("../../../hooks/useGetCountryFieldTranslation");
var _useGetCountryFieldTranslationDefault = parcelHelpers.interopDefault(_useGetCountryFieldTranslation);
var _country = require("../../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _tooltipWrapper = require("../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const CountryRisk = (props)=>{
    const { countryFields } = props;
    const { getCountryRiskDescription } = (0, _useCountriesDefault.default)();
    const getCountryFieldTranslation = (0, _useGetCountryFieldTranslationDefault.default)();
    // group all fields by country
    const fieldsByCountryMap = (0, _riskHelpers.groupByCountry)(countryFields);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
        gap: "2",
        children: Object.entries(fieldsByCountryMap).map(([country, fields])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                dismissOnMouseOut: true,
                preferredPosition: "above",
                content: getCountryRiskDescription(country),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    blockAlign: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                            spacing: "tight",
                            alignment: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                                    country: country,
                                    fontWeight: "semibold",
                                    children: ":"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: fields.map(getCountryFieldTranslation).join(", ")
                        })
                    ]
                })
            }, country))
    });
};
exports.default = CountryRisk;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../helpers/risk.helpers":"1qPrk","../../../hooks/useCountries":"azDTp","../../../hooks/useGetCountryFieldTranslation":"7MDus","../../Country/Country":"eeWSc","../../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ff4Mv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _questionMarkSvg = require("../../../assets/icons/question-mark.svg");
var _questionMarkSvgDefault = parcelHelpers.interopDefault(_questionMarkSvg);
var _textBubbleSvg = require("../../../assets/icons/text-bubble.svg");
var _textBubbleSvgDefault = parcelHelpers.interopDefault(_textBubbleSvg);
var _useTranslatedText = require("../../hooks/useTranslatedText");
var _useTranslatedTextDefault = parcelHelpers.interopDefault(_useTranslatedText);
var _collectionUtils = require("../../utils/collectionUtils");
var _disclosureAnswer = require("../DisclosureAnswers/DisclosureAnswer");
var _disclosureAnswerDefault = parcelHelpers.interopDefault(_disclosureAnswer);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _signedByLabel = require("../SignedByLabel/SignedByLabel");
var _signedByLabelDefault = parcelHelpers.interopDefault(_signedByLabel);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const DisclosureRiskIndicator = (props)=>{
    const { disclosureRiskInformation } = props;
    const t = (0, _useTranslatedTextDefault.default)();
    const { signature, answer, riskIndicator } = disclosureRiskInformation;
    if (!signature || !riskIndicator) return null;
    const tooltip = !(0, _collectionUtils.hasContent)(riskIndicator.additional_description) ? undefined : riskIndicator.additional_description?.length === 1 ? t((0, _collectionUtils.first)(riskIndicator.additional_description)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List), {
        spacing: "extraTight",
        children: riskIndicator.additional_description?.map((description, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                children: t(description)
            }, index))
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        status: "warning",
        hideIcon: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                    content: tooltip,
                    width: "wide",
                    active: tooltip === undefined ? false : undefined,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "semibold",
                        children: t(riskIndicator.description)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "1",
                    blockAlign: "start",
                    wrap: false,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _questionMarkSvgDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: answer ? t(answer.question.text) : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "1",
                    blockAlign: "start",
                    wrap: false,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _textBubbleSvgDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureAnswerDefault.default), {
                            answer: answer
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signedByLabelDefault.default), {
                    signature: signature
                })
            ]
        })
    });
};
exports.default = DisclosureRiskIndicator;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/question-mark.svg":"7OxQS","../../../assets/icons/text-bubble.svg":"52FbG","../../hooks/useTranslatedText":"lODeq","../../utils/collectionUtils":"gr5mc","../DisclosureAnswers/DisclosureAnswer":"2mmVu","../extensions/Icon":"eHSf0","../KDKBanner/KDKBanner":"3zPW6","../SignedByLabel/SignedByLabel":"csvZH","../TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7OxQS":[function(require,module,exports) {
module.exports = require("32d8d641b180caa9").getBundleURL("kEMsi") + "question-mark.b974b79a.svg";

},{"32d8d641b180caa9":"75UoR"}],"82B6D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _textBubbleSvg = require("../../../assets/icons/text-bubble.svg");
var _textBubbleSvgDefault = parcelHelpers.interopDefault(_textBubbleSvg);
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _badges = require("../Badges/Badges");
var _badgesDefault = parcelHelpers.interopDefault(_badges);
var _collapsibleText = require("../CollapsibleText/CollapsibleText");
var _collapsibleTextDefault = parcelHelpers.interopDefault(_collapsibleText);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const MatchCaseRiskIndicator = (props)=>{
    const { customerId, matchCase } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        status: "warning",
        hideIcon: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    blockAlign: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                            url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MATCH_CASE_DETAILS, {
                                customerId,
                                id: matchCase.id
                            }),
                            children: matchCase.match_entity_name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgesDefault.default), {
                            isPep: matchCase.review?.is_pep,
                            isSanctioned: matchCase.review?.is_sanctioned,
                            hasNegativeNews: matchCase.review?.negative_news,
                            isOther: matchCase.review?.other
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                    spacing: "none",
                    wrap: false,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _textBubbleSvgDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                            fill: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsibleTextDefault.default), {
                                text: matchCase.review?.description
                            })
                        })
                    ]
                }),
                matchCase.review?.reviewed_by && matchCase.review?.created_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                    italic: true,
                    children: f("common.reviewed.label", {
                        name: getUserDisplayName(matchCase.review.reviewed_by),
                        timestamp: new Date(matchCase.review.created_dt)
                    })
                })
            ]
        })
    });
};
exports.default = MatchCaseRiskIndicator;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../../assets/icons/text-bubble.svg":"52FbG","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../Badges/Badges":"cI72s","../CollapsibleText/CollapsibleText":"1EGA4","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1EGA4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const CLAMP_CHARACTERS_WIDTH = 100; // in characters
const CollapsibleText = (props)=>{
    const { text = "", clampLength = CLAMP_CHARACTERS_WIDTH, ...rest } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [isClamped, toggleClamped] = (0, _useOpenCloseDefault.default)(true);
    const showClampButton = text && text.length > clampLength;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        spacing: isClamped ? "extraTight" : "none",
        wrap: !isClamped,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                fill: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledClampedText, {
                    clamped: isClamped,
                    ...rest,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: text
                    })
                })
            }),
            showClampButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                monochrome: true,
                onClick: toggleClamped,
                children: isClamped ? f("common.labels.show-more") : f("common.labels.show-less")
            })
        ]
    });
};
const StyledClampedText = (0, _styledComponentsDefault.default).span`
  transition: max-height var(--p-ease-out) var(--p-duration-500);

  -webkit-box-orient: vertical;
  box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;

  max-height: ${({ clamped })=>clamped ? "2em" : "40em"};
  -webkit-line-clamp: ${({ clamped })=>clamped ? "1" : "none"};
  line-clamp: ${({ clamped })=>clamped ? "1" : "none"};
`;
exports.default = CollapsibleText;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fLpna":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _textBubbleSvg = require("../../../assets/icons/text-bubble.svg");
var _textBubbleSvgDefault = parcelHelpers.interopDefault(_textBubbleSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _badges = require("../Badges/Badges");
var _badgesDefault = parcelHelpers.interopDefault(_badges);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _personNameHelpers = require("../PersonName/PersonName.helpers");
var _riskIndicatorPersonName = require("../RiskIndicatorPersonName/RiskIndicatorPersonName");
var _riskIndicatorPersonNameDefault = parcelHelpers.interopDefault(_riskIndicatorPersonName);
const PersonRiskIndicator = (props)=>{
    const { personRiskInformation } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const entity = personRiskInformation.role || personRiskInformation.owner;
    const showManuallyUpdatedInfo = Boolean(entity && (0, _personNameHelpers.isManuallyUpdated)(entity) && entity.updated_dt);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        status: "warning",
        hideIcon: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskIndicatorPersonNameDefault.default), {
                    riskInformation: personRiskInformation
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "1",
                    blockAlign: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _textBubbleSvgDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            as: "span",
                            children: [
                                f("details.basic-info.marked-as"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgesDefault.default), {
                            isPep: personRiskInformation.isPep,
                            isSanctioned: personRiskInformation.isSanctioned
                        })
                    ]
                }),
                showManuallyUpdatedInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                    children: f("common.labels.modified-by", {
                        name: getUserDisplayName(entity.updated_by),
                        timestamp: new Date(entity.updated_dt)
                    })
                })
            ]
        })
    });
};
exports.default = PersonRiskIndicator;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/text-bubble.svg":"52FbG","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../Badges/Badges":"cI72s","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","../KDKBanner/KDKBanner":"3zPW6","../PersonName/PersonName.helpers":"gsHLg","../RiskIndicatorPersonName/RiskIndicatorPersonName":"g59sF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eYp6X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _matchHelpers = require("../../helpers/match.helpers");
var _riskHelpers = require("../../helpers/risk.helpers");
const useRiskIndicators = (props)=>{
    const { industryRisk, matchCases = [], countriesRisk = [], disclosuresRisk = [], personnelRisk = [] } = props;
    const confirmedMatchCases = matchCases.filter((0, _matchHelpers.isConfirmedMatchCase));
    const showConfirmedMatches = confirmedMatchCases.length > 0;
    /*
    risk information should be shown if there's at least some data available
    and if the set risk level justifies showing it.
  */ const industryRiskCount = (0, _riskHelpers.getIndustryRiskCount)(industryRisk);
    const showIndustryRisk = industryRiskCount > 0;
    const groupedCountriesRisk = (0, _riskHelpers.groupRiskInformationByPersonName)(countriesRisk);
    const showGeographicRisk = groupedCountriesRisk.length > 0;
    const showDisclosuresRisk = disclosuresRisk.length > 0;
    const groupedPersonnelRisk = (0, _riskHelpers.groupRiskInformationByPersonName)(personnelRisk);
    const showPersonnelRisk = groupedPersonnelRisk.length > 0;
    const riskIndicatorsCount = confirmedMatchCases.length + industryRiskCount + groupedCountriesRisk.length + disclosuresRisk.length + groupedPersonnelRisk.length;
    const showRiskIndicators = showConfirmedMatches || showIndustryRisk || showGeographicRisk || showDisclosuresRisk || showPersonnelRisk;
    return {
        showConfirmedMatches,
        confirmedMatchCases,
        industryRiskCount,
        showIndustryRisk,
        showRiskIndicators,
        riskIndicatorsCount,
        showGeographicRisk,
        countriesRisk: groupedCountriesRisk,
        showDisclosuresRisk,
        disclosuresRisk,
        showPersonnelRisk,
        personnelRisk: groupedPersonnelRisk
    };
};
exports.default = useRiskIndicators;

},{"../../helpers/match.helpers":"4U2lJ","../../helpers/risk.helpers":"1qPrk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7qDJg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _routes = require("../constants/routes");
var _reviewsHelpers = require("../helpers/reviews.helpers");
var _useQueryData = require("../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _customerReviewPageHelpers = require("../pages/CustomerReviewPage/CustomerReviewPage.helpers");
var _utilities = require("../types/utilities");
var _collectionUtils = require("../utils/collectionUtils");
const useCustomerReviewMutations = (customer, review, reviewId)=>{
    const history = (0, _reactRouterDom.useHistory)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const updateCustomerQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(customer);
    const { updateQueryData: updateReviewQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW,
        customer.id,
        reviewId
    ]);
    // search for an existing review in the pending reviews list first and then in the regular reviews list
    const isNew = !reviewId || !customer.reviews.some((review)=>review.id === reviewId);
    const onAfterReviewMutation = (updatedReview, actionType)=>{
        if (actionType === "complete") {
            // update customer details and review details
            // if the action type is complete and the review doesn't require an approval
            if (!(0, _reviewsHelpers.isReviewApprovalRequired)(updatedReview)) {
                updateCustomerQueryData((queryData)=>{
                    queryData.review_status = updatedReview.accepted ? "APPROVED" : "REJECTED";
                    queryData.risk_level = updatedReview.risk_level || "NOT_SET";
                    queryData.is_pep = Boolean(updatedReview.is_pep);
                    queryData.is_sanctioned = Boolean(updatedReview.is_sanctioned);
                });
                updateReviewQueryData((queryData)=>{
                    queryData.review_status = updatedReview.accepted ? "APPROVED" : "REJECTED";
                    queryData.risk_level = updatedReview.risk_level || "NOT_SET";
                    queryData.is_pep = Boolean(updatedReview.is_pep);
                    queryData.is_sanctioned = Boolean(updatedReview.is_sanctioned);
                });
            }
            // invalidate the entire customer details query in order to refresh the follow-up date
            queryClient.invalidateQueries((0, _utilities.getCustomerQueryKey)(customer));
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW,
                customer.id,
                reviewId
            ]);
        }
    };
    const createReviewMutation = (actionType)=>(0, _reactQuery.useMutation)(()=>actionType === "complete" ? (0, _apiDefault.default).createCustomerReview(customer.id, (0, _customerReviewPageHelpers.convertToCreateCustomerReviewRequest)(review)) : (0, _apiDefault.default).createDraftCustomerReview(customer.id, (0, _customerReviewPageHelpers.convertToCreateDraftCustomerReviewRequest)(review)), {
            onSuccess: (newReview)=>{
                updateCustomerQueryData((queryData)=>queryData.reviews = [
                        newReview,
                        ...queryData.reviews
                    ]);
                // this is the first time a new review is saved - so set a new customer review data
                queryClient.setQueryData([
                    (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW,
                    customer.id,
                    newReview.id
                ], {
                    ...customer,
                    reviews: [
                        newReview,
                        ...customer.reviews
                    ]
                });
                onAfterReviewMutation(newReview, actionType);
                // replace the new customer review URL with the created review id
                if (actionType === "save") history.replace((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMER_REVIEW, {
                    customerId: customer.id,
                    id: newReview.id
                }));
            }
        });
    const updateReviewMutation = (actionType)=>(0, _reactQuery.useMutation)(()=>actionType === "complete" ? (0, _apiDefault.default).updateCustomerReview(customer.id, reviewId, (0, _customerReviewPageHelpers.convertToCreateCustomerReviewRequest)(review)) : (0, _apiDefault.default).updateDraftCustomerReview(customer.id, reviewId, (0, _customerReviewPageHelpers.convertToCreateDraftCustomerReviewRequest)(review)), {
            onSuccess: (updatedReview)=>{
                updateCustomerQueryData((queryData)=>queryData.reviews = (0, _collectionUtils.updateItem)(queryData.reviews, updatedReview));
                updateReviewQueryData((queryData)=>queryData.reviews = (0, _collectionUtils.updateItem)(queryData.reviews, updatedReview));
                onAfterReviewMutation(updatedReview, actionType);
            }
        });
    const createMutation = (actionType)=>{
        return isNew ? createReviewMutation(actionType) : updateReviewMutation(actionType);
    };
    const saveMutation = createMutation("save");
    const completeMutation = createMutation("complete");
    const isLoading = saveMutation.isLoading || completeMutation.isLoading;
    return {
        isLoading,
        saveMutation,
        completeMutation
    };
};
exports.default = useCustomerReviewMutations;

},{"react-router-dom":"1ee65","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../constants/routes":"ihtm8","../helpers/reviews.helpers":"1oYIN","../hooks/useQueryData":"4laI9","../pages/CustomerReviewPage/CustomerReviewPage.helpers":"g8JYT","../types/utilities":"6zLpB","../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g8JYT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertToCreateCustomerReviewRequest", ()=>convertToCreateCustomerReviewRequest);
parcelHelpers.export(exports, "convertToCreateDraftCustomerReviewRequest", ()=>convertToCreateDraftCustomerReviewRequest);
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _measuresHelpers = require("../../helpers/measures.helpers");
var _util = require("../../utils/util");
const convertToCreateCustomerReviewRequest = (review)=>({
        ...(0, _util.removeProperty)(review, "id"),
        accepted: Boolean(review.accepted),
        measures: review.measures?.map((0, _measuresHelpers.convertMeasureToCreateCustomMeasureRequest)),
        checklist_answers: review.checklist_answers?.map((0, _checklistsHelpers.convertOptionalChecklistAnswersRequestToChecklistAnswersRequest))
    });
const convertToCreateDraftCustomerReviewRequest = (review)=>({
        ...(0, _util.removeProperty)(review, "id"),
        risk_level: review.risk_level === "NOT_SET" ? undefined : review.risk_level,
        accepted: review.accepted,
        measures: review.measures?.map((0, _measuresHelpers.convertMeasureToCreateCustomMeasureRequest)),
        checklist_answers: review.checklist_answers?.map((0, _checklistsHelpers.convertOptionalChecklistAnswersRequestToChecklistAnswersRequest))
    });

},{"../../helpers/checklists.helpers":"4fhyQ","../../helpers/measures.helpers":"4P5ib","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gn3Cd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CustomerReviewSkeleton = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonPage), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "heading2xl",
                    as: "p",
                    children: f("reviews.titles.risk-review")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "8",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                                lines: 6
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                                lines: 6
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                                lines: 6
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                            oneThird: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "8",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                                lines: 6
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = CustomerReviewSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8OLgg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _customerReviews = require("../../constants/customer-reviews");
var _pageAnchors = require("../../constants/page-anchors");
var _reviewChecklists = require("../../constants/review-checklists");
var _routes = require("../../constants/routes");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _displayHelpers = require("../../helpers/display.helpers");
var _reviewsHelpers = require("../../helpers/reviews.helpers");
var _useCustomerPath = require("../../hooks/useCustomerPath");
var _useCustomerPathDefault = parcelHelpers.interopDefault(_useCustomerPath);
var _useCustomerReview = require("../../hooks/useCustomerReview");
var _useCustomerReviewDefault = parcelHelpers.interopDefault(_useCustomerReview);
var _useCustomerReviewBanner = require("../../hooks/useCustomerReviewBanner");
var _useCustomerReviewBannerDefault = parcelHelpers.interopDefault(_useCustomerReviewBanner);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useGetMLROUsers = require("../../hooks/useGetMLROUsers");
var _useGetMLROUsersDefault = parcelHelpers.interopDefault(_useGetMLROUsers);
var _useGetReviewChecklists = require("../../hooks/useGetReviewChecklists");
var _useGetReviewChecklistsDefault = parcelHelpers.interopDefault(_useGetReviewChecklists);
var _useGetUsers = require("../../hooks/useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
var _useInitialCustomerReview = require("../../hooks/useInitialCustomerReview");
var _useInitialCustomerReviewDefault = parcelHelpers.interopDefault(_useInitialCustomerReview);
var _useIsMLROUser = require("../../hooks/useIsMLROUser");
var _useIsMLROUserDefault = parcelHelpers.interopDefault(_useIsMLROUser);
var _useReviewChecklistConditions = require("../../hooks/useReviewChecklistConditions");
var _useReviewChecklistConditionsDefault = parcelHelpers.interopDefault(_useReviewChecklistConditions);
var _useStorage = require("../../hooks/useStorage");
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
const useCustomerReviewPage = (customer, riskIndicators, reviewId, assignmentId)=>{
    const features = (0, _useFeaturesDefault.default)();
    // search for an existing review in the reviews list
    const exitingReview = reviewId ? customer.reviews.find((review)=>review.id === reviewId) : undefined;
    const isNew = !reviewId || !exitingReview;
    const initialCustomerReview = (0, _useInitialCustomerReviewDefault.default)(customer, riskIndicators);
    // if an assignment id was passed from a URL param - set it as the initial selected assignment for the review
    initialCustomerReview.assignment_id = assignmentId;
    const [review, setReview, resetReviewIsChanged, isReviewChanged] = (0, _useStorage.useSessionStorage)((0, _reviewsHelpers.getReviewStorageKey)(customer.id, reviewId), ()=>isNew ? initialCustomerReview : (0, _reviewsHelpers.convertCustomerReviewToOptionalCustomerReviewRequest)(exitingReview));
    //////// check if review is readonly (can be edited)
    const { isNewCustomerReviewDisabled } = (0, _useCustomerReviewBannerDefault.default)(customer);
    const { isEditable } = (0, _useCustomerReviewDefault.default)(exitingReview);
    const isPossibleToApprove = Boolean(exitingReview?.is_possible_to_approve && !exitingReview.approval?.approved_by);
    const readonly = Boolean(isNewCustomerReviewDisabled || !isNew && !isEditable);
    const originalReviewRef = (0, _react.useRef)({
        ...review
    });
    //////// navigate to customer details page or the assignment details page
    const history = (0, _reactRouterDom.useHistory)();
    const { getCustomerPath } = (0, _useCustomerPathDefault.default)();
    const customerDetailsPageUrl = `${getCustomerPath(customer.id, customer.type)}#${(0, _pageAnchors.PAGE_ANCHORS).REVIEWS_SECTION}`;
    const previousPageURL = assignmentId ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).ASSIGNMENT_DETAILS, {
        customerId: customer.id,
        id: assignmentId
    }) : customerDetailsPageUrl;
    const assignmentName = customer.assignments?.find((assignment)=>assignment.id === assignmentId)?.name;
    const previousPageLabel = assignmentName || (0, _displayHelpers.getCustomerName)(customer);
    const onBackNavigation = ()=>{
        resetReviewIsChanged();
        history.push(previousPageURL);
    };
    //////// assignments
    // include active assignments and a previously selected assignment (even if it is not active)
    const assignments = (customer.assignments || []).filter((assignment)=>(0, _assignmentsHelpers.isActiveAssignment)(assignment) || assignment.id === review.assignment_id);
    // use to determine if an assignment was selected (or customer relationship)
    // this is used because initially the customer relationship is not selected in the assignment selector
    const [isAssignmentRelationSelected, setIsAssignmentRelationSelected] = (0, _react.useState)(// if the customer has no assignments or this is not a new review it means that isAssignmentRelationSelected is selected
    // it's either undefined which means it is the customer relation or already selected assignment
    !(0, _collectionUtils.hasContent)(assignments) || !isNew || review.assignment_id !== undefined);
    //////// checklists
    // save the list of checklists that were added as a result of a change in the review to they could be marked as "new"
    const [addedChecklistsIds, setAddedChecklistsIds] = (0, _react.useState)([]);
    const resetAddedChecklists = ()=>setAddedChecklistsIds([]);
    // save a list of checklists that were manually removed by the user so they would not be automatically added again
    const [manuallyRemovedChecklistIds, setManuallyRemovedChecklistsIds] = (0, _react.useState)([]);
    const getMatchedReviewChecklists = (0, _useReviewChecklistConditionsDefault.default)(customer, riskIndicators);
    // check for changes in the pre-selected review checklists based on changes in the review
    // for example: if the assignment changes, or the user is marked as PEP / Sanction
    const calculateReviewChecklists = (checklistAnswers = [], updatedReview)=>{
        const prevMatchedReviewChecklistsIds = checklistAnswers.map((checklistAnswer)=>checklistAnswer.checklist_id);
        // get a list of checklists that were not manually removed by the user
        const newMatchedReviewChecklists = getMatchedReviewChecklists(updatedReview).filter((checklist)=>!manuallyRemovedChecklistIds.includes(checklist.id));
        const newMatchedReviewChecklistsIds = (0, _collectionUtils.pickIds)(newMatchedReviewChecklists);
        const [checklistsIdsToAdd, checklistsIdsToRemove] = (0, _collectionUtils.delta)(newMatchedReviewChecklistsIds, prevMatchedReviewChecklistsIds);
        const checklistsToAdd = newMatchedReviewChecklists.filter((checklist)=>checklistsIdsToAdd.includes(checklist.id));
        const reviewChecklistsAnswers = updatedReview.checklist_answers || [];
        const defaultAnswer = features.REVIEW__CHECKLIST_DEFAULT_TO_NO ? false : undefined;
        // add checklists that were added
        reviewChecklistsAnswers.push(...checklistsToAdd.map((checklist)=>(0, _checklistsHelpers.createChecklistAnswers)(checklist, defaultAnswer)));
        // remove checklists that removed
        checklistsIdsToRemove.forEach((checklistId)=>{
            // find the checklist answers to be removed
            const removedChecklistAnswerCandidate = reviewChecklistsAnswers?.find((checklistAnswer)=>checklistAnswer.checklist_id == checklistId);
            // if the answers are not filled the they can be removed - but if they are partially filled then do not remove them
            if (!(0, _checklistsHelpers.isChecklistPartiallyFilled)(removedChecklistAnswerCandidate?.answers)) {
                const indexOfChecklistAnswer = removedChecklistAnswerCandidate ? reviewChecklistsAnswers.indexOf(removedChecklistAnswerCandidate) : -1;
                if (indexOfChecklistAnswer > -1) reviewChecklistsAnswers?.splice(indexOfChecklistAnswer, 1);
            }
        });
        setAddedChecklistsIds(checklistsIdsToAdd);
        return reviewChecklistsAnswers;
    };
    // load the list of review checklists
    // if the review checklists are not fetched yet - update the review once the checklists have been fetched
    const { data: reviewChecklists } = (0, _useGetReviewChecklistsDefault.default)();
    const reviewChecklistsWereLoaded = (0, _collectionUtils.hasContent)(reviewChecklists?.checklists);
    (0, _react.useEffect)(()=>{
        if (!readonly && reviewChecklistsWereLoaded) {
            const checklistsAnswers = calculateReviewChecklists(originalReviewRef.current.checklist_answers, review);
            setReview({
                ...review,
                checklist_answers: checklistsAnswers
            });
        }
    }, [
        reviewChecklistsWereLoaded,
        readonly
    ]);
    //////// automatic risk and approvers
    const isMLROUser = (0, _useIsMLROUserDefault.default)();
    const { isSingleUser } = (0, _useGetUsersDefault.default)();
    const mlroUsers = (0, _useGetMLROUsersDefault.default)();
    // the current user is not MLRO AND it is not the single user of the system
    const canBeMarkedForApproval = features.AUTOMATIC_CUSTOMER_REVIEW_APPROVAL && !isMLROUser && !isSingleUser;
    const setAutomaticRiskAndApprovers = (updatedReview, fieldName, value)=>{
        const isMarkedAsPepOrSanctioned = value === true;
        const wasUnmarkedAsPepOrSanctioned = value === false && originalReviewRef.current[fieldName] === true;
        // if the customer is marked as pep or sanctioned they should have a HIGH risk level
        // this is not a validation - so the user can change the risk level after these changes are set
        if (isMarkedAsPepOrSanctioned) updatedReview.risk_level = "HIGH";
        // if the customer is marked as pep or sanctioned or was previously marked as pep or sanctioned
        // and the current user is not MLRO AND it is not the single user of the system
        // they should require approval
        // this is not a validation - so the user can change the required approval after these changes are set
        if ((isMarkedAsPepOrSanctioned || wasUnmarkedAsPepOrSanctioned) && canBeMarkedForApproval) {
            updatedReview.requires_approval = true;
            // if MLRO user is defined and not included in the approval user ids - add it
            if ((0, _collectionUtils.hasContent)(mlroUsers)) {
                const approvalUserIds = updatedReview.approval_user_ids || [];
                // add mlro users if not selected
                updatedReview.approval_user_ids = [
                    ...new Set([
                        ...approvalUserIds,
                        ...mlroUsers.map((user)=>user.id)
                    ]).values()
                ];
            }
        }
    };
    const handleReviewChange = (fieldName, value)=>{
        const updatedReview = {
            ...review,
            [fieldName]: value
        };
        if ((0, _customerReviews.HIGH_RISK_FIELDS).includes(fieldName)) setAutomaticRiskAndApprovers(updatedReview, fieldName, value);
        if (fieldName === "assignment_id") setIsAssignmentRelationSelected(true);
        if ((0, _reviewChecklists.REVIEW_FIELDS_INCLUDED_IN_CHECKLISTS).includes(fieldName)) updatedReview.checklist_answers = calculateReviewChecklists(review.checklist_answers, updatedReview);
        if (fieldName === "checklist_answers") resetAddedChecklists();
        setReview(updatedReview);
    };
    const isInvalidChecklistAnswers = features.REVIEW_CHECKLIST && review.checklist_answers?.some((checklistAnswer)=>(0, _reviewsHelpers.isInvalidReviewChecklistAnswers)(checklistAnswer, reviewChecklists?.checklists));
    const isInvalidReview = (0, _stringUtils.isEmptyString)(review.comment) || review.risk_level === "NOT_SET" || review.accepted === undefined || !isAssignmentRelationSelected || // the approval users list should not be empty
    review.requires_approval && !(0, _collectionUtils.hasContent)(review.approval_user_ids) || isInvalidChecklistAnswers;
    const reviewedBy = isPossibleToApprove || !isEditable ? exitingReview?.reviewed_by : undefined;
    const reviewApproval = exitingReview?.approval;
    const reviewDate = exitingReview?.date;
    const signatures = customer.disclosure_documents.filter((disclosure)=>disclosure.is_signed).flatMap((disclosure)=>disclosure.signatures).filter((signature)=>Boolean(signature.disclosure || signature.disclosure_answers || signature.questionnaire_answers));
    // a list of checklist answers from a saved/pending review
    const savedChecklistAnswers = exitingReview?.checklist_answers;
    return {
        previousPageLabel,
        readonly,
        review,
        reviewedBy,
        reviewDate,
        reviewApproval,
        isInvalidReview,
        isPossibleToApprove,
        isReviewChanged,
        canBeDeleted: isEditable,
        assignments,
        signatures,
        savedChecklistAnswers,
        addedChecklistsIds,
        manuallyRemovedChecklistIds,
        resetAddedChecklists,
        setManuallyRemovedChecklistsIds,
        handleReviewChange,
        resetReviewIsChanged,
        setReview,
        onBackNavigation
    };
};
exports.default = useCustomerReviewPage;

},{"react":"cOWTg","react-router-dom":"1ee65","../../constants/customer-reviews":"fUs4p","../../constants/page-anchors":"4WmvA","../../constants/review-checklists":"dV1lT","../../constants/routes":"ihtm8","../../helpers/assignments.helpers":"7t8rY","../../helpers/checklists.helpers":"4fhyQ","../../helpers/display.helpers":"2q3xY","../../helpers/reviews.helpers":"1oYIN","../../hooks/useCustomerPath":"gJfCj","../../hooks/useCustomerReview":"8Ciom","../../hooks/useCustomerReviewBanner":"1BJZA","../../hooks/useFeatures":"hvBWb","../../hooks/useGetMLROUsers":"cE2Tf","../../hooks/useGetReviewChecklists":"lxc8X","../../hooks/useGetUsers":"c83Pg","../../hooks/useInitialCustomerReview":"tRYhm","../../hooks/useIsMLROUser":"338u5","../../hooks/useReviewChecklistConditions":"9STzP","../../hooks/useStorage":"aERXD","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fUs4p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HIGH_RISK_FIELDS", ()=>HIGH_RISK_FIELDS);
const HIGH_RISK_FIELDS = [
    "is_pep",
    "is_sanctioned"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dV1lT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEW_REVIEW_CHECKLIST_PREFIX", ()=>NEW_REVIEW_CHECKLIST_PREFIX);
parcelHelpers.export(exports, "REVIEW_FIELDS_INCLUDED_IN_CHECKLISTS", ()=>REVIEW_FIELDS_INCLUDED_IN_CHECKLISTS);
const NEW_REVIEW_CHECKLIST_PREFIX = "review-checklist";
const REVIEW_FIELDS_INCLUDED_IN_CHECKLISTS = [
    "assignment_id",
    "is_pep",
    "is_sanctioned",
    "risk_level",
    "labels"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"tRYhm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useRiskIndicators = require("../components/RiskIndicators/useRiskIndicators");
var _useRiskIndicatorsDefault = parcelHelpers.interopDefault(_useRiskIndicators);
var _checklistsHelpers = require("../helpers/checklists.helpers");
var _customerHelpers = require("../helpers/customer.helpers");
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useReviewChecklistConditions = require("./useReviewChecklistConditions");
var _useReviewChecklistConditionsDefault = parcelHelpers.interopDefault(_useReviewChecklistConditions);
const useInitialCustomerReview = (customer, riskIndicators)=>{
    const features = (0, _useFeaturesDefault.default)();
    const { showGeographicRisk, showDisclosuresRisk, showIndustryRisk } = (0, _useRiskIndicatorsDefault.default)(riskIndicators);
    const getMatchedReviewChecklists = (0, _useReviewChecklistConditionsDefault.default)(customer, riskIndicators);
    const getInitialRiskLevel = ()=>{
        if (customer.is_pep || customer.is_sanctioned) return "HIGH";
        if (features.REVIEW__AUTO_SET_RISK && (showGeographicRisk || showDisclosuresRisk || showIndustryRisk)) return "HIGH";
        return customer.risk_level;
    };
    const preselectedReviewChecklists = getMatchedReviewChecklists();
    const defaultAnswer = features.REVIEW__CHECKLIST_DEFAULT_TO_NO ? false : undefined;
    const customerReview = {
        // if accepted is undefined then this is the first review (customer relationship was not defined yet)
        accepted: customer.review_status === "APPROVED" ? true : customer.review_status === "REJECTED" ? false : undefined,
        risk_level: getInitialRiskLevel(),
        is_pep: (0, _customerHelpers.isCustomerPEP)(customer),
        is_sanctioned: (0, _customerHelpers.isCustomerSanctioned)(customer),
        requires_approval: false,
        comment: "",
        labels: [],
        checklist_answers: preselectedReviewChecklists.map((checklist)=>(0, _checklistsHelpers.createChecklistAnswers)(checklist, defaultAnswer))
    };
    return customerReview;
};
exports.default = useInitialCustomerReview;

},{"../components/RiskIndicators/useRiskIndicators":"eYp6X","../helpers/checklists.helpers":"4fhyQ","../helpers/customer.helpers":"dkhe3","./useFeatures":"hvBWb","./useReviewChecklistConditions":"9STzP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9STzP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useRiskIndicators = require("../components/RiskIndicators/useRiskIndicators");
var _useRiskIndicatorsDefault = parcelHelpers.interopDefault(_useRiskIndicators);
var _checklistsHelpers = require("../helpers/checklists.helpers");
var _customerHelpers = require("../helpers/customer.helpers");
var _collectionUtils = require("../utils/collectionUtils");
var _useGetReviewChecklists = require("./useGetReviewChecklists");
var _useGetReviewChecklistsDefault = parcelHelpers.interopDefault(_useGetReviewChecklists);
const useReviewChecklistConditions = (customer, riskIndicators)=>{
    const { data } = (0, _useGetReviewChecklistsDefault.default)();
    const { showGeographicRisk, showIndustryRisk, disclosuresRisk } = (0, _useRiskIndicatorsDefault.default)(riskIndicators);
    const isMatched = (checklist, review)=>{
        // check if checklist is not archived
        if (!(0, _checklistsHelpers.isChecklistActive)(checklist)) return false;
        const condition = checklist.display_settings;
        const reviewPEP = review?.is_pep;
        const reviewSanction = review?.is_sanctioned;
        const reviewAssignmentId = review?.assignment_id;
        const assignmentPurpose = customer.assignments?.find((assignment)=>assignment.id === reviewAssignmentId)?.purpose;
        // check customer type
        if (customer.type === "person" && checklist.customer_type === "company" || customer.type === "company" && checklist.customer_type === "person") return false;
        if (condition.is_always_select) // check always select
        return true;
        // check tags
        if ((0, _collectionUtils.hasContent)(condition.labels) && ((0, _collectionUtils.includesAllItems)(customer.labels, condition.labels) || (0, _collectionUtils.includesAllItems)(review?.labels, condition.labels))) return true;
        // check assignment purpose
        if (assignmentPurpose && condition.assignment_purposes?.includes(assignmentPurpose)) return true;
        // check risk categories
        // check pep
        const disclosurePEP = disclosuresRisk.some(({ riskIndicator })=>riskIndicator?.type === "PEP" || riskIndicator?.type === "PEP_RCA");
        if (condition.risk_categories?.includes("PEP") && (disclosurePEP || reviewPEP || (0, _customerHelpers.isCustomerPEP)(customer))) return true;
        // check sanction
        if (condition.risk_categories?.includes("SANCTION") && (reviewSanction || (0, _customerHelpers.isCustomerSanctioned)(customer))) return true;
        // check geographic risk
        const disclosureGeographicRisk = disclosuresRisk.some(({ riskIndicator })=>riskIndicator?.type === "HIGH_RISK_COUNTRY");
        if (condition.risk_categories?.includes("GEOGRAPHIC_RISK") && (disclosureGeographicRisk || showGeographicRisk)) return true;
        // check industry risk
        const disclosureIndustryRisk = disclosuresRisk.some(({ riskIndicator })=>riskIndicator?.type === "HIGH_RISK_INDUSTRY");
        if (condition.risk_categories?.includes("INDUSTRY_RISK") && (disclosureIndustryRisk || showIndustryRisk)) return true;
        return false;
    };
    const getSelectedReviewChecklists = (review)=>{
        return data?.checklists.filter((checklist)=>isMatched(checklist, review)) || [];
    };
    return getSelectedReviewChecklists;
};
exports.default = useReviewChecklistConditions;

},{"../components/RiskIndicators/useRiskIndicators":"eYp6X","../helpers/checklists.helpers":"4fhyQ","../helpers/customer.helpers":"dkhe3","../utils/collectionUtils":"gr5mc","./useGetReviewChecklists":"lxc8X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lHtC7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _customersListBulkActions = require("../../components/CustomersListBulkActions/CustomersListBulkActions");
var _customersListBulkActionsDefault = parcelHelpers.interopDefault(_customersListBulkActions);
var _customersListEmptyState = require("../../components/CustomersListEmptyState/CustomersListEmptyState");
var _customersListEmptyStateDefault = parcelHelpers.interopDefault(_customersListEmptyState);
var _customersListFilters = require("../../components/CustomersListFilters/CustomersListFilters");
var _customersListFiltersDefault = parcelHelpers.interopDefault(_customersListFilters);
var _useRestoreLastWindowLocationSearch = require("../../components/CustomersListFilters/useRestoreLastWindowLocationSearch");
var _useRestoreLastWindowLocationSearchDefault = parcelHelpers.interopDefault(_useRestoreLastWindowLocationSearch);
var _customersListFreshCustomerEmptyState = require("../../components/CustomersListFreshCustomerEmptyState/CustomersListFreshCustomerEmptyState");
var _customersListFreshCustomerEmptyStateDefault = parcelHelpers.interopDefault(_customersListFreshCustomerEmptyState);
var _customersListTable = require("../../components/CustomersListTable/CustomersListTable");
var _customersListTableDefault = parcelHelpers.interopDefault(_customersListTable);
var _badge = require("../../components/extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _kdktabs = require("../../components/KDKTabs/KDKTabs");
var _kdktabsDefault = parcelHelpers.interopDefault(_kdktabs);
var _registerCustomerDropdownMenu = require("../../components/RegisterCustomerDropdownMenu/RegisterCustomerDropdownMenu");
var _registerCustomerDropdownMenuDefault = parcelHelpers.interopDefault(_registerCustomerDropdownMenu);
var _relatedSearchResults = require("../../components/RelatedSearchResults/RelatedSearchResults");
var _relatedSearchResultsDefault = parcelHelpers.interopDefault(_relatedSearchResults);
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _sessionState = require("../../constants/session-state");
var _styles = require("../../constants/styles");
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useCustomersListBulkActions = require("../../hooks/useCustomersListBulkActions");
var _useCustomersListBulkActionsDefault = parcelHelpers.interopDefault(_useCustomersListBulkActions);
var _useCustomersListParams = require("../../hooks/useCustomersListParams");
var _useCustomersListParamsDefault = parcelHelpers.interopDefault(_useCustomersListParams);
var _useCustomersTableColumns = require("../../hooks/useCustomersTableColumns");
var _useCustomersTableColumnsDefault = parcelHelpers.interopDefault(_useCustomersTableColumns);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSelectionMap = require("../../hooks/useSelectionMap");
var _useSelectionMapDefault = parcelHelpers.interopDefault(_useSelectionMap);
var _useShowResponsibleUserFilter = require("../../hooks/useShowResponsibleUserFilter");
var _useShowResponsibleUserFilterDefault = parcelHelpers.interopDefault(_useShowResponsibleUserFilter);
var _utilities = require("../../types/utilities");
const CUSTOMERS_LIST_TAB = 0;
const PENDING_TASKS_LIST_TAB = 1;
const CustomersListPage = ()=>{
    (0, _useRestoreLastWindowLocationSearchDefault.default)((0, _sessionState.CUSTOMERS_LIST_SEARCH));
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { user } = (0, _useAuthDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const location = (0, _reactRouterDom.useLocation)();
    const showResponsibleUserFilter = (0, _useShowResponsibleUserFilterDefault.default)();
    const { searchParams, isEmptySearch, q, haveOwnershipUpdates, isArchived, pendingTasks, setPendingTasks, responsibleUserIds, setResponsibleUserIds } = (0, _useCustomersListParamsDefault.default)();
    const selectedTabIndex = pendingTasks ? PENDING_TASKS_LIST_TAB : CUSTOMERS_LIST_TAB;
    const { isLoading, data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST,
        ...Object.values(searchParams)
    ], ()=>(0, _apiDefault.default).getCustomers(searchParams));
    const { data: countsData } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_COUNTS,
        ...Object.values(searchParams)
    ], ()=>(0, _apiDefault.default).getCustomerCounts(searchParams));
    const count = countsData?.count || 0;
    const customersWithPendingTasksCount = countsData?.has_pending_tasks_count || 0;
    const customers = data?.customers || [];
    const paginationCount = pendingTasks ? customersWithPendingTasksCount : count;
    const isFreshCustomer = customers.length === 0 && isEmptySearch;
    const isFromDashboard = location.state?.fromDashboard === true;
    const renderRelatedSearchResults = (customer)=>{
        const relatedSearchResults = (0, _utilities.isCompanySearchResult)(customer) ? customer.related_search_results || [] : [];
        if (relatedSearchResults.length === 0) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _relatedSearchResultsDefault.default), {
            searchResults: relatedSearchResults,
            searchTerm: q
        });
    };
    const columns = (0, _useCustomersTableColumnsDefault.default)(q, haveOwnershipUpdates, renderRelatedSearchResults);
    const [selectedCustomersIds, selectedCustomers, handleSelectionChange, clearSelection] = (0, _useSelectionMapDefault.default)(customers);
    // switching between normal and archived customers changes the available actions in the page
    // clear the selected customers if the filter is changed so there won't be a mix of archived and regular customers
    (0, _react.useEffect)(clearSelection, [
        isArchived
    ]);
    // run this effect here and not (for example) in useCustomersListParams.tsx
    // in order to avoid re-running it in multiple components that use useCustomersListParams
    (0, _react.useEffect)(()=>{
        if (!user || !showResponsibleUserFilter) return;
        // if the users is a "plain" user (without groups) and there are no responsible users ids as parameters
        // set the default responsible user id to be the current user
        const useCurrentUserId = user.groups.length === 0 && responsibleUserIds.length === 0;
        if (useCurrentUserId) setResponsibleUserIds([
            user.id
        ]);
    }, [
        user,
        showResponsibleUserFilter
    ]);
    const selectedCount = selectedCustomersIds.length;
    const { isEmpty: areBulkActionEmpty } = (0, _useCustomersListBulkActionsDefault.default)(selectedCount, isArchived);
    const isAllSelected = count === selectedCustomersIds.length;
    const selectedLabel = isAllSelected ? f("customers.list.header.customers.count.all", {
        count
    }) : f("customers.list.header.customers.count", {
        count,
        selected: selectedCustomersIds.length
    });
    const countersLabel = count > 0 ? selectedLabel : "";
    const handleTabChange = (0, _react.useCallback)((selectedTabIndex)=>{
        setPendingTasks(selectedTabIndex === PENDING_TASKS_LIST_TAB);
    }, []);
    const tabs = [
        {
            id: "all-customers",
            content: f("customers.list.tabs.labels.all", {
                count
            })
        },
        {
            id: "customers-with-pending-tasks",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                spacing: "tight",
                distribution: "center",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        children: f("customers.list.tabs.labels.pending-tasks")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                        status: customersWithPendingTasksCount > 0 ? "severe" : undefined,
                        children: formatNumber(customersWithPendingTasksCount)
                    })
                ]
            })
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                isFromDashboard && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                    url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).DASHBOARD),
                    displayLabel: f("nav-bar.dashboard"),
                    showAsLink: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    align: "space-between",
                    blockAlign: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "heading2xl",
                            as: "p",
                            children: f("customers.list.title")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _registerCustomerDropdownMenuDefault.default), {})
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListFiltersDefault.default), {
                            isLoading: isLoading
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTabs, {
                            tabs: tabs,
                            selected: selectedTabIndex,
                            onSelect: handleTabChange,
                            fitted: true,
                            centered: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSelectionWrapper, {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    children: countersLabel
                                                })
                                            }),
                                            selectedCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListBulkActionsDefault.default), {
                                                customers: selectedCustomers,
                                                isArchived: isArchived,
                                                onClearSelection: clearSelection
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTable, {
                                        columns: columns,
                                        customers: customers,
                                        isLoading: isLoading,
                                        additionalPaginationOnTop: features.CUSTOMERS_LIST__PAGINATION_ON_TOP,
                                        count: paginationCount || 0,
                                        selectable: !areBulkActionEmpty,
                                        selectedIds: selectedCustomersIds,
                                        onSelectionChange: handleSelectionChange
                                    }),
                                    !isLoading && customers.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                            children: isFreshCustomer ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListFreshCustomerEmptyStateDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListEmptyStateDefault.default), {})
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const StyledTable = (0, _styledComponentsDefault.default)((0, _customersListTableDefault.default))`
  & .Polaris-DataTable,
  & .Polaris-DataTable__ScrollContainer {
    overflow: unset;
  }

  & thead > tr > th {
    position: sticky;
    top: var(--kdk-toolbar-height);
    z-index: var(--p-z-1);
    background-color: var(--p-surface);
  }

  & table {
    border-collapse: separate;
    border-spacing: 0 var(--p-space-2);
  }

  & tbody > tr > td:first-child {
    border-top-left-radius: var(--p-border-radius-1);
    border-bottom-left-radius: var(--p-border-radius-1);
  }

  & tbody > tr > td:last-child {
    border-top-right-radius: var(--p-border-radius-1);
    border-bottom-right-radius: var(--p-border-radius-1);
  }

  .Polaris-DataTable__TableRow + .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {
    border-top: none;
  }

  padding: 0 var(--p-space-4) var(--p-space-4);
  background-color: var(--p-surface);
  border-radius: var(--p-border-radius-1);
  box-shadow: var(--p-shadow-card);

  // For small viewports - reduce gap of page and adjust table row "card" corners
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    & table {
      border-collapse: collapse;
      border-spacing: 0;
    }

    padding: 0;
    box-shadow: none;

    // select the second table cell since the first one (selection checkboxes) is hidden
    & tbody > tr > td:nth-child(2) {
      border-top-left-radius: var(--p-border-radius-2);
      border-top-right-radius: var(--p-border-radius-2);
    }

    & tbody > tr > td:last-child {
      border-bottom-left-radius: var(--p-border-radius-2);
      border-bottom-right-radius: var(--p-border-radius-2);
    }
  }
`;
const StyledTabs = (0, _styledComponentsDefault.default)((0, _kdktabsDefault.default))`
  & > .Polaris-HorizontalStack {
    margin: 0 20%;
  }

  & .Polaris-Box {
    margin-bottom: var(--p-space-4);
  }

  // For small viewports - reduce gap of page
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    & > .Polaris-HorizontalStack {
      margin: 0;
    }
  }
`;
const StyledSelectionWrapper = (0, _styledComponentsDefault.default).div`
  display: flex;
  min-height: calc(var(--p-font-line-height-4) + var(--p-border-width-1)); // 2px to account for border width
  align-items: center;
`;
exports.default = CustomersListPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../components/BackButton/BackButton":"4fa4k","../../components/CustomersListBulkActions/CustomersListBulkActions":"liUU5","../../components/CustomersListEmptyState/CustomersListEmptyState":"5yume","../../components/CustomersListFilters/CustomersListFilters":"9JJkq","../../components/CustomersListFilters/useRestoreLastWindowLocationSearch":"3cuOV","../../components/CustomersListFreshCustomerEmptyState/CustomersListFreshCustomerEmptyState":"aBWie","../../components/CustomersListTable/CustomersListTable":"27PCy","../../components/extensions/Badge":"9irVp","../../components/KDKTabs/KDKTabs":"hryzj","../../components/RegisterCustomerDropdownMenu/RegisterCustomerDropdownMenu":"c3ucx","../../components/RelatedSearchResults/RelatedSearchResults":"hMjQd","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../constants/session-state":"g0N7C","../../constants/styles":"dZWds","../../hooks/useAuth":"k9r0q","../../hooks/useCustomersListBulkActions":"25KJi","../../hooks/useCustomersListParams":"euKlt","../../hooks/useCustomersTableColumns":"hYOXE","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSelectionMap":"i8gbg","../../hooks/useShowResponsibleUserFilter":"khaJz","../../types/utilities":"6zLpB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"liUU5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useCustomersListBulkActions = require("../../hooks/useCustomersListBulkActions");
var _useCustomersListBulkActionsDefault = parcelHelpers.interopDefault(_useCustomersListBulkActions);
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _projectInfoModal = require("../ProjectInfoModal/ProjectInfoModal");
var _projectInfoModalDefault = parcelHelpers.interopDefault(_projectInfoModal);
var _addToProjectModal = require("./AddToProjectModal/AddToProjectModal");
var _addToProjectModalDefault = parcelHelpers.interopDefault(_addToProjectModal);
var _responsibleUsersModal = require("./ResponsibleUsersModal/ResponsibleUsersModal");
var _responsibleUsersModalDefault = parcelHelpers.interopDefault(_responsibleUsersModal);
var _archiveCustomers = require("./ArchiveCustomers");
var _archiveCustomersDefault = parcelHelpers.interopDefault(_archiveCustomers);
var _changeScreeningTypeModal = require("./ChangeScreeningTypeModal");
var _changeScreeningTypeModalDefault = parcelHelpers.interopDefault(_changeScreeningTypeModal);
var _customersTagsPopover = require("./CustomersTagsPopover");
var _customersTagsPopoverDefault = parcelHelpers.interopDefault(_customersTagsPopover);
var _deleteCustomers = require("./DeleteCustomers");
var _deleteCustomersDefault = parcelHelpers.interopDefault(_deleteCustomers);
var _followupDateModal = require("./FollowupDateModal");
var _followupDateModalDefault = parcelHelpers.interopDefault(_followupDateModal);
var _restoreCustomers = require("./RestoreCustomers");
var _restoreCustomersDefault = parcelHelpers.interopDefault(_restoreCustomers);
const CustomersListBulkActions = (props)=>{
    const { customers, isArchived, onClearSelection } = props;
    const { bulkActions, showResponsibleUserModal, showArchiveConfirm, showDeleteConfirm, showRestoreConfirm, showAddToProjectModal, showAddToNewProjectModal, showFollowupDateModal, showChangeScreeningTypeModal, closeResponsibleUserModal, closeArchiveConfirm, closeDeleteConfirm, closeRestoreConfirm, closeAddToProjectModal, closeAddToNewProjectModal, closeFollowupDateModal, closesChangeScreeningTypeModal } = (0, _useCustomersListBulkActionsDefault.default)(customers.length, isArchived);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: bulkActions,
                cutoff: bulkActions.length === 1 ? 1 : 0
            }),
            !isArchived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersTagsPopoverDefault.default), {
                customers: customers
            }),
            showResponsibleUserModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsibleUsersModalDefault.default), {
                customers: customers,
                onClose: closeResponsibleUserModal
            }),
            showArchiveConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archiveCustomersDefault.default), {
                customers: customers,
                onClose: closeArchiveConfirm,
                onSuccess: onClearSelection
            }),
            showDeleteConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteCustomersDefault.default), {
                customers: customers,
                onClose: closeDeleteConfirm,
                onSuccess: onClearSelection
            }),
            showRestoreConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _restoreCustomersDefault.default), {
                customers: customers,
                onClose: closeRestoreConfirm,
                onSuccess: onClearSelection
            }),
            showAddToProjectModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addToProjectModalDefault.default), {
                customers: customers,
                onClose: closeAddToProjectModal
            }),
            showAddToNewProjectModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectInfoModalDefault.default), {
                customers: customers,
                onClose: closeAddToNewProjectModal
            }),
            showFollowupDateModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _followupDateModalDefault.default), {
                customers: customers,
                onClose: closeFollowupDateModal
            }),
            showChangeScreeningTypeModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changeScreeningTypeModalDefault.default), {
                customers: customers,
                onClose: closesChangeScreeningTypeModal
            })
        ]
    });
};
exports.default = CustomersListBulkActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useCustomersListBulkActions":"25KJi","../ActionsDropdown/ActionsDropdown":"izRYG","../ProjectInfoModal/ProjectInfoModal":"bljDA","./AddToProjectModal/AddToProjectModal":"hXY5u","./ResponsibleUsersModal/ResponsibleUsersModal":"9LFts","./ArchiveCustomers":"jxk2c","./ChangeScreeningTypeModal":"73SD2","./CustomersTagsPopover":"bFGcF","./DeleteCustomers":"gVKiS","./FollowupDateModal":"6oEiW","./RestoreCustomers":"lOpET","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"25KJi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _archiveboxSvg = require("../../assets/icons/archivebox.svg");
var _archiveboxSvgDefault = parcelHelpers.interopDefault(_archiveboxSvg);
var _calendarSvg = require("../../assets/icons/calendar.svg");
var _calendarSvgDefault = parcelHelpers.interopDefault(_calendarSvg);
var _folderPlusSvg = require("../../assets/icons/folder-plus.svg");
var _folderPlusSvgDefault = parcelHelpers.interopDefault(_folderPlusSvg);
var _foldersSvg = require("../../assets/icons/folders.svg");
var _foldersSvgDefault = parcelHelpers.interopDefault(_foldersSvg);
var _gearSvg = require("../../assets/icons/gear.svg");
var _gearSvgDefault = parcelHelpers.interopDefault(_gearSvg);
var _personArrowTowardSvg = require("../../assets/icons/person-arrow-toward.svg");
var _personArrowTowardSvgDefault = parcelHelpers.interopDefault(_personArrowTowardSvg);
var _restoreSvg = require("../../assets/icons/restore.svg");
var _restoreSvgDefault = parcelHelpers.interopDefault(_restoreSvg);
var _trashSvg = require("../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _permissions = require("../constants/permissions");
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("./useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("./usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useProjectPermissions = require("./useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
const useCustomersListBulkActions = (selectedCustomersCount, isArchivedCustomers)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const { isCreateOrAddToProjectEnabled } = (0, _useProjectPermissionsDefault.default)();
    const [showResponsibleUserModal, toggleResponsibleUserModal, closeResponsibleUserModal] = (0, _useOpenCloseDefault.default)();
    const [showArchiveConfirm, toggleArchiveConfirm, closeArchiveConfirm] = (0, _useOpenCloseDefault.default)();
    const [showDeleteConfirm, toggleDeleteConfirm, closeDeleteConfirm] = (0, _useOpenCloseDefault.default)();
    const [showRestoreConfirm, toggleRestoreConfirm, closeRestoreConfirm] = (0, _useOpenCloseDefault.default)();
    const [showAddToProjectModal, toggleAddToProjectModal, closeAddToProjectModal] = (0, _useOpenCloseDefault.default)();
    const [showAddToNewProjectModal, toggleAddToNewProjectModal, closeAddToNewProjectModal] = (0, _useOpenCloseDefault.default)();
    const [showFollowupDateModal, toggleFollowupDateModal, closeFollowupDateModal] = (0, _useOpenCloseDefault.default)();
    const [showChangeScreeningTypeModal, toggleChangeScreeningTypeModal, closesChangeScreeningTypeModal] = (0, _useOpenCloseDefault.default)();
    const bulkActions = [];
    if (isArchivedCustomers) {
        bulkActions.push({
            content: f("bulk.actions.restore.confirmation.title"),
            image: (0, _restoreSvgDefault.default),
            onAction: toggleRestoreConfirm,
            disabled: selectedCustomersCount === 0
        });
        if (isPermittedTo((0, _permissions.PERMISSIONS_TYPES).DELETE_CUSTOMER)) bulkActions.push({
            content: f("bulk.actions.delete.confirmation.title"),
            image: (0, _trashSvgDefault.default),
            onAction: toggleDeleteConfirm,
            disabled: selectedCustomersCount === 0
        });
    } else {
        if (features.RESPONSIBLE_USER) bulkActions.push({
            content: f("bulk.actions.responsible.label"),
            image: (0, _personArrowTowardSvgDefault.default),
            onAction: toggleResponsibleUserModal,
            disabled: selectedCustomersCount === 0
        });
        bulkActions.push({
            content: f("bulk.actions.archive.confirmation.title"),
            image: (0, _archiveboxSvgDefault.default),
            onAction: toggleArchiveConfirm,
            disabled: selectedCustomersCount === 0
        });
        if (isCreateOrAddToProjectEnabled) {
            bulkActions.push({
                content: f("bulk.actions.add-to-existing-project.label"),
                image: (0, _foldersSvgDefault.default),
                onAction: toggleAddToProjectModal,
                disabled: selectedCustomersCount === 0
            });
            bulkActions.push({
                content: f("bulk.actions.add-to-new-project.label"),
                image: (0, _folderPlusSvgDefault.default),
                onAction: toggleAddToNewProjectModal,
                disabled: selectedCustomersCount === 0
            });
        }
        bulkActions.push({
            content: f("bulk.actions.followup.label"),
            image: (0, _calendarSvgDefault.default),
            onAction: toggleFollowupDateModal,
            disabled: selectedCustomersCount === 0
        });
        if (features.CUSTOMERS_LIST__BATCH_CHANGE_SCREENING_ACTION && isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS)) bulkActions.push({
            content: f("bulk.actions.change-screening-type.label"),
            image: (0, _gearSvgDefault.default),
            onAction: toggleChangeScreeningTypeModal,
            disabled: selectedCustomersCount === 0
        });
    }
    const isEmpty = bulkActions.length === 0;
    return {
        isEmpty,
        bulkActions,
        showResponsibleUserModal,
        showArchiveConfirm,
        showDeleteConfirm,
        showRestoreConfirm,
        showAddToProjectModal,
        showAddToNewProjectModal,
        showFollowupDateModal,
        showChangeScreeningTypeModal,
        closeResponsibleUserModal,
        closeArchiveConfirm,
        closeDeleteConfirm,
        closeRestoreConfirm,
        closeAddToProjectModal,
        closeAddToNewProjectModal,
        closeFollowupDateModal,
        closesChangeScreeningTypeModal
    };
};
exports.default = useCustomersListBulkActions;

},{"../../assets/icons/archivebox.svg":"cyEGJ","../../assets/icons/calendar.svg":"kKBe6","../../assets/icons/folder-plus.svg":"kDzpg","../../assets/icons/folders.svg":"7c7Qz","../../assets/icons/gear.svg":"765LR","../../assets/icons/person-arrow-toward.svg":"jZVqt","../../assets/icons/restore.svg":"hwxcs","../../assets/icons/trash.svg":"jqW55","../constants/permissions":"jhCn5","./useFeatures":"hvBWb","./useFormatMessage":"8Y8fq","./useOpenClose":"idooG","./usePermissions":"4CdYX","./useProjectPermissions":"23Tgs","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kDzpg":[function(require,module,exports) {
module.exports = require("7171e2b9f45a61fe").getBundleURL("kEMsi") + "folder-plus.0b47208f.svg";

},{"7171e2b9f45a61fe":"75UoR"}],"765LR":[function(require,module,exports) {
module.exports = require("7ef5eef07d9b5f0").getBundleURL("kEMsi") + "gear.274a89d3.svg";

},{"7ef5eef07d9b5f0":"75UoR"}],"jZVqt":[function(require,module,exports) {
module.exports = require("2b90f4f6aa9377a0").getBundleURL("kEMsi") + "person-arrow-toward.a29522c3.svg";

},{"2b90f4f6aa9377a0":"75UoR"}],"bljDA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const ProjectInfoModal = (props)=>{
    const { project, customers = [], onClose } = props;
    const [name, setName] = (0, _react.useState)(project?.name || "");
    const [description, setDescription] = (0, _react.useState)(project?.description || "");
    const f = (0, _useFormatMessageDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const history = (0, _reactRouterDom.useHistory)();
    const isNewProject = project?.id === undefined;
    const showFooter = isNewProject && customers.length > 0;
    const customersIds = customers.map((customer)=>customer.id);
    const actionLabel = isNewProject ? f("projects.common.labels.create.project") : f("projects.common.labels.update.project");
    const saveProjectMutation = (0, _reactQuery.useMutation)(()=>isNewProject ? (0, _apiDefault.default).createProject({
            name,
            description,
            customer_ids: customersIds
        }) : (0, _apiDefault.default).updateProject(project.id, {
            name,
            description
        }), {
        onSuccess: (updatedProject)=>{
            if (isNewProject) history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
                id: updatedProject.id
            }));
            else queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
                project.id
            ]);
            handleClose();
        }
    });
    const handleClose = ()=>{
        saveProjectMutation.reset();
        onClose();
    };
    const isInvalid = ()=>(0, _stringUtils.isEmptyString)(name) || (0, _stringUtils.isEmptyString)(description);
    const saveProjectAction = {
        content: actionLabel,
        onAction: ()=>saveProjectMutation.mutate(),
        loading: saveProjectMutation.isLoading,
        disabled: saveProjectMutation.isLoading || isInvalid()
    };
    const cancelAction = {
        content: f("default.cancel"),
        onAction: ()=>handleClose(),
        disabled: saveProjectMutation.isLoading
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        title: actionLabel,
        onClose: handleClose,
        primaryAction: saveProjectAction,
        secondaryActions: [
            cancelAction
        ],
        footer: showFooter && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            children: f("common.labels.selected-customers-count", {
                count: customers.length
            })
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal).Section, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                            label: f("project.details.labels.name"),
                            autoComplete: "off",
                            requiredIndicator: true,
                            autoFocus: true,
                            disabled: saveProjectMutation.isLoading,
                            value: name,
                            onChange: setName
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                            label: f("project.details.labels.description"),
                            autoComplete: "off",
                            requiredIndicator: true,
                            multiline: 4,
                            disabled: saveProjectMutation.isLoading,
                            value: description,
                            onChange: setDescription
                        })
                    ]
                }),
                saveProjectMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: saveProjectMutation.error
                })
            ]
        })
    });
};
exports.default = ProjectInfoModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9LFts":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _displayHelpers = require("../../../helpers/display.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _displayName = require("../../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _emailView = require("../../EmailView/EmailView");
var _emailViewDefault = parcelHelpers.interopDefault(_emailView);
var _errorPanel = require("../../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _rowHighlighter = require("../../extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _useSetResponsibleUser = require("./useSetResponsibleUser");
var _useSetResponsibleUserDefault = parcelHelpers.interopDefault(_useSetResponsibleUser);
const ResponsibleUsersModal = (props)=>{
    const { customers, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const [showSuccessMessageToast, toggleSuccessMessageToast, closeSuccessMessageToast] = (0, _useOpenCloseDefault.default)();
    const { isLoadingUsers, hasError, error, users, isValid, isUpdating, areAllChecked, handleSelectAll, isUserChecked, handleUserSelection, setResponsibleUsers } = (0, _useSetResponsibleUserDefault.default)(customers);
    const saveAction = {
        content: f("default.save"),
        onAction: async ()=>{
            await setResponsibleUsers();
            toggleSuccessMessageToast();
        },
        disabled: !isValid,
        loading: isUpdating
    };
    const cancelAction = {
        content: f("default.cancel"),
        onAction: ()=>onClose(),
        disabled: isLoadingUsers || isUpdating
    };
    const renderRow = (user)=>[
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                checked: isUserChecked(user),
                onChange: ()=>handleUserSelection(user),
                label: "",
                labelHidden: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
                subdued: !user.is_active,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                    type: "person",
                    name: (0, _displayHelpers.getFullName)(user)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledEmailView, {
                children: user.email
            })
        ];
    const customersNamesLabel = formatMultipleNames(customers.map((0, _displayHelpers.getCustomerName)));
    const handleToastDismiss = ()=>{
        closeSuccessMessageToast();
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
                open: !showSuccessMessageToast,
                title: f("responsible.modal.title"),
                onClose: onClose,
                primaryAction: saveAction,
                secondaryActions: [
                    cancelAction
                ],
                noScroll: true,
                loading: isLoadingUsers,
                footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: f("common.labels.selected-customers-count", {
                        count: customers.length
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal).Section, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                children: f("responsible.modal.message", {
                                    names: customersNamesLabel
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                                columnContentTypes: [
                                    "text",
                                    "text",
                                    "text"
                                ],
                                headings: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                        checked: areAllChecked,
                                        label: "",
                                        labelHidden: true,
                                        onChange: handleSelectAll
                                    }),
                                    f("table.column.name"),
                                    f("table.column.email")
                                ],
                                rows: users.map(renderRow)
                            })
                        ]
                    }),
                    hasError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: error
                    })
                ]
            }),
            showSuccessMessageToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                onDismiss: handleToastDismiss,
                content: f("bulk.actions.responsible.success.message")
            })
        ]
    });
};
const StyledEmailView = (0, _styledComponentsDefault.default)((0, _emailViewDefault.default))`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 28ch;
`;
exports.default = ResponsibleUsersModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../helpers/display.helpers":"2q3xY","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useFormatMultipleNames":"gogmY","../../../hooks/useOpenClose":"idooG","../../DisplayName/DisplayName":"gKd5g","../../EmailView/EmailView":"6hcVY","../../ErrorPanel/ErrorPanel":"2hHqH","../../extensions/RowHighlighter":"9EbPr","./useSetResponsibleUser":"4Pko2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4Pko2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../../constants/queries-keys");
var _useGetUsers = require("../../../hooks/useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
var _collectionUtils = require("../../../utils/collectionUtils");
var _selectionUtils = require("../../../utils/selectionUtils");
const useSetResponsibleUser = (customers)=>{
    const customerIds = customers.map((customer)=>customer.id);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { isLoading: isLoadingUsers, users, activeUsers, error: loadingUsersError } = (0, _useGetUsersDefault.default)();
    const { selectedItems: selectedResponsibleUsers, partiallySelectedItems: partiallySelectedResponsibleUsers } = (0, _selectionUtils.getIndeterminateSelection)(customers, (entity)=>entity.responsible_users || []);
    const [responsibleUsersIds, setResponsibleUsersIds] = (0, _react.useState)(()=>selectedResponsibleUsers.map((user)=>user.id));
    const [partiallySelectedResponsibleUsersIds, setPartiallySelectedResponsibleUsersIds] = (0, _react.useState)(()=>partiallySelectedResponsibleUsers.map((user)=>user.id));
    const setResponsibleUserMutation = (0, _reactQuery.useMutation)((0, _apiDefault.default).batchSetResponsibleUsersOnCustomers, {
        onSuccess: ()=>{
            // TODO better update the query cache instead of invalidating it completely
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST
            ]);
        }
    });
    /**
   * This method will either call setResponsibleUserMutation once to set all the selected users as responsible users
   * for all the given customer OR it will call setResponsibleUserMutation multiple times if there are partially selected users
   */ const setResponsibleUsers = async ()=>{
        // if there are no partially selected responsible users
        // set all the selected responsible users to all the customers in a single mutation
        if (partiallySelectedResponsibleUsersIds.length === 0) setResponsibleUserMutation.mutate({
            customer_ids: customerIds,
            user_ids: responsibleUsersIds
        });
        else {
            // there is at least one customer with responsible users that were partially selected
            // (which means they will not be included in the responsibleUsersIds)
            // in order to avoid removing these responsible users from the customers,
            // set customers with responsible users that are partially selected
            // in a different mutation that also includes their responsible users
            const mutations = [];
            const customersWithoutPartialResponsibleUsersIds = [];
            customers.forEach((customer)=>{
                // if the customer has a responsible user that's in partiallySelectedResponsibleUsersIds
                // it means that responsible user should be included when setting responsible users for that customer
                const existingResponsibleUsers = customer.responsible_users || [];
                if (existingResponsibleUsers.find((responsible)=>partiallySelectedResponsibleUsersIds.includes(responsible.id))) {
                    // responsible users for customer with partially selected responsible users should include
                    // 1. all selected responsible users
                    // 2. partially selected responsible users that were already assigned to the customer
                    const combinedResponsibleUserIds = [
                        ...responsibleUsersIds,
                        ...existingResponsibleUsers.filter((user)=>partiallySelectedResponsibleUsersIds.includes(user.id)).map((user)=>user.id)
                    ];
                    mutations.push(setResponsibleUserMutation.mutateAsync({
                        customer_ids: [
                            customer.id
                        ],
                        user_ids: combinedResponsibleUserIds
                    }));
                } else // the customer does not have a responsible user that's in partiallySelectedResponsibleUserIds
                // which means it could be set all the selected responsible users (without adding any previous responsible users)
                customersWithoutPartialResponsibleUsersIds.push(customer.id);
            });
            // if there are customers without partial selected responsible users,
            // add another mutation to set the selected responsible users for all of them
            if (customersWithoutPartialResponsibleUsersIds.length > 0) mutations.push(setResponsibleUserMutation.mutateAsync({
                customer_ids: customersWithoutPartialResponsibleUsersIds,
                user_ids: responsibleUsersIds
            }));
            await Promise.all(mutations);
        }
    };
    const hasError = loadingUsersError || setResponsibleUserMutation.isError;
    const error = loadingUsersError || setResponsibleUserMutation.error;
    const areAllChecked = responsibleUsersIds.length === activeUsers.length;
    const isValid = !isLoadingUsers && responsibleUsersIds.length > 0;
    const isUpdating = setResponsibleUserMutation.isLoading;
    const handleSelectAll = ()=>{
        if (areAllChecked) {
            setResponsibleUsersIds([]);
            setPartiallySelectedResponsibleUsersIds([]);
        } else setResponsibleUsersIds(activeUsers.map((user)=>user.id));
    };
    const isUserChecked = (user)=>partiallySelectedResponsibleUsersIds.includes(user.id) ? "indeterminate" : responsibleUsersIds.includes(user.id);
    const handleUserSelection = (user)=>{
        // always remove the responsible user id from the partially selected list if any changes are made to its selection
        setPartiallySelectedResponsibleUsersIds((prevState)=>prevState.filter((id)=>id !== user.id));
        // if the user is active allow to toggle it on and off. if the user is not active only allow to toggle it off
        setResponsibleUsersIds((prevState)=>user.is_active ? (0, _collectionUtils.toggleElement)(prevState, user.id) : prevState.filter((userId)=>userId !== user.id));
    };
    return {
        isLoadingUsers,
        hasError,
        error,
        users,
        isValid,
        isUpdating,
        areAllChecked,
        handleSelectAll,
        isUserChecked,
        handleUserSelection,
        setResponsibleUsers
    };
};
exports.default = useSetResponsibleUser;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../../../api":"f6lXD","../../../constants/queries-keys":"6hYSF","../../../hooks/useGetUsers":"c83Pg","../../../utils/collectionUtils":"gr5mc","../../../utils/selectionUtils":"eUSyD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eUSyD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// K - an Element that contains a list of items of type T
// example: K = Customer, T = User
// getItemsForElement is responsible to return the array of items (T[]) for a given element of type K
// example: getItemsForElement = (customer: Customer) => customer.responsibleUsers
parcelHelpers.export(exports, "getIndeterminateSelection", ()=>getIndeterminateSelection);
function getIndeterminateSelection(elements, getItemsForElement) {
    // count the number of elements that contains the current item
    const elementsCountByItem = elements.reduce((elementsCounts, element)=>{
        getItemsForElement(element)?.forEach((item)=>{
            elementsCounts[item.id] = elementsCounts[item.id] ? {
                ...elementsCounts[item.id],
                count: elementsCounts[item.id].count + 1
            } : {
                count: 1,
                item
            };
        });
        return elementsCounts;
    }, {});
    const selectedItems = [];
    const partiallySelectedItems = [];
    Object.values(elementsCountByItem).forEach((itemElementsCount)=>{
        // if the number of elements for the item is equal to the total number of elements
        // then the item is selected by all elements
        if (itemElementsCount.count === elements.length) selectedItems.push(itemElementsCount.item);
        else // otherwise, the item is selected by some (but not all) elements
        partiallySelectedItems.push(itemElementsCount.item);
    });
    return {
        selectedItems,
        partiallySelectedItems
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jxk2c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const ArchiveCustomers = (props)=>{
    const { customers, onClose, onSuccess } = props;
    const queryClient = (0, _reactQuery.useQueryClient)();
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const customerIds = customers.map((customer)=>customer.id);
    const customersNamesLabel = formatMultipleNames(customers.map((0, _displayHelpers.getCustomerName)));
    const archiveCustomersApiCall = ()=>(0, _apiDefault.default).archiveCustomers({
            customer_ids: customerIds
        });
    const handleSuccess = async ()=>{
        await queryClient.invalidateQueries([
            (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST
        ]);
        onSuccess();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        apiCall: archiveCustomersApiCall,
        onSuccess: handleSuccess,
        isOpen: true,
        isDestructive: true,
        title: f("bulk.actions.archive.confirmation.title"),
        description: f("bulk.actions.archive.confirmation.description", {
            names: customersNamesLabel
        }),
        onNo: onClose,
        actionTitle: f("default.archive"),
        useSuccessToast: true,
        successTitle: f("bulk.actions.archive.success.message", {
            count: customers.length
        })
    });
};
exports.default = ArchiveCustomers;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"73SD2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../helpers/display.helpers");
var _useBatchUpdateScreeningConfiguration = require("../../hooks/useBatchUpdateScreeningConfiguration");
var _useBatchUpdateScreeningConfigurationDefault = parcelHelpers.interopDefault(_useBatchUpdateScreeningConfiguration);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _screeningTypeCard = require("../ScreeningTypeCard/ScreeningTypeCard");
var _screeningTypeCardDefault = parcelHelpers.interopDefault(_screeningTypeCard);
const ChangeScreeningTypeModal = (props)=>{
    const { customers, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const [showSuccessMessageToast, toggleSuccessMessageToast, closeSuccessMessageToast] = (0, _useOpenCloseDefault.default)();
    const [screeningType, setScreeningType] = (0, _react.useState)("MONITORING");
    const saveScreeningTypeMutation = (0, _useBatchUpdateScreeningConfigurationDefault.default)(customers);
    const saveAction = {
        content: f("default.save"),
        onAction: ()=>saveScreeningTypeMutation.mutate(screeningType, {
                onSuccess: toggleSuccessMessageToast
            }),
        loading: saveScreeningTypeMutation.isLoading
    };
    const cancelAction = {
        content: f("default.cancel"),
        onAction: ()=>onClose(),
        disabled: saveScreeningTypeMutation.isLoading
    };
    const customersNamesLabel = formatMultipleNames(customers.map((0, _displayHelpers.getCustomerName)));
    const handleToastDismiss = ()=>{
        closeSuccessMessageToast();
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
                open: !showSuccessMessageToast,
                title: f("screening-type.modal.title"),
                onClose: onClose,
                primaryAction: saveAction,
                secondaryActions: [
                    cancelAction
                ],
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "bodyMd",
                                    as: "span",
                                    children: f("screening-type.modal.message", {
                                        names: customersNamesLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningTypeCardDefault.default), {
                                    screeningType: screeningType,
                                    readonly: saveScreeningTypeMutation.isLoading,
                                    onScreeningTypeChange: (newValue)=>setScreeningType(newValue)
                                })
                            ]
                        })
                    }),
                    saveScreeningTypeMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: saveScreeningTypeMutation.error
                    })
                ]
            }),
            showSuccessMessageToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                onDismiss: handleToastDismiss,
                content: f("bulk.actions.screening-type.success.message")
            })
        ]
    });
};
exports.default = ChangeScreeningTypeModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/display.helpers":"2q3xY","../../hooks/useBatchUpdateScreeningConfiguration":"jSR4S","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../../hooks/useOpenClose":"idooG","../ErrorPanel/ErrorPanel":"2hHqH","../ScreeningTypeCard/ScreeningTypeCard":"2sGBG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jSR4S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _filters = require("../constants/filters");
var _queriesKeys = require("../constants/queries-keys");
var _promiseUtils = require("../utils/promiseUtils");
var _useCustomersListParams = require("./useCustomersListParams");
var _useCustomersListParamsDefault = parcelHelpers.interopDefault(_useCustomersListParams);
async function updateCompanySignatureConfiguration(customerId, screeningType) {
    const companyScreeningConfiguration = await (0, _apiDefault.default).getCompanyScreeningConfiguration(customerId);
    return (0, _apiDefault.default).updateCompanyScreeningConfiguration(customerId, {
        roles: companyScreeningConfiguration.roles.map((role)=>role.role.id).filter(Boolean),
        owners: companyScreeningConfiguration.beneficial_owners.map((owner)=>owner.owner.id).filter(Boolean),
        screening_type: screeningType
    });
}
async function startCustomerMonitoring(customer) {
    return customer.type === "person" ? (0, _apiDefault.default).updatePersonScreeningConfiguration(customer.id, {
        screening_type: "MONITORING"
    }) : updateCompanySignatureConfiguration(customer.id, "MONITORING");
}
async function stopCustomerMonitoring(customer) {
    return customer.type === "person" ? await (0, _apiDefault.default).stopPersonScreening(customer.id) : await (0, _apiDefault.default).stopCompanyScreening(customer.id);
}
const useBatchUpdateScreeningConfiguration = (customers)=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { screeningType } = (0, _useCustomersListParamsDefault.default)();
    return (0, _reactQuery.useMutation)((screeningType)=>Promise.all(customers.map((customer, i)=>(0, _promiseUtils.resolveAfter)(()=>screeningType === "MONITORING" ? startCustomerMonitoring(customer) : stopCustomerMonitoring(customer), i * 500 // delay execution of each api call with 500 milliseconds
            ))), {
        // invalidate the customers list results
        onSuccess: async ()=>{
            // if the customers filters contains a screening type filter then invalidate the customers list results cache
            if (screeningType === (0, _filters.SCREENING_TYPE_FILTERS).ONE_TIME || screeningType === (0, _filters.SCREENING_TYPE_FILTERS).MONITORING) await queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST
            ]);
        }
    });
};
exports.default = useBatchUpdateScreeningConfiguration;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/filters":"94mf3","../constants/queries-keys":"6hYSF","../utils/promiseUtils":"gGn8B","./useCustomersListParams":"euKlt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"94mf3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MARKED_AS_FILTERS", ()=>MARKED_AS_FILTERS);
parcelHelpers.export(exports, "SCREENING_TYPE_FILTERS", ()=>SCREENING_TYPE_FILTERS);
parcelHelpers.export(exports, "MIN_DATE_FILTER", ()=>MIN_DATE_FILTER);
parcelHelpers.export(exports, "MAX_DATE_FILTER", ()=>MAX_DATE_FILTER);
var MARKED_AS_FILTERS;
(function(MARKED_AS_FILTERS) {
    MARKED_AS_FILTERS["PEP"] = "PEP";
    MARKED_AS_FILTERS["SANCTIONED"] = "SANCTIONED";
})(MARKED_AS_FILTERS || (MARKED_AS_FILTERS = {}));
var SCREENING_TYPE_FILTERS;
(function(SCREENING_TYPE_FILTERS) {
    SCREENING_TYPE_FILTERS["MONITORING"] = "MONITORING";
    SCREENING_TYPE_FILTERS["ONE_TIME"] = "ONE_TIME";
})(SCREENING_TYPE_FILTERS || (SCREENING_TYPE_FILTERS = {}));
const MIN_DATE_FILTER = new Date("2020-01-01");
const MAX_DATE_FILTER = new Date("2050-01-01");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gGn8B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAfter", ()=>resolveAfter);
function resolveAfter(promise, delay) {
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(promise()), delay);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"euKlt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _customersListSearchParams = require("../constants/customers-list-search-params");
var _filters = require("../constants/filters");
var _pagination = require("../constants/pagination");
var _dateUtils = require("../utils/dateUtils");
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
var _useListParams = require("./useListParams");
var _useListParamsDefault = parcelHelpers.interopDefault(_useListParams);
var _useURLSearchParam = require("./useURLSearchParam");
const useCustomersListParams = ()=>{
    const { order, setOrder, page, setPage, limit, setLimit, q, setQ, createdRange, setCreatedRange, createdAfter, setCreatedAfter, createdBefore, setCreatedBefore, searchParams: baseSearchParams, isEmptySearch: baseIsEmptySearch, resetAllFilters: baseResetAllFilters } = (0, _useListParamsDefault.default)();
    const [status, setStatus] = (0, _useURLSearchParam.useURLSearchParam)((0, _customersListSearchParams.STATUS_NAME_PARAMETER));
    const [customerType, setCustomerType] = (0, _useURLSearchParam.useURLSearchParam)((0, _customersListSearchParams.CUSTOMER_TYPE_NAME_PARAMETER));
    const [risk, setRisk] = (0, _useURLSearchParam.useURLSearchParam)((0, _customersListSearchParams.RISK_NAME_PARAMETER));
    const [responsibleUserIds, setResponsibleUserIds] = (0, _useURLSearchParam.useURLSearchParams)((0, _customersListSearchParams.RESPONSIBLE_USERS_NAME_PARAMETER));
    const [isArchived, setIsArchived] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.ARCHIVED_NAME_PARAMETER));
    const [unresolved, setUnresolved] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.UNRESOLVED_NAME_PARAMETER));
    const [isPep, setIsPep] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.MARKED_AS_PEP_NAME_PARAMETER));
    const [isSanctioned, setIsSanctioned] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.MARKED_AS_SANCTIONED_NAME_PARAMETER));
    const [screeningType, setScreeningType] = (0, _useURLSearchParam.useURLSearchParam)((0, _customersListSearchParams.SCREENING_TYPE_NAME_PARAMETER));
    const [countryCode, setCountryCode] = (0, _useURLSearchParam.useURLSearchParam)((0, _customersListSearchParams.COUNTRY_CODE_NAME_PARAMETER));
    const [industryCodes, setIndustryCodes] = (0, _useURLSearchParam.useURLSearchParams)((0, _customersListSearchParams.CUSTOMER_INDUSTRY_CODES_NAME_PARAMETER));
    const [pendingTasks, setPendingTasks] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.PENDING_TASKS_TAB_NAME_PARAMETER));
    const [tagIds, setTagIds] = (0, _useURLSearchParam.useURLSearchParams)((0, _customersListSearchParams.TAGS_NAME_PARAMETER));
    const [haveOwnershipUpdates, setHaveOwnershipUpdates] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.OWNERSHIP_UPDATES_NAME_PARAMETER));
    const [followupRange, setFollowupRange] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.FOLLOWUP_RANGE_NAME_PARAMETER));
    const [followupAfter, setFollowupAfter] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.FOLLOWUP_AFTER_NAME_PARAMETER));
    const [followupBefore, setFollowupBefore] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.FOLLOWUP_BEFORE_NAME_PARAMETER));
    const [isFollowupExpired, setIsFollowupExpired] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.FOLLOW_UP_EXPIRED_NAME_PARAMETER));
    const [isPendingMeasures, setIsPendingMeasures] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.PENDING_MEASURES_NAME_PARAMETER));
    // runs the setter methods and resets the page to 0
    // this is done so only when the user changes a filter the page will be reset to 0
    // if we were to use "useEffect" it will cause the page to reset when restoring the location.search
    function resetPageWrapper(setter) {
        return (props)=>{
            setter(props);
            setPage(0);
        };
    }
    const markedAsFilters = [];
    if (isPep) markedAsFilters.push((0, _filters.MARKED_AS_FILTERS).PEP);
    if (isSanctioned) markedAsFilters.push((0, _filters.MARKED_AS_FILTERS).SANCTIONED);
    const handleMarkedAsFiltersChange = (filters)=>{
        // Check the filtered items to toggle them
        setIsPep(filters.includes((0, _filters.MARKED_AS_FILTERS).PEP));
        setIsSanctioned(filters.includes((0, _filters.MARKED_AS_FILTERS).SANCTIONED));
    };
    const handleSetFollowupRange = (range)=>{
        if (range !== (0, _pagination.DateRange).CUSTOM) {
            setFollowupAfter(undefined);
            setFollowupBefore(undefined);
        }
        setFollowupRange(range);
    };
    const followupBeforeValue = (0, _dateUtils.getRangeDate)(followupRange, followupBefore, false);
    const validFollowUpAfter = (0, _dateUtils.isValidDate)(followupAfter, (0, _filters.MIN_DATE_FILTER), (0, _filters.MAX_DATE_FILTER)) ? followupAfter : undefined;
    const validFollowUpBefore = (0, _dateUtils.isValidDate)(followupBeforeValue, (0, _filters.MIN_DATE_FILTER), (0, _filters.MAX_DATE_FILTER)) ? followupBeforeValue : undefined;
    const searchParams = (0, _util.removeEmptyValues)({
        ...baseSearchParams,
        status,
        hasPendingTasks: pendingTasks ? "1" : undefined,
        $type: customerType,
        riskLevel: risk,
        isArchived: isArchived ? "1" : undefined,
        hasUnresolvedCases: unresolved ? "1" : undefined,
        isPep: isPep ? "1" : undefined,
        isSanctioned: isSanctioned ? "1" : undefined,
        screeningType: screeningType,
        countryCode: countryCode,
        industryCodes: industryCodes.length === 0 ? undefined : industryCodes.join(","),
        labels: tagIds.length === 0 ? undefined : tagIds.join(","),
        responsibleUsers: responsibleUserIds.length === 0 ? undefined : responsibleUserIds.join(","),
        unhandledOwnershipUpdates: haveOwnershipUpdates ? "1" : undefined,
        followUpAfter: validFollowUpAfter,
        followUpBefore: validFollowUpBefore,
        isFollowUpExpired: isFollowupExpired ? "1" : undefined,
        hasPendingMeasures: isPendingMeasures ? "1" : undefined
    });
    const isEmptySearch = baseIsEmptySearch && (0, _stringUtils.isEmptyString)(risk) && (0, _stringUtils.isEmptyString)(customerType) && (0, _stringUtils.isEmptyString)(status) && responsibleUserIds.length === 0 && (0, _stringUtils.isEmptyString)(screeningType) && (0, _stringUtils.isEmptyString)(countryCode) && industryCodes.length === 0 && !unresolved && !isPep && !isSanctioned && !isArchived && tagIds.length === 0 && !haveOwnershipUpdates && (0, _stringUtils.isEmptyString)(followupRange) && (0, _stringUtils.isEmptyString)(validFollowUpAfter) && (0, _stringUtils.isEmptyString)(validFollowUpBefore) && !isFollowupExpired && !isPendingMeasures;
    const resetAllFilters = ()=>{
        baseResetAllFilters();
        setStatus(undefined);
        setCustomerType(undefined);
        setRisk(undefined);
        setResponsibleUserIds([]);
        setIsArchived(undefined);
        setIsPep(undefined);
        setUnresolved(undefined);
        setIsSanctioned(undefined);
        setScreeningType("");
        setCountryCode(undefined);
        setIndustryCodes([]);
        setTagIds([]);
        setHaveOwnershipUpdates(undefined);
        setFollowupRange(undefined);
        setFollowupAfter(undefined);
        setFollowupBefore(undefined);
        setIsFollowupExpired(undefined);
        setIsPendingMeasures(undefined);
    };
    return {
        order,
        setOrder,
        page,
        setPage,
        limit,
        setLimit,
        q,
        setQ,
        status,
        setStatus: resetPageWrapper(setStatus),
        customerType,
        setCustomerType: resetPageWrapper(setCustomerType),
        risk,
        setRisk: resetPageWrapper(setRisk),
        screeningType,
        setScreeningType: resetPageWrapper(setScreeningType),
        isArchived,
        setIsArchived: resetPageWrapper(setIsArchived),
        unresolved,
        setUnresolved: resetPageWrapper(setUnresolved),
        isPep,
        setIsPep: resetPageWrapper(setIsPep),
        isSanctioned,
        setIsSanctioned: resetPageWrapper(setIsSanctioned),
        responsibleUserIds,
        setResponsibleUserIds: resetPageWrapper(setResponsibleUserIds),
        countryCode,
        setCountryCode: resetPageWrapper(setCountryCode),
        industryCodes,
        setIndustryCodes: resetPageWrapper(setIndustryCodes),
        tagIds,
        setTagIds: resetPageWrapper(setTagIds),
        haveOwnershipUpdates,
        setHaveOwnershipUpdates: resetPageWrapper(setHaveOwnershipUpdates),
        createdRange,
        setCreatedRange: resetPageWrapper(setCreatedRange),
        createdAfter,
        setCreatedAfter: resetPageWrapper(setCreatedAfter),
        createdBefore,
        setCreatedBefore: resetPageWrapper(setCreatedBefore),
        followupRange,
        setFollowupRange: resetPageWrapper(handleSetFollowupRange),
        followupAfter,
        setFollowupAfter: resetPageWrapper(setFollowupAfter),
        followupBefore,
        setFollowupBefore: resetPageWrapper(setFollowupBefore),
        isFollowupExpired,
        setIsFollowupExpired: resetPageWrapper(setIsFollowupExpired),
        isPendingMeasures,
        setIsPendingMeasures: resetPageWrapper(setIsPendingMeasures),
        searchParams,
        markedAsFilters,
        handleMarkedAsFiltersChange,
        pendingTasks,
        setPendingTasks: resetPageWrapper(setPendingTasks),
        isEmptySearch,
        resetAllFilters
    };
};
exports.default = useCustomersListParams;

},{"../constants/customers-list-search-params":"9nE5m","../constants/filters":"94mf3","../constants/pagination":"e05H0","../utils/dateUtils":"euvUV","../utils/stringUtils":"4gVdA","../utils/util":"4MniK","./useListParams":"2rzFa","./useURLSearchParam":"5Oncb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9nE5m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PENDING_TASKS_TAB_NAME_PARAMETER", ()=>PENDING_TASKS_TAB_NAME_PARAMETER);
parcelHelpers.export(exports, "RISK_NAME_PARAMETER", ()=>RISK_NAME_PARAMETER);
parcelHelpers.export(exports, "STATUS_NAME_PARAMETER", ()=>STATUS_NAME_PARAMETER);
parcelHelpers.export(exports, "MARKED_AS_PEP_NAME_PARAMETER", ()=>MARKED_AS_PEP_NAME_PARAMETER);
parcelHelpers.export(exports, "MARKED_AS_SANCTIONED_NAME_PARAMETER", ()=>MARKED_AS_SANCTIONED_NAME_PARAMETER);
parcelHelpers.export(exports, "SCREENING_TYPE_NAME_PARAMETER", ()=>SCREENING_TYPE_NAME_PARAMETER);
parcelHelpers.export(exports, "CUSTOMER_TYPE_NAME_PARAMETER", ()=>CUSTOMER_TYPE_NAME_PARAMETER);
parcelHelpers.export(exports, "INCLUDE_ARCHIVED_CUSTOMERS_NAME_PARAMETER", ()=>INCLUDE_ARCHIVED_CUSTOMERS_NAME_PARAMETER);
parcelHelpers.export(exports, "CUSTOMER_INDUSTRY_CODES_NAME_PARAMETER", ()=>CUSTOMER_INDUSTRY_CODES_NAME_PARAMETER);
parcelHelpers.export(exports, "COUNTRY_CODE_NAME_PARAMETER", ()=>COUNTRY_CODE_NAME_PARAMETER);
parcelHelpers.export(exports, "TAGS_NAME_PARAMETER", ()=>TAGS_NAME_PARAMETER);
parcelHelpers.export(exports, "PENDING_MEASURES_NAME_PARAMETER", ()=>PENDING_MEASURES_NAME_PARAMETER);
parcelHelpers.export(exports, "ARCHIVED_NAME_PARAMETER", ()=>ARCHIVED_NAME_PARAMETER);
parcelHelpers.export(exports, "UNRESOLVED_NAME_PARAMETER", ()=>UNRESOLVED_NAME_PARAMETER);
parcelHelpers.export(exports, "FOLLOW_UP_EXPIRED_NAME_PARAMETER", ()=>FOLLOW_UP_EXPIRED_NAME_PARAMETER);
parcelHelpers.export(exports, "OWNERSHIP_UPDATES_NAME_PARAMETER", ()=>OWNERSHIP_UPDATES_NAME_PARAMETER);
parcelHelpers.export(exports, "RESPONSIBLE_USERS_NAME_PARAMETER", ()=>RESPONSIBLE_USERS_NAME_PARAMETER);
parcelHelpers.export(exports, "CUSTOMER_FILTER_TYPE_PARAMS", ()=>CUSTOMER_FILTER_TYPE_PARAMS);
parcelHelpers.export(exports, "CUSTOMER_FILTER_STATUS_PARAMS", ()=>CUSTOMER_FILTER_STATUS_PARAMS);
const PENDING_TASKS_TAB_NAME_PARAMETER = "pendingTasks";
const RISK_NAME_PARAMETER = "risk";
const STATUS_NAME_PARAMETER = "status";
const MARKED_AS_PEP_NAME_PARAMETER = "isPep";
const MARKED_AS_SANCTIONED_NAME_PARAMETER = "isSanctioned";
const SCREENING_TYPE_NAME_PARAMETER = "screeningType";
const CUSTOMER_TYPE_NAME_PARAMETER = "customerType";
const INCLUDE_ARCHIVED_CUSTOMERS_NAME_PARAMETER = "includeArchivedCustomers";
const CUSTOMER_INDUSTRY_CODES_NAME_PARAMETER = "industryType";
const COUNTRY_CODE_NAME_PARAMETER = "countryCode";
const TAGS_NAME_PARAMETER = "labels";
const PENDING_MEASURES_NAME_PARAMETER = "pendingMeasures";
const ARCHIVED_NAME_PARAMETER = "isArchived";
const UNRESOLVED_NAME_PARAMETER = "unresolved";
const FOLLOW_UP_EXPIRED_NAME_PARAMETER = "followupExpired";
const OWNERSHIP_UPDATES_NAME_PARAMETER = "ownershipUpdates";
const RESPONSIBLE_USERS_NAME_PARAMETER = "responsibleUsers";
var CUSTOMER_FILTER_TYPE_PARAMS;
(function(CUSTOMER_FILTER_TYPE_PARAMS) {
    CUSTOMER_FILTER_TYPE_PARAMS["PERSON"] = "persons";
    CUSTOMER_FILTER_TYPE_PARAMS["COMPANY"] = "companies";
})(CUSTOMER_FILTER_TYPE_PARAMS || (CUSTOMER_FILTER_TYPE_PARAMS = {}));
var CUSTOMER_FILTER_STATUS_PARAMS;
(function(CUSTOMER_FILTER_STATUS_PARAMS) {
    CUSTOMER_FILTER_STATUS_PARAMS["STARTED"] = "STARTED";
    CUSTOMER_FILTER_STATUS_PARAMS["REVIEW_REQUIRED"] = "REVIEW_REQUIRED";
    CUSTOMER_FILTER_STATUS_PARAMS["DRAFT_REVIEW"] = "DRAFT_REVIEW";
    CUSTOMER_FILTER_STATUS_PARAMS["REVIEW_APPROVAL_REQUIRED"] = "REVIEW_APPROVAL_REQUIRED";
    CUSTOMER_FILTER_STATUS_PARAMS["NOT_READY"] = "NOT_READY";
    CUSTOMER_FILTER_STATUS_PARAMS["APPROVED"] = "APPROVED";
    CUSTOMER_FILTER_STATUS_PARAMS["REJECTED"] = "REJECTED";
})(CUSTOMER_FILTER_STATUS_PARAMS || (CUSTOMER_FILTER_STATUS_PARAMS = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2rzFa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _filters = require("../constants/filters");
var _pagination = require("../constants/pagination");
var _dateUtils = require("../utils/dateUtils");
var _stringUtils = require("../utils/stringUtils");
var _useNonInitialEffect = require("./useNonInitialEffect");
var _useNonInitialEffectDefault = parcelHelpers.interopDefault(_useNonInitialEffect);
var _useURLSearchParam = require("./useURLSearchParam");
/**
 * hook to handle basic server side url list params such as pagination, ordering, name filter and created filter
 */ const useListParams = ()=>{
    const [order, setOrder] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.ORDER_NAME_PARAMETER));
    const [page, setPage] = (0, _useURLSearchParam.useNumericURLSearchParam)((0, _pagination.PAGE_NAME_PARAMETER));
    const [limit, setLimit] = (0, _useURLSearchParam.useNumericURLSearchParam)((0, _pagination.LIMIT_NAME_PARAMETER), (0, _pagination.CUSTOMERS_PER_PAGE));
    const [q, setQ] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.QUERY_NAME_PARAMETER));
    const [createdRange, setCreatedRange] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.CREATED_RANGE_NAME_PARAMETER));
    const [createdAfter, setCreatedAfter] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.CREATED_AFTER_NAME_PARAMETER));
    const [createdBefore, setCreatedBefore] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.CREATED_BEFORE_NAME_PARAMETER));
    (0, _useNonInitialEffectDefault.default)(()=>{
        setPage(0);
    }, [
        order,
        limit,
        q,
        createdRange,
        createdAfter,
        createdBefore
    ]);
    const createdAfterValue = (0, _dateUtils.getRangeDate)(createdRange, createdAfter, true);
    const validAfterDate = (0, _dateUtils.isValidDate)(createdAfterValue, (0, _filters.MIN_DATE_FILTER), (0, _filters.MAX_DATE_FILTER)) ? createdAfterValue : undefined;
    const validBeforeDate = (0, _dateUtils.isValidDate)(createdBefore, (0, _filters.MIN_DATE_FILTER), (0, _filters.MAX_DATE_FILTER)) ? createdBefore : undefined;
    const searchParams = {
        ordering: order,
        limit,
        offset: page && limit ? page * limit : undefined,
        q,
        createdAfter: validAfterDate,
        createdBefore: validBeforeDate
    };
    const isEmptySearch = (0, _stringUtils.isEmptyString)(q) && (0, _stringUtils.isEmptyString)(createdRange) && (0, _stringUtils.isEmptyString)(validAfterDate) && (0, _stringUtils.isEmptyString)(validBeforeDate);
    const resetAllFilters = ()=>{
        setQ(undefined);
        setOrder(undefined);
        setPage(undefined);
        setLimit((0, _pagination.CUSTOMERS_PER_PAGE));
        setCreatedRange(undefined);
        setCreatedAfter(undefined);
        setCreatedBefore(undefined);
    };
    const handleSetCreatedRange = (range)=>{
        if (range !== (0, _pagination.DateRange).CUSTOM) {
            setCreatedAfter(undefined);
            setCreatedBefore(undefined);
        }
        setCreatedRange(range);
    };
    return {
        order,
        setOrder,
        page,
        setPage,
        limit,
        setLimit,
        q,
        setQ,
        createdRange,
        setCreatedRange: handleSetCreatedRange,
        createdAfter,
        setCreatedAfter,
        createdBefore,
        setCreatedBefore,
        searchParams,
        isEmptySearch,
        resetAllFilters
    };
};
exports.default = useListParams;

},{"../constants/filters":"94mf3","../constants/pagination":"e05H0","../utils/dateUtils":"euvUV","../utils/stringUtils":"4gVdA","./useNonInitialEffect":"7lww1","./useURLSearchParam":"5Oncb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Oncb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useURLSearchParams", ()=>useURLSearchParams);
parcelHelpers.export(exports, "useURLSearchParam", ()=>useURLSearchParam);
parcelHelpers.export(exports, "useBooleanURLSearchParam", ()=>useBooleanURLSearchParam);
parcelHelpers.export(exports, "useNumericURLSearchParam", ()=>useNumericURLSearchParam);
var _reactRouterDom = require("react-router-dom");
function useBase(searchParameterName, convertToType) {
    const history = (0, _reactRouterDom.useHistory)();
    // get value from url search params (either a string or null is not found)
    const searchParams = new URLSearchParams(history.location.search);
    const searchParamValue = searchParams.get(searchParameterName);
    // initial value is the converted url search param value
    const initialValue = convertToType(searchParamValue);
    const setValue = (value)=>{
        // get the current url search params
        const currentSearchParams = new URLSearchParams(history.location.search);
        // Save to URLSearchParams or remove from url search params if value is the same as the default one
        if (value) currentSearchParams.set(searchParameterName, String(value));
        else currentSearchParams.delete(searchParameterName);
        const search = "?" + currentSearchParams.toString();
        // update the URL if there are changes
        if (history.location.search !== search) history.replace({
            ...history.location,
            search
        });
    };
    return [
        initialValue,
        setValue
    ];
}
const useURLSearchParams = (searchParameterName)=>{
    const history = (0, _reactRouterDom.useHistory)();
    const searchParams = new URLSearchParams(history.location.search);
    const searchParamValues = searchParams.getAll(searchParameterName);
    const setValues = (values)=>{
        const currentSearchParams = new URLSearchParams(history.location.search);
        currentSearchParams.delete(searchParameterName);
        values.forEach((value)=>currentSearchParams.append(searchParameterName, String(value)));
        const search = "?" + currentSearchParams.toString();
        // update the URL if there are changes
        if (history.location.search !== search) history.replace({
            ...history.location,
            search
        });
    };
    return [
        searchParamValues,
        setValues
    ];
};
function useURLSearchParam(searchParameterName) {
    return useBase(searchParameterName, (value)=>value);
}
function useBooleanURLSearchParam(searchParameterName) {
    return useBase(searchParameterName, (value)=>!!value);
}
const convertParameterValueToNumber = (searchParameterName, defaultValue)=>{
    return (value)=>{
        if (!value) return defaultValue;
        try {
            return parseInt(value, 10);
        } catch (error) {
            console.error(`Failed to parse search parameter ${searchParameterName} to a number. ${error}`);
            return defaultValue;
        }
    };
};
function useNumericURLSearchParam(searchParameterName, defaultValue = 0) {
    return useBase(searchParameterName, convertParameterValueToNumber(searchParameterName, defaultValue));
}

},{"react-router-dom":"1ee65","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bFGcF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _entitiesTagPopover = require("../EntitiesTagPopover/EntitiesTagPopover");
var _entitiesTagPopoverDefault = parcelHelpers.interopDefault(_entitiesTagPopover);
const CustomersTagsPopover = (props)=>{
    const { customers, readonly } = props;
    const queryClient = (0, _reactQuery.useQueryClient)();
    const customersIds = customers.map((customer)=>customer.id);
    const updateCustomers = (updatedCustomers)=>{
        const queryCache = queryClient.getQueryCache();
        // find all search queries that begins with QUERIES_KEYS.CUSTOMERS_LIST
        const customersSearchQueries = queryCache.findAll([
            (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST
        ]);
        customersSearchQueries.forEach(({ queryKey })=>{
            const cacheData = queryClient.getQueryData(queryKey);
            if (cacheData) {
                // merge the updatedCustomers with existing query cached customers
                const customers = cacheData.customers.map((customer)=>customersIds.includes(customer.id) ? {
                        ...customer,
                        ...updatedCustomers.find((updatedCustomer)=>updatedCustomer.id === customer.id)
                    } : customer);
                queryClient.setQueryData(queryKey, {
                    ...cacheData,
                    customers
                });
            }
        });
    };
    const onAssignTags = ({ entitiesIds, tagIds })=>{
        return (0, _apiDefault.default).batchSetLabelsOnCustomers({
            target_ids: entitiesIds,
            label_ids: tagIds
        }).then(({ customers })=>customers);
    };
    const onCreatedAndAssignTag = (customersIds, title)=>(0, _apiDefault.default).batchCreateAndAssignLabelOnCustomers({
            target_ids: customersIds,
            title
        }).then(({ customers })=>customers);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entitiesTagPopoverDefault.default), {
        entities: customers,
        readonly: readonly,
        onUpdateEntities: updateCustomers,
        onAssignTags: onAssignTags,
        onCreatedAndAssignTag: onCreatedAndAssignTag
    });
};
exports.default = CustomersTagsPopover;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../EntitiesTagPopover/EntitiesTagPopover":"lx47p","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lx47p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _selectionUtils = require("../../utils/selectionUtils");
var _tagsEditorPopover = require("../TagsEditorPopover/TagsEditorPopover");
var _tagsEditorPopoverDefault = parcelHelpers.interopDefault(_tagsEditorPopover);
function EntitiesTagPopover(props) {
    const { entities, readonly, onAssignTags, onCreatedAndAssignTag, onUpdateEntities } = props;
    const entitiesIds = entities.map((entity)=>entity.id);
    const { selectedItems: selectedTags, partiallySelectedItems: partiallySelectedTags } = (0, _selectionUtils.getIndeterminateSelection)(entities, (entity)=>entity.labels);
    const f = (0, _useFormatMessageDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { allTags } = (0, _useTagsDefault.default)();
    const [showSuccessMessageToast, toggleSuccessMessageToast, closeSuccessMessageToast] = (0, _useOpenCloseDefault.default)();
    const assignTagMutation = (0, _reactQuery.useMutation)(onAssignTags, {
        onSuccess: (updatedEntities)=>{
            toggleSuccessMessageToast();
            onUpdateEntities(updatedEntities);
        }
    });
    const createAndAssignTagMutation = (0, _reactQuery.useMutation)((text)=>onCreatedAndAssignTag(entitiesIds, text), {
        onSuccess: async (updatedEntities)=>{
            await queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS
            ]);
            onUpdateEntities(updatedEntities);
        }
    });
    const handleSelectionChange = async (selectedTags)=>{
        const selectedTagIds = selectedTags.map((tag)=>tag.id);
        // remove selected tags from the partiallySelectedTags because a selected tag means it's not partial anymore
        const partiallySelectedTagIds = partiallySelectedTags.filter((tag)=>!selectedTagIds.includes(tag.id)).map((tag)=>tag.id);
        // if there are no partially selected tags, set all the selected tags to all the entities in a single mutation
        if (partiallySelectedTagIds.length === 0) assignTagMutation.mutate({
            entitiesIds,
            tagIds: selectedTagIds
        });
        else {
            // there is at least one entity with tags that were partially selected (which means they will not
            // be included in the selectedTags)
            // in order to avoid removing these tags from the entities,
            // set entities with tags that are partially selected in a different mutation that also includes their tags
            const mutations = [];
            const entitiesWithoutPartialtagIds = [];
            entities.forEach((entity)=>{
                // if the entity has a tag that's in partiallySelected tagIds it means this tag should be included
                // when setting tags for that entity
                if (entity.labels?.find((tag)=>partiallySelectedTagIds.includes(tag.id))) {
                    const tags = entity.labels || [];
                    // tags for entity with partially selected tag(s)
                    // includes: all selected tags, partially selected tags that were already assigned to the entity
                    const tagIds = [
                        ...selectedTagIds,
                        ...tags.filter((tag)=>partiallySelectedTagIds.includes(tag.id)).map((tag)=>tag.id)
                    ];
                    mutations.push(assignTagMutation.mutateAsync({
                        entitiesIds: [
                            entity.id
                        ],
                        tagIds: tagIds
                    }));
                } else // the entity does not have a tag that's in partiallySelectedTagIds
                // which means it could be set all the selected tags (without adding any previous tags)
                entitiesWithoutPartialtagIds.push(entity.id);
            });
            // if there are entities without partial selected tags, add another mutation to set the selected tags
            // for all of them
            if (entitiesWithoutPartialtagIds.length > 0) mutations.push(assignTagMutation.mutateAsync({
                entitiesIds: entitiesWithoutPartialtagIds,
                tagIds: selectedTagIds
            }));
            await Promise.all(mutations);
        }
    };
    const createTagAndAssign = async (text)=>await createAndAssignTagMutation.mutateAsync(text);
    const isLoading = assignTagMutation.isLoading || createAndAssignTagMutation.isLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsEditorPopoverDefault.default), {
                tags: allTags,
                selectedTags: selectedTags,
                partiallySelectedTags: partiallySelectedTags,
                onSelectionChange: (selectedTags)=>handleSelectionChange(selectedTags),
                onNewTag: createTagAndAssign,
                size: "slim",
                disabled: readonly || isLoading
            }),
            showSuccessMessageToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                onDismiss: closeSuccessMessageToast,
                content: f("tags.popover.success.message")
            })
        ]
    });
}
exports.default = EntitiesTagPopover;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useTags":"31uzS","../../utils/selectionUtils":"eUSyD","../TagsEditorPopover/TagsEditorPopover":"auX01","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gVKiS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const DeleteCustomers = (props)=>{
    const { customers, onClose, onSuccess } = props;
    const [confirmDelete, setConfirmDelete] = (0, _react.useState)(false);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const customerIds = customers.map((customer)=>customer.id);
    const customersNamesLabel = formatMultipleNames(customers.map((0, _displayHelpers.getCustomerName)), 2);
    const handleSuccess = async ()=>{
        await queryClient.invalidateQueries([
            (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST
        ]);
        onSuccess();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        apiCall: ()=>(0, _apiDefault.default).deleteCustomers({
                customer_ids: customerIds
            }),
        onSuccess: handleSuccess,
        isActionDisabled: !confirmDelete,
        title: f("bulk.actions.delete.confirmation.title"),
        description: f("bulk.actions.delete.confirmation.description", {
            names: customersNamesLabel
        }),
        onNo: onClose,
        actionTitle: f("default.delete"),
        useSuccessToast: true,
        successTitle: f("bulk.actions.delete.success.message", {
            count: customers.length
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                label: f("bulk.actions.delete.confirmation.check"),
                checked: confirmDelete,
                onChange: setConfirmDelete
            })
        })
    });
};
exports.default = DeleteCustomers;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6oEiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _followup = require("../../constants/followup");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _stringUtils = require("../../utils/stringUtils");
var _dateInput = require("../DateInput/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const FollowupDateModal = (props)=>{
    const { customers, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const [showSuccessMessageToast, toggleSuccessMessageToast, closeSuccessMessageToast] = (0, _useOpenCloseDefault.default)();
    const [followupDate, setFollowupDate] = (0, _react.useState)();
    const customersIds = customers.map((customer)=>customer.id);
    const saveFollowupDateMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).batchSetFollowUpDateOnCustomers({
            customer_ids: customersIds,
            follow_up_date: followupDate
        }), {
        onSuccess: ()=>toggleSuccessMessageToast()
    });
    const saveAction = {
        content: f("default.save"),
        onAction: ()=>saveFollowupDateMutation.mutate(),
        loading: saveFollowupDateMutation.isLoading,
        disabled: (0, _stringUtils.isEmptyString)(followupDate)
    };
    const cancelAction = {
        content: f("default.cancel"),
        onAction: ()=>onClose(),
        disabled: saveFollowupDateMutation.isLoading
    };
    const customersNamesLabel = formatMultipleNames(customers.map((0, _displayHelpers.getCustomerName)));
    const handleToastDismiss = ()=>{
        closeSuccessMessageToast();
        onClose();
    };
    const minDate = new Date();
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + (0, _followup.MAX_FOLLOWUP_INTERVAL_IN_MONTHS) / 12);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
                open: !showSuccessMessageToast,
                title: f("followup.modal.title"),
                onClose: onClose,
                primaryAction: saveAction,
                secondaryActions: [
                    cancelAction
                ],
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "bodyMd",
                                    as: "span",
                                    children: f("followup.modal.message", {
                                        names: customersNamesLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                                    label: f("followup.modal.labels.date"),
                                    value: followupDate,
                                    onChange: (newValue, isValid)=>setFollowupDate(isValid ? newValue : undefined),
                                    minDate: minDate,
                                    maxDate: maxDate,
                                    disabled: saveFollowupDateMutation.isLoading,
                                    requiredIndicator: true,
                                    autoComplete: "off"
                                })
                            ]
                        })
                    }),
                    saveFollowupDateMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: saveFollowupDateMutation.error
                    })
                ]
            }),
            showSuccessMessageToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                onDismiss: handleToastDismiss,
                content: f("bulk.actions.followup.success.message")
            })
        ]
    });
};
exports.default = FollowupDateModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/followup":"kBYmS","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../../hooks/useOpenClose":"idooG","../../utils/stringUtils":"4gVdA","../DateInput/DateInput":"6BAM5","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lOpET":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const RestoreCustomers = (props)=>{
    const { customers, onClose, onSuccess } = props;
    const queryClient = (0, _reactQuery.useQueryClient)();
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const customerIds = customers.map((customer)=>customer.id);
    const customersNamesLabel = formatMultipleNames(customers.map((0, _displayHelpers.getCustomerName)));
    const restoreCustomersApiCall = ()=>(0, _apiDefault.default).restoreCustomers({
            customer_ids: customerIds
        });
    const handleSuccess = async ()=>{
        await queryClient.invalidateQueries([
            (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST
        ]);
        onSuccess();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        apiCall: restoreCustomersApiCall,
        onSuccess: handleSuccess,
        isOpen: true,
        isDestructive: true,
        title: f("bulk.actions.restore.confirmation.title"),
        description: f("bulk.actions.restore.confirmation.description", {
            names: customersNamesLabel
        }),
        onNo: onClose,
        actionTitle: f("default.restore"),
        useSuccessToast: true,
        successTitle: f("bulk.actions.restore.success.message", {
            count: customers.length
        })
    });
};
exports.default = RestoreCustomers;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5yume":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _noMatchSvg = require("../../../assets/images/no-match.svg");
var _noMatchSvgDefault = parcelHelpers.interopDefault(_noMatchSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CustomersListEmptyState = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        inlineAlign: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Image), {
                height: 75,
                alt: "No results found",
                source: (0, _noMatchSvgDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "h2",
                variant: "headingLg",
                children: f("customers.list.empty.title")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "p",
                alignment: "center",
                children: f("customers.list.empty.content")
            })
        ]
    });
};
exports.default = CustomersListEmptyState;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/images/no-match.svg":"ck896","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ck896":[function(require,module,exports) {
module.exports = require("76b5369945e257c5").getBundleURL("kEMsi") + "no-match.7f802bb1.svg";

},{"76b5369945e257c5":"75UoR"}],"9JJkq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _durations = require("../../constants/durations");
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useDebounce = require("../../hooks/useDebounce");
var _useDebounceDefault = parcelHelpers.interopDefault(_useDebounce);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _appliedFilters = require("../AppliedFilters/AppliedFilters");
var _appliedFiltersDefault = parcelHelpers.interopDefault(_appliedFilters);
var _savedFilters = require("./SavedFilters/SavedFilters");
var _savedFiltersDefault = parcelHelpers.interopDefault(_savedFilters);
var _useCustomersListFilters = require("./useCustomersListFilters");
var _useCustomersListFiltersDefault = parcelHelpers.interopDefault(_useCustomersListFilters);
const CustomersListFilters = (props)=>{
    const { isLoading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { q, setQ, filters, appliedFilters, resetAllFilters } = (0, _useCustomersListFiltersDefault.default)(isLoading);
    const [queryText, setQueryText, queryTextChanged] = (0, _useChangedStateDefault.default)(q ?? "");
    // When navigating back to the customers list page,
    // the previous URL search string is re-loaded from session storage in order to restore the previous applied filters and search query.
    // Since restoring the URL search params happens AFTER initial rendering of this component,
    // the initial value of queryText will be an empty string - which means that if q value changes due to the
    // re-loaded from session storage, Filters component will remain empty - even though the URL search param
    // may contain a query string
    // in order to fix this issue, call setQueryText with q value (when changes) but only if q is not empty and
    // queryText has not queryTextChanged (so it would not try to update it when typing)
    (0, _react.useEffect)(()=>{
        if (!queryTextChanged && !(0, _stringUtils.isEmptyString)(q)) setQueryText(q ?? "");
    }, [
        q,
        queryTextChanged
    ]);
    (0, _useDebounceDefault.default)(()=>setQ(queryText), (0, _durations.QUERY_SEARCH_DEBOUNCE_DELAY), [
        queryText
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                spacing: "tight",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _savedFiltersDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                        fill: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Filters), {
                            queryValue: queryText,
                            queryPlaceholder: f("component.search.customers.hint"),
                            filters: filters,
                            appliedFilters: appliedFilters,
                            hideTags: true,
                            onQueryChange: setQueryText,
                            onQueryClear: ()=>setQueryText(""),
                            onClearAll: ()=>resetAllFilters()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appliedFiltersDefault.default), {
                appliedFilters: appliedFilters
            })
        ]
    });
};
exports.default = CustomersListFilters;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/durations":"5sjIW","../../hooks/useChangedState":"170jW","../../hooks/useDebounce":"i1Evt","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../AppliedFilters/AppliedFilters":"b9vWr","./SavedFilters/SavedFilters":"38S99","./useCustomersListFilters":"eRpWc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b9vWr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _tag = require("../Tag/Tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
const AppliedFilters = (props)=>{
    const { appliedFilters } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
        gap: "2",
        blockAlign: "center",
        children: appliedFilters.map((appliedFilter)=>appliedFilter.isTag ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagDefault.default), {
                color: appliedFilter.tagColor,
                onRemove: ()=>appliedFilter.onRemove(appliedFilter.key),
                children: appliedFilter.label
            }, appliedFilter.key) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Tag), {
                onRemove: ()=>appliedFilter.onRemove(appliedFilter.key),
                children: appliedFilter.label
            }, appliedFilter.key))
    });
};
exports.default = AppliedFilters;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../Tag/Tag":"4KuO7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"38S99":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _polarisIcons = require("@shopify/polaris-icons");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _starSvg = require("../../../../assets/icons/star.svg");
var _starSvgDefault = parcelHelpers.interopDefault(_starSvg);
var _trashSvg = require("../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _customersListSearchParams = require("../../../constants/customers-list-search-params");
var _styles = require("../../../constants/styles");
var _useAuth = require("../../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useCustomersListParams = require("../../../hooks/useCustomersListParams");
var _useCustomersListParamsDefault = parcelHelpers.interopDefault(_useCustomersListParams);
var _useFeatures = require("../../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useSnackbar = require("../../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _popoverButton = require("../../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _tooltipWrapper = require("../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _useCustomersListFilters = require("../useCustomersListFilters");
var _useCustomersListFiltersDefault = parcelHelpers.interopDefault(_useCustomersListFilters);
var _filterDetails = require("./FilterDetails");
var _filterDetailsDefault = parcelHelpers.interopDefault(_filterDetails);
var _useSavedFilters = require("./useSavedFilters");
var _useSavedFiltersDefault = parcelHelpers.interopDefault(_useSavedFilters);
const SavedFilters = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const feature = (0, _useFeaturesDefault.default)();
    const { user } = (0, _useAuthDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const location = (0, _reactRouterDom.useLocation)();
    const { appliedFilters, resetAllFilters } = (0, _useCustomersListFiltersDefault.default)(false);
    const { isEmptySearch } = (0, _useCustomersListParamsDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const { activeFilterName, saveCurrentFilters, savedFilters, deleteSavedFilters, applyFilter } = (0, _useSavedFiltersDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const appliedFiltersLabel = formatMultipleNames(appliedFilters.filter(Boolean).map((filter)=>filter.label));
    const onSaveNewFilter = (filterName, closePopover)=>{
        closePopover();
        saveCurrentFilters(filterName);
    };
    const onFilterDelete = (filterName)=>{
        deleteSavedFilters(filterName);
        setSnackbar(f("component.filters.saved-filters.deleted.message"));
    };
    const actions = [
        {
            content: f("component.filters.saved-filters.without-filters"),
            onAction: ()=>resetAllFilters(),
            active: isEmptySearch,
            suffix: isEmptySearch ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _polarisIcons.TickSmallMinor)
            }) : undefined
        }
    ];
    if (feature.RESPONSIBLE_USER && user) {
        const myCustomersSearch = `?${(0, _customersListSearchParams.RESPONSIBLE_USERS_NAME_PARAMETER)}=${user.id}`;
        const isMyCustomersFilter = location.search === myCustomersSearch;
        actions.push({
            content: f("component.filters.saved-filters.my-customers"),
            onAction: ()=>history.replace({
                    ...location,
                    search: myCustomersSearch
                }),
            active: isMyCustomersFilter,
            suffix: isMyCustomersFilter ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _polarisIcons.TickSmallMinor)
            }) : undefined
        });
    }
    // add saved filters
    actions.push(...savedFilters.map((filterName)=>({
            content: filterName,
            onAction: ()=>applyFilter(filterName),
            active: filterName === activeFilterName,
            suffix: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                wrap: false,
                children: [
                    filterName === activeFilterName && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _polarisIcons.TickSmallMinor)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                        content: f("component.filters.saved-filters.delete-filter"),
                        dismissOnMouseOut: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            plain: true,
                            outline: true,
                            icon: (0, _trashSvgDefault.default),
                            onClick: ()=>onFilterDelete(filterName)
                        })
                    })
                ]
            })
        })));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPopoverButton, {
        icon: (0, _starSvgDefault.default),
        connectedDisclosure: {
            actions
        },
        label: f("component.filters.saved-filters.save-filters.label"),
        render: (closePopover)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterDetailsDefault.default), {
                    defaultFilterName: appliedFiltersLabel,
                    onSave: (filterName)=>onSaveNewFilter(filterName, closePopover),
                    onCancel: closePopover
                })
            })
    });
};
const StyledPopoverButton = (0, _styledComponentsDefault.default)((0, _popoverButtonDefault.default))`
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    .Polaris-Button__Text {
      display: none;
    }
  }
`;
exports.default = SavedFilters;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@shopify/polaris-icons":"zOlgc","styled-components":"eBrdC","../../../../assets/icons/star.svg":"6EbZx","../../../../assets/icons/trash.svg":"jqW55","../../../constants/customers-list-search-params":"9nE5m","../../../constants/styles":"dZWds","../../../hooks/useAuth":"k9r0q","../../../hooks/useCustomersListParams":"euKlt","../../../hooks/useFeatures":"hvBWb","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useFormatMultipleNames":"gogmY","../../../hooks/useSnackbar":"gQ3G9","../../extensions/Button":"8exc0","../../extensions/Icon":"eHSf0","../../PopoverButton/PopoverButton":"ihB8F","../../TooltipWrapper/TooltipWrapper":"b5W2d","../useCustomersListFilters":"eRpWc","./FilterDetails":"evwMd","./useSavedFilters":"5odoP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6EbZx":[function(require,module,exports) {
module.exports = require("de90e3f2b587557a").getBundleURL("kEMsi") + "star.91ede1ca.svg";

},{"de90e3f2b587557a":"75UoR"}],"eRpWc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _customersListSearchParams = require("../../constants/customers-list-search-params");
var _filtersHelpers = require("../../helpers/filters.helpers");
var _tagHelpers = require("../../helpers/tag.helpers");
var _useCountries = require("../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useCreatedDateAppliedFilters = require("../../hooks/useCreatedDateAppliedFilters");
var _useCreatedDateAppliedFiltersDefault = parcelHelpers.interopDefault(_useCreatedDateAppliedFilters);
var _useCustomersListParams = require("../../hooks/useCustomersListParams");
var _useCustomersListParamsDefault = parcelHelpers.interopDefault(_useCustomersListParams);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useIndustryTypes = require("../../hooks/useIndustryTypes");
var _useIndustryTypesDefault = parcelHelpers.interopDefault(_useIndustryTypes);
var _useShowResponsibleUserFilter = require("../../hooks/useShowResponsibleUserFilter");
var _useShowResponsibleUserFilterDefault = parcelHelpers.interopDefault(_useShowResponsibleUserFilter);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _collectionUtils = require("../../utils/collectionUtils");
var _countrySelect = require("../CountrySelect/CountrySelect");
var _countrySelectDefault = parcelHelpers.interopDefault(_countrySelect);
var _createdDateFilter = require("../CreatedDateFilter/CreatedDateFilter");
var _createdDateFilterDefault = parcelHelpers.interopDefault(_createdDateFilter);
var _industryTypesFilter = require("../IndustryTypesFilter/IndustryTypesFilter");
var _industryTypesFilterDefault = parcelHelpers.interopDefault(_industryTypesFilter);
var _tagsFilter = require("../TagsFilter/TagsFilter");
var _tagsFilterDefault = parcelHelpers.interopDefault(_tagsFilter);
var _usersList = require("../UsersList/UsersList");
var _usersListDefault = parcelHelpers.interopDefault(_usersList);
var _followupDateFilter = require("./FollowupDateFilter");
var _followupDateFilterDefault = parcelHelpers.interopDefault(_followupDateFilter);
var _useFiltersOptions = require("./useFiltersOptions");
var _useFiltersOptionsDefault = parcelHelpers.interopDefault(_useFiltersOptions);
var _useFollowupDataAppliedFilters = require("./useFollowupDataAppliedFilters");
var _useFollowupDataAppliedFiltersDefault = parcelHelpers.interopDefault(_useFollowupDataAppliedFilters);
const useCustomersListFilters = (isLoading)=>{
    const { q, setQ, status, setStatus, customerType, setCustomerType, risk, setRisk, screeningType, setScreeningType, isArchived, setIsArchived, unresolved, setUnresolved, isPep, setIsPep, isSanctioned, setIsSanctioned, responsibleUserIds, setResponsibleUserIds, countryCode, setCountryCode, industryCodes, setIndustryCodes, tagIds, setTagIds, createdRange, setCreatedRange, createdAfter, setCreatedAfter, createdBefore, setCreatedBefore, followupRange, setFollowupRange, followupAfter, setFollowupAfter, followupBefore, setFollowupBefore, isFollowupExpired, setIsFollowupExpired, isPendingMeasures, setIsPendingMeasures, haveOwnershipUpdates, setHaveOwnershipUpdates, markedAsFilters, handleMarkedAsFiltersChange, resetAllFilters } = (0, _useCustomersListParamsDefault.default)();
    const appliedCreatedDateFilters = (0, _useCreatedDateAppliedFiltersDefault.default)({
        createdRange,
        setCreatedRange,
        createdAfter,
        setCreatedAfter,
        createdBefore,
        setCreatedBefore
    });
    const appliedFollowupDateFilters = (0, _useFollowupDataAppliedFiltersDefault.default)({
        followupRange,
        setFollowupRange,
        followupAfter,
        setFollowupAfter,
        followupBefore,
        setFollowupBefore
    });
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const filterOptions = (0, _useFiltersOptionsDefault.default)();
    const { getCountryName } = (0, _useCountriesDefault.default)();
    const { getUserFullName } = (0, _useGetUserNameDefault.default)(features.RESPONSIBLE_USER);
    const { findTag } = (0, _useTagsDefault.default)();
    // only call get all industry codes end point if there are industry codes in the filters
    const { getIndustryLabel } = (0, _useIndustryTypesDefault.default)(industryCodes.length > 0);
    const showResponsibleUserFilter = (0, _useShowResponsibleUserFilterDefault.default)();
    const tagsFilter = {
        key: "tags",
        label: f("component.filters.tags.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsFilterDefault.default), {
            tagIds: tagIds,
            setTagIds: setTagIds
        })
    };
    const industryCodesFilter = {
        key: "industry-types",
        label: f("component.filters.industry-type.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryTypesFilterDefault.default), {
            industryCodes: industryCodes,
            setIndustryCodes: setIndustryCodes
        })
    };
    const [statusFilter, statusAppliedFilter] = (0, _filtersHelpers.createFilter)("status", f("component.filters.status.title"), status, isLoading, filterOptions.customerStatus, setStatus);
    const [customerTypeFilter, customerTypeAppliedFilter] = (0, _filtersHelpers.createFilter)("customerType", f("component.filter.customer.title"), customerType, isLoading, filterOptions.customerType, setCustomerType);
    const [riskFilter, riskAppliedFilter] = (0, _filtersHelpers.createFilter)("risk", f("component.filter.risk.title"), risk, isLoading, filterOptions.risk, setRisk);
    const [screeningTypeFilter, screeningTypeAppliedFilter] = (0, _filtersHelpers.createFilter)("screening", f("component.filter.screening.title"), screeningType, isLoading, filterOptions.screening, setScreeningType);
    const countryCodeFilter = {
        key: "country",
        label: f("component.filter.country.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countrySelectDefault.default), {
            labelHidden: true,
            label: f("component.filter.country.title"),
            value: countryCode,
            onSelect: (country)=>setCountryCode(country)
        })
    };
    const unresolvedMatchesFilter = {
        key: "unresolved-matches",
        label: f("component.filters.unresolved-matched.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
            title: f("component.filters.unresolved-matched.title"),
            titleHidden: true,
            choices: filterOptions.unresolvedMatches,
            allowMultiple: true,
            selected: unresolved ? [
                (0, _customersListSearchParams.UNRESOLVED_NAME_PARAMETER)
            ] : [],
            onChange: (selected)=>setUnresolved(selected.includes((0, _customersListSearchParams.UNRESOLVED_NAME_PARAMETER)))
        })
    };
    const markedAsFilter = {
        key: "marked-as",
        label: f("component.filters.marked-as.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
            title: f("component.filters.marked-as.title"),
            titleHidden: true,
            choices: filterOptions.markedAs,
            allowMultiple: true,
            selected: markedAsFilters,
            onChange: (selected)=>handleMarkedAsFiltersChange(selected)
        })
    };
    const createdDateFilter = {
        key: "created",
        label: f("component.filters.created.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createdDateFilterDefault.default), {
            isLoading: isLoading,
            createdRange: createdRange,
            createdAfter: createdAfter,
            createdBefore: createdBefore,
            setCreatedRange: setCreatedRange,
            setCreatedAfter: setCreatedAfter,
            setCreatedBefore: setCreatedBefore
        })
    };
    const archivedCustomerFilter = {
        key: "archived-customer",
        label: f("component.filters.archive.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
            title: f("component.filters.archive.title"),
            titleHidden: true,
            choices: filterOptions.archive,
            allowMultiple: true,
            selected: isArchived ? [
                (0, _customersListSearchParams.ARCHIVED_NAME_PARAMETER)
            ] : [],
            onChange: (selected)=>setIsArchived(selected.includes((0, _customersListSearchParams.ARCHIVED_NAME_PARAMETER)))
        })
    };
    const filters = [
        tagsFilter,
        statusFilter,
        customerTypeFilter,
        riskFilter,
        unresolvedMatchesFilter,
        markedAsFilter,
        screeningTypeFilter,
        createdDateFilter,
        countryCodeFilter,
        archivedCustomerFilter
    ];
    filters.push(industryCodesFilter);
    const appliedFilters = [
        statusAppliedFilter,
        customerTypeAppliedFilter,
        riskAppliedFilter,
        screeningTypeAppliedFilter
    ].filter(Boolean);
    // find Tags from ids, filter missing tags, sort by tag title and add to applied filters
    tagIds.map(findTag).filter(Boolean).sort((tagA, tagB)=>(0, _tagHelpers.getTagTitle)(tagB).localeCompare((0, _tagHelpers.getTagTitle)(tagA))).forEach((tag)=>{
        appliedFilters.unshift({
            key: "tag-" + tag.id,
            label: (0, _tagHelpers.getTagTitle)(tag),
            tagColor: tag.color,
            isTag: true,
            onRemove: ()=>setTagIds(tagIds.filter((id)=>id !== tag.id))
        });
    });
    industryCodes.forEach((industryCode)=>{
        appliedFilters.unshift({
            key: "industry-code-" + industryCode,
            label: `${f("component.filters.industry-type.title")}: ${getIndustryLabel(industryCode)}`,
            onRemove: ()=>setIndustryCodes(industryCodes.filter((id)=>id !== industryCode))
        });
    });
    if (unresolved) appliedFilters.push({
        key: "match-is-unresolved",
        label: f("component.filters.match.text.open.matches"),
        onRemove: ()=>setUnresolved(false)
    });
    if (isPep) appliedFilters.push({
        key: "match-is-pep",
        label: f("component.filters.match.text.pep.matches"),
        onRemove: ()=>setIsPep(false)
    });
    if (isSanctioned) appliedFilters.push({
        key: "match-is-sanctioned",
        label: f("component.filters.match.text.sanction.matches"),
        onRemove: ()=>setIsSanctioned(false)
    });
    appliedFilters.push(...appliedCreatedDateFilters);
    if (countryCode) appliedFilters.push({
        key: "country",
        label: `${f("component.filter.country.title")}: ${getCountryName(countryCode)}`,
        onRemove: ()=>setCountryCode(undefined)
    });
    if (isArchived) appliedFilters.push({
        key: "archived-customer",
        label: f("badge.archived"),
        onRemove: ()=>setIsArchived(false)
    });
    if (showResponsibleUserFilter) {
        const responsibleUserFilter = {
            key: "responsible-user",
            label: f("responsible.label"),
            shortcut: true,
            disabled: isLoading,
            hideClearButton: true,
            filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersListDefault.default), {
                showAllUsersOption: true,
                selectedUserIds: responsibleUserIds,
                allowMultiple: true,
                onChange: setResponsibleUserIds
            })
        };
        // responsible users filter should be visible in the "default" filters group - add it after the status (first) filter
        filters.splice(1, 0, responsibleUserFilter);
        responsibleUserIds.forEach((userId)=>{
            const userName = getUserFullName(userId);
            appliedFilters.push({
                key: "responsible-user" + userId,
                label: `${f("responsible.label")}: ${userName}`,
                onRemove: ()=>setResponsibleUserIds((0, _collectionUtils.toggleElement)(responsibleUserIds, userId))
            });
        });
    }
    const isFollowupExpiredFilter = {
        key: "followup-expired",
        label: f("component.filters.followup-expired.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
            title: f("component.filters.followup-expired.title"),
            titleHidden: true,
            choices: filterOptions.followup,
            allowMultiple: true,
            selected: isFollowupExpired ? [
                (0, _customersListSearchParams.FOLLOW_UP_EXPIRED_NAME_PARAMETER)
            ] : [],
            onChange: (selected)=>setIsFollowupExpired(selected.includes((0, _customersListSearchParams.FOLLOW_UP_EXPIRED_NAME_PARAMETER)))
        })
    };
    const followupDateFilter = {
        key: "followup",
        label: f("component.filters.followup.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _followupDateFilterDefault.default), {
            isLoading: isLoading,
            followupRange: followupRange,
            followupAfter: followupAfter,
            followupBefore: followupBefore,
            setFollowupRange: setFollowupRange,
            setFollowupAfter: setFollowupAfter,
            setFollowupBefore: setFollowupBefore
        })
    };
    filters.push(isFollowupExpiredFilter);
    filters.push(followupDateFilter);
    if (isFollowupExpired) appliedFilters.push({
        key: "followup-expired",
        label: f("component.filters.followup-expired.title"),
        onRemove: ()=>setIsFollowupExpired(false)
    });
    appliedFilters.push(...appliedFollowupDateFilters);
    if (features.MEASURES) {
        const isPendingMeasuresFilter = {
            key: "pending-measures",
            label: f("component.filters.pending-measures.title"),
            shortcut: true,
            disabled: isLoading,
            hideClearButton: true,
            filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
                title: f("component.filters.pending-measures.title"),
                titleHidden: true,
                choices: filterOptions.measures,
                allowMultiple: true,
                selected: isPendingMeasures ? [
                    (0, _customersListSearchParams.PENDING_MEASURES_NAME_PARAMETER)
                ] : [],
                onChange: (selected)=>setIsPendingMeasures(selected.includes((0, _customersListSearchParams.PENDING_MEASURES_NAME_PARAMETER)))
            })
        };
        filters.push(isPendingMeasuresFilter);
    }
    if (isPendingMeasures) appliedFilters.push({
        key: "pending-measures",
        label: f("component.filters.pending-measures.title"),
        onRemove: ()=>setIsPendingMeasures(false)
    });
    const ownershipUpdatesFilter = {
        key: "ownership-updates",
        label: f("component.filters.ownership-updates.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
            title: f("component.filters.ownership-updates.title"),
            titleHidden: true,
            choices: filterOptions.ownershipUpdates,
            allowMultiple: true,
            selected: haveOwnershipUpdates ? [
                (0, _customersListSearchParams.OWNERSHIP_UPDATES_NAME_PARAMETER)
            ] : [],
            onChange: (selected)=>setHaveOwnershipUpdates(selected.includes((0, _customersListSearchParams.OWNERSHIP_UPDATES_NAME_PARAMETER)))
        })
    };
    filters.push(ownershipUpdatesFilter);
    if (haveOwnershipUpdates) appliedFilters.push({
        key: "ownership-updates",
        label: f("ownership-update.info.label"),
        onRemove: ()=>setHaveOwnershipUpdates(false)
    });
    const uniqueAppliedFilters = (0, _collectionUtils.uniqueElementsBy)(appliedFilters, "key");
    return {
        q,
        setQ,
        filters,
        appliedFilters: uniqueAppliedFilters,
        resetAllFilters
    };
};
exports.default = useCustomersListFilters;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/customers-list-search-params":"9nE5m","../../helpers/filters.helpers":"1yvvL","../../helpers/tag.helpers":"ecpII","../../hooks/useCountries":"azDTp","../../hooks/useCreatedDateAppliedFilters":"1QHn4","../../hooks/useCustomersListParams":"euKlt","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useIndustryTypes":"e8cij","../../hooks/useShowResponsibleUserFilter":"khaJz","../../hooks/useTags":"31uzS","../../utils/collectionUtils":"gr5mc","../CountrySelect/CountrySelect":"dlvog","../CreatedDateFilter/CreatedDateFilter":"rFh9u","../IndustryTypesFilter/IndustryTypesFilter":"cgKGV","../TagsFilter/TagsFilter":"48hmU","../UsersList/UsersList":"dqxGe","./FollowupDateFilter":"8etjS","./useFiltersOptions":"duoqc","./useFollowupDataAppliedFilters":"krSZa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1yvvL":[function(require,module,exports) {
/** this util file has a ".tsx" extension since it has functions that return object with React component in them **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFilter", ()=>createFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFiltersOptions = require("../components/CustomersListFilters/useFiltersOptions");
var _stringUtils = require("../utils/stringUtils");
function createFilter(key, label, value, disabled, choices, onChange) {
    const valueLabel = choices.find((choice)=>choice.value === value)?.label || value;
    const displayLabel = `${label}${(0, _stringUtils.isEmptyString)(value) ? "" : `: ${valueLabel}`}`;
    const filter = {
        key,
        label,
        shortcut: true,
        disabled,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
            title: label,
            titleHidden: true,
            choices: choices,
            selected: value ? [
                value
            ] : [
                (0, _useFiltersOptions.ALL_FILTER_ITEM_VALUE)
            ],
            onChange: (selected)=>onChange(selected[0] === (0, _useFiltersOptions.ALL_FILTER_ITEM_VALUE) ? undefined : selected[0])
        })
    };
    const appliedFilter = (0, _stringUtils.isEmptyString)(value) ? undefined : {
        key,
        label: displayLabel,
        onRemove: ()=>onChange(undefined)
    };
    return [
        filter,
        appliedFilter
    ];
}

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../components/CustomersListFilters/useFiltersOptions":"duoqc","../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"duoqc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL_FILTER_ITEM_VALUE", ()=>ALL_FILTER_ITEM_VALUE);
var _customersListSearchParams = require("../../constants/customers-list-search-params");
var _filters = require("../../constants/filters");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ALL_FILTER_ITEM_VALUE = "__clear__";
const useFiltersOptions = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const ALL_ITEMS_FILTER_ITEM = {
        label: f("component.filters.all.title"),
        value: ALL_FILTER_ITEM_VALUE,
        disabled: false
    };
    const CUSTOMER_STATUS_OPTIONS = [
        ALL_ITEMS_FILTER_ITEM,
        {
            label: f("component.filters.status.started"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_STATUS_PARAMS).STARTED
        },
        {
            label: f("component.filters.status.not-ready"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_STATUS_PARAMS).NOT_READY
        },
        {
            label: f("component.filters.status.review-required"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_STATUS_PARAMS).REVIEW_REQUIRED
        },
        {
            label: f("component.filters.status.draft-review"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_STATUS_PARAMS).DRAFT_REVIEW
        },
        {
            label: f("component.filters.status.review-approval-required"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_STATUS_PARAMS).REVIEW_APPROVAL_REQUIRED
        },
        {
            label: f("component.filters.status.approved"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_STATUS_PARAMS).APPROVED
        },
        {
            label: f("component.filters.status.rejected"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_STATUS_PARAMS).REJECTED
        }
    ];
    const CUSTOMER_TYPE_OPTIONS = [
        ALL_ITEMS_FILTER_ITEM,
        {
            label: f("component.filter.customer.option.company.title"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_TYPE_PARAMS).COMPANY
        },
        {
            label: f("component.filter.customer.option.person.title"),
            value: (0, _customersListSearchParams.CUSTOMER_FILTER_TYPE_PARAMS).PERSON
        }
    ];
    const RISK_OPTIONS = [
        ALL_ITEMS_FILTER_ITEM,
        {
            label: f("risklabel.LOW"),
            value: "LOW"
        },
        {
            label: f("risklabel.MEDIUM"),
            value: "MEDIUM"
        },
        {
            label: f("risklabel.HIGH"),
            value: "HIGH"
        }
    ];
    const UNRESOLVED_MATCHES_OPTIONS = [
        {
            label: f("component.filters.match.option.open.matches"),
            value: (0, _customersListSearchParams.UNRESOLVED_NAME_PARAMETER)
        }
    ];
    const PEP_SANCTION_FILTERS = [
        {
            label: f("component.filters.marked-as.option.pep"),
            value: (0, _filters.MARKED_AS_FILTERS).PEP
        },
        {
            label: f("component.filters.marked-as.option.sanction"),
            value: (0, _filters.MARKED_AS_FILTERS).SANCTIONED
        }
    ];
    const ARCHIVE_OPTIONS = [
        {
            label: f("component.filters.archive.option.include-archived-customers"),
            value: (0, _customersListSearchParams.ARCHIVED_NAME_PARAMETER)
        }
    ];
    const FOLLOWUP_EXPIRED_OPTIONS = [
        {
            label: f("component.filters.followup.option.expired"),
            value: (0, _customersListSearchParams.FOLLOW_UP_EXPIRED_NAME_PARAMETER)
        }
    ];
    const PENDING_MEASURES_OPTIONS = [
        {
            label: f("component.filters.pending-measures.option"),
            value: (0, _customersListSearchParams.PENDING_MEASURES_NAME_PARAMETER)
        }
    ];
    const OWNERSHIP_UPDATES_OPTIONS = [
        {
            label: f("component.filters.ownership-updates.label"),
            value: (0, _customersListSearchParams.OWNERSHIP_UPDATES_NAME_PARAMETER)
        }
    ];
    const SCREENING_OPTIONS = [
        ALL_ITEMS_FILTER_ITEM,
        {
            label: f("component.filters.screening.option.monitoring"),
            value: (0, _filters.SCREENING_TYPE_FILTERS).MONITORING
        },
        {
            label: f("component.filters.screening.option.one-time"),
            value: (0, _filters.SCREENING_TYPE_FILTERS).ONE_TIME
        }
    ];
    const PROJECT_STATUS_OPTIONS = [
        ALL_ITEMS_FILTER_ITEM,
        {
            label: f("component.filters.project.option.active"),
            value: "ACTIVE"
        },
        {
            label: f("component.filters.project.option.inactive"),
            value: "INACTIVE"
        }
    ];
    return {
        customerStatus: CUSTOMER_STATUS_OPTIONS,
        customerType: CUSTOMER_TYPE_OPTIONS,
        risk: RISK_OPTIONS,
        unresolvedMatches: UNRESOLVED_MATCHES_OPTIONS,
        markedAs: PEP_SANCTION_FILTERS,
        archive: ARCHIVE_OPTIONS,
        followup: FOLLOWUP_EXPIRED_OPTIONS,
        screening: SCREENING_OPTIONS,
        projectStatus: PROJECT_STATUS_OPTIONS,
        ownershipUpdates: OWNERSHIP_UPDATES_OPTIONS,
        measures: PENDING_MEASURES_OPTIONS
    };
};
exports.default = useFiltersOptions;

},{"../../constants/customers-list-search-params":"9nE5m","../../constants/filters":"94mf3","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1QHn4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
var _pagination = require("../constants/pagination");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useCreatedDateAppliedFilters = (props)=>{
    const { createdRange, createdBefore, createdAfter, setCreatedRange, setCreatedAfter, setCreatedBefore } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatDate } = (0, _reactIntl.useIntl)();
    const appliedCreatedDateFilters = [];
    if (createdRange && createdRange !== (0, _pagination.DateRange).CUSTOM) appliedCreatedDateFilters.push({
        key: "created",
        label: f(`component.filters.created.applied.range.${createdRange}`),
        onRemove: ()=>setCreatedRange(undefined)
    });
    if (createdAfter && createdRange === (0, _pagination.DateRange).CUSTOM) appliedCreatedDateFilters.push({
        key: "created-after",
        label: f("component.filters.created.labels.after", {
            date: formatDate(createdAfter)
        }),
        onRemove: ()=>{
            setCreatedAfter(undefined);
            if (!createdBefore) setCreatedRange(undefined);
        }
    });
    if (createdBefore && createdRange === (0, _pagination.DateRange).CUSTOM) appliedCreatedDateFilters.push({
        key: "created-before",
        label: f("component.filters.created.labels.before", {
            date: formatDate(createdBefore)
        }),
        onRemove: ()=>{
            setCreatedBefore(undefined);
            if (!createdAfter) setCreatedRange(undefined);
        }
    });
    return appliedCreatedDateFilters;
};
exports.default = useCreatedDateAppliedFilters;

},{"react-intl":"8H1wU","../constants/pagination":"e05H0","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e8cij":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _displayHelpers = require("../helpers/display.helpers");
var _useLanguage = require("./useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
// set the stale time to 1 hour to avoid multiple calls to getIndustryTypes
const useIndustryTypes = (enabled = false)=>{
    const language = (0, _useLanguageDefault.default)();
    const getAllIndustryTypesQuery = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).ALL_INDUSTRY_TYPES
    ], ()=>(0, _apiDefault.default).listAllIndustryCodes(), {
        staleTime: (0, _queriesKeys.STALE_TIME),
        enabled
    });
    const allIndustries = getAllIndustryTypesQuery.data?.industry_codes || [];
    const industryTypesMap = (0, _react.useMemo)(()=>Object.fromEntries(allIndustries.map((industry)=>[
                industry.code,
                industry
            ])), [
        allIndustries,
        language
    ]);
    const getIndustryLabel = (0, _react.useCallback)((industryCode)=>(0, _displayHelpers.getTranslationText)(language, industryTypesMap[industryCode]?.name) || industryCode, [
        industryTypesMap
    ]);
    // allIndustries contains both categories and codes
    // industry codes have 6 characters (formatted like this 00.000) while categories have less than 6 characters
    // (example: 01.10)
    const industriesWithoutCategories = (0, _react.useMemo)(()=>allIndustries.filter(({ code })=>code.length === 6), [
        allIndustries
    ]);
    return {
        allIndustries,
        industriesWithoutCategories,
        getIndustryLabel,
        isLoading: getAllIndustryTypesQuery.isLoading
    };
};
exports.default = useIndustryTypes;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../helpers/display.helpers":"2q3xY","./useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"khaJz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
const useShowResponsibleUserFilter = ()=>{
    const features = (0, _useFeaturesDefault.default)();
    const { user } = (0, _useAuthDefault.default)();
    // admin users are user with more or more groups
    const isAdminUser = user?.groups !== undefined && user.groups.length > 0;
    if (!features.RESPONSIBLE_USER) return false;
    // if ENFORCE_RESPONSIBLE_USER_FILTER is enabled, only show the responsible users filter for
    // users with groups (KDK Admin, MLRO, etc.) and hide it for regular users (without groups).
    return features.ENFORCE_RESPONSIBLE_USER_FILTER ? isAdminUser : true;
};
exports.default = useShowResponsibleUserFilter;

},{"./useAuth":"k9r0q","./useFeatures":"hvBWb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"rFh9u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _pagination = require("../../constants/pagination");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _dateInput = require("../DateInput/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
const MIN_DATE = new Date("2020-01-01");
const MAX_DATE = new Date();
const CreatedDateFilter = (props)=>{
    const { isLoading, createdRange, createdAfter, createdBefore, setCreatedRange, setCreatedAfter, setCreatedBefore } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                name: "created",
                label: f(`component.filters.created.range.ALL`),
                disabled: isLoading,
                checked: (0, _stringUtils.isEmptyString)(createdRange),
                onChange: ()=>setCreatedRange(undefined)
            }),
            Object.values((0, _pagination.DateRange)).map((rangeOption)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                    name: "created",
                    label: f(`component.filters.created.range.${rangeOption}`),
                    disabled: isLoading,
                    checked: createdRange === rangeOption,
                    onChange: ()=>setCreatedRange(rangeOption)
                }, rangeOption)),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                        label: f("component.filters.created-after.title"),
                        value: createdAfter || "",
                        onChange: (date)=>setCreatedAfter(date),
                        maxDate: MAX_DATE,
                        minDate: MIN_DATE,
                        disabled: isLoading || createdRange !== (0, _pagination.DateRange).CUSTOM,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                        label: f("component.filters.created-before.title"),
                        value: createdBefore || "",
                        onChange: (date)=>setCreatedBefore(date),
                        maxDate: MAX_DATE,
                        minDate: MIN_DATE,
                        disabled: isLoading || createdRange !== (0, _pagination.DateRange).CUSTOM,
                        autoComplete: "off"
                    })
                ]
            })
        ]
    });
};
exports.default = CreatedDateFilter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/pagination":"e05H0","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../DateInput/DateInput":"6BAM5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cgKGV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useDebouncedState = require("../../hooks/useDebouncedState");
var _useDebouncedStateDefault = parcelHelpers.interopDefault(_useDebouncedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useIndustryTypes = require("../../hooks/useIndustryTypes");
var _useIndustryTypesDefault = parcelHelpers.interopDefault(_useIndustryTypes);
var _stringUtils = require("../../utils/stringUtils");
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _stickyWrapper = require("../StickyWrapper/StickyWrapper");
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
const IndustryTypesFilter = (props)=>{
    const { industryCodes, setIndustryCodes } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [enableAPICall, setEnableAPICall] = (0, _react.useState)(false);
    const [filterValue, setFilterValue, debouncedValue] = (0, _useDebouncedStateDefault.default)("");
    const { industriesWithoutCategories, getIndustryLabel, isLoading } = (0, _useIndustryTypesDefault.default)(enableAPICall);
    // only call get all industry codes end point after initial mount
    (0, _react.useEffect)(()=>setEnableAPICall(true), []);
    const choices = (0, _react.useMemo)(()=>{
        const filteredIndustries = (0, _stringUtils.isEmptyString)(filterValue) ? industriesWithoutCategories : industriesWithoutCategories.filter((industry)=>getIndustryLabel(industry.code).toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()));
        return filteredIndustries.map((industry)=>({
                value: industry.code,
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                    searchWords: [
                        debouncedValue
                    ],
                    textToHighlight: getIndustryLabel(industry.code)
                })
            }));
    }, [
        industriesWithoutCategories,
        debouncedValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stickyWrapper.StickyWrapper), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                label: f("industry-types.filter.label"),
                value: filterValue,
                onChange: setFilterValue,
                disabled: isLoading,
                clearButton: true,
                onClearButtonClick: ()=>setFilterValue("")
            }),
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("default.loading")
                    })
                ]
            }),
            !isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
                title: "",
                choices: choices,
                selected: industryCodes,
                onChange: setIndustryCodes,
                titleHidden: true,
                allowMultiple: true
            })
        ]
    });
};
exports.default = IndustryTypesFilter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useDebouncedState":"lKEJK","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useIndustryTypes":"e8cij","../../utils/stringUtils":"4gVdA","../SearchTextField/SearchTextField":"k5bRy","../StickyWrapper/StickyWrapper":"dIiqP","../TextHighlighter/TextHighlighter":"43Xhz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lKEJK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _durations = require("../constants/durations");
var _useDebounce = require("./useDebounce");
var _useDebounceDefault = parcelHelpers.interopDefault(_useDebounce);
function useDebouncedState(initialValue, delay = (0, _durations.QUERY_SEARCH_DEBOUNCE_DELAY)) {
    const [value, setValue] = (0, _react.useState)(initialValue);
    const [debouncedValue, setDebouncedValue] = (0, _react.useState)(initialValue);
    (0, _useDebounceDefault.default)(()=>setDebouncedValue(value), delay, [
        value
    ]);
    return [
        value,
        setValue,
        debouncedValue
    ];
}
exports.default = useDebouncedState;

},{"react":"cOWTg","../constants/durations":"5sjIW","./useDebounce":"i1Evt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"48hmU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _stickyWrapper = require("../StickyWrapper/StickyWrapper");
var _tagsChoiceList = require("../TagsChoiceList/TagsChoiceList");
var _tagsChoiceListDefault = parcelHelpers.interopDefault(_tagsChoiceList);
const TagsFilter = (props)=>{
    const { tagIds, setTagIds } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [filterValue, setFilterValue] = (0, _react.useState)("");
    const { allTags, findTag } = (0, _useTagsDefault.default)();
    // default tag contains "..." as title and tagId - if a tag is found then that tags will be displayed
    const getTagWithDefaults = (tagId)=>Object.assign({
            id: tagId,
            title: "..."
        }, findTag(tagId));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stickyWrapper.StickyWrapper), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                label: f("tags.editor.filter-tags"),
                value: filterValue,
                onChange: setFilterValue
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsChoiceListDefault.default), {
                tags: allTags,
                selectedTags: tagIds.map(getTagWithDefaults),
                titleHidden: true,
                filterValue: filterValue,
                enableReadonlySelection: true,
                onSelectionChange: (selectedTags)=>setTagIds(selectedTags.map((tag)=>tag.id))
            })
        ]
    });
};
exports.default = TagsFilter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useTags":"31uzS","../SearchTextField/SearchTextField":"k5bRy","../StickyWrapper/StickyWrapper":"dIiqP","../TagsChoiceList/TagsChoiceList":"knnR1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8etjS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _followup = require("../../constants/followup");
var _pagination = require("../../constants/pagination");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _dateInput = require("../DateInput/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
const MIN_DATE = new Date("2020-01-01");
const FollowupDateFilter = (props)=>{
    const { isLoading, followupRange, followupAfter, followupBefore, setFollowupRange, setFollowupAfter, setFollowupBefore } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + (0, _followup.MAX_FOLLOWUP_INTERVAL_IN_MONTHS) / 12);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                name: "followup",
                label: f(`component.filters.followup.range.ALL`),
                disabled: isLoading,
                checked: (0, _stringUtils.isEmptyString)(followupRange),
                onChange: ()=>setFollowupRange(undefined)
            }),
            Object.values((0, _pagination.DateRange)).map((rangeOption)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                    name: "followup",
                    label: f(`component.filters.followup.range.${rangeOption}`),
                    disabled: isLoading,
                    checked: followupRange === rangeOption,
                    onChange: ()=>setFollowupRange(rangeOption)
                }, rangeOption)),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                        label: f("component.filters.followup-after.title"),
                        value: followupAfter || "",
                        onChange: (date)=>setFollowupAfter(date),
                        minDate: MIN_DATE,
                        maxDate: maxDate,
                        disabled: isLoading || followupRange !== (0, _pagination.DateRange).CUSTOM,
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                        label: f("component.filters.followup-before.title"),
                        value: followupBefore || "",
                        onChange: (date)=>setFollowupBefore(date),
                        minDate: MIN_DATE,
                        maxDate: maxDate,
                        disabled: isLoading || followupRange !== (0, _pagination.DateRange).CUSTOM,
                        autoComplete: "off"
                    })
                ]
            })
        ]
    });
};
exports.default = FollowupDateFilter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/followup":"kBYmS","../../constants/pagination":"e05H0","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../DateInput/DateInput":"6BAM5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"krSZa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
var _pagination = require("../../constants/pagination");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useFollowupDataAppliedFilters = (props)=>{
    const { followupRange, followupBefore, followupAfter, setFollowupRange, setFollowupAfter, setFollowupBefore } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatDate } = (0, _reactIntl.useIntl)();
    const appliedFollowupDateFilters = [];
    if (followupRange && followupRange !== (0, _pagination.DateRange).CUSTOM) appliedFollowupDateFilters.push({
        key: "followup",
        label: f(`component.filters.followup.applied.range.${followupRange}`),
        onRemove: ()=>setFollowupRange(undefined)
    });
    if (followupAfter && followupRange === (0, _pagination.DateRange).CUSTOM) appliedFollowupDateFilters.push({
        key: "followup-after",
        label: f("component.filters.followup.labels.after", {
            date: formatDate(followupAfter)
        }),
        onRemove: ()=>{
            setFollowupAfter(undefined);
            if (!followupBefore) setFollowupRange(undefined);
        }
    });
    if (followupBefore && followupRange === (0, _pagination.DateRange).CUSTOM) appliedFollowupDateFilters.push({
        key: "followup-before",
        label: f("component.filters.followup.labels.before", {
            date: formatDate(followupBefore)
        }),
        onRemove: (followupAfter)=>{
            setFollowupBefore(undefined);
            if (!followupAfter) setFollowupRange(undefined);
        }
    });
    return appliedFollowupDateFilters;
};
exports.default = useFollowupDataAppliedFilters;

},{"react-intl":"8H1wU","../../constants/pagination":"e05H0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"evwMd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useCustomersListParams = require("../../../hooks/useCustomersListParams");
var _useCustomersListParamsDefault = parcelHelpers.interopDefault(_useCustomersListParams);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSnackbar = require("../../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _stringUtils = require("../../../utils/stringUtils");
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _useSavedFilters = require("./useSavedFilters");
var _useSavedFiltersDefault = parcelHelpers.interopDefault(_useSavedFilters);
const FilterDetails = (props)=>{
    const { defaultFilterName = "", onSave, onCancel } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isEmptySearch } = (0, _useCustomersListParamsDefault.default)();
    const [filterName, setFilterName] = (0, _react.useState)(defaultFilterName);
    const { savedFilters } = (0, _useSavedFiltersDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const disabled = isEmptySearch || (0, _stringUtils.isEmptyString)(filterName) || savedFilters.includes(filterName);
    const handleFormSubmit = ()=>{
        onSave(filterName);
        setFilterName("");
        setSnackbar(f("component.filters.saved-filters.saved.message"));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                value: filterName,
                onChange: setFilterName,
                selectTextOnFocus: true,
                label: f("component.filters.saved-filters.filter-name"),
                autoComplete: "off",
                placeholder: f("component.filters.saved-filters.filter-name"),
                disabled: isEmptySearch
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                spacing: "extraTight",
                wrap: false,
                distribution: "trailing",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        primary: true,
                        disabled: disabled,
                        onClick: handleFormSubmit,
                        children: f("component.filters.saved-filters.save-filters.label")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: onCancel,
                        children: f("default.cancel")
                    })
                ]
            })
        ]
    });
};
exports.default = FilterDetails;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useCustomersListParams":"euKlt","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useSnackbar":"gQ3G9","../../../utils/stringUtils":"4gVdA","../../extensions/Button":"8exc0","./useSavedFilters":"5odoP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5odoP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _useStorage = require("../../../hooks/useStorage");
var _stringUtils = require("../../../utils/stringUtils");
const useSavedFilters = ()=>{
    const history = (0, _reactRouterDom.useHistory)();
    const location = (0, _reactRouterDom.useLocation)();
    const [filtersMap, setFiltersMap] = (0, _useStorage.useLocalStorage)("savedFilters", {});
    const saveCurrentFilters = (filterName)=>{
        if ((0, _stringUtils.isEmptyString)(location.search)) return;
        filtersMap[filterName] = location.search;
        setFiltersMap(filtersMap);
    };
    const deleteSavedFilters = (filterName)=>{
        delete filtersMap[filterName];
        setFiltersMap(filtersMap);
    };
    const applyFilter = (filterName)=>{
        if (!filtersMap[filterName]) return;
        history.replace({
            ...location,
            search: filtersMap[filterName]
        });
    };
    const savedFilters = Object.keys(filtersMap);
    const activeFilter = Object.entries(filtersMap).find(([, search])=>location.search === search);
    const activeFilterName = activeFilter ? activeFilter[0] : undefined;
    return {
        savedFilters,
        activeFilterName,
        saveCurrentFilters,
        deleteSavedFilters,
        applyFilter
    };
};
exports.default = useSavedFilters;

},{"react-router-dom":"1ee65","../../../hooks/useStorage":"aERXD","../../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3cuOV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _useStorage = require("../../hooks/useStorage");
var _stringUtils = require("../../utils/stringUtils");
const useRestoreLastWindowLocationSearch = (key)=>{
    const [lastState, setLastState] = (0, _useStorage.useSessionStorage)(key, "");
    const history = (0, _reactRouterDom.useHistory)();
    // whenever the last state or the current window.location.search changes - update the last state
    // to store the current window.location.search
    (0, _react.useEffect)(()=>{
        if (lastState !== window.location.search) setLastState(window.location.search);
    }, [
        lastState,
        window.location.search
    ]);
    // if the last state was not empty, and it's different from the current window.location.search
    // change the current location search to the last state
    (0, _react.useEffect)(()=>{
        if (!(0, _stringUtils.isEmptyString)(lastState) && lastState !== window.location.search) {
            console.debug("useRestoreLastWindowLocationSearch", history.location, lastState);
            history.replace({
                ...history.location,
                search: lastState
            });
        }
    }, []);
};
exports.default = useRestoreLastWindowLocationSearch;

},{"react":"cOWTg","react-router-dom":"1ee65","../../hooks/useStorage":"aERXD","../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aBWie":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _freshCustomerSvg = require("../../../assets/images/fresh-customer.svg");
var _freshCustomerSvgDefault = parcelHelpers.interopDefault(_freshCustomerSvg);
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _kdkemptyState = require("../KDKEmptyState/KDKEmptyState");
var _kdkemptyStateDefault = parcelHelpers.interopDefault(_kdkemptyState);
const CustomersListFreshCustomerEmptyState = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const lookupPath = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_LOOKUP);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledEmptyState, {
        header: f("customers.list.fresh-customer.title"),
        description: f("customers.list.fresh-customer.content"),
        image: (0, _freshCustomerSvgDefault.default),
        altImage: "",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
            primary: true,
            url: lookupPath,
            children: f("customers.list.fresh-customer.label")
        })
    });
};
const StyledEmptyState = (0, _styledComponentsDefault.default)((0, _kdkemptyStateDefault.default))`
  margin-top: 0;
`;
exports.default = CustomersListFreshCustomerEmptyState;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/images/fresh-customer.svg":"k2IVf","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../KDKEmptyState/KDKEmptyState":"bZwvm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k2IVf":[function(require,module,exports) {
module.exports = require("ee4710626154777c").getBundleURL("kEMsi") + "fresh-customer.0240b6c7.svg";

},{"ee4710626154777c":"75UoR"}],"27PCy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pagination = require("../../constants/pagination");
var _pendingTasksHelpers = require("../../helpers/pending-tasks.helpers");
var _useCustomersListParams = require("../../hooks/useCustomersListParams");
var _useCustomersListParamsDefault = parcelHelpers.interopDefault(_useCustomersListParams);
var _reactTable = require("../ReactTable/ReactTable");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable);
var _customersListPagination = require("./CustomersListPagination");
var _customersListPaginationDefault = parcelHelpers.interopDefault(_customersListPagination);
const CustomersListTable = (props)=>{
    const { columns, customers, count, isLoading, hidePagination, additionalPaginationOnTop, sortLocally, selectable, selectedIds, onSelectionChange, ...rest } = props;
    const { order, setOrder, setPage } = (0, _useCustomersListParamsDefault.default)();
    const getRowId = (0, _react.useCallback)((customer)=>customer.id, []);
    const handleSortChange = (0, _react.useCallback)((columnId, sortDirection)=>{
        const orderDirection = sortDirection === "ascending" ? "" : "-";
        const newOrder = orderDirection + columnId;
        setOrder(newOrder);
        setPage(0);
    }, [
        setOrder,
        setPage
    ]);
    const sortedColumnId = order?.includes((0, _pagination.SORT_BY_NAME_PARAMETER)) ? (0, _pagination.SORT_BY_NAME_PARAMETER) : (0, _pagination.SORT_BY_ADDED_DATE_PARAMETER);
    const sortedDirection = !order || order.startsWith("-") ? "descending" : "ascending";
    const showPagination = !hidePagination && customers.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTableDefault.default), {
        columns: columns,
        data: customers,
        getRowId: getRowId,
        getRowProps: (customer)=>(0, _pendingTasksHelpers.hasActionablePendingTasks)(customer) ? {
                status: "info"
            } : {
                status: "regular"
            },
        sortLocally: sortLocally,
        sortedColumnId: sortedColumnId,
        sortedDirection: sortedDirection,
        onSortChange: handleSortChange,
        selectedIds: selectedIds || [],
        onSelectionChange: onSelectionChange,
        selectable: selectable,
        isLoading: isLoading,
        headerContent: showPagination && additionalPaginationOnTop ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListPaginationDefault.default), {
            isLoading: isLoading,
            customers: customers,
            count: count
        }) : null,
        footerContent: showPagination ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListPaginationDefault.default), {
            isLoading: isLoading,
            customers: customers,
            count: count
        }) : null,
        ...rest
    });
};
exports.default = CustomersListTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../constants/pagination":"e05H0","../../helpers/pending-tasks.helpers":"dLOfL","../../hooks/useCustomersListParams":"euKlt","../ReactTable/ReactTable":"iNTSb","./CustomersListPagination":"fiKDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fiKDQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useCustomersListParams = require("../../hooks/useCustomersListParams");
var _useCustomersListParamsDefault = parcelHelpers.interopDefault(_useCustomersListParams);
var _paginationControls = require("../PaginationControls/PaginationControls");
var _paginationControlsDefault = parcelHelpers.interopDefault(_paginationControls);
const CustomersListPagination = (props)=>{
    const { isLoading, customers, count } = props;
    const { page, setPage, limit, setLimit } = (0, _useCustomersListParamsDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationControlsDefault.default), {
        isLoading: isLoading,
        page: page,
        limit: limit,
        count: count,
        itemsCount: customers.length,
        setPage: setPage,
        setLimit: setLimit
    });
};
exports.default = CustomersListPagination;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useCustomersListParams":"euKlt","../PaginationControls/PaginationControls":"aXNRN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aXNRN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _plainSelect = require("../PlainSelect/PlainSelect");
var _plainSelectDefault = parcelHelpers.interopDefault(_plainSelect);
const PaginationControls = (props)=>{
    const { isLoading, page = 0, limit = 0, count, itemsCount, setPage, setLimit } = props;
    const hasNext = (page + 1) * limit < count;
    const hasPrev = page > 0;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plainSelectDefault.default), {
                label: f("component.pagination.labels.select-limit", {
                    limit
                }),
                labelInline: true,
                options: [
                    "20",
                    "50",
                    "100",
                    "200"
                ],
                onChange: (limitValue)=>setLimit(parseInt(limitValue, 10)),
                value: limit + "",
                disabled: isLoading
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: f("component.pagination.labels.showing", {
                    start: limit * page || 1,
                    end: Math.min(limit * page + itemsCount, count),
                    count: count
                })
            }),
            hasPrev && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                onClick: ()=>setPage(page - 1),
                disabled: isLoading,
                children: f("default.previous")
            }),
            hasNext && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                onClick: ()=>setPage(page + 1),
                disabled: isLoading,
                children: f("default.next")
            })
        ]
    });
};
exports.default = PaginationControls;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","../PlainSelect/PlainSelect":"4Y0fH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4Y0fH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const isStrictOption = (option)=>typeof option !== "string";
const PlainSelect = (props)=>{
    const { loading } = props;
    const [active, toggle, close] = (0, _useOpenCloseDefault.default)(false);
    const mapOptionToDescriptor = (option)=>isStrictOption(option) ? {
            ...option,
            active: option.value === props.value
        } : typeof option === "string" ? {
            label: option,
            value: option,
            active: option === props.value,
            disabled: false
        } : {
            label: option.title,
            value: option.title
        };
    const handleChange = (selected)=>{
        props.onChange && props.onChange(selected[0], "");
        close();
    };
    const options = (0, _react.useMemo)(()=>(props.options || []).map(mapOptionToDescriptor), [
        props.value,
        props.options
    ]);
    const label = props.label;
    const activator = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        onClick: toggle,
        size: "slim",
        plain: true,
        loading: loading,
        disabled: props.disabled,
        disclosure: active ? "up" : "down",
        children: label
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Popover), {
        active: active,
        activator: activator,
        onClose: close,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.OptionList), {
            options: options,
            onChange: handleChange,
            selected: props.value ? [
                props.value
            ] : []
        })
    });
};
exports.default = PlainSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c3ucx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _companySvg = require("../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _personSvg = require("../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _plusMajorWhiteSvg = require("../../../assets/icons/plus-major-white.svg");
var _plusMajorWhiteSvgDefault = parcelHelpers.interopDefault(_plusMajorWhiteSvg);
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
const RegisterCustomerDropdownMenu = (props)=>{
    const { readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const personOnboardingPath = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).ONBOARDING_NEW_PERSON);
    const companyOnboardingPath = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_LOOKUP);
    const items = [
        {
            content: f("nav-bar.new-customer.person"),
            url: personOnboardingPath,
            disabled: readonly,
            image: (0, _personSvgDefault.default)
        },
        {
            content: f("nav-bar.new-customer.company"),
            url: companyOnboardingPath,
            disabled: readonly,
            image: (0, _companySvgDefault.default)
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
        items: items,
        icon: (0, _plusMajorWhiteSvgDefault.default),
        title: f("nav-bar.new-customer"),
        disabled: readonly,
        primary: true,
        size: "medium"
    });
};
exports.default = RegisterCustomerDropdownMenu;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../../../assets/icons/company.svg":"luBbc","../../../assets/icons/person.svg":"1Xt5L","../../../assets/icons/plus-major-white.svg":"5HqsJ","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../ActionsDropdown/ActionsDropdown":"izRYG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hMjQd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tree = require("../Tree/Tree");
var _treeDefault = parcelHelpers.interopDefault(_tree);
var _relatedSearchResult = require("./RelatedSearchResult");
var _relatedSearchResultDefault = parcelHelpers.interopDefault(_relatedSearchResult);
var _useRelatedSearchResults = require("./useRelatedSearchResults");
var _useRelatedSearchResultsDefault = parcelHelpers.interopDefault(_useRelatedSearchResults);
const RelatedSearchResults = (props)=>{
    const { searchResults, searchTerm } = props;
    const { searchResultsToDisplay } = (0, _useRelatedSearchResultsDefault.default)(searchResults);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _treeDefault.default), {
        vOffset: 8,
        children: searchResultsToDisplay.map((relatedSearchResult)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _treeDefault.default).Item, {
                disabled: relatedSearchResult.archived,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _relatedSearchResultDefault.default), {
                    searchResult: relatedSearchResult,
                    searchTerm: searchTerm
                })
            }, relatedSearchResult.id))
    });
};
exports.default = RelatedSearchResults;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../Tree/Tree":"9UFco","./RelatedSearchResult":"8FsA9","./useRelatedSearchResults":"h1B0c","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9UFco":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const Tree = (props)=>{
    const { children, vOffset = 0, ...rest } = props;
    return(// @ts-ignore
    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTree, {
        ...rest,
        style: {
            "--v-offset": vOffset + "px"
        },
        children: children
    }));
};
const StyledTree = (0, _styledComponentsDefault.default).ul`
  list-style: none;
  padding-left: var(--p-space-6);
  margin-bottom: 0;
`;
Tree.Item = (0, _styledComponentsDefault.default).li`
  position: relative;
  --border-style: ${({ disabled })=>disabled ? "dotted" : "solid"};

  &:last-of-type::before {
    border-bottom-left-radius: ${({ disabled })=>disabled ? "0" : "var(--p-border-radius-05)"};
  }

  // draw the |_ tree line before the element
  &::before {
    content: "";
    position: absolute;
    top: calc(-1 * var(--v-offset));
    height: ${({ disabled })=>disabled ? "calc(50% - var(--p-border-width-1))" : "50%"};
    width: 1rem;
    left: -1rem;

    border-bottom: var(--p-border-dark);
    border-left: var(--p-border-dark);
    border-width: var(--p-border-width-2);
    border-bottom-style: var(--border-style);
    border-left-style: var(--border-style);
  }

  // for adjacent elements, extend the height of the vertical line tree line so it will intersect with the element
  // above it (this creating the illusion of a continuous line)
  // |
  // |_
  & + &::before {
    top: calc(-50% - var(--v-offset) + 2 * var(--p-border-width-2));
    height: calc(100% - 2 * var(--p-border-width-2));
  }
`;
exports.default = Tree;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8FsA9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useDisplayName = require("../../hooks/useDisplayName");
var _useDisplayNameDefault = parcelHelpers.interopDefault(_useDisplayName);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _position = require("../Position/Position");
var _positionDefault = parcelHelpers.interopDefault(_position);
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
var _relatedSearchResultsHelpers = require("./RelatedSearchResults.helpers");
const RelatedSearchResult = (props)=>{
    const { searchResult, searchTerm } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const formatDisplayName = (0, _useDisplayNameDefault.default)();
    const searchWords = searchTerm ? searchTerm.split(" ") : [];
    const typesLabel = searchResult.types.join(", ") + (searchResult.archived ? ` (${f("default.expired")})` : "");
    const displayName = formatDisplayName(searchResult);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _displayNameDefault.default), {
        type: "person",
        subdued: searchResult.archived,
        subtitle: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _positionDefault.default), {
            title: typesLabel,
            children: typesLabel
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTextHighlighter, {
                style: {
                    "--text-color": searchResult.archived ? "var(--p-text-subdued)" : "inherit"
                },
                searchWords: searchWords,
                textToHighlight: displayName,
                title: displayName
            }),
            (0, _relatedSearchResultsHelpers.isRelatedSearchUBO)(searchResult) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                size: "xsmall",
                status: "warning",
                children: f("common.labels.ubo")
            })
        ]
    });
};
const StyledTextHighlighter = (0, _styledComponentsDefault.default)((0, _textHighlighterDefault.default))`
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-color);
`;
exports.default = RelatedSearchResult;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","../../hooks/useDisplayName":"aWMpm","../../hooks/useFormatMessage":"8Y8fq","../DisplayName/DisplayName":"gKd5g","../extensions/Badge":"9irVp","../Position/Position":"kTPkn","../TextHighlighter/TextHighlighter":"43Xhz","./RelatedSearchResults.helpers":"j33S0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j33S0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRelatedRole", ()=>isRelatedRole);
parcelHelpers.export(exports, "isRelatedSearchUBO", ()=>isRelatedSearchUBO);
parcelHelpers.export(exports, "getRelatedRoleOrOwnerKey", ()=>getRelatedRoleOrOwnerKey);
var _personHelpers = require("../../helpers/person.helpers");
const isRelatedRole = (relatedData)=>{
    return relatedData.result_type === "ROLE";
};
const isRelatedSearchUBO = (searchResult)=>!isRelatedRole(searchResult) && (0, _personHelpers.isUBO)(searchResult);
const getRelatedRoleOrOwnerKey = (entity)=>(0, _personHelpers.getPersonKey)(entity);

},{"../../helpers/person.helpers":"6qOIE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h1B0c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _roleTypes = require("../../constants/role-types");
var _roleTypesDefault = parcelHelpers.interopDefault(_roleTypes);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../utils/collectionUtils");
var _relatedSearchResultsHelpers = require("./RelatedSearchResults.helpers");
const useRelatedSearchResults = (searchResults)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const searchResultsToDisplay = (0, _react.useMemo)(()=>{
        const entitiesMap = (0, _collectionUtils.groupBy)(searchResults, (0, _relatedSearchResultsHelpers.getRelatedRoleOrOwnerKey));
        const entitiesToDisplay = [
            ...entitiesMap.values()
        ].map((entities)=>({
                ...Object.assign({}, ...entities),
                types: entities.map((role)=>(0, _relatedSearchResultsHelpers.isRelatedRole)(role) ? f((0, _roleTypesDefault.default)[role.type]) : f("table.row.owner"))
            }));
        return entitiesToDisplay;
    }, [
        searchResults
    ]);
    return {
        searchResultsToDisplay
    };
};
exports.default = useRelatedSearchResults;

},{"react":"cOWTg","../../constants/role-types":"fAycz","../../hooks/useFormatMessage":"8Y8fq","../../utils/collectionUtils":"gr5mc","./RelatedSearchResults.helpers":"j33S0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hYOXE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactTable = require("@tanstack/react-table");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _customDate = require("../components/CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _customerName = require("../components/CustomerName/CustomerName");
var _customerNameDefault = parcelHelpers.interopDefault(_customerName);
var _customerApprovalStatus = require("../components/CustomerStatus/CustomerApprovalStatus");
var _customerApprovalStatusDefault = parcelHelpers.interopDefault(_customerApprovalStatus);
var _customerPendingTaskStatus = require("../components/CustomerStatus/CustomerPendingTaskStatus");
var _customerPendingTaskStatusDefault = parcelHelpers.interopDefault(_customerPendingTaskStatus);
var _multipleUsersInitials = require("../components/MultipleUsersInitials/MultipleUsersInitials");
var _multipleUsersInitialsDefault = parcelHelpers.interopDefault(_multipleUsersInitials);
var _pendingTasksButton = require("../components/PendingTasksButton/PendingTasksButton");
var _pendingTasksButtonDefault = parcelHelpers.interopDefault(_pendingTasksButton);
var _risk = require("../components/Risk/Risk");
var _riskDefault = parcelHelpers.interopDefault(_risk);
var _tableColumnHeader = require("../components/TableColumnHeader/TableColumnHeader");
var _tableColumnHeaderDefault = parcelHelpers.interopDefault(_tableColumnHeader);
var _tooltipWrapper = require("../components/TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _pagination = require("../constants/pagination");
var _styles = require("../constants/styles");
var _displayHelpers = require("../helpers/display.helpers");
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useCustomersTableColumns = (searchTerm, haveOwnershipUpdates, nameColumnChildren)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const columnHelper = (0, _reactTable.createColumnHelper)();
    const tableColumns = [
        columnHelper.accessor((row)=>(0, _displayHelpers.getCustomerName)(row).toLowerCase(), {
            header: f("customers.list.column.customer"),
            id: (0, _pagination.SORT_BY_NAME_PARAMETER),
            enableSorting: true,
            cell: (props)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    blockAlign: "baseline",
                    wrap: false,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCustomerApprovalStatus, {
                            customer: props.row.original
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTruncatedWrapper, {
                            maxWidth: "var(--kdk-column-max-width)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerNameDefault.default), {
                                customer: props.row.original,
                                searchTerm: searchTerm,
                                children: nameColumnChildren && nameColumnChildren(props.row.original)
                            })
                        })
                    ]
                });
            }
        }),
        columnHelper.accessor("review_status", {
            header: f("customers.list.column.tasks"),
            enableSorting: false,
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "2",
                    inlineAlign: "start",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTruncatedWrapper, {
                            maxWidth: "var(--kdk-column-max-width)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerPendingTaskStatusDefault.default), {
                                customer: props.row.original,
                                haveOwnershipUpdates: haveOwnershipUpdates
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pendingTasksButtonDefault.default), {
                            customer: props.row.original,
                            haveOwnershipUpdates: haveOwnershipUpdates
                        })
                    ]
                })
        }),
        features.RESPONSIBLE_USER ? columnHelper.accessor("responsible_users", {
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableColumnHeaderDefault.default), {
                    children: f("customers.list.column.responsible.users")
                }),
            meta: {
                label: f("customers.list.column.responsible.users")
            },
            enableSorting: false,
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multipleUsersInitialsDefault.default), {
                    users: props.getValue() || [],
                    responsive: true
                })
        }) : undefined,
        features.EXTERNAL_ID ? columnHelper.accessor("external_id", {
            header: f("customers.list.column.external-id"),
            enableSorting: false,
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                    content: f("customers.list.external-id.tooltip", {
                        id: props.getValue()
                    }),
                    preferredPosition: "above",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTruncatedWrapper, {
                        title: props.getValue(),
                        maxWidth: "7rem",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            truncate: true,
                            children: props.getValue()
                        })
                    })
                })
        }) : undefined,
        columnHelper.accessor("risk_level", {
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCenteredCell, {
                    children: f("customers.list.column.risk")
                }),
            meta: {
                label: f("customers.list.column.risk"),
                centered: true
            },
            enableSorting: false,
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDefault.default), {
                    risk: props.row.original.risk_level
                })
        }),
        columnHelper.accessor((row)=>new Date(row.created), {
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableColumnHeaderDefault.default), {
                    centered: true,
                    children: f("customers.list.column.added")
                }),
            meta: {
                label: f("customers.list.column.added")
            },
            id: (0, _pagination.SORT_BY_ADDED_DATE_PARAMETER),
            enableSorting: true,
            sortingFn: "datetime",
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                        date: props.row.original.created
                    })
                })
        })
    ].filter(Boolean);
    return tableColumns;
};
const StyledTruncatedWrapper = (0, _styledComponentsDefault.default).div`
  max-width: ${({ maxWidth })=>maxWidth};
`;
const StyledCenteredCell = (0, _styledComponentsDefault.default).div`
  text-align: center;
`;
const StyledCustomerApprovalStatus = (0, _styledComponentsDefault.default)((0, _customerApprovalStatusDefault.default))`
  margin-left: calc(-1 * var(--p-space-4));
  padding-bottom: var(--p-space-05);

  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    margin-left: 0;
  }
`;
exports.default = useCustomersTableColumns;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-table":"86D8M","styled-components":"eBrdC","../components/CustomDate/CustomDate":"5KD00","../components/CustomerName/CustomerName":"iIQjm","../components/CustomerStatus/CustomerApprovalStatus":"54xm8","../components/CustomerStatus/CustomerPendingTaskStatus":"dKhIl","../components/MultipleUsersInitials/MultipleUsersInitials":"2srna","../components/PendingTasksButton/PendingTasksButton":"aMHTv","../components/Risk/Risk":"9VLEF","../components/TableColumnHeader/TableColumnHeader":"6jCSM","../components/TooltipWrapper/TooltipWrapper":"b5W2d","../constants/pagination":"e05H0","../constants/styles":"dZWds","../helpers/display.helpers":"2q3xY","./useFeatures":"hvBWb","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iIQjm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _displayHelpers = require("../../helpers/display.helpers");
var _useCustomerPath = require("../../hooks/useCustomerPath");
var _useCustomerPathDefault = parcelHelpers.interopDefault(_useCustomerPath);
var _utilities = require("../../types/utilities");
var _archivedBadge = require("../ArchivedBadge/ArchivedBadge");
var _archivedBadgeDefault = parcelHelpers.interopDefault(_archivedBadge);
var _badges = require("../Badges/Badges");
var _badgesDefault = parcelHelpers.interopDefault(_badges);
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _displayTagsWrapper = require("../DisplayTagsWrapper/DisplayTagsWrapper");
var _displayTagsWrapperDefault = parcelHelpers.interopDefault(_displayTagsWrapper);
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
const CustomerName = (props)=>{
    const { customer, searchTerm, children } = props;
    const { getCustomerPath } = (0, _useCustomerPathDefault.default)();
    const customerName = (0, _displayHelpers.getCustomerName)(customer);
    const url = getCustomerPath(customer.id, customer.type, customer.onboarding_status, (0, _utilities.isManualCompany)(customer));
    const searchWords = searchTerm ? searchTerm.split(" ") : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayTagsWrapperDefault.default), {
                tags: customer.labels,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                    type: customer.type,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                        url: url,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                            searchWords: searchWords,
                            textToHighlight: customerName
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgesDefault.default), {
                isPep: customer.is_pep,
                isSanctioned: customer.is_sanctioned,
                children: customer.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archivedBadgeDefault.default), {
                    customer: customer
                })
            }),
            children
        ]
    });
};
exports.default = CustomerName;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/display.helpers":"2q3xY","../../hooks/useCustomerPath":"gJfCj","../../types/utilities":"6zLpB","../ArchivedBadge/ArchivedBadge":"8eATJ","../Badges/Badges":"cI72s","../DisplayName/DisplayName":"gKd5g","../DisplayTagsWrapper/DisplayTagsWrapper":"2idSA","../TextHighlighter/TextHighlighter":"43Xhz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dKhIl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useCustomerPendingTasks = require("../../hooks/useCustomerPendingTasks");
var _useCustomerPendingTasksDefault = parcelHelpers.interopDefault(_useCustomerPendingTasks);
var _stringUtils = require("../../utils/stringUtils");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _status = require("../Status/Status");
var _statusDefault = parcelHelpers.interopDefault(_status);
const CustomerPendingTaskStatus = (props)=>{
    const { customer, haveOwnershipUpdates } = props;
    const taskStatuses = (0, _useCustomerPendingTasksDefault.default)(customer, haveOwnershipUpdates);
    if (taskStatuses.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        children: "-"
    });
    const topTaskStatus = taskStatuses[0];
    const hasSubtitle = !(0, _stringUtils.isEmptyString)(topTaskStatus.subtitle);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusDefault.default), {
                title: topTaskStatus.title,
                icon: topTaskStatus.icon
            }),
            hasSubtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTruncatedText, {
                title: topTaskStatus.subtitle,
                children: topTaskStatus.subtitle
            })
        ]
    });
};
const StyledTruncatedText = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
exports.default = CustomerPendingTaskStatus;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useCustomerPendingTasks":"lrfps","../../utils/stringUtils":"4gVdA","../CondensedText/CondensedText":"1FshD","../Status/Status":"7QUNV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lrfps":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pendingTasksHelpers = require("../helpers/pending-tasks.helpers");
var _usePendingTask = require("./usePendingTask");
var _usePendingTaskDefault = parcelHelpers.interopDefault(_usePendingTask);
const useCustomerPendingTasks = (customer, haveOwnershipUpdates)=>{
    const getPendingTaskStatuses = (0, _usePendingTaskDefault.default)(customer);
    if (!(0, _pendingTasksHelpers.hasPendingTasks)(customer)) return [];
    const pendingTasks = customer.pending_tasks;
    if (!pendingTasks || pendingTasks.length === 0 || pendingTasks[0] === undefined) return [];
    // if haveOwnershipUpdates is true then try to return the "REVIEW_OWNERSHIP_UPDATES" task first
    const topPendingTask = haveOwnershipUpdates && pendingTasks.length > 1 ? pendingTasks.find((task)=>task.type === "REVIEW_OWNERSHIP_UPDATES") || pendingTasks[0] : pendingTasks[0];
    return getPendingTaskStatuses(topPendingTask);
};
exports.default = useCustomerPendingTasks;

},{"../helpers/pending-tasks.helpers":"dLOfL","./usePendingTask":"41VLN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7QUNV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const Status = (props)=>{
    const { title = "", subtitle, icon, size = "12px" } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        alignment: "center",
        spacing: "extraTight",
        wrap: false,
        children: [
            icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: icon,
                width: size,
                height: size
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                fill: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            truncate: true,
                            children: title
                        }),
                        subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                            children: subtitle
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = Status;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aMHTv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useCustomerPendingTasks = require("../../hooks/useCustomerPendingTasks");
var _useCustomerPendingTasksDefault = parcelHelpers.interopDefault(_useCustomerPendingTasks);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const PendingTasksButton = (props)=>{
    const { customer, haveOwnershipUpdates } = props;
    const taskStatuses = (0, _useCustomerPendingTasksDefault.default)(customer, haveOwnershipUpdates);
    if (taskStatuses.length === 0) return null;
    // TODO render as Split button if there is more than 1 task statuses
    const topTaskStatus = taskStatuses[0];
    const { url, urlLabel } = topTaskStatus;
    if (url && urlLabel) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        size: "slim",
        url: url,
        children: urlLabel
    });
    return null;
};
exports.default = PendingTasksButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useCustomerPendingTasks":"lrfps","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6jCSM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const TableColumnHeader = (props)=>{
    const { centered, minWidth, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableHeaderCell, {
        centered: centered,
        minWidth: minWidth,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            color: "subdued",
            children: children
        })
    });
};
const StyledTableHeaderCell = (0, _styledComponentsDefault.default).div`
  white-space: normal;
  text-align: ${({ centered })=>centered ? "center" : "inherited"};
  min-width: ${({ minWidth })=>minWidth || "auto"};
`;
exports.default = TableColumnHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i8gbg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * Save selected entities in addition to selected ids
 *
 * This hook is used to save the selected entities when navigating between pages in a paginated table
 *
 * @param entities a list of all the entities (not just selected) that are currently available
 */ const useSelectionMap = (entities)=>{
    const [selectedIds, setSelectedIds] = (0, _react.useState)([]);
    // entities will change when moving to another page so save all previous entities in a ref
    const allEntities = (0, _react.useRef)({});
    (0, _react.useEffect)(()=>{
        allEntities.current = {
            ...allEntities.current,
            ...Object.fromEntries(entities.map((entity)=>[
                    entity.id,
                    entity
                ]))
        };
    }, [
        entities.map((entity)=>entity.id)
    ]);
    const clearSelection = (0, _react.useCallback)(()=>setSelectedIds([]), []);
    const selectedEntities = (0, _react.useMemo)(()=>selectedIds.map((entityId)=>allEntities.current[entityId]), [
        selectedIds
    ]);
    return [
        selectedIds,
        selectedEntities,
        setSelectedIds,
        clearSelection
    ];
};
exports.default = useSelectionMap;

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4AZ8h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useRestoreLastWindowLocationSearch = require("../../components/CustomersListFilters/useRestoreLastWindowLocationSearch");
var _useRestoreLastWindowLocationSearchDefault = parcelHelpers.interopDefault(_useRestoreLastWindowLocationSearch);
var _dashboardFilters = require("../../components/DashboardFilters/DashboardFilters");
var _dashboardFiltersDefault = parcelHelpers.interopDefault(_dashboardFilters);
var _queriesKeys = require("../../constants/queries-keys");
var _sessionState = require("../../constants/session-state");
var _useDashboardParams = require("../../hooks/useDashboardParams");
var _useDashboardParamsDefault = parcelHelpers.interopDefault(_useDashboardParams);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _errorPage = require("../ErrorPage");
var _errorPageDefault = parcelHelpers.interopDefault(_errorPage);
var _dashboard = require("./Dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _dashboardPageHelpers = require("./DashboardPage.helpers");
const DashboardPage = ()=>{
    (0, _useRestoreLastWindowLocationSearchDefault.default)((0, _sessionState.DASHBOARD_SEARCH));
    const f = (0, _useFormatMessageDefault.default)();
    const { dashboardParams, ...filters } = (0, _useDashboardParamsDefault.default)();
    const { isLoading, isError, error, data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).DASHBOARD,
        ...Object.values(dashboardParams)
    ], ()=>(0, _apiDefault.default).getDashboard(dashboardParams));
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPageDefault.default), {
        error: error
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "heading2xl",
                        as: "p",
                        children: f("nav-bar.dashboard")
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardFiltersDefault.default), {
                    isLoading: isLoading,
                    ...filters
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardDefault.default), {
                    metrics: isLoading ? (0, _dashboardPageHelpers.EMPTY_DASHBOARD_VALUES) : data,
                    loading: isLoading
                })
            ]
        })
    });
};
exports.default = DashboardPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/CustomersListFilters/useRestoreLastWindowLocationSearch":"3cuOV","../../components/DashboardFilters/DashboardFilters":"fdwoP","../../constants/queries-keys":"6hYSF","../../constants/session-state":"g0N7C","../../hooks/useDashboardParams":"8HUPW","../../hooks/useFormatMessage":"8Y8fq","../ErrorPage":"8Le05","./Dashboard":"aCPA0","./DashboardPage.helpers":"3OHPa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fdwoP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _customersListSearchParams = require("../../constants/customers-list-search-params");
var _filtersHelpers = require("../../helpers/filters.helpers");
var _tagHelpers = require("../../helpers/tag.helpers");
var _useDashboardDateAppliedFilters = require("../../hooks/useDashboardDateAppliedFilters");
var _useDashboardDateAppliedFiltersDefault = parcelHelpers.interopDefault(_useDashboardDateAppliedFilters);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useShowResponsibleUserFilter = require("../../hooks/useShowResponsibleUserFilter");
var _useShowResponsibleUserFilterDefault = parcelHelpers.interopDefault(_useShowResponsibleUserFilter);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _collectionUtils = require("../../utils/collectionUtils");
var _util = require("../../utils/util");
var _appliedFilters = require("../AppliedFilters/AppliedFilters");
var _appliedFiltersDefault = parcelHelpers.interopDefault(_appliedFilters);
var _useFiltersOptions = require("../CustomersListFilters/useFiltersOptions");
var _dashboardDateIntervalFilter = require("../DashboardDateIntervalFilter/DashboardDateIntervalFilter");
var _dashboardDateIntervalFilterDefault = parcelHelpers.interopDefault(_dashboardDateIntervalFilter);
var _tagsFilter = require("../TagsFilter/TagsFilter");
var _tagsFilterDefault = parcelHelpers.interopDefault(_tagsFilter);
var _usersList = require("../UsersList/UsersList");
var _usersListDefault = parcelHelpers.interopDefault(_usersList);
const DashboardFilters = (props)=>{
    const { isLoading, responsibleUserIds, tagIds, customerType, includeArchivedCustomers, setResponsibleUserIds, setTagIds, setCustomerType, setIncludeArchivedCustomers, ...dateFilters } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { findTag } = (0, _useTagsDefault.default)();
    const { getUserFullName } = (0, _useGetUserNameDefault.default)(features.RESPONSIBLE_USER);
    const showResponsibleUserFilter = (0, _useShowResponsibleUserFilterDefault.default)();
    const appliedCreatedDateFilters = (0, _useDashboardDateAppliedFiltersDefault.default)(dateFilters);
    const filters = [];
    const appliedFilters = [];
    filters.push({
        key: "tag",
        label: f("component.filters.tags.title"),
        shortcut: true,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsFilterDefault.default), {
            tagIds: tagIds,
            setTagIds: setTagIds
        })
    });
    // find Tags from ids, filter missing tags, sort by tag title and add to applied filters
    tagIds.map(findTag).filter(Boolean).sort((tagA, tagB)=>(0, _tagHelpers.getTagTitle)(tagB).localeCompare((0, _tagHelpers.getTagTitle)(tagA))).forEach((tag)=>{
        appliedFilters.unshift({
            key: "tag-" + tag.id,
            label: (0, _tagHelpers.getTagTitle)(tag),
            tagColor: tag.color,
            isTag: true,
            onRemove: ()=>setTagIds(tagIds.filter((id)=>id !== tag.id))
        });
    });
    if (showResponsibleUserFilter) filters.push({
        key: "responsible-user",
        label: f("responsible.label"),
        shortcut: true,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersListDefault.default), {
            showAllUsersOption: true,
            selectedUserIds: responsibleUserIds,
            allowMultiple: true,
            onChange: setResponsibleUserIds
        })
    });
    const [customerTypeFilter, customerTypeAppliedFilter] = (0, _filtersHelpers.createFilter)("customer-type", f("component.filter.customer.title"), customerType, false, [
        {
            label: f("component.filters.all.title"),
            value: (0, _useFiltersOptions.ALL_FILTER_ITEM_VALUE)
        },
        {
            label: f("component.filter.customer.option.company.title"),
            value: "COMPANY"
        },
        {
            label: f("component.filter.customer.option.person.title"),
            value: "PERSON"
        }
    ], setCustomerType);
    filters.push(customerTypeFilter);
    if (customerTypeAppliedFilter) appliedFilters.push(customerTypeAppliedFilter);
    const activeCustomersOnlyFilter = {
        key: "active-customers",
        label: f("component.filters.include.archive.title"),
        shortcut: true,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ChoiceList), {
            title: f("component.filters.include.archive.title"),
            titleHidden: true,
            choices: [
                {
                    label: f("component.filters.include.archive.title"),
                    value: (0, _customersListSearchParams.INCLUDE_ARCHIVED_CUSTOMERS_NAME_PARAMETER)
                }
            ],
            allowMultiple: true,
            selected: includeArchivedCustomers ? [
                (0, _customersListSearchParams.INCLUDE_ARCHIVED_CUSTOMERS_NAME_PARAMETER)
            ] : [],
            onChange: (selected)=>setIncludeArchivedCustomers(selected.includes((0, _customersListSearchParams.INCLUDE_ARCHIVED_CUSTOMERS_NAME_PARAMETER)))
        })
    };
    filters.push(activeCustomersOnlyFilter);
    if (includeArchivedCustomers) appliedFilters.push({
        key: "active-customers",
        label: f("component.filters.include.archive.title"),
        onRemove: ()=>setIncludeArchivedCustomers(false)
    });
    const dateFilter = {
        key: "date-interval",
        label: f("dashboard.filters.date.title"),
        shortcut: true,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardDateIntervalFilterDefault.default), {
            isLoading: isLoading,
            ...dateFilters
        })
    };
    filters.push(dateFilter);
    appliedFilters.push(...responsibleUserIds.map((userId)=>({
            key: "responsible-user",
            label: `${f("responsible.label")}: ${getUserFullName(userId)}`,
            onRemove: ()=>setResponsibleUserIds((0, _collectionUtils.toggleElement)(responsibleUserIds, userId))
        })));
    appliedFilters.push(...appliedCreatedDateFilters);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        inlineAlign: "stretch",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Filters), {
                queryValue: "",
                filters: filters,
                appliedFilters: appliedFilters,
                hideTags: true,
                hideQueryField: true,
                onQueryChange: (0, _util.noop),
                onQueryClear: (0, _util.noop),
                onClearAll: (0, _util.noop)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appliedFiltersDefault.default), {
                appliedFilters: appliedFilters
            })
        ]
    });
};
exports.default = DashboardFilters;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../constants/customers-list-search-params":"9nE5m","../../helpers/filters.helpers":"1yvvL","../../helpers/tag.helpers":"ecpII","../../hooks/useDashboardDateAppliedFilters":"57KnP","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useShowResponsibleUserFilter":"khaJz","../../hooks/useTags":"31uzS","../../utils/collectionUtils":"gr5mc","../../utils/util":"4MniK","../AppliedFilters/AppliedFilters":"b9vWr","../CustomersListFilters/useFiltersOptions":"duoqc","../DashboardDateIntervalFilter/DashboardDateIntervalFilter":"h41YU","../TagsFilter/TagsFilter":"48hmU","../UsersList/UsersList":"dqxGe","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"57KnP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactIntl = require("react-intl");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useDashboardDateAppliedFilters = (props)=>{
    const { dateInterval, startDate, endDate, setDateInterval, setStartDate, setEndDate } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatDate } = (0, _reactIntl.useIntl)();
    const appliedCreatedDateFilters = [];
    if (dateInterval && dateInterval !== "CUSTOM_DATE_RANGE") appliedCreatedDateFilters.push({
        key: "date-interval",
        label: f(`dashboard.filters.date.interval.${dateInterval}`),
        onRemove: ()=>setDateInterval(undefined)
    });
    if (startDate && dateInterval === "CUSTOM_DATE_RANGE") appliedCreatedDateFilters.push({
        key: "start-date",
        label: f("dashboard.filters.date.from", {
            date: formatDate(startDate)
        }),
        onRemove: ()=>{
            setStartDate(undefined);
            if (!endDate) setDateInterval(undefined);
        }
    });
    if (endDate && dateInterval === "CUSTOM_DATE_RANGE") appliedCreatedDateFilters.push({
        key: "end-date",
        label: f("dashboard.filters.date.until", {
            date: formatDate(endDate)
        }),
        onRemove: ()=>{
            setEndDate(undefined);
            if (!startDate) setDateInterval(undefined);
        }
    });
    return appliedCreatedDateFilters;
};
exports.default = useDashboardDateAppliedFilters;

},{"react-intl":"8H1wU","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h41YU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _dateInput = require("../DateInput/DateInput");
var _dateInputDefault = parcelHelpers.interopDefault(_dateInput);
const MIN_DATE = new Date("2020-01-01");
const MAX_DATE = new Date();
const INTERVAL_OPTIONS = [
    "DAILY",
    "WEEKLY",
    "MONTHLY",
    "QUARTERLY",
    "ANNUALLY",
    "CUSTOM_DATE_RANGE"
];
const DashboardDateIntervalFilter = (props)=>{
    const { isLoading, dateInterval, startDate, endDate, setDateInterval, setStartDate, setEndDate } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                name: "date-interval",
                label: f("component.filters.all.title"),
                disabled: isLoading,
                checked: (0, _stringUtils.isEmptyString)(dateInterval),
                onChange: ()=>setDateInterval(undefined)
            }),
            INTERVAL_OPTIONS.map((rangeOption)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                    name: "date-interval",
                    label: f(`dashboard.filters.date.interval.${rangeOption}`),
                    disabled: isLoading,
                    checked: dateInterval === rangeOption,
                    onChange: ()=>setDateInterval(rangeOption)
                }, rangeOption)),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                        label: f("dashboard.filters.date.from", {
                            date: ""
                        }),
                        value: startDate || "",
                        onChange: setStartDate,
                        maxDate: MAX_DATE,
                        minDate: MIN_DATE,
                        disabled: isLoading || dateInterval !== "CUSTOM_DATE_RANGE",
                        autoComplete: "off"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateInputDefault.default), {
                        label: f("dashboard.filters.date.until", {
                            date: ""
                        }),
                        value: endDate || "",
                        onChange: setEndDate,
                        maxDate: MAX_DATE,
                        minDate: MIN_DATE,
                        disabled: isLoading || dateInterval !== "CUSTOM_DATE_RANGE",
                        autoComplete: "off"
                    })
                ]
            })
        ]
    });
};
exports.default = DashboardDateIntervalFilter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../DateInput/DateInput":"6BAM5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8HUPW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _customersListSearchParams = require("../constants/customers-list-search-params");
var _filters = require("../constants/filters");
var _pagination = require("../constants/pagination");
var _dateUtils = require("../utils/dateUtils");
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
var _useAuth = require("./useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useURLSearchParam = require("./useURLSearchParam");
const useDashboardParams = ()=>{
    const { user } = (0, _useAuthDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const [responsibleUserIds, setResponsibleUserIds] = (0, _useURLSearchParam.useURLSearchParams)((0, _customersListSearchParams.RESPONSIBLE_USERS_NAME_PARAMETER));
    const [tagIds, setTagIds] = (0, _useURLSearchParam.useURLSearchParams)((0, _customersListSearchParams.TAGS_NAME_PARAMETER));
    const [customerType, setCustomerType] = (0, _useURLSearchParam.useURLSearchParam)((0, _customersListSearchParams.CUSTOMER_TYPE_NAME_PARAMETER));
    const [includeArchivedCustomers, setIncludeArchivedCustomers] = (0, _useURLSearchParam.useBooleanURLSearchParam)((0, _customersListSearchParams.INCLUDE_ARCHIVED_CUSTOMERS_NAME_PARAMETER));
    const [dateInterval, setDateInterval] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.DASHBOARD_INTERVAL_NAME_PARAMETER));
    const [startDate, setStartDate] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.DASHBOARD_START_NAME_PARAMETER));
    const [endDate, setEndDate] = (0, _useURLSearchParam.useURLSearchParam)((0, _pagination.DASHBOARD_END_NAME_PARAMETER));
    (0, _react.useEffect)(()=>{
        if (!user || !features.RESPONSIBLE_USER) return;
        // if the users is a "plain" user (without groups) and there are no responsible users ids as parameters
        // set the default responsible user id to be the current user
        const useCurrentUserId = user.groups.length === 0 && responsibleUserIds.length === 0;
        if (useCurrentUserId) setResponsibleUserIds([
            user.id
        ]);
    }, [
        user,
        features.RESPONSIBLE_USER
    ]);
    const validStartDate = (0, _dateUtils.isValidDate)(startDate, (0, _filters.MIN_DATE_FILTER), (0, _filters.MAX_DATE_FILTER)) ? startDate : undefined;
    const validEndDate = (0, _dateUtils.isValidDate)(endDate, (0, _filters.MIN_DATE_FILTER), (0, _filters.MAX_DATE_FILTER)) ? endDate : undefined;
    const dashboardParams = (0, _util.removeEmptyValues)({
        responsibleUserIds,
        labelIds: tagIds,
        customerType: customerType,
        includeArchivedCustomers,
        interval: dateInterval,
        // do not change params (and trigger a re-fetch from the API) until dates are valid
        startDate: validStartDate,
        endDate: validEndDate
    });
    // do not send "CUSTOM_DATE_RANGE" if there are no start date or end date set
    if (dateInterval === "CUSTOM_DATE_RANGE" && (0, _stringUtils.isEmptyString)(validStartDate) && (0, _stringUtils.isEmptyString)(validEndDate)) delete dashboardParams["interval"];
    const isEmptySearch = tagIds.length === 0 && responsibleUserIds.length === 0 && (0, _stringUtils.isEmptyString)(customerType) && (0, _stringUtils.isEmptyString)(dateInterval) && (0, _stringUtils.isEmptyString)(validStartDate) && (0, _stringUtils.isEmptyString)(validEndDate);
    const resetAllFilters = ()=>{
        setResponsibleUserIds([]);
        setTagIds([]);
        setCustomerType(undefined);
        setIncludeArchivedCustomers(undefined);
        setDateInterval(undefined);
        setStartDate(undefined);
        setEndDate(undefined);
    };
    return {
        responsibleUserIds,
        setResponsibleUserIds,
        tagIds,
        setTagIds,
        customerType,
        setCustomerType,
        includeArchivedCustomers,
        setIncludeArchivedCustomers,
        dateInterval,
        setDateInterval,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        dashboardParams,
        isEmptySearch,
        resetAllFilters
    };
};
exports.default = useDashboardParams;

},{"react":"cOWTg","../constants/customers-list-search-params":"9nE5m","../constants/filters":"94mf3","../constants/pagination":"e05H0","../utils/dateUtils":"euvUV","../utils/stringUtils":"4gVdA","../utils/util":"4MniK","./useAuth":"k9r0q","./useFeatures":"hvBWb","./useURLSearchParam":"5Oncb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aCPA0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useDashboardParams = require("../../hooks/useDashboardParams");
var _useDashboardParamsDefault = parcelHelpers.interopDefault(_useDashboardParams);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _customersByIndustryTypeWidget = require("./CustomersByIndustryTypeWidget/CustomersByIndustryTypeWidget");
var _customersByIndustryTypeWidgetDefault = parcelHelpers.interopDefault(_customersByIndustryTypeWidget);
var _riskDataWidget = require("./RiskDataWidget/RiskDataWidget");
var _riskDataWidgetDefault = parcelHelpers.interopDefault(_riskDataWidget);
var _customersByReviewStatusWidget = require("./CustomersByReviewStatusWidget");
var _customersByReviewStatusWidgetDefault = parcelHelpers.interopDefault(_customersByReviewStatusWidget);
var _customersByRiskWidget = require("./CustomersByRiskWidget");
var _customersByRiskWidgetDefault = parcelHelpers.interopDefault(_customersByRiskWidget);
var _customersByTypeWidget = require("./CustomersByTypeWidget");
var _customersByTypeWidgetDefault = parcelHelpers.interopDefault(_customersByTypeWidget);
var _customersMarkedAsPepWidget = require("./CustomersMarkedAsPepWidget");
var _customersMarkedAsPepWidgetDefault = parcelHelpers.interopDefault(_customersMarkedAsPepWidget);
var _customersMarkedAsSanctionedWidget = require("./CustomersMarkedAsSanctionedWidget");
var _customersMarkedAsSanctionedWidgetDefault = parcelHelpers.interopDefault(_customersMarkedAsSanctionedWidget);
var _customersWithPendingTasksWidget = require("./CustomersWithPendingTasksWidget");
var _customersWithPendingTasksWidgetDefault = parcelHelpers.interopDefault(_customersWithPendingTasksWidget);
const Dashboard = (props)=>{
    const { metrics, loading } = props;
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { customerType } = (0, _useDashboardParamsDefault.default)();
    const { customers_active_count, customers_pep_count, customers_pep_count_by_customer_type, customers_sanctioned_count, customers_sanctioned_count_by_customer_type, customers_with_pending_tasks_count, customers_count_by_risk_level, customers_count_by_customer_type, customers_count_by_review_status, customers_count_by_industry_code, customers_count_by_risk_data, assignments_count_by_risk_data } = metrics;
    const showIndustriesWidget = customerType !== "PERSON";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledColumnsContainer, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Grid), {
            columns: {
                xs: 1,
                sm: 2,
                lg: 3
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersWithPendingTasksWidgetDefault.default), {
                    loading: loading,
                    customersWithPendingTasksCount: customers_with_pending_tasks_count
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersByRiskWidgetDefault.default), {
                    values: customers_count_by_risk_level,
                    customersCount: customers_active_count,
                    loading: loading
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersMarkedAsPepWidgetDefault.default), {
                    loading: loading,
                    values: customers_pep_count_by_customer_type,
                    total: customers_pep_count,
                    customersCount: customers_active_count
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersByTypeWidgetDefault.default), {
                    values: customers_count_by_customer_type,
                    customersCount: customers_active_count,
                    loading: loading
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersByReviewStatusWidgetDefault.default), {
                    values: customers_count_by_review_status,
                    total: customers_active_count,
                    loading: loading
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersMarkedAsSanctionedWidgetDefault.default), {
                    loading: loading,
                    values: customers_sanctioned_count_by_customer_type,
                    total: customers_sanctioned_count,
                    customersCount: customers_active_count
                }),
                showIndustriesWidget && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Grid).Cell, {
                    columnSpan: {
                        xs: 1,
                        md: 3
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersByIndustryTypeWidgetDefault.default), {
                        loading: loading,
                        industries: customers_count_by_industry_code.metrics,
                        categories: customers_count_by_industry_code.categories,
                        customersCount: customers_count_by_customer_type.COMPANY
                    })
                }),
                features.REAL_ESTATE && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Grid).Cell, {
                    columnSpan: {
                        xs: 1,
                        md: 3
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataWidgetDefault.default), {
                        title: f("dashboard.widgets.risk-data.by.customer.title"),
                        infoTooltip: f("dashboard.widgets.risk-data.by.customer.tooltip"),
                        riskData: customers_count_by_risk_data,
                        loading: loading
                    })
                }),
                features.VITEC_CREATE_VITEC_SPECIFIC_ASSIGNMENTS && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Grid).Cell, {
                    columnSpan: {
                        xs: 1,
                        md: 3
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataWidgetDefault.default), {
                        title: f("dashboard.widgets.risk-data.by.assignment.title"),
                        infoTooltip: f("dashboard.widgets.risk-data.by.assignment.tooltip"),
                        riskData: assignments_count_by_risk_data,
                        loading: loading
                    })
                })
            ]
        })
    });
};
const StyledColumnsContainer = (0, _styledComponentsDefault.default).div`
  & > .Polaris-Grid > .Polaris-Card + .Polaris-Card {
    margin-top: 0;
  }
`;
exports.default = Dashboard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useDashboardParams":"8HUPW","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","./CustomersByIndustryTypeWidget/CustomersByIndustryTypeWidget":"lE0ZZ","./RiskDataWidget/RiskDataWidget":"hIWpH","./CustomersByReviewStatusWidget":"aAlfo","./CustomersByRiskWidget":"762eb","./CustomersByTypeWidget":"9WVyN","./CustomersMarkedAsPepWidget":"bTNyD","./CustomersMarkedAsSanctionedWidget":"bTllM","./CustomersWithPendingTasksWidget":"55u82","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lE0ZZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactFlipMove = require("react-flip-move");
var _reactFlipMoveDefault = parcelHelpers.interopDefault(_reactFlipMove);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _chevronLeftSvg = require("../../../../assets/icons/chevron-left.svg");
var _chevronLeftSvgDefault = parcelHelpers.interopDefault(_chevronLeftSvg);
var _condensedText = require("../../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _pieChart = require("../../../components/PieChart/PieChart");
var _pieChartDefault = parcelHelpers.interopDefault(_pieChart);
var _searchTextField = require("../../../components/SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _textHighlighter = require("../../../components/TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
var _styles = require("../../../constants/styles");
var _displayHelpers = require("../../../helpers/display.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _stringUtils = require("../../../utils/stringUtils");
var _dashboardColorBlock = require("../DashboardColorBlock");
var _dashboardColorBlockDefault = parcelHelpers.interopDefault(_dashboardColorBlock);
var _dashboardNavigation = require("../DashboardNavigation");
var _dashboardNavigationDefault = parcelHelpers.interopDefault(_dashboardNavigation);
var _dashboardNumbersItem = require("../DashboardNumbersItem");
var _dashboardNumbersItemDefault = parcelHelpers.interopDefault(_dashboardNumbersItem);
var _dashboardVerticalStack = require("../DashboardVerticalStack");
var _dashboardVerticalStackDefault = parcelHelpers.interopDefault(_dashboardVerticalStack);
var _dashboardWidget = require("../DashboardWidget");
var _dashboardWidgetDefault = parcelHelpers.interopDefault(_dashboardWidget);
var _useDashboardNavigation = require("../useDashboardNavigation");
var _useDashboardNavigationDefault = parcelHelpers.interopDefault(_useDashboardNavigation);
var _useFilterIndustries = require("./useFilterIndustries");
var _useFilterIndustriesDefault = parcelHelpers.interopDefault(_useFilterIndustries);
const CustomersByIndustryTypeWidget = (props)=>{
    const { loading, industries, categories, customersCount } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const { navigateToCustomersByIndustryType } = (0, _useDashboardNavigationDefault.default)();
    const [filter, setFilter] = (0, _react.useState)("");
    const [selectedCategory, setSelectedCategory] = (0, _react.useState)();
    const clearCategory = ()=>setSelectedCategory(undefined);
    const clearQueryText = (0, _react.useCallback)(()=>setFilter(""), []);
    const { filteredIndustries, filteredIndustriesCount } = (0, _useFilterIndustriesDefault.default)(industries, categories, filter, selectedCategory);
    const dataLabels = filteredIndustries.map((industry)=>(0, _displayHelpers.getTranslationText)(language, industry.industry_name));
    const dataColors = (0, _styles.PRESET_COLORS_FOR_INDUSTRY_TYPE_PIE_CHART);
    const clickHandler = (industry)=>{
        if (industry) {
            if ((0, _useFilterIndustries.isCategoryCode)(industry.industry_code)) setSelectedCategory({
                code: industry.industry_code,
                name: industry.industry_name
            });
            else navigateToCustomersByIndustryType(industry.industry_code);
        } else clearCategory();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardWidgetDefault.default), {
        title: f("dashboard.widgets.industry-types.title"),
        loading: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledGridContainer, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledPieContainer, {
                    children: [
                        industries.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                            children: f("dashboard.widgets.industry-types.empty.message")
                        }),
                        industries.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pieChartDefault.default), {
                            values: filteredIndustries,
                            valueKey: "count",
                            labels: dataLabels,
                            colors: dataColors,
                            tooltipPrefix: f("customers.list.title"),
                            onItemClick: clickHandler
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledListContainer, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFilterContainer, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                                        labelHidden: true,
                                        placeholder: f("dashboard.widgets.industry-types.filter.placeholder"),
                                        value: filter,
                                        onChange: setFilter,
                                        disabled: industries.length === 0,
                                        clearButton: true,
                                        onClearButtonClick: clearQueryText
                                    }),
                                    selectedCategory && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "2",
                                        blockAlign: "center",
                                        wrap: false,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                                onClick: clearCategory,
                                                plain: true,
                                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                    source: (0, _chevronLeftSvgDefault.default),
                                                    width: "8px",
                                                    height: "12px"
                                                }),
                                                children: f("button.go.back")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                fontWeight: "semibold",
                                                truncate: true,
                                                children: (0, _displayHelpers.getTranslationText)(language, selectedCategory.name)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Scrollable), {
                            vertical: true,
                            horizontal: false,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFlipMoveDefault.default), {
                                enterAnimation: {
                                    from: {
                                        transform: selectedCategory ? "translateX(100%)" : "translateX(-100%)"
                                    },
                                    to: {
                                        transform: ""
                                    }
                                },
                                leaveAnimation: {
                                    from: {
                                        transform: ""
                                    },
                                    to: {
                                        transform: selectedCategory ? "translateX(-100%)" : "translateX(100%)"
                                    }
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardVerticalStackDefault.default), {
                                    children: filteredIndustries.map((industry)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDashboardNavigation, {
                                            spacing: "medium",
                                            onClick: ()=>clickHandler(industry),
                                            hideCaret: selectedCategory === undefined,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                gap: "4",
                                                blockAlign: "stretch",
                                                wrap: false,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardColorBlockDefault.default), {
                                                            color: dataColors[filteredIndustries.indexOf(industry) % dataColors.length],
                                                            border: (0, _stringUtils.isEmptyString)(industry.industry_code) ? "black" : undefined
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNumbersItemDefault.default), {
                                                        value: industry.count,
                                                        percent: !customersCount ? 0 : industry.count / customersCount,
                                                        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIndustryName, {
                                                            searchWords: [
                                                                filter
                                                            ],
                                                            textToHighlight: (0, _displayHelpers.getTranslationText)(language, industry.industry_name),
                                                            title: (0, _displayHelpers.getTranslationText)(language, industry.industry_name)
                                                        })
                                                    })
                                                ]
                                            })
                                        }, industry.industry_code))
                                }, selectedCategory?.code)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFooterContainer, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                as: "span",
                                children: [
                                    filteredIndustriesCount,
                                    " ",
                                    selectedCategory ? f("default.industries") : f("default.categories")
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const StyledGridContainer = (0, _styledComponentsDefault.default).div`
  height: 100%;
  min-height: 16rem;

  display: grid;
  grid-template-columns: 1fr 2fr;

  // For small viewports - use vertical layout
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    grid-template-columns: 1fr;
    grid-auto-flow: row;
  }

  & > * + * {
    border-left: var(--p-border-divider);
  }
`;
const StyledPieContainer = (0, _styledComponentsDefault.default).div`
  height: 100%;
  padding: var(--p-space-4);
  margin: 0 auto;
  aspect-ratio: 1 / 1;
  text-align: center;

  min-height: 16rem;
`;
const StyledListContainer = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-rows: auto 1fr;

  max-height: 16rem;
`;
const StyledFilterContainer = (0, _styledComponentsDefault.default).div`
  padding: var(--p-space-4) var(--p-space-4) var(--p-space-2) var(--p-space-4);
`;
const StyledFooterContainer = (0, _styledComponentsDefault.default).div`
  padding: var(--p-space-1) var(--p-space-4);
`;
const StyledDashboardNavigation = (0, _styledComponentsDefault.default)((0, _dashboardNavigationDefault.default))`
  height: auto;
  padding-left: var(--p-space-4);
  padding-right: var(--p-space-4);

  display: grid;
  grid-template-columns: 1fr auto;
`;
const StyledIndustryName = (0, _styledComponentsDefault.default)((0, _textHighlighterDefault.default))`
  & > mark {
    background: inherit;
    color: inherit;
    text-decoration: underline;
  }
`;
exports.default = CustomersByIndustryTypeWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-flip-move":"7Sobo","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/chevron-left.svg":"abXPg","../../../components/CondensedText/CondensedText":"1FshD","../../../components/extensions/Icon":"eHSf0","../../../components/PieChart/PieChart":"8qAWv","../../../components/SearchTextField/SearchTextField":"k5bRy","../../../components/TextHighlighter/TextHighlighter":"43Xhz","../../../constants/styles":"dZWds","../../../helpers/display.helpers":"2q3xY","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useLanguage":"2W6IE","../../../utils/stringUtils":"4gVdA","../DashboardColorBlock":"4Jghj","../DashboardNavigation":"dsYkB","../DashboardNumbersItem":"9RIaS","../DashboardVerticalStack":"iN7sd","../DashboardWidget":"98uzT","../useDashboardNavigation":"eWi9U","./useFilterIndustries":"cQgyZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8qAWv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactChartjs2 = require("react-chartjs-2");
var _chartJs = require("chart.js");
var _chartjsPluginDatalabels = require("chartjs-plugin-datalabels");
var _chartjsPluginDatalabelsDefault = parcelHelpers.interopDefault(_chartjsPluginDatalabels);
(0, _chartJs.Chart).register((0, _chartJs.ArcElement), (0, _chartJs.Tooltip), (0, _chartJs.Legend));
(0, _chartJs.Chart).register((0, _chartjsPluginDatalabelsDefault.default));
(0, _chartJs.Chart).defaults.font.family = `"BatonTurboWeb", "Arial", "sans-serif"`;
(0, _chartJs.Chart).defaults.font.size = 15;
(0, _chartJs.Chart).defaults.font.weight = "bold";
function PieChart(props) {
    const { values, valueKey, labels, colors, tooltipPrefix, onItemClick } = props;
    const data = {
        labels,
        datasets: [
            {
                // @ts-ignore
                data: values,
                backgroundColor: colors,
                label: tooltipPrefix
            }
        ]
    };
    const options = {
        onClick: (_, elements, chart)=>{
            if (onItemClick) {
                if (elements[0]) {
                    const index = elements[0].index;
                    const dateset = chart.data.datasets[0].data;
                    onItemClick(dateset[index]);
                } else onItemClick();
            }
        },
        onHover: (event, chartElements)=>{
            if (chartElements.length === 1 && event.native?.target) // @ts-ignore
            event.native.target.style.cursor = "pointer";
        },
        parsing: {
            key: valueKey
        },
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                color: "white",
                formatter: (value)=>value ? value[valueKey] : 0
            },
            tooltip: {}
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactChartjs2.Doughnut), {
        data: data,
        options: options
    });
}
exports.default = PieChart;

},{"react/jsx-runtime":"enbMA","react-chartjs-2":"81C4E","chart.js":"gQHtV","chartjs-plugin-datalabels":"lzY1E","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"81C4E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar);
parcelHelpers.export(exports, "Bubble", ()=>Bubble);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Doughnut", ()=>Doughnut);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "Pie", ()=>Pie);
parcelHelpers.export(exports, "PolarArea", ()=>PolarArea);
parcelHelpers.export(exports, "Radar", ()=>Radar);
parcelHelpers.export(exports, "Scatter", ()=>Scatter);
parcelHelpers.export(exports, "getDatasetAtEvent", ()=>getDatasetAtEvent);
parcelHelpers.export(exports, "getElementAtEvent", ()=>getElementAtEvent);
parcelHelpers.export(exports, "getElementsAtEvent", ()=>getElementsAtEvent);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _chartJs = require("chart.js");
const defaultDatasetIdKey = "label";
function reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    setLabels(nextData, data.labels);
    setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getDatasetAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function getElementsAtEvent(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function ChartComponent(props, ref) {
    const { height = 150, width = 300, redraw = false, datasetIdKey, type, data, options, plugins = [], fallbackContent, updateMode, ...canvasProps } = props;
    const canvasRef = (0, _react.useRef)(null);
    const chartRef = (0, _react.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, _chartJs.Chart)(canvasRef.current, {
            type,
            data: cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins
        });
        reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && options) setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current) setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, _react.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, _react.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, _react.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const Chart = /*#__PURE__*/ (0, _react.forwardRef)(ChartComponent);
function createTypedChart(type, registerables) {
    (0, _chartJs.Chart).register(registerables);
    return /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Chart, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const Line = /* #__PURE__ */ createTypedChart("line", (0, _chartJs.LineController));
const Bar = /* #__PURE__ */ createTypedChart("bar", (0, _chartJs.BarController));
const Radar = /* #__PURE__ */ createTypedChart("radar", (0, _chartJs.RadarController));
const Doughnut = /* #__PURE__ */ createTypedChart("doughnut", (0, _chartJs.DoughnutController));
const PolarArea = /* #__PURE__ */ createTypedChart("polarArea", (0, _chartJs.PolarAreaController));
const Bubble = /* #__PURE__ */ createTypedChart("bubble", (0, _chartJs.BubbleController));
const Pie = /* #__PURE__ */ createTypedChart("pie", (0, _chartJs.PieController));
const Scatter = /* #__PURE__ */ createTypedChart("scatter", (0, _chartJs.ScatterController));

},{"react":"cOWTg","chart.js":"gQHtV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gQHtV":[function(require,module,exports) {
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "Animations", ()=>Animations);
parcelHelpers.export(exports, "ArcElement", ()=>ArcElement);
parcelHelpers.export(exports, "BarController", ()=>BarController);
parcelHelpers.export(exports, "BarElement", ()=>BarElement);
parcelHelpers.export(exports, "BasePlatform", ()=>BasePlatform);
parcelHelpers.export(exports, "BasicPlatform", ()=>BasicPlatform);
parcelHelpers.export(exports, "BubbleController", ()=>BubbleController);
parcelHelpers.export(exports, "CategoryScale", ()=>CategoryScale);
parcelHelpers.export(exports, "Chart", ()=>Chart);
parcelHelpers.export(exports, "Colors", ()=>plugin_colors);
parcelHelpers.export(exports, "DatasetController", ()=>DatasetController);
parcelHelpers.export(exports, "Decimation", ()=>plugin_decimation);
parcelHelpers.export(exports, "DomPlatform", ()=>DomPlatform);
parcelHelpers.export(exports, "DoughnutController", ()=>DoughnutController);
parcelHelpers.export(exports, "Element", ()=>Element);
parcelHelpers.export(exports, "Filler", ()=>index);
parcelHelpers.export(exports, "Interaction", ()=>Interaction);
parcelHelpers.export(exports, "Legend", ()=>plugin_legend);
parcelHelpers.export(exports, "LineController", ()=>LineController);
parcelHelpers.export(exports, "LineElement", ()=>LineElement);
parcelHelpers.export(exports, "LinearScale", ()=>LinearScale);
parcelHelpers.export(exports, "LogarithmicScale", ()=>LogarithmicScale);
parcelHelpers.export(exports, "PieController", ()=>PieController);
parcelHelpers.export(exports, "PointElement", ()=>PointElement);
parcelHelpers.export(exports, "PolarAreaController", ()=>PolarAreaController);
parcelHelpers.export(exports, "RadarController", ()=>RadarController);
parcelHelpers.export(exports, "RadialLinearScale", ()=>RadialLinearScale);
parcelHelpers.export(exports, "Scale", ()=>Scale);
parcelHelpers.export(exports, "ScatterController", ()=>ScatterController);
parcelHelpers.export(exports, "SubTitle", ()=>plugin_subtitle);
parcelHelpers.export(exports, "Ticks", ()=>(0, _helpersSegmentJs.aL));
parcelHelpers.export(exports, "TimeScale", ()=>TimeScale);
parcelHelpers.export(exports, "TimeSeriesScale", ()=>TimeSeriesScale);
parcelHelpers.export(exports, "Title", ()=>plugin_title);
parcelHelpers.export(exports, "Tooltip", ()=>plugin_tooltip);
parcelHelpers.export(exports, "_adapters", ()=>adapters);
parcelHelpers.export(exports, "_detectPlatform", ()=>_detectPlatform);
parcelHelpers.export(exports, "animator", ()=>animator);
parcelHelpers.export(exports, "controllers", ()=>controllers);
parcelHelpers.export(exports, "defaults", ()=>(0, _helpersSegmentJs.d));
parcelHelpers.export(exports, "elements", ()=>elements);
parcelHelpers.export(exports, "layouts", ()=>layouts);
parcelHelpers.export(exports, "plugins", ()=>plugins);
parcelHelpers.export(exports, "registerables", ()=>registerables);
parcelHelpers.export(exports, "registry", ()=>registry);
parcelHelpers.export(exports, "scales", ()=>scales);
var _helpersSegmentJs = require("./chunks/helpers.segment.js");
var _color = require("@kurkle/color");
class Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, _helpersSegmentJs.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var animator = /* #__PURE__ */ new Animator();
const transparent = "transparent";
const interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, _helpersSegmentJs.c)(from || transparent);
        const c1 = c0.valid && (0, _helpersSegmentJs.c)(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, _helpersSegmentJs.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, _helpersSegmentJs.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = (0, _helpersSegmentJs.e)[cfg.easing] || (0, _helpersSegmentJs.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, _helpersSegmentJs.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, _helpersSegmentJs.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, _helpersSegmentJs.i)(config)) return;
        const animationOptions = Object.keys((0, _helpersSegmentJs.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, _helpersSegmentJs.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, _helpersSegmentJs.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
}
function awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = scaleClip(xScale, allowedOverflow);
    const y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    let t, r, b, l;
    if ((0, _helpersSegmentJs.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, _helpersSegmentJs.g)(otherValue) && (singleMode || value === 0 || (0, _helpersSegmentJs.s)(value) === (0, _helpersSegmentJs.s)(otherValue))) value += otherValue;
    }
    return value;
}
function convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    const { min, max, minDefined, maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function updateStacks(controller, parsed) {
    const { chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale, vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return (0, _helpersSegmentJs.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: "default",
        type: "dataset"
    });
}
function createDataContext(parent, index, element) {
    return (0, _helpersSegmentJs.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: "default",
        type: "data"
    });
}
function clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled("filler")) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, _helpersSegmentJs.v)(dataset.xAxisID, getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, _helpersSegmentJs.v)(dataset.yAxisID, getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, _helpersSegmentJs.v)(dataset.rAxisID, getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, _helpersSegmentJs.u)(this._data, this);
        if (meta._stacked) clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, _helpersSegmentJs.i)(data)) this._data = convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, _helpersSegmentJs.u)(_data, this);
                const meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, _helpersSegmentJs.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale, _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, _helpersSegmentJs.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, _helpersSegmentJs.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale, yScale } = meta;
        const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, _helpersSegmentJs.f)(item, xAxisKey), index),
                y: yScale.parse((0, _helpersSegmentJs.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, _helpersSegmentJs.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, _helpersSegmentJs.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = toClip((0, _helpersSegmentJs.v)(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, _helpersSegmentJs.h)(index);
        if (cached) return cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, _helpersSegmentJs.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, _helpersSegmentJs._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, _helpersSegmentJs.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, _helpersSegmentJs.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if ((0, _helpersSegmentJs.b)(entry)) parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, _helpersSegmentJs.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start, end, reverse, top, bottom } = borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else edge = startEnd(edge, a, b);
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function setInflateAmount(properties, { inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    static id = "bar";
    static defaults = {
        datasetElementType: false,
        dataElementType: "bar",
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "base",
                    "width",
                    "height"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category",
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: "linear",
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale, vScale } = meta;
        const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, _helpersSegmentJs.f)(obj, iAxisKey), i);
            parsed.push(parseValue((0, _helpersSegmentJs.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale, vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index, _cachedMeta: { vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, _helpersSegmentJs.k)(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, _helpersSegmentJs.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale, _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, _helpersSegmentJs.s)(value) !== (0, _helpersSegmentJs.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, _helpersSegmentJs.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, _helpersSegmentJs.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, _helpersSegmentJs.v)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
class BubbleController extends DatasetController {
    static id = "bubble";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "borderWidth",
                    "radius"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersSegmentJs.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, _helpersSegmentJs.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale, vScale } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, _helpersSegmentJs.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, _helpersSegmentJs.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, _helpersSegmentJs.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, _helpersSegmentJs.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, _helpersSegmentJs.H), startY, endY);
        const minX = calcMin((0, _helpersSegmentJs.P), startX, endX);
        const minY = calcMin((0, _helpersSegmentJs.P) + (0, _helpersSegmentJs.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class DoughnutController extends DatasetController {
    static id = "doughnut";
    static defaults = {
        datasetElementType: false,
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "circumference",
                    "endAngle",
                    "innerRadius",
                    "outerRadius",
                    "startAngle",
                    "x",
                    "y",
                    "offset",
                    "borderWidth",
                    "spacing"
                ]
            }
        },
        cutout: "50%",
        rotation: 0,
        circumference: 360,
        radius: "100%",
        spacing: 0,
        indexAxis: "r"
    };
    static descriptors = {
        _scriptable: (name)=>name !== "spacing",
        _indexable: (name)=>name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, _helpersSegmentJs.i)(data[start])) {
                const { key = "value" } = this._parsing;
                getter = (i)=>+(0, _helpersSegmentJs.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, _helpersSegmentJs.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, _helpersSegmentJs.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, _helpersSegmentJs.T);
        let max = -(0, _helpersSegmentJs.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, _helpersSegmentJs.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference, rotation } = this._getRotationExtents();
        const { ratioX, ratioY, offsetX, offsetY } = getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, _helpersSegmentJs.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, _helpersSegmentJs.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, _helpersSegmentJs.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersSegmentJs.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, _helpersSegmentJs.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class LineController extends DatasetController {
    static id = "line";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category"
            },
            _value_: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersSegmentJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersSegmentJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersSegmentJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, _helpersSegmentJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class PolarAreaController extends DatasetController {
    static id = "polarArea";
    static defaults = {
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "startAngle",
                    "endAngle",
                    "innerRadius",
                    "outerRadius"
                ]
            }
        },
        indexAxis: "r",
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle, color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: "radialLinear",
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, _helpersSegmentJs.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersSegmentJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, _helpersSegmentJs.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius,
                startAngle,
                endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, _helpersSegmentJs.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class PieController extends DoughnutController {
    static id = "pie";
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: "100%"
    };
}
class RadarController extends DatasetController {
    static id = "radar";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        indexAxis: "r",
        showLine: true,
        elements: {
            line: {
                fill: "start"
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: "radialLinear"
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, _helpersSegmentJs.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x,
                y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class ScatterController extends DatasetController {
    static id = "scatter";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: "point"
        },
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale, yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + ")"
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start, count } = (0, _helpersSegmentJs.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, _helpersSegmentJs.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps, segment } = this.options;
        const maxGapLength = (0, _helpersSegmentJs.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, _helpersSegmentJs.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var controllers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: BarController,
    BubbleController: BubbleController,
    DoughnutController: DoughnutController,
    LineController: LineController,
    PieController: PieController,
    PolarAreaController: PolarAreaController,
    RadarController: RadarController,
    ScatterController: ScatterController
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return abstract();
    }
    parse() {
        return abstract();
    }
    format() {
        return abstract();
    }
    add() {
        return abstract();
    }
    diff() {
        return abstract();
    }
    startOf() {
        return abstract();
    }
    endOf() {
        return abstract();
    }
}
var adapters = {
    _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
    const { controller, data, _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, _helpersSegmentJs.A) : (0, _helpersSegmentJs.B);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index, data } = metasets[i];
        const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, _helpersSegmentJs.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element,
            datasetIndex,
            index
        });
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle, endAngle } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle } = (0, _helpersSegmentJs.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, _helpersSegmentJs.p)(angle, startAngle, endAngle)) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element,
            datasetIndex,
            index
        });
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var Interaction = {
    evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element,
                    datasetIndex: meta.index,
                    index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            return getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, _helpersSegmentJs.z)(e, chart);
            return getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack, stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack, pos, stackWeight } = wrap;
        if (!stack || !STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function setLayoutDims(layouts, params) {
    const stacks = buildStacks(layouts);
    const { vBoxMaxWidth, hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    const layoutBoxes = wrapBoxes(boxes);
    const fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
    const right = sortByWeight(filterByPosition(layoutBoxes, "right"));
    const top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
    const bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    const { pos, box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, _helpersSegmentJs.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        const { same, other } = updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x, y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, _helpersSegmentJs.h)(stack.start)) y = stack.start;
            if (box.fullSize) setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, _helpersSegmentJs.h)(stack.start)) x = stack.start;
            if (box.fullSize) setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, _helpersSegmentJs.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, _helpersSegmentJs.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, (0, _helpersSegmentJs.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) fitBoxes(verticalBoxes, chartArea, params, stacks);
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, _helpersSegmentJs.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class BasePlatform {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const EXPANDO_KEY = "$chartjs";
const EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const isNullOrEmpty = (value)=>value === null || value === "";
function initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if (isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, _helpersSegmentJs.J)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, _helpersSegmentJs.J)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const eventListenerOptions = (0, _helpersSegmentJs.K) ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
    const type = EVENT_TYPES[event.type] || event.type;
    const { x, y } = (0, _helpersSegmentJs.z)(event, chart);
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) return;
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) window.addEventListener("resize", onWindowResize);
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) window.removeEventListener("resize", onWindowResize);
}
function createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, _helpersSegmentJs.I)(canvas);
    if (!container) return;
    const resize = (0, _helpersSegmentJs.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") unlistenDevicePixelRatioChanges(chart);
}
function createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, _helpersSegmentJs.L)((event)=>{
        if (chart.ctx !== null) listener(fromNativeEvent(event, chart));
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
class DomPlatform extends BasePlatform {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) return false;
        const initial = canvas[EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, _helpersSegmentJs.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        const handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        const handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, _helpersSegmentJs.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, _helpersSegmentJs.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function _detectPlatform(canvas) {
    if (!(0, _helpersSegmentJs.M)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return BasicPlatform;
    return DomPlatform;
}
class Element {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x, y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    hasValue() {
        return (0, _helpersSegmentJs.x)(this.x) && (0, _helpersSegmentJs.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, (0, _helpersSegmentJs.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        skip(ticks, newTicks, spacing, last, (0, _helpersSegmentJs.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, _helpersSegmentJs.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, _helpersSegmentJs.v)(majorStart, 0);
    const end = Math.min((0, _helpersSegmentJs.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function garbageCollect(caches, length) {
    (0, _helpersSegmentJs.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, _helpersSegmentJs.a0)(options.font, fallback);
    const padding = (0, _helpersSegmentJs.E)(options.padding);
    const lines = (0, _helpersSegmentJs.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return (0, _helpersSegmentJs.j)(parent, {
        scale,
        type: "scale"
    });
}
function createTickContext(parent, index, tick) {
    return (0, _helpersSegmentJs.j)(parent, {
        tick,
        index,
        type: "tick"
    });
}
function titleAlign(align, position, reverse) {
    let ret = (0, _helpersSegmentJs.a1)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = reverseAlign(ret);
    return ret;
}
function titleArgs(scale, offset, position, align) {
    const { top, left, bottom, right, chart } = scale;
    const { chartArea, scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, _helpersSegmentJs.a2)(align, left, right);
        if ((0, _helpersSegmentJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, _helpersSegmentJs.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = offsetFromEdge(scale, position, offset);
        titleY = (0, _helpersSegmentJs.a2)(align, bottom, top);
        rotation = position === "left" ? -(0, _helpersSegmentJs.H) : (0, _helpersSegmentJs.H);
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
        _userMin = (0, _helpersSegmentJs.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, _helpersSegmentJs.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, _helpersSegmentJs.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, _helpersSegmentJs.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, _helpersSegmentJs.O)(_userMin, _suggestedMin),
            max: (0, _helpersSegmentJs.O)(_userMax, _suggestedMax),
            minDefined: (0, _helpersSegmentJs.g)(_userMin),
            maxDefined: (0, _helpersSegmentJs.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min,
            max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, _helpersSegmentJs.O)(min, (0, _helpersSegmentJs.O)(max, min)),
            max: (0, _helpersSegmentJs.O)(max, (0, _helpersSegmentJs.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, _helpersSegmentJs.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero, grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, _helpersSegmentJs.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, _helpersSegmentJs.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, _helpersSegmentJs.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, _helpersSegmentJs.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, _helpersSegmentJs.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, _helpersSegmentJs.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, _helpersSegmentJs.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, _helpersSegmentJs.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, _helpersSegmentJs.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, _helpersSegmentJs.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, _helpersSegmentJs.U)(Math.min(Math.asin((0, _helpersSegmentJs.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, _helpersSegmentJs.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, _helpersSegmentJs.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, _helpersSegmentJs.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, _helpersSegmentJs.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first, last, widest, highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, _helpersSegmentJs.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align, padding }, position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, _helpersSegmentJs.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis, position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, _helpersSegmentJs.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, _helpersSegmentJs.k)(label) && !(0, _helpersSegmentJs.b)(label)) {
                width = (0, _helpersSegmentJs.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, _helpersSegmentJs.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, _helpersSegmentJs.k)(nestedLabel) && !(0, _helpersSegmentJs.b)(nestedLabel)) {
                    width = (0, _helpersSegmentJs.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, _helpersSegmentJs.W)(this._alignToPixels ? (0, _helpersSegmentJs.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min, max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, _helpersSegmentJs.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid, position, border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, _helpersSegmentJs.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, _helpersSegmentJs.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, _helpersSegmentJs.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align, crossAlign, padding, mirror } = optionTicks;
        const tl = getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, _helpersSegmentJs.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, _helpersSegmentJs.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, _helpersSegmentJs.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, _helpersSegmentJs.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                    case "inner":
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position, ticks } = this.options;
        const rotation = -(0, _helpersSegmentJs.t)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position, ticks: { crossAlign, mirror, padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign,
            x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx, options: { backgroundColor }, left, top, width, height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart, ctx, options: { border, grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, _helpersSegmentJs.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, _helpersSegmentJs.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, _helpersSegmentJs.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, _helpersSegmentJs.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, _helpersSegmentJs.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, _helpersSegmentJs.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, _helpersSegmentJs.$)(ctx);
    }
    drawTitle() {
        const { ctx, options: { position, title, reverse } } = this;
        if (!title.display) return;
        const font = (0, _helpersSegmentJs.a0)(title.font);
        const padding = (0, _helpersSegmentJs.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, _helpersSegmentJs.i)(position)) {
            offset += padding.bottom;
            if ((0, _helpersSegmentJs.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset, position, align);
        (0, _helpersSegmentJs.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, _helpersSegmentJs.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, _helpersSegmentJs.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, _helpersSegmentJs.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if (isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) (0, _helpersSegmentJs.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, _helpersSegmentJs.d)[scope]) {
            delete (0, _helpersSegmentJs.d)[scope][id];
            if (this.override) delete (0, _helpersSegmentJs.a3)[id];
        }
    }
}
function registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, _helpersSegmentJs.a4)(Object.create(null), [
        parentScope ? (0, _helpersSegmentJs.d).get(parentScope) : {},
        (0, _helpersSegmentJs.d).get(scope),
        item.defaults
    ]);
    (0, _helpersSegmentJs.d).set(scope, itemDefaults);
    if (item.defaultRoutes) routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, _helpersSegmentJs.d).describe(scope, item.descriptors);
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, _helpersSegmentJs.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class Registry {
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, "datasets", true);
        this.elements = new TypedRegistry(Element, "elements");
        this.plugins = new TypedRegistry(Object, "plugins");
        this.scales = new TypedRegistry(Scale, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, _helpersSegmentJs.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, _helpersSegmentJs.a5)(method);
        (0, _helpersSegmentJs.Q)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, _helpersSegmentJs.Q)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var registry = /* #__PURE__ */ new Registry();
class PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, _helpersSegmentJs.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, _helpersSegmentJs.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, _helpersSegmentJs.v)(config.options && config.options.plugins, {});
        const plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys(registry.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push(registry.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin,
            options: pluginOpts(chart.config, {
                plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function pluginOpts(config, { plugin, local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function getIndexAxis(type, options) {
    const datasetDefaults = (0, _helpersSegmentJs.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function idMatchesAxis(id) {
    if (id === "x" || id === "y" || id === "r") return id;
}
function axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function determineAxis(id, ...scaleOptions) {
    if (idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + "AxisID"] === id) return {
        axis
    };
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return getAxisFromDataset(id, "x", boundDs[0]) || getAxisFromDataset(id, "y", boundDs[0]);
    }
    return {};
}
function mergeScaleConfig(config, options) {
    const chartDefaults = (0, _helpersSegmentJs.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, _helpersSegmentJs.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), (0, _helpersSegmentJs.d).scales[scaleConf.type]);
        const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, _helpersSegmentJs.ab)(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        const datasetDefaults = (0, _helpersSegmentJs.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, _helpersSegmentJs.ab)(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, _helpersSegmentJs.ab)(scale, [
            (0, _helpersSegmentJs.d).scales[scale.type],
            (0, _helpersSegmentJs.d).scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, _helpersSegmentJs.v)(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    let keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
const addIfFound = (set, obj, key)=>{
    const opts = (0, _helpersSegmentJs.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class Config {
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options, type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.a3)[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.d), key));
            keys.forEach((key)=>addIfFound(scopes, (0, _helpersSegmentJs.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if (keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options, type } = this;
        return [
            options,
            (0, _helpersSegmentJs.a3)[type] || {},
            (0, _helpersSegmentJs.d).datasets[type] || {},
            {
                type
            },
            (0, _helpersSegmentJs.d),
            (0, _helpersSegmentJs.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = (0, _helpersSegmentJs.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, _helpersSegmentJs.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
        return (0, _helpersSegmentJs.i)(context) ? (0, _helpersSegmentJs.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, _helpersSegmentJs.a9)(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const hasFunction = (value)=>(0, _helpersSegmentJs.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, _helpersSegmentJs.a7)(value[key]));
function needContext(proxy, names) {
    const { isScriptable, isIndexable } = (0, _helpersSegmentJs.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, _helpersSegmentJs.a7)(value) || hasFunction(value)) || indexable && (0, _helpersSegmentJs.b)(value)) return true;
    }
    return false;
}
var version = "4.4.1";
const KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, _helpersSegmentJs.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, _helpersSegmentJs.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function getCanvas(item) {
    if ((0, _helpersSegmentJs.M)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const instances = {};
const getChart = (key)=>{
    const canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    const { xScale, yScale } = meta;
    if (xScale && yScale) return {
        left: getSizeForArea(xScale, chartArea, "left"),
        right: getSizeForArea(xScale, chartArea, "right"),
        top: getSizeForArea(yScale, chartArea, "top"),
        bottom: getSizeForArea(yScale, chartArea, "bottom")
    };
    return chartArea;
}
class Chart {
    static defaults = (0, _helpersSegmentJs.d);
    static instances = instances;
    static overrides = (0, _helpersSegmentJs.a3);
    static registry = registry;
    static version = version;
    static getChart = getChart;
    static register(...items) {
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister(...items) {
        registry.remove(...items);
        invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new Config(userConfig);
        const initialCanvas = getCanvas(item);
        const existingChart = getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, _helpersSegmentJs.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, _helpersSegmentJs.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, "complete", onAnimationsComplete);
        animator.listen(this, "progress", onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
        if (!(0, _helpersSegmentJs.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, _helpersSegmentJs.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, _helpersSegmentJs.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
    resize(width, height) {
        if (!animator.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width,
            height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, _helpersSegmentJs.ae)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, _helpersSegmentJs.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, _helpersSegmentJs.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, _helpersSegmentJs.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = determineAxis(id, scaleOptions);
            const scaleType = (0, _helpersSegmentJs.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, _helpersSegmentJs.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, _helpersSegmentJs.F)(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = registry.getController(type);
                const { datasetElementType, dataElementType } = (0, _helpersSegmentJs.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, _helpersSegmentJs.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, _helpersSegmentJs.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode
        });
        this._layers.sort(compare2Level("z", "_idx"));
        const { _active, _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, _helpersSegmentJs.F)(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, _helpersSegmentJs.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method, start, count } of changes){
            const move = method === "_removeElements" ? -count : count;
            moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, _helpersSegmentJs.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, _helpersSegmentJs.F)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, _helpersSegmentJs.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) animator.start(this);
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width, height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = getDatasetArea(meta, this.chartArea);
        const args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, _helpersSegmentJs.Y)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, _helpersSegmentJs.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, _helpersSegmentJs.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = Interaction.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, _helpersSegmentJs.j)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, _helpersSegmentJs.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas, ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, _helpersSegmentJs.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, _helpersSegmentJs.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, _helpersSegmentJs.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, _helpersSegmentJs.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersSegmentJs.ah)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, _helpersSegmentJs.ai)(e);
        const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, _helpersSegmentJs.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, _helpersSegmentJs.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, _helpersSegmentJs.ah)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function invalidatePlugins() {
    return (0, _helpersSegmentJs.F)(Chart.instances, (chart)=>chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
    const { startAngle, pixelMargin, x, y, outerRadius, innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, _helpersSegmentJs.H), startAngle - (0, _helpersSegmentJs.H));
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return (0, _helpersSegmentJs.ak)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, _helpersSegmentJs.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, _helpersSegmentJs.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, _helpersSegmentJs.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    const { x, y, startAngle: start, pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, _helpersSegmentJs.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart, outerEnd, innerStart, innerEnd } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, _helpersSegmentJs.H));
        }
        // The line from point 3 to point 4
        const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, _helpersSegmentJs.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, _helpersSegmentJs.H));
        }
        // The line from point 7 to point 8
        const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, _helpersSegmentJs.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.T));
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles, startAngle, circumference, options } = element;
    const { borderWidth, borderJoinStyle, borderDash, borderDashOffset } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.T));
    }
    if (inner) clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    static id = "arc";
    static defaults = {
        borderAlign: "center",
        borderColor: "#fff",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash"
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle, distance } = (0, _helpersSegmentJs.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle, endAngle, innerRadius, outerRadius, circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, _helpersSegmentJs.v)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, _helpersSegmentJs.T) || (0, _helpersSegmentJs.p)(angle, startAngle, endAngle);
        const withinRadius = (0, _helpersSegmentJs.aj)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, startAngle, endAngle, innerRadius, outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius"
        ], useFinalPosition);
        const { offset, spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options, circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, _helpersSegmentJs.T) ? Math.floor(circumference / (0, _helpersSegmentJs.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, _helpersSegmentJs.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, _helpersSegmentJs.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, _helpersSegmentJs.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, _helpersSegmentJs.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, _helpersSegmentJs.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, _helpersSegmentJs.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, _helpersSegmentJs.v)(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
    if (options.stepped) return 0, _helpersSegmentJs.ar;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, _helpersSegmentJs.as;
    return lineTo;
}
function pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function pathSegment(ctx, line, segment, params) {
    const { points, options } = line;
    const { count, start, loop, ilen } = pathVars(points, segment, params);
    const lineMethod = getLineMethod(options);
    let { move = true, reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count, start, ilen } = pathVars(points, segment, params);
    const { move = true, reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function _getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
    if (options.stepped) return 0, _helpersSegmentJs.ao;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, _helpersSegmentJs.ap;
    return 0, _helpersSegmentJs.aq;
}
function strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    const { segments, options } = line;
    const segmentMethod = _getSegmentMethod(line);
    for (const segment of segments){
        setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const usePath2D = typeof Path2D === "function";
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) strokePathWithCache(ctx, line, start, count);
    else strokePathDirect(ctx, line, start, count);
}
class LineElement extends Element {
    static id = "line";
    static defaults = {
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: "miter",
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: "default",
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash" && name !== "fill"
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, _helpersSegmentJs.al)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, _helpersSegmentJs.am)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, _helpersSegmentJs.an)(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = _getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start, end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = _getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    static id = "point";
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: "circle",
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x, y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, _helpersSegmentJs.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, _helpersSegmentJs.at)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function getBarBounds(bar, useFinalPosition) {
    const { x, y, base, width, height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, _helpersSegmentJs.S)(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, _helpersSegmentJs.av)(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, _helpersSegmentJs.aw)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, _helpersSegmentJs.i)(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    const bounds = getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = parseBorderWidth(bar, width / 2, height / 2);
    const radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, _helpersSegmentJs.aj)(x, bounds.left, bounds.right)) && (skipY || (0, _helpersSegmentJs.aj)(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    static id = "bar";
    static defaults = {
        borderSkipped: "start",
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: "auto",
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount, options: { borderColor, backgroundColor } } = this;
        const { inner, outer } = boundingRects(this);
        const addRectPath = hasRadius(outer.radius) ? (0, _helpersSegmentJs.au) : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x, y, base, horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
var elements = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: ArcElement,
    BarElement: BarElement,
    LineElement: LineElement,
    PointElement: PointElement
});
const BORDER_COLORS = [
    "rgb(54, 162, 235)",
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)" // grey
];
// Border colors with 50% transparency
const BACKGROUND_COLORS = /* #__PURE__ */ BORDER_COLORS.map((color)=>color.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function getBorderColor(i) {
    return BORDER_COLORS[i % BORDER_COLORS.length];
}
function getBackgroundColor(i) {
    return BACKGROUND_COLORS[i % BACKGROUND_COLORS.length];
}
function colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = getBorderColor(i);
    dataset.backgroundColor = getBackgroundColor(i);
    return ++i;
}
function colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBorderColor(i++));
    return i;
}
function colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>getBackgroundColor(i++));
    return i;
}
function getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof DoughnutController) i = colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof PolarAreaController) i = colorizePolarAreaDataset(dataset, i);
        else if (controller) i = colorizeDefaultDataset(dataset, i);
    };
}
function containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var plugin_colors = {
    id: "colors",
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets }, options: chartOptions } = chart.config;
        const { elements } = chartOptions;
        if (!options.forceOverride && (containsColorsDefinitions(datasets) || containsColorsDefinition(chartOptions) || elements && containsColorsDefinitions(elements))) return;
        const colorizer = getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, _helpersSegmentJs.k)(minIndex) && !(0, _helpersSegmentJs.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        cleanDecimatedDataset(dataset);
    });
}
function getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale } = meta;
    const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, _helpersSegmentJs.S)((0, _helpersSegmentJs.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, _helpersSegmentJs.S)((0, _helpersSegmentJs.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start,
        count
    };
}
var plugin_decimation = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data, indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, _helpersSegmentJs.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start, count } = getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, _helpersSegmentJs.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        cleanDecimatedData(chart);
    }
};
function _segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start, end } = segment;
        end = _findSegmentEnd(start, end, points);
        const bounds = _getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, _helpersSegmentJs.an)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, _helpersSegmentJs.ax)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: _getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: _getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, _helpersSegmentJs.ay)(start);
        end = (0, _helpersSegmentJs.ay)(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    const { x = null, y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start, end })=>{
        end = _findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, _helpersSegmentJs.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = _pointsFromSegments(boundary, line);
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}
function _resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, _helpersSegmentJs.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function _decodeFill(line, index, count) {
    const fill = parseFillOption(line);
    if ((0, _helpersSegmentJs.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, _helpersSegmentJs.g)(target) && Math.floor(target) === target) return decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function _getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, _helpersSegmentJs.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function _getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, _helpersSegmentJs.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, _helpersSegmentJs.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function _buildStackLine(source) {
    const { scale, index, line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new LineElement({
        points,
        options: {}
    });
}
function getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first, last, point } = findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, _helpersSegmentJs.aj)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}
class simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x, y, radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, _helpersSegmentJs.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x, y, radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
}
function _getTarget(source) {
    const { chart, fill, line } = source;
    if ((0, _helpersSegmentJs.g)(fill)) return getLineByIndex(chart, fill);
    if (fill === "stack") return _buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) return boundary;
    return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return computeCircularBoundary(source);
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    const { scale = {}, fill } = source;
    const pixel = _getTargetPixel(fill, scale);
    if ((0, _helpersSegmentJs.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    const { scale, fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = _getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function _drawfill(ctx, source, area) {
    const target = _getTarget(source);
    const { line, scale, axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above = color, below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, _helpersSegmentJs.Y)(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis
        });
        (0, _helpersSegmentJs.$)(ctx);
    }
}
function doFill(ctx, cfg) {
    const { line, target, above, below, area, scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        clipVertical(ctx, target, area.top);
        fill(ctx, {
            line,
            target,
            color: above,
            scale,
            property
        });
        ctx.restore();
        ctx.save();
        clipVertical(ctx, target, area.bottom);
    }
    fill(ctx, {
        line,
        target,
        color: below,
        scale,
        property
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    const { segments, points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start, end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    const { line, target, property, color, scale } = cfg;
    const segments = _segments(line, target, property);
    for (const { source: src, target: tgt, start, end } of segments){
        const { style: { backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function clipBounds(ctx, scale, bounds) {
    const { top, bottom } = scale.chart.chartArea;
    const { property, start, end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var index = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: _decodeFill(line, i, count),
                chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) _drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (_shouldApplyFill(source)) _drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight = fontSize, boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, _helpersSegmentJs.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options, ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, _helpersSegmentJs.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth, itemHeight } = getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx, maxWidth, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx, maxHeight, options: { labels: { padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth, itemHeight } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align, labels: { padding }, rtl } } = this;
        const rtlHelper = (0, _helpersSegmentJs.az)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, _helpersSegmentJs.Y)(ctx, this);
            this._draw();
            (0, _helpersSegmentJs.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes, lineWidths, ctx } = this;
        const { align, labels: labelOpts } = opts;
        const defaultColor = (0, _helpersSegmentJs.d).color;
        const rtlHelper = (0, _helpersSegmentJs.az)(opts.rtl, this.left, this.width);
        const labelFont = (0, _helpersSegmentJs.a0)(labelOpts.font);
        const { padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth, boxHeight, itemHeight } = getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, _helpersSegmentJs.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, _helpersSegmentJs.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, _helpersSegmentJs.v)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, _helpersSegmentJs.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, _helpersSegmentJs.v)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, _helpersSegmentJs.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, _helpersSegmentJs.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, _helpersSegmentJs.aD)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, _helpersSegmentJs.aw)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, _helpersSegmentJs.au)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, _helpersSegmentJs.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, _helpersSegmentJs.aA)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, _helpersSegmentJs.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, _helpersSegmentJs.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, _helpersSegmentJs.aB)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== "string") {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, _helpersSegmentJs.aC)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, _helpersSegmentJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersSegmentJs.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, _helpersSegmentJs.az)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, _helpersSegmentJs.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, _helpersSegmentJs.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, _helpersSegmentJs.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, _helpersSegmentJs.a1)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, _helpersSegmentJs.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, _helpersSegmentJs.a0)(titleOpts.font);
        const titlePadding = (0, _helpersSegmentJs.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, _helpersSegmentJs.aj)(x, this.left, this.right) && (0, _helpersSegmentJs.aj)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, _helpersSegmentJs.aj)(x, hitBox.left, hitBox.left + hitBox.width) && (0, _helpersSegmentJs.aj)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, _helpersSegmentJs.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, _helpersSegmentJs.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, _helpersSegmentJs.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== "string") legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== "string") itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var plugin_legend = {
    id: "legend",
    _element: Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle, pointStyle, textAlign, color, useBorderRadius, borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, _helpersSegmentJs.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class Title extends Element {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, _helpersSegmentJs.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, _helpersSegmentJs.E)(opts.padding);
        const textSize = lineCount * (0, _helpersSegmentJs.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top, left, bottom, right, options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, _helpersSegmentJs.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, _helpersSegmentJs.a2)(align, bottom, top);
                rotation = (0, _helpersSegmentJs.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, _helpersSegmentJs.a2)(align, top, bottom);
                rotation = (0, _helpersSegmentJs.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX,
            titleY,
            maxWidth,
            rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, _helpersSegmentJs.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset);
        (0, _helpersSegmentJs.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth,
            rotation,
            textAlign: (0, _helpersSegmentJs.a1)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function createTitle(chart, titleOpts) {
    const title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart
    });
    layouts.configure(chart, title, titleOpts);
    layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var plugin_title = {
    id: "title",
    _element: Title,
    start (chart, _args, options) {
        createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const map = new WeakMap();
var plugin_subtitle = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new Title({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, title, options);
        layouts.addBox(chart, title);
        map.set(chart, title);
    },
    stop (chart) {
        layouts.removeBox(chart, map.get(chart));
        map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = map.get(chart);
        layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, _helpersSegmentJs.aE)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, _helpersSegmentJs.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function createTooltipItem(chart, item) {
    const { element, datasetIndex, index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label, value } = controller.getLabelAndValue(index);
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
function getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body, footer, title } = tooltip;
    const { boxWidth, boxHeight } = options;
    const bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
    const titleFont = (0, _helpersSegmentJs.a0)(options.titleFont);
    const footerFont = (0, _helpersSegmentJs.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, _helpersSegmentJs.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, _helpersSegmentJs.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, _helpersSegmentJs.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, _helpersSegmentJs.F)(body, (bodyItem)=>{
        (0, _helpersSegmentJs.F)(bodyItem.before, maxLineWidth);
        (0, _helpersSegmentJs.F)(bodyItem.lines, maxLineWidth);
        (0, _helpersSegmentJs.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, _helpersSegmentJs.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    const { y, height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x, width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function determineXAlign(chart, options, size, yAlign) {
    const { x, width } = size;
    const { width: chartWidth, chartArea: { left, right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if (doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    let { x, width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    let { y, height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize, caretPadding, cornerRadius } = options;
    const { xAlign, yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersSegmentJs.aw)(cornerRadius);
    let x = alignX(size, xAlign);
    const y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, _helpersSegmentJs.S)(x, 0, chart.width - size.width),
        y: (0, _helpersSegmentJs.S)(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    const padding = (0, _helpersSegmentJs.E)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, _helpersSegmentJs.j)(parent, {
        tooltip,
        tooltipItems,
        type: "tooltip"
    });
}
function overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
    beforeTitle: (0, _helpersSegmentJs.aF),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return "";
    },
    afterTitle: (0, _helpersSegmentJs.aF),
    beforeBody: (0, _helpersSegmentJs.aF),
    beforeLabel: (0, _helpersSegmentJs.aF),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || "";
        if (label) label += ": ";
        const value = tooltipItem.formattedValue;
        if (!(0, _helpersSegmentJs.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, _helpersSegmentJs.aF),
    afterBody: (0, _helpersSegmentJs.aF),
    beforeFooter: (0, _helpersSegmentJs.aF),
    footer: (0, _helpersSegmentJs.aF),
    afterFooter: (0, _helpersSegmentJs.aF)
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === "undefined") return defaultCallbacks[name].call(ctx, arg);
    return result;
}
class Tooltip extends Element {
    static positioners = positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new Animations(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks } = options;
        const beforeTitle = invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
        const title = invokeCallbackWithFallback(callbacks, "title", this, context);
        const afterTitle = invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks } = options;
        const bodyItems = [];
        (0, _helpersSegmentJs.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, "label", this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks } = options;
        const beforeFooter = invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
        const footer = invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
        const afterFooter = invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, _helpersSegmentJs.F)(tooltipItems, (context)=>{
            const scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, "labelColor", this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign, yAlign } = this;
        const { caretSize, cornerRadius } = options;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersSegmentJs.aw)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width, height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, _helpersSegmentJs.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight, boxWidth } = options;
        const bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
        const colorX = getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, _helpersSegmentJs.at)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, _helpersSegmentJs.at)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, _helpersSegmentJs.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, _helpersSegmentJs.aw)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, _helpersSegmentJs.au)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, _helpersSegmentJs.au)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body } = this;
        const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
        const bodyFont = (0, _helpersSegmentJs.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, _helpersSegmentJs.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, _helpersSegmentJs.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, _helpersSegmentJs.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, _helpersSegmentJs.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, _helpersSegmentJs.az)(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, _helpersSegmentJs.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign, yAlign } = this;
        const { x, y } = pt;
        const { width, height } = tooltipSize;
        const { topLeft, topRight, bottomLeft, bottomRight } = (0, _helpersSegmentJs.aw)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = determineAlignment(chart, options, positionAndSize);
            const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, _helpersSegmentJs.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, _helpersSegmentJs.aA)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, _helpersSegmentJs.aC)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex, index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !(0, _helpersSegmentJs.ah)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, _helpersSegmentJs.ah)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX, caretY, options } = this;
        const position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var plugin_tooltip = {
    id: "tooltip",
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new Tooltip({
            chart,
            options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var plugins = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: plugin_colors,
    Decimation: plugin_decimation,
    Filler: index,
    Legend: plugin_legend,
    SubTitle: plugin_subtitle,
    Title: plugin_title,
    Tooltip: plugin_tooltip
});
const addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const validIndex = (index, max)=>index === null ? null : (0, _helpersSegmentJs.S)(Math.round(index), 0, max);
function _getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class CategoryScale extends Scale {
    static id = "category";
    static defaults = {
        ticks: {
            callback: _getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index, label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, _helpersSegmentJs.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, (0, _helpersSegmentJs.v)(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, _helpersSegmentJs.k)(min);
    const maxDefined = !(0, _helpersSegmentJs.k)(max);
    const countDefined = !(0, _helpersSegmentJs.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, _helpersSegmentJs.aH)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, _helpersSegmentJs.aH)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, _helpersSegmentJs.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, _helpersSegmentJs.aI)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, _helpersSegmentJs.aJ)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, _helpersSegmentJs.aK)(spacing), (0, _helpersSegmentJs.aK)(niceMin));
    factor = Math.pow(10, (0, _helpersSegmentJs.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, _helpersSegmentJs.aJ)(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, _helpersSegmentJs.aJ)(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
    const rad = (0, _helpersSegmentJs.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, _helpersSegmentJs.k)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero } = this.options;
        const { minDefined, maxDefined } = this.getUserBounds();
        let { min, max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, _helpersSegmentJs.s)(min);
            const maxSign = (0, _helpersSegmentJs.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit, stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, _helpersSegmentJs.aG)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, _helpersSegmentJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class LinearScale extends LinearScaleBase {
    static id = "linear";
    static defaults = {
        ticks: {
            callback: (0, _helpersSegmentJs.aL).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersSegmentJs.g)(min) ? min : 0;
        this.max = (0, _helpersSegmentJs.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, _helpersSegmentJs.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const log10Floor = (v)=>Math.floor((0, _helpersSegmentJs.aM)(v));
const changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    const range = max - min;
    let rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10)rangeExp++;
    while(steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, { min, max }) {
    min = (0, _helpersSegmentJs.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = log10Floor(min);
    let exp = startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, _helpersSegmentJs.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, _helpersSegmentJs.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    static id = "logarithmic";
    static defaults = {
        ticks: {
            callback: (0, _helpersSegmentJs.aL).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, _helpersSegmentJs.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(true);
        this.min = (0, _helpersSegmentJs.g)(min) ? Math.max(0, min) : null;
        this.max = (0, _helpersSegmentJs.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, _helpersSegmentJs.g)(this._userMin)) this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined, maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin(changeExponent(max, -1));
        if (max <= 0) setMax(changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, _helpersSegmentJs.aG)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, _helpersSegmentJs.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, _helpersSegmentJs.aM)(start);
        this._valueRange = (0, _helpersSegmentJs.aM)(this.max) - (0, _helpersSegmentJs.aM)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, _helpersSegmentJs.aM)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, _helpersSegmentJs.E)(tickOpts.backdropPadding);
        return (0, _helpersSegmentJs.v)(tickOpts.font && tickOpts.font.size, (0, _helpersSegmentJs.d).font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = (0, _helpersSegmentJs.b)(label) ? label : [
        label
    ];
    return {
        w: (0, _helpersSegmentJs.aN)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, _helpersSegmentJs.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, _helpersSegmentJs.a0)(opts.font);
        const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, _helpersSegmentJs.ay)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, _helpersSegmentJs.U)(angleRadians));
        const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra, additionalAngle, padding, size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, _helpersSegmentJs.U)((0, _helpersSegmentJs.ay)(pointLabelPosition.angle + (0, _helpersSegmentJs.H))));
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) return true;
    const { left, top, right, bottom } = item;
    const apexesInArea = (0, _helpersSegmentJs.C)({
        x: left,
        y: top
    }, area) || (0, _helpersSegmentJs.C)({
        x: left,
        y: bottom
    }, area) || (0, _helpersSegmentJs.C)({
        x: right,
        y: top
    }, area) || (0, _helpersSegmentJs.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels, display } = opts.pointLabels;
    const itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, _helpersSegmentJs.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === "auto") {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    const { left, top, right, bottom } = item;
    const { backdropColor } = opts;
    if (!(0, _helpersSegmentJs.k)(backdropColor)) {
        const borderRadius = (0, _helpersSegmentJs.aw)(opts.borderRadius);
        const padding = (0, _helpersSegmentJs.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, _helpersSegmentJs.au)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function drawPointLabels(scale, labelCount) {
    const { ctx, options: { pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, _helpersSegmentJs.a0)(optsAtIndex.font);
        const { x, y, textAlign } = item;
        (0, _helpersSegmentJs.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, _helpersSegmentJs.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color, lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return (0, _helpersSegmentJs.j)(parent, {
        label,
        index,
        type: "pointLabel"
    });
}
class RadialLinearScale extends LinearScaleBase {
    static id = "radialLinear";
    static defaults = {
        display: true,
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, _helpersSegmentJs.aL).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        "angleLines.color": "borderColor",
        "pointLabels.color": "color",
        "ticks.color": "color"
    };
    static descriptors = {
        angleLines: {
            _fallback: "grid"
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, _helpersSegmentJs.E)(getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min, max } = this.getMinMax(false);
        this.min = (0, _helpersSegmentJs.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, _helpersSegmentJs.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, _helpersSegmentJs.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, _helpersSegmentJs.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, _helpersSegmentJs.ay)(index * angleMultiplier + (0, _helpersSegmentJs.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, _helpersSegmentJs.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, _helpersSegmentJs.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, _helpersSegmentJs.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left, top, right, bottom } = this._pointLabelItems[index];
        return {
            left,
            top,
            right,
            bottom
        };
    }
    drawBackground() {
        const { backgroundColor, grid: { circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines, grid, border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color, lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, _helpersSegmentJs.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, _helpersSegmentJs.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, _helpersSegmentJs.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const UNITS = /* #__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
    return a - b;
}
function parse(scale, input) {
    if ((0, _helpersSegmentJs.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser, round, isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, _helpersSegmentJs.g)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, _helpersSegmentJs.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = UNITS.length;
    for(let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = INTERVALS[UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
    }
    return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        const unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
    for(let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) return UNITS[i];
    }
}
function addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo, hi } = (0, _helpersSegmentJs.aP)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    static id = "time";
    static defaults = {
        bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            source: "auto",
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, _helpersSegmentJs.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min, max, minDefined, maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, _helpersSegmentJs.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, _helpersSegmentJs.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, _helpersSegmentJs.aO)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, _helpersSegmentJs.S)(start, 0, limit);
        end = (0, _helpersSegmentJs.S)(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, _helpersSegmentJs.v)(options.ticks.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, _helpersSegmentJs.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, _helpersSegmentJs.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, _helpersSegmentJs.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push(parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, _helpersSegmentJs._)(values.sort(sorter));
    }
}
function interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo, hi } = (0, _helpersSegmentJs.B)(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo, hi } = (0, _helpersSegmentJs.B)(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    static id = "timeseries";
    static defaults = TimeScale.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = interpolate(table, this.min);
        this._tableRange = interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min, max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var scales = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: CategoryScale,
    LinearScale: LinearScale,
    LogarithmicScale: LogarithmicScale,
    RadialLinearScale: RadialLinearScale,
    TimeScale: TimeScale,
    TimeSeriesScale: TimeSeriesScale
});
const registerables = [
    controllers,
    elements,
    plugins,
    scales
];

},{"./chunks/helpers.segment.js":"37JCH","@kurkle/color":"dk24D","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"37JCH":[function(require,module,exports) {
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>unclipArea);
parcelHelpers.export(exports, "A", ()=>_rlookupByKey);
parcelHelpers.export(exports, "B", ()=>_lookupByKey);
parcelHelpers.export(exports, "C", ()=>_isPointInArea);
parcelHelpers.export(exports, "D", ()=>getAngleFromPoint);
parcelHelpers.export(exports, "E", ()=>toPadding);
parcelHelpers.export(exports, "F", ()=>each);
parcelHelpers.export(exports, "G", ()=>getMaximumSize);
parcelHelpers.export(exports, "H", ()=>HALF_PI);
parcelHelpers.export(exports, "I", ()=>_getParentNode);
parcelHelpers.export(exports, "J", ()=>readUsedSize);
parcelHelpers.export(exports, "K", ()=>supportsEventListenerOptions);
parcelHelpers.export(exports, "L", ()=>throttled);
parcelHelpers.export(exports, "M", ()=>_isDomSupported);
parcelHelpers.export(exports, "N", ()=>_factorize);
parcelHelpers.export(exports, "O", ()=>finiteOrDefault);
parcelHelpers.export(exports, "P", ()=>PI);
parcelHelpers.export(exports, "Q", ()=>callback);
parcelHelpers.export(exports, "R", ()=>_addGrace);
parcelHelpers.export(exports, "S", ()=>_limitValue);
parcelHelpers.export(exports, "T", ()=>TAU);
parcelHelpers.export(exports, "U", ()=>toDegrees);
parcelHelpers.export(exports, "V", ()=>_measureText);
parcelHelpers.export(exports, "W", ()=>_int16Range);
parcelHelpers.export(exports, "X", ()=>_alignPixel);
parcelHelpers.export(exports, "Y", ()=>clipArea);
parcelHelpers.export(exports, "Z", ()=>renderText);
parcelHelpers.export(exports, "_", ()=>_arrayUnique);
parcelHelpers.export(exports, "a", ()=>resolve);
parcelHelpers.export(exports, "a$", ()=>fontString);
parcelHelpers.export(exports, "a0", ()=>toFont);
parcelHelpers.export(exports, "a1", ()=>_toLeftRightCenter);
parcelHelpers.export(exports, "a2", ()=>_alignStartEnd);
parcelHelpers.export(exports, "a3", ()=>overrides);
parcelHelpers.export(exports, "a4", ()=>merge);
parcelHelpers.export(exports, "a5", ()=>_capitalize);
parcelHelpers.export(exports, "a6", ()=>descriptors);
parcelHelpers.export(exports, "a7", ()=>isFunction);
parcelHelpers.export(exports, "a8", ()=>_attachContext);
parcelHelpers.export(exports, "a9", ()=>_createResolver);
parcelHelpers.export(exports, "aA", ()=>overrideTextDirection);
parcelHelpers.export(exports, "aB", ()=>_textX);
parcelHelpers.export(exports, "aC", ()=>restoreTextDirection);
parcelHelpers.export(exports, "aD", ()=>drawPointLegend);
parcelHelpers.export(exports, "aE", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "aF", ()=>noop);
parcelHelpers.export(exports, "aG", ()=>_setMinAndMaxByKey);
parcelHelpers.export(exports, "aH", ()=>niceNum);
parcelHelpers.export(exports, "aI", ()=>almostWhole);
parcelHelpers.export(exports, "aJ", ()=>almostEquals);
parcelHelpers.export(exports, "aK", ()=>_decimalPlaces);
parcelHelpers.export(exports, "aL", ()=>Ticks);
parcelHelpers.export(exports, "aM", ()=>log10);
parcelHelpers.export(exports, "aN", ()=>_longestText);
parcelHelpers.export(exports, "aO", ()=>_filterBetween);
parcelHelpers.export(exports, "aP", ()=>_lookup);
parcelHelpers.export(exports, "aQ", ()=>isPatternOrGradient);
parcelHelpers.export(exports, "aR", ()=>getHoverColor);
parcelHelpers.export(exports, "aS", ()=>clone);
parcelHelpers.export(exports, "aT", ()=>_merger);
parcelHelpers.export(exports, "aU", ()=>_mergerIf);
parcelHelpers.export(exports, "aV", ()=>_deprecated);
parcelHelpers.export(exports, "aW", ()=>_splitKey);
parcelHelpers.export(exports, "aX", ()=>toFontString);
parcelHelpers.export(exports, "aY", ()=>splineCurve);
parcelHelpers.export(exports, "aZ", ()=>splineCurveMonotone);
parcelHelpers.export(exports, "a_", ()=>getStyle);
parcelHelpers.export(exports, "aa", ()=>_descriptors);
parcelHelpers.export(exports, "ab", ()=>mergeIf);
parcelHelpers.export(exports, "ac", ()=>uid);
parcelHelpers.export(exports, "ad", ()=>debounce);
parcelHelpers.export(exports, "ae", ()=>retinaScale);
parcelHelpers.export(exports, "af", ()=>clearCanvas);
parcelHelpers.export(exports, "ag", ()=>setsEqual);
parcelHelpers.export(exports, "ah", ()=>_elementsEqual);
parcelHelpers.export(exports, "ai", ()=>_isClickEvent);
parcelHelpers.export(exports, "aj", ()=>_isBetween);
parcelHelpers.export(exports, "ak", ()=>_readValueToProps);
parcelHelpers.export(exports, "al", ()=>_updateBezierControlPoints);
parcelHelpers.export(exports, "am", ()=>_computeSegments);
parcelHelpers.export(exports, "an", ()=>_boundSegments);
parcelHelpers.export(exports, "ao", ()=>_steppedInterpolation);
parcelHelpers.export(exports, "ap", ()=>_bezierInterpolation);
parcelHelpers.export(exports, "aq", ()=>_pointInLine);
parcelHelpers.export(exports, "ar", ()=>_steppedLineTo);
parcelHelpers.export(exports, "as", ()=>_bezierCurveTo);
parcelHelpers.export(exports, "at", ()=>drawPoint);
parcelHelpers.export(exports, "au", ()=>addRoundedRectPath);
parcelHelpers.export(exports, "av", ()=>toTRBL);
parcelHelpers.export(exports, "aw", ()=>toTRBLCorners);
parcelHelpers.export(exports, "ax", ()=>_boundSegment);
parcelHelpers.export(exports, "ay", ()=>_normalizeAngle);
parcelHelpers.export(exports, "az", ()=>getRtlAdapter);
parcelHelpers.export(exports, "b", ()=>isArray);
parcelHelpers.export(exports, "b0", ()=>toLineHeight);
parcelHelpers.export(exports, "b1", ()=>PITAU);
parcelHelpers.export(exports, "b2", ()=>INFINITY);
parcelHelpers.export(exports, "b3", ()=>RAD_PER_DEG);
parcelHelpers.export(exports, "b4", ()=>QUARTER_PI);
parcelHelpers.export(exports, "b5", ()=>TWO_THIRDS_PI);
parcelHelpers.export(exports, "b6", ()=>_angleDiff);
parcelHelpers.export(exports, "c", ()=>color);
parcelHelpers.export(exports, "d", ()=>defaults);
parcelHelpers.export(exports, "e", ()=>effects);
parcelHelpers.export(exports, "f", ()=>resolveObjectKey);
parcelHelpers.export(exports, "g", ()=>isNumberFinite);
parcelHelpers.export(exports, "h", ()=>defined);
parcelHelpers.export(exports, "i", ()=>isObject);
parcelHelpers.export(exports, "j", ()=>createContext);
parcelHelpers.export(exports, "k", ()=>isNullOrUndef);
parcelHelpers.export(exports, "l", ()=>listenArrayEvents);
parcelHelpers.export(exports, "m", ()=>toPercentage);
parcelHelpers.export(exports, "n", ()=>toDimension);
parcelHelpers.export(exports, "o", ()=>formatNumber);
parcelHelpers.export(exports, "p", ()=>_angleBetween);
parcelHelpers.export(exports, "q", ()=>_getStartAndCountOfVisiblePoints);
parcelHelpers.export(exports, "r", ()=>requestAnimFrame);
parcelHelpers.export(exports, "s", ()=>sign);
parcelHelpers.export(exports, "t", ()=>toRadians);
parcelHelpers.export(exports, "u", ()=>unlistenArrayEvents);
parcelHelpers.export(exports, "v", ()=>valueOrDefault);
parcelHelpers.export(exports, "w", ()=>_scaleRangesChanged);
parcelHelpers.export(exports, "x", ()=>isNumber);
parcelHelpers.export(exports, "y", ()=>_parseObjectDataRadialScale);
parcelHelpers.export(exports, "z", ()=>getRelativePosition);
var _color = require("@kurkle/color");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const uid = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || typeof value === "undefined";
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const toPercentage = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function clone(source) {
    if (isArray(source)) return source.map(clone);
    if (isObject(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = clone(source[keys[k]]);
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
    else target[key] = clone(sval);
}
function merge(target, source, options) {
    const sources = isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!isObject(target)) return target;
    options = options || {};
    const merger = options.merger || _merger;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) mergeIf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = clone(sval);
}
/**
 * @private
 */ function _deprecated(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    "": (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    const keys = _splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value)=>typeof value !== "undefined";
const isFunction = (value)=>typeof value === "function";
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    const roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor(log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = _normalizeAngle(angle);
    const s = _normalizeAngle(start);
    const e = _normalizeAngle(end);
    const angleToStart = _normalizeAngle(s - a);
    const angleToEnd = _normalizeAngle(e - a);
    const startToAngle = _normalizeAngle(a - s);
    const endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        const method = "_onData" + _capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function fontString(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
/**
* Request animation polyfill
*/ const requestAnimFrame = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const _toLeftRightCenter = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const _alignStartEnd = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const _textX = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale, _parsed } = meta;
        const axis = iScale.axis;
        const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
        if (minDefined) start = _limitValue(Math.min(_lookupByKey(_parsed, axis, min).lo, animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = _limitValue(Math.max(_lookupByKey(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    const { xScale, yScale, _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const atEdge = (t)=>t === 0 || t === 1;
const elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new (0, _color.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
function applyAnimationsDefaults(defaults) {
    defaults.set("animation", {
        delay: undefined,
        duration: 1000,
        easing: "easeOutQuart",
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe("animation", {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
    });
    defaults.set("animations", {
        colors: {
            type: "color",
            properties: colors
        },
        numbers: {
            type: "number",
            properties: numbers
        }
    });
    defaults.describe("animations", {
        _fallback: "animation"
    });
    defaults.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function applyLayoutsDefaults(defaults) {
    defaults.set("layout", {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}
const formatters = {
    values (value) {
        return isArray(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = calculateDelta(tickValue, ticks);
        }
        const logDelta = log10(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var Ticks = {
    formatters
};
function applyScaleDefaults(defaults) {
    defaults.set("scale", {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: "ticks",
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: false,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    });
    defaults.route("scale.ticks", "color", "", "color");
    defaults.route("scale.grid", "color", "", "borderColor");
    defaults.route("scale.border", "color", "", "borderColor");
    defaults.route("scale.title", "color", "", "color");
    defaults.describe("scale", {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
        _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
    });
    defaults.describe("scales", {
        _fallback: "scale"
    });
    defaults.describe("scale.ticks", {
        _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
        _indexable: (name)=>name !== "backdropPadding"
    });
}
const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === "string") return merge(getScope$1(root, scope), values);
    return merge(getScope$1(root, ""), scope);
}
class Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return set(this, scope, values);
    }
    get(scope) {
        return getScope$1(this, scope);
    }
    describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = getScope$1(this, scope);
        const targetScopeObject = getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if (isObject(local)) return Object.assign({}, target, local);
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) longest = _measureText(ctx, data, gc, longest, thing);
        else if (isArray(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            else ctx.arc(x, y, radius, 0, TAU);
            ctx.closePath();
            break;
        case "triangle":
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case "rectRot":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += QUARTER_PI;
        /* falls through */ case "cross":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "star":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!isNullOrUndef(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font, opts = {}) {
    const lines = isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!isNullOrUndef(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    const { x, y, w, h, radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    const matches = ("" + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    const ret = {};
    const objProps = isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    const obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    let size = valueOrDefault(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = valueOrDefault(options.style, fallback.style);
    if (style && !("" + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ""
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    const { min, max } = minmax;
    const change = toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes, prefixes = [
    ""
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === "undefined") fallback = _resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable = defaults.scriptable, _indexable = defaults.indexable, _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value)=>isObject(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) value = _resolveScriptable(prop, value, target, receiver);
    if (isArray(value) && value.length) value = _resolveArray(prop, value, target, descriptors.isIndexable);
    if (needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy, _context, _subProxy, _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    const { _proxy, _context, _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== "undefined" && isIndexable(prop)) return value[_context.index % value.length];
    else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = createSubResolver(scopes, _proxy, prop, item);
            value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== "undefined" && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return _createResolver(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = addScopes(set, allScopes, key, fallback, item);
    return key;
}
function subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if (isArray(target) && isObject(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = _resolve(readKey(prefix, prop), scopes);
        if (typeof value !== "undefined") return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function _resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== "undefined") return value;
    }
}
function getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
    const { iScale } = meta;
    const { key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse(resolveObjectKey(item, key), index)
        };
    }
    return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = distanceBetweenPoints(current, previous);
    const d12 = distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points, indexAxis = "x") {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") splineCurveMonotone(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function _isDomSupported() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * @private
 */ function _getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle(el).getPropertyValue(property);
}
const positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX, offsetY } = source;
    let box = false;
    let x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ("native" in event) return event;
    const { canvas, currentDevicePixelRatio } = chart;
    const style = getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = getPositionedStyle(style, "padding");
    const borders = getPositionedStyle(style, "border", "width");
    const { x, y, box } = getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width, height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = getComputedStyle(container);
            const containerBorder = getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
const round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = getComputedStyle(canvas);
    const margins = getPositionedStyle(style, "margin");
    const maxWidth = parseMaxStyle(style.maxWidth, canvas, "clientWidth") || INFINITY;
    const maxHeight = parseMaxStyle(style.maxHeight, canvas, "clientHeight") || INFINITY;
    const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    let { width, height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = getPositionedStyle(style, "border", "width");
        const paddings = getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener("test", null, options);
            window.removeEventListener("test", null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    const value = getStyle(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = _pointInLine(p1, cp1, t);
    const b = _pointInLine(cp1, cp2, t);
    const c = _pointInLine(cp2, p2, t);
    const d = _pointInLine(a, b, t);
    const e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}
const getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function propertyFn(property) {
    if (property === "angle") return {
        between: _angleBetween,
        compare: _angleDiff,
        normalize: _normalizeAngle
    };
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment({ start, end, count, loop, style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    const { property, start: startBound, end: endBound } = bounds;
    const { between, normalize } = propertyFn(property);
    const count = points.length;
    let { start, end, loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
function _boundSegment(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare, between, normalize } = propertyFn(property);
    const { start, end, loop, style } = getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push(normalizeSegment({
        start: subStart,
        end,
        loop,
        count,
        style
    }));
    return result;
}
function _boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start,
        end
    };
}
function solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop
    });
    return result;
}
function _computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return splitByStyles(line, [
        {
            start,
            end,
            loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex
            })));
            if (styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!isPatternOrGradient(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

},{"@kurkle/color":"dk24D","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dk24D":[function(require,module,exports) {
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "b2n", ()=>b2n);
parcelHelpers.export(exports, "b2p", ()=>b2p);
parcelHelpers.export(exports, "default", ()=>index_esm);
parcelHelpers.export(exports, "hexParse", ()=>hexParse);
parcelHelpers.export(exports, "hexString", ()=>hexString);
parcelHelpers.export(exports, "hsl2rgb", ()=>hsl2rgb);
parcelHelpers.export(exports, "hslString", ()=>hslString);
parcelHelpers.export(exports, "hsv2rgb", ()=>hsv2rgb);
parcelHelpers.export(exports, "hueParse", ()=>hueParse);
parcelHelpers.export(exports, "hwb2rgb", ()=>hwb2rgb);
parcelHelpers.export(exports, "lim", ()=>lim);
parcelHelpers.export(exports, "n2b", ()=>n2b);
parcelHelpers.export(exports, "n2p", ()=>n2p);
parcelHelpers.export(exports, "nameParse", ()=>nameParse);
parcelHelpers.export(exports, "p2b", ()=>p2b);
parcelHelpers.export(exports, "rgb2hsl", ()=>rgb2hsl);
parcelHelpers.export(exports, "rgbParse", ()=>rgbParse);
parcelHelpers.export(exports, "rgbString", ()=>rgbString);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "round", ()=>round);
function round(v) {
    return v + 0.5 | 0;
}
const lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function p2b(v) {
    return lim(round(v * 2.55), 0, 255);
}
function b2p(v) {
    return lim(round(v / 2.55), 0, 100);
}
function n2b(v) {
    return lim(round(v * 255), 0, 255);
}
function b2n(v) {
    return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
    return lim(round(v * 100), 0, 100);
}
const map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const hex = [
    ..."0123456789ABCDEF"
];
const h1 = (b)=>hex[b & 0xF];
const h2 = (b)=>hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const isShort = (v)=>eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & map$1[str[1]] * 17,
            g: 255 & map$1[str[2]] * 17,
            b: 255 & map$1[str[3]] * 17,
            a: len === 5 ? map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: map$1[str[1]] << 4 | map$1[str[2]],
            g: map$1[str[3]] << 4 | map$1[str[4]],
            b: map$1[str[5]] << 4 | map$1[str[6]],
            a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
        };
    }
    return ret;
}
const alpha = (a, f)=>a < 255 ? f(a) : "";
function hexString(v) {
    var f = isShort(v) ? h1 : h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function hwb2rgbn(h, w, b) {
    const rgb = hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
    return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
    return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
    return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
    return (h % 360 + 360) % 360;
}
function hueParse(str) {
    const m = HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
    const h = hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = hsv2rgb(h, p1, p2);
    else v = hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function rotate(v, deg) {
    var h = rgb2hsl(v);
    h[0] = hue(h[0] + deg);
    h = hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function hslString(v) {
    if (!v) return;
    const a = rgb2hsl(v);
    const h = a[0];
    const s = n2p(a[1]);
    const l = n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function unpack() {
    const unpacked = {};
    const keys = Object.keys(names$1);
    const tkeys = Object.keys(map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, map[k]);
        }
        k = parseInt(names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let names;
function nameParse(str) {
    if (!names) {
        names = unpack();
        names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
    const m = RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
    g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
    b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
    const r = from(b2n(rgb1.r));
    const g = from(b2n(rgb1.g));
    const b = from(b2n(rgb1.b));
    return {
        r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
        g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
        b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function modHSL(v, i, ratio) {
    if (v) {
        let tmp = rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = n2b(input[3]);
        }
    } else {
        v = clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = n2b(v.a);
    }
    return v;
}
function functionParse(str) {
    if (str.charAt(0) === "r") return rgbParse(str);
    return hueParse(str);
}
class Color {
    constructor(input){
        if (input instanceof Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = fromObject(input);
        else if (type === "string") v = hexParse(input) || nameParse(input) || functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = clone(this._rgb);
        if (v) v.a = b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = fromObject(obj);
    }
    rgbString() {
        return this._valid ? rgbString(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? hexString(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? hslString(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        rotate(this._rgb, deg);
        return this;
    }
}
function index_esm(input) {
    return new Color(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lzY1E":[function(require,module,exports) {
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>plugin);
var _helpers = require("chart.js/helpers");
var _chartJs = require("chart.js");
var devicePixelRatio = function() {
    if (typeof window !== "undefined") {
        if (window.devicePixelRatio) return window.devicePixelRatio;
        // devicePixelRatio is undefined on IE10
        // https://stackoverflow.com/a/20204180/8837887
        // https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
        var screen = window.screen;
        if (screen) return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
    }
    return 1;
}();
var utils = {
    // @todo move this in Chart.helpers.toTextLines
    toTextLines: function(inputs) {
        var lines = [];
        var input;
        inputs = [].concat(inputs);
        while(inputs.length){
            input = inputs.pop();
            if (typeof input === "string") lines.unshift.apply(lines, input.split("\n"));
            else if (Array.isArray(input)) inputs.push.apply(inputs, input);
            else if (!(0, _helpers.isNullOrUndef)(inputs)) lines.unshift("" + input);
        }
        return lines;
    },
    // @todo move this in Chart.helpers.canvas.textSize
    // @todo cache calls of measureText if font doesn't change?!
    textSize: function(ctx, lines, font) {
        var items = [].concat(lines);
        var ilen = items.length;
        var prev = ctx.font;
        var width = 0;
        var i;
        ctx.font = font.string;
        for(i = 0; i < ilen; ++i)width = Math.max(ctx.measureText(items[i]).width, width);
        ctx.font = prev;
        return {
            height: ilen * font.lineHeight,
            width: width
        };
    },
    /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */ bound: function(min, value, max) {
        return Math.max(min, Math.min(value, max));
    },
    /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */ arrayDiff: function(a0, a1) {
        var prev = a0.slice();
        var updates = [];
        var i, j, ilen, v;
        for(i = 0, ilen = a1.length; i < ilen; ++i){
            v = a1[i];
            j = prev.indexOf(v);
            if (j === -1) updates.push([
                v,
                1
            ]);
            else prev.splice(j, 1);
        }
        for(i = 0, ilen = prev.length; i < ilen; ++i)updates.push([
            prev[i],
            -1
        ]);
        return updates;
    },
    /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */ rasterize: function(v) {
        return Math.round(v * devicePixelRatio) / devicePixelRatio;
    }
};
function orient(point, origin) {
    var x0 = origin.x;
    var y0 = origin.y;
    if (x0 === null) return {
        x: 0,
        y: -1
    };
    if (y0 === null) return {
        x: 1,
        y: 0
    };
    var dx = point.x - x0;
    var dy = point.y - y0;
    var ln = Math.sqrt(dx * dx + dy * dy);
    return {
        x: ln ? dx / ln : 0,
        y: ln ? dy / ln : -1
    };
}
function aligned(x, y, vx, vy, align) {
    switch(align){
        case "center":
            vx = vy = 0;
            break;
        case "bottom":
            vx = 0;
            vy = 1;
            break;
        case "right":
            vx = 1;
            vy = 0;
            break;
        case "left":
            vx = -1;
            vy = 0;
            break;
        case "top":
            vx = 0;
            vy = -1;
            break;
        case "start":
            vx = -vx;
            vy = -vy;
            break;
        case "end":
            break;
        default:
            // clockwise rotation (in degree)
            align *= Math.PI / 180;
            vx = Math.cos(align);
            vy = Math.sin(align);
            break;
    }
    return {
        x: x,
        y: y,
        vx: vx,
        vy: vy
    };
}
// Line clipping (Cohen–Sutherland algorithm)
// https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm
var R_INSIDE = 0;
var R_LEFT = 1;
var R_RIGHT = 2;
var R_BOTTOM = 4;
var R_TOP = 8;
function region(x, y, rect) {
    var res = R_INSIDE;
    if (x < rect.left) res |= R_LEFT;
    else if (x > rect.right) res |= R_RIGHT;
    if (y < rect.top) res |= R_TOP;
    else if (y > rect.bottom) res |= R_BOTTOM;
    return res;
}
function clipped(segment, area) {
    var x0 = segment.x0;
    var y0 = segment.y0;
    var x1 = segment.x1;
    var y1 = segment.y1;
    var r0 = region(x0, y0, area);
    var r1 = region(x1, y1, area);
    var r, x, y;
    // eslint-disable-next-line no-constant-condition
    while(true){
        if (!(r0 | r1) || r0 & r1) break;
        // at least one point is outside
        r = r0 || r1;
        if (r & R_TOP) {
            x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
            y = area.top;
        } else if (r & R_BOTTOM) {
            x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
            y = area.bottom;
        } else if (r & R_RIGHT) {
            y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
            x = area.right;
        } else if (r & R_LEFT) {
            y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
            x = area.left;
        }
        if (r === r0) {
            x0 = x;
            y0 = y;
            r0 = region(x0, y0, area);
        } else {
            x1 = x;
            y1 = y;
            r1 = region(x1, y1, area);
        }
    }
    return {
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1
    };
}
function compute$1(range, config) {
    var anchor = config.anchor;
    var segment = range;
    var x, y;
    if (config.clamp) segment = clipped(segment, config.area);
    if (anchor === "start") {
        x = segment.x0;
        y = segment.y0;
    } else if (anchor === "end") {
        x = segment.x1;
        y = segment.y1;
    } else {
        x = (segment.x0 + segment.x1) / 2;
        y = (segment.y0 + segment.y1) / 2;
    }
    return aligned(x, y, range.vx, range.vy, config.align);
}
var positioners = {
    arc: function(el, config) {
        var angle = (el.startAngle + el.endAngle) / 2;
        var vx = Math.cos(angle);
        var vy = Math.sin(angle);
        var r0 = el.innerRadius;
        var r1 = el.outerRadius;
        return compute$1({
            x0: el.x + vx * r0,
            y0: el.y + vy * r0,
            x1: el.x + vx * r1,
            y1: el.y + vy * r1,
            vx: vx,
            vy: vy
        }, config);
    },
    point: function(el, config) {
        var v = orient(el, config.origin);
        var rx = v.x * el.options.radius;
        var ry = v.y * el.options.radius;
        return compute$1({
            x0: el.x - rx,
            y0: el.y - ry,
            x1: el.x + rx,
            y1: el.y + ry,
            vx: v.x,
            vy: v.y
        }, config);
    },
    bar: function(el, config) {
        var v = orient(el, config.origin);
        var x = el.x;
        var y = el.y;
        var sx = 0;
        var sy = 0;
        if (el.horizontal) {
            x = Math.min(el.x, el.base);
            sx = Math.abs(el.base - el.x);
        } else {
            y = Math.min(el.y, el.base);
            sy = Math.abs(el.base - el.y);
        }
        return compute$1({
            x0: x,
            y0: y + sy,
            x1: x + sx,
            y1: y,
            vx: v.x,
            vy: v.y
        }, config);
    },
    fallback: function(el, config) {
        var v = orient(el, config.origin);
        return compute$1({
            x0: el.x,
            y0: el.y,
            x1: el.x + (el.width || 0),
            y1: el.y + (el.height || 0),
            vx: v.x,
            vy: v.y
        }, config);
    }
};
var rasterize = utils.rasterize;
function boundingRects(model) {
    var borderWidth = model.borderWidth || 0;
    var padding = model.padding;
    var th = model.size.height;
    var tw = model.size.width;
    var tx = -tw / 2;
    var ty = -th / 2;
    return {
        frame: {
            x: tx - padding.left - borderWidth,
            y: ty - padding.top - borderWidth,
            w: tw + padding.width + borderWidth * 2,
            h: th + padding.height + borderWidth * 2
        },
        text: {
            x: tx,
            y: ty,
            w: tw,
            h: th
        }
    };
}
function getScaleOrigin(el, context) {
    var scale = context.chart.getDatasetMeta(context.datasetIndex).vScale;
    if (!scale) return null;
    if (scale.xCenter !== undefined && scale.yCenter !== undefined) return {
        x: scale.xCenter,
        y: scale.yCenter
    };
    var pixel = scale.getBasePixel();
    return el.horizontal ? {
        x: pixel,
        y: null
    } : {
        x: null,
        y: pixel
    };
}
function getPositioner(el) {
    if (el instanceof (0, _chartJs.ArcElement)) return positioners.arc;
    if (el instanceof (0, _chartJs.PointElement)) return positioners.point;
    if (el instanceof (0, _chartJs.BarElement)) return positioners.bar;
    return positioners.fallback;
}
function drawRoundedRect(ctx, x, y, w, h, radius) {
    var HALF_PI = Math.PI / 2;
    if (radius) {
        var r = Math.min(radius, h / 2, w / 2);
        var left = x + r;
        var top = y + r;
        var right = x + w - r;
        var bottom = y + h - r;
        ctx.moveTo(x, top);
        if (left < right && top < bottom) {
            ctx.arc(left, top, r, -Math.PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, Math.PI);
        } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, Math.PI + HALF_PI);
        } else if (top < bottom) {
            ctx.arc(left, top, r, -Math.PI, 0);
            ctx.arc(left, bottom, r, 0, Math.PI);
        } else ctx.arc(left, top, r, -Math.PI, Math.PI);
        ctx.closePath();
        ctx.moveTo(x, y);
    } else ctx.rect(x, y, w, h);
}
function drawFrame(ctx, rect, model) {
    var bgColor = model.backgroundColor;
    var borderColor = model.borderColor;
    var borderWidth = model.borderWidth;
    if (!bgColor && (!borderColor || !borderWidth)) return;
    ctx.beginPath();
    drawRoundedRect(ctx, rasterize(rect.x) + borderWidth / 2, rasterize(rect.y) + borderWidth / 2, rasterize(rect.w) - borderWidth, rasterize(rect.h) - borderWidth, model.borderRadius);
    ctx.closePath();
    if (bgColor) {
        ctx.fillStyle = bgColor;
        ctx.fill();
    }
    if (borderColor && borderWidth) {
        ctx.strokeStyle = borderColor;
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = "miter";
        ctx.stroke();
    }
}
function textGeometry(rect, align, font) {
    var h = font.lineHeight;
    var w = rect.w;
    var x = rect.x;
    var y = rect.y + h / 2;
    if (align === "center") x += w / 2;
    else if (align === "end" || align === "right") x += w;
    return {
        h: h,
        w: w,
        x: x,
        y: y
    };
}
function drawTextLine(ctx, text, cfg) {
    var shadow = ctx.shadowBlur;
    var stroked = cfg.stroked;
    var x = rasterize(cfg.x);
    var y = rasterize(cfg.y);
    var w = rasterize(cfg.w);
    if (stroked) ctx.strokeText(text, x, y, w);
    if (cfg.filled) {
        if (shadow && stroked) // Prevent drawing shadow on both the text stroke and fill, so
        // if the text is stroked, remove the shadow for the text fill.
        ctx.shadowBlur = 0;
        ctx.fillText(text, x, y, w);
        if (shadow && stroked) ctx.shadowBlur = shadow;
    }
}
function drawText(ctx, lines, rect, model) {
    var align = model.textAlign;
    var color = model.color;
    var filled = !!color;
    var font = model.font;
    var ilen = lines.length;
    var strokeColor = model.textStrokeColor;
    var strokeWidth = model.textStrokeWidth;
    var stroked = strokeColor && strokeWidth;
    var i;
    if (!ilen || !filled && !stroked) return;
    // Adjust coordinates based on text alignment and line height
    rect = textGeometry(rect, align, font);
    ctx.font = font.string;
    ctx.textAlign = align;
    ctx.textBaseline = "middle";
    ctx.shadowBlur = model.textShadowBlur;
    ctx.shadowColor = model.textShadowColor;
    if (filled) ctx.fillStyle = color;
    if (stroked) {
        ctx.lineJoin = "round";
        ctx.lineWidth = strokeWidth;
        ctx.strokeStyle = strokeColor;
    }
    for(i = 0, ilen = lines.length; i < ilen; ++i)drawTextLine(ctx, lines[i], {
        stroked: stroked,
        filled: filled,
        w: rect.w,
        x: rect.x,
        y: rect.y + rect.h * i
    });
}
var Label = function(config, ctx, el, index) {
    var me = this;
    me._config = config;
    me._index = index;
    me._model = null;
    me._rects = null;
    me._ctx = ctx;
    me._el = el;
};
(0, _helpers.merge)(Label.prototype, {
    /**
   * @private
   */ _modelize: function(display, lines, config, context) {
        var me = this;
        var index = me._index;
        var font = (0, _helpers.toFont)((0, _helpers.resolve)([
            config.font,
            {}
        ], context, index));
        var color = (0, _helpers.resolve)([
            config.color,
            (0, _chartJs.defaults).color
        ], context, index);
        return {
            align: (0, _helpers.resolve)([
                config.align,
                "center"
            ], context, index),
            anchor: (0, _helpers.resolve)([
                config.anchor,
                "center"
            ], context, index),
            area: context.chart.chartArea,
            backgroundColor: (0, _helpers.resolve)([
                config.backgroundColor,
                null
            ], context, index),
            borderColor: (0, _helpers.resolve)([
                config.borderColor,
                null
            ], context, index),
            borderRadius: (0, _helpers.resolve)([
                config.borderRadius,
                0
            ], context, index),
            borderWidth: (0, _helpers.resolve)([
                config.borderWidth,
                0
            ], context, index),
            clamp: (0, _helpers.resolve)([
                config.clamp,
                false
            ], context, index),
            clip: (0, _helpers.resolve)([
                config.clip,
                false
            ], context, index),
            color: color,
            display: display,
            font: font,
            lines: lines,
            offset: (0, _helpers.resolve)([
                config.offset,
                4
            ], context, index),
            opacity: (0, _helpers.resolve)([
                config.opacity,
                1
            ], context, index),
            origin: getScaleOrigin(me._el, context),
            padding: (0, _helpers.toPadding)((0, _helpers.resolve)([
                config.padding,
                4
            ], context, index)),
            positioner: getPositioner(me._el),
            rotation: (0, _helpers.resolve)([
                config.rotation,
                0
            ], context, index) * (Math.PI / 180),
            size: utils.textSize(me._ctx, lines, font),
            textAlign: (0, _helpers.resolve)([
                config.textAlign,
                "start"
            ], context, index),
            textShadowBlur: (0, _helpers.resolve)([
                config.textShadowBlur,
                0
            ], context, index),
            textShadowColor: (0, _helpers.resolve)([
                config.textShadowColor,
                color
            ], context, index),
            textStrokeColor: (0, _helpers.resolve)([
                config.textStrokeColor,
                color
            ], context, index),
            textStrokeWidth: (0, _helpers.resolve)([
                config.textStrokeWidth,
                0
            ], context, index)
        };
    },
    update: function(context) {
        var me = this;
        var model = null;
        var rects = null;
        var index = me._index;
        var config = me._config;
        var value, label, lines;
        // We first resolve the display option (separately) to avoid computing
        // other options in case the label is hidden (i.e. display: false).
        var display = (0, _helpers.resolve)([
            config.display,
            true
        ], context, index);
        if (display) {
            value = context.dataset.data[index];
            label = (0, _helpers.valueOrDefault)((0, _helpers.callback)(config.formatter, [
                value,
                context
            ]), value);
            lines = (0, _helpers.isNullOrUndef)(label) ? [] : utils.toTextLines(label);
            if (lines.length) {
                model = me._modelize(display, lines, config, context);
                rects = boundingRects(model);
            }
        }
        me._model = model;
        me._rects = rects;
    },
    geometry: function() {
        return this._rects ? this._rects.frame : {};
    },
    rotation: function() {
        return this._model ? this._model.rotation : 0;
    },
    visible: function() {
        return this._model && this._model.opacity;
    },
    model: function() {
        return this._model;
    },
    draw: function(chart, center) {
        var me = this;
        var ctx = chart.ctx;
        var model = me._model;
        var rects = me._rects;
        var area;
        if (!this.visible()) return;
        ctx.save();
        if (model.clip) {
            area = model.area;
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        }
        ctx.globalAlpha = utils.bound(0, model.opacity, 1);
        ctx.translate(rasterize(center.x), rasterize(center.y));
        ctx.rotate(model.rotation);
        drawFrame(ctx, rects.frame, model);
        drawText(ctx, model.lines, rects.text, model);
        ctx.restore();
    }
});
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991; // eslint-disable-line es/no-number-minsafeinteger
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991; // eslint-disable-line es/no-number-maxsafeinteger
function rotated(point, center, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var cx = center.x;
    var cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
function projected(points, axis) {
    var min = MAX_INTEGER;
    var max = MIN_INTEGER;
    var origin = axis.origin;
    var i, pt, vx, vy, dp;
    for(i = 0; i < points.length; ++i){
        pt = points[i];
        vx = pt.x - origin.x;
        vy = pt.y - origin.y;
        dp = axis.vx * vx + axis.vy * vy;
        min = Math.min(min, dp);
        max = Math.max(max, dp);
    }
    return {
        min: min,
        max: max
    };
}
function toAxis(p0, p1) {
    var vx = p1.x - p0.x;
    var vy = p1.y - p0.y;
    var ln = Math.sqrt(vx * vx + vy * vy);
    return {
        vx: (p1.x - p0.x) / ln,
        vy: (p1.y - p0.y) / ln,
        origin: p0,
        ln: ln
    };
}
var HitBox = function() {
    this._rotation = 0;
    this._rect = {
        x: 0,
        y: 0,
        w: 0,
        h: 0
    };
};
(0, _helpers.merge)(HitBox.prototype, {
    center: function() {
        var r = this._rect;
        return {
            x: r.x + r.w / 2,
            y: r.y + r.h / 2
        };
    },
    update: function(center, rect, rotation) {
        this._rotation = rotation;
        this._rect = {
            x: rect.x + center.x,
            y: rect.y + center.y,
            w: rect.w,
            h: rect.h
        };
    },
    contains: function(point) {
        var me = this;
        var margin = 1;
        var rect = me._rect;
        point = rotated(point, me.center(), -me._rotation);
        return !(point.x < rect.x - margin || point.y < rect.y - margin || point.x > rect.x + rect.w + margin * 2 || point.y > rect.y + rect.h + margin * 2);
    },
    // Separating Axis Theorem
    // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
    intersects: function(other) {
        var r0 = this._points();
        var r1 = other._points();
        var axes = [
            toAxis(r0[0], r0[1]),
            toAxis(r0[0], r0[3])
        ];
        var i, pr0, pr1;
        if (this._rotation !== other._rotation) // Only separate with r1 axis if the rotation is different,
        // else it's enough to separate r0 and r1 with r0 axis only!
        axes.push(toAxis(r1[0], r1[1]), toAxis(r1[0], r1[3]));
        for(i = 0; i < axes.length; ++i){
            pr0 = projected(r0, axes[i]);
            pr1 = projected(r1, axes[i]);
            if (pr0.max < pr1.min || pr1.max < pr0.min) return false;
        }
        return true;
    },
    /**
   * @private
   */ _points: function() {
        var me = this;
        var rect = me._rect;
        var angle = me._rotation;
        var center = me.center();
        return [
            rotated({
                x: rect.x,
                y: rect.y
            }, center, angle),
            rotated({
                x: rect.x + rect.w,
                y: rect.y
            }, center, angle),
            rotated({
                x: rect.x + rect.w,
                y: rect.y + rect.h
            }, center, angle),
            rotated({
                x: rect.x,
                y: rect.y + rect.h
            }, center, angle)
        ];
    }
});
function coordinates(el, model, geometry) {
    var point = model.positioner(el, model);
    var vx = point.vx;
    var vy = point.vy;
    if (!vx && !vy) // if aligned center, we don't want to offset the center point
    return {
        x: point.x,
        y: point.y
    };
    var w = geometry.w;
    var h = geometry.h;
    // take in account the label rotation
    var rotation = model.rotation;
    var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
    var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));
    // scale the unit vector (vx, vy) to get at least dx or dy equal to
    // w or h respectively (else we would calculate the distance to the
    // ellipse inscribed in the bounding rect)
    var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
    dx *= vx * vs;
    dy *= vy * vs;
    // finally, include the explicit offset
    dx += model.offset * vx;
    dy += model.offset * vy;
    return {
        x: point.x + dx,
        y: point.y + dy
    };
}
function collide(labels, collider) {
    var i, j, s0, s1;
    // IMPORTANT Iterate in the reverse order since items at the end of the
    // list have an higher weight/priority and thus should be less impacted
    // by the overlapping strategy.
    for(i = labels.length - 1; i >= 0; --i){
        s0 = labels[i].$layout;
        for(j = i - 1; j >= 0 && s0._visible; --j){
            s1 = labels[j].$layout;
            if (s1._visible && s0._box.intersects(s1._box)) collider(s0, s1);
        }
    }
    return labels;
}
function compute(labels) {
    var i, ilen, label, state, geometry, center, proxy;
    // Initialize labels for overlap detection
    for(i = 0, ilen = labels.length; i < ilen; ++i){
        label = labels[i];
        state = label.$layout;
        if (state._visible) {
            // Chart.js 3 removed el._model in favor of getProps(), making harder to
            // abstract reading values in positioners. Also, using string arrays to
            // read values (i.e. var {a,b,c} = el.getProps(["a","b","c"])) would make
            // positioners inefficient in the normal case (i.e. not the final values)
            // and the code a bit ugly, so let's use a Proxy instead.
            proxy = new Proxy(label._el, {
                get: (el, p)=>el.getProps([
                        p
                    ], true)[p]
            });
            geometry = label.geometry();
            center = coordinates(proxy, label.model(), geometry);
            state._box.update(center, geometry, label.rotation());
        }
    }
    // Auto hide overlapping labels
    return collide(labels, function(s0, s1) {
        var h0 = s0._hidable;
        var h1 = s1._hidable;
        if (h0 && h1 || h1) s1._visible = false;
        else if (h0) s0._visible = false;
    });
}
var layout = {
    prepare: function(datasets) {
        var labels = [];
        var i, j, ilen, jlen, label;
        for(i = 0, ilen = datasets.length; i < ilen; ++i)for(j = 0, jlen = datasets[i].length; j < jlen; ++j){
            label = datasets[i][j];
            labels.push(label);
            label.$layout = {
                _box: new HitBox(),
                _hidable: false,
                _visible: true,
                _set: i,
                _idx: label._index
            };
        }
        // TODO New `z` option: labels with a higher z-index are drawn
        // of top of the ones with a lower index. Lowest z-index labels
        // are also discarded first when hiding overlapping labels.
        labels.sort(function(a, b) {
            var sa = a.$layout;
            var sb = b.$layout;
            return sa._idx === sb._idx ? sb._set - sa._set : sb._idx - sa._idx;
        });
        this.update(labels);
        return labels;
    },
    update: function(labels) {
        var dirty = false;
        var i, ilen, label, model, state;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            model = label.model();
            state = label.$layout;
            state._hidable = model && model.display === "auto";
            state._visible = label.visible();
            dirty |= state._hidable;
        }
        if (dirty) compute(labels);
    },
    lookup: function(labels, point) {
        var i, state;
        // IMPORTANT Iterate in the reverse order since items at the end of
        // the list have an higher z-index, thus should be picked first.
        for(i = labels.length - 1; i >= 0; --i){
            state = labels[i].$layout;
            if (state && state._visible && state._box.contains(point)) return labels[i];
        }
        return null;
    },
    draw: function(chart, labels) {
        var i, ilen, label, state, geometry, center;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            state = label.$layout;
            if (state._visible) {
                geometry = label.geometry();
                center = coordinates(label._el, label.model(), geometry);
                state._box.update(center, geometry, label.rotation());
                label.draw(chart, center);
            }
        }
    }
};
var formatter = function(value) {
    if ((0, _helpers.isNullOrUndef)(value)) return null;
    var label = value;
    var keys, klen, k;
    if ((0, _helpers.isObject)(value)) {
        if (!(0, _helpers.isNullOrUndef)(value.label)) label = value.label;
        else if (!(0, _helpers.isNullOrUndef)(value.r)) label = value.r;
        else {
            label = "";
            keys = Object.keys(value);
            for(k = 0, klen = keys.length; k < klen; ++k)label += (k !== 0 ? ", " : "") + keys[k] + ": " + value[keys[k]];
        }
    }
    return "" + label;
};
/**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */ var defaults = {
    align: "center",
    anchor: "center",
    backgroundColor: null,
    borderColor: null,
    borderRadius: 0,
    borderWidth: 0,
    clamp: false,
    clip: false,
    color: undefined,
    display: true,
    font: {
        family: undefined,
        lineHeight: 1.2,
        size: undefined,
        style: undefined,
        weight: null
    },
    formatter: formatter,
    labels: undefined,
    listeners: {},
    offset: 4,
    opacity: 1,
    padding: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
    },
    rotation: 0,
    textAlign: "start",
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    textShadowBlur: 0,
    textShadowColor: undefined
};
/**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */ var EXPANDO_KEY = "$datalabels";
var DEFAULT_KEY = "$default";
function configure(dataset, options) {
    var override = dataset.datalabels;
    var listeners = {};
    var configs = [];
    var labels, keys;
    if (override === false) return null;
    if (override === true) override = {};
    options = (0, _helpers.merge)({}, [
        options,
        override
    ]);
    labels = options.labels || {};
    keys = Object.keys(labels);
    delete options.labels;
    if (keys.length) keys.forEach(function(key) {
        if (labels[key]) configs.push((0, _helpers.merge)({}, [
            options,
            labels[key],
            {
                _key: key
            }
        ]));
    });
    else // Default label if no "named" label defined.
    configs.push(options);
    // listeners: {<event-type>: {<label-key>: <fn>}}
    listeners = configs.reduce(function(target, config) {
        (0, _helpers.each)(config.listeners || {}, function(fn, event) {
            target[event] = target[event] || {};
            target[event][config._key || DEFAULT_KEY] = fn;
        });
        delete config.listeners;
        return target;
    }, {});
    return {
        labels: configs,
        listeners: listeners
    };
}
function dispatchEvent(chart, listeners, label, event) {
    if (!listeners) return;
    var context = label.$context;
    var groups = label.$groups;
    var callback$1;
    if (!listeners[groups._set]) return;
    callback$1 = listeners[groups._set][groups._key];
    if (!callback$1) return;
    if ((0, _helpers.callback)(callback$1, [
        context,
        event
    ]) === true) {
        // Users are allowed to tweak the given context by injecting values that can be
        // used in scriptable options to display labels differently based on the current
        // event (e.g. highlight an hovered label). That's why we update the label with
        // the output context and schedule a new chart render by setting it dirty.
        chart[EXPANDO_KEY]._dirty = true;
        label.update(context);
    }
}
function dispatchMoveEvents(chart, listeners, previous, label, event) {
    var enter, leave;
    if (!previous && !label) return;
    if (!previous) enter = true;
    else if (!label) leave = true;
    else if (previous !== label) leave = enter = true;
    if (leave) dispatchEvent(chart, listeners.leave, previous, event);
    if (enter) dispatchEvent(chart, listeners.enter, label, event);
}
function handleMoveEvents(chart, event) {
    var expando = chart[EXPANDO_KEY];
    var listeners = expando._listeners;
    var previous, label;
    if (!listeners.enter && !listeners.leave) return;
    if (event.type === "mousemove") label = layout.lookup(expando._labels, event);
    else if (event.type !== "mouseout") return;
    previous = expando._hovered;
    expando._hovered = label;
    dispatchMoveEvents(chart, listeners, previous, label, event);
}
function handleClickEvents(chart, event) {
    var expando = chart[EXPANDO_KEY];
    var handlers = expando._listeners.click;
    var label = handlers && layout.lookup(expando._labels, event);
    if (label) dispatchEvent(chart, handlers, label, event);
}
var plugin = {
    id: "datalabels",
    defaults: defaults,
    beforeInit: function(chart) {
        chart[EXPANDO_KEY] = {
            _actives: []
        };
    },
    beforeUpdate: function(chart) {
        var expando = chart[EXPANDO_KEY];
        expando._listened = false;
        expando._listeners = {}; // {<event-type>: {<dataset-index>: {<label-key>: <fn>}}}
        expando._datasets = []; // per dataset labels: [Label[]]
        expando._labels = []; // layouted labels: Label[]
    },
    afterDatasetUpdate: function(chart, args, options) {
        var datasetIndex = args.index;
        var expando = chart[EXPANDO_KEY];
        var labels = expando._datasets[datasetIndex] = [];
        var visible = chart.isDatasetVisible(datasetIndex);
        var dataset = chart.data.datasets[datasetIndex];
        var config = configure(dataset, options);
        var elements = args.meta.data || [];
        var ctx = chart.ctx;
        var i, j, ilen, jlen, cfg, key, el, label;
        ctx.save();
        for(i = 0, ilen = elements.length; i < ilen; ++i){
            el = elements[i];
            el[EXPANDO_KEY] = [];
            if (visible && el && chart.getDataVisibility(i) && !el.skip) for(j = 0, jlen = config.labels.length; j < jlen; ++j){
                cfg = config.labels[j];
                key = cfg._key;
                label = new Label(cfg, ctx, el, i);
                label.$groups = {
                    _set: datasetIndex,
                    _key: key || DEFAULT_KEY
                };
                label.$context = {
                    active: false,
                    chart: chart,
                    dataIndex: i,
                    dataset: dataset,
                    datasetIndex: datasetIndex
                };
                label.update(label.$context);
                el[EXPANDO_KEY].push(label);
                labels.push(label);
            }
        }
        ctx.restore();
        // Store listeners at the chart level and per event type to optimize
        // cases where no listeners are registered for a specific event.
        (0, _helpers.merge)(expando._listeners, config.listeners, {
            merger: function(event, target, source) {
                target[event] = target[event] || {};
                target[event][args.index] = source[event];
                expando._listened = true;
            }
        });
    },
    afterUpdate: function(chart) {
        chart[EXPANDO_KEY]._labels = layout.prepare(chart[EXPANDO_KEY]._datasets);
    },
    // Draw labels on top of all dataset elements
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
    afterDatasetsDraw: function(chart) {
        layout.draw(chart, chart[EXPANDO_KEY]._labels);
    },
    beforeEvent: function(chart, args) {
        // If there is no listener registered for this chart, `listened` will be false,
        // meaning we can immediately ignore the incoming event and avoid useless extra
        // computation for users who don't implement label interactions.
        if (chart[EXPANDO_KEY]._listened) {
            var event = args.event;
            switch(event.type){
                case "mousemove":
                case "mouseout":
                    handleMoveEvents(chart, event);
                    break;
                case "click":
                    handleClickEvents(chart, event);
                    break;
            }
        }
    },
    afterEvent: function(chart) {
        var expando = chart[EXPANDO_KEY];
        var previous = expando._actives;
        var actives = expando._actives = chart.getActiveElements();
        var updates = utils.arrayDiff(previous, actives);
        var i, ilen, j, jlen, update, label, labels;
        for(i = 0, ilen = updates.length; i < ilen; ++i){
            update = updates[i];
            if (update[1]) {
                labels = update[0].element[EXPANDO_KEY] || [];
                for(j = 0, jlen = labels.length; j < jlen; ++j){
                    label = labels[j];
                    label.$context.active = update[1] === 1;
                    label.update(label.$context);
                }
            }
        }
        if (expando._dirty || updates.length) {
            layout.update(expando._labels);
            chart.render();
        }
        delete expando._dirty;
    }
};

},{"chart.js/helpers":"erb5b","chart.js":"gQHtV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"erb5b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _helpersJs = require("../dist/helpers.js");
parcelHelpers.exportAll(_helpersJs, exports);

},{"../dist/helpers.js":"7Bzdz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Bzdz":[function(require,module,exports) {
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HALF_PI", ()=>(0, _helpersSegmentJs.H));
parcelHelpers.export(exports, "INFINITY", ()=>(0, _helpersSegmentJs.b2));
parcelHelpers.export(exports, "PI", ()=>(0, _helpersSegmentJs.P));
parcelHelpers.export(exports, "PITAU", ()=>(0, _helpersSegmentJs.b1));
parcelHelpers.export(exports, "QUARTER_PI", ()=>(0, _helpersSegmentJs.b4));
parcelHelpers.export(exports, "RAD_PER_DEG", ()=>(0, _helpersSegmentJs.b3));
parcelHelpers.export(exports, "TAU", ()=>(0, _helpersSegmentJs.T));
parcelHelpers.export(exports, "TWO_THIRDS_PI", ()=>(0, _helpersSegmentJs.b5));
parcelHelpers.export(exports, "_addGrace", ()=>(0, _helpersSegmentJs.R));
parcelHelpers.export(exports, "_alignPixel", ()=>(0, _helpersSegmentJs.X));
parcelHelpers.export(exports, "_alignStartEnd", ()=>(0, _helpersSegmentJs.a2));
parcelHelpers.export(exports, "_angleBetween", ()=>(0, _helpersSegmentJs.p));
parcelHelpers.export(exports, "_angleDiff", ()=>(0, _helpersSegmentJs.b6));
parcelHelpers.export(exports, "_arrayUnique", ()=>(0, _helpersSegmentJs._));
parcelHelpers.export(exports, "_attachContext", ()=>(0, _helpersSegmentJs.a8));
parcelHelpers.export(exports, "_bezierCurveTo", ()=>(0, _helpersSegmentJs.as));
parcelHelpers.export(exports, "_bezierInterpolation", ()=>(0, _helpersSegmentJs.ap));
parcelHelpers.export(exports, "_boundSegment", ()=>(0, _helpersSegmentJs.ax));
parcelHelpers.export(exports, "_boundSegments", ()=>(0, _helpersSegmentJs.an));
parcelHelpers.export(exports, "_capitalize", ()=>(0, _helpersSegmentJs.a5));
parcelHelpers.export(exports, "_computeSegments", ()=>(0, _helpersSegmentJs.am));
parcelHelpers.export(exports, "_createResolver", ()=>(0, _helpersSegmentJs.a9));
parcelHelpers.export(exports, "_decimalPlaces", ()=>(0, _helpersSegmentJs.aK));
parcelHelpers.export(exports, "_deprecated", ()=>(0, _helpersSegmentJs.aV));
parcelHelpers.export(exports, "_descriptors", ()=>(0, _helpersSegmentJs.aa));
parcelHelpers.export(exports, "_elementsEqual", ()=>(0, _helpersSegmentJs.ah));
parcelHelpers.export(exports, "_factorize", ()=>(0, _helpersSegmentJs.N));
parcelHelpers.export(exports, "_filterBetween", ()=>(0, _helpersSegmentJs.aO));
parcelHelpers.export(exports, "_getParentNode", ()=>(0, _helpersSegmentJs.I));
parcelHelpers.export(exports, "_getStartAndCountOfVisiblePoints", ()=>(0, _helpersSegmentJs.q));
parcelHelpers.export(exports, "_int16Range", ()=>(0, _helpersSegmentJs.W));
parcelHelpers.export(exports, "_isBetween", ()=>(0, _helpersSegmentJs.aj));
parcelHelpers.export(exports, "_isClickEvent", ()=>(0, _helpersSegmentJs.ai));
parcelHelpers.export(exports, "_isDomSupported", ()=>(0, _helpersSegmentJs.M));
parcelHelpers.export(exports, "_isPointInArea", ()=>(0, _helpersSegmentJs.C));
parcelHelpers.export(exports, "_limitValue", ()=>(0, _helpersSegmentJs.S));
parcelHelpers.export(exports, "_longestText", ()=>(0, _helpersSegmentJs.aN));
parcelHelpers.export(exports, "_lookup", ()=>(0, _helpersSegmentJs.aP));
parcelHelpers.export(exports, "_lookupByKey", ()=>(0, _helpersSegmentJs.B));
parcelHelpers.export(exports, "_measureText", ()=>(0, _helpersSegmentJs.V));
parcelHelpers.export(exports, "_merger", ()=>(0, _helpersSegmentJs.aT));
parcelHelpers.export(exports, "_mergerIf", ()=>(0, _helpersSegmentJs.aU));
parcelHelpers.export(exports, "_normalizeAngle", ()=>(0, _helpersSegmentJs.ay));
parcelHelpers.export(exports, "_parseObjectDataRadialScale", ()=>(0, _helpersSegmentJs.y));
parcelHelpers.export(exports, "_pointInLine", ()=>(0, _helpersSegmentJs.aq));
parcelHelpers.export(exports, "_readValueToProps", ()=>(0, _helpersSegmentJs.ak));
parcelHelpers.export(exports, "_rlookupByKey", ()=>(0, _helpersSegmentJs.A));
parcelHelpers.export(exports, "_scaleRangesChanged", ()=>(0, _helpersSegmentJs.w));
parcelHelpers.export(exports, "_setMinAndMaxByKey", ()=>(0, _helpersSegmentJs.aG));
parcelHelpers.export(exports, "_splitKey", ()=>(0, _helpersSegmentJs.aW));
parcelHelpers.export(exports, "_steppedInterpolation", ()=>(0, _helpersSegmentJs.ao));
parcelHelpers.export(exports, "_steppedLineTo", ()=>(0, _helpersSegmentJs.ar));
parcelHelpers.export(exports, "_textX", ()=>(0, _helpersSegmentJs.aB));
parcelHelpers.export(exports, "_toLeftRightCenter", ()=>(0, _helpersSegmentJs.a1));
parcelHelpers.export(exports, "_updateBezierControlPoints", ()=>(0, _helpersSegmentJs.al));
parcelHelpers.export(exports, "addRoundedRectPath", ()=>(0, _helpersSegmentJs.au));
parcelHelpers.export(exports, "almostEquals", ()=>(0, _helpersSegmentJs.aJ));
parcelHelpers.export(exports, "almostWhole", ()=>(0, _helpersSegmentJs.aI));
parcelHelpers.export(exports, "callback", ()=>(0, _helpersSegmentJs.Q));
parcelHelpers.export(exports, "clearCanvas", ()=>(0, _helpersSegmentJs.af));
parcelHelpers.export(exports, "clipArea", ()=>(0, _helpersSegmentJs.Y));
parcelHelpers.export(exports, "clone", ()=>(0, _helpersSegmentJs.aS));
parcelHelpers.export(exports, "color", ()=>(0, _helpersSegmentJs.c));
parcelHelpers.export(exports, "createContext", ()=>(0, _helpersSegmentJs.j));
parcelHelpers.export(exports, "debounce", ()=>(0, _helpersSegmentJs.ad));
parcelHelpers.export(exports, "defined", ()=>(0, _helpersSegmentJs.h));
parcelHelpers.export(exports, "distanceBetweenPoints", ()=>(0, _helpersSegmentJs.aE));
parcelHelpers.export(exports, "drawPoint", ()=>(0, _helpersSegmentJs.at));
parcelHelpers.export(exports, "drawPointLegend", ()=>(0, _helpersSegmentJs.aD));
parcelHelpers.export(exports, "each", ()=>(0, _helpersSegmentJs.F));
parcelHelpers.export(exports, "easingEffects", ()=>(0, _helpersSegmentJs.e));
parcelHelpers.export(exports, "finiteOrDefault", ()=>(0, _helpersSegmentJs.O));
parcelHelpers.export(exports, "fontString", ()=>(0, _helpersSegmentJs.a$));
parcelHelpers.export(exports, "formatNumber", ()=>(0, _helpersSegmentJs.o));
parcelHelpers.export(exports, "getAngleFromPoint", ()=>(0, _helpersSegmentJs.D));
parcelHelpers.export(exports, "getHoverColor", ()=>(0, _helpersSegmentJs.aR));
parcelHelpers.export(exports, "getMaximumSize", ()=>(0, _helpersSegmentJs.G));
parcelHelpers.export(exports, "getRelativePosition", ()=>(0, _helpersSegmentJs.z));
parcelHelpers.export(exports, "getRtlAdapter", ()=>(0, _helpersSegmentJs.az));
parcelHelpers.export(exports, "getStyle", ()=>(0, _helpersSegmentJs.a_));
parcelHelpers.export(exports, "isArray", ()=>(0, _helpersSegmentJs.b));
parcelHelpers.export(exports, "isFinite", ()=>(0, _helpersSegmentJs.g));
parcelHelpers.export(exports, "isFunction", ()=>(0, _helpersSegmentJs.a7));
parcelHelpers.export(exports, "isNullOrUndef", ()=>(0, _helpersSegmentJs.k));
parcelHelpers.export(exports, "isNumber", ()=>(0, _helpersSegmentJs.x));
parcelHelpers.export(exports, "isObject", ()=>(0, _helpersSegmentJs.i));
parcelHelpers.export(exports, "isPatternOrGradient", ()=>(0, _helpersSegmentJs.aQ));
parcelHelpers.export(exports, "listenArrayEvents", ()=>(0, _helpersSegmentJs.l));
parcelHelpers.export(exports, "log10", ()=>(0, _helpersSegmentJs.aM));
parcelHelpers.export(exports, "merge", ()=>(0, _helpersSegmentJs.a4));
parcelHelpers.export(exports, "mergeIf", ()=>(0, _helpersSegmentJs.ab));
parcelHelpers.export(exports, "niceNum", ()=>(0, _helpersSegmentJs.aH));
parcelHelpers.export(exports, "noop", ()=>(0, _helpersSegmentJs.aF));
parcelHelpers.export(exports, "overrideTextDirection", ()=>(0, _helpersSegmentJs.aA));
parcelHelpers.export(exports, "readUsedSize", ()=>(0, _helpersSegmentJs.J));
parcelHelpers.export(exports, "renderText", ()=>(0, _helpersSegmentJs.Z));
parcelHelpers.export(exports, "requestAnimFrame", ()=>(0, _helpersSegmentJs.r));
parcelHelpers.export(exports, "resolve", ()=>(0, _helpersSegmentJs.a));
parcelHelpers.export(exports, "resolveObjectKey", ()=>(0, _helpersSegmentJs.f));
parcelHelpers.export(exports, "restoreTextDirection", ()=>(0, _helpersSegmentJs.aC));
parcelHelpers.export(exports, "retinaScale", ()=>(0, _helpersSegmentJs.ae));
parcelHelpers.export(exports, "setsEqual", ()=>(0, _helpersSegmentJs.ag));
parcelHelpers.export(exports, "sign", ()=>(0, _helpersSegmentJs.s));
parcelHelpers.export(exports, "splineCurve", ()=>(0, _helpersSegmentJs.aY));
parcelHelpers.export(exports, "splineCurveMonotone", ()=>(0, _helpersSegmentJs.aZ));
parcelHelpers.export(exports, "supportsEventListenerOptions", ()=>(0, _helpersSegmentJs.K));
parcelHelpers.export(exports, "throttled", ()=>(0, _helpersSegmentJs.L));
parcelHelpers.export(exports, "toDegrees", ()=>(0, _helpersSegmentJs.U));
parcelHelpers.export(exports, "toDimension", ()=>(0, _helpersSegmentJs.n));
parcelHelpers.export(exports, "toFont", ()=>(0, _helpersSegmentJs.a0));
parcelHelpers.export(exports, "toFontString", ()=>(0, _helpersSegmentJs.aX));
parcelHelpers.export(exports, "toLineHeight", ()=>(0, _helpersSegmentJs.b0));
parcelHelpers.export(exports, "toPadding", ()=>(0, _helpersSegmentJs.E));
parcelHelpers.export(exports, "toPercentage", ()=>(0, _helpersSegmentJs.m));
parcelHelpers.export(exports, "toRadians", ()=>(0, _helpersSegmentJs.t));
parcelHelpers.export(exports, "toTRBL", ()=>(0, _helpersSegmentJs.av));
parcelHelpers.export(exports, "toTRBLCorners", ()=>(0, _helpersSegmentJs.aw));
parcelHelpers.export(exports, "uid", ()=>(0, _helpersSegmentJs.ac));
parcelHelpers.export(exports, "unclipArea", ()=>(0, _helpersSegmentJs.$));
parcelHelpers.export(exports, "unlistenArrayEvents", ()=>(0, _helpersSegmentJs.u));
parcelHelpers.export(exports, "valueOrDefault", ()=>(0, _helpersSegmentJs.v));
var _helpersSegmentJs = require("./chunks/helpers.segment.js");
var _color = require("@kurkle/color");

},{"./chunks/helpers.segment.js":"37JCH","@kurkle/color":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4Jghj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
exports.default = (0, _styledComponentsDefault.default).div`
  background-color: ${({ color })=>color};
  width: var(--p-space-2);
  height: 100%;
  border-radius: var(--p-border-radius-4);
  border: solid thin ${({ border })=>border || "transparent"};
`;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dsYkB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _linkChevronRightSvg = require("../../../assets/icons/link-chevron-right.svg");
var _linkChevronRightSvgDefault = parcelHelpers.interopDefault(_linkChevronRightSvg);
var _icon = require("../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const DashboardNavigation = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { highlight, spacing = "large", hideCaret, onClick, children, ...rest } = props;
    const showCaret = !hideCaret && onClick !== undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDashboardNavigation, {
        $spacing: spacing,
        $highlight: highlight,
        onClick: onClick,
        ref: ref,
        ...rest,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
                children: children
            }),
            showCaret && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _linkChevronRightSvgDefault.default)
            })
        ]
    });
});
const StyledDashboardNavigation = (0, _styledComponentsDefault.default).button`
  --kdk-navigation-spacing: ${({ $spacing })=>$spacing === "medium" ? "var(--p-space-2)" : "var(--p-space-4)"};
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  height: 100%;
  width: 100%;

  padding: var(--kdk-navigation-spacing) calc(var(--kdk-navigation-spacing) / 2) var(--kdk-navigation-spacing)
    var(--kdk-navigation-spacing);

  text-align: left;
  border: none;
  transition: background-color var(--p-motion-duration-100);
  background-color: ${({ $highlight })=>$highlight ? "var(--p-surface-highlight-subdued)" : "inherit"};
  cursor: ${({ onClick })=>onClick ? "pointer" : undefined};

  &:hover {
    background-color: ${({ $highlight })=>$highlight ? "var(--p-surface-highlight-subdued-hovered)" : "var(--p-surface-hovered)"};
  }

  &:active {
    background-color: ${({ $highlight })=>$highlight ? "var(--p-surface-highlight-subdued-pressed)" : "var(--p-surface-pressed)"};
  }
`;
exports.default = DashboardNavigation;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","../../../assets/icons/link-chevron-right.svg":"9isBS","../../components/extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9isBS":[function(require,module,exports) {
module.exports = require("5e115946094c61f").getBundleURL("kEMsi") + "link-chevron-right.d7eeb1fa.svg";

},{"5e115946094c61f":"75UoR"}],"9RIaS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const DashboardNumbersItem = (props)=>{
    const { value = 0, percent = 0, label } = props;
    const { formatNumber } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                blockAlign: "start",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "heading2xl",
                        as: "p",
                        children: formatNumber(value)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPercentWrapper, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "bodyMd",
                            as: "span",
                            fontWeight: "bold",
                            children: formatNumber(percent, {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                                style: "percent"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                variant: "bodyMd",
                fontWeight: "bold",
                truncate: true,
                children: label
            })
        ]
    });
};
const StyledPercentWrapper = (0, _styledComponentsDefault.default).div`
  padding-left: var(--p-space-2);
  display: block;
  margin-left: var(--p-space-2);
  border-left: var(--p-border-divider);
`;
exports.default = DashboardNumbersItem;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iN7sd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const DashboardVerticalStack = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { ...stackProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledStackWrapper, {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
            ...stackProps
        })
    });
});
const StyledStackWrapper = (0, _styledComponentsDefault.default).div`
  height: 100%;

  & > .Polaris-VerticalStack {
    height: 100%;
  }

  & > .Polaris-VerticalStack > * + * {
    border-top: var(--p-border-divider);
  }
`;
exports.default = DashboardVerticalStack;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"98uzT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFlipMove = require("react-flip-move");
var _reactFlipMoveDefault = parcelHelpers.interopDefault(_reactFlipMove);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _infoBlueSvg = require("../../../assets/icons/info-blue.svg");
var _infoBlueSvgDefault = parcelHelpers.interopDefault(_infoBlueSvg);
var _condensedText = require("../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _tooltipWrapper = require("../../components/TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
const DashboardWidget = (props)=>{
    const { title, infoTooltip, loading, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCard, {
        className: "Polaris-Card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                flush: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledHeader, {
                        children: title
                    }),
                    infoTooltip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTooltipContent, {
                            children: infoTooltip
                        }),
                        dismissOnMouseOut: true,
                        preferredPosition: "above",
                        width: "wide",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: (0, _infoBlueSvgDefault.default)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                flush: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledFlipMove, {
                    children: [
                        loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLoadingContainer, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {})
                        }),
                        !loading && children
                    ]
                })
            })
        ]
    });
};
const StyledCard = (0, _styledComponentsDefault.default).div`
  display: flex;
  flex-direction: column;

  & .Polaris-Card__Section:last-child {
    flex: 1;
    overflow: hidden;
  }

  & .Polaris-Card__Section:last-child > div {
    height: 100%;
  }
`;
const StyledHeader = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  text-transform: uppercase;
  display: inline-block;
  padding: var(--p-space-1) var(--p-space-1) var(--p-space-1) var(--p-space-4);
`;
const StyledFlipMove = (0, _styledComponentsDefault.default)((0, _reactFlipMoveDefault.default))`
  height: 100%;
`;
const StyledLoadingContainer = (0, _styledComponentsDefault.default).div`
  min-height: 16rem;
  display: grid;
  grid-template-rows: auto min-content;
  place-items: center;
`;
const StyledTooltipContent = (0, _styledComponentsDefault.default).p`
  white-space: pre-wrap;
`;
exports.default = DashboardWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-flip-move":"7Sobo","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/info-blue.svg":"kCjLz","../../components/CondensedText/CondensedText":"1FshD","../../components/TooltipWrapper/TooltipWrapper":"b5W2d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eWi9U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _customersListSearchParams = require("../../constants/customers-list-search-params");
var _routes = require("../../constants/routes");
var _sessionState = require("../../constants/session-state");
var _useClearLastWindowLocationSearch = require("../../hooks/useClearLastWindowLocationSearch");
var _useClearLastWindowLocationSearchDefault = parcelHelpers.interopDefault(_useClearLastWindowLocationSearch);
const useDashboardNavigation = ()=>{
    const history = (0, _reactRouterDom.useHistory)();
    const location = (0, _reactRouterDom.useLocation)();
    const clearLastWindowLocationSearch = (0, _useClearLastWindowLocationSearchDefault.default)((0, _sessionState.CUSTOMERS_LIST_SEARCH));
    const navigateToCustomersList = (params)=>{
        clearLastWindowLocationSearch();
        const searchParams = new URLSearchParams(location.search);
        Object.entries(params).forEach(([name, value])=>searchParams.set(name, value));
        const url = `${(0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMERS)}?${searchParams.toString()}`;
        history.push(url, {
            ...location.state,
            fromDashboard: true
        });
    };
    const navigateToPendingTasks = ()=>navigateToCustomersList({
            [(0, _customersListSearchParams.PENDING_TASKS_TAB_NAME_PARAMETER)]: "true"
        });
    const navigateToCustomersByRisk = (risk)=>navigateToCustomersList({
            [(0, _customersListSearchParams.RISK_NAME_PARAMETER)]: risk
        });
    const navigateToCustomersByStatus = (statusParam)=>navigateToCustomersList({
            [(0, _customersListSearchParams.STATUS_NAME_PARAMETER)]: statusParam
        });
    const navigateToPepCustomers = (customerType)=>{
        const params = {
            [(0, _customersListSearchParams.MARKED_AS_PEP_NAME_PARAMETER)]: "true"
        };
        if (customerType) params[0, _customersListSearchParams.CUSTOMER_TYPE_NAME_PARAMETER] = customerType;
        navigateToCustomersList(params);
    };
    const navigateToSanctionedCustomers = (customerType)=>{
        const params = {
            [(0, _customersListSearchParams.MARKED_AS_SANCTIONED_NAME_PARAMETER)]: "true"
        };
        if (customerType) params[0, _customersListSearchParams.CUSTOMER_TYPE_NAME_PARAMETER] = customerType;
        navigateToCustomersList(params);
    };
    const navigateToCustomersByType = (customerType)=>navigateToCustomersList({
            [(0, _customersListSearchParams.CUSTOMER_TYPE_NAME_PARAMETER)]: customerType
        });
    const navigateToCustomersByIndustryType = (industryCode)=>navigateToCustomersList({
            [(0, _customersListSearchParams.CUSTOMER_INDUSTRY_CODES_NAME_PARAMETER)]: industryCode
        });
    return {
        navigateToPendingTasks,
        navigateToCustomersByRisk,
        navigateToCustomersByStatus,
        navigateToPepCustomers,
        navigateToSanctionedCustomers,
        navigateToCustomersByType,
        navigateToCustomersByIndustryType
    };
};
exports.default = useDashboardNavigation;

},{"react-router-dom":"1ee65","../../constants/customers-list-search-params":"9nE5m","../../constants/routes":"ihtm8","../../constants/session-state":"g0N7C","../../hooks/useClearLastWindowLocationSearch":"6FkWL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6FkWL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stringUtils = require("../utils/stringUtils");
var _useStorage = require("./useStorage");
const useClearLastWindowLocationSearch = (key)=>{
    const [lastState, setLastState] = (0, _useStorage.useSessionStorage)(key, "");
    const clearLastWindowLocationSearch = ()=>{
        if (!(0, _stringUtils.isEmptyString)(lastState)) setLastState("");
    };
    return clearLastWindowLocationSearch;
};
exports.default = useClearLastWindowLocationSearch;

},{"../utils/stringUtils":"4gVdA","./useStorage":"aERXD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cQgyZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCategoryCode", ()=>isCategoryCode);
var _react = require("react");
var _displayHelpers = require("../../../helpers/display.helpers");
var _useLanguage = require("../../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _collectionUtils = require("../../../utils/collectionUtils");
var _stringUtils = require("../../../utils/stringUtils");
const isCategoryCode = (code)=>!code.includes(".");
const useFilterIndustries = (industries, categories, filter, selectedCategory)=>{
    const language = (0, _useLanguageDefault.default)();
    // group industries by their level 2 code (value before ".")
    // example: "44.087" -> "44"
    const industriesMap = (0, _react.useMemo)(()=>(0, _collectionUtils.groupBy)(industries, (industry)=>industry.industry_code.split(".")[0]), [
        industries,
        categories
    ]);
    const categoriesIndustriesItems = (0, _react.useMemo)(()=>categories.map((category)=>({
                industry_code: category.code,
                industry_name: category.name,
                count: (industriesMap.get(category.code) || []).reduce((result, industry)=>result + industry.count, 0)
            })), [
        industriesMap
    ]);
    // filter list based of text filter
    const filteredItems = (0, _react.useMemo)(()=>{
        const categoryIndustries = selectedCategory ? industriesMap.get(selectedCategory.code) || [] : categoriesIndustriesItems;
        if ((0, _stringUtils.isEmptyString)(filter)) return categoryIndustries;
        return categoryIndustries.filter((industry)=>(0, _displayHelpers.getTranslationText)(language, industry.industry_name).toLocaleLowerCase().includes(filter.toLocaleLowerCase()));
    }, [
        industriesMap,
        filter,
        language,
        selectedCategory
    ]);
    const filteredIndustries = (0, _react.useMemo)(()=>{
        // sort list
        filteredItems.sort((industryA, industryB)=>industryB.count - industryA.count);
        return filteredItems;
    }, [
        filteredItems
    ]);
    return {
        filteredIndustries,
        filteredIndustriesCount: filteredItems.length
    };
};
exports.default = useFilterIndustries;

},{"react":"cOWTg","../../../helpers/display.helpers":"2q3xY","../../../hooks/useLanguage":"2W6IE","../../../utils/collectionUtils":"gr5mc","../../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hIWpH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../../constants/styles");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardWidget = require("../DashboardWidget");
var _dashboardWidgetDefault = parcelHelpers.interopDefault(_dashboardWidget);
var _riskDataRow = require("./RiskDataRow");
var _riskDataRowDefault = parcelHelpers.interopDefault(_riskDataRow);
const RiskDataWidget = (props)=>{
    const { riskData, title, infoTooltip, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardWidgetDefault.default), {
        title: title,
        infoTooltip: infoTooltip,
        loading: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledGridContainer, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledListContainer, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.construction-industry"),
                            value: riskData.CONSTRUCTION_INDUSTRY
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.high-risk-industry"),
                            value: riskData.HIGH_RISK_INDUSTRY
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.PEP"),
                            value: riskData.PEP
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.high-risk-country"),
                            value: riskData.HIGH_RISK_COUNTRY
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledListContainer, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.financed-crypto"),
                            value: riskData.FINANCED_CRYPTO
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.financed-crowdfunding"),
                            value: riskData.FINANCED_CROWDFUNDING
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.missing-work-documentation"),
                            value: riskData.MISSING_WORK_DOCUMENTATION
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDataRowDefault.default), {
                            label: f("dashboard.widgets.risk-data.missing-funding-documentation"),
                            value: riskData.MISSING_FUNDING_DOCUMENTATION
                        })
                    ]
                })
            ]
        })
    });
};
const StyledGridContainer = (0, _styledComponentsDefault.default).div`
  height: 100%;
  min-height: 16rem;

  display: grid;
  grid-template-columns: 1fr 1fr;

  // For small viewports - use vertical layout
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    grid-template-columns: 1fr;
    grid-auto-flow: row;
  }

  & > * + * {
    border-left: var(--p-border-divider);
  }
`;
const StyledListContainer = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-rows: repeat(4, 1fr);

  max-height: 16rem;

  padding: var(--p-space-4);

  & > div:nth-child(even) {
    background-color: var(--p-surface-highlight-subdued-hovered);
  }
`;
exports.default = RiskDataWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","../../../constants/styles":"dZWds","../../../hooks/useFormatMessage":"8Y8fq","../DashboardWidget":"98uzT","./RiskDataRow":"he562","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"he562":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const RiskDataRow = (props)=>{
    const { label, value, ...rest } = props;
    const { formatNumber } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledContainer, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "bodyLg",
                as: "span",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "bodyLg",
                fontWeight: "bold",
                as: "span",
                children: formatNumber(value)
            })
        ]
    });
};
const StyledContainer = (0, _styledComponentsDefault.default).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;

  gap: var(--p-space-4);
  padding: var(--p-space-4);
`;
exports.default = RiskDataRow;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aAlfo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardNavigation = require("./DashboardNavigation");
var _dashboardNavigationDefault = parcelHelpers.interopDefault(_dashboardNavigation);
var _dashboardNumbersItem = require("./DashboardNumbersItem");
var _dashboardNumbersItemDefault = parcelHelpers.interopDefault(_dashboardNumbersItem);
var _dashboardVerticalStack = require("./DashboardVerticalStack");
var _dashboardVerticalStackDefault = parcelHelpers.interopDefault(_dashboardVerticalStack);
var _dashboardWidget = require("./DashboardWidget");
var _dashboardWidgetDefault = parcelHelpers.interopDefault(_dashboardWidget);
var _useDashboardNavigation = require("./useDashboardNavigation");
var _useDashboardNavigationDefault = parcelHelpers.interopDefault(_useDashboardNavigation);
const ReviewStatuses = [
    "APPROVED",
    "REJECTED",
    "REVIEW_REQUIRED",
    "NOT_READY"
];
const STATUS_COLORS = {
    APPROVED: {
        start: "var(--kdk-dashboard-risk-low-gradient-start)",
        end: "var(--kdk-dashboard-risk-low-gradient-end)"
    },
    REJECTED: {
        start: "var(--kdk-dashboard-risk-high-gradient-start)",
        end: "var(--kdk-dashboard-risk-high-gradient-end)"
    },
    REVIEW_REQUIRED: {
        start: "var(--kdk-dashboard-risk-medium-gradient-start)",
        end: "var(--kdk-dashboard-risk-medium-gradient-end)"
    },
    NOT_READY: {
        start: "darkgray",
        end: "var(--kdk-dark-grey)"
    }
};
const CustomersByReviewStatusWidget = (props)=>{
    const { values, total, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { navigateToCustomersByStatus } = (0, _useDashboardNavigationDefault.default)();
    const ReviewStatusTitles = {
        APPROVED: f("common.labels.approved"),
        REJECTED: f("common.labels.rejected"),
        NOT_READY: f("risklabel.NOT_SET"),
        REVIEW_REQUIRED: f("onboarding.status.ready-for-review")
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardWidgetDefault.default), {
        title: f("dashboard.widgets.status.title"),
        loading: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardVerticalStackDefault.default), {
            align: "space-evenly",
            children: ReviewStatuses.map((status)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDashboardNavigation, {
                    spacing: "medium",
                    onClick: ()=>navigateToCustomersByStatus(status),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNumbersItemDefault.default), {
                                value: values[status],
                                percent: !total ? 0 : values[status] / total,
                                label: ReviewStatusTitles[status]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledHorizontalBar, {
                                value: !total ? 0 : Math.round(values[status] / total * 100),
                                startColor: STATUS_COLORS[status].start,
                                endColor: STATUS_COLORS[status].end
                            })
                        ]
                    })
                }, status))
        })
    });
};
const StyledDashboardNavigation = (0, _styledComponentsDefault.default)((0, _dashboardNavigationDefault.default))`
  padding-left: var(--p-space-4);
  padding-right: var(--p-space-2);
`;
const StyledHorizontalBar = (0, _styledComponentsDefault.default).div`
  width: ${({ value })=>value}%;
  border-radius: 0 6rem 6rem 0;
  box-shadow: var(--kdk-dashboard-widget-shadow);
  background: linear-gradient(90deg, ${({ startColor })=>startColor}, ${({ endColor })=>endColor});
  padding: var(--p-space-2) 0;
  transition: width var(--p-ease) var(--p-duration-500);
`;
exports.default = CustomersByReviewStatusWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","./DashboardNavigation":"dsYkB","./DashboardNumbersItem":"9RIaS","./DashboardVerticalStack":"iN7sd","./DashboardWidget":"98uzT","./useDashboardNavigation":"eWi9U","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"762eb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _riskTypes = require("../../constants/risk-types");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardBarChart = require("./DashboardBarChart");
var _dashboardBarChartDefault = parcelHelpers.interopDefault(_dashboardBarChart);
var _dashboardColorBlock = require("./DashboardColorBlock");
var _dashboardColorBlockDefault = parcelHelpers.interopDefault(_dashboardColorBlock);
var _dashboardNavigation = require("./DashboardNavigation");
var _dashboardNavigationDefault = parcelHelpers.interopDefault(_dashboardNavigation);
var _dashboardNumbersItem = require("./DashboardNumbersItem");
var _dashboardNumbersItemDefault = parcelHelpers.interopDefault(_dashboardNumbersItem);
var _dashboardStack = require("./DashboardStack");
var _dashboardStackDefault = parcelHelpers.interopDefault(_dashboardStack);
var _dashboardVerticalStack = require("./DashboardVerticalStack");
var _dashboardVerticalStackDefault = parcelHelpers.interopDefault(_dashboardVerticalStack);
var _dashboardWidget = require("./DashboardWidget");
var _dashboardWidgetDefault = parcelHelpers.interopDefault(_dashboardWidget);
var _useDashboardNavigation = require("./useDashboardNavigation");
var _useDashboardNavigationDefault = parcelHelpers.interopDefault(_useDashboardNavigation);
const RISK_COLORS = {
    HIGH: {
        start: "var(--kdk-dashboard-risk-high-gradient-start)",
        end: "var(--kdk-dashboard-risk-high-gradient-end)"
    },
    MEDIUM: {
        start: "var(--kdk-dashboard-risk-medium-gradient-start)",
        end: "var(--kdk-dashboard-risk-medium-gradient-end)"
    },
    LOW: {
        start: "var(--kdk-dashboard-risk-low-gradient-start)",
        end: "var(--kdk-dashboard-risk-low-gradient-end)"
    },
    NOT_SET: {
        start: "darkgray",
        end: "black"
    }
};
const CustomersByRiskWidget = (props)=>{
    const { values, customersCount, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { navigateToCustomersByRisk } = (0, _useDashboardNavigationDefault.default)();
    const bars = (0, _riskTypes.ReversedRiskTypes).map((risk)=>({
            value: !customersCount ? 0 : Math.round(values[risk] / customersCount * 100),
            startColor: RISK_COLORS[risk].start,
            endColor: RISK_COLORS[risk].end
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardWidgetDefault.default), {
        title: f("dashboard.widgets.risk-levels.title"),
        loading: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardStackDefault.default), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                    fill: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardVerticalStackDefault.default), {
                        children: (0, _riskTypes.ReversedRiskTypes).map((risk)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNavigationDefault.default), {
                                onClick: ()=>navigateToCustomersByRisk(risk),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                    distribution: "leading",
                                    wrap: false,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardColorBlockDefault.default), {
                                            color: RISK_COLORS[risk].start
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNumbersItemDefault.default), {
                                            value: values[risk],
                                            percent: !customersCount ? 0 : values[risk] / customersCount,
                                            label: f(`risklabel.${risk}`)
                                        })
                                    ]
                                })
                            }, risk))
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardBarChartDefault.default), {
                    bars: bars
                })
            ]
        })
    });
};
exports.default = CustomersByRiskWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/risk-types":"hJsRK","../../hooks/useFormatMessage":"8Y8fq","./DashboardBarChart":"122G6","./DashboardColorBlock":"4Jghj","./DashboardNavigation":"dsYkB","./DashboardNumbersItem":"9RIaS","./DashboardStack":"6xhJE","./DashboardVerticalStack":"iN7sd","./DashboardWidget":"98uzT","./useDashboardNavigation":"eWi9U","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"122G6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const DashboardBarChart = (props)=>{
    const { bars } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBarChart, {
        children: bars.map((bar, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledVerticalBar, {
                ...bar
            }, index))
    });
};
const StyledBarChart = (0, _styledComponentsDefault.default).div`
  display: flex;
  align-items: flex-end;
  height: 100%;
  padding: var(--p-space-4);
  gap: var(--p-space-4);

  & > div {
    flex: 1;
  }
`;
const StyledVerticalBar = (0, _styledComponentsDefault.default).div`
  height: ${({ value })=>value}%;
  border-radius: 6rem 6rem 0 0;
  box-shadow: var(--kdk-dashboard-widget-shadow);
  background: linear-gradient(${({ startColor })=>startColor}, ${({ endColor })=>endColor});
  padding: 0 var(--p-space-2);
  transition: height var(--p-ease) var(--p-duration-500);
`;
exports.default = DashboardBarChart;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6xhJE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const DashboardStack = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { spacing = "none", wrap = false, ...stackProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledStackWrapper, {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack), {
            spacing: spacing,
            wrap: wrap,
            ...stackProps
        })
    });
});
const StyledStackWrapper = (0, _styledComponentsDefault.default).div`
  height: 100%;

  & > .Polaris-Stack {
    height: 100%;
  }

  & > .Polaris-Stack > .Polaris-Stack__Item + .Polaris-Stack__Item {
    border-left: var(--p-border-divider);
  }
`;
exports.default = DashboardStack;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9WVyN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardColorBlock = require("./DashboardColorBlock");
var _dashboardColorBlockDefault = parcelHelpers.interopDefault(_dashboardColorBlock);
var _dashboardNavigation = require("./DashboardNavigation");
var _dashboardNavigationDefault = parcelHelpers.interopDefault(_dashboardNavigation);
var _dashboardNumbersItem = require("./DashboardNumbersItem");
var _dashboardNumbersItemDefault = parcelHelpers.interopDefault(_dashboardNumbersItem);
var _dashboardStack = require("./DashboardStack");
var _dashboardStackDefault = parcelHelpers.interopDefault(_dashboardStack);
var _dashboardVerticalStack = require("./DashboardVerticalStack");
var _dashboardVerticalStackDefault = parcelHelpers.interopDefault(_dashboardVerticalStack);
var _dashboardWidget = require("./DashboardWidget");
var _dashboardWidgetDefault = parcelHelpers.interopDefault(_dashboardWidget);
var _styledResponsiveCircle = require("./StyledResponsiveCircle");
var _useDashboardNavigation = require("./useDashboardNavigation");
var _useDashboardNavigationDefault = parcelHelpers.interopDefault(_useDashboardNavigation);
const CustomersByTypeWidget = (props)=>{
    const { values, customersCount, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const { navigateToCustomersByType } = (0, _useDashboardNavigationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardWidgetDefault.default), {
        title: f("dashboard.widgets.active-customers.title"),
        loading: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardVerticalStackDefault.default), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCenterWrapper, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "heading4xl",
                        as: "p",
                        children: formatNumber(customersCount)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        flex: 1
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardStackDefault.default), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                fill: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardVerticalStackDefault.default), {
                                    align: "space-evenly",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNavigationDefault.default), {
                                            onClick: ()=>navigateToCustomersByType("companies"),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                                distribution: "leading",
                                                wrap: false,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardColorBlockDefault.default), {
                                                        color: "var(--kdk-dashboard-customer-type-company)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNumbersItemDefault.default), {
                                                        value: values.COMPANY,
                                                        percent: !customersCount ? 0 : values.COMPANY / customersCount,
                                                        label: f("component.filter.customer.option.company.title")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNavigationDefault.default), {
                                            onClick: ()=>navigateToCustomersByType("persons"),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                                distribution: "leading",
                                                wrap: false,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardColorBlockDefault.default), {
                                                        color: "var(--kdk-dashboard-customer-type-person)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNumbersItemDefault.default), {
                                                        value: values.PERSON,
                                                        percent: !customersCount ? 0 : values.PERSON / customersCount,
                                                        label: f("component.filter.customer.option.person.title")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPieChartContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPieChart, {
                                    $width: "6rem",
                                    $value: !customersCount ? 0 : values.PERSON / customersCount
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const StyledPieChartContainer = (0, _styledComponentsDefault.default).div`
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  padding: var(--p-space-4);
`;
const StyledPieChart = (0, _styledComponentsDefault.default)((0, _styledResponsiveCircle.StyledResponsiveCircle))`
  background: conic-gradient(
    from 0deg,
    var(--kdk-dashboard-dark-gradient-end) 0,
    var(--kdk-dashboard-customer-type-person) ${({ $value })=>Math.round($value * 100)}%,
    var(--kdk-dashboard-dark-gradient-end) 0,
    var(--kdk-dashboard-dark-gradient-start) 100%
  );
  box-shadow:
    25px -15px 20px 10px rgba(0, 0, 0, 0.75) inset,
    0px 20px 30px 20px rgba(0, 0, 0, 0.25) inset,
    var(--kdk-dashboard-widget-shadow);
`;
const StyledCenterWrapper = (0, _styledComponentsDefault.default).div`
  display: grid;
  place-items: center;
  padding: var(--p-space-2);
`;
exports.default = CustomersByTypeWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","./DashboardColorBlock":"4Jghj","./DashboardNavigation":"dsYkB","./DashboardNumbersItem":"9RIaS","./DashboardStack":"6xhJE","./DashboardVerticalStack":"iN7sd","./DashboardWidget":"98uzT","./StyledResponsiveCircle":"4v91E","./useDashboardNavigation":"eWi9U","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4v91E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledResponsiveCircle", ()=>StyledResponsiveCircle);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const StyledResponsiveCircle = (0, _styledComponentsDefault.default).div`
  border-radius: var(--p-border-radius-half);
  width: ${({ $width })=>$width || "65%"};
  position: relative;
  margin: 0 auto;

  // weird hack to create a square (with a circle in it)
  // see https://spin.atomicobject.com/2015/07/14/css-responsive-square/
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  & > :first-child {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
  }
`;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bTNyD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardCustomerTypeTemplateWidget = require("./DashboardCustomerTypeTemplateWidget");
var _dashboardCustomerTypeTemplateWidgetDefault = parcelHelpers.interopDefault(_dashboardCustomerTypeTemplateWidget);
var _useDashboardNavigation = require("./useDashboardNavigation");
var _useDashboardNavigationDefault = parcelHelpers.interopDefault(_useDashboardNavigation);
const CustomersMarkedAsPepWidget = (props)=>{
    const { values, total, customersCount, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { navigateToPepCustomers } = (0, _useDashboardNavigationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardCustomerTypeTemplateWidgetDefault.default), {
        title: f("dashboard.widgets.marked-as-pep.title"),
        values: values,
        totalCount: total,
        allCustomersCount: customersCount,
        loading: loading,
        onNavigation: navigateToPepCustomers
    });
};
exports.default = CustomersMarkedAsPepWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","./DashboardCustomerTypeTemplateWidget":"jUX0m","./useDashboardNavigation":"eWi9U","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jUX0m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _companySvg = require("../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _personSvg = require("../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _icon = require("../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardContentCircle = require("./DashboardContentCircle");
var _dashboardContentCircleDefault = parcelHelpers.interopDefault(_dashboardContentCircle);
var _dashboardNavigation = require("./DashboardNavigation");
var _dashboardNavigationDefault = parcelHelpers.interopDefault(_dashboardNavigation);
var _dashboardNumbersItem = require("./DashboardNumbersItem");
var _dashboardNumbersItemDefault = parcelHelpers.interopDefault(_dashboardNumbersItem);
var _dashboardStack = require("./DashboardStack");
var _dashboardStackDefault = parcelHelpers.interopDefault(_dashboardStack);
var _dashboardVerticalStack = require("./DashboardVerticalStack");
var _dashboardVerticalStackDefault = parcelHelpers.interopDefault(_dashboardVerticalStack);
var _dashboardWidget = require("./DashboardWidget");
var _dashboardWidgetDefault = parcelHelpers.interopDefault(_dashboardWidget);
const DashboardCustomerTypeTemplateWidget = (props)=>{
    const { title, totalCount, allCustomersCount, values, loading, onNavigation } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const circleWidth = totalCount > 999 ? "55%" : "45%";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardWidgetDefault.default), {
        title: title,
        loading: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardVerticalStackDefault.default), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNavigationDefault.default), {
                    onClick: ()=>onNavigation(),
                    highlight: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDashboardContentCircle, {
                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "heading4xl",
                            as: "p",
                            children: formatNumber(totalCount)
                        }),
                        subtitle: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "bold",
                            children: formatNumber(!allCustomersCount ? 0 : totalCount / allCustomersCount, {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                                style: "percent"
                            })
                        }),
                        width: circleWidth
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledShrinkItem, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardStackDefault.default), {
                        distribution: "fillEvenly",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNavigationDefault.default), {
                                onClick: ()=>onNavigation("companies"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNumbersItemDefault.default), {
                                    value: values?.COMPANY || 0,
                                    percent: !totalCount ? 0 : (values?.COMPANY || 0) / totalCount,
                                    label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "1",
                                        blockAlign: "center",
                                        wrap: false,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                children: f("component.filter.customer.option.company.title")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                source: (0, _companySvgDefault.default)
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNavigationDefault.default), {
                                onClick: ()=>onNavigation("persons"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNumbersItemDefault.default), {
                                    value: values?.PERSON || 0,
                                    percent: !totalCount ? 0 : (values?.PERSON || 0) / totalCount,
                                    label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "1",
                                        blockAlign: "center",
                                        wrap: false,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                children: f("component.filter.customer.option.person.title")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                source: (0, _personSvgDefault.default)
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const StyledShrinkItem = (0, _styledComponentsDefault.default).div`
  & {
    flex: 0;
  }
`;
const StyledDashboardContentCircle = (0, _styledComponentsDefault.default)((0, _dashboardContentCircleDefault.default))`
  border: solid var(--p-border-width-4) var(--kdk-dashboard-risk-high-gradient-start);
  box-shadow: var(--kdk-dashboard-widget-shadow);
  background: var(--p-surface);

  & svg.kdk-divider {
    color: var(--kdk-dashboard-risk-high-gradient-start);
  }
`;
exports.default = DashboardCustomerTypeTemplateWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/company.svg":"luBbc","../../../assets/icons/person.svg":"1Xt5L","../../components/extensions/Icon":"eHSf0","../../hooks/useFormatMessage":"8Y8fq","./DashboardContentCircle":"2r0Ab","./DashboardNavigation":"dsYkB","./DashboardNumbersItem":"9RIaS","./DashboardStack":"6xhJE","./DashboardVerticalStack":"iN7sd","./DashboardWidget":"98uzT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2r0Ab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styledResponsiveCircle = require("./StyledResponsiveCircle");
const DashboardContentCircle = (props)=>{
    const { title, subtitle, width, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledResponsiveCircle.StyledResponsiveCircle), {
        $width: width,
        ...rest,
        children: [
            subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledContent, {
                children: [
                    title,
                    subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDivider, {
                        className: "kdk-divider",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                            x1: 0,
                            y1: 0,
                            x2: "100%",
                            y2: 0,
                            strokeWidth: 2,
                            stroke: "currentColor",
                            strokeDasharray: "6 7"
                        })
                    }),
                    subtitle
                ]
            }),
            !subtitle && title
        ]
    });
};
const StyledContent = (0, _styledComponentsDefault.default).div`
  padding-top: var(--p-space-5);

  & > :first-child {
    font-size: 3.5rem;
    align-self: flex-end;
  }

  & > :last-child {
    align-self: flex-start;
  }
`;
const StyledDivider = (0, _styledComponentsDefault.default).svg`
  width: 75%;
  height: 2px;
`;
exports.default = DashboardContentCircle;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","./StyledResponsiveCircle":"4v91E","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bTllM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardCustomerTypeTemplateWidget = require("./DashboardCustomerTypeTemplateWidget");
var _dashboardCustomerTypeTemplateWidgetDefault = parcelHelpers.interopDefault(_dashboardCustomerTypeTemplateWidget);
var _useDashboardNavigation = require("./useDashboardNavigation");
var _useDashboardNavigationDefault = parcelHelpers.interopDefault(_useDashboardNavigation);
const CustomersMarkedAsSanctionedWidget = (props)=>{
    const { values, total, customersCount, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { navigateToSanctionedCustomers } = (0, _useDashboardNavigationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardCustomerTypeTemplateWidgetDefault.default), {
        title: f("dashboard.widgets.marked-as-sanctioned.title"),
        totalCount: total,
        allCustomersCount: customersCount,
        values: values,
        loading: loading,
        onNavigation: navigateToSanctionedCustomers
    });
};
exports.default = CustomersMarkedAsSanctionedWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","./DashboardCustomerTypeTemplateWidget":"jUX0m","./useDashboardNavigation":"eWi9U","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"55u82":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dashboardContentCircle = require("./DashboardContentCircle");
var _dashboardContentCircleDefault = parcelHelpers.interopDefault(_dashboardContentCircle);
var _dashboardNavigation = require("./DashboardNavigation");
var _dashboardNavigationDefault = parcelHelpers.interopDefault(_dashboardNavigation);
var _dashboardWidget = require("./DashboardWidget");
var _dashboardWidgetDefault = parcelHelpers.interopDefault(_dashboardWidget);
var _useDashboardNavigation = require("./useDashboardNavigation");
var _useDashboardNavigationDefault = parcelHelpers.interopDefault(_useDashboardNavigation);
const CustomersWithPendingTasksWidget = (props)=>{
    const { customersWithPendingTasksCount, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const { navigateToPendingTasks } = (0, _useDashboardNavigationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardWidgetDefault.default), {
        title: f("dashboard.widgets.pending-tasks.title"),
        loading: loading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardNavigationDefault.default), {
            onClick: navigateToPendingTasks,
            highlight: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledGradientCircle, {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "heading4xl",
                    as: "p",
                    children: formatNumber(customersWithPendingTasksCount)
                })
            })
        })
    });
};
const StyledGradientCircle = (0, _styledComponentsDefault.default)((0, _dashboardContentCircleDefault.default))`
  box-shadow: var(--kdk-dashboard-widget-shadow);
  border: solid var(--p-border-width-1) var(--kdk-dashboard-dark-border);
  background: linear-gradient(var(--kdk-dashboard-dark-gradient-start), var(--kdk-dashboard-dark-gradient-end));
  color: white;
`;
exports.default = CustomersWithPendingTasksWidget;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","./DashboardContentCircle":"2r0Ab","./DashboardNavigation":"dsYkB","./DashboardWidget":"98uzT","./useDashboardNavigation":"eWi9U","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3OHPa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_DASHBOARD_VALUES", ()=>EMPTY_DASHBOARD_VALUES);
const EMPTY_DASHBOARD_VALUES = {
    customers_approved_count: 0,
    customers_count_by_onboarding_status: {
        DONE: 0,
        FETCHING_DATA: 0,
        READY: 0,
        SCREENING_CONFIG: 0,
        SIGNATURE_CONFIG: 0,
        STARTED: 0
    },
    reviews_expired_count: 0,
    customers_active_count: 0,
    customers_pep_count: 0,
    customers_pep_count_by_customer_type: {
        PERSON: 0,
        COMPANY: 0
    },
    customers_sanctioned_count: 0,
    customers_sanctioned_count_by_customer_type: {
        PERSON: 0,
        COMPANY: 0
    },
    customers_with_pending_tasks_count: 0,
    customers_count_by_risk_level: {
        HIGH: 0,
        MEDIUM: 0,
        LOW: 0,
        NOT_SET: 0
    },
    customers_count_by_customer_type: {
        PERSON: 0,
        COMPANY: 0
    },
    customers_count_by_review_status: {
        APPROVED: 0,
        NOT_READY: 0,
        REVIEW_REQUIRED: 0,
        REJECTED: 0
    },
    customers_count_by_industry_code: {
        metrics: [],
        categories: []
    },
    customers_count_by_risk_data: {
        HIGH_RISK_COUNTRY: 0,
        CONSTRUCTION_INDUSTRY: 0,
        HIGH_RISK_INDUSTRY: 0,
        PEP: 0,
        FINANCED_CRYPTO: 0,
        FINANCED_CROWDFUNDING: 0,
        MISSING_WORK_DOCUMENTATION: 0,
        MISSING_FUNDING_DOCUMENTATION: 0
    },
    assignments_count_by_risk_data: {
        HIGH_RISK_COUNTRY: 0,
        CONSTRUCTION_INDUSTRY: 0,
        HIGH_RISK_INDUSTRY: 0,
        PEP: 0,
        FINANCED_CRYPTO: 0,
        FINANCED_CROWDFUNDING: 0,
        MISSING_WORK_DOCUMENTATION: 0,
        MISSING_FUNDING_DOCUMENTATION: 0
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7RtRD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _logoutSvg = require("../../assets/images/logout.svg");
var _logoutSvgDefault = parcelHelpers.interopDefault(_logoutSvg);
var _kdkemptyState = require("../components/KDKEmptyState/KDKEmptyState");
var _kdkemptyStateDefault = parcelHelpers.interopDefault(_kdkemptyState);
var _useFormatMessage = require("../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const Expired = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const f = (0, _useFormatMessageDefault.default)();
    // Figure out where the user should be redirected after reauthenticating
    // If `sessionExpiryURL` is set in location state, use it. Else default to `window.location.origin`
    const location = (0, _reactRouterDom.useLocation)();
    const locationState = location.state || {};
    const returnToUrl = locationState?.sessionExpiryURL || window.location.origin;
    (0, _react.useEffect)(()=>{
        queryClient.clear();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkemptyStateDefault.default), {
            header: f("expired.heading"),
            description: f("expired.description"),
            image: (0, _logoutSvgDefault.default),
            altImage: "Session expired",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                primary: true,
                onClick: ()=>{
                    // Try to open the session expiry URL in this tab. Use `window.open` instead of logout because:
                    // 1. If the user's session has expired (which it should have unless he/she is active in another tab)
                    //      opening the session expiry URL will automatically redirect the user to the login page, and, after
                    //      logging in again there, automatically redirect the user to the session expiry URL.
                    // 2. If the user's session has _not_ expired, the user will be redirected to the session expiry URL without having
                    //    to log in again. This is not the best UX, but it's a compromise we can live with
                    window.open(returnToUrl, "_self");
                },
                children: f("expired.actions.logout")
            })
        })
    });
};
exports.default = Expired;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../assets/images/logout.svg":"i5cZl","../components/KDKEmptyState/KDKEmptyState":"bZwvm","../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i5cZl":[function(require,module,exports) {
module.exports = require("5d89ede0721fd3d0").getBundleURL("kEMsi") + "logout.cccce5c4.svg";

},{"5d89ede0721fd3d0":"75UoR"}],"cFQBq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _importCustomersTable = require("../../components/ImportCustomersTable/ImportCustomersTable");
var _importCustomersTableDefault = parcelHelpers.interopDefault(_importCustomersTable);
var _importCustomersHelpers = require("../../helpers/import-customers.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _fileImport = require("./FileImport");
var _fileImportDefault = parcelHelpers.interopDefault(_fileImport);
var _importCustomersFooter = require("./ImportCustomersFooter");
var _importCustomersFooterDefault = parcelHelpers.interopDefault(_importCustomersFooter);
var _importCustomersHeader = require("./ImportCustomersHeader");
var _importCustomersHeaderDefault = parcelHelpers.interopDefault(_importCustomersHeader);
var _importCustomersInstructionsBanner = require("./ImportCustomersInstructionsBanner");
var _importCustomersInstructionsBannerDefault = parcelHelpers.interopDefault(_importCustomersInstructionsBanner);
var _importCustomersPageHelpers = require("./ImportCustomersPage.helpers");
var _importCustomersPagination = require("./ImportCustomersPagination");
var _importCustomersPaginationDefault = parcelHelpers.interopDefault(_importCustomersPagination);
var _importCustomersValidationBanner = require("./ImportCustomersValidationBanner");
var _importCustomersValidationBannerDefault = parcelHelpers.interopDefault(_importCustomersValidationBanner);
var _useImportCustomersPage = require("./useImportCustomersPage");
var _useImportCustomersPageDefault = parcelHelpers.interopDefault(_useImportCustomersPage);
var _useImportCustomersTable = require("./useImportCustomersTable");
var _useImportCustomersTableDefault = parcelHelpers.interopDefault(_useImportCustomersTable);
const ImportCustomersPage = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const customerType = "company";
    const { rows, rowSelection, columnsNames, headers, filters, filename, actionItemsCount, validationColumns, importedCount, useFirstRowAsHeaders, setUseFirstRowAsHeaders, handleFileRead, setRowSelection, setColumnNames, setStatuses, setSearchText, importRows, reset } = (0, _useImportCustomersPageDefault.default)(customerType);
    const table = (0, _useImportCustomersTableDefault.default)({
        rows,
        columnsNames,
        customerType,
        headers,
        filters,
        rowSelection,
        onSelectionChange: setRowSelection,
        onColumnChange: setColumnNames
    });
    const visibleRowsCount = table.getFilteredRowModel().rows.length;
    const errorsCount = (0, _react.useMemo)(()=>table.getFilteredRowModel().rows.filter((row)=>(0, _importCustomersHelpers.isImportDataError)(row.original)).length, [
        table.getFilteredRowModel()
    ]);
    const handleReset = ()=>{
        table.reset();
        reset();
    };
    const handleRowsRead = (rows, filename, columnsCounts)=>{
        table.reset();
        handleFileRead(rows, filename, columnsCounts);
    };
    const selectedRowsCount = Object.keys(rowSelection).length;
    const isValidColumns = (0, _importCustomersPageHelpers.isValidColumnsNames)(columnsNames, validationColumns);
    const disableImport = !isValidColumns || selectedRowsCount === 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: customerType === "company" ? f("import-customers.wizard.page.title.companies") : f("import-customers.wizard.page.title.people"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileImportDefault.default), {
                    onRowsRead: handleRowsRead,
                    filename: filename
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                    children: [
                        rows.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersInstructionsBannerDefault.default), {})
                        }),
                        rows.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersHeaderDefault.default), {
                                        statuses: filters.statuses,
                                        useFirstRowAsHeaders: useFirstRowAsHeaders,
                                        setUseFirstRowAsHeaders: setUseFirstRowAsHeaders,
                                        totalCount: rows.length,
                                        visibleRowsCount: visibleRowsCount,
                                        selectedRowsCount: selectedRowsCount,
                                        errorsCount: errorsCount,
                                        importedCount: importedCount,
                                        onFilterQueryChange: setSearchText,
                                        onStatusesChanges: setStatuses
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersValidationBannerDefault.default), {
                                        columnsNames: columnsNames,
                                        validationColumns: validationColumns
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersTableDefault.default), {
                                        table: table
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersPaginationDefault.default), {
                                        table: table
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersFooterDefault.default), {
                    customerType: customerType,
                    disableImport: disableImport,
                    actionItemsCount: actionItemsCount,
                    onReset: handleReset,
                    onImport: importRows
                })
            ]
        })
    });
};
exports.default = ImportCustomersPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../components/ImportCustomersTable/ImportCustomersTable":"ewaBK","../../helpers/import-customers.helpers":"j5UDq","../../hooks/useFormatMessage":"8Y8fq","./FileImport":"azq9s","./ImportCustomersFooter":"bQVZ1","./ImportCustomersHeader":"euqDw","./ImportCustomersInstructionsBanner":"dqpf3","./ImportCustomersPage.helpers":"ejwRn","./ImportCustomersPagination":"bCSVL","./ImportCustomersValidationBanner":"6kmsz","./useImportCustomersPage":"ade0C","./useImportCustomersTable":"dYTFI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ewaBK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTable = require("@tanstack/react-table");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _importCustomersHelpers = require("../../helpers/import-customers.helpers");
const ImportCustomersTable = (props)=>{
    const { table, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "Polaris-IndexTable",
        ...rest,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTable, {
            className: "Polaris-IndexTable-ScrollContainer",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "Polaris-IndexTable__Table",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledStickyTableHeader, {
                        children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        className: "Polaris-IndexTable__TableHeading",
                                        colSpan: header.colSpan,
                                        children: (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                    }, header.id))
                            }, headerGroup.id))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: table.getRowModel().rows.map((row)=>{
                            const className = (0, _classnamesDefault.default)("Polaris-IndexTable__TableRow", {
                                "Polaris-IndexTable--statusSuccess": row.original.status === "IMPORTED",
                                "Polaris-IndexTable--statusSubdued": (0, _importCustomersHelpers.isImportDataError)(row.original)
                            });
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableRow, {
                                className: className,
                                children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: "Polaris-IndexTable__TableCell",
                                        children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                    }, cell.id))
                            }, row.id);
                        })
                    })
                ]
            })
        })
    });
};
const StyledTable = (0, _styledComponentsDefault.default).div`
  max-height: 40vh;
  overflow-y: auto;
`;
const StyledStickyTableHeader = (0, _styledComponentsDefault.default).thead`
  & > tr > th {
    position: sticky;
    top: 0;
    z-index: var(--p-z-1);
    background-color: var(--p-surface);
  }
`;
const StyledTableRow = (0, _styledComponentsDefault.default).tr`
  cursor: default;
  --kdk-backgrorund-color: transparent;

  background-color: var(--kdk-backgrorund-color);
  & > td {
    background-color: var(--kdk-backgrorund-color);
  }

  &:hover {
    --kdk-backgrorund-color: var(--p-surface-hovered);
  }
`;
exports.default = ImportCustomersTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-table":"86D8M","classnames":"2uoUy","styled-components":"eBrdC","../../helpers/import-customers.helpers":"j5UDq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j5UDq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLoading", ()=>isLoading);
parcelHelpers.export(exports, "isImportDataError", ()=>isImportDataError);
var _importCustomers = require("../constants/import-customers");
const isLoading = (row)=>row.status === "IMPORTING";
const isImportDataError = (row)=>(0, _importCustomers.ERROR_STATUSES).includes(row.status);

},{"../constants/import-customers":"MoQPY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"MoQPY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ORG_ID_COLUMN", ()=>ORG_ID_COLUMN);
parcelHelpers.export(exports, "NAME_COLUMN", ()=>NAME_COLUMN);
parcelHelpers.export(exports, "RESPONSIBLE_USER_EMAIL_COLUMN", ()=>RESPONSIBLE_USER_EMAIL_COLUMN);
parcelHelpers.export(exports, "EXTERNAL_ID_COLUMN", ()=>EXTERNAL_ID_COLUMN);
parcelHelpers.export(exports, "IGNORE_COLUMN", ()=>IGNORE_COLUMN);
parcelHelpers.export(exports, "ERROR_STATUSES", ()=>ERROR_STATUSES);
parcelHelpers.export(exports, "PAGE_SIZES", ()=>PAGE_SIZES);
parcelHelpers.export(exports, "DEFAULT_PAGE_SIZE", ()=>DEFAULT_PAGE_SIZE);
const ORG_ID_COLUMN = "Org. ID";
const NAME_COLUMN = "Name";
const RESPONSIBLE_USER_EMAIL_COLUMN = "Responsible user email";
const EXTERNAL_ID_COLUMN = "External ID";
const IGNORE_COLUMN = "Ignore";
const ERROR_STATUSES = [
    "VALIDATION_ERROR",
    "IMPORT_ERROR"
];
const PAGE_SIZES = [
    "10",
    "50",
    "100",
    "200",
    "500",
    "1000",
    "5000"
];
const DEFAULT_PAGE_SIZE = 200;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"azq9s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _readExcelFile = require("read-excel-file");
var _readExcelFileDefault = parcelHelpers.interopDefault(_readExcelFile);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _useDebouncedState = require("../../hooks/useDebouncedState");
var _useDebouncedStateDefault = parcelHelpers.interopDefault(_useDebouncedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _importCustomersPageHelpers = require("./ImportCustomersPage.helpers");
const FileImport = (props)=>{
    const { filename, onRowsRead } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showProgress, setShowProgress] = (0, _useDebouncedStateDefault.default)(false, 1000);
    const [readFileError, setReadFileError] = (0, _react.useState)();
    const clearReadFileError = ()=>setReadFileError(undefined);
    const handleDropZoneDrop = async (_dropFiles, acceptedFiles)=>{
        clearReadFileError();
        if (acceptedFiles.length === 0) return;
        setShowProgress(true);
        try {
            const file = acceptedFiles[0];
            const fileRows = await (0, _readExcelFileDefault.default)(file);
            const importDataRows = [];
            let columnCount = 0;
            fileRows.forEach((row)=>{
                importDataRows.push((0, _importCustomersPageHelpers.convertRowToImportRowData)(row));
                columnCount = Math.max(columnCount, row.filter(Boolean).length);
            });
            onRowsRead(importDataRows, file.name, columnCount);
        } catch (error) {
            setReadFileError(error);
        }
        setShowProgress(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                        variant: "headingLg",
                        as: "p",
                        children: [
                            f("common.labels.file.upload"),
                            filename ? ": " + filename : ""
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DropZone), {
                        onDrop: handleDropZoneDrop,
                        allowMultiple: false,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DropZone).FileUpload, {})
                    }),
                    showProgress && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ProgressBar), {
                        progress: 100,
                        animated: true
                    }),
                    readFileError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: readFileError,
                        actionTitle: "Read file"
                    })
                ]
            })
        })
    });
};
exports.default = FileImport;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","read-excel-file":"ctMtd","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../hooks/useDebouncedState":"lKEJK","../../hooks/useFormatMessage":"8Y8fq","./ImportCustomersPage.helpers":"ejwRn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ctMtd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _readXlsxFileBrowserJsDefault.default));
parcelHelpers.export(exports, "readSheetNames", ()=>(0, _readSheetNamesBrowserJsDefault.default));
parcelHelpers.export(exports, "parseExcelDate", ()=>(0, _parseDateJsDefault.default));
parcelHelpers.export(exports, "Integer", ()=>(0, _integerJsDefault.default));
parcelHelpers.export(exports, "Email", ()=>(0, _emailJsDefault.default));
parcelHelpers.export(exports, "URL", ()=>(0, _urlJsDefault.default));
var _readXlsxFileBrowserJs = require("./modules/read/readXlsxFileBrowser.js");
var _readXlsxFileBrowserJsDefault = parcelHelpers.interopDefault(_readXlsxFileBrowserJs);
var _readSheetNamesBrowserJs = require("./modules/read/readSheetNamesBrowser.js");
var _readSheetNamesBrowserJsDefault = parcelHelpers.interopDefault(_readSheetNamesBrowserJs);
var _parseDateJs = require("./modules/read/parseDate.js");
var _parseDateJsDefault = parcelHelpers.interopDefault(_parseDateJs);
var _integerJs = require("./modules/types/Integer.js");
var _integerJsDefault = parcelHelpers.interopDefault(_integerJs);
var _emailJs = require("./modules/types/Email.js");
var _emailJsDefault = parcelHelpers.interopDefault(_emailJs);
var _urlJs = require("./modules/types/URL.js");
var _urlJsDefault = parcelHelpers.interopDefault(_urlJs);

},{"./modules/read/readXlsxFileBrowser.js":"5CcBK","./modules/read/readSheetNamesBrowser.js":false,"./modules/read/parseDate.js":false,"./modules/types/Integer.js":false,"./modules/types/Email.js":false,"./modules/types/URL.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5CcBK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>readXlsxFile);
var _xmlBrowserJs = require("../xml/xmlBrowser.js");
var _xmlBrowserJsDefault = parcelHelpers.interopDefault(_xmlBrowserJs);
var _unpackXlsxFileBrowserJs = require("./unpackXlsxFileBrowser.js");
var _unpackXlsxFileBrowserJsDefault = parcelHelpers.interopDefault(_unpackXlsxFileBrowserJs);
var _readXlsxFileContentsJs = require("./readXlsxFileContents.js");
var _readXlsxFileContentsJsDefault = parcelHelpers.interopDefault(_readXlsxFileContentsJs);
function readXlsxFile(file) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, _unpackXlsxFileBrowserJsDefault.default)(file).then(function(entries) {
        return (0, _readXlsxFileContentsJsDefault.default)(entries, (0, _xmlBrowserJsDefault.default), options);
    });
}

},{"../xml/xmlBrowser.js":"iuByW","./unpackXlsxFileBrowser.js":"3XCBe","./readXlsxFileContents.js":"dPgIw","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iuByW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    createDocument: function createDocument(content) {
        // if (!content) {
        // 	throw new Error('No *.xml content')
        // }
        // A weird bug: it won't parse XML unless it's trimmed.
        // https://github.com/catamphetamine/read-excel-file/issues/21
        return new DOMParser().parseFromString(content.trim(), "text/xml");
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3XCBe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unpackXlsxFile);
var _fflate = require("fflate");
function unpackXlsxFile(input) {
    if (input instanceof File) return input.arrayBuffer().then(unpackXlsxArrayBuffer);
    if (input instanceof Blob) return input.arrayBuffer().then(unpackXlsxArrayBuffer);
    return unpackXlsxArrayBuffer(input);
}
/**
 * Reads XLSX file in a browser from an `ArrayBuffer`.
 * @param  {ArrayBuffer} input
 * @return {Promise} Resolves to an object holding XLSX file entries.
 */ function unpackXlsxArrayBuffer(arrayBuffer) {
    var archive = new Uint8Array(arrayBuffer);
    var contents = (0, _fflate.unzipSync)(archive);
    return Promise.resolve(getContents(contents)); // return new Promise((resolve, reject) => {
// 	unzip(archive, (error, contents) => {
// 		if (error) {
// 			return reject(error)
// 		}
// 		return resolve(getContents(contents))
// 	})
// })
}
function getContents(contents) {
    var unzippedFiles = [];
    for(var _i = 0, _Object$keys = Object.keys(contents); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        unzippedFiles[key] = (0, _fflate.strFromU8)(contents[key]);
    }
    return unzippedFiles;
}

},{"fflate":"1YUUf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1YUUf":[function(require,module,exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlateErrorCode", ()=>FlateErrorCode);
parcelHelpers.export(exports, "Deflate", ()=>Deflate);
parcelHelpers.export(exports, "AsyncDeflate", ()=>AsyncDeflate);
parcelHelpers.export(exports, "deflate", ()=>deflate);
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */ parcelHelpers.export(exports, "deflateSync", ()=>deflateSync);
parcelHelpers.export(exports, "Inflate", ()=>Inflate);
parcelHelpers.export(exports, "AsyncInflate", ()=>AsyncInflate);
parcelHelpers.export(exports, "inflate", ()=>inflate);
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "inflateSync", ()=>inflateSync);
parcelHelpers.export(exports, "Gzip", ()=>Gzip);
parcelHelpers.export(exports, "AsyncGzip", ()=>AsyncGzip);
parcelHelpers.export(exports, "gzip", ()=>gzip);
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */ parcelHelpers.export(exports, "gzipSync", ()=>gzipSync);
parcelHelpers.export(exports, "Gunzip", ()=>Gunzip);
parcelHelpers.export(exports, "AsyncGunzip", ()=>AsyncGunzip);
parcelHelpers.export(exports, "gunzip", ()=>gunzip);
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "gunzipSync", ()=>gunzipSync);
parcelHelpers.export(exports, "Zlib", ()=>Zlib);
parcelHelpers.export(exports, "AsyncZlib", ()=>AsyncZlib);
parcelHelpers.export(exports, "zlib", ()=>zlib);
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */ parcelHelpers.export(exports, "zlibSync", ()=>zlibSync);
parcelHelpers.export(exports, "Unzlib", ()=>Unzlib);
parcelHelpers.export(exports, "AsyncUnzlib", ()=>AsyncUnzlib);
parcelHelpers.export(exports, "unzlib", ()=>unzlib);
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "unzlibSync", ()=>unzlibSync);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compress", ()=>gzip);
parcelHelpers.export(exports, "AsyncCompress", ()=>AsyncGzip);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compressSync", ()=>gzipSync);
parcelHelpers.export(exports, "Compress", ()=>Gzip);
parcelHelpers.export(exports, "Decompress", ()=>Decompress);
parcelHelpers.export(exports, "AsyncDecompress", ()=>AsyncDecompress);
parcelHelpers.export(exports, "decompress", ()=>decompress);
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "decompressSync", ()=>decompressSync);
parcelHelpers.export(exports, "DecodeUTF8", ()=>DecodeUTF8);
parcelHelpers.export(exports, "EncodeUTF8", ()=>EncodeUTF8);
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */ parcelHelpers.export(exports, "strToU8", ()=>strToU8);
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */ parcelHelpers.export(exports, "strFromU8", ()=>strFromU8);
parcelHelpers.export(exports, "ZipPassThrough", ()=>ZipPassThrough);
parcelHelpers.export(exports, "ZipDeflate", ()=>ZipDeflate);
parcelHelpers.export(exports, "AsyncZipDeflate", ()=>AsyncZipDeflate);
parcelHelpers.export(exports, "Zip", ()=>Zip);
parcelHelpers.export(exports, "zip", ()=>zip);
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */ parcelHelpers.export(exports, "zipSync", ()=>zipSync);
parcelHelpers.export(exports, "UnzipPassThrough", ()=>UnzipPassThrough);
parcelHelpers.export(exports, "UnzipInflate", ()=>UnzipInflate);
parcelHelpers.export(exports, "AsyncUnzipInflate", ()=>AsyncUnzipInflate);
parcelHelpers.export(exports, "Unzip", ()=>Unzip);
parcelHelpers.export(exports, "unzip", ()=>unzip);
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */ parcelHelpers.export(exports, "unzipSync", ()=>unzipSync);
var ch2 = {};
var wk = function(c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: "text/javascript"
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err["code"] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var clim = new u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var freb = function(eb, start) {
    var b = new u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for(var i = 0; i < 32768; ++i){
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[rev[v] >>> rvb] = sv;
        }
    } else {
        co = new u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for(var i = 0; i < 144; ++i)flt[i] = 8;
for(var i = 144; i < 256; ++i)flt[i] = 9;
for(var i = 256; i < 280; ++i)flt[i] = 7;
for(var i = 280; i < 288; ++i)flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for(var i = 0; i < 32; ++i)fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v.BYTES_PER_ELEMENT == 2 ? u16 : v.BYTES_PER_ELEMENT == 4 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
];
var err = function(ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) err(0);
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[clim[i]] = bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else err(1);
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
            if (!c) err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) err(0);
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        et,
        0
    ];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var ln = function(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = flm, ll = flt, dm = fdm, dl = fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
        var dst = syms[i] & 31;
        wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
    } else wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e >= s) // write final block
        w[pos >> 3] = lst;
        pos = wfblk(w, pos + 1, dat.subarray(i, e));
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = wfblk(w, pos + 1, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var dopt = function(dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf("[") + 1, st.lastIndexOf("]")).replace(/\s+/g, "").split(",");
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == "function") {
            fnStr += ";" + k + "=";
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf("[native code]") != -1) {
                    var spInd = st_1.indexOf(" ", 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf("(", spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ";" + k + ".prototype." + t + "=" + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var ch = [];
// clone bufs
var cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var wrkr = function(fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = "", td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + init.toString() + "}", id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        fl,
        fd,
        flrm,
        fdrm,
        rev,
        ec,
        hMap,
        max,
        bits,
        bits16,
        shft,
        slc,
        err,
        inflt,
        inflateSync,
        pbf,
        gu8
    ];
};
var bDflt = function() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        revfl,
        revfd,
        flm,
        flt,
        fdm,
        fdt,
        rev,
        deo,
        et,
        hMap,
        wbits,
        wbits16,
        hTree,
        ln,
        lc,
        clen,
        wfblk,
        wblk,
        shft,
        slc,
        dflt,
        dopt,
        deflateSync,
        pbf
    ];
};
// gzip extra
var gze = function() {
    return [
        gzh,
        gzhl,
        wbytes,
        crc,
        crct
    ];
};
// gunzip extra
var guze = function() {
    return [
        gzs,
        gzl
    ];
};
// zlib extra
var zle = function() {
    return [
        zlh,
        wbytes,
        adler
    ];
};
// unzlib extra
var zule = function() {
    return [
        zlv
    ];
};
// post buf
var pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var gu8 = function(o) {
    return o && o.size && new u8(o.size);
};
// async helper
var cbify = function(dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (!strm.ondata) err(5);
        if (t) strm.ondata(err(4, 0, 1), null, !!f);
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var b8 = function(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
};
// write bytes
var wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, "invalid gzip data");
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, "invalid zlib data");
    if (d[1] & 32) err(6, "invalid zlib data: preset dictionaries not supported");
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == "function") cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var Deflate = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == "function") cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var AsyncDeflate = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function() {
                return [
                    astrm,
                    Deflate
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function deflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt
    ], function(ev) {
        return pbf(deflateSync(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var Inflate = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var AsyncInflate = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            function() {
                return [
                    astrm,
                    Inflate
                ];
            }
        ], this, 0, function() {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function inflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt
    ], function(ev) {
        return pbf(inflateSync(ev.data[0], gu8(ev.data[1])));
    }, 1, cb);
}
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var Gzip = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v) gzh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var AsyncGzip = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function() {
                return [
                    astrm,
                    Deflate,
                    Gzip
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function gzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function() {
            return [
                gzipSync
            ];
        }
    ], function(ev) {
        return pbf(gzipSync(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function gzipSync(data, opts) {
    if (!opts) opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var Gunzip = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) err(6, "invalid gzip data");
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var AsyncGunzip = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            guze,
            function() {
                return [
                    astrm,
                    Inflate,
                    Gunzip
                ];
            }
        ], this, 0, function() {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function gunzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function() {
            return [
                gunzipSync
            ];
        }
    ], function(ev) {
        return pbf(gunzipSync(ev.data[0]));
    }, 3, cb);
}
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var Zlib = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) zlh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var AsyncZlib = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function() {
                return [
                    astrm,
                    Deflate,
                    Zlib
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function zlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function() {
            return [
                zlibSync
            ];
        }
    ], function(ev) {
        return pbf(zlibSync(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function zlibSync(data, opts) {
    if (!opts) opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var Unzlib = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) err(6, "invalid zlib data");
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var AsyncUnzlib = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            zule,
            function() {
                return [
                    astrm,
                    Inflate,
                    Unzlib
                ];
            }
        ], this, 0, function() {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function unzlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function() {
            return [
                unzlibSync
            ];
        }
    ], function(ev) {
        return pbf(unzlibSync(ev.data[0], gu8(ev.data[1])));
    }, 5, cb);
}
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var Decompress = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var AsyncDecompress = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function decompress(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
}
function decompressSync(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, out) : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += "/"] = [
                new u8(0),
                op
            ];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != "undefined" && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != "undefined" && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, {
        stream: true
    });
    tds = 1;
} catch (e) {}
// decode UTF8
var dutf8 = function(d) {
    for(var r = "", i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var DecodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds) this.t = new TextDecoder();
        else this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) err(8);
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var EncodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te) return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = "";
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if (td) return td.decode(dat);
    else {
        var _a = dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) err(8);
        return out;
    }
}
// deflate bit flag
var dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var slzh = function(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
};
// read zip header
var zh = function(d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [
        bs,
        b4(d, b + 24),
        b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        b2(d, b + 10),
        sc,
        su,
        fn,
        es + b2(d, b + 30) + b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var z64e = function(d, b) {
    for(; b2(d, b) != 1; b += 4 + b2(d, b + 2));
    return [
        b8(d, b + 12),
        b8(d, b + 4),
        b8(d, b + 20)
    ];
};
// extra field length
var exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) err(10);
    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != -1) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        wbytes(d, b, +k);
        wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function(o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var ZipPassThrough = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var ZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var AsyncZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var Zip = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (!this.ondata) err(5);
        // finishing or finished
        if (this.d & 2) this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function zip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    var r = {};
    fltn(data, "", r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl(err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, deflateSync(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function zipSync(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    fltn(data, "", r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535) err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var UnzipPassThrough = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var UnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var AsyncUnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new AsyncInflate(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var Unzip = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) err(5);
        if (!this.p) err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) err(5);
                                if (!sc_1) file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) file_1.ondata(err(14, "unknown compression type " + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push(et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var mt = typeof queueMicrotask == "function" ? queueMicrotask : typeof setTimeout == "function" ? setTimeout : function(fn) {
    fn();
};
function unzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd(err(13, 0, 1), null);
        return tAll;
    }
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = b4(data, e - 12);
            z = b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = b4(data, ze + 32);
                o = b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) try {
                        cbl(null, inflateSync(infl, new u8(su)));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push(inflate(infl, {
                        size: su
                    }, cbl));
                } else cbl(err(14, "unknown compression type " + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) err(13);
    var c = b2(data, e + 8);
    if (!c) return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = b4(data, e - 12);
        z = b4(data, ze) == 0x6064B50;
        if (z) {
            c = b4(data, ze + 32);
            o = b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));
            else err(14, "unknown compression type " + c_2);
        }
    }
    return files;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dPgIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>readXlsxFileContents);
var _readXlsxJs = require("./readXlsx.js");
var _readXlsxJsDefault = parcelHelpers.interopDefault(_readXlsxJs);
var _convertToJsonJs = require("./schema/convertToJson.js");
var _convertToJsonJsDefault = parcelHelpers.interopDefault(_convertToJsonJs);
var _convertMapToSchemaJs = require("./schema/convertMapToSchema.js");
var _convertMapToSchemaJsDefault = parcelHelpers.interopDefault(_convertMapToSchemaJs);
var _excluded = [
    "schema",
    "map"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function readXlsxFileContents(entries, xml, _ref) {
    var schema = _ref.schema, map = _ref.map, options = _objectWithoutProperties(_ref, _excluded);
    if (!schema && map) schema = (0, _convertMapToSchemaJsDefault.default)(map);
    var result = (0, _readXlsxJsDefault.default)(entries, xml, _objectSpread(_objectSpread({}, options), {}, {
        properties: schema || options.properties
    }));
    if (schema) return (0, _convertToJsonJsDefault.default)(result.data, schema, _objectSpread(_objectSpread({}, options), {}, {
        properties: result.properties
    }));
    return result;
}

},{"./readXlsx.js":"17zuZ","./schema/convertToJson.js":"9yO1w","./schema/convertMapToSchema.js":"iX6rt","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"17zuZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>readXlsx);
var _parsePropertiesJs = require("./parseProperties.js");
var _parsePropertiesJsDefault = parcelHelpers.interopDefault(_parsePropertiesJs);
var _parseFilePathsJs = require("./parseFilePaths.js");
var _parseFilePathsJsDefault = parcelHelpers.interopDefault(_parseFilePathsJs);
var _parseStylesJs = require("./parseStyles.js");
var _parseStylesJsDefault = parcelHelpers.interopDefault(_parseStylesJs);
var _parseSharedStringsJs = require("./parseSharedStrings.js");
var _parseSharedStringsJsDefault = parcelHelpers.interopDefault(_parseSharedStringsJs);
var _parseSheetJs = require("./parseSheet.js");
var _parseSheetJsDefault = parcelHelpers.interopDefault(_parseSheetJs);
var _getDataJs = require("./getData.js"); // For an introduction in reading `*.xlsx` files see "The minimum viable XLSX reader":
var _getDataJsDefault = parcelHelpers.interopDefault(_getDataJs);
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function readXlsx(contents, xml) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!options.sheet) options = _objectSpread({
        sheet: 1
    }, options);
    var getXmlFileContent = function getXmlFileContent(filePath) {
        if (!contents[filePath]) throw new Error('"'.concat(filePath, '" file not found inside the *.xlsx file zip archive'));
        return contents[filePath];
    }; // Some Excel editors don't want to use standard naming scheme for sheet files.
    // https://github.com/tidyverse/readxl/issues/104
    var filePaths = (0, _parseFilePathsJsDefault.default)(getXmlFileContent("xl/_rels/workbook.xml.rels"), xml); // Default file path for "shared strings": "xl/sharedStrings.xml".
    var values = filePaths.sharedStrings ? (0, _parseSharedStringsJsDefault.default)(getXmlFileContent(filePaths.sharedStrings), xml) : []; // Default file path for "styles": "xl/styles.xml".
    var styles = filePaths.styles ? (0, _parseStylesJsDefault.default)(getXmlFileContent(filePaths.styles), xml) : {};
    var properties = (0, _parsePropertiesJsDefault.default)(getXmlFileContent("xl/workbook.xml"), xml); // A feature for getting the list of sheets in an Excel file.
    // https://github.com/catamphetamine/read-excel-file/issues/14
    if (options.getSheets) return properties.sheets.map(function(_ref) {
        var name = _ref.name;
        return {
            name: name
        };
    });
     // Find the sheet by name, or take the first one.
    var sheetId = getSheetId(options.sheet, properties.sheets); // If the sheet wasn't found then throw an error.
    // Example: "xl/worksheets/sheet1.xml".
    if (!sheetId || !filePaths.sheets[sheetId]) throw createSheetNotFoundError(options.sheet, properties.sheets);
     // Parse sheet data.
    var sheet = (0, _parseSheetJsDefault.default)(getXmlFileContent(filePaths.sheets[sheetId]), xml, values, styles, properties, options); // Get spreadsheet data.
    var data = (0, _getDataJsDefault.default)(sheet, options); // Can return properties, if required.
    if (options.properties) return {
        data: data,
        properties: properties
    };
     // Return spreadsheet data.
    return data;
}
function getSheetId(sheet, sheets) {
    if (typeof sheet === "number") {
        var _sheet = sheets[sheet - 1];
        return _sheet && _sheet.relationId;
    }
    for(var _iterator = _createForOfIteratorHelperLoose(sheets), _step; !(_step = _iterator()).done;){
        var _sheet2 = _step.value;
        if (_sheet2.name === sheet) return _sheet2.relationId;
    }
}
function createSheetNotFoundError(sheet, sheets) {
    var sheetsList = sheets && sheets.map(function(sheet, i) {
        return '"'.concat(sheet.name, '" (#').concat(i + 1, ")");
    }).join(", ");
    return new Error("Sheet ".concat(typeof sheet === "number" ? "#" + sheet : '"' + sheet + '"', " not found in the *.xlsx file.").concat(sheets ? " Available sheets: " + sheetsList + "." : ""));
}

},{"./parseProperties.js":"3Hb5U","./parseFilePaths.js":"gj09x","./parseStyles.js":"hrFIT","./parseSharedStrings.js":"jnDgw","./parseSheet.js":"3HMIw","./getData.js":"dO7pg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3Hb5U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProperties);
var _xlsxJs = require("../xml/xlsx.js"); // I guess `xl/workbook.xml` file should always be present inside the *.xlsx archive.
function parseProperties(content, xml) {
    var book = xml.createDocument(content);
    var properties = {}; // Read `<workbookPr/>` element to detect whether dates are 1900-based or 1904-based.
    // https://support.microsoft.com/en-gb/help/214330/differences-between-the-1900-and-the-1904-date-system-in-excel
    // http://webapp.docx4java.org/OnlineDemo/ecma376/SpreadsheetML/workbookPr.html
    var workbookProperties = (0, _xlsxJs.getWorkbookProperties)(book);
    if (workbookProperties && workbookProperties.getAttribute("date1904") === "1") properties.epoch1904 = true;
     // Get sheets info (indexes, names, if they're available).
    // Example:
    // <sheets>
    //   <sheet
    //     xmlns:ns="http://schemas.openxmlformats.org/officeDocument/2006/relationships"
    //     name="Sheet1"
    //     sheetId="1"
    //     ns:id="rId3"/>
    // </sheets>
    // http://www.datypic.com/sc/ooxml/e-ssml_sheet-1.html
    properties.sheets = [];
    var addSheetInfo = function addSheetInfo(sheet) {
        if (sheet.getAttribute("name")) properties.sheets.push({
            id: sheet.getAttribute("sheetId"),
            name: sheet.getAttribute("name"),
            relationId: sheet.getAttribute("r:id")
        });
    };
    (0, _xlsxJs.getSheets)(book).forEach(addSheetInfo);
    return properties;
}

},{"../xml/xlsx.js":"6kX5P","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6kX5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// each element being an XML DOM element representing a cell.
parcelHelpers.export(exports, "getCells", ()=>getCells);
parcelHelpers.export(exports, "getMergedCells", ()=>getMergedCells);
parcelHelpers.export(exports, "getCellValue", ()=>getCellValue);
parcelHelpers.export(exports, "getCellInlineStringValue", ()=>getCellInlineStringValue);
parcelHelpers.export(exports, "getDimensions", ()=>getDimensions);
parcelHelpers.export(exports, "getBaseStyles", ()=>getBaseStyles);
parcelHelpers.export(exports, "getCellStyles", ()=>getCellStyles);
parcelHelpers.export(exports, "getNumberFormats", ()=>getNumberFormats);
parcelHelpers.export(exports, "getSharedStrings", ()=>getSharedStrings);
parcelHelpers.export(exports, "getWorkbookProperties", ()=>getWorkbookProperties);
parcelHelpers.export(exports, "getRelationships", ()=>getRelationships);
parcelHelpers.export(exports, "getSheets", ()=>getSheets);
var _domJs = require("./dom.js"); // Returns an array of cells,
function getCells(document) {
    var worksheet = document.documentElement;
    var sheetData = (0, _domJs.findChild)(worksheet, "sheetData");
    var cells = [];
    (0, _domJs.forEach)(sheetData, "row", function(row) {
        (0, _domJs.forEach)(row, "c", function(cell) {
            cells.push(cell);
        });
    });
    return cells;
}
function getMergedCells(document) {
    var worksheet = document.documentElement;
    var mergedCells = (0, _domJs.findChild)(worksheet, "mergeCells");
    var mergedCellsInfo = [];
    if (mergedCells) (0, _domJs.forEach)(mergedCells, "mergeCell", function(mergedCell) {
        mergedCellsInfo.push(mergedCell.getAttribute("ref"));
    });
    return mergedCellsInfo;
}
function getCellValue(document, node) {
    return (0, _domJs.findChild)(node, "v");
}
function getCellInlineStringValue(document, node) {
    if (node.firstChild && (0, _domJs.getTagName)(node.firstChild) === "is" && node.firstChild.firstChild && (0, _domJs.getTagName)(node.firstChild.firstChild) === "t") return node.firstChild.firstChild.textContent;
}
function getDimensions(document) {
    var worksheet = document.documentElement;
    var dimensions = (0, _domJs.findChild)(worksheet, "dimension");
    if (dimensions) return dimensions.getAttribute("ref");
}
function getBaseStyles(document) {
    var styleSheet = document.documentElement;
    var cellStyleXfs = (0, _domJs.findChild)(styleSheet, "cellStyleXfs");
    if (cellStyleXfs) return (0, _domJs.findChildren)(cellStyleXfs, "xf");
    return [];
}
function getCellStyles(document) {
    var styleSheet = document.documentElement;
    var cellXfs = (0, _domJs.findChild)(styleSheet, "cellXfs");
    if (!cellXfs) return [];
    return (0, _domJs.findChildren)(cellXfs, "xf");
}
function getNumberFormats(document) {
    var styleSheet = document.documentElement;
    var numberFormats = [];
    var numFmts = (0, _domJs.findChild)(styleSheet, "numFmts");
    if (numFmts) return (0, _domJs.findChildren)(numFmts, "numFmt");
    return [];
}
function getSharedStrings(document) {
    // An `<si/>` element can contain a `<t/>` (simplest case) or a set of `<r/>` ("rich formatting") elements having `<t/>`.
    // https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.sharedstringitem?redirectedfrom=MSDN&view=openxml-2.8.1
    // http://www.datypic.com/sc/ooxml/e-ssml_si-1.html
    var sst = document.documentElement;
    return (0, _domJs.map)(sst, "si", function(string) {
        var t = (0, _domJs.findChild)(string, "t");
        if (t) return t.textContent;
        var value = "";
        (0, _domJs.forEach)(string, "r", function(r) {
            value += (0, _domJs.findChild)(r, "t").textContent;
        });
        return value;
    });
}
function getWorkbookProperties(document) {
    var workbook = document.documentElement;
    return (0, _domJs.findChild)(workbook, "workbookPr");
}
function getRelationships(document) {
    var relationships = document.documentElement;
    return (0, _domJs.findChildren)(relationships, "Relationship");
}
function getSheets(document) {
    var workbook = document.documentElement;
    var sheets = (0, _domJs.findChild)(workbook, "sheets");
    return (0, _domJs.findChildren)(sheets, "sheet");
}

},{"./dom.js":"1nBpF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1nBpF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findChild", ()=>findChild);
parcelHelpers.export(exports, "findChildren", ()=>findChildren);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "getTagName", ()=>getTagName) // This function is only used for occasional debug messages.
;
parcelHelpers.export(exports, "getOuterXml", ()=>getOuterXml);
function findChild(node, tagName) {
    var i = 0;
    while(i < node.childNodes.length){
        var childNode = node.childNodes[i]; // `nodeType: 1` means "Element".
        // https://www.w3schools.com/xml/prop_element_nodetype.asp
        if (childNode.nodeType === 1 && getTagName(childNode) === tagName) return childNode;
        i++;
    }
}
function findChildren(node, tagName) {
    var results = [];
    var i = 0;
    while(i < node.childNodes.length){
        var childNode = node.childNodes[i]; // `nodeType: 1` means "Element".
        // https://www.w3schools.com/xml/prop_element_nodetype.asp
        if (childNode.nodeType === 1 && getTagName(childNode) === tagName) results.push(childNode);
        i++;
    }
    return results;
}
function forEach(node, tagName, func) {
    // if (typeof tagName === 'function') {
    // 	func = tagName
    // 	tagName = undefined
    // }
    var i = 0;
    while(i < node.childNodes.length){
        var childNode = node.childNodes[i];
        if (tagName) // `nodeType: 1` means "Element".
        // https://www.w3schools.com/xml/prop_element_nodetype.asp
        {
            if (childNode.nodeType === 1 && getTagName(childNode) === tagName) func(childNode, i);
        } else func(childNode, i);
        i++;
    }
}
function map(node, tagName, func) {
    var results = [];
    forEach(node, tagName, function(node, i) {
        results.push(func(node, i));
    });
    return results;
}
var NAMESPACE_REG_EXP = /.+\:/;
function getTagName(element) {
    // For some weird reason, if an element is declared as,
    // for example, `<x:sheets/>`, then its `.tagName` will be
    // "x:sheets" instead of just "sheets".
    // https://gitlab.com/catamphetamine/read-excel-file/-/issues/25
    // Its not clear how to tell it to ignore any namespaces
    // when getting `.tagName`, so just replacing anything
    // before a colon, if any.
    return element.tagName.replace(NAMESPACE_REG_EXP, "");
}
function getOuterXml(node) {
    // `nodeType: 1` means "Element".
    // https://www.w3schools.com/xml/prop_element_nodetype.asp
    if (node.nodeType !== 1) return node.textContent;
    var xml = "<" + getTagName(node);
    var j = 0;
    while(j < node.attributes.length){
        xml += " " + node.attributes[j].name + "=" + '"' + node.attributes[j].value + '"';
        j++;
    }
    xml += ">";
    var i = 0;
    while(i < node.childNodes.length){
        xml += getOuterXml(node.childNodes[i]);
        i++;
    }
    xml += "</" + getTagName(node) + ">";
    return xml;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gj09x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseFilePaths);
var _xlsxJs = require("../xml/xlsx.js");
function parseFilePaths(content, xml) {
    // Example:
    // <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    //   ...
    //   <Relationship
    //     Id="rId3"
    //     Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"
    //     Target="worksheets/sheet1.xml"/>
    // </Relationships>
    var document = xml.createDocument(content);
    var filePaths = {
        sheets: {},
        sharedStrings: undefined,
        styles: undefined
    };
    var addFilePathInfo = function addFilePathInfo(relationship) {
        var filePath = relationship.getAttribute("Target");
        var fileType = relationship.getAttribute("Type");
        switch(fileType){
            case "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles":
                filePaths.styles = getFilePath(filePath);
                break;
            case "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings":
                filePaths.sharedStrings = getFilePath(filePath);
                break;
            case "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet":
                filePaths.sheets[relationship.getAttribute("Id")] = getFilePath(filePath);
                break;
        }
    };
    (0, _xlsxJs.getRelationships)(document).forEach(addFilePathInfo); // Seems like "sharedStrings.xml" is not required to exist.
    // For example, when the spreadsheet doesn't contain any strings.
    // https://github.com/catamphetamine/read-excel-file/issues/85
    // if (!filePaths.sharedStrings) {
    //   throw new Error('"sharedStrings.xml" file not found in the *.xlsx file')
    // }
    return filePaths;
}
function getFilePath(path) {
    // Normally, `path` is a relative path inside the ZIP archive,
    // like "worksheets/sheet1.xml", or "sharedStrings.xml", or "styles.xml".
    // There has been one weird case when file path was an absolute path,
    // like "/xl/worksheets/sheet1.xml" (specifically for sheets):
    // https://github.com/catamphetamine/read-excel-file/pull/95
    // Other libraries (like `xlsx`) and software (like Google Docs)
    // seem to support such absolute file paths, so this library does too.
    if (path[0] === "/") return path.slice(1);
     // // Seems like a path could also be a URL.
    // // http://officeopenxml.com/anatomyofOOXML-xlsx.php
    // if (/^[a-z]+\:\/\//.test(path)) {
    //   return path
    // }
    return "xl/" + path;
}

},{"../xml/xlsx.js":"6kX5P","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hrFIT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseStyles);
var _xlsxJs = require("../xml/xlsx.js"); // http://officeopenxml.com/SSstyles.php
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function parseStyles(content, xml) {
    if (!content) return {};
     // https://social.msdn.microsoft.com/Forums/sqlserver/en-US/708978af-b598-45c4-a598-d3518a5a09f0/howwhen-is-cellstylexfs-vs-cellxfs-applied-to-a-cell?forum=os_binaryfile
    // https://www.office-forums.com/threads/cellxfs-cellstylexfs.2163519/
    var doc = xml.createDocument(content);
    var baseStyles = (0, _xlsxJs.getBaseStyles)(doc).map(parseCellStyle);
    var numberFormats = (0, _xlsxJs.getNumberFormats)(doc).map(parseNumberFormatStyle).reduce(function(formats, format) {
        // Format ID is a numeric index.
        // There're some standard "built-in" formats (in Excel) up to about `100`.
        formats[format.id] = format;
        return formats;
    }, []);
    var getCellStyle = function getCellStyle(xf) {
        if (xf.hasAttribute("xfId")) return _objectSpread(_objectSpread({}, baseStyles[xf.xfId]), parseCellStyle(xf, numberFormats));
        return parseCellStyle(xf, numberFormats);
    };
    return (0, _xlsxJs.getCellStyles)(doc).map(getCellStyle);
}
function parseNumberFormatStyle(numFmt) {
    return {
        id: numFmt.getAttribute("numFmtId"),
        template: numFmt.getAttribute("formatCode")
    };
} // http://www.datypic.com/sc/ooxml/e-ssml_xf-2.html
function parseCellStyle(xf, numFmts) {
    var style = {};
    if (xf.hasAttribute("numFmtId")) {
        var numberFormatId = xf.getAttribute("numFmtId"); // Built-in number formats don't have a `<numFmt/>` element in `styles.xml`.
        // https://hexdocs.pm/xlsxir/number_styles.html
        if (numFmts[numberFormatId]) style.numberFormat = numFmts[numberFormatId];
        else style.numberFormat = {
            id: numberFormatId
        };
    }
    return style;
}

},{"../xml/xlsx.js":"6kX5P","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jnDgw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseSharedStrings);
var _xlsxJs = require("../xml/xlsx.js");
function parseSharedStrings(content, xml) {
    if (!content) return [];
    return (0, _xlsxJs.getSharedStrings)(xml.createDocument(content));
}

},{"../xml/xlsx.js":"6kX5P","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3HMIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseSheet);
var _parseCellsJs = require("./parseCells.js");
var _parseCellsJsDefault = parcelHelpers.interopDefault(_parseCellsJs);
var _parseDimensionsJs = require("./parseDimensions.js");
var _parseDimensionsJsDefault = parcelHelpers.interopDefault(_parseDimensionsJs);
var _coordinatesJs = require("./coordinates.js");
function parseSheet(content, xml, values, styles, properties, options) {
    var sheet = xml.createDocument(content);
    var cells = (0, _parseCellsJsDefault.default)(sheet, xml, values, styles, properties, options); // `dimensions` defines the spreadsheet area containing all non-empty cells.
    // https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.sheetdimension?view=openxml-2.8.1
    var dimensions = (0, _parseDimensionsJsDefault.default)(sheet) || (0, _coordinatesJs.calculateDimensions)(cells);
    return {
        cells: cells,
        dimensions: dimensions
    };
}

},{"./parseCells.js":"hKWfo","./parseDimensions.js":"3iQmB","./coordinates.js":"lGzby","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hKWfo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseCells);
var _parseCellJs = require("./parseCell.js");
var _parseCellJsDefault = parcelHelpers.interopDefault(_parseCellJs);
var _xlsxJs = require("../xml/xlsx.js");
function parseCells(sheet, xml, values, styles, properties, options) {
    var cells = (0, _xlsxJs.getCells)(sheet);
    if (cells.length === 0) return [];
     // const mergedCells = getMergedCells(sheet)
    // for (const mergedCell of mergedCells) {
    //   const [from, to] = mergedCell.split(':').map(parseCellCoordinates)
    //   console.log('Merged Cell.', 'From:', from, 'To:', to)
    // }
    return cells.map(function(node) {
        return (0, _parseCellJsDefault.default)(node, sheet, xml, values, styles, properties, options);
    });
}

},{"./parseCell.js":"2rEIO","../xml/xlsx.js":"6kX5P","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2rEIO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseCell);
var _parseCellValueJs = require("./parseCellValue.js");
var _parseCellValueJsDefault = parcelHelpers.interopDefault(_parseCellValueJs);
var _coordinatesJs = require("./coordinates.js");
var _xlsxJs = require("../xml/xlsx.js");
var _domJs = require("../xml/dom.js"); // Example of a `<c/>`ell element:
function parseCell(node, sheet, xml, values, styles, properties, options) {
    var coords = (0, _coordinatesJs.parseCellCoordinates)(node.getAttribute("r"));
    var valueElement = (0, _xlsxJs.getCellValue)(sheet, node); // For `xpath`, `value` can be `undefined` while for native `DOMParser` it's `null`.
    // So using `value && ...` instead of `if (value !== undefined) { ... }` here
    // for uniform compatibility with both `xpath` and native `DOMParser`.
    var value = valueElement && valueElement.textContent;
    var type;
    if (node.hasAttribute("t")) type = node.getAttribute("t");
    return {
        row: coords[0],
        column: coords[1],
        value: (0, _parseCellValueJsDefault.default)(value, type, {
            getInlineStringValue: function getInlineStringValue() {
                return (0, _xlsxJs.getCellInlineStringValue)(sheet, node);
            },
            getInlineStringXml: function getInlineStringXml() {
                return (0, _domJs.getOuterXml)(node);
            },
            getStyleId: function getStyleId() {
                return node.getAttribute("s");
            },
            styles: styles,
            values: values,
            properties: properties,
            options: options
        })
    };
}

},{"./parseCellValue.js":"022fg","./coordinates.js":"lGzby","../xml/xlsx.js":"6kX5P","../xml/dom.js":"1nBpF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"022fg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseCellValue);
var _parseDateJs = require("./parseDate.js");
var _parseDateJsDefault = parcelHelpers.interopDefault(_parseDateJs);
var _isDateTimestampJs = require("./isDateTimestamp.js"); // Parses a string `value` of a cell.
var _isDateTimestampJsDefault = parcelHelpers.interopDefault(_isDateTimestampJs);
function parseCellValue(value, type, _ref) {
    var getInlineStringValue = _ref.getInlineStringValue, getInlineStringXml = _ref.getInlineStringXml, getStyleId = _ref.getStyleId, styles = _ref.styles, values = _ref.values, properties = _ref.properties, options = _ref.options;
    if (!type) // Default cell type is "n" (numeric).
    // http://www.datypic.com/sc/ooxml/t-ssml_CT_Cell.html
    type = "n";
     // Available Excel cell types:
    // https://github.com/SheetJS/sheetjs/blob/19620da30be2a7d7b9801938a0b9b1fd3c4c4b00/docbits/52_datatype.md
    //
    // Some other document (seems to be old):
    // http://webapp.docx4java.org/OnlineDemo/ecma376/SpreadsheetML/ST_CellType.html
    //
    switch(type){
        // XLSX tends to store all strings as "shared" (indexed) ones
        // using "s" cell type (for saving on strage space).
        // "str" cell type is then generally only used for storing
        // formula-pre-calculated cell values.
        case "str":
            value = parseString(value, options);
            break;
        // Sometimes, XLSX stores strings as "inline" strings rather than "shared" (indexed) ones.
        // Perhaps the specification doesn't force it to use one or another.
        // Example: `<sheetData><row r="1"><c r="A1" s="1" t="inlineStr"><is><t>Test 123</t></is></c></row></sheetData>`.
        case "inlineStr":
            value = getInlineStringValue();
            if (value === undefined) throw new Error('Unsupported "inline string" cell value structure: '.concat(getInlineStringXml()));
            value = parseString(value, options);
            break;
        // XLSX tends to store string values as "shared" (indexed) ones.
        // "Shared" strings is a way for an Excel editor to reduce
        // the file size by storing "commonly used" strings in a dictionary
        // and then referring to such strings by their index in that dictionary.
        // Example: `<sheetData><row r="1"><c r="A1" s="1" t="s"><v>0</v></c></row></sheetData>`.
        case "s":
            // If a cell has no value then there's no `<c/>` element for it.
            // If a `<c/>` element exists then it's not empty.
            // The `<v/>`alue is a key in the "shared strings" dictionary of the
            // XLSX file, so look it up in the `values` dictionary by the numeric key.
            var sharedStringIndex = Number(value);
            if (isNaN(sharedStringIndex)) throw new Error('Invalid "shared" string index: '.concat(value));
            if (sharedStringIndex >= values.length) throw new Error('An out-of-bounds "shared" string index: '.concat(value));
            value = values[sharedStringIndex];
            value = parseString(value, options);
            break;
        // Boolean (TRUE/FALSE) values are stored as either "1" or "0"
        // in cells of type "b".
        case "b":
            if (value === "1") value = true;
            else if (value === "0") value = false;
            else throw new Error('Unsupported "boolean" cell value: '.concat(value));
            break;
        // XLSX specification seems to support cells of type "z":
        // blank "stub" cells that should be ignored by data processing utilities.
        case "z":
            value = undefined;
            break;
        // XLSX specification also defines cells of type "e" containing a numeric "error" code.
        // It's not clear what that means though.
        // They also wrote: "and `w` property stores its common name".
        // It's unclear what they meant by that.
        case "e":
            value = decodeError(value);
            break;
        // XLSX supports date cells of type "d", though seems like it (almost?) never
        // uses it for storing dates, preferring "n" numeric timestamp cells instead.
        // The value of a "d" cell is supposedly a string in "ISO 8601" format.
        // I haven't seen an XLSX file having such cells.
        // Example: `<sheetData><row r="1"><c r="A1" s="1" t="d"><v>2021-06-10T00:47:45.700Z</v></c></row></sheetData>`.
        case "d":
            if (value === undefined) break;
            var parsedDate = new Date(value);
            if (isNaN(parsedDate.valueOf())) throw new Error('Unsupported "date" cell value: '.concat(value));
            value = parsedDate;
            break;
        // Numeric cells have type "n".
        case "n":
            if (value === undefined) break;
            var isDateTimestampNumber = (0, _isDateTimestampJsDefault.default)(getStyleId(), styles, options); // XLSX does have "d" type for dates, but it's not commonly used.
            // Instead, it prefers using "n" type for storing dates as timestamps.
            if (isDateTimestampNumber) {
                // Parse the number from string.
                value = parseNumberDefault(value); // Parse the number as a date timestamp.
                value = (0, _parseDateJsDefault.default)(value, properties);
            } else // Parse the number from string.
            // Supports custom parsing function to work around javascript number encoding precision issues.
            // https://gitlab.com/catamphetamine/read-excel-file/-/issues/85
            value = (options.parseNumber || parseNumberDefault)(value);
            break;
        default:
            throw new TypeError("Cell type not supported: ".concat(type));
    } // Convert empty values to `null`.
    if (value === undefined) value = null;
    return value;
} // Decodes numeric error code to a string code.
// https://github.com/SheetJS/sheetjs/blob/19620da30be2a7d7b9801938a0b9b1fd3c4c4b00/docbits/52_datatype.md
function decodeError(errorCode) {
    // While the error values are determined by the application,
    // the following are some example error values that could be used:
    switch(errorCode){
        case 0x00:
            return "#NULL!";
        case 0x07:
            return "#DIV/0!";
        case 0x0F:
            return "#VALUE!";
        case 0x17:
            return "#REF!";
        case 0x1D:
            return "#NAME?";
        case 0x24:
            return "#NUM!";
        case 0x2A:
            return "#N/A";
        case 0x2B:
            return "#GETTING_DATA";
        default:
            // Such error code doesn't exist. I made it up.
            return "#ERROR_".concat(errorCode);
    }
}
function parseString(value, options) {
    // In some weird cases, a developer might want to disable
    // the automatic trimming of all strings.
    // For example, leading spaces might express a tree-like hierarchy.
    // https://github.com/catamphetamine/read-excel-file/pull/106#issuecomment-1136062917
    if (options.trim !== false) value = value.trim();
    if (value === "") value = undefined;
    return value;
} // Parses a number from string.
// Throws an error if the number couldn't be parsed.
// When parsing floating-point number, is affected by
// the javascript number encoding precision issues:
// https://www.youtube.com/watch?v=2gIxbTn7GSc
// https://www.avioconsulting.com/blog/overcoming-javascript-numeric-precision-issues
function parseNumberDefault(stringifiedNumber) {
    var parsedNumber = Number(stringifiedNumber);
    if (isNaN(parsedNumber)) throw new Error('Invalid "numeric" cell value: '.concat(stringifiedNumber));
    return parsedNumber;
}

},{"./parseDate.js":"d5mUp","./isDateTimestamp.js":"jB6jN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d5mUp":[function(require,module,exports) {
// Parses an Excel Date ("serial") into a corresponding javascript Date in UTC+0 timezone.
// (with time equal to 00:00)
//
// https://www.pcworld.com/article/3063622/software/mastering-excel-date-time-serial-numbers-networkdays-datevalue-and-more.html
// "If you need to calculate dates in your spreadsheets,
//  Excel uses its own unique system, which it calls Serial Numbers".
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseExcelDate);
function parseExcelDate(excelSerialDate, options) {
    // https://support.microsoft.com/en-gb/help/214330/differences-between-the-1900-and-the-1904-date-system-in-excel
    if (options && options.epoch1904) excelSerialDate += 1462;
     // "Excel serial date" is just
    // the count of days since `01/01/1900`
    // (seems that it may be even fractional).
    //
    // The count of days elapsed
    // since `01/01/1900` (Excel epoch)
    // till `01/01/1970` (Unix epoch).
    // Accounts for leap years
    // (19 of them, yielding 19 extra days).
    var daysBeforeUnixEpoch = 25569; // An hour, approximately, because a minute
    // may be longer than 60 seconds, due to "leap seconds".
    //
    // Still, Javascript `Date` (and UNIX time in general) intentionally
    // drops the concept of "leap seconds" in order to make things simpler.
    // So it's fine.
    // https://stackoverflow.com/questions/53019726/where-are-the-leap-seconds-in-javascript
    //
    // "The JavaScript Date object specifically adheres to the concept of Unix Time
    //  (albeit with higher precision). This is part of the POSIX specification,
    //  and thus is sometimes called "POSIX Time". It does not count leap seconds,
    //  but rather assumes every day had exactly 86,400 seconds. You can read about
    //  this in section 20.3.1.1 of the current ECMAScript specification, which states:
    //
    //  "Time is measured in ECMAScript in milliseconds since 01 January, 1970 UTC.
    //   In time values leap seconds are ignored. It is assumed that there are exactly
    //   86,400,000 milliseconds per day."
    //
    //  The fact is, that the unpredictable nature of leap seconds makes them very
    //  difficult to work with in APIs. One can't generally pass timestamps around
    //  that need leap seconds tables to be interpreted correctly, and expect that
    //  one system will interpret them the same as another. For example, while your
    //  example timestamp 1483228826 is 2017-01-01T00:00:00Z on your system,
    //  it would be interpreted as 2017-01-01T00:00:26Z on POSIX based systems,
    //  or systems without leap second tables. So they aren't portable.
    //  Even on systems that have full updated tables, there's no telling what those
    //  tables will contain in the future (beyond the 6-month IERS announcement period),
    //  so I can't produce a future timestamp without risk that it may eventually change.
    //
    //  To be clear - to support leap seconds in a programming language, the implementation
    //  must go out of its way to do so, and must make tradeoffs that are not always acceptable.
    //  Though there are exceptions, the general position is to not support them - not because
    //  of any subversion or active countermeasures, but because supporting them properly is much,
    //  much harder."
    //
    // https://en.wikipedia.org/wiki/Unix_time#Leap_seconds
    // https://en.wikipedia.org/wiki/Leap_year
    // https://en.wikipedia.org/wiki/Leap_second
    //
    var hour = 3600000;
    return new Date(Math.round((excelSerialDate - daysBeforeUnixEpoch) * 24 * hour));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jB6jN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDateTimestamp);
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function isDateTimestamp(styleId, styles, options) {
    if (styleId) {
        var style = styles[styleId];
        if (!style) throw new Error("Cell style not found: ".concat(styleId));
        if (!style.numberFormat) return false;
        if (BUILT_IN_DATE_NUMBER_FORMAT_IDS.indexOf(Number(style.numberFormat.id)) >= 0 || // Whether it's a "number format" that uses a "formatting template"
        // that the developer is certain is a date formatting template.
        options.dateFormat && style.numberFormat.template === options.dateFormat || // Whether the "smart formatting template" feature is not disabled
        // and it has detected that it's a date formatting template by looking at it.
        options.smartDateParser !== false && style.numberFormat.template && isDateTemplate(style.numberFormat.template)) return true;
    }
} // https://hexdocs.pm/xlsxir/number_styles.html
var BUILT_IN_DATE_NUMBER_FORMAT_IDS = [
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    27,
    30,
    36,
    45,
    46,
    47,
    50,
    57
]; // On some date formats, there's an "[$-414]" prefix.
// I don't have any idea what that is.
//
// https://stackoverflow.com/questions/4730152/what-indicates-an-office-open-xml-cell-contains-a-date-time-value
//
// Examples:
//
// * 27 (built-in format) "[$-404]e/m/d"
// * 164 (custom format) "[$-414]mmmm\ yyyy;@"
//
var DATE_FORMAT_WEIRD_PREFIX = /^\[\$-414\]/; // On some date formats, there's an ";@" postfix.
// I don't have any idea what that is.
// Examples:
//
// * 164 (custom format) "m/d/yyyy;@"
// * 164 (custom format) "[$-414]mmmm\ yyyy;@"
//
var DATE_FORMAT_WEIRD_POSTFIX = /;@$/;
function isDateTemplate(template) {
    // Date format tokens could be in upper case or in lower case.
    // There seems to be no single standard.
    // So lowercase the template first.
    template = template.toLowerCase(); // On some date formats, there's an "[$-414]" prefix.
    // I don't have any idea what that is. Trim it.
    template = template.replace(DATE_FORMAT_WEIRD_PREFIX, ""); // On some date formats, there's an ";@" postfix.
    // I don't have any idea what that is. Trim it.
    template = template.replace(DATE_FORMAT_WEIRD_POSTFIX, "");
    var tokens = template.split(/\W+/);
    for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (DATE_TEMPLATE_TOKENS.indexOf(token) < 0) return false;
    }
    return true;
} // These tokens could be in upper case or in lower case.
// There seems to be no single standard, so using lower case.
var DATE_TEMPLATE_TOKENS = [
    "ss",
    "mm",
    "h",
    "hh",
    "am",
    "pm",
    "d",
    "dd",
    "m",
    "mm",
    "mmm",
    "mmmm",
    "yy",
    "yyyy",
    // It's used in "built-in" XLSX formats:
    // * 27 '[$-404]e/m/d';
    // * 36 '[$-404]e/m/d';
    // * 50 '[$-404]e/m/d';
    // * 57 '[$-404]e/m/d';
    "e"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lGzby":[function(require,module,exports) {
// Maps "A1"-like coordinates to `{ row, column }` numeric coordinates.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateDimensions", ()=>calculateDimensions) // Converts a letter coordinate to a digit coordinate.
;
parcelHelpers.export(exports, "parseCellCoordinates", ()=>parseCellCoordinates);
var LETTERS = [
    "",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
];
function calculateDimensions(cells) {
    var comparator = function comparator(a, b) {
        return a - b;
    };
    var allRows = cells.map(function(cell) {
        return cell.row;
    }).sort(comparator);
    var allCols = cells.map(function(cell) {
        return cell.column;
    }).sort(comparator);
    var minRow = allRows[0];
    var maxRow = allRows[allRows.length - 1];
    var minCol = allCols[0];
    var maxCol = allCols[allCols.length - 1];
    return [
        {
            row: minRow,
            column: minCol
        },
        {
            row: maxRow,
            column: maxCol
        }
    ];
}
// Examples: "A" -> 1, "B" -> 2, "Z" -> 26, "AA" -> 27, etc.
function columnLettersToNumber(columnLetters) {
    // `for ... of ...` would require Babel polyfill for iterating a string.
    var n = 0;
    var i = 0;
    while(i < columnLetters.length){
        n *= 26;
        n += LETTERS.indexOf(columnLetters[i]);
        i++;
    }
    return n;
}
function parseCellCoordinates(coords) {
    // Coordinate examples: "AA2091", "R988", "B1".
    coords = coords.split(/(\d+)/);
    return [
        parseInt(coords[1]),
        columnLettersToNumber(coords[0].trim())
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3iQmB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseDimensions);
var _coordinatesJs = require("./coordinates.js");
var _xlsxJs = require("../xml/xlsx.js"); // `dimensions` defines the spreadsheet area containing all non-empty cells.
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function parseDimensions(sheet) {
    var dimensions = (0, _xlsxJs.getDimensions)(sheet);
    if (dimensions) {
        dimensions = dimensions.split(":").map((0, _coordinatesJs.parseCellCoordinates)).map(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 2), row = _ref2[0], column = _ref2[1];
            return {
                row: row,
                column: column
            };
        }); // Sometimes there can be just a single cell as a spreadsheet's "dimensions".
        // For example, the default "dimensions" in Apache POI library is "A1",
        // meaning that only the first cell in the spreadsheet is used.
        //
        // A quote from Apache POI library:
        // "Single cell ranges are formatted like single cell references (e.g. 'A1' instead of 'A1:A1')."
        //
        if (dimensions.length === 1) dimensions = [
            dimensions[0],
            dimensions[0]
        ];
        return dimensions;
    }
}

},{"./coordinates.js":"lGzby","../xml/xlsx.js":"6kX5P","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dO7pg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getData);
var _dropEmptyRowsJs = require("./dropEmptyRows.js");
var _dropEmptyRowsJsDefault = parcelHelpers.interopDefault(_dropEmptyRowsJs);
var _dropEmptyColumnsJs = require("./dropEmptyColumns.js");
var _dropEmptyColumnsJsDefault = parcelHelpers.interopDefault(_dropEmptyColumnsJs);
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function getData(sheet, options) {
    var dimensions = sheet.dimensions, cells = sheet.cells; // If the sheet is empty.
    if (cells.length === 0) return [];
    var _dimensions = _slicedToArray(dimensions, 2), leftTop = _dimensions[0], rightBottom = _dimensions[1]; // Don't discard empty rows or columns at the start.
    // https://github.com/catamphetamine/read-excel-file/issues/102
    // const colsCount = (rightBottom.column - leftTop.column) + 1
    // const rowsCount = (rightBottom.row - leftTop.row) + 1
    var colsCount = rightBottom.column;
    var rowsCount = rightBottom.row; // Initialize spreadsheet data structure.
    var data = new Array(rowsCount);
    var i = 0;
    while(i < rowsCount){
        data[i] = new Array(colsCount);
        var j = 0;
        while(j < colsCount){
            data[i][j] = null;
            j++;
        }
        i++;
    } // Fill in spreadsheet `data`.
    // (this code implies that `cells` aren't necessarily sorted by row and column:
    //  maybe that's not correct, this piece code was initially copy-pasted
    //  from some other library that used `XPath`)
    for(var _iterator = _createForOfIteratorHelperLoose(cells), _step; !(_step = _iterator()).done;){
        var cell = _step.value;
        // Don't discard empty rows or columns at the start.
        // https://github.com/catamphetamine/read-excel-file/issues/102
        // const rowIndex = cell.row - leftTop.row
        // const columnIndex = cell.column - leftTop.column
        var rowIndex = cell.row - 1;
        var columnIndex = cell.column - 1; // Ignore the data in the cell if it's outside of the spreadsheet's "dimensions".
        if (columnIndex < colsCount && rowIndex < rowsCount) data[rowIndex][columnIndex] = cell.value;
    } // Fill in the row map.
    var rowMap = options.rowMap;
    if (rowMap) {
        var _i2 = 0;
        while(_i2 < data.length){
            rowMap[_i2] = _i2;
            _i2++;
        }
    } // Drop empty columns or rows.
    data = (0, _dropEmptyRowsJsDefault.default)((0, _dropEmptyColumnsJsDefault.default)(data, {
        onlyTrimAtTheEnd: true
    }), {
        onlyTrimAtTheEnd: true,
        rowMap: rowMap
    }); // Optionally transform data before applying `schema`.
    if (options.transformData) data = options.transformData(data); // data = options.transformData(data, {
    return data;
}

},{"./dropEmptyRows.js":"8QnT1","./dropEmptyColumns.js":"9Mnt4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8QnT1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dropEmptyRows);
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function dropEmptyRows(data) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, rowMap = _ref.rowMap, _ref$accessor = _ref.accessor, accessor = _ref$accessor === void 0 ? function(_) {
        return _;
    } : _ref$accessor, onlyTrimAtTheEnd = _ref.onlyTrimAtTheEnd;
    // Drop empty rows.
    var i = data.length - 1;
    while(i >= 0){
        // Check if the row is empty.
        var empty = true;
        for(var _iterator = _createForOfIteratorHelperLoose(data[i]), _step; !(_step = _iterator()).done;){
            var cell = _step.value;
            if (accessor(cell) !== null) {
                empty = false;
                break;
            }
        } // Remove the empty row.
        if (empty) {
            data.splice(i, 1);
            if (rowMap) rowMap.splice(i, 1);
        } else if (onlyTrimAtTheEnd) break;
        i--;
    }
    return data;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9Mnt4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dropEmptyColumns);
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function dropEmptyColumns(data) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$accessor = _ref.accessor, accessor = _ref$accessor === void 0 ? function(_) {
        return _;
    } : _ref$accessor, onlyTrimAtTheEnd = _ref.onlyTrimAtTheEnd;
    var i = data[0].length - 1;
    while(i >= 0){
        var empty = true;
        for(var _iterator = _createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;){
            var row = _step.value;
            if (accessor(row[i]) !== null) {
                empty = false;
                break;
            }
        }
        if (empty) {
            var j = 0;
            while(j < data.length){
                data[j].splice(i, 1);
                j++;
            }
        } else if (onlyTrimAtTheEnd) break;
        i--;
    }
    return data;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9yO1w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert 2D array to nested objects.
 * If row oriented data, row 0 is dotted key names.
 * Column oriented data is transposed.
 * @param {any[][]} data - An array of rows, each row being an array of cells.
 * @param {object} schema
 * @return {object[]}
 */ parcelHelpers.export(exports, "default", ()=>function(data, schema, options) {
        if (options) options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
        else options = DEFAULT_OPTIONS;
        var _options = options, isColumnOriented = _options.isColumnOriented, rowMap = _options.rowMap, ignoreEmptyRows = _options.ignoreEmptyRows;
        validateSchema(schema);
        if (isColumnOriented) data = transpose(data);
        var columns = data[0];
        var results = [];
        var errors = [];
        for(var i = 1; i < data.length; i++){
            var result = read(schema, data[i], i, columns, errors, options);
            if (result !== null || ignoreEmptyRows === false) results.push(result);
        } // Correct error rows.
        if (rowMap) for(var _iterator = _createForOfIteratorHelperLoose(errors), _step; !(_step = _iterator()).done;){
            var error = _step.value;
            // Convert the `row` index in `data` to the
            // actual `row` index in the spreadsheet.
            // `- 1` converts row number to row index.
            // `+ 1` converts row index to row number.
            error.row = rowMap[error.row - 1] + 1;
        }
        return {
            rows: results,
            errors: errors
        };
    });
/**
 * Converts textual value to a javascript typed value.
 * @param  {any} value
 * @param  {object} schemaEntry
 * @return {{ value: any, error: string }}
 */ parcelHelpers.export(exports, "parseValue", ()=>parseValue);
parcelHelpers.export(exports, "getBlock", ()=>getBlock);
/**
 * Parses a string of comma-separated substrings into an array of substrings.
 * (the `export` is just for tests)
 * @param  {string} string — A string of comma-separated substrings.
 * @return {string[]} An array of substrings.
 */ parcelHelpers.export(exports, "parseArray", ()=>parseArray) // Transpose a 2D array.
;
var _numberJs = require("../../types/Number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _stringJs = require("../../types/String.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _booleanJs = require("../../types/Boolean.js");
var _booleanJsDefault = parcelHelpers.interopDefault(_booleanJs);
var _dateJs = require("../../types/Date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DEFAULT_OPTIONS = {
    isColumnOriented: false
};
function read(schema, row, rowIndex, columns, errors, options) {
    var object = {};
    var isEmptyObject = true;
    var createError = function createError(_ref) {
        var column = _ref.column, value = _ref.value, errorMessage = _ref.error, reason = _ref.reason;
        var error = {
            error: errorMessage,
            row: rowIndex + 1,
            column: column,
            value: value
        };
        if (reason) error.reason = reason;
        if (schema[column].type) error.type = schema[column].type;
        return error;
    };
    var pendingRequiredChecks = [];
    var _loop = function _loop() {
        var key = _Object$keys[_i];
        var schemaEntry = schema[key];
        var isNestedSchema = _typeof(schemaEntry.type) === "object" && !Array.isArray(schemaEntry.type);
        var rawValue = row[columns.indexOf(key)];
        if (rawValue === undefined) rawValue = null;
        var value = void 0;
        var error = void 0;
        var reason = void 0;
        if (isNestedSchema) value = read(schemaEntry.type, row, rowIndex, columns, errors, options);
        else {
            if (rawValue === null) value = null;
            else if (Array.isArray(schemaEntry.type)) {
                var notEmpty = false;
                var array = parseArray(rawValue).map(function(_value) {
                    var result = parseValue(_value, schemaEntry, options);
                    if (result.error) {
                        value = _value;
                        error = result.error;
                        reason = result.reason;
                    }
                    if (result.value !== null) notEmpty = true;
                    return result.value;
                });
                if (!error) value = notEmpty ? array : null;
            } else {
                var result = parseValue(rawValue, schemaEntry, options);
                error = result.error;
                reason = result.reason;
                value = error ? rawValue : result.value;
            }
        }
        if (!error && value === null) {
            if (typeof schemaEntry.required === "function") pendingRequiredChecks.push({
                column: key
            });
            else if (schemaEntry.required === true) error = "required";
        }
        if (error) errors.push(createError({
            column: key,
            value: value,
            error: error,
            reason: reason
        }));
        else {
            if (isEmptyObject && value !== null) isEmptyObject = false;
            if (value !== null || options.includeNullValues) object[schemaEntry.prop] = value;
        }
    };
    for(var _i = 0, _Object$keys = Object.keys(schema); _i < _Object$keys.length; _i++)_loop();
    if (isEmptyObject) return null;
    for(var _i2 = 0, _pendingRequiredCheck = pendingRequiredChecks; _i2 < _pendingRequiredCheck.length; _i2++){
        var column = _pendingRequiredCheck[_i2].column;
        var required = schema[column].required(object);
        if (required) errors.push(createError({
            column: column,
            value: null,
            error: "required"
        }));
    }
    return object;
}
function parseValue(value, schemaEntry, options) {
    if (value === null) return {
        value: null
    };
    var result;
    if (schemaEntry.parse) result = parseCustomValue(value, schemaEntry.parse);
    else if (schemaEntry.type) result = parseValueOfType(value, // See `parseArray()` function for more details.
    // Example `type`: String[]
    // Input: 'Barack Obama, "String, with, colons", Donald Trump'
    // Output: ['Barack Obama', 'String, with, colons', 'Donald Trump']
    Array.isArray(schemaEntry.type) ? schemaEntry.type[0] : schemaEntry.type, options);
    else result = {
        value: value
    }; // throw new Error('Invalid schema entry: no .type and no .parse():\n\n' + JSON.stringify(schemaEntry, null, 2))
     // If errored then return the error.
    if (result.error) return result;
    if (result.value !== null) {
        if (schemaEntry.oneOf && schemaEntry.oneOf.indexOf(result.value) < 0) return {
            error: "invalid",
            reason: "unknown"
        };
        if (schemaEntry.validate) try {
            schemaEntry.validate(result.value);
        } catch (error) {
            return {
                error: error.message
            };
        }
    }
    return result;
}
/**
 * Converts textual value to a custom value using supplied `.parse()`.
 * @param  {any} value
 * @param  {function} parse
 * @return {{ value: any, error: string }}
 */ function parseCustomValue(value, parse) {
    try {
        value = parse(value);
        if (value === undefined) return {
            value: null
        };
        return {
            value: value
        };
    } catch (error) {
        var result = {
            error: error.message
        };
        if (error.reason) result.reason = error.reason;
        return result;
    }
}
/**
 * Converts textual value to a javascript typed value.
 * @param  {any} value
 * @param  {} type
 * @return {{ value: (string|number|Date|boolean), error: string, reason?: string }}
 */ function parseValueOfType(value, type, options) {
    switch(type){
        case String:
            return parseCustomValue(value, (0, _stringJsDefault.default));
        case Number:
            return parseCustomValue(value, (0, _numberJsDefault.default));
        case Date:
            return parseCustomValue(value, function(value) {
                return (0, _dateJsDefault.default)(value, {
                    properties: options.properties
                });
            });
        case Boolean:
            return parseCustomValue(value, (0, _booleanJsDefault.default));
        default:
            if (typeof type === "function") return parseCustomValue(value, type);
            throw new Error("Unsupported schema type: ".concat(type && type.name || type));
    }
}
function getBlock(string, endCharacter, startIndex) {
    var i = 0;
    var substring = "";
    var character;
    while(startIndex + i < string.length){
        var _character = string[startIndex + i];
        if (_character === endCharacter) return [
            substring,
            i
        ];
        else if (_character === '"') {
            var block = getBlock(string, '"', startIndex + i + 1);
            substring += block[0];
            i += 1 + block[1] + 1;
        } else {
            substring += _character;
            i++;
        }
    }
    return [
        substring,
        i
    ];
}
function parseArray(string) {
    var blocks = [];
    var index = 0;
    while(index < string.length){
        var _getBlock = getBlock(string, ",", index), _getBlock2 = _slicedToArray(_getBlock, 2), substring = _getBlock2[0], length = _getBlock2[1];
        index += length + 1;
        blocks.push(substring.trim());
    }
    return blocks;
}
// https://stackoverflow.com/questions/17428587/transposing-a-2d-array-in-javascript
var transpose = function transpose(array) {
    return array[0].map(function(_, i) {
        return array.map(function(row) {
            return row[i];
        });
    });
};
function validateSchema(schema) {
    for(var _i3 = 0, _Object$keys2 = Object.keys(schema); _i3 < _Object$keys2.length; _i3++){
        var key = _Object$keys2[_i3];
        var entry = schema[key];
        if (!entry.prop) throw new Error('"prop" not defined for schema entry "'.concat(key, '".'));
    }
}

},{"../../types/Number.js":"bTxGb","../../types/String.js":"d1HEr","../../types/Boolean.js":"l7WEa","../../types/Date.js":"6JbA1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bTxGb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NumberType);
var _invalidErrorJs = require("./InvalidError.js");
var _invalidErrorJsDefault = parcelHelpers.interopDefault(_invalidErrorJs);
function NumberType(value) {
    // An XLSX file editing software might not always correctly
    // detect numeric values in string-type cells. Users won't bother
    // manually selecting a cell type, so the editing software has to guess
    // based on the user's input. One can assume that such auto-detection
    // might not always work.
    //
    // So, if a cell is supposed to be a numeric one, convert a string value to a number.
    //
    if (typeof value === "string") {
        var stringifiedValue = value;
        value = Number(value);
        if (String(value) !== stringifiedValue) throw new (0, _invalidErrorJsDefault.default)("not_a_number");
    }
    if (typeof value !== "number") throw new (0, _invalidErrorJsDefault.default)("not_a_number");
    if (isNaN(value)) throw new (0, _invalidErrorJsDefault.default)("invalid_number");
     // At this point, `value` can only be a number.
    //
    // The global `isFinite()` function filters out:
    // * NaN
    // * -Infinity
    // * Infinity
    //
    // All other values pass (including non-numbers).
    //
    if (!isFinite(value)) throw new (0, _invalidErrorJsDefault.default)("out_of_bounds");
    return value;
}

},{"./InvalidError.js":"4CrM2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4CrM2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InvalidError);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var InvalidError = /*#__PURE__*/ function(_Error) {
    _inherits(InvalidError, _Error);
    var _super = _createSuper(InvalidError);
    function InvalidError(reason) {
        var _this;
        _classCallCheck(this, InvalidError);
        _this = _super.call(this, "invalid");
        _this.reason = reason;
        return _this;
    }
    return _createClass(InvalidError);
}(/*#__PURE__*/ _wrapNativeSuper(Error));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d1HEr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StringType);
var _invalidErrorJs = require("./InvalidError.js");
var _invalidErrorJsDefault = parcelHelpers.interopDefault(_invalidErrorJs);
function StringType(value) {
    if (typeof value === "string") return value;
     // Excel tends to perform a forced automatic convertion of string-type values
    // to number-type ones when the user has input them. Otherwise, users wouldn't
    // be able to perform formula calculations on those cell values because users
    // won't bother manually choosing a "numeric" cell type for each cell, and
    // even if they did, choosing a "numeric" cell type every time wouldn't be an
    // acceptable "user experience".
    //
    // So, if a cell value is supposed to be a string and Excel has automatically
    // converted it to a number, perform a backwards conversion.
    //
    if (typeof value === "number") {
        if (isNaN(value)) throw new (0, _invalidErrorJsDefault.default)("invalid_number");
         // The global `isFinite()` function filters out:
        // * NaN
        // * -Infinity
        // * Infinity
        //
        // All other values pass (including non-numbers).
        //
        if (!isFinite(value)) throw new (0, _invalidErrorJsDefault.default)("out_of_bounds");
        return String(value);
    }
    throw new (0, _invalidErrorJsDefault.default)("not_a_string");
}

},{"./InvalidError.js":"4CrM2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"l7WEa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BooleanType);
var _invalidErrorJs = require("./InvalidError.js");
var _invalidErrorJsDefault = parcelHelpers.interopDefault(_invalidErrorJs);
function BooleanType(value) {
    if (typeof value === "boolean") return value;
    throw new (0, _invalidErrorJsDefault.default)("not_a_boolean");
}

},{"./InvalidError.js":"4CrM2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6JbA1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateType);
var _parseDateJs = require("../read/parseDate.js");
var _parseDateJsDefault = parcelHelpers.interopDefault(_parseDateJs);
var _invalidErrorJs = require("./InvalidError.js");
var _invalidErrorJsDefault = parcelHelpers.interopDefault(_invalidErrorJs);
function DateType(value, _ref) {
    var properties = _ref.properties;
    // XLSX has no specific format for dates.
    // Sometimes a date can be heuristically detected.
    // https://github.com/catamphetamine/read-excel-file/issues/3#issuecomment-395770777
    if (value instanceof Date) {
        if (isNaN(value.valueOf())) throw new (0, _invalidErrorJsDefault.default)("out_of_bounds");
        return value;
    }
    if (typeof value === "number") {
        if (isNaN(value)) throw new (0, _invalidErrorJsDefault.default)("invalid_number");
        if (!isFinite(value)) throw new (0, _invalidErrorJsDefault.default)("out_of_bounds");
        var date = (0, _parseDateJsDefault.default)(value, properties);
        if (isNaN(date.valueOf())) throw new (0, _invalidErrorJsDefault.default)("out_of_bounds");
        return date;
    }
    throw new (0, _invalidErrorJsDefault.default)("not_a_date");
}

},{"../read/parseDate.js":"d5mUp","./InvalidError.js":"4CrM2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iX6rt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>convertMapToSchema);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function convertMapToSchema(map) {
    var schema = {};
    for(var _i = 0, _Object$keys = Object.keys(map); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        var prop = map[key];
        var type = void 0;
        if (_typeof(prop) === "object") {
            prop = Object.keys(map[key])[0];
            type = convertMapToSchema(map[key][prop]);
        }
        schema[key] = {
            prop: prop
        };
        if (type) schema[key].type = type;
    }
    return schema;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ejwRn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertRowToImportRowData", ()=>convertRowToImportRowData);
parcelHelpers.export(exports, "getImportRowValue", ()=>getImportRowValue);
parcelHelpers.export(exports, "getImportRowOrgId", ()=>getImportRowOrgId);
parcelHelpers.export(exports, "isValidColumnsNames", ()=>isValidColumnsNames);
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _util = require("../../utils/util");
const convertRowToImportRowData = (row)=>({
        id: (0, _util.uniqueId)("import-row-data"),
        record: row.map((cell)=>String(cell)).filter(Boolean),
        status: "INITIAL"
    });
const getImportRowValue = (row, dataIndex)=>dataIndex > -1 && dataIndex < row.record.length ? row.record[dataIndex] : undefined;
const getImportRowOrgId = (row, orgIdRecordIndex)=>(0, _onboardingHelpers.stripOrgId)(getImportRowValue(row, orgIdRecordIndex) || "");
const isValidColumnsNames = (columnsNames, requiredColumns)=>requiredColumns.every((columnName)=>columnsNames.includes(columnName) && columnsNames.indexOf(columnName) === columnsNames.lastIndexOf(columnName));

},{"../../helpers/onboarding.helpers":"fMYah","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bQVZ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _importCustomersProgress = require("./ImportCustomersProgress");
var _importCustomersProgressDefault = parcelHelpers.interopDefault(_importCustomersProgress);
const ImportCustomersFooter = (props)=>{
    const { customerType, disableImport, actionItemsCount, onReset, onImport } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const mutationsCount = (0, _reactQuery.useIsMutating)();
    const loading = actionItemsCount > 0 && mutationsCount > 0;
    const importButtonLabel = customerType === "company" ? f("import-customers.wizard.labels.import-companies.button") : f("import-customers.wizard.labels.import-people.button");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        distribution: "trailing",
        alignment: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                fill: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersProgressDefault.default), {
                    actionItemsCount: actionItemsCount
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                onClick: onReset,
                children: f("default.reset")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                onClick: onImport,
                primary: true,
                disabled: disableImport,
                loading: loading,
                children: importButtonLabel
            })
        ]
    });
};
exports.default = ImportCustomersFooter;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../hooks/useFormatMessage":"8Y8fq","./ImportCustomersProgress":"4XPcW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4XPcW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ImportCustomersProgress = (props)=>{
    const { actionItemsCount } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const mutationsCount = (0, _reactQuery.useIsMutating)();
    const progress = actionItemsCount === 0 ? 0 : Math.ceil((actionItemsCount - mutationsCount) / actionItemsCount * 100);
    const label = progress === 100 ? f("import-customers.wizard.labels.finished") : f("import-customers.wizard.labels.importing", {
        count: actionItemsCount - mutationsCount,
        total: actionItemsCount
    });
    if (progress === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "bodyMd",
                as: "span",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ProgressBar), {
                progress: progress,
                animated: true
            })
        ]
    });
};
exports.default = ImportCustomersProgress;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"euqDw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _checkmarkGreenSvg = require("../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _icon = require("../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _importCustomersFilters = require("./ImportCustomersFilters");
var _importCustomersFiltersDefault = parcelHelpers.interopDefault(_importCustomersFilters);
const ImportCustomersHeader = (props)=>{
    const { useFirstRowAsHeaders, setUseFirstRowAsHeaders, totalCount, visibleRowsCount, selectedRowsCount, errorsCount, importedCount, ...filtersProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const headerLabel = `${f("default.preview")}${totalCount > 0 ? ` - ${formatNumber(totalCount)} rows` : ""}`;
    const isAllSelected = visibleRowsCount === selectedRowsCount;
    const selectedLabel = isAllSelected ? f("customers.list.header.customers.count.all", {
        count: visibleRowsCount
    }) : f("customers.list.header.customers.count", {
        count: visibleRowsCount,
        selected: selectedRowsCount
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "headingLg",
                as: "p",
                children: headerLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                spacing: "tight",
                children: [
                    totalCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: selectedLabel
                    }),
                    errorsCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                        as: "span",
                        color: "critical",
                        children: [
                            formatNumber(errorsCount),
                            " errors"
                        ]
                    }),
                    importedCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: (0, _checkmarkGreenSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                as: "span",
                                children: [
                                    formatNumber(importedCount),
                                    " imported successfully"
                                ]
                            })
                        ]
                    })
                ]
            }),
            totalCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomersFiltersDefault.default), {
                ...filtersProps
            }),
            totalCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                label: f("import-customers.wizard.labels.first-row-contains-headers"),
                checked: useFirstRowAsHeaders,
                onChange: setUseFirstRowAsHeaders
            })
        ]
    });
};
exports.default = ImportCustomersHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","../../../assets/icons/checkmark-green.svg":"8HW5l","../../components/extensions/Icon":"eHSf0","../../hooks/useFormatMessage":"8Y8fq","./ImportCustomersFilters":"jSBXV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jSBXV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _searchTextField = require("../../components/SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _durations = require("../../constants/durations");
var _importCustomers = require("../../constants/import-customers");
var _useDebouncedState = require("../../hooks/useDebouncedState");
var _useDebouncedStateDefault = parcelHelpers.interopDefault(_useDebouncedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ImportCustomersFilters = (props)=>{
    const { statuses, onStatusesChanges, onFilterQueryChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [queryText, setQueryText] = (0, _useDebouncedStateDefault.default)("", (0, _durations.QUERY_SEARCH_DEBOUNCE_DELAY));
    (0, _react.useEffect)(()=>onFilterQueryChange(queryText), [
        queryText
    ]);
    const clearQueryText = (0, _react.useCallback)(()=>setQueryText(""), []);
    const toggleErrors = ()=>onStatusesChanges(statuses.length === 0 ? (0, _importCustomers.ERROR_STATUSES) : []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
        gap: statuses.length === 0 ? "0" : "2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
            distribution: "leading",
            alignment: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                    value: queryText,
                    onChange: setQueryText,
                    labelHidden: true,
                    placeholder: f("default.search"),
                    clearButton: true,
                    onClearButtonClick: clearQueryText
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                    label: "Show errors",
                    checked: statuses.length > 0,
                    onChange: toggleErrors
                })
            ]
        })
    });
};
exports.default = ImportCustomersFilters;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../components/SearchTextField/SearchTextField":"k5bRy","../../constants/durations":"5sjIW","../../constants/import-customers":"MoQPY","../../hooks/useDebouncedState":"lKEJK","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dqpf3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _kdkbanner = require("../../components/KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ImportCustomersInstructionsBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        status: "info",
        hideIcon: true,
        title: f("import-customers.wizard.page.welcome.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: f("import-customers.wizard.page.welcome.description")
        })
    });
};
exports.default = ImportCustomersInstructionsBanner;

},{"react/jsx-runtime":"enbMA","../../components/KDKBanner/KDKBanner":"3zPW6","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bCSVL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _plainSelect = require("../../components/PlainSelect/PlainSelect");
var _plainSelectDefault = parcelHelpers.interopDefault(_plainSelect);
var _importCustomers = require("../../constants/import-customers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ImportCustomersPagination = (props)=>{
    const { table } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const start = table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1;
    const end = Math.min((table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize, table.getFilteredRowModel().rows.length);
    const count = table.getFilteredRowModel().rows.length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _plainSelectDefault.default), {
                label: f("component.pagination.labels.select-limit", {
                    limit: table.getState().pagination.pageSize
                }),
                labelInline: true,
                options: (0, _importCustomers.PAGE_SIZES),
                onChange: (limitValue)=>table.setPageSize(parseInt(limitValue, 10)),
                value: table.getState().pagination.pageSize + ""
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                removeUnderline: true,
                onClick: ()=>table.setPageIndex(0),
                children: f("component.pagination.labels.showing", {
                    start,
                    end,
                    count
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                onClick: table.previousPage,
                disabled: !table.getCanPreviousPage(),
                children: f("default.previous")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                onClick: table.nextPage,
                disabled: !table.getCanNextPage(),
                children: f("default.next")
            })
        ]
    });
};
exports.default = ImportCustomersPagination;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../components/extensions/Button":"8exc0","../../components/PlainSelect/PlainSelect":"4Y0fH","../../constants/import-customers":"MoQPY","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6kmsz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _kdkbanner = require("../../components/KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ImportCustomersValidationBanner = (props)=>{
    const { columnsNames, validationColumns } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const missingRequiredColumns = validationColumns.filter((columnName)=>!columnsNames.includes(columnName));
    const multipleRequiredColumns = validationColumns.filter((columnName)=>columnsNames.includes(columnName) && columnsNames.indexOf(columnName) !== columnsNames.lastIndexOf(columnName));
    const hasErrors = missingRequiredColumns.length > 0 || multipleRequiredColumns.length > 0;
    if (!hasErrors) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _kdkbannerDefault.default), {
        status: "warning",
        hideIcon: true,
        children: [
            missingRequiredColumns.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: f("import-customers.wizard.warning.missing-columns", {
                    count: missingRequiredColumns.length,
                    names: missingRequiredColumns.join(", ")
                })
            }),
            multipleRequiredColumns.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: f("import-customers.wizard.warning.multiple-columns", {
                    count: multipleRequiredColumns.length,
                    names: multipleRequiredColumns.join(", ")
                })
            })
        ]
    });
};
exports.default = /*#__PURE__*/ (0, _react.memo)(ImportCustomersValidationBanner);

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../components/KDKBanner/KDKBanner":"3zPW6","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ade0C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _importCustomers = require("../../constants/import-customers");
var _useErrorParser = require("../../hooks/useErrorParser");
var _useErrorParserDefault = parcelHelpers.interopDefault(_useErrorParser);
var _util = require("../../utils/util");
var _importCustomersPageHelpers = require("./ImportCustomersPage.helpers");
var _useGetDefaultImportColumnsNames = require("./useGetDefaultImportColumnsNames");
var _useGetDefaultImportColumnsNamesDefault = parcelHelpers.interopDefault(_useGetDefaultImportColumnsNames);
var _useImportCompanies = require("./useImportCompanies");
var _useImportCompaniesDefault = parcelHelpers.interopDefault(_useImportCompanies);
const useImportCustomersPage = (customerType)=>{
    const mutationsCount = (0, _reactQuery.useIsMutating)();
    const { defaultColumns, validationColumns } = (0, _useGetDefaultImportColumnsNamesDefault.default)(customerType);
    const [rowsMap, setRowsMap] = (0, _react.useState)({});
    const [useFirstRowAsHeaders, setUseFirstRowAsHeaders] = (0, _react.useState)(false);
    const [filename, setFilename] = (0, _react.useState)("");
    const [columnsNames, setColumnNames] = (0, _react.useState)([
        ...defaultColumns
    ]);
    const [rowSelection, setRowSelection] = (0, _react.useState)({});
    const rows = (0, _react.useMemo)(()=>Object.values(rowsMap).slice(useFirstRowAsHeaders ? 1 : 0), [
        rowsMap,
        useFirstRowAsHeaders
    ]);
    const headers = (0, _react.useMemo)(()=>useFirstRowAsHeaders ? Object.values(rowsMap)[0].record : [], [
        rows,
        rowsMap.length
    ]);
    // TODO use different hook for importing people if customerType === "person"
    const { validateRows, importRow } = (0, _useImportCompaniesDefault.default)(columnsNames);
    const [actionItemsCount, setActionItemsCount] = (0, _react.useState)(0);
    const parseError = (0, _useErrorParserDefault.default)(customerType);
    const [searchText, setSearchText] = (0, _react.useState)("");
    const [statuses, setStatuses] = (0, _react.useState)([]);
    const updateRow = (row, selected)=>{
        setRowsMap((prevState)=>({
                ...prevState,
                [row.id]: row
            }));
        if (!(0, _util.isNil)(selected)) setRowSelection((prevState)=>{
            if (selected) return {
                ...prevState,
                [row.id]: true
            };
            const result = {
                ...prevState
            };
            delete result[row.id];
            return result;
        });
    };
    const handleFileRead = (rows, filename, columnsCount)=>{
        reset();
        const importedRowsMap = {};
        validateRows(rows, columnsNames, (row)=>importedRowsMap[row.id] = row);
        setRowsMap(importedRowsMap);
        // do not auto select rows that failed validation
        // the code is using for each instead of filter in order to improve performance for large files
        const selection = {};
        Object.values(importedRowsMap).forEach((row)=>{
            if (row.status === "READY_FOR_IMPORT") selection[row.id] = true;
        });
        setRowSelection(selection);
        setFilename(filename);
        const ignoreColumnCount = Math.max(0, columnsCount - defaultColumns.length);
        // fill the columns names array with columns for all the found cells in the file
        setColumnNames((prevState)=>[
                ...prevState,
                ...Array(ignoreColumnCount).fill((0, _importCustomers.IGNORE_COLUMN))
            ]);
    };
    const clearSelection = (row)=>setRowSelection((prevState)=>delete prevState[row.id] ? prevState : prevState);
    const handleSetColumnNames = (0, _react.useCallback)((updatedColumnNames)=>{
        setColumnNames(updatedColumnNames);
        // previous columns were invalid and updated columns are valid
        const previousColumnsStateChanged = !(0, _importCustomersPageHelpers.isValidColumnsNames)(columnsNames, validationColumns) && (0, _importCustomersPageHelpers.isValidColumnsNames)(updatedColumnNames, validationColumns);
        const validationColumnsChanged = validationColumns.some((columnName)=>columnsNames.indexOf(columnName) !== updatedColumnNames.indexOf(columnName));
        // if validation columns have changed or previous columns were invalid (but now they are valid) -
        // re-run rows validation
        const shouldValidateRows = validationColumnsChanged || previousColumnsStateChanged;
        if (shouldValidateRows) validateRows(rows, updatedColumnNames, (row, hasError)=>updateRow(row, !hasError));
    }, [
        rowsMap,
        columnsNames.join("-"),
        validationColumns.join("-")
    ]);
    // Import customers mutation
    const importRowMutation = (0, _reactQuery.useMutation)(importRow, {
        onMutate: (row)=>updateRow({
                ...row,
                status: "IMPORTING"
            }),
        onSettled: (response, error, row)=>clearSelection(row),
        onSuccess: (response, row)=>updateRow({
                ...row,
                status: "IMPORTED"
            }, false),
        onError: (error, row)=>{
            // error status 409 means company already exists
            const { generalError, fieldsErrorsMap } = parseError(error);
            updateRow({
                ...row,
                status: "IMPORT_ERROR",
                errorMessage: generalError || [
                    ...fieldsErrorsMap.values()
                ].join(", ")
            });
        }
    });
    const importRows = (0, _react.useCallback)(()=>{
        let count = 0;
        Object.keys(rowSelection).forEach((rowId)=>{
            const row = rowsMap[rowId];
            if (rowSelection[rowId] && row.status === "READY_FOR_IMPORT") {
                count++;
                importRowMutation.mutate(rowsMap[rowId]);
            }
        });
        setActionItemsCount(count);
    }, [
        rowsMap,
        rowSelection
    ]);
    const reset = (0, _react.useCallback)(()=>{
        setRowsMap({});
        setFilename("");
        setRowSelection({});
        setColumnNames([
            ...defaultColumns
        ]);
        setUseFirstRowAsHeaders(false);
        setSearchText("");
        setStatuses([]);
        setActionItemsCount(0);
    }, []);
    const importedCount = (0, _react.useMemo)(()=>actionItemsCount > 0 && mutationsCount === 0 ? rows.filter((row)=>row.status === "IMPORTED").length : 0, [
        rows,
        actionItemsCount,
        mutationsCount
    ]);
    return {
        rows,
        columnsNames,
        headers,
        rowSelection,
        filters: {
            searchText,
            statuses
        },
        filename,
        actionItemsCount,
        validationColumns,
        importedCount,
        useFirstRowAsHeaders,
        setUseFirstRowAsHeaders,
        handleFileRead,
        setRowSelection,
        setColumnNames: handleSetColumnNames,
        setStatuses,
        setSearchText,
        importRows,
        reset
    };
};
exports.default = useImportCustomersPage;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../../constants/import-customers":"MoQPY","../../hooks/useErrorParser":"daNOL","../../utils/util":"4MniK","./ImportCustomersPage.helpers":"ejwRn","./useGetDefaultImportColumnsNames":"g2Dgx","./useImportCompanies":"4TIZo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g2Dgx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _importCustomers = require("../../constants/import-customers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
const useGetDefaultImportColumnsNames = (customerType)=>{
    const features = (0, _useFeaturesDefault.default)();
    // TODO add different columns for person customer type
    const defaultColumns = customerType === "company" ? [
        (0, _importCustomers.ORG_ID_COLUMN),
        (0, _importCustomers.NAME_COLUMN)
    ] : [];
    const validationColumns = customerType === "company" ? [
        (0, _importCustomers.ORG_ID_COLUMN)
    ] : [];
    if (features.EXTERNAL_ID) defaultColumns.push((0, _importCustomers.EXTERNAL_ID_COLUMN));
    if (features.RESPONSIBLE_USER) {
        defaultColumns.push((0, _importCustomers.RESPONSIBLE_USER_EMAIL_COLUMN));
        validationColumns.push((0, _importCustomers.RESPONSIBLE_USER_EMAIL_COLUMN));
    }
    return {
        defaultColumns,
        validationColumns
    };
};
exports.default = useGetDefaultImportColumnsNames;

},{"../../constants/import-customers":"MoQPY","../../hooks/useFeatures":"hvBWb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4TIZo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _companyDetails = require("../../constants/company-details");
var _countries = require("../../constants/countries");
var _importCustomers = require("../../constants/import-customers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetOnboardingWarnings = require("../../hooks/useGetOnboardingWarnings");
var _useGetOnboardingWarningsDefault = parcelHelpers.interopDefault(_useGetOnboardingWarnings);
var _useGetUsers = require("../../hooks/useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
var _importCustomersPageHelpers = require("./ImportCustomersPage.helpers");
const getRecordIndices = (columnsNames)=>({
        orgIdIndex: columnsNames.indexOf((0, _importCustomers.ORG_ID_COLUMN)),
        nameIndex: columnsNames.indexOf((0, _importCustomers.NAME_COLUMN)),
        externalIdIndex: columnsNames.indexOf((0, _importCustomers.EXTERNAL_ID_COLUMN)),
        responsibleUserEmailIndex: columnsNames.indexOf((0, _importCustomers.RESPONSIBLE_USER_EMAIL_COLUMN))
    });
const useImportCompanies = (columnNames)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const { activeUsers } = (0, _useGetUsersDefault.default)();
    const usersEmails = (0, _react.useMemo)(()=>new Set(activeUsers.map((user)=>user.email.toLowerCase())), [
        activeUsers.length
    ]);
    // the indices to read properties from a row record
    const recordIndices = (0, _react.useMemo)(()=>getRecordIndices(columnNames), [
        columnNames.join("-")
    ]);
    const getOnboardingWarnings = (0, _useGetOnboardingWarningsDefault.default)();
    const getDataRowIdentifier = (row)=>(0, _importCustomersPageHelpers.getImportRowOrgId)(row, recordIndices.orgIdIndex);
    const validateRow = (row, existingIds, updatedRecordIndices)=>{
        const orgId = (0, _importCustomersPageHelpers.getImportRowOrgId)(row, updatedRecordIndices.orgIdIndex);
        if (!(0, _companyDetails.NORWEGIAN_COMPANY_NATIONAL_ID_REGEX).test(orgId + "")) return f("import-customers.wizard.validation-error.invalid-org-id");
        if (existingIds.has(orgId)) return f("import-customers.wizard.validation-error.duplicate-org-id");
        if (updatedRecordIndices.responsibleUserEmailIndex > -1) {
            const email = (0, _importCustomersPageHelpers.getImportRowValue)(row, updatedRecordIndices.responsibleUserEmailIndex);
            if (!email || !usersEmails.has(email.toLowerCase())) return f("import-customers.wizard.validation-error.responsible-user-not-found");
        }
        return undefined;
    };
    const validateRows = (rows, updatedColumnNames = columnNames, callback)=>{
        const rowsUniqueIdSet = new Set();
        const updatedRecordIndices = getRecordIndices(updatedColumnNames);
        rows.forEach((row)=>{
            const validationMessage = validateRow(row, rowsUniqueIdSet, updatedRecordIndices);
            if (validationMessage) callback({
                ...row,
                status: "VALIDATION_ERROR",
                errorMessage: validationMessage
            }, true);
            else callback({
                ...row,
                status: "READY_FOR_IMPORT",
                errorMessage: undefined
            }, false);
            rowsUniqueIdSet.add(getDataRowIdentifier(row));
        });
    };
    const importRow = async (row)=>{
        const lookupInfo = await (0, _apiDefault.default).getCompanyInfo("NO", (0, _importCustomersPageHelpers.getImportRowOrgId)(row, recordIndices.orgIdIndex));
        const warnings = getOnboardingWarnings(lookupInfo.basic_legal_entity_info);
        if (warnings.length > 0) return Promise.reject(warnings[0]);
        else return (0, _apiDefault.default).createCompanyCustomer({
            country: (0, _countries.DEFAULT_COUNTRY),
            name: (0, _importCustomersPageHelpers.getImportRowValue)(row, recordIndices.nameIndex),
            national_id: (0, _importCustomersPageHelpers.getImportRowOrgId)(row, recordIndices.orgIdIndex) + "",
            external_id: (0, _importCustomersPageHelpers.getImportRowValue)(row, recordIndices.externalIdIndex),
            responsible_user_email: (0, _importCustomersPageHelpers.getImportRowValue)(row, recordIndices.responsibleUserEmailIndex)
        });
    };
    return {
        validateRows,
        importRow
    };
};
exports.default = useImportCompanies;

},{"react":"cOWTg","../../api":"f6lXD","../../constants/company-details":"2I1G6","../../constants/countries":"2hBLK","../../constants/import-customers":"MoQPY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetOnboardingWarnings":"hAu55","../../hooks/useGetUsers":"c83Pg","./ImportCustomersPage.helpers":"ejwRn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hAu55":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stringUtils = require("../utils/stringUtils");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useGetOnboardingWarnings = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const getOnboardingWarnings = (lookupInfo)=>{
        const warnings = [];
        if (lookupInfo.is_bankrupt) warnings.push(f("lookup.error.company.bankrupt"));
        if (lookupInfo.under_forced_liquidation_or_dissolution) warnings.push(f("lookup.error.company.under-forced-liquidation"));
        if (!(0, _stringUtils.isEmptyString)(lookupInfo.closure_date)) warnings.push(f("lookup.error.company.closed"));
        return warnings;
    };
    return getOnboardingWarnings;
};
exports.default = useGetOnboardingWarnings;

},{"../utils/stringUtils":"4gVdA","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dYTFI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactTable = require("@tanstack/react-table");
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _condensedText = require("../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _importCustomerStatus = require("../../components/ImportCustomersTable/ImportCustomerStatus");
var _importCustomerStatusDefault = parcelHelpers.interopDefault(_importCustomerStatus);
var _textHighlighter = require("../../components/TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
var _tooltipWrapper = require("../../components/TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _importCustomers = require("../../constants/import-customers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _columnNameSelect = require("./ColumnNameSelect");
var _columnNameSelectDefault = parcelHelpers.interopDefault(_columnNameSelect);
const useImportCustomersTable = (props)=>{
    const { rows, columnsNames, customerType, headers, filters, rowSelection, onSelectionChange, onColumnChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const columns = (0, _react.useMemo)(()=>{
        const searchWords = filters.searchText.split(" ");
        const updateColumn = (index, name)=>{
            const columns = [
                ...columnsNames
            ];
            columns[index] = name;
            onColumnChange(columns);
        };
        return [
            {
                id: "select",
                enablePinning: true,
                enableGlobalFilter: false,
                header: ({ table })=>{
                    const checkedState = table.getIsSomeRowsSelected() ? "indeterminate" : table.getIsAllRowsSelected();
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                        labelHidden: true,
                        label: "",
                        checked: checkedState,
                        onChange: table.toggleAllRowsSelected
                    });
                },
                cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                        labelHidden: true,
                        label: "",
                        checked: row.getIsSelected(),
                        onChange: row.getToggleSelectedHandler()
                    })
            },
            {
                accessorKey: "status",
                header: f("table.column.status"),
                enableGlobalFilter: false,
                enablePinning: true,
                filterFn: "arrIncludesSome",
                cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importCustomerStatusDefault.default), {
                        importRowData: props.row.original
                    })
            },
            ...columnsNames.map((columnName, index)=>({
                    accessorFn: (row)=>row.record[index],
                    id: "column_" + index,
                    enableGlobalFilter: columnName !== (0, _importCustomers.IGNORE_COLUMN),
                    enablePinning: true,
                    header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "1",
                            wrap: false,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnNameSelectDefault.default), {
                                            columnName: columnName,
                                            customerType: customerType,
                                            onChange: (name)=>updateColumn(index, name)
                                        }),
                                        !(0, _stringUtils.isEmptyString)(headers[index]) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                            children: headers[index].toUpperCase()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                                    content: f("import-customers.wizard.table.hide-column-button.tooltip"),
                                    preferredPosition: "above",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        plain: true,
                                        removeUnderline: true,
                                        destructive: true,
                                        hoverable: true,
                                        icon: (0, _trashSvgDefault.default),
                                        onClick: ()=>{
                                            column.toggleVisibility(false);
                                            // mark column as ignored so it will not be included in row validation
                                            updateColumn(index, (0, _importCustomers.IGNORE_COLUMN));
                                        }
                                    })
                                })
                            ]
                        }),
                    cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                            searchWords: searchWords,
                            textToHighlight: props.row.original.record[index] || ""
                        })
                })),
            {
                accessorKey: "nameFromSearch",
                header: f("table.column.name-from-search"),
                enablePinning: true,
                cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                        searchWords: searchWords,
                        textToHighlight: props.getValue() || ""
                    })
            }
        ];
    }, [
        filters.searchText,
        columnsNames.join("-"),
        headers.join("-")
    ]);
    const table = (0, _reactTable.useReactTable)({
        columns,
        data: rows,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        getFilteredRowModel: (0, _reactTable.getFilteredRowModel)(),
        getPaginationRowModel: (0, _reactTable.getPaginationRowModel)(),
        autoResetPageIndex: true,
        state: {
            rowSelection,
            globalFilter: filters.searchText
        },
        initialState: {
            pagination: {
                pageSize: (0, _importCustomers.DEFAULT_PAGE_SIZE)
            }
        },
        getRowId: (row)=>row.id,
        onRowSelectionChange: onSelectionChange
    });
    (0, _react.useEffect)(()=>{
        if (filters.statuses.length > 0) table.getColumn("status")?.setFilterValue(filters.statuses);
        else table.getColumn("status")?.setFilterValue(undefined);
    }, [
        table,
        filters.statuses.join("-")
    ]);
    (0, _react.useEffect)(()=>{
        table.getAllColumns().forEach((colum)=>{
            if (colum.id.startsWith((0, _importCustomers.IGNORE_COLUMN))) colum.pin(false);
            else if (colum.id === "nameFromSearch") colum.pin("right");
            else colum.pin("left");
        });
    }, [
        table,
        columnsNames.join("-")
    ]);
    return table;
};
exports.default = useImportCustomersTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-table":"86D8M","../../../assets/icons/trash.svg":"jqW55","../../components/CondensedText/CondensedText":"1FshD","../../components/extensions/Button":"8exc0","../../components/ImportCustomersTable/ImportCustomerStatus":"jrPzv","../../components/TextHighlighter/TextHighlighter":"43Xhz","../../components/TooltipWrapper/TooltipWrapper":"b5W2d","../../constants/import-customers":"MoQPY","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","./ColumnNameSelect":"jW7L2","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jrPzv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _importCustomersHelpers = require("../../helpers/import-customers.helpers");
var _useGetImportCustomerStatusLabelAndIcon = require("../../hooks/useGetImportCustomerStatusLabelAndIcon");
var _useGetImportCustomerStatusLabelAndIconDefault = parcelHelpers.interopDefault(_useGetImportCustomerStatusLabelAndIcon);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const ImportCustomerStatus = (props)=>{
    const { importRowData } = props;
    const getStatusLabelAndIcon = (0, _useGetImportCustomerStatusLabelAndIconDefault.default)();
    const { icon, label } = getStatusLabelAndIcon(importRowData.status);
    const animate = (0, _importCustomersHelpers.isLoading)(importRowData);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        blockAlign: "center",
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SpinningIcon, {
                source: icon,
                animate: animate,
                height: "20px",
                width: "20px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: label
                    }),
                    importRowData.errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: "critical",
                        children: importRowData.errorMessage
                    })
                ]
            })
        ]
    });
};
const rotate = (0, _styledComponents.keyframes)`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const SpinningIcon = (0, _styledComponentsDefault.default)((0, _iconDefault.default))`
  &:before {
    animation: ${rotate} var(--p-linear) 1.5s none;
    animation-iteration-count: ${({ animate })=>animate ? "infinite" : 0};
  }
`;
exports.default = /*#__PURE__*/ (0, _react.memo)(ImportCustomerStatus);

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/import-customers.helpers":"j5UDq","../../hooks/useGetImportCustomerStatusLabelAndIcon":"oA4Ct","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"oA4Ct":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _checkmarkGreenSvg = require("../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _circleCrossSvg = require("../../assets/icons/circle-cross.svg");
var _circleCrossSvgDefault = parcelHelpers.interopDefault(_circleCrossSvg);
var _fileSvg = require("../../assets/icons/file.svg");
var _fileSvgDefault = parcelHelpers.interopDefault(_fileSvg);
var _screeningInactiveSvg = require("../../assets/icons/screening_inactive.svg");
var _screeningInactiveSvgDefault = parcelHelpers.interopDefault(_screeningInactiveSvg);
var _triangleFilledExclamationSvg = require("../../assets/icons/triangle-filled-exclamation.svg");
var _triangleFilledExclamationSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationSvg);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const StatusIcons = {
    INITIAL: (0, _fileSvgDefault.default),
    VALIDATION_ERROR: (0, _triangleFilledExclamationSvgDefault.default),
    READY_FOR_IMPORT: (0, _screeningInactiveSvgDefault.default),
    IMPORTING: (0, _screeningInactiveSvgDefault.default),
    IMPORTED: (0, _checkmarkGreenSvgDefault.default),
    IMPORT_ERROR: (0, _circleCrossSvgDefault.default)
};
const useGetImportCustomerStatusLabelAndIcon = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const getStatusLabelAndIcon = (0, _react.useCallback)((status)=>{
        const label = f(`import-customers.wizard.status.${status}`);
        const icon = StatusIcons[status];
        return {
            label,
            icon
        };
    }, []);
    return getStatusLabelAndIcon;
};
exports.default = useGetImportCustomerStatusLabelAndIcon;

},{"react":"cOWTg","../../assets/icons/checkmark-green.svg":"8HW5l","../../assets/icons/circle-cross.svg":"daUCT","../../assets/icons/file.svg":"bLqMZ","../../assets/icons/screening_inactive.svg":"gWCr8","../../assets/icons/triangle-filled-exclamation.svg":"4pLP6","./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jW7L2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _importCustomers = require("../../constants/import-customers");
var _useGetColumnLabel = require("./useGetColumnLabel");
var _useGetColumnLabelDefault = parcelHelpers.interopDefault(_useGetColumnLabel);
var _useGetDefaultImportColumnsNames = require("./useGetDefaultImportColumnsNames");
var _useGetDefaultImportColumnsNamesDefault = parcelHelpers.interopDefault(_useGetDefaultImportColumnsNames);
const ColumnNameSelect = (props)=>{
    const { columnName, customerType, onChange } = props;
    const { defaultColumns } = (0, _useGetDefaultImportColumnsNamesDefault.default)(customerType);
    const getColumnLabel = (0, _useGetColumnLabelDefault.default)();
    const OPTIONS = (0, _react.useMemo)(()=>[
            ...defaultColumns,
            (0, _importCustomers.IGNORE_COLUMN)
        ].map((name)=>({
                value: name,
                label: getColumnLabel(name)
            })), [
        defaultColumns
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Select), {
        label: columnName,
        labelHidden: true,
        value: columnName,
        options: OPTIONS,
        onChange: onChange
    });
};
exports.default = ColumnNameSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/import-customers":"MoQPY","./useGetColumnLabel":"6hIRj","./useGetDefaultImportColumnsNames":"g2Dgx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6hIRj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _importCustomers = require("../../constants/import-customers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useGetColumnLabel = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const ColumnTranslation = (0, _react.useMemo)(()=>({
            [(0, _importCustomers.ORG_ID_COLUMN)]: f("company.details.caption.national_id"),
            [(0, _importCustomers.NAME_COLUMN)]: f("table.column.name"),
            [(0, _importCustomers.RESPONSIBLE_USER_EMAIL_COLUMN)]: f("table.column.responsible-user"),
            [(0, _importCustomers.EXTERNAL_ID_COLUMN)]: f("customers.list.column.external-id"),
            [(0, _importCustomers.IGNORE_COLUMN)]: f("table.column.ignore")
        }), []);
    const getColumnLabel = (columnName)=>ColumnTranslation[columnName];
    return getColumnLabel;
};
exports.default = useGetColumnLabel;

},{"react":"cOWTg","../../constants/import-customers":"MoQPY","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Tij7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
var _sessionState = require("../../constants/session-state");
const LogoutRedirect = ()=>{
    // check if a value was set in BeaufortAuthProvider.authenticateBeaufortUser (AuthProvider.tsx)
    // before logging the user out due to invalid token
    const redirectTo = localStorage.getItem((0, _sessionState.REDIRECT_TO_AFTER_LOGOUT_KEY)) || (0, _routes.ROUTES).HOME;
    localStorage.removeItem((0, _sessionState.REDIRECT_TO_AFTER_LOGOUT_KEY));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
        to: redirectTo
    });
};
exports.default = LogoutRedirect;

},{"react/jsx-runtime":"enbMA","react-router-dom":"1ee65","../../constants/routes":"ihtm8","../../constants/session-state":"g0N7C","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b4N08":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _complyAdvantageMatch = require("../../components/ComplyAdvantageMatch/ComplyAdvantageMatch");
var _complyAdvantageMatchDefault = parcelHelpers.interopDefault(_complyAdvantageMatch);
var _detailsSkeleton = require("../../components/DetailsSkeleton/DetailsSkeleton");
var _detailsSkeletonDefault = parcelHelpers.interopDefault(_detailsSkeleton);
var _matchDetailsReviewSection = require("../../components/MatchDetailsReviewSection/MatchDetailsReviewSection");
var _matchDetailsReviewSectionDefault = parcelHelpers.interopDefault(_matchDetailsReviewSection);
var _matchHeader = require("../../components/MatchHeader/MatchHeader");
var _matchHeaderDefault = parcelHelpers.interopDefault(_matchHeader);
var _matchPageNavigation = require("../../components/MatchPageNavigation/MatchPageNavigation");
var _matchPageNavigationDefault = parcelHelpers.interopDefault(_matchPageNavigation);
var _rdcmatch = require("../../components/RDCMatch/RDCMatch");
var _rdcmatchDefault = parcelHelpers.interopDefault(_rdcmatch);
var _queriesKeys = require("../../constants/queries-keys");
var _matchHelpers = require("../../helpers/match.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useMatchPage = require("../../hooks/useMatchPage");
var _useMatchPageDefault = parcelHelpers.interopDefault(_useMatchPage);
const MatchPage = ({ data })=>{
    const { id, customerId } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const { match, avatarImages, reviews, matchCases, nextUnresolvedMatchCase } = (0, _useMatchPageDefault.default)(data);
    const isConfirmed = (0, _matchHelpers.isConfirmedMatch)(data.case);
    const isRejected = (0, _matchHelpers.isRejectedMatch)(data.case);
    const status = isRejected ? "critical" : isConfirmed ? "warning" : "info";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchPageNavigationDefault.default), {
                        matchData: data,
                        matchCases: matchCases
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchHeaderDefault.default), {
                        id: id,
                        status: status,
                        description: data.case.summary_text || f("common.banner.possible.match.title"),
                        subjectName: match.entity_name,
                        matchEntityName: match.entity_name,
                        date: match.timestamp,
                        lastUpdateDate: match.updated_timestamp,
                        avatarImages: avatarImages,
                        isRDC: (0, _matchHelpers.isRDCMatch)(match)
                    }),
                    (0, _matchHelpers.isRDCMatch)(match) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rdcmatchDefault.default), {
                        matchDetails: data
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _complyAdvantageMatchDefault.default), {
                        matchDetails: data
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsReviewSectionDefault.default), {
                        customerId: customerId,
                        customerType: match.subject_type,
                        id: id,
                        reviews: reviews,
                        isCustomerArchived: data.customer_is_archived,
                        nextUnresolvedMatchCase: nextUnresolvedMatchCase
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFooter, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchPageNavigationDefault.default), {
                    matchData: data,
                    matchCases: matchCases
                })
            })
        ]
    });
};
const StyledFooter = (0, _styledComponentsDefault.default).div`
  margin: var(--p-space-8) 0;
`;
exports.default = (0, _asyncPage.withAsyncPage)(MatchPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).MATCH_DETAILS,
    apiFunction: (0, _apiDefault.default).getCustomerMatchCaseDetails,
    paramNames: [
        "customerId",
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/ComplyAdvantageMatch/ComplyAdvantageMatch":"7Vrpb","../../components/DetailsSkeleton/DetailsSkeleton":"lj8DC","../../components/MatchDetailsReviewSection/MatchDetailsReviewSection":"2qVxZ","../../components/MatchHeader/MatchHeader":"1Rt9K","../../components/MatchPageNavigation/MatchPageNavigation":"6CUqn","../../components/RDCMatch/RDCMatch":"kmKaX","../../constants/queries-keys":"6hYSF","../../helpers/match.helpers":"4U2lJ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useMatchPage":"lXzDN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Vrpb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useComplyAdvantageMatch = require("../../hooks/useComplyAdvantageMatch");
var _useComplyAdvantageMatchDefault = parcelHelpers.interopDefault(_useComplyAdvantageMatch);
var _complyAdvantageMatchDetailsGeographicComparisonSection = require("../ComplyAdvantageMatchDetailsGeographicComparisonSection/ComplyAdvantageMatchDetailsGeographicComparisonSection");
var _complyAdvantageMatchDetailsGeographicComparisonSectionDefault = parcelHelpers.interopDefault(_complyAdvantageMatchDetailsGeographicComparisonSection);
var _matchDetailsComparisonSection = require("../MatchDetailsComparisonSection/MatchDetailsComparisonSection");
var _matchDetailsComparisonSectionDefault = parcelHelpers.interopDefault(_matchDetailsComparisonSection);
var _matchDetailsNegativeNewsSection = require("../MatchDetailsNegativeNewsSection/MatchDetailsNegativeNewsSection");
var _matchDetailsNegativeNewsSectionDefault = parcelHelpers.interopDefault(_matchDetailsNegativeNewsSection);
var _matchDetailsOtherSection = require("../MatchDetailsOtherSection/MatchDetailsOtherSection");
var _matchDetailsOtherSectionDefault = parcelHelpers.interopDefault(_matchDetailsOtherSection);
var _matchDetailsPEPSection = require("../MatchDetailsPEPSection/MatchDetailsPEPSection");
var _matchDetailsPEPSectionDefault = parcelHelpers.interopDefault(_matchDetailsPEPSection);
var _matchDetailsRelationsSection = require("../MatchDetailsRelationsSection/MatchDetailsRelationsSection");
var _matchDetailsRelationsSectionDefault = parcelHelpers.interopDefault(_matchDetailsRelationsSection);
var _matchDetailsSanctionsSection = require("../MatchDetailsSanctionsSection/MatchDetailsSanctionsSection");
var _matchDetailsSanctionsSectionDefault = parcelHelpers.interopDefault(_matchDetailsSanctionsSection);
var _matchKeyInformationSection = require("../MatchKeyInformationSection/MatchKeyInformationSection");
var _matchKeyInformationSectionDefault = parcelHelpers.interopDefault(_matchKeyInformationSection);
const ComplyAdvantageMatch = (props)=>{
    const { matchDetails } = props;
    const { sanctionEvents, pepEvents, positions, hasNewInfo } = (0, _useComplyAdvantageMatchDefault.default)(matchDetails);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsComparisonSectionDefault.default), {
                        matchDetails: matchDetails
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _complyAdvantageMatchDetailsGeographicComparisonSectionDefault.default), {
                        matchDetails: matchDetails
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchKeyInformationSectionDefault.default), {
                matchDetails: matchDetails
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsRelationsSectionDefault.default), {
                        matchDetails: matchDetails
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsPEPSectionDefault.default), {
                        pepEvents: pepEvents,
                        positions: positions,
                        hasNewInfo: hasNewInfo
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsSanctionsSectionDefault.default), {
                        sanctionEvents: sanctionEvents,
                        hasNewInfo: hasNewInfo
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsNegativeNewsSectionDefault.default), {
                        matchDetails: matchDetails
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsOtherSectionDefault.default), {
                        matchDetails: matchDetails
                    })
                ]
            })
        ]
    });
};
exports.default = ComplyAdvantageMatch;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useComplyAdvantageMatch":"kDpOy","../ComplyAdvantageMatchDetailsGeographicComparisonSection/ComplyAdvantageMatchDetailsGeographicComparisonSection":"3gUYv","../MatchDetailsComparisonSection/MatchDetailsComparisonSection":"fGP6J","../MatchDetailsNegativeNewsSection/MatchDetailsNegativeNewsSection":"797BN","../MatchDetailsOtherSection/MatchDetailsOtherSection":"O8TuI","../MatchDetailsPEPSection/MatchDetailsPEPSection":"13GZJ","../MatchDetailsRelationsSection/MatchDetailsRelationsSection":"j4nWK","../MatchDetailsSanctionsSection/MatchDetailsSanctionsSection":"bSoQZ","../MatchKeyInformationSection/MatchKeyInformationSection":"hDi8D","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kDpOy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _customerHelpers = require("../helpers/customer.helpers");
var _matchHelpers = require("../helpers/match.helpers");
var _personHelpers = require("../helpers/person.helpers");
var _collectionUtils = require("../utils/collectionUtils");
var _useMatchPage = require("./useMatchPage");
var _useMatchPageDefault = parcelHelpers.interopDefault(_useMatchPage);
const useComplyAdvantageMatch = (data)=>{
    const match = data.case.match;
    const newMatch = data.case.match_new;
    const subject = match.subject;
    const { isSubjectPerson, hasNewInfo } = (0, _useMatchPageDefault.default)(data);
    // RDC attributes
    const { riskography, links, remarks } = (0, _react.useMemo)(()=>(0, _matchHelpers.groupMatchAttributesByCode)(match), [
        match
    ]);
    // ComplyAdvantage attributes
    const { countries, nationalities } = (0, _react.useMemo)(()=>(0, _matchHelpers.groupComplyMatchFieldsByDescription)(newMatch), [
        newMatch
    ]);
    //// Countries
    const subjectCountries = isSubjectPerson(subject) ? (0, _personHelpers.getPersonUniqueCountries)(subject) : [
        subject.country
    ];
    const matchCountries = countries;
    //// Addresses
    const subjectAddresses = (isSubjectPerson(subject) ? [
        subject.address
    ] : [
        subject.business_address,
        subject.office_address,
        subject.mailing_address
    ]).filter(Boolean).filter((0, _customerHelpers.isPartialAddress));
    // sort by relevance
    const matchAddresses = match.addresses.filter((address)=>(0, _matchHelpers.isNotComplyAdvantageSource)(address) && (0, _matchHelpers.isPartialMatchAddress)(address));
    matchAddresses.sort((0, _matchHelpers.sortAddressesByRelevance)(subjectAddresses));
    //// Nationalities
    const matchNationalities = nationalities;
    const subjectNationalities = isSubjectPerson(subject) ? [
        subject.country_of_citizenship
    ].filter(Boolean) : [];
    const subjectPersonBirthDate = isSubjectPerson(subject) ? subject.birth_date || subject.birth_year?.toFixed(0) : "";
    // sort birth dates by relevance
    const birthdates = match.birth_dates.sort((0, _matchHelpers.sortBirthDatesByRelevance)(subjectPersonBirthDate));
    // RDC Events
    const { positions, pepEvents, sanctionEvents, adverseMediaEvents, otherEvents } = (0, _react.useMemo)(()=>{
        // if event category is "WLT" (watch list) then use the sub_category code for grouping
        const groupedEvents = (0, _collectionUtils.groupBy)(match.events, (event)=>event.category.code === "WLT" ? event.sub_category.code : event.category.code);
        const externalSources = [
            ...newMatch.sanction_sources,
            ...newMatch.pep_sources
        ];
        const sources = externalSources.map((sourceName)=>newMatch.sources[sourceName]);
        const positions = sources.flatMap((source)=>{
            const startDate = source.attributes?.find((attribute)=>attribute.description === "active_start_date")?.value;
            return source.positions?.map((position)=>({
                    ...position,
                    startDate
                }));
        }).filter(Boolean).filter((position)=>position.source_key !== "complyadvantage").sort((posA, posB)=>posA.value.localeCompare(posB.value));
        const barePepEvents = groupedEvents.get("PEP") || [];
        const bareSanctionEvents = groupedEvents.get("SAN") || [];
        const adverseMediaEvents = groupedEvents.get("ADV") || [];
        adverseMediaEvents.sort((0, _matchHelpers.getSortMatchEventByRelevance)(hasNewInfo));
        const otherEvents = (0, _collectionUtils.difference)([
            ...groupedEvents.keys()
        ], [
            "PEP",
            "SAN",
            "ADV"
        ]).flatMap((key)=>groupedEvents.get(key) || []);
        otherEvents.sort((0, _matchHelpers.getSortMatchEventByRelevance)(hasNewInfo));
        // Enrich sanctions events with additional information from Comply Advantage sources
        const sanctionEvents = bareSanctionEvents.map((event)=>{
            const source = event.source_key ? newMatch.sources[event.source_key] : undefined;
            const attributes = source?.attributes;
            const program = attributes?.find((attribute)=>attribute.description === "Program")?.value;
            const otherInformation = attributes?.find((attribute)=>attribute.description === "Other Information")?.value;
            const amendedDate = attributes?.find((attribute)=>attribute.description === "Amended On")?.value;
            return Object.assign({
                program,
                otherInformation,
                amendedDate
            }, event);
        });
        barePepEvents.sort((0, _matchHelpers.getSortMatchEventByRelevance)(hasNewInfo));
        // Enrich PEP events with additional information from Comply Advantage sources
        const pepEvents = barePepEvents.filter((event)=>event.source_key !== "complyadvantage") // filter comply advantage sources
        .map((event)=>{
            const source = event.source_key ? newMatch.sources[event.source_key] : undefined;
            const attributes = source?.attributes;
            const startDate = attributes?.find((attribute)=>attribute.description === "active_start_date")?.value;
            // TODO replace "active_start_date" description once it's available
            // const removedDate = attributes?.find((attribute) => attribute.description === "active_start_date")?.value;
            const chamber = attributes?.find((attribute)=>attribute.description === "Chamber")?.value;
            const pepFunction = attributes?.find((attribute)=>attribute.description === "Function")?.value;
            const institutionType = attributes?.find((attribute)=>attribute.description === "Institution Type")?.value;
            const otherInformation = attributes?.find((attribute)=>attribute.description === "Other Info")?.value;
            return Object.assign({
                startDate,
                /*removedDate*/ chamber,
                pepFunction,
                institutionType,
                otherInformation
            }, event);
        });
        return {
            positions,
            pepEvents,
            sanctionEvents,
            adverseMediaEvents,
            otherEvents
        };
    }, [
        match.id
    ]);
    const adverseMediaCategories = [
        ...new Set(adverseMediaEvents.map((event)=>event.sub_category.description))
    ];
    const sources = match.sources.filter((0, _matchHelpers.isEmptyMatchSource));
    sources.sort((0, _matchHelpers.getSortMatchSourceByRelevance)(hasNewInfo));
    return {
        subjectCountries,
        matchCountries,
        subjectAddresses,
        matchAddresses,
        subjectNationalities,
        matchNationalities,
        subjectPersonBirthDate,
        birthdates,
        riskography,
        links,
        remarks,
        adverseMediaCategories,
        pepEvents,
        positions,
        sanctionEvents,
        adverseMediaEvents,
        otherEvents,
        sources,
        hasNewInfo
    };
};
exports.default = useComplyAdvantageMatch;

},{"react":"cOWTg","../helpers/customer.helpers":"dkhe3","../helpers/match.helpers":"4U2lJ","../helpers/person.helpers":"6qOIE","../utils/collectionUtils":"gr5mc","./useMatchPage":"lXzDN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lXzDN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _matchHelpers = require("../helpers/match.helpers");
const useMatchPage = (data)=>{
    const match = data.case.match;
    const reviews = data.case.reviews;
    const status = data.case.status;
    const isPerson = match.subject_type !== "company";
    // isUpdated is true if the match has been reviewed, but has been
    // updated since the last review, ie. it needs a new review
    const isUpdated = reviews.length > 0 && status !== "RESOLVED";
    // used to hint TypeScript which type to check
    const isSubjectPerson = (subject)=>isPerson;
    const hasNewInfo = (entity)=>isUpdated && !entity.is_reviewed;
    const { avatarImages } = (0, _react.useMemo)(()=>(0, _matchHelpers.groupMatchAttributesByCode)(match), [
        match
    ]);
    // get all match cases of the current customer
    const { data: matches } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_MATCH_CASES,
        data.customer_id
    ], ()=>(0, _apiDefault.default).getCustomerMatchCases(data.customer_id));
    const matchCases = matches?.match_cases || [];
    const nextUnresolvedMatchCase = (0, _matchHelpers.findNextUnresolvedMatchCase)(matches?.match_cases, data.case.id);
    return {
        match,
        reviews,
        avatarImages,
        matchCases,
        nextUnresolvedMatchCase,
        isSubjectPerson,
        hasNewInfo
    };
};
exports.default = useMatchPage;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../helpers/match.helpers":"4U2lJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3gUYv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _globeSvg = require("../../../assets/icons/globe.svg");
var _globeSvgDefault = parcelHelpers.interopDefault(_globeSvg);
var _matchSvg = require("../../../assets/icons/match.svg");
var _matchSvgDefault = parcelHelpers.interopDefault(_matchSvg);
var _useComplyAdvantageMatch = require("../../hooks/useComplyAdvantageMatch");
var _useComplyAdvantageMatchDefault = parcelHelpers.interopDefault(_useComplyAdvantageMatch);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../utils/collectionUtils");
var _addressInfo = require("../AddressInfo/AddressInfo");
var _addressInfoDefault = parcelHelpers.interopDefault(_addressInfo);
var _comparisonTable = require("../ComparisonTable/ComparisonTable");
var _comparisonTableDefault = parcelHelpers.interopDefault(_comparisonTable);
var _comparisonTableHelpers = require("../ComparisonTable/ComparisonTable.helpers");
var _comparisonTableHeader = require("../ComparisonTable/ComparisonTableHeader");
var _comparisonTableHeaderDefault = parcelHelpers.interopDefault(_comparisonTableHeader);
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _matchAddressInfo = require("../MatchAddressInfo/MatchAddressInfo");
var _matchAddressInfoDefault = parcelHelpers.interopDefault(_matchAddressInfo);
const ComplyAdvantageMatchDetailsGeographicComparisonSection = (props)=>{
    const { matchDetails } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { subjectCountries, matchCountries, subjectAddresses, matchAddresses, subjectNationalities, matchNationalities, hasNewInfo } = (0, _useComplyAdvantageMatchDefault.default)(matchDetails);
    const rows = [
        (0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.country"), subjectCountries.map((countyCode)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: countyCode,
                shortName: true
            })), matchCountries, (attribute)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: attribute?.value,
                shortName: true
            }), hasNewInfo, true),
        (0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.address"), subjectAddresses.map((address)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                address: address,
                shortCountryName: true
            })), matchAddresses, (address)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAddressInfoDefault.default), {
                address: address
            }), hasNewInfo, true)
    ];
    if ((0, _collectionUtils.hasContent)(subjectNationalities)) rows.push((0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.nationality"), subjectNationalities.map((countyCode)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
            country: countyCode,
            shortName: true
        })), matchNationalities, (attribute)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
            country: attribute?.value,
            shortName: true
        }), hasNewInfo));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableDefault.default), {
            headings: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableHeaderDefault.default), {
                    icon: (0, _globeSvgDefault.default),
                    label: f("matches.titles.geographic-affiliation")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableHeaderDefault.default), {
                    icon: (0, _matchSvgDefault.default),
                    label: f("matches.titles.data-source")
                })
            ],
            rows: rows
        })
    });
};
exports.default = ComplyAdvantageMatchDetailsGeographicComparisonSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/globe.svg":"kv6Wl","../../../assets/icons/match.svg":"esK8q","../../hooks/useComplyAdvantageMatch":"kDpOy","../../hooks/useFormatMessage":"8Y8fq","../../utils/collectionUtils":"gr5mc","../AddressInfo/AddressInfo":"9YtjF","../ComparisonTable/ComparisonTable":"1Nv4g","../ComparisonTable/ComparisonTable.helpers":"36taR","../ComparisonTable/ComparisonTableHeader":"d3kWG","../Country/Country":"eeWSc","../MatchAddressInfo/MatchAddressInfo":"60EMZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"esK8q":[function(require,module,exports) {
module.exports = require("72475cdec50b7ff").getBundleURL("kEMsi") + "match.9559794d.svg";

},{"72475cdec50b7ff":"75UoR"}],"1Nv4g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
const ComparisonTable = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
        ...props,
        columnContentTypes: [
            "text",
            "text"
        ],
        increasedTableDensity: true,
        hoverable: false
    });
};
exports.default = ComparisonTable;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"36taR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createComparisonTableEntry", ()=>createComparisonTableEntry);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _collectionUtils = require("../../utils/collectionUtils");
var _util = require("../../utils/util");
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
var _comparisonCellContent = require("./ComparisonCellContent");
var _comparisonCellContentDefault = parcelHelpers.interopDefault(_comparisonCellContent);
var _comparisonTableCell = require("./ComparisonTableCell");
var _comparisonTableCellDefault = parcelHelpers.interopDefault(_comparisonTableCell);
var _comparisonTableOtherValuesCollapsible = require("./ComparisonTableOtherValuesCollapsible");
var _comparisonTableOtherValuesCollapsibleDefault = parcelHelpers.interopDefault(_comparisonTableOtherValuesCollapsible);
function createComparisonTableEntry(label, subjectValue, matchAttributes, getMatchEntryValue, hasNewInfo, displayAsList) {
    const firstValue = (0, _collectionUtils.first)(matchAttributes) ? getMatchEntryValue((0, _collectionUtils.first)(matchAttributes), true) : undefined;
    const showEmphasis = !(0, _util.isEmpty)(subjectValue) && !(0, _util.isEmpty)(firstValue);
    return [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableCellDefault.default), {
            label: label,
            children: Array.isArray(subjectValue) && (0, _collectionUtils.hasContent)(subjectValue) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                gap: showEmphasis ? "4" : "2",
                align: "start",
                children: subjectValue.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonCellContentDefault.default), {
                        emphasis: showEmphasis,
                        children: item
                    }, index))
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonCellContentDefault.default), {
                emphasis: showEmphasis,
                children: subjectValue
            })
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _comparisonTableCellDefault.default), {
            label: label,
            children: [
                !displayAsList && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "2",
                    inlineAlign: "start",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonCellContentDefault.default), {
                            emphasis: showEmphasis,
                            children: firstValue
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableOtherValuesCollapsibleDefault.default), {
                            values: matchAttributes?.slice(1),
                            renderValue: (matchEntry, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            as: "span",
                                            variant: "bodySm",
                                            color: "subdued",
                                            truncate: true,
                                            children: getMatchEntryValue(matchEntry)
                                        }),
                                        hasNewInfo && hasNewInfo(matchEntry) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                                    ]
                                }, `${getMatchEntryValue(matchEntry) || ""}-${index}`)
                        })
                    ]
                }),
                displayAsList && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "start",
                    children: (0, _collectionUtils.hasContent)(matchAttributes) ? matchAttributes?.map((matchAttribute, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonCellContentDefault.default), {
                            emphasis: showEmphasis,
                            children: getMatchEntryValue(matchAttribute)
                        }, index)) : "---"
                })
            ]
        })
    ];
}

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../utils/collectionUtils":"gr5mc","../../utils/util":"4MniK","../NewInfoBadge/NewInfoBadge":"7fmsH","./ComparisonCellContent":"lPGj0","./ComparisonTableCell":"cc3Dl","./ComparisonTableOtherValuesCollapsible":"1ZO6E","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lPGj0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const ComparisonCellContent = (0, _styledComponentsDefault.default).div`
  &:empty:before {
    content: "---";
  }

  padding: var(--p-space-1) var(--p-space-2);
  border-radius: var(--p-border-radius-1);
  margin-left: calc(-1 * var(--p-space-2));
  background-color: ${({ emphasis })=>emphasis ? "var(--p-color-bg-app)" : undefined};
  font-weight: ${({ emphasis })=>emphasis ? "var(--p-font-weight-semibold)" : undefined};
`;
exports.default = ComparisonCellContent;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cc3Dl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _dataTableCellChild = require("../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
const ComparisonTableCell = (props)=>{
    const { label, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
        width: "50%",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledText, {
                    children: label
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    align: "space-between",
                    blockAlign: "baseline",
                    children: children
                })
            ]
        })
    });
};
const StyledText = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  text-transform: uppercase;
`;
exports.default = ComparisonTableCell;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../CondensedText/CondensedText":"1FshD","../DataTableCellChild/DataTableCellChild":"boueG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1ZO6E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function ComparisonTableOtherValuesCollapsible(props) {
    const { values, label, renderValue } = props;
    const [isOpen, toggleOpen] = (0, _useOpenCloseDefault.default)();
    if (!values || values.length === 0) return null;
    if (values.length === 1) return renderValue(values[0], 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                size: "micro",
                monochrome: true,
                removeUnderline: true,
                textAlign: "left",
                disclosure: isOpen ? "up" : "down",
                onClick: toggleOpen,
                children: label || renderValue(values[0], 0)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                id: "",
                open: isOpen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                    gap: "1",
                    children: values.slice(1).map(renderValue)
                })
            })
        ]
    });
}
exports.default = ComparisonTableOtherValuesCollapsible;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"d3kWG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _dataTableCellChild = require("../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const ComparisonTableHeader = (props)=>{
    const { icon, label } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDataTableCellChild, {
        width: "50%",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "center",
            wrap: false,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: icon
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    variant: "headingMd",
                    fontWeight: "semibold",
                    children: label
                })
            ]
        })
    });
};
// used to override (revert) the data table header colors
const StyledDataTableCellChild = (0, _styledComponentsDefault.default)((0, _dataTableCellChildDefault.default))`
  color: var(--p-color-text) !important;
`;
exports.default = ComparisonTableHeader;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../DataTableCellChild/DataTableCellChild":"boueG","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"60EMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
const MatchAddressInfo = (props)=>{
    const { address } = props;
    const f = (0, _useFormatMessageDefault.default)();
    if (!address) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: f("not.specified")
    });
    const addressLabel = [
        address.addr1,
        address.addr2,
        address.city,
        address.state_prov
    ].filter(Boolean).join(", ");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        wrap: false,
        children: [
            addressLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "bodyMd",
                as: "span",
                children: addressLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: address.country_code,
                shortName: true
            })
        ]
    });
};
exports.default = MatchAddressInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../Country/Country":"eeWSc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fGP6J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _companySvg = require("../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _matchSvg = require("../../../assets/icons/match.svg");
var _matchSvgDefault = parcelHelpers.interopDefault(_matchSvg);
var _personSvg = require("../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useRDCMatch = require("../../hooks/useRDCMatch");
var _useRDCMatchDefault = parcelHelpers.interopDefault(_useRDCMatch);
var _comparisonTable = require("../ComparisonTable/ComparisonTable");
var _comparisonTableDefault = parcelHelpers.interopDefault(_comparisonTable);
var _comparisonTableHelpers = require("../ComparisonTable/ComparisonTable.helpers");
var _comparisonTableHeader = require("../ComparisonTable/ComparisonTableHeader");
var _comparisonTableHeaderDefault = parcelHelpers.interopDefault(_comparisonTableHeader);
const MatchDetailsComparisonSection = (props)=>{
    const { matchDetails } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { match, aliases, subjectPersonBirthDate, birthdates, isSubjectPerson, hasNewInfo } = (0, _useRDCMatchDefault.default)(matchDetails);
    const subject = match.subject;
    const isPerson = isSubjectPerson(subject);
    const rows = [
        (0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.name"), isSubjectPerson(subject) ? (0, _displayHelpers.getFullName)(subject) : subject.name, aliases, (alias, first)=>first ? alias.name : `${alias?.type}: ${alias?.name}`, hasNewInfo)
    ];
    if (isSubjectPerson(subject)) rows.push((0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.birth_date"), subjectPersonBirthDate, birthdates, (attribute)=>attribute?.value, hasNewInfo));
    const customerIcon = isPerson ? (0, _personSvgDefault.default) : (0, _companySvgDefault.default);
    const customerLabel = isPerson ? f("matches.titles.person-customer") : f("matches.titles.company-customer");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableDefault.default), {
            headings: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableHeaderDefault.default), {
                    icon: customerIcon,
                    label: customerLabel
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableHeaderDefault.default), {
                    icon: (0, _matchSvgDefault.default),
                    label: f("matches.titles.data-source")
                })
            ],
            rows: rows
        })
    });
};
exports.default = MatchDetailsComparisonSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/company.svg":"luBbc","../../../assets/icons/match.svg":"esK8q","../../../assets/icons/person.svg":"1Xt5L","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useRDCMatch":"16HRo","../ComparisonTable/ComparisonTable":"1Nv4g","../ComparisonTable/ComparisonTable.helpers":"36taR","../ComparisonTable/ComparisonTableHeader":"d3kWG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"16HRo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _stringSimilarityJs = require("string-similarity-js");
var _stringSimilarityJsDefault = parcelHelpers.interopDefault(_stringSimilarityJs);
var _customerHelpers = require("../helpers/customer.helpers");
var _displayHelpers = require("../helpers/display.helpers");
var _matchHelpers = require("../helpers/match.helpers");
var _collectionUtils = require("../utils/collectionUtils");
var _useMatchPage = require("./useMatchPage");
var _useMatchPageDefault = parcelHelpers.interopDefault(_useMatchPage);
const useRDCMatch = (data)=>{
    const match = data.case.match;
    const subject = match.subject;
    const { isSubjectPerson, hasNewInfo } = (0, _useMatchPageDefault.default)(data);
    // RDC attributes
    const { riskography, links, remarks, nationalities, citizenships, countries_of_incorporations } = (0, _react.useMemo)(()=>(0, _matchHelpers.groupMatchAttributesByCode)(match), [
        match
    ]);
    const subjectPersonBirthDate = isSubjectPerson(subject) ? subject.birth_date || subject.birth_year?.toFixed(0) : "";
    // sort birth dates by relevance
    const birthdates = match.birth_dates.filter((0, _matchHelpers.isNotComplyAdvantageSource)).sort((0, _matchHelpers.sortBirthDatesByRelevance)(subjectPersonBirthDate));
    const subjectAddresses = (isSubjectPerson(subject) ? [
        subject.address
    ] : [
        subject.business_address,
        subject.office_address,
        subject.mailing_address
    ]).filter(Boolean).filter((0, _customerHelpers.isPartialAddress));
    // sort addresses by relevance
    const addresses = match.addresses.filter((0, _matchHelpers.isPartialMatchAddress));
    addresses.sort((0, _matchHelpers.sortAddressesByRelevance)(subjectAddresses));
    const { pepEvents, sanctionEvents, adverseMediaEvents, otherEvents } = (0, _react.useMemo)(()=>{
        // if event category is "WLT" (watch list) then use the sub_category code for grouping
        const groupedEvents = (0, _collectionUtils.groupBy)(match.events, (event)=>event.category.code === "WLT" ? event.sub_category.code : event.category.code);
        const pepEvents = groupedEvents.get("PEP") || [];
        pepEvents.sort((0, _matchHelpers.getSortMatchEventByRelevance)(hasNewInfo));
        const sanctionEvents = groupedEvents.get("SAN") || [];
        sanctionEvents.sort((0, _matchHelpers.getSortMatchEventByRelevance)(hasNewInfo));
        const adverseMediaEvents = groupedEvents.get("ADV") || [];
        adverseMediaEvents.sort((0, _matchHelpers.getSortMatchEventByRelevance)(hasNewInfo));
        const otherEvents = (0, _collectionUtils.difference)([
            ...groupedEvents.keys()
        ], [
            "PEP",
            "SAN",
            "ADV"
        ]).flatMap((key)=>groupedEvents.get(key) || []);
        otherEvents.sort((0, _matchHelpers.getSortMatchEventByRelevance)(hasNewInfo));
        return {
            pepEvents,
            sanctionEvents,
            adverseMediaEvents,
            otherEvents
        };
    }, [
        match.id
    ]);
    const adverseMediaCategories = [
        ...new Set(adverseMediaEvents.map((event)=>event.sub_category.description))
    ];
    const sources = match.sources.filter((0, _matchHelpers.isEmptyMatchSource));
    sources.sort((0, _matchHelpers.getSortMatchSourceByRelevance)(hasNewInfo));
    const positions = match.positions.sort();
    // sort aliases by proximity to subject name
    const aliases = (0, _react.useMemo)(()=>{
        const matchName = (isSubjectPerson(subject) ? (0, _displayHelpers.getFullName)(subject) : subject.name) || "";
        return match.aliases.sort((aliasA, aliasB)=>(0, _stringSimilarityJsDefault.default)(aliasB.name, matchName) - (0, _stringSimilarityJsDefault.default)(aliasA.name, matchName));
    }, [
        match
    ]);
    return {
        match,
        aliases,
        isSubjectPerson,
        hasNewInfo,
        subjectPersonBirthDate,
        birthdates,
        subjectAddresses,
        addresses,
        riskography,
        links,
        remarks,
        nationalities,
        citizenships,
        countries_of_incorporations,
        adverseMediaCategories,
        pepEvents,
        positions,
        sanctionEvents,
        adverseMediaEvents,
        otherEvents,
        sources
    };
};
exports.default = useRDCMatch;

},{"react":"cOWTg","string-similarity-js":"ksDXa","../helpers/customer.helpers":"dkhe3","../helpers/display.helpers":"2q3xY","../helpers/match.helpers":"4U2lJ","../utils/collectionUtils":"gr5mc","./useMatchPage":"lXzDN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"797BN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useRDCMatch = require("../../hooks/useRDCMatch");
var _useRDCMatchDefault = parcelHelpers.interopDefault(_useRDCMatch);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _matchAttributesCollapsibleCardSections = require("../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections");
var _matchAttributesCollapsibleCardSectionsDefault = parcelHelpers.interopDefault(_matchAttributesCollapsibleCardSections);
var _matchCategorySection = require("../MatchCategorySection/MatchCategorySection");
var _matchCategorySectionDefault = parcelHelpers.interopDefault(_matchCategorySection);
var _matchDetailsBadge = require("../MatchDetailsBadge/MatchDetailsBadge");
var _matchDetailsBadgeDefault = parcelHelpers.interopDefault(_matchDetailsBadge);
var _matchEvent = require("../MatchEvent/MatchEvent");
var _matchEventDefault = parcelHelpers.interopDefault(_matchEvent);
const MatchDetailsNegativeNewsSection = (props)=>{
    const { matchDetails } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { adverseMediaCategories, adverseMediaEvents, hasNewInfo } = (0, _useRDCMatchDefault.default)(matchDetails);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _matchCategorySectionDefault.default), {
        title: f("matches.labels.negative-news"),
        children: [
            adverseMediaCategories.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                    children: f("matches.titles.categories")
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    children: adverseMediaCategories.map((category)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsBadgeDefault.default), {
                            children: category
                        }, category))
                })
            }),
            adverseMediaEvents.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
                title: f("matches.titles.events"),
                elements: adverseMediaEvents,
                renderElement: (event)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchEventDefault.default), {
                        event: event,
                        showNewInfo: hasNewInfo(event),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsBadgeDefault.default), {
                            children: event.sub_category.description
                        })
                    })
            })
        ]
    });
};
exports.default = MatchDetailsNegativeNewsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useRDCMatch":"16HRo","../CondensedText/CondensedText":"1FshD","../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections":"lVrDr","../MatchCategorySection/MatchCategorySection":"1qjqI","../MatchDetailsBadge/MatchDetailsBadge":"lS2eI","../MatchEvent/MatchEvent":"ktrDM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lVrDr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _matches = require("../../constants/matches");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
function MatchAttributesCollapsibleCardSections(props) {
    const { title, elements, renderElement } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showMoreSources, toggleShowMoreSources] = (0, _useOpenCloseDefault.default)();
    if (!elements || elements.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            elements.slice(0, (0, _matches.MATCH_ATTRIBUTE_ITEMS_CUTOFF)).map((element, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    title: i === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: title
                    }) : undefined,
                    children: renderElement(element)
                }, i)),
            elements.length > (0, _matches.MATCH_ATTRIBUTE_ITEMS_CUTOFF) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                        id: `match-card-sections-${title}`,
                        open: showMoreSources,
                        children: elements.slice((0, _matches.MATCH_ATTRIBUTE_ITEMS_CUTOFF)).map((element, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                children: renderElement(element)
                            }, (0, _matches.MATCH_ATTRIBUTE_ITEMS_CUTOFF) + i))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                onClick: toggleShowMoreSources,
                                disclosure: showMoreSources ? "up" : "down",
                                children: showMoreSources ? f("default.hide") : f("common.labels.show-more-with-count", {
                                    count: elements.length - (0, _matches.MATCH_ATTRIBUTE_ITEMS_CUTOFF)
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = MatchAttributesCollapsibleCardSections;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../constants/matches":"gcrL3","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../CondensedText/CondensedText":"1FshD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1qjqI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
const MatchCategorySection = (props)=>{
    const { title, description, children } = props;
    const isEmpty = (0, _reactDefault.default).Children.count(children) === 0 || (0, _reactDefault.default).Children.toArray(children).filter(Boolean).length === 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "h3",
                    variant: "headingMd",
                    color: isEmpty ? "subdued" : undefined,
                    children: title
                }),
                description
            ]
        }),
        children: [
            children,
            isEmpty && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    color: "subdued",
                    children: "---"
                })
            })
        ]
    });
};
exports.default = MatchCategorySection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lS2eI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
const MatchDetailsBadge = (0, _styledComponentsDefault.default)((0, _badgeDefault.default))`
  & > .Polaris-Badge {
    border-radius: var(--p-border-radius-1);
  }
`;
exports.default = MatchDetailsBadge;

},{"styled-components":"eBrdC","../extensions/Badge":"9irVp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ktrDM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
const MatchEvent = (props)=>{
    const { event, showNewInfo, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "2",
                blockAlign: "baseline",
                children: [
                    event.date && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                fontWeight: "bold",
                                variant: "bodySm",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                    date: event.date
                                })
                            }),
                            event.amendedDate && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                children: [
                                    f("match.basic-info.last-updated") + " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                        date: event.amendedDate
                                    })
                                ]
                            })
                        ]
                    }),
                    showNewInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledInfoContainer, {
                children: [
                    event.program && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: "Program:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: event.program
                            })
                        ]
                    }),
                    event.chamber && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: "Chamber:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: event.chamber
                            })
                        ]
                    }),
                    event.pepFunction && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: "Function:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: event.pepFunction
                            })
                        ]
                    }),
                    event.institutionType && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: "Institution Type:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: event.institutionType
                            })
                        ]
                    }),
                    event.otherInformation && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: "Other information:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: event.otherInformation
                            })
                        ]
                    })
                ]
            }),
            event.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "p",
                children: event.description.replace(": ", "")
            }),
            !event.source?.source_url && event.source?.source_name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: "subdued",
                        children: f("matches.labels.source.name")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        truncate: true,
                        children: event.source?.source_name
                    })
                ]
            }),
            event.source?.publisher && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: "subdued",
                        children: f("matches.labels.source.publisher")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        truncate: true,
                        children: event.source?.publisher
                    })
                ]
            }),
            event.source?.source_url && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("matches.labels.source.url")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                            url: (0, _stringUtils.parseWebsite)(event.source?.source_url),
                            external: true,
                            children: event.source?.source_name || event.source?.source_url
                        })
                    })
                ]
            }),
            children
        ]
    });
};
const StyledInfoContainer = (0, _styledComponentsDefault.default).div`
  display: grid;
  gap: var(--p-space-1) var(--p-space-4);
  grid-template-columns: auto 1fr;
  margin-bottom: var(--p-space-4);
`;
exports.default = MatchEvent;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../CondensedText/CondensedText":"1FshD","../CustomDate/CustomDate":"5KD00","../NewInfoBadge/NewInfoBadge":"7fmsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"O8TuI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useRDCMatch = require("../../hooks/useRDCMatch");
var _useRDCMatchDefault = parcelHelpers.interopDefault(_useRDCMatch);
var _stringUtils = require("../../utils/stringUtils");
var _matchAttributesCollapsibleCardSections = require("../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections");
var _matchAttributesCollapsibleCardSectionsDefault = parcelHelpers.interopDefault(_matchAttributesCollapsibleCardSections);
var _matchCategorySection = require("../MatchCategorySection/MatchCategorySection");
var _matchCategorySectionDefault = parcelHelpers.interopDefault(_matchCategorySection);
var _matchEvent = require("../MatchEvent/MatchEvent");
var _matchEventDefault = parcelHelpers.interopDefault(_matchEvent);
var _matchSource = require("../MatchSource/MatchSource");
var _matchSourceDefault = parcelHelpers.interopDefault(_matchSource);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
const MatchDetailsOtherSection = (props)=>{
    const { matchDetails } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { otherEvents, remarks, sources, links, hasNewInfo } = (0, _useRDCMatchDefault.default)(matchDetails);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _matchCategorySectionDefault.default), {
        title: f("matches.labels.other"),
        children: [
            otherEvents.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
                title: f("matches.titles.events"),
                elements: otherEvents,
                renderElement: (event)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchEventDefault.default), {
                        event: event,
                        showNewInfo: hasNewInfo(event)
                    })
            }),
            remarks.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
                title: f("matches.titles.comments"),
                elements: remarks,
                renderElement: (remark)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                children: remark.value
                            }),
                            hasNewInfo(remark) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                        ]
                    })
            }),
            sources.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
                title: f("matches.titles.sources"),
                elements: sources,
                renderElement: (source)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchSourceDefault.default), {
                        source: source,
                        showNewInfo: hasNewInfo(source)
                    })
            }),
            links.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
                title: f("matches.titles.relevant-links"),
                elements: links,
                renderElement: (link)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "1",
                        children: [
                            hasNewInfo(link) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLinkWrapper, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                                    url: (0, _stringUtils.parseWebsite)(link.value),
                                    external: true,
                                    children: decodeURI(link.value)
                                })
                            })
                        ]
                    })
            })
        ]
    });
};
const StyledLinkWrapper = (0, _styledComponentsDefault.default).div`
  word-break: break-all;
`;
exports.default = MatchDetailsOtherSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useRDCMatch":"16HRo","../../utils/stringUtils":"4gVdA","../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections":"lVrDr","../MatchCategorySection/MatchCategorySection":"1qjqI","../MatchEvent/MatchEvent":"ktrDM","../MatchSource/MatchSource":"gPHbg","../NewInfoBadge/NewInfoBadge":"7fmsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gPHbg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
const MatchSource = (props)=>{
    const { source, showNewInfo } = props;
    const { entity_dt, headline, source_url, source_name, publisher, publication_source } = source;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "2",
                blockAlign: "baseline",
                children: [
                    entity_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "bold",
                        variant: "bodySm",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                            date: entity_dt
                        })
                    }),
                    showNewInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                ]
            }),
            headline && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "p",
                children: headline
            }),
            !source.source_url && source.source_name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: "subdued",
                        children: f("matches.labels.source.name")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: source_name
                    })
                ]
            }),
            publisher && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: "subdued",
                        children: f("matches.labels.source.publisher")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: publisher
                    })
                ]
            }),
            publication_source && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: "subdued",
                        children: f("matches.labels.source.publication-source")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: publication_source
                    })
                ]
            }),
            source_url && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("matches.labels.source.url")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                        url: (0, _stringUtils.parseWebsite)(source_url),
                        external: true,
                        children: source_name || source_url
                    })
                ]
            })
        ]
    });
};
exports.default = MatchSource;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../CustomDate/CustomDate":"5KD00","../NewInfoBadge/NewInfoBadge":"7fmsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"13GZJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _triangleFilledExclamationMonochromeSvg = require("../../../assets/icons/triangle-filled-exclamation-monochrome.svg");
var _triangleFilledExclamationMonochromeSvgDefault = parcelHelpers.interopDefault(_triangleFilledExclamationMonochromeSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../utils/collectionUtils");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _matchAttributesCollapsibleCardSections = require("../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections");
var _matchAttributesCollapsibleCardSectionsDefault = parcelHelpers.interopDefault(_matchAttributesCollapsibleCardSections);
var _matchCategorySection = require("../MatchCategorySection/MatchCategorySection");
var _matchCategorySectionDefault = parcelHelpers.interopDefault(_matchCategorySection);
var _matchEvent = require("../MatchEvent/MatchEvent");
var _matchEventDefault = parcelHelpers.interopDefault(_matchEvent);
var _matchValuesCollapsible = require("../MatchKeyInformationSection/MatchValuesCollapsible");
var _matchValuesCollapsibleDefault = parcelHelpers.interopDefault(_matchValuesCollapsible);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
var _tag = require("../Tag/Tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tooltipWrapper = require("../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _matchDetailsPEPHelpText = require("./MatchDetailsPEPHelpText");
var _matchDetailsPEPHelpTextDefault = parcelHelpers.interopDefault(_matchDetailsPEPHelpText);
const MatchDetailsPEPSection = (props)=>{
    const { pepEvents, positions, hasNewInfo } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const showDescription = (0, _collectionUtils.hasContent)(positions) || (0, _collectionUtils.hasContent)(pepEvents);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _matchCategorySectionDefault.default), {
        title: f("matches.labels.pep"),
        description: showDescription ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
            content: f("matches.labels.pep.detailed.tooltip"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWarningTag, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    blockAlign: "center",
                    wrap: false,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _triangleFilledExclamationMonochromeSvgDefault.default),
                            useMask: true,
                            width: "16px",
                            height: "16px"
                        }),
                        f("matches.labels.pep.detailed")
                    ]
                })
            })
        }) : undefined,
        children: [
            positions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchValuesCollapsibleDefault.default), {
                label: f("matches.titles.positions"),
                values: positions,
                renderValue: (position, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "1",
                                blockAlign: "baseline",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        variant: "bodySm",
                                        fontWeight: "semibold",
                                        children: position.value
                                    }),
                                    position.startDate && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                        children: [
                                            f("common.labels.start-date"),
                                            ": ",
                                            position.startDate
                                        ]
                                    })
                                ]
                            }),
                            hasNewInfo(position) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                        ]
                    }, index)
            }),
            pepEvents.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
                title: f("matches.titles.events"),
                elements: pepEvents,
                renderElement: (event)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchEventDefault.default), {
                        event: event,
                        showNewInfo: hasNewInfo(event)
                    })
            }),
            showDescription && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsPEPHelpTextDefault.default), {})
                ]
            })
        ]
    });
};
const StyledWarningTag = (0, _styledComponentsDefault.default)((0, _tagDefault.default))`
  & .Polaris-Tag {
    background-color: var(--kdk-yellow-500);
    border: solid var(--p-border-width-1) var(--kdk-yellow-600);
  }
`;
exports.default = MatchDetailsPEPSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/triangle-filled-exclamation-monochrome.svg":"iabow","../../hooks/useFormatMessage":"8Y8fq","../../utils/collectionUtils":"gr5mc","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections":"lVrDr","../MatchCategorySection/MatchCategorySection":"1qjqI","../MatchEvent/MatchEvent":"ktrDM","../MatchKeyInformationSection/MatchValuesCollapsible":"ichM0","../NewInfoBadge/NewInfoBadge":"7fmsH","../Tag/Tag":"4KuO7","../TooltipWrapper/TooltipWrapper":"b5W2d","./MatchDetailsPEPHelpText":"4iLim","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ichM0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _matches = require("../../constants/matches");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function MatchValuesCollapsible(props) {
    const { values = [], label, labelHidden, renderValue } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [isOpen, toggleOpen] = (0, _useOpenCloseDefault.default)();
    const buttonLabel = isOpen ? f("common.labels.show-less") : f("common.labels.show-more-with-count", {
        count: values.length - (0, _matches.MATCH_POSITIONS_AND_RELATIONS_CUTOFF)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            align: "space-between",
            blockAlign: "center",
            children: [
                !labelHidden && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                    children: label
                }),
                values.length > (0, _matches.MATCH_POSITIONS_AND_RELATIONS_CUTOFF) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    plain: true,
                    size: "micro",
                    monochrome: true,
                    removeUnderline: true,
                    textAlign: "right",
                    disclosure: isOpen ? "up" : "down",
                    onClick: toggleOpen,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: "subdued",
                        children: buttonLabel
                    })
                })
            ]
        }),
        children: [
            values.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                color: "subdued",
                children: "---"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "1",
                children: [
                    values.slice(0, (0, _matches.MATCH_POSITIONS_AND_RELATIONS_CUTOFF)).map((value, index)=>renderValue(value, index)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                        id: label,
                        open: isOpen,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                            gap: "1",
                            children: values.slice((0, _matches.MATCH_POSITIONS_AND_RELATIONS_CUTOFF)).map((value, index)=>renderValue(value, (0, _matches.MATCH_POSITIONS_AND_RELATIONS_CUTOFF) + index))
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = MatchValuesCollapsible;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../constants/matches":"gcrL3","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../CondensedText/CondensedText":"1FshD","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4iLim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _helpText = require("../HelpText/HelpText");
var _helpTextDefault = parcelHelpers.interopDefault(_helpText);
var _markdownContent = require("../MarkdownContent/MarkdownContent");
var _markdownContentDefault = parcelHelpers.interopDefault(_markdownContent);
const MatchDetailsPEPHelpText = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpTextDefault.default), {
        title: f("matches.help-text.pep.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownContentDefault.default), {
            content: f("matches.help-text.pep.description")
        })
    });
};
exports.default = MatchDetailsPEPHelpText;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","../HelpText/HelpText":"6YGoh","../MarkdownContent/MarkdownContent":"cPR47","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6YGoh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const HelpText = (props)=>{
    const { title, children } = props;
    const [isExpanded, toggleExpanded] = (0, _useOpenCloseDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBanner, {
        hideIcon: true,
        status: "info",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                plain: true,
                monochrome: true,
                removeUnderline: true,
                fullWidth: true,
                textAlign: "left",
                disclosure: isExpanded ? "up" : "down",
                onClick: toggleExpanded,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                open: isExpanded,
                id: "",
                children: children
            })
        ]
    });
};
const StyledBanner = (0, _styledComponentsDefault.default)((0, _kdkbannerDefault.default))`
  margin: var(--p-space-4);

  & > .Polaris-Banner {
    padding: var(--p-space-2) var(--p-space-4);
  }

  & > .Polaris-Banner .Polaris-Button {
    padding: 0;
  }

  & > .Polaris-Banner .Polaris-Button__Content {
    flex: 1;
  }
`;
exports.default = HelpText;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useOpenClose":"idooG","../extensions/Button":"8exc0","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j4nWK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useMatchRelationLabel = require("../../hooks/useMatchRelationLabel");
var _useMatchRelationLabelDefault = parcelHelpers.interopDefault(_useMatchRelationLabel);
var _useRDCMatch = require("../../hooks/useRDCMatch");
var _useRDCMatchDefault = parcelHelpers.interopDefault(_useRDCMatch);
var _collectionUtils = require("../../utils/collectionUtils");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _matchCategorySection = require("../MatchCategorySection/MatchCategorySection");
var _matchCategorySectionDefault = parcelHelpers.interopDefault(_matchCategorySection);
var _matchValuesCollapsible = require("../MatchKeyInformationSection/MatchValuesCollapsible");
var _matchValuesCollapsibleDefault = parcelHelpers.interopDefault(_matchValuesCollapsible);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
const MatchDetailsRelationsSection = (props)=>{
    const { matchDetails } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { match, hasNewInfo } = (0, _useRDCMatchDefault.default)(matchDetails);
    const getMatchRelationLabel = (0, _useMatchRelationLabelDefault.default)();
    const relationsByType = (0, _collectionUtils.groupBy)(match.relations, (relation)=>relation.type);
    const relations = [
        ...relationsByType.entries()
    ].map(([type, entries])=>({
            type,
            newInfo: entries.some(hasNewInfo),
            names: entries.map((entity)=>entity.entity_name).join(", ")
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCategorySectionDefault.default), {
        title: f("matches.labels.relations"),
        children: relations.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchValuesCollapsibleDefault.default), {
            label: f("matches.titles.relations"),
            labelHidden: true,
            values: relations,
            renderValue: (relation, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledContainer, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "2",
                                blockAlign: "start",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                        children: getMatchRelationLabel(relation.type)
                                    }),
                                    relation.newInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "span",
                                variant: "bodySm",
                                fontWeight: "semibold",
                                children: relation.names
                            })
                        ]
                    })
                }, index)
        })
    });
};
const StyledContainer = (0, _styledComponentsDefault.default).div`
  margin-bottom: var(--p-space-2);
`;
exports.default = MatchDetailsRelationsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useMatchRelationLabel":"7x3f6","../../hooks/useRDCMatch":"16HRo","../../utils/collectionUtils":"gr5mc","../CondensedText/CondensedText":"1FshD","../MatchCategorySection/MatchCategorySection":"1qjqI","../MatchKeyInformationSection/MatchValuesCollapsible":"ichM0","../NewInfoBadge/NewInfoBadge":"7fmsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7x3f6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("./useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
const useMatchRelationLabel = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    // a translations map for match relation type (which is an unknown string)
    const translationsMap = (0, _react.useMemo)(()=>new Map([
            [
                "PARENT",
                f("match.relations.PARENT")
            ],
            [
                "FATHER",
                f("match.relations.FATHER")
            ],
            [
                "MOTHER",
                f("match.relations.MOTHER")
            ],
            [
                "CHILD",
                f("match.relations.CHILD")
            ],
            [
                "DAUGHTER",
                f("match.relations.DAUGHTER")
            ],
            [
                "SPOUSE",
                f("match.relations.SPOUSE")
            ],
            [
                "WIFE",
                f("match.relations.WIFE")
            ],
            [
                "SIBLING",
                f("match.relations.SIBLING")
            ],
            [
                "ACTING FOR OR ON BEHALF OF",
                f("match.relations.ACTING")
            ],
            [
                "RELATIVE",
                f("match.relations.RELATIVE")
            ]
        ]), [
        language
    ]);
    const getRelationshipLabel = (0, _react.useCallback)((relationType)=>translationsMap.get(relationType.toLocaleUpperCase()) || relationType.toLocaleUpperCase(), [
        language
    ]);
    return getRelationshipLabel;
};
exports.default = useMatchRelationLabel;

},{"react":"cOWTg","./useFormatMessage":"8Y8fq","./useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bSoQZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _redFlagSvg = require("../../../assets/icons/red-flag.svg");
var _redFlagSvgDefault = parcelHelpers.interopDefault(_redFlagSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _matchAttributesCollapsibleCardSections = require("../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections");
var _matchAttributesCollapsibleCardSectionsDefault = parcelHelpers.interopDefault(_matchAttributesCollapsibleCardSections);
var _matchCategorySection = require("../MatchCategorySection/MatchCategorySection");
var _matchCategorySectionDefault = parcelHelpers.interopDefault(_matchCategorySection);
var _matchEvent = require("../MatchEvent/MatchEvent");
var _matchEventDefault = parcelHelpers.interopDefault(_matchEvent);
var _tag = require("../Tag/Tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
const MatchDetailsSanctionsSection = (props)=>{
    const { sanctionEvents, hasNewInfo } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const showDescription = sanctionEvents.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCategorySectionDefault.default), {
        title: f("matches.labels.sanctions"),
        description: showDescription ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSanctionTag, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                blockAlign: "center",
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _redFlagSvgDefault.default),
                        width: "16px",
                        height: "16px"
                    }),
                    f("matches.labels.sanction")
                ]
            })
        }) : undefined,
        children: showDescription && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
            title: f("matches.titles.listings"),
            elements: sanctionEvents,
            renderElement: (event)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchEventDefault.default), {
                    event: event,
                    showNewInfo: hasNewInfo(event)
                })
        })
    });
};
const StyledSanctionTag = (0, _styledComponentsDefault.default)((0, _tagDefault.default))`
  & .Polaris-Tag {
    background-color: var(--kdk-red-500);
    border: solid var(--p-border-width-1) var(--kdk-red);
  }
`;
exports.default = MatchDetailsSanctionsSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/red-flag.svg":"5HNDS","../../hooks/useFormatMessage":"8Y8fq","../extensions/Icon":"eHSf0","../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections":"lVrDr","../MatchCategorySection/MatchCategorySection":"1qjqI","../MatchEvent/MatchEvent":"ktrDM","../Tag/Tag":"4KuO7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5HNDS":[function(require,module,exports) {
module.exports = require("eaaee7c98e11e93d").getBundleURL("kEMsi") + "red-flag.b2c2fa9e.svg";

},{"eaaee7c98e11e93d":"75UoR"}],"hDi8D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useRDCMatch = require("../../hooks/useRDCMatch");
var _useRDCMatchDefault = parcelHelpers.interopDefault(_useRDCMatch);
var _matchAttributesCollapsibleCardSections = require("../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections");
var _matchAttributesCollapsibleCardSectionsDefault = parcelHelpers.interopDefault(_matchAttributesCollapsibleCardSections);
var _matchCategorySection = require("../MatchCategorySection/MatchCategorySection");
var _matchCategorySectionDefault = parcelHelpers.interopDefault(_matchCategorySection);
var _newInfoBadge = require("../NewInfoBadge/NewInfoBadge");
var _newInfoBadgeDefault = parcelHelpers.interopDefault(_newInfoBadge);
const MatchKeyInformationSection = (props)=>{
    const { matchDetails } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { riskography, hasNewInfo } = (0, _useRDCMatchDefault.default)(matchDetails);
    if (riskography.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCategorySectionDefault.default), {
        title: f("matches.titles.key-information"),
        children: riskography.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAttributesCollapsibleCardSectionsDefault.default), {
            title: f("matches.titles.summary"),
            elements: riskography,
            renderElement: (risk)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: risk ? "semibold" : undefined,
                            children: risk.value
                        }),
                        hasNewInfo(risk) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newInfoBadgeDefault.default), {})
                    ]
                })
        })
    });
};
exports.default = MatchKeyInformationSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useRDCMatch":"16HRo","../MatchAttributesCollapsibleCardSections/MatchAttributesCollapsibleCardSections":"lVrDr","../MatchCategorySection/MatchCategorySection":"1qjqI","../NewInfoBadge/NewInfoBadge":"7fmsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2qVxZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _pageAnchors = require("../../constants/page-anchors");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _matchReviewCard = require("../MatchReviewCard/MatchReviewCard");
var _matchReviewCardDefault = parcelHelpers.interopDefault(_matchReviewCard);
var _matchReviewForm = require("../MatchReviewForm/MatchReviewForm");
var _matchReviewFormDefault = parcelHelpers.interopDefault(_matchReviewForm);
var _matchReviewSuccessToast = require("../MatchReviewSuccessToast/MatchReviewSuccessToast");
var _matchReviewSuccessToastDefault = parcelHelpers.interopDefault(_matchReviewSuccessToast);
var _useMatchReview = require("./useMatchReview");
var _useMatchReviewDefault = parcelHelpers.interopDefault(_useMatchReview);
const MatchDetailsReviewSection = (props)=>{
    const { customerId, customerType, id, reviews, isCustomerArchived, nextUnresolvedMatchCase } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { onMatchReviewed, resolvedReview, clearResolvedReview } = (0, _useMatchReviewDefault.default)(customerId, customerType, id);
    const [isReviewModalOpen, toggleReviewModal] = (0, _useOpenCloseDefault.default)();
    const hasExistingReviews = reviews.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            align: "space-between",
                            wrap: false,
                            blockAlign: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    variant: "bodyLg",
                                    fontWeight: "semibold",
                                    children: f("matches.titles.assessment")
                                }),
                                hasExistingReviews && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                    primary: true,
                                    onClick: toggleReviewModal,
                                    children: f("reviews.labels.change-review")
                                })
                            ]
                        }),
                        !hasExistingReviews && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchReviewFormDefault.default), {
                            customerId: customerId,
                            customerType: customerType,
                            caseId: id,
                            readonly: isCustomerArchived,
                            onAfterMatchReviewed: onMatchReviewed
                        })
                    ]
                })
            }),
            hasExistingReviews && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: (0, _pageAnchors.PAGE_ANCHORS).REVIEWS_SECTION,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: reviews.map((review)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchReviewCardDefault.default), {
                                review: review
                            }, review.id))
                    })
                })
            }),
            isReviewModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
                open: true,
                title: f("matches.titles.assessment"),
                large: true,
                onClose: toggleReviewModal,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchReviewFormDefault.default), {
                        customerId: customerId,
                        customerType: customerType,
                        caseId: id,
                        readonly: isCustomerArchived,
                        onClose: toggleReviewModal,
                        onAfterMatchReviewed: onMatchReviewed
                    })
                })
            }),
            resolvedReview && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchReviewSuccessToastDefault.default), {
                isApproved: resolvedReview?.is_match,
                customerId: customerId,
                nextMatch: nextUnresolvedMatchCase,
                onDismiss: clearResolvedReview
            })
        ]
    });
};
exports.default = MatchDetailsReviewSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/page-anchors":"4WmvA","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../MatchReviewCard/MatchReviewCard":"5nIw9","../MatchReviewForm/MatchReviewForm":"8iFfd","../MatchReviewSuccessToast/MatchReviewSuccessToast":"6iCv1","./useMatchReview":"6mlEY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5nIw9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _badges = require("../Badges/Badges");
var _badgesDefault = parcelHelpers.interopDefault(_badges);
var _matchCaseStatus = require("../MatchCaseStatus/MatchCaseStatus");
var _matchCaseStatusDefault = parcelHelpers.interopDefault(_matchCaseStatus);
var _reviewCard = require("../ReviewCard/ReviewCard");
var _reviewCardDefault = parcelHelpers.interopDefault(_reviewCard);
const hasBadges = (review)=>Boolean(review.is_pep || review.is_sanctioned || review.negative_news || review.other);
const MatchReviewCard = (props)=>{
    const { review } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewCardDefault.default), {
        reviewStatus: review.is_match ? "warning" : undefined,
        reviewDate: review.created_dt,
        reviewedBy: review.reviewed_by,
        reviewHeader: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCaseStatusDefault.default), {
                    isResolved: true,
                    isConfirmed: review.is_match
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: review.is_match ? f("matches.review.approved") : f("matches.review.denied")
                }),
                hasBadges(review) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgesDefault.default), {
                    isPep: review.is_pep,
                    isSanctioned: review.is_sanctioned,
                    hasNegativeNews: review.negative_news,
                    isOther: review.other
                })
            ]
        }),
        reviewContent: review.description
    });
};
exports.default = MatchReviewCard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../Badges/Badges":"cI72s","../MatchCaseStatus/MatchCaseStatus":"4RV38","../ReviewCard/ReviewCard":"7p3dh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8iFfd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _fullWidthCheckbox = require("../FullWidthCheckbox/FullWidthCheckbox");
var _fullWidthCheckboxDefault = parcelHelpers.interopDefault(_fullWidthCheckbox);
var _fullWidthRadioButton = require("../FullWidthRadioButton/FullWidthRadioButton");
var _fullWidthRadioButtonDefault = parcelHelpers.interopDefault(_fullWidthRadioButton);
const DEFAULT_REVIEW = {
    is_match: false,
    is_pep: false,
    is_sanctioned: false,
    negative_news: false,
    other: false,
    description: ""
};
const MatchReviewForm = (props)=>{
    const { customerId, customerType, caseId, readonly, onClose, onAfterMatchReviewed } = props;
    const [review, setReview] = (0, _react.useState)({
        ...DEFAULT_REVIEW
    });
    const [isTouched, setIsTouched] = (0, _react.useState)(false);
    const f = (0, _useFormatMessageDefault.default)();
    const reset = ()=>{
        saveReviewMutation.reset();
        setReview({
            ...DEFAULT_REVIEW
        });
        setIsTouched(false);
        onClose && onClose();
    };
    const saveReviewMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).createMatchReview(customerId, caseId, review), {
        onSuccess: (confirmedReview)=>{
            setReview({
                ...review,
                description: ""
            });
            onAfterMatchReviewed(confirmedReview);
            onClose && onClose();
        }
    });
    const handleReviewChange = (key, value)=>{
        const updatedReview = {
            ...review,
            [key]: value
        };
        if (key === "is_match") {
            setIsTouched(true);
            if (!updatedReview.is_match) {
                updatedReview.is_pep = false;
                updatedReview.is_sanctioned = false;
                updatedReview.negative_news = false;
                updatedReview.other = false;
            }
        }
        setReview(updatedReview);
    };
    const disabled = readonly || saveReviewMutation.isLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "6",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                align: "space-evenly",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledRadioButton, {
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: f("default.confirm")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    children: customerType === "person" ? f("matches.button.confirm.match.description-person") : f("matches.button.confirm.match.description-company")
                                })
                            ]
                        }),
                        checked: isTouched && review.is_match,
                        id: "true",
                        name: "approve",
                        onChange: (_, newValue)=>handleReviewChange("is_match", newValue == "true"),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledRadioButton, {
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: f("default.reject")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    children: customerType === "person" ? f("matches.button.decline.match.description-person") : f("matches.button.decline.match.description-company")
                                })
                            ]
                        }),
                        id: "false",
                        name: "approve",
                        checked: isTouched && !review.is_match,
                        onChange: (_, newValue)=>{
                            document.getElementById("text")?.focus();
                            handleReviewChange("is_match", newValue == "true");
                        },
                        disabled: disabled
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "semibold",
                        children: f("matches.labels.details")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledFormLayout, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthCheckboxDefault.default), {
                                disabled: !review.is_match || disabled || customerType === "company",
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: f("matches.labels.pep")
                                }),
                                helpText: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: f("matches.labels.pep.helper-text")
                                }),
                                checked: review.is_pep,
                                onChange: (checked)=>handleReviewChange("is_pep", checked)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthCheckboxDefault.default), {
                                disabled: !review.is_match || disabled,
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: f("matches.labels.sanction")
                                }),
                                helpText: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: customerType === "person" ? f("matches.labels.sanction.helper-text-person") : f("matches.labels.sanction.helper-text-company")
                                }),
                                checked: review.is_sanctioned,
                                onChange: (checked)=>handleReviewChange("is_sanctioned", checked)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthCheckboxDefault.default), {
                                disabled: !review.is_match || disabled,
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: f("matches.labels.negative-news")
                                }),
                                checked: review.negative_news,
                                onChange: (checked)=>handleReviewChange("negative_news", checked),
                                helpText: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: customerType === "person" ? f("matches.labels.negative-news.helper-text-person") : f("matches.labels.negative-news.helper-text-company")
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullWidthCheckboxDefault.default), {
                                disabled: !review.is_match || disabled,
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    as: "span",
                                    fontWeight: "semibold",
                                    children: f("matches.labels.other")
                                }),
                                helpText: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: customerType === "person" ? f("matches.labels.other.helper-text-person") : f("matches.labels.other.helper-text-company")
                                }),
                                checked: review.other,
                                onChange: (checked)=>handleReviewChange("other", checked)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                value: review.description || "",
                onChange: (newValue)=>handleReviewChange("description", newValue),
                multiline: 4,
                id: "text",
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "semibold",
                    children: f("matches.labels.review.description")
                }),
                autoComplete: "off",
                disabled: disabled
            }),
            saveReviewMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: saveReviewMutation.error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "4",
                align: "end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                        onClick: ()=>reset(),
                        disabled: disabled,
                        children: f("default.cancel")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                        disabled: saveReviewMutation.isLoading || !isTouched || review.description === "" || readonly,
                        loading: saveReviewMutation.isLoading,
                        primary: true,
                        onClick: ()=>saveReviewMutation.mutate(),
                        children: f("default.save")
                    })
                ]
            })
        ]
    });
};
const StyledFormLayout = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-gap: var(--p-space-4);
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 15ch), 1fr));
`;
const StyledRadioButton = (0, _styledComponentsDefault.default)((0, _fullWidthRadioButtonDefault.default))`
  flex: 1;

  // do not make selected radio button font bold in order to make the description stay with regular font width
  & .Polaris-Choice__Label {
    font-weight: revert !important;
  }
`;
exports.default = MatchReviewForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../hooks/useFormatMessage":"8Y8fq","../ErrorPanel/ErrorPanel":"2hHqH","../FullWidthCheckbox/FullWidthCheckbox":"hSWFx","../FullWidthRadioButton/FullWidthRadioButton":"cK5m4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hSWFx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("../../constants/styles");
const FullWidthCheckbox = (props)=>{
    const { checked, disabled } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCheckboxWrapper, {
        checked: checked === "indeterminate" || checked === true,
        disabled: disabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
            ...props
        })
    });
};
const StyledCheckboxWrapper = (0, _styledComponentsDefault.default).span`
  border-radius: var(--p-border-radius-1);
  padding: var(--p-space-4);
  background-color: ${({ checked, disabled })=>checked && !disabled ? "var(--p-surface-selected)" : "var(--p-surface)"};
  border: var(--p-border-width-1) solid
    ${({ checked, disabled })=>checked && !disabled ? "var(--p-interactive)" : "var(--p-border-subdued)"};

  & .Polaris-Choice__Label {
    user-select: none;
  }

  & .Polaris-Choice__Descriptions {
    padding-left: var(--p-space-1);
  }

  width: 100%;

  // For small viewports - render button as a regular block element
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    padding: var(--p-space-2);
  }
`;
exports.default = FullWidthCheckbox;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/styles":"dZWds","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6iCv1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const MatchReviewSuccessToast = (props)=>{
    const { isApproved, customerId, nextMatch, onDismiss } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const navigateToNextMatch = ()=>{
        if (nextMatch && customerId) history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MATCH_CASE_DETAILS, {
            customerId,
            id: nextMatch.id
        }), history.location.state);
    };
    const content = isApproved ? f("matches.review.approved") : f("matches.review.denied");
    const action = nextMatch ? {
        content: f("matches.button.review-next-match"),
        onAction: navigateToNextMatch
    } : undefined;
    // when showing the action to show next match make the toast visible for a longer time period
    // values are in milliseconds
    const duration = nextMatch ? 15000 : 3000;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
        onDismiss: onDismiss,
        content: content,
        action: action,
        duration: duration
    });
};
exports.default = MatchReviewSuccessToast;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6mlEY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _pageAnchors = require("../../constants/page-anchors");
var _queriesKeys = require("../../constants/queries-keys");
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _utilities = require("../../types/utilities");
var _browserUtils = require("../../utils/browserUtils");
const useMatchReview = (customerId, customerType, id)=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).MATCH_DETAILS,
        customerId,
        id
    ]);
    const [resolvedReview, setResolvedReview] = (0, _react.useState)();
    const clearResolvedReview = (0, _react.useCallback)(()=>setResolvedReview(undefined), []);
    const onMatchReviewed = async (review)=>{
        setResolvedReview(review);
        // update the current match details page with the new review
        updateQueryData((queryData)=>{
            queryData.case.status = "RESOLVED";
            queryData.case.resolved_by = review.reviewed_by;
            queryData.case.reviews = [
                review,
                ...queryData.case.reviews
            ];
        });
        // invalidate the customer match cases query in order to get the latest matches
        await queryClient.invalidateQueries([
            (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_MATCH_CASES,
            customerId
        ]);
        // also invalidate the customer details page query in order to update the matches list
        await queryClient.invalidateQueries([
            (0, _utilities.getCustomerQueryKey)({
                id: customerId,
                type: customerType
            })
        ]);
        requestAnimationFrame(()=>(0, _browserUtils.scrollInPage)((0, _pageAnchors.PAGE_ANCHORS).REVIEWS_SECTION, {
                behavior: "smooth"
            }));
    };
    return {
        onMatchReviewed,
        resolvedReview,
        clearResolvedReview
    };
};
exports.default = useMatchReview;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../../constants/page-anchors":"4WmvA","../../constants/queries-keys":"6hYSF","../../hooks/useQueryData":"4laI9","../../types/utilities":"6zLpB","../../utils/browserUtils":"4ShiW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1Rt9K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _matchStatusConfirmedSvg = require("../../../assets/icons/match_status_confirmed.svg");
var _matchStatusConfirmedSvgDefault = parcelHelpers.interopDefault(_matchStatusConfirmedSvg);
var _matchStatusNewSvg = require("../../../assets/icons/match_status_new.svg");
var _matchStatusNewSvgDefault = parcelHelpers.interopDefault(_matchStatusNewSvg);
var _matchStatusRejectedSvg = require("../../../assets/icons/match_status_rejected.svg");
var _matchStatusRejectedSvgDefault = parcelHelpers.interopDefault(_matchStatusRejectedSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _customDate = require("../CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _matchImages = require("../MatchImages/MatchImages");
var _matchImagesDefault = parcelHelpers.interopDefault(_matchImages);
const MatchHeader = (props)=>{
    const { id, status, description, subjectName, matchEntityName, date, lastUpdateDate, avatarImages, isRDC } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const icon = status === "warning" ? (0, _matchStatusConfirmedSvgDefault.default) : status === "critical" ? (0, _matchStatusRejectedSvgDefault.default) : (0, _matchStatusNewSvgDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
                status: status,
                hideIcon: true,
                hideBorder: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    align: "space-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "4",
                                    align: "start",
                                    wrap: false,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            source: icon,
                                            width: "50px",
                                            height: "50px"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    fontWeight: "semibold",
                                                    children: description
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    variant: "headingLg",
                                                    as: "h1",
                                                    children: subjectName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "8",
                                    align: "start",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                            gap: "1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    children: f("match.basic-info.id")
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    fontWeight: "semibold",
                                                    children: id
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                            gap: "1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    children: f("match.basic-info.match-date")
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    fontWeight: "semibold",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                                        date: date
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                            gap: "1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    children: f("matches.labels.source")
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    fontWeight: "semibold",
                                                    children: isRDC ? "RDC" : "ComplyAdvantage"
                                                })
                                            ]
                                        }),
                                        lastUpdateDate && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                            gap: "1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    children: f("match.basic-info.last-updated")
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    fontWeight: "semibold",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                                                        date: lastUpdateDate
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchImagesDefault.default), {
                            entityName: matchEntityName,
                            avatarAttributes: avatarImages
                        })
                    ]
                })
            })
        })
    });
};
exports.default = MatchHeader;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../../assets/icons/match_status_confirmed.svg":"5NiXC","../../../assets/icons/match_status_new.svg":"ixMbA","../../../assets/icons/match_status_rejected.svg":"lMNlR","../../hooks/useFormatMessage":"8Y8fq","../CustomDate/CustomDate":"5KD00","../extensions/Icon":"eHSf0","../KDKBanner/KDKBanner":"3zPW6","../MatchImages/MatchImages":"9jAu9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5NiXC":[function(require,module,exports) {
module.exports = require("f7874994389bf754").getBundleURL("kEMsi") + "match_status_confirmed.d566b1b6.svg";

},{"f7874994389bf754":"75UoR"}],"ixMbA":[function(require,module,exports) {
module.exports = require("6a1c40e0d3c2a14d").getBundleURL("kEMsi") + "match_status_new.8d0fa3b2.svg";

},{"6a1c40e0d3c2a14d":"75UoR"}],"lMNlR":[function(require,module,exports) {
module.exports = require("6ffa152e78a7aa3e").getBundleURL("kEMsi") + "match_status_rejected.cc1f5501.svg";

},{"6ffa152e78a7aa3e":"75UoR"}],"9jAu9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _collectionUtils = require("../../utils/collectionUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const MatchImages = (props)=>{
    const { entityName, avatarAttributes } = props;
    const [selectedThumbnail, setSelectedThumbnail] = (0, _react.useState)();
    if (!avatarAttributes || avatarAttributes.length === 0) return null;
    const avatarAttribute = (0, _collectionUtils.first)(avatarAttributes);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                gap: "2",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    plain: true,
                    onClick: ()=>setSelectedThumbnail(avatarAttribute.value),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Thumbnail), {
                        source: avatarAttribute.value,
                        alt: avatarAttribute.description,
                        size: "large",
                        transparent: true
                    })
                })
            }),
            selectedThumbnail !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
                open: true,
                title: entityName,
                onClose: ()=>setSelectedThumbnail(undefined),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Scrollable), {
                                horizontal: true,
                                vertical: false,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                                    gap: "2",
                                    wrap: false,
                                    children: avatarAttributes.map((avatarImageAttribute, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledImageButton, {
                                            plain: true,
                                            onClick: ()=>setSelectedThumbnail(avatarImageAttribute.value),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Thumbnail), {
                                                source: avatarImageAttribute.value,
                                                alt: avatarImageAttribute.description,
                                                size: "large"
                                            }, index)
                                        }, index))
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledImage, {
                                src: selectedThumbnail
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const StyledImageButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  flex: 0 0 auto;
`;
const StyledImage = (0, _styledComponentsDefault.default).img`
  width: 100%;
`;
exports.default = MatchImages;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../utils/collectionUtils":"gr5mc","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6CUqn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _routes = require("../../constants/routes");
var _navigationHelpers = require("../../helpers/navigation.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _backButton = require("../BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
const MatchPageNavigation = (props)=>{
    const { matchData, matchCases } = props;
    const { customer_id: customerId, customer_type, customer_name } = matchData;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const matchPosition = matchCases.findIndex((matchCase)=>matchCase.id === matchData.case.id);
    const nextMatchCase = matchPosition > -1 && matchPosition < matchCases.length - 1 ? matchCases[matchPosition + 1] : undefined;
    const prevMatchCase = matchPosition > 0 ? matchCases[matchPosition - 1] : undefined;
    const hasNext = nextMatchCase !== undefined;
    const hasPrevious = prevMatchCase !== undefined;
    const onNext = ()=>history.replace((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MATCH_CASE_DETAILS, {
            customerId,
            id: nextMatchCase.id
        }), history.location.state);
    const onPrevious = ()=>history.replace((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).MATCH_CASE_DETAILS, {
            customerId,
            id: prevMatchCase.id
        }), history.location.state);
    const nextTooltip = nextMatchCase ? f("matches.navigation.tooltip", {
        summary: nextMatchCase.summary_text,
        name: nextMatchCase.subject_name
    }) : undefined;
    const previousTooltip = prevMatchCase ? f("matches.navigation.tooltip", {
        summary: prevMatchCase.summary_text,
        name: prevMatchCase.subject_name
    }) : undefined;
    const paginationProps = {
        hasNext,
        hasPrevious,
        onNext,
        onPrevious,
        nextTooltip,
        previousTooltip
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                url: (0, _navigationHelpers.getDetailsPageURL)(customerId, customer_type),
                displayLabel: customer_name,
                showAsLink: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                fill: true
            }),
            matchCases.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Pagination), {
                ...paginationProps
            })
        ]
    });
};
exports.default = MatchPageNavigation;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../constants/routes":"ihtm8","../../helpers/navigation.helpers":"adimP","../../hooks/useFormatMessage":"8Y8fq","../BackButton/BackButton":"4fa4k","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kmKaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useRDCMatch = require("../../hooks/useRDCMatch");
var _useRDCMatchDefault = parcelHelpers.interopDefault(_useRDCMatch);
var _matchDetailsComparisonSection = require("../MatchDetailsComparisonSection/MatchDetailsComparisonSection");
var _matchDetailsComparisonSectionDefault = parcelHelpers.interopDefault(_matchDetailsComparisonSection);
var _matchDetailsNegativeNewsSection = require("../MatchDetailsNegativeNewsSection/MatchDetailsNegativeNewsSection");
var _matchDetailsNegativeNewsSectionDefault = parcelHelpers.interopDefault(_matchDetailsNegativeNewsSection);
var _matchDetailsOtherSection = require("../MatchDetailsOtherSection/MatchDetailsOtherSection");
var _matchDetailsOtherSectionDefault = parcelHelpers.interopDefault(_matchDetailsOtherSection);
var _matchDetailsPEPSection = require("../MatchDetailsPEPSection/MatchDetailsPEPSection");
var _matchDetailsPEPSectionDefault = parcelHelpers.interopDefault(_matchDetailsPEPSection);
var _matchDetailsRelationsSection = require("../MatchDetailsRelationsSection/MatchDetailsRelationsSection");
var _matchDetailsRelationsSectionDefault = parcelHelpers.interopDefault(_matchDetailsRelationsSection);
var _matchDetailsSanctionsSection = require("../MatchDetailsSanctionsSection/MatchDetailsSanctionsSection");
var _matchDetailsSanctionsSectionDefault = parcelHelpers.interopDefault(_matchDetailsSanctionsSection);
var _matchKeyInformationSection = require("../MatchKeyInformationSection/MatchKeyInformationSection");
var _matchKeyInformationSectionDefault = parcelHelpers.interopDefault(_matchKeyInformationSection);
var _rdcmatchDetailsGeographicComparisonSection = require("../RDCMatchDetailsGeographicComparisonSection/RDCMatchDetailsGeographicComparisonSection");
var _rdcmatchDetailsGeographicComparisonSectionDefault = parcelHelpers.interopDefault(_rdcmatchDetailsGeographicComparisonSection);
const RDCMatch = (props)=>{
    const { matchDetails } = props;
    const { sanctionEvents, pepEvents, positions, hasNewInfo } = (0, _useRDCMatchDefault.default)(matchDetails);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsComparisonSectionDefault.default), {
                        matchDetails: matchDetails
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rdcmatchDetailsGeographicComparisonSectionDefault.default), {
                        matchDetails: matchDetails
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchKeyInformationSectionDefault.default), {
                matchDetails: matchDetails
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsRelationsSectionDefault.default), {
                        matchDetails: matchDetails
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsPEPSectionDefault.default), {
                        pepEvents: pepEvents,
                        positions: positions,
                        hasNewInfo: hasNewInfo
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsSanctionsSectionDefault.default), {
                        sanctionEvents: sanctionEvents,
                        hasNewInfo: hasNewInfo
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsNegativeNewsSectionDefault.default), {
                        matchDetails: matchDetails
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchDetailsOtherSectionDefault.default), {
                        matchDetails: matchDetails
                    })
                ]
            })
        ]
    });
};
exports.default = RDCMatch;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useRDCMatch":"16HRo","../MatchDetailsComparisonSection/MatchDetailsComparisonSection":"fGP6J","../MatchDetailsNegativeNewsSection/MatchDetailsNegativeNewsSection":"797BN","../MatchDetailsOtherSection/MatchDetailsOtherSection":"O8TuI","../MatchDetailsPEPSection/MatchDetailsPEPSection":"13GZJ","../MatchDetailsRelationsSection/MatchDetailsRelationsSection":"j4nWK","../MatchDetailsSanctionsSection/MatchDetailsSanctionsSection":"bSoQZ","../MatchKeyInformationSection/MatchKeyInformationSection":"hDi8D","../RDCMatchDetailsGeographicComparisonSection/RDCMatchDetailsGeographicComparisonSection":"dxxTx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dxxTx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _globeSvg = require("../../../assets/icons/globe.svg");
var _globeSvgDefault = parcelHelpers.interopDefault(_globeSvg);
var _matchSvg = require("../../../assets/icons/match.svg");
var _matchSvgDefault = parcelHelpers.interopDefault(_matchSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useRDCMatch = require("../../hooks/useRDCMatch");
var _useRDCMatchDefault = parcelHelpers.interopDefault(_useRDCMatch);
var _addressInfo = require("../AddressInfo/AddressInfo");
var _addressInfoDefault = parcelHelpers.interopDefault(_addressInfo);
var _comparisonTable = require("../ComparisonTable/ComparisonTable");
var _comparisonTableDefault = parcelHelpers.interopDefault(_comparisonTable);
var _comparisonTableHelpers = require("../ComparisonTable/ComparisonTable.helpers");
var _comparisonTableHeader = require("../ComparisonTable/ComparisonTableHeader");
var _comparisonTableHeaderDefault = parcelHelpers.interopDefault(_comparisonTableHeader);
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _matchAddressInfo = require("../MatchAddressInfo/MatchAddressInfo");
var _matchAddressInfoDefault = parcelHelpers.interopDefault(_matchAddressInfo);
const RDCMatchDetailsGeographicComparisonSection = (props)=>{
    const { matchDetails } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { match, subjectAddresses, addresses, nationalities, citizenships, countries_of_incorporations, isSubjectPerson, hasNewInfo } = (0, _useRDCMatchDefault.default)(matchDetails);
    const subject = match.subject;
    const areAddressesOnlyCountries = match.addresses.every((address)=>[
            address.addr1,
            address.addr2,
            address.city,
            address.state_prov
        ].filter(Boolean).length === 0);
    const rows = [
        (0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.address"), subjectAddresses.map((address)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                address: address,
                shortCountryName: true
            })), addresses, (address)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchAddressInfoDefault.default), {
                address: address
            }), hasNewInfo, areAddressesOnlyCountries)
    ];
    if (isSubjectPerson(subject)) rows.push((0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.citizenship"), /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
        country: subject.country_of_citizenship,
        shortName: true
    }), citizenships, (attribute)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
            country: attribute?.value,
            shortName: true
        }), hasNewInfo), (0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.national-id-country"), /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
        country: subject.national_id_country,
        shortName: true
    }), nationalities, (attribute)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
            country: attribute?.value,
            shortName: true
        }), hasNewInfo));
    else (0, _comparisonTableHelpers.createComparisonTableEntry)(f("common.labels.country"), /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
        country: subject.country,
        shortName: true
    }), countries_of_incorporations, (attribute)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
            country: attribute?.value,
            shortName: true
        }), hasNewInfo);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableDefault.default), {
            headings: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableHeaderDefault.default), {
                    icon: (0, _globeSvgDefault.default),
                    label: f("matches.titles.geographic-affiliation")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comparisonTableHeaderDefault.default), {
                    icon: (0, _matchSvgDefault.default),
                    label: f("matches.titles.data-source")
                })
            ],
            rows: rows
        })
    });
};
exports.default = RDCMatchDetailsGeographicComparisonSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/globe.svg":"kv6Wl","../../../assets/icons/match.svg":"esK8q","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useRDCMatch":"16HRo","../AddressInfo/AddressInfo":"9YtjF","../ComparisonTable/ComparisonTable":"1Nv4g","../ComparisonTable/ComparisonTable.helpers":"36taR","../ComparisonTable/ComparisonTableHeader":"d3kWG","../Country/Country":"eeWSc","../MatchAddressInfo/MatchAddressInfo":"60EMZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7uHQs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _attachmentsSection = require("../../components/AttachmentsSection/AttachmentsSection");
var _attachmentsSectionDefault = parcelHelpers.interopDefault(_attachmentsSection);
var _companyDisclosureAssignmentSelector = require("../../components/CompanyDisclosureAssignmentSelector/CompanyDisclosureAssignmentSelector");
var _companyDisclosureAssignmentSelectorDefault = parcelHelpers.interopDefault(_companyDisclosureAssignmentSelector);
var _customerUploadDocumentButton = require("../../components/CustomerUploadDocumentButton/CustomerUploadDocumentButton");
var _customerUploadDocumentButtonDefault = parcelHelpers.interopDefault(_customerUploadDocumentButton);
var _emptyAssignmentBanner = require("../../components/EmptyAssignmentBanner/EmptyAssignmentBanner");
var _emptyAssignmentBannerDefault = parcelHelpers.interopDefault(_emptyAssignmentBanner);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _onboardingWizardPageSkeleton = require("../../components/OnboardingWizardPageSkeleton/OnboardingWizardPageSkeleton");
var _onboardingWizardPageSkeletonDefault = parcelHelpers.interopDefault(_onboardingWizardPageSkeleton);
var _queriesKeys = require("../../constants/queries-keys");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _attachments = require("../../helpers/attachments");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _useDisclosureAssignment = require("../../hooks/useDisclosureAssignment");
var _useDisclosureAssignmentDefault = parcelHelpers.interopDefault(_useDisclosureAssignment);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useNavigationToolbar = require("../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _collectionUtils = require("../../utils/collectionUtils");
const OnboardingCompanyAssignmentsPage = ({ data })=>{
    const { id } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { onboardingStepIndex, goToStep } = (0, _useNavigationToolbarDefault.default)();
    const { setQueryData: setOnboardingDisclosuresQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_DISCLOSURES,
        id
    ]);
    const [signatureConfiguration, companyDetails] = data;
    const updateCustomerQueryData = (0, _useQueryData.useCustomerDetailsQueryData)(companyDetails || {
        id,
        type: "company"
    });
    const [uploadingFilesCount, setUploadingFilesCount] = (0, _react.useState)(0);
    const assignmentId = signatureConfiguration.assignment_id;
    const assignments = companyDetails?.assignments?.filter((0, _assignmentsHelpers.isActiveAssignment));
    const { selectedAssignment, setSelectedAssignment, shouldUpdateAssignment, updateAssignmentMutation } = (0, _useDisclosureAssignmentDefault.default)(id, assignmentId, assignments);
    const updateSignaturesMutation = (0, _reactQuery.useMutation)(async ()=>{
        let assignmentId = selectedAssignment?.id;
        if (shouldUpdateAssignment) {
            const savedAssignment = await updateAssignmentMutation.mutateAsync();
            assignmentId = savedAssignment.id;
        }
        return (0, _apiDefault.default).updateCompanySignatureConfiguration(id, {
            signature_required: signatureConfiguration.signatures.length > 0,
            signatures: signatureConfiguration.signatures?.map((0, _onboardingHelpers.convertSignatureToCompanyRoleSignatureConfiguration)),
            assignment_id: assignmentId
        });
    }, {
        onSuccess: (response)=>{
            setOnboardingDisclosuresQueryData([
                response,
                companyDetails
            ]);
            // Navigate to the next company onboarding step
            goToStep(onboardingStepIndex + 1);
        }
    });
    const addNewAssignment = (assignment)=>{
        updateCustomerQueryData((prevData)=>prevData.assignments = prevData.assignments ? [
                assignment,
                ...prevData.assignments
            ] : [
                assignment
            ]);
        // also update the onboarding wizard query cache
        companyDetails.assignments = companyDetails.assignments ? [
            assignment,
            ...companyDetails.assignments
        ] : [
            assignment
        ];
        setOnboardingDisclosuresQueryData([
            signatureConfiguration,
            companyDetails
        ]);
        setSelectedAssignment(assignment);
    };
    const updateAssignment = ()=>updateSignaturesMutation.mutate();
    const disabled = updateSignaturesMutation.isLoading || uploadingFilesCount > 0;
    const pageTitle = features.ATTACHMENTS ? f("onboarding.assignments-and-attachments.title") : f("onboarding.assignments.title");
    const pageDescription = features.ATTACHMENTS ? f("onboarding.assignments-and-attachments.description") : f("onboarding.assignments.description");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: pageTitle,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: pageDescription
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: (0, _collectionUtils.hasContent)(assignments) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyDisclosureAssignmentSelectorDefault.default), {
                            assignments: assignments,
                            selectedAssignment: selectedAssignment,
                            setSelectedAssignment: setSelectedAssignment,
                            readonly: updateSignaturesMutation.isLoading
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyAssignmentBannerDefault.default), {
                            customerId: companyDetails.id,
                            onSave: addNewAssignment
                        })
                    })
                }),
                features.ATTACHMENTS && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                align: "space-between",
                                blockAlign: "start",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "h5",
                                        fontWeight: "bold",
                                        children: f("attachments.section.title")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledUploadButton, {
                                        entity: companyDetails,
                                        assignments: assignments,
                                        selectedAssignmentId: selectedAssignment?.id,
                                        onFileUploadingStart: (filesCount)=>setUploadingFilesCount(filesCount),
                                        onFileUploadingFinish: ()=>setUploadingFilesCount(0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentsSectionDefault.default), {
                                entity: companyDetails,
                                uploadingFilesCount: uploadingFilesCount,
                                hideTitle: true,
                                hideSignatures: true,
                                hideEmptyState: true,
                                filterAttachment: (0, _attachments.isActiveAttachment)
                            })
                        ]
                    })
                }),
                updateSignaturesMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: updateSignaturesMutation.error
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            disabled: disabled,
                            onClick: ()=>goToStep(onboardingStepIndex - 1),
                            children: f("button.go.back")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            disabled: disabled,
                            onClick: ()=>goToStep(onboardingStepIndex + 1),
                            children: f("common.buttons.actions.skip-step")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            primary: true,
                            disabled: uploadingFilesCount > 0,
                            loading: updateSignaturesMutation.isLoading,
                            onClick: updateAssignment,
                            children: f("button.go.next")
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(OnboardingCompanyAssignmentsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_DISCLOSURES,
    apiFunction: (id, options)=>Promise.all([
            (0, _apiDefault.default).getCompanySignatureConfiguration(id, options),
            (0, _apiDefault.default).getCompanyCustomerDetails(id, options)
        ]),
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingWizardPageSkeletonDefault.default), {})
});
const StyledUploadButton = (0, _styledComponentsDefault.default)((0, _customerUploadDocumentButtonDefault.default))`
  position: revert;
`;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/AttachmentsSection/AttachmentsSection":"1J3Nq","../../components/CompanyDisclosureAssignmentSelector/CompanyDisclosureAssignmentSelector":"63l2t","../../components/CustomerUploadDocumentButton/CustomerUploadDocumentButton":"iVpsA","../../components/EmptyAssignmentBanner/EmptyAssignmentBanner":"gBcjC","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/OnboardingWizardPageSkeleton/OnboardingWizardPageSkeleton":"hlp5z","../../constants/queries-keys":"6hYSF","../../helpers/assignments.helpers":"7t8rY","../../helpers/attachments":"6o6Ej","../../helpers/onboarding.helpers":"fMYah","../../hooks/useDisclosureAssignment":"0tZFn","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useNavigationToolbar":"gd2EG","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gBcjC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _assignmentModal = require("../AssignmentModal/AssignmentModal");
var _assignmentModalDefault = parcelHelpers.interopDefault(_assignmentModal);
const EmptyAssignmentBanner = (props)=>{
    const { onSave, ...assignmentModalProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showModal, toggleShowModal, closeModal] = (0, _useOpenCloseDefault.default)();
    const handleSave = (assignment, isNew)=>{
        closeModal();
        onSave(assignment, isNew);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                align: "space-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "p",
                        variant: "headingSm",
                        fontWeight: "bold",
                        children: f("common.labels.include-assignment")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                        onClick: toggleShowModal,
                        children: f("common.buttons.actions.create-assignment")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            showModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentModalDefault.default), {
                onCancel: closeModal,
                onSave: handleSave,
                ...assignmentModalProps
            })
        ]
    });
};
exports.default = EmptyAssignmentBanner;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../AddButton/AddButton":"WJGEt","../AssignmentModal/AssignmentModal":"bVFci","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gd2EG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../constants/routes");
const useNavigationToolbar = ()=>{
    const history = (0, _reactRouterDom.useHistory)();
    const path = history.location.pathname;
    const matchOnboardingCompanyWizard = (0, _reactRouterDom.matchPath)(path, {
        path: (0, _routes.ONBOARDING_COMPANY_WIZARD_ROUTES)
    });
    const matchOnboardingManualCompanyWizard = (0, _reactRouterDom.matchPath)(path, {
        path: (0, _routes.ONBOARDING_MANUAL_COMPANY_WIZARD_ROUTES)
    });
    const matchOnboardingPerson = (0, _reactRouterDom.matchPath)(path, {
        path: (0, _routes.ONBOARDING_PERSON_ROUTES)
    });
    let onboardingType;
    let onboardingStepIndex = -1;
    if (matchOnboardingPerson) {
        onboardingType = "person";
        onboardingStepIndex = 0;
    } else if (matchOnboardingManualCompanyWizard) {
        onboardingType = "manual-company-wizard";
        onboardingStepIndex = (0, _routes.ONBOARDING_MANUAL_COMPANY_WIZARD_ROUTES).findIndex((route)=>(0, _reactRouterDom.matchPath)(path, route));
    } else if (matchOnboardingCompanyWizard) {
        onboardingType = "company-wizard";
        onboardingStepIndex = (0, _routes.ONBOARDING_COMPANY_WIZARD_ROUTES).findIndex((route)=>(0, _reactRouterDom.matchPath)(path, route));
    }
    const goToStep = (stepIndex)=>{
        const steps = onboardingType === "company-wizard" ? (0, _routes.ONBOARDING_COMPANY_WIZARD_ROUTES) : onboardingType === "manual-company-wizard" ? (0, _routes.ONBOARDING_MANUAL_COMPANY_WIZARD_ROUTES) : [];
        if (stepIndex < 0 || stepIndex >= steps.length) throw new Error(`stepIndex must be between 0 and ${steps.length - 1}`);
        const route = steps[stepIndex];
        const pathname = (0, _reactRouterDom.generatePath)(route, {
            id
        });
        history.push(pathname);
    };
    const id = matchOnboardingPerson?.params?.id || matchOnboardingCompanyWizard?.params.id || matchOnboardingManualCompanyWizard?.params.id;
    const isManualCompany = onboardingType === "manual-company-wizard";
    return {
        id,
        onboardingType,
        isManualCompany,
        onboardingStepIndex,
        goToStep
    };
};
exports.default = useNavigationToolbar;

},{"react-router-dom":"1ee65","../constants/routes":"ihtm8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"goxpF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _companyDisclosureSignatureForm = require("../../components/CompanyDisclosureSignatureForm/CompanyDisclosureSignatureForm");
var _companyDisclosureSignatureFormDefault = parcelHelpers.interopDefault(_companyDisclosureSignatureForm);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _onboardingWizardPageSkeleton = require("../../components/OnboardingWizardPageSkeleton/OnboardingWizardPageSkeleton");
var _onboardingWizardPageSkeletonDefault = parcelHelpers.interopDefault(_onboardingWizardPageSkeleton);
var _queriesKeys = require("../../constants/queries-keys");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _useAttachmentsAPI = require("../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _useDisclosureAssignment = require("../../hooks/useDisclosureAssignment");
var _useDisclosureAssignmentDefault = parcelHelpers.interopDefault(_useDisclosureAssignment);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useNavigationToolbar = require("../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const OnboardingCompanyDisclosuresPage = ({ data })=>{
    const { id } = (0, _reactRouterDom.useParams)();
    const [signatureConfiguration, companyDetails] = data;
    const f = (0, _useFormatMessageDefault.default)();
    const { onboardingStepIndex, goToStep } = (0, _useNavigationToolbarDefault.default)();
    const { setQueryData: setOnboardingDisclosuresQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_DISCLOSURES,
        id
    ]);
    const { updateQueryData: updateCompanyCustomerDetailsQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_SUMMARY,
        id
    ]);
    const [signatures, setSignatures] = (0, _react.useState)(new Map());
    const [isFormValid, setFormValid] = (0, _react.useState)(false);
    const assignments = companyDetails?.assignments?.filter((0, _assignmentsHelpers.isActiveAssignment));
    const assignmentId = signatureConfiguration.assignment_id;
    const { selectedAssignment, setSelectedAssignment, shouldUpdateAssignment, updateAssignmentMutation } = (0, _useDisclosureAssignmentDefault.default)(id, assignmentId, assignments);
    const { entityId, getAttachments } = (0, _useAttachmentsAPIDefault.default)(selectedAssignment ? {
        ...selectedAssignment,
        customer_id: id
    } : companyDetails);
    const attachmentsQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
        entityId
    ];
    const { data: attachmentsList } = (0, _reactQuery.useQuery)(attachmentsQueryKey, ()=>getAttachments(entityId));
    const updateSignaturesMutation = (0, _reactQuery.useMutation)(async ()=>{
        const signaturesArray = [
            ...signatures.values()
        ];
        if (shouldUpdateAssignment) await updateAssignmentMutation.mutateAsync();
        return (0, _apiDefault.default).updateCompanySignatureConfiguration(id, {
            signature_required: signaturesArray.length > 0,
            signatures: signaturesArray,
            assignment_id: selectedAssignment?.id
        });
    }, {
        onSuccess: (response)=>{
            onSignatureConfigurationUpdated(response);
        }
    });
    const onSignatureConfigurationUpdated = (response)=>{
        // Update the current data with the response of api.updateCompanySignatureConfiguration
        setOnboardingDisclosuresQueryData([
            response,
            companyDetails
        ]);
        // Update the company onboarding summary data
        updateCompanyCustomerDetailsQueryData((queryData)=>{
            queryData.disclosure_documents[0] = {
                ...queryData.disclosure_documents[0],
                signature_required: response.signatures.length > 0,
                signatures: response.signatures
            };
        });
        // Navigate to the next company onboarding summary step
        goToStep(onboardingStepIndex + 1);
    };
    const skipSignatureStepMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updateCompanySignatureConfiguration(id, {
            signature_required: false
        }), {
        onSuccess: (response)=>onSignatureConfigurationUpdated(response)
    });
    const sendSignatures = ()=>updateSignaturesMutation.mutate();
    (0, _react.useEffect)(()=>{
        const updatedSignaturesMap = new Map(signatureConfiguration.signatures.map((signature)=>[
                signature.role_id,
                (0, _onboardingHelpers.convertSignatureToCompanyRoleSignatureConfiguration)(signature)
            ]));
        setSignatures(updatedSignaturesMap);
    }, [
        data
    ]);
    const isMutating = skipSignatureStepMutation.isLoading || updateSignaturesMutation.isLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("onboarding.disclosures.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: f("onboarding.disclosures.company-description")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyDisclosureSignatureFormDefault.default), {
                    companyDetails: companyDetails,
                    companySignatureConfiguration: signatureConfiguration,
                    signaturesByRoleId: signatures,
                    readonly: updateSignaturesMutation.isLoading,
                    onChange: (signatures, isValid)=>{
                        setSignatures(signatures);
                        setFormValid(isValid);
                    },
                    assignments: assignments,
                    selectedAssignment: selectedAssignment,
                    setSelectedAssignment: setSelectedAssignment,
                    attachments: attachmentsList?.attachment_list
                }),
                (updateSignaturesMutation.isError || skipSignatureStepMutation.isError) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: updateSignaturesMutation.error || skipSignatureStepMutation.error
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            disabled: isMutating,
                            onClick: ()=>goToStep(onboardingStepIndex - 1),
                            children: f("button.go.back")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            disabled: isMutating,
                            loading: skipSignatureStepMutation.isLoading,
                            onClick: ()=>skipSignatureStepMutation.mutate(),
                            children: f("common.buttons.actions.skip-step")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            primary: true,
                            disabled: isMutating || !isFormValid,
                            loading: updateSignaturesMutation.isLoading,
                            onClick: sendSignatures,
                            children: f("button.go.next")
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(OnboardingCompanyDisclosuresPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_DISCLOSURES,
    apiFunction: (id, options)=>Promise.all([
            (0, _apiDefault.default).getCompanySignatureConfiguration(id, options),
            (0, _apiDefault.default).getCompanyCustomerDetails(id, options)
        ]),
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingWizardPageSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/CompanyDisclosureSignatureForm/CompanyDisclosureSignatureForm":"7prlj","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/OnboardingWizardPageSkeleton/OnboardingWizardPageSkeleton":"hlp5z","../../constants/queries-keys":"6hYSF","../../helpers/assignments.helpers":"7t8rY","../../helpers/onboarding.helpers":"fMYah","../../hooks/useAttachmentsAPI":"7xA5e","../../hooks/useDisclosureAssignment":"0tZFn","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useNavigationToolbar":"gd2EG","../../hooks/useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7a3cj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _routes = require("../../constants/routes");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _companyLookupResultConfirm = require("./CompanyLookupResultConfirm/CompanyLookupResultConfirm");
var _companyLookupResultConfirmDefault = parcelHelpers.interopDefault(_companyLookupResultConfirm);
const NotFound = ({ id })=>{
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const lookupPath = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_LOOKUP);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "headingXl",
                    as: "p",
                    children: f("lookup.error.company.not.found", {
                        orgId: id
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    primary: true,
                    onClick: ()=>history.push(lookupPath),
                    children: f("lookup.again")
                })
            ]
        })
    });
};
const OnboardingCompanyLookupResultPage = ()=>{
    const { orgId } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const { data, isLoading, isError } = (0, _reactQuery.useQuery)([
        "search",
        orgId
    ], ()=>(0, _apiDefault.default).getCompanyInfo("NO", (0, _onboardingHelpers.stripOrgId)(orgId)));
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "headingLg",
                    as: "p",
                    children: f("in.progress")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ProgressBar), {
                    progress: 70,
                    size: "small"
                })
            ]
        })
    });
    if (isError || !data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotFound, {
        id: orgId
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyLookupResultConfirmDefault.default), {
        lookupInfo: data.basic_legal_entity_info
    });
};
exports.default = OnboardingCompanyLookupResultPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/routes":"ihtm8","../../helpers/onboarding.helpers":"fMYah","../../hooks/useFormatMessage":"8Y8fq","./CompanyLookupResultConfirm/CompanyLookupResultConfirm":"2rSMD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2rSMD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addressInfo = require("../../../components/AddressInfo/AddressInfo");
var _addressInfoDefault = parcelHelpers.interopDefault(_addressInfo);
var _displayName = require("../../../components/DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _errorPanel = require("../../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _industryRisk = require("../../../components/IndustryRisk/IndustryRisk");
var _industryRiskDefault = parcelHelpers.interopDefault(_industryRisk);
var _countries = require("../../../constants/countries");
var _routes = require("../../../constants/routes");
var _errorsHelpers = require("../../../helpers/errors.helpers");
var _navigationHelpers = require("../../../helpers/navigation.helpers");
var _onboardingHelpers = require("../../../helpers/onboarding.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _disabledOnboardingWarning = require("./DisabledOnboardingWarning");
var _disabledOnboardingWarningDefault = parcelHelpers.interopDefault(_disabledOnboardingWarning);
const CompanyLookupResultConfirm = (props)=>{
    const { lookupInfo } = props;
    const { national_id, name, business_address, mailing_address, legal_entity_type, risk_information } = lookupInfo;
    const history = (0, _reactRouterDom.useHistory)();
    const f = (0, _useFormatMessageDefault.default)();
    const createCompanyMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).createCompanyCustomer({
            national_id: `${national_id}`,
            country: (0, _countries.DEFAULT_COUNTRY),
            name,
            project_id: createdFromProject?.id
        }), {
        onSuccess: (response)=>{
            history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_ONBOARDING_SCREENING, {
                id: response.id
            }));
        }
    });
    const createdFromProject = history.location.state?.createdFromProject;
    const isOnboardingDisabled = (0, _onboardingHelpers.isCompanyOnboardingDisabled)(lookupInfo);
    const description = legal_entity_type.description_nb || legal_entity_type.description_en;
    if (createCompanyMutation.isError && (0, _errorsHelpers.isConflictError)(createCompanyMutation.error)) {
        // Conflict - company customer already exists. Redirect to company customer
        const existingCustomerId = createCompanyMutation.error.data?.id;
        const onboardingStatus = createCompanyMutation.error.data?.onboarding_status;
        if (existingCustomerId) history.push((0, _navigationHelpers.getCompanyPath)(existingCustomerId, onboardingStatus));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("lookup.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                                    strong: true,
                                    name: name,
                                    type: "company"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            variant: "bodyMd",
                                            as: "span",
                                            color: "subdued",
                                            children: f("company.details.caption.national_id")
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: national_id
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            variant: "bodyMd",
                                            as: "span",
                                            color: "subdued",
                                            children: f("company.details.caption.company.type")
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                legal_entity_type.code,
                                                " ",
                                                description && `(${description})`
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            variant: "bodyMd",
                                            as: "span",
                                            color: "subdued",
                                            children: f("company.details.caption.address")
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                                                address: business_address
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            variant: "bodyMd",
                                            as: "span",
                                            color: "subdued",
                                            children: f("company.details.caption.address.postal")
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                                                address: mailing_address
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryRiskDefault.default), {
                                    industryRisk: risk_information,
                                    title: f("company.details.caption.industry-codes"),
                                    showAllIndustryTypes: true
                                })
                            ]
                        })
                    })
                }),
                isOnboardingDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disabledOnboardingWarningDefault.default), {
                    lookupInfo: lookupInfo
                }),
                createCompanyMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: createCompanyMutation.error
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            onClick: ()=>{
                                const redirectURLAfterClose = createdFromProject ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
                                    id: createdFromProject.id
                                }) : (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMERS);
                                history.push(redirectURLAfterClose);
                            },
                            children: f("default.cancel")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            onClick: ()=>history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_LOOKUP), {
                                    createdFromProject
                                }),
                            children: f("lookup.again")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            primary: true,
                            loading: createCompanyMutation.isLoading,
                            disabled: createCompanyMutation.isLoading || isOnboardingDisabled,
                            onClick: ()=>createCompanyMutation.mutate(),
                            children: f("lookup.correct.customer")
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = CompanyLookupResultConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../api":"f6lXD","../../../components/AddressInfo/AddressInfo":"9YtjF","../../../components/DisplayName/DisplayName":"gKd5g","../../../components/ErrorPanel/ErrorPanel":"2hHqH","../../../components/extensions/Button":"8exc0","../../../components/IndustryRisk/IndustryRisk":"6aep9","../../../constants/countries":"2hBLK","../../../constants/routes":"ihtm8","../../../helpers/errors.helpers":"9SYBd","../../../helpers/navigation.helpers":"adimP","../../../helpers/onboarding.helpers":"fMYah","../../../hooks/useFormatMessage":"8Y8fq","./DisabledOnboardingWarning":"axbxz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"axbxz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetOnboardingWarnings = require("../../../hooks/useGetOnboardingWarnings");
var _useGetOnboardingWarningsDefault = parcelHelpers.interopDefault(_useGetOnboardingWarnings);
const DisabledOnboardingWarning = (props)=>{
    const { lookupInfo } = props;
    const getOnboardingWarnings = (0, _useGetOnboardingWarningsDefault.default)();
    const warnings = getOnboardingWarnings(lookupInfo);
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "critical",
        title: f("lookup.error.title"),
        children: warnings.map((warning)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: warning
            }, warning))
    });
};
exports.default = DisabledOnboardingWarning;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useGetOnboardingWarnings":"hAu55","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4ekKK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _companyCustomerForm = require("../../components/CompanyCustomerForm/CompanyCustomerForm");
var _companyCustomerFormDefault = parcelHelpers.interopDefault(_companyCustomerForm);
var _kdktabs = require("../../components/KDKTabs/KDKTabs");
var _kdktabsDefault = parcelHelpers.interopDefault(_kdktabs);
var _integrations = require("../../constants/integrations");
var _routes = require("../../constants/routes");
var _useDefaultCountry = require("../../hooks/useDefaultCountry");
var _useDefaultCountryDefault = parcelHelpers.interopDefault(_useDefaultCountry);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _companyLookupForm = require("./CompanyLookupForm");
var _companyLookupFormDefault = parcelHelpers.interopDefault(_companyLookupForm);
var _onboardingCompanyPageHelpers = require("./OnboardingCompanyPage.helpers");
const OnboardingCompanyPage = ()=>{
    const history = (0, _reactRouterDom.useHistory)();
    const f = (0, _useFormatMessageDefault.default)();
    const defaultCountry = (0, _useDefaultCountryDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const createdFromProject = location.state?.createdFromProject;
    const companyCountryOptions = [
        ...(0, _integrations.COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS).map((countryCode)=>({
                id: countryCode,
                content: f(`new-company-customer.country-options.${countryCode.toLowerCase()}`)
            })),
        {
            id: "other",
            content: f("new-company-customer.country-options.other")
        }
    ];
    const [companyCountry, setCompanyCountry] = (0, _react.useState)(defaultCountry);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktabsDefault.default), {
                tabs: companyCountryOptions,
                selected: companyCountryOptions.findIndex((t)=>t.id === companyCountry),
                onSelect: (i)=>setCompanyCountry(companyCountryOptions[i].id)
            }),
            (0, _onboardingCompanyPageHelpers.hasIntegration)(companyCountry) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
                title: f("new-company-customer.titles.norwegian"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyLookupFormDefault.default), {
                    projectId: createdFromProject?.id,
                    projectName: createdFromProject?.name
                })
            }),
            !(0, _onboardingCompanyPageHelpers.hasIntegration)(companyCountry) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
                title: f("new-company-customer.titles.manual"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "bodyMd",
                            as: "span",
                            children: f("new-company-customer.texts.manual")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyCustomerFormDefault.default), {
                            projectId: createdFromProject?.id,
                            projectName: createdFromProject?.name,
                            onAfterSubmit: (createdCompanyCustomer)=>{
                                history.push((0, _reactRouter.generatePath)((0, _routes.ROUTES).MANUAL_COMPANY_ONBOARDING_SCREENING, {
                                    id: createdCompanyCustomer.id
                                }));
                            }
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = OnboardingCompanyPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router":"5RYYS","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../components/CompanyCustomerForm/CompanyCustomerForm":"2nMmk","../../components/KDKTabs/KDKTabs":"hryzj","../../constants/integrations":"kD3Sk","../../constants/routes":"ihtm8","../../hooks/useDefaultCountry":"9Xjpj","../../hooks/useFormatMessage":"8Y8fq","./CompanyLookupForm":"f0uwa","./OnboardingCompanyPage.helpers":"1KaYM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f0uwa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _companyDetails = require("../../constants/company-details");
var _routes = require("../../constants/routes");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CompanyLookupForm = (props)=>{
    const { projectId, projectName } = props;
    const history = (0, _reactRouterDom.useHistory)();
    const f = (0, _useFormatMessageDefault.default)();
    const [value, setValue] = (0, _react.useState)("");
    const [error, setError] = (0, _react.useState)();
    const createdFromProject = projectId && projectName ? {
        id: projectId,
        name: projectName
    } : undefined;
    const handleChange = (newValue)=>{
        if (!(0, _companyDetails.NORWEGIAN_COMPANY_NATIONAL_ID_REGEX).test(newValue)) setError(f("lookup.error.wrong.orgid"));
        else setError(undefined);
        setValue(newValue);
    };
    const handleChoiceKeyDown = (event)=>{
        if (event.key === "Enter" && value && !error) {
            event.preventDefault();
            submit();
        }
    };
    const submit = ()=>{
        const lookupPath = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_LOOKUP_RESULT, {
            orgId: (0, _onboardingHelpers.stripOrgId)(value)
        });
        history.push(lookupPath, {
            createdFromProject
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "bodyMd",
                as: "span",
                children: f("lookup.search.title")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                onKeyDown: handleChoiceKeyDown,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                    id: "lookup-input",
                    autoFocus: true,
                    onChange: handleChange,
                    value: value,
                    placeholder: f("lookup.input.placeholder"),
                    label: f("lookup.search.title"),
                    labelHidden: true,
                    autoComplete: "off"
                })
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: error,
                fieldID: "lookup-input"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                gap: "4",
                align: "end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    primary: true,
                    disabled: !value || Boolean(error),
                    onClick: submit,
                    children: f("lookup.button.search")
                })
            })
        ]
    });
};
exports.default = CompanyLookupForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../constants/company-details":"2I1G6","../../constants/routes":"ihtm8","../../helpers/onboarding.helpers":"fMYah","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1KaYM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasIntegration", ()=>hasIntegration);
var _integrations = require("../../constants/integrations");
const hasIntegration = (country)=>country ? (0, _integrations.COUNTRIES_WITH_COMPANY_REGISTER_INTEGRATIONS).includes(country) : false;

},{"../../constants/integrations":"kD3Sk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3iLrz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _infoBox = require("../../components/InfoBox/InfoBox");
var _infoBoxDefault = parcelHelpers.interopDefault(_infoBox);
var _ownersCard = require("../../components/OwnersCard/OwnersCard");
var _ownersCardDefault = parcelHelpers.interopDefault(_ownersCard);
var _rolesCard = require("../../components/RolesCard/RolesCard");
var _rolesCardDefault = parcelHelpers.interopDefault(_rolesCard);
var _screeningEmptyState = require("../../components/ScreeningEmptyState/ScreeningEmptyState");
var _screeningEmptyStateDefault = parcelHelpers.interopDefault(_screeningEmptyState);
var _screeningSkeleton = require("../../components/ScreeningSkeleton/ScreeningSkeleton");
var _screeningSkeletonDefault = parcelHelpers.interopDefault(_screeningSkeleton);
var _screeningTypeCard = require("../../components/ScreeningTypeCard/ScreeningTypeCard");
var _screeningTypeCardDefault = parcelHelpers.interopDefault(_screeningTypeCard);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _queriesKeys = require("../../constants/queries-keys");
var _customerHelpers = require("../../helpers/customer.helpers");
var _ownersHelpers = require("../../helpers/owners.helpers");
var _personHelpers = require("../../helpers/person.helpers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetCompanyScreeningConfiguration = require("../../hooks/useGetCompanyScreeningConfiguration");
var _useGetCompanyScreeningConfigurationDefault = parcelHelpers.interopDefault(_useGetCompanyScreeningConfiguration);
var _useGetOnboardingConfiguration = require("../../hooks/useGetOnboardingConfiguration");
var _useGetOnboardingConfigurationDefault = parcelHelpers.interopDefault(_useGetOnboardingConfiguration);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _useNavigationToolbar = require("../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
var _errorPage = require("../ErrorPage");
var _errorPageDefault = parcelHelpers.interopDefault(_errorPage);
var _companyDetailsCard = require("./CompanyDetailsCard");
var _companyDetailsCardDefault = parcelHelpers.interopDefault(_companyDetailsCard);
const OnboardingCompanyScreeningPage = ()=>{
    const { id: customerId } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const { onboardingStepIndex, goToStep } = (0, _useNavigationToolbarDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [owners, setOwners] = (0, _react.useState)([]);
    const [roles, setRoles] = (0, _react.useState)([]);
    const [screeningType, setScreeningType] = (0, _react.useState)();
    const [selectedRoles, setSelectedRoles] = (0, _react.useState)([]);
    const [selectedOwners, setSelectedOwners] = (0, _react.useState)([]);
    const defaultSignatureConfiguration = (0, _useGetOnboardingConfigurationDefault.default)("company");
    // Get screening config and company customer details
    const companyCustomerDetailsQuery = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_DETAILS,
        customerId
    ], ()=>(0, _apiDefault.default).getCompanyCustomerDetails(customerId));
    const companyScreeningConfigQuery = (0, _useGetCompanyScreeningConfigurationDefault.default)(customerId);
    // mutation
    const updateScreeningConfiguration = (0, _reactQuery.useMutation)(()=>{
        return (0, _apiDefault.default).updateCompanyScreeningConfiguration(customerId, {
            roles: selectedRoles,
            owners: selectedOwners,
            screening_type: screeningType
        });
    }, {
        onSuccess: ()=>{
            companyScreeningConfigQuery.invalidateQuery();
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_DISCLOSURES,
                customerId
            ]);
            goToStep(onboardingStepIndex + 1);
        }
    });
    // mutation end
    (0, _react.useEffect)(()=>{
        if (companyScreeningConfigQuery.isLoading || !companyScreeningConfigQuery.data) return;
        const screening = companyScreeningConfigQuery.data;
        setRoles(screening.roles.map((role)=>role.role));
        setSelectedRoles(screening.roles.filter((r)=>r.screening_required).map((r)=>r.role.id));
        // Make all "active" (ie. not deleted) owners OR owners currently in screening config available for (de)selection
        setOwners(screening.beneficial_owners.filter((o)=>!o.owner.deleted || o.screening_required).map((o)=>o.owner));
        // Preselect owners currently in the screening config
        // or UBOs (and if features.SCREENING__MARK_ALL_OWNERS is enabled then all owners)
        setSelectedOwners(screening.beneficial_owners.filter((beneficialOwner)=>(0, _ownersHelpers.isOwnerPerson)(beneficialOwner.owner) && (beneficialOwner.screening_required || ((0, _personHelpers.isUBO)(beneficialOwner.owner) || features.SCREENING__MARK_ALL_OWNERS) && !beneficialOwner.owner.deleted)).map((beneficialOwner)=>beneficialOwner.owner.id));
        // if a previous screening type was saved - use it
        if (screening.screening_type === "MONITORING" || screening.screening_type === "ONE_TIME") setScreeningType(screening.screening_type);
        else if (defaultSignatureConfiguration?.screening_type) setScreeningType(defaultSignatureConfiguration.screening_type);
    }, [
        companyScreeningConfigQuery.data,
        defaultSignatureConfiguration
    ]);
    if (companyScreeningConfigQuery.isError || companyCustomerDetailsQuery.isError) {
        if (companyScreeningConfigQuery.isMaxRetriesReached) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningEmptyStateDefault.default), {});
        else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPageDefault.default), {
            error: companyScreeningConfigQuery.error || companyCustomerDetailsQuery.error
        });
    }
    const displaySkeleton = companyScreeningConfigQuery.isLoading || !companyScreeningConfigQuery.data || companyCustomerDetailsQuery.isLoading || !companyCustomerDetailsQuery.data || !screeningType;
    if (displaySkeleton) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningSkeletonDefault.default), {
        progress: companyScreeningConfigQuery.loadingProgress,
        message: f("screening.messages.retrieving-details")
    });
    const companyCustomer = companyCustomerDetailsQuery.data;
    const canHaveShareholders = companyCustomer.can_have_shareholders === false ? false : true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("screening.titles.screening"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                children: companyCustomer.is_manual ? f("screening.titles.screening.manual.description") : canHaveShareholders ? f("screening.titles.screening.description") : f("screening.titles.screening.without-shareholders.description")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
                                title: f("screening.titles.banner.title"),
                                status: "info",
                                children: f("screening.titles.banner.description")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                                size: "medium"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "headingMd",
                                as: "h2",
                                children: f("screening.titles.customer")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyDetailsCardDefault.default), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    secondary: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout).Section, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingMd",
                            as: "h2",
                            children: f("screening.titles.owners")
                        }),
                        companyCustomer.is_manual && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "bodyMd",
                            as: "span",
                            children: f("screening.messages.specify-owners")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    secondary: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ownersCardDefault.default), {
                            customer: companyCustomer,
                            selectable: true,
                            owners: owners,
                            selectedOwners: selectedOwners,
                            onSelectionChange: setSelectedOwners,
                            isArchiveDisabled: (ownerId)=>selectedOwners.includes(ownerId),
                            onArchive: (archivedOwnerId)=>{
                                setOwners(owners.filter((owner)=>owner.id !== archivedOwnerId));
                                if (selectedOwners.includes(archivedOwnerId)) setSelectedOwners(selectedOwners.filter((selectedOwner)=>selectedOwner !== archivedOwnerId));
                            },
                            onUpdate: (updatedOwner)=>{
                                setOwners(owners.map((owner)=>owner.id === updatedOwner.id ? Object.assign(owner, updatedOwner) : owner));
                                if ((0, _personHelpers.isUBO)(updatedOwner) && !selectedOwners.includes(updatedOwner.id)) setSelectedOwners([
                                    ...selectedOwners,
                                    updatedOwner.id
                                ]);
                            },
                            onCreate: (createdOwner)=>{
                                setOwners([
                                    createdOwner
                                ].concat(owners));
                                if ((0, _personHelpers.isUBO)(createdOwner)) setSelectedOwners([
                                    ...selectedOwners,
                                    createdOwner.id
                                ]);
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    secondary: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _infoBoxDefault.default), {
                        title: f("screening.infobox.owners.title"),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: f("screening.infobox.owners.definition")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: companyCustomer.is_manual ? f("screening.infobox.owners.text.manual") : f("screening.infobox.owners.text.norwegian")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout).Section, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingMd",
                            as: "h2",
                            children: f("screening.titles.roles")
                        }),
                        companyCustomer.is_manual && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "bodyMd",
                            as: "span",
                            children: f("screening.messages.specify-roles")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rolesCardDefault.default), {
                            customer: companyCustomer,
                            roles: roles,
                            selectedRoles: selectedRoles,
                            selectable: true,
                            companyType: (0, _customerHelpers.getCompanyType)(language, companyCustomer.company_type),
                            companyCountry: companyCustomerDetailsQuery.data?.country,
                            getIsDeleteDisabled: (roleId)=>selectedRoles.includes(roleId),
                            onSelectionChange: setSelectedRoles,
                            onDelete: (deletedRoleId)=>{
                                setRoles(roles.filter((role)=>role.id !== deletedRoleId));
                                if (selectedRoles.includes(deletedRoleId)) setSelectedRoles(selectedRoles.filter((selectedRole)=>selectedRole !== deletedRoleId));
                            },
                            onUpdate: (updatedRole)=>setRoles(roles.map((role)=>role.id === updatedRole.id ? updatedRole : role)),
                            onCreate: (createdRole)=>setRoles([
                                    createdRole
                                ].concat(roles))
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    secondary: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _infoBoxDefault.default), {
                        title: f("screening.infobox.roles.title"),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: f("screening.infobox.roles.definition")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: companyCustomer.is_manual ? f("screening.infobox.roles.text.manual") : f("screening.infobox.roles.text.norwegian")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout).Section, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingMd",
                            as: "h2",
                            children: f("screening.titles.screening-frequency")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningTypeCardDefault.default), {
                                        screeningType: screeningType,
                                        onScreeningTypeChange: setScreeningType
                                    })
                                })
                            }),
                            updateScreeningConfiguration.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                                message: updateScreeningConfiguration.error
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "4",
                                align: "end",
                                children: [
                                    companyCustomer.is_manual && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        onClick: ()=>goToStep(onboardingStepIndex - 1),
                                        disabled: updateScreeningConfiguration.isLoading,
                                        children: f("button.go.back")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                        primary: true,
                                        disabled: updateScreeningConfiguration.isLoading || !screeningType || screeningType === "NONE",
                                        loading: updateScreeningConfiguration.isLoading,
                                        onClick: ()=>updateScreeningConfiguration.mutate(),
                                        children: f("button.go.next")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    secondary: true
                })
            ]
        })
    });
};
exports.default = OnboardingCompanyScreeningPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/InfoBox/InfoBox":"6Vxib","../../components/OwnersCard/OwnersCard":"f1O1W","../../components/RolesCard/RolesCard":"7Zoco","../../components/ScreeningEmptyState/ScreeningEmptyState":"5Zeqa","../../components/ScreeningSkeleton/ScreeningSkeleton":"kuEJQ","../../components/ScreeningTypeCard/ScreeningTypeCard":"2sGBG","../../components/SectionMargin/SectionMargin":"l3u8a","../../constants/queries-keys":"6hYSF","../../helpers/customer.helpers":"dkhe3","../../helpers/owners.helpers":"lynDH","../../helpers/person.helpers":"6qOIE","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetCompanyScreeningConfiguration":"if7XX","../../hooks/useGetOnboardingConfiguration":"27sqE","../../hooks/useLanguage":"2W6IE","../../hooks/useNavigationToolbar":"gd2EG","../ErrorPage":"8Le05","./CompanyDetailsCard":"aUue6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Vxib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
const InfoBox = (props)=>{
    const { title, children } = props;
    const [isExpanded, toggleExpanded] = (0, _useOpenCloseDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Banner), {
        status: "info",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                onClick: toggleExpanded,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTitleWrapper, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        fontWeight: "semibold",
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                open: isExpanded,
                id: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInfoBoxContent, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: children
                    })
                })
            })
        ]
    });
};
const StyledInfoBoxContent = (0, _styledComponentsDefault.default).div`
  margin-top: var(--p-space-4);
  white-space: pre-wrap;
`;
const StyledTitleWrapper = (0, _styledComponentsDefault.default).div`
  & > * {
    flex-wrap: unset;
    max-width: 200px;
    overflow-wrap: anywhere;
  }
`;
exports.default = InfoBox;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../hooks/useOpenClose":"idooG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aUue6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _companySvg = require("../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _docTextSvg = require("../../../assets/icons/doc-text.svg");
var _docTextSvgDefault = parcelHelpers.interopDefault(_docTextSvg);
var _folderSvg = require("../../../assets/icons/folder.svg");
var _folderSvgDefault = parcelHelpers.interopDefault(_folderSvg);
var _globeSvg = require("../../../assets/icons/globe.svg");
var _globeSvgDefault = parcelHelpers.interopDefault(_globeSvg);
var _tagSvg = require("../../../assets/icons/tag.svg");
var _tagSvgDefault = parcelHelpers.interopDefault(_tagSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addressInfo = require("../../components/AddressInfo/AddressInfo");
var _addressInfoDefault = parcelHelpers.interopDefault(_addressInfo);
var _condensedText = require("../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _country = require("../../components/Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _icon = require("../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useProjectPermissions = require("../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
const CompanyCardSkeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {})
                ]
            })
        })
    });
const CompanyDetailsCard = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const query = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_DETAILS,
        id
    ], ()=>(0, _apiDefault.default).getCompanyCustomerDetails(id));
    const f = (0, _useFormatMessageDefault.default)();
    const { isProjectsEnabled } = (0, _useProjectPermissionsDefault.default)();
    if (query.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
        message: query.error,
        actionTitle: f("company-card.errors.fetch-failed-action")
    });
    if (!query.data || query.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CompanyCardSkeleton, {});
    const companyCustomer = query.data;
    const companyType = companyCustomer.company_type && (companyCustomer.company_type.description_nb || companyCustomer.company_type.code);
    const hasProject = isProjectsEnabled && companyCustomer.projects?.length === 1 && companyCustomer.projects[0] !== undefined;
    const projectName = hasProject ? companyCustomer.projects[0].name : "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledGridContainer, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _companySvgDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("common.labels.name").toUpperCase()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        fontWeight: "semibold",
                        children: companyCustomer.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _globeSvgDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("common.labels.country").toUpperCase()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                        country: companyCustomer.country
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _docTextSvgDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("company-form.labels.national-id").toUpperCase()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        children: [
                            companyCustomer.national_id,
                            " ",
                            companyType && ` - ${companyType}`
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _tagSvgDefault.default)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        children: f("common.labels.address").toUpperCase()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                        address: companyCustomer.business_address
                    }),
                    hasProject && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: (0, _folderSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                children: f("summary.project.title").toUpperCase()
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                children: projectName
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const StyledGridContainer = (0, _styledComponentsDefault.default).div`
  display: grid;
  gap: var(--p-space-4);
  grid-template-columns: min-content min-content auto;
  align-items: center;
`;
exports.default = CompanyDetailsCard;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router":"5RYYS","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../assets/icons/company.svg":"luBbc","../../../assets/icons/doc-text.svg":"leosj","../../../assets/icons/folder.svg":"b2aWC","../../../assets/icons/globe.svg":"kv6Wl","../../../assets/icons/tag.svg":"jZ7nZ","../../api":"f6lXD","../../components/AddressInfo/AddressInfo":"9YtjF","../../components/CondensedText/CondensedText":"1FshD","../../components/Country/Country":"eeWSc","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/extensions/Icon":"eHSf0","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useProjectPermissions":"23Tgs","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2VQqu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _displayName = require("../../components/DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _onboardingCompanyAttachmentsInfo = require("../../components/OnboardingCompanyAttachmentsInfo/OnboardingCompanyAttachmentsInfo");
var _onboardingCompanyAttachmentsInfoDefault = parcelHelpers.interopDefault(_onboardingCompanyAttachmentsInfo);
var _onboardingSummaryAssignmentInfo = require("../../components/OnboardingSummaryAssignmentInfo/OnboardingSummaryAssignmentInfo");
var _onboardingSummaryAssignmentInfoDefault = parcelHelpers.interopDefault(_onboardingSummaryAssignmentInfo);
var _onboardingSummarySignatureSection = require("../../components/OnboardingSummarySignatureSection/OnboardingSummarySignatureSection");
var _onboardingSummarySignatureSectionDefault = parcelHelpers.interopDefault(_onboardingSummarySignatureSection);
var _roleType = require("../../components/RoleType/RoleType");
var _roleTypeDefault = parcelHelpers.interopDefault(_roleType);
var _sectionDivider = require("../../components/SectionDivider/SectionDivider");
var _sectionDividerDefault = parcelHelpers.interopDefault(_sectionDivider);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _usersSelect = require("../../components/UsersSelect/UsersSelect");
var _usersSelectDefault = parcelHelpers.interopDefault(_usersSelect);
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _displayHelpers = require("../../helpers/display.helpers");
var _useAttachmentsAPI = require("../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatOwnershipPercentage = require("../../hooks/useFormatOwnershipPercentage");
var _useFormatOwnershipPercentageDefault = parcelHelpers.interopDefault(_useFormatOwnershipPercentage);
var _useNavigationToolbar = require("../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
var _useProjectPermissions = require("../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _collectionUtils = require("../../utils/collectionUtils");
const OnboardingCompanySummaryPage = ({ data: customer })=>{
    const { id } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const formatPercent = (0, _useFormatOwnershipPercentageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_SUMMARY,
        id
    ]);
    const { isProjectsEnabled } = (0, _useProjectPermissionsDefault.default)();
    const { onboardingStepIndex, goToStep } = (0, _useNavigationToolbarDefault.default)();
    const { entityId, getAttachments } = (0, _useAttachmentsAPIDefault.default)(customer);
    const attachmentsQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
        entityId
    ];
    const { isLoading, data } = (0, _reactQuery.useQuery)(attachmentsQueryKey, ()=>getAttachments(entityId));
    const [isPosting, setPosting] = (0, _react.useState)(false);
    const roles = customer.screening?.roles || [];
    const owners = customer.screening?.beneficial_owners || [];
    const onboardingSignatures = (0, _collectionUtils.first)(customer.disclosure_documents)?.signatures || [];
    const showAttachments = !isLoading && (0, _collectionUtils.hasContent)(data?.attachment_list);
    const renderRoles = (roles)=>{
        return roles.map(({ role })=>[
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                    type: "person",
                    name: (0, _displayHelpers.getFullName)(role.person),
                    birthDate: (0, _displayHelpers.getBirthDate)(role.person),
                    comment: role.comment
                }, role.id),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roleTypeDefault.default), {
                    role: role
                })
            ]);
    };
    const renderOwners = (owners)=>{
        return owners.map(({ owner })=>{
            return [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                    type: "person",
                    name: (0, _displayHelpers.getFullName)(owner.person),
                    birthDate: (0, _displayHelpers.getBirthDate)(owner.person),
                    comment: owner.comment
                }),
                formatPercent(owner.percent_share || "0")
            ];
        });
    };
    const associatedProject = customer.projects && customer.projects.length === 1 ? customer.projects[0] : undefined;
    const isCreatedViaProject = associatedProject !== undefined;
    const redirectURLAfterFinish = isCreatedViaProject ? (0, _reactRouter.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
        id: associatedProject.id
    }) : (0, _reactRouter.generatePath)((0, _routes.ROUTES).COMPANY_DETAILS, {
        id
    });
    const updateResponsibleUsers = (responsibleUserIds)=>(0, _apiDefault.default).updateCustomerDetails(customer.id, {
            responsible_users: responsibleUserIds
        }).then((response)=>response.responsible_users || []);
    const updateQueryCache = (responsibleUsers)=>updateQueryData((queryData)=>queryData.responsible_users = responsibleUsers);
    const finish = ()=>{
        setPosting(true);
        (0, _apiDefault.default).finishOnboarding(id).then(()=>{
            setPosting(false);
            history.push((0, _reactRouter.generatePath)(redirectURLAfterFinish));
        }).catch((error)=>{
            setPosting(false);
            console.log(error);
        });
    };
    const showProjectName = associatedProject && (!isProjectsEnabled || !isCreatedViaProject);
    const showAssignment = (0, _collectionUtils.hasContent)(customer.assignments) && onboardingSignatures.some((signature)=>signature.assignment_id !== undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("onboarding-summary.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "p",
                    children: f("summary.description")
                }),
                features.RESPONSIBLE_USER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        title: f("summary.responsible-user"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersSelectDefault.default), {
                            selectedUsers: customer.responsible_users || [],
                            emptySelectionLabel: f("responsible.empty.users"),
                            updateErrorMessage: f("responsible.error"),
                            onUserSelection: updateResponsibleUsers,
                            onAfterUserSelection: updateQueryCache
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        title: f("summary.screening-type"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            children: f(`screening-type.${customer.screening?.screening_type || "NOT_SET"}`)
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        title: f("summary.text.screening.company"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                            name: customer.name,
                            type: customer.type || "company",
                            children: customer.national_id && f("display-name.suffixes.labels.org-id", {
                                orgId: customer.national_id
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                        title: f("summary.text.screening.owners"),
                        children: [
                            owners.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "p",
                                children: f("summary.text.no-owners")
                            }),
                            owners.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                                columnContentTypes: [
                                    "text",
                                    "numeric"
                                ],
                                headings: [
                                    f("table.column.name"),
                                    f("table.column.shares")
                                ],
                                rows: renderOwners(owners),
                                hoverable: false
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                        title: f("summary.text.screening.roles"),
                        children: [
                            roles.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "p",
                                children: f("summary.text.no-roles")
                            }),
                            roles.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                                columnContentTypes: [
                                    "text",
                                    "text"
                                ],
                                headings: [
                                    f("table.column.name"),
                                    f("table.column.role")
                                ],
                                rows: renderRoles(roles),
                                hoverable: false
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                        title: f("summary.signers.title"),
                        children: [
                            onboardingSignatures.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "p",
                                children: f("summary.signers.text.skipped")
                            }),
                            onboardingSignatures.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingSummarySignatureSectionDefault.default), {
                                signatures: onboardingSignatures
                            })
                        ]
                    })
                }),
                showAssignment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingSummaryAssignmentInfoDefault.default), {
                            assignment: (0, _collectionUtils.first)(customer.assignments)
                        })
                    })
                }),
                showProjectName && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        title: f("summary.project.title"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "p",
                            children: associatedProject.name
                        })
                    })
                }),
                showAttachments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        title: f("attachments.section.title"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingCompanyAttachmentsInfoDefault.default), {
                            customer: customer
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            disabled: isPosting,
                            onClick: ()=>goToStep(onboardingStepIndex - 1),
                            children: f("button.go.back")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            primary: true,
                            loading: isPosting,
                            disabled: isPosting,
                            onClick: finish,
                            children: f("summary.signers.start.screening")
                        })
                    ]
                })
            ]
        })
    });
};
const Skeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                    size: "large"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                    lines: 3
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                    lines: 1
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDividerDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                    lines: 1
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDividerDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                    lines: 3
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDividerDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                    lines: 3
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDividerDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonDisplayText), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                    lines: 3
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDividerDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        primary: true,
                        disabled: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 1
                        })
                    })
                })
            ]
        })
    });
exports.default = (0, _asyncPage.withAsyncPage)(OnboardingCompanySummaryPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).COMPANY_ONBOARDING_SUMMARY,
    apiFunction: (0, _apiDefault.default).getCompanyCustomerDetails,
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Skeleton, {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router":"5RYYS","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/DisplayName/DisplayName":"gKd5g","../../components/extensions/Button":"8exc0","../../components/OnboardingCompanyAttachmentsInfo/OnboardingCompanyAttachmentsInfo":"aGvdL","../../components/OnboardingSummaryAssignmentInfo/OnboardingSummaryAssignmentInfo":"9maxu","../../components/OnboardingSummarySignatureSection/OnboardingSummarySignatureSection":"1SYNX","../../components/RoleType/RoleType":"eHoEr","../../components/SectionDivider/SectionDivider":"9PqIT","../../components/SectionMargin/SectionMargin":"l3u8a","../../components/UsersSelect/UsersSelect":"k1Nxo","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../helpers/display.helpers":"2q3xY","../../hooks/useAttachmentsAPI":"7xA5e","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatOwnershipPercentage":"ihLqM","../../hooks/useNavigationToolbar":"gd2EG","../../hooks/useProjectPermissions":"23Tgs","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aGvdL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactQuery = require("@tanstack/react-query");
var _queriesKeys = require("../../constants/queries-keys");
var _useAttachmentsAPI = require("../../hooks/useAttachmentsAPI");
var _useAttachmentsAPIDefault = parcelHelpers.interopDefault(_useAttachmentsAPI);
var _util = require("../../utils/util");
var _attachmentsTable = require("../AttachmentsSection/AttachmentsTable");
var _attachmentsTableDefault = parcelHelpers.interopDefault(_attachmentsTable);
const OnboardingCompanyAttachmentsInfo = (props)=>{
    const { customer } = props;
    const { entityId, getAttachments } = (0, _useAttachmentsAPIDefault.default)(customer);
    const attachmentsQueryKey = [
        (0, _queriesKeys.QUERIES_KEYS).ATTACHMENTS,
        entityId
    ];
    const { isError, data } = (0, _reactQuery.useQuery)(attachmentsQueryKey, ()=>getAttachments(entityId));
    const attachments = data?.attachment_list?.filter((attachment)=>!attachment.assignment_is_archived) || [];
    if (isError) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentsTableDefault.default), {
        entity: customer,
        attachments: attachments,
        uploadingFilesCount: 0,
        hideSignatures: true,
        onAttachmentSelected: (0, _util.noop)
    });
};
exports.default = OnboardingCompanyAttachmentsInfo;

},{"react/jsx-runtime":"enbMA","@tanstack/react-query":"91Vyq","../../constants/queries-keys":"6hYSF","../../hooks/useAttachmentsAPI":"7xA5e","../../utils/util":"4MniK","../AttachmentsSection/AttachmentsTable":"l2FqJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9maxu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _projectSvg = require("../../../assets/icons/project.svg");
var _projectSvgDefault = parcelHelpers.interopDefault(_projectSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _assignmentPurpose = require("../AssignmentPurpose/AssignmentPurpose");
var _assignmentPurposeDefault = parcelHelpers.interopDefault(_assignmentPurpose);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _verticalDivider = require("../VerticalDivider/VerticalDivider");
var _verticalDividerDefault = parcelHelpers.interopDefault(_verticalDivider);
const OnboardingSummaryAssignmentInfo = (props)=>{
    const { assignment } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        blockAlign: "center",
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: (0, _projectSvgDefault.default),
                                width: "16px",
                                height: "12px"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "h3",
                                fontWeight: "bold",
                                children: f("customer-assignments.modal.assignment-name")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "p",
                        children: assignment?.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verticalDividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        blockAlign: "center",
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: (0, _projectSvgDefault.default),
                                width: "16px",
                                height: "12px"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                as: "h3",
                                fontWeight: "bold",
                                children: f("customer-assignments.details.assignment-purpose")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "p",
                        children: assignment ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentPurposeDefault.default), {
                            assignment: assignment
                        }) : "-"
                    })
                ]
            })
        ]
    });
};
const Container = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-columns: 1fr var(--p-space-4) 1fr;
`;
exports.default = OnboardingSummaryAssignmentInfo;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/project.svg":"b4tRC","../../hooks/useFormatMessage":"8Y8fq","../AssignmentPurpose/AssignmentPurpose":"1jViK","../extensions/Icon":"eHSf0","../VerticalDivider/VerticalDivider":"r7aOz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"r7aOz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const VerticalDivider = (0, _styledComponentsDefault.default).div`
  border-left: var(--p-border-width-1) solid var(--p-color-border-subdued);
`;
exports.default = VerticalDivider;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1SYNX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _disclosuresHelpers = require("../../helpers/disclosures.helpers");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _displayName = require("../DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _language = require("../Language/Language");
var _languageDefault = parcelHelpers.interopDefault(_language);
const renderSignatures = (signatures)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const getEmailLabel = (signature)=>(0, _util.isEmailEnabled)(signature) && signature.email ? signature.email : f("signature.email.not.provided");
    const getScopeLabel = (signature)=>{
        const selectionLabels = [];
        if (signature.use_standard_disclosure) selectionLabels.push(f("disclosure-request.field.use_standard_disclosure"));
        if (signature.use_pep_disclosure) selectionLabels.push(f("disclosure-request.field.use_pep_disclosure"));
        if (signature.use_verification) {
            const verificationLabel = (0, _disclosuresHelpers.isKYCSelected)(signature) ? (0, _stringUtils.lowercaseFirstLetter)(f("disclosure-request.field.use_verification")) : f("disclosure-request.field.use_verification");
            selectionLabels.push(verificationLabel);
        }
        return formatMultipleNames(selectionLabels);
    };
    return signatures.map((signature)=>[
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                type: "person",
                name: (0, _displayHelpers.getFullName)(signature.person),
                birthDate: (0, _displayHelpers.getBirthDate)(signature.person)
            }),
            getScopeLabel(signature),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageDefault.default), {
                language: signature.language
            }),
            getEmailLabel(signature)
        ]);
};
const OnboardingSummarySignatureSection = (props)=>{
    const { signatures } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const columnContentTypes = [
        "text",
        "text",
        "text",
        "text"
    ];
    const headings = [
        f("onboarding-summary.signature-table-column.name"),
        f("onboarding-summary.signature-table-column.scope"),
        f("onboarding-summary.signature-table-column.content-language"),
        f("onboarding-summary.signature-table-column.email-or-url")
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
        columnContentTypes: columnContentTypes,
        headings: headings,
        rows: renderSignatures(signatures),
        hoverable: false
    });
};
exports.default = OnboardingSummarySignatureSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/disclosures.helpers":"6yWoC","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","../DisplayName/DisplayName":"gKd5g","../Language/Language":"h9jd4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9PqIT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const SectionDivider = (0, _styledComponentsDefault.default).div`
  border-top: var(--p-border-divider);
`;
exports.default = SectionDivider;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lYxQH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _companyCustomerForm = require("../../components/CompanyCustomerForm/CompanyCustomerForm");
var _companyCustomerFormDefault = parcelHelpers.interopDefault(_companyCustomerForm);
var _detailsSkeleton = require("../../components/DetailsSkeleton/DetailsSkeleton");
var _detailsSkeletonDefault = parcelHelpers.interopDefault(_detailsSkeleton);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useNavigationToolbar = require("../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
/**
 * Page for updating manually created company customer during onboarding
 */ const OnboardingManualCompanyPage = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const { id } = (0, _reactRouterDom.useParams)();
    const { onboardingStepIndex, goToStep } = (0, _useNavigationToolbarDefault.default)();
    const [companyCustomerDetails, setCompanyCustomerDetails] = (0, _react.useState)();
    // Get existing company customer by the ID param
    const [isLoading, setIsLoading] = (0, _react.useState)(id ? true : false);
    (0, _react.useEffect)(()=>{
        // Set loading while fetching
        setIsLoading(true);
        (0, _apiDefault.default).getCompanyCustomerDetails(id).then((data)=>{
            setCompanyCustomerDetails(data);
            // Disable loading state
            setIsLoading(false);
        });
    }, []);
    if (isLoading) // Display skeleton while loading company customer
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsSkeletonDefault.default), {});
    else // Not loading - display form with input fields
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("onboarding.bar.manual-company.information.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _companyCustomerFormDefault.default), {
            companyCustomer: companyCustomerDetails,
            onAfterSubmit: ()=>{
                // Navigate to the next step after the company customer has successfully been updated
                goToStep(onboardingStepIndex + 1);
            }
        })
    });
};
exports.default = OnboardingManualCompanyPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/CompanyCustomerForm/CompanyCustomerForm":"2nMmk","../../components/DetailsSkeleton/DetailsSkeleton":"lj8DC","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useNavigationToolbar":"gd2EG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ihi8l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _onboardingPersonForm = require("../../components/OnboardingPersonForm/OnboardingPersonForm");
var _onboardingPersonFormDefault = parcelHelpers.interopDefault(_onboardingPersonForm);
var _onboarding = require("../../constants/onboarding");
var _queriesKeys = require("../../constants/queries-keys");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _integrationHelpers = require("../../helpers/integration.helpers");
var _useDefaultCountry = require("../../hooks/useDefaultCountry");
var _useDefaultCountryDefault = parcelHelpers.interopDefault(_useDefaultCountry);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const OnboardingPersonEditPage = ({ data })=>{
    const defaultCountry = (0, _useDefaultCountryDefault.default)();
    const [personData, screeningData, disclosureData] = data;
    const country = personData?.country_of_citizenship || defaultCountry;
    // set missing country in person data fields
    const person = {
        ...personData,
        address: personData.address || {
            country
        },
        birth_date: personData.birth_date || "",
        country_of_origin: personData.country_of_origin || country,
        country_of_citizenship: personData.country_of_citizenship || country,
        country_of_residence: personData.country_of_residence || country
    };
    // do not allow to cancel onboarding if the customer belongs to a vitec project
    const disableCancelOnboarding = personData.projects?.find((0, _integrationHelpers.isVitecProject)) !== undefined;
    const responsibleUsersIds = personData.responsible_users?.map((user)=>user.id) || [];
    const screeningType = (0, _onboarding.ONBOARDING_SCREENING_TYPES).includes(screeningData.screening_type) ? screeningData.screening_type : "MONITORING";
    const assignments = personData.assignments?.filter((0, _assignmentsHelpers.isActiveAssignment));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingPersonFormDefault.default), {
        personId: person.id,
        personValues: person,
        screeningType: screeningType,
        isSignatureRequired: !!disclosureData.signature_required,
        signature: {
            ...disclosureData,
            email: disclosureData.email || person.email
        },
        disableCancelOnboarding: disableCancelOnboarding,
        responsibleUsersIds: responsibleUsersIds,
        assignments: assignments
    });
};
const PersonSkeleton = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.ProgressBar), {
                    progress: 85,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                disabled: true,
                                children: f("default.cancel")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                disabled: true,
                                primary: true,
                                children: f("default.next")
                            })
                        ]
                    })
                })
            })
        ]
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(OnboardingPersonEditPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).PERSON_ONBOARDING_DETAILS,
    apiFunction: (id, options)=>Promise.all([
            (0, _apiDefault.default).getPersonCustomerDetails(id, options),
            (0, _apiDefault.default).getPersonScreeningConfiguration(id, options),
            (0, _apiDefault.default).getPersonSignatureConfiguration(id, options)
        ]),
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PersonSkeleton, {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/OnboardingPersonForm/OnboardingPersonForm":"9hBPW","../../constants/onboarding":"lQH9P","../../constants/queries-keys":"6hYSF","../../helpers/assignments.helpers":"7t8rY","../../helpers/integration.helpers":"keU9B","../../hooks/useDefaultCountry":"9Xjpj","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9hBPW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _clockSvg = require("../../../assets/icons/clock.svg");
var _clockSvgDefault = parcelHelpers.interopDefault(_clockSvg);
var _personSvg = require("../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _displayHelpers = require("../../helpers/display.helpers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _stringUtils = require("../../utils/stringUtils");
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _disclosureSignatureForm = require("../DisclosureSignatureForm/DisclosureSignatureForm");
var _disclosureSignatureFormDefault = parcelHelpers.interopDefault(_disclosureSignatureForm);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _personForm = require("../PersonForm/PersonForm");
var _personFormDefault = parcelHelpers.interopDefault(_personForm);
var _popoverButton = require("../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _screeningTypeCard = require("../ScreeningTypeCard/ScreeningTypeCard");
var _screeningTypeCardDefault = parcelHelpers.interopDefault(_screeningTypeCard);
var _usersList = require("../UsersList/UsersList");
var _usersListDefault = parcelHelpers.interopDefault(_usersList);
var _useOnboardingPersonForm = require("./useOnboardingPersonForm");
var _useOnboardingPersonFormDefault = parcelHelpers.interopDefault(_useOnboardingPersonForm);
const OnboardingPersonForm = (props)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { getUserFullName } = (0, _useGetUserNameDefault.default)();
    const { createdFromProject, isSavedPerson, person, setPerson, changed, responsibleUsersIds, setResponsibleUsersIds, screeningType, setScreeningType, signature, setSignature, selectedAssignment, setSelectedAssignment, setIsFormValid, invalid, shouldSendDisclosure, setShouldSendDisclosure, finishOnboarding, isLoading, generalError, fieldsErrorsMap, registerPerson, savePerson, cancelOnboarding, handleCancel } = (0, _useOnboardingPersonFormDefault.default)(props);
    const [showCancelConfirm, toggleCancelConfirm] = (0, _useOpenCloseDefault.default)();
    const customerName = (0, _stringUtils.isEmptyString)((0, _displayHelpers.getFullName)(person)) ? f("screening.titles.customer") : (0, _displayHelpers.getFullName)(person);
    const popoverLabel = responsibleUsersIds.length === 0 ? f("responsible.empty.users") : formatMultipleNames(responsibleUsersIds.map((userId)=>getUserFullName(userId)), 1);
    const handlePersonChange = (key, value)=>setPerson((prevPerson)=>({
                ...prevPerson,
                [key]: value
            }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "1",
                        blockAlign: "center",
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                source: (0, _personSvgDefault.default)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "headingMd",
                                as: "h2",
                                children: f("onboarding.new.person.title")
                            })
                        ]
                    }),
                    createdFromProject && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "headingMd",
                            as: "h2",
                            children: createdFromProject.name
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personFormDefault.default), {
                                renderAsCards: true,
                                value: person,
                                birthDateIsRequired: true,
                                isCreating: true,
                                disabled: isLoading,
                                onChange: setPerson,
                                onValidityChange: setIsFormValid,
                                fieldsErrorMap: fieldsErrorsMap
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingXs",
                                        as: "h3",
                                        children: f("screening.titles.screening-frequency")
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningTypeCardDefault.default), {
                                        screeningType: screeningType,
                                        onScreeningTypeChange: (newValue)=>setScreeningType(newValue)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                        gap: "4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                                gap: "2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                        variant: "headingXs",
                                                        as: "h3",
                                                        children: f("onboarding.disclosures.title")
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                        as: "span",
                                                        color: "subdued",
                                                        children: f("onboarding.disclosures.person-description")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Checkbox), {
                                                checked: shouldSendDisclosure,
                                                onChange: setShouldSendDisclosure,
                                                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                    as: "span",
                                                    fontWeight: "semibold",
                                                    children: f("onboarding.disclosures.person.require-disclosure")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureSignatureFormDefault.default), {
                                                readonly: !shouldSendDisclosure,
                                                signature: signature,
                                                customerId: props.personId,
                                                customerType: "person",
                                                signatureName: customerName,
                                                onChange: setSignature,
                                                assignments: props.assignments,
                                                selectedAssignment: selectedAssignment,
                                                onAssignmentChange: setSelectedAssignment
                                            })
                                        ]
                                    })
                                })
                            }),
                            features.EXTERNAL_ID && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingXs",
                                        as: "h3",
                                        children: f("company-form.labels.external-id")
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                            value: person.external_id || "",
                                            onChange: (newValue)=>handlePersonChange("external_id", newValue),
                                            placeholder: f("company-form.labels.external-id"),
                                            label: f("company-form.labels.external-id"),
                                            labelHidden: true,
                                            disabled: isLoading,
                                            maxLength: 50,
                                            error: fieldsErrorsMap.get("external_id"),
                                            autoComplete: "off"
                                        })
                                    })
                                })
                            }),
                            features.RESPONSIBLE_USER && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingXs",
                                        as: "h3",
                                        children: f("summary.responsible-user")
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
                                        fullWidth: false,
                                        label: popoverLabel,
                                        disclosure: true,
                                        disabled: isLoading,
                                        render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersListDefault.default), {
                                                        selectedUserIds: responsibleUsersIds,
                                                        onChange: setResponsibleUsersIds,
                                                        allowMultiple: true,
                                                        selectedFirst: true
                                                    })
                                                })
                                            })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: generalError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                                    message: generalError
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: changed ? toggleCancelConfirm : handleCancel,
                        disabled: isLoading,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _trashSvgDefault.default),
                            useMask: true
                        }),
                        destructive: isSavedPerson && changed,
                        children: changed ? f("onboarding.cancel.and.delete") : f("default.cancel")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: savePerson,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _clockSvgDefault.default),
                            width: "16px",
                            height: "16px",
                            useMask: true
                        }),
                        disabled: isLoading || invalid,
                        loading: isLoading && !finishOnboarding,
                        children: f("onboarding.cancel.and.save")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                        fill: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: registerPerson,
                        disabled: isLoading || invalid,
                        loading: isLoading && finishOnboarding,
                        primary: true,
                        children: f("summary.signers.start.screening")
                    })
                ]
            }),
            showCancelConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: cancelOnboarding,
                title: f("onboarding.cancel.confirm.title"),
                description: f("onboarding.cancel.confirm.description", {
                    name: customerName
                }),
                actionTitle: f("onboarding.cancel.and.delete"),
                onNo: toggleCancelConfirm,
                onSuccess: handleCancel
            })
        ]
    });
};
exports.default = OnboardingPersonForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/clock.svg":"2a5U1","../../../assets/icons/person.svg":"1Xt5L","../../../assets/icons/trash.svg":"jqW55","../../helpers/display.helpers":"2q3xY","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../../hooks/useGetUserName":"edBne","../../hooks/useOpenClose":"idooG","../../utils/stringUtils":"4gVdA","../ConfirmAction/ConfirmAction":"icP5J","../DisclosureSignatureForm/DisclosureSignatureForm":"ayCrt","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","../PersonForm/PersonForm":"8xv61","../PopoverButton/PopoverButton":"ihB8F","../ScreeningTypeCard/ScreeningTypeCard":"2sGBG","../UsersList/UsersList":"dqxGe","./useOnboardingPersonForm":"6GyhU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2a5U1":[function(require,module,exports) {
module.exports = require("b7b27861a6e24ef3").getBundleURL("kEMsi") + "clock.5aa78d4a.svg";

},{"b7b27861a6e24ef3":"75UoR"}],"6GyhU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _routes = require("../../constants/routes");
var _customerHelpers = require("../../helpers/customer.helpers");
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useDefaultCountry = require("../../hooks/useDefaultCountry");
var _useDefaultCountryDefault = parcelHelpers.interopDefault(_useDefaultCountry);
var _useDisclosureAssignment = require("../../hooks/useDisclosureAssignment");
var _useDisclosureAssignmentDefault = parcelHelpers.interopDefault(_useDisclosureAssignment);
var _useErrorParser = require("../../hooks/useErrorParser");
var _useErrorParserDefault = parcelHelpers.interopDefault(_useErrorParser);
var _useValidateDisclosureForm = require("../../hooks/useValidateDisclosureForm");
var _useValidateDisclosureFormDefault = parcelHelpers.interopDefault(_useValidateDisclosureForm);
const useOnboardingPersonForm = (props)=>{
    const { personId, personValues, screeningType: initialScreeningType, isSignatureRequired, signature: initialSignature, disableCancelOnboarding, responsibleUsersIds: initialResponsibleUsersIds, assignments } = props;
    const history = (0, _reactRouterDom.useHistory)();
    const defaultCountry = (0, _useDefaultCountryDefault.default)();
    const validateDisclosureForm = (0, _useValidateDisclosureFormDefault.default)();
    const [person, setPerson, changed] = (0, _useChangedStateDefault.default)(personValues);
    const [isFormValid, setIsFormValid] = (0, _react.useState)(false);
    const [responsibleUsersIds, setResponsibleUsersIds, responsibleUsersChanged] = (0, _useChangedStateDefault.default)(initialResponsibleUsersIds);
    const [screeningType, setScreeningType] = (0, _react.useState)(initialScreeningType);
    const [signature, setSignature] = (0, _react.useState)(initialSignature);
    const { selectedAssignment, setSelectedAssignment, shouldUpdateAssignment, updateAssignmentMutation } = (0, _useDisclosureAssignmentDefault.default)(personId, signature.assignment_id, assignments);
    const [shouldSendDisclosure, setShouldSendDisclosure] = (0, _react.useState)(isSignatureRequired);
    const [finishOnboarding, setFinishOnboarding] = (0, _react.useState)(true);
    const parseError = (0, _useErrorParserDefault.default)("person");
    const createdFromProject = history.location.state?.createdFromProject;
    const isSavedPerson = personId !== undefined;
    (0, _react.useEffect)(()=>{
        // update the signature email only if send disclosure is enabled
        // and the signature should be sent as an email
        if (shouldSendDisclosure && signature.send_email) setSignature((prevState)=>({
                ...prevState,
                email: person.email
            }));
    }, [
        shouldSendDisclosure,
        signature.send_email,
        person.email
    ]);
    const navigateBack = (personId)=>{
        const redirectURLAfterFinish = createdFromProject ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
            id: createdFromProject.id
        }) : (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PERSON_DETAILS, {
            id: personId
        });
        history.push(redirectURLAfterFinish);
    };
    const registerPerson = ()=>{
        setFinishOnboarding(true);
        savePersonMutation.mutate();
    };
    const savePersonMutation = (0, _reactQuery.useMutation)(()=>{
        const personCustomerRequest = (0, _customerHelpers.convertToCreatePersonCustomerRequest)(person, defaultCountry);
        return isSavedPerson ? (0, _apiDefault.default).updatePerson(personId, personCustomerRequest) : (0, _apiDefault.default).createPersonCustomer({
            ...personCustomerRequest,
            project_id: createdFromProject?.id
        });
    }, {
        onSuccess: (updatedPerson)=>updateScreeningMutation.mutate(updatedPerson.id)
    });
    const updateScreeningMutation = (0, _reactQuery.useMutation)((personId)=>(0, _apiDefault.default).updatePersonScreeningConfiguration(personId, {
            screening_type: screeningType
        }), {
        onSuccess: (response)=>updateSignatureConfigurationMutation.mutate(response.customer_id)
    });
    const updateSignatureConfigurationMutation = (0, _reactQuery.useMutation)(async (personId)=>{
        const request = shouldSendDisclosure ? {
            ...signature,
            signature_required: true,
            assignment_id: selectedAssignment?.id
        } : {
            signature_required: false
        };
        // update the existing assignment with the purpose change (if there was any)
        // and only after that continue to save the signature
        if (shouldSendDisclosure && shouldUpdateAssignment) await updateAssignmentMutation.mutateAsync();
        return (0, _apiDefault.default).setPersonSignatureConfiguration(personId, request);
    }, {
        onSuccess: (response, personId)=>{
            if (finishOnboarding) finishOnboardingMutation.mutate(personId);
            else handleCancel();
        }
    });
    const updateResponsibleUsersMutation = (0, _reactQuery.useMutation)((personId)=>(0, _apiDefault.default).updateCustomerDetails(personId, {
            responsible_users: responsibleUsersIds
        }));
    const finishOnboardingMutation = (0, _reactQuery.useMutation)((0, _apiDefault.default).finishOnboarding, {
        onSuccess: (response, personId)=>{
            if (responsibleUsersChanged) updateResponsibleUsersMutation.mutate(personId, {
                onSuccess: ()=>navigateBack(personId)
            });
            else navigateBack(personId);
        }
    });
    const isSignatureValid = validateDisclosureForm([
        signature
    ]);
    const invalid = !isFormValid || shouldSendDisclosure && !isSignatureValid;
    const isLoading = savePersonMutation.isLoading || updateScreeningMutation.isLoading || updateSignatureConfigurationMutation.isLoading || finishOnboardingMutation.isLoading || updateResponsibleUsersMutation.isLoading;
    const { generalError, fieldsErrorsMap } = parseError(savePersonMutation.error || updateScreeningMutation.error || updateScreeningMutation.error || finishOnboardingMutation.error || updateResponsibleUsersMutation.error);
    const cancelOnboarding = ()=>isSavedPerson && !disableCancelOnboarding ? (0, _apiDefault.default).cancelOnboarding(personId) : Promise.resolve(undefined);
    const savePerson = ()=>{
        setFinishOnboarding(false);
        savePersonMutation.mutate();
    };
    const handleCancel = ()=>createdFromProject ? history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
            id: createdFromProject.id
        })) : history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).HOME));
    return {
        createdFromProject,
        isSavedPerson,
        person,
        setPerson,
        changed,
        responsibleUsersIds,
        setResponsibleUsersIds,
        screeningType,
        setScreeningType,
        signature,
        setSignature,
        selectedAssignment,
        setSelectedAssignment,
        invalid,
        setIsFormValid,
        shouldSendDisclosure,
        setShouldSendDisclosure,
        finishOnboarding,
        isLoading,
        generalError,
        fieldsErrorsMap,
        registerPerson,
        savePerson,
        cancelOnboarding,
        handleCancel
    };
};
exports.default = useOnboardingPersonForm;

},{"react":"cOWTg","react-router-dom":"1ee65","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/routes":"ihtm8","../../helpers/customer.helpers":"dkhe3","../../hooks/useChangedState":"170jW","../../hooks/useDefaultCountry":"9Xjpj","../../hooks/useDisclosureAssignment":"0tZFn","../../hooks/useErrorParser":"daNOL","../../hooks/useValidateDisclosureForm":"6IoRW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b5kV5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _onboardingPersonForm = require("../../components/OnboardingPersonForm/OnboardingPersonForm");
var _onboardingPersonFormDefault = parcelHelpers.interopDefault(_onboardingPersonForm);
var _personHelpers = require("../../helpers/person.helpers");
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useDefaultCountry = require("../../hooks/useDefaultCountry");
var _useDefaultCountryDefault = parcelHelpers.interopDefault(_useDefaultCountry);
var _useGetOnboardingConfiguration = require("../../hooks/useGetOnboardingConfiguration");
var _useGetOnboardingConfigurationDefault = parcelHelpers.interopDefault(_useGetOnboardingConfiguration);
const OnboardingPersonNewPage = ()=>{
    const defaultCountry = (0, _useDefaultCountryDefault.default)();
    const { user } = (0, _useAuthDefault.default)();
    const defaultSignatureConfiguration = (0, _useGetOnboardingConfigurationDefault.default)("person");
    const responsibleUsersIds = user ? [
        user.id
    ] : [];
    if (!defaultSignatureConfiguration) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingPersonFormDefault.default), {
        personValues: (0, _personHelpers.createNewPerson)(defaultCountry),
        responsibleUsersIds: responsibleUsersIds,
        screeningType: defaultSignatureConfiguration.screening_type,
        isSignatureRequired: true,
        signature: defaultSignatureConfiguration.signature_settings
    });
};
exports.default = OnboardingPersonNewPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../components/OnboardingPersonForm/OnboardingPersonForm":"9hBPW","../../helpers/person.helpers":"6qOIE","../../hooks/useAuth":"k9r0q","../../hooks/useDefaultCountry":"9Xjpj","../../hooks/useGetOnboardingConfiguration":"27sqE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"enpd2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("react-router");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _displayName = require("../../components/DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _screeningSkeleton = require("../../components/ScreeningSkeleton/ScreeningSkeleton");
var _screeningSkeletonDefault = parcelHelpers.interopDefault(_screeningSkeleton);
var _screeningStatusBadge = require("../../components/ScreeningStatusBadge/ScreeningStatusBadge");
var _screeningStatusBadgeDefault = parcelHelpers.interopDefault(_screeningStatusBadge);
var _screeningTypeCard = require("../../components/ScreeningTypeCard/ScreeningTypeCard");
var _screeningTypeCardDefault = parcelHelpers.interopDefault(_screeningTypeCard);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _stopScreeningModal = require("../../components/StopScreeningModal/StopScreeningModal");
var _stopScreeningModalDefault = parcelHelpers.interopDefault(_stopScreeningModal);
var _queriesKeys = require("../../constants/queries-keys");
var _displayHelpers = require("../../helpers/display.helpers");
var _screening = require("../../helpers/screening");
var _useCustomerDetailsBackButton = require("../../hooks/useCustomerDetailsBackButton");
var _useCustomerDetailsBackButtonDefault = parcelHelpers.interopDefault(_useCustomerDetailsBackButton);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _errorPage = require("../ErrorPage");
var _errorPageDefault = parcelHelpers.interopDefault(_errorPage);
const PERSON_DETAILS_RESPONSE_INDEX = 0;
const PERSON_SCREENING_RESPONSE_INDEX = 1;
const PersonChangeScreeningPage = ()=>{
    const { id } = (0, _reactRouter.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [screeningType, setScreeningType] = (0, _react.useState)("MONITORING");
    const [isControlConfirmationActive, setControlConfirmationActive] = (0, _react.useState)(false);
    const { backButtonURL, goToCustomerDetails } = (0, _useCustomerDetailsBackButtonDefault.default)(id, "person");
    const { isLoading, isError, error, data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).PERSON_CHANGE_SCREENING,
        id
    ], ()=>Promise.all([
            (0, _apiDefault.default).getPersonCustomerDetails(id),
            (0, _apiDefault.default).getPersonScreeningConfiguration(id)
        ]));
    const changeScreeningMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updatePersonScreeningConfiguration(id, {
            screening_type: screeningType
        }), {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).PERSON_CHANGE_SCREENING,
                id
            ]);
            goToCustomerDetails(f("screening.snackbar.started"));
        }
    });
    const screening = data ? data[PERSON_SCREENING_RESPONSE_INDEX] : undefined;
    const isNewScreening = screening?.screening_status && screening.screening_status === "DONE";
    const customerName = screening?.customer_name || "";
    (0, _react.useEffect)(()=>{
        if (screening?.screening_type) setScreeningType(screening.screening_type);
    }, [
        screening?.screening_type
    ]);
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPageDefault.default), {
        error: error
    });
    if (isLoading || !data) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningSkeletonDefault.default), {});
    const person = data[PERSON_DETAILS_RESPONSE_INDEX];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stopScreeningModalDefault.default), {
                id: id,
                isOpen: isControlConfirmationActive,
                isPerson: true,
                onStop: ()=>{
                    setControlConfirmationActive(false);
                    goToCustomerDetails(f("screening.snackbar.stopped"));
                },
                onClose: ()=>{
                    setControlConfirmationActive(false);
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                        url: backButtonURL,
                        displayLabel: customerName,
                        showAsLink: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "heading2xl",
                        as: "p",
                        children: !isNewScreening ? f("change-screening.titles.screening-title") : f("change-screening.titles.new-screening")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "4",
                                children: [
                                    !isNewScreening && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                        distribution: "equalSpacing",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                                alignment: "center",
                                                spacing: "tight",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                        variant: "bodyMd",
                                                        as: "span",
                                                        fontWeight: "semibold",
                                                        children: "Status:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: f(`screening-type.${screeningType}`)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningStatusBadgeDefault.default), {
                                                        screening: {
                                                            screening_status: screening.screening_status,
                                                            screening_type: screeningType
                                                        }
                                                    }),
                                                    (0, _screening.isScreeningActive)(screening) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Badge), {
                                                        status: "success",
                                                        progress: "complete",
                                                        children: f("screening.status.active")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                                onClick: ()=>setControlConfirmationActive(true),
                                                children: f("change-screening.buttons.stop-monitoring")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "headingLg",
                                        as: "p",
                                        children: f("change-screening.titles.screening-person")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                                            columnContentTypes: [
                                                "text"
                                            ],
                                            headings: [],
                                            rows: [
                                                [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                                                        type: "person",
                                                        name: (0, _displayHelpers.getPersonDisplayName)(person),
                                                        birthDate: (0, _displayHelpers.getBirthDate)(person)
                                                    })
                                                ]
                                            ]
                                        })
                                    }),
                                    isNewScreening && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                        gap: "4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                variant: "headingXl",
                                                as: "p",
                                                children: f("change-screening.titles.choose-screening-type")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningTypeCardDefault.default), {
                                                        screeningType: screeningType,
                                                        onScreeningTypeChange: (newValue)=>setScreeningType(newValue)
                                                    })
                                                })
                                            }),
                                            changeScreeningMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                                                message: changeScreeningMutation.error
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                gap: "4",
                                                align: "end",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                                        disabled: changeScreeningMutation.isLoading,
                                                        onClick: ()=>goToCustomerDetails(),
                                                        children: f("default.cancel")
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                                        primary: true,
                                                        disabled: changeScreeningMutation.isLoading || !screeningType,
                                                        loading: changeScreeningMutation.isLoading,
                                                        onClick: changeScreeningMutation.mutate,
                                                        children: f("change-screening.buttons.start-screening")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = PersonChangeScreeningPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router":"5RYYS","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/BackButton/BackButton":"4fa4k","../../components/DisplayName/DisplayName":"gKd5g","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/ScreeningSkeleton/ScreeningSkeleton":"kuEJQ","../../components/ScreeningStatusBadge/ScreeningStatusBadge":"bGehF","../../components/ScreeningTypeCard/ScreeningTypeCard":"2sGBG","../../components/SectionMargin/SectionMargin":"l3u8a","../../components/StopScreeningModal/StopScreeningModal":"edWFg","../../constants/queries-keys":"6hYSF","../../helpers/display.helpers":"2q3xY","../../helpers/screening":"aJP5k","../../hooks/useCustomerDetailsBackButton":"3YBG0","../../hooks/useFormatMessage":"8Y8fq","../ErrorPage":"8Le05","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6F44I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _cardNavigationSection = require("../../components/CardNavigationSection/CardNavigationSection");
var _cardNavigationSectionDefault = parcelHelpers.interopDefault(_cardNavigationSection);
var _collapsibleSection = require("../../components/CollapsibleSection/CollapsibleSection");
var _collapsibleSectionDefault = parcelHelpers.interopDefault(_collapsibleSection);
var _customerDetailsHeader = require("../../components/CustomerDetailsHeader/CustomerDetailsHeader");
var _customerDetailsHeaderDefault = parcelHelpers.interopDefault(_customerDetailsHeader);
var _customerFeaturesSection = require("../../components/CustomerFeaturesSection/CustomerFeaturesSection");
var _customerFeaturesSectionDefault = parcelHelpers.interopDefault(_customerFeaturesSection);
var _customerNotesSection = require("../../components/CustomerNotesSection/CustomerNotesSection");
var _customerNotesSectionDefault = parcelHelpers.interopDefault(_customerNotesSection);
var _customerReviewsSection = require("../../components/CustomerReviewsSection/CustomerReviewsSection");
var _customerReviewsSectionDefault = parcelHelpers.interopDefault(_customerReviewsSection);
var _detailsSkeleton = require("../../components/DetailsSkeleton/DetailsSkeleton");
var _detailsSkeletonDefault = parcelHelpers.interopDefault(_detailsSkeleton);
var _disclosureDocumentSection = require("../../components/DisclosureDocumentSection/DisclosureDocumentSection");
var _disclosureDocumentSectionDefault = parcelHelpers.interopDefault(_disclosureDocumentSection);
var _matchCasesSection = require("../../components/MatchCasesSection/MatchCasesSection");
var _matchCasesSectionDefault = parcelHelpers.interopDefault(_matchCasesSection);
var _navigationSection = require("../../components/NavigationSection/NavigationSection");
var _navigationSectionDefault = parcelHelpers.interopDefault(_navigationSection);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _pageAnchors = require("../../constants/page-anchors");
var _queriesKeys = require("../../constants/queries-keys");
var _displayHelpers = require("../../helpers/display.helpers");
var _onboardingHelpers = require("../../helpers/onboarding.helpers");
var _screening = require("../../helpers/screening");
var _useAppTitle = require("../../hooks/useAppTitle");
var _useAppTitleDefault = parcelHelpers.interopDefault(_useAppTitle);
var _useCustomerDetailsRefresh = require("../../hooks/useCustomerDetailsRefresh");
var _useCustomerDetailsRefreshDefault = parcelHelpers.interopDefault(_useCustomerDetailsRefresh);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _personInfoSection = require("./PersonInfoSection");
var _personInfoSectionDefault = parcelHelpers.interopDefault(_personInfoSection);
const PersonDetailsPage = ({ data: person })=>{
    const f = (0, _useFormatMessageDefault.default)();
    (0, _useAppTitleDefault.default)((0, _displayHelpers.getPersonDisplayName)(person));
    (0, _useCustomerDetailsRefreshDefault.default)(person);
    const hasFinishedOnboarding = (0, _onboardingHelpers.isOnboardingFinished)(person);
    const readonly = person.is_archived || !hasFinishedOnboarding;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationSectionDefault.default), {
                                anchor: (0, _pageAnchors.PAGE_ANCHORS).TOP_SECTION,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerDetailsHeaderDefault.default), {
                                    customer: person
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                            flush: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationSectionDefault.default), {
                                anchor: (0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_DETAILS,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsibleSectionDefault.default), {
                                    showPrefix: true,
                                    title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "bodyMd",
                                        as: "span",
                                        children: f("person.details.title")
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personInfoSectionDefault.default), {
                                        person: person,
                                        readonly: readonly
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).CUSTOMER_MATCH_CASES,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matchCasesSectionDefault.default), {
                        customerId: person.id,
                        customerType: person.type,
                        hasFinishedOnboarding: hasFinishedOnboarding,
                        matchCases: person.match_cases,
                        isScreeningStarting: (0, _screening.isScreeningStarting)(person.screening),
                        isScreeningActive: (0, _screening.isScreeningActive)(person.screening),
                        readonly: readonly
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).DISCLOSURES_SECTION,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureDocumentSectionDefault.default), {
                        customerId: person.id,
                        customerType: "person",
                        disclosureDocuments: person.disclosure_documents,
                        readonly: readonly,
                        addButtonLabel: f("common.buttons.actions.new-disclosure"),
                        emptyLabel: f("disclosure-documents.empty"),
                        assignments: person.assignments
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerFeaturesSectionDefault.default), {
                        customer: person,
                        readonly: readonly
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).REVIEWS_SECTION,
                    bottom: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewsSectionDefault.default), {
                        customer: person,
                        readonly: readonly
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                    size: "medium"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerNotesSectionDefault.default), {
                        customer: person,
                        readonly: readonly
                    })
                })
            ]
        })
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(PersonDetailsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).PERSON_DETAILS,
    apiFunction: (0, _apiDefault.default).getPersonCustomerDetails,
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/CardNavigationSection/CardNavigationSection":"fANmn","../../components/CollapsibleSection/CollapsibleSection":"3po8A","../../components/CustomerDetailsHeader/CustomerDetailsHeader":"ah8Q4","../../components/CustomerFeaturesSection/CustomerFeaturesSection":"2kHZk","../../components/CustomerNotesSection/CustomerNotesSection":"5nVqt","../../components/CustomerReviewsSection/CustomerReviewsSection":"jtFVT","../../components/DetailsSkeleton/DetailsSkeleton":"lj8DC","../../components/DisclosureDocumentSection/DisclosureDocumentSection":"434BH","../../components/MatchCasesSection/MatchCasesSection":"6mVwc","../../components/NavigationSection/NavigationSection":"ayv4V","../../components/SectionMargin/SectionMargin":"l3u8a","../../constants/page-anchors":"4WmvA","../../constants/queries-keys":"6hYSF","../../helpers/display.helpers":"2q3xY","../../helpers/onboarding.helpers":"fMYah","../../helpers/screening":"aJP5k","../../hooks/useAppTitle":"51tmg","../../hooks/useCustomerDetailsRefresh":"hSjF4","../../hooks/useFormatMessage":"8Y8fq","./PersonInfoSection":"9YqWL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9YqWL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _addressInfo = require("../../components/AddressInfo/AddressInfo");
var _addressInfoDefault = parcelHelpers.interopDefault(_addressInfo);
var _country = require("../../components/Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _editCustomerDetailsButton = require("../../components/EditCustomerDetailsButton/EditCustomerDetailsButton");
var _editCustomerDetailsButtonDefault = parcelHelpers.interopDefault(_editCustomerDetailsButton);
var _infoTable = require("../../components/InfoTable/InfoTable");
var _infoTableDefault = parcelHelpers.interopDefault(_infoTable);
var _tooltipWrapper = require("../../components/TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _useCountries = require("../../hooks/useCountries");
var _useCountriesDefault = parcelHelpers.interopDefault(_useCountries);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _dateUtils = require("../../utils/dateUtils");
const PersonInfoSection = (props)=>{
    const { person, readonly } = props;
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { formatDate } = (0, _reactIntl.useIntl)();
    const { getCountryName, getCountryRiskDescription, isHighRiskCountry } = (0, _useCountriesDefault.default)();
    const nationalIdTooltip = `${person.national_id_country ? getCountryName(person.national_id_country, true) : ""} ${person.national_id}`;
    const rows = [
        features.EXTERNAL_ID ? {
            label: f("person.details.caption.externalId"),
            value: person.external_id || "-"
        } : undefined,
        {
            label: f("person.details.caption.first.name"),
            value: person.first_name
        },
        {
            label: f("person.details.caption.last.name"),
            value: person.last_name
        },
        {
            label: f("person.details.caption.birth.date"),
            value: (0, _dateUtils.isValidDate)(person.birth_date) ? formatDate(person.birth_date) : person.birth_year?.toFixed(0) || "-"
        },
        {
            label: f("person.details.caption.person.number"),
            value: person.national_id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                content: nationalIdTooltip,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: "*****"
                })
            }) : f("not.specified")
        },
        person.country_of_origin ? {
            label: f("person.details.caption.origin"),
            value: person.country_of_origin ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: person.country_of_origin
            }) : "-",
            isWarning: isHighRiskCountry(person.country_of_origin),
            warningDescription: getCountryRiskDescription(person.country_of_origin)
        } : undefined,
        {
            label: f("person.details.caption.citizenship"),
            value: person.country_of_citizenship ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: person.country_of_citizenship
            }) : "-",
            isWarning: isHighRiskCountry(person.country_of_citizenship),
            warningDescription: getCountryRiskDescription(person.country_of_citizenship)
        },
        {
            label: f("person.details.caption.residence"),
            value: person.country_of_residence ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
                country: person.country_of_residence
            }) : "-",
            isWarning: isHighRiskCountry(person.country_of_residence),
            warningDescription: getCountryRiskDescription(person.country_of_residence)
        },
        {
            label: f("person.details.caption.address"),
            value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressInfoDefault.default), {
                address: person.address
            })
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                customer: person,
                readonly: readonly
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoTableDefault.default), {
                rows: rows,
                useCondensedLabels: true
            })
        ]
    });
};
const StyledButton = (0, _styledComponentsDefault.default)((0, _editCustomerDetailsButtonDefault.default))`
  margin: var(--p-space-4);
`;
exports.default = PersonInfoSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../components/AddressInfo/AddressInfo":"9YtjF","../../components/Country/Country":"eeWSc","../../components/EditCustomerDetailsButton/EditCustomerDetailsButton":"aUsoK","../../components/InfoTable/InfoTable":"b83NY","../../components/TooltipWrapper/TooltipWrapper":"b5W2d","../../hooks/useCountries":"azDTp","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../utils/dateUtils":"euvUV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8685K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _disclosureSignatureForm = require("../../components/DisclosureSignatureForm/DisclosureSignatureForm");
var _disclosureSignatureFormDefault = parcelHelpers.interopDefault(_disclosureSignatureForm);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _personDisclosureSkeleton = require("../../components/PersonDisclosureSkeleton/PersonDisclosureSkeleton");
var _personDisclosureSkeletonDefault = parcelHelpers.interopDefault(_personDisclosureSkeleton);
var _queriesKeys = require("../../constants/queries-keys");
var _assignmentsHelpers = require("../../helpers/assignments.helpers");
var _displayHelpers = require("../../helpers/display.helpers");
var _useCreatePersonDisclosure = require("../../hooks/useCreatePersonDisclosure");
var _useCreatePersonDisclosureDefault = parcelHelpers.interopDefault(_useCreatePersonDisclosure);
var _useCustomerDetailsBackButton = require("../../hooks/useCustomerDetailsBackButton");
var _useCustomerDetailsBackButtonDefault = parcelHelpers.interopDefault(_useCustomerDetailsBackButton);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useValidateDisclosureForm = require("../../hooks/useValidateDisclosureForm");
var _useValidateDisclosureFormDefault = parcelHelpers.interopDefault(_useValidateDisclosureForm);
const PersonRequestDisclosurePage = ({ data: person })=>{
    const { id, assignmentId } = (0, _reactRouterDom.useParams)();
    const history = (0, _reactRouterDom.useHistory)();
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const validateForm = (0, _useValidateDisclosureFormDefault.default)();
    const [isAssignmentSelectionValid, setIsAssignmentSelectionValid] = (0, _react.useState)(true);
    // force AssignmentSelector to show an error if assignment selection is invalid only after the create request button was clicked
    const [forceShowInvalidSelectionError, setForceShowInvalidSelectionError] = (0, _react.useState)(false);
    const { createDisclosureMutation, signature, setSignature, selectedAssignment, setSelectedAssignment } = (0, _useCreatePersonDisclosureDefault.default)(id, person.email, person.assignments, assignmentId);
    // if features.ASSIGNMENTS__HIDE_DETAILS is enabled, do not use the assignment id to return to the
    // assignment details page since it is going to be hidden
    const { backButtonURL } = (0, _useCustomerDetailsBackButtonDefault.default)(id, "person", features.ASSIGNMENTS__HIDE_DETAILS ? undefined : selectedAssignment?.id);
    const backPageLabel = `${(0, _displayHelpers.getPersonDisplayName)(person)}${!features.ASSIGNMENTS__HIDE_DETAILS && selectedAssignment ? ` / ${selectedAssignment.name}` : ""}`;
    // after a new disclosure is created return back to the assignment details page or person details page
    const navigateToDetailsPage = ()=>{
        if (backButtonURL) history.push(backButtonURL);
        else history.goBack();
    };
    const handleContinue = ()=>{
        if (isAssignmentSelectionValid) createDisclosureMutation.mutate(undefined, {
            onSuccess: navigateToDetailsPage
        });
        else setForceShowInvalidSelectionError(true);
    };
    if (!signature) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personDisclosureSkeletonDefault.default), {});
    const isFormValid = validateForm([
        signature
    ]);
    const assignments = person.assignments?.filter((0, _assignmentsHelpers.isActiveAssignment));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                            url: backButtonURL,
                            displayLabel: backPageLabel,
                            showAsLink: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "heading2xl",
                            as: "p",
                            children: f("disclosure-request.title")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _disclosureSignatureFormDefault.default), {
                            signature: signature,
                            customerId: person.id,
                            customerType: "person",
                            signatureName: (0, _displayHelpers.getPersonDisplayName)(person),
                            readonly: createDisclosureMutation.isLoading,
                            forceShowError: forceShowInvalidSelectionError,
                            assignments: assignments,
                            disableAssignmentSelection: assignmentId !== undefined,
                            selectedAssignment: selectedAssignment,
                            onChange: setSignature,
                            onAssignmentChange: (assignment, isValidSelection)=>{
                                setIsAssignmentSelectionValid(isValidSelection);
                                setSelectedAssignment(assignment);
                                // clear force show - the AssignmentSelector will deal with showing error from now
                                setForceShowInvalidSelectionError(false);
                            }
                        })
                    })
                }),
                createDisclosureMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: createDisclosureMutation.error
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                            url: backButtonURL
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            disabled: !isFormValid,
                            loading: createDisclosureMutation.isLoading,
                            primary: true,
                            onClick: handleContinue,
                            children: f("disclosure-request.button.send")
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(PersonRequestDisclosurePage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).PERSON_DETAILS,
    apiFunction: (id, _, options)=>(0, _apiDefault.default).getPersonCustomerDetails(id, options),
    paramNames: [
        "id",
        "assignmentId"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personDisclosureSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/BackButton/BackButton":"4fa4k","../../components/DisclosureSignatureForm/DisclosureSignatureForm":"ayCrt","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/PersonDisclosureSkeleton/PersonDisclosureSkeleton":"iwQxR","../../constants/queries-keys":"6hYSF","../../helpers/assignments.helpers":"7t8rY","../../helpers/display.helpers":"2q3xY","../../hooks/useCreatePersonDisclosure":"gmF4l","../../hooks/useCustomerDetailsBackButton":"3YBG0","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useValidateDisclosureForm":"6IoRW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iwQxR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _useCustomerDetailsBackButton = require("../../hooks/useCustomerDetailsBackButton");
var _useCustomerDetailsBackButtonDefault = parcelHelpers.interopDefault(_useCustomerDetailsBackButton);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _backButton = require("../BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
const PersonDisclosureSkeleton = ()=>{
    const { id, assignmentId } = (0, _reactRouterDom.useParams)();
    const f = (0, _useFormatMessageDefault.default)();
    const { backButtonURL } = (0, _useCustomerDetailsBackButtonDefault.default)(id, "person", assignmentId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                            url: backButtonURL,
                            displayLabel: "...",
                            showAsLink: true,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "heading2xl",
                            as: "p",
                            children: f("disclosure-request.title")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {})
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 5
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                            url: backButtonURL,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                            disabled: true,
                            primary: true,
                            children: f("disclosure-request.button.send")
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = PersonDisclosureSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../hooks/useCustomerDetailsBackButton":"3YBG0","../../hooks/useFormatMessage":"8Y8fq","../BackButton/BackButton":"4fa4k","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gmF4l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _collectionUtils = require("../utils/collectionUtils");
var _useDisclosureAssignment = require("./useDisclosureAssignment");
var _useDisclosureAssignmentDefault = parcelHelpers.interopDefault(_useDisclosureAssignment);
var _useGetOnboardingConfiguration = require("./useGetOnboardingConfiguration");
var _useGetOnboardingConfigurationDefault = parcelHelpers.interopDefault(_useGetOnboardingConfiguration);
var _useQueryData = require("./useQueryData");
const useCreatePersonDisclosure = (customerId, email, assignments, assignmentId // the assignment id from the URL param
)=>{
    const defaultSignatureConfiguration = (0, _useGetOnboardingConfigurationDefault.default)("person");
    const updatePersonQueryData = (0, _useQueryData.useCustomerDetailsQueryData)({
        type: "person",
        id: customerId
    });
    const updateAssignmentInPersonDetails = (assignment)=>updatePersonQueryData((queryData)=>{
            if (queryData.assignments) queryData.assignments = (0, _collectionUtils.updateItem)(queryData.assignments, assignment);
        });
    const [signature, setSignature] = (0, _react.useState)();
    const { selectedAssignment, setSelectedAssignment, shouldUpdateAssignment, updateAssignmentMutation } = (0, _useDisclosureAssignmentDefault.default)(customerId, assignmentId, assignments, updateAssignmentInPersonDetails);
    // set default signature if current signature is empty
    (0, _react.useEffect)(()=>{
        if (defaultSignatureConfiguration && !signature) setSignature({
            ...defaultSignatureConfiguration.signature_settings,
            email,
            assignment_id: selectedAssignment?.id
        });
    }, [
        defaultSignatureConfiguration,
        signature === undefined
    ]);
    const createDisclosureMutation = (0, _reactQuery.useMutation)(async ()=>{
        // if SHOW_ASSIGNMENTS_IN_DISCLOSURE_FORM is enabled and was changed - update the assignment be
        if (shouldUpdateAssignment) await updateAssignmentMutation.mutateAsync();
        return (0, _apiDefault.default).createPersonCustomerDisclosureDocument(customerId, {
            ...signature,
            assignment_id: selectedAssignment?.id
        });
    }, {
        onSuccess: async (response)=>{
            // Add the newly created disclosure document to the start of the array of customer details
            updatePersonQueryData((queryData)=>queryData.disclosure_documents.unshift(response));
        }
    });
    return {
        createDisclosureMutation,
        signature,
        setSignature,
        selectedAssignment,
        setSelectedAssignment
    };
};
exports.default = useCreatePersonDisclosure;

},{"react":"cOWTg","@tanstack/react-query":"91Vyq","../api":"f6lXD","../utils/collectionUtils":"gr5mc","./useDisclosureAssignment":"0tZFn","./useGetOnboardingConfiguration":"27sqE","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aSxYy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _planUpdateProjectsPng = require("../../../assets/images/plan-update-projects.png");
var _planUpdateProjectsPngDefault = parcelHelpers.interopDefault(_planUpdateProjectsPng);
var _externalUrls = require("../../constants/external-urls");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const PlanConversionProjectPage = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    secondary: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        alt: f("plan-conversion.projects.image.alt-text"),
                        width: "100%",
                        height: "100%",
                        loading: "lazy",
                        src: (0, _planUpdateProjectsPngDefault.default)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "heading2xl",
                                as: "p",
                                children: f("projects.page.title")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                children: f("plan-conversion.projects.description")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                children: f("plan-conversion.messages.access-feature")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                                url: (0, _externalUrls.PLAN_CONVERSION_PAGE),
                                external: true,
                                children: f("plan-conversion.banner.labels.link")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
exports.default = PlanConversionProjectPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/images/plan-update-projects.png":"eiOHa","../../constants/external-urls":"bvBLe","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eiOHa":[function(require,module,exports) {
module.exports = require("e6c6fd49fb0658d0").getBundleURL("kEMsi") + "plan-update-projects.3aeb1de4.png";

},{"e6c6fd49fb0658d0":"75UoR"}],"jIjKD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addFileButton = require("../../components/AddFileButton/AddFileButton");
var _addFileButtonDefault = parcelHelpers.interopDefault(_addFileButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _attachmentsSection = require("../../components/AttachmentsSection/AttachmentsSection");
var _attachmentsSectionDefault = parcelHelpers.interopDefault(_attachmentsSection);
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _cardNavigationSection = require("../../components/CardNavigationSection/CardNavigationSection");
var _cardNavigationSectionDefault = parcelHelpers.interopDefault(_cardNavigationSection);
var _detailsSkeleton = require("../../components/DetailsSkeleton/DetailsSkeleton");
var _detailsSkeletonDefault = parcelHelpers.interopDefault(_detailsSkeleton);
var _externalNavigationLink = require("../../components/ExternalNavigationLink/ExternalNavigationLink");
var _externalNavigationLinkDefault = parcelHelpers.interopDefault(_externalNavigationLink);
var _projectNotesSection = require("../../components/ProjectNotesSection/ProjectNotesSection");
var _projectNotesSectionDefault = parcelHelpers.interopDefault(_projectNotesSection);
var _pageAnchors = require("../../constants/page-anchors");
var _queriesKeys = require("../../constants/queries-keys");
var _integrationHelpers = require("../../helpers/integration.helpers");
var _useAppTitle = require("../../hooks/useAppTitle");
var _useAppTitleDefault = parcelHelpers.interopDefault(_useAppTitle);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSetLocationState = require("../../hooks/useSetLocationState");
var _useSetLocationStateDefault = parcelHelpers.interopDefault(_useSetLocationState);
var _basicProjectInfo = require("./BasicProjectInfo/BasicProjectInfo");
var _basicProjectInfoDefault = parcelHelpers.interopDefault(_basicProjectInfo);
var _projectActionsMenu = require("./ProjectActionsMenu/ProjectActionsMenu");
var _projectActionsMenuDefault = parcelHelpers.interopDefault(_projectActionsMenu);
var _projectCustomersSection = require("./ProjectCustomersSection/ProjectCustomersSection");
var _projectCustomersSectionDefault = parcelHelpers.interopDefault(_projectCustomersSection);
var _useProjectDetailsBackButton = require("./useProjectDetailsBackButton");
var _useProjectDetailsBackButtonDefault = parcelHelpers.interopDefault(_useProjectDetailsBackButton);
const ProjectDetailsPage = ({ data: project })=>{
    (0, _useAppTitleDefault.default)(project.name);
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { backButtonURL } = (0, _useProjectDetailsBackButtonDefault.default)();
    const isVitec = (0, _integrationHelpers.isVitecProject)(project);
    (0, _useSetLocationStateDefault.default)("fromProject", {
        id: project.id,
        name: project.name
    });
    const [uploadingFilesCount, setUploadingFilesCount] = (0, _react.useState)(0);
    const showAttachments = !isVitec && features.ATTACHMENTS;
    const showNotes = !isVitec;
    const readonly = project.status !== "ACTIVE";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    anchor: (0, _pageAnchors.PAGE_ANCHORS).TOP_SECTION,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                                url: backButtonURL,
                                displayLabel: f("projects.page.title"),
                                showAsLink: true
                            }),
                            isVitec && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
                                title: f("project.banner.vitec.label"),
                                status: "info",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: f("project.banner.vitec.imported.text")
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                blockAlign: "baseline",
                                align: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "4",
                                        blockAlign: "baseline",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                variant: "heading2xl",
                                                as: "p",
                                                children: project.name
                                            }),
                                            isVitec && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalNavigationLinkDefault.default), {
                                                url: project.integrations?.vitec_data?.vitec_url,
                                                children: f("project.button.imported-from-vitec")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectActionsMenuDefault.default), {
                                        project: project,
                                        readonly: readonly
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _basicProjectInfoDefault.default), {
                                project: project,
                                readonly: readonly
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectCustomersSectionDefault.default), {
                        project: project,
                        readonly: readonly
                    })
                }),
                showAttachments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachmentsSectionDefault.default), {
                        entity: project,
                        readonly: readonly,
                        uploadingFilesCount: uploadingFilesCount,
                        fetchSuggestedSigners: ()=>(0, _apiDefault.default).getProjectCustomersDetails(project.id).then((response)=>response.customers),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addFileButtonDefault.default), {
                            entity: project,
                            onFileUploadingStart: (filesCount)=>setUploadingFilesCount(filesCount),
                            onFileUploadingFinish: ()=>setUploadingFilesCount(0)
                        })
                    })
                }),
                showNotes && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNavigationSectionDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectNotesSectionDefault.default), {
                        project: project,
                        readonly: readonly
                    })
                })
            ]
        })
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(ProjectDetailsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
    apiFunction: (0, _apiDefault.default).getProject,
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AddFileButton/AddFileButton":"7ZmVz","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/AttachmentsSection/AttachmentsSection":"1J3Nq","../../components/BackButton/BackButton":"4fa4k","../../components/CardNavigationSection/CardNavigationSection":"fANmn","../../components/DetailsSkeleton/DetailsSkeleton":"lj8DC","../../components/ExternalNavigationLink/ExternalNavigationLink":"51TTg","../../components/ProjectNotesSection/ProjectNotesSection":"dwejQ","../../constants/page-anchors":"4WmvA","../../constants/queries-keys":"6hYSF","../../helpers/integration.helpers":"keU9B","../../hooks/useAppTitle":"51tmg","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSetLocationState":"f0MAX","./BasicProjectInfo/BasicProjectInfo":"bTwOg","./ProjectActionsMenu/ProjectActionsMenu":"gxos5","./ProjectCustomersSection/ProjectCustomersSection":"6Jgen","./useProjectDetailsBackButton":"6Or2Z","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dwejQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notesHelpers = require("../../helpers/notes.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useProjectCreateNoteMutation = require("../../hooks/useProjectCreateNoteMutation");
var _useProjectCreateNoteMutationDefault = parcelHelpers.interopDefault(_useProjectCreateNoteMutation);
var _notesSection = require("../NotesSection/NotesSection");
var _notesSectionDefault = parcelHelpers.interopDefault(_notesSection);
const ProjectNotesSection = (props)=>{
    const { project, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const createNoteMutation = (0, _useProjectCreateNoteMutationDefault.default)(project.id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notesSectionDefault.default), {
        notes: project.reviews.map((0, _notesHelpers.convertPreviewReviewToNote)),
        readonly: readonly,
        placeholder: f("project.notes.placeholder"),
        createNoteMutation: createNoteMutation
    });
};
exports.default = ProjectNotesSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../helpers/notes.helpers":"10TqV","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useProjectCreateNoteMutation":"6r371","../NotesSection/NotesSection":"jTr9t","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6r371":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useProjectCreateNoteMutation = (projectId)=>{
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        projectId
    ]);
    const createNoteMutation = (0, _reactQuery.useMutation)((comment)=>(0, _apiDefault.default).createProjectReview(projectId, {
            comment
        }), {
        onSuccess: (newNote)=>{
            updateQueryData((prevData)=>prevData.reviews = [
                    newNote,
                    ...prevData.reviews
                ]);
        }
    });
    return createNoteMutation;
};
exports.default = useProjectCreateNoteMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f0MAX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
/**
 * Sets an entry in the location state for the current location in order for AdapterLink
 * to access it and inject it into links created in the current location page.
 *
 * @see AdapterLink
 *
 * @param stateKey
 * @param stateValue
 */ function useSetLocationState(stateKey, stateValue) {
    const history = (0, _reactRouterDom.useHistory)();
    const isStateEmpty = !history.location.state || history.location.state[stateKey] === undefined;
    if (isStateEmpty) {
        console.debug("useSetLocationState", history.location.pathname, {
            ...history.location.state,
            [stateKey]: stateValue
        });
        history.replace(history.location.pathname, {
            ...history.location.state || {},
            [stateKey]: stateValue
        });
    }
}
exports.default = useSetLocationState;

},{"react-router-dom":"1ee65","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bTwOg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _detailsGrid = require("../../../components/DetailsGrid/DetailsGrid");
var _detailsGridDefault = parcelHelpers.interopDefault(_detailsGrid);
var _kdkbanner = require("../../../components/KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _projectStatus = require("../../../components/ProjectStatus/ProjectStatus");
var _projectStatusDefault = parcelHelpers.interopDefault(_projectStatus);
var _useFeatures = require("../../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _projectResponsibleUsersSelect = require("./ProjectResponsibleUsersSelect");
var _projectResponsibleUsersSelectDefault = parcelHelpers.interopDefault(_projectResponsibleUsersSelect);
const BasicProjectInfo = (props)=>{
    const { project, readonly } = props;
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { formatDate } = (0, _reactIntl.useIntl)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdkbannerDefault.default), {
        hideIcon: true,
        hideBorder: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailsGridDefault.default), {
            rows: 2,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: [
                        f("project.info.labels.status"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "bold",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectStatusDefault.default), {
                        status: project.status
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: [
                        f("project.info.labels.created"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    fontWeight: "bold",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        children: formatDate(project.created_dt)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: [
                        f("project.info.labels.description"),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDescription, {
                    children: project.description
                }),
                features.RESPONSIBLE_USER && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                            variant: "bodyMd",
                            as: "span",
                            children: [
                                f("project.info.labels.project-managers"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectResponsibleUsersSelectDefault.default), {
                            projectId: project.id,
                            responsibleUsers: project.responsible_users || [],
                            readonly: readonly
                        })
                    ]
                })
            ]
        })
    });
};
const StyledDescription = (0, _styledComponentsDefault.default).p`
  white-space: pre-wrap;
  word-break: break-all;
  font-weight: var(--p-font-weight-bold);
`;
exports.default = BasicProjectInfo;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../components/DetailsGrid/DetailsGrid":"dIEbw","../../../components/KDKBanner/KDKBanner":"3zPW6","../../../components/ProjectStatus/ProjectStatus":"gsvYx","../../../hooks/useFeatures":"hvBWb","../../../hooks/useFormatMessage":"8Y8fq","./ProjectResponsibleUsersSelect":"3yXTI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3yXTI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _usersSelect = require("../../../components/UsersSelect/UsersSelect");
var _usersSelectDefault = parcelHelpers.interopDefault(_usersSelect);
var _queriesKeys = require("../../../constants/queries-keys");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const ProjectResponsibleUsersSelect = (props)=>{
    const { projectId, responsibleUsers, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        projectId
    ]);
    const updateResponsibleUsers = (selectedUserIds)=>(0, _apiDefault.default).updateProject(projectId, {
            responsible_users: selectedUserIds
        }).then((response)=>response.responsible_users || []);
    const updateQueryCache = (responsibleUsers)=>updateQueryData((queryData)=>queryData.responsible_users = responsibleUsers);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersSelectDefault.default), {
        selectedUsers: responsibleUsers,
        emptySelectionLabel: f("project.info.manager.empty.user"),
        updateErrorMessage: f("project.info.manager.error"),
        readonly: readonly,
        strong: true,
        onUserSelection: updateResponsibleUsers,
        onAfterUserSelection: updateQueryCache
    });
};
exports.default = ProjectResponsibleUsersSelect;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../api":"f6lXD","../../../components/UsersSelect/UsersSelect":"k1Nxo","../../../constants/queries-keys":"6hYSF","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gxos5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _penLineSvg = require("../../../../assets/icons/pen-line.svg");
var _penLineSvgDefault = parcelHelpers.interopDefault(_penLineSvg);
var _restoreSvg = require("../../../../assets/icons/restore.svg");
var _restoreSvgDefault = parcelHelpers.interopDefault(_restoreSvg);
var _xmarkCircleSvg = require("../../../../assets/icons/xmark-circle.svg");
var _xmarkCircleSvgDefault = parcelHelpers.interopDefault(_xmarkCircleSvg);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _actionsDropdown = require("../../../components/ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _projectInfoModal = require("../../../components/ProjectInfoModal/ProjectInfoModal");
var _projectInfoModalDefault = parcelHelpers.interopDefault(_projectInfoModal);
var _queriesKeys = require("../../../constants/queries-keys");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _projectEndConfirmation = require("./ProjectEndConfirmation");
var _projectEndConfirmationDefault = parcelHelpers.interopDefault(_projectEndConfirmation);
const ProjectActionsMenu = (props)=>{
    const { project, readonly } = props;
    const [showInfoModal, toggleShowInfoModal, closeInfoModal] = (0, _useOpenCloseDefault.default)();
    const [showEndProjectConfirmation, toggleEndProjectConfirmation, closeEndProjectConfirmation] = (0, _useOpenCloseDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        project.id
    ]);
    const disabled = readonly || project.status !== "ACTIVE";
    const reactivateProjectMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updateProject(project.id, {
            status: "ACTIVE"
        }), {
        onSuccess: async (response)=>setQueryData(response)
    });
    const reactivateProject = ()=>reactivateProjectMutation.mutate();
    const actions = [
        {
            content: f("project.actions.labels.edit"),
            onAction: toggleShowInfoModal,
            image: (0, _penLineSvgDefault.default),
            disabled
        }
    ];
    if (project.status === "ACTIVE") actions.push({
        content: f("project.actions.labels.end-project"),
        onAction: toggleEndProjectConfirmation,
        image: (0, _xmarkCircleSvgDefault.default),
        disabled: reactivateProjectMutation.isLoading || readonly
    });
    if (project.status === "INACTIVE") actions.push({
        content: f("project.actions.labels.reactivate"),
        onAction: reactivateProject,
        image: (0, _restoreSvgDefault.default)
    });
    const resetErroneousMutation = ()=>{
        if (reactivateProjectMutation.isError) reactivateProjectMutation.reset();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: actions,
                loading: reactivateProjectMutation.isLoading,
                primary: true,
                size: "medium"
            }),
            reactivateProjectMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: reactivateProjectMutation.error,
                error: true,
                onDismiss: resetErroneousMutation
            }),
            showInfoModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectInfoModalDefault.default), {
                project: project,
                onClose: closeInfoModal
            }),
            showEndProjectConfirmation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectEndConfirmationDefault.default), {
                project: project,
                onClose: closeEndProjectConfirmation
            })
        ]
    });
};
exports.default = ProjectActionsMenu;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../assets/icons/pen-line.svg":"9iTi6","../../../../assets/icons/restore.svg":"hwxcs","../../../../assets/icons/xmark-circle.svg":"6JVeg","../../../api":"f6lXD","../../../components/ActionsDropdown/ActionsDropdown":"izRYG","../../../components/ProjectInfoModal/ProjectInfoModal":"bljDA","../../../constants/queries-keys":"6hYSF","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useOpenClose":"idooG","../../../hooks/useQueryData":"4laI9","./ProjectEndConfirmation":"2xm6F","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2xm6F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _confirmAction = require("../../../components/ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _queriesKeys = require("../../../constants/queries-keys");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const ProjectEndConfirmation = (props)=>{
    const { project, onClose } = props;
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        project.id
    ]);
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        apiCall: ()=>(0, _apiDefault.default).updateProject(project.id, {
                status: "INACTIVE"
            }),
        onSuccess: setQueryData,
        title: f("project.end.confirmation.title"),
        description: f("project.end.confirmation.description", {
            name: project.name
        }),
        actionTitle: f("project.end.confirmation.action.label", {
            name: project.name
        }),
        onNo: onClose
    });
};
exports.default = ProjectEndConfirmation;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../api":"f6lXD","../../../components/ConfirmAction/ConfirmAction":"icP5J","../../../constants/queries-keys":"6hYSF","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Jgen":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _companySvg = require("../../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _linesHorizontal3Svg = require("../../../../assets/icons/lines-horizontal-3.svg");
var _linesHorizontal3SvgDefault = parcelHelpers.interopDefault(_linesHorizontal3Svg);
var _personSvg = require("../../../../assets/icons/person.svg");
var _personSvgDefault = parcelHelpers.interopDefault(_personSvg);
var _plusMajorWhiteSvg = require("../../../../assets/icons/plus-major-white.svg");
var _plusMajorWhiteSvgDefault = parcelHelpers.interopDefault(_plusMajorWhiteSvg);
var _actionsDropdown = require("../../../components/ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _routes = require("../../../constants/routes");
var _integrationHelpers = require("../../../helpers/integration.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useSelectionMap = require("../../../hooks/useSelectionMap");
var _useSelectionMapDefault = parcelHelpers.interopDefault(_useSelectionMap);
var _useSetLocationState = require("../../../hooks/useSetLocationState");
var _useSetLocationStateDefault = parcelHelpers.interopDefault(_useSetLocationState);
var _addCustomersToProjectModal = require("./AddCustomersToProjectModal/AddCustomersToProjectModal");
var _addCustomersToProjectModalDefault = parcelHelpers.interopDefault(_addCustomersToProjectModal);
var _projectCustomersBulkActions = require("./ProjectCustomersBulkActions/ProjectCustomersBulkActions");
var _projectCustomersBulkActionsDefault = parcelHelpers.interopDefault(_projectCustomersBulkActions);
var _projectCustomerEmptyState = require("./ProjectCustomerEmptyState");
var _projectCustomerEmptyStateDefault = parcelHelpers.interopDefault(_projectCustomerEmptyState);
var _projectCustomersTable = require("./ProjectCustomersTable");
var _projectCustomersTableDefault = parcelHelpers.interopDefault(_projectCustomersTable);
const ProjectCustomersSection = (props)=>{
    const { project, readonly } = props;
    const [showCustomersSelectModal, toggleCustomersSelectModal, closeCustomersSelectModal] = (0, _useOpenCloseDefault.default)();
    const [selectedCustomersIds, selectedCustomers, handleSelectionChange, clearSelection] = (0, _useSelectionMapDefault.default)(project.customers);
    const f = (0, _useFormatMessageDefault.default)();
    const isVitec = (0, _integrationHelpers.isVitecProject)(project);
    const disabled = readonly || project.status !== "ACTIVE";
    const count = project.customers.length;
    /*
  onboarding links from the project details page should redirect the user
  to the onboarding pages for person or company and associate the new customers-section with this project.
  they should also display the project name.

  in order to associate the new customers-section with this project, the project id should be added to the
  api.createPersonCustomer or api.updateCompanyScreeningConfiguration.

  the mechanism to pass data between links is by using react router's link state object.
  when setting data in a link state, after navigating to that link (from within the application) the component
  rendered from that link can access the link's state and retrieve the information stored in it.

  the component that renders links is AdapterLink which is set as the Link component renderer in App.tsx:
  <AppProvider linkComponent={AdapterLink} ... />

  inside AdapterLink, the project id and name are retrieved from the current location state (the project details URL)
  and added to the created links state - the created links are for the onboarding of new customers-section.
*/ (0, _useSetLocationStateDefault.default)("createdFromProject", {
        id: project.id,
        name: project.name
    });
    const companyOnboardingPath = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).COMPANY_LOOKUP);
    const personOnboardingPath = (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).ONBOARDING_NEW_PERSON);
    const items = [
        {
            content: f("project.customers.buttons.add-existing-customers"),
            onAction: ()=>toggleCustomersSelectModal(),
            disabled: readonly,
            image: (0, _linesHorizontal3SvgDefault.default)
        },
        {
            content: f("project.customers.buttons.add-new-person-customer"),
            url: personOnboardingPath,
            disabled: readonly,
            image: (0, _personSvgDefault.default)
        },
        {
            content: f("project.customers.buttons.add-new-company-customer"),
            url: companyOnboardingPath,
            disabled: readonly,
            image: (0, _companySvgDefault.default)
        }
    ];
    const isAllSelected = count === selectedCustomersIds.length;
    const selectedLabel = isAllSelected ? f("customers.list.header.customers.count.all", {
        count
    }) : f("customers.list.header.customers.count", {
        count,
        selected: selectedCustomersIds.length
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                alignment: "trailing",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: count === 0 ? "0" : "6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "headingMd",
                                as: "h2",
                                children: f("project.customers.title")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "4",
                                blockAlign: "center",
                                children: [
                                    count > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableSelection, {
                                        children: selectedLabel
                                    }),
                                    selectedCustomersIds.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectCustomersBulkActionsDefault.default), {
                                        project: project,
                                        customers: selectedCustomers,
                                        readonly: readonly,
                                        onClearSelection: clearSelection
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                        fill: true
                    }),
                    !isVitec && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                        items: items,
                        icon: (0, _plusMajorWhiteSvgDefault.default),
                        title: f("project.customers.buttons.add-customers"),
                        disabled: disabled,
                        size: "medium",
                        primary: true
                    })
                ]
            }),
            count > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectCustomersTableDefault.default), {
                project: project,
                selectedCustomersIds: selectedCustomersIds,
                onSelectionChange: handleSelectionChange
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectCustomerEmptyStateDefault.default), {
                    project: project
                })
            }),
            showCustomersSelectModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addCustomersToProjectModalDefault.default), {
                project: project,
                readonly: readonly,
                onClose: closeCustomersSelectModal
            })
        ]
    });
};
const StyledTableSelection = (0, _styledComponentsDefault.default).p`
  min-height: var(--p-space-8);
  line-height: var(--p-space-8);
`;
exports.default = ProjectCustomersSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/company.svg":"luBbc","../../../../assets/icons/lines-horizontal-3.svg":"fCrVw","../../../../assets/icons/person.svg":"1Xt5L","../../../../assets/icons/plus-major-white.svg":"5HqsJ","../../../components/ActionsDropdown/ActionsDropdown":"izRYG","../../../constants/routes":"ihtm8","../../../helpers/integration.helpers":"keU9B","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useOpenClose":"idooG","../../../hooks/useSelectionMap":"i8gbg","../../../hooks/useSetLocationState":"f0MAX","./AddCustomersToProjectModal/AddCustomersToProjectModal":"jTFNs","./ProjectCustomersBulkActions/ProjectCustomersBulkActions":"gYWs8","./ProjectCustomerEmptyState":"6c5yM","./ProjectCustomersTable":"fKLi9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fCrVw":[function(require,module,exports) {
module.exports = require("44bc5d589ba3368e").getBundleURL("kEMsi") + "lines-horizontal-3.95c876a6.svg";

},{"44bc5d589ba3368e":"75UoR"}],"jTFNs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _errorPanel = require("../../../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _queriesKeys = require("../../../../constants/queries-keys");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _customersResourceList = require("./CustomersResourceList");
var _customersResourceListDefault = parcelHelpers.interopDefault(_customersResourceList);
const AddCustomersToProjectModal = (props)=>{
    const { project, readonly, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        project.id
    ]);
    const [page, setPage] = (0, _react.useState)(0);
    const [selectedIds, setSelectedIds] = (0, _react.useState)(project.customers.map((customer)=>customer.id));
    const addCustomersToProjectMutation = (0, _reactQuery.useMutation)(()=>(0, _apiDefault.default).updateProject(project.id, {
            customer_ids: selectedIds
        }), {
        onSuccess: (updatedProject)=>{
            setQueryData(updatedProject);
            onClose();
        }
    });
    const saveAction = {
        content: f("default.add"),
        onAction: ()=>addCustomersToProjectMutation.mutate(),
        disabled: readonly || addCustomersToProjectMutation.isLoading,
        loading: addCustomersToProjectMutation.isLoading
    };
    const cancelAction = {
        content: f("default.close"),
        onAction: onClose,
        disabled: addCustomersToProjectMutation.isLoading
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Modal), {
        open: true,
        title: f("project.customers.modal.title", {
            name: project.name
        }),
        onClose: onClose,
        primaryAction: saveAction,
        secondaryActions: [
            cancelAction
        ],
        onScrolledToBottom: ()=>setPage(page + 1),
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            variant: "bodyMd",
            as: "span",
            children: f("common.labels.selected-customers-count", {
                count: selectedIds.length
            })
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersResourceListDefault.default), {
                    page: page,
                    resetPage: ()=>setPage(0),
                    selectedIds: selectedIds,
                    existingCustomers: project.customers,
                    onSelectionChange: setSelectedIds
                })
            }),
            addCustomersToProjectMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: addCustomersToProjectMutation.error
            })
        ]
    });
};
exports.default = AddCustomersToProjectModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../../api":"f6lXD","../../../../components/ErrorPanel/ErrorPanel":"2hHqH","../../../../constants/queries-keys":"6hYSF","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useQueryData":"4laI9","./CustomersResourceList":"ej4G5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ej4G5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _displayName = require("../../../../components/DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _entitiesResourceList = require("../../../../components/EntitiesResourceList/EntitiesResourceList");
var _entitiesResourceListDefault = parcelHelpers.interopDefault(_entitiesResourceList);
var _queriesKeys = require("../../../../constants/queries-keys");
var _displayHelpers = require("../../../../helpers/display.helpers");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CustomersResourceList = (props)=>{
    const { existingCustomers = [], ...resourceListProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entitiesResourceListDefault.default), {
        getEntities: (searchParams)=>(0, _apiDefault.default).getCustomers(searchParams).then((response)=>response.customers),
        queryKey: (0, _queriesKeys.QUERIES_KEYS).CUSTOMERS_LIST,
        allowMultiple: true,
        queryPlaceholder: f("component.search.customers.hint"),
        renderItem: (customer)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                type: customer.type,
                name: (0, _displayHelpers.getCustomerName)(customer)
            }),
        existingEntities: existingCustomers,
        ...resourceListProps
    });
};
exports.default = CustomersResourceList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../api":"f6lXD","../../../../components/DisplayName/DisplayName":"gKd5g","../../../../components/EntitiesResourceList/EntitiesResourceList":"f9nUU","../../../../constants/queries-keys":"6hYSF","../../../../helpers/display.helpers":"2q3xY","../../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gYWs8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _xmarkCircleSvg = require("../../../../../assets/icons/xmark-circle.svg");
var _xmarkCircleSvgDefault = parcelHelpers.interopDefault(_xmarkCircleSvg);
var _actionsDropdown = require("../../../../components/ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _projectCustomersLabelPopover = require("./ProjectCustomersLabelPopover");
var _projectCustomersLabelPopoverDefault = parcelHelpers.interopDefault(_projectCustomersLabelPopover);
var _removeCustomersFromProjectConfirm = require("./RemoveCustomersFromProjectConfirm");
var _removeCustomersFromProjectConfirmDefault = parcelHelpers.interopDefault(_removeCustomersFromProjectConfirm);
const ProjectCustomersBulkActions = (props)=>{
    const { project, customers, readonly, onClearSelection } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showRemoveCustomersConfirm, toggleRemoveCustomersConfirm, closeRemoveCustomersConfirm] = (0, _useOpenCloseDefault.default)();
    const actions = [
        {
            content: f("project.customers.actions.remove-from-project"),
            disabled: customers.length === 0 || readonly,
            image: (0, _xmarkCircleSvgDefault.default),
            onAction: toggleRemoveCustomersConfirm
        }
    ];
    const handleSuccess = ()=>{
        closeRemoveCustomersConfirm();
        onClearSelection();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: actions,
                disabled: readonly,
                cutoff: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectCustomersLabelPopoverDefault.default), {
                project: project,
                customers: customers,
                readonly: readonly
            }),
            showRemoveCustomersConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeCustomersFromProjectConfirmDefault.default), {
                project: project,
                customers: customers,
                onClose: closeRemoveCustomersConfirm,
                onSuccess: handleSuccess
            })
        ]
    });
};
exports.default = ProjectCustomersBulkActions;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../../assets/icons/xmark-circle.svg":"6JVeg","../../../../components/ActionsDropdown/ActionsDropdown":"izRYG","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useOpenClose":"idooG","./ProjectCustomersLabelPopover":"gRpy6","./RemoveCustomersFromProjectConfirm":"j2AAu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gRpy6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _entitiesTagPopover = require("../../../../components/EntitiesTagPopover/EntitiesTagPopover");
var _entitiesTagPopoverDefault = parcelHelpers.interopDefault(_entitiesTagPopover);
var _queriesKeys = require("../../../../constants/queries-keys");
var _useQueryData = require("../../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const ProjectCustomersLabelPopover = (props)=>{
    const { project, customers, readonly } = props;
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        project.id
    ]);
    const updateProjectCustomers = (updatedCustomers)=>updateQueryData((queryData)=>// merge the updatedCustomers with existing project query cached customers
            queryData.customers = queryData.customers.map((customer)=>updatedCustomers.find((updatedCustomer)=>updatedCustomer.id === customer.id) || customer));
    const onAssignLabels = ({ entitiesIds, tagIds })=>{
        return (0, _apiDefault.default).batchSetLabelsOnProjectCustomers(project.id, {
            target_ids: entitiesIds,
            label_ids: tagIds
        }).then(({ customers })=>customers);
    };
    const onCreatedAndAssignLabel = (customersIds, title)=>(0, _apiDefault.default).batchCreateAndAssignLabelOnProjectCustomers(project.id, {
            target_ids: customersIds,
            title
        }).then(({ customers })=>customers);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entitiesTagPopoverDefault.default), {
        entities: customers,
        readonly: readonly,
        onUpdateEntities: updateProjectCustomers,
        onAssignTags: onAssignLabels,
        onCreatedAndAssignTag: onCreatedAndAssignLabel
    });
};
exports.default = ProjectCustomersLabelPopover;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../api":"f6lXD","../../../../components/EntitiesTagPopover/EntitiesTagPopover":"lx47p","../../../../constants/queries-keys":"6hYSF","../../../../hooks/useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j2AAu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _confirmAction = require("../../../../components/ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _queriesKeys = require("../../../../constants/queries-keys");
var _displayHelpers = require("../../../../helpers/display.helpers");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useQueryData = require("../../../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _useSnackbar = require("../../../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
const RemoveCustomersFromProjectConfirm = (props)=>{
    const { project, customers: customersToRemove, onClose, onSuccess } = props;
    const existingCustomers = project.customers;
    const customersIdsToRemove = customersToRemove.map((customer)=>customer.id);
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECT_DETAILS,
        project.id
    ]);
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const customersNamesLabel = formatMultipleNames(customersToRemove.map((0, _displayHelpers.getCustomerName)));
    const updatedProjectCustomersIds = existingCustomers.map((existingCustomer)=>existingCustomer.id).filter((existingCustomerId)=>!customersIdsToRemove.includes(existingCustomerId));
    const handleSuccess = (updatedProject)=>{
        setSnackbar(f("project.remove-customers.success.message", {
            count: customersToRemove.length
        }));
        setQueryData(updatedProject);
        onSuccess();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        isOpen: true,
        apiCall: ()=>(0, _apiDefault.default).updateProject(project.id, {
                customer_ids: updatedProjectCustomersIds
            }),
        onSuccess: handleSuccess,
        title: f("project.remove-customers.confirmation.title"),
        description: f("project.remove-customers.confirmation.description", {
            names: customersNamesLabel,
            projectName: project.name
        }),
        onNo: onClose,
        actionTitle: f("project.remove-customers.confirmation.action.label")
    });
};
exports.default = RemoveCustomersFromProjectConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../../api":"f6lXD","../../../../components/ConfirmAction/ConfirmAction":"icP5J","../../../../constants/queries-keys":"6hYSF","../../../../helpers/display.helpers":"2q3xY","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useFormatMultipleNames":"gogmY","../../../../hooks/useQueryData":"4laI9","../../../../hooks/useSnackbar":"gQ3G9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6c5yM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _externalNavigationLink = require("../../../components/ExternalNavigationLink/ExternalNavigationLink");
var _externalNavigationLinkDefault = parcelHelpers.interopDefault(_externalNavigationLink);
var _integrationHelpers = require("../../../helpers/integration.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ProjectCustomerEmptyState = (props)=>{
    const { project } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const isVitec = (0, _integrationHelpers.isVitecProject)(project);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.EmptyState), {
        heading: f("project.customers.empty.header"),
        image: "",
        children: [
            isVitec && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                inlineAlign: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        children: f("project.vitec.customers.empty.message")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalNavigationLinkDefault.default), {
                        url: project.integrations?.vitec_data?.vitec_url,
                        children: f("project.button.imported-from-vitec")
                    })
                ]
            }),
            !isVitec && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: f("project.customers.empty.message")
            })
        ]
    });
};
exports.default = ProjectCustomerEmptyState;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../components/ExternalNavigationLink/ExternalNavigationLink":"51TTg","../../../helpers/integration.helpers":"keU9B","../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fKLi9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _customersListTable = require("../../../components/CustomersListTable/CustomersListTable");
var _customersListTableDefault = parcelHelpers.interopDefault(_customersListTable);
var _integrationHelpers = require("../../../helpers/integration.helpers");
var _useProjectCustomersTableColumns = require("./useProjectCustomersTableColumns");
var _useProjectCustomersTableColumnsDefault = parcelHelpers.interopDefault(_useProjectCustomersTableColumns);
const ProjectCustomersTable = (props)=>{
    const { project, selectedCustomersIds, onSelectionChange } = props;
    const isVitec = (0, _integrationHelpers.isVitecProject)(project);
    const columns = (0, _useProjectCustomersTableColumnsDefault.default)(project);
    const count = project.customers.length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customersListTableDefault.default), {
        columns: columns,
        customers: project.customers,
        count: count,
        hidePagination: true,
        sortLocally: true,
        selectable: !isVitec,
        selectedIds: selectedCustomersIds,
        onSelectionChange: onSelectionChange
    });
};
exports.default = ProjectCustomersTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../../components/CustomersListTable/CustomersListTable":"27PCy","../../../helpers/integration.helpers":"keU9B","./useProjectCustomersTableColumns":"1bKRT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1bKRT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTable = require("@tanstack/react-table");
var _tableColumnHeader = require("../../../components/TableColumnHeader/TableColumnHeader");
var _tableColumnHeaderDefault = parcelHelpers.interopDefault(_tableColumnHeader);
var _vitecProjectProxies = require("../../../components/VitecProjectProxies/VitecProjectProxies");
var _vitecProjectProxiesDefault = parcelHelpers.interopDefault(_vitecProjectProxies);
var _integrationHelpers = require("../../../helpers/integration.helpers");
var _useCustomersTableColumns = require("../../../hooks/useCustomersTableColumns");
var _useCustomersTableColumnsDefault = parcelHelpers.interopDefault(_useCustomersTableColumns);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _vitecReportUploadStatus = require("./VitecReportUploadStatus");
var _vitecReportUploadStatusDefault = parcelHelpers.interopDefault(_vitecReportUploadStatus);
const useProjectCustomersTableColumns = (project)=>{
    const f = (0, _useFormatMessageDefault.default)();
    const isVitec = (0, _integrationHelpers.isVitecProject)(project);
    const renderProxies = (customer)=>{
        const vitecCustomers = project.integrations?.vitec_data?.customers;
        if (!vitecCustomers) return null;
        const vitecCustomer = vitecCustomers.find((vc)=>vc.id === customer.id);
        if (!vitecCustomer || !vitecCustomer.proxy_id) return null;
        const vitecProxyCustomer = vitecCustomers.find((vc)=>vc.id === vitecCustomer.proxy_id);
        const projectProxyCustomer = project.customers.find((pc)=>pc.id === vitecProxyCustomer?.id);
        if (!projectProxyCustomer) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vitecProjectProxiesDefault.default), {
            customer: projectProxyCustomer
        });
    };
    const projectCustomersColumns = (0, _useCustomersTableColumnsDefault.default)(undefined, undefined, isVitec ? renderProxies : undefined);
    const columnHelper = (0, _reactTable.createColumnHelper)();
    const vitecProjectCustomersTableColumns = [
        ...projectCustomersColumns
    ];
    // replace last column with report column
    vitecProjectCustomersTableColumns[projectCustomersColumns.length - 1] = columnHelper.display({
        header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableColumnHeaderDefault.default), {
                centered: true,
                children: f("customers.list.column.report")
            }),
        id: "report",
        cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vitecReportUploadStatusDefault.default), {
                reportStatus: project.integrations?.vitec_data?.customers.find((vitecCustomer)=>vitecCustomer.id === props.row.original.id)?.report?.status
            })
    });
    return isVitec ? vitecProjectCustomersTableColumns : projectCustomersColumns;
};
exports.default = useProjectCustomersTableColumns;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@tanstack/react-table":"86D8M","../../../components/TableColumnHeader/TableColumnHeader":"6jCSM","../../../components/VitecProjectProxies/VitecProjectProxies":"4UhCT","../../../helpers/integration.helpers":"keU9B","../../../hooks/useCustomersTableColumns":"hYOXE","../../../hooks/useFormatMessage":"8Y8fq","./VitecReportUploadStatus":"8GicC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4UhCT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _customerName = require("../CustomerName/CustomerName");
var _customerNameDefault = parcelHelpers.interopDefault(_customerName);
var _tree = require("../Tree/Tree");
var _treeDefault = parcelHelpers.interopDefault(_tree);
const VitecProjectProxies = (props)=>{
    const { customer } = props;
    const labels = [
        ...customer.labels || []
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _treeDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _treeDefault.default).Item, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerNameDefault.default), {
                customer: {
                    ...customer,
                    labels
                }
            })
        })
    });
};
exports.default = VitecProjectProxies;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../CustomerName/CustomerName":"iIQjm","../Tree/Tree":"9UFco","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8GicC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _checkmarkGreenSvg = require("../../../../assets/icons/checkmark-green.svg");
var _checkmarkGreenSvgDefault = parcelHelpers.interopDefault(_checkmarkGreenSvg);
var _circleCrossSvg = require("../../../../assets/icons/circle-cross.svg");
var _circleCrossSvgDefault = parcelHelpers.interopDefault(_circleCrossSvg);
var _hourglassSvg = require("../../../../assets/icons/hourglass.svg");
var _hourglassSvgDefault = parcelHelpers.interopDefault(_hourglassSvg);
var _icon = require("../../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const VitecReportStatusIcon = {
    COMPLETED: (0, _checkmarkGreenSvgDefault.default),
    WAITING: (0, _hourglassSvgDefault.default),
    FAILED: (0, _circleCrossSvgDefault.default)
};
const VitecReportUploadStatus = (props)=>{
    const { reportStatus } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const getReportStatusLabel = ()=>{
        switch(reportStatus){
            case "WAITING":
                return f("vitec.report.upload.status.WAITING");
            case "COMPLETED":
                return f("vitec.report.upload.status.COMPLETED");
            case "FAILED":
                return f("vitec.report.upload.status.FAILED");
            default:
                return "-";
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "1",
        blockAlign: "center",
        wrap: false,
        children: [
            reportStatus && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: VitecReportStatusIcon[reportStatus]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                children: getReportStatusLabel()
            })
        ]
    });
};
exports.default = VitecReportUploadStatus;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../../assets/icons/checkmark-green.svg":"8HW5l","../../../../assets/icons/circle-cross.svg":"daUCT","../../../../assets/icons/hourglass.svg":"4jWqV","../../../components/extensions/Icon":"eHSf0","../../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Or2Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
const useProjectDetailsBackButton = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const { fromProjectsList } = location.state || {};
    // returning undefined as a URL will cause the BackButton component to call history.goBack() instead of a regular url
    const backButtonURL = fromProjectsList ? undefined : (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECTS_LIST);
    return {
        backButtonURL
    };
};
exports.default = useProjectDetailsBackButton;

},{"react-router-dom":"1ee65","../../constants/routes":"ihtm8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f7VUG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _projectInfoModal = require("../../components/ProjectInfoModal/ProjectInfoModal");
var _projectInfoModalDefault = parcelHelpers.interopDefault(_projectInfoModal);
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useProjectPermissions = require("../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
var _projectsListEmptyState = require("./ProjectsListEmptyState");
var _projectsListEmptyStateDefault = parcelHelpers.interopDefault(_projectsListEmptyState);
var _projectsListFilters = require("./ProjectsListFilters");
var _projectsListFiltersDefault = parcelHelpers.interopDefault(_projectsListFilters);
var _projectsListTable = require("./ProjectsListTable");
var _projectsListTableDefault = parcelHelpers.interopDefault(_projectsListTable);
var _useProjectListParams = require("./useProjectListParams");
var _useProjectListParamsDefault = parcelHelpers.interopDefault(_useProjectListParams);
const ProjectsListPage = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const { isCreateOrAddToProjectEnabled } = (0, _useProjectPermissionsDefault.default)();
    const { searchParams, isEmptySearch } = (0, _useProjectListParamsDefault.default)();
    const [showModal, toggleShowModal, closeModal] = (0, _useOpenCloseDefault.default)();
    const [selectedProjectsMap, setSelectedProjectsMap] = (0, _react.useState)({});
    const selectedProjectsIds = Object.keys(selectedProjectsMap);
    const { isLoading, isError, error, data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).PROJECTS,
        ...Object.values(searchParams)
    ], ()=>(0, _apiDefault.default).getProjects(searchParams));
    const count = data?.count || 0;
    const projects = data?.projects || [];
    const handleSelectionChange = (0, _react.useCallback)((selectedIds)=>{
        setSelectedProjectsMap((currentSelectedProjectsMap)=>{
            const selectionMap = {};
            selectedIds.forEach((selectedProjectId)=>{
                selectionMap[selectedProjectId] = currentSelectedProjectsMap[selectedProjectId] || projects.find((project)=>project.id === selectedProjectId);
            });
            return selectionMap;
        });
    }, [
        projects
    ]);
    const showEmptyState = isEmptySearch && count === 0 && !isLoading && !isError;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                fill: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "heading2xl",
                                    as: "p",
                                    children: f("projects.page.title")
                                })
                            }),
                            isCreateOrAddToProjectEnabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                                onClick: toggleShowModal,
                                children: f("projects.common.labels.create.project")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectsListFiltersDefault.default), {
                        isLoading: isLoading
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableToolbar, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                            gap: "4",
                            blockAlign: "center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                children: count > 0 ? f("projects.page.header.projects.count", {
                                    count,
                                    selected: selectedProjectsIds.length
                                }) : ""
                            })
                        })
                    })
                ]
            }),
            !showEmptyState && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTable, {
                isLoading: isLoading,
                projects: projects,
                count: count,
                selectedIds: selectedProjectsIds,
                onSelectionChange: handleSelectionChange
            }),
            showEmptyState && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectsListEmptyStateDefault.default), {}),
            isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                    message: error
                })
            }),
            showModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectInfoModalDefault.default), {
                onClose: closeModal
            })
        ]
    });
};
const StyledTableToolbar = (0, _styledComponentsDefault.default).div`
  & > div {
    min-height: 4.375rem;
  }
`;
const StyledTable = (0, _styledComponentsDefault.default)((0, _projectsListTableDefault.default))`
  & .Polaris-DataTable,
  & .Polaris-DataTable__ScrollContainer {
    overflow: unset;
  }

  & thead > tr > th {
    position: sticky;
    top: var(--kdk-toolbar-height);
    z-index: var(--p-z-1);
    background-color: var(--p-surface);
  }
`;
exports.default = ProjectsListPage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../components/AddButton/AddButton":"WJGEt","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/ProjectInfoModal/ProjectInfoModal":"bljDA","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useProjectPermissions":"23Tgs","./ProjectsListEmptyState":"8MBui","./ProjectsListFilters":"1Guii","./ProjectsListTable":"jLakG","./useProjectListParams":"83sLN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8MBui":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const ProjectsListEmptyState = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.EmptyState), {
        heading: f("projects.list.empty.projects.header"),
        image: "",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: f("projects.list.empty.projects.message")
        })
    });
};
exports.default = ProjectsListEmptyState;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1Guii":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _createdDateFilter = require("../../components/CreatedDateFilter/CreatedDateFilter");
var _createdDateFilterDefault = parcelHelpers.interopDefault(_createdDateFilter);
var _useFiltersOptions = require("../../components/CustomersListFilters/useFiltersOptions");
var _useFiltersOptionsDefault = parcelHelpers.interopDefault(_useFiltersOptions);
var _usersList = require("../../components/UsersList/UsersList");
var _usersListDefault = parcelHelpers.interopDefault(_usersList);
var _durations = require("../../constants/durations");
var _filtersHelpers = require("../../helpers/filters.helpers");
var _useCreatedDateAppliedFilters = require("../../hooks/useCreatedDateAppliedFilters");
var _useCreatedDateAppliedFiltersDefault = parcelHelpers.interopDefault(_useCreatedDateAppliedFilters);
var _useDebounce = require("../../hooks/useDebounce");
var _useDebounceDefault = parcelHelpers.interopDefault(_useDebounce);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useShowResponsibleUserFilter = require("../../hooks/useShowResponsibleUserFilter");
var _useShowResponsibleUserFilterDefault = parcelHelpers.interopDefault(_useShowResponsibleUserFilter);
var _collectionUtils = require("../../utils/collectionUtils");
var _useProjectListParams = require("./useProjectListParams");
var _useProjectListParamsDefault = parcelHelpers.interopDefault(_useProjectListParams);
const ProjectsListFilters = (props)=>{
    const { isLoading } = props;
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserFullName } = (0, _useGetUserNameDefault.default)(features.RESPONSIBLE_USER);
    const filterOptions = (0, _useFiltersOptionsDefault.default)();
    const showResponsibleUserFilter = (0, _useShowResponsibleUserFilterDefault.default)();
    const { q, setQ, status, setStatus, responsibleUserIds, setResponsibleUserIds, createdRange, setCreatedRange, createdAfter, setCreatedAfter, createdBefore, setCreatedBefore, resetAllFilters } = (0, _useProjectListParamsDefault.default)();
    const appliedCreatedDateFilters = (0, _useCreatedDateAppliedFiltersDefault.default)({
        createdRange,
        setCreatedRange,
        createdAfter,
        setCreatedAfter,
        createdBefore,
        setCreatedBefore
    });
    const [queryText, setQueryText] = (0, _react.useState)(q ?? "");
    (0, _useDebounceDefault.default)(()=>setQ(queryText), (0, _durations.QUERY_SEARCH_DEBOUNCE_DELAY), [
        queryText
    ]);
    const [statusFilter, statusAppliedFilter] = (0, _filtersHelpers.createFilter)("status", f("component.filters.status.title"), status || "", isLoading, filterOptions.projectStatus, setStatus);
    const createdDateFilter = {
        key: "created",
        label: f("component.filters.created.title"),
        shortcut: true,
        disabled: isLoading,
        hideClearButton: true,
        filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createdDateFilterDefault.default), {
            isLoading: isLoading,
            createdRange: createdRange,
            createdAfter: createdAfter,
            createdBefore: createdBefore,
            setCreatedRange: setCreatedRange,
            setCreatedAfter: setCreatedAfter,
            setCreatedBefore: setCreatedBefore
        })
    };
    const filters = [
        statusFilter,
        createdDateFilter
    ];
    const appliedFilters = [
        statusAppliedFilter
    ].filter(Boolean);
    appliedFilters.push(...appliedCreatedDateFilters);
    if (showResponsibleUserFilter) {
        const responsibleUserFilter = {
            key: "responsible-user",
            label: f("responsible.label"),
            shortcut: true,
            disabled: isLoading,
            hideClearButton: true,
            filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersListDefault.default), {
                showAllUsersOption: true,
                selectedUserIds: responsibleUserIds,
                allowMultiple: true,
                onChange: setResponsibleUserIds
            })
        };
        // responsible users filter should be visible in the "default" filters group - add it after the status (first) filter
        filters.splice(1, 0, responsibleUserFilter);
        responsibleUserIds.forEach((userId)=>{
            const userName = getUserFullName(userId);
            appliedFilters.push({
                key: "responsible-user",
                label: `${f("responsible.label")}: ${userName}`,
                onRemove: ()=>setResponsibleUserIds((0, _collectionUtils.toggleElement)(responsibleUserIds, userId))
            });
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Filters), {
        queryValue: queryText,
        queryPlaceholder: f("projects.list.filters.search.hint"),
        filters: filters,
        appliedFilters: appliedFilters,
        onQueryChange: setQueryText,
        onQueryClear: ()=>setQueryText(""),
        onClearAll: resetAllFilters
    });
};
exports.default = ProjectsListFilters;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../components/CreatedDateFilter/CreatedDateFilter":"rFh9u","../../components/CustomersListFilters/useFiltersOptions":"duoqc","../../components/UsersList/UsersList":"dqxGe","../../constants/durations":"5sjIW","../../helpers/filters.helpers":"1yvvL","../../hooks/useCreatedDateAppliedFilters":"1QHn4","../../hooks/useDebounce":"i1Evt","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useShowResponsibleUserFilter":"khaJz","../../utils/collectionUtils":"gr5mc","./useProjectListParams":"83sLN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"83sLN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _customersListSearchParams = require("../../constants/customers-list-search-params");
var _useListParams = require("../../hooks/useListParams");
var _useListParamsDefault = parcelHelpers.interopDefault(_useListParams);
var _useNonInitialEffect = require("../../hooks/useNonInitialEffect");
var _useNonInitialEffectDefault = parcelHelpers.interopDefault(_useNonInitialEffect);
var _useURLSearchParam = require("../../hooks/useURLSearchParam");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
const useProjectListParams = ()=>{
    const { order, setOrder, page, setPage, limit, setLimit, q, setQ, createdRange, setCreatedRange, createdAfter, setCreatedAfter, createdBefore, setCreatedBefore, searchParams: baseSearchParams, isEmptySearch: baseIsEmptySearch, resetAllFilters: baseResetAllFilters } = (0, _useListParamsDefault.default)();
    const [status, setStatus] = (0, _useURLSearchParam.useURLSearchParam)((0, _customersListSearchParams.STATUS_NAME_PARAMETER));
    const [responsibleUserIds, setResponsibleUserIds] = (0, _useURLSearchParam.useURLSearchParams)((0, _customersListSearchParams.RESPONSIBLE_USERS_NAME_PARAMETER));
    (0, _useNonInitialEffectDefault.default)(()=>{
        setPage(0);
    }, [
        status,
        responsibleUserIds.toString()
    ]);
    const searchParams = (0, _util.removeEmptyValues)({
        ...baseSearchParams,
        status: status,
        responsibleIds: responsibleUserIds.length === 0 ? undefined : responsibleUserIds.join(",")
    });
    const isEmptySearch = baseIsEmptySearch && (0, _stringUtils.isEmptyString)(status) && responsibleUserIds.length === 0;
    const resetAllFilters = ()=>{
        baseResetAllFilters();
        setStatus(undefined);
        setResponsibleUserIds([]);
    };
    return {
        order,
        setOrder,
        page,
        setPage,
        limit,
        setLimit,
        q,
        setQ,
        status,
        setStatus,
        responsibleUserIds,
        setResponsibleUserIds,
        createdRange,
        setCreatedRange,
        createdAfter,
        setCreatedAfter,
        createdBefore,
        setCreatedBefore,
        searchParams,
        isEmptySearch,
        resetAllFilters
    };
};
exports.default = useProjectListParams;

},{"../../constants/customers-list-search-params":"9nE5m","../../hooks/useListParams":"2rzFa","../../hooks/useNonInitialEffect":"7lww1","../../hooks/useURLSearchParam":"5Oncb","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jLakG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIntl = require("react-intl");
var _reactTable = require("@tanstack/react-table");
var _customDate = require("../../components/CustomDate/CustomDate");
var _customDateDefault = parcelHelpers.interopDefault(_customDate);
var _multipleUsersInitials = require("../../components/MultipleUsersInitials/MultipleUsersInitials");
var _multipleUsersInitialsDefault = parcelHelpers.interopDefault(_multipleUsersInitials);
var _paginationControls = require("../../components/PaginationControls/PaginationControls");
var _paginationControlsDefault = parcelHelpers.interopDefault(_paginationControls);
var _projectName = require("../../components/ProjectName/ProjectName");
var _projectNameDefault = parcelHelpers.interopDefault(_projectName);
var _projectStatus = require("../../components/ProjectStatus/ProjectStatus");
var _projectStatusDefault = parcelHelpers.interopDefault(_projectStatus);
var _reactTable1 = require("../../components/ReactTable/ReactTable");
var _reactTableDefault = parcelHelpers.interopDefault(_reactTable1);
var _tableColumnHeader = require("../../components/TableColumnHeader/TableColumnHeader");
var _tableColumnHeaderDefault = parcelHelpers.interopDefault(_tableColumnHeader);
var _pagination = require("../../constants/pagination");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useProjectListParams = require("./useProjectListParams");
var _useProjectListParamsDefault = parcelHelpers.interopDefault(_useProjectListParams);
const ProjectsListTable = (props)=>{
    const { isLoading, projects, count, selectedIds, onSelectionChange, ...rest } = props;
    const features = (0, _useFeaturesDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const { page, setPage, limit, setLimit, order, setOrder } = (0, _useProjectListParamsDefault.default)();
    const columnHelper = (0, _reactTable.createColumnHelper)();
    const columns = [
        columnHelper.accessor("status", {
            header: f("projects.list.column.status"),
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectStatusDefault.default), {
                    status: props.getValue()
                })
        }),
        columnHelper.accessor("id", {
            header: f("projects.list.column.name"),
            id: (0, _pagination.SORT_BY_NAME_PARAMETER),
            enableSorting: true,
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _projectNameDefault.default), {
                    project: props.row.original,
                    renderAsLink: true
                })
        }),
        columnHelper.accessor("customer_count", {
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableColumnHeaderDefault.default), {
                    centered: true,
                    children: f("customers.list.column.customers.count")
                }),
            meta: {
                label: f("customers.list.column.customers.count")
            },
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: formatNumber(props.getValue())
                })
        }),
        features.RESPONSIBLE_USER ? columnHelper.accessor("responsible_users", {
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableColumnHeaderDefault.default), {
                    centered: true,
                    children: f("customers.list.column.responsible.users")
                }),
            meta: {
                label: f("customers.list.column.responsible.users")
            },
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multipleUsersInitialsDefault.default), {
                    users: props.getValue(),
                    responsive: true
                })
        }) : undefined,
        columnHelper.accessor("created_dt", {
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableColumnHeaderDefault.default), {
                    centered: true,
                    children: f("customers.list.column.added")
                }),
            meta: {
                label: f("customers.list.column.added")
            },
            id: (0, _pagination.SORT_BY_ADDED_DATE_PARAMETER),
            sortingFn: "datetime",
            enableSorting: true,
            cell: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customDateDefault.default), {
                        date: props.getValue()
                    })
                })
        })
    ].filter(Boolean);
    const getRowId = (0, _react.useCallback)((project)=>project.id, []);
    const handleSortChange = (0, _react.useCallback)((columnId, sortDirection)=>{
        const orderDirection = sortDirection === "ascending" ? "" : "-";
        const newOrder = orderDirection + columnId;
        setOrder(newOrder);
        setPage(0);
    }, [
        setOrder,
        setPage
    ]);
    const sortedColumnId = order?.includes((0, _pagination.SORT_BY_NAME_PARAMETER)) ? (0, _pagination.SORT_BY_NAME_PARAMETER) : (0, _pagination.SORT_BY_ADDED_DATE_PARAMETER);
    const sortedDirection = !order || order.startsWith("-") ? "descending" : "ascending";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTableDefault.default), {
        columns: columns,
        data: projects,
        getRowId: getRowId,
        sortedColumnId: sortedColumnId,
        sortedDirection: sortedDirection,
        onSortChange: handleSortChange,
        selectedIds: selectedIds || [],
        onSelectionChange: onSelectionChange,
        isLoading: isLoading,
        footerContent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationControlsDefault.default), {
            isLoading: isLoading,
            page: page,
            limit: limit,
            count: count,
            itemsCount: projects.length,
            setPage: setPage,
            setLimit: setLimit
        }),
        ...rest
    });
};
exports.default = ProjectsListTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@tanstack/react-table":"86D8M","../../components/CustomDate/CustomDate":"5KD00","../../components/MultipleUsersInitials/MultipleUsersInitials":"2srna","../../components/PaginationControls/PaginationControls":"aXNRN","../../components/ProjectName/ProjectName":"IXkOY","../../components/ProjectStatus/ProjectStatus":"gsvYx","../../components/ReactTable/ReactTable":"iNTSb","../../components/TableColumnHeader/TableColumnHeader":"6jCSM","../../constants/pagination":"e05H0","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","./useProjectListParams":"83sLN","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3q1vG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_CUSTOMER_NOTIFICATIONS_SETTINGS", ()=>EMPTY_CUSTOMER_NOTIFICATIONS_SETTINGS);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _numbersUtils = require("../../utils/numbersUtils");
const EMPTY_CUSTOMER_NOTIFICATIONS_SETTINGS = {
    email_notification_frequency: 1,
    max_amount_of_notifications: 1
};
const MAX_REMINDERS_OPTIONS = [
    3,
    5,
    7
]; // maximum number of notifications to be sent
const MIN_REMINDERS_FREQUENCY = 0; // not set
const MAX_REMINDERS_FREQUENCY = 31; // 31 days
const SettingsAutoReminder = (props)=>{
    const { autoRemindersSettings, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const FREQUENCIES_OPTIONS = new Map([
        [
            MIN_REMINDERS_FREQUENCY,
            f("auto-reminders-settings.send-options.not-set")
        ],
        [
            7,
            f("auto-reminders-settings.send-options.weekly")
        ],
        [
            14,
            f("auto-reminders-settings.send-options.bi-weekly")
        ]
    ]);
    const [settings, setSettings] = (0, _react.useState)(autoRemindersSettings);
    const [isCustom, setIsCustom] = (0, _react.useState)(!FREQUENCIES_OPTIONS.has(autoRemindersSettings.email_notification_frequency));
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTIFICATIONS_SETTINGS
    ]);
    const disabled = readonly || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const setNotificationsFrequency = (frequency, custom)=>{
        // validate frequency only if it is custom
        if (!custom || (0, _numbersUtils.isNumberInRange)(frequency, MIN_REMINDERS_FREQUENCY, MAX_REMINDERS_FREQUENCY)) {
            setSettings({
                ...settings,
                email_notification_frequency: frequency
            });
            setIsCustom(custom);
        }
    };
    const setMaxNotificationsAmount = (amount)=>{
        setSettings({
            ...settings,
            max_amount_of_notifications: amount
        });
    };
    const handleIsCustomChange = ()=>{
        setNotificationsFrequency(1, true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        readonly: readonly,
        apiCall: ()=>(0, _apiDefault.default).updateCustomerNotificationSettings(settings),
        onSaveAfter: setQueryData,
        title: f("auto-reminders-settings.page.title"),
        subtitle: f("auto-reminders-settings.description"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                fontWeight: "semibold",
                                children: f("auto-reminders-settings.form.label")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: [
                                    [
                                        ...FREQUENCIES_OPTIONS
                                    ].map(([frequency, label])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                            label: label,
                                            checked: settings.email_notification_frequency === frequency && !isCustom,
                                            onChange: ()=>setNotificationsFrequency(frequency, false),
                                            disabled: disabled
                                        }, label)),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "4",
                                        blockAlign: "center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                                label: f("auto-reminders-settings.send-options.custom"),
                                                checked: isCustom,
                                                onChange: handleIsCustomChange,
                                                disabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTextFieldWrapper, {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                                    label: f("auto-reminders-settings.send-options.custom.placeholder"),
                                                    labelHidden: true,
                                                    type: "number",
                                                    placeholder: f("auto-reminders-settings.send-options.custom.placeholder"),
                                                    value: isCustom ? settings.email_notification_frequency.toString() : "",
                                                    onChange: (value)=>setNotificationsFrequency(parseInt(value), true),
                                                    min: MIN_REMINDERS_FREQUENCY + 1,
                                                    max: MAX_REMINDERS_FREQUENCY,
                                                    autoComplete: "off",
                                                    disabled: disabled,
                                                    suffix: isCustom ? f("default.days", {
                                                        days: settings.email_notification_frequency
                                                    }) : undefined
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "8",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                fontWeight: "semibold",
                                children: f("auto-reminders-settings.limit-options.label")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: MAX_REMINDERS_OPTIONS.map((amount)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                        label: f("default.times", {
                                            count: amount
                                        }),
                                        checked: settings.max_amount_of_notifications === amount,
                                        onChange: ()=>setMaxNotificationsAmount(amount),
                                        disabled: disabled
                                    }, amount))
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const StyledTextFieldWrapper = (0, _styledComponentsDefault.default).div`
  max-width: 20ch;
`;
const SettingsAutoRemindersPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsAutoReminder, {
        autoRemindersSettings: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsAutoRemindersPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTIFICATIONS_SETTINGS,
    apiFunction: (0, _apiDefault.default).getCustomerNotificationSettings,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsAutoReminder, {
        readonly: true,
        autoRemindersSettings: EMPTY_CUSTOMER_NOTIFICATIONS_SETTINGS
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../utils/numbersUtils":"2RGyl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gJDHL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _permissions = require("../../constants/permissions");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useSettingsPage = require("../../hooks/useSettingsPage");
var _useSettingsPageDefault = parcelHelpers.interopDefault(_useSettingsPage);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _missingRequiredPermissionsBanner = require("../MissingRequiredPermissionsBanner/MissingRequiredPermissionsBanner");
var _missingRequiredPermissionsBannerDefault = parcelHelpers.interopDefault(_missingRequiredPermissionsBanner);
const SettingsPage = (props)=>{
    const { readonly, permissions = (0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS, overrideRoleNames, footer, apiCall, onSaveAfter, children, ...pageProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [showSuccessMessageToast, toggleShowSuccessMessageToast, closeSuccessMessageToast] = (0, _useOpenCloseDefault.default)();
    const updateSettingMutation = (0, _reactQuery.useMutation)(apiCall || Promise.reject, {
        onSuccess: (response)=>{
            onSaveAfter && onSaveAfter(response);
            toggleShowSuccessMessageToast();
        }
    });
    (0, _useSettingsPageDefault.default)();
    const showMissingPermissionsBanner = !readonly && permissions !== false && !isPermittedTo(permissions);
    const disabled = readonly || permissions !== false && !isPermittedTo(permissions);
    return(// @ts-ignore
    // TS ignore here because subtitle property type is changed from string to ReactNode (which is actually supported
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Page), {
        ...pageProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    showMissingPermissionsBanner && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _missingRequiredPermissionsBannerDefault.default), {
                        overrideRoleNames: overrideRoleNames
                    }),
                    children,
                    updateSettingMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: updateSettingMutation.error
                    }),
                    apiCall && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        align: footer ? "space-between" : "end",
                        children: [
                            footer,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                                primary: true,
                                loading: updateSettingMutation.isLoading,
                                onClick: ()=>updateSettingMutation.mutate({}),
                                disabled: disabled,
                                children: f("common.labels.save-settings")
                            })
                        ]
                    })
                ]
            }),
            showSuccessMessageToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: f("common.labels.saved-successfully"),
                onDismiss: closeSuccessMessageToast
            })
        ]
    }));
};
exports.default = SettingsPage;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../constants/permissions":"jhCn5","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useSettingsPage":"j0i19","../ErrorPanel/ErrorPanel":"2hHqH","../MissingRequiredPermissionsBanner/MissingRequiredPermissionsBanner":"3fDH6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j0i19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _usePageNavigation = require("./usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
var _useSettingsItems = require("./useSettingsItems");
var _useSettingsItemsDefault = parcelHelpers.interopDefault(_useSettingsItems);
const useSettingsPage = ()=>{
    const sections = (0, _useSettingsItemsDefault.default)();
    const { setNavigationSections, clearNavigationSections } = (0, _usePageNavigationDefault.default)();
    (0, _react.useEffect)(()=>{
        setNavigationSections(sections);
        return ()=>clearNavigationSections();
    }, []);
};
exports.default = useSettingsPage;

},{"react":"cOWTg","./usePageNavigation":"1o5Hm","./useSettingsItems":"k0lrv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k0lrv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _gearSvg = require("jsx:../../assets/icons/gear.svg");
var _gearSvgDefault = parcelHelpers.interopDefault(_gearSvg);
var _routes = require("../constants/routes");
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetKYCPreviewerURL = require("./useGetKYCPreviewerURL");
var _useGetKYCPreviewerURLDefault = parcelHelpers.interopDefault(_useGetKYCPreviewerURL);
var _useLanguage = require("./useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
const useSettingsItems = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    const kycPreviewerURL = (0, _useGetKYCPreviewerURLDefault.default)();
    const sections = (0, _react.useMemo)(()=>{
        const userManagement = {
            title: f("navigation.settings.users.section.title"),
            items: [
                {
                    url: (0, _routes.ROUTES).SETTINGS_USERS,
                    label: f("navigation.settings.users.title")
                }
            ]
        };
        const onboardingManagement = {
            title: f("navigation.settings.onboarding.section.title"),
            items: [
                {
                    url: (0, _routes.ROUTES).SETTINGS_ONBOARDING,
                    label: f("navigation.settings.onboarding.person.title")
                }
            ]
        };
        const kycManagement = {
            title: f("common.labels.kyc"),
            items: []
        };
        if (features.DISCLOSURE_SETTINGS) kycManagement.items.push({
            url: (0, _routes.ROUTES).SETTINGS_DISCLOSURE,
            label: f("disclosure.settings.page.title")
        });
        kycManagement.items.push({
            url: (0, _routes.ROUTES).SETTINGS_QUESTIONNAIRES_LIST,
            label: f("navigation.settings.kyc.custom-questionnaires.label")
        });
        const riskManagement = {
            title: f("navigation.settings.risk-management.section.title"),
            items: [
                {
                    url: (0, _routes.ROUTES).SETTINGS_FOLLOWUP,
                    label: f("followup-settings.page.title")
                }
            ]
        };
        if (features.MEASURES) riskManagement.items.push({
            url: (0, _routes.ROUTES).SETTINGS_MEASURES,
            label: f("measures-settings.page.title")
        });
        riskManagement.items.push({
            url: (0, _routes.ROUTES).SETTINGS_GUIDELINE,
            label: f("customer-review-guideline-settings.page.title")
        }, {
            url: (0, _routes.ROUTES).SETTINGS_TAGS,
            label: f("tags.page.title")
        });
        if (features.REVIEW_CHECKLIST) riskManagement.items.push({
            url: (0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLISTS_LIST,
            label: f("navigation.settings.checklists.label")
        });
        const notificationsManagement = {
            title: f("navigation.settings.notifications.section.title"),
            items: [
                {
                    url: (0, _routes.ROUTES).SETTINGS_AUTO_REMINDERS,
                    label: f("navigation.settings.kyc.auto-reminder.label")
                },
                {
                    url: (0, _routes.ROUTES).SETTINGS_FOLLOWUP_NOTIFICATIONS,
                    label: f("followup-notifications.settings.page.title")
                }
            ]
        };
        if (features.SETTINGS__CUSTOMER_INFO_NOTIFICATIONS) notificationsManagement.items.push({
            url: (0, _routes.ROUTES).SETTINGS_CUSTOMER_NOTIFICATIONS,
            label: f("navigation.settings.notifications.customer-info.label")
        });
        const internalTools = {
            title: f("navigation.settings.internal-tools.section.title"),
            items: []
        };
        if (features.KYC_PREVIEWER) internalTools.items.push({
            url: kycPreviewerURL,
            label: f("navigation.settings.internal-tools.kyc-previewer.label"),
            options: {
                external: true
            }
        });
        const result = [
            {
                title: f("menu.settings"),
                icon: (0, _gearSvgDefault.default),
                items: []
            },
            userManagement,
            onboardingManagement,
            kycManagement,
            riskManagement,
            notificationsManagement
        ];
        if (internalTools.items.length > 0) result.push(internalTools);
        return result;
    }, [
        features,
        language
    ]);
    return sections;
};
exports.default = useSettingsItems;

},{"react":"cOWTg","jsx:../../assets/icons/gear.svg":"6nmWx","../constants/routes":"ihtm8","./useFeatures":"hvBWb","./useFormatMessage":"8Y8fq","./useGetKYCPreviewerURL":"7IQrN","./useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6nmWx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGear = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.7 3.55v1.71l.867.307c.157.056.31.12.459.19l.83.398 1.21-1.21a.25.25 0 0 1 .353 0l.637.636a.25.25 0 0 1 0 .353l-1.21 1.21.397.83c.07.15.134.302.19.46l.306.866h1.711a.25.25 0 0 1 .25.25v.9a.25.25 0 0 1-.25.25h-1.71l-.307.867c-.056.157-.12.31-.19.459l-.398.83 1.21 1.21a.25.25 0 0 1 0 .353l-.636.637a.25.25 0 0 1-.353 0l-1.21-1.21-.83.397a4.662 4.662 0 0 1-.46.19l-.866.306v1.711a.25.25 0 0 1-.25.25h-.9a.25.25 0 0 1-.25-.25v-1.71l-.867-.307a4.659 4.659 0 0 1-.459-.19l-.83-.398-1.21 1.21a.25.25 0 0 1-.353 0l-.637-.636a.25.25 0 0 1 0-.353l1.21-1.21-.397-.83a4.67 4.67 0 0 1-.19-.46l-.306-.866H3.55a.25.25 0 0 1-.25-.25v-.9a.25.25 0 0 1 .25-.25h1.71l.307-.867c.056-.157.12-.31.19-.459l.398-.83-1.21-1.21a.25.25 0 0 1 0-.353l.636-.637a.25.25 0 0 1 .353 0l1.21 1.21.83-.397c.15-.07.302-.134.46-.19l.866-.306V3.55a.25.25 0 0 1 .25-.25h.9a.25.25 0 0 1 .25.25ZM11 2a1 1 0 0 1 1 1v1.341c.2.071.397.153.587.244l.949-.949a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414l-.949.95c.091.19.173.385.244.586H17a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1.341c-.071.2-.153.396-.244.587l.949.949a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0l-.95-.949c-.19.091-.385.173-.586.244V17a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1.341a5.989 5.989 0 0 1-.587-.244l-.949.949a1 1 0 0 1-1.414 0L3.636 14.95a1 1 0 0 1 0-1.414l.949-.95A5.957 5.957 0 0 1 4.34 12H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1.341c.071-.2.153-.397.244-.587l-.949-.949a1 1 0 0 1 0-1.414L5.05 3.636a1 1 0 0 1 1.414 0l.95.949c.19-.091.385-.173.586-.244V3a1 1 0 0 1 1-1h2Zm-.3 8a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0Zm1.3 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
            fill: "#1D1C31"
        })
    });
exports.default = SvgGear;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7IQrN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useFeatures = require("./useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
const useGetKYCPreviewerURL = ()=>{
    const features = (0, _useFeaturesDefault.default)();
    const { data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).KYC_PREVIEW
    ], ()=>(0, _apiDefault.default).getInternalKycPreviewLink(), {
        enabled: features.KYC_PREVIEWER,
        staleTime: (0, _queriesKeys.STALE_TIME)
    });
    return data;
};
exports.default = useGetKYCPreviewerURL;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useFeatures":"hvBWb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3fDH6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _permissions = require("../../constants/permissions");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useFormatMultipleNames = require("../../hooks/useFormatMultipleNames");
var _useFormatMultipleNamesDefault = parcelHelpers.interopDefault(_useFormatMultipleNames);
var _useGetUsers = require("../../hooks/useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
const MissingRequiredPermissionsBanner = (props)=>{
    const { overrideRoleNames } = props;
    const { groups } = (0, _useGetUsersDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const formatMultipleNames = (0, _useFormatMultipleNamesDefault.default)();
    const roleNames = overrideRoleNames || groups.filter((group)=>group.role_key === (0, _permissions.MLRO_GROUP_KEY) || group.role_key === (0, _permissions.COMPLIANCE_OFFICER_GROUP_KEY)).map((group)=>group.name);
    const roleNamesDisplayLabel = formatMultipleNames(roleNames, 2);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
        status: "info",
        title: "",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: f("missing-required-permission.banner.description", {
                roles: roleNamesDisplayLabel
            })
        })
    });
};
exports.default = MissingRequiredPermissionsBanner;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/permissions":"jhCn5","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useFormatMultipleNames":"gogmY","../../hooks/useGetUsers":"c83Pg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1sbLP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _useRichFormatMessage = require("../../hooks/useRichFormatMessage");
var _useRichFormatMessageDefault = parcelHelpers.interopDefault(_useRichFormatMessage);
var _settingsAutoRemindersPage = require("../SettingsAutoRemindersPage/SettingsAutoRemindersPage");
const SettingsCustomerIntoNotifications = (props)=>{
    const { notificationsSettings, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const richFormat = (0, _useRichFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [settings, setSettings] = (0, _react.useState)(notificationsSettings);
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTIFICATIONS_SETTINGS
    ]);
    const FREQUENCIES_OPTIONS = new Map([
        [
            "IMMEDIATELY",
            f("customer-notifications-settings.frequency.options.immediately")
        ],
        [
            "DAILY",
            f("customer-notifications-settings.frequency.options.daily")
        ],
        [
            "WEEKLY",
            f("customer-notifications-settings.frequency.options.weekly")
        ]
    ]);
    const disabled = readonly || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const setNotificationsFrequency = (frequency)=>{
        setSettings({
            ...settings,
            basic_info_update_notification_frequency: frequency
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsPageDefault.default), {
        readonly: readonly,
        apiCall: ()=>(0, _apiDefault.default).updateCustomerNotificationSettings(settings),
        onSaveAfter: setQueryData,
        title: f("customer-notifications-settings.page.title"),
        subtitle: richFormat("customer-notifications-settings.description"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "bodyMd",
                            as: "span",
                            fontWeight: "semibold",
                            children: f("customer-notifications-settings.frequency.label")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: [
                                ...FREQUENCIES_OPTIONS
                            ].map(([frequency, label])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: label,
                                    checked: settings.basic_info_update_notification_frequency === frequency,
                                    onChange: ()=>setNotificationsFrequency(frequency),
                                    disabled: disabled
                                }, frequency))
                        })
                    ]
                })
            })
        })
    });
};
const SettingsCustomerIntoNotificationsPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsCustomerIntoNotifications, {
        notificationsSettings: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsCustomerIntoNotificationsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_NOTIFICATIONS_SETTINGS,
    apiFunction: (0, _apiDefault.default).getCustomerNotificationSettings,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsCustomerIntoNotifications, {
        readonly: true,
        notificationsSettings: (0, _settingsAutoRemindersPage.EMPTY_CUSTOMER_NOTIFICATIONS_SETTINGS)
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../hooks/useRichFormatMessage":"6rmtK","../SettingsAutoRemindersPage/SettingsAutoRemindersPage":"3q1vG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ligA9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _displayName = require("../../components/DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _imageDropZone = require("../../components/ImageDropZone/ImageDropZone");
var _imageDropZoneDefault = parcelHelpers.interopDefault(_imageDropZone);
var _kdktabs = require("../../components/KDKTabs/KDKTabs");
var _kdktabsDefault = parcelHelpers.interopDefault(_kdktabs);
var _previewDisclosureModal = require("../../components/PreviewDisclosureModal/PreviewDisclosureModal");
var _previewDisclosureModalDefault = parcelHelpers.interopDefault(_previewDisclosureModal);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _translationTextMarkdownEditor = require("../../components/TranslationTextMarkdownEditor/TranslationTextMarkdownEditor");
var _translationTextMarkdownEditorDefault = parcelHelpers.interopDefault(_translationTextMarkdownEditor);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _util = require("../../utils/util");
const LOGO_FILE_SIZE_LIMIT_IN_KB = 200;
const SettingsDisclosure = (props)=>{
    const { settings: initialSettings, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [customerType, setCustomerType] = (0, _react.useState)("person");
    const [settings, setSettings] = (0, _react.useState)(initialSettings);
    const [isShowPreview, togglePreview] = (0, _useOpenCloseDefault.default)();
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).DISCLOSURE_SETTINGS
    ]);
    const onSuccess = (response)=>{
        setSettings(response);
        setQueryData(response);
        queryClient.invalidateQueries([
            (0, _queriesKeys.QUERIES_KEYS).DISCLOSURE_SETTINGS
        ]);
    };
    const onFieldChange = (0, _react.useCallback)((field, value)=>{
        // If the value of person_intro_text/company_intro_text is empty, set the field as undefined
        if ((field === "person_intro_text" || field === "company_intro_text") && (0, _util.isTranslationTextEmpty)(value)) value = undefined;
        setSettings((prevState)=>({
                ...prevState,
                [field]: value
            }));
    }, []);
    const logoPresent = settings.logo !== undefined && settings.logo !== "";
    const disabled = readonly || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const tabs = [
        {
            id: "person",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                name: f("disclosure.settings.page.tabs.customer-type.person"),
                type: "person"
            })
        },
        {
            id: "company",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                name: f("disclosure.settings.page.tabs.customer-type.company"),
                type: "company"
            })
        }
    ];
    const handleTabSelectionChange = (selectedTabIndex)=>setCustomerType(selectedTabIndex === 0 ? "person" : "company");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        readonly: readonly,
        apiCall: ()=>(0, _apiDefault.default).updateDisclosureSettings(settings),
        onSaveAfter: onSuccess,
        title: f("disclosure.settings.page.title"),
        subtitle: f("disclosure.settings.page.description"),
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            onClick: togglePreview,
            disabled: readonly,
            children: f("default.preview")
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                        vertical: logoPresent,
                        distribution: "equalSpacing",
                        alignment: logoPresent ? "leading" : "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        fontWeight: "bold",
                                        as: "legend",
                                        children: f("disclosure.settings.page.labels.logo")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItalicText, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            color: "subdued",
                                            as: "span",
                                            children: f("disclosure.settings.page.labels.supported-filetypes", {
                                                limit: LOGO_FILE_SIZE_LIMIT_IN_KB
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageDropZoneDefault.default), {
                                readonly: disabled,
                                image: settings.logo,
                                filename: settings.logo_filename,
                                filesizeLimit: LOGO_FILE_SIZE_LIMIT_IN_KB * 1024,
                                onChange: (logo, filename)=>{
                                    onFieldChange("logo", logo);
                                    onFieldChange("logo_filename", filename);
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    title: f("disclosure.settings.page.labels.text"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktabsDefault.default), {
                        selected: customerType === "person" ? 0 : 1,
                        tabs: tabs,
                        onSelect: handleTabSelectionChange,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                                    size: "medium"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingLg",
                                    color: "subdued",
                                    as: "h1",
                                    children: f(`disclosure.settings.page.labels.email.subject.${customerType}`)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    variant: "headingSm",
                                    color: "subdued",
                                    as: "h1",
                                    children: f("disclosure.settings.page.labels.email.header")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _translationTextMarkdownEditorDefault.default), {
                                    translationText: (customerType === "person" ? settings.person_intro_text : settings.company_intro_text) || {
                                        nb: ""
                                    },
                                    readonly: disabled,
                                    onTextChange: (value)=>onFieldChange(customerType === "person" ? "person_intro_text" : "company_intro_text", value)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                    color: "subdued",
                                    as: "legend",
                                    children: f("disclosure.settings.page.labels.email.due-diligence.list.title")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.List), {
                                    spacing: "extraTight",
                                    type: "bullet",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                color: "subdued",
                                                as: "legend",
                                                children: f("disclosure.settings.page.labels.email.due-diligence.identification")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.List).Item, {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                color: "subdued",
                                                as: "legend",
                                                children: f("disclosure.settings.page.labels.email.due-diligence.kyc")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            isShowPreview && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewDisclosureModalDefault.default), {
                customerType: customerType,
                settings: settings,
                onClose: togglePreview
            })
        ]
    });
};
const ItalicText = (0, _styledComponentsDefault.default).span`
  font-style: italic;
`;
const SettingsDisclosurePage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsDisclosure, {
        settings: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsDisclosurePage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).DISCLOSURE_SETTINGS,
    apiFunction: (0, _apiDefault.default).getDisclosureSettings,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsDisclosure, {
        settings: {},
        readonly: true
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/DisplayName/DisplayName":"gKd5g","../../components/extensions/Button":"8exc0","../../components/ImageDropZone/ImageDropZone":"iGaOU","../../components/KDKTabs/KDKTabs":"hryzj","../../components/PreviewDisclosureModal/PreviewDisclosureModal":"lccxH","../../components/SectionMargin/SectionMargin":"l3u8a","../../components/SettingsPage/SettingsPage":"gJDHL","../../components/TranslationTextMarkdownEditor/TranslationTextMarkdownEditor":"jyxRk","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iGaOU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIntl = require("react-intl");
var _polaris = require("@shopify/polaris");
var _xmarkSvg = require("../../../assets/icons/xmark.svg");
var _xmarkSvgDefault = parcelHelpers.interopDefault(_xmarkSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _browserUtils = require("../../utils/browserUtils");
var _util = require("../../utils/util");
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const ImageDropZone = (props)=>{
    const { readonly, image, filename, filesizeLimit, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { formatNumber } = (0, _reactIntl.useIntl)();
    const [file, setFile] = (0, _react.useState)();
    const [error, setError] = (0, _react.useState)();
    const clearFile = (0, _react.useCallback)(()=>handleFileChange(undefined), []);
    const isFileSet = Boolean(file);
    const convertImage = async (file)=>{
        setError(undefined);
        setFile(file);
        const base64File = await (0, _browserUtils.fileToBase64)(file);
        onChange(base64File, file.name);
    };
    const acceptedFileTypes = "image/png,image/jpg,image/jpeg";
    (0, _react.useEffect)(()=>{
        if (image && !isFileSet) (0, _browserUtils.base64ToFile)(image, filename || "logo.png", acceptedFileTypes).then(setFile).catch(setError);
    }, [
        image,
        filename,
        isFileSet
    ]);
    const handleFileChange = async (updatedFile)=>{
        if (updatedFile) convertImage(updatedFile);
        else {
            setFile(undefined);
            setError(undefined);
            onChange("", "");
        }
    };
    const handleDropZoneDrop = (0, _react.useCallback)((_dropFiles, acceptedFiles)=>handleFileChange(acceptedFiles[0]), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DropZone), {
                accept: acceptedFileTypes,
                type: "image",
                onDrop: handleDropZoneDrop,
                disabled: readonly || !(0, _util.isNil)(file),
                allowMultiple: false,
                outline: false,
                variableHeight: true,
                customValidator: (file)=>filesizeLimit ? file.size <= filesizeLimit : true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    inlineAlign: file ? "start" : "center",
                    children: [
                        !file && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                            children: f("common.labels.file.upload")
                        }),
                        file && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "4",
                            blockAlign: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Thumbnail), {
                                    alt: file.name,
                                    source: window.URL.createObjectURL(file)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    icon: (0, _xmarkSvgDefault.default),
                                    plain: true,
                                    onClick: clearFile,
                                    disabled: readonly
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        file.name,
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Text), {
                                            variant: "bodySm",
                                            as: "p",
                                            children: [
                                                formatNumber(file.size / 1024, {
                                                    maximumFractionDigits: 0
                                                }),
                                                " KB"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: error
            })
        ]
    });
};
exports.default = ImageDropZone;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-intl":"8H1wU","@shopify/polaris":"ek5a0","../../../assets/icons/xmark.svg":"5t6Jt","../../hooks/useFormatMessage":"8Y8fq","../../utils/browserUtils":"4ShiW","../../utils/util":"4MniK","../AddButton/AddButton":"WJGEt","../ErrorPanel/ErrorPanel":"2hHqH","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5t6Jt":[function(require,module,exports) {
module.exports = require("54e64190c95369ec").getBundleURL("kEMsi") + "xmark.a26e6962.svg";

},{"54e64190c95369ec":"75UoR"}],"lccxH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _useFetch = require("../../hooks/useFetch");
var _useFetchDefault = parcelHelpers.interopDefault(_useFetch);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const PreviewDisclosureModal = (props)=>{
    const { customerType, settings, onClose } = props;
    const language = (0, _useLanguageDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const fetch = (0, _useFetchDefault.default)();
    const [iframeSource, setIframeSource] = (0, _react.useState)("");
    const previewDisclosureSettings = (0, _reactQuery.useMutation)((0, _apiDefault.default).previewDisclosureSettings);
    const closeAction = {
        content: f("default.close"),
        onAction: onClose
    };
    (0, _react.useEffect)(()=>previewDisclosureSettings.mutate(settings, {
            onSuccess: (data)=>{
                const subjectType = customerType === "person" ? "person" : "legal_entity";
                const previewUrl = `${data.preview_url}?language=${language}&subject_type=${subjectType}`;
                fetch(previewUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data.payload)
                }).then((res)=>res.blob()).then((blob)=>{
                    const urlObject = URL.createObjectURL(blob);
                    setIframeSource(urlObject);
                });
            }
        }), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        large: true,
        onClose: onClose,
        title: f("default.preview"),
        primaryAction: closeAction,
        loading: previewDisclosureSettings.isLoading,
        iFrameName: "kyc-settings-preview",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            flush: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                vertical: true,
                alignment: "fill",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPreviewContainer, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                            src: iframeSource,
                            name: "kyc-settings-preview"
                        })
                    }),
                    previewDisclosureSettings.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: previewDisclosureSettings.error
                    })
                ]
            })
        })
    });
};
const StyledPreviewContainer = (0, _styledComponentsDefault.default).div`
  background: var(--p-surface-dark);
  display: flex;
  justify-content: center;
  padding: var(--p-space-4);

  & > iframe {
    background: var(--p-surface);
    width: var(--p-breakpoints-sm);
    min-height: 50vh;
  }
`;
exports.default = PreviewDisclosureModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../hooks/useFetch":"9uRF8","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useLanguage":"2W6IE","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jyxRk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _languages = require("../../constants/languages");
var _languageSelect = require("../DisclosureSignatureForm/LanguageSelect");
var _languageSelectDefault = parcelHelpers.interopDefault(_languageSelect);
var _markdownEditor = require("../MarkdownEditor/MarkdownEditor");
var _markdownEditorDefault = parcelHelpers.interopDefault(_markdownEditor);
const TranslationTextMarkdownEditor = (props)=>{
    const { translationText, language = (0, _languages.DEFAULT_LANGUAGE), readonly, onTextChange, onLanguageChange, children } = props;
    const [selectedLanguage, setSelectedLanguage] = (0, _react.useState)(language);
    (0, _react.useEffect)(()=>setSelectedLanguage(language), [
        language
    ]);
    (0, _react.useEffect)(()=>onLanguageChange && onLanguageChange(selectedLanguage), [
        selectedLanguage
    ]);
    const handleChange = (value)=>onTextChange({
            ...translationText || {
                nb: "",
                en: ""
            },
            [selectedLanguage]: value
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownEditorDefault.default), {
        value: translationText?.[selectedLanguage] || "",
        onChange: handleChange,
        toolbarRightSection: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
            align: "end",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageSelectDefault.default), {
                onChange: setSelectedLanguage,
                value: selectedLanguage,
                disabled: readonly
            })
        }),
        disabled: readonly,
        children: children
    }, selectedLanguage);
};
exports.default = TranslationTextMarkdownEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/languages":"ecnY7","../DisclosureSignatureForm/LanguageSelect":"9t94t","../MarkdownEditor/MarkdownEditor":"6Wb6X","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6Wb6X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _markdown = require("@lexical/markdown");
var _lexicalAutoFocusPlugin = require("@lexical/react/LexicalAutoFocusPlugin");
var _lexicalComposer = require("@lexical/react/LexicalComposer");
var _lexicalContentEditable = require("@lexical/react/LexicalContentEditable");
var _lexicalErrorBoundary = require("@lexical/react/LexicalErrorBoundary");
var _lexicalErrorBoundaryDefault = parcelHelpers.interopDefault(_lexicalErrorBoundary);
var _lexicalLinkPlugin = require("@lexical/react/LexicalLinkPlugin");
var _lexicalListPlugin = require("@lexical/react/LexicalListPlugin");
var _lexicalMarkdownShortcutPlugin = require("@lexical/react/LexicalMarkdownShortcutPlugin");
var _lexicalOnChangePlugin = require("@lexical/react/LexicalOnChangePlugin");
var _lexicalRichTextPlugin = require("@lexical/react/LexicalRichTextPlugin");
var _lexicalTabIndentationPlugin = require("@lexical/react/LexicalTabIndentationPlugin");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _markdown1 = require("../../constants/markdown");
var _browserUtils = require("../../utils/browserUtils");
var _autoLinkPlugin = require("./AutoLinkPlugin");
var _autoLinkPluginDefault = parcelHelpers.interopDefault(_autoLinkPlugin);
var _markdownEditorToolbar = require("./MarkdownEditorToolbar");
var _markdownEditorToolbarDefault = parcelHelpers.interopDefault(_markdownEditorToolbar);
var _markdownStylesWrapper = require("./MarkdownStylesWrapper");
var _updateStatePlugin = require("./UpdateStatePlugin");
var _updateStatePluginDefault = parcelHelpers.interopDefault(_updateStatePlugin);
const MarkdownEditor = (props)=>{
    const { value = "", toolbarRightSection, disabled, onChange, children } = props;
    function handleChange(editorState) {
        editorState.read(()=>{
            const markdown = (0, _markdown.$convertToMarkdownString)((0, _markdown1.TRANSFORMERS));
            onChange(markdown);
        });
    }
    function onError(error) {
        console.error(error);
    }
    const initialConfig = {
        ...(0, _markdown1.BASE_MARKDOWN_CONFIG),
        namespace: "markdown-editor",
        editable: !disabled,
        editorState: ()=>(0, _markdown.$convertFromMarkdownString)(value, (0, _markdown1.TRANSFORMERS)),
        onError
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _lexicalComposer.LexicalComposer), {
        initialConfig: initialConfig,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownEditorToolbarDefault.default), {
                    disabled: disabled,
                    children: toolbarRightSection
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                subdued: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledEditor, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalRichTextPlugin.RichTextPlugin), {
                            contentEditable: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "4",
                                children: [
                                    children,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalContentEditable.ContentEditable), {
                                        className: "editor-inner"
                                    })
                                ]
                            }),
                            placeholder: null,
                            ErrorBoundary: (0, _lexicalErrorBoundaryDefault.default)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalOnChangePlugin.OnChangePlugin), {
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateStatePluginDefault.default), {
                            value: value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalAutoFocusPlugin.AutoFocusPlugin), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalTabIndentationPlugin.TabIndentationPlugin), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalListPlugin.ListPlugin), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalLinkPlugin.LinkPlugin), {
                            validateUrl: (0, _browserUtils.isValidUrl)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoLinkPluginDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lexicalMarkdownShortcutPlugin.MarkdownShortcutPlugin), {
                            transformers: (0, _markdown1.TRANSFORMERS)
                        })
                    ]
                })
            })
        ]
    });
};
const StyledEditor = (0, _styledComponentsDefault.default)((0, _markdownStylesWrapper.MarkdownStylesWrapper))`
  & .editor-inner {
    background-color: var(--p-surface);
    min-height: 20rem;
    font-size: var(--p-font-size-100);
    font-weight: var(--p-font-weight-regular);
    line-height: var(--p-font-line-height-2);
    font-family: var(--p-font-family-sans);
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    padding: var(--p-space-2);
    border: var(--p-border-base);
    border-radius: var(--p-border-radius-1);
  }
`;
exports.default = MarkdownEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@lexical/markdown":"a7yhR","@lexical/react/LexicalAutoFocusPlugin":"eCu7G","@lexical/react/LexicalComposer":"dTVDi","@lexical/react/LexicalContentEditable":"3VJcw","@lexical/react/LexicalErrorBoundary":"epcXG","@lexical/react/LexicalLinkPlugin":"g4yT3","@lexical/react/LexicalListPlugin":"hCew6","@lexical/react/LexicalMarkdownShortcutPlugin":"l5WKj","@lexical/react/LexicalOnChangePlugin":"cmWs4","@lexical/react/LexicalRichTextPlugin":"eV9p8","@lexical/react/LexicalTabIndentationPlugin":"lloy8","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/markdown":"6FvAU","../../utils/browserUtils":"4ShiW","./AutoLinkPlugin":"aAd3r","./MarkdownEditorToolbar":"6Xcf5","./MarkdownStylesWrapper":"glWzc","./UpdateStatePlugin":"8L2QK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eCu7G":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalAutoFocusPlugin = require("9343ff4564a03a8b");
module.exports = LexicalAutoFocusPlugin;

},{"9343ff4564a03a8b":"5ibta"}],"5ibta":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("3d1c08c808811e3f"), f = require("1dff5cb0084f93c3");
exports.AutoFocusPlugin = function({ defaultSelection: c }) {
    let [a] = e.useLexicalComposerContext();
    f.useEffect(()=>{
        a.focus(()=>{
            let d = document.activeElement, b = a.getRootElement();
            null === b || null !== d && b.contains(d) || b.focus({
                preventScroll: !0
            });
        }, {
            defaultSelection: c
        });
    }, [
        c,
        a
    ]);
    return null;
};

},{"3d1c08c808811e3f":"2kfbx","1dff5cb0084f93c3":"cOWTg"}],"g4yT3":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalLinkPlugin = require("66f29c8f039706e");
module.exports = LexicalLinkPlugin;

},{"66f29c8f039706e":"atx0j"}],"atx0j":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = require("eaa6c0c210925cc3"), c = require("8aede4573928c15e"), k = require("3f1c771c9b18e53e"), l = require("6c184b9ccb4e645f"), m = require("7316bd8cfd9788e2");
exports.LinkPlugin = function({ validateUrl: d }) {
    let [e] = c.useLexicalComposerContext();
    m.useEffect(()=>{
        if (!e.hasNodes([
            b.LinkNode
        ])) throw Error("LinkPlugin: LinkNode not registered on editor");
        return k.mergeRegister(e.registerCommand(b.TOGGLE_LINK_COMMAND, (a)=>{
            if (null === a) return b.toggleLink(a), !0;
            if ("string" === typeof a) return void 0 === d || d(a) ? (b.toggleLink(a), !0) : !1;
            let { url: f, target: g, rel: h, title: n } = a;
            b.toggleLink(f, {
                rel: h,
                target: g,
                title: n
            });
            return !0;
        }, l.COMMAND_PRIORITY_LOW), void 0 !== d ? e.registerCommand(l.PASTE_COMMAND, (a)=>{
            let f = l.$getSelection();
            if (!l.$isRangeSelection(f) || f.isCollapsed() || !(a instanceof ClipboardEvent) || null == a.clipboardData) return !1;
            let g = a.clipboardData.getData("text");
            return d(g) ? f.getNodes().some((h)=>l.$isElementNode(h)) ? !1 : (e.dispatchCommand(b.TOGGLE_LINK_COMMAND, g), a.preventDefault(), !0) : !1;
        }, l.COMMAND_PRIORITY_LOW) : ()=>{});
    }, [
        e,
        d
    ]);
    return null;
};

},{"eaa6c0c210925cc3":"2MxRL","8aede4573928c15e":"2kfbx","3f1c771c9b18e53e":"1V3L7","6c184b9ccb4e645f":"6uPvi","7316bd8cfd9788e2":"cOWTg"}],"hCew6":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalListPlugin = require("45249c0ce27dee14");
module.exports = LexicalListPlugin;

},{"45249c0ce27dee14":"6vDKa"}],"6vDKa":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = require("fc16e487e7f87192"), c = require("984bca4fb0c05b"), d = require("bef33b8134618bb8"), e = require("299735c51c7fa77b"), f = require("17518cd00fbf0d66");
function g(a) {
    d.useEffect(()=>e.mergeRegister(a.registerCommand(b.INSERT_ORDERED_LIST_COMMAND, ()=>{
            b.insertList(a, "number");
            return !0;
        }, f.COMMAND_PRIORITY_LOW), a.registerCommand(b.INSERT_UNORDERED_LIST_COMMAND, ()=>{
            b.insertList(a, "bullet");
            return !0;
        }, f.COMMAND_PRIORITY_LOW), a.registerCommand(b.REMOVE_LIST_COMMAND, ()=>{
            b.removeList(a);
            return !0;
        }, f.COMMAND_PRIORITY_LOW), a.registerCommand(f.INSERT_PARAGRAPH_COMMAND, ()=>b.$handleListInsertParagraph() ? !0 : !1, f.COMMAND_PRIORITY_LOW)), [
        a
    ]);
}
exports.ListPlugin = function() {
    let [a] = c.useLexicalComposerContext();
    d.useEffect(()=>{
        if (!a.hasNodes([
            b.ListNode,
            b.ListItemNode
        ])) throw Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
    }, [
        a
    ]);
    g(a);
    return null;
};

},{"fc16e487e7f87192":"2CQxU","984bca4fb0c05b":"2kfbx","bef33b8134618bb8":"cOWTg","299735c51c7fa77b":"1V3L7","17518cd00fbf0d66":"6uPvi"}],"l5WKj":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalMarkdownShortcutPlugin = require("2eeebbf21223b85c");
module.exports = LexicalMarkdownShortcutPlugin;

},{"2eeebbf21223b85c":"3xmD4"}],"3xmD4":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var c = require("e231bd4e5e10e2cd"), d = require("bdf4cf8589656ab8"), e = require("8781b147b6c99e03"), f = require("9b46fd4d4215fd89");
let g = [
    {
        dependencies: [
            e.HorizontalRuleNode
        ],
        export: (a)=>e.$isHorizontalRuleNode(a) ? "***" : null,
        regExp: /^(---|\*\*\*|___)\s?$/,
        replace: (a, b, k, h)=>{
            b = e.$createHorizontalRuleNode();
            h || null != a.getNextSibling() ? a.replace(b) : a.insertBefore(b);
            b.selectNext();
        },
        type: "element"
    },
    ...c.TRANSFORMERS
];
exports.DEFAULT_TRANSFORMERS = g;
exports.MarkdownShortcutPlugin = function({ transformers: a = g }) {
    let [b] = d.useLexicalComposerContext();
    f.useEffect(()=>c.registerMarkdownShortcuts(b, a), [
        b,
        a
    ]);
    return null;
};

},{"e231bd4e5e10e2cd":"a7yhR","bdf4cf8589656ab8":"2kfbx","8781b147b6c99e03":"eoeS2","9b46fd4d4215fd89":"cOWTg"}],"eoeS2":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalHorizontalRuleNode = require("44e3c4e2da77c898");
module.exports = LexicalHorizontalRuleNode;

},{"44e3c4e2da77c898":"8BzsJ"}],"8BzsJ":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var a = require("f3763f22b0963ab8"), f = require("194ceb95dacf2898"), g = require("79a1d98e05de481"), k = require("b04ff0dd3a717645"), n = require("258f4f287730236c");
let p = k.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
function q({ nodeKey: b }) {
    let [d] = a.useLexicalComposerContext(), [e, l, m] = f.useLexicalNodeSelection(b), h = n.useCallback((c)=>{
        e && k.$isNodeSelection(k.$getSelection()) && (c.preventDefault(), c = k.$getNodeByKey(b), r(c) && c.remove());
        return !1;
    }, [
        e,
        b
    ]);
    n.useEffect(()=>g.mergeRegister(d.registerCommand(k.CLICK_COMMAND, (c)=>{
            let v = d.getElementByKey(b);
            return c.target === v ? (c.shiftKey || m(), l(!e), !0) : !1;
        }, k.COMMAND_PRIORITY_LOW), d.registerCommand(k.KEY_DELETE_COMMAND, h, k.COMMAND_PRIORITY_LOW), d.registerCommand(k.KEY_BACKSPACE_COMMAND, h, k.COMMAND_PRIORITY_LOW)), [
        m,
        d,
        e,
        b,
        h,
        l
    ]);
    n.useEffect(()=>{
        let c = d.getElementByKey(b);
        null !== c && (c.className = e ? "selected" : "");
    }, [
        d,
        e,
        b
    ]);
    return null;
}
class t extends k.DecoratorNode {
    static getType() {
        return "horizontalrule";
    }
    static clone(b) {
        return new t(b.__key);
    }
    static importJSON() {
        return u();
    }
    static importDOM() {
        return {
            hr: ()=>({
                    conversion: w,
                    priority: 0
                })
        };
    }
    exportJSON() {
        return {
            type: "horizontalrule",
            version: 1
        };
    }
    exportDOM() {
        return {
            element: document.createElement("hr")
        };
    }
    createDOM() {
        return document.createElement("hr");
    }
    getTextContent() {
        return "\n";
    }
    isInline() {
        return !1;
    }
    updateDOM() {
        return !1;
    }
    decorate() {
        return n.createElement(q, {
            nodeKey: this.__key
        });
    }
}
function w() {
    return {
        node: u()
    };
}
function u() {
    return k.$applyNodeReplacement(new t);
}
function r(b) {
    return b instanceof t;
}
exports.$createHorizontalRuleNode = u;
exports.$isHorizontalRuleNode = r;
exports.HorizontalRuleNode = t;
exports.INSERT_HORIZONTAL_RULE_COMMAND = p;

},{"f3763f22b0963ab8":"2kfbx","194ceb95dacf2898":"am7pV","79a1d98e05de481":"1V3L7","b04ff0dd3a717645":"6uPvi","258f4f287730236c":"cOWTg"}],"am7pV":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const useLexicalNodeSelection = require("c9257f1b21af9e96");
module.exports = useLexicalNodeSelection;

},{"c9257f1b21af9e96":"1ivgK"}],"1ivgK":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = require("1e96ff0bf4439648"), f = require("2ab39a126bf89ecb"), h = require("f8df2cee5ca1f5c5");
function k(c, a) {
    return c.getEditorState().read(()=>{
        let g = f.$getNodeByKey(a);
        return null === g ? !1 : g.isSelected();
    });
}
exports.useLexicalNodeSelection = function(c) {
    let [a] = b.useLexicalComposerContext(), [g, l] = h.useState(()=>k(a, c));
    h.useEffect(()=>{
        let e = !0, d = a.registerUpdateListener(()=>{
            e && l(k(a, c));
        });
        return ()=>{
            e = !1;
            d();
        };
    }, [
        a,
        c
    ]);
    let m = h.useCallback((e)=>{
        a.update(()=>{
            let d = f.$getSelection();
            f.$isNodeSelection(d) || (d = f.$createNodeSelection(), f.$setSelection(d));
            f.$isNodeSelection(d) && (e ? d.add(c) : d.delete(c));
        });
    }, [
        a,
        c
    ]), n = h.useCallback(()=>{
        a.update(()=>{
            const e = f.$getSelection();
            f.$isNodeSelection(e) && e.clear();
        });
    }, [
        a
    ]);
    return [
        g,
        m,
        n
    ];
};

},{"1e96ff0bf4439648":"2kfbx","2ab39a126bf89ecb":"6uPvi","f8df2cee5ca1f5c5":"cOWTg"}],"cmWs4":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalOnChangePlugin = require("fdae816d869f2a52");
module.exports = LexicalOnChangePlugin;

},{"fdae816d869f2a52":"78HEY"}],"78HEY":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var c = require("3378573bf2864e08"), g = require("46341577a00b447"), h = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement ? g.useLayoutEffect : g.useEffect;
exports.OnChangePlugin = function({ ignoreHistoryMergeTagChange: d = !0, ignoreSelectionChange: e = !1, onChange: a }) {
    let [b] = c.useLexicalComposerContext();
    h(()=>{
        if (a) return b.registerUpdateListener(({ editorState: k, dirtyElements: l, dirtyLeaves: m, prevEditorState: n, tags: f })=>{
            e && 0 === l.size && 0 === m.size || d && f.has("history-merge") || n.isEmpty() || a(k, b, f);
        });
    }, [
        b,
        d,
        e,
        a
    ]);
    return null;
};

},{"3378573bf2864e08":"2kfbx","46341577a00b447":"cOWTg"}],"lloy8":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
const LexicalTabIndentationPlugin = require("3aa69a60477fd68a");
module.exports = LexicalTabIndentationPlugin;

},{"3aa69a60477fd68a":"gmJbu"}],"gmJbu":[function(require,module,exports) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var d = require("adacd749fb78f99f"), e = require("5e2f3689c771e48c"), f = require("54d65403a82e2a41"), g = require("576d23c786920ae1");
function h(b) {
    var a = b.getNodes();
    if (0 < e.$filter(a, (c)=>f.$isBlockElementNode(c) && c.canIndent() ? c : null).length) return !0;
    a = b.anchor;
    b = b.focus;
    b = b.isBefore(a) ? b : a;
    a = b.getNode();
    a = e.$getNearestBlockElementAncestorOrThrow(a);
    if (a.canIndent()) {
        a = a.getKey();
        let c = f.$createRangeSelection();
        c.anchor.set(a, 0, "element");
        c.focus.set(a, 0, "element");
        c = f.$normalizeSelection__EXPERIMENTAL(c);
        if (c.anchor.is(b)) return !0;
    }
    return !1;
}
function k(b) {
    return b.registerCommand(f.KEY_TAB_COMMAND, (a)=>{
        let c = f.$getSelection();
        if (!f.$isRangeSelection(c)) return !1;
        a.preventDefault();
        a = h(c) ? a.shiftKey ? f.OUTDENT_CONTENT_COMMAND : f.INDENT_CONTENT_COMMAND : f.INSERT_TAB_COMMAND;
        return b.dispatchCommand(a, void 0);
    }, f.COMMAND_PRIORITY_EDITOR);
}
exports.TabIndentationPlugin = function() {
    let [b] = d.useLexicalComposerContext();
    g.useEffect(()=>k(b));
    return null;
};
exports.registerTabIndentation = k;

},{"adacd749fb78f99f":"2kfbx","5e2f3689c771e48c":"1V3L7","54d65403a82e2a41":"6uPvi","576d23c786920ae1":"cOWTg"}],"6Xcf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _list = require("@lexical/list");
var _lexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _richText = require("@lexical/rich-text");
var _selection = require("@lexical/selection");
var _utils = require("@lexical/utils");
var _polaris = require("@shopify/polaris");
var _lexical = require("lexical");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _listOlSvg = require("../../../assets/icons/list-ol.svg");
var _listOlSvgDefault = parcelHelpers.interopDefault(_listOlSvg);
var _listUlSvg = require("../../../assets/icons/list-ul.svg");
var _listUlSvgDefault = parcelHelpers.interopDefault(_listUlSvg);
var _textBubbleSvg = require("../../../assets/icons/text-bubble.svg");
var _textBubbleSvgDefault = parcelHelpers.interopDefault(_textBubbleSvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const LowPriority = 1;
const MarkdownEditorToolbar = (props)=>{
    const { disabled, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [editor] = (0, _lexicalComposerContext.useLexicalComposerContext)();
    const [isBold, setIsBold] = (0, _react.useState)(false);
    const [isItalic, setIsItalic] = (0, _react.useState)(false);
    const [isStrikethrough, setIsStrikethrough] = (0, _react.useState)(false);
    const [blockType, setBlockType] = (0, _react.useState)("paragraph");
    const updateToolbar = (0, _react.useCallback)(()=>{
        const selection = (0, _lexical.$getSelection)();
        if ((0, _lexical.$isRangeSelection)(selection)) {
            const anchorNode = selection.anchor.getNode();
            const element = anchorNode.getKey() === "root" ? anchorNode : anchorNode.getTopLevelElementOrThrow();
            const elementKey = element.getKey();
            const elementDOM = editor.getElementByKey(elementKey);
            if (elementDOM !== null) {
                if ((0, _list.$isListNode)(element)) {
                    const parentList = (0, _utils.$getNearestNodeOfType)(anchorNode, (0, _list.ListNode));
                    const type = parentList ? parentList.getTag() : element.getTag();
                    setBlockType(type);
                } else {
                    const type = (0, _richText.$isHeadingNode)(element) ? element.getTag() : element.getType();
                    setBlockType(type);
                }
            }
            // Update text format
            setIsBold(selection.hasFormat("bold"));
            setIsItalic(selection.hasFormat("italic"));
            setIsStrikethrough(selection.hasFormat("strikethrough"));
        }
    }, [
        editor
    ]);
    (0, _react.useEffect)(()=>{
        return (0, _utils.mergeRegister)(editor.registerUpdateListener(({ editorState })=>{
            editorState.read(()=>{
                updateToolbar();
            });
        }), editor.registerCommand((0, _lexical.SELECTION_CHANGE_COMMAND), ()=>{
            updateToolbar();
            return false;
        }, LowPriority));
    }, [
        editor,
        updateToolbar
    ]);
    const formatText = (format)=>()=>editor.dispatchCommand((0, _lexical.FORMAT_TEXT_COMMAND), format);
    const formatParagraph = ()=>{
        if (blockType !== "paragraph") editor.update(()=>{
            const selection = (0, _lexical.$getSelection)();
            if ((0, _lexical.$isRangeSelection)(selection)) (0, _selection.$wrapNodes)(selection, ()=>(0, _lexical.$createParagraphNode)());
        });
    };
    const formatLargeHeading = ()=>{
        if (blockType !== "h1") editor.update(()=>{
            const selection = (0, _lexical.$getSelection)();
            if ((0, _lexical.$isRangeSelection)(selection)) (0, _selection.$wrapNodes)(selection, ()=>(0, _richText.$createHeadingNode)("h1"));
        });
    };
    const formatSmallHeading = ()=>{
        if (blockType !== "h2") editor.update(()=>{
            const selection = (0, _lexical.$getSelection)();
            if ((0, _lexical.$isRangeSelection)(selection)) (0, _selection.$wrapNodes)(selection, ()=>(0, _richText.$createHeadingNode)("h2"));
        });
    };
    const formatQuote = ()=>{
        if (blockType !== "quote") editor.update(()=>{
            const selection = (0, _lexical.$getSelection)();
            if ((0, _lexical.$isRangeSelection)(selection)) (0, _selection.$wrapNodes)(selection, ()=>(0, _richText.$createQuoteNode)());
        });
    };
    const formatBulletList = ()=>{
        if (blockType !== "ul") editor.dispatchCommand((0, _list.INSERT_UNORDERED_LIST_COMMAND), undefined);
        else editor.dispatchCommand((0, _list.REMOVE_LIST_COMMAND), undefined);
    };
    const formatNumberedList = ()=>{
        if (blockType !== "ol") editor.dispatchCommand((0, _list.INSERT_ORDERED_LIST_COMMAND), undefined);
        else editor.dispatchCommand((0, _list.REMOVE_LIST_COMMAND), undefined);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
        spacing: "tight",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.ButtonGroup), {
                segmented: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        outline: true,
                        pressed: isBold,
                        onClick: formatText("bold"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "semibold",
                            children: "B"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        outline: true,
                        pressed: isItalic,
                        onClick: formatText("italic"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItalicText, {
                            children: "I"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        outline: true,
                        pressed: isStrikethrough,
                        onClick: formatText("strikethrough"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StrikeThroughText, {
                            children: "S"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.ButtonGroup), {
                segmented: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        outline: true,
                        pressed: blockType === "paragraph",
                        onClick: formatParagraph,
                        children: f("default.normal")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        outline: true,
                        pressed: blockType === "h1",
                        onClick: formatLargeHeading,
                        children: "H1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        outline: true,
                        pressed: blockType === "h2",
                        onClick: formatSmallHeading,
                        children: "H2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _textBubbleSvgDefault.default),
                            useMask: true
                        }),
                        outline: true,
                        pressed: blockType === "quote",
                        onClick: formatQuote
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.ButtonGroup), {
                segmented: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _listUlSvgDefault.default),
                            useMask: true
                        }),
                        outline: true,
                        pressed: blockType === "ul",
                        onClick: formatBulletList
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        disabled: disabled,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _listOlSvgDefault.default),
                            useMask: true
                        }),
                        outline: true,
                        pressed: blockType === "ol",
                        onClick: formatNumberedList
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                fill: true,
                children: children
            })
        ]
    });
};
const ItalicText = (0, _styledComponentsDefault.default).span`
  font-style: italic;
`;
const StrikeThroughText = (0, _styledComponentsDefault.default).span`
  text-decoration: line-through;
`;
exports.default = MarkdownEditorToolbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@lexical/list":"2CQxU","@lexical/react/LexicalComposerContext":"2kfbx","@lexical/rich-text":"kNqAc","@lexical/selection":"57ffa","@lexical/utils":"1V3L7","@shopify/polaris":"ek5a0","lexical":"6uPvi","styled-components":"eBrdC","../../../assets/icons/list-ol.svg":"7F8uj","../../../assets/icons/list-ul.svg":"4rYEX","../../../assets/icons/text-bubble.svg":"52FbG","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7F8uj":[function(require,module,exports) {
module.exports = require("ffba4d8135e87de3").getBundleURL("kEMsi") + "list-ol.da0bd3bd.svg";

},{"ffba4d8135e87de3":"75UoR"}],"4rYEX":[function(require,module,exports) {
module.exports = require("3f8984adb5cf9c8a").getBundleURL("kEMsi") + "list-ul.32d174ca.svg";

},{"3f8984adb5cf9c8a":"75UoR"}],"8L2QK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _markdown = require("@lexical/markdown");
var _lexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _markdown1 = require("../../constants/markdown");
var _useNonInitialEffect = require("../../hooks/useNonInitialEffect");
var _useNonInitialEffectDefault = parcelHelpers.interopDefault(_useNonInitialEffect);
const UpdateStatePlugin = (props)=>{
    const { value } = props;
    const [editor] = (0, _lexicalComposerContext.useLexicalComposerContext)();
    (0, _useNonInitialEffectDefault.default)(()=>{
        if (!editor) return;
        editor.update(()=>{
            const markdown = (0, _markdown.$convertToMarkdownString)((0, _markdown1.TRANSFORMERS));
            if (markdown !== value) (0, _markdown.$convertFromMarkdownString)(value, (0, _markdown1.TRANSFORMERS));
        });
    }, [
        value,
        editor
    ]);
    return null;
};
exports.default = UpdateStatePlugin;

},{"@lexical/markdown":"a7yhR","@lexical/react/LexicalComposerContext":"2kfbx","../../constants/markdown":"6FvAU","../../hooks/useNonInitialEffect":"7lww1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"abnaO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _settingsFollowupPage = require("../SettingsFollowupPage/SettingsFollowupPage");
const SettingsFollowupNotifications = (props)=>{
    const { settings, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [notificationsFrequency, setNotificationsFrequency] = (0, _react.useState)(settings.email_notification_frequency);
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).FOLLOW_UP_SETTINGS
    ]);
    const updateSettingMutation = ()=>(0, _apiDefault.default).updateFollowUpSettings({
            ...settings,
            email_notification_frequency: notificationsFrequency
        });
    const disabled = readonly || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsPageDefault.default), {
        readonly: readonly,
        apiCall: updateSettingMutation,
        onSaveAfter: setQueryData,
        title: f("followup-notifications.settings.page.title"),
        subtitle: f("followup-notifications.settings.intervals.description"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            variant: "bodyMd",
                            as: "span",
                            fontWeight: "semibold",
                            children: f("notifications-settings.followup.form.label")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: f("notifications-settings.followup.form.label.no-notification"),
                                    checked: !readonly && notificationsFrequency === "NOT_SET",
                                    onChange: ()=>setNotificationsFrequency("NOT_SET"),
                                    disabled: disabled
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: f("notifications-settings.followup.form.label.weekly"),
                                    checked: !readonly && notificationsFrequency === "WEEKLY",
                                    onChange: ()=>setNotificationsFrequency("WEEKLY"),
                                    disabled: disabled
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: f("notifications-settings.followup.form.label.monthly"),
                                    checked: !readonly && notificationsFrequency === "MONTHLY",
                                    onChange: ()=>setNotificationsFrequency("MONTHLY"),
                                    disabled: disabled
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const SettingsFollowupNotificationsPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsFollowupNotifications, {
        settings: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsFollowupNotificationsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).FOLLOW_UP_SETTINGS,
    apiFunction: (0, _apiDefault.default).getFollowUpSettings,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsFollowupNotifications, {
        readonly: true,
        settings: (0, _settingsFollowupPage.EMPTY_FOLLOWUP_SETTINGS)
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../SettingsFollowupPage/SettingsFollowupPage":"iaLmF","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iaLmF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_FOLLOWUP_SETTINGS", ()=>EMPTY_FOLLOWUP_SETTINGS);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _followup = require("../../constants/followup");
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _collectionUtils = require("../../utils/collectionUtils");
var _numbersUtils = require("../../utils/numbersUtils");
var _riskIntervalsEditor = require("./RiskIntervalsEditor/RiskIntervalsEditor");
var _riskIntervalsEditorDefault = parcelHelpers.interopDefault(_riskIntervalsEditor);
const EMPTY_FOLLOWUP_SETTINGS = {
    email_notification_frequency: "NOT_SET"
};
const convertMonthsToIntervalType = (months)=>({
        months,
        custom: (0, _numbersUtils.isNumber)(months) && !(0, _followup.INTERVALS_IN_MONTHS).includes(months)
    });
const SettingsFollowup = (props)=>{
    const { followupSettings, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [intervals, setIntervals] = (0, _react.useState)(()=>new Map([
            [
                "LOW",
                convertMonthsToIntervalType(followupSettings.low_risk_level_interval)
            ],
            [
                "MEDIUM",
                convertMonthsToIntervalType(followupSettings.medium_risk_level_interval)
            ],
            [
                "HIGH",
                convertMonthsToIntervalType(followupSettings.high_risk_level_interval)
            ]
        ]));
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).FOLLOW_UP_SETTINGS
    ]);
    const getInterval = (risk)=>intervals.get(risk)?.months;
    const updateSettingMutation = ()=>(0, _apiDefault.default).updateFollowUpSettings({
            ...followupSettings,
            low_risk_level_interval: getInterval("LOW"),
            medium_risk_level_interval: getInterval("MEDIUM"),
            high_risk_level_interval: getInterval("HIGH")
        });
    const disabled = readonly || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const updateInterval = (risk, months, custom = false)=>setIntervals(new Map(intervals).set(risk, {
            ...intervals.get(risk),
            months,
            custom
        }));
    // split label into 2 parts in order to insert a link between them
    const messages = f("followup-settings.page.link-to-notifications").split("<link>");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsPageDefault.default), {
        readonly: readonly,
        apiCall: updateSettingMutation,
        onSaveAfter: setQueryData,
        title: f("followup-settings.page.title"),
        subtitle: f("followup-settings.intervals.description"),
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
            gap: "1",
            blockAlign: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: (0, _collectionUtils.first)(messages)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                    url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_FOLLOWUP_NOTIFICATIONS),
                    children: f("followup-notifications.settings.page.title")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    children: (0, _collectionUtils.last)(messages)
                })
            ]
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Scrollable), {
                    vertical: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskIntervalsEditorDefault.default), {
                        intervals: intervals,
                        readonly: disabled,
                        onIntervalChange: updateInterval
                    })
                })
            })
        })
    });
};
const SettingsFollowupPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsFollowup, {
        followupSettings: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsFollowupPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).FOLLOW_UP_SETTINGS,
    apiFunction: (0, _apiDefault.default).getFollowUpSettings,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsFollowup, {
        readonly: true,
        followupSettings: EMPTY_FOLLOWUP_SETTINGS
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/followup":"kBYmS","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","../../utils/numbersUtils":"2RGyl","./RiskIntervalsEditor/RiskIntervalsEditor":"iLkVA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iLkVA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _separatorStackWrapper = require("../../../components/SeparatorStackWrapper/SeparatorStackWrapper");
var _separatorStackWrapperDefault = parcelHelpers.interopDefault(_separatorStackWrapper);
var _riskTypes = require("../../../constants/risk-types");
var _riskFollowupInterval = require("./RiskFollowupInterval");
var _riskFollowupIntervalDefault = parcelHelpers.interopDefault(_riskFollowupInterval);
const RiskIntervalsEditor = (props)=>{
    const { intervals, readonly, onIntervalChange } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separatorStackWrapperDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack), {
            distribution: "fillEvenly",
            wrap: false,
            children: (0, _riskTypes.RiskTypes).map((risk)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskFollowupIntervalDefault.default), {
                    risk: risk,
                    isCustom: Boolean(intervals.get(risk)?.custom),
                    readonly: readonly,
                    intervalInMonths: intervals.get(risk)?.months,
                    onIntervalChange: (intervalInMonths, isCustom)=>onIntervalChange(risk, intervalInMonths, isCustom)
                }, risk))
        })
    });
};
exports.default = RiskIntervalsEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../components/SeparatorStackWrapper/SeparatorStackWrapper":"9GfEY","../../../constants/risk-types":"hJsRK","./RiskFollowupInterval":"9kmfz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9kmfz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _risk = require("../../../components/Risk/Risk");
var _riskDefault = parcelHelpers.interopDefault(_risk);
var _followup = require("../../../constants/followup");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _util = require("../../../utils/util");
const RiskFollowupInterval = (props)=>{
    const { risk, isCustom, intervalInMonths, readonly, onIntervalChange } = props;
    const [customInterval, setCustomInterval] = (0, _react.useState)(intervalInMonths || 1);
    const f = (0, _useFormatMessageDefault.default)();
    const getIntervalLabel = (months)=>months < 12 ? f("common.month", {
            months: months
        }) : f("common.year", {
            years: months / 12
        });
    const handleCustomIntervalChange = (value)=>{
        const months = parseInt(value);
        setCustomInterval(months);
        onIntervalChange(months, true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskDefault.default), {
                risk: risk,
                labelSuffix: f("default.risk")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                        label: f("followup-settings.intervals.labels.no-interval"),
                        checked: (0, _util.isNil)(intervalInMonths),
                        onChange: ()=>onIntervalChange(undefined, false),
                        disabled: readonly
                    }),
                    (0, _followup.INTERVALS_IN_MONTHS).map((interval)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                            label: getIntervalLabel(interval),
                            checked: intervalInMonths === interval && !isCustom,
                            onChange: ()=>onIntervalChange(interval, false),
                            disabled: readonly
                        }, interval)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        blockAlign: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                label: f("followup-settings.intervals.labels.custom-interval"),
                                checked: isCustom,
                                onChange: ()=>onIntervalChange(customInterval, true),
                                disabled: readonly
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCustomIntervalWrapper, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                    type: "number",
                                    label: f("followup-settings.intervals.labels.custom-interval"),
                                    labelHidden: true,
                                    placeholder: f("followup-settings.intervals.labels.custom-interval.placeholder"),
                                    autoComplete: "off",
                                    suffix: f("default.months", {
                                        months: customInterval
                                    }),
                                    min: 1,
                                    max: (0, _followup.MAX_FOLLOWUP_INTERVAL_IN_MONTHS),
                                    value: Number(customInterval).toFixed(0),
                                    onChange: handleCustomIntervalChange,
                                    disabled: readonly || !isCustom,
                                    focused: isCustom && !readonly
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }, risk);
};
// limit the width of the custom text field
const StyledCustomIntervalWrapper = (0, _styledComponentsDefault.default).div`
  width: var(--kdk-followup-number-max-width);
  padding-bottom: var(--p-space-1);
`;
exports.default = RiskFollowupInterval;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../components/Risk/Risk":"9VLEF","../../../constants/followup":"kBYmS","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8jD3v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _confirmAction = require("../../components/ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _customerReviewGuidelineEditor = require("../../components/CustomerReviewGuidelineEditor/CustomerReviewGuidelineEditor");
var _customerReviewGuidelineEditorDefault = parcelHelpers.interopDefault(_customerReviewGuidelineEditor);
var _displayName = require("../../components/DisplayName/DisplayName");
var _displayNameDefault = parcelHelpers.interopDefault(_displayName);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _kdktabs = require("../../components/KDKTabs/KDKTabs");
var _kdktabsDefault = parcelHelpers.interopDefault(_kdktabs);
var _sectionMargin = require("../../components/SectionMargin/SectionMargin");
var _sectionMarginDefault = parcelHelpers.interopDefault(_sectionMargin);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const EMPTY_GUIDELINE = {
    text_md: {
        nb: "",
        en: ""
    },
    title: {
        nb: "",
        en: ""
    }
};
const SettingsGuidelines = (props)=>{
    const { guidelines, readonly } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [customerType, setCustomerType] = (0, _react.useState)("person");
    const [personGuideline, setPersonGuideline, isPersonGuidelineChanged] = (0, _useChangedStateDefault.default)(guidelines[0]);
    const [companyGuideline, setCompanyGuideline, isCompanyGuidelineChanged] = (0, _useChangedStateDefault.default)(guidelines[1]);
    const [showResetWarning, toggleResetWarning, closeResetWarning] = (0, _useOpenCloseDefault.default)();
    const [showSuccessMessageToast, toggleShowSuccessMessageToast, closeSuccessMessageToast] = (0, _useOpenCloseDefault.default)();
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_GUIDELINES_SETTINGS
    ]);
    const updateSettings = ()=>Promise.all([
            (0, _apiDefault.default).updateReviewGuideline("person", personGuideline),
            (0, _apiDefault.default).updateReviewGuideline("company", companyGuideline)
        ]);
    const onSuccess = (responses)=>{
        setQueryData(responses);
        queryClient.invalidateQueries([
            (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_GUIDELINE
        ]);
    };
    const resetSettingsMutation = (0, _reactQuery.useMutation)(()=>Promise.all([
            (0, _apiDefault.default).updateReviewSettings({
                use_default_guideline: true
            })
        ]), {
        onSuccess: async ()=>{
            await queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_GUIDELINE
            ]);
            await queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_GUIDELINES_SETTINGS
            ]);
            const data = queryClient.getQueryData([
                (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_GUIDELINES_SETTINGS
            ]);
            if (data) {
                const [updatedPersonGuideline, updatedCompanyGuideline] = data;
                setPersonGuideline(updatedPersonGuideline);
                setCompanyGuideline(updatedCompanyGuideline);
            }
            toggleShowSuccessMessageToast();
            closeResetWarning();
        }
    });
    const isChanged = isPersonGuidelineChanged || isCompanyGuidelineChanged;
    const disabled = readonly || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS) || resetSettingsMutation.isLoading;
    const tabs = [
        {
            id: "person",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                name: f("common.labels.customer-type.person"),
                type: "person"
            })
        },
        {
            id: "company",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayNameDefault.default), {
                name: f("common.labels.customer-type.company"),
                type: "company"
            })
        }
    ];
    const handleSelectionChange = (selectedTabIndex)=>setCustomerType(selectedTabIndex === 0 ? "person" : "company");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        apiCall: updateSettings,
        onSaveAfter: onSuccess,
        title: f("customer-review-guideline-settings.page.title"),
        subtitle: f("customer-review-guideline-settings.page.description"),
        readonly: readonly,
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            disabled: disabled || !isChanged,
            onClick: toggleResetWarning,
            children: f("default.reset")
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktabsDefault.default), {
                selected: customerType === "person" ? 0 : 1,
                tabs: tabs,
                onSelect: handleSelectionChange
            }),
            customerType === "person" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewGuidelineEditorDefault.default), {
                guideline: personGuideline,
                readonly: disabled,
                onChange: setPersonGuideline
            }),
            customerType === "company" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerReviewGuidelineEditorDefault.default), {
                guideline: companyGuideline,
                readonly: disabled,
                onChange: setCompanyGuideline
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionMarginDefault.default), {
                divider: true,
                size: "medium"
            }),
            resetSettingsMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: resetSettingsMutation.error
            }),
            showSuccessMessageToast && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
                content: f("common.labels.saved-successfully"),
                onDismiss: closeSuccessMessageToast
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: ()=>resetSettingsMutation.mutateAsync(),
                isOpen: showResetWarning,
                title: f("customer-review-guideline-settings.page.reset.confirmation.title"),
                description: f("customer-review-guideline-settings.page.reset.confirmation.description"),
                isDestructive: true,
                actionTitle: f("default.reset"),
                onNo: closeResetWarning
            })
        ]
    });
};
const SettingsGuidelinesPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsGuidelines, {
        guidelines: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsGuidelinesPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).CUSTOMER_REVIEW_GUIDELINES_SETTINGS,
    apiFunction: (options)=>Promise.all([
            (0, _apiDefault.default).getReviewGuideline("person", options),
            (0, _apiDefault.default).getReviewGuideline("company", options)
        ]),
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsGuidelines, {
        readonly: true,
        guidelines: [
            EMPTY_GUIDELINE,
            EMPTY_GUIDELINE
        ]
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/ConfirmAction/ConfirmAction":"icP5J","../../components/CustomerReviewGuidelineEditor/CustomerReviewGuidelineEditor":"bul2R","../../components/DisplayName/DisplayName":"gKd5g","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/extensions/Button":"8exc0","../../components/KDKTabs/KDKTabs":"hryzj","../../components/SectionMargin/SectionMargin":"l3u8a","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../hooks/useChangedState":"170jW","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bul2R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _languages = require("../../constants/languages");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _translationTextMarkdownEditor = require("../TranslationTextMarkdownEditor/TranslationTextMarkdownEditor");
var _translationTextMarkdownEditorDefault = parcelHelpers.interopDefault(_translationTextMarkdownEditor);
const CustomerReviewGuidelineEditor = (props)=>{
    const { guideline, readonly, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const [language, setLanguage] = (0, _react.useState)((0, _languages.DEFAULT_LANGUAGE));
    const handleChange = (field, value)=>onChange({
            ...guideline,
            [field]: value
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _translationTextMarkdownEditorDefault.default), {
                    translationText: guideline.text_md,
                    onTextChange: (value)=>handleChange("text_md", value),
                    language: language,
                    onLanguageChange: setLanguage,
                    readonly: readonly,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                        label: f("customer-review-guideline-settings.labels.guideline.header"),
                        value: guideline.title[language] || "",
                        placeholder: f("reviews.titles.guideline-tips"),
                        onChange: (value)=>handleChange("title", {
                                ...guideline.title,
                                [language]: value
                            }),
                        labelHidden: true,
                        autoComplete: "off"
                    })
                }, language)
            }),
            guideline.updated_by && guideline.updated_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                italic: true,
                children: f("common.labels.modified-by", {
                    name: getUserDisplayName(guideline.updated_by),
                    timestamp: new Date(guideline.updated_dt)
                })
            })
        ]
    });
};
exports.default = CustomerReviewGuidelineEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/languages":"ecnY7","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../CondensedText/CondensedText":"1FshD","../TranslationTextMarkdownEditor/TranslationTextMarkdownEditor":"jyxRk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9LhNc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_MEASURE", ()=>EMPTY_MEASURE);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFlipMove = require("react-flip-move");
var _reactFlipMoveDefault = parcelHelpers.interopDefault(_reactFlipMove);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _penLineSvg = require("../../../assets/icons/pen-line.svg");
var _penLineSvgDefault = parcelHelpers.interopDefault(_penLineSvg);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _actionsDropdown = require("../../components/ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _condensedText = require("../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _confirmAction = require("../../components/ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _badge = require("../../components/extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _cardSection = require("../../components/extensions/CardSection");
var _cardSectionDefault = parcelHelpers.interopDefault(_cardSection);
var _measureEditModal = require("../../components/MeasureEditModal/MeasureEditModal");
var _measureEditModalDefault = parcelHelpers.interopDefault(_measureEditModal);
var _moveButtons = require("../../components/MoveButtons/MoveButtons");
var _moveButtonsDefault = parcelHelpers.interopDefault(_moveButtons);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _collectionUtils = require("../../utils/collectionUtils");
var _util = require("../../utils/util");
const EMPTY_MEASURES = {
    measure_configs: []
};
const EMPTY_MEASURE = {
    id: "",
    title: "",
    description: ""
};
const SettingsMeasures = (props)=>{
    const { measuresList, readonly, loading } = props;
    const [isShowingArchivedMeasures, toggleShowArchivedMeasures] = (0, _useOpenCloseDefault.default)();
    const [isModalOpen, toggleModalOpen, closeModal] = (0, _useOpenCloseDefault.default)();
    const [isDeleteConfirmOpen, toggleDeleteConfirm, closeDeleteConfirm] = (0, _useOpenCloseDefault.default)();
    const [currentMeasure, setCurrentMeasure] = (0, _react.useState)(EMPTY_MEASURE);
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).MEASURES_SETTINGS
    ]);
    const f = (0, _useFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const measures = isShowingArchivedMeasures ? measuresList.measure_configs : measuresList.measure_configs.filter((measureConfig)=>!measureConfig.is_archived);
    const isNewMeasure = !currentMeasure.id;
    const saveMeasureMutation = (0, _reactQuery.useMutation)(({ title, description })=>{
        return isNewMeasure ? (0, _apiDefault.default).createGlobalMeasureConfig({
            title,
            description
        }) : (0, _apiDefault.default).updateGlobalMeasureConfig(currentMeasure.id, {
            title,
            description
        });
    }, {
        onSuccess: (updatedMeasure)=>{
            if (isNewMeasure) updateQueryData((queryData)=>queryData.measure_configs = [
                    updatedMeasure,
                    ...queryData.measure_configs
                ]);
            else updateQueryData((queryData)=>queryData.measure_configs = queryData.measure_configs.map((measure)=>measure.id === updatedMeasure.id ? updatedMeasure : measure));
            closeAndClearModal();
        }
    });
    const moveMeasureMutation = (0, _reactQuery.useMutation)(({ measure, direction })=>(0, _apiDefault.default).moveGlobalMeasureConfig(measure.id, {
            direction: direction === "up" ? "UP" : "DOWN"
        }), {
        onMutate: ({ measure, direction })=>{
            const index = measures.indexOf(measure);
            const targetIndex = index + (direction === "up" ? -1 : 1);
            updateQueryData((queryData)=>queryData.measure_configs = (0, _collectionUtils.swapElements)(queryData.measure_configs, index, targetIndex));
        }
    });
    const disabled = readonly || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const deleteMeasureMutation = (0, _reactQuery.useMutation)((0, _apiDefault.default).archiveGlobalMeasureConfig, {
        onSuccess: (response, deletedMeasureId)=>{
            updateQueryData((queryData)=>queryData.measure_configs = queryData.measure_configs.filter((measure)=>measure.id !== deletedMeasureId));
        }
    });
    const closeAndClearModal = ()=>{
        closeModal();
        setCurrentMeasure(EMPTY_MEASURE);
        saveMeasureMutation.reset();
    };
    const editMeasure = (measure)=>{
        setCurrentMeasure(measure);
        toggleModalOpen();
    };
    const getMeasureActions = (measure)=>measure.is_archived ? [] : [
            {
                content: disabled ? f("default.view") : f("default.edit"),
                image: (0, _penLineSvgDefault.default),
                disabled: readonly,
                onAction: ()=>readonly ? (0, _util.noop) : editMeasure(measure)
            },
            {
                content: f("default.archive"),
                image: (0, _trashSvgDefault.default),
                disabled: disabled,
                onAction: ()=>{
                    if (!disabled) {
                        setCurrentMeasure(measure);
                        toggleDeleteConfirm();
                    }
                }
            }
        ];
    const filterUsersLabel = isShowingArchivedMeasures ? f("measures-settings.page.filter.hide-archived-measures") : f("measures-settings.page.filter.show-archived-measures");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        readonly: readonly,
        title: f("measures-settings.page.title"),
        subtitle: f("measures-settings.page.description"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            onClick: toggleModalOpen,
            disabled: disabled,
            children: f("measures.modal.title.add")
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                children: [
                    measures.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                    spacing: "extraLoose",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                            fill: true,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                                children: f("table.column.measure")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                            children: f("common.buttons.actions.button").toUpperCase()
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFlipMoveDefault.default), {
                                enterAnimation: false,
                                leaveAnimation: false,
                                appearAnimation: false,
                                children: measures.map((measure, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCardSection, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                                            wrap: false,
                                            spacing: "extraLoose",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                                                    fill: true,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledMeasureConfigRow, {
                                                        onClick: measure.is_archived ? (0, _util.noop) : ()=>editMeasure(measure),
                                                        disabled: measure.is_archived,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                                            gap: "4",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                                    gap: measure.is_archived ? "2" : "0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                                            variant: "bodyMd",
                                                                            as: "span",
                                                                            fontWeight: "semibold",
                                                                            children: measure.title
                                                                        }),
                                                                        measure.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                                                                            size: "xsmall",
                                                                            children: f("badge.archived")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                                    as: "span",
                                                                    color: measure.is_archived ? "subdued" : undefined,
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DescriptionText, {
                                                                        children: measure.description
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                    gap: "4",
                                                    blockAlign: "center",
                                                    wrap: false,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                                                            items: getMeasureActions(measure),
                                                            hideTitle: true
                                                        }),
                                                        !measure.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveButtonsDefault.default), {
                                                            readonly: disabled,
                                                            disableMoveUp: index === 0,
                                                            disableMoveDown: index === measures.length - 1 || measures[index + 1]?.is_archived,
                                                            onOrderChange: (direction)=>moveMeasureMutation.mutate({
                                                                    measure,
                                                                    direction
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, measure.id))
                            })
                        ]
                    }),
                    !loading && measures.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.EmptyState), {
                        image: "",
                        heading: f("measures.modal.empty-state")
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.EmptyState), {
                        image: "",
                        heading: f("default.loading"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: toggleShowArchivedMeasures,
                    disclosure: isShowingArchivedMeasures ? "up" : "down",
                    children: filterUsersLabel
                })
            }),
            isModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measureEditModalDefault.default), {
                measure: currentMeasure,
                existingMeasures: measures,
                isNewMeasure: isNewMeasure,
                readonly: disabled,
                isLoading: saveMeasureMutation.isLoading,
                error: saveMeasureMutation.error,
                onSave: (measure)=>saveMeasureMutation.mutate(measure),
                onClose: closeAndClearModal
            }),
            isDeleteConfirmOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: ()=>deleteMeasureMutation.mutateAsync(currentMeasure.id),
                title: f("measures.confirm-archive.title"),
                description: f("measures.confirm-archive.description", {
                    name: currentMeasure.title
                }),
                onNo: ()=>{
                    closeDeleteConfirm();
                    setCurrentMeasure(EMPTY_MEASURE);
                },
                actionTitle: f("measures.confirm-archive.labels.archive.button")
            })
        ]
    });
};
const StyledCardSection = (0, _styledComponentsDefault.default)((0, _cardSectionDefault.default))`
  border-top: var(--p-border-divider);
  transition: background-color var(--p-duration-200) var(--p-ease-in-out);

  &:hover {
    background-color: var(--p-surface-hovered);
  }
`;
const StyledMeasureConfigRow = (0, _styledComponentsDefault.default).div`
  cursor: ${({ disabled })=>disabled ? "auto" : "pointer"};
`;
const DescriptionText = (0, _styledComponentsDefault.default).div`
  white-space: pre;
`;
const SettingsMeasuresPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsMeasures, {
        measuresList: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsMeasuresPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).MEASURES_SETTINGS,
    apiFunction: (0, _apiDefault.default).getGlobalMeasureConfigs,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsMeasures, {
        readonly: true,
        loading: true,
        measuresList: EMPTY_MEASURES
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-flip-move":"7Sobo","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../assets/icons/pen-line.svg":"9iTi6","../../../assets/icons/trash.svg":"jqW55","../../api":"f6lXD","../../components/ActionsDropdown/ActionsDropdown":"izRYG","../../components/AddButton/AddButton":"WJGEt","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/CondensedText/CondensedText":"1FshD","../../components/ConfirmAction/ConfirmAction":"icP5J","../../components/extensions/Badge":"9irVp","../../components/extensions/Button":"8exc0","../../components/extensions/CardSection":"c1OyP","../../components/MeasureEditModal/MeasureEditModal":"748su","../../components/MoveButtons/MoveButtons":"dsvCr","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c1OyP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _types = require("./types");
const CardSection = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { status, className, ...cardSectionProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyleCardSectionWrapper, {
        status: status,
        className: className,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
            ...cardSectionProps
        })
    });
});
const StyleCardSectionWrapper = (0, _styledComponentsDefault.default).div`
  & .Polaris-Card__Section {
    ${({ status })=>status && `background-color: var(${(0, _types.STATUS_TO_CUSTOM_PROPERTY_NAME)[status]});`}
  }
`;
exports.default = CardSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","./types":"k0aig","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bP3xm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _screeningTypeCard = require("../../components/ScreeningTypeCard/ScreeningTypeCard");
var _screeningTypeCardDefault = parcelHelpers.interopDefault(_screeningTypeCard);
var _sectionTile = require("../../components/SectionTile/SectionTile");
var _sectionTileDefault = parcelHelpers.interopDefault(_sectionTile);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _signatureConfigurationForm = require("../../components/SignatureConfigurationForm/SignatureConfigurationForm");
var _signatureConfigurationFormDefault = parcelHelpers.interopDefault(_signatureConfigurationForm);
var _onboarding = require("../../constants/onboarding");
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const SettingsOnboarding = (props)=>{
    const { settings: initialSettings, readonly, loading } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const [settings, setSettings] = (0, _react.useState)({
        ...initialSettings
    });
    const { setQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ONBOARDING_SETTINGS
    ]);
    const onFieldChange = (0, _react.useCallback)((field, value)=>setSettings((prevState)=>({
                ...prevState,
                [field]: value
            })), [
        settings
    ]);
    const onSignatureFieldChange = (0, _react.useCallback)((value)=>setSettings((prevState)=>({
                ...prevState,
                signature_settings: value
            })), [
        settings
    ]);
    const disabled = readonly || loading || !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        readonly: disabled,
        apiCall: ()=>(0, _apiDefault.default).updatePersonOnboardingSettings(settings),
        onSaveAfter: setQueryData,
        title: f("onboarding-settings.page.title"),
        subtitle: f("onboarding-settings.page.description"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionTileDefault.default), {
                        title: f("screening.titles.screening-frequency"),
                        gap: "4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screeningTypeCardDefault.default), {
                            readonly: disabled,
                            screeningType: settings.screening_type,
                            onScreeningTypeChange: (newValue)=>onFieldChange("screening_type", newValue)
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signatureConfigurationFormDefault.default), {
                        signature: settings.signature_settings,
                        customerType: "person",
                        readonly: disabled,
                        onSignatureChange: onSignatureFieldChange
                    })
                })
            })
        ]
    });
};
const SettingsOnboardingPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsOnboarding, {
        settings: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsOnboardingPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).ONBOARDING_SETTINGS,
    apiFunction: (0, _apiDefault.default).getPersonOnboardingSettings,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsOnboarding, {
        readonly: true,
        loading: true,
        settings: (0, _onboarding.DEFAULT_ONBOARDING_CONFIGURATION)
    })
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/ScreeningTypeCard/ScreeningTypeCard":"2sGBG","../../components/SectionTile/SectionTile":"9KSoL","../../components/SettingsPage/SettingsPage":"gJDHL","../../components/SignatureConfigurationForm/SignatureConfigurationForm":"dMptb","../../constants/onboarding":"lQH9P","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eeCug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _eyeSvg = require("../../../assets/icons/eye.svg");
var _eyeSvgDefault = parcelHelpers.interopDefault(_eyeSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _badge = require("../../components/extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _questionnaireEditor = require("../../components/QuestionnaireEditor/QuestionnaireEditor");
var _questionnaireEditorDefault = parcelHelpers.interopDefault(_questionnaireEditor);
var _questionnairePageHeader = require("../../components/QuestionnairePageHeader/QuestionnairePageHeader");
var _questionnairePageHeaderDefault = parcelHelpers.interopDefault(_questionnairePageHeader);
var _questionnairePageSkeleton = require("../../components/QuestionnairePageSkeleton/QuestionnairePageSkeleton");
var _questionnairePageSkeletonDefault = parcelHelpers.interopDefault(_questionnairePageSkeleton);
var _questionnairePreviewModal = require("../../components/QuestionnairePreviewModal/QuestionnairePreviewModal");
var _questionnairePreviewModalDefault = parcelHelpers.interopDefault(_questionnairePreviewModal);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _questionnaires = require("../../constants/questionnaires");
var _routes = require("../../constants/routes");
var _questionnaireHelpers = require("../../helpers/questionnaire.helpers");
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _collectionUtils = require("../../utils/collectionUtils");
var _history = require("../../utils/history");
var _historyDefault = parcelHelpers.interopDefault(_history);
var _util = require("../../utils/util");
var _settingsQuestionnaireDetailsPageHelpers = require("./SettingsQuestionnaireDetailsPage.helpers");
const SettingsQuestionnaireDetailsPage = ({ data })=>{
    const isNew = (0, _settingsQuestionnaireDetailsPageHelpers.isNewQuestionnaire)(data);
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [questionnaire, setQuestionnaire, changed] = (0, _useChangedStateDefault.default)(()=>(0, _util.clone)(data));
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES
    ]);
    const [showPreviewModal, togglePreviewModal, closePreviewModal] = (0, _useOpenCloseDefault.default)();
    const saveQuestionnaireMutation = (0, _reactQuery.useMutation)(()=>isNew ? (0, _apiDefault.default).createQuestionnaire((0, _questionnaireHelpers.convertQuestionnaireToCreateQuestionnaireRequest)(questionnaire)) : (0, _apiDefault.default).updateQuestionnaire(questionnaire.id, (0, _questionnaireHelpers.convertQuestionnaireToUpdateQuestionnaireRequest)(questionnaire)), {
        onSuccess: (newQuestionnaire)=>{
            updateQueryData((queryData)=>{
                if (isNew) {
                    queryData.questionnaires = [
                        newQuestionnaire,
                        ...queryData.questionnaires
                    ];
                    // after a new questionnaire is saved, route to the same page but with the saved questionnaire id
                    (0, _historyDefault.default).push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_QUESTIONNAIRE_DETAILS, {
                        id: newQuestionnaire.id
                    }));
                } else queryData.questionnaires = (0, _collectionUtils.updateItem)(queryData.questionnaires, newQuestionnaire);
            });
            setSnackbar(f("common.labels.saved-successfully"));
            Promise.all([
                queryClient.invalidateQueries([
                    (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES_SUMMARY
                ]),
                queryClient.invalidateQueries([
                    (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES
                ])
            ]);
        }
    });
    const readonly = !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const handleChange = (updatedQuestionnaire)=>{
        setQuestionnaire(()=>(0, _util.clone)(updatedQuestionnaire));
        saveQuestionnaireMutation.reset();
    };
    const navigateToQuestionnairesListPage = ()=>(0, _historyDefault.default).push((0, _routes.ROUTES).SETTINGS_QUESTIONNAIRES_LIST);
    const invalid = (0, _settingsQuestionnaireDetailsPageHelpers.isInvalidQuestionnaire)(questionnaire);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                        showAsLink: true,
                        url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_QUESTIONNAIRES_LIST),
                        displayLabel: f("questionnaire.page.title")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "2",
                        blockAlign: "baseline",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "headingLg",
                                as: "h2",
                                children: f("questionnaire.details.page.title.new-questionnaire")
                            }),
                            questionnaire.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                                size: "xsmall",
                                children: f("badge.archived")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairePageHeaderDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnaireEditorDefault.default), {
                        questionnaire: questionnaire,
                        readonly: saveQuestionnaireMutation.isLoading || questionnaire.is_archived || readonly,
                        onChange: handleChange,
                        error: saveQuestionnaireMutation.error
                    }),
                    invalid && changed && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.InlineError), {
                        message: f("questionnaire.details.page.invalid"),
                        fieldID: ""
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: togglePreviewModal,
                                icon: (0, _eyeSvgDefault.default),
                                disabled: invalid || saveQuestionnaireMutation.isLoading || questionnaire.is_archived,
                                children: f("default.preview")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: navigateToQuestionnairesListPage,
                                disabled: saveQuestionnaireMutation.isLoading,
                                children: f("default.cancel")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                primary: true,
                                onClick: ()=>saveQuestionnaireMutation.mutate(),
                                loading: saveQuestionnaireMutation.isLoading,
                                disabled: invalid || !changed || readonly,
                                children: f("default.save")
                            })
                        ]
                    })
                ]
            }),
            showPreviewModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairePreviewModalDefault.default), {
                questionnaire: questionnaire,
                onClose: closePreviewModal
            })
        ]
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsQuestionnaireDetailsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES,
    apiFunction: (id, options)=>id === (0, _questionnaires.NEW_QUESTIONNAIRE_ID) ? Promise.resolve((0, _settingsQuestionnaireDetailsPageHelpers.createNewQuestionnaire)()) : (0, _apiDefault.default).getQuestionnaire(id, options),
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairePageSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../assets/icons/eye.svg":"5t2Hp","../../api":"f6lXD","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/BackButton/BackButton":"4fa4k","../../components/extensions/Badge":"9irVp","../../components/extensions/Button":"8exc0","../../components/QuestionnaireEditor/QuestionnaireEditor":"isg5R","../../components/QuestionnairePageHeader/QuestionnairePageHeader":"7AVQ2","../../components/QuestionnairePageSkeleton/QuestionnairePageSkeleton":"lvvwX","../../components/QuestionnairePreviewModal/QuestionnairePreviewModal":"2GL6j","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../constants/questionnaires":"7t2eX","../../constants/routes":"ihtm8","../../helpers/questionnaire.helpers":"7cplm","../../hooks/useChangedState":"170jW","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../hooks/useSnackbar":"gQ3G9","../../utils/collectionUtils":"gr5mc","../../utils/history":"c4gdf","../../utils/util":"4MniK","./SettingsQuestionnaireDetailsPage.helpers":"aqFCl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5t2Hp":[function(require,module,exports) {
module.exports = require("99b95f104811fccf").getBundleURL("kEMsi") + "eye.9931954b.svg";

},{"99b95f104811fccf":"75UoR"}],"isg5R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _languages = require("../../constants/languages");
var _questionsHelpers = require("../../helpers/questions.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _customerTypeForm = require("../CustomerTypeForm/CustomerTypeForm");
var _customerTypeFormDefault = parcelHelpers.interopDefault(_customerTypeForm);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _questionsEditor = require("../QuestionsEditor/QuestionsEditor");
var _questionsEditorDefault = parcelHelpers.interopDefault(_questionsEditor);
var _sectionDivider = require("../SectionDivider/SectionDivider");
var _sectionDividerDefault = parcelHelpers.interopDefault(_sectionDivider);
var _translationTextField = require("../TranslationTextField/TranslationTextField");
var _translationTextFieldDefault = parcelHelpers.interopDefault(_translationTextField);
const QuestionnaireEditor = (props)=>{
    const { questionnaire, readonly, error, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const questionnaireTitleLabels = {
        en: f("questionnaire.title.label", {
            language: `${f("common.language.english")} ${(0, _languages.LANGUAGES_FLAGS)["en"]}`
        }),
        nb: f("questionnaire.title.label", {
            language: `${f("common.language.norwegian")} ${(0, _languages.LANGUAGES_FLAGS)["nb"]}`
        })
    };
    const handleFieldChange = (key, value)=>onChange({
            ...questionnaire,
            [key]: value
        });
    const handleQuestionChange = (questions)=>onChange({
            ...questionnaire,
            questions
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                    value: questionnaire.name,
                                    label: f("common.labels.name"),
                                    requiredIndicator: true,
                                    autoFocus: true,
                                    autoComplete: "on",
                                    disabled: readonly,
                                    onChange: (value)=>handleFieldChange("name", value),
                                    error: (0, _stringUtils.isEmptyString)(questionnaire.name) ? f("common.errors.invalid.empty.name") : undefined
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                    value: questionnaire.description,
                                    label: f("common.labels.description"),
                                    autoComplete: "on",
                                    multiline: 4,
                                    disabled: readonly,
                                    onChange: (value)=>handleFieldChange("description", value)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                        oneHalf: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "bodyMd",
                        as: "span",
                        color: "subdued",
                        children: f("common.labels.customer-type")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerTypeFormDefault.default), {
                        customerType: questionnaire.customer_type,
                        readonly: readonly,
                        onChange: (customerType)=>handleFieldChange("customer_type", customerType)
                    })
                ]
            }),
            !(0, _util.isNil)(error) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _translationTextFieldDefault.default), {
                            text: questionnaire.title,
                            vertical: true,
                            autoComplete: "on",
                            disabled: readonly,
                            getLabel: (language)=>questionnaireTitleLabels[language],
                            onChange: (text)=>handleFieldChange("title", text),
                            error: (0, _stringUtils.isEmptyString)(questionnaire.title?.nb) ? f("common.errors.invalid.empty.title") : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                        oneHalf: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionsEditorDefault.default), {
                questions: questionnaire.questions,
                readonly: readonly,
                onNewQuestion: (0, _questionsHelpers.createNewQuestion),
                onChange: handleQuestionChange
            })
        ]
    });
};
exports.default = QuestionnaireEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/languages":"ecnY7","../../helpers/questions.helpers":"5Cq11","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","../CustomerTypeForm/CustomerTypeForm":"aVpAu","../ErrorPanel/ErrorPanel":"2hHqH","../KDKTextField/KDKTextField":"b5QRp","../QuestionsEditor/QuestionsEditor":"b06dz","../SectionDivider/SectionDivider":"9PqIT","../TranslationTextField/TranslationTextField":"58a0s","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5Cq11":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNewQuestion", ()=>createNewQuestion);
parcelHelpers.export(exports, "createNewChoice", ()=>createNewChoice);
parcelHelpers.export(exports, "isQuestionnaireQuestion", ()=>isQuestionnaireQuestion);
parcelHelpers.export(exports, "duplicateQuestion", ()=>duplicateQuestion);
parcelHelpers.export(exports, "isChoicesQuestion", ()=>isChoicesQuestion);
parcelHelpers.export(exports, "isCountryQuestion", ()=>isCountryQuestion);
parcelHelpers.export(exports, "isInvalidChoice", ()=>isInvalidChoice);
parcelHelpers.export(exports, "isInvalidQuestion", ()=>isInvalidQuestion);
var _languages = require("../constants/languages");
var _questions = require("../constants/questions");
var _stringUtils = require("../utils/stringUtils");
var _util = require("../utils/util");
const createNewQuestion = ()=>({
        id: (0, _util.uniqueId)((0, _questions.NEW_QUESTION_PREFIX)),
        text: {
            en: "",
            nb: ""
        },
        type: "YES_NO",
        is_required: false,
        show_infobox: false,
        infobox: undefined
    });
const createNewChoice = ()=>({
        id: (0, _util.uniqueId)((0, _questions.NEW_QUESTION_CHOICE_PREFIX)),
        text: Object.fromEntries((0, _languages.SUPPORTED_LANGUAGES).map((language)=>[
                language,
                ""
            ]))
    });
const isQuestionnaireQuestion = (question)=>!(0, _util.isNil)(question.is_required);
const duplicateQuestion = (question)=>isQuestionnaireQuestion(question) ? {
        ...question,
        id: (0, _util.uniqueId)((0, _questions.NEW_QUESTION_PREFIX)),
        choices: question.choices?.map((choice)=>({
                ...choice,
                id: (0, _util.uniqueId)((0, _questions.NEW_QUESTION_CHOICE_PREFIX))
            }))
    } : {
        ...question,
        id: (0, _util.uniqueId)((0, _questions.NEW_QUESTION_PREFIX))
    };
const isChoicesQuestion = (questionType)=>questionType === "SINGLE_CHOICE" || questionType === "MULTIPLE_CHOICE";
const isCountryQuestion = (questionAnswer)=>questionAnswer.question.type === "SINGLE_COUNTRY_CHOICE" || questionAnswer.question.type === "MULTIPLE_COUNTRY_CHOICE";
const isInvalidChoice = (choice)=>(0, _stringUtils.isEmptyString)(choice.text[0, _languages.DEFAULT_LANGUAGE]);
const areDuplicateChoices = (choices = [])=>choices.length > 1 && new Set(choices.map((choice)=>choice.text[0, _languages.DEFAULT_LANGUAGE])).size < choices.length;
const isInvalidQuestion = (question)=>// question text are empty
    (0, _stringUtils.isEmptyString)(question.text[0, _languages.DEFAULT_LANGUAGE]) || isChoicesQuestion(question.type) && question.choices?.length && question.choices.length < 2 || isChoicesQuestion(question.type) && question.choices?.some(isInvalidChoice) || isChoicesQuestion(question.type) && areDuplicateChoices(question.choices);

},{"../constants/languages":"ecnY7","../constants/questions":"5Ewo5","../utils/stringUtils":"4gVdA","../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aVpAu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const CustomerTypeForm = (props)=>{
    const { customerType, readonly, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                label: f("common.labels.customer-type.company"),
                name: "companyType",
                disabled: readonly,
                checked: customerType === "company",
                onChange: ()=>onChange("company")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                label: f("common.labels.customer-type.person"),
                name: "companyType",
                disabled: readonly,
                checked: customerType === "person",
                onChange: ()=>onChange("person")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                label: f("common.labels.both-customer-types"),
                name: "companyType",
                disabled: readonly,
                checked: customerType === "both",
                onChange: ()=>onChange("both")
            })
        ]
    });
};
exports.default = CustomerTypeForm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b06dz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _questionsHelpers = require("../../helpers/questions.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _questionsTable = require("./QuestionsTable/QuestionsTable");
var _questionsTableDefault = parcelHelpers.interopDefault(_questionsTable);
const QuestionsEditor = (props)=>{
    const { questions, readonly, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const addNewQuestion = ()=>onChange([
            ...questions,
            (0, _questionsHelpers.createNewQuestion)()
        ]);
    // div wrapper is needed to sticky toolbar to work
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledToolbar, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    gap: "4",
                    align: "end",
                    children: questions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                        onClick: addNewQuestion,
                        disabled: readonly,
                        children: f("questions.editor.buttons.add-question.label")
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionsTableDefault.default), {
                ...props
            })
        ]
    });
};
const StyledToolbar = (0, _styledComponentsDefault.default).div`
  background-color: var(--p-color-bg-app);
  position: sticky;
  top: var(--kdk-toolbar-height);
  z-index: var(--p-z-1);
  padding-bottom: var(--p-space-4);
  margin-left: -5px;
  margin-right: -2px;
`;
exports.default = QuestionsEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/questions.helpers":"5Cq11","../../hooks/useFormatMessage":"8Y8fq","../AddButton/AddButton":"WJGEt","./QuestionsTable/QuestionsTable":"hF0qW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hF0qW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFlipMove = require("react-flip-move");
var _reactFlipMoveDefault = parcelHelpers.interopDefault(_reactFlipMove);
var _polaris = require("@shopify/polaris");
var _languages = require("../../../constants/languages");
var _questionsHelpers = require("../../../helpers/questions.helpers");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../../utils/collectionUtils");
var _stringUtils = require("../../../utils/stringUtils");
var _addButton = require("../../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _questionEditor = require("./QuestionEditor/QuestionEditor");
var _questionEditorDefault = parcelHelpers.interopDefault(_questionEditor);
var _questionEditorHelpers = require("./QuestionEditor/QuestionEditor.helpers");
var _questionsTableRow = require("./QuestionsTableRow");
var _questionsTableRowDefault = parcelHelpers.interopDefault(_questionsTableRow);
const QuestionsTable = (props)=>{
    const { questions, readonly, onNewQuestion, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const isEmpty = questions.length === 0;
    const addNewQuestion = ()=>onChange([
            ...questions,
            onNewQuestion()
        ]);
    const handleQuestionChange = (question)=>onChange((0, _collectionUtils.updateItem)(questions, question));
    const handleQuestionDelete = (question)=>onChange((0, _collectionUtils.removeItem)(questions, question));
    const handleQuestionOrderChange = (question, direction)=>{
        const index = questions.indexOf(question);
        const targetIndex = direction === "up" ? index - 1 : index + 1;
        onChange((0, _collectionUtils.swapElements)(questions, index, targetIndex));
    };
    const handleQuestionDuplicate = (question)=>onChange((0, _collectionUtils.insertAt)(questions, (0, _questionsHelpers.duplicateQuestion)(question), questions.indexOf(question)));
    const isValidQuestion = (question)=>{
        if ((0, _stringUtils.isEmptyString)(question.text[0, _languages.DEFAULT_LANGUAGE])) return f("question.editor.errors.empty-question");
        const hasDuplicateName = questions.some((q)=>q.id !== question.id && q.text[0, _languages.DEFAULT_LANGUAGE].trim() === question.text[0, _languages.DEFAULT_LANGUAGE].trim());
        if (hasDuplicateName) return f("question.editor.errors.duplicate-question");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isEmpty && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        inlineAlign: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                variant: "bodyMd",
                                as: "span",
                                color: "subdued",
                                children: f("question.editor.questions-table.empty.label")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                                onClick: addNewQuestion,
                                disabled: readonly,
                                children: f("questions.editor.buttons.add-question.label")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFlipMoveDefault.default), {
                children: questions.map((question, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionsTableRowDefault.default), {
                        isFirst: index === 0,
                        isLast: index === questions.length - 1,
                        readonly: readonly,
                        onOrderChange: (direction)=>handleQuestionOrderChange(question, direction),
                        onDuplicate: ()=>handleQuestionDuplicate(question),
                        onDelete: ()=>handleQuestionDelete(question),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionEditorDefault.default), {
                            question: question,
                            autofocus: index === questions.length - 1 && (0, _questionEditorHelpers.isNewQuestion)(question),
                            readonly: readonly,
                            isValidQuestion: isValidQuestion,
                            onChange: handleQuestionChange
                        })
                    }, question.id))
            })
        ]
    });
};
exports.default = QuestionsTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-flip-move":"7Sobo","@shopify/polaris":"ek5a0","../../../constants/languages":"ecnY7","../../../helpers/questions.helpers":"5Cq11","../../../hooks/useFormatMessage":"8Y8fq","../../../utils/collectionUtils":"gr5mc","../../../utils/stringUtils":"4gVdA","../../AddButton/AddButton":"WJGEt","./QuestionEditor/QuestionEditor":"303C5","./QuestionEditor/QuestionEditor.helpers":"lAPjZ","./QuestionsTableRow":"c42Se","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"303C5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _languages = require("../../../../constants/languages");
var _questionsHelpers = require("../../../../helpers/questions.helpers");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _popoverButton = require("../../../PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _toggleInput = require("../../../ToggleInput/ToggleInput");
var _toggleInputDefault = parcelHelpers.interopDefault(_toggleInput);
var _translationTextField = require("../../../TranslationTextField/TranslationTextField");
var _translationTextFieldDefault = parcelHelpers.interopDefault(_translationTextField);
var _verticalDivider = require("../../../VerticalDivider/VerticalDivider");
var _verticalDividerDefault = parcelHelpers.interopDefault(_verticalDivider);
var _choicesTable = require("./ChoicesTable/ChoicesTable");
var _choicesTableDefault = parcelHelpers.interopDefault(_choicesTable);
var _useQuestionTypesOptions = require("./useQuestionTypesOptions");
var _useQuestionTypesOptionsDefault = parcelHelpers.interopDefault(_useQuestionTypesOptions);
const QuestionEditor = (props)=>{
    const { question, autofocus, readonly, isValidQuestion, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const questionTypeOptions = (0, _useQuestionTypesOptionsDefault.default)();
    const handleQuestionTextChange = (text)=>onChange({
            ...question,
            text
        });
    const handleQuestionTypeChange = (type)=>{
        if ((0, _questionsHelpers.isQuestionnaireQuestion)(question) && (0, _questionsHelpers.isChoicesQuestion)(type)) {
            if (!question.choices || question.choices.length === 0) // question support choices but the choices list is empty - add a default empty choice
            onChange({
                ...question,
                type,
                choices: [
                    (0, _questionsHelpers.createNewChoice)()
                ]
            });
            else // question support choices but the choices list is not empty - keep the choices
            // this means that the user switched between single/multiple question type and there's no need to clear the list
            onChange({
                ...question,
                type
            });
        } else // question is not choices type so clear the choices list
        onChange({
            ...question,
            type,
            choices: undefined
        });
    };
    const handleChoicesChange = (choices)=>onChange({
            ...question,
            choices
        });
    const questionDescriptionLabels = {
        en: f("questionnaire.question.description.label", {
            language: `${f("common.language.english")} ${(0, _languages.LANGUAGES_FLAGS)["en"]}`
        }),
        nb: f("questionnaire.question.description.label", {
            language: `${f("common.language.norwegian")} ${(0, _languages.LANGUAGES_FLAGS)["nb"]}`
        })
    };
    const showChoicesTable = (0, _questionsHelpers.isQuestionnaireQuestion)(question) && (0, _questionsHelpers.isChoicesQuestion)(question.type);
    const errorMessage = isValidQuestion(question);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledContent, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _translationTextFieldDefault.default), {
                            text: question.text,
                            requiredIndicator: true,
                            vertical: true,
                            getLabel: (language)=>questionDescriptionLabels[language],
                            autoComplete: "on",
                            disabled: readonly,
                            autoFocus: autofocus,
                            onChange: handleQuestionTextChange,
                            error: errorMessage
                        }),
                        showChoicesTable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choicesTableDefault.default), {
                            choices: question.choices || [],
                            onChange: handleChoicesChange,
                            readonly: readonly
                        })
                    ]
                })
            }),
            (0, _questionsHelpers.isQuestionnaireQuestion)(question) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Divider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFooter, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "4",
                            blockAlign: "stretch",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
                                    size: "slim",
                                    disclosure: "select",
                                    disabled: readonly,
                                    fluidContent: true,
                                    label: questionTypeOptions.find((option)=>option.value === question.type)?.label,
                                    render: (onClose)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.OptionList), {
                                            selected: [
                                                question.type
                                            ],
                                            options: questionTypeOptions,
                                            onChange: (selected)=>{
                                                handleQuestionTypeChange(selected[0]);
                                                onClose();
                                            }
                                        })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verticalDividerDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleInputDefault.default), {
                                    label: f("default.mandatory"),
                                    checked: question.is_required,
                                    onChange: ()=>onChange({
                                            ...question,
                                            is_required: !question.is_required
                                        }),
                                    disabled: readonly
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const StyledContent = (0, _styledComponentsDefault.default).div`
  padding: 0 var(--p-space-4) var(--p-space-4) var(--p-space-4);

  width: 75%;
`;
const StyledFooter = (0, _styledComponentsDefault.default).div`
  padding: var(--p-space-4) var(--p-space-4) 0 var(--p-space-4);
`;
exports.default = QuestionEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../constants/languages":"ecnY7","../../../../helpers/questions.helpers":"5Cq11","../../../../hooks/useFormatMessage":"8Y8fq","../../../PopoverButton/PopoverButton":"ihB8F","../../../ToggleInput/ToggleInput":"dDMC1","../../../TranslationTextField/TranslationTextField":"58a0s","../../../VerticalDivider/VerticalDivider":"r7aOz","./ChoicesTable/ChoicesTable":"1EbS8","./useQuestionTypesOptions":"8KHsv","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"58a0s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _languages = require("../../constants/languages");
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _language = require("../Language/Language");
var _languageDefault = parcelHelpers.interopDefault(_language);
const createDefaultTranslationText = ()=>({
        [(0, _languages.DEFAULT_LANGUAGE)]: ""
    });
const TranslationTextField = (props)=>{
    const { text = createDefaultTranslationText(), vertical, showFlagPrefix, getLabel = ()=>"", onChange, requiredIndicator, focused, autoFocus, prefix, error, ...textFieldProps } = props;
    if (vertical) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
        gap: "4",
        children: (0, _languages.SUPPORTED_LANGUAGES).map((language)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                value: text ? text[language] || "" : "",
                label: getLabel(language),
                prefix: showFlagPrefix ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageDefault.default), {
                    language: language
                }) : prefix,
                requiredIndicator: language === (0, _languages.DEFAULT_LANGUAGE) && requiredIndicator,
                focused: language === (0, _languages.DEFAULT_LANGUAGE) && focused,
                autoFocus: language === (0, _languages.DEFAULT_LANGUAGE) && autoFocus,
                error: language === (0, _languages.DEFAULT_LANGUAGE) && error,
                onChange: (value)=>onChange({
                        ...text,
                        [language]: value
                    }),
                ...textFieldProps
            }, language))
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
        gap: "4",
        wrap: false,
        children: (0, _languages.SUPPORTED_LANGUAGES).map((language)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                value: text ? text[language] || "" : "",
                label: getLabel(language),
                prefix: showFlagPrefix ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageDefault.default), {
                    language: language
                }) : prefix,
                requiredIndicator: language === (0, _languages.DEFAULT_LANGUAGE) && requiredIndicator,
                focused: language === (0, _languages.DEFAULT_LANGUAGE) && focused,
                autoFocus: language === (0, _languages.DEFAULT_LANGUAGE) && autoFocus,
                error: language === (0, _languages.DEFAULT_LANGUAGE) && error,
                onChange: (value)=>onChange({
                        ...text,
                        [language]: value
                    }),
                ...textFieldProps
            }, language))
    });
};
exports.default = TranslationTextField;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/languages":"ecnY7","../KDKTextField/KDKTextField":"b5QRp","../Language/Language":"h9jd4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1EbS8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFlipMove = require("react-flip-move");
var _reactFlipMoveDefault = parcelHelpers.interopDefault(_reactFlipMove);
var _polaris = require("@shopify/polaris");
var _questionsHelpers = require("../../../../../helpers/questions.helpers");
var _useFormatMessage = require("../../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _collectionUtils = require("../../../../../utils/collectionUtils");
var _addItemButton = require("../../../../AddItemButton/AddItemButton");
var _addItemButtonDefault = parcelHelpers.interopDefault(_addItemButton);
var _choiceEditor = require("./ChoiceEditor/ChoiceEditor");
var _choiceEditorDefault = parcelHelpers.interopDefault(_choiceEditor);
const ChoicesTable = (props)=>{
    const { choices, readonly, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const addChoice = ()=>onChange([
            ...choices,
            (0, _questionsHelpers.createNewChoice)()
        ]);
    const handleChoiceChange = (choice)=>onChange((0, _collectionUtils.updateItem)(choices, choice));
    const handleChoiceOrderChange = (choice, direction)=>{
        const index = choices.indexOf(choice);
        const targetIndex = direction === "up" ? index - 1 : index + 1;
        onChange((0, _collectionUtils.swapElements)(choices, index, targetIndex));
    };
    const handleChoiceDelete = (choice)=>onChange((0, _collectionUtils.removeItem)(choices, choice));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFlipMoveDefault.default), {
                children: choices.map((choice, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choiceEditorDefault.default), {
                        choice: choice,
                        position: index + 1,
                        isFirst: index === 0,
                        isLast: index === choices.length - 1,
                        readonly: readonly,
                        onChange: handleChoiceChange,
                        onOrderChange: handleChoiceOrderChange,
                        onDelete: handleChoiceDelete
                    }, choice.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addItemButtonDefault.default), {
                    onClick: addChoice,
                    disabled: readonly,
                    children: f("questionnaire.choices-table.button.add.label")
                })
            })
        ]
    });
};
exports.default = ChoicesTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-flip-move":"7Sobo","@shopify/polaris":"ek5a0","../../../../../helpers/questions.helpers":"5Cq11","../../../../../hooks/useFormatMessage":"8Y8fq","../../../../../utils/collectionUtils":"gr5mc","../../../../AddItemButton/AddItemButton":"8Rs0C","./ChoiceEditor/ChoiceEditor":"aoIMa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aoIMa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _removeSvg = require("../../../../../../../assets/icons/remove.svg");
var _removeSvgDefault = parcelHelpers.interopDefault(_removeSvg);
var _useFormatMessage = require("../../../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../../../../../utils/stringUtils");
var _button = require("../../../../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _moveButtons = require("../../../../../MoveButtons/MoveButtons");
var _moveButtonsDefault = parcelHelpers.interopDefault(_moveButtons);
var _translationTextField = require("../../../../../TranslationTextField/TranslationTextField");
var _translationTextFieldDefault = parcelHelpers.interopDefault(_translationTextField);
var _verticalDivider = require("../../../../../VerticalDivider/VerticalDivider");
var _verticalDividerDefault = parcelHelpers.interopDefault(_verticalDivider);
var _choiceEditorHelpers = require("./ChoiceEditor.helpers");
const ChoiceEditor = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { choice, position, isFirst, isLast, readonly, onChange, onOrderChange, onDelete } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const handleChoiceChange = (text)=>onChange({
            ...choice,
            text
        });
    const handleOrderChange = (direction)=>onOrderChange(choice, direction);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledChoiceEditor, {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "1",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    variant: "bodyMd",
                    as: "span",
                    children: f("questionnaire.choices-table.description.label", {
                        index: position
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                    blockAlign: "start",
                    align: "space-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _translationTextFieldDefault.default), {
                            text: choice.text,
                            showFlagPrefix: true,
                            requiredIndicator: true,
                            autoComplete: "on",
                            autoFocus: isLast && (0, _choiceEditorHelpers.isNewQuestionChoice)(choice),
                            disabled: readonly,
                            onChange: handleChoiceChange,
                            error: (0, _stringUtils.isEmptyString)(choice.text.nb) ? f("questionnaire.choices-table.errors.empty-option") : undefined
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "4",
                            blockAlign: "stretch",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveButtonsDefault.default), {
                                    disableMoveUp: isFirst,
                                    disableMoveDown: isLast,
                                    onOrderChange: handleOrderChange,
                                    readonly: readonly
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verticalDividerDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    destructive: true,
                                    plain: true,
                                    removeUnderline: true,
                                    hoverable: true,
                                    icon: (0, _removeSvgDefault.default),
                                    onClick: ()=>onDelete(choice),
                                    disabled: readonly
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const StyledChoiceEditor = (0, _styledComponentsDefault.default).div`
  & + & {
    margin-top: var(--p-space-3);
  }
`;
exports.default = ChoiceEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../../../../assets/icons/remove.svg":"81FDc","../../../../../../hooks/useFormatMessage":"8Y8fq","../../../../../../utils/stringUtils":"4gVdA","../../../../../extensions/Button":"8exc0","../../../../../MoveButtons/MoveButtons":"dsvCr","../../../../../TranslationTextField/TranslationTextField":"58a0s","../../../../../VerticalDivider/VerticalDivider":"r7aOz","./ChoiceEditor.helpers":"6WzU6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"81FDc":[function(require,module,exports) {
module.exports = require("df53abc673c56d30").getBundleURL("kEMsi") + "remove.670aafb5.svg";

},{"df53abc673c56d30":"75UoR"}],"6WzU6":[function(require,module,exports) {
// this is a hack to let the ChoiceEditor determine if a choice is new or existing
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNewQuestionChoice", ()=>isNewQuestionChoice);
var _questions = require("../../../../../../constants/questions");
const isNewQuestionChoice = (question)=>question.id.startsWith((0, _questions.NEW_QUESTION_CHOICE_PREFIX));

},{"../../../../../../constants/questions":"5Ewo5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8KHsv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useFormatMessage = require("../../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useLanguage = require("../../../../hooks/useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
const useQuestionTypesOptions = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const language = (0, _useLanguageDefault.default)();
    return (0, _react.useMemo)(()=>{
        return [
            {
                value: "YES_NO",
                label: f("questionnaire.question.type.boolean")
            },
            {
                value: "TEXT",
                label: f("questionnaire.question.type.text")
            },
            {
                value: "SINGLE_CHOICE",
                label: f("questionnaire.question.type.single-choice")
            },
            {
                value: "MULTIPLE_CHOICE",
                label: f("questionnaire.question.type.multiple-choice")
            },
            {
                value: "SINGLE_COUNTRY_CHOICE",
                label: f("questionnaire.question.type.single-country-choice")
            },
            {
                value: "MULTIPLE_COUNTRY_CHOICE",
                label: f("questionnaire.question.type.multiple-country-choice")
            }
        ];
    }, [
        language
    ]);
};
exports.default = useQuestionTypesOptions;

},{"react":"cOWTg","../../../../hooks/useFormatMessage":"8Y8fq","../../../../hooks/useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lAPjZ":[function(require,module,exports) {
// this is a hack to let the QuestionEditor determine if a question is new or existing
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNewQuestion", ()=>isNewQuestion);
var _questions = require("../../../../constants/questions");
const isNewQuestion = (question)=>question.id?.startsWith((0, _questions.NEW_QUESTION_PREFIX));

},{"../../../../constants/questions":"5Ewo5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c42Se":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _copySvg = require("../../../../assets/icons/copy.svg");
var _copySvgDefault = parcelHelpers.interopDefault(_copySvg);
var _trashSvg = require("../../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _moveButtons = require("../../MoveButtons/MoveButtons");
var _moveButtonsDefault = parcelHelpers.interopDefault(_moveButtons);
var _tooltipWrapper = require("../../TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _verticalDivider = require("../../VerticalDivider/VerticalDivider");
var _verticalDividerDefault = parcelHelpers.interopDefault(_verticalDivider);
const QuestionsTableRow = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { isFirst, isLast, readonly, onOrderChange, onDuplicate, onDelete, children } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return(// use a div element with className "Polaris-Card" to mimic Polaris Card component but with the ability to set a ref
    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCardWrapper, {
        ref: ref,
        className: "Polaris-Card",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
            fullWidth: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCardToolbar, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        blockAlign: "stretch",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                                content: f("default.copy"),
                                dismissOnMouseOut: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                    onClick: onDuplicate,
                                    icon: (0, _copySvgDefault.default),
                                    plain: true,
                                    hoverable: true,
                                    disabled: readonly
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verticalDividerDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveButtonsDefault.default), {
                                disableMoveUp: isFirst,
                                disableMoveDown: isLast,
                                readonly: readonly,
                                onOrderChange: onOrderChange
                            })
                        ]
                    })
                }),
                children,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCardFooter, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        destructive: true,
                        plain: true,
                        removeUnderline: true,
                        disabled: readonly,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _trashSvgDefault.default),
                            useMask: true
                        }),
                        onClick: onDelete,
                        children: f("question.editor.buttons.delete.label")
                    })
                })
            ]
        })
    }));
});
const StyledCardWrapper = (0, _styledComponentsDefault.default).div`
  position: relative;
`;
const StyledCardToolbar = (0, _styledComponentsDefault.default).div`
  position: absolute;

  top: var(--p-space-4);
  right: var(--p-space-4);
`;
const StyledCardFooter = (0, _styledComponentsDefault.default).div`
  position: absolute;

  bottom: var(--p-space-4);
  right: var(--p-space-4);
`;
exports.default = QuestionsTableRow;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/copy.svg":"9gsmj","../../../../assets/icons/trash.svg":"jqW55","../../../hooks/useFormatMessage":"8Y8fq","../../extensions/Button":"8exc0","../../extensions/Icon":"eHSf0","../../MoveButtons/MoveButtons":"dsvCr","../../TooltipWrapper/TooltipWrapper":"b5W2d","../../VerticalDivider/VerticalDivider":"r7aOz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7AVQ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const QuestionnairePageHeader = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
        as: "span",
        color: "subdued",
        children: f("questionnaire.page.header.description")
    });
};
exports.default = QuestionnairePageHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lvvwX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSettingsPage = require("../../hooks/useSettingsPage");
var _useSettingsPageDefault = parcelHelpers.interopDefault(_useSettingsPage);
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _filterContainer = require("../FilterContainer/FilterContainer");
var _filterContainerDefault = parcelHelpers.interopDefault(_filterContainer);
var _questionnairePageHeader = require("../QuestionnairePageHeader/QuestionnairePageHeader");
var _questionnairePageHeaderDefault = parcelHelpers.interopDefault(_questionnairePageHeader);
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
const QuestionnairePageSkeleton = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    (0, _useSettingsPageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("questionnaire.page.title"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            disabled: true,
            children: f("questionnaire.page.add-questionnaire.button.label")
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairePageHeaderDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterContainerDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                        placeholder: f("questionnaire.page.filter.placeholder"),
                        labelHidden: true,
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {})
                    })
                })
            ]
        })
    });
};
exports.default = QuestionnairePageSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSettingsPage":"j0i19","../AddButton/AddButton":"WJGEt","../FilterContainer/FilterContainer":"5kkHv","../QuestionnairePageHeader/QuestionnairePageHeader":"7AVQ2","../SearchTextField/SearchTextField":"k5bRy","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5kkHv":[function(require,module,exports) {
// used to change the minimum search text field width in order to show all the placeholder text
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const FilterContainer = (0, _styledComponentsDefault.default).div`
  display: flex;

  & .Polaris-TextField {
    min-width: 25vw;
  }
`;
exports.default = FilterContainer;

},{"styled-components":"eBrdC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2GL6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _usePreviewQuestionnaireMutation = require("../../hooks/usePreviewQuestionnaireMutation");
var _usePreviewQuestionnaireMutationDefault = parcelHelpers.interopDefault(_usePreviewQuestionnaireMutation);
var _previewModalAsync = require("../PreviewModalAsync/PreviewModalAsync");
var _previewModalAsyncDefault = parcelHelpers.interopDefault(_previewModalAsync);
const QuestionnairePreviewModal = (props)=>{
    const { questionnaire, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const previewQuestionnaireMutation = (0, _usePreviewQuestionnaireMutationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewModalAsyncDefault.default), {
        getPreviewURLPromise: ()=>previewQuestionnaireMutation.mutateAsync(questionnaire),
        title: f("questionnaire.preview.modal.title", {
            name: questionnaire.name
        }),
        loading: previewQuestionnaireMutation.isLoading,
        onClose: onClose
    });
};
exports.default = QuestionnairePreviewModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useFormatMessage":"8Y8fq","../../hooks/usePreviewQuestionnaireMutation":"g0OeS","../PreviewModalAsync/PreviewModalAsync":"1u6BW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g0OeS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _questionnaireHelpers = require("../helpers/questionnaire.helpers");
var _useFetch = require("./useFetch");
var _useFetchDefault = parcelHelpers.interopDefault(_useFetch);
var _useLanguage = require("./useLanguage");
var _useLanguageDefault = parcelHelpers.interopDefault(_useLanguage);
const usePreviewQuestionnaireMutation = ()=>{
    const language = (0, _useLanguageDefault.default)();
    const fetch = (0, _useFetchDefault.default)();
    const previewQuestionnaireMutation = (0, _reactQuery.useMutation)(async (questionnaire)=>{
        const createQuestionnaireRequest = (0, _questionnaireHelpers.convertQuestionnaireToCreateQuestionnaireRequest)(questionnaire);
        const previewData = await (0, _apiDefault.default).generateQuestionnairePreviewRequest(createQuestionnaireRequest);
        const previewUrl = `${previewData.preview_url}?language=${language}`;
        return await fetch(previewUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(previewData.payload)
        })// convert the response to an Object URL string that can be used inside an iFrame
        .then((res)=>res.blob()).then((blob)=>URL.createObjectURL(blob));
    });
    return previewQuestionnaireMutation;
};
exports.default = usePreviewQuestionnaireMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../helpers/questionnaire.helpers":"7cplm","./useFetch":"9uRF8","./useLanguage":"2W6IE","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7cplm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertQuestionnaireToCreateQuestionnaireRequest", ()=>convertQuestionnaireToCreateQuestionnaireRequest);
parcelHelpers.export(exports, "convertQuestionnaireToUpdateQuestionnaireRequest", ()=>convertQuestionnaireToUpdateQuestionnaireRequest);
parcelHelpers.export(exports, "isQuestionnaireActive", ()=>isQuestionnaireActive);
var _util = require("../utils/util");
// remove id from question choice when converting to create request
const convertQuestionChoiceToCreateQuestionChoiceRequest = (choice)=>(0, _util.removeProperty)(choice, "id");
// remove id from question when converting to create request
const convertQuestionToCreateQuestionRequest = (question)=>({
        ...(0, _util.removeProperty)(question, "id"),
        choices: question.choices?.map(convertQuestionChoiceToCreateQuestionChoiceRequest)
    });
const convertQuestionnaireToCreateQuestionnaireRequest = (questionnaire)=>({
        name: questionnaire.name,
        description: questionnaire.description,
        title: questionnaire.title,
        customer_type: questionnaire.customer_type,
        questions: questionnaire.questions.map(convertQuestionToCreateQuestionRequest)
    });
const convertQuestionnaireToUpdateQuestionnaireRequest = (questionnaire)=>({
        name: questionnaire.name,
        description: questionnaire.description,
        title: questionnaire.title,
        customer_type: questionnaire.customer_type,
        questions: questionnaire.questions.map(convertQuestionToCreateQuestionRequest),
        is_archived: questionnaire.is_archived
    });
const isQuestionnaireActive = (questionnaire)=>!questionnaire.is_archived;

},{"../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7t2eX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEW_QUESTIONNAIRE_ID", ()=>NEW_QUESTIONNAIRE_ID);
parcelHelpers.export(exports, "NEW_QUESTIONNAIRE_PREFIX", ()=>NEW_QUESTIONNAIRE_PREFIX);
const NEW_QUESTIONNAIRE_ID = "new";
const NEW_QUESTIONNAIRE_PREFIX = "questionnaire";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aqFCl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNewQuestionnaire", ()=>createNewQuestionnaire);
parcelHelpers.export(exports, "isNewQuestionnaire", ()=>isNewQuestionnaire);
parcelHelpers.export(exports, "hasDuplicateQuestions", ()=>hasDuplicateQuestions);
parcelHelpers.export(exports, "isInvalidQuestionnaire", ()=>isInvalidQuestionnaire);
var _languages = require("../../constants/languages");
var _questionnaires = require("../../constants/questionnaires");
var _questionsHelpers = require("../../helpers/questions.helpers");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
const createNewQuestionnaire = ()=>({
        id: (0, _util.uniqueId)((0, _questionnaires.NEW_QUESTIONNAIRE_PREFIX)),
        name: "",
        customer_type: "both",
        questions: [],
        is_archived: false,
        created_dt: new Date().toString(),
        version: 0
    });
const isNewQuestionnaire = (questionnaire)=>questionnaire.id.startsWith((0, _questionnaires.NEW_QUESTIONNAIRE_PREFIX));
const hasDuplicateQuestions = (questionnaire)=>// create a set of all the questions for the current language - is the set size is different from the questions
    // size it means that there are more questions than in the Set --> there is at least one duplicate question
    new Set(questionnaire.questions.map((question)=>question.text[0, _languages.DEFAULT_LANGUAGE])).size !== questionnaire.questions.length;
const isInvalidQuestionnaire = (questionnaire)=>(0, _stringUtils.isEmptyString)(questionnaire.name) || (0, _stringUtils.isEmptyString)(questionnaire.title?.nb) || questionnaire.questions.some((0, _questionsHelpers.isInvalidQuestion)) || hasDuplicateQuestions(questionnaire);

},{"../../constants/languages":"ecnY7","../../constants/questionnaires":"7t2eX","../../helpers/questions.helpers":"5Cq11","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"85JyS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _filterContainer = require("../../components/FilterContainer/FilterContainer");
var _filterContainerDefault = parcelHelpers.interopDefault(_filterContainer);
var _importQuestionnairesButton = require("../../components/ImportQuestionnairesButton/ImportQuestionnairesButton");
var _importQuestionnairesButtonDefault = parcelHelpers.interopDefault(_importQuestionnairesButton);
var _questionnairePageSkeleton = require("../../components/QuestionnairePageSkeleton/QuestionnairePageSkeleton");
var _questionnairePageSkeletonDefault = parcelHelpers.interopDefault(_questionnairePageSkeleton);
var _questionnairePreviewModal = require("../../components/QuestionnairePreviewModal/QuestionnairePreviewModal");
var _questionnairePreviewModalDefault = parcelHelpers.interopDefault(_questionnairePreviewModal);
var _searchTextField = require("../../components/SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _questionnaires = require("../../constants/questionnaires");
var _routes = require("../../constants/routes");
var _useExportQuestionnaireMutation = require("../../hooks/useExportQuestionnaireMutation");
var _useExportQuestionnaireMutationDefault = parcelHelpers.interopDefault(_useExportQuestionnaireMutation);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQuestionnaireRestoreMutation = require("../../hooks/useQuestionnaireRestoreMutation");
var _useQuestionnaireRestoreMutationDefault = parcelHelpers.interopDefault(_useQuestionnaireRestoreMutation);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
var _questionnaireArchiveConfirm = require("./QuestionnaireArchiveConfirm");
var _questionnaireArchiveConfirmDefault = parcelHelpers.interopDefault(_questionnaireArchiveConfirm);
var _questionnairesTable = require("./QuestionnairesTable");
var _questionnairesTableDefault = parcelHelpers.interopDefault(_questionnairesTable);
const SettingsQuestionnairesListPage = ({ data })=>{
    const [selectedQuestionnaire, setSelectedQuestionnaire] = (0, _react.useState)();
    const clearSelectedQuestionnaire = ()=>setSelectedQuestionnaire(undefined);
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const [isShowingArchivedQuestionnaires, toggleShowArchivedQuestionnaires] = (0, _useOpenCloseDefault.default)();
    const restoreQuestionnaireMutation = (0, _useQuestionnaireRestoreMutationDefault.default)();
    const exportQuestionnaireMutation = (0, _useExportQuestionnaireMutationDefault.default)();
    const [queryText, setQueryText] = (0, _react.useState)("");
    const hasArchivedQuestionnaires = data.questionnaires.some((questionnaire)=>questionnaire.is_archived);
    const questionnairesToDisplay = (0, _react.useMemo)(()=>{
        let questionnaires = isShowingArchivedQuestionnaires ? data.questionnaires : data.questionnaires.filter((questionnaire)=>!questionnaire.is_archived);
        if (!(0, _stringUtils.isEmptyString)(queryText)) questionnaires = questionnaires.filter((questionnaire)=>questionnaire.name.toLocaleLowerCase().includes(queryText.toLocaleLowerCase()));
        return questionnaires.sort((0, _collectionUtils.sortByName));
    }, [
        isShowingArchivedQuestionnaires,
        data.questionnaires,
        queryText
    ]);
    const handlePreview = (questionnaire)=>setSelectedQuestionnaire({
            questionnaire,
            actionType: "Preview"
        });
    const handleArchive = (questionnaire)=>setSelectedQuestionnaire({
            questionnaire,
            actionType: "Archive"
        });
    const handleRestore = (questionnaire)=>restoreQuestionnaireMutation.mutate(questionnaire);
    const handleExport = (questionnaire)=>exportQuestionnaireMutation.mutate(questionnaire, {
            //  No need for translation since this action is used to move questionnaire between tenants
            onSuccess: ()=>setSnackbar("questionnaire exported successfully!")
        });
    const showPreviewQuestionnaireModal = selectedQuestionnaire?.actionType === "Preview";
    const showArchiveQuestionnaireModal = selectedQuestionnaire?.actionType === "Archive";
    const readonly = !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const filterQuestionnairesLabel = isShowingArchivedQuestionnaires ? f("questionnaire.page.filter.hide-archived-questionnaires") : f("questionnaire.page.filter.show-archived-questionnaires");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        readonly: readonly,
        title: f("questionnaire.page.title"),
        subtitle: f("questionnaire.page.header.description"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_QUESTIONNAIRE_DETAILS, {
                id: (0, _questionnaires.NEW_QUESTIONNAIRE_ID)
            }),
            disabled: readonly,
            children: f("questionnaire.page.add-questionnaire.button.label")
        }),
        secondaryActions: features.SETTINGS__REVIEW_CHECKLISTS_IMPORT_EXPORT ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importQuestionnairesButtonDefault.default), {}) : undefined,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterContainerDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                    placeholder: f("questionnaire.page.filter.placeholder"),
                    value: queryText,
                    clearButton: true,
                    labelHidden: true,
                    onChange: setQueryText,
                    onClearButtonClick: ()=>setQueryText("")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairesTableDefault.default), {
                    questionnaires: questionnairesToDisplay,
                    queryText: queryText,
                    readonly: readonly,
                    isRestoringQuestionnaire: restoreQuestionnaireMutation.isLoading,
                    selectedQuestionnaireId: selectedQuestionnaire?.questionnaire.id,
                    onPreview: handlePreview,
                    onArchive: handleArchive,
                    onRestore: handleRestore,
                    onExport: handleExport
                })
            }),
            hasArchivedQuestionnaires && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: toggleShowArchivedQuestionnaires,
                    disclosure: isShowingArchivedQuestionnaires ? "up" : "down",
                    children: filterQuestionnairesLabel
                })
            }),
            showPreviewQuestionnaireModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairePreviewModalDefault.default), {
                questionnaire: selectedQuestionnaire.questionnaire,
                onClose: clearSelectedQuestionnaire
            }),
            showArchiveQuestionnaireModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnaireArchiveConfirmDefault.default), {
                questionnaire: selectedQuestionnaire.questionnaire,
                onClose: clearSelectedQuestionnaire
            })
        ]
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsQuestionnairesListPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES,
    apiFunction: (0, _apiDefault.default).listQuestionnaires,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionnairePageSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AddButton/AddButton":"WJGEt","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/extensions/Button":"8exc0","../../components/FilterContainer/FilterContainer":"5kkHv","../../components/ImportQuestionnairesButton/ImportQuestionnairesButton":"6qtzs","../../components/QuestionnairePageSkeleton/QuestionnairePageSkeleton":"lvvwX","../../components/QuestionnairePreviewModal/QuestionnairePreviewModal":"2GL6j","../../components/SearchTextField/SearchTextField":"k5bRy","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../constants/questionnaires":"7t2eX","../../constants/routes":"ihtm8","../../hooks/useExportQuestionnaireMutation":"dV3sI","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useQuestionnaireRestoreMutation":"gloiy","../../hooks/useSnackbar":"gQ3G9","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","./QuestionnaireArchiveConfirm":"4eMxP","./QuestionnairesTable":"dscZI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6qtzs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _questionnaireHelpers = require("../../helpers/questionnaire.helpers");
var _useGetQuestionnairesSummary = require("../../hooks/useGetQuestionnairesSummary");
var _useGetQuestionnairesSummaryDefault = parcelHelpers.interopDefault(_useGetQuestionnairesSummary);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const ImportQuestionnairesButton = ()=>{
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const { data } = (0, _useGetQuestionnairesSummaryDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const existingNames = (0, _react.useMemo)(()=>data?.questionnaire_summaries.filter((0, _questionnaireHelpers.isQuestionnaireActive)).map((questionnaire)=>questionnaire.name) || [], [
        data
    ]);
    const getValidQuestionnaireName = (name)=>existingNames.includes(name) ? `imported-${name}` : name;
    const createQuestionnaireMutation = (0, _reactQuery.useMutation)((files)=>Promise.all(files.map(handleFile)), {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES_SUMMARY
            ]);
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES
            ]);
            //  No need for translation since this action is used to move questionnaires between tenants
            setSnackbar("Imported successfully.");
        }
    });
    const handleFilesUpload = async (files)=>{
        createQuestionnaireMutation.mutate(files);
    };
    const handleFile = async (file)=>{
        return new Promise((resolve, reject)=>{
            try {
                const reader = new FileReader();
                reader.addEventListener("load", async ()=>{
                    const questionnaire = JSON.parse(reader.result);
                    const createdQuestionnaire = await (0, _apiDefault.default).createQuestionnaire({
                        ...questionnaire,
                        name: getValidQuestionnaireName(questionnaire.name)
                    });
                    resolve(createdQuestionnaire);
                }, false);
                if (file) reader.readAsText(file);
            } catch (error) {
                reject(error);
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DropZone), {
                outline: false,
                variableHeight: true,
                type: "file",
                accept: "application/json",
                onDropAccepted: handleFilesUpload,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    loading: createQuestionnaireMutation.isLoading,
                    children: "Import"
                })
            }),
            createQuestionnaireMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: createQuestionnaireMutation.error
            })
        ]
    });
};
exports.default = ImportQuestionnairesButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../helpers/questionnaire.helpers":"7cplm","../../hooks/useGetQuestionnairesSummary":"3Fs8h","../../hooks/useSnackbar":"gQ3G9","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dV3sI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _fileSaver = require("file-saver");
var _fileSaverDefault = parcelHelpers.interopDefault(_fileSaver);
var _questionnaireHelpers = require("../helpers/questionnaire.helpers");
var _filenameUtils = require("../utils/filenameUtils");
const useExportQuestionnaireMutation = ()=>{
    const exportQuestionnaire = async (questionnaire)=>{
        const questionnaireRequest = (0, _questionnaireHelpers.convertQuestionnaireToCreateQuestionnaireRequest)(questionnaire);
        const questionnaireExportString = JSON.stringify(questionnaireRequest, null, "	");
        const filename = (0, _filenameUtils.convertToValidFilename)(questionnaire.name) || "questionnaire";
        // @ts-ignore
        if (window.showSaveFilePicker) {
            const myblob = new Blob([
                questionnaireExportString
            ], {
                type: "text/plain"
            });
            const opts = {
                types: [
                    {
                        description: "Questionnaire",
                        accept: {
                            "text/plain": [
                                ".json"
                            ]
                        }
                    }
                ],
                suggestedName: filename
            };
            // @ts-ignore
            const handle = await window.showSaveFilePicker(opts);
            // @ts-ignore
            const writable = await handle.createWritable();
            // @ts-ignore
            writable.write(myblob);
            writable.close();
        } else {
            const file = new File([
                questionnaireExportString
            ], `${filename}.json`, {
                type: "text/plain"
            });
            (0, _fileSaverDefault.default).saveAs(file);
        }
    };
    return (0, _reactQuery.useMutation)(exportQuestionnaire);
};
exports.default = useExportQuestionnaireMutation;

},{"@tanstack/react-query":"91Vyq","file-saver":"9vIAJ","../helpers/questionnaire.helpers":"7cplm","../utils/filenameUtils":"2FnJx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9vIAJ":[function(require,module,exports) {
var global = arguments[3];
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(this, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof global && global.global === global ? global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

},{}],"gloiy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _questionnaireHelpers = require("../helpers/questionnaire.helpers");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useQuestionnaireRestoreMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES
    ]);
    const restoreQuestionnaireMutation = (0, _reactQuery.useMutation)((questionnaire)=>(0, _apiDefault.default).updateQuestionnaire(questionnaire.id, {
            ...(0, _questionnaireHelpers.convertQuestionnaireToUpdateQuestionnaireRequest)(questionnaire),
            is_archived: false
        }), {
        onSuccess: (response)=>{
            updateQueryData((queryData)=>{
                queryData.questionnaires = queryData.questionnaires.map((entry)=>entry.id === response.id ? response : entry);
            });
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES_SUMMARY
            ]);
        }
    });
    return restoreQuestionnaireMutation;
};
exports.default = useQuestionnaireRestoreMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../helpers/questionnaire.helpers":"7cplm","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4eMxP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _confirmAction = require("../../components/ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQuestionnaireArchiveMutation = require("../../hooks/useQuestionnaireArchiveMutation");
var _useQuestionnaireArchiveMutationDefault = parcelHelpers.interopDefault(_useQuestionnaireArchiveMutation);
const QuestionnaireArchiveConfirm = (props)=>{
    const { questionnaire, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const archiveQuestionnaireMutation = (0, _useQuestionnaireArchiveMutationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        apiCall: ()=>archiveQuestionnaireMutation.mutateAsync(questionnaire),
        title: f("questionnaire.archive.confirmation.title"),
        description: f("questionnaire.archive.confirmation.description", {
            name: questionnaire.name
        }),
        onNo: onClose,
        actionTitle: f("default.archive")
    });
};
exports.default = QuestionnaireArchiveConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../components/ConfirmAction/ConfirmAction":"icP5J","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQuestionnaireArchiveMutation":"1XS5v","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1XS5v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useQuestionnaireArchiveMutation = ()=>{
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).QUESTIONNAIRES
    ]);
    const archiveQuestionnaireMutation = (0, _reactQuery.useMutation)((questionnaire)=>(0, _apiDefault.default).archiveQuestionnaire(questionnaire.id), {
        onSuccess: (_, questionnaire)=>{
            updateQueryData((queryData)=>{
                queryData.questionnaires = queryData.questionnaires.map((entry)=>entry.id === questionnaire.id ? {
                        ...questionnaire,
                        is_archived: true
                    } : entry);
            });
        }
    });
    return archiveQuestionnaireMutation;
};
exports.default = useQuestionnaireArchiveMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dscZI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _archiveboxSvg = require("../../../assets/icons/archivebox.svg");
var _archiveboxSvgDefault = parcelHelpers.interopDefault(_archiveboxSvg);
var _arrowRightOffsetCircleSvg = require("../../../assets/icons/arrow-right-offset-circle.svg");
var _arrowRightOffsetCircleSvgDefault = parcelHelpers.interopDefault(_arrowRightOffsetCircleSvg);
var _docTextSvg = require("../../../assets/icons/doc-text.svg");
var _docTextSvgDefault = parcelHelpers.interopDefault(_docTextSvg);
var _eyeSvg = require("../../../assets/icons/eye.svg");
var _eyeSvgDefault = parcelHelpers.interopDefault(_eyeSvg);
var _penLineSvg = require("../../../assets/icons/pen-line.svg");
var _penLineSvgDefault = parcelHelpers.interopDefault(_penLineSvg);
var _restoreSvg = require("../../../assets/icons/restore.svg");
var _restoreSvgDefault = parcelHelpers.interopDefault(_restoreSvg);
var _actionsDropdown = require("../../components/ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _condensedText = require("../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _dataTableCellChild = require("../../components/DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _badge = require("../../components/extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _icon = require("../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _rowHighlighter = require("../../components/extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _textHighlighter = require("../../components/TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
var _tooltipWrapper = require("../../components/TooltipWrapper/TooltipWrapper");
var _tooltipWrapperDefault = parcelHelpers.interopDefault(_tooltipWrapper);
var _routes = require("../../constants/routes");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const QuestionnairesTable = (props)=>{
    const { questionnaires, isRestoringQuestionnaire, queryText, selectedQuestionnaireId, readonly, onPreview, onArchive, onRestore, onExport } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const getQuestionnaireActions = (questionnaire)=>{
        const actions = [
            {
                content: f("default.edit"),
                image: (0, _penLineSvgDefault.default),
                disabled: readonly,
                onAction: ()=>history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_QUESTIONNAIRE_DETAILS, {
                        id: questionnaire.id
                    }))
            },
            {
                content: f("default.preview"),
                image: (0, _eyeSvgDefault.default),
                onAction: ()=>onPreview(questionnaire)
            },
            questionnaire.is_archived ? {
                content: f("default.restore"),
                image: (0, _restoreSvgDefault.default),
                prefix: isRestoringQuestionnaire ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                    size: "small"
                }) : null,
                disabled: readonly,
                onAction: ()=>onRestore(questionnaire)
            } : {
                content: f("default.archive"),
                image: (0, _archiveboxSvgDefault.default),
                disabled: readonly,
                onAction: ()=>onArchive(questionnaire)
            }
        ];
        if (features.SETTINGS__REVIEW_CHECKLISTS_IMPORT_EXPORT) actions.push({
            content: "Export",
            image: (0, _arrowRightOffsetCircleSvgDefault.default),
            onAction: ()=>onExport(questionnaire)
        });
        return actions;
    };
    const getCustomerTypeLabel = (questionnaire)=>{
        switch(questionnaire.customer_type){
            case "both":
                return f("common.labels.both-customer-types");
            case "company":
                return f("common.labels.customer-type.company");
            case "person":
                return f("common.labels.customer-type.person");
            default:
                return "-";
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
        columnContentTypes: [
            "text",
            "text",
            "text",
            "text"
        ],
        headings: [
            f("table.column.name"),
            f("table.column.customerTypes"),
            f("table.column.questions"),
            f("common.buttons.actions.button").toUpperCase()
        ],
        rows: questionnaires.map((questionnaire)=>[
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                                url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_QUESTIONNAIRE_DETAILS, {
                                    id: questionnaire.id
                                }),
                                removeUnderline: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                    gap: "2",
                                    blockAlign: "center",
                                    wrap: false,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            source: (0, _docTextSvgDefault.default)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                            as: "span",
                                            color: questionnaire.is_archived ? "subdued" : undefined,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                                                searchWords: [
                                                    queryText
                                                ],
                                                textToHighlight: questionnaire.name
                                            })
                                        }),
                                        questionnaire.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                                            size: "xsmall",
                                            status: "new",
                                            children: f("badge.archived")
                                        })
                                    ]
                                })
                            }),
                            questionnaire.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipWrapperDefault.default), {
                                content: questionnaire.description,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        truncate: true,
                                        color: "subdued",
                                        children: questionnaire.description
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                    width: "15%",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: questionnaire.is_archived ? "subdued" : undefined,
                        children: getCustomerTypeLabel(questionnaire)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCenterCell, {
                    width: "10%",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: questionnaire.is_archived ? "subdued" : undefined,
                        children: questionnaire.questions.length
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                    width: "10%",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                        items: getQuestionnaireActions(questionnaire),
                        hideTitle: true,
                        forceOpen: isRestoringQuestionnaire && questionnaire.id === selectedQuestionnaireId
                    })
                })
            ])
    });
};
const StyledCenterCell = (0, _styledComponentsDefault.default)((0, _dataTableCellChildDefault.default))`
  text-align: center;
`;
exports.default = QuestionnairesTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/archivebox.svg":"cyEGJ","../../../assets/icons/arrow-right-offset-circle.svg":"fayaE","../../../assets/icons/doc-text.svg":"leosj","../../../assets/icons/eye.svg":"5t2Hp","../../../assets/icons/pen-line.svg":"9iTi6","../../../assets/icons/restore.svg":"hwxcs","../../components/ActionsDropdown/ActionsDropdown":"izRYG","../../components/CondensedText/CondensedText":"1FshD","../../components/DataTableCellChild/DataTableCellChild":"boueG","../../components/extensions/Badge":"9irVp","../../components/extensions/Icon":"eHSf0","../../components/extensions/RowHighlighter":"9EbPr","../../components/TextHighlighter/TextHighlighter":"43Xhz","../../components/TooltipWrapper/TooltipWrapper":"b5W2d","../../constants/routes":"ihtm8","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fayaE":[function(require,module,exports) {
module.exports = require("381a14e37666f3c6").getBundleURL("kEMsi") + "arrow-right-offset-circle.59da6ee8.svg";

},{"381a14e37666f3c6":"75UoR"}],"hfkbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _copySvg = require("../../../assets/icons/copy.svg");
var _copySvgDefault = parcelHelpers.interopDefault(_copySvg);
var _eyeSvg = require("../../../assets/icons/eye.svg");
var _eyeSvgDefault = parcelHelpers.interopDefault(_eyeSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _backButton = require("../../components/BackButton/BackButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _condensedText = require("../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reviewChecklistDuplicateModal = require("../../components/ReviewChecklistDuplicateModal/ReviewChecklistDuplicateModal");
var _reviewChecklistDuplicateModalDefault = parcelHelpers.interopDefault(_reviewChecklistDuplicateModal);
var _reviewChecklistEditor = require("../../components/ReviewChecklistEditor/ReviewChecklistEditor");
var _reviewChecklistEditorDefault = parcelHelpers.interopDefault(_reviewChecklistEditor);
var _reviewChecklistPageHeader = require("../../components/ReviewChecklistPageHeader/ReviewChecklistPageHeader");
var _reviewChecklistPageHeaderDefault = parcelHelpers.interopDefault(_reviewChecklistPageHeader);
var _reviewChecklistPageSkeleton = require("../../components/ReviewChecklistPageSkeleton/ReviewChecklistPageSkeleton");
var _reviewChecklistPageSkeletonDefault = parcelHelpers.interopDefault(_reviewChecklistPageSkeleton);
var _reviewChecklistPreviewModal = require("../../components/ReviewChecklistPreviewModal/ReviewChecklistPreviewModal");
var _reviewChecklistPreviewModalDefault = parcelHelpers.interopDefault(_reviewChecklistPreviewModal);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useChangedState = require("../../hooks/useChangedState");
var _useChangedStateDefault = parcelHelpers.interopDefault(_useChangedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUserName = require("../../hooks/useGetUserName");
var _useGetUserNameDefault = parcelHelpers.interopDefault(_useGetUserName);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _settingsReviewChecklistDetailsPageHelpers = require("./SettingsReviewChecklistDetailsPage.helpers");
const SettingsReviewChecklistDetailsPage = ({ data })=>{
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const { getUserDisplayName } = (0, _useGetUserNameDefault.default)();
    const [checklist, setChecklist, changed] = (0, _useChangedStateDefault.default)(()=>(0, _util.clone)(data));
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS
    ]);
    const [showPreviewModal, togglePreviewModal, closePreviewModal] = (0, _useOpenCloseDefault.default)();
    const [showDuplicateModal, toggleDuplicateModal, closeDuplicateModal] = (0, _useOpenCloseDefault.default)();
    const isNew = (0, _reactRouterDom.matchPath)(history.location.pathname, (0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLIST_DETAILS_NEW) !== null;
    const saveChecklistMutation = (0, _reactQuery.useMutation)(()=>isNew ? (0, _apiDefault.default).createReviewChecklist((0, _checklistsHelpers.convertChecklistToCreateChecklistRequest)(checklist)) : (0, _apiDefault.default).updateReviewChecklist(checklist.id, (0, _checklistsHelpers.convertChecklistToCreateChecklistRequest)(checklist)), {
        onSuccess: (newChecklist)=>{
            setSnackbar(isNew ? f("review.checklist.details.page.messages.created-successfully", {
                name: checklist.name
            }) : f("common.labels.saved-successfully"));
            // after a new checklist is saved, route to the same page but with the saved checklist id
            if (isNew) history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLIST_DETAILS, {
                id: newChecklist.id
            }));
            updateQueryData((queryData)=>{
                if (isNew) queryData.checklists = [
                    newChecklist,
                    ...queryData.checklists
                ];
                else queryData.checklists = (0, _collectionUtils.updateItem)(queryData.checklists, checklist);
            });
        }
    });
    const readonly = !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const handleChange = (updatedChecklist)=>{
        setChecklist(()=>(0, _util.clone)(updatedChecklist));
        saveChecklistMutation.reset();
    };
    const navigateToReviewChecklistsListPage = ()=>history.push((0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLISTS_LIST);
    const invalid = (0, _settingsReviewChecklistDetailsPageHelpers.isInvalidReviewChecklist)(checklist);
    const title = isNew ? f("review.checklist.details.page.title.new-checklist") : f("review.checklist.details.page.title.edit-checklist");
    const questions = checklist.questions;
    const addNewQuestion = ()=>handleChange({
            ...checklist,
            questions: [
                ...questions,
                (0, _checklistsHelpers.createNewReviewChecklistQuestion)()
            ]
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "8",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                        showAsLink: true,
                        url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLISTS_LIST),
                        displayLabel: f("review.checklists.page.title")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistPageHeaderDefault.default), {
                        title: title,
                        isArchived: checklist.is_archived
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistEditorDefault.default), {
                        checklist: checklist,
                        readonly: saveChecklistMutation.isLoading || checklist.is_archived || readonly,
                        isNew: isNew,
                        onChange: handleChange,
                        error: saveChecklistMutation.error
                    }),
                    checklist.updated_by && checklist.updated_dt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                        italic: true,
                        children: f("common.labels.modified-by", {
                            name: getUserDisplayName(checklist.updated_by),
                            timestamp: new Date(checklist.updated_dt)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        align: questions.length > 0 ? "space-between" : "end",
                        children: [
                            questions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
                                onClick: addNewQuestion,
                                disabled: readonly || checklist.is_archived || saveChecklistMutation.isLoading,
                                children: f("questions.editor.buttons.add-question.label")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        onClick: toggleDuplicateModal,
                                        icon: (0, _copySvgDefault.default),
                                        disabled: invalid || checklist.is_archived || saveChecklistMutation.isLoading,
                                        children: f("default.copy")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        onClick: togglePreviewModal,
                                        icon: (0, _eyeSvgDefault.default),
                                        disabled: invalid || saveChecklistMutation.isLoading,
                                        children: f("default.preview")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        onClick: navigateToReviewChecklistsListPage,
                                        disabled: saveChecklistMutation.isLoading,
                                        children: checklist.is_archived || readonly ? f("default.close") : f("default.cancel")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        primary: true,
                                        onClick: ()=>saveChecklistMutation.mutate(),
                                        loading: saveChecklistMutation.isLoading,
                                        disabled: invalid || !changed || readonly,
                                        children: f("default.save")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showPreviewModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistPreviewModalDefault.default), {
                checklist: checklist,
                onClose: closePreviewModal
            }),
            showDuplicateModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistDuplicateModalDefault.default), {
                checklist: checklist,
                navigateToChecklistListPageAfterCopy: true,
                onClose: closeDuplicateModal
            })
        ]
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsReviewChecklistDetailsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS,
    apiFunction: (id, options)=>(0, _stringUtils.isEmptyString)(id) ? Promise.resolve((0, _settingsReviewChecklistDetailsPageHelpers.createNewReviewChecklist)()) : (0, _apiDefault.default).getReviewChecklist(id, options),
    paramNames: [
        "id"
    ],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistPageSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../../assets/icons/copy.svg":"9gsmj","../../../assets/icons/eye.svg":"5t2Hp","../../api":"f6lXD","../../components/AddButton/AddButton":"WJGEt","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/BackButton/BackButton":"4fa4k","../../components/CondensedText/CondensedText":"1FshD","../../components/extensions/Button":"8exc0","../../components/ReviewChecklistDuplicateModal/ReviewChecklistDuplicateModal":"aMGeo","../../components/ReviewChecklistEditor/ReviewChecklistEditor":"kSfko","../../components/ReviewChecklistPageHeader/ReviewChecklistPageHeader":"kff8A","../../components/ReviewChecklistPageSkeleton/ReviewChecklistPageSkeleton":"b37K2","../../components/ReviewChecklistPreviewModal/ReviewChecklistPreviewModal":"gHv76","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useChangedState":"170jW","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUserName":"edBne","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../hooks/useSnackbar":"gQ3G9","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","./SettingsReviewChecklistDetailsPage.helpers":"32SNQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aMGeo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetReviewChecklists = require("../../hooks/useGetReviewChecklists");
var _useGetReviewChecklistsDefault = parcelHelpers.interopDefault(_useGetReviewChecklists);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const ReviewChecklistDuplicateModal = (props)=>{
    const { checklist, isTemplate, navigateToChecklistListPageAfterCopy, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const { data } = (0, _useGetReviewChecklistsDefault.default)();
    const checklists = data?.checklists || [];
    const checklistNames = new Set(checklists.filter((0, _checklistsHelpers.isChecklistActive)).map((checklist)=>checklist.name));
    const [newName, setNewName] = (0, _react.useState)(isTemplate ? checklist.name : checklist.name + " copy");
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS
    ]);
    const errorMessage = (0, _stringUtils.isEmptyString)(newName) ? f("common.errors.invalid.empty.name") : checklistNames.has(newName) ? f("common.errors.invalid.name.exists") : undefined;
    const title = isTemplate ? f("review.checklist.template.instance.modal.title", {
        name: checklist.name
    }) : f("review.checklist.duplicate.modal.title", {
        name: checklist.name
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        isOpen: true,
        apiCall: ()=>(0, _apiDefault.default).createReviewChecklist({
                ...(0, _checklistsHelpers.convertChecklistToCreateChecklistRequest)(checklist),
                name: newName
            }),
        title: title,
        actionTitle: f("default.save"),
        isActionDisabled: !(0, _stringUtils.isEmptyString)(errorMessage),
        onNo: onClose,
        isDestructive: false,
        useSuccessToast: !navigateToChecklistListPageAfterCopy,
        successTitle: f("review.checklist.duplicate.modal.success.message", {
            name: newName
        }),
        onSuccess: (duplicateChecklist)=>{
            updateQueryData((queryData)=>{
                queryData.checklists.push(duplicateChecklist);
                queryData.checklists.sort((0, _collectionUtils.sortByName));
            });
            if (navigateToChecklistListPageAfterCopy) history.push((0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLISTS_LIST));
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
            label: f("common.labels.name"),
            autoComplete: "off",
            requiredIndicator: true,
            value: newName,
            onChange: setNewName,
            error: errorMessage
        })
    });
};
exports.default = ReviewChecklistDuplicateModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetReviewChecklists":"lxc8X","../../hooks/useQueryData":"4laI9","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kSfko":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _kdktextField = require("../KDKTextField/KDKTextField");
var _kdktextFieldDefault = parcelHelpers.interopDefault(_kdktextField);
var _questionsTable = require("../QuestionsEditor/QuestionsTable/QuestionsTable");
var _questionsTableDefault = parcelHelpers.interopDefault(_questionsTable);
var _reviewChecklistConditionsEditor = require("../ReviewChecklistConditionsEditor/ReviewChecklistConditionsEditor");
var _reviewChecklistConditionsEditorDefault = parcelHelpers.interopDefault(_reviewChecklistConditionsEditor);
var _reviewChecklistEditorTipsBanner = require("../ReviewChecklistEditorTipsBanner/ReviewChecklistEditorTipsBanner");
var _reviewChecklistEditorTipsBannerDefault = parcelHelpers.interopDefault(_reviewChecklistEditorTipsBanner);
var _sectionDivider = require("../SectionDivider/SectionDivider");
var _sectionDividerDefault = parcelHelpers.interopDefault(_sectionDivider);
const ReviewChecklistEditor = (props)=>{
    const { checklist, readonly, isNew, error, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const handleFieldChange = (key, value)=>onChange({
            ...checklist,
            [key]: value
        });
    const handleQuestionsChange = (questions)=>onChange({
            ...checklist,
            questions
        });
    // cast checklist.questions to Question[] in order to force existence of id field
    const questions = checklist.questions;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Layout), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktextFieldDefault.default), {
                                    value: checklist.name || "",
                                    label: f("common.labels.name"),
                                    requiredIndicator: true,
                                    autoFocus: true,
                                    autoComplete: "on",
                                    disabled: readonly,
                                    onChange: (value)=>handleFieldChange("name", value),
                                    error: (0, _stringUtils.isEmptyString)(checklist.name) ? f("review.checklist.editor.empty.name") : undefined
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                    value: checklist.description || "",
                                    label: f("common.labels.description"),
                                    autoComplete: "on",
                                    multiline: 4,
                                    disabled: readonly,
                                    onChange: (value)=>handleFieldChange("description", value)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Layout).Section, {
                        oneHalf: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistEditorTipsBannerDefault.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistConditionsEditorDefault.default), {
                checklist: checklist,
                readonly: readonly,
                isNew: isNew,
                onChange: onChange
            }),
            !(0, _util.isNil)(error) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionsTableDefault.default), {
                questions: questions,
                readonly: readonly,
                onNewQuestion: (0, _checklistsHelpers.createNewReviewChecklistQuestion),
                onChange: handleQuestionsChange
            })
        ]
    });
};
exports.default = ReviewChecklistEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","../ErrorPanel/ErrorPanel":"2hHqH","../KDKTextField/KDKTextField":"b5QRp","../QuestionsEditor/QuestionsTable/QuestionsTable":"hF0qW","../ReviewChecklistConditionsEditor/ReviewChecklistConditionsEditor":"kJMmm","../ReviewChecklistEditorTipsBanner/ReviewChecklistEditorTipsBanner":"66Ihk","../SectionDivider/SectionDivider":"9PqIT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kJMmm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useYesNo = require("../../hooks/useYesNo");
var _useYesNoDefault = parcelHelpers.interopDefault(_useYesNo);
var _customerTypeForm = require("../CustomerTypeForm/CustomerTypeForm");
var _customerTypeFormDefault = parcelHelpers.interopDefault(_customerTypeForm);
var _reviewChecklistRiskConditionsEditor = require("./ReviewChecklistRiskConditionsEditor");
var _reviewChecklistRiskConditionsEditorDefault = parcelHelpers.interopDefault(_reviewChecklistRiskConditionsEditor);
const ReviewChecklistConditionsEditor = (props)=>{
    const { checklist, readonly, isNew, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const yesNo = (0, _useYesNoDefault.default)();
    const [selectionType, setSelectionType] = (0, _react.useState)((0, _checklistsHelpers.getChecklistSelectionType)(checklist.display_settings));
    const handleChange = (field, value)=>onChange({
            ...checklist,
            [field]: value
        });
    const handleSelectionTypeChange = (selectionType)=>{
        setSelectionType(selectionType);
        if (selectionType === "always") onChange({
            ...checklist,
            display_settings: {
                ...(0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS),
                is_always_select: true
            }
        });
        else onChange({
            ...checklist,
            display_settings: (0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS)
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    title: f("review.checklist.editor.labels.customer-type"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customerTypeFormDefault.default), {
                        customerType: checklist.customer_type,
                        readonly: readonly,
                        onChange: (customerType)=>handleChange("customer_type", customerType)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                    title: f("review.checklist.editor.labels.selection-type"),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: f("default.no"),
                                    checked: selectionType === "manual",
                                    disabled: readonly,
                                    name: "selection-type",
                                    onChange: ()=>handleSelectionTypeChange("manual")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: f("review.checklist.editor.labels.yes-always"),
                                    checked: selectionType === "always",
                                    disabled: readonly,
                                    name: "selection-type",
                                    onChange: ()=>handleSelectionTypeChange("always")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                    label: f("review.checklist.editor.labels.yes-choose"),
                                    checked: selectionType === "automatic",
                                    disabled: readonly,
                                    name: "selection-type",
                                    onChange: ()=>handleSelectionTypeChange("automatic")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                            id: "review-checklist-detailed-conditions",
                            open: selectionType === "automatic",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistRiskConditionsEditorDefault.default), {
                                checklist: checklist,
                                isNew: isNew,
                                readonly: readonly || selectionType !== "automatic",
                                onChange: onChange
                            }, selectionType)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    title: f("review.checklist.editor.labels.required"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                label: yesNo(true),
                                checked: checklist.is_required,
                                disabled: readonly,
                                name: "checklist-required",
                                onChange: (required)=>handleChange("is_required", required)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                                label: yesNo(false),
                                checked: !checklist.is_required,
                                disabled: readonly,
                                name: "checklist-required",
                                onChange: (required)=>handleChange("is_required", !required)
                            })
                        ]
                    })
                })
            })
        ]
    });
};
exports.default = ReviewChecklistConditionsEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useYesNo":"dfOzB","../CustomerTypeForm/CustomerTypeForm":"aVpAu","./ReviewChecklistRiskConditionsEditor":"5fmtX","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5fmtX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _collectionUtils = require("../../utils/collectionUtils");
var _displayTagsWrapper = require("../DisplayTagsWrapper/DisplayTagsWrapper");
var _displayTagsWrapperDefault = parcelHelpers.interopDefault(_displayTagsWrapper);
var _tagsEditorPopover = require("../TagsEditorPopover/TagsEditorPopover");
var _tagsEditorPopoverDefault = parcelHelpers.interopDefault(_tagsEditorPopover);
var _reviewChecklistPurposesConditionsEditor = require("./ReviewChecklistPurposesConditionsEditor");
var _reviewChecklistPurposesConditionsEditorDefault = parcelHelpers.interopDefault(_reviewChecklistPurposesConditionsEditor);
var _riskCategorySelect = require("./RiskCategorySelect");
var _riskCategorySelectDefault = parcelHelpers.interopDefault(_riskCategorySelect);
const ReviewChecklistRiskConditionsEditor = (props)=>{
    const { checklist, readonly, isNew, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { allTags } = (0, _useTagsDefault.default)();
    const [conditionType, setConditionType] = (0, _react.useState)((0, _checklistsHelpers.getChecklistConditionType)(checklist.display_settings));
    const handleConditionTypeChange = (conditionType)=>{
        setConditionType(conditionType);
        onChange({
            ...checklist,
            display_settings: (0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS)
        });
    };
    const handleConditionChange = (field, value)=>{
        onChange({
            ...checklist,
            display_settings: {
                ...(0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS),
                [field]: value
            }
        });
    };
    const removeTag = (tag)=>handleConditionChange("labels", (0, _collectionUtils.removeItem)(checklist.display_settings?.labels || [], tag));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                fullWidth: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    gap: "2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "h5",
                            variant: "headingSm",
                            fontWeight: "bold",
                            children: f("review.checklist.editor.labels.risk-type")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                            label: f("review.checklist.editor.condition-type.risk"),
                            checked: conditionType === "risk",
                            onChange: (checked)=>checked ? handleConditionTypeChange("risk") : undefined,
                            disabled: readonly
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                            id: "risk-condition-type-collapsible",
                            open: conditionType === "risk",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                gap: "4",
                                blockAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Spacer, {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _riskCategorySelectDefault.default), {
                                        riskCategory: (0, _collectionUtils.first)(checklist.display_settings?.risk_categories),
                                        readonly: readonly || conditionType !== "risk",
                                        onChange: (riskCategory)=>handleConditionChange("risk_categories", [
                                                riskCategory
                                            ])
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                        label: f("review.checklist.editor.condition-type.purpose"),
                        checked: conditionType === "purpose",
                        onChange: (checked)=>checked ? handleConditionTypeChange("purpose") : undefined,
                        disabled: readonly
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                        id: "purpose-condition-type-collapsible",
                        open: conditionType === "purpose",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistPurposesConditionsEditorDefault.default), {
                            checklist: checklist,
                            isNew: isNew,
                            readonly: readonly,
                            onChange: onChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card).Section, {
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                        label: f("review.checklist.editor.condition-type.tags"),
                        checked: conditionType === "tag",
                        onChange: (checked)=>checked ? handleConditionTypeChange("tag") : undefined,
                        disabled: readonly
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Collapsible), {
                        id: "tag-condition-type-collapsible",
                        open: conditionType === "tag",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                            gap: "4",
                            blockAlign: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Spacer, {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsEditorPopoverDefault.default), {
                                    disabled: readonly || conditionType !== "tag",
                                    tags: allTags,
                                    selectedTags: checklist.display_settings?.labels,
                                    enableReadonlySelection: true,
                                    onSelectionChange: (tags)=>handleConditionChange("labels", tags)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _displayTagsWrapperDefault.default), {
                                    tags: checklist.display_settings?.labels,
                                    onRemove: removeTag,
                                    readonly: readonly || conditionType !== "tag"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const Spacer = (0, _styledComponentsDefault.default).div`
  margin-left: var(--p-space-3);
`;
exports.default = ReviewChecklistRiskConditionsEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useTags":"31uzS","../../utils/collectionUtils":"gr5mc","../DisplayTagsWrapper/DisplayTagsWrapper":"2idSA","../TagsEditorPopover/TagsEditorPopover":"auX01","./ReviewChecklistPurposesConditionsEditor":"f7LSK","./RiskCategorySelect":"3AsFM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f7LSK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _plusMajorSvg = require("../../../assets/icons/plus-major.svg");
var _plusMajorSvgDefault = parcelHelpers.interopDefault(_plusMajorSvg);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _industryChoicesSelect = require("../AssignmentModal/IndustryChoicesSelect");
var _industryChoicesSelectDefault = parcelHelpers.interopDefault(_industryChoicesSelect);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _purposeChoicesSelect = require("../PurposeChoicesSelect/PurposeChoicesSelect");
var _purposeChoicesSelectDefault = parcelHelpers.interopDefault(_purposeChoicesSelect);
const ReviewChecklistPurposesConditionsEditor = (props)=>{
    const { checklist, readonly, isNew, onChange } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const handleIndustryTypeChange = (value)=>{
        onChange({
            ...checklist,
            display_settings: {
                ...(0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS),
                assignment_industry_type: value
            }
        });
    };
    const handlePurposeChange = (purposes)=>{
        // when changing a purpose - keep the selected industry type
        const industryType = checklist.display_settings?.assignment_industry_type;
        onChange({
            ...checklist,
            display_settings: {
                ...(0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS),
                assignment_industry_type: industryType,
                assignment_purposes: purposes
            }
        });
    };
    const updatePurpose = (purpose = "", index)=>{
        // replace current purpose at index with the new purpose value
        const purposes = checklist.display_settings?.assignment_purposes.length === 0 ? [
            purpose
        ] : [
            ...checklist.display_settings.assignment_purposes
        ];
        purposes.splice(index, 1, purpose);
        handlePurposeChange(purposes);
    };
    const addPurpose = ()=>{
        handlePurposeChange([
            ...checklist.display_settings.assignment_purposes,
            ""
        ]);
    };
    const removePurpose = (purpose)=>{
        handlePurposeChange(checklist.display_settings.assignment_purposes.filter((assignmentPurpose)=>assignmentPurpose !== purpose));
    };
    // make sure that the first purpose exists (even as an empty string) even if the list of purposes is empty
    const purposesToDisplay = checklist.display_settings?.assignment_purposes.length === 0 ? [
        ""
    ] : checklist.display_settings?.assignment_purposes;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
        gap: "4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Spacer, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FlexFill, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Grid), {
                    columns: {
                        md: 2
                    },
                    gap: {
                        xs: "4"
                    },
                    children: [
                        features.ASSIGNMENT_INDUSTRIES && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Grid).Cell, {
                            columnSpan: {
                                xs: 6,
                                sm: 6,
                                md: 4
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _industryChoicesSelectDefault.default), {
                                label: f("customer-assignments.modal.assignment-industry"),
                                autoComplete: "off",
                                placeholder: f("customer-assignments.modal.assignment-industry.placeholder"),
                                selectedIndustry: checklist.display_settings?.assignment_industry_type,
                                onChange: (industryType)=>handleIndustryTypeChange(industryType),
                                disabled: readonly
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Grid).Cell, {
                            columnSpan: {
                                xs: 6,
                                sm: 6
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: purposesToDisplay.map((purpose, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _purposeChoicesSelectDefault.default), {
                                        label: index === 0 ? f("customer-assignments.details.assignment-purpose") : f("default.or"),
                                        hasPurposeDesc: false,
                                        showDeprecatedPurposes: !isNew,
                                        disablePurposeDescription: true,
                                        industryType: checklist.display_settings?.assignment_industry_type,
                                        value: purpose,
                                        onChange: (purpose)=>updatePurpose(purpose, index),
                                        disabled: readonly,
                                        excludedOptions: checklist.display_settings?.assignment_purposes,
                                        connectedRight: index === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            icon: (0, _plusMajorSvgDefault.default),
                                            onClick: addPurpose,
                                            disabled: readonly
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                            icon: (0, _trashSvgDefault.default),
                                            onClick: ()=>removePurpose(purpose),
                                            disabled: readonly
                                        })
                                    }, `purpose-${purpose}-${index}`))
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const Spacer = (0, _styledComponentsDefault.default).div`
  margin-left: var(--p-space-3);
`;
const FlexFill = (0, _styledComponentsDefault.default).div`
  flex: 1;
`;
exports.default = ReviewChecklistPurposesConditionsEditor;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/plus-major.svg":"fCy4K","../../../assets/icons/trash.svg":"jqW55","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../AssignmentModal/IndustryChoicesSelect":"ibvbu","../extensions/Button":"8exc0","../PurposeChoicesSelect/PurposeChoicesSelect":"fbzrz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3AsFM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _useRiskCategories = require("../../hooks/useRiskCategories");
var _useRiskCategoriesDefault = parcelHelpers.interopDefault(_useRiskCategories);
const RiskCategorySelect = (props)=>{
    const { riskCategory, readonly, onChange } = props;
    const options = (0, _useRiskCategoriesDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
        gap: "4",
        children: [
            ...options.entries()
        ].map(([category, label])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.RadioButton), {
                label: label,
                checked: riskCategory === category,
                name: "risk-category",
                disabled: readonly,
                onChange: (checked)=>checked ? onChange(category) : undefined
            }, category))
    });
};
exports.default = RiskCategorySelect;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","../../hooks/useRiskCategories":"kMyXO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kMyXO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useFormatMessage = require("./useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
const useRiskCategories = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const riskCategoriesMap = new Map([
        [
            "PEP",
            f("common.labels.risk-category.pep")
        ],
        [
            "SANCTION",
            f("common.labels.risk-category.sanction")
        ],
        [
            "GEOGRAPHIC_RISK",
            f("common.labels.risk-category.geographical")
        ],
        [
            "INDUSTRY_RISK",
            f("common.labels.risk-category.industry")
        ]
    ]);
    return riskCategoriesMap;
};
exports.default = useRiskCategories;

},{"./useFormatMessage":"8Y8fq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"66Ihk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
var _markdownContent = require("../MarkdownContent/MarkdownContent");
var _markdownContentDefault = parcelHelpers.interopDefault(_markdownContent);
const ReviewChecklistEditorTipsBanner = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBanner, {
        status: "info",
        title: f("review.checklist.editor.tips.banner.title"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownContentDefault.default), {
            content: f("review.checklist.editor.tips.banner.description")
        })
    });
};
const StyledBanner = (0, _styledComponentsDefault.default)((0, _kdkbannerDefault.default))`
  display: inline-block;
  margin-top: var(--p-space-6);
  width: 100%;
`;
exports.default = ReviewChecklistEditorTipsBanner;

},{"react/jsx-runtime":"enbMA","styled-components":"eBrdC","../../hooks/useFormatMessage":"8Y8fq","../KDKBanner/KDKBanner":"3zPW6","../MarkdownContent/MarkdownContent":"cPR47","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kff8A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
const ReviewChecklistPageHeader = (props)=>{
    const { title = "", isArchived } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                gap: "2",
                blockAlign: "baseline",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        variant: "headingLg",
                        as: "h2",
                        children: title
                    }),
                    isArchived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                        size: "xsmall",
                        children: f("badge.archived")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "span",
                color: "subdued",
                children: f("review.checklists.page.header.description")
            })
        ]
    });
};
exports.default = ReviewChecklistPageHeader;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../extensions/Badge":"9irVp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b37K2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSettingsPage = require("../../hooks/useSettingsPage");
var _useSettingsPageDefault = parcelHelpers.interopDefault(_useSettingsPage);
var _addButton = require("../AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _filterContainer = require("../FilterContainer/FilterContainer");
var _filterContainerDefault = parcelHelpers.interopDefault(_filterContainer);
var _reviewChecklistPageHeader = require("../ReviewChecklistPageHeader/ReviewChecklistPageHeader");
var _reviewChecklistPageHeaderDefault = parcelHelpers.interopDefault(_reviewChecklistPageHeader);
var _searchTextField = require("../SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
const ReviewChecklistPageSkeleton = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    (0, _useSettingsPageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("review.checklists.page.title"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            disabled: true,
            children: f("review.checklists.page.add.button.label")
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistPageHeaderDefault.default), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterContainerDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                        placeholder: f("review.checklists.page.filter.placeholder"),
                        labelHidden: true,
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {})
                    })
                })
            ]
        })
    });
};
exports.default = ReviewChecklistPageSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSettingsPage":"j0i19","../AddButton/AddButton":"WJGEt","../FilterContainer/FilterContainer":"5kkHv","../ReviewChecklistPageHeader/ReviewChecklistPageHeader":"kff8A","../SearchTextField/SearchTextField":"k5bRy","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gHv76":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _previewModal = require("../PreviewModal/PreviewModal");
var _previewModalDefault = parcelHelpers.interopDefault(_previewModal);
var _reviewChecklistForm = require("../ReviewChecklistForm/ReviewChecklistForm");
var _reviewChecklistFormDefault = parcelHelpers.interopDefault(_reviewChecklistForm);
const ReviewChecklistPreviewModal = (props)=>{
    const { checklist, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [previewAnswers, setPreviewAnswers] = (0, _react.useState)(new Map());
    const onChange = (questionId, answer, text)=>{
        setPreviewAnswers((prevState)=>new Map([
                ...prevState.entries(),
                [
                    questionId,
                    {
                        question_id: questionId,
                        answer,
                        additional_info: text
                    }
                ]
            ]));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewModalDefault.default), {
        large: true,
        title: f("review.checklist.preview.modal.title", {
            name: checklist.name
        }),
        onClose: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                subdued: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistFormDefault.default), {
                    checklist: checklist,
                    answers: previewAnswers,
                    onChange: onChange
                })
            })
        })
    });
};
exports.default = ReviewChecklistPreviewModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../PreviewModal/PreviewModal":"dCYRZ","../ReviewChecklistForm/ReviewChecklistForm":"4ZXsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"32SNQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNewReviewChecklist", ()=>createNewReviewChecklist);
parcelHelpers.export(exports, "isInvalidReviewChecklist", ()=>isInvalidReviewChecklist);
var _languages = require("../../constants/languages");
var _reviewChecklists = require("../../constants/review-checklists");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
const createNewReviewChecklist = ()=>({
        id: (0, _util.uniqueId)((0, _reviewChecklists.NEW_REVIEW_CHECKLIST_PREFIX)),
        name: "",
        customer_type: "both",
        questions: [],
        is_archived: false,
        is_required: false,
        created_dt: new Date().toString(),
        version: 0,
        display_settings: (0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS)
    });
const isInvalidReviewChecklistQuestion = (question)=>(0, _stringUtils.isEmptyString)(question.text[0, _languages.DEFAULT_LANGUAGE]);
const isInvalidReviewChecklist = (checklist)=>(0, _stringUtils.isEmptyString)(checklist.name) || checklist.questions.length === 0 || checklist.questions.some(isInvalidReviewChecklistQuestion) || checklist.display_settings.assignment_purposes.some((0, _stringUtils.isEmptyString));

},{"../../constants/languages":"ecnY7","../../constants/review-checklists":"dV1lT","../../helpers/checklists.helpers":"4fhyQ","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3Mr7z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _filterContainer = require("../../components/FilterContainer/FilterContainer");
var _filterContainerDefault = parcelHelpers.interopDefault(_filterContainer);
var _importChecklistsButton = require("../../components/ImportChecklistsButton/ImportChecklistsButton");
var _importChecklistsButtonDefault = parcelHelpers.interopDefault(_importChecklistsButton);
var _reviewChecklistArchiveConfirm = require("../../components/ReviewChecklistArchiveConfirm/ReviewChecklistArchiveConfirm");
var _reviewChecklistArchiveConfirmDefault = parcelHelpers.interopDefault(_reviewChecklistArchiveConfirm);
var _reviewChecklistCreateInstanceModal = require("../../components/ReviewChecklistCreateInstanceModal/ReviewChecklistCreateInstanceModal");
var _reviewChecklistCreateInstanceModalDefault = parcelHelpers.interopDefault(_reviewChecklistCreateInstanceModal);
var _reviewChecklistDuplicateModal = require("../../components/ReviewChecklistDuplicateModal/ReviewChecklistDuplicateModal");
var _reviewChecklistDuplicateModalDefault = parcelHelpers.interopDefault(_reviewChecklistDuplicateModal);
var _reviewChecklistPageSkeleton = require("../../components/ReviewChecklistPageSkeleton/ReviewChecklistPageSkeleton");
var _reviewChecklistPageSkeletonDefault = parcelHelpers.interopDefault(_reviewChecklistPageSkeleton);
var _reviewChecklistPreviewModal = require("../../components/ReviewChecklistPreviewModal/ReviewChecklistPreviewModal");
var _reviewChecklistPreviewModalDefault = parcelHelpers.interopDefault(_reviewChecklistPreviewModal);
var _reviewChecklistsTable = require("../../components/ReviewChecklistsTable/ReviewChecklistsTable");
var _reviewChecklistsTableDefault = parcelHelpers.interopDefault(_reviewChecklistsTable);
var _reviewChecklistTemplatesSection = require("../../components/ReviewChecklistTemplatesSection/ReviewChecklistTemplatesSection");
var _reviewChecklistTemplatesSectionDefault = parcelHelpers.interopDefault(_reviewChecklistTemplatesSection);
var _searchTextField = require("../../components/SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _routes = require("../../constants/routes");
var _useChecklistRestoreMutation = require("../../hooks/useChecklistRestoreMutation");
var _useChecklistRestoreMutationDefault = parcelHelpers.interopDefault(_useChecklistRestoreMutation);
var _useExportReviewChecklistMutation = require("../../hooks/useExportReviewChecklistMutation");
var _useExportReviewChecklistMutationDefault = parcelHelpers.interopDefault(_useExportReviewChecklistMutation);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _collectionUtils = require("../../utils/collectionUtils");
var _stringUtils = require("../../utils/stringUtils");
const SettingsReviewChecklistsListPage = ({ data })=>{
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const [activeAction, setActiveAction] = (0, _react.useState)();
    const resetActiveAction = ()=>setActiveAction(undefined);
    const [isShowingArchivedChecklist, toggleShowArchivedChecklist] = (0, _useOpenCloseDefault.default)();
    const restoreChecklistMutation = (0, _useChecklistRestoreMutationDefault.default)();
    const exportReviewChecklistMutation = (0, _useExportReviewChecklistMutationDefault.default)();
    const [queryText, setQueryText] = (0, _react.useState)("");
    const hasArchivedChecklists = data.checklists.some((checklist)=>checklist.is_archived);
    const checklistsToDisplay = (0, _react.useMemo)(()=>{
        let checklists = isShowingArchivedChecklist ? data.checklists : data.checklists.filter((checklist)=>!checklist.is_archived);
        if (!(0, _stringUtils.isEmptyString)(queryText)) checklists = checklists.filter((checklist)=>checklist.name.toLocaleLowerCase().includes(queryText.toLocaleLowerCase()));
        checklists.sort((0, _collectionUtils.sortByName));
        return checklists;
    }, [
        isShowingArchivedChecklist,
        data.checklists,
        queryText
    ]);
    const handlePreview = (checklist)=>setActiveAction({
            checklist: checklist,
            actionType: "Preview"
        });
    const handleDuplicate = (checklist)=>setActiveAction({
            checklist: checklist,
            actionType: "Duplicate"
        });
    const handleArchive = (checklist)=>setActiveAction({
            checklist: checklist,
            actionType: "Archive"
        });
    const handleCreateInstance = (checklist)=>setActiveAction({
            checklist: checklist,
            actionType: "Instance"
        });
    const handleRestore = (checklist)=>restoreChecklistMutation.mutate(checklist.id);
    const handleExport = (checklist)=>exportReviewChecklistMutation.mutate(checklist, {
            //  No need for translation since this action is used to move checklists between tenants
            onSuccess: ()=>setSnackbar("checklist exported successfully!")
        });
    const readonly = !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).EDIT_SETTINGS);
    const filterChecklistsLabel = isShowingArchivedChecklist ? f("review.checklists.page.filter.hide-archived-checklists") : f("review.checklists.page.filter.show-archived-checklists");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        readonly: readonly,
        title: f("review.checklists.page.title"),
        subtitle: f("review.checklists.page.header.description"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLIST_DETAILS_NEW),
            disabled: readonly,
            children: f("review.checklists.page.add.button.label")
        }),
        secondaryActions: features.SETTINGS__REVIEW_CHECKLISTS_IMPORT_EXPORT ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importChecklistsButtonDefault.default), {}) : undefined,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "10",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistTemplatesSectionDefault.default), {
                        onCreateInstance: handleCreateInstance,
                        readonly: readonly
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "h2",
                                        variant: "headingSm",
                                        children: f("review.checklists.page.table.header")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterContainerDefault.default), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                                            placeholder: f("review.checklists.page.filter.placeholder"),
                                            value: queryText,
                                            clearButton: true,
                                            onChange: setQueryText,
                                            onClearButtonClick: ()=>setQueryText("")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistsTableDefault.default), {
                                    checklists: checklistsToDisplay,
                                    readonly: readonly,
                                    queryText: queryText,
                                    isRestoringChecklist: restoreChecklistMutation.isLoading,
                                    selectedChecklistId: activeAction?.checklist.id,
                                    onPreview: handlePreview,
                                    onDuplicate: handleDuplicate,
                                    onArchive: handleArchive,
                                    onRestore: handleRestore,
                                    onExport: handleExport
                                })
                            })
                        ]
                    })
                ]
            }),
            hasArchivedChecklists && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: toggleShowArchivedChecklist,
                    disclosure: isShowingArchivedChecklist ? "up" : "down",
                    children: filterChecklistsLabel
                })
            }),
            activeAction?.actionType === "Preview" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistPreviewModalDefault.default), {
                checklist: activeAction?.checklist,
                onClose: resetActiveAction
            }),
            activeAction?.actionType === "Duplicate" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistDuplicateModalDefault.default), {
                checklist: activeAction?.checklist,
                onClose: resetActiveAction
            }),
            activeAction?.actionType === "Archive" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistArchiveConfirmDefault.default), {
                checklist: activeAction.checklist,
                onClose: resetActiveAction
            }),
            activeAction?.actionType === "Instance" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistCreateInstanceModalDefault.default), {
                checklistTemplate: activeAction?.checklist,
                onClose: resetActiveAction
            })
        ]
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsReviewChecklistsListPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS,
    apiFunction: (0, _apiDefault.default).getReviewChecklists,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistPageSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","../../api":"f6lXD","../../components/AddButton/AddButton":"WJGEt","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/extensions/Button":"8exc0","../../components/FilterContainer/FilterContainer":"5kkHv","../../components/ImportChecklistsButton/ImportChecklistsButton":"c0HZA","../../components/ReviewChecklistArchiveConfirm/ReviewChecklistArchiveConfirm":"lh8T7","../../components/ReviewChecklistCreateInstanceModal/ReviewChecklistCreateInstanceModal":"4UTxU","../../components/ReviewChecklistDuplicateModal/ReviewChecklistDuplicateModal":"aMGeo","../../components/ReviewChecklistPageSkeleton/ReviewChecklistPageSkeleton":"b37K2","../../components/ReviewChecklistPreviewModal/ReviewChecklistPreviewModal":"gHv76","../../components/ReviewChecklistsTable/ReviewChecklistsTable":"6gsv4","../../components/ReviewChecklistTemplatesSection/ReviewChecklistTemplatesSection":"gN0SV","../../components/SearchTextField/SearchTextField":"k5bRy","../../components/SettingsPage/SettingsPage":"gJDHL","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../constants/routes":"ihtm8","../../hooks/useChecklistRestoreMutation":"40lE6","../../hooks/useExportReviewChecklistMutation":"5647J","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useSnackbar":"gQ3G9","../../utils/collectionUtils":"gr5mc","../../utils/stringUtils":"4gVdA","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"c0HZA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useGetReviewChecklists = require("../../hooks/useGetReviewChecklists");
var _useGetReviewChecklistsDefault = parcelHelpers.interopDefault(_useGetReviewChecklists);
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
var _useTags = require("../../hooks/useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
var _collectionUtils = require("../../utils/collectionUtils");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
const ImportChecklistsButton = ()=>{
    const { setSnackbar } = (0, _useSnackbarDefault.default)();
    const { data } = (0, _useGetReviewChecklistsDefault.default)();
    const { findTagByTitle } = (0, _useTagsDefault.default)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const existingNames = (0, _react.useMemo)(()=>data?.checklists.filter((0, _checklistsHelpers.isChecklistActive)).map((checklist)=>checklist.name) || [], [
        data
    ]);
    const getValidChecklistName = (name)=>existingNames.includes(name) ? `imported-${name}` : name;
    const createChecklistsMutation = (0, _reactQuery.useMutation)((files)=>Promise.all(files.map(handleFile)), {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS
            ]);
            //  No need for translation since this action is used to move checklists between tenants
            setSnackbar("Imported successfully.");
        }
    });
    const handleFilesUpload = async (files)=>{
        createChecklistsMutation.mutate(files);
    };
    const importLabels = async (labels)=>{
        return new Promise((resolve)=>{
            const labelsMap = {};
            let wereNewLabelsAdded = false;
            labels.forEach((checklistLabel)=>{
                const existingLabel = findTagByTitle(checklistLabel.title.nb);
                if (existingLabel) // existing label was found so replace checklistLabel id with the existing label id
                labelsMap[checklistLabel.id] = existingLabel.id;
                else {
                    // create a new label and replace checklistLabel id with the new label id
                    const labelData = {
                        title: checklistLabel.title,
                        color: checklistLabel.color
                    };
                    (0, _apiDefault.default).createLabel(labelData).then((newLabel)=>{
                        wereNewLabelsAdded = true;
                        labelsMap[checklistLabel.id] = newLabel.id;
                    });
                }
            });
            if (wereNewLabelsAdded) queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS
            ]);
            resolve(labelsMap);
        });
    };
    const handleFile = async (file)=>{
        return new Promise((resolve, reject)=>{
            try {
                const reader = new FileReader();
                reader.addEventListener("load", async ()=>{
                    const importData = JSON.parse(reader.result);
                    const { checklist, labels } = importData;
                    // find or create the labels from the checklist before adding it
                    if (checklist.display_settings?.label_ids && (0, _collectionUtils.hasContent)(labels)) {
                        // find / create labels
                        const labelsMap = await importLabels(labels);
                        // replace original labels ids with existing labels ids
                        const checklistLabels = checklist.display_settings.label_ids;
                        checklist.display_settings.label_ids = checklistLabels.map((oldLabelId)=>labelsMap[oldLabelId]);
                    }
                    const createdChecklist = await (0, _apiDefault.default).createReviewChecklist({
                        ...checklist,
                        name: getValidChecklistName(checklist.name)
                    });
                    resolve(createdChecklist);
                }, false);
                if (file) reader.readAsText(file);
            } catch (error) {
                reject(error);
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DropZone), {
                outline: false,
                variableHeight: true,
                type: "file",
                accept: "application/json",
                onDropAccepted: handleFilesUpload,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    loading: createChecklistsMutation.isLoading,
                    children: "Import"
                })
            }),
            createChecklistsMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                message: createChecklistsMutation.error
            })
        ]
    });
};
exports.default = ImportChecklistsButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useGetReviewChecklists":"lxc8X","../../hooks/useSnackbar":"gQ3G9","../../hooks/useTags":"31uzS","../../utils/collectionUtils":"gr5mc","../ErrorPanel/ErrorPanel":"2hHqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lh8T7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useChecklistArchiveMutation = require("../../hooks/useChecklistArchiveMutation");
var _useChecklistArchiveMutationDefault = parcelHelpers.interopDefault(_useChecklistArchiveMutation);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
const ReviewChecklistArchiveConfirm = (props)=>{
    const { checklist, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const archiveQuestionnaireMutation = (0, _useChecklistArchiveMutationDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
        apiCall: ()=>archiveQuestionnaireMutation.mutateAsync(checklist),
        title: f("review.checklists.archive.confirmation.title"),
        description: f("review.checklists.archive.confirmation.description", {
            name: checklist.name
        }),
        onNo: onClose,
        actionTitle: f("default.archive")
    });
};
exports.default = ReviewChecklistArchiveConfirm;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useChecklistArchiveMutation":"94lMA","../../hooks/useFormatMessage":"8Y8fq","../ConfirmAction/ConfirmAction":"icP5J","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"94lMA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useChecklistArchiveMutation = ()=>{
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS
    ]);
    const archiveChecklistMutation = (0, _reactQuery.useMutation)((checklist)=>(0, _apiDefault.default).archiveReviewChecklist(checklist.id), {
        onSuccess: (_, checklist)=>{
            updateQueryData((queryData)=>{
                queryData.checklists = queryData.checklists.map((entry)=>entry.id === checklist.id ? {
                        ...checklist,
                        is_archived: true
                    } : entry);
            });
        }
    });
    return archiveChecklistMutation;
};
exports.default = useChecklistArchiveMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4UTxU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _previewModal = require("../PreviewModal/PreviewModal");
var _previewModalDefault = parcelHelpers.interopDefault(_previewModal);
var _reviewChecklistDuplicateModal = require("../ReviewChecklistDuplicateModal/ReviewChecklistDuplicateModal");
var _reviewChecklistDuplicateModalDefault = parcelHelpers.interopDefault(_reviewChecklistDuplicateModal);
var _reviewChecklistForm = require("../ReviewChecklistForm/ReviewChecklistForm");
var _reviewChecklistFormDefault = parcelHelpers.interopDefault(_reviewChecklistForm);
const ReviewChecklistCreateInstanceModal = (props)=>{
    const { checklistTemplate, onClose } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const [showDuplicateModal, toggleDuplicateModal, closeDuplicateModal] = (0, _useOpenCloseDefault.default)();
    const [previewAnswers, setPreviewAnswers] = (0, _react.useState)(new Map());
    const onChange = (questionId, answer, text)=>{
        setPreviewAnswers((prevState)=>new Map([
                ...prevState.entries(),
                [
                    questionId,
                    {
                        question_id: questionId,
                        answer,
                        additional_info: text
                    }
                ]
            ]));
    };
    const handleClose = ()=>{
        closeDuplicateModal();
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _previewModalDefault.default), {
        primaryAction: {
            content: f("component.review.checklist.create-instance"),
            onAction: toggleDuplicateModal
        },
        secondaryActions: [
            {
                content: f("default.cancel"),
                onAction: onClose
            }
        ],
        title: f("review.checklist.template.preview.modal.title", {
            name: checklistTemplate.name
        }),
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card).Section, {
                    subdued: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistFormDefault.default), {
                        checklist: checklistTemplate,
                        answers: previewAnswers,
                        onChange: onChange
                    })
                })
            }),
            showDuplicateModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistDuplicateModalDefault.default), {
                checklist: checklistTemplate,
                onClose: handleClose,
                isTemplate: true
            })
        ]
    });
};
exports.default = ReviewChecklistCreateInstanceModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../PreviewModal/PreviewModal":"dCYRZ","../ReviewChecklistDuplicateModal/ReviewChecklistDuplicateModal":"aMGeo","../ReviewChecklistForm/ReviewChecklistForm":"4ZXsH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6gsv4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _archiveboxSvg = require("../../../assets/icons/archivebox.svg");
var _archiveboxSvgDefault = parcelHelpers.interopDefault(_archiveboxSvg);
var _arrowRightOffsetCircleSvg = require("../../../assets/icons/arrow-right-offset-circle.svg");
var _arrowRightOffsetCircleSvgDefault = parcelHelpers.interopDefault(_arrowRightOffsetCircleSvg);
var _checklistSvg = require("../../../assets/icons/Checklist.svg");
var _checklistSvgDefault = parcelHelpers.interopDefault(_checklistSvg);
var _copySvg = require("../../../assets/icons/copy.svg");
var _copySvgDefault = parcelHelpers.interopDefault(_copySvg);
var _eyeSvg = require("../../../assets/icons/eye.svg");
var _eyeSvgDefault = parcelHelpers.interopDefault(_eyeSvg);
var _penLineSvg = require("../../../assets/icons/pen-line.svg");
var _penLineSvgDefault = parcelHelpers.interopDefault(_penLineSvg);
var _restoreSvg = require("../../../assets/icons/restore.svg");
var _restoreSvgDefault = parcelHelpers.interopDefault(_restoreSvg);
var _routes = require("../../constants/routes");
var _tables = require("../../constants/tables");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useYesNo = require("../../hooks/useYesNo");
var _useYesNoDefault = parcelHelpers.interopDefault(_useYesNo);
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _dataTableCellChild = require("../DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _rowHighlighter = require("../extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _reviewChecklistConditionsLabel = require("../ReviewChecklistConditionsLabel/ReviewChecklistConditionsLabel");
var _reviewChecklistConditionsLabelDefault = parcelHelpers.interopDefault(_reviewChecklistConditionsLabel);
var _textHighlighter = require("../TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
const ReviewChecklistsTable = (props)=>{
    const { checklists, isRestoringChecklist, queryText, selectedChecklistId, readonly, onPreview, onDuplicate, onArchive, onRestore, onExport } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const yesNo = (0, _useYesNoDefault.default)();
    const getCustomerTypeLabel = (checklist)=>{
        switch(checklist.customer_type){
            case "both":
                return f("common.labels.both-customer-types");
            case "company":
                return f("common.labels.customer-type.company");
            case "person":
                return f("common.labels.customer-type.person");
            default:
                return "-";
        }
    };
    const getChecklistActions = (checklist)=>{
        const actions = [
            {
                content: f("default.edit"),
                image: (0, _penLineSvgDefault.default),
                disabled: readonly,
                url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLIST_DETAILS, {
                    id: checklist.id
                })
            },
            {
                content: f("default.preview"),
                image: (0, _eyeSvgDefault.default),
                onAction: ()=>onPreview(checklist)
            },
            checklist.is_archived ? {
                content: f("default.restore"),
                image: (0, _restoreSvgDefault.default),
                prefix: isRestoringChecklist ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Spinner), {
                    size: "small"
                }) : null,
                disabled: readonly,
                onAction: ()=>onRestore(checklist)
            } : {
                content: f("default.archive"),
                image: (0, _archiveboxSvgDefault.default),
                disabled: readonly,
                onAction: ()=>onArchive(checklist)
            },
            {
                content: f("default.copy"),
                image: (0, _copySvgDefault.default),
                onAction: ()=>onDuplicate(checklist)
            }
        ];
        if (features.SETTINGS__REVIEW_CHECKLISTS_IMPORT_EXPORT) actions.push({
            content: "Export",
            image: (0, _arrowRightOffsetCircleSvgDefault.default),
            onAction: ()=>onExport(checklist)
        });
        return actions;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
        columnContentTypes: [
            "text",
            "text",
            "text",
            "text",
            "text",
            "text"
        ],
        headings: [
            f("table.column.name"),
            f("table.column.customerTypes"),
            f("table.column.used"),
            f("table.column.required"),
            f("table.column.questions"),
            f("common.buttons.actions.button").toUpperCase()
        ],
        rows: checklists.map((checklist)=>[
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                    width: (0, _tables.MAIN_COLUMN_WIDTH),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
                        subdued: checklist.is_archived,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                                    url: (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).SETTINGS_REVIEW_CHECKLIST_DETAILS, {
                                        id: checklist.id
                                    }),
                                    removeUnderline: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                        gap: "2",
                                        blockAlign: "center",
                                        wrap: false,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                source: (0, _checklistSvgDefault.default)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                color: checklist.is_archived ? "subdued" : undefined,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                                                    searchWords: [
                                                        queryText
                                                    ],
                                                    textToHighlight: checklist.name
                                                })
                                            }),
                                            checklist.is_archived && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                                                size: "xsmall",
                                                status: "new",
                                                children: f("badge.archived")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDescriptionText, {
                                    children: checklist.description
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    color: checklist.is_archived ? "subdued" : undefined,
                    children: getCustomerTypeLabel(checklist)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                    width: "25%",
                    wrap: "nowrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: checklist.is_archived ? "subdued" : undefined,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewChecklistConditionsLabelDefault.default), {
                            checklist: checklist
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                    as: "span",
                    color: checklist.is_archived ? "subdued" : undefined,
                    children: yesNo(checklist.is_required)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCenterCell, {
                    width: "10%",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        color: checklist.is_archived ? "subdued" : undefined,
                        children: checklist.questions.length
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                    width: "10%",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                        items: getChecklistActions(checklist),
                        hideTitle: true,
                        forceOpen: isRestoringChecklist && checklist.id === selectedChecklistId
                    })
                })
            ])
    });
};
const StyledCenterCell = (0, _styledComponentsDefault.default)((0, _dataTableCellChildDefault.default))`
  text-align: center;
`;
const StyledDescriptionText = (0, _styledComponentsDefault.default)((0, _condensedTextDefault.default))`
  line-height: var(--p-font-line-height-1);
`;
exports.default = ReviewChecklistsTable;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/archivebox.svg":"cyEGJ","../../../assets/icons/arrow-right-offset-circle.svg":"fayaE","../../../assets/icons/Checklist.svg":"5vsgR","../../../assets/icons/copy.svg":"9gsmj","../../../assets/icons/eye.svg":"5t2Hp","../../../assets/icons/pen-line.svg":"9iTi6","../../../assets/icons/restore.svg":"hwxcs","../../constants/routes":"ihtm8","../../constants/tables":"01ORG","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useYesNo":"dfOzB","../ActionsDropdown/ActionsDropdown":"izRYG","../CondensedText/CondensedText":"1FshD","../DataTableCellChild/DataTableCellChild":"boueG","../extensions/Badge":"9irVp","../extensions/Icon":"eHSf0","../extensions/RowHighlighter":"9EbPr","../ReviewChecklistConditionsLabel/ReviewChecklistConditionsLabel":"gSO4g","../TextHighlighter/TextHighlighter":"43Xhz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gSO4g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checklistsHelpers = require("../../helpers/checklists.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetAssignmentIndustriesAndPurposes = require("../../hooks/useGetAssignmentIndustriesAndPurposes");
var _useGetAssignmentIndustriesAndPurposesDefault = parcelHelpers.interopDefault(_useGetAssignmentIndustriesAndPurposes);
var _useRiskCategories = require("../../hooks/useRiskCategories");
var _useRiskCategoriesDefault = parcelHelpers.interopDefault(_useRiskCategories);
var _collectionUtils = require("../../utils/collectionUtils");
var _badges = require("../Badges/Badges");
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _badge = require("../extensions/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _kdktag = require("../KDKTag/KDKTag");
var _kdktagDefault = parcelHelpers.interopDefault(_kdktag);
const ReviewChecklistConditionsLabel = (props)=>{
    const { checklist } = props;
    const f = (0, _useFormatMessageDefault.default)();
    const { getPurposeLabel } = (0, _useGetAssignmentIndustriesAndPurposesDefault.default)();
    const options = (0, _useRiskCategoriesDefault.default)();
    const { display_settings } = checklist;
    const selectionType = (0, _checklistsHelpers.getChecklistSelectionType)(display_settings);
    const conditionType = (0, _checklistsHelpers.getChecklistConditionType)(display_settings);
    const getConditionTypeLabel = (conditionType)=>{
        switch(conditionType){
            case "risk":
                return f("review.checklist.editor.condition-type.risk");
            case "tag":
                return f("review.checklist.editor.condition-type.tags");
            case "purpose":
                return f("review.checklist.editor.condition-type.purpose");
            default:
                return "";
        }
    };
    switch(selectionType){
        case "manual":
            return f("review.checklist.editor.selection-type.manual");
        case "always":
            return f("review.checklist.editor.selection-type.always");
        case "automatic":
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("review.checklist.editor.selection-type.automatic")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("common.labels.triggered-when")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                        gap: "2",
                        blockAlign: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                children: [
                                    getConditionTypeLabel(conditionType),
                                    ":"
                                ]
                            }),
                            conditionType === "tag" && display_settings.labels.map((tag)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktagDefault.default), {
                                    tag: tag
                                }, tag.id)),
                            conditionType === "purpose" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLabel, {
                                children: getPurposeLabel((0, _collectionUtils.first)(display_settings.assignment_purposes))
                            }),
                            conditionType === "risk" && display_settings.risk_categories.map((riskCategory)=>/*#__PURE__*/ (0, _react.createElement)((0, _badgeDefault.default), {
                                    ...(0, _badges.DISPLAY_BADGE_PROPS),
                                    key: riskCategory
                                }, options.get(riskCategory)))
                        ]
                    })
                ]
            });
        default:
            return null;
    }
};
const StyledLabel = (0, _styledComponentsDefault.default).span`
  white-space: normal;
  word-break: break-all;
`;
exports.default = ReviewChecklistConditionsLabel;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../helpers/checklists.helpers":"4fhyQ","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetAssignmentIndustriesAndPurposes":"d3Dsc","../../hooks/useRiskCategories":"kMyXO","../../utils/collectionUtils":"gr5mc","../Badges/Badges":"cI72s","../CondensedText/CondensedText":"1FshD","../extensions/Badge":"9irVp","../KDKTag/KDKTag":"8koxk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gN0SV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _reviewChecklistTemplates = require("../../constants/review-checklist-templates");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _reviewChecklistTemplateCard = require("../ReviewChecklistTemplateCard/ReviewChecklistTemplateCard");
var _reviewChecklistTemplateCardDefault = parcelHelpers.interopDefault(_reviewChecklistTemplateCard);
const ReviewChecklistTemplatesSection = (props)=>{
    const { onCreateInstance, ...templateCardProps } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        gap: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                as: "h2",
                variant: "headingMd",
                children: f("component.review.checklist.template.title")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                gap: "8",
                children: (0, _reviewChecklistTemplates.REVIEW_CHECKLIST_TEMPLATES).map((template)=>/*#__PURE__*/ (0, _react.createElement)((0, _reviewChecklistTemplateCardDefault.default), {
                        templateChecklist: template,
                        onCreateInstance: ()=>onCreateInstance(template),
                        ...templateCardProps,
                        key: template.id
                    }))
            })
        ]
    });
};
exports.default = ReviewChecklistTemplatesSection;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../constants/review-checklist-templates":"K9Ajr","../../hooks/useFormatMessage":"8Y8fq","../ReviewChecklistTemplateCard/ReviewChecklistTemplateCard":"94IFx","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"K9Ajr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REVIEW_CHECKLIST_TEMPLATES", ()=>REVIEW_CHECKLIST_TEMPLATES);
var _checklistsTemplatesHelpers = require("../helpers/checklists-templates.helpers");
const HIGH_RISK_PERSON_TEMPLATE = (0, _checklistsTemplatesHelpers.createChecklistTemplate)("Momenter som kan indikere h\xf8y risiko (person)", "Momenter knyttet til type kunde, som kan indikere at risikoen for hvitvasking og terrorfinansiering er h\xf8y.\nKilder: Hvitvaskingsforskriften \xa7 4-9 og veileder til hvitvaskingsloven.", "person", [
    {
        en: "Are there unusual circumstances relating to the customer relationship?",
        nb: "Er det uvanlige omstendigheter knyttet til kundeforholdet?"
    },
    {
        en: "Is the information received from the customer incomplete or unclear?",
        nb: "Er opplysningene mottatt fra kunden mangelfulle eller uklare?"
    },
    {
        en: "Is there reason to doubt whether the information received from the customer is correct?",
        nb: "Er det grunn til \xe5 tvile p\xe5 om opplysningene mottatt fra kunden er korrekte?"
    },
    {
        en: "Are there other, objective circumstances with the customer that may indicate an increased risk (for example, relevant negative media coverage, known connection to criminal circles or criminal circumstances)?",
        nb: "Er det andre, objektive forhold ved kunden som kan indikere forh\xf8yet risiko (eksempelvis relevant negativ medieomtale, kjent tilknytning til kriminelle milj\xf8er eller straffbare forhold)?"
    }
]);
const HIGH_RISK_COMPANY_TEMPLATE = (0, _checklistsTemplatesHelpers.createChecklistTemplate)("Momenter som kan indikere h\xf8y risiko (selskap)", "Momenter knyttet til typen kunde, som kan indikere at risikoen for hvitvasking og terrorfinansiering er h\xf8y. Kilder: Hvitvaskingsforskriften \xa7 4-9 og veileder til hvitvaskingsloven.", "company", [
    {
        en: 'Is the customer a "personal wealth management company"?',
        nb: 'Er kunden et "personlig formuesforvaltningsselskap"?'
    },
    {
        en: "Does the customer have trustee-registered shareholders or bearer shares?",
        nb: "Har kunden forvalterregistrerte aksjon\xe6rer eller ihendehaveraksjer?"
    },
    {
        en: "Does the customer have a cash-based business?",
        nb: "Har kunden kontantbasert virksomhet?"
    },
    {
        en: "Is the customer's ownership structure unusual or unnecessarily complex based on the nature of the business (without a natural business explanation)?",
        nb: "Er kundens eierstruktur uvanlig eller un\xf8dvendig kompleks ut fra virksomhetens art (uten at det har en naturlig forretningsmessig forklaring)?"
    },
    {
        en: "Are there unusual circumstances relating to the customer relationship?",
        nb: "Er det uvanlige omstendigheter knyttet til kundeforholdet?"
    },
    {
        en: "Is the information received from the customer incomplete or unclear?",
        nb: "Er opplysningene mottatt fra kunden mangelfulle eller uklare?"
    },
    {
        en: "Is there reason to doubt whether the information received from the customer is correct?",
        nb: "Er det grunn til \xe5 tvile p\xe5 om opplysningene mottatt fra kunden er korrekte?"
    },
    {
        en: "Are there other, objective circumstances with the customer that may indicate an increased risk (for example, relevant negative media coverage, known connection to criminal circles or criminal circumstances)?",
        nb: "Er det andre, objektive forhold ved kunden som kan indikere forh\xf8yet risiko (eksempelvis relevant negativ medieomtale, kjent tilknytning til kriminelle milj\xf8er eller straffbare forhold)?"
    }
]);
const REVIEW_CHECKLIST_TEMPLATES = [
    HIGH_RISK_PERSON_TEMPLATE,
    HIGH_RISK_COMPANY_TEMPLATE
];

},{"../helpers/checklists-templates.helpers":"7NVmh","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7NVmh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createChecklistTemplate", ()=>createChecklistTemplate);
var _stringUtils = require("../utils/stringUtils");
var _checklistsHelpers = require("./checklists.helpers");
const CHECKLIST_TEMPLATE_ID_PREFIX = "template";
const createChecklistTemplate = (name, description, customerType, questions = [])=>{
    return {
        id: `${CHECKLIST_TEMPLATE_ID_PREFIX}-${(0, _stringUtils.toKebabCase)(name)}`,
        name,
        description,
        version: -1,
        customer_type: customerType,
        created_dt: "",
        is_archived: false,
        is_required: false,
        questions: questions.map((text)=>({
                id: (0, _stringUtils.toKebabCase)(text.en),
                text
            })),
        display_settings: {
            ...(0, _checklistsHelpers.EMPTY_REVIEW_CHECKLIST_DISPLAY_SETTINGS)
        }
    };
};

},{"../utils/stringUtils":"4gVdA","./checklists.helpers":"4fhyQ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"94IFx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _copySvg = require("../../../assets/icons/copy.svg");
var _copySvgDefault = parcelHelpers.interopDefault(_copySvg);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _condensedText = require("../CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _kdkbanner = require("../KDKBanner/KDKBanner");
var _kdkbannerDefault = parcelHelpers.interopDefault(_kdkbanner);
const ReviewChecklistTemplateCard = (props)=>{
    const { templateChecklist, readonly, onCreateInstance } = props;
    const f = (0, _useFormatMessageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBanner, {
        status: "info",
        hideIcon: true,
        hideBorder: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            align: "space-between",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                            as: "span",
                            fontWeight: "semibold",
                            children: templateChecklist.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                            children: templateChecklist.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    align: "end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                        onClick: ()=>onCreateInstance(templateChecklist),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            source: (0, _copySvgDefault.default)
                        }),
                        size: "slim",
                        disabled: readonly,
                        children: f("component.review.checklist.create-instance")
                    })
                })
            ]
        })
    });
};
const StyledBanner = (0, _styledComponentsDefault.default)((0, _kdkbannerDefault.default))`
  width: 20rem;
  background-color: var(--p-color-bg);
  padding: var(--p-space-1);
  border-radius: var(--p-border-radius-2);

  & > .Polaris-Banner {
    background-color: var(--p-color-bg-info-subdued-hover);
    padding: var(--p-space-3);
    height: 100%;
  }
`;
exports.default = ReviewChecklistTemplateCard;

},{"react/jsx-runtime":"enbMA","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../assets/icons/copy.svg":"9gsmj","../../hooks/useFormatMessage":"8Y8fq","../CondensedText/CondensedText":"1FshD","../extensions/Icon":"eHSf0","../KDKBanner/KDKBanner":"3zPW6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"40lE6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _api = require("../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../constants/queries-keys");
var _collectionUtils = require("../utils/collectionUtils");
var _useQueryData = require("./useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
const useChecklistRestoreMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS
    ]);
    const restoreChecklistMutation = (0, _reactQuery.useMutation)((0, _apiDefault.default).restoreReviewChecklist, {
        onSuccess: (restoredReviewChecklist)=>{
            updateQueryData((queryData)=>{
                queryData.checklists = (0, _collectionUtils.updateItem)(queryData.checklists, restoredReviewChecklist);
            });
            queryClient.invalidateQueries([
                (0, _queriesKeys.QUERIES_KEYS).REVIEW_CHECKLISTS
            ]);
        }
    });
    return restoreChecklistMutation;
};
exports.default = useChecklistRestoreMutation;

},{"@tanstack/react-query":"91Vyq","../api":"f6lXD","../constants/queries-keys":"6hYSF","../utils/collectionUtils":"gr5mc","./useQueryData":"4laI9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5647J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactQuery = require("@tanstack/react-query");
var _fileSaver = require("file-saver");
var _fileSaverDefault = parcelHelpers.interopDefault(_fileSaver);
var _checklistsHelpers = require("../helpers/checklists.helpers");
var _filenameUtils = require("../utils/filenameUtils");
var _useTags = require("./useTags");
var _useTagsDefault = parcelHelpers.interopDefault(_useTags);
const useExportReviewChecklistMutation = ()=>{
    const { findTag } = (0, _useTagsDefault.default)();
    const exportChecklist = async (checklist)=>{
        const checklistRequest = (0, _checklistsHelpers.convertChecklistToCreateChecklistRequest)(checklist);
        const exportData = {
            checklist: checklistRequest,
            labels: checklistRequest.display_settings?.label_ids?.map(findTag) || []
        };
        const checklistExportString = JSON.stringify(exportData, null, "	");
        const filename = (0, _filenameUtils.convertToValidFilename)(checklist.name) || "checklist";
        // @ts-ignore
        if (window.showSaveFilePicker) {
            const myblob = new Blob([
                checklistExportString
            ], {
                type: "text/plain"
            });
            const opts = {
                types: [
                    {
                        description: "Checklist",
                        accept: {
                            "text/plain": [
                                ".json"
                            ]
                        }
                    }
                ],
                suggestedName: filename
            };
            // @ts-ignore
            const handle = await window.showSaveFilePicker(opts);
            // @ts-ignore
            const writable = await handle.createWritable();
            // @ts-ignore
            writable.write(myblob);
            writable.close();
        } else {
            const file = new File([
                checklistExportString
            ], `${filename}.json`, {
                type: "text/plain"
            });
            (0, _fileSaverDefault.default).saveAs(file);
        }
    };
    return (0, _reactQuery.useMutation)(exportChecklist);
};
exports.default = useExportReviewChecklistMutation;

},{"@tanstack/react-query":"91Vyq","file-saver":"9vIAJ","../helpers/checklists.helpers":"4fhyQ","../utils/filenameUtils":"2FnJx","./useTags":"31uzS","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h8ir7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _penLineSvg = require("../../../assets/icons/pen-line.svg");
var _penLineSvgDefault = parcelHelpers.interopDefault(_penLineSvg);
var _tagSvg = require("../../../assets/icons/tag.svg");
var _tagSvgDefault = parcelHelpers.interopDefault(_tagSvg);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _actionsDropdown = require("../../components/ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _confirmAction = require("../../components/ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _dataTableCellChild = require("../../components/DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _icon = require("../../components/extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _rowHighlighter = require("../../components/extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _filterContainer = require("../../components/FilterContainer/FilterContainer");
var _filterContainerDefault = parcelHelpers.interopDefault(_filterContainer);
var _searchTextField = require("../../components/SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _tag = require("../../components/Tag/Tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tagEditModal = require("../../components/TagEditModal/TagEditModal");
var _tagEditModalDefault = parcelHelpers.interopDefault(_tagEditModal);
var _textHighlighter = require("../../components/TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
var _durations = require("../../constants/durations");
var _queriesKeys = require("../../constants/queries-keys");
var _tagHelpers = require("../../helpers/tag.helpers");
var _useDebouncedState = require("../../hooks/useDebouncedState");
var _useDebouncedStateDefault = parcelHelpers.interopDefault(_useDebouncedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _settingsTagsSkeleton = require("./SettingsTagsSkeleton");
var _settingsTagsSkeletonDefault = parcelHelpers.interopDefault(_settingsTagsSkeleton);
const EMPTY_TAG = {
    id: "",
    title: {
        nb: "",
        en: ""
    },
    is_assigned: false
};
const SettingsTags = (props)=>{
    const { tagsList, readonly } = props;
    const [isModalOpen, toggleModalOpen] = (0, _useOpenCloseDefault.default)();
    const [isDeleteConfirmOpen, toggleDeleteConfirm, closeDeleteConfirm] = (0, _useOpenCloseDefault.default)();
    const [currentTag, setCurrentTag] = (0, _react.useState)();
    const [queryText, setQueryText, debouncedQueryValue] = (0, _useDebouncedStateDefault.default)("", (0, _durations.SETTINGS_SEARCH_DEBOUNCE_DELAY));
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS
    ]);
    const f = (0, _useFormatMessageDefault.default)();
    const tags = (0, _react.useMemo)(()=>{
        return tagsList.labels.filter((tag)=>(0, _stringUtils.isEmptyString)(debouncedQueryValue) || (0, _tagHelpers.getTagTitle)(tag).toLocaleLowerCase().includes(debouncedQueryValue.toLocaleLowerCase()));
    }, [
        debouncedQueryValue,
        tagsList.labels
    ]);
    const deleteTagMutation = (0, _reactQuery.useMutation)((0, _apiDefault.default).deleteLabel, {
        onSuccess: (response, deletedTagId)=>{
            updateQueryData((tagsData)=>{
                tagsData.count -= 1;
                tagsData.labels = tagsData.labels.filter((tag)=>tag.id !== deletedTagId);
            });
        }
    });
    const newTag = ()=>{
        setCurrentTag(EMPTY_TAG);
        toggleModalOpen();
    };
    const editTag = (tag)=>{
        setCurrentTag(tag);
        toggleModalOpen();
    };
    const closeAndClearModal = ()=>{
        setCurrentTag(undefined);
        toggleModalOpen();
    };
    const getTagActions = (tag)=>[
            {
                content: f("default.edit"),
                prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _penLineSvgDefault.default),
                    useMask: true
                }),
                disabled: readonly,
                onAction: ()=>readonly ? (0, _util.noop) : editTag(tag)
            },
            {
                content: f("default.delete"),
                prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    source: (0, _trashSvgDefault.default),
                    useMask: true
                }),
                disabled: readonly || tag.is_assigned || tag.read_only,
                helpText: tag.is_assigned ? f("tags.page.assigned-tag.delete.description") : undefined,
                onAction: ()=>{
                    if (!readonly) {
                        setCurrentTag(tag);
                        toggleDeleteConfirm();
                    }
                }
            }
        ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        readonly: readonly,
        title: f("tags.page.title"),
        subtitle: f("tags.page.subtitle"),
        permissions: false,
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            onClick: newTag,
            disabled: readonly,
            children: f("tags.modal.title.add-tag")
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterContainerDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                    placeholder: f("tags.page.filter.placeholder"),
                    value: queryText,
                    clearButton: true,
                    labelHidden: true,
                    onChange: setQueryText,
                    onClearButtonClick: ()=>setQueryText("")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                children: [
                    tags.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.EmptyState), {
                        image: "",
                        heading: f("tags.modal.empty-state")
                    }),
                    tags.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                        increasedTableDensity: true,
                        columnContentTypes: [
                            "text",
                            "text"
                        ],
                        headings: [
                            f("table.column.name"),
                            f("common.buttons.actions.button").toUpperCase()
                        ],
                        rows: tags.map((tag)=>[
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
                                    clickable: !readonly,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyleTagCell, {
                                        onClick: ()=>readonly ? (0, _util.noop) : editTag(tag),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                            gap: "2",
                                            blockAlign: "center",
                                            wrap: false,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                                    source: (0, _tagSvgDefault.default)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagDefault.default), {
                                                    color: tag.color,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                                                        searchWords: [
                                                            queryText
                                                        ],
                                                        textToHighlight: (0, _tagHelpers.getTagTitle)(tag)
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                                        items: getTagActions(tag),
                                        hideTitle: true
                                    })
                                })
                            ])
                    })
                ]
            }),
            isModalOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagEditModalDefault.default), {
                tag: currentTag,
                onClose: closeAndClearModal
            }),
            isDeleteConfirmOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: ()=>deleteTagMutation.mutateAsync(currentTag.id),
                title: f("tags.modal.tag.delete-tag"),
                description: f("tags.modal.tag.delete-tag.description", {
                    name: (0, _tagHelpers.getTagTitle)(currentTag)
                }),
                onNo: ()=>{
                    closeDeleteConfirm();
                    setCurrentTag(EMPTY_TAG);
                },
                actionTitle: f("tags.modal.tag.delete-tag")
            })
        ]
    });
};
const StyleTagCell = (0, _styledComponentsDefault.default).div`
  line-height: 1.75rem;
`;
const SettingsTagsPage = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SettingsTags, {
        tagsList: data
    });
};
exports.default = (0, _asyncPage.withAsyncPage)(SettingsTagsPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS,
    apiFunction: (0, _apiDefault.default).getAllLabels,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsTagsSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../../assets/icons/pen-line.svg":"9iTi6","../../../assets/icons/tag.svg":"jZ7nZ","../../../assets/icons/trash.svg":"jqW55","../../api":"f6lXD","../../components/ActionsDropdown/ActionsDropdown":"izRYG","../../components/AddButton/AddButton":"WJGEt","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/ConfirmAction/ConfirmAction":"icP5J","../../components/DataTableCellChild/DataTableCellChild":"boueG","../../components/extensions/Icon":"eHSf0","../../components/extensions/RowHighlighter":"9EbPr","../../components/FilterContainer/FilterContainer":"5kkHv","../../components/SearchTextField/SearchTextField":"k5bRy","../../components/SettingsPage/SettingsPage":"gJDHL","../../components/Tag/Tag":"4KuO7","../../components/TagEditModal/TagEditModal":"4yMBl","../../components/TextHighlighter/TextHighlighter":"43Xhz","../../constants/durations":"5sjIW","../../constants/queries-keys":"6hYSF","../../helpers/tag.helpers":"ecpII","../../hooks/useDebouncedState":"lKEJK","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/useQueryData":"4laI9","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","./SettingsTagsSkeleton":"i9deo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4yMBl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactColor = require("react-color");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _languages = require("../../constants/languages");
var _queriesKeys = require("../../constants/queries-keys");
var _styles = require("../../constants/styles");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _stringUtils = require("../../utils/stringUtils");
var _errorPanel = require("../ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _kdktag = require("../KDKTag/KDKTag");
var _kdktagDefault = parcelHelpers.interopDefault(_kdktag);
var _translationTextField = require("../TranslationTextField/TranslationTextField");
var _translationTextFieldDefault = parcelHelpers.interopDefault(_translationTextField);
const TagEditModal = (props)=>{
    const { tag: initialTag, onClose } = props;
    const isNewTag = !initialTag.id;
    const f = (0, _useFormatMessageDefault.default)();
    const [tag, setTag] = (0, _react.useState)({
        ...initialTag
    });
    const { getQueryData, updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).ALL_TAGS
    ]);
    const tags = getQueryData()?.labels || [];
    const tagsNames = (0, _react.useMemo)(()=>new Set(tags.map((tag)=>tag.id !== initialTag.id ? tag.title[0, _languages.DEFAULT_LANGUAGE].toLocaleLowerCase() : "")), [
        initialTag.title[0, _languages.DEFAULT_LANGUAGE],
        tags
    ]);
    const tagDescriptionLabels = {
        en: f("tags.modal.tag.name", {
            language: `${f("common.language.english")} ${(0, _languages.LANGUAGES_FLAGS)["en"]}`
        }),
        nb: f("tags.modal.tag.name", {
            language: `${f("common.language.norwegian")} ${(0, _languages.LANGUAGES_FLAGS)["nb"]}`
        })
    };
    const modalTitle = isNewTag ? f("tags.modal.title.add-tag") : f("tags.modal.title.update-tag");
    // a tag title is invalid if it is empty or already exists in the unique Set of all other tags
    const isInvalidTag = (0, _stringUtils.isEmptyString)(tag.title[0, _languages.DEFAULT_LANGUAGE].trim()) || tagsNames.has(tag.title[0, _languages.DEFAULT_LANGUAGE].trim().toLocaleLowerCase());
    const saveTagMutation = (0, _reactQuery.useMutation)((params)=>tag.id ? (0, _apiDefault.default).updateLabel(tag.id, params) : (0, _apiDefault.default).createLabel(params), {
        onSuccess: (tag)=>{
            updateQueryData((tagsList)=>{
                if (isNewTag) {
                    tagsList.labels = [
                        tag,
                        ...tagsList.labels
                    ];
                    tagsList.count += 1;
                } else tagsList.labels = tagsList.labels.map((currentTag)=>currentTag.id === tag.id ? tag : currentTag);
            });
            onClose();
        }
    });
    const saveTag = ()=>saveTagMutation.mutate({
            ...tag,
            title: {
                nb: tag.title.nb.trim(),
                en: tag.title.en?.trim()
            }
        });
    const handleUpdate = (value, property)=>setTag({
            ...tag,
            [property]: value
        });
    const onColorChange = (color)=>{
        if (tag.read_only) return;
        if (color === (0, _styles.DEFAULT_TAG_COLOR)) handleUpdate(undefined, "color");
        else handleUpdate(color, "color");
    };
    const saveAction = {
        content: isNewTag ? f("default.add") : f("default.save"),
        onAction: saveTag,
        disabled: isInvalidTag || tag.read_only,
        loading: saveTagMutation.isLoading
    };
    const cancelAction = {
        content: f("default.cancel"),
        onAction: onClose,
        disabled: saveTagMutation.isLoading
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
        open: true,
        large: true,
        title: modalTitle,
        onClose: onClose,
        primaryAction: saveAction,
        secondaryActions: [
            cancelAction
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                gap: "4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                        distribution: "fillEvenly",
                        wrap: false,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "8",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _translationTextFieldDefault.default), {
                                        getLabel: (language)=>tagDescriptionLabels[language],
                                        placeholder: f("tags.modal.tag.placeholder"),
                                        text: tag.title,
                                        onChange: (text)=>handleUpdate(text, "title"),
                                        autoComplete: "off",
                                        requiredIndicator: true,
                                        autoFocus: true,
                                        disabled: saveTagMutation.isLoading || tag.read_only,
                                        error: isInvalidTag ? f("tags.modal.tag.validation-error") : undefined
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                        gap: "1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                                as: "span",
                                                fontWeight: "semibold",
                                                children: f("default.preview")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.HorizontalStack), {
                                                gap: "4",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktagDefault.default), {
                                                        tag: tag,
                                                        language: (0, _languages.DEFAULT_LANGUAGE)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kdktagDefault.default), {
                                                        tag: tag,
                                                        language: "en"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        as: "span",
                                        children: f("tags.modal.tag.color")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyleColorPicker, {
                                        colors: (0, _styles.PRESET_COLORS_FOR_TAG_PICKER),
                                        color: tag.color || (0, _styles.DEFAULT_TAG_COLOR),
                                        triangle: "hide",
                                        disabled: tag.read_only,
                                        onChange: (value)=>onColorChange(value.hex)
                                    })
                                ]
                            })
                        ]
                    }),
                    saveTagMutation.isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                        message: saveTagMutation.error
                    })
                ]
            })
        })
    });
};
const StyleColorPicker = (0, _styledComponentsDefault.default)((0, _reactColor.TwitterPicker))`
  box-shadow: none !important;
  border: var(--p-border-width-1) solid var(--p-border-subdued);
  border-top-color: var(--p-border-shadow);
  border-radius: var(--p-border-radius-1);

  & > div {
    padding: 0 !important;
    pointer-events: ${({ disabled })=>disabled ? "none" : undefined};
  }
`;
exports.default = TagEditModal;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-color":"bQnEm","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../constants/languages":"ecnY7","../../constants/queries-keys":"6hYSF","../../constants/styles":"dZWds","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useQueryData":"4laI9","../../utils/stringUtils":"4gVdA","../ErrorPanel/ErrorPanel":"2hHqH","../KDKTag/KDKTag":"8koxk","../TranslationTextField/TranslationTextField":"58a0s","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bQnEm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "BlockPicker", ()=>(0, _blockDefault.default));
parcelHelpers.export(exports, "CirclePicker", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "ChromePicker", ()=>(0, _chromeDefault.default));
parcelHelpers.export(exports, "CompactPicker", ()=>(0, _compactDefault.default));
parcelHelpers.export(exports, "GithubPicker", ()=>(0, _githubDefault.default));
parcelHelpers.export(exports, "HuePicker", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "MaterialPicker", ()=>(0, _materialDefault.default));
parcelHelpers.export(exports, "PhotoshopPicker", ()=>(0, _photoshopDefault.default));
parcelHelpers.export(exports, "SketchPicker", ()=>(0, _sketchDefault.default));
parcelHelpers.export(exports, "SliderPicker", ()=>(0, _sliderDefault.default));
parcelHelpers.export(exports, "SwatchesPicker", ()=>(0, _swatchesDefault.default));
parcelHelpers.export(exports, "TwitterPicker", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "GooglePicker", ()=>(0, _googleDefault.default));
parcelHelpers.export(exports, "CustomPicker", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _chromeDefault.default));
var _alpha = require("./components/alpha/Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _block = require("./components/block/Block");
var _blockDefault = parcelHelpers.interopDefault(_block);
var _circle = require("./components/circle/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _chrome = require("./components/chrome/Chrome");
var _chromeDefault = parcelHelpers.interopDefault(_chrome);
var _compact = require("./components/compact/Compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _github = require("./components/github/Github");
var _githubDefault = parcelHelpers.interopDefault(_github);
var _hue = require("./components/hue/Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _material = require("./components/material/Material");
var _materialDefault = parcelHelpers.interopDefault(_material);
var _photoshop = require("./components/photoshop/Photoshop");
var _photoshopDefault = parcelHelpers.interopDefault(_photoshop);
var _sketch = require("./components/sketch/Sketch");
var _sketchDefault = parcelHelpers.interopDefault(_sketch);
var _slider = require("./components/slider/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _swatches = require("./components/swatches/Swatches");
var _swatchesDefault = parcelHelpers.interopDefault(_swatches);
var _twitter = require("./components/twitter/Twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _google = require("./components/google/Google");
var _googleDefault = parcelHelpers.interopDefault(_google);
var _colorWrap = require("./components/common/ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);

},{"./components/alpha/Alpha":"8tn0M","./components/block/Block":"7esn7","./components/circle/Circle":"19NxW","./components/chrome/Chrome":"4OQf8","./components/compact/Compact":"cgXib","./components/github/Github":"9Mj7G","./components/hue/Hue":"b4bdB","./components/material/Material":"cSei9","./components/photoshop/Photoshop":"dodgb","./components/sketch/Sketch":"j2nDA","./components/slider/Slider":"4d8rR","./components/swatches/Swatches":"7go7N","./components/twitter/Twitter":"eDiyN","./components/google/Google":"cWytM","./components/common/ColorWrap":"5kVue","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8tn0M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>AlphaPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _alphaPointer = require("./AlphaPointer");
var _alphaPointerDefault = parcelHelpers.interopDefault(_alphaPointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var AlphaPicker = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            alpha: {
                radius: "2px",
                style: style
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "alpha-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), _extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
AlphaPicker.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, _alphaPointerDefault.default)
};
exports.default = (0, _common.ColorWrap)(AlphaPicker);

},{"react":"cOWTg","reactcss":"itrAO","../common":"i0APu","./AlphaPointer":"8QsUB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"itrAO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
var _flattenNames = require("d21bbaf20f135ed7");
var _flattenNames2 = _interopRequireDefault(_flattenNames);
var _mergeClasses = require("7ab5259b27ba03f4");
var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
var _autoprefix = require("f7ab0b82c66de9f6");
var _autoprefix2 = _interopRequireDefault(_autoprefix);
var _hover2 = require("610a3f6b931726da");
var _hover3 = _interopRequireDefault(_hover2);
var _active = require("8d8d6281227b8365");
var _active2 = _interopRequireDefault(_active);
var _loop2 = require("c3bae8551a541b09");
var _loop3 = _interopRequireDefault(_loop2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, _flattenNames2.default)(activations);
    var merged = (0, _mergeClasses2.default)(classes, activeNames);
    return (0, _autoprefix2.default)(merged);
};
exports.default = ReactCSS;

},{"d21bbaf20f135ed7":"2IF9g","7ab5259b27ba03f4":"3HYVJ","f7ab0b82c66de9f6":"bBbPU","610a3f6b931726da":"eNmUH","8d8d6281227b8365":"8gyT4","c3bae8551a541b09":"a4IcH"}],"2IF9g":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.flattenNames = undefined;
var _isString2 = require("cc07907b88eac890");
var _isString3 = _interopRequireDefault(_isString2);
var _forOwn2 = require("2db844d13e15e498");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _isPlainObject2 = require("8ea197129e7ee890");
var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
var _map2 = require("8f65518dcbd71fa0");
var _map3 = _interopRequireDefault(_map2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var flattenNames = exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, _map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, _isPlainObject3.default)(thing)) (0, _forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, _isString3.default)(thing)) names.push(thing);
    });
    return names;
};
exports.default = flattenNames;

},{"cc07907b88eac890":"lpjX5","2db844d13e15e498":"gRb3j","8ea197129e7ee890":"iHHX6","8f65518dcbd71fa0":"2ef7Q"}],"lpjX5":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"iw7hV","46fdd4d2c5d7b4ab":"bf4G8","36ebbb6a9d8b3fe4":"g4Din"}],"iw7hV":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"hwpKR","9b2aaf31b7bdd837":"lA1o1","46d5beb3375f8a28":"jJZvD"}],"hwpKR":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"bnhvP"}],"bnhvP":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"98BO2"}],"98BO2":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"lA1o1":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"hwpKR"}],"jJZvD":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"bf4G8":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"g4Din":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"gRb3j":[function(require,module,exports) {
var baseForOwn = require("29fecbf008d96984"), castFunction = require("e9d5e9d48b9f93d3");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forOwn(object, iteratee) {
    return object && baseForOwn(object, castFunction(iteratee));
}
module.exports = forOwn;

},{"29fecbf008d96984":"5vW33","e9d5e9d48b9f93d3":"llXEg"}],"5vW33":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"44Kq0","1fb77c53defe5720":"eCp02"}],"44Kq0":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"dcUIN"}],"dcUIN":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"eCp02":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"gAsZZ","e8453365fdacc8da":"iXswe","7760b47b02971dfa":"hBFWj"}],"gAsZZ":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"b9QUE","9cdb51ffa56f149b":"4RUtW","38cd49f1e493b3d7":"bf4G8","b379831fe1873fed":"9HAYd","f362a34cd8321bb7":"bXAJU","c019db5297494469":"2KCbq"}],"b9QUE":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"4RUtW":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"6755j","bead821d6af018b5":"g4Din"}],"6755j":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"iw7hV","b6cdbe52dcf709f8":"g4Din"}],"9HAYd":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"bnhvP","a1e87b138cf75d1d":"hcOtb"}],"hcOtb":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"bXAJU":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"2KCbq":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"kvnCB","903f50eb1c16d257":"gLbOa","fa49853a82034c30":"4GuVn"}],"kvnCB":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"iw7hV","f661b3a120d7a4cb":"5lZy3","cdd86c83797c0618":"g4Din"}],"5lZy3":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"gLbOa":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"4GuVn":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"98BO2"}],"iXswe":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"aHmiE","3ec652610d8dd5d3":"jLzRv"}],"aHmiE":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"jLzRv":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"54clC"}],"54clC":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"hBFWj":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"8ouvy","f3db08d4d1110aaf":"5lZy3"}],"8ouvy":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"iw7hV","3cba3c966459d528":"3l4Cf"}],"3l4Cf":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"llXEg":[function(require,module,exports) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == "function" ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"83vrH"}],"83vrH":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"iHHX6":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"iw7hV","2ca5b85a120835de":"80cAH","963b65e043435612":"g4Din"}],"80cAH":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"54clC"}],"2ef7Q":[function(require,module,exports) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"ao5i2","8bad46685c8864d":"aTR1J","51c76ab24fdb66f9":"V8eYu","7cb4cacc4dea406c":"bf4G8"}],"ao5i2":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"aTR1J":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"kSwk1","4f010869f7b63154":"Jxpay","28f06147d1eb9502":"83vrH","3c56f88c4debf449":"bf4G8","aee920e0ef5bf111":"lPBgP"}],"kSwk1":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"j5gBn","89e9034a8071e297":"gSIGs","782598b150762386":"6ub96"}],"j5gBn":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"7eLr0","9003c0cc8ac007b6":"ehlij"}],"7eLr0":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"uvtXq","ceda2a63c77c915":"eT21C","91ee1b348d9d7172":"8nI7P","3fe28318f65b9332":"1KVzg","724ca4def8b84e06":"eQRYO","e9ceacb40d9582bd":"13FJ9"}],"uvtXq":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"llMKk","b700cb849df2c166":"9Mj3G","d76dd90eead6cced":"4dizX","3d210628ba60ec8":"ftOHp","76026bf2d4cfff93":"ab8Pp"}],"llMKk":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"9Mj3G":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"aTPzs"}],"aTPzs":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"hqHoe"}],"hqHoe":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"4dizX":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"aTPzs"}],"ftOHp":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"aTPzs"}],"ab8Pp":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"aTPzs"}],"eT21C":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"uvtXq"}],"8nI7P":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"1KVzg":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"eQRYO":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"13FJ9":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"uvtXq","1494efbafafa9552":"9R2Yy","6049e8027fe9407f":"k7IgK"}],"9R2Yy":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"3L2Ao","29224713b8d411e6":"bnhvP"}],"3L2Ao":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"ektaD","16db51a0e009bd8c":"fQ4h0"}],"ektaD":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"8ouvy","cabbc2adfaeb27d9":"7ga4H","cbb5703fe1562e7f":"3l4Cf","388b819f47a43aa5":"8W2Ek"}],"7ga4H":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"1YDuF"}],"1YDuF":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"bnhvP"}],"8W2Ek":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"fQ4h0":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"k7IgK":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"7UTG0","d2967b0e32ccfa56":"eK7qg","ca21409ea89624c0":"7UZhG","f88fd07f8dd1f67d":"9AEzg","dbf3eae765642a3b":"gMg83"}],"7UTG0":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"8wekg","a07dcf3fd3097a0c":"uvtXq","92c01c953ef00ded":"9R2Yy"}],"8wekg":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"hILhe","bc25d439ccd1fb47":"jfsRT","f096b37295a92ab0":"jrJ66","d88173cbc6a133c8":"lKGaE","afb9b3bae0461cbf":"jfTGA"}],"hILhe":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"5M4nz"}],"5M4nz":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"3L2Ao"}],"jfsRT":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"jrJ66":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"5M4nz"}],"lKGaE":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"5M4nz"}],"jfTGA":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"5M4nz"}],"eK7qg":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"isp9q"}],"isp9q":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"i6qXc"}],"i6qXc":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"7UZhG":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"isp9q"}],"9AEzg":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"isp9q"}],"gMg83":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"isp9q"}],"ehlij":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"3YaAp","809bbb0c20650dbc":"g4Din"}],"3YaAp":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"7eLr0","96bc8a1825db53a5":"2vQsw","8bdece495e87fb69":"f020p","bb94920432a68eca":"cnE7U","45495edff98e5837":"gGFRp","18256411ae9e2858":"bf4G8","e5ba7abf54247fc5":"9HAYd","50d786bb5c7366af":"2KCbq"}],"2vQsw":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"2WqXp","1ee20de911db0cb0":"bIZrl","defff3d81be91b23":"yyREe"}],"2WqXp":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"k7IgK","9a831e81e9a1f98c":"kIcSs","1a2b6c8a7399c39f":"5yWi1"}],"kIcSs":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"5yWi1":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"bIZrl":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"yyREe":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"f020p":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"hwpKR","dbf6aa5033a0f48":"fG0rZ","539966708f906e61":"hqHoe","8142d4017f0a425f":"2vQsw","48cddf732eff33ba":"9g9AM","9dc78b26c5daba20":"he6JS"}],"fG0rZ":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"bnhvP"}],"9g9AM":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"he6JS":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"cnE7U":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"dAM3w"}],"dAM3w":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"5SFDk","aa79b69a13f924db":"igy23","e3ad83e53433bc8a":"eCp02"}],"5SFDk":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"amisw","148b85918856c33a":"bf4G8"}],"amisw":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"igy23":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"en7Tn","6b1c62cea92cdb9":"iRF5T"}],"en7Tn":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"iRF5T":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"gGFRp":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"fIybL","28e3344aae951f13":"9R2Yy","b286298be5b1d9a4":"4NLz5","3ae50c158f89813":"aRv4k","9f458755f627d456":"7Zkd7","8e9160b373d7fe66":"iw7hV","b210627dd951641f":"8W2Ek"}],"fIybL":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"3L2Ao","f83c375075418382":"bnhvP"}],"4NLz5":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"3L2Ao","a5c6637bac681a0":"bnhvP"}],"aRv4k":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"3L2Ao","ca486d41cdf819d4":"bnhvP"}],"7Zkd7":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"3L2Ao","7a9a6581834a8452":"bnhvP"}],"gSIGs":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"cSXPA","94ffded3a85af2f6":"eCp02"}],"cSXPA":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"3l4Cf"}],"6ub96":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"Jxpay":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"ehlij","d5ca180f7d6f956a":"6hKrY","3462bb3f546fa1f7":"hRsA8","f5fef07966a1c4ee":"028tC","2a1cd212d48516":"cSXPA","885e72ee7fc6d296":"6ub96","cd65eaf4a3af29f6":"hyRao"}],"6hKrY":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"4SY0s"}],"4SY0s":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"dTHs3","c3296f04fad32769":"hyRao"}],"dTHs3":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"bf4G8","e823e604d75f975b":"028tC","f5fff1c342107fbd":"1TP2g","b04e8cc634273c23":"Swbno"}],"028tC":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"bf4G8","4cdff6c9e9ff5d38":"i2v8Z"}],"i2v8Z":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"iw7hV","74644060ad1a1d3c":"g4Din"}],"1TP2g":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"16FkE"}],"16FkE":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"rsXKp"}],"rsXKp":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"k7IgK"}],"Swbno":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"8r92r"}],"8r92r":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"hwpKR","8439a3a1551d0706":"ao5i2","4b12c9f502d3288a":"bf4G8","a0ebd327d618908a":"i2v8Z"}],"hyRao":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"i2v8Z"}],"hRsA8":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"lUrjZ","b0aefd36de99e579":"f1cef"}],"lUrjZ":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"f1cef":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"dTHs3","47ffafdab3ba0d6f":"4RUtW","93ebd263ff0131c1":"bf4G8","252ef74480e01958":"bXAJU","23c2f64e75e90a2":"5lZy3","af5ade297cb685ee":"hyRao"}],"lPBgP":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"GKhpi","abf31da39349df22":"6T0fJ","a387ef4a4373de2c":"028tC","9315973458389ae7":"hyRao"}],"GKhpi":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"6T0fJ":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"4SY0s"}],"V8eYu":[function(require,module,exports) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"7VAY6","2924e2db4bb5430d":"hBFWj"}],"7VAY6":[function(require,module,exports) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"5vW33","f1e3fc84161ef3ec":"3gdwl"}],"3gdwl":[function(require,module,exports) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"hBFWj"}],"3HYVJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeClasses = undefined;
var _forOwn2 = require("42f7fd880fbb6b28");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _cloneDeep2 = require("fe0598645aa3c32b");
var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, _forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = _extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
exports.default = mergeClasses;

},{"42f7fd880fbb6b28":"gRb3j","fe0598645aa3c32b":"82Srx"}],"82Srx":[function(require,module,exports) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"flTIH"}],"flTIH":[function(require,module,exports) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"7eLr0","3a79976eb46af94a":"5cUhm","bc83a05a4f99d69b":"aoKSx","e6b4c3e6c85df6bb":"lRtE5","f340cc553ba5643c":"l0v2B","e72e99883a50402d":"cSpAT","dc840ead07f1054":"WP5At","309288e8ee190af0":"a9K3b","687fa30fede0b048":"fSUPq","bb0ba724f98b094d":"dAM3w","12bae1dca0e83064":"3LP5X","4c3204eaea28d680":"gGFRp","fd7741200b462cdf":"5QmKG","f93a1d24ac08e076":"6GpMY","630039e80f692f17":"lXl5T","f37949484ab52dae":"bf4G8","ac876cc65d29c86e":"9HAYd","1056c031d98783c0":"illH6","1800fb3122907fc2":"3l4Cf","31f022f648037bd3":"9XqEF","5f3267fbd9848a7d":"eCp02","7d3f3bdc4f2e7bb8":"7SkEm"}],"5cUhm":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"aoKSx":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"ckEYC","b62ef95b3cf1cde1":"hqHoe"}],"ckEYC":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"hlTpT"}],"hlTpT":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"3L2Ao"}],"lRtE5":[function(require,module,exports) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"1eXVJ","fcf23a0242ef0da9":"eCp02"}],"1eXVJ":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"aoKSx","9cddf6ac1a092765":"ckEYC"}],"l0v2B":[function(require,module,exports) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"1eXVJ","7697a1565646c93":"7SkEm"}],"7SkEm":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"gAsZZ","194eb1a802636842":"hNA45","ac15afdc3ddd76cd":"hBFWj"}],"hNA45":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"3l4Cf","f7d53cd92b2b977b":"aHmiE","c039208a16eb68bd":"aFIAu"}],"aFIAu":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"cSpAT":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"bnhvP"}],"WP5At":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"a9K3b":[function(require,module,exports) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"1eXVJ","39cbde2205d9399c":"igy23"}],"fSUPq":[function(require,module,exports) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"1eXVJ","9b660e6b0c20d303":"3Kj9z"}],"3Kj9z":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"amisw","6ccae2aa7cfa3c66":"80cAH","bdb501682ee9305d":"igy23","7641fe4ae6d2cc96":"iRF5T"}],"3LP5X":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"5SFDk","feede5d0a2d06427":"3Kj9z","287f70f798405911":"7SkEm"}],"5QmKG":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"6GpMY":[function(require,module,exports) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"8k6ni","dbf04edaab2ae376":"2mM30","763300f2dd9bdaf3":"1pKHf","c30e64d90e4b92d1":"9diPo","d1edd8349e9ad54d":"9LPHE"}],"8k6ni":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"fG0rZ"}],"2mM30":[function(require,module,exports) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"8k6ni"}],"1pKHf":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"9diPo":[function(require,module,exports) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"hwpKR"}],"9LPHE":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"8k6ni"}],"lXl5T":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"4g9la","8c92276927b7c3e0":"80cAH","e939f15d7a0f64a5":"aHmiE"}],"4g9la":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"3l4Cf"}],"illH6":[function(require,module,exports) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"7t23G","6a7e6b1a2d9fb1d5":"gLbOa","7d4f449dd306450f":"4GuVn"}],"7t23G":[function(require,module,exports) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"gGFRp","88260e33e0003386":"g4Din"}],"9XqEF":[function(require,module,exports) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"cPtgb","3cb35dba719c68b1":"gLbOa","7a3e899a332ff7be":"4GuVn"}],"cPtgb":[function(require,module,exports) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"gGFRp","b6fc875bc5f351c9":"g4Din"}],"bBbPU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoprefix = undefined;
var _forOwn2 = require("6b2ab06ed0e74650");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var autoprefix = exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, _forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, _forOwn3.default)(styles, function(value, key) {
            var transform = transforms[key];
            if (transform) expanded = _extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
exports.default = autoprefix;

},{"6b2ab06ed0e74650":"gRb3j"}],"eNmUH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hover = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("a618bb79e13970dd");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hover = exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }(_react2.default.Component);
};
exports.default = hover;

},{"a618bb79e13970dd":"cOWTg"}],"8gyT4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.active = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("91e1b91cd0b21ba2");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var active = exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }(_react2.default.Component);
};
exports.default = active;

},{"91e1b91cd0b21ba2":"cOWTg"}],"a4IcH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
exports.default = loopable;

},{}],"i0APu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "Checkboard", ()=>(0, _checkboardDefault.default));
parcelHelpers.export(exports, "EditableInput", ()=>(0, _editableInputDefault.default));
parcelHelpers.export(exports, "Hue", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "Raised", ()=>(0, _raisedDefault.default));
parcelHelpers.export(exports, "Saturation", ()=>(0, _saturationDefault.default));
parcelHelpers.export(exports, "ColorWrap", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "Swatch", ()=>(0, _swatchDefault.default));
var _alpha = require("./Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _editableInput = require("./EditableInput");
var _editableInputDefault = parcelHelpers.interopDefault(_editableInput);
var _hue = require("./Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _raised = require("./Raised");
var _raisedDefault = parcelHelpers.interopDefault(_raised);
var _saturation = require("./Saturation");
var _saturationDefault = parcelHelpers.interopDefault(_saturation);
var _colorWrap = require("./ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);
var _swatch = require("./Swatch");
var _swatchDefault = parcelHelpers.interopDefault(_swatch);

},{"./Alpha":"6WCKn","./Checkboard":"5BhlM","./EditableInput":"9mcDI","./Hue":"dPNzH","./Raised":"fYNgg","./Saturation":"ghdiY","./ColorWrap":"5kVue","./Swatch":"9EhD5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6WCKn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>Alpha);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _alpha = require("../../helpers/alpha");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function(_ref) {
    _inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": _extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.checkboard
                }, (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
                    renderers: this.props.renderers
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.gradient
                }), (0, _reactDefault.default).createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Alpha;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/alpha":"e1rCq","./Checkboard":"5BhlM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e1rCq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5BhlM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkboard", ()=>Checkboard);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _checkboard = require("../../helpers/checkboard");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + _checkboard.get(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, _react.isValidElement)(children) ? (0, _reactDefault.default).cloneElement(children, _extends({}, children.props, {
        style: _extends({}, children.props.style, styles.grid)
    })) : (0, _reactDefault.default).createElement("div", {
        style: styles.grid
    });
};
Checkboard.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
exports.default = Checkboard;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/checkboard":"2ou9e","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2ou9e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "get", ()=>get);
var checkboardCache = {};
var render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if (checkboardCache[key]) return checkboardCache[key];
    var checkboard = render(c1, c2, size, serverCanvas);
    checkboardCache[key] = checkboard;
    return checkboard;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9mcDI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableInput", ()=>EditableInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [
    UP_KEY_CODE,
    DOWN_KEY_CODE
];
var isValidKeyCode = function isValidKeyCode(keyCode) {
    return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var idCounter = 1;
var EditableInput = function(_ref) {
    _inherits(EditableInput, _ref);
    function EditableInput(props) {
        _classCallCheck(this, EditableInput);
        var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = getNumberValue(e.target.value);
            if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + idCounter++;
        return _this;
    }
    _createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return _defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.wrap
                }, (0, _reactDefault.default).createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? (0, _reactDefault.default).createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = EditableInput;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dPNzH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hue", ()=>Hue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _hue = require("../../helpers/hue");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref) {
    _inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), (0, _reactDefault.default).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Hue;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/hue":"7Jp3V","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Jp3V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fYNgg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Raised", ()=>Raised);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.wrap
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.bg
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.content
    }, children));
};
Raised.propTypes = {
    background: (0, _propTypesDefault.default).string,
    zDepth: (0, _propTypesDefault.default).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Raised.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
exports.default = Raised;

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kd6oR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMergeJs = require("./_baseMerge.js");
var _baseMergeJsDefault = parcelHelpers.interopDefault(_baseMergeJs);
var _createAssignerJs = require("./_createAssigner.js");
var _createAssignerJsDefault = parcelHelpers.interopDefault(_createAssignerJs);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = (0, _createAssignerJsDefault.default)(function(object, source, srcIndex) {
    (0, _baseMergeJsDefault.default)(object, source, srcIndex);
});
exports.default = merge;

},{"./_baseMerge.js":"1NPFv","./_createAssigner.js":"kaE1u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1NPFv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _baseMergeDeepJs = require("./_baseMergeDeep.js");
var _baseMergeDeepJsDefault = parcelHelpers.interopDefault(_baseMergeDeepJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, _baseForJsDefault.default)(source, function(srcValue, key) {
        stack || (stack = new (0, _stackJsDefault.default));
        if ((0, _isObjectJsDefault.default)(srcValue)) (0, _baseMergeDeepJsDefault.default)(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, _safeGetJsDefault.default)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, _assignMergeValueJsDefault.default)(object, key, newValue);
        }
    }, (0, _keysInJsDefault.default));
}
exports.default = baseMerge;

},{"./_Stack.js":"lnW1A","./_assignMergeValue.js":"itv1o","./_baseFor.js":"iqxIb","./_baseMergeDeep.js":"6qAZH","./isObject.js":"OCMWa","./keysIn.js":"a6pBW","./_safeGet.js":"q1b05","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lnW1A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype["delete"] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"7NSvj","./_stackClear.js":"7N7O4","./_stackDelete.js":"fCtdY","./_stackGet.js":"hgqMO","./_stackHas.js":"e1lcM","./_stackSet.js":"gdV4T","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7NSvj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype["delete"] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"20Jh2","./_listCacheDelete.js":"03WzD","./_listCacheGet.js":"1kBkn","./_listCacheHas.js":"71Gg3","./_listCacheSet.js":"2pwDJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"20Jh2":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"03WzD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"2NYNW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2NYNW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"hIG96","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hIG96":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1kBkn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"2NYNW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"71Gg3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"2NYNW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2pwDJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"2NYNW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7N7O4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"7NSvj","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fCtdY":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hgqMO":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"e1lcM":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gdV4T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"7NSvj","./_Map.js":"gmih8","./_MapCache.js":"b92s8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gmih8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Map");
exports.default = Map;

},{"./_getNative.js":"kqm6v","./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kqm6v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"3sYnO","./_getValue.js":"ks7X3","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3sYnO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"40EFn","./_isMasked.js":"iLDcY","./isObject.js":"OCMWa","./_toSource.js":"eLUxy","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"40EFn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"5h2C9","./isObject.js":"OCMWa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5h2C9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"bn0qk","./_getRawTag.js":"lWMo8","./_objectToString.js":"2mDQr","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bn0qk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dgYbV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function("return this")();
exports.default = root;

},{"./_freeGlobal.js":"lOnLi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lOnLi":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lWMo8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"bn0qk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2mDQr":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"OCMWa":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iLDcY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"fUL7R","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fUL7R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)["__core-js_shared__"];
exports.default = coreJsData;

},{"./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eLUxy":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ks7X3":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b92s8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype["delete"] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"OL1aa","./_mapCacheDelete.js":"fXyCJ","./_mapCacheGet.js":"9hpto","./_mapCacheHas.js":"3S4bO","./_mapCacheSet.js":"fzIEs","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"OL1aa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, _hashJsDefault.default),
        "map": new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        "string": new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"jmzyg","./_ListCache.js":"7NSvj","./_Map.js":"gmih8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jmzyg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype["delete"] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"hegyi","./_hashDelete.js":"kj0uK","./_hashGet.js":"k1Ae7","./_hashHas.js":"ark9D","./_hashSet.js":"7Qfjo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hegyi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"h4SYI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h4SYI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, "create");
exports.default = nativeCreate;

},{"./_getNative.js":"kqm6v","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kj0uK":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"k1Ae7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"h4SYI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ark9D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"h4SYI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Qfjo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"h4SYI","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fXyCJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"1hi3I","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1hi3I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"17VvD","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"17VvD":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9hpto":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"1hi3I","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3S4bO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"1hi3I","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fzIEs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"1hi3I","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"itv1o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, _eqJsDefault.default)(object[key], value) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignMergeValue;

},{"./_baseAssignValue.js":"9vUEn","./eq.js":"hIG96","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9vUEn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"h77w9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h77w9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"kqm6v","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iqxIb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createBaseForJs = require("./_createBaseFor.js");
var _createBaseForJsDefault = parcelHelpers.interopDefault(_createBaseForJs);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = (0, _createBaseForJsDefault.default)();
exports.default = baseFor;

},{"./_createBaseFor.js":"2fROf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2fROf":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
exports.default = createBaseFor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6qAZH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeObjectJs = require("./isArrayLikeObject.js");
var _isArrayLikeObjectJsDefault = parcelHelpers.interopDefault(_isArrayLikeObjectJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPlainObjectJs = require("./isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
var _toPlainObjectJs = require("./toPlainObject.js");
var _toPlainObjectJsDefault = parcelHelpers.interopDefault(_toPlainObjectJs);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, _safeGetJsDefault.default)(object, key), srcValue = (0, _safeGetJsDefault.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, _assignMergeValueJsDefault.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, _isArrayJsDefault.default)(srcValue), isBuff = !isArr && (0, _isBufferJsDefault.default)(srcValue), isTyped = !isArr && !isBuff && (0, _isTypedArrayJsDefault.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, _isArrayJsDefault.default)(objValue)) newValue = objValue;
            else if ((0, _isArrayLikeObjectJsDefault.default)(objValue)) newValue = (0, _copyArrayJsDefault.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, _cloneBufferJsDefault.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, _cloneTypedArrayJsDefault.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, _isPlainObjectJsDefault.default)(srcValue) || (0, _isArgumentsJsDefault.default)(srcValue)) {
            newValue = objValue;
            if ((0, _isArgumentsJsDefault.default)(objValue)) newValue = (0, _toPlainObjectJsDefault.default)(objValue);
            else if (!(0, _isObjectJsDefault.default)(objValue) || (0, _isFunctionJsDefault.default)(objValue)) newValue = (0, _initCloneObjectJsDefault.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, _assignMergeValueJsDefault.default)(object, key, newValue);
}
exports.default = baseMergeDeep;

},{"./_assignMergeValue.js":"itv1o","./_cloneBuffer.js":"2drLX","./_cloneTypedArray.js":"bGvnC","./_copyArray.js":"grXiL","./_initCloneObject.js":"4oIKI","./isArguments.js":"4wZvJ","./isArray.js":"a6xTq","./isArrayLikeObject.js":"ixfkt","./isBuffer.js":"3lQ8J","./isFunction.js":"40EFn","./isObject.js":"OCMWa","./isPlainObject.js":"hTOcW","./isTypedArray.js":"8vntp","./_safeGet.js":"q1b05","./toPlainObject.js":"42iOV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2drLX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bGvnC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"1uK6q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1uK6q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"hAara","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hAara":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"grXiL":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4oIKI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"bVgpK","./_getPrototype.js":"dAfur","./_isPrototype.js":"7g6tJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bVgpK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"OCMWa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dAfur":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"9y41j","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9y41j":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7g6tJ":[function(require,module,exports) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4wZvJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"jQPKV","./isObjectLike.js":"cEf8u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jQPKV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"5h2C9","./isObjectLike.js":"cEf8u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cEf8u":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == "object";
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a6xTq":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ixfkt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isArrayLikeJsDefault.default)(value);
}
exports.default = isArrayLikeObject;

},{"./isArrayLike.js":"7YvcL","./isObjectLike.js":"cEf8u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7YvcL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"40EFn","./isLength.js":"qxAio","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"qxAio":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3lQ8J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"dgYbV","./stubFalse.js":"7g2wO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7g2wO":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hTOcW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"5h2C9","./_getPrototype.js":"dAfur","./isObjectLike.js":"cEf8u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8vntp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"72Z8B","./_baseUnary.js":"8sVjL","./_nodeUtil.js":"eU43U","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"72Z8B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"5h2C9","./isLength.js":"qxAio","./isObjectLike.js":"cEf8u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8sVjL":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eU43U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"lOnLi","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"q1b05":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
exports.default = safeGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"42iOV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return (0, _copyObjectJsDefault.default)(value, (0, _keysInJsDefault.default)(value));
}
exports.default = toPlainObject;

},{"./_copyObject.js":"6nkvi","./keysIn.js":"a6pBW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6nkvi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"03KTi","./_baseAssignValue.js":"9vUEn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"03KTi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"9vUEn","./eq.js":"hIG96","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a6pBW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"2Lguy","./_baseKeysIn.js":"eDNBm","./isArrayLike.js":"7YvcL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2Lguy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"6aM0K","./isArguments.js":"4wZvJ","./isArray.js":"a6xTq","./isBuffer.js":"3lQ8J","./_isIndex.js":"3Qf8u","./isTypedArray.js":"8vntp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6aM0K":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3Qf8u":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eDNBm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"OCMWa","./_isPrototype.js":"7g6tJ","./_nativeKeysIn.js":"j5mlW","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j5mlW":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kaE1u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseRestJs = require("./_baseRest.js");
var _baseRestJsDefault = parcelHelpers.interopDefault(_baseRestJs);
var _isIterateeCallJs = require("./_isIterateeCall.js");
var _isIterateeCallJsDefault = parcelHelpers.interopDefault(_isIterateeCallJs);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return (0, _baseRestJsDefault.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, _isIterateeCallJsDefault.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
exports.default = createAssigner;

},{"./_baseRest.js":"lM6PY","./_isIterateeCall.js":"daTlU","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lM6PY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _overRestJs = require("./_overRest.js");
var _overRestJsDefault = parcelHelpers.interopDefault(_overRestJs);
var _setToStringJs = require("./_setToString.js");
var _setToStringJsDefault = parcelHelpers.interopDefault(_setToStringJs);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return (0, _setToStringJsDefault.default)((0, _overRestJsDefault.default)(func, start, (0, _identityJsDefault.default)), func + "");
}
exports.default = baseRest;

},{"./identity.js":"9TWzV","./_overRest.js":"fvRz4","./_setToString.js":"80oNn","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9TWzV":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function identity(value) {
    return value;
}
exports.default = identity;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fvRz4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _applyJs = require("./_apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, _applyJsDefault.default)(func, this, otherArgs);
    };
}
exports.default = overRest;

},{"./_apply.js":"6U96d","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6U96d":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
exports.default = apply;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"80oNn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSetToStringJs = require("./_baseSetToString.js");
var _baseSetToStringJsDefault = parcelHelpers.interopDefault(_baseSetToStringJs);
var _shortOutJs = require("./_shortOut.js");
var _shortOutJsDefault = parcelHelpers.interopDefault(_shortOutJs);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = (0, _shortOutJsDefault.default)((0, _baseSetToStringJsDefault.default));
exports.default = setToString;

},{"./_baseSetToString.js":"4dwLm","./_shortOut.js":"a9VFM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4dwLm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !(0, _definePropertyJsDefault.default) ? (0, _identityJsDefault.default) : function(func, string) {
    return (0, _definePropertyJsDefault.default)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, _constantJsDefault.default)(string),
        "writable": true
    });
};
exports.default = baseSetToString;

},{"./constant.js":"cdWXn","./_defineProperty.js":"h77w9","./identity.js":"9TWzV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cdWXn":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function constant(value) {
    return function() {
        return value;
    };
}
exports.default = constant;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"a9VFM":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
exports.default = shortOut;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"daTlU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!(0, _isObjectJsDefault.default)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, _isArrayLikeJsDefault.default)(object) && (0, _isIndexJsDefault.default)(index, object.length) : type == "string" && index in object) return (0, _eqJsDefault.default)(object[index], value);
    return false;
}
exports.default = isIterateeCall;

},{"./eq.js":"hIG96","./isArrayLike.js":"7YvcL","./_isIndex.js":"3Qf8u","./isObject.js":"OCMWa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ghdiY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Saturation", ()=>Saturation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _throttle = require("lodash-es/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _saturation = require("../../helpers/saturation");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref) {
    _inherits(Saturation, _ref);
    function Saturation(props) {
        _classCallCheck(this, Saturation);
        var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, _saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, _throttleDefault.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    _createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), (0, _reactDefault.default).createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), (0, _reactDefault.default).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Saturation;

},{"react":"cOWTg","reactcss":"itrAO","lodash-es/throttle":"ek0E7","../../helpers/saturation":"iv8qz","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ek0E7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounceJs = require("./debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, _debounceJsDefault.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
exports.default = throttle;

},{"./debounce.js":"6qADi","./isObject.js":"OCMWa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6qADi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _nowJs = require("./now.js");
var _nowJsDefault = parcelHelpers.interopDefault(_nowJs);
var _toNumberJs = require("./toNumber.js");
var _toNumberJsDefault = parcelHelpers.interopDefault(_toNumberJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    wait = (0, _toNumberJsDefault.default)(wait) || 0;
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax((0, _toNumberJsDefault.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, _nowJsDefault.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, _nowJsDefault.default)());
    }
    function debounced() {
        var time = (0, _nowJsDefault.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
exports.default = debounce;

},{"./isObject.js":"OCMWa","./now.js":"7BkA0","./toNumber.js":"jqrjw","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7BkA0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return (0, _rootJsDefault.default).Date.now();
};
exports.default = now;

},{"./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jqrjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTrimJs = require("./_baseTrim.js");
var _baseTrimJsDefault = parcelHelpers.interopDefault(_baseTrimJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, _isSymbolJsDefault.default)(value)) return NAN;
    if ((0, _isObjectJsDefault.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, _isObjectJsDefault.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, _baseTrimJsDefault.default)(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
exports.default = toNumber;

},{"./_baseTrim.js":"fHPUT","./isObject.js":"OCMWa","./isSymbol.js":"5BU5B","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fHPUT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trimmedEndIndexJs = require("./_trimmedEndIndex.js");
var _trimmedEndIndexJsDefault = parcelHelpers.interopDefault(_trimmedEndIndexJs);
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, (0, _trimmedEndIndexJsDefault.default)(string) + 1).replace(reTrimStart, "") : string;
}
exports.default = baseTrim;

},{"./_trimmedEndIndex.js":"hu1ai","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hu1ai":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
exports.default = trimmedEndIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5BU5B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"5h2C9","./isObjectLike.js":"cEf8u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iv8qz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"5kVue":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWrap", ()=>ColorWrap);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounce = require("lodash-es/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _color = require("../../helpers/color");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        _inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            _classCallCheck(this, ColorPicker);
            var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = _extends({}, _color.toState(props.color, 0));
            _this.debounce = (0, _debounceDefault.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        _createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, _reactDefault.default).createElement(Picker, _extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return _extends({}, _color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, _react.PureComponent) || (0, _react.Component));
    ColorPicker.propTypes = _extends({}, Picker.propTypes);
    ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
exports.default = ColorWrap;

},{"react":"cOWTg","lodash-es/debounce":"6qADi","../../helpers/color":"adNd7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"adNd7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "simpleCheckForValidColor", ()=>simpleCheckForValidColor);
parcelHelpers.export(exports, "toState", ()=>toState);
parcelHelpers.export(exports, "isValidHex", ()=>isValidHex);
parcelHelpers.export(exports, "getContrastingColor", ()=>getContrastingColor);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "isvalidColorString", ()=>isvalidColorString);
var _each = require("lodash-es/each");
var _eachDefault = parcelHelpers.interopDefault(_each);
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, _eachDefault.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var toState = function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2Default.default)(data.hex) : (0, _tinycolor2Default.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var isValidHex = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2Default.default)(hex).isValid();
};
var getContrastingColor = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = toState(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, _tinycolor2Default.default)(type + " (" + stringWithoutDegree + ")")._ok;
};

},{"lodash-es/each":"7BmM8","tinycolor2":"42SOf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7BmM8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _forEachJsDefault.default));
var _forEachJs = require("./forEach.js");
var _forEachJsDefault = parcelHelpers.interopDefault(_forEachJs);

},{"./forEach.js":"72YrL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"72YrL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayEachJs = require("./_arrayEach.js");
var _arrayEachJsDefault = parcelHelpers.interopDefault(_arrayEachJs);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _castFunctionJs = require("./_castFunction.js");
var _castFunctionJsDefault = parcelHelpers.interopDefault(_castFunctionJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayEachJsDefault.default) : (0, _baseEachJsDefault.default);
    return func(collection, (0, _castFunctionJsDefault.default)(iteratee));
}
exports.default = forEach;

},{"./_arrayEach.js":"kkbet","./_baseEach.js":"7KfXv","./_castFunction.js":"jIv7b","./isArray.js":"a6xTq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kkbet":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
exports.default = arrayEach;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7KfXv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForOwnJs = require("./_baseForOwn.js");
var _baseForOwnJsDefault = parcelHelpers.interopDefault(_baseForOwnJs);
var _createBaseEachJs = require("./_createBaseEach.js");
var _createBaseEachJsDefault = parcelHelpers.interopDefault(_createBaseEachJs);
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = (0, _createBaseEachJsDefault.default)((0, _baseForOwnJsDefault.default));
exports.default = baseEach;

},{"./_baseForOwn.js":"1A9jX","./_createBaseEach.js":"eRfr7","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1A9jX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && (0, _baseForJsDefault.default)(object, iteratee, (0, _keysJsDefault.default));
}
exports.default = baseForOwn;

},{"./_baseFor.js":"iqxIb","./keys.js":"jsJjJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jsJjJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object) : (0, _baseKeysJsDefault.default)(object);
}
exports.default = keys;

},{"./_arrayLikeKeys.js":"2Lguy","./_baseKeys.js":"jKgwf","./isArrayLike.js":"7YvcL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jKgwf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"7g6tJ","./_nativeKeys.js":"9aSgb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9aSgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"9y41j","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eRfr7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, _isArrayLikeJsDefault.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
exports.default = createBaseEach;

},{"./isArrayLike.js":"7YvcL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jIv7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == "function" ? value : (0, _identityJsDefault.default);
}
exports.default = castFunction;

},{"./identity.js":"9TWzV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"42SOf":[function(require,module,exports) {
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});

},{}],"9EhD5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatch", ()=>Swatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _interaction = require("../../helpers/interaction");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var ENTER = 13;
var Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, _reactcssDefault.default)({
        default: {
            swatch: _extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, _reactDefault.default).createElement("div", _extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
exports.default = (0, _interaction.handleFocus)(Swatch);

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/interaction":"fXd1q","./Checkboard":"5BhlM","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fXd1q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleFocus", ()=>handleFocus);
/* eslint-disable no-invalid-this */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return (0, _reactDefault.default).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, _reactDefault.default).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, _reactDefault.default).Component);
};

},{"react":"cOWTg","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8QsUB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPointer", ()=>AlphaPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var AlphaPointer = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = AlphaPointer;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7esn7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Block", ()=>Block);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _blockSwatches = require("./BlockSwatches");
var _blockSwatchesDefault = parcelHelpers.interopDefault(_blockSwatches);
var Block = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var transparent = hex === "transparent";
    var handleChange = function handleChange(hexCode, e) {
        _color.isValidHex(hexCode) && onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                boxShadow: "0 1px rgba(0,0,0,.1)",
                borderRadius: "6px",
                position: "relative"
            },
            head: {
                height: "110px",
                background: hex,
                borderRadius: "6px 6px 0 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative"
            },
            body: {
                padding: "10px"
            },
            label: {
                fontSize: "18px",
                color: _color.getContrastingColor(hex),
                position: "relative"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 10px 10px 10px",
                borderColor: "transparent transparent " + hex + " transparent",
                position: "absolute",
                top: "-10px",
                left: "50%",
                marginLeft: "-10px"
            },
            input: {
                width: "100%",
                fontSize: "12px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "22px",
                boxShadow: "inset 0 0 0 1px #ddd",
                borderRadius: "4px",
                padding: "0 7px",
                boxSizing: "border-box"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide"
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "block-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.head
    }, transparent && (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        borderRadius: "6px 6px 0 0"
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.label
    }, hex)), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _reactDefault.default).createElement((0, _blockSwatchesDefault.default), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
Block.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        "top",
        "hide"
    ]),
    styles: (0, _propTypesDefault.default).object
};
Block.defaultProps = {
    width: 170,
    colors: [
        "#D9E3F0",
        "#F47373",
        "#697689",
        "#37D67A",
        "#2CCCE4",
        "#555555",
        "#dce775",
        "#ff8a65",
        "#ba68c8"
    ],
    triangle: "top",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Block);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","../../helpers/color":"adNd7","../common":"i0APu","./BlockSwatches":"67Ep6","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"67Ep6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockSwatches", ()=>BlockSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _common = require("../common");
var BlockSwatches = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatches: {
                marginRight: "-10px"
            },
            swatch: {
                width: "22px",
                height: "22px",
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "4px"
            },
            clear: {
                clear: "both"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    }));
};
exports.default = BlockSwatches;

},{"react":"cOWTg","reactcss":"itrAO","lodash-es/map":"gMilE","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gMilE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _baseIterateeJs = require("./_baseIteratee.js");
var _baseIterateeJsDefault = parcelHelpers.interopDefault(_baseIterateeJs);
var _baseMapJs = require("./_baseMap.js");
var _baseMapJsDefault = parcelHelpers.interopDefault(_baseMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayMapJsDefault.default) : (0, _baseMapJsDefault.default);
    return func(collection, (0, _baseIterateeJsDefault.default)(iteratee, 3));
}
exports.default = map;

},{"./_arrayMap.js":"bOWLx","./_baseIteratee.js":"8ZPc0","./_baseMap.js":"lr1Zs","./isArray.js":"a6xTq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bOWLx":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
exports.default = arrayMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8ZPc0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMatchesJs = require("./_baseMatches.js");
var _baseMatchesJsDefault = parcelHelpers.interopDefault(_baseMatchesJs);
var _baseMatchesPropertyJs = require("./_baseMatchesProperty.js");
var _baseMatchesPropertyJsDefault = parcelHelpers.interopDefault(_baseMatchesPropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, _identityJsDefault.default;
    if (typeof value == "object") return (0, _isArrayJsDefault.default)(value) ? (0, _baseMatchesPropertyJsDefault.default)(value[0], value[1]) : (0, _baseMatchesJsDefault.default)(value);
    return (0, _propertyJsDefault.default)(value);
}
exports.default = baseIteratee;

},{"./_baseMatches.js":"2gIoa","./_baseMatchesProperty.js":"2jgIK","./identity.js":"9TWzV","./isArray.js":"a6xTq","./property.js":"8YTzT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2gIoa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsMatchJs = require("./_baseIsMatch.js");
var _baseIsMatchJsDefault = parcelHelpers.interopDefault(_baseIsMatchJs);
var _getMatchDataJs = require("./_getMatchData.js");
var _getMatchDataJsDefault = parcelHelpers.interopDefault(_getMatchDataJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = (0, _getMatchDataJsDefault.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, _matchesStrictComparableJsDefault.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, _baseIsMatchJsDefault.default)(object, source, matchData);
    };
}
exports.default = baseMatches;

},{"./_baseIsMatch.js":"j2bUr","./_getMatchData.js":"bSdzU","./_matchesStrictComparable.js":"8qQ0W","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j2bUr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, _stackJsDefault.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
exports.default = baseIsMatch;

},{"./_Stack.js":"lnW1A","./_baseIsEqual.js":"7uEvo","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7uEvo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualDeepJs = require("./_baseIsEqualDeep.js");
var _baseIsEqualDeepJsDefault = parcelHelpers.interopDefault(_baseIsEqualDeepJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, _isObjectLikeJsDefault.default)(value) && !(0, _isObjectLikeJsDefault.default)(other)) return value !== value && other !== other;
    return (0, _baseIsEqualDeepJsDefault.default)(value, other, bitmask, customizer, baseIsEqual, stack);
}
exports.default = baseIsEqual;

},{"./_baseIsEqualDeep.js":"hAJMW","./isObjectLike.js":"cEf8u","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hAJMW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _equalByTagJs = require("./_equalByTag.js");
var _equalByTagJsDefault = parcelHelpers.interopDefault(_equalByTagJs);
var _equalObjectsJs = require("./_equalObjects.js");
var _equalObjectsJsDefault = parcelHelpers.interopDefault(_equalObjectsJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, _isArrayJsDefault.default)(object), othIsArr = (0, _isArrayJsDefault.default)(other), objTag = objIsArr ? arrayTag : (0, _getTagJsDefault.default)(object), othTag = othIsArr ? arrayTag : (0, _getTagJsDefault.default)(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, _isBufferJsDefault.default)(object)) {
        if (!(0, _isBufferJsDefault.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, _stackJsDefault.default));
        return objIsArr || (0, _isTypedArrayJsDefault.default)(object) ? (0, _equalArraysJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, _equalByTagJsDefault.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, _stackJsDefault.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, _stackJsDefault.default));
    return (0, _equalObjectsJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack);
}
exports.default = baseIsEqualDeep;

},{"./_Stack.js":"lnW1A","./_equalArrays.js":"gnx18","./_equalByTag.js":"6gsog","./_equalObjects.js":"35Ayy","./_getTag.js":"fjr02","./isArray.js":"a6xTq","./isBuffer.js":"3lQ8J","./isTypedArray.js":"8vntp","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gnx18":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setCacheJs = require("./_SetCache.js");
var _setCacheJsDefault = parcelHelpers.interopDefault(_setCacheJs);
var _arraySomeJs = require("./_arraySome.js");
var _arraySomeJsDefault = parcelHelpers.interopDefault(_arraySomeJs);
var _cacheHasJs = require("./_cacheHas.js");
var _cacheHasJsDefault = parcelHelpers.interopDefault(_cacheHasJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new (0, _setCacheJsDefault.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, _arraySomeJsDefault.default)(other, function(othValue, othIndex) {
                if (!(0, _cacheHasJsDefault.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
exports.default = equalArrays;

},{"./_SetCache.js":"cm4VI","./_arraySome.js":"johyR","./_cacheHas.js":"cU7EZ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cm4VI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
var _setCacheAddJs = require("./_setCacheAdd.js");
var _setCacheAddJsDefault = parcelHelpers.interopDefault(_setCacheAddJs);
var _setCacheHasJs = require("./_setCacheHas.js");
var _setCacheHasJsDefault = parcelHelpers.interopDefault(_setCacheHasJs);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, _mapCacheJsDefault.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = (0, _setCacheAddJsDefault.default);
SetCache.prototype.has = (0, _setCacheHasJsDefault.default);
exports.default = SetCache;

},{"./_MapCache.js":"b92s8","./_setCacheAdd.js":"ev76Y","./_setCacheHas.js":"1fSnR","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ev76Y":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
exports.default = setCacheAdd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1fSnR":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setCacheHas(value) {
    return this.__data__.has(value);
}
exports.default = setCacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"johyR":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
exports.default = arraySome;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cU7EZ":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function cacheHas(cache, key) {
    return cache.has(key);
}
exports.default = cacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6gsog":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _mapToArrayJs = require("./_mapToArray.js");
var _mapToArrayJsDefault = parcelHelpers.interopDefault(_mapToArrayJs);
var _setToArrayJs = require("./_setToArray.js");
var _setToArrayJsDefault = parcelHelpers.interopDefault(_setToArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, _uint8ArrayJsDefault.default)(object), new (0, _uint8ArrayJsDefault.default)(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, _eqJsDefault.default)(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = (0, _mapToArrayJsDefault.default);
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, _setToArrayJsDefault.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, _equalArraysJsDefault.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
exports.default = equalByTag;

},{"./_Symbol.js":"bn0qk","./_Uint8Array.js":"hAara","./eq.js":"hIG96","./_equalArrays.js":"gnx18","./_mapToArray.js":"kN0wM","./_setToArray.js":"itoZr","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kN0wM":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
exports.default = mapToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"itoZr":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
exports.default = setToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"35Ayy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getAllKeysJs = require("./_getAllKeys.js");
var _getAllKeysJsDefault = parcelHelpers.interopDefault(_getAllKeysJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = (0, _getAllKeysJsDefault.default)(object), objLength = objProps.length, othProps = (0, _getAllKeysJsDefault.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
exports.default = equalObjects;

},{"./_getAllKeys.js":"8lapm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8lapm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysJsDefault.default), (0, _getSymbolsJsDefault.default));
}
exports.default = getAllKeys;

},{"./_baseGetAllKeys.js":"h3gEW","./_getSymbols.js":"cCwvJ","./keys.js":"jsJjJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h3gEW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, _isArrayJsDefault.default)(object) ? result : (0, _arrayPushJsDefault.default)(result, symbolsFunc(object));
}
exports.default = baseGetAllKeys;

},{"./_arrayPush.js":"iUO5K","./isArray.js":"a6xTq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iUO5K":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
exports.default = arrayPush;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cCwvJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFilterJs = require("./_arrayFilter.js");
var _arrayFilterJsDefault = parcelHelpers.interopDefault(_arrayFilterJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, _arrayFilterJsDefault.default)(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
exports.default = getSymbols;

},{"./_arrayFilter.js":"jKqV4","./stubArray.js":"lUIxX","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jKqV4":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
exports.default = arrayFilter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lUIxX":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubArray() {
    return [];
}
exports.default = stubArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fjr02":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"aXm5l","./_Map.js":"gmih8","./_Promise.js":"34tJS","./_Set.js":"haAZR","./_WeakMap.js":"ek31V","./_baseGetTag.js":"5h2C9","./_toSource.js":"eLUxy","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"aXm5l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "DataView");
exports.default = DataView;

},{"./_getNative.js":"kqm6v","./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"34tJS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Promise");
exports.default = Promise;

},{"./_getNative.js":"kqm6v","./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"haAZR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "Set");
exports.default = Set;

},{"./_getNative.js":"kqm6v","./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ek31V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), "WeakMap");
exports.default = WeakMap;

},{"./_getNative.js":"kqm6v","./_root.js":"dgYbV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bSdzU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = (0, _keysJsDefault.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, _isStrictComparableJsDefault.default)(value)
        ];
    }
    return result;
}
exports.default = getMatchData;

},{"./_isStrictComparable.js":"jfmdz","./keys.js":"jsJjJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jfmdz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !(0, _isObjectJsDefault.default)(value);
}
exports.default = isStrictComparable;

},{"./isObject.js":"OCMWa","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8qQ0W":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
exports.default = matchesStrictComparable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2jgIK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
var _getJs = require("./get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if ((0, _isKeyJsDefault.default)(path) && (0, _isStrictComparableJsDefault.default)(srcValue)) return (0, _matchesStrictComparableJsDefault.default)((0, _toKeyJsDefault.default)(path), srcValue);
    return function(object) {
        var objValue = (0, _getJsDefault.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, _hasInJsDefault.default)(object, path) : (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
exports.default = baseMatchesProperty;

},{"./_baseIsEqual.js":"7uEvo","./get.js":"1iSnr","./hasIn.js":"iBeRx","./_isKey.js":"bIOTi","./_isStrictComparable.js":"jfmdz","./_matchesStrictComparable.js":"8qQ0W","./_toKey.js":"eGG43","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1iSnr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, _baseGetJsDefault.default)(object, path);
    return result === undefined ? defaultValue : result;
}
exports.default = get;

},{"./_baseGet.js":"9L3TK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9L3TK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, _toKeyJsDefault.default)(path[index++])];
    return index && index == length ? object : undefined;
}
exports.default = baseGet;

},{"./_castPath.js":"kWMjI","./_toKey.js":"eGG43","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kWMjI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _stringToPathJs = require("./_stringToPath.js");
var _stringToPathJsDefault = parcelHelpers.interopDefault(_stringToPathJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return value;
    return (0, _isKeyJsDefault.default)(value, object) ? [
        value
    ] : (0, _stringToPathJsDefault.default)((0, _toStringJsDefault.default)(value));
}
exports.default = castPath;

},{"./isArray.js":"a6xTq","./_isKey.js":"bIOTi","./_stringToPath.js":"kx7g3","./toString.js":"gjeYV","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bIOTi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, _isSymbolJsDefault.default)(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
exports.default = isKey;

},{"./isArray.js":"a6xTq","./isSymbol.js":"5BU5B","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"kx7g3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeCappedJs = require("./_memoizeCapped.js");
var _memoizeCappedJsDefault = parcelHelpers.interopDefault(_memoizeCappedJs);
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = (0, _memoizeCappedJsDefault.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
exports.default = stringToPath;

},{"./_memoizeCapped.js":"jNkXf","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"jNkXf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = (0, _memoizeJsDefault.default)(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
exports.default = memoizeCapped;

},{"./memoize.js":"hR4ro","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hR4ro":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"b92s8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"gjeYV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseToStringJs = require("./_baseToString.js");
var _baseToStringJsDefault = parcelHelpers.interopDefault(_baseToStringJs);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : (0, _baseToStringJsDefault.default)(value);
}
exports.default = toString;

},{"./_baseToString.js":"lgQYk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lgQYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, _isArrayJsDefault.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMapJsDefault.default)(value, baseToString) + "";
    if ((0, _isSymbolJsDefault.default)(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = baseToString;

},{"./_Symbol.js":"bn0qk","./_arrayMap.js":"bOWLx","./isArray.js":"a6xTq","./isSymbol.js":"5BU5B","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eGG43":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || (0, _isSymbolJsDefault.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
exports.default = toKey;

},{"./isSymbol.js":"5BU5B","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iBeRx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseHasInJs = require("./_baseHasIn.js");
var _baseHasInJsDefault = parcelHelpers.interopDefault(_baseHasInJs);
var _hasPathJs = require("./_hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && (0, _hasPathJsDefault.default)(object, path, (0, _baseHasInJsDefault.default));
}
exports.default = hasIn;

},{"./_baseHasIn.js":"6yr5d","./_hasPath.js":"eTdGd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6yr5d":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
exports.default = baseHasIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eTdGd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, _toKeyJsDefault.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, _isLengthJsDefault.default)(length) && (0, _isIndexJsDefault.default)(key, length) && ((0, _isArrayJsDefault.default)(object) || (0, _isArgumentsJsDefault.default)(object));
}
exports.default = hasPath;

},{"./_castPath.js":"kWMjI","./isArguments.js":"4wZvJ","./isArray.js":"a6xTq","./_isIndex.js":"3Qf8u","./isLength.js":"qxAio","./_toKey.js":"eGG43","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8YTzT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basePropertyJs = require("./_baseProperty.js");
var _basePropertyJsDefault = parcelHelpers.interopDefault(_basePropertyJs);
var _basePropertyDeepJs = require("./_basePropertyDeep.js");
var _basePropertyDeepJsDefault = parcelHelpers.interopDefault(_basePropertyDeepJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return (0, _isKeyJsDefault.default)(path) ? (0, _basePropertyJsDefault.default)((0, _toKeyJsDefault.default)(path)) : (0, _basePropertyDeepJsDefault.default)(path);
}
exports.default = property;

},{"./_baseProperty.js":"70Tfu","./_basePropertyDeep.js":"40ho8","./_isKey.js":"bIOTi","./_toKey.js":"eGG43","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"70Tfu":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
exports.default = baseProperty;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"40ho8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return (0, _baseGetJsDefault.default)(object, path);
    };
}
exports.default = basePropertyDeep;

},{"./_baseGet.js":"9L3TK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lr1Zs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = (0, _isArrayLikeJsDefault.default)(collection) ? Array(collection.length) : [];
    (0, _baseEachJsDefault.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
exports.default = baseMap;

},{"./_baseEach.js":"7KfXv","./isArrayLike.js":"7YvcL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"19NxW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", ()=>Circle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _circleSwatch = require("./CircleSwatch");
var _circleSwatchDefault = parcelHelpers.interopDefault(_circleSwatch);
var Circle = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                display: "flex",
                flexWrap: "wrap",
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "circle-picker " + className
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _circleSwatchDefault.default), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
Circle.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    circleSize: (0, _propTypesDefault.default).number,
    circleSpacing: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Circle.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        _materialColors.red["500"],
        _materialColors.pink["500"],
        _materialColors.purple["500"],
        _materialColors.deepPurple["500"],
        _materialColors.indigo["500"],
        _materialColors.blue["500"],
        _materialColors.lightBlue["500"],
        _materialColors.cyan["500"],
        _materialColors.teal["500"],
        _materialColors.green["500"],
        _materialColors.lightGreen["500"],
        _materialColors.lime["500"],
        _materialColors.yellow["500"],
        _materialColors.amber["500"],
        _materialColors.orange["500"],
        _materialColors.deepOrange["500"],
        _materialColors.brown["500"],
        _materialColors.blueGrey["500"]
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Circle);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/map":"gMilE","lodash-es/merge":"kd6oR","material-colors":"7qcW5","../common":"i0APu","./CircleSwatch":"04GsY","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7qcW5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "pink", ()=>pink);
parcelHelpers.export(exports, "purple", ()=>purple);
parcelHelpers.export(exports, "deepPurple", ()=>deepPurple);
parcelHelpers.export(exports, "indigo", ()=>indigo);
parcelHelpers.export(exports, "blue", ()=>blue);
parcelHelpers.export(exports, "lightBlue", ()=>lightBlue);
parcelHelpers.export(exports, "cyan", ()=>cyan);
parcelHelpers.export(exports, "teal", ()=>teal);
parcelHelpers.export(exports, "green", ()=>green);
parcelHelpers.export(exports, "lightGreen", ()=>lightGreen);
parcelHelpers.export(exports, "lime", ()=>lime);
parcelHelpers.export(exports, "yellow", ()=>yellow);
parcelHelpers.export(exports, "amber", ()=>amber);
parcelHelpers.export(exports, "orange", ()=>orange);
parcelHelpers.export(exports, "deepOrange", ()=>deepOrange);
parcelHelpers.export(exports, "brown", ()=>brown);
parcelHelpers.export(exports, "grey", ()=>grey);
parcelHelpers.export(exports, "blueGrey", ()=>blueGrey);
parcelHelpers.export(exports, "darkText", ()=>darkText);
parcelHelpers.export(exports, "lightText", ()=>lightText);
parcelHelpers.export(exports, "darkIcons", ()=>darkIcons);
parcelHelpers.export(exports, "lightIcons", ()=>lightIcons);
parcelHelpers.export(exports, "white", ()=>white);
parcelHelpers.export(exports, "black", ()=>black);
var red = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var pink = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var purple = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var deepPurple = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var indigo = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var blue = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var lightBlue = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var cyan = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var teal = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var green = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var lightGreen = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var lime = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var yellow = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var amber = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var orange = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var deepOrange = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var brown = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var grey = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var blueGrey = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var darkText = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var lightText = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var darkIcons = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var lightIcons = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var white = "#ffffff";
var black = "#000000";
exports.default = {
    red: red,
    pink: pink,
    purple: purple,
    deepPurple: deepPurple,
    indigo: indigo,
    blue: blue,
    lightBlue: lightBlue,
    cyan: cyan,
    teal: teal,
    green: green,
    lightGreen: lightGreen,
    lime: lime,
    yellow: yellow,
    amber: amber,
    orange: orange,
    deepOrange: deepOrange,
    brown: brown,
    grey: grey,
    blueGrey: blueGrey,
    darkText: darkText,
    lightText: lightText,
    darkIcons: darkIcons,
    lightIcons: lightIcons,
    white: white,
    black: black
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"04GsY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleSwatch", ()=>CircleSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CircleSwatch = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: "scale(1)",
                transition: "100ms transform ease"
            },
            Swatch: {
                borderRadius: "50%",
                background: "transparent",
                boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
                transition: "100ms box-shadow ease"
            }
        },
        "hover": {
            swatch: {
                transform: "scale(1.2)"
            }
        },
        "active": {
            Swatch: {
                boxShadow: "inset 0 0 0 3px " + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color
        }
    }));
};
CircleSwatch.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
exports.default = (0, _reactcss.handleHover)(CircleSwatch);

},{"react":"cOWTg","reactcss":"itrAO","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4OQf8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chrome", ()=>Chrome);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _chromeFields = require("./ChromeFields");
var _chromeFieldsDefault = parcelHelpers.interopDefault(_chromeFields);
var _chromePointer = require("./ChromePointer");
var _chromePointerDefault = parcelHelpers.interopDefault(_chromePointer);
var _chromePointerCircle = require("./ChromePointerCircle");
var _chromePointerCircleDefault = parcelHelpers.interopDefault(_chromePointerCircle);
var Chrome = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                borderRadius: "2px",
                boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
                boxSizing: "initial",
                fontFamily: "Menlo"
            },
            saturation: {
                width: "100%",
                paddingBottom: "55%",
                position: "relative",
                borderRadius: "2px 2px 0 0",
                overflow: "hidden"
            },
            Saturation: {
                radius: "2px 2px 0 0"
            },
            body: {
                padding: "16px 16px 12px"
            },
            controls: {
                display: "flex"
            },
            color: {
                width: "32px"
            },
            swatch: {
                marginTop: "6px",
                width: "16px",
                height: "16px",
                borderRadius: "8px",
                position: "relative",
                overflow: "hidden"
            },
            active: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "8px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
                zIndex: "2"
            },
            toggles: {
                flex: "1"
            },
            hue: {
                height: "10px",
                position: "relative",
                marginBottom: "8px"
            },
            Hue: {
                radius: "2px"
            },
            alpha: {
                height: "10px",
                position: "relative"
            },
            Alpha: {
                radius: "2px"
            }
        },
        "disableAlpha": {
            color: {
                width: "22px"
            },
            alpha: {
                display: "none"
            },
            hue: {
                marginBottom: "0px"
            },
            swatch: {
                width: "10px",
                height: "10px",
                marginTop: "0px"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "chrome-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _chromePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.color
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        renderers: renderers
    }))), (0, _reactDefault.default).createElement("div", {
        style: styles.toggles
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        renderers: renderers,
        onChange: onChange
    })))), (0, _reactDefault.default).createElement((0, _chromeFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
Chrome.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    disableAlpha: (0, _propTypesDefault.default).bool,
    styles: (0, _propTypesDefault.default).object,
    defaultView: (0, _propTypesDefault.default).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
Chrome.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Chrome);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","../common":"i0APu","./ChromeFields":"7REk5","./ChromePointer":"fSeYZ","./ChromePointerCircle":"iIE7N","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7REk5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromeFields", ()=>ChromeFields);
/* eslint-disable react/no-did-mount-set-state, no-param-reassign */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _isUndefined = require("lodash-es/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _common = require("../common");
var _unfoldMoreHorizontalIcon = require("@icons/material/UnfoldMoreHorizontalIcon");
var _unfoldMoreHorizontalIconDefault = parcelHelpers.interopDefault(_unfoldMoreHorizontalIcon);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
    _inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        _classCallCheck(this, ChromeFields);
        var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === "hex") _this.setState({
                view: "rgb"
            });
            else if (_this.state.view === "rgb") _this.setState({
                view: "hsl"
            });
            else if (_this.state.view === "hsl") {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: "hex"
                });
                else _this.setState({
                    view: "rgb"
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) _color.isValidHex(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: "hex"
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: "rgb"
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: "rgb"
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === "string" && data.s.includes("%")) data.s = data.s.replace("%", "");
                if (typeof data.l === "string" && data.l.includes("%")) data.l = data.l.replace("%", "");
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, _isUndefinedDefault.default)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, _isUndefinedDefault.default)(data.l) ? data.l : _this.props.hsl.l),
                    source: "hsl"
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = "#eee";
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = "transparent";
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    _createClass(ChromeFields, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    "default": {
                        wrap: {
                            paddingTop: "16px",
                            display: "flex"
                        },
                        fields: {
                            flex: "1",
                            display: "flex",
                            marginLeft: "-6px"
                        },
                        field: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        alpha: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        toggle: {
                            width: "32px",
                            textAlign: "right",
                            position: "relative"
                        },
                        icon: {
                            marginRight: "-4px",
                            marginTop: "12px",
                            cursor: "pointer",
                            position: "relative"
                        },
                        iconHighlight: {
                            position: "absolute",
                            width: "24px",
                            height: "28px",
                            background: "#eee",
                            borderRadius: "4px",
                            top: "10px",
                            left: "12px",
                            display: "none"
                        },
                        input: {
                            fontSize: "11px",
                            color: "#333",
                            width: "100%",
                            borderRadius: "2px",
                            border: "none",
                            boxShadow: "inset 0 0 0 1px #dadada",
                            height: "21px",
                            textAlign: "center"
                        },
                        label: {
                            textTransform: "uppercase",
                            fontSize: "11px",
                            lineHeight: "11px",
                            color: "#969696",
                            textAlign: "center",
                            display: "block",
                            marginTop: "12px"
                        },
                        svg: {
                            fill: "#333",
                            width: "24px",
                            height: "24px",
                            border: "1px transparent solid",
                            borderRadius: "5px"
                        }
                    },
                    "disableAlpha": {
                        alpha: {
                            display: "none"
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === "hex") fields = (0, _reactDefault.default).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "hex",
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "rgb") fields = (0, _reactDefault.default).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "r",
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "g",
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "b",
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "hsl") fields = (0, _reactDefault.default).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "h",
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "s",
                    value: Math.round(this.props.hsl.s * 100) + "%",
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "l",
                    value: Math.round(this.props.hsl.l * 100) + "%",
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.wrap,
                    className: "flexbox-fix"
                }, fields, (0, _reactDefault.default).createElement("div", {
                    style: styles.toggle
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, _reactDefault.default).createElement((0, _unfoldMoreHorizontalIconDefault.default), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === "hex") return {
                    view: "rgb"
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, _reactDefault.default).Component);
ChromeFields.defaultProps = {
    view: "hex"
};
exports.default = ChromeFields;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/color":"adNd7","lodash-es/isUndefined":"1apd1","../common":"i0APu","@icons/material/UnfoldMoreHorizontalIcon":"75Gf4","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1apd1":[function(require,module,exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isUndefined(value) {
    return value === undefined;
}
exports.default = isUndefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"75Gf4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("cab3160a8154bde");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return _react2.default.createElement("svg", _extends({
        viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
};

},{"cab3160a8154bde":"cOWTg"}],"fSeYZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointer", ()=>ChromePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointer = function ChromePointer() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                transform: "translate(-6px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = ChromePointer;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iIE7N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointerCircle", ()=>ChromePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointerCircle = function ChromePointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = ChromePointerCircle;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cgXib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compact", ()=>Compact);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _compactColor = require("./CompactColor");
var _compactColorDefault = parcelHelpers.interopDefault(_compactColor);
var _compactFields = require("./CompactFields");
var _compactFieldsDefault = parcelHelpers.interopDefault(_compactFields);
var Compact = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            Compact: {
                background: "#f6f6f6",
                radius: "4px"
            },
            compact: {
                paddingTop: "5px",
                paddingLeft: "5px",
                boxSizing: "initial",
                width: "240px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else onChange(data, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.compact,
        className: "compact-picker " + className
    }, (0, _reactDefault.default).createElement("div", null, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _compactColorDefault.default), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    })), (0, _reactDefault.default).createElement((0, _compactFieldsDefault.default), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
Compact.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Compact.defaultProps = {
    colors: [
        "#4D4D4D",
        "#999999",
        "#FFFFFF",
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#333333",
        "#808080",
        "#cccccc",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#666666",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Compact);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/map":"gMilE","lodash-es/merge":"kd6oR","../../helpers/color":"adNd7","../common":"i0APu","./CompactColor":"eBCpf","./CompactFields":"8Yup5","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eBCpf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactColor", ()=>CompactColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var CompactColor = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            color: {
                background: color,
                width: "15px",
                height: "15px",
                float: "left",
                marginRight: "5px",
                marginBottom: "5px",
                position: "relative",
                cursor: "pointer"
            },
            dot: {
                absolute: "5px 5px 5px 5px",
                background: _color.getContrastingColor(color),
                borderRadius: "50%",
                opacity: "0"
            }
        },
        "active": {
            dot: {
                opacity: "1"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            dot: {
                background: "#000"
            }
        },
        "transparent": {
            dot: {
                background: "#000"
            }
        }
    }, {
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.dot
    }));
};
exports.default = CompactColor;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/color":"adNd7","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8Yup5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactFields", ()=>CompactFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CompactFields = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            fields: {
                display: "flex",
                paddingBottom: "6px",
                paddingRight: "5px",
                position: "relative"
            },
            active: {
                position: "absolute",
                top: "6px",
                left: "5px",
                height: "9px",
                width: "9px",
                background: hex
            },
            HEXwrap: {
                flex: "6",
                position: "relative"
            },
            HEXinput: {
                width: "80%",
                padding: "0px",
                paddingLeft: "20%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            HEXlabel: {
                display: "none"
            },
            RGBwrap: {
                flex: "3",
                position: "relative"
            },
            RGBinput: {
                width: "70%",
                padding: "0px",
                paddingLeft: "30%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            RGBlabel: {
                position: "absolute",
                top: "3px",
                left: "0px",
                lineHeight: "16px",
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#999"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else onChange({
            hex: data.hex,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }));
};
exports.default = CompactFields;

},{"react":"cOWTg","reactcss":"itrAO","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9Mj7G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Github", ()=>Github);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _githubSwatch = require("./GithubSwatch");
var _githubSwatchDefault = parcelHelpers.interopDefault(_githubSwatch);
var Github = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                borderRadius: "4px",
                position: "relative",
                padding: "5px",
                display: "flex",
                flexWrap: "wrap"
            },
            triangle: {
                position: "absolute",
                border: "7px solid transparent",
                borderBottomColor: "#fff"
            },
            triangleShadow: {
                position: "absolute",
                border: "8px solid transparent",
                borderBottomColor: "rgba(0,0,0,0.15)"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-14px",
                left: "10px"
            },
            triangleShadow: {
                top: "-16px",
                left: "9px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-14px",
                right: "10px"
            },
            triangleShadow: {
                top: "-16px",
                right: "9px"
            }
        },
        "bottom-left-triangle": {
            triangle: {
                top: "35px",
                left: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                left: "9px",
                transform: "rotate(180deg)"
            }
        },
        "bottom-right-triangle": {
            triangle: {
                top: "35px",
                right: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                right: "9px",
                transform: "rotate(180deg)"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right",
        "bottom-left-triangle": triangle === "bottom-left",
        "bottom-right-triangle": triangle === "bottom-right"
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "github-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.triangle
    }), (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _githubSwatchDefault.default), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
Github.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        "hide",
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]),
    styles: (0, _propTypesDefault.default).object
};
Github.defaultProps = {
    width: 200,
    colors: [
        "#B80000",
        "#DB3E00",
        "#FCCB00",
        "#008B02",
        "#006B76",
        "#1273DE",
        "#004DCF",
        "#5300EB",
        "#EB9694",
        "#FAD0C3",
        "#FEF3BD",
        "#C1E1C5",
        "#BEDADC",
        "#C4DEF6",
        "#BED3F3",
        "#D4C4FB"
    ],
    triangle: "top-left",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Github);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/map":"gMilE","lodash-es/merge":"kd6oR","../common":"i0APu","./GithubSwatch":"3dlkB","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3dlkB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GithubSwatch", ()=>GithubSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var GithubSwatch = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
    };
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatch: {
                width: "25px",
                height: "25px",
                fontSize: "0"
            }
        },
        "hover": {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
exports.default = (0, _reactcss.handleHover)(GithubSwatch);

},{"react":"cOWTg","reactcss":"itrAO","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"b4bdB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HuePicker", ()=>HuePicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _huePointer = require("./HuePointer");
var _huePointerDefault = parcelHelpers.interopDefault(_huePointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var HuePicker = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "hue-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.Hue), _extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
HuePicker.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
HuePicker.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, _huePointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(HuePicker);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","../common":"i0APu","./HuePointer":"hZ4Hw","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hZ4Hw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cSei9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Material", ()=>Material);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Material = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            material: {
                width: "98px",
                height: "98px",
                padding: "16px",
                fontFamily: "Roboto"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "2px solid " + hex,
                outline: "none",
                height: "30px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "1px solid #eee",
                outline: "none",
                height: "30px"
            },
            RGBlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            split: {
                display: "flex",
                marginRight: "-10px",
                paddingTop: "11px"
            },
            third: {
                flex: "1",
                paddingRight: "10px"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        styles: passedStyles
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.material,
        className: "material-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.split,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    })))));
};
exports.default = (0, _common.ColorWrap)(Material);

},{"react":"cOWTg","reactcss":"itrAO","lodash-es/merge":"kd6oR","../../helpers/color":"adNd7","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dodgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Photoshop", ()=>Photoshop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _photoshopFields = require("./PhotoshopFields");
var _photoshopFieldsDefault = parcelHelpers.interopDefault(_photoshopFields);
var _photoshopPointerCircle = require("./PhotoshopPointerCircle");
var _photoshopPointerCircleDefault = parcelHelpers.interopDefault(_photoshopPointerCircle);
var _photoshopPointer = require("./PhotoshopPointer");
var _photoshopPointerDefault = parcelHelpers.interopDefault(_photoshopPointer);
var _photoshopButton = require("./PhotoshopButton");
var _photoshopButtonDefault = parcelHelpers.interopDefault(_photoshopButton);
var _photoshopPreviews = require("./PhotoshopPreviews");
var _photoshopPreviewsDefault = parcelHelpers.interopDefault(_photoshopPreviews);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
    _inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        _classCallCheck(this, Photoshop);
        var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    _createClass(Photoshop, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? "" : _props$className;
                var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
                    "default": {
                        picker: {
                            background: "#DCDCDC",
                            borderRadius: "4px",
                            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                            boxSizing: "initial",
                            width: "513px"
                        },
                        head: {
                            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                            borderBottom: "1px solid #B1B1B1",
                            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                            height: "23px",
                            lineHeight: "24px",
                            borderRadius: "4px 4px 0 0",
                            fontSize: "13px",
                            color: "#4D4D4D",
                            textAlign: "center"
                        },
                        body: {
                            padding: "15px 15px 0",
                            display: "flex"
                        },
                        saturation: {
                            width: "256px",
                            height: "256px",
                            position: "relative",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0",
                            overflow: "hidden"
                        },
                        hue: {
                            position: "relative",
                            height: "256px",
                            width: "19px",
                            marginLeft: "10px",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0"
                        },
                        controls: {
                            width: "180px",
                            marginLeft: "10px"
                        },
                        top: {
                            display: "flex"
                        },
                        previews: {
                            width: "60px"
                        },
                        actions: {
                            flex: "1",
                            marginLeft: "20px"
                        }
                    }
                }, passedStyles));
                return (0, _reactDefault.default).createElement("div", {
                    style: styles.picker,
                    className: "photoshop-picker " + className
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.head
                }, this.props.header), (0, _reactDefault.default).createElement("div", {
                    style: styles.body,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.saturation
                }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, _photoshopPointerCircleDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement((0, _common.Hue), {
                    direction: "vertical",
                    hsl: this.props.hsl,
                    pointer: (0, _photoshopPointerDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.controls
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.top,
                    className: "flexbox-fix"
                }, (0, _reactDefault.default).createElement("div", {
                    style: styles.previews
                }, (0, _reactDefault.default).createElement((0, _photoshopPreviewsDefault.default), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, _reactDefault.default).createElement("div", {
                    style: styles.actions
                }, (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: "OK",
                    onClick: this.props.onAccept,
                    active: true
                }), (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: "Cancel",
                    onClick: this.props.onCancel
                }), (0, _reactDefault.default).createElement((0, _photoshopFieldsDefault.default), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, _reactDefault.default).Component);
Photoshop.propTypes = {
    header: (0, _propTypesDefault.default).string,
    styles: (0, _propTypesDefault.default).object
};
Photoshop.defaultProps = {
    header: "Color Picker",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Photoshop);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","../common":"i0APu","./PhotoshopFields":"eZO5y","./PhotoshopPointerCircle":"eKXRz","./PhotoshopPointer":"bXIGu","./PhotoshopButton":"6ijUa","./PhotoshopPreviews":"9QBt1","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eZO5y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPicker", ()=>PhotoshopPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var PhotoshopPicker = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            fields: {
                paddingTop: "5px",
                paddingBottom: "9px",
                width: "80px",
                position: "relative"
            },
            divider: {
                height: "5px"
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                marginLeft: "40%",
                width: "40%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "5px",
                fontSize: "13px",
                paddingLeft: "3px",
                marginRight: "10px"
            },
            RGBlabel: {
                left: "0px",
                top: "0px",
                width: "34px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px",
                position: "absolute"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                marginLeft: "20%",
                width: "80%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "6px",
                fontSize: "13px",
                paddingLeft: "3px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "14px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px"
            },
            fieldSymbols: {
                position: "absolute",
                top: "5px",
                right: "-7px",
                fontSize: "13px"
            },
            symbol: {
                height: "20px",
                lineHeight: "22px",
                paddingBottom: "7px"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data["#"]) _color.isValidHex(data["#"]) && onChange({
            hex: data["#"],
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: "hsv"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.fields
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "h",
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "s",
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "v",
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "#",
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.fieldSymbols
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.symbol
    }, "\xb0"), (0, _reactDefault.default).createElement("div", {
        style: styles.symbol
    }, "%"), (0, _reactDefault.default).createElement("div", {
        style: styles.symbol
    }, "%")));
};
exports.default = PhotoshopPicker;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/color":"adNd7","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"eKXRz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        },
        "black-outline": {
            picker: {
                boxShadow: "inset 0 0 0 1px #000"
            }
        }
    }, {
        "black-outline": hsl.l > 0.5
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = PhotoshopPointerCircle;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"bXIGu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "4px 0 4px 6px",
                borderColor: "transparent transparent transparent #fff",
                position: "absolute",
                top: "1px",
                left: "1px"
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "5px 0 5px 8px",
                borderColor: "transparent transparent transparent #555"
            },
            left: {
                Extend: "triangleBorder",
                transform: "translate(-13px, -4px)"
            },
            leftInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            },
            right: {
                Extend: "triangleBorder",
                transform: "translate(20px, -14px) rotate(180deg)"
            },
            rightInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.pointer
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.left
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.leftInside
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.right
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.rightInside
    })));
};
exports.default = PhotoshopPointerCircle;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6ijUa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopButton", ()=>PhotoshopButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopButton = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            button: {
                backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
                border: "1px solid #878787",
                borderRadius: "2px",
                height: "20px",
                boxShadow: "0 1px 0 0 #EAEAEA",
                fontSize: "14px",
                color: "#000",
                lineHeight: "20px",
                textAlign: "center",
                marginBottom: "10px",
                cursor: "pointer"
            }
        },
        "active": {
            button: {
                boxShadow: "0 0 0 1px #878787"
            }
        }
    }, {
        active: active
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
exports.default = PhotoshopButton;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9QBt1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPreviews", ()=>PhotoshopPreviews);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatches: {
                border: "1px solid #B3B3B3",
                borderBottom: "1px solid #F0F0F0",
                marginBottom: "2px",
                marginTop: "1px"
            },
            new: {
                height: "34px",
                background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
            },
            current: {
                height: "34px",
                background: currentColor,
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
            },
            label: {
                fontSize: "14px",
                color: "#000",
                textAlign: "center"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", null, (0, _reactDefault.default).createElement("div", {
        style: styles.label
    }, "new"), (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.new
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.current
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.label
    }, "current"));
};
exports.default = PhotoshopPreviews;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"j2nDA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sketch", ()=>Sketch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sketchFields = require("./SketchFields");
var _sketchFieldsDefault = parcelHelpers.interopDefault(_sketchFields);
var _sketchPresetColors = require("./SketchPresetColors");
var _sketchPresetColorsDefault = parcelHelpers.interopDefault(_sketchPresetColors);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Sketch = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": _extends({
            picker: {
                width: width,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, passedStyles),
        "disableAlpha": {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "sketch-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.sliders
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, _reactDefault.default).createElement("div", {
        style: styles.color
    }, (0, _reactDefault.default).createElement((0, _common.Checkboard), null), (0, _reactDefault.default).createElement("div", {
        style: styles.activeColor
    }))), (0, _reactDefault.default).createElement((0, _sketchFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, _reactDefault.default).createElement((0, _sketchPresetColorsDefault.default), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
Sketch.propTypes = {
    disableAlpha: (0, _propTypesDefault.default).bool,
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object
};
Sketch.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
};
exports.default = (0, _common.ColorWrap)(Sketch);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","../common":"i0APu","./SketchFields":"iLIaO","./SketchPresetColors":"hKfP8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"iLIaO":[function(require,module,exports) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchFields", ()=>SketchFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var SketchFields = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
exports.default = SketchFields;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/color":"adNd7","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hKfP8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchPresetColors", ()=>SketchPresetColors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var SketchPresetColors = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return (0, _reactDefault.default).createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, (0, _reactDefault.default).createElement((0, _common.Swatch), _extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
SketchPresetColors.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            color: (0, _propTypesDefault.default).string,
            title: (0, _propTypesDefault.default).string
        })
    ])).isRequired
};
exports.default = SketchPresetColors;

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4d8rR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sliderSwatches = require("./SliderSwatches");
var _sliderSwatchesDefault = parcelHelpers.interopDefault(_sliderSwatches);
var _sliderPointer = require("./SliderPointer");
var _sliderPointerDefault = parcelHelpers.interopDefault(_sliderPointer);
var Slider = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            hue: {
                height: "12px",
                position: "relative"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement("div", {
        style: styles.wrap || {},
        className: "slider-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchesDefault.default), {
        hsl: hsl,
        onClick: onChange
    })));
};
Slider.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
Slider.defaultProps = {
    pointer: (0, _sliderPointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Slider);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","../common":"i0APu","./SliderSwatches":"9LXRU","./SliderPointer":"3H39I","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9LXRU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatches", ()=>SliderSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _sliderSwatch = require("./SliderSwatch");
var _sliderSwatchDefault = parcelHelpers.interopDefault(_sliderSwatch);
var SliderSwatches = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatches: {
                marginTop: "20px"
            },
            swatch: {
                boxSizing: "border-box",
                width: "20%",
                paddingRight: "1px",
                float: "left"
            },
            clear: {
                clear: "both"
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    }));
};
exports.default = SliderSwatches;

},{"react":"cOWTg","reactcss":"itrAO","./SliderSwatch":"dyAmP","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dyAmP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatch", ()=>SliderSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderSwatch = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            swatch: {
                height: "12px",
                background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
                cursor: "pointer"
            }
        },
        "first": {
            swatch: {
                borderRadius: "2px 0 0 2px"
            }
        },
        "last": {
            swatch: {
                borderRadius: "0 2px 2px 0"
            }
        },
        "active": {
            swatch: {
                transform: "scaleY(1.8)",
                borderRadius: "3.6px/2px"
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: "hsl"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.swatch,
        onClick: handleClick
    });
};
exports.default = SliderSwatch;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3H39I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer() {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "14px",
                height: "14px",
                borderRadius: "6px",
                transform: "translate(-7px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"cOWTg","reactcss":"itrAO","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7go7N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatches", ()=>Swatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _swatchesGroup = require("./SwatchesGroup");
var _swatchesGroupDefault = parcelHelpers.interopDefault(_swatchesGroup);
var Swatches = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: "scroll"
            },
            body: {
                padding: "16px 0 6px 16px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "swatches-picker " + className
    }, (0, _reactDefault.default).createElement((0, _common.Raised), null, (0, _reactDefault.default).createElement("div", {
        style: styles.overflow
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(group) {
        return (0, _reactDefault.default).createElement((0, _swatchesGroupDefault.default), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    })))));
};
Swatches.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    height: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)),
    styles: (0, _propTypesDefault.default).object
};
Swatches.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            _materialColors.red["900"],
            _materialColors.red["700"],
            _materialColors.red["500"],
            _materialColors.red["300"],
            _materialColors.red["100"]
        ],
        [
            _materialColors.pink["900"],
            _materialColors.pink["700"],
            _materialColors.pink["500"],
            _materialColors.pink["300"],
            _materialColors.pink["100"]
        ],
        [
            _materialColors.purple["900"],
            _materialColors.purple["700"],
            _materialColors.purple["500"],
            _materialColors.purple["300"],
            _materialColors.purple["100"]
        ],
        [
            _materialColors.deepPurple["900"],
            _materialColors.deepPurple["700"],
            _materialColors.deepPurple["500"],
            _materialColors.deepPurple["300"],
            _materialColors.deepPurple["100"]
        ],
        [
            _materialColors.indigo["900"],
            _materialColors.indigo["700"],
            _materialColors.indigo["500"],
            _materialColors.indigo["300"],
            _materialColors.indigo["100"]
        ],
        [
            _materialColors.blue["900"],
            _materialColors.blue["700"],
            _materialColors.blue["500"],
            _materialColors.blue["300"],
            _materialColors.blue["100"]
        ],
        [
            _materialColors.lightBlue["900"],
            _materialColors.lightBlue["700"],
            _materialColors.lightBlue["500"],
            _materialColors.lightBlue["300"],
            _materialColors.lightBlue["100"]
        ],
        [
            _materialColors.cyan["900"],
            _materialColors.cyan["700"],
            _materialColors.cyan["500"],
            _materialColors.cyan["300"],
            _materialColors.cyan["100"]
        ],
        [
            _materialColors.teal["900"],
            _materialColors.teal["700"],
            _materialColors.teal["500"],
            _materialColors.teal["300"],
            _materialColors.teal["100"]
        ],
        [
            "#194D33",
            _materialColors.green["700"],
            _materialColors.green["500"],
            _materialColors.green["300"],
            _materialColors.green["100"]
        ],
        [
            _materialColors.lightGreen["900"],
            _materialColors.lightGreen["700"],
            _materialColors.lightGreen["500"],
            _materialColors.lightGreen["300"],
            _materialColors.lightGreen["100"]
        ],
        [
            _materialColors.lime["900"],
            _materialColors.lime["700"],
            _materialColors.lime["500"],
            _materialColors.lime["300"],
            _materialColors.lime["100"]
        ],
        [
            _materialColors.yellow["900"],
            _materialColors.yellow["700"],
            _materialColors.yellow["500"],
            _materialColors.yellow["300"],
            _materialColors.yellow["100"]
        ],
        [
            _materialColors.amber["900"],
            _materialColors.amber["700"],
            _materialColors.amber["500"],
            _materialColors.amber["300"],
            _materialColors.amber["100"]
        ],
        [
            _materialColors.orange["900"],
            _materialColors.orange["700"],
            _materialColors.orange["500"],
            _materialColors.orange["300"],
            _materialColors.orange["100"]
        ],
        [
            _materialColors.deepOrange["900"],
            _materialColors.deepOrange["700"],
            _materialColors.deepOrange["500"],
            _materialColors.deepOrange["300"],
            _materialColors.deepOrange["100"]
        ],
        [
            _materialColors.brown["900"],
            _materialColors.brown["700"],
            _materialColors.brown["500"],
            _materialColors.brown["300"],
            _materialColors.brown["100"]
        ],
        [
            _materialColors.blueGrey["900"],
            _materialColors.blueGrey["700"],
            _materialColors.blueGrey["500"],
            _materialColors.blueGrey["300"],
            _materialColors.blueGrey["100"]
        ],
        [
            "#000000",
            "#525252",
            "#969696",
            "#D9D9D9",
            "#FFFFFF"
        ]
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Swatches);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/map":"gMilE","lodash-es/merge":"kd6oR","material-colors":"7qcW5","../common":"i0APu","./SwatchesGroup":"6hnyq","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6hnyq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesGroup", ()=>SwatchesGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _swatchesColor = require("./SwatchesColor");
var _swatchesColorDefault = parcelHelpers.interopDefault(_swatchesColor);
var SwatchesGroup = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            group: {
                paddingBottom: "10px",
                width: "40px",
                float: "left",
                marginRight: "10px"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.group
    }, (0, _mapDefault.default)(group, function(color, i) {
        return (0, _reactDefault.default).createElement((0, _swatchesColorDefault.default), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
exports.default = SwatchesGroup;

},{"react":"cOWTg","reactcss":"itrAO","lodash-es/map":"gMilE","./SwatchesColor":"doizd","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"doizd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesColor", ()=>SwatchesColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var _checkIcon = require("@icons/material/CheckIcon");
var _checkIconDefault = parcelHelpers.interopDefault(_checkIcon);
var SwatchesColor = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        "default": {
            color: {
                width: "40px",
                height: "24px",
                cursor: "pointer",
                background: color,
                marginBottom: "1px"
            },
            check: {
                color: _color.getContrastingColor(color),
                marginLeft: "8px",
                display: "none"
            }
        },
        "first": {
            color: {
                overflow: "hidden",
                borderRadius: "2px 2px 0 0"
            }
        },
        "last": {
            color: {
                overflow: "hidden",
                borderRadius: "0 0 2px 2px"
            }
        },
        "active": {
            check: {
                display: "block"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            check: {
                color: "#333"
            }
        },
        "transparent": {
            check: {
                color: "#333"
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.check
    }, (0, _reactDefault.default).createElement((0, _checkIconDefault.default), null)));
};
exports.default = SwatchesColor;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/color":"adNd7","../common":"i0APu","@icons/material/CheckIcon":"1sNsT","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1sNsT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("b7292f2d749daff7");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return _react2.default.createElement("svg", _extends({
        viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};

},{"b7292f2d749daff7":"cOWTg"}],"eDiyN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Twitter", ()=>Twitter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Twitter = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "0 solid rgba(0,0,0,0.25)",
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                borderRadius: "4px",
                position: "relative"
            },
            body: {
                padding: "15px 9px 9px 15px"
            },
            label: {
                fontSize: "18px",
                color: "#fff"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent #fff transparent",
                position: "absolute"
            },
            triangleShadow: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
                position: "absolute"
            },
            hash: {
                background: "#F0F0F0",
                height: "30px",
                width: "30px",
                borderRadius: "4px 0 0 4px",
                float: "left",
                color: "#98A1A4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            input: {
                width: "100px",
                fontSize: "14px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "28px",
                boxShadow: "inset 0 0 0 1px #F0F0F0",
                boxSizing: "content-box",
                borderRadius: "0 4px 4px 0",
                float: "left",
                paddingLeft: "8px"
            },
            swatch: {
                width: "30px",
                height: "30px",
                float: "left",
                borderRadius: "4px",
                margin: "0 6px 6px 0"
            },
            clear: {
                clear: "both"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-10px",
                left: "12px"
            },
            triangleShadow: {
                top: "-11px",
                left: "12px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-10px",
                right: "12px"
            },
            triangleShadow: {
                top: "-11px",
                right: "12px"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right"
    });
    var handleChange = function handleChange(hexcode, e) {
        _color.isValidHex(hexcode) && onChange({
            hex: hexcode,
            source: "hex"
        }, e);
    };
    return (0, _reactDefault.default).createElement("div", {
        style: styles.card,
        className: "twitter-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(c, i) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.hash
    }, "#"), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.clear
    })));
};
Twitter.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    triangle: (0, _propTypesDefault.default).oneOf([
        "hide",
        "top-left",
        "top-right"
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Twitter.defaultProps = {
    width: 276,
    colors: [
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ],
    triangle: "top-left",
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Twitter);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/map":"gMilE","lodash-es/merge":"kd6oR","../../helpers/color":"adNd7","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cWytM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Google", ()=>Google);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _googlePointerCircle = require("./GooglePointerCircle");
var _googlePointerCircleDefault = parcelHelpers.interopDefault(_googlePointerCircle);
var _googlePointer = require("./GooglePointer");
var _googlePointerDefault = parcelHelpers.interopDefault(_googlePointer);
var _googleFields = require("./GoogleFields");
var _googleFieldsDefault = parcelHelpers.interopDefault(_googleFields);
var Google = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                border: "1px solid #dfe1e5",
                boxSizing: "initial",
                display: "flex",
                flexWrap: "wrap",
                borderRadius: "8px 8px 0px 0px"
            },
            head: {
                height: "57px",
                width: "100%",
                paddingTop: "16px",
                paddingBottom: "16px",
                paddingLeft: "16px",
                fontSize: "20px",
                boxSizing: "border-box",
                fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
            },
            saturation: {
                width: "70%",
                padding: "0px",
                position: "relative",
                overflow: "hidden"
            },
            swatch: {
                width: "30%",
                height: "228px",
                padding: "0px",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
                position: "relative",
                overflow: "hidden"
            },
            body: {
                margin: "auto",
                width: "95%"
            },
            controls: {
                display: "flex",
                boxSizing: "border-box",
                height: "52px",
                paddingTop: "22px"
            },
            color: {
                width: "32px"
            },
            hue: {
                height: "8px",
                position: "relative",
                margin: "0px 16px 0px 16px",
                width: "100%"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker,
        className: "google-picker " + className
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.head
    }, header), (0, _reactDefault.default).createElement("div", {
        style: styles.swatch
    }), (0, _reactDefault.default).createElement("div", {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _googlePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.body
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        radius: "4px",
        pointer: (0, _googlePointerDefault.default),
        onChange: onChange
    }))), (0, _reactDefault.default).createElement((0, _googleFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
Google.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object,
    header: (0, _propTypesDefault.default).string
};
Google.defaultProps = {
    width: 652,
    styles: {},
    header: "Color picker"
};
exports.default = (0, _common.ColorWrap)(Google);

},{"react":"cOWTg","prop-types":"jc0Wl","reactcss":"itrAO","lodash-es/merge":"kd6oR","../common":"i0APu","./GooglePointerCircle":"f1gJq","./GooglePointer":"2oLId","./GoogleFields":"3SVNk","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"f1gJq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointerCircle", ()=>GooglePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointerCircle = function GooglePointerCircle(props) {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                border: "2px #fff solid",
                transform: "translate(-12px, -13px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
GooglePointerCircle.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointerCircle.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointerCircle;

},{"react":"cOWTg","reactcss":"itrAO","prop-types":"jc0Wl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"2oLId":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointer", ()=>GooglePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointer = function GooglePointer(props) {
    var styles = (0, _reactcssDefault.default)({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                transform: "translate(-10px, -7px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
                border: "2px white solid"
            }
        }
    });
    return (0, _reactDefault.default).createElement("div", {
        style: styles.picker
    });
};
GooglePointer.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointer.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointer;

},{"react":"cOWTg","reactcss":"itrAO","prop-types":"jc0Wl","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"3SVNk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleFields", ()=>GoogleFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var GoogleFields = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(",");
            _color.isvalidColorString(data.rgb, "rgb") && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: "rgb"
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(",");
            if (_color.isvalidColorString(data.hsv, "hsv")) {
                _values[2] = _values[2].replace("%", "");
                _values[1] = _values[1].replace("%", "");
                _values[0] = _values[0].replace("\xb0", "");
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: "hsv"
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(",");
            if (_color.isvalidColorString(data.hsl, "hsl")) {
                _values2[2] = _values2[2].replace("%", "");
                _values2[1] = _values2[1].replace("%", "");
                _values2[0] = _values2[0].replace("\xb0", "");
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: "hsl"
                }, e);
            }
        }
    };
    var styles = (0, _reactcssDefault.default)({
        "default": {
            wrap: {
                display: "flex",
                height: "100px",
                marginTop: "4px"
            },
            fields: {
                width: "100%"
            },
            column: {
                paddingTop: "10px",
                display: "flex",
                justifyContent: "space-between"
            },
            double: {
                padding: "0px 4.4px",
                boxSizing: "border-box"
            },
            input: {
                width: "100%",
                height: "38px",
                boxSizing: "border-box",
                padding: "4px 10% 3px",
                textAlign: "center",
                border: "1px solid #dadce0",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            input2: {
                height: "38px",
                width: "100%",
                border: "1px solid #dadce0",
                boxSizing: "border-box",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                paddingLeft: "10px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label: {
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "35px",
                top: "-6px",
                left: "0",
                right: "0",
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label2: {
                left: "10px",
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "32px",
                top: "-6px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            single: {
                flexGrow: "1",
                margin: "0px 4.4px"
            }
        }
    });
    var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
    var hslValue = Math.round(hsl.h) + "\xb0, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
    var hsvValue = Math.round(hsv.h) + "\xb0, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
    return (0, _reactDefault.default).createElement("div", {
        style: styles.wrap,
        className: "flexbox-fix"
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.fields
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.column
    }, (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "rgb",
        value: rgbValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsv",
        value: hsvValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement("div", {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsl",
        value: hslValue,
        onChange: handleChange
    })))));
};
exports.default = GoogleFields;

},{"react":"cOWTg","reactcss":"itrAO","../../helpers/color":"adNd7","../common":"i0APu","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"i9deo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _dataTableCellChild = require("../../components/DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSettingsPage = require("../../hooks/useSettingsPage");
var _useSettingsPageDefault = parcelHelpers.interopDefault(_useSettingsPage);
const SettingsTagsSkeleton = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    (0, _useSettingsPageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("tags.page.title"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            disabled: true,
            children: f("tags.modal.title.add-tag")
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.VerticalStack), {
            gap: "4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                    columnContentTypes: [
                        "text",
                        "numeric"
                    ],
                    headings: [
                        f("table.column.name"),
                        ""
                    ],
                    rows: Array(4).fill([
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                            lines: 1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                            width: "10%",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                lines: 1
                            })
                        })
                    ])
                })
            })
        })
    });
};
exports.default = SettingsTagsSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../components/AddButton/AddButton":"WJGEt","../../components/DataTableCellChild/DataTableCellChild":"boueG","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSettingsPage":"j0i19","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6AsjY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _asyncPage = require("../../components/AsyncPage/AsyncPage");
var _condensedText = require("../../components/CondensedText/CondensedText");
var _condensedTextDefault = parcelHelpers.interopDefault(_condensedText);
var _dataTableCellChild = require("../../components/DataTableCellChild/DataTableCellChild");
var _dataTableCellChildDefault = parcelHelpers.interopDefault(_dataTableCellChild);
var _emailView = require("../../components/EmailView/EmailView");
var _emailViewDefault = parcelHelpers.interopDefault(_emailView);
var _errorPanel = require("../../components/ErrorPanel/ErrorPanel");
var _errorPanelDefault = parcelHelpers.interopDefault(_errorPanel);
var _rowHighlighter = require("../../components/extensions/RowHighlighter");
var _rowHighlighterDefault = parcelHelpers.interopDefault(_rowHighlighter);
var _filterContainer = require("../../components/FilterContainer/FilterContainer");
var _filterContainerDefault = parcelHelpers.interopDefault(_filterContainer);
var _popoverButton = require("../../components/PopoverButton/PopoverButton");
var _popoverButtonDefault = parcelHelpers.interopDefault(_popoverButton);
var _searchTextField = require("../../components/SearchTextField/SearchTextField");
var _searchTextFieldDefault = parcelHelpers.interopDefault(_searchTextField);
var _settingsPage = require("../../components/SettingsPage/SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _textHighlighter = require("../../components/TextHighlighter/TextHighlighter");
var _textHighlighterDefault = parcelHelpers.interopDefault(_textHighlighter);
var _durations = require("../../constants/durations");
var _permissions = require("../../constants/permissions");
var _queriesKeys = require("../../constants/queries-keys");
var _tables = require("../../constants/tables");
var _displayHelpers = require("../../helpers/display.helpers");
var _useDebouncedState = require("../../hooks/useDebouncedState");
var _useDebouncedStateDefault = parcelHelpers.interopDefault(_useDebouncedState);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useGetUsers = require("../../hooks/useGetUsers");
var _useGetUsersDefault = parcelHelpers.interopDefault(_useGetUsers);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _useQueryData = require("../../hooks/useQueryData");
var _useQueryDataDefault = parcelHelpers.interopDefault(_useQueryData);
var _useTranslateGroup = require("../../hooks/useTranslateGroup");
var _useTranslateGroupDefault = parcelHelpers.interopDefault(_useTranslateGroup);
var _useYesNo = require("../../hooks/useYesNo");
var _useYesNoDefault = parcelHelpers.interopDefault(_useYesNo);
var _stringUtils = require("../../utils/stringUtils");
var _util = require("../../utils/util");
var _settingsUsersSkeleton = require("./SettingsUsersSkeleton");
var _settingsUsersSkeletonDefault = parcelHelpers.interopDefault(_settingsUsersSkeleton);
const EMPTY_USER = {
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    is_active: true
};
const SettingsUsersPage = ({ data })=>{
    const [isModalOpen, toggleModalOpen, closeModal] = (0, _useOpenCloseDefault.default)();
    const [isShowingInactiveUsers, toggleShowInactiveUsers] = (0, _useOpenCloseDefault.default)();
    const [queryText, setQueryText, debouncedQueryValue] = (0, _useDebouncedStateDefault.default)("", (0, _durations.SETTINGS_SEARCH_DEBOUNCE_DELAY));
    const [currentUser, setCurrentUser] = (0, _react.useState)(EMPTY_USER);
    const [isReactivating, setReactivating] = (0, _react.useState)(false);
    const { updateQueryData } = (0, _useQueryDataDefault.default)([
        (0, _queriesKeys.QUERIES_KEYS).USERS
    ]);
    const yesNo = (0, _useYesNoDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const { getUserGroupsDisplayName, activeUsers } = (0, _useGetUsersDefault.default)();
    const getGroupName = (0, _useTranslateGroupDefault.default)();
    const readonly = !isPermittedTo((0, _permissions.PERMISSIONS_TYPES).ADMIN_USER);
    const saveUserMutation = (0, _reactQuery.useMutation)(({ first_name, last_name, email, groups, is_active })=>{
        return currentUser.id ? (0, _apiDefault.default).updateUser(currentUser.id, {
            first_name,
            last_name,
            email,
            groups,
            is_active
        }) : (0, _apiDefault.default).createUser({
            first_name,
            last_name,
            email,
            groups
        });
    }, {
        onSuccess: (updatedUser)=>{
            updateQueryData((queryData)=>{
                if (currentUser.id) // update existing user
                queryData.users = queryData.users.map((currentUser)=>currentUser.id === updatedUser.id ? updatedUser : currentUser);
                else // add new user
                queryData.users = [
                    updatedUser,
                    ...queryData.users
                ];
            });
            closeAndClearModal();
        }
    });
    const groups = data.groups || [];
    const users = (0, _react.useMemo)(()=>{
        return (isShowingInactiveUsers ? data.users : activeUsers).filter((user)=>(0, _stringUtils.isEmptyString)(debouncedQueryValue) || (0, _displayHelpers.getFullName)(user).toLocaleLowerCase().includes(debouncedQueryValue.toLocaleLowerCase()));
    }, [
        debouncedQueryValue,
        isShowingInactiveUsers,
        data.users
    ]);
    const inactiveUsersCount = (0, _react.useMemo)(()=>data.users.filter((user)=>!user.is_active && (0, _displayHelpers.getFullName)(user).toLocaleLowerCase().includes(debouncedQueryValue.toLocaleLowerCase())).length, [
        data.users,
        debouncedQueryValue
    ]);
    const isSaving = saveUserMutation.isLoading;
    const adminGroup = groups.find((group)=>group.role_key === "KDK_ADMIN");
    const rolesNames = adminGroup?.name ? [
        adminGroup?.name
    ] : [];
    const adminUsers = (0, _react.useMemo)(()=>adminGroup?.id ? activeUsers.filter((user)=>user.groups?.includes(adminGroup.id)) : [], [
        data.users
    ]);
    const handleUpdate = (value, property)=>{
        if (property === "email") saveUserMutation.reset();
        setCurrentUser({
            ...currentUser,
            [property]: value
        });
    };
    const activateUser = (isActive)=>{
        setReactivating(true);
        currentUser.is_active = isActive;
        saveUserMutation.mutate(currentUser, {
            onSuccess: ()=>setReactivating(false)
        });
    };
    const saveUser = ()=>saveUserMutation.mutate(currentUser);
    const closeAndClearModal = ()=>{
        closeModal();
        setCurrentUser(EMPTY_USER);
        saveUserMutation.reset();
    };
    const editUser = readonly ? (0, _util.noop) : (user)=>{
        setCurrentUser(user);
        toggleModalOpen();
    };
    const isNewUser = !currentUser.id;
    const modalTitle = isNewUser ? f("users.modal.title.add-user") : f("users.modal.title.update-user");
    const emailServerError = saveUserMutation.error?.data?.email && saveUserMutation.error.data.email.length > 0 ? saveUserMutation.error.data.email[0] : undefined;
    const filterUsersLabel = isShowingInactiveUsers ? f("users.page.filter.hide-inactive-users", {
        count: inactiveUsersCount
    }) : f("users.page.filter.show-inactive-users", {
        count: inactiveUsersCount
    });
    const cancelAction = {
        content: f("default.cancel"),
        onAction: closeAndClearModal,
        disabled: isSaving
    };
    const saveAction = {
        content: f("default.save"),
        onAction: saveUser,
        loading: isSaving && !isReactivating,
        disabled: isReactivating || !(0, _stringUtils.isEmail)(currentUser.email) || !currentUser.first_name || !currentUser.last_name
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _settingsPageDefault.default), {
        permissions: (0, _permissions.PERMISSIONS_TYPES).ADMIN_USER,
        overrideRoleNames: rolesNames,
        title: f("users.page.title"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            onClick: toggleModalOpen,
            disabled: readonly,
            children: f("users.page.add-user.button-label")
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterContainerDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchTextFieldDefault.default), {
                    placeholder: f("users.page.filter.placeholder"),
                    value: queryText,
                    clearButton: true,
                    labelHidden: true,
                    onChange: setQueryText,
                    onClearButtonClick: ()=>setQueryText("")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Card), {
                children: [
                    users.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.EmptyState), {
                        heading: f("users.page.table.empty"),
                        image: ""
                    }),
                    users.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                        increasedTableDensity: true,
                        columnContentTypes: [
                            "text",
                            "text",
                            "text",
                            "text"
                        ],
                        headings: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _condensedTextDefault.default), {
                                children: f("table.column.name")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                children: [
                                    " ",
                                    f("table.column.email")
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                children: [
                                    " ",
                                    f("table.column.groups")
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _condensedTextDefault.default), {
                                children: [
                                    " ",
                                    f("table.column.active")
                                ]
                            })
                        ],
                        rows: users.map((user)=>[
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dataTableCellChildDefault.default), {
                                    width: (0, _tables.USER_NAME_COLUMN_WIDTH),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rowHighlighterDefault.default), {
                                        subdued: !user.is_active,
                                        clickable: !readonly,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textHighlighterDefault.default), {
                                            searchWords: [
                                                queryText
                                            ],
                                            textToHighlight: (0, _displayHelpers.getFullName)(user),
                                            onClick: ()=>editUser(user)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    onClick: ()=>editUser(user),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailViewDefault.default), {
                                        children: user.email || ""
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledGroupsCell, {
                                    onClick: ()=>editUser(user),
                                    children: getUserGroupsDisplayName(user)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledActiveTableCell, {
                                    onClick: ()=>editUser(user),
                                    children: yesNo(user.is_active)
                                })
                            ])
                    })
                ]
            }),
            inactiveUsersCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    onClick: toggleShowInactiveUsers,
                    disclosure: isShowingInactiveUsers ? "up" : "down",
                    children: filterUsersLabel
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal), {
                title: modalTitle,
                open: isModalOpen,
                onClose: closeAndClearModal,
                primaryAction: saveAction,
                secondaryActions: [
                    cancelAction
                ],
                footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Button), {
                    disabled: !currentUser.id || isSaving,
                    destructive: true,
                    loading: isSaving && isReactivating,
                    onClick: ()=>activateUser(!currentUser.is_active),
                    children: currentUser.is_active ? f("users.modal.label.deactivate") : f("users.modal.label.activate")
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Modal).Section, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                        gap: "4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.FormLayout), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.FormLayout).Group, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                            autoFocus: true,
                                            label: f("common.labels.first_name"),
                                            value: currentUser.first_name,
                                            placeholder: f("common.labels.first_name"),
                                            disabled: isSaving,
                                            onChange: (value)=>handleUpdate(value, "first_name"),
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                            label: f("common.labels.last_name"),
                                            value: currentUser.last_name,
                                            placeholder: f("common.labels.last_name"),
                                            disabled: isSaving,
                                            onChange: (value)=>handleUpdate(value, "last_name"),
                                            autoComplete: "off"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TextField), {
                                label: f("common.labels.email"),
                                value: currentUser.email,
                                type: "email",
                                placeholder: f("email.placeholder.text"),
                                disabled: isSaving,
                                error: currentUser.email && !(0, _stringUtils.isEmail)(currentUser.email) ? f("email.invalid.address.error") : emailServerError,
                                onChange: (value)=>handleUpdate(value, "email"),
                                autoComplete: "off"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
                                gap: "1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                                        variant: "bodyMd",
                                        as: "span",
                                        children: f("common.labels.groups")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverButtonDefault.default), {
                                        disabled: isSaving,
                                        textAlign: "left",
                                        useCaret: true,
                                        fullWidth: false,
                                        label: !currentUser.groups || currentUser.groups.length === 0 ? f("users.modal.empty-group") : getUserGroupsDisplayName(currentUser),
                                        render: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.OptionList), {
                                                allowMultiple: true,
                                                title: f("common.labels.groups"),
                                                selected: (currentUser.groups || []).map((id)=>`${id}`),
                                                options: groups.map((group)=>({
                                                        label: getGroupName(group),
                                                        value: `${group.id}`,
                                                        disabled: group.id === adminGroup?.id && adminUsers.length === 1
                                                    })),
                                                onChange: (selected)=>{
                                                    handleUpdate(selected.map((idString)=>Number(idString)), "groups");
                                                }
                                            })
                                    })
                                ]
                            }),
                            saveUserMutation.isError && !emailServerError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorPanelDefault.default), {
                                message: saveUserMutation.error
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const StyledActiveTableCell = (0, _styledComponentsDefault.default)((0, _dataTableCellChildDefault.default))`
  // set a minimum width to the Active column cell in order to have a padding on the column header
  min-width: 4ch;
`;
const StyledGroupsCell = (0, _styledComponentsDefault.default).div`
  white-space: normal;
`;
exports.default = (0, _asyncPage.withAsyncPage)(SettingsUsersPage, {
    queryKey: (0, _queriesKeys.QUERIES_KEYS).USERS,
    apiFunction: (0, _apiDefault.default).getAllUsersAndGroups,
    paramNames: [],
    skeleton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsUsersSkeletonDefault.default), {})
});

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../components/AddButton/AddButton":"WJGEt","../../components/AsyncPage/AsyncPage":"1i0FH","../../components/CondensedText/CondensedText":"1FshD","../../components/DataTableCellChild/DataTableCellChild":"boueG","../../components/EmailView/EmailView":"6hcVY","../../components/ErrorPanel/ErrorPanel":"2hHqH","../../components/extensions/RowHighlighter":"9EbPr","../../components/FilterContainer/FilterContainer":"5kkHv","../../components/PopoverButton/PopoverButton":"ihB8F","../../components/SearchTextField/SearchTextField":"k5bRy","../../components/SettingsPage/SettingsPage":"gJDHL","../../components/TextHighlighter/TextHighlighter":"43Xhz","../../constants/durations":"5sjIW","../../constants/permissions":"jhCn5","../../constants/queries-keys":"6hYSF","../../constants/tables":"01ORG","../../helpers/display.helpers":"2q3xY","../../hooks/useDebouncedState":"lKEJK","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useGetUsers":"c83Pg","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../hooks/useQueryData":"4laI9","../../hooks/useTranslateGroup":"b4II6","../../hooks/useYesNo":"dfOzB","../../utils/stringUtils":"4gVdA","../../utils/util":"4MniK","./SettingsUsersSkeleton":"g9gqH","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g9gqH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _addButton = require("../../components/AddButton/AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _button = require("../../components/extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useSettingsPage = require("../../hooks/useSettingsPage");
var _useSettingsPageDefault = parcelHelpers.interopDefault(_useSettingsPage);
var _util = require("../../utils/util");
const SettingsUsersSkeleton = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    (0, _useSettingsPageDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Page), {
        title: f("users.page.title"),
        primaryAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonDefault.default), {
            disabled: true,
            children: f("default.add")
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
            gap: "4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Filters), {
                        filters: [],
                        queryValue: "",
                        onQueryChange: (0, _util.noop),
                        onQueryClear: (0, _util.noop),
                        onClearAll: (0, _util.noop),
                        queryPlaceholder: f("users.page.filter.placeholder"),
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Card), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.DataTable), {
                        columnContentTypes: [
                            "text",
                            "text",
                            "text",
                            "text"
                        ],
                        headings: [
                            f("table.column.name"),
                            f("table.column.email"),
                            f("table.column.groups"),
                            f("table.column.active")
                        ],
                        rows: Array(4).fill([
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                lines: 1
                            }, 1),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                lines: 1
                            }, 2),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                lines: 1
                            }, 3),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.SkeletonBodyText), {
                                lines: 1
                            }, 4)
                        ])
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    disabled: true,
                    children: f("users.page.filter.show-inactive-users")
                })
            ]
        })
    });
};
exports.default = SettingsUsersSkeleton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../components/AddButton/AddButton":"WJGEt","../../components/extensions/Button":"8exc0","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useSettingsPage":"j0i19","../../utils/util":"4MniK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"hchhm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _accessDenied = require("../../pages/AccessDenied");
var _accessDeniedDefault = parcelHelpers.interopDefault(_accessDenied);
var _collectionUtils = require("../../utils/collectionUtils");
const RequireAuth = (props)=>{
    const { requiredFeatures = [], children } = props;
    const { isAuthenticated } = (0, _useAuthDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    const hasRequiredFeatures = requiredFeatures.some((feature)=>features[feature]);
    // if the user is authenticated and doesn't have the required features for this route (if exists)
    // then return AccessDenied page
    if (isAuthenticated && (0, _collectionUtils.hasContent)(requiredFeatures) && !hasRequiredFeatures) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accessDeniedDefault.default), {});
    return /*#__PURE__*/ (0, _reactDefault.default).isValidElement(children) ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    });
};
exports.default = RequireAuth; /***************************************
 * 🚨🚨🚨🚨 wrapping RequireAuth with withAuthenticationRequired
 * will cause an infinite loop when trying to login
 * this is an Auth0 issue caused when configuring it with refresh tokens
 ***************************************/  // export default withAuthenticationRequired(RequireAuth, {
 //   returnTo: () => `${window.location.pathname}${window.location.search}${window.location.hash}`,
 // });

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useAuth":"k9r0q","../../hooks/useFeatures":"hvBWb","../../pages/AccessDenied":"5b6Vh","../../utils/collectionUtils":"gr5mc","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ysHSv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
var _sessionState = require("../../constants/session-state");
var _useClearLastWindowLocationSearch = require("../../hooks/useClearLastWindowLocationSearch");
var _useClearLastWindowLocationSearchDefault = parcelHelpers.interopDefault(_useClearLastWindowLocationSearch);
const RedirectToCustomersList = ()=>{
    const clearLastWindowLocationSearch = (0, _useClearLastWindowLocationSearchDefault.default)((0, _sessionState.CUSTOMERS_LIST_SEARCH));
    clearLastWindowLocationSearch();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
        to: (0, _routes.ROUTES).CUSTOMERS
    });
};
exports.default = RedirectToCustomersList;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../../constants/routes":"ihtm8","../../constants/session-state":"g0N7C","../../hooks/useClearLastWindowLocationSearch":"6FkWL","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"h6cF9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _kdkLogoSvg = require("../../../../assets/images/kdk-logo.svg");
var _kdkLogoSvgDefault = parcelHelpers.interopDefault(_kdkLogoSvg);
var _routes = require("../../../constants/routes");
var _styles = require("../../../constants/styles");
var _useNavigationToolbar = require("../../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
var _onboardingToolbar = require("../../OnboardingToolbar/OnboardingToolbar");
var _onboardingToolbarDefault = parcelHelpers.interopDefault(_onboardingToolbar);
var _settingsButton = require("../../SettingsButton/SettingsButton");
var _settingsButtonDefault = parcelHelpers.interopDefault(_settingsButton);
var _userMenu = require("../../UserMenu/UserMenu");
var _userMenuDefault = parcelHelpers.interopDefault(_userMenu);
var _statusMessage = require("./StatusMessage/StatusMessage");
var _statusMessageDefault = parcelHelpers.interopDefault(_statusMessage);
var _mainToolbar = require("./MainToolbar");
var _mainToolbarDefault = parcelHelpers.interopDefault(_mainToolbar);
const NavigationToolbar = ()=>{
    const { onboardingType, onboardingStepIndex } = (0, _useNavigationToolbarDefault.default)();
    const isOnboardingWizard = onboardingType !== undefined;
    const isMainMenu = onboardingStepIndex < 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.VerticalStack), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusMessageDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledNavigationToolbar, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _polaris.Stack), {
                    alignment: "fill",
                    wrap: false,
                    spacing: "none",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Link), {
                            url: (0, _routes.ROUTES).HOME,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLogo, {
                                src: (0, _kdkLogoSvgDefault.default)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Stack).Item, {
                            fill: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMainButtons, {
                                children: [
                                    isMainMenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainToolbarDefault.default), {}),
                                    isOnboardingWizard && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingToolbarDefault.default), {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSecondaryButtons, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsButtonDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userMenuDefault.default), {})
                    ]
                })
            })
        ]
    });
};
const StyledNavigationToolbar = (0, _styledComponentsDefault.default).div`
  height: var(--kdk-toolbar-height);
  display: flex;
  max-width: 100vw;

  & > * {
    flex: 1;
  }

  background-color: var(--p-surface);
`;
const StyledLogo = (0, _styledComponentsDefault.default).img`
  height: var(--kdk-toolbar-height);
  padding: var(--p-space-2);
`;
const StyledMainButtons = (0, _styledComponentsDefault.default).div`
  padding: 0 var(--p-space-12);
  height: 100%;

  // For small viewports - remove paddings and margins to compact main toolbar
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    padding: 0;
    --pc-stack-spacing: var(--p-space-1);

    .Polaris-Stack.Polaris-Stack--spacingExtraLoose {
      --pc-stack-spacing: var(--p-space-1);
    }
  }
`;
const StyledSecondaryButtons = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-auto-flow: column;
  place-items: center;
  height: 100%;
  gap: var(--p-space-4);
  margin-right: var(--p-space-2);

  > * + * {
    border-right: var(--p-border-divider);
    border-left: var(--p-border-divider);
  }

  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    display: none;
  }
`;
exports.default = NavigationToolbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/images/kdk-logo.svg":"8zURd","../../../constants/routes":"ihtm8","../../../constants/styles":"dZWds","../../../hooks/useNavigationToolbar":"gd2EG","../../OnboardingToolbar/OnboardingToolbar":"iBR2P","../../SettingsButton/SettingsButton":"4aYaP","../../UserMenu/UserMenu":"9kq2v","./StatusMessage/StatusMessage":"eF6ER","./MainToolbar":"dLU4Q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"8zURd":[function(require,module,exports) {
module.exports = require("ea3bb65a6a19e62").getBundleURL("kEMsi") + "kdk-logo.96cc0459.svg";

},{"ea3bb65a6a19e62":"75UoR"}],"iBR2P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useNavigationToolbar = require("../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
var _onboardingWizardToolbar = require("./OnboardingWizardToolbar");
var _onboardingWizardToolbarDefault = parcelHelpers.interopDefault(_onboardingWizardToolbar);
var _oneStepOnboardingToolbar = require("./OneStepOnboardingToolbar");
var _oneStepOnboardingToolbarDefault = parcelHelpers.interopDefault(_oneStepOnboardingToolbar);
const OnboardingToolbar = ()=>{
    const { onboardingType } = (0, _useNavigationToolbarDefault.default)();
    const isOneStepOnboarding = onboardingType === "person";
    if (isOneStepOnboarding) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _oneStepOnboardingToolbarDefault.default), {});
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingWizardToolbarDefault.default), {});
};
exports.default = OnboardingToolbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../../hooks/useNavigationToolbar":"gd2EG","./OnboardingWizardToolbar":"fdKkW","./OneStepOnboardingToolbar":"6lHpC","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"fdKkW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _reactQuery = require("@tanstack/react-query");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _routes = require("../../constants/routes");
var _integrationHelpers = require("../../helpers/integration.helpers");
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useNavigationToolbar = require("../../hooks/useNavigationToolbar");
var _useNavigationToolbarDefault = parcelHelpers.interopDefault(_useNavigationToolbar);
var _utilities = require("../../types/utilities");
var _hideOnMobile = require("../HideOnMobile/HideOnMobile");
var _hideOnMobileDefault = parcelHelpers.interopDefault(_hideOnMobile);
var _showOnMobile = require("../ShowOnMobile/ShowOnMobile");
var _showOnMobileDefault = parcelHelpers.interopDefault(_showOnMobile);
var _cancelOnboardingMenu = require("./CancelOnboardingMenu");
var _cancelOnboardingMenuDefault = parcelHelpers.interopDefault(_cancelOnboardingMenu);
var _onboardingWizardMenu = require("./OnboardingWizardMenu");
var _onboardingWizardMenuDefault = parcelHelpers.interopDefault(_onboardingWizardMenu);
const ToolbarItem = ({ disabled, onClick, isPast, isActive, children })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledToolbarItem, {
        onClick: onClick,
        isActive: isActive,
        disabled: disabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
            as: "span",
            fontWeight: isActive || isPast ? "semibold" : undefined,
            color: !isActive && !isPast ? "subdued" : undefined,
            children: children
        })
    });
};
const OnboardingWizardToolbar = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const features = (0, _useFeaturesDefault.default)();
    const createdFromProjectId = history.location.state?.createdFromProject?.id;
    const redirectURLAfterClose = createdFromProjectId ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
        id: createdFromProjectId
    }) : (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMERS);
    const { id: customerId, onboardingType, onboardingStepIndex, goToStep } = (0, _useNavigationToolbarDefault.default)();
    // fetch customer details to check if they belong to a vitec project
    const { isLoading, data: customer } = (0, _reactQuery.useQuery)((0, _utilities.getCustomerQueryKey)({
        id: customerId,
        type: "company"
    }), ()=>(0, _apiDefault.default).getCompanyCustomerDetails(customerId), {
        enabled: customerId !== undefined
    });
    // do not allow to cancel onboarding if the customer belongs to a vitec project
    const allowCancelOnboarding = !isLoading && customer?.projects?.find((0, _integrationHelpers.isVitecProject)) === undefined;
    // add tab title for assignment wizard step after the screening step
    const assignmentStepLabel = features.ATTACHMENTS ? f("onboarding.bar.company.assignments-and-attachments.title") : f("onboarding.bar.company.assignments.title");
    const menuItems = {
        person: [],
        "company-wizard": [
            f("onboarding.bar.company.screening.title"),
            assignmentStepLabel,
            f("onboarding.bar.company.disclosures.title"),
            f("onboarding.bar.company.summary.title")
        ].filter(Boolean),
        "manual-company-wizard": [
            f("onboarding.bar.manual-company.information.title"),
            f("onboarding.bar.company.screening.title"),
            assignmentStepLabel,
            f("onboarding.bar.company.disclosures.title"),
            f("onboarding.bar.company.summary.title")
        ].filter(Boolean)
    };
    if (!onboardingType) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledToolbarWrapper, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hideOnMobileDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.HorizontalStack), {
                    blockAlign: "center",
                    align: "center",
                    wrap: false,
                    children: menuItems[onboardingType].map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolbarItem, {
                            disabled: index >= onboardingStepIndex,
                            onClick: ()=>goToStep(index),
                            isPast: index < onboardingStepIndex,
                            isActive: onboardingStepIndex === index,
                            children: `${index + 1}. ${item}`
                        }, item))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _showOnMobileDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingWizardMenuDefault.default), {
                    menuItems: menuItems,
                    onboardingType: onboardingType,
                    onboardingStepIndex: onboardingStepIndex,
                    goToStep: goToStep
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelOnboardingMenuDefault.default), {
                customer: customer,
                allowCancelOnboarding: allowCancelOnboarding,
                onClose: ()=>history.push(redirectURLAfterClose)
            })
        ]
    });
};
const StyledToolbarWrapper = (0, _styledComponentsDefault.default).div`
  height: 100%;
  margin: 0 var(--p-space-4);

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;
`;
const StyledToolbarItem = (0, _styledComponentsDefault.default).div`
  userselect: none;
  cursor: pointer;
  padding: 0 var(--p-space-4);
  height: var(--kdk-toolbar-height);
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  min-width: max-content;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    height: var(--p-border-width-4);
    width: 100%;
    background-color: ${(props)=>props.isActive ? "var(--kdk-blue-600)" : "transparent"};
  }

  &:hover {
    background-color: ${({ onClick })=>onClick ? "var(--p-surface-hovered)" : undefined};
  }

  &:active {
    background-color: ${({ onClick })=>onClick ? "var(--p-surface-pressed)" : undefined};
  }
  ${(props)=>props.disabled && `
      cursor: default;
      pointer-events: none;

      &:hover {
        background-color: inherit;
      }
  `}
`;
exports.default = OnboardingWizardToolbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","@tanstack/react-query":"91Vyq","styled-components":"eBrdC","../../api":"f6lXD","../../constants/routes":"ihtm8","../../helpers/integration.helpers":"keU9B","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useNavigationToolbar":"gd2EG","../../types/utilities":"6zLpB","../HideOnMobile/HideOnMobile":"fcHQN","../ShowOnMobile/ShowOnMobile":"fzlW0","./CancelOnboardingMenu":"cUA41","./OnboardingWizardMenu":"dy1HK","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"cUA41":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _clockSvg = require("../../../assets/icons/clock.svg");
var _clockSvgDefault = parcelHelpers.interopDefault(_clockSvg);
var _trashSvg = require("../../../assets/icons/trash.svg");
var _trashSvgDefault = parcelHelpers.interopDefault(_trashSvg);
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _routes = require("../../constants/routes");
var _displayHelpers = require("../../helpers/display.helpers");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
var _confirmAction = require("../ConfirmAction/ConfirmAction");
var _confirmActionDefault = parcelHelpers.interopDefault(_confirmAction);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const CancelOnboardingMenu = (props)=>{
    const { customer, allowCancelOnboarding, onClose } = props;
    const [showCancelConfirm, toggleCancelConfirm] = (0, _useOpenCloseDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const location = (0, _reactRouterDom.useLocation)();
    const canCancelOnboarding = allowCancelOnboarding && customer !== undefined;
    const isPersonOnboarding = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: [
            (0, _routes.ROUTES).ONBOARDING_SAVED_PERSON,
            (0, _routes.ROUTES).ONBOARDING_NEW_PERSON
        ]
    }) !== null;
    const items = isPersonOnboarding ? [
        {
            content: f("default.cancel"),
            onAction: onClose
        }
    ] : [
        {
            content: f("onboarding.cancel.and.save"),
            onAction: onClose,
            prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _clockSvgDefault.default),
                useMask: true
            }),
            disabled: !customer
        },
        {
            content: f("onboarding.cancel.and.delete"),
            onAction: canCancelOnboarding ? toggleCancelConfirm : onClose,
            prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                source: (0, _trashSvgDefault.default),
                useMask: true
            })
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
                items: items,
                hideIcon: true,
                title: f("onboarding.cancel.onboarding"),
                disclosure: "down",
                size: "medium",
                forceOpen: showCancelConfirm
            }),
            showCancelConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _confirmActionDefault.default), {
                apiCall: ()=>(0, _apiDefault.default).cancelOnboarding(customer.id),
                title: f("onboarding.cancel.confirm.title"),
                description: f("onboarding.cancel.confirm.description", {
                    name: (0, _displayHelpers.getCustomerName)(customer)
                }),
                actionTitle: f("onboarding.cancel.and.delete"),
                onNo: toggleCancelConfirm,
                onSuccess: onClose
            })
        ]
    });
};
exports.default = CancelOnboardingMenu;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../../../assets/icons/clock.svg":"2a5U1","../../../assets/icons/trash.svg":"jqW55","../../api":"f6lXD","../../constants/routes":"ihtm8","../../helpers/display.helpers":"2q3xY","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../ActionsDropdown/ActionsDropdown":"izRYG","../ConfirmAction/ConfirmAction":"icP5J","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dy1HK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionsDropdown = require("../ActionsDropdown/ActionsDropdown");
var _actionsDropdownDefault = parcelHelpers.interopDefault(_actionsDropdown);
const OnboardingWizardMenu = (props)=>{
    const { menuItems, onboardingType, onboardingStepIndex, goToStep } = props;
    const currentMenuLabel = menuItems[onboardingType][onboardingStepIndex];
    const items = menuItems[onboardingType].map((item, index)=>({
            disabled: index > onboardingStepIndex,
            onClick: ()=>goToStep(index),
            content: item,
            active: onboardingStepIndex === index
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionsDropdownDefault.default), {
        items: items,
        hideIcon: true,
        title: currentMenuLabel,
        size: "medium",
        // plain
        monochrome: true,
        disclosure: true,
        removeUnderline: true
    });
};
exports.default = OnboardingWizardMenu;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","../ActionsDropdown/ActionsDropdown":"izRYG","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"6lHpC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _routes = require("../../constants/routes");
var _styles = require("../../constants/styles");
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const OneStepOnboardingToolbar = ()=>{
    const f = (0, _useFormatMessageDefault.default)();
    const history = (0, _reactRouterDom.useHistory)();
    const createdFromProjectId = history.location.state?.createdFromProject?.id;
    const redirectURLAfterClose = createdFromProjectId ? (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).PROJECT_DETAILS, {
        id: createdFromProjectId
    }) : (0, _reactRouterDom.generatePath)((0, _routes.ROUTES).CUSTOMERS);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledToolbar, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                variant: "headingMd",
                as: "h2",
                children: f("onboarding.new.person.title")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                onClick: ()=>history.push(redirectURLAfterClose),
                children: f("default.cancel")
            })
        ]
    });
};
const StyledToolbar = (0, _styledComponentsDefault.default).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  // For small viewports - reduce heading line height
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    & > .Polaris-Heading {
      line-height: var(--p-font-line-height-2);
    }
  }
`;
exports.default = OneStepOnboardingToolbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../constants/routes":"ihtm8","../../constants/styles":"dZWds","../../hooks/useFormatMessage":"8Y8fq","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"4aYaP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _gearSvg = require("../../../assets/icons/gear.svg");
var _gearSvgDefault = parcelHelpers.interopDefault(_gearSvg);
var _useSettingsItems = require("../../hooks/useSettingsItems");
var _useSettingsItemsDefault = parcelHelpers.interopDefault(_useSettingsItems);
var _stringUtils = require("../../utils/stringUtils");
var _button = require("../extensions/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const SettingsButton = ()=>{
    const settingsSections = (0, _useSettingsItemsDefault.default)();
    const firstSettingsPage = settingsSections.find((section)=>section.items.length > 0)?.items.find((item)=>!(0, _stringUtils.isEmptyString)(item.url))?.url || "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
        icon: (0, _gearSvgDefault.default),
        url: firstSettingsPage,
        round: true
    });
};
const StyledButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  & > .Polaris-Button {
    padding: 0;
    box-shadow: none;

    & img {
      width: 26px;
      height: 26px;
    }
  }

  height: 100%;

  display: grid;
  place-items: center;

  padding: 0 var(--p-space-3);
`;
exports.default = SettingsButton;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","styled-components":"eBrdC","../../../assets/icons/gear.svg":"765LR","../../hooks/useSettingsItems":"k0lrv","../../utils/stringUtils":"4gVdA","../extensions/Button":"8exc0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"9kq2v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _polaris = require("@shopify/polaris");
var _arrowRightOffsetCircleSvg = require("../../../assets/icons/arrow-right-offset-circle.svg");
var _arrowRightOffsetCircleSvgDefault = parcelHelpers.interopDefault(_arrowRightOffsetCircleSvg);
var _emailSvg = require("../../../assets/icons/email.svg");
var _emailSvgDefault = parcelHelpers.interopDefault(_emailSvg);
var _importCompanySvg = require("../../../assets/icons/import-company.svg");
var _importCompanySvgDefault = parcelHelpers.interopDefault(_importCompanySvg);
var _externalUrls = require("../../constants/external-urls");
var _permissions = require("../../constants/permissions");
var _routes = require("../../constants/routes");
var _displayHelpers = require("../../helpers/display.helpers");
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
var _useFormatMessage = require("../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useOpenClose = require("../../hooks/useOpenClose");
var _useOpenCloseDefault = parcelHelpers.interopDefault(_useOpenClose);
var _usePermissions = require("../../hooks/usePermissions");
var _usePermissionsDefault = parcelHelpers.interopDefault(_usePermissions);
var _languageProvider = require("../../providers/LanguageProvider");
var _country = require("../Country/Country");
var _countryDefault = parcelHelpers.interopDefault(_country);
var _icon = require("../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const UserMenu = ()=>{
    const features = (0, _useFeaturesDefault.default)();
    const { isPermittedTo } = (0, _usePermissionsDefault.default)();
    const f = (0, _useFormatMessageDefault.default)();
    const [language, setLanguage] = (0, _react.useContext)((0, _languageProvider.LanguageContext));
    const { logout, user } = (0, _useAuthDefault.default)();
    const [isUserMenuOpen, toggleUserMenu] = (0, _useOpenCloseDefault.default)();
    const openSupportEmail = ()=>window.location.href = `mailto:${0, _externalUrls.SUPPORT_EMAIL}`;
    const actions = [];
    const userMenuItems = [];
    userMenuItems.push({
        content: f("menu.support-email"),
        prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _emailSvgDefault.default)
        }),
        onAction: openSupportEmail
    });
    if (features.IMPORT_WIZARD && isPermittedTo((0, _permissions.PERMISSIONS_TYPES).ADMIN_USER)) userMenuItems.push({
        content: f("menu.import.companies"),
        image: (0, _importCompanySvgDefault.default),
        url: (0, _routes.ROUTES).IMPORT_CUSTOMERS
    });
    userMenuItems.push({
        content: language === "en" ? f("menu.language.english") : f("menu.language.norwegian"),
        prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countryDefault.default), {
            country: language === "en" ? "US" : "NO",
            hideLabel: true
        }),
        onAction: ()=>setLanguage(language === "en" ? "nb" : "en")
    });
    userMenuItems.push({
        content: f("menu.logout"),
        prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
            source: (0, _arrowRightOffsetCircleSvgDefault.default)
        }),
        onAction: ()=>logout()
    });
    actions.push({
        items: userMenuItems
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.TopBar).UserMenu, {
        actions: actions,
        name: (0, _displayHelpers.getFullName)(user),
        open: isUserMenuOpen,
        onToggle: toggleUserMenu,
        initials: ""
    });
};
exports.default = UserMenu;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../../assets/icons/arrow-right-offset-circle.svg":"fayaE","../../../assets/icons/email.svg":"bKu0l","../../../assets/icons/import-company.svg":"g33dQ","../../constants/external-urls":"bvBLe","../../constants/permissions":"jhCn5","../../constants/routes":"ihtm8","../../helpers/display.helpers":"2q3xY","../../hooks/useAuth":"k9r0q","../../hooks/useFeatures":"hvBWb","../../hooks/useFormatMessage":"8Y8fq","../../hooks/useOpenClose":"idooG","../../hooks/usePermissions":"4CdYX","../../providers/LanguageProvider":"iHLZe","../Country/Country":"eeWSc","../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"g33dQ":[function(require,module,exports) {
module.exports = require("8b41ecf3a55c84f6").getBundleURL("kEMsi") + "import-company.89454a7a.svg";

},{"8b41ecf3a55c84f6":"75UoR"}],"eF6ER":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _markdownContent = require("../../../MarkdownContent/MarkdownContent");
var _markdownContentDefault = parcelHelpers.interopDefault(_markdownContent);
var _useStatusMessage = require("./useStatusMessage");
var _useStatusMessageDefault = parcelHelpers.interopDefault(_useStatusMessage);
const SERVER_SEVERITY_TO_BANNER_SEVERITY_MAP = {
    INFO: "info",
    WARNING: "warning",
    CRITICAL: "critical"
};
const StatusMessage = ()=>{
    const wrapperRef = (0, _react.useRef)(null);
    const { showBanner, statusMessage } = (0, _useStatusMessageDefault.default)();
    (0, _react.useEffect)(()=>{
        const messageOffset = showBanner && wrapperRef.current ? `${wrapperRef.current.getBoundingClientRect().height}px` : "0px";
        // if showBanner is true, set Polaris top padding to match the new toolbar height --kdk-message-offset
        document.documentElement.style.setProperty("--kdk-message-offset", messageOffset);
    }, [
        showBanner,
        wrapperRef.current
    ]);
    if (!showBanner || !statusMessage) return null;
    const { message, severity } = statusMessage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBannerWrapper, {
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Banner), {
            status: SERVER_SEVERITY_TO_BANNER_SEVERITY_MAP[severity],
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownContentDefault.default), {
                content: message
            })
        })
    });
};
const StyledBannerWrapper = (0, _styledComponentsDefault.default).div`
  & .Polaris-Banner {
    padding: 0.875rem;
    justify-content: center;
    border-radius: 0;
    border-right: none;
    border-left: none;
  }

  & .Polaris-Banner__ContentWrapper {
    flex: 0 1 auto;
  }

  & .Polaris-Text--headingMd {
    font-weight: var(--p-font-weight-regular);
  }
`;
exports.default = StatusMessage;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../MarkdownContent/MarkdownContent":"cPR47","./useStatusMessage":"ixQMJ","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"ixQMJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../../../constants/queries-keys");
var _routes = require("../../../../constants/routes");
var _useAuth = require("../../../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
const POLLING_INTERVAL = 900000; // poll every 15 minutes
const useStatusMessage = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const { isAuthenticated } = (0, _useAuthDefault.default)();
    const isInExpiredOrAccessDeniedPage = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: [
            (0, _routes.ROUTES).EXPIRED,
            (0, _routes.ROUTES).ACCESS_DENIED
        ]
    }) !== null;
    const { data } = (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).STATUS_MESSAGE
    ], ()=>(0, _apiDefault.default).getStatusMessageList(), {
        enabled: isAuthenticated && !isInExpiredOrAccessDeniedPage,
        refetchInterval: POLLING_INTERVAL
    });
    // we currently only show the first message
    const statusMessage = data?.status_messages[0];
    const showBanner = statusMessage !== undefined;
    return {
        showBanner,
        statusMessage
    };
};
exports.default = useStatusMessage;

},{"react-router-dom":"1ee65","@tanstack/react-query":"91Vyq","../../../../api":"f6lXD","../../../../constants/queries-keys":"6hYSF","../../../../constants/routes":"ihtm8","../../../../hooks/useAuth":"k9r0q","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dLU4Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _companySvg = require("../../../../assets/icons/company.svg");
var _companySvgDefault = parcelHelpers.interopDefault(_companySvg);
var _dashboardSvg = require("../../../../assets/icons/dashboard.svg");
var _dashboardSvgDefault = parcelHelpers.interopDefault(_dashboardSvg);
var _folderSvg = require("../../../../assets/icons/folder.svg");
var _folderSvgDefault = parcelHelpers.interopDefault(_folderSvg);
var _routes = require("../../../constants/routes");
var _styles = require("../../../constants/styles");
var _useFormatMessage = require("../../../hooks/useFormatMessage");
var _useFormatMessageDefault = parcelHelpers.interopDefault(_useFormatMessage);
var _useProjectPermissions = require("../../../hooks/useProjectPermissions");
var _useProjectPermissionsDefault = parcelHelpers.interopDefault(_useProjectPermissions);
var _stringUtils = require("../../../utils/stringUtils");
var _icon = require("../../extensions/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const MainToolbar = ()=>{
    const history = (0, _reactRouterDom.useHistory)();
    const f = (0, _useFormatMessageDefault.default)();
    const { isProjectsEnabled } = (0, _useProjectPermissionsDefault.default)();
    const path = history.location.pathname;
    const showProjectsUpgradePlan = !isProjectsEnabled;
    const showProjectsLink = isProjectsEnabled || showProjectsUpgradePlan;
    const isOverviewActive = (0, _stringUtils.isEmptyString)(path) || (0, _reactRouterDom.matchPath)(path, {
        path: [
            (0, _routes.ROUTES).HOME,
            (0, _routes.ROUTES).CUSTOMERS
        ],
        exact: true
    }) !== null;
    const isProjectsLinkActive = showProjectsUpgradePlan ? !!(0, _reactRouterDom.matchPath)(path, (0, _routes.ROUTES).PLAN_UPGRADE_PROJECTS_LIST) : !!(0, _reactRouterDom.matchPath)(path, (0, _routes.ROUTES).PROJECTS_LIST);
    const isDashboardActive = !!(0, _reactRouterDom.matchPath)(path, (0, _routes.ROUTES).DASHBOARD);
    const handleProjectsLinkClick = ()=>history.push(showProjectsUpgradePlan ? (0, _routes.ROUTES).PLAN_UPGRADE_PROJECTS_LIST : (0, _routes.ROUTES).PROJECTS_LIST);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledToolbarWrapper, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMainToolbarLink, {
                isActive: isOverviewActive,
                onClick: ()=>history.push((0, _routes.ROUTES).CUSTOMERS),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _companySvgDefault.default),
                        useMask: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("nav-bar.overview")
                    })
                ]
            }),
            showProjectsLink && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMainToolbarLink, {
                isActive: isProjectsLinkActive,
                onClick: handleProjectsLinkClick,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _folderSvgDefault.default),
                        useMask: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("projects.page.title")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMainToolbarLink, {
                isActive: isDashboardActive,
                onClick: ()=>history.push((0, _routes.ROUTES).DASHBOARD),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        source: (0, _dashboardSvgDefault.default),
                        useMask: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Text), {
                        as: "span",
                        children: f("nav-bar.dashboard")
                    })
                ]
            })
        ]
    });
};
const StyledToolbarWrapper = (0, _styledComponentsDefault.default).div`
  display: flex;
  gap: var(--p-space-8);
  flex-wrap: nowrap;

  // For small viewports - reduce gap and set buttons width to be equal
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    gap: var(--p-space-1);

    & > * {
      flex: 1;
    }
  }
`;
const StyledMainToolbarLink = (0, _styledComponentsDefault.default).div`
  cursor: pointer;
  display: flex;
  height: var(--kdk-toolbar-height);
  align-items: center;
  justify-content: center;
  padding: 0 var(--p-space-4);
  gap: var(--p-space-1);

  color: ${(props)=>props.isActive ? "white" : "inherit"};
  background-color: ${(props)=>props.isActive ? "var(--kdk-red)" : "inherit"};

  ${({ isActive })=>!isActive && `
      &:hover {
        background-color: var(--p-surface-hovered);
      }
    
      &:active {
        background-color: var(--p-surface-pressed);
      }
  `}

  // For small viewports - remove paddings and change font size to compact main toolbar
  @media (max-width: ${(0, _styles.MOBILE_BREAKPOINT)}) {
    padding: 0 var(--p-space-1);
    font-size: var(--p-font-size-75);
    flex-direction: column;
    gap: 0;
  }
`;
exports.default = MainToolbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../../assets/icons/company.svg":"luBbc","../../../../assets/icons/dashboard.svg":"dfmqs","../../../../assets/icons/folder.svg":"b2aWC","../../../constants/routes":"ihtm8","../../../constants/styles":"dZWds","../../../hooks/useFormatMessage":"8Y8fq","../../../hooks/useProjectPermissions":"23Tgs","../../../utils/stringUtils":"4gVdA","../../extensions/Icon":"eHSf0","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"dfmqs":[function(require,module,exports) {
module.exports = require("a5ad5cb7666c4910").getBundleURL("kEMsi") + "dashboard.e7e739c3.svg";

},{"a5ad5cb7666c4910":"75UoR"}],"d1LgG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _polaris = require("@shopify/polaris");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _pageAnchors = require("../../../constants/page-anchors");
var _routes = require("../../../constants/routes");
var _usePageNavigation = require("../../../hooks/usePageNavigation");
var _usePageNavigationDefault = parcelHelpers.interopDefault(_usePageNavigation);
const isActive = (anchor)=>location.hash === `#${anchor}` || anchor === (0, _pageAnchors.PAGE_ANCHORS).TOP_SECTION && location.hash === "";
const PageNavigationMenu = ()=>{
    const location1 = (0, _reactRouterDom.useLocation)();
    const { showNavigationMenu, navigationSections, navigateInPage } = (0, _usePageNavigationDefault.default)();
    if (!showNavigationMenu) return null;
    const createItemProp = ({ url, anchor, label, disabled, options: { count, isNew, external } = {} })=>({
            url,
            onClick: anchor ? ()=>navigateInPage(anchor) : undefined,
            label,
            selected: anchor ? isActive(anchor) : (0, _reactRouterDom.matchPath)(location1.pathname, {
                path: url
            }) !== null,
            badge: count && count > 0 ? `${count}` : undefined,
            disabled,
            external,
            // in order to show new indicator in Polaris, we need to set a sub navigation item with a "new" property set to true
            subNavigationItems: isNew ? [
                {
                    url: "",
                    label: "",
                    new: true
                }
            ] : undefined
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Navigation), {
            location: (0, _routes.ROUTES).HOME,
            children: navigationSections.map(({ title, icon, items }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Navigation).Section, {
                    title: title,
                    icon: icon,
                    items: items.map(createItemProp)
                }, index))
        })
    });
};
const StyledWrapper = (0, _styledComponentsDefault.default).div`
  & .Polaris-Navigation {
    border-right: none;
    margin-top: calc(var(--kdk-message-offset) + var(--p-space-4));
  }

  & .Polaris-Navigation__SecondaryNavigation.Polaris-Navigation--isExpanded {
    display: none;
  }

  & .Polaris-Navigation__SectionHeading {
    padding-left: var(--p-space-5);

    & > .Polaris-Text--root {
      font-weight: var(--p-font-weight-bold);
      font-size: revert;
      color: var(--p-text);
    }
  }

  & .Polaris-Navigation__Item {
    font-weight: var(--p-font-weight-semibold);
  }
`;
exports.default = PageNavigationMenu;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","@shopify/polaris":"ek5a0","styled-components":"eBrdC","../../../constants/page-anchors":"4WmvA","../../../constants/routes":"ihtm8","../../../hooks/usePageNavigation":"1o5Hm","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"1rEwl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _routes = require("../../constants/routes");
const AdapterLink = (props)=>{
    const { url, children, external, download, target, ...rest } = props;
    const location = (0, _reactRouterDom.useLocation)();
    const htmlAnchorParams = rest;
    const fromMatchPage = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).MATCH_CASE_DETAILS
    }) !== null;
    const fromCustomerAssignmentDetails = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).ASSIGNMENT_DETAILS
    }) !== null;
    const fromCustomerReviewPage = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).CUSTOMER_REVIEW
    }) !== null;
    const fromCustomerReviewNewPage = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).CUSTOMER_REVIEW_NEW
    }) !== null;
    const fromCustomersList = !fromMatchPage && !fromCustomerAssignmentDetails && !fromCustomerReviewPage && !fromCustomerReviewNewPage && (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).CUSTOMERS
    }) !== null;
    const fromCustomerDetails = !fromMatchPage && (0, _reactRouterDom.matchPath)(location.pathname, {
        path: [
            (0, _routes.ROUTES).COMPANY_DETAILS,
            (0, _routes.ROUTES).PERSON_DETAILS
        ]
    }) !== null;
    const fromProjectsList = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).PROJECTS_LIST,
        exact: true
    }) !== null;
    const fromDashboard = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).DASHBOARD
    }) !== null;
    const isProjectPage = (0, _reactRouterDom.matchPath)(location.pathname, {
        path: (0, _routes.ROUTES).PROJECT_DETAILS
    }) !== null;
    // if link is generated from within the project details page
    // get the project id and project name from the current link state
    const createdFromProject = location.state?.createdFromProject;
    const fromProject = isProjectPage ? location.state?.fromProject : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: {
            pathname: url,
            state: {
                fromCustomerDetails,
                fromCustomersList,
                fromProjectsList,
                fromDashboard,
                createdFromProject,
                fromProject,
                fromCustomerAssignmentDetails
            }
        },
        download: download || rest.download,
        target: external ? "_blank" : target,
        ...htmlAnchorParams,
        children: children
    });
};
exports.default = AdapterLink;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-router-dom":"1ee65","../../constants/routes":"ihtm8","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"7Xe3D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHelmet = require("react-helmet");
var _reactQuery = require("@tanstack/react-query");
var _api = require("../../api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _queriesKeys = require("../../constants/queries-keys");
var _useAuth = require("../../hooks/useAuth");
var _useAuthDefault = parcelHelpers.interopDefault(_useAuth);
var _useFeatures = require("../../hooks/useFeatures");
var _useFeaturesDefault = parcelHelpers.interopDefault(_useFeatures);
/**
 * This setting must be set BEFORE loading Hubspot's live chat script (aka tracking script)
 * It prevents the live chat widget to load until window.HubSpotConversations.widget.load() is called
 * This is done in order to create a user identification token using Hubspot's API in beaufort-api
 * and set is before loading the live chat widget
 */ window.hsConversationsSettings = {
    loadImmediately: false
};
/**
 * Loads Hubspot's live chat script which will render a live chat widget in KDK
 *
 * Chat flows are defined in Hubspot (https://app.hubspot.com/chatflows/8006423/) and are rendered using
 * target rules (in which URLs should the chat flow be rendered).
 *
 * The chat flow for KDK is called "KDK chat" and it would be rendered only if the url starts with
 * https://app.test.kjenndinkunde.no/ or https://app.kjenndinkunde.no/
 */ const LiveChat = ()=>{
    const { isAuthenticated, user: currentUser } = (0, _useAuthDefault.default)();
    const features = (0, _useFeaturesDefault.default)();
    // do not try to fetch if the user is not authenticated and fetched
    const enabled = Boolean(features.HUBSPOT_LIVE_CHAT && isAuthenticated && currentUser !== undefined);
    (0, _reactQuery.useQuery)([
        (0, _queriesKeys.QUERIES_KEYS).HUBSPOT_LIVE_CHAT,
        currentUser?.id
    ], ()=>(0, _apiDefault.default).generateHubspotIdentificationToken({
            email: currentUser.email,
            first_name: currentUser.first_name,
            last_name: currentUser.last_name
        }), {
        enabled,
        staleTime: (0, _queriesKeys.STALE_TIME),
        onSuccess: ({ token })=>{
            window.hsConversationsSettings = {
                identificationEmail: currentUser?.email,
                identificationToken: token
            };
            // after setting the current user email and identification token - load the live chat widget
            window.HubSpotConversations?.widget?.load();
        }
    });
    // if the feature is not enabled do not even load the live chat widget
    if (!features.HUBSPOT_LIVE_CHAT) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmet.Helmet), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
            type: "text/javascript",
            id: "hs-script-loader",
            async: true,
            defer: true,
            src: "https://js.hs-scripts.com/8006423.js"
        })
    });
};
exports.default = LiveChat;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","react-helmet":"lt78C","@tanstack/react-query":"91Vyq","../../api":"f6lXD","../../constants/queries-keys":"6hYSF","../../hooks/useAuth":"k9r0q","../../hooks/useFeatures":"hvBWb","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"lt78C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helmet", ()=>HelmetExport);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSideEffect = require("react-side-effect");
var _reactSideEffectDefault = parcelHelpers.interopDefault(_reactSideEffect);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _objectAssign = require("object-assign");
var _objectAssignDefault = parcelHelpers.interopDefault(_objectAssign);
var global = arguments[3];
var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function(name) {
    return TAG_NAMES[name];
});
var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function(obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var SELF_CLOSING_TAGS = [
    TAG_NAMES.NOSCRIPT,
    TAG_NAMES.SCRIPT,
    TAG_NAMES.STYLE
];
var HELMET_ATTRIBUTE = "data-react-helmet";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};
var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + _typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssignDefault.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([
            TAG_PROPERTIES.HREF,
            TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [
            TAG_PROPERTIES.REL,
            TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [
            TAG_PROPERTIES.NAME,
            TAG_PROPERTIES.CHARSET,
            TAG_PROPERTIES.HTTPEQUIV,
            TAG_PROPERTIES.PROPERTY,
            TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [
            TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [
            TAG_PROPERTIES.SRC,
            TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [
            TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            rafPolyfill(callback);
        }, 0);
    };
}();
var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var _helmetCallback = null;
var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) cancelAnimationFrame(_helmetCallback);
    if (newState.defer) _helmetCallback = requestAnimationFrame(function() {
        commitTagChanges(newState, function() {
            _helmetCallback = null;
        });
    });
    else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};
var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);
    updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = flattenArray(title);
    updateAttributes(TAG_NAMES.TITLE, attributes);
};
var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute(HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute(HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + '="true">' + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, _reactDefault.default).createElement(TAG_NAMES.TITLE, props, title)
    ];
};
var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, _reactDefault.default).createElement(type, mappedTag);
    });
};
var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompareDefault.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                _extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });
                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }
            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, _reactDefault.default).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = _extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, _reactDefault.default).createElement(Component, newProps);
        };
        createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, _reactDefault.default).Component), _class.propTypes = {
        base: (0, _propTypesDefault.default).object,
        bodyAttributes: (0, _propTypesDefault.default).object,
        children: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
            (0, _propTypesDefault.default).node
        ]),
        defaultTitle: (0, _propTypesDefault.default).string,
        defer: (0, _propTypesDefault.default).bool,
        encodeSpecialCharacters: (0, _propTypesDefault.default).bool,
        htmlAttributes: (0, _propTypesDefault.default).object,
        link: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        meta: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        noscript: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        onChangeClientState: (0, _propTypesDefault.default).func,
        script: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        style: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        title: (0, _propTypesDefault.default).string,
        titleAttributes: (0, _propTypesDefault.default).object,
        titleTemplate: (0, _propTypesDefault.default).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var NullComponent = function NullComponent() {
    return null;
};
var HelmetSideEffects = (0, _reactSideEffectDefault.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;
exports.default = HelmetExport;

},{"prop-types":"jc0Wl","react-side-effect":"03a3I","react-fast-compare":"5bxip","react":"cOWTg","object-assign":"hGF6S","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"03a3I":[function(require,module,exports) {
"use strict";
function _interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
var React = require("85d8b04033ce6109");
var React__default = _interopDefault(React);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            _inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }(React.PureComponent);
        _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        _defineProperty(SideEffect, "canUseDOM", canUseDOM);
        return SideEffect;
    };
}
module.exports = withSideEffect;

},{"85d8b04033ce6109":"cOWTg"}],"hGF6S":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"hrOS0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _polaris = require("@shopify/polaris");
var _useSnackbar = require("../../hooks/useSnackbar");
var _useSnackbarDefault = parcelHelpers.interopDefault(_useSnackbar);
const Snackbar = ()=>{
    const { snackbar, clearSnackbar } = (0, _useSnackbarDefault.default)();
    if (!snackbar) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _polaris.Toast), {
        content: snackbar,
        onDismiss: clearSnackbar
    });
};
exports.default = Snackbar;

},{"react/jsx-runtime":"enbMA","react":"cOWTg","@shopify/polaris":"ek5a0","../../hooks/useSnackbar":"gQ3G9","@parcel/transformer-js/src/esmodule-helpers.js":"bNgzC"}],"awtT9":[function() {},{}],"AVQWA":[function(require,module,exports) {
module.exports = require("83f1655b314f0687")(require("5d2b191f9454af95").resolve("brV81")).then(()=>module.bundle.root("9DODJ"));

},{"83f1655b314f0687":"6jNAI","5d2b191f9454af95":"9zCcB"}],"6jNAI":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"9JIos"}],"9JIos":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}]},["gupJu"], "gupJu", "parcelRequirebad5")

//# sourceMappingURL=index.7e9a15dd.js.map
